/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			var _m = moreModules[moduleId];
/******/
/******/ 			// Check if module is deduplicated
/******/ 			switch(typeof _m) {
/******/ 			case "object":
/******/ 				// Module can be created from a template
/******/ 				modules[moduleId] = (function(_m) {
/******/ 					var args = _m.slice(1), templateId = _m[0];
/******/ 					return function (a,b,c) {
/******/ 						modules[templateId].apply(this, [a,b,c].concat(args));
/******/ 					};
/******/ 				}(_m));
/******/ 				break;
/******/ 			case "function":
/******/ 				// Normal module
/******/ 				modules[moduleId] = _m;
/******/ 				break;
/******/ 			default:
/******/ 				// Module is a copy of another module
/******/ 				modules[moduleId] = modules[_m];
/******/ 				break;
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"1":"b72a5421","2":"79d82729"}[chunkId] + ".chunk.js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(953);
	module.exports = __webpack_require__(1213);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(184);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.30.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        var flags = null,
	            parsedParts = false,
	            isNowValid = m._d && !isNaN(m._d.getTime());
	        if (isNowValid) {
	            flags = getParsingFlags(m);
	            parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            isNowValid =
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidEra &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        } else {
	            return isNowValid;
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {
	        D: 'date',
	        dates: 'date',
	        date: 'date',
	        d: 'day',
	        days: 'day',
	        day: 'day',
	        e: 'weekday',
	        weekdays: 'weekday',
	        weekday: 'weekday',
	        E: 'isoWeekday',
	        isoweekdays: 'isoWeekday',
	        isoweekday: 'isoWeekday',
	        DDD: 'dayOfYear',
	        dayofyears: 'dayOfYear',
	        dayofyear: 'dayOfYear',
	        h: 'hour',
	        hours: 'hour',
	        hour: 'hour',
	        ms: 'millisecond',
	        milliseconds: 'millisecond',
	        millisecond: 'millisecond',
	        m: 'minute',
	        minutes: 'minute',
	        minute: 'minute',
	        M: 'month',
	        months: 'month',
	        month: 'month',
	        Q: 'quarter',
	        quarters: 'quarter',
	        quarter: 'quarter',
	        s: 'second',
	        seconds: 'second',
	        second: 'second',
	        gg: 'weekYear',
	        weekyears: 'weekYear',
	        weekyear: 'weekYear',
	        GG: 'isoWeekYear',
	        isoweekyears: 'isoWeekYear',
	        isoweekyear: 'isoWeekYear',
	        w: 'week',
	        weeks: 'week',
	        week: 'week',
	        W: 'isoWeek',
	        isoweeks: 'isoWeek',
	        isoweek: 'isoWeek',
	        y: 'year',
	        years: 'year',
	        year: 'year',
	    };
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {
	        date: 9,
	        day: 11,
	        weekday: 11,
	        isoWeekday: 11,
	        dayOfYear: 4,
	        hour: 13,
	        millisecond: 16,
	        minute: 14,
	        month: 8,
	        quarter: 7,
	        second: 15,
	        weekYear: 1,
	        isoWeekYear: 1,
	        week: 5,
	        isoWeek: 5,
	        year: 1,
	    };
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
	        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        if (!mom.isValid()) {
	            return NaN;
	        }
	
	        var d = mom._d,
	            isUTC = mom._isUTC;
	
	        switch (unit) {
	            case 'Milliseconds':
	                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
	            case 'Seconds':
	                return isUTC ? d.getUTCSeconds() : d.getSeconds();
	            case 'Minutes':
	                return isUTC ? d.getUTCMinutes() : d.getMinutes();
	            case 'Hours':
	                return isUTC ? d.getUTCHours() : d.getHours();
	            case 'Date':
	                return isUTC ? d.getUTCDate() : d.getDate();
	            case 'Day':
	                return isUTC ? d.getUTCDay() : d.getDay();
	            case 'Month':
	                return isUTC ? d.getUTCMonth() : d.getMonth();
	            case 'FullYear':
	                return isUTC ? d.getUTCFullYear() : d.getFullYear();
	            default:
	                return NaN; // Just in case
	        }
	    }
	
	    function set$1(mom, unit, value) {
	        var d, isUTC, year, month, date;
	
	        if (!mom.isValid() || isNaN(value)) {
	            return;
	        }
	
	        d = mom._d;
	        isUTC = mom._isUTC;
	
	        switch (unit) {
	            case 'Milliseconds':
	                return void (isUTC
	                    ? d.setUTCMilliseconds(value)
	                    : d.setMilliseconds(value));
	            case 'Seconds':
	                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
	            case 'Minutes':
	                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
	            case 'Hours':
	                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
	            case 'Date':
	                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
	            // case 'Day': // Not real
	            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
	            // case 'Month': // Not used because we need to pass two variables
	            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
	            case 'FullYear':
	                break; // See below ...
	            default:
	                return; // Just in case
	        }
	
	        year = value;
	        month = mom.month();
	        date = mom.date();
	        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
	        void (isUTC
	            ? d.setUTCFullYear(year, month, date)
	            : d.setFullYear(year, month, date));
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // PARSING
	
	    addRegexToken('M', match1to2, match1to2NoLeadingZero);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        var month = value,
	            date = mom.date();
	
	        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
	        void (mom._isUTC
	            ? mom._d.setUTCMonth(month, date)
	            : mom._d.setMonth(month, date));
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            shortP,
	            longP;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortP = regexEscape(this.monthsShort(mom, ''));
	            longP = regexEscape(this.months(mom, ''));
	            shortPieces.push(shortP);
	            longPieces.push(longP);
	            mixedPieces.push(longP);
	            mixedPieces.push(shortP);
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // PARSING
	
	    addRegexToken('w', match1to2, match1to2NoLeadingZero);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2, match1to2NoLeadingZero);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	              ? weekdays[m.day()]
	              : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	              ? this._weekdaysShort[m.day()]
	              : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	              ? this._weekdaysMin[m.day()]
	              : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        var day = get(this, 'Day');
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2, match1to2HasZero);
	    addRegexToken('h', match1to2, match1to2NoLeadingZero);
	    addRegexToken('k', match1to2, match1to2NoLeadingZero);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        // Ensure name is available and function returns boolean
	        return !!(name && name.match('^[^/\\\\]*$'));
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(1660)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                      ? DATE
	                      : a[HOUR] < 0 ||
	                          a[HOUR] > 24 ||
	                          (a[HOUR] === 24 &&
	                              (a[MINUTE] !== 0 ||
	                                  a[SECOND] !== 0 ||
	                                  a[MILLISECOND] !== 0))
	                        ? HOUR
	                        : a[MINUTE] < 0 || a[MINUTE] > 59
	                          ? MINUTE
	                          : a[SECOND] < 0 || a[SECOND] > 59
	                            ? SECOND
	                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                              ? MILLISECOND
	                              : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	              ? 'lastWeek'
	              : diff < 0
	                ? 'lastDay'
	                : diff < 1
	                  ? 'sameDay'
	                  : diff < 2
	                    ? 'nextDay'
	                    : diff < 7
	                      ? 'nextWeek'
	                      : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            erasName,
	            erasAbbr,
	            erasNarrow,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            erasName = regexEscape(eras[i].name);
	            erasAbbr = regexEscape(eras[i].abbr);
	            erasNarrow = regexEscape(eras[i].narrow);
	
	            namePieces.push(erasName);
	            abbrPieces.push(erasAbbr);
	            narrowPieces.push(erasNarrow);
	            mixedPieces.push(erasName);
	            mixedPieces.push(erasAbbr);
	            mixedPieces.push(erasNarrow);
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday() + this.localeData()._week.dow,
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // PARSING
	
	    addRegexToken('D', match1to2, match1to2NoLeadingZero);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // PARSING
	
	    addRegexToken('m', match1to2, match1to2HasZero);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // PARSING
	
	    addRegexToken('s', match1to2, match1to2HasZero);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y'),
	        valueOf$1 = asMilliseconds;
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.30.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)(module)))

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1724)();
	}


/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(1228);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(1225);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(196);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(196);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(333);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = '';
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}
	
			return classes;
		}
	
		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}
	
			if (typeof arg !== 'object') {
				return '';
			}
	
			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}
	
			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}
	
			var classes = '';
	
			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}
	
			return classes;
		}
	
		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var environment_1 = __webpack_require__(28);
	/**
	 * Shuffles the array in-place using Fisher-Yates algorithm.
	 *
	 * ```js
	 * const a = [1, 2, 3, 4, 5];
	 * tf.util.shuffle(a);
	 * console.log(a);
	 * ```
	 *
	 * @param array The array to shuffle in-place.
	 */
	/** @doc {heading: 'Util', namespace: 'util'} */
	// tslint:disable-next-line:no-any
	function shuffle(array) {
	    var counter = array.length;
	    var temp = 0;
	    var index = 0;
	    // While there are elements in the array
	    while (counter > 0) {
	        // Pick a random index
	        index = (Math.random() * counter) | 0;
	        // Decrease counter by 1
	        counter--;
	        // And swap the last element with it
	        temp = array[counter];
	        array[counter] = array[index];
	        array[index] = temp;
	    }
	}
	exports.shuffle = shuffle;
	/** Clamps a value to a specified range. */
	function clamp(min, x, max) {
	    return Math.max(min, Math.min(x, max));
	}
	exports.clamp = clamp;
	function nearestLargerEven(val) {
	    return val % 2 === 0 ? val : val + 1;
	}
	exports.nearestLargerEven = nearestLargerEven;
	function sum(arr) {
	    var sum = 0;
	    for (var i = 0; i < arr.length; i++) {
	        sum += arr[i];
	    }
	    return sum;
	}
	exports.sum = sum;
	/**
	 * Returns a sample from a uniform [a, b) distribution.
	 *
	 * @param a The minimum support (inclusive).
	 * @param b The maximum support (exclusive).
	 * @return A pseudorandom number on the half-open interval [a,b).
	 */
	function randUniform(a, b) {
	    var r = Math.random();
	    return (b * r) + (1 - r) * a;
	}
	exports.randUniform = randUniform;
	/** Returns the squared Euclidean distance between two vectors. */
	function distSquared(a, b) {
	    var result = 0;
	    for (var i = 0; i < a.length; i++) {
	        var diff = Number(a[i]) - Number(b[i]);
	        result += diff * diff;
	    }
	    return result;
	}
	exports.distSquared = distSquared;
	/**
	 * Asserts that the expression is true. Otherwise throws an error with the
	 * provided message.
	 *
	 * ```js
	 * const x = 2;
	 * tf.util.assert(x === 2, 'x is not 2');
	 * ```
	 *
	 * @param expr The expression to assert (as a boolean).
	 * @param msg A function that returns the message to report when throwing an
	 *     error. We use a function for performance reasons.
	 */
	/** @doc {heading: 'Util', namespace: 'util'} */
	function assert(expr, msg) {
	    if (!expr) {
	        throw new Error(typeof msg === 'string' ? msg : msg());
	    }
	}
	exports.assert = assert;
	function assertShapesMatch(shapeA, shapeB, errorMessagePrefix) {
	    if (errorMessagePrefix === void 0) { errorMessagePrefix = ''; }
	    assert(arraysEqual(shapeA, shapeB), function () { return errorMessagePrefix + (" Shapes " + shapeA + " and " + shapeB + " must match"); });
	}
	exports.assertShapesMatch = assertShapesMatch;
	function assertNonNull(a) {
	    assert(a != null, function () { return "The input to the tensor constructor must be a non-null value."; });
	}
	exports.assertNonNull = assertNonNull;
	// NOTE: We explicitly type out what T extends instead of any so that
	// util.flatten on a nested array of number doesn't try to infer T as a
	// number[][], causing us to explicitly type util.flatten<number>().
	/**
	 *  Flattens an arbitrarily nested array.
	 *
	 * ```js
	 * const a = [[1, 2], [3, 4], [5, [6, [7]]]];
	 * const flat = tf.util.flatten(a);
	 * console.log(flat);
	 * ```
	 *
	 *  @param arr The nested array to flatten.
	 *  @param result The destination array which holds the elements.
	 *  @param skipTypedArray If true, avoids flattening the typed arrays. Defaults
	 *      to false.
	 */
	/** @doc {heading: 'Util', namespace: 'util'} */
	function flatten(arr, result, skipTypedArray) {
	    if (result === void 0) { result = []; }
	    if (skipTypedArray === void 0) { skipTypedArray = false; }
	    if (result == null) {
	        result = [];
	    }
	    if (Array.isArray(arr) || isTypedArray(arr) && !skipTypedArray) {
	        for (var i = 0; i < arr.length; ++i) {
	            flatten(arr[i], result, skipTypedArray);
	        }
	    }
	    else {
	        result.push(arr);
	    }
	    return result;
	}
	exports.flatten = flatten;
	/**
	 * Returns the size (number of elements) of the tensor given its shape.
	 *
	 * ```js
	 * const shape = [3, 4, 2];
	 * const size = tf.util.sizeFromShape(shape);
	 * console.log(size);
	 * ```
	 */
	/** @doc {heading: 'Util', namespace: 'util'} */
	function sizeFromShape(shape) {
	    if (shape.length === 0) {
	        // Scalar.
	        return 1;
	    }
	    var size = shape[0];
	    for (var i = 1; i < shape.length; i++) {
	        size *= shape[i];
	    }
	    return size;
	}
	exports.sizeFromShape = sizeFromShape;
	function isScalarShape(shape) {
	    return shape.length === 0;
	}
	exports.isScalarShape = isScalarShape;
	function arraysEqual(n1, n2) {
	    if (n1 === n2) {
	        return true;
	    }
	    if (n1 == null || n2 == null) {
	        return false;
	    }
	    if (n1.length !== n2.length) {
	        return false;
	    }
	    for (var i = 0; i < n1.length; i++) {
	        if (n1[i] !== n2[i]) {
	            return false;
	        }
	    }
	    return true;
	}
	exports.arraysEqual = arraysEqual;
	function isInt(a) {
	    return a % 1 === 0;
	}
	exports.isInt = isInt;
	function tanh(x) {
	    // tslint:disable-next-line:no-any
	    if (Math.tanh != null) {
	        // tslint:disable-next-line:no-any
	        return Math.tanh(x);
	    }
	    if (x === Infinity) {
	        return 1;
	    }
	    else if (x === -Infinity) {
	        return -1;
	    }
	    else {
	        var e2x = Math.exp(2 * x);
	        return (e2x - 1) / (e2x + 1);
	    }
	}
	exports.tanh = tanh;
	function sizeToSquarishShape(size) {
	    var width = Math.ceil(Math.sqrt(size));
	    return [width, Math.ceil(size / width)];
	}
	exports.sizeToSquarishShape = sizeToSquarishShape;
	/**
	 * Creates a new array with randomized indicies to a given quantity.
	 *
	 * ```js
	 * const randomTen = tf.util.createShuffledIndices(10);
	 * console.log(randomTen);
	 * ```
	 *
	 * @param number Quantity of how many shuffled indicies to create.
	 */
	/** @doc {heading: 'Util', namespace: 'util'} */
	function createShuffledIndices(n) {
	    var shuffledIndices = new Uint32Array(n);
	    for (var i = 0; i < n; ++i) {
	        shuffledIndices[i] = i;
	    }
	    shuffle(shuffledIndices);
	    return shuffledIndices;
	}
	exports.createShuffledIndices = createShuffledIndices;
	function rightPad(a, size) {
	    if (size <= a.length) {
	        return a;
	    }
	    return a + ' '.repeat(size - a.length);
	}
	exports.rightPad = rightPad;
	function repeatedTry(checkFn, delayFn, maxCounter) {
	    if (delayFn === void 0) { delayFn = function (counter) { return 0; }; }
	    return new Promise(function (resolve, reject) {
	        var tryCount = 0;
	        var tryFn = function () {
	            if (checkFn()) {
	                resolve();
	                return;
	            }
	            tryCount++;
	            var nextBackoff = delayFn(tryCount);
	            if (maxCounter != null && tryCount >= maxCounter) {
	                reject();
	                return;
	            }
	            setTimeout(tryFn, nextBackoff);
	        };
	        tryFn();
	    });
	}
	exports.repeatedTry = repeatedTry;
	/**
	 * Given the full size of the array and a shape that may contain -1 as the
	 * implicit dimension, returns the inferred shape where -1 is replaced.
	 * E.g. For shape=[2, -1, 3] and size=24, it will return [2, 4, 3].
	 *
	 * @param shape The shape, which may contain -1 in some dimension.
	 * @param size The full size (number of elements) of the array.
	 * @return The inferred shape where -1 is replaced with the inferred size.
	 */
	function inferFromImplicitShape(shape, size) {
	    var shapeProd = 1;
	    var implicitIdx = -1;
	    for (var i = 0; i < shape.length; ++i) {
	        if (shape[i] >= 0) {
	            shapeProd *= shape[i];
	        }
	        else if (shape[i] === -1) {
	            if (implicitIdx !== -1) {
	                throw Error("Shapes can only have 1 implicit size. " +
	                    ("Found -1 at dim " + implicitIdx + " and dim " + i));
	            }
	            implicitIdx = i;
	        }
	        else if (shape[i] < 0) {
	            throw Error("Shapes can not be < 0. Found " + shape[i] + " at dim " + i);
	        }
	    }
	    if (implicitIdx === -1) {
	        if (size > 0 && size !== shapeProd) {
	            throw Error("Size(" + size + ") must match the product of shape " + shape);
	        }
	        return shape;
	    }
	    if (shapeProd === 0) {
	        throw Error("Cannot infer the missing size in [" + shape + "] when " +
	            "there are 0 elements");
	    }
	    if (size % shapeProd !== 0) {
	        throw Error("The implicit shape can't be a fractional number. " +
	            ("Got " + size + " / " + shapeProd));
	    }
	    var newShape = shape.slice();
	    newShape[implicitIdx] = size / shapeProd;
	    return newShape;
	}
	exports.inferFromImplicitShape = inferFromImplicitShape;
	function parseAxisParam(axis, shape) {
	    var rank = shape.length;
	    // Normalize input
	    axis = axis == null ? shape.map(function (s, i) { return i; }) : [].concat(axis);
	    // Check for valid range
	    assert(axis.every(function (ax) { return ax >= -rank && ax < rank; }), function () {
	        return "All values in axis param must be in range [-" + rank + ", " + rank + ") but " +
	            ("got axis " + axis);
	    });
	    // Check for only integers
	    assert(axis.every(function (ax) { return isInt(ax); }), function () { return "All values in axis param must be integers but " +
	        ("got axis " + axis); });
	    // Handle negative axis.
	    return axis.map(function (a) { return a < 0 ? rank + a : a; });
	}
	exports.parseAxisParam = parseAxisParam;
	/** Reduces the shape by removing all dimensions of shape 1. */
	function squeezeShape(shape, axis) {
	    var newShape = [];
	    var keptDims = [];
	    var isEmptyArray = axis != null && Array.isArray(axis) && axis.length === 0;
	    var axes = (axis == null || isEmptyArray) ?
	        null :
	        parseAxisParam(axis, shape).sort();
	    var j = 0;
	    for (var i = 0; i < shape.length; ++i) {
	        if (axes != null) {
	            if (axes[j] === i && shape[i] !== 1) {
	                throw new Error("Can't squeeze axis " + i + " since its dim '" + shape[i] + "' is not 1");
	            }
	            if ((axes[j] == null || axes[j] > i) && shape[i] === 1) {
	                newShape.push(shape[i]);
	                keptDims.push(i);
	            }
	            if (axes[j] <= i) {
	                j++;
	            }
	        }
	        if (shape[i] !== 1) {
	            newShape.push(shape[i]);
	            keptDims.push(i);
	        }
	    }
	    return { newShape: newShape, keptDims: keptDims };
	}
	exports.squeezeShape = squeezeShape;
	function getTypedArrayFromDType(dtype, size) {
	    var values = null;
	    if (dtype == null || dtype === 'float32') {
	        values = new Float32Array(size);
	    }
	    else if (dtype === 'int32') {
	        values = new Int32Array(size);
	    }
	    else if (dtype === 'bool') {
	        values = new Uint8Array(size);
	    }
	    else {
	        throw new Error("Unknown data type " + dtype);
	    }
	    return values;
	}
	exports.getTypedArrayFromDType = getTypedArrayFromDType;
	function getArrayFromDType(dtype, size) {
	    var values = null;
	    if (dtype == null || dtype === 'float32') {
	        values = new Float32Array(size);
	    }
	    else if (dtype === 'int32') {
	        values = new Int32Array(size);
	    }
	    else if (dtype === 'bool') {
	        values = new Uint8Array(size);
	    }
	    else if (dtype === 'string') {
	        values = new Array(size);
	    }
	    else {
	        throw new Error("Unknown data type " + dtype);
	    }
	    return values;
	}
	exports.getArrayFromDType = getArrayFromDType;
	function checkConversionForErrors(vals, dtype) {
	    for (var i = 0; i < vals.length; i++) {
	        var num = vals[i];
	        if (isNaN(num) || !isFinite(num)) {
	            throw Error("A tensor of type " + dtype + " being uploaded contains " + num + ".");
	        }
	    }
	}
	exports.checkConversionForErrors = checkConversionForErrors;
	/** Returns true if the dtype is valid. */
	function isValidDtype(dtype) {
	    return dtype === 'bool' || dtype === 'complex64' || dtype === 'float32' ||
	        dtype === 'int32' || dtype === 'string';
	}
	exports.isValidDtype = isValidDtype;
	/**
	 * Returns true if the new type can't encode the old type without loss of
	 * precision.
	 */
	function hasEncodingLoss(oldType, newType) {
	    if (newType === 'complex64') {
	        return false;
	    }
	    if (newType === 'float32' && oldType !== 'complex64') {
	        return false;
	    }
	    if (newType === 'int32' && oldType !== 'float32' && oldType !== 'complex64') {
	        return false;
	    }
	    if (newType === 'bool' && oldType === 'bool') {
	        return false;
	    }
	    return true;
	}
	exports.hasEncodingLoss = hasEncodingLoss;
	function isTypedArray(a) {
	    return a instanceof Float32Array || a instanceof Int32Array ||
	        a instanceof Uint8Array;
	}
	exports.isTypedArray = isTypedArray;
	function bytesPerElement(dtype) {
	    if (dtype === 'float32' || dtype === 'int32') {
	        return 4;
	    }
	    else if (dtype === 'complex64') {
	        return 8;
	    }
	    else if (dtype === 'bool') {
	        return 1;
	    }
	    else {
	        throw new Error("Unknown dtype " + dtype);
	    }
	}
	exports.bytesPerElement = bytesPerElement;
	/**
	 * Returns the approximate number of bytes allocated in the string array - 2
	 * bytes per character. Computing the exact bytes for a native string in JS is
	 * not possible since it depends on the encoding of the html page that serves
	 * the website.
	 */
	function bytesFromStringArray(arr) {
	    if (arr == null) {
	        return 0;
	    }
	    var bytes = 0;
	    arr.forEach(function (x) { return bytes += x.length; });
	    return bytes;
	}
	exports.bytesFromStringArray = bytesFromStringArray;
	/** Returns true if the value is a string. */
	function isString(value) {
	    return typeof value === 'string' || value instanceof String;
	}
	exports.isString = isString;
	function isBoolean(value) {
	    return typeof value === 'boolean';
	}
	exports.isBoolean = isBoolean;
	function isNumber(value) {
	    return typeof value === 'number';
	}
	exports.isNumber = isNumber;
	function inferDtype(values) {
	    if (Array.isArray(values)) {
	        return inferDtype(values[0]);
	    }
	    if (values instanceof Float32Array) {
	        return 'float32';
	    }
	    else if (values instanceof Int32Array || values instanceof Uint8Array) {
	        return 'int32';
	    }
	    else if (isNumber(values)) {
	        return 'float32';
	    }
	    else if (isString(values)) {
	        return 'string';
	    }
	    else if (isBoolean(values)) {
	        return 'bool';
	    }
	    return 'float32';
	}
	exports.inferDtype = inferDtype;
	function isFunction(f) {
	    return !!(f && f.constructor && f.call && f.apply);
	}
	exports.isFunction = isFunction;
	function nearestDivisor(size, start) {
	    for (var i = start; i < size; ++i) {
	        if (size % i === 0) {
	            return i;
	        }
	    }
	    return size;
	}
	exports.nearestDivisor = nearestDivisor;
	function computeStrides(shape) {
	    var rank = shape.length;
	    if (rank < 2) {
	        return [];
	    }
	    // Last dimension has implicit stride of 1, thus having D-1 (instead of D)
	    // strides.
	    var strides = new Array(rank - 1);
	    strides[rank - 2] = shape[rank - 1];
	    for (var i = rank - 3; i >= 0; --i) {
	        strides[i] = strides[i + 1] * shape[i + 1];
	    }
	    return strides;
	}
	exports.computeStrides = computeStrides;
	function toTypedArray(a, dtype, debugMode) {
	    if (dtype === 'string') {
	        throw new Error('Cannot convert a string[] to a TypedArray');
	    }
	    if (Array.isArray(a)) {
	        a = flatten(a);
	    }
	    if (debugMode) {
	        checkConversionForErrors(a, dtype);
	    }
	    if (noConversionNeeded(a, dtype)) {
	        return a;
	    }
	    if (dtype == null || dtype === 'float32' || dtype === 'complex64') {
	        return new Float32Array(a);
	    }
	    else if (dtype === 'int32') {
	        return new Int32Array(a);
	    }
	    else if (dtype === 'bool') {
	        var bool = new Uint8Array(a.length);
	        for (var i = 0; i < bool.length; ++i) {
	            if (Math.round(a[i]) !== 0) {
	                bool[i] = 1;
	            }
	        }
	        return bool;
	    }
	    else {
	        throw new Error("Unknown data type " + dtype);
	    }
	}
	exports.toTypedArray = toTypedArray;
	function createNestedArray(offset, shape, a) {
	    var ret = new Array();
	    if (shape.length === 1) {
	        var d = shape[0];
	        for (var i = 0; i < d; i++) {
	            ret[i] = a[offset + i];
	        }
	    }
	    else {
	        var d = shape[0];
	        var rest = shape.slice(1);
	        var len = rest.reduce(function (acc, c) { return acc * c; });
	        for (var i = 0; i < d; i++) {
	            ret[i] = createNestedArray(offset + i * len, rest, a);
	        }
	    }
	    return ret;
	}
	// Provide a nested array of TypedArray in given shape.
	function toNestedArray(shape, a) {
	    if (shape.length === 0) {
	        // Scalar type should return a single number.
	        return a[0];
	    }
	    var size = shape.reduce(function (acc, c) { return acc * c; });
	    if (size === 0) {
	        // A tensor with shape zero should be turned into empty list.
	        return [];
	    }
	    if (size !== a.length) {
	        throw new Error("[" + shape + "] does not match the input size.");
	    }
	    return createNestedArray(0, shape, a);
	}
	exports.toNestedArray = toNestedArray;
	function noConversionNeeded(a, dtype) {
	    return (a instanceof Float32Array && dtype === 'float32') ||
	        (a instanceof Int32Array && dtype === 'int32') ||
	        (a instanceof Uint8Array && dtype === 'bool');
	}
	function makeOnesTypedArray(size, dtype) {
	    var array = makeZerosTypedArray(size, dtype);
	    for (var i = 0; i < array.length; i++) {
	        array[i] = 1;
	    }
	    return array;
	}
	exports.makeOnesTypedArray = makeOnesTypedArray;
	function makeZerosTypedArray(size, dtype) {
	    if (dtype == null || dtype === 'float32' || dtype === 'complex64') {
	        return new Float32Array(size);
	    }
	    else if (dtype === 'int32') {
	        return new Int32Array(size);
	    }
	    else if (dtype === 'bool') {
	        return new Uint8Array(size);
	    }
	    else {
	        throw new Error("Unknown data type " + dtype);
	    }
	}
	exports.makeZerosTypedArray = makeZerosTypedArray;
	/**
	 * Returns the current high-resolution time in milliseconds relative to an
	 * arbitrary time in the past. It works across different platforms (node.js,
	 * browsers).
	 *
	 * ```js
	 * console.log(tf.util.now());
	 * ```
	 */
	/** @doc {heading: 'Util', namespace: 'util'} */
	function now() {
	    return environment_1.env().platform.now();
	}
	exports.now = now;
	function assertNonNegativeIntegerDimensions(shape) {
	    shape.forEach(function (dimSize) {
	        assert(Number.isInteger(dimSize) && dimSize >= 0, function () {
	            return "Tensor must have a shape comprised of positive integers but got " +
	                ("shape [" + shape + "].");
	        });
	    });
	}
	exports.assertNonNegativeIntegerDimensions = assertNonNegativeIntegerDimensions;
	/**
	 * Returns a platform-specific implementation of
	 * [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
	 *
	 * If `fetch` is defined on the global object (`window`, `process`, etc.),
	 * `tf.util.fetch` returns that function.
	 *
	 * If not, `tf.util.fetch` returns a platform-specific solution.
	 *
	 * ```js
	 * const resource = await tf.util.fetch('https://unpkg.com/@tensorflow/tfjs');
	 * // handle response
	 * ```
	 */
	/** @doc {heading: 'Util'} */
	function fetch(path, requestInits) {
	    return environment_1.env().platform.fetch(path, requestInits);
	}
	exports.fetch = fetch;
	/**
	 * Encodes the provided string into bytes using the provided encoding scheme.
	 *
	 * @param s The string to encode.
	 * @param encoding The encoding scheme. Defaults to utf-8.
	 *
	 */
	/** @doc {heading: 'Util'} */
	function encodeString(s, encoding) {
	    if (encoding === void 0) { encoding = 'utf-8'; }
	    encoding = encoding || 'utf-8';
	    return environment_1.env().platform.encode(s, encoding);
	}
	exports.encodeString = encodeString;
	/**
	 * Decodes the provided bytes into a string using the provided encoding scheme.
	 * @param bytes The bytes to decode.
	 *
	 * @param encoding The encoding scheme. Defaults to utf-8.
	 */
	/** @doc {heading: 'Util'} */
	function decodeString(bytes, encoding) {
	    if (encoding === void 0) { encoding = 'utf-8'; }
	    encoding = encoding || 'utf-8';
	    return environment_1.env().platform.decode(bytes, encoding);
	}
	exports.decodeString = decodeString;
	/**
	 * Computes flat index for a given location (multidimentionsal index) in a
	 * Tensor/multidimensional array.
	 *
	 * @param locs Location in the tensor.
	 * @param rank Rank of the tensor.
	 * @param strides Tensor strides.
	 */
	function locToIndex(locs, rank, strides) {
	    if (rank === 0) {
	        return 0;
	    }
	    else if (rank === 1) {
	        return locs[0];
	    }
	    var index = locs[locs.length - 1];
	    for (var i = 0; i < locs.length - 1; ++i) {
	        index += strides[i] * locs[i];
	    }
	    return index;
	}
	exports.locToIndex = locToIndex;
	/**
	 * Computes the location (multidimensional index) in a tensor/multidimentional
	 * array for a given flat index.
	 *
	 * @param index Index in flat array.
	 * @param rank Rank of tensor.
	 * @param strides Strides of tensor.
	 */
	function indexToLoc(index, rank, strides) {
	    if (rank === 0) {
	        return [];
	    }
	    else if (rank === 1) {
	        return [index];
	    }
	    var locs = new Array(rank);
	    for (var i = 0; i < locs.length - 1; ++i) {
	        locs[i] = Math.floor(index / strides[i]);
	        index -= locs[i] * strides[i];
	    }
	    locs[locs.length - 1] = index;
	    return locs;
	}
	exports.indexToLoc = indexToLoc;
	//# sourceMappingURL=util.js.map

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = undefined;
	
	var _entries = __webpack_require__(509);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.prefix = prefix;
	exports.getClassSet = getClassSet;
	exports.splitBsProps = splitBsProps;
	exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
	exports.addStyle = addStyle;
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StyleConfig = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	    if (typeof last === 'function') {
	      return fn.apply(undefined, args);
	    }
	    return function (Component) {
	      return fn.apply(undefined, args.concat([Component]));
	    };
	  };
	} // TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
	
	function prefix(props, variant) {
	  !(props.bsClass != null) ?  false ? (0, _invariant2['default'])(false, 'A `bsClass` prop is required for this component') : (0, _invariant2['default'])(false) : void 0;
	  return props.bsClass + (variant ? '-' + variant : '');
	}
	
	var bsClass = exports.bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	
	  propTypes.bsClass = _propTypes2['default'].string;
	  defaultProps.bsClass = defaultClass;
	
	  return Component;
	});
	
	var bsStyles = exports.bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _propTypes2['default'].oneOf(existing);
	
	  // expose the values on the propType function for documentation
	  Component.STYLES = propType._values = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	
	var bsSizes = exports.bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	
	  var values = [];
	  existing.forEach(function (size) {
	    var mappedSize = _StyleConfig.SIZE_MAP[size];
	    if (mappedSize && mappedSize !== size) {
	      values.push(mappedSize);
	    }
	
	    values.push(size);
	  });
	
	  var propType = _propTypes2['default'].oneOf(values);
	  propType._values = values;
	
	  // expose the values on the propType function for documentation
	  Component.SIZES = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    if (!Component.defaultProps) {
	      Component.defaultProps = {};
	    }
	    Component.defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	
	function getClassSet(props) {
	  var _classes;
	
	  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);
	
	  if (props.bsSize) {
	    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
	    classes[prefix(props, bsSize)] = true;
	  }
	
	  if (props.bsStyle) {
	    classes[prefix(props, props.bsStyle)] = true;
	  }
	
	  return classes;
	}
	
	function getBsProps(props) {
	  return {
	    bsClass: props.bsClass,
	    bsSize: props.bsSize,
	    bsStyle: props.bsStyle,
	    bsRole: props.bsRole
	  };
	}
	
	function isBsProp(propName) {
	  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
	}
	
	function splitBsProps(props) {
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (!isBsProp(propName)) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	function splitBsPropsAndOmit(props, omittedPropNames) {
	  var isOmittedProp = {};
	  omittedPropNames.forEach(function (propName) {
	    isOmittedProp[propName] = true;
	  });
	
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref2) {
	    var propName = _ref2[0],
	        propValue = _ref2[1];
	
	    if (!isBsProp(propName) && !isOmittedProp[propName]) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	/**
	 * Add a style variant to a Component. Mutates the propTypes of the component
	 * in order to validate the new variant.
	 */
	function addStyle(Component) {
	  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    styleVariant[_key2 - 1] = arguments[_key2];
	  }
	
	  bsStyles(styleVariant, Component);
	}
	
	var _curry = exports._curry = curry;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __createBinding;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __createBinding = function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    };
	
	    __exportStar = function (m, exports) {
	        for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
	    };
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @fileoverview
	 * @suppress {partialAlias} Optimization disabled due to passing the module
	 * object into a function below:
	 *
	 *   import * as ops from './ops/ops';
	 *   setOpHandler(ops);
	 */
	// Engine is the global singleton that needs to be initialized before the rest
	// of the app.
	__webpack_require__(15);
	// Register backend-agnostic flags.
	__webpack_require__(1036);
	// backend_cpu.ts and backend_webgl.ts are standalone files and should be
	// explicitly included here.
	__webpack_require__(478);
	__webpack_require__(958);
	// Import all kernels from cpu.
	__webpack_require__(962);
	// Import all kernels from webgl.
	__webpack_require__(1015);
	// Register all the gradients.
	__webpack_require__(1079);
	__webpack_require__(1074);
	__webpack_require__(1075);
	var backend_util = __webpack_require__(234);
	exports.backend_util = backend_util;
	// Serialization.
	var io = __webpack_require__(1042);
	exports.io = io;
	var math = __webpack_require__(1046);
	exports.math = math;
	var browser = __webpack_require__(1049);
	exports.browser = browser;
	var gather_util = __webpack_require__(315);
	exports.gather_util = gather_util;
	var scatter_util = __webpack_require__(239);
	exports.scatter_util = scatter_util;
	var slice_util = __webpack_require__(192);
	exports.slice_util = slice_util;
	var serialization = __webpack_require__(110);
	exports.serialization = serialization;
	var tensor_1 = __webpack_require__(75);
	var tensor_util = __webpack_require__(111);
	exports.tensor_util = tensor_util;
	var test_util = __webpack_require__(1082);
	exports.test_util = test_util;
	var util = __webpack_require__(10);
	exports.util = util;
	var version_1 = __webpack_require__(1084);
	exports.version_core = version_1.version;
	var webgl = __webpack_require__(1085);
	exports.webgl = webgl;
	// Optimizers.
	var adadelta_optimizer_1 = __webpack_require__(321);
	exports.AdadeltaOptimizer = adadelta_optimizer_1.AdadeltaOptimizer;
	var adagrad_optimizer_1 = __webpack_require__(322);
	exports.AdagradOptimizer = adagrad_optimizer_1.AdagradOptimizer;
	var adam_optimizer_1 = __webpack_require__(323);
	exports.AdamOptimizer = adam_optimizer_1.AdamOptimizer;
	var adamax_optimizer_1 = __webpack_require__(324);
	exports.AdamaxOptimizer = adamax_optimizer_1.AdamaxOptimizer;
	var momentum_optimizer_1 = __webpack_require__(325);
	exports.MomentumOptimizer = momentum_optimizer_1.MomentumOptimizer;
	var optimizer_1 = __webpack_require__(129);
	exports.Optimizer = optimizer_1.Optimizer;
	var rmsprop_optimizer_1 = __webpack_require__(326);
	exports.RMSPropOptimizer = rmsprop_optimizer_1.RMSPropOptimizer;
	var sgd_optimizer_1 = __webpack_require__(240);
	exports.SGDOptimizer = sgd_optimizer_1.SGDOptimizer;
	var tensor_2 = __webpack_require__(75);
	exports.Tensor = tensor_2.Tensor;
	exports.TensorBuffer = tensor_2.TensorBuffer;
	exports.Variable = tensor_2.Variable;
	var types_1 = __webpack_require__(193);
	exports.Rank = types_1.Rank;
	exports.sumOutType = types_1.sumOutType;
	__export(__webpack_require__(74));
	var loss_ops_1 = __webpack_require__(489);
	exports.Reduction = loss_ops_1.Reduction;
	__export(__webpack_require__(1083));
	__export(__webpack_require__(73));
	__export(__webpack_require__(152));
	var gradients_1 = __webpack_require__(190);
	exports.customGrad = gradients_1.customGrad;
	exports.grad = gradients_1.grad;
	exports.grads = gradients_1.grads;
	exports.valueAndGrad = gradients_1.valueAndGrad;
	exports.valueAndGrads = gradients_1.valueAndGrads;
	exports.variableGrads = gradients_1.variableGrads;
	var environment_1 = __webpack_require__(28);
	exports.Environment = environment_1.Environment;
	exports.env = environment_1.env;
	exports.ENV = environment_1.ENV;
	// Top-level method exports.
	var browser_util_1 = __webpack_require__(1035);
	exports.nextFrame = browser_util_1.nextFrame;
	// Backend specific.
	var backend_1 = __webpack_require__(306);
	exports.KernelBackend = backend_1.KernelBackend;
	exports.DataStorage = backend_1.DataStorage;
	var ops = __webpack_require__(74);
	tensor_1.setOpHandler(ops);
	// Import all op chainers and add type info to Tensor.
	__webpack_require__(1077);
	//# sourceMappingURL=index.js.map

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unreachable = exports.warn = exports.utf8StringToString = exports.stringToUTF8String = exports.stringToPDFString = exports.stringToBytes = exports.string32 = exports.shadow = exports.setVerbosityLevel = exports.ReadableStream = exports.removeNullCharacters = exports.readUint32 = exports.readUint16 = exports.readInt8 = exports.log2 = exports.loadJpegStream = exports.isEvalSupported = exports.isLittleEndian = exports.createValidAbsoluteUrl = exports.isSameOrigin = exports.isSpace = exports.isString = exports.isNum = exports.isEmptyObj = exports.isBool = exports.isArrayBuffer = exports.info = exports.getVerbosityLevel = exports.getLookupTableFactory = exports.deprecated = exports.createObjectURL = exports.createPromiseCapability = exports.createBlob = exports.bytesToString = exports.assert = exports.arraysToBytes = exports.arrayByteLength = exports.FormatError = exports.XRefParseException = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.StreamType = exports.PasswordResponses = exports.PasswordException = exports.PageViewport = exports.NotImplementedException = exports.NativeImageDecoding = exports.MissingPDFException = exports.MissingDataException = exports.MessageHandler = exports.InvalidPDFException = exports.AbortException = exports.CMapCompressionType = exports.ImageKind = exports.FontType = exports.AnnotationType = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.UNSUPPORTED_FEATURES = exports.VERBOSITY_LEVELS = exports.OPS = exports.IDENTITY_MATRIX = exports.FONT_IDENTITY_MATRIX = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	__webpack_require__(1716);
	
	var _streams_polyfill = __webpack_require__(1717);
	
	var FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
	var NativeImageDecoding = {
	  NONE: 'none',
	  DECODE: 'decode',
	  DISPLAY: 'display'
	};
	var TextRenderingMode = {
	  FILL: 0,
	  STROKE: 1,
	  FILL_STROKE: 2,
	  INVISIBLE: 3,
	  FILL_ADD_TO_PATH: 4,
	  STROKE_ADD_TO_PATH: 5,
	  FILL_STROKE_ADD_TO_PATH: 6,
	  ADD_TO_PATH: 7,
	  FILL_STROKE_MASK: 3,
	  ADD_TO_PATH_FLAG: 4
	};
	var ImageKind = {
	  GRAYSCALE_1BPP: 1,
	  RGB_24BPP: 2,
	  RGBA_32BPP: 3
	};
	var AnnotationType = {
	  TEXT: 1,
	  LINK: 2,
	  FREETEXT: 3,
	  LINE: 4,
	  SQUARE: 5,
	  CIRCLE: 6,
	  POLYGON: 7,
	  POLYLINE: 8,
	  HIGHLIGHT: 9,
	  UNDERLINE: 10,
	  SQUIGGLY: 11,
	  STRIKEOUT: 12,
	  STAMP: 13,
	  CARET: 14,
	  INK: 15,
	  POPUP: 16,
	  FILEATTACHMENT: 17,
	  SOUND: 18,
	  MOVIE: 19,
	  WIDGET: 20,
	  SCREEN: 21,
	  PRINTERMARK: 22,
	  TRAPNET: 23,
	  WATERMARK: 24,
	  THREED: 25,
	  REDACT: 26
	};
	var AnnotationFlag = {
	  INVISIBLE: 0x01,
	  HIDDEN: 0x02,
	  PRINT: 0x04,
	  NOZOOM: 0x08,
	  NOROTATE: 0x10,
	  NOVIEW: 0x20,
	  READONLY: 0x40,
	  LOCKED: 0x80,
	  TOGGLENOVIEW: 0x100,
	  LOCKEDCONTENTS: 0x200
	};
	var AnnotationFieldFlag = {
	  READONLY: 0x0000001,
	  REQUIRED: 0x0000002,
	  NOEXPORT: 0x0000004,
	  MULTILINE: 0x0001000,
	  PASSWORD: 0x0002000,
	  NOTOGGLETOOFF: 0x0004000,
	  RADIO: 0x0008000,
	  PUSHBUTTON: 0x0010000,
	  COMBO: 0x0020000,
	  EDIT: 0x0040000,
	  SORT: 0x0080000,
	  FILESELECT: 0x0100000,
	  MULTISELECT: 0x0200000,
	  DONOTSPELLCHECK: 0x0400000,
	  DONOTSCROLL: 0x0800000,
	  COMB: 0x1000000,
	  RICHTEXT: 0x2000000,
	  RADIOSINUNISON: 0x2000000,
	  COMMITONSELCHANGE: 0x4000000
	};
	var AnnotationBorderStyleType = {
	  SOLID: 1,
	  DASHED: 2,
	  BEVELED: 3,
	  INSET: 4,
	  UNDERLINE: 5
	};
	var StreamType = {
	  UNKNOWN: 0,
	  FLATE: 1,
	  LZW: 2,
	  DCT: 3,
	  JPX: 4,
	  JBIG: 5,
	  A85: 6,
	  AHX: 7,
	  CCF: 8,
	  RL: 9
	};
	var FontType = {
	  UNKNOWN: 0,
	  TYPE1: 1,
	  TYPE1C: 2,
	  CIDFONTTYPE0: 3,
	  CIDFONTTYPE0C: 4,
	  TRUETYPE: 5,
	  CIDFONTTYPE2: 6,
	  TYPE3: 7,
	  OPENTYPE: 8,
	  TYPE0: 9,
	  MMTYPE1: 10
	};
	var VERBOSITY_LEVELS = {
	  errors: 0,
	  warnings: 1,
	  infos: 5
	};
	var CMapCompressionType = {
	  NONE: 0,
	  BINARY: 1,
	  STREAM: 2
	};
	var OPS = {
	  dependency: 1,
	  setLineWidth: 2,
	  setLineCap: 3,
	  setLineJoin: 4,
	  setMiterLimit: 5,
	  setDash: 6,
	  setRenderingIntent: 7,
	  setFlatness: 8,
	  setGState: 9,
	  save: 10,
	  restore: 11,
	  transform: 12,
	  moveTo: 13,
	  lineTo: 14,
	  curveTo: 15,
	  curveTo2: 16,
	  curveTo3: 17,
	  closePath: 18,
	  rectangle: 19,
	  stroke: 20,
	  closeStroke: 21,
	  fill: 22,
	  eoFill: 23,
	  fillStroke: 24,
	  eoFillStroke: 25,
	  closeFillStroke: 26,
	  closeEOFillStroke: 27,
	  endPath: 28,
	  clip: 29,
	  eoClip: 30,
	  beginText: 31,
	  endText: 32,
	  setCharSpacing: 33,
	  setWordSpacing: 34,
	  setHScale: 35,
	  setLeading: 36,
	  setFont: 37,
	  setTextRenderingMode: 38,
	  setTextRise: 39,
	  moveText: 40,
	  setLeadingMoveText: 41,
	  setTextMatrix: 42,
	  nextLine: 43,
	  showText: 44,
	  showSpacedText: 45,
	  nextLineShowText: 46,
	  nextLineSetSpacingShowText: 47,
	  setCharWidth: 48,
	  setCharWidthAndBounds: 49,
	  setStrokeColorSpace: 50,
	  setFillColorSpace: 51,
	  setStrokeColor: 52,
	  setStrokeColorN: 53,
	  setFillColor: 54,
	  setFillColorN: 55,
	  setStrokeGray: 56,
	  setFillGray: 57,
	  setStrokeRGBColor: 58,
	  setFillRGBColor: 59,
	  setStrokeCMYKColor: 60,
	  setFillCMYKColor: 61,
	  shadingFill: 62,
	  beginInlineImage: 63,
	  beginImageData: 64,
	  endInlineImage: 65,
	  paintXObject: 66,
	  markPoint: 67,
	  markPointProps: 68,
	  beginMarkedContent: 69,
	  beginMarkedContentProps: 70,
	  endMarkedContent: 71,
	  beginCompat: 72,
	  endCompat: 73,
	  paintFormXObjectBegin: 74,
	  paintFormXObjectEnd: 75,
	  beginGroup: 76,
	  endGroup: 77,
	  beginAnnotations: 78,
	  endAnnotations: 79,
	  beginAnnotation: 80,
	  endAnnotation: 81,
	  paintJpegXObject: 82,
	  paintImageMaskXObject: 83,
	  paintImageMaskXObjectGroup: 84,
	  paintImageXObject: 85,
	  paintInlineImageXObject: 86,
	  paintInlineImageXObjectGroup: 87,
	  paintImageXObjectRepeat: 88,
	  paintImageMaskXObjectRepeat: 89,
	  paintSolidColorImageMask: 90,
	  constructPath: 91
	};
	var verbosity = VERBOSITY_LEVELS.warnings;
	function setVerbosityLevel(level) {
	  verbosity = level;
	}
	function getVerbosityLevel() {
	  return verbosity;
	}
	function info(msg) {
	  if (verbosity >= VERBOSITY_LEVELS.infos) {
	    console.log('Info: ' + msg);
	  }
	}
	function warn(msg) {
	  if (verbosity >= VERBOSITY_LEVELS.warnings) {
	    console.log('Warning: ' + msg);
	  }
	}
	function deprecated(details) {
	  console.log('Deprecated API usage: ' + details);
	}
	function unreachable(msg) {
	  throw new Error(msg);
	}
	function assert(cond, msg) {
	  if (!cond) {
	    unreachable(msg);
	  }
	}
	var UNSUPPORTED_FEATURES = {
	  unknown: 'unknown',
	  forms: 'forms',
	  javaScript: 'javaScript',
	  smask: 'smask',
	  shadingPattern: 'shadingPattern',
	  font: 'font'
	};
	function isSameOrigin(baseUrl, otherUrl) {
	  try {
	    var base = new URL(baseUrl);
	    if (!base.origin || base.origin === 'null') {
	      return false;
	    }
	  } catch (e) {
	    return false;
	  }
	  var other = new URL(otherUrl, base);
	  return base.origin === other.origin;
	}
	function isValidProtocol(url) {
	  if (!url) {
	    return false;
	  }
	  switch (url.protocol) {
	    case 'http:':
	    case 'https:':
	    case 'ftp:':
	    case 'mailto:':
	    case 'tel:':
	      return true;
	    default:
	      return false;
	  }
	}
	function createValidAbsoluteUrl(url, baseUrl) {
	  if (!url) {
	    return null;
	  }
	  try {
	    var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
	    if (isValidProtocol(absoluteUrl)) {
	      return absoluteUrl;
	    }
	  } catch (ex) {}
	  return null;
	}
	function shadow(obj, prop, value) {
	  Object.defineProperty(obj, prop, {
	    value: value,
	    enumerable: true,
	    configurable: true,
	    writable: false
	  });
	  return value;
	}
	function getLookupTableFactory(initializer) {
	  var lookup;
	  return function () {
	    if (initializer) {
	      lookup = Object.create(null);
	      initializer(lookup);
	      initializer = null;
	    }
	    return lookup;
	  };
	}
	var PasswordResponses = {
	  NEED_PASSWORD: 1,
	  INCORRECT_PASSWORD: 2
	};
	var PasswordException = function PasswordExceptionClosure() {
	  function PasswordException(msg, code) {
	    this.name = 'PasswordException';
	    this.message = msg;
	    this.code = code;
	  }
	  PasswordException.prototype = new Error();
	  PasswordException.constructor = PasswordException;
	  return PasswordException;
	}();
	var UnknownErrorException = function UnknownErrorExceptionClosure() {
	  function UnknownErrorException(msg, details) {
	    this.name = 'UnknownErrorException';
	    this.message = msg;
	    this.details = details;
	  }
	  UnknownErrorException.prototype = new Error();
	  UnknownErrorException.constructor = UnknownErrorException;
	  return UnknownErrorException;
	}();
	var InvalidPDFException = function InvalidPDFExceptionClosure() {
	  function InvalidPDFException(msg) {
	    this.name = 'InvalidPDFException';
	    this.message = msg;
	  }
	  InvalidPDFException.prototype = new Error();
	  InvalidPDFException.constructor = InvalidPDFException;
	  return InvalidPDFException;
	}();
	var MissingPDFException = function MissingPDFExceptionClosure() {
	  function MissingPDFException(msg) {
	    this.name = 'MissingPDFException';
	    this.message = msg;
	  }
	  MissingPDFException.prototype = new Error();
	  MissingPDFException.constructor = MissingPDFException;
	  return MissingPDFException;
	}();
	var UnexpectedResponseException = function UnexpectedResponseExceptionClosure() {
	  function UnexpectedResponseException(msg, status) {
	    this.name = 'UnexpectedResponseException';
	    this.message = msg;
	    this.status = status;
	  }
	  UnexpectedResponseException.prototype = new Error();
	  UnexpectedResponseException.constructor = UnexpectedResponseException;
	  return UnexpectedResponseException;
	}();
	var NotImplementedException = function NotImplementedExceptionClosure() {
	  function NotImplementedException(msg) {
	    this.message = msg;
	  }
	  NotImplementedException.prototype = new Error();
	  NotImplementedException.prototype.name = 'NotImplementedException';
	  NotImplementedException.constructor = NotImplementedException;
	  return NotImplementedException;
	}();
	var MissingDataException = function MissingDataExceptionClosure() {
	  function MissingDataException(begin, end) {
	    this.begin = begin;
	    this.end = end;
	    this.message = 'Missing data [' + begin + ', ' + end + ')';
	  }
	  MissingDataException.prototype = new Error();
	  MissingDataException.prototype.name = 'MissingDataException';
	  MissingDataException.constructor = MissingDataException;
	  return MissingDataException;
	}();
	var XRefParseException = function XRefParseExceptionClosure() {
	  function XRefParseException(msg) {
	    this.message = msg;
	  }
	  XRefParseException.prototype = new Error();
	  XRefParseException.prototype.name = 'XRefParseException';
	  XRefParseException.constructor = XRefParseException;
	  return XRefParseException;
	}();
	var FormatError = function FormatErrorClosure() {
	  function FormatError(msg) {
	    this.message = msg;
	  }
	  FormatError.prototype = new Error();
	  FormatError.prototype.name = 'FormatError';
	  FormatError.constructor = FormatError;
	  return FormatError;
	}();
	var AbortException = function AbortExceptionClosure() {
	  function AbortException(msg) {
	    this.name = 'AbortException';
	    this.message = msg;
	  }
	  AbortException.prototype = new Error();
	  AbortException.constructor = AbortException;
	  return AbortException;
	}();
	var NullCharactersRegExp = /\x00/g;
	function removeNullCharacters(str) {
	  if (typeof str !== 'string') {
	    warn('The argument for removeNullCharacters must be a string.');
	    return str;
	  }
	  return str.replace(NullCharactersRegExp, '');
	}
	function bytesToString(bytes) {
	  assert(bytes !== null && (typeof bytes === 'undefined' ? 'undefined' : _typeof(bytes)) === 'object' && bytes.length !== undefined, 'Invalid argument for bytesToString');
	  var length = bytes.length;
	  var MAX_ARGUMENT_COUNT = 8192;
	  if (length < MAX_ARGUMENT_COUNT) {
	    return String.fromCharCode.apply(null, bytes);
	  }
	  var strBuf = [];
	  for (var i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
	    var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
	    var chunk = bytes.subarray(i, chunkEnd);
	    strBuf.push(String.fromCharCode.apply(null, chunk));
	  }
	  return strBuf.join('');
	}
	function stringToBytes(str) {
	  assert(typeof str === 'string', 'Invalid argument for stringToBytes');
	  var length = str.length;
	  var bytes = new Uint8Array(length);
	  for (var i = 0; i < length; ++i) {
	    bytes[i] = str.charCodeAt(i) & 0xFF;
	  }
	  return bytes;
	}
	function arrayByteLength(arr) {
	  if (arr.length !== undefined) {
	    return arr.length;
	  }
	  assert(arr.byteLength !== undefined);
	  return arr.byteLength;
	}
	function arraysToBytes(arr) {
	  if (arr.length === 1 && arr[0] instanceof Uint8Array) {
	    return arr[0];
	  }
	  var resultLength = 0;
	  var i,
	      ii = arr.length;
	  var item, itemLength;
	  for (i = 0; i < ii; i++) {
	    item = arr[i];
	    itemLength = arrayByteLength(item);
	    resultLength += itemLength;
	  }
	  var pos = 0;
	  var data = new Uint8Array(resultLength);
	  for (i = 0; i < ii; i++) {
	    item = arr[i];
	    if (!(item instanceof Uint8Array)) {
	      if (typeof item === 'string') {
	        item = stringToBytes(item);
	      } else {
	        item = new Uint8Array(item);
	      }
	    }
	    itemLength = item.byteLength;
	    data.set(item, pos);
	    pos += itemLength;
	  }
	  return data;
	}
	function string32(value) {
	  return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
	}
	function log2(x) {
	  if (x <= 0) {
	    return 0;
	  }
	  return Math.ceil(Math.log2(x));
	}
	function readInt8(data, start) {
	  return data[start] << 24 >> 24;
	}
	function readUint16(data, offset) {
	  return data[offset] << 8 | data[offset + 1];
	}
	function readUint32(data, offset) {
	  return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
	}
	function isLittleEndian() {
	  var buffer8 = new Uint8Array(4);
	  buffer8[0] = 1;
	  var view32 = new Uint32Array(buffer8.buffer, 0, 1);
	  return view32[0] === 1;
	}
	function isEvalSupported() {
	  try {
	    new Function('');
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	var IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
	var Util = function UtilClosure() {
	  function Util() {}
	  var rgbBuf = ['rgb(', 0, ',', 0, ',', 0, ')'];
	  Util.makeCssRgb = function Util_makeCssRgb(r, g, b) {
	    rgbBuf[1] = r;
	    rgbBuf[3] = g;
	    rgbBuf[5] = b;
	    return rgbBuf.join('');
	  };
	  Util.transform = function Util_transform(m1, m2) {
	    return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
	  };
	  Util.applyTransform = function Util_applyTransform(p, m) {
	    var xt = p[0] * m[0] + p[1] * m[2] + m[4];
	    var yt = p[0] * m[1] + p[1] * m[3] + m[5];
	    return [xt, yt];
	  };
	  Util.applyInverseTransform = function Util_applyInverseTransform(p, m) {
	    var d = m[0] * m[3] - m[1] * m[2];
	    var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
	    var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
	    return [xt, yt];
	  };
	  Util.getAxialAlignedBoundingBox = function Util_getAxialAlignedBoundingBox(r, m) {
	    var p1 = Util.applyTransform(r, m);
	    var p2 = Util.applyTransform(r.slice(2, 4), m);
	    var p3 = Util.applyTransform([r[0], r[3]], m);
	    var p4 = Util.applyTransform([r[2], r[1]], m);
	    return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
	  };
	  Util.inverseTransform = function Util_inverseTransform(m) {
	    var d = m[0] * m[3] - m[1] * m[2];
	    return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
	  };
	  Util.apply3dTransform = function Util_apply3dTransform(m, v) {
	    return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]];
	  };
	  Util.singularValueDecompose2dScale = function Util_singularValueDecompose2dScale(m) {
	    var transpose = [m[0], m[2], m[1], m[3]];
	    var a = m[0] * transpose[0] + m[1] * transpose[2];
	    var b = m[0] * transpose[1] + m[1] * transpose[3];
	    var c = m[2] * transpose[0] + m[3] * transpose[2];
	    var d = m[2] * transpose[1] + m[3] * transpose[3];
	    var first = (a + d) / 2;
	    var second = Math.sqrt((a + d) * (a + d) - 4 * (a * d - c * b)) / 2;
	    var sx = first + second || 1;
	    var sy = first - second || 1;
	    return [Math.sqrt(sx), Math.sqrt(sy)];
	  };
	  Util.normalizeRect = function Util_normalizeRect(rect) {
	    var r = rect.slice(0);
	    if (rect[0] > rect[2]) {
	      r[0] = rect[2];
	      r[2] = rect[0];
	    }
	    if (rect[1] > rect[3]) {
	      r[1] = rect[3];
	      r[3] = rect[1];
	    }
	    return r;
	  };
	  Util.intersect = function Util_intersect(rect1, rect2) {
	    function compare(a, b) {
	      return a - b;
	    }
	    var orderedX = [rect1[0], rect1[2], rect2[0], rect2[2]].sort(compare),
	        orderedY = [rect1[1], rect1[3], rect2[1], rect2[3]].sort(compare),
	        result = [];
	    rect1 = Util.normalizeRect(rect1);
	    rect2 = Util.normalizeRect(rect2);
	    if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
	      result[0] = orderedX[1];
	      result[2] = orderedX[2];
	    } else {
	      return false;
	    }
	    if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
	      result[1] = orderedY[1];
	      result[3] = orderedY[2];
	    } else {
	      return false;
	    }
	    return result;
	  };
	  var ROMAN_NUMBER_MAP = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM', '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC', '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
	  Util.toRoman = function Util_toRoman(number, lowerCase) {
	    assert(Number.isInteger(number) && number > 0, 'The number should be a positive integer.');
	    var pos,
	        romanBuf = [];
	    while (number >= 1000) {
	      number -= 1000;
	      romanBuf.push('M');
	    }
	    pos = number / 100 | 0;
	    number %= 100;
	    romanBuf.push(ROMAN_NUMBER_MAP[pos]);
	    pos = number / 10 | 0;
	    number %= 10;
	    romanBuf.push(ROMAN_NUMBER_MAP[10 + pos]);
	    romanBuf.push(ROMAN_NUMBER_MAP[20 + number]);
	    var romanStr = romanBuf.join('');
	    return lowerCase ? romanStr.toLowerCase() : romanStr;
	  };
	  Util.appendToArray = function Util_appendToArray(arr1, arr2) {
	    Array.prototype.push.apply(arr1, arr2);
	  };
	  Util.prependToArray = function Util_prependToArray(arr1, arr2) {
	    Array.prototype.unshift.apply(arr1, arr2);
	  };
	  Util.extendObj = function extendObj(obj1, obj2) {
	    for (var key in obj2) {
	      obj1[key] = obj2[key];
	    }
	  };
	  Util.getInheritableProperty = function Util_getInheritableProperty(dict, name, getArray) {
	    while (dict && !dict.has(name)) {
	      dict = dict.get('Parent');
	    }
	    if (!dict) {
	      return null;
	    }
	    return getArray ? dict.getArray(name) : dict.get(name);
	  };
	  Util.inherit = function Util_inherit(sub, base, prototype) {
	    sub.prototype = Object.create(base.prototype);
	    sub.prototype.constructor = sub;
	    for (var prop in prototype) {
	      sub.prototype[prop] = prototype[prop];
	    }
	  };
	  Util.loadScript = function Util_loadScript(src, callback) {
	    var script = document.createElement('script');
	    var loaded = false;
	    script.setAttribute('src', src);
	    if (callback) {
	      script.onload = function () {
	        if (!loaded) {
	          callback();
	        }
	        loaded = true;
	      };
	    }
	    document.getElementsByTagName('head')[0].appendChild(script);
	  };
	  return Util;
	}();
	var PageViewport = function PageViewportClosure() {
	  function PageViewport(viewBox, scale, rotation, offsetX, offsetY, dontFlip) {
	    this.viewBox = viewBox;
	    this.scale = scale;
	    this.rotation = rotation;
	    this.offsetX = offsetX;
	    this.offsetY = offsetY;
	    var centerX = (viewBox[2] + viewBox[0]) / 2;
	    var centerY = (viewBox[3] + viewBox[1]) / 2;
	    var rotateA, rotateB, rotateC, rotateD;
	    rotation = rotation % 360;
	    rotation = rotation < 0 ? rotation + 360 : rotation;
	    switch (rotation) {
	      case 180:
	        rotateA = -1;
	        rotateB = 0;
	        rotateC = 0;
	        rotateD = 1;
	        break;
	      case 90:
	        rotateA = 0;
	        rotateB = 1;
	        rotateC = 1;
	        rotateD = 0;
	        break;
	      case 270:
	        rotateA = 0;
	        rotateB = -1;
	        rotateC = -1;
	        rotateD = 0;
	        break;
	      default:
	        rotateA = 1;
	        rotateB = 0;
	        rotateC = 0;
	        rotateD = -1;
	        break;
	    }
	    if (dontFlip) {
	      rotateC = -rotateC;
	      rotateD = -rotateD;
	    }
	    var offsetCanvasX, offsetCanvasY;
	    var width, height;
	    if (rotateA === 0) {
	      offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
	      offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
	      width = Math.abs(viewBox[3] - viewBox[1]) * scale;
	      height = Math.abs(viewBox[2] - viewBox[0]) * scale;
	    } else {
	      offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
	      offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
	      width = Math.abs(viewBox[2] - viewBox[0]) * scale;
	      height = Math.abs(viewBox[3] - viewBox[1]) * scale;
	    }
	    this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
	    this.width = width;
	    this.height = height;
	    this.fontScale = scale;
	  }
	  PageViewport.prototype = {
	    clone: function PageViewPort_clone(args) {
	      args = args || {};
	      var scale = 'scale' in args ? args.scale : this.scale;
	      var rotation = 'rotation' in args ? args.rotation : this.rotation;
	      return new PageViewport(this.viewBox.slice(), scale, rotation, this.offsetX, this.offsetY, args.dontFlip);
	    },
	    convertToViewportPoint: function PageViewport_convertToViewportPoint(x, y) {
	      return Util.applyTransform([x, y], this.transform);
	    },
	    convertToViewportRectangle: function PageViewport_convertToViewportRectangle(rect) {
	      var tl = Util.applyTransform([rect[0], rect[1]], this.transform);
	      var br = Util.applyTransform([rect[2], rect[3]], this.transform);
	      return [tl[0], tl[1], br[0], br[1]];
	    },
	    convertToPdfPoint: function PageViewport_convertToPdfPoint(x, y) {
	      return Util.applyInverseTransform([x, y], this.transform);
	    }
	  };
	  return PageViewport;
	}();
	var PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2D8, 0x2C7, 0x2C6, 0x2D9, 0x2DD, 0x2DB, 0x2DA, 0x2DC, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203A, 0x2212, 0x2030, 0x201E, 0x201C, 0x201D, 0x2018, 0x2019, 0x201A, 0x2122, 0xFB01, 0xFB02, 0x141, 0x152, 0x160, 0x178, 0x17D, 0x131, 0x142, 0x153, 0x161, 0x17E, 0, 0x20AC];
	function stringToPDFString(str) {
	  var i,
	      n = str.length,
	      strBuf = [];
	  if (str[0] === '\xFE' && str[1] === '\xFF') {
	    for (i = 2; i < n; i += 2) {
	      strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
	    }
	  } else {
	    for (i = 0; i < n; ++i) {
	      var code = PDFStringTranslateTable[str.charCodeAt(i)];
	      strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
	    }
	  }
	  return strBuf.join('');
	}
	function stringToUTF8String(str) {
	  return decodeURIComponent(escape(str));
	}
	function utf8StringToString(str) {
	  return unescape(encodeURIComponent(str));
	}
	function isEmptyObj(obj) {
	  for (var key in obj) {
	    return false;
	  }
	  return true;
	}
	function isBool(v) {
	  return typeof v === 'boolean';
	}
	function isNum(v) {
	  return typeof v === 'number';
	}
	function isString(v) {
	  return typeof v === 'string';
	}
	function isArrayBuffer(v) {
	  return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v !== null && v.byteLength !== undefined;
	}
	function isSpace(ch) {
	  return ch === 0x20 || ch === 0x09 || ch === 0x0D || ch === 0x0A;
	}
	function createPromiseCapability() {
	  var capability = {};
	  capability.promise = new Promise(function (resolve, reject) {
	    capability.resolve = resolve;
	    capability.reject = reject;
	  });
	  return capability;
	}
	var createBlob = function createBlob(data, contentType) {
	  if (typeof Blob !== 'undefined') {
	    return new Blob([data], { type: contentType });
	  }
	  throw new Error('The "Blob" constructor is not supported.');
	};
	var createObjectURL = function createObjectURLClosure() {
	  var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	  return function createObjectURL(data, contentType) {
	    var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    if (!forceDataSchema && URL.createObjectURL) {
	      var blob = createBlob(data, contentType);
	      return URL.createObjectURL(blob);
	    }
	    var buffer = 'data:' + contentType + ';base64,';
	    for (var i = 0, ii = data.length; i < ii; i += 3) {
	      var b1 = data[i] & 0xFF;
	      var b2 = data[i + 1] & 0xFF;
	      var b3 = data[i + 2] & 0xFF;
	      var d1 = b1 >> 2,
	          d2 = (b1 & 3) << 4 | b2 >> 4;
	      var d3 = i + 1 < ii ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
	      var d4 = i + 2 < ii ? b3 & 0x3F : 64;
	      buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
	    }
	    return buffer;
	  };
	}();
	function resolveCall(fn, args) {
	  var thisArg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  if (!fn) {
	    return Promise.resolve(undefined);
	  }
	  return new Promise(function (resolve, reject) {
	    resolve(fn.apply(thisArg, args));
	  });
	}
	function wrapReason(reason) {
	  if ((typeof reason === 'undefined' ? 'undefined' : _typeof(reason)) !== 'object') {
	    return reason;
	  }
	  switch (reason.name) {
	    case 'AbortException':
	      return new AbortException(reason.message);
	    case 'MissingPDFException':
	      return new MissingPDFException(reason.message);
	    case 'UnexpectedResponseException':
	      return new UnexpectedResponseException(reason.message, reason.status);
	    default:
	      return new UnknownErrorException(reason.message, reason.details);
	  }
	}
	function makeReasonSerializable(reason) {
	  if (!(reason instanceof Error) || reason instanceof AbortException || reason instanceof MissingPDFException || reason instanceof UnexpectedResponseException || reason instanceof UnknownErrorException) {
	    return reason;
	  }
	  return new UnknownErrorException(reason.message, reason.toString());
	}
	function resolveOrReject(capability, success, reason) {
	  if (success) {
	    capability.resolve();
	  } else {
	    capability.reject(reason);
	  }
	}
	function finalize(promise) {
	  return Promise.resolve(promise).catch(function () {});
	}
	function MessageHandler(sourceName, targetName, comObj) {
	  var _this = this;
	
	  this.sourceName = sourceName;
	  this.targetName = targetName;
	  this.comObj = comObj;
	  this.callbackId = 1;
	  this.streamId = 1;
	  this.postMessageTransfers = true;
	  this.streamSinks = Object.create(null);
	  this.streamControllers = Object.create(null);
	  var callbacksCapabilities = this.callbacksCapabilities = Object.create(null);
	  var ah = this.actionHandler = Object.create(null);
	  this._onComObjOnMessage = function (event) {
	    var data = event.data;
	    if (data.targetName !== _this.sourceName) {
	      return;
	    }
	    if (data.stream) {
	      _this._processStreamMessage(data);
	    } else if (data.isReply) {
	      var callbackId = data.callbackId;
	      if (data.callbackId in callbacksCapabilities) {
	        var callback = callbacksCapabilities[callbackId];
	        delete callbacksCapabilities[callbackId];
	        if ('error' in data) {
	          callback.reject(wrapReason(data.error));
	        } else {
	          callback.resolve(data.data);
	        }
	      } else {
	        throw new Error('Cannot resolve callback ' + callbackId);
	      }
	    } else if (data.action in ah) {
	      var action = ah[data.action];
	      if (data.callbackId) {
	        var _sourceName = _this.sourceName;
	        var _targetName = data.sourceName;
	        Promise.resolve().then(function () {
	          return action[0].call(action[1], data.data);
	        }).then(function (result) {
	          comObj.postMessage({
	            sourceName: _sourceName,
	            targetName: _targetName,
	            isReply: true,
	            callbackId: data.callbackId,
	            data: result
	          });
	        }, function (reason) {
	          comObj.postMessage({
	            sourceName: _sourceName,
	            targetName: _targetName,
	            isReply: true,
	            callbackId: data.callbackId,
	            error: makeReasonSerializable(reason)
	          });
	        });
	      } else if (data.streamId) {
	        _this._createStreamSink(data);
	      } else {
	        action[0].call(action[1], data.data);
	      }
	    } else {
	      throw new Error('Unknown action from worker: ' + data.action);
	    }
	  };
	  comObj.addEventListener('message', this._onComObjOnMessage);
	}
	MessageHandler.prototype = {
	  on: function on(actionName, handler, scope) {
	    var ah = this.actionHandler;
	    if (ah[actionName]) {
	      throw new Error('There is already an actionName called "' + actionName + '"');
	    }
	    ah[actionName] = [handler, scope];
	  },
	  send: function send(actionName, data, transfers) {
	    var message = {
	      sourceName: this.sourceName,
	      targetName: this.targetName,
	      action: actionName,
	      data: data
	    };
	    this.postMessage(message, transfers);
	  },
	  sendWithPromise: function sendWithPromise(actionName, data, transfers) {
	    var callbackId = this.callbackId++;
	    var message = {
	      sourceName: this.sourceName,
	      targetName: this.targetName,
	      action: actionName,
	      data: data,
	      callbackId: callbackId
	    };
	    var capability = createPromiseCapability();
	    this.callbacksCapabilities[callbackId] = capability;
	    try {
	      this.postMessage(message, transfers);
	    } catch (e) {
	      capability.reject(e);
	    }
	    return capability.promise;
	  },
	  sendWithStream: function sendWithStream(actionName, data, queueingStrategy, transfers) {
	    var _this2 = this;
	
	    var streamId = this.streamId++;
	    var sourceName = this.sourceName;
	    var targetName = this.targetName;
	    return new _streams_polyfill.ReadableStream({
	      start: function start(controller) {
	        var startCapability = createPromiseCapability();
	        _this2.streamControllers[streamId] = {
	          controller: controller,
	          startCall: startCapability,
	          isClosed: false
	        };
	        _this2.postMessage({
	          sourceName: sourceName,
	          targetName: targetName,
	          action: actionName,
	          streamId: streamId,
	          data: data,
	          desiredSize: controller.desiredSize
	        });
	        return startCapability.promise;
	      },
	      pull: function pull(controller) {
	        var pullCapability = createPromiseCapability();
	        _this2.streamControllers[streamId].pullCall = pullCapability;
	        _this2.postMessage({
	          sourceName: sourceName,
	          targetName: targetName,
	          stream: 'pull',
	          streamId: streamId,
	          desiredSize: controller.desiredSize
	        });
	        return pullCapability.promise;
	      },
	      cancel: function cancel(reason) {
	        var cancelCapability = createPromiseCapability();
	        _this2.streamControllers[streamId].cancelCall = cancelCapability;
	        _this2.streamControllers[streamId].isClosed = true;
	        _this2.postMessage({
	          sourceName: sourceName,
	          targetName: targetName,
	          stream: 'cancel',
	          reason: reason,
	          streamId: streamId
	        });
	        return cancelCapability.promise;
	      }
	    }, queueingStrategy);
	  },
	  _createStreamSink: function _createStreamSink(data) {
	    var _this3 = this;
	
	    var self = this;
	    var action = this.actionHandler[data.action];
	    var streamId = data.streamId;
	    var desiredSize = data.desiredSize;
	    var sourceName = this.sourceName;
	    var targetName = data.sourceName;
	    var capability = createPromiseCapability();
	    var sendStreamRequest = function sendStreamRequest(_ref) {
	      var stream = _ref.stream,
	          chunk = _ref.chunk,
	          transfers = _ref.transfers,
	          success = _ref.success,
	          reason = _ref.reason;
	
	      _this3.postMessage({
	        sourceName: sourceName,
	        targetName: targetName,
	        stream: stream,
	        streamId: streamId,
	        chunk: chunk,
	        success: success,
	        reason: reason
	      }, transfers);
	    };
	    var streamSink = {
	      enqueue: function enqueue(chunk) {
	        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	        var transfers = arguments[2];
	
	        if (this.isCancelled) {
	          return;
	        }
	        var lastDesiredSize = this.desiredSize;
	        this.desiredSize -= size;
	        if (lastDesiredSize > 0 && this.desiredSize <= 0) {
	          this.sinkCapability = createPromiseCapability();
	          this.ready = this.sinkCapability.promise;
	        }
	        sendStreamRequest({
	          stream: 'enqueue',
	          chunk: chunk,
	          transfers: transfers
	        });
	      },
	      close: function close() {
	        if (this.isCancelled) {
	          return;
	        }
	        this.isCancelled = true;
	        sendStreamRequest({ stream: 'close' });
	        delete self.streamSinks[streamId];
	      },
	      error: function error(reason) {
	        if (this.isCancelled) {
	          return;
	        }
	        this.isCancelled = true;
	        sendStreamRequest({
	          stream: 'error',
	          reason: reason
	        });
	      },
	
	      sinkCapability: capability,
	      onPull: null,
	      onCancel: null,
	      isCancelled: false,
	      desiredSize: desiredSize,
	      ready: null
	    };
	    streamSink.sinkCapability.resolve();
	    streamSink.ready = streamSink.sinkCapability.promise;
	    this.streamSinks[streamId] = streamSink;
	    resolveCall(action[0], [data.data, streamSink], action[1]).then(function () {
	      sendStreamRequest({
	        stream: 'start_complete',
	        success: true
	      });
	    }, function (reason) {
	      sendStreamRequest({
	        stream: 'start_complete',
	        success: false,
	        reason: reason
	      });
	    });
	  },
	  _processStreamMessage: function _processStreamMessage(data) {
	    var _this4 = this;
	
	    var sourceName = this.sourceName;
	    var targetName = data.sourceName;
	    var streamId = data.streamId;
	    var sendStreamResponse = function sendStreamResponse(_ref2) {
	      var stream = _ref2.stream,
	          success = _ref2.success,
	          reason = _ref2.reason;
	
	      _this4.comObj.postMessage({
	        sourceName: sourceName,
	        targetName: targetName,
	        stream: stream,
	        success: success,
	        streamId: streamId,
	        reason: reason
	      });
	    };
	    var deleteStreamController = function deleteStreamController() {
	      Promise.all([_this4.streamControllers[data.streamId].startCall, _this4.streamControllers[data.streamId].pullCall, _this4.streamControllers[data.streamId].cancelCall].map(function (capability) {
	        return capability && finalize(capability.promise);
	      })).then(function () {
	        delete _this4.streamControllers[data.streamId];
	      });
	    };
	    switch (data.stream) {
	      case 'start_complete':
	        resolveOrReject(this.streamControllers[data.streamId].startCall, data.success, wrapReason(data.reason));
	        break;
	      case 'pull_complete':
	        resolveOrReject(this.streamControllers[data.streamId].pullCall, data.success, wrapReason(data.reason));
	        break;
	      case 'pull':
	        if (!this.streamSinks[data.streamId]) {
	          sendStreamResponse({
	            stream: 'pull_complete',
	            success: true
	          });
	          break;
	        }
	        if (this.streamSinks[data.streamId].desiredSize <= 0 && data.desiredSize > 0) {
	          this.streamSinks[data.streamId].sinkCapability.resolve();
	        }
	        this.streamSinks[data.streamId].desiredSize = data.desiredSize;
	        resolveCall(this.streamSinks[data.streamId].onPull).then(function () {
	          sendStreamResponse({
	            stream: 'pull_complete',
	            success: true
	          });
	        }, function (reason) {
	          sendStreamResponse({
	            stream: 'pull_complete',
	            success: false,
	            reason: reason
	          });
	        });
	        break;
	      case 'enqueue':
	        assert(this.streamControllers[data.streamId], 'enqueue should have stream controller');
	        if (!this.streamControllers[data.streamId].isClosed) {
	          this.streamControllers[data.streamId].controller.enqueue(data.chunk);
	        }
	        break;
	      case 'close':
	        assert(this.streamControllers[data.streamId], 'close should have stream controller');
	        if (this.streamControllers[data.streamId].isClosed) {
	          break;
	        }
	        this.streamControllers[data.streamId].isClosed = true;
	        this.streamControllers[data.streamId].controller.close();
	        deleteStreamController();
	        break;
	      case 'error':
	        assert(this.streamControllers[data.streamId], 'error should have stream controller');
	        this.streamControllers[data.streamId].controller.error(wrapReason(data.reason));
	        deleteStreamController();
	        break;
	      case 'cancel_complete':
	        resolveOrReject(this.streamControllers[data.streamId].cancelCall, data.success, wrapReason(data.reason));
	        deleteStreamController();
	        break;
	      case 'cancel':
	        if (!this.streamSinks[data.streamId]) {
	          break;
	        }
	        resolveCall(this.streamSinks[data.streamId].onCancel, [wrapReason(data.reason)]).then(function () {
	          sendStreamResponse({
	            stream: 'cancel_complete',
	            success: true
	          });
	        }, function (reason) {
	          sendStreamResponse({
	            stream: 'cancel_complete',
	            success: false,
	            reason: reason
	          });
	        });
	        this.streamSinks[data.streamId].sinkCapability.reject(wrapReason(data.reason));
	        this.streamSinks[data.streamId].isCancelled = true;
	        delete this.streamSinks[data.streamId];
	        break;
	      default:
	        throw new Error('Unexpected stream case');
	    }
	  },
	  postMessage: function postMessage(message, transfers) {
	    if (transfers && this.postMessageTransfers) {
	      this.comObj.postMessage(message, transfers);
	    } else {
	      this.comObj.postMessage(message);
	    }
	  },
	  destroy: function destroy() {
	    this.comObj.removeEventListener('message', this._onComObjOnMessage);
	  }
	};
	function loadJpegStream(id, imageUrl, objs) {
	  var img = new Image();
	  img.onload = function loadJpegStream_onloadClosure() {
	    objs.resolve(id, img);
	  };
	  img.onerror = function loadJpegStream_onerrorClosure() {
	    objs.resolve(id, null);
	    warn('Error during JPEG image loading');
	  };
	  img.src = imageUrl;
	}
	exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
	exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
	exports.OPS = OPS;
	exports.VERBOSITY_LEVELS = VERBOSITY_LEVELS;
	exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
	exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
	exports.AnnotationFieldFlag = AnnotationFieldFlag;
	exports.AnnotationFlag = AnnotationFlag;
	exports.AnnotationType = AnnotationType;
	exports.FontType = FontType;
	exports.ImageKind = ImageKind;
	exports.CMapCompressionType = CMapCompressionType;
	exports.AbortException = AbortException;
	exports.InvalidPDFException = InvalidPDFException;
	exports.MessageHandler = MessageHandler;
	exports.MissingDataException = MissingDataException;
	exports.MissingPDFException = MissingPDFException;
	exports.NativeImageDecoding = NativeImageDecoding;
	exports.NotImplementedException = NotImplementedException;
	exports.PageViewport = PageViewport;
	exports.PasswordException = PasswordException;
	exports.PasswordResponses = PasswordResponses;
	exports.StreamType = StreamType;
	exports.TextRenderingMode = TextRenderingMode;
	exports.UnexpectedResponseException = UnexpectedResponseException;
	exports.UnknownErrorException = UnknownErrorException;
	exports.Util = Util;
	exports.XRefParseException = XRefParseException;
	exports.FormatError = FormatError;
	exports.arrayByteLength = arrayByteLength;
	exports.arraysToBytes = arraysToBytes;
	exports.assert = assert;
	exports.bytesToString = bytesToString;
	exports.createBlob = createBlob;
	exports.createPromiseCapability = createPromiseCapability;
	exports.createObjectURL = createObjectURL;
	exports.deprecated = deprecated;
	exports.getLookupTableFactory = getLookupTableFactory;
	exports.getVerbosityLevel = getVerbosityLevel;
	exports.info = info;
	exports.isArrayBuffer = isArrayBuffer;
	exports.isBool = isBool;
	exports.isEmptyObj = isEmptyObj;
	exports.isNum = isNum;
	exports.isString = isString;
	exports.isSpace = isSpace;
	exports.isSameOrigin = isSameOrigin;
	exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
	exports.isLittleEndian = isLittleEndian;
	exports.isEvalSupported = isEvalSupported;
	exports.loadJpegStream = loadJpegStream;
	exports.log2 = log2;
	exports.readInt8 = readInt8;
	exports.readUint16 = readUint16;
	exports.readUint32 = readUint32;
	exports.removeNullCharacters = removeNullCharacters;
	exports.ReadableStream = _streams_polyfill.ReadableStream;
	exports.setVerbosityLevel = setVerbosityLevel;
	exports.shadow = shadow;
	exports.string32 = string32;
	exports.stringToBytes = stringToBytes;
	exports.stringToPDFString = stringToPDFString;
	exports.stringToUTF8String = stringToUTF8String;
	exports.utf8StringToString = utf8StringToString;
	exports.warn = warn;
	exports.unreachable = unreachable;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var environment_1 = __webpack_require__(28);
	var kernel_registry_1 = __webpack_require__(152);
	var profiler_1 = __webpack_require__(1076);
	var tape_1 = __webpack_require__(1080);
	var tensor_1 = __webpack_require__(75);
	var tensor_util_1 = __webpack_require__(111);
	var util = __webpack_require__(10);
	var util_1 = __webpack_require__(10);
	var EngineState = /** @class */ (function () {
	    function EngineState() {
	        // Public since optimizers will use it.
	        this.registeredVariables = {};
	        this.nextTapeNodeId = 0;
	        this.numBytes = 0;
	        this.numTensors = 0;
	        this.numStringTensors = 0;
	        this.numDataBuffers = 0;
	        // Number of nested tf.grad() statements when computing higher-order
	        // gradients. E.g. `1` for first-order gradients and `2` for second-order
	        // gradients. Used to track if the tape should be removed after a backprop.
	        this.gradientDepth = 0;
	        // Number of nested kernel calls. When kernel depth is greater than 1, we turn
	        // off the tape.
	        this.kernelDepth = 0;
	        this.scopeStack = [];
	        /**
	         * Keeps track of the number of data moves during a kernel execution. We
	         * maintain a stack since kernels can call other kernels, recursively.
	         */
	        this.numDataMovesStack = [];
	        this.nextScopeId = 0;
	        this.tensorInfo = new WeakMap();
	        this.profiling = false;
	        this.activeProfile = { newBytes: 0, newTensors: 0, peakBytes: 0, kernels: [], result: null };
	    }
	    EngineState.prototype.dispose = function () {
	        for (var variableName in this.registeredVariables) {
	            this.registeredVariables[variableName].dispose();
	        }
	    };
	    return EngineState;
	}());
	var Engine = /** @class */ (function () {
	    function Engine(ENV) {
	        this.ENV = ENV;
	        this.registry = {};
	        this.registryFactory = {};
	        this.pendingBackendInitId = 0;
	        this.state = new EngineState();
	    }
	    Engine.prototype.ready = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var sortedBackends, i, backendName, success;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (this.pendingBackendInit != null) {
	                            return [2 /*return*/, this.pendingBackendInit.then(function () { })];
	                        }
	                        if (this.backendInstance != null) {
	                            return [2 /*return*/];
	                        }
	                        sortedBackends = this.getSortedBackends();
	                        i = 0;
	                        _a.label = 1;
	                    case 1:
	                        if (!(i < sortedBackends.length)) return [3 /*break*/, 5];
	                        backendName = sortedBackends[i];
	                        return [4 /*yield*/, this.initializeBackend(backendName).success];
	                    case 2:
	                        success = _a.sent();
	                        if (!success) return [3 /*break*/, 4];
	                        return [4 /*yield*/, this.setBackend(backendName)];
	                    case 3:
	                        _a.sent();
	                        return [2 /*return*/];
	                    case 4:
	                        i++;
	                        return [3 /*break*/, 1];
	                    case 5: throw new Error("Could not initialize any backends, all backend initializations " +
	                        "failed.");
	                }
	            });
	        });
	    };
	    Object.defineProperty(Engine.prototype, "backend", {
	        get: function () {
	            if (this.pendingBackendInit != null) {
	                throw new Error("Backend '" + this.backendName + "' has not yet been initialized. Make " +
	                    "sure to await tf.ready() or await tf.setBackend() before calling " +
	                    "other methods");
	            }
	            if (this.backendInstance == null) {
	                var _a = this.initializeBackendsAndReturnBest(), name_1 = _a.name, asyncInit = _a.asyncInit;
	                if (asyncInit) {
	                    throw new Error("The highest priority backend '" + name_1 + "' has not yet been " +
	                        "initialized. Make sure to await tf.ready() or " +
	                        "await tf.setBackend() before calling other methods");
	                }
	                this.setBackend(name_1);
	            }
	            return this.backendInstance;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Engine.prototype.backendNames = function () {
	        return Object.keys(this.registryFactory);
	    };
	    Engine.prototype.findBackend = function (backendName) {
	        if (!(backendName in this.registry)) {
	            // If the backend hasn't been initialized but we have a registry entry for
	            // it, initialize it and return it.
	            if (backendName in this.registryFactory) {
	                var asyncInit = this.initializeBackend(backendName).asyncInit;
	                if (asyncInit) {
	                    // Backend is not ready yet.
	                    return null;
	                }
	            }
	            else {
	                return null;
	            }
	        }
	        return this.registry[backendName];
	    };
	    Engine.prototype.findBackendFactory = function (backendName) {
	        if (!(backendName in this.registryFactory)) {
	            return null;
	        }
	        return this.registryFactory[backendName].factory;
	    };
	    Engine.prototype.registerBackend = function (backendName, factory, priority) {
	        if (priority === void 0) { priority = 1; }
	        if (backendName in this.registryFactory) {
	            console.warn(backendName + " backend was already registered. " +
	                "Reusing existing backend factory.");
	            return false;
	        }
	        this.registryFactory[backendName] = { factory: factory, priority: priority };
	        return true;
	    };
	    Engine.prototype.setBackend = function (backendName) {
	        return __awaiter(this, void 0, void 0, function () {
	            var _a, success, asyncInit, result, _b;
	            return __generator(this, function (_c) {
	                switch (_c.label) {
	                    case 0:
	                        if (this.registryFactory[backendName] == null) {
	                            throw new Error("Backend name '" + backendName + "' not found in registry");
	                        }
	                        this.backendName = backendName;
	                        if (!(this.registry[backendName] == null)) return [3 /*break*/, 4];
	                        this.backendInstance = null;
	                        _a = this.initializeBackend(backendName), success = _a.success, asyncInit = _a.asyncInit;
	                        if (!asyncInit) return [3 /*break*/, 2];
	                        return [4 /*yield*/, success];
	                    case 1:
	                        _b = _c.sent();
	                        return [3 /*break*/, 3];
	                    case 2:
	                        _b = success;
	                        _c.label = 3;
	                    case 3:
	                        result = _b;
	                        if (!result) {
	                            return [2 /*return*/, false];
	                        }
	                        _c.label = 4;
	                    case 4:
	                        this.backendInstance = this.registry[backendName];
	                        this.setupRegisteredKernels();
	                        // Reset the profiler.
	                        this.profiler = new profiler_1.Profiler(this.backendInstance);
	                        return [2 /*return*/, true];
	                }
	            });
	        });
	    };
	    Engine.prototype.setupRegisteredKernels = function () {
	        var _this = this;
	        var kernels = kernel_registry_1.getKernelsForBackend(this.backendName);
	        kernels.forEach(function (kernel) {
	            if (kernel.setupFunc != null) {
	                kernel.setupFunc(_this.backendInstance);
	            }
	        });
	    };
	    Engine.prototype.disposeRegisteredKernels = function (backendName) {
	        var _this = this;
	        var kernels = kernel_registry_1.getKernelsForBackend(backendName);
	        kernels.forEach(function (kernel) {
	            if (kernel.disposeFunc != null) {
	                kernel.disposeFunc(_this.registry[backendName]);
	            }
	        });
	    };
	    /**
	     * Initializes a backend by looking up the backend name in the factory
	     * registry and calling the factory method. Returns a boolean representing
	     * whether the initialization of the backend suceeded. Throws an error if
	     * there is no backend in the factory registry.
	     */
	    Engine.prototype.initializeBackend = function (backendName) {
	        var _this = this;
	        var registryFactoryEntry = this.registryFactory[backendName];
	        if (registryFactoryEntry == null) {
	            throw new Error("Cannot initialize backend " + backendName + ", no registration found.");
	        }
	        try {
	            var backend = registryFactoryEntry.factory();
	            // Test if the factory returns a promise.
	            if (Promise.resolve(backend) === backend) {
	                var promiseId_1 = ++this.pendingBackendInitId;
	                var success = backend
	                    .then(function (backendInstance) {
	                    // Outdated promise. Another backend was set in the meantime.
	                    if (promiseId_1 < _this.pendingBackendInitId) {
	                        return false;
	                    }
	                    _this.registry[backendName] = backendInstance;
	                    _this.pendingBackendInit = null;
	                    return true;
	                })
	                    .catch(function (err) {
	                    // Outdated promise. Another backend was set in the meantime.
	                    if (promiseId_1 < _this.pendingBackendInitId) {
	                        return false;
	                    }
	                    _this.pendingBackendInit = null;
	                    console.warn("Initialization of backend " + backendName + " failed");
	                    console.warn(err.stack || err.message);
	                    return false;
	                });
	                this.pendingBackendInit = success;
	                return { success: success, asyncInit: true };
	            }
	            else {
	                this.registry[backendName] = backend;
	                return { success: true, asyncInit: false };
	            }
	        }
	        catch (err) {
	            console.warn("Initialization of backend " + backendName + " failed");
	            console.warn(err.stack || err.message);
	            return { success: false, asyncInit: false };
	        }
	    };
	    Engine.prototype.removeBackend = function (backendName) {
	        if (!(backendName in this.registryFactory)) {
	            throw new Error(backendName + " backend not found in registry");
	        }
	        if (this.backendName === backendName && this.pendingBackendInit != null) {
	            // There is a pending promise of the backend we want to remove. Make it
	            // obsolete.
	            this.pendingBackendInitId++;
	        }
	        if (backendName in this.registry) {
	            this.disposeRegisteredKernels(backendName);
	            this.registry[backendName].dispose();
	            delete this.registry[backendName];
	        }
	        delete this.registryFactory[backendName];
	        // Unset the backend if it is active.
	        if (this.backendName === backendName) {
	            this.pendingBackendInit = null;
	            this.backendName = null;
	            this.backendInstance = null;
	        }
	    };
	    Engine.prototype.getSortedBackends = function () {
	        var _this = this;
	        if (Object.keys(this.registryFactory).length === 0) {
	            throw new Error('No backend found in registry.');
	        }
	        return Object.keys(this.registryFactory).sort(function (a, b) {
	            // Highest priority comes first.
	            return _this.registryFactory[b].priority -
	                _this.registryFactory[a].priority;
	        });
	    };
	    Engine.prototype.initializeBackendsAndReturnBest = function () {
	        var sortedBackends = this.getSortedBackends();
	        for (var i = 0; i < sortedBackends.length; i++) {
	            var backendName = sortedBackends[i];
	            var _a = this.initializeBackend(backendName), success = _a.success, asyncInit = _a.asyncInit;
	            if (asyncInit || success) {
	                return { name: backendName, asyncInit: asyncInit };
	            }
	        }
	        throw new Error("Could not initialize any backends, all backend initializations " +
	            "failed.");
	    };
	    Engine.prototype.moveData = function (destBackend, dataId) {
	        var info = this.state.tensorInfo.get(dataId);
	        var srcBackend = info.backend;
	        var values = this.readSync(dataId);
	        // Delete the tensor from the old backend and move it to the new
	        // backend.
	        srcBackend.disposeData(dataId);
	        info.backend = destBackend;
	        destBackend.move(dataId, values, info.shape, info.dtype);
	        if (this.shouldCheckForMemLeaks()) {
	            // Track the number of moves during a kernel execution to correctly
	            // detect memory leaks.
	            this.state.numDataMovesStack[this.state.numDataMovesStack.length - 1]++;
	        }
	    };
	    Engine.prototype.tidy = function (nameOrFn, fn) {
	        var _this = this;
	        var name = null;
	        if (fn == null) {
	            // Called with only 1 argument.
	            if (typeof nameOrFn !== 'function') {
	                throw new Error('Please provide a function to tidy()');
	            }
	            fn = nameOrFn;
	        }
	        else {
	            // Called with 2 arguments.
	            if (typeof nameOrFn !== 'string' && !(nameOrFn instanceof String)) {
	                throw new Error('When calling with two arguments, the first argument ' +
	                    'to tidy() must be a string');
	            }
	            if (typeof fn !== 'function') {
	                throw new Error('When calling with two arguments, the 2nd argument ' +
	                    'to tidy() must be a function');
	            }
	            name = nameOrFn;
	            // TODO(nsthorat,smilkov): Do operation logging and performance
	            // profiling.
	        }
	        var result;
	        return this.scopedRun(function () { return _this.startScope(name); }, function () { return _this.endScope(result); }, function () {
	            result = fn();
	            if (result instanceof Promise) {
	                console.error('Cannot return a Promise inside of tidy.');
	            }
	            return result;
	        });
	    };
	    Engine.prototype.scopedRun = function (start, end, f) {
	        start();
	        try {
	            var res = f();
	            end();
	            return res;
	        }
	        catch (ex) {
	            end();
	            throw ex;
	        }
	    };
	    Engine.prototype.nextTensorId = function () {
	        return Engine.nextTensorId++;
	    };
	    Engine.prototype.nextVariableId = function () {
	        return Engine.nextVariableId++;
	    };
	    /**
	     * This method is called instead of the public-facing tensor.clone() when
	     * saving a tensor for backwards pass. It makes sure to add the clone
	     * operation to the tape regardless of being called inside a kernel
	     * execution.
	     *
	     * This method will go away once all kernels are modularized since we won't
	     * need to turn off the tape inside runKernel().
	     */
	    Engine.prototype.clone = function (x) {
	        var y = this.makeTensorFromDataId(x.dataId, x.shape, x.dtype);
	        var inputs = { x: x };
	        var grad = function (dy) { return ({ x: function () { return dy.toFloat(); } }); };
	        var saved = [];
	        this.addTapeNode(this.state.activeScope.name, inputs, [y], grad, saved);
	        return y;
	    };
	    /**
	     * Execute a kernel with the given name and return the output tensor.
	     *
	     * @param kernelName The name of the kernel to execute.
	     * @param inputs A map of input names to tensors.
	     * @param attrs A map of attribute names to their values. An attribute is a
	     *     primitive (non-tensor) input to the kernel.
	     * @param inputsToSave A list of tensors, inputs to save for the backprop
	     *     computation.
	     * @param outputsToSave A list of booleans, specifying which output to save
	     *     for the backprop computation. These are booleans since the output
	     * tensors are not visible to the user.
	     */
	    Engine.prototype.runKernel = function (kernelName, inputs, attrs, inputsToSave, outputsToSave) {
	        var forwardFunc = null;
	        var backwardsFunc = null;
	        // Call runKernel as a stop-gap until we modularize all kernels.
	        // Once we modularize all kernels, we will remove the existing
	        // `runKernelFunc`.
	        return this.runKernelFunc(forwardFunc, inputs, backwardsFunc, kernelName, attrs, inputsToSave, outputsToSave);
	    };
	    Engine.prototype.shouldCheckForMemLeaks = function () {
	        return this.ENV.getBool('IS_TEST');
	    };
	    Engine.prototype.checkKernelForMemLeak = function (kernelName, numDataIdsBefore, outInfos) {
	        var numDataIdsAfter = this.backend.numDataIds();
	        // Count the number of data ids associated with the result of the kernel.
	        var numOutputDataIds = 0;
	        outInfos.forEach(function (info) {
	            // Complex numbers allocate 3 data ids, one for 'real', one for
	            // 'imaginary', and one for the container that holds the former two.
	            numOutputDataIds += (info.dtype === 'complex64' ? 3 : 1);
	        });
	        // Account for the number of moves during kernel execution. A "data move"
	        // can happen in the middle of a kernel execution, placing a new (key,value)
	        // pair in the data storage. Since data moves have net zero effect (we
	        // always remove the data from the old backend), we have to cancel them out
	        // when detecting memory leaks.
	        var numMoves = this.state.numDataMovesStack[this.state.numDataMovesStack.length - 1];
	        var dataIdsLeaked = numDataIdsAfter - numDataIdsBefore - numOutputDataIds - numMoves;
	        if (dataIdsLeaked > 0) {
	            throw new Error("Backend '" + this.backendName + "' has an internal memory leak " +
	                ("(" + dataIdsLeaked + " data ids) after running '" + kernelName + "'"));
	        }
	    };
	    /**
	     * @deprecated Use `runKernel` for newly added kernels. Keep using this method
	     *     only for kernels that are not yet fully modularized.
	     */
	    Engine.prototype.runKernelFunc = function (forwardFunc, inputs, backwardsFunc, kernelName, attrs, inputsToSave, outputsToSave) {
	        var _this = this;
	        if (inputsToSave === void 0) { inputsToSave = []; }
	        if (outputsToSave === void 0) { outputsToSave = []; }
	        var outputs;
	        var saved = [];
	        var isTapeOn = this.isTapeOn();
	        if (kernelName == null) {
	            kernelName =
	                this.state.activeScope != null ? this.state.activeScope.name : '';
	        }
	        var saveFunc = function (tensors) {
	            // Do not save unless we are recording to the tape. Otherwise it would
	            // cause a mem leak since we would never run backprop, which disposes
	            // the kept tensors.
	            if (!isTapeOn) {
	                return;
	            }
	            saved = tensors.map(function (tensor) { return _this.keep(_this.clone(tensor)); });
	        };
	        var startingBytecount = this.state.numBytes;
	        var startingNumTensors = this.state.numTensors;
	        if (this.shouldCheckForMemLeaks()) {
	            this.state.numDataMovesStack.push(0);
	        }
	        var kernelFunc;
	        var kernel = kernel_registry_1.getKernel(kernelName, this.backendName);
	        var out;
	        if (kernel != null) {
	            kernelFunc = function () {
	                var numDataIdsBefore = _this.backend.numDataIds();
	                out = kernel.kernelFunc({ inputs: inputs, attrs: attrs, backend: _this.backend });
	                var outInfos = Array.isArray(out) ? out : [out];
	                if (_this.shouldCheckForMemLeaks()) {
	                    _this.checkKernelForMemLeak(kernelName, numDataIdsBefore, outInfos);
	                }
	                var outTensors = outInfos.map(function (_a) {
	                    var dataId = _a.dataId, shape = _a.shape, dtype = _a.dtype;
	                    return _this.makeTensorFromDataId(dataId, shape, dtype);
	                });
	                var outsToSave = outTensors.filter(function (_, i) { return outputsToSave[i]; });
	                // Save the inputs and outputs.
	                saveFunc((inputsToSave || []).slice().concat(outsToSave));
	                return outTensors;
	            };
	        }
	        else {
	            kernelFunc = function () {
	                var numDataIdsBefore = _this.backend.numDataIds();
	                out = _this.tidy(function () { return forwardFunc(_this.backend, saveFunc); });
	                var outs = (Array.isArray(out) ? out : [out]);
	                if (_this.shouldCheckForMemLeaks()) {
	                    _this.checkKernelForMemLeak(kernelName, numDataIdsBefore, outs);
	                }
	                return outs;
	            };
	        }
	        // Stop recording to a tape when running a kernel.
	        this.scopedRun(function () { return _this.state.kernelDepth++; }, function () { return _this.state.kernelDepth--; }, function () {
	            if (!_this.ENV.getBool('DEBUG')) {
	                outputs = kernelFunc();
	            }
	            else {
	                outputs = _this.profiler.profileKernel(kernelName, inputs, function () { return kernelFunc(); });
	            }
	        });
	        if (isTapeOn) {
	            this.addTapeNode(kernelName, inputs, outputs, backwardsFunc, saved);
	        }
	        if (this.state.profiling) {
	            this.state.activeProfile.kernels.push({
	                name: kernelName,
	                bytesAdded: this.state.numBytes - startingBytecount,
	                totalBytesSnapshot: this.state.numBytes,
	                tensorsAdded: this.state.numTensors - startingNumTensors,
	                totalTensorsSnapshot: this.state.numTensors,
	                inputShapes: Object.keys(inputs).map(function (key) { return inputs[key].shape; }),
	                outputShapes: outputs.map(function (item) { return item.shape; })
	            });
	        }
	        return (Array.isArray(out) ? outputs : outputs[0]);
	    };
	    /**
	     * Internal method used by public APIs for tensor creation. Makes a new
	     * tensor with the provided shape, dtype and values. It always
	     * creates a new data id and writes the values to the underlying backend.
	     */
	    Engine.prototype.makeTensor = function (values, shape, dtype, backend) {
	        if (values == null) {
	            throw new Error('Values passed to engine.makeTensor() are null');
	        }
	        dtype = dtype || 'float32';
	        backend = backend || this.backend;
	        var backendVals = values;
	        if (dtype === 'string' && util.isString(values[0])) {
	            backendVals = values.map(function (d) { return util.encodeString(d); });
	        }
	        var dataId = backend.write(backendVals, shape, dtype);
	        var t = new tensor_1.Tensor(shape, dtype, dataId, this.nextTensorId());
	        this.incRef(t, backend);
	        // Count bytes for string tensors.
	        if (dtype === 'string') {
	            var info = this.state.tensorInfo.get(dataId);
	            var newBytes = util_1.bytesFromStringArray(backendVals);
	            this.state.numBytes += newBytes - info.bytes;
	            info.bytes = newBytes;
	        }
	        return t;
	    };
	    /**
	     * Internal method used by backends. Makes a new tensor
	     * that is a wrapper around an existing data id. It doesn't create
	     * a new data id, only increments the ref count used in memory tracking.
	     */
	    Engine.prototype.makeTensorFromDataId = function (dataId, shape, dtype, backend) {
	        dtype = dtype || 'float32';
	        var t = new tensor_1.Tensor(shape, dtype, dataId, this.nextTensorId());
	        this.incRef(t, backend);
	        return t;
	    };
	    Engine.prototype.makeVariable = function (initialValue, trainable, name, dtype) {
	        if (trainable === void 0) { trainable = true; }
	        name = name || this.nextVariableId().toString();
	        if (dtype != null && dtype !== initialValue.dtype) {
	            initialValue = initialValue.asType(dtype);
	        }
	        var v = new tensor_1.Variable(initialValue, trainable, name, this.nextTensorId());
	        if (this.state.registeredVariables[v.name] != null) {
	            throw new Error("Variable with name " + v.name + " was already registered");
	        }
	        this.state.registeredVariables[v.name] = v;
	        this.incRef(v, this.backend);
	        return v;
	    };
	    Engine.prototype.incRef = function (a, backend) {
	        var refCount = this.state.tensorInfo.has(a.dataId) ?
	            this.state.tensorInfo.get(a.dataId).refCount :
	            0;
	        this.state.numTensors++;
	        if (a.dtype === 'string') {
	            this.state.numStringTensors++;
	        }
	        if (refCount === 0) {
	            this.state.numDataBuffers++;
	            // Bytes for complex numbers are counted by their components. Bytes for
	            // string tensors are counted when writing values.
	            var bytes = 0;
	            if (a.dtype !== 'complex64' && a.dtype !== 'string') {
	                bytes = a.size * util.bytesPerElement(a.dtype);
	            }
	            this.state.tensorInfo.set(a.dataId, {
	                backend: backend || this.backend,
	                dtype: a.dtype,
	                shape: a.shape,
	                bytes: bytes,
	                refCount: 0
	            });
	            this.state.numBytes += bytes;
	        }
	        this.state.tensorInfo.get(a.dataId).refCount++;
	        if (!(a instanceof tensor_1.Variable)) {
	            this.track(a);
	        }
	    };
	    Engine.prototype.disposeTensor = function (a) {
	        if (!this.state.tensorInfo.has(a.dataId)) {
	            return;
	        }
	        this.state.numTensors--;
	        if (a.dtype === 'string') {
	            this.state.numStringTensors--;
	        }
	        var info = this.state.tensorInfo.get(a.dataId);
	        var refCount = info.refCount;
	        if (refCount <= 1) {
	            // Don't count bytes for complex numbers as they are counted by their
	            // components.
	            if (a.dtype !== 'complex64') {
	                this.state.numBytes -= info.bytes;
	            }
	            this.state.numDataBuffers--;
	            info.backend.disposeData(a.dataId);
	            this.state.tensorInfo.delete(a.dataId);
	        }
	        else {
	            this.state.tensorInfo.get(a.dataId).refCount--;
	        }
	        // TODO(nsthorat): Construct an error and save the stack trace for
	        // debugging when in debug mode. Creating a stack trace is too expensive
	        // to do unconditionally.
	    };
	    Engine.prototype.disposeVariables = function () {
	        for (var varName in this.state.registeredVariables) {
	            var v = this.state.registeredVariables[varName];
	            this.disposeVariable(v);
	        }
	    };
	    Engine.prototype.disposeVariable = function (v) {
	        this.disposeTensor(v);
	        if (this.state.registeredVariables[v.name] != null) {
	            delete this.state.registeredVariables[v.name];
	        }
	    };
	    Engine.prototype.memory = function () {
	        var info = this.backend.memory();
	        info.numTensors = this.state.numTensors;
	        info.numDataBuffers = this.state.numDataBuffers;
	        info.numBytes = this.state.numBytes;
	        if (this.state.numStringTensors > 0) {
	            info.unreliable = true;
	            if (info.reasons == null) {
	                info.reasons = [];
	            }
	            info.reasons.push('Memory usage by string tensors is approximate ' +
	                '(2 bytes per character)');
	        }
	        return info;
	    };
	    Engine.prototype.profile = function (query) {
	        return __awaiter(this, void 0, void 0, function () {
	            var startBytes, startNumTensors;
	            return __generator(this, function (_a) {
	                this.state.profiling = true;
	                startBytes = this.state.numBytes;
	                startNumTensors = this.state.numTensors;
	                this.state.activeProfile.kernels = [];
	                this.state.activeProfile.result = query();
	                this.state.profiling = false;
	                this.state.activeProfile.peakBytes = Math.max.apply(Math, this.state.activeProfile.kernels.map(function (d) { return d.totalBytesSnapshot; }));
	                this.state.activeProfile.newBytes = this.state.numBytes - startBytes;
	                this.state.activeProfile.newTensors =
	                    this.state.numTensors - startNumTensors;
	                return [2 /*return*/, this.state.activeProfile];
	            });
	        });
	    };
	    Engine.prototype.isTapeOn = function () {
	        return this.state.gradientDepth > 0 && this.state.kernelDepth === 0;
	    };
	    Engine.prototype.addTapeNode = function (kernelName, inputs, outputs, gradientsFunc, saved) {
	        var _this = this;
	        var tapeNode = { id: this.state.nextTapeNodeId++, kernelName: kernelName, inputs: inputs, outputs: outputs, saved: saved };
	        var gradConfig = kernel_registry_1.getGradient(kernelName);
	        if (gradConfig != null) {
	            gradientsFunc = gradConfig.gradFunc;
	        }
	        if (gradientsFunc != null) {
	            tapeNode.gradient = function (dys) {
	                // TODO(smilkov): To optimize back-prop, pass dys that are not used in
	                // the backprop graph to the user as null instead of zeros
	                dys = dys.map(function (dy, i) {
	                    if (dy == null) {
	                        var output = outputs[i];
	                        var vals = util.makeZerosTypedArray(output.size, output.dtype);
	                        return _this.makeTensor(vals, output.shape, output.dtype);
	                    }
	                    return dy;
	                });
	                // Grad functions of ops with single outputs expect a dy, while ops
	                // with multiple outputs expect dys (array of dy).
	                return gradientsFunc(dys.length > 1 ? dys : dys[0], saved);
	            };
	        }
	        this.state.activeTape.push(tapeNode);
	    };
	    Engine.prototype.keep = function (result) {
	        result.kept = true;
	        return result;
	    };
	    Engine.prototype.startTape = function () {
	        if (this.state.gradientDepth === 0) {
	            this.state.activeTape = [];
	        }
	        this.state.gradientDepth++;
	    };
	    Engine.prototype.endTape = function () {
	        this.state.gradientDepth--;
	    };
	    /**
	     * Start a scope. Use this with endScope() to achieve the same functionality
	     * as scope() without the need for a function closure.
	     */
	    Engine.prototype.startScope = function (name) {
	        var scopeInfo = {
	            track: [],
	            name: 'unnamed scope',
	            id: this.state.nextScopeId++
	        };
	        if (name) {
	            scopeInfo.name = name;
	        }
	        this.state.scopeStack.push(scopeInfo);
	        this.state.activeScope = scopeInfo;
	    };
	    /**
	     * End a scope. Use this with startScope() to achieve the same functionality
	     * as scope() without the need for a function closure.
	     */
	    Engine.prototype.endScope = function (result) {
	        var _this = this;
	        var tensorsToTrackInParent = tensor_util_1.getTensorsInContainer(result);
	        var tensorsToTrackInParentSet = new Set(tensorsToTrackInParent.map(function (t) { return t.id; }));
	        // Dispose the arrays tracked in this scope.
	        for (var i = 0; i < this.state.activeScope.track.length; i++) {
	            var tensor = this.state.activeScope.track[i];
	            if (!tensor.kept && !tensorsToTrackInParentSet.has(tensor.id)) {
	                tensor.dispose();
	            }
	        }
	        var oldScope = this.state.scopeStack.pop();
	        this.state.activeScope = this.state.scopeStack.length === 0 ?
	            null :
	            this.state.scopeStack[this.state.scopeStack.length - 1];
	        // Track the current result in the parent scope.
	        tensorsToTrackInParent.forEach(function (tensor) {
	            // Only track the tensor if was allocated in the inner scope and is not
	            // globally kept.
	            if (!tensor.kept && tensor.scopeId === oldScope.id) {
	                _this.track(tensor);
	            }
	        });
	    };
	    /**
	     * Returns gradients of `f` with respect to each of the `xs`. The gradients
	     * returned are of the same length as `xs`, but some might be null if `f`
	     * was not a function of that `x`. It also takes optional dy to multiply the
	     * gradient, which defaults to `1`.
	     */
	    Engine.prototype.gradients = function (f, xs, dy, allowNoGradients) {
	        var _this = this;
	        if (allowNoGradients === void 0) { allowNoGradients = false; }
	        util.assert(xs.length > 0, function () { return 'gradients() received an empty list of xs.'; });
	        if (dy != null && dy.dtype !== 'float32') {
	            throw new Error("dy must have 'float32' dtype, but has '" + dy.dtype + "'");
	        }
	        var y = this.scopedRun(function () { return _this.startTape(); }, function () { return _this.endTape(); }, function () { return _this.tidy('forward', f); });
	        util.assert(y instanceof tensor_1.Tensor, function () { return 'The result y returned by f() must be a tensor.'; });
	        // Filter out the nodes that don't connect x => y.
	        var filteredTape = tape_1.getFilteredNodesXToY(this.state.activeTape, xs, y);
	        if (!allowNoGradients && filteredTape.length === 0 && xs.length > 0) {
	            throw new Error('Cannot compute gradient of y=f(x) with respect to x. Make sure ' +
	                'that the f you passed encloses all operations that lead from x ' +
	                'to y.');
	        }
	        return this.tidy('backward', function () {
	            var accumulatedGradientMap = {};
	            accumulatedGradientMap[y.id] = (dy == null) ? ones(y.shape) : dy;
	            // Backprop gradients through the filtered nodes.
	            tape_1.backpropagateGradients(accumulatedGradientMap, filteredTape, 
	            // Pass the tidy function to avoid circular dep with `tape.ts`.
	            function (f) { return _this.tidy(f); });
	            var grads = xs.map(function (x) { return accumulatedGradientMap[x.id]; });
	            if (_this.state.gradientDepth === 0) {
	                // This means that we are not computing higher-order gradients
	                // and can clean up the tape.
	                _this.state.activeTape.forEach(function (node) {
	                    for (var _i = 0, _a = node.saved; _i < _a.length; _i++) {
	                        var tensor = _a[_i];
	                        tensor.dispose();
	                    }
	                });
	                _this.state.activeTape = null;
	            }
	            return { value: y, grads: grads };
	        });
	    };
	    Engine.prototype.customGrad = function (f) {
	        var _this = this;
	        util.assert(util.isFunction(f), function () { return 'The f passed in customGrad(f) must be a function.'; });
	        return function () {
	            var inputs = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                inputs[_i] = arguments[_i];
	            }
	            util.assert(inputs.every(function (t) { return t instanceof tensor_1.Tensor; }), function () { return 'The args passed in customGrad(f)(x1, x2,...) must all be ' +
	                'tensors'; });
	            var res;
	            var inputMap = {};
	            inputs.forEach(function (input, i) {
	                inputMap[i] = input;
	            });
	            return _this.runKernelFunc(function (_, save) {
	                res = f.apply(void 0, inputs.concat([save]));
	                util.assert(res.value instanceof tensor_1.Tensor, function () { return 'The function f passed in customGrad(f) must return an ' +
	                    'object where `obj.value` is a tensor'; });
	                util.assert(util.isFunction(res.gradFunc), function () { return 'The function f passed in customGrad(f) must return an ' +
	                    'object where `obj.gradFunc` is a function.'; });
	                return res.value;
	            }, inputMap, function (dy, saved) {
	                var gradRes = res.gradFunc(dy, saved);
	                var grads = Array.isArray(gradRes) ? gradRes : [gradRes];
	                util.assert(grads.length === inputs.length, function () { return 'The function f passed in customGrad(f) must return an ' +
	                    'object where `obj.gradFunc` is a function that returns ' +
	                    'the same number of tensors as inputs passed to f(...).'; });
	                util.assert(grads.every(function (t) { return t instanceof tensor_1.Tensor; }), function () { return 'The function f passed in customGrad(f) must return an ' +
	                    'object where `obj.gradFunc` is a function that returns ' +
	                    'a list of only tensors.'; });
	                var gradMap = {};
	                grads.forEach(function (grad, i) {
	                    gradMap[i] = function () { return grad; };
	                });
	                return gradMap;
	            });
	        };
	    };
	    Engine.prototype.readSync = function (dataId) {
	        // Route the read to the correct backend.
	        var info = this.state.tensorInfo.get(dataId);
	        return info.backend.readSync(dataId);
	    };
	    Engine.prototype.read = function (dataId) {
	        // Route the read to the correct backend.
	        var info = this.state.tensorInfo.get(dataId);
	        return info.backend.read(dataId);
	    };
	    Engine.prototype.time = function (query) {
	        return __awaiter(this, void 0, void 0, function () {
	            var start, timingInfo;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        start = util_1.now();
	                        return [4 /*yield*/, this.backend.time(query)];
	                    case 1:
	                        timingInfo = _a.sent();
	                        timingInfo.wallMs = util_1.now() - start;
	                        return [2 /*return*/, timingInfo];
	                }
	            });
	        });
	    };
	    /**
	     * Tracks a Tensor in the current scope to be automatically cleaned up
	     * when the current scope ends, and returns the value.
	     *
	     * @param result The Tensor to track in the current scope.
	     */
	    Engine.prototype.track = function (result) {
	        if (this.state.activeScope != null) {
	            result.scopeId = this.state.activeScope.id;
	            this.state.activeScope.track.push(result);
	        }
	        return result;
	    };
	    Object.defineProperty(Engine.prototype, "registeredVariables", {
	        get: function () {
	            return this.state.registeredVariables;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Resets the engine state. Removes all backends but does not remove
	     * registered backend factories.
	     */
	    Engine.prototype.reset = function () {
	        // Make any pending promise obsolete.
	        this.pendingBackendInitId++;
	        this.state.dispose();
	        this.ENV.reset();
	        this.state = new EngineState();
	        for (var backendName in this.registry) {
	            this.disposeRegisteredKernels(backendName);
	            this.registry[backendName].dispose();
	            delete this.registry[backendName];
	        }
	        this.backendName = null;
	        this.backendInstance = null;
	        this.pendingBackendInit = null;
	    };
	    Engine.nextTensorId = 0;
	    Engine.nextVariableId = 0;
	    return Engine;
	}());
	exports.Engine = Engine;
	function ones(shape) {
	    var values = util_1.makeOnesTypedArray(util_1.sizeFromShape(shape), 'float32');
	    return exports.ENGINE.makeTensor(values, shape, 'float32');
	}
	var GLOBAL;
	function getGlobalNamespace() {
	    if (GLOBAL == null) {
	        // tslint:disable-next-line:no-any
	        var ns = void 0;
	        if (typeof (window) !== 'undefined') {
	            ns = window;
	        }
	        else if (typeof (global) !== 'undefined') {
	            ns = global;
	        }
	        else if (typeof (process) !== 'undefined') {
	            ns = process;
	        }
	        else if (typeof (self) !== 'undefined') {
	            ns = self;
	        }
	        else {
	            throw new Error('Could not find a global object');
	        }
	        GLOBAL = ns;
	    }
	    return GLOBAL;
	}
	function getOrMakeEngine() {
	    var ns = getGlobalNamespace();
	    if (ns._tfengine == null) {
	        var environment = new environment_1.Environment(ns);
	        ns._tfengine = new Engine(environment);
	    }
	    environment_1.setEnvironmentGlobal(ns._tfengine.ENV);
	    // Tell the current tensor interface that the global engine is responsible
	    // for tracking.
	    tensor_1.setTensorTracker(function () { return ns._tfengine; });
	    return ns._tfengine;
	}
	exports.ENGINE = getOrMakeEngine();
	//# sourceMappingURL=engine.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(39)))

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.values = exports.untouch = exports.unregisterField = exports.touch = exports.SubmissionError = exports.submit = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.setSubmitSucceeded = exports.setSubmitFailed = exports.reset = exports.registerField = exports.reduxForm = exports.reducer = exports.propTypes = exports.isValid = exports.isPristine = exports.isInvalid = exports.isDirty = exports.initialize = exports.getFormSubmitErrors = exports.getFormSyncErrors = exports.getFormValues = exports.formValueSelector = exports.focus = exports.FormSection = exports.FieldArray = exports.Fields = exports.Field = exports.destroy = exports.change = exports.autofill = exports.blur = exports.arrayUnshift = exports.arraySwap = exports.arraySplice = exports.arrayShift = exports.arrayRemoveAll = exports.arrayRemove = exports.arrayPush = exports.arrayPop = exports.arrayMove = exports.arrayInsert = exports.actionTypes = undefined;
	
	var _createAll2 = __webpack_require__(1985);
	
	var _createAll3 = _interopRequireDefault(_createAll2);
	
	var _plain = __webpack_require__(148);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _createAll = (0, _createAll3.default)(_plain2.default);
	
	var actionTypes = _createAll.actionTypes,
	    arrayInsert = _createAll.arrayInsert,
	    arrayMove = _createAll.arrayMove,
	    arrayPop = _createAll.arrayPop,
	    arrayPush = _createAll.arrayPush,
	    arrayRemove = _createAll.arrayRemove,
	    arrayRemoveAll = _createAll.arrayRemoveAll,
	    arrayShift = _createAll.arrayShift,
	    arraySplice = _createAll.arraySplice,
	    arraySwap = _createAll.arraySwap,
	    arrayUnshift = _createAll.arrayUnshift,
	    blur = _createAll.blur,
	    autofill = _createAll.autofill,
	    change = _createAll.change,
	    destroy = _createAll.destroy,
	    Field = _createAll.Field,
	    Fields = _createAll.Fields,
	    FieldArray = _createAll.FieldArray,
	    FormSection = _createAll.FormSection,
	    focus = _createAll.focus,
	    formValueSelector = _createAll.formValueSelector,
	    getFormValues = _createAll.getFormValues,
	    getFormSyncErrors = _createAll.getFormSyncErrors,
	    getFormSubmitErrors = _createAll.getFormSubmitErrors,
	    initialize = _createAll.initialize,
	    isDirty = _createAll.isDirty,
	    isInvalid = _createAll.isInvalid,
	    isPristine = _createAll.isPristine,
	    isValid = _createAll.isValid,
	    propTypes = _createAll.propTypes,
	    reducer = _createAll.reducer,
	    reduxForm = _createAll.reduxForm,
	    registerField = _createAll.registerField,
	    reset = _createAll.reset,
	    setSubmitFailed = _createAll.setSubmitFailed,
	    setSubmitSucceeded = _createAll.setSubmitSucceeded,
	    startAsyncValidation = _createAll.startAsyncValidation,
	    startSubmit = _createAll.startSubmit,
	    stopAsyncValidation = _createAll.stopAsyncValidation,
	    stopSubmit = _createAll.stopSubmit,
	    submit = _createAll.submit,
	    SubmissionError = _createAll.SubmissionError,
	    touch = _createAll.touch,
	    unregisterField = _createAll.unregisterField,
	    untouch = _createAll.untouch,
	    values = _createAll.values;
	exports.actionTypes = actionTypes;
	exports.arrayInsert = arrayInsert;
	exports.arrayMove = arrayMove;
	exports.arrayPop = arrayPop;
	exports.arrayPush = arrayPush;
	exports.arrayRemove = arrayRemove;
	exports.arrayRemoveAll = arrayRemoveAll;
	exports.arrayShift = arrayShift;
	exports.arraySplice = arraySplice;
	exports.arraySwap = arraySwap;
	exports.arrayUnshift = arrayUnshift;
	exports.blur = blur;
	exports.autofill = autofill;
	exports.change = change;
	exports.destroy = destroy;
	exports.Field = Field;
	exports.Fields = Fields;
	exports.FieldArray = FieldArray;
	exports.FormSection = FormSection;
	exports.focus = focus;
	exports.formValueSelector = formValueSelector;
	exports.getFormValues = getFormValues;
	exports.getFormSyncErrors = getFormSyncErrors;
	exports.getFormSubmitErrors = getFormSubmitErrors;
	exports.initialize = initialize;
	exports.isDirty = isDirty;
	exports.isInvalid = isInvalid;
	exports.isPristine = isPristine;
	exports.isValid = isValid;
	exports.propTypes = propTypes;
	exports.reducer = reducer;
	exports.reduxForm = reduxForm;
	exports.registerField = registerField;
	exports.reset = reset;
	exports.setSubmitFailed = setSubmitFailed;
	exports.setSubmitSucceeded = setSubmitSucceeded;
	exports.startAsyncValidation = startAsyncValidation;
	exports.startSubmit = startSubmit;
	exports.stopAsyncValidation = stopAsyncValidation;
	exports.stopSubmit = stopSubmit;
	exports.submit = submit;
	exports.SubmissionError = SubmissionError;
	exports.touch = touch;
	exports.unregisterField = unregisterField;
	exports.untouch = untouch;
	exports.values = values;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var environment_1 = __webpack_require__(28);
	var tensor_1 = __webpack_require__(75);
	var util_1 = __webpack_require__(10);
	function inferShape(val, dtype) {
	    var firstElem = val;
	    if (util_1.isTypedArray(val)) {
	        return dtype === 'string' ? [] : [val.length];
	    }
	    if (!Array.isArray(val)) {
	        return []; // Scalar.
	    }
	    var shape = [];
	    while (Array.isArray(firstElem) ||
	        util_1.isTypedArray(firstElem) && dtype !== 'string') {
	        shape.push(firstElem.length);
	        firstElem = firstElem[0];
	    }
	    if (Array.isArray(val) &&
	        environment_1.env().getBool('TENSORLIKE_CHECK_SHAPE_CONSISTENCY')) {
	        deepAssertShapeConsistency(val, shape, []);
	    }
	    return shape;
	}
	exports.inferShape = inferShape;
	function deepAssertShapeConsistency(val, shape, indices) {
	    indices = indices || [];
	    if (!(Array.isArray(val)) && !util_1.isTypedArray(val)) {
	        util_1.assert(shape.length === 0, function () { return "Element arr[" + indices.join('][') + "] is a primitive, " +
	            ("but should be an array/TypedArray of " + shape[0] + " elements"); });
	        return;
	    }
	    util_1.assert(shape.length > 0, function () { return "Element arr[" + indices.join('][') + "] should be a primitive, " +
	        ("but is an array of " + val.length + " elements"); });
	    util_1.assert(val.length === shape[0], function () { return "Element arr[" + indices.join('][') + "] should have " + shape[0] + " " +
	        ("elements, but has " + val.length + " elements"); });
	    var subShape = shape.slice(1);
	    for (var i = 0; i < val.length; ++i) {
	        deepAssertShapeConsistency(val[i], subShape, indices.concat(i));
	    }
	}
	function assertDtype(expectedDtype, actualDType, argName, functionName) {
	    if (expectedDtype == null) {
	        return;
	    }
	    if (expectedDtype !== 'numeric' && expectedDtype !== actualDType ||
	        expectedDtype === 'numeric' && actualDType === 'string') {
	        throw new Error("Argument '" + argName + "' passed to '" + functionName + "' must " +
	            ("be " + expectedDtype + " tensor, but got " + actualDType + " tensor"));
	    }
	}
	function convertToTensor(x, argName, functionName, parseAsDtype) {
	    if (parseAsDtype === void 0) { parseAsDtype = 'numeric'; }
	    if (x instanceof tensor_1.Tensor) {
	        assertDtype(parseAsDtype, x.dtype, argName, functionName);
	        return x;
	    }
	    var inferredDtype = util_1.inferDtype(x);
	    // If the user expects a bool/int/float, use that info to update the
	    // inferredDtype when it is not a string.
	    if (inferredDtype !== 'string' &&
	        ['bool', 'int32', 'float32'].indexOf(parseAsDtype) >= 0) {
	        inferredDtype = parseAsDtype;
	    }
	    assertDtype(parseAsDtype, inferredDtype, argName, functionName);
	    if ((x == null) ||
	        (!util_1.isTypedArray(x) && !Array.isArray(x) && typeof x !== 'number' &&
	            typeof x !== 'boolean' && typeof x !== 'string')) {
	        var type = x == null ? 'null' : x.constructor.name;
	        throw new Error("Argument '" + argName + "' passed to '" + functionName + "' must be a " +
	            ("Tensor or TensorLike, but got '" + type + "'"));
	    }
	    var inferredShape = inferShape(x, inferredDtype);
	    if (!util_1.isTypedArray(x) && !Array.isArray(x)) {
	        x = [x];
	    }
	    var skipTypedArray = true;
	    var values = inferredDtype !== 'string' ?
	        util_1.toTypedArray(x, inferredDtype, environment_1.env().getBool('DEBUG')) :
	        util_1.flatten(x, [], skipTypedArray);
	    return engine_1.ENGINE.makeTensor(values, inferredShape, inferredDtype);
	}
	exports.convertToTensor = convertToTensor;
	function convertToTensorArray(arg, argName, functionName, parseAsDtype) {
	    if (parseAsDtype === void 0) { parseAsDtype = 'numeric'; }
	    if (!Array.isArray(arg)) {
	        throw new Error("Argument " + argName + " passed to " + functionName + " must be a " +
	            '`Tensor[]` or `TensorLike[]`');
	    }
	    var tensors = arg;
	    return tensors.map(function (t, i) { return convertToTensor(t, argName + "[" + i + "]", functionName); }, parseAsDtype);
	}
	exports.convertToTensorArray = convertToTensorArray;
	//# sourceMappingURL=tensor_util_env.js.map

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var engine_1 = __webpack_require__(15);
	/**
	 * Used for wrapping functions that perform math operations on
	 * Tensors. The function will be wrapped in a named scope that cleans all
	 * memory usage after the function is done.
	 */
	function op(f) {
	    var keys = Object.keys(f);
	    if (keys.length !== 1) {
	        throw new Error("Please provide an object with a single key " +
	            "(operation name) mapping to a function. Got an object with " +
	            (keys.length + " keys."));
	    }
	    var opName = keys[0];
	    var fn = f[opName];
	    // Strip the underscore from the end of the function name.
	    if (opName.endsWith('_')) {
	        opName = opName.substring(0, opName.length - 1);
	    }
	    // tslint:disable-next-line:no-any
	    var f2 = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        engine_1.ENGINE.startScope(opName);
	        try {
	            var result = fn.apply(void 0, args);
	            if (result instanceof Promise) {
	                console.error('Cannot return a Promise inside of tidy.');
	            }
	            engine_1.ENGINE.endScope(result);
	            return result;
	        }
	        catch (ex) {
	            engine_1.ENGINE.endScope(null);
	            throw ex;
	        }
	    };
	    Object.defineProperty(f2, 'name', { value: opName, configurable: true });
	    // tslint:disable-next-line:no-any
	    return f2;
	}
	exports.op = op;
	//# sourceMappingURL=operation.js.map

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(1934);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(1935);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 21 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MODIFIER_KEY_NAMES = exports.DEFAULT_VERTICAL_SPACING = exports.FANG_HEIGHT_PX = exports.FANG_WIDTH_PX = exports.WEEKDAYS = exports.BLOCKED_MODIFIER = exports.DAY_SIZE = exports.OPEN_UP = exports.OPEN_DOWN = exports.ANCHOR_RIGHT = exports.ANCHOR_LEFT = exports.INFO_POSITION_AFTER = exports.INFO_POSITION_BEFORE = exports.INFO_POSITION_BOTTOM = exports.INFO_POSITION_TOP = exports.ICON_AFTER_POSITION = exports.ICON_BEFORE_POSITION = exports.VERTICAL_SCROLLABLE = exports.VERTICAL_ORIENTATION = exports.HORIZONTAL_ORIENTATION = exports.END_DATE = exports.START_DATE = exports.ISO_MONTH_FORMAT = exports.ISO_FORMAT = exports.DISPLAY_FORMAT = void 0;
	var DISPLAY_FORMAT = 'L';
	exports.DISPLAY_FORMAT = DISPLAY_FORMAT;
	var ISO_FORMAT = 'YYYY-MM-DD';
	exports.ISO_FORMAT = ISO_FORMAT;
	var ISO_MONTH_FORMAT = 'YYYY-MM';
	exports.ISO_MONTH_FORMAT = ISO_MONTH_FORMAT;
	var START_DATE = 'startDate';
	exports.START_DATE = START_DATE;
	var END_DATE = 'endDate';
	exports.END_DATE = END_DATE;
	var HORIZONTAL_ORIENTATION = 'horizontal';
	exports.HORIZONTAL_ORIENTATION = HORIZONTAL_ORIENTATION;
	var VERTICAL_ORIENTATION = 'vertical';
	exports.VERTICAL_ORIENTATION = VERTICAL_ORIENTATION;
	var VERTICAL_SCROLLABLE = 'verticalScrollable';
	exports.VERTICAL_SCROLLABLE = VERTICAL_SCROLLABLE;
	var ICON_BEFORE_POSITION = 'before';
	exports.ICON_BEFORE_POSITION = ICON_BEFORE_POSITION;
	var ICON_AFTER_POSITION = 'after';
	exports.ICON_AFTER_POSITION = ICON_AFTER_POSITION;
	var INFO_POSITION_TOP = 'top';
	exports.INFO_POSITION_TOP = INFO_POSITION_TOP;
	var INFO_POSITION_BOTTOM = 'bottom';
	exports.INFO_POSITION_BOTTOM = INFO_POSITION_BOTTOM;
	var INFO_POSITION_BEFORE = 'before';
	exports.INFO_POSITION_BEFORE = INFO_POSITION_BEFORE;
	var INFO_POSITION_AFTER = 'after';
	exports.INFO_POSITION_AFTER = INFO_POSITION_AFTER;
	var ANCHOR_LEFT = 'left';
	exports.ANCHOR_LEFT = ANCHOR_LEFT;
	var ANCHOR_RIGHT = 'right';
	exports.ANCHOR_RIGHT = ANCHOR_RIGHT;
	var OPEN_DOWN = 'down';
	exports.OPEN_DOWN = OPEN_DOWN;
	var OPEN_UP = 'up';
	exports.OPEN_UP = OPEN_UP;
	var DAY_SIZE = 39;
	exports.DAY_SIZE = DAY_SIZE;
	var BLOCKED_MODIFIER = 'blocked';
	exports.BLOCKED_MODIFIER = BLOCKED_MODIFIER;
	var WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];
	exports.WEEKDAYS = WEEKDAYS;
	var FANG_WIDTH_PX = 20;
	exports.FANG_WIDTH_PX = FANG_WIDTH_PX;
	var FANG_HEIGHT_PX = 10;
	exports.FANG_HEIGHT_PX = FANG_HEIGHT_PX;
	var DEFAULT_VERTICAL_SPACING = 22;
	exports.DEFAULT_VERTICAL_SPACING = DEFAULT_VERTICAL_SPACING;
	var MODIFIER_KEY_NAMES = new Set(['Shift', 'Control', 'Alt', 'Meta']);
	exports.MODIFIER_KEY_NAMES = MODIFIER_KEY_NAMES;

/***/ },
/* 22 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./type')} */
	module.exports = TypeError;


/***/ },
/* 23 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1092);

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(99);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2019, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var allLocaleData = _interopDefault(__webpack_require__(2081));
	var IntlMessageFormat = _interopDefault(__webpack_require__(638));
	var IntlRelativeFormat = _interopDefault(__webpack_require__(1541));
	var PropTypes = _interopDefault(__webpack_require__(3));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var hoistNonReactStatics = _interopDefault(__webpack_require__(405));
	var invariant = _interopDefault(__webpack_require__(36));
	var memoizeIntlConstructor = _interopDefault(__webpack_require__(1533));
	
	// GENERATED FILE
	var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
	    var s = String(n).split("."),
	        v0 = !s[1],
	        t0 = Number(s[0]) == n,
	        n10 = t0 && s[0].slice(-1),
	        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
	  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function addLocaleData() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var locales = Array.isArray(data) ? data : [data];
	
	  locales.forEach(function (localeData) {
	    if (localeData && localeData.locale) {
	      IntlMessageFormat.__addLocaleData(localeData);
	      IntlRelativeFormat.__addLocaleData(localeData);
	    }
	  });
	}
	
	function hasLocaleData(locale) {
	  var localeParts = (locale || '').split('-');
	
	  while (localeParts.length > 0) {
	    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
	      return true;
	    }
	
	    localeParts.pop();
	  }
	
	  return false;
	}
	
	function hasIMFAndIRFLocaleData(locale) {
	  var normalizedLocale = locale && locale.toLowerCase();
	
	  return !!(IntlMessageFormat.__localeData__[normalizedLocale] && IntlRelativeFormat.__localeData__[normalizedLocale]);
	}
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	var asyncGenerator = function () {
	  function AwaitValue(value) {
	    this.value = value;
	  }
	
	  function AsyncGenerator(gen) {
	    var front, back;
	
	    function send(key, arg) {
	      return new Promise(function (resolve, reject) {
	        var request = {
	          key: key,
	          arg: arg,
	          resolve: resolve,
	          reject: reject,
	          next: null
	        };
	
	        if (back) {
	          back = back.next = request;
	        } else {
	          front = back = request;
	          resume(key, arg);
	        }
	      });
	    }
	
	    function resume(key, arg) {
	      try {
	        var result = gen[key](arg);
	        var value = result.value;
	
	        if (value instanceof AwaitValue) {
	          Promise.resolve(value.value).then(function (arg) {
	            resume("next", arg);
	          }, function (arg) {
	            resume("throw", arg);
	          });
	        } else {
	          settle(result.done ? "return" : "normal", result.value);
	        }
	      } catch (err) {
	        settle("throw", err);
	      }
	    }
	
	    function settle(type, value) {
	      switch (type) {
	        case "return":
	          front.resolve({
	            value: value,
	            done: true
	          });
	          break;
	
	        case "throw":
	          front.reject(value);
	          break;
	
	        default:
	          front.resolve({
	            value: value,
	            done: false
	          });
	          break;
	      }
	
	      front = front.next;
	
	      if (front) {
	        resume(front.key, front.arg);
	      } else {
	        back = null;
	      }
	    }
	
	    this._invoke = send;
	
	    if (typeof gen.return !== "function") {
	      this.return = undefined;
	    }
	  }
	
	  if (typeof Symbol === "function" && Symbol.asyncIterator) {
	    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
	      return this;
	    };
	  }
	
	  AsyncGenerator.prototype.next = function (arg) {
	    return this._invoke("next", arg);
	  };
	
	  AsyncGenerator.prototype.throw = function (arg) {
	    return this._invoke("throw", arg);
	  };
	
	  AsyncGenerator.prototype.return = function (arg) {
	    return this._invoke("return", arg);
	  };
	
	  return {
	    wrap: function (fn) {
	      return function () {
	        return new AsyncGenerator(fn.apply(this, arguments));
	      };
	    },
	    await: function (value) {
	      return new AwaitValue(value);
	    }
	  };
	}();
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var bool = PropTypes.bool;
	var number = PropTypes.number;
	var string = PropTypes.string;
	var func = PropTypes.func;
	var object = PropTypes.object;
	var oneOf = PropTypes.oneOf;
	var shape = PropTypes.shape;
	var any = PropTypes.any;
	var oneOfType = PropTypes.oneOfType;
	
	var localeMatcher = oneOf(['best fit', 'lookup']);
	var narrowShortLong = oneOf(['narrow', 'short', 'long']);
	var numeric2digit = oneOf(['numeric', '2-digit']);
	var funcReq = func.isRequired;
	
	var intlConfigPropTypes = {
	  locale: string,
	  timeZone: string,
	  formats: object,
	  messages: object,
	  textComponent: any,
	
	  defaultLocale: string,
	  defaultFormats: object,
	
	  onError: func
	};
	
	var intlFormatPropTypes = {
	  formatDate: funcReq,
	  formatTime: funcReq,
	  formatRelative: funcReq,
	  formatNumber: funcReq,
	  formatPlural: funcReq,
	  formatMessage: funcReq,
	  formatHTMLMessage: funcReq
	};
	
	var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
	  formatters: object,
	  now: funcReq
	}));
	
	var messageDescriptorPropTypes = {
	  id: string.isRequired,
	  description: oneOfType([string, object]),
	  defaultMessage: string
	};
	
	var dateTimeFormatPropTypes = {
	  localeMatcher: localeMatcher,
	  formatMatcher: oneOf(['basic', 'best fit']),
	
	  timeZone: string,
	  hour12: bool,
	
	  weekday: narrowShortLong,
	  era: narrowShortLong,
	  year: numeric2digit,
	  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
	  day: numeric2digit,
	  hour: numeric2digit,
	  minute: numeric2digit,
	  second: numeric2digit,
	  timeZoneName: oneOf(['short', 'long'])
	};
	
	var numberFormatPropTypes = {
	  localeMatcher: localeMatcher,
	
	  style: oneOf(['decimal', 'currency', 'percent']),
	  currency: string,
	  currencyDisplay: oneOf(['symbol', 'code', 'name']),
	  useGrouping: bool,
	
	  minimumIntegerDigits: number,
	  minimumFractionDigits: number,
	  maximumFractionDigits: number,
	  minimumSignificantDigits: number,
	  maximumSignificantDigits: number
	};
	
	var relativeFormatPropTypes = {
	  style: oneOf(['best fit', 'numeric']),
	  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year', 'second-short', 'minute-short', 'hour-short', 'day-short', 'month-short', 'year-short'])
	};
	
	var pluralFormatPropTypes = {
	  style: oneOf(['cardinal', 'ordinal'])
	};
	
	/*
	HTML escaping and shallow-equals implementations are the same as React's
	(on purpose.) Therefore, it has the following Copyright and Licensing:
	
	Copyright 2013-2014, Facebook, Inc.
	All rights reserved.
	
	This source code is licensed under the BSD-style license found in the LICENSE
	file in the root directory of React's source tree.
	*/
	
	var intlConfigPropNames = Object.keys(intlConfigPropTypes);
	
	var ESCAPED_CHARS = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  "'": '&#x27;'
	};
	
	var UNSAFE_CHARS_REGEX = /[&><"']/g;
	
	function escape(str) {
	  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
	    return ESCAPED_CHARS[match];
	  });
	}
	
	function filterProps(props, whitelist) {
	  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  return whitelist.reduce(function (filtered, name) {
	    if (props.hasOwnProperty(name)) {
	      filtered[name] = props[name];
	    } else if (defaults$$1.hasOwnProperty(name)) {
	      filtered[name] = defaults$$1[name];
	    }
	
	    return filtered;
	  }, {});
	}
	
	function invariantIntlContext() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      intl = _ref.intl;
	
	  invariant(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
	}
	
	function shallowEquals(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
	  var props = _ref2.props,
	      state = _ref2.state,
	      _ref2$context = _ref2.context,
	      context = _ref2$context === undefined ? {} : _ref2$context;
	  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var _context$intl = context.intl,
	      intl = _context$intl === undefined ? {} : _context$intl;
	  var _nextContext$intl = nextContext.intl,
	      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;
	
	
	  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
	}
	
	function createError(message, exception) {
	  var eMsg = exception ? '\n' + exception : '';
	  return '[React Intl] ' + message + eMsg;
	}
	
	function defaultErrorHandler(error) {
	  if (false) {
	    console.error(error);
	  }
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// Inspired by react-redux's `connect()` HOC factory function implementation:
	// https://github.com/rackt/react-redux
	
	function getDisplayName(Component$$1) {
	  return Component$$1.displayName || Component$$1.name || 'Component';
	}
	
	function injectIntl(WrappedComponent) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$intlPropName = options.intlPropName,
	      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var InjectIntl = function (_Component) {
	    inherits(InjectIntl, _Component);
	
	    function InjectIntl(props, context) {
	      classCallCheck(this, InjectIntl);
	
	      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));
	
	      invariantIntlContext(context);
	      return _this;
	    }
	
	    createClass(InjectIntl, [{
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        invariant(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');
	
	        return this._wrappedInstance;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        return React__default.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
	          ref: withRef ? /* istanbul ignore next */function (ref) {
	            return _this2._wrappedInstance = ref;
	          } : null
	        }));
	      }
	    }]);
	    return InjectIntl;
	  }(React.Component);
	
	  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
	  InjectIntl.contextTypes = {
	    intl: intlShape
	  };
	  InjectIntl.WrappedComponent = WrappedComponent;
	
	
	  return hoistNonReactStatics(InjectIntl, WrappedComponent);
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function defineMessages(messageDescriptors) {
	  // This simply returns what's passed-in because it's meant to be a hook for
	  // babel-plugin-react-intl.
	  return messageDescriptors;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// This is a "hack" until a proper `intl-pluralformat` package is created.
	
	function resolveLocale(locales) {
	  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
	  return IntlMessageFormat.prototype._resolveLocale(locales);
	}
	
	function findPluralFunction(locale) {
	  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
	  return IntlMessageFormat.prototype._findPluralRuleFunction(locale);
	}
	
	var IntlPluralFormat = function IntlPluralFormat(locales) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  classCallCheck(this, IntlPluralFormat);
	
	  var useOrdinal = options.style === 'ordinal';
	  var pluralFn = findPluralFunction(resolveLocale(locales));
	
	  this.format = function (value) {
	    return pluralFn(value, useOrdinal);
	  };
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
	var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
	var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
	var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);
	
	var RELATIVE_FORMAT_THRESHOLDS = {
	  second: 60, // seconds to minute
	  minute: 60, // minutes to hour
	  hour: 24, // hours to day
	  day: 30, // days to month
	  month: 12 };
	
	function updateRelativeFormatThresholds(newThresholds) {
	  var thresholds = IntlRelativeFormat.thresholds;
	  thresholds.second = newThresholds.second;
	  thresholds.minute = newThresholds.minute;
	  thresholds.hour = newThresholds.hour;
	  thresholds.day = newThresholds.day;
	  thresholds.month = newThresholds.month;
	  thresholds['second-short'] = newThresholds['second-short'];
	  thresholds['minute-short'] = newThresholds['minute-short'];
	  thresholds['hour-short'] = newThresholds['hour-short'];
	  thresholds['day-short'] = newThresholds['day-short'];
	  thresholds['month-short'] = newThresholds['month-short'];
	}
	
	function getNamedFormat(formats, type, name, onError) {
	  var format = formats && formats[type] && formats[type][name];
	  if (format) {
	    return format;
	  }
	
	  onError(createError('No ' + type + ' format named: ' + name));
	}
	
	function formatDate(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats,
	      timeZone = config.timeZone;
	  var format = options.format;
	
	
	  var onError = config.onError || defaultErrorHandler;
	  var date = new Date(value);
	  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'date', format, onError));
	  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);
	
	  try {
	    return state.getDateTimeFormat(locale, filteredOptions).format(date);
	  } catch (e) {
	    onError(createError('Error formatting date.', e));
	  }
	
	  return String(date);
	}
	
	function formatTime(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats,
	      timeZone = config.timeZone;
	  var format = options.format;
	
	
	  var onError = config.onError || defaultErrorHandler;
	  var date = new Date(value);
	  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'time', format, onError));
	  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);
	
	  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
	    // Add default formatting options if hour, minute, or second isn't defined.
	    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
	  }
	
	  try {
	    return state.getDateTimeFormat(locale, filteredOptions).format(date);
	  } catch (e) {
	    onError(createError('Error formatting time.', e));
	  }
	
	  return String(date);
	}
	
	function formatRelative(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats;
	  var format = options.format;
	
	
	  var onError = config.onError || defaultErrorHandler;
	  var date = new Date(value);
	  var now = new Date(options.now);
	  var defaults$$1 = format && getNamedFormat(formats, 'relative', format, onError);
	  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);
	
	  // Capture the current threshold values, then temporarily override them with
	  // specific values just for this render.
	  var oldThresholds = _extends({}, IntlRelativeFormat.thresholds);
	  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);
	
	  try {
	    return state.getRelativeFormat(locale, filteredOptions).format(date, {
	      now: isFinite(now) ? now : state.now()
	    });
	  } catch (e) {
	    onError(createError('Error formatting relative time.', e));
	  } finally {
	    updateRelativeFormatThresholds(oldThresholds);
	  }
	
	  return String(date);
	}
	
	function formatNumber(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats;
	  var format = options.format;
	
	
	  var onError = config.onError || defaultErrorHandler;
	  var defaults$$1 = format && getNamedFormat(formats, 'number', format, onError);
	  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);
	
	  try {
	    return state.getNumberFormat(locale, filteredOptions).format(value);
	  } catch (e) {
	    onError(createError('Error formatting number.', e));
	  }
	
	  return String(value);
	}
	
	function formatPlural(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale;
	
	
	  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
	  var onError = config.onError || defaultErrorHandler;
	
	  try {
	    return state.getPluralFormat(locale, filteredOptions).format(value);
	  } catch (e) {
	    onError(createError('Error formatting plural.', e));
	  }
	
	  return 'other';
	}
	
	function formatMessage(config, state) {
	  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats,
	      messages = config.messages,
	      defaultLocale = config.defaultLocale,
	      defaultFormats = config.defaultFormats;
	  var id = messageDescriptor.id,
	      defaultMessage = messageDescriptor.defaultMessage;
	
	  // Produce a better error if the user calls `intl.formatMessage(element)`
	
	  if (false) {
	    invariant(!React.isValidElement(config), '[React Intl] Don\'t pass React elements to ' + 'formatMessage(), pass `.props`.');
	  }
	
	  // `id` is a required field of a Message Descriptor.
	  invariant(id, '[React Intl] An `id` must be provided to format a message.');
	
	  var message = messages && messages[id];
	  var hasValues = Object.keys(values).length > 0;
	
	  // Avoid expensive message formatting for simple messages without values. In
	  // development messages will always be formatted in case of missing values.
	  if (!hasValues && ("production") === 'production') {
	    return message || defaultMessage || id;
	  }
	
	  var formattedMessage = void 0;
	  var onError = config.onError || defaultErrorHandler;
	
	  if (message) {
	    try {
	      var formatter = state.getMessageFormat(message, locale, formats);
	
	      formattedMessage = formatter.format(values);
	    } catch (e) {
	      onError(createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''), e));
	    }
	  } else {
	    // This prevents warnings from littering the console in development
	    // when no `messages` are passed into the <IntlProvider> for the
	    // default locale, and a default message is in the source.
	    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
	      onError(createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '')));
	    }
	  }
	
	  if (!formattedMessage && defaultMessage) {
	    try {
	      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);
	
	      formattedMessage = _formatter.format(values);
	    } catch (e) {
	      onError(createError('Error formatting the default message for: "' + id + '"', e));
	    }
	  }
	
	  if (!formattedMessage) {
	    onError(createError('Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.')));
	  }
	
	  return formattedMessage || message || defaultMessage || id;
	}
	
	function formatHTMLMessage(config, state, messageDescriptor) {
	  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  // Process all the values before they are used when formatting the ICU
	  // Message string. Since the formatted message might be injected via
	  // `innerHTML`, all String-based values need to be HTML-escaped.
	  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
	    var value = rawValues[name];
	    escaped[name] = typeof value === 'string' ? escape(value) : value;
	    return escaped;
	  }, {});
	
	  return formatMessage(config, state, messageDescriptor, escapedValues);
	}
	
	
	
	var format = Object.freeze({
		formatDate: formatDate,
		formatTime: formatTime,
		formatRelative: formatRelative,
		formatNumber: formatNumber,
		formatPlural: formatPlural,
		formatMessage: formatMessage,
		formatHTMLMessage: formatHTMLMessage
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
	var intlFormatPropNames = Object.keys(intlFormatPropTypes);
	
	// These are not a static property on the `IntlProvider` class so the intl
	// config values can be inherited from an <IntlProvider> ancestor.
	var defaultProps = {
	  formats: {},
	  messages: {},
	  timeZone: null,
	  textComponent: 'span',
	
	  defaultLocale: 'en',
	  defaultFormats: {},
	
	  onError: defaultErrorHandler
	};
	
	var IntlProvider = function (_Component) {
	  inherits(IntlProvider, _Component);
	
	  function IntlProvider(props) {
	    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    classCallCheck(this, IntlProvider);
	
	    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));
	
	    invariant(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');
	
	    var intlContext = context.intl;
	
	    // Used to stabilize time when performing an initial rendering so that
	    // all relative times use the same reference "now" time.
	
	    var initialNow = void 0;
	    if (isFinite(props.initialNow)) {
	      initialNow = Number(props.initialNow);
	    } else {
	      // When an `initialNow` isn't provided via `props`, look to see an
	      // <IntlProvider> exists in the ancestry and call its `now()`
	      // function to propagate its value for "now".
	      initialNow = intlContext ? intlContext.now() : Date.now();
	    }
	
	    // Creating `Intl*` formatters is expensive. If there's a parent
	    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
	    // memoize the `Intl*` constructors and cache them for the lifecycle of
	    // this IntlProvider instance.
	
	    var _ref = intlContext || {},
	        _ref$formatters = _ref.formatters,
	        formatters = _ref$formatters === undefined ? {
	      getDateTimeFormat: memoizeIntlConstructor(Intl.DateTimeFormat),
	      getNumberFormat: memoizeIntlConstructor(Intl.NumberFormat),
	      getMessageFormat: memoizeIntlConstructor(IntlMessageFormat),
	      getRelativeFormat: memoizeIntlConstructor(IntlRelativeFormat),
	      getPluralFormat: memoizeIntlConstructor(IntlPluralFormat)
	    } : _ref$formatters;
	
	    _this.state = _extends({}, formatters, {
	
	      // Wrapper to provide stable "now" time for initial render.
	      now: function now() {
	        return _this._didDisplay ? Date.now() : initialNow;
	      }
	    });
	    return _this;
	  }
	
	  createClass(IntlProvider, [{
	    key: 'getConfig',
	    value: function getConfig() {
	      var intlContext = this.context.intl;
	
	      // Build a whitelisted config object from `props`, defaults, and
	      // `context.intl`, if an <IntlProvider> exists in the ancestry.
	
	      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);
	
	      // Apply default props. This must be applied last after the props have
	      // been resolved and inherited from any <IntlProvider> in the ancestry.
	      // This matches how React resolves `defaultProps`.
	      for (var propName in defaultProps) {
	        if (config[propName] === undefined) {
	          config[propName] = defaultProps[propName];
	        }
	      }
	
	      if (!hasLocaleData(config.locale)) {
	        var _config = config,
	            locale = _config.locale,
	            defaultLocale = _config.defaultLocale,
	            defaultFormats = _config.defaultFormats,
	            onError = _config.onError;
	
	
	        onError(createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));
	
	        // Since there's no registered locale data for `locale`, this will
	        // fallback to the `defaultLocale` to make sure things can render.
	        // The `messages` are overridden to the `defaultProps` empty object
	        // to maintain referential equality across re-renders. It's assumed
	        // each <FormattedMessage> contains a `defaultMessage` prop.
	        config = _extends({}, config, {
	          locale: defaultLocale,
	          formats: defaultFormats,
	          messages: defaultProps.messages
	        });
	      }
	
	      return config;
	    }
	  }, {
	    key: 'getBoundFormatFns',
	    value: function getBoundFormatFns(config, state) {
	      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
	        boundFormatFns[name] = format[name].bind(null, config, state);
	        return boundFormatFns;
	      }, {});
	    }
	  }, {
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var config = this.getConfig();
	
	      // Bind intl factories and current config to the format functions.
	      var boundFormatFns = this.getBoundFormatFns(config, this.state);
	
	      var _state = this.state,
	          now = _state.now,
	          formatters = objectWithoutProperties(_state, ['now']);
	
	
	      return {
	        intl: _extends({}, config, boundFormatFns, {
	          formatters: formatters,
	          now: now
	        })
	      };
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._didDisplay = true;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return React.Children.only(this.props.children);
	    }
	  }]);
	  return IntlProvider;
	}(React.Component);
	
	IntlProvider.displayName = 'IntlProvider';
	IntlProvider.contextTypes = {
	  intl: intlShape
	};
	IntlProvider.childContextTypes = {
	  intl: intlShape.isRequired
	};
	 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
	  children: PropTypes.element.isRequired,
	  initialNow: PropTypes.any
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedDate = function (_Component) {
	  inherits(FormattedDate, _Component);
	
	  function FormattedDate(props, context) {
	    classCallCheck(this, FormattedDate);
	
	    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedDate, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatDate = _context$intl.formatDate,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedDate = formatDate(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedDate);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedDate
	      );
	    }
	  }]);
	  return FormattedDate;
	}(React.Component);
	
	FormattedDate.displayName = 'FormattedDate';
	FormattedDate.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedTime = function (_Component) {
	  inherits(FormattedTime, _Component);
	
	  function FormattedTime(props, context) {
	    classCallCheck(this, FormattedTime);
	
	    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedTime, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatTime = _context$intl.formatTime,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedTime = formatTime(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedTime);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedTime
	      );
	    }
	  }]);
	  return FormattedTime;
	}(React.Component);
	
	FormattedTime.displayName = 'FormattedTime';
	FormattedTime.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var SECOND = 1000;
	var MINUTE = 1000 * 60;
	var HOUR = 1000 * 60 * 60;
	var DAY = 1000 * 60 * 60 * 24;
	
	// The maximum timer delay value is a 32-bit signed integer.
	// See: https://mdn.io/setTimeout
	var MAX_TIMER_DELAY = 2147483647;
	
	function selectUnits(delta) {
	  var absDelta = Math.abs(delta);
	
	  if (absDelta < MINUTE) {
	    return 'second';
	  }
	
	  if (absDelta < HOUR) {
	    return 'minute';
	  }
	
	  if (absDelta < DAY) {
	    return 'hour';
	  }
	
	  // The maximum scheduled delay will be measured in days since the maximum
	  // timer delay is less than the number of milliseconds in 25 days.
	  return 'day';
	}
	
	function getUnitDelay(units) {
	  switch (units) {
	    case 'second':
	      return SECOND;
	    case 'minute':
	      return MINUTE;
	    case 'hour':
	      return HOUR;
	    case 'day':
	      return DAY;
	    default:
	      return MAX_TIMER_DELAY;
	  }
	}
	
	function isSameDate(a, b) {
	  if (a === b) {
	    return true;
	  }
	
	  var aTime = new Date(a).getTime();
	  var bTime = new Date(b).getTime();
	
	  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
	}
	
	var FormattedRelative = function (_Component) {
	  inherits(FormattedRelative, _Component);
	
	  function FormattedRelative(props, context) {
	    classCallCheck(this, FormattedRelative);
	
	    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));
	
	    invariantIntlContext(context);
	
	    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();
	
	    // `now` is stored as state so that `render()` remains a function of
	    // props + state, instead of accessing `Date.now()` inside `render()`.
	    _this.state = { now: now };
	    return _this;
	  }
	
	  createClass(FormattedRelative, [{
	    key: 'scheduleNextUpdate',
	    value: function scheduleNextUpdate(props, state) {
	      var _this2 = this;
	
	      // Cancel and pending update because we're scheduling a new update.
	      clearTimeout(this._timer);
	
	      var value = props.value,
	          units = props.units,
	          updateInterval = props.updateInterval;
	
	      var time = new Date(value).getTime();
	
	      // If the `updateInterval` is falsy, including `0` or we don't have a
	      // valid date, then auto updates have been turned off, so we bail and
	      // skip scheduling an update.
	      if (!updateInterval || !isFinite(time)) {
	        return;
	      }
	
	      var delta = time - state.now;
	      var unitDelay = getUnitDelay(units || selectUnits(delta));
	      var unitRemainder = Math.abs(delta % unitDelay);
	
	      // We want the largest possible timer delay which will still display
	      // accurate information while reducing unnecessary re-renders. The delay
	      // should be until the next "interesting" moment, like a tick from
	      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
	      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);
	
	      this._timer = setTimeout(function () {
	        _this2.setState({ now: _this2.context.intl.now() });
	      }, delay);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scheduleNextUpdate(this.props, this.state);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref) {
	      var nextValue = _ref.value;
	
	      // When the `props.value` date changes, `state.now` needs to be updated,
	      // and the next update can be rescheduled.
	      if (!isSameDate(nextValue, this.props.value)) {
	        this.setState({ now: this.context.intl.now() });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      this.scheduleNextUpdate(nextProps, nextState);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._timer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatRelative = _context$intl.formatRelative,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));
	
	      if (typeof children === 'function') {
	        return children(formattedRelative);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedRelative
	      );
	    }
	  }]);
	  return FormattedRelative;
	}(React.Component);
	
	FormattedRelative.displayName = 'FormattedRelative';
	FormattedRelative.contextTypes = {
	  intl: intlShape
	};
	FormattedRelative.defaultProps = {
	  updateInterval: 1000 * 10
	};
	 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  updateInterval: PropTypes.number,
	  initialNow: PropTypes.any,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedNumber = function (_Component) {
	  inherits(FormattedNumber, _Component);
	
	  function FormattedNumber(props, context) {
	    classCallCheck(this, FormattedNumber);
	
	    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedNumber, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatNumber = _context$intl.formatNumber,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedNumber = formatNumber(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedNumber);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedNumber
	      );
	    }
	  }]);
	  return FormattedNumber;
	}(React.Component);
	
	FormattedNumber.displayName = 'FormattedNumber';
	FormattedNumber.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedPlural = function (_Component) {
	  inherits(FormattedPlural, _Component);
	
	  function FormattedPlural(props, context) {
	    classCallCheck(this, FormattedPlural);
	
	    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedPlural, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatPlural = _context$intl.formatPlural,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          other = _props.other,
	          children = _props.children;
	
	
	      var pluralCategory = formatPlural(value, this.props);
	      var formattedPlural = this.props[pluralCategory] || other;
	
	      if (typeof children === 'function') {
	        return children(formattedPlural);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedPlural
	      );
	    }
	  }]);
	  return FormattedPlural;
	}(React.Component);
	
	FormattedPlural.displayName = 'FormattedPlural';
	FormattedPlural.contextTypes = {
	  intl: intlShape
	};
	FormattedPlural.defaultProps = {
	  style: 'cardinal'
	};
	 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	
	  other: PropTypes.node.isRequired,
	  zero: PropTypes.node,
	  one: PropTypes.node,
	  two: PropTypes.node,
	  few: PropTypes.node,
	  many: PropTypes.node,
	
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
	  if (false) {
	    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
	  }
	  return formatMessage({}, { getMessageFormat: memoizeIntlConstructor(IntlMessageFormat) }, descriptor, values);
	};
	
	var FormattedMessage = function (_Component) {
	  inherits(FormattedMessage, _Component);
	
	  function FormattedMessage(props, context) {
	    classCallCheck(this, FormattedMessage);
	
	    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));
	
	    if (!props.defaultMessage) {
	      invariantIntlContext(context);
	    }
	    return _this;
	  }
	
	  createClass(FormattedMessage, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var values = this.props.values;
	      var nextValues = nextProps.values;
	
	
	      if (!shallowEquals(nextValues, values)) {
	        return true;
	      }
	
	      // Since `values` has already been checked, we know they're not
	      // different, so the current `values` are carried over so the shallow
	      // equals comparison on the other props isn't affected by the `values`.
	      var nextPropsToCheck = _extends({}, nextProps, {
	        values: values
	      });
	
	      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        next[_key - 1] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _ref = this.context.intl || {},
	          _ref$formatMessage = _ref.formatMessage,
	          formatMessage$$1 = _ref$formatMessage === undefined ? defaultFormatMessage : _ref$formatMessage,
	          _ref$textComponent = _ref.textComponent,
	          Text = _ref$textComponent === undefined ? 'span' : _ref$textComponent;
	
	      var _props = this.props,
	          id = _props.id,
	          description = _props.description,
	          defaultMessage = _props.defaultMessage,
	          values = _props.values,
	          _props$tagName = _props.tagName,
	          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
	          children = _props.children;
	
	
	      var tokenDelimiter = void 0;
	      var tokenizedValues = void 0;
	      var elements = void 0;
	
	      var hasValues = values && Object.keys(values).length > 0;
	      if (hasValues) {
	        // Creates a token with a random UID that should not be guessable or
	        // conflict with other parts of the `message` string.
	        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);
	
	        var generateToken = function () {
	          var counter = 0;
	          return function () {
	            return 'ELEMENT-' + uid + '-' + (counter += 1);
	          };
	        }();
	
	        // Splitting with a delimiter to support IE8. When using a regex
	        // with a capture group IE8 does not include the capture group in
	        // the resulting array.
	        tokenDelimiter = '@__' + uid + '__@';
	        tokenizedValues = {};
	        elements = {};
	
	        // Iterates over the `props` to keep track of any React Element
	        // values so they can be represented by the `token` as a placeholder
	        // when the `message` is formatted. This allows the formatted
	        // message to then be broken-up into parts with references to the
	        // React Elements inserted back in.
	        Object.keys(values).forEach(function (name) {
	          var value = values[name];
	
	          if (React.isValidElement(value)) {
	            var token = generateToken();
	            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
	            elements[token] = value;
	          } else {
	            tokenizedValues[name] = value;
	          }
	        });
	      }
	
	      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	      var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);
	
	      var nodes = void 0;
	
	      var hasElements = elements && Object.keys(elements).length > 0;
	      if (hasElements) {
	        // Split the message into parts so the React Element values captured
	        // above can be inserted back into the rendered message. This
	        // approach allows messages to render with React Elements while
	        // keeping React's virtual diffing working properly.
	        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
	          return !!part;
	        }).map(function (part) {
	          return elements[part] || part;
	        });
	      } else {
	        nodes = [formattedMessage];
	      }
	
	      if (typeof children === 'function') {
	        return children.apply(undefined, toConsumableArray(nodes));
	      }
	
	      // Needs to use `createElement()` instead of JSX, otherwise React will
	      // warn about a missing `key` prop with rich-text message formatting.
	      return React.createElement.apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
	    }
	  }]);
	  return FormattedMessage;
	}(React.Component);
	
	FormattedMessage.displayName = 'FormattedMessage';
	FormattedMessage.contextTypes = {
	  intl: intlShape
	};
	FormattedMessage.defaultProps = {
	  values: {}
	};
	 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
	  values: PropTypes.object,
	  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedHTMLMessage = function (_Component) {
	  inherits(FormattedHTMLMessage, _Component);
	
	  function FormattedHTMLMessage(props, context) {
	    classCallCheck(this, FormattedHTMLMessage);
	
	    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedHTMLMessage, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var values = this.props.values;
	      var nextValues = nextProps.values;
	
	
	      if (!shallowEquals(nextValues, values)) {
	        return true;
	      }
	
	      // Since `values` has already been checked, we know they're not
	      // different, so the current `values` are carried over so the shallow
	      // equals comparison on the other props isn't affected by the `values`.
	      var nextPropsToCheck = _extends({}, nextProps, {
	        values: values
	      });
	
	      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        next[_key - 1] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatHTMLMessage = _context$intl.formatHTMLMessage,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          id = _props.id,
	          description = _props.description,
	          defaultMessage = _props.defaultMessage,
	          rawValues = _props.values,
	          _props$tagName = _props.tagName,
	          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
	          children = _props.children;
	
	
	      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);
	
	      if (typeof children === 'function') {
	        return children(formattedHTMLMessage);
	      }
	
	      // Since the message presumably has HTML in it, we need to set
	      // `innerHTML` in order for it to be rendered and not escaped by React.
	      // To be safe, all string prop values were escaped when formatting the
	      // message. It is assumed that the message is not UGC, and came from the
	      // developer making it more like a template.
	      //
	      // Note: There's a perf impact of using this component since there's no
	      // way for React to do its virtual DOM diffing.
	      var html = { __html: formattedHTMLMessage };
	      return React__default.createElement(Component$$1, { dangerouslySetInnerHTML: html });
	    }
	  }]);
	  return FormattedHTMLMessage;
	}(React.Component);
	
	FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
	FormattedHTMLMessage.contextTypes = {
	  intl: intlShape
	};
	FormattedHTMLMessage.defaultProps = {
	  values: {}
	};
	 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
	  values: PropTypes.object,
	  tagName: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(defaultLocaleData);
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(allLocaleData);
	
	exports.addLocaleData = addLocaleData;
	exports.intlShape = intlShape;
	exports.injectIntl = injectIntl;
	exports.defineMessages = defineMessages;
	exports.IntlProvider = IntlProvider;
	exports.FormattedDate = FormattedDate;
	exports.FormattedTime = FormattedTime;
	exports.FormattedRelative = FormattedRelative;
	exports.FormattedNumber = FormattedNumber;
	exports.FormattedPlural = FormattedPlural;
	exports.FormattedMessage = FormattedMessage;
	exports.FormattedHTMLMessage = FormattedHTMLMessage;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(301);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  if (propType !== 'function' && propType !== 'string') {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ },
/* 28 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// Expects flags from URL in the format ?tfjsflags=FLAG1:1,FLAG2:true.
	var TENSORFLOWJS_FLAGS_PREFIX = 'tfjsflags';
	/**
	 * The environment contains evaluated flags as well as the registered platform.
	 * This is always used as a global singleton and can be retrieved with
	 * `tf.env()`.
	 */
	/** @doc {heading: 'Environment'} */
	var Environment = /** @class */ (function () {
	    // tslint:disable-next-line: no-any
	    function Environment(global) {
	        this.global = global;
	        this.flags = {};
	        this.flagRegistry = {};
	        this.urlFlags = {};
	        this.populateURLFlags();
	    }
	    Environment.prototype.setPlatform = function (platformName, platform) {
	        if (this.platform != null) {
	            console.warn("Platform " + this.platformName + " has already been set. " +
	                ("Overwriting the platform with " + platform + "."));
	        }
	        this.platformName = platformName;
	        this.platform = platform;
	    };
	    Environment.prototype.registerFlag = function (flagName, evaluationFn, setHook) {
	        this.flagRegistry[flagName] = { evaluationFn: evaluationFn, setHook: setHook };
	        // Override the flag value from the URL. This has to happen here because the
	        // environment is initialized before flags get registered.
	        if (this.urlFlags[flagName] != null) {
	            var flagValue = this.urlFlags[flagName];
	            console.warn("Setting feature override from URL " + flagName + ": " + flagValue + ".");
	            this.set(flagName, flagValue);
	        }
	    };
	    Environment.prototype.get = function (flagName) {
	        if (flagName in this.flags) {
	            return this.flags[flagName];
	        }
	        this.flags[flagName] = this.evaluateFlag(flagName);
	        return this.flags[flagName];
	    };
	    Environment.prototype.getNumber = function (flagName) {
	        return this.get(flagName);
	    };
	    Environment.prototype.getBool = function (flagName) {
	        return this.get(flagName);
	    };
	    Environment.prototype.getFlags = function () {
	        return this.flags;
	    };
	    Object.defineProperty(Environment.prototype, "features", {
	        // For backwards compatibility.
	        get: function () {
	            return this.flags;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Environment.prototype.set = function (flagName, value) {
	        if (this.flagRegistry[flagName] == null) {
	            throw new Error("Cannot set flag " + flagName + " as it has not been registered.");
	        }
	        this.flags[flagName] = value;
	        if (this.flagRegistry[flagName].setHook != null) {
	            this.flagRegistry[flagName].setHook(value);
	        }
	    };
	    Environment.prototype.evaluateFlag = function (flagName) {
	        if (this.flagRegistry[flagName] == null) {
	            throw new Error("Cannot evaluate flag '" + flagName + "': no evaluation function found.");
	        }
	        return this.flagRegistry[flagName].evaluationFn();
	    };
	    Environment.prototype.setFlags = function (flags) {
	        this.flags = Object.assign({}, flags);
	    };
	    Environment.prototype.reset = function () {
	        this.flags = {};
	        this.urlFlags = {};
	        this.populateURLFlags();
	    };
	    Environment.prototype.populateURLFlags = function () {
	        var _this = this;
	        if (typeof this.global === 'undefined' ||
	            typeof this.global.location === 'undefined' ||
	            typeof this.global.location.search === 'undefined') {
	            return;
	        }
	        var urlParams = getQueryParams(this.global.location.search);
	        if (TENSORFLOWJS_FLAGS_PREFIX in urlParams) {
	            var keyValues = urlParams[TENSORFLOWJS_FLAGS_PREFIX].split(',');
	            keyValues.forEach(function (keyValue) {
	                var _a = keyValue.split(':'), key = _a[0], value = _a[1];
	                _this.urlFlags[key] = parseValue(key, value);
	            });
	        }
	    };
	    return Environment;
	}());
	exports.Environment = Environment;
	function getQueryParams(queryString) {
	    var params = {};
	    queryString.replace(/[?&]([^=?&]+)(?:=([^&]*))?/g, function (s) {
	        var t = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            t[_i - 1] = arguments[_i];
	        }
	        decodeParam(params, t[0], t[1]);
	        return t.join('=');
	    });
	    return params;
	}
	exports.getQueryParams = getQueryParams;
	function decodeParam(params, name, value) {
	    params[decodeURIComponent(name)] = decodeURIComponent(value || '');
	}
	function parseValue(flagName, value) {
	    value = value.toLowerCase();
	    if (value === 'true' || value === 'false') {
	        return value === 'true';
	    }
	    else if ("" + +value === value) {
	        return +value;
	    }
	    throw new Error("Could not parse value flag value " + value + " for flag " + flagName + ".");
	}
	/**
	 * Returns the current environment (a global singleton).
	 *
	 * The environment object contains the evaluated feature values as well as the
	 * active platform.
	 */
	/** @doc {heading: 'Environment'} */
	function env() {
	    return exports.ENV;
	}
	exports.env = env;
	exports.ENV = null;
	function setEnvironmentGlobal(environment) {
	    exports.ENV = environment;
	}
	exports.setEnvironmentGlobal = setEnvironmentGlobal;
	//# sourceMappingURL=environment.js.map

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1429);
	
	function CustomSpinner(props) {
	    return _react2.default.createElement(
	        "div",
	        { className: "custom-spinner-backdrop" },
	        _react2.default.createElement(
	            "div",
	            { className: "custom-spinner-containter" },
	            _react2.default.createElement(
	                "div",
	                { className: "custom-spinner-content text-center" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "square" },
	                    _react2.default.createElement("div", { className: "arrow-up" })
	                ),
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    props.message
	                )
	            )
	        )
	    );
	};
	exports.default = CustomSpinner;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Section(props) {
	    var className = props.className;
	
	    return _react2.default.createElement(
	        "section",
	        { className: className },
	        _react2.default.createElement(
	            "div",
	            { className: "pd-main container relative" },
	            props.children
	        )
	    );
	};
	exports.default = Section;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var environment_1 = __webpack_require__(28);
	var tensor_util_env_1 = __webpack_require__(17);
	var util_1 = __webpack_require__(10);
	var complex_ops_1 = __webpack_require__(191);
	var operation_1 = __webpack_require__(18);
	/**
	 * Creates a `tf.Tensor` with the provided values, shape and dtype.
	 *
	 * ```js
	 * // Pass an array of values to create a vector.
	 * tf.tensor([1, 2, 3, 4]).print();
	 * ```
	 *
	 * ```js
	 * // Pass a nested array of values to make a matrix or a higher
	 * // dimensional tensor.
	 * tf.tensor([[1, 2], [3, 4]]).print();
	 * ```
	 *
	 * ```js
	 * // Pass a flat array and specify a shape yourself.
	 * tf.tensor([1, 2, 3, 4], [2, 2]).print();
	 * ```
	 *
	 * @param values The values of the tensor. Can be nested array of numbers,
	 *     or a flat array, or a `TypedArray`. If the values are strings,
	 *     they will be encoded as utf-8 and kept as `Uint8Array[]`.
	 * @param shape The shape of the tensor. Optional. If not provided,
	 *   it is inferred from `values`.
	 * @param dtype The data type.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function tensor(values, shape, dtype) {
	    var inferredShape = tensor_util_env_1.inferShape(values, dtype);
	    return makeTensor(values, shape, inferredShape, dtype);
	}
	exports.tensor = tensor;
	/** This is shared code across all tensor creation methods. */
	function makeTensor(values, shape, inferredShape, dtype) {
	    if (dtype == null) {
	        dtype = util_1.inferDtype(values);
	    }
	    if (dtype === 'complex64') {
	        throw new Error("Cannot construct a complex64 tensor directly. " +
	            "Please use tf.complex(real, imag).");
	    }
	    if (!util_1.isTypedArray(values) && !Array.isArray(values) &&
	        typeof values !== 'number' && typeof values !== 'boolean' &&
	        typeof values !== 'string') {
	        throw new Error('values passed to tensor(values) must be a number/boolean/string or ' +
	            'an array of numbers/booleans/strings, or a TypedArray');
	    }
	    if (shape != null) {
	        util_1.assertNonNegativeIntegerDimensions(shape);
	        var providedSize_1 = util_1.sizeFromShape(shape);
	        var inferredSize_1 = util_1.sizeFromShape(inferredShape);
	        util_1.assert(providedSize_1 === inferredSize_1, function () {
	            return "Based on the provided shape, [" + shape + "], the tensor should have " +
	                (providedSize_1 + " values but has " + inferredSize_1);
	        });
	        for (var i = 0; i < inferredShape.length; ++i) {
	            var inferred = inferredShape[i];
	            var flatDimsDontMatch = i === inferredShape.length - 1 ?
	                inferred !== util_1.sizeFromShape(shape.slice(i)) :
	                true;
	            util_1.assert(inferredShape[i] === shape[i] || !flatDimsDontMatch, function () { return "Error creating a new Tensor. Inferred shape " +
	                ("(" + inferredShape + ") does not match the provided ") +
	                ("shape (" + shape + "). "); });
	        }
	    }
	    if (!util_1.isTypedArray(values) && !Array.isArray(values)) {
	        values = [values];
	    }
	    shape = shape || inferredShape;
	    values = dtype !== 'string' ?
	        util_1.toTypedArray(values, dtype, environment_1.env().getBool('DEBUG')) :
	        util_1.flatten(values, [], true);
	    return engine_1.ENGINE.makeTensor(values, shape, dtype);
	}
	/**
	 * Creates rank-0 `tf.Tensor` (scalar) with the provided value and dtype.
	 *
	 * The same functionality can be achieved with `tf.tensor`, but in general
	 * we recommend using `tf.scalar` as it makes the code more readable.
	 *
	 * ```js
	 * tf.scalar(3.14).print();
	 * ```
	 *
	 * @param value The value of the scalar.
	 * @param dtype The data type.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function scalar(value, dtype) {
	    if (((util_1.isTypedArray(value) && dtype !== 'string') || Array.isArray(value)) &&
	        dtype !== 'complex64') {
	        throw new Error('Error creating a new Scalar: value must be a primitive ' +
	            '(number|boolean|string)');
	    }
	    if (dtype === 'string' && util_1.isTypedArray(value) &&
	        !(value instanceof Uint8Array)) {
	        throw new Error('When making a scalar from encoded string, ' +
	            'the value must be `Uint8Array`.');
	    }
	    var shape = [];
	    var inferredShape = [];
	    return makeTensor(value, shape, inferredShape, dtype);
	}
	exports.scalar = scalar;
	/**
	 * Creates rank-1 `tf.Tensor` with the provided values, shape and dtype.
	 *
	 * The same functionality can be achieved with `tf.tensor`, but in general
	 * we recommend using `tf.tensor1d` as it makes the code more readable.
	 *
	 * ```js
	 * tf.tensor1d([1, 2, 3]).print();
	 * ```
	 *
	 * @param values The values of the tensor. Can be array of numbers,
	 *     or a `TypedArray`.
	 * @param dtype The data type.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function tensor1d(values, dtype) {
	    util_1.assertNonNull(values);
	    var inferredShape = tensor_util_env_1.inferShape(values, dtype);
	    if (inferredShape.length !== 1) {
	        throw new Error('tensor1d() requires values to be a flat/TypedArray');
	    }
	    var shape = null;
	    return makeTensor(values, shape, inferredShape, dtype);
	}
	exports.tensor1d = tensor1d;
	/**
	 * Creates rank-2 `tf.Tensor` with the provided values, shape and dtype.
	 *
	 * The same functionality can be achieved with `tf.tensor`, but in general
	 * we recommend using `tf.tensor2d` as it makes the code more readable.
	 *
	 *  ```js
	 * // Pass a nested array.
	 * tf.tensor2d([[1, 2], [3, 4]]).print();
	 * ```
	 * ```js
	 * // Pass a flat array and specify a shape.
	 * tf.tensor2d([1, 2, 3, 4], [2, 2]).print();
	 * ```
	 *
	 * @param values The values of the tensor. Can be nested array of numbers,
	 *     or a flat array, or a `TypedArray`.
	 * @param shape The shape of the tensor. If not provided, it is inferred from
	 *     `values`.
	 * @param dtype The data type.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function tensor2d(values, shape, dtype) {
	    util_1.assertNonNull(values);
	    if (shape != null && shape.length !== 2) {
	        throw new Error('tensor2d() requires shape to have two numbers');
	    }
	    var inferredShape = tensor_util_env_1.inferShape(values, dtype);
	    if (inferredShape.length !== 2 && inferredShape.length !== 1) {
	        throw new Error('tensor2d() requires values to be number[][] or flat/TypedArray');
	    }
	    if (inferredShape.length === 1 && shape == null) {
	        throw new Error('tensor2d() requires shape to be provided when `values` ' +
	            'are a flat/TypedArray');
	    }
	    return makeTensor(values, shape, inferredShape, dtype);
	}
	exports.tensor2d = tensor2d;
	/**
	 * Creates rank-3 `tf.Tensor` with the provided values, shape and dtype.
	 *
	 * The same functionality can be achieved with `tf.tensor`, but in general
	 * we recommend using `tf.tensor3d` as it makes the code more readable.
	 *
	 *  ```js
	 * // Pass a nested array.
	 * tf.tensor3d([[[1], [2]], [[3], [4]]]).print();
	 * ```
	 * ```js
	 * // Pass a flat array and specify a shape.
	 * tf.tensor3d([1, 2, 3, 4], [2, 2, 1]).print();
	 * ```
	 *
	 * @param values The values of the tensor. Can be nested array of numbers,
	 *     or a flat array, or a `TypedArray`.
	 * @param shape The shape of the tensor. If not provided,  it is inferred from
	 *     `values`.
	 * @param dtype The data type.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function tensor3d(values, shape, dtype) {
	    util_1.assertNonNull(values);
	    if (shape != null && shape.length !== 3) {
	        throw new Error('tensor3d() requires shape to have three numbers');
	    }
	    var inferredShape = tensor_util_env_1.inferShape(values, dtype);
	    if (inferredShape.length !== 3 && inferredShape.length !== 1) {
	        throw new Error('tensor3d() requires values to be number[][][] or flat/TypedArray');
	    }
	    if (inferredShape.length === 1 && shape == null) {
	        throw new Error('tensor3d() requires shape to be provided when `values` ' +
	            'are a flat array');
	    }
	    return makeTensor(values, shape, inferredShape, dtype);
	}
	exports.tensor3d = tensor3d;
	/**
	 * Creates rank-4 `tf.Tensor` with the provided values, shape and dtype.
	 *
	 * The same functionality can be achieved with `tf.tensor`, but in general
	 * we recommend using `tf.tensor4d` as it makes the code more readable.
	 *
	 *  ```js
	 * // Pass a nested array.
	 * tf.tensor4d([[[[1], [2]], [[3], [4]]]]).print();
	 * ```
	 * ```js
	 * // Pass a flat array and specify a shape.
	 * tf.tensor4d([1, 2, 3, 4], [1, 2, 2, 1]).print();
	 * ```
	 *
	 * @param values The values of the tensor. Can be nested array of numbers,
	 *     or a flat array, or a `TypedArray`.
	 * @param shape The shape of the tensor. Optional. If not provided,
	 *   it is inferred from `values`.
	 * @param dtype The data type.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function tensor4d(values, shape, dtype) {
	    util_1.assertNonNull(values);
	    if (shape != null && shape.length !== 4) {
	        throw new Error('tensor4d() requires shape to have four numbers');
	    }
	    var inferredShape = tensor_util_env_1.inferShape(values, dtype);
	    if (inferredShape.length !== 4 && inferredShape.length !== 1) {
	        throw new Error('tensor4d() requires values to be number[][][][] or flat/TypedArray');
	    }
	    if (inferredShape.length === 1 && shape == null) {
	        throw new Error('tensor4d() requires shape to be provided when `values` ' +
	            'are a flat array');
	    }
	    return makeTensor(values, shape, inferredShape, dtype);
	}
	exports.tensor4d = tensor4d;
	/**
	 * Creates rank-5 `tf.Tensor` with the provided values, shape and dtype.
	 *
	 * The same functionality can be achieved with `tf.tensor`, but in general
	 * we recommend using `tf.tensor5d` as it makes the code more readable.
	 *
	 *  ```js
	 * // Pass a nested array.
	 * tf.tensor5d([[[[[1], [2]], [[3], [4]]]]]).print();
	 * ```
	 * ```js
	 * // Pass a flat array and specify a shape.
	 * tf.tensor5d([1, 2, 3, 4, 5, 6, 7, 8], [1, 2, 2, 2, 1]).print();
	 * ```
	 *
	 * @param values The values of the tensor. Can be nested array of numbers,
	 *     or a flat array, or a `TypedArray`.
	 * @param shape The shape of the tensor. Optional. If not provided,
	 *   it is inferred from `values`.
	 * @param dtype The data type.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function tensor5d(values, shape, dtype) {
	    util_1.assertNonNull(values);
	    if (shape != null && shape.length !== 5) {
	        throw new Error('tensor5d() requires shape to have five numbers');
	    }
	    var inferredShape = tensor_util_env_1.inferShape(values, dtype);
	    if (inferredShape.length !== 5 && inferredShape.length !== 1) {
	        throw new Error('tensor5d() requires values to be ' +
	            'number[][][][][] or flat/TypedArray');
	    }
	    if (inferredShape.length === 1 && shape == null) {
	        throw new Error('tensor5d() requires shape to be provided when `values` ' +
	            'are a flat array');
	    }
	    return makeTensor(values, shape, inferredShape, dtype);
	}
	exports.tensor5d = tensor5d;
	/**
	 * Creates rank-6 `tf.Tensor` with the provided values, shape and dtype.
	 *
	 * The same functionality can be achieved with `tf.tensor`, but in general
	 * we recommend using `tf.tensor6d` as it makes the code more readable.
	 *
	 *  ```js
	 * // Pass a nested array.
	 * tf.tensor6d([[[[[[1],[2]],[[3],[4]]],[[[5],[6]],[[7],[8]]]]]]).print();
	 * ```
	 * ```js
	 * // Pass a flat array and specify a shape.
	 * tf.tensor6d([1, 2, 3, 4, 5, 6, 7, 8], [1, 1, 2, 2, 2, 1]).print();
	 * ```
	 *
	 * @param values The values of the tensor. Can be nested array of numbers,
	 *     or a flat array, or a `TypedArray`.
	 * @param shape The shape of the tensor. Optional. If not provided,
	 *   it is inferred from `values`.
	 * @param dtype The data type.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function tensor6d(values, shape, dtype) {
	    util_1.assertNonNull(values);
	    if (shape != null && shape.length !== 6) {
	        throw new Error('tensor6d() requires shape to have six numbers');
	    }
	    var inferredShape = tensor_util_env_1.inferShape(values, dtype);
	    if (inferredShape.length !== 6 && inferredShape.length !== 1) {
	        throw new Error('tensor6d() requires values to be number[][][][][][] or ' +
	            'flat/TypedArray');
	    }
	    if (inferredShape.length === 1 && shape == null) {
	        throw new Error('tensor6d() requires shape to be provided when `values` ' +
	            'are a flat array');
	    }
	    shape = shape ||
	        inferredShape;
	    return makeTensor(values, shape, inferredShape, dtype);
	}
	exports.tensor6d = tensor6d;
	/**
	 * Creates a new variable with the provided initial value.
	 * ```js
	 * const x = tf.variable(tf.tensor([1, 2, 3]));
	 * x.assign(tf.tensor([4, 5, 6]));
	 *
	 * x.print();
	 * ```
	 *
	 * @param initialValue Initial value for the tensor.
	 * @param trainable If true, optimizers are allowed to update it.
	 * @param name Name of the variable. Defaults to a unique id.
	 * @param dtype If set, initialValue will be converted to the given type.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function variable(initialValue, trainable, name, dtype) {
	    if (trainable === void 0) { trainable = true; }
	    return engine_1.ENGINE.makeVariable(initialValue, trainable, name, dtype);
	}
	exports.variable = variable;
	/**
	 * Creates a `tf.Tensor` with all elements set to 1.
	 *
	 * ```js
	 * tf.ones([2, 2]).print();
	 * ```
	 *
	 * @param shape An array of integers defining the output tensor shape.
	 * @param dtype The type of an element in the resulting tensor. Defaults to
	 *     'float'.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function ones(shape, dtype) {
	    if (dtype === void 0) { dtype = 'float32'; }
	    if (dtype === 'complex64') {
	        var real_1 = ones(shape, 'float32');
	        var imag_1 = zeros(shape, 'float32');
	        return complex_ops_1.complex(real_1, imag_1);
	    }
	    var values = util_1.makeOnesTypedArray(util_1.sizeFromShape(shape), dtype);
	    return engine_1.ENGINE.makeTensor(values, shape, dtype);
	}
	exports.ones = ones;
	/**
	 * Creates a `tf.Tensor` with all elements set to 0.
	 *
	 * ```js
	 * tf.zeros([2, 2]).print();
	 * ```
	 *
	 * @param shape An array of integers defining the output tensor shape.
	 * @param dtype The type of an element in the resulting tensor. Can
	 *     be 'float32', 'int32' or 'bool'. Defaults to 'float'.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function zeros(shape, dtype) {
	    if (dtype === void 0) { dtype = 'float32'; }
	    if (dtype === 'complex64') {
	        var real_2 = zeros(shape, 'float32');
	        var imag_2 = zeros(shape, 'float32');
	        return complex_ops_1.complex(real_2, imag_2);
	    }
	    var values = util_1.makeZerosTypedArray(util_1.sizeFromShape(shape), dtype);
	    return engine_1.ENGINE.makeTensor(values, shape, dtype);
	}
	exports.zeros = zeros;
	/**
	 * Creates a `tf.Tensor` filled with a scalar value.
	 *
	 * ```js
	 * tf.fill([2, 2], 4).print();
	 * ```
	 *
	 * @param shape An array of integers defining the output tensor shape.
	 * @param value The scalar value to fill the tensor with.
	 * @param dtype The type of an element in the resulting tensor. Defaults to
	 * 'float'.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function fill(shape, value, dtype) {
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.fill(shape, value, dtype); }, {});
	}
	exports.fill = fill;
	/**
	 * Creates a `tf.Tensor` with all elements set to 1 with the same shape as the
	 * given tensor.
	 *
	 * ```js
	 * const x = tf.tensor([1, 2]);
	 * tf.onesLike(x).print();
	 * ```
	 * @param x A tensor.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function onesLike_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'onesLike');
	    if ($x.dtype === 'complex64') {
	        var r = exports.onesLike(complex_ops_1.real($x));
	        var i = exports.zerosLike(complex_ops_1.imag($x));
	        return complex_ops_1.complex(r, i);
	    }
	    var der = function (dy, saved) { return ({ $x: function () { return exports.zerosLike(dy); } }); };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.onesLike($x); }, { $x: $x }, der);
	}
	/**
	 * Creates a `tf.Tensor` with all elements set to 0 with the same shape as the
	 * given tensor.
	 *
	 * ```js
	 * const x = tf.tensor([1, 2]);
	 * tf.zerosLike(x).print();
	 * ```
	 *
	 * @param x The tensor of required shape.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function zerosLike_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'zerosLike');
	    var der = function (dy, saved) { return ({ $x: function () { return exports.zerosLike(dy); } }); };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.zerosLike($x); }, { $x: $x }, der);
	}
	/**
	 * Return an evenly spaced sequence of numbers over the given interval.
	 *
	 * ```js
	 * tf.linspace(0, 9, 10).print();
	 * ```
	 * @param start The start value of the sequence.
	 * @param stop The end value of the sequence.
	 * @param num The number of values to generate.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function linspace(start, stop, num) {
	    if (num <= 0) {
	        throw new Error('The number of values should be positive.');
	    }
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.linspace(start, stop, num); }, {});
	}
	exports.linspace = linspace;
	/**
	 * Creates a new `tf.Tensor1D` filled with the numbers in the range provided.
	 *
	 * The tensor is a is half-open interval meaning it includes start, but
	 * excludes stop. Decrementing ranges and negative step values are also
	 * supported.
	 *
	 * ```js
	 * tf.range(0, 9, 2).print();
	 * ```
	 *
	 * @param start An integer start value
	 * @param stop An integer stop value
	 * @param step An integer increment (will default to 1 or -1)
	 * @param dtype The data type of the output tensor. Defaults to 'float32'.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function range(start, stop, step, dtype) {
	    if (step === void 0) { step = 1; }
	    if (dtype === void 0) { dtype = 'float32'; }
	    if (step === 0) {
	        throw new Error('Cannot have a step of zero');
	    }
	    var sameStartStop = start === stop;
	    var increasingRangeNegativeStep = start < stop && step < 0;
	    var decreasingRangePositiveStep = stop < start && step > 1;
	    if (sameStartStop || increasingRangeNegativeStep ||
	        decreasingRangePositiveStep) {
	        return zeros([0], dtype);
	    }
	    var numElements = Math.abs(Math.ceil((stop - start) / step));
	    var values = util_1.makeZerosTypedArray(numElements, dtype);
	    if (stop < start && step === 1) {
	        // Auto adjust the step's sign if it hasn't been set
	        // (or was set to 1)
	        step = -1;
	    }
	    values[0] = start;
	    for (var i = 1; i < values.length; i++) {
	        values[i] = values[i - 1] + step;
	    }
	    return tensor1d(values, dtype);
	}
	exports.range = range;
	exports.onesLike = operation_1.op({ onesLike_: onesLike_ });
	exports.zerosLike = operation_1.op({ zerosLike_: zerosLike_ });
	//# sourceMappingURL=tensor_ops.js.map

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(128);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(462);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(182);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(1943);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(912);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(1939);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(1954);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(1940);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(1941);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(914);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(1942);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(463);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(1952);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(919);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(1945);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(1946);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(1950);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(916);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	tslib_1.__exportStar(__webpack_require__(1442), exports);
	tslib_1.__exportStar(__webpack_require__(579), exports);
	tslib_1.__exportStar(__webpack_require__(580), exports);
	tslib_1.__exportStar(__webpack_require__(1443), exports);
	tslib_1.__exportStar(__webpack_require__(1444), exports);
	tslib_1.__exportStar(__webpack_require__(381), exports);
	tslib_1.__exportStar(__webpack_require__(581), exports);
	tslib_1.__exportStar(__webpack_require__(582), exports);
	tslib_1.__exportStar(__webpack_require__(382), exports);
	tslib_1.__exportStar(__webpack_require__(584), exports);
	//# sourceMappingURL=index.js.map

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	var classes_1 = __webpack_require__(48);
	var Dimensions_1 = __webpack_require__(210);
	function isTensor(tensor, dim) {
	    return tensor instanceof tf.Tensor && tensor.shape.length === dim;
	}
	exports.isTensor = isTensor;
	function isTensor1D(tensor) {
	    return isTensor(tensor, 1);
	}
	exports.isTensor1D = isTensor1D;
	function isTensor2D(tensor) {
	    return isTensor(tensor, 2);
	}
	exports.isTensor2D = isTensor2D;
	function isTensor3D(tensor) {
	    return isTensor(tensor, 3);
	}
	exports.isTensor3D = isTensor3D;
	function isTensor4D(tensor) {
	    return isTensor(tensor, 4);
	}
	exports.isTensor4D = isTensor4D;
	function isFloat(num) {
	    return num % 1 !== 0;
	}
	exports.isFloat = isFloat;
	function isEven(num) {
	    return num % 2 === 0;
	}
	exports.isEven = isEven;
	function round(num, prec) {
	    if (prec === void 0) { prec = 2; }
	    var f = Math.pow(10, prec);
	    return Math.floor(num * f) / f;
	}
	exports.round = round;
	function isDimensions(obj) {
	    return obj && obj.width && obj.height;
	}
	exports.isDimensions = isDimensions;
	function computeReshapedDimensions(_a, inputSize) {
	    var width = _a.width, height = _a.height;
	    var scale = inputSize / Math.max(height, width);
	    return new Dimensions_1.Dimensions(Math.round(width * scale), Math.round(height * scale));
	}
	exports.computeReshapedDimensions = computeReshapedDimensions;
	function getCenterPoint(pts) {
	    return pts.reduce(function (sum, pt) { return sum.add(pt); }, new classes_1.Point(0, 0))
	        .div(new classes_1.Point(pts.length, pts.length));
	}
	exports.getCenterPoint = getCenterPoint;
	function range(num, start, step) {
	    return Array(num).fill(0).map(function (_, i) { return start + (i * step); });
	}
	exports.range = range;
	function isValidNumber(num) {
	    return !!num && num !== Infinity && num !== -Infinity && !isNaN(num) || num === 0;
	}
	exports.isValidNumber = isValidNumber;
	function isValidProbablitiy(num) {
	    return isValidNumber(num) && 0 <= num && num <= 1.0;
	}
	exports.isValidProbablitiy = isValidProbablitiy;
	//# sourceMappingURL=index.js.map

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GET_NEXT_STEP = exports.LOGOUT_USER = exports.UPDATE_USER_EMAIL = exports.VALIDATE_EMAIL_FAILURE = exports.VALIDATE_EMAIL_SUCCESS = exports.VALIDATE_EMAIL = exports.SAVE_FILES = exports.SAVE_INCOMES = exports.SAVE_SERVICE_INFO = exports.SAVE_PERSONAL_INFO = exports.SAVE_EMAIL = exports.SAVE_JOB_INFO = exports.SAVE_ADDRESS = exports.VERIFY_CODE = exports.SAVE_AFFIDAVIT = exports.LOAD_CBU = exports.SIGNIN_USER_FAILURE = exports.SIGNIN_USER_SUCCESS = exports.ACCEPT_CONTRACT = exports.LOAD_PRODUCT = exports.PROCESSED_SUBSCRIBER = exports.STOP_SUBMIT_FORM = exports.SET_SUBSCRIPTION_EMAIL = exports.SUBMIT_FORM = exports.SET_START = exports.RESET_USER = exports.SIGNUP_USER_FAILURE = exports.SIGNUP_USER_SUCCESS = exports.SIGNUP_USER = exports.RESET_TOKEN = exports.ME_FROM_TOKEN_FAILURE = exports.ME_FROM_TOKEN_SUCCESS = exports.ME_FROM_TOKEN = undefined;
	exports.meFromTokenSuccess = meFromTokenSuccess;
	exports.meFromTokenFailure = meFromTokenFailure;
	exports.resetToken = resetToken;
	exports.resetUser = resetUser;
	exports.setStart = setStart;
	exports.submitForm = submitForm;
	exports.setSubscriptionEmail = setSubscriptionEmail;
	exports.stopSubmitForm = stopSubmitForm;
	exports.processSubscriber = processSubscriber;
	exports.loadProduct = loadProduct;
	exports.loadCbu = loadCbu;
	exports.verifyCode = verifyCode;
	exports.acceptContract = acceptContract;
	exports.saveAffidavit = saveAffidavit;
	exports.signInUserSuccess = signInUserSuccess;
	exports.signInUserFailure = signInUserFailure;
	exports.logoutUser = logoutUser;
	exports.updateUserEmail = updateUserEmail;
	exports.validateEmail = validateEmail;
	exports.getNextStep = getNextStep;
	exports.saveAddress = saveAddress;
	exports.saveJobInfo = saveJobInfo;
	exports.saveEmail = saveEmail;
	exports.savePersonalInfo = savePersonalInfo;
	exports.saveServiceInfo = saveServiceInfo;
	exports.saveIncomes = saveIncomes;
	exports.saveFiles = saveFiles;
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = __webpack_require__(2);
	//Get current user(me) from token in localStorage
	var ME_FROM_TOKEN = exports.ME_FROM_TOKEN = 'ME_FROM_TOKEN';
	var ME_FROM_TOKEN_SUCCESS = exports.ME_FROM_TOKEN_SUCCESS = 'ME_FROM_TOKEN_SUCCESS';
	var ME_FROM_TOKEN_FAILURE = exports.ME_FROM_TOKEN_FAILURE = 'ME_FROM_TOKEN_FAILURE';
	var RESET_TOKEN = exports.RESET_TOKEN = 'RESET_TOKEN';
	
	//Sign Up User
	var SIGNUP_USER = exports.SIGNUP_USER = 'SIGNUP_USER';
	var SIGNUP_USER_SUCCESS = exports.SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS';
	var SIGNUP_USER_FAILURE = exports.SIGNUP_USER_FAILURE = 'SIGNUP_USER_FAILURE';
	var RESET_USER = exports.RESET_USER = 'RESET_USER';
	
	var SET_START = exports.SET_START = 'SET_START';
	
	//Sign Up Subscriber
	var SUBMIT_FORM = exports.SUBMIT_FORM = 'SUBMIT_FORM';
	var SET_SUBSCRIPTION_EMAIL = exports.SET_SUBSCRIPTION_EMAIL = 'SET_SUBSCRIPTION_EMAIL';
	var STOP_SUBMIT_FORM = exports.STOP_SUBMIT_FORM = 'STOP_SUBMIT_FORM';
	var PROCESSED_SUBSCRIBER = exports.PROCESSED_SUBSCRIBER = 'PROCESSED_SUBSCRIBER';
	var LOAD_PRODUCT = exports.LOAD_PRODUCT = 'LOAD_PRODUCT';
	var ACCEPT_CONTRACT = exports.ACCEPT_CONTRACT = 'ACCEPT_CONTRACT';
	
	var SIGNIN_USER_SUCCESS = exports.SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
	var SIGNIN_USER_FAILURE = exports.SIGNIN_USER_FAILURE = 'SIGNIN_USER_FAILURE';
	
	//Steps by providers
	var LOAD_CBU = exports.LOAD_CBU = 'LOAD_CBU';
	
	var SAVE_AFFIDAVIT = exports.SAVE_AFFIDAVIT = 'SAVE_AFFIDAVIT';
	
	//Sms Validation
	var VERIFY_CODE = exports.VERIFY_CODE = 'VERIFY_CODE';
	
	//Address Form
	var SAVE_ADDRESS = exports.SAVE_ADDRESS = 'SAVE_ADDRESS';
	
	var SAVE_JOB_INFO = exports.SAVE_JOB_INFO = 'SAVE_JOB_INFO';
	
	var SAVE_EMAIL = exports.SAVE_EMAIL = 'SAVE_EMAIL';
	
	var SAVE_PERSONAL_INFO = exports.SAVE_PERSONAL_INFO = 'SAVE_PERSONAL_INFO';
	
	var SAVE_SERVICE_INFO = exports.SAVE_SERVICE_INFO = 'SAVE_SERVICE_INFO';
	
	var SAVE_INCOMES = exports.SAVE_INCOMES = 'SAVE_INCOMES';
	
	var SAVE_FILES = exports.SAVE_FILES = 'SAVE_FILES';
	
	//validate email, if success, then load user and login
	var VALIDATE_EMAIL = exports.VALIDATE_EMAIL = 'VALIDATE_EMAIL';
	var VALIDATE_EMAIL_SUCCESS = exports.VALIDATE_EMAIL_SUCCESS = 'VALIDATE_EMAIL_SUCCESS';
	var VALIDATE_EMAIL_FAILURE = exports.VALIDATE_EMAIL_FAILURE = 'VALIDATE_EMAIL_FAILURE';
	
	//called when email is updated in profile to update main user's email state
	var UPDATE_USER_EMAIL = exports.UPDATE_USER_EMAIL = 'UPDATE_USER_EMAIL';
	
	//log out user
	var LOGOUT_USER = exports.LOGOUT_USER = 'LOGOUT_USER';
	
	var GET_NEXT_STEP = exports.GET_NEXT_STEP = 'GET_NEXT_STEP';
	
	var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	
	function meFromTokenSuccess(currentUser) {
	    return {
	        type: ME_FROM_TOKEN_SUCCESS,
	        payload: currentUser
	    };
	}
	
	function meFromTokenFailure(error) {
	    return {
	        type: ME_FROM_TOKEN_FAILURE,
	        payload: error
	    };
	}
	
	function resetToken() {
	    //used for logout
	    return {
	        type: RESET_TOKEN
	    };
	}
	
	function resetUser() {
	    return {
	        type: RESET_USER
	    };
	}
	
	function setStart(start) {
	
	    var config = {
	        headers: {
	            'Content-Type': 'application/json',
	            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	        }
	    };
	
	    var request = _axios2.default.get(ROOT_URL + '/leads/start', config);
	
	    return {
	        type: SET_START,
	        payload: request
	    };
	}
	
	function submitForm() {
	    var sleep = function sleep(ms) {
	        return new Promise(function (resolve) {
	            return setTimeout(resolve, ms);
	        });
	    };
	    return {
	        type: SUBMIT_FORM,
	        payload: sleep(1)
	    };
	}
	
	function setSubscriptionEmail(formValues, jwt_token) {
	    var headers = {
	        'Content-Type': 'application/json'
	    };
	
	    var request = _axios2.default.put(ROOT_URL + '/subscribers/by_jwt/' + sessionStorage.getItem('jwtAuthToken'), formValues, headers);
	
	    return {
	        type: SET_SUBSCRIPTION_EMAIL,
	        payload: request
	    };
	}
	
	function stopSubmitForm() {
	
	    var sleep = function sleep(ms) {
	        return new Promise(function (resolve) {
	            return setTimeout(resolve, ms);
	        });
	    };
	    return {
	        type: STOP_SUBMIT_FORM,
	        payload: sleep(1)
	    };
	}
	
	function processSubscriber(formValues) {
	    var headers = {
	        'Content-Type': 'application/json'
	    };
	
	    var request = _axios2.default.post(ROOT_URL + '/subscribers/process', formValues, headers);
	
	    return {
	        type: PROCESSED_SUBSCRIBER,
	        payload: request
	    };
	}
	
	function loadProduct(product) {
	    var config = {
	        headers: {
	            'Content-Type': 'application/json',
	            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	        }
	    };
	
	    var request = _axios2.default.put(ROOT_URL + '/leads/product', product, config);
	
	    return {
	        type: LOAD_PRODUCT,
	        payload: request
	    };
	}
	
	function loadCbu(cbu) {
	
	    var config = {
	        headers: {
	            'Content-Type': 'application/json',
	            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	        }
	    };
	
	    var request = _axios2.default.put(ROOT_URL + '/leads/cbu', cbu, config);
	
	    return {
	        type: LOAD_CBU,
	        payload: request
	    };
	}
	
	function verifyCode(sms_code) {
	
	    var config = {
	        headers: {
	            'Content-Type': 'application/json',
	            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	        }
	    };
	
	    var data = {
	        'code': sms_code
	    };
	
	    var request = _axios2.default.post(ROOT_URL + '/sms/verify_code', data, config);
	
	    return {
	        type: VERIFY_CODE,
	        payload: request
	    };
	}
	
	function acceptContract(values) {
	    var config = {
	        headers: {
	            'Content-Type': 'application/json',
	            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	        }
	    };
	    var contract_accepted = values.contract_accepted;
	
	
	    var request = _axios2.default.put(ROOT_URL + '/leads/contracts/' + values.endpoint, { contract_accepted: contract_accepted }, config);
	
	    return {
	        type: ACCEPT_CONTRACT,
	        payload: request
	    };
	}
	
	function saveAffidavit(values) {
	
	    var config = {
	        headers: {
	            'Content-Type': 'application/json',
	            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	        }
	    };
	
	    var request = _axios2.default.put(ROOT_URL + '/leads/affidavit', values, config);
	
	    return {
	        type: SAVE_AFFIDAVIT,
	        payload: request
	    };
	}
	
	function signInUserSuccess(user) {
	    return {
	        type: SIGNIN_USER_SUCCESS,
	        payload: user
	    };
	}
	
	function signInUserFailure(error) {
	    return {
	        type: SIGNIN_USER_FAILURE,
	        payload: error
	    };
	}
	
	function logoutUser() {
	    return {
	        type: LOGOUT_USER
	    };
	}
	
	function updateUserEmail(email) {
	    return {
	        type: UPDATE_USER_EMAIL,
	        payload: email
	    };
	}
	
	function validateEmail() {
	    return {
	        type: VALIDATE_EMAIL
	    };
	}
	
	function getNextStep() {
	
	    var config = {
	        headers: {
	            'Content-Type': 'application/json',
	            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	        }
	    };
	
	    var request = _axios2.default.get(ROOT_URL + '/leads/steps/next', config);
	    return {
	        type: GET_NEXT_STEP,
	        payload: request
	    };
	}
	
	function saveAddress(values) {
	
	    var config = {
	        headers: {
	            'Content-Type': 'application/json',
	            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	        }
	    };
	
	    var data = {
	        'address_street': values.address_street,
	        'address_description': values.address_description,
	        'income': values.income,
	        'zip_code': values.zip_code,
	        'form_locality': values.form_locality
	    };
	
	    var request = _axios2.default.put(ROOT_URL + '/subscribers/address', data, config);
	
	    return {
	        type: SAVE_ADDRESS,
	        payload: request
	    };
	}
	
	function saveJobInfo(values) {
	
	    var config = {
	        headers: {
	            'Content-Type': 'application/json',
	            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	        }
	    };
	
	    var now = moment(new Date());
	    var initDate = now.subtract(values.init_date, 'months').subtract(1, 'days');
	
	    var data = {
	        'vehicle': values.vehicle,
	        'job_type': values.job_type,
	        'init_date': initDate.format("YYYY-MM-DD"),
	        'remuneration_without_taxes': values.remuneration_without_taxes
	    };
	
	    var request = _axios2.default.put(ROOT_URL + '/subscribers/job_info', data, config);
	
	    return {
	        type: SAVE_JOB_INFO,
	        payload: request
	    };
	}
	
	function saveEmail(values) {
	
	    var config = {
	        headers: {
	            'Content-Type': 'application/json',
	            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	        }
	    };
	    var data = {
	        'email': values.email
	    };
	
	    var request = _axios2.default.put(ROOT_URL + '/subscribers/email', data, config);
	
	    return {
	        type: SAVE_EMAIL,
	        payload: request
	    };
	}
	
	function savePersonalInfo(values) {
	
	    var config = {
	        headers: {
	            'Content-Type': 'application/json',
	            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	        }
	    };
	
	    var data = {
	        'marital_status': values.marital_status,
	        'couple_has_employment': values.couple_has_employment,
	        'partner_incomes': values.partner_incomes,
	        'people_in_house': values.people_in_house,
	        'house_condition': values.house_condition,
	        'breadwinner': values.breadwinner,
	        'rental_price': values.rental_price,
	        'bathrooms': values.bathrooms,
	        'bedrooms': values.bedrooms,
	        'children': values.children,
	        'independent_children': (values.children - values.dependent_children).toString(),
	        'children_in_school': values.children_in_school,
	        'children_institution_type': values.children_institution_type
	    };
	
	    var request = _axios2.default.put(ROOT_URL + '/subscribers/personal_info', data, config);
	
	    return {
	        type: SAVE_PERSONAL_INFO,
	        payload: request
	    };
	}
	
	function saveServiceInfo(values) {
	
	    var config = {
	        headers: {
	            'Content-Type': 'application/json',
	            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	        }
	    };
	
	    var data = {
	        'vehicle': values.vehicle,
	        'car_insurance': values.car_insurance,
	        'life_insurance': values.life_insurance,
	        'house_insurance': values.house_insurance,
	        'services': values.services,
	        'tv_service': values.tv_service,
	        'internet_service': values.internet_service
	    };
	
	    var request = _axios2.default.put(ROOT_URL + '/subscribers/service_info', data, config);
	
	    return {
	        type: SAVE_SERVICE_INFO,
	        payload: request
	    };
	}
	
	function saveIncomes(values) {
	
	    var config = {
	        headers: {
	            'Content-Type': 'application/json',
	            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	        }
	    };
	
	    /*var data = {
	        'leasing_type': values.leasing_type,
	        'monotributo_category': values.monotributo_category,
	        'monthly_costs': values.monthly_costs,
	        'number_of_employees': values.number_of_employees,
	        'self_employment_incomes': values.self_employment_incomes.map((income) => { return {...income, date: income.date.format("YYYY-MM-DD")}})
	    };*/
	    var data = Object.assign({}, values);
	
	    var now = moment(new Date());
	    var baseDate = now.subtract(1, 'month').startOf('month');
	
	    if ('self_employment_incomes' in values) {
	        data = Object.assign({}, values, { self_employment_incomes: values.self_employment_incomes.map(function (income) {
	                return Object.assign({}, income, { income_date: income.income_date.format("YYYY-MM-DD") });
	            }) });
	    }
	
	    if ('check_stubs' in values) {
	        data = Object.assign({}, values, { check_stubs: values.check_stubs.map(function (check_stub) {
	                return Object.assign({}, check_stub, { remuneration_date: baseDate.clone().add(check_stub.remuneration_date, 'days').format("YYYY-MM-DD") });
	            }) });
	    }
	
	    var request = _axios2.default.put(ROOT_URL + '/subscribers/incomes', data, config);
	
	    return {
	        type: SAVE_INCOMES,
	        payload: request
	    };
	}
	
	function saveFiles(values) {
	
	    var config = {
	        headers: {
	            'Content-Type': 'application/json',
	            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	        }
	    };
	
	    var data = {
	        'document_number_front': values.document_number_front,
	        'document_number_back': values.document_number_back,
	        'tax': values.tax,
	        'cbu_document': values.cbu_document,
	        'last_pay_check': values.last_pay_check
	    };
	
	    var request = _axios2.default.put(ROOT_URL + '/subscribers/upload', data, config);
	    return {
	        type: SAVE_FILES,
	        payload: request
	    };
	}

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =  true ? __webpack_require__(1086) : require('./build');
	
	//# sourceMappingURL=index.js.map

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.styles = undefined;
	
	var _regenerator = __webpack_require__(195);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.formatMoney = formatMoney;
	exports.getErrorsApiToReduxForm = getErrorsApiToReduxForm;
	exports.getQueryString = getQueryString;
	exports.sanetizeMktParams = sanetizeMktParams;
	exports.minToSize = minToSize;
	exports.range = range;
	exports.getMiddleIndexValue = getMiddleIndexValue;
	exports.getRandomNumber = getRandomNumber;
	exports.shuffle = shuffle;
	exports.resizeImage = resizeImage;
	exports.getMaxMinAmountValue = getMaxMinAmountValue;
	exports.objectToArrayKeepObject = objectToArrayKeepObject;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var _marked = [range].map(_regenerator2.default.mark);
	
	function formatMoney(value, cents, separator, dot) {
	    var includeSpace = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	
	    if (!value) {
	        return false;
	    }
	    cents = Math.abs(cents);
	    cents = isNaN(cents) ? 2 : cents;
	    separator = separator === undefined ? "." : separator;
	    dot = dot === undefined ? "," : dot;
	    var s = value < 0 ? "-" : "$";
	    s = includeSpace && value > 0 ? s + " " : s;
	    var i = String(parseInt(value = Math.abs(Number(value) || 0).toFixed(cents), 10));
	    var j = i.length;
	    j = j > 3 ? j % 3 : 0;
	    return s + (j ? i.substr(0, j) + dot : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + dot) + (cents ? separator + Math.abs(value - i).toFixed(cents).slice(2) : "");
	};
	
	function getErrorsApiToReduxForm(errors) {
	    var apiErrors = errors;
	    var fields = Object.keys(errors);
	    var reduxFormErrorFormat = {};
	    fields.forEach(function (field) {
	        reduxFormErrorFormat[field] = '';
	        apiErrors[field].forEach(function (description) {
	            reduxFormErrorFormat[field] = reduxFormErrorFormat[field] + ' ' + description;
	        });
	    });
	    return reduxFormErrorFormat;
	};
	
	function getQueryString(mkt_params) {
	    var mkt_params_keys = Object.keys(mkt_params);
	    var queryString = '?';
	    mkt_params_keys.forEach(function (mkt_params_key, index) {
	        //if (checkIfParamExist(mkt_params_key)){
	        if (index !== 0) {
	            queryString = queryString.concat('&');
	        }
	        queryString = queryString.concat(mkt_params_key + '=' + mkt_params[mkt_params_key] + '');
	        //}
	    });
	    return queryString;
	};
	
	function sanetizeMktParams(mktParamsObject) {
	    var mktParamsSanetizedObject = {};
	    Object.keys(mktParamsObject).map(function (key, index) {
	        if (checkIfParamExist(key)) {
	            mktParamsSanetizedObject[key] = mktParamsObject[key];
	        }
	        return mktParamsSanetizedObject[key];
	    });
	    return mktParamsSanetizedObject;
	}
	
	function checkIfParamExist(param) {
	    var allowedParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_provider', 'cid'];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = allowedParams[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var allowedParam = _step.value;
	
	            if (allowedParam === param) {
	                return true;
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    ;
	    return false;
	}
	
	function minToSize(width) {
	    return window.innerWidth <= width;
	}
	
	var styles = exports.styles = {
	    item: {
	        padding: '2px 6px',
	        cursor: 'default'
	    },
	    highlightedItem: {
	        color: 'white',
	        background: 'hsl(200, 50%, 50%)',
	        padding: '2px 6px',
	        cursor: 'default'
	    },
	    menu: {
	        border: 'solid 1px #ccc'
	    }
	};
	
	function range(start, end) {
	    var i;
	    return _regenerator2.default.wrap(function range$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    i = start;
	
	                case 1:
	                    if (!(i <= end)) {
	                        _context.next = 7;
	                        break;
	                    }
	
	                    _context.next = 4;
	                    return i;
	
	                case 4:
	                    i++;
	                    _context.next = 1;
	                    break;
	
	                case 7:
	                case "end":
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function getMiddleIndexValue(list) {
	    return Math.round((list.length - 1) / 2);
	}
	
	function getRandomNumber(max, min, integer) {
	    var random = Math.random() * (+max - +min) + +min;
	    return integer && Math.floor(random) || random;
	}
	
	//algorithm Fisher-Yates
	function shuffle(array) {
	    var currentIndex = array.length,
	        temporaryValue,
	        randomIndex;
	
	    while (0 !== currentIndex) {
	        randomIndex = Math.floor(Math.random() * currentIndex);
	        currentIndex -= 1;
	
	        temporaryValue = array[currentIndex];
	        array[currentIndex] = array[randomIndex];
	        array[randomIndex] = temporaryValue;
	    }
	
	    return array;
	}
	
	function resizeImage(originalWidth, originalHeight, widthMax, heightMax) {
	    var resizedImage = {
	        width: originalWidth,
	        height: originalHeight
	    };
	
	    if (originalWidth > widthMax || originalHeight > heightMax) {
	        resizedImage = {
	            width: widthMax,
	            height: heightMax
	        };
	        var aspectRatio = originalWidth / originalHeight;
	
	        if (originalWidth > originalHeight) {
	            resizedImage.height = widthMax / aspectRatio;
	        } else {
	            resizedImage.width = heightMax * aspectRatio;
	        }
	    }
	
	    return resizedImage;
	}
	
	function getMaxMinAmountValue(amounts, type) {
	    var amountkeys = Object.keys(amounts);
	    var amountValues = amountkeys.map(function (amount) {
	        return Number(amount);
	    });
	    var amount = type === "max" ? Math.max.apply(Math, _toConsumableArray(amountValues)) : Math.min.apply(Math, _toConsumableArray(amountValues));
	    return amount;
	}
	
	function objectToArrayKeepObject(obj) {
	
	    var result = [];
	    var keys = Object.keys(obj);
	
	    for (var i = 0; i < keys.length; i++) {
	        var key = keys[i];
	        var value = obj[key];
	        result.push(_defineProperty({}, key, value));
	    }
	    return result;
	}

/***/ },
/* 39 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.utils = exports.Well = exports.Tooltip = exports.Thumbnail = exports.Tabs = exports.TabPane = exports.Table = exports.TabContent = exports.TabContainer = exports.Tab = exports.SplitButton = exports.SafeAnchor = exports.Row = exports.ResponsiveEmbed = exports.Radio = exports.ProgressBar = exports.Popover = exports.PanelGroup = exports.Panel = exports.PaginationButton = exports.Pagination = exports.Pager = exports.PageItem = exports.PageHeader = exports.OverlayTrigger = exports.Overlay = exports.NavItem = exports.NavDropdown = exports.NavbarBrand = exports.Navbar = exports.Nav = exports.ModalTitle = exports.ModalHeader = exports.ModalFooter = exports.ModalBody = exports.Modal = exports.MenuItem = exports.Media = exports.ListGroupItem = exports.ListGroup = exports.Label = exports.Jumbotron = exports.InputGroup = exports.Image = exports.HelpBlock = exports.Grid = exports.Glyphicon = exports.FormGroup = exports.FormControl = exports.Form = exports.Fade = exports.DropdownButton = exports.Dropdown = exports.Collapse = exports.Col = exports.ControlLabel = exports.Clearfix = exports.Checkbox = exports.CarouselItem = exports.Carousel = exports.ButtonToolbar = exports.ButtonGroup = exports.Button = exports.BreadcrumbItem = exports.Breadcrumb = exports.Badge = exports.Alert = exports.Accordion = undefined;
	
	var _Accordion2 = __webpack_require__(1741);
	
	var _Accordion3 = _interopRequireDefault(_Accordion2);
	
	var _Alert2 = __webpack_require__(1742);
	
	var _Alert3 = _interopRequireDefault(_Alert2);
	
	var _Badge2 = __webpack_require__(1743);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _Breadcrumb2 = __webpack_require__(1744);
	
	var _Breadcrumb3 = _interopRequireDefault(_Breadcrumb2);
	
	var _BreadcrumbItem2 = __webpack_require__(832);
	
	var _BreadcrumbItem3 = _interopRequireDefault(_BreadcrumbItem2);
	
	var _Button2 = __webpack_require__(221);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _ButtonGroup2 = __webpack_require__(833);
	
	var _ButtonGroup3 = _interopRequireDefault(_ButtonGroup2);
	
	var _ButtonToolbar2 = __webpack_require__(1745);
	
	var _ButtonToolbar3 = _interopRequireDefault(_ButtonToolbar2);
	
	var _Carousel2 = __webpack_require__(1746);
	
	var _Carousel3 = _interopRequireDefault(_Carousel2);
	
	var _CarouselItem2 = __webpack_require__(834);
	
	var _CarouselItem3 = _interopRequireDefault(_CarouselItem2);
	
	var _Checkbox2 = __webpack_require__(1748);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Clearfix2 = __webpack_require__(1749);
	
	var _Clearfix3 = _interopRequireDefault(_Clearfix2);
	
	var _ControlLabel2 = __webpack_require__(1751);
	
	var _ControlLabel3 = _interopRequireDefault(_ControlLabel2);
	
	var _Col2 = __webpack_require__(1750);
	
	var _Col3 = _interopRequireDefault(_Col2);
	
	var _Collapse2 = __webpack_require__(428);
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	var _Dropdown2 = __webpack_require__(286);
	
	var _Dropdown3 = _interopRequireDefault(_Dropdown2);
	
	var _DropdownButton2 = __webpack_require__(1752);
	
	var _DropdownButton3 = _interopRequireDefault(_DropdownButton2);
	
	var _Fade2 = __webpack_require__(287);
	
	var _Fade3 = _interopRequireDefault(_Fade2);
	
	var _Form2 = __webpack_require__(1754);
	
	var _Form3 = _interopRequireDefault(_Form2);
	
	var _FormControl2 = __webpack_require__(1755);
	
	var _FormControl3 = _interopRequireDefault(_FormControl2);
	
	var _FormGroup2 = __webpack_require__(1758);
	
	var _FormGroup3 = _interopRequireDefault(_FormGroup2);
	
	var _Glyphicon2 = __webpack_require__(429);
	
	var _Glyphicon3 = _interopRequireDefault(_Glyphicon2);
	
	var _Grid2 = __webpack_require__(836);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _HelpBlock2 = __webpack_require__(1759);
	
	var _HelpBlock3 = _interopRequireDefault(_HelpBlock2);
	
	var _Image2 = __webpack_require__(1760);
	
	var _Image3 = _interopRequireDefault(_Image2);
	
	var _InputGroup2 = __webpack_require__(1761);
	
	var _InputGroup3 = _interopRequireDefault(_InputGroup2);
	
	var _Jumbotron2 = __webpack_require__(1764);
	
	var _Jumbotron3 = _interopRequireDefault(_Jumbotron2);
	
	var _Label2 = __webpack_require__(1765);
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	var _ListGroup2 = __webpack_require__(1766);
	
	var _ListGroup3 = _interopRequireDefault(_ListGroup2);
	
	var _ListGroupItem2 = __webpack_require__(837);
	
	var _ListGroupItem3 = _interopRequireDefault(_ListGroupItem2);
	
	var _Media2 = __webpack_require__(430);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _MenuItem2 = __webpack_require__(1773);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _Modal2 = __webpack_require__(1774);
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	var _ModalBody2 = __webpack_require__(838);
	
	var _ModalBody3 = _interopRequireDefault(_ModalBody2);
	
	var _ModalFooter2 = __webpack_require__(839);
	
	var _ModalFooter3 = _interopRequireDefault(_ModalFooter2);
	
	var _ModalHeader2 = __webpack_require__(840);
	
	var _ModalHeader3 = _interopRequireDefault(_ModalHeader2);
	
	var _ModalTitle2 = __webpack_require__(841);
	
	var _ModalTitle3 = _interopRequireDefault(_ModalTitle2);
	
	var _Nav2 = __webpack_require__(842);
	
	var _Nav3 = _interopRequireDefault(_Nav2);
	
	var _Navbar2 = __webpack_require__(1777);
	
	var _Navbar3 = _interopRequireDefault(_Navbar2);
	
	var _NavbarBrand2 = __webpack_require__(844);
	
	var _NavbarBrand3 = _interopRequireDefault(_NavbarBrand2);
	
	var _NavDropdown2 = __webpack_require__(1776);
	
	var _NavDropdown3 = _interopRequireDefault(_NavDropdown2);
	
	var _NavItem2 = __webpack_require__(843);
	
	var _NavItem3 = _interopRequireDefault(_NavItem2);
	
	var _Overlay2 = __webpack_require__(845);
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	var _OverlayTrigger2 = __webpack_require__(1781);
	
	var _OverlayTrigger3 = _interopRequireDefault(_OverlayTrigger2);
	
	var _PageHeader2 = __webpack_require__(1782);
	
	var _PageHeader3 = _interopRequireDefault(_PageHeader2);
	
	var _PageItem2 = __webpack_require__(1783);
	
	var _PageItem3 = _interopRequireDefault(_PageItem2);
	
	var _Pager2 = __webpack_require__(1784);
	
	var _Pager3 = _interopRequireDefault(_Pager2);
	
	var _Pagination2 = __webpack_require__(1785);
	
	var _Pagination3 = _interopRequireDefault(_Pagination2);
	
	var _PaginationButton2 = __webpack_require__(847);
	
	var _PaginationButton3 = _interopRequireDefault(_PaginationButton2);
	
	var _Panel2 = __webpack_require__(1786);
	
	var _Panel3 = _interopRequireDefault(_Panel2);
	
	var _PanelGroup2 = __webpack_require__(848);
	
	var _PanelGroup3 = _interopRequireDefault(_PanelGroup2);
	
	var _Popover2 = __webpack_require__(1787);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _ProgressBar2 = __webpack_require__(1788);
	
	var _ProgressBar3 = _interopRequireDefault(_ProgressBar2);
	
	var _Radio2 = __webpack_require__(1789);
	
	var _Radio3 = _interopRequireDefault(_Radio2);
	
	var _ResponsiveEmbed2 = __webpack_require__(1790);
	
	var _ResponsiveEmbed3 = _interopRequireDefault(_ResponsiveEmbed2);
	
	var _Row2 = __webpack_require__(1791);
	
	var _Row3 = _interopRequireDefault(_Row2);
	
	var _SafeAnchor2 = __webpack_require__(103);
	
	var _SafeAnchor3 = _interopRequireDefault(_SafeAnchor2);
	
	var _SplitButton2 = __webpack_require__(1792);
	
	var _SplitButton3 = _interopRequireDefault(_SplitButton2);
	
	var _Tab2 = __webpack_require__(1794);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _TabContainer2 = __webpack_require__(431);
	
	var _TabContainer3 = _interopRequireDefault(_TabContainer2);
	
	var _TabContent2 = __webpack_require__(432);
	
	var _TabContent3 = _interopRequireDefault(_TabContent2);
	
	var _Table2 = __webpack_require__(1795);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TabPane2 = __webpack_require__(849);
	
	var _TabPane3 = _interopRequireDefault(_TabPane2);
	
	var _Tabs2 = __webpack_require__(1796);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Thumbnail2 = __webpack_require__(1797);
	
	var _Thumbnail3 = _interopRequireDefault(_Thumbnail2);
	
	var _Tooltip2 = __webpack_require__(1798);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _Well2 = __webpack_require__(1799);
	
	var _Well3 = _interopRequireDefault(_Well2);
	
	var _utils2 = __webpack_require__(1803);
	
	var _utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.Accordion = _Accordion3['default'];
	exports.Alert = _Alert3['default'];
	exports.Badge = _Badge3['default'];
	exports.Breadcrumb = _Breadcrumb3['default'];
	exports.BreadcrumbItem = _BreadcrumbItem3['default'];
	exports.Button = _Button3['default'];
	exports.ButtonGroup = _ButtonGroup3['default'];
	exports.ButtonToolbar = _ButtonToolbar3['default'];
	exports.Carousel = _Carousel3['default'];
	exports.CarouselItem = _CarouselItem3['default'];
	exports.Checkbox = _Checkbox3['default'];
	exports.Clearfix = _Clearfix3['default'];
	exports.ControlLabel = _ControlLabel3['default'];
	exports.Col = _Col3['default'];
	exports.Collapse = _Collapse3['default'];
	exports.Dropdown = _Dropdown3['default'];
	exports.DropdownButton = _DropdownButton3['default'];
	exports.Fade = _Fade3['default'];
	exports.Form = _Form3['default'];
	exports.FormControl = _FormControl3['default'];
	exports.FormGroup = _FormGroup3['default'];
	exports.Glyphicon = _Glyphicon3['default'];
	exports.Grid = _Grid3['default'];
	exports.HelpBlock = _HelpBlock3['default'];
	exports.Image = _Image3['default'];
	exports.InputGroup = _InputGroup3['default'];
	exports.Jumbotron = _Jumbotron3['default'];
	exports.Label = _Label3['default'];
	exports.ListGroup = _ListGroup3['default'];
	exports.ListGroupItem = _ListGroupItem3['default'];
	exports.Media = _Media3['default'];
	exports.MenuItem = _MenuItem3['default'];
	exports.Modal = _Modal3['default'];
	exports.ModalBody = _ModalBody3['default'];
	exports.ModalFooter = _ModalFooter3['default'];
	exports.ModalHeader = _ModalHeader3['default'];
	exports.ModalTitle = _ModalTitle3['default'];
	exports.Nav = _Nav3['default'];
	exports.Navbar = _Navbar3['default'];
	exports.NavbarBrand = _NavbarBrand3['default'];
	exports.NavDropdown = _NavDropdown3['default'];
	exports.NavItem = _NavItem3['default'];
	exports.Overlay = _Overlay3['default'];
	exports.OverlayTrigger = _OverlayTrigger3['default'];
	exports.PageHeader = _PageHeader3['default'];
	exports.PageItem = _PageItem3['default'];
	exports.Pager = _Pager3['default'];
	exports.Pagination = _Pagination3['default'];
	exports.PaginationButton = _PaginationButton3['default'];
	exports.Panel = _Panel3['default'];
	exports.PanelGroup = _PanelGroup3['default'];
	exports.Popover = _Popover3['default'];
	exports.ProgressBar = _ProgressBar3['default'];
	exports.Radio = _Radio3['default'];
	exports.ResponsiveEmbed = _ResponsiveEmbed3['default'];
	exports.Row = _Row3['default'];
	exports.SafeAnchor = _SafeAnchor3['default'];
	exports.SplitButton = _SplitButton3['default'];
	exports.Tab = _Tab3['default'];
	exports.TabContainer = _TabContainer3['default'];
	exports.TabContent = _TabContent3['default'];
	exports.Table = _Table3['default'];
	exports.TabPane = _TabPane3['default'];
	exports.Tabs = _Tabs3['default'];
	exports.Thumbnail = _Thumbnail3['default'];
	exports.Tooltip = _Tooltip3['default'];
	exports.Well = _Well3['default'];
	exports.utils = _utils;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var broadcast_util_1 = __webpack_require__(57);
	var util = __webpack_require__(10);
	var glsl_version_1 = __webpack_require__(81);
	var shader_util = __webpack_require__(120);
	function makeShader(inputsInfo, outputShape, userCode, usesPackedTextures) {
	    var prefixSnippets = [];
	    inputsInfo.forEach(function (x) {
	        var size = util.sizeFromShape(x.shapeInfo.logicalShape);
	        // Snippet when we decided to upload the values as uniform.
	        if (x.shapeInfo.isUniform) {
	            prefixSnippets.push("uniform float " + x.name + (size > 1 ? "[" + size + "]" : '') + ";");
	        }
	        else {
	            prefixSnippets.push("uniform sampler2D " + x.name + ";");
	            prefixSnippets.push("uniform int offset" + x.name + ";");
	        }
	    });
	    var inputPrefixSnippet = prefixSnippets.join('\n');
	    var inputSamplingSnippet = inputsInfo
	        .map(function (x) { return getInputSamplingSnippet(x, outputShape, usesPackedTextures); })
	        .join('\n');
	    var outTexShape = outputShape.texShape;
	    var glsl = glsl_version_1.getGlslDifferences();
	    var floatTextureSampleSnippet = getFloatTextureSampleSnippet(glsl);
	    var outputSamplingSnippet;
	    var floatTextureSetOutputSnippet;
	    var shaderPrefix = getShaderPrefix(glsl);
	    if (outputShape.isPacked) {
	        outputSamplingSnippet =
	            getPackedOutputSamplingSnippet(outputShape.logicalShape, outTexShape);
	        floatTextureSetOutputSnippet = getFloatTextureSetRGBASnippet(glsl);
	    }
	    else {
	        outputSamplingSnippet =
	            getOutputSamplingSnippet(outputShape.logicalShape, outTexShape);
	        floatTextureSetOutputSnippet = getFloatTextureSetRSnippet(glsl);
	    }
	    if (usesPackedTextures) {
	        shaderPrefix += SHADER_PACKED_PREFIX;
	    }
	    var source = [
	        shaderPrefix, floatTextureSampleSnippet, floatTextureSetOutputSnippet,
	        inputPrefixSnippet, outputSamplingSnippet, inputSamplingSnippet, userCode
	    ].join('\n');
	    return source;
	}
	exports.makeShader = makeShader;
	function getSamplerFromInInfo(inInfo) {
	    var shape = inInfo.shapeInfo.logicalShape;
	    switch (shape.length) {
	        case 0:
	            return getSamplerScalar(inInfo);
	        case 1:
	            return getSampler1D(inInfo);
	        case 2:
	            return getSampler2D(inInfo);
	        case 3:
	            return getSampler3D(inInfo);
	        case 4:
	            return getSampler4D(inInfo);
	        case 5:
	            return getSampler5D(inInfo);
	        case 6:
	            return getSampler6D(inInfo);
	        default:
	            throw new Error(shape.length + "-D input sampling" +
	                " is not yet supported");
	    }
	}
	function getPackedSamplerFromInInfo(inInfo) {
	    var shape = inInfo.shapeInfo.logicalShape;
	    switch (shape.length) {
	        case 0:
	            return getPackedSamplerScalar(inInfo);
	        case 1:
	            return getPackedSampler1D(inInfo);
	        case 2:
	            return getPackedSampler2D(inInfo);
	        case 3:
	            return getPackedSampler3D(inInfo);
	        default:
	            return getPackedSamplerND(inInfo);
	    }
	}
	function getInputSamplingSnippet(inInfo, outShapeInfo, usesPackedTextures) {
	    if (usesPackedTextures === void 0) { usesPackedTextures = false; }
	    var res = '';
	    if (usesPackedTextures) {
	        res += getPackedSamplerFromInInfo(inInfo);
	    }
	    else {
	        res += getSamplerFromInInfo(inInfo);
	    }
	    var inShape = inInfo.shapeInfo.logicalShape;
	    var outShape = outShapeInfo.logicalShape;
	    if (inShape.length <= outShape.length) {
	        if (usesPackedTextures) {
	            res += getPackedSamplerAtOutputCoords(inInfo, outShapeInfo);
	        }
	        else {
	            res += getSamplerAtOutputCoords(inInfo, outShapeInfo);
	        }
	    }
	    return res;
	}
	function getPackedOutputSamplingSnippet(outShape, outTexShape) {
	    switch (outShape.length) {
	        case 0:
	            return getOutputScalarCoords();
	        case 1:
	            return getOutputPacked1DCoords(outShape, outTexShape);
	        case 2:
	            return getOutputPacked2DCoords(outShape, outTexShape);
	        case 3:
	            return getOutputPacked3DCoords(outShape, outTexShape);
	        default:
	            return getOutputPackedNDCoords(outShape, outTexShape);
	    }
	}
	function getOutputSamplingSnippet(outShape, outTexShape) {
	    switch (outShape.length) {
	        case 0:
	            return getOutputScalarCoords();
	        case 1:
	            return getOutput1DCoords(outShape, outTexShape);
	        case 2:
	            return getOutput2DCoords(outShape, outTexShape);
	        case 3:
	            return getOutput3DCoords(outShape, outTexShape);
	        case 4:
	            return getOutput4DCoords(outShape, outTexShape);
	        case 5:
	            return getOutput5DCoords(outShape, outTexShape);
	        case 6:
	            return getOutput6DCoords(outShape, outTexShape);
	        default:
	            throw new Error(outShape.length + "-D output sampling is not yet supported");
	    }
	}
	function getFloatTextureSampleSnippet(glsl) {
	    return "\n    float sampleTexture(sampler2D textureSampler, vec2 uv) {\n      return " + glsl.texture2D + "(textureSampler, uv).r;\n    }\n  ";
	}
	function getFloatTextureSetRSnippet(glsl) {
	    return "\n    void setOutput(float val) {\n      " + glsl.output + " = vec4(val, 0, 0, 0);\n    }\n  ";
	}
	function getFloatTextureSetRGBASnippet(glsl) {
	    return "\n    void setOutput(vec4 val) {\n      " + glsl.output + " = val;\n    }\n  ";
	}
	function getShaderPrefix(glsl) {
	    var SHADER_PREFIX = glsl.version + "\n    precision highp float;\n    precision highp int;\n    precision highp sampler2D;\n    " + glsl.varyingFs + " vec2 resultUV;\n    " + glsl.defineOutput + "\n    const vec2 halfCR = vec2(0.5, 0.5);\n\n    struct ivec5\n    {\n      int x;\n      int y;\n      int z;\n      int w;\n      int u;\n    };\n\n    struct ivec6\n    {\n      int x;\n      int y;\n      int z;\n      int w;\n      int u;\n      int v;\n    };\n\n    uniform float NAN;\n    " + glsl.defineSpecialNaN + "\n    " + glsl.defineSpecialInf + "\n    " + glsl.defineRound + "\n\n    int imod(int x, int y) {\n      return x - y * (x / y);\n    }\n\n    int idiv(int a, int b, float sign) {\n      int res = a / b;\n      int mod = imod(a, b);\n      if (sign < 0. && mod != 0) {\n        res -= 1;\n      }\n      return res;\n    }\n\n    //Based on the work of Dave Hoskins\n    //https://www.shadertoy.com/view/4djSRW\n    #define HASHSCALE1 443.8975\n    float random(float seed){\n      vec2 p = resultUV * seed;\n      vec3 p3  = fract(vec3(p.xyx) * HASHSCALE1);\n      p3 += dot(p3, p3.yzx + 19.19);\n      return fract((p3.x + p3.y) * p3.z);\n    }\n\n    " + SAMPLE_1D_SNIPPET + "\n    " + SAMPLE_2D_SNIPPET + "\n    " + SAMPLE_3D_SNIPPET + "\n  ";
	    return SHADER_PREFIX;
	}
	var SAMPLE_1D_SNIPPET = "\nvec2 uvFromFlat(int texNumR, int texNumC, int index) {\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\nvec2 packedUVfrom1D(int texNumR, int texNumC, int index) {\n  int texelIndex = index / 2;\n  int texR = texelIndex / texNumC;\n  int texC = texelIndex - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n";
	var SAMPLE_2D_SNIPPET = "\nvec2 packedUVfrom2D(int texelsInLogicalRow, int texNumR,\n  int texNumC, int row, int col) {\n  int texelIndex = (row / 2) * texelsInLogicalRow + (col / 2);\n  int texR = texelIndex / texNumC;\n  int texC = texelIndex - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n";
	var SAMPLE_3D_SNIPPET = "\nvec2 packedUVfrom3D(int texNumR, int texNumC,\n    int texelsInBatch, int texelsInLogicalRow, int b,\n    int row, int col) {\n  int index = b * texelsInBatch + (row / 2) * texelsInLogicalRow + (col / 2);\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n";
	var SHADER_PACKED_PREFIX = "\n  float getChannel(vec4 frag, vec2 innerDims) {\n    vec2 modCoord = mod(innerDims, 2.);\n    return modCoord.x == 0. ?\n      (modCoord.y == 0. ? frag.r : frag.g) :\n      (modCoord.y == 0. ? frag.b : frag.a);\n  }\n  float getChannel(vec4 frag, int dim) {\n    float modCoord = mod(float(dim), 2.);\n    return modCoord == 0. ? frag.r : frag.g;\n  }\n";
	function getOutputScalarCoords() {
	    return "\n    int getOutputCoords() {\n      return 0;\n    }\n  ";
	}
	function getOutputPacked1DCoords(shape, texShape) {
	    var packedTexShape = [Math.ceil(texShape[0] / 2), Math.ceil(texShape[1] / 2)];
	    if (packedTexShape[0] === 1) {
	        return "\n      int getOutputCoords() {\n        return 2 * int(resultUV.x * " + packedTexShape[1] + ".0);\n      }\n    ";
	    }
	    if (packedTexShape[1] === 1) {
	        return "\n      int getOutputCoords() {\n        return 2 * int(resultUV.y * " + packedTexShape[0] + ".0);\n      }\n    ";
	    }
	    return "\n    int getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + packedTexShape[0] + ", " + packedTexShape[1] + "));\n      return 2 * (resTexRC.x * " + packedTexShape[1] + " + resTexRC.y);\n    }\n  ";
	}
	function getOutput1DCoords(shape, texShape) {
	    if (texShape[0] === 1) {
	        return "\n      int getOutputCoords() {\n        return int(resultUV.x * " + texShape[1] + ".0);\n      }\n    ";
	    }
	    if (texShape[1] === 1) {
	        return "\n      int getOutputCoords() {\n        return int(resultUV.y * " + texShape[0] + ".0);\n      }\n    ";
	    }
	    return "\n    int getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + texShape[0] + ", " + texShape[1] + "));\n      return resTexRC.x * " + texShape[1] + " + resTexRC.y;\n    }\n  ";
	}
	function getOutputPacked3DCoords(shape, texShape) {
	    var packedTexShape = [Math.ceil(texShape[0] / 2), Math.ceil(texShape[1] / 2)];
	    var texelsInLogicalRow = Math.ceil(shape[2] / 2);
	    var texelsInBatch = texelsInLogicalRow * Math.ceil(shape[1] / 2);
	    return "\n    ivec3 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + packedTexShape[0] + ", " + packedTexShape[1] + "));\n      int index = resTexRC.x * " + packedTexShape[1] + " + resTexRC.y;\n\n      int b = index / " + texelsInBatch + ";\n      index -= b * " + texelsInBatch + ";\n\n      int r = 2 * (index / " + texelsInLogicalRow + ");\n      int c = imod(index, " + texelsInLogicalRow + ") * 2;\n\n      return ivec3(b, r, c);\n    }\n  ";
	}
	function getOutput3DCoords(shape, texShape) {
	    var coordsFromIndexSnippet = shader_util.getLogicalCoordinatesFromFlatIndex(['r', 'c', 'd'], shape);
	    return "\n    ivec3 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + texShape[0] + ", " + texShape[1] + "));\n      int index = resTexRC.x * " + texShape[1] + " + resTexRC.y;\n      " + coordsFromIndexSnippet + "\n      return ivec3(r, c, d);\n    }\n  ";
	}
	function getOutputPackedNDCoords(shape, texShape) {
	    var packedTexShape = [Math.ceil(texShape[0] / 2), Math.ceil(texShape[1] / 2)];
	    var texelsInLogicalRow = Math.ceil(shape[shape.length - 1] / 2);
	    var texelsInBatch = texelsInLogicalRow * Math.ceil(shape[shape.length - 2] / 2);
	    var texelsInBatchN = texelsInBatch;
	    var batches = "";
	    var coords = 'b, r, c';
	    for (var b = 2; b < shape.length - 1; b++) {
	        texelsInBatchN *= shape[shape.length - b - 1];
	        batches = "\n      int b" + b + " = index / " + texelsInBatchN + ";\n      index -= b" + b + " * " + texelsInBatchN + ";\n    " + batches;
	        coords = "b" + b + ", " + coords;
	    }
	    return "\n    ivec" + shape.length + " getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + packedTexShape[0] + ", " + packedTexShape[1] + "));\n      int index = resTexRC.x * " + packedTexShape[1] + " + resTexRC.y;\n\n      " + batches + "\n\n      int b = index / " + texelsInBatch + ";\n      index -= b * " + texelsInBatch + ";\n\n      int r = 2 * (index / " + texelsInLogicalRow + ");\n      int c = imod(index, " + texelsInLogicalRow + ") * 2;\n\n      return ivec" + shape.length + "(" + coords + ");\n    }\n  ";
	}
	function getOutput4DCoords(shape, texShape) {
	    var coordsFromIndexSnippet = shader_util.getLogicalCoordinatesFromFlatIndex(['r', 'c', 'd', 'd2'], shape);
	    return "\n    ivec4 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n        vec2(" + texShape[0] + ", " + texShape[1] + "));\n      int index = resTexRC.x * " + texShape[1] + " + resTexRC.y;\n      " + coordsFromIndexSnippet + "\n      return ivec4(r, c, d, d2);\n    }\n  ";
	}
	function getOutput5DCoords(shape, texShape) {
	    var coordsFromIndexSnippet = shader_util.getLogicalCoordinatesFromFlatIndex(['r', 'c', 'd', 'd2', 'd3'], shape);
	    return "\n    ivec5 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx * vec2(" + texShape[0] + ",\n                             " + texShape[1] + "));\n\n      int index = resTexRC.x * " + texShape[1] + " + resTexRC.y;\n\n      " + coordsFromIndexSnippet + "\n\n      ivec5 outShape = ivec5(r, c, d, d2, d3);\n      return outShape;\n    }\n  ";
	}
	function getOutput6DCoords(shape, texShape) {
	    var coordsFromIndexSnippet = shader_util.getLogicalCoordinatesFromFlatIndex(['r', 'c', 'd', 'd2', 'd3', 'd4'], shape);
	    return "\n    ivec6 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n        vec2(" + texShape[0] + ", " + texShape[1] + "));\n      int index = resTexRC.x * " + texShape[1] + " + resTexRC.y;\n\n      " + coordsFromIndexSnippet + "\n\n      ivec6 result = ivec6(r, c, d, d2, d3, d4);\n      return result;\n    }\n  ";
	}
	function getOutputPacked2DCoords(shape, texShape) {
	    var packedTexShape = [Math.ceil(texShape[0] / 2), Math.ceil(texShape[1] / 2)];
	    if (util.arraysEqual(shape, texShape)) {
	        return "\n      ivec2 getOutputCoords() {\n        return 2 * ivec2(resultUV.yx * vec2(" + packedTexShape[0] + ", " + packedTexShape[1] + "));\n      }\n    ";
	    }
	    // texels needed to accommodate a logical row
	    var texelsInLogicalRow = Math.ceil(shape[1] / 2);
	    /**
	     * getOutputCoords
	     *
	     * resTexRC: The rows and columns of the texels. If you move over one
	     * texel to the right in the packed texture, you are moving over one column
	     * (not two).
	     *
	     * index: The texel index
	     */
	    return "\n    ivec2 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + packedTexShape[0] + ", " + packedTexShape[1] + "));\n\n      int index = resTexRC.x * " + packedTexShape[1] + " + resTexRC.y;\n      int r = 2 * (index / " + texelsInLogicalRow + ");\n      int c = imod(index, " + texelsInLogicalRow + ") * 2;\n\n      return ivec2(r, c);\n    }\n  ";
	}
	function getOutput2DCoords(shape, texShape) {
	    if (util.arraysEqual(shape, texShape)) {
	        return "\n      ivec2 getOutputCoords() {\n        return ivec2(resultUV.yx * vec2(" + texShape[0] + ", " + texShape[1] + "));\n      }\n    ";
	    }
	    if (shape[1] === 1) {
	        return "\n      ivec2 getOutputCoords() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n                               vec2(" + texShape[0] + ", " + texShape[1] + "));\n        int index = resTexRC.x * " + texShape[1] + " + resTexRC.y;\n        return ivec2(index, 0);\n      }\n    ";
	    }
	    if (shape[0] === 1) {
	        return "\n      ivec2 getOutputCoords() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n                               vec2(" + texShape[0] + ", " + texShape[1] + "));\n        int index = resTexRC.x * " + texShape[1] + " + resTexRC.y;\n        return ivec2(0, index);\n      }\n    ";
	    }
	    return "\n    ivec2 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + texShape[0] + ", " + texShape[1] + "));\n      int index = resTexRC.x * " + texShape[1] + " + resTexRC.y;\n      int r = index / " + shape[1] + ";\n      int c = index - r * " + shape[1] + ";\n      return ivec2(r, c);\n    }\n  ";
	}
	function getFlatOffsetUniformName(texName) {
	    return "offset" + texName;
	}
	function getPackedSamplerScalar(inputInfo) {
	    var texName = inputInfo.name;
	    var funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
	    var glsl = glsl_version_1.getGlslDifferences();
	    return "\n    vec4 " + funcName + "() {\n      return " + glsl.texture2D + "(" + texName + ", halfCR);\n    }\n  ";
	}
	function getSamplerScalar(inputInfo) {
	    var texName = inputInfo.name;
	    var funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
	    if (inputInfo.shapeInfo.isUniform) {
	        return "float " + funcName + "() {return " + texName + ";}";
	    }
	    var _a = inputInfo.shapeInfo.texShape, texNumR = _a[0], texNumC = _a[1];
	    if (texNumR === 1 && texNumC === 1) {
	        return "\n      float " + funcName + "() {\n        return sampleTexture(" + texName + ", halfCR);\n      }\n    ";
	    }
	    var _b = inputInfo.shapeInfo.texShape, tNumR = _b[0], tNumC = _b[1];
	    var offset = getFlatOffsetUniformName(texName);
	    return "\n    float " + funcName + "() {\n      vec2 uv = uvFromFlat(" + tNumR + ", " + tNumC + ", " + offset + ");\n      return sampleTexture(" + texName + ", uv);\n    }\n  ";
	}
	function getPackedSampler1D(inputInfo) {
	    var texName = inputInfo.name;
	    var funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
	    var texShape = inputInfo.shapeInfo.texShape;
	    var packedTexShape = [Math.ceil(texShape[0] / 2), Math.ceil(texShape[1] / 2)];
	    var glsl = glsl_version_1.getGlslDifferences();
	    return "\n    vec4 " + funcName + "(int index) {\n      vec2 uv = packedUVfrom1D(\n        " + packedTexShape[0] + ", " + packedTexShape[1] + ", index);\n      return " + glsl.texture2D + "(" + texName + ", uv);\n    }\n  ";
	}
	function getSampler1D(inputInfo) {
	    var texName = inputInfo.name;
	    var funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
	    if (inputInfo.shapeInfo.isUniform) {
	        // Uniform arrays will be less than 65505 (no risk of float16 overflow).
	        return "\n      float " + funcName + "(int index) {\n        " + getUniformSampler(inputInfo) + "\n      }\n    ";
	    }
	    var texShape = inputInfo.shapeInfo.texShape;
	    var tNumR = texShape[0];
	    var tNumC = texShape[1];
	    if (tNumC === 1 && tNumR === 1) {
	        return "\n      float " + funcName + "(int index) {\n        return sampleTexture(" + texName + ", halfCR);\n      }\n    ";
	    }
	    var offset = getFlatOffsetUniformName(texName);
	    if (tNumC === 1) {
	        return "\n      float " + funcName + "(int index) {\n        vec2 uv = vec2(0.5, (float(index + " + offset + ") + 0.5) / " + tNumR + ".0);\n        return sampleTexture(" + texName + ", uv);\n      }\n    ";
	    }
	    if (tNumR === 1) {
	        return "\n      float " + funcName + "(int index) {\n        vec2 uv = vec2((float(index + " + offset + ") + 0.5) / " + tNumC + ".0, 0.5);\n        return sampleTexture(" + texName + ", uv);\n      }\n    ";
	    }
	    return "\n    float " + funcName + "(int index) {\n      vec2 uv = uvFromFlat(" + tNumR + ", " + tNumC + ", index + " + offset + ");\n      return sampleTexture(" + texName + ", uv);\n    }\n  ";
	}
	function getPackedSampler2D(inputInfo) {
	    var shape = inputInfo.shapeInfo.logicalShape;
	    var texName = inputInfo.name;
	    var funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
	    var texShape = inputInfo.shapeInfo.texShape;
	    var texNumR = texShape[0];
	    var texNumC = texShape[1];
	    var glsl = glsl_version_1.getGlslDifferences();
	    if (texShape != null && util.arraysEqual(shape, texShape)) {
	        return "\n      vec4 " + funcName + "(int row, int col) {\n        vec2 uv = (vec2(col, row) + halfCR) / vec2(" + texNumC + ".0, " + texNumR + ".0);\n\n        return " + glsl.texture2D + "(" + texName + ", uv);\n      }\n    ";
	    }
	    var packedTexShape = [Math.ceil(texShape[0] / 2), Math.ceil(texShape[1] / 2)];
	    var valuesPerRow = Math.ceil(shape[1] / 2);
	    return "\n    vec4 " + funcName + "(int row, int col) {\n      vec2 uv = packedUVfrom2D(" + valuesPerRow + ", " + packedTexShape[0] + ", " + packedTexShape[1] + ", row, col);\n      return " + glsl.texture2D + "(" + texName + ", uv);\n    }\n  ";
	}
	function getSampler2D(inputInfo) {
	    var shape = inputInfo.shapeInfo.logicalShape;
	    var texName = inputInfo.name;
	    var funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
	    var texShape = inputInfo.shapeInfo.texShape;
	    if (texShape != null && util.arraysEqual(shape, texShape)) {
	        var texNumR_1 = texShape[0];
	        var texNumC_1 = texShape[1];
	        return "\n    float " + funcName + "(int row, int col) {\n      vec2 uv = (vec2(col, row) + halfCR) / vec2(" + texNumC_1 + ".0, " + texNumR_1 + ".0);\n      return sampleTexture(" + texName + ", uv);\n    }\n  ";
	    }
	    var _a = util.squeezeShape(shape), newShape = _a.newShape, keptDims = _a.keptDims;
	    var squeezedShape = newShape;
	    if (squeezedShape.length < shape.length) {
	        var newInputInfo = squeezeInputInfo(inputInfo, squeezedShape);
	        var params = ['row', 'col'];
	        return "\n      " + getSamplerFromInInfo(newInputInfo) + "\n      float " + funcName + "(int row, int col) {\n        return " + funcName + "(" + getSqueezedParams(params, keptDims) + ");\n      }\n    ";
	    }
	    if (inputInfo.shapeInfo.isUniform) {
	        // Uniform arrays will be less than 65505 (no risk of float16 overflow).
	        return "\n      float " + funcName + "(int row, int col) {\n        int index = round(dot(vec2(row, col), vec2(" + shape[1] + ", 1)));\n        " + getUniformSampler(inputInfo) + "\n      }\n    ";
	    }
	    var texNumR = texShape[0];
	    var texNumC = texShape[1];
	    var offset = getFlatOffsetUniformName(texName);
	    if (texNumC === 1) {
	        // index is used directly as physical (no risk of float16 overflow).
	        return "\n    float " + funcName + "(int row, int col) {\n      float index = dot(vec3(row, col, " + offset + "), vec3(" + shape[1] + ", 1, 1));\n      vec2 uv = vec2(0.5, (index + 0.5) / " + texNumR + ".0);\n      return sampleTexture(" + texName + ", uv);\n    }\n  ";
	    }
	    if (texNumR === 1) {
	        // index is used directly as physical (no risk of float16 overflow).
	        return "\n    float " + funcName + "(int row, int col) {\n      float index = dot(vec3(row, col, " + offset + "), vec3(" + shape[1] + ", 1, 1));\n      vec2 uv = vec2((index + 0.5) / " + texNumC + ".0, 0.5);\n      return sampleTexture(" + texName + ", uv);\n    }\n  ";
	    }
	    return "\n  float " + funcName + "(int row, int col) {\n    // Explicitly use integer operations as dot() only works on floats.\n    int index = row * " + shape[1] + " + col + " + offset + ";\n    vec2 uv = uvFromFlat(" + texNumR + ", " + texNumC + ", index);\n    return sampleTexture(" + texName + ", uv);\n  }\n";
	}
	function getPackedSampler3D(inputInfo) {
	    var shape = inputInfo.shapeInfo.logicalShape;
	    var texName = inputInfo.name;
	    var funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
	    var texShape = inputInfo.shapeInfo.texShape;
	    var packedTexShape = [Math.ceil(texShape[0] / 2), Math.ceil(texShape[1] / 2)];
	    if (shape[0] === 1) {
	        var squeezedShape = shape.slice(1);
	        var keptDims = [1, 2];
	        var newInputInfo = squeezeInputInfo(inputInfo, squeezedShape);
	        var params = ['b', 'row', 'col'];
	        return "\n        " + getPackedSamplerFromInInfo(newInputInfo) + "\n        vec4 " + funcName + "(int b, int row, int col) {\n          return " + funcName + "(" + getSqueezedParams(params, keptDims) + ");\n        }\n      ";
	    }
	    var texNumR = packedTexShape[0];
	    var texNumC = packedTexShape[1];
	    var valuesPerRow = Math.ceil(shape[2] / 2);
	    var texelsInBatch = valuesPerRow * Math.ceil(shape[1] / 2);
	    var glsl = glsl_version_1.getGlslDifferences();
	    return "\n    vec4 " + funcName + "(int b, int row, int col) {\n      vec2 uv = packedUVfrom3D(\n        " + texNumR + ", " + texNumC + ", " + texelsInBatch + ", " + valuesPerRow + ", b, row, col);\n      return " + glsl.texture2D + "(" + texName + ", uv);\n    }\n  ";
	}
	function getSampler3D(inputInfo) {
	    var shape = inputInfo.shapeInfo.logicalShape;
	    var texName = inputInfo.name;
	    var funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
	    var stride0 = shape[1] * shape[2];
	    var stride1 = shape[2];
	    var _a = util.squeezeShape(shape), newShape = _a.newShape, keptDims = _a.keptDims;
	    var squeezedShape = newShape;
	    if (squeezedShape.length < shape.length) {
	        var newInputInfo = squeezeInputInfo(inputInfo, squeezedShape);
	        var params = ['row', 'col', 'depth'];
	        return "\n        " + getSamplerFromInInfo(newInputInfo) + "\n        float " + funcName + "(int row, int col, int depth) {\n          return " + funcName + "(" + getSqueezedParams(params, keptDims) + ");\n        }\n      ";
	    }
	    if (inputInfo.shapeInfo.isUniform) {
	        // Uniform arrays will be less than 65505 (no risk of float16 overflow).
	        return "\n      float " + funcName + "(int row, int col, int depth) {\n        int index = round(dot(vec3(row, col, depth),\n                          vec3(" + stride0 + ", " + stride1 + ", 1)));\n        " + getUniformSampler(inputInfo) + "\n      }\n    ";
	    }
	    var texShape = inputInfo.shapeInfo.texShape;
	    var texNumR = texShape[0];
	    var texNumC = texShape[1];
	    var flatOffset = inputInfo.shapeInfo.flatOffset;
	    if (texNumC === stride0 && flatOffset == null) {
	        // texC is used directly as physical (no risk of float16 overflow).
	        return "\n        float " + funcName + "(int row, int col, int depth) {\n          float texR = float(row);\n          float texC = dot(vec2(col, depth), vec2(" + stride1 + ", 1));\n          vec2 uv = (vec2(texC, texR) + halfCR) /\n                     vec2(" + texNumC + ".0, " + texNumR + ".0);\n          return sampleTexture(" + texName + ", uv);\n        }\n      ";
	    }
	    if (texNumC === stride1 && flatOffset == null) {
	        // texR is used directly as physical (no risk of float16 overflow).
	        return "\n    float " + funcName + "(int row, int col, int depth) {\n      float texR = dot(vec2(row, col), vec2(" + shape[1] + ", 1));\n      float texC = float(depth);\n      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(" + texNumC + ".0, " + texNumR + ".0);\n      return sampleTexture(" + texName + ", uv);\n    }\n  ";
	    }
	    var offset = getFlatOffsetUniformName(texName);
	    return "\n      float " + funcName + "(int row, int col, int depth) {\n        // Explicitly use integer operations as dot() only works on floats.\n        int index = row * " + stride0 + " + col * " + stride1 + " + depth + " + offset + ";\n        vec2 uv = uvFromFlat(" + texNumR + ", " + texNumC + ", index);\n        return sampleTexture(" + texName + ", uv);\n      }\n  ";
	}
	function getPackedSamplerND(inputInfo) {
	    var shape = inputInfo.shapeInfo.logicalShape;
	    var rank = shape.length;
	    var texName = inputInfo.name;
	    var funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
	    var texShape = inputInfo.shapeInfo.texShape;
	    var packedTexShape = [Math.ceil(texShape[0] / 2), Math.ceil(texShape[1] / 2)];
	    var texNumR = packedTexShape[0];
	    var texNumC = packedTexShape[1];
	    var valuesPerRow = Math.ceil(shape[rank - 1] / 2);
	    var texelsInBatch = valuesPerRow * Math.ceil(shape[rank - 2] / 2);
	    var params = "int b, int row, int col";
	    var index = "b * " + texelsInBatch + " + (row / 2) * " + valuesPerRow + " + (col / 2)";
	    for (var b = 2; b < rank - 1; b++) {
	        params = "int b" + b + ", " + params;
	        texelsInBatch *= shape[rank - b - 1];
	        index = "b" + b + " * " + texelsInBatch + " + " + index;
	    }
	    var glsl = glsl_version_1.getGlslDifferences();
	    return "\n    vec4 " + funcName + "(" + params + ") {\n      int index = " + index + ";\n      int texR = index / " + texNumC + ";\n      int texC = index - texR * " + texNumC + ";\n      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(" + texNumC + ", " + texNumR + ");\n      return " + glsl.texture2D + "(" + texName + ", uv);\n    }\n  ";
	}
	function getSampler4D(inputInfo) {
	    var shape = inputInfo.shapeInfo.logicalShape;
	    var texName = inputInfo.name;
	    var funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
	    var stride2 = shape[3];
	    var stride1 = shape[2] * stride2;
	    var stride0 = shape[1] * stride1;
	    var _a = util.squeezeShape(shape), newShape = _a.newShape, keptDims = _a.keptDims;
	    if (newShape.length < shape.length) {
	        var newInputInfo = squeezeInputInfo(inputInfo, newShape);
	        var params = ['row', 'col', 'depth', 'depth2'];
	        return "\n      " + getSamplerFromInInfo(newInputInfo) + "\n      float " + funcName + "(int row, int col, int depth, int depth2) {\n        return " + funcName + "(" + getSqueezedParams(params, keptDims) + ");\n      }\n    ";
	    }
	    if (inputInfo.shapeInfo.isUniform) {
	        // Uniform arrays will be less than 65505 (no risk of float16 overflow).
	        return "\n      float " + funcName + "(int row, int col, int depth, int depth2) {\n        int index = round(dot(vec4(row, col, depth, depth2),\n                          vec4(" + stride0 + ", " + stride1 + ", " + stride2 + ", 1)));\n        " + getUniformSampler(inputInfo) + "\n      }\n    ";
	    }
	    var flatOffset = inputInfo.shapeInfo.flatOffset;
	    var texShape = inputInfo.shapeInfo.texShape;
	    var texNumR = texShape[0];
	    var texNumC = texShape[1];
	    if (texNumC === stride0 && flatOffset == null) {
	        // texC is used directly as physical (no risk of float16 overflow).
	        return "\n      float " + funcName + "(int row, int col, int depth, int depth2) {\n        float texR = float(row);\n        float texC =\n            dot(vec3(col, depth, depth2),\n                vec3(" + stride1 + ", " + stride2 + ", 1));\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2(" + texNumC + ".0, " + texNumR + ".0);\n        return sampleTexture(" + texName + ", uv);\n      }\n    ";
	    }
	    if (texNumC === stride2 && flatOffset == null) {
	        // texR is used directly as physical (no risk of float16 overflow).
	        return "\n      float " + funcName + "(int row, int col, int depth, int depth2) {\n        float texR = dot(vec3(row, col, depth),\n                         vec3(" + shape[1] * shape[2] + ", " + shape[2] + ", 1));\n        float texC = float(depth2);\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2(" + texNumC + ".0, " + texNumR + ".0);\n        return sampleTexture(" + texName + ", uv);\n      }\n    ";
	    }
	    var offset = getFlatOffsetUniformName(texName);
	    return "\n    float " + funcName + "(int row, int col, int depth, int depth2) {\n      // Explicitly use integer operations as dot() only works on floats.\n      int index = row * " + stride0 + " + col * " + stride1 + " +\n          depth * " + stride2 + " + depth2;\n      vec2 uv = uvFromFlat(" + texNumR + ", " + texNumC + ", index + " + offset + ");\n      return sampleTexture(" + texName + ", uv);\n    }\n  ";
	}
	function getSampler5D(inputInfo) {
	    var shape = inputInfo.shapeInfo.logicalShape;
	    var texName = inputInfo.name;
	    var funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
	    var stride3 = shape[4];
	    var stride2 = shape[3] * stride3;
	    var stride1 = shape[2] * stride2;
	    var stride0 = shape[1] * stride1;
	    var _a = util.squeezeShape(shape), newShape = _a.newShape, keptDims = _a.keptDims;
	    if (newShape.length < shape.length) {
	        var newInputInfo = squeezeInputInfo(inputInfo, newShape);
	        var params = ['row', 'col', 'depth', 'depth2', 'depth3'];
	        return "\n      " + getSamplerFromInInfo(newInputInfo) + "\n      float " + funcName + "(int row, int col, int depth, int depth2, int depth3) {\n        return " + funcName + "(" + getSqueezedParams(params, keptDims) + ");\n      }\n    ";
	    }
	    if (inputInfo.shapeInfo.isUniform) {
	        // Uniform arrays will be less than 65505 (no risk of float16 overflow).
	        return "\n      float " + funcName + "(int row, int col, int depth, int depth2, int depth3) {\n        float index = dot(\n          vec4(row, col, depth, depth2),\n          vec4(" + stride0 + ", " + stride1 + ", " + stride2 + ", " + stride3 + ")) +\n          depth3;\n        " + getUniformSampler(inputInfo) + "\n      }\n    ";
	    }
	    var flatOffset = inputInfo.shapeInfo.flatOffset;
	    var texShape = inputInfo.shapeInfo.texShape;
	    var texNumR = texShape[0];
	    var texNumC = texShape[1];
	    if (texNumC === stride0 && flatOffset == null) {
	        // texC is used directly as physical (no risk of float16 overflow).
	        return "\n      float " + funcName + "(int row, int col, int depth, int depth2, int depth3) {\n        int texR = row;\n        float texC = dot(vec4(col, depth, depth2, depth3),\n                         vec4(" + stride1 + ", " + stride2 + ", " + stride3 + ", 1));\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2(" + texNumC + ".0, " + texNumR + ".0);\n        return sampleTexture(" + texName + ", uv);\n      }\n    ";
	    }
	    if (texNumC === stride3 && flatOffset == null) {
	        // texR is used directly as physical (no risk of float16 overflow).
	        return "\n      float " + funcName + "(int row, int col, int depth, int depth2, int depth3) {\n        float texR = dot(\n          vec4(row, col, depth, depth2),\n          vec4(" + shape[1] * shape[2] * shape[3] + ",\n               " + shape[2] * shape[3] + ", " + shape[3] + ", 1));\n        int texC = depth3;\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2(" + texNumC + ".0, " + texNumR + ".0);\n        return sampleTexture(" + texName + ", uv);\n      }\n    ";
	    }
	    var offset = getFlatOffsetUniformName(texName);
	    return "\n    float " + funcName + "(int row, int col, int depth, int depth2, int depth3) {\n      // Explicitly use integer operations as dot() only works on floats.\n      int index = row * " + stride0 + " + col * " + stride1 + " + depth * " + stride2 + " +\n          depth2 * " + stride3 + " + depth3 + " + offset + ";\n      vec2 uv = uvFromFlat(" + texNumR + ", " + texNumC + ", index);\n      return sampleTexture(" + texName + ", uv);\n    }\n  ";
	}
	function getSampler6D(inputInfo) {
	    var shape = inputInfo.shapeInfo.logicalShape;
	    var texName = inputInfo.name;
	    var funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
	    var _a = util.squeezeShape(shape), newShape = _a.newShape, keptDims = _a.keptDims;
	    if (newShape.length < shape.length) {
	        var newInputInfo = squeezeInputInfo(inputInfo, newShape);
	        var params = ['row', 'col', 'depth', 'depth2', 'depth3', 'depth4'];
	        return "\n      " + getSamplerFromInInfo(newInputInfo) + "\n      float " + funcName + "(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        return " + funcName + "(" + getSqueezedParams(params, keptDims) + ");\n      }\n    ";
	    }
	    var stride4 = shape[5];
	    var stride3 = shape[4] * stride4;
	    var stride2 = shape[3] * stride3;
	    var stride1 = shape[2] * stride2;
	    var stride0 = shape[1] * stride1;
	    if (inputInfo.shapeInfo.isUniform) {
	        // Uniform arrays will be less than 65505 (no risk of float16 overflow).
	        return "\n      float " + funcName + "(int row, int col, int depth,\n                  int depth2, int depth3, int depth4) {\n        int index = round(dot(\n          vec4(row, col, depth, depth2),\n          vec4(" + stride0 + ", " + stride1 + ", " + stride2 + ", " + stride3 + ")) +\n          dot(\n            vec2(depth3, depth4),\n            vec2(" + stride4 + ", 1)));\n        " + getUniformSampler(inputInfo) + "\n      }\n    ";
	    }
	    var flatOffset = inputInfo.shapeInfo.flatOffset;
	    var texShape = inputInfo.shapeInfo.texShape;
	    var texNumR = texShape[0];
	    var texNumC = texShape[1];
	    if (texNumC === stride0 && flatOffset == null) {
	        // texC is used directly as physical (no risk of float16 overflow).
	        return "\n      float " + funcName + "(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        int texR = row;\n        float texC = dot(vec4(col, depth, depth2, depth3),\n          vec4(" + stride1 + ", " + stride2 + ", " + stride3 + ", " + stride4 + ")) +\n               float(depth4);\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2(" + texNumC + ".0, " + texNumR + ".0);\n        return sampleTexture(" + texName + ", uv);\n      }\n    ";
	    }
	    if (texNumC === stride4 && flatOffset == null) {
	        // texR is used directly as physical (no risk of float16 overflow).
	        return "\n      float " + funcName + "(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        float texR = dot(vec4(row, col, depth, depth2),\n          vec4(" + shape[1] * shape[2] * shape[3] * shape[4] + ",\n               " + shape[2] * shape[3] * shape[4] + ",\n               " + shape[3] * shape[4] + ",\n               " + shape[4] + ")) + float(depth3);\n        int texC = depth4;\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2(" + texNumC + ".0, " + texNumR + ".0);\n        return sampleTexture(" + texName + ", uv);\n      }\n    ";
	    }
	    var offset = getFlatOffsetUniformName(texName);
	    return "\n    float " + funcName + "(int row, int col, int depth,\n                  int depth2, int depth3, int depth4) {\n      // Explicitly use integer operations as dot() only works on floats.\n      int index = row * " + stride0 + " + col * " + stride1 + " + depth * " + stride2 + " +\n          depth2 * " + stride3 + " + depth3 * " + stride4 + " + depth4 + " + offset + ";\n      vec2 uv = uvFromFlat(" + texNumR + ", " + texNumC + ", index);\n      return sampleTexture(" + texName + ", uv);\n    }\n  ";
	}
	function getUniformSampler(inputInfo) {
	    var texName = inputInfo.name;
	    var inSize = util.sizeFromShape(inputInfo.shapeInfo.logicalShape);
	    if (inSize < 2) {
	        return "return " + texName + ";";
	    }
	    return "\n    for (int i = 0; i < " + inSize + "; i++) {\n      if (i == index) {\n        return " + texName + "[i];\n      }\n    }\n  ";
	}
	function getPackedSamplerAtOutputCoords(inputInfo, outShapeInfo) {
	    var texName = inputInfo.name;
	    var texFuncSnippet = texName.charAt(0).toUpperCase() + texName.slice(1);
	    var funcName = 'get' + texFuncSnippet + 'AtOutCoords';
	    var inRank = inputInfo.shapeInfo.logicalShape.length;
	    var outRank = outShapeInfo.logicalShape.length;
	    var broadcastDims = broadcast_util_1.getBroadcastDims(inputInfo.shapeInfo.logicalShape, outShapeInfo.logicalShape);
	    var type = getCoordsDataType(outRank);
	    var rankDiff = outRank - inRank;
	    var coordsSnippet;
	    var fields = ['x', 'y', 'z', 'w', 'u', 'v'];
	    if (inRank === 0) {
	        coordsSnippet = '';
	    }
	    else if (outRank < 2 && broadcastDims.length >= 1) {
	        coordsSnippet = 'coords = 0;';
	    }
	    else {
	        coordsSnippet =
	            broadcastDims.map(function (d) { return "coords." + fields[d + rankDiff] + " = 0;"; })
	                .join('\n');
	    }
	    var unpackedCoordsSnippet = '';
	    if (outRank < 2 && inRank > 0) {
	        unpackedCoordsSnippet = 'coords';
	    }
	    else {
	        unpackedCoordsSnippet = inputInfo.shapeInfo.logicalShape
	            .map(function (s, i) { return "coords." + fields[i + rankDiff]; })
	            .join(', ');
	    }
	    var output = "return outputValue;";
	    var inSize = util.sizeFromShape(inputInfo.shapeInfo.logicalShape);
	    var isInputScalar = inSize === 1;
	    var outSize = util.sizeFromShape(outShapeInfo.logicalShape);
	    var isOutputScalar = outSize === 1;
	    if (inRank === 1 && !isInputScalar && !isOutputScalar) {
	        output = "\n      return vec4(outputValue.xy, outputValue.xy);\n    ";
	    }
	    else if (isInputScalar && !isOutputScalar) {
	        if (outRank === 1) {
	            output = "\n        return vec4(outputValue.x, outputValue.x, 0., 0.);\n      ";
	        }
	        else {
	            output = "\n        return vec4(outputValue.x);\n      ";
	        }
	    }
	    else if (broadcastDims.length) {
	        var rows = inRank - 2;
	        var cols = inRank - 1;
	        if (broadcastDims.indexOf(rows) > -1 && broadcastDims.indexOf(cols) > -1) {
	            output = "return vec4(outputValue.x);";
	        }
	        else if (broadcastDims.indexOf(rows) > -1) {
	            output = "return vec4(outputValue.x, outputValue.y, " +
	                "outputValue.x, outputValue.y);";
	        }
	        else if (broadcastDims.indexOf(cols) > -1) {
	            output = "return vec4(outputValue.xx, outputValue.zz);";
	        }
	    }
	    return "\n    vec4 " + funcName + "() {\n      " + type + " coords = getOutputCoords();\n      " + coordsSnippet + "\n      vec4 outputValue = get" + texFuncSnippet + "(" + unpackedCoordsSnippet + ");\n      " + output + "\n    }\n  ";
	}
	function getSamplerAtOutputCoords(inputInfo, outShapeInfo) {
	    var texName = inputInfo.name;
	    var texFuncSnippet = texName.charAt(0).toUpperCase() + texName.slice(1);
	    var funcName = 'get' + texFuncSnippet + 'AtOutCoords';
	    var outTexShape = outShapeInfo.texShape;
	    var inTexShape = inputInfo.shapeInfo.texShape;
	    var inRank = inputInfo.shapeInfo.logicalShape.length;
	    var outRank = outShapeInfo.logicalShape.length;
	    if (!inputInfo.shapeInfo.isUniform && inRank === outRank &&
	        inputInfo.shapeInfo.flatOffset == null &&
	        util.arraysEqual(inTexShape, outTexShape)) {
	        return "\n      float " + funcName + "() {\n        return sampleTexture(" + texName + ", resultUV);\n      }\n    ";
	    }
	    var type = getCoordsDataType(outRank);
	    var broadcastDims = broadcast_util_1.getBroadcastDims(inputInfo.shapeInfo.logicalShape, outShapeInfo.logicalShape);
	    var rankDiff = outRank - inRank;
	    var coordsSnippet;
	    var fields = ['x', 'y', 'z', 'w', 'u', 'v'];
	    if (inRank === 0) {
	        coordsSnippet = '';
	    }
	    else if (outRank < 2 && broadcastDims.length >= 1) {
	        coordsSnippet = 'coords = 0;';
	    }
	    else {
	        coordsSnippet =
	            broadcastDims.map(function (d) { return "coords." + fields[d + rankDiff] + " = 0;"; })
	                .join('\n');
	    }
	    var unpackedCoordsSnippet = '';
	    if (outRank < 2 && inRank > 0) {
	        unpackedCoordsSnippet = 'coords';
	    }
	    else {
	        unpackedCoordsSnippet = inputInfo.shapeInfo.logicalShape
	            .map(function (s, i) { return "coords." + fields[i + rankDiff]; })
	            .join(', ');
	    }
	    return "\n    float " + funcName + "() {\n      " + type + " coords = getOutputCoords();\n      " + coordsSnippet + "\n      return get" + texFuncSnippet + "(" + unpackedCoordsSnippet + ");\n    }\n  ";
	}
	function getCoordsDataType(rank) {
	    if (rank <= 1) {
	        return 'int';
	    }
	    else if (rank === 2) {
	        return 'ivec2';
	    }
	    else if (rank === 3) {
	        return 'ivec3';
	    }
	    else if (rank === 4) {
	        return 'ivec4';
	    }
	    else if (rank === 5) {
	        return 'ivec5';
	    }
	    else if (rank === 6) {
	        return 'ivec6';
	    }
	    else {
	        throw Error("GPU for rank " + rank + " is not yet supported");
	    }
	}
	exports.getCoordsDataType = getCoordsDataType;
	/** Returns a new input info (a copy) that has a squeezed logical shape. */
	function squeezeInputInfo(inInfo, squeezedShape) {
	    // Deep copy.
	    var newInputInfo = JSON.parse(JSON.stringify(inInfo));
	    newInputInfo.shapeInfo.logicalShape = squeezedShape;
	    return newInputInfo;
	}
	function getSqueezedParams(params, keptDims) {
	    return keptDims.map(function (d) { return params[d]; }).join(', ');
	}
	//# sourceMappingURL=shader_compiler.js.map

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withAuthControl(WrappedComponent) {
	
	    return function (_React$Component) {
	        _inherits(_class, _React$Component);
	
	        function _class() {
	            _classCallCheck(this, _class);
	
	            return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	        }
	
	        _createClass(_class, [{
	            key: 'componentDidMount',
	            value: function componentDidMount() {
	                var jwtToken = sessionStorage.getItem('jwtToken');
	                var endpoint = sessionStorage.getItem('endpoint');
	                if (jwtToken === null || endpoint === null) {
	                    _reactRouter.browserHistory.push('/');
	                } else {
	                    if (endpoint !== this.props.location.pathname) {
	                        _reactRouter.browserHistory.push(endpoint);
	                    }
	                }
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                return _react2.default.createElement(WrappedComponent, this.props);
	            }
	        }]);
	
	        return _class;
	    }(_react2.default.Component);
	}
	
	exports.default = withAuthControl;

/***/ },
/* 43 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var DOMProperty = __webpack_require__(180);
	var ReactDOMComponentFlags = __webpack_require__(880);
	
	var invariant = __webpack_require__(20);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 45 */
/***/ function(module, exports) {

	function _interopRequireDefault(e) {
	  return e && e.__esModule ? e : {
	    "default": e
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 47 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	tslib_1.__exportStar(__webpack_require__(573), exports);
	tslib_1.__exportStar(__webpack_require__(165), exports);
	tslib_1.__exportStar(__webpack_require__(210), exports);
	tslib_1.__exportStar(__webpack_require__(97), exports);
	tslib_1.__exportStar(__webpack_require__(166), exports);
	tslib_1.__exportStar(__webpack_require__(574), exports);
	tslib_1.__exportStar(__webpack_require__(378), exports);
	tslib_1.__exportStar(__webpack_require__(575), exports);
	tslib_1.__exportStar(__webpack_require__(576), exports);
	tslib_1.__exportStar(__webpack_require__(577), exports);
	tslib_1.__exportStar(__webpack_require__(379), exports);
	tslib_1.__exportStar(__webpack_require__(380), exports);
	tslib_1.__exportStar(__webpack_require__(1441), exports);
	tslib_1.__exportStar(__webpack_require__(578), exports);
	//# sourceMappingURL=index.js.map

/***/ },
/* 49 */,
/* 50 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports['default'] = createChainedFunction;
	module.exports = exports['default'];

/***/ },
/* 51 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CalendarDayPhrases = exports.DayPickerNavigationPhrases = exports.DayPickerKeyboardShortcutsPhrases = exports.DayPickerPhrases = exports.SingleDatePickerInputPhrases = exports.SingleDatePickerPhrases = exports.DateRangePickerInputPhrases = exports.DateRangePickerPhrases = exports["default"] = void 0;
	var calendarLabel = 'Calendar';
	var closeDatePicker = 'Close';
	var focusStartDate = 'Interact with the calendar and add the check-in date for your trip.';
	var clearDate = 'Clear Date';
	var clearDates = 'Clear Dates';
	var jumpToPrevMonth = 'Move backward to switch to the previous month.';
	var jumpToNextMonth = 'Move forward to switch to the next month.';
	var keyboardShortcuts = 'Keyboard Shortcuts';
	var showKeyboardShortcutsPanel = 'Open the keyboard shortcuts panel.';
	var hideKeyboardShortcutsPanel = 'Close the shortcuts panel.';
	var openThisPanel = 'Open this panel.';
	var enterKey = 'Enter key';
	var leftArrowRightArrow = 'Right and left arrow keys';
	var upArrowDownArrow = 'up and down arrow keys';
	var pageUpPageDown = 'page up and page down keys';
	var homeEnd = 'Home and end keys';
	var escape = 'Escape key';
	var questionMark = 'Question mark';
	var selectFocusedDate = 'Select the date in focus.';
	var moveFocusByOneDay = 'Move backward (left) and forward (right) by one day.';
	var moveFocusByOneWeek = 'Move backward (up) and forward (down) by one week.';
	var moveFocusByOneMonth = 'Switch months.';
	var moveFocustoStartAndEndOfWeek = 'Go to the first or last day of a week.';
	var returnFocusToInput = 'Return to the date input field.';
	var keyboardNavigationInstructions = "Press the down arrow key to interact with the calendar and\n  select a date. Press the question mark key to get the keyboard shortcuts for changing dates.";
	
	var chooseAvailableStartDate = function chooseAvailableStartDate(_ref) {
	  var date = _ref.date;
	  return "Choose ".concat(date, " as your check-in date. It\u2019s available.");
	};
	
	var chooseAvailableEndDate = function chooseAvailableEndDate(_ref2) {
	  var date = _ref2.date;
	  return "Choose ".concat(date, " as your check-out date. It\u2019s available.");
	};
	
	var chooseAvailableDate = function chooseAvailableDate(_ref3) {
	  var date = _ref3.date;
	  return date;
	};
	
	var dateIsUnavailable = function dateIsUnavailable(_ref4) {
	  var date = _ref4.date;
	  return "Not available. ".concat(date);
	};
	
	var dateIsSelected = function dateIsSelected(_ref5) {
	  var date = _ref5.date;
	  return "Selected. ".concat(date);
	};
	
	var dateIsSelectedAsStartDate = function dateIsSelectedAsStartDate(_ref6) {
	  var date = _ref6.date;
	  return "Selected as start date. ".concat(date);
	};
	
	var dateIsSelectedAsEndDate = function dateIsSelectedAsEndDate(_ref7) {
	  var date = _ref7.date;
	  return "Selected as end date. ".concat(date);
	};
	
	var _default = {
	  calendarLabel: calendarLabel,
	  closeDatePicker: closeDatePicker,
	  focusStartDate: focusStartDate,
	  clearDate: clearDate,
	  clearDates: clearDates,
	  jumpToPrevMonth: jumpToPrevMonth,
	  jumpToNextMonth: jumpToNextMonth,
	  keyboardShortcuts: keyboardShortcuts,
	  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
	  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	  openThisPanel: openThisPanel,
	  enterKey: enterKey,
	  leftArrowRightArrow: leftArrowRightArrow,
	  upArrowDownArrow: upArrowDownArrow,
	  pageUpPageDown: pageUpPageDown,
	  homeEnd: homeEnd,
	  escape: escape,
	  questionMark: questionMark,
	  selectFocusedDate: selectFocusedDate,
	  moveFocusByOneDay: moveFocusByOneDay,
	  moveFocusByOneWeek: moveFocusByOneWeek,
	  moveFocusByOneMonth: moveFocusByOneMonth,
	  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
	  returnFocusToInput: returnFocusToInput,
	  keyboardNavigationInstructions: keyboardNavigationInstructions,
	  chooseAvailableStartDate: chooseAvailableStartDate,
	  chooseAvailableEndDate: chooseAvailableEndDate,
	  dateIsUnavailable: dateIsUnavailable,
	  dateIsSelected: dateIsSelected,
	  dateIsSelectedAsStartDate: dateIsSelectedAsStartDate,
	  dateIsSelectedAsEndDate: dateIsSelectedAsEndDate
	};
	exports["default"] = _default;
	var DateRangePickerPhrases = {
	  calendarLabel: calendarLabel,
	  closeDatePicker: closeDatePicker,
	  clearDates: clearDates,
	  focusStartDate: focusStartDate,
	  jumpToPrevMonth: jumpToPrevMonth,
	  jumpToNextMonth: jumpToNextMonth,
	  keyboardShortcuts: keyboardShortcuts,
	  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
	  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	  openThisPanel: openThisPanel,
	  enterKey: enterKey,
	  leftArrowRightArrow: leftArrowRightArrow,
	  upArrowDownArrow: upArrowDownArrow,
	  pageUpPageDown: pageUpPageDown,
	  homeEnd: homeEnd,
	  escape: escape,
	  questionMark: questionMark,
	  selectFocusedDate: selectFocusedDate,
	  moveFocusByOneDay: moveFocusByOneDay,
	  moveFocusByOneWeek: moveFocusByOneWeek,
	  moveFocusByOneMonth: moveFocusByOneMonth,
	  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
	  returnFocusToInput: returnFocusToInput,
	  keyboardNavigationInstructions: keyboardNavigationInstructions,
	  chooseAvailableStartDate: chooseAvailableStartDate,
	  chooseAvailableEndDate: chooseAvailableEndDate,
	  dateIsUnavailable: dateIsUnavailable,
	  dateIsSelected: dateIsSelected,
	  dateIsSelectedAsStartDate: dateIsSelectedAsStartDate,
	  dateIsSelectedAsEndDate: dateIsSelectedAsEndDate
	};
	exports.DateRangePickerPhrases = DateRangePickerPhrases;
	var DateRangePickerInputPhrases = {
	  focusStartDate: focusStartDate,
	  clearDates: clearDates,
	  keyboardNavigationInstructions: keyboardNavigationInstructions
	};
	exports.DateRangePickerInputPhrases = DateRangePickerInputPhrases;
	var SingleDatePickerPhrases = {
	  calendarLabel: calendarLabel,
	  closeDatePicker: closeDatePicker,
	  clearDate: clearDate,
	  jumpToPrevMonth: jumpToPrevMonth,
	  jumpToNextMonth: jumpToNextMonth,
	  keyboardShortcuts: keyboardShortcuts,
	  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
	  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	  openThisPanel: openThisPanel,
	  enterKey: enterKey,
	  leftArrowRightArrow: leftArrowRightArrow,
	  upArrowDownArrow: upArrowDownArrow,
	  pageUpPageDown: pageUpPageDown,
	  homeEnd: homeEnd,
	  escape: escape,
	  questionMark: questionMark,
	  selectFocusedDate: selectFocusedDate,
	  moveFocusByOneDay: moveFocusByOneDay,
	  moveFocusByOneWeek: moveFocusByOneWeek,
	  moveFocusByOneMonth: moveFocusByOneMonth,
	  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
	  returnFocusToInput: returnFocusToInput,
	  keyboardNavigationInstructions: keyboardNavigationInstructions,
	  chooseAvailableDate: chooseAvailableDate,
	  dateIsUnavailable: dateIsUnavailable,
	  dateIsSelected: dateIsSelected
	};
	exports.SingleDatePickerPhrases = SingleDatePickerPhrases;
	var SingleDatePickerInputPhrases = {
	  clearDate: clearDate,
	  keyboardNavigationInstructions: keyboardNavigationInstructions
	};
	exports.SingleDatePickerInputPhrases = SingleDatePickerInputPhrases;
	var DayPickerPhrases = {
	  calendarLabel: calendarLabel,
	  jumpToPrevMonth: jumpToPrevMonth,
	  jumpToNextMonth: jumpToNextMonth,
	  keyboardShortcuts: keyboardShortcuts,
	  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
	  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	  openThisPanel: openThisPanel,
	  enterKey: enterKey,
	  leftArrowRightArrow: leftArrowRightArrow,
	  upArrowDownArrow: upArrowDownArrow,
	  pageUpPageDown: pageUpPageDown,
	  homeEnd: homeEnd,
	  escape: escape,
	  questionMark: questionMark,
	  selectFocusedDate: selectFocusedDate,
	  moveFocusByOneDay: moveFocusByOneDay,
	  moveFocusByOneWeek: moveFocusByOneWeek,
	  moveFocusByOneMonth: moveFocusByOneMonth,
	  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
	  returnFocusToInput: returnFocusToInput,
	  chooseAvailableStartDate: chooseAvailableStartDate,
	  chooseAvailableEndDate: chooseAvailableEndDate,
	  chooseAvailableDate: chooseAvailableDate,
	  dateIsUnavailable: dateIsUnavailable,
	  dateIsSelected: dateIsSelected,
	  dateIsSelectedAsStartDate: dateIsSelectedAsStartDate,
	  dateIsSelectedAsEndDate: dateIsSelectedAsEndDate
	};
	exports.DayPickerPhrases = DayPickerPhrases;
	var DayPickerKeyboardShortcutsPhrases = {
	  keyboardShortcuts: keyboardShortcuts,
	  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
	  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	  openThisPanel: openThisPanel,
	  enterKey: enterKey,
	  leftArrowRightArrow: leftArrowRightArrow,
	  upArrowDownArrow: upArrowDownArrow,
	  pageUpPageDown: pageUpPageDown,
	  homeEnd: homeEnd,
	  escape: escape,
	  questionMark: questionMark,
	  selectFocusedDate: selectFocusedDate,
	  moveFocusByOneDay: moveFocusByOneDay,
	  moveFocusByOneWeek: moveFocusByOneWeek,
	  moveFocusByOneMonth: moveFocusByOneMonth,
	  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
	  returnFocusToInput: returnFocusToInput
	};
	exports.DayPickerKeyboardShortcutsPhrases = DayPickerKeyboardShortcutsPhrases;
	var DayPickerNavigationPhrases = {
	  jumpToPrevMonth: jumpToPrevMonth,
	  jumpToNextMonth: jumpToNextMonth
	};
	exports.DayPickerNavigationPhrases = DayPickerNavigationPhrases;
	var CalendarDayPhrases = {
	  chooseAvailableDate: chooseAvailableDate,
	  dateIsUnavailable: dateIsUnavailable,
	  dateIsSelected: dateIsSelected,
	  dateIsSelectedAsStartDate: dateIsSelectedAsStartDate,
	  dateIsSelectedAsEndDate: dateIsSelectedAsEndDate
	};
	exports.CalendarDayPhrases = CalendarDayPhrases;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1843);


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function TopScrolleable(WrappedComponent) {
	    // ...and returns another component...
	    return function (_React$Component) {
	        _inherits(_class, _React$Component);
	
	        function _class() {
	            _classCallCheck(this, _class);
	
	            return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	        }
	
	        _createClass(_class, [{
	            key: 'componentWillMount',
	            value: function componentWillMount() {
	                window.scrollTo(0, 0);
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                // ... and renders the wrapped component with the fresh data!
	                // Notice that we pass through any additional props
	                return _react2.default.createElement(WrappedComponent, this.props);
	            }
	        }]);
	
	        return _class;
	    }(_react2.default.Component);
	}
	
	exports.default = TopScrolleable;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	tslib_1.__exportStar(__webpack_require__(586), exports);
	tslib_1.__exportStar(__webpack_require__(587), exports);
	tslib_1.__exportStar(__webpack_require__(265), exports);
	tslib_1.__exportStar(__webpack_require__(1446), exports);
	tslib_1.__exportStar(__webpack_require__(1445), exports);
	tslib_1.__exportStar(__webpack_require__(1447), exports);
	tslib_1.__exportStar(__webpack_require__(588), exports);
	tslib_1.__exportStar(__webpack_require__(1448), exports);
	tslib_1.__exportStar(__webpack_require__(266), exports);
	tslib_1.__exportStar(__webpack_require__(139), exports);
	tslib_1.__exportStar(__webpack_require__(267), exports);
	tslib_1.__exportStar(__webpack_require__(589), exports);
	tslib_1.__exportStar(__webpack_require__(590), exports);
	tslib_1.__exportStar(__webpack_require__(591), exports);
	tslib_1.__exportStar(__webpack_require__(383), exports);
	tslib_1.__exportStar(__webpack_require__(1449), exports);
	tslib_1.__exportStar(__webpack_require__(1450), exports);
	tslib_1.__exportStar(__webpack_require__(585), exports);
	tslib_1.__exportStar(__webpack_require__(268), exports);
	tslib_1.__exportStar(__webpack_require__(592), exports);
	//# sourceMappingURL=index.js.map

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var createBrowserEnv_1 = __webpack_require__(1455);
	var createFileSystem_1 = __webpack_require__(595);
	var createNodejsEnv_1 = __webpack_require__(1456);
	var isBrowser_1 = __webpack_require__(1457);
	var isNodejs_1 = __webpack_require__(1458);
	var environment;
	function getEnv() {
	    if (!environment) {
	        throw new Error('getEnv - environment is not defined, check isNodejs() and isBrowser()');
	    }
	    return environment;
	}
	function setEnv(env) {
	    environment = env;
	}
	function initialize() {
	    // check for isBrowser() first to prevent electron renderer process
	    // to be initialized with wrong environment due to isNodejs() returning true
	    if (isBrowser_1.isBrowser()) {
	        setEnv(createBrowserEnv_1.createBrowserEnv());
	    }
	    if (isNodejs_1.isNodejs()) {
	        setEnv(createNodejsEnv_1.createNodejsEnv());
	    }
	}
	function monkeyPatch(env) {
	    if (!environment) {
	        initialize();
	    }
	    if (!environment) {
	        throw new Error('monkeyPatch - environment is not defined, check isNodejs() and isBrowser()');
	    }
	    var _a = env.Canvas, Canvas = _a === void 0 ? environment.Canvas : _a, _b = env.Image, Image = _b === void 0 ? environment.Image : _b;
	    environment.Canvas = Canvas;
	    environment.Image = Image;
	    environment.createCanvasElement = env.createCanvasElement || (function () { return new Canvas(); });
	    environment.createImageElement = env.createImageElement || (function () { return new Image(); });
	    environment.ImageData = env.ImageData || environment.ImageData;
	    environment.Video = env.Video || environment.Video;
	    environment.fetch = env.fetch || environment.fetch;
	    environment.readFile = env.readFile || environment.readFile;
	}
	exports.env = {
	    getEnv: getEnv,
	    setEnv: setEnv,
	    initialize: initialize,
	    createBrowserEnv: createBrowserEnv_1.createBrowserEnv,
	    createFileSystem: createFileSystem_1.createFileSystem,
	    createNodejsEnv: createNodejsEnv_1.createNodejsEnv,
	    monkeyPatch: monkeyPatch,
	    isBrowser: isBrowser_1.isBrowser,
	    isNodejs: isNodejs_1.isNodejs
	};
	initialize();
	//# sourceMappingURL=index.js.map

/***/ },
/* 56 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var Size = exports.Size = {
	  LARGE: 'large',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	};
	
	var SIZE_MAP = exports.SIZE_MAP = {
	  large: 'lg',
	  medium: 'md',
	  small: 'sm',
	  xsmall: 'xs',
	  lg: 'lg',
	  md: 'md',
	  sm: 'sm',
	  xs: 'xs'
	};
	
	var DEVICE_SIZES = exports.DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
	
	var State = exports.State = {
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	};
	
	var Style = exports.Style = {
	  DEFAULT: 'default',
	  PRIMARY: 'primary',
	  LINK: 'link',
	  INVERSE: 'inverse'
	};

/***/ },
/* 57 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Returns the dimensions in the input shape that are broadcasted to
	 * produce the provided output shape.
	 *
	 * The returned dimensions are 0-indexed and sorted. An example:
	 * inShape = [4, 1, 3]
	 * outShape = [5, 4, 3, 3]
	 * result = [1]. Dimension 1 (2nd dimension of input) gets broadcasted 1 => 3.
	 */
	function getBroadcastDims(inShape, outShape) {
	    var inRank = inShape.length;
	    var dims = [];
	    for (var i = 0; i < inRank; i++) {
	        var dim = inRank - 1 - i;
	        var a = inShape[dim] || 1;
	        var b = outShape[outShape.length - 1 - i] || 1;
	        if (b > 1 && a === 1) {
	            dims.unshift(dim);
	        }
	    }
	    return dims;
	}
	exports.getBroadcastDims = getBroadcastDims;
	/**
	 * Returns the axes in the output space that should be reduced to produce
	 * the input space.
	 */
	function getReductionAxes(inShape, outShape) {
	    var result = [];
	    for (var i = 0; i < outShape.length; i++) {
	        var inDim = inShape[inShape.length - i - 1];
	        var outAxis = outShape.length - i - 1;
	        var outDim = outShape[outAxis];
	        if (inDim == null || (inDim === 1 && outDim > 1)) {
	            result.unshift(outAxis);
	        }
	    }
	    return result;
	}
	exports.getReductionAxes = getReductionAxes;
	function assertAndGetBroadcastShape(shapeA, shapeB) {
	    var result = [];
	    var l = Math.max(shapeA.length, shapeB.length);
	    for (var i = 0; i < l; i++) {
	        var a = shapeA[shapeA.length - i - 1];
	        if (a == null) {
	            a = 1;
	        }
	        var b = shapeB[shapeB.length - i - 1];
	        if (b == null) {
	            b = 1;
	        }
	        if (a === 1) {
	            result.unshift(b);
	        }
	        else if (b === 1) {
	            result.unshift(a);
	        }
	        else if (a !== b) {
	            var errMsg = "Operands could not be broadcast together with shapes " +
	                (shapeA + " and " + shapeB + ".");
	            throw Error(errMsg);
	        }
	        else {
	            result.unshift(a);
	        }
	    }
	    return result;
	}
	exports.assertAndGetBroadcastShape = assertAndGetBroadcastShape;
	//# sourceMappingURL=broadcast_util.js.map

/***/ },
/* 58 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 59 */,
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getPhrasePropTypes;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getPhrasePropTypes(defaultPhrases) {
	  return Object.keys(defaultPhrases).reduce(function (phrases, key) {
	    return _objectSpread({}, phrases, _defineProperty({}, key, _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].node])));
	  }, {});
	}

/***/ },
/* 61 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(1231)
	var ieee754 = __webpack_require__(1531)
	var isArray = __webpack_require__(1550)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62).Buffer, (function() { return this; }())))

/***/ },
/* 63 */
58,
/* 64 */
[2130, 345, 252, 63],
/* 65 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 66 */
[2130, 364, 257, 58],
/* 67 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(63);
	var core = __webpack_require__(43);
	var ctx = __webpack_require__(157);
	var hide = __webpack_require__(132);
	var has = __webpack_require__(131);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 69 */
43,
/* 70 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule shallowCompare
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return (
	    !shallowEqual(instance.props, nextProps) ||
	    !shallowEqual(instance.state, nextState)
	  );
	}
	
	module.exports = shallowCompare;


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only maps over children that are "valid components".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @return {object} Object containing the ordered map of results.
	 */
	function map(children, func, context) {
	  var index = 0;
	
	  return _react2['default'].Children.map(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return child;
	    }
	
	    return func.call(context, child, index++);
	  });
	}
	
	/**
	 * Iterates through children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for context.
	 */
	// TODO: This module should be ElementChildren, and should use named exports.
	
	function forEach(children, func, context) {
	  var index = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    func.call(context, child, index++);
	  });
	}
	
	/**
	 * Count the number of "valid components" in the Children container.
	 *
	 * @param {?*} children Children tree container.
	 * @returns {number}
	 */
	function count(children) {
	  var result = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    ++result;
	  });
	
	  return result;
	}
	
	/**
	 * Finds children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @returns {array} of children that meet the func return statement
	 */
	function filter(children, func, context) {
	  var index = 0;
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result.push(child);
	    }
	  });
	
	  return result;
	}
	
	function find(children, func, context) {
	  var index = 0;
	  var result = undefined;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = child;
	    }
	  });
	
	  return result;
	}
	
	function every(children, func, context) {
	  var index = 0;
	  var result = true;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (!func.call(context, child, index++)) {
	      result = false;
	    }
	  });
	
	  return result;
	}
	
	function some(children, func, context) {
	  var index = 0;
	  var result = false;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = true;
	    }
	  });
	
	  return result;
	}
	
	function toArray(children) {
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    result.push(child);
	  });
	
	  return result;
	}
	
	exports['default'] = {
	  map: map,
	  forEach: forEach,
	  count: count,
	  find: find,
	  filter: filter,
	  every: every,
	  some: some,
	  toArray: toArray
	};
	module.exports = exports['default'];

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withStylesPropTypes = exports.css = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.withStyles = withStyles;
	
	var _object = __webpack_require__(1670);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(405);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _constants = __webpack_require__(1958);
	
	var _brcast = __webpack_require__(1959);
	
	var _brcast2 = _interopRequireDefault(_brcast);
	
	var _ThemedStyleSheet = __webpack_require__(920);
	
	var _ThemedStyleSheet2 = _interopRequireDefault(_ThemedStyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint react/forbid-foreign-prop-types: off */
	
	// Add some named exports to assist in upgrading and for convenience
	var css = exports.css = _ThemedStyleSheet2['default'].resolveLTR;
	var withStylesPropTypes = exports.withStylesPropTypes = {
	  styles: _propTypes2['default'].object.isRequired, // eslint-disable-line react/forbid-prop-types
	  theme: _propTypes2['default'].object.isRequired, // eslint-disable-line react/forbid-prop-types
	  css: _propTypes2['default'].func.isRequired
	};
	
	var EMPTY_STYLES = {};
	var EMPTY_STYLES_FN = function EMPTY_STYLES_FN() {
	  return EMPTY_STYLES;
	};
	
	var START_MARK = 'react-with-styles.createStyles.start';
	var END_MARK = 'react-with-styles.createStyles.end';
	
	function baseClass(pureComponent) {
	  if (pureComponent) {
	    if (!_react2['default'].PureComponent) {
	      throw new ReferenceError('withStyles() pureComponent option requires React 15.3.0 or later');
	    }
	
	    return _react2['default'].PureComponent;
	  }
	
	  return _react2['default'].Component;
	}
	
	var contextTypes = _defineProperty({}, _constants.CHANNEL, _brcast2['default']);
	
	var defaultDirection = _constants.DIRECTIONS.LTR;
	
	function withStyles(styleFn) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$stylesPropName = _ref.stylesPropName,
	      stylesPropName = _ref$stylesPropName === undefined ? 'styles' : _ref$stylesPropName,
	      _ref$themePropName = _ref.themePropName,
	      themePropName = _ref$themePropName === undefined ? 'theme' : _ref$themePropName,
	      _ref$cssPropName = _ref.cssPropName,
	      cssPropName = _ref$cssPropName === undefined ? 'css' : _ref$cssPropName,
	      _ref$flushBefore = _ref.flushBefore,
	      flushBefore = _ref$flushBefore === undefined ? false : _ref$flushBefore,
	      _ref$pureComponent = _ref.pureComponent,
	      pureComponent = _ref$pureComponent === undefined ? false : _ref$pureComponent;
	
	  var styleDefLTR = void 0;
	  var styleDefRTL = void 0;
	  var currentThemeLTR = void 0;
	  var currentThemeRTL = void 0;
	  var BaseClass = baseClass(pureComponent);
	
	  function getResolveMethod(direction) {
	    return direction === _constants.DIRECTIONS.LTR ? _ThemedStyleSheet2['default'].resolveLTR : _ThemedStyleSheet2['default'].resolveRTL;
	  }
	
	  function getCurrentTheme(direction) {
	    return direction === _constants.DIRECTIONS.LTR ? currentThemeLTR : currentThemeRTL;
	  }
	
	  function getStyleDef(direction, wrappedComponentName) {
	    var currentTheme = getCurrentTheme(direction);
	    var styleDef = direction === _constants.DIRECTIONS.LTR ? styleDefLTR : styleDefRTL;
	
	    var registeredTheme = _ThemedStyleSheet2['default'].get();
	
	    // Return the existing styles if they've already been defined
	    // and if the theme used to create them corresponds to the theme
	    // registered with ThemedStyleSheet
	    if (styleDef && currentTheme === registeredTheme) {
	      return styleDef;
	    }
	
	    if (false) {
	      performance.clearMarks(START_MARK);
	      performance.mark(START_MARK);
	    }
	
	    var isRTL = direction === _constants.DIRECTIONS.RTL;
	
	    if (isRTL) {
	      styleDefRTL = styleFn ? _ThemedStyleSheet2['default'].createRTL(styleFn) : EMPTY_STYLES_FN;
	
	      currentThemeRTL = registeredTheme;
	      styleDef = styleDefRTL;
	    } else {
	      styleDefLTR = styleFn ? _ThemedStyleSheet2['default'].createLTR(styleFn) : EMPTY_STYLES_FN;
	
	      currentThemeLTR = registeredTheme;
	      styleDef = styleDefLTR;
	    }
	
	    if (false) {
	      performance.clearMarks(END_MARK);
	      performance.mark(END_MARK);
	
	      var measureName = '\uD83D\uDC69\u200D\uD83C\uDFA8 withStyles(' + String(wrappedComponentName) + ') [create styles]';
	
	      performance.measure(measureName, START_MARK, END_MARK);
	      performance.clearMarks(measureName);
	    }
	
	    return styleDef;
	  }
	
	  function getState(direction, wrappedComponentName) {
	    return {
	      resolveMethod: getResolveMethod(direction),
	      styleDef: getStyleDef(direction, wrappedComponentName)
	    };
	  }
	
	  return function () {
	    function withStylesHOC(WrappedComponent) {
	      var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	      // NOTE: Use a class here so components are ref-able if need be:
	      // eslint-disable-next-line react/prefer-stateless-function
	
	      var WithStyles = function (_BaseClass) {
	        _inherits(WithStyles, _BaseClass);
	
	        function WithStyles(props, context) {
	          _classCallCheck(this, WithStyles);
	
	          var _this = _possibleConstructorReturn(this, (WithStyles.__proto__ || Object.getPrototypeOf(WithStyles)).call(this, props, context));
	
	          var direction = _this.context[_constants.CHANNEL] ? _this.context[_constants.CHANNEL].getState() : defaultDirection;
	
	          _this.state = getState(direction, wrappedComponentName);
	          return _this;
	        }
	
	        _createClass(WithStyles, [{
	          key: 'componentDidMount',
	          value: function () {
	            function componentDidMount() {
	              var _this2 = this;
	
	              if (this.context[_constants.CHANNEL]) {
	                // subscribe to future direction changes
	                this.channelUnsubscribe = this.context[_constants.CHANNEL].subscribe(function (direction) {
	                  _this2.setState(getState(direction, wrappedComponentName));
	                });
	              }
	            }
	
	            return componentDidMount;
	          }()
	        }, {
	          key: 'componentWillUnmount',
	          value: function () {
	            function componentWillUnmount() {
	              if (this.channelUnsubscribe) {
	                this.channelUnsubscribe();
	              }
	            }
	
	            return componentWillUnmount;
	          }()
	        }, {
	          key: 'render',
	          value: function () {
	            function render() {
	              var _ref2;
	
	              // As some components will depend on previous styles in
	              // the component tree, we provide the option of flushing the
	              // buffered styles (i.e. to a style tag) **before** the rendering
	              // cycle begins.
	              //
	              // The interfaces provide the optional "flush" method which
	              // is run in turn by ThemedStyleSheet.flush.
	              if (flushBefore) {
	                _ThemedStyleSheet2['default'].flush();
	              }
	
	              var _state = this.state,
	                  resolveMethod = _state.resolveMethod,
	                  styleDef = _state.styleDef;
	
	
	              return _react2['default'].createElement(WrappedComponent, _extends({}, this.props, (_ref2 = {}, _defineProperty(_ref2, themePropName, _ThemedStyleSheet2['default'].get()), _defineProperty(_ref2, stylesPropName, styleDef()), _defineProperty(_ref2, cssPropName, resolveMethod), _ref2)));
	            }
	
	            return render;
	          }()
	        }]);
	
	        return WithStyles;
	      }(BaseClass);
	
	      WithStyles.WrappedComponent = WrappedComponent;
	      WithStyles.displayName = 'withStyles(' + String(wrappedComponentName) + ')';
	      WithStyles.contextTypes = contextTypes;
	      if (WrappedComponent.propTypes) {
	        WithStyles.propTypes = (0, _object2['default'])({}, WrappedComponent.propTypes);
	        delete WithStyles.propTypes[stylesPropName];
	        delete WithStyles.propTypes[themePropName];
	        delete WithStyles.propTypes[cssPropName];
	      }
	      if (WrappedComponent.defaultProps) {
	        WithStyles.defaultProps = (0, _object2['default'])({}, WrappedComponent.defaultProps);
	      }
	
	      return (0, _hoistNonReactStatics2['default'])(WithStyles, WrappedComponent);
	    }
	
	    return withStylesHOC;
	  }();
	}

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var environment_1 = __webpack_require__(28);
	var tensor_1 = __webpack_require__(75);
	var tensor_util_1 = __webpack_require__(111);
	/**
	 * Enables production mode which disables correctness checks in favor of
	 * performance.
	 */
	/** @doc {heading: 'Environment'} */
	function enableProdMode() {
	    environment_1.env().set('PROD', true);
	}
	exports.enableProdMode = enableProdMode;
	/**
	 * Enables debug mode which will log information about all executed kernels:
	 * the elapsed time of the kernel execution, as well as the rank, shape, and
	 * size of the output tensor.
	 *
	 * Debug mode will significantly slow down your application as it will
	 * download the result of every operation to the CPU. This should not be used in
	 * production. Debug mode does not affect the timing information of the kernel
	 * execution as we do not measure download time in the kernel execution time.
	 *
	 * See also: `tf.profile`, `tf.memory`.
	 */
	/** @doc {heading: 'Environment'} */
	function enableDebugMode() {
	    environment_1.env().set('DEBUG', true);
	}
	exports.enableDebugMode = enableDebugMode;
	/** Globally disables deprecation warnings */
	function disableDeprecationWarnings() {
	    environment_1.env().set('DEPRECATION_WARNINGS_ENABLED', false);
	    console.warn("TensorFlow.js deprecation warnings have been disabled.");
	}
	exports.disableDeprecationWarnings = disableDeprecationWarnings;
	/** Warn users about deprecated functionality. */
	function deprecationWarn(msg) {
	    if (environment_1.env().getBool('DEPRECATION_WARNINGS_ENABLED')) {
	        console.warn(msg + ' You can disable deprecation warnings with ' +
	            'tf.disableDeprecationWarnings().');
	    }
	}
	exports.deprecationWarn = deprecationWarn;
	tensor_1.setDeprecationWarningFn(deprecationWarn);
	/**
	 * Dispose all variables kept in backend engine.
	 */
	/** @doc {heading: 'Environment'} */
	function disposeVariables() {
	    engine_1.ENGINE.disposeVariables();
	}
	exports.disposeVariables = disposeVariables;
	/**
	 * It returns the global engine that keeps track of all tensors and backends.
	 */
	/** @doc {heading: 'Environment'} */
	function engine() {
	    return engine_1.ENGINE;
	}
	exports.engine = engine;
	/**
	 * Returns memory info at the current time in the program. The result is an
	 * object with the following properties:
	 *
	 * - `numBytes`: Number of bytes allocated (undisposed) at this time.
	 * - `numTensors`: Number of unique tensors allocated.
	 * - `numDataBuffers`: Number of unique data buffers allocated
	 *   (undisposed) at this time, which is ≤ the number of tensors
	 *   (e.g. `a.reshape(newShape)` makes a new Tensor that shares the same
	 *   data buffer with `a`).
	 * - `unreliable`: True if the memory usage is unreliable. See `reasons` when
	 *    `unreliable` is true.
	 * - `reasons`: `string[]`, reasons why the memory is unreliable, present if
	 *    `unreliable` is true.
	 *
	 * WebGL Properties:
	 * - `numBytesInGPU`: Number of bytes allocated (undisposed) in the GPU only at
	 *     this time.
	 */
	/** @doc {heading: 'Performance', subheading: 'Memory'} */
	function memory() {
	    return engine_1.ENGINE.memory();
	}
	exports.memory = memory;
	/**
	 * Executes the provided function `f()` and returns a promise that resolves
	 * with information about the function's memory use:
	 * - `newBytes`: the number of new bytes allocated
	 * - `newTensors`: the number of new tensors created
	 * - `peakBytes`: the peak number of bytes allocated
	 * - `kernels`: an array of objects for each kernel involved that reports
	 * their input and output shapes, number of bytes used, and number of new
	 * tensors created.
	 *
	 * ```js
	 * const profile = await tf.profile(() => {
	 *   const x = tf.tensor1d([1, 2, 3]);
	 *   let x2 = x.square();
	 *   x2.dispose();
	 *   x2 = x.square();
	 *   x2.dispose();
	 *   return x;
	 * });
	 *
	 * console.log(`newBytes: ${profile.newBytes}`);
	 * console.log(`newTensors: ${profile.newTensors}`);
	 * console.log(`byte usage over all kernels: ${profile.kernels.map(k =>
	 * k.totalBytesSnapshot)}`);
	 * ```
	 *
	 */
	/** @doc {heading: 'Performance', subheading: 'Profile'} */
	function profile(f) {
	    return engine_1.ENGINE.profile(f);
	}
	exports.profile = profile;
	/**
	 * Executes the provided function `fn` and after it is executed, cleans up all
	 * intermediate tensors allocated by `fn` except those returned by `fn`.
	 * `fn` must not return a Promise (async functions not allowed). The returned
	 * result can be a complex object.
	 *
	 * Using this method helps avoid memory leaks. In general, wrap calls to
	 * operations in `tf.tidy` for automatic memory cleanup.
	 *
	 * NOTE: Variables do *not* get cleaned up when inside a tidy(). If you want to
	 * dispose variables, please use `tf.disposeVariables` or call dispose()
	 * directly on variables.
	 *
	 * ```js
	 * // y = 2 ^ 2 + 1
	 * const y = tf.tidy(() => {
	 *   // a, b, and one will be cleaned up when the tidy ends.
	 *   const one = tf.scalar(1);
	 *   const a = tf.scalar(2);
	 *   const b = a.square();
	 *
	 *   console.log('numTensors (in tidy): ' + tf.memory().numTensors);
	 *
	 *   // The value returned inside the tidy function will return
	 *   // through the tidy, in this case to the variable y.
	 *   return b.add(one);
	 * });
	 *
	 * console.log('numTensors (outside tidy): ' + tf.memory().numTensors);
	 * y.print();
	 * ```
	 *
	 * @param nameOrFn The name of the closure, or the function to execute.
	 *     If a name is provided, the 2nd argument should be the function.
	 *     If debug mode is on, the timing and the memory usage of the function
	 *     will be tracked and displayed on the console using the provided name.
	 * @param fn The function to execute.
	 */
	/** @doc {heading: 'Performance', subheading: 'Memory'} */
	function tidy(nameOrFn, fn) {
	    return engine_1.ENGINE.tidy(nameOrFn, fn);
	}
	exports.tidy = tidy;
	/**
	 * Disposes any `tf.Tensor`s found within the provided object.
	 *
	 * @param container an object that may be a `tf.Tensor` or may directly
	 *     contain `tf.Tensor`s, such as a `Tensor[]` or `{key: Tensor, ...}`. If
	 *     the object is not a `tf.Tensor` or does not contain `Tensors`, nothing
	 *     happens. In general it is safe to pass any object here, except that
	 *     `Promise`s are not supported.
	 */
	/** @doc {heading: 'Performance', subheading: 'Memory'} */
	function dispose(container) {
	    var tensors = tensor_util_1.getTensorsInContainer(container);
	    tensors.forEach(function (tensor) { return tensor.dispose(); });
	}
	exports.dispose = dispose;
	/**
	 * Keeps a `tf.Tensor` generated inside a `tf.tidy` from being disposed
	 * automatically.
	 *
	 * ```js
	 * let b;
	 * const y = tf.tidy(() => {
	 *   const one = tf.scalar(1);
	 *   const a = tf.scalar(2);
	 *
	 *   // b will not be cleaned up by the tidy. a and one will be cleaned up
	 *   // when the tidy ends.
	 *   b = tf.keep(a.square());
	 *
	 *   console.log('numTensors (in tidy): ' + tf.memory().numTensors);
	 *
	 *   // The value returned inside the tidy function will return
	 *   // through the tidy, in this case to the variable y.
	 *   return b.add(one);
	 * });
	 *
	 * console.log('numTensors (outside tidy): ' + tf.memory().numTensors);
	 * console.log('y:');
	 * y.print();
	 * console.log('b:');
	 * b.print();
	 * ```
	 *
	 * @param result The tensor to keep from being disposed.
	 */
	/** @doc {heading: 'Performance', subheading: 'Memory'} */
	function keep(result) {
	    return engine_1.ENGINE.keep(result);
	}
	exports.keep = keep;
	/**
	 * Executes `f()` and returns a promise that resolves with timing
	 * information.
	 *
	 * The result is an object with the following properties:
	 *
	 * - `wallMs`: Wall execution time.
	 * - `kernelMs`: Kernel execution time, ignoring data transfer. If using the
	 * WebGL backend and the query timer extension is not available, this will
	 * return an error object.
	 * - On `WebGL` The following additional properties exist:
	 *   - `uploadWaitMs`: CPU blocking time on texture uploads.
	 *   - `downloadWaitMs`: CPU blocking time on texture downloads (readPixels).
	 *
	 * ```js
	 * const x = tf.randomNormal([20, 20]);
	 * const time = await tf.time(() => x.matMul(x));
	 *
	 * console.log(`kernelMs: ${time.kernelMs}, wallTimeMs: ${time.wallMs}`);
	 * ```
	 *
	 * @param f The function to execute and time.
	 */
	/** @doc {heading: 'Performance', subheading: 'Timing'} */
	function time(f) {
	    return engine_1.ENGINE.time(f);
	}
	exports.time = time;
	/**
	 * Sets the backend (cpu, webgl, wasm, etc) responsible for creating tensors and
	 * executing operations on those tensors. Returns a promise that resolves
	 * to a boolean if the backend initialization was successful.
	 *
	 * Note this disposes the current backend, if any, as well as any tensors
	 * associated with it. A new backend is initialized, even if it is of the
	 * same type as the previous one.
	 *
	 * @param backendName The name of the backend. Currently supports
	 *     `'webgl'|'cpu'` in the browser, `'tensorflow'` under node.js
	 *     (requires tfjs-node), and `'wasm'` (requires tfjs-backend-wasm).
	 */
	/** @doc {heading: 'Backends'} */
	function setBackend(backendName) {
	    return engine_1.ENGINE.setBackend(backendName);
	}
	exports.setBackend = setBackend;
	/**
	 * Returns a promise that resolves when the currently selected backend (or the
	 * highest priority one) has initialized. Await this promise when you are using
	 * a backend that has async initialization.
	 */
	/** @doc {heading: 'Backends'} */
	function ready() {
	    return engine_1.ENGINE.ready();
	}
	exports.ready = ready;
	/**
	 * Returns the current backend name (cpu, webgl, etc). The backend is
	 * responsible for creating tensors and executing operations on those tensors.
	 */
	/** @doc {heading: 'Backends'} */
	function getBackend() {
	    return engine_1.ENGINE.backendName;
	}
	exports.getBackend = getBackend;
	/**
	 * Removes a backend and the registered factory.
	 */
	/** @doc {heading: 'Backends'} */
	function removeBackend(name) {
	    engine_1.ENGINE.removeBackend(name);
	}
	exports.removeBackend = removeBackend;
	/**
	 * Finds the backend registered under the provided name. Returns null if the
	 * name is not in the registry, or the registration hasn't finished yet.
	 */
	function findBackend(name) {
	    return engine_1.ENGINE.findBackend(name);
	}
	exports.findBackend = findBackend;
	/**
	 * Finds the backend factory registered under the provided name. Returns a
	 * function that produces a new backend when called. Returns null if the name
	 * is not in the registry.
	 */
	function findBackendFactory(name) {
	    return engine_1.ENGINE.findBackendFactory(name);
	}
	exports.findBackendFactory = findBackendFactory;
	/**
	 * Registers a global backend. The registration should happen when importing
	 * a module file (e.g. when importing `backend_webgl.ts`), and is used for
	 * modular builds (e.g. custom tfjs bundle with only webgl support).
	 *
	 * @param factory The backend factory function. When called, it should
	 * return a backend instance, or a promise of an instance.
	 * @param priority The priority of the backend (higher = more important).
	 *     In case multiple backends are registered, the priority is used to find
	 *     the best backend. Defaults to 1.
	 * @return False if there is already a registered backend under this name, true
	 *     if not.
	 */
	/** @doc {heading: 'Backends'} */
	function registerBackend(name, factory, priority) {
	    if (priority === void 0) { priority = 1; }
	    return engine_1.ENGINE.registerBackend(name, factory, priority);
	}
	exports.registerBackend = registerBackend;
	/**
	 * Gets the current backend. If no backends have been initialized, this will
	 * attempt to initialize the best backend. Will throw an error if the highest
	 * priority backend has async initialization, in which case, you should call
	 * 'await tf.ready()' before running other code.
	 */
	/** @doc {heading: 'Backends'} */
	function backend() {
	    return engine_1.ENGINE.backend;
	}
	exports.backend = backend;
	/**
	 * Sets the global platform.
	 *
	 * @param platformName The name of this platform.
	 * @param platform A platform implementation.
	 */
	function setPlatform(platformName, platform) {
	    environment_1.env().setPlatform(platformName, platform);
	}
	exports.setPlatform = setPlatform;
	//# sourceMappingURL=globals.js.map

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	// Modularized ops.
	var square_1 = __webpack_require__(1069);
	exports.square = square_1.square;
	var squared_difference_1 = __webpack_require__(498);
	exports.squaredDifference = squared_difference_1.squaredDifference;
	__export(__webpack_require__(1047));
	__export(__webpack_require__(1048));
	__export(__webpack_require__(191));
	__export(__webpack_require__(237));
	// Selectively exporting to avoid exposing gradient ops.
	var conv_1 = __webpack_require__(314);
	exports.conv1d = conv_1.conv1d;
	exports.conv2d = conv_1.conv2d;
	exports.conv3d = conv_1.conv3d;
	exports.depthwiseConv2d = conv_1.depthwiseConv2d;
	exports.separableConv2d = conv_1.separableConv2d;
	exports.conv2dTranspose = conv_1.conv2dTranspose;
	exports.conv3dTranspose = conv_1.conv3dTranspose;
	__export(__webpack_require__(490));
	__export(__webpack_require__(1065));
	__export(__webpack_require__(1063));
	__export(__webpack_require__(318));
	__export(__webpack_require__(320));
	__export(__webpack_require__(492));
	__export(__webpack_require__(487));
	__export(__webpack_require__(109));
	__export(__webpack_require__(493));
	__export(__webpack_require__(154));
	__export(__webpack_require__(89));
	__export(__webpack_require__(31));
	__export(__webpack_require__(1072));
	__export(__webpack_require__(497));
	__export(__webpack_require__(1060));
	__export(__webpack_require__(491));
	__export(__webpack_require__(494));
	__export(__webpack_require__(1061));
	__export(__webpack_require__(1062));
	__export(__webpack_require__(1070));
	__export(__webpack_require__(1071));
	__export(__webpack_require__(1066));
	__export(__webpack_require__(319));
	__export(__webpack_require__(1067));
	__export(__webpack_require__(1056));
	__export(__webpack_require__(1051));
	__export(__webpack_require__(1052));
	__export(__webpack_require__(496));
	__export(__webpack_require__(1058));
	var operation_1 = __webpack_require__(18);
	exports.op = operation_1.op;
	// Second level exports.
	var losses = __webpack_require__(489);
	exports.losses = losses;
	var linalg = __webpack_require__(1059);
	exports.linalg = linalg;
	var image = __webpack_require__(1057);
	exports.image = image;
	var spectral = __webpack_require__(319);
	exports.spectral = spectral;
	var fused = __webpack_require__(1054);
	exports.fused = fused;
	var signal = __webpack_require__(496);
	exports.signal = signal;
	//# sourceMappingURL=ops.js.map

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var tensor_format_1 = __webpack_require__(1081);
	var util = __webpack_require__(10);
	var util_1 = __webpack_require__(10);
	/**
	 * A mutable object, similar to `tf.Tensor`, that allows users to set values
	 * at locations before converting to an immutable `tf.Tensor`.
	 *
	 * See `tf.buffer` for creating a tensor buffer.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Classes'} */
	var TensorBuffer = /** @class */ (function () {
	    function TensorBuffer(shape, dtype, values) {
	        var _this = this;
	        this.dtype = dtype;
	        this.shape = shape.slice();
	        this.size = util.sizeFromShape(shape);
	        if (values != null) {
	            var n_1 = values.length;
	            util.assert(n_1 === this.size, function () { return "Length of values '" + n_1 + "' does not match the size " +
	                ("inferred by the shape '" + _this.size + "'."); });
	        }
	        if (dtype === 'complex64') {
	            throw new Error("complex64 dtype TensorBuffers are not supported. Please create " +
	                "a TensorBuffer for the real and imaginary parts separately and " +
	                "call tf.complex(real, imag).");
	        }
	        this.values = values || util.getArrayFromDType(dtype, this.size);
	        this.strides = util_1.computeStrides(shape);
	    }
	    /**
	     * Sets a value in the buffer at a given location.
	     *
	     * @param value The value to set.
	     * @param locs  The location indices.
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Creation'} */
	    TensorBuffer.prototype.set = function (value) {
	        var _this = this;
	        var locs = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            locs[_i - 1] = arguments[_i];
	        }
	        if (locs.length === 0) {
	            locs = [0];
	        }
	        util.assert(locs.length === this.rank, function () { return "The number of provided coordinates (" + locs.length + ") must " +
	            ("match the rank (" + _this.rank + ")"); });
	        var index = this.locToIndex(locs);
	        this.values[index] = value;
	    };
	    /**
	     * Returns the value in the buffer at the provided location.
	     *
	     * @param locs The location indices.
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Creation'} */
	    TensorBuffer.prototype.get = function () {
	        var locs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            locs[_i] = arguments[_i];
	        }
	        if (locs.length === 0) {
	            locs = [0];
	        }
	        var i = 0;
	        for (var _a = 0, locs_1 = locs; _a < locs_1.length; _a++) {
	            var loc = locs_1[_a];
	            if (loc < 0 || loc >= this.shape[i]) {
	                var msg = "Requested out of range element at " + locs + ". " +
	                    ("  Buffer shape=" + this.shape);
	                throw new Error(msg);
	            }
	            i++;
	        }
	        var index = locs[locs.length - 1];
	        for (var i_1 = 0; i_1 < locs.length - 1; ++i_1) {
	            index += this.strides[i_1] * locs[i_1];
	        }
	        return this.values[index];
	    };
	    TensorBuffer.prototype.locToIndex = function (locs) {
	        if (this.rank === 0) {
	            return 0;
	        }
	        else if (this.rank === 1) {
	            return locs[0];
	        }
	        var index = locs[locs.length - 1];
	        for (var i = 0; i < locs.length - 1; ++i) {
	            index += this.strides[i] * locs[i];
	        }
	        return index;
	    };
	    TensorBuffer.prototype.indexToLoc = function (index) {
	        if (this.rank === 0) {
	            return [];
	        }
	        else if (this.rank === 1) {
	            return [index];
	        }
	        var locs = new Array(this.shape.length);
	        for (var i = 0; i < locs.length - 1; ++i) {
	            locs[i] = Math.floor(index / this.strides[i]);
	            index -= locs[i] * this.strides[i];
	        }
	        locs[locs.length - 1] = index;
	        return locs;
	    };
	    Object.defineProperty(TensorBuffer.prototype, "rank", {
	        get: function () {
	            return this.shape.length;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Creates an immutable `tf.Tensor` object from the buffer.
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Creation'} */
	    TensorBuffer.prototype.toTensor = function () {
	        return trackerFn().makeTensor(this.values, this.shape, this.dtype);
	    };
	    return TensorBuffer;
	}());
	exports.TensorBuffer = TensorBuffer;
	// For tracking tensor creation and disposal.
	var trackerFn = null;
	// Used by chaining methods to call into ops.
	var opHandler = null;
	// Used to warn about deprecated methods.
	var deprecationWarningFn = null;
	// This here so that we can use this method on dev branches and keep the
	// functionality at master.
	// tslint:disable-next-line:no-unused-expression
	[deprecationWarningFn];
	/**
	 * An external consumer can register itself as the tensor tracker. This way
	 * the Tensor class can notify the tracker for every tensor created and
	 * disposed.
	 */
	function setTensorTracker(fn) {
	    trackerFn = fn;
	}
	exports.setTensorTracker = setTensorTracker;
	/**
	 * An external consumer can register itself as the op handler. This way the
	 * Tensor class can have chaining methods that call into ops via the op
	 * handler.
	 */
	function setOpHandler(handler) {
	    opHandler = handler;
	}
	exports.setOpHandler = setOpHandler;
	/**
	 * Sets the deprecation warning function to be used by this file. This way the
	 * Tensor class can be a leaf but still use the environment.
	 */
	function setDeprecationWarningFn(fn) {
	    deprecationWarningFn = fn;
	}
	exports.setDeprecationWarningFn = setDeprecationWarningFn;
	/**
	 * A `tf.Tensor` object represents an immutable, multidimensional array of
	 * numbers that has a shape and a data type.
	 *
	 * See `tf.tensor` for details on how to create a `tf.Tensor`.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Classes'} */
	var Tensor = /** @class */ (function () {
	    function Tensor(shape, dtype, dataId, id) {
	        /** Whether this tensor has been globally kept. */
	        this.kept = false;
	        this.isDisposedInternal = false;
	        this.shape = shape.slice();
	        this.dtype = dtype || 'float32';
	        this.size = util.sizeFromShape(shape);
	        this.strides = util_1.computeStrides(shape);
	        this.dataId = dataId;
	        this.id = id;
	        this.rankType = (this.rank < 5 ? this.rank.toString() : 'higher');
	    }
	    /** Flatten a Tensor to a 1D array. */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.flatten = function () {
	        this.throwIfDisposed();
	        return this.as1D();
	    };
	    /** Converts a size-1 `tf.Tensor` to a `tf.Scalar`. */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.asScalar = function () {
	        this.throwIfDisposed();
	        util.assert(this.size === 1, function () { return 'The array must have only 1 element.'; });
	        return this.reshape([]);
	    };
	    /** Converts a `tf.Tensor` to a `tf.Tensor1D`. */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.as1D = function () {
	        this.throwIfDisposed();
	        return this.reshape([this.size]);
	    };
	    /**
	     * Converts a `tf.Tensor` to a `tf.Tensor2D`.
	     *
	     * @param rows Number of rows in `tf.Tensor2D`.
	     * @param columns Number of columns in `tf.Tensor2D`.
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.as2D = function (rows, columns) {
	        this.throwIfDisposed();
	        return this.reshape([rows, columns]);
	    };
	    /**
	     * Converts a `tf.Tensor` to a `tf.Tensor3D`.
	     *
	     * @param rows Number of rows in `tf.Tensor3D`.
	     * @param columns Number of columns in `tf.Tensor3D`.
	     * @param depth Depth of `tf.Tensor3D`.
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.as3D = function (rows, columns, depth) {
	        this.throwIfDisposed();
	        return this.reshape([rows, columns, depth]);
	    };
	    /**
	     * Converts a `tf.Tensor` to a `tf.Tensor4D`.
	     *
	     * @param rows Number of rows in `tf.Tensor4D`.
	     * @param columns Number of columns in `tf.Tensor4D`.
	     * @param depth Depth of `tf.Tensor4D`.
	     * @param depth2 4th dimension of `tf.Tensor4D`.
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.as4D = function (rows, columns, depth, depth2) {
	        this.throwIfDisposed();
	        return this.reshape([rows, columns, depth, depth2]);
	    };
	    /**
	     * Converts a `tf.Tensor` to a `tf.Tensor5D`.
	     *
	     * @param rows Number of rows in `tf.Tensor5D`.
	     * @param columns Number of columns in `tf.Tensor5D`.
	     * @param depth Depth of `tf.Tensor5D`.
	     * @param depth2 4th dimension of `tf.Tensor5D`.
	     * @param depth3 5th dimension of 'tf.Tensor5D'
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.as5D = function (rows, columns, depth, depth2, depth3) {
	        this.throwIfDisposed();
	        return this.reshape([rows, columns, depth, depth2, depth3]);
	    };
	    /**
	     * Casts a `tf.Tensor` to a specified dtype.
	     *
	     * @param dtype Data-type to cast the tensor to.
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.asType = function (dtype) {
	        this.throwIfDisposed();
	        return opHandler.cast(this, dtype);
	    };
	    Object.defineProperty(Tensor.prototype, "rank", {
	        get: function () {
	            return this.shape.length;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns a promise of `tf.TensorBuffer` that holds the underlying data.
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.buffer = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var vals;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.data()];
	                    case 1:
	                        vals = _a.sent();
	                        return [2 /*return*/, opHandler.buffer(this.shape, this.dtype, vals)];
	                }
	            });
	        });
	    };
	    /** Returns a `tf.TensorBuffer` that holds the underlying data. */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.bufferSync = function () {
	        return opHandler.buffer(this.shape, this.dtype, this.dataSync());
	    };
	    /**
	     * Returns the tensor data as a nested array. The transfer of data is done
	     * asynchronously.
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.array = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var vals;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.data()];
	                    case 1:
	                        vals = _a.sent();
	                        return [2 /*return*/, util_1.toNestedArray(this.shape, vals)];
	                }
	            });
	        });
	    };
	    /**
	     * Returns the tensor data as a nested array. The transfer of data is done
	     * synchronously.
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.arraySync = function () {
	        return util_1.toNestedArray(this.shape, this.dataSync());
	    };
	    /**
	     * Asynchronously downloads the values from the `tf.Tensor`. Returns a
	     * promise of `TypedArray` that resolves when the computation has finished.
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.data = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var data, bytes;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.throwIfDisposed();
	                        data = trackerFn().read(this.dataId);
	                        if (!(this.dtype === 'string')) return [3 /*break*/, 2];
	                        return [4 /*yield*/, data];
	                    case 1:
	                        bytes = _a.sent();
	                        try {
	                            return [2 /*return*/, bytes.map(function (b) { return util.decodeString(b); })];
	                        }
	                        catch (_b) {
	                            throw new Error('Failed to decode the string bytes into utf-8. ' +
	                                'To get the original bytes, call tensor.bytes().');
	                        }
	                        _a.label = 2;
	                    case 2: return [2 /*return*/, data];
	                }
	            });
	        });
	    };
	    /**
	     * Synchronously downloads the values from the `tf.Tensor`. This blocks the
	     * UI thread until the values are ready, which can cause performance issues.
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.dataSync = function () {
	        this.throwIfDisposed();
	        var data = trackerFn().readSync(this.dataId);
	        if (this.dtype === 'string') {
	            try {
	                return data.map(function (b) { return util.decodeString(b); });
	            }
	            catch (_a) {
	                throw new Error('Failed to decode the string bytes into utf-8. ' +
	                    'To get the original bytes, call tensor.bytes().');
	            }
	        }
	        return data;
	    };
	    /** Returns the underlying bytes of the tensor's data. */
	    Tensor.prototype.bytes = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var data;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.throwIfDisposed();
	                        return [4 /*yield*/, trackerFn().read(this.dataId)];
	                    case 1:
	                        data = _a.sent();
	                        if (this.dtype === 'string') {
	                            return [2 /*return*/, data];
	                        }
	                        else {
	                            return [2 /*return*/, new Uint8Array(data.buffer)];
	                        }
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Disposes `tf.Tensor` from memory.
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.dispose = function () {
	        if (this.isDisposed) {
	            return;
	        }
	        trackerFn().disposeTensor(this);
	        this.isDisposedInternal = true;
	    };
	    Object.defineProperty(Tensor.prototype, "isDisposed", {
	        get: function () {
	            return this.isDisposedInternal;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Tensor.prototype.throwIfDisposed = function () {
	        if (this.isDisposed) {
	            throw new Error("Tensor is disposed.");
	        }
	    };
	    /** Casts the array to type `float32` */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.toFloat = function () {
	        return this.asType('float32');
	    };
	    /** Casts the array to type `int32` */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.toInt = function () {
	        return this.asType('int32');
	    };
	    /** Casts the array to type `bool` */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.toBool = function () {
	        return this.asType('bool');
	    };
	    /**
	     * Prints the `tf.Tensor`. See `tf.print` for details.
	     *
	     * @param verbose Whether to print verbose information about the tensor,
	     *    including dtype and size.
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.print = function (verbose) {
	        if (verbose === void 0) { verbose = false; }
	        return opHandler.print(this, verbose);
	    };
	    /**
	     * Reshapes the tensor into the provided shape.
	     * See `tf.reshape` for more details.
	     *
	     * @param newShape An array of integers defining the output tensor shape.
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.reshape = function (newShape) {
	        this.throwIfDisposed();
	        return opHandler.reshape(this, newShape);
	    };
	    /**
	     * Reshapes the tensor into the shape of the provided tensor.
	     *
	     * @param x The tensor of required shape.
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.reshapeAs = function (x) {
	        this.throwIfDisposed();
	        return this.reshape(x.shape);
	    };
	    /**
	     * Returns a `tf.Tensor` that has expanded rank, by inserting a dimension
	     * into the tensor's shape. See `tf.expandDims` for details.
	     *
	     * @param axis The dimension index at which to insert shape of 1. Defaults to
	     *     0 (the first dimension).
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.expandDims = function (axis) {
	        if (axis === void 0) { axis = 0; }
	        return opHandler.expandDims(this, axis);
	    };
	    /**
	     * Returns the cumulative sum of the `tf.Tensor` along `axis`.
	     *
	     * @param axis The axis along which to sum. Optional. Defaults to 0.
	     * @param exclusive Whether to perform exclusive cumulative sum. Defaults to
	     *    false. If set to true then the sum of each tensor entry does not
	     * include its own value, but only the values previous to it along the
	     * specified axis.
	     * @param reverse Whether to sum in the opposite direction. Defaults to
	     *    false.
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.cumsum = function (axis, exclusive, reverse) {
	        if (axis === void 0) { axis = 0; }
	        if (exclusive === void 0) { exclusive = false; }
	        if (reverse === void 0) { reverse = false; }
	        return opHandler.cumsum(this, axis, exclusive, reverse);
	    };
	    /**
	     * Returns a `tf.Tensor` with dimensions of size 1 removed from the shape.
	     * See `tf.squeeze` for more details.
	     *
	     * @param axis A list of numbers. If specified, only squeezes the
	     *    dimensions listed. The dimension index starts at 0. It is an error to
	     *    squeeze a dimension that is not 1.
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.squeeze = function (axis) {
	        this.throwIfDisposed();
	        return opHandler.squeeze(this, axis);
	    };
	    /** Returns a copy of the tensor. See `tf.clone` for details. */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.clone = function () {
	        this.throwIfDisposed();
	        return opHandler.clone(this);
	    };
	    Tensor.prototype.oneHot = function (depth, onValue, offValue) {
	        this.throwIfDisposed();
	        return opHandler.oneHot(this, depth, onValue, offValue);
	    };
	    /**
	     * Returns a human-readable description of the tensor. Useful for logging.
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Tensor.prototype.toString = function (verbose) {
	        if (verbose === void 0) { verbose = false; }
	        var vals = this.dataSync();
	        return tensor_format_1.tensorToString(vals, this.shape, this.dtype, verbose);
	    };
	    // Below is chain API that is not exposed to docs to avoid repetition. To
	    // expose a method, move it above this comment and add @doc and jsdoc.
	    Tensor.prototype.tile = function (reps) {
	        this.throwIfDisposed();
	        return opHandler.tile(this, reps);
	    };
	    Tensor.prototype.gather = function (indices, axis) {
	        if (axis === void 0) { axis = 0; }
	        this.throwIfDisposed();
	        return opHandler.gather(this, indices, axis);
	    };
	    Tensor.prototype.matMul = function (b, transposeA, transposeB) {
	        if (transposeA === void 0) { transposeA = false; }
	        if (transposeB === void 0) { transposeB = false; }
	        this.throwIfDisposed();
	        return opHandler.matMul(this, b, transposeA, transposeB);
	    };
	    Tensor.prototype.dot = function (b) {
	        this.throwIfDisposed();
	        return opHandler.dot(this, b);
	    };
	    Tensor.prototype.norm = function (ord, axis, keepDims) {
	        if (ord === void 0) { ord = 'euclidean'; }
	        if (axis === void 0) { axis = null; }
	        if (keepDims === void 0) { keepDims = false; }
	        this.throwIfDisposed();
	        return opHandler.norm(this, ord, axis, keepDims);
	    };
	    Tensor.prototype.slice = function (begin, size) {
	        this.throwIfDisposed();
	        return opHandler.slice(this, begin, size);
	    };
	    Tensor.prototype.reverse = function (axis) {
	        this.throwIfDisposed();
	        return opHandler.reverse(this, axis);
	    };
	    Tensor.prototype.concat = function (x, axis) {
	        if (axis === void 0) { axis = 0; }
	        this.throwIfDisposed();
	        if (x instanceof Tensor) {
	            x = [x];
	        }
	        return opHandler.concat([this].concat(x), axis);
	    };
	    Tensor.prototype.split = function (numOrSizeSplits, axis) {
	        if (axis === void 0) { axis = 0; }
	        this.throwIfDisposed();
	        return opHandler.split(this, numOrSizeSplits, axis);
	    };
	    Tensor.prototype.stack = function (x, axis) {
	        if (axis === void 0) { axis = 0; }
	        return opHandler.stack([this, x], axis);
	    };
	    Tensor.prototype.unstack = function (axis) {
	        if (axis === void 0) { axis = 0; }
	        return opHandler.unstack(this, axis);
	    };
	    Tensor.prototype.pad = function (paddings, constantValue) {
	        if (constantValue === void 0) { constantValue = 0; }
	        return opHandler.pad(this, paddings, constantValue);
	    };
	    /**
	     * @deprecated Use `tf.batchNorm` instead, and note the positional argument
	     *     change of scale, offset, and varianceEpsilon.
	     */
	    Tensor.prototype.batchNormalization = function (mean, variance, varianceEpsilon, scale, offset) {
	        if (varianceEpsilon === void 0) { varianceEpsilon = .001; }
	        deprecationWarningFn('tf.batchNormalization() is going away. ' +
	            'Use tf.batchNorm() instead, and note the positional argument change ' +
	            'of scale, offset, and varianceEpsilon');
	        return this.batchNorm(mean, variance, offset, scale, varianceEpsilon);
	    };
	    Tensor.prototype.batchNorm = function (mean, variance, offset, scale, varianceEpsilon) {
	        if (varianceEpsilon === void 0) { varianceEpsilon = .001; }
	        this.throwIfDisposed();
	        return opHandler.batchNorm(this, mean, variance, offset, scale, varianceEpsilon);
	    };
	    // Reduction ops.
	    Tensor.prototype.all = function (axis, keepDims) {
	        if (axis === void 0) { axis = null; }
	        if (keepDims === void 0) { keepDims = false; }
	        this.throwIfDisposed();
	        return opHandler.all(this, axis, keepDims);
	    };
	    Tensor.prototype.any = function (axis, keepDims) {
	        if (axis === void 0) { axis = null; }
	        if (keepDims === void 0) { keepDims = false; }
	        this.throwIfDisposed();
	        return opHandler.any(this, axis, keepDims);
	    };
	    Tensor.prototype.logSumExp = function (axis, keepDims) {
	        if (axis === void 0) { axis = null; }
	        if (keepDims === void 0) { keepDims = false; }
	        this.throwIfDisposed();
	        return opHandler.logSumExp(this, axis, keepDims);
	    };
	    Tensor.prototype.sum = function (axis, keepDims) {
	        if (axis === void 0) { axis = null; }
	        if (keepDims === void 0) { keepDims = false; }
	        this.throwIfDisposed();
	        return opHandler.sum(this, axis, keepDims);
	    };
	    Tensor.prototype.prod = function (axis, keepDims) {
	        if (axis === void 0) { axis = null; }
	        if (keepDims === void 0) { keepDims = false; }
	        this.throwIfDisposed();
	        return opHandler.prod(this, axis, keepDims);
	    };
	    Tensor.prototype.mean = function (axis, keepDims) {
	        if (axis === void 0) { axis = null; }
	        if (keepDims === void 0) { keepDims = false; }
	        this.throwIfDisposed();
	        return opHandler.mean(this, axis, keepDims);
	    };
	    Tensor.prototype.min = function (axis, keepDims) {
	        if (axis === void 0) { axis = null; }
	        if (keepDims === void 0) { keepDims = false; }
	        this.throwIfDisposed();
	        return opHandler.min(this, axis, keepDims);
	    };
	    Tensor.prototype.max = function (axis, keepDims) {
	        if (axis === void 0) { axis = null; }
	        if (keepDims === void 0) { keepDims = false; }
	        this.throwIfDisposed();
	        return opHandler.max(this, axis, keepDims);
	    };
	    Tensor.prototype.argMin = function (axis) {
	        if (axis === void 0) { axis = null; }
	        this.throwIfDisposed();
	        return opHandler.argMin(this, axis);
	    };
	    Tensor.prototype.argMax = function (axis) {
	        if (axis === void 0) { axis = null; }
	        this.throwIfDisposed();
	        return opHandler.argMax(this, axis);
	    };
	    // Transformations
	    Tensor.prototype.cast = function (dtype) {
	        this.throwIfDisposed();
	        return opHandler.cast(this, dtype);
	    };
	    // Binary ops.
	    Tensor.prototype.add = function (x) {
	        this.throwIfDisposed();
	        return opHandler.add(this, x);
	    };
	    Tensor.prototype.addStrict = function (x) {
	        this.throwIfDisposed();
	        return opHandler.addStrict(this, x);
	    };
	    Tensor.prototype.atan2 = function (x) {
	        this.throwIfDisposed();
	        return opHandler.atan2(this, x);
	    };
	    Tensor.prototype.sub = function (x) {
	        this.throwIfDisposed();
	        return opHandler.sub(this, x);
	    };
	    Tensor.prototype.subStrict = function (x) {
	        this.throwIfDisposed();
	        return opHandler.subStrict(this, x);
	    };
	    Tensor.prototype.pow = function (exp) {
	        this.throwIfDisposed();
	        return opHandler.pow(this, exp);
	    };
	    Tensor.prototype.powStrict = function (exp) {
	        this.throwIfDisposed();
	        return opHandler.powStrict(this, exp);
	    };
	    Tensor.prototype.mul = function (x) {
	        this.throwIfDisposed();
	        return opHandler.mul(this, x);
	    };
	    Tensor.prototype.mulStrict = function (x) {
	        this.throwIfDisposed();
	        return opHandler.mulStrict(this, x);
	    };
	    Tensor.prototype.div = function (x) {
	        this.throwIfDisposed();
	        return opHandler.div(this, x);
	    };
	    Tensor.prototype.divNoNan = function (x) {
	        this.throwIfDisposed();
	        return opHandler.divNoNan(this, x);
	    };
	    Tensor.prototype.floorDiv = function (x) {
	        this.throwIfDisposed();
	        return opHandler.floorDiv(this, x);
	    };
	    Tensor.prototype.divStrict = function (x) {
	        this.throwIfDisposed();
	        return opHandler.divStrict(this, x);
	    };
	    Tensor.prototype.minimum = function (x) {
	        this.throwIfDisposed();
	        return opHandler.minimum(this, x);
	    };
	    Tensor.prototype.minimumStrict = function (x) {
	        this.throwIfDisposed();
	        return opHandler.minimumStrict(this, x);
	    };
	    Tensor.prototype.maximum = function (x) {
	        this.throwIfDisposed();
	        return opHandler.maximum(this, x);
	    };
	    Tensor.prototype.maximumStrict = function (x) {
	        this.throwIfDisposed();
	        return opHandler.maximumStrict(this, x);
	    };
	    Tensor.prototype.mod = function (x) {
	        this.throwIfDisposed();
	        return opHandler.mod(this, x);
	    };
	    Tensor.prototype.modStrict = function (x) {
	        this.throwIfDisposed();
	        return opHandler.modStrict(this, x);
	    };
	    Tensor.prototype.squaredDifferenceStrict = function (x) {
	        this.throwIfDisposed();
	        return opHandler.squaredDifferenceStrict(this, x);
	    };
	    Tensor.prototype.transpose = function (perm) {
	        this.throwIfDisposed();
	        return opHandler.transpose(this, perm);
	    };
	    // Compare ops.
	    Tensor.prototype.notEqual = function (x) {
	        this.throwIfDisposed();
	        return opHandler.notEqual(this, x);
	    };
	    Tensor.prototype.notEqualStrict = function (x) {
	        this.throwIfDisposed();
	        return opHandler.notEqualStrict(this, x);
	    };
	    Tensor.prototype.less = function (x) {
	        this.throwIfDisposed();
	        return opHandler.less(this, x);
	    };
	    Tensor.prototype.lessStrict = function (x) {
	        this.throwIfDisposed();
	        return opHandler.lessStrict(this, x);
	    };
	    Tensor.prototype.equal = function (x) {
	        this.throwIfDisposed();
	        return opHandler.equal(this, x);
	    };
	    Tensor.prototype.equalStrict = function (x) {
	        this.throwIfDisposed();
	        return opHandler.equalStrict(this, x);
	    };
	    Tensor.prototype.lessEqual = function (x) {
	        this.throwIfDisposed();
	        return opHandler.lessEqual(this, x);
	    };
	    Tensor.prototype.lessEqualStrict = function (x) {
	        this.throwIfDisposed();
	        return opHandler.lessEqualStrict(this, x);
	    };
	    Tensor.prototype.greater = function (x) {
	        this.throwIfDisposed();
	        return opHandler.greater(this, x);
	    };
	    Tensor.prototype.greaterStrict = function (x) {
	        this.throwIfDisposed();
	        return opHandler.greaterStrict(this, x);
	    };
	    Tensor.prototype.greaterEqual = function (x) {
	        this.throwIfDisposed();
	        return opHandler.greaterEqual(this, x);
	    };
	    Tensor.prototype.greaterEqualStrict = function (x) {
	        this.throwIfDisposed();
	        return opHandler.greaterEqualStrict(this, x);
	    };
	    // Compare ops.
	    Tensor.prototype.logicalAnd = function (x) {
	        this.throwIfDisposed();
	        return opHandler.logicalAnd(this, x);
	    };
	    Tensor.prototype.logicalOr = function (x) {
	        this.throwIfDisposed();
	        return opHandler.logicalOr(this, x);
	    };
	    Tensor.prototype.logicalNot = function () {
	        this.throwIfDisposed();
	        return opHandler.logicalNot(this);
	    };
	    Tensor.prototype.logicalXor = function (x) {
	        this.throwIfDisposed();
	        return opHandler.logicalXor(this, x);
	    };
	    Tensor.prototype.where = function (condition, x) {
	        this.throwIfDisposed();
	        return opHandler.where(condition, this, x);
	    };
	    // Unary ops.
	    Tensor.prototype.neg = function () {
	        this.throwIfDisposed();
	        return opHandler.neg(this);
	    };
	    Tensor.prototype.ceil = function () {
	        this.throwIfDisposed();
	        return opHandler.ceil(this);
	    };
	    Tensor.prototype.floor = function () {
	        this.throwIfDisposed();
	        return opHandler.floor(this);
	    };
	    Tensor.prototype.sign = function () {
	        this.throwIfDisposed();
	        return opHandler.sign(this);
	    };
	    Tensor.prototype.isNaN = function () {
	        this.throwIfDisposed();
	        return opHandler.isNaN(this);
	    };
	    Tensor.prototype.isInf = function () {
	        this.throwIfDisposed();
	        return opHandler.isInf(this);
	    };
	    Tensor.prototype.isFinite = function () {
	        this.throwIfDisposed();
	        return opHandler.isFinite(this);
	    };
	    Tensor.prototype.exp = function () {
	        this.throwIfDisposed();
	        return opHandler.exp(this);
	    };
	    Tensor.prototype.expm1 = function () {
	        this.throwIfDisposed();
	        return opHandler.expm1(this);
	    };
	    Tensor.prototype.log = function () {
	        this.throwIfDisposed();
	        return opHandler.log(this);
	    };
	    Tensor.prototype.log1p = function () {
	        this.throwIfDisposed();
	        return opHandler.log1p(this);
	    };
	    Tensor.prototype.sqrt = function () {
	        this.throwIfDisposed();
	        return opHandler.sqrt(this);
	    };
	    Tensor.prototype.rsqrt = function () {
	        this.throwIfDisposed();
	        return opHandler.rsqrt(this);
	    };
	    Tensor.prototype.square = function () {
	        this.throwIfDisposed();
	        return opHandler.square(this);
	    };
	    Tensor.prototype.reciprocal = function () {
	        this.throwIfDisposed();
	        return opHandler.reciprocal(this);
	    };
	    Tensor.prototype.abs = function () {
	        this.throwIfDisposed();
	        return opHandler.abs(this);
	    };
	    Tensor.prototype.clipByValue = function (min, max) {
	        this.throwIfDisposed();
	        return opHandler.clipByValue(this, min, max);
	    };
	    Tensor.prototype.relu = function () {
	        this.throwIfDisposed();
	        return opHandler.relu(this);
	    };
	    Tensor.prototype.relu6 = function () {
	        this.throwIfDisposed();
	        return opHandler.relu6(this);
	    };
	    Tensor.prototype.elu = function () {
	        this.throwIfDisposed();
	        return opHandler.elu(this);
	    };
	    Tensor.prototype.selu = function () {
	        this.throwIfDisposed();
	        return opHandler.selu(this);
	    };
	    Tensor.prototype.leakyRelu = function (alpha) {
	        if (alpha === void 0) { alpha = 0.2; }
	        this.throwIfDisposed();
	        return opHandler.leakyRelu(this, alpha);
	    };
	    Tensor.prototype.prelu = function (alpha) {
	        this.throwIfDisposed();
	        return opHandler.prelu(this, alpha);
	    };
	    Tensor.prototype.sigmoid = function () {
	        this.throwIfDisposed();
	        return opHandler.sigmoid(this);
	    };
	    Tensor.prototype.logSigmoid = function () {
	        this.throwIfDisposed();
	        return opHandler.logSigmoid(this);
	    };
	    Tensor.prototype.softplus = function () {
	        this.throwIfDisposed();
	        return opHandler.softplus(this);
	    };
	    Tensor.prototype.zerosLike = function () {
	        this.throwIfDisposed();
	        return opHandler.zerosLike(this);
	    };
	    Tensor.prototype.onesLike = function () {
	        this.throwIfDisposed();
	        return opHandler.onesLike(this);
	    };
	    Tensor.prototype.sin = function () {
	        this.throwIfDisposed();
	        return opHandler.sin(this);
	    };
	    Tensor.prototype.cos = function () {
	        this.throwIfDisposed();
	        return opHandler.cos(this);
	    };
	    Tensor.prototype.tan = function () {
	        this.throwIfDisposed();
	        return opHandler.tan(this);
	    };
	    Tensor.prototype.asin = function () {
	        this.throwIfDisposed();
	        return opHandler.asin(this);
	    };
	    Tensor.prototype.acos = function () {
	        this.throwIfDisposed();
	        return opHandler.acos(this);
	    };
	    Tensor.prototype.atan = function () {
	        this.throwIfDisposed();
	        return opHandler.atan(this);
	    };
	    Tensor.prototype.sinh = function () {
	        this.throwIfDisposed();
	        return opHandler.sinh(this);
	    };
	    Tensor.prototype.cosh = function () {
	        this.throwIfDisposed();
	        return opHandler.cosh(this);
	    };
	    Tensor.prototype.tanh = function () {
	        this.throwIfDisposed();
	        return opHandler.tanh(this);
	    };
	    Tensor.prototype.asinh = function () {
	        this.throwIfDisposed();
	        return opHandler.asinh(this);
	    };
	    Tensor.prototype.acosh = function () {
	        this.throwIfDisposed();
	        return opHandler.acosh(this);
	    };
	    Tensor.prototype.atanh = function () {
	        this.throwIfDisposed();
	        return opHandler.atanh(this);
	    };
	    Tensor.prototype.erf = function () {
	        this.throwIfDisposed();
	        return opHandler.erf(this);
	    };
	    Tensor.prototype.round = function () {
	        this.throwIfDisposed();
	        return opHandler.round(this);
	    };
	    Tensor.prototype.step = function (alpha) {
	        if (alpha === void 0) { alpha = 0.0; }
	        this.throwIfDisposed();
	        return opHandler.step(this, alpha);
	    };
	    Tensor.prototype.softmax = function (dim) {
	        if (dim === void 0) { dim = -1; }
	        this.throwIfDisposed();
	        return opHandler.softmax(this, dim);
	    };
	    Tensor.prototype.logSoftmax = function (axis) {
	        if (axis === void 0) { axis = -1; }
	        this.throwIfDisposed();
	        return opHandler.logSoftmax(this, axis);
	    };
	    // Image ops.
	    Tensor.prototype.resizeBilinear = function (newShape2D, alignCorners) {
	        if (alignCorners === void 0) { alignCorners = false; }
	        this.throwIfDisposed();
	        return opHandler.image.resizeBilinear(this, newShape2D, alignCorners);
	    };
	    Tensor.prototype.resizeNearestNeighbor = function (newShape2D, alignCorners) {
	        if (alignCorners === void 0) { alignCorners = false; }
	        this.throwIfDisposed();
	        return opHandler.image.resizeNearestNeighbor(this, newShape2D, alignCorners);
	    };
	    // Convolutions.
	    Tensor.prototype.conv1d = function (filter, stride, pad, dataFormat, dilation, dimRoundingMode) {
	        if (dataFormat === void 0) { dataFormat = 'NWC'; }
	        if (dilation === void 0) { dilation = 1; }
	        this.throwIfDisposed();
	        return opHandler.conv1d(this, filter, stride, pad, dataFormat, dilation, dimRoundingMode);
	    };
	    Tensor.prototype.conv2d = function (filter, strides, pad, dataFormat, dilations, dimRoundingMode) {
	        if (dataFormat === void 0) { dataFormat = 'NHWC'; }
	        if (dilations === void 0) { dilations = [1, 1]; }
	        this.throwIfDisposed();
	        return opHandler.conv2d(this, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
	    };
	    Tensor.prototype.conv2dTranspose = function (filter, outputShape, strides, pad, dimRoundingMode) {
	        this.throwIfDisposed();
	        return opHandler.conv2dTranspose(this, filter, outputShape, strides, pad, dimRoundingMode);
	    };
	    Tensor.prototype.depthwiseConv2D = function (filter, strides, pad, dataFormat, dilations, dimRoundingMode) {
	        if (dataFormat === void 0) { dataFormat = 'NHWC'; }
	        if (dilations === void 0) { dilations = [1, 1]; }
	        this.throwIfDisposed();
	        return opHandler.depthwiseConv2d(this, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
	    };
	    Tensor.prototype.separableConv2d = function (depthwiseFilter, pointwiseFilter, strides, pad, dilation, dataFormat) {
	        if (dilation === void 0) { dilation = [1, 1]; }
	        if (dataFormat === void 0) { dataFormat = 'NHWC'; }
	        this.throwIfDisposed();
	        return opHandler.separableConv2d(this, depthwiseFilter, pointwiseFilter, strides, pad, dilation, dataFormat);
	    };
	    // Pooling.
	    Tensor.prototype.avgPool = function (filterSize, strides, pad, dimRoundingMode) {
	        this.throwIfDisposed();
	        return opHandler.avgPool(this, filterSize, strides, pad, dimRoundingMode);
	    };
	    Tensor.prototype.maxPool = function (filterSize, strides, pad, dimRoundingMode) {
	        this.throwIfDisposed();
	        return opHandler.maxPool(this, filterSize, strides, pad, dimRoundingMode);
	    };
	    Tensor.prototype.localResponseNormalization = function (radius, bias, alpha, beta) {
	        if (radius === void 0) { radius = 5; }
	        if (bias === void 0) { bias = 1; }
	        if (alpha === void 0) { alpha = 1; }
	        if (beta === void 0) { beta = 0.5; }
	        return opHandler.localResponseNormalization(this, radius, bias, alpha, beta);
	    };
	    Tensor.prototype.pool = function (windowShape, poolingType, padding, dilationRate, strides) {
	        this.throwIfDisposed();
	        return opHandler.pool(this, windowShape, poolingType, padding, dilationRate, strides);
	    };
	    Tensor.prototype.variable = function (trainable, name, dtype) {
	        if (trainable === void 0) { trainable = true; }
	        this.throwIfDisposed();
	        return trackerFn().makeVariable(this, trainable, name, dtype);
	    };
	    Tensor.prototype.unsortedSegmentSum = function (segmentIds, numSegments) {
	        this.throwIfDisposed();
	        return opHandler.unsortedSegmentSum(this, segmentIds, numSegments);
	    };
	    Tensor.prototype.batchToSpaceND = function (blockShape, crops) {
	        this.throwIfDisposed();
	        return opHandler.batchToSpaceND(this, blockShape, crops);
	    };
	    Tensor.prototype.spaceToBatchND = function (blockShape, paddings) {
	        this.throwIfDisposed();
	        return opHandler.spaceToBatchND(this, blockShape, paddings);
	    };
	    Tensor.prototype.topk = function (k, sorted) {
	        if (k === void 0) { k = 1; }
	        if (sorted === void 0) { sorted = true; }
	        this.throwIfDisposed();
	        return opHandler.topk(this, k, sorted);
	    };
	    Tensor.prototype.stridedSlice = function (begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask) {
	        if (beginMask === void 0) { beginMask = 0; }
	        if (endMask === void 0) { endMask = 0; }
	        if (ellipsisMask === void 0) { ellipsisMask = 0; }
	        if (newAxisMask === void 0) { newAxisMask = 0; }
	        if (shrinkAxisMask === void 0) { shrinkAxisMask = 0; }
	        this.throwIfDisposed();
	        return opHandler.stridedSlice(this, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask);
	    };
	    Tensor.prototype.depthToSpace = function (blockSize, dataFormat) {
	        this.throwIfDisposed();
	        return opHandler.depthToSpace(this, blockSize, dataFormat);
	    };
	    Tensor.prototype.fft = function () {
	        this.throwIfDisposed();
	        return opHandler.spectral.fft(this);
	    };
	    Tensor.prototype.ifft = function () {
	        this.throwIfDisposed();
	        return opHandler.spectral.ifft(this);
	    };
	    Tensor.prototype.rfft = function () {
	        this.throwIfDisposed();
	        return opHandler.spectral.rfft(this);
	    };
	    Tensor.prototype.irfft = function () {
	        this.throwIfDisposed();
	        return opHandler.spectral.irfft(this);
	    };
	    return Tensor;
	}());
	exports.Tensor = Tensor;
	Object.defineProperty(Tensor, Symbol.hasInstance, {
	    value: function (instance) {
	        return !!instance && instance.dataId != null && instance.shape != null &&
	            instance.dtype != null;
	    }
	});
	/**
	 * A mutable `tf.Tensor`, useful for persisting state, e.g. for training.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Classes'} */
	var Variable = /** @class */ (function (_super) {
	    __extends(Variable, _super);
	    function Variable(initialValue, trainable, name, tensorId) {
	        var _this = _super.call(this, initialValue.shape, initialValue.dtype, initialValue.dataId, tensorId) || this;
	        _this.trainable = trainable;
	        _this.name = name;
	        return _this;
	    }
	    /**
	     * Assign a new `tf.Tensor` to this variable. The new `tf.Tensor` must have
	     * the same shape and dtype as the old `tf.Tensor`.
	     *
	     * @param newValue New tensor to be assigned to this variable.
	     */
	    /** @doc {heading: 'Tensors', subheading: 'Classes'} */
	    Variable.prototype.assign = function (newValue) {
	        if (newValue.dtype !== this.dtype) {
	            throw new Error("dtype of the new value (" + newValue.dtype + ") and " +
	                ("previous value (" + this.dtype + ") must match"));
	        }
	        if (!util.arraysEqual(newValue.shape, this.shape)) {
	            throw new Error("shape of the new value (" + newValue.shape + ") and " +
	                ("previous value (" + this.shape + ") must match"));
	        }
	        trackerFn().disposeTensor(this);
	        this.dataId = newValue.dataId;
	        trackerFn().incRef(this, null /* backend */);
	    };
	    Variable.prototype.dispose = function () {
	        trackerFn().disposeVariable(this);
	        this.isDisposedInternal = true;
	    };
	    return Variable;
	}(Tensor));
	exports.Variable = Variable;
	Object.defineProperty(Variable, Symbol.hasInstance, {
	    value: function (instance) {
	        return instance instanceof Tensor && instance.assign != null &&
	            instance.assign instanceof Function;
	    }
	});
	//# sourceMappingURL=tensor.js.map

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(505);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1426);
	
	function CustomAlert(props) {
		return _react2.default.createElement(
			_reactBootstrap.Alert,
			{ bsStyle: props.bsStyle },
			typeof props.title !== 'undefined' && _react2.default.createElement(
				'strong',
				null,
				props.title,
				' '
			),
			typeof props.message !== 'undefined' && props.message,
			typeof props.description !== 'undefined' && _react2.default.createElement(
				'p',
				null,
				props.description,
				' '
			)
		);
	};
	exports.default = CustomAlert;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DynamicLabelInput = __webpack_require__(243);
	
	var _DynamicLabelInput2 = _interopRequireDefault(_DynamicLabelInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderField = function renderField(_ref) {
	  var input = _ref.input,
	      label = _ref.label,
	      fieldInfo = _ref.fieldInfo,
	      showSuccess = _ref.showSuccess,
	      showLabel = _ref.showLabel,
	      type = _ref.type,
	      autoComplete = _ref.autoComplete,
	      _ref$meta = _ref.meta,
	      asyncValidating = _ref$meta.asyncValidating,
	      touched = _ref$meta.touched,
	      error = _ref$meta.error,
	      valid = _ref$meta.valid,
	      invalid = _ref$meta.invalid,
	      warning = _ref$meta.warning;
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group ' + (touched && invalid ? 'has-error' : '') + ' ' + (touched && valid && showSuccess ? 'has-success' : '') },
	    _react2.default.createElement(
	      'div',
	      { className: asyncValidating ? 'async-validating' : '' },
	      _react2.default.createElement(_DynamicLabelInput2.default, Object.assign({}, input, {
	        className: 'form-control',
	        showLabel: showLabel === undefined && ("montemar-card-calf") === 'montemar',
	        placeholder: label,
	        fieldInfo: fieldInfo,
	        type: type,
	        autoComplete: autoComplete })),
	      _react2.default.createElement(
	        'div',
	        { className: 'help-block' },
	        touched && (error && _react2.default.createElement(
	          'span',
	          null,
	          error
	        ) || warning && _react2.default.createElement(
	          'span',
	          null,
	          warning
	        ))
	      )
	    )
	  );
	};
	
	exports.default = renderField;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(58);
	var core = __webpack_require__(69);
	var hide = __webpack_require__(162);
	var redefine = __webpack_require__(136);
	var ctx = __webpack_require__(134);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 80 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var environment_1 = __webpack_require__(28);
	function getGlslDifferences() {
	    var version;
	    var attribute;
	    var varyingVs;
	    var varyingFs;
	    var texture2D;
	    var output;
	    var defineOutput;
	    var defineSpecialNaN;
	    var defineSpecialInf;
	    var defineRound;
	    if (environment_1.env().getNumber('WEBGL_VERSION') === 2) {
	        version = '#version 300 es';
	        attribute = 'in';
	        varyingVs = 'out';
	        varyingFs = 'in';
	        texture2D = 'texture';
	        output = 'outputColor';
	        defineOutput = 'out vec4 outputColor;';
	        // Use custom isnan definition to work across differences between
	        // implementations on various platforms. While this should happen in ANGLE
	        // we still see differences between android and windows (on chrome) when
	        // using isnan directly.
	        defineSpecialNaN = "\n      bool isnan_custom(float val) {\n        return (val > 0.0 || val < 0.0) ? false : val != 0.0;\n      }\n\n      bvec4 isnan_custom(vec4 val) {\n        return bvec4(isnan_custom(val.x),\n          isnan_custom(val.y), isnan_custom(val.z), isnan_custom(val.w));\n      }\n\n      #define isnan(value) isnan_custom(value)\n    ";
	        // In webgl 2 we do not need to specify a custom isinf so there is no
	        // need for a special INFINITY constant.
	        defineSpecialInf = "";
	        defineRound = "\n      #define round(value) newRound(value)\n      int newRound(float value) {\n        return int(floor(value + 0.5));\n      }\n\n      ivec4 newRound(vec4 value) {\n        return ivec4(floor(value + vec4(0.5)));\n      }\n    ";
	    }
	    else {
	        version = '';
	        attribute = 'attribute';
	        varyingVs = 'varying';
	        varyingFs = 'varying';
	        texture2D = 'texture2D';
	        output = 'gl_FragColor';
	        defineOutput = '';
	        // WebGL1 has no built in isnan so we define one here.
	        defineSpecialNaN = "\n      #define isnan(value) isnan_custom(value)\n      bool isnan_custom(float val) {\n        return (val > 0. || val < 1. || val == 0.) ? false : true;\n      }\n      bvec4 isnan_custom(vec4 val) {\n        return bvec4(isnan(val.x), isnan(val.y), isnan(val.z), isnan(val.w));\n      }\n    ";
	        defineSpecialInf = "\n      uniform float INFINITY;\n\n      bool isinf(float val) {\n        return abs(val) == INFINITY;\n      }\n      bvec4 isinf(vec4 val) {\n        return equal(abs(val), vec4(INFINITY));\n      }\n    ";
	        defineRound = "\n      int round(float value) {\n        return int(floor(value + 0.5));\n      }\n\n      ivec4 round(vec4 value) {\n        return ivec4(floor(value + vec4(0.5)));\n      }\n    ";
	    }
	    return {
	        version: version,
	        attribute: attribute,
	        varyingVs: varyingVs,
	        varyingFs: varyingFs,
	        texture2D: texture2D,
	        output: output,
	        defineOutput: defineOutput,
	        defineSpecialNaN: defineSpecialNaN,
	        defineSpecialInf: defineSpecialInf,
	        defineRound: defineRound
	    };
	}
	exports.getGlslDifferences = getGlslDifferences;
	//# sourceMappingURL=glsl_version.js.map

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var environment_1 = __webpack_require__(28);
	var util = __webpack_require__(10);
	var PackingScheme;
	(function (PackingScheme) {
	    /**
	     * All values in a single texel are densely packed without any constraints.
	     *
	     * This is how the shader encodes a tensor with shape = [2, 3, 4]
	     * (indices are [batch, row, col]).
	     *
	     * 000|001   010|011   020|021
	     * -------   -------   -------
	     * 002|003   012|013   022|023
	     *
	     * 100|101   110|111   120|121
	     * -------   -------   -------
	     * 102|103   112|113   122|123
	     *
	     */
	    PackingScheme[PackingScheme["DENSE"] = 0] = "DENSE";
	    /**
	     * Single texels contain only values from the same batch, and from adjacent
	     * rows and columns.
	     *
	     * This is how the shader encodes a tensor with shape = [2, 3, 5]
	     * (indices are [batch, row, col]).
	     *
	     * 000|001   002|003   004|xxx   020|021   022|023   024|xxx
	     * -------   -------   -------   -------   -------   -------
	     * 010|011   012|013   014|xxx   xxx|xxx   xxx|xxx   xxx|xxx
	     *
	     * 100|101   102|103   104|xxx   120|121   122|123   124|xxx
	     * -------   -------   -------   -------   -------   -------
	     * 110|111   112|113   114|xxx   xxx|xxx   xxx|xxx   xxx|xxx
	     *
	     */
	    PackingScheme[PackingScheme["SHARED_BATCH"] = 1] = "SHARED_BATCH";
	})(PackingScheme = exports.PackingScheme || (exports.PackingScheme = {}));
	var TextureUsage;
	(function (TextureUsage) {
	    TextureUsage[TextureUsage["RENDER"] = 0] = "RENDER";
	    TextureUsage[TextureUsage["UPLOAD"] = 1] = "UPLOAD";
	    TextureUsage[TextureUsage["PIXELS"] = 2] = "PIXELS";
	    TextureUsage[TextureUsage["DOWNLOAD"] = 3] = "DOWNLOAD";
	})(TextureUsage = exports.TextureUsage || (exports.TextureUsage = {}));
	var PhysicalTextureType;
	(function (PhysicalTextureType) {
	    PhysicalTextureType[PhysicalTextureType["UNPACKED_FLOAT16"] = 0] = "UNPACKED_FLOAT16";
	    PhysicalTextureType[PhysicalTextureType["UNPACKED_FLOAT32"] = 1] = "UNPACKED_FLOAT32";
	    PhysicalTextureType[PhysicalTextureType["PACKED_4X1_UNSIGNED_BYTE"] = 2] = "PACKED_4X1_UNSIGNED_BYTE";
	    PhysicalTextureType[PhysicalTextureType["PACKED_2X2_FLOAT32"] = 3] = "PACKED_2X2_FLOAT32";
	    PhysicalTextureType[PhysicalTextureType["PACKED_2X2_FLOAT16"] = 4] = "PACKED_2X2_FLOAT16";
	})(PhysicalTextureType = exports.PhysicalTextureType || (exports.PhysicalTextureType = {}));
	function getUnpackedMatrixTextureShapeWidthHeight(rows, columns) {
	    return [columns, rows];
	}
	exports.getUnpackedMatrixTextureShapeWidthHeight = getUnpackedMatrixTextureShapeWidthHeight;
	function getUnpackedArraySizeFromMatrixSize(matrixSize, channelsPerTexture) {
	    return matrixSize * channelsPerTexture;
	}
	exports.getUnpackedArraySizeFromMatrixSize = getUnpackedArraySizeFromMatrixSize;
	function getColorMatrixTextureShapeWidthHeight(rows, columns) {
	    return [columns * 4, rows];
	}
	exports.getColorMatrixTextureShapeWidthHeight = getColorMatrixTextureShapeWidthHeight;
	/**
	 * Get shape for densely packed RGBA texture.
	 */
	function getDenseTexShape(shape) {
	    var size = util.sizeFromShape(shape);
	    var texelsNeeded = Math.ceil(size / 4);
	    return util.sizeToSquarishShape(texelsNeeded);
	}
	exports.getDenseTexShape = getDenseTexShape;
	function getMatrixSizeFromUnpackedArraySize(unpackedSize, channelsPerTexture) {
	    if (unpackedSize % channelsPerTexture !== 0) {
	        throw new Error("unpackedSize (" + unpackedSize + ") must be a multiple of " +
	            ("" + channelsPerTexture));
	    }
	    return unpackedSize / channelsPerTexture;
	}
	exports.getMatrixSizeFromUnpackedArraySize = getMatrixSizeFromUnpackedArraySize;
	function decodeMatrixFromUnpackedColorRGBAArray(unpackedArray, matrix, channels) {
	    var requiredSize = unpackedArray.length * channels / 4;
	    if (matrix.length < requiredSize) {
	        throw new Error("matrix length (" + matrix.length + ") must be >= " + requiredSize);
	    }
	    var dst = 0;
	    for (var src = 0; src < unpackedArray.length; src += 4) {
	        for (var c = 0; c < channels; c++) {
	            matrix[dst++] = unpackedArray[src + c];
	        }
	    }
	}
	exports.decodeMatrixFromUnpackedColorRGBAArray = decodeMatrixFromUnpackedColorRGBAArray;
	function getPackedMatrixTextureShapeWidthHeight(rows, columns) {
	    return [
	        Math.max(1, Math.ceil(columns / 2)), Math.max(1, Math.ceil(rows / 2))
	    ];
	}
	exports.getPackedMatrixTextureShapeWidthHeight = getPackedMatrixTextureShapeWidthHeight;
	function getPackedRGBAArraySizeFromMatrixShape(rows, columns) {
	    var _a = getPackedMatrixTextureShapeWidthHeight(rows, columns), w = _a[0], h = _a[1];
	    return w * h * 4;
	}
	exports.getPackedRGBAArraySizeFromMatrixShape = getPackedRGBAArraySizeFromMatrixShape;
	function getTextureConfig(
	// tslint:disable-next-line:no-any
	gl, textureHalfFloatExtension) {
	    // tslint:disable-next-line:no-any
	    var glany = gl;
	    var internalFormatFloat;
	    var internalFormatHalfFloat;
	    var internalFormatPackedHalfFloat;
	    var internalFormatPackedFloat;
	    var textureFormatFloat;
	    var downloadTextureFormat;
	    var downloadUnpackNumChannels;
	    var defaultNumChannels;
	    var textureTypeHalfFloat;
	    var textureTypeFloat;
	    if (environment_1.env().getNumber('WEBGL_VERSION') === 2) {
	        internalFormatFloat = glany.R32F;
	        internalFormatHalfFloat = glany.R16F;
	        internalFormatPackedHalfFloat = glany.RGBA16F;
	        internalFormatPackedFloat = glany.RGBA32F;
	        textureFormatFloat = glany.RED;
	        downloadUnpackNumChannels = 4;
	        defaultNumChannels = 1;
	        textureTypeHalfFloat = glany.HALF_FLOAT;
	        textureTypeFloat = glany.FLOAT;
	    }
	    else {
	        internalFormatFloat = gl.RGBA;
	        internalFormatHalfFloat = gl.RGBA;
	        internalFormatPackedHalfFloat = gl.RGBA;
	        internalFormatPackedFloat = glany.RGBA;
	        textureFormatFloat = gl.RGBA;
	        downloadUnpackNumChannels = 4;
	        defaultNumChannels = 4;
	        textureTypeHalfFloat = textureHalfFloatExtension != null ?
	            textureHalfFloatExtension.HALF_FLOAT_OES :
	            null;
	        textureTypeFloat = gl.FLOAT;
	    }
	    downloadTextureFormat = gl.RGBA;
	    return {
	        internalFormatFloat: internalFormatFloat,
	        internalFormatHalfFloat: internalFormatHalfFloat,
	        internalFormatPackedHalfFloat: internalFormatPackedHalfFloat,
	        internalFormatPackedFloat: internalFormatPackedFloat,
	        textureFormatFloat: textureFormatFloat,
	        downloadTextureFormat: downloadTextureFormat,
	        downloadUnpackNumChannels: downloadUnpackNumChannels,
	        defaultNumChannels: defaultNumChannels,
	        textureTypeHalfFloat: textureTypeHalfFloat,
	        textureTypeFloat: textureTypeFloat
	    };
	}
	exports.getTextureConfig = getTextureConfig;
	//# sourceMappingURL=tex_util.js.map

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(40);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(1412);
	
	var FlowProgressBar = function (_Component) {
	    _inherits(FlowProgressBar, _Component);
	
	    function FlowProgressBar(props) {
	        _classCallCheck(this, FlowProgressBar);
	
	        var _this = _possibleConstructorReturn(this, (FlowProgressBar.__proto__ || Object.getPrototypeOf(FlowProgressBar)).call(this, props));
	
	        _this.state = {
	            progress: null
	        };
	        return _this;
	    }
	
	    _createClass(FlowProgressBar, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            if (true) {
	                return null;
	            }
	            var config = {
	                headers: {
	                    'Content-Type': 'application/json',
	                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                }
	            };
	            _axios2.default.get(ROOT_URL + '/leads/steps/current_step', config).then(function (response) {
	                var progress = response.data.current_step / response.data.total_steps * 100;
	                progress = Math.floor(progress);
	                _this2.setState({
	                    progress: progress
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var progress = this.state.progress;
	
	
	            var progressBar = _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-lg-12 col-md-12 col-sm-12 text-center' },
	                    _react2.default.createElement(_reactBootstrap.ProgressBar, { className: 'flow-progress-bar', now: progress, label: progress + '%', max: 100, min: 0 })
	                )
	            );
	
	            var component = progress ? progressBar : _react2.default.createElement('div', { style: { marginTop: "40px" } });
	            return component;
	        }
	    }]);
	
	    return FlowProgressBar;
	}(_react.Component);
	
	exports.default = FlowProgressBar;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(85);
	
	var callBindBasic = __webpack_require__(247);
	
	/** @type {(thisArg: string, searchString: string, position?: number) => number} */
	var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);
	
	/** @type {import('.')} */
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		/* eslint no-extra-parens: 0 */
	
		var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBindBasic(/** @type {const} */ ([intrinsic]));
		}
		return intrinsic;
	};


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var undefined;
	
	var $Object = __webpack_require__(209);
	
	var $Error = __webpack_require__(1389);
	var $EvalError = __webpack_require__(1388);
	var $RangeError = __webpack_require__(568);
	var $ReferenceError = __webpack_require__(1390);
	var $SyntaxError = __webpack_require__(262);
	var $TypeError = __webpack_require__(22);
	var $URIError = __webpack_require__(1391);
	
	var abs = __webpack_require__(664);
	var floor = __webpack_require__(419);
	var max = __webpack_require__(1654);
	var min = __webpack_require__(1655);
	var pow = __webpack_require__(1656);
	var round = __webpack_require__(1657);
	var sign = __webpack_require__(1658);
	
	var $Function = Function;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = __webpack_require__(140);
	var $defineProperty = __webpack_require__(208);
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(633)();
	
	var getProto = __webpack_require__(1522);
	var $ObjectGPO = __webpack_require__(631);
	var $ReflectGPO = __webpack_require__(632);
	
	var $apply = __webpack_require__(335);
	var $call = __webpack_require__(336);
	
	var needsEval = {};
	
	var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		__proto__: null,
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': needsEval,
		'%AsyncGenerator%': needsEval,
		'%AsyncGeneratorFunction%': needsEval,
		'%AsyncIteratorPrototype%': needsEval,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
		'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': $Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': $EvalError,
		'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': needsEval,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': $Object,
		'%Object.getOwnPropertyDescriptor%': $gOPD,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': $RangeError,
		'%ReferenceError%': $ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': $URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	
		'%Function.prototype.call%': $call,
		'%Function.prototype.apply%': $apply,
		'%Object.defineProperty%': $defineProperty,
		'%Object.getPrototypeOf%': $ObjectGPO,
		'%Math.abs%': abs,
		'%Math.floor%': floor,
		'%Math.max%': max,
		'%Math.min%': min,
		'%Math.pow%': pow,
		'%Math.round%': round,
		'%Math.sign%': sign,
		'%Reflect.getPrototypeOf%': $ReflectGPO
	};
	
	if (getProto) {
		try {
			null.error; // eslint-disable-line no-unused-expressions
		} catch (e) {
			// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
			var errorProto = getProto(getProto(e));
			INTRINSICS['%Error.prototype%'] = errorProto;
		}
	}
	
	var doEval = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen && getProto) {
				value = getProto(gen.prototype);
			}
		}
	
		INTRINSICS[name] = value;
	
		return value;
	};
	
	var LEGACY_ALIASES = {
		__proto__: null,
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(213);
	var hasOwn = __webpack_require__(141);
	var $concat = bind.call($call, Array.prototype.concat);
	var $spliceApply = bind.call($apply, Array.prototype.splice);
	var $replace = bind.call($call, String.prototype.replace);
	var $strSlice = bind.call($call, String.prototype.slice);
	var $exec = bind.call($call, RegExp.prototype.exec);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) {
				value = doEval(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		if ($exec(/^%?[^%]*%?$/, name) === null) {
			throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
		}
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 87 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 88 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SquaredDifference = 'SquaredDifference';
	exports.Square = 'Square';
	exports.NonMaxSuppressionV5 = 'NonMaxSuppressionV5';
	/**
	 * TensorFlow.js-only kernels
	 */
	exports.FromPixels = 'FromPixels';
	//# sourceMappingURL=kernel_names.js.map

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_1 = __webpack_require__(75);
	var tensor_util_env_1 = __webpack_require__(17);
	var util = __webpack_require__(10);
	var axis_util_1 = __webpack_require__(108);
	var concat_split_1 = __webpack_require__(237);
	var operation_1 = __webpack_require__(18);
	var rand_1 = __webpack_require__(1064);
	var tensor_ops_1 = __webpack_require__(31);
	/**
	 * Broadcast an array to a compatible shape NumPy-style.
	 *
	 * The tensor's shape is compared to the broadcast shape from end to beginning.
	 * Ones are prepended to the tensor's shape until is has the same length as
	 * the broadcast shape. If input.shape[i]==shape[i], the (i+1)-th axis is
	 * already broadcast-compatible. If input.shape[i]==1 and shape[i]==N, then
	 * the input tensor is tiled N times along that axis (using tf.tile).
	 *
	 * @param input The tensor that is to be broadcasted.
	 * @param shape The input is to be broadcast to this shape.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Transformations'} */
	function broadcastTo_(x, shape) {
	    var input = tensor_util_env_1.convertToTensor(x, 'broadcastTo', 'x');
	    var xShape = input.shape;
	    if (shape.some(function (d) { return !(d > 0) || d % 1 !== 0; })) {
	        throw new Error("broadcastTo(): Invalid broadcast shape [" + shape + "].");
	    }
	    if (shape.length < input.rank) {
	        throw new Error("broadcastTo(): shape.length=" + shape.length + " < input.rank=" + input.rank + ".");
	    }
	    if (shape.length > input.rank) {
	        var newShape = input.shape.slice();
	        while (newShape.length < shape.length) {
	            newShape.unshift(1);
	        }
	        input = input.reshape(newShape);
	    }
	    var reps = Array.from(shape);
	    for (var i = shape.length - 1; i >= 0; i--) {
	        if (input.shape[i] === shape[i]) {
	            reps[i] = 1;
	        }
	        else if (input.shape[i] !== 1) {
	            throw new Error("broadcastTo(): [" + xShape + "] cannot be broadcast to [" + shape + "].");
	        }
	    }
	    var axes = reps.map(function (n, i) { return n > 1 ? i : -1; }).filter(function (i) { return i >= 0; });
	    if (axes.length === 0) {
	        return input.clone();
	    }
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.tile(input, reps); }, { input: input }, function (dy) {
	        return ({ input: function () { return dy.sum(axes, /*keepDims=*/ true); } });
	    });
	}
	/**
	 * Creates a new tensor with the same values and shape as the specified
	 * tensor.
	 *
	 * ```js
	 * const x = tf.tensor([1, 2]);
	 *
	 * x.clone().print();
	 * ```
	 *
	 * @param x The tensor to clone.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function clone_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'clone', null);
	    var der = function (dy) {
	        return { $x: function () { return dy.toFloat(); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function () { return engine_1.ENGINE.makeTensorFromDataId($x.dataId, $x.shape, $x.dtype); }, { $x: $x }, der);
	}
	/**
	 * Create an identity matrix.
	 *
	 * @param numRows Number of rows.
	 * @param numColumns Number of columns. Defaults to `numRows`.
	 * @param batchShape If provided, will add the batch shape to the beginning
	 *   of the shape of the returned `tf.Tensor` by repeating the identity
	 *   matrix.
	 * @param dtype Data type.
	 * @returns Identity matrix of the specified size and data type, possibly
	 *   with batch repetition if `batchShape` is specified.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function eye_(numRows, numColumns, batchShape, dtype) {
	    if (dtype === void 0) { dtype = 'float32'; }
	    if (numColumns == null) {
	        numColumns = numRows;
	    }
	    var buff = buffer([numRows, numColumns], dtype);
	    var n = numRows <= numColumns ? numRows : numColumns;
	    for (var i = 0; i < n; ++i) {
	        buff.set(1, i, i);
	    }
	    var out = buff.toTensor().as2D(numRows, numColumns);
	    if (batchShape == null) {
	        return out;
	    }
	    else {
	        if (batchShape.length === 1) {
	            return exports.tile(exports.expandDims(out, 0), [batchShape[0], 1, 1]);
	        }
	        else if (batchShape.length === 2) {
	            return exports.tile(exports.expandDims(exports.expandDims(out, 0), 0), [batchShape[0], batchShape[1], 1, 1]);
	        }
	        else if (batchShape.length === 3) {
	            return exports.tile(exports.expandDims(exports.expandDims(exports.expandDims(out, 0), 0), 0), [batchShape[0], batchShape[1], batchShape[2], 1, 1]);
	        }
	        else {
	            throw new Error("eye() currently supports only 1D and 2D " +
	                (
	                // tslint:disable-next-line:no-any
	                "batchShapes, but received " + batchShape.length + "D."));
	        }
	    }
	}
	/**
	 * Creates a `tf.Tensor` with values sampled from a normal distribution.
	 *
	 * ```js
	 * tf.randomNormal([2, 2]).print();
	 * ```
	 *
	 * @param shape An array of integers defining the output tensor shape.
	 * @param mean The mean of the normal distribution.
	 * @param stdDev The standard deviation of the normal distribution.
	 * @param dtype The data type of the output.
	 * @param seed The seed for the random number generator.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Random'} */
	function randomNormal_(shape, mean, stdDev, dtype, seed) {
	    if (mean === void 0) { mean = 0; }
	    if (stdDev === void 0) { stdDev = 1; }
	    if (dtype != null && dtype === 'bool') {
	        throw new Error("Unsupported data type " + dtype);
	    }
	    var randGauss = new rand_1.MPRandGauss(mean, stdDev, dtype, false /* truncated */, seed);
	    var res = buffer(shape, dtype);
	    for (var i = 0; i < res.values.length; i++) {
	        res.values[i] = randGauss.nextValue();
	    }
	    return res.toTensor();
	}
	/**
	 * Creates a `tf.Tensor` with values sampled from a truncated normal
	 * distribution.
	 *
	 * ```js
	 * tf.truncatedNormal([2, 2]).print();
	 * ```
	 *
	 * The generated values follow a normal distribution with specified mean and
	 * standard deviation, except that values whose magnitude is more than 2
	 * standard deviations from the mean are dropped and re-picked.
	 *
	 * @param shape An array of integers defining the output tensor shape.
	 * @param mean The mean of the normal distribution.
	 * @param stdDev The standard deviation of the normal distribution.
	 * @param dtype The data type of the output tensor.
	 * @param seed The seed for the random number generator.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function truncatedNormal_(shape, mean, stdDev, dtype, seed) {
	    if (mean === void 0) { mean = 0; }
	    if (stdDev === void 0) { stdDev = 1; }
	    if (dtype != null && dtype === 'bool') {
	        throw new Error("Unsupported data type " + dtype);
	    }
	    var randGauss = new rand_1.MPRandGauss(mean, stdDev, dtype, true /* truncated */, seed);
	    var res = buffer(shape, dtype);
	    for (var i = 0; i < res.values.length; i++) {
	        res.values[i] = randGauss.nextValue();
	    }
	    return res.toTensor();
	}
	/**
	 * Creates a `tf.Tensor` with values sampled from a gamma distribution.
	 *
	 * ```js
	 * tf.randomGamma([2, 2], 1).print();
	 * ```
	 *
	 * @param shape An array of integers defining the output tensor shape.
	 * @param alpha The shape parameter of the gamma distribution.
	 * @param beta The inverse scale parameter of the gamma distribution. Defaults
	 *     to 1.
	 * @param dtype The data type of the output. Defaults to float32.
	 * @param seed The seed for the random number generator.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Random'} */
	function randomGamma_(shape, alpha, beta, dtype, seed) {
	    if (beta === void 0) { beta = 1; }
	    if (dtype === void 0) { dtype = 'float32'; }
	    if (beta == null) {
	        beta = 1;
	    }
	    if (dtype == null) {
	        dtype = 'float32';
	    }
	    if (dtype !== 'float32' && dtype !== 'int32') {
	        throw new Error("Unsupported data type " + dtype);
	    }
	    var rgamma = new rand_1.RandGamma(alpha, beta, dtype, seed);
	    var res = buffer(shape, dtype);
	    for (var i = 0; i < res.values.length; i++) {
	        res.values[i] = rgamma.nextValue();
	    }
	    return res.toTensor();
	}
	/**
	 * Creates a `tf.Tensor` with values sampled from a uniform distribution.
	 *
	 * The generated values follow a uniform distribution in the range [minval,
	 * maxval). The lower bound minval is included in the range, while the upper
	 * bound maxval is excluded.
	 *
	 * ```js
	 * tf.randomUniform([2, 2]).print();
	 * ```
	 *
	 * @param shape An array of integers defining the output tensor shape.
	 * @param minval The lower bound on the range of random values to generate.
	 *   Defaults to 0.
	 * @param maxval The upper bound on the range of random values to generate.
	 *   Defaults to 1.
	 * @param dtype The data type of the output tensor. Defaults to 'float32'.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Random'} */
	function randomUniform_(shape, minval, maxval, dtype, seed) {
	    if (minval === void 0) { minval = 0; }
	    if (maxval === void 0) { maxval = 1; }
	    if (dtype === void 0) { dtype = 'float32'; }
	    var res = buffer(shape, dtype);
	    var random = new rand_1.UniformRandom(minval, maxval, null, seed);
	    for (var i = 0; i < res.values.length; i++) {
	        res.values[i] = random.nextValue();
	    }
	    return res.toTensor();
	}
	/**
	 * Creates a `tf.Tensor` with values sampled from a random number generator
	 * function defined by the user.
	 *
	 * @param shape An array of integers defining the output tensor shape.
	 * @param randFunction A random number generator function which is called
	 * for each element in the output tensor.
	 * @param dtype The data type of the output tensor. Defaults to 'float32'.
	 */
	function rand_(shape, randFunction, dtype) {
	    var size = util.sizeFromShape(shape);
	    var values = null;
	    if (dtype == null || dtype === 'float32') {
	        values = new Float32Array(size);
	    }
	    else if (dtype === 'int32') {
	        values = new Int32Array(size);
	    }
	    else if (dtype === 'bool') {
	        values = new Uint8Array(size);
	    }
	    else {
	        throw new Error("Unknown data type " + dtype);
	    }
	    for (var i = 0; i < size; i++) {
	        values[i] = randFunction();
	    }
	    return engine_1.ENGINE.makeTensor(values, shape, dtype);
	}
	/**
	 * Creates a `tf.Tensor` with values drawn from a multinomial distribution.
	 *
	 * ```js
	 * const probs = tf.tensor([.75, .25]);
	 * tf.multinomial(probs, 3).print();
	 * ```
	 *
	 * @param logits 1D array with unnormalized log-probabilities, or
	 *     2D array of shape `[batchSize, numOutcomes]`. See the `normalized`
	 *     parameter.
	 * @param numSamples Number of samples to draw for each row slice.
	 * @param seed The seed number.
	 * @param normalized Whether the provided `logits` are normalized true
	 *     probabilities (sum to 1). Defaults to false.
	 * @return 1D array of shape `[numSamples]`, or 2D array of shape
	 *     `[batchSize, numSamples]`, depending on the rank of the input.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Random'} */
	function multinomial_(logits, numSamples, seed, normalized) {
	    if (normalized === void 0) { normalized = false; }
	    var $logits = tensor_util_env_1.convertToTensor(logits, 'logits', 'multinomial');
	    var numOutcomes = $logits.size;
	    var origRank = $logits.rank;
	    if (numOutcomes < 2) {
	        throw new Error("Error in multinomial: you need at least 2 outcomes, but got " +
	            (numOutcomes + "."));
	    }
	    if (origRank > 2) {
	        throw new Error("Rank of probabilities must be 1 or 2, but is " + origRank);
	    }
	    seed = seed || Math.random();
	    var logits2D = origRank === 1 ? $logits.as2D(1, -1) : $logits;
	    var res = engine_1.ENGINE.runKernelFunc(function (backend) { return backend.multinomial(logits2D, normalized, numSamples, seed); }, { logits2D: logits2D });
	    return origRank === 1 ? res.as1D() : res;
	}
	/**
	 * Creates a one-hot `tf.Tensor`. The locations represented by `indices` take
	 * value `onValue` (defaults to 1), while all other locations take value
	 * `offValue` (defaults to 0). If `indices` is rank `R`, the output has rank
	 * `R+1` with the last axis of size `depth`.
	 *
	 * ```js
	 * tf.oneHot(tf.tensor1d([0, 1], 'int32'), 3).print();
	 * ```
	 *
	 * @param indices `tf.Tensor` of indices with dtype `int32`.
	 * @param depth The depth of the one hot dimension.
	 * @param onValue A number used to fill in the output when the index matches
	 * the location.
	 * @param offValue A number used to fill in the output when the index does
	 *     not match the location.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function oneHot_(indices, depth, onValue, offValue) {
	    if (onValue === void 0) { onValue = 1; }
	    if (offValue === void 0) { offValue = 0; }
	    if (depth < 2) {
	        throw new Error("Error in oneHot: depth must be >=2, but it is " + depth);
	    }
	    var $indices = tensor_util_env_1.convertToTensor(indices, 'indices', 'oneHot', 'int32');
	    var outShape = $indices.shape.concat([depth]);
	    $indices = $indices.flatten();
	    var grad = function (dy) {
	        return { $indices: function () { return tensor_ops_1.zeros($indices.shape, 'float32'); } };
	    };
	    var result = engine_1.ENGINE.runKernelFunc(function (backend) { return backend.oneHot($indices, depth, onValue, offValue); }, { $indices: $indices }, grad);
	    return result.reshape(outShape);
	}
	/**
	 * Reshapes a `tf.Tensor` to a given shape.
	 *
	 * Given an input tensor, returns a new tensor with the same values as the
	 * input tensor with shape `shape`.
	 *
	 * If one component of shape is the special value -1, the size of that
	 * dimension is computed so that the total size remains constant. In
	 * particular, a shape of [-1] flattens into 1-D. At most one component of
	 * shape can be -1.
	 *
	 * If shape is 1-D or higher, then the operation returns a tensor with shape
	 * shape filled with the values of tensor. In this case, the number of
	 * elements implied by shape must be the same as the number of elements in
	 * tensor.
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, 3, 4]);
	 * x.reshape([2, 2]).print();
	 * ```
	 *
	 * @param x The input tensor to be reshaped.
	 * @param shape An array of integers defining the output tensor shape.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Transformations'} */
	function reshape_(x, shape) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'reshape', null);
	    shape = util.inferFromImplicitShape(shape, $x.size);
	    util.assert($x.size === util.sizeFromShape(shape), function () { return 'new shape and old shape must have the same number of elements.'; });
	    var grad = function (dy) {
	        return { x: function () { return dy.reshape($x.shape); } };
	    };
	    var attrs = { shape: shape };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.reshape($x, shape); }, { x: $x }, grad, 'Reshape', attrs);
	}
	/**
	 * Removes dimensions of size 1 from the shape of a `tf.Tensor`.
	 *
	 * ```js
	 * const x = tf.tensor([1, 2, 3, 4], [1, 1, 4]);
	 * x.squeeze().print();
	 * ```
	 *
	 * @param x The input tensor to be squeezed.
	 * @param axis An optional list of numbers. If specified, only
	 *     squeezes the dimensions listed. The dimension index starts at 0. It
	 * is an error to squeeze a dimension that is not 1.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Transformations'} */
	function squeeze_(x, axis) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'squeeze');
	    return exports.reshape($x, util.squeezeShape($x.shape, axis).newShape);
	}
	/**
	 * Casts a `tf.Tensor` to a new dtype.
	 *
	 * ```js
	 * const x = tf.tensor1d([1.5, 2.5, 3]);
	 * tf.cast(x, 'int32').print();
	 * ```
	 * @param x The input tensor to be casted.
	 * @param dtype The dtype to cast the input tensor to.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Transformations'} */
	function cast_(x, dtype) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'cast');
	    // Sanity checks.
	    if (!util.isValidDtype(dtype)) {
	        throw new Error("Failed to cast to unknown dtype " + dtype);
	    }
	    if (dtype === 'string' && $x.dtype !== 'string' ||
	        dtype !== 'string' && $x.dtype === 'string') {
	        throw new Error('Only strings can be casted to strings');
	    }
	    var grad = function (dy) {
	        return { x: function () { return dy.clone(); } };
	    };
	    var attrs = { dtype: dtype };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.cast($x, dtype); }, { x: $x }, grad, 'Cast', attrs);
	}
	/**
	 * Construct a tensor by repeating it the number of times given by reps.
	 *
	 * This operation creates a new tensor by replicating `input` `reps`
	 * times. The output tensor's i'th dimension has `input.shape[i] *
	 * reps[i]` elements, and the values of `input` are replicated
	 * `reps[i]` times along the i'th dimension. For example, tiling
	 * `[a, b, c, d]` by `[2]` produces `[a, b, c, d, a, b, c, d]`.
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 2]);
	 *
	 * a.tile([2]).print();    // or a.tile([2])
	 * ```
	 *
	 * ```js
	 * const a = tf.tensor2d([1, 2, 3, 4], [2, 2]);
	 *
	 * a.tile([1, 2]).print();  // or a.tile([1, 2])
	 * ```
	 * @param x The tensor to tile.
	 * @param reps Determines the number of replications per dimension.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Slicing and Joining'} */
	function tile_(x, reps) {
	    var parseAs = null;
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'tile', parseAs);
	    util.assert($x.rank === reps.length, function () { return "Error in transpose: rank of input " + $x.rank + " " +
	        ("must match length of reps " + reps + "."); });
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        var derX = function () {
	            var xGrad = tensor_ops_1.zerosLike($x);
	            // TODO(cais): Maybe reduce memory footprint by avoiding repeated
	            // slicing.
	            if ($x.rank === 1) {
	                for (var i = 0; i < reps[0]; ++i) {
	                    xGrad = xGrad.add(dy.slice([i * $x.shape[0]], [$x.shape[0]]));
	                }
	            }
	            else if ($x.rank === 2) {
	                for (var i = 0; i < reps[0]; ++i) {
	                    for (var j = 0; j < reps[1]; ++j) {
	                        xGrad = xGrad.add(dy.slice([i * $x.shape[0], j * $x.shape[1]], [$x.shape[0], $x.shape[1]]));
	                    }
	                }
	            }
	            else if ($x.rank === 3) {
	                for (var i = 0; i < reps[0]; ++i) {
	                    for (var j = 0; j < reps[1]; ++j) {
	                        for (var k = 0; k < reps[2]; ++k) {
	                            xGrad = xGrad.add(dy.slice([i * $x.shape[0], j * $x.shape[1], k * $x.shape[2]], [$x.shape[0], $x.shape[1], $x.shape[2]]));
	                        }
	                    }
	                }
	            }
	            else if ($x.rank === 4) {
	                for (var i = 0; i < reps[0]; ++i) {
	                    for (var j = 0; j < reps[1]; ++j) {
	                        for (var k = 0; k < reps[2]; ++k) {
	                            for (var l = 0; l < reps[3]; ++l) {
	                                xGrad = xGrad.add(dy.slice([
	                                    i * $x.shape[0], j * $x.shape[1], k * $x.shape[2],
	                                    l * $x.shape[3]
	                                ], [$x.shape[0], $x.shape[1], $x.shape[2], $x.shape[3]]));
	                            }
	                        }
	                    }
	                }
	            }
	            else {
	                throw new Error("Gradient for tile operation is not implemented for rank-" +
	                    ($x.rank + " tensors yet."));
	            }
	            return xGrad;
	        };
	        return { x: derX };
	    };
	    var inputsToSave = [$x];
	    var attrs = { reps: reps };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.tile($x, reps);
	        save([$x]);
	        return res;
	    }, { x: $x }, grad, 'Tile', attrs, inputsToSave);
	}
	/**
	 * Pads a `tf.Tensor1D` with a given value and paddings. See `pad` for details.
	 */
	function pad1d_(x, paddings, constantValue) {
	    if (constantValue === void 0) { constantValue = 0; }
	    util.assert(paddings.length === 2, function () { return 'Invalid number of paddings. Must be length of 2.'; });
	    return exports.pad(x, [paddings], constantValue);
	}
	/**
	 * Pads a `tf.Tensor2D` with a given value and paddings. See `pad` for details.
	 */
	function pad2d_(x, paddings, constantValue) {
	    if (constantValue === void 0) { constantValue = 0; }
	    util.assert(paddings.length === 2 && paddings[0].length === 2 &&
	        paddings[1].length === 2, function () { return 'Invalid number of paddings. Must be length of 2 each.'; });
	    return exports.pad(x, paddings, constantValue);
	}
	/**
	 * Pads a `tf.Tensor3D` with a given value and paddings. See `pad` for details.
	 */
	function pad3d_(x, paddings, constantValue) {
	    if (constantValue === void 0) { constantValue = 0; }
	    util.assert(paddings.length === 3 && paddings[0].length === 2 &&
	        paddings[1].length === 2 && paddings[2].length === 2, function () { return 'Invalid number of paddings. Must be length of 2 each.'; });
	    return exports.pad(x, paddings, constantValue);
	}
	/**
	 * Pads a `tf.Tensor4D` with a given value and paddings. See `pad` for details.
	 */
	function pad4d_(x, paddings, constantValue) {
	    if (constantValue === void 0) { constantValue = 0; }
	    util.assert(paddings.length === 4 && paddings[0].length === 2 &&
	        paddings[1].length === 2 && paddings[2].length === 2 &&
	        paddings[3].length === 2, function () { return 'Invalid number of paddings. Must be length of 2 each.'; });
	    return exports.pad(x, paddings, constantValue);
	}
	/**
	 * Pads a `tf.Tensor` with a given value and paddings.
	 *
	 * This operation currently only implements the `CONSTANT` mode.
	 *
	 * Also available are stricter rank-specific methods with the same signature
	 * as this method that assert that `paddings` is of given length.
	 *   - `tf.pad1d`
	 *   - `tf.pad2d`
	 *   - `tf.pad3d`
	 *   - `tf.pad4d`
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, 3, 4]);
	 * x.pad([[1, 2]]).print();
	 * ```
	 * @param x The tensor to pad.
	 * @param paddings An array of length `R` (the rank of the tensor), where
	 * each element is a length-2 tuple of ints `[padBefore, padAfter]`,
	 * specifying how much to pad along each dimension of the tensor.
	 * @param constantValue The pad value to use. Defaults to 0.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Transformations'} */
	function pad_(x, paddings, constantValue) {
	    if (constantValue === void 0) { constantValue = 0; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'pad');
	    if ($x.rank === 0) {
	        throw new Error('pad(scalar) is not defined. Pass non-scalar to pad');
	    }
	    var grad = function (dy) {
	        // Pad introduces values around the original tensor, so the gradient
	        // slices the original shape out of the gradient.
	        var begin = paddings.map(function (p) { return p[0]; });
	        return { x: function () { return dy.slice(begin, $x.shape); } };
	    };
	    var attrs = { paddings: paddings, constantValue: constantValue };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.pad($x, paddings, constantValue); }, { x: $x }, grad, 'PadV2', attrs);
	}
	/**
	 * Stacks a list of rank-`R` `tf.Tensor`s into one rank-`(R+1)` `tf.Tensor`.
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 2]);
	 * const b = tf.tensor1d([3, 4]);
	 * const c = tf.tensor1d([5, 6]);
	 * tf.stack([a, b, c]).print();
	 * ```
	 *
	 * @param tensors A list of tensor objects with the same shape and dtype.
	 * @param axis The axis to stack along. Defaults to 0 (the first dim).
	 */
	/** @doc {heading: 'Tensors', subheading: 'Slicing and Joining'} */
	function stack_(tensors, axis) {
	    if (axis === void 0) { axis = 0; }
	    var $tensors = tensor_util_env_1.convertToTensorArray(tensors, 'tensors', 'stack');
	    util.assert($tensors.length >= 1, function () { return 'Pass at least one tensor to tf.stack'; });
	    if ($tensors.length === 1) {
	        return $tensors[0].expandDims(axis);
	    }
	    var rank = $tensors[0].rank;
	    var shape = $tensors[0].shape;
	    var dtype = $tensors[0].dtype;
	    util.assert(axis <= rank, function () { return 'Axis must be <= rank of the tensor'; });
	    $tensors.forEach(function (t) {
	        util.assertShapesMatch(shape, t.shape, 'All tensors passed to stack must have matching shapes');
	    });
	    $tensors.forEach(function (t) {
	        util.assert(dtype === t.dtype, function () { return 'All tensors passed to stack must have matching dtypes'; });
	    });
	    var expandedTensors = $tensors.map(function (t) { return t.expandDims(axis); });
	    return concat_split_1.concat(expandedTensors, axis);
	}
	/**
	 * This operation reshapes the "batch" dimension 0 into `M + 1` dimensions of
	 * shape `blockShape + [batch]`, interleaves these blocks back into the grid
	 * defined by the spatial dimensions `[1, ..., M]`, to obtain a result with
	 * the same rank as the input. The spatial dimensions of this intermediate
	 * result are then optionally cropped according to `crops` to produce the
	 * output. This is the reverse of `tf.spaceToBatchND`. See below for a precise
	 * description.
	 *
	 * ```js
	 * const x = tf.tensor4d([1, 2, 3, 4], [4, 1, 1, 1]);
	 * const blockShape = [2, 2];
	 * const crops = [[0, 0], [0, 0]];
	 *
	 * x.batchToSpaceND(blockShape, crops).print();
	 * ```
	 *
	 * @param x A `tf.Tensor`. N-D with `x.shape` = `[batch] + spatialShape +
	 * remainingShape`, where spatialShape has `M` dimensions.
	 * @param blockShape A 1-D array. Must have shape `[M]`, all values must
	 * be >= 1.
	 * @param crops A 2-D array.  Must have shape `[M, 2]`, all values must be >= 0.
	 * `crops[i] = [cropStart, cropEnd]` specifies the amount to crop from input
	 * dimension `i + 1`, which corresponds to spatial dimension `i`. It is required
	 * that `cropStart[i] + cropEnd[i] <= blockShape[i] * inputShape[i + 1]`
	 *
	 * This operation is equivalent to the following steps:
	 *
	 * 1. Reshape `x` to `reshaped` of shape: `[blockShape[0], ...,
	 * blockShape[M-1], batch / prod(blockShape), x.shape[1], ...,
	 * x.shape[N-1]]`
	 *
	 * 2. Permute dimensions of `reshaped`to produce `permuted` of shape `[batch /
	 * prod(blockShape),x.shape[1], blockShape[0], ..., x.shape[M],
	 * blockShape[M-1],x.shape[M+1], ..., x.shape[N-1]]`
	 *
	 * 3. Reshape `permuted` to produce `reshapedPermuted` of shape `[batch /
	 * prod(blockShape),x.shape[1] * blockShape[0], ..., x.shape[M] *
	 * blockShape[M-1],x.shape[M+1], ..., x.shape[N-1]]`
	 *
	 * 4. Crop the start and end of dimensions `[1, ..., M]` of `reshapedPermuted`
	 * according to `crops` to produce the output of shape: `[batch /
	 * prod(blockShape),x.shape[1] * blockShape[0] - crops[0,0] - crops[0,1],
	 * ..., x.shape[M] * blockShape[M-1] - crops[M-1,0] -
	 * crops[M-1,1],x.shape[M+1], ..., x.shape[N-1]]`
	 */
	/** @doc {heading: 'Tensors', subheading: 'Transformations'} */
	function batchToSpaceND_(x, blockShape, crops) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'batchToSpaceND');
	    var prod = blockShape.reduce(function (a, b) { return a * b; });
	    util.assert($x.rank >= 1 + blockShape.length, function () { return "input rank is " + $x.rank + " but should be > than blockShape.length " + blockShape.length; });
	    util.assert(crops.length === blockShape.length, function () { return "crops.length is " + crops.length + " but should be equal to blockShape.length  " + blockShape.length; });
	    util.assert($x.shape[0] % prod === 0, function () { return "input tensor batch is " + $x.shape[0] + " but is not divisible by the product of " +
	        ("the elements of blockShape " + blockShape.join(' * ') + " === " + prod); });
	    var grad = function (dy) {
	        return { $x: function () { return dy.spaceToBatchND(blockShape, crops); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.batchToSpaceND($x, blockShape, crops); }, { $x: $x }, grad);
	}
	/**
	 * This operation divides "spatial" dimensions `[1, ..., M]` of the input into
	 * a grid of blocks of shape `blockShape`, and interleaves these blocks with
	 * the "batch" dimension (0) such that in the output, the spatial
	 * dimensions `[1, ..., M]` correspond to the position within the grid,
	 * and the batch dimension combines both the position within a spatial block
	 * and the original batch position. Prior to division into blocks,
	 * the spatial dimensions of the input are optionally zero padded
	 * according to `paddings`. See below for a precise description.
	 *
	 * ```js
	 * const x = tf.tensor4d([1, 2, 3, 4], [1, 2, 2, 1]);
	 * const blockShape = [2, 2];
	 * const paddings = [[0, 0], [0, 0]];
	 *
	 * x.spaceToBatchND(blockShape, paddings).print();
	 * ```
	 *
	 * @param x A `tf.Tensor`. N-D with `x.shape` = `[batch] + spatialShape +
	 * remainingShape`, where spatialShape has `M` dimensions.
	 * @param blockShape A 1-D array. Must have shape `[M]`, all values must
	 * be >= 1.
	 * @param paddings A 2-D array. Must have shape `[M, 2]`, all values must be >=
	 *     0. `paddings[i] = [padStart, padEnd]` specifies the amount to zero-pad
	 * from input dimension `i + 1`, which corresponds to spatial dimension `i`. It
	 * is required that
	 * `(inputShape[i + 1] + padStart + padEnd) % blockShape[i] === 0`
	 *
	 * This operation is equivalent to the following steps:
	 *
	 * 1. Zero-pad the start and end of dimensions `[1, ..., M]` of the input
	 * according to `paddings` to produce `padded` of shape paddedShape.
	 *
	 * 2. Reshape `padded` to `reshapedPadded` of shape:
	 * `[batch] + [paddedShape[1] / blockShape[0], blockShape[0], ...,
	 * paddedShape[M] / blockShape[M-1], blockShape[M-1]] + remainingShape`
	 *
	 * 3. Permute dimensions of `reshapedPadded` to produce `permutedReshapedPadded`
	 * of shape: `blockShape + [batch] + [paddedShape[1] / blockShape[0], ...,
	 * paddedShape[M] / blockShape[M-1]] + remainingShape`
	 *
	 * 4. Reshape `permutedReshapedPadded` to flatten `blockShape` into the
	 * batch dimension, producing an output tensor of shape:
	 * `[batch * prod(blockShape)] + [paddedShape[1] / blockShape[0], ...,
	 * paddedShape[M] / blockShape[M-1]] + remainingShape`
	 */
	/** @doc {heading: 'Tensors', subheading: 'Transformations'} */
	function spaceToBatchND_(x, blockShape, paddings) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'spaceToBatchND');
	    util.assert($x.rank >= 1 + blockShape.length, function () { return "input rank " + $x.rank + " should be > than [blockShape] " + blockShape.length; });
	    util.assert(paddings.length === blockShape.length, function () { return "paddings.shape[0] " + paddings.length + " must be equal to [blockShape] " + blockShape.length; });
	    util.assert($x.shape.reduce(function (a, b, i) {
	        if (i > 0 && i <= blockShape.length) {
	            return a &&
	                ((b + paddings[i - 1][0] + paddings[i - 1][1]) %
	                    blockShape[i - 1] ===
	                    0);
	        }
	        return a;
	    }, true), function () { return "input spatial dimensions " + $x.shape.slice(1) + " with paddings " + paddings.toString() + " must be divisible by blockShapes " + blockShape.toString(); });
	    var grad = function (dy) {
	        return { $x: function () { return dy.batchToSpaceND(blockShape, paddings); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.spaceToBatchND($x, blockShape, paddings); }, { $x: $x }, grad);
	}
	/**
	 * Unstacks a `tf.Tensor` of rank-`R` into a list of rank-`(R-1)` `tf.Tensor`s.
	 *
	 * ```js
	 * const a = tf.tensor2d([1, 2, 3, 4], [2, 2]);
	 *
	 * tf.unstack(a).forEach(tensor => tensor.print());
	 * ```
	 *
	 * @param x A tensor object.
	 * @param axis The axis to unstack along. Defaults to 0 (the first dim).
	 */
	/** @doc {heading: 'Tensors', subheading: 'Slicing and Joining'} */
	function unstack_(x, axis) {
	    if (axis === void 0) { axis = 0; }
	    axis = axis || 0;
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'unstack');
	    util.assert(axis >= -$x.shape.length && axis < $x.shape.length, function () {
	        return "Axis = " + axis + " is not in [-" + $x.shape.length + ", " + $x.shape.length + ")";
	    });
	    if (axis < 0) {
	        axis += $x.shape.length;
	    }
	    var grad = function (dy) {
	        return { x: function () { return exports.stack(dy, axis); } };
	    };
	    var attrs = { axis: axis };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.unstack($x, axis); }, { x: $x }, grad, 'Unpack', attrs);
	}
	/**
	 * Computes the cumulative sum of a `tf.Tensor` along `axis`.
	 *
	 * ```js
	 * const x = tf.tensor([1, 2, 3, 4]);
	 * x.cumsum().print();
	 * ```
	 * ```js
	 * const x = tf.tensor([[1, 2], [3, 4]]);
	 * x.cumsum().print();
	 * ```
	 *
	 * @param x The input tensor to be summed.
	 * @param axis The axis along which to sum. Optional. Defaults to 0.
	 * @param exclusive Whether to perform exclusive cumulative sum. Optional.
	 *     Defaults to false. If set to true then the sum of each tensor entry
	 *     does not include its own value, but only the values previous to it
	 *     along the specified axis.
	 * @param reverse Whether to sum in the opposite direction. Optional.
	 *     Defaults to false.
	 */
	/** @doc {heading: 'Operations', subheading: 'Scan'} */
	function cumsum_(x, axis, exclusive, reverse) {
	    if (axis === void 0) { axis = 0; }
	    if (exclusive === void 0) { exclusive = false; }
	    if (reverse === void 0) { reverse = false; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'cumsum');
	    axis = axis | 0;
	    var permutation = axis_util_1.getAxesPermutation([axis], $x.rank);
	    var permutedX = $x;
	    if (permutation != null) {
	        permutedX = $x.transpose(permutation);
	    }
	    var permutedAxis = axis_util_1.getInnerMostAxes(1, $x.rank)[0];
	    var grad = function (dy) {
	        return { permutedX: function () { return dy.cumsum(axis, exclusive, !reverse); } };
	    };
	    var value = engine_1.ENGINE.runKernelFunc(function (backend) { return backend.cumsum(permutedX, permutedAxis, exclusive, reverse); }, { permutedX: permutedX }, grad);
	    if (permutation != null) {
	        value = value.transpose(permutation);
	    }
	    return value;
	}
	/**
	 * Returns a `tf.Tensor` that has expanded rank, by inserting a dimension
	 * into the tensor's shape.
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, 3, 4]);
	 * const axis = 1;
	 * x.expandDims(axis).print();
	 * ```
	 *
	 * @param x The input tensor whose dimensions to be expanded.
	 * @param axis The dimension index at which to insert shape of `1`. Defaults
	 *     to 0 (the first dimension).
	 */
	/** @doc {heading: 'Tensors', subheading: 'Transformations'} */
	function expandDims_(x, axis) {
	    if (axis === void 0) { axis = 0; }
	    var parseAs = null;
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'expandDims', parseAs);
	    util.assert(axis <= $x.rank, function () { return 'Axis must be <= rank of the tensor'; });
	    var newShape = $x.shape.slice();
	    if (axis < 0) {
	        // Negative value is counted from the tail of rank.
	        util.assert(-($x.rank + 1) <= axis, function () { return "Axis must be in the interval [" + -($x.rank + 1) + ", " + $x.rank + "]"; });
	        axis = $x.rank + axis + 1;
	    }
	    newShape.splice(axis, 0, 1);
	    return exports.reshape($x, newShape);
	}
	/**
	 * Rearranges data from depth into blocks of spatial data. More specifically,
	 * this op outputs a copy of the input tensor where values from the `depth`
	 * dimension are moved in spatial blocks to the `height` and `width` dimensions.
	 * The attr `blockSize` indicates the input block size and how the data is
	 * moved.
	 *
	 *  - Chunks of data of size `blockSize * blockSize` from depth are rearranged
	 * into non-overlapping blocks of size `blockSize x blockSize`
	 *
	 *  - The width the output tensor is `inputWidth * blockSize`, whereas the
	 * height is `inputHeight * blockSize`
	 *
	 *  - The Y, X coordinates within each block of the output image are determined
	 * by the high order component of the input channel index
	 *
	 *  - The depth of the input tensor must be divisible by `blockSize *
	 * blockSize`
	 *
	 * The `dataFormat` attr specifies the layout of the input and output tensors
	 * with the following options: "NHWC": [ `batch, height, width, channels` ]
	 * "NCHW": [ `batch, channels, height, width` ]
	 *
	 * ```js
	 * const x = tf.tensor4d([1, 2, 3, 4], [1, 1, 1, 4]);
	 * const blockSize = 2;
	 * const dataFormat = "NHWC";
	 *
	 * tf.depthToSpace(x, blockSize, dataFormat).print();
	 * ```
	 *
	 * @param x The input tensor of rank 4
	 * @param blockSIze  An `int` that is `>= 2`. The size of the spatial block
	 * @param dataFormat An optional string from: "NHWC", "NCHW". Defaults to "NHWC"
	 */
	/** @doc {heading: 'Tensors', subheading: 'Transformations'} */
	function depthToSpace_(x, blockSize, dataFormat) {
	    if (dataFormat === void 0) { dataFormat = 'NHWC'; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'depthToSpace');
	    var inputHeight = (dataFormat === 'NHWC') ? $x.shape[1] : $x.shape[2];
	    var inputWidth = (dataFormat === 'NHWC') ? $x.shape[2] : $x.shape[3];
	    var inputDepth = (dataFormat === 'NHWC') ? $x.shape[3] : $x.shape[1];
	    util.assert(inputHeight * blockSize >= 0, function () { return "Negative dimension size caused by overflow when multiplying\n      " + inputHeight + " and " + blockSize + "  for depthToSpace with input shape\n      " + $x.shape; });
	    util.assert(inputWidth * blockSize >= 0, function () { return "Negative dimension size caused by overflow when multiplying\n      " + inputWidth + " and " + blockSize + " for depthToSpace with input shape\n          " + $x.shape; });
	    util.assert((inputDepth % (blockSize * blockSize) === 0), function () { return "Dimension size must be evenly divisible by " + blockSize * blockSize + " but is " + inputDepth + " for depthToSpace with input shape " + $x.shape; });
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.depthToSpace($x, blockSize, dataFormat); }, { $x: $x });
	}
	/**
	 * Computes the difference between two lists of numbers.
	 *
	 * Given a Tensor `x` and a Tensor `y`, this operation returns a Tensor `out`
	 * that represents all values that are in `x` but not in `y`. The returned
	 * Tensor `out` is sorted in the same order that the numbers appear in `x`
	 * (duplicates are preserved). This operation also returns a Tensor indices that
	 * represents the position of each out element in `x`. In other words:
	 *
	 * `out[i] = x[idx[i]] for i in [0, 1, ..., out.length - 1]`
	 *
	 * ```js
	 * const x = [1, 2, 3, 4, 5, 6];
	 * const y = [1, 3, 5];
	 *
	 * const [out, indices] = await tf.setdiff1dAsync(x, y);
	 * out.print(); // [2, 4, 6]
	 * indices.print(); // [1, 3, 5]
	 * ```
	 *
	 * @param x 1-D Tensor. Values to keep.
	 * @param y 1-D Tensor. Must have the same type as x. Values to exclude in the
	 *     output.
	 * @returns Promise of Tensor tuple [out, indices].
	 *  out: Tensor with the same type as x.
	 *  indices: A Tensor of type int32.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Transformations'} */
	function setdiff1dAsync_(x, y) {
	    return __awaiter(this, void 0, void 0, function () {
	        var $x, $y, xVals, yVals, ySet, outputSize, i, buffer, indices, i, p;
	        return __generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    $x = tensor_util_env_1.convertToTensor(x, 'x', 'setdiff1d');
	                    $y = tensor_util_env_1.convertToTensor(y, 'y', 'setdiff1d');
	                    util.assert($x.dtype === $y.dtype, function () { return "x and y should have the same dtype, but got x (" + $x.dtype + ") and y (" + $y.dtype + ")."; });
	                    util.assert($x.rank === 1, function () { return "x should be 1D tensor, but got x (" + $x.shape + ")."; });
	                    util.assert($y.rank === 1, function () { return "y should be 1D tensor, but got y (" + $y.shape + ")."; });
	                    return [4 /*yield*/, $x.data()];
	                case 1:
	                    xVals = _a.sent();
	                    return [4 /*yield*/, $y.data()];
	                case 2:
	                    yVals = _a.sent();
	                    ySet = new Set(yVals);
	                    outputSize = 0;
	                    for (i = 0; i < xVals.length; i++) {
	                        if (!ySet.has(xVals[i])) {
	                            outputSize++;
	                        }
	                    }
	                    buffer = new tensor_1.TensorBuffer([outputSize], $x.dtype);
	                    indices = new tensor_1.TensorBuffer([outputSize], 'int32');
	                    for (i = 0, p = 0; i < xVals.length; i++) {
	                        if (!ySet.has(xVals[i])) {
	                            buffer.values[p] = xVals[i];
	                            indices.values[p] = i;
	                            p++;
	                        }
	                    }
	                    return [2 /*return*/, [buffer.toTensor(), indices.toTensor()]];
	            }
	        });
	    });
	}
	/**
	 * Creates an empty `tf.TensorBuffer` with the specified `shape` and `dtype`.
	 *
	 * The values are stored in CPU as `TypedArray`. Fill the buffer using
	 * `buffer.set()`, or by modifying directly `buffer.values`.
	 *
	 * When done, call `buffer.toTensor()` to get an immutable `tf.Tensor` with
	 * those values.
	 *
	 * ```js
	 * // Create a buffer and set values at particular indices.
	 * const buffer = tf.buffer([2, 2]);
	 * buffer.set(3, 0, 0);
	 * buffer.set(5, 1, 0);
	 *
	 * // Convert the buffer back to a tensor.
	 * buffer.toTensor().print();
	 * ```
	 *
	 * @param shape An array of integers defining the output tensor shape.
	 * @param dtype The dtype of the buffer. Defaults to 'float32'.
	 * @param values The values of the buffer as `TypedArray`. Defaults to
	 * zeros.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function buffer(shape, dtype, values) {
	    if (dtype === void 0) { dtype = 'float32'; }
	    dtype = dtype || 'float32';
	    util.assertNonNegativeIntegerDimensions(shape);
	    return new tensor_1.TensorBuffer(shape, dtype, values);
	}
	exports.buffer = buffer;
	/**
	 * Prints information about the `tf.Tensor` including its data.
	 *
	 * ```js
	 * const verbose = true;
	 * tf.tensor2d([1, 2, 3, 4], [2, 2]).print(verbose);
	 * ```
	 * @param x The tensor to be printed.
	 * @param verbose Whether to print verbose information about the ` Tensor`,
	 * including dtype and size.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function print(x, verbose) {
	    if (verbose === void 0) { verbose = false; }
	    console.log(x.toString(verbose));
	}
	exports.print = print;
	exports.batchToSpaceND = operation_1.op({ batchToSpaceND_: batchToSpaceND_ });
	exports.broadcastTo = operation_1.op({ broadcastTo_: broadcastTo_ });
	exports.cast = operation_1.op({ cast_: cast_ });
	exports.clone = operation_1.op({ clone_: clone_ });
	exports.cumsum = operation_1.op({ cumsum_: cumsum_ });
	exports.depthToSpace = operation_1.op({ depthToSpace_: depthToSpace_ });
	exports.expandDims = operation_1.op({ expandDims_: expandDims_ });
	exports.eye = operation_1.op({ eye_: eye_ });
	exports.multinomial = operation_1.op({ multinomial_: multinomial_ });
	exports.oneHot = operation_1.op({ oneHot_: oneHot_ });
	exports.pad = operation_1.op({ pad_: pad_ });
	exports.pad1d = operation_1.op({ pad1d_: pad1d_ });
	exports.pad2d = operation_1.op({ pad2d_: pad2d_ });
	exports.pad3d = operation_1.op({ pad3d_: pad3d_ });
	exports.pad4d = operation_1.op({ pad4d_: pad4d_ });
	exports.rand = operation_1.op({ rand_: rand_ });
	exports.randomNormal = operation_1.op({ randomNormal_: randomNormal_ });
	exports.randomGamma = operation_1.op({ randomGamma_: randomGamma_ });
	exports.randomUniform = operation_1.op({ randomUniform_: randomUniform_ });
	exports.reshape = operation_1.op({ reshape_: reshape_ });
	exports.spaceToBatchND = operation_1.op({ spaceToBatchND_: spaceToBatchND_ });
	exports.squeeze = operation_1.op({ squeeze_: squeeze_ });
	exports.stack = operation_1.op({ stack_: stack_ });
	exports.tile = operation_1.op({ tile_: tile_ });
	exports.truncatedNormal = operation_1.op({ truncatedNormal_: truncatedNormal_ });
	exports.unstack = operation_1.op({ unstack_: unstack_ });
	exports.setdiff1dAsync = setdiff1dAsync_;
	//# sourceMappingURL=array_ops.js.map

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1252), __esModule: true };

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(1226);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 92 */
[2087, 122],
/* 93 */
[2091, 158],
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(805);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var defineDataProperty = __webpack_require__(369);
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var supportsDescriptors = __webpack_require__(274)();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object) {
			if (predicate === true) {
				if (object[name] === value) {
					return;
				}
			} else if (!isFunction(predicate) || !predicate()) {
				return;
			}
		}
	
		if (supportsDescriptors) {
			defineDataProperty(object, name, value, true);
		} else {
			defineDataProperty(object, name, value);
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ },
/* 95 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./isObject')} */
	module.exports = function isObject(x) {
		return !!x && (typeof x === 'function' || typeof x === 'object');
	};


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var getModelUris_1 = __webpack_require__(382);
	var dom_1 = __webpack_require__(54);
	var env_1 = __webpack_require__(55);
	var NeuralNetwork = /** @class */ (function () {
	    function NeuralNetwork(_name) {
	        this._name = _name;
	        this._params = undefined;
	        this._paramMappings = [];
	    }
	    Object.defineProperty(NeuralNetwork.prototype, "params", {
	        get: function () { return this._params; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NeuralNetwork.prototype, "paramMappings", {
	        get: function () { return this._paramMappings; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NeuralNetwork.prototype, "isLoaded", {
	        get: function () { return !!this.params; },
	        enumerable: true,
	        configurable: true
	    });
	    NeuralNetwork.prototype.getParamFromPath = function (paramPath) {
	        var _a = this.traversePropertyPath(paramPath), obj = _a.obj, objProp = _a.objProp;
	        return obj[objProp];
	    };
	    NeuralNetwork.prototype.reassignParamFromPath = function (paramPath, tensor) {
	        var _a = this.traversePropertyPath(paramPath), obj = _a.obj, objProp = _a.objProp;
	        obj[objProp].dispose();
	        obj[objProp] = tensor;
	    };
	    NeuralNetwork.prototype.getParamList = function () {
	        var _this = this;
	        return this._paramMappings.map(function (_a) {
	            var paramPath = _a.paramPath;
	            return ({
	                path: paramPath,
	                tensor: _this.getParamFromPath(paramPath)
	            });
	        });
	    };
	    NeuralNetwork.prototype.getTrainableParams = function () {
	        return this.getParamList().filter(function (param) { return param.tensor instanceof tf.Variable; });
	    };
	    NeuralNetwork.prototype.getFrozenParams = function () {
	        return this.getParamList().filter(function (param) { return !(param.tensor instanceof tf.Variable); });
	    };
	    NeuralNetwork.prototype.variable = function () {
	        var _this = this;
	        this.getFrozenParams().forEach(function (_a) {
	            var path = _a.path, tensor = _a.tensor;
	            _this.reassignParamFromPath(path, tensor.variable());
	        });
	    };
	    NeuralNetwork.prototype.freeze = function () {
	        var _this = this;
	        this.getTrainableParams().forEach(function (_a) {
	            var path = _a.path, variable = _a.tensor;
	            var tensor = tf.tensor(variable.dataSync());
	            variable.dispose();
	            _this.reassignParamFromPath(path, tensor);
	        });
	    };
	    NeuralNetwork.prototype.dispose = function (throwOnRedispose) {
	        if (throwOnRedispose === void 0) { throwOnRedispose = true; }
	        this.getParamList().forEach(function (param) {
	            if (throwOnRedispose && param.tensor.isDisposed) {
	                throw new Error("param tensor has already been disposed for path " + param.path);
	            }
	            param.tensor.dispose();
	        });
	        this._params = undefined;
	    };
	    NeuralNetwork.prototype.serializeParams = function () {
	        return new Float32Array(this.getParamList()
	            .map(function (_a) {
	            var tensor = _a.tensor;
	            return Array.from(tensor.dataSync());
	        })
	            .reduce(function (flat, arr) { return flat.concat(arr); }));
	    };
	    NeuralNetwork.prototype.load = function (weightsOrUrl) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (weightsOrUrl instanceof Float32Array) {
	                            this.extractWeights(weightsOrUrl);
	                            return [2 /*return*/];
	                        }
	                        return [4 /*yield*/, this.loadFromUri(weightsOrUrl)];
	                    case 1:
	                        _a.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    NeuralNetwork.prototype.loadFromUri = function (uri) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var weightMap;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (uri && typeof uri !== 'string') {
	                            throw new Error(this._name + ".loadFromUri - expected model uri");
	                        }
	                        return [4 /*yield*/, dom_1.loadWeightMap(uri, this.getDefaultModelName())];
	                    case 1:
	                        weightMap = _a.sent();
	                        this.loadFromWeightMap(weightMap);
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    NeuralNetwork.prototype.loadFromDisk = function (filePath) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var readFile, _a, manifestUri, modelBaseUri, fetchWeightsFromDisk, loadWeights, manifest, _b, _c, weightMap;
	            return tslib_1.__generator(this, function (_d) {
	                switch (_d.label) {
	                    case 0:
	                        if (filePath && typeof filePath !== 'string') {
	                            throw new Error(this._name + ".loadFromDisk - expected model file path");
	                        }
	                        readFile = env_1.env.getEnv().readFile;
	                        _a = getModelUris_1.getModelUris(filePath, this.getDefaultModelName()), manifestUri = _a.manifestUri, modelBaseUri = _a.modelBaseUri;
	                        fetchWeightsFromDisk = function (filePaths) { return Promise.all(filePaths.map(function (filePath) { return readFile(filePath).then(function (buf) { return buf.buffer; }); })); };
	                        loadWeights = tf.io.weightsLoaderFactory(fetchWeightsFromDisk);
	                        _c = (_b = JSON).parse;
	                        return [4 /*yield*/, readFile(manifestUri)];
	                    case 1:
	                        manifest = _c.apply(_b, [(_d.sent()).toString()]);
	                        return [4 /*yield*/, loadWeights(manifest, modelBaseUri)];
	                    case 2:
	                        weightMap = _d.sent();
	                        this.loadFromWeightMap(weightMap);
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    NeuralNetwork.prototype.loadFromWeightMap = function (weightMap) {
	        var _a = this.extractParamsFromWeigthMap(weightMap), paramMappings = _a.paramMappings, params = _a.params;
	        this._paramMappings = paramMappings;
	        this._params = params;
	    };
	    NeuralNetwork.prototype.extractWeights = function (weights) {
	        var _a = this.extractParams(weights), paramMappings = _a.paramMappings, params = _a.params;
	        this._paramMappings = paramMappings;
	        this._params = params;
	    };
	    NeuralNetwork.prototype.traversePropertyPath = function (paramPath) {
	        if (!this.params) {
	            throw new Error("traversePropertyPath - model has no loaded params");
	        }
	        var result = paramPath.split('/').reduce(function (res, objProp) {
	            if (!res.nextObj.hasOwnProperty(objProp)) {
	                throw new Error("traversePropertyPath - object does not have property " + objProp + ", for path " + paramPath);
	            }
	            return { obj: res.nextObj, objProp: objProp, nextObj: res.nextObj[objProp] };
	        }, { nextObj: this.params });
	        var obj = result.obj, objProp = result.objProp;
	        if (!obj || !objProp || !(obj[objProp] instanceof tf.Tensor)) {
	            throw new Error("traversePropertyPath - parameter is not a tensor, for path " + paramPath);
	        }
	        return { obj: obj, objProp: objProp };
	    };
	    return NeuralNetwork;
	}());
	exports.NeuralNetwork = NeuralNetwork;
	//# sourceMappingURL=NeuralNetwork.js.map

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var ObjectDetection_1 = __webpack_require__(379);
	var FaceDetection = /** @class */ (function (_super) {
	    tslib_1.__extends(FaceDetection, _super);
	    function FaceDetection(score, relativeBox, imageDims) {
	        return _super.call(this, score, score, '', relativeBox, imageDims) || this;
	    }
	    FaceDetection.prototype.forSize = function (width, height) {
	        var _a = _super.prototype.forSize.call(this, width, height), score = _a.score, relativeBox = _a.relativeBox, imageDims = _a.imageDims;
	        return new FaceDetection(score, relativeBox, imageDims);
	    };
	    return FaceDetection;
	}(ObjectDetection_1.ObjectDetection));
	exports.FaceDetection = FaceDetection;
	//# sourceMappingURL=FaceDetection.js.map

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	tslib_1.__exportStar(__webpack_require__(618), exports);
	tslib_1.__exportStar(__webpack_require__(1487), exports);
	tslib_1.__exportStar(__webpack_require__(619), exports);
	tslib_1.__exportStar(__webpack_require__(620), exports);
	tslib_1.__exportStar(__webpack_require__(621), exports);
	tslib_1.__exportStar(__webpack_require__(1488), exports);
	function sigmoid(x) {
	    return 1 / (1 + Math.exp(-x));
	}
	exports.sigmoid = sigmoid;
	function inverseSigmoid(x) {
	    return Math.log(x / (1 - x));
	}
	exports.inverseSigmoid = inverseSigmoid;
	//# sourceMappingURL=index.js.map

/***/ },
/* 99 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 100 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(651);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 102 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  disabled: _propTypes2['default'].bool,
	  role: _propTypes2['default'].string,
	  tabIndex: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * this is sort of silly but needed for Button
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'a'
	};
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
	 */
	
	var SafeAnchor = function (_React$Component) {
	  (0, _inherits3['default'])(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props, context) {
	    (0, _classCallCheck3['default'])(this, SafeAnchor);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  SafeAnchor.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        href = _props.href,
	        onClick = _props.onClick;
	
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        disabled = _props2.disabled,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'disabled']);
	
	
	    if (isTrivialHref(props.href)) {
	      props.role = props.role || 'button';
	      // we want to make sure there is a href attribute on the node
	      // otherwise, the cursor incorrectly styled (except with role='button')
	      props.href = props.href || '#';
	    }
	
	    if (disabled) {
	      props.tabIndex = -1;
	      props.style = (0, _extends3['default'])({ pointerEvents: 'none' }, props.style);
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	      onClick: this.handleClick
	    }));
	  };
	
	  return SafeAnchor;
	}(_react2['default'].Component);
	
	SafeAnchor.propTypes = propTypes;
	SafeAnchor.defaultProps = defaultProps;
	
	exports['default'] = SafeAnchor;
	module.exports = exports['default'];

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(47);
	
	var CallbackQueue = __webpack_require__(878);
	var PooledClass = __webpack_require__(147);
	var ReactFeatureFlags = __webpack_require__(883);
	var ReactReconciler = __webpack_require__(181);
	var Transaction = __webpack_require__(295);
	
	var invariant = __webpack_require__(20);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(2);
	var momentValidationWrapper = __webpack_require__(1906);
	var core = __webpack_require__(1905);
	
	module.exports = {
	
	  momentObj : core.createMomentChecker(
	    'object',
	    function(obj) {
	      return typeof obj === 'object';
	    },
	    function isValid(value) {
	      return momentValidationWrapper.isValidMoment(value);
	    },
	    'Moment'
	  ),
	
	  momentString : core.createMomentChecker(
	    'string',
	    function(str) {
	      return typeof str === 'string';
	    },
	    function isValid(value) {
	      return momentValidationWrapper.isValidMoment(moment(value));
	    },
	    'Moment'
	  ),
	
	  momentDurationObj : core.createMomentChecker(
	    'object',
	    function(obj) {
	      return typeof obj === 'object';
	    },
	    function isValid(value) {
	      return moment.isDuration(value);
	    },
	    'Duration'
	  ),
	
	};


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makePageCallback = exports.cancelRunningTask = exports.makeCancellable = exports.displayCORSWarning = exports.errorOnDev = exports.warnOnDev = exports.getPixelRatio = exports.callIfDefined = exports.dataURItoUint8Array = exports.isParamObject = exports.isDataURI = exports.isFile = exports.isBlob = exports.isArrayBuffer = exports.isString = exports.isProvided = exports.isDefined = exports.isProduction = exports.isLocalFileSystem = exports.isBrowser = undefined;
	
	var _promise = __webpack_require__(334);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(90);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Checks if we're running in a browser environment.
	 */
	var isBrowser = exports.isBrowser = typeof window !== 'undefined';
	
	/**
	 * Checks whether we're running from a local file system.
	 */
	var isLocalFileSystem = exports.isLocalFileSystem = isBrowser && window.location.protocol === 'file:';
	
	/**
	 * Checks whether we're running on a production build or not.
	 */
	var isProduction = exports.isProduction = ("production") === 'production';
	
	/**
	 * Checks whether a variable is defined.
	 *
	 * @param {*} variable Variable to check
	 */
	var isDefined = exports.isDefined = function isDefined(variable) {
	  return typeof variable !== 'undefined';
	};
	
	/**
	 * Checks whether a variable is defined and not null.
	 *
	 * @param {*} variable Variable to check
	 */
	var isProvided = exports.isProvided = function isProvided(variable) {
	  return isDefined(variable) && variable !== null;
	};
	
	/**
	 * Checkes whether a variable provided is a string.
	 *
	 * @param {*} variable Variable to check
	 */
	var isString = exports.isString = function isString(variable) {
	  return typeof variable === 'string';
	};
	
	/**
	 * Checks whether a variable provided is an ArrayBuffer.
	 *
	 * @param {*} variable Variable to check
	 */
	var isArrayBuffer = exports.isArrayBuffer = function isArrayBuffer(variable) {
	  return variable instanceof ArrayBuffer;
	};
	
	/**
	 * Checkes whether a variable provided is a Blob.
	 *
	 * @param {*} variable Variable to check
	 */
	var isBlob = exports.isBlob = function isBlob(variable) {
	  if (!isBrowser) {
	    throw new Error('Attempted to check if a variable is a Blob on a non-browser environment.');
	  }
	
	  return variable instanceof Blob;
	};
	
	/**
	 * Checkes whether a variable provided is a File.
	 *
	 * @param {*} variable Variable to check
	 */
	var isFile = exports.isFile = function isFile(variable) {
	  if (!isBrowser) {
	    throw new Error('Attempted to check if a variable is a File on a non-browser environment.');
	  }
	
	  return variable instanceof File;
	};
	
	/**
	 * Checks whether a string provided is a data URI.
	 *
	 * @param {String} str String to check
	 */
	var isDataURI = exports.isDataURI = function isDataURI(str) {
	  return isString(str) && /^data:/.test(str);
	};
	
	var isParamObject = exports.isParamObject = function isParamObject(file) {
	  return file instanceof Object && ('data' in file || 'range' in file || 'url' in file);
	};
	
	var dataURItoUint8Array = exports.dataURItoUint8Array = function dataURItoUint8Array(dataURI) {
	  if (!isDataURI(dataURI)) {
	    throw new Error('dataURItoUint8Array was provided with an argument which is not a valid data URI.');
	  }
	
	  var byteString = void 0;
	  if (dataURI.split(',')[0].indexOf('base64') >= 0) {
	    byteString = atob(dataURI.split(',')[1]);
	  } else {
	    byteString = unescape(dataURI.split(',')[1]);
	  }
	
	  var ia = new Uint8Array(byteString.length);
	  for (var i = 0; i < byteString.length; i += 1) {
	    ia[i] = byteString.charCodeAt(i);
	  }
	
	  return ia;
	};
	
	/**
	 * Calls a function, if it's defined, with specified arguments
	 * @param {Function} fn
	 * @param {Object} args
	 */
	var callIfDefined = exports.callIfDefined = function callIfDefined(fn) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  if (fn && typeof fn === 'function') {
	    fn.apply(undefined, args);
	  }
	};
	
	var getPixelRatio = exports.getPixelRatio = function getPixelRatio() {
	  return isBrowser && window.devicePixelRatio || 1;
	};
	
	var consoleOnDev = function consoleOnDev(method) {
	  for (var _len2 = arguments.length, message = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    message[_key2 - 1] = arguments[_key2];
	  }
	
	  if (!isProduction) {
	    var _console;
	
	    // eslint-disable-next-line no-console
	    (_console = console)[method].apply(_console, message);
	  }
	};
	
	var warnOnDev = exports.warnOnDev = function warnOnDev() {
	  for (var _len3 = arguments.length, message = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    message[_key3] = arguments[_key3];
	  }
	
	  return consoleOnDev.apply(undefined, ['warn'].concat(message));
	};
	
	var errorOnDev = exports.errorOnDev = function errorOnDev() {
	  for (var _len4 = arguments.length, message = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	    message[_key4] = arguments[_key4];
	  }
	
	  return consoleOnDev.apply(undefined, ['error'].concat(message));
	};
	
	var displayCORSWarning = exports.displayCORSWarning = function displayCORSWarning() {
	  if (isLocalFileSystem) {
	    // eslint-disable-next-line no-console
	    warnOnDev('Loading PDF as base64 strings/URLs might not work on protocols other than HTTP/HTTPS. On Google Chrome, you can use --allow-file-access-from-files flag for debugging purposes.');
	  }
	};
	
	var PromiseCancelledException = function (_Error) {
	  (0, _inherits3.default)(PromiseCancelledException, _Error);
	
	  function PromiseCancelledException(message, type) {
	    (0, _classCallCheck3.default)(this, PromiseCancelledException);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PromiseCancelledException.__proto__ || (0, _getPrototypeOf2.default)(PromiseCancelledException)).call(this, message, type));
	
	    _this.name = 'PromiseCancelledException';
	    _this.message = message;
	    _this.type = type;
	    return _this;
	  }
	
	  return PromiseCancelledException;
	}(Error);
	
	var makeCancellable = exports.makeCancellable = function makeCancellable(promise) {
	  var isCancelled = false;
	
	  var wrappedPromise = new _promise2.default(function (resolve, reject) {
	    promise.then(function () {
	      return isCancelled ? reject(new PromiseCancelledException('Promise cancelled')) : resolve.apply(undefined, arguments);
	    }, function (error) {
	      return isCancelled ? reject(new PromiseCancelledException('Promise cancelled')) : reject(error);
	    });
	  });
	
	  return {
	    promise: wrappedPromise,
	    cancel: function cancel() {
	      isCancelled = true;
	    }
	  };
	};
	
	var cancelRunningTask = exports.cancelRunningTask = function cancelRunningTask(runningTask) {
	  if (!runningTask || !runningTask.cancel) {
	    return;
	  }
	
	  runningTask.cancel();
	};
	
	var makePageCallback = exports.makePageCallback = function makePageCallback(page, scale) {
	  Object.defineProperty(page, 'width', {
	    get: function get() {
	      return this.view[2] * scale;
	    },
	    configurable: true });
	  Object.defineProperty(page, 'height', {
	    get: function get() {
	      return this.view[3] * scale;
	    },
	    configurable: true });
	  Object.defineProperty(page, 'originalWidth', {
	    get: function get() {
	      return this.view[2];
	    },
	    configurable: true });
	  Object.defineProperty(page, 'originalHeight', {
	    get: function get() {
	      return this.view[3];
	    },
	    configurable: true });
	  return page;
	};

/***/ },
/* 107 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function getVecChannels(name, rank) {
	    return ['x', 'y', 'z', 'w', 'u', 'v'].slice(0, rank).map(function (d) { return name + "." + d; });
	}
	exports.getVecChannels = getVecChannels;
	function getChannels(name, rank) {
	    if (rank === 1) {
	        return [name];
	    }
	    return getVecChannels(name, rank);
	}
	exports.getChannels = getChannels;
	function getSourceCoords(rank, dims) {
	    if (rank === 1) {
	        return 'rc';
	    }
	    var coords = '';
	    for (var i = 0; i < rank; i++) {
	        coords += dims[i];
	        if (i < rank - 1) {
	            coords += ',';
	        }
	    }
	    return coords;
	}
	exports.getSourceCoords = getSourceCoords;
	//# sourceMappingURL=packing_util.js.map

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util = __webpack_require__(10);
	/**
	 * Returns true if the axis specifies the inner most dimensions of the
	 * array.
	 */
	function axesAreInnerMostDims(axes, rank) {
	    for (var i = 0; i < axes.length; ++i) {
	        if (axes[axes.length - i - 1] !== rank - 1 - i) {
	            return false;
	        }
	    }
	    return true;
	}
	exports.axesAreInnerMostDims = axesAreInnerMostDims;
	function combineLocations(outputLoc, reduceLoc, axes) {
	    var rank = outputLoc.length + reduceLoc.length;
	    var loc = [];
	    var outIdx = 0;
	    var reduceIdx = 0;
	    for (var dim = 0; dim < rank; dim++) {
	        if (axes.indexOf(dim) === -1) {
	            loc.push(outputLoc[outIdx++]);
	        }
	        else {
	            loc.push(reduceLoc[reduceIdx++]);
	        }
	    }
	    return loc;
	}
	exports.combineLocations = combineLocations;
	function computeOutAndReduceShapes(aShape, axes) {
	    var outShape = [];
	    var rank = aShape.length;
	    for (var dim = 0; dim < rank; dim++) {
	        if (axes.indexOf(dim) === -1) {
	            outShape.push(aShape[dim]);
	        }
	    }
	    var reduceShape = axes.map(function (dim) { return aShape[dim]; });
	    return [outShape, reduceShape];
	}
	exports.computeOutAndReduceShapes = computeOutAndReduceShapes;
	function expandShapeToKeepDim(shape, axes) {
	    var reduceSubShape = axes.map(function (x) { return 1; });
	    return combineLocations(shape, reduceSubShape, axes);
	}
	exports.expandShapeToKeepDim = expandShapeToKeepDim;
	function assertAxesAreInnerMostDims(msg, axes, rank) {
	    util.assert(axesAreInnerMostDims(axes, rank), function () { return msg + " supports only inner-most axes for now. " +
	        ("Got axes " + axes + " and rank-" + rank + " input."); });
	}
	exports.assertAxesAreInnerMostDims = assertAxesAreInnerMostDims;
	/**
	 * Returns the axes permutation to be used with `tf.transpose`, if such
	 * permutation is necessary. Otherwise it returns null. This method is used by
	 * operations that operate only on inner-most axes.
	 */
	function getAxesPermutation(axes, rank) {
	    if (axesAreInnerMostDims(axes, rank)) {
	        return null;
	    }
	    var result = [];
	    for (var i = 0; i < rank; ++i) {
	        if (axes.indexOf(i) === -1) {
	            result.push(i);
	        }
	    }
	    axes.forEach(function (axis) { return result.push(axis); });
	    return result;
	}
	exports.getAxesPermutation = getAxesPermutation;
	/** Returns the axes permutation that undoes the original permutation. */
	function getUndoAxesPermutation(axes) {
	    return axes.map(function (axis, i) { return [i, axis]; })
	        .sort(function (a, b) { return a[1] - b[1]; })
	        .map(function (x) { return x[0]; });
	}
	exports.getUndoAxesPermutation = getUndoAxesPermutation;
	function getInnerMostAxes(numAxes, rank) {
	    var res = [];
	    for (var i = rank - numAxes; i < rank; ++i) {
	        res.push(i);
	    }
	    return res;
	}
	exports.getInnerMostAxes = getInnerMostAxes;
	//# sourceMappingURL=axis_util.js.map

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_util_1 = __webpack_require__(111);
	var tensor_util_env_1 = __webpack_require__(17);
	var util = __webpack_require__(10);
	var broadcast_util = __webpack_require__(57);
	var logical_ops_1 = __webpack_require__(154);
	var operation_1 = __webpack_require__(18);
	var tensor_ops_1 = __webpack_require__(31);
	var unary_ops_1 = __webpack_require__(320);
	/**
	 * Adds two `tf.Tensor`s element-wise, A + B. Supports broadcasting.
	 *
	 * We also expose `tf.addStrict` which has the same signature as this op and
	 * asserts that `a` and `b` are the same shape (does not broadcast).
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 2, 3, 4]);
	 * const b = tf.tensor1d([10, 20, 30, 40]);
	 *
	 * a.add(b).print();  // or tf.add(a, b)
	 * ```
	 *
	 * ```js
	 * // Broadcast add a with b.
	 * const a = tf.scalar(5);
	 * const b = tf.tensor1d([10, 20, 30, 40]);
	 *
	 * a.add(b).print();  // or tf.add(a, b)
	 * ```
	 * @param a The first `tf.Tensor` to add.
	 * @param b The second `tf.Tensor` to add. Must have the same type as `a`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Arithmetic'} */
	function add_(a, b) {
	    var _a;
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'add');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'add');
	    _a = tensor_util_1.makeTypesMatch($a, $b), $a = _a[0], $b = _a[1];
	    var outShape = broadcast_util.assertAndGetBroadcastShape($a.shape, $b.shape);
	    var der = function (dy) {
	        var derA = function () {
	            var res = dy;
	            var reduceAxes = broadcast_util.getReductionAxes($a.shape, outShape);
	            if (reduceAxes.length > 0) {
	                res = res.sum(reduceAxes);
	            }
	            return res.reshape($a.shape);
	        };
	        var derB = function () {
	            var res = dy;
	            var reduceAxes = broadcast_util.getReductionAxes($b.shape, outShape);
	            if (reduceAxes.length > 0) {
	                res = res.sum(reduceAxes);
	            }
	            return res.reshape($b.shape);
	        };
	        return { a: derA, b: derB };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.add($a, $b); }, { a: $a, b: $b }, der, 'Add');
	}
	/**
	 * Adds a list of `tf.Tensor`s element-wise, each with the same shape and dtype.
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 2]);
	 * const b = tf.tensor1d([3, 4]);
	 * const c = tf.tensor1d([5, 6]);
	 *
	 * tf.addN([a, b, c]).print();
	 * ```
	 * @param tensors A list of tensors with the same shape and dtype.
	 */
	/** @doc {heading: 'Operations', subheading: 'Arithmetic'} */
	function addN_(tensors) {
	    util.assert(Array.isArray(tensors), function () { return 'The argument passed to tf.addN() must be a list of tensors'; });
	    util.assert(tensors.length >= 1, function () { return "Must pass at least one tensor to tf.addN(), but got " +
	        ("" + tensors.length); });
	    var $tensors = tensors.map(function (t, i) { return tensor_util_env_1.convertToTensor(t, "tensors" + i, 'addN'); });
	    var firstTensor = $tensors[0];
	    $tensors.forEach(function (t) {
	        if (t.dtype !== firstTensor.dtype) {
	            throw new Error('All tensors passed to tf.addN() must have the same dtype');
	        }
	    });
	    $tensors.forEach(function (t) {
	        if (!util.arraysEqual(t.shape, firstTensor.shape)) {
	            throw new Error('All tensors passed to tf.addN() must have the same shape');
	        }
	    });
	    var der = function (dy) {
	        var ders = {};
	        $tensors.forEach(function (t, i) {
	            ders[i] = function () { return dy.clone(); };
	        });
	        return ders;
	    };
	    var inputs = $tensors;
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.addN($tensors); }, inputs, der, 'AddN');
	}
	/**
	 * Adds two `tf.Tensor`s element-wise, A + B.
	 *
	 * Inputs must be the same shape. For broadcasting support, use add() instead.
	 *
	 * @param a The first Tensor to add element-wise.
	 * @param b The second Tensor to add element-wise.
	 */
	function addStrict_(a, b) {
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'addStrict');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'addStrict');
	    util.assertShapesMatch($a.shape, $b.shape, 'Error in addStrict: ');
	    return $a.add($b);
	}
	/**
	 * Subtracts two `tf.Tensor`s element-wise, A - B. Supports broadcasting.
	 *
	 * We also expose `tf.subStrict` which has the same signature as this op and
	 * asserts that `a` and `b` are the same shape (does not broadcast).
	 *
	 * ```js
	 * const a = tf.tensor1d([10, 20, 30, 40]);
	 * const b = tf.tensor1d([1, 2, 3, 4]);
	 *
	 * a.sub(b).print();  // or tf.sub(a, b)
	 * ```
	 *
	 * ```js
	 * // Broadcast subtract a with b.
	 * const a = tf.tensor1d([10, 20, 30, 40]);
	 * const b = tf.scalar(5);
	 *
	 * a.sub(b).print();  // or tf.sub(a, b)
	 * ```
	 * @param a The first `tf.Tensor` to subtract from.
	 * @param b The second `tf.Tensor` to be subtracted. Must have the same dtype as
	 * `a`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Arithmetic'} */
	function sub_(a, b) {
	    var _a;
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'sub');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'sub');
	    _a = tensor_util_1.makeTypesMatch($a, $b), $a = _a[0], $b = _a[1];
	    var outShape = broadcast_util.assertAndGetBroadcastShape($a.shape, $b.shape);
	    var der = function (dy) {
	        var derA = function () {
	            var res = dy;
	            var reduceAxes = broadcast_util.getReductionAxes($a.shape, outShape);
	            if (reduceAxes.length > 0) {
	                res = res.sum(reduceAxes);
	            }
	            return res.reshape($a.shape);
	        };
	        var derB = function () {
	            var res = dy;
	            var reduceAxes = broadcast_util.getReductionAxes($b.shape, outShape);
	            if (reduceAxes.length > 0) {
	                res = res.sum(reduceAxes);
	            }
	            return res.neg().reshape($b.shape);
	        };
	        return { a: derA, b: derB };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.subtract($a, $b); }, { a: $a, b: $b }, der, 'Sub');
	}
	/**
	 * Subtracts two `tf.Tensor`s element-wise, A - B. Inputs must
	 * be the same shape.
	 *
	 * For broadcasting support, use `tf.sub` instead.
	 *
	 * @param a The first Tensor to subtract element-wise.
	 * @param b The second Tensor to subtract element-wise.
	 */
	function subStrict_(a, b) {
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'subStrict');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'subStrict');
	    util.assertShapesMatch($a.shape, $b.shape, 'Error in subStrict: ');
	    return $a.sub($b);
	}
	/**
	 * Computes the power of one `tf.Tensor` to another. Supports broadcasting.
	 *
	 * Given a `tf.Tensor` x and a `tf.Tensor` y, this operation computes x^y for
	 * corresponding elements in x and y. The result's dtype will be the upcasted
	 * type of the `base` and `exp` dtypes.
	 *
	 * ```js
	 * const a = tf.tensor([[2, 3], [4, 5]])
	 * const b = tf.tensor([[1, 2], [3, 0]]).toInt();
	 *
	 * a.pow(b).print();  // or tf.pow(a, b)
	 * ```
	 *
	 * ```js
	 * const a = tf.tensor([[1, 2], [3, 4]])
	 * const b = tf.tensor(2).toInt();
	 *
	 * a.pow(b).print();  // or tf.pow(a, b)
	 * ```
	 * We also expose `powStrict` which has the same signature as this op and
	 * asserts that `base` and `exp` are the same shape (does not broadcast).
	 *
	 * @param base The base `tf.Tensor` to pow element-wise.
	 * @param exp The exponent `tf.Tensor` to pow element-wise.
	 */
	/** @doc {heading: 'Operations', subheading: 'Arithmetic'} */
	function pow_(base, exp) {
	    var _a;
	    var $base = tensor_util_env_1.convertToTensor(base, 'base', 'pow');
	    var $exp = tensor_util_env_1.convertToTensor(exp, 'exp', 'pow');
	    _a = tensor_util_1.makeTypesMatch($base, $exp), $base = _a[0], $exp = _a[1];
	    var outShape = broadcast_util.assertAndGetBroadcastShape($base.shape, $exp.shape);
	    var grad = function (dy, saved) {
	        var $base = saved[0], $exp = saved[1], y = saved[2];
	        var derBase = function () {
	            var expFloat = $exp.toFloat();
	            var res = dy.mul(expFloat.mul($base.pow(expFloat.sub(tensor_ops_1.scalar(1)))));
	            var reduceAxes = broadcast_util.getReductionAxes($base.shape, outShape);
	            if (reduceAxes.length > 0) {
	                res = res.sum(reduceAxes);
	            }
	            return res.reshape($base.shape);
	        };
	        var derExp = function () {
	            var condition = $base.greater(0);
	            var logBase = $base.log().where(condition, tensor_ops_1.zerosLike($base));
	            var res = dy.mul(y.mul(logBase));
	            var reduceAxes = broadcast_util.getReductionAxes($exp.shape, outShape);
	            if (reduceAxes.length > 0) {
	                res = res.sum(reduceAxes);
	            }
	            return res.reshape($exp.shape);
	        };
	        return { a: derBase, b: derExp };
	    };
	    var attrs = {};
	    var inputsToSave = [$base, $exp];
	    var outputsToSave = [true];
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var y = backend.pow($base, $exp);
	        save([$base, $exp, y]);
	        return y;
	    }, { a: $base, b: $exp }, grad, 'Pow', attrs, inputsToSave, outputsToSave);
	}
	/**
	 * Computes the power of one `tf.Tensor` to another. Inputs must
	 * be the same shape.
	 *
	 * For broadcasting support, use `tf.pow` instead.
	 *
	 * @param base The base tensor to pow element-wise.
	 * @param exp The exponent tensor to pow element-wise.
	 */
	function powStrict_(base, exp) {
	    util.assertShapesMatch(base.shape, exp.shape, 'Error in powStrict: ');
	    return base.pow(exp);
	}
	/**
	 * Multiplies two `tf.Tensor`s element-wise, A * B. Supports broadcasting.
	 *
	 * We also expose `tf.mulStrict` which has the same signature as this op and
	 * asserts that `a` and `b` are the same shape (does not broadcast).
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 2, 3, 4]);
	 * const b = tf.tensor1d([2, 3, 4, 5]);
	 *
	 * a.mul(b).print();  // or tf.mul(a, b)
	 * ```
	 *
	 * ```js
	 * // Broadcast mul a with b.
	 * const a = tf.tensor1d([1, 2, 3, 4]);
	 * const b = tf.scalar(5);
	 *
	 * a.mul(b).print();  // or tf.mul(a, b)
	 * ```
	 * @param a The first tensor to multiply.
	 * @param b The second tensor to multiply. Must have the same dtype as `a`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Arithmetic'} */
	function mul_(a, b) {
	    var _a;
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'mul');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'mul');
	    _a = tensor_util_1.makeTypesMatch($a, $b), $a = _a[0], $b = _a[1];
	    var outShape = broadcast_util.assertAndGetBroadcastShape($a.shape, $b.shape);
	    var der = function (dy, saved) {
	        var $a = saved[0], $b = saved[1];
	        var derA = function () {
	            var res = dy.mul($b.toFloat());
	            var reduceAxes = broadcast_util.getReductionAxes($a.shape, outShape);
	            if (reduceAxes.length > 0) {
	                return res.sum(reduceAxes).reshape($a.shape);
	            }
	            return res;
	        };
	        var derB = function () {
	            var res = dy.mul($a.toFloat());
	            var reduceAxes = broadcast_util.getReductionAxes($b.shape, outShape);
	            if (reduceAxes.length > 0) {
	                return res.sum(reduceAxes).reshape($b.shape);
	            }
	            return res;
	        };
	        return { a: derA, b: derB };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.multiply($a, $b);
	        save([$a, $b]);
	        return res;
	    }, { a: $a, b: $b }, der, 'Mul');
	}
	/**
	 * Multiplies two `tf.Tensor`s element-wise, A * B.
	 *
	 * Inputs must be the same shape. For broadcasting support, use `tf.mul`.
	 *
	 * @param a The first tensor to multiply.
	 * @param b The first tensor to multiply. Must have the same
	 *    dtype as `a`.
	 */
	function mulStrict_(a, b) {
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'mul');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'mul');
	    util.assertShapesMatch($a.shape, $b.shape, 'Error in multiplyStrict: ');
	    return $a.mul($b);
	}
	/**
	 * Divides two `tf.Tensor`s element-wise, A / B. Supports broadcasting.
	 *
	 * We also expose `tf.divStrict` which has the same signature as this op and
	 * asserts that `a` and `b` are the same shape (does not broadcast).
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 4, 9, 16]);
	 * const b = tf.tensor1d([1, 2, 3, 4]);
	 *
	 * a.div(b).print();  // or tf.div(a, b)
	 * ```
	 *
	 * ```js
	 * // Broadcast div a with b.
	 * const a = tf.tensor1d([2, 4, 6, 8]);
	 * const b = tf.scalar(2);
	 *
	 * a.div(b).print();  // or tf.div(a, b)
	 * ```
	 *
	 * @param a The first tensor as the numerator.
	 * @param b The second tensor as the denominator. Must have the same dtype as
	 * `a`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Arithmetic'} */
	function div_(a, b) {
	    var _a;
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'div');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'div');
	    _a = tensor_util_1.makeTypesMatch($a, $b), $a = _a[0], $b = _a[1];
	    if ($a.dtype === 'int32' && $b.dtype === 'int32') {
	        return exports.floorDiv($a, $b);
	    }
	    var outShape = broadcast_util.assertAndGetBroadcastShape($a.shape, $b.shape);
	    var der = function (dy, saved) {
	        var $a = saved[0], $b = saved[1];
	        var derA = function () {
	            var res = dy.div($b.toFloat());
	            var reduceAxes = broadcast_util.getReductionAxes($a.shape, outShape);
	            if (reduceAxes.length > 0) {
	                return res.sum(reduceAxes).reshape($a.shape);
	            }
	            return res;
	        };
	        var derB = function () {
	            var res = dy.mul($a.toFloat());
	            var reduceAxes = broadcast_util.getReductionAxes($b.shape, outShape);
	            if (reduceAxes.length > 0) {
	                res = res.sum(reduceAxes).reshape($b.shape);
	            }
	            var tmp = $b.square();
	            return res.div(tmp.toFloat()).neg();
	        };
	        return { a: derA, b: derB };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.realDivide($a, $b);
	        save([$a, $b]);
	        return res;
	    }, { a: $a, b: $b }, der, 'Div');
	}
	/**
	 * Divides two `tf.Tensor`s element-wise, A / B. Supports broadcasting. Return 0
	 * if denominator is 0.
	 *
	 * We also expose `tf.divStrict` which has the same signature as this op and
	 * asserts that `a` and `b` are the same shape (does not broadcast).
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 4, 9, 16]);
	 * const b = tf.tensor1d([1, 2, 3, 4]);
	 * const c = tf.tensor1d([0, 0, 0, 0]);
	 *
	 * a.divNoNan(b).print();  // or tf.divNoNan(a, b)
	 * a.divNoNan(c).print();  // or tf.divNoNan(a, c)
	 * ```
	 *
	 * ```js
	 * // Broadcast div a with b.
	 * const a = tf.tensor1d([2, 4, 6, 8]);
	 * const b = tf.scalar(2);
	 * const c = tf.scalar(0);
	 *
	 * a.divNoNan(b).print();  // or tf.divNoNan(a, b)
	 * a.divNoNan(c).print();  // or tf.divNoNan(a, c)
	 * ```
	 *
	 * @param a The first tensor as the numerator.
	 * @param b The second tensor as the denominator. Must have the same dtype as
	 * `a`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Arithmetic'} */
	function divNoNan_(a, b) {
	    var _a;
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'div');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'div');
	    _a = tensor_util_1.makeTypesMatch($a, $b), $a = _a[0], $b = _a[1];
	    var divResult = exports.div($a, $b);
	    var zeros = tensor_ops_1.zerosLike(divResult);
	    var bEqualsZero = $b.equal(zeros);
	    return logical_ops_1.where(bEqualsZero, zeros, divResult);
	}
	/**
	 * Divides two `tf.Tensor`s element-wise, A / B. Supports broadcasting.
	 * The result is rounded with floor function.
	 *
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 4, 9, 16]);
	 * const b = tf.tensor1d([1, 2, 3, 4]);
	 *
	 * a.floorDiv(b).print();  // or tf.div(a, b)
	 * ```
	 *
	 * ```js
	 * // Broadcast div a with b.
	 * const a = tf.tensor1d([2, 4, 6, 8]);
	 * const b = tf.scalar(2);
	 *
	 * a.floorDiv(b).print();  // or tf.floorDiv(a, b)
	 * ```
	 *
	 * @param a The first tensor as the numerator.
	 * @param b The second tensor as the denominator. Must have the same dtype as
	 * `a`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Arithmetic'} */
	function floorDiv_(a, b) {
	    var _a;
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'floorDiv');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'floorDiv');
	    _a = tensor_util_1.makeTypesMatch($a, $b), $a = _a[0], $b = _a[1];
	    var outShape = broadcast_util.assertAndGetBroadcastShape($a.shape, $b.shape);
	    var der = function (dy, saved) {
	        var $a = saved[0], $b = saved[1];
	        var derA = function () {
	            var res = dy.div($b.toFloat());
	            var reduceAxes = broadcast_util.getReductionAxes($a.shape, outShape);
	            if (reduceAxes.length > 0) {
	                return res.sum(reduceAxes).reshape($a.shape);
	            }
	            return res;
	        };
	        var derB = function () {
	            var res = dy.mul($a.toFloat());
	            var reduceAxes = broadcast_util.getReductionAxes($b.shape, outShape);
	            if (reduceAxes.length > 0) {
	                res = res.sum(reduceAxes).reshape($b.shape);
	            }
	            var tmp = $b.square();
	            return res.div(tmp.toFloat()).neg();
	        };
	        return { a: derA, b: derB };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.floorDiv($a, $b);
	        save([$a, $b]);
	        return res;
	    }, { a: $a, b: $b }, der, 'FloorDiv');
	}
	/**
	 * Divides two `tf.Tensor`s element-wise, A / B. Inputs must
	 * be the same shape.
	 *
	 * @param a The first tensor as the numerator for element-wise division.
	 * @param b The second tensor as the denominator for element-wise division.
	 */
	function divStrict_(a, b) {
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'div');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'div');
	    util.assertShapesMatch($a.shape, $b.shape, 'Error in divideStrict: ');
	    return $a.div($b);
	}
	/**
	 * Returns the mod of a and b element-wise.
	 * `floor(x / y) * y + mod(x, y) = x`
	 * Supports broadcasting.
	 *
	 * We also expose `tf.modStrict` which has the same signature as this op and
	 * asserts that `a` and `b` are the same shape (does not broadcast).
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 4, 3, 16]);
	 * const b = tf.tensor1d([1, 2, 9, 4]);
	 *
	 * a.mod(b).print();  // or tf.mod(a, b)
	 * ```
	 *
	 * ```js
	 * // Broadcast a mod b.
	 * const a = tf.tensor1d([2, 4, 6, 8]);
	 * const b = tf.scalar(5);
	 *
	 * a.mod(b).print();  // or tf.mod(a, b)
	 * ```
	 *
	 * @param a The first tensor.
	 * @param b The second tensor. Must have the same type as `a`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Arithmetic'} */
	function mod_(a, b) {
	    var _a;
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'mod');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'mod');
	    _a = tensor_util_1.makeTypesMatch($a, $b), $a = _a[0], $b = _a[1];
	    var outShape = broadcast_util.assertAndGetBroadcastShape($a.shape, $b.shape);
	    var der = function (dy, saved) {
	        var $a = saved[0], $b = saved[1];
	        var derA = function () {
	            var reduceAxes = broadcast_util.getReductionAxes($a.shape, outShape);
	            if (reduceAxes.length > 0) {
	                return dy.sum(reduceAxes).reshape($a.shape);
	            }
	            return dy;
	        };
	        var derB = function () {
	            var res = dy.mul($a.div($b).floor().neg());
	            var reduceAxes = broadcast_util.getReductionAxes($b.shape, outShape);
	            if (reduceAxes.length > 0) {
	                return res.sum(reduceAxes).reshape($b.shape);
	            }
	            return res;
	        };
	        return { $a: derA, $b: derB };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.mod($a, $b);
	        save([$a, $b]);
	        return res;
	    }, { $a: $a, $b: $b }, der);
	}
	/**
	 * Returns the mod of a and b (`a < b ? a : b`) element-wise. Inputs must
	 * be the same shape. For broadcasting support, use mod().
	 *
	 * @param a The first tensor.
	 * @param b The second tensor. Must have the same dtype as `a`.
	 */
	function modStrict_(a, b) {
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'modStrict');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'modStrict');
	    util.assertShapesMatch($a.shape, $b.shape, 'Error in modStrict: ');
	    return $a.mod($b);
	}
	/**
	 * Returns the min of a and b (`a < b ? a : b`) element-wise.
	 * Supports broadcasting.
	 *
	 * We also expose `minimumStrict` which has the same signature as this op and
	 * asserts that `a` and `b` are the same shape (does not broadcast).
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 4, 3, 16]);
	 * const b = tf.tensor1d([1, 2, 9, 4]);
	 *
	 * a.minimum(b).print();  // or tf.minimum(a, b)
	 * ```
	 *
	 * ```js
	 * // Broadcast minimum a with b.
	 * const a = tf.tensor1d([2, 4, 6, 8]);
	 * const b = tf.scalar(5);
	 *
	 * a.minimum(b).print();  // or tf.minimum(a, b)
	 * ```
	 *
	 * @param a The first tensor.
	 * @param b The second tensor. Must have the same type as `a`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Arithmetic'} */
	function minimum_(a, b) {
	    var _a;
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'minimum');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'minimum');
	    _a = tensor_util_1.makeTypesMatch($a, $b), $a = _a[0], $b = _a[1];
	    if ($a.dtype === 'bool') {
	        $a = $a.toInt();
	        $b = $b.toInt();
	    }
	    broadcast_util.assertAndGetBroadcastShape($a.shape, $b.shape);
	    var der = function (dy, saved) {
	        var $a = saved[0], $b = saved[1];
	        var derA = function () { return dy.mul($a.lessEqual($b).toFloat()); };
	        var derB = function () { return dy.mul($a.greater($b).toFloat()); };
	        return { a: derA, b: derB };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.minimum($a, $b);
	        save([$a, $b]);
	        return res;
	    }, { a: $a, b: $b }, der, 'Minimum');
	}
	/**
	 * Returns the min of a and b (`a < b ? a : b`) element-wise. Inputs must
	 * be the same shape. For broadcasting support, use minimum().
	 *
	 * @param a The first tensor.
	 * @param b The second tensor. Must have the same dtype as `a`.
	 */
	function minimumStrict_(a, b) {
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'minimumStrict');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'minimumStrict');
	    util.assertShapesMatch($a.shape, $b.shape, 'Error in minimumStrict: ');
	    return $a.minimum($b);
	}
	/**
	 * Returns the max of a and b (`a > b ? a : b`) element-wise.
	 * Supports broadcasting.
	 *
	 * We also expose `tf.maximumStrict` which has the same signature as this op and
	 * asserts that `a` and `b` are the same shape (does not broadcast).
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 4, 3, 16]);
	 * const b = tf.tensor1d([1, 2, 9, 4]);
	 *
	 * a.maximum(b).print();  // or tf.maximum(a, b)
	 * ```
	 *
	 * ```js
	 * // Broadcast maximum a with b.
	 * const a = tf.tensor1d([2, 4, 6, 8]);
	 * const b = tf.scalar(5);
	 *
	 * a.maximum(b).print();  // or tf.maximum(a, b)
	 * ```
	 *
	 * @param a The first tensor.
	 * @param b The second tensor. Must have the same type as `a`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Arithmetic'} */
	function maximum_(a, b) {
	    var _a;
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'maximum');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'maximum');
	    _a = tensor_util_1.makeTypesMatch($a, $b), $a = _a[0], $b = _a[1];
	    if ($a.dtype === 'bool') {
	        $a = $a.toInt();
	        $b = $b.toInt();
	    }
	    broadcast_util.assertAndGetBroadcastShape($a.shape, $b.shape);
	    var der = function (dy, saved) {
	        var $a = saved[0], $b = saved[1];
	        var derA = function () { return dy.mul($a.greaterEqual($b).toFloat()); };
	        var derB = function () { return dy.mul($a.less($b).toFloat()); };
	        return { a: derA, b: derB };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.maximum($a, $b);
	        save([$a, $b]);
	        return res;
	    }, { a: $a, b: $b }, der, 'Maximum');
	}
	/**
	 * Returns the max of a and b (`a > b ? a : b`) element-wise. Inputs must
	 * be the same shape. For broadcasting support, use maximum().
	 *
	 * @param a The first tensor.
	 * @param b The second tensor. Must have the same dtype as `a`.
	 */
	function maximumStrict_(a, b) {
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'maximumStrict');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'maximumStrict');
	    util.assertShapesMatch($a.shape, $b.shape, 'Error in maximumStrict: ');
	    return $a.maximum($b);
	}
	/**
	 * Returns (a - b) * (a - b) element-wise.
	 *
	 * Inputs must be the same shape. For broadcasting support, use
	 * `tf.squaredDifference` instead.
	 *
	 * @param a The first tensor.
	 * @param b The second tensor. Must have the same type as `a`.
	 */
	function squaredDifferenceStrict_(a, b) {
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'squaredDifferenceStrict');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'squaredDifferenceStrict');
	    util.assertShapesMatch($a.shape, $b.shape, 'Error in squaredDifferenceStrict: ');
	    return $a.squaredDifference($b);
	}
	/**
	 * Computes arctangent of `tf.Tensor`s a / b element-wise: `atan2(a, b)`.
	 * Supports broadcasting.
	 *
	 * ```js
	 * const a = tf.tensor1d([1.0, 1.0, -1.0, .7]);
	 * const b = tf.tensor1d([2.0, 13.0, 3.5, .21]);
	 *
	 * tf.atan2(a, b).print()
	 * ```
	 *
	 * @param a The first tensor.
	 * @param b The second tensor. Must have the same dtype as `a`.
	 *
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function atan2_(a, b) {
	    var _a;
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'atan2');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'atan2');
	    _a = tensor_util_1.makeTypesMatch($a, $b), $a = _a[0], $b = _a[1];
	    var outShape = broadcast_util.assertAndGetBroadcastShape($a.shape, $b.shape);
	    var der = function (dy, saved) {
	        var $a = saved[0], $b = saved[1];
	        var derA = function () {
	            var d = exports.add($a.square(), $b.square());
	            var res = dy.mul($b.div(d));
	            var reduceAxes = broadcast_util.getReductionAxes($a.shape, outShape);
	            if (reduceAxes.length > 0) {
	                res = res.sum(reduceAxes);
	            }
	            return res.reshape($a.shape);
	        };
	        var derB = function () {
	            var d = exports.add($a.square(), $b.square());
	            var res = unary_ops_1.neg(dy.mul($a.div(d)));
	            var reduceAxes = broadcast_util.getReductionAxes($b.shape, outShape);
	            if (reduceAxes.length > 0) {
	                res = res.sum(reduceAxes);
	            }
	            return res.reshape($b.shape);
	        };
	        return { $a: derA, $b: derB };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.atan2($a, $b);
	        save([$a, $b]);
	        return res;
	    }, { $a: $a, $b: $b }, der);
	}
	exports.add = operation_1.op({ add_: add_ });
	exports.addN = operation_1.op({ addN_: addN_ });
	exports.addStrict = operation_1.op({ addStrict_: addStrict_ });
	exports.atan2 = operation_1.op({ atan2_: atan2_ });
	exports.div = operation_1.op({ div_: div_ });
	exports.divNoNan = operation_1.op({ divNoNan_: divNoNan_ });
	exports.divStrict = operation_1.op({ divStrict_: divStrict_ });
	exports.floorDiv = operation_1.op({ floorDiv_: floorDiv_ });
	exports.maximum = operation_1.op({ maximum_: maximum_ });
	exports.maximumStrict = operation_1.op({ maximumStrict_: maximumStrict_ });
	exports.minimum = operation_1.op({ minimum_: minimum_ });
	exports.minimumStrict = operation_1.op({ minimumStrict_: minimumStrict_ });
	exports.mod = operation_1.op({ mod_: mod_ });
	exports.modStrict = operation_1.op({ modStrict_: modStrict_ });
	exports.mul = operation_1.op({ mul_: mul_ });
	exports.mulStrict = operation_1.op({ mulStrict_: mulStrict_ });
	exports.pow = operation_1.op({ pow_: pow_ });
	exports.powStrict = operation_1.op({ powStrict_: powStrict_ });
	exports.squaredDifferenceStrict = operation_1.op({ squaredDifferenceStrict_: squaredDifferenceStrict_ });
	exports.sub = operation_1.op({ sub_: sub_ });
	exports.subStrict = operation_1.op({ subStrict_: subStrict_ });
	//# sourceMappingURL=binary_ops.js.map

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(10);
	/**
	 * Serializable defines the serialization contract.
	 *
	 * TFJS requires serializable classes to return their className when asked
	 * to avoid issues with minification.
	 */
	var Serializable = /** @class */ (function () {
	    function Serializable() {
	    }
	    /**
	     * Return the class name for this class to use in serialization contexts.
	     *
	     * Generally speaking this will be the same thing that constructor.name
	     * would have returned.  However, the class name needs to be robust
	     * against minification for serialization/deserialization to work properly.
	     *
	     * There's also places such as initializers.VarianceScaling, where
	     * implementation details between different languages led to different
	     * class hierarchies and a non-leaf node is used for serialization purposes.
	     */
	    Serializable.prototype.getClassName = function () {
	        return this.constructor
	            .className;
	    };
	    /**
	     * Creates an instance of T from a ConfigDict.
	     *
	     * This works for most descendants of serializable.  A few need to
	     * provide special handling.
	     * @param cls A Constructor for the class to instantiate.
	     * @param config The Configuration for the object.
	     */
	    /** @nocollapse */
	    Serializable.fromConfig = function (cls, config) {
	        return new cls(config);
	    };
	    return Serializable;
	}());
	exports.Serializable = Serializable;
	/**
	 * Maps string keys to class constructors.
	 *
	 * Used during (de)serialization from the cross-language JSON format, which
	 * requires the class name in the serialization format matches the class
	 * names as used in Python, should it exist.
	 */
	var SerializationMap = /** @class */ (function () {
	    function SerializationMap() {
	        this.classNameMap = {};
	    }
	    /**
	     * Returns the singleton instance of the map.
	     */
	    SerializationMap.getMap = function () {
	        if (SerializationMap.instance == null) {
	            SerializationMap.instance = new SerializationMap();
	        }
	        return SerializationMap.instance;
	    };
	    /**
	     * Registers the class as serializable.
	     */
	    SerializationMap.register = function (cls) {
	        SerializationMap.getMap().classNameMap[cls.className] =
	            [cls, cls.fromConfig];
	    };
	    return SerializationMap;
	}());
	exports.SerializationMap = SerializationMap;
	/**
	 * Register a class with the serialization map of TensorFlow.js.
	 *
	 * This is often used for registering custom Layers, so they can be
	 * serialized and deserialized.
	 *
	 * Example:
	 *
	 * ```js
	 * class MyCustomLayer extends tf.layers.Layer {
	 *   static className = 'MyCustomLayer';
	 *
	 *   constructor(config) {
	 *     super(config);
	 *   }
	 * }
	 * tf.serialization.registerClass(MyCustomLayer);
	 * ```
	 *
	 * @param cls The class to be registered. It must have a public static member
	 *   called `className` defined and the value must be a non-empty string.
	 */
	/** @doc {heading: 'Models', subheading: 'Serialization', ignoreCI: true} */
	function registerClass(cls) {
	    util_1.assert(cls.className != null, function () { return "Class being registered does not have the static className " +
	        "property defined."; });
	    util_1.assert(typeof cls.className === 'string', function () { return "className is required to be a string, but got type " +
	        typeof cls.className; });
	    util_1.assert(cls.className.length > 0, function () { return "Class being registered has an empty-string as its className, " +
	        "which is disallowed."; });
	    SerializationMap.register(cls);
	}
	exports.registerClass = registerClass;
	//# sourceMappingURL=serialization.js.map

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tensor_1 = __webpack_require__(75);
	var types_1 = __webpack_require__(193);
	var util_1 = __webpack_require__(10);
	function makeTypesMatch(a, b) {
	    if (a.dtype === b.dtype) {
	        return [a, b];
	    }
	    var dtype = types_1.upcastType(a.dtype, b.dtype);
	    return [a.cast(dtype), b.cast(dtype)];
	}
	exports.makeTypesMatch = makeTypesMatch;
	function assertTypesMatch(a, b) {
	    util_1.assert(a.dtype === b.dtype, function () { return "The dtypes of the first(" + a.dtype + ") and" +
	        (" second(" + b.dtype + ") input must match"); });
	}
	exports.assertTypesMatch = assertTypesMatch;
	function isTensorInList(tensor, tensorList) {
	    return tensorList.some(function (x) { return x.id === tensor.id; });
	}
	exports.isTensorInList = isTensorInList;
	/**
	 * Extracts any `Tensor`s found within the provided object.
	 *
	 * @param container an object that may be a `Tensor` or may directly contain
	 *   `Tensor`s, such as a `Tensor[]` or `{key: Tensor, ...}`. In general it
	 *   is safe to pass any object here, except that `Promise`s are not
	 *   supported.
	 * @returns An array of `Tensors` found within the passed object. If the
	 *   argument is simply a `Tensor', a list containing that `Tensor` is
	 *   returned. If the object is not a `Tensor` or does not
	 *   contain `Tensors`, an empty list is returned.
	 */
	function getTensorsInContainer(result) {
	    var list = [];
	    var seen = new Set();
	    walkTensorContainer(result, list, seen);
	    return list;
	}
	exports.getTensorsInContainer = getTensorsInContainer;
	function walkTensorContainer(container, list, seen) {
	    if (container == null) {
	        return;
	    }
	    if (container instanceof tensor_1.Tensor) {
	        list.push(container);
	        return;
	    }
	    if (!isIterable(container)) {
	        return;
	    }
	    // Iteration over keys works also for arrays.
	    var iterable = container;
	    for (var k in iterable) {
	        var val = iterable[k];
	        if (!seen.has(val)) {
	            seen.add(val);
	            walkTensorContainer(val, list, seen);
	        }
	    }
	}
	// tslint:disable-next-line:no-any
	function isIterable(obj) {
	    return Array.isArray(obj) || typeof obj === 'object';
	}
	//# sourceMappingURL=tensor_util.js.map

/***/ },
/* 112 */
[2109, 92, 517, 348, 93],
/* 113 */
[2087, 65],
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(62).Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(550);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(47);
	
	var PooledClass = __webpack_require__(147);
	
	var emptyFunction = __webpack_require__(99);
	var warning = __webpack_require__(25);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isRotate = exports.isPdf = exports.isPageNumber = exports.isPageIndex = exports.isPage = exports.isLinkService = exports.isFile = exports.isClassName = exports.eventsProps = undefined;
	
	var _typeof2 = __webpack_require__(196);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(1560);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _utils = __webpack_require__(106);
	
	var _events = __webpack_require__(298);
	
	var _LinkService = __webpack_require__(907);
	
	var _LinkService2 = _interopRequireDefault(_LinkService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventsProps = exports.eventsProps = (0, _lodash2.default)(function () {
	  var eventProps = {};
	
	  [].concat(_events.mouseEvents, _events.touchEvents).forEach(function (eventName) {
	    eventProps[eventName] = _propTypes2.default.func;
	  });
	
	  return eventProps;
	});
	
	var fileTypes = [_propTypes2.default.string, _propTypes2.default.instanceOf(ArrayBuffer), _propTypes2.default.shape({
	  data: _propTypes2.default.object,
	  httpHeaders: _propTypes2.default.object,
	  range: _propTypes2.default.object,
	  url: _propTypes2.default.string,
	  withCredentials: _propTypes2.default.bool
	})];
	if (typeof File !== 'undefined') {
	  fileTypes.push(_propTypes2.default.instanceOf(File));
	}
	if (typeof Blob !== 'undefined') {
	  fileTypes.push(_propTypes2.default.instanceOf(Blob));
	}
	
	var isClassName = exports.isClassName = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]);
	
	var isFile = exports.isFile = _propTypes2.default.oneOfType(fileTypes);
	
	var isLinkService = exports.isLinkService = _propTypes2.default.instanceOf(_LinkService2.default);
	
	var isPage = exports.isPage = _propTypes2.default.shape({
	  commonObjs: _propTypes2.default.shape({
	    objs: _propTypes2.default.object.isRequired
	  }).isRequired,
	  getAnnotations: _propTypes2.default.func.isRequired,
	  getTextContent: _propTypes2.default.func.isRequired,
	  getViewport: _propTypes2.default.func.isRequired,
	  render: _propTypes2.default.func.isRequired,
	  transport: _propTypes2.default.shape({
	    fontLoader: _propTypes2.default.object.isRequired
	  }).isRequired
	});
	
	var isPageIndex = exports.isPageIndex = function isPageIndex(props, propName, componentName) {
	  var pageIndex = props[propName];
	  var pageNumber = props.pageNumber,
	      pdf = props.pdf;
	
	
	  if (!(0, _utils.isDefined)(pdf)) {
	    return null;
	  }
	
	  if ((0, _utils.isDefined)(pageIndex)) {
	    if (typeof pageIndex !== 'number') {
	      return new Error('`' + propName + '` of type `' + (typeof pageIndex === 'undefined' ? 'undefined' : (0, _typeof3.default)(pageIndex)) + '` supplied to `' + componentName + '`, expected `number`.');
	    }
	
	    if (pageIndex < 0) {
	      return new Error('Expected `' + propName + '` to be greater or equal to 0.');
	    }
	
	    var numPages = pdf.pdfInfo.numPages;
	
	
	    if (pageIndex + 1 > numPages) {
	      return new Error('Expected `' + propName + '` to be less or equal to ' + (numPages - 1) + '.');
	    }
	  } else if (!(0, _utils.isDefined)(pageNumber)) {
	    return new Error('`' + propName + '` not supplied. Either pageIndex or pageNumber must be supplied to `' + componentName + '`.');
	  }
	
	  // Everything is fine
	  return null;
	};
	
	var isPageNumber = exports.isPageNumber = function isPageNumber(props, propName, componentName) {
	  var pageNumber = props[propName];
	  var pageIndex = props.pageIndex,
	      pdf = props.pdf;
	
	
	  if (!(0, _utils.isDefined)(pdf)) {
	    return null;
	  }
	
	  if ((0, _utils.isDefined)(pageNumber)) {
	    if (typeof pageNumber !== 'number') {
	      return new Error('`' + propName + '` of type `' + (typeof pageNumber === 'undefined' ? 'undefined' : (0, _typeof3.default)(pageNumber)) + '` supplied to `' + componentName + '`, expected `number`.');
	    }
	
	    if (pageNumber < 1) {
	      return new Error('Expected `' + propName + '` to be greater or equal to 1.');
	    }
	
	    var numPages = pdf.pdfInfo.numPages;
	
	
	    if (pageNumber > numPages) {
	      return new Error('Expected `' + propName + '` to be less or equal to ' + numPages + '.');
	    }
	  } else if (!(0, _utils.isDefined)(pageIndex)) {
	    return new Error('`' + propName + '` not supplied. Either pageIndex or pageNumber must be supplied to `' + componentName + '`.');
	  }
	
	  // Everything is fine
	  return null;
	};
	
	var isPdf = exports.isPdf = _propTypes2.default.oneOfType([_propTypes2.default.shape({
	  getDestination: _propTypes2.default.func.isRequired,
	  getOutline: _propTypes2.default.func.isRequired,
	  getPage: _propTypes2.default.func.isRequired,
	  numPages: _propTypes2.default.number.isRequired
	}), _propTypes2.default.bool]);
	
	var isRotate = exports.isRotate = _propTypes2.default.oneOf([0, 90, 180, 270]);

/***/ },
/* 118 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 119 */
61,
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util = __webpack_require__(10);
	/**
	 * Produces GLSL code that derives logical coordinates from a flat
	 * index. The code performs integer division with each stride and decrements
	 * the index until the index equals the final dimension coordinate.
	 */
	function getLogicalCoordinatesFromFlatIndex(coords, shape, index) {
	    if (index === void 0) { index = 'index'; }
	    var strides = util.computeStrides(shape);
	    return strides
	        .map(function (stride, i) {
	        var line1 = "int " + coords[i] + " = " + index + " / " + stride;
	        var line2 = i === strides.length - 1 ?
	            "int " + coords[i + 1] + " = " + index + " - " + coords[i] + " * " + stride :
	            "index -= " + coords[i] + " * " + stride;
	        return line1 + "; " + line2 + ";";
	    })
	        .join('');
	}
	exports.getLogicalCoordinatesFromFlatIndex = getLogicalCoordinatesFromFlatIndex;
	function buildVec(x) {
	    if (x.length === 1) {
	        return "" + x[0];
	    }
	    return "vec" + x.length + "(" + x.join(',') + ")";
	}
	/**
	 * Produces GLSL code that computes the dot product of the input x and y
	 * vectors. Handles splitting inputs into increments of vec4s when necessary.
	 */
	function dotify(x, y) {
	    if (x.length !== y.length) {
	        throw new Error("Vectors to be dotted must be of the same length -" +
	            ("got " + x.length + " and " + y.length));
	    }
	    var slices = [];
	    var nearestVec4 = Math.floor(x.length / 4);
	    var nearestVec4Remainder = x.length % 4;
	    for (var i = 0; i < nearestVec4; i++) {
	        var xSlice = x.slice(i * 4, i * 4 + 4);
	        var ySlice = y.slice(i * 4, i * 4 + 4);
	        slices.push(buildVec(xSlice) + ", " + buildVec(ySlice));
	    }
	    if (nearestVec4Remainder !== 0) {
	        var xSlice = x.slice(nearestVec4 * 4);
	        var ySlice = y.slice(nearestVec4 * 4);
	        if (xSlice.length === 1) {
	            xSlice = xSlice.map(function (d) { return "float(" + d + ")"; });
	            ySlice = ySlice.map(function (d) { return "float(" + d + ")"; });
	        }
	        slices.push(buildVec(xSlice) + ", " + buildVec(ySlice));
	    }
	    return slices.map(function (d, i) { return "dot(" + d + ")"; }).join('+');
	}
	exports.dotify = dotify;
	/**
	 * Produces GLSL that computes the flat index from 3D coordinates.
	 */
	function getFlatIndexFrom3D(shape) {
	    var strides = util.computeStrides(shape).map(function (d) { return d.toString(); });
	    return "\n  int getFlatIndex(ivec3 coords) {\n    return coords.x * " + strides[0] + " + coords.y * " + strides[1] + " + coords.z;\n  }\n";
	}
	exports.getFlatIndexFrom3D = getFlatIndexFrom3D;
	exports.ENCODE_FLOAT_SNIPPET = "\n  const float FLOAT_MAX = 1.70141184e38;\n  const float FLOAT_MIN = 1.17549435e-38;\n\n  lowp vec4 encode_float(highp float v) {\n    if (isnan(v)) {\n      return vec4(255, 255, 255, 255);\n    }\n\n    highp float av = abs(v);\n\n    if(av < FLOAT_MIN) {\n      return vec4(0.0, 0.0, 0.0, 0.0);\n    } else if(v > FLOAT_MAX) {\n      return vec4(0.0, 0.0, 128.0, 127.0) / 255.0;\n    } else if(v < -FLOAT_MAX) {\n      return vec4(0.0, 0.0,  128.0, 255.0) / 255.0;\n    }\n\n    highp vec4 c = vec4(0,0,0,0);\n\n    highp float e = floor(log2(av));\n    highp float m = exp2(fract(log2(av))) - 1.0;\n\n    c[2] = floor(128.0 * m);\n    m -= c[2] / 128.0;\n    c[1] = floor(32768.0 * m);\n    m -= c[1] / 32768.0;\n    c[0] = floor(8388608.0 * m);\n\n    highp float ebias = e + 127.0;\n    c[3] = floor(ebias / 2.0);\n    ebias -= c[3] * 2.0;\n    c[2] += floor(ebias) * 128.0;\n\n    c[3] += 128.0 * step(0.0, -v);\n\n    return c / 255.0;\n  }\n";
	//# sourceMappingURL=shader_compiler_util.js.map

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DynamicLabelInput = __webpack_require__(243);
	
	var _DynamicLabelInput2 = _interopRequireDefault(_DynamicLabelInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectField = function SelectField(_ref) {
	    var input = _ref.input,
	        onChange = _ref.onChange,
	        label = _ref.label,
	        showSuccess = _ref.showSuccess,
	        defaultValue = _ref.defaultValue,
	        options = _ref.options,
	        type = _ref.type,
	        _ref$meta = _ref.meta,
	        asyncValidating = _ref$meta.asyncValidating,
	        touched = _ref$meta.touched,
	        error = _ref$meta.error,
	        valid = _ref$meta.valid,
	        invalid = _ref$meta.invalid,
	        warning = _ref$meta.warning;
	
	
	    var handleOnChange = function handleOnChange(event) {
	        if (onChange) {
	            onChange(event);
	        }
	        input.onChange(event);
	    };
	
	    var field = _react2.default.createElement(
	        _DynamicLabelInput2.default,
	        Object.assign({}, input, {
	            onChange: handleOnChange,
	            type: 'select',
	            className: options.filter(function (option) {
	                return option.id === parseInt(input.value, 10);
	            }).length !== 0 ? 'form-control selected-field' : 'form-control',
	            showLabel: ("montemar-card-calf") === 'montemar',
	            placeholder: defaultValue }),
	        defaultValue && _react2.default.createElement(
	            'option',
	            { value: false },
	            defaultValue
	        ),
	        options.map(function (option, index) {
	            return _react2.default.createElement(
	                'option',
	                { className: "pd-option-item", key: option.id, value: option.id },
	                option.name
	            );
	        })
	    );
	
	    if (type === 'hidden') {
	
	        field = _react2.default.createElement(
	            'div',
	            { className: 'form-group ' + (touched && invalid ? 'has-error' : '') + ' ' + (touched && valid && showSuccess ? 'has-success' : '') },
	            _react2.default.createElement(
	                'div',
	                { className: asyncValidating ? 'async-validating' : '' },
	                _react2.default.createElement(_DynamicLabelInput2.default, Object.assign({}, input, { onChange: handleOnChange, className: 'form-control', placeholder: label, type: type }))
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'form-group ' + (touched && invalid ? 'has-error' : '') + ' ' + (touched && valid && showSuccess ? 'has-success' : '') },
	        _react2.default.createElement(
	            'div',
	            { className: asyncValidating ? 'async-validating' : '' },
	            field,
	            _react2.default.createElement(
	                'div',
	                { className: 'help-block' },
	                touched && (error && _react2.default.createElement(
	                    'span',
	                    null,
	                    error
	                ) || warning && _react2.default.createElement(
	                    'span',
	                    null,
	                    warning
	                ))
	            )
	        )
	    );
	};
	exports.default = SelectField;

/***/ },
/* 122 */
65,
/* 123 */
[2091, 204],
/* 124 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $TypeError = __webpack_require__(22);
	
	var hasOwn = __webpack_require__(141);
	
	var allowed = {
		__proto__: null,
		'[[Configurable]]': true,
		'[[Enumerable]]': true,
		'[[Get]]': true,
		'[[Set]]': true,
		'[[Value]]': true,
		'[[Writable]]': true
	};
	
	// https://262.ecma-international.org/6.0/#sec-property-descriptor-specification-type
	
	module.exports = function isPropertyDescriptor(Desc) {
		if (!Desc || typeof Desc !== 'object') {
			return false;
		}
	
		for (var key in Desc) { // eslint-disable-line
			if (hasOwn(Desc, key) && !allowed[key]) {
				return false;
			}
		}
	
		var isData = hasOwn(Desc, '[[Value]]') || hasOwn(Desc, '[[Writable]]');
		var IsAccessor = hasOwn(Desc, '[[Get]]') || hasOwn(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	};


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },
/* 127 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = noflip;
	var NOFLIP = '/* @noflip */'; // Appends a noflip comment to a style rule in order to prevent it from being automatically
	// flipped in RTL contexts. This should be used only in situations where the style must remain
	// unflipped regardless of direction context. See: https://github.com/kentcdodds/rtl-css-js#usage
	
	function noflip(value) {
	  if (typeof value === 'number') return "".concat(value, "px ").concat(NOFLIP);
	  if (typeof value === 'string') return "".concat(value, " ").concat(NOFLIP);
	  throw new TypeError('noflip expects a string or a number');
	}

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var globals_1 = __webpack_require__(73);
	var gradients_1 = __webpack_require__(190);
	var ops_1 = __webpack_require__(74);
	var serialization_1 = __webpack_require__(110);
	/** @doc {heading: 'Training', subheading: 'Classes', namespace: 'train'} */
	var Optimizer = /** @class */ (function (_super) {
	    __extends(Optimizer, _super);
	    function Optimizer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Executes `f()` and minimizes the scalar output of `f()` by computing
	     * gradients of y with respect to the list of trainable variables provided by
	     * `varList`. If no list is provided, it defaults to all trainable variables.
	     *
	     * @param f The function to execute and whose output to minimize.
	     * @param returnCost Whether to return the scalar cost value produced by
	     * executing `f()`.
	     * @param varList An optional list of variables to update. If specified, only
	     * the trainable variables in varList will be updated by minimize. Defaults to
	     * all trainable variables.
	     */
	    /** @doc {heading: 'Training', subheading: 'Optimizers'} */
	    Optimizer.prototype.minimize = function (f, returnCost, varList) {
	        if (returnCost === void 0) { returnCost = false; }
	        var _a = this.computeGradients(f, varList), value = _a.value, grads = _a.grads;
	        if (varList != null) {
	            var gradArray = varList.map(function (v) { return ({ name: v.name, tensor: grads[v.name] }); });
	            this.applyGradients(gradArray);
	        }
	        else {
	            this.applyGradients(grads);
	        }
	        // Dispose gradients.
	        globals_1.dispose(grads);
	        if (returnCost) {
	            return value;
	        }
	        else {
	            value.dispose();
	            return null;
	        }
	    };
	    Object.defineProperty(Optimizer.prototype, "iterations", {
	        /**
	         * The number of iterations that this optimizer instance has been invoked for.
	         */
	        get: function () {
	            if (this.iterations_ == null) {
	                this.iterations_ = 0;
	            }
	            return this.iterations_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Optimizer.prototype.incrementIterations = function () {
	        this.iterations_ = this.iterations + 1;
	    };
	    /**
	     * Executes f() and computes the gradient of the scalar output of f() with
	     * respect to the list of trainable variables provided by `varList`. If no
	     * list is provided, it defaults to all trainable variables.
	     *
	     * @param f The function to execute and whose output to use for computing
	     * gradients with respect to variables.
	     * @param varList An optional list of variables to compute gradients with
	     * respect to. If specified, only the trainable variables in varList will have
	     * gradients computed with respect to. Defaults to all trainable variables.
	     */
	    Optimizer.prototype.computeGradients = function (f, varList) {
	        return gradients_1.variableGrads(f, varList);
	    };
	    /**
	     * Dispose the variables (if any) owned by this optimizer instance.
	     */
	    Optimizer.prototype.dispose = function () {
	        if (this.iterations_ != null) {
	            globals_1.dispose(this.iterations_);
	        }
	    };
	    Optimizer.prototype.saveIterations = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                if (this.iterations_ == null) {
	                    this.iterations_ = 0;
	                }
	                return [2 /*return*/, {
	                        name: 'iter',
	                        // TODO(cais): Use 'int64' type when available.
	                        tensor: ops_1.scalar(this.iterations_, 'int32')
	                    }];
	            });
	        });
	    };
	    Optimizer.prototype.getWeights = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                throw new Error('getWeights() is not implemented for this optimizer yet.');
	            });
	        });
	    };
	    Optimizer.prototype.setWeights = function (weightValues) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                throw new Error("setWeights() is not implemented for this optimizer class " +
	                    ("" + this.getClassName()));
	            });
	        });
	    };
	    /**
	     * Extract the first element of the weight values and set it
	     * as the iterations counter variable of this instance of optimizer.
	     *
	     * @param weightValues
	     * @returns Weight values with the first element consumed and excluded.
	     */
	    Optimizer.prototype.extractIterations = function (weightValues) {
	        return __awaiter(this, void 0, void 0, function () {
	            var _a;
	            return __generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        _a = this;
	                        return [4 /*yield*/, weightValues[0].tensor.data()];
	                    case 1:
	                        _a.iterations_ = (_b.sent())[0];
	                        return [2 /*return*/, weightValues.slice(1)];
	                }
	            });
	        });
	    };
	    return Optimizer;
	}(serialization_1.Serializable));
	exports.Optimizer = Optimizer;
	Object.defineProperty(Optimizer, Symbol.hasInstance, {
	    value: function (instance) {
	        return instance.minimize != null && instance.computeGradients != null &&
	            instance.applyGradients != null;
	    }
	});
	//# sourceMappingURL=optimizer.js.map

/***/ },
/* 130 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function getType(fileName) {
		var parts = fileName.split('.');
		return parts[parts.length - 1];
	}
	
	var generateValidator = function generateValidator(fields) {
		return function (values) {
			var errors = {};
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;
	
			try {
				for (var _iterator = fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var field = _step.value;
	
					if (field.value && field.value.constructor === Array) {
						if (values[field.name]) {
							errors[field.name] = generateValidator(field.value)(values[field.name]);
						}
					}
					if (field.required) {
						if (!values[field.name] || !field.range && values[field.name] === 'false') {
							errors[field.name] = 'Este Campo es Obligatorio';
						}
					}
					if (field.range) {
						if ('min' in field.range && values[field.name] < field.range.min || 'max' in field.range && values[field.name] > field.range.max) {
							errors[field.name] = 'Valor no permitido';
						}
					}
					if (field.accepted_types && values[field.name]) {
						var fileType = getType(values[field.name][0].name);
						if (!field.accepted_types.includes(fileType)) {
							errors[field.name] = 'El tipo de archivo no es compatible';
						}
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
	
			return errors;
		};
	};
	
	exports.default = generateValidator;

/***/ },
/* 131 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 132 */
[2094, 112, 200, 93],
/* 133 */
[2125, 518, 338],
/* 134 */
[2090, 202],
/* 135 */
131,
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(58);
	var hide = __webpack_require__(162);
	var has = __webpack_require__(135);
	var SRC = __webpack_require__(257)('src');
	var $toString = __webpack_require__(1302);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(69).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 137 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isPropertyKey(argument) {
		return typeof argument === 'string' || typeof argument === 'symbol';
	};


/***/ },
/* 138 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var env_1 = __webpack_require__(55);
	var resolveInput_1 = __webpack_require__(268);
	function getContext2dOrThrow(canvasArg) {
	    var _a = env_1.env.getEnv(), Canvas = _a.Canvas, CanvasRenderingContext2D = _a.CanvasRenderingContext2D;
	    if (canvasArg instanceof CanvasRenderingContext2D) {
	        return canvasArg;
	    }
	    var canvas = resolveInput_1.resolveInput(canvasArg);
	    if (!(canvas instanceof Canvas)) {
	        throw new Error('resolveContext2d - expected canvas to be of instance of Canvas');
	    }
	    var ctx = canvas.getContext('2d');
	    if (!ctx) {
	        throw new Error('resolveContext2d - canvas 2d context is null');
	    }
	    return ctx;
	}
	exports.getContext2dOrThrow = getContext2dOrThrow;
	//# sourceMappingURL=getContext2dOrThrow.js.map

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/** @type {import('.')} */
	var $gOPD = __webpack_require__(1524);
	
	if ($gOPD) {
		try {
			$gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			$gOPD = null;
		}
	}
	
	module.exports = $gOPD;


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var call = Function.prototype.call;
	var $hasOwn = Object.prototype.hasOwnProperty;
	var bind = __webpack_require__(213);
	
	/** @type {import('.')} */
	module.exports = bind.call(call, $hasOwn);


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1579),
	    getValue = __webpack_require__(1605);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 143 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DummyStatTimer = exports.StatTimer = exports.SimpleXMLParser = exports.DOMSVGFactory = exports.DOMCMapReaderFactory = exports.DOMCanvasFactory = exports.DEFAULT_LINK_REL = exports.getDefaultSetting = exports.LinkTarget = exports.getFilenameFromUrl = exports.isExternalLinkTargetSet = exports.addLinkAttributes = exports.RenderingCancelledException = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __webpack_require__(14);
	
	var _global_scope = __webpack_require__(220);
	
	var _global_scope2 = _interopRequireDefault(_global_scope);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DEFAULT_LINK_REL = 'noopener noreferrer nofollow';
	var SVG_NS = 'http://www.w3.org/2000/svg';
	
	var DOMCanvasFactory = function () {
	  function DOMCanvasFactory() {
	    _classCallCheck(this, DOMCanvasFactory);
	  }
	
	  _createClass(DOMCanvasFactory, [{
	    key: 'create',
	    value: function create(width, height) {
	      if (width <= 0 || height <= 0) {
	        throw new Error('invalid canvas size');
	      }
	      var canvas = document.createElement('canvas');
	      var context = canvas.getContext('2d');
	      canvas.width = width;
	      canvas.height = height;
	      return {
	        canvas: canvas,
	        context: context
	      };
	    }
	  }, {
	    key: 'reset',
	    value: function reset(canvasAndContext, width, height) {
	      if (!canvasAndContext.canvas) {
	        throw new Error('canvas is not specified');
	      }
	      if (width <= 0 || height <= 0) {
	        throw new Error('invalid canvas size');
	      }
	      canvasAndContext.canvas.width = width;
	      canvasAndContext.canvas.height = height;
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy(canvasAndContext) {
	      if (!canvasAndContext.canvas) {
	        throw new Error('canvas is not specified');
	      }
	      canvasAndContext.canvas.width = 0;
	      canvasAndContext.canvas.height = 0;
	      canvasAndContext.canvas = null;
	      canvasAndContext.context = null;
	    }
	  }]);
	
	  return DOMCanvasFactory;
	}();
	
	var DOMCMapReaderFactory = function () {
	  function DOMCMapReaderFactory(_ref) {
	    var _ref$baseUrl = _ref.baseUrl,
	        baseUrl = _ref$baseUrl === undefined ? null : _ref$baseUrl,
	        _ref$isCompressed = _ref.isCompressed,
	        isCompressed = _ref$isCompressed === undefined ? false : _ref$isCompressed;
	
	    _classCallCheck(this, DOMCMapReaderFactory);
	
	    this.baseUrl = baseUrl;
	    this.isCompressed = isCompressed;
	  }
	
	  _createClass(DOMCMapReaderFactory, [{
	    key: 'fetch',
	    value: function fetch(_ref2) {
	      var _this = this;
	
	      var name = _ref2.name;
	
	      if (!this.baseUrl) {
	        return Promise.reject(new Error('CMap baseUrl must be specified, ' + 'see "PDFJS.cMapUrl" (and also "PDFJS.cMapPacked").'));
	      }
	      if (!name) {
	        return Promise.reject(new Error('CMap name must be specified.'));
	      }
	      return new Promise(function (resolve, reject) {
	        var url = _this.baseUrl + name + (_this.isCompressed ? '.bcmap' : '');
	        var request = new XMLHttpRequest();
	        request.open('GET', url, true);
	        if (_this.isCompressed) {
	          request.responseType = 'arraybuffer';
	        }
	        request.onreadystatechange = function () {
	          if (request.readyState !== XMLHttpRequest.DONE) {
	            return;
	          }
	          if (request.status === 200 || request.status === 0) {
	            var data = void 0;
	            if (_this.isCompressed && request.response) {
	              data = new Uint8Array(request.response);
	            } else if (!_this.isCompressed && request.responseText) {
	              data = (0, _util.stringToBytes)(request.responseText);
	            }
	            if (data) {
	              resolve({
	                cMapData: data,
	                compressionType: _this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE
	              });
	              return;
	            }
	          }
	          reject(new Error('Unable to load ' + (_this.isCompressed ? 'binary ' : '') + 'CMap at: ' + url));
	        };
	        request.send(null);
	      });
	    }
	  }]);
	
	  return DOMCMapReaderFactory;
	}();
	
	var DOMSVGFactory = function () {
	  function DOMSVGFactory() {
	    _classCallCheck(this, DOMSVGFactory);
	  }
	
	  _createClass(DOMSVGFactory, [{
	    key: 'create',
	    value: function create(width, height) {
	      (0, _util.assert)(width > 0 && height > 0, 'Invalid SVG dimensions');
	      var svg = document.createElementNS(SVG_NS, 'svg:svg');
	      svg.setAttribute('version', '1.1');
	      svg.setAttribute('width', width + 'px');
	      svg.setAttribute('height', height + 'px');
	      svg.setAttribute('preserveAspectRatio', 'none');
	      svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
	      return svg;
	    }
	  }, {
	    key: 'createElement',
	    value: function createElement(type) {
	      (0, _util.assert)(typeof type === 'string', 'Invalid SVG element type');
	      return document.createElementNS(SVG_NS, type);
	    }
	  }]);
	
	  return DOMSVGFactory;
	}();
	
	var SimpleDOMNode = function () {
	  function SimpleDOMNode(nodeName, nodeValue) {
	    _classCallCheck(this, SimpleDOMNode);
	
	    this.nodeName = nodeName;
	    this.nodeValue = nodeValue;
	    Object.defineProperty(this, 'parentNode', {
	      value: null,
	      writable: true
	    });
	  }
	
	  _createClass(SimpleDOMNode, [{
	    key: 'hasChildNodes',
	    value: function hasChildNodes() {
	      return this.childNodes && this.childNodes.length > 0;
	    }
	  }, {
	    key: 'firstChild',
	    get: function get() {
	      return this.childNodes[0];
	    }
	  }, {
	    key: 'nextSibling',
	    get: function get() {
	      var index = this.parentNode.childNodes.indexOf(this);
	      return this.parentNode.childNodes[index + 1];
	    }
	  }, {
	    key: 'textContent',
	    get: function get() {
	      if (!this.childNodes) {
	        return this.nodeValue || '';
	      }
	      return this.childNodes.map(function (child) {
	        return child.textContent;
	      }).join('');
	    }
	  }]);
	
	  return SimpleDOMNode;
	}();
	
	var SimpleXMLParser = function () {
	  function SimpleXMLParser() {
	    _classCallCheck(this, SimpleXMLParser);
	  }
	
	  _createClass(SimpleXMLParser, [{
	    key: 'parseFromString',
	    value: function parseFromString(data) {
	      var _this2 = this;
	
	      var nodes = [];
	      data = data.replace(/<\?[\s\S]*?\?>|<!--[\s\S]*?-->/g, '').trim();
	      data = data.replace(/<!DOCTYPE[^>\[]+(\[[^\]]+)?[^>]+>/g, '').trim();
	      data = data.replace(/>([^<][\s\S]*?)</g, function (all, text) {
	        var length = nodes.length;
	        var node = new SimpleDOMNode('#text', _this2._decodeXML(text));
	        nodes.push(node);
	        if (node.textContent.trim().length === 0) {
	          return '><';
	        }
	        return '>' + length + ',<';
	      });
	      data = data.replace(/<!\[CDATA\[([\s\S]*?)\]\]>/g, function (all, text) {
	        var length = nodes.length;
	        var node = new SimpleDOMNode('#text', text);
	        nodes.push(node);
	        return length + ',';
	      });
	      var regex = /<([\w\:]+)((?:[\s\w:=]|'[^']*'|"[^"]*")*)(?:\/>|>([\d,]*)<\/[^>]+>)/g;
	      var lastLength = void 0;
	      do {
	        lastLength = nodes.length;
	        data = data.replace(regex, function (all, name, attrs, data) {
	          var length = nodes.length;
	          var node = new SimpleDOMNode(name);
	          var children = [];
	          if (data) {
	            data = data.split(',');
	            data.pop();
	            data.forEach(function (child) {
	              var childNode = nodes[+child];
	              childNode.parentNode = node;
	              children.push(childNode);
	            });
	          }
	          node.childNodes = children;
	          nodes.push(node);
	          return length + ',';
	        });
	      } while (lastLength < nodes.length);
	      return { documentElement: nodes.pop() };
	    }
	  }, {
	    key: '_decodeXML',
	    value: function _decodeXML(text) {
	      if (text.indexOf('&') < 0) {
	        return text;
	      }
	      return text.replace(/&(#(x[0-9a-f]+|\d+)|\w+);/gi, function (all, entityName, number) {
	        if (number) {
	          if (number[0] === 'x') {
	            number = parseInt(number.substring(1), 16);
	          } else {
	            number = +number;
	          }
	          return String.fromCharCode(number);
	        }
	        switch (entityName) {
	          case 'amp':
	            return '&';
	          case 'lt':
	            return '<';
	          case 'gt':
	            return '>';
	          case 'quot':
	            return '\"';
	          case 'apos':
	            return '\'';
	        }
	        return '&' + entityName + ';';
	      });
	    }
	  }]);
	
	  return SimpleXMLParser;
	}();
	
	var RenderingCancelledException = function RenderingCancelledException() {
	  function RenderingCancelledException(msg, type) {
	    this.message = msg;
	    this.type = type;
	  }
	  RenderingCancelledException.prototype = new Error();
	  RenderingCancelledException.prototype.name = 'RenderingCancelledException';
	  RenderingCancelledException.constructor = RenderingCancelledException;
	  return RenderingCancelledException;
	}();
	var LinkTarget = {
	  NONE: 0,
	  SELF: 1,
	  BLANK: 2,
	  PARENT: 3,
	  TOP: 4
	};
	var LinkTargetStringMap = ['', '_self', '_blank', '_parent', '_top'];
	function addLinkAttributes(link, params) {
	  var url = params && params.url;
	  link.href = link.title = url ? (0, _util.removeNullCharacters)(url) : '';
	  if (url) {
	    var target = params.target;
	    if (typeof target === 'undefined') {
	      target = getDefaultSetting('externalLinkTarget');
	    }
	    link.target = LinkTargetStringMap[target];
	    var rel = params.rel;
	    if (typeof rel === 'undefined') {
	      rel = getDefaultSetting('externalLinkRel');
	    }
	    link.rel = rel;
	  }
	}
	function getFilenameFromUrl(url) {
	  var anchor = url.indexOf('#');
	  var query = url.indexOf('?');
	  var end = Math.min(anchor > 0 ? anchor : url.length, query > 0 ? query : url.length);
	  return url.substring(url.lastIndexOf('/', end) + 1, end);
	}
	function getDefaultSetting(id) {
	  var globalSettings = _global_scope2.default.PDFJS;
	  switch (id) {
	    case 'pdfBug':
	      return globalSettings ? globalSettings.pdfBug : false;
	    case 'disableAutoFetch':
	      return globalSettings ? globalSettings.disableAutoFetch : false;
	    case 'disableStream':
	      return globalSettings ? globalSettings.disableStream : false;
	    case 'disableRange':
	      return globalSettings ? globalSettings.disableRange : false;
	    case 'disableFontFace':
	      return globalSettings ? globalSettings.disableFontFace : false;
	    case 'disableCreateObjectURL':
	      return globalSettings ? globalSettings.disableCreateObjectURL : false;
	    case 'disableWebGL':
	      return globalSettings ? globalSettings.disableWebGL : true;
	    case 'cMapUrl':
	      return globalSettings ? globalSettings.cMapUrl : null;
	    case 'cMapPacked':
	      return globalSettings ? globalSettings.cMapPacked : false;
	    case 'postMessageTransfers':
	      return globalSettings ? globalSettings.postMessageTransfers : true;
	    case 'workerPort':
	      return globalSettings ? globalSettings.workerPort : null;
	    case 'workerSrc':
	      return globalSettings ? globalSettings.workerSrc : null;
	    case 'disableWorker':
	      return globalSettings ? globalSettings.disableWorker : false;
	    case 'maxImageSize':
	      return globalSettings ? globalSettings.maxImageSize : -1;
	    case 'imageResourcesPath':
	      return globalSettings ? globalSettings.imageResourcesPath : '';
	    case 'isEvalSupported':
	      return globalSettings ? globalSettings.isEvalSupported : true;
	    case 'externalLinkTarget':
	      if (!globalSettings) {
	        return LinkTarget.NONE;
	      }
	      switch (globalSettings.externalLinkTarget) {
	        case LinkTarget.NONE:
	        case LinkTarget.SELF:
	        case LinkTarget.BLANK:
	        case LinkTarget.PARENT:
	        case LinkTarget.TOP:
	          return globalSettings.externalLinkTarget;
	      }
	      (0, _util.warn)('PDFJS.externalLinkTarget is invalid: ' + globalSettings.externalLinkTarget);
	      globalSettings.externalLinkTarget = LinkTarget.NONE;
	      return LinkTarget.NONE;
	    case 'externalLinkRel':
	      return globalSettings ? globalSettings.externalLinkRel : DEFAULT_LINK_REL;
	    case 'enableStats':
	      return !!(globalSettings && globalSettings.enableStats);
	    default:
	      throw new Error('Unknown default setting: ' + id);
	  }
	}
	function isExternalLinkTargetSet() {
	  var externalLinkTarget = getDefaultSetting('externalLinkTarget');
	  switch (externalLinkTarget) {
	    case LinkTarget.NONE:
	      return false;
	    case LinkTarget.SELF:
	    case LinkTarget.BLANK:
	    case LinkTarget.PARENT:
	    case LinkTarget.TOP:
	      return true;
	  }
	}
	
	var StatTimer = function () {
	  function StatTimer() {
	    var enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	    _classCallCheck(this, StatTimer);
	
	    this.enabled = !!enable;
	    this.started = Object.create(null);
	    this.times = [];
	  }
	
	  _createClass(StatTimer, [{
	    key: 'time',
	    value: function time(name) {
	      if (!this.enabled) {
	        return;
	      }
	      if (name in this.started) {
	        (0, _util.warn)('Timer is already running for ' + name);
	      }
	      this.started[name] = Date.now();
	    }
	  }, {
	    key: 'timeEnd',
	    value: function timeEnd(name) {
	      if (!this.enabled) {
	        return;
	      }
	      if (!(name in this.started)) {
	        (0, _util.warn)('Timer has not been started for ' + name);
	      }
	      this.times.push({
	        'name': name,
	        'start': this.started[name],
	        'end': Date.now()
	      });
	      delete this.started[name];
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var times = this.times;
	      var out = '',
	          longest = 0;
	      for (var i = 0, ii = times.length; i < ii; ++i) {
	        var name = times[i]['name'];
	        if (name.length > longest) {
	          longest = name.length;
	        }
	      }
	      for (var _i = 0, _ii = times.length; _i < _ii; ++_i) {
	        var span = times[_i];
	        var duration = span.end - span.start;
	        out += span['name'].padEnd(longest) + ' ' + duration + 'ms\n';
	      }
	      return out;
	    }
	  }]);
	
	  return StatTimer;
	}();
	
	var DummyStatTimer = function () {
	  function DummyStatTimer() {
	    _classCallCheck(this, DummyStatTimer);
	
	    (0, _util.unreachable)('Cannot initialize DummyStatTimer.');
	  }
	
	  _createClass(DummyStatTimer, null, [{
	    key: 'time',
	    value: function time(name) {}
	  }, {
	    key: 'timeEnd',
	    value: function timeEnd(name) {}
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return '';
	    }
	  }]);
	
	  return DummyStatTimer;
	}();
	
	exports.RenderingCancelledException = RenderingCancelledException;
	exports.addLinkAttributes = addLinkAttributes;
	exports.isExternalLinkTargetSet = isExternalLinkTargetSet;
	exports.getFilenameFromUrl = getFilenameFromUrl;
	exports.LinkTarget = LinkTarget;
	exports.getDefaultSetting = getDefaultSetting;
	exports.DEFAULT_LINK_REL = DEFAULT_LINK_REL;
	exports.DOMCanvasFactory = DOMCanvasFactory;
	exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
	exports.DOMSVGFactory = DOMSVGFactory;
	exports.SimpleXMLParser = SimpleXMLParser;
	exports.StatTimer = StatTimer;
	exports.DummyStatTimer = DummyStatTimer;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _propTypes["default"].oneOf(_constants.WEEKDAYS);
	
	exports["default"] = _default;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _propTypes["default"].oneOf([_constants.OPEN_DOWN, _constants.OPEN_UP]);
	
	exports["default"] = _default;

/***/ },
/* 147 */
[2143, 23],
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _some2 = __webpack_require__(1649);
	
	var _some3 = _interopRequireDefault(_some2);
	
	var _splice = __webpack_require__(2009);
	
	var _splice2 = _interopRequireDefault(_splice);
	
	var _getIn = __webpack_require__(935);
	
	var _getIn2 = _interopRequireDefault(_getIn);
	
	var _setIn = __webpack_require__(2008);
	
	var _setIn2 = _interopRequireDefault(_setIn);
	
	var _deepEqual = __webpack_require__(2006);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _deleteIn = __webpack_require__(2007);
	
	var _deleteIn2 = _interopRequireDefault(_deleteIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var structure = {
	  empty: {},
	  emptyList: [],
	  getIn: _getIn2.default,
	  setIn: _setIn2.default,
	  deepEqual: _deepEqual2.default,
	  deleteIn: _deleteIn2.default,
	  fromJS: function fromJS(value) {
	    return value;
	  },
	  size: function size(array) {
	    return array ? array.length : 0;
	  },
	  some: _some3.default,
	  splice: _splice2.default
	};
	
	exports.default = structure;

/***/ },
/* 149 */
[2138, 942, 469],
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var tensor_ops_1 = __webpack_require__(31);
	var util_1 = __webpack_require__(10);
	var types_1 = __webpack_require__(484);
	/** Number of bytes reserved for the length of the string. (32bit integer). */
	var NUM_BYTES_STRING_LENGTH = 4;
	/**
	 * Encode a map from names to weight values as an ArrayBuffer, along with an
	 * `Array` of `WeightsManifestEntry` as specification of the encoded weights.
	 *
	 * This function does not perform sharding.
	 *
	 * This function is the reverse of `decodeWeights`.
	 *
	 * @param tensors A map ("dict") from names to tensors.
	 * @param group Group to which the weights belong (optional).
	 * @returns A `Promise` of
	 *   - A flat `ArrayBuffer` with all the binary values of the `Tensor`s
	 *     concatenated.
	 *   - An `Array` of `WeightManifestEntry`s, carrying information including
	 *     tensor names, `dtype`s and shapes.
	 * @throws Error: on unsupported tensor `dtype`.
	 */
	function encodeWeights(tensors, group) {
	    return __awaiter(this, void 0, void 0, function () {
	        var specs, dataPromises, names, _loop_1, i, tensorValues;
	        var _this = this;
	        return __generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    specs = [];
	                    dataPromises = [];
	                    names = Array.isArray(tensors) ?
	                        tensors.map(function (tensor) { return tensor.name; }) :
	                        Object.keys(tensors);
	                    _loop_1 = function (i) {
	                        var name_1 = names[i];
	                        var t = Array.isArray(tensors) ? tensors[i].tensor : tensors[name_1];
	                        if (t.dtype !== 'float32' && t.dtype !== 'int32' && t.dtype !== 'bool' &&
	                            t.dtype !== 'string') {
	                            throw new Error("Unsupported dtype in weight '" + name_1 + "': " + t.dtype);
	                        }
	                        var spec = { name: name_1, shape: t.shape, dtype: t.dtype };
	                        if (t.dtype === 'string') {
	                            var utf8bytes = new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
	                                var vals, totalNumBytes, bytes, offset, i_1, val, bytesOfLength;
	                                return __generator(this, function (_a) {
	                                    switch (_a.label) {
	                                        case 0: return [4 /*yield*/, t.bytes()];
	                                        case 1:
	                                            vals = _a.sent();
	                                            totalNumBytes = vals.reduce(function (p, c) { return p + c.length; }, 0) +
	                                                NUM_BYTES_STRING_LENGTH * vals.length;
	                                            bytes = new Uint8Array(totalNumBytes);
	                                            offset = 0;
	                                            for (i_1 = 0; i_1 < vals.length; i_1++) {
	                                                val = vals[i_1];
	                                                bytesOfLength = new Uint8Array(new Uint32Array([val.length]).buffer);
	                                                bytes.set(bytesOfLength, offset);
	                                                offset += NUM_BYTES_STRING_LENGTH;
	                                                bytes.set(val, offset);
	                                                offset += val.length;
	                                            }
	                                            resolve(bytes);
	                                            return [2 /*return*/];
	                                    }
	                                });
	                            }); });
	                            dataPromises.push(utf8bytes);
	                        }
	                        else {
	                            dataPromises.push(t.data());
	                        }
	                        if (group != null) {
	                            spec.group = group;
	                        }
	                        specs.push(spec);
	                    };
	                    for (i = 0; i < names.length; ++i) {
	                        _loop_1(i);
	                    }
	                    return [4 /*yield*/, Promise.all(dataPromises)];
	                case 1:
	                    tensorValues = _a.sent();
	                    return [2 /*return*/, { data: concatenateTypedArrays(tensorValues), specs: specs }];
	            }
	        });
	    });
	}
	exports.encodeWeights = encodeWeights;
	/**
	 * Decode flat ArrayBuffer as weights.
	 *
	 * This function does not handle sharding.
	 *
	 * This function is the reverse of `encodeWeights`.
	 *
	 * @param buffer A flat ArrayBuffer carrying the binary values of the tensors
	 *   concatenated in the order specified in `specs`.
	 * @param specs Specifications of the names, dtypes and shapes of the tensors
	 *   whose value are encoded by `buffer`.
	 * @return A map from tensor name to tensor value, with the names corresponding
	 *   to names in `specs`.
	 * @throws Error, if any of the tensors has unsupported dtype.
	 */
	function decodeWeights(buffer, specs) {
	    // TODO(adarob, cais): Support quantization.
	    var out = {};
	    var offset = 0;
	    var _loop_2 = function (spec) {
	        var name_2 = spec.name;
	        var dtype = spec.dtype;
	        var shape = spec.shape;
	        var size = util_1.sizeFromShape(shape);
	        var values = void 0;
	        if ('quantization' in spec) {
	            var quantization_1 = spec.quantization;
	            if (quantization_1.dtype !== 'uint8' && quantization_1.dtype !== 'uint16') {
	                throw new Error("Weight " + spec.name + " has unknown " +
	                    ("quantization dtype " + quantization_1.dtype + ". ") +
	                    "Supported quantization dtypes are: 'uint8' and 'uint16'.");
	            }
	            var quantizationSizeFactor = types_1.DTYPE_VALUE_SIZE_MAP[quantization_1.dtype];
	            var byteBuffer = buffer.slice(offset, offset + size * quantizationSizeFactor);
	            var quantizedArray = (quantization_1.dtype === 'uint8') ?
	                new Uint8Array(byteBuffer) :
	                new Uint16Array(byteBuffer);
	            if (dtype === 'float32') {
	                values = Float32Array.from(quantizedArray, function (v) { return v * quantization_1.scale + quantization_1.min; });
	            }
	            else if (dtype === 'int32') {
	                values = Int32Array.from(quantizedArray, function (v) { return Math.round(v * quantization_1.scale + quantization_1.min); });
	            }
	            else {
	                throw new Error("Unsupported dtype in weight '" + name_2 + "': " + dtype);
	            }
	            offset += size * quantizationSizeFactor;
	        }
	        else if (dtype === 'string') {
	            var size_1 = util_1.sizeFromShape(spec.shape);
	            values = [];
	            for (var i = 0; i < size_1; i++) {
	                var byteLength = new Uint32Array(buffer.slice(offset, offset + NUM_BYTES_STRING_LENGTH))[0];
	                offset += NUM_BYTES_STRING_LENGTH;
	                var bytes = new Uint8Array(buffer.slice(offset, offset + byteLength));
	                values.push(bytes);
	                offset += byteLength;
	            }
	        }
	        else {
	            var dtypeFactor = types_1.DTYPE_VALUE_SIZE_MAP[dtype];
	            var byteBuffer = buffer.slice(offset, offset + size * dtypeFactor);
	            if (dtype === 'float32') {
	                values = new Float32Array(byteBuffer);
	            }
	            else if (dtype === 'int32') {
	                values = new Int32Array(byteBuffer);
	            }
	            else if (dtype === 'bool') {
	                values = new Uint8Array(byteBuffer);
	            }
	            else {
	                throw new Error("Unsupported dtype in weight '" + name_2 + "': " + dtype);
	            }
	            offset += size * dtypeFactor;
	        }
	        out[name_2] = tensor_ops_1.tensor(values, shape, dtype);
	    };
	    for (var _i = 0, specs_1 = specs; _i < specs_1.length; _i++) {
	        var spec = specs_1[_i];
	        _loop_2(spec);
	    }
	    return out;
	}
	exports.decodeWeights = decodeWeights;
	/**
	 * Concatenate TypedArrays into an ArrayBuffer.
	 */
	function concatenateTypedArrays(xs) {
	    // TODO(adarob, cais): Support quantization.
	    if (xs === null) {
	        throw new Error("Invalid input value: " + JSON.stringify(xs));
	    }
	    var totalByteLength = 0;
	    // `normalizedXs` is here for this reason: a `TypedArray`'s `buffer'
	    // can have a different byte length from that of the `TypedArray` itself,
	    // for example, when the `TypedArray` is created from an offset in an
	    // `ArrayBuffer`. `normliazedXs` holds `TypedArray`s whose `buffer`s match
	    // the `TypedArray` in byte length. If an element of `xs` does not show
	    // this property, a new `TypedArray` that satisfy this property will be
	    // constructed and pushed into `normalizedXs`.
	    var normalizedXs = [];
	    xs.forEach(function (x) {
	        totalByteLength += x.byteLength;
	        // tslint:disable:no-any
	        normalizedXs.push(x.byteLength === x.buffer.byteLength ? x :
	            new x.constructor(x));
	        if (!(x instanceof Float32Array || x instanceof Int32Array ||
	            x instanceof Uint8Array)) {
	            throw new Error("Unsupported TypedArray subtype: " + x.constructor.name);
	        }
	        // tslint:enable:no-any
	    });
	    var y = new Uint8Array(totalByteLength);
	    var offset = 0;
	    normalizedXs.forEach(function (x) {
	        y.set(new Uint8Array(x.buffer), offset);
	        offset += x.byteLength;
	    });
	    return y.buffer;
	}
	exports.concatenateTypedArrays = concatenateTypedArrays;
	// Use Buffer on Node.js instead of Blob/atob/btoa
	var useNodeBuffer = typeof Buffer !== 'undefined' &&
	    (typeof Blob === 'undefined' || typeof atob === 'undefined' ||
	        typeof btoa === 'undefined');
	/**
	 * Calculate the byte length of a JavaScript string.
	 *
	 * Note that a JavaScript string can contain wide characters, therefore the
	 * length of the string is not necessarily equal to the byte length.
	 *
	 * @param str Input string.
	 * @returns Byte length.
	 */
	function stringByteLength(str) {
	    if (useNodeBuffer) {
	        return Buffer.byteLength(str);
	    }
	    return new Blob([str]).size;
	}
	exports.stringByteLength = stringByteLength;
	/**
	 * Encode an ArrayBuffer as a base64 encoded string.
	 *
	 * @param buffer `ArrayBuffer` to be converted.
	 * @returns A string that base64-encodes `buffer`.
	 */
	function arrayBufferToBase64String(buffer) {
	    if (useNodeBuffer) {
	        return Buffer.from(buffer).toString('base64');
	    }
	    var buf = new Uint8Array(buffer);
	    var s = '';
	    for (var i = 0, l = buf.length; i < l; i++) {
	        s += String.fromCharCode(buf[i]);
	    }
	    return btoa(s);
	}
	exports.arrayBufferToBase64String = arrayBufferToBase64String;
	/**
	 * Decode a base64 string as an ArrayBuffer.
	 *
	 * @param str Base64 string.
	 * @returns Decoded `ArrayBuffer`.
	 */
	function base64StringToArrayBuffer(str) {
	    if (useNodeBuffer) {
	        var buf = Buffer.from(str, 'base64');
	        return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength);
	    }
	    var s = atob(str);
	    var buffer = new Uint8Array(s.length);
	    for (var i = 0; i < s.length; ++i) {
	        buffer.set([s.charCodeAt(i)], i);
	    }
	    return buffer.buffer;
	}
	exports.base64StringToArrayBuffer = base64StringToArrayBuffer;
	/**
	 * Concatenate a number of ArrayBuffers into one.
	 *
	 * @param buffers A number of array buffers to concatenate.
	 * @returns Result of concatenating `buffers` in order.
	 */
	function concatenateArrayBuffers(buffers) {
	    var totalByteLength = 0;
	    buffers.forEach(function (buffer) {
	        totalByteLength += buffer.byteLength;
	    });
	    var temp = new Uint8Array(totalByteLength);
	    var offset = 0;
	    buffers.forEach(function (buffer) {
	        temp.set(new Uint8Array(buffer), offset);
	        offset += buffer.byteLength;
	    });
	    return temp.buffer;
	}
	exports.concatenateArrayBuffers = concatenateArrayBuffers;
	/**
	 * Get the basename of a path.
	 *
	 * Behaves in a way analogous to Linux's basename command.
	 *
	 * @param path
	 */
	function basename(path) {
	    var SEPARATOR = '/';
	    path = path.trim();
	    while (path.endsWith(SEPARATOR)) {
	        path = path.slice(0, path.length - 1);
	    }
	    var items = path.split(SEPARATOR);
	    return items[items.length - 1];
	}
	exports.basename = basename;
	/**
	 * Populate ModelArtifactsInfo fields for a model with JSON topology.
	 * @param modelArtifacts
	 * @returns A ModelArtifactsInfo object.
	 */
	function getModelArtifactsInfoForJSON(modelArtifacts) {
	    if (modelArtifacts.modelTopology instanceof ArrayBuffer) {
	        throw new Error('Expected JSON model topology, received ArrayBuffer.');
	    }
	    return {
	        dateSaved: new Date(),
	        modelTopologyType: 'JSON',
	        modelTopologyBytes: modelArtifacts.modelTopology == null ?
	            0 :
	            stringByteLength(JSON.stringify(modelArtifacts.modelTopology)),
	        weightSpecsBytes: modelArtifacts.weightSpecs == null ?
	            0 :
	            stringByteLength(JSON.stringify(modelArtifacts.weightSpecs)),
	        weightDataBytes: modelArtifacts.weightData == null ?
	            0 :
	            modelArtifacts.weightData.byteLength,
	    };
	}
	exports.getModelArtifactsInfoForJSON = getModelArtifactsInfoForJSON;
	//# sourceMappingURL=io_utils.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62).Buffer))

/***/ },
/* 151 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var IORouterRegistry = /** @class */ (function () {
	    function IORouterRegistry() {
	        this.saveRouters = [];
	        this.loadRouters = [];
	    }
	    IORouterRegistry.getInstance = function () {
	        if (IORouterRegistry.instance == null) {
	            IORouterRegistry.instance = new IORouterRegistry();
	        }
	        return IORouterRegistry.instance;
	    };
	    /**
	     * Register a save-handler router.
	     *
	     * @param saveRouter A function that maps a URL-like string onto an instance
	     * of `IOHandler` with the `save` method defined or `null`.
	     */
	    IORouterRegistry.registerSaveRouter = function (saveRouter) {
	        IORouterRegistry.getInstance().saveRouters.push(saveRouter);
	    };
	    /**
	     * Register a load-handler router.
	     *
	     * @param loadRouter A function that maps a URL-like string onto an instance
	     * of `IOHandler` with the `load` method defined or `null`.
	     */
	    IORouterRegistry.registerLoadRouter = function (loadRouter) {
	        IORouterRegistry.getInstance().loadRouters.push(loadRouter);
	    };
	    /**
	     * Look up IOHandler for saving, given a URL-like string.
	     *
	     * @param url
	     * @returns If only one match is found, an instance of IOHandler with the
	     * `save` method defined. If no match is found, `null`.
	     * @throws Error, if more than one match is found.
	     */
	    IORouterRegistry.getSaveHandlers = function (url) {
	        return IORouterRegistry.getHandlers(url, 'save');
	    };
	    /**
	     * Look up IOHandler for loading, given a URL-like string.
	     *
	     * @param url
	     * @param onProgress Optional, progress callback function, fired periodically
	     *   before the load is completed.
	     * @returns All valid handlers for `url`, given the currently registered
	     *   handler routers.
	     */
	    IORouterRegistry.getLoadHandlers = function (url, onProgress) {
	        return IORouterRegistry.getHandlers(url, 'load', onProgress);
	    };
	    IORouterRegistry.getHandlers = function (url, handlerType, onProgress) {
	        var validHandlers = [];
	        var routers = handlerType === 'load' ?
	            IORouterRegistry.getInstance().loadRouters :
	            IORouterRegistry.getInstance().saveRouters;
	        routers.forEach(function (router) {
	            var handler = router(url, onProgress);
	            if (handler !== null) {
	                validHandlers.push(handler);
	            }
	        });
	        return validHandlers;
	    };
	    return IORouterRegistry;
	}());
	exports.IORouterRegistry = IORouterRegistry;
	exports.registerSaveRouter = function (loudRouter) {
	    return IORouterRegistry.registerSaveRouter(loudRouter);
	};
	exports.registerLoadRouter = function (loudRouter) {
	    return IORouterRegistry.registerLoadRouter(loudRouter);
	};
	exports.getSaveHandlers = function (url) {
	    return IORouterRegistry.getSaveHandlers(url);
	};
	exports.getLoadHandlers = function (url, onProgress) {
	    return IORouterRegistry.getLoadHandlers(url, onProgress);
	};
	//# sourceMappingURL=router_registry.js.map

/***/ },
/* 152 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var kernelRegistry = new Map();
	var gradRegistry = new Map();
	/**
	 * Returns the kernel function (code) associated with the provided names.
	 *
	 * @param kernelName The official name of the kernel.
	 * @param backendName The official name of the backend.
	 */
	function getKernel(kernelName, backendName) {
	    var key = makeKey(kernelName, backendName);
	    return kernelRegistry.get(key);
	}
	exports.getKernel = getKernel;
	/**
	 * Returns the registered gradient info associated with the provided kernel.
	 * @param kernelName The official TF kernel name.
	 */
	function getGradient(kernelName) {
	    return gradRegistry.get(kernelName);
	}
	exports.getGradient = getGradient;
	function getKernelsForBackend(backendName) {
	    var it = kernelRegistry.entries();
	    var result = [];
	    while (true) {
	        var _a = it.next(), done = _a.done, value = _a.value;
	        if (done) {
	            break;
	        }
	        var key = value[0], config = value[1];
	        var backend = key.split('_')[0];
	        if (backend === backendName) {
	            result.push(config);
	        }
	    }
	    return result;
	}
	exports.getKernelsForBackend = getKernelsForBackend;
	/**
	 * Registers the function (forward pass) for the kernel in a global registry.
	 *
	 * @param config A config object with the following properties:
	 * - `kernelName` The official name of the kernel.
	 * - `backendName` The official name of the backend.
	 * - `kernelFunc` The function to run during the forward pass of the kernel.
	 * - `setupFunc` Optional. Gets called once, after the backend initializes.
	 * - `disposeFunc` Optional. Gets called once, right before the backend is
	 * disposed.
	 */
	function registerKernel(config) {
	    var kernelName = config.kernelName, backendName = config.backendName;
	    var key = makeKey(kernelName, backendName);
	    if (kernelRegistry.has(key)) {
	        throw new Error("The kernel '" + kernelName + "' for backend " +
	            ("'" + backendName + "' is already registered"));
	    }
	    kernelRegistry.set(key, config);
	}
	exports.registerKernel = registerKernel;
	/**
	 * Registers a gradient function for a given kernel in the global registry,
	 * to be used during the back-propagation of that kernel.
	 *
	 * @param config An object with the following properties:
	 * - `kernelName` The name of the kernel that the gradient function is for.
	 * - `gradFunc` The function to run during back-propagation.
	 */
	function registerGradient(config) {
	    var kernelName = config.kernelName;
	    if (gradRegistry.has(kernelName)) {
	        console.warn("Overriding the gradient for '" + kernelName + "'");
	    }
	    gradRegistry.set(kernelName, config);
	}
	exports.registerGradient = registerGradient;
	/**
	 * Removes the kernel function from the registry.
	 *
	 * @param kernelName The official name of the kernel.
	 * @param backendName The official name of the backend.
	 *
	 */
	function unregisterKernel(kernelName, backendName) {
	    var key = makeKey(kernelName, backendName);
	    if (!kernelRegistry.has(key)) {
	        throw new Error("The kernel '" + kernelName + "' for backend " +
	            ("'" + backendName + "' is not registered"));
	    }
	    kernelRegistry.delete(key);
	}
	exports.unregisterKernel = unregisterKernel;
	/** Removes the registered gradient from the global registry. */
	function unregisterGradient(kernelName) {
	    if (!gradRegistry.has(kernelName)) {
	        throw new Error("The gradient '" + kernelName + "' for backend is not registered");
	    }
	    gradRegistry.delete(kernelName);
	}
	exports.unregisterGradient = unregisterGradient;
	function makeKey(kernelName, backendName) {
	    return backendName + "_" + kernelName;
	}
	//# sourceMappingURL=kernel_registry.js.map

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util = __webpack_require__(10);
	function assertParamsConsistent(shapes, axis) {
	    var rank = shapes[0].length;
	    shapes.forEach(function (shape, i) {
	        util.assert(shape.length === rank, function () {
	            return "Error in concat" + rank + "D: rank of tensors[" + i + "] must be the same " +
	                ("as the rank of the rest (" + rank + ")");
	        });
	    });
	    util.assert(axis >= 0 && axis < rank, function () { return "Error in concat" + rank + "D: axis must be between 0 and " + (rank - 1) + "."; });
	    var firstShape = shapes[0];
	    shapes.forEach(function (shape, i) {
	        for (var r = 0; r < rank; r++) {
	            util.assert((r === axis) || (shape[r] === firstShape[r]), function () { return "Error in concat" + rank + "D: Shape of tensors[" + i + "] (" + shape + ") " +
	                ("does not match the shape of the rest (" + firstShape + ") ") +
	                ("along the non-concatenated axis " + i + "."); });
	        }
	    });
	}
	exports.assertParamsConsistent = assertParamsConsistent;
	function computeOutShape(shapes, axis) {
	    var outputShape = shapes[0].slice();
	    for (var i = 1; i < shapes.length; i++) {
	        outputShape[axis] += shapes[i][axis];
	    }
	    return outputShape;
	}
	exports.computeOutShape = computeOutShape;
	//# sourceMappingURL=concat_util.js.map

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var where_impl_1 = __webpack_require__(310);
	var engine_1 = __webpack_require__(15);
	var tensor_util_env_1 = __webpack_require__(17);
	var util_1 = __webpack_require__(10);
	var broadcast_util_1 = __webpack_require__(57);
	var operation_1 = __webpack_require__(18);
	var tensor_ops_1 = __webpack_require__(31);
	/**
	 * Returns the truth value of `NOT x` element-wise.
	 *
	 * ```js
	 * const a = tf.tensor1d([false, true], 'bool');
	 *
	 * a.logicalNot().print();
	 * ```
	 *
	 * @param x The input tensor. Must be of dtype 'bool'.
	 */
	/** @doc {heading: 'Operations', subheading: 'Logical'} */
	function logicalNot_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'logicalNot', 'bool');
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.logicalNot($x); }, { $x: $x });
	}
	/**
	 * Returns the truth value of `a AND b` element-wise. Supports broadcasting.
	 *
	 * ```js
	 * const a = tf.tensor1d([false, false, true, true], 'bool');
	 * const b = tf.tensor1d([false, true, false, true], 'bool');
	 *
	 * a.logicalAnd(b).print();
	 * ```
	 *
	 * @param a The first input tensor. Must be of dtype bool.
	 * @param b The second input tensor. Must be of dtype bool.
	 */
	/** @doc {heading: 'Operations', subheading: 'Logical'} */
	function logicalAnd_(a, b) {
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'logicalAnd', 'bool');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'logicalAnd', 'bool');
	    broadcast_util_1.assertAndGetBroadcastShape($a.shape, $b.shape);
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.logicalAnd($a, $b); }, { a: $a, b: $b }, null /* grad */, 'LogicalAnd');
	}
	/**
	 * Returns the truth value of `a OR b` element-wise. Supports broadcasting.
	 *
	 * ```js
	 * const a = tf.tensor1d([false, false, true, true], 'bool');
	 * const b = tf.tensor1d([false, true, false, true], 'bool');
	 *
	 * a.logicalOr(b).print();
	 * ```
	 * @param a The first input tensor. Must be of dtype bool.
	 * @param b The second input tensor. Must be of dtype bool.
	 */
	/** @doc {heading: 'Operations', subheading: 'Logical'} */
	function logicalOr_(a, b) {
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'logicalOr', 'bool');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'logicalOr', 'bool');
	    broadcast_util_1.assertAndGetBroadcastShape($a.shape, $b.shape);
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.logicalOr($a, $b); }, { $a: $a, $b: $b });
	}
	/**
	 * Returns the truth value of `a XOR b` element-wise. Supports broadcasting.
	 *
	 * ```js
	 * const a = tf.tensor1d([false, false, true, true], 'bool');
	 * const b = tf.tensor1d([false, true, false, true], 'bool');
	 *
	 * a.logicalXor(b).print();
	 * ```
	 *
	 * @param a The first input tensor. Must be of dtype bool.
	 * @param b The second input tensor. Must be of dtype bool.
	 */
	/** @doc {heading: 'Operations', subheading: 'Logical'} */
	function logicalXor_(a, b) {
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'logicalXor', 'bool');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'logicalXor', 'bool');
	    broadcast_util_1.assertAndGetBroadcastShape($a.shape, $b.shape);
	    // x ^ y = (x | y) & ~(x & y)
	    return exports.logicalOr(a, b).logicalAnd(exports.logicalAnd(a, b).logicalNot());
	}
	/**
	 * Returns the elements, either `a` or `b` depending on the `condition`.
	 *
	 * If the condition is true, select from `a`, otherwise select from `b`.
	 *
	 * ```js
	 * const cond = tf.tensor1d([false, false, true], 'bool');
	 * const a = tf.tensor1d([1 , 2, 3]);
	 * const b = tf.tensor1d([-1, -2, -3]);
	 *
	 * a.where(cond, b).print();
	 * ```
	 *
	 * @param condition The input condition. Must be of dtype bool.
	 * @param a If `condition` is rank 1, `a` may have a higher rank but
	 *     its first dimension must match the size of `condition`.
	 * @param b A tensor with the same shape and type as `a`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Logical'} */
	function where_(condition, a, b) {
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'where');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'where');
	    var $condition = tensor_util_env_1.convertToTensor(condition, 'condition', 'where', 'bool');
	    util_1.assertShapesMatch($a.shape, $b.shape, 'Error in where: ');
	    if ($condition.rank === 1) {
	        // If condition rank is 1, then the first dimension must match the size of
	        // condition.
	        util_1.assert($condition.shape[0] === $a.shape[0], function () { return 'The first dimension of `a` must match the size of `condition`.'; });
	    }
	    else {
	        // A must have the same shape as condition.
	        util_1.assertShapesMatch($condition.shape, $b.shape, 'Error in where: ');
	    }
	    // TODO(julianoks): Return null for condition gradient
	    // when backprop supports it.
	    var grad = function (dy, saved) {
	        var $condition = saved[0];
	        return {
	            $condition: function () { return tensor_ops_1.zerosLike($condition).toFloat(); },
	            $a: function () { return dy.mul($condition.cast(dy.dtype)); },
	            $b: function () { return dy.mul($condition.logicalNot().cast(dy.dtype)); }
	        };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.select($condition, $a, $b);
	        save([$condition]);
	        return res;
	    }, { $condition: $condition, $a: $a, $b: $b }, grad);
	}
	/**
	 * Returns the coordinates of true elements of condition.
	 *
	 * The coordinates are returned in a 2-D tensor where the first dimension (rows)
	 * represents the number of true elements, and the second dimension (columns)
	 * represents the coordinates of the true elements. Keep in mind, the shape of
	 * the output tensor can vary depending on how many true values there are in
	 * input. Indices are output in row-major order. The resulting tensor has the
	 * shape `[numTrueElems, condition.rank]`.
	 *
	 * This is analogous to calling the python `tf.where(cond)` without an x or y.
	 *
	 * ```js
	 * const cond = tf.tensor1d([false, false, true], 'bool');
	 * const result = await tf.whereAsync(cond);
	 * result.print();
	 * ```
	 */
	/** @doc {heading: 'Operations', subheading: 'Logical'} */
	function whereAsync_(condition) {
	    return __awaiter(this, void 0, void 0, function () {
	        var $condition, vals, res;
	        return __generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    $condition = tensor_util_env_1.convertToTensor(condition, 'condition', 'whereAsync', 'bool');
	                    return [4 /*yield*/, $condition.data()];
	                case 1:
	                    vals = _a.sent();
	                    res = where_impl_1.whereImpl($condition.shape, vals);
	                    if (condition !== $condition) {
	                        $condition.dispose();
	                    }
	                    return [2 /*return*/, res];
	            }
	        });
	    });
	}
	exports.logicalAnd = operation_1.op({ logicalAnd_: logicalAnd_ });
	exports.logicalNot = operation_1.op({ logicalNot_: logicalNot_ });
	exports.logicalOr = operation_1.op({ logicalOr_: logicalOr_ });
	exports.logicalXor = operation_1.op({ logicalXor_: logicalXor_ });
	exports.where = operation_1.op({ where_: where_ });
	exports.whereAsync = whereAsync_;
	//# sourceMappingURL=logical_ops.js.map

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Button = exports.PhoneButton = exports.WAButton = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App = __webpack_require__(241);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CLASS_NAME = 'btn btn-primary';
	
	var Button = function (_Component) {
	    _inherits(Button, _Component);
	
	    function Button(props) {
	        _classCallCheck(this, Button);
	
	        var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));
	
	        _this.state = {
	            disabled: false,
	            showLoading: false
	        };
	        return _this;
	    }
	
	    _createClass(Button, [{
	        key: 'trackGAEvent',
	        value: function trackGAEvent() {
	            var gaEvent = {};
	            if (this.props.gaCategory) gaEvent.category = this.props.gaCategory;
	
	            if (this.props.gaAction) gaEvent.action = this.props.gaAction;
	            if (this.props.gaValue) gaEvent.value = parseInt(this.props.gaValue, 10);
	            if (this.props.gaLabel) gaEvent.label = this.props.gaLabel;
	            _App.ReactGA.event(gaEvent);
	        }
	    }, {
	        key: 'onClick',
	        value: function onClick(event) {
	            if (this.props.gaEvent) this.trackGAEvent();
	            window.location = event;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                type = _props.type,
	                className = _props.className,
	                disabled = _props.disabled,
	                value = _props.value,
	                faclass = _props.faclass,
	                dataLink = _props.dataLink;
	
	            var classNames = !className ? CLASS_NAME : CLASS_NAME + ' ' + className;
	
	            return _react2.default.createElement(
	                'button',
	                {
	                    type: type,
	                    onClick: this.onClick.bind(this, dataLink || ''),
	                    className: classNames,
	                    disabled: disabled === true ? disabled : this.state.disabled
	                },
	                _react2.default.createElement('i', { className: faclass }),
	                ' ',
	                value
	            );
	        }
	    }]);
	
	    return Button;
	}(_react.Component);
	
	Button.defaultProps = {
	    type: 'button'
	};
	Button.propTypes = {
	    type: _react.PropTypes.oneOf(['button', 'submit', 'reset']).isRequired,
	    className: _react.PropTypes.string,
	    disabled: _react.PropTypes.bool,
	    value: _react.PropTypes.string.isRequired,
	    dataLink: _react.PropTypes.string,
	    gaEvent: _react.PropTypes.string,
	    gaCategory: _react.PropTypes.string,
	    gaAction: _react.PropTypes.string,
	    gaValue: _react.PropTypes.string,
	    gaLabel: _react.PropTypes.string
	};
	
	var WAButton = function (_Component2) {
	    _inherits(WAButton, _Component2);
	
	    function WAButton() {
	        _classCallCheck(this, WAButton);
	
	        return _possibleConstructorReturn(this, (WAButton.__proto__ || Object.getPrototypeOf(WAButton)).apply(this, arguments));
	    }
	
	    _createClass(WAButton, [{
	        key: 'WALink',
	        value: function WALink() {
	            var _props2 = this.props,
	                phone = _props2.phone,
	                text = _props2.text;
	
	            return 'https://api.whatsapp.com/send?phone=' + phone + '&text=' + text;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(Button, { dataLink: this.WALink(), className: 'pd-simple-button pd-green-button', value: this.props.value, gaEvent: this.props.gaEvent, gaCategory: this.props.gaCategory, gaAction: this.props.gaAction, gaValue: this.props.gaValue, gaLabel: this.props.gaLabel, faclass: 'fa fa-whatsapp fa-lg fa-whatsapp-margin' });
	        }
	    }]);
	
	    return WAButton;
	}(_react.Component);
	
	WAButton.propTypes = {
	    phone: _react.PropTypes.string,
	    text: _react.PropTypes.string
	};
	
	var PhoneButton = function (_Component3) {
	    _inherits(PhoneButton, _Component3);
	
	    function PhoneButton() {
	        _classCallCheck(this, PhoneButton);
	
	        return _possibleConstructorReturn(this, (PhoneButton.__proto__ || Object.getPrototypeOf(PhoneButton)).apply(this, arguments));
	    }
	
	    _createClass(PhoneButton, [{
	        key: 'PhoneLink',
	        value: function PhoneLink() {
	            var _props3 = this.props,
	                phone = _props3.phone,
	                text = _props3.text;
	
	            return 'tel:' + phone;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(Button, { dataLink: this.PhoneLink(), className: 'pd-simple-button btn-warning btn-md', value: this.props.value, gaEvent: this.props.gaEvent, gaCategory: this.props.gaCategory, gaAction: this.props.gaAction, gaValue: this.props.gaValue, gaLabel: this.props.gaLabel, faclass: 'fa fa-phone fa-lg fa-whatsapp-margin' });
	        }
	    }]);
	
	    return PhoneButton;
	}(_react.Component);
	
	PhoneButton.propTypes = {
	    phone: _react.PropTypes.string,
	    text: _react.PropTypes.string
	};
	exports.WAButton = WAButton;
	exports.PhoneButton = PhoneButton;
	exports.Button = Button;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1255), __esModule: true };

/***/ },
/* 157 */
[2090, 250],
/* 158 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 159 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 160 */
[2114, 526, 340],
/* 161 */
[2127, 338],
/* 162 */
[2094, 206, 361, 123],
/* 163 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(45);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(124));
	
	var _default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	exports.default = _default;
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	  return false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(34);
	var Point_1 = __webpack_require__(380);
	var Box = /** @class */ (function () {
	    function Box(_box, allowNegativeDimensions) {
	        if (allowNegativeDimensions === void 0) { allowNegativeDimensions = true; }
	        var box = (_box || {});
	        var isBbox = [box.left, box.top, box.right, box.bottom].every(utils_1.isValidNumber);
	        var isRect = [box.x, box.y, box.width, box.height].every(utils_1.isValidNumber);
	        if (!isRect && !isBbox) {
	            throw new Error("Box.constructor - expected box to be IBoundingBox | IRect, instead have " + JSON.stringify(box));
	        }
	        var _a = isRect
	            ? [box.x, box.y, box.width, box.height]
	            : [box.left, box.top, box.right - box.left, box.bottom - box.top], x = _a[0], y = _a[1], width = _a[2], height = _a[3];
	        Box.assertIsValidBox({ x: x, y: y, width: width, height: height }, 'Box.constructor', allowNegativeDimensions);
	        this._x = x;
	        this._y = y;
	        this._width = width;
	        this._height = height;
	    }
	    Box.isRect = function (rect) {
	        return !!rect && [rect.x, rect.y, rect.width, rect.height].every(utils_1.isValidNumber);
	    };
	    Box.assertIsValidBox = function (box, callee, allowNegativeDimensions) {
	        if (allowNegativeDimensions === void 0) { allowNegativeDimensions = false; }
	        if (!Box.isRect(box)) {
	            throw new Error(callee + " - invalid box: " + JSON.stringify(box) + ", expected object with properties x, y, width, height");
	        }
	        if (!allowNegativeDimensions && (box.width < 0 || box.height < 0)) {
	            throw new Error(callee + " - width (" + box.width + ") and height (" + box.height + ") must be positive numbers");
	        }
	    };
	    Object.defineProperty(Box.prototype, "x", {
	        get: function () { return this._x; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Box.prototype, "y", {
	        get: function () { return this._y; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Box.prototype, "width", {
	        get: function () { return this._width; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Box.prototype, "height", {
	        get: function () { return this._height; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Box.prototype, "left", {
	        get: function () { return this.x; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Box.prototype, "top", {
	        get: function () { return this.y; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Box.prototype, "right", {
	        get: function () { return this.x + this.width; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Box.prototype, "bottom", {
	        get: function () { return this.y + this.height; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Box.prototype, "area", {
	        get: function () { return this.width * this.height; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Box.prototype, "topLeft", {
	        get: function () { return new Point_1.Point(this.left, this.top); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Box.prototype, "topRight", {
	        get: function () { return new Point_1.Point(this.right, this.top); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Box.prototype, "bottomLeft", {
	        get: function () { return new Point_1.Point(this.left, this.bottom); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Box.prototype, "bottomRight", {
	        get: function () { return new Point_1.Point(this.right, this.bottom); },
	        enumerable: true,
	        configurable: true
	    });
	    Box.prototype.round = function () {
	        var _a = [this.x, this.y, this.width, this.height]
	            .map(function (val) { return Math.round(val); }), x = _a[0], y = _a[1], width = _a[2], height = _a[3];
	        return new Box({ x: x, y: y, width: width, height: height });
	    };
	    Box.prototype.floor = function () {
	        var _a = [this.x, this.y, this.width, this.height]
	            .map(function (val) { return Math.floor(val); }), x = _a[0], y = _a[1], width = _a[2], height = _a[3];
	        return new Box({ x: x, y: y, width: width, height: height });
	    };
	    Box.prototype.toSquare = function () {
	        var _a = this, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        var diff = Math.abs(width - height);
	        if (width < height) {
	            x -= (diff / 2);
	            width += diff;
	        }
	        if (height < width) {
	            y -= (diff / 2);
	            height += diff;
	        }
	        return new Box({ x: x, y: y, width: width, height: height });
	    };
	    Box.prototype.rescale = function (s) {
	        var scaleX = utils_1.isDimensions(s) ? s.width : s;
	        var scaleY = utils_1.isDimensions(s) ? s.height : s;
	        return new Box({
	            x: this.x * scaleX,
	            y: this.y * scaleY,
	            width: this.width * scaleX,
	            height: this.height * scaleY
	        });
	    };
	    Box.prototype.pad = function (padX, padY) {
	        var _a = [
	            this.x - (padX / 2),
	            this.y - (padY / 2),
	            this.width + padX,
	            this.height + padY
	        ], x = _a[0], y = _a[1], width = _a[2], height = _a[3];
	        return new Box({ x: x, y: y, width: width, height: height });
	    };
	    Box.prototype.clipAtImageBorders = function (imgWidth, imgHeight) {
	        var _a = this, x = _a.x, y = _a.y, right = _a.right, bottom = _a.bottom;
	        var clippedX = Math.max(x, 0);
	        var clippedY = Math.max(y, 0);
	        var newWidth = right - clippedX;
	        var newHeight = bottom - clippedY;
	        var clippedWidth = Math.min(newWidth, imgWidth - clippedX);
	        var clippedHeight = Math.min(newHeight, imgHeight - clippedY);
	        return (new Box({ x: clippedX, y: clippedY, width: clippedWidth, height: clippedHeight })).floor();
	    };
	    Box.prototype.shift = function (sx, sy) {
	        var _a = this, width = _a.width, height = _a.height;
	        var x = this.x + sx;
	        var y = this.y + sy;
	        return new Box({ x: x, y: y, width: width, height: height });
	    };
	    Box.prototype.padAtBorders = function (imageHeight, imageWidth) {
	        var w = this.width + 1;
	        var h = this.height + 1;
	        var dx = 1;
	        var dy = 1;
	        var edx = w;
	        var edy = h;
	        var x = this.left;
	        var y = this.top;
	        var ex = this.right;
	        var ey = this.bottom;
	        if (ex > imageWidth) {
	            edx = -ex + imageWidth + w;
	            ex = imageWidth;
	        }
	        if (ey > imageHeight) {
	            edy = -ey + imageHeight + h;
	            ey = imageHeight;
	        }
	        if (x < 1) {
	            edy = 2 - x;
	            x = 1;
	        }
	        if (y < 1) {
	            edy = 2 - y;
	            y = 1;
	        }
	        return { dy: dy, edy: edy, dx: dx, edx: edx, y: y, ey: ey, x: x, ex: ex, w: w, h: h };
	    };
	    Box.prototype.calibrate = function (region) {
	        return new Box({
	            left: this.left + (region.left * this.width),
	            top: this.top + (region.top * this.height),
	            right: this.right + (region.right * this.width),
	            bottom: this.bottom + (region.bottom * this.height)
	        }).toSquare().round();
	    };
	    return Box;
	}());
	exports.Box = Box;
	//# sourceMappingURL=Box.js.map

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ops_1 = __webpack_require__(98);
	var utils_1 = __webpack_require__(34);
	var Box_1 = __webpack_require__(165);
	var Dimensions_1 = __webpack_require__(210);
	var FaceDetection_1 = __webpack_require__(97);
	var Point_1 = __webpack_require__(380);
	var Rect_1 = __webpack_require__(578);
	// face alignment constants
	var relX = 0.5;
	var relY = 0.43;
	var relScale = 0.45;
	var FaceLandmarks = /** @class */ (function () {
	    function FaceLandmarks(relativeFaceLandmarkPositions, imgDims, shift) {
	        if (shift === void 0) { shift = new Point_1.Point(0, 0); }
	        var width = imgDims.width, height = imgDims.height;
	        this._imgDims = new Dimensions_1.Dimensions(width, height);
	        this._shift = shift;
	        this._positions = relativeFaceLandmarkPositions.map(function (pt) { return pt.mul(new Point_1.Point(width, height)).add(shift); });
	    }
	    Object.defineProperty(FaceLandmarks.prototype, "shift", {
	        get: function () { return new Point_1.Point(this._shift.x, this._shift.y); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FaceLandmarks.prototype, "imageWidth", {
	        get: function () { return this._imgDims.width; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FaceLandmarks.prototype, "imageHeight", {
	        get: function () { return this._imgDims.height; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FaceLandmarks.prototype, "positions", {
	        get: function () { return this._positions; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FaceLandmarks.prototype, "relativePositions", {
	        get: function () {
	            var _this = this;
	            return this._positions.map(function (pt) { return pt.sub(_this._shift).div(new Point_1.Point(_this.imageWidth, _this.imageHeight)); });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    FaceLandmarks.prototype.forSize = function (width, height) {
	        return new this.constructor(this.relativePositions, { width: width, height: height });
	    };
	    FaceLandmarks.prototype.shiftBy = function (x, y) {
	        return new this.constructor(this.relativePositions, this._imgDims, new Point_1.Point(x, y));
	    };
	    FaceLandmarks.prototype.shiftByPoint = function (pt) {
	        return this.shiftBy(pt.x, pt.y);
	    };
	    /**
	     * Aligns the face landmarks after face detection from the relative positions of the faces
	     * bounding box, or it's current shift. This function should be used to align the face images
	     * after face detection has been performed, before they are passed to the face recognition net.
	     * This will make the computed face descriptor more accurate.
	     *
	     * @param detection (optional) The bounding box of the face or the face detection result. If
	     * no argument was passed the position of the face landmarks are assumed to be relative to
	     * it's current shift.
	     * @returns The bounding box of the aligned face.
	     */
	    FaceLandmarks.prototype.align = function (detection, options) {
	        if (options === void 0) { options = {}; }
	        if (detection) {
	            var box = detection instanceof FaceDetection_1.FaceDetection
	                ? detection.box.floor()
	                : new Box_1.Box(detection);
	            return this.shiftBy(box.x, box.y).align(null, options);
	        }
	        var _a = Object.assign({}, { useDlibAlignment: false, minBoxPadding: 0.2 }, options), useDlibAlignment = _a.useDlibAlignment, minBoxPadding = _a.minBoxPadding;
	        if (useDlibAlignment) {
	            return this.alignDlib();
	        }
	        return this.alignMinBbox(minBoxPadding);
	    };
	    FaceLandmarks.prototype.alignDlib = function () {
	        var centers = this.getRefPointsForAlignment();
	        var leftEyeCenter = centers[0], rightEyeCenter = centers[1], mouthCenter = centers[2];
	        var distToMouth = function (pt) { return mouthCenter.sub(pt).magnitude(); };
	        var eyeToMouthDist = (distToMouth(leftEyeCenter) + distToMouth(rightEyeCenter)) / 2;
	        var size = Math.floor(eyeToMouthDist / relScale);
	        var refPoint = utils_1.getCenterPoint(centers);
	        // TODO: pad in case rectangle is out of image bounds
	        var x = Math.floor(Math.max(0, refPoint.x - (relX * size)));
	        var y = Math.floor(Math.max(0, refPoint.y - (relY * size)));
	        return new Rect_1.Rect(x, y, Math.min(size, this.imageWidth + x), Math.min(size, this.imageHeight + y));
	    };
	    FaceLandmarks.prototype.alignMinBbox = function (padding) {
	        var box = ops_1.minBbox(this.positions);
	        return box.pad(box.width * padding, box.height * padding);
	    };
	    FaceLandmarks.prototype.getRefPointsForAlignment = function () {
	        throw new Error('getRefPointsForAlignment not implemented by base class');
	    };
	    return FaceLandmarks;
	}());
	exports.FaceLandmarks = FaceLandmarks;
	//# sourceMappingURL=FaceLandmarks.js.map

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var FaceDetection_1 = __webpack_require__(97);
	function isWithFaceDetection(obj) {
	    return obj['detection'] instanceof FaceDetection_1.FaceDetection;
	}
	exports.isWithFaceDetection = isWithFaceDetection;
	function extendWithFaceDetection(sourceObj, detection) {
	    var extension = { detection: detection };
	    return Object.assign({}, sourceObj, extension);
	}
	exports.extendWithFaceDetection = extendWithFaceDetection;
	//# sourceMappingURL=WithFaceDetection.js.map

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var ComposableTask = /** @class */ (function () {
	    function ComposableTask() {
	    }
	    ComposableTask.prototype.then = function (onfulfilled) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _a;
	            return tslib_1.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        _a = onfulfilled;
	                        return [4 /*yield*/, this.run()];
	                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
	                }
	            });
	        });
	    };
	    ComposableTask.prototype.run = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                throw new Error('ComposableTask - run is not implemented');
	            });
	        });
	    };
	    return ComposableTask;
	}());
	exports.ComposableTask = ComposableTask;
	//# sourceMappingURL=ComposableTask.js.map

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AgeGenderNet_1 = __webpack_require__(572);
	var FaceExpressionNet_1 = __webpack_require__(597);
	var FaceLandmark68Net_1 = __webpack_require__(386);
	var FaceLandmark68TinyNet_1 = __webpack_require__(604);
	var FaceRecognitionNet_1 = __webpack_require__(387);
	var Mtcnn_1 = __webpack_require__(390);
	var SsdMobilenetv1_1 = __webpack_require__(395);
	var TinyFaceDetector_1 = __webpack_require__(396);
	var tinyYolov2_1 = __webpack_require__(212);
	exports.nets = {
	    ssdMobilenetv1: new SsdMobilenetv1_1.SsdMobilenetv1(),
	    tinyFaceDetector: new TinyFaceDetector_1.TinyFaceDetector(),
	    tinyYolov2: new tinyYolov2_1.TinyYolov2(),
	    mtcnn: new Mtcnn_1.Mtcnn(),
	    faceLandmark68Net: new FaceLandmark68Net_1.FaceLandmark68Net(),
	    faceLandmark68TinyNet: new FaceLandmark68TinyNet_1.FaceLandmark68TinyNet(),
	    faceRecognitionNet: new FaceRecognitionNet_1.FaceRecognitionNet(),
	    faceExpressionNet: new FaceExpressionNet_1.FaceExpressionNet(),
	    ageGenderNet: new AgeGenderNet_1.AgeGenderNet()
	};
	/**
	 * Attempts to detect all faces in an image using SSD Mobilenetv1 Network.
	 *
	 * @param input The input image.
	 * @param options (optional, default: see SsdMobilenetv1Options constructor for default parameters).
	 * @returns Bounding box of each face with score.
	 */
	exports.ssdMobilenetv1 = function (input, options) {
	    return exports.nets.ssdMobilenetv1.locateFaces(input, options);
	};
	/**
	 * Attempts to detect all faces in an image using the Tiny Face Detector.
	 *
	 * @param input The input image.
	 * @param options (optional, default: see TinyFaceDetectorOptions constructor for default parameters).
	 * @returns Bounding box of each face with score.
	 */
	exports.tinyFaceDetector = function (input, options) {
	    return exports.nets.tinyFaceDetector.locateFaces(input, options);
	};
	/**
	 * Attempts to detect all faces in an image using the Tiny Yolov2 Network.
	 *
	 * @param input The input image.
	 * @param options (optional, default: see TinyYolov2Options constructor for default parameters).
	 * @returns Bounding box of each face with score.
	 */
	exports.tinyYolov2 = function (input, options) {
	    return exports.nets.tinyYolov2.locateFaces(input, options);
	};
	/**
	 * Attempts to detect all faces in an image and the 5 point face landmarks
	 * of each detected face using the MTCNN Network.
	 *
	 * @param input The input image.
	 * @param options (optional, default: see MtcnnOptions constructor for default parameters).
	 * @returns Bounding box of each face with score and 5 point face landmarks.
	 */
	exports.mtcnn = function (input, options) {
	    return exports.nets.mtcnn.forward(input, options);
	};
	/**
	 * Detects the 68 point face landmark positions of the face shown in an image.
	 *
	 * @param inputs The face image extracted from the bounding box of a face. Can
	 * also be an array of input images, which will be batch processed.
	 * @returns 68 point face landmarks or array thereof in case of batch input.
	 */
	exports.detectFaceLandmarks = function (input) {
	    return exports.nets.faceLandmark68Net.detectLandmarks(input);
	};
	/**
	 * Detects the 68 point face landmark positions of the face shown in an image
	 * using a tinier version of the 68 point face landmark model, which is slightly
	 * faster at inference, but also slightly less accurate.
	 *
	 * @param inputs The face image extracted from the bounding box of a face. Can
	 * also be an array of input images, which will be batch processed.
	 * @returns 68 point face landmarks or array thereof in case of batch input.
	 */
	exports.detectFaceLandmarksTiny = function (input) {
	    return exports.nets.faceLandmark68TinyNet.detectLandmarks(input);
	};
	/**
	 * Computes a 128 entry vector (face descriptor / face embeddings) from the face shown in an image,
	 * which uniquely represents the features of that persons face. The computed face descriptor can
	 * be used to measure the similarity between faces, by computing the euclidean distance of two
	 * face descriptors.
	 *
	 * @param inputs The face image extracted from the aligned bounding box of a face. Can
	 * also be an array of input images, which will be batch processed.
	 * @returns Face descriptor with 128 entries or array thereof in case of batch input.
	 */
	exports.computeFaceDescriptor = function (input) {
	    return exports.nets.faceRecognitionNet.computeFaceDescriptor(input);
	};
	/**
	 * Recognizes the facial expressions from a face image.
	 *
	 * @param inputs The face image extracted from the bounding box of a face. Can
	 * also be an array of input images, which will be batch processed.
	 * @returns Facial expressions with corresponding probabilities or array thereof in case of batch input.
	 */
	exports.recognizeFaceExpressions = function (input) {
	    return exports.nets.faceExpressionNet.predictExpressions(input);
	};
	/**
	 * Predicts age and gender from a face image.
	 *
	 * @param inputs The face image extracted from the bounding box of a face. Can
	 * also be an array of input images, which will be batch processed.
	 * @returns Predictions with age, gender and gender probability or array thereof in case of batch input.
	 */
	exports.predictAgeAndGender = function (input) {
	    return exports.nets.ageGenderNet.predictAgeAndGender(input);
	};
	exports.loadSsdMobilenetv1Model = function (url) { return exports.nets.ssdMobilenetv1.load(url); };
	exports.loadTinyFaceDetectorModel = function (url) { return exports.nets.tinyFaceDetector.load(url); };
	exports.loadMtcnnModel = function (url) { return exports.nets.mtcnn.load(url); };
	exports.loadTinyYolov2Model = function (url) { return exports.nets.tinyYolov2.load(url); };
	exports.loadFaceLandmarkModel = function (url) { return exports.nets.faceLandmark68Net.load(url); };
	exports.loadFaceLandmarkTinyModel = function (url) { return exports.nets.faceLandmark68TinyNet.load(url); };
	exports.loadFaceRecognitionModel = function (url) { return exports.nets.faceRecognitionNet.load(url); };
	exports.loadFaceExpressionModel = function (url) { return exports.nets.faceExpressionNet.load(url); };
	exports.loadAgeGenderModel = function (url) { return exports.nets.ageGenderNet.load(url); };
	// backward compatibility
	exports.loadFaceDetectionModel = exports.loadSsdMobilenetv1Model;
	exports.locateFaces = exports.ssdMobilenetv1;
	exports.detectLandmarks = exports.detectFaceLandmarks;
	//# sourceMappingURL=nets.js.map

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(126);
	
	var _Actions = __webpack_require__(275);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },
/* 171 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isTouchDevice;
	function isTouchDevice() {
	  return !!(typeof window !== 'undefined' && ('ontouchstart' in window || window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch)) || !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints));
	}
	module.exports = exports['default'];

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(278),
	    getRawTag = __webpack_require__(1602),
	    objectToString = __webpack_require__(1630);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 173 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _propTypes["default"].oneOf([_constants.ICON_BEFORE_POSITION, _constants.ICON_AFTER_POSITION]);
	
	exports["default"] = _default;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _propTypes["default"].oneOf([_constants.HORIZONTAL_ORIENTATION, _constants.VERTICAL_ORIENTATION, _constants.VERTICAL_SCROLLABLE]);
	
	exports["default"] = _default;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isInclusivelyAfterDay;
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _isBeforeDay = _interopRequireDefault(__webpack_require__(225));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function isInclusivelyAfterDay(a, b) {
	  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
	  return !(0, _isBeforeDay["default"])(a, b);
	}

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isSameDay;
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function isSameDay(a, b) {
	  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false; // Compare least significant, most likely to change units first
	  // Moment's isSame clones moment inputs and is a tad slow
	
	  return a.date() === b.date() && a.month() === b.month() && a.year() === b.year();
	}

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = toMomentObject;
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function toMomentObject(dateString, customFormat) {
	  var dateFormats = customFormat ? [customFormat, _constants.DISPLAY_FORMAT, _constants.ISO_FORMAT] : [_constants.DISPLAY_FORMAT, _constants.ISO_FORMAT];
	  var date = (0, _moment["default"])(dateString, dateFormats, true);
	  return date.isValid() ? date.hour(12) : null;
	}

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(439);
	var setInnerHTML = __webpack_require__(297);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(447);
	var setTextContent = __webpack_require__(896);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(20);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1866);
	var ReactInstrumentation = __webpack_require__(86);
	
	var warning = __webpack_require__(25);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(464);
	
	var ReactBaseClasses = __webpack_require__(921);
	var ReactChildren = __webpack_require__(1967);
	var ReactDOMFactories = __webpack_require__(1968);
	var ReactElement = __webpack_require__(185);
	var ReactPropTypes = __webpack_require__(1969);
	var ReactVersion = __webpack_require__(1970);
	
	var createReactClass = __webpack_require__(1971);
	var onlyChild = __webpack_require__(1975);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(464);
	
	var ReactCurrentOwner = __webpack_require__(118);
	
	var warning = __webpack_require__(25);
	var canDefineProperty = __webpack_require__(925);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(923);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(375).EventEmitter;
	var inherits = __webpack_require__(100);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(2038);
	Stream.Writable = __webpack_require__(2040);
	Stream.Duplex = __webpack_require__(2036);
	Stream.Transform = __webpack_require__(2039);
	Stream.PassThrough = __webpack_require__(2037);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ },
/* 187 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Implementation of the NonMaxSuppression kernel shared between webgl and cpu.
	 */
	var tensor_ops_1 = __webpack_require__(31);
	var array_util_1 = __webpack_require__(957);
	function nonMaxSuppressionV3(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold) {
	    var dummySoftNmsSigma = 0.0;
	    return nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, dummySoftNmsSigma)
	        .selectedIndices;
	}
	exports.nonMaxSuppressionV3 = nonMaxSuppressionV3;
	function nonMaxSuppressionV5(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma) {
	    // For NonMaxSuppressionV5Op, we always return a second output holding
	    // corresponding scores.
	    var returnScoresTensor = true;
	    var result = nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma, returnScoresTensor);
	    result.numValidOutputs.dispose();
	    return {
	        selectedIndices: result.selectedIndices,
	        selectedScores: result.selectedScores
	    };
	}
	exports.nonMaxSuppressionV5 = nonMaxSuppressionV5;
	function nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma, returnScoresTensor, padToMaxOutputSize) {
	    if (returnScoresTensor === void 0) { returnScoresTensor = false; }
	    if (padToMaxOutputSize === void 0) { padToMaxOutputSize = false; }
	    // The list is sorted in ascending order, so that we can always pop the
	    // candidate with the largest score in O(1) time.
	    var candidates = Array.from(scores)
	        .map(function (score, boxIndex) { return ({ score: score, boxIndex: boxIndex, suppressBeginIndex: 0 }); })
	        .filter(function (c) { return c.score > scoreThreshold; })
	        .sort(ascendingComparator);
	    // If softNmsSigma is 0, the outcome of this algorithm is exactly same as
	    // before.
	    var scale = softNmsSigma > 0 ? (-0.5 / softNmsSigma) : 0.0;
	    var selectedIndices = [];
	    var selectedScores = [];
	    while (selectedIndices.length < maxOutputSize && candidates.length > 0) {
	        var candidate = candidates.pop();
	        var originalScore = candidate.score, boxIndex = candidate.boxIndex, suppressBeginIndex = candidate.suppressBeginIndex;
	        if (originalScore < scoreThreshold) {
	            break;
	        }
	        // Overlapping boxes are likely to have similar scores, therefore we
	        // iterate through the previously selected boxes backwards in order to
	        // see if candidate's score should be suppressed. We use
	        // suppressBeginIndex to track and ensure a candidate can be suppressed
	        // by a selected box no more than once. Also, if the overlap exceeds
	        // iouThreshold, we simply ignore the candidate.
	        var ignoreCandidate = false;
	        for (var j = selectedIndices.length - 1; j >= suppressBeginIndex; --j) {
	            var iou = intersectionOverUnion(boxes, boxIndex, selectedIndices[j]);
	            if (iou >= iouThreshold) {
	                ignoreCandidate = true;
	                break;
	            }
	            candidate.score =
	                candidate.score * suppressWeight(iouThreshold, scale, iou);
	            if (candidate.score <= scoreThreshold) {
	                break;
	            }
	        }
	        // At this point, if `candidate.score` has not dropped below
	        // `scoreThreshold`, then we know that we went through all of the
	        // previous selections and can safely update `suppressBeginIndex` to the
	        // end of the selected array. Then we can re-insert the candidate with
	        // the updated score and suppressBeginIndex back in the candidate list.
	        // If on the other hand, `candidate.score` has dropped below the score
	        // threshold, we will not add it back to the candidates list.
	        candidate.suppressBeginIndex = selectedIndices.length;
	        if (!ignoreCandidate) {
	            // Candidate has passed all the tests, and is not suppressed, so
	            // select the candidate.
	            if (candidate.score === originalScore) {
	                selectedIndices.push(boxIndex);
	                selectedScores.push(candidate.score);
	            }
	            else if (candidate.score > scoreThreshold) {
	                // Candidate's score is suppressed but is still high enough to be
	                // considered, so add back to the candidates list.
	                array_util_1.binaryInsert(candidates, candidate, ascendingComparator);
	            }
	        }
	    }
	    // NonMaxSuppressionV4 feature: padding output to maxOutputSize.
	    var numValidOutputs = selectedIndices.length;
	    if (padToMaxOutputSize) {
	        selectedIndices.fill(0, numValidOutputs);
	        selectedScores.fill(0.0, numValidOutputs);
	    }
	    return {
	        selectedIndices: tensor_ops_1.tensor1d(selectedIndices, 'int32'),
	        selectedScores: tensor_ops_1.tensor1d(selectedScores, 'float32'),
	        numValidOutputs: tensor_ops_1.scalar(numValidOutputs, 'int32')
	    };
	}
	function intersectionOverUnion(boxes, i, j) {
	    var iCoord = boxes.subarray(i * 4, i * 4 + 4);
	    var jCoord = boxes.subarray(j * 4, j * 4 + 4);
	    var yminI = Math.min(iCoord[0], iCoord[2]);
	    var xminI = Math.min(iCoord[1], iCoord[3]);
	    var ymaxI = Math.max(iCoord[0], iCoord[2]);
	    var xmaxI = Math.max(iCoord[1], iCoord[3]);
	    var yminJ = Math.min(jCoord[0], jCoord[2]);
	    var xminJ = Math.min(jCoord[1], jCoord[3]);
	    var ymaxJ = Math.max(jCoord[0], jCoord[2]);
	    var xmaxJ = Math.max(jCoord[1], jCoord[3]);
	    var areaI = (ymaxI - yminI) * (xmaxI - xminI);
	    var areaJ = (ymaxJ - yminJ) * (xmaxJ - xminJ);
	    if (areaI <= 0 || areaJ <= 0) {
	        return 0.0;
	    }
	    var intersectionYmin = Math.max(yminI, yminJ);
	    var intersectionXmin = Math.max(xminI, xminJ);
	    var intersectionYmax = Math.min(ymaxI, ymaxJ);
	    var intersectionXmax = Math.min(xmaxI, xmaxJ);
	    var intersectionArea = Math.max(intersectionYmax - intersectionYmin, 0.0) *
	        Math.max(intersectionXmax - intersectionXmin, 0.0);
	    return intersectionArea / (areaI + areaJ - intersectionArea);
	}
	// A Gaussian penalty function, this method always returns values in [0, 1].
	// The weight is a function of similarity, the more overlap two boxes are, the
	// smaller the weight is, meaning highly overlapping boxe will be significantly
	// penalized. On the other hand, a non-overlapping box will not be penalized.
	function suppressWeight(iouThreshold, scale, iou) {
	    var weight = Math.exp(scale * iou * iou);
	    return iou <= iouThreshold ? weight : 0.0;
	}
	function ascendingComparator(c1, c2) {
	    // For objects with same scores, we make the object with the larger index go
	    // first. In an array that pops from the end, this means that the object with
	    // the smaller index will be popped first. This ensures the same output as
	    // the TensorFlow python version.
	    return (c1.score - c2.score) ||
	        ((c1.score === c2.score) && (c2.boxIndex - c1.boxIndex));
	}
	//# sourceMappingURL=non_max_suppression_impl.js.map

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var environment_1 = __webpack_require__(28);
	var util = __webpack_require__(10);
	var canvas_util_1 = __webpack_require__(236);
	var tex_util_1 = __webpack_require__(82);
	function callAndCheck(gl, debugMode, func) {
	    var returnValue = func();
	    if (debugMode) {
	        checkWebGLError(gl);
	    }
	    return returnValue;
	}
	exports.callAndCheck = callAndCheck;
	function checkWebGLError(gl) {
	    var error = gl.getError();
	    if (error !== gl.NO_ERROR) {
	        throw new Error('WebGL Error: ' + getWebGLErrorMessage(gl, error));
	    }
	}
	// https://en.wikipedia.org/wiki/Half-precision_floating-point_format
	var MIN_FLOAT16 = 5.96e-8;
	var MAX_FLOAT16 = 65504;
	function canBeRepresented(num) {
	    if (environment_1.env().getBool('WEBGL_RENDER_FLOAT32_ENABLED') || num === 0 ||
	        (MIN_FLOAT16 < Math.abs(num) && Math.abs(num) < MAX_FLOAT16)) {
	        return true;
	    }
	    return false;
	}
	exports.canBeRepresented = canBeRepresented;
	function getWebGLErrorMessage(gl, status) {
	    switch (status) {
	        case gl.NO_ERROR:
	            return 'NO_ERROR';
	        case gl.INVALID_ENUM:
	            return 'INVALID_ENUM';
	        case gl.INVALID_VALUE:
	            return 'INVALID_VALUE';
	        case gl.INVALID_OPERATION:
	            return 'INVALID_OPERATION';
	        case gl.INVALID_FRAMEBUFFER_OPERATION:
	            return 'INVALID_FRAMEBUFFER_OPERATION';
	        case gl.OUT_OF_MEMORY:
	            return 'OUT_OF_MEMORY';
	        case gl.CONTEXT_LOST_WEBGL:
	            return 'CONTEXT_LOST_WEBGL';
	        default:
	            return "Unknown error code " + status;
	    }
	}
	exports.getWebGLErrorMessage = getWebGLErrorMessage;
	function getExtensionOrThrow(gl, debug, extensionName) {
	    return throwIfNull(gl, debug, function () { return gl.getExtension(extensionName); }, 'Extension "' + extensionName + '" not supported on this browser.');
	}
	exports.getExtensionOrThrow = getExtensionOrThrow;
	function createVertexShader(gl, debug, vertexShaderSource) {
	    var vertexShader = throwIfNull(gl, debug, function () { return gl.createShader(gl.VERTEX_SHADER); }, 'Unable to create vertex WebGLShader.');
	    callAndCheck(gl, debug, function () { return gl.shaderSource(vertexShader, vertexShaderSource); });
	    callAndCheck(gl, debug, function () { return gl.compileShader(vertexShader); });
	    if (gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS) === false) {
	        console.log(gl.getShaderInfoLog(vertexShader));
	        throw new Error('Failed to compile vertex shader.');
	    }
	    return vertexShader;
	}
	exports.createVertexShader = createVertexShader;
	function createFragmentShader(gl, debug, fragmentShaderSource) {
	    var fragmentShader = throwIfNull(gl, debug, function () { return gl.createShader(gl.FRAGMENT_SHADER); }, 'Unable to create fragment WebGLShader.');
	    callAndCheck(gl, debug, function () { return gl.shaderSource(fragmentShader, fragmentShaderSource); });
	    callAndCheck(gl, debug, function () { return gl.compileShader(fragmentShader); });
	    if (gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS) === false) {
	        logShaderSourceAndInfoLog(fragmentShaderSource, gl.getShaderInfoLog(fragmentShader));
	        throw new Error('Failed to compile fragment shader.');
	    }
	    return fragmentShader;
	}
	exports.createFragmentShader = createFragmentShader;
	var lineNumberRegex = /ERROR: [0-9]+:([0-9]+):/g;
	function logShaderSourceAndInfoLog(shaderSource, shaderInfoLog) {
	    var lineNumberRegexResult = lineNumberRegex.exec(shaderInfoLog);
	    if (lineNumberRegexResult == null) {
	        console.log("Couldn't parse line number in error: " + shaderInfoLog);
	        console.log(shaderSource);
	        return;
	    }
	    var lineNumber = +lineNumberRegexResult[1];
	    var shaderLines = shaderSource.split('\n');
	    var pad = shaderLines.length.toString().length + 2;
	    var linesWithLineNumbers = shaderLines.map(function (line, lineNumber) {
	        return util.rightPad((lineNumber + 1).toString(), pad) + line;
	    });
	    var maxLineLength = 0;
	    for (var i = 0; i < linesWithLineNumbers.length; i++) {
	        maxLineLength = Math.max(linesWithLineNumbers[i].length, maxLineLength);
	    }
	    var beforeErrorLines = linesWithLineNumbers.slice(0, lineNumber - 1);
	    var errorLine = linesWithLineNumbers.slice(lineNumber - 1, lineNumber);
	    var afterErrorLines = linesWithLineNumbers.slice(lineNumber);
	    console.log(beforeErrorLines.join('\n'));
	    console.log(shaderInfoLog.split('\n')[0]);
	    console.log("%c " + util.rightPad(errorLine[0], maxLineLength), 'border:1px solid red; background-color:#e3d2d2; color:#a61717');
	    console.log(afterErrorLines.join('\n'));
	}
	function createProgram(gl, debug) {
	    return throwIfNull(gl, debug, function () { return gl.createProgram(); }, 'Unable to create WebGLProgram.');
	}
	exports.createProgram = createProgram;
	function linkProgram(gl, debug, program) {
	    callAndCheck(gl, debug, function () { return gl.linkProgram(program); });
	    if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
	        console.log(gl.getProgramInfoLog(program));
	        throw new Error('Failed to link vertex and fragment shaders.');
	    }
	}
	exports.linkProgram = linkProgram;
	function validateProgram(gl, debug, program) {
	    callAndCheck(gl, debug, function () { return gl.validateProgram(program); });
	    if (gl.getProgramParameter(program, gl.VALIDATE_STATUS) === false) {
	        console.log(gl.getProgramInfoLog(program));
	        throw new Error('Shader program validation failed.');
	    }
	}
	exports.validateProgram = validateProgram;
	function createStaticVertexBuffer(gl, debug, data) {
	    var buffer = throwIfNull(gl, debug, function () { return gl.createBuffer(); }, 'Unable to create WebGLBuffer');
	    callAndCheck(gl, debug, function () { return gl.bindBuffer(gl.ARRAY_BUFFER, buffer); });
	    callAndCheck(gl, debug, function () { return gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW); });
	    return buffer;
	}
	exports.createStaticVertexBuffer = createStaticVertexBuffer;
	function createStaticIndexBuffer(gl, debug, data) {
	    var buffer = throwIfNull(gl, debug, function () { return gl.createBuffer(); }, 'Unable to create WebGLBuffer');
	    callAndCheck(gl, debug, function () { return gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buffer); });
	    callAndCheck(gl, debug, function () { return gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, data, gl.STATIC_DRAW); });
	    return buffer;
	}
	exports.createStaticIndexBuffer = createStaticIndexBuffer;
	function getNumChannels() {
	    if (environment_1.env().getNumber('WEBGL_VERSION') === 2) {
	        return 1;
	    }
	    return 4;
	}
	exports.getNumChannels = getNumChannels;
	function createTexture(gl, debug) {
	    return throwIfNull(gl, debug, function () { return gl.createTexture(); }, 'Unable to create WebGLTexture.');
	}
	exports.createTexture = createTexture;
	function validateTextureSize(width, height) {
	    var maxTextureSize = environment_1.env().getNumber('WEBGL_MAX_TEXTURE_SIZE');
	    if ((width <= 0) || (height <= 0)) {
	        var requested = "[" + width + "x" + height + "]";
	        throw new Error('Requested texture size ' + requested + ' is invalid.');
	    }
	    if ((width > maxTextureSize) || (height > maxTextureSize)) {
	        var requested = "[" + width + "x" + height + "]";
	        var max = "[" + maxTextureSize + "x" + maxTextureSize + "]";
	        throw new Error('Requested texture size ' + requested +
	            ' greater than WebGL maximum on this browser / GPU ' + max + '.');
	    }
	}
	exports.validateTextureSize = validateTextureSize;
	function createFramebuffer(gl, debug) {
	    return throwIfNull(gl, debug, function () { return gl.createFramebuffer(); }, 'Unable to create WebGLFramebuffer.');
	}
	exports.createFramebuffer = createFramebuffer;
	function bindVertexBufferToProgramAttribute(gl, debug, program, attribute, buffer, arrayEntriesPerItem, itemStrideInBytes, itemOffsetInBytes) {
	    var loc = gl.getAttribLocation(program, attribute);
	    if (loc === -1) {
	        // The GPU compiler decided to strip out this attribute because it's unused,
	        // thus no need to bind.
	        return false;
	    }
	    callAndCheck(gl, debug, function () { return gl.bindBuffer(gl.ARRAY_BUFFER, buffer); });
	    callAndCheck(gl, debug, function () { return gl.vertexAttribPointer(loc, arrayEntriesPerItem, gl.FLOAT, false, itemStrideInBytes, itemOffsetInBytes); });
	    callAndCheck(gl, debug, function () { return gl.enableVertexAttribArray(loc); });
	    return true;
	}
	exports.bindVertexBufferToProgramAttribute = bindVertexBufferToProgramAttribute;
	function bindTextureUnit(gl, debug, texture, textureUnit) {
	    validateTextureUnit(gl, textureUnit);
	    callAndCheck(gl, debug, function () { return gl.activeTexture(gl.TEXTURE0 + textureUnit); });
	    callAndCheck(gl, debug, function () { return gl.bindTexture(gl.TEXTURE_2D, texture); });
	}
	exports.bindTextureUnit = bindTextureUnit;
	function unbindTextureUnit(gl, debug, textureUnit) {
	    validateTextureUnit(gl, textureUnit);
	    callAndCheck(gl, debug, function () { return gl.activeTexture(gl.TEXTURE0 + textureUnit); });
	    callAndCheck(gl, debug, function () { return gl.bindTexture(gl.TEXTURE_2D, null); });
	}
	exports.unbindTextureUnit = unbindTextureUnit;
	function getProgramUniformLocationOrThrow(gl, debug, program, uniformName) {
	    return throwIfNull(gl, debug, function () { return gl.getUniformLocation(program, uniformName); }, 'uniform "' + uniformName + '" not present in program.');
	}
	exports.getProgramUniformLocationOrThrow = getProgramUniformLocationOrThrow;
	function getProgramUniformLocation(gl, program, uniformName) {
	    return gl.getUniformLocation(program, uniformName);
	}
	exports.getProgramUniformLocation = getProgramUniformLocation;
	function bindTextureToProgramUniformSampler(gl, debug, program, texture, uniformSamplerLocation, textureUnit) {
	    callAndCheck(gl, debug, function () { return bindTextureUnit(gl, debug, texture, textureUnit); });
	    callAndCheck(gl, debug, function () { return gl.uniform1i(uniformSamplerLocation, textureUnit); });
	}
	exports.bindTextureToProgramUniformSampler = bindTextureToProgramUniformSampler;
	function bindCanvasToFramebuffer(gl, debug) {
	    callAndCheck(gl, debug, function () { return gl.bindFramebuffer(gl.FRAMEBUFFER, null); });
	    callAndCheck(gl, debug, function () { return gl.viewport(0, 0, gl.canvas.width, gl.canvas.height); });
	    callAndCheck(gl, debug, function () { return gl.scissor(0, 0, gl.canvas.width, gl.canvas.height); });
	}
	exports.bindCanvasToFramebuffer = bindCanvasToFramebuffer;
	function bindColorTextureToFramebuffer(gl, debug, texture, framebuffer) {
	    callAndCheck(gl, debug, function () { return gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer); });
	    callAndCheck(gl, debug, function () { return gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0); });
	}
	exports.bindColorTextureToFramebuffer = bindColorTextureToFramebuffer;
	function unbindColorTextureFromFramebuffer(gl, debug, framebuffer) {
	    callAndCheck(gl, debug, function () { return gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer); });
	    callAndCheck(gl, debug, function () { return gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, null, 0); });
	}
	exports.unbindColorTextureFromFramebuffer = unbindColorTextureFromFramebuffer;
	function validateFramebuffer(gl) {
	    var status = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
	    if (status !== gl.FRAMEBUFFER_COMPLETE) {
	        throw new Error('Error binding framebuffer: ' + getFramebufferErrorMessage(gl, status));
	    }
	}
	exports.validateFramebuffer = validateFramebuffer;
	function getFramebufferErrorMessage(gl, status) {
	    switch (status) {
	        case gl.FRAMEBUFFER_INCOMPLETE_ATTACHMENT:
	            return 'FRAMEBUFFER_INCOMPLETE_ATTACHMENT';
	        case gl.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:
	            return 'FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT';
	        case gl.FRAMEBUFFER_INCOMPLETE_DIMENSIONS:
	            return 'FRAMEBUFFER_INCOMPLETE_DIMENSIONS';
	        case gl.FRAMEBUFFER_UNSUPPORTED:
	            return 'FRAMEBUFFER_UNSUPPORTED';
	        default:
	            return "unknown error " + status;
	    }
	}
	exports.getFramebufferErrorMessage = getFramebufferErrorMessage;
	function throwIfNull(gl, debug, returnTOrNull, failureMessage) {
	    var tOrNull = callAndCheck(gl, debug, function () { return returnTOrNull(); });
	    if (tOrNull == null) {
	        throw new Error(failureMessage);
	    }
	    return tOrNull;
	}
	function validateTextureUnit(gl, textureUnit) {
	    var maxTextureUnit = gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS - 1;
	    var glTextureUnit = textureUnit + gl.TEXTURE0;
	    if (glTextureUnit < gl.TEXTURE0 || glTextureUnit > maxTextureUnit) {
	        var textureUnitRange = "[gl.TEXTURE0, gl.TEXTURE" + maxTextureUnit + "]";
	        throw new Error("textureUnit must be in " + textureUnitRange + ".");
	    }
	}
	function getBatchDim(shape, dimsToSkip) {
	    if (dimsToSkip === void 0) { dimsToSkip = 2; }
	    return util.sizeFromShape(shape.slice(0, shape.length - dimsToSkip));
	}
	exports.getBatchDim = getBatchDim;
	function getRowsCols(shape) {
	    if (shape.length === 0) {
	        throw Error('Cannot get rows and columns of an empty shape array.');
	    }
	    return [
	        shape.length > 1 ? shape[shape.length - 2] : 1, shape[shape.length - 1]
	    ];
	}
	exports.getRowsCols = getRowsCols;
	function getShapeAs3D(shape) {
	    var shapeAs3D = [1, 1, 1];
	    var isScalar = shape.length === 0 || (shape.length === 1 && shape[0] === 1);
	    if (!isScalar) {
	        shapeAs3D =
	            [getBatchDim(shape)].concat(getRowsCols(shape));
	    }
	    return shapeAs3D;
	}
	exports.getShapeAs3D = getShapeAs3D;
	function getTextureShapeFromLogicalShape(logShape, isPacked) {
	    var _a;
	    if (isPacked === void 0) { isPacked = false; }
	    var maxTexSize = environment_1.env().getNumber('WEBGL_MAX_TEXTURE_SIZE');
	    if (isPacked) {
	        maxTexSize = maxTexSize * 2;
	        // This logic ensures we accurately count the number of packed texels needed
	        // to accommodate the tensor. We can only pack values in the same texel if
	        // they are from adjacent pairs of rows/cols within the same batch. So if a
	        // tensor has 3 rows, we pretend it has 4 rows in order to account for the
	        // fact that the texels containing the third row are half empty.
	        logShape = logShape.map(function (d, i) { return i >= logShape.length - 2 ?
	            util.nearestLargerEven(logShape[i]) :
	            logShape[i]; });
	        // Packed texture height is at least 2 (the channel height of a single
	        // texel).
	        if (logShape.length === 1) {
	            logShape = [2, logShape[0]];
	        }
	    }
	    // If logical shape is 2, we don't squeeze, since we want to match physical.
	    if (logShape.length !== 2) {
	        var squeezeResult = util.squeezeShape(logShape);
	        logShape = squeezeResult.newShape;
	    }
	    var size = util.sizeFromShape(logShape);
	    if (logShape.length <= 1 && size <= maxTexSize) {
	        return [1, size];
	    }
	    else if (logShape.length === 2 && logShape[0] <= maxTexSize &&
	        logShape[1] <= maxTexSize) {
	        return logShape;
	    }
	    else if (logShape.length === 3 && logShape[0] * logShape[1] <= maxTexSize &&
	        logShape[2] <= maxTexSize) {
	        return [logShape[0] * logShape[1], logShape[2]];
	    }
	    else if (logShape.length === 3 && logShape[0] <= maxTexSize &&
	        logShape[1] * logShape[2] <= maxTexSize) {
	        return [logShape[0], logShape[1] * logShape[2]];
	    }
	    else if (logShape.length === 4 &&
	        logShape[0] * logShape[1] * logShape[2] <= maxTexSize &&
	        logShape[3] <= maxTexSize) {
	        return [logShape[0] * logShape[1] * logShape[2], logShape[3]];
	    }
	    else if (logShape.length === 4 && logShape[0] <= maxTexSize &&
	        logShape[1] * logShape[2] * logShape[3] <= maxTexSize) {
	        return [logShape[0], logShape[1] * logShape[2] * logShape[3]];
	    }
	    else {
	        if (isPacked) {
	            // For packed textures size equals the number of channels required to
	            // accommodate the texture data. However in order to squarify such that
	            // inner dimensions stay even, we rewrite size to equal the number of
	            // texels. Then in the return statement we rehydrate the squarified
	            // dimensions to channel units.
	            var batchDim = getBatchDim(logShape);
	            var rows = 2, cols = 2;
	            if (logShape.length) {
	                _a = getRowsCols(logShape), rows = _a[0], cols = _a[1];
	            }
	            size = batchDim * (rows / 2) * (cols / 2);
	            return util.sizeToSquarishShape(size).map(function (d) { return d * 2; });
	        }
	        return util.sizeToSquarishShape(size);
	    }
	}
	exports.getTextureShapeFromLogicalShape = getTextureShapeFromLogicalShape;
	function isEven(n) {
	    return n % 2 === 0;
	}
	/**
	 * This determines whether reshaping a packed texture requires rearranging
	 * the data within the texture, assuming 2x2 packing.
	 */
	function isReshapeFree(shape1, shape2) {
	    shape1 = shape1.slice(-2);
	    shape2 = shape2.slice(-2);
	    if (util.arraysEqual(shape1, shape2)) {
	        return true;
	    }
	    if (!shape1.length || !shape2.length) { // One of the shapes is a scalar.
	        return true;
	    }
	    if (shape1[0] === 0 || shape1[1] === 0 || shape2[0] === 0 ||
	        shape2[1] === 0) {
	        return true;
	    }
	    if (shape1.length !== shape2.length) { // One of the shapes is a vector.
	        var shape1Cols = shape1.slice(-1)[0];
	        var shape2Cols = shape2.slice(-1)[0];
	        if (shape1Cols === shape2Cols) {
	            return true;
	        }
	        if (isEven(shape1Cols) && isEven(shape2Cols) &&
	            (shape1[0] === 1 || shape2[0] === 1)) {
	            return true;
	        }
	    }
	    return shape1[1] === shape2[1] && isEven(shape1[0]) && isEven(shape2[0]);
	}
	exports.isReshapeFree = isReshapeFree;
	// We cache webgl params because the environment gets reset between
	// unit tests and we don't want to constantly query the WebGLContext for
	// MAX_TEXTURE_SIZE.
	var MAX_TEXTURE_SIZE;
	var MAX_TEXTURES_IN_SHADER;
	function getWebGLMaxTextureSize(webGLVersion) {
	    if (MAX_TEXTURE_SIZE == null) {
	        var gl = canvas_util_1.getWebGLContext(webGLVersion);
	        MAX_TEXTURE_SIZE = gl.getParameter(gl.MAX_TEXTURE_SIZE);
	    }
	    return MAX_TEXTURE_SIZE;
	}
	exports.getWebGLMaxTextureSize = getWebGLMaxTextureSize;
	function resetMaxTextureSize() {
	    MAX_TEXTURE_SIZE = null;
	}
	exports.resetMaxTextureSize = resetMaxTextureSize;
	function resetMaxTexturesInShader() {
	    MAX_TEXTURES_IN_SHADER = null;
	}
	exports.resetMaxTexturesInShader = resetMaxTexturesInShader;
	function getMaxTexturesInShader(webGLVersion) {
	    if (MAX_TEXTURES_IN_SHADER == null) {
	        var gl = canvas_util_1.getWebGLContext(webGLVersion);
	        MAX_TEXTURES_IN_SHADER = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
	    }
	    // We cap at 16 to avoid spurious runtime "memory exhausted" error.
	    return Math.min(16, MAX_TEXTURES_IN_SHADER);
	}
	exports.getMaxTexturesInShader = getMaxTexturesInShader;
	function getWebGLDisjointQueryTimerVersion(webGLVersion) {
	    if (webGLVersion === 0) {
	        return 0;
	    }
	    var queryTimerVersion;
	    var gl = canvas_util_1.getWebGLContext(webGLVersion);
	    if (hasExtension(gl, 'EXT_disjoint_timer_query_webgl2') &&
	        webGLVersion === 2) {
	        queryTimerVersion = 2;
	    }
	    else if (hasExtension(gl, 'EXT_disjoint_timer_query')) {
	        queryTimerVersion = 1;
	    }
	    else {
	        queryTimerVersion = 0;
	    }
	    return queryTimerVersion;
	}
	exports.getWebGLDisjointQueryTimerVersion = getWebGLDisjointQueryTimerVersion;
	function hasExtension(gl, extensionName) {
	    var ext = gl.getExtension(extensionName);
	    return ext != null;
	}
	exports.hasExtension = hasExtension;
	function isWebGLVersionEnabled(webGLVersion) {
	    try {
	        var gl = canvas_util_1.getWebGLContext(webGLVersion);
	        if (gl != null) {
	            return true;
	        }
	    }
	    catch (e) {
	        return false;
	    }
	    return false;
	}
	exports.isWebGLVersionEnabled = isWebGLVersionEnabled;
	function isCapableOfRenderingToFloatTexture(webGLVersion) {
	    if (webGLVersion === 0) {
	        return false;
	    }
	    var gl = canvas_util_1.getWebGLContext(webGLVersion);
	    if (webGLVersion === 1) {
	        if (!hasExtension(gl, 'OES_texture_float')) {
	            return false;
	        }
	    }
	    else {
	        if (!hasExtension(gl, 'EXT_color_buffer_float')) {
	            return false;
	        }
	    }
	    var isFrameBufferComplete = createFloatTextureAndBindToFramebuffer(gl);
	    return isFrameBufferComplete;
	}
	exports.isCapableOfRenderingToFloatTexture = isCapableOfRenderingToFloatTexture;
	/**
	 * Check if we can download values from a float/half-float texture.
	 *
	 * Note that for performance reasons we use binding a texture to a framebuffer
	 * as a proxy for ability to download float values later using readPixels. The
	 * texture params of this texture will not match those in readPixels exactly
	 * but if we are unable to bind some kind of float texture to the frameBuffer
	 * then we definitely will not be able to read float values from it.
	 */
	function isDownloadFloatTextureEnabled(webGLVersion) {
	    if (webGLVersion === 0) {
	        return false;
	    }
	    var gl = canvas_util_1.getWebGLContext(webGLVersion);
	    if (webGLVersion === 1) {
	        if (!hasExtension(gl, 'OES_texture_float')) {
	            return false;
	        }
	        if (!hasExtension(gl, 'WEBGL_color_buffer_float')) {
	            return false;
	        }
	    }
	    else {
	        if (hasExtension(gl, 'EXT_color_buffer_float')) {
	            return createFloatTextureAndBindToFramebuffer(gl);
	        }
	        var COLOR_BUFFER_HALF_FLOAT = 'EXT_color_buffer_half_float';
	        if (hasExtension(gl, COLOR_BUFFER_HALF_FLOAT)) {
	            var textureHalfFloatExtension = gl.getExtension(COLOR_BUFFER_HALF_FLOAT);
	            return createHalfFloatTextureAndBindToFramebuffer(gl, textureHalfFloatExtension);
	        }
	        return false;
	    }
	    var isFrameBufferComplete = createFloatTextureAndBindToFramebuffer(gl);
	    return isFrameBufferComplete;
	}
	exports.isDownloadFloatTextureEnabled = isDownloadFloatTextureEnabled;
	function createFloatTextureAndBindToFramebuffer(gl) {
	    var texConfig = tex_util_1.getTextureConfig(gl);
	    var texture = gl.createTexture();
	    gl.bindTexture(gl.TEXTURE_2D, texture);
	    var width = 1;
	    var height = 1;
	    gl.texImage2D(gl.TEXTURE_2D, 0, texConfig.internalFormatFloat, width, height, 0, texConfig.textureFormatFloat, texConfig.textureTypeFloat, null);
	    var frameBuffer = gl.createFramebuffer();
	    gl.bindFramebuffer(gl.FRAMEBUFFER, frameBuffer);
	    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
	    var isFrameBufferComplete = gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE;
	    gl.bindTexture(gl.TEXTURE_2D, null);
	    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
	    gl.deleteTexture(texture);
	    gl.deleteFramebuffer(frameBuffer);
	    return isFrameBufferComplete;
	}
	function createHalfFloatTextureAndBindToFramebuffer(
	// tslint:disable-next-line:no-any
	gl, textureHalfFloatExtension) {
	    var texConfig = tex_util_1.getTextureConfig(gl, textureHalfFloatExtension);
	    var texture = gl.createTexture();
	    gl.bindTexture(gl.TEXTURE_2D, texture);
	    var width = 1;
	    var height = 1;
	    gl.texImage2D(gl.TEXTURE_2D, 0, texConfig.internalFormatHalfFloat, width, height, 0, texConfig.textureFormatFloat, texConfig.textureTypeHalfFloat, null);
	    var frameBuffer = gl.createFramebuffer();
	    gl.bindFramebuffer(gl.FRAMEBUFFER, frameBuffer);
	    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
	    var isFrameBufferComplete = gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE;
	    gl.bindTexture(gl.TEXTURE_2D, null);
	    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
	    gl.deleteTexture(texture);
	    gl.deleteFramebuffer(frameBuffer);
	    return isFrameBufferComplete;
	}
	function isWebGLFenceEnabled(webGLVersion) {
	    if (webGLVersion !== 2) {
	        return false;
	    }
	    var gl = canvas_util_1.getWebGLContext(webGLVersion);
	    // tslint:disable-next-line:no-any
	    var isEnabled = gl.fenceSync != null;
	    return isEnabled;
	}
	exports.isWebGLFenceEnabled = isWebGLFenceEnabled;
	//# sourceMappingURL=webgl_util.js.map

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_1 = __webpack_require__(75);
	var tensor_util_env_1 = __webpack_require__(17);
	var util = __webpack_require__(10);
	/**
	 * Provided `f(x)`, returns another function `g(x, dy?)`, which gives the
	 * gradient of `f(x)` with respect to `x`.
	 *
	 * If `dy` is provided, the gradient of `f(x).mul(dy).sum()` with respect to
	 * `x` is computed instead. `f(x)` must take a single tensor `x` and return a
	 * single tensor `y`. If `f()` takes multiple inputs, use `tf.grads` instead.
	 *
	 * ```js
	 * // f(x) = x ^ 2
	 * const f = x => x.square();
	 * // f'(x) = 2x
	 * const g = tf.grad(f);
	 *
	 * const x = tf.tensor1d([2, 3]);
	 * g(x).print();
	 * ```
	 *
	 * ```js
	 * // f(x) = x ^ 3
	 * const f = x => x.pow(tf.scalar(3, 'int32'));
	 * // f'(x) = 3x ^ 2
	 * const g = tf.grad(f);
	 * // f''(x) = 6x
	 * const gg = tf.grad(g);
	 *
	 * const x = tf.tensor1d([2, 3]);
	 * gg(x).print();
	 * ```
	 *
	 * @param f The function f(x), to compute gradient for.
	 */
	/** @doc {heading: 'Training', subheading: 'Gradients'} */
	function grad(f) {
	    util.assert(util.isFunction(f), function () { return 'The f passed in grad(f) must be a function'; });
	    return function (x, dy) {
	        // x can be of any dtype, thus null as the last argument.
	        var $x = tensor_util_env_1.convertToTensor(x, 'x', 'tf.grad', null);
	        var $dy = (dy != null) ? tensor_util_env_1.convertToTensor(dy, 'dy', 'tf.grad') : null;
	        return engine_1.ENGINE.tidy(function () {
	            var _a = engine_1.ENGINE.gradients(function () { return f($x); }, [$x], $dy), value = _a.value, grads = _a.grads;
	            if ($dy != null) {
	                util.assertShapesMatch(value.shape, $dy.shape, 'The shape of dy passed in grad(f)(x, dy) must match the shape ' +
	                    'returned by f(x)');
	            }
	            checkGrads(grads);
	            return grads[0];
	        });
	    };
	}
	exports.grad = grad;
	/**
	 * Provided `f(x1, x2,...)`, returns another function `g([x1, x2,...], dy?)`,
	 * which gives an array of gradients of `f()` with respect to each input
	 * [`x1`,`x2`,...].
	 *
	 * If `dy` is passed when calling `g()`, the gradient of
	 * `f(x1,...).mul(dy).sum()` with respect to each input is computed instead.
	 * The provided `f` must take one or more tensors and return a single tensor
	 * `y`. If `f()` takes a single input, we recommend using `tf.grad` instead.
	 *
	 * ```js
	 * // f(a, b) = a * b
	 * const f = (a, b) => a.mul(b);
	 * // df / da = b, df / db = a
	 * const g = tf.grads(f);
	 *
	 * const a = tf.tensor1d([2, 3]);
	 * const b = tf.tensor1d([-2, -3]);
	 * const [da, db] = g([a, b]);
	 * console.log('da');
	 * da.print();
	 * console.log('db');
	 * db.print();
	 * ```
	 *
	 * @param f The function `f(x1, x2,...)` to compute gradients for.
	 */
	/** @doc {heading: 'Training', subheading: 'Gradients'} */
	function grads(f) {
	    util.assert(util.isFunction(f), function () { return 'The f passed in grads(f) must be a function'; });
	    return function (args, dy) {
	        util.assert(Array.isArray(args), function () { return 'The args passed in grads(f)(args) must be an array ' +
	            'of `Tensor`s or `TensorLike`s'; });
	        // args can be of any dtype, thus null as the last argument.
	        var $args = tensor_util_env_1.convertToTensorArray(args, 'args', 'tf.grads', null);
	        var $dy = (dy != null) ? tensor_util_env_1.convertToTensor(dy, 'dy', 'tf.grads') : null;
	        return engine_1.ENGINE.tidy(function () {
	            var _a = engine_1.ENGINE.gradients(function () { return f.apply(void 0, $args); }, $args, $dy), value = _a.value, grads = _a.grads;
	            if ($dy != null) {
	                util.assertShapesMatch(value.shape, $dy.shape, 'The shape of dy passed in grads(f)([x1,...], dy) must ' +
	                    'match the shape returned by f([x1,...])');
	            }
	            checkGrads(grads);
	            return grads;
	        });
	    };
	}
	exports.grads = grads;
	/**
	 * Like `tf.grad`, but also returns the value of `f()`. Useful when `f()`
	 * returns a metric you want to show.
	 *
	 * The result is a rich object with the following properties:
	 * - grad: The gradient of `f(x)` w.r.t `x` (result of `tf.grad`).
	 * - value: The value returned by `f(x)`.
	 *
	 * ```js
	 * // f(x) = x ^ 2
	 * const f = x => x.square();
	 * // f'(x) = 2x
	 * const g = tf.valueAndGrad(f);
	 *
	 * const x = tf.tensor1d([2, 3]);
	 * const {value, grad} = g(x);
	 *
	 * console.log('value');
	 * value.print();
	 * console.log('grad');
	 * grad.print();
	 * ```
	 */
	/** @doc {heading: 'Training', subheading: 'Gradients'} */
	function valueAndGrad(f) {
	    util.assert(util.isFunction(f), function () { return 'The f passed in valueAndGrad(f) must be a function'; });
	    return function (x, dy) {
	        util.assert(x instanceof tensor_1.Tensor, function () { return 'The x passed in valueAndGrad(f)(x) must be a tensor'; });
	        util.assert(dy == null || dy instanceof tensor_1.Tensor, function () { return 'The dy passed in valueAndGrad(f)(x, dy) must be a tensor'; });
	        var _a = engine_1.ENGINE.gradients(function () { return f(x); }, [x], dy), grads = _a.grads, value = _a.value;
	        checkGrads(grads);
	        return { grad: grads[0], value: value };
	    };
	}
	exports.valueAndGrad = valueAndGrad;
	/**
	 * Like `tf.grads`, but returns also the value of `f()`. Useful when `f()`
	 * returns a metric you want to show.
	 *
	 * The result is a rich object with the following properties:
	 * - grads: The gradients of `f()` w.r.t each input (result of `tf.grads`).
	 * - value: The value returned by `f(x)`.
	 *
	 * ```js
	 * // f(a, b) = a * b
	 * const f = (a, b) => a.mul(b);
	 * // df/da = b, df/db = a
	 * const g = tf.valueAndGrads(f);
	 *
	 * const a = tf.tensor1d([2, 3]);
	 * const b = tf.tensor1d([-2, -3]);
	 * const {value, grads} = g([a, b]);
	 *
	 * const [da, db] = grads;
	 *
	 * console.log('value');
	 * value.print();
	 *
	 * console.log('da');
	 * da.print();
	 * console.log('db');
	 * db.print();
	 * ```
	 */
	/** @doc {heading: 'Training', subheading: 'Gradients'} */
	function valueAndGrads(f) {
	    util.assert(util.isFunction(f), function () { return 'The f passed in valueAndGrads(f) must be a function'; });
	    return function (args, dy) {
	        util.assert(Array.isArray(args) && args.every(function (arg) { return arg instanceof tensor_1.Tensor; }), function () { return 'The args passed in valueAndGrads(f)(args) must be array of ' +
	            'tensors'; });
	        util.assert(dy == null || dy instanceof tensor_1.Tensor, function () { return 'The dy passed in valueAndGrads(f)(args, dy) must be a tensor'; });
	        var res = engine_1.ENGINE.gradients(function () { return f.apply(void 0, args); }, args, dy);
	        if (dy != null) {
	            util.assertShapesMatch(res.value.shape, dy.shape, 'The shape of dy passed in valueAndGrads(f)([x1,...], dy) must ' +
	                'match the shape returned by f([x1,...])');
	        }
	        checkGrads(res.grads);
	        return res;
	    };
	}
	exports.valueAndGrads = valueAndGrads;
	/**
	 * Computes and returns the gradient of f(x) with respect to the list of
	 * trainable variables provided by `varList`. If no list is provided, it
	 * defaults to all trainable variables.
	 *
	 * ```js
	 * const a = tf.variable(tf.tensor1d([3, 4]));
	 * const b = tf.variable(tf.tensor1d([5, 6]));
	 * const x = tf.tensor1d([1, 2]);
	 *
	 * // f(a, b) = a * x ^ 2 + b * x
	 * const f = () => a.mul(x.square()).add(b.mul(x)).sum();
	 * // df/da = x ^ 2, df/db = x
	 * const {value, grads} = tf.variableGrads(f);
	 *
	 * Object.keys(grads).forEach(varName => grads[varName].print());
	 * ```
	 *
	 * @param f The function to execute. f() should return a scalar.
	 * @param varList The list of variables to compute the gradients with respect
	 *     to. Defaults to all trainable variables.
	 * @returns An object with the following keys and values:
	 *   - `value`: The value of the function `f`.
	 *   - `grads`: A map from the names of the variables to the gradients.
	 *     If the `varList` argument is provided explicitly and contains a subset of
	 *     non-trainable variables, this map in the return value will contain keys
	 *     that map the names of the non-trainable variables to `null`.
	 */
	/** @doc {heading: 'Training', subheading: 'Gradients'} */
	function variableGrads(f, varList) {
	    util.assert(util.isFunction(f), function () { return 'The f passed in variableGrads(f) must be a function'; });
	    util.assert(varList == null ||
	        Array.isArray(varList) && varList.every(function (v) { return v instanceof tensor_1.Variable; }), function () {
	        return 'The varList passed in variableGrads(f, varList) must be an array ' +
	            'of variables';
	    });
	    var specifiedVarList = varList != null;
	    if (!specifiedVarList) {
	        // Get all of the trainable variables.
	        varList = [];
	        for (var varName in engine_1.ENGINE.registeredVariables) {
	            varList.push(engine_1.ENGINE.registeredVariables[varName]);
	        }
	    }
	    var specifiedNonTrainable = specifiedVarList ? varList.filter(function (variable) { return !variable.trainable; }) : null;
	    // Prune non-trainable variables.
	    var originalVarCount = varList.length;
	    varList = varList.filter(function (variable) { return variable.trainable; });
	    util.assert(varList.length > 0, function () { return "variableGrads() expects at least one of the input variables to " +
	        ("be trainable, but none of the " + originalVarCount + " variables is ") +
	        "trainable."; });
	    var allowNoGradients = true;
	    var _a = engine_1.ENGINE.gradients(f, varList, null, allowNoGradients), value = _a.value, grads = _a.grads;
	    util.assert(grads.some(function (g) { return g != null; }), function () { return 'Cannot find a connection between any variable and the result of ' +
	        'the loss function y=f(x). Please make sure the operations that ' +
	        'use variables are inside the function f passed to minimize().'; });
	    util.assert(value.rank === 0, function () { return "The f passed in variableGrads(f) must return a scalar, but it " +
	        ("returned a rank-" + value.rank + " tensor"); });
	    var namedGrads = {};
	    varList.forEach(function (v, i) {
	        if (grads[i] != null) {
	            namedGrads[v.name] = grads[i];
	        }
	    });
	    if (specifiedNonTrainable != null) {
	        // If varList is explicitly provided and contains non-trainable values,
	        // add them to the returned gradients with `null` values.
	        specifiedNonTrainable.forEach(function (v) { return namedGrads[v.name] = null; });
	    }
	    return { value: value, grads: namedGrads };
	}
	exports.variableGrads = variableGrads;
	/**
	 * Overrides the gradient computation of a function `f`.
	 *
	 * Takes a function
	 * `f(...inputs, save) => {value: Tensor, gradFunc: (dy, saved) => Tensor[]}`
	 * and returns another function `g(...inputs)` which takes the same inputs as
	 * `f`. When called, `g` returns `f().value`. In backward mode, custom gradients
	 * with respect to each input of `f` are computed using `f().gradFunc`.
	 *
	 * The `save` function passsed to `f` should be used for saving tensors needed
	 * in the gradient. And the `saved` passed to the `gradFunc` is a
	 * `NamedTensorMap`, which contains those saved tensor.
	 *
	 * ```js
	 * const customOp = tf.customGrad((x, save) => {
	 *   // Save x to make sure it's available later for the gradient.
	 *   save([x]);
	 *   // Override gradient of our custom x ^ 2 op to be dy * abs(x);
	 *   return {
	 *     value: x.square(),
	 *     // Note `saved.x` which points to the `x` we saved earlier.
	 *     gradFunc: (dy, saved) => [dy.mul(saved[0].abs())]
	 *   };
	 * });
	 *
	 * const x = tf.tensor1d([-1, -2, 3]);
	 * const dx = tf.grad(x => customOp(x));
	 *
	 * console.log(`f(x):`);
	 * customOp(x).print();
	 * console.log(`f'(x):`);
	 * dx(x).print();
	 * ```
	 *
	 * @param f The function to evaluate in forward mode, which should return
	 *     `{value: Tensor, gradFunc: (dy, saved) => Tensor[]}`, where `gradFunc`
	 *     returns the custom gradients of `f` with respect to its inputs.
	 */
	/** @doc {heading: 'Training', subheading: 'Gradients'} */
	function customGrad(f) {
	    return engine_1.ENGINE.customGrad(f);
	}
	exports.customGrad = customGrad;
	function checkGrads(grads) {
	    var numNullGradients = grads.filter(function (g) { return g == null; }).length;
	    if (numNullGradients > 0) {
	        throw new Error("Cannot compute gradient of y=f(x) with respect to x. Make sure that\n    the f you passed encloses all operations that lead from x to y.");
	    }
	}
	//# sourceMappingURL=gradients.js.map

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var engine_1 = __webpack_require__(15);
	var tensor_util_env_1 = __webpack_require__(17);
	var util = __webpack_require__(10);
	var operation_1 = __webpack_require__(18);
	/**
	 * Converts two real numbers to a complex number.
	 *
	 * Given a tensor `real` representing the real part of a complex number, and a
	 * tensor `imag` representing the imaginary part of a complex number, this
	 * operation returns complex numbers elementwise of the form [r0, i0, r1, i1],
	 * where r represents the real part and i represents the imag part.
	 *
	 * The input tensors real and imag must have the same shape.
	 *
	 * ```js
	 * const real = tf.tensor1d([2.25, 3.25]);
	 * const imag = tf.tensor1d([4.75, 5.75]);
	 * const complex = tf.complex(real, imag);
	 *
	 * complex.print();
	 * ```
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function complex_(real, imag) {
	    var $real = tensor_util_env_1.convertToTensor(real, 'real', 'complex');
	    var $imag = tensor_util_env_1.convertToTensor(imag, 'imag', 'complex');
	    util.assertShapesMatch($real.shape, $imag.shape, "real and imag shapes, " + $real.shape + " and " + $imag.shape + ", " +
	        "must match in call to tf.complex().");
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.complex($real, $imag); }, { $real: $real, $imag: $imag });
	}
	/**
	 * Returns the real part of a complex (or real) tensor.
	 *
	 * Given a tensor input, this operation returns a tensor of type float that is
	 * the real part of each element in input considered as a complex number.
	 *
	 * If the input is real, it simply makes a clone.
	 *
	 * ```js
	 * const x = tf.complex([-2.25, 3.25], [4.75, 5.75]);
	 * tf.real(x).print();
	 * ```
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function real_(input) {
	    var $input = tensor_util_env_1.convertToTensor(input, 'input', 'real');
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.real($input); }, { $input: $input });
	}
	/**
	 * Returns the imaginary part of a complex (or real) tensor.
	 *
	 * Given a tensor input, this operation returns a tensor of type float that is
	 * the imaginary part of each element in input considered as a complex number.
	 * If input is real, a tensor of all zeros is returned.
	 *
	 * ```js
	 * const x = tf.complex([-2.25, 3.25], [4.75, 5.75]);
	 * tf.imag(x).print();
	 * ```
	 */
	/** @doc {heading: 'Tensors', subheading: 'Creation'} */
	function imag_(input) {
	    var $input = tensor_util_env_1.convertToTensor(input, 'input', 'imag');
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.imag($input); }, { $input: $input });
	}
	exports.complex = operation_1.op({ complex_: complex_ });
	exports.real = operation_1.op({ real_: real_ });
	exports.imag = operation_1.op({ imag_: imag_ });
	//# sourceMappingURL=complex_ops.js.map

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util = __webpack_require__(10);
	function assertParamsValid(input, begin, size) {
	    util.assert(input.rank === begin.length, function () { return "Error in slice" + input.rank + "D: Length of begin " + begin + " must " +
	        ("match the rank of the array (" + input.rank + ")."); });
	    util.assert(input.rank === size.length, function () { return "Error in slice" + input.rank + "D: Length of size " + size + " must " +
	        ("match the rank of the array (" + input.rank + ")."); });
	    var _loop_1 = function (i) {
	        util.assert(begin[i] + size[i] <= input.shape[i], function () { return "Error in slice" + input.rank + "D: begin[" + i + "] + size[" + i + "] " +
	            ("(" + (begin[i] + size[i]) + ") would overflow input.shape[" + i + "] (" + input.shape[i] + ")"); });
	    };
	    for (var i = 0; i < input.rank; ++i) {
	        _loop_1(i);
	    }
	}
	exports.assertParamsValid = assertParamsValid;
	/** Converts a binary mask to an array of axes. Used in stridedSlice(). */
	function maskToAxes(mask) {
	    var axes = [];
	    var axis = 0;
	    while (mask > 0) {
	        if (mask & 1) {
	            axes.push(axis);
	        }
	        mask /= 2;
	        axis++;
	    }
	    return axes;
	}
	exports.maskToAxes = maskToAxes;
	/** Computes the output shape given the strided slice params. */
	function computeOutShape(begin, end, strides) {
	    var size = [];
	    for (var axis = 0; axis < begin.length; axis++) {
	        size[axis] = Math.ceil((end[axis] - begin[axis]) / strides[axis]);
	    }
	    return size;
	}
	exports.computeOutShape = computeOutShape;
	function startForAxis(beginMask, startIndices, strides, inputShape, axis) {
	    // Begin with the specified index
	    var start = startIndices[axis];
	    var stride = strides[axis] || 1;
	    // Check the axis bit from right of beginMask or the begin index is not set
	    // for the axis.
	    if (beginMask & 1 << axis || start == null) {
	        if (stride > 0) {
	            // Forward iteration - use the first element. These values will get
	            // clamped below (Note: We could have set them to 0 and axis_size-1, but
	            // use lowest() and max() to maintain symmetry with StopForAxis())
	            start = Number.MIN_SAFE_INTEGER;
	        }
	        else {
	            // Backward iteration - use the last element.
	            start = Number.MAX_SAFE_INTEGER;
	        }
	    }
	    // Handle negative indices
	    var axisSize = inputShape[axis];
	    if (start < 0) {
	        start += axisSize;
	    }
	    // Clamping
	    start = util.clamp(0, start, axisSize - 1);
	    return start;
	}
	exports.startForAxis = startForAxis;
	function stopForAxis(endMask, stopIndices, strides, inputShape, axis) {
	    // Begin with the specified index
	    var stop = stopIndices[axis];
	    var stride = strides[axis] || 1;
	    // Check the axis bit from right of endMask or if the stop index is not set
	    // for this axis.
	    if (endMask & (1 << axis) || stop == null) {
	        if (stride > 0) {
	            // Forward iteration - use the last element. These values will get
	            // clamped below
	            stop = Number.MAX_SAFE_INTEGER;
	        }
	        else {
	            // Backward iteration - use the first element.
	            stop = Number.MIN_SAFE_INTEGER;
	        }
	    }
	    // Handle negative indices
	    var axisSize = inputShape[axis];
	    if (stop < 0) {
	        stop += axisSize;
	    }
	    // Clamping
	    // Because the end index points one past the last element, we need slightly
	    // different clamping ranges depending on the direction.
	    if (stride > 0) {
	        // Forward iteration
	        stop = util.clamp(0, stop, axisSize);
	    }
	    else {
	        // Backward iteration
	        stop = util.clamp(-1, stop, axisSize - 1);
	    }
	    return stop;
	}
	exports.stopForAxis = stopForAxis;
	/**
	 * Returns true if the slice occupies a continous set of elements in the
	 * 'flat' space.
	 */
	function isSliceContinous(shape, begin, size) {
	    // Index of the first axis that has size > 1.
	    var firstNonOneAxis = size.length;
	    for (var i = 0; i < size.length; i++) {
	        if (size[i] > 1) {
	            firstNonOneAxis = i;
	            break;
	        }
	    }
	    for (var i = firstNonOneAxis + 1; i < size.length; i++) {
	        if (begin[i] > 0 || size[i] !== shape[i]) {
	            return false;
	        }
	    }
	    return true;
	}
	exports.isSliceContinous = isSliceContinous;
	function computeFlatOffset(begin, strides) {
	    var flatOffset = begin.length > 0 ? begin[begin.length - 1] : 1;
	    for (var i = 0; i < begin.length - 1; i++) {
	        flatOffset += begin[i] * strides[i];
	    }
	    return flatOffset;
	}
	exports.computeFlatOffset = computeFlatOffset;
	//# sourceMappingURL=slice_util.js.map

/***/ },
/* 193 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Rank;
	(function (Rank) {
	    Rank["R0"] = "R0";
	    Rank["R1"] = "R1";
	    Rank["R2"] = "R2";
	    Rank["R3"] = "R3";
	    Rank["R4"] = "R4";
	    Rank["R5"] = "R5";
	    Rank["R6"] = "R6";
	})(Rank = exports.Rank || (exports.Rank = {}));
	// Looks for upcasting types. Used, for example, in operations with mixed dtype
	// inputs.
	var UpcastInt32AndMap;
	(function (UpcastInt32AndMap) {
	    UpcastInt32AndMap["float32"] = "float32";
	    UpcastInt32AndMap["int32"] = "int32";
	    UpcastInt32AndMap["bool"] = "int32";
	    UpcastInt32AndMap["complex64"] = "complex64";
	})(UpcastInt32AndMap || (UpcastInt32AndMap = {}));
	var UpcastBoolAndMap;
	(function (UpcastBoolAndMap) {
	    UpcastBoolAndMap["float32"] = "float32";
	    UpcastBoolAndMap["int32"] = "int32";
	    UpcastBoolAndMap["bool"] = "bool";
	    UpcastBoolAndMap["complex64"] = "complex64";
	})(UpcastBoolAndMap || (UpcastBoolAndMap = {}));
	var UpcastFloat32AndMap;
	(function (UpcastFloat32AndMap) {
	    UpcastFloat32AndMap["float32"] = "float32";
	    UpcastFloat32AndMap["int32"] = "float32";
	    UpcastFloat32AndMap["bool"] = "float32";
	    UpcastFloat32AndMap["complex64"] = "complex64";
	})(UpcastFloat32AndMap || (UpcastFloat32AndMap = {}));
	var UpcastComplex64AndMap;
	(function (UpcastComplex64AndMap) {
	    UpcastComplex64AndMap["float32"] = "complex64";
	    UpcastComplex64AndMap["int32"] = "complex64";
	    UpcastComplex64AndMap["bool"] = "complex64";
	    UpcastComplex64AndMap["complex64"] = "complex64";
	})(UpcastComplex64AndMap || (UpcastComplex64AndMap = {}));
	var upcastTypeMap = {
	    'float32': UpcastFloat32AndMap,
	    'int32': UpcastInt32AndMap,
	    'bool': UpcastBoolAndMap,
	    'complex64': UpcastComplex64AndMap
	};
	function upcastType(typeA, typeB) {
	    if (typeA === 'string' || typeB === 'string') {
	        if (typeA === 'string' && typeB === 'string') {
	            return 'string';
	        }
	        throw new Error("Can not upcast " + typeA + " with " + typeB);
	    }
	    return upcastTypeMap[typeA][typeB];
	}
	exports.upcastType = upcastType;
	/** Returns the output type after summation. */
	function sumOutType(type) {
	    return upcastType(type, 'int32');
	}
	exports.sumOutType = sumOutType;
	//# sourceMappingURL=types.js.map

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _superagent = __webpack_require__(304);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _reduxForm = __webpack_require__(16);
	
	var _SelectField = __webpack_require__(121);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AttributeOptions = function (_Component) {
	    _inherits(AttributeOptions, _Component);
	
	    function AttributeOptions(props) {
	        _classCallCheck(this, AttributeOptions);
	
	        var _this = _possibleConstructorReturn(this, (AttributeOptions.__proto__ || Object.getPrototypeOf(AttributeOptions)).call(this, props));
	
	        _this.state = { attribute_options: _this.props.attributeOptions };
	        _this.renderHandledSelectField = _this.renderHandledSelectField.bind(_this);
	        return _this;
	    }
	
	    _createClass(AttributeOptions, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            _superagent2.default.get(ROOT_URL + '/attribute_options/' + this.props.attributeName).end(function (error, response) {
	                if (!error && response) {
	                    _this2.setState({ attribute_options: response.body.attribute_options });
	                } else {
	                    console.log('There was an error fetching from API', error);
	                }
	            });
	        }
	    }, {
	        key: 'renderHandledSelectField',
	        value: function renderHandledSelectField(props) {
	            var _this3 = this;
	
	            var customOnChange = props.input.onChange;
	            if (this.props.onChange) {
	                customOnChange = function customOnChange(event) {
	                    _this3.props.onChange(event.target.value);
	                    props.input.onChange(event);
	                };
	            }
	            var field_props = Object.assign({}, props, { input: Object.assign({}, props.input, { onChange: customOnChange }) });
	            return _react2.default.createElement(_SelectField2.default, field_props);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_reduxForm.Field, {
	                className: 'form-control',
	                name: this.props.name,
	                component: this.renderHandledSelectField,
	                options: this.props.attributeOptions,
	                defaultValue: this.props.defaultValue,
	                label: this.props.label,
	                type: 'select'
	            });
	        }
	    }]);
	
	    return AttributeOptions;
	}(_react.Component);
	
	exports.default = AttributeOptions;

/***/ },
/* 195 */
[2084, 1220],
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(1230);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(1229);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 197 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 198 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 199 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 200 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 201 */
[2134, 1277, 521],
/* 202 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 203 */
197,
/* 204 */
158,
/* 205 */
159,
/* 206 */
[2109, 113, 540, 547, 123],
/* 207 */
[2125, 356, 354],
/* 208 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	var $defineProperty = Object.defineProperty || false;
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = false;
		}
	}
	
	module.exports = $defineProperty;


/***/ },
/* 209 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = Object;


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(34);
	var Dimensions = /** @class */ (function () {
	    function Dimensions(width, height) {
	        if (!utils_1.isValidNumber(width) || !utils_1.isValidNumber(height)) {
	            throw new Error("Dimensions.constructor - expected width and height to be valid numbers, instead have " + JSON.stringify({ width: width, height: height }));
	        }
	        this._width = width;
	        this._height = height;
	    }
	    Object.defineProperty(Dimensions.prototype, "width", {
	        get: function () { return this._width; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Dimensions.prototype, "height", {
	        get: function () { return this._height; },
	        enumerable: true,
	        configurable: true
	    });
	    Dimensions.prototype.reverse = function () {
	        return new Dimensions(1 / this.width, 1 / this.height);
	    };
	    return Dimensions;
	}());
	exports.Dimensions = Dimensions;
	//# sourceMappingURL=Dimensions.js.map

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var FaceDetection_1 = __webpack_require__(97);
	var FaceLandmarks_1 = __webpack_require__(166);
	var WithFaceDetection_1 = __webpack_require__(167);
	function isWithFaceLandmarks(obj) {
	    return WithFaceDetection_1.isWithFaceDetection(obj)
	        && obj['landmarks'] instanceof FaceLandmarks_1.FaceLandmarks
	        && obj['unshiftedLandmarks'] instanceof FaceLandmarks_1.FaceLandmarks
	        && obj['alignedRect'] instanceof FaceDetection_1.FaceDetection;
	}
	exports.isWithFaceLandmarks = isWithFaceLandmarks;
	function extendWithFaceLandmarks(sourceObj, unshiftedLandmarks) {
	    var shift = sourceObj.detection.box;
	    var landmarks = unshiftedLandmarks.shiftBy(shift.x, shift.y);
	    var rect = landmarks.align();
	    var imageDims = sourceObj.detection.imageDims;
	    var alignedRect = new FaceDetection_1.FaceDetection(sourceObj.detection.score, rect.rescale(imageDims.reverse()), imageDims);
	    var extension = {
	        landmarks: landmarks,
	        unshiftedLandmarks: unshiftedLandmarks,
	        alignedRect: alignedRect
	    };
	    return Object.assign({}, sourceObj, extension);
	}
	exports.extendWithFaceLandmarks = extendWithFaceLandmarks;
	//# sourceMappingURL=WithFaceLandmarks.js.map

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var TinyYolov2_1 = __webpack_require__(1499);
	exports.TinyYolov2 = TinyYolov2_1.TinyYolov2;
	tslib_1.__exportStar(__webpack_require__(626), exports);
	tslib_1.__exportStar(__webpack_require__(627), exports);
	function createTinyYolov2(weights, withSeparableConvs) {
	    if (withSeparableConvs === void 0) { withSeparableConvs = true; }
	    var net = new TinyYolov2_1.TinyYolov2(withSeparableConvs);
	    net.extractWeights(weights);
	    return net;
	}
	exports.createTinyYolov2 = createTinyYolov2;
	//# sourceMappingURL=index.js.map

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(1521);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(215);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(172),
	    isObjectLike = __webpack_require__(173);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 216 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./isNaN')} */
	module.exports = Number.isNaN || function isNaN(a) {
		return a !== a;
	};


/***/ },
/* 217 */
[2138, 1663, 1665],
/* 218 */,
/* 219 */,
/* 220 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	module.exports = typeof window !== 'undefined' && window.Math === Math ? window : typeof global !== 'undefined' && global.Math === Math ? global : typeof self !== 'undefined' && self.Math === Math ? self : {};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(156);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(56);
	
	var _SafeAnchor = __webpack_require__(103);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  block: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  componentClass: _elementType2['default'],
	  href: _propTypes2['default'].string,
	  /**
	   * Defines HTML button type attribute
	   * @defaultValue 'button'
	   */
	  type: _propTypes2['default'].oneOf(['button', 'reset', 'submit'])
	};
	
	var defaultProps = {
	  active: false,
	  block: false,
	  disabled: false
	};
	
	var Button = function (_React$Component) {
	  (0, _inherits3['default'])(Button, _React$Component);
	
	  function Button() {
	    (0, _classCallCheck3['default'])(this, Button);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
	    return _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, elementProps.disabled && 'disabled')
	    }));
	  };
	
	  Button.prototype.renderButton = function renderButton(_ref, className) {
	    var componentClass = _ref.componentClass,
	        elementProps = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass']);
	
	    var Component = componentClass || 'button';
	
	    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, elementProps, {
	      type: elementProps.type || 'button',
	      className: className
	    }));
	  };
	
	  Button.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        active = _props.active,
	        block = _props.block,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'block', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
	    var fullClassName = (0, _classnames2['default'])(className, classes);
	
	    if (elementProps.href) {
	      return this.renderAnchor(elementProps, fullClassName);
	    }
	
	    return this.renderButton(elementProps, fullClassName);
	  };
	
	  return Button;
	}(_react2['default'].Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));
	module.exports = exports['default'];

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var CloseButton = function () {
	  function CloseButton(props) {
	    return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
	      fillRule: "evenodd",
	      d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z"
	    }));
	  }
	
	  return CloseButton;
	}();
	
	CloseButton.defaultProps = {
	  focusable: "false",
	  viewBox: "0 0 12 12"
	};
	var _default = CloseButton;
	exports["default"] = _default;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _propTypes["default"].oneOf([_constants.INFO_POSITION_TOP, _constants.INFO_POSITION_BOTTOM, _constants.INFO_POSITION_BEFORE, _constants.INFO_POSITION_AFTER]);
	
	exports["default"] = _default;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf([_constants.START_DATE, _constants.END_DATE])]);
	
	exports["default"] = _default;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isBeforeDay;
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function isBeforeDay(a, b) {
	  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
	  var aYear = a.year();
	  var aMonth = a.month();
	  var bYear = b.year();
	  var bMonth = b.month();
	  var isSameYear = aYear === bYear;
	  var isSameMonth = aMonth === bMonth;
	  if (isSameYear && isSameMonth) return a.date() < b.date();
	  if (isSameYear) return aMonth < bMonth;
	  return aYear < bYear;
	}

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var EventPluginRegistry = __webpack_require__(440);
	var EventPluginUtils = __webpack_require__(441);
	var ReactErrorUtils = __webpack_require__(445);
	
	var accumulateInto = __webpack_require__(889);
	var forEachAccumulated = __webpack_require__(890);
	var invariant = __webpack_require__(20);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(226);
	var EventPluginUtils = __webpack_require__(441);
	
	var accumulateInto = __webpack_require__(889);
	var forEachAccumulated = __webpack_require__(890);
	var warning = __webpack_require__(25);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 228 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(116);
	
	var getEventTarget = __webpack_require__(450);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(163);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(3);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = _propTypes.elementType;
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ },
/* 232 */
23,
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(937);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(2016);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(2015);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(2014);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(936);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(938);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_ops_1 = __webpack_require__(31);
	var util_1 = __webpack_require__(10);
	// Utilities needed by backend consumers of tf-core.
	__export(__webpack_require__(108));
	__export(__webpack_require__(57));
	__export(__webpack_require__(153));
	__export(__webpack_require__(238));
	__export(__webpack_require__(316));
	var types_1 = __webpack_require__(193);
	exports.upcastType = types_1.upcastType;
	function castTensor(x, dtype, backend) {
	    if (dtype === 'complex64') {
	        if (x.dtype === 'complex64') {
	            return x.clone();
	        }
	        var zerosTensor = tensor_ops_1.zeros(x.shape);
	        var floatX = x.toFloat();
	        var result = backend.complex(floatX, zerosTensor);
	        zerosTensor.dispose();
	        floatX.dispose();
	        return result;
	    }
	    if (!util_1.hasEncodingLoss(x.dtype, dtype)) {
	        // We don't change the underlying data, since we cast to higher
	        // precision.
	        return engine_1.ENGINE.makeTensorFromDataId(x.dataId, x.shape, dtype);
	    }
	    if (x.dtype === 'complex64') {
	        var real = backend.real(x);
	        var result = real.cast(dtype);
	        real.dispose();
	        return result;
	    }
	    if (dtype === 'int32') {
	        return backend.int(x);
	    }
	    else if (dtype === 'bool') {
	        var zero = tensor_ops_1.scalar(0, x.dtype);
	        var result = backend.notEqual(x, zero);
	        zero.dispose();
	        return result;
	    }
	    else {
	        throw new Error("Error in Cast: failed to cast " + x.dtype + " to " + dtype);
	    }
	}
	exports.castTensor = castTensor;
	function reshapeTensor(x, shape) {
	    return engine_1.ENGINE.makeTensorFromDataId(x.dataId, shape, x.dtype);
	}
	exports.reshapeTensor = reshapeTensor;
	function linspaceImpl(start, stop, num) {
	    var step = (stop - start) / (num - 1);
	    var values = util_1.makeZerosTypedArray(num, 'float32');
	    values[0] = start;
	    for (var i = 1; i < values.length; i++) {
	        values[i] = values[i - 1] + step;
	    }
	    return tensor_ops_1.tensor1d(values, 'float32');
	}
	exports.linspaceImpl = linspaceImpl;
	//# sourceMappingURL=backend_util.js.map

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(10);
	function assertNotComplex(tensor, opName) {
	    if (!Array.isArray(tensor)) {
	        tensor = [tensor];
	    }
	    tensor.forEach(function (t) {
	        if (t != null) {
	            util_1.assert(t.dtype !== 'complex64', function () { return opName + " does not support complex64 tensors."; });
	        }
	    });
	}
	exports.assertNotComplex = assertNotComplex;
	//# sourceMappingURL=cpu_util.js.map

/***/ },
/* 236 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var contexts = {};
	var WEBGL_ATTRIBUTES = {
	    alpha: false,
	    antialias: false,
	    premultipliedAlpha: false,
	    preserveDrawingBuffer: false,
	    depth: false,
	    stencil: false,
	    failIfMajorPerformanceCaveat: true
	};
	function setWebGLContext(webGLVersion, gl) {
	    contexts[webGLVersion] = gl;
	}
	exports.setWebGLContext = setWebGLContext;
	function getWebGLContext(webGLVersion) {
	    if (!(webGLVersion in contexts)) {
	        contexts[webGLVersion] = getWebGLRenderingContext(webGLVersion);
	    }
	    var gl = contexts[webGLVersion];
	    if (gl.isContextLost()) {
	        delete contexts[webGLVersion];
	        return getWebGLContext(webGLVersion);
	    }
	    gl.disable(gl.DEPTH_TEST);
	    gl.disable(gl.STENCIL_TEST);
	    gl.disable(gl.BLEND);
	    gl.disable(gl.DITHER);
	    gl.disable(gl.POLYGON_OFFSET_FILL);
	    gl.disable(gl.SAMPLE_COVERAGE);
	    gl.enable(gl.SCISSOR_TEST);
	    gl.enable(gl.CULL_FACE);
	    gl.cullFace(gl.BACK);
	    return contexts[webGLVersion];
	}
	exports.getWebGLContext = getWebGLContext;
	function createCanvas(webGLVersion) {
	    if (typeof OffscreenCanvas !== 'undefined' && webGLVersion === 2) {
	        return new OffscreenCanvas(300, 150);
	    }
	    else if (typeof document !== 'undefined') {
	        return document.createElement('canvas');
	    }
	    else {
	        throw new Error('Cannot create a canvas in this context');
	    }
	}
	function getWebGLRenderingContext(webGLVersion) {
	    if (webGLVersion !== 1 && webGLVersion !== 2) {
	        throw new Error('Cannot get WebGL rendering context, WebGL is disabled.');
	    }
	    var canvas = createCanvas(webGLVersion);
	    canvas.addEventListener('webglcontextlost', function (ev) {
	        ev.preventDefault();
	        delete contexts[webGLVersion];
	    }, false);
	    if (webGLVersion === 1) {
	        return (canvas.getContext('webgl', WEBGL_ATTRIBUTES) ||
	            canvas.getContext('experimental-webgl', WEBGL_ATTRIBUTES));
	    }
	    return canvas.getContext('webgl2', WEBGL_ATTRIBUTES);
	}
	//# sourceMappingURL=canvas_util.js.map

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_util_env_1 = __webpack_require__(17);
	var util_1 = __webpack_require__(10);
	var util_2 = __webpack_require__(10);
	var concat_util_1 = __webpack_require__(153);
	var operation_1 = __webpack_require__(18);
	var tensor_ops_1 = __webpack_require__(31);
	/**
	 * Concatenates a list of`tf.Tensor1D`s along an axis. See `concat` for details.
	 *
	 * For example, if:
	 * A: shape(3) = |r1, g1, b1|
	 * B: shape(2) = |r2, g2|
	 * C = tf.concat1d([A, B]) == |r1, g1, b1, r2, g2|
	 *
	 * @param tensors A list of`tf.Tensor`s to concatenate.
	 * @return The concatenated array.
	 */
	function concat1d_(tensors) {
	    return exports.concat(tensors, 0 /* axis */);
	}
	/**
	 * Concatenates a list of`tf.Tensor2D`s along an axis. See `concat` for details.
	 *
	 * For example, if:
	 * A: shape(2, 3) = | r1, g1, b1 |
	 *                  | r2, g2, b2 |
	 *
	 * B: shape(2, 3) = | r3, g3, b3 |
	 *                  | r4, g4, b4 |
	 *
	 * C = tf.concat2d([A, B], axis)
	 *
	 * if axis = 0:
	 * C: shape(4, 3) = | r1, g1, b1 |
	 *                  | r2, g2, b2 |
	 *                  | r3, g3, b3 |
	 *                  | r4, g4, b4 |
	 *
	 * if axis = 1:
	 * C = shape(2, 6) = | r1, g1, b1, r3, g3, b3 |
	 *                   | r2, g2, b2, r4, g4, b4 |
	 *
	 *
	 * @param tensors A list of `tf.Tensor`s to concatenate.
	 * @param axis The axis to concatenate along.
	 * @return The concatenated array.
	 */
	function concat2d_(tensors, axis) {
	    return exports.concat(tensors, axis);
	}
	/**
	 * Concatenates a list of `tf.Tensor3D`s along an axis.
	 * See `concat` for details.
	 *
	 * For example, if:
	 * A: shape(2, 1, 3) = | r1, g1, b1 |
	 *                     | r2, g2, b2 |
	 *
	 * B: shape(2, 1, 3) = | r3, g3, b3 |
	 *                     | r4, g4, b4 |
	 *
	 * C = tf.concat3d([A, B], axis)
	 *
	 * if axis = 0:
	 * C: shape(4, 1, 3) = | r1, g1, b1 |
	 *                     | r2, g2, b2 |
	 *                     | r3, g3, b3 |
	 *                     | r4, g4, b4 |
	 *
	 * if axis = 1:
	 * C: shape(2, 2, 3) = | r1, g1, b1, r3, g3, b3 |
	 *                     | r2, g2, b2, r4, g4, b4 |
	 *
	 * if axis = 2:
	 * C = shape(2, 1, 6) = | r1, g1, b1, r3, g3, b3 |
	 *                      | r2, g2, b2, r4, g4, b4 |
	 *
	 * @param tensors A list of`tf.Tensor`s to concatenate.
	 * @param axis The axis to concate along.
	 * @return The concatenated array.
	 */
	function concat3d_(tensors, axis) {
	    return exports.concat(tensors, axis);
	}
	/**
	 * Concatenates a list of `tf.Tensor4D`s along an axis.
	 * See `concat` for details.
	 *
	 * @param tensors A list of `tf.Tensor`s to concatenate.
	 * @param axis The axis to concate along.
	 * @return The concatenated array.
	 */
	function concat4d_(tensors, axis) {
	    return exports.concat(tensors, axis);
	}
	/**
	 * Concatenates a list of `tf.Tensor`s along a given axis.
	 *
	 * The tensors ranks and types must match, and their sizes must match in all
	 * dimensions except `axis`.
	 *
	 * Also available are stricter rank-specific methods that assert that
	 * `tensors` are of the given rank:
	 *   - `tf.concat1d`
	 *   - `tf.concat2d`
	 *   - `tf.concat3d`
	 *   - `tf.concat4d`
	 *
	 * Except `tf.concat1d` (which does not have axis param), all methods have
	 * same signature as this method.
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 2]);
	 * const b = tf.tensor1d([3, 4]);
	 * a.concat(b).print();  // or a.concat(b)
	 * ```
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 2]);
	 * const b = tf.tensor1d([3, 4]);
	 * const c = tf.tensor1d([5, 6]);
	 * tf.concat([a, b, c]).print();
	 * ```
	 *
	 * ```js
	 * const a = tf.tensor2d([[1, 2], [10, 20]]);
	 * const b = tf.tensor2d([[3, 4], [30, 40]]);
	 * const axis = 1;
	 * tf.concat([a, b], axis).print();
	 * ```
	 * @param tensors A list of tensors to concatenate.
	 * @param axis The axis to concate along. Defaults to 0 (the first dim).
	 */
	/** @doc {heading: 'Tensors', subheading: 'Slicing and Joining'} */
	function concat_(tensors, axis) {
	    if (axis === void 0) { axis = 0; }
	    util_1.assert(tensors.length >= 1, function () { return 'Pass at least one tensor to concat'; });
	    var $tensors = tensor_util_env_1.convertToTensorArray(tensors, 'tensors', 'concat');
	    if ($tensors[0].dtype === 'complex64') {
	        $tensors.forEach(function (tensor) {
	            if (tensor.dtype !== 'complex64') {
	                throw new Error("Cannot concatenate complex64 tensors with a tensor\n          with dtype " + tensor.dtype + ". ");
	            }
	        });
	    }
	    axis = util_2.parseAxisParam(axis, $tensors[0].shape)[0];
	    var outShape = concat_util_1.computeOutShape($tensors.map(function (t) { return t.shape; }), axis);
	    if (util_1.sizeFromShape(outShape) === 0) {
	        return tensor_ops_1.tensor([], outShape);
	    }
	    // Keep only non-empty tensors (ignore tensors with 0 in their shape).
	    $tensors = $tensors.filter(function (t) { return t.size > 0; });
	    if ($tensors.length === 1) {
	        return $tensors[0];
	    }
	    var shapes = $tensors.map(function (t) { return t.shape; });
	    concat_util_1.assertParamsConsistent(shapes, axis);
	    var der = function (dy) {
	        var sizeSplits = shapes.map(function (s) { return s[axis]; });
	        var derTensors = exports.split(dy, sizeSplits, axis);
	        return derTensors.map(function (t) { return function () { return t; }; });
	    };
	    var inputs = $tensors;
	    var attr = { axis: axis };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.concat($tensors, axis); }, inputs, der, 'Concat', attr);
	}
	/**
	 * Splits a `tf.Tensor` into sub tensors.
	 *
	 * If `numOrSizeSplits` is a number, splits `x` along dimension `axis`
	 * into `numOrSizeSplits` smaller tensors.
	 * Requires that `numOrSizeSplits` evenly divides `x.shape[axis]`.
	 *
	 * If `numOrSizeSplits` is a number array, splits `x` into
	 * `numOrSizeSplits.length` pieces. The shape of the `i`-th piece has the
	 * same size as `x` except along dimension `axis` where the size is
	 * `numOrSizeSplits[i]`.
	 *
	 * ```js
	 * const x = tf.tensor2d([1, 2, 3, 4, 5, 6, 7, 8], [2, 4]);
	 * const [a, b] = tf.split(x, 2, 1);
	 * a.print();
	 * b.print();
	 *
	 * const [c, d, e] = tf.split(x, [1, 2, 1], 1);
	 * c.print();
	 * d.print();
	 * e.print();
	 * ```
	 *
	 * @param x The input tensor to split.
	 * @param numOrSizeSplits Either an integer indicating the number of
	 * splits along the axis or an array of integers containing the sizes of
	 * each output tensor along the axis. If a number then it must evenly divide
	 * `x.shape[axis]`; otherwise the sum of sizes must match `x.shape[axis]`.
	 * @param axis The dimension along which to split. Defaults to 0 (the first
	 * dim).
	 */
	/** @doc {heading: 'Tensors', subheading: 'Slicing and Joining'} */
	function split_(x, numOrSizeSplits, axis) {
	    if (axis === void 0) { axis = 0; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'split');
	    axis = util_2.parseAxisParam(axis, $x.shape)[0];
	    var splitSizes;
	    if (typeof (numOrSizeSplits) === 'number') {
	        util_1.assert($x.shape[axis] % numOrSizeSplits === 0, function () { return 'Number of splits must evenly divide the axis.'; });
	        splitSizes =
	            new Array(numOrSizeSplits).fill($x.shape[axis] / numOrSizeSplits);
	    }
	    else {
	        util_1.assert($x.shape[axis] === numOrSizeSplits.reduce(function (a, b) { return a + b; }), function () { return 'The sum of sizes must match the size of the axis dimension.'; });
	        splitSizes = numOrSizeSplits;
	    }
	    var der = function (dy) { return ({ $x: function () { return exports.concat(dy, axis); } }); };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.split($x, splitSizes, axis); }, { $x: $x }, der);
	}
	exports.concat = operation_1.op({ concat_: concat_ });
	exports.concat1d = operation_1.op({ concat1d_: concat1d_ });
	exports.concat2d = operation_1.op({ concat2d_: concat2d_ });
	exports.concat3d = operation_1.op({ concat3d_: concat3d_ });
	exports.concat4d = operation_1.op({ concat4d_: concat4d_ });
	exports.split = operation_1.op({ split_: split_ });
	//# sourceMappingURL=concat_split.js.map

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util = __webpack_require__(10);
	function computePool2DInfo(inShape, filterSize, strides, dilations, pad, roundingMode, dataFormat) {
	    if (dataFormat === void 0) { dataFormat = 'channelsLast'; }
	    var _a = parseTupleParam(filterSize), filterHeight = _a[0], filterWidth = _a[1];
	    var filterShape;
	    if (dataFormat === 'channelsLast') {
	        filterShape = [filterHeight, filterWidth, inShape[3], inShape[3]];
	    }
	    else if (dataFormat === 'channelsFirst') {
	        filterShape = [filterHeight, filterWidth, inShape[1], inShape[1]];
	    }
	    else {
	        throw new Error("Unknown dataFormat " + dataFormat);
	    }
	    return computeConv2DInfo(inShape, filterShape, strides, dilations, pad, roundingMode, false, dataFormat);
	}
	exports.computePool2DInfo = computePool2DInfo;
	/**
	 * Computes the information for a forward pass of a pooling3D operation.
	 */
	function computePool3DInfo(inShape, filterSize, strides, dilations, pad, roundingMode, dataFormat) {
	    if (dataFormat === void 0) { dataFormat = 'NDHWC'; }
	    var _a = parse3TupleParam(filterSize), filterDepth = _a[0], filterHeight = _a[1], filterWidth = _a[2];
	    var filterShape;
	    var $dataFormat;
	    if (dataFormat === 'NDHWC') {
	        $dataFormat = 'channelsLast';
	        filterShape =
	            [filterDepth, filterHeight, filterWidth, inShape[4], inShape[4]];
	    }
	    else if (dataFormat === 'NCDHW') {
	        $dataFormat = 'channelsFirst';
	        filterShape =
	            [filterDepth, filterHeight, filterWidth, inShape[1], inShape[1]];
	    }
	    else {
	        throw new Error("Unknown dataFormat " + dataFormat);
	    }
	    return computeConv3DInfo(inShape, filterShape, strides, dilations, pad, false, $dataFormat, roundingMode);
	}
	exports.computePool3DInfo = computePool3DInfo;
	/**
	 * Computes the information for a forward pass of a convolution/pooling
	 * operation.
	 */
	function computeConv2DInfo(inShape, filterShape, strides, dilations, pad, roundingMode, depthwise, dataFormat) {
	    if (depthwise === void 0) { depthwise = false; }
	    if (dataFormat === void 0) { dataFormat = 'channelsLast'; }
	    var _a = [-1, -1, -1, -1], batchSize = _a[0], inHeight = _a[1], inWidth = _a[2], inChannels = _a[3];
	    if (dataFormat === 'channelsLast') {
	        batchSize = inShape[0], inHeight = inShape[1], inWidth = inShape[2], inChannels = inShape[3];
	    }
	    else if (dataFormat === 'channelsFirst') {
	        batchSize = inShape[0], inChannels = inShape[1], inHeight = inShape[2], inWidth = inShape[3];
	    }
	    else {
	        throw new Error("Unknown dataFormat " + dataFormat);
	    }
	    var filterHeight = filterShape[0], filterWidth = filterShape[1], filterChannels = filterShape[3];
	    var _b = parseTupleParam(strides), strideHeight = _b[0], strideWidth = _b[1];
	    var _c = parseTupleParam(dilations), dilationHeight = _c[0], dilationWidth = _c[1];
	    var effectiveFilterHeight = getEffectiveFilterSize(filterHeight, dilationHeight);
	    var effectiveFilterWidth = getEffectiveFilterSize(filterWidth, dilationWidth);
	    var _d = getPadAndOutInfo(pad, inHeight, inWidth, strideHeight, strideWidth, effectiveFilterHeight, effectiveFilterWidth, roundingMode), padInfo = _d.padInfo, outHeight = _d.outHeight, outWidth = _d.outWidth;
	    var outChannels = depthwise ? filterChannels * inChannels : filterChannels;
	    var outShape;
	    if (dataFormat === 'channelsFirst') {
	        outShape = [batchSize, outChannels, outHeight, outWidth];
	    }
	    else if (dataFormat === 'channelsLast') {
	        outShape = [batchSize, outHeight, outWidth, outChannels];
	    }
	    return {
	        batchSize: batchSize,
	        dataFormat: dataFormat,
	        inHeight: inHeight,
	        inWidth: inWidth,
	        inChannels: inChannels,
	        outHeight: outHeight,
	        outWidth: outWidth,
	        outChannels: outChannels,
	        padInfo: padInfo,
	        strideHeight: strideHeight,
	        strideWidth: strideWidth,
	        filterHeight: filterHeight,
	        filterWidth: filterWidth,
	        effectiveFilterHeight: effectiveFilterHeight,
	        effectiveFilterWidth: effectiveFilterWidth,
	        dilationHeight: dilationHeight,
	        dilationWidth: dilationWidth,
	        inShape: inShape,
	        outShape: outShape,
	        filterShape: filterShape
	    };
	}
	exports.computeConv2DInfo = computeConv2DInfo;
	/**
	 * Computes the information for a forward pass of a 3D convolution/pooling
	 * operation.
	 */
	function computeConv3DInfo(inShape, filterShape, strides, dilations, pad, depthwise, dataFormat, roundingMode) {
	    if (depthwise === void 0) { depthwise = false; }
	    if (dataFormat === void 0) { dataFormat = 'channelsLast'; }
	    var _a = [-1, -1, -1, -1, -1], batchSize = _a[0], inDepth = _a[1], inHeight = _a[2], inWidth = _a[3], inChannels = _a[4];
	    if (dataFormat === 'channelsLast') {
	        batchSize = inShape[0], inDepth = inShape[1], inHeight = inShape[2], inWidth = inShape[3], inChannels = inShape[4];
	    }
	    else if (dataFormat === 'channelsFirst') {
	        batchSize = inShape[0], inChannels = inShape[1], inDepth = inShape[2], inHeight = inShape[3], inWidth = inShape[4];
	    }
	    else {
	        throw new Error("Unknown dataFormat " + dataFormat);
	    }
	    var filterDepth = filterShape[0], filterHeight = filterShape[1], filterWidth = filterShape[2], filterChannels = filterShape[4];
	    var _b = parse3TupleParam(strides), strideDepth = _b[0], strideHeight = _b[1], strideWidth = _b[2];
	    var _c = parse3TupleParam(dilations), dilationDepth = _c[0], dilationHeight = _c[1], dilationWidth = _c[2];
	    var effectiveFilterDepth = getEffectiveFilterSize(filterDepth, dilationDepth);
	    var effectiveFilterHeight = getEffectiveFilterSize(filterHeight, dilationHeight);
	    var effectiveFilterWidth = getEffectiveFilterSize(filterWidth, dilationWidth);
	    var _d = get3DPadAndOutInfo(pad, inDepth, inHeight, inWidth, strideDepth, strideHeight, strideWidth, effectiveFilterDepth, effectiveFilterHeight, effectiveFilterWidth, roundingMode), padInfo = _d.padInfo, outDepth = _d.outDepth, outHeight = _d.outHeight, outWidth = _d.outWidth;
	    var outChannels = depthwise ? filterChannels * inChannels : filterChannels;
	    var outShape;
	    if (dataFormat === 'channelsFirst') {
	        outShape = [batchSize, outChannels, outDepth, outHeight, outWidth];
	    }
	    else if (dataFormat === 'channelsLast') {
	        outShape = [batchSize, outDepth, outHeight, outWidth, outChannels];
	    }
	    return {
	        batchSize: batchSize,
	        dataFormat: dataFormat,
	        inDepth: inDepth,
	        inHeight: inHeight,
	        inWidth: inWidth,
	        inChannels: inChannels,
	        outDepth: outDepth,
	        outHeight: outHeight,
	        outWidth: outWidth,
	        outChannels: outChannels,
	        padInfo: padInfo,
	        strideDepth: strideDepth,
	        strideHeight: strideHeight,
	        strideWidth: strideWidth,
	        filterDepth: filterDepth,
	        filterHeight: filterHeight,
	        filterWidth: filterWidth,
	        effectiveFilterDepth: effectiveFilterDepth,
	        effectiveFilterHeight: effectiveFilterHeight,
	        effectiveFilterWidth: effectiveFilterWidth,
	        dilationDepth: dilationDepth,
	        dilationHeight: dilationHeight,
	        dilationWidth: dilationWidth,
	        inShape: inShape,
	        outShape: outShape,
	        filterShape: filterShape
	    };
	}
	exports.computeConv3DInfo = computeConv3DInfo;
	function computeOutputShape2D(inShape, fieldSize, stride, zeroPad, roundingMode) {
	    if (zeroPad == null) {
	        zeroPad = computeDefaultPad(inShape, fieldSize, stride);
	    }
	    var inputRows = inShape[0];
	    var inputCols = inShape[1];
	    var outputRows = conditionalRound((inputRows - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
	    util.assert(util.isInt(outputRows), function () { return "The output # of rows (" + outputRows + ") must be an integer. " +
	        "Change the stride and/or zero pad parameters"; });
	    var outputCols = conditionalRound((inputCols - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
	    util.assert(util.isInt(outputCols), function () { return "The output # of columns (" + outputCols + ") must be an integer. " +
	        "Change the stride and/or zero pad parameters"; });
	    return [outputRows, outputCols];
	}
	function computeOutputShape4D(inShape, fieldSize, outChannels, stride, zeroPad, roundingMode) {
	    if (zeroPad == null) {
	        zeroPad = computeDefaultPad(inShape, fieldSize, stride);
	    }
	    var inputDepth = inShape[0];
	    var inputRows = inShape[1];
	    var inputCols = inShape[2];
	    var outputDepths = conditionalRound((inputDepth - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
	    util.assert(util.isInt(outputDepths), function () { return "The output # of depths (" + outputDepths + ") must be an integer. " +
	        "Change the stride and/or zero pad parameters"; });
	    var outputRows = conditionalRound((inputRows - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
	    util.assert(util.isInt(outputRows), function () { return "The output # of rows (" + outputRows + ") must be an integer. " +
	        "Change the stride and/or zero pad parameters"; });
	    var outputCols = conditionalRound((inputCols - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
	    util.assert(util.isInt(outputCols), function () { return "The output # of columns (" + outputCols + ") must be an integer. " +
	        "Change the stride and/or zero pad parameters"; });
	    return [outputDepths, outputRows, outputCols, outChannels];
	}
	function computeDefaultPad(inputShape, fieldSize, stride, dilation) {
	    if (dilation === void 0) { dilation = 1; }
	    var effectiveFieldSize = getEffectiveFilterSize(fieldSize, dilation);
	    return Math.floor((inputShape[0] * (stride - 1) - stride + effectiveFieldSize) / 2);
	}
	exports.computeDefaultPad = computeDefaultPad;
	function parseTupleParam(param) {
	    if (typeof param === 'number') {
	        return [param, param, param];
	    }
	    if (param.length === 2) {
	        return [param[0], param[1], 1];
	    }
	    return param;
	}
	function parse3TupleParam(param) {
	    return typeof param === 'number' ? [param, param, param] : param;
	}
	/* See https://www.tensorflow.org/api_docs/python/tf/nn/atrous_conv2d
	 * Atrous convolution is equivalent to standard convolution with upsampled
	 * filters with effective_filter_height =
	 * filter_height + (filter_height - 1) * (dilation - 1)
	 * and effective_filter_width =
	 * filter_width + (filter_width - 1) * (dilation - 1),
	 * produced by inserting dilation - 1 zeros along consecutive elements across
	 * the filters' spatial dimensions.
	 * When there is a dilation, this converts a filter dimension to the
	 * effective filter dimension, so it can be used in a standard convolution.
	 */
	function getEffectiveFilterSize(filterSize, dilation) {
	    if (dilation <= 1) {
	        return filterSize;
	    }
	    return filterSize + (filterSize - 1) * (dilation - 1);
	}
	function getPadAndOutInfo(pad, inHeight, inWidth, strideHeight, strideWidth, filterHeight, filterWidth, roundingMode) {
	    var padInfo;
	    var outHeight;
	    var outWidth;
	    if (typeof pad === 'number') {
	        var padType = (pad === 0) ? 'VALID' : 'NUMBER';
	        padInfo = { top: pad, bottom: pad, left: pad, right: pad, type: padType };
	        var outShape = computeOutputShape2D([inHeight, inWidth], filterHeight, strideHeight, pad, roundingMode);
	        outHeight = outShape[0];
	        outWidth = outShape[1];
	    }
	    else if (pad === 'same') {
	        outHeight = Math.ceil(inHeight / strideHeight);
	        outWidth = Math.ceil(inWidth / strideWidth);
	        var padAlongHeight = Math.max(0, (outHeight - 1) * strideHeight + filterHeight - inHeight);
	        var padAlongWidth = Math.max(0, (outWidth - 1) * strideWidth + filterWidth - inWidth);
	        var top_1 = Math.floor(padAlongHeight / 2);
	        var bottom = padAlongHeight - top_1;
	        var left = Math.floor(padAlongWidth / 2);
	        var right = padAlongWidth - left;
	        padInfo = { top: top_1, bottom: bottom, left: left, right: right, type: 'SAME' };
	    }
	    else if (pad === 'valid') {
	        padInfo = { top: 0, bottom: 0, left: 0, right: 0, type: 'VALID' };
	        outHeight = Math.ceil((inHeight - filterHeight + 1) / strideHeight);
	        outWidth = Math.ceil((inWidth - filterWidth + 1) / strideWidth);
	    }
	    else {
	        throw Error("Unknown padding parameter: " + pad);
	    }
	    return { padInfo: padInfo, outHeight: outHeight, outWidth: outWidth };
	}
	function get3DPadAndOutInfo(pad, inDepth, inHeight, inWidth, strideDepth, strideHeight, strideWidth, filterDepth, filterHeight, filterWidth, roundingMode) {
	    var padInfo;
	    var outDepth;
	    var outHeight;
	    var outWidth;
	    if (typeof pad === 'number') {
	        var padType = (pad === 0) ? 'VALID' : 'NUMBER';
	        padInfo = {
	            top: pad,
	            bottom: pad,
	            left: pad,
	            right: pad,
	            front: pad,
	            back: pad,
	            type: padType
	        };
	        var outShape = computeOutputShape4D([inDepth, inHeight, inWidth, 1], filterDepth, 1, strideDepth, pad, roundingMode);
	        outDepth = outShape[0];
	        outHeight = outShape[1];
	        outWidth = outShape[2];
	    }
	    else if (pad === 'same') {
	        outDepth = Math.ceil(inDepth / strideDepth);
	        outHeight = Math.ceil(inHeight / strideHeight);
	        outWidth = Math.ceil(inWidth / strideWidth);
	        var padAlongDepth = (outDepth - 1) * strideDepth + filterDepth - inDepth;
	        var padAlongHeight = (outHeight - 1) * strideHeight + filterHeight - inHeight;
	        var padAlongWidth = (outWidth - 1) * strideWidth + filterWidth - inWidth;
	        var front = Math.floor(padAlongDepth / 2);
	        var back = padAlongDepth - front;
	        var top_2 = Math.floor(padAlongHeight / 2);
	        var bottom = padAlongHeight - top_2;
	        var left = Math.floor(padAlongWidth / 2);
	        var right = padAlongWidth - left;
	        padInfo = { top: top_2, bottom: bottom, left: left, right: right, front: front, back: back, type: 'SAME' };
	    }
	    else if (pad === 'valid') {
	        padInfo = {
	            top: 0,
	            bottom: 0,
	            left: 0,
	            right: 0,
	            front: 0,
	            back: 0,
	            type: 'VALID'
	        };
	        outDepth = Math.ceil((inDepth - filterDepth + 1) / strideDepth);
	        outHeight = Math.ceil((inHeight - filterHeight + 1) / strideHeight);
	        outWidth = Math.ceil((inWidth - filterWidth + 1) / strideWidth);
	    }
	    else {
	        throw Error("Unknown padding parameter: " + pad);
	    }
	    return { padInfo: padInfo, outDepth: outDepth, outHeight: outHeight, outWidth: outWidth };
	}
	/**
	 * Rounds a value depending on the rounding mode
	 * @param value
	 * @param roundingMode
	 */
	function conditionalRound(value, roundingMode) {
	    if (!roundingMode) {
	        return value;
	    }
	    switch (roundingMode) {
	        case 'round':
	            // used for Caffe Conv
	            return Math.round(value);
	        case 'ceil':
	            // used for Caffe Pool
	            return Math.ceil(value);
	        case 'floor':
	            return Math.floor(value);
	        default:
	            throw new Error("Unknown roundingMode " + roundingMode);
	    }
	}
	function tupleValuesAreOne(param) {
	    var _a = parseTupleParam(param), dimA = _a[0], dimB = _a[1], dimC = _a[2];
	    return dimA === 1 && dimB === 1 && dimC === 1;
	}
	exports.tupleValuesAreOne = tupleValuesAreOne;
	function eitherStridesOrDilationsAreOne(strides, dilations) {
	    return tupleValuesAreOne(strides) || tupleValuesAreOne(dilations);
	}
	exports.eitherStridesOrDilationsAreOne = eitherStridesOrDilationsAreOne;
	/**
	 * Convert Conv2D dataFormat from 'NHWC'|'NCHW' to
	 *    'channelsLast'|'channelsFirst'
	 * @param dataFormat in 'NHWC'|'NCHW' mode
	 * @return dataFormat in 'channelsLast'|'channelsFirst' mode
	 * @throws unknown dataFormat
	 */
	function convertConv2DDataFormat(dataFormat) {
	    if (dataFormat === 'NHWC') {
	        return 'channelsLast';
	    }
	    else if (dataFormat === 'NCHW') {
	        return 'channelsFirst';
	    }
	    else {
	        throw new Error("Unknown dataFormat " + dataFormat);
	    }
	}
	exports.convertConv2DDataFormat = convertConv2DDataFormat;
	//# sourceMappingURL=conv_util.js.map

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(10);
	/**
	 * Check whether updates.shape = indices.shape[:batchDim] +
	 * shape[sliceDim:]
	 *
	 * @param x The input tensor.
	 */
	function validateUpdateShape(shape, indices, updates) {
	    var sliceDim = (indices.rank > 1) ? indices.shape[indices.rank - 1] : 1;
	    var batchDim = (indices.rank > 1) ? indices.rank - 1 : 1;
	    var shapeError = 'Must have updates.shape = indices.shape[:batchDim] + ' +
	        ("shape[sliceDim:], got updates.shape: " + updates.shape) +
	        (", indices.shape: " + indices.shape + ", shape: " + shape) +
	        (", sliceDim: " + sliceDim + ", and batchDim: " + batchDim + ".");
	    if (updates.rank < batchDim) {
	        throw new Error(shapeError + (" update.rank < " + batchDim + ". "));
	    }
	    if (shape.length < sliceDim + (updates.rank - batchDim)) {
	        throw new Error(shapeError +
	            (" Output shape length < " + (sliceDim + (updates.rank - batchDim))));
	    }
	    if (updates.rank !== batchDim + shape.length - sliceDim) {
	        throw new Error(shapeError + (" update.rank != " + (batchDim + shape.length - sliceDim)));
	    }
	    for (var d = 0; d < batchDim; ++d) {
	        if (updates.shape[d] !== indices.shape[d]) {
	            throw new Error(shapeError +
	                (" updates.shape[" + d + "] (" + updates.shape[d] + ") != indices.shape[" + d + "] (" + indices.shape[d] + ")."));
	        }
	    }
	    for (var d = 0; d < updates.rank - batchDim; ++d) {
	        if (updates.shape[d + batchDim] !== shape[d + sliceDim]) {
	            throw new Error(shapeError +
	                (" updates.shape[" + (d + batchDim) + "] (" + updates.shape[d + batchDim] + ") != shape[" + (d + batchDim) + "] (" + shape[d + batchDim] + ")"));
	        }
	    }
	}
	exports.validateUpdateShape = validateUpdateShape;
	/**
	 * Validate scatter nd inputs.
	 *
	 * @param update The tensor contains the update values.
	 * @param indices The tensor contains the indices for the update values.
	 * @param shape The shape of the output tensor.
	 */
	function validateInput(updates, indices, shape) {
	    if (indices.rank < 1) {
	        throw new Error('tf.scatterND() expects the indices to be rank 1 or higher,' +
	            (" but the rank was " + indices.rank + "."));
	    }
	    if (updates.rank < 1) {
	        throw new Error('tf.scatterND() expects the updates to be rank 1 or higher,' +
	            (" but the rank was " + updates.rank + "."));
	    }
	    if (indices.dtype !== 'int32') {
	        throw new Error("The dtype of 'indices' should be int32, but got dtype: " + indices.dtype);
	    }
	    if (shape.length < 1) {
	        throw new Error("Output rank must be greater or equal to 1, but got shape: " + shape);
	    }
	    if (shape.length === 0) {
	        if (indices.size === 0) {
	            throw new Error("Indices specified for empty output. indices shape: " + indices.shape);
	        }
	        if (updates.size === 0) {
	            throw new Error("Updates specified for empty output. updates shape: " + updates.shape);
	        }
	    }
	    validateUpdateShape(shape, indices, updates);
	}
	exports.validateInput = validateInput;
	/**
	 * Calculate the shape information for the output.
	 *
	 * @param update The tensor contains the update values.
	 * @param indices The tensor contains the indices for the update values.
	 * @param shape The shape of the output tensor.
	 *
	 * @returns ScatterShapeInfo
	 */
	function calculateShapes(updates, indices, shape) {
	    // Calculate the number of dimensions in indices
	    var indicesRank = indices.shape.length;
	    var sliceRank = (indicesRank > 1) ? indices.shape[indicesRank - 1] : 1;
	    // Calculate the number of elements that make up each slice of our updated
	    // tensor. This allows us to work with flattened tensors and copy over whole
	    // slices at a time.
	    var totalNd = shape.length;
	    var sliceSize = 1;
	    for (var i = sliceRank; i < totalNd; ++i) {
	        sliceSize *= shape[i];
	    }
	    var safeSliceDim = (sliceRank < 1) ? 1 : sliceRank;
	    var numUpdates = util_1.sizeFromShape(indices.shape) / safeSliceDim;
	    var strides = util_1.computeStrides(shape.slice(0, sliceRank)).concat([1]);
	    var outputSize = util_1.sizeFromShape(shape);
	    return { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize };
	}
	exports.calculateShapes = calculateShapes;
	//# sourceMappingURL=scatter_nd_util.js.map

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var globals_1 = __webpack_require__(73);
	var ops_1 = __webpack_require__(74);
	var serialization_1 = __webpack_require__(110);
	var optimizer_1 = __webpack_require__(129);
	/** @doclink Optimizer */
	var SGDOptimizer = /** @class */ (function (_super) {
	    __extends(SGDOptimizer, _super);
	    function SGDOptimizer(learningRate) {
	        var _this = _super.call(this) || this;
	        _this.learningRate = learningRate;
	        _this.setLearningRate(learningRate);
	        return _this;
	    }
	    SGDOptimizer.prototype.applyGradients = function (variableGradients) {
	        var _this = this;
	        var varNames = Array.isArray(variableGradients) ?
	            variableGradients.map(function (v) { return v.name; }) :
	            Object.keys(variableGradients);
	        varNames.forEach(function (name, i) {
	            var gradient = Array.isArray(variableGradients) ?
	                variableGradients[i].tensor :
	                variableGradients[name];
	            if (gradient == null) {
	                return;
	            }
	            var value = engine_1.ENGINE.registeredVariables[name];
	            globals_1.tidy(function () {
	                var newValue = _this.c.mul(gradient).add(value);
	                value.assign(newValue);
	            });
	        });
	        this.incrementIterations();
	    };
	    /**
	     * Sets the learning rate of the optimizer.
	     */
	    SGDOptimizer.prototype.setLearningRate = function (learningRate) {
	        this.learningRate = learningRate;
	        if (this.c != null) {
	            this.c.dispose();
	        }
	        this.c = globals_1.keep(ops_1.scalar(-learningRate));
	    };
	    SGDOptimizer.prototype.dispose = function () {
	        this.c.dispose();
	    };
	    SGDOptimizer.prototype.getWeights = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.saveIterations()];
	                    case 1: return [2 /*return*/, [_a.sent()]];
	                }
	            });
	        });
	    };
	    SGDOptimizer.prototype.setWeights = function (weightValues) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.extractIterations(weightValues)];
	                    case 1:
	                        weightValues = _a.sent();
	                        if (weightValues.length !== 0) {
	                            throw new Error('SGD optimizer does not have settable weights.');
	                        }
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    SGDOptimizer.prototype.getConfig = function () {
	        return { 'learningRate': this.learningRate };
	    };
	    /** @nocollapse */
	    SGDOptimizer.fromConfig = function (cls, config) {
	        return new cls(config['learningRate']);
	    };
	    /** @nocollapse */
	    SGDOptimizer.className = 'SGD'; // Note: Name matters for Python compatibility.
	    return SGDOptimizer;
	}(optimizer_1.Optimizer));
	exports.SGDOptimizer = SGDOptimizer;
	serialization_1.registerClass(SGDOptimizer);
	//# sourceMappingURL=sgd_optimizer.js.map

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ReactGA = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(32);
	
	var _reactIntl = __webpack_require__(26);
	
	__webpack_require__(1805);
	
	var _MainContainer = __webpack_require__(1199);
	
	var _MainContainer2 = _interopRequireDefault(_MainContainer);
	
	var _StartContainer = __webpack_require__(1209);
	
	var _StartContainer2 = _interopRequireDefault(_StartContainer);
	
	var _CbuContainer = __webpack_require__(1190);
	
	var _CbuContainer2 = _interopRequireDefault(_CbuContainer);
	
	var _SmsContainer = __webpack_require__(1208);
	
	var _SmsContainer2 = _interopRequireDefault(_SmsContainer);
	
	var _ProductContainer = __webpack_require__(1203);
	
	var _ProductContainer2 = _interopRequireDefault(_ProductContainer);
	
	var _AddressContainer = __webpack_require__(1186);
	
	var _AddressContainer2 = _interopRequireDefault(_AddressContainer);
	
	var _PendingContainer = __webpack_require__(1201);
	
	var _PendingContainer2 = _interopRequireDefault(_PendingContainer);
	
	var _JobInfoFormContainer = __webpack_require__(1198);
	
	var _JobInfoFormContainer2 = _interopRequireDefault(_JobInfoFormContainer);
	
	var _EmailFormContainer = __webpack_require__(1193);
	
	var _EmailFormContainer2 = _interopRequireDefault(_EmailFormContainer);
	
	var _ServiceInfoFormContainer = __webpack_require__(1207);
	
	var _ServiceInfoFormContainer2 = _interopRequireDefault(_ServiceInfoFormContainer);
	
	var _PersonalInfoFormContainer = __webpack_require__(1202);
	
	var _PersonalInfoFormContainer2 = _interopRequireDefault(_PersonalInfoFormContainer);
	
	var _IncomesFormContainer = __webpack_require__(1197);
	
	var _IncomesFormContainer2 = _interopRequireDefault(_IncomesFormContainer);
	
	var _UploadFormContainer = __webpack_require__(1212);
	
	var _UploadFormContainer2 = _interopRequireDefault(_UploadFormContainer);
	
	var _UploadDocumentsContainer = __webpack_require__(1211);
	
	var _UploadDocumentsContainer2 = _interopRequireDefault(_UploadDocumentsContainer);
	
	var _AffidavitContainer = __webpack_require__(1187);
	
	var _AffidavitContainer2 = _interopRequireDefault(_AffidavitContainer);
	
	var _EmailVerificationContainer = __webpack_require__(1195);
	
	var _EmailVerificationContainer2 = _interopRequireDefault(_EmailVerificationContainer);
	
	var _Congratulations = __webpack_require__(1116);
	
	var _Congratulations2 = _interopRequireDefault(_Congratulations);
	
	var _Rejected = __webpack_require__(1151);
	
	var _Rejected2 = _interopRequireDefault(_Rejected);
	
	var _Inspected = __webpack_require__(1138);
	
	var _Inspected2 = _interopRequireDefault(_Inspected);
	
	var _Disapproved = __webpack_require__(1127);
	
	var _Disapproved2 = _interopRequireDefault(_Disapproved);
	
	var _CheckOut = __webpack_require__(1113);
	
	var _CheckOut2 = _interopRequireDefault(_CheckOut);
	
	var _RenaperFaceContainer = __webpack_require__(1205);
	
	var _RenaperFaceContainer2 = _interopRequireDefault(_RenaperFaceContainer);
	
	var _RenaperDniContainer = __webpack_require__(1204);
	
	var _RenaperDniContainer2 = _interopRequireDefault(_RenaperDniContainer);
	
	var _EmailPendingContainer = __webpack_require__(1194);
	
	var _EmailPendingContainer2 = _interopRequireDefault(_EmailPendingContainer);
	
	var _WhatsappButton = __webpack_require__(1184);
	
	var _WhatsappButton2 = _interopRequireDefault(_WhatsappButton);
	
	var _SelfieWithDocumentContainer = __webpack_require__(1206);
	
	var _SelfieWithDocumentContainer2 = _interopRequireDefault(_SelfieWithDocumentContainer);
	
	var _reactHotkeys = __webpack_require__(898);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var moment = __webpack_require__(2);
	
	
	var keyMap = {
	    SHOW_SELLER_CODE: "shift+c"
	};
	
	var ReactGA = __webpack_require__(1893);
	ReactGA.initialize('UA-131391948-1');
	exports.ReactGA = ReactGA;
	
	moment.locale('es');
	
	function logPageView() {
	    var page = window.location.pathname + window.location.search;
	    ReactGA.set({ page: page });
	    ReactGA.pageview(page);
	    window.dataLayer = window.dataLayer || [];
	    window.dataLayer.push({
	        event: 'virtualPageview',
	        page: page
	    });
	}
	
	function formatPhoneNumber(phoneNumber) {
	    var rawPhone = (phoneNumber || '').toString();
	    var digits = rawPhone.replace(/\D/g, '');
	    if (digits.length === 10) {
	        return digits.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
	    }
	    return rawPhone;
	}
	
	var App = function (_Component) {
	    _inherits(App, _Component);
	
	    function App() {
	        _classCallCheck(this, App);
	
	        return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	    }
	
	    _createClass(App, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _reactHotkeys.HotKeys,
	                { keyMap: keyMap },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'App' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content' },
	                        _react2.default.createElement(
	                            _reactRouter.Router,
	                            { history: _reactRouter.browserHistory },
	                            _react2.default.createElement(_reactRouter.Route, { path: '/', component: _MainContainer2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/start', component: _StartContainer2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/email', component: _EmailVerificationContainer2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/incomes', component: _IncomesFormContainer2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/job-info', component: _JobInfoFormContainer2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/add-email', component: _EmailFormContainer2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/personal-info', component: _PersonalInfoFormContainer2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/service-info', component: _ServiceInfoFormContainer2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/uploads', component: _UploadFormContainer2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/upload-documents', component: _UploadDocumentsContainer2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/cbu', component: _CbuContainer2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/renaper-face', component: _RenaperFaceContainer2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/renaper-dni', component: _RenaperDniContainer2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/selfie-with-document', component: _SelfieWithDocumentContainer2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/sms', component: _SmsContainer2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/address', component: _AddressContainer2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/product', component: _ProductContainer2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/pending', component: _PendingContainer2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/email-pending', component: _EmailPendingContainer2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/affidavit', component: _AffidavitContainer2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/checkout', component: _CheckOut2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/congratulations', component: _Congratulations2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/rejected', component: _Rejected2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/inspected', component: _Inspected2.default, onEnter: logPageView }),
	                            _react2.default.createElement(_reactRouter.Route, { path: '/disapproved', component: _Disapproved2.default, onEnter: logPageView })
	                        )
	                    ),
	                    _react2.default.createElement(_WhatsappButton2.default, { number: ("2616362912"), text: 'Hola, tengo una consulta.', gaEvent: 'true', gaCategory: 'CallToAction', gaAction: 'WhatsApp Tapping', gaLabel: formatPhoneNumber(({"NODE_ENV":"production","API_URL":"https://api-dev.montemar.com.ar/0.3","PAGE_TITLE":"Calf Pay - Montemar","PUBLIC_URL":"","PAGE":"montemar-card-calf","REACT_APP_PAGE_TITLE":"Calf Pay - Montemar","REACT_APP_PHONE_NUMBER":"2616362912","REACT_APP_API_URL":"https://api-dev.montemar.com.ar/0.3"}).PHONE_NUMBER) }),
	                    _react2.default.createElement(
	                        'footer',
	                        { className: 'pd-footer' },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'footer-bottom' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'container clearfix' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { id: 'footer-info' },
	                                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                                        id: 'app.footer-info',
	                                        description: 'Datos de la empresa' })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'footer_sign' },
	                                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                                        id: 'app.footer-sign',
	                                        description: 'Datos de la empresa' })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(40);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BasicTemplate(props) {
	    return _react2.default.createElement(
	        _Section2.default,
	        { className: 'intro_form' },
	        _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	                _reactBootstrap.Col,
	                { className: 'text-center', xs: 12, md: 12, lg: 12 },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'header-img' },
	                    _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(61) })
	                )
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Col,
	                { className: 'text-center pd-content-bottom', xs: 10, xsOffset: 1, md: 10, mdOffset: 1, lg: 10, lgOffset: 1 },
	                props.children
	            )
	        )
	    );
	};
	exports.default = BasicTemplate;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(38);
	
	var _CustomCurrencyInput = __webpack_require__(1120);
	
	var _CustomCurrencyInput2 = _interopRequireDefault(_CustomCurrencyInput);
	
	var _FieldInformation = __webpack_require__(329);
	
	var _FieldInformation2 = _interopRequireDefault(_FieldInformation);
	
	var _CustomSwitchInput = __webpack_require__(1126);
	
	var _CustomSwitchInput2 = _interopRequireDefault(_CustomSwitchInput);
	
	var _reactDates = __webpack_require__(1804);
	
	__webpack_require__(569);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var moment = __webpack_require__(2);
	
	
	__webpack_require__(1410);
	
	__webpack_require__(570);
	
	var DynamicLabelInput = function (_Component) {
	  _inherits(DynamicLabelInput, _Component);
	
	  function DynamicLabelInput(props) {
	    _classCallCheck(this, DynamicLabelInput);
	
	    var _this = _possibleConstructorReturn(this, (DynamicLabelInput.__proto__ || Object.getPrototypeOf(DynamicLabelInput)).call(this, props));
	
	    _this.state = { showLabel: false || _this.props.value };
	    _this.onChangeHandler = _this.onChangeHandler.bind(_this);
	    return _this;
	  }
	
	  _createClass(DynamicLabelInput, [{
	    key: 'onChangeHandler',
	    value: function onChangeHandler(event) {
	      var _props = this.props,
	          type = _props.type,
	          onChange = _props.onChange;
	
	      var value = void 0;
	      if (moment.isMoment(event) || this.props.type == 'currency') {
	        value = event;
	      } else {
	        value = event.target.value;
	      }
	      if (!value && type !== 'currency' || value === 'false' && type === 'select' || isNaN(value) && type === 'currency' || type === 'switch') {
	        this.setState({ showLabel: false });
	      } else {
	        this.setState({ showLabel: true });
	      }
	      onChange(event);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          type = _props2.type,
	          showLabel = _props2.showLabel,
	          field_props = _objectWithoutProperties(_props2, ['type', 'showLabel']);
	
	      var label = showLabel && this.state.showLabel && _react2.default.createElement(
	        'div',
	        {
	          className:  true ? ' dynamic-label-text-area' : '' },
	        _react2.default.createElement(
	          'span',
	          null,
	          field_props.placeholder
	        )
	      );
	
	      var input_element = false;
	
	      switch (type) {
	        case 'currency':
	          input_element = _react2.default.createElement(_CustomCurrencyInput2.default, Object.assign({}, field_props, { onChange: this.onChangeHandler, autoComplete: 'sdf' }));
	          break;
	        case 'switch':
	          input_element = _react2.default.createElement(_CustomSwitchInput2.default, Object.assign({}, field_props, { label: field_props.placeholder, onChange: this.onChangeHandler }));
	          break;
	        case 'textarea':
	          var fieldInfo = field_props.fieldInfo;
	
	          input_element = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('textarea', Object.assign({}, field_props, {
	              label: field_props.placeholder,
	              onChange: this.onChangeHandler,
	              style: {
	                display: "inline-block",
	                width: fieldInfo ? "90%" : "100%",
	                marginRight: fieldInfo ? "5px" : "0px"
	              }
	            })),
	            fieldInfo ? _react2.default.createElement(_FieldInformation2.default, { title: fieldInfo.title, info: fieldInfo.info }) : ''
	          );
	          break;
	        case 'select':
	          input_element = _react2.default.createElement(
	            'select',
	            Object.assign({}, field_props, { onChange: this.onChangeHandler, className: field_props.className }),
	            this.props.children
	          );
	          break;
	        case 'calendar':
	          input_element = _react2.default.createElement(_reactDates.SingleDatePicker, {
	            date: field_props.value || null // momentPropTypes.momentObj or null
	            , onDateChange: this.onChangeHandler // PropTypes.func.isRequired
	            , placeholder: field_props.placeholder,
	            focused: field_props.focused // PropTypes.bool
	            , onFocusChange: field_props.onFocusChange // PropTypes.func.isRequired
	            , displayFormat: 'DD/MM/YYYY',
	            id: 'your_unique_id' // PropTypes.string.isRequired,
	            , numberOfMonths: 1,
	            withFullScreenPortal: (0, _utils.minToSize)(576),
	            noBorder: true,
	            readOnly: true,
	            block: true,
	            hideKeyboardShortcutsPanel: true,
	            isOutsideRange: function isOutsideRange(day) {
	              return (0, _reactDates.isInclusivelyAfterDay)(day, moment().add(1, 'days'));
	            },
	            renderMonthElement: this.props.renderMonthElement && function (_ref) {
	              var month = _ref.month,
	                  onMonthSelect = _ref.onMonthSelect,
	                  onYearSelect = _ref.onYearSelect;
	
	              return _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', justifyContent: 'center' } },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'select',
	                    {
	                      value: month.month(),
	                      onChange: function onChange(e) {
	                        onMonthSelect(month, e.target.value);
	                      }
	                    },
	                    moment.monthsShort().map(function (label, value) {
	                      return _react2.default.createElement(
	                        'option',
	                        { value: value },
	                        label
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'select',
	                    {
	                      value: month.year(),
	                      onChange: function onChange(e) {
	                        onYearSelect(month, e.target.value);
	                      }
	                    },
	                    [].concat(_toConsumableArray((0, _utils.range)(moment().year() - 70, moment().year()))).map(function (year) {
	                      return _react2.default.createElement(
	                        'option',
	                        { value: year },
	                        year
	                      );
	                    })
	                  )
	                )
	              );
	            }
	          });
	          break;
	        default:
	          input_element = _react2.default.createElement('input', Object.assign({}, field_props, { type: type, onChange: this.onChangeHandler }));
	          break;
	
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: !this.state.showLabel && "dynamic-label-default" },
	        label,
	        input_element
	      );
	    }
	  }]);
	
	  return DynamicLabelInput;
	}(_react.Component);
	
	exports.default = DynamicLabelInput;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(195);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function LeadInfo(WrappedComponent) {
	
	    return function (_React$Component) {
	        _inherits(_class, _React$Component);
	
	        function _class(props) {
	            _classCallCheck(this, _class);
	
	            var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	            _this.state = {
	                client_name: ''
	            };
	            _this.extractName = _this.extractName.bind(_this);
	            return _this;
	        }
	
	        _createClass(_class, [{
	            key: 'extractName',
	            value: function extractName(name, position) {
	                var words = name.split(' ');
	                var result = void 0;
	                var exceptions = ['del', 'de'];
	
	                if (position === 'start') {
	                    result = words[0];
	                } else if (position === 'end') {
	                    var lastTwoWords = words.slice(-2);
	                    var penultimateWord = lastTwoWords[0];
	                    var lastWord = lastTwoWords[1];
	
	                    if (exceptions.includes(penultimateWord)) {
	                        result = lastWord;
	                    } else {
	                        result = lastTwoWords.join(" ");
	                    }
	                }
	
	                return result;
	            }
	        }, {
	            key: 'componentDidMount',
	            value: function () {
	                var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                    var sanitizedName, formName, apiName, ROOT_URL, config, response;
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                        while (1) {
	                            switch (_context.prev = _context.next) {
	                                case 0:
	                                    _context.prev = 0;
	                                    sanitizedName = localStorage.getItem('sanitizedName');
	
	                                    if (!(sanitizedName === null)) {
	                                        _context.next = 17;
	                                        break;
	                                    }
	
	                                    formName = localStorage.getItem('formName');
	
	                                    if (!formName) {
	                                        _context.next = 8;
	                                        break;
	                                    }
	
	                                    sanitizedName = this.extractName(formName, 'start');
	                                    _context.next = 16;
	                                    break;
	
	                                case 8:
	                                    apiName = void 0;
	                                    ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	                                    config = {
	                                        headers: {
	                                            'Content-Type': 'application/json',
	                                            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                                        }
	                                    };
	                                    _context.next = 13;
	                                    return _axios2.default.get(ROOT_URL + '/leads/details', config);
	
	                                case 13:
	                                    response = _context.sent;
	
	
	                                    apiName = response.data['name'];
	                                    sanitizedName = this.extractName(apiName, 'end');
	
	                                case 16:
	                                    localStorage.setItem('sanitizedName', sanitizedName);
	
	                                case 17:
	                                    this.setState({
	                                        client_name: sanitizedName
	                                    });
	                                    _context.next = 23;
	                                    break;
	
	                                case 20:
	                                    _context.prev = 20;
	                                    _context.t0 = _context['catch'](0);
	
	                                    this.setState({
	                                        client_name: 'Cliente'
	                                    });
	
	                                case 23:
	                                case 'end':
	                                    return _context.stop();
	                            }
	                        }
	                    }, _callee, this, [[0, 20]]);
	                }));
	
	                function componentDidMount() {
	                    return _ref.apply(this, arguments);
	                }
	
	                return componentDidMount;
	            }()
	        }, {
	            key: 'render',
	            value: function render() {
	                return _react2.default.createElement(WrappedComponent, Object.assign({}, this.props, { clientName: this.state.client_name }));
	            }
	        }]);
	
	        return _class;
	    }(_react2.default.Component);
	}
	
	exports.default = LeadInfo;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var LoadField = function LoadField(_ref) {
		var children = _ref.children,
		    props = _objectWithoutProperties(_ref, ["children"]);
	
		return _react2.default.createElement(
			"div",
			props,
			children || _react2.default.createElement("i", { className: "fa fa-circle-o-notch fa-spin fa-lg fa-fw" })
		);
	};
	
	exports.default = LoadField;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RenaperStepErrorMessage = function RenaperStepErrorMessage(props) {
	    return _react2.default.createElement(
	        'p',
	        { className: 'error' },
	        props.message ? props.message : "Algo salió mal. Por favor reintenta el paso nuevamente."
	    );
	};
	
	exports.default = RenaperStepErrorMessage;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(213);
	var $TypeError = __webpack_require__(22);
	
	var $call = __webpack_require__(336);
	var $actualApply = __webpack_require__(514);
	
	/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
	module.exports = function callBindBasic(args) {
		if (args.length < 1 || typeof args[0] !== 'function') {
			throw new $TypeError('a function is required');
		}
		return $actualApply(bind, $call, args);
	};


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var setFunctionLength = __webpack_require__(2028);
	
	var $defineProperty = __webpack_require__(208);
	
	var callBindBasic = __webpack_require__(247);
	var applyBind = __webpack_require__(1233);
	
	module.exports = function callBind(originalFunction) {
		var func = callBindBasic(arguments);
		var adjustedLength = originalFunction.length - (arguments.length - 1);
		return setFunctionLength(
			func,
			1 + (adjustedLength > 0 ? adjustedLength : 0),
			true
		);
	};
	
	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}


/***/ },
/* 249 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	// Adapted from Modernizr
	// https://github.com/Modernizr/Modernizr/blob/acb3f0d9/feature-detects/dom/passiveeventlisteners.js#L26-L37
	function testPassiveEventListeners() {
	  if (!CAN_USE_DOM) {
	    return false;
	  }
	
	  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
	    return false;
	  }
	
	  var supportsPassiveOption = false;
	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      // eslint-disable-next-line getter-return
	      get: function () {
	        function get() {
	          supportsPassiveOption = true;
	        }
	
	        return get;
	      }()
	    });
	    var noop = function noop() {};
	    window.addEventListener('testPassiveEventSupport', noop, opts);
	    window.removeEventListener('testPassiveEventSupport', noop, opts);
	  } catch (e) {
	    // do nothing
	  }
	
	  return supportsPassiveOption;
	}
	
	var memoized = void 0;
	
	function canUsePassiveEventListeners() {
	  if (memoized === undefined) {
	    memoized = testPassiveEventListeners();
	  }
	  return memoized;
	}
	
	function normalizeEventOptions(eventOptions) {
	  if (!eventOptions) {
	    return undefined;
	  }
	
	  if (!canUsePassiveEventListeners()) {
	    // If the browser does not support the passive option, then it is expecting
	    // a boolean for the options argument to specify whether it should use
	    // capture or not. In more modern browsers, this is passed via the `capture`
	    // option, so let's just hoist that value up.
	    return !!eventOptions.capture;
	  }
	
	  return eventOptions;
	}
	
	/* eslint-disable no-bitwise */
	
	/**
	 * Generate a unique key for any set of event options
	 */
	function eventOptionsKey(normalizedEventOptions) {
	  if (!normalizedEventOptions) {
	    return 0;
	  }
	
	  // If the browser does not support passive event listeners, the normalized
	  // event options will be a boolean.
	  if (normalizedEventOptions === true) {
	    return 100;
	  }
	
	  // At this point, the browser supports passive event listeners, so we expect
	  // the event options to be an object with possible properties of capture,
	  // passive, and once.
	  //
	  // We want to consistently return the same value, regardless of the order of
	  // these properties, so let's use binary maths to assign each property to a
	  // bit, and then add those together (with an offset to account for the
	  // booleans at the beginning of this function).
	  var capture = normalizedEventOptions.capture << 0;
	  var passive = normalizedEventOptions.passive << 1;
	  var once = normalizedEventOptions.once << 2;
	  return capture + passive + once;
	}
	
	function ensureCanMutateNextEventHandlers(eventHandlers) {
	  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
	    // eslint-disable-next-line no-param-reassign
	    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
	  }
	}
	
	function TargetEventHandlers(target) {
	  this.target = target;
	  this.events = {};
	}
	
	TargetEventHandlers.prototype.getEventHandlers = function () {
	  function getEventHandlers(eventName, options) {
	    var key = String(eventName) + ' ' + String(eventOptionsKey(options));
	
	    if (!this.events[key]) {
	      this.events[key] = {
	        handlers: [],
	        handleEvent: undefined
	      };
	      this.events[key].nextHandlers = this.events[key].handlers;
	    }
	
	    return this.events[key];
	  }
	
	  return getEventHandlers;
	}();
	
	TargetEventHandlers.prototype.handleEvent = function () {
	  function handleEvent(eventName, options, event) {
	    var eventHandlers = this.getEventHandlers(eventName, options);
	    eventHandlers.handlers = eventHandlers.nextHandlers;
	    eventHandlers.handlers.forEach(function (handler) {
	      if (handler) {
	        // We need to check for presence here because a handler function may
	        // cause later handlers to get removed. This can happen if you for
	        // instance have a waypoint that unmounts another waypoint as part of an
	        // onEnter/onLeave handler.
	        handler(event);
	      }
	    });
	  }
	
	  return handleEvent;
	}();
	
	TargetEventHandlers.prototype.add = function () {
	  function add(eventName, listener, options) {
	    var _this = this;
	
	    // options has already been normalized at this point.
	    var eventHandlers = this.getEventHandlers(eventName, options);
	
	    ensureCanMutateNextEventHandlers(eventHandlers);
	
	    if (eventHandlers.nextHandlers.length === 0) {
	      eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);
	
	      this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
	    }
	
	    eventHandlers.nextHandlers.push(listener);
	
	    var isSubscribed = true;
	    var unsubscribe = function () {
	      function unsubscribe() {
	        if (!isSubscribed) {
	          return;
	        }
	
	        isSubscribed = false;
	
	        ensureCanMutateNextEventHandlers(eventHandlers);
	        var index = eventHandlers.nextHandlers.indexOf(listener);
	        eventHandlers.nextHandlers.splice(index, 1);
	
	        if (eventHandlers.nextHandlers.length === 0) {
	          // All event handlers have been removed, so we want to remove the event
	          // listener from the target node.
	
	          if (_this.target) {
	            // There can be a race condition where the target may no longer exist
	            // when this function is called, e.g. when a React component is
	            // unmounting. Guarding against this prevents the following error:
	            //
	            //   Cannot read property 'removeEventListener' of undefined
	            _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
	          }
	
	          eventHandlers.handleEvent = undefined;
	        }
	      }
	
	      return unsubscribe;
	    }();
	    return unsubscribe;
	  }
	
	  return add;
	}();
	
	var EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';
	
	// eslint-disable-next-line import/prefer-default-export
	function addEventListener(target, eventName, listener, options) {
	  if (!target[EVENT_HANDLERS_KEY]) {
	    // eslint-disable-next-line no-param-reassign
	    target[EVENT_HANDLERS_KEY] = new TargetEventHandlers(target);
	  }
	  var normalizedEventOptions = normalizeEventOptions(options);
	  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
	}
	
	exports.addEventListener = addEventListener;


/***/ },
/* 250 */
202,
/* 251 */
[2118, 112, 131, 64],
/* 252 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1283);
	var global = __webpack_require__(63);
	var hide = __webpack_require__(132);
	var Iterators = __webpack_require__(159);
	var TO_STRING_TAG = __webpack_require__(64)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 254 */
[2093, 134, 1308, 1305, 113, 366, 1327],
/* 255 */
[2114, 1318, 538],
/* 256 */
[2118, 206, 135, 66],
/* 257 */
252,
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(45);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(124));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 259 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(45);
	
	exports.__esModule = true;
	exports.default = style;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(558));
	
	var _hyphenateStyle = _interopRequireDefault(__webpack_require__(1360));
	
	var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(1355));
	
	var _removeStyle = _interopRequireDefault(__webpack_require__(1356));
	
	var _properties = __webpack_require__(557);
	
	var _isTransform = _interopRequireDefault(__webpack_require__(1357));
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	
	    if (!value && value !== 0) {
	      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ": " + transforms + ";";
	  }
	
	  node.style.cssText += ';' + css;
	}
	
	module.exports = exports["default"];

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $TypeError = __webpack_require__(22);
	
	var inspect = __webpack_require__(1668);
	
	var isPropertyKey = __webpack_require__(137);
	
	var isObject = __webpack_require__(95);
	
	// https://262.ecma-international.org/6.0/#sec-get-o-p
	
	module.exports = function Get(O, P) {
		// 7.3.1.1
		if (!isObject(O)) {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
		// 7.3.1.2
		if (!isPropertyKey(P)) {
			throw new $TypeError('Assertion failed: P is not a Property Key, got ' + inspect(P));
		}
		// 7.3.1.3
		return O[P];
	};


/***/ },
/* 262 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./syntax')} */
	module.exports = SyntaxError;


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $TypeError = __webpack_require__(22);
	
	/** @type {import('./RequireObjectCoercible')} */
	module.exports = function RequireObjectCoercible(value) {
		if (value == null) {
			throw new $TypeError((arguments.length > 0 && arguments[1]) || ('Cannot call method on ' + value));
		}
		return value;
	};


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	function fullyConnectedLayer(x, params) {
	    return tf.tidy(function () {
	        return tf.add(tf.matMul(x, params.weights), params.bias);
	    });
	}
	exports.fullyConnectedLayer = fullyConnectedLayer;
	//# sourceMappingURL=fullyConnectedLayer.js.map

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var env_1 = __webpack_require__(55);
	var getContext2dOrThrow_1 = __webpack_require__(139);
	var getMediaDimensions_1 = __webpack_require__(267);
	var isMediaLoaded_1 = __webpack_require__(383);
	function createCanvas(_a) {
	    var width = _a.width, height = _a.height;
	    var createCanvasElement = env_1.env.getEnv().createCanvasElement;
	    var canvas = createCanvasElement();
	    canvas.width = width;
	    canvas.height = height;
	    return canvas;
	}
	exports.createCanvas = createCanvas;
	function createCanvasFromMedia(media, dims) {
	    var ImageData = env_1.env.getEnv().ImageData;
	    if (!(media instanceof ImageData) && !isMediaLoaded_1.isMediaLoaded(media)) {
	        throw new Error('createCanvasFromMedia - media has not finished loading yet');
	    }
	    var _a = dims || getMediaDimensions_1.getMediaDimensions(media), width = _a.width, height = _a.height;
	    var canvas = createCanvas({ width: width, height: height });
	    if (media instanceof ImageData) {
	        getContext2dOrThrow_1.getContext2dOrThrow(canvas).putImageData(media, 0, 0);
	    }
	    else {
	        getContext2dOrThrow_1.getContext2dOrThrow(canvas).drawImage(media, 0, 0, width, height);
	    }
	    return canvas;
	}
	exports.createCanvasFromMedia = createCanvasFromMedia;
	//# sourceMappingURL=createCanvas.js.map

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var env_1 = __webpack_require__(55);
	function fetchOrThrow(url, init) {
	    return tslib_1.__awaiter(this, void 0, void 0, function () {
	        var fetch, res;
	        return tslib_1.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    fetch = env_1.env.getEnv().fetch;
	                    return [4 /*yield*/, fetch(url, init)];
	                case 1:
	                    res = _a.sent();
	                    if (!(res.status < 400)) {
	                        throw new Error("failed to fetch: (" + res.status + ") " + res.statusText + ", from url: " + res.url);
	                    }
	                    return [2 /*return*/, res];
	            }
	        });
	    });
	}
	exports.fetchOrThrow = fetchOrThrow;
	//# sourceMappingURL=fetchOrThrow.js.map

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Dimensions_1 = __webpack_require__(210);
	var env_1 = __webpack_require__(55);
	function getMediaDimensions(input) {
	    var _a = env_1.env.getEnv(), Image = _a.Image, Video = _a.Video;
	    if (input instanceof Image) {
	        return new Dimensions_1.Dimensions(input.naturalWidth, input.naturalHeight);
	    }
	    if (input instanceof Video) {
	        return new Dimensions_1.Dimensions(input.videoWidth, input.videoHeight);
	    }
	    return new Dimensions_1.Dimensions(input.width, input.height);
	}
	exports.getMediaDimensions = getMediaDimensions;
	//# sourceMappingURL=getMediaDimensions.js.map

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var env_1 = __webpack_require__(55);
	function resolveInput(arg) {
	    if (!env_1.env.isNodejs() && typeof arg === 'string') {
	        return document.getElementById(arg);
	    }
	    return arg;
	}
	exports.resolveInput = resolveInput;
	//# sourceMappingURL=resolveInput.js.map

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var WithFaceDescriptor_1 = __webpack_require__(609);
	var ComposableTask_1 = __webpack_require__(168);
	var extractFacesAndComputeResults_1 = __webpack_require__(389);
	var nets_1 = __webpack_require__(169);
	var PredictAgeAndGenderTask_1 = __webpack_require__(270);
	var PredictFaceExpressionsTask_1 = __webpack_require__(271);
	var ComputeFaceDescriptorsTaskBase = /** @class */ (function (_super) {
	    tslib_1.__extends(ComputeFaceDescriptorsTaskBase, _super);
	    function ComputeFaceDescriptorsTaskBase(parentTask, input) {
	        var _this = _super.call(this) || this;
	        _this.parentTask = parentTask;
	        _this.input = input;
	        return _this;
	    }
	    return ComputeFaceDescriptorsTaskBase;
	}(ComposableTask_1.ComposableTask));
	exports.ComputeFaceDescriptorsTaskBase = ComputeFaceDescriptorsTaskBase;
	var ComputeAllFaceDescriptorsTask = /** @class */ (function (_super) {
	    tslib_1.__extends(ComputeAllFaceDescriptorsTask, _super);
	    function ComputeAllFaceDescriptorsTask() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ComputeAllFaceDescriptorsTask.prototype.run = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var parentResults, descriptors;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.parentTask];
	                    case 1:
	                        parentResults = _a.sent();
	                        return [4 /*yield*/, extractFacesAndComputeResults_1.extractAllFacesAndComputeResults(parentResults, this.input, function (faces) { return Promise.all(faces.map(function (face) {
	                                return nets_1.nets.faceRecognitionNet.computeFaceDescriptor(face);
	                            })); }, null, function (parentResult) { return parentResult.landmarks.align(null, { useDlibAlignment: true }); })];
	                    case 2:
	                        descriptors = _a.sent();
	                        return [2 /*return*/, descriptors.map(function (descriptor, i) { return WithFaceDescriptor_1.extendWithFaceDescriptor(parentResults[i], descriptor); })];
	                }
	            });
	        });
	    };
	    ComputeAllFaceDescriptorsTask.prototype.withFaceExpressions = function () {
	        return new PredictFaceExpressionsTask_1.PredictAllFaceExpressionsWithFaceAlignmentTask(this, this.input);
	    };
	    ComputeAllFaceDescriptorsTask.prototype.withAgeAndGender = function () {
	        return new PredictAgeAndGenderTask_1.PredictAllAgeAndGenderWithFaceAlignmentTask(this, this.input);
	    };
	    return ComputeAllFaceDescriptorsTask;
	}(ComputeFaceDescriptorsTaskBase));
	exports.ComputeAllFaceDescriptorsTask = ComputeAllFaceDescriptorsTask;
	var ComputeSingleFaceDescriptorTask = /** @class */ (function (_super) {
	    tslib_1.__extends(ComputeSingleFaceDescriptorTask, _super);
	    function ComputeSingleFaceDescriptorTask() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ComputeSingleFaceDescriptorTask.prototype.run = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var parentResult, descriptor;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.parentTask];
	                    case 1:
	                        parentResult = _a.sent();
	                        if (!parentResult) {
	                            return [2 /*return*/];
	                        }
	                        return [4 /*yield*/, extractFacesAndComputeResults_1.extractSingleFaceAndComputeResult(parentResult, this.input, function (face) { return nets_1.nets.faceRecognitionNet.computeFaceDescriptor(face); }, null, function (parentResult) { return parentResult.landmarks.align(null, { useDlibAlignment: true }); })];
	                    case 2:
	                        descriptor = _a.sent();
	                        return [2 /*return*/, WithFaceDescriptor_1.extendWithFaceDescriptor(parentResult, descriptor)];
	                }
	            });
	        });
	    };
	    ComputeSingleFaceDescriptorTask.prototype.withFaceExpressions = function () {
	        return new PredictFaceExpressionsTask_1.PredictSingleFaceExpressionsWithFaceAlignmentTask(this, this.input);
	    };
	    ComputeSingleFaceDescriptorTask.prototype.withAgeAndGender = function () {
	        return new PredictAgeAndGenderTask_1.PredictSingleAgeAndGenderWithFaceAlignmentTask(this, this.input);
	    };
	    return ComputeSingleFaceDescriptorTask;
	}(ComputeFaceDescriptorsTaskBase));
	exports.ComputeSingleFaceDescriptorTask = ComputeSingleFaceDescriptorTask;
	//# sourceMappingURL=ComputeFaceDescriptorsTasks.js.map

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var WithAge_1 = __webpack_require__(608);
	var WithGender_1 = __webpack_require__(610);
	var ComposableTask_1 = __webpack_require__(168);
	var ComputeFaceDescriptorsTasks_1 = __webpack_require__(269);
	var extractFacesAndComputeResults_1 = __webpack_require__(389);
	var nets_1 = __webpack_require__(169);
	var PredictFaceExpressionsTask_1 = __webpack_require__(271);
	var PredictAgeAndGenderTaskBase = /** @class */ (function (_super) {
	    tslib_1.__extends(PredictAgeAndGenderTaskBase, _super);
	    function PredictAgeAndGenderTaskBase(parentTask, input, extractedFaces) {
	        var _this = _super.call(this) || this;
	        _this.parentTask = parentTask;
	        _this.input = input;
	        _this.extractedFaces = extractedFaces;
	        return _this;
	    }
	    return PredictAgeAndGenderTaskBase;
	}(ComposableTask_1.ComposableTask));
	exports.PredictAgeAndGenderTaskBase = PredictAgeAndGenderTaskBase;
	var PredictAllAgeAndGenderTask = /** @class */ (function (_super) {
	    tslib_1.__extends(PredictAllAgeAndGenderTask, _super);
	    function PredictAllAgeAndGenderTask() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PredictAllAgeAndGenderTask.prototype.run = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var parentResults, ageAndGenderByFace;
	            var _this = this;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.parentTask];
	                    case 1:
	                        parentResults = _a.sent();
	                        return [4 /*yield*/, extractFacesAndComputeResults_1.extractAllFacesAndComputeResults(parentResults, this.input, function (faces) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
	                                return tslib_1.__generator(this, function (_a) {
	                                    switch (_a.label) {
	                                        case 0: return [4 /*yield*/, Promise.all(faces.map(function (face) { return nets_1.nets.ageGenderNet.predictAgeAndGender(face); }))];
	                                        case 1: return [2 /*return*/, _a.sent()];
	                                    }
	                                });
	                            }); }, this.extractedFaces)];
	                    case 2:
	                        ageAndGenderByFace = _a.sent();
	                        return [2 /*return*/, parentResults.map(function (parentResult, i) {
	                                var _a = ageAndGenderByFace[i], age = _a.age, gender = _a.gender, genderProbability = _a.genderProbability;
	                                return WithAge_1.extendWithAge(WithGender_1.extendWithGender(parentResult, gender, genderProbability), age);
	                            })];
	                }
	            });
	        });
	    };
	    PredictAllAgeAndGenderTask.prototype.withFaceExpressions = function () {
	        return new PredictFaceExpressionsTask_1.PredictAllFaceExpressionsTask(this, this.input);
	    };
	    return PredictAllAgeAndGenderTask;
	}(PredictAgeAndGenderTaskBase));
	exports.PredictAllAgeAndGenderTask = PredictAllAgeAndGenderTask;
	var PredictSingleAgeAndGenderTask = /** @class */ (function (_super) {
	    tslib_1.__extends(PredictSingleAgeAndGenderTask, _super);
	    function PredictSingleAgeAndGenderTask() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PredictSingleAgeAndGenderTask.prototype.run = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var parentResult, _a, age, gender, genderProbability;
	            return tslib_1.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0: return [4 /*yield*/, this.parentTask];
	                    case 1:
	                        parentResult = _b.sent();
	                        if (!parentResult) {
	                            return [2 /*return*/];
	                        }
	                        return [4 /*yield*/, extractFacesAndComputeResults_1.extractSingleFaceAndComputeResult(parentResult, this.input, function (face) { return nets_1.nets.ageGenderNet.predictAgeAndGender(face); }, this.extractedFaces)];
	                    case 2:
	                        _a = _b.sent(), age = _a.age, gender = _a.gender, genderProbability = _a.genderProbability;
	                        return [2 /*return*/, WithAge_1.extendWithAge(WithGender_1.extendWithGender(parentResult, gender, genderProbability), age)];
	                }
	            });
	        });
	    };
	    PredictSingleAgeAndGenderTask.prototype.withFaceExpressions = function () {
	        return new PredictFaceExpressionsTask_1.PredictSingleFaceExpressionsTask(this, this.input);
	    };
	    return PredictSingleAgeAndGenderTask;
	}(PredictAgeAndGenderTaskBase));
	exports.PredictSingleAgeAndGenderTask = PredictSingleAgeAndGenderTask;
	var PredictAllAgeAndGenderWithFaceAlignmentTask = /** @class */ (function (_super) {
	    tslib_1.__extends(PredictAllAgeAndGenderWithFaceAlignmentTask, _super);
	    function PredictAllAgeAndGenderWithFaceAlignmentTask() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PredictAllAgeAndGenderWithFaceAlignmentTask.prototype.withFaceExpressions = function () {
	        return new PredictFaceExpressionsTask_1.PredictAllFaceExpressionsWithFaceAlignmentTask(this, this.input);
	    };
	    PredictAllAgeAndGenderWithFaceAlignmentTask.prototype.withFaceDescriptors = function () {
	        return new ComputeFaceDescriptorsTasks_1.ComputeAllFaceDescriptorsTask(this, this.input);
	    };
	    return PredictAllAgeAndGenderWithFaceAlignmentTask;
	}(PredictAllAgeAndGenderTask));
	exports.PredictAllAgeAndGenderWithFaceAlignmentTask = PredictAllAgeAndGenderWithFaceAlignmentTask;
	var PredictSingleAgeAndGenderWithFaceAlignmentTask = /** @class */ (function (_super) {
	    tslib_1.__extends(PredictSingleAgeAndGenderWithFaceAlignmentTask, _super);
	    function PredictSingleAgeAndGenderWithFaceAlignmentTask() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PredictSingleAgeAndGenderWithFaceAlignmentTask.prototype.withFaceExpressions = function () {
	        return new PredictFaceExpressionsTask_1.PredictSingleFaceExpressionsWithFaceAlignmentTask(this, this.input);
	    };
	    PredictSingleAgeAndGenderWithFaceAlignmentTask.prototype.withFaceDescriptor = function () {
	        return new ComputeFaceDescriptorsTasks_1.ComputeSingleFaceDescriptorTask(this, this.input);
	    };
	    return PredictSingleAgeAndGenderWithFaceAlignmentTask;
	}(PredictSingleAgeAndGenderTask));
	exports.PredictSingleAgeAndGenderWithFaceAlignmentTask = PredictSingleAgeAndGenderWithFaceAlignmentTask;
	//# sourceMappingURL=PredictAgeAndGenderTask.js.map

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var WithFaceExpressions_1 = __webpack_require__(388);
	var ComposableTask_1 = __webpack_require__(168);
	var ComputeFaceDescriptorsTasks_1 = __webpack_require__(269);
	var extractFacesAndComputeResults_1 = __webpack_require__(389);
	var nets_1 = __webpack_require__(169);
	var PredictAgeAndGenderTask_1 = __webpack_require__(270);
	var PredictFaceExpressionsTaskBase = /** @class */ (function (_super) {
	    tslib_1.__extends(PredictFaceExpressionsTaskBase, _super);
	    function PredictFaceExpressionsTaskBase(parentTask, input, extractedFaces) {
	        var _this = _super.call(this) || this;
	        _this.parentTask = parentTask;
	        _this.input = input;
	        _this.extractedFaces = extractedFaces;
	        return _this;
	    }
	    return PredictFaceExpressionsTaskBase;
	}(ComposableTask_1.ComposableTask));
	exports.PredictFaceExpressionsTaskBase = PredictFaceExpressionsTaskBase;
	var PredictAllFaceExpressionsTask = /** @class */ (function (_super) {
	    tslib_1.__extends(PredictAllFaceExpressionsTask, _super);
	    function PredictAllFaceExpressionsTask() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PredictAllFaceExpressionsTask.prototype.run = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var parentResults, faceExpressionsByFace;
	            var _this = this;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.parentTask];
	                    case 1:
	                        parentResults = _a.sent();
	                        return [4 /*yield*/, extractFacesAndComputeResults_1.extractAllFacesAndComputeResults(parentResults, this.input, function (faces) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
	                                return tslib_1.__generator(this, function (_a) {
	                                    switch (_a.label) {
	                                        case 0: return [4 /*yield*/, Promise.all(faces.map(function (face) { return nets_1.nets.faceExpressionNet.predictExpressions(face); }))];
	                                        case 1: return [2 /*return*/, _a.sent()];
	                                    }
	                                });
	                            }); }, this.extractedFaces)];
	                    case 2:
	                        faceExpressionsByFace = _a.sent();
	                        return [2 /*return*/, parentResults.map(function (parentResult, i) { return WithFaceExpressions_1.extendWithFaceExpressions(parentResult, faceExpressionsByFace[i]); })];
	                }
	            });
	        });
	    };
	    PredictAllFaceExpressionsTask.prototype.withAgeAndGender = function () {
	        return new PredictAgeAndGenderTask_1.PredictAllAgeAndGenderTask(this, this.input);
	    };
	    return PredictAllFaceExpressionsTask;
	}(PredictFaceExpressionsTaskBase));
	exports.PredictAllFaceExpressionsTask = PredictAllFaceExpressionsTask;
	var PredictSingleFaceExpressionsTask = /** @class */ (function (_super) {
	    tslib_1.__extends(PredictSingleFaceExpressionsTask, _super);
	    function PredictSingleFaceExpressionsTask() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PredictSingleFaceExpressionsTask.prototype.run = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var parentResult, faceExpressions;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.parentTask];
	                    case 1:
	                        parentResult = _a.sent();
	                        if (!parentResult) {
	                            return [2 /*return*/];
	                        }
	                        return [4 /*yield*/, extractFacesAndComputeResults_1.extractSingleFaceAndComputeResult(parentResult, this.input, function (face) { return nets_1.nets.faceExpressionNet.predictExpressions(face); }, this.extractedFaces)];
	                    case 2:
	                        faceExpressions = _a.sent();
	                        return [2 /*return*/, WithFaceExpressions_1.extendWithFaceExpressions(parentResult, faceExpressions)];
	                }
	            });
	        });
	    };
	    PredictSingleFaceExpressionsTask.prototype.withAgeAndGender = function () {
	        return new PredictAgeAndGenderTask_1.PredictSingleAgeAndGenderTask(this, this.input);
	    };
	    return PredictSingleFaceExpressionsTask;
	}(PredictFaceExpressionsTaskBase));
	exports.PredictSingleFaceExpressionsTask = PredictSingleFaceExpressionsTask;
	var PredictAllFaceExpressionsWithFaceAlignmentTask = /** @class */ (function (_super) {
	    tslib_1.__extends(PredictAllFaceExpressionsWithFaceAlignmentTask, _super);
	    function PredictAllFaceExpressionsWithFaceAlignmentTask() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PredictAllFaceExpressionsWithFaceAlignmentTask.prototype.withAgeAndGender = function () {
	        return new PredictAgeAndGenderTask_1.PredictAllAgeAndGenderWithFaceAlignmentTask(this, this.input);
	    };
	    PredictAllFaceExpressionsWithFaceAlignmentTask.prototype.withFaceDescriptors = function () {
	        return new ComputeFaceDescriptorsTasks_1.ComputeAllFaceDescriptorsTask(this, this.input);
	    };
	    return PredictAllFaceExpressionsWithFaceAlignmentTask;
	}(PredictAllFaceExpressionsTask));
	exports.PredictAllFaceExpressionsWithFaceAlignmentTask = PredictAllFaceExpressionsWithFaceAlignmentTask;
	var PredictSingleFaceExpressionsWithFaceAlignmentTask = /** @class */ (function (_super) {
	    tslib_1.__extends(PredictSingleFaceExpressionsWithFaceAlignmentTask, _super);
	    function PredictSingleFaceExpressionsWithFaceAlignmentTask() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PredictSingleFaceExpressionsWithFaceAlignmentTask.prototype.withAgeAndGender = function () {
	        return new PredictAgeAndGenderTask_1.PredictSingleAgeAndGenderWithFaceAlignmentTask(this, this.input);
	    };
	    PredictSingleFaceExpressionsWithFaceAlignmentTask.prototype.withFaceDescriptor = function () {
	        return new ComputeFaceDescriptorsTasks_1.ComputeSingleFaceDescriptorTask(this, this.input);
	    };
	    return PredictSingleFaceExpressionsWithFaceAlignmentTask;
	}(PredictSingleFaceExpressionsTask));
	exports.PredictSingleFaceExpressionsWithFaceAlignmentTask = PredictSingleFaceExpressionsWithFaceAlignmentTask;
	//# sourceMappingURL=PredictFaceExpressionsTask.js.map

/***/ },
/* 272 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var MtcnnOptions = /** @class */ (function () {
	    function MtcnnOptions(_a) {
	        var _b = _a === void 0 ? {} : _a, minFaceSize = _b.minFaceSize, scaleFactor = _b.scaleFactor, maxNumScales = _b.maxNumScales, scoreThresholds = _b.scoreThresholds, scaleSteps = _b.scaleSteps;
	        this._name = 'MtcnnOptions';
	        this._minFaceSize = minFaceSize || 20;
	        this._scaleFactor = scaleFactor || 0.709;
	        this._maxNumScales = maxNumScales || 10;
	        this._scoreThresholds = scoreThresholds || [0.6, 0.7, 0.7];
	        this._scaleSteps = scaleSteps;
	        if (typeof this._minFaceSize !== 'number' || this._minFaceSize < 0) {
	            throw new Error(this._name + " - expected minFaceSize to be a number > 0");
	        }
	        if (typeof this._scaleFactor !== 'number' || this._scaleFactor <= 0 || this._scaleFactor >= 1) {
	            throw new Error(this._name + " - expected scaleFactor to be a number between 0 and 1");
	        }
	        if (typeof this._maxNumScales !== 'number' || this._maxNumScales < 0) {
	            throw new Error(this._name + " - expected maxNumScales to be a number > 0");
	        }
	        if (!Array.isArray(this._scoreThresholds)
	            || this._scoreThresholds.length !== 3
	            || this._scoreThresholds.some(function (th) { return typeof th !== 'number'; })) {
	            throw new Error(this._name + " - expected scoreThresholds to be an array of numbers of length 3");
	        }
	        if (this._scaleSteps
	            && (!Array.isArray(this._scaleSteps) || this._scaleSteps.some(function (th) { return typeof th !== 'number'; }))) {
	            throw new Error(this._name + " - expected scaleSteps to be an array of numbers");
	        }
	    }
	    Object.defineProperty(MtcnnOptions.prototype, "minFaceSize", {
	        get: function () { return this._minFaceSize; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MtcnnOptions.prototype, "scaleFactor", {
	        get: function () { return this._scaleFactor; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MtcnnOptions.prototype, "maxNumScales", {
	        get: function () { return this._maxNumScales; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MtcnnOptions.prototype, "scoreThresholds", {
	        get: function () { return this._scoreThresholds; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MtcnnOptions.prototype, "scaleSteps", {
	        get: function () { return this._scaleSteps; },
	        enumerable: true,
	        configurable: true
	    });
	    return MtcnnOptions;
	}());
	exports.MtcnnOptions = MtcnnOptions;
	//# sourceMappingURL=MtcnnOptions.js.map

/***/ },
/* 273 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var SsdMobilenetv1Options = /** @class */ (function () {
	    function SsdMobilenetv1Options(_a) {
	        var _b = _a === void 0 ? {} : _a, minConfidence = _b.minConfidence, maxResults = _b.maxResults;
	        this._name = 'SsdMobilenetv1Options';
	        this._minConfidence = minConfidence || 0.5;
	        this._maxResults = maxResults || 100;
	        if (typeof this._minConfidence !== 'number' || this._minConfidence <= 0 || this._minConfidence >= 1) {
	            throw new Error(this._name + " - expected minConfidence to be a number between 0 and 1");
	        }
	        if (typeof this._maxResults !== 'number') {
	            throw new Error(this._name + " - expected maxResults to be a number");
	        }
	    }
	    Object.defineProperty(SsdMobilenetv1Options.prototype, "minConfidence", {
	        get: function () { return this._minConfidence; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SsdMobilenetv1Options.prototype, "maxResults", {
	        get: function () { return this._maxResults; },
	        enumerable: true,
	        configurable: true
	    });
	    return SsdMobilenetv1Options;
	}());
	exports.SsdMobilenetv1Options = SsdMobilenetv1Options;
	//# sourceMappingURL=SsdMobilenetv1Options.js.map

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(208);
	
	var hasPropertyDescriptors = function hasPropertyDescriptors() {
		return !!$defineProperty;
	};
	
	hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
		// node v0.6 has a bug where array lengths can be Set but not Defined
		if (!$defineProperty) {
			return null;
		}
		try {
			return $defineProperty([], 'length', { value: 1 }).length !== 1;
		} catch (e) {
			// In Firefox 4-22, defining length on an array throws an exception.
			return true;
		}
	};
	
	module.exports = hasPropertyDescriptors;


/***/ },
/* 275 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },
/* 276 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1616),
	    listCacheDelete = __webpack_require__(1617),
	    listCacheGet = __webpack_require__(1618),
	    listCacheHas = __webpack_require__(1619),
	    listCacheSet = __webpack_require__(1620);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(101);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(414);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1613);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(142);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(644),
	    copyArray = __webpack_require__(1592),
	    isArray = __webpack_require__(102),
	    isSymbol = __webpack_require__(215),
	    stringToPath = __webpack_require__(655),
	    toKey = __webpack_require__(214),
	    toString = __webpack_require__(663);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	}
	
	module.exports = toPath;


/***/ },
/* 283 */
/***/ function(module, exports) {

	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (source.hasOwnProperty(p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);


/***/ },
/* 284 */,
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	module.exports = function isNodeJS() {
	  return (typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && process + '' === '[object process]';
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _activeElement = __webpack_require__(553);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(164);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _keycode = __webpack_require__(407);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(299);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _isRequiredForA11y = __webpack_require__(300);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(305);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ButtonGroup = __webpack_require__(833);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _DropdownMenu = __webpack_require__(1753);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _DropdownToggle = __webpack_require__(835);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _createChainedFunction = __webpack_require__(50);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _PropTypes = __webpack_require__(1800);
	
	var _ValidComponentChildren = __webpack_require__(71);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TOGGLE_ROLE = _DropdownToggle2['default'].defaultProps.bsRole;
	var MENU_ROLE = _DropdownMenu2['default'].defaultProps.bsRole;
	
	var propTypes = {
	  /**
	   * The menu will open above the dropdown button, instead of below it.
	   */
	  dropup: _propTypes2['default'].bool,
	
	  /**
	   * An html id attribute, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  componentClass: _elementType2['default'],
	
	  /**
	   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
	   * @type {node}
	   */
	  children: (0, _all2['default'])((0, _PropTypes.requiredRoles)(TOGGLE_ROLE, MENU_ROLE), (0, _PropTypes.exclusiveRoles)(MENU_ROLE)),
	
	  /**
	   * Whether or not component is disabled.
	   */
	  disabled: _propTypes2['default'].bool,
	
	  /**
	   * Align the menu to the right side of the Dropdown toggle
	   */
	  pullRight: _propTypes2['default'].bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  open: _propTypes2['default'].bool,
	
	  /**
	   * A callback fired when the Dropdown closes.
	   */
	  onClose: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
	   *
	   * ```js
	   * function(Boolean isOpen, Object event, { String source }) {}
	   * ```
	   * @controllable open
	   */
	  onToggle: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when a menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
	   * a menu button.
	   */
	  role: _propTypes2['default'].string,
	
	  /**
	   * Which event when fired outside the component will cause it to be closed
	   */
	  rootCloseEvent: _propTypes2['default'].oneOf(['click', 'mousedown']),
	
	  /**
	   * @private
	   */
	  onMouseEnter: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseLeave: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: _ButtonGroup2['default']
	};
	
	var Dropdown = function (_React$Component) {
	  (0, _inherits3['default'])(Dropdown, _React$Component);
	
	  function Dropdown(props, context) {
	    (0, _classCallCheck3['default'])(this, Dropdown);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	
	    _this._focusInDropdown = false;
	    _this.lastOpenEventType = null;
	    return _this;
	  }
	
	  Dropdown.prototype.componentDidMount = function componentDidMount() {
	    this.focusNextOnOpen();
	  };
	
	  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!nextProps.open && this.props.open) {
	      this._focusInDropdown = (0, _contains2['default'])(_reactDom2['default'].findDOMNode(this.menu), (0, _activeElement2['default'])(document));
	    }
	  };
	
	  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var open = this.props.open;
	
	    var prevOpen = prevProps.open;
	
	    if (open && !prevOpen) {
	      this.focusNextOnOpen();
	    }
	
	    if (!open && prevOpen) {
	      // if focus hasn't already moved from the menu lets return it
	      // to the toggle
	      if (this._focusInDropdown) {
	        this._focusInDropdown = false;
	        this.focus();
	      }
	    }
	  };
	
	  Dropdown.prototype.handleClick = function handleClick(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    this.toggleOpen(event, { source: 'click' });
	  };
	
	  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        if (!this.props.open) {
	          this.toggleOpen(event, { source: 'keydown' });
	        } else if (this.menu.focusNext) {
	          this.menu.focusNext();
	        }
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.handleClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  Dropdown.prototype.toggleOpen = function toggleOpen(event, eventDetails) {
	    var open = !this.props.open;
	
	    if (open) {
	      this.lastOpenEventType = eventDetails.source;
	    }
	
	    if (this.props.onToggle) {
	      this.props.onToggle(open, event, eventDetails);
	    }
	  };
	
	  Dropdown.prototype.handleClose = function handleClose(event, eventDetails) {
	    if (!this.props.open) {
	      return;
	    }
	
	    this.toggleOpen(event, eventDetails);
	  };
	
	  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
	    var menu = this.menu;
	
	    if (!menu.focusNext) {
	      return;
	    }
	
	    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
	      menu.focusNext();
	    }
	  };
	
	  Dropdown.prototype.focus = function focus() {
	    var toggle = _reactDom2['default'].findDOMNode(this.toggle);
	
	    if (toggle && toggle.focus) {
	      toggle.focus();
	    }
	  };
	
	  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
	    var _this2 = this;
	
	    var ref = function ref(c) {
	      _this2.toggle = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
	      ref: ref,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'toggle'),
	      onClick: (0, _createChainedFunction2['default'])(child.props.onClick, this.handleClick),
	      onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, this.handleKeyDown)
	    }));
	  };
	
	  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
	    var _this3 = this;
	
	    var id = _ref.id,
	        onClose = _ref.onClose,
	        onSelect = _ref.onSelect,
	        rootCloseEvent = _ref.rootCloseEvent,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['id', 'onClose', 'onSelect', 'rootCloseEvent']);
	
	    var ref = function ref(c) {
	      _this3.menu = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
	      ref: ref,
	      labelledBy: id,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'menu'),
	      onClose: (0, _createChainedFunction2['default'])(child.props.onClose, onClose, this.handleClose),
	      onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, function (key, event) {
	        return _this3.handleClose(event, { source: 'select' });
	      }),
	      rootCloseEvent: rootCloseEvent
	    }));
	  };
	
	  Dropdown.prototype.render = function render() {
	    var _classes,
	        _this4 = this;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        id = _props.id,
	        dropup = _props.dropup,
	        disabled = _props.disabled,
	        pullRight = _props.pullRight,
	        open = _props.open,
	        onClose = _props.onClose,
	        onSelect = _props.onSelect,
	        role = _props.role,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onClose', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);
	
	
	    delete props.onToggle;
	
	    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);
	
	    if (dropup) {
	      classes[bsClass] = false;
	      classes.dropup = true;
	    }
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, props, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        switch (child.props.bsRole) {
	          case TOGGLE_ROLE:
	            return _this4.renderToggle(child, {
	              id: id, disabled: disabled, open: open, role: role, bsClass: bsClass
	            });
	          case MENU_ROLE:
	            return _this4.renderMenu(child, {
	              id: id, open: open, pullRight: pullRight, bsClass: bsClass, onClose: onClose, onSelect: onSelect, rootCloseEvent: rootCloseEvent
	            });
	          default:
	            return child;
	        }
	      })
	    );
	  };
	
	  return Dropdown;
	}(_react2['default'].Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('dropdown', Dropdown);
	
	var UncontrolledDropdown = (0, _uncontrollable2['default'])(Dropdown, { open: 'onToggle' });
	
	UncontrolledDropdown.Toggle = _DropdownToggle2['default'];
	UncontrolledDropdown.Menu = _DropdownMenu2['default'];
	
	exports['default'] = UncontrolledDropdown;
	module.exports = exports['default'];

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(904);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  'in': _propTypes2['default'].bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _propTypes2['default'].bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2['default'].bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _propTypes2['default'].number,
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _propTypes2['default'].func,
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _propTypes2['default'].func,
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false
	};
	
	var Fade = function (_React$Component) {
	  (0, _inherits3['default'])(Fade, _React$Component);
	
	  function Fade() {
	    (0, _classCallCheck3['default'])(this, Fade);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Fade.prototype.render = function render() {
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, this.props, {
	      className: (0, _classnames2['default'])(this.props.className, 'fade'),
	      enteredClassName: 'in',
	      enteringClassName: 'in'
	    }));
	  };
	
	  return Fade;
	}(_react2['default'].Component);
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	
	exports['default'] = Fade;
	module.exports = exports['default'];

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _entries = __webpack_require__(509);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	exports["default"] = splitComponentProps;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function splitComponentProps(props, Component) {
	  var componentPropTypes = Component.propTypes;
	
	  var parentProps = {};
	  var childProps = {};
	
	  (0, _entries2["default"])(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (componentPropTypes[propName]) {
	      parentProps[propName] = propValue;
	    } else {
	      childProps[propName] = propValue;
	    }
	  });
	
	  return [parentProps, childProps];
	}
	module.exports = exports["default"];

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var _default = (0, _airbnbPropTypes.and)([_propTypes["default"].instanceOf(Set), function () {
	  function modifiers(props, propName) {
	    for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      rest[_key - 2] = arguments[_key];
	    }
	
	    var propValue = props[propName];
	    var firstError;
	
	    _toConsumableArray(propValue).some(function (v, i) {
	      var _PropTypes$string;
	
	      var fakePropName = "".concat(propName, ": index ").concat(i);
	      firstError = (_PropTypes$string = _propTypes["default"].string).isRequired.apply(_PropTypes$string, [_defineProperty({}, fakePropName, v), fakePropName].concat(rest));
	      return firstError != null;
	    });
	
	    return firstError == null ? null : firstError;
	  }
	
	  return modifiers;
	}()], 'Modifiers (Set of Strings)');
	
	exports["default"] = _default;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isAfterDay;
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _isBeforeDay = _interopRequireDefault(__webpack_require__(225));
	
	var _isSameDay = _interopRequireDefault(__webpack_require__(177));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function isAfterDay(a, b) {
	  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
	  return !(0, _isBeforeDay["default"])(a, b) && !(0, _isSameDay["default"])(a, b);
	}

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = toISODateString;
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _toMomentObject = _interopRequireDefault(__webpack_require__(178));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function toISODateString(date, currentFormat) {
	  var dateObj = _moment["default"].isMoment(date) ? date : (0, _toMomentObject["default"])(date, currentFormat);
	  if (!dateObj) return null;
	  return dateObj.format(_constants.ISO_FORMAT);
	}

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = toISOMonthString;
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _toMomentObject = _interopRequireDefault(__webpack_require__(178));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function toISOMonthString(date, currentFormat) {
	  var dateObj = _moment["default"].isMoment(date) ? date : (0, _toMomentObject["default"])(date, currentFormat);
	  if (!dateObj) return null;
	  return dateObj.format(_constants.ISO_MONTH_FORMAT);
	}

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(47);
	
	var EventPluginRegistry = __webpack_require__(440);
	var ReactEventEmitterMixin = __webpack_require__(1858);
	var ViewportMetrics = __webpack_require__(888);
	
	var getVendorPrefixedEventName = __webpack_require__(1890);
	var isEventSupported = __webpack_require__(451);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(229);
	var ViewportMetrics = __webpack_require__(888);
	
	var getEventModifierState = __webpack_require__(449);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(20);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 296 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(67);
	var DOMNamespaces = __webpack_require__(439);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(447);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 298 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// As defined on the list of supported mouse events: https://facebook.github.io/react/docs/events.html#mouse-events
	var mouseEvents = exports.mouseEvents = ['onClick', 'onContextMenu', 'onDoubleClick', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp'];
	// As defined on the list of supported touch events: https://facebook.github.io/react/docs/events.html#touch-events
	var touchEvents = exports.touchEvents = ['onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart'];
	
	/**
	 * Returns an object with on-event callback props curried with provided args.
	 * @param {Object} props Props passed to a component.
	 * @param {*} args Argument(s) that on-event callbacks shall be curried with.
	 */
	var makeEventProps = exports.makeEventProps = function makeEventProps(props, getArgs) {
	  var eventProps = {};
	
	  [].concat(mouseEvents, touchEvents).forEach(function (eventName) {
	    if (props[eventName]) {
	      eventProps[eventName] = function (event) {
	        return props[eventName](event, getArgs());
	      };
	    }
	  });
	
	  return eventProps;
	};

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = all;
	
	var _createChainableTypeChecker = __webpack_require__(301);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function all() {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  function allPropTypes() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var error = null;
	
	    validators.forEach(function (validator) {
	      if (error != null) {
	        return;
	      }
	
	      var result = validator.apply(undefined, args);
	      if (result != null) {
	        error = result;
	      }
	    });
	
	    return error;
	  }
	
	  return (0, _createChainableTypeChecker2.default)(allPropTypes);
	}

/***/ },
/* 300 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ },
/* 301 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ },
/* 302 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatName;
	var isFieldArrayRegx = /\[\d+\]$/;
	
	function formatName(context, name) {
	  var sectionPrefix = context._reduxForm.sectionPrefix;
	
	  return !sectionPrefix || isFieldArrayRegx.test(name) ? name : sectionPrefix + "." + name;
	}

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Buffer = __webpack_require__(62).Buffer;
	
	var isBufferEncoding = Buffer.isEncoding
	  || function(encoding) {
	       switch (encoding && encoding.toLowerCase()) {
	         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
	         default: return false;
	       }
	     }
	
	
	function assertEncoding(encoding) {
	  if (encoding && !isBufferEncoding(encoding)) {
	    throw new Error('Unknown encoding: ' + encoding);
	  }
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters. CESU-8 is handled as part of the UTF-8 encoding.
	//
	// @TODO Handling all encodings inside a single object makes it very difficult
	// to reason about this code, so it should be split up in the future.
	// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
	// points as used by CESU-8.
	var StringDecoder = exports.StringDecoder = function(encoding) {
	  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
	  assertEncoding(encoding);
	  switch (this.encoding) {
	    case 'utf8':
	      // CESU-8 represents each of Surrogate Pair by 3-bytes
	      this.surrogateSize = 3;
	      break;
	    case 'ucs2':
	    case 'utf16le':
	      // UTF-16 represents each of Surrogate Pair by 2-bytes
	      this.surrogateSize = 2;
	      this.detectIncompleteChar = utf16DetectIncompleteChar;
	      break;
	    case 'base64':
	      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
	      this.surrogateSize = 3;
	      this.detectIncompleteChar = base64DetectIncompleteChar;
	      break;
	    default:
	      this.write = passThroughWrite;
	      return;
	  }
	
	  // Enough space to store all bytes of a single character. UTF-8 needs 4
	  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
	  this.charBuffer = new Buffer(6);
	  // Number of bytes received for the current incomplete multi-byte character.
	  this.charReceived = 0;
	  // Number of bytes expected for the current incomplete multi-byte character.
	  this.charLength = 0;
	};
	
	
	// write decodes the given buffer and returns it as JS string that is
	// guaranteed to not contain any partial multi-byte characters. Any partial
	// character found at the end of the buffer is buffered up, and will be
	// returned when calling write again with the remaining bytes.
	//
	// Note: Converting a Buffer containing an orphan surrogate to a String
	// currently works, but converting a String to a Buffer (via `new Buffer`, or
	// Buffer#write) will replace incomplete surrogates with the unicode
	// replacement character. See https://codereview.chromium.org/121173009/ .
	StringDecoder.prototype.write = function(buffer) {
	  var charStr = '';
	  // if our last write ended with an incomplete multibyte character
	  while (this.charLength) {
	    // determine how many remaining bytes this buffer has to offer for this char
	    var available = (buffer.length >= this.charLength - this.charReceived) ?
	        this.charLength - this.charReceived :
	        buffer.length;
	
	    // add the new bytes to the char buffer
	    buffer.copy(this.charBuffer, this.charReceived, 0, available);
	    this.charReceived += available;
	
	    if (this.charReceived < this.charLength) {
	      // still not enough chars in this buffer? wait for more ...
	      return '';
	    }
	
	    // remove bytes belonging to the current character from the buffer
	    buffer = buffer.slice(available, buffer.length);
	
	    // get the character that was split
	    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
	
	    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	    var charCode = charStr.charCodeAt(charStr.length - 1);
	    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	      this.charLength += this.surrogateSize;
	      charStr = '';
	      continue;
	    }
	    this.charReceived = this.charLength = 0;
	
	    // if there are no more bytes in this buffer, just emit our char
	    if (buffer.length === 0) {
	      return charStr;
	    }
	    break;
	  }
	
	  // determine and set charLength / charReceived
	  this.detectIncompleteChar(buffer);
	
	  var end = buffer.length;
	  if (this.charLength) {
	    // buffer the incomplete character bytes we got
	    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
	    end -= this.charReceived;
	  }
	
	  charStr += buffer.toString(this.encoding, 0, end);
	
	  var end = charStr.length - 1;
	  var charCode = charStr.charCodeAt(end);
	  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	    var size = this.surrogateSize;
	    this.charLength += size;
	    this.charReceived += size;
	    this.charBuffer.copy(this.charBuffer, size, 0, size);
	    buffer.copy(this.charBuffer, 0, 0, size);
	    return charStr.substring(0, end);
	  }
	
	  // or just emit the charStr
	  return charStr;
	};
	
	// detectIncompleteChar determines if there is an incomplete UTF-8 character at
	// the end of the given buffer. If so, it sets this.charLength to the byte
	// length that character, and sets this.charReceived to the number of bytes
	// that are available for this character.
	StringDecoder.prototype.detectIncompleteChar = function(buffer) {
	  // determine how many bytes we have to check at the end of this buffer
	  var i = (buffer.length >= 3) ? 3 : buffer.length;
	
	  // Figure out if one of the last i bytes of our buffer announces an
	  // incomplete char.
	  for (; i > 0; i--) {
	    var c = buffer[buffer.length - i];
	
	    // See http://en.wikipedia.org/wiki/UTF-8#Description
	
	    // 110XXXXX
	    if (i == 1 && c >> 5 == 0x06) {
	      this.charLength = 2;
	      break;
	    }
	
	    // 1110XXXX
	    if (i <= 2 && c >> 4 == 0x0E) {
	      this.charLength = 3;
	      break;
	    }
	
	    // 11110XXX
	    if (i <= 3 && c >> 3 == 0x1E) {
	      this.charLength = 4;
	      break;
	    }
	  }
	  this.charReceived = i;
	};
	
	StringDecoder.prototype.end = function(buffer) {
	  var res = '';
	  if (buffer && buffer.length)
	    res = this.write(buffer);
	
	  if (this.charReceived) {
	    var cr = this.charReceived;
	    var buf = this.charBuffer;
	    var enc = this.encoding;
	    res += buf.slice(0, cr).toString(enc);
	  }
	
	  return res;
	};
	
	function passThroughWrite(buffer) {
	  return buffer.toString(this.encoding);
	}
	
	function utf16DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 2;
	  this.charLength = this.charReceived ? 2 : 0;
	}
	
	function base64DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 3;
	  this.charLength = this.charReceived ? 3 : 0;
	}


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  console.warn("Using browser-only version of superagent in non-browser environment");
	  root = this;
	}
	
	var Emitter = __webpack_require__(1237);
	var RequestBase = __webpack_require__(2045);
	var isObject = __webpack_require__(945);
	var ResponseBase = __webpack_require__(2046);
	var Agent = __webpack_require__(2044);
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Expose `request`.
	 */
	
	var request = exports = module.exports = function(method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new exports.Request('GET', method).end(url);
	  }
	
	  // url first
	  if (1 == arguments.length) {
	    return new exports.Request('GET', method);
	  }
	
	  return new exports.Request(method, url);
	}
	
	exports.Request = Request;
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  throw Error("Browser-only version of superagent could not find XHR");
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    pushEncodedKeyValuePair(pairs, key, obj[key]);
	  }
	  return pairs.join('&');
	}
	
	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */
	
	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (val != null) {
	    if (Array.isArray(val)) {
	      val.forEach(function(v) {
	        pushEncodedKeyValuePair(pairs, key, v);
	      });
	    } else if (isObject(val)) {
	      for(var subkey in val) {
	        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
	      }
	    } else {
	      pairs.push(encodeURIComponent(key)
	        + '=' + encodeURIComponent(val));
	    }
	  } else if (val === null) {
	    pairs.push(encodeURIComponent(key));
	  }
	}
	
	/**
	 * Expose serialization method.
	 */
	
	request.serializeObject = serialize;
	
	/**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var pair;
	  var pos;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    pos = pair.indexOf('=');
	    if (pos == -1) {
	      obj[decodeURIComponent(pair)] = '';
	    } else {
	      obj[decodeURIComponent(pair.slice(0, pos))] =
	        decodeURIComponent(pair.slice(pos + 1));
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'text/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	request.serialize = {
	  'application/x-www-form-urlencoded': serialize,
	  'application/json': JSON.stringify
	};
	
	/**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    if (index === -1) { // could be empty line, just skip it
	      continue;
	    }
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */
	
	function isJSON(mime) {
	  // should match /json or +json
	  // but not /json-seq
	  return /[\/+]json($|[^-\w])/.test(mime);
	}
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req) {
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  var status = this.xhr.status;
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }
	  this._setStatusProperties(status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this._setHeaderProperties(this.header);
	
	  if (null === this.text && req._responseType) {
	    this.body = this.xhr.response;
	  } else {
	    this.body = this.req.method != 'HEAD'
	      ? this._parseBody(this.text ? this.text : this.xhr.response)
	      : null;
	  }
	}
	
	ResponseBase(Response.prototype);
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype._parseBody = function(str) {
	  var parse = request.parse[this.type];
	  if (this.req._parser) {
	    return this.req._parser(this, str);
	  }
	  if (!parse && isJSON(this.type)) {
	    parse = request.parse['application/json'];
	  }
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {}; // preserves header name case
	  this._header = {}; // coerces header names to lowercase
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      if (self.xhr) {
	        // ie9 doesn't have 'response' property
	        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
	        // issue #876: return the http status code if the response parsing fails
	        err.status = self.xhr.status ? self.xhr.status : null;
	        err.statusCode = err.status; // backwards-compat only
	      } else {
	        err.rawResponse = null;
	        err.status = null;
	      }
	
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    var new_err;
	    try {
	      if (!self._isResponseOK(res)) {
	        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	      }
	    } catch(custom_err) {
	      new_err = custom_err; // ok() callback can throw
	    }
	
	    // #1000 don't catch errors from the callback to avoid double calling it
	    if (new_err) {
	      new_err.original = err;
	      new_err.response = res;
	      new_err.status = res.status;
	      self.callback(new_err, res);
	    } else {
	      self.callback(null, res);
	    }
	  });
	}
	
	/**
	 * Mixin `Emitter` and `RequestBase`.
	 */
	
	Emitter(Request.prototype);
	RequestBase(Request.prototype);
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} [pass] optional in case of using 'bearer' as type
	 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass, options){
	  if (1 === arguments.length) pass = '';
	  if (typeof pass === 'object' && pass !== null) { // pass is optional and can be replaced with options
	    options = pass;
	    pass = '';
	  }
	  if (!options) {
	    options = {
	      type: 'function' === typeof btoa ? 'basic' : 'auto',
	    };
	  }
	
	  var encoder = function(string) {
	    if ('function' === typeof btoa) {
	      return btoa(string);
	    }
	    throw new Error('Cannot use basic auth, btoa is not a function');
	  };
	
	  return this._auth(user, pass, options, encoder);
	};
	
	/**
	 * Add query-string `val`.
	 *
	 * Examples:
	 *
	 *   request.get('/shoes')
	 *     .query('size=10')
	 *     .query({ color: 'blue' })
	 *
	 * @param {Object|String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `options` (or filename).
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String|Object} options
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, options){
	  if (file) {
	    if (this._data) {
	      throw Error("superagent can't mix .send() and .attach()");
	    }
	
	    this._getFormData().append(field, file, options || file.name);
	  }
	  return this;
	};
	
	Request.prototype._getFormData = function(){
	  if (!this._formData) {
	    this._formData = new root.FormData();
	  }
	  return this._formData;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  if (this._shouldRetry(err, res)) {
	    return this._retry();
	  }
	
	  var fn = this._callback;
	  this.clearTimeout();
	
	  if (err) {
	    if (this._maxRetries) err.retries = this._retries - 1;
	    this.emit('error', err);
	  }
	
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;
	
	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;
	
	  this.callback(err);
	};
	
	// This only warns, because the request is still likely to work
	Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
	  console.warn("This is not supported in browser version of superagent");
	  return this;
	};
	
	// This throws, because it can't send/receive data as expected
	Request.prototype.pipe = Request.prototype.write = function(){
	  throw Error("Streaming is not supported in browser version of superagent");
	};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	Request.prototype._isHost = function _isHost(obj) {
	  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
	  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
	}
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  if (this._endCalled) {
	    console.warn("Warning: .end() was called twice. This is not supported in superagent");
	  }
	  this._endCalled = true;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // querystring
	  this._finalizeQueryString();
	
	  return this._end();
	};
	
	Request.prototype._end = function() {
	  var self = this;
	  var xhr = (this.xhr = request.getXHR());
	  var data = this._formData || this._data;
	
	  this._setTimeouts();
	
	  // state change
	  xhr.onreadystatechange = function(){
	    var readyState = xhr.readyState;
	    if (readyState >= 2 && self._responseTimeoutTimer) {
	      clearTimeout(self._responseTimeoutTimer);
	    }
	    if (4 != readyState) {
	      return;
	    }
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (!status) {
	      if (self.timedout || self._aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(direction, e) {
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = direction;
	    self.emit('progress', e);
	  };
	  if (this.hasListeners('progress')) {
	    try {
	      xhr.onprogress = handleProgress.bind(null, 'download');
	      if (xhr.upload) {
	        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
	      }
	    } catch(e) {
	      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	      // Reported here:
	      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	    }
	  }
	
	  // initiate request
	  try {
	    if (this.username && this.password) {
	      xhr.open(this.method, this.url, true, this.username, this.password);
	    } else {
	      xhr.open(this.method, this.url, true);
	    }
	  } catch (err) {
	    // see #1149
	    return this.callback(err);
	  }
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
	    // serialize stuff
	    var contentType = this._header['content-type'];
	    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) {
	      serialize = request.serialize['application/json'];
	    }
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	
	    if (this.header.hasOwnProperty(field))
	      xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  if (this._responseType) {
	    xhr.responseType = this._responseType;
	  }
	
	  // send stuff
	  this.emit('request', this);
	
	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};
	
	request.agent = function() {
	  return new Agent();
	};
	
	["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function(method) {
	  Agent.prototype[method.toLowerCase()] = function(url, fn) {
	    var req = new request.Request(method, url);
	    this._setDefaults(req);
	    if (fn) {
	      req.end(fn);
	    }
	    return req;
	  };
	});
	
	Agent.prototype.del = Agent.prototype['delete'];
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn) {
	  var req = request('GET', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn) {
	  var req = request('HEAD', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * OPTIONS query to `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.options = function(url, data, fn) {
	  var req = request('OPTIONS', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	function del(url, data, fn) {
	  var req = request('DELETE', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	}
	
	request['del'] = del;
	request['delete'] = del;
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn) {
	  var req = request('PATCH', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn) {
	  var req = request('POST', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn) {
	  var req = request('PUT', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__(2051);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (!component.unmounted) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)(mixin, set);
	module.exports = exports['default'];

/***/ },
/* 306 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EPSILON_FLOAT32 = 1e-7;
	exports.EPSILON_FLOAT16 = 1e-4;
	/** Convenient class for storing tensor-related data. */
	var DataStorage = /** @class */ (function () {
	    function DataStorage(backend, dataMover) {
	        this.backend = backend;
	        this.dataMover = dataMover;
	        this.data = new WeakMap();
	        this.dataIdsCount = 0;
	    }
	    DataStorage.prototype.get = function (dataId) {
	        if (!this.data.has(dataId)) {
	            this.dataMover.moveData(this.backend, dataId);
	        }
	        return this.data.get(dataId);
	    };
	    DataStorage.prototype.set = function (dataId, value) {
	        this.dataIdsCount++;
	        this.data.set(dataId, value);
	    };
	    DataStorage.prototype.has = function (dataId) {
	        return this.data.has(dataId);
	    };
	    DataStorage.prototype.delete = function (dataId) {
	        this.dataIdsCount--;
	        return this.data.delete(dataId);
	    };
	    DataStorage.prototype.numDataIds = function () {
	        return this.dataIdsCount;
	    };
	    return DataStorage;
	}());
	exports.DataStorage = DataStorage;
	/**
	 * The interface that defines the kernels that should be implemented when
	 * adding a new backend. New backends don't need to implement every one of the
	 * methods, this can be done gradually (throw an error for unimplemented
	 * methods).
	 */
	var KernelBackend = /** @class */ (function () {
	    function KernelBackend() {
	    }
	    KernelBackend.prototype.time = function (f) {
	        return notYetImplemented('time');
	    };
	    KernelBackend.prototype.read = function (dataId) {
	        return notYetImplemented('read');
	    };
	    KernelBackend.prototype.readSync = function (dataId) {
	        return notYetImplemented('readSync');
	    };
	    KernelBackend.prototype.numDataIds = function () {
	        return notYetImplemented('numDataIds');
	    };
	    KernelBackend.prototype.disposeData = function (dataId) {
	        return notYetImplemented('disposeData');
	    };
	    KernelBackend.prototype.write = function (values, shape, dtype) {
	        return notYetImplemented('write');
	    };
	    KernelBackend.prototype.move = function (dataId, values, shape, dtype) {
	        return notYetImplemented('move');
	    };
	    KernelBackend.prototype.memory = function () {
	        return notYetImplemented('memory');
	    };
	    /** Returns the highest precision for floats in bits (e.g. 16 or 32) */
	    KernelBackend.prototype.floatPrecision = function () {
	        return notYetImplemented('floatPrecision');
	    };
	    /** Returns the smallest representable number.  */
	    KernelBackend.prototype.epsilon = function () {
	        return this.floatPrecision() === 32 ? exports.EPSILON_FLOAT32 : exports.EPSILON_FLOAT16;
	    };
	    KernelBackend.prototype.batchMatMul = function (a, b, transposeA, transposeB) {
	        return notYetImplemented('batchMatMul');
	    };
	    KernelBackend.prototype.fusedBatchMatMul = function (_a) {
	        var a = _a.a, b = _a.b, transposeA = _a.transposeA, transposeB = _a.transposeB, bias = _a.bias, activation = _a.activation, preluActivationWeights = _a.preluActivationWeights;
	        return notYetImplemented('fusedBatchMatMul');
	    };
	    KernelBackend.prototype.slice = function (x, begin, size) {
	        return notYetImplemented('slice');
	    };
	    KernelBackend.prototype.stridedSlice = function (x, begin, end, strides) {
	        return notYetImplemented('stridedSlice');
	    };
	    KernelBackend.prototype.unstack = function (x, axis) {
	        return notYetImplemented('unstack');
	    };
	    KernelBackend.prototype.reverse = function (a, axis) {
	        return notYetImplemented('reverse');
	    };
	    KernelBackend.prototype.concat = function (tensors, axis) {
	        return notYetImplemented('concat');
	    };
	    KernelBackend.prototype.neg = function (a) {
	        return notYetImplemented('neg');
	    };
	    KernelBackend.prototype.add = function (a, b) {
	        return notYetImplemented('add');
	    };
	    KernelBackend.prototype.addN = function (tensors) {
	        return notYetImplemented('addN');
	    };
	    KernelBackend.prototype.subtract = function (a, b) {
	        return notYetImplemented('subtract');
	    };
	    KernelBackend.prototype.multiply = function (a, b) {
	        return notYetImplemented('multiply');
	    };
	    KernelBackend.prototype.realDivide = function (a, b) {
	        return notYetImplemented('realDivide');
	    };
	    KernelBackend.prototype.floorDiv = function (a, b) {
	        return notYetImplemented('floorDiv');
	    };
	    KernelBackend.prototype.sum = function (x, axes) {
	        return notYetImplemented('sum');
	    };
	    KernelBackend.prototype.prod = function (x, axes) {
	        return notYetImplemented('prod');
	    };
	    KernelBackend.prototype.unsortedSegmentSum = function (x, segmentIds, numSegments) {
	        return notYetImplemented('unsortedSegmentSum');
	    };
	    KernelBackend.prototype.argMin = function (x, axis) {
	        return notYetImplemented('argMin');
	    };
	    KernelBackend.prototype.argMax = function (x, axis) {
	        return notYetImplemented('argMax');
	    };
	    KernelBackend.prototype.equal = function (a, b) {
	        return notYetImplemented('equal');
	    };
	    KernelBackend.prototype.notEqual = function (a, b) {
	        return notYetImplemented('notEqual');
	    };
	    KernelBackend.prototype.less = function (a, b) {
	        return notYetImplemented('less');
	    };
	    KernelBackend.prototype.lessEqual = function (a, b) {
	        return notYetImplemented('lessEqual');
	    };
	    KernelBackend.prototype.greater = function (a, b) {
	        return notYetImplemented('greater');
	    };
	    KernelBackend.prototype.greaterEqual = function (a, b) {
	        return notYetImplemented('greaterEqual');
	    };
	    KernelBackend.prototype.logicalNot = function (a) {
	        return notYetImplemented('logicalNot');
	    };
	    KernelBackend.prototype.logicalAnd = function (a, b) {
	        return notYetImplemented('logicalAnd');
	    };
	    KernelBackend.prototype.logicalOr = function (a, b) {
	        return notYetImplemented('logicalOr');
	    };
	    KernelBackend.prototype.where = function (condition) {
	        return notYetImplemented('where');
	    };
	    KernelBackend.prototype.select = function (condition, a, b) {
	        return notYetImplemented('select');
	    };
	    KernelBackend.prototype.topk = function (x, k, sorted) {
	        return notYetImplemented('topk');
	    };
	    KernelBackend.prototype.min = function (x, axes) {
	        return notYetImplemented('min');
	    };
	    KernelBackend.prototype.minimum = function (a, b) {
	        return notYetImplemented('minimum');
	    };
	    KernelBackend.prototype.mod = function (a, b) {
	        return notYetImplemented('mod');
	    };
	    KernelBackend.prototype.max = function (x, axes) {
	        return notYetImplemented('max');
	    };
	    KernelBackend.prototype.maximum = function (a, b) {
	        return notYetImplemented('maximum');
	    };
	    KernelBackend.prototype.all = function (x, axes) {
	        return notYetImplemented('all');
	    };
	    KernelBackend.prototype.any = function (x, axes) {
	        return notYetImplemented('any');
	    };
	    KernelBackend.prototype.squaredDifference = function (a, b) {
	        return notYetImplemented('squaredDifference');
	    };
	    KernelBackend.prototype.ceil = function (x) {
	        return notYetImplemented('ceil');
	    };
	    KernelBackend.prototype.floor = function (x) {
	        return notYetImplemented('floor');
	    };
	    KernelBackend.prototype.round = function (x) {
	        return notYetImplemented('round');
	    };
	    KernelBackend.prototype.sign = function (x) {
	        return notYetImplemented('sign');
	    };
	    KernelBackend.prototype.isNaN = function (x) {
	        return notYetImplemented('isNaN');
	    };
	    KernelBackend.prototype.isInf = function (x) {
	        return notYetImplemented('isInf');
	    };
	    KernelBackend.prototype.isFinite = function (x) {
	        return notYetImplemented('isFinite');
	    };
	    KernelBackend.prototype.pow = function (a, b) {
	        return notYetImplemented('pow');
	    };
	    KernelBackend.prototype.exp = function (x) {
	        return notYetImplemented('exp');
	    };
	    KernelBackend.prototype.expm1 = function (x) {
	        return notYetImplemented('expm1');
	    };
	    KernelBackend.prototype.softmax = function (x, dim) {
	        return notYetImplemented('softmax');
	    };
	    KernelBackend.prototype.log = function (x) {
	        return notYetImplemented('log');
	    };
	    KernelBackend.prototype.log1p = function (x) {
	        return notYetImplemented('log1p');
	    };
	    KernelBackend.prototype.sqrt = function (x) {
	        return notYetImplemented('sqrt');
	    };
	    KernelBackend.prototype.rsqrt = function (x) {
	        return notYetImplemented('rsqrt');
	    };
	    KernelBackend.prototype.square = function (x) {
	        return notYetImplemented('square');
	    };
	    KernelBackend.prototype.reciprocal = function (x) {
	        return notYetImplemented('reciprocal');
	    };
	    KernelBackend.prototype.relu = function (x) {
	        return notYetImplemented('relu');
	    };
	    KernelBackend.prototype.relu6 = function (x) {
	        return notYetImplemented('relu6');
	    };
	    KernelBackend.prototype.prelu = function (x, a) {
	        return notYetImplemented('prelu');
	    };
	    KernelBackend.prototype.elu = function (x) {
	        return notYetImplemented('elu');
	    };
	    KernelBackend.prototype.eluDer = function (dy, y) {
	        return notYetImplemented('eluDer');
	    };
	    KernelBackend.prototype.selu = function (x) {
	        return notYetImplemented('selu');
	    };
	    KernelBackend.prototype.int = function (x) {
	        return notYetImplemented('int');
	    };
	    KernelBackend.prototype.clip = function (x, min, max) {
	        return notYetImplemented('clip');
	    };
	    KernelBackend.prototype.abs = function (x) {
	        return notYetImplemented('abs');
	    };
	    KernelBackend.prototype.complexAbs = function (x) {
	        return notYetImplemented('complexAbs');
	    };
	    KernelBackend.prototype.sigmoid = function (x) {
	        return notYetImplemented('sigmoid');
	    };
	    KernelBackend.prototype.softplus = function (x) {
	        return notYetImplemented('softplus');
	    };
	    KernelBackend.prototype.sin = function (x) {
	        return notYetImplemented('sin');
	    };
	    KernelBackend.prototype.cos = function (x) {
	        return notYetImplemented('cos');
	    };
	    KernelBackend.prototype.tan = function (x) {
	        return notYetImplemented('tan');
	    };
	    KernelBackend.prototype.asin = function (x) {
	        return notYetImplemented('asin');
	    };
	    KernelBackend.prototype.acos = function (x) {
	        return notYetImplemented('acos');
	    };
	    KernelBackend.prototype.atan = function (x) {
	        return notYetImplemented('atan');
	    };
	    KernelBackend.prototype.atan2 = function (a, b) {
	        return notYetImplemented('atan2');
	    };
	    KernelBackend.prototype.sinh = function (x) {
	        return notYetImplemented('sinh');
	    };
	    KernelBackend.prototype.cosh = function (x) {
	        return notYetImplemented('cosh');
	    };
	    KernelBackend.prototype.tanh = function (x) {
	        return notYetImplemented('tanh');
	    };
	    KernelBackend.prototype.asinh = function (x) {
	        return notYetImplemented('asinh');
	    };
	    KernelBackend.prototype.acosh = function (x) {
	        return notYetImplemented('acosh');
	    };
	    KernelBackend.prototype.atanh = function (x) {
	        return notYetImplemented('atanh');
	    };
	    KernelBackend.prototype.erf = function (x) {
	        return notYetImplemented('erf');
	    };
	    KernelBackend.prototype.step = function (x, alpha) {
	        return notYetImplemented('step');
	    };
	    KernelBackend.prototype.fusedConv2d = function (_a) {
	        var input = _a.input, filter = _a.filter, convInfo = _a.convInfo, bias = _a.bias, activation = _a.activation, preluActivationWeights = _a.preluActivationWeights;
	        return notYetImplemented('fusedConv2d');
	    };
	    KernelBackend.prototype.conv2d = function (x, filter, convInfo) {
	        return notYetImplemented('conv2d');
	    };
	    KernelBackend.prototype.conv2dDerInput = function (dy, filter, convInfo) {
	        return notYetImplemented('conv2dDerInput');
	    };
	    KernelBackend.prototype.conv2dDerFilter = function (x, dY, convInfo) {
	        return notYetImplemented('conv2dDerFilter');
	    };
	    KernelBackend.prototype.fusedDepthwiseConv2D = function (_a) {
	        var input = _a.input, filter = _a.filter, convInfo = _a.convInfo, bias = _a.bias, activation = _a.activation, preluActivationWeights = _a.preluActivationWeights;
	        return notYetImplemented('fusedDepthwiseConv2D');
	    };
	    KernelBackend.prototype.depthwiseConv2D = function (input, filter, convInfo) {
	        return notYetImplemented('depthwiseConv2D');
	    };
	    KernelBackend.prototype.depthwiseConv2DDerInput = function (dy, filter, convInfo) {
	        return notYetImplemented('depthwiseConv2DDerInput');
	    };
	    KernelBackend.prototype.depthwiseConv2DDerFilter = function (x, dY, convInfo) {
	        return notYetImplemented('depthwiseConv2DDerFilter');
	    };
	    KernelBackend.prototype.conv3d = function (x, filter, convInfo) {
	        return notYetImplemented('conv3d');
	    };
	    KernelBackend.prototype.conv3dDerInput = function (dy, filter, convInfo) {
	        return notYetImplemented('conv3dDerInput');
	    };
	    KernelBackend.prototype.conv3dDerFilter = function (x, dY, convInfo) {
	        return notYetImplemented('conv3dDerFilter');
	    };
	    KernelBackend.prototype.maxPool = function (x, convInfo) {
	        return notYetImplemented('maxPool');
	    };
	    KernelBackend.prototype.maxPoolBackprop = function (dy, x, y, convInfo) {
	        return notYetImplemented('maxPoolBackprop');
	    };
	    KernelBackend.prototype.avgPool = function (x, convInfo) {
	        return notYetImplemented('avgPool');
	    };
	    KernelBackend.prototype.avgPoolBackprop = function (dy, x, convInfo) {
	        return notYetImplemented('avgPoolBackprop');
	    };
	    KernelBackend.prototype.avgPool3d = function (x, convInfo) {
	        return notYetImplemented('avgPool3d');
	    };
	    KernelBackend.prototype.avgPool3dBackprop = function (dy, x, convInfo) {
	        return notYetImplemented('avgPool3dBackprop');
	    };
	    KernelBackend.prototype.maxPool3d = function (x, convInfo) {
	        return notYetImplemented('maxPool3d');
	    };
	    KernelBackend.prototype.maxPool3dBackprop = function (dy, x, y, convInfo) {
	        return notYetImplemented('maxPool3dBackprop');
	    };
	    KernelBackend.prototype.reshape = function (x, shape) {
	        return notYetImplemented('reshape');
	    };
	    KernelBackend.prototype.cast = function (x, dtype) {
	        return notYetImplemented('cast');
	    };
	    KernelBackend.prototype.tile = function (x, reps) {
	        return notYetImplemented('tile');
	    };
	    KernelBackend.prototype.pad = function (x, paddings, constantValue) {
	        return notYetImplemented('pad');
	    };
	    KernelBackend.prototype.transpose = function (x, perm) {
	        return notYetImplemented('transpose');
	    };
	    KernelBackend.prototype.gather = function (x, indices, axis) {
	        return notYetImplemented('gather');
	    };
	    KernelBackend.prototype.gatherND = function (x, indices) {
	        return notYetImplemented('gatherND');
	    };
	    KernelBackend.prototype.scatterND = function (indices, updates, shape) {
	        return notYetImplemented('scatterND');
	    };
	    KernelBackend.prototype.batchToSpaceND = function (x, blockShape, crops) {
	        return notYetImplemented('batchToSpaceND');
	    };
	    KernelBackend.prototype.spaceToBatchND = function (x, blockShape, paddings) {
	        return notYetImplemented('spaceToBatchND');
	    };
	    KernelBackend.prototype.resizeBilinear = function (x, newHeight, newWidth, alignCorners) {
	        return notYetImplemented('resizeBilinear');
	    };
	    KernelBackend.prototype.resizeBilinearBackprop = function (dy, x, alignCorners) {
	        return notYetImplemented('resizeBilinearBackprop');
	    };
	    KernelBackend.prototype.resizeNearestNeighbor = function (x, newHEight, newWidth, alignCorners) {
	        return notYetImplemented('resizeNearestNeighbor');
	    };
	    KernelBackend.prototype.resizeNearestNeighborBackprop = function (dy, x, alignCorners) {
	        return notYetImplemented('resizeNearestNeighborBackprop');
	    };
	    KernelBackend.prototype.batchNormalization = function (x, mean, variance, varianceEpsilon, scale, offset) {
	        return notYetImplemented('batchNormalization');
	    };
	    KernelBackend.prototype.localResponseNormalization4D = function (x, radius, bias, alpha, beta) {
	        return notYetImplemented('localResponseNormalization4D');
	    };
	    KernelBackend.prototype.LRNGrad = function (dy, inputImage, outputImage, radius, bias, alpha, beta) {
	        return notYetImplemented('LRNGrad');
	    };
	    KernelBackend.prototype.multinomial = function (logits, normalized, numSamples, seed) {
	        return notYetImplemented('multinomial');
	    };
	    KernelBackend.prototype.oneHot = function (indices, depth, onValue, offValue) {
	        return notYetImplemented('oneHot');
	    };
	    KernelBackend.prototype.cumsum = function (x, axis, exclusive, reverse) {
	        return notYetImplemented('cumsum');
	    };
	    KernelBackend.prototype.nonMaxSuppression = function (boxes, scores, maxOutputSize, iouThreshold, scoreThreshold) {
	        return notYetImplemented('nonMaxSuppression');
	    };
	    KernelBackend.prototype.fft = function (x) {
	        return notYetImplemented('fft');
	    };
	    KernelBackend.prototype.ifft = function (x) {
	        return notYetImplemented('ifft');
	    };
	    KernelBackend.prototype.complex = function (real, imag) {
	        return notYetImplemented('complex');
	    };
	    KernelBackend.prototype.real = function (input) {
	        return notYetImplemented('real');
	    };
	    KernelBackend.prototype.imag = function (input) {
	        return notYetImplemented('imag');
	    };
	    KernelBackend.prototype.cropAndResize = function (image, boxes, boxIndex, cropSize, method, extrapolationValue) {
	        return notYetImplemented('cropAndResize');
	    };
	    KernelBackend.prototype.depthToSpace = function (x, blockSize, dataFormat) {
	        return notYetImplemented('depthToSpace');
	    };
	    // Aligns with the "SplitV" kernel in TensorFlow.
	    KernelBackend.prototype.split = function (value, sizeSplits, axis) {
	        return notYetImplemented('split');
	    };
	    KernelBackend.prototype.sparseToDense = function (sparseIndices, sparseValues, outputShape, defaultValue) {
	        return notYetImplemented('sparseToDense');
	    };
	    KernelBackend.prototype.diag = function (x) {
	        return notYetImplemented('diag');
	    };
	    KernelBackend.prototype.fill = function (shape, value, dtype) {
	        return notYetImplemented('fill');
	    };
	    KernelBackend.prototype.onesLike = function (x) {
	        return notYetImplemented('onesLike');
	    };
	    KernelBackend.prototype.zerosLike = function (x) {
	        return notYetImplemented('zerosLike');
	    };
	    KernelBackend.prototype.linspace = function (start, stop, num) {
	        return notYetImplemented('linspace');
	    };
	    KernelBackend.prototype.dispose = function () {
	        return notYetImplemented('dispose');
	    };
	    return KernelBackend;
	}());
	exports.KernelBackend = KernelBackend;
	function notYetImplemented(kernelName) {
	    throw new Error("'" + kernelName + "' not yet implemented or not found in the registry. " +
	        "Did you forget to import the kernel?");
	}
	//# sourceMappingURL=backend.js.map

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var broadcast_util = __webpack_require__(57);
	var CHECK_NAN_SNIPPET = "\n  if (isnan(a)) return a;\n  if (isnan(b)) return b;\n";
	exports.ADD = 'return a + b;';
	exports.SUB = 'return a - b;';
	exports.MUL = 'return a * b;';
	// Without the equality check div produces 0.9999 for a = b, which when
	// floored can cause errors.
	exports.DIV = "\nif (a == b) {\n  return 1.0;\n};\nreturn a / b;";
	// We use native integer division to deal with floating point imprecision. Since
	// we implement floor division and glsl implements truncated division, we
	// correct for this by subtracting 1 from result when the result is negative and
	// there is a remainder.
	exports.INT_DIV = "\n  float s = sign(a) * sign(b);\n  int ia = round(a);\n  int ib = round(b);\n  if (ib != 0) {\n    // Windows (D3D) wants guaranteed non-zero int division at compile-time.\n    return float(idiv(ia, ib, s));\n  } else {\n    return NAN;\n  }\n";
	exports.POW = "\nif(a < 0.0 && floor(b) < b){\n  return NAN;\n}\nif (b == 0.0) {\n  return 1.0;\n}\nreturn (round(mod(b, 2.0)) != 1) ?\n    pow(abs(a), b) : sign(a) * pow(abs(a), b);\n";
	exports.SQUARED_DIFFERENCE = 'return (a - b) * (a - b);';
	exports.EQUAL = "return float(a == b);";
	exports.NOT_EQUAL = "return float(a != b);";
	exports.LESS = "return float(a < b);";
	exports.LESS_EQUAL = "return float(a <= b);";
	exports.GREATER = "return float(a > b);";
	exports.GREATER_EQUAL = "return float(a >= b);";
	exports.LOGICAL_AND = "return float(a >= 1.0 && b >= 1.0);";
	exports.LOGICAL_OR = "return float(a >= 1.0 || b >= 1.0);";
	exports.MAX = CHECK_NAN_SNIPPET + "\n  return max(a, b);\n";
	exports.MIN = CHECK_NAN_SNIPPET + "\n  return min(a, b);\n";
	exports.MOD = "if (b == 0.0) return NAN;\n  return mod(a, b);";
	exports.ATAN2 = CHECK_NAN_SNIPPET + "\n  return atan(a, b);\n";
	exports.ELU_DER = "return (b >= 1.0) ? a : a * (b + 1.0);";
	exports.PRELU = "return (a < 0.) ? b * a : a;";
	var BinaryOpProgram = /** @class */ (function () {
	    function BinaryOpProgram(op, aShape, bShape) {
	        this.variableNames = ['A', 'B'];
	        this.outputShape =
	            broadcast_util.assertAndGetBroadcastShape(aShape, bShape);
	        this.userCode = "\n      float binaryOperation(float a, float b) {\n        " + op + "\n      }\n\n      void main() {\n        float a = getAAtOutCoords();\n        float b = getBAtOutCoords();\n        setOutput(binaryOperation(a, b));\n      }\n    ";
	    }
	    return BinaryOpProgram;
	}());
	exports.BinaryOpProgram = BinaryOpProgram;
	//# sourceMappingURL=binaryop_gpu.js.map

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var broadcast_util = __webpack_require__(57);
	var util_1 = __webpack_require__(10);
	var packing_util_1 = __webpack_require__(107);
	var shader_compiler_1 = __webpack_require__(41);
	var CHECK_NAN_SNIPPET = "\n  result.r = isNaN.r > 0. ? NAN : result.r;\n  result.g = isNaN.g > 0. ? NAN : result.g;\n  result.b = isNaN.b > 0. ? NAN : result.b;\n  result.a = isNaN.a > 0. ? NAN : result.a;\n";
	// We do the same as in ./binaryop_gpu, with vec4 and ivec4.
	// On Linux, the vectorized implementation produces NaNs when a and b are 0.
	exports.DIV = "\n  // vec4 one = vec4(equal(a, b));\n  // return one + (vec4(1.0) - one) * a / b;\n  vec4 result = a / b;\n  if(a.x == b.x) {\n    result.x = 1.;\n  }\n  if(a.y == b.y) {\n    result.y = 1.;\n  }\n  if(a.z == b.z) {\n    result.z = 1.;\n  }\n  if(a.w == b.w) {\n    result.w = 1.;\n  }\n\n  return result;\n";
	exports.INT_DIV = "\n  ivec4 ia = round(a);\n  ivec4 ib = round(b);\n  bvec4 cond = notEqual(ib, ivec4(0));\n  ivec4 result = ivec4(0);\n  vec4 s = sign(a) * sign(b);\n\n  // Windows (D3D) wants guaranteed non-zero int division at compile-time.\n  if (cond[0]) {\n    result[0] = idiv(ia[0], ib[0], s[0]);\n  }\n  if (cond[1]) {\n    result[1] = idiv(ia[1], ib[1], s[1]);\n  }\n  if (cond[2]) {\n    result[2] = idiv(ia[2], ib[2], s[2]);\n  }\n  if (cond[3]) {\n    result[3] = idiv(ia[3], ib[3], s[3]);\n  }\n  return vec4(result);\n";
	exports.POW = "\n  // isModRound1 has 1 for components with round(mod(b, 2.0)) == 1, 0 otherwise.\n  vec4 isModRound1 = vec4(equal(round(mod(b, 2.0)), ivec4(1)));\n  vec4 multiplier = sign(a) * isModRound1 + (vec4(1.0) - isModRound1);\n  vec4 result = multiplier * pow(abs(a), b);\n\n  // Ensure that a^0 = 1, including 0^0 = 1 as this correspond to TF and JS\n  bvec4 isExpZero = equal(b, vec4(0.0));\n  result.r = isExpZero.r ? 1.0 : result.r;\n  result.g = isExpZero.g ? 1.0 : result.g;\n  result.b = isExpZero.b ? 1.0 : result.b;\n  result.a = isExpZero.a ? 1.0 : result.a;\n\n  vec4 isNaN = vec4(lessThan(a, vec4(0.0))) * vec4(lessThan(floor(b), b));\n  " +
	    CHECK_NAN_SNIPPET + "\n  return result;\n";
	exports.PRELU = "\n  vec4 aLessThanZero = vec4(lessThan(a, vec4(0.)));\n  return (aLessThanZero * (b * a)) + ((vec4(1.0) - aLessThanZero) * a);\n";
	exports.ELU_DER = "\n  vec4 bGTEZero = vec4(greaterThanEqual(b, vec4(0.)));\n  return (bGTEZero * a) + ((vec4(1.0) - bGTEZero) * (a * (b + vec4(1.0))));\n";
	exports.ATAN2 = "\n  vec4 result = atan(a, b);\n  vec4 isNaN = min(vec4(isnan(a)) + vec4(isnan(b)), vec4(1.0));\n  " +
	    CHECK_NAN_SNIPPET + "\n  return result;\n";
	exports.EQUAL = "\n  return vec4(equal(a, b));\n";
	exports.NOT_EQUAL = "\n  return vec4(notEqual(a, b));\n";
	exports.LESS = "\n  return vec4(lessThan(a, b));\n";
	exports.LESS_EQUAL = "\n  return vec4(lessThanEqual(a, b));\n";
	exports.GREATER = "\n  return vec4(greaterThan(a, b));\n";
	exports.GREATER_EQUAL = "\n  return vec4(greaterThanEqual(a, b));\n";
	exports.LOGICAL_AND = "\n  return vec4(\n    vec4(greaterThanEqual(a, vec4(1.0))) *\n    vec4(greaterThanEqual(b, vec4(1.0))));\n";
	exports.LOGICAL_OR = "\n  return min(\n    vec4(greaterThanEqual(a, vec4(1.0))) +\n    vec4(greaterThanEqual(b, vec4(1.0))),\n    vec4(1.0));\n";
	exports.MAX = "\n  vec4 result = vec4(max(a, b));\n  vec4 isNaN = min(vec4(isnan(a)) + vec4(isnan(b)), vec4(1.0));\n  " +
	    CHECK_NAN_SNIPPET + "\n  return result;\n";
	exports.MIN = "\n  vec4 result = vec4(min(a, b));\n  vec4 isNaN = min(vec4(isnan(a)) + vec4(isnan(b)), vec4(1.0));\n  " +
	    CHECK_NAN_SNIPPET + "\n  return result;\n";
	exports.MOD = "\n  vec4 result = mod(a, b);\n  vec4 isNaN = vec4(equal(b, vec4(0.0)));\n  " +
	    CHECK_NAN_SNIPPET + "\n  return result;\n";
	var BinaryOpPackedProgram = /** @class */ (function () {
	    function BinaryOpPackedProgram(op, aShape, bShape, checkOutOfBounds) {
	        if (checkOutOfBounds === void 0) { checkOutOfBounds = false; }
	        this.variableNames = ['A', 'B'];
	        this.supportsBroadcasting = true;
	        this.packedInputs = true;
	        this.packedOutput = true;
	        this.outputShape =
	            broadcast_util.assertAndGetBroadcastShape(aShape, bShape);
	        var rank = this.outputShape.length;
	        var checkOutOfBoundsString = '';
	        if (checkOutOfBounds) {
	            if (rank === 0 || util_1.sizeFromShape(this.outputShape) === 1) {
	                checkOutOfBoundsString = "\n          result.y = 0.;\n          result.z = 0.;\n          result.w = 0.;\n        ";
	            }
	            else {
	                var dtype = shader_compiler_1.getCoordsDataType(rank);
	                checkOutOfBoundsString = "\n          " + dtype + " coords = getOutputCoords();\n        ";
	                if (rank === 1) {
	                    checkOutOfBoundsString += "\n            result.y = (coords + 1) >= " + this.outputShape[0] + " ? 0. : result.y;\n            result.z = 0.;\n            result.w = 0.;\n          ";
	                }
	                else {
	                    var channels = packing_util_1.getChannels('coords', rank);
	                    checkOutOfBoundsString += "\n            bool nextRowOutOfBounds =\n              (" + channels[rank - 2] + " + 1) >= " + this.outputShape[rank - 2] + ";\n            bool nextColOutOfBounds =\n              (" + channels[rank - 1] + " + 1) >= " + this.outputShape[rank - 1] + ";\n            result.y = nextColOutOfBounds ? 0. : result.y;\n            result.z = nextRowOutOfBounds ? 0. : result.z;\n            result.w = nextColOutOfBounds || nextRowOutOfBounds ? 0. : result.w;\n          ";
	                }
	            }
	        }
	        this.userCode = "\n      vec4 binaryOperation(vec4 a, vec4 b) {\n        " + op + "\n      }\n\n      void main() {\n        vec4 a = getAAtOutCoords();\n        vec4 b = getBAtOutCoords();\n\n        vec4 result = binaryOperation(a, b);\n        " + checkOutOfBoundsString + "\n\n        setOutput(result);\n      }\n    ";
	    }
	    return BinaryOpPackedProgram;
	}());
	exports.BinaryOpPackedProgram = BinaryOpPackedProgram;
	//# sourceMappingURL=binaryop_packed_gpu.js.map

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var erf_util = __webpack_require__(488);
	var selu_util = __webpack_require__(317);
	var UnaryOpProgram = /** @class */ (function () {
	    function UnaryOpProgram(aShape, opSnippet) {
	        this.variableNames = ['A'];
	        this.outputShape = aShape;
	        this.userCode = "\n      float unaryOperation(float x) {\n        " + opSnippet + "\n      }\n\n      void main() {\n        float x = getAAtOutCoords();\n        float y = unaryOperation(x);\n\n        setOutput(y);\n      }\n    ";
	    }
	    return UnaryOpProgram;
	}());
	exports.UnaryOpProgram = UnaryOpProgram;
	var CHECK_NAN_SNIPPET = "if (isnan(x)) return x;";
	exports.LINEAR = "return x;";
	exports.ABS = "return abs(x);";
	exports.RELU = CHECK_NAN_SNIPPET + "\n  return (x < 0.0) ? 0.0 : x;\n";
	exports.RELU6 = CHECK_NAN_SNIPPET + "\n  return (x < 0.0) ? 0.0 : min(6.0, x);\n";
	exports.ELU = "return (x >= 0.0) ? x : (exp(x) - 1.0);";
	exports.SELU = "\n  // Stable and Attracting Fixed Point (0, 1) for Normalized Weights.\n  // see: https://arxiv.org/abs/1706.02515\n  float scaleAlpha = " + selu_util.SELU_SCALEALPHA + ";\n  float scale = " + selu_util.SELU_SCALE + ";\n  return (x >= 0.0) ? scale * x : scaleAlpha * (exp(x) - 1.0);\n";
	function STEP(alpha) {
	    if (alpha === void 0) { alpha = 0.0; }
	    return CHECK_NAN_SNIPPET + ("\n    return x > 0.0 ? 1.0 : float(" + alpha + ");\n  ");
	}
	exports.STEP = STEP;
	exports.NEG = "return -x;";
	exports.CEIL = "return ceil(x);";
	exports.FLOOR = "return floor(x);";
	exports.SIGN = "\n  if (isnan(x)) { return 0.0; }\n  return sign(x);\n";
	exports.IS_NAN = "return float(isnan(x));";
	exports.IS_INF = "return float(isinf(x));";
	exports.IS_FINITE = "return float(!isnan(x) && !isinf(x));";
	exports.ROUND = "\n  // OpenGL ES does not support round function.\n  // The algorithm is based on banker's rounding.\n  float base = floor(x);\n  if ((x - base) < 0.5) {\n    return floor(x);\n  } else if ((x - base) > 0.5) {\n    return ceil(x);\n  } else {\n    if (mod(base, 2.0) == 0.0) {\n      return base;\n    } else {\n      return base + 1.0;\n    }\n  }\n";
	exports.EXP = "return exp(x);";
	exports.EXPM1 = "return exp(x) - 1.0;";
	exports.LOG = "if (x < 0.0) return NAN;\n  return log(x);";
	exports.LOG1P = "return log(1.0 + x);";
	exports.SQRT = "return sqrt(x);";
	exports.RSQRT = "return inversesqrt(x);";
	exports.SIGMOID = "return 1.0 / (1.0 + exp(-1.0 * x));";
	/**
	 * mirrors the implementation of tf.nn.softplus: https://goo.gl/vkcvwX
	 *
	 * epsilon is the difference between 1.0 and the next representable
	 * float. For a single precision 32 bit float this should be 2^-23, see:
	 * https://math.byu.edu/~schow/work/IEEEFloatingPoint.htm
	 *
	 * too_large = (x > -threshold) is value above which exp(x) may overflow
	 * but softplus(x) == x is within machine epsilon
	 *
	 * too_small = (x < threshold) is value below which exp(x) may underflow,
	 * but softplus(x) == exp(x) is within machine epsilon.
	 */
	exports.SOFTPLUS = "\n  float epsilon = 1.1920928955078125e-7;\n  float threshold = log(epsilon) + 2.0;\n\n  bool too_large = x > -threshold;\n  bool too_small = x < threshold;\n\n  float result;\n  float exp_x = exp(x);\n\n  if (too_large){\n    result = x;\n  }\n  else if (too_small){\n    result = exp_x;\n  }\n  else{\n    result = log(exp_x + 1.0);\n  }\n  return result;\n";
	exports.SIN = CHECK_NAN_SNIPPET + "\n  return sin(x);\n";
	exports.COS = CHECK_NAN_SNIPPET + "\n  return cos(x);\n";
	exports.TAN = "return tan(x);";
	exports.ASIN = CHECK_NAN_SNIPPET + "\n  if (abs(x) > 1.) {\n    return NAN;\n  }\n  return asin(x);\n";
	exports.ACOS = CHECK_NAN_SNIPPET + "\n  if (abs(x) > 1.) {\n    return NAN;\n  }\n  return acos(x);\n";
	exports.ATAN = CHECK_NAN_SNIPPET + "\n  return atan(x);\n";
	exports.SINH = "\n  float e2x = exp(x);\n  return (e2x - 1.0 / e2x) / 2.0;\n";
	exports.COSH = "\n  float e2x = exp(-x);\n  return (e2x + 1.0 / e2x) / 2.0;\n";
	exports.TANH = "\n  float e2x = exp(-2.0 * abs(x));\n  return sign(x) * (1.0 - e2x) / (1.0 + e2x);\n";
	exports.ASINH = CHECK_NAN_SNIPPET + "return log(x + sqrt(x * x + 1.0));";
	exports.ACOSH = CHECK_NAN_SNIPPET + "\n  if (x < 1.0) return NAN;\n  return log(x + sqrt(x * x - 1.0));";
	exports.ATANH = CHECK_NAN_SNIPPET + "\n  if ((x < -1.0) || (x > 1.0)) return NAN;\n  return (log(1.0 + x) - log(1.0 - x)) / 2.0;";
	exports.ERF = "\n  // Error function is calculated approximately with elementary function.\n  // See \"Handbook of Mathematical Functions with Formulas,\n  // Graphs, and Mathematical Tables\", Abramowitz and Stegun.\n  float p = " + erf_util.ERF_P + ";\n  float a1 = " + erf_util.ERF_A1 + ";\n  float a2 = " + erf_util.ERF_A2 + ";\n  float a3 = " + erf_util.ERF_A3 + ";\n  float a4 = " + erf_util.ERF_A4 + ";\n  float a5 = " + erf_util.ERF_A5 + ";\n\n  float sign = sign(x);\n  x = abs(x);\n  float t = 1.0 / (1.0 + p * x);\n  return sign * (1.0 - (((((a5*t + a4)*t) + a3)*t + a2)*t + a1)*t*exp(-x*x));\n";
	exports.SQUARE = "return x * x;";
	exports.RECIPROCAL = "return 1.0 / x;";
	exports.LOGICAL_NOT = "return float(!(x >= 1.0));";
	exports.TO_INT = "return float(int(x));";
	exports.CLONE = 'return x;';
	//# sourceMappingURL=unaryop_gpu.js.map

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** An implementation of the Where kernel shared between cpu and webgl */
	var array_ops_1 = __webpack_require__(89);
	function whereImpl(condShape, condVals) {
	    var indices = [];
	    for (var i = 0; i < condVals.length; i++) {
	        if (condVals[i]) {
	            indices.push(i);
	        }
	    }
	    var inBuffer = array_ops_1.buffer(condShape, 'int32');
	    var out = array_ops_1.buffer([indices.length, condShape.length], 'int32');
	    for (var i = 0; i < indices.length; i++) {
	        var loc = inBuffer.indexToLoc(indices[i]);
	        var offset = i * condShape.length;
	        out.values.set(loc, offset);
	    }
	    return out.toTensor();
	}
	exports.whereImpl = whereImpl;
	//# sourceMappingURL=where_impl.js.map

/***/ },
/* 311 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function isMobile() {
	    // tslint:disable-next-line:no-any
	    var a = navigator.userAgent || navigator.vendor || window.opera;
	    // tslint:disable-next-line:max-line-length
	    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i
	        .test(a) ||
	        // tslint:disable-next-line:max-line-length
	        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
	            .test(a.substr(0, 4));
	}
	exports.isMobile = isMobile;
	function isBrowser() {
	    return (typeof window !== 'undefined' && window.document != null) ||
	        //@ts-ignore
	        (typeof WorkerGlobalScope !== 'undefined');
	}
	exports.isBrowser = isBrowser;
	//# sourceMappingURL=device_util.js.map

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Classes and functions for model management across multiple storage mediums.
	 *
	 * Supported client actions:
	 * - Listing models on all registered storage mediums.
	 * - Remove model by URL from any registered storage mediums, by using URL
	 *   string.
	 * - Moving or copying model from one path to another in the same medium or from
	 *   one medium to another, by using URL strings.
	 */
	var util_1 = __webpack_require__(10);
	var router_registry_1 = __webpack_require__(151);
	var URL_SCHEME_SUFFIX = '://';
	var ModelStoreManagerRegistry = /** @class */ (function () {
	    function ModelStoreManagerRegistry() {
	        this.managers = {};
	    }
	    ModelStoreManagerRegistry.getInstance = function () {
	        if (ModelStoreManagerRegistry.instance == null) {
	            ModelStoreManagerRegistry.instance = new ModelStoreManagerRegistry();
	        }
	        return ModelStoreManagerRegistry.instance;
	    };
	    /**
	     * Register a save-handler router.
	     *
	     * @param saveRouter A function that maps a URL-like string onto an instance
	     * of `IOHandler` with the `save` method defined or `null`.
	     */
	    ModelStoreManagerRegistry.registerManager = function (scheme, manager) {
	        util_1.assert(scheme != null, function () { return 'scheme must not be undefined or null.'; });
	        if (scheme.endsWith(URL_SCHEME_SUFFIX)) {
	            scheme = scheme.slice(0, scheme.indexOf(URL_SCHEME_SUFFIX));
	        }
	        util_1.assert(scheme.length > 0, function () { return 'scheme must not be an empty string.'; });
	        var registry = ModelStoreManagerRegistry.getInstance();
	        util_1.assert(registry.managers[scheme] == null, function () { return "A model store manager is already registered for scheme '" + scheme + "'."; });
	        registry.managers[scheme] = manager;
	    };
	    ModelStoreManagerRegistry.getManager = function (scheme) {
	        var manager = this.getInstance().managers[scheme];
	        if (manager == null) {
	            throw new Error("Cannot find model manager for scheme '" + scheme + "'");
	        }
	        return manager;
	    };
	    ModelStoreManagerRegistry.getSchemes = function () {
	        return Object.keys(this.getInstance().managers);
	    };
	    return ModelStoreManagerRegistry;
	}());
	exports.ModelStoreManagerRegistry = ModelStoreManagerRegistry;
	/**
	 * Helper method for parsing a URL string into a scheme and a path.
	 *
	 * @param url E.g., 'localstorage://my-model'
	 * @returns A dictionary with two fields: scheme and path.
	 *   Scheme: e.g., 'localstorage' in the example above.
	 *   Path: e.g., 'my-model' in the example above.
	 */
	function parseURL(url) {
	    if (url.indexOf(URL_SCHEME_SUFFIX) === -1) {
	        throw new Error("The url string provided does not contain a scheme. " +
	            "Supported schemes are: " +
	            ("" + ModelStoreManagerRegistry.getSchemes().join(',')));
	    }
	    return {
	        scheme: url.split(URL_SCHEME_SUFFIX)[0],
	        path: url.split(URL_SCHEME_SUFFIX)[1],
	    };
	}
	function cloneModelInternal(sourceURL, destURL, deleteSource) {
	    if (deleteSource === void 0) { deleteSource = false; }
	    return __awaiter(this, void 0, void 0, function () {
	        var loadHandlers, loadHandler, saveHandlers, saveHandler, sourceScheme, sourcePath, sameMedium, modelArtifacts, saveResult;
	        return __generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    util_1.assert(sourceURL !== destURL, function () { return "Old path and new path are the same: '" + sourceURL + "'"; });
	                    loadHandlers = router_registry_1.IORouterRegistry.getLoadHandlers(sourceURL);
	                    util_1.assert(loadHandlers.length > 0, function () { return "Copying failed because no load handler is found for source URL " + sourceURL + "."; });
	                    util_1.assert(loadHandlers.length < 2, function () { return "Copying failed because more than one (" + loadHandlers.length + ") " +
	                        ("load handlers for source URL " + sourceURL + "."); });
	                    loadHandler = loadHandlers[0];
	                    saveHandlers = router_registry_1.IORouterRegistry.getSaveHandlers(destURL);
	                    util_1.assert(saveHandlers.length > 0, function () { return "Copying failed because no save handler is found for destination " +
	                        ("URL " + destURL + "."); });
	                    util_1.assert(saveHandlers.length < 2, function () { return "Copying failed because more than one (" + loadHandlers.length + ") " +
	                        ("save handlers for destination URL " + destURL + "."); });
	                    saveHandler = saveHandlers[0];
	                    sourceScheme = parseURL(sourceURL).scheme;
	                    sourcePath = parseURL(sourceURL).path;
	                    sameMedium = sourceScheme === parseURL(sourceURL).scheme;
	                    return [4 /*yield*/, loadHandler.load()];
	                case 1:
	                    modelArtifacts = _a.sent();
	                    if (!(deleteSource && sameMedium)) return [3 /*break*/, 3];
	                    return [4 /*yield*/, ModelStoreManagerRegistry.getManager(sourceScheme)
	                            .removeModel(sourcePath)];
	                case 2:
	                    _a.sent();
	                    _a.label = 3;
	                case 3: return [4 /*yield*/, saveHandler.save(modelArtifacts)];
	                case 4:
	                    saveResult = _a.sent();
	                    if (!(deleteSource && !sameMedium)) return [3 /*break*/, 6];
	                    return [4 /*yield*/, ModelStoreManagerRegistry.getManager(sourceScheme)
	                            .removeModel(sourcePath)];
	                case 5:
	                    _a.sent();
	                    _a.label = 6;
	                case 6: return [2 /*return*/, saveResult.modelArtifactsInfo];
	            }
	        });
	    });
	}
	/**
	 * List all models stored in registered storage mediums.
	 *
	 * For a web browser environment, the registered mediums are Local Storage and
	 * IndexedDB.
	 *
	 * ```js
	 * // First create and save a model.
	 * const model = tf.sequential();
	 * model.add(tf.layers.dense(
	 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
	 * await model.save('localstorage://demo/management/model1');
	 *
	 * // Then list existing models.
	 * console.log(JSON.stringify(await tf.io.listModels()));
	 *
	 * // Delete the model.
	 * await tf.io.removeModel('localstorage://demo/management/model1');
	 *
	 * // List models again.
	 * console.log(JSON.stringify(await tf.io.listModels()));
	 * ```
	 *
	 * @returns A `Promise` of a dictionary mapping URLs of existing models to
	 * their model artifacts info. URLs include medium-specific schemes, e.g.,
	 *   'indexeddb://my/model/1'. Model artifacts info include type of the
	 * model's topology, byte sizes of the topology, weights, etc.
	 */
	/**
	 * @doc {
	 *   heading: 'Models',
	 *   subheading: 'Management',
	 *   namespace: 'io',
	 *   ignoreCI: true
	 * }
	 */
	function listModels() {
	    return __awaiter(this, void 0, void 0, function () {
	        var schemes, out, _i, schemes_1, scheme, schemeOut, path, url;
	        return __generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    schemes = ModelStoreManagerRegistry.getSchemes();
	                    out = {};
	                    _i = 0, schemes_1 = schemes;
	                    _a.label = 1;
	                case 1:
	                    if (!(_i < schemes_1.length)) return [3 /*break*/, 4];
	                    scheme = schemes_1[_i];
	                    return [4 /*yield*/, ModelStoreManagerRegistry.getManager(scheme).listModels()];
	                case 2:
	                    schemeOut = _a.sent();
	                    for (path in schemeOut) {
	                        url = scheme + URL_SCHEME_SUFFIX + path;
	                        out[url] = schemeOut[path];
	                    }
	                    _a.label = 3;
	                case 3:
	                    _i++;
	                    return [3 /*break*/, 1];
	                case 4: return [2 /*return*/, out];
	            }
	        });
	    });
	}
	exports.listModels = listModels;
	/**
	 * Remove a model specified by URL from a reigstered storage medium.
	 *
	 * ```js
	 * // First create and save a model.
	 * const model = tf.sequential();
	 * model.add(tf.layers.dense(
	 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
	 * await model.save('localstorage://demo/management/model1');
	 *
	 * // Then list existing models.
	 * console.log(JSON.stringify(await tf.io.listModels()));
	 *
	 * // Delete the model.
	 * await tf.io.removeModel('localstorage://demo/management/model1');
	 *
	 * // List models again.
	 * console.log(JSON.stringify(await tf.io.listModels()));
	 * ```
	 *
	 * @param url A URL to a stored model, with a scheme prefix, e.g.,
	 *   'localstorage://my-model-1', 'indexeddb://my/model/2'.
	 * @returns ModelArtifactsInfo of the deleted model (if and only if deletion
	 *   is successful).
	 * @throws Error if deletion fails, e.g., if no model exists at `path`.
	 */
	/**
	 * @doc {
	 *   heading: 'Models',
	 *   subheading: 'Management',
	 *   namespace: 'io',
	 *   ignoreCI: true
	 * }
	 */
	function removeModel(url) {
	    return __awaiter(this, void 0, void 0, function () {
	        var schemeAndPath, manager;
	        return __generator(this, function (_a) {
	            schemeAndPath = parseURL(url);
	            manager = ModelStoreManagerRegistry.getManager(schemeAndPath.scheme);
	            return [2 /*return*/, manager.removeModel(schemeAndPath.path)];
	        });
	    });
	}
	exports.removeModel = removeModel;
	/**
	 * Copy a model from one URL to another.
	 *
	 * This function supports:
	 *
	 * 1. Copying within a storage medium, e.g.,
	 *    `tf.io.copyModel('localstorage://model-1', 'localstorage://model-2')`
	 * 2. Copying between two storage mediums, e.g.,
	 *    `tf.io.copyModel('localstorage://model-1', 'indexeddb://model-1')`
	 *
	 * ```js
	 * // First create and save a model.
	 * const model = tf.sequential();
	 * model.add(tf.layers.dense(
	 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
	 * await model.save('localstorage://demo/management/model1');
	 *
	 * // Then list existing models.
	 * console.log(JSON.stringify(await tf.io.listModels()));
	 *
	 * // Copy the model, from Local Storage to IndexedDB.
	 * await tf.io.copyModel(
	 *     'localstorage://demo/management/model1',
	 *     'indexeddb://demo/management/model1');
	 *
	 * // List models again.
	 * console.log(JSON.stringify(await tf.io.listModels()));
	 *
	 * // Remove both models.
	 * await tf.io.removeModel('localstorage://demo/management/model1');
	 * await tf.io.removeModel('indexeddb://demo/management/model1');
	 * ```
	 *
	 * @param sourceURL Source URL of copying.
	 * @param destURL Destination URL of copying.
	 * @returns ModelArtifactsInfo of the copied model (if and only if copying
	 *   is successful).
	 * @throws Error if copying fails, e.g., if no model exists at `sourceURL`, or
	 *   if `oldPath` and `newPath` are identical.
	 */
	/**
	 * @doc {
	 *   heading: 'Models',
	 *   subheading: 'Management',
	 *   namespace: 'io',
	 *   ignoreCI: true
	 * }
	 */
	function copyModel(sourceURL, destURL) {
	    return __awaiter(this, void 0, void 0, function () {
	        var deleteSource;
	        return __generator(this, function (_a) {
	            deleteSource = false;
	            return [2 /*return*/, cloneModelInternal(sourceURL, destURL, deleteSource)];
	        });
	    });
	}
	exports.copyModel = copyModel;
	/**
	 * Move a model from one URL to another.
	 *
	 * This function supports:
	 *
	 * 1. Moving within a storage medium, e.g.,
	 *    `tf.io.moveModel('localstorage://model-1', 'localstorage://model-2')`
	 * 2. Moving between two storage mediums, e.g.,
	 *    `tf.io.moveModel('localstorage://model-1', 'indexeddb://model-1')`
	 *
	 * ```js
	 * // First create and save a model.
	 * const model = tf.sequential();
	 * model.add(tf.layers.dense(
	 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
	 * await model.save('localstorage://demo/management/model1');
	 *
	 * // Then list existing models.
	 * console.log(JSON.stringify(await tf.io.listModels()));
	 *
	 * // Move the model, from Local Storage to IndexedDB.
	 * await tf.io.moveModel(
	 *     'localstorage://demo/management/model1',
	 *     'indexeddb://demo/management/model1');
	 *
	 * // List models again.
	 * console.log(JSON.stringify(await tf.io.listModels()));
	 *
	 * // Remove the moved model.
	 * await tf.io.removeModel('indexeddb://demo/management/model1');
	 * ```
	 *
	 * @param sourceURL Source URL of moving.
	 * @param destURL Destination URL of moving.
	 * @returns ModelArtifactsInfo of the copied model (if and only if copying
	 *   is successful).
	 * @throws Error if moving fails, e.g., if no model exists at `sourceURL`, or
	 *   if `oldPath` and `newPath` are identical.
	 */
	/**
	 * @doc {
	 *   heading: 'Models',
	 *   subheading: 'Management',
	 *   namespace: 'io',
	 *   ignoreCI: true
	 * }
	 */
	function moveModel(sourceURL, destURL) {
	    return __awaiter(this, void 0, void 0, function () {
	        var deleteSource;
	        return __generator(this, function (_a) {
	            deleteSource = true;
	            return [2 /*return*/, cloneModelInternal(sourceURL, destURL, deleteSource)];
	        });
	    });
	}
	exports.moveModel = moveModel;
	//# sourceMappingURL=model_management.js.map

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var environment_1 = __webpack_require__(28);
	function warn() {
	    var msg = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        msg[_i] = arguments[_i];
	    }
	    if (!environment_1.env().getBool('IS_TEST')) {
	        console.warn.apply(console, msg);
	    }
	}
	exports.warn = warn;
	function log() {
	    var msg = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        msg[_i] = arguments[_i];
	    }
	    if (!environment_1.env().getBool('IS_TEST')) {
	        console.log.apply(console, msg);
	    }
	}
	exports.log = log;
	//# sourceMappingURL=log.js.map

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_util_env_1 = __webpack_require__(17);
	var util = __webpack_require__(10);
	var conv_util = __webpack_require__(238);
	var operation_1 = __webpack_require__(18);
	/**
	 * Computes a 1D convolution over the input x.
	 *
	 * @param x The input tensor, of rank 3 or rank 2, of shape
	 *     `[batch, width, inChannels]`. If rank 2, batch of 1 is assumed.
	 * @param filter The filter, rank 3, of shape
	 *     `[filterWidth, inDepth, outDepth]`.
	 * @param stride The number of entries by which the filter is moved right at
	 *     each step.
	 * @param pad The type of padding algorithm.
	 *    - `same` and stride 1: output will be of same size as input,
	 *       regardless of filter size.
	 *    - `valid`: output will be smaller than input if filter is larger
	 *       than 1x1.
	 *   - For more info, see this guide:
	 *     [https://www.tensorflow.org/api_guides/python/nn#Convolution](
	 *          https://www.tensorflow.org/api_guides/python/nn#Convolution)
	 * @param dataFormat An optional string from "NWC", "NCW". Defaults to "NWC",
	 *     the data is stored in the order of [batch, in_width, in_channels]. Only
	 *     "NWC" is currently supported.
	 * @param dilation The dilation rate in which we sample input values in
	 *     atrous convolution. Defaults to `1`. If it is greater than 1, then
	 *     stride must be `1`.
	 * @param dimRoundingMode The rounding mode used when computing output
	 *     dimensions if pad is a number. If none is provided, it will not round
	 *     and error if the output is of fractional size.
	 */
	/** @doc {heading: 'Operations', subheading: 'Convolution'} */
	function conv1d_(x, filter, stride, pad, dataFormat, dilation, dimRoundingMode) {
	    if (dataFormat === void 0) { dataFormat = 'NWC'; }
	    if (dilation === void 0) { dilation = 1; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'conv1d');
	    var $filter = tensor_util_env_1.convertToTensor(filter, 'filter', 'conv1d');
	    var x3D = $x;
	    var reshapedTo3D = false;
	    if ($x.rank === 2) {
	        reshapedTo3D = true;
	        x3D = $x.as3D(1, $x.shape[0], $x.shape[1]);
	    }
	    util.assert(x3D.rank === 3, function () { return "Error in conv1d: input must be rank 3, but got rank " + x3D.rank + "."; });
	    util.assert($filter.rank === 3, function () { return "Error in conv1d: filter must be rank 3, but got rank " +
	        ($filter.rank + "."); });
	    if (dimRoundingMode != null) {
	        util.assert(util.isInt(pad), function () { return "Error in conv1d: pad must be an integer when using, " +
	            ("dimRoundingMode " + dimRoundingMode + " but got pad " + pad + "."); });
	    }
	    util.assert(x3D.shape[2] === $filter.shape[1], function () { return "Error in conv1d: depth of input (" + x3D.shape[2] + ") must match " +
	        ("input depth for filter " + $filter.shape[1] + "."); });
	    util.assert(conv_util.eitherStridesOrDilationsAreOne(stride, dilation), function () { return 'Error in conv1D: Either stride or dilation must be 1. ' +
	        ("Got stride " + stride + " and dilation '" + dilation + "'"); });
	    util.assert(dataFormat === 'NWC', function () { return "Error in conv1d: got dataFormat of " + dataFormat + " but only NWC is currently supported."; });
	    var filter4D = $filter.as4D(1, $filter.shape[0], $filter.shape[1], $filter.shape[2]);
	    var input4D = x3D.as4D(x3D.shape[0], 1, x3D.shape[1], x3D.shape[2]);
	    var strides = [1, stride];
	    var dilations = [1, dilation];
	    var conv2dDataFormat = 'NHWC';
	    var res = exports.conv2d(input4D, filter4D, strides, pad, conv2dDataFormat, dilations, dimRoundingMode);
	    if (reshapedTo3D) {
	        return res.as2D(res.shape[2], res.shape[3]);
	    }
	    return res.as3D(res.shape[0], res.shape[2], res.shape[3]);
	}
	/**
	 * Computes a 2D convolution over the input x.
	 *
	 * @param x The input tensor, of rank 4 or rank 3, of shape
	 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
	 * assumed.
	 * @param filter The filter, rank 4, of shape
	 *     `[filterHeight, filterWidth, inDepth, outDepth]`.
	 * @param strides The strides of the convolution: `[strideHeight,
	 * strideWidth]`.
	 * @param pad The type of padding algorithm.
	 *    - `same` and stride 1: output will be of same size as input,
	 *       regardless of filter size.
	 *    - `valid`: output will be smaller than input if filter is larger
	 *       than 1x1.
	 *   - For more info, see this guide:
	 *     [https://www.tensorflow.org/api_guides/python/nn#Convolution](
	 *          https://www.tensorflow.org/api_guides/python/nn#Convolution)
	 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
	 *     "NHWC". Specify the data format of the input and output data. With the
	 *     default format "NHWC", the data is stored in the order of: [batch,
	 *     height, width, channels].
	 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
	 *     in which we sample input values across the height and width dimensions
	 *     in atrous convolution. Defaults to `[1, 1]`. If `dilations` is a single
	 *     number, then `dilationHeight == dilationWidth`. If it is greater than
	 *     1, then all values of `strides` must be 1.
	 * @param dimRoundingMode The rounding mode used when computing output
	 *     dimensions if pad is a number. If none is provided, it will not round
	 *     and error if the output is of fractional size.
	 */
	/** @doc {heading: 'Operations', subheading: 'Convolution'} */
	function conv2d_(x, filter, strides, pad, dataFormat, dilations, dimRoundingMode) {
	    if (dataFormat === void 0) { dataFormat = 'NHWC'; }
	    if (dilations === void 0) { dilations = [1, 1]; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'conv2d');
	    var $filter = tensor_util_env_1.convertToTensor(filter, 'filter', 'conv2d');
	    var x4D = $x;
	    var reshapedTo4D = false;
	    if ($x.rank === 3) {
	        reshapedTo4D = true;
	        x4D = $x.as4D(1, $x.shape[0], $x.shape[1], $x.shape[2]);
	    }
	    util.assert(x4D.rank === 4, function () { return "Error in conv2d: input must be rank 4, but got rank " + x4D.rank + "."; });
	    util.assert($filter.rank === 4, function () { return "Error in conv2d: filter must be rank 4, but got rank " +
	        ($filter.rank + "."); });
	    if (dimRoundingMode != null) {
	        util.assert(util.isInt(pad), function () { return "Error in conv2d: pad must be an integer when using, " +
	            ("dimRoundingMode " + dimRoundingMode + " but got pad " + pad + "."); });
	    }
	    var inDepth = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
	    util.assert(inDepth === $filter.shape[2], function () { return "Error in conv2d: depth of input (" + inDepth + ") must match " +
	        ("input depth for filter " + $filter.shape[2] + "."); });
	    util.assert(conv_util.eitherStridesOrDilationsAreOne(strides, dilations), function () { return 'Error in conv2D: Either strides or dilations must be 1. ' +
	        ("Got strides " + strides + " and dilations '" + dilations + "'"); });
	    var $dataFormat = conv_util.convertConv2DDataFormat(dataFormat);
	    var convInfo = conv_util.computeConv2DInfo(x4D.shape, $filter.shape, strides, dilations, pad, dimRoundingMode, false, $dataFormat);
	    var grad = function (dy, saved) {
	        var _a = saved, $filter = _a[0], x4D = _a[1];
	        util.assert(conv_util.tupleValuesAreOne(dilations), function () { return 'Error in gradient of conv2D: dilation rates greater than 1 ' +
	            ("are not yet supported in gradients. Got dilations '" + dilations + "'"); });
	        return {
	            x: function () { return exports.conv2dDerInput(x4D.shape, dy, $filter, strides, pad, dataFormat); },
	            filter: function () {
	                return exports.conv2dDerFilter(x4D, dy, $filter.shape, strides, pad, dataFormat);
	            }
	        };
	    };
	    var inputsToSave = [$filter, x4D];
	    var res = engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.conv2d(x4D, $filter, convInfo);
	        save([$filter, x4D]);
	        return res;
	    }, { x: x4D, filter: $filter }, grad, 'Conv2D', convInfo, inputsToSave);
	    if (reshapedTo4D) {
	        return res.as3D(res.shape[1], res.shape[2], res.shape[3]);
	    }
	    return res;
	}
	/**
	 * Computes the derivative of the input of a 2D convolution.
	 *
	 * @param xShape The shape of the input: [batch, height, width, inDepth].
	 * If length of 3, batch of 1 is assumed.
	 * @param dy The derivative of the output, of rank 4 or rank 3 of shape
	 *   `[batch, outHeight, outWidth, outDepth]`. If rank 3, batch of 1 is
	 * assumed.
	 * @param filter The filter, rank 4, of shape
	 *     `[filterHeight, filterWidth, inDepth, outDepth]`.
	 * @param strides The strides of the convolution: `[strideHeight,
	 * strideWidth]`.
	 * @param pad The type of padding algorithm used:
	 *    - `same` and stride 1: output will be of same size as input,
	 *       regardless of filter size.
	 *    - `valid`: output will be smaller than input if filter is larger
	 *       than 1x1.
	 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
	 *     "NHWC". Specify the data format of the input and output data. With the
	 *     default format "NHWC", the data is stored in the order of: [batch,
	 *     height, width, channels].
	 * @param dimRoundingMode The rounding mode used when computing output
	 *     dimensions if pad is a number. If none is provided, it will not round
	 *     and error if the output is of fractional size.
	 */
	function conv2dDerInput_(xShape, dy, filter, strides, pad, dataFormat, dimRoundingMode) {
	    if (dataFormat === void 0) { dataFormat = 'NHWC'; }
	    util.assert(xShape.length === dy.rank, function () { return "Length of inShape " +
	        ("(" + xShape.length + ") and rank of dy (" + dy.rank + ") must match"); });
	    var xShape4D = xShape;
	    var dy4D = dy;
	    var reshapedTo4D = false;
	    if (dy.rank === 3) {
	        reshapedTo4D = true;
	        dy4D = dy.as4D(1, dy.shape[0], dy.shape[1], dy.shape[2]);
	        xShape4D = [1, xShape[0], xShape[1], xShape[2]];
	    }
	    util.assert(xShape4D.length === 4, function () {
	        return "Error in conv2dDerInput: inShape must be length 4, but got length " +
	            (xShape4D.length + ".");
	    });
	    util.assert(dy4D.rank === 4, function () { return "Error in conv2dDerInput: dy must be rank 4, but got " +
	        ("rank " + dy4D.rank); });
	    util.assert(filter.rank === 4, function () { return "Error in conv2dDerInput: filter must be rank 4, but got " +
	        ("rank " + filter.rank); });
	    var inDepth = dataFormat === 'NHWC' ? xShape4D[3] : xShape4D[1];
	    var outDepth = dataFormat === 'NHWC' ? dy4D.shape[3] : dy4D.shape[1];
	    util.assert(inDepth === filter.shape[2], function () { return "Error in conv2dDerInput: depth of input (" + inDepth + ") must " +
	        ("match input depth for filter " + filter.shape[2] + "."); });
	    util.assert(outDepth === filter.shape[3], function () { return "Error in conv2dDerInput: depth of output (" + outDepth + ") must " +
	        ("match output depth for filter " + filter.shape[3] + "."); });
	    if (dimRoundingMode != null) {
	        util.assert(util.isInt(pad), function () { return "Error in conv2dDerInput: pad must be an integer when using, " +
	            ("dimRoundingMode " + dimRoundingMode + " but got pad " + pad + "."); });
	    }
	    var dilations = 1;
	    var grad = function (ddx, saved) {
	        var filter = saved[0], dy4D = saved[1];
	        return {
	            dy4D: function () { return exports.conv2d(ddx, filter, strides, pad, dataFormat, dilations, dimRoundingMode); },
	            filter: function () { return exports.conv2dDerFilter(ddx, dy4D, filter.shape, strides, pad, dataFormat, dimRoundingMode); }
	        };
	    };
	    var $dataFormat = conv_util.convertConv2DDataFormat(dataFormat);
	    var convInfo = conv_util.computeConv2DInfo(xShape4D, filter.shape, strides, dilations, pad, dimRoundingMode, false, $dataFormat);
	    var res = engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.conv2dDerInput(dy4D, filter, convInfo);
	        save([filter, dy4D]);
	        return res;
	    }, { dy4D: dy4D, filter: filter }, grad);
	    if (reshapedTo4D) {
	        return res.as3D(res.shape[1], res.shape[2], res.shape[3]);
	    }
	    return res;
	}
	/**
	 * Computes the derivative of the filter of a 2D convolution.
	 *
	 * @param x The input tensor, of rank 4 or rank 3 of shape
	 *     [batch, height, width, inChannels]. If rank 3, batch of 1 is assumed.
	 * @param dy The dy image, of rank 4 or rank 3, of shape
	 *     [batch, height, width, outDepth]. If rank 3, batch of 1 is assumed.
	 * @param filterShape The shape of the filter, length 4,
	 *     [filterHeight, filterWidth, inDepth, outDepth].
	 * @param strides The strides of the convolution: [strideHeight,
	 * strideWidth].
	 * @param pad A string from: 'same', 'valid'. The type of padding algorithm
	 *     used in the forward prop of the op.
	 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
	 *     "NHWC". Specify the data format of the input and output data. With the
	 *     default format "NHWC", the data is stored in the order of: [batch,
	 *     height, width, channels].
	 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. The
	 *     rounding mode used when computing output dimensions if pad is a
	 *     number. If none is provided, it will not round and error if the output
	 *     is of fractional size.
	 */
	function conv2dDerFilter_(x, dy, filterShape, strides, pad, dataFormat, dimRoundingMode) {
	    if (dataFormat === void 0) { dataFormat = 'NHWC'; }
	    var x4D = x;
	    if (x.rank === 3) {
	        x4D = x.as4D(1, x.shape[0], x.shape[1], x.shape[2]);
	    }
	    var dy4D = dy;
	    if (dy4D.rank === 3) {
	        dy4D = dy.as4D(1, dy.shape[0], dy.shape[1], dy.shape[2]);
	    }
	    util.assert(x4D.rank === 4, function () { return "Error in conv2dDerFilter: input must be rank 4, but got shape " +
	        (x4D.shape + "."); });
	    util.assert(dy4D.rank === 4, function () { return "Error in conv2dDerFilter: dy must be rank 4, but got shape " +
	        (dy4D.shape + "."); });
	    util.assert(filterShape.length === 4, function () { return "Error in conv2dDerFilter: filterShape must be length 4, but got " +
	        (filterShape + "."); });
	    var inDepth = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
	    var outDepth = dataFormat === 'NHWC' ? dy4D.shape[3] : dy4D.shape[1];
	    util.assert(inDepth === filterShape[2], function () { return "Error in conv2dDerFilter: depth of input " + inDepth + ") must " +
	        ("match input depth in filter (" + filterShape[2] + "."); });
	    util.assert(outDepth === filterShape[3], function () { return "Error in conv2dDerFilter: depth of dy (" + outDepth + ") must " +
	        ("match output depth for filter (" + filterShape[3] + ")."); });
	    if (dimRoundingMode != null) {
	        util.assert(util.isInt(pad), function () { return "Error in conv2dDerFilter: pad must be an integer when using, " +
	            ("dimRoundingMode " + dimRoundingMode + " but got pad " + pad + "."); });
	    }
	    var dilations = 1;
	    var $dataFormat = conv_util.convertConv2DDataFormat(dataFormat);
	    var convInfo = conv_util.computeConv2DInfo(x4D.shape, filterShape, strides, dilations, pad, dimRoundingMode, false, $dataFormat);
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.conv2dDerFilter(x4D, dy4D, convInfo); }, { x4D: x4D, dy4D: dy4D });
	}
	/**
	 * Computes the transposed 2D convolution of an image, also known as a
	 * deconvolution.
	 *
	 * @param x The input image, of rank 4 or rank 3, of shape
	 *   `[batch, height, width, inDepth]`. If rank 3, batch of 1 is assumed.
	 * @param filter The filter, rank 4, of shape
	 *     `[filterHeight, filterWidth, outDepth, inDepth]`.
	 *     `inDepth` must match `inDepth` in `x`.
	 * @param outputShape Output shape, of rank 4 or rank 3:
	 *     `[batch, height, width, outDepth]`. If rank 3, batch of 1 is assumed.
	 * @param strides The strides of the original convolution:
	 *     `[strideHeight, strideWidth]`.
	 * @param pad  The type of padding algorithm used in the non-transpose version
	 *    of the op.
	 * @param dimRoundingMode The rounding mode used when computing output
	 *    dimensions if pad is a number. If none is provided, it will not round
	 *    and error if the output is of fractional size.
	 */
	/** @doc {heading: 'Operations', subheading: 'Convolution'} */
	function conv2dTranspose_(x, filter, outputShape, strides, pad, dimRoundingMode) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'conv2dTranspose');
	    var $filter = tensor_util_env_1.convertToTensor(filter, 'filter', 'conv2dTranspose');
	    return conv2dDerInput_(outputShape, $x, $filter, strides, pad, 'NHWC', dimRoundingMode);
	}
	/**
	 * Depthwise 2D convolution.
	 *
	 * Given a 4D `input` array and a `filter` array of shape
	 * `[filterHeight, filterWidth, inChannels, channelMultiplier]` containing
	 * `inChannels` convolutional filters of depth 1, this op applies a
	 * different filter to each input channel (expanding from 1 channel to
	 * `channelMultiplier` channels for each), then concatenates the results
	 * together. The output has `inChannels * channelMultiplier` channels.
	 *
	 * See
	 * [https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d](
	 *     https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d)
	 * for more details.
	 *
	 * @param x The input tensor, of rank 4 or rank 3, of shape
	 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
	 * assumed.
	 * @param filter The filter tensor, rank 4, of shape
	 *     `[filterHeight, filterWidth, inChannels, channelMultiplier]`.
	 * @param strides The strides of the convolution: `[strideHeight,
	 * strideWidth]`. If strides is a single number, then `strideHeight ==
	 * strideWidth`.
	 * @param pad The type of padding algorithm.
	 *   - `same` and stride 1: output will be of same size as input,
	 *       regardless of filter size.
	 *   - `valid`: output will be smaller than input if filter is larger
	 *       than 1x1.
	 *   - For more info, see this guide:
	 *     [https://www.tensorflow.org/api_guides/python/nn#Convolution](
	 *          https://www.tensorflow.org/api_guides/python/nn#Convolution)
	 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
	 *     in which we sample input values across the height and width dimensions
	 *     in atrous convolution. Defaults to `[1, 1]`. If `rate` is a single
	 *     number, then `dilationHeight == dilationWidth`. If it is greater than
	 *     1, then all values of `strides` must be 1.
	 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
	 *     "NHWC". Specify the data format of the input and output data. With the
	 *     default format "NHWC", the data is stored in the order of: [batch,
	 *     height, width, channels]. Only "NHWC" is currently supported.
	 * @param dimRoundingMode The rounding mode used when computing output
	 *     dimensions if pad is a number. If none is provided, it will not round
	 *     and error if the output is of fractional size.
	 */
	/** @doc {heading: 'Operations', subheading: 'Convolution'} */
	function depthwiseConv2d_(x, filter, strides, pad, dataFormat, dilations, dimRoundingMode) {
	    if (dataFormat === void 0) { dataFormat = 'NHWC'; }
	    if (dilations === void 0) { dilations = [1, 1]; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'depthwiseConv2d');
	    var $filter = tensor_util_env_1.convertToTensor(filter, 'filter', 'depthwiseConv2d');
	    var x4D = $x;
	    var reshapedTo4D = false;
	    if ($x.rank === 3) {
	        reshapedTo4D = true;
	        x4D = $x.as4D(1, $x.shape[0], $x.shape[1], $x.shape[2]);
	    }
	    util.assert(x4D.rank === 4, function () { return "Error in depthwiseConv2d: input must be rank 4, but got " +
	        ("rank " + x4D.rank + "."); });
	    util.assert($filter.rank === 4, function () { return "Error in depthwiseConv2d: filter must be rank 4, but got rank " +
	        ($filter.rank + "."); });
	    util.assert(x4D.shape[3] === $filter.shape[2], function () { return "Error in depthwiseConv2d: number of input channels " +
	        ("(" + x4D.shape[3] + ") must match the inChannels dimension in ") +
	        ("filter " + $filter.shape[2] + "."); });
	    if (dilations == null) {
	        dilations = [1, 1];
	    }
	    util.assert(conv_util.eitherStridesOrDilationsAreOne(strides, dilations), function () {
	        return 'Error in depthwiseConv2d: Either strides or dilations must be 1. ' +
	            ("Got strides " + strides + " and dilations '" + dilations + "'");
	    });
	    if (dimRoundingMode != null) {
	        util.assert(util.isInt(pad), function () { return "Error in depthwiseConv2d: pad must be an integer when using, " +
	            ("dimRoundingMode " + dimRoundingMode + " but got pad " + pad + "."); });
	    }
	    var convInfo = conv_util.computeConv2DInfo(x4D.shape, $filter.shape, strides, dilations, pad, dimRoundingMode, true /* depthwise */);
	    var grad = function (dy, saved) {
	        util.assert(conv_util.tupleValuesAreOne(dilations), function () { return 'Error in gradient of depthwiseConv2d: dilation rates ' +
	            "greater than 1 are not yet supported. Got dilations " +
	            ("'" + dilations + "'"); });
	        var x4D = saved[0], $filter = saved[1];
	        return {
	            x: function () { return exports.depthwiseConv2dDerInput(x4D.shape, dy, $filter, convInfo); },
	            filter: function () { return exports.depthwiseConv2dDerFilter(x4D, dy, $filter.shape, convInfo); },
	        };
	    };
	    var inputsToSave = [x4D, $filter];
	    var res = engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.depthwiseConv2D(x4D, $filter, convInfo);
	        save([x4D, $filter]);
	        return res;
	    }, { x: x4D, filter: $filter }, grad, 'DepthwiseConv2dNative', convInfo, inputsToSave);
	    if (reshapedTo4D) {
	        return res.as3D(res.shape[1], res.shape[2], res.shape[3]);
	    }
	    return res;
	}
	/**
	 * 2-D convolution with separable filters.
	 *
	 * Performs a depthwise convolution that acts separately on channels followed
	 * by a pointwise convolution that mixes channels. Note that this is
	 * separability between dimensions [1, 2] and 3, not spatial separability
	 * between dimensions 1 and 2.
	 *
	 * See
	 * [https://www.tensorflow.org/api_docs/python/tf/nn/separable_conv2d](
	 *     https://www.tensorflow.org/api_docs/python/tf/nn/separable_conv2d)
	 * for more details.
	 *
	 * @param x The input tensor, of rank 4 or rank 3, of shape
	 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
	 * assumed.
	 * @param depthwiseFilter The depthwise filter tensor, rank 4, of shape
	 *     `[filterHeight, filterWidth, inChannels, channelMultiplier]`. This is
	 *     the filter used in the first step.
	 * @param pointwiseFilter The pointwise filter tensor, rank 4, of shape
	 *     `[1, 1, inChannels * channelMultiplier, outChannels]`. This is
	 *     the filter used in the second step.
	 * @param strides The strides of the convolution: `[strideHeight,
	 * strideWidth]`. If strides is a single number, then `strideHeight ==
	 * strideWidth`.
	 * @param pad The type of padding algorithm.
	 *   - `same` and stride 1: output will be of same size as input,
	 *       regardless of filter size.
	 *   - `valid`: output will be smaller than input if filter is larger
	 *       than 1x1.
	 *   - For more info, see this guide:
	 *     [https://www.tensorflow.org/api_guides/python/nn#Convolution](
	 *          https://www.tensorflow.org/api_guides/python/nn#Convolution)
	 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
	 *     in which we sample input values across the height and width dimensions
	 *     in atrous convolution. Defaults to `[1, 1]`. If `rate` is a single
	 *     number, then `dilationHeight == dilationWidth`. If it is greater than
	 *     1, then all values of `strides` must be 1.
	 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
	 *     "NHWC". Specify the data format of the input and output data. With the
	 *     default format "NHWC", the data is stored in the order of: [batch,
	 *     height, width, channels]. Only "NHWC" is currently supported.
	 */
	/** @doc {heading: 'Operations', subheading: 'Convolution'} */
	function separableConv2d_(x, depthwiseFilter, pointwiseFilter, strides, pad, dilation, dataFormat) {
	    if (dilation === void 0) { dilation = [1, 1]; }
	    if (dataFormat === void 0) { dataFormat = 'NHWC'; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'separableConv2d');
	    var $depthwiseFilter = tensor_util_env_1.convertToTensor(depthwiseFilter, 'depthwiseFilter', 'separableConv2d');
	    var $pointwiseFilter = tensor_util_env_1.convertToTensor(pointwiseFilter, 'pointwiseFilter', 'separableConv2d');
	    var x4D = $x;
	    var reshapedTo4D = false;
	    if ($x.rank === 3) {
	        reshapedTo4D = true;
	        x4D = $x.as4D(1, $x.shape[0], $x.shape[1], $x.shape[2]);
	    }
	    if (dataFormat === 'NCHW') {
	        throw new Error('separableConv2d currently does not support dataFormat NCHW; only ' +
	            'NHWC is supported');
	    }
	    util.assert(x4D.rank === 4, function () { return "Error in separableConv2d: input must be rank 4, but got " +
	        ("rank " + x4D.rank + "."); });
	    util.assert($depthwiseFilter.rank === 4, function () { return "Error in separableConv2d: depthwise filter must be rank 4, but " +
	        ("got rank " + $depthwiseFilter.rank + "."); });
	    util.assert($pointwiseFilter.rank === 4, function () { return "Error in separableConv2d: pointwise filter must be rank 4, but " +
	        ("got rank " + $depthwiseFilter.rank + "."); });
	    util.assert($pointwiseFilter.shape[0] === 1, function () {
	        return "Error in separableConv2d: the first dimension of pointwise filter " +
	            (" must be 1, but got " + $pointwiseFilter.shape[0] + ".");
	    });
	    util.assert($pointwiseFilter.shape[1] === 1, function () { return "Error in separableConv2d: the second dimension of pointwise " +
	        ("filter must be 1, but got " + $pointwiseFilter.shape[1] + "."); });
	    var inChannels = $depthwiseFilter.shape[2];
	    var channelMultiplier = $depthwiseFilter.shape[3];
	    util.assert($pointwiseFilter.shape[2] === inChannels * channelMultiplier, function () {
	        return "Error in separableConv2d: the third dimension of pointwise filter " +
	            ("must be " + inChannels * channelMultiplier + ", ") +
	            ("but got " + $pointwiseFilter.shape[2] + ".");
	    });
	    var depthwise = exports.depthwiseConv2d(x4D, $depthwiseFilter, strides, pad, dataFormat, dilation);
	    var pointwiseStride = 1;
	    var res = exports.conv2d(depthwise, $pointwiseFilter, pointwiseStride, 'valid', dataFormat);
	    if (reshapedTo4D) {
	        return res.as3D(res.shape[1], res.shape[2], res.shape[3]);
	    }
	    return res;
	}
	function parseTupleParam(param) {
	    if (typeof param === 'number') {
	        return [param, param, param];
	    }
	    if (param.length === 2) {
	        return [param[0], param[1], 1];
	    }
	    return param;
	}
	function tupleValuesAreOne(param) {
	    var _a = parseTupleParam(param), dimA = _a[0], dimB = _a[1], dimC = _a[2];
	    return dimA === 1 && dimB === 1 && dimC === 1;
	}
	function eitherStridesOrDilationsAreOne(strides, dilations) {
	    return tupleValuesAreOne(strides) || tupleValuesAreOne(dilations);
	}
	function depthwiseConv2dDerInput_(xShape, dy, filter, convInfo) {
	    var dy4D = dy;
	    var reshapedTo4D = false;
	    if (dy.rank === 3) {
	        reshapedTo4D = true;
	        dy4D = dy.as4D(1, dy.shape[0], dy.shape[1], dy.shape[2]);
	    }
	    var res = engine_1.ENGINE.runKernelFunc(function (backend) { return backend.depthwiseConv2DDerInput(dy4D, filter, convInfo); }, { dy4D: dy4D });
	    if (reshapedTo4D) {
	        return res.as3D(res.shape[1], res.shape[2], res.shape[3]);
	    }
	    return res;
	}
	function depthwiseConv2dDerFilter_(x, dy, filterShape, convInfo) {
	    var x4D = x;
	    if (x.rank === 3) {
	        x4D = x.as4D(1, x.shape[0], x.shape[1], x.shape[2]);
	    }
	    var dy4D = dy;
	    if (dy4D.rank === 3) {
	        dy4D = dy.as4D(1, dy.shape[0], dy.shape[1], dy.shape[2]);
	    }
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.depthwiseConv2DDerFilter(x4D, dy4D, convInfo); }, { x4D: x4D, dy4D: dy4D });
	}
	/**
	 * Computes a 3D convolution over the input x.
	 *
	 * @param x The input tensor, of rank 5 or rank 4, of shape
	 *     `[batch, depth, height, width, channels]`. If rank 4,
	 * batch of 1 is assumed.
	 * @param filter The filter, rank 5, of shape
	 *     `[filterDepth, filterHeight, filterWidth, inChannels, outChannels]`.
	 *      inChannels must match between input and filter.
	 * @param strides The strides of the convolution: `[strideDepth, strideHeight,
	 * strideWidth]`.
	 * @param pad The type of padding algorithm.
	 *    - `same` and stride 1: output will be of same size as input,
	 *       regardless of filter size.
	 *    - `valid`: output will be smaller than input if filter is larger
	 *       than 1x1.
	 *   - For more info, see this guide:
	 *     [https://www.tensorflow.org/api_guides/python/nn#Convolution](
	 *          https://www.tensorflow.org/api_guides/python/nn#Convolution)
	 * @param dataFormat: An optional string from: "NDHWC", "NCDHW". Defaults to
	 *     "NDHWC". Specify the data format of the input and output data. With the
	 *     default format "NDHWC", the data is stored in the order of: [batch,
	 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
	 * @param dilations The dilation rates: `[dilationDepth, dilationHeight,
	 *     dilationWidth]` in which we sample input values across the height
	 *     and width dimensions in atrous convolution. Defaults to `[1, 1, 1]`.
	 *     If `dilations` is a single number, then
	 *     `dilationDepth == dilationHeight == dilationWidth`. If it is greater
	 *     than 1, then all values of `strides` must be 1.
	 */
	/** @doc {heading: 'Operations', subheading: 'Convolution'} */
	function conv3d_(x, filter, strides, pad, dataFormat, dilations) {
	    if (dataFormat === void 0) { dataFormat = 'NDHWC'; }
	    if (dilations === void 0) { dilations = [1, 1, 1]; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'conv3d');
	    var $filter = tensor_util_env_1.convertToTensor(filter, 'filter', 'conv3d');
	    var x5D = $x;
	    var reshapedTo5D = false;
	    if ($x.rank === 4) {
	        reshapedTo5D = true;
	        x5D = $x.as5D(1, $x.shape[0], $x.shape[1], $x.shape[2], $x.shape[3]);
	    }
	    util.assert(x5D.rank === 5, function () { return "Error in conv3d: input must be rank 5, but got rank " + x5D.rank + "."; });
	    util.assert($filter.rank === 5, function () { return "Error in conv3d: filter must be rank 5, but got rank " +
	        ($filter.rank + "."); });
	    util.assert(x5D.shape[4] === $filter.shape[3], function () { return "Error in conv3d: depth of input (" + x5D.shape[4] + ") must match " +
	        ("input depth for filter " + $filter.shape[3] + "."); });
	    util.assert(eitherStridesOrDilationsAreOne(strides, dilations), function () { return 'Error in conv3D: Either strides or dilations must be 1. ' +
	        ("Got strides " + strides + " and dilations '" + dilations + "'"); });
	    util.assert(dataFormat === 'NDHWC', function () { return "Error in conv3d: got dataFormat of " + dataFormat + " but only NDHWC is currently supported."; });
	    var convInfo = conv_util.computeConv3DInfo(x5D.shape, $filter.shape, strides, dilations, pad);
	    var grad = function (dy, saved) {
	        util.assert(tupleValuesAreOne(dilations), function () {
	            return 'Error in gradient of conv3D: dilation rates greater than 1 are ' +
	                ("not yet supported in gradients. Got dilations '" + dilations + "'");
	        });
	        var x5D = saved[0], $filter = saved[1];
	        return {
	            x: function () { return conv3dDerInput_(x5D.shape, dy, $filter, strides, pad); },
	            $filter: function () { return conv3dDerFilter_(x5D, dy, $filter.shape, strides, pad); }
	        };
	    };
	    var res = engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.conv3d(x5D, $filter, convInfo);
	        save([x5D, $filter]);
	        return res;
	    }, { x: x5D, $filter: $filter }, grad);
	    if (reshapedTo5D) {
	        return res.as4D(res.shape[1], res.shape[2], res.shape[3], res.shape[4]);
	    }
	    return res;
	}
	/**
	 * Computes the derivative of the input of a 3D convolution.
	 *
	 * @param xShape The shape of the input: [batch, depth, height, width,
	 * in_channels]. If length of 4, batch of 1 is assumed.
	 * @param dy The derivative of the output, of rank 5 or rank 4 of shape
	 *   `[batch, outDepth, outHeight, outWidth, in_channels]`.
	 * If rank 4, batch of 1 is assumed.
	 * @param filter The filter, rank 5, of shape
	 *     `[filterDepth, filterHeight, filterWidth, inDepth, outDepth]`.
	 * @param strides The strides of the convolution: `[strideDepth, strideHeight,
	 * strideWidth]`.
	 * @param pad The type of padding algorithm used:
	 *    - `same` and stride 1: output will be of same size as input,
	 *       regardless of filter size.
	 *    - `valid`: output will be smaller than input if filter is larger
	 *       than 1x1.
	 */
	function conv3dDerInput_(xShape, dy, filter, strides, pad) {
	    util.assert(xShape.length === dy.rank, function () { return "Length of inShape " +
	        ("(" + xShape.length + ") and rank of dy (" + dy.rank + ") must match"); });
	    var xShape5D = xShape;
	    var dy5D = dy;
	    var reshapedTo5D = false;
	    if (dy.rank === 4) {
	        reshapedTo5D = true;
	        dy5D = dy.as5D(1, dy.shape[0], dy.shape[1], dy.shape[2], dy.shape[3]);
	        xShape5D = [1, xShape[0], xShape[1], xShape[2], xShape[3]];
	    }
	    var inDepth = xShape5D[4];
	    var outDepth = dy5D.shape[4];
	    util.assert(xShape5D.length === 5, function () {
	        return "Error in conv3dDerInput: inShape must be length 5, but got length " +
	            (xShape5D.length + ".");
	    });
	    util.assert(dy5D.rank === 5, function () { return "Error in conv3dDerInput: dy must be rank 5, but got " +
	        ("rank " + dy5D.rank); });
	    util.assert(filter.rank === 5, function () { return "Error in conv3dDerInput: filter must be rank 5, but got " +
	        ("rank " + filter.rank); });
	    util.assert(inDepth === filter.shape[3], function () { return "Error in conv3dDerInput: depth of input (" + inDepth + ") must " +
	        ("match input depth for filter " + filter.shape[3] + "."); });
	    util.assert(outDepth === filter.shape[4], function () { return "Error in conv3dDerInput: depth of output (" + outDepth + ") must " +
	        ("match output depth for filter " + filter.shape[4] + "."); });
	    var dilations = 1;
	    var convInfo = conv_util.computeConv3DInfo(xShape5D, filter.shape, strides, dilations, pad);
	    var res = engine_1.ENGINE.runKernelFunc(function (backend) { return backend.conv3dDerInput(dy5D, filter, convInfo); }, { dy5D: dy5D });
	    if (reshapedTo5D) {
	        return res.as4D(res.shape[1], res.shape[2], res.shape[3], res.shape[4]);
	    }
	    return res;
	}
	/**
	 * Computes the derivative of the filter of a 3D convolution.
	 *
	 * @param x The input tensor, of rank 5 or rank 4 of shape
	 *     [batch, depth, height, width, inChannels]. If rank 4, batch of 1 is
	 *     assumed.
	 * @param dy The dy image, of rank 5 or rank 4, of shape
	 *     [batch, depth, height, width, outDepth]. If rank 4, batch of 1 is
	 *     assumed.
	 * @param filterShape The shape of the filter, length 5,
	 *     [filterDepth, filterHeight, filterWidth, inDepth, outDepth].
	 * @param strides The strides of the convolution: [strideDepth, strideHeight,
	 * strideWidth].
	 * @param pad A string from: 'same', 'valid'. The type of padding algorithm
	 *     used in the forward prop of the op.
	 */
	function conv3dDerFilter_(x, dy, filterShape, strides, pad) {
	    var x5D = x;
	    if (x.rank === 4) {
	        x5D = x.as5D(1, x.shape[0], x.shape[1], x.shape[2], x.shape[3]);
	    }
	    var dy5D = dy;
	    if (dy5D.rank === 4) {
	        dy5D = dy.as5D(1, dy.shape[0], dy.shape[1], dy.shape[2], dy.shape[3]);
	    }
	    util.assert(x5D.rank === 5, function () { return "Error in conv3dDerFilter: input must be rank 5, but got shape " +
	        (x5D.shape + "."); });
	    util.assert(dy5D.rank === 5, function () { return "Error in conv3dDerFilter: dy must be rank 5, but got shape " +
	        (dy5D.shape + "."); });
	    util.assert(filterShape.length === 5, function () { return "Error in conv3dDerFilter: filterShape must be length 5, but got " +
	        (filterShape + "."); });
	    util.assert(x5D.shape[4] === filterShape[3], function () { return "Error in conv3dDerFilter: depth of input " + x5D.shape[4] + ") must " +
	        ("match input depth in filter (" + filterShape[3] + "."); });
	    util.assert(dy5D.shape[4] === filterShape[4], function () { return "Error in conv3dDerFilter: depth of dy (" + dy5D.shape[4] + ") must " +
	        ("match output depth for filter (" + filterShape[4] + ")."); });
	    var dilations = 1;
	    var convInfo = conv_util.computeConv3DInfo(x5D.shape, filterShape, strides, dilations, pad);
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.conv3dDerFilter(x5D, dy5D, convInfo); }, { x5D: x5D, dy5D: dy5D });
	}
	/**
	 * Computes the transposed 3D convolution of a volume, also known as a
	 * deconvolution.
	 *
	 * @param x The input image, of rank 5 or rank 4, of shape
	 *   `[batch, depth, height, width, inDepth]`. If rank 4, batch of 1 is assumed.
	 * @param filter The filter, rank 4, of shape
	 *     `[depth, filterHeight, filterWidth, outDepth, inDepth]`.
	 *     `inDepth` must match `inDepth` in `x`.
	 * @param outputShape Output shape, of rank 5 or rank 4:
	 *     `[batch, depth, height, width, outDepth]`. If rank 3, batch of 1 is
	 *    assumed.
	 * @param strides The strides of the original convolution:
	 *     `[strideDepth, strideHeight, strideWidth]`.
	 * @param pad  The type of padding algorithm used in the non-transpose version
	 *    of the op.
	 */
	/** @doc {heading: 'Operations', subheading: 'Convolution'} */
	function conv3dTranspose_(x, filter, outputShape, strides, pad) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'conv3dTranspose');
	    var $filter = tensor_util_env_1.convertToTensor(filter, 'filter', 'conv3dTranspose');
	    return conv3dDerInput_(outputShape, $x, $filter, strides, pad);
	}
	exports.conv1d = operation_1.op({ conv1d_: conv1d_ });
	exports.conv2d = operation_1.op({ conv2d_: conv2d_ });
	exports.conv3d = operation_1.op({ conv3d_: conv3d_ });
	exports.conv2dDerFilter = operation_1.op({ conv2dDerFilter_: conv2dDerFilter_ });
	exports.conv2dDerInput = operation_1.op({ conv2dDerInput_: conv2dDerInput_ });
	exports.depthwiseConv2d = operation_1.op({ depthwiseConv2d_: depthwiseConv2d_ });
	exports.depthwiseConv2dDerInput = operation_1.op({ depthwiseConv2dDerInput_: depthwiseConv2dDerInput_ });
	exports.depthwiseConv2dDerFilter = operation_1.op({ depthwiseConv2dDerFilter_: depthwiseConv2dDerFilter_ });
	exports.separableConv2d = operation_1.op({ separableConv2d_: separableConv2d_ });
	exports.conv2dTranspose = operation_1.op({ conv2dTranspose_: conv2dTranspose_ });
	exports.conv3dTranspose = operation_1.op({ conv3dTranspose_: conv3dTranspose_ });
	//# sourceMappingURL=conv.js.map

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(10);
	/**
	 * Validate gather nd inputs.
	 *
	 * @param tensor The tensor contains the source values.
	 * @param indices The tensor contains the indices to slice the source.
	 *
	 * @returns [resultShape, numUpdates, sliceSize, strides]
	 */
	function prepareAndValidate(tensor, indices) {
	    if (tensor.rank < 1) {
	        throw new Error('tf.gatherND() expects the input to be rank 1 or higher,' +
	            (" but the rank was " + tensor.rank + "."));
	    }
	    if (indices.rank < 1) {
	        throw new Error('tf.gatherND() expects the indices to be rank 1 or higher,' +
	            (" but the rank was " + indices.rank + "."));
	    }
	    if (indices.dtype !== 'int32') {
	        throw new Error('tf.gatherND() expects the indices to be int32 type,' +
	            (" but the dtype was " + indices.dtype + "."));
	    }
	    if (indices.shape[indices.rank - 1] > tensor.rank) {
	        throw new Error('index innermost dimension length must be <= tensor rank; saw: ' +
	            (indices.shape[indices.rank - 1] + " vs. " + tensor.rank));
	    }
	    if (tensor.size === 0) {
	        throw new Error('Requested more than 0 entries, but input is empty.' +
	            (" Input shape: " + tensor.shape + "."));
	    }
	    var indicesShape = indices.shape;
	    var sliceRank = indicesShape[indicesShape.length - 1];
	    // The result shape is
	    //   indices.shape[:-1] + params.shape[indices.shape[-1]:]
	    var nResult = 1;
	    for (var i = 0; i < indicesShape.length - 1; ++i) {
	        nResult *= indicesShape[i];
	    }
	    var inputShape = tensor.shape;
	    var resultShape = indicesShape.slice();
	    resultShape.pop();
	    var sliceSize = 1;
	    for (var i = sliceRank; i < tensor.rank; ++i) {
	        sliceSize *= inputShape[i];
	        resultShape.push(inputShape[i]);
	    }
	    var strides = util_1.computeStrides(tensor.shape).map(function (stride) { return stride / sliceSize; }).concat([1]).slice(0, sliceRank);
	    return [resultShape, nResult, sliceSize, strides];
	}
	exports.prepareAndValidate = prepareAndValidate;
	//# sourceMappingURL=gather_nd_util.js.map

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Inputs of size above this threshold will be parallelized by calling multiple
	 * shader programs.
	 */
	var util_1 = __webpack_require__(10);
	exports.PARALLELIZE_THRESHOLD = 30;
	function computeOptimalWindowSize(inSize) {
	    if (inSize <= exports.PARALLELIZE_THRESHOLD) {
	        return inSize;
	    }
	    return util_1.nearestDivisor(inSize, Math.floor(Math.sqrt(inSize)));
	}
	exports.computeOptimalWindowSize = computeOptimalWindowSize;
	//# sourceMappingURL=reduce_util.js.map

/***/ },
/* 317 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SELU_SCALEALPHA = 1.7580993408473768599402175208123;
	exports.SELU_SCALE = 1.0507009873554804934193349852946;
	//# sourceMappingURL=selu_util.js.map

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_util_env_1 = __webpack_require__(17);
	var util = __webpack_require__(10);
	var operation_1 = __webpack_require__(18);
	var slice_util = __webpack_require__(192);
	/**
	 * Extracts a 1D slice from 1D array starting at coordinates `begin` and is
	 * of length `size`. See `slice` for details.
	 */
	function slice1d_(x, begin, size) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'slice1d');
	    util.assert($x.rank === 1, function () {
	        return "slice1d expects a rank-1 tensor, but got a rank-" + $x.rank + " tensor";
	    });
	    return exports.slice($x, [begin], [size]);
	}
	/**
	 * Extracts a 2D slice from a 2D array starting at coordinates `begin` and
	 * is of size `size`. See `slice` for details.
	 */
	function slice2d_(x, begin, size) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'slice2d');
	    util.assert($x.rank === 2, function () {
	        return "slice2d expects a rank-2 tensor, but got a rank-" + $x.rank + " tensor";
	    });
	    return exports.slice($x, begin, size);
	}
	/**
	 * Extracts a 3D slice from a 3D array starting at coordinates `begin` and
	 * is of size `size`. See `slice` for details.
	 */
	function slice3d_(x, begin, size) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'slice3d');
	    util.assert($x.rank === 3, function () {
	        return "slice3d expects a rank-3 tensor, but got a rank-" + $x.rank + " tensor";
	    });
	    return exports.slice($x, begin, size);
	}
	/**
	 * Extracts a 4D slice from a 4D array starting at coordinates `begin` and
	 * is of size `size`. See `slice` for details.
	 */
	function slice4d_(x, begin, size) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'slice4d');
	    util.assert($x.rank === 4, function () {
	        return "slice4d expects a rank-4 tensor, but got a rank-" + $x.rank + " tensor";
	    });
	    return exports.slice($x, begin, size);
	}
	/**
	 * Extracts a slice from a `tf.Tensor` starting at coordinates `begin`
	 * and is of size `size`.
	 *
	 * Also available are stricter rank-specific methods with the same signature
	 * as this method that assert that `x` is of the given rank:
	 *   - `tf.slice1d`
	 *   - `tf.slice2d`
	 *   - `tf.slice3d`
	 *   - `tf.slice4d`
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, 3, 4]);
	 *
	 * x.slice([1], [2]).print();
	 * ```
	 *
	 * ```js
	 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
	 *
	 * x.slice([1, 0], [1, 2]).print();
	 * ```
	 * @param x The input `tf.Tensor` to slice from.
	 * @param begin The coordinates to start the slice from. The length can be
	 *     less than the rank of x - the rest of the axes will have implicit 0 as
	 *     start. Can also be a single number, in which case it specifies the
	 *     first axis.
	 * @param size The size of the slice. The length can be less than the rank of
	 *     x - the rest of the axes will have implicit -1. A value of -1 requests
	 *     the rest of the dimensions in the axis. Can also be a single number,
	 *     in which case it specifies the size of the first axis.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Slicing and Joining'} */
	function slice_(x, begin, size) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'slice');
	    if ($x.rank === 0) {
	        throw new Error('Slicing scalar is not possible');
	    }
	    // The following logic allows for more ergonomic calls.
	    var begin_;
	    if (typeof begin === 'number') {
	        begin_ = [begin].concat(new Array($x.rank - 1).fill(0));
	    }
	    else if (begin.length < $x.rank) {
	        begin_ = begin.concat(new Array($x.rank - begin.length).fill(0));
	    }
	    else {
	        begin_ = begin.slice();
	    }
	    begin_.forEach(function (d) {
	        util.assert(d !== -1, function () { return 'slice() does not support negative begin indexing.'; });
	    });
	    var size_;
	    if (size == null) {
	        size_ = new Array($x.rank).fill(-1);
	    }
	    else if (typeof size === 'number') {
	        size_ = [size].concat(new Array($x.rank - 1).fill(-1));
	    }
	    else if (size.length < $x.rank) {
	        size_ = size.concat(new Array($x.rank - size.length).fill(-1));
	    }
	    else {
	        size_ = size;
	    }
	    size_ = size_.map(function (d, i) {
	        if (d >= 0) {
	            return d;
	        }
	        else {
	            util.assert(d === -1, function () { return "Negative size values should be exactly -1 but got " +
	                (d + " for the slice() size at index " + i + "."); });
	            return $x.shape[i] - begin_[i];
	        }
	    });
	    slice_util.assertParamsValid($x, begin_, size_);
	    var inputShape = $x.shape;
	    var grad = function (dy) {
	        // Create an Nx2 padding where the first column represents how many
	        // zeros are prepended (at start) for each dimension, and the second
	        // column indicates how many zeros are appended (at end).
	        // The number of zeros to append is the shape of the input
	        // elementwise-subtracted by both the begin vector and sizes vector.
	        var paddings = [];
	        for (var i = 0; i < dy.rank; i++) {
	            paddings.push([begin_[i], inputShape[i] - begin_[i] - size_[i]]);
	        }
	        return { x: function () { return dy.pad(paddings); } };
	    };
	    var attrs = { begin: begin_, size: size_ };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.slice($x, begin_, size_); }, { x: $x }, grad, 'Slice', attrs);
	}
	exports.slice = operation_1.op({ slice_: slice_ });
	exports.slice1d = operation_1.op({ slice1d_: slice1d_ });
	exports.slice2d = operation_1.op({ slice2d_: slice2d_ });
	exports.slice3d = operation_1.op({ slice3d_: slice3d_ });
	exports.slice4d = operation_1.op({ slice4d_: slice4d_ });
	//# sourceMappingURL=slice.js.map

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var complex_ops_1 = __webpack_require__(191);
	var operation_1 = __webpack_require__(18);
	var util_1 = __webpack_require__(10);
	var tensor_ops_1 = __webpack_require__(31);
	/**
	 * Fast Fourier transform.
	 *
	 * Computes the 1-dimensional discrete Fourier transform over the inner-most
	 * dimension of input.
	 *
	 * ```js
	 * const real = tf.tensor1d([1, 2, 3]);
	 * const imag = tf.tensor1d([1, 2, 3]);
	 * const x = tf.complex(real, imag);
	 *
	 * x.fft().print();  // tf.spectral.fft(x).print();
	 * ```
	 * @param input The complex input to compute an fft over.
	 */
	/**
	 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
	 */
	function fft_(input) {
	    util_1.assert(input.dtype === 'complex64', function () { return "The dtype for tf.spectral.fft() must be complex64 " +
	        ("but got " + input.dtype + "."); });
	    // Collapse all outer dimensions to a single batch dimension.
	    var innerDimensionSize = input.shape[input.shape.length - 1];
	    var batch = input.size / innerDimensionSize;
	    var input2D = input.as2D(batch, innerDimensionSize);
	    var ret = engine_1.ENGINE.runKernelFunc(function (backend) { return backend.fft(input2D); }, { input: input });
	    return ret.reshape(input.shape);
	}
	/**
	 * Inverse fast Fourier transform.
	 *
	 * Computes the inverse 1-dimensional discrete Fourier transform over the
	 * inner-most dimension of input.
	 *
	 * ```js
	 * const real = tf.tensor1d([1, 2, 3]);
	 * const imag = tf.tensor1d([1, 2, 3]);
	 * const x = tf.complex(real, imag);
	 *
	 * x.ifft().print();  // tf.spectral.ifft(x).print();
	 * ```
	 * @param input The complex input to compute an ifft over.
	 */
	/**
	 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
	 */
	function ifft_(input) {
	    util_1.assert(input.dtype === 'complex64', function () { return "The dtype for tf.spectral.ifft() must be complex64 " +
	        ("but got " + input.dtype + "."); });
	    // Collapse all outer dimensions to a single batch dimension.
	    var innerDimensionSize = input.shape[input.shape.length - 1];
	    var batch = input.size / innerDimensionSize;
	    var input2D = input.as2D(batch, innerDimensionSize);
	    var ret = engine_1.ENGINE.runKernelFunc(function (backend) { return backend.ifft(input2D); }, { input: input });
	    return ret.reshape(input.shape);
	}
	/**
	 * Real value input fast Fourier transform.
	 *
	 * Computes the 1-dimensional discrete Fourier transform over the
	 * inner-most dimension of the real input.
	 *
	 * ```js
	 * const real = tf.tensor1d([1, 2, 3]);
	 *
	 * real.rfft().print();
	 * ```
	 * @param input The real value input to compute an rfft over.
	 */
	/**
	 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
	 */
	function rfft_(input, fftLength) {
	    util_1.assert(input.dtype === 'float32', function () { return "The dtype for rfft() must be real value but got " + input.dtype; });
	    var innerDimensionSize = input.shape[input.shape.length - 1];
	    var batch = input.size / innerDimensionSize;
	    var adjustedInput;
	    if (fftLength != null && fftLength < innerDimensionSize) {
	        // Need to crop
	        var begin = input.shape.map(function (v) { return 0; });
	        var size = input.shape.map(function (v) { return v; });
	        size[input.shape.length - 1] = fftLength;
	        adjustedInput = input.slice(begin, size);
	        innerDimensionSize = fftLength;
	    }
	    else if (fftLength != null && fftLength > innerDimensionSize) {
	        // Need to pad with zeros
	        var zerosShape = input.shape.map(function (v) { return v; });
	        zerosShape[input.shape.length - 1] = fftLength - innerDimensionSize;
	        adjustedInput = input.concat(tensor_ops_1.zeros(zerosShape), input.shape.length - 1);
	        innerDimensionSize = fftLength;
	    }
	    else {
	        adjustedInput = input;
	    }
	    // Complement the input with zero imaginary numbers.
	    var zerosInput = adjustedInput.zerosLike();
	    var complexInput = complex_ops_1.complex(adjustedInput, zerosInput).as2D(batch, innerDimensionSize);
	    var ret = exports.fft(complexInput);
	    // Exclude complex conjugations. These conjugations are put symmetrically.
	    var half = Math.floor(innerDimensionSize / 2) + 1;
	    var realValues = complex_ops_1.real(ret);
	    var imagValues = complex_ops_1.imag(ret);
	    var realComplexConjugate = realValues.split([half, innerDimensionSize - half], realValues.shape.length - 1);
	    var imagComplexConjugate = imagValues.split([half, innerDimensionSize - half], imagValues.shape.length - 1);
	    var outputShape = adjustedInput.shape.slice();
	    outputShape[adjustedInput.shape.length - 1] = half;
	    return complex_ops_1.complex(realComplexConjugate[0], imagComplexConjugate[0])
	        .reshape(outputShape);
	}
	/**
	 * Inversed real value input fast Fourier transform.
	 *
	 * Computes the 1-dimensional inversed discrete Fourier transform over the
	 * inner-most dimension of the real input.
	 *
	 * ```js
	 * const real = tf.tensor1d([1, 2, 3]);
	 * const imag = tf.tensor1d([0, 0, 0]);
	 * const x = tf.complex(real, imag);
	 *
	 * x.irfft().print();
	 * ```
	 * @param input The real value input to compute an irfft over.
	 */
	/**
	 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
	 */
	function irfft_(input) {
	    var innerDimensionSize = input.shape[input.shape.length - 1];
	    var batch = input.size / innerDimensionSize;
	    if (innerDimensionSize <= 2) {
	        var complexInput = input.as2D(batch, innerDimensionSize);
	        var ret = exports.ifft(complexInput);
	        return complex_ops_1.real(ret);
	    }
	    else {
	        // The length of unique components of the DFT of a real-valued signal
	        // is 2 * (input_len - 1)
	        var outputShape = [batch, 2 * (innerDimensionSize - 1)];
	        var realInput = complex_ops_1.real(input).as2D(batch, innerDimensionSize);
	        var imagInput = complex_ops_1.imag(input).as2D(batch, innerDimensionSize);
	        var realConjugate = realInput.slice([0, 1], [batch, innerDimensionSize - 2]).reverse(1);
	        var imagConjugate = imagInput.slice([0, 1], [batch, innerDimensionSize - 2])
	            .reverse(1)
	            .mul(tensor_ops_1.scalar(-1));
	        var r = realInput.concat(realConjugate, 1);
	        var i = imagInput.concat(imagConjugate, 1);
	        var complexInput = complex_ops_1.complex(r, i).as2D(outputShape[0], outputShape[1]);
	        var ret = exports.ifft(complexInput);
	        return complex_ops_1.real(ret);
	    }
	}
	exports.fft = operation_1.op({ fft_: fft_ });
	exports.ifft = operation_1.op({ ifft_: ifft_ });
	exports.rfft = operation_1.op({ rfft_: rfft_ });
	exports.irfft = operation_1.op({ irfft_: irfft_ });
	//# sourceMappingURL=spectral_ops.js.map

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_util_env_1 = __webpack_require__(17);
	var util = __webpack_require__(10);
	var operation_1 = __webpack_require__(18);
	var tensor_ops_1 = __webpack_require__(31);
	/**
	 * Computes `-1 * x` element-wise.
	 *
	 * ```js
	 * const x = tf.tensor2d([1, 2, -2, 0], [2, 2]);
	 *
	 * x.neg().print();  // or tf.neg(x)
	 * ```
	 *
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function neg_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'neg');
	    var grad = function (dy) {
	        return { x: function () { return dy.neg(); } };
	    };
	    var attrs = {};
	    var inputsToSave = [$x];
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.neg($x); }, { x: $x }, grad, 'Neg', attrs, inputsToSave);
	}
	/**
	 * Computes ceiling of input `tf.Tensor` element-wise: `ceil(x)`
	 *
	 * ```js
	 * const x = tf.tensor1d([.6, 1.1, -3.3]);
	 *
	 * x.ceil().print();  // or tf.ceil(x)
	 * ```
	 * @param x The input Tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function ceil_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'ceil');
	    // TODO(manrajgrover): Return null for gradients when backprop supports it.
	    var grad = function (dy) {
	        return { $x: function () { return tensor_ops_1.zerosLike(dy); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.ceil($x); }, { $x: $x }, grad);
	}
	/**
	 * Computes floor of input `tf.Tensor` element-wise: `floor(x)`.
	 *
	 * ```js
	 * const x = tf.tensor1d([.6, 1.1, -3.3]);
	 *
	 * x.floor().print();  // or tf.floor(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function floor_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'floor');
	    // TODO(nsthorat): Let gradients be null for cases where we want to stop
	    // backpropgation.
	    var grad = function (dy) {
	        return { $x: function () { return tensor_ops_1.zerosLike(dy); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.floor($x); }, { $x: $x }, grad);
	}
	/**
	 * Returns an element-wise indication of the sign of a number.
	 *
	 * ```js
	 * const x = tf.tensor1d([.6, 1.1, -3.3, NaN, 0]);
	 *
	 * x.sign().print();  // or tf.sign(x)
	 * ```
	 * @param x The input Tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function sign_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'sign');
	    var grad = function (dy) {
	        return { $x: function () { return tensor_ops_1.zerosLike(dy); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.sign($x); }, { $x: $x }, grad);
	}
	/**
	 * RReturns which elements of x are NaN.
	 *
	 * ```js
	 * const x = tf.tensor1d([NaN, Infinity, -Infinity, 0, 1]);
	 *
	 * x.isNaN().print();  // or tf.isNaN(x)
	 * ```
	 * @param x The input Tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function isNaN_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'isNaN');
	    // TODO(nsthorat): Let gradients be null for cases where we want to stop
	    // backpropgation.
	    var grad = function (dy) {
	        return { $x: function () { return tensor_ops_1.zerosLike(dy); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.isNaN($x); }, { $x: $x }, grad);
	}
	/**
	 * Returns which elements of x are Infinity or -Infinity.
	 *
	 * ```js
	 * const x = tf.tensor1d([NaN, Infinity, -Infinity, 0, 1]);
	 *
	 * x.isInf().print();  // or tf.isNaN(x)
	 * ```
	 * @param x The input Tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function isInf_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'isInf');
	    // TODO(nsthorat): Let gradients be null for cases where we want to stop
	    // backpropgation.
	    var grad = function (dy) {
	        return { $x: function () { return tensor_ops_1.zerosLike(dy); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.isInf($x); }, { $x: $x }, grad);
	}
	/**
	 * Returns which elements of x are finite.
	 *
	 * ```js
	 * const x = tf.tensor1d([NaN, Infinity, -Infinity, 0, 1]);
	 *
	 * x.isFinite().print();  // or tf.isNaN(x)
	 * ```
	 * @param x The input Tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function isFinite_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'isFinite');
	    // TODO(nsthorat): Let gradients be null for cases where we want to stop
	    // backpropgation.
	    var grad = function (dy) {
	        return { $x: function () { return tensor_ops_1.zerosLike(dy); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.isFinite($x); }, { $x: $x }, grad);
	}
	/**
	 * Computes round of input `tf.Tensor` element-wise: `round(x)`.
	 * It implements banker's rounding.
	 *
	 * ```js
	 * const x = tf.tensor1d([.6, 1.1, -3.3]);
	 *
	 * x.round().print();  // or tf.round(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function round_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'round');
	    // TODO(nsthorat): Let gradients be null for cases where we want to stop
	    // backpropgation.
	    var grad = function (dy) {
	        return { $x: function () { return tensor_ops_1.zerosLike(dy); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.round($x); }, { $x: $x }, grad);
	}
	/**
	 * Computes exponential of the input `tf.Tensor` element-wise. `e ^ x`
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, -3]);
	 *
	 * x.exp().print();  // or tf.exp(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function exp_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'exp');
	    var bck = function (dy, saved) {
	        return { x: function () { return dy.mulStrict(saved[0]); } };
	    };
	    var attrs = {};
	    var inputsToSave = [];
	    var outputsToSave = [true];
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var y = backend.exp($x);
	        save([y]);
	        return y;
	    }, { x: $x }, bck, 'Exp', attrs, inputsToSave, outputsToSave);
	}
	/**
	 * Computes exponential of the input `tf.Tensor` minus one element-wise.
	 * `e ^ x - 1`
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, -3]);
	 *
	 * x.expm1().print();  // or tf.expm1(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function expm1_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'expm1');
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return { $x: function () { return dy.mul($x.exp()); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.expm1($x);
	        save([$x]);
	        return res;
	    }, { $x: $x }, grad);
	}
	/**
	 * Computes natural logarithm of the input `tf.Tensor` element-wise: `ln(x)`
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, Math.E]);
	 *
	 * x.log().print();  // or tf.log(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function log_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'log');
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return { x: function () { return dy.div($x.toFloat()); } };
	    };
	    var attrs = {};
	    var inputsToSave = [$x];
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.log($x);
	        save([$x]);
	        return res;
	    }, { x: $x }, grad, 'Log', attrs, inputsToSave);
	}
	/**
	 * Computes natural logarithm of the input `tf.Tensor` plus one
	 * element-wise: `ln(1 + x)`
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, Math.E - 1]);
	 *
	 * x.log1p().print();  // or tf.log1p(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function log1p_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'log1p');
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return { $x: function () { return dy.div($x.add(1)); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.log1p($x);
	        save([$x]);
	        return res;
	    }, { $x: $x }, grad);
	}
	/**
	 * Computes square root of the input `tf.Tensor` element-wise: `y = sqrt(x)`
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, 4, -1]);
	 *
	 * x.sqrt().print();  // or tf.sqrt(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function sqrt_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'sqrt');
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return { $x: function () { return dy.div($x.toFloat().sqrt().mul(2)); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.sqrt($x);
	        save([$x]);
	        return res;
	    }, { $x: $x }, grad);
	}
	/**
	 * Computes reciprocal of square root of the input `tf.Tensor` element-wise:
	 * `y = 1 / sqrt(x)`
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, 4, -1]);
	 *
	 * x.rsqrt().print();  // or tf.rsqrt(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function rsqrt_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'rsqrt');
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return { x: function () { return dy.div($x.pow(1.5).mul(2)).neg(); } };
	    };
	    var inputsToSave = [$x];
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.rsqrt($x);
	        save([$x]);
	        return res;
	    }, { x: $x }, grad, 'Rsqrt', {} /* attrs */, inputsToSave);
	}
	/**
	 * Computes reciprocal of x element-wise: `1 / x`
	 *
	 * ```js
	 * const x = tf.tensor1d([0, 1, 2]);
	 *
	 * x.reciprocal().print();  // or tf.reciprocal(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function reciprocal_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'reciprocal');
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return { $x: function () { return dy.div($x.square().neg()); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.reciprocal($x);
	        save([$x]);
	        return res;
	    }, { $x: $x }, grad);
	}
	/**
	 * Computes absolute value element-wise: `abs(x)`
	 *
	 * ```js
	 * const x = tf.tensor1d([-1, 2, -3, 4]);
	 *
	 * x.abs().print();  // or tf.abs(x)
	 * ```
	 * @param x The input `tf.Tensor`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function abs_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'abs');
	    if ($x.dtype === 'complex64') {
	        return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.complexAbs($x); }, { $x: $x });
	    }
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return { x: function () { return dy.mul($x.toFloat().step(-1)); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.abs($x);
	        save([$x]);
	        return res;
	    }, { x: $x }, grad, 'Abs');
	}
	/**
	 * Clips values element-wise. `max(min(x, clipValueMax), clipValueMin)`
	 *
	 * ```js
	 * const x = tf.tensor1d([-1, 2, -3, 4]);
	 *
	 * x.clipByValue(-2, 3).print();  // or tf.clipByValue(x, -2, 3)
	 * ```
	 * @param x The input tensor.
	 * @param clipValueMin Lower-bound of range to be clipped to.
	 * @param clipValueMax Upper-bound of range to be clipped to.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function clipByValue_(x, clipValueMin, clipValueMax) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'clipByValue');
	    util.assert((clipValueMin <= clipValueMax), function () { return "Error in clip: min (" + clipValueMin + ") must be " +
	        ("less than or equal to max (" + clipValueMax + ")."); });
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return {
	            x: function () { return dy.where($x.greaterEqual(clipValueMin)
	                .logicalAnd($x.lessEqual(clipValueMax)), tensor_ops_1.zerosLike(dy)); },
	        };
	    };
	    var inputsToSave = [$x];
	    var attr = { min: clipValueMin, max: clipValueMax };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.clip($x, clipValueMin, clipValueMax);
	        save([$x]);
	        return res;
	    }, { x: $x }, grad, 'ClipByValue', attr, inputsToSave);
	}
	/**
	 * Computes sigmoid element-wise, `1 / (1 + exp(-x))`
	 *
	 * ```js
	 * const x = tf.tensor1d([0, -1, 2, -3]);
	 *
	 * x.sigmoid().print();  // or tf.sigmoid(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function sigmoid_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'sigmoid');
	    var grad = function (dy, saved) {
	        var y = saved[0];
	        return { x: function () { return dy.mul(y.mul(tensor_ops_1.scalar(1).sub(y))); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var y = backend.sigmoid($x);
	        save([y]);
	        return y;
	    }, { x: $x }, grad, 'Sigmoid');
	}
	/**
	 * Computes log sigmoid of the input `tf.Tensor` element-wise:
	 * `logSigmoid(x)`. For numerical stability, we use `-tf.softplus(-x)`.
	 *
	 * ```js
	 * const x = tf.tensor1d([0, 1, -1, .7]);
	 *
	 * x.logSigmoid().print();  // or tf.logSigmoid(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function logSigmoid_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'logSigmoid');
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return { $x: function () { return dy.mul($x.neg().sigmoid()); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.softplus($x.neg()).neg();
	        save([$x]);
	        return res;
	    }, { $x: $x }, grad);
	}
	/**
	 * Computes softplus of the input `tf.Tensor` element-wise: `log(exp(x) + 1)`
	 *
	 * ```js
	 * const x = tf.tensor1d([0, 1, -1, .7]);
	 *
	 * x.softplus().print();  // or tf.softplus(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function softplus_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'softplus');
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return { $x: function () { return dy.mul($x.sigmoid()); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.softplus($x);
	        save([$x]);
	        return res;
	    }, { $x: $x }, grad);
	}
	/**
	 * Computes sin of the input Tensor element-wise: `sin(x)`
	 *
	 * ```js
	 * const x = tf.tensor1d([0, Math.PI / 2, Math.PI * 3 / 4]);
	 *
	 * x.sin().print();  // or tf.sin(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function sin_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'sin');
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return { x: function () { return $x.toFloat().cos().mul(dy); } };
	    };
	    var inputsToSave = [$x];
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.sin($x);
	        save([$x]);
	        return res;
	    }, { x: $x }, grad, 'Sin', {} /* attrs */, inputsToSave);
	}
	/**
	 * Computes cos of the input `tf.Tensor` element-wise: `cos(x)`
	 *
	 * ```js
	 * const x = tf.tensor1d([0, Math.PI / 2, Math.PI * 3 / 4]);
	 *
	 * x.cos().print();  // or tf.cos(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function cos_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'cos');
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return { x: function () { return $x.toFloat().sin().neg().mul(dy); } };
	    };
	    var inputsToSave = [$x];
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.cos($x);
	        save([$x]);
	        return res;
	    }, { x: $x }, grad, 'Cos', {} /* attrs */, inputsToSave);
	}
	/**
	 * Computes tan of the input `tf.Tensor` element-wise, `tan(x)`
	 *
	 * ```js
	 * const x = tf.tensor1d([0, Math.PI / 2, Math.PI * 3 / 4]);
	 *
	 * x.tan().print();  // or tf.tan(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function tan_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'tan');
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return { $x: function () { return dy.div($x.cos().square()); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.tan($x);
	        save([$x]);
	        return res;
	    }, { $x: $x }, grad);
	}
	/**
	 * Computes asin of the input `tf.Tensor` element-wise: `asin(x)`
	 *
	 * ```js
	 * const x = tf.tensor1d([0, 1, -1, .7]);
	 *
	 * x.asin().print();  // or tf.asin(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function asin_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'asin');
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return {
	            $x: function () { return dy.divStrict(tensor_ops_1.scalar(1).sub($x.toFloat().square()).sqrt()); }
	        };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.asin($x);
	        save([$x]);
	        return res;
	    }, { $x: $x }, grad);
	}
	/**
	 * Computes acos of the input `tf.Tensor` element-wise: `acos(x)`
	 *
	 * ```js
	 * const x = tf.tensor1d([0, 1, -1, .7]);
	 *
	 * x.acos().print();  // or tf.acos(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function acos_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'acos');
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return {
	            $x: function () {
	                return dy.divStrict(tensor_ops_1.scalar(1).sub($x.toFloat().square()).sqrt()).neg();
	            }
	        };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.acos($x);
	        save([$x]);
	        return res;
	    }, { $x: $x }, grad);
	}
	/**
	 * Computes atan of the input `tf.Tensor` element-wise: `atan(x)`
	 *
	 * ```js
	 * const x = tf.tensor1d([0, 1, -1, .7]);
	 *
	 * x.atan().print();  // or tf.atan(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function atan_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'atan');
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return { $x: function () { return dy.div($x.toFloat().square().add(1)); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.atan($x);
	        save([$x]);
	        return res;
	    }, { $x: $x }, grad);
	}
	/**
	 * Computes hyperbolic sin of the input `tf.Tensor` element-wise: `sinh(x)`
	 *
	 * ```js
	 * const x = tf.tensor1d([0, 1, -1, .7]);
	 *
	 * x.sinh().print();  // or tf.sinh(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function sinh_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'sinh');
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return { $x: function () { return $x.toFloat().cosh().mulStrict(dy); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.sinh($x);
	        save([$x]);
	        return res;
	    }, { $x: $x }, grad);
	}
	/**
	 * Computes hyperbolic cos of the input `tf.Tensor` element-wise: `cosh(x)`
	 *
	 * ```js
	 * const x = tf.tensor1d([0, 1, -1, .7]);
	 *
	 * x.cosh().print();  // or tf.cosh(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function cosh_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'cosh');
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return { $x: function () { return $x.toFloat().sinh().mulStrict(dy); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.cosh($x);
	        save([$x]);
	        return res;
	    }, { $x: $x }, grad);
	}
	/**
	 * Computes hyperbolic tangent of the input `tf.Tensor` element-wise: `tanh(x)`
	 *
	 * ```js
	 * const x = tf.tensor1d([0, 1, -1, 70]);
	 *
	 * x.tanh().print();  // or tf.tanh(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function tanh_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'tanh');
	    var grad = function (dy, saved) {
	        var y = saved[0];
	        return { x: function () { return tensor_ops_1.scalar(1).sub(y.square()).mulStrict(dy); } };
	    };
	    var outputsToSave = [true];
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var y = backend.tanh($x);
	        save([y]);
	        return y;
	    }, { x: $x }, grad, 'Tanh', {} /* attrs */, null /* inputsToSave */, outputsToSave);
	}
	/**
	 * Computes inverse hyperbolic sin of the input `tf.Tensor` element-wise:
	 * `asinh(x)`
	 *
	 * ```js
	 * const x = tf.tensor1d([0, 1, -1, .7]);
	 *
	 * x.asinh().print();  // or tf.asinh(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function asinh_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'asinh');
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return {
	            $x: function () { return dy.divStrict(tensor_ops_1.scalar(1).add($x.toFloat().square()).sqrt()); }
	        };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.asinh($x);
	        save([$x]);
	        return res;
	    }, { $x: $x }, grad);
	}
	/**
	 * Computes the inverse hyperbolic cos of the input `tf.Tensor` element-wise:
	 * `acosh(x)`
	 *
	 * ```js
	 * const x = tf.tensor1d([10, 1, 3, 5.7]);
	 *
	 * x.acosh().print();  // or tf.acosh(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function acosh_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'acosh');
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return { $x: function () { return dy.divStrict($x.toFloat().square().sub(1).sqrt()); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.acosh($x);
	        save([$x]);
	        return res;
	    }, { $x: $x }, grad);
	}
	/**
	 * Computes inverse hyperbolic tan of the input `tf.Tensor` element-wise:
	 * `atanh(x)`
	 *
	 * ```js
	 * const x = tf.tensor1d([0, .1, -.1, .7]);
	 *
	 * x.atanh().print();  // or tf.atanh(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function atanh_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'atanh');
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return { $x: function () { return dy.div(tensor_ops_1.scalar(1).sub($x.toFloat().square())); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.atanh($x);
	        save([$x]);
	        return res;
	    }, { $x: $x }, grad);
	}
	/**
	 * Computes gause error function of the input `tf.Tensor` element-wise:
	 * `erf(x)`
	 *
	 * ```js
	 * const x = tf.tensor1d([0, .1, -.1, .7]);
	 *
	 * x.erf().print(); // or tf.erf(x);
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function erf_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'erf');
	    util.assert($x.dtype === 'int32' || $x.dtype === 'float32', function () { return 'Input dtype must be `int32` or `float32`.'; });
	    if ($x.dtype === 'int32') {
	        $x = $x.toFloat();
	    }
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return {
	            $x: function () { return dy.mul($x.square().neg().exp().mul(2 / Math.sqrt(Math.PI))); }
	        };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.erf($x);
	        save([$x]);
	        return res;
	    }, { $x: $x }, grad);
	}
	/**
	 * Computes step of the input `tf.Tensor` element-wise: `x > 0 ? 1 : alpha * x`
	 *
	 * ```js
	 * const x = tf.tensor1d([0, 2, -1, -3]);
	 *
	 * x.step(.5).print();  // or tf.step(x, .5)
	 * ```
	 * @param x The input tensor.
	 * @param alpha The gradient when input is negative.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function step_(x, alpha) {
	    if (alpha === void 0) { alpha = 0.0; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'step');
	    // TODO(manrajgrover): Return null for gradients when backprop supports
	    // it.
	    var grad = function (dy) {
	        return { $x: function () { return tensor_ops_1.zerosLike(dy); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.step($x, alpha); }, { $x: $x }, grad);
	}
	exports.abs = operation_1.op({ abs_: abs_ });
	exports.acos = operation_1.op({ acos_: acos_ });
	exports.acosh = operation_1.op({ acosh_: acosh_ });
	exports.asin = operation_1.op({ asin_: asin_ });
	exports.asinh = operation_1.op({ asinh_: asinh_ });
	exports.atan = operation_1.op({ atan_: atan_ });
	exports.atanh = operation_1.op({ atanh_: atanh_ });
	exports.ceil = operation_1.op({ ceil_: ceil_ });
	exports.clipByValue = operation_1.op({ clipByValue_: clipByValue_ });
	exports.cos = operation_1.op({ cos_: cos_ });
	exports.cosh = operation_1.op({ cosh_: cosh_ });
	exports.erf = operation_1.op({ erf_: erf_ });
	exports.exp = operation_1.op({ exp_: exp_ });
	exports.expm1 = operation_1.op({ expm1_: expm1_ });
	exports.floor = operation_1.op({ floor_: floor_ });
	exports.log = operation_1.op({ log_: log_ });
	exports.log1p = operation_1.op({ log1p_: log1p_ });
	exports.logSigmoid = operation_1.op({ logSigmoid_: logSigmoid_ });
	exports.neg = operation_1.op({ neg_: neg_ });
	exports.reciprocal = operation_1.op({ reciprocal_: reciprocal_ });
	exports.round = operation_1.op({ round_: round_ });
	exports.rsqrt = operation_1.op({ rsqrt_: rsqrt_ });
	exports.sigmoid = operation_1.op({ sigmoid_: sigmoid_ });
	exports.sign = operation_1.op({ sign_: sign_ });
	exports.isNaN = operation_1.op({ isNaN_: isNaN_ });
	exports.isInf = operation_1.op({ isInf_: isInf_ });
	exports.isFinite = operation_1.op({ isFinite_: isFinite_ });
	exports.sin = operation_1.op({ sin_: sin_ });
	exports.sinh = operation_1.op({ sinh_: sinh_ });
	exports.softplus = operation_1.op({ softplus_: softplus_ });
	exports.sqrt = operation_1.op({ sqrt_: sqrt_ });
	exports.step = operation_1.op({ step_: step_ });
	exports.tan = operation_1.op({ tan_: tan_ });
	exports.tanh = operation_1.op({ tanh_: tanh_ });
	//# sourceMappingURL=unary_ops.js.map

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var globals_1 = __webpack_require__(73);
	var ops_1 = __webpack_require__(74);
	var serialization_1 = __webpack_require__(110);
	var optimizer_1 = __webpack_require__(129);
	/** @doclink Optimizer */
	var AdadeltaOptimizer = /** @class */ (function (_super) {
	    __extends(AdadeltaOptimizer, _super);
	    function AdadeltaOptimizer(learningRate, rho, epsilon) {
	        if (epsilon === void 0) { epsilon = null; }
	        var _this = _super.call(this) || this;
	        _this.learningRate = learningRate;
	        _this.rho = rho;
	        _this.epsilon = epsilon;
	        _this.accumulatedGrads = [];
	        _this.accumulatedUpdates = [];
	        if (epsilon == null) {
	            _this.epsilon = engine_1.ENGINE.backend.epsilon();
	        }
	        return _this;
	    }
	    AdadeltaOptimizer.prototype.applyGradients = function (variableGradients) {
	        var _this = this;
	        var variableNames = Array.isArray(variableGradients) ?
	            variableGradients.map(function (item) { return item.name; }) :
	            Object.keys(variableGradients);
	        variableNames.forEach(function (name, i) {
	            var value = engine_1.ENGINE.registeredVariables[name];
	            var trainable = false;
	            if (_this.accumulatedGrads[i] == null) {
	                _this.accumulatedGrads[i] = {
	                    originalName: name + "/accum_grad",
	                    variable: globals_1.tidy(function () { return ops_1.zerosLike(value).variable(trainable); })
	                };
	            }
	            if (_this.accumulatedUpdates[i] == null) {
	                _this.accumulatedUpdates[i] = {
	                    originalName: name + "/accum_var",
	                    variable: globals_1.tidy(function () { return ops_1.zerosLike(value).variable(trainable); })
	                };
	            }
	            var gradient = Array.isArray(variableGradients) ?
	                variableGradients[i].tensor :
	                variableGradients[name];
	            if (gradient == null) {
	                return;
	            }
	            var accumulatedGrad = _this.accumulatedGrads[i].variable;
	            var accumulatedUpdate = _this.accumulatedUpdates[i].variable;
	            globals_1.tidy(function () {
	                var newAccumulatedGrad = accumulatedGrad.mul(_this.rho).add(gradient.square().mul(1 - _this.rho));
	                var updates = accumulatedUpdate.add(_this.epsilon)
	                    .sqrt()
	                    .div(accumulatedGrad.add(_this.epsilon).sqrt())
	                    .mul(gradient);
	                var newAccumulatedUpdate = accumulatedUpdate.mul(_this.rho).add(updates.square().mul(1 - _this.rho));
	                accumulatedGrad.assign(newAccumulatedGrad);
	                accumulatedUpdate.assign(newAccumulatedUpdate);
	                var newValue = updates.mul(-_this.learningRate).add(value);
	                value.assign(newValue);
	            });
	        });
	        this.incrementIterations();
	    };
	    AdadeltaOptimizer.prototype.dispose = function () {
	        if (this.accumulatedUpdates != null) {
	            globals_1.dispose(this.accumulatedGrads.map(function (v) { return v.variable; }));
	            globals_1.dispose(this.accumulatedUpdates.map(function (v) { return v.variable; }));
	        }
	    };
	    AdadeltaOptimizer.prototype.getWeights = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var variables;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        variables = this.accumulatedGrads.concat(this.accumulatedUpdates);
	                        return [4 /*yield*/, this.saveIterations()];
	                    case 1: return [2 /*return*/, [_a.sent()].concat(variables.map(function (v) { return ({ name: v.originalName, tensor: v.variable }); }))];
	                }
	            });
	        });
	    };
	    AdadeltaOptimizer.prototype.setWeights = function (weightValues) {
	        return __awaiter(this, void 0, void 0, function () {
	            var variableCount, trainable;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.extractIterations(weightValues)];
	                    case 1:
	                        weightValues = _a.sent();
	                        variableCount = weightValues.length / 2;
	                        trainable = false;
	                        this.accumulatedGrads =
	                            weightValues.slice(0, variableCount).map(function (v) { return ({
	                                originalName: v.name,
	                                variable: v.tensor.variable(trainable)
	                            }); });
	                        this.accumulatedUpdates =
	                            weightValues.slice(variableCount, variableCount * 2)
	                                .map(function (v) { return ({
	                                originalName: v.name,
	                                variable: v.tensor.variable(trainable)
	                            }); });
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    AdadeltaOptimizer.prototype.getConfig = function () {
	        return {
	            'learningRate': this.learningRate,
	            'rho': this.rho,
	            'epsilon': this.epsilon
	        };
	    };
	    /** @nocollapse */
	    AdadeltaOptimizer.fromConfig = function (cls, config) {
	        return new cls(config['learningRate'], config['rho'], config['epsilon']);
	    };
	    /** @nocollapse */
	    AdadeltaOptimizer.className = 'Adadelta'; // Name matters for Python compatibility.
	    return AdadeltaOptimizer;
	}(optimizer_1.Optimizer));
	exports.AdadeltaOptimizer = AdadeltaOptimizer;
	serialization_1.registerClass(AdadeltaOptimizer);
	//# sourceMappingURL=adadelta_optimizer.js.map

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var globals_1 = __webpack_require__(73);
	var ops_1 = __webpack_require__(74);
	var serialization_1 = __webpack_require__(110);
	var optimizer_1 = __webpack_require__(129);
	/** @doclink Optimizer */
	var AdagradOptimizer = /** @class */ (function (_super) {
	    __extends(AdagradOptimizer, _super);
	    function AdagradOptimizer(learningRate, initialAccumulatorValue) {
	        if (initialAccumulatorValue === void 0) { initialAccumulatorValue = 0.1; }
	        var _this = _super.call(this) || this;
	        _this.learningRate = learningRate;
	        _this.initialAccumulatorValue = initialAccumulatorValue;
	        _this.accumulatedGrads = [];
	        return _this;
	    }
	    AdagradOptimizer.prototype.applyGradients = function (variableGradients) {
	        var _this = this;
	        var variableNames = Array.isArray(variableGradients) ?
	            variableGradients.map(function (item) { return item.name; }) :
	            Object.keys(variableGradients);
	        variableNames.forEach(function (name, i) {
	            var value = engine_1.ENGINE.registeredVariables[name];
	            if (_this.accumulatedGrads[i] == null) {
	                var trainable_1 = false;
	                _this.accumulatedGrads[i] = {
	                    originalName: name + "/accumulator",
	                    variable: globals_1.tidy(function () { return ops_1.fill(value.shape, _this.initialAccumulatorValue)
	                        .variable(trainable_1); })
	                };
	            }
	            var gradient = Array.isArray(variableGradients) ?
	                variableGradients[i].tensor :
	                variableGradients[name];
	            if (gradient == null) {
	                return;
	            }
	            var accumulatedGrad = _this.accumulatedGrads[i].variable;
	            globals_1.tidy(function () {
	                var newAccumulatedGrad = accumulatedGrad.add(gradient.square());
	                accumulatedGrad.assign(newAccumulatedGrad);
	                var newValue = gradient
	                    .div(newAccumulatedGrad.add(engine_1.ENGINE.backend.epsilon()).sqrt())
	                    .mul(-_this.learningRate)
	                    .add(value);
	                value.assign(newValue);
	            });
	        });
	        this.incrementIterations();
	    };
	    AdagradOptimizer.prototype.dispose = function () {
	        if (this.accumulatedGrads != null) {
	            globals_1.dispose(this.accumulatedGrads.map(function (v) { return v.variable; }));
	        }
	    };
	    AdagradOptimizer.prototype.getWeights = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.saveIterations()];
	                    case 1: 
	                    // Order matters for Python compatibility.
	                    return [2 /*return*/, [_a.sent()].concat(this.accumulatedGrads.map(function (v) { return ({ name: v.originalName, tensor: v.variable }); }))];
	                }
	            });
	        });
	    };
	    AdagradOptimizer.prototype.setWeights = function (weightValues) {
	        return __awaiter(this, void 0, void 0, function () {
	            var trainable;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.extractIterations(weightValues)];
	                    case 1:
	                        weightValues = _a.sent();
	                        trainable = false;
	                        this.accumulatedGrads = weightValues.map(function (v) { return ({ originalName: v.name, variable: v.tensor.variable(trainable) }); });
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    AdagradOptimizer.prototype.getConfig = function () {
	        return {
	            'learningRate': this.learningRate,
	            'initialAccumulatorValue': this.initialAccumulatorValue,
	        };
	    };
	    /** @nocollapse */
	    AdagradOptimizer.fromConfig = function (cls, config) {
	        return new cls(config['learningRate'], config['initialAccumulatorValue']);
	    };
	    /** @nocollapse */
	    AdagradOptimizer.className = 'Adagrad'; // Note: Name matters for Python compatibility.
	    return AdagradOptimizer;
	}(optimizer_1.Optimizer));
	exports.AdagradOptimizer = AdagradOptimizer;
	serialization_1.registerClass(AdagradOptimizer);
	//# sourceMappingURL=adagrad_optimizer.js.map

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var globals_1 = __webpack_require__(73);
	var ops_1 = __webpack_require__(74);
	var serialization_1 = __webpack_require__(110);
	var optimizer_1 = __webpack_require__(129);
	var AdamOptimizer = /** @class */ (function (_super) {
	    __extends(AdamOptimizer, _super);
	    function AdamOptimizer(learningRate, beta1, beta2, epsilon) {
	        if (epsilon === void 0) { epsilon = null; }
	        var _this = _super.call(this) || this;
	        _this.learningRate = learningRate;
	        _this.beta1 = beta1;
	        _this.beta2 = beta2;
	        _this.epsilon = epsilon;
	        _this.accumulatedFirstMoment = [];
	        _this.accumulatedSecondMoment = [];
	        globals_1.tidy(function () {
	            // accB* will be updated by batch.
	            _this.accBeta1 = ops_1.scalar(beta1).variable();
	            _this.accBeta2 = ops_1.scalar(beta2).variable();
	        });
	        if (epsilon == null) {
	            _this.epsilon = engine_1.ENGINE.backend.epsilon();
	        }
	        return _this;
	    }
	    AdamOptimizer.prototype.applyGradients = function (variableGradients) {
	        var _this = this;
	        var varNames = Array.isArray(variableGradients) ?
	            variableGradients.map(function (v) { return v.name; }) :
	            Object.keys(variableGradients);
	        globals_1.tidy(function () {
	            var oneMinusAccBeta1 = ops_1.sub(1, _this.accBeta1);
	            var oneMinusAccBeta2 = ops_1.sub(1, _this.accBeta2);
	            varNames.forEach(function (name, i) {
	                var value = engine_1.ENGINE.registeredVariables[name];
	                var trainable = false;
	                if (_this.accumulatedFirstMoment[i] == null) {
	                    _this.accumulatedFirstMoment[i] = {
	                        originalName: name + "/m",
	                        variable: globals_1.tidy(function () { return ops_1.zerosLike(value).variable(trainable); })
	                    };
	                }
	                if (_this.accumulatedSecondMoment[i] == null) {
	                    _this.accumulatedSecondMoment[i] = {
	                        originalName: name + "/v",
	                        variable: globals_1.tidy(function () { return ops_1.zerosLike(value).variable(trainable); })
	                    };
	                }
	                var gradient = Array.isArray(variableGradients) ?
	                    variableGradients[i].tensor :
	                    variableGradients[name];
	                if (gradient == null) {
	                    return;
	                }
	                var firstMoment = _this.accumulatedFirstMoment[i].variable;
	                var secondMoment = _this.accumulatedSecondMoment[i].variable;
	                var newFirstMoment = firstMoment.mul(_this.beta1).add(gradient.mul(1 - _this.beta1));
	                var newSecondMoment = secondMoment.mul(_this.beta2)
	                    .add(gradient.square().mul(1 - _this.beta2));
	                var biasCorrectedFirstMoment = newFirstMoment.div(oneMinusAccBeta1);
	                var biasCorrectedSecondMoment = newSecondMoment.div(oneMinusAccBeta2);
	                firstMoment.assign(newFirstMoment);
	                secondMoment.assign(newSecondMoment);
	                var newValue = biasCorrectedFirstMoment
	                    .div(biasCorrectedSecondMoment.sqrt().add(_this.epsilon))
	                    .mul(-_this.learningRate)
	                    .add(value);
	                value.assign(newValue);
	            });
	            _this.accBeta1.assign(_this.accBeta1.mul(_this.beta1));
	            _this.accBeta2.assign(_this.accBeta2.mul(_this.beta2));
	        });
	        this.incrementIterations();
	    };
	    AdamOptimizer.prototype.dispose = function () {
	        this.accBeta1.dispose();
	        this.accBeta2.dispose();
	        if (this.accumulatedFirstMoment != null) {
	            globals_1.dispose(this.accumulatedFirstMoment.map(function (v) { return v.variable; }));
	        }
	        if (this.accumulatedSecondMoment != null) {
	            globals_1.dispose(this.accumulatedSecondMoment.map(function (v) { return v.variable; }));
	        }
	    };
	    AdamOptimizer.prototype.getWeights = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var variables;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        variables = this.accumulatedFirstMoment.concat(this.accumulatedSecondMoment);
	                        return [4 /*yield*/, this.saveIterations()];
	                    case 1: return [2 /*return*/, [_a.sent()].concat(variables.map(function (v) { return ({ name: v.originalName, tensor: v.variable }); }))];
	                }
	            });
	        });
	    };
	    AdamOptimizer.prototype.setWeights = function (weightValues) {
	        return __awaiter(this, void 0, void 0, function () {
	            var variableCount, trainable;
	            var _this = this;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.extractIterations(weightValues)];
	                    case 1:
	                        weightValues = _a.sent();
	                        globals_1.tidy(function () {
	                            _this.accBeta1.assign(ops_1.pow(_this.beta1, _this.iterations_ + 1));
	                            _this.accBeta2.assign(ops_1.pow(_this.beta2, _this.iterations_ + 1));
	                        });
	                        variableCount = weightValues.length / 2;
	                        trainable = false;
	                        this.accumulatedFirstMoment =
	                            weightValues.slice(0, variableCount).map(function (v) { return ({
	                                originalName: v.name,
	                                variable: v.tensor.variable(trainable)
	                            }); });
	                        this.accumulatedSecondMoment =
	                            weightValues.slice(variableCount, variableCount * 2)
	                                .map(function (v) { return ({
	                                originalName: v.name,
	                                variable: v.tensor.variable(trainable)
	                            }); });
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    AdamOptimizer.prototype.getConfig = function () {
	        return {
	            'learningRate': this.learningRate,
	            'beta1': this.beta1,
	            'beta2': this.beta2,
	            'epsilon': this.epsilon,
	        };
	    };
	    /** @nocollapse */
	    AdamOptimizer.fromConfig = function (cls, config) {
	        return new cls(config['learningRate'], config['beta1'], config['beta2'], config['epsilon']);
	    };
	    /** @nocollapse */
	    AdamOptimizer.className = 'Adam'; // Note: Name matters for Python compatibility.
	    return AdamOptimizer;
	}(optimizer_1.Optimizer));
	exports.AdamOptimizer = AdamOptimizer;
	serialization_1.registerClass(AdamOptimizer);
	//# sourceMappingURL=adam_optimizer.js.map

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var globals_1 = __webpack_require__(73);
	var ops_1 = __webpack_require__(74);
	var serialization_1 = __webpack_require__(110);
	var optimizer_1 = __webpack_require__(129);
	var AdamaxOptimizer = /** @class */ (function (_super) {
	    __extends(AdamaxOptimizer, _super);
	    function AdamaxOptimizer(learningRate, beta1, beta2, epsilon, decay) {
	        if (epsilon === void 0) { epsilon = null; }
	        if (decay === void 0) { decay = 0.0; }
	        var _this = _super.call(this) || this;
	        _this.learningRate = learningRate;
	        _this.beta1 = beta1;
	        _this.beta2 = beta2;
	        _this.epsilon = epsilon;
	        _this.decay = decay;
	        _this.accumulatedFirstMoment = [];
	        _this.accumulatedWeightedInfNorm = [];
	        globals_1.tidy(function () {
	            _this.iteration = ops_1.scalar(0).variable();
	            _this.accBeta1 = ops_1.scalar(beta1).variable();
	        });
	        if (epsilon == null) {
	            _this.epsilon = engine_1.ENGINE.backend.epsilon();
	        }
	        return _this;
	    }
	    AdamaxOptimizer.prototype.applyGradients = function (variableGradients) {
	        var _this = this;
	        var variableNames = Array.isArray(variableGradients) ?
	            variableGradients.map(function (item) { return item.name; }) :
	            Object.keys(variableGradients);
	        globals_1.tidy(function () {
	            var oneMinusAccBeta1 = ops_1.sub(1, _this.accBeta1);
	            var lr = ops_1.div(-_this.learningRate, _this.iteration.mul(_this.decay).add(1));
	            variableNames.forEach(function (name, i) {
	                var value = engine_1.ENGINE.registeredVariables[name];
	                var trainable = false;
	                if (_this.accumulatedFirstMoment[i] == null) {
	                    _this.accumulatedFirstMoment[i] = {
	                        originalName: name + "/m",
	                        variable: ops_1.zerosLike(value).variable(trainable)
	                    };
	                }
	                if (_this.accumulatedWeightedInfNorm[i] == null) {
	                    _this.accumulatedWeightedInfNorm[i] = {
	                        originalName: name + "/v",
	                        variable: ops_1.zerosLike(value).variable(trainable)
	                    };
	                }
	                var gradient = Array.isArray(variableGradients) ?
	                    variableGradients[i].tensor :
	                    variableGradients[name];
	                if (gradient == null) {
	                    return;
	                }
	                var firstMoment = _this.accumulatedFirstMoment[i].variable;
	                var weightedInfNorm = _this.accumulatedWeightedInfNorm[i].variable;
	                var newFirstMoment = firstMoment.mul(_this.beta1).add(gradient.mul(1 - _this.beta1));
	                var ut0 = weightedInfNorm.mul(_this.beta2);
	                var ut1 = gradient.abs();
	                var newWeightedInfNorm = ut0.maximum(ut1);
	                firstMoment.assign(newFirstMoment);
	                weightedInfNorm.assign(newWeightedInfNorm);
	                var newValue = lr.div(oneMinusAccBeta1)
	                    .mul(newFirstMoment.div(newWeightedInfNorm.add(_this.epsilon)))
	                    .add(value);
	                value.assign(newValue);
	            });
	            _this.iteration.assign(_this.iteration.add(1));
	            _this.accBeta1.assign(_this.accBeta1.mul(_this.beta1));
	        });
	        this.incrementIterations();
	    };
	    AdamaxOptimizer.prototype.dispose = function () {
	        this.accBeta1.dispose();
	        this.iteration.dispose();
	        if (this.accumulatedFirstMoment != null) {
	            globals_1.dispose(this.accumulatedFirstMoment.map(function (v) { return v.variable; }));
	        }
	        if (this.accumulatedWeightedInfNorm != null) {
	            globals_1.dispose(this.accumulatedWeightedInfNorm.map(function (v) { return v.variable; }));
	        }
	    };
	    AdamaxOptimizer.prototype.getWeights = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                throw new Error('getWeights() is not implemented for Adamax yet.');
	            });
	        });
	    };
	    AdamaxOptimizer.prototype.setWeights = function (weightValues) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                throw new Error('setWeights() is not implemented for Adamax yet.');
	            });
	        });
	    };
	    AdamaxOptimizer.prototype.getConfig = function () {
	        return {
	            'learningRate': this.learningRate,
	            'beta1': this.beta1,
	            'beta2': this.beta2,
	            'epsilon': this.epsilon,
	            'decay': this.decay
	        };
	    };
	    /** @nocollapse */
	    AdamaxOptimizer.fromConfig = function (cls, config) {
	        return new cls(config['learningRate'], config['beta1'], config['beta2'], config['epsilon'], config['decay']);
	    };
	    /** @nocollapse */
	    AdamaxOptimizer.className = 'Adamax'; // Note: Name matters for Python compatbility.
	    return AdamaxOptimizer;
	}(optimizer_1.Optimizer));
	exports.AdamaxOptimizer = AdamaxOptimizer;
	serialization_1.registerClass(AdamaxOptimizer);
	//# sourceMappingURL=adamax_optimizer.js.map

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var globals_1 = __webpack_require__(73);
	var ops_1 = __webpack_require__(74);
	var serialization_1 = __webpack_require__(110);
	var sgd_optimizer_1 = __webpack_require__(240);
	/** @doclink Optimizer */
	var MomentumOptimizer = /** @class */ (function (_super) {
	    __extends(MomentumOptimizer, _super);
	    function MomentumOptimizer(learningRate, momentum, useNesterov) {
	        if (useNesterov === void 0) { useNesterov = false; }
	        var _this = _super.call(this, learningRate) || this;
	        _this.learningRate = learningRate;
	        _this.momentum = momentum;
	        _this.useNesterov = useNesterov;
	        _this.accumulations = [];
	        _this.m = ops_1.scalar(_this.momentum);
	        return _this;
	    }
	    MomentumOptimizer.prototype.applyGradients = function (variableGradients) {
	        var _this = this;
	        var variableNames = Array.isArray(variableGradients) ?
	            variableGradients.map(function (item) { return item.name; }) :
	            Object.keys(variableGradients);
	        variableNames.forEach(function (name, i) {
	            var value = engine_1.ENGINE.registeredVariables[name];
	            if (_this.accumulations[i] == null) {
	                var trainable_1 = false;
	                _this.accumulations[i] = {
	                    originalName: name + "/momentum",
	                    variable: globals_1.tidy(function () { return ops_1.zerosLike(value).variable(trainable_1); })
	                };
	            }
	            var accumulation = _this.accumulations[i].variable;
	            var gradient = Array.isArray(variableGradients) ?
	                variableGradients[i].tensor :
	                variableGradients[name];
	            if (gradient == null) {
	                return;
	            }
	            globals_1.tidy(function () {
	                var newValue;
	                var newAccumulation = _this.m.mul(accumulation).add(gradient);
	                if (_this.useNesterov) {
	                    newValue =
	                        _this.c.mul(gradient.add(newAccumulation.mul(_this.m))).add(value);
	                }
	                else {
	                    newValue = _this.c.mul(newAccumulation).add(value);
	                }
	                accumulation.assign(newAccumulation);
	                value.assign(newValue);
	            });
	        });
	        this.incrementIterations();
	    };
	    MomentumOptimizer.prototype.dispose = function () {
	        this.m.dispose();
	        if (this.accumulations != null) {
	            globals_1.dispose(this.accumulations.map(function (v) { return v.variable; }));
	        }
	    };
	    /**
	     * Sets the momentum of the optimizer.
	     *
	     * @param momentum
	     */
	    MomentumOptimizer.prototype.setMomentum = function (momentum) {
	        this.momentum = momentum;
	    };
	    MomentumOptimizer.prototype.getWeights = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.saveIterations()];
	                    case 1: 
	                    // Order matters for Python compatibility.
	                    return [2 /*return*/, [_a.sent()].concat(this.accumulations.map(function (v) { return ({ name: v.originalName, tensor: v.variable }); }))];
	                }
	            });
	        });
	    };
	    MomentumOptimizer.prototype.setWeights = function (weightValues) {
	        return __awaiter(this, void 0, void 0, function () {
	            var trainable;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.extractIterations(weightValues)];
	                    case 1:
	                        weightValues = _a.sent();
	                        trainable = false;
	                        this.accumulations = weightValues.map(function (v) { return ({ originalName: v.name, variable: v.tensor.variable(trainable) }); });
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    MomentumOptimizer.prototype.getConfig = function () {
	        return {
	            'learningRate': this.learningRate,
	            'momentum': this.momentum,
	            'useNesterov': this.useNesterov
	        };
	    };
	    /** @nocollapse */
	    MomentumOptimizer.fromConfig = function (cls, config) {
	        return new cls(config['learningRate'], config['momentum'], config['useNesterov']);
	    };
	    /** @nocollapse */
	    MomentumOptimizer.className = 'Momentum'; // Name matters for Python compatibility.
	    return MomentumOptimizer;
	}(sgd_optimizer_1.SGDOptimizer));
	exports.MomentumOptimizer = MomentumOptimizer;
	serialization_1.registerClass(MomentumOptimizer);
	//# sourceMappingURL=momentum_optimizer.js.map

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var globals_1 = __webpack_require__(73);
	var ops_1 = __webpack_require__(74);
	var serialization_1 = __webpack_require__(110);
	var optimizer_1 = __webpack_require__(129);
	/** @doclink Optimizer */
	var RMSPropOptimizer = /** @class */ (function (_super) {
	    __extends(RMSPropOptimizer, _super);
	    function RMSPropOptimizer(learningRate, decay, momentum, epsilon, centered) {
	        if (decay === void 0) { decay = 0.9; }
	        if (momentum === void 0) { momentum = 0.0; }
	        if (epsilon === void 0) { epsilon = null; }
	        if (centered === void 0) { centered = false; }
	        var _this = _super.call(this) || this;
	        _this.learningRate = learningRate;
	        _this.decay = decay;
	        _this.momentum = momentum;
	        _this.epsilon = epsilon;
	        _this.accumulatedMeanSquares = [];
	        _this.accumulatedMoments = [];
	        _this.accumulatedMeanGrads = [];
	        _this.centered = centered;
	        if (epsilon == null) {
	            _this.epsilon = engine_1.ENGINE.backend.epsilon();
	        }
	        if (learningRate == null) {
	            throw new Error("learningRate for RMSPropOptimizer must be defined.");
	        }
	        return _this;
	    }
	    RMSPropOptimizer.prototype.applyGradients = function (variableGradients) {
	        var _this = this;
	        var variableNames = Array.isArray(variableGradients) ?
	            variableGradients.map(function (item) { return item.name; }) :
	            Object.keys(variableGradients);
	        variableNames.forEach(function (name, i) {
	            var value = engine_1.ENGINE.registeredVariables[name];
	            var trainable = false;
	            if (_this.accumulatedMeanSquares[i] == null) {
	                _this.accumulatedMeanSquares[i] = {
	                    originalName: name + "/rms",
	                    variable: globals_1.tidy(function () { return ops_1.zerosLike(value).variable(trainable); })
	                };
	            }
	            if (_this.accumulatedMoments[i] == null) {
	                _this.accumulatedMoments[i] = {
	                    originalName: name + "/momentum",
	                    variable: globals_1.tidy(function () { return ops_1.zerosLike(value).variable(trainable); })
	                };
	            }
	            if (_this.accumulatedMeanGrads[i] == null && _this.centered) {
	                _this.accumulatedMeanGrads[i] = {
	                    originalName: name + "/mg",
	                    variable: globals_1.tidy(function () { return ops_1.zerosLike(value).variable(trainable); })
	                };
	            }
	            var gradient = Array.isArray(variableGradients) ?
	                variableGradients[i].tensor :
	                variableGradients[name];
	            if (gradient == null) {
	                return;
	            }
	            var accumulatedMeanSquare = _this.accumulatedMeanSquares[i].variable;
	            var accumulatedMoments = _this.accumulatedMoments[i].variable;
	            globals_1.tidy(function () {
	                var newAccumulatedMeanSquare = accumulatedMeanSquare.mul(_this.decay)
	                    .add(gradient.square().mul(1 - _this.decay));
	                if (_this.centered) {
	                    var accumulatedMeanGrad = _this.accumulatedMeanGrads[i].variable;
	                    // Centered gradient
	                    var newAccumulatedMeanGrad = accumulatedMeanGrad.mul(_this.decay)
	                        .add(gradient.mul(1 - _this.decay));
	                    var newAccumulatedMoments = accumulatedMoments.mul(_this.momentum)
	                        .add(gradient.mul(_this.learningRate)
	                        .div(newAccumulatedMeanSquare
	                        .sub(newAccumulatedMeanGrad.square().add(_this.epsilon))
	                        .sqrt()));
	                    accumulatedMeanSquare.assign(newAccumulatedMeanSquare);
	                    accumulatedMeanGrad.assign(newAccumulatedMeanGrad);
	                    accumulatedMoments.assign(newAccumulatedMoments);
	                    var newValue = value.sub(newAccumulatedMoments);
	                    value.assign(newValue);
	                }
	                else {
	                    // Plain gradient
	                    var newAccumulatedMeanSquare_1 = accumulatedMeanSquare.mul(_this.decay)
	                        .add(gradient.square().mul(1 - _this.decay));
	                    var newAccumulatedMoments = accumulatedMoments.mul(_this.momentum)
	                        .add(gradient.mul(_this.learningRate)
	                        .div(newAccumulatedMeanSquare_1.add(_this.epsilon)
	                        .sqrt()));
	                    accumulatedMeanSquare.assign(newAccumulatedMeanSquare_1);
	                    accumulatedMoments.assign(newAccumulatedMoments);
	                    var newValue = value.sub(newAccumulatedMoments);
	                    value.assign(newValue);
	                }
	            });
	        });
	        this.incrementIterations();
	    };
	    RMSPropOptimizer.prototype.dispose = function () {
	        if (this.accumulatedMeanSquares != null) {
	            globals_1.dispose(this.accumulatedMeanSquares.map(function (v) { return v.variable; }));
	        }
	        if (this.accumulatedMeanGrads != null && this.centered) {
	            globals_1.dispose(this.accumulatedMeanGrads.map(function (v) { return v.variable; }));
	        }
	        if (this.accumulatedMoments != null) {
	            globals_1.dispose(this.accumulatedMoments.map(function (v) { return v.variable; }));
	        }
	    };
	    RMSPropOptimizer.prototype.getWeights = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var variables;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        variables = this.accumulatedMeanSquares.concat(this.accumulatedMoments);
	                        if (this.centered) {
	                            variables.push.apply(variables, this.accumulatedMeanGrads);
	                        }
	                        return [4 /*yield*/, this.saveIterations()];
	                    case 1: return [2 /*return*/, [_a.sent()].concat(variables.map(function (v) { return ({ name: v.originalName, tensor: v.variable }); }))];
	                }
	            });
	        });
	    };
	    RMSPropOptimizer.prototype.setWeights = function (weightValues) {
	        return __awaiter(this, void 0, void 0, function () {
	            var variableCount, trainable;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.extractIterations(weightValues)];
	                    case 1:
	                        weightValues = _a.sent();
	                        variableCount = this.centered ? weightValues.length / 3 : weightValues.length / 2;
	                        trainable = false;
	                        this.accumulatedMeanSquares =
	                            weightValues.slice(0, variableCount).map(function (v) { return ({
	                                originalName: v.name,
	                                variable: v.tensor.variable(trainable)
	                            }); });
	                        this.accumulatedMoments =
	                            weightValues.slice(variableCount, variableCount * 2)
	                                .map(function (v) { return ({
	                                originalName: v.name,
	                                variable: v.tensor.variable(trainable)
	                            }); });
	                        if (this.centered) {
	                            this.accumulatedMeanGrads =
	                                weightValues.slice(variableCount * 2, variableCount * 3)
	                                    .map(function (v) { return ({
	                                    originalName: v.name,
	                                    variable: v.tensor.variable(trainable)
	                                }); });
	                        }
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    RMSPropOptimizer.prototype.getConfig = function () {
	        return {
	            'learningRate': this.learningRate,
	            'decay': this.decay,
	            'momentum': this.momentum,
	            'epsilon': this.epsilon,
	            'centered': this.centered
	        };
	    };
	    /** @nocollapse */
	    RMSPropOptimizer.fromConfig = function (cls, config) {
	        return new cls(config['learningRate'], config['decay'], config['momentum'], config['epsilon'], config['centered']);
	    };
	    /** @nocollapse */
	    RMSPropOptimizer.className = 'RMSProp'; // Note: Name matters for Python compatibility.
	    return RMSPropOptimizer;
	}(optimizer_1.Optimizer));
	exports.RMSPropOptimizer = RMSPropOptimizer;
	serialization_1.registerClass(RMSPropOptimizer);
	//# sourceMappingURL=rmsprop_optimizer.js.map

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(76);
	var normalizeHeaderName = __webpack_require__(1106);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(501);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(501);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1425);
	
	function CustomAlertModal(props) {
	    return _react2.default.createElement(
	        "div",
	        { className: "custom-alert-modal-backdrop" },
	        _react2.default.createElement(
	            "div",
	            { className: "custom-alert-modal-containter" },
	            _react2.default.createElement(
	                "div",
	                { className: "custom-alert-modal-content text-center" },
	                props.children
	            )
	        )
	    );
	};
	exports.default = CustomAlertModal;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FieldInformation = function (_Component) {
	    _inherits(FieldInformation, _Component);
	
	    function FieldInformation(props) {
	        _classCallCheck(this, FieldInformation);
	
	        var _this = _possibleConstructorReturn(this, (FieldInformation.__proto__ || Object.getPrototypeOf(FieldInformation)).call(this, props));
	
	        _this.state = {
	            showModal: false
	        };
	
	        _this.close = _this.close.bind(_this);
	        _this.open = _this.open.bind(_this);
	        return _this;
	    }
	
	    _createClass(FieldInformation, [{
	        key: 'close',
	        value: function close() {
	            this.setState(Object.assign({}, this.state, { showModal: false }));
	        }
	    }, {
	        key: 'open',
	        value: function open() {
	            this.setState(Object.assign({}, this.state, { showModal: true }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                info = _props.info,
	                title = _props.title;
	
	            return _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                    'a',
	                    { onClick: this.open },
	                    _react2.default.createElement('i', { className: 'fa fa-question-circle fa-lg', 'aria-hidden': 'true' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal,
	                    { className: 'custom-modal', show: this.state.showModal, onHide: this.close, bsSize: 'large' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Header,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Modal.Title,
	                            null,
	                            title
	                        )
	                    ),
	                    _react2.default.createElement(_reactBootstrap.Modal.Body, { dangerouslySetInnerHTML: { __html: info } }),
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Footer,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                type: 'submit',
	                                bsStyle: 'success',
	                                onClick: this.close
	                            },
	                            'Entendido'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FieldInformation;
	}(_react.Component);
	
	exports.default = FieldInformation;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MoneyField = function MoneyField(_ref) {
		var children = _ref.children,
		    decimals = _ref.decimals;
	
		var digits = decimals && 2;
		return _react2.default.createElement(
			'div',
			null,
			(0, _utils.formatMoney)(children, digits, ',', '.')
		);
	};
	
	exports.default = MoneyField;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(1418);
	
	var MainForm = function (_Component) {
	    _inherits(MainForm, _Component);
	
	    function MainForm(props) {
	        _classCallCheck(this, MainForm);
	
	        var _this = _possibleConstructorReturn(this, (MainForm.__proto__ || Object.getPrototypeOf(MainForm)).call(this, props));
	
	        _this.scrollToTop.bind(_this);
	        return _this;
	    }
	
	    _createClass(MainForm, [{
	        key: "scrollToTop",
	        value: function scrollToTop() {
	            window.scrollTo(0, 0);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "button",
	                { type: "submit", onClick: this.scrollToTop, className: "puedo-button puedo-button-anchor" },
	                "Envi\xE1 tu solicitud"
	            );
	        }
	    }]);
	
	    return MainForm;
	}(_react.Component);
	
	exports.default = MainForm;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1421);
	
	var TextWithLine = function TextWithLine(props) {
			return _react2.default.createElement(
					'div',
					{ className: 'text-with-line' },
					_react2.default.createElement(
							'span',
							{ className: 'text-without-line' },
							props.value
					)
			);
	};
	
	exports.default = TextWithLine;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1248), __esModule: true };

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1256), __esModule: true };

/***/ },
/* 335 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./functionApply')} */
	module.exports = Function.prototype.apply;


/***/ },
/* 336 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./functionCall')} */
	module.exports = Function.prototype.call;


/***/ },
/* 337 */
[2089, 197, 64],
/* 338 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 339 */
[2092, 122, 63],
/* 340 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 341 */
[2106, 250],
/* 342 */
[2108, 92, 1272, 340, 344, 339, 516],
/* 343 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 344 */
[2119, 345, 252],
/* 345 */
[2120, 43, 63, 198],
/* 346 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 347 */
[2126, 346],
/* 348 */
[2128, 122],
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(63);
	var core = __webpack_require__(43);
	var LIBRARY = __webpack_require__(198);
	var wksExt = __webpack_require__(350);
	var defineProperty = __webpack_require__(112).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(64);


/***/ },
/* 351 */
[2131, 337, 64, 159, 43],
/* 352 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 353 */
[2089, 203, 66],
/* 354 */
338,
/* 355 */
[2092, 65, 58],
/* 356 */
[2097, 203],
/* 357 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 358 */
[2104, 257, 65, 135, 206, 204],
/* 359 */
[2106, 202],
/* 360 */
199,
/* 361 */
200,
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(136);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 363 */
[2119, 364, 257],
/* 364 */
[2120, 69, 58, 357],
/* 365 */
346,
/* 366 */
[2126, 365],
/* 367 */
[2127, 354],
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(65);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(208);
	
	var $SyntaxError = __webpack_require__(262);
	var $TypeError = __webpack_require__(22);
	
	var gopd = __webpack_require__(140);
	
	/** @type {import('.')} */
	module.exports = function defineDataProperty(
		obj,
		property,
		value
	) {
		if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
			throw new $TypeError('`obj` must be an object or a function`');
		}
		if (typeof property !== 'string' && typeof property !== 'symbol') {
			throw new $TypeError('`property` must be a string or a symbol`');
		}
		if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
			throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
			throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
			throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
			throw new $TypeError('`loose`, if provided, must be a boolean');
		}
	
		var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
		var nonWritable = arguments.length > 4 ? arguments[4] : null;
		var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
		var loose = arguments.length > 6 ? arguments[6] : false;
	
		/* @type {false | TypedPropertyDescriptor<unknown>} */
		var desc = !!gopd && gopd(obj, property);
	
		if ($defineProperty) {
			$defineProperty(obj, property, {
				configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
				enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
				value: value,
				writable: nonWritable === null && desc ? desc.writable : !nonWritable
			});
		} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
			// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
			obj[property] = value; // eslint-disable-line no-param-reassign
		} else {
			throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
		}
	};


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(45);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(124));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $TypeError = __webpack_require__(22);
	
	var hasOwn = __webpack_require__(141);
	
	var isPropertyDescriptor = __webpack_require__(125);
	
	// https://262.ecma-international.org/5.1/#sec-8.10.1
	
	module.exports = function IsAccessorDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}
	
		if (!isPropertyDescriptor(Desc)) {
			throw new $TypeError('Assertion failed: `Desc` must be a Property Descriptor');
		}
	
		if (!hasOwn(Desc, '[[Get]]') && !hasOwn(Desc, '[[Set]]')) {
			return false;
		}
	
		return true;
	};


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://262.ecma-international.org/6.0/#sec-isarray
	module.exports = __webpack_require__(566);


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $TypeError = __webpack_require__(22);
	
	var hasOwn = __webpack_require__(141);
	
	var isPropertyDescriptor = __webpack_require__(125);
	
	// https://262.ecma-international.org/5.1/#sec-8.10.2
	
	module.exports = function IsDataDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}
	
		if (!isPropertyDescriptor(Desc)) {
			throw new $TypeError('Assertion failed: `Desc` must be a Property Descriptor');
		}
	
		if (!hasOwn(Desc, '[[Value]]') && !hasOwn(Desc, '[[Writable]]')) {
			return false;
		}
	
		return true;
	};


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $isNaN = __webpack_require__(216);
	
	// http://262.ecma-international.org/5.1/#sec-9.12
	
	module.exports = function SameValue(x, y) {
		if (x === y) { // 0 === -0, but they are not identical.
			if (x === 0) { return 1 / x === 1 / y; }
			return true;
		}
		return $isNaN(x) && $isNaN(y);
	};


/***/ },
/* 375 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 376 */
138,
/* 377 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Gender;
	(function (Gender) {
	    Gender["FEMALE"] = "female";
	    Gender["MALE"] = "male";
	})(Gender = exports.Gender || (exports.Gender = {}));
	//# sourceMappingURL=types.js.map

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var utils_1 = __webpack_require__(34);
	var FaceLandmarks_1 = __webpack_require__(166);
	var FaceLandmarks68 = /** @class */ (function (_super) {
	    tslib_1.__extends(FaceLandmarks68, _super);
	    function FaceLandmarks68() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    FaceLandmarks68.prototype.getJawOutline = function () {
	        return this.positions.slice(0, 17);
	    };
	    FaceLandmarks68.prototype.getLeftEyeBrow = function () {
	        return this.positions.slice(17, 22);
	    };
	    FaceLandmarks68.prototype.getRightEyeBrow = function () {
	        return this.positions.slice(22, 27);
	    };
	    FaceLandmarks68.prototype.getNose = function () {
	        return this.positions.slice(27, 36);
	    };
	    FaceLandmarks68.prototype.getLeftEye = function () {
	        return this.positions.slice(36, 42);
	    };
	    FaceLandmarks68.prototype.getRightEye = function () {
	        return this.positions.slice(42, 48);
	    };
	    FaceLandmarks68.prototype.getMouth = function () {
	        return this.positions.slice(48, 68);
	    };
	    FaceLandmarks68.prototype.getRefPointsForAlignment = function () {
	        return [
	            this.getLeftEye(),
	            this.getRightEye(),
	            this.getMouth()
	        ].map(utils_1.getCenterPoint);
	    };
	    return FaceLandmarks68;
	}(FaceLandmarks_1.FaceLandmarks));
	exports.FaceLandmarks68 = FaceLandmarks68;
	//# sourceMappingURL=FaceLandmarks68.js.map

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Box_1 = __webpack_require__(165);
	var Dimensions_1 = __webpack_require__(210);
	var ObjectDetection = /** @class */ (function () {
	    function ObjectDetection(score, classScore, className, relativeBox, imageDims) {
	        this._imageDims = new Dimensions_1.Dimensions(imageDims.width, imageDims.height);
	        this._score = score;
	        this._classScore = classScore;
	        this._className = className;
	        this._box = new Box_1.Box(relativeBox).rescale(this._imageDims);
	    }
	    Object.defineProperty(ObjectDetection.prototype, "score", {
	        get: function () { return this._score; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ObjectDetection.prototype, "classScore", {
	        get: function () { return this._classScore; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ObjectDetection.prototype, "className", {
	        get: function () { return this._className; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ObjectDetection.prototype, "box", {
	        get: function () { return this._box; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ObjectDetection.prototype, "imageDims", {
	        get: function () { return this._imageDims; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ObjectDetection.prototype, "imageWidth", {
	        get: function () { return this.imageDims.width; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ObjectDetection.prototype, "imageHeight", {
	        get: function () { return this.imageDims.height; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ObjectDetection.prototype, "relativeBox", {
	        get: function () { return new Box_1.Box(this._box).rescale(this.imageDims.reverse()); },
	        enumerable: true,
	        configurable: true
	    });
	    ObjectDetection.prototype.forSize = function (width, height) {
	        return new ObjectDetection(this.score, this.classScore, this.className, this.relativeBox, { width: width, height: height });
	    };
	    return ObjectDetection;
	}());
	exports.ObjectDetection = ObjectDetection;
	//# sourceMappingURL=ObjectDetection.js.map

/***/ },
/* 380 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Point = /** @class */ (function () {
	    function Point(x, y) {
	        this._x = x;
	        this._y = y;
	    }
	    Object.defineProperty(Point.prototype, "x", {
	        get: function () { return this._x; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Point.prototype, "y", {
	        get: function () { return this._y; },
	        enumerable: true,
	        configurable: true
	    });
	    Point.prototype.add = function (pt) {
	        return new Point(this.x + pt.x, this.y + pt.y);
	    };
	    Point.prototype.sub = function (pt) {
	        return new Point(this.x - pt.x, this.y - pt.y);
	    };
	    Point.prototype.mul = function (pt) {
	        return new Point(this.x * pt.x, this.y * pt.y);
	    };
	    Point.prototype.div = function (pt) {
	        return new Point(this.x / pt.x, this.y / pt.y);
	    };
	    Point.prototype.abs = function () {
	        return new Point(Math.abs(this.x), Math.abs(this.y));
	    };
	    Point.prototype.magnitude = function () {
	        return Math.sqrt(Math.pow(this.x, 2) + Math.pow(this.y, 2));
	    };
	    Point.prototype.floor = function () {
	        return new Point(Math.floor(this.x), Math.floor(this.y));
	    };
	    return Point;
	}());
	exports.Point = Point;
	//# sourceMappingURL=Point.js.map

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	var types_1 = __webpack_require__(584);
	function extractSeparableConvParamsFactory(extractWeights, paramMappings) {
	    return function (channelsIn, channelsOut, mappedPrefix) {
	        var depthwise_filter = tf.tensor4d(extractWeights(3 * 3 * channelsIn), [3, 3, channelsIn, 1]);
	        var pointwise_filter = tf.tensor4d(extractWeights(channelsIn * channelsOut), [1, 1, channelsIn, channelsOut]);
	        var bias = tf.tensor1d(extractWeights(channelsOut));
	        paramMappings.push({ paramPath: mappedPrefix + "/depthwise_filter" }, { paramPath: mappedPrefix + "/pointwise_filter" }, { paramPath: mappedPrefix + "/bias" });
	        return new types_1.SeparableConvParams(depthwise_filter, pointwise_filter, bias);
	    };
	}
	exports.extractSeparableConvParamsFactory = extractSeparableConvParamsFactory;
	function loadSeparableConvParamsFactory(extractWeightEntry) {
	    return function (prefix) {
	        var depthwise_filter = extractWeightEntry(prefix + "/depthwise_filter", 4);
	        var pointwise_filter = extractWeightEntry(prefix + "/pointwise_filter", 4);
	        var bias = extractWeightEntry(prefix + "/bias", 1);
	        return new types_1.SeparableConvParams(depthwise_filter, pointwise_filter, bias);
	    };
	}
	exports.loadSeparableConvParamsFactory = loadSeparableConvParamsFactory;
	//# sourceMappingURL=extractSeparableConvParamsFactory.js.map

/***/ },
/* 382 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function getModelUris(uri, defaultModelName) {
	    var defaultManifestFilename = defaultModelName + "-weights_manifest.json";
	    if (!uri) {
	        return {
	            modelBaseUri: '',
	            manifestUri: defaultManifestFilename
	        };
	    }
	    if (uri === '/') {
	        return {
	            modelBaseUri: '/',
	            manifestUri: "/" + defaultManifestFilename
	        };
	    }
	    var protocol = uri.startsWith('http://') ? 'http://' : uri.startsWith('https://') ? 'https://' : '';
	    uri = uri.replace(protocol, '');
	    var parts = uri.split('/').filter(function (s) { return s; });
	    var manifestFile = uri.endsWith('.json')
	        ? parts[parts.length - 1]
	        : defaultManifestFilename;
	    var modelBaseUri = protocol + (uri.endsWith('.json') ? parts.slice(0, parts.length - 1) : parts).join('/');
	    modelBaseUri = uri.startsWith('/') ? "/" + modelBaseUri : modelBaseUri;
	    return {
	        modelBaseUri: modelBaseUri,
	        manifestUri: modelBaseUri === '/' ? "/" + manifestFile : modelBaseUri + "/" + manifestFile
	    };
	}
	exports.getModelUris = getModelUris;
	//# sourceMappingURL=getModelUris.js.map

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var env_1 = __webpack_require__(55);
	function isMediaLoaded(media) {
	    var _a = env_1.env.getEnv(), Image = _a.Image, Video = _a.Video;
	    return (media instanceof Image && media.complete)
	        || (media instanceof Video && media.readyState >= 3);
	}
	exports.isMediaLoaded = isMediaLoaded;
	//# sourceMappingURL=isMediaLoaded.js.map

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var getContext2dOrThrow_1 = __webpack_require__(139);
	var resolveInput_1 = __webpack_require__(268);
	var AnchorPosition;
	(function (AnchorPosition) {
	    AnchorPosition["TOP_LEFT"] = "TOP_LEFT";
	    AnchorPosition["TOP_RIGHT"] = "TOP_RIGHT";
	    AnchorPosition["BOTTOM_LEFT"] = "BOTTOM_LEFT";
	    AnchorPosition["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
	})(AnchorPosition = exports.AnchorPosition || (exports.AnchorPosition = {}));
	var DrawTextFieldOptions = /** @class */ (function () {
	    function DrawTextFieldOptions(options) {
	        if (options === void 0) { options = {}; }
	        var anchorPosition = options.anchorPosition, backgroundColor = options.backgroundColor, fontColor = options.fontColor, fontSize = options.fontSize, fontStyle = options.fontStyle, padding = options.padding;
	        this.anchorPosition = anchorPosition || AnchorPosition.TOP_LEFT;
	        this.backgroundColor = backgroundColor || 'rgba(0, 0, 0, 0.5)';
	        this.fontColor = fontColor || 'rgba(255, 255, 255, 1)';
	        this.fontSize = fontSize || 14;
	        this.fontStyle = fontStyle || 'Georgia';
	        this.padding = padding || 4;
	    }
	    return DrawTextFieldOptions;
	}());
	exports.DrawTextFieldOptions = DrawTextFieldOptions;
	var DrawTextField = /** @class */ (function () {
	    function DrawTextField(text, anchor, options) {
	        if (options === void 0) { options = {}; }
	        this.text = typeof text === 'string'
	            ? [text]
	            : (text instanceof DrawTextField ? text.text : text);
	        this.anchor = anchor;
	        this.options = new DrawTextFieldOptions(options);
	    }
	    DrawTextField.prototype.measureWidth = function (ctx) {
	        var padding = this.options.padding;
	        return this.text.map(function (l) { return ctx.measureText(l).width; }).reduce(function (w0, w1) { return w0 < w1 ? w1 : w0; }, 0) + (2 * padding);
	    };
	    DrawTextField.prototype.measureHeight = function () {
	        var _a = this.options, fontSize = _a.fontSize, padding = _a.padding;
	        return this.text.length * fontSize + (2 * padding);
	    };
	    DrawTextField.prototype.getUpperLeft = function (ctx, canvasDims) {
	        var anchorPosition = this.options.anchorPosition;
	        var isShiftLeft = anchorPosition === AnchorPosition.BOTTOM_RIGHT || anchorPosition === AnchorPosition.TOP_RIGHT;
	        var isShiftTop = anchorPosition === AnchorPosition.BOTTOM_LEFT || anchorPosition === AnchorPosition.BOTTOM_RIGHT;
	        var textFieldWidth = this.measureWidth(ctx);
	        var textFieldHeight = this.measureHeight();
	        var x = (isShiftLeft ? this.anchor.x - textFieldWidth : this.anchor.x);
	        var y = isShiftTop ? this.anchor.y - textFieldHeight : this.anchor.y;
	        // adjust anchor if text box exceeds canvas borders
	        if (canvasDims) {
	            var width = canvasDims.width, height = canvasDims.height;
	            var newX = Math.max(Math.min(x, width - textFieldWidth), 0);
	            var newY = Math.max(Math.min(y, height - textFieldHeight), 0);
	            return { x: newX, y: newY };
	        }
	        return { x: x, y: y };
	    };
	    DrawTextField.prototype.draw = function (canvasArg) {
	        var canvas = resolveInput_1.resolveInput(canvasArg);
	        var ctx = getContext2dOrThrow_1.getContext2dOrThrow(canvas);
	        var _a = this.options, backgroundColor = _a.backgroundColor, fontColor = _a.fontColor, fontSize = _a.fontSize, fontStyle = _a.fontStyle, padding = _a.padding;
	        ctx.font = fontSize + "px " + fontStyle;
	        var maxTextWidth = this.measureWidth(ctx);
	        var textHeight = this.measureHeight();
	        ctx.fillStyle = backgroundColor;
	        var upperLeft = this.getUpperLeft(ctx, canvas);
	        ctx.fillRect(upperLeft.x, upperLeft.y, maxTextWidth, textHeight);
	        ctx.fillStyle = fontColor;
	        this.text.forEach(function (textLine, i) {
	            var x = padding + upperLeft.x;
	            var y = padding + upperLeft.y + ((i + 1) * fontSize);
	            ctx.fillText(textLine, x, y);
	        });
	    };
	    return DrawTextField;
	}());
	exports.DrawTextField = DrawTextField;
	//# sourceMappingURL=DrawTextField.js.map

/***/ },
/* 385 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.FACE_EXPRESSION_LABELS = ['neutral', 'happy', 'sad', 'angry', 'fearful', 'disgusted', 'surprised'];
	var FaceExpressions = /** @class */ (function () {
	    function FaceExpressions(probabilities) {
	        var _this = this;
	        if (probabilities.length !== 7) {
	            throw new Error("FaceExpressions.constructor - expected probabilities.length to be 7, have: " + probabilities.length);
	        }
	        exports.FACE_EXPRESSION_LABELS.forEach(function (expression, idx) {
	            _this[expression] = probabilities[idx];
	        });
	    }
	    FaceExpressions.prototype.asSortedArray = function () {
	        var _this = this;
	        return exports.FACE_EXPRESSION_LABELS
	            .map(function (expression) { return ({ expression: expression, probability: _this[expression] }); })
	            .sort(function (e0, e1) { return e1.probability - e0.probability; });
	    };
	    return FaceExpressions;
	}());
	exports.FaceExpressions = FaceExpressions;
	//# sourceMappingURL=FaceExpressions.js.map

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var FaceFeatureExtractor_1 = __webpack_require__(599);
	var FaceLandmark68NetBase_1 = __webpack_require__(603);
	var FaceLandmark68Net = /** @class */ (function (_super) {
	    tslib_1.__extends(FaceLandmark68Net, _super);
	    function FaceLandmark68Net(faceFeatureExtractor) {
	        if (faceFeatureExtractor === void 0) { faceFeatureExtractor = new FaceFeatureExtractor_1.FaceFeatureExtractor(); }
	        return _super.call(this, 'FaceLandmark68Net', faceFeatureExtractor) || this;
	    }
	    FaceLandmark68Net.prototype.getDefaultModelName = function () {
	        return 'face_landmark_68_model';
	    };
	    FaceLandmark68Net.prototype.getClassifierChannelsIn = function () {
	        return 256;
	    };
	    return FaceLandmark68Net;
	}(FaceLandmark68NetBase_1.FaceLandmark68NetBase));
	exports.FaceLandmark68Net = FaceLandmark68Net;
	//# sourceMappingURL=FaceLandmark68Net.js.map

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var dom_1 = __webpack_require__(54);
	var NeuralNetwork_1 = __webpack_require__(96);
	var ops_1 = __webpack_require__(98);
	var convLayer_1 = __webpack_require__(607);
	var extractParams_1 = __webpack_require__(1467);
	var extractParamsFromWeigthMap_1 = __webpack_require__(1468);
	var residualLayer_1 = __webpack_require__(1470);
	var FaceRecognitionNet = /** @class */ (function (_super) {
	    tslib_1.__extends(FaceRecognitionNet, _super);
	    function FaceRecognitionNet() {
	        return _super.call(this, 'FaceRecognitionNet') || this;
	    }
	    FaceRecognitionNet.prototype.forwardInput = function (input) {
	        var params = this.params;
	        if (!params) {
	            throw new Error('FaceRecognitionNet - load model before inference');
	        }
	        return tf.tidy(function () {
	            var batchTensor = input.toBatchTensor(150, true).toFloat();
	            var meanRgb = [122.782, 117.001, 104.298];
	            var normalized = ops_1.normalize(batchTensor, meanRgb).div(tf.scalar(256));
	            var out = convLayer_1.convDown(normalized, params.conv32_down);
	            out = tf.maxPool(out, 3, 2, 'valid');
	            out = residualLayer_1.residual(out, params.conv32_1);
	            out = residualLayer_1.residual(out, params.conv32_2);
	            out = residualLayer_1.residual(out, params.conv32_3);
	            out = residualLayer_1.residualDown(out, params.conv64_down);
	            out = residualLayer_1.residual(out, params.conv64_1);
	            out = residualLayer_1.residual(out, params.conv64_2);
	            out = residualLayer_1.residual(out, params.conv64_3);
	            out = residualLayer_1.residualDown(out, params.conv128_down);
	            out = residualLayer_1.residual(out, params.conv128_1);
	            out = residualLayer_1.residual(out, params.conv128_2);
	            out = residualLayer_1.residualDown(out, params.conv256_down);
	            out = residualLayer_1.residual(out, params.conv256_1);
	            out = residualLayer_1.residual(out, params.conv256_2);
	            out = residualLayer_1.residualDown(out, params.conv256_down_out);
	            var globalAvg = out.mean([1, 2]);
	            var fullyConnected = tf.matMul(globalAvg, params.fc);
	            return fullyConnected;
	        });
	    };
	    FaceRecognitionNet.prototype.forward = function (input) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _a;
	            return tslib_1.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        _a = this.forwardInput;
	                        return [4 /*yield*/, dom_1.toNetInput(input)];
	                    case 1: return [2 /*return*/, _a.apply(this, [_b.sent()])];
	                }
	            });
	        });
	    };
	    FaceRecognitionNet.prototype.computeFaceDescriptor = function (input) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var netInput, faceDescriptorTensors, faceDescriptorsForBatch;
	            var _this = this;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, dom_1.toNetInput(input)];
	                    case 1:
	                        netInput = _a.sent();
	                        faceDescriptorTensors = tf.tidy(function () { return tf.unstack(_this.forwardInput(netInput)); });
	                        return [4 /*yield*/, Promise.all(faceDescriptorTensors.map(function (t) { return t.data(); }))];
	                    case 2:
	                        faceDescriptorsForBatch = _a.sent();
	                        faceDescriptorTensors.forEach(function (t) { return t.dispose(); });
	                        return [2 /*return*/, netInput.isBatchInput
	                                ? faceDescriptorsForBatch
	                                : faceDescriptorsForBatch[0]];
	                }
	            });
	        });
	    };
	    FaceRecognitionNet.prototype.getDefaultModelName = function () {
	        return 'face_recognition_model';
	    };
	    FaceRecognitionNet.prototype.extractParamsFromWeigthMap = function (weightMap) {
	        return extractParamsFromWeigthMap_1.extractParamsFromWeigthMap(weightMap);
	    };
	    FaceRecognitionNet.prototype.extractParams = function (weights) {
	        return extractParams_1.extractParams(weights);
	    };
	    return FaceRecognitionNet;
	}(NeuralNetwork_1.NeuralNetwork));
	exports.FaceRecognitionNet = FaceRecognitionNet;
	//# sourceMappingURL=FaceRecognitionNet.js.map

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var FaceExpressions_1 = __webpack_require__(385);
	function isWithFaceExpressions(obj) {
	    return obj['expressions'] instanceof FaceExpressions_1.FaceExpressions;
	}
	exports.isWithFaceExpressions = isWithFaceExpressions;
	function extendWithFaceExpressions(sourceObj, expressions) {
	    var extension = { expressions: expressions };
	    return Object.assign({}, sourceObj, extension);
	}
	exports.extendWithFaceExpressions = extendWithFaceExpressions;
	//# sourceMappingURL=WithFaceExpressions.js.map

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var dom_1 = __webpack_require__(54);
	var WithFaceLandmarks_1 = __webpack_require__(211);
	function extractAllFacesAndComputeResults(parentResults, input, computeResults, extractedFaces, getRectForAlignment) {
	    if (getRectForAlignment === void 0) { getRectForAlignment = function (_a) {
	        var alignedRect = _a.alignedRect;
	        return alignedRect;
	    }; }
	    return tslib_1.__awaiter(this, void 0, void 0, function () {
	        var faceBoxes, faces, _a, _b, results;
	        return tslib_1.__generator(this, function (_c) {
	            switch (_c.label) {
	                case 0:
	                    faceBoxes = parentResults.map(function (parentResult) {
	                        return WithFaceLandmarks_1.isWithFaceLandmarks(parentResult)
	                            ? getRectForAlignment(parentResult)
	                            : parentResult.detection;
	                    });
	                    _a = extractedFaces;
	                    if (_a) return [3 /*break*/, 5];
	                    if (!(input instanceof tf.Tensor)) return [3 /*break*/, 2];
	                    return [4 /*yield*/, dom_1.extractFaceTensors(input, faceBoxes)];
	                case 1:
	                    _b = _c.sent();
	                    return [3 /*break*/, 4];
	                case 2: return [4 /*yield*/, dom_1.extractFaces(input, faceBoxes)];
	                case 3:
	                    _b = _c.sent();
	                    _c.label = 4;
	                case 4:
	                    _a = (_b);
	                    _c.label = 5;
	                case 5:
	                    faces = _a;
	                    return [4 /*yield*/, computeResults(faces)];
	                case 6:
	                    results = _c.sent();
	                    faces.forEach(function (f) { return f instanceof tf.Tensor && f.dispose(); });
	                    return [2 /*return*/, results];
	            }
	        });
	    });
	}
	exports.extractAllFacesAndComputeResults = extractAllFacesAndComputeResults;
	function extractSingleFaceAndComputeResult(parentResult, input, computeResult, extractedFaces, getRectForAlignment) {
	    return tslib_1.__awaiter(this, void 0, void 0, function () {
	        var _this = this;
	        return tslib_1.__generator(this, function (_a) {
	            return [2 /*return*/, extractAllFacesAndComputeResults([parentResult], input, function (faces) { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
	                    return [2 /*return*/, computeResult(faces[0])];
	                }); }); }, extractedFaces, getRectForAlignment)];
	        });
	    });
	}
	exports.extractSingleFaceAndComputeResult = extractSingleFaceAndComputeResult;
	//# sourceMappingURL=extractFacesAndComputeResults.js.map

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var classes_1 = __webpack_require__(48);
	var FaceDetection_1 = __webpack_require__(97);
	var FaceLandmarks5_1 = __webpack_require__(574);
	var dom_1 = __webpack_require__(54);
	var factories_1 = __webpack_require__(611);
	var NeuralNetwork_1 = __webpack_require__(96);
	var bgrToRgbTensor_1 = __webpack_require__(1479);
	var config_1 = __webpack_require__(392);
	var extractParams_1 = __webpack_require__(1480);
	var extractParamsFromWeigthMap_1 = __webpack_require__(1481);
	var getSizesForScale_1 = __webpack_require__(616);
	var MtcnnOptions_1 = __webpack_require__(272);
	var pyramidDown_1 = __webpack_require__(1483);
	var stage1_1 = __webpack_require__(1484);
	var stage2_1 = __webpack_require__(1485);
	var stage3_1 = __webpack_require__(1486);
	var Mtcnn = /** @class */ (function (_super) {
	    tslib_1.__extends(Mtcnn, _super);
	    function Mtcnn() {
	        return _super.call(this, 'Mtcnn') || this;
	    }
	    Mtcnn.prototype.load = function (weightsOrUrl) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                console.warn('mtcnn is deprecated and will be removed soon');
	                return [2 /*return*/, _super.prototype.load.call(this, weightsOrUrl)];
	            });
	        });
	    };
	    Mtcnn.prototype.loadFromDisk = function (filePath) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                console.warn('mtcnn is deprecated and will be removed soon');
	                return [2 /*return*/, _super.prototype.loadFromDisk.call(this, filePath)];
	            });
	        });
	    };
	    Mtcnn.prototype.forwardInput = function (input, forwardParams) {
	        if (forwardParams === void 0) { forwardParams = {}; }
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var params, inputCanvas, stats, tsTotal, imgTensor, onReturn, _a, height, width, _b, minFaceSize, scaleFactor, maxNumScales, scoreThresholds, scaleSteps, scales, ts, out1, out2, out3, results;
	            return tslib_1.__generator(this, function (_c) {
	                switch (_c.label) {
	                    case 0:
	                        params = this.params;
	                        if (!params) {
	                            throw new Error('Mtcnn - load model before inference');
	                        }
	                        inputCanvas = input.canvases[0];
	                        if (!inputCanvas) {
	                            throw new Error('Mtcnn - inputCanvas is not defined, note that passing tensors into Mtcnn.forwardInput is not supported yet.');
	                        }
	                        stats = {};
	                        tsTotal = Date.now();
	                        imgTensor = tf.tidy(function () {
	                            return bgrToRgbTensor_1.bgrToRgbTensor(tf.expandDims(tf.browser.fromPixels(inputCanvas)).toFloat());
	                        });
	                        onReturn = function (results) {
	                            // dispose tensors on return
	                            imgTensor.dispose();
	                            stats.total = Date.now() - tsTotal;
	                            return results;
	                        };
	                        _a = imgTensor.shape.slice(1), height = _a[0], width = _a[1];
	                        _b = new MtcnnOptions_1.MtcnnOptions(forwardParams), minFaceSize = _b.minFaceSize, scaleFactor = _b.scaleFactor, maxNumScales = _b.maxNumScales, scoreThresholds = _b.scoreThresholds, scaleSteps = _b.scaleSteps;
	                        scales = (scaleSteps || pyramidDown_1.pyramidDown(minFaceSize, scaleFactor, [height, width]))
	                            .filter(function (scale) {
	                            var sizes = getSizesForScale_1.getSizesForScale(scale, [height, width]);
	                            return Math.min(sizes.width, sizes.height) > config_1.CELL_SIZE;
	                        })
	                            .slice(0, maxNumScales);
	                        stats.scales = scales;
	                        stats.pyramid = scales.map(function (scale) { return getSizesForScale_1.getSizesForScale(scale, [height, width]); });
	                        ts = Date.now();
	                        return [4 /*yield*/, stage1_1.stage1(imgTensor, scales, scoreThresholds[0], params.pnet, stats)];
	                    case 1:
	                        out1 = _c.sent();
	                        stats.total_stage1 = Date.now() - ts;
	                        if (!out1.boxes.length) {
	                            return [2 /*return*/, onReturn({ results: [], stats: stats })];
	                        }
	                        stats.stage2_numInputBoxes = out1.boxes.length;
	                        // using the inputCanvas to extract and resize the image patches, since it is faster
	                        // than doing this on the gpu
	                        ts = Date.now();
	                        return [4 /*yield*/, stage2_1.stage2(inputCanvas, out1.boxes, scoreThresholds[1], params.rnet, stats)];
	                    case 2:
	                        out2 = _c.sent();
	                        stats.total_stage2 = Date.now() - ts;
	                        if (!out2.boxes.length) {
	                            return [2 /*return*/, onReturn({ results: [], stats: stats })];
	                        }
	                        stats.stage3_numInputBoxes = out2.boxes.length;
	                        ts = Date.now();
	                        return [4 /*yield*/, stage3_1.stage3(inputCanvas, out2.boxes, scoreThresholds[2], params.onet, stats)];
	                    case 3:
	                        out3 = _c.sent();
	                        stats.total_stage3 = Date.now() - ts;
	                        results = out3.boxes.map(function (box, idx) { return factories_1.extendWithFaceLandmarks(factories_1.extendWithFaceDetection({}, new FaceDetection_1.FaceDetection(out3.scores[idx], new classes_1.Rect(box.left / width, box.top / height, box.width / width, box.height / height), {
	                            height: height,
	                            width: width
	                        })), new FaceLandmarks5_1.FaceLandmarks5(out3.points[idx].map(function (pt) { return pt.sub(new classes_1.Point(box.left, box.top)).div(new classes_1.Point(box.width, box.height)); }), { width: box.width, height: box.height })); });
	                        return [2 /*return*/, onReturn({ results: results, stats: stats })];
	                }
	            });
	        });
	    };
	    Mtcnn.prototype.forward = function (input, forwardParams) {
	        if (forwardParams === void 0) { forwardParams = {}; }
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _a;
	            return tslib_1.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        _a = this.forwardInput;
	                        return [4 /*yield*/, dom_1.toNetInput(input)];
	                    case 1: return [4 /*yield*/, _a.apply(this, [_b.sent(),
	                            forwardParams])];
	                    case 2: return [2 /*return*/, (_b.sent()).results];
	                }
	            });
	        });
	    };
	    Mtcnn.prototype.forwardWithStats = function (input, forwardParams) {
	        if (forwardParams === void 0) { forwardParams = {}; }
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _a;
	            return tslib_1.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        _a = this.forwardInput;
	                        return [4 /*yield*/, dom_1.toNetInput(input)];
	                    case 1: return [2 /*return*/, _a.apply(this, [_b.sent(),
	                            forwardParams])];
	                }
	            });
	        });
	    };
	    Mtcnn.prototype.getDefaultModelName = function () {
	        return 'mtcnn_model';
	    };
	    Mtcnn.prototype.extractParamsFromWeigthMap = function (weightMap) {
	        return extractParamsFromWeigthMap_1.extractParamsFromWeigthMap(weightMap);
	    };
	    Mtcnn.prototype.extractParams = function (weights) {
	        return extractParams_1.extractParams(weights);
	    };
	    return Mtcnn;
	}(NeuralNetwork_1.NeuralNetwork));
	exports.Mtcnn = Mtcnn;
	//# sourceMappingURL=Mtcnn.js.map

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var classes_1 = __webpack_require__(48);
	var MtcnnBox = /** @class */ (function (_super) {
	    tslib_1.__extends(MtcnnBox, _super);
	    function MtcnnBox(left, top, right, bottom) {
	        return _super.call(this, { left: left, top: top, right: right, bottom: bottom }, true) || this;
	    }
	    return MtcnnBox;
	}(classes_1.Box));
	exports.MtcnnBox = MtcnnBox;
	//# sourceMappingURL=MtcnnBox.js.map

/***/ },
/* 392 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.CELL_STRIDE = 2;
	exports.CELL_SIZE = 12;
	//# sourceMappingURL=config.js.map

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	function prelu(x, alpha) {
	    return tf.tidy(function () {
	        return tf.add(tf.relu(x), tf.mul(alpha, tf.neg(tf.relu(tf.neg(x)))));
	    });
	}
	exports.prelu = prelu;
	//# sourceMappingURL=prelu.js.map

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	var common_1 = __webpack_require__(33);
	var prelu_1 = __webpack_require__(393);
	function sharedLayer(x, params, isPnet) {
	    if (isPnet === void 0) { isPnet = false; }
	    return tf.tidy(function () {
	        var out = common_1.convLayer(x, params.conv1, 'valid');
	        out = prelu_1.prelu(out, params.prelu1_alpha);
	        out = tf.maxPool(out, isPnet ? [2, 2] : [3, 3], [2, 2], 'same');
	        out = common_1.convLayer(out, params.conv2, 'valid');
	        out = prelu_1.prelu(out, params.prelu2_alpha);
	        out = isPnet ? out : tf.maxPool(out, [3, 3], [2, 2], 'valid');
	        out = common_1.convLayer(out, params.conv3, 'valid');
	        out = prelu_1.prelu(out, params.prelu3_alpha);
	        return out;
	    });
	}
	exports.sharedLayer = sharedLayer;
	//# sourceMappingURL=sharedLayers.js.map

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var classes_1 = __webpack_require__(48);
	var FaceDetection_1 = __webpack_require__(97);
	var dom_1 = __webpack_require__(54);
	var NeuralNetwork_1 = __webpack_require__(96);
	var extractParams_1 = __webpack_require__(1491);
	var extractParamsFromWeigthMap_1 = __webpack_require__(1492);
	var mobileNetV1_1 = __webpack_require__(1493);
	var nonMaxSuppression_1 = __webpack_require__(1494);
	var outputLayer_1 = __webpack_require__(1495);
	var predictionLayer_1 = __webpack_require__(1496);
	var SsdMobilenetv1Options_1 = __webpack_require__(273);
	var SsdMobilenetv1 = /** @class */ (function (_super) {
	    tslib_1.__extends(SsdMobilenetv1, _super);
	    function SsdMobilenetv1() {
	        return _super.call(this, 'SsdMobilenetv1') || this;
	    }
	    SsdMobilenetv1.prototype.forwardInput = function (input) {
	        var params = this.params;
	        if (!params) {
	            throw new Error('SsdMobilenetv1 - load model before inference');
	        }
	        return tf.tidy(function () {
	            var batchTensor = input.toBatchTensor(512, false).toFloat();
	            var x = tf.sub(tf.mul(batchTensor, tf.scalar(0.007843137718737125)), tf.scalar(1));
	            var features = mobileNetV1_1.mobileNetV1(x, params.mobilenetv1);
	            var _a = predictionLayer_1.predictionLayer(features.out, features.conv11, params.prediction_layer), boxPredictions = _a.boxPredictions, classPredictions = _a.classPredictions;
	            return outputLayer_1.outputLayer(boxPredictions, classPredictions, params.output_layer);
	        });
	    };
	    SsdMobilenetv1.prototype.forward = function (input) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _a;
	            return tslib_1.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        _a = this.forwardInput;
	                        return [4 /*yield*/, dom_1.toNetInput(input)];
	                    case 1: return [2 /*return*/, _a.apply(this, [_b.sent()])];
	                }
	            });
	        });
	    };
	    SsdMobilenetv1.prototype.locateFaces = function (input, options) {
	        if (options === void 0) { options = {}; }
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _a, maxResults, minConfidence, netInput, _b, _boxes, _scores, boxes, scores, i, scoresData, _c, _d, iouThreshold, indices, reshapedDims, inputSize, padX, padY, boxesData, results;
	            return tslib_1.__generator(this, function (_e) {
	                switch (_e.label) {
	                    case 0:
	                        _a = new SsdMobilenetv1Options_1.SsdMobilenetv1Options(options), maxResults = _a.maxResults, minConfidence = _a.minConfidence;
	                        return [4 /*yield*/, dom_1.toNetInput(input)];
	                    case 1:
	                        netInput = _e.sent();
	                        _b = this.forwardInput(netInput), _boxes = _b.boxes, _scores = _b.scores;
	                        boxes = _boxes[0];
	                        scores = _scores[0];
	                        for (i = 1; i < _boxes.length; i++) {
	                            _boxes[i].dispose();
	                            _scores[i].dispose();
	                        }
	                        _d = (_c = Array).from;
	                        return [4 /*yield*/, scores.data()];
	                    case 2:
	                        scoresData = _d.apply(_c, [_e.sent()]);
	                        iouThreshold = 0.5;
	                        indices = nonMaxSuppression_1.nonMaxSuppression(boxes, scoresData, maxResults, iouThreshold, minConfidence);
	                        reshapedDims = netInput.getReshapedInputDimensions(0);
	                        inputSize = netInput.inputSize;
	                        padX = inputSize / reshapedDims.width;
	                        padY = inputSize / reshapedDims.height;
	                        boxesData = boxes.arraySync();
	                        results = indices
	                            .map(function (idx) {
	                            var _a = [
	                                Math.max(0, boxesData[idx][0]),
	                                Math.min(1.0, boxesData[idx][2])
	                            ].map(function (val) { return val * padY; }), top = _a[0], bottom = _a[1];
	                            var _b = [
	                                Math.max(0, boxesData[idx][1]),
	                                Math.min(1.0, boxesData[idx][3])
	                            ].map(function (val) { return val * padX; }), left = _b[0], right = _b[1];
	                            return new FaceDetection_1.FaceDetection(scoresData[idx], new classes_1.Rect(left, top, right - left, bottom - top), {
	                                height: netInput.getInputHeight(0),
	                                width: netInput.getInputWidth(0)
	                            });
	                        });
	                        boxes.dispose();
	                        scores.dispose();
	                        return [2 /*return*/, results];
	                }
	            });
	        });
	    };
	    SsdMobilenetv1.prototype.getDefaultModelName = function () {
	        return 'ssd_mobilenetv1_model';
	    };
	    SsdMobilenetv1.prototype.extractParamsFromWeigthMap = function (weightMap) {
	        return extractParamsFromWeigthMap_1.extractParamsFromWeigthMap(weightMap);
	    };
	    SsdMobilenetv1.prototype.extractParams = function (weights) {
	        return extractParams_1.extractParams(weights);
	    };
	    return SsdMobilenetv1;
	}(NeuralNetwork_1.NeuralNetwork));
	exports.SsdMobilenetv1 = SsdMobilenetv1;
	//# sourceMappingURL=SsdMobilenetv1.js.map

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var classes_1 = __webpack_require__(48);
	var TinyYolov2Base_1 = __webpack_require__(625);
	var const_1 = __webpack_require__(1497);
	var TinyFaceDetector = /** @class */ (function (_super) {
	    tslib_1.__extends(TinyFaceDetector, _super);
	    function TinyFaceDetector() {
	        var _this = this;
	        var config = {
	            withSeparableConvs: true,
	            iouThreshold: const_1.IOU_THRESHOLD,
	            classes: ['face'],
	            anchors: const_1.BOX_ANCHORS,
	            meanRgb: const_1.MEAN_RGB,
	            isFirstLayerConv2d: true,
	            filterSizes: [3, 16, 32, 64, 128, 256, 512]
	        };
	        _this = _super.call(this, config) || this;
	        return _this;
	    }
	    Object.defineProperty(TinyFaceDetector.prototype, "anchors", {
	        get: function () {
	            return this.config.anchors;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TinyFaceDetector.prototype.locateFaces = function (input, forwardParams) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var objectDetections;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.detect(input, forwardParams)];
	                    case 1:
	                        objectDetections = _a.sent();
	                        return [2 /*return*/, objectDetections.map(function (det) { return new classes_1.FaceDetection(det.score, det.relativeBox, { width: det.imageWidth, height: det.imageHeight }); })];
	                }
	            });
	        });
	    };
	    TinyFaceDetector.prototype.getDefaultModelName = function () {
	        return 'tiny_face_detector_model';
	    };
	    TinyFaceDetector.prototype.extractParamsFromWeigthMap = function (weightMap) {
	        return _super.prototype.extractParamsFromWeigthMap.call(this, weightMap);
	    };
	    return TinyFaceDetector;
	}(TinyYolov2Base_1.TinyYolov2Base));
	exports.TinyFaceDetector = TinyFaceDetector;
	//# sourceMappingURL=TinyFaceDetector.js.map

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	function leaky(x) {
	    return tf.tidy(function () {
	        var min = tf.mul(x, tf.scalar(0.10000000149011612));
	        return tf.add(tf.relu(tf.sub(x, min)), min);
	        //return tf.maximum(x, min)
	    });
	}
	exports.leaky = leaky;
	//# sourceMappingURL=leaky.js.map

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 399 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 400 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./shams')} */
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		/** @type {{ [k in symbol]?: unknown }} */
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			// eslint-disable-next-line no-extra-parens
			var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(170);
	
	var _DOMUtils = __webpack_require__(276);
	
	var _DOMStateStorage = __webpack_require__(635);
	
	var _PathUtils = __webpack_require__(126);
	
	var _ExecutionEnvironment = __webpack_require__(402);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },
/* 402 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(1525);
	
	var _PathUtils = __webpack_require__(126);
	
	var _runTransitionHook = __webpack_require__(404);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(275);
	
	var _LocationUtils = __webpack_require__(170);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(454);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 406 */
/***/ function(module, exports) {

	module.exports = isPromise;
	module.exports.default = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ },
/* 407 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 408 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(142),
	    root = __webpack_require__(101);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1621),
	    mapCacheDelete = __webpack_require__(1622),
	    mapCacheGet = __webpack_require__(1623),
	    mapCacheHas = __webpack_require__(1624),
	    mapCacheSet = __webpack_require__(1625);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1577),
	    isObjectLike = __webpack_require__(173);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 412 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(102),
	    isSymbol = __webpack_require__(215);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 414 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(659),
	    isLength = __webpack_require__(416);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 416 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(172),
	    getPrototype = __webpack_require__(1601),
	    isObjectLike = __webpack_require__(173);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(1569),
	    baseKeys = __webpack_require__(1581),
	    isArrayLike = __webpack_require__(415);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 419 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./floor')} */
	module.exports = Math.floor;


/***/ },
/* 420 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = mergeClassNames;
	
	function mergeClassNames() {
	  return Array.prototype.slice.call(arguments).reduce(function (classList, arg) {
	    return classList.concat(arg);
	  }, []).filter(function (arg) {
	    return typeof arg === 'string';
	  }).join(' ');
	}

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(807);
	
	var lacksProperEnumerationOrder = function () {
		if (!Object.assign) {
			return false;
		}
		/*
		 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
		 * note: this does not detect the bug unless there's 20 characters
		 */
		var str = 'abcdefghijklmnopqrst';
		var letters = str.split('');
		var map = {};
		for (var i = 0; i < letters.length; ++i) {
			map[letters[i]] = letters[i];
		}
		var obj = Object.assign({}, map);
		var actual = '';
		for (var k in obj) {
			actual += k;
		}
		return str !== actual;
	};
	
	var assignHasPendingExceptions = function () {
		if (!Object.assign || !Object.preventExtensions) {
			return false;
		}
		/*
		 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
		 * which is 72% slower than our shim, and Firefox 40's native implementation.
		 */
		var thrower = Object.preventExtensions({ 1: 2 });
		try {
			Object.assign(thrower, 'xy');
		} catch (e) {
			return thrower[1] === 'y';
		}
		return false;
	};
	
	module.exports = function getPolyfill() {
		if (!Object.assign) {
			return implementation;
		}
		if (lacksProperEnumerationOrder()) {
			return implementation;
		}
		if (assignHasPendingExceptions()) {
			return implementation;
		}
		return Object.assign;
	};


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(94);
	var callBind = __webpack_require__(248);
	
	var implementation = __webpack_require__(808);
	var getPolyfill = __webpack_require__(809);
	var shim = __webpack_require__(1672);
	
	var polyfill = callBind(getPolyfill(), Object);
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ },
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateResponseStatus = exports.validateRangeRequestCapabilities = exports.extractFilenameFromHeader = exports.createResponseStatusError = undefined;
	
	var _util = __webpack_require__(14);
	
	var _content_disposition = __webpack_require__(1705);
	
	function validateRangeRequestCapabilities(_ref) {
	  var getResponseHeader = _ref.getResponseHeader,
	      isHttp = _ref.isHttp,
	      rangeChunkSize = _ref.rangeChunkSize,
	      disableRange = _ref.disableRange;
	
	  (0, _util.assert)(rangeChunkSize > 0, 'Range chunk size must be larger than zero');
	  var returnValues = {
	    allowRangeRequests: false,
	    suggestedLength: undefined
	  };
	  if (disableRange || !isHttp) {
	    return returnValues;
	  }
	  if (getResponseHeader('Accept-Ranges') !== 'bytes') {
	    return returnValues;
	  }
	  var contentEncoding = getResponseHeader('Content-Encoding') || 'identity';
	  if (contentEncoding !== 'identity') {
	    return returnValues;
	  }
	  var length = parseInt(getResponseHeader('Content-Length'), 10);
	  if (!Number.isInteger(length)) {
	    return returnValues;
	  }
	  returnValues.suggestedLength = length;
	  if (length <= 2 * rangeChunkSize) {
	    return returnValues;
	  }
	  returnValues.allowRangeRequests = true;
	  return returnValues;
	}
	function extractFilenameFromHeader(getResponseHeader) {
	  var contentDisposition = getResponseHeader('Content-Disposition');
	  if (contentDisposition) {
	    var filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);
	    if (/\.pdf$/i.test(filename)) {
	      return filename;
	    }
	  }
	  return null;
	}
	function createResponseStatusError(status, url) {
	  if (status === 404 || status === 0 && /^file:/.test(url)) {
	    return new _util.MissingPDFException('Missing PDF "' + url + '".');
	  }
	  return new _util.UnexpectedResponseException('Unexpected server response (' + status + ') while retrieving PDF "' + url + '".', status);
	}
	function validateResponseStatus(status) {
	  return status === 200 || status === 206;
	}
	exports.createResponseStatusError = createResponseStatusError;
	exports.extractFilenameFromHeader = extractFilenameFromHeader;
	exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
	exports.validateResponseStatus = validateResponseStatus;

/***/ },
/* 427 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = compareObjects;
	function compareObjects(objA, objB) {
	  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  if (objA === objB) {
	    return false;
	  }
	
	  var aKeys = Object.keys(objA);
	  var bKeys = Object.keys(objB);
	
	  if (aKeys.length !== bKeys.length) {
	    return true;
	  }
	
	  var keysMap = {};
	  var i = void 0,
	      len = void 0;
	
	  for (i = 0, len = keys.length; i < len; i++) {
	    keysMap[keys[i]] = true;
	  }
	
	  for (i = 0, len = aKeys.length; i < len; i++) {
	    var key = aKeys[i];
	    var aValue = objA[key];
	    var bValue = objB[key];
	
	    if (aValue === bValue) {
	      continue;
	    }
	
	    if (!keysMap[key] || aValue === null || bValue === null || (typeof aValue === 'undefined' ? 'undefined' : _typeof(aValue)) !== 'object' || (typeof bValue === 'undefined' ? 'undefined' : _typeof(bValue)) !== 'object') {
	      return true;
	    }
	
	    var aValueKeys = Object.keys(aValue);
	    var bValueKeys = Object.keys(bValue);
	
	    if (aValueKeys.length !== bValueKeys.length) {
	      return true;
	    }
	
	    for (var n = 0, length = aValueKeys.length; n < length; n++) {
	      var aValueKey = aValueKeys[n];
	
	      if (aValue[aValueKey] !== bValue[aValueKey]) {
	        return true;
	      }
	    }
	  }
	
	  return false;
	}

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _style = __webpack_require__(260);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(904);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _capitalize = __webpack_require__(850);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _createChainedFunction = __webpack_require__(50);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MARGINS = {
	  height: ['marginTop', 'marginBottom'],
	  width: ['marginLeft', 'marginRight']
	};
	
	// reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	function triggerBrowserReflow(node) {
	  node.offsetHeight; // eslint-disable-line no-unused-expressions
	}
	
	function getDimensionValue(dimension, elem) {
	  var value = elem['offset' + (0, _capitalize2['default'])(dimension)];
	  var margins = MARGINS[dimension];
	
	  return value + parseInt((0, _style2['default'])(elem, margins[0]), 10) + parseInt((0, _style2['default'])(elem, margins[1]), 10);
	}
	
	var propTypes = {
	  /**
	   * Show the component; triggers the expand or collapse animation
	   */
	  'in': _propTypes2['default'].bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is collapsed
	   */
	  unmountOnExit: _propTypes2['default'].bool,
	
	  /**
	   * Run the expand animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2['default'].bool,
	
	  /**
	   * Duration of the collapse animation in milliseconds, to ensure that
	   * finishing callbacks are fired even if the original browser transition end
	   * events are canceled
	   */
	  timeout: _propTypes2['default'].number,
	
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _propTypes2['default'].func,
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _propTypes2['default'].func,
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * The dimension used when collapsing, or a function that returns the
	   * dimension
	   *
	   * _Note: Bootstrap only partially supports 'width'!
	   * You will need to supply your own CSS animation for the `.width` CSS class._
	   */
	  dimension: _propTypes2['default'].oneOfType([_propTypes2['default'].oneOf(['height', 'width']), _propTypes2['default'].func]),
	
	  /**
	   * Function that returns the height or width of the animating DOM node
	   *
	   * Allows for providing some custom logic for how much the Collapse component
	   * should animate in its specified dimension. Called with the current
	   * dimension prop value and the DOM node.
	   */
	  getDimensionValue: _propTypes2['default'].func,
	
	  /**
	   * ARIA role of collapsible element
	   */
	  role: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  dimension: 'height',
	  getDimensionValue: getDimensionValue
	};
	
	var Collapse = function (_React$Component) {
	  (0, _inherits3['default'])(Collapse, _React$Component);
	
	  function Collapse(props, context) {
	    (0, _classCallCheck3['default'])(this, Collapse);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleEntered = _this.handleEntered.bind(_this);
	    _this.handleExit = _this.handleExit.bind(_this);
	    _this.handleExiting = _this.handleExiting.bind(_this);
	    return _this;
	  }
	
	  /* -- Expanding -- */
	
	
	  Collapse.prototype.handleEnter = function handleEnter(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.handleEntering = function handleEntering(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
	  };
	
	  Collapse.prototype.handleEntered = function handleEntered(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = null;
	  };
	
	  /* -- Collapsing -- */
	
	
	  Collapse.prototype.handleExit = function handleExit(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
	    triggerBrowserReflow(elem);
	  };
	
	  Collapse.prototype.handleExiting = function handleExiting(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype._dimension = function _dimension() {
	    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
	  };
	
	  // for testing
	
	
	  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
	    return elem['scroll' + (0, _capitalize2['default'])(dimension)] + 'px';
	  };
	
	  Collapse.prototype.render = function render() {
	    var _props = this.props,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className']);
	
	
	    delete props.dimension;
	    delete props.getDimensionValue;
	
	    var handleEnter = (0, _createChainedFunction2['default'])(this.handleEnter, onEnter);
	    var handleEntering = (0, _createChainedFunction2['default'])(this.handleEntering, onEntering);
	    var handleEntered = (0, _createChainedFunction2['default'])(this.handleEntered, onEntered);
	    var handleExit = (0, _createChainedFunction2['default'])(this.handleExit, onExit);
	    var handleExiting = (0, _createChainedFunction2['default'])(this.handleExiting, onExiting);
	
	    var classes = {
	      width: this._dimension() === 'width'
	    };
	
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, props, {
	      'aria-expanded': props.role ? props['in'] : null,
	      className: (0, _classnames2['default'])(className, classes),
	      exitedClassName: 'collapse',
	      exitingClassName: 'collapsing',
	      enteredClassName: 'collapse in',
	      enteringClassName: 'collapsing',
	      onEnter: handleEnter,
	      onEntering: handleEntering,
	      onEntered: handleEntered,
	      onExit: handleExit,
	      onExiting: handleExiting
	    }));
	  };
	
	  return Collapse;
	}(_react2['default'].Component);
	
	Collapse.propTypes = propTypes;
	Collapse.defaultProps = defaultProps;
	
	exports['default'] = Collapse;
	module.exports = exports['default'];

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
	   */
	  glyph: _propTypes2['default'].string.isRequired
	};
	
	var Glyphicon = function (_React$Component) {
	  (0, _inherits3['default'])(Glyphicon, _React$Component);
	
	  function Glyphicon() {
	    (0, _classCallCheck3['default'])(this, Glyphicon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Glyphicon.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        glyph = _props.glyph,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['glyph', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, glyph)] = true, _extends2));
	
	    return _react2['default'].createElement('span', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Glyphicon;
	}(_react2['default'].Component);
	
	Glyphicon.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('glyphicon', Glyphicon);
	module.exports = exports['default'];

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _MediaBody = __webpack_require__(1767);
	
	var _MediaBody2 = _interopRequireDefault(_MediaBody);
	
	var _MediaHeading = __webpack_require__(1768);
	
	var _MediaHeading2 = _interopRequireDefault(_MediaHeading);
	
	var _MediaLeft = __webpack_require__(1769);
	
	var _MediaLeft2 = _interopRequireDefault(_MediaLeft);
	
	var _MediaList = __webpack_require__(1770);
	
	var _MediaList2 = _interopRequireDefault(_MediaList);
	
	var _MediaListItem = __webpack_require__(1771);
	
	var _MediaListItem2 = _interopRequireDefault(_MediaListItem);
	
	var _MediaRight = __webpack_require__(1772);
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Media = function (_React$Component) {
	  (0, _inherits3['default'])(Media, _React$Component);
	
	  function Media() {
	    (0, _classCallCheck3['default'])(this, Media);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Media.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Media;
	}(_react2['default'].Component);
	
	Media.propTypes = propTypes;
	Media.defaultProps = defaultProps;
	
	Media.Heading = _MediaHeading2['default'];
	Media.Body = _MediaBody2['default'];
	Media.Left = _MediaLeft2['default'];
	Media.Right = _MediaRight2['default'];
	Media.List = _MediaList2['default'];
	Media.ListItem = _MediaListItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media', Media);
	module.exports = exports['default'];

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uncontrollable = __webpack_require__(305);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TAB = 'tab';
	var PANE = 'pane';
	
	var idPropType = _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]);
	
	var propTypes = {
	  /**
	   * HTML id attribute, required if no `generateChildId` prop
	   * is specified.
	   */
	  id: function id(props) {
	    var error = null;
	
	    if (!props.generateChildId) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      error = idPropType.apply(undefined, [props].concat(args));
	
	      if (!error && !props.id) {
	        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
	      }
	    }
	
	    return error;
	  },
	
	
	  /**
	   * A function that takes an `eventKey` and `type` and returns a unique id for
	   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
	   * function, meaning it should always return the _same_ id for the same set
	   * of inputs. The default value requires that an `id` to be set for the
	   * `<TabContainer>`.
	   *
	   * The `type` argument will either be `"tab"` or `"pane"`.
	   *
	   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	   */
	  generateChildId: _propTypes2['default'].func,
	
	  /**
	   * A callback fired when a tab is selected.
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * The `eventKey` of the currently active tab.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2['default'].any
	};
	
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any,
	    onSelect: _propTypes2['default'].func.isRequired,
	    getTabId: _propTypes2['default'].func.isRequired,
	    getPaneId: _propTypes2['default'].func.isRequired
	  })
	};
	
	var TabContainer = function (_React$Component) {
	  (0, _inherits3['default'])(TabContainer, _React$Component);
	
	  function TabContainer() {
	    (0, _classCallCheck3['default'])(this, TabContainer);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  TabContainer.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        activeKey = _props.activeKey,
	        onSelect = _props.onSelect,
	        generateChildId = _props.generateChildId,
	        id = _props.id;
	
	
	    var getId = generateChildId || function (key, type) {
	      return id ? id + '-' + type + '-' + key : null;
	    };
	
	    return {
	      $bs_tabContainer: {
	        activeKey: activeKey,
	        onSelect: onSelect,
	        getTabId: function getTabId(key) {
	          return getId(key, TAB);
	        },
	        getPaneId: function getPaneId(key) {
	          return getId(key, PANE);
	        }
	      }
	    };
	  };
	
	  TabContainer.prototype.render = function render() {
	    var _props2 = this.props,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['children']);
	
	
	    delete props.generateChildId;
	    delete props.onSelect;
	    delete props.activeKey;
	
	    return _react2['default'].cloneElement(_react2['default'].Children.only(children), props);
	  };
	
	  return TabContainer;
	}(_react2['default'].Component);
	
	TabContainer.propTypes = propTypes;
	TabContainer.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _uncontrollable2['default'])(TabContainer, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Sets a default animation strategy for all children `<TabPane>`s. Use
	   * `false` to disable, `true` to enable the default `<Fade>` animation or any
	   * `<Transition>` component.
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when they are no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any
	  })
	};
	
	var childContextTypes = {
	  $bs_tabContent: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	    activeKey: _propTypes2['default'].any,
	    mountOnEnter: _propTypes2['default'].bool,
	    unmountOnExit: _propTypes2['default'].bool,
	    onPaneEnter: _propTypes2['default'].func.isRequired,
	    onPaneExited: _propTypes2['default'].func.isRequired,
	    exiting: _propTypes2['default'].bool.isRequired
	  })
	};
	
	var TabContent = function (_React$Component) {
	  (0, _inherits3['default'])(TabContent, _React$Component);
	
	  function TabContent(props, context) {
	    (0, _classCallCheck3['default'])(this, TabContent);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
	    _this.handlePaneExited = _this.handlePaneExited.bind(_this);
	
	    // Active entries in state will be `null` unless `animation` is set. Need
	    // to track active child in case keys swap and the active child changes
	    // but the active key does not.
	    _this.state = {
	      activeKey: null,
	      activeChild: null
	    };
	    return _this;
	  }
	
	  TabContent.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit;
	
	
	    var stateActiveKey = this.state.activeKey;
	    var containerActiveKey = this.getContainerActiveKey();
	
	    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
	    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
	
	    return {
	      $bs_tabContent: {
	        bsClass: bsClass,
	        animation: animation,
	        activeKey: activeKey,
	        mountOnEnter: mountOnEnter,
	        unmountOnExit: unmountOnExit,
	        onPaneEnter: this.handlePaneEnter,
	        onPaneExited: this.handlePaneExited,
	        exiting: exiting
	      }
	    };
	  };
	
	  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!nextProps.animation && this.state.activeChild) {
	      this.setState({ activeKey: null, activeChild: null });
	    }
	  };
	
	  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
	    if (!this.props.animation) {
	      return false;
	    }
	
	    // It's possible that this child should be transitioning out.
	    if (childKey !== this.getContainerActiveKey()) {
	      return false;
	    }
	
	    this.setState({
	      activeKey: childKey,
	      activeChild: child
	    });
	
	    return true;
	  };
	
	  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
	    // This might happen as everything is unmounting.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState(function (_ref) {
	      var activeChild = _ref.activeChild;
	
	      if (activeChild !== child) {
	        return null;
	      }
	
	      return {
	        activeKey: null,
	        activeChild: null
	      };
	    });
	  };
	
	  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
	    var tabContainer = this.context.$bs_tabContainer;
	    return tabContainer && tabContainer.activeKey;
	  };
	
	  TabContent.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        className = _props2.className,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'className']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'content'))
	    }));
	  };
	
	  return TabContent;
	}(_react2['default'].Component);
	
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;
	TabContent.contextTypes = contextTypes;
	TabContent.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab', TabContent);
	module.exports = exports['default'];

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.PureCalendarDay = void 0;
	
	var _reactAddonsShallowCompare = _interopRequireDefault(__webpack_require__(70));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(105));
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _defaultPhrases = __webpack_require__(51);
	
	var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(60));
	
	var _getCalendarDaySettings = _interopRequireDefault(__webpack_require__(870));
	
	var _ModifiersShape = _interopRequireDefault(__webpack_require__(289));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () { function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); } return _getPrototypeOf; }(); return _getPrototypeOf(o); }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function () { function _setPrototypeOf(o, p) { o.__proto__ = p; return o; } return _setPrototypeOf; }(); return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
	  day: _reactMomentProptypes["default"].momentObj,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  isOutsideDay: _propTypes["default"].bool,
	  modifiers: _ModifiersShape["default"],
	  isFocused: _propTypes["default"].bool,
	  tabIndex: _propTypes["default"].oneOf([0, -1]),
	  onDayClick: _propTypes["default"].func,
	  onDayMouseEnter: _propTypes["default"].func,
	  onDayMouseLeave: _propTypes["default"].func,
	  renderDayContents: _propTypes["default"].func,
	  ariaLabelFormat: _propTypes["default"].string,
	  // internationalization
	  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.CalendarDayPhrases))
	})) : {};
	var defaultProps = {
	  day: (0, _moment["default"])(),
	  daySize: _constants.DAY_SIZE,
	  isOutsideDay: false,
	  modifiers: new Set(),
	  isFocused: false,
	  tabIndex: -1,
	  onDayClick: function () {
	    function onDayClick() {}
	
	    return onDayClick;
	  }(),
	  onDayMouseEnter: function () {
	    function onDayMouseEnter() {}
	
	    return onDayMouseEnter;
	  }(),
	  onDayMouseLeave: function () {
	    function onDayMouseLeave() {}
	
	    return onDayMouseLeave;
	  }(),
	  renderDayContents: null,
	  ariaLabelFormat: 'dddd, LL',
	  // internationalization
	  phrases: _defaultPhrases.CalendarDayPhrases
	};
	
	var CalendarDay =
	/*#__PURE__*/
	function (_ref) {
	  _inherits(CalendarDay, _ref);
	
	  _createClass(CalendarDay, [{
	    key: !_react["default"].PureComponent && "shouldComponentUpdate",
	    value: function () {
	      function value(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
	      }
	
	      return value;
	    }()
	  }]);
	
	  function CalendarDay() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, CalendarDay);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CalendarDay)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.setButtonRef = _this.setButtonRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    return _this;
	  }
	
	  _createClass(CalendarDay, [{
	    key: "componentDidUpdate",
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var _this$props = this.props,
	            isFocused = _this$props.isFocused,
	            tabIndex = _this$props.tabIndex;
	
	        if (tabIndex === 0) {
	          if (isFocused || tabIndex !== prevProps.tabIndex) {
	            this.buttonRef.focus();
	          }
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: "onDayClick",
	    value: function () {
	      function onDayClick(day, e) {
	        var onDayClick = this.props.onDayClick;
	        onDayClick(day, e);
	      }
	
	      return onDayClick;
	    }()
	  }, {
	    key: "onDayMouseEnter",
	    value: function () {
	      function onDayMouseEnter(day, e) {
	        var onDayMouseEnter = this.props.onDayMouseEnter;
	        onDayMouseEnter(day, e);
	      }
	
	      return onDayMouseEnter;
	    }()
	  }, {
	    key: "onDayMouseLeave",
	    value: function () {
	      function onDayMouseLeave(day, e) {
	        var onDayMouseLeave = this.props.onDayMouseLeave;
	        onDayMouseLeave(day, e);
	      }
	
	      return onDayMouseLeave;
	    }()
	  }, {
	    key: "onKeyDown",
	    value: function () {
	      function onKeyDown(day, e) {
	        var onDayClick = this.props.onDayClick;
	        var key = e.key;
	
	        if (key === 'Enter' || key === ' ') {
	          onDayClick(day, e);
	        }
	      }
	
	      return onKeyDown;
	    }()
	  }, {
	    key: "setButtonRef",
	    value: function () {
	      function setButtonRef(ref) {
	        this.buttonRef = ref;
	      }
	
	      return setButtonRef;
	    }()
	  }, {
	    key: "render",
	    value: function () {
	      function render() {
	        var _this2 = this;
	
	        var _this$props2 = this.props,
	            day = _this$props2.day,
	            ariaLabelFormat = _this$props2.ariaLabelFormat,
	            daySize = _this$props2.daySize,
	            isOutsideDay = _this$props2.isOutsideDay,
	            modifiers = _this$props2.modifiers,
	            renderDayContents = _this$props2.renderDayContents,
	            tabIndex = _this$props2.tabIndex,
	            styles = _this$props2.styles,
	            phrases = _this$props2.phrases;
	        if (!day) return _react["default"].createElement("td", null);
	
	        var _getCalendarDaySettin = (0, _getCalendarDaySettings["default"])(day, ariaLabelFormat, daySize, modifiers, phrases),
	            daySizeStyles = _getCalendarDaySettin.daySizeStyles,
	            useDefaultCursor = _getCalendarDaySettin.useDefaultCursor,
	            selected = _getCalendarDaySettin.selected,
	            hoveredSpan = _getCalendarDaySettin.hoveredSpan,
	            isOutsideRange = _getCalendarDaySettin.isOutsideRange,
	            ariaLabel = _getCalendarDaySettin.ariaLabel;
	
	        return _react["default"].createElement("td", _extends({}, (0, _reactWithStyles.css)(styles.CalendarDay, useDefaultCursor && styles.CalendarDay__defaultCursor, styles.CalendarDay__default, isOutsideDay && styles.CalendarDay__outside, modifiers.has('today') && styles.CalendarDay__today, modifiers.has('first-day-of-week') && styles.CalendarDay__firstDayOfWeek, modifiers.has('last-day-of-week') && styles.CalendarDay__lastDayOfWeek, modifiers.has('hovered-offset') && styles.CalendarDay__hovered_offset, modifiers.has('highlighted-calendar') && styles.CalendarDay__highlighted_calendar, modifiers.has('blocked-minimum-nights') && styles.CalendarDay__blocked_minimum_nights, modifiers.has('blocked-calendar') && styles.CalendarDay__blocked_calendar, hoveredSpan && styles.CalendarDay__hovered_span, modifiers.has('selected-span') && styles.CalendarDay__selected_span, modifiers.has('last-in-range') && styles.CalendarDay__last_in_range, modifiers.has('selected-start') && styles.CalendarDay__selected_start, modifiers.has('selected-end') && styles.CalendarDay__selected_end, selected && styles.CalendarDay__selected, isOutsideRange && styles.CalendarDay__blocked_out_of_range, daySizeStyles), {
	          role: "button" // eslint-disable-line jsx-a11y/no-noninteractive-element-to-interactive-role
	          ,
	          ref: this.setButtonRef,
	          "aria-disabled": modifiers.has('blocked'),
	          "aria-label": ariaLabel,
	          onMouseEnter: function () {
	            function onMouseEnter(e) {
	              _this2.onDayMouseEnter(day, e);
	            }
	
	            return onMouseEnter;
	          }(),
	          onMouseLeave: function () {
	            function onMouseLeave(e) {
	              _this2.onDayMouseLeave(day, e);
	            }
	
	            return onMouseLeave;
	          }(),
	          onMouseUp: function () {
	            function onMouseUp(e) {
	              e.currentTarget.blur();
	            }
	
	            return onMouseUp;
	          }(),
	          onClick: function () {
	            function onClick(e) {
	              _this2.onDayClick(day, e);
	            }
	
	            return onClick;
	          }(),
	          onKeyDown: function () {
	            function onKeyDown(e) {
	              _this2.onKeyDown(day, e);
	            }
	
	            return onKeyDown;
	          }(),
	          tabIndex: tabIndex
	        }), renderDayContents ? renderDayContents(day, modifiers) : day.format('D'));
	      }
	
	      return render;
	    }()
	  }]);
	
	  return CalendarDay;
	}(_react["default"].PureComponent || _react["default"].Component);
	
	exports.PureCalendarDay = CalendarDay;
	CalendarDay.propTypes =  false ? propTypes : {};
	CalendarDay.defaultProps = defaultProps;
	
	var _default = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var _ref2$reactDates = _ref2.reactDates,
	      color = _ref2$reactDates.color,
	      font = _ref2$reactDates.font;
	  return {
	    CalendarDay: {
	      boxSizing: 'border-box',
	      cursor: 'pointer',
	      fontSize: font.size,
	      textAlign: 'center',
	      ':active': {
	        outline: 0
	      }
	    },
	    CalendarDay__defaultCursor: {
	      cursor: 'default'
	    },
	    CalendarDay__default: {
	      border: "1px solid ".concat(color.core.borderLight),
	      color: color.text,
	      background: color.background,
	      ':hover': {
	        background: color.core.borderLight,
	        border: "1px solid ".concat(color.core.borderLight),
	        color: 'inherit'
	      }
	    },
	    CalendarDay__hovered_offset: {
	      background: color.core.borderBright,
	      border: "1px double ".concat(color.core.borderLight),
	      color: 'inherit'
	    },
	    CalendarDay__outside: {
	      border: 0,
	      background: color.outside.backgroundColor,
	      color: color.outside.color,
	      ':hover': {
	        border: 0
	      }
	    },
	    CalendarDay__blocked_minimum_nights: {
	      background: color.minimumNights.backgroundColor,
	      border: "1px solid ".concat(color.minimumNights.borderColor),
	      color: color.minimumNights.color,
	      ':hover': {
	        background: color.minimumNights.backgroundColor_hover,
	        color: color.minimumNights.color_active
	      },
	      ':active': {
	        background: color.minimumNights.backgroundColor_active,
	        color: color.minimumNights.color_active
	      }
	    },
	    CalendarDay__highlighted_calendar: {
	      background: color.highlighted.backgroundColor,
	      color: color.highlighted.color,
	      ':hover': {
	        background: color.highlighted.backgroundColor_hover,
	        color: color.highlighted.color_active
	      },
	      ':active': {
	        background: color.highlighted.backgroundColor_active,
	        color: color.highlighted.color_active
	      }
	    },
	    CalendarDay__selected_span: {
	      background: color.selectedSpan.backgroundColor,
	      border: "1px double ".concat(color.selectedSpan.borderColor),
	      color: color.selectedSpan.color,
	      ':hover': {
	        background: color.selectedSpan.backgroundColor_hover,
	        border: "1px double ".concat(color.selectedSpan.borderColor),
	        color: color.selectedSpan.color_active
	      },
	      ':active': {
	        background: color.selectedSpan.backgroundColor_active,
	        border: "1px double ".concat(color.selectedSpan.borderColor),
	        color: color.selectedSpan.color_active
	      }
	    },
	    CalendarDay__last_in_range: {
	      borderStyle: 'solid',
	      ':hover': {
	        borderStyle: 'solid'
	      }
	    },
	    CalendarDay__selected: {
	      background: color.selected.backgroundColor,
	      border: "1px double ".concat(color.selected.borderColor),
	      color: color.selected.color,
	      ':hover': {
	        background: color.selected.backgroundColor_hover,
	        border: "1px double ".concat(color.selected.borderColor),
	        color: color.selected.color_active
	      },
	      ':active': {
	        background: color.selected.backgroundColor_active,
	        border: "1px double ".concat(color.selected.borderColor),
	        color: color.selected.color_active
	      }
	    },
	    CalendarDay__hovered_span: {
	      background: color.hoveredSpan.backgroundColor,
	      border: "1px double ".concat(color.hoveredSpan.borderColor),
	      color: color.hoveredSpan.color,
	      ':hover': {
	        background: color.hoveredSpan.backgroundColor_hover,
	        border: "1px double ".concat(color.hoveredSpan.borderColor),
	        color: color.hoveredSpan.color_active
	      },
	      ':active': {
	        background: color.hoveredSpan.backgroundColor_active,
	        border: "1px double ".concat(color.hoveredSpan.borderColor),
	        color: color.hoveredSpan.color_active
	      }
	    },
	    CalendarDay__blocked_calendar: {
	      background: color.blocked_calendar.backgroundColor,
	      border: "1px solid ".concat(color.blocked_calendar.borderColor),
	      color: color.blocked_calendar.color,
	      ':hover': {
	        background: color.blocked_calendar.backgroundColor_hover,
	        border: "1px solid ".concat(color.blocked_calendar.borderColor),
	        color: color.blocked_calendar.color_active
	      },
	      ':active': {
	        background: color.blocked_calendar.backgroundColor_active,
	        border: "1px solid ".concat(color.blocked_calendar.borderColor),
	        color: color.blocked_calendar.color_active
	      }
	    },
	    CalendarDay__blocked_out_of_range: {
	      background: color.blocked_out_of_range.backgroundColor,
	      border: "1px solid ".concat(color.blocked_out_of_range.borderColor),
	      color: color.blocked_out_of_range.color,
	      ':hover': {
	        background: color.blocked_out_of_range.backgroundColor_hover,
	        border: "1px solid ".concat(color.blocked_out_of_range.borderColor),
	        color: color.blocked_out_of_range.color_active
	      },
	      ':active': {
	        background: color.blocked_out_of_range.backgroundColor_active,
	        border: "1px solid ".concat(color.blocked_out_of_range.borderColor),
	        color: color.blocked_out_of_range.color_active
	      }
	    },
	    CalendarDay__selected_start: {},
	    CalendarDay__selected_end: {},
	    CalendarDay__today: {},
	    CalendarDay__firstDayOfWeek: {},
	    CalendarDay__lastDayOfWeek: {}
	  };
	}, {
	  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
	})(CalendarDay);
	
	exports["default"] = _default;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.PureDayPicker = exports.defaultProps = void 0;
	
	var _reactAddonsShallowCompare = _interopRequireDefault(__webpack_require__(70));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _throttle = _interopRequireDefault(__webpack_require__(662));
	
	var _isTouchDevice = _interopRequireDefault(__webpack_require__(171));
	
	var _reactOutsideClickHandler = _interopRequireDefault(__webpack_require__(457));
	
	var _defaultPhrases = __webpack_require__(51);
	
	var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(60));
	
	var _noflip = _interopRequireDefault(__webpack_require__(127));
	
	var _CalendarMonthGrid = _interopRequireDefault(__webpack_require__(853));
	
	var _DayPickerNavigation = _interopRequireDefault(__webpack_require__(1812));
	
	var _DayPickerKeyboardShortcuts = _interopRequireWildcard(__webpack_require__(1811));
	
	var _getNumberOfCalendarMonthWeeks = _interopRequireDefault(__webpack_require__(1820));
	
	var _getCalendarMonthWidth = _interopRequireDefault(__webpack_require__(871));
	
	var _calculateDimension = _interopRequireDefault(__webpack_require__(868));
	
	var _getActiveElement = _interopRequireDefault(__webpack_require__(1818));
	
	var _isDayVisible = _interopRequireDefault(__webpack_require__(436));
	
	var _ModifiersShape = _interopRequireDefault(__webpack_require__(289));
	
	var _ScrollableOrientationShape = _interopRequireDefault(__webpack_require__(175));
	
	var _DayOfWeekShape = _interopRequireDefault(__webpack_require__(145));
	
	var _CalendarInfoPositionShape = _interopRequireDefault(__webpack_require__(223));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () { function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); } return _getPrototypeOf; }(); return _getPrototypeOf(o); }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function () { function _setPrototypeOf(o, p) { o.__proto__ = p; return o; } return _setPrototypeOf; }(); return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var MONTH_PADDING = 23;
	var PREV_TRANSITION = 'prev';
	var NEXT_TRANSITION = 'next';
	var MONTH_SELECTION_TRANSITION = 'month_selection';
	var YEAR_SELECTION_TRANSITION = 'year_selection';
	var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
	  // calendar presentation props
	  enableOutsideDays: _propTypes["default"].bool,
	  numberOfMonths: _propTypes["default"].number,
	  orientation: _ScrollableOrientationShape["default"],
	  withPortal: _propTypes["default"].bool,
	  onOutsideClick: _propTypes["default"].func,
	  hidden: _propTypes["default"].bool,
	  initialVisibleMonth: _propTypes["default"].func,
	  firstDayOfWeek: _DayOfWeekShape["default"],
	  renderCalendarInfo: _propTypes["default"].func,
	  calendarInfoPosition: _CalendarInfoPositionShape["default"],
	  hideKeyboardShortcutsPanel: _propTypes["default"].bool,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  isRTL: _propTypes["default"].bool,
	  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
	  noBorder: _propTypes["default"].bool,
	  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
	  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
	  horizontalMonthPadding: _airbnbPropTypes.nonNegativeInteger,
	  // navigation props
	  disablePrev: _propTypes["default"].bool,
	  disableNext: _propTypes["default"].bool,
	  navPrev: _propTypes["default"].node,
	  navNext: _propTypes["default"].node,
	  noNavButtons: _propTypes["default"].bool,
	  onPrevMonthClick: _propTypes["default"].func,
	  onNextMonthClick: _propTypes["default"].func,
	  onMonthChange: _propTypes["default"].func,
	  onYearChange: _propTypes["default"].func,
	  onMultiplyScrollableMonths: _propTypes["default"].func,
	  // VERTICAL_SCROLLABLE daypickers only
	  // month props
	  renderMonthText: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
	  renderMonthElement: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
	  // day props
	  modifiers: _propTypes["default"].objectOf(_propTypes["default"].objectOf(_ModifiersShape["default"])),
	  renderCalendarDay: _propTypes["default"].func,
	  renderDayContents: _propTypes["default"].func,
	  onDayClick: _propTypes["default"].func,
	  onDayMouseEnter: _propTypes["default"].func,
	  onDayMouseLeave: _propTypes["default"].func,
	  // accessibility props
	  isFocused: _propTypes["default"].bool,
	  getFirstFocusableDay: _propTypes["default"].func,
	  onBlur: _propTypes["default"].func,
	  showKeyboardShortcuts: _propTypes["default"].bool,
	  onTab: _propTypes["default"].func,
	  onShiftTab: _propTypes["default"].func,
	  // internationalization
	  monthFormat: _propTypes["default"].string,
	  weekDayFormat: _propTypes["default"].string,
	  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.DayPickerPhrases)),
	  dayAriaLabelFormat: _propTypes["default"].string
	})) : {};
	var defaultProps = {
	  // calendar presentation props
	  enableOutsideDays: false,
	  numberOfMonths: 2,
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  withPortal: false,
	  onOutsideClick: function () {
	    function onOutsideClick() {}
	
	    return onOutsideClick;
	  }(),
	  hidden: false,
	  initialVisibleMonth: function () {
	    function initialVisibleMonth() {
	      return (0, _moment["default"])();
	    }
	
	    return initialVisibleMonth;
	  }(),
	  firstDayOfWeek: null,
	  renderCalendarInfo: null,
	  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
	  hideKeyboardShortcutsPanel: false,
	  daySize: _constants.DAY_SIZE,
	  isRTL: false,
	  verticalHeight: null,
	  noBorder: false,
	  transitionDuration: undefined,
	  verticalBorderSpacing: undefined,
	  horizontalMonthPadding: 13,
	  // navigation props
	  disablePrev: false,
	  disableNext: false,
	  navPrev: null,
	  navNext: null,
	  noNavButtons: false,
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	  onMonthChange: function () {
	    function onMonthChange() {}
	
	    return onMonthChange;
	  }(),
	  onYearChange: function () {
	    function onYearChange() {}
	
	    return onYearChange;
	  }(),
	  onMultiplyScrollableMonths: function () {
	    function onMultiplyScrollableMonths() {}
	
	    return onMultiplyScrollableMonths;
	  }(),
	  // month props
	  renderMonthText: null,
	  renderMonthElement: null,
	  // day props
	  modifiers: {},
	  renderCalendarDay: undefined,
	  renderDayContents: null,
	  onDayClick: function () {
	    function onDayClick() {}
	
	    return onDayClick;
	  }(),
	  onDayMouseEnter: function () {
	    function onDayMouseEnter() {}
	
	    return onDayMouseEnter;
	  }(),
	  onDayMouseLeave: function () {
	    function onDayMouseLeave() {}
	
	    return onDayMouseLeave;
	  }(),
	  // accessibility props
	  isFocused: false,
	  getFirstFocusableDay: null,
	  onBlur: function () {
	    function onBlur() {}
	
	    return onBlur;
	  }(),
	  showKeyboardShortcuts: false,
	  onTab: function () {
	    function onTab() {}
	
	    return onTab;
	  }(),
	  onShiftTab: function () {
	    function onShiftTab() {}
	
	    return onShiftTab;
	  }(),
	  // internationalization
	  monthFormat: 'MMMM YYYY',
	  weekDayFormat: 'dd',
	  phrases: _defaultPhrases.DayPickerPhrases,
	  dayAriaLabelFormat: undefined
	};
	exports.defaultProps = defaultProps;
	
	var DayPicker =
	/*#__PURE__*/
	function (_ref) {
	  _inherits(DayPicker, _ref);
	
	  _createClass(DayPicker, [{
	    key: !_react["default"].PureComponent && "shouldComponentUpdate",
	    value: function () {
	      function value(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
	      }
	
	      return value;
	    }()
	  }]);
	
	  function DayPicker(props) {
	    var _this;
	
	    _classCallCheck(this, DayPicker);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(DayPicker).call(this, props));
	    var currentMonth = props.hidden ? (0, _moment["default"])() : props.initialVisibleMonth();
	    var focusedDate = currentMonth.clone().startOf('month');
	
	    if (props.getFirstFocusableDay) {
	      focusedDate = props.getFirstFocusableDay(currentMonth);
	    }
	
	    var horizontalMonthPadding = props.horizontalMonthPadding;
	    var translationValue = props.isRTL && _this.isHorizontal() ? -(0, _getCalendarMonthWidth["default"])(props.daySize, horizontalMonthPadding) : 0;
	    _this.hasSetInitialVisibleMonth = !props.hidden;
	    _this.state = {
	      currentMonth: currentMonth,
	      monthTransition: null,
	      translationValue: translationValue,
	      scrollableMonthMultiple: 1,
	      calendarMonthWidth: (0, _getCalendarMonthWidth["default"])(props.daySize, horizontalMonthPadding),
	      focusedDate: !props.hidden || props.isFocused ? focusedDate : null,
	      nextFocusedDate: null,
	      showKeyboardShortcuts: props.showKeyboardShortcuts,
	      onKeyboardShortcutsPanelClose: function () {
	        function onKeyboardShortcutsPanelClose() {}
	
	        return onKeyboardShortcutsPanelClose;
	      }(),
	      isTouchDevice: (0, _isTouchDevice["default"])(),
	      withMouseInteractions: true,
	      calendarInfoWidth: 0,
	      monthTitleHeight: null,
	      hasSetHeight: false
	    };
	
	    _this.setCalendarMonthWeeks(currentMonth);
	
	    _this.calendarMonthGridHeight = 0;
	    _this.setCalendarInfoWidthTimeout = null;
	    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.throttledKeyDown = (0, _throttle["default"])(_this.onFinalKeyDown, 200, {
	      trailing: false
	    });
	    _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onPrevMonthTransition = _this.onPrevMonthTransition.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onNextMonthClick = _this.onNextMonthClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onNextMonthTransition = _this.onNextMonthTransition.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onMonthChange = _this.onMonthChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onYearChange = _this.onYearChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.multiplyScrollableMonths = _this.multiplyScrollableMonths.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.updateStateAfterMonthTransition = _this.updateStateAfterMonthTransition.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.openKeyboardShortcutsPanel = _this.openKeyboardShortcutsPanel.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.closeKeyboardShortcutsPanel = _this.closeKeyboardShortcutsPanel.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.setCalendarInfoRef = _this.setCalendarInfoRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.setContainerRef = _this.setContainerRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.setTransitionContainerRef = _this.setTransitionContainerRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.setMonthTitleHeight = _this.setMonthTitleHeight.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    return _this;
	  }
	
	  _createClass(DayPicker, [{
	    key: "componentDidMount",
	    value: function () {
	      function componentDidMount() {
	        var currentMonth = this.state.currentMonth;
	
	        if (this.calendarInfo) {
	          this.setState({
	            isTouchDevice: (0, _isTouchDevice["default"])(),
	            calendarInfoWidth: (0, _calculateDimension["default"])(this.calendarInfo, 'width', true, true)
	          });
	        } else {
	          this.setState({
	            isTouchDevice: (0, _isTouchDevice["default"])()
	          });
	        }
	
	        this.setCalendarMonthWeeks(currentMonth);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "componentWillReceiveProps",
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var hidden = nextProps.hidden,
	            isFocused = nextProps.isFocused,
	            showKeyboardShortcuts = nextProps.showKeyboardShortcuts,
	            onBlur = nextProps.onBlur,
	            renderMonthText = nextProps.renderMonthText,
	            horizontalMonthPadding = nextProps.horizontalMonthPadding;
	        var currentMonth = this.state.currentMonth;
	
	        if (!hidden) {
	          if (!this.hasSetInitialVisibleMonth) {
	            this.hasSetInitialVisibleMonth = true;
	            this.setState({
	              currentMonth: nextProps.initialVisibleMonth()
	            });
	          }
	        }
	
	        var _this$props = this.props,
	            daySize = _this$props.daySize,
	            prevIsFocused = _this$props.isFocused,
	            prevRenderMonthText = _this$props.renderMonthText;
	
	        if (nextProps.daySize !== daySize) {
	          this.setState({
	            calendarMonthWidth: (0, _getCalendarMonthWidth["default"])(nextProps.daySize, horizontalMonthPadding)
	          });
	        }
	
	        if (isFocused !== prevIsFocused) {
	          if (isFocused) {
	            var focusedDate = this.getFocusedDay(currentMonth);
	            var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;
	
	            if (nextProps.showKeyboardShortcuts) {
	              // the ? shortcut came from the input and we should return input there once it is close
	              onKeyboardShortcutsPanelClose = onBlur;
	            }
	
	            this.setState({
	              showKeyboardShortcuts: showKeyboardShortcuts,
	              onKeyboardShortcutsPanelClose: onKeyboardShortcutsPanelClose,
	              focusedDate: focusedDate,
	              withMouseInteractions: false
	            });
	          } else {
	            this.setState({
	              focusedDate: null
	            });
	          }
	        }
	
	        if (renderMonthText !== prevRenderMonthText) {
	          this.setState({
	            monthTitleHeight: null
	          });
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: "componentWillUpdate",
	    value: function () {
	      function componentWillUpdate() {
	        var _this2 = this;
	
	        var transitionDuration = this.props.transitionDuration; // Calculating the dimensions trigger a DOM repaint which
	        // breaks the CSS transition.
	        // The setTimeout will wait until the transition ends.
	
	        if (this.calendarInfo) {
	          this.setCalendarInfoWidthTimeout = setTimeout(function () {
	            var calendarInfoWidth = _this2.state.calendarInfoWidth;
	            var calendarInfoPanelWidth = (0, _calculateDimension["default"])(_this2.calendarInfo, 'width', true, true);
	
	            if (calendarInfoWidth !== calendarInfoPanelWidth) {
	              _this2.setState({
	                calendarInfoWidth: calendarInfoPanelWidth
	              });
	            }
	          }, transitionDuration);
	        }
	      }
	
	      return componentWillUpdate;
	    }()
	  }, {
	    key: "componentDidUpdate",
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var _this$props2 = this.props,
	            orientation = _this$props2.orientation,
	            daySize = _this$props2.daySize,
	            isFocused = _this$props2.isFocused,
	            numberOfMonths = _this$props2.numberOfMonths;
	        var _this$state = this.state,
	            focusedDate = _this$state.focusedDate,
	            monthTitleHeight = _this$state.monthTitleHeight;
	
	        if (this.isHorizontal() && (orientation !== prevProps.orientation || daySize !== prevProps.daySize)) {
	          var visibleCalendarWeeks = this.calendarMonthWeeks.slice(1, numberOfMonths + 1);
	          var calendarMonthWeeksHeight = Math.max.apply(Math, [0].concat(_toConsumableArray(visibleCalendarWeeks))) * (daySize - 1);
	          var newMonthHeight = monthTitleHeight + calendarMonthWeeksHeight + 1;
	          this.adjustDayPickerHeight(newMonthHeight);
	        }
	
	        if (!prevProps.isFocused && isFocused && !focusedDate) {
	          this.container.focus();
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: "componentWillUnmount",
	    value: function () {
	      function componentWillUnmount() {
	        clearTimeout(this.setCalendarInfoWidthTimeout);
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: "onKeyDown",
	    value: function () {
	      function onKeyDown(e) {
	        e.stopPropagation();
	
	        if (!_constants.MODIFIER_KEY_NAMES.has(e.key)) {
	          this.throttledKeyDown(e);
	        }
	      }
	
	      return onKeyDown;
	    }()
	  }, {
	    key: "onFinalKeyDown",
	    value: function () {
	      function onFinalKeyDown(e) {
	        this.setState({
	          withMouseInteractions: false
	        });
	        var _this$props3 = this.props,
	            onBlur = _this$props3.onBlur,
	            onTab = _this$props3.onTab,
	            onShiftTab = _this$props3.onShiftTab,
	            isRTL = _this$props3.isRTL;
	        var _this$state2 = this.state,
	            focusedDate = _this$state2.focusedDate,
	            showKeyboardShortcuts = _this$state2.showKeyboardShortcuts;
	        if (!focusedDate) return;
	        var newFocusedDate = focusedDate.clone();
	        var didTransitionMonth = false; // focus might be anywhere when the keyboard shortcuts panel is opened so we want to
	        // return it to wherever it was before when the panel was opened
	
	        var activeElement = (0, _getActiveElement["default"])();
	
	        var onKeyboardShortcutsPanelClose = function () {
	          function onKeyboardShortcutsPanelClose() {
	            if (activeElement) activeElement.focus();
	          }
	
	          return onKeyboardShortcutsPanelClose;
	        }();
	
	        switch (e.key) {
	          case 'ArrowUp':
	            e.preventDefault();
	            newFocusedDate.subtract(1, 'week');
	            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
	            break;
	
	          case 'ArrowLeft':
	            e.preventDefault();
	
	            if (isRTL) {
	              newFocusedDate.add(1, 'day');
	            } else {
	              newFocusedDate.subtract(1, 'day');
	            }
	
	            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
	            break;
	
	          case 'Home':
	            e.preventDefault();
	            newFocusedDate.startOf('week');
	            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
	            break;
	
	          case 'PageUp':
	            e.preventDefault();
	            newFocusedDate.subtract(1, 'month');
	            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
	            break;
	
	          case 'ArrowDown':
	            e.preventDefault();
	            newFocusedDate.add(1, 'week');
	            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
	            break;
	
	          case 'ArrowRight':
	            e.preventDefault();
	
	            if (isRTL) {
	              newFocusedDate.subtract(1, 'day');
	            } else {
	              newFocusedDate.add(1, 'day');
	            }
	
	            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
	            break;
	
	          case 'End':
	            e.preventDefault();
	            newFocusedDate.endOf('week');
	            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
	            break;
	
	          case 'PageDown':
	            e.preventDefault();
	            newFocusedDate.add(1, 'month');
	            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
	            break;
	
	          case '?':
	            this.openKeyboardShortcutsPanel(onKeyboardShortcutsPanelClose);
	            break;
	
	          case 'Escape':
	            if (showKeyboardShortcuts) {
	              this.closeKeyboardShortcutsPanel();
	            } else {
	              onBlur(e);
	            }
	
	            break;
	
	          case 'Tab':
	            if (e.shiftKey) {
	              onShiftTab();
	            } else {
	              onTab(e);
	            }
	
	            break;
	
	          default:
	            break;
	        } // If there was a month transition, do not update the focused date until the transition has
	        // completed. Otherwise, attempting to focus on a DOM node may interrupt the CSS animation. If
	        // didTransitionMonth is true, the focusedDate gets updated in #updateStateAfterMonthTransition
	
	
	        if (!didTransitionMonth) {
	          this.setState({
	            focusedDate: newFocusedDate
	          });
	        }
	      }
	
	      return onFinalKeyDown;
	    }()
	  }, {
	    key: "onPrevMonthClick",
	    value: function () {
	      function onPrevMonthClick(e) {
	        if (e) e.preventDefault();
	        this.onPrevMonthTransition();
	      }
	
	      return onPrevMonthClick;
	    }()
	  }, {
	    key: "onPrevMonthTransition",
	    value: function () {
	      function onPrevMonthTransition(nextFocusedDate) {
	        var _this$props4 = this.props,
	            daySize = _this$props4.daySize,
	            isRTL = _this$props4.isRTL,
	            numberOfMonths = _this$props4.numberOfMonths;
	        var _this$state3 = this.state,
	            calendarMonthWidth = _this$state3.calendarMonthWidth,
	            monthTitleHeight = _this$state3.monthTitleHeight;
	        var translationValue;
	
	        if (this.isVertical()) {
	          var calendarMonthWeeksHeight = this.calendarMonthWeeks[0] * (daySize - 1);
	          translationValue = monthTitleHeight + calendarMonthWeeksHeight + 1;
	        } else if (this.isHorizontal()) {
	          translationValue = calendarMonthWidth;
	
	          if (isRTL) {
	            translationValue = -2 * calendarMonthWidth;
	          }
	
	          var visibleCalendarWeeks = this.calendarMonthWeeks.slice(0, numberOfMonths);
	
	          var _calendarMonthWeeksHeight = Math.max.apply(Math, [0].concat(_toConsumableArray(visibleCalendarWeeks))) * (daySize - 1);
	
	          var newMonthHeight = monthTitleHeight + _calendarMonthWeeksHeight + 1;
	          this.adjustDayPickerHeight(newMonthHeight);
	        }
	
	        this.setState({
	          monthTransition: PREV_TRANSITION,
	          translationValue: translationValue,
	          focusedDate: null,
	          nextFocusedDate: nextFocusedDate
	        });
	      }
	
	      return onPrevMonthTransition;
	    }()
	  }, {
	    key: "onMonthChange",
	    value: function () {
	      function onMonthChange(currentMonth) {
	        this.setCalendarMonthWeeks(currentMonth);
	        this.calculateAndSetDayPickerHeight(); // Translation value is a hack to force an invisible transition that
	        // properly rerenders the CalendarMonthGrid
	
	        this.setState({
	          monthTransition: MONTH_SELECTION_TRANSITION,
	          translationValue: 0.00001,
	          focusedDate: null,
	          nextFocusedDate: currentMonth,
	          currentMonth: currentMonth
	        });
	      }
	
	      return onMonthChange;
	    }()
	  }, {
	    key: "onYearChange",
	    value: function () {
	      function onYearChange(currentMonth) {
	        this.setCalendarMonthWeeks(currentMonth);
	        this.calculateAndSetDayPickerHeight(); // Translation value is a hack to force an invisible transition that
	        // properly rerenders the CalendarMonthGrid
	
	        this.setState({
	          monthTransition: YEAR_SELECTION_TRANSITION,
	          translationValue: 0.0001,
	          focusedDate: null,
	          nextFocusedDate: currentMonth,
	          currentMonth: currentMonth
	        });
	      }
	
	      return onYearChange;
	    }()
	  }, {
	    key: "onNextMonthClick",
	    value: function () {
	      function onNextMonthClick(e) {
	        if (e) e.preventDefault();
	        this.onNextMonthTransition();
	      }
	
	      return onNextMonthClick;
	    }()
	  }, {
	    key: "onNextMonthTransition",
	    value: function () {
	      function onNextMonthTransition(nextFocusedDate) {
	        var _this$props5 = this.props,
	            isRTL = _this$props5.isRTL,
	            numberOfMonths = _this$props5.numberOfMonths,
	            daySize = _this$props5.daySize;
	        var _this$state4 = this.state,
	            calendarMonthWidth = _this$state4.calendarMonthWidth,
	            monthTitleHeight = _this$state4.monthTitleHeight;
	        var translationValue;
	
	        if (this.isVertical()) {
	          var firstVisibleMonthWeeks = this.calendarMonthWeeks[1];
	          var calendarMonthWeeksHeight = firstVisibleMonthWeeks * (daySize - 1);
	          translationValue = -(monthTitleHeight + calendarMonthWeeksHeight + 1);
	        }
	
	        if (this.isHorizontal()) {
	          translationValue = -calendarMonthWidth;
	
	          if (isRTL) {
	            translationValue = 0;
	          }
	
	          var visibleCalendarWeeks = this.calendarMonthWeeks.slice(2, numberOfMonths + 2);
	
	          var _calendarMonthWeeksHeight2 = Math.max.apply(Math, [0].concat(_toConsumableArray(visibleCalendarWeeks))) * (daySize - 1);
	
	          var newMonthHeight = monthTitleHeight + _calendarMonthWeeksHeight2 + 1;
	          this.adjustDayPickerHeight(newMonthHeight);
	        }
	
	        this.setState({
	          monthTransition: NEXT_TRANSITION,
	          translationValue: translationValue,
	          focusedDate: null,
	          nextFocusedDate: nextFocusedDate
	        });
	      }
	
	      return onNextMonthTransition;
	    }()
	  }, {
	    key: "getFirstDayOfWeek",
	    value: function () {
	      function getFirstDayOfWeek() {
	        var firstDayOfWeek = this.props.firstDayOfWeek;
	
	        if (firstDayOfWeek == null) {
	          return _moment["default"].localeData().firstDayOfWeek();
	        }
	
	        return firstDayOfWeek;
	      }
	
	      return getFirstDayOfWeek;
	    }()
	  }, {
	    key: "getFirstVisibleIndex",
	    value: function () {
	      function getFirstVisibleIndex() {
	        var orientation = this.props.orientation;
	        var monthTransition = this.state.monthTransition;
	        if (orientation === _constants.VERTICAL_SCROLLABLE) return 0;
	        var firstVisibleMonthIndex = 1;
	
	        if (monthTransition === PREV_TRANSITION) {
	          firstVisibleMonthIndex -= 1;
	        } else if (monthTransition === NEXT_TRANSITION) {
	          firstVisibleMonthIndex += 1;
	        }
	
	        return firstVisibleMonthIndex;
	      }
	
	      return getFirstVisibleIndex;
	    }()
	  }, {
	    key: "getFocusedDay",
	    value: function () {
	      function getFocusedDay(newMonth) {
	        var _this$props6 = this.props,
	            getFirstFocusableDay = _this$props6.getFirstFocusableDay,
	            numberOfMonths = _this$props6.numberOfMonths;
	        var focusedDate;
	
	        if (getFirstFocusableDay) {
	          focusedDate = getFirstFocusableDay(newMonth);
	        }
	
	        if (newMonth && (!focusedDate || !(0, _isDayVisible["default"])(focusedDate, newMonth, numberOfMonths))) {
	          focusedDate = newMonth.clone().startOf('month');
	        }
	
	        return focusedDate;
	      }
	
	      return getFocusedDay;
	    }()
	  }, {
	    key: "setMonthTitleHeight",
	    value: function () {
	      function setMonthTitleHeight(monthTitleHeight) {
	        var _this3 = this;
	
	        this.setState({
	          monthTitleHeight: monthTitleHeight
	        }, function () {
	          _this3.calculateAndSetDayPickerHeight();
	        });
	      }
	
	      return setMonthTitleHeight;
	    }()
	  }, {
	    key: "setCalendarMonthWeeks",
	    value: function () {
	      function setCalendarMonthWeeks(currentMonth) {
	        var numberOfMonths = this.props.numberOfMonths;
	        this.calendarMonthWeeks = [];
	        var month = currentMonth.clone().subtract(1, 'months');
	        var firstDayOfWeek = this.getFirstDayOfWeek();
	
	        for (var i = 0; i < numberOfMonths + 2; i += 1) {
	          var numberOfWeeks = (0, _getNumberOfCalendarMonthWeeks["default"])(month, firstDayOfWeek);
	          this.calendarMonthWeeks.push(numberOfWeeks);
	          month = month.add(1, 'months');
	        }
	      }
	
	      return setCalendarMonthWeeks;
	    }()
	  }, {
	    key: "setContainerRef",
	    value: function () {
	      function setContainerRef(ref) {
	        this.container = ref;
	      }
	
	      return setContainerRef;
	    }()
	  }, {
	    key: "setCalendarInfoRef",
	    value: function () {
	      function setCalendarInfoRef(ref) {
	        this.calendarInfo = ref;
	      }
	
	      return setCalendarInfoRef;
	    }()
	  }, {
	    key: "setTransitionContainerRef",
	    value: function () {
	      function setTransitionContainerRef(ref) {
	        this.transitionContainer = ref;
	      }
	
	      return setTransitionContainerRef;
	    }()
	  }, {
	    key: "maybeTransitionNextMonth",
	    value: function () {
	      function maybeTransitionNextMonth(newFocusedDate) {
	        var numberOfMonths = this.props.numberOfMonths;
	        var _this$state5 = this.state,
	            currentMonth = _this$state5.currentMonth,
	            focusedDate = _this$state5.focusedDate;
	        var newFocusedDateMonth = newFocusedDate.month();
	        var focusedDateMonth = focusedDate.month();
	        var isNewFocusedDateVisible = (0, _isDayVisible["default"])(newFocusedDate, currentMonth, numberOfMonths);
	
	        if (newFocusedDateMonth !== focusedDateMonth && !isNewFocusedDateVisible) {
	          this.onNextMonthTransition(newFocusedDate);
	          return true;
	        }
	
	        return false;
	      }
	
	      return maybeTransitionNextMonth;
	    }()
	  }, {
	    key: "maybeTransitionPrevMonth",
	    value: function () {
	      function maybeTransitionPrevMonth(newFocusedDate) {
	        var numberOfMonths = this.props.numberOfMonths;
	        var _this$state6 = this.state,
	            currentMonth = _this$state6.currentMonth,
	            focusedDate = _this$state6.focusedDate;
	        var newFocusedDateMonth = newFocusedDate.month();
	        var focusedDateMonth = focusedDate.month();
	        var isNewFocusedDateVisible = (0, _isDayVisible["default"])(newFocusedDate, currentMonth, numberOfMonths);
	
	        if (newFocusedDateMonth !== focusedDateMonth && !isNewFocusedDateVisible) {
	          this.onPrevMonthTransition(newFocusedDate);
	          return true;
	        }
	
	        return false;
	      }
	
	      return maybeTransitionPrevMonth;
	    }()
	  }, {
	    key: "multiplyScrollableMonths",
	    value: function () {
	      function multiplyScrollableMonths(e) {
	        var onMultiplyScrollableMonths = this.props.onMultiplyScrollableMonths;
	        if (e) e.preventDefault();
	        if (onMultiplyScrollableMonths) onMultiplyScrollableMonths(e);
	        this.setState(function (_ref2) {
	          var scrollableMonthMultiple = _ref2.scrollableMonthMultiple;
	          return {
	            scrollableMonthMultiple: scrollableMonthMultiple + 1
	          };
	        });
	      }
	
	      return multiplyScrollableMonths;
	    }()
	  }, {
	    key: "isHorizontal",
	    value: function () {
	      function isHorizontal() {
	        var orientation = this.props.orientation;
	        return orientation === _constants.HORIZONTAL_ORIENTATION;
	      }
	
	      return isHorizontal;
	    }()
	  }, {
	    key: "isVertical",
	    value: function () {
	      function isVertical() {
	        var orientation = this.props.orientation;
	        return orientation === _constants.VERTICAL_ORIENTATION || orientation === _constants.VERTICAL_SCROLLABLE;
	      }
	
	      return isVertical;
	    }()
	  }, {
	    key: "updateStateAfterMonthTransition",
	    value: function () {
	      function updateStateAfterMonthTransition() {
	        var _this4 = this;
	
	        var _this$props7 = this.props,
	            onPrevMonthClick = _this$props7.onPrevMonthClick,
	            onNextMonthClick = _this$props7.onNextMonthClick,
	            numberOfMonths = _this$props7.numberOfMonths,
	            onMonthChange = _this$props7.onMonthChange,
	            onYearChange = _this$props7.onYearChange,
	            isRTL = _this$props7.isRTL;
	        var _this$state7 = this.state,
	            currentMonth = _this$state7.currentMonth,
	            monthTransition = _this$state7.monthTransition,
	            focusedDate = _this$state7.focusedDate,
	            nextFocusedDate = _this$state7.nextFocusedDate,
	            withMouseInteractions = _this$state7.withMouseInteractions,
	            calendarMonthWidth = _this$state7.calendarMonthWidth;
	        if (!monthTransition) return;
	        var newMonth = currentMonth.clone();
	        var firstDayOfWeek = this.getFirstDayOfWeek();
	
	        if (monthTransition === PREV_TRANSITION) {
	          newMonth.subtract(1, 'month');
	          if (onPrevMonthClick) onPrevMonthClick(newMonth);
	          var newInvisibleMonth = newMonth.clone().subtract(1, 'month');
	          var numberOfWeeks = (0, _getNumberOfCalendarMonthWeeks["default"])(newInvisibleMonth, firstDayOfWeek);
	          this.calendarMonthWeeks = [numberOfWeeks].concat(_toConsumableArray(this.calendarMonthWeeks.slice(0, -1)));
	        } else if (monthTransition === NEXT_TRANSITION) {
	          newMonth.add(1, 'month');
	          if (onNextMonthClick) onNextMonthClick(newMonth);
	
	          var _newInvisibleMonth = newMonth.clone().add(numberOfMonths, 'month');
	
	          var _numberOfWeeks = (0, _getNumberOfCalendarMonthWeeks["default"])(_newInvisibleMonth, firstDayOfWeek);
	
	          this.calendarMonthWeeks = _toConsumableArray(this.calendarMonthWeeks.slice(1)).concat([_numberOfWeeks]);
	        } else if (monthTransition === MONTH_SELECTION_TRANSITION) {
	          if (onMonthChange) onMonthChange(newMonth);
	        } else if (monthTransition === YEAR_SELECTION_TRANSITION) {
	          if (onYearChange) onYearChange(newMonth);
	        }
	
	        var newFocusedDate = null;
	
	        if (nextFocusedDate) {
	          newFocusedDate = nextFocusedDate;
	        } else if (!focusedDate && !withMouseInteractions) {
	          newFocusedDate = this.getFocusedDay(newMonth);
	        }
	
	        this.setState({
	          currentMonth: newMonth,
	          monthTransition: null,
	          translationValue: isRTL && this.isHorizontal() ? -calendarMonthWidth : 0,
	          nextFocusedDate: null,
	          focusedDate: newFocusedDate
	        }, function () {
	          // we don't want to focus on the relevant calendar day after a month transition
	          // if the user is navigating around using a mouse
	          if (withMouseInteractions) {
	            var activeElement = (0, _getActiveElement["default"])();
	
	            if (activeElement && activeElement !== document.body && _this4.container.contains(activeElement) && activeElement.blur) {
	              activeElement.blur();
	            }
	          }
	        });
	      }
	
	      return updateStateAfterMonthTransition;
	    }()
	  }, {
	    key: "adjustDayPickerHeight",
	    value: function () {
	      function adjustDayPickerHeight(newMonthHeight) {
	        var _this5 = this;
	
	        var monthHeight = newMonthHeight + MONTH_PADDING;
	
	        if (monthHeight !== this.calendarMonthGridHeight) {
	          this.transitionContainer.style.height = "".concat(monthHeight, "px");
	
	          if (!this.calendarMonthGridHeight) {
	            setTimeout(function () {
	              _this5.setState({
	                hasSetHeight: true
	              });
	            }, 0);
	          }
	
	          this.calendarMonthGridHeight = monthHeight;
	        }
	      }
	
	      return adjustDayPickerHeight;
	    }()
	  }, {
	    key: "calculateAndSetDayPickerHeight",
	    value: function () {
	      function calculateAndSetDayPickerHeight() {
	        var _this$props8 = this.props,
	            daySize = _this$props8.daySize,
	            numberOfMonths = _this$props8.numberOfMonths;
	        var monthTitleHeight = this.state.monthTitleHeight;
	        var visibleCalendarWeeks = this.calendarMonthWeeks.slice(1, numberOfMonths + 1);
	        var calendarMonthWeeksHeight = Math.max.apply(Math, [0].concat(_toConsumableArray(visibleCalendarWeeks))) * (daySize - 1);
	        var newMonthHeight = monthTitleHeight + calendarMonthWeeksHeight + 1;
	
	        if (this.isHorizontal()) {
	          this.adjustDayPickerHeight(newMonthHeight);
	        }
	      }
	
	      return calculateAndSetDayPickerHeight;
	    }()
	  }, {
	    key: "openKeyboardShortcutsPanel",
	    value: function () {
	      function openKeyboardShortcutsPanel(onCloseCallBack) {
	        this.setState({
	          showKeyboardShortcuts: true,
	          onKeyboardShortcutsPanelClose: onCloseCallBack
	        });
	      }
	
	      return openKeyboardShortcutsPanel;
	    }()
	  }, {
	    key: "closeKeyboardShortcutsPanel",
	    value: function () {
	      function closeKeyboardShortcutsPanel() {
	        var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;
	
	        if (onKeyboardShortcutsPanelClose) {
	          onKeyboardShortcutsPanelClose();
	        }
	
	        this.setState({
	          onKeyboardShortcutsPanelClose: null,
	          showKeyboardShortcuts: false
	        });
	      }
	
	      return closeKeyboardShortcutsPanel;
	    }()
	  }, {
	    key: "renderNavigation",
	    value: function () {
	      function renderNavigation() {
	        var _this$props9 = this.props,
	            disablePrev = _this$props9.disablePrev,
	            disableNext = _this$props9.disableNext,
	            navPrev = _this$props9.navPrev,
	            navNext = _this$props9.navNext,
	            noNavButtons = _this$props9.noNavButtons,
	            orientation = _this$props9.orientation,
	            phrases = _this$props9.phrases,
	            isRTL = _this$props9.isRTL;
	
	        if (noNavButtons) {
	          return null;
	        }
	
	        var onNextMonthClick = orientation === _constants.VERTICAL_SCROLLABLE ? this.multiplyScrollableMonths : this.onNextMonthClick;
	        return _react["default"].createElement(_DayPickerNavigation["default"], {
	          disablePrev: disablePrev,
	          disableNext: disableNext,
	          onPrevMonthClick: this.onPrevMonthClick,
	          onNextMonthClick: onNextMonthClick,
	          navPrev: navPrev,
	          navNext: navNext,
	          orientation: orientation,
	          phrases: phrases,
	          isRTL: isRTL
	        });
	      }
	
	      return renderNavigation;
	    }()
	  }, {
	    key: "renderWeekHeader",
	    value: function () {
	      function renderWeekHeader(index) {
	        var _this$props10 = this.props,
	            daySize = _this$props10.daySize,
	            horizontalMonthPadding = _this$props10.horizontalMonthPadding,
	            orientation = _this$props10.orientation,
	            weekDayFormat = _this$props10.weekDayFormat,
	            styles = _this$props10.styles;
	        var calendarMonthWidth = this.state.calendarMonthWidth;
	        var verticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
	        var horizontalStyle = {
	          left: index * calendarMonthWidth
	        };
	        var verticalStyle = {
	          marginLeft: -calendarMonthWidth / 2
	        };
	        var weekHeaderStyle = {}; // no styles applied to the vertical-scrollable orientation
	
	        if (this.isHorizontal()) {
	          weekHeaderStyle = horizontalStyle;
	        } else if (this.isVertical() && !verticalScrollable) {
	          weekHeaderStyle = verticalStyle;
	        }
	
	        var firstDayOfWeek = this.getFirstDayOfWeek();
	        var header = [];
	
	        for (var i = 0; i < 7; i += 1) {
	          header.push(_react["default"].createElement("li", _extends({
	            key: i
	          }, (0, _reactWithStyles.css)(styles.DayPicker_weekHeader_li, {
	            width: daySize
	          })), _react["default"].createElement("small", null, (0, _moment["default"])().day((i + firstDayOfWeek) % 7).format(weekDayFormat))));
	        }
	
	        return _react["default"].createElement("div", _extends({}, (0, _reactWithStyles.css)(styles.DayPicker_weekHeader, this.isVertical() && styles.DayPicker_weekHeader__vertical, verticalScrollable && styles.DayPicker_weekHeader__verticalScrollable, weekHeaderStyle, {
	          padding: "0 ".concat(horizontalMonthPadding, "px")
	        }), {
	          key: "week-".concat(index)
	        }), _react["default"].createElement("ul", (0, _reactWithStyles.css)(styles.DayPicker_weekHeader_ul), header));
	      }
	
	      return renderWeekHeader;
	    }()
	  }, {
	    key: "render",
	    value: function () {
	      function render() {
	        var _this6 = this;
	
	        var _this$state8 = this.state,
	            calendarMonthWidth = _this$state8.calendarMonthWidth,
	            currentMonth = _this$state8.currentMonth,
	            monthTransition = _this$state8.monthTransition,
	            translationValue = _this$state8.translationValue,
	            scrollableMonthMultiple = _this$state8.scrollableMonthMultiple,
	            focusedDate = _this$state8.focusedDate,
	            showKeyboardShortcuts = _this$state8.showKeyboardShortcuts,
	            isTouch = _this$state8.isTouchDevice,
	            hasSetHeight = _this$state8.hasSetHeight,
	            calendarInfoWidth = _this$state8.calendarInfoWidth,
	            monthTitleHeight = _this$state8.monthTitleHeight;
	        var _this$props11 = this.props,
	            enableOutsideDays = _this$props11.enableOutsideDays,
	            numberOfMonths = _this$props11.numberOfMonths,
	            orientation = _this$props11.orientation,
	            modifiers = _this$props11.modifiers,
	            withPortal = _this$props11.withPortal,
	            onDayClick = _this$props11.onDayClick,
	            onDayMouseEnter = _this$props11.onDayMouseEnter,
	            onDayMouseLeave = _this$props11.onDayMouseLeave,
	            firstDayOfWeek = _this$props11.firstDayOfWeek,
	            renderMonthText = _this$props11.renderMonthText,
	            renderCalendarDay = _this$props11.renderCalendarDay,
	            renderDayContents = _this$props11.renderDayContents,
	            renderCalendarInfo = _this$props11.renderCalendarInfo,
	            renderMonthElement = _this$props11.renderMonthElement,
	            calendarInfoPosition = _this$props11.calendarInfoPosition,
	            hideKeyboardShortcutsPanel = _this$props11.hideKeyboardShortcutsPanel,
	            onOutsideClick = _this$props11.onOutsideClick,
	            monthFormat = _this$props11.monthFormat,
	            daySize = _this$props11.daySize,
	            isFocused = _this$props11.isFocused,
	            isRTL = _this$props11.isRTL,
	            styles = _this$props11.styles,
	            theme = _this$props11.theme,
	            phrases = _this$props11.phrases,
	            verticalHeight = _this$props11.verticalHeight,
	            dayAriaLabelFormat = _this$props11.dayAriaLabelFormat,
	            noBorder = _this$props11.noBorder,
	            transitionDuration = _this$props11.transitionDuration,
	            verticalBorderSpacing = _this$props11.verticalBorderSpacing,
	            horizontalMonthPadding = _this$props11.horizontalMonthPadding;
	        var dayPickerHorizontalPadding = theme.reactDates.spacing.dayPickerHorizontalPadding;
	        var isHorizontal = this.isHorizontal();
	        var numOfWeekHeaders = this.isVertical() ? 1 : numberOfMonths;
	        var weekHeaders = [];
	
	        for (var i = 0; i < numOfWeekHeaders; i += 1) {
	          weekHeaders.push(this.renderWeekHeader(i));
	        }
	
	        var verticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
	        var height;
	
	        if (isHorizontal) {
	          height = this.calendarMonthGridHeight;
	        } else if (this.isVertical() && !verticalScrollable && !withPortal) {
	          // If the user doesn't set a desired height,
	          // we default back to this kind of made-up value that generally looks good
	          height = verticalHeight || 1.75 * calendarMonthWidth;
	        }
	
	        var isCalendarMonthGridAnimating = monthTransition !== null;
	        var shouldFocusDate = !isCalendarMonthGridAnimating && isFocused;
	        var keyboardShortcutButtonLocation = _DayPickerKeyboardShortcuts.BOTTOM_RIGHT;
	
	        if (this.isVertical()) {
	          keyboardShortcutButtonLocation = withPortal ? _DayPickerKeyboardShortcuts.TOP_LEFT : _DayPickerKeyboardShortcuts.TOP_RIGHT;
	        }
	
	        var shouldAnimateHeight = isHorizontal && hasSetHeight;
	        var calendarInfoPositionTop = calendarInfoPosition === _constants.INFO_POSITION_TOP;
	        var calendarInfoPositionBottom = calendarInfoPosition === _constants.INFO_POSITION_BOTTOM;
	        var calendarInfoPositionBefore = calendarInfoPosition === _constants.INFO_POSITION_BEFORE;
	        var calendarInfoPositionAfter = calendarInfoPosition === _constants.INFO_POSITION_AFTER;
	        var calendarInfoIsInline = calendarInfoPositionBefore || calendarInfoPositionAfter;
	
	        var calendarInfo = renderCalendarInfo && _react["default"].createElement("div", _extends({
	          ref: this.setCalendarInfoRef
	        }, (0, _reactWithStyles.css)(calendarInfoIsInline && styles.DayPicker_calendarInfo__horizontal)), renderCalendarInfo());
	
	        var calendarInfoPanelWidth = renderCalendarInfo && calendarInfoIsInline ? calendarInfoWidth : 0;
	        var firstVisibleMonthIndex = this.getFirstVisibleIndex();
	        var wrapperHorizontalWidth = calendarMonthWidth * numberOfMonths + 2 * dayPickerHorizontalPadding; // Adding `1px` because of whitespace between 2 inline-block
	
	        var fullHorizontalWidth = wrapperHorizontalWidth + calendarInfoPanelWidth + 1;
	        var transitionContainerStyle = {
	          width: isHorizontal && wrapperHorizontalWidth,
	          height: height
	        };
	        var dayPickerWrapperStyle = {
	          width: isHorizontal && wrapperHorizontalWidth
	        };
	        var dayPickerStyle = {
	          width: isHorizontal && fullHorizontalWidth,
	          // These values are to center the datepicker (approximately) on the page
	          marginLeft: isHorizontal && withPortal ? -fullHorizontalWidth / 2 : null,
	          marginTop: isHorizontal && withPortal ? -calendarMonthWidth / 2 : null
	        };
	        return _react["default"].createElement("div", _extends({
	          role: "application",
	          "aria-label": phrases.calendarLabel
	        }, (0, _reactWithStyles.css)(styles.DayPicker, isHorizontal && styles.DayPicker__horizontal, verticalScrollable && styles.DayPicker__verticalScrollable, isHorizontal && withPortal && styles.DayPicker_portal__horizontal, this.isVertical() && withPortal && styles.DayPicker_portal__vertical, dayPickerStyle, !monthTitleHeight && styles.DayPicker__hidden, !noBorder && styles.DayPicker__withBorder)), _react["default"].createElement(_reactOutsideClickHandler["default"], {
	          onOutsideClick: onOutsideClick
	        }, (calendarInfoPositionTop || calendarInfoPositionBefore) && calendarInfo, _react["default"].createElement("div", (0, _reactWithStyles.css)(dayPickerWrapperStyle, calendarInfoIsInline && isHorizontal && styles.DayPicker_wrapper__horizontal), _react["default"].createElement("div", _extends({}, (0, _reactWithStyles.css)(styles.DayPicker_weekHeaders, isHorizontal && styles.DayPicker_weekHeaders__horizontal), {
	          "aria-hidden": "true",
	          role: "presentation"
	        }), weekHeaders), _react["default"].createElement("div", _extends({}, (0, _reactWithStyles.css)(styles.DayPicker_focusRegion), {
	          ref: this.setContainerRef,
	          onClick: function () {
	            function onClick(e) {
	              e.stopPropagation();
	            }
	
	            return onClick;
	          }(),
	          onKeyDown: this.onKeyDown,
	          onMouseUp: function () {
	            function onMouseUp() {
	              _this6.setState({
	                withMouseInteractions: true
	              });
	            }
	
	            return onMouseUp;
	          }(),
	          role: "region",
	          tabIndex: -1
	        }), !verticalScrollable && this.renderNavigation(), _react["default"].createElement("div", _extends({}, (0, _reactWithStyles.css)(styles.DayPicker_transitionContainer, shouldAnimateHeight && styles.DayPicker_transitionContainer__horizontal, this.isVertical() && styles.DayPicker_transitionContainer__vertical, verticalScrollable && styles.DayPicker_transitionContainer__verticalScrollable, transitionContainerStyle), {
	          ref: this.setTransitionContainerRef
	        }), _react["default"].createElement(_CalendarMonthGrid["default"], {
	          setMonthTitleHeight: !monthTitleHeight ? this.setMonthTitleHeight : undefined,
	          translationValue: translationValue,
	          enableOutsideDays: enableOutsideDays,
	          firstVisibleMonthIndex: firstVisibleMonthIndex,
	          initialMonth: currentMonth,
	          isAnimating: isCalendarMonthGridAnimating,
	          modifiers: modifiers,
	          orientation: orientation,
	          numberOfMonths: numberOfMonths * scrollableMonthMultiple,
	          onDayClick: onDayClick,
	          onDayMouseEnter: onDayMouseEnter,
	          onDayMouseLeave: onDayMouseLeave,
	          onMonthChange: this.onMonthChange,
	          onYearChange: this.onYearChange,
	          renderMonthText: renderMonthText,
	          renderCalendarDay: renderCalendarDay,
	          renderDayContents: renderDayContents,
	          renderMonthElement: renderMonthElement,
	          onMonthTransitionEnd: this.updateStateAfterMonthTransition,
	          monthFormat: monthFormat,
	          daySize: daySize,
	          firstDayOfWeek: firstDayOfWeek,
	          isFocused: shouldFocusDate,
	          focusedDate: focusedDate,
	          phrases: phrases,
	          isRTL: isRTL,
	          dayAriaLabelFormat: dayAriaLabelFormat,
	          transitionDuration: transitionDuration,
	          verticalBorderSpacing: verticalBorderSpacing,
	          horizontalMonthPadding: horizontalMonthPadding
	        }), verticalScrollable && this.renderNavigation()), !isTouch && !hideKeyboardShortcutsPanel && _react["default"].createElement(_DayPickerKeyboardShortcuts["default"], {
	          block: this.isVertical() && !withPortal,
	          buttonLocation: keyboardShortcutButtonLocation,
	          showKeyboardShortcutsPanel: showKeyboardShortcuts,
	          openKeyboardShortcutsPanel: this.openKeyboardShortcutsPanel,
	          closeKeyboardShortcutsPanel: this.closeKeyboardShortcutsPanel,
	          phrases: phrases
	        }))), (calendarInfoPositionBottom || calendarInfoPositionAfter) && calendarInfo));
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DayPicker;
	}(_react["default"].PureComponent || _react["default"].Component);
	
	exports.PureDayPicker = DayPicker;
	DayPicker.propTypes =  false ? propTypes : {};
	DayPicker.defaultProps = defaultProps;
	
	var _default = (0, _reactWithStyles.withStyles)(function (_ref3) {
	  var _ref3$reactDates = _ref3.reactDates,
	      color = _ref3$reactDates.color,
	      font = _ref3$reactDates.font,
	      noScrollBarOnVerticalScrollable = _ref3$reactDates.noScrollBarOnVerticalScrollable,
	      spacing = _ref3$reactDates.spacing,
	      zIndex = _ref3$reactDates.zIndex;
	  return {
	    DayPicker: {
	      background: color.background,
	      position: 'relative',
	      textAlign: (0, _noflip["default"])('left')
	    },
	    DayPicker__horizontal: {
	      background: color.background
	    },
	    DayPicker__verticalScrollable: {
	      height: '100%'
	    },
	    DayPicker__hidden: {
	      visibility: 'hidden'
	    },
	    DayPicker__withBorder: {
	      boxShadow: (0, _noflip["default"])('0 2px 6px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.07)'),
	      borderRadius: 3
	    },
	    DayPicker_portal__horizontal: {
	      boxShadow: 'none',
	      position: 'absolute',
	      left: (0, _noflip["default"])('50%'),
	      top: '50%'
	    },
	    DayPicker_portal__vertical: {
	      position: 'initial'
	    },
	    DayPicker_focusRegion: {
	      outline: 'none'
	    },
	    DayPicker_calendarInfo__horizontal: {
	      display: 'inline-block',
	      verticalAlign: 'top'
	    },
	    DayPicker_wrapper__horizontal: {
	      display: 'inline-block',
	      verticalAlign: 'top'
	    },
	    DayPicker_weekHeaders: {
	      position: 'relative'
	    },
	    DayPicker_weekHeaders__horizontal: {
	      marginLeft: (0, _noflip["default"])(spacing.dayPickerHorizontalPadding)
	    },
	    DayPicker_weekHeader: {
	      color: color.placeholderText,
	      position: 'absolute',
	      top: 62,
	      zIndex: zIndex + 2,
	      textAlign: (0, _noflip["default"])('left')
	    },
	    DayPicker_weekHeader__vertical: {
	      left: (0, _noflip["default"])('50%')
	    },
	    DayPicker_weekHeader__verticalScrollable: {
	      top: 0,
	      display: 'table-row',
	      borderBottom: "1px solid ".concat(color.core.border),
	      background: color.background,
	      marginLeft: (0, _noflip["default"])(0),
	      left: (0, _noflip["default"])(0),
	      width: '100%',
	      textAlign: 'center'
	    },
	    DayPicker_weekHeader_ul: {
	      listStyle: 'none',
	      margin: '1px 0',
	      paddingLeft: (0, _noflip["default"])(0),
	      paddingRight: (0, _noflip["default"])(0),
	      fontSize: font.size
	    },
	    DayPicker_weekHeader_li: {
	      display: 'inline-block',
	      textAlign: 'center'
	    },
	    DayPicker_transitionContainer: {
	      position: 'relative',
	      overflow: 'hidden',
	      borderRadius: 3
	    },
	    DayPicker_transitionContainer__horizontal: {
	      transition: 'height 0.2s ease-in-out'
	    },
	    DayPicker_transitionContainer__vertical: {
	      width: '100%'
	    },
	    DayPicker_transitionContainer__verticalScrollable: _objectSpread({
	      paddingTop: 20,
	      height: '100%',
	      position: 'absolute',
	      top: 0,
	      bottom: 0,
	      right: (0, _noflip["default"])(0),
	      left: (0, _noflip["default"])(0),
	      overflowY: 'scroll'
	    }, noScrollBarOnVerticalScrollable && {
	      '-webkitOverflowScrolling': 'touch',
	      '::-webkit-scrollbar': {
	        '-webkit-appearance': 'none',
	        display: 'none'
	      }
	    })
	  };
	}, {
	  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
	})(DayPicker);
	
	exports["default"] = _default;

/***/ },
/* 435 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getInputHeight;
	
	/* eslint-disable camelcase */
	function getPadding(vertical, top, bottom) {
	  var isTopDefined = typeof top === 'number';
	  var isBottomDefined = typeof bottom === 'number';
	  var isVerticalDefined = typeof vertical === 'number';
	
	  if (isTopDefined && isBottomDefined) {
	    return top + bottom;
	  }
	
	  if (isTopDefined && isVerticalDefined) {
	    return top + vertical;
	  }
	
	  if (isTopDefined) {
	    return top;
	  }
	
	  if (isBottomDefined && isVerticalDefined) {
	    return bottom + vertical;
	  }
	
	  if (isBottomDefined) {
	    return bottom;
	  }
	
	  if (isVerticalDefined) {
	    return 2 * vertical;
	  }
	
	  return 0;
	}
	
	function getInputHeight(_ref, small) {
	  var _ref$font$input = _ref.font.input,
	      lineHeight = _ref$font$input.lineHeight,
	      lineHeight_small = _ref$font$input.lineHeight_small,
	      _ref$spacing = _ref.spacing,
	      inputPadding = _ref$spacing.inputPadding,
	      displayTextPaddingVertical = _ref$spacing.displayTextPaddingVertical,
	      displayTextPaddingTop = _ref$spacing.displayTextPaddingTop,
	      displayTextPaddingBottom = _ref$spacing.displayTextPaddingBottom,
	      displayTextPaddingVertical_small = _ref$spacing.displayTextPaddingVertical_small,
	      displayTextPaddingTop_small = _ref$spacing.displayTextPaddingTop_small,
	      displayTextPaddingBottom_small = _ref$spacing.displayTextPaddingBottom_small;
	  var calcLineHeight = small ? lineHeight_small : lineHeight;
	  var padding = small ? getPadding(displayTextPaddingVertical_small, displayTextPaddingTop_small, displayTextPaddingBottom_small) : getPadding(displayTextPaddingVertical, displayTextPaddingTop, displayTextPaddingBottom);
	  return parseInt(calcLineHeight, 10) + 2 * inputPadding + padding;
	}

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isDayVisible;
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _isBeforeDay = _interopRequireDefault(__webpack_require__(225));
	
	var _isAfterDay = _interopRequireDefault(__webpack_require__(290));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function isDayVisible(day, month, numberOfMonths, enableOutsideDays) {
	  if (!_moment["default"].isMoment(day)) return false;
	  var firstDayOfFirstMonth = month.clone().startOf('month');
	  if (enableOutsideDays) firstDayOfFirstMonth = firstDayOfFirstMonth.startOf('week');
	  if ((0, _isBeforeDay["default"])(day, firstDayOfFirstMonth)) return false;
	  var lastDayOfLastMonth = month.clone().add(numberOfMonths - 1, 'months').endOf('month');
	  if (enableOutsideDays) lastDayOfLastMonth = lastDayOfLastMonth.endOf('week');
	  return !(0, _isAfterDay["default"])(day, lastDayOfLastMonth);
	}

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = toLocalizedDateString;
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _toMomentObject = _interopRequireDefault(__webpack_require__(178));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function toLocalizedDateString(date, currentFormat) {
	  var dateObj = _moment["default"].isMoment(date) ? date : (0, _toMomentObject["default"])(date, currentFormat);
	  if (!dateObj) return null;
	  return dateObj.format(_constants.DISPLAY_FORMAT);
	}

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(179);
	var Danger = __webpack_require__(1835);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactInstrumentation = __webpack_require__(86);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(447);
	var setInnerHTML = __webpack_require__(297);
	var setTextContent = __webpack_require__(896);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 439 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(20);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactErrorUtils = __webpack_require__(445);
	
	var invariant = __webpack_require__(20);
	var warning = __webpack_require__(25);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 442 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactPropTypesSecret = __webpack_require__(1864);
	var propTypesFactory = __webpack_require__(830);
	
	var React = __webpack_require__(184);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(20);
	var warning = __webpack_require__(25);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(20);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactCurrentOwner = __webpack_require__(118);
	var ReactInstanceMap = __webpack_require__(228);
	var ReactInstrumentation = __webpack_require__(86);
	var ReactUpdates = __webpack_require__(104);
	
	var invariant = __webpack_require__(20);
	var warning = __webpack_require__(25);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 447 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 448 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 449 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 450 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(67);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 452 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(47);
	
	var emptyFunction = __webpack_require__(99);
	var warning = __webpack_require__(25);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1895);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _extends = _interopDefault(__webpack_require__(473));
	var _objectWithoutPropertiesLoose = _interopDefault(__webpack_require__(955));
	var _inheritsLoose = _interopDefault(__webpack_require__(954));
	var react = __webpack_require__(1);
	var PropTypes = _interopDefault(__webpack_require__(3));
	var ResizeObserver = _interopDefault(__webpack_require__(2019));
	
	var types = ['client', 'offset', 'scroll', 'bounds', 'margin'];
	function getTypes(props) {
	  var allowedTypes = [];
	  types.forEach(function (type) {
	    if (props[type]) {
	      allowedTypes.push(type);
	    }
	  });
	  return allowedTypes;
	}
	
	function getContentRect(node, types) {
	  var calculations = {};
	
	  if (types.indexOf('client') > -1) {
	    calculations.client = {
	      top: node.clientTop,
	      left: node.clientLeft,
	      width: node.clientWidth,
	      height: node.clientHeight
	    };
	  }
	
	  if (types.indexOf('offset') > -1) {
	    calculations.offset = {
	      top: node.offsetTop,
	      left: node.offsetLeft,
	      width: node.offsetWidth,
	      height: node.offsetHeight
	    };
	  }
	
	  if (types.indexOf('scroll') > -1) {
	    calculations.scroll = {
	      top: node.scrollTop,
	      left: node.scrollLeft,
	      width: node.scrollWidth,
	      height: node.scrollHeight
	    };
	  }
	
	  if (types.indexOf('bounds') > -1) {
	    var rect = node.getBoundingClientRect();
	    calculations.bounds = {
	      top: rect.top,
	      right: rect.right,
	      bottom: rect.bottom,
	      left: rect.left,
	      width: rect.width,
	      height: rect.height
	    };
	  }
	
	  if (types.indexOf('margin') > -1) {
	    var styles = getComputedStyle(node);
	    calculations.margin = {
	      top: styles ? parseInt(styles.marginTop) : 0,
	      right: styles ? parseInt(styles.marginRight) : 0,
	      bottom: styles ? parseInt(styles.marginBottom) : 0,
	      left: styles ? parseInt(styles.marginLeft) : 0
	    };
	  }
	
	  return calculations;
	}
	
	/**
	 * Returns the global window object associated with provided element.
	 */
	function getWindowOf(target) {
	  // Assume that the element is an instance of Node, which means that it
	  // has the "ownerDocument" property from which we can retrieve a
	  // corresponding global object.
	  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView; // Return the local window object if it's not possible extract one from
	  // provided element.
	
	  return ownerGlobal || window;
	}
	
	function withContentRect(types) {
	  return function (WrappedComponent) {
	    var _class, _temp;
	
	    return _temp = _class =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithContentRect, _Component);
	
	      function WithContentRect() {
	        var _this;
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	        _this.state = {
	          contentRect: {
	            entry: {},
	            client: {},
	            offset: {},
	            scroll: {},
	            bounds: {},
	            margin: {}
	          }
	        };
	        _this._animationFrameID = null;
	        _this._resizeObserver = null;
	        _this._node = null;
	        _this._window = null;
	
	        _this.measure = function (entries) {
	          var contentRect = getContentRect(_this._node, types || getTypes(_this.props));
	
	          if (entries) {
	            contentRect.entry = entries[0].contentRect;
	          }
	
	          _this._animationFrameID = _this._window.requestAnimationFrame(function () {
	            if (_this._resizeObserver !== null) {
	              _this.setState({
	                contentRect: contentRect
	              });
	
	              if (typeof _this.props.onResize === 'function') {
	                _this.props.onResize(contentRect);
	              }
	            }
	          });
	        };
	
	        _this._handleRef = function (node) {
	          if (_this._resizeObserver !== null && _this._node !== null) {
	            _this._resizeObserver.unobserve(_this._node);
	          }
	
	          _this._node = node;
	          _this._window = getWindowOf(_this._node);
	          var innerRef = _this.props.innerRef;
	
	          if (innerRef) {
	            if (typeof innerRef === 'function') {
	              innerRef(_this._node);
	            } else {
	              innerRef.current = _this._node;
	            }
	          }
	
	          if (_this._resizeObserver !== null && _this._node !== null) {
	            _this._resizeObserver.observe(_this._node);
	          }
	        };
	
	        return _this;
	      }
	
	      var _proto = WithContentRect.prototype;
	
	      _proto.componentDidMount = function componentDidMount() {
	        this._resizeObserver = this._window !== null && this._window.ResizeObserver ? new this._window.ResizeObserver(this.measure) : new ResizeObserver(this.measure);
	
	        if (this._node !== null) {
	          this._resizeObserver.observe(this._node);
	
	          if (typeof this.props.onResize === 'function') {
	            this.props.onResize(getContentRect(this._node, types || getTypes(this.props)));
	          }
	        }
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        if (this._window !== null) {
	          this._window.cancelAnimationFrame(this._animationFrameID);
	        }
	
	        if (this._resizeObserver !== null) {
	          this._resizeObserver.disconnect();
	
	          this._resizeObserver = null;
	        }
	      };
	
	      _proto.render = function render() {
	        var _this$props = this.props,
	            innerRef = _this$props.innerRef,
	            onResize = _this$props.onResize,
	            props = _objectWithoutPropertiesLoose(_this$props, ["innerRef", "onResize"]);
	
	        return react.createElement(WrappedComponent, _extends({}, props, {
	          measureRef: this._handleRef,
	          measure: this.measure,
	          contentRect: this.state.contentRect
	        }));
	      };
	
	      return WithContentRect;
	    }(react.Component), _class.propTypes = {
	      client: PropTypes.bool,
	      offset: PropTypes.bool,
	      scroll: PropTypes.bool,
	      bounds: PropTypes.bool,
	      margin: PropTypes.bool,
	      innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
	      onResize: PropTypes.func
	    }, _temp;
	  };
	}
	
	var Measure = withContentRect()(function (_ref) {
	  var measure = _ref.measure,
	      measureRef = _ref.measureRef,
	      contentRect = _ref.contentRect,
	      children = _ref.children;
	  return children({
	    measure: measure,
	    measureRef: measureRef,
	    contentRect: contentRect
	  });
	});
	Measure.displayName = 'Measure';
	Measure.propTypes.children = PropTypes.func;
	
	exports.default = Measure;
	exports.withContentRect = withContentRect;


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;
	
	var _exenv = __webpack_require__(1397);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EE = _exenv2.default;
	
	var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
	
	var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};
	
	var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};
	
	var canUseDOM = exports.canUseDOM = EE.canUseDOM;
	
	exports.default = SafeHTMLElement;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	// eslint-disable-next-line import/no-unresolved
	module.exports = __webpack_require__(1907);


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(301);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);

/***/ },
/* 460 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	function ContextProvider(name) {
	  var _childContextTypes, _config;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  var config = (_config = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _config[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _config);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillMount = config.componentWillMount;
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillMount;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _config2;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  var config = (_config2 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref2;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref2 = {}, _ref2[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref2;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _config2[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _config2);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(454);
	
	var _createReactClass = __webpack_require__(115);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _getRouteParams = __webpack_require__(1949);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(461);
	
	var _RouteUtils = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        // Handle components is object for { [name]: component } but not valid element
	        // type of react, such as React.memo, React.lazy and so on.
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object' && !(0, _reactIs.isValidElementType)(components)) {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 464 */
47,
/* 465 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ARRAY_INSERT = exports.ARRAY_INSERT = '@@redux-form/ARRAY_INSERT';
	var ARRAY_MOVE = exports.ARRAY_MOVE = '@@redux-form/ARRAY_MOVE';
	var ARRAY_POP = exports.ARRAY_POP = '@@redux-form/ARRAY_POP';
	var ARRAY_PUSH = exports.ARRAY_PUSH = '@@redux-form/ARRAY_PUSH';
	var ARRAY_REMOVE = exports.ARRAY_REMOVE = '@@redux-form/ARRAY_REMOVE';
	var ARRAY_REMOVE_ALL = exports.ARRAY_REMOVE_ALL = '@@redux-form/ARRAY_REMOVE_ALL';
	var ARRAY_SHIFT = exports.ARRAY_SHIFT = '@@redux-form/ARRAY_SHIFT';
	var ARRAY_SPLICE = exports.ARRAY_SPLICE = '@@redux-form/ARRAY_SPLICE';
	var ARRAY_UNSHIFT = exports.ARRAY_UNSHIFT = '@@redux-form/ARRAY_UNSHIFT';
	var ARRAY_SWAP = exports.ARRAY_SWAP = '@@redux-form/ARRAY_SWAP';
	var AUTOFILL = exports.AUTOFILL = '@@redux-form/AUTOFILL';
	var BLUR = exports.BLUR = '@@redux-form/BLUR';
	var CHANGE = exports.CHANGE = '@@redux-form/CHANGE';
	var CLEAR_SUBMIT = exports.CLEAR_SUBMIT = '@@redux-form/CLEAR_SUBMIT';
	var DESTROY = exports.DESTROY = '@@redux-form/DESTROY';
	var FOCUS = exports.FOCUS = '@@redux-form/FOCUS';
	var INITIALIZE = exports.INITIALIZE = '@@redux-form/INITIALIZE';
	var REGISTER_FIELD = exports.REGISTER_FIELD = '@@redux-form/REGISTER_FIELD';
	var RESET = exports.RESET = '@@redux-form/RESET';
	var SET_SUBMIT_FAILED = exports.SET_SUBMIT_FAILED = '@@redux-form/SET_SUBMIT_FAILED';
	var SET_SUBMIT_SUCCEEDED = exports.SET_SUBMIT_SUCCEEDED = '@@redux-form/SET_SUBMIT_SUCCEEDED';
	var START_ASYNC_VALIDATION = exports.START_ASYNC_VALIDATION = '@@redux-form/START_ASYNC_VALIDATION';
	var START_SUBMIT = exports.START_SUBMIT = '@@redux-form/START_SUBMIT';
	var STOP_ASYNC_VALIDATION = exports.STOP_ASYNC_VALIDATION = '@@redux-form/STOP_ASYNC_VALIDATION';
	var STOP_SUBMIT = exports.STOP_SUBMIT = '@@redux-form/STOP_SUBMIT';
	var SUBMIT = exports.SUBMIT = '@@redux-form/SUBMIT';
	var TOUCH = exports.TOUCH = '@@redux-form/TOUCH';
	var UNREGISTER_FIELD = exports.UNREGISTER_FIELD = '@@redux-form/UNREGISTER_FIELD';
	var UNTOUCH = exports.UNTOUCH = '@@redux-form/UNTOUCH';
	var UPDATE_SYNC_ERRORS = exports.UPDATE_SYNC_ERRORS = '@@redux-form/UPDATE_SYNC_ERRORS';
	var UPDATE_SYNC_WARNINGS = exports.UPDATE_SYNC_WARNINGS = '@@redux-form/UPDATE_SYNC_WARNINGS';

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hasError = __webpack_require__(1997);
	
	var _hasError2 = _interopRequireDefault(_hasError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsValid = function createIsValid(structure) {
	  var getIn = structure.getIn;
	
	  var hasError = (0, _hasError2.default)(structure);
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      var formState = getFormState(state);
	      var syncError = getIn(formState, form + '.syncError');
	      if (syncError) {
	        return false;
	      }
	      var syncErrors = getIn(formState, form + '.syncErrors');
	      var asyncErrors = getIn(formState, form + '.asyncErrors');
	      var submitErrors = getIn(formState, form + '.submitErrors');
	      if (!syncErrors && !asyncErrors && !submitErrors) {
	        return true;
	      }
	
	      var registeredFields = getIn(formState, form + '.registeredFields') || [];
	      return !registeredFields.some(function (field) {
	        return hasError(field, syncErrors, asyncErrors, submitErrors);
	      });
	    };
	  };
	};
	
	exports.default = createIsValid;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _shallowequal = __webpack_require__(2033);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
	  return !(0, _shallowequal2.default)(instance.props, nextProps) || !(0, _shallowequal2.default)(instance.state, nextState);
	};
	
	exports.default = shallowCompare;

/***/ },
/* 468 */
[2140, 149],
/* 469 */
[2141, 149, 149],
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(39).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(470).setImmediate, __webpack_require__(470).clearImmediate))

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tjt_mc.dfdfc33e.png";

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tjt_mtm.9fbd97f2.png";

/***/ },
/* 473 */
/***/ function(module, exports) {

	function _extends() {
	  return module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
	    for (var e = 1; e < arguments.length; e++) {
	      var t = arguments[e];
	      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
	    }
	    return n;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
	}
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 474 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Merges real and imaginary Float32Arrays into a single complex Float32Array.
	 *
	 * The memory layout is interleaved as follows:
	 * real: [r0, r1, r2]
	 * imag: [i0, i1, i2]
	 * complex: [r0, i0, r1, i1, r2, i2]
	 *
	 * This is the inverse of splitRealAndImagArrays.
	 *
	 * @param real The real values of the complex tensor values.
	 * @param imag The imag values of the complex tensor values.
	 * @returns A complex tensor as a Float32Array with merged values.
	 */
	function mergeRealAndImagArrays(real, imag) {
	    if (real.length !== imag.length) {
	        throw new Error("Cannot merge real and imag arrays of different lengths. real:" +
	            (real.length + ", imag: " + imag.length + "."));
	    }
	    var result = new Float32Array(real.length * 2);
	    for (var i = 0; i < result.length; i += 2) {
	        result[i] = real[i / 2];
	        result[i + 1] = imag[i / 2];
	    }
	    return result;
	}
	exports.mergeRealAndImagArrays = mergeRealAndImagArrays;
	/**
	 * Splits a complex Float32Array into real and imag parts.
	 *
	 * The memory layout is interleaved as follows:
	 * complex: [r0, i0, r1, i1, r2, i2]
	 * real: [r0, r1, r2]
	 * imag: [i0, i1, i2]
	 *
	 * This is the inverse of mergeRealAndImagArrays.
	 *
	 * @param complex The complex tensor values.
	 * @returns An object with real and imag Float32Array components of the complex
	 *     tensor.
	 */
	function splitRealAndImagArrays(complex) {
	    var real = new Float32Array(complex.length / 2);
	    var imag = new Float32Array(complex.length / 2);
	    for (var i = 0; i < complex.length; i += 2) {
	        real[i / 2] = complex[i];
	        imag[i / 2] = complex[i + 1];
	    }
	    return { real: real, imag: imag };
	}
	exports.splitRealAndImagArrays = splitRealAndImagArrays;
	/**
	 * Extracts even indexed complex values in the given array.
	 * @param complex The complex tensor values
	 */
	function complexWithEvenIndex(complex) {
	    var len = Math.ceil(complex.length / 4);
	    var real = new Float32Array(len);
	    var imag = new Float32Array(len);
	    for (var i = 0; i < complex.length; i += 4) {
	        real[Math.floor(i / 4)] = complex[i];
	        imag[Math.floor(i / 4)] = complex[i + 1];
	    }
	    return { real: real, imag: imag };
	}
	exports.complexWithEvenIndex = complexWithEvenIndex;
	/**
	 * Extracts odd indexed comple values in the given array.
	 * @param complex The complex tensor values
	 */
	function complexWithOddIndex(complex) {
	    var len = Math.floor(complex.length / 4);
	    var real = new Float32Array(len);
	    var imag = new Float32Array(len);
	    for (var i = 2; i < complex.length; i += 4) {
	        real[Math.floor(i / 4)] = complex[i];
	        imag[Math.floor(i / 4)] = complex[i + 1];
	    }
	    return { real: real, imag: imag };
	}
	exports.complexWithOddIndex = complexWithOddIndex;
	/**
	 * Get the map representing a complex value in the given array.
	 * @param complex The complex tensor values.
	 * @param index An index of the target complex value.
	 */
	function getComplexWithIndex(complex, index) {
	    var real = complex[index * 2];
	    var imag = complex[index * 2 + 1];
	    return { real: real, imag: imag };
	}
	exports.getComplexWithIndex = getComplexWithIndex;
	/**
	 * Insert a given complex value into the TypedArray.
	 * @param data The array in which the complex value is inserted.
	 * @param c The complex value to be inserted.
	 * @param index An index of the target complex value.
	 */
	function assignToTypedArray(data, real, imag, index) {
	    data[index * 2] = real;
	    data[index * 2 + 1] = imag;
	}
	exports.assignToTypedArray = assignToTypedArray;
	/**
	 * Make the list of exponent terms used by FFT.
	 */
	function exponents(n, inverse) {
	    var real = new Float32Array(n / 2);
	    var imag = new Float32Array(n / 2);
	    for (var i = 0; i < Math.ceil(n / 2); i++) {
	        var x = (inverse ? 2 : -2) * Math.PI * (i / n);
	        real[i] = Math.cos(x);
	        imag[i] = Math.sin(x);
	    }
	    return { real: real, imag: imag };
	}
	exports.exponents = exponents;
	/**
	 * Make the exponent term used by FFT.
	 */
	function exponent(k, n, inverse) {
	    var x = (inverse ? 2 : -2) * Math.PI * (k / n);
	    var real = Math.cos(x);
	    var imag = Math.sin(x);
	    return { real: real, imag: imag };
	}
	exports.exponent = exponent;
	//# sourceMappingURL=complex_util.js.map

/***/ },
/* 475 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Shared implementation of the split kernel across WebGL and CPU. */
	function split(x, sizeSplits, axis) {
	    var begin = new Array(x.rank).fill(0);
	    var size = x.shape.slice();
	    return sizeSplits.map(function (s) {
	        size[axis] = s;
	        var slice = x.slice(begin, size);
	        begin[axis] += s;
	        return slice;
	    });
	}
	exports.split = split;
	//# sourceMappingURL=split_shared.js.map

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * An implementation of the tile kernel shared between webgl and cpu for string
	 * tensors only.
	 */
	var array_ops_1 = __webpack_require__(89);
	function tile(xBuf, reps) {
	    var newShape = new Array(xBuf.rank);
	    for (var i = 0; i < newShape.length; i++) {
	        newShape[i] = xBuf.shape[i] * reps[i];
	    }
	    var result = array_ops_1.buffer(newShape, xBuf.dtype);
	    for (var i = 0; i < result.values.length; ++i) {
	        var newLoc = result.indexToLoc(i);
	        var originalLoc = new Array(xBuf.rank);
	        for (var j = 0; j < originalLoc.length; j++) {
	            originalLoc[j] = newLoc[j] % xBuf.shape[j];
	        }
	        var originalIndex = xBuf.locToIndex(originalLoc);
	        result.values[i] = xBuf.values[originalIndex];
	    }
	    return result.toTensor();
	}
	exports.tile = tile;
	//# sourceMappingURL=tile_impl.js.map

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** An implementation of the TopK kernel shared between webgl and cpu. */
	var tensor_ops_1 = __webpack_require__(31);
	var util_1 = __webpack_require__(10);
	function topkImpl(x, xShape, xDtype, k, sorted) {
	    // Reshape into a 2d tensor [batch, lastDim] and compute topk along lastDim.
	    var lastDim = xShape[xShape.length - 1];
	    var _a = [x.length / lastDim, lastDim], batch = _a[0], size = _a[1];
	    var allTopKVals = util_1.getTypedArrayFromDType(xDtype, batch * k);
	    var allTopKIndices = util_1.getTypedArrayFromDType('int32', batch * k);
	    for (var b = 0; b < batch; b++) {
	        var offset = b * size;
	        var vals = x.subarray(offset, offset + size);
	        var valAndInd = [];
	        for (var i = 0; i < vals.length; i++) {
	            valAndInd.push({ value: vals[i], index: i });
	        }
	        valAndInd.sort(function (a, b) { return b.value - a.value; });
	        var outOffset = b * k;
	        var topKVals = allTopKVals.subarray(outOffset, outOffset + k);
	        var topKIndices = allTopKIndices.subarray(outOffset, outOffset + k);
	        for (var i = 0; i < k; i++) {
	            topKVals[i] = valAndInd[i].value;
	            topKIndices[i] = valAndInd[i].index;
	        }
	    }
	    // Reshape back to the original input shape, except that the last
	    // dimension is k.
	    var outputShape = xShape.slice();
	    outputShape[outputShape.length - 1] = k;
	    return [
	        tensor_ops_1.tensor(allTopKVals, outputShape, xDtype),
	        tensor_ops_1.tensor(allTopKIndices, outputShape, 'int32')
	    ];
	}
	exports.topkImpl = topkImpl;
	//# sourceMappingURL=topk_impl.js.map

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Import webgl flags.
	__webpack_require__(992);
	var device_util = __webpack_require__(311);
	var engine_1 = __webpack_require__(15);
	var environment_1 = __webpack_require__(28);
	var globals_1 = __webpack_require__(73);
	var log_1 = __webpack_require__(313);
	var array_ops_1 = __webpack_require__(89);
	var array_ops_util = __webpack_require__(486);
	var axis_util = __webpack_require__(108);
	var complex_ops_1 = __webpack_require__(191);
	var concat_util_1 = __webpack_require__(153);
	var gather_nd_util = __webpack_require__(315);
	var reduce_util = __webpack_require__(316);
	var scatter_nd_util = __webpack_require__(239);
	var segment_util = __webpack_require__(495);
	var slice_util = __webpack_require__(192);
	var softmax_1 = __webpack_require__(497);
	var tensor_ops_1 = __webpack_require__(31);
	var types_1 = __webpack_require__(193);
	var util = __webpack_require__(10);
	var util_1 = __webpack_require__(10);
	var backend_1 = __webpack_require__(306);
	var backend_util = __webpack_require__(234);
	var complex_util_1 = __webpack_require__(474);
	var non_max_suppression_impl_1 = __webpack_require__(188);
	var split_shared_1 = __webpack_require__(475);
	var tile_impl_1 = __webpack_require__(476);
	var topk_impl_1 = __webpack_require__(477);
	var where_impl_1 = __webpack_require__(310);
	var addn_gpu_1 = __webpack_require__(964);
	var addn_packed_gpu_1 = __webpack_require__(965);
	var argminmax_gpu_1 = __webpack_require__(966);
	var argminmax_packed_gpu_1 = __webpack_require__(967);
	var avg_pool_backprop_gpu_1 = __webpack_require__(968);
	var batchnorm_gpu_1 = __webpack_require__(969);
	var batchnorm_packed_gpu_1 = __webpack_require__(970);
	var binaryop_complex_gpu = __webpack_require__(479);
	var binaryop_complex_gpu_1 = __webpack_require__(479);
	var binaryop_gpu = __webpack_require__(307);
	var binaryop_gpu_1 = __webpack_require__(307);
	var binaryop_packed_gpu = __webpack_require__(308);
	var binaryop_packed_gpu_1 = __webpack_require__(308);
	var canvas_util_1 = __webpack_require__(236);
	var clip_gpu_1 = __webpack_require__(971);
	var clip_packed_gpu_1 = __webpack_require__(972);
	var complex_abs_gpu_1 = __webpack_require__(973);
	var concat_gpu_1 = __webpack_require__(974);
	var concat_packed_gpu_1 = __webpack_require__(975);
	var conv_backprop_gpu_1 = __webpack_require__(976);
	var conv_backprop_gpu_depthwise_1 = __webpack_require__(977);
	var conv_gpu_1 = __webpack_require__(978);
	var conv_gpu_depthwise_1 = __webpack_require__(979);
	var conv_packed_gpu_depthwise_1 = __webpack_require__(980);
	var crop_and_resize_gpu_1 = __webpack_require__(981);
	var cumsum_gpu_1 = __webpack_require__(982);
	var decode_matrix_gpu_1 = __webpack_require__(983);
	var decode_matrix_packed_gpu_1 = __webpack_require__(984);
	var depth_to_space_gpu_1 = __webpack_require__(985);
	var diag_gpu_1 = __webpack_require__(986);
	var encode_float_gpu_1 = __webpack_require__(987);
	var encode_float_packed_gpu_1 = __webpack_require__(988);
	var encode_matrix_gpu_1 = __webpack_require__(989);
	var encode_matrix_packed_gpu_1 = __webpack_require__(990);
	var fft_gpu = __webpack_require__(480);
	var fft_gpu_1 = __webpack_require__(480);
	var fill_gpu_1 = __webpack_require__(991);
	var gather_gpu_1 = __webpack_require__(993);
	var gather_nd_gpu_1 = __webpack_require__(994);
	var gpgpu_context_1 = __webpack_require__(481);
	var gpgpu_math = __webpack_require__(995);
	var im2col_packed_gpu_1 = __webpack_require__(996);
	var lrn_gpu_1 = __webpack_require__(1003);
	var lrn_grad_gpu_1 = __webpack_require__(1004);
	var lrn_packed_gpu_1 = __webpack_require__(1005);
	var max_pool_backprop_gpu_1 = __webpack_require__(1006);
	var mulmat_packed_gpu_1 = __webpack_require__(1007);
	var multinomial_gpu_1 = __webpack_require__(1008);
	var onehot_gpu_1 = __webpack_require__(1009);
	var pack_gpu_1 = __webpack_require__(1010);
	var pad_gpu_1 = __webpack_require__(1011);
	var pad_packed_gpu_1 = __webpack_require__(1012);
	var pool_gpu_1 = __webpack_require__(1013);
	var reduce_gpu_1 = __webpack_require__(1014);
	var reshape_packed_gpu_1 = __webpack_require__(1016);
	var resize_bilinear_backprop_gpu_1 = __webpack_require__(1017);
	var resize_bilinear_gpu_1 = __webpack_require__(1018);
	var resize_bilinear_packed_gpu_1 = __webpack_require__(1019);
	var resize_nearest_neighbor_backprop_gpu_1 = __webpack_require__(1020);
	var resize_nearest_neighbor_gpu_1 = __webpack_require__(1021);
	var reverse_gpu_1 = __webpack_require__(1022);
	var reverse_packed_gpu_1 = __webpack_require__(1023);
	var scatter_gpu_1 = __webpack_require__(1024);
	var segment_gpu_1 = __webpack_require__(1025);
	var select_gpu_1 = __webpack_require__(1026);
	var slice_gpu_1 = __webpack_require__(1027);
	var slice_packed_gpu_1 = __webpack_require__(1028);
	var strided_slice_gpu_1 = __webpack_require__(1029);
	var tex_util = __webpack_require__(82);
	var tex_util_1 = __webpack_require__(82);
	var texture_manager_1 = __webpack_require__(1030);
	var tile_gpu_1 = __webpack_require__(1031);
	var transpose_gpu_1 = __webpack_require__(1032);
	var transpose_packed_gpu_1 = __webpack_require__(1033);
	var unary_op = __webpack_require__(309);
	var unaryop_gpu_1 = __webpack_require__(309);
	var unary_packed_op = __webpack_require__(483);
	var unaryop_packed_gpu_1 = __webpack_require__(483);
	var unpack_gpu_1 = __webpack_require__(1034);
	var webgl_util = __webpack_require__(189);
	var binaryCaches = {};
	function getBinaryCache(webGLVersion) {
	    if (webGLVersion in binaryCaches) {
	        return binaryCaches[webGLVersion];
	    }
	    binaryCaches[webGLVersion] = {};
	    return binaryCaches[webGLVersion];
	}
	exports.getBinaryCache = getBinaryCache;
	function mapActivationToShaderProgram(activation, packed) {
	    if (packed === void 0) { packed = false; }
	    if (activation === 'linear') {
	        if (packed) {
	            return unary_packed_op.LINEAR;
	        }
	        return unary_op.LINEAR;
	    }
	    else if (activation === 'relu') {
	        if (packed) {
	            return unary_packed_op.RELU;
	        }
	        return unary_op.RELU;
	    }
	    else if (activation === 'elu') {
	        if (packed) {
	            return unary_packed_op.ELU;
	        }
	        return unary_op.ELU;
	    }
	    else if (activation === 'relu6') {
	        if (packed) {
	            return unary_packed_op.RELU6;
	        }
	        return unary_op.RELU6;
	    }
	    else if (activation === 'prelu') {
	        if (packed) {
	            return binaryop_packed_gpu.PRELU;
	        }
	        return binaryop_gpu.PRELU;
	    }
	    throw new Error("Activation " + activation + " has not been implemented for the WebGL backend.");
	}
	// Empirically determined constant used to determine size threshold for handing
	// off execution to the CPU.
	var CPU_HANDOFF_SIZE_THRESHOLD = 128;
	// Empirically determined constant used to decide the number of MB on GPU
	// before we warn about high memory use. The MB are this constant * screen area
	// * dpi / 1024 / 1024.
	var BEFORE_PAGING_CONSTANT = 600;
	function numMBBeforeWarning() {
	    if (environment_1.env().global.screen == null) {
	        return 1024; // 1 GB.
	    }
	    return (environment_1.env().global.screen.height * environment_1.env().global.screen.width *
	        window.devicePixelRatio) *
	        BEFORE_PAGING_CONSTANT / 1024 / 1024;
	}
	// Empirically determined minimal shared dimension in matmul before we forward
	// to a.mul(b).sum() in order to take advantage of GPU parallelism. See
	// https://github.com/tensorflow/tfjs-core/pull/1379 for benchmarks.
	exports.MATMUL_SHARED_DIM_THRESHOLD = 1000;
	var MathBackendWebGL = /** @class */ (function (_super) {
	    __extends(MathBackendWebGL, _super);
	    function MathBackendWebGL(gpgpu) {
	        var _this = _super.call(this) || this;
	        // Maps data ids that have a pending read operation, to list of subscribers.
	        _this.pendingRead = new WeakMap();
	        // List of data ids that are scheduled for disposal, but are waiting on a
	        // pending read operation.
	        _this.pendingDisposal = new WeakSet();
	        // Used to count the number of 'shallow' sliced tensors that point to the
	        // same data id.
	        _this.dataRefCount = new WeakMap();
	        _this.numBytesInGPU = 0;
	        // Accumulated time spent (including blocking) in uploading data to webgl.
	        _this.uploadWaitMs = 0;
	        // Accumulated time spent (including blocking in downloading data from webgl.
	        _this.downloadWaitMs = 0;
	        _this.warnedAboutMemory = false;
	        _this.pendingDeletes = 0;
	        _this.disposed = false;
	        if (!environment_1.env().getBool('HAS_WEBGL')) {
	            throw new Error('WebGL is not supported on this device');
	        }
	        if (gpgpu == null) {
	            var gl = canvas_util_1.getWebGLContext(environment_1.env().getNumber('WEBGL_VERSION'));
	            _this.binaryCache = getBinaryCache(environment_1.env().getNumber('WEBGL_VERSION'));
	            _this.gpgpu = new gpgpu_context_1.GPGPUContext(gl);
	            _this.canvas = gl.canvas;
	            _this.gpgpuCreatedLocally = true;
	        }
	        else {
	            _this.gpgpu = gpgpu;
	            _this.binaryCache = {};
	            _this.gpgpuCreatedLocally = false;
	            _this.canvas = gpgpu.gl.canvas;
	        }
	        _this.textureManager = new texture_manager_1.TextureManager(_this.gpgpu);
	        _this.numMBBeforeWarning = numMBBeforeWarning();
	        _this.texData = new backend_1.DataStorage(_this, engine_1.ENGINE);
	        return _this;
	    }
	    MathBackendWebGL.prototype.numDataIds = function () {
	        return this.texData.numDataIds() +
	            (this.cpuBackend ? this.cpuBackend.numDataIds() : 0) -
	            this.pendingDeletes;
	    };
	    MathBackendWebGL.prototype.write = function (values, shape, dtype) {
	        if (environment_1.env().getBool('DEBUG')) {
	            this.checkNumericalProblems(values);
	        }
	        if (dtype === 'complex64' && values != null) {
	            throw new Error("Cannot write to a complex64 dtype. " +
	                "Please use tf.complex(real, imag).");
	        }
	        var dataId = {};
	        this.texData.set(dataId, { shape: shape, dtype: dtype, values: values, usage: tex_util_1.TextureUsage.UPLOAD });
	        return dataId;
	    };
	    MathBackendWebGL.prototype.move = function (dataId, values, shape, dtype) {
	        if (environment_1.env().getBool('DEBUG')) {
	            this.checkNumericalProblems(values);
	        }
	        if (dtype === 'complex64') {
	            throw new Error("Cannot write to a complex64 dtype. " +
	                "Please use tf.complex(real, imag).");
	        }
	        this.texData.set(dataId, { shape: shape, dtype: dtype, values: values, usage: tex_util_1.TextureUsage.UPLOAD });
	    };
	    MathBackendWebGL.prototype.readSync = function (dataId) {
	        var texData = this.texData.get(dataId);
	        var values = texData.values, dtype = texData.dtype, complexTensors = texData.complexTensors, slice = texData.slice, shape = texData.shape, isPacked = texData.isPacked;
	        if (slice != null) {
	            var program = void 0;
	            if (isPacked) {
	                program = new unaryop_packed_gpu_1.UnaryOpPackedProgram(shape, unary_op.CLONE);
	            }
	            else {
	                program = new unaryop_gpu_1.UnaryOpProgram(shape, unary_op.CLONE);
	            }
	            var res = this.runWebGLProgram(program, [{ dataId: dataId, shape: shape, dtype: dtype }], dtype);
	            var data = this.readSync(res.dataId);
	            this.disposeData(res.dataId);
	            return data;
	        }
	        if (values != null) {
	            return this.convertAndCacheOnCPU(dataId);
	        }
	        if (dtype === 'string') {
	            return values;
	        }
	        var shouldTimeProgram = this.activeTimers != null;
	        var start;
	        if (shouldTimeProgram) {
	            start = util.now();
	        }
	        var result;
	        if (dtype === 'complex64') {
	            var realValues = complexTensors.real.dataSync();
	            var imagValues = complexTensors.imag.dataSync();
	            result = complex_util_1.mergeRealAndImagArrays(realValues, imagValues);
	        }
	        else {
	            result = this.getValuesFromTexture(dataId);
	        }
	        if (shouldTimeProgram) {
	            this.downloadWaitMs += util.now() - start;
	        }
	        return this.convertAndCacheOnCPU(dataId, result);
	    };
	    MathBackendWebGL.prototype.read = function (dataId) {
	        return __awaiter(this, void 0, void 0, function () {
	            var subscribers_1, texData, values, shape, slice, dtype, complexTensors, isPacked, program, res, data, buffer, tmpDownloadTarget, tmpData, vals, ps, realValues, imagValues, size, dTypeVals, subscribers;
	            var _a;
	            return __generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        if (this.pendingRead.has(dataId)) {
	                            subscribers_1 = this.pendingRead.get(dataId);
	                            return [2 /*return*/, new Promise(function (resolve) { return subscribers_1.push(resolve); })];
	                        }
	                        texData = this.texData.get(dataId);
	                        values = texData.values, shape = texData.shape, slice = texData.slice, dtype = texData.dtype, complexTensors = texData.complexTensors, isPacked = texData.isPacked;
	                        if (slice != null) {
	                            program = void 0;
	                            if (isPacked) {
	                                program = new unaryop_packed_gpu_1.UnaryOpPackedProgram(shape, unary_op.CLONE);
	                            }
	                            else {
	                                program = new unaryop_gpu_1.UnaryOpProgram(shape, unary_op.CLONE);
	                            }
	                            res = this.runWebGLProgram(program, [{ dataId: dataId, shape: shape, dtype: dtype }], dtype);
	                            data = this.read(res.dataId);
	                            this.disposeData(res.dataId);
	                            return [2 /*return*/, data];
	                        }
	                        if (values != null) {
	                            return [2 /*return*/, this.convertAndCacheOnCPU(dataId)];
	                        }
	                        if (!environment_1.env().getBool('WEBGL_DOWNLOAD_FLOAT_ENABLED') &&
	                            environment_1.env().getNumber('WEBGL_VERSION') === 2) {
	                            throw new Error("tensor.data() with WEBGL_DOWNLOAD_FLOAT_ENABLED=false and " +
	                                "WEBGL_VERSION=2 not yet supported.");
	                        }
	                        buffer = null;
	                        if (dtype !== 'complex64' && environment_1.env().get('WEBGL_BUFFER_SUPPORTED')) {
	                            // Possibly copy the texture into a buffer before inserting a fence.
	                            tmpDownloadTarget = this.decode(dataId);
	                            tmpData = this.texData.get(tmpDownloadTarget.dataId);
	                            buffer = (_a = this.gpgpu).createBufferFromTexture.apply(_a, [tmpData.texture].concat(tex_util.getDenseTexShape(shape)));
	                        }
	                        this.pendingRead.set(dataId, []);
	                        if (!(dtype !== 'complex64')) return [3 /*break*/, 2];
	                        // Create a fence and wait for it to resolve.
	                        return [4 /*yield*/, this.gpgpu.createAndWaitForFence()];
	                    case 1:
	                        // Create a fence and wait for it to resolve.
	                        _b.sent();
	                        _b.label = 2;
	                    case 2:
	                        if (!(dtype === 'complex64')) return [3 /*break*/, 4];
	                        return [4 /*yield*/, Promise.all([complexTensors.real.data(), complexTensors.imag.data()])];
	                    case 3:
	                        ps = _b.sent();
	                        realValues = ps[0];
	                        imagValues = ps[1];
	                        vals = complex_util_1.mergeRealAndImagArrays(realValues, imagValues);
	                        return [3 /*break*/, 5];
	                    case 4:
	                        if (buffer == null) {
	                            vals = this.getValuesFromTexture(dataId);
	                        }
	                        else {
	                            size = util.sizeFromShape(shape);
	                            vals = this.gpgpu.downloadFloat32MatrixFromBuffer(buffer, size);
	                        }
	                        _b.label = 5;
	                    case 5:
	                        if (tmpDownloadTarget != null) {
	                            this.disposeData(tmpDownloadTarget.dataId);
	                        }
	                        dTypeVals = this.convertAndCacheOnCPU(dataId, vals);
	                        subscribers = this.pendingRead.get(dataId);
	                        this.pendingRead.delete(dataId);
	                        // Notify all pending reads.
	                        subscribers.forEach(function (resolve) { return resolve(dTypeVals); });
	                        if (this.pendingDisposal.has(dataId)) {
	                            this.pendingDisposal.delete(dataId);
	                            this.disposeData(dataId);
	                            this.pendingDeletes--;
	                        }
	                        return [2 /*return*/, dTypeVals];
	                }
	            });
	        });
	    };
	    MathBackendWebGL.prototype.checkNumericalProblems = function (values) {
	        if (values == null) {
	            return;
	        }
	        for (var i = 0; i < values.length; i++) {
	            var num = values[i];
	            if (!webgl_util.canBeRepresented(num)) {
	                if (environment_1.env().getBool('WEBGL_RENDER_FLOAT32_CAPABLE')) {
	                    throw Error("The value " + num + " cannot be represented with your " +
	                        "current settings. Consider enabling float32 rendering: " +
	                        "'tf.env().set('WEBGL_RENDER_FLOAT32_ENABLED', true);'");
	                }
	                throw Error("The value " + num + " cannot be represented on this device.");
	            }
	        }
	    };
	    MathBackendWebGL.prototype.getValuesFromTexture = function (dataId) {
	        var _a;
	        var _b = this.texData.get(dataId), shape = _b.shape, dtype = _b.dtype, isPacked = _b.isPacked;
	        var size = util.sizeFromShape(shape);
	        if (environment_1.env().getBool('WEBGL_DOWNLOAD_FLOAT_ENABLED')) {
	            var tmpTarget = this.decode(dataId);
	            var tmpData_1 = this.texData.get(tmpTarget.dataId);
	            var vals_1 = (_a = this.gpgpu).downloadMatrixFromPackedTexture.apply(_a, [tmpData_1.texture].concat(tex_util.getDenseTexShape(shape))).subarray(0, size);
	            this.disposeData(tmpTarget.dataId);
	            return vals_1;
	        }
	        var shouldUsePackedProgram = environment_1.env().getBool('WEBGL_PACK') && isPacked === true;
	        var outputShape = shouldUsePackedProgram ? webgl_util.getShapeAs3D(shape) : shape;
	        var program = shouldUsePackedProgram ?
	            new encode_float_packed_gpu_1.EncodeFloatPackedProgram(outputShape) :
	            new encode_float_gpu_1.EncodeFloatProgram(outputShape);
	        var output = this.runWebGLProgram(program, [{ shape: outputShape, dtype: dtype, dataId: dataId }], 'float32');
	        var tmpData = this.texData.get(output.dataId);
	        var vals = this.gpgpu
	            .downloadByteEncodedFloatMatrixFromOutputTexture(tmpData.texture, tmpData.texShape[0], tmpData.texShape[1])
	            .subarray(0, size);
	        this.disposeData(output.dataId);
	        return vals;
	    };
	    MathBackendWebGL.prototype.time = function (f) {
	        return __awaiter(this, void 0, void 0, function () {
	            var oldActiveTimers, newActiveTimers, outerMostTime, flattenedActiveTimerQueries, flattenedActiveTimerNames, res, kernelMs_1;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        oldActiveTimers = this.activeTimers;
	                        newActiveTimers = [];
	                        outerMostTime = false;
	                        if (this.programTimersStack == null) {
	                            this.programTimersStack = newActiveTimers;
	                            outerMostTime = true;
	                        }
	                        else {
	                            this.activeTimers.push(newActiveTimers);
	                        }
	                        this.activeTimers = newActiveTimers;
	                        f();
	                        flattenedActiveTimerQueries = util.flatten(this.activeTimers.map(function (d) { return d.query; }))
	                            .filter(function (d) { return d != null; });
	                        flattenedActiveTimerNames = util.flatten(this.activeTimers.map(function (d) { return d.name; }))
	                            .filter(function (d) { return d != null; });
	                        this.activeTimers = oldActiveTimers;
	                        if (outerMostTime) {
	                            this.programTimersStack = null;
	                        }
	                        res = {
	                            uploadWaitMs: this.uploadWaitMs,
	                            downloadWaitMs: this.downloadWaitMs,
	                            kernelMs: null,
	                            wallMs: null // will be filled by the engine
	                        };
	                        if (!(environment_1.env().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0)) return [3 /*break*/, 2];
	                        return [4 /*yield*/, Promise.all(flattenedActiveTimerQueries)];
	                    case 1:
	                        kernelMs_1 = _a.sent();
	                        res['kernelMs'] = util.sum(kernelMs_1);
	                        res['getExtraProfileInfo'] = function () {
	                            return kernelMs_1.map(function (d, i) { return ({ name: flattenedActiveTimerNames[i], ms: d }); })
	                                .map(function (d) { return d.name + ": " + d.ms; })
	                                .join(', ');
	                        };
	                        return [3 /*break*/, 3];
	                    case 2:
	                        res['kernelMs'] = {
	                            error: 'WebGL query timers are not supported in this environment.'
	                        };
	                        _a.label = 3;
	                    case 3:
	                        this.uploadWaitMs = 0;
	                        this.downloadWaitMs = 0;
	                        return [2 /*return*/, res];
	                }
	            });
	        });
	    };
	    MathBackendWebGL.prototype.memory = function () {
	        return { unreliable: false, numBytesInGPU: this.numBytesInGPU };
	    };
	    MathBackendWebGL.prototype.startTimer = function () {
	        if (environment_1.env().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0) {
	            return this.gpgpu.beginQuery();
	        }
	        return { startMs: util.now(), endMs: null };
	    };
	    MathBackendWebGL.prototype.endTimer = function (query) {
	        if (environment_1.env().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0) {
	            this.gpgpu.endQuery();
	            return query;
	        }
	        query.endMs = util.now();
	        return query;
	    };
	    MathBackendWebGL.prototype.getQueryTime = function (query) {
	        return __awaiter(this, void 0, void 0, function () {
	            var timerQuery;
	            return __generator(this, function (_a) {
	                if (environment_1.env().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0) {
	                    return [2 /*return*/, this.gpgpu.waitForQueryAndGetTime(query)];
	                }
	                timerQuery = query;
	                return [2 /*return*/, timerQuery.endMs - timerQuery.startMs];
	            });
	        });
	    };
	    MathBackendWebGL.prototype.disposeData = function (dataId) {
	        if (this.pendingDisposal.has(dataId)) {
	            return;
	        }
	        if (this.pendingRead.has(dataId)) {
	            this.pendingDisposal.add(dataId);
	            this.pendingDeletes++;
	            return;
	        }
	        // No-op if already disposed.
	        if (!this.texData.has(dataId)) {
	            return;
	        }
	        this.releaseGPUData(dataId);
	        var complexTensors = this.texData.get(dataId).complexTensors;
	        if (complexTensors != null) {
	            complexTensors.real.dispose();
	            complexTensors.imag.dispose();
	        }
	        this.texData.delete(dataId);
	    };
	    MathBackendWebGL.prototype.releaseGPUData = function (dataId) {
	        var _a = this.texData.get(dataId), texture = _a.texture, dtype = _a.dtype, texShape = _a.texShape, usage = _a.usage, isPacked = _a.isPacked, slice = _a.slice;
	        var key = slice && slice.origDataId || dataId;
	        var refCount = this.dataRefCount.get(key);
	        if (refCount > 1) {
	            this.dataRefCount.set(key, refCount - 1);
	        }
	        else {
	            this.dataRefCount.delete(key);
	            if (texture != null) {
	                this.numBytesInGPU -= this.computeBytes(texShape, dtype);
	                this.textureManager.releaseTexture(texture, texShape, usage, isPacked);
	            }
	        }
	        var texData = this.texData.get(dataId);
	        texData.texture = null;
	        texData.texShape = null;
	        texData.isPacked = false;
	        texData.slice = null;
	    };
	    MathBackendWebGL.prototype.getTexture = function (dataId) {
	        this.uploadToGPU(dataId);
	        return this.texData.get(dataId).texture;
	    };
	    /**
	     * Returns internal information for the specific data bucket. Used in unit
	     * tests.
	     */
	    MathBackendWebGL.prototype.getDataInfo = function (dataId) {
	        return this.texData.get(dataId);
	    };
	    MathBackendWebGL.prototype.getCPUBackend = function () {
	        if (!environment_1.env().getBool('WEBGL_CPU_FORWARD')) {
	            return null;
	        }
	        if (this.cpuBackend == null) {
	            this.cpuBackend = engine_1.ENGINE.findBackend('cpu');
	        }
	        return this.cpuBackend;
	    };
	    /*
	    Tests whether all the inputs to an op are small and on the CPU. This heuristic
	    determines when it would be faster to execute a kernel on the CPU. WebGL
	    kernels opt into running this check and forwarding when appropriate.
	    TODO(https://github.com/tensorflow/tfjs/issues/872): Develop a more
	    sustainable strategy for optimizing backend execution of ops.
	     */
	    MathBackendWebGL.prototype.shouldExecuteOnCPU = function (inputs, sizeThreshold) {
	        var _this = this;
	        if (sizeThreshold === void 0) { sizeThreshold = CPU_HANDOFF_SIZE_THRESHOLD; }
	        return this.getCPUBackend() != null &&
	            inputs.every(function (input) { return _this.texData.get(input.dataId).texture == null &&
	                input.size < sizeThreshold; });
	    };
	    MathBackendWebGL.prototype.getGPGPUContext = function () {
	        return this.gpgpu;
	    };
	    MathBackendWebGL.prototype.complex = function (real, imag) {
	        var result = this.makeOutput(real.shape, 'complex64');
	        var resultData = this.texData.get(result.dataId);
	        // The backend owns the reference to the underlying real and imaginary
	        // clones. These will explicitly get disposed when the complex tensor is
	        // disposed.
	        resultData.complexTensors = {
	            real: engine_1.ENGINE.keep(real.clone()),
	            imag: engine_1.ENGINE.keep(imag.clone())
	        };
	        return result;
	    };
	    MathBackendWebGL.prototype.real = function (input) {
	        var resultData = this.texData.get(input.dataId);
	        return resultData.complexTensors.real.clone();
	    };
	    MathBackendWebGL.prototype.imag = function (input) {
	        var resultData = this.texData.get(input.dataId);
	        return resultData.complexTensors.imag.clone();
	    };
	    MathBackendWebGL.prototype.slice = function (x, begin, size) {
	        if (this.shouldExecuteOnCPU([x])) {
	            return this.cpuBackend.slice(x, begin, size);
	        }
	        // Short-circuit computation if the slice is zero-sized.
	        if (util.sizeFromShape(size) === 0) {
	            return tensor_ops_1.tensor([], size, x.dtype);
	        }
	        var isPacked = this.texData.get(x.dataId).isPacked;
	        var isContinous = slice_util.isSliceContinous(x.shape, begin, size);
	        if (isPacked || !isContinous) {
	            var program = environment_1.env().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ?
	                new slice_packed_gpu_1.SlicePackedProgram(size) :
	                new slice_gpu_1.SliceProgram(size);
	            var customSetup = program.getCustomSetupFunc(begin);
	            return this.compileAndRun(program, [x], null, customSetup);
	        }
	        this.uploadToGPU(x.dataId);
	        return this.shallowSlice(x, begin, size);
	    };
	    MathBackendWebGL.prototype.shallowSlice = function (x, begin, size) {
	        var xTexData = this.texData.get(x.dataId);
	        var t = this.makeOutput(size, x.dtype);
	        var newTexData = this.texData.get(t.dataId);
	        // Copy texture data from the original tensor.
	        Object.assign(newTexData, xTexData);
	        newTexData.shape = size;
	        newTexData.dtype = x.dtype;
	        var flatOffset = slice_util.computeFlatOffset(begin, x.strides);
	        if (xTexData.slice) {
	            // We are slicing an already sliced tensor, so we have to accumulate
	            // the offset.
	            flatOffset += xTexData.slice.flatOffset;
	        }
	        newTexData.slice = {
	            flatOffset: flatOffset,
	            // Point to the original dataId, which is used to do ref counting.
	            origDataId: xTexData.slice && xTexData.slice.origDataId || x.dataId
	        };
	        // Increase the ref count for that data bucket.
	        var refCount = this.dataRefCount.get(newTexData.slice.origDataId) || 1;
	        this.dataRefCount.set(newTexData.slice.origDataId, refCount + 1);
	        return t;
	    };
	    MathBackendWebGL.prototype.stridedSlice = function (x, begin, end, strides) {
	        if (this.shouldExecuteOnCPU([x])) {
	            return this.cpuBackend.stridedSlice(x, begin, end, strides);
	        }
	        var outShape = slice_util.computeOutShape(begin, end, strides);
	        if (outShape.some(function (axis) { return axis === 0; })) {
	            return tensor_ops_1.tensor([], outShape);
	        }
	        var program = new strided_slice_gpu_1.StridedSliceProgram(begin, strides, outShape);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.reverse = function (x, axis) {
	        var program = environment_1.env().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ?
	            new reverse_packed_gpu_1.ReversePackedProgram(x.shape, axis) :
	            new reverse_gpu_1.ReverseProgram(x.shape, axis);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.concat = function (tensors, axis) {
	        if (tensors[0].dtype === 'complex64') {
	            var reals = tensors.map(function (t) { return complex_ops_1.real(t); });
	            var imags = tensors.map(function (t) { return complex_ops_1.imag(t); });
	            return complex_ops_1.complex(this.concat(reals, axis), this.concat(imags, axis));
	        }
	        if (this.shouldExecuteOnCPU(tensors)) {
	            return this.cpuBackend.concat(tensors, axis);
	        }
	        if (tensors.length === 1) {
	            return tensors[0];
	        }
	        if (tensors.length > environment_1.env().getNumber('WEBGL_MAX_TEXTURES_IN_SHADER')) {
	            var midIndex = Math.floor(tensors.length / 2);
	            var leftSide = this.concat(tensors.slice(0, midIndex), axis);
	            var rightSide = this.concat(tensors.slice(midIndex), axis);
	            return this.concat([leftSide, rightSide], axis);
	        }
	        if (environment_1.env().getBool('WEBGL_PACK_ARRAY_OPERATIONS') && tensors[0].rank > 1) {
	            var program_1 = new concat_packed_gpu_1.ConcatPackedProgram(tensors.map(function (t) { return t.shape; }), axis);
	            return this.compileAndRun(program_1, tensors);
	        }
	        // Any concat of n-dimensional tensors across any axis can be reduced to
	        // a concatenation of two-dimensional tensors across the axis 1 by first
	        // partitioning the axes of the original tensors into those less than the
	        // axis to be concatenated and the rest. Then reshape the tensors
	        // into a two-dimensional tensor by collapsing these two sets of axes and
	        // concatenate the resulting matrices across the axis 1, finally reshaping
	        // the result to have the proper shape.
	        var outShape = concat_util_1.computeOutShape(tensors.map(function (t) { return t.shape; }), axis);
	        var tensors2D = tensors.map(function (t) { return t.as2D(-1, util_1.sizeFromShape(t.shape.slice(axis))); });
	        var program = new concat_gpu_1.ConcatProgram(tensors2D.map(function (t) { return t.shape; }));
	        var res = this.compileAndRun(program, tensors2D);
	        return res.reshape(outShape);
	    };
	    MathBackendWebGL.prototype.neg = function (x) {
	        if (this.shouldExecuteOnCPU([x])) {
	            return this.cpuBackend.neg(x);
	        }
	        if (environment_1.env().getBool('WEBGL_PACK_UNARY_OPERATIONS')) {
	            return this.packedUnaryOp(x, unary_op.NEG, x.dtype);
	        }
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.NEG);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.batchMatMul = function (a, b, transposeA, transposeB) {
	        var outerShapeA = transposeA ? a.shape[2] : a.shape[1];
	        var outerShapeB = transposeB ? b.shape[1] : b.shape[2];
	        var sharedDim = transposeA ? a.shape[1] : a.shape[2];
	        var _a = a.shape, batch = _a[0];
	        // Since the matrices are vectors, it is faster to call mul().sum()
	        // because sum() is O(sqrt(N)) due to divide-and-conquer.
	        if ((outerShapeA === 1 || outerShapeB === 1) &&
	            sharedDim > exports.MATMUL_SHARED_DIM_THRESHOLD) {
	            if (transposeA) {
	                a = a.transpose([0, 2, 1]);
	            }
	            if (transposeB) {
	                b = b.transpose([0, 2, 1]);
	            }
	            var a3D = outerShapeB === 1 ? a : a.as3D(batch, sharedDim, 1);
	            var axis = outerShapeB === 1 ? 2 : 1;
	            var b3D = outerShapeB === 1 ? b.as3D(batch, 1, sharedDim) : b;
	            return this.multiply(a3D, b3D).sum(axis, true /* keepDims */);
	        }
	        var dtype = types_1.upcastType(a.dtype, b.dtype);
	        var program = new mulmat_packed_gpu_1.MatMulPackedProgram(a.shape, [batch, outerShapeA, outerShapeB], transposeA, transposeB);
	        return this.compileAndRun(program, [a, b], dtype);
	    };
	    MathBackendWebGL.prototype.fusedBatchMatMul = function (_a) {
	        var a = _a.a, b = _a.b, transposeA = _a.transposeA, transposeB = _a.transposeB, bias = _a.bias, activation = _a.activation, preluActivationWeights = _a.preluActivationWeights;
	        var outerShapeA = transposeA ? a.shape[2] : a.shape[1];
	        var outerShapeB = transposeB ? b.shape[1] : b.shape[2];
	        var _b = a.shape, batch = _b[0];
	        var dtype = types_1.upcastType(a.dtype, b.dtype);
	        var hasBias = bias != null;
	        var hasPreluActivationWeights = preluActivationWeights != null;
	        var fusedActivation = activation ? mapActivationToShaderProgram(activation, true) : null;
	        var program = new mulmat_packed_gpu_1.MatMulPackedProgram(a.shape, [batch, outerShapeA, outerShapeB], transposeA, transposeB, hasBias, fusedActivation, hasPreluActivationWeights);
	        var inputs = [a, b];
	        if (bias) {
	            inputs.push(bias);
	        }
	        if (preluActivationWeights) {
	            inputs.push(preluActivationWeights);
	        }
	        return this.compileAndRun(program, inputs, dtype);
	    };
	    MathBackendWebGL.prototype.multiply = function (a, b) {
	        if (a.dtype === 'complex64') {
	            var aData = this.texData.get(a.dataId);
	            var bData = this.texData.get(b.dataId);
	            var realProgram = new binaryop_complex_gpu_1.BinaryOpComplexProgram(binaryop_complex_gpu.COMPLEX_MULTIPLY.REAL, a.shape, b.shape);
	            var imagProgram = new binaryop_complex_gpu_1.BinaryOpComplexProgram(binaryop_complex_gpu.COMPLEX_MULTIPLY.IMAG, a.shape, b.shape);
	            var inputs = [
	                this.makeComplexComponentTensorInfo(a, aData.complexTensors.real),
	                this.makeComplexComponentTensorInfo(a, aData.complexTensors.imag),
	                this.makeComplexComponentTensorInfo(b, bData.complexTensors.real),
	                this.makeComplexComponentTensorInfo(b, bData.complexTensors.imag)
	            ];
	            var real_1 = this.compileAndRun(realProgram, inputs);
	            var imag_1 = this.compileAndRun(imagProgram, inputs);
	            var complex_1 = this.complex(real_1, imag_1);
	            real_1.dispose();
	            imag_1.dispose();
	            return complex_1;
	        }
	        if (this.shouldExecuteOnCPU([a, b])) {
	            return this.cpuBackend.multiply(a, b);
	        }
	        if (environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS')) {
	            return this.packedBinaryOp(a, b, binaryop_gpu.MUL, a.dtype);
	        }
	        var program = new binaryop_gpu_1.BinaryOpProgram(binaryop_gpu.MUL, a.shape, b.shape);
	        return this.compileAndRun(program, [a, b], a.dtype);
	    };
	    MathBackendWebGL.prototype.batchNormalization = function (x, mean, variance, varianceEpsilon, scale, offset) {
	        var inputs = [x, mean, variance];
	        var offsetShape = null;
	        if (offset != null) {
	            offsetShape = offset.shape;
	            inputs.push(offset);
	        }
	        var scaleShape = null;
	        if (scale != null) {
	            scaleShape = scale.shape;
	            inputs.push(scale);
	        }
	        if (environment_1.env().getBool('WEBGL_PACK_NORMALIZATION')) {
	            var batchNormPackedProgram = new batchnorm_packed_gpu_1.BatchNormPackedProgram(x.shape, mean.shape, variance.shape, offsetShape, scaleShape, varianceEpsilon);
	            return this.compileAndRun(batchNormPackedProgram, inputs);
	        }
	        var batchNormProgram = new batchnorm_gpu_1.BatchNormProgram(x.shape, mean.shape, variance.shape, offsetShape, scaleShape, varianceEpsilon);
	        return this.compileAndRun(batchNormProgram, inputs);
	    };
	    MathBackendWebGL.prototype.localResponseNormalization4D = function (x, radius, bias, alpha, beta) {
	        var program = environment_1.env().getBool('WEBGL_PACK_NORMALIZATION') ?
	            new lrn_packed_gpu_1.LRNPackedProgram(x.shape, radius, bias, alpha, beta) :
	            new lrn_gpu_1.LRNProgram(x.shape, radius, bias, alpha, beta);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.LRNGrad = function (dy, inputImage, outputImage, depthRadius, bias, alpha, beta) {
	        var program = new lrn_grad_gpu_1.LRNGradProgram(inputImage.shape, depthRadius, bias, alpha, beta);
	        return this.compileAndRun(program, [inputImage, outputImage, dy]);
	    };
	    MathBackendWebGL.prototype.tile = function (x, reps) {
	        if (x.dtype === 'string') {
	            var data = this.readSync(x.dataId);
	            var decodedData = data.map(function (d) { return util.decodeString(d); });
	            var buf = array_ops_1.buffer(x.shape, x.dtype, decodedData);
	            return tile_impl_1.tile(buf, reps);
	        }
	        var program = new tile_gpu_1.TileProgram(x.shape, reps);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.pad = function (x, paddings, constantValue) {
	        var program = environment_1.env().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ?
	            new pad_packed_gpu_1.PadPackedProgram(x.shape, paddings, constantValue) :
	            new pad_gpu_1.PadProgram(x.shape, paddings, constantValue);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.transpose = function (x, perm) {
	        if (this.shouldExecuteOnCPU([x])) {
	            return this.cpuBackend.transpose(x, perm);
	        }
	        var program = environment_1.env().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ?
	            new transpose_packed_gpu_1.TransposePackedProgram(x.shape, perm) :
	            new transpose_gpu_1.TransposeProgram(x.shape, perm);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.gather = function (x, indices, axis) {
	        if (this.shouldExecuteOnCPU([x, indices])) {
	            return this.cpuBackend.gather(x, indices, axis);
	        }
	        var program = new gather_gpu_1.GatherProgram(x.shape, indices.size, axis);
	        return this.compileAndRun(program, [x, indices]);
	    };
	    MathBackendWebGL.prototype.batchToSpaceND = function (x, blockShape, crops) {
	        util.assert(x.rank <= 4, function () { return 'batchToSpaceND for rank > 4 with a WebGL backend not ' +
	            'implemented yet'; });
	        var prod = blockShape.reduce(function (a, b) { return a * b; });
	        var reshaped = array_ops_util.getReshaped(x.shape, blockShape, prod);
	        var permuted = array_ops_util.getPermuted(reshaped.length, blockShape.length);
	        var reshapedPermuted = array_ops_util.getReshapedPermuted(x.shape, blockShape, prod);
	        var sliceBeginCoords = array_ops_util.getSliceBeginCoords(crops, blockShape.length);
	        var sliceSize = array_ops_util.getSliceSize(reshapedPermuted, crops, blockShape.length);
	        return x.reshape(reshaped)
	            .transpose(permuted)
	            .reshape(reshapedPermuted)
	            .slice(sliceBeginCoords, sliceSize);
	    };
	    MathBackendWebGL.prototype.spaceToBatchND = function (x, blockShape, paddings) {
	        util.assert(x.rank <= 4, function () { return 'spaceToBatchND for rank > 4 with a WebGL backend not ' +
	            'implemented yet'; });
	        var prod = blockShape.reduce(function (a, b) { return a * b; });
	        var completePaddings = [[0, 0]];
	        completePaddings.push.apply(completePaddings, paddings);
	        for (var i = 1 + blockShape.length; i < x.shape.length; ++i) {
	            completePaddings.push([0, 0]);
	        }
	        var paddedX = x.pad(completePaddings);
	        var reshapedPaddedShape = array_ops_util.getReshaped(paddedX.shape, blockShape, prod, false);
	        var permutedReshapedPaddedPermutation = array_ops_util.getPermuted(reshapedPaddedShape.length, blockShape.length, false);
	        var flattenShape = array_ops_util.getReshapedPermuted(paddedX.shape, blockShape, prod, false);
	        return paddedX.reshape(reshapedPaddedShape)
	            .transpose(permutedReshapedPaddedPermutation)
	            .reshape(flattenShape);
	    };
	    MathBackendWebGL.prototype.reduce = function (x, reduceType, dtype) {
	        var batchSize = x.shape[0];
	        var inSize = x.shape[1];
	        var windowSize = reduce_util.computeOptimalWindowSize(inSize);
	        var reduceInfo = { windowSize: windowSize, inSize: inSize, batchSize: batchSize };
	        var program = new reduce_gpu_1.ReduceProgram(reduceInfo, reduceType);
	        var output = this.compileAndRun(program, [x], dtype);
	        // No need to run another GPGPU program.
	        if (output.shape[1] === 1) {
	            return output;
	        }
	        return this.reduce(output, reduceType, dtype);
	    };
	    MathBackendWebGL.prototype.argReduce = function (x, reduceType, bestIndicesA) {
	        if (bestIndicesA === void 0) { bestIndicesA = null; }
	        var batchSize = x.shape[0];
	        var inSize = x.shape[1];
	        if (bestIndicesA != null) {
	            batchSize = bestIndicesA.shape[0];
	            inSize = bestIndicesA.shape[1];
	        }
	        var windowSize = reduce_util.computeOptimalWindowSize(inSize);
	        var reduceInfo = { windowSize: windowSize, inSize: inSize, batchSize: batchSize };
	        var program = new argminmax_gpu_1.ArgMinMaxProgram(reduceInfo, reduceType, bestIndicesA == null);
	        var inputs = [x];
	        if (bestIndicesA != null) {
	            inputs.push(bestIndicesA);
	        }
	        var output = this.compileAndRun(program, inputs, 'int32');
	        // No need to run another GPGPU program.
	        if (output.shape[1] === 1) {
	            return output;
	        }
	        return this.argReduce(x, reduceType, output);
	    };
	    MathBackendWebGL.prototype.argReducePacked = function (x, reduceType, bestIndicesA) {
	        if (bestIndicesA === void 0) { bestIndicesA = null; }
	        var inShape = bestIndicesA != null ? bestIndicesA.shape : x.shape;
	        var inSize = inShape[inShape.length - 1];
	        var windowSize = reduce_util.computeOptimalWindowSize(inSize);
	        var program = new argminmax_packed_gpu_1.ArgMinMaxPackedProgram(inShape, windowSize, reduceType, bestIndicesA == null);
	        var inputs = bestIndicesA == null ? [x] : [x, bestIndicesA];
	        var output = this.compileAndRun(program, inputs, 'int32');
	        if (output.rank === x.rank) {
	            return this.argReducePacked(x, reduceType, output);
	        }
	        return output;
	    };
	    MathBackendWebGL.prototype.sum = function (x, axes) {
	        axis_util.assertAxesAreInnerMostDims('sum', axes, x.rank);
	        var _a = axis_util.computeOutAndReduceShapes(x.shape, axes), outShape = _a[0], reduceShape = _a[1];
	        var inSize = util.sizeFromShape(reduceShape);
	        var a2D = x.as2D(-1, inSize);
	        var outputDType = types_1.sumOutType(x.dtype);
	        return this.reduce(a2D, 'sum', outputDType).reshape(outShape);
	    };
	    MathBackendWebGL.prototype.prod = function (x, axes) {
	        if (this.shouldExecuteOnCPU([x])) {
	            return this.cpuBackend.prod(x, axes);
	        }
	        var _a = axis_util.computeOutAndReduceShapes(x.shape, axes), outShape = _a[0], reduceShape = _a[1];
	        var inSize = util.sizeFromShape(reduceShape);
	        var a2D = x.as2D(-1, inSize);
	        var outputDType = types_1.sumOutType(x.dtype);
	        return this.reduce(a2D, 'prod', outputDType).reshape(outShape);
	    };
	    MathBackendWebGL.prototype.unsortedSegmentSum = function (x, segmentIds, numSegments) {
	        var axis = 0;
	        var permutation = axis_util.getAxesPermutation([axis], x.rank);
	        var permutedX = x;
	        if (permutation != null) {
	            permutedX = x.transpose(permutation);
	            axis = axis_util.getInnerMostAxes(1, x.rank)[0];
	        }
	        var outShape = segment_util.computeOutShape(permutedX.shape, axis, numSegments);
	        var inSize = util.sizeFromShape([permutedX.shape[axis]]);
	        var a2D = permutedX.as2D(-1, inSize);
	        var outputDType = types_1.sumOutType(x.dtype);
	        var result = this.segOpCompute(a2D, 'unsortedSegmentSum', segmentIds, outputDType, numSegments)
	            .reshape(outShape);
	        if (permutation != null) {
	            result = result.transpose(axis_util.getUndoAxesPermutation(permutation));
	        }
	        return result;
	    };
	    MathBackendWebGL.prototype.segOpCompute = function (x, segOpType, segmentIds, dtype, numSegments) {
	        var batchSize = x.shape[0];
	        var inSize = x.shape[1];
	        var windowSize = segment_util.segOpComputeOptimalWindowSize(inSize, numSegments);
	        var segOpInfo = { windowSize: windowSize, inSize: inSize, batchSize: batchSize, numSegments: numSegments };
	        var program = new segment_gpu_1.SegmentOpProgram(segOpInfo, segOpType);
	        var output = this.compileAndRun(program, [x, segmentIds], dtype);
	        // No need to run another GPGPU program.
	        if (output.shape[1] === numSegments) {
	            return output;
	        }
	        segmentIds = tensor_ops_1.range(0, numSegments).tile([inSize / windowSize]);
	        return this.segOpCompute(output, segOpType, segmentIds, dtype, numSegments);
	    };
	    MathBackendWebGL.prototype.argMinMaxReduce = function (x, axis, reduceType) {
	        var axes = [axis];
	        axis_util.assertAxesAreInnerMostDims('arg' + reduceType.charAt(0).toUpperCase() + reduceType.slice(1), axes, x.rank);
	        if (!environment_1.env().getBool('WEBGL_PACK_REDUCE') || x.rank <= 2) {
	            var _a = axis_util.computeOutAndReduceShapes(x.shape, axes), outShape = _a[0], reduceShape = _a[1];
	            var inSize = util.sizeFromShape(reduceShape);
	            var a2D = x.as2D(-1, inSize);
	            return this.argReduce(a2D, reduceType).reshape(outShape);
	        }
	        return this.argReducePacked(x, reduceType);
	    };
	    MathBackendWebGL.prototype.argMin = function (x, axis) {
	        return this.argMinMaxReduce(x, axis, 'min');
	    };
	    MathBackendWebGL.prototype.argMax = function (x, axis) {
	        return this.argMinMaxReduce(x, axis, 'max');
	    };
	    MathBackendWebGL.prototype.cumsum = function (x, axis, exclusive, reverse) {
	        if (axis !== x.rank - 1) {
	            throw new Error("WebGL cumsum shader expects an inner-most axis=" + (x.rank - 1) + " " +
	                ("but got axis=" + axis));
	        }
	        var program = new cumsum_gpu_1.CumSumProgram(x.shape, exclusive, reverse);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.equal = function (a, b) {
	        if (environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS')) {
	            return this.packedBinaryOp(a, b, binaryop_packed_gpu.EQUAL, 'bool');
	        }
	        var program = new binaryop_gpu_1.BinaryOpProgram(binaryop_gpu.EQUAL, a.shape, b.shape);
	        return this.compileAndRun(program, [a, b], 'bool');
	    };
	    MathBackendWebGL.prototype.notEqual = function (a, b) {
	        if (environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS')) {
	            return this.packedBinaryOp(a, b, binaryop_packed_gpu.NOT_EQUAL, 'bool');
	        }
	        var program = new binaryop_gpu_1.BinaryOpProgram(binaryop_gpu.NOT_EQUAL, a.shape, b.shape);
	        return this.compileAndRun(program, [a, b], 'bool');
	    };
	    MathBackendWebGL.prototype.less = function (a, b) {
	        if (this.shouldExecuteOnCPU([a, b])) {
	            return this.cpuBackend.less(a, b);
	        }
	        if (environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS')) {
	            return this.packedBinaryOp(a, b, binaryop_packed_gpu.LESS, 'bool');
	        }
	        var program = new binaryop_gpu_1.BinaryOpProgram(binaryop_gpu.LESS, a.shape, b.shape);
	        return this.compileAndRun(program, [a, b], 'bool');
	    };
	    MathBackendWebGL.prototype.lessEqual = function (a, b) {
	        if (environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS')) {
	            return this.packedBinaryOp(a, b, binaryop_packed_gpu.LESS_EQUAL, 'bool');
	        }
	        var program = new binaryop_gpu_1.BinaryOpProgram(binaryop_gpu.LESS_EQUAL, a.shape, b.shape);
	        return this.compileAndRun(program, [a, b], 'bool');
	    };
	    MathBackendWebGL.prototype.greater = function (a, b) {
	        if (this.shouldExecuteOnCPU([a, b])) {
	            return this.cpuBackend.greater(a, b);
	        }
	        if (environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS')) {
	            return this.packedBinaryOp(a, b, binaryop_packed_gpu.GREATER, 'bool');
	        }
	        var program = new binaryop_gpu_1.BinaryOpProgram(binaryop_gpu.GREATER, a.shape, b.shape);
	        return this.compileAndRun(program, [a, b], 'bool');
	    };
	    MathBackendWebGL.prototype.greaterEqual = function (a, b) {
	        if (environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS')) {
	            return this.packedBinaryOp(a, b, binaryop_packed_gpu.GREATER_EQUAL, 'bool');
	        }
	        var program = new binaryop_gpu_1.BinaryOpProgram(binaryop_gpu.GREATER_EQUAL, a.shape, b.shape);
	        return this.compileAndRun(program, [a, b], 'bool');
	    };
	    MathBackendWebGL.prototype.logicalNot = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.LOGICAL_NOT);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.logicalAnd = function (a, b) {
	        if (environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS')) {
	            return this.packedBinaryOp(a, b, binaryop_packed_gpu.LOGICAL_AND, 'bool');
	        }
	        var program = new binaryop_gpu_1.BinaryOpProgram(binaryop_gpu.LOGICAL_AND, a.shape, b.shape);
	        return this.compileAndRun(program, [a, b], 'bool');
	    };
	    MathBackendWebGL.prototype.logicalOr = function (a, b) {
	        if (environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS')) {
	            return this.packedBinaryOp(a, b, binaryop_packed_gpu.LOGICAL_OR, 'bool');
	        }
	        var program = new binaryop_gpu_1.BinaryOpProgram(binaryop_gpu.LOGICAL_OR, a.shape, b.shape);
	        return this.compileAndRun(program, [a, b], 'bool');
	    };
	    MathBackendWebGL.prototype.select = function (condition, a, b) {
	        var program = new select_gpu_1.SelectProgram(condition.rank, a.shape, a.rank);
	        return this.compileAndRun(program, [condition, a, b], types_1.upcastType(a.dtype, b.dtype));
	    };
	    MathBackendWebGL.prototype.where = function (condition) {
	        log_1.warn('tf.where() in webgl locks the UI thread. ' +
	            'Call tf.whereAsync() instead');
	        var condVals = condition.dataSync();
	        return where_impl_1.whereImpl(condition.shape, condVals);
	    };
	    MathBackendWebGL.prototype.topk = function (x, k, sorted) {
	        var xVals = x.dataSync();
	        return topk_impl_1.topkImpl(xVals, x.shape, x.dtype, k, sorted);
	    };
	    MathBackendWebGL.prototype.min = function (x, axes) {
	        axis_util.assertAxesAreInnerMostDims('min', axes, x.rank);
	        var _a = axis_util.computeOutAndReduceShapes(x.shape, axes), outShape = _a[0], reduceShape = _a[1];
	        var inSize = util.sizeFromShape(reduceShape);
	        var a2D = x.as2D(-1, inSize);
	        return this.reduce(a2D, 'min', a2D.dtype).reshape(outShape);
	    };
	    MathBackendWebGL.prototype.minimum = function (a, b) {
	        if (this.shouldExecuteOnCPU([a, b])) {
	            return this.cpuBackend.minimum(a, b);
	        }
	        var program = environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS') ?
	            new binaryop_packed_gpu_1.BinaryOpPackedProgram(binaryop_packed_gpu.MIN, a.shape, b.shape) :
	            new binaryop_gpu_1.BinaryOpProgram(binaryop_gpu.MIN, a.shape, b.shape);
	        return this.compileAndRun(program, [a, b]);
	    };
	    MathBackendWebGL.prototype.mod = function (a, b) {
	        var program = environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS') ?
	            new binaryop_packed_gpu_1.BinaryOpPackedProgram(binaryop_packed_gpu.MOD, a.shape, b.shape) :
	            new binaryop_gpu_1.BinaryOpProgram(binaryop_gpu.MOD, a.shape, b.shape);
	        return this.compileAndRun(program, [a, b]);
	    };
	    MathBackendWebGL.prototype.max = function (x, axes) {
	        if (this.shouldExecuteOnCPU([x])) {
	            return this.cpuBackend.max(x, axes);
	        }
	        axis_util.assertAxesAreInnerMostDims('max', axes, x.rank);
	        var _a = axis_util.computeOutAndReduceShapes(x.shape, axes), outShape = _a[0], reduceShape = _a[1];
	        var inSize = util.sizeFromShape(reduceShape);
	        var a2D = x.as2D(-1, inSize);
	        return this.reduce(a2D, 'max', a2D.dtype).reshape(outShape);
	    };
	    MathBackendWebGL.prototype.maximum = function (a, b) {
	        if (this.shouldExecuteOnCPU([a, b])) {
	            return this.cpuBackend.maximum(a, b);
	        }
	        var program = environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS') ?
	            new binaryop_packed_gpu_1.BinaryOpPackedProgram(binaryop_packed_gpu.MAX, a.shape, b.shape) :
	            new binaryop_gpu_1.BinaryOpProgram(binaryop_gpu.MAX, a.shape, b.shape);
	        return this.compileAndRun(program, [a, b]);
	    };
	    MathBackendWebGL.prototype.all = function (x, axes) {
	        axis_util.assertAxesAreInnerMostDims('all', axes, x.rank);
	        var _a = axis_util.computeOutAndReduceShapes(x.shape, axes), outShape = _a[0], reduceShape = _a[1];
	        var inSize = util.sizeFromShape(reduceShape);
	        var a2D = x.as2D(-1, inSize);
	        return this.reduce(a2D, 'all', a2D.dtype).reshape(outShape);
	    };
	    MathBackendWebGL.prototype.any = function (x, axes) {
	        axis_util.assertAxesAreInnerMostDims('any', axes, x.rank);
	        var _a = axis_util.computeOutAndReduceShapes(x.shape, axes), outShape = _a[0], reduceShape = _a[1];
	        var inSize = util.sizeFromShape(reduceShape);
	        var a2D = x.as2D(-1, inSize);
	        return this.reduce(a2D, 'any', a2D.dtype).reshape(outShape);
	    };
	    MathBackendWebGL.prototype.realDivide = function (a, b) {
	        var op = binaryop_gpu.DIV;
	        var outputDtype = 'float32';
	        if (environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS')) {
	            var checkOutOfBounds = true;
	            return this.packedBinaryOp(a, b, binaryop_packed_gpu.DIV, outputDtype, checkOutOfBounds);
	        }
	        var program = new binaryop_gpu_1.BinaryOpProgram(op, a.shape, b.shape);
	        return this.compileAndRun(program, [a, b], outputDtype);
	    };
	    MathBackendWebGL.prototype.floorDiv = function (a, b) {
	        var op = binaryop_gpu.INT_DIV;
	        var outputDtype = 'int32';
	        if (environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS')) {
	            return this.packedBinaryOp(a, b, binaryop_packed_gpu.INT_DIV, outputDtype);
	        }
	        var program = new binaryop_gpu_1.BinaryOpProgram(op, a.shape, b.shape);
	        return this.compileAndRun(program, [a, b], outputDtype);
	    };
	    MathBackendWebGL.prototype.add = function (a, b) {
	        if (a.dtype === 'complex64' && b.dtype === 'complex64') {
	            return this.complexSeparableBinaryOp(a, b, binaryop_gpu.ADD);
	        }
	        if (this.shouldExecuteOnCPU([a, b])) {
	            return this.cpuBackend.add(a, b);
	        }
	        var dtype = types_1.upcastType(a.dtype, b.dtype);
	        if (environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS')) {
	            return this.packedBinaryOp(a, b, binaryop_gpu.ADD, dtype);
	        }
	        var program = new binaryop_gpu_1.BinaryOpProgram(binaryop_gpu.ADD, a.shape, b.shape);
	        return this.compileAndRun(program, [a, b], dtype);
	    };
	    MathBackendWebGL.prototype.packedUnaryOp = function (x, op, dtype) {
	        var program = new unaryop_packed_gpu_1.UnaryOpPackedProgram(x.shape, op);
	        return this.compileAndRun(program, [x], dtype);
	    };
	    MathBackendWebGL.prototype.packedBinaryOp = function (a, b, op, dtype, checkOutOfBounds) {
	        if (checkOutOfBounds === void 0) { checkOutOfBounds = false; }
	        var program = new binaryop_packed_gpu_1.BinaryOpPackedProgram(op, a.shape, b.shape, checkOutOfBounds);
	        return this.compileAndRun(program, [a, b], dtype);
	    };
	    /**
	     * Computes a complex binary operation that can be decomposed into a simple
	     * binary operation on both the real and imagary parts.
	     */
	    MathBackendWebGL.prototype.complexSeparableBinaryOp = function (a, b, op) {
	        var _this = this;
	        var aData = this.texData.get(a.dataId);
	        var bData = this.texData.get(b.dataId);
	        var _a = [
	            [aData.complexTensors.real, bData.complexTensors.real],
	            [aData.complexTensors.imag, bData.complexTensors.imag]
	        ].map(function (complexParts) {
	            var aPart = complexParts[0], bPart = complexParts[1];
	            var aHandle = _this.makeComplexComponentTensorInfo(a, aPart);
	            var bHandle = _this.makeComplexComponentTensorInfo(b, bPart);
	            var program = new binaryop_gpu_1.BinaryOpProgram(op, a.shape, b.shape);
	            return _this.compileAndRun(program, [aHandle, bHandle], types_1.upcastType(aPart.dtype, bPart.dtype));
	        }), real = _a[0], imag = _a[1];
	        var complex = this.complex(real, imag);
	        real.dispose();
	        imag.dispose();
	        return complex;
	    };
	    // Returns a TensorInfo with the complex shape and the dataId of the
	    // underlying part. We need to do this because a reshaped complex tensor is
	    // not reflected in its parts.
	    MathBackendWebGL.prototype.makeComplexComponentTensorInfo = function (complexTensor, complexPart) {
	        return {
	            dataId: complexPart.dataId,
	            dtype: complexPart.dtype,
	            shape: complexTensor.shape
	        };
	    };
	    MathBackendWebGL.prototype.addN = function (tensors) {
	        if (tensors.length === 1) {
	            return tensors[0];
	        }
	        // Limit the number of uploaded textures for optimization.
	        if (tensors.length > environment_1.env().get('WEBGL_MAX_TEXTURES_IN_SHADER')) {
	            var midIndex = Math.floor(tensors.length / 2);
	            var leftSide = this.addN(tensors.slice(0, midIndex));
	            var rightSide = this.addN(tensors.slice(midIndex));
	            return this.addN([leftSide, rightSide]);
	        }
	        var dtype = tensors.map(function (t) { return t.dtype; }).reduce(function (d1, d2) { return types_1.upcastType(d1, d2); });
	        var shapes = tensors.map(function (t) { return t.shape; });
	        // We can make sure shapes are identical in op level.
	        var usePackedOp = environment_1.env().getBool('WEBGL_PACK');
	        var program = usePackedOp ?
	            new addn_packed_gpu_1.AddNPackedProgram(tensors[0].shape, shapes) :
	            new addn_gpu_1.AddNProgram(tensors[0].shape, shapes);
	        return this.compileAndRun(program, tensors, dtype);
	    };
	    MathBackendWebGL.prototype.subtract = function (a, b) {
	        if (a.dtype === 'complex64' && b.dtype === 'complex64') {
	            return this.complexSeparableBinaryOp(a, b, binaryop_gpu.SUB);
	        }
	        if (this.shouldExecuteOnCPU([a, b])) {
	            return this.cpuBackend.subtract(a, b);
	        }
	        var dtype = types_1.upcastType(a.dtype, b.dtype);
	        if (environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS')) {
	            return this.packedBinaryOp(a, b, binaryop_gpu.SUB, a.dtype);
	        }
	        var program = new binaryop_gpu_1.BinaryOpProgram(binaryop_gpu.SUB, a.shape, b.shape);
	        return this.compileAndRun(program, [a, b], dtype);
	    };
	    MathBackendWebGL.prototype.pow = function (a, b) {
	        var usePackedOp = environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS');
	        var program = usePackedOp ?
	            new binaryop_packed_gpu_1.BinaryOpPackedProgram(binaryop_packed_gpu.POW, a.shape, b.shape) :
	            new binaryop_gpu_1.BinaryOpProgram(binaryop_gpu.POW, a.shape, b.shape);
	        var dtype = types_1.upcastType(a.dtype, b.dtype);
	        return this.compileAndRun(program, [a, b], dtype);
	    };
	    MathBackendWebGL.prototype.ceil = function (x) {
	        if (this.shouldExecuteOnCPU([x])) {
	            return this.cpuBackend.ceil(x);
	        }
	        if (environment_1.env().getBool('WEBGL_PACK_UNARY_OPERATIONS')) {
	            return this.packedUnaryOp(x, unary_op.CEIL, x.dtype);
	        }
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.CEIL);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.floor = function (x) {
	        if (this.shouldExecuteOnCPU([x])) {
	            return this.cpuBackend.floor(x);
	        }
	        if (environment_1.env().getBool('WEBGL_PACK_UNARY_OPERATIONS')) {
	            return this.packedUnaryOp(x, unary_op.FLOOR, x.dtype);
	        }
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.FLOOR);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.sign = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.SIGN);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.isNaN = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.IS_NAN);
	        return this.compileAndRun(program, [x], 'bool');
	    };
	    MathBackendWebGL.prototype.isInf = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.IS_INF);
	        return this.compileAndRun(program, [x], 'bool');
	    };
	    MathBackendWebGL.prototype.isFinite = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.IS_FINITE);
	        return this.compileAndRun(program, [x], 'bool');
	    };
	    MathBackendWebGL.prototype.round = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.ROUND);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.exp = function (x) {
	        if (this.shouldExecuteOnCPU([x])) {
	            return this.cpuBackend.exp(x);
	        }
	        if (environment_1.env().getBool('WEBGL_PACK_UNARY_OPERATIONS')) {
	            return this.packedUnaryOp(x, unary_op.EXP, x.dtype);
	        }
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.EXP);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.expm1 = function (x) {
	        if (this.shouldExecuteOnCPU([x])) {
	            return this.cpuBackend.expm1(x);
	        }
	        if (environment_1.env().getBool('WEBGL_PACK_UNARY_OPERATIONS')) {
	            return this.packedUnaryOp(x, unary_op.EXPM1, x.dtype);
	        }
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.EXPM1);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.softmax = function (logits, dim) {
	        var axes = util.parseAxisParam([dim], logits.shape);
	        var maxLogit = this.max(logits, axes);
	        var expandedShape = axis_util.expandShapeToKeepDim(maxLogit.shape, axes);
	        var a = this.subtract(logits, maxLogit.reshape(expandedShape));
	        var b = this.exp(a);
	        var sumExp = this.sum(b, axes).reshape(expandedShape);
	        return this.realDivide(b, sumExp);
	    };
	    MathBackendWebGL.prototype.log = function (x) {
	        if (this.shouldExecuteOnCPU([x])) {
	            return this.cpuBackend.log(x);
	        }
	        if (environment_1.env().getBool('WEBGL_PACK_UNARY_OPERATIONS')) {
	            return this.packedUnaryOp(x, unary_packed_op.LOG, x.dtype);
	        }
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.LOG);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.log1p = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.LOG1P);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.sqrt = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.SQRT);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.rsqrt = function (x) {
	        if (this.shouldExecuteOnCPU([x])) {
	            return this.cpuBackend.rsqrt(x);
	        }
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.RSQRT);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.reciprocal = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.RECIPROCAL);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.relu = function (x) {
	        var program;
	        if (environment_1.env().getBool('WEBGL_PACK')) {
	            program = new unaryop_packed_gpu_1.UnaryOpPackedProgram(x.shape, unary_packed_op.RELU);
	        }
	        else {
	            program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.RELU);
	        }
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.relu6 = function (x) {
	        var program;
	        if (environment_1.env().getBool('WEBGL_PACK')) {
	            program = new unaryop_packed_gpu_1.UnaryOpPackedProgram(x.shape, unary_packed_op.RELU6);
	        }
	        else {
	            program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.RELU6);
	        }
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.prelu = function (x, alpha) {
	        var program = environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS') ?
	            new binaryop_packed_gpu_1.BinaryOpPackedProgram(binaryop_packed_gpu.PRELU, x.shape, alpha.shape) :
	            new binaryop_gpu_1.BinaryOpProgram(binaryop_gpu.PRELU, x.shape, alpha.shape);
	        return this.compileAndRun(program, [x, alpha]);
	    };
	    MathBackendWebGL.prototype.elu = function (x) {
	        if (environment_1.env().getBool('WEBGL_PACK_UNARY_OPERATIONS')) {
	            return this.packedUnaryOp(x, unary_packed_op.ELU, x.dtype);
	        }
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.ELU);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.eluDer = function (dy, y) {
	        var program = environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS') ?
	            new binaryop_packed_gpu_1.BinaryOpPackedProgram(binaryop_packed_gpu.ELU_DER, dy.shape, y.shape) :
	            new binaryop_gpu_1.BinaryOpProgram(binaryop_gpu.ELU_DER, dy.shape, y.shape);
	        return this.compileAndRun(program, [dy, y]);
	    };
	    MathBackendWebGL.prototype.selu = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.SELU);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.int = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.TO_INT);
	        return this.compileAndRun(program, [x], 'int32');
	    };
	    MathBackendWebGL.prototype.clip = function (x, min, max) {
	        var program;
	        if (environment_1.env().getBool('WEBGL_PACK_CLIP')) {
	            program = new clip_packed_gpu_1.ClipPackedProgram(x.shape);
	        }
	        else {
	            program = new clip_gpu_1.ClipProgram(x.shape);
	        }
	        var customSetup = program.getCustomSetupFunc(min, max);
	        return this.compileAndRun(program, [x], null, customSetup);
	    };
	    MathBackendWebGL.prototype.abs = function (x) {
	        if (this.shouldExecuteOnCPU([x])) {
	            return this.cpuBackend.abs(x);
	        }
	        if (environment_1.env().getBool('WEBGL_PACK_UNARY_OPERATIONS')) {
	            return this.packedUnaryOp(x, unary_op.ABS, x.dtype);
	        }
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.ABS);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.complexAbs = function (x) {
	        var xData = this.texData.get(x.dataId);
	        var program = new complex_abs_gpu_1.ComplexAbsProgram(x.shape);
	        var inputs = [
	            this.makeComplexComponentTensorInfo(x, xData.complexTensors.real),
	            this.makeComplexComponentTensorInfo(x, xData.complexTensors.imag),
	        ];
	        return this.compileAndRun(program, inputs);
	    };
	    MathBackendWebGL.prototype.sigmoid = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.SIGMOID);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.softplus = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.SOFTPLUS);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.sin = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.SIN);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.cos = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.COS);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.tan = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.TAN);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.asin = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.ASIN);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.acos = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.ACOS);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.atan = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.ATAN);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.atan2 = function (a, b) {
	        var program = environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS') ?
	            new binaryop_packed_gpu_1.BinaryOpPackedProgram(binaryop_packed_gpu.ATAN2, a.shape, b.shape) :
	            new binaryop_gpu_1.BinaryOpProgram(binaryop_gpu.ATAN2, a.shape, b.shape);
	        return this.compileAndRun(program, [a, b]);
	    };
	    MathBackendWebGL.prototype.sinh = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.SINH);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.cosh = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.COSH);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.tanh = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.TANH);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.asinh = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.ASINH);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.acosh = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.ACOSH);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.atanh = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.ATANH);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.erf = function (x) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.ERF);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.step = function (x, alpha) {
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unary_op.STEP(alpha));
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.conv2dByMatMul = function (x, filter, convInfo, bias, activation, preluActivationWeights) {
	        // Reshapes conv2D input to 2D tensors, uses matMul and then reshape the
	        // result from 2D to 4D.
	        var xShape = x.shape;
	        var xTexData = this.texData.get(x.dataId);
	        var sharedMatMulDim = convInfo.inChannels;
	        var outerShapeX = xShape[0] * xShape[1] * xShape[2];
	        var outerShapeFilter = convInfo.outChannels;
	        var isChannelsLast = convInfo.dataFormat === 'channelsLast';
	        var transposeA = false;
	        var transposeB = false;
	        // TODO: Once reduction ops are packed, batchMatMul will always be packed
	        // and we can remove this condition.
	        var batchMatMulWillBeUnpacked = (outerShapeX === 1 || outerShapeFilter === 1) &&
	            sharedMatMulDim > exports.MATMUL_SHARED_DIM_THRESHOLD;
	        var reshapeWillBeExpensive = xShape[2] % 2 !== 0 && !!xTexData.isPacked;
	        if (batchMatMulWillBeUnpacked || !environment_1.env().getBool('WEBGL_LAZILY_UNPACK') ||
	            !environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS') ||
	            !reshapeWillBeExpensive) {
	            var targetShape_1 = isChannelsLast ? xShape[0] * xShape[1] * xShape[2] :
	                xShape[0] * xShape[2] * xShape[3];
	            var xReshaped_1 = this.reshape(x, [1, targetShape_1, convInfo.inChannels]);
	            var filterReshaped_1 = this.reshape(filter, [1, convInfo.inChannels, convInfo.outChannels]);
	            return this.reshape(this.fusedBatchMatMul({
	                a: xReshaped_1,
	                b: filterReshaped_1,
	                transposeA: transposeA,
	                transposeB: transposeB,
	                bias: bias,
	                activation: activation,
	                preluActivationWeights: preluActivationWeights
	            }), convInfo.outShape);
	        }
	        // Following optimization is specific to packed |x| with odd row count
	        // (For example, in channelLast mode, 'row count' refers to x.shape[2]):
	        // we avoid expensive packed 2x2 reshape by padding row count to next,
	        // even number. When x.shape[2] is odd, the result of packed batchMatMul is
	        // the same (has the same texture layout and and values in the texture) as
	        // it is for even x.shape[2] + 1. We make the odd-rows tensor to look like
	        // even-rows tensor before the operation and, after the batchMatMul,
	        // fix the even-rows result to have odd number of rows.
	        var targetShape = isChannelsLast ?
	            xShape[0] * xShape[1] * (xShape[2] + 1) :
	            xShape[0] * xShape[2] * (xShape[3] + 1);
	        var xReshaped = {
	            dataId: x.dataId,
	            shape: [1, targetShape, convInfo.inChannels],
	            dtype: x.dtype
	        };
	        // xTexData.shape gets referenced from GPGPUBinary.inShapeInfos.
	        // Decrementing row count, after batchMatMul->...->compileProgram leads to
	        // invalid row count within the reference in GPGPUBinary.inShapeInfos.
	        // Alternative fix would be to provide a copy to GPGPUBinary.inShapeInfos
	        // in compileProgram method, but that would affect compilation of all
	        // programs - instead, provide a copy here, with even row count, before
	        // calling batchMatMul->...->compileProgram and after that, the original
	        // xTexData.shape is restored.
	        var originalXTexDataShape = xTexData.shape;
	        xTexData.shape = xTexData.shape.slice();
	        xTexData.shape[xTexData.shape.length - 2]++;
	        util.assert(webgl_util.isReshapeFree(xTexData.shape, xReshaped.shape), function () { return "packed reshape " + xTexData.shape + " to " + xReshaped.shape + " isn't free"; });
	        var filterReshaped = this.reshape(filter, [1, convInfo.inChannels, convInfo.outChannels]);
	        var pointwiseConv = this.fusedBatchMatMul({
	            a: xReshaped,
	            b: filterReshaped,
	            transposeA: transposeA,
	            transposeB: transposeB,
	            bias: bias,
	            activation: activation,
	            preluActivationWeights: preluActivationWeights
	        });
	        var pointwiseConvTexData = this.texData.get(pointwiseConv.dataId);
	        util.assert(pointwiseConvTexData.isPacked, function () { return 'batchMatMul result is expected to be packed'; });
	        // Restore the input shape to original.
	        xTexData.shape = originalXTexDataShape;
	        // Set the output shape - there is no need for expensive reshape as data
	        // layout is already correct.
	        pointwiseConvTexData.shape = convInfo.outShape;
	        return engine_1.ENGINE.makeTensorFromDataId(pointwiseConv.dataId, convInfo.outShape, pointwiseConv.dtype);
	    };
	    MathBackendWebGL.prototype.conv2dWithIm2Row = function (x, filter, convInfo, bias, activation, preluActivationWeights) {
	        // Rearranges conv2d input so each block to be convolved over forms the
	        // column of a new matrix with shape [filterWidth * filterHeight *
	        // inChannels, outHeight * outWidth]. The filter is also rearranged so each
	        // output channel forms a row of a new matrix with shape [outChannels,
	        // filterWidth * filterHeight * inChannels]. The convolution is then
	        // computed by multiplying these matrices and reshaping the result.
	        var filterWidth = convInfo.filterWidth, filterHeight = convInfo.filterHeight, inChannels = convInfo.inChannels, outWidth = convInfo.outWidth, outHeight = convInfo.outHeight, dataFormat = convInfo.dataFormat;
	        var isChannelsLast = dataFormat === 'channelsLast';
	        var sharedDim = filterWidth * filterHeight * inChannels;
	        var numCols = outHeight * outWidth;
	        var x2ColShape = [sharedDim, numCols];
	        var transposeA = true;
	        var transposeB = false;
	        var xSqueezed = x.squeeze([0]);
	        var w2Row = filter.reshape([1, sharedDim, -1]);
	        var im2ColProgram = new im2col_packed_gpu_1.Im2ColPackedProgram(x2ColShape, xSqueezed.shape, convInfo);
	        var im2Col = this.compileAndRun(im2ColProgram, [xSqueezed]).reshape([
	            1, x2ColShape[0], x2ColShape[1]
	        ]);
	        var hasBias = bias != null;
	        var hasPreluActivationWeights = preluActivationWeights != null;
	        var fusedActivation = activation ? mapActivationToShaderProgram(activation, true) : null;
	        var matmulProgram = new mulmat_packed_gpu_1.MatMulPackedProgram(im2Col.shape, [1, numCols, convInfo.outChannels], transposeA, transposeB, hasBias, fusedActivation, hasPreluActivationWeights);
	        var inputs = [im2Col, w2Row];
	        if (bias) {
	            inputs.push(bias);
	        }
	        if (hasPreluActivationWeights) {
	            inputs.push(preluActivationWeights);
	        }
	        var product = this.compileAndRun(matmulProgram, inputs);
	        if (isChannelsLast) {
	            return product.reshape([1, outHeight, outWidth, convInfo.outChannels]);
	        }
	        else {
	            return product.reshape([1, convInfo.outChannels, outHeight, outWidth]);
	        }
	    };
	    MathBackendWebGL.prototype.fusedConv2d = function (_a) {
	        var input = _a.input, filter = _a.filter, convInfo = _a.convInfo, bias = _a.bias, activation = _a.activation, preluActivationWeights = _a.preluActivationWeights;
	        if (convInfo.filterHeight === 1 && convInfo.filterWidth === 1 &&
	            convInfo.dilationHeight === 1 && convInfo.dilationWidth === 1 &&
	            convInfo.strideHeight === 1 && convInfo.strideWidth === 1 &&
	            (convInfo.padInfo.type === 'SAME' ||
	                convInfo.padInfo.type === 'VALID')) {
	            return this.conv2dByMatMul(input, filter, convInfo, bias, activation, preluActivationWeights);
	        }
	        if (environment_1.env().getBool('WEBGL_CONV_IM2COL') && input.shape[0] === 1) {
	            return this.conv2dWithIm2Row(input, filter, convInfo, bias, activation, preluActivationWeights);
	        }
	        var hasBias = bias != null;
	        var hasPreluActivationWeights = preluActivationWeights != null;
	        var fusedActivation = activation ? mapActivationToShaderProgram(activation, false) : null;
	        var program = new conv_gpu_1.Conv2DProgram(convInfo, hasBias, fusedActivation, hasPreluActivationWeights);
	        var inputs = [input, filter];
	        if (bias) {
	            inputs.push(bias);
	        }
	        if (preluActivationWeights) {
	            inputs.push(preluActivationWeights);
	        }
	        return this.compileAndRun(program, inputs);
	    };
	    MathBackendWebGL.prototype.conv2d = function (x, filter, convInfo) {
	        if (convInfo.filterHeight === 1 && convInfo.filterWidth === 1 &&
	            convInfo.dilationHeight === 1 && convInfo.dilationWidth === 1 &&
	            convInfo.strideHeight === 1 && convInfo.strideWidth === 1 &&
	            (convInfo.padInfo.type === 'SAME' ||
	                convInfo.padInfo.type === 'VALID')) {
	            return this.conv2dByMatMul(x, filter, convInfo);
	        }
	        if (environment_1.env().getBool('WEBGL_CONV_IM2COL') && x.shape[0] === 1) {
	            return this.conv2dWithIm2Row(x, filter, convInfo);
	        }
	        var program = new conv_gpu_1.Conv2DProgram(convInfo);
	        return this.compileAndRun(program, [x, filter]);
	    };
	    MathBackendWebGL.prototype.conv2dDerInput = function (dy, filter, convInfo) {
	        var program = new conv_backprop_gpu_1.Conv2DDerInputProgram(convInfo);
	        return this.compileAndRun(program, [dy, filter]);
	    };
	    MathBackendWebGL.prototype.conv2dDerFilter = function (x, dy, convInfo) {
	        var program = new conv_backprop_gpu_1.Conv2DDerFilterProgram(convInfo);
	        return this.compileAndRun(program, [x, dy]);
	    };
	    MathBackendWebGL.prototype.fusedDepthwiseConv2D = function (_a) {
	        var input = _a.input, filter = _a.filter, convInfo = _a.convInfo, bias = _a.bias, activation = _a.activation, preluActivationWeights = _a.preluActivationWeights;
	        var shouldPackDepthwiseConv = environment_1.env().getBool('WEBGL_PACK_DEPTHWISECONV') &&
	            convInfo.strideWidth <= 2 &&
	            convInfo.outChannels / convInfo.inChannels === 1;
	        var fusedActivation = activation ?
	            mapActivationToShaderProgram(activation, shouldPackDepthwiseConv) :
	            null;
	        var inputs = [input, filter];
	        var hasBias = bias != null;
	        var hasPreluActivationWeights = preluActivationWeights != null;
	        if (hasBias) {
	            inputs.push(bias);
	        }
	        if (hasPreluActivationWeights) {
	            inputs.push(preluActivationWeights);
	        }
	        var program;
	        if (shouldPackDepthwiseConv) {
	            program = new conv_packed_gpu_depthwise_1.DepthwiseConvPacked2DProgram(convInfo, hasBias, fusedActivation, hasPreluActivationWeights);
	            return this.compileAndRun(program, inputs);
	        }
	        program = new conv_gpu_depthwise_1.DepthwiseConv2DProgram(convInfo, hasBias, fusedActivation, hasPreluActivationWeights);
	        return this.compileAndRun(program, inputs);
	    };
	    MathBackendWebGL.prototype.depthwiseConv2D = function (x, filter, convInfo) {
	        var program;
	        if (environment_1.env().getBool('WEBGL_PACK_DEPTHWISECONV') &&
	            convInfo.strideWidth <= 2 &&
	            convInfo.outChannels / convInfo.inChannels === 1) {
	            program = new conv_packed_gpu_depthwise_1.DepthwiseConvPacked2DProgram(convInfo);
	            return this.compileAndRun(program, [x, filter]);
	        }
	        program = new conv_gpu_depthwise_1.DepthwiseConv2DProgram(convInfo);
	        return this.compileAndRun(program, [x, filter]);
	    };
	    MathBackendWebGL.prototype.depthwiseConv2DDerInput = function (dy, filter, convInfo) {
	        var program = new conv_backprop_gpu_depthwise_1.DepthwiseConv2DDerInputProgram(convInfo);
	        return this.compileAndRun(program, [dy, filter]);
	    };
	    MathBackendWebGL.prototype.depthwiseConv2DDerFilter = function (x, dy, convInfo) {
	        var program = new conv_backprop_gpu_depthwise_1.DepthwiseConv2DDerFilterProgram(convInfo);
	        return this.compileAndRun(program, [x, dy]);
	    };
	    MathBackendWebGL.prototype.conv3d = function (x, filter, convInfo) {
	        var program = new conv_gpu_1.Conv3DProgram(convInfo);
	        return this.compileAndRun(program, [x, filter]);
	    };
	    MathBackendWebGL.prototype.conv3dDerInput = function (dy, filter, convInfo) {
	        var program = new conv_backprop_gpu_1.Conv3DDerInputProgram(convInfo);
	        return this.compileAndRun(program, [dy, filter]);
	    };
	    MathBackendWebGL.prototype.conv3dDerFilter = function (x, dy, convInfo) {
	        var program = new conv_backprop_gpu_1.Conv3DDerFilterProgram(convInfo);
	        return this.compileAndRun(program, [x, dy]);
	    };
	    MathBackendWebGL.prototype.maxPool = function (x, convInfo) {
	        var program = new pool_gpu_1.Pool2DProgram(convInfo, 'max', false);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.avgPool = function (x, convInfo) {
	        var program = new pool_gpu_1.Pool2DProgram(convInfo, 'avg', false);
	        return this.compileAndRun(program, [x], 'float32');
	    };
	    MathBackendWebGL.prototype.maxPoolBackprop = function (dy, x, y, convInfo) {
	        var getPositions = true;
	        var maxPoolPositionsProgram = new pool_gpu_1.Pool2DProgram(convInfo, 'max', getPositions);
	        var maxPoolPositions = this.compileAndRun(maxPoolPositionsProgram, [x]);
	        var maxPoolBackPropProgram = new max_pool_backprop_gpu_1.MaxPool2DBackpropProgram(convInfo);
	        var result = this.compileAndRun(maxPoolBackPropProgram, [dy, maxPoolPositions], x.dtype);
	        maxPoolPositions.dispose();
	        return result;
	    };
	    MathBackendWebGL.prototype.avgPoolBackprop = function (dy, x, convInfo) {
	        var avgPoolBackpropProgram = new avg_pool_backprop_gpu_1.AvgPool2DBackpropProgram(convInfo);
	        return this.compileAndRun(avgPoolBackpropProgram, [dy], x.dtype);
	    };
	    MathBackendWebGL.prototype.cast = function (x, dtype) {
	        return backend_util.castTensor(x, dtype, this);
	    };
	    MathBackendWebGL.prototype.unstack = function (x, axis) {
	        var num = x.shape[axis];
	        var outShape = new Array(x.rank - 1);
	        var outIndex = 0;
	        for (var i = 0; i < x.rank; i++) {
	            if (i !== axis) {
	                outShape[outIndex++] = x.shape[i];
	            }
	        }
	        var begin = new Array(x.rank).fill(0);
	        var size = x.shape.slice();
	        size[axis] = 1;
	        var res = new Array(num);
	        for (var i = 0; i < res.length; i++) {
	            begin[axis] = i;
	            res[i] = this.slice(x, begin, size).reshape(outShape);
	        }
	        return res;
	    };
	    MathBackendWebGL.prototype.avgPool3d = function (x, convInfo) {
	        var program = new pool_gpu_1.Pool3DProgram(convInfo, 'avg', false);
	        return this.compileAndRun(program, [x], 'float32');
	    };
	    MathBackendWebGL.prototype.avgPool3dBackprop = function (dy, x, convInfo) {
	        var avgPool3dBackpropProgram = new avg_pool_backprop_gpu_1.AvgPool3DBackpropProgram(convInfo);
	        return this.compileAndRun(avgPool3dBackpropProgram, [dy], x.dtype);
	    };
	    MathBackendWebGL.prototype.maxPool3d = function (x, convInfo) {
	        var program = new pool_gpu_1.Pool3DProgram(convInfo, 'max', false);
	        return this.compileAndRun(program, [x], 'float32');
	    };
	    MathBackendWebGL.prototype.maxPool3dBackprop = function (dy, x, y, convInfo) {
	        var getPositions = true;
	        var maxPool3dPositionsProgram = new pool_gpu_1.Pool3DProgram(convInfo, 'max', getPositions);
	        var maxPool3dPositions = this.compileAndRun(maxPool3dPositionsProgram, [x]);
	        var maxPool3dBackPropProgram = new max_pool_backprop_gpu_1.MaxPool3DBackpropProgram(convInfo);
	        var result = this.compileAndRun(maxPool3dBackPropProgram, [dy, maxPool3dPositions], x.dtype);
	        maxPool3dPositions.dispose();
	        return result;
	    };
	    MathBackendWebGL.prototype.reshape = function (x, shape) {
	        var texData = this.texData.get(x.dataId);
	        if (texData.isPacked && !webgl_util.isReshapeFree(x.shape, shape) &&
	            !(texData.texture !== null &&
	                webgl_util.isReshapeFree(texData.shape, shape))) {
	            var info = this.packedReshape(x, shape);
	            return engine_1.ENGINE.makeTensorFromDataId(info.dataId, info.shape, info.dtype);
	        }
	        return backend_util.reshapeTensor(x, shape);
	    };
	    MathBackendWebGL.prototype.resizeBilinear = function (x, newHeight, newWidth, alignCorners) {
	        var program = environment_1.env().getBool('WEBGL_PACK_IMAGE_OPERATIONS') ?
	            new resize_bilinear_packed_gpu_1.ResizeBilinearPackedProgram(x.shape, newHeight, newWidth, alignCorners) :
	            new resize_bilinear_gpu_1.ResizeBilinearProgram(x.shape, newHeight, newWidth, alignCorners);
	        return this.compileAndRun(program, [x], 'float32');
	    };
	    MathBackendWebGL.prototype.resizeBilinearBackprop = function (dy, x, alignCorners) {
	        var program = new resize_bilinear_backprop_gpu_1.ResizeBilinearBackpropProgram(dy, x, alignCorners);
	        return this.compileAndRun(program, [dy]);
	    };
	    MathBackendWebGL.prototype.resizeNearestNeighbor = function (x, newHeight, newWidth, alignCorners) {
	        var program = new resize_nearest_neighbor_gpu_1.ResizeNearestNeighborProgram(x.shape, newHeight, newWidth, alignCorners);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.resizeNearestNeighborBackprop = function (dy, x, alignCorners) {
	        var program = new resize_nearest_neighbor_backprop_gpu_1.ResizeNearestNeigborBackpropProgram(dy, x, alignCorners);
	        return this.compileAndRun(program, [dy]);
	    };
	    MathBackendWebGL.prototype.multinomial = function (logits, normalized, numSamples, seed) {
	        var probs = normalized ? logits : softmax_1.softmax(logits);
	        var batchSize = probs.shape[0];
	        var numOutcomes = probs.shape[1];
	        var program = new multinomial_gpu_1.MultinomialProgram(batchSize, numOutcomes, numSamples);
	        var customSetup = program.getCustomSetupFunc(seed);
	        return this.compileAndRun(program, [probs], 'int32', customSetup);
	    };
	    MathBackendWebGL.prototype.oneHot = function (indices, depth, onValue, offValue) {
	        var program = new onehot_gpu_1.OneHotProgram(indices.size, depth, onValue, offValue);
	        return this.compileAndRun(program, [indices]);
	    };
	    MathBackendWebGL.prototype.diag = function (x) {
	        var program = new diag_gpu_1.DiagProgram(x.size);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.nonMaxSuppression = function (boxes, scores, maxOutputSize, iouThreshold, scoreThreshold) {
	        log_1.warn('tf.nonMaxSuppression() in webgl locks the UI thread. ' +
	            'Call tf.nonMaxSuppressionAsync() instead');
	        var boxesVals = boxes.dataSync();
	        var scoresVals = scores.dataSync();
	        return non_max_suppression_impl_1.nonMaxSuppressionV3(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold);
	    };
	    MathBackendWebGL.prototype.cropAndResize = function (image, boxes, boxIndex, cropSize, method, extrapolationValue) {
	        var program = new crop_and_resize_gpu_1.CropAndResizeProgram(image.shape, boxes.shape, cropSize, method, extrapolationValue);
	        return this.compileAndRun(program, [image, boxes, boxIndex], 'float32');
	    };
	    MathBackendWebGL.prototype.depthToSpace = function (x, blockSize, dataFormat) {
	        util.assert(blockSize > 1, function () {
	            return "blockSize should be > 1 for depthToSpace, but was: " + blockSize;
	        });
	        var batchSize = x.shape[0];
	        var inputHeight = (dataFormat === 'NHWC') ? x.shape[1] : x.shape[2];
	        var inputWidth = (dataFormat === 'NHWC') ? x.shape[2] : x.shape[3];
	        var inputDepth = (dataFormat === 'NHWC') ? x.shape[3] : x.shape[1];
	        var outputHeight = inputHeight * blockSize;
	        var outputWidth = inputWidth * blockSize;
	        var outputDepth = inputDepth / (blockSize * blockSize);
	        var outputShape = (dataFormat === 'NHWC') ?
	            [batchSize, outputHeight, outputWidth, outputDepth] :
	            [batchSize, outputDepth, outputHeight, outputWidth];
	        var program = new depth_to_space_gpu_1.DepthToSpaceProgram(outputShape, blockSize, dataFormat);
	        return this.compileAndRun(program, [x]);
	    };
	    MathBackendWebGL.prototype.split = function (x, sizeSplits, axis) {
	        return split_shared_1.split(x, sizeSplits, axis);
	    };
	    MathBackendWebGL.prototype.scatterND = function (indices, updates, shape) {
	        var _a = scatter_nd_util.calculateShapes(updates, indices, shape), sliceRank = _a.sliceRank, numUpdates = _a.numUpdates, sliceSize = _a.sliceSize, strides = _a.strides, outputSize = _a.outputSize;
	        var flattenShape = [outputSize / sliceSize, sliceSize];
	        var flattenIndices = indices.reshape([numUpdates, sliceRank]);
	        var flattenX = updates.reshape([numUpdates, sliceSize]);
	        if (outputSize === 0) {
	            return backend_util.reshapeTensor(tensor_ops_1.tensor([]), shape);
	        }
	        var defaultValue = tensor_ops_1.scalar(0);
	        var program = new scatter_gpu_1.ScatterProgram(numUpdates, sliceRank, flattenIndices.rank, flattenX.rank, strides, flattenShape);
	        var res = this.compileAndRun(program, [flattenX, flattenIndices, defaultValue]);
	        return res.reshape(shape);
	    };
	    MathBackendWebGL.prototype.sparseToDense = function (sparseIndices, sparseValues, outputShape, defaultValue) {
	        var _a = scatter_nd_util.calculateShapes(sparseValues, sparseIndices, outputShape), sliceRank = _a.sliceRank, numUpdates = _a.numUpdates, strides = _a.strides, outputSize = _a.outputSize;
	        var sumDupeIndices = false;
	        var program = new scatter_gpu_1.ScatterProgram(numUpdates, sliceRank, sparseIndices.rank, sparseValues.rank, strides, [outputSize, 1], sumDupeIndices);
	        var res = this.compileAndRun(program, [sparseValues, sparseIndices, defaultValue]);
	        return res.reshape(outputShape);
	    };
	    MathBackendWebGL.prototype.fft = function (x) {
	        var inverse = false;
	        return this.fftImpl(x, inverse);
	    };
	    MathBackendWebGL.prototype.ifft = function (x) {
	        var inverse = true;
	        return this.fftImpl(x, inverse);
	    };
	    MathBackendWebGL.prototype.fftImpl = function (x, inverse) {
	        var xData = this.texData.get(x.dataId);
	        var realProgram = new fft_gpu_1.FFTProgram(fft_gpu.COMPLEX_FFT.REAL, x.shape, inverse);
	        var imagProgram = new fft_gpu_1.FFTProgram(fft_gpu.COMPLEX_FFT.IMAG, x.shape, inverse);
	        var inputs = [
	            this.makeComplexComponentTensorInfo(x, xData.complexTensors.real),
	            this.makeComplexComponentTensorInfo(x, xData.complexTensors.imag),
	        ];
	        var real = this.compileAndRun(realProgram, inputs);
	        var imag = this.compileAndRun(imagProgram, inputs);
	        var complex = this.complex(real, imag).as2D(x.shape[0], x.shape[1]);
	        real.dispose();
	        imag.dispose();
	        return complex;
	    };
	    MathBackendWebGL.prototype.gatherND = function (x, indices) {
	        var indicesShape = indices.shape;
	        var sliceRank = indicesShape[indicesShape.length - 1];
	        var _a = gather_nd_util.prepareAndValidate(x, indices), resultShape = _a[0], numSlices = _a[1], sliceSize = _a[2], strides = _a[3];
	        var flattenIndices = indices.reshape([numSlices, sliceRank]);
	        var flattenX = x.reshape([x.size / sliceSize, sliceSize]);
	        var program = new gather_nd_gpu_1.GatherNDProgram(sliceRank, strides, [numSlices, sliceSize]);
	        var res = this.compileAndRun(program, [flattenX, flattenIndices]);
	        return res.reshape(resultShape);
	    };
	    MathBackendWebGL.prototype.fill = function (shape, value, dtype) {
	        dtype = dtype || util_1.inferDtype(value);
	        if (dtype === 'string') {
	            // String type should be handled in CPU memory.
	            var values = util_1.getArrayFromDType(dtype, util_1.sizeFromShape(shape));
	            values.fill(value);
	            return engine_1.ENGINE.makeTensor(values, shape, dtype, this);
	        }
	        else {
	            var program = new fill_gpu_1.FillProgram(shape, value);
	            var customSetup = program.getCustomSetupFunc(value);
	            return this.compileAndRun(program, [], dtype, customSetup);
	        }
	    };
	    MathBackendWebGL.prototype.onesLike = function (x) {
	        if (x.dtype === 'string') {
	            throw new Error('onesLike is not supported under string dtype');
	        }
	        else {
	            // TODO(cais, smilkov): Add WebGL shader for onesLike:
	            //   https://github.com/tensorflow/tfjs/issues/1293
	            return this.fill(x.shape, 1, x.dtype);
	        }
	    };
	    MathBackendWebGL.prototype.zerosLike = function (x) {
	        return this.fill(x.shape, x.dtype === 'string' ? '' : 0, x.dtype);
	    };
	    MathBackendWebGL.prototype.linspace = function (start, stop, num) {
	        // TODO: Use CPU implementation due to the precision problem in Safari.
	        return backend_util.linspaceImpl(start, stop, num);
	    };
	    MathBackendWebGL.prototype.makeTensorInfo = function (shape, dtype) {
	        var dataId = this.write(null /* values */, shape, dtype);
	        this.texData.get(dataId).usage = null;
	        return { dataId: dataId, shape: shape, dtype: dtype };
	    };
	    MathBackendWebGL.prototype.makeOutput = function (shape, dtype) {
	        var dataId = this.makeTensorInfo(shape, dtype).dataId;
	        return engine_1.ENGINE.makeTensorFromDataId(dataId, shape, dtype, this);
	    };
	    MathBackendWebGL.prototype.unpackTensor = function (input) {
	        var program = new unpack_gpu_1.UnpackProgram(input.shape);
	        return this.runWebGLProgram(program, [input], input.dtype);
	    };
	    MathBackendWebGL.prototype.packTensor = function (input) {
	        var program = new pack_gpu_1.PackProgram(input.shape);
	        var preventEagerUnpackingOutput = true;
	        return this.runWebGLProgram(program, [input], input.dtype, null /* customSetup */, preventEagerUnpackingOutput);
	    };
	    MathBackendWebGL.prototype.packedReshape = function (input, afterShape) {
	        var input3DShape = [
	            webgl_util.getBatchDim(input.shape)
	        ].concat(webgl_util.getRowsCols(input.shape));
	        var input3D = {
	            dtype: input.dtype,
	            shape: input3DShape,
	            dataId: input.dataId
	        };
	        var afterShapeAs3D = [
	            webgl_util.getBatchDim(afterShape)
	        ].concat(webgl_util.getRowsCols(afterShape));
	        var program = new reshape_packed_gpu_1.ReshapePackedProgram(afterShapeAs3D, input3DShape);
	        var preventEagerUnpackingOfOutput = true;
	        var output = this.runWebGLProgram(program, [input3D], input.dtype, null /* customSetup */, preventEagerUnpackingOfOutput);
	        return { dataId: output.dataId, shape: afterShape, dtype: output.dtype };
	    };
	    MathBackendWebGL.prototype.decode = function (dataId) {
	        var texData = this.texData.get(dataId);
	        var isPacked = texData.isPacked, shape = texData.shape, dtype = texData.dtype;
	        var shapeAs3D = webgl_util.getShapeAs3D(shape);
	        var program;
	        if (isPacked) {
	            program = new decode_matrix_packed_gpu_1.DecodeMatrixPackedProgram(shapeAs3D);
	        }
	        else {
	            program = new decode_matrix_gpu_1.DecodeMatrixProgram(shapeAs3D);
	        }
	        var preventEagerUnpackingOfOutput = true;
	        var out = this.runWebGLProgram(program, [{ shape: shapeAs3D, dtype: dtype, dataId: dataId }], dtype, null /* customSetup */, preventEagerUnpackingOfOutput);
	        return { dtype: dtype, shape: shape, dataId: out.dataId };
	    };
	    MathBackendWebGL.prototype.runWebGLProgram = function (program, inputs, outputDtype, customSetup, preventEagerUnpackingOfOutput) {
	        var _this = this;
	        if (preventEagerUnpackingOfOutput === void 0) { preventEagerUnpackingOfOutput = false; }
	        var output = this.makeTensorInfo(program.outputShape, outputDtype);
	        var outData = this.texData.get(output.dataId);
	        if (program.packedOutput) {
	            outData.isPacked = true;
	        }
	        if (program.outPackingScheme === tex_util.PackingScheme.DENSE) {
	            var texelShape = tex_util.getDenseTexShape(program.outputShape);
	            // For a densely packed output, we explicitly set texShape
	            // so it doesn't get assigned later according to our typical packing
	            // scheme wherein a single texel can only contain values from adjacent
	            // rows/cols.
	            outData.texShape = texelShape.map(function (d) { return d * 2; });
	        }
	        if (program.outTexUsage != null) {
	            outData.usage = program.outTexUsage;
	        }
	        if (util_1.sizeFromShape(output.shape) === 0) {
	            // Short-circuit the computation since the result is empty (has 0 in its
	            // shape).
	            outData.values = util_1.getTypedArrayFromDType(output.dtype, 0);
	            return output;
	        }
	        var dataToDispose = [];
	        var inputsData = inputs.map(function (input) {
	            if (input.dtype === 'complex64') {
	                throw new Error("GPGPUProgram does not support complex64 input. For complex64 " +
	                    "dtypes, please separate the program into real and imaginary " +
	                    "parts.");
	            }
	            var texData = _this.texData.get(input.dataId);
	            if (texData.texture == null) {
	                if (!program.packedInputs &&
	                    util.sizeFromShape(input.shape) <=
	                        environment_1.env().getNumber('WEBGL_SIZE_UPLOAD_UNIFORM')) {
	                    // Upload small tensors that live on the CPU as uniforms, not as
	                    // textures. Do this only when the environment supports 32bit floats
	                    // due to problems when comparing 16bit floats with 32bit floats.
	                    // TODO(https://github.com/tensorflow/tfjs/issues/821): Make it
	                    // possible for packed shaders to sample from uniforms.
	                    return {
	                        shape: input.shape,
	                        texData: null,
	                        isUniform: true,
	                        uniformValues: texData.values
	                    };
	                }
	                // This ensures that if a packed program's inputs have not yet been
	                // uploaded to the GPU, they get uploaded as packed right off the bat.
	                if (program.packedInputs) {
	                    texData.isPacked = true;
	                    texData.shape = input.shape;
	                }
	            }
	            else if (!!texData.isPacked !== !!program.packedInputs) {
	                input = texData.isPacked ? _this.unpackTensor(input) :
	                    _this.packTensor(input);
	                dataToDispose.push(input);
	                texData = _this.texData.get(input.dataId);
	            }
	            else if (texData.isPacked &&
	                !webgl_util.isReshapeFree(texData.shape, input.shape)) {
	                // This is a special case where a texture exists for a tensor
	                // but the shapes are incompatible (due to packing constraints) because
	                // the tensor did not have a chance to go through the packed reshape
	                // shader. This only happens when we reshape the *same* tensor to form
	                // *distinct* inputs to an op, e.g. dotting a vector with itself. This
	                // case will disappear once packed uploading is the default.
	                var savedInput = input;
	                var targetShape = input.shape;
	                input.shape = texData.shape;
	                input = _this.packedReshape(input, targetShape);
	                dataToDispose.push(input);
	                texData = _this.texData.get(input.dataId);
	                savedInput.shape = targetShape;
	            }
	            _this.uploadToGPU(input.dataId);
	            return { shape: input.shape, texData: texData, isUniform: false };
	        });
	        this.uploadToGPU(output.dataId);
	        var outputData = { shape: output.shape, texData: outData, isUniform: false };
	        var key = gpgpu_math.makeShaderKey(program, inputsData, outputData);
	        var binary = this.getAndSaveBinary(key, function () {
	            return gpgpu_math.compileProgram(_this.gpgpu, program, inputsData, outputData);
	        });
	        var shouldTimeProgram = this.activeTimers != null;
	        var query;
	        if (shouldTimeProgram) {
	            query = this.startTimer();
	        }
	        gpgpu_math.runProgram(this.gpgpu, binary, inputsData, outputData, customSetup);
	        dataToDispose.forEach(function (info) { return _this.disposeData(info.dataId); });
	        if (shouldTimeProgram) {
	            query = this.endTimer(query);
	            this.activeTimers.push({ name: program.constructor.name, query: this.getQueryTime(query) });
	        }
	        if (!environment_1.env().getBool('WEBGL_LAZILY_UNPACK') && outData.isPacked &&
	            preventEagerUnpackingOfOutput === false) {
	            var unpacked = this.unpackTensor(output);
	            this.disposeData(output.dataId);
	            return unpacked;
	        }
	        return output;
	    };
	    MathBackendWebGL.prototype.compileAndRun = function (program, inputs, outputDtype, customSetup, preventEagerUnpackingOfOutput) {
	        if (preventEagerUnpackingOfOutput === void 0) { preventEagerUnpackingOfOutput = false; }
	        outputDtype = outputDtype || inputs[0].dtype;
	        var outInfo = this.runWebGLProgram(program, inputs, outputDtype, customSetup, preventEagerUnpackingOfOutput);
	        return engine_1.ENGINE.makeTensorFromDataId(outInfo.dataId, outInfo.shape, outInfo.dtype);
	    };
	    MathBackendWebGL.prototype.getAndSaveBinary = function (key, getBinary) {
	        if (!(key in this.binaryCache)) {
	            this.binaryCache[key] = getBinary();
	        }
	        return this.binaryCache[key];
	    };
	    MathBackendWebGL.prototype.getTextureManager = function () {
	        return this.textureManager;
	    };
	    MathBackendWebGL.prototype.dispose = function () {
	        var _this = this;
	        if (this.disposed) {
	            return;
	        }
	        // Avoid disposing the compiled webgl programs during unit testing because
	        // it slows down test execution.
	        if (!environment_1.env().getBool('IS_TEST')) {
	            var allKeys = Object.keys(this.binaryCache);
	            allKeys.forEach(function (key) {
	                _this.gpgpu.deleteProgram(_this.binaryCache[key].webGLProgram);
	                delete _this.binaryCache[key];
	            });
	        }
	        this.textureManager.dispose();
	        if (this.canvas != null &&
	            (typeof (HTMLCanvasElement) !== 'undefined' &&
	                this.canvas instanceof HTMLCanvasElement)) {
	            this.canvas.remove();
	        }
	        else {
	            this.canvas = null;
	        }
	        if (this.gpgpuCreatedLocally) {
	            this.gpgpu.program = null;
	            this.gpgpu.dispose();
	        }
	        this.disposed = true;
	    };
	    MathBackendWebGL.prototype.floatPrecision = function () {
	        var _this = this;
	        if (this.floatPrecisionValue == null) {
	            this.floatPrecisionValue = globals_1.tidy(function () {
	                if (!environment_1.env().get('WEBGL_RENDER_FLOAT32_ENABLED')) {
	                    // Momentarily switching DEBUG flag to false so we don't throw an
	                    // error trying to upload a small value.
	                    var debugFlag = environment_1.env().getBool('DEBUG');
	                    environment_1.env().set('DEBUG', false);
	                    var underflowCheckValue = _this.abs(tensor_ops_1.scalar(1e-8)).dataSync()[0];
	                    environment_1.env().set('DEBUG', debugFlag);
	                    if (underflowCheckValue > 0) {
	                        return 32;
	                    }
	                }
	                return 16;
	            });
	        }
	        return this.floatPrecisionValue;
	    };
	    /** Returns the smallest representable number.  */
	    MathBackendWebGL.prototype.epsilon = function () {
	        return this.floatPrecision() === 32 ? backend_1.EPSILON_FLOAT32 : backend_1.EPSILON_FLOAT16;
	    };
	    MathBackendWebGL.prototype.uploadToGPU = function (dataId) {
	        var _a;
	        var texData = this.texData.get(dataId);
	        var shape = texData.shape, dtype = texData.dtype, values = texData.values, texture = texData.texture, usage = texData.usage, isPacked = texData.isPacked;
	        if (texture != null) {
	            // Array is already on GPU. No-op.
	            return;
	        }
	        var shouldTimeProgram = this.activeTimers != null;
	        var start;
	        if (shouldTimeProgram) {
	            start = util.now();
	        }
	        var texShape = texData.texShape;
	        if (texShape == null) {
	            texShape = webgl_util.getTextureShapeFromLogicalShape(shape, isPacked);
	            texData.texShape = texShape;
	        }
	        if (values != null) {
	            var shapeAs3D = webgl_util.getShapeAs3D(shape);
	            var program = void 0;
	            var width = texShape[1], height = texShape[0];
	            var isByteArray = values instanceof Uint8Array;
	            if (isPacked) {
	                _a = tex_util.getPackedMatrixTextureShapeWidthHeight(texShape[0], texShape[1]), width = _a[0], height = _a[1];
	                program = new encode_matrix_packed_gpu_1.EncodeMatrixPackedProgram(shapeAs3D, [height, width], isByteArray);
	            }
	            else {
	                program =
	                    new encode_matrix_gpu_1.EncodeMatrixProgram(shapeAs3D, [height, width], isByteArray);
	            }
	            var tempDenseInputHandle = this.makeTensorInfo([height, width], dtype);
	            if (isByteArray) {
	                this.texData.get(tempDenseInputHandle.dataId).usage =
	                    tex_util_1.TextureUsage.PIXELS;
	            }
	            else {
	                this.texData.get(tempDenseInputHandle.dataId).usage =
	                    tex_util_1.TextureUsage.UPLOAD;
	            }
	            this.gpgpu.uploadDenseMatrixToTexture(this.getTexture(tempDenseInputHandle.dataId), width, height, values);
	            // We want the output to remain packed regardless of the value of
	            // WEBGL_PACK.
	            var preventEagerUnpacking = true;
	            var encodedOutputTarget = this.runWebGLProgram(program, [tempDenseInputHandle], dtype, null, preventEagerUnpacking);
	            // Have the original texture assume the identity of the encoded output.
	            var outputTexData = this.texData.get(encodedOutputTarget.dataId);
	            texData.texture = outputTexData.texture;
	            texData.texShape = outputTexData.texShape;
	            texData.isPacked = outputTexData.isPacked;
	            texData.usage = outputTexData.usage;
	            this.disposeData(tempDenseInputHandle.dataId);
	            this.texData.delete(encodedOutputTarget.dataId);
	            // Once uploaded, don't store the values on cpu.
	            texData.values = null;
	            if (shouldTimeProgram) {
	                this.uploadWaitMs += util.now() - start;
	            }
	        }
	        else {
	            var newTexture = this.acquireTexture(texShape, usage, dtype, isPacked);
	            texData.texture = newTexture;
	        }
	    };
	    MathBackendWebGL.prototype.convertAndCacheOnCPU = function (dataId, float32Values) {
	        var texData = this.texData.get(dataId);
	        var dtype = texData.dtype;
	        this.releaseGPUData(dataId);
	        if (float32Values != null) {
	            texData.values = float32ToTypedArray(float32Values, dtype);
	        }
	        return texData.values;
	    };
	    MathBackendWebGL.prototype.acquireTexture = function (texShape, texType, dtype, isPacked) {
	        this.numBytesInGPU += this.computeBytes(texShape, dtype);
	        if (!this.warnedAboutMemory &&
	            this.numBytesInGPU > this.numMBBeforeWarning * 1024 * 1024) {
	            var mb = (this.numBytesInGPU / 1024 / 1024).toFixed(2);
	            this.warnedAboutMemory = true;
	            console.warn("High memory usage in GPU: " + mb + " MB, " +
	                "most likely due to a memory leak");
	        }
	        return this.textureManager.acquireTexture(texShape, texType, isPacked);
	    };
	    MathBackendWebGL.prototype.computeBytes = function (shape, dtype) {
	        return shape[0] * shape[1] * util.bytesPerElement(dtype);
	    };
	    return MathBackendWebGL;
	}(backend_1.KernelBackend));
	exports.MathBackendWebGL = MathBackendWebGL;
	if (device_util.isBrowser()) {
	    engine_1.ENGINE.registerBackend('webgl', function () { return new MathBackendWebGL(); }, 2 /* priority */);
	}
	function float32ToTypedArray(a, dtype) {
	    if (dtype === 'float32' || dtype === 'complex64') {
	        return a;
	    }
	    else if (dtype === 'int32' || dtype === 'bool') {
	        var result = (dtype === 'int32') ? new Int32Array(a.length) :
	            new Uint8Array(a.length);
	        for (var i = 0; i < result.length; ++i) {
	            result[i] = Math.round(a[i]);
	        }
	        return result;
	    }
	    else {
	        throw new Error("Unknown dtype " + dtype);
	    }
	}
	//# sourceMappingURL=backend_webgl.js.map

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var broadcast_util = __webpack_require__(57);
	// (Ar + Ai)(Br + Bi) =
	// ArBr + ArBi + AiBr + AiBi = ArBr - AB + ArBi + AiBr
	// Yr = ArBr - AB
	// Yi = ArBi + AiBr
	exports.COMPLEX_MULTIPLY = {
	    REAL: 'return areal * breal - aimag * bimag;',
	    IMAG: 'return areal * bimag + aimag * breal;'
	};
	var BinaryOpComplexProgram = /** @class */ (function () {
	    function BinaryOpComplexProgram(op, aShape, bShape) {
	        this.variableNames = ['AReal', 'AImag', 'BReal', 'BImag'];
	        this.outputShape =
	            broadcast_util.assertAndGetBroadcastShape(aShape, bShape);
	        this.userCode = "\n      float binaryOpComplex(\n          float areal, float aimag, float breal, float bimag) {\n        " + op + "\n      }\n\n      void main() {\n        float areal = getARealAtOutCoords();\n        float aimag = getAImagAtOutCoords();\n        float breal = getBRealAtOutCoords();\n        float bimag = getBImagAtOutCoords();\n        setOutput(binaryOpComplex(areal, aimag, breal, bimag));\n      }\n    ";
	    }
	    return BinaryOpComplexProgram;
	}());
	exports.BinaryOpComplexProgram = BinaryOpComplexProgram;
	//# sourceMappingURL=binaryop_complex_gpu.js.map

/***/ },
/* 480 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.COMPLEX_FFT = {
	    REAL: 'return real * expR - imag * expI;',
	    IMAG: 'return real * expI + imag * expR;'
	};
	var FFTProgram = /** @class */ (function () {
	    function FFTProgram(op, inputShape, inverse) {
	        this.variableNames = ['real', 'imag'];
	        var innerDim = inputShape[1];
	        this.outputShape = inputShape;
	        var exponentMultiplierSnippet = inverse ? "2.0 * " + Math.PI : "-2.0 * " + Math.PI;
	        var resultDenominator = inverse ? innerDim + ".0" : '1.0';
	        this.userCode = "\n      const float exponentMultiplier = " + exponentMultiplierSnippet + ";\n\n      float unaryOpComplex(float real, float expR, float imag, float expI) {\n        " + op + "\n      }\n\n      float mulMatDFT(int batch, int index) {\n        float indexRatio = float(index) / float(" + innerDim + ");\n        float exponentMultiplierTimesIndexRatio =\n            exponentMultiplier * indexRatio;\n\n        float result = 0.0;\n\n        for (int i = 0; i < " + innerDim + "; i++) {\n          // x = (-2|2 * PI / N) * index * i;\n          float x = exponentMultiplierTimesIndexRatio * float(i);\n          float expR = cos(x);\n          float expI = sin(x);\n          float real = getReal(batch, i);\n          float imag = getImag(batch, i);\n\n          result +=\n              unaryOpComplex(real, expR, imag, expI) / " + resultDenominator + ";\n        }\n\n        return result;\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        setOutput(mulMatDFT(coords[0], coords[1]));\n      }\n    ";
	    }
	    return FFTProgram;
	}());
	exports.FFTProgram = FFTProgram;
	//# sourceMappingURL=fft_gpu.js.map

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var environment_1 = __webpack_require__(28);
	var util = __webpack_require__(10);
	var canvas_util_1 = __webpack_require__(236);
	var gpgpu_util = __webpack_require__(482);
	var tex_util = __webpack_require__(82);
	var webgl_util = __webpack_require__(189);
	var GPGPUContext = /** @class */ (function () {
	    function GPGPUContext(gl) {
	        this.outputTexture = null;
	        this.program = null;
	        this.disposed = false;
	        this.vertexAttrsAreBound = false;
	        this.itemsToPoll = [];
	        var glVersion = environment_1.env().getNumber('WEBGL_VERSION');
	        if (gl != null) {
	            this.gl = gl;
	            canvas_util_1.setWebGLContext(glVersion, gl);
	        }
	        else {
	            this.gl = canvas_util_1.getWebGLContext(glVersion);
	        }
	        // WebGL 2.0 enables texture floats without an extension.
	        var COLOR_BUFFER_FLOAT = 'WEBGL_color_buffer_float';
	        var COLOR_BUFFER_HALF_FLOAT = 'EXT_color_buffer_half_float';
	        if (environment_1.env().getNumber('WEBGL_VERSION') === 1) {
	            var TEXTURE_FLOAT = 'OES_texture_float';
	            var TEXTURE_HALF_FLOAT = 'OES_texture_half_float';
	            this.textureFloatExtension =
	                webgl_util.getExtensionOrThrow(this.gl, this.debug, TEXTURE_FLOAT);
	            if (webgl_util.hasExtension(this.gl, TEXTURE_HALF_FLOAT)) {
	                this.textureHalfFloatExtension = webgl_util.getExtensionOrThrow(this.gl, this.debug, TEXTURE_HALF_FLOAT);
	            }
	            else if (environment_1.env().get('WEBGL_FORCE_F16_TEXTURES')) {
	                throw new Error('GL context does not support half float textures, yet the ' +
	                    'environment flag WEBGL_FORCE_F16_TEXTURES is set to true.');
	            }
	            this.colorBufferFloatExtension = this.gl.getExtension(COLOR_BUFFER_FLOAT);
	            if (webgl_util.hasExtension(this.gl, COLOR_BUFFER_HALF_FLOAT)) {
	                this.colorBufferHalfFloatExtension = webgl_util.getExtensionOrThrow(this.gl, this.debug, COLOR_BUFFER_HALF_FLOAT);
	            }
	            else if (environment_1.env().get('WEBGL_FORCE_F16_TEXTURES')) {
	                throw new Error('GL context does not support color renderable half floats, yet ' +
	                    'the environment flag WEBGL_FORCE_F16_TEXTURES is set to true.');
	            }
	        }
	        else {
	            COLOR_BUFFER_FLOAT = 'EXT_color_buffer_float';
	            if (webgl_util.hasExtension(this.gl, COLOR_BUFFER_FLOAT)) {
	                this.colorBufferFloatExtension =
	                    this.gl.getExtension(COLOR_BUFFER_FLOAT);
	            }
	            else if (webgl_util.hasExtension(this.gl, COLOR_BUFFER_HALF_FLOAT)) {
	                this.colorBufferHalfFloatExtension =
	                    this.gl.getExtension(COLOR_BUFFER_HALF_FLOAT);
	            }
	            else {
	                throw new Error('GL context does not support color renderable floats');
	            }
	        }
	        this.vertexBuffer = gpgpu_util.createVertexBuffer(this.gl, this.debug);
	        this.indexBuffer = gpgpu_util.createIndexBuffer(this.gl, this.debug);
	        this.framebuffer = webgl_util.createFramebuffer(this.gl, this.debug);
	        this.textureConfig =
	            tex_util.getTextureConfig(this.gl, this.textureHalfFloatExtension);
	    }
	    Object.defineProperty(GPGPUContext.prototype, "debug", {
	        get: function () {
	            return environment_1.env().getBool('DEBUG');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    GPGPUContext.prototype.dispose = function () {
	        var _this = this;
	        if (this.disposed) {
	            return;
	        }
	        if (this.program != null) {
	            console.warn('Disposing a GPGPUContext that still has a bound WebGLProgram.' +
	                ' This is probably a resource leak, delete the program with ' +
	                'GPGPUContext.deleteProgram before disposing.');
	        }
	        if (this.outputTexture != null) {
	            console.warn('Disposing a GPGPUContext that still has a bound output matrix ' +
	                'texture.  This is probably a resource leak, delete the output ' +
	                'matrix texture with GPGPUContext.deleteMatrixTexture before ' +
	                'disposing.');
	        }
	        var gl = this.gl;
	        webgl_util.callAndCheck(gl, this.debug, function () { return gl.finish(); });
	        webgl_util.callAndCheck(gl, this.debug, function () { return gl.bindFramebuffer(gl.FRAMEBUFFER, null); });
	        webgl_util.callAndCheck(gl, this.debug, function () { return gl.deleteFramebuffer(_this.framebuffer); });
	        webgl_util.callAndCheck(gl, this.debug, function () { return gl.bindBuffer(gl.ARRAY_BUFFER, null); });
	        webgl_util.callAndCheck(gl, this.debug, function () { return gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null); });
	        webgl_util.callAndCheck(gl, this.debug, function () { return gl.deleteBuffer(_this.indexBuffer); });
	        this.disposed = true;
	    };
	    GPGPUContext.prototype.createFloat32MatrixTexture = function (rows, columns) {
	        this.throwIfDisposed();
	        return gpgpu_util.createFloat32MatrixTexture(this.gl, this.debug, rows, columns, this.textureConfig);
	    };
	    GPGPUContext.prototype.createFloat16MatrixTexture = function (rows, columns) {
	        this.throwIfDisposed();
	        return gpgpu_util.createFloat16MatrixTexture(this.gl, this.debug, rows, columns, this.textureConfig);
	    };
	    GPGPUContext.prototype.createUnsignedBytesMatrixTexture = function (rows, columns) {
	        this.throwIfDisposed();
	        return gpgpu_util.createUnsignedBytesMatrixTexture(this.gl, this.debug, rows, columns, this.textureConfig);
	    };
	    GPGPUContext.prototype.uploadPixelDataToTexture = function (texture, pixels) {
	        this.throwIfDisposed();
	        gpgpu_util.uploadPixelDataToTexture(this.gl, this.debug, texture, pixels);
	    };
	    GPGPUContext.prototype.uploadDenseMatrixToTexture = function (texture, width, height, data) {
	        this.throwIfDisposed();
	        gpgpu_util.uploadDenseMatrixToTexture(this.gl, this.debug, texture, width, height, data, this.textureConfig);
	    };
	    GPGPUContext.prototype.createFloat16PackedMatrixTexture = function (rows, columns) {
	        this.throwIfDisposed();
	        return gpgpu_util.createFloat16PackedMatrixTexture(this.gl, this.debug, rows, columns, this.textureConfig);
	    };
	    GPGPUContext.prototype.createPackedMatrixTexture = function (rows, columns) {
	        this.throwIfDisposed();
	        return gpgpu_util.createPackedMatrixTexture(this.gl, this.debug, rows, columns, this.textureConfig);
	    };
	    GPGPUContext.prototype.deleteMatrixTexture = function (texture) {
	        var _this = this;
	        this.throwIfDisposed();
	        if (this.outputTexture === texture) {
	            webgl_util.unbindColorTextureFromFramebuffer(this.gl, this.debug, this.framebuffer);
	            this.outputTexture = null;
	        }
	        webgl_util.callAndCheck(this.gl, this.debug, function () { return _this.gl.deleteTexture(texture); });
	    };
	    GPGPUContext.prototype.downloadByteEncodedFloatMatrixFromOutputTexture = function (texture, rows, columns) {
	        var _this = this;
	        return this.downloadMatrixDriver(texture, function () { return gpgpu_util.downloadByteEncodedFloatMatrixFromOutputTexture(_this.gl, _this.debug, rows, columns, _this.textureConfig); });
	    };
	    GPGPUContext.prototype.downloadPackedMatrixFromBuffer = function (buffer, batch, rows, columns, physicalRows, physicalCols) {
	        return gpgpu_util.downloadPackedMatrixFromBuffer(this.gl, buffer, batch, rows, columns, physicalRows, physicalCols, this.textureConfig);
	    };
	    GPGPUContext.prototype.downloadFloat32MatrixFromBuffer = function (buffer, size) {
	        return gpgpu_util.downloadFloat32MatrixFromBuffer(this.gl, buffer, size);
	    };
	    GPGPUContext.prototype.createBufferFromTexture = function (texture, rows, columns) {
	        this.bindTextureToFrameBuffer(texture);
	        var result = gpgpu_util.createBufferFromOutputTexture(this.gl, this.debug, rows, columns, this.textureConfig);
	        this.unbindTextureToFrameBuffer();
	        return result;
	    };
	    GPGPUContext.prototype.createAndWaitForFence = function () {
	        var fenceContext = this.createFence(this.gl);
	        return this.pollFence(fenceContext);
	    };
	    GPGPUContext.prototype.createFence = function (gl) {
	        var _this = this;
	        var query;
	        var isFencePassed;
	        if (environment_1.env().getBool('WEBGL_FENCE_API_ENABLED')) {
	            var gl2_1 = gl;
	            var sync_1 = gl2_1.fenceSync(gl2_1.SYNC_GPU_COMMANDS_COMPLETE, 0);
	            gl.flush();
	            isFencePassed = function () {
	                var status = gl2_1.clientWaitSync(sync_1, 0, 0);
	                return status === gl2_1.ALREADY_SIGNALED ||
	                    status === gl2_1.CONDITION_SATISFIED;
	            };
	            query = sync_1;
	        }
	        else if (environment_1.env().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') > 0) {
	            query = this.beginQuery();
	            this.endQuery();
	            isFencePassed = function () { return _this.isQueryAvailable(query, environment_1.env().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION')); };
	        }
	        else {
	            // If we have no way to fence, return true immediately. This will fire in
	            // WebGL 1.0 when there is no disjoint query timer. In this case, because
	            // the fence passes immediately, we'll immediately ask for a download of
	            // the texture, which will cause the UI thread to hang.
	            isFencePassed = function () { return true; };
	        }
	        return { query: query, isFencePassed: isFencePassed };
	    };
	    GPGPUContext.prototype.downloadMatrixFromPackedTexture = function (texture, physicalRows, physicalCols) {
	        var _this = this;
	        return this.downloadMatrixDriver(texture, function () { return gpgpu_util.downloadMatrixFromPackedOutputTexture(_this.gl, _this.debug, physicalRows, physicalCols); });
	    };
	    GPGPUContext.prototype.createProgram = function (fragmentShaderSource) {
	        this.throwIfDisposed();
	        var gl = this.gl;
	        var fragmentShader = webgl_util.createFragmentShader(gl, this.debug, fragmentShaderSource);
	        var vertexShader = gpgpu_util.createVertexShader(gl, this.debug);
	        var program = webgl_util.createProgram(gl, this.debug);
	        webgl_util.callAndCheck(gl, this.debug, function () { return gl.attachShader(program, vertexShader); });
	        webgl_util.callAndCheck(gl, this.debug, function () { return gl.attachShader(program, fragmentShader); });
	        webgl_util.linkProgram(gl, this.debug, program);
	        if (this.debug) {
	            webgl_util.validateProgram(gl, this.debug, program);
	        }
	        if (!this.vertexAttrsAreBound) {
	            this.setProgram(program);
	            this.vertexAttrsAreBound = gpgpu_util.bindVertexProgramAttributeStreams(gl, this.debug, this.program, this.vertexBuffer);
	        }
	        return program;
	    };
	    GPGPUContext.prototype.deleteProgram = function (program) {
	        var _this = this;
	        this.throwIfDisposed();
	        if (program === this.program) {
	            this.program = null;
	        }
	        if (program != null) {
	            webgl_util.callAndCheck(this.gl, this.debug, function () { return _this.gl.deleteProgram(program); });
	        }
	    };
	    GPGPUContext.prototype.setProgram = function (program) {
	        var _this = this;
	        this.throwIfDisposed();
	        this.program = program;
	        if ((this.program != null) && this.debug) {
	            webgl_util.validateProgram(this.gl, this.debug, this.program);
	        }
	        webgl_util.callAndCheck(this.gl, this.debug, function () { return _this.gl.useProgram(program); });
	    };
	    GPGPUContext.prototype.getUniformLocation = function (program, uniformName, shouldThrow) {
	        if (shouldThrow === void 0) { shouldThrow = true; }
	        this.throwIfDisposed();
	        if (shouldThrow) {
	            return webgl_util.getProgramUniformLocationOrThrow(this.gl, this.debug, program, uniformName);
	        }
	        else {
	            return webgl_util.getProgramUniformLocation(this.gl, program, uniformName);
	        }
	    };
	    GPGPUContext.prototype.getAttributeLocation = function (program, attribute) {
	        var _this = this;
	        this.throwIfDisposed();
	        return webgl_util.callAndCheck(this.gl, this.debug, function () { return _this.gl.getAttribLocation(program, attribute); });
	    };
	    GPGPUContext.prototype.getUniformLocationNoThrow = function (program, uniformName) {
	        this.throwIfDisposed();
	        return this.gl.getUniformLocation(program, uniformName);
	    };
	    GPGPUContext.prototype.setInputMatrixTexture = function (inputMatrixTexture, uniformLocation, textureUnit) {
	        this.throwIfDisposed();
	        this.throwIfNoProgram();
	        webgl_util.bindTextureToProgramUniformSampler(this.gl, this.debug, this.program, inputMatrixTexture, uniformLocation, textureUnit);
	    };
	    GPGPUContext.prototype.setOutputMatrixTexture = function (outputMatrixTexture, rows, columns) {
	        this.setOutputMatrixTextureDriver(outputMatrixTexture, columns, rows);
	    };
	    GPGPUContext.prototype.setOutputPackedMatrixTexture = function (outputPackedMatrixTexture, rows, columns) {
	        this.throwIfDisposed();
	        var _a = tex_util.getPackedMatrixTextureShapeWidthHeight(rows, columns), width = _a[0], height = _a[1];
	        this.setOutputMatrixTextureDriver(outputPackedMatrixTexture, width, height);
	    };
	    GPGPUContext.prototype.setOutputMatrixWriteRegion = function (startRow, numRows, startColumn, numColumns) {
	        this.setOutputMatrixWriteRegionDriver(startColumn, startRow, numColumns, numRows);
	    };
	    GPGPUContext.prototype.setOutputPackedMatrixWriteRegion = function (startRow, numRows, startColumn, numColumns) {
	        throw new Error('setOutputPackedMatrixWriteRegion not implemented.');
	    };
	    GPGPUContext.prototype.debugValidate = function () {
	        if (this.program != null) {
	            webgl_util.validateProgram(this.gl, this.debug, this.program);
	        }
	        webgl_util.validateFramebuffer(this.gl);
	    };
	    GPGPUContext.prototype.executeProgram = function () {
	        this.throwIfDisposed();
	        this.throwIfNoProgram();
	        var gl = this.gl;
	        if (this.debug) {
	            this.debugValidate();
	        }
	        webgl_util.callAndCheck(gl, this.debug, function () { return gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0); });
	    };
	    GPGPUContext.prototype.blockUntilAllProgramsCompleted = function () {
	        var _this = this;
	        this.throwIfDisposed();
	        webgl_util.callAndCheck(this.gl, this.debug, function () { return _this.gl.finish(); });
	    };
	    GPGPUContext.prototype.getQueryTimerExtension = function () {
	        if (this.disjointQueryTimerExtension == null) {
	            this.disjointQueryTimerExtension =
	                webgl_util.getExtensionOrThrow(this.gl, this.debug, environment_1.env().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') === 2 ?
	                    'EXT_disjoint_timer_query_webgl2' :
	                    'EXT_disjoint_timer_query');
	        }
	        return this.disjointQueryTimerExtension;
	    };
	    GPGPUContext.prototype.getQueryTimerExtensionWebGL2 = function () {
	        return this.getQueryTimerExtension();
	    };
	    GPGPUContext.prototype.getQueryTimerExtensionWebGL1 = function () {
	        return this.getQueryTimerExtension();
	    };
	    GPGPUContext.prototype.beginQuery = function () {
	        if (environment_1.env().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') === 2) {
	            var gl2 = this.gl;
	            var ext_1 = this.getQueryTimerExtensionWebGL2();
	            var query_1 = gl2.createQuery();
	            gl2.beginQuery(ext_1.TIME_ELAPSED_EXT, query_1);
	            return query_1;
	        }
	        var ext = this.getQueryTimerExtensionWebGL1();
	        var query = ext.createQueryEXT();
	        ext.beginQueryEXT(ext.TIME_ELAPSED_EXT, query);
	        return query;
	    };
	    GPGPUContext.prototype.endQuery = function () {
	        if (environment_1.env().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') === 2) {
	            var gl2 = this.gl;
	            var ext_2 = this.getQueryTimerExtensionWebGL2();
	            gl2.endQuery(ext_2.TIME_ELAPSED_EXT);
	            return;
	        }
	        var ext = this.getQueryTimerExtensionWebGL1();
	        ext.endQueryEXT(ext.TIME_ELAPSED_EXT);
	    };
	    GPGPUContext.prototype.waitForQueryAndGetTime = function (query) {
	        return __awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, util.repeatedTry(function () { return _this.disposed || // while testing contexts are created / disposed
	                            // in rapid succession, so without this check we
	                            // may poll for the query timer indefinitely
	                            _this.isQueryAvailable(query, environment_1.env().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION')); })];
	                    case 1:
	                        _a.sent();
	                        return [2 /*return*/, this.getQueryTime(query, environment_1.env().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION'))];
	                }
	            });
	        });
	    };
	    GPGPUContext.prototype.getQueryTime = function (query, queryTimerVersion) {
	        if (queryTimerVersion === 0) {
	            return null;
	        }
	        if (queryTimerVersion === 2) {
	            var gl2 = this.gl;
	            var timeElapsedNanos = gl2.getQueryParameter(query, gl2.QUERY_RESULT);
	            // Return milliseconds.
	            return timeElapsedNanos / 1000000;
	        }
	        else {
	            var ext = this.getQueryTimerExtensionWebGL1();
	            var timeElapsedNanos = ext.getQueryObjectEXT(query, ext.QUERY_RESULT_EXT);
	            // Return milliseconds.
	            return timeElapsedNanos / 1000000;
	        }
	    };
	    GPGPUContext.prototype.isQueryAvailable = function (query, queryTimerVersion) {
	        if (queryTimerVersion === 0) {
	            return true;
	        }
	        if (queryTimerVersion === 2) {
	            var gl2 = this.gl;
	            var ext = this.getQueryTimerExtensionWebGL2();
	            var available = gl2.getQueryParameter(query, gl2.QUERY_RESULT_AVAILABLE);
	            if (this.disjoint == null) {
	                this.disjoint = this.gl.getParameter(ext.GPU_DISJOINT_EXT);
	            }
	            return available && !this.disjoint;
	        }
	        else {
	            var ext = this.getQueryTimerExtensionWebGL1();
	            var available = ext.getQueryObjectEXT(query, ext.QUERY_RESULT_AVAILABLE_EXT);
	            if (this.disjoint == null) {
	                this.disjoint = this.gl.getParameter(ext.GPU_DISJOINT_EXT);
	            }
	            return available && !this.disjoint;
	        }
	    };
	    GPGPUContext.prototype.pollFence = function (fenceContext) {
	        var _this = this;
	        return new Promise(function (resolve) {
	            _this.addItemToPoll(function () { return fenceContext.isFencePassed(); }, function () { return resolve(); });
	        });
	    };
	    GPGPUContext.prototype.pollItems = function () {
	        // Find the last query that has finished.
	        var index = linearSearchLastTrue(this.itemsToPoll.map(function (x) { return x.isDoneFn; }));
	        for (var i = 0; i <= index; ++i) {
	            var resolveFn = this.itemsToPoll[i].resolveFn;
	            resolveFn();
	        }
	        this.itemsToPoll = this.itemsToPoll.slice(index + 1);
	    };
	    GPGPUContext.prototype.addItemToPoll = function (isDoneFn, resolveFn) {
	        var _this = this;
	        this.itemsToPoll.push({ isDoneFn: isDoneFn, resolveFn: resolveFn });
	        if (this.itemsToPoll.length > 1) {
	            // We already have a running loop that polls.
	            return;
	        }
	        // Start a new loop that polls.
	        util.repeatedTry(function () {
	            _this.pollItems();
	            // End the loop if no more items to poll.
	            return _this.itemsToPoll.length === 0;
	        });
	    };
	    GPGPUContext.prototype.bindTextureToFrameBuffer = function (texture) {
	        this.throwIfDisposed();
	        webgl_util.bindColorTextureToFramebuffer(this.gl, this.debug, texture, this.framebuffer);
	        if (this.debug) {
	            webgl_util.validateFramebuffer(this.gl);
	        }
	    };
	    GPGPUContext.prototype.unbindTextureToFrameBuffer = function () {
	        if (this.outputTexture != null) {
	            webgl_util.bindColorTextureToFramebuffer(this.gl, this.debug, this.outputTexture, this.framebuffer);
	            if (this.debug) {
	                webgl_util.validateFramebuffer(this.gl);
	            }
	        }
	        else {
	            webgl_util.unbindColorTextureFromFramebuffer(this.gl, this.debug, this.framebuffer);
	        }
	    };
	    GPGPUContext.prototype.downloadMatrixDriver = function (texture, downloadAndDecode) {
	        this.bindTextureToFrameBuffer(texture);
	        var result = downloadAndDecode();
	        this.unbindTextureToFrameBuffer();
	        return result;
	    };
	    GPGPUContext.prototype.setOutputMatrixTextureDriver = function (outputMatrixTextureMaybePacked, width, height) {
	        this.throwIfDisposed();
	        var gl = this.gl;
	        webgl_util.bindColorTextureToFramebuffer(gl, this.debug, outputMatrixTextureMaybePacked, this.framebuffer);
	        if (this.debug) {
	            webgl_util.validateFramebuffer(gl);
	        }
	        this.outputTexture = outputMatrixTextureMaybePacked;
	        webgl_util.callAndCheck(gl, this.debug, function () { return gl.viewport(0, 0, width, height); });
	        webgl_util.callAndCheck(gl, this.debug, function () { return gl.scissor(0, 0, width, height); });
	    };
	    GPGPUContext.prototype.setOutputMatrixWriteRegionDriver = function (x, y, width, height) {
	        var _this = this;
	        this.throwIfDisposed();
	        webgl_util.callAndCheck(this.gl, this.debug, function () { return _this.gl.scissor(x, y, width, height); });
	    };
	    GPGPUContext.prototype.throwIfDisposed = function () {
	        if (this.disposed) {
	            throw new Error('Attempted to use disposed GPGPUContext.');
	        }
	    };
	    GPGPUContext.prototype.throwIfNoProgram = function () {
	        if (this.program == null) {
	            throw new Error('No GPU program is currently set.');
	        }
	    };
	    return GPGPUContext;
	}());
	exports.GPGPUContext = GPGPUContext;
	/**
	 * Finds the index of the last true element using linear search.
	 * Note: We can't do binary search because Chrome expects us to explicitly
	 * test all fences before download:
	 * https://github.com/tensorflow/tfjs/issues/1145
	 */
	function linearSearchLastTrue(arr) {
	    var i = 0;
	    for (; i < arr.length; ++i) {
	        var isDone = arr[i]();
	        if (!isDone) {
	            break;
	        }
	    }
	    return i - 1;
	}
	exports.linearSearchLastTrue = linearSearchLastTrue;
	//# sourceMappingURL=gpgpu_context.js.map

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var glsl_version_1 = __webpack_require__(81);
	var tex_util = __webpack_require__(82);
	var webgl_util = __webpack_require__(189);
	function createVertexShader(gl, debug) {
	    var glsl = glsl_version_1.getGlslDifferences();
	    var vertexShaderSource = glsl.version + "\n    precision highp float;\n    " + glsl.attribute + " vec3 clipSpacePos;\n    " + glsl.attribute + " vec2 uv;\n    " + glsl.varyingVs + " vec2 resultUV;\n\n    void main() {\n      gl_Position = vec4(clipSpacePos, 1);\n      resultUV = uv;\n    }";
	    return webgl_util.createVertexShader(gl, debug, vertexShaderSource);
	}
	exports.createVertexShader = createVertexShader;
	function createVertexBuffer(gl, debug) {
	    // [x y z u v] * [upper-left, lower-left, upper-right, lower-right]
	    var vertexArray = new Float32Array([-1, 1, 0, 0, 1, -1, -1, 0, 0, 0, 1, 1, 0, 1, 1, 1, -1, 0, 1, 0]);
	    return webgl_util.createStaticVertexBuffer(gl, debug, vertexArray);
	}
	exports.createVertexBuffer = createVertexBuffer;
	function createIndexBuffer(gl, debug) {
	    // OpenGL (and WebGL) have "CCW == front" winding
	    var triangleVertexIndices = new Uint16Array([0, 1, 2, 2, 1, 3]);
	    return webgl_util.createStaticIndexBuffer(gl, debug, triangleVertexIndices);
	}
	exports.createIndexBuffer = createIndexBuffer;
	function createAndConfigureTexture(gl, debug, width, height, internalFormat, textureFormat, textureType) {
	    webgl_util.validateTextureSize(width, height);
	    var texture = webgl_util.createTexture(gl, debug);
	    var tex2d = gl.TEXTURE_2D;
	    webgl_util.callAndCheck(gl, debug, function () { return gl.bindTexture(tex2d, texture); });
	    webgl_util.callAndCheck(gl, debug, function () { return gl.texParameteri(tex2d, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); });
	    webgl_util.callAndCheck(gl, debug, function () { return gl.texParameteri(tex2d, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE); });
	    webgl_util.callAndCheck(gl, debug, function () { return gl.texParameteri(tex2d, gl.TEXTURE_MIN_FILTER, gl.NEAREST); });
	    webgl_util.callAndCheck(gl, debug, function () { return gl.texParameteri(tex2d, gl.TEXTURE_MAG_FILTER, gl.NEAREST); });
	    webgl_util.callAndCheck(gl, debug, function () { return gl.texImage2D(tex2d, 0, internalFormat, width, height, 0, textureFormat, textureType, null); });
	    webgl_util.callAndCheck(gl, debug, function () { return gl.bindTexture(gl.TEXTURE_2D, null); });
	    return texture;
	}
	function createFloat32MatrixTexture(gl, debug, rows, columns, textureConfig) {
	    var _a = tex_util.getUnpackedMatrixTextureShapeWidthHeight(rows, columns), width = _a[0], height = _a[1];
	    return createAndConfigureTexture(gl, debug, width, height, textureConfig.internalFormatFloat, textureConfig.textureFormatFloat, gl.FLOAT);
	}
	exports.createFloat32MatrixTexture = createFloat32MatrixTexture;
	function createFloat16MatrixTexture(gl, debug, rows, columns, textureConfig) {
	    var _a = tex_util.getUnpackedMatrixTextureShapeWidthHeight(rows, columns), width = _a[0], height = _a[1];
	    return createAndConfigureTexture(gl, debug, width, height, textureConfig.internalFormatHalfFloat, textureConfig.textureFormatFloat, textureConfig.textureTypeHalfFloat);
	}
	exports.createFloat16MatrixTexture = createFloat16MatrixTexture;
	function createUnsignedBytesMatrixTexture(gl, debug, rows, columns, textureConfig) {
	    var _a = tex_util.getUnpackedMatrixTextureShapeWidthHeight(rows, columns), width = _a[0], height = _a[1];
	    return createAndConfigureTexture(gl, debug, width, height, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE);
	}
	exports.createUnsignedBytesMatrixTexture = createUnsignedBytesMatrixTexture;
	function createPackedMatrixTexture(gl, debug, rows, columns, textureConfig) {
	    var _a = tex_util.getPackedMatrixTextureShapeWidthHeight(rows, columns), width = _a[0], height = _a[1];
	    return createAndConfigureTexture(gl, debug, width, height, textureConfig.internalFormatPackedFloat, gl.RGBA, gl.FLOAT);
	}
	exports.createPackedMatrixTexture = createPackedMatrixTexture;
	function createFloat16PackedMatrixTexture(gl, debug, rows, columns, textureConfig) {
	    var _a = tex_util.getPackedMatrixTextureShapeWidthHeight(rows, columns), width = _a[0], height = _a[1];
	    return createAndConfigureTexture(gl, debug, width, height, textureConfig.internalFormatPackedHalfFloat, gl.RGBA, textureConfig.textureTypeHalfFloat);
	}
	exports.createFloat16PackedMatrixTexture = createFloat16PackedMatrixTexture;
	function bindVertexProgramAttributeStreams(gl, debug, program, vertexBuffer) {
	    var posOffset = 0; // x is the first buffer element
	    var uvOffset = 3 * 4; // uv comes after [x y z]
	    var stride = (3 * 4) + (2 * 4); // xyz + uv, each entry is 4-byte float.
	    webgl_util.callAndCheck(gl, debug, function () { return gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer); });
	    var success = webgl_util.bindVertexBufferToProgramAttribute(gl, debug, program, 'clipSpacePos', vertexBuffer, 3, stride, posOffset);
	    return success &&
	        webgl_util.bindVertexBufferToProgramAttribute(gl, debug, program, 'uv', vertexBuffer, 2, stride, uvOffset);
	}
	exports.bindVertexProgramAttributeStreams = bindVertexProgramAttributeStreams;
	function uploadDenseMatrixToTexture(gl, debug, texture, width, height, data, textureConfig) {
	    webgl_util.callAndCheck(gl, debug, function () { return gl.bindTexture(gl.TEXTURE_2D, texture); });
	    var dataForUpload, texelDataType, internalFormat;
	    if (data instanceof Uint8Array) {
	        dataForUpload = new Uint8Array(width * height * 4);
	        texelDataType = gl.UNSIGNED_BYTE;
	        internalFormat = gl.RGBA;
	    }
	    else {
	        dataForUpload = new Float32Array(width * height * 4);
	        texelDataType = gl.FLOAT;
	        internalFormat = textureConfig.internalFormatPackedFloat;
	    }
	    dataForUpload.set(data);
	    webgl_util.callAndCheck(gl, debug, function () { return gl.texImage2D(gl.TEXTURE_2D, 0, internalFormat, width, height, 0, gl.RGBA, texelDataType, dataForUpload); });
	    webgl_util.callAndCheck(gl, debug, function () { return gl.bindTexture(gl.TEXTURE_2D, null); });
	}
	exports.uploadDenseMatrixToTexture = uploadDenseMatrixToTexture;
	function uploadPixelDataToTexture(gl, debug, texture, pixels) {
	    webgl_util.callAndCheck(gl, debug, function () { return gl.bindTexture(gl.TEXTURE_2D, texture); });
	    if (pixels.data instanceof Uint8Array) {
	        webgl_util.callAndCheck(gl, debug, function () { return gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, pixels.width, pixels.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, pixels.data); });
	    }
	    else {
	        webgl_util.callAndCheck(gl, debug, function () { return gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, pixels); });
	    }
	    webgl_util.callAndCheck(gl, debug, function () { return gl.bindTexture(gl.TEXTURE_2D, null); });
	}
	exports.uploadPixelDataToTexture = uploadPixelDataToTexture;
	function createBufferFromOutputTexture(gl2, debug, rows, columns, textureConfig) {
	    // Create and bind the buffer.
	    var buffer = gl2.createBuffer();
	    webgl_util.callAndCheck(gl2, debug, function () { return gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, buffer); });
	    // Initialize the buffer to the size of the texture in bytes.
	    var bytesPerFloat = 4;
	    var valuesPerTexel = 4;
	    var bufferSizeBytes = bytesPerFloat * valuesPerTexel * rows * columns;
	    webgl_util.callAndCheck(gl2, debug, function () { return gl2.bufferData(gl2.PIXEL_PACK_BUFFER, bufferSizeBytes, gl2.STREAM_READ); });
	    // Enqueue a command on the GPU command queue to copy of texture into the
	    // buffer.
	    webgl_util.callAndCheck(gl2, debug, function () { return gl2.readPixels(0, 0, columns, rows, gl2.RGBA, gl2.FLOAT, 0); });
	    webgl_util.callAndCheck(gl2, debug, function () { return gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, null); });
	    return buffer;
	}
	exports.createBufferFromOutputTexture = createBufferFromOutputTexture;
	function downloadFloat32MatrixFromBuffer(gl, buffer, size) {
	    var gl2 = gl;
	    var downloadTarget = new Float32Array(size);
	    gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, buffer);
	    gl2.getBufferSubData(gl2.PIXEL_PACK_BUFFER, 0, downloadTarget);
	    gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, null);
	    return downloadTarget;
	}
	exports.downloadFloat32MatrixFromBuffer = downloadFloat32MatrixFromBuffer;
	function downloadByteEncodedFloatMatrixFromOutputTexture(gl, debug, rows, columns, textureConfig) {
	    var _a = tex_util.getUnpackedMatrixTextureShapeWidthHeight(rows, columns), w = _a[0], h = _a[1];
	    var numChannels = 4;
	    var downloadTarget = new Uint8Array(tex_util.getUnpackedArraySizeFromMatrixSize(rows * columns, numChannels));
	    webgl_util.callAndCheck(gl, debug, function () { return gl.readPixels(0, 0, w, h, textureConfig.downloadTextureFormat, gl.UNSIGNED_BYTE, downloadTarget); });
	    // By wrapping the buffer in a Float32Array, we use native browser IEEE 754
	    // decoding of the 4 bytes that back each 32 bit float.
	    return new Float32Array(downloadTarget.buffer);
	}
	exports.downloadByteEncodedFloatMatrixFromOutputTexture = downloadByteEncodedFloatMatrixFromOutputTexture;
	function downloadPackedMatrixFromBuffer(gl, buffer, batch, rows, cols, physicalRows, physicalCols, textureConfig) {
	    var gl2 = gl;
	    var downloadTarget = new Float32Array(tex_util.getPackedRGBAArraySizeFromMatrixShape(physicalRows, physicalCols));
	    gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, buffer);
	    gl2.getBufferSubData(gl2.PIXEL_PACK_BUFFER, 0, downloadTarget);
	    gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, null);
	    return downloadTarget;
	}
	exports.downloadPackedMatrixFromBuffer = downloadPackedMatrixFromBuffer;
	function downloadMatrixFromPackedOutputTexture(gl, debug, physicalRows, physicalCols) {
	    var packedRGBA = new Float32Array(physicalRows * physicalCols * 4);
	    webgl_util.callAndCheck(gl, debug, function () { return gl.readPixels(0, 0, physicalCols, physicalRows, gl.RGBA, gl.FLOAT, packedRGBA); });
	    return packedRGBA;
	}
	exports.downloadMatrixFromPackedOutputTexture = downloadMatrixFromPackedOutputTexture;
	//# sourceMappingURL=gpgpu_util.js.map

/***/ },
/* 483 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.LINEAR = "return x;";
	exports.LOG = "\n  vec4 result = log(x);\n  vec4 isNaN = vec4(lessThan(x, vec4(0.0)));\n  result.r = isNaN.r == 1.0 ? NAN : result.r;\n  result.g = isNaN.g == 1.0 ? NAN : result.g;\n  result.b = isNaN.b == 1.0 ? NAN : result.b;\n  result.a = isNaN.a == 1.0 ? NAN : result.a;\n\n  return result;\n";
	exports.RELU = "\n  vec4 result = x * vec4(greaterThanEqual(x, vec4(0.0)));\n  bvec4 isNaN = isnan(x);\n\n  result.r = isNaN.r ? x.r : result.r;\n  result.g = isNaN.g ? x.g : result.g;\n  result.b = isNaN.b ? x.b : result.b;\n  result.a = isNaN.a ? x.a : result.a;\n\n  return result;\n";
	exports.RELU6 = "\n  vec4 result = min(x, vec4(6.)) * vec4(greaterThanEqual(x, vec4(0.0)));\n  bvec4 isNaN = isnan(x);\n\n  result.r = isNaN.r ? x.r : result.r;\n  result.g = isNaN.g ? x.g : result.g;\n  result.b = isNaN.b ? x.b : result.b;\n  result.a = isNaN.a ? x.a : result.a;\n\n  return result;\n";
	exports.ELU = "\n  vec4 result;\n\n  result.r = (x.r >= 0.0) ? x.r : (exp(x.r) - 1.0);\n  result.g = (x.g >= 0.0) ? x.g : (exp(x.g) - 1.0);\n  result.b = (x.b >= 0.0) ? x.b : (exp(x.b) - 1.0);\n  result.a = (x.a >= 0.0) ? x.a : (exp(x.a) - 1.0);\n\n  return result;\n";
	var UnaryOpPackedProgram = /** @class */ (function () {
	    function UnaryOpPackedProgram(aShape, opSnippet) {
	        this.variableNames = ['A'];
	        this.packedInputs = true;
	        this.packedOutput = true;
	        this.outputShape = aShape;
	        this.userCode = "\n      vec4 unaryOperation(vec4 x) {\n        " + opSnippet + "\n      }\n\n      void main() {\n        vec4 x = getAAtOutCoords();\n        vec4 y = unaryOperation(x);\n\n        setOutput(y);\n      }\n    ";
	    }
	    return UnaryOpPackedProgram;
	}());
	exports.UnaryOpPackedProgram = UnaryOpPackedProgram;
	//# sourceMappingURL=unaryop_packed_gpu.js.map

/***/ },
/* 484 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/* Type definitions for exporting and importing of models. */
	/**
	 * A map from Tensor dtype to number of bytes per element of the Tensor.
	 */
	exports.DTYPE_VALUE_SIZE_MAP = {
	    'float32': 4,
	    'int32': 4,
	    'uint16': 2,
	    'uint8': 1,
	    'bool': 1,
	};
	//# sourceMappingURL=types.js.map

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var environment_1 = __webpack_require__(28);
	var util = __webpack_require__(10);
	var io_utils_1 = __webpack_require__(150);
	var progress_1 = __webpack_require__(1045);
	var types_1 = __webpack_require__(484);
	/**
	 * Reads binary weights data from a number of URLs.
	 *
	 * @param fetchURLs URLs to send the HTTP requests at, using `fetch` calls.
	 * @param requestOptions RequestInit (options) for the HTTP requests.
	 * @param fetchFunc Optional overriding value for the `window.fetch` function.
	 * @param onProgress Optional, progress callback function, fired periodically
	 *   before the load is completed.
	 * @returns A `Promise` of an Array of `ArrayBuffer`. The Array has the same
	 *   length as `fetchURLs`.
	 */
	function loadWeightsAsArrayBuffer(fetchURLs, loadOptions) {
	    return __awaiter(this, void 0, void 0, function () {
	        var fetchFunc, requests, fetchStartFraction, fetchEndFraction, responses, _a, bufferPromises, bufferStartFraction, bufferEndFraction, buffers, _b;
	        return __generator(this, function (_c) {
	            switch (_c.label) {
	                case 0:
	                    if (loadOptions == null) {
	                        loadOptions = {};
	                    }
	                    fetchFunc = loadOptions.fetchFunc == null ? environment_1.env().platform.fetch :
	                        loadOptions.fetchFunc;
	                    requests = fetchURLs.map(function (fetchURL) {
	                        return fetchFunc(fetchURL, loadOptions.requestInit, { isBinary: true });
	                    });
	                    fetchStartFraction = 0;
	                    fetchEndFraction = 0.5;
	                    if (!(loadOptions.onProgress == null)) return [3 /*break*/, 2];
	                    return [4 /*yield*/, Promise.all(requests)];
	                case 1:
	                    _a = _c.sent();
	                    return [3 /*break*/, 4];
	                case 2: return [4 /*yield*/, progress_1.monitorPromisesProgress(requests, loadOptions.onProgress, fetchStartFraction, fetchEndFraction)];
	                case 3:
	                    _a = _c.sent();
	                    _c.label = 4;
	                case 4:
	                    responses = _a;
	                    bufferPromises = responses.map(function (response) { return response.arrayBuffer(); });
	                    bufferStartFraction = 0.5;
	                    bufferEndFraction = 1;
	                    if (!(loadOptions.onProgress == null)) return [3 /*break*/, 6];
	                    return [4 /*yield*/, Promise.all(bufferPromises)];
	                case 5:
	                    _b = _c.sent();
	                    return [3 /*break*/, 8];
	                case 6: return [4 /*yield*/, progress_1.monitorPromisesProgress(bufferPromises, loadOptions.onProgress, bufferStartFraction, bufferEndFraction)];
	                case 7:
	                    _b = _c.sent();
	                    _c.label = 8;
	                case 8:
	                    buffers = _b;
	                    return [2 /*return*/, buffers];
	            }
	        });
	    });
	}
	exports.loadWeightsAsArrayBuffer = loadWeightsAsArrayBuffer;
	/**
	 * Reads a weights manifest JSON configuration, fetches the weights and
	 * returns them as `Tensor`s.
	 *
	 * @param manifest The weights manifest JSON.
	 * @param filePathPrefix The path prefix for filenames given in the manifest.
	 *     Defaults to the empty string.
	 * @param weightNames The names of the weights to be fetched.
	 */
	function loadWeights(manifest, filePathPrefix, weightNames, requestInit) {
	    if (filePathPrefix === void 0) { filePathPrefix = ''; }
	    return __awaiter(this, void 0, void 0, function () {
	        var fetchWeights, loadWeights;
	        return __generator(this, function (_a) {
	            fetchWeights = function (fetchUrls) {
	                return loadWeightsAsArrayBuffer(fetchUrls, { requestInit: requestInit });
	            };
	            loadWeights = weightsLoaderFactory(fetchWeights);
	            return [2 /*return*/, loadWeights(manifest, filePathPrefix, weightNames)];
	        });
	    });
	}
	exports.loadWeights = loadWeights;
	/**
	 * Creates a function, which reads a weights manifest JSON configuration,
	 * fetches the weight files using the specified function and returns them as
	 * `Tensor`s.
	 *
	 * ```js
	 * // example for creating a nodejs weight loader, which reads the weight files
	 * // from disk using fs.readFileSync
	 *
	 * import * as fs from 'fs'
	 *
	 * const fetchWeightsFromDisk = (filePaths: string[]) =>
	 *   filePaths.map(filePath => fs.readFileSync(filePath).buffer)
	 *
	 * const loadWeights = tf.io.weightsLoaderFactory(fetchWeightsFromDisk)
	 *
	 * const manifest = JSON.parse(
	 *   fs.readFileSync('./my_model-weights_manifest').toString()
	 * )
	 * const weightMap = await loadWeights(manifest, './')
	 * ```
	 * @param fetchWeightsFunction The function used for fetching the weight files.
	 * @returns Weight loading function.
	 */
	function weightsLoaderFactory(fetchWeightsFunction) {
	    var _this = this;
	    return function (manifest, filePathPrefix, weightNames) {
	        if (filePathPrefix === void 0) { filePathPrefix = ''; }
	        return __awaiter(_this, void 0, void 0, function () {
	            var groupIndicesToFetchMap, groupWeightsToFetch, weightsFound, allManifestWeightNames, weightsNotFound, groupIndicesToFetch, fetchUrls, buffers, weightsTensorMap, bufferIndexOffset;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        groupIndicesToFetchMap = manifest.map(function () { return false; });
	                        groupWeightsToFetch = {};
	                        weightsFound = weightNames != null ? weightNames.map(function () { return false; }) : [];
	                        allManifestWeightNames = [];
	                        manifest.forEach(function (manifestGroupConfig, groupIndex) {
	                            var groupOffset = 0;
	                            manifestGroupConfig.weights.forEach(function (weightsEntry) {
	                                var rawDtype = ('quantization' in weightsEntry) ?
	                                    weightsEntry.quantization.dtype :
	                                    weightsEntry.dtype;
	                                var weightsBytes = types_1.DTYPE_VALUE_SIZE_MAP[rawDtype] *
	                                    util.sizeFromShape(weightsEntry.shape);
	                                var enqueueWeightsForFetchingFn = function () {
	                                    groupIndicesToFetchMap[groupIndex] = true;
	                                    if (groupWeightsToFetch[groupIndex] == null) {
	                                        groupWeightsToFetch[groupIndex] = [];
	                                    }
	                                    groupWeightsToFetch[groupIndex].push({
	                                        manifestEntry: weightsEntry,
	                                        groupOffset: groupOffset,
	                                        sizeBytes: weightsBytes
	                                    });
	                                };
	                                if (weightNames != null) {
	                                    weightNames.forEach(function (weightName, weightIndex) {
	                                        if (weightName === weightsEntry.name) {
	                                            enqueueWeightsForFetchingFn();
	                                            weightsFound[weightIndex] = true;
	                                        }
	                                    });
	                                }
	                                else {
	                                    enqueueWeightsForFetchingFn();
	                                }
	                                allManifestWeightNames.push(weightsEntry.name);
	                                groupOffset += weightsBytes;
	                            });
	                        });
	                        if (!weightsFound.every(function (found) { return found; })) {
	                            weightsNotFound = weightNames.filter(function (_, i) { return !weightsFound[i]; });
	                            throw new Error("Could not find weights in manifest with names: " +
	                                (weightsNotFound.join(', ') + ". \n") +
	                                "Manifest JSON has weights with names: " +
	                                (allManifestWeightNames.join(', ') + "."));
	                        }
	                        groupIndicesToFetch = groupIndicesToFetchMap.reduce(function (accumulator, shouldFetch, i) {
	                            if (shouldFetch) {
	                                accumulator.push(i);
	                            }
	                            return accumulator;
	                        }, []);
	                        fetchUrls = [];
	                        groupIndicesToFetch.forEach(function (i) {
	                            manifest[i].paths.forEach(function (filepath) {
	                                var fetchUrl = filePathPrefix +
	                                    (!filePathPrefix.endsWith('/') ? '/' : '') + filepath;
	                                fetchUrls.push(fetchUrl);
	                            });
	                        });
	                        return [4 /*yield*/, fetchWeightsFunction(fetchUrls)];
	                    case 1:
	                        buffers = _a.sent();
	                        weightsTensorMap = {};
	                        bufferIndexOffset = 0;
	                        groupIndicesToFetch.forEach(function (i) {
	                            var numBuffers = manifest[i].paths.length;
	                            var groupBytes = 0;
	                            for (var i_1 = 0; i_1 < numBuffers; i_1++) {
	                                groupBytes += buffers[bufferIndexOffset + i_1].byteLength;
	                            }
	                            // Create a buffer for the whole group.
	                            var groupBuffer = new ArrayBuffer(groupBytes);
	                            var groupByteBuffer = new Uint8Array(groupBuffer);
	                            var groupBufferOffset = 0;
	                            for (var i_2 = 0; i_2 < numBuffers; i_2++) {
	                                var buffer = new Uint8Array(buffers[bufferIndexOffset + i_2]);
	                                groupByteBuffer.set(buffer, groupBufferOffset);
	                                groupBufferOffset += buffer.byteLength;
	                            }
	                            var weightsEntries = groupWeightsToFetch[i];
	                            weightsEntries.forEach(function (weightsEntry) {
	                                var byteBuffer = groupBuffer.slice(weightsEntry.groupOffset, weightsEntry.groupOffset + weightsEntry.sizeBytes);
	                                var nameToTensorMap = io_utils_1.decodeWeights(byteBuffer, [weightsEntry.manifestEntry]);
	                                for (var name_1 in nameToTensorMap) {
	                                    weightsTensorMap[name_1] = nameToTensorMap[name_1];
	                                }
	                            });
	                            bufferIndexOffset += numBuffers;
	                        });
	                        return [2 /*return*/, weightsTensorMap];
	                }
	            });
	        });
	    };
	}
	exports.weightsLoaderFactory = weightsLoaderFactory;
	//# sourceMappingURL=weights_loader.js.map

/***/ },
/* 486 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Gets the new shape of the input Tensor after it's been reshaped
	 * to:
	 * [blockShape[0], ..., blockShape[M-1], batch / prod(blockShape),
	 * inputShape[1], ..., inputShape[N-1]]
	 *
	 * See step 1: https://www.tensorflow.org/api_docs/python/tf/batch_to_space_nd
	 */
	function getReshaped(inputShape, blockShape, prod, batchToSpace) {
	    if (batchToSpace === void 0) { batchToSpace = true; }
	    var reshaped = [];
	    if (batchToSpace) {
	        reshaped = reshaped.concat(blockShape.slice(0));
	        reshaped.push(inputShape[0] / prod);
	        reshaped = reshaped.concat(inputShape.slice(1));
	    }
	    else {
	        reshaped = reshaped.concat(inputShape[0]);
	        var spatialLength = blockShape.length;
	        for (var i = 0; i < spatialLength; ++i) {
	            reshaped =
	                reshaped.concat([inputShape[i + 1] / blockShape[i], blockShape[i]]);
	        }
	        reshaped = reshaped.concat(inputShape.slice(spatialLength + 1));
	    }
	    return reshaped;
	}
	exports.getReshaped = getReshaped;
	/**
	 * Gets the permutation that will transpose the dimensions of the
	 * reshaped tensor to shape:
	 *
	 * [batch / prod(block_shape),inputShape[1], blockShape[0], ...,
	 * inputShape[M], blockShape[M-1],inputShape[M+1], ..., inputShape[N-1]]
	 *
	 * see step 2: https://www.tensorflow.org/api_docs/python/tf/batch_to_space_nd
	 */
	function getPermuted(reshapedRank, blockShapeRank, batchToSpace) {
	    if (batchToSpace === void 0) { batchToSpace = true; }
	    var permuted = [];
	    if (batchToSpace) {
	        permuted.push(blockShapeRank);
	        for (var i = blockShapeRank + 1; i < reshapedRank; ++i) {
	            if (i <= 2 * blockShapeRank) {
	                permuted.push(i);
	                permuted.push(i - (blockShapeRank + 1));
	            }
	            else {
	                permuted.push(i);
	            }
	        }
	    }
	    else {
	        var permutedBeforeBatch = [];
	        var permutedAfterBatch = [];
	        for (var i = 1; i < reshapedRank; ++i) {
	            if (i >= blockShapeRank * 2 + 1 || i % 2 === 1) {
	                permutedAfterBatch.push(i);
	            }
	            else {
	                permutedBeforeBatch.push(i);
	            }
	        }
	        permuted.push.apply(permuted, permutedBeforeBatch);
	        permuted.push(0);
	        permuted.push.apply(permuted, permutedAfterBatch);
	    }
	    return permuted;
	}
	exports.getPermuted = getPermuted;
	/**
	 * Gets the shape of the reshaped and permuted input Tensor before any cropping
	 * is applied.  The new shape will be:
	 *
	 * [batch / prod(blockShape),inputShape[1] * blockShape[0], ...,
	 * inputShape[M] * blockShape[M-1],inputShape[M+1], ..., inputShape[N-1]]
	 *
	 * See step 3: https://www.tensorflow.org/api_docs/python/tf/batch_to_space_nd
	 */
	function getReshapedPermuted(inputShape, blockShape, prod, batchToSpace) {
	    if (batchToSpace === void 0) { batchToSpace = true; }
	    var reshapedPermuted = [];
	    if (batchToSpace) {
	        reshapedPermuted.push(inputShape[0] / prod);
	    }
	    else {
	        reshapedPermuted.push(inputShape[0] * prod);
	    }
	    for (var i = 1; i < inputShape.length; ++i) {
	        if (i <= blockShape.length) {
	            if (batchToSpace) {
	                reshapedPermuted.push(blockShape[i - 1] * inputShape[i]);
	            }
	            else {
	                reshapedPermuted.push(inputShape[i] / blockShape[i - 1]);
	            }
	        }
	        else {
	            reshapedPermuted.push(inputShape[i]);
	        }
	    }
	    return reshapedPermuted;
	}
	exports.getReshapedPermuted = getReshapedPermuted;
	/**
	 * Converts the crops argument into the beginning coordinates of a slice
	 * operation.
	 */
	function getSliceBeginCoords(crops, blockShape) {
	    var sliceBeginCoords = [0];
	    for (var i = 0; i < blockShape; ++i) {
	        sliceBeginCoords.push(crops[i][0]);
	    }
	    return sliceBeginCoords;
	}
	exports.getSliceBeginCoords = getSliceBeginCoords;
	/**
	 * Converts the crops argument into the size of a slice operation.  When
	 * combined with getSliceBeginCoords this function allows the reshaped and
	 * permuted Tensor to be cropped to its final output shape of:
	 *
	 * inputShape[1] * blockShape[0] - crops[0,0] - crops[0,1], ...,
	 * inputShape[M] * blockShape[M-1] -crops[M-1,0] -
	 * crops[M-1,1],inputShape[M+1], ..., inputShape[N-1]]
	 *
	 * See step 4: https://www.tensorflow.org/api_docs/python/tf/batch_to_space_nd
	 */
	function getSliceSize(uncroppedShape, crops, blockShape) {
	    var sliceSize = uncroppedShape.slice(0, 1);
	    for (var i = 0; i < blockShape; ++i) {
	        sliceSize.push(uncroppedShape[i + 1] - crops[i][0] - crops[i][1]);
	    }
	    return sliceSize;
	}
	exports.getSliceSize = getSliceSize;
	//# sourceMappingURL=array_ops_util.js.map

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_util_1 = __webpack_require__(111);
	var tensor_util_env_1 = __webpack_require__(17);
	var util_1 = __webpack_require__(10);
	var broadcast_util_1 = __webpack_require__(57);
	var operation_1 = __webpack_require__(18);
	var tensor_ops_1 = __webpack_require__(31);
	/**
	 * Returns the truth value of (a != b) element-wise. Supports broadcasting.
	 *
	 * We also expose `tf.notEqualStrict` which has the same signature as this op
	 * and asserts that `a` and `b` are the same shape (does not broadcast).
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 2, 3]);
	 * const b = tf.tensor1d([0, 2, 3]);
	 *
	 * a.notEqual(b).print();
	 * ```
	 * @param a The first input tensor.
	 * @param b The second input tensor. Must have the same dtype as `a`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Logical'} */
	function notEqual_(a, b) {
	    var _a;
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'notEqual');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'notEqual');
	    _a = tensor_util_1.makeTypesMatch($a, $b), $a = _a[0], $b = _a[1];
	    broadcast_util_1.assertAndGetBroadcastShape($a.shape, $b.shape);
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.notEqual($a, $b); }, { a: $a, b: $b }, null /* grad */, 'NotEqual');
	}
	/**
	 * Strict version of `tf.notEqual` that forces `a` and `b` to be of the same
	 * shape.
	 *
	 * @param a The first input tensor.
	 * @param b The second input tensor. Must have the same shape and dtype as
	 *     `a`.
	 */
	function notEqualStrict_(a, b) {
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'notEqualStrict');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'notEqualStrict');
	    util_1.assertShapesMatch($a.shape, $b.shape, 'Error in notEqualStrict: ');
	    return $a.notEqual($b);
	}
	/**
	 * Returns the truth value of (a < b) element-wise. Supports broadcasting.
	 *
	 * We also expose `tf.lessStrict` which has the same signature as this op and
	 * asserts that `a` and `b` are the same shape (does not broadcast).
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 2, 3]);
	 * const b = tf.tensor1d([2, 2, 2]);
	 *
	 * a.less(b).print();
	 * ```
	 * @param a The first input tensor.
	 * @param b The second input tensor. Must have the same dtype as `a`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Logical'} */
	function less_(a, b) {
	    var _a;
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'less');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'less');
	    _a = tensor_util_1.makeTypesMatch($a, $b), $a = _a[0], $b = _a[1];
	    broadcast_util_1.assertAndGetBroadcastShape($a.shape, $b.shape);
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.less($a, $b); }, { a: $a, b: $b }, null /* grad */, 'Less');
	}
	/**
	 * Strict version of `tf.less` that forces `a` and `b` to be of the same
	 * shape.
	 *
	 * @param a The first input tensor.
	 * @param b The second input tensor. Must have the same shape and dtype as
	 *     `a`.
	 */
	function lessStrict_(a, b) {
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'lessStrict');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'lessStrict');
	    util_1.assertShapesMatch($a.shape, $b.shape, 'Error in lessStrict: ');
	    return $a.less($b);
	}
	/**
	 * Returns the truth value of (a == b) element-wise. Supports broadcasting.
	 *
	 * We also expose `tf.equalStrict` which has the same signature as this op
	 * and asserts that `a` and `b` are the same shape (does not broadcast).
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 2, 3]);
	 * const b = tf.tensor1d([2, 2, 2]);
	 *
	 * a.equal(b).print();
	 * ```
	 *
	 * @param a The first input tensor.
	 * @param b The second input tensor. Must have the same dtype as `a`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Logical'} */
	function equal_(a, b) {
	    var _a;
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'equal');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'equal');
	    _a = tensor_util_1.makeTypesMatch($a, $b), $a = _a[0], $b = _a[1];
	    broadcast_util_1.assertAndGetBroadcastShape($a.shape, $b.shape);
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.equal($a, $b); }, { $a: $a, $b: $b });
	}
	function equalStrict_(a, b) {
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'equalStrict');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'equalStrict');
	    util_1.assertShapesMatch($a.shape, $b.shape, 'Error in equalStrict: ');
	    return $a.equal($b);
	}
	/**
	 * Returns the truth value of (a <= b) element-wise. Supports broadcasting.
	 *
	 * We also expose `tf.lessEqualStrict` which has the same signature as this op
	 * and asserts that `a` and `b` are the same shape (does not broadcast).
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 2, 3]);
	 * const b = tf.tensor1d([2, 2, 2]);
	 *
	 * a.lessEqual(b).print();
	 * ```
	 *
	 * @param a The first input tensor.
	 * @param b The second input tensor. Must have the same dtype as `a`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Logical'} */
	function lessEqual_(a, b) {
	    var _a;
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'lessEqual');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'lessEqual');
	    _a = tensor_util_1.makeTypesMatch($a, $b), $a = _a[0], $b = _a[1];
	    broadcast_util_1.assertAndGetBroadcastShape($a.shape, $b.shape);
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.lessEqual($a, $b);
	        save([$a, $b]);
	        return res;
	    }, { a: $a, b: $b }, null /* grad */, 'LessEqual');
	}
	function lessEqualStrict_(a, b) {
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'lessEqualStrict');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'lessEqualStrict');
	    util_1.assertShapesMatch($a.shape, $b.shape, 'Error in lessEqualStrict: ');
	    return $a.lessEqual($b);
	}
	/**
	 * Returns the truth value of (a > b) element-wise. Supports broadcasting.
	 *
	 * We also expose `tf.greaterStrict` which has the same signature as this
	 * op and asserts that `a` and `b` are the same shape (does not broadcast).
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 2, 3]);
	 * const b = tf.tensor1d([2, 2, 2]);
	 *
	 * a.greater(b).print();
	 * ```
	 *
	 * @param a The first input tensor.
	 * @param b The second input tensor. Must have the same dtype as `a`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Logical'} */
	function greater_(a, b) {
	    var _a;
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'greater');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'greater');
	    _a = tensor_util_1.makeTypesMatch($a, $b), $a = _a[0], $b = _a[1];
	    broadcast_util_1.assertAndGetBroadcastShape($a.shape, $b.shape);
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.greater($a, $b); }, { a: $a, b: $b }, null /* grad */, 'Greater');
	}
	function greaterStrict_(a, b) {
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'greaterStrict');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'greaterStrict');
	    util_1.assertShapesMatch($a.shape, $b.shape, 'Error in greaterStrict: ');
	    return $a.greater($b);
	}
	/**
	 * Returns the truth value of (a >= b) element-wise. Supports broadcasting.
	 *
	 * We also expose `tf.greaterEqualStrict` which has the same signature as this
	 * op and asserts that `a` and `b` are the same shape (does not broadcast).
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 2, 3]);
	 * const b = tf.tensor1d([2, 2, 2]);
	 *
	 * a.greaterEqual(b).print();
	 * ```
	 *
	 * @param a The first input tensor.
	 * @param b The second input tensor. Must have the same dtype as `a`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Logical'} */
	function greaterEqual_(a, b) {
	    var _a;
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'greaterEqual');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'greaterEqual');
	    _a = tensor_util_1.makeTypesMatch($a, $b), $a = _a[0], $b = _a[1];
	    broadcast_util_1.assertAndGetBroadcastShape($a.shape, $b.shape);
	    var grad = function (dy, saved) {
	        var $a = saved[0], $b = saved[1];
	        return { a: function () { return tensor_ops_1.zerosLike($a); }, b: function () { return tensor_ops_1.zerosLike($b); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.greaterEqual($a, $b);
	        save([$a, $b]);
	        return res;
	    }, { a: $a, b: $b }, grad, 'GreaterEqual');
	}
	function greaterEqualStrict_(a, b) {
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'greaterEqualStrict');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'greaterEqualStrict');
	    util_1.assertShapesMatch($a.shape, $b.shape, 'Error in greaterEqualStrict: ');
	    return $a.greaterEqual($b);
	}
	exports.equal = operation_1.op({ equal_: equal_ });
	exports.equalStrict = operation_1.op({ equalStrict_: equalStrict_ });
	exports.greater = operation_1.op({ greater_: greater_ });
	exports.greaterEqual = operation_1.op({ greaterEqual_: greaterEqual_ });
	exports.greaterEqualStrict = operation_1.op({ greaterEqualStrict_: greaterEqualStrict_ });
	exports.greaterStrict = operation_1.op({ greaterStrict_: greaterStrict_ });
	exports.less = operation_1.op({ less_: less_ });
	exports.lessEqual = operation_1.op({ lessEqual_: lessEqual_ });
	exports.lessEqualStrict = operation_1.op({ lessEqualStrict_: lessEqualStrict_ });
	exports.lessStrict = operation_1.op({ lessStrict_: lessStrict_ });
	exports.notEqual = operation_1.op({ notEqual_: notEqual_ });
	exports.notEqualStrict = operation_1.op({ notEqualStrict_: notEqualStrict_ });
	//# sourceMappingURL=compare.js.map

/***/ },
/* 488 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ERF_P = 0.3275911;
	exports.ERF_A1 = 0.254829592;
	exports.ERF_A2 = -0.284496736;
	exports.ERF_A3 = 1.421413741;
	exports.ERF_A4 = -1.453152027;
	exports.ERF_A5 = 1.061405429;
	//# sourceMappingURL=erf_util.js.map

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var gradients_1 = __webpack_require__(190);
	var tensor_util_env_1 = __webpack_require__(17);
	var util_1 = __webpack_require__(10);
	var axis_util_1 = __webpack_require__(108);
	var binary_ops_1 = __webpack_require__(109);
	var operation_1 = __webpack_require__(18);
	var tensor_ops_1 = __webpack_require__(31);
	var Reduction;
	(function (Reduction) {
	    Reduction[Reduction["NONE"] = 0] = "NONE";
	    Reduction[Reduction["MEAN"] = 1] = "MEAN";
	    Reduction[Reduction["SUM"] = 2] = "SUM";
	    Reduction[Reduction["SUM_BY_NONZERO_WEIGHTS"] = 3] = "SUM_BY_NONZERO_WEIGHTS";
	})(Reduction = exports.Reduction || (exports.Reduction = {}));
	/**
	 * Computes the weighted loss between two tensors.
	 *
	 * @param losses Tensor of shape `[batch_size, d1, ... dN]`.
	 * @param weights Tensor whose rank is either 0, or the same rank as
	 *    `losses`, and must be broadcastable to `losses` (i.e., all
	 *    dimensions must be either `1`, or the same as the corresponding
	 *    `losses` dimension).
	 */
	/** @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'} */
	function computeWeightedLoss_(losses, weights, reduction) {
	    if (reduction === void 0) { reduction = Reduction.SUM_BY_NONZERO_WEIGHTS; }
	    var $losses = tensor_util_env_1.convertToTensor(losses, 'losses', 'computeWeightedLoss');
	    var $weights = null;
	    if (weights != null) {
	        $weights = tensor_util_env_1.convertToTensor(weights, 'weights', 'computeWeightedLoss');
	    }
	    var weightedLoss = ($weights == null) ? $losses : $losses.mul($weights);
	    if (reduction === Reduction.NONE) {
	        return weightedLoss;
	    }
	    if (reduction === Reduction.SUM) {
	        return weightedLoss.sum();
	    }
	    if (reduction === Reduction.MEAN) {
	        if ($weights == null) {
	            return weightedLoss.mean();
	        }
	        else {
	            var broadcastFactor = $losses.size / $weights.size;
	            var result = weightedLoss.sum().div($weights.sum());
	            return broadcastFactor > 1 ? result.div(tensor_ops_1.scalar(broadcastFactor)) :
	                result;
	        }
	    }
	    if (reduction === Reduction.SUM_BY_NONZERO_WEIGHTS) {
	        if ($weights == null) {
	            return weightedLoss.sum().div(tensor_ops_1.scalar($losses.size));
	        }
	        else {
	            var broadcastedWeights = $weights.mul(tensor_ops_1.ones($losses.shape));
	            var numNonZeros = broadcastedWeights.notEqual(tensor_ops_1.scalar(0)).sum().toFloat();
	            return weightedLoss.sum().div(numNonZeros);
	        }
	    }
	    throw Error("Unknown reduction: " + reduction);
	}
	/**
	 * Computes the absolute difference loss between two tensors.
	 *
	 * @param labels The ground truth output tensor, same dimensions as
	 *    'predictions'.
	 * @param predictions The predicted outputs.
	 * @param weights Tensor whose rank is either 0, or the same rank as
	 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
	 *    must be either `1`, or the same as the corresponding `losses`
	 *    dimension).
	 * @param reduction Type of reduction to apply to loss. Should be of type
	 *    `Reduction`
	 */
	/** @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'} */
	function absoluteDifference_(labels, predictions, weights, reduction) {
	    if (reduction === void 0) { reduction = Reduction.SUM_BY_NONZERO_WEIGHTS; }
	    var $labels = tensor_util_env_1.convertToTensor(labels, 'labels', 'absoluteDifference');
	    var $predictions = tensor_util_env_1.convertToTensor(predictions, 'predictions', 'absoluteDifference');
	    var $weights = null;
	    if (weights != null) {
	        $weights = tensor_util_env_1.convertToTensor(weights, 'weights', 'absoluteDifference');
	    }
	    util_1.assertShapesMatch($labels.shape, $predictions.shape, 'Error in absoluteDifference: ');
	    var losses = $labels.sub($predictions).abs();
	    return exports.computeWeightedLoss(losses, $weights, reduction);
	}
	/**
	 * Computes the mean squared error between two tensors.
	 *
	 * @param labels The ground truth output tensor, same dimensions as
	 *    'predictions'.
	 * @param predictions The predicted outputs.
	 * @param weights Tensor whose rank is either 0, or the same rank as
	 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
	 *    must be either `1`, or the same as the corresponding `losses`
	 *    dimension).
	 * @param reduction Type of reduction to apply to loss. Should be of type
	 *    `Reduction`
	 */
	/** @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'} */
	function meanSquaredError_(labels, predictions, weights, reduction) {
	    if (reduction === void 0) { reduction = Reduction.SUM_BY_NONZERO_WEIGHTS; }
	    var $labels = tensor_util_env_1.convertToTensor(labels, 'labels', 'meanSquaredError');
	    var $predictions = tensor_util_env_1.convertToTensor(predictions, 'predictions', 'meanSquaredError');
	    var $weights = null;
	    if (weights != null) {
	        $weights = tensor_util_env_1.convertToTensor(weights, 'weights', 'meanSquaredError');
	    }
	    util_1.assertShapesMatch($labels.shape, $predictions.shape, 'Error in meanSquaredError: ');
	    var losses = $labels.squaredDifference($predictions);
	    return exports.computeWeightedLoss(losses, $weights, reduction);
	}
	/**
	 * Computes the cosine distance loss between two tensors.
	 *
	 * @param labels The ground truth output tensor, same dimensions as
	 *    'predictions'.
	 * @param predictions The predicted outputs.
	 * @param axis The dimension along which the cosine distance is computed.
	 * @param weights Tensor whose rank is either 0, or the same rank as
	 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
	 *    must be either `1`, or the same as the corresponding `losses`
	 *    dimension).
	 * @param reduction Type of reduction to apply to loss. Should be of type
	 *    `Reduction`
	 */
	/** @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'} */
	function cosineDistance_(labels, predictions, axis, weights, reduction) {
	    if (reduction === void 0) { reduction = Reduction.SUM_BY_NONZERO_WEIGHTS; }
	    var $labels = tensor_util_env_1.convertToTensor(labels, 'labels', 'cosineDistance');
	    var $predictions = tensor_util_env_1.convertToTensor(predictions, 'predictions', 'cosineDistance');
	    var $weights = null;
	    if (weights != null) {
	        $weights = tensor_util_env_1.convertToTensor(weights, 'weights', 'cosineDistance');
	    }
	    util_1.assertShapesMatch($labels.shape, $predictions.shape, 'Error in cosineDistance: ');
	    var one = tensor_ops_1.scalar(1);
	    var losses = one.sub($labels.mul($predictions).sum(axis, true));
	    return exports.computeWeightedLoss(losses, $weights, reduction);
	}
	/**
	 * Computes the Hinge loss between two tensors.
	 *
	 * @param labels The ground truth output tensor, same dimensions as
	 *    'predictions'.
	 * @param predictions The predicted outputs.
	 * @param weights Tensor whose rank is either 0, or the same rank as
	 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
	 *    must be either `1`, or the same as the corresponding `losses`
	 *    dimension).
	 * @param reduction Type of reduction to apply to loss. Should be of type
	 *    `Reduction`
	 */
	/** @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'} */
	function hingeLoss_(labels, predictions, weights, reduction) {
	    if (reduction === void 0) { reduction = Reduction.SUM_BY_NONZERO_WEIGHTS; }
	    var $labels = tensor_util_env_1.convertToTensor(labels, 'labels', 'hingeLoss');
	    var $predictions = tensor_util_env_1.convertToTensor(predictions, 'predictions', 'hingeLoss');
	    var $weights = null;
	    if (weights != null) {
	        $weights = tensor_util_env_1.convertToTensor(weights, 'weights', 'hingeLoss');
	    }
	    util_1.assertShapesMatch($labels.shape, $predictions.shape, 'Error in hingeLoss: ');
	    var one = tensor_ops_1.scalar(1);
	    // Convert binary labels to (-1, 1)
	    $labels = tensor_ops_1.scalar(2).mul($labels).sub(one);
	    var losses = one.sub($labels.mul($predictions)).relu();
	    return exports.computeWeightedLoss(losses, $weights, reduction);
	}
	/**
	 * Computes the log loss between two tensors.
	 *
	 * @param labels The ground truth output tensor, same dimensions as
	 *    'predictions'.
	 * @param predictions The predicted outputs.
	 * @param weights Tensor whose rank is either 0, or the same rank as
	 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
	 *    must be either `1`, or the same as the corresponding `losses`
	 *    dimension).
	 * @param epsilon A small increment to avoid taking log of zero
	 * @param reduction Type of reduction to apply to loss. Should be of type
	 *    `Reduction`
	 */
	/** @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'} */
	function logLoss_(labels, predictions, weights, epsilon, reduction) {
	    if (epsilon === void 0) { epsilon = 1e-7; }
	    if (reduction === void 0) { reduction = Reduction.SUM_BY_NONZERO_WEIGHTS; }
	    var $labels = tensor_util_env_1.convertToTensor(labels, 'labels', 'logLoss');
	    var $predictions = tensor_util_env_1.convertToTensor(predictions, 'predictions', 'logLoss');
	    var $weights = null;
	    if (weights != null) {
	        $weights = tensor_util_env_1.convertToTensor(weights, 'weights', 'logLoss');
	    }
	    util_1.assertShapesMatch($labels.shape, $predictions.shape, 'Error in logLoss: ');
	    var one = tensor_ops_1.scalar(1);
	    var epsilonScalar = tensor_ops_1.scalar(epsilon);
	    var losses = $labels.mul($predictions.add(epsilonScalar).log())
	        .neg()
	        .sub(one.sub($labels).mul(one.sub($predictions).add(epsilonScalar).log()));
	    return exports.computeWeightedLoss(losses, $weights, reduction);
	}
	function sigmoidCrossEntropyWithLogits_(labels, logits) {
	    var $labels = tensor_util_env_1.convertToTensor(labels, 'labels', 'sigmoidCrossEntropyWithLogits');
	    var $logits = tensor_util_env_1.convertToTensor(logits, 'logits', 'sigmoidCrossEntropyWithLogits');
	    util_1.assertShapesMatch($labels.shape, $logits.shape, 'Error in sigmoidCrossEntropyWithLogits: ');
	    /**
	     * Implementation Details:
	     *
	     * For brevity, let `x = logits`, `z = labels`.  The logistic loss is
	     *     z * -log(sigmoid(x)) + (1 - z) * -log(1 - sigmoid(x))
	     *   = z * -log(1 / (1 + exp(-x))) + (1 - z) * -log(exp(-x) / (1 + exp(-x)))
	     *   = z * log(1 + exp(-x)) + (1 - z) * (-log(exp(-x)) + log(1 + exp(-x)))
	     *   = z * log(1 + exp(-x)) + (1 - z) * (x + log(1 + exp(-x))
	     *   = (1 - z) * x + log(1 + exp(-x))
	     *   = x - x * z + log(1 + exp(-x))
	     *
	     *   For x < 0, to avoid overflow in exp(-x), we reformulate the above
	     *     x - x * z + log(1 + exp(-x))
	     *   = log(exp(x)) - x * z + log(1 + exp(-x))
	     *   = - x * z + log(1 + exp(x))
	     *
	     * Hence, to ensure stability and avoid overflow, the implementation uses
	     * this equivalent formulation:
	     *     max(x, 0) - x * z + log(1 + exp(-abs(x)))
	     */
	    var maxOutput = $logits.relu();
	    var outputXTarget = $logits.mul($labels);
	    var sigmoidOutput = $logits.abs().neg().exp().log1p();
	    return maxOutput.sub(outputXTarget).add(sigmoidOutput);
	}
	/**
	 * Computes the sigmoid cross entropy loss between two tensors.
	 *
	 * If labelSmoothing is nonzero, smooth the labels towards 1/2:
	 *
	 *   newMulticlassLabels = multiclassLabels * (1 - labelSmoothing)
	 *                         + 0.5 * labelSmoothing
	 *
	 * @param multiClassLabels The ground truth output tensor of shape
	 * [batch_size, num_classes], same dimensions as 'predictions'.
	 * @param logits The predicted outputs.
	 * @param weights Tensor whose rank is either 0, or the same rank as
	 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
	 *    must be either `1`, or the same as the corresponding `losses`
	 *    dimension).
	 * @param labelSmoothing If greater than 0, then smooth the labels.
	 * @param reduction Type of reduction to apply to loss. Should be of type
	 *    `Reduction`
	 */
	/** @doc { heading: 'Training', subheading: 'Losses', namespace: 'losses' } */
	function sigmoidCrossEntropy_(multiClassLabels, logits, weights, labelSmoothing, reduction) {
	    if (labelSmoothing === void 0) { labelSmoothing = 0; }
	    if (reduction === void 0) { reduction = Reduction.SUM_BY_NONZERO_WEIGHTS; }
	    var $multiClassLabels = tensor_util_env_1.convertToTensor(multiClassLabels, 'multiClassLabels', 'sigmoidCrossEntropy');
	    var $logits = tensor_util_env_1.convertToTensor(logits, 'logits', 'sigmoidCrossEntropy');
	    var $weights = null;
	    if (weights != null) {
	        $weights = tensor_util_env_1.convertToTensor(weights, 'weights', 'sigmoidCrossEntropy');
	    }
	    util_1.assertShapesMatch($multiClassLabels.shape, $logits.shape, 'Error in sigmoidCrossEntropy: ');
	    if (labelSmoothing > 0) {
	        var labelSmoothingScalar = tensor_ops_1.scalar(labelSmoothing);
	        var one = tensor_ops_1.scalar(1);
	        var half = tensor_ops_1.scalar(0.5);
	        $multiClassLabels = $multiClassLabels.mul(one.sub(labelSmoothingScalar))
	            .add(half.mul(labelSmoothingScalar));
	    }
	    var losses = sigmoidCrossEntropyWithLogits_($multiClassLabels, $logits);
	    return exports.computeWeightedLoss(losses, $weights, reduction);
	}
	/**
	 * Computes the huber loss between two tensors.
	 *
	 * @param labels The ground truth output tensor, same dimensions as
	 *    'predictions'.
	 * @param predictions The predicted outputs.
	 * @param weights Tensor whose rank is either 0, or the same rank as
	 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
	 *    must be either `1`, or the same as the corresponding `losses`
	 *    dimension).
	 * @param delta Point where huber loss changes from quadratic to linear.
	 * @param reduction Type of reduction to apply to loss. Should be of type
	 *    `Reduction`.
	 */
	/** @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'} */
	function huberLoss_(labels, predictions, weights, delta, reduction) {
	    if (delta === void 0) { delta = 1.0; }
	    if (reduction === void 0) { reduction = Reduction.SUM_BY_NONZERO_WEIGHTS; }
	    var $labels = tensor_util_env_1.convertToTensor(labels, 'labels', 'huberLoss');
	    var $predictions = tensor_util_env_1.convertToTensor(predictions, 'predictions', 'huberLoss');
	    var $weights = null;
	    if (weights != null) {
	        $weights = tensor_util_env_1.convertToTensor(weights, 'weights', 'huberLoss');
	    }
	    util_1.assertShapesMatch($labels.shape, $predictions.shape, 'Error in huberLoss: ');
	    var deltaScalar = tensor_ops_1.scalar(delta);
	    var error = $predictions.sub($labels).abs();
	    var quadratic = binary_ops_1.minimum(error, deltaScalar);
	    var linear = error.sub(quadratic);
	    var losses = tensor_ops_1.scalar(0.5).mul(quadratic.square()).add(deltaScalar.mul(linear));
	    return exports.computeWeightedLoss(losses, $weights, reduction);
	}
	/**
	 * Computes softmax cross entropy between logits and labels.
	 *
	 * Measures the probability error in discrete classification tasks in which
	 * the classes are mutually exclusive (each entry is in exactly one class).
	 * For example, each CIFAR-10 image is labeled with one and only one label: an
	 * image can be a dog or a truck, but not both.
	 *
	 * `NOTE`: While the classes are mutually exclusive, their probabilities need
	 * not be. All that is required is that each row of labels is a valid
	 * probability distribution. If they are not, the computation of the gradient
	 * will be incorrect.
	 *
	 * `WARNING`: This op expects unscaled logits, since it performs a softmax on
	 * logits internally for efficiency. Do not call this op with the output of
	 * softmax, as it will produce incorrect results.
	 *
	 * logits and labels must have the same shape, e.g. [batch_size, num_classes]
	 * and the same dtype.
	 * @param labels The labels array.
	 * @param logits The logits array.
	 * @param dim The dimension softmax would be performed on. Defaults to `-1`
	 *     which indicates the last dimension.
	 */
	function softmaxCrossEntropyWithLogits_(labels, logits, dim) {
	    if (dim === void 0) { dim = -1; }
	    if (dim === -1) {
	        dim = logits.rank - 1;
	    }
	    if (dim !== logits.rank - 1) {
	        throw Error("Softmax cross entropy along a non-last dimension is not yet " +
	            ("supported. Labels / logits was rank " + logits.rank + " ") +
	            ("and dim was " + dim));
	    }
	    // Use a custom gradient for numerical stability.
	    var customOp = gradients_1.customGrad(function (labels, logits, save) {
	        // Reference:
	        //   1. http://cs231n.github.io/linear-classify/#softmax
	        //   2. https://blog.feedly.com/tricks-of-the-trade-logsumexp/
	        var keepDims = true;
	        var lse = logits.logSumExp([dim], keepDims);
	        var logResult = logits.toFloat().sub(lse);
	        save([labels, logResult]);
	        var costVector = logResult.mul(labels).neg();
	        var value = costVector.sum([dim]);
	        var gradFunc = function (dy, saved) {
	            var labels = saved[0], logResult = saved[1];
	            var dyShape = axis_util_1.expandShapeToKeepDim(dy.shape, [dim]);
	            return [
	                dy.reshape(dyShape).mul(labels.toFloat().sub(logResult.exp())),
	                dy.reshape(dyShape).mul(logResult.exp().sub(labels.toFloat())),
	            ];
	        };
	        return { value: value, gradFunc: gradFunc };
	    });
	    return customOp(labels, logits);
	}
	/**
	 * Computes the softmax cross entropy loss between two tensors.
	 *
	 * If labelSmoothing is nonzero, smooth the labels towards 1/2:
	 *
	 *   newOnehotLabels = onehotLabels * (1 - labelSmoothing)
	 *                         + labelSmoothing / numClasses
	 *
	 * @param onehotLabels One hot encoded labels
	 *    [batch_size, num_classes], same dimensions as 'predictions'.
	 * @param logits The predicted outputs.
	 * @param weights Tensor whose rank is either 0, or 1, and must be
	 *    broadcastable to `loss`  of shape [batch_size]
	 * @param labelSmoothing If greater than 0, then smooth the labels.
	 * @param reduction Type of reduction to apply to loss. Should be of type
	 *    `Reduction`
	 */
	/** @doc { heading: 'Training', subheading: 'Losses', namespace: 'losses' } */
	function softmaxCrossEntropy_(onehotLabels, logits, weights, labelSmoothing, reduction) {
	    if (labelSmoothing === void 0) { labelSmoothing = 0; }
	    if (reduction === void 0) { reduction = Reduction.SUM_BY_NONZERO_WEIGHTS; }
	    var $onehotLabels = tensor_util_env_1.convertToTensor(onehotLabels, 'onehotLabels', 'softmaxCrossEntropy');
	    var $logits = tensor_util_env_1.convertToTensor(logits, 'logits', 'softmaxCrossEntropy');
	    var $weights = null;
	    if (weights != null) {
	        $weights = tensor_util_env_1.convertToTensor(weights, 'weights', 'softmaxCrossEntropy');
	    }
	    util_1.assertShapesMatch($onehotLabels.shape, $logits.shape, 'Error in softmaxCrossEntropy: ');
	    if (labelSmoothing > 0) {
	        var labelSmoothingScalar = tensor_ops_1.scalar(labelSmoothing);
	        var one = tensor_ops_1.scalar(1);
	        var numClasses = tensor_ops_1.scalar($onehotLabels.shape[1]);
	        $onehotLabels = $onehotLabels.mul(one.sub(labelSmoothingScalar))
	            .add(labelSmoothingScalar.div(numClasses));
	    }
	    var losses = softmaxCrossEntropyWithLogits_($onehotLabels, $logits);
	    return exports.computeWeightedLoss(losses, $weights, reduction);
	}
	exports.absoluteDifference = operation_1.op({ absoluteDifference_: absoluteDifference_ });
	exports.computeWeightedLoss = operation_1.op({ computeWeightedLoss_: computeWeightedLoss_ });
	exports.cosineDistance = operation_1.op({ cosineDistance_: cosineDistance_ });
	exports.hingeLoss = operation_1.op({ hingeLoss_: hingeLoss_ });
	exports.huberLoss = operation_1.op({ huberLoss_: huberLoss_ });
	exports.logLoss = operation_1.op({ logLoss_: logLoss_ });
	exports.meanSquaredError = operation_1.op({ meanSquaredError_: meanSquaredError_ });
	exports.sigmoidCrossEntropy = operation_1.op({ sigmoidCrossEntropy_: sigmoidCrossEntropy_ });
	exports.softmaxCrossEntropy = operation_1.op({ softmaxCrossEntropy_: softmaxCrossEntropy_ });
	//# sourceMappingURL=loss_ops.js.map

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_util_1 = __webpack_require__(111);
	var tensor_util_env_1 = __webpack_require__(17);
	var util = __webpack_require__(10);
	var operation_1 = __webpack_require__(18);
	/**
	 * Computes the dot product of two matrices, A * B. These must be matrices.
	 *
	 * ```js
	 * const a = tf.tensor2d([1, 2], [1, 2]);
	 * const b = tf.tensor2d([1, 2, 3, 4], [2, 2]);
	 *
	 * a.matMul(b).print();  // or tf.matMul(a, b)
	 * ```
	 * @param a First matrix in dot product operation.
	 * @param b Second matrix in dot product operation.
	 * @param transposeA If true, `a` is transposed before multiplication.
	 * @param transposeB If true, `b` is transposed before multiplication.
	 */
	/** @doc {heading: 'Operations', subheading: 'Matrices'} */
	function matMul_(a, b, transposeA, transposeB) {
	    var _a;
	    if (transposeA === void 0) { transposeA = false; }
	    if (transposeB === void 0) { transposeB = false; }
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'matMul');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'matMul');
	    _a = tensor_util_1.makeTypesMatch($a, $b), $a = _a[0], $b = _a[1];
	    var innerShapeA = transposeA ? $a.shape[$a.rank - 2] : $a.shape[$a.rank - 1];
	    var innerShapeB = transposeB ? $b.shape[$b.rank - 1] : $b.shape[$b.rank - 2];
	    var outerShapeA = transposeA ? $a.shape[$a.rank - 1] : $a.shape[$a.rank - 2];
	    var outerShapeB = transposeB ? $b.shape[$b.rank - 2] : $b.shape[$b.rank - 1];
	    var outerDimsA = $a.shape.slice(0, -2);
	    var outerDimsB = $b.shape.slice(0, -2);
	    var batchDimA = util.sizeFromShape(outerDimsA);
	    var batchDimB = util.sizeFromShape(outerDimsB);
	    util.assert($a.rank >= 2 && $b.rank >= 2 && $a.rank === $b.rank, function () { return "Error in matMul: inputs must have the same rank of at least 2, " +
	        ("got ranks " + $a.rank + " and " + $b.rank + "."); });
	    util.assert(util.arraysEqual(outerDimsA, outerDimsB), function () { return "Error in matMul: outer dimensions (" + outerDimsA + ") and (" +
	        (outerDimsB + ") of Tensors with shapes " + $a.shape + " and ") +
	        ($b.shape + " must match."); });
	    util.assert(innerShapeA === innerShapeB, function () { return "Error in matMul: inner shapes (" + innerShapeA + ") and (" +
	        (innerShapeB + ") of Tensors with shapes " + $a.shape + " and ") +
	        ($b.shape + " and transposeA=" + transposeA) +
	        (" and transposeB=" + transposeB + " must match."); });
	    var outShape = $a.shape.slice(0, -2).concat([outerShapeA, outerShapeB]);
	    var a3D = transposeA ? $a.as3D(batchDimA, innerShapeA, outerShapeA) :
	        $a.as3D(batchDimA, outerShapeA, innerShapeA);
	    var b3D = transposeB ? $b.as3D(batchDimB, outerShapeB, innerShapeB) :
	        $b.as3D(batchDimB, innerShapeB, outerShapeB);
	    var grad = function (dy, saved) {
	        var _a = saved, a3D = _a[0], b3D = _a[1];
	        if (!transposeA && !transposeB) {
	            return {
	                a: function () { return dy.matMul(b3D, false, true); },
	                b: function () { return a3D.matMul(dy, true, false); }
	            };
	        }
	        else if (!transposeA && transposeB) {
	            return {
	                a: function () { return dy.matMul(b3D, false, false); },
	                b: function () { return dy.matMul(a3D, true, false); }
	            };
	        }
	        else if (transposeA && !transposeB) {
	            return {
	                a: function () { return b3D.matMul(dy, false, true); },
	                b: function () { return a3D.matMul(dy, false, false); }
	            };
	        }
	        else {
	            return {
	                a: function () { return b3D.matMul(dy, true, true); },
	                b: function () { return dy.matMul(a3D, true, true); }
	            };
	        }
	    };
	    var attrs = { transposeA: transposeA, transposeB: transposeB };
	    var res = engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.batchMatMul(a3D, b3D, transposeA, transposeB);
	        save([a3D, b3D]);
	        return res;
	    }, { a: a3D, b: b3D }, grad, 'BatchMatMul', attrs);
	    return res.reshape(outShape);
	}
	/**
	 * Computes the outer product of two vectors, `v1` and `v2`.
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 2, 3]);
	 * const b = tf.tensor1d([3, 4, 5]);
	 *
	 * tf.outerProduct(a, b).print();
	 * ```
	 * @param v1 The first vector in the outer product operation.
	 * @param v2 The second vector in the outer product operation.
	 */
	/** @doc {heading: 'Operations', subheading: 'Matrices'} */
	function outerProduct_(v1, v2) {
	    var $v1 = tensor_util_env_1.convertToTensor(v1, 'v1', 'outerProduct');
	    var $v2 = tensor_util_env_1.convertToTensor(v2, 'v2', 'outerProduct');
	    util.assert($v1.rank === 1 && $v2.rank === 1, function () { return "Error in outerProduct: inputs must be rank 1, but got ranks " +
	        ($v1.rank + " and " + $v2.rank + "."); });
	    return $v1.as2D(-1, 1).matMul($v2.as2D(1, -1));
	}
	/**
	 * Computes the dot product of two matrices and/or vectors, `t1` and `t2`.
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 2]);
	 * const b = tf.tensor2d([[1, 2], [3, 4]]);
	 * const c = tf.tensor2d([[1, 2, 3], [4, 5, 6]]);
	 *
	 * a.dot(b).print();  // or tf.dot(a, b)
	 * b.dot(a).print();
	 * b.dot(c).print();
	 * ```
	 * @param t1 The first tensor in the dot operation.
	 * @param t2 The second tensor in the dot operation.
	 */
	/** @doc {heading: 'Operations', subheading: 'Matrices'} */
	function dot_(t1, t2) {
	    var $t1 = tensor_util_env_1.convertToTensor(t1, 't1', 'dot');
	    var $t2 = tensor_util_env_1.convertToTensor(t2, 't2', 'dot');
	    util.assert(($t1.rank === 1 || $t1.rank === 2) && ($t2.rank === 1 || $t2.rank === 2), function () { return "Error in dot: inputs must all be rank 1 or 2, but got ranks " +
	        ($t1.rank + " and " + $t2.rank + "."); });
	    var t1Inner = ($t1.rank === 1 ? $t1.size : $t1.shape[1]);
	    var t2Inner = ($t2.rank === 1 ? $t2.size : $t2.shape[0]);
	    util.assert(t1Inner === t2Inner, function () { return "Error in dot: inner dimensions of inputs must match, but got " +
	        (t1Inner + " and " + t2Inner + "."); });
	    if ($t1.rank === 1 && $t2.rank === 1) {
	        return $t1.as2D(1, -1).matMul($t2.as2D(-1, 1)).asScalar();
	    }
	    else if ($t1.rank === 1 && $t2.rank === 2) {
	        return $t1.as2D(1, -1).matMul($t2.as2D($t2.shape[0], $t2.shape[1])).as1D();
	    }
	    else if ($t1.rank === 2 && $t2.rank === 1) {
	        return $t1.matMul($t2.as2D(-1, 1)).as1D();
	    }
	    else {
	        return $t1.matMul($t2.as2D($t2.shape[0], $t2.shape[1]));
	    }
	}
	exports.matMul = operation_1.op({ matMul_: matMul_ });
	exports.dot = operation_1.op({ dot_: dot_ });
	exports.outerProduct = operation_1.op({ outerProduct_: outerProduct_ });
	//# sourceMappingURL=matmul.js.map

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tensor_util_env_1 = __webpack_require__(17);
	var util_1 = __webpack_require__(10);
	var axis_util = __webpack_require__(108);
	var operation_1 = __webpack_require__(18);
	var tensor_ops_1 = __webpack_require__(31);
	/**
	 * Computes the norm of scalar, vectors, and matrices.
	 * This function can compute several different vector norms (the 1-norm, the
	 * Euclidean or 2-norm, the inf-norm, and in general the p-norm for p > 0)
	 * and matrix norms (Frobenius, 1-norm, and inf-norm).
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, 3, 4]);
	 *
	 * x.norm().print();  // or tf.norm(x)
	 * ```
	 *
	 * @param x The input array.
	 * @param ord Optional. Order of the norm. Supported norm types are
	 * following:
	 *
	 *  | ord        | norm for matrices         | norm for vectors
	 *  |------------|---------------------------|---------------------
	 *  |'euclidean' |Frobenius norm             |2-norm
	 *  |'fro'       |Frobenius norm	           |
	 *  |Infinity    |max(sum(abs(x), axis=1))   |max(abs(x))
	 *  |-Infinity   |min(sum(abs(x), axis=1))   |min(abs(x))
	 *  |1           |max(sum(abs(x), axis=0))   |sum(abs(x))
	 *  |2           |                           |sum(abs(x)^2)^1/2*
	 *
	 * @param axis Optional. If axis is null (the default), the input is
	 * considered a vector and a single vector norm is computed over the entire
	 * set of values in the Tensor, i.e. norm(x, ord) is equivalent
	 * to norm(x.reshape([-1]), ord). If axis is a integer, the input
	 * is considered a batch of vectors, and axis determines the axis in x
	 * over which to compute vector norms. If axis is a 2-tuple of integer it is
	 * considered a batch of matrices and axis determines the axes in NDArray
	 * over which to compute a matrix norm.
	 * @param keepDims Optional. If true, the norm have the same dimensionality
	 * as the input.
	 */
	/** @doc {heading: 'Operations', subheading: 'Matrices'} */
	function norm_(x, ord, axis, keepDims) {
	    if (ord === void 0) { ord = 'euclidean'; }
	    if (axis === void 0) { axis = null; }
	    if (keepDims === void 0) { keepDims = false; }
	    x = tensor_util_env_1.convertToTensor(x, 'x', 'norm');
	    var norm = normImpl(x, ord, axis);
	    var keepDimsShape = norm.shape;
	    if (keepDims) {
	        var axes = util_1.parseAxisParam(axis, x.shape);
	        keepDimsShape = axis_util.expandShapeToKeepDim(norm.shape, axes);
	    }
	    return norm.reshape(keepDimsShape);
	}
	function normImpl(x, p, axis) {
	    if (axis === void 0) { axis = null; }
	    if (x.rank === 0) {
	        return x.abs();
	    }
	    // consider vector when no axis is specified
	    if (x.rank !== 1 && axis === null) {
	        return normImpl(x.reshape([-1]), p, axis);
	    }
	    // vector
	    if (x.rank === 1 || typeof axis === 'number' ||
	        Array.isArray(axis) && axis.length === 1) {
	        if (p === 1) {
	            return x.abs().sum(axis);
	        }
	        if (p === Infinity) {
	            return x.abs().max(axis);
	        }
	        if (p === -Infinity) {
	            return x.abs().min(axis);
	        }
	        if (p === 'euclidean' || p === 2) {
	            // norm(x, 2) = sum(abs(xi) ^ 2) ^ 1/2
	            return x.abs().pow(tensor_ops_1.scalar(2, 'int32')).sum(axis).sqrt();
	        }
	        throw new Error("Error in norm: invalid ord value: " + p);
	    }
	    // matrix (assumption axis[0] < axis[1])
	    if (Array.isArray(axis) && axis.length === 2) {
	        if (p === 1) {
	            return x.abs().sum(axis[0]).max(axis[1] - 1);
	        }
	        if (p === Infinity) {
	            return x.abs().sum(axis[1]).max(axis[0]);
	        }
	        if (p === -Infinity) {
	            return x.abs().sum(axis[1]).min(axis[0]);
	        }
	        if (p === 'fro' || p === 'euclidean') {
	            // norm(x) = sqrt(sum(pow(x, 2)))
	            return x.square().sum(axis).sqrt();
	        }
	        throw new Error("Error in norm: invalid ord value: " + p);
	    }
	    throw new Error("Error in norm: invalid axis: " + axis);
	}
	exports.norm = operation_1.op({ norm_: norm_ });
	//# sourceMappingURL=norm.js.map

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var gradients_1 = __webpack_require__(190);
	var tensor_util_env_1 = __webpack_require__(17);
	var util = __webpack_require__(10);
	var axis_util = __webpack_require__(108);
	var operation_1 = __webpack_require__(18);
	var tensor_ops_1 = __webpack_require__(31);
	/**
	 * Computes the log(sum(exp(elements across the reduction dimensions)).
	 *
	 * Reduces the input along the dimensions given in `axis`. Unless `keepDims`
	 * is true, the rank of the array is reduced by 1 for each entry in `axis`.
	 * If `keepDims` is true, the reduced dimensions are retained with length 1.
	 * If `axis` has no entries, all dimensions are reduced, and an array with a
	 * single element is returned.
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, 3]);
	 *
	 * x.logSumExp().print();  // or tf.logSumExp(x)
	 * ```
	 *
	 * ```js
	 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
	 *
	 * const axis = 1;
	 * x.logSumExp(axis).print();  // or tf.logSumExp(a, axis)
	 * ```
	 * @param x The input tensor.
	 * @param axis The dimension(s) to reduce. If null (the default),
	 *     reduces all dimensions.
	 * @param keepDims If true, retains reduced dimensions with length
	 *     of 1. Defaults to false.
	 */
	/** @doc {heading: 'Operations', subheading: 'Reduction'} */
	function logSumExp_(x, axis, keepDims) {
	    if (axis === void 0) { axis = null; }
	    if (keepDims === void 0) { keepDims = false; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'logSumExp');
	    var axes = util.parseAxisParam(axis, $x.shape);
	    var xMax = $x.max(axes, true /* keepDims */);
	    var a = $x.sub(xMax);
	    var b = a.exp();
	    var c = b.sum(axes);
	    var d = c.log();
	    var res = xMax.reshape(d.shape).add(d);
	    if (keepDims) {
	        var newShape = axis_util.expandShapeToKeepDim(res.shape, axes);
	        return res.reshape(newShape);
	    }
	    return res;
	}
	/**
	 * Computes the sum of elements across dimensions of a `tf.Tensor`.
	 *
	 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
	 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
	 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
	 * length 1. If axes has no entries, all dimensions are reduced, and a
	 * `tf.Tensor` with a single element is returned.
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, 3]);
	 *
	 * x.sum().print();  // or tf.sum(x)
	 * ```
	 *
	 * ```js
	 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
	 *
	 * const axis = 1;
	 * x.sum(axis).print();  // or tf.sum(x, axis)
	 * ```
	 *
	 * @param x The input tensor to compute the sum over. If the dtype is `bool`
	 *   it will be converted to `int32` and the output dtype will be `int32`.
	 * @param axis The dimension(s) to reduce. By default it reduces
	 *     all dimensions.
	 * @param keepDims If true, retains reduced dimensions with size 1.
	 */
	/** @doc {heading: 'Operations', subheading: 'Reduction'} */
	function sum_(x, axis, keepDims) {
	    if (axis === void 0) { axis = null; }
	    if (keepDims === void 0) { keepDims = false; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'sum');
	    if ($x.dtype === 'bool') {
	        $x = $x.toInt();
	    }
	    var axes = util.parseAxisParam(axis, $x.shape);
	    // Use a custom gradient to bypass 2 gradient backprops since sum is used
	    // extremely often.
	    var customOp = gradients_1.customGrad(function (x) {
	        var permutation = axis_util.getAxesPermutation(axes, x.rank);
	        var reductionAxes = axes;
	        var permutedX = x;
	        if (permutation != null) {
	            permutedX = x.transpose(permutation);
	            reductionAxes = axis_util.getInnerMostAxes(reductionAxes.length, x.rank);
	        }
	        var gradFunc = function (dy) {
	            var expandedDyShape = x.shape.slice();
	            axes.forEach(function (axis) {
	                expandedDyShape[axis] = 1;
	            });
	            var expandedDy = dy.reshape(expandedDyShape);
	            var derX = expandedDy.mul(tensor_ops_1.ones(x.shape, 'float32'));
	            return derX;
	        };
	        var gradInputs = function (dy) {
	            return { x: function () { return gradFunc(dy); } };
	        };
	        var attrs = { axes: reductionAxes };
	        var value = engine_1.ENGINE.runKernelFunc(function (backend) { return backend.sum(permutedX, reductionAxes); }, { x: permutedX }, gradInputs, 'Sum', attrs);
	        if (keepDims) {
	            var newShape = axis_util.expandShapeToKeepDim(value.shape, axes);
	            value = value.reshape(newShape);
	        }
	        return { value: value, gradFunc: gradFunc };
	    });
	    return customOp($x);
	}
	/**
	 * Computes the product of elements across dimensions of a `tf.Tensor`.
	 *
	 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
	 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
	 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
	 * length 1. If `axes` has no entries, all dimensions are reduced, and a
	 * `tf.Tensor` with a single element is returned.
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, 3]);
	 *
	 * x.prod().print();  // or tf.prod(x)
	 * ```
	 *
	 * ```js
	 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
	 *
	 * const axis = 1;
	 * x.prod(axis).print();  // or tf.prod(x, axis)
	 * ```
	 *
	 * @param x The input tensor to compute the product over. If the dtype is `bool`
	 *   it will be converted to `int32` and the output dtype will be `int32`.
	 * @param axis The dimension(s) to reduce. By default it reduces
	 *     all dimensions.
	 * @param keepDims If true, retains reduced dimensions with size 1.
	 */
	/** @doc {heading: 'Operations', subheading: 'Reduction'} */
	function prod_(x, axis, keepDims) {
	    if (axis === void 0) { axis = null; }
	    if (keepDims === void 0) { keepDims = false; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'prod');
	    if ($x.dtype === 'bool') {
	        $x = $x.toInt();
	    }
	    var axes = util.parseAxisParam(axis, $x.shape);
	    var permutation = axis_util.getAxesPermutation(axes, $x.rank);
	    var reductionAxes = axes;
	    var permutedX = $x;
	    if (permutation != null) {
	        permutedX = $x.transpose(permutation);
	        reductionAxes = axis_util.getInnerMostAxes(reductionAxes.length, $x.rank);
	    }
	    var value = engine_1.ENGINE.runKernelFunc(function (backend) { return backend.prod(permutedX, reductionAxes); }, { permutedX: permutedX });
	    if (keepDims) {
	        var newShape = axis_util.expandShapeToKeepDim(value.shape, axes);
	        value = value.reshape(newShape);
	    }
	    return value;
	}
	/**
	 * Computes the mean of elements across dimensions of a `tf.Tensor`.
	 *
	 * Reduces `x` along the dimensions given in `axis`. Unless `keepDims` is
	 * true, the rank of the `tf.Tensor` is reduced by 1 for each entry in `axis`.
	 * If `keepDims` is true, the reduced dimensions are retained with length 1.
	 * If `axis` has no entries, all dimensions are reduced, and a `tf.Tensor` with
	 * a single element is returned.
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, 3]);
	 *
	 * x.mean().print();  // or tf.mean(a)
	 * ```
	 *
	 * ```js
	 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
	 *
	 * const axis = 1;
	 * x.mean(axis).print();  // or tf.mean(x, axis)
	 * ```
	 *
	 * @param x The input tensor.
	 * @param axis The dimension(s) to reduce. By default it reduces
	 *     all dimensions.
	 * @param keepDims If true, retains reduced dimensions with size 1.
	 */
	/** @doc {heading: 'Operations', subheading: 'Reduction'} */
	function mean_(x, axis, keepDims) {
	    if (axis === void 0) { axis = null; }
	    if (keepDims === void 0) { keepDims = false; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'mean');
	    var axes = util.parseAxisParam(axis, $x.shape);
	    var shapes = axis_util.computeOutAndReduceShapes($x.shape, axes);
	    var reduceShape = shapes[1];
	    var reduceSize = util.sizeFromShape(reduceShape);
	    // Use a custom gradient to bypass 2 gradient backprops since mean is used
	    // extremely often.
	    var customOp = gradients_1.customGrad(function (x) {
	        var reduceSizeScalar = tensor_ops_1.scalar(reduceSize);
	        // Cast if needed.
	        var xReduce = reduceSizeScalar.dtype === x.dtype ? x : x.cast(reduceSizeScalar.dtype);
	        var res = xReduce.div(reduceSizeScalar);
	        var value = res.sum(axis, keepDims);
	        var gradFunc = function (dy) {
	            var expandedDyShape = x.shape.slice();
	            axes.forEach(function (axis) {
	                expandedDyShape[axis] = 1;
	            });
	            var expandedDy = dy.reshape(expandedDyShape);
	            var derX = expandedDy.mul(tensor_ops_1.ones(x.shape, 'float32')).div(reduceSize);
	            return derX;
	        };
	        return { value: value, gradFunc: gradFunc };
	    });
	    return customOp($x);
	}
	/**
	 * Gradient helper function for the min and max operations.
	 */
	function gradForMinAndMax(dy, y, xOrig, origAxes, permutedAxes) {
	    if (y.rank < xOrig.rank) {
	        y = y.reshape(axis_util.expandShapeToKeepDim(y.shape, origAxes));
	    }
	    if (dy.rank < xOrig.rank) {
	        dy = dy.reshape(axis_util.expandShapeToKeepDim(dy.shape, origAxes));
	    }
	    return {
	        x: function () {
	            var dx = dy.mul(xOrig.equal(y).cast(dy.dtype));
	            return permutedAxes == null ? dx : dx.transpose(permutedAxes);
	        }
	    };
	}
	/**
	 * Computes the minimum value from the input.
	 *
	 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
	 * is true, the rank of the array is reduced by 1 for each entry in `axes`.
	 * If `keepDims` is true, the reduced dimensions are retained with length 1.
	 * If `axes` has no entries, all dimensions are reduced, and an array with a
	 * single element is returned.
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, 3]);
	 *
	 * x.min().print();  // or tf.min(x)
	 * ```
	 *
	 * ```js
	 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
	 *
	 * const axis = 1;
	 * x.min(axis).print();  // or tf.min(x, axis)
	 * ```
	 *
	 * @param x The input Tensor.
	 * @param axis The dimension(s) to reduce. By default it reduces
	 *     all dimensions.
	 * @param keepDims If true, retains reduced dimensions with size 1.
	 */
	/** @doc {heading: 'Operations', subheading: 'Reduction'} */
	function min_(x, axis, keepDims) {
	    if (axis === void 0) { axis = null; }
	    if (keepDims === void 0) { keepDims = false; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'min');
	    var xOrig = $x;
	    var origAxes = util.parseAxisParam(axis, $x.shape);
	    var axes = origAxes;
	    var permutedAxes = axis_util.getAxesPermutation(axes, $x.rank);
	    if (permutedAxes != null) {
	        $x = $x.transpose(permutedAxes);
	        axes = axis_util.getInnerMostAxes(axes.length, $x.rank);
	    }
	    var grad = function (dy, saved) {
	        return gradForMinAndMax(dy, saved[1], saved[0], origAxes, permutedAxes);
	    };
	    var inputsToSave = [$x];
	    var outputsToSave = [true];
	    var res = engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var y = backend.min($x, axes);
	        save([xOrig, y]);
	        return y;
	    }, { x: $x }, grad, 'Min', { axes: axes }, inputsToSave, outputsToSave);
	    if (keepDims) {
	        var newShape = axis_util.expandShapeToKeepDim(res.shape, origAxes);
	        res = res.reshape(newShape);
	    }
	    return res;
	}
	/**
	 * Computes the maximum of elements across dimensions of a `tf.Tensor`.
	 *
	 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
	 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
	 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
	 * length 1. If `axes` has no entries, all dimensions are reduced, and an
	 * `tf.Tensor` with a single element is returned.
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, 3]);
	 *
	 * x.max().print();  // or tf.max(x)
	 * ```
	 *
	 * ```js
	 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
	 *
	 * const axis = 1;
	 * x.max(axis).print();  // or tf.max(x, axis)
	 * ```
	 *
	 * @param x The input tensor.
	 * @param axis The dimension(s) to reduce. By default it reduces
	 *     all dimensions.
	 * @param keepDims If true, retains reduced dimensions with size 1.
	 */
	/** @doc {heading: 'Operations', subheading: 'Reduction'} */
	function max_(x, axis, keepDims) {
	    if (axis === void 0) { axis = null; }
	    if (keepDims === void 0) { keepDims = false; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'max');
	    var xOrig = $x;
	    var origAxes = util.parseAxisParam(axis, $x.shape);
	    var axes = origAxes;
	    var permutedAxes = axis_util.getAxesPermutation(axes, $x.rank);
	    if (permutedAxes != null) {
	        $x = $x.transpose(permutedAxes);
	        axes = axis_util.getInnerMostAxes(axes.length, $x.rank);
	    }
	    var grad = function (dy, saved) {
	        return gradForMinAndMax(dy, saved[1], saved[0], origAxes, permutedAxes);
	    };
	    var inputsToSave = [$x];
	    var outputsToSave = [true];
	    var res = engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var y = backend.max($x, axes);
	        save([xOrig, y]);
	        return y;
	    }, { x: $x }, grad, 'Max', { axes: axes }, inputsToSave, outputsToSave);
	    if (keepDims) {
	        var newShape = axis_util.expandShapeToKeepDim(res.shape, origAxes);
	        res = res.reshape(newShape);
	    }
	    return res;
	}
	/**
	 * Returns the indices of the minimum values along an `axis`.
	 *
	 * The result has the same shape as `input` with the dimension along `axis`
	 * removed.
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, 3]);
	 *
	 * x.argMin().print();  // or tf.argMin(x)
	 * ```
	 *
	 * ```js
	 * const x = tf.tensor2d([1, 2, 4, 3], [2, 2]);
	 *
	 * const axis = 1;
	 * x.argMin(axis).print();  // or tf.argMin(x, axis)
	 * ```
	 *
	 * @param x The input tensor.
	 * @param axis The dimension to reduce. Defaults to 0 (outer-most dimension).
	 *
	 */
	/** @doc {heading: 'Operations', subheading: 'Reduction'} */
	function argMin_(x, axis) {
	    if (axis === void 0) { axis = 0; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'argMin');
	    if (axis == null) {
	        axis = 0;
	    }
	    var axes = util.parseAxisParam(axis, $x.shape);
	    var permutedAxes = axis_util.getAxesPermutation(axes, $x.rank);
	    if (permutedAxes != null) {
	        $x = $x.transpose(permutedAxes);
	        axes = axis_util.getInnerMostAxes(axes.length, $x.rank);
	    }
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return { $x: function () { return tensor_ops_1.zerosLike($x); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.argMin($x, axes[0]);
	        save([$x]);
	        return res;
	    }, { $x: $x }, grad);
	}
	/**
	 * Returns the indices of the maximum values along an `axis`.
	 *
	 * The result has the same shape as `input` with the dimension along `axis`
	 * removed.
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, 3]);
	 *
	 * x.argMax().print();  // or tf.argMax(x)
	 * ```
	 *
	 * ```js
	 * const x = tf.tensor2d([1, 2, 4, 3], [2, 2]);
	 *
	 * const axis = 1;
	 * x.argMax(axis).print();  // or tf.argMax(x, axis)
	 * ```
	 *
	 * @param x The input tensor.
	 * @param axis The dimension to reduce. Defaults to 0 (outer-most dimension).
	 */
	/** @doc {heading: 'Operations', subheading: 'Reduction'} */
	function argMax_(x, axis) {
	    if (axis === void 0) { axis = 0; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'argMax');
	    if (axis == null) {
	        axis = 0;
	    }
	    var axes = util.parseAxisParam(axis, $x.shape);
	    var permutedAxes = axis_util.getAxesPermutation(axes, $x.rank);
	    if (permutedAxes != null) {
	        $x = $x.transpose(permutedAxes);
	        axes = axis_util.getInnerMostAxes(axes.length, $x.rank);
	    }
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return { x: function () { return tensor_ops_1.zerosLike($x); } };
	    };
	    var attrs = { axis: axes[0] };
	    var inputsToSave = [$x];
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.argMax($x, axes[0]);
	        save([$x]);
	        return res;
	    }, { x: $x }, grad, 'ArgMax', attrs, inputsToSave);
	}
	/**
	 * Computes the logical and of elements across dimensions of a `tf.Tensor`.
	 *
	 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
	 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
	 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
	 * length 1. If `axes` has no entries, all dimensions are reduced, and an
	 * `tf.Tensor` with a single element is returned.
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 1, 1], 'bool');
	 *
	 * x.all().print();  // or tf.all(x)
	 * ```
	 *
	 * ```js
	 * const x = tf.tensor2d([1, 1, 0, 0], [2, 2], 'bool');
	 *
	 * const axis = 1;
	 * x.all(axis).print();  // or tf.all(x, axis)
	 * ```
	 *
	 * @param x The input tensor. Must be of dtype bool.
	 * @param axis The dimension(s) to reduce. By default it reduces
	 *     all dimensions.
	 * @param keepDims If true, retains reduced dimensions with size 1.
	 */
	/** @doc {heading: 'Operations', subheading: 'Reduction'} */
	function all_(x, axis, keepDims) {
	    if (axis === void 0) { axis = null; }
	    if (keepDims === void 0) { keepDims = false; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'all', 'bool');
	    var origAxes = util.parseAxisParam(axis, $x.shape);
	    var axes = origAxes;
	    var permutedAxes = axis_util.getAxesPermutation(axes, $x.rank);
	    if (permutedAxes != null) {
	        $x = $x.transpose(permutedAxes);
	        axes = axis_util.getInnerMostAxes(axes.length, $x.rank);
	    }
	    var res = engine_1.ENGINE.runKernelFunc(function (backend) { return backend.all($x, axes); }, { $x: $x });
	    if (keepDims) {
	        var newShape = axis_util.expandShapeToKeepDim(res.shape, origAxes);
	        return res.reshape(newShape);
	    }
	    return res;
	}
	/**
	 * Computes the logical or of elements across dimensions of a `tf.Tensor`.
	 *
	 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
	 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
	 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
	 * length 1. If `axes` has no entries, all dimensions are reduced, and an
	 * `tf.Tensor` with a single element is returned.
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 1, 1], 'bool');
	 *
	 * x.any().print();  // or tf.any(x)
	 * ```
	 *
	 * ```js
	 * const x = tf.tensor2d([1, 1, 0, 0], [2, 2], 'bool');
	 *
	 * const axis = 1;
	 * x.any(axis).print();  // or tf.any(x, axis)
	 * ```
	 *
	 * @param x The input tensor. Must be of dtype bool.
	 * @param axis The dimension(s) to reduce. By default it reduces
	 *     all dimensions.
	 * @param keepDims If true, retains reduced dimensions with size 1.
	 */
	/** @doc {heading: 'Operations', subheading: 'Reduction'} */
	function any_(x, axis, keepDims) {
	    if (axis === void 0) { axis = null; }
	    if (keepDims === void 0) { keepDims = false; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'any', 'bool');
	    var origAxes = util.parseAxisParam(axis, $x.shape);
	    var axes = origAxes;
	    var permutedAxes = axis_util.getAxesPermutation(axes, $x.rank);
	    if (permutedAxes != null) {
	        $x = $x.transpose(permutedAxes);
	        axes = axis_util.getInnerMostAxes(axes.length, $x.rank);
	    }
	    var res = engine_1.ENGINE.runKernelFunc(function (backend) { return backend.any($x, axes); }, { $x: $x });
	    if (keepDims) {
	        var newShape = axis_util.expandShapeToKeepDim(res.shape, origAxes);
	        return res.reshape(newShape);
	    }
	    return res;
	}
	/**
	 * Calculates the mean and variance of `x`. The mean and variance are
	 * calculated by aggregating the contents of `x` across `axes`. If `x` is
	 * 1-D and `axes = [0]` this is just the mean and variance of a vector.
	 *
	 * @param x The input tensor.
	 * @param axis The dimension(s) along with to compute mean and
	 *     variance. By default it reduces all dimensions.
	 * @param keepDims If true, the moments have the same dimensionality as the
	 *     input.
	 * @return An object with two keys: `mean` and `variance`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Normalization'} */
	function moments_(x, axis, keepDims) {
	    if (axis === void 0) { axis = null; }
	    if (keepDims === void 0) { keepDims = false; }
	    x = tensor_util_env_1.convertToTensor(x, 'x', 'moments');
	    var axes = util.parseAxisParam(axis, x.shape);
	    var mean = x.mean(axes, keepDims);
	    var keepDimsShape = mean.shape;
	    if (!keepDims) {
	        keepDimsShape = axis_util.expandShapeToKeepDim(mean.shape, axes);
	    }
	    var devSquared = x.toFloat().sub(mean.reshape(keepDimsShape)).square();
	    var variance = devSquared.mean(axes, keepDims);
	    return { mean: mean, variance: variance };
	}
	exports.all = operation_1.op({ all_: all_ });
	// tslint:disable-next-line:variable-name
	exports.any = operation_1.op({ any_: any_ });
	exports.argMax = operation_1.op({ argMax_: argMax_ });
	exports.argMin = operation_1.op({ argMin_: argMin_ });
	exports.logSumExp = operation_1.op({ logSumExp_: logSumExp_ });
	exports.max = operation_1.op({ max_: max_ });
	exports.mean = operation_1.op({ mean_: mean_ });
	exports.min = operation_1.op({ min_: min_ });
	exports.moments = operation_1.op({ moments_: moments_ });
	exports.sum = operation_1.op({ sum_: sum_ });
	exports.prod = operation_1.op({ prod_: prod_ });
	//# sourceMappingURL=reduction_ops.js.map

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_util_env_1 = __webpack_require__(17);
	var binary_ops_1 = __webpack_require__(109);
	var broadcast_util_1 = __webpack_require__(57);
	var logical_ops_1 = __webpack_require__(154);
	var operation_1 = __webpack_require__(18);
	var selu_util_1 = __webpack_require__(317);
	var tensor_ops_1 = __webpack_require__(31);
	/**
	 * Computes rectified linear element-wise: `max(x, 0)`.
	 *
	 * ```js
	 * const x = tf.tensor1d([-1, 2, -3, 4]);
	 *
	 * x.relu().print();  // or tf.relu(x)
	 * ```
	 * @param x The input tensor. If the dtype is `bool`, the output dtype will be
	 *     `int32'.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function relu_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'relu');
	    if ($x.dtype === 'bool') {
	        return $x.toInt();
	    }
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return { x: function () { return dy.mulStrict($x.step().toFloat()); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.relu($x);
	        save([$x]);
	        return res;
	    }, { x: $x }, grad, 'Relu');
	}
	/**
	 * Computes rectified linear 6 element-wise: `min(max(x, 0), 6)`.
	 *
	 * ```js
	 * const x = tf.tensor1d([-1, 2, -3, 8]);
	 *
	 * x.relu6().print();  // or tf.relu6(x)
	 * ```
	 * @param x The input tensor. If the dtype is `bool`, the output dtype will be
	 *     `int32'.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function relu6_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'relu6');
	    if ($x.dtype === 'bool') {
	        return $x.toInt();
	    }
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        var mask = $x.lessEqual(6).mul($x.step());
	        return { x: function () { return dy.mulStrict(mask.toFloat()); } };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.relu6($x);
	        save([$x]);
	        return res;
	    }, { x: $x }, grad, 'Relu6');
	}
	/**
	 * Computes exponential linear element-wise: `x > 0 ? e ^ x - 1 : 0`.
	 *
	 * ```js
	 * const x = tf.tensor1d([-1, 1, -3, 2]);
	 *
	 * x.elu().print();  // or tf.elu(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function elu_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'elu');
	    var grad = function (dy, saved) {
	        var y = saved[0];
	        return {
	            $x: function () {
	                return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.eluDer(dy, y); }, { dy: dy, y: y });
	            }
	        };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var y = backend.elu($x);
	        save([y]);
	        return y;
	    }, { $x: $x }, grad);
	}
	/**
	 * Computes scaled exponential linear element-wise.
	 *
	 * `x < 0 ? scale * alpha * (exp(x) - 1) : x`
	 *
	 * ```js
	 * const x = tf.tensor1d([-1, 2, -3, 4]);
	 *
	 * x.selu().print();  // or tf.selu(x)
	 * ```
	 * @param x The input tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function selu_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'selu');
	    var grad = function (dy, saved) {
	        var $x = saved[0];
	        return {
	            $x: function () {
	                var mask = $x.greater(tensor_ops_1.scalar(0));
	                var scaleAlpha = tensor_ops_1.scalar(selu_util_1.SELU_SCALEALPHA);
	                var scale = tensor_ops_1.scalar(selu_util_1.SELU_SCALE);
	                var greaterThanZeroDer = dy.mul(scale);
	                var lessEqualZeroDer = dy.mul(scaleAlpha).mul($x.toFloat().exp());
	                return logical_ops_1.where(mask, greaterThanZeroDer, lessEqualZeroDer);
	            }
	        };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.selu($x);
	        save([$x]);
	        return res;
	    }, { $x: $x }, grad);
	}
	/**
	 * Computes leaky rectified linear element-wise.
	 *
	 * See
	 * [http://web.stanford.edu/~awni/papers/relu_hybrid_icml2013_final.pdf](
	 *     http://web.stanford.edu/~awni/papers/relu_hybrid_icml2013_final.pdf)
	 *
	 * ```js
	 * const x = tf.tensor1d([-1, 2, -3, 4]);
	 *
	 * x.leakyRelu(0.1).print();  // or tf.leakyRelu(x, 0.1)
	 * ```
	 * @param x The input tensor.
	 * @param alpha The scaling factor for negative values, defaults to 0.2.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function leakyRelu_(x, alpha) {
	    if (alpha === void 0) { alpha = 0.2; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'leakyRelu');
	    return binary_ops_1.maximum(tensor_ops_1.scalar(alpha).mul($x), $x);
	}
	/**
	 * Computes leaky rectified linear element-wise with parametric alphas.
	 *
	 * `x < 0 ? alpha * x : f(x) = x`
	 *
	 * ```js
	 * const x = tf.tensor1d([-1, 2, -3, 4]);
	 * const alpha = tf.scalar(0.1);
	 *
	 * x.prelu(alpha).print();  // or tf.prelu(x, alpha)
	 * ```
	 * @param x The input tensor.
	 * @param alpha Scaling factor for negative values.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function prelu_(x, alpha) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'prelu');
	    var $alpha = tensor_util_env_1.convertToTensor(alpha, 'alpha', 'prelu');
	    var grad = function (dy, saved) {
	        var $x = saved[0], $alpha = saved[1];
	        var mask = $x.greater(0);
	        return {
	            x: function () { return logical_ops_1.where(mask, dy, dy.mul($alpha)); },
	            alpha: function () {
	                var res = logical_ops_1.where(mask, tensor_ops_1.zerosLike(dy), dy.mul($x));
	                var reduceAxes = broadcast_util_1.getReductionAxes($alpha.shape, dy.shape);
	                if (reduceAxes.length > 0) {
	                    res = res.sum(reduceAxes);
	                }
	                return res.reshape($alpha.shape);
	            }
	        };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.prelu($x, $alpha);
	        save([$x, $alpha]);
	        return res;
	    }, { x: $x, alpha: $alpha }, grad, 'Prelu');
	}
	exports.elu = operation_1.op({ elu_: elu_ });
	exports.leakyRelu = operation_1.op({ leakyRelu_: leakyRelu_ });
	exports.prelu = operation_1.op({ prelu_: prelu_ });
	exports.relu = operation_1.op({ relu_: relu_ });
	exports.relu6 = operation_1.op({ relu6_: relu6_ });
	exports.selu = operation_1.op({ selu_: selu_ });
	//# sourceMappingURL=relu_ops.js.map

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_util_env_1 = __webpack_require__(17);
	var util_1 = __webpack_require__(10);
	var array_ops_1 = __webpack_require__(89);
	var axis_util_1 = __webpack_require__(108);
	var binary_ops_1 = __webpack_require__(109);
	var compare_1 = __webpack_require__(487);
	var logical_ops_1 = __webpack_require__(154);
	var operation_1 = __webpack_require__(18);
	var segment_util_1 = __webpack_require__(495);
	var tensor_ops_1 = __webpack_require__(31);
	/**
	 * Computes the sum along segments of a `tf.Tensor`.
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, 3, 4]);
	 * const segmentIds = tf.tensor1d([1, 2, 0, 1], 'int32');
	 * const numSegments = 3;
	 *
	 * x.unsortedSegmentSum(segmentIds, numSegments).print()
	 * //or tf.unsortedSegmentSum(x, segmentIds, numSegments)
	 * ```
	 * @param x The `tf.Tensor` that will be summed along its segments.
	 * @param segmentIds A `tf.Tensor1D` whose rank is equal to the rank of `x`'s
	 * dimension along the `axis`.  Maps each element of `x` to a segment.
	 * @param numSegments The number of distinct `segmentIds`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Segment'} */
	function unsortedSegmentSum_(x, segmentIds, numSegments) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'unsortedSegmentSum');
	    var $segmentIds = tensor_util_env_1.convertToTensor(segmentIds, 'segmentIds', 'unsortedSegmentSum', 'int32');
	    util_1.assert(util_1.isInt(numSegments), function () { return 'numSegments must be of dtype int'; });
	    var gradFunc = function (dy, saved) {
	        var $segmentIds = saved[0];
	        var derX = function () {
	            return gatherDropNegatives(dy, $segmentIds);
	        };
	        return { $x: derX };
	    };
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.unsortedSegmentSum($x, $segmentIds, numSegments);
	        save([$segmentIds]);
	        return res;
	    }, { $x: $x }, gradFunc);
	}
	/**
	 * Gather slices from tensor `x`'s axis `axis` according to `indices`.
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, 3, 4]);
	 * const indices = tf.tensor1d([1, 3, 3], 'int32');
	 *
	 * x.gather(indices).print();
	 * ```
	 *
	 * ```js
	 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
	 * const indices = tf.tensor1d([1, 1, 0], 'int32');
	 *
	 * x.gather(indices).print();
	 * ```
	 * @param x The input tensor whose slices to be gathered.
	 * @param indices The indices of the values to extract.
	 * @param axis The axis over which to select values. Defaults to 0.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Slicing and Joining'} */
	function gather_(x, indices, axis) {
	    if (axis === void 0) { axis = 0; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'gather');
	    var $indices = tensor_util_env_1.convertToTensor(indices, 'indices', 'gather', 'int32');
	    axis = util_1.parseAxisParam(axis, $x.shape)[0];
	    var shapeInfo = segment_util_1.collectGatherOpShapeInfo($x, $indices, axis);
	    var grad = function (dy, saved) {
	        var $indices = saved[0];
	        var derX = function () {
	            var paramsShape = $x.shape;
	            var indicesSize = $indices.size;
	            var outerShape = paramsShape.slice(0, axis);
	            var outerDims = outerShape.length;
	            var innerShape = paramsShape.slice(axis, paramsShape.length).slice(1);
	            var innerDims = innerShape.length;
	            var outerAxesIndices = arrayRange(0, outerDims);
	            var innerAxesIndices = arrayRange(outerDims + 1, outerDims + 1 + innerDims);
	            var valuesShape = arrayConcat([outerShape, [indicesSize], innerShape]);
	            var values = dy.reshape(valuesShape);
	            var reshapedIndices = $indices.reshape([indicesSize]);
	            var transposeDims = arrayConcat([[outerDims], outerAxesIndices, innerAxesIndices]);
	            var valuesTranspose = values.transpose(transposeDims);
	            var paramsGrad = exports.unsortedSegmentSum(valuesTranspose, reshapedIndices, $x.shape[axis]);
	            var invertTransposeDims = axis_util_1.getUndoAxesPermutation(transposeDims);
	            paramsGrad = paramsGrad.transpose(invertTransposeDims);
	            return paramsGrad;
	        };
	        return { x: derX, indices: function () { return $indices; } };
	    };
	    return (engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.gather($x, $indices.flatten(), axis);
	        save([$indices]);
	        return res;
	    }, { x: $x, indices: $indices }, grad, 'Gather', { axis: axis }))
	        .reshape(shapeInfo.outputShape);
	}
	function arrayRange(start, stop) {
	    var result = [];
	    for (var i = start; i < stop; ++i) {
	        result.push(i);
	    }
	    return result;
	}
	function arrayConcat(arrays) {
	    var result = [];
	    for (var i = 0; i < arrays.length; ++i) {
	        for (var j = 0; j < arrays[i].length; ++j) {
	            result.push(arrays[i][j]);
	        }
	    }
	    return result;
	}
	function gatherDropNegatives(x, indices) {
	    // Helper function for unsorted segment ops. Gathers params for
	    // positive segment ids and gathers 0 for inputs with negative segment id.
	    // Mirrors _GatherDropNegatives from tensorflow/python/ops/math_grad.py
	    var zeroClippedIndices = binary_ops_1.maximum(indices, tensor_ops_1.zerosLike(indices));
	    var gathered = exports.gather(x, zeroClippedIndices);
	    var isPositive = compare_1.greaterEqual(indices, tensor_ops_1.scalar(0, 'int32'));
	    var numIters = gathered.rank - isPositive.rank;
	    for (var i = 0; i < numIters; ++i) {
	        isPositive = array_ops_1.expandDims(isPositive, i + 1);
	    }
	    isPositive = logical_ops_1.logicalAnd(isPositive, tensor_ops_1.ones(gathered.shape, 'bool'));
	    var zeroSlice = tensor_ops_1.zerosLike(gathered);
	    return logical_ops_1.where(isPositive, gathered, zeroSlice);
	}
	exports.gather = operation_1.op({ gather_: gather_ });
	exports.unsortedSegmentSum = operation_1.op({ unsortedSegmentSum_: unsortedSegmentSum_ });
	//# sourceMappingURL=segment_ops.js.map

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(10);
	var reduce_util_1 = __webpack_require__(316);
	function segOpComputeOptimalWindowSize(inSize, numSegments) {
	    var done = false;
	    var res;
	    if (inSize <= reduce_util_1.PARALLELIZE_THRESHOLD) {
	        res = inSize;
	        done = true;
	    }
	    else {
	        res = util_1.nearestDivisor(inSize, Math.floor(Math.sqrt(inSize)));
	    }
	    while (!done) {
	        if (res > numSegments || res === inSize) {
	            done = true;
	        }
	        else {
	            res = util_1.nearestDivisor(inSize, res + 1);
	        }
	    }
	    return res;
	}
	exports.segOpComputeOptimalWindowSize = segOpComputeOptimalWindowSize;
	function computeOutShape(aShape, axis, numSegments) {
	    var outShape = [];
	    var rank = aShape.length;
	    for (var dim = 0; dim < rank; dim++) {
	        if (dim !== axis) {
	            outShape.push(aShape[dim]);
	        }
	        else {
	            outShape.push(numSegments);
	        }
	    }
	    return outShape;
	}
	exports.computeOutShape = computeOutShape;
	function collectGatherOpShapeInfo(x, indices, axis) {
	    var dimSize = x.shape[axis];
	    var outputShape = [];
	    var batchSize = 1;
	    var sliceSize = 1;
	    for (var i = 0; i < axis; i++) {
	        outputShape.push(x.shape[i]);
	        batchSize *= x.shape[i];
	    }
	    for (var i = 0; i < indices.rank; i++) {
	        outputShape.push(indices.shape[i]);
	    }
	    for (var i = axis + 1; i < x.rank; i++) {
	        outputShape.push(x.shape[i]);
	        sliceSize *= x.shape[i];
	    }
	    return { batchSize: batchSize, sliceSize: sliceSize, dimSize: dimSize, outputShape: outputShape };
	}
	exports.collectGatherOpShapeInfo = collectGatherOpShapeInfo;
	//# sourceMappingURL=segment_util.js.map

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var operation_1 = __webpack_require__(18);
	var binary_ops_1 = __webpack_require__(109);
	var concat_split_1 = __webpack_require__(237);
	var slice_1 = __webpack_require__(318);
	var spectral_ops_1 = __webpack_require__(319);
	var tensor_ops_1 = __webpack_require__(31);
	/**
	 * Generate a Hann window.
	 *
	 * See: https://en.wikipedia.org/wiki/Window_function#Hann_and_Hamming_windows
	 *
	 * ```js
	 * tf.signal.hannWindow(10).print();
	 * ```
	 * @param The length of window
	 */
	/**
	 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
	 */
	function hannWindow_(windowLength) {
	    return cosineWindow(windowLength, 0.5, 0.5);
	}
	/**
	 * Generate a hamming window.
	 *
	 * See: https://en.wikipedia.org/wiki/Window_function#Hann_and_Hamming_windows
	 *
	 * ```js
	 * tf.signal.hammingWindow(10).print();
	 * ```
	 * @param The length of window
	 */
	/**
	 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
	 */
	function hammingWindow_(windowLength) {
	    return cosineWindow(windowLength, 0.54, 0.46);
	}
	/**
	 * Expands input into frames of frameLength.
	 * Slides a window size with frameStep.
	 *
	 * ```js
	 * tf.signal.frame([1, 2, 3], 2, 1).print();
	 * ```
	 * @param signal The input tensor to be expanded
	 * @param frameLength Length of each frame
	 * @param frameStep The frame hop size in samples.
	 * @param padEnd Whether to pad the end of signal with padValue.
	 * @param padValue An number to use where the input signal does
	 *     not exist when padEnd is True.
	 */
	/**
	 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
	 */
	function frame_(signal, frameLength, frameStep, padEnd, padValue) {
	    if (padEnd === void 0) { padEnd = false; }
	    if (padValue === void 0) { padValue = 0; }
	    var start = 0;
	    var output = [];
	    while (start + frameLength <= signal.size) {
	        output.push(slice_1.slice(signal, start, frameLength));
	        start += frameStep;
	    }
	    if (padEnd) {
	        while (start < signal.size) {
	            var padLen = (start + frameLength) - signal.size;
	            var pad = concat_split_1.concat([slice_1.slice(signal, start, frameLength - padLen),
	                tensor_ops_1.fill([padLen], padValue)]);
	            output.push(pad);
	            start += frameStep;
	        }
	    }
	    if (output.length === 0) {
	        return tensor_ops_1.tensor2d([], [0, frameLength]);
	    }
	    return concat_split_1.concat(output).as2D(output.length, frameLength);
	}
	/**
	 * Computes the Short-time Fourier Transform of signals
	 * See: https://en.wikipedia.org/wiki/Short-time_Fourier_transform
	 *
	 * ```js
	 * const input = tf.tensor1d([1, 1, 1, 1, 1])
	 * tf.signal.stft(input, 3, 1).print();
	 * ```
	 * @param signal 1-dimensional real value tensor.
	 * @param frameLength The window length of samples.
	 * @param frameStep The number of samples to step.
	 * @param fftLength The size of the FFT to apply.
	 * @param windowFn A callable that takes a window length and returns 1-d tensor.
	 */
	/**
	 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
	 */
	function stft_(signal, frameLength, frameStep, fftLength, windowFn) {
	    if (windowFn === void 0) { windowFn = exports.hannWindow; }
	    if (fftLength == null) {
	        fftLength = enclosingPowerOfTwo(frameLength);
	    }
	    var framedSignal = exports.frame(signal, frameLength, frameStep);
	    var windowedSignal = binary_ops_1.mul(framedSignal, windowFn(frameLength));
	    var output = [];
	    for (var i = 0; i < framedSignal.shape[0]; i++) {
	        output.push(spectral_ops_1.rfft(windowedSignal.slice([i, 0], [1, frameLength]), fftLength));
	    }
	    return concat_split_1.concat(output);
	}
	function enclosingPowerOfTwo(value) {
	    // Return 2**N for integer N such that 2**N >= value.
	    return Math.floor(Math.pow(2, Math.ceil(Math.log(value) / Math.log(2.0))));
	}
	function cosineWindow(windowLength, a, b) {
	    var even = 1 - windowLength % 2;
	    var newValues = new Float32Array(windowLength);
	    for (var i = 0; i < windowLength; ++i) {
	        var cosArg = (2.0 * Math.PI * i) / (windowLength + even - 1);
	        newValues[i] = a - b * Math.cos(cosArg);
	    }
	    return tensor_ops_1.tensor1d(newValues, 'float32');
	}
	exports.hannWindow = operation_1.op({ hannWindow_: hannWindow_ });
	exports.hammingWindow = operation_1.op({ hammingWindow_: hammingWindow_ });
	exports.frame = operation_1.op({ frame_: frame_ });
	exports.stft = operation_1.op({ stft_: stft_ });
	//# sourceMappingURL=signal_ops.js.map

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var gradients_1 = __webpack_require__(190);
	var tensor_util_env_1 = __webpack_require__(17);
	var operation_1 = __webpack_require__(18);
	/**
	 * Computes the softmax normalized vector given the logits.
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 2, 3]);
	 *
	 * a.softmax().print();  // or tf.softmax(a)
	 * ```
	 *
	 * ```js
	 * const a = tf.tensor2d([2, 4, 6, 1, 2, 3], [2, 3]);
	 *
	 * a.softmax().print();  // or tf.softmax(a)
	 * ```
	 *
	 * @param logits The logits array.
	 * @param dim The dimension softmax would be performed on. Defaults to `-1`
	 *     which indicates the last dimension.
	 */
	/** @doc {heading: 'Operations', subheading: 'Normalization'} */
	function softmax_(logits, dim) {
	    if (dim === void 0) { dim = -1; }
	    var $logits = tensor_util_env_1.convertToTensor(logits, 'logits', 'softmax', 'float32');
	    if (dim === -1) {
	        dim = $logits.rank - 1;
	    }
	    if (dim !== $logits.rank - 1) {
	        throw Error('Softmax along a non-last dimension is not yet supported. ' +
	            ("Logits was rank " + $logits.rank + " and dim was " + dim));
	    }
	    var inputsToSave = [];
	    var outputsToSave = [true];
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var y = backend.softmax($logits, dim);
	        save([y]);
	        return y;
	    }, { logits: $logits }, function (dy, saved) {
	        var y = saved[0];
	        var dyTimesY = dy.mul(y);
	        var keepDims = true;
	        return {
	            logits: function () { return dyTimesY.sub(dyTimesY.sum([dim], keepDims).mul(y)); }
	        };
	    }, 'Softmax', { dim: dim }, inputsToSave, outputsToSave);
	}
	/**
	 * Computes the log softmax.
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 2, 3]);
	 *
	 * a.logSoftmax().print();  // or tf.logSoftmax(a)
	 * ```
	 *
	 * ```js
	 * const a = tf.tensor2d([2, 4, 6, 1, 2, 3], [2, 3]);
	 *
	 * a.logSoftmax().print();  // or tf.logSoftmax(a)
	 * ```
	 *
	 * @param logits The logits array.
	 * @param axis The dimension softmax would be performed on. Defaults to `-1`
	 *     which indicates the last dimension.
	 */
	/** @doc {heading: 'Operations', subheading: 'Normalization'} */
	function logSoftmax_(logits, axis) {
	    if (axis === void 0) { axis = -1; }
	    var $logits = tensor_util_env_1.convertToTensor(logits, 'logits', 'logSoftmax');
	    if (axis === -1) {
	        axis = $logits.rank - 1;
	    }
	    if (axis !== $logits.rank - 1) {
	        throw Error('Log Softmax along a non-last dimension is not yet supported. ' +
	            ("Logits was rank " + $logits.rank + " and axis was " + axis));
	    }
	    var customOp = gradients_1.customGrad(function (logits, save) {
	        var keepDims = true;
	        var xMax = logits.max(axis, true);
	        var shifted = logits.sub(xMax);
	        var value = shifted.toFloat().sub(shifted.exp().sum(axis, keepDims).log());
	        save([value]);
	        var gradFunc = function (dy, saved) {
	            var value = saved[0];
	            var softmax = value.exp();
	            return dy.sub(dy.sum(axis, keepDims).mul(softmax));
	        };
	        return { value: value, gradFunc: gradFunc };
	    });
	    return customOp($logits);
	}
	exports.softmax = operation_1.op({ softmax_: softmax_ });
	exports.logSoftmax = operation_1.op({ logSoftmax_: logSoftmax_ });
	//# sourceMappingURL=softmax.js.map

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2020 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var kernel_names_1 = __webpack_require__(88);
	var tensor_util_1 = __webpack_require__(111);
	var tensor_util_env_1 = __webpack_require__(17);
	var broadcast_util_1 = __webpack_require__(57);
	var operation_1 = __webpack_require__(18);
	var tensor_ops_1 = __webpack_require__(31);
	/**
	 * Returns (a - b) * (a - b) element-wise.
	 * Supports broadcasting.
	 *
	 * We also expose `tf.squaredDifferenceStrict` which has the same signature as
	 * this op and asserts that `a` and `b` are the same shape (does not
	 * broadcast).
	 *
	 * ```js
	 * const a = tf.tensor1d([1, 4, 3, 16]);
	 * const b = tf.tensor1d([1, 2, 9, 4]);
	 *
	 * a.squaredDifference(b).print();  // or tf.squaredDifference(a, b)
	 * ```
	 *
	 * ```js
	 * // Broadcast squared difference  a with b.
	 * const a = tf.tensor1d([2, 4, 6, 8]);
	 * const b = tf.scalar(5);
	 *
	 * a.squaredDifference(b).print();  // or tf.squaredDifference(a, b)
	 * ```
	 *
	 * @param a The first tensor.
	 * @param b The second tensor. Must have the same type as `a`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Arithmetic'} */
	function squaredDifference_(a, b) {
	    var _a;
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'squaredDifference');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'squaredDifference');
	    _a = tensor_util_1.makeTypesMatch($a, $b), $a = _a[0], $b = _a[1];
	    broadcast_util_1.assertAndGetBroadcastShape($a.shape, $b.shape);
	    var der = function (dy, saved) {
	        var $a = saved[0], $b = saved[1];
	        var two = tensor_ops_1.scalar(2);
	        var derA = function () { return dy.mul($a.sub($b).mul(two)); };
	        var derB = function () { return dy.mul($b.sub($a).mul(two)); };
	        return { a: derA, b: derB };
	    };
	    var forward = function (backend, save) {
	        var res = backend.squaredDifference($a, $b);
	        save([$a, $b]);
	        return res;
	    };
	    var inputs = { a: $a, b: $b };
	    var attrs = {};
	    var inputsToSave = [$a, $b];
	    var outputToSave = [];
	    return engine_1.ENGINE.runKernelFunc(forward, inputs, der, kernel_names_1.SquaredDifference, attrs, inputsToSave, outputToSave);
	}
	exports.squaredDifference = operation_1.op({ squaredDifference_: squaredDifference_ });
	//# sourceMappingURL=squared_difference.js.map

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ArraySpeciesCreate = __webpack_require__(1364);
	var FlattenIntoArray = __webpack_require__(1369);
	var Get = __webpack_require__(261);
	var ToIntegerOrInfinity = __webpack_require__(561);
	var ToLength = __webpack_require__(562);
	var ToObject = __webpack_require__(1380);
	
	module.exports = function flat() {
		var O = ToObject(this);
		var sourceLen = ToLength(Get(O, 'length'));
	
		var depthNum = 1;
		if (arguments.length > 0 && typeof arguments[0] !== 'undefined') {
			depthNum = ToIntegerOrInfinity(arguments[0]);
		}
	
		var A = ArraySpeciesCreate(O, 0);
		FlattenIntoArray(A, O, sourceLen, 0, depthNum);
		return A;
	};


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(499);
	
	module.exports = function getPolyfill() {
		return Array.prototype.flat || implementation;
	};


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(76);
	var settle = __webpack_require__(1098);
	var buildURL = __webpack_require__(1101);
	var parseHeaders = __webpack_require__(1107);
	var isURLSameOrigin = __webpack_require__(1105);
	var createError = __webpack_require__(504);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(1100);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(1103);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        if (request.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 502 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 503 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(1097);
	
	/**
	 * Create an Error with the specified message, config, error code, and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, response);
	};


/***/ },
/* 505 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 506 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchEmployments = fetchEmployments;
	exports.fetchEmploymentsSuccess = fetchEmploymentsSuccess;
	exports.fetchEmploymentsFailure = fetchEmploymentsFailure;
	var FETCH_EMPLOYMENTS = exports.FETCH_EMPLOYMENTS = 'FETCH_EMPLOYMENTS';
	var FETCH_EMPLOYMENTS_SUCCESS = exports.FETCH_EMPLOYMENTS_SUCCESS = 'FETCH_EMPLOYMENTS_SUCCESS';
	var FETCH_EMPLOYMENTS_FAILURE = exports.FETCH_EMPLOYMENTS_FAILURE = 'FETCH_EMPLOYMENTS_FAILURE';
	var RESET_EMPLOYMENTS = exports.RESET_EMPLOYMENTS = 'RESET_EMPLOYMENTS';
	
	function fetchEmployments() {
	
	    return {
	        type: FETCH_EMPLOYMENTS,
	        payload: this.state.employments
	    };
	}
	
	function fetchEmploymentsSuccess(employments) {
	    return {
	        type: FETCH_EMPLOYMENTS_SUCCESS,
	        payload: employments
	    };
	}
	
	function fetchEmploymentsFailure(error) {
	    return {
	        type: FETCH_EMPLOYMENTS_FAILURE,
	        payload: error
	    };
	}

/***/ },
/* 507 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchStates = fetchStates;
	exports.fetchStatesSuccess = fetchStatesSuccess;
	exports.fetchStatesFailure = fetchStatesFailure;
	var FETCH_STATES = exports.FETCH_STATES = 'FETCH_STATES';
	var FETCH_STATES_SUCCESS = exports.FETCH_STATES_SUCCESS = 'FETCH_STATES_SUCCESS';
	var FETCH_STATES_FAILURE = exports.FETCH_STATES_FAILURE = 'FETCH_STATES_FAILURE';
	var RESET_STATES = exports.RESET_STATES = 'RESET_STATES';
	
	function fetchStates() {
	
	    return {
	        type: FETCH_STATES,
	        payload: this.state.states
	    };
	}
	
	function fetchStatesSuccess(states) {
	    return {
	        type: FETCH_STATES_SUCCESS,
	        payload: states
	    };
	}
	
	function fetchStatesFailure(error) {
	    return {
	        type: FETCH_STATES_FAILURE,
	        payload: error
	    };
	}

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMeasure = __webpack_require__(455);
	
	var _reactMeasure2 = _interopRequireDefault(_reactMeasure);
	
	var _browserUtils = __webpack_require__(1219);
	
	var _utils = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(138);
	
	var CAPTURE_OPTIONS = {
	  audio: false,
	  video: { facingMode: "environment",
	    width: { ideal: 20000 },
	    height: { ideal: 20000 }
	  }
	};
	
	var FIXED_CAPTURE_OPTIONS = {
	  audio: false,
	  video: {
	    facingMode: "environment",
	    width: 1200,
	    height: 746
	  }
	};
	
	var DocumentCamera = function (_Component) {
	  _inherits(DocumentCamera, _Component);
	
	  function DocumentCamera(props) {
	    _classCallCheck(this, DocumentCamera);
	
	    var _this = _possibleConstructorReturn(this, (DocumentCamera.__proto__ || Object.getPrototypeOf(DocumentCamera)).call(this, props));
	
	    _this.state = {
	      stream: null,
	      picture: null,
	      pictureUrl: null,
	      saved: false,
	      playing: false,
	      hasCameraPermission: false,
	      parentSize: {
	        height: 0,
	        width: 0
	      },
	      mediaSize: {
	        height: 0,
	        width: 0,
	        aspectRatio: 1.586
	      },
	      imageToCapture: {
	        height: 0,
	        width: 0
	      },
	      resizedVideo: {
	        height: null,
	        width: null,
	        contentComponent: null,
	        videoAspectRatio: null,
	        videoWidth: null,
	        videoHeight: null
	      }
	    };
	    _this.video = null;
	    _this.containerVideo = null;
	    _this.canvas = null;
	    _this.imageToCapture = null;
	    _this.handleOnChange = _this.handleOnChange.bind(_this);
	    _this.handleCanPlay = _this.handleCanPlay.bind(_this);
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.handleShapeResize = _this.handleShapeResize.bind(_this);
	    _this.onCapture = _this.onCapture.bind(_this);
	    _this.handleCapture = _this.handleCapture.bind(_this);
	    _this.onClear = _this.onClear.bind(_this);
	    _this.handleClear = _this.handleClear.bind(_this);
	    return _this;
	  }
	
	  _createClass(DocumentCamera, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var captureOptions = this.props.captureOptions || CAPTURE_OPTIONS;
	
	      if (!(0, _browserUtils.checkUserMediaContrainsCompatibility)()) {
	        captureOptions = FIXED_CAPTURE_OPTIONS;
	      }
	
	      navigator.mediaDevices.getUserMedia(captureOptions).then(function (stream) {
	        _this2.setState(Object.assign({}, _this2.state, {
	          stream: stream,
	          hasCameraPermission: true
	        }));
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.state.stream.getTracks().forEach(function (track) {
	        track.stop();
	      });
	    }
	  }, {
	    key: 'handleOnChange',
	    value: function handleOnChange(event) {
	      event.preventDefault();
	      if (this.props.onChange) {
	        this.props.onChange(this.state.picture);
	      }
	      this.setState(Object.assign({}, this.state, {
	        saved: true
	      }));
	    }
	  }, {
	    key: 'handleCapture',
	    value: function handleCapture(event) {
	      var _this3 = this;
	
	      var _state = this.state,
	          mediaSize = _state.mediaSize,
	          parentSize = _state.parentSize,
	          resizedVideo = _state.resizedVideo;
	      //const offset = this.calculateOffset(mediaSize, this.video);
	      //console.log(imageToCapture);
	
	      var shapeToCapture = {
	        height: parentSize.height > parentSize.width ? parentSize.width * 0.9 * 0.62 : parentSize.height * 0.5,
	        width: parentSize.height > parentSize.width ? parentSize.width * 0.9 : parentSize.height * 0.5 / 0.62
	      };
	      var videoScale = resizedVideo.width / this.video.videoWidth;
	      /*const offset = this.calculateOffset({
	        height: imageToCapture.height * 1.1,
	        width: imageToCapture.width  * 1.1,
	      },
	      this.video);
	       const parentOffset = this.calculateOffset({
	        height: parentSize.height,
	        width: parentSize.width,
	      },
	      this.video);
	       const canvasOffset = this.calculateOffset({
	        height: imageToCapture.height * 1.1,
	        width: imageToCapture.width  * 1.1,
	      },
	      {
	        videoWidth: parentSize.width,
	        videoHeight: parentSize.height,
	      });*/
	
	      var offset = this.calculateOffset({
	        height: shapeToCapture.height * 1.1,
	        width: shapeToCapture.width * 1.1
	      }, {
	        videoWidth: resizedVideo.width,
	        videoHeight: resizedVideo.height
	      });
	
	      var realOffset = {
	        x: offset.x / videoScale,
	        y: offset.y / videoScale
	      };
	
	      var realShape = {
	        width: this.video.videoWidth - realOffset.x * 2,
	        height: this.video.videoHeight - realOffset.y * 2
	      };
	      if (event) {
	        event.preventDefault();
	      }
	
	      var resizedImageToProcess = (0, _utils.resizeImage)(realShape.width, realShape.height, 1200, 1200);
	
	      var hiddenCanvas = document.createElement('canvas');
	      this.canvas = hiddenCanvas;
	      hiddenCanvas.height = resizedImageToProcess.height;
	      hiddenCanvas.width = resizedImageToProcess.width;
	      var hiddenContext = hiddenCanvas.getContext('2d');
	      hiddenContext.drawImage(this.video, realOffset.x, realOffset.y, realShape.width, realShape.height, 0, 0, resizedImageToProcess.width, resizedImageToProcess.height);
	
	      hiddenCanvas.toBlob(function (blob) {
	        return _this3.onCapture(blob);
	      }, "image/jpeg", 1);
	      this.setState(Object.assign({}, this.state, {
	        pictureUrl: hiddenCanvas.toDataURL('image/jpeg', 1)
	      }));
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(contentRect) {
	      var _state2 = this.state,
	          mediaSize = _state2.mediaSize,
	          stream = _state2.stream;
	
	
	      var calculatedSize = {};
	      var parentSize = {};
	      var resizedVideo = {};
	
	      if (contentRect.entry) {
	
	        calculatedSize = {
	          width: contentRect.entry.width,
	          height: contentRect.entry.height
	        };
	        if (contentRect.entry.width > contentRect.entry.height) {
	          calculatedSize.height = Math.round(contentRect.entry.width / mediaSize.aspectRatio);
	        } else {
	          calculatedSize.width = Math.round(contentRect.entry.height / mediaSize.aspectRatio);
	        }
	
	        parentSize = {
	          width: contentRect.entry.width,
	          height: contentRect.entry.height
	        };
	
	        if (this.video) {
	          var browserVideoSize = stream.getVideoTracks()[0].getSettings();
	          var videoAspectRatio = null;
	          var originalVideoSize = {
	            width: browserVideoSize.width,
	            height: browserVideoSize.height
	          };
	
	          if (contentRect.entry.height > contentRect.entry.width) {
	            originalVideoSize = {
	              width: browserVideoSize.width > browserVideoSize.height ? browserVideoSize.height : browserVideoSize.width,
	              height: browserVideoSize.width > browserVideoSize.height ? browserVideoSize.width : browserVideoSize.height
	            };
	          }
	
	          videoAspectRatio = originalVideoSize.width / originalVideoSize.height;
	
	          var capturedScreenHeight = originalVideoSize.height * 100 / contentRect.entry.height;
	          var capturdScreenWidth = originalVideoSize.width * 100 / contentRect.entry.width;
	          if (capturedScreenHeight > capturdScreenWidth) {
	            resizedVideo = {
	              width: contentRect.entry.width,
	              height: contentRect.entry.width / videoAspectRatio
	            };
	          } else {
	            resizedVideo = {
	              width: contentRect.entry.height * videoAspectRatio,
	              height: contentRect.entry.height
	            };
	          }
	
	          resizedVideo = Object.assign({}, resizedVideo, {
	            contentComponent: contentRect.entry,
	            videoAspectRatio: videoAspectRatio,
	            videoWidth: originalVideoSize.width,
	            videoHeight: originalVideoSize.height
	          });
	        }
	
	        this.setState(Object.assign({}, this.state, {
	          mediaSize: Object.assign({}, calculatedSize, {
	            aspectRatio: mediaSize.aspectRatio
	          }),
	          parentSize: Object.assign({}, parentSize),
	          resizedVideo: Object.assign({}, resizedVideo)
	        }));
	      }
	    }
	  }, {
	    key: 'handleShapeResize',
	    value: function handleShapeResize(contentRect) {
	      var mediaSize = this.state.mediaSize;
	
	
	      var imageToCapture = {};
	
	      if (contentRect.entry) {
	
	        imageToCapture = {
	          width: contentRect.entry.width,
	          height: contentRect.entry.height
	        };
	
	        this.setState(Object.assign({}, this.state, {
	          imageToCapture: Object.assign({}, imageToCapture)
	        }));
	      }
	    }
	  }, {
	    key: 'onCapture',
	    value: function onCapture(blob) {
	
	      this.setState(Object.assign({}, this.state, {
	        picture: blob
	      }));
	    }
	  }, {
	    key: 'handleClear',
	    value: function handleClear() {
	      var context = this.canvas.getContext("2d");
	      context.clearRect(0, 0, this.canvas.width, this.canvas.height);
	      this.onClear();
	    }
	  }, {
	    key: 'onClear',
	    value: function onClear(blob) {
	      this.setState(Object.assign({}, this.state, {
	        picture: null,
	        pictureUrl: null
	      }));
	    }
	  }, {
	    key: 'handleCanPlay',
	    value: function handleCanPlay() {
	      var mediaSize = this.state.mediaSize;
	
	      var newAspectRatio = this.calculateRatio(this.video.videoHeight, this.video.videoWidth);
	
	      this.setState(Object.assign({}, this.state, {
	        playing: true,
	        mediaSize: Object.assign({}, mediaSize, {
	          aspectRatio: newAspectRatio || mediaSize.aspectRatio
	        })
	      }));
	      this.video.play();
	    }
	  }, {
	    key: 'calculateRatio',
	    value: function calculateRatio(height, width) {
	      if (height && width) {
	        var isLandscape = height <= width;
	        var ratio = isLandscape ? width / height : height / width;
	        return ratio;
	      }
	    }
	  }, {
	    key: 'calculateDocumentFrame',
	    value: function calculateDocumentFrame(containerWidth, containerHeight, frameAspectRatio) {
	      var defaultFixedSide = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	      var fixedSide = containerWidth >= containerHeight ? containerWidth : containerHeight;
	      if (defaultFixedSide) {
	        fixedSide = defaultFixedSide === 'width' ? containerWidth : containerHeight;
	      }
	      var variableSide = fixedSide == containerWidth ? containerHeight : containerWidth;
	      var fixedSideFrame = 20;
	      var fixedContentSize = Math.round(fixedSide - fixedSideFrame * 2);
	      var variableContentSize = Math.round(fixedContentSize / frameAspectRatio);
	      var variableSideFrame = (variableSide - variableContentSize) / 2;
	      return {
	        frameWidth: fixedSide === containerWidth ? fixedSideFrame : variableSideFrame,
	        frameHeight: fixedSide === containerHeight ? fixedSideFrame : variableSideFrame
	      };
	    }
	  }, {
	    key: 'calculateOffset',
	    value: function calculateOffset(videoContainer, video) {
	      if (video && videoContainer) {
	        return {
	          x: video.videoWidth > videoContainer.width ? Math.round((video.videoWidth - videoContainer.width) / 2) : 0,
	          y: video.videoHeight > videoContainer.height ? Math.round((video.videoHeight - videoContainer.height) / 2) : 0
	        };
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state3 = this.state,
	          mediaSize = _state3.mediaSize,
	          hasCameraPermission = _state3.hasCameraPermission,
	          imageToCapture = _state3.imageToCapture,
	          parentSize = _state3.parentSize,
	          resizedVideo = _state3.resizedVideo,
	          stream = _state3.stream;
	      var shapeStyle = this.props.shapeStyle;
	
	      var parentOffset = null;
	      var canvasOffset = null;
	      var shapeSize = {};
	      var originalVideoSize = null;
	
	      if (this.state.stream && this.video) {
	        parentOffset = this.calculateOffset({
	          height: parentSize.height,
	          width: parentSize.width
	        }, this.video);
	        canvasOffset = this.calculateOffset({
	          height: imageToCapture.height * 1.1,
	          width: imageToCapture.width * 1.1
	        }, {
	          videoWidth: parentSize.width,
	          videoHeight: parentSize.height
	        });
	        originalVideoSize = stream.getVideoTracks()[0].getSettings();
	      }
	
	      if (this.state.stream && this.video && !this.video.srcObject) {
	        this.video.srcObject = this.state.stream;
	      }
	
	      var documentFrames = this.calculateDocumentFrame(mediaSize.width, mediaSize.height, shapeStyle.aspectRatio, shapeStyle.defaultFixedSide);
	      var videoOffset = this.calculateOffset(mediaSize, this.video);
	
	      var ConfirmButtons = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary action-button', onClick: this.handleOnChange },
	          _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok', 'aria-hidden': 'true' })
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary action-button', onClick: this.handleClear },
	          _react2.default.createElement('span', { className: 'glyphicon glyphicon-remove', 'aria-hidden': 'true' })
	        )
	      );
	      var shownButtons = this.state.picture ? ConfirmButtons : _react2.default.createElement(
	        'button',
	        { onClick: this.handleCapture, className: 'btn btn-primary btn-lg action-button' },
	        _react2.default.createElement('span', { className: 'glyphicon glyphicon-camera', 'aria-hidden': 'true' })
	      );
	      var alert = _react2.default.createElement(
	        'div',
	        { 'class': 'alert alert-warning', role: 'alert' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Debes aceptar el permiso para poder acceder a tu camara.'
	        )
	      );
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: {
	            height: "100%",
	            width: "100%",
	            background: "#000"
	          } },
	        _react2.default.createElement(
	          'div',
	          { style: {
	              height: "100%",
	              width: "100%",
	              margin: "0 auto"
	            } },
	          !hasCameraPermission && alert || _react2.default.createElement(
	            _reactMeasure2.default,
	            { onResize: this.handleResize },
	            function (_ref) {
	              var measureRef = _ref.measureRef;
	              return _react2.default.createElement(
	                'div',
	                {
	                  ref: measureRef,
	                  style: {
	                    position: "relative",
	                    height: "100%",
	                    width: "100%",
	                    overflow: "hidden"
	                  } },
	                _react2.default.createElement('video', {
	                  ref: function ref(component) {
	                    _this4.video = component;
	                  },
	                  onPlay: _this4.handleCanPlay,
	                  style: {
	                    position: 'absolute',
	                    width: resizedVideo && resizedVideo.width || "100%",
	                    height: resizedVideo && resizedVideo.height || "100%",
	                    objectFit: "fill",
	                    top: "50%",
	                    left: "50%",
	                    transform: "translate(-50%,-50%)"
	                  },
	                  hidden: _this4.state.picture,
	                  autoPlay: true,
	                  playsInline: true,
	                  muted: true
	                }),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    style: {
	                      position: 'absolute',
	                      width: "100%",
	                      height: "100%"
	                    } },
	                  _react2.default.createElement(
	                    _reactMeasure2.default,
	                    { onResize: _this4.handleShapeResize },
	                    function (_ref2) {
	                      var measureRef = _ref2.measureRef;
	                      return _react2.default.createElement('div', {
	                        style: Object.assign({
	                          position: "absolute",
	                          marginLeft: "50%",
	                          transform: "translate(-50%, -50%)",
	                          top: "50%",
	                          height: parentSize.height > parentSize.width ? parentSize.width * 0.9 * 0.62 : parentSize.height * 0.5,
	                          width: parentSize.height > parentSize.width ? parentSize.width * 0.9 : parentSize.height * 0.5 / 0.62,
	                          boxShadow: '0px 0px 20px 500px rgba(0, 0, 0, 0.6)',
	                          border: '1px solid #ffffff',
	                          borderRadius: "15%"
	                        }, shapeStyle),
	                        ref: measureRef,
	                        hidden: _this4.state.picture,
	                        id: 'prueba' });
	                    }
	                  ),
	                  _react2.default.createElement('img', {
	                    src: _this4.state.pictureUrl,
	                    style: {
	                      position: "absolute",
	                      marginLeft: "50%",
	                      transform: "translate(-50%, -50%)",
	                      top: "50%",
	                      height: parentSize.height > parentSize.width ? parentSize.width * 0.9 * 0.62 : parentSize.height * 0.5,
	                      width: parentSize.height > parentSize.width ? parentSize.width * 0.9 : parentSize.height * 0.5 / 0.62
	                    },
	                    hidden: !_this4.state.pictureUrl }),
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      style: {
	                        position: "absolute",
	                        marginLeft: "50%",
	                        transform: "translateX(-50%)",
	                        top: "5%",
	                        textAlign: "center"
	                      } },
	                    _react2.default.createElement('img', {
	                      src: _this4.props.headerIcon,
	                      style: {
	                        maxHeight: "48px",
	                        width: "100%"
	                      } }),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                          'h3',
	                          null,
	                          _this4.props.headerTitle
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      style: {
	                        position: "absolute",
	                        marginLeft: "50%",
	                        transform: "translateX(-50%)",
	                        bottom: "3%",
	                        textAlign: "center"
	                      } },
	                    _this4.state.updateCamera && _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Camara actualizada'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                          'h3',
	                          null,
	                          'Cheque\xE1 que se lean bien los datos de tu DNI'
	                        )
	                      )
	                    ),
	                    !_this4.state.saved && shownButtons
	                  )
	                )
	              );
	            }
	          )
	        )
	      );
	    }
	  }]);
	
	  return DocumentCamera;
	}(_react.Component);
	
	module.exports = DocumentCamera;

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1251), __esModule: true };

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(334);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(1224);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(1223);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ },
/* 512 */
[2084, 2017],
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Transform = __webpack_require__(1666);
	
	var binding = __webpack_require__(1232);
	var util = __webpack_require__(952);
	var assert = __webpack_require__(1091).ok;
	
	// zlib doesn't provide these, so kludge them in following the same
	// const naming scheme zlib uses.
	binding.Z_MIN_WINDOWBITS = 8;
	binding.Z_MAX_WINDOWBITS = 15;
	binding.Z_DEFAULT_WINDOWBITS = 15;
	
	// fewer than 64 bytes per chunk is stupid.
	// technically it could work with as few as 8, but even 64 bytes
	// is absurdly low.  Usually a MB or more is best.
	binding.Z_MIN_CHUNK = 64;
	binding.Z_MAX_CHUNK = Infinity;
	binding.Z_DEFAULT_CHUNK = (16 * 1024);
	
	binding.Z_MIN_MEMLEVEL = 1;
	binding.Z_MAX_MEMLEVEL = 9;
	binding.Z_DEFAULT_MEMLEVEL = 8;
	
	binding.Z_MIN_LEVEL = -1;
	binding.Z_MAX_LEVEL = 9;
	binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;
	
	// expose all the zlib constants
	Object.keys(binding).forEach(function(k) {
	  if (k.match(/^Z/)) exports[k] = binding[k];
	});
	
	// translation table for return codes.
	exports.codes = {
	  Z_OK: binding.Z_OK,
	  Z_STREAM_END: binding.Z_STREAM_END,
	  Z_NEED_DICT: binding.Z_NEED_DICT,
	  Z_ERRNO: binding.Z_ERRNO,
	  Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
	  Z_DATA_ERROR: binding.Z_DATA_ERROR,
	  Z_MEM_ERROR: binding.Z_MEM_ERROR,
	  Z_BUF_ERROR: binding.Z_BUF_ERROR,
	  Z_VERSION_ERROR: binding.Z_VERSION_ERROR
	};
	
	Object.keys(exports.codes).forEach(function(k) {
	  exports.codes[exports.codes[k]] = k;
	});
	
	exports.Deflate = Deflate;
	exports.Inflate = Inflate;
	exports.Gzip = Gzip;
	exports.Gunzip = Gunzip;
	exports.DeflateRaw = DeflateRaw;
	exports.InflateRaw = InflateRaw;
	exports.Unzip = Unzip;
	
	exports.createDeflate = function(o) {
	  return new Deflate(o);
	};
	
	exports.createInflate = function(o) {
	  return new Inflate(o);
	};
	
	exports.createDeflateRaw = function(o) {
	  return new DeflateRaw(o);
	};
	
	exports.createInflateRaw = function(o) {
	  return new InflateRaw(o);
	};
	
	exports.createGzip = function(o) {
	  return new Gzip(o);
	};
	
	exports.createGunzip = function(o) {
	  return new Gunzip(o);
	};
	
	exports.createUnzip = function(o) {
	  return new Unzip(o);
	};
	
	
	// Convenience methods.
	// compress/decompress a string or buffer in one step.
	exports.deflate = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Deflate(opts), buffer, callback);
	};
	
	exports.deflateSync = function(buffer, opts) {
	  return zlibBufferSync(new Deflate(opts), buffer);
	};
	
	exports.gzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Gzip(opts), buffer, callback);
	};
	
	exports.gzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Gzip(opts), buffer);
	};
	
	exports.deflateRaw = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new DeflateRaw(opts), buffer, callback);
	};
	
	exports.deflateRawSync = function(buffer, opts) {
	  return zlibBufferSync(new DeflateRaw(opts), buffer);
	};
	
	exports.unzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Unzip(opts), buffer, callback);
	};
	
	exports.unzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Unzip(opts), buffer);
	};
	
	exports.inflate = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Inflate(opts), buffer, callback);
	};
	
	exports.inflateSync = function(buffer, opts) {
	  return zlibBufferSync(new Inflate(opts), buffer);
	};
	
	exports.gunzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Gunzip(opts), buffer, callback);
	};
	
	exports.gunzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Gunzip(opts), buffer);
	};
	
	exports.inflateRaw = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new InflateRaw(opts), buffer, callback);
	};
	
	exports.inflateRawSync = function(buffer, opts) {
	  return zlibBufferSync(new InflateRaw(opts), buffer);
	};
	
	function zlibBuffer(engine, buffer, callback) {
	  var buffers = [];
	  var nread = 0;
	
	  engine.on('error', onError);
	  engine.on('end', onEnd);
	
	  engine.end(buffer);
	  flow();
	
	  function flow() {
	    var chunk;
	    while (null !== (chunk = engine.read())) {
	      buffers.push(chunk);
	      nread += chunk.length;
	    }
	    engine.once('readable', flow);
	  }
	
	  function onError(err) {
	    engine.removeListener('end', onEnd);
	    engine.removeListener('readable', flow);
	    callback(err);
	  }
	
	  function onEnd() {
	    var buf = Buffer.concat(buffers, nread);
	    buffers = [];
	    callback(null, buf);
	    engine.close();
	  }
	}
	
	function zlibBufferSync(engine, buffer) {
	  if (typeof buffer === 'string')
	    buffer = new Buffer(buffer);
	  if (!Buffer.isBuffer(buffer))
	    throw new TypeError('Not a string or buffer');
	
	  var flushFlag = binding.Z_FINISH;
	
	  return engine._processChunk(buffer, flushFlag);
	}
	
	// generic zlib
	// minimal 2-byte header
	function Deflate(opts) {
	  if (!(this instanceof Deflate)) return new Deflate(opts);
	  Zlib.call(this, opts, binding.DEFLATE);
	}
	
	function Inflate(opts) {
	  if (!(this instanceof Inflate)) return new Inflate(opts);
	  Zlib.call(this, opts, binding.INFLATE);
	}
	
	
	
	// gzip - bigger header, same deflate compression
	function Gzip(opts) {
	  if (!(this instanceof Gzip)) return new Gzip(opts);
	  Zlib.call(this, opts, binding.GZIP);
	}
	
	function Gunzip(opts) {
	  if (!(this instanceof Gunzip)) return new Gunzip(opts);
	  Zlib.call(this, opts, binding.GUNZIP);
	}
	
	
	
	// raw - no header
	function DeflateRaw(opts) {
	  if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
	  Zlib.call(this, opts, binding.DEFLATERAW);
	}
	
	function InflateRaw(opts) {
	  if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
	  Zlib.call(this, opts, binding.INFLATERAW);
	}
	
	
	// auto-detect header.
	function Unzip(opts) {
	  if (!(this instanceof Unzip)) return new Unzip(opts);
	  Zlib.call(this, opts, binding.UNZIP);
	}
	
	
	// the Zlib class they all inherit from
	// This thing manages the queue of requests, and returns
	// true or false if there is anything in the queue when
	// you call the .write() method.
	
	function Zlib(opts, mode) {
	  this._opts = opts = opts || {};
	  this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;
	
	  Transform.call(this, opts);
	
	  if (opts.flush) {
	    if (opts.flush !== binding.Z_NO_FLUSH &&
	        opts.flush !== binding.Z_PARTIAL_FLUSH &&
	        opts.flush !== binding.Z_SYNC_FLUSH &&
	        opts.flush !== binding.Z_FULL_FLUSH &&
	        opts.flush !== binding.Z_FINISH &&
	        opts.flush !== binding.Z_BLOCK) {
	      throw new Error('Invalid flush flag: ' + opts.flush);
	    }
	  }
	  this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
	
	  if (opts.chunkSize) {
	    if (opts.chunkSize < exports.Z_MIN_CHUNK ||
	        opts.chunkSize > exports.Z_MAX_CHUNK) {
	      throw new Error('Invalid chunk size: ' + opts.chunkSize);
	    }
	  }
	
	  if (opts.windowBits) {
	    if (opts.windowBits < exports.Z_MIN_WINDOWBITS ||
	        opts.windowBits > exports.Z_MAX_WINDOWBITS) {
	      throw new Error('Invalid windowBits: ' + opts.windowBits);
	    }
	  }
	
	  if (opts.level) {
	    if (opts.level < exports.Z_MIN_LEVEL ||
	        opts.level > exports.Z_MAX_LEVEL) {
	      throw new Error('Invalid compression level: ' + opts.level);
	    }
	  }
	
	  if (opts.memLevel) {
	    if (opts.memLevel < exports.Z_MIN_MEMLEVEL ||
	        opts.memLevel > exports.Z_MAX_MEMLEVEL) {
	      throw new Error('Invalid memLevel: ' + opts.memLevel);
	    }
	  }
	
	  if (opts.strategy) {
	    if (opts.strategy != exports.Z_FILTERED &&
	        opts.strategy != exports.Z_HUFFMAN_ONLY &&
	        opts.strategy != exports.Z_RLE &&
	        opts.strategy != exports.Z_FIXED &&
	        opts.strategy != exports.Z_DEFAULT_STRATEGY) {
	      throw new Error('Invalid strategy: ' + opts.strategy);
	    }
	  }
	
	  if (opts.dictionary) {
	    if (!Buffer.isBuffer(opts.dictionary)) {
	      throw new Error('Invalid dictionary: it should be a Buffer instance');
	    }
	  }
	
	  this._binding = new binding.Zlib(mode);
	
	  var self = this;
	  this._hadError = false;
	  this._binding.onerror = function(message, errno) {
	    // there is no way to cleanly recover.
	    // continuing only obscures problems.
	    self._binding = null;
	    self._hadError = true;
	
	    var error = new Error(message);
	    error.errno = errno;
	    error.code = exports.codes[errno];
	    self.emit('error', error);
	  };
	
	  var level = exports.Z_DEFAULT_COMPRESSION;
	  if (typeof opts.level === 'number') level = opts.level;
	
	  var strategy = exports.Z_DEFAULT_STRATEGY;
	  if (typeof opts.strategy === 'number') strategy = opts.strategy;
	
	  this._binding.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS,
	                     level,
	                     opts.memLevel || exports.Z_DEFAULT_MEMLEVEL,
	                     strategy,
	                     opts.dictionary);
	
	  this._buffer = new Buffer(this._chunkSize);
	  this._offset = 0;
	  this._closed = false;
	  this._level = level;
	  this._strategy = strategy;
	
	  this.once('end', this.close);
	}
	
	util.inherits(Zlib, Transform);
	
	Zlib.prototype.params = function(level, strategy, callback) {
	  if (level < exports.Z_MIN_LEVEL ||
	      level > exports.Z_MAX_LEVEL) {
	    throw new RangeError('Invalid compression level: ' + level);
	  }
	  if (strategy != exports.Z_FILTERED &&
	      strategy != exports.Z_HUFFMAN_ONLY &&
	      strategy != exports.Z_RLE &&
	      strategy != exports.Z_FIXED &&
	      strategy != exports.Z_DEFAULT_STRATEGY) {
	    throw new TypeError('Invalid strategy: ' + strategy);
	  }
	
	  if (this._level !== level || this._strategy !== strategy) {
	    var self = this;
	    this.flush(binding.Z_SYNC_FLUSH, function() {
	      self._binding.params(level, strategy);
	      if (!self._hadError) {
	        self._level = level;
	        self._strategy = strategy;
	        if (callback) callback();
	      }
	    });
	  } else {
	    process.nextTick(callback);
	  }
	};
	
	Zlib.prototype.reset = function() {
	  return this._binding.reset();
	};
	
	// This is the _flush function called by the transform class,
	// internally, when the last chunk has been written.
	Zlib.prototype._flush = function(callback) {
	  this._transform(new Buffer(0), '', callback);
	};
	
	Zlib.prototype.flush = function(kind, callback) {
	  var ws = this._writableState;
	
	  if (typeof kind === 'function' || (kind === void 0 && !callback)) {
	    callback = kind;
	    kind = binding.Z_FULL_FLUSH;
	  }
	
	  if (ws.ended) {
	    if (callback)
	      process.nextTick(callback);
	  } else if (ws.ending) {
	    if (callback)
	      this.once('end', callback);
	  } else if (ws.needDrain) {
	    var self = this;
	    this.once('drain', function() {
	      self.flush(callback);
	    });
	  } else {
	    this._flushFlag = kind;
	    this.write(new Buffer(0), '', callback);
	  }
	};
	
	Zlib.prototype.close = function(callback) {
	  if (callback)
	    process.nextTick(callback);
	
	  if (this._closed)
	    return;
	
	  this._closed = true;
	
	  this._binding.close();
	
	  var self = this;
	  process.nextTick(function() {
	    self.emit('close');
	  });
	};
	
	Zlib.prototype._transform = function(chunk, encoding, cb) {
	  var flushFlag;
	  var ws = this._writableState;
	  var ending = ws.ending || ws.ended;
	  var last = ending && (!chunk || ws.length === chunk.length);
	
	  if (!chunk === null && !Buffer.isBuffer(chunk))
	    return cb(new Error('invalid input'));
	
	  // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag.
	  // If it's explicitly flushing at some other time, then we use
	  // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
	  // goodness.
	  if (last)
	    flushFlag = binding.Z_FINISH;
	  else {
	    flushFlag = this._flushFlag;
	    // once we've flushed the last of the queue, stop flushing and
	    // go back to the normal behavior.
	    if (chunk.length >= ws.length) {
	      this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
	    }
	  }
	
	  var self = this;
	  this._processChunk(chunk, flushFlag, cb);
	};
	
	Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
	  var availInBefore = chunk && chunk.length;
	  var availOutBefore = this._chunkSize - this._offset;
	  var inOff = 0;
	
	  var self = this;
	
	  var async = typeof cb === 'function';
	
	  if (!async) {
	    var buffers = [];
	    var nread = 0;
	
	    var error;
	    this.on('error', function(er) {
	      error = er;
	    });
	
	    do {
	      var res = this._binding.writeSync(flushFlag,
	                                        chunk, // in
	                                        inOff, // in_off
	                                        availInBefore, // in_len
	                                        this._buffer, // out
	                                        this._offset, //out_off
	                                        availOutBefore); // out_len
	    } while (!this._hadError && callback(res[0], res[1]));
	
	    if (this._hadError) {
	      throw error;
	    }
	
	    var buf = Buffer.concat(buffers, nread);
	    this.close();
	
	    return buf;
	  }
	
	  var req = this._binding.write(flushFlag,
	                                chunk, // in
	                                inOff, // in_off
	                                availInBefore, // in_len
	                                this._buffer, // out
	                                this._offset, //out_off
	                                availOutBefore); // out_len
	
	  req.buffer = chunk;
	  req.callback = callback;
	
	  function callback(availInAfter, availOutAfter) {
	    if (self._hadError)
	      return;
	
	    var have = availOutBefore - availOutAfter;
	    assert(have >= 0, 'have should not go down');
	
	    if (have > 0) {
	      var out = self._buffer.slice(self._offset, self._offset + have);
	      self._offset += have;
	      // serve some output to the consumer.
	      if (async) {
	        self.push(out);
	      } else {
	        buffers.push(out);
	        nread += out.length;
	      }
	    }
	
	    // exhausted the output buffer, or used all the input create a new one.
	    if (availOutAfter === 0 || self._offset >= self._chunkSize) {
	      availOutBefore = self._chunkSize;
	      self._offset = 0;
	      self._buffer = new Buffer(self._chunkSize);
	    }
	
	    if (availOutAfter === 0) {
	      // Not actually done.  Need to reprocess.
	      // Also, update the availInBefore to the availInAfter value,
	      // so that if we have to hit it a third (fourth, etc.) time,
	      // it'll have the correct byte counts.
	      inOff += (availInBefore - availInAfter);
	      availInBefore = availInAfter;
	
	      if (!async)
	        return true;
	
	      var newReq = self._binding.write(flushFlag,
	                                       chunk,
	                                       inOff,
	                                       availInBefore,
	                                       self._buffer,
	                                       self._offset,
	                                       self._chunkSize);
	      newReq.callback = callback; // this same function
	      newReq.buffer = chunk;
	      return;
	    }
	
	    if (!async)
	      return false;
	
	    // finished with the chunk.
	    cb();
	  }
	};
	
	util.inherits(Deflate, Zlib);
	util.inherits(Inflate, Zlib);
	util.inherits(Gzip, Zlib);
	util.inherits(Gunzip, Zlib);
	util.inherits(DeflateRaw, Zlib);
	util.inherits(InflateRaw, Zlib);
	util.inherits(Unzip, Zlib);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62).Buffer, __webpack_require__(39)))

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(213);
	
	var $apply = __webpack_require__(335);
	var $call = __webpack_require__(336);
	var $reflectApply = __webpack_require__(1234);
	
	/** @type {import('./actualApply')} */
	module.exports = $reflectApply || bind.call($call, $apply);


/***/ },
/* 515 */
/***/ function(module, exports) {

	var charenc = {
	  // UTF-8 encoding
	  utf8: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
	    }
	  },
	
	  // Binary encoding
	  bin: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      for (var bytes = [], i = 0; i < str.length; i++)
	        bytes.push(str.charCodeAt(i) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      for (var str = [], i = 0; i < bytes.length; i++)
	        str.push(String.fromCharCode(bytes[i]));
	      return str.join('');
	    }
	  }
	};
	
	module.exports = charenc;


/***/ },
/* 516 */
[2095, 63],
/* 517 */
[2096, 93, 158, 339],
/* 518 */
[2097, 197],
/* 519 */
[2098, 159, 64],
/* 520 */
[2100, 92],
/* 521 */
[2102, 198, 68, 531, 132, 159, 1267, 251, 525, 64],
/* 522 */
[2103, 64],
/* 523 */
[2111, 199, 200, 133, 348, 131, 517, 93],
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(526);
	var hiddenKeys = __webpack_require__(340).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 525 */
[2112, 131, 161, 344],
/* 526 */
[2113, 131, 133, 1261, 344],
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(68);
	var core = __webpack_require__(43);
	var fails = __webpack_require__(158);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 528 */
[2115, 93, 160, 133, 199],
/* 529 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 530 */
[2116, 92, 122, 341],
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(132);


/***/ },
/* 532 */
[2121, 92, 250, 64],
/* 533 */
[2123, 157, 1265, 516, 339, 63, 197],
/* 534 */
/***/ function(module, exports) {



/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(66)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(162)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 536 */
[2088, 207, 366, 1325],
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(134);
	var IObject = __webpack_require__(356);
	var toObject = __webpack_require__(367);
	var toLength = __webpack_require__(366);
	var asc = __webpack_require__(1299);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 538 */
340,
/* 539 */
[2095, 58],
/* 540 */
[2096, 123, 204, 355],
/* 541 */
[2102, 357, 79, 136, 162, 205, 1309, 256, 1317, 66],
/* 542 */
[2103, 66],
/* 543 */
529,
/* 544 */
[2116, 113, 65, 359],
/* 545 */
[2121, 113, 202, 66],
/* 546 */
[2123, 134, 1304, 539, 355, 58, 203],
/* 547 */
[2128, 65],
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(353);
	var test = {};
	test[__webpack_require__(66)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(136)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(1328);
	var getKeys = __webpack_require__(255);
	var redefine = __webpack_require__(136);
	var global = __webpack_require__(58);
	var hide = __webpack_require__(162);
	var Iterators = __webpack_require__(205);
	var wks = __webpack_require__(66);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(1341);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 551 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function contains(other) {
		if (arguments.length < 1) {
			throw new TypeError('1 argument is required');
		}
		if (typeof other !== 'object') {
			throw new TypeError('Argument 1 (”other“) to Node.contains must be an instance of Node');
		}
	
		var node = other;
		do {
			if (this === node) {
				return true;
			}
			if (node) {
				node = node.parentNode;
			}
		} while (node);
	
		return false;
	};


/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(551);
	
	module.exports = function getPolyfill() {
		if (typeof document !== 'undefined') {
			if (document.contains) {
				return document.contains;
			}
			if (document.body && document.body.contains) {
				try {
					if (typeof document.body.contains.call(document, '') === 'boolean') {
						return document.body.contains;
					}
				} catch (e) { /**/ }
			}
		}
		return implementation;
	};


/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(45);
	
	exports.__esModule = true;
	exports.default = activeElement;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(163));
	
	function activeElement(doc) {
	  if (doc === void 0) {
	    doc = (0, _ownerDocument.default)();
	  }
	
	  try {
	    return doc.activeElement;
	  } catch (e) {
	    /* ie throws if no active element */
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 554 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(45);
	
	exports.__esModule = true;
	exports.default = offset;
	
	var _contains = _interopRequireDefault(__webpack_require__(164));
	
	var _isWindow = _interopRequireDefault(__webpack_require__(259));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(163));
	
	function offset(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      win = (0, _isWindow.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = {
	    top: 0,
	    left: 0,
	    height: 0,
	    width: 0
	  };
	  if (!doc) return; // Make sure it's not a disconnected DOM node
	
	  if (!(0, _contains.default)(docElem, node)) return box;
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height
	
	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	  return box;
	}
	
	module.exports = exports["default"];

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(45);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(259));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(45);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(124));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(45);
	
	exports.__esModule = true;
	exports.default = camelizeStyleName;
	
	var _camelize = _interopRequireDefault(__webpack_require__(1358));
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	var msPattern = /^-ms-/;
	
	function camelizeStyleName(string) {
	  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = exports["default"];

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(45);
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(124));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $TypeError = __webpack_require__(22);
	
	var isPropertyDescriptor = __webpack_require__(125);
	var fromPropertyDescriptor = __webpack_require__(1386);
	
	// https://262.ecma-international.org/6.0/#sec-frompropertydescriptor
	
	module.exports = function FromPropertyDescriptor(Desc) {
		if (typeof Desc !== 'undefined' && !isPropertyDescriptor(Desc)) {
			throw new $TypeError('Assertion failed: `Desc` must be a Property Descriptor');
		}
	
		return fromPropertyDescriptor(Desc);
	};


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ToNumber = __webpack_require__(1379);
	var truncate = __webpack_require__(1384);
	
	var $isNaN = __webpack_require__(216);
	var $isFinite = __webpack_require__(666);
	
	// https://262.ecma-international.org/14.0/#sec-tointegerorinfinity
	
	module.exports = function ToIntegerOrInfinity(value) {
		var number = ToNumber(value);
		if ($isNaN(number) || number === 0) { return 0; }
		if (!$isFinite(number)) { return number; }
		return truncate(number);
	};


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var MAX_SAFE_INTEGER = __webpack_require__(665);
	
	var ToIntegerOrInfinity = __webpack_require__(561);
	
	// https://262.ecma-international.org/12.0/#sec-tolength
	
	module.exports = function ToLength(argument) {
		var len = ToIntegerOrInfinity(argument);
		if (len <= 0) { return 0; } // includes converting -0 to +0
		if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
		return len;
	};


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasOwn = __webpack_require__(141);
	
	var $TypeError = __webpack_require__(22);
	var isObject = __webpack_require__(95);
	
	var IsCallable = __webpack_require__(1371);
	var ToBoolean = __webpack_require__(1378);
	
	// https://262.ecma-international.org/5.1/#sec-8.10.5
	
	module.exports = function ToPropertyDescriptor(Obj) {
		if (!isObject(Obj)) {
			throw new $TypeError('ToPropertyDescriptor requires an object');
		}
	
		var desc = {};
		if (hasOwn(Obj, 'enumerable')) {
			desc['[[Enumerable]]'] = ToBoolean(Obj.enumerable);
		}
		if (hasOwn(Obj, 'configurable')) {
			desc['[[Configurable]]'] = ToBoolean(Obj.configurable);
		}
		if (hasOwn(Obj, 'value')) {
			desc['[[Value]]'] = Obj.value;
		}
		if (hasOwn(Obj, 'writable')) {
			desc['[[Writable]]'] = ToBoolean(Obj.writable);
		}
		if (hasOwn(Obj, 'get')) {
			var getter = Obj.get;
			if (typeof getter !== 'undefined' && !IsCallable(getter)) {
				throw new $TypeError('getter must be a function');
			}
			desc['[[Get]]'] = getter;
		}
		if (hasOwn(Obj, 'set')) {
			var setter = Obj.set;
			if (typeof setter !== 'undefined' && !IsCallable(setter)) {
				throw new $TypeError('setter must be a function');
			}
			desc['[[Set]]'] = setter;
		}
	
		if ((hasOwn(desc, '[[Get]]') || hasOwn(desc, '[[Set]]')) && (hasOwn(desc, '[[Value]]') || hasOwn(desc, '[[Writable]]'))) {
			throw new $TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
		}
		return desc;
	};


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(85);
	
	var $String = GetIntrinsic('%String%');
	var $TypeError = __webpack_require__(22);
	
	// https://262.ecma-international.org/6.0/#sec-tostring
	
	module.exports = function ToString(argument) {
		if (typeof argument === 'symbol') {
			throw new $TypeError('Cannot convert a Symbol value to a string');
		}
		return $String(argument);
	};


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasPropertyDescriptors = __webpack_require__(274);
	
	var $defineProperty = __webpack_require__(208);
	
	var hasArrayLengthDefineBug = hasPropertyDescriptors.hasArrayLengthDefineBug();
	
	// eslint-disable-next-line global-require
	var isArray = hasArrayLengthDefineBug && __webpack_require__(566);
	
	var callBound = __webpack_require__(84);
	
	var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');
	
	// eslint-disable-next-line max-params
	module.exports = function DefineOwnProperty(IsDataDescriptor, SameValue, FromPropertyDescriptor, O, P, desc) {
		if (!$defineProperty) {
			if (!IsDataDescriptor(desc)) {
				// ES3 does not support getters/setters
				return false;
			}
			if (!desc['[[Configurable]]'] || !desc['[[Writable]]']) {
				return false;
			}
	
			// fallback for ES3
			if (P in O && $isEnumerable(O, P) !== !!desc['[[Enumerable]]']) {
				// a non-enumerable existing property
				return false;
			}
	
			// property does not exist at all, or exists but is enumerable
			var V = desc['[[Value]]'];
			// eslint-disable-next-line no-param-reassign
			O[P] = V; // will use [[Define]]
			return SameValue(O[P], V);
		}
		if (
			hasArrayLengthDefineBug
			&& P === 'length'
			&& '[[Value]]' in desc
			&& isArray(O)
			&& O.length !== desc['[[Value]]']
		) {
			// eslint-disable-next-line no-param-reassign
			O.length = desc['[[Value]]'];
			return O.length === desc['[[Value]]'];
		}
	
		$defineProperty(O, P, FromPropertyDescriptor(desc));
		return true;
	};


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(85);
	
	var $Array = GetIntrinsic('%Array%');
	
	// eslint-disable-next-line global-require
	var toStr = !$Array.isArray && __webpack_require__(84)('Object.prototype.toString');
	
	module.exports = $Array.isArray || function IsArray(argument) {
		return toStr(argument) === '[object Array]';
	};


/***/ },
/* 567 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isPrimitive(value) {
		return value === null || (typeof value !== 'function' && typeof value !== 'object');
	};


/***/ },
/* 568 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./range')} */
	module.exports = RangeError;


/***/ },
/* 569 */
138,
/* 570 */
138,
/* 571 */
138,
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var fullyConnectedLayer_1 = __webpack_require__(264);
	var util_1 = __webpack_require__(606);
	var TinyXception_1 = __webpack_require__(1505);
	var extractParams_1 = __webpack_require__(1438);
	var extractParamsFromWeigthMap_1 = __webpack_require__(1439);
	var types_1 = __webpack_require__(377);
	var NeuralNetwork_1 = __webpack_require__(96);
	var dom_1 = __webpack_require__(54);
	var AgeGenderNet = /** @class */ (function (_super) {
	    tslib_1.__extends(AgeGenderNet, _super);
	    function AgeGenderNet(faceFeatureExtractor) {
	        if (faceFeatureExtractor === void 0) { faceFeatureExtractor = new TinyXception_1.TinyXception(2); }
	        var _this = _super.call(this, 'AgeGenderNet') || this;
	        _this._faceFeatureExtractor = faceFeatureExtractor;
	        return _this;
	    }
	    Object.defineProperty(AgeGenderNet.prototype, "faceFeatureExtractor", {
	        get: function () {
	            return this._faceFeatureExtractor;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AgeGenderNet.prototype.runNet = function (input) {
	        var _this = this;
	        var params = this.params;
	        if (!params) {
	            throw new Error(this._name + " - load model before inference");
	        }
	        return tf.tidy(function () {
	            var bottleneckFeatures = input instanceof dom_1.NetInput
	                ? _this.faceFeatureExtractor.forwardInput(input)
	                : input;
	            var pooled = tf.avgPool(bottleneckFeatures, [7, 7], [2, 2], 'valid').as2D(bottleneckFeatures.shape[0], -1);
	            var age = fullyConnectedLayer_1.fullyConnectedLayer(pooled, params.fc.age).as1D();
	            var gender = fullyConnectedLayer_1.fullyConnectedLayer(pooled, params.fc.gender);
	            return { age: age, gender: gender };
	        });
	    };
	    AgeGenderNet.prototype.forwardInput = function (input) {
	        var _this = this;
	        return tf.tidy(function () {
	            var _a = _this.runNet(input), age = _a.age, gender = _a.gender;
	            return { age: age, gender: tf.softmax(gender) };
	        });
	    };
	    AgeGenderNet.prototype.forward = function (input) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _a;
	            return tslib_1.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        _a = this.forwardInput;
	                        return [4 /*yield*/, dom_1.toNetInput(input)];
	                    case 1: return [2 /*return*/, _a.apply(this, [_b.sent()])];
	                }
	            });
	        });
	    };
	    AgeGenderNet.prototype.predictAgeAndGender = function (input) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var netInput, out, ages, genders, ageAndGenderTensors, predictionsByBatch;
	            var _this = this;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, dom_1.toNetInput(input)];
	                    case 1:
	                        netInput = _a.sent();
	                        return [4 /*yield*/, this.forwardInput(netInput)];
	                    case 2:
	                        out = _a.sent();
	                        ages = tf.unstack(out.age);
	                        genders = tf.unstack(out.gender);
	                        ageAndGenderTensors = ages.map(function (ageTensor, i) { return ({
	                            ageTensor: ageTensor,
	                            genderTensor: genders[i]
	                        }); });
	                        return [4 /*yield*/, Promise.all(ageAndGenderTensors.map(function (_a) {
	                                var ageTensor = _a.ageTensor, genderTensor = _a.genderTensor;
	                                return tslib_1.__awaiter(_this, void 0, void 0, function () {
	                                    var age, probMale, isMale, gender, genderProbability;
	                                    return tslib_1.__generator(this, function (_b) {
	                                        switch (_b.label) {
	                                            case 0: return [4 /*yield*/, ageTensor.data()];
	                                            case 1:
	                                                age = (_b.sent())[0];
	                                                return [4 /*yield*/, genderTensor.data()];
	                                            case 2:
	                                                probMale = (_b.sent())[0];
	                                                isMale = probMale > 0.5;
	                                                gender = isMale ? types_1.Gender.MALE : types_1.Gender.FEMALE;
	                                                genderProbability = isMale ? probMale : (1 - probMale);
	                                                ageTensor.dispose();
	                                                genderTensor.dispose();
	                                                return [2 /*return*/, { age: age, gender: gender, genderProbability: genderProbability }];
	                                        }
	                                    });
	                                });
	                            }))];
	                    case 3:
	                        predictionsByBatch = _a.sent();
	                        out.age.dispose();
	                        out.gender.dispose();
	                        return [2 /*return*/, netInput.isBatchInput
	                                ? predictionsByBatch
	                                : predictionsByBatch[0]];
	                }
	            });
	        });
	    };
	    AgeGenderNet.prototype.getDefaultModelName = function () {
	        return 'age_gender_model';
	    };
	    AgeGenderNet.prototype.dispose = function (throwOnRedispose) {
	        if (throwOnRedispose === void 0) { throwOnRedispose = true; }
	        this.faceFeatureExtractor.dispose(throwOnRedispose);
	        _super.prototype.dispose.call(this, throwOnRedispose);
	    };
	    AgeGenderNet.prototype.loadClassifierParams = function (weights) {
	        var _a = this.extractClassifierParams(weights), params = _a.params, paramMappings = _a.paramMappings;
	        this._params = params;
	        this._paramMappings = paramMappings;
	    };
	    AgeGenderNet.prototype.extractClassifierParams = function (weights) {
	        return extractParams_1.extractParams(weights);
	    };
	    AgeGenderNet.prototype.extractParamsFromWeigthMap = function (weightMap) {
	        var _a = util_1.seperateWeightMaps(weightMap), featureExtractorMap = _a.featureExtractorMap, classifierMap = _a.classifierMap;
	        this.faceFeatureExtractor.loadFromWeightMap(featureExtractorMap);
	        return extractParamsFromWeigthMap_1.extractParamsFromWeigthMap(classifierMap);
	    };
	    AgeGenderNet.prototype.extractParams = function (weights) {
	        var classifierWeightSize = (512 * 1 + 1) + (512 * 2 + 2);
	        var featureExtractorWeights = weights.slice(0, weights.length - classifierWeightSize);
	        var classifierWeights = weights.slice(weights.length - classifierWeightSize);
	        this.faceFeatureExtractor.extractWeights(featureExtractorWeights);
	        return this.extractClassifierParams(classifierWeights);
	    };
	    return AgeGenderNet;
	}(NeuralNetwork_1.NeuralNetwork));
	exports.AgeGenderNet = AgeGenderNet;
	//# sourceMappingURL=AgeGenderNet.js.map

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var Box_1 = __webpack_require__(165);
	var BoundingBox = /** @class */ (function (_super) {
	    tslib_1.__extends(BoundingBox, _super);
	    function BoundingBox(left, top, right, bottom, allowNegativeDimensions) {
	        if (allowNegativeDimensions === void 0) { allowNegativeDimensions = false; }
	        return _super.call(this, { left: left, top: top, right: right, bottom: bottom }, allowNegativeDimensions) || this;
	    }
	    return BoundingBox;
	}(Box_1.Box));
	exports.BoundingBox = BoundingBox;
	//# sourceMappingURL=BoundingBox.js.map

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var utils_1 = __webpack_require__(34);
	var FaceLandmarks_1 = __webpack_require__(166);
	var FaceLandmarks5 = /** @class */ (function (_super) {
	    tslib_1.__extends(FaceLandmarks5, _super);
	    function FaceLandmarks5() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    FaceLandmarks5.prototype.getRefPointsForAlignment = function () {
	        var pts = this.positions;
	        return [
	            pts[0],
	            pts[1],
	            utils_1.getCenterPoint([pts[3], pts[4]])
	        ];
	    };
	    return FaceLandmarks5;
	}(FaceLandmarks_1.FaceLandmarks));
	exports.FaceLandmarks5 = FaceLandmarks5;
	//# sourceMappingURL=FaceLandmarks5.js.map

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(34);
	var FaceMatch = /** @class */ (function () {
	    function FaceMatch(label, distance) {
	        this._label = label;
	        this._distance = distance;
	    }
	    Object.defineProperty(FaceMatch.prototype, "label", {
	        get: function () { return this._label; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FaceMatch.prototype, "distance", {
	        get: function () { return this._distance; },
	        enumerable: true,
	        configurable: true
	    });
	    FaceMatch.prototype.toString = function (withDistance) {
	        if (withDistance === void 0) { withDistance = true; }
	        return "" + this.label + (withDistance ? " (" + utils_1.round(this.distance) + ")" : '');
	    };
	    return FaceMatch;
	}());
	exports.FaceMatch = FaceMatch;
	//# sourceMappingURL=FaceMatch.js.map

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var utils_1 = __webpack_require__(34);
	var Box_1 = __webpack_require__(165);
	var LabeledBox = /** @class */ (function (_super) {
	    tslib_1.__extends(LabeledBox, _super);
	    function LabeledBox(box, label) {
	        var _this = _super.call(this, box) || this;
	        _this._label = label;
	        return _this;
	    }
	    LabeledBox.assertIsValidLabeledBox = function (box, callee) {
	        Box_1.Box.assertIsValidBox(box, callee);
	        if (!utils_1.isValidNumber(box.label)) {
	            throw new Error(callee + " - expected property label (" + box.label + ") to be a number");
	        }
	    };
	    Object.defineProperty(LabeledBox.prototype, "label", {
	        get: function () { return this._label; },
	        enumerable: true,
	        configurable: true
	    });
	    return LabeledBox;
	}(Box_1.Box));
	exports.LabeledBox = LabeledBox;
	//# sourceMappingURL=LabeledBox.js.map

/***/ },
/* 577 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var LabeledFaceDescriptors = /** @class */ (function () {
	    function LabeledFaceDescriptors(label, descriptors) {
	        if (!(typeof label === 'string')) {
	            throw new Error('LabeledFaceDescriptors - constructor expected label to be a string');
	        }
	        if (!Array.isArray(descriptors) || descriptors.some(function (desc) { return !(desc instanceof Float32Array); })) {
	            throw new Error('LabeledFaceDescriptors - constructor expected descriptors to be an array of Float32Array');
	        }
	        this._label = label;
	        this._descriptors = descriptors;
	    }
	    Object.defineProperty(LabeledFaceDescriptors.prototype, "label", {
	        get: function () { return this._label; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(LabeledFaceDescriptors.prototype, "descriptors", {
	        get: function () { return this._descriptors; },
	        enumerable: true,
	        configurable: true
	    });
	    LabeledFaceDescriptors.prototype.toJSON = function () {
	        return {
	            label: this.label,
	            descriptors: this.descriptors.map(function (d) { return Array.from(d); })
	        };
	    };
	    LabeledFaceDescriptors.fromJSON = function (json) {
	        var descriptors = json.descriptors.map(function (d) {
	            return new Float32Array(d);
	        });
	        return new LabeledFaceDescriptors(json.label, descriptors);
	    };
	    return LabeledFaceDescriptors;
	}());
	exports.LabeledFaceDescriptors = LabeledFaceDescriptors;
	//# sourceMappingURL=LabeledFaceDescriptors.js.map

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var Box_1 = __webpack_require__(165);
	var Rect = /** @class */ (function (_super) {
	    tslib_1.__extends(Rect, _super);
	    function Rect(x, y, width, height, allowNegativeDimensions) {
	        if (allowNegativeDimensions === void 0) { allowNegativeDimensions = false; }
	        return _super.call(this, { x: x, y: y, width: width, height: height }, allowNegativeDimensions) || this;
	    }
	    return Rect;
	}(Box_1.Box));
	exports.Rect = Rect;
	//# sourceMappingURL=Rect.js.map

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	function depthwiseSeparableConv(x, params, stride) {
	    return tf.tidy(function () {
	        var out = tf.separableConv2d(x, params.depthwise_filter, params.pointwise_filter, stride, 'same');
	        out = tf.add(out, params.bias);
	        return out;
	    });
	}
	exports.depthwiseSeparableConv = depthwiseSeparableConv;
	//# sourceMappingURL=depthwiseSeparableConv.js.map

/***/ },
/* 580 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function disposeUnusedWeightTensors(weightMap, paramMappings) {
	    Object.keys(weightMap).forEach(function (path) {
	        if (!paramMappings.some(function (pm) { return pm.originalPath === path; })) {
	            weightMap[path].dispose();
	        }
	    });
	}
	exports.disposeUnusedWeightTensors = disposeUnusedWeightTensors;
	//# sourceMappingURL=disposeUnusedWeightTensors.js.map

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(34);
	function extractWeightEntryFactory(weightMap, paramMappings) {
	    return function (originalPath, paramRank, mappedPath) {
	        var tensor = weightMap[originalPath];
	        if (!utils_1.isTensor(tensor, paramRank)) {
	            throw new Error("expected weightMap[" + originalPath + "] to be a Tensor" + paramRank + "D, instead have " + tensor);
	        }
	        paramMappings.push({ originalPath: originalPath, paramPath: mappedPath || originalPath });
	        return tensor;
	    };
	}
	exports.extractWeightEntryFactory = extractWeightEntryFactory;
	//# sourceMappingURL=extractWeightEntryFactory.js.map

/***/ },
/* 582 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function extractWeightsFactory(weights) {
	    var remainingWeights = weights;
	    function extractWeights(numWeights) {
	        var ret = remainingWeights.slice(0, numWeights);
	        remainingWeights = remainingWeights.slice(numWeights);
	        return ret;
	    }
	    function getRemainingWeights() {
	        return remainingWeights;
	    }
	    return {
	        extractWeights: extractWeights,
	        getRemainingWeights: getRemainingWeights
	    };
	}
	exports.extractWeightsFactory = extractWeightsFactory;
	//# sourceMappingURL=extractWeightsFactory.js.map

/***/ },
/* 583 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function loadConvParamsFactory(extractWeightEntry) {
	    return function (prefix) {
	        var filters = extractWeightEntry(prefix + "/filters", 4);
	        var bias = extractWeightEntry(prefix + "/bias", 1);
	        return { filters: filters, bias: bias };
	    };
	}
	exports.loadConvParamsFactory = loadConvParamsFactory;
	//# sourceMappingURL=loadConvParamsFactory.js.map

/***/ },
/* 584 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var SeparableConvParams = /** @class */ (function () {
	    function SeparableConvParams(depthwise_filter, pointwise_filter, bias) {
	        this.depthwise_filter = depthwise_filter;
	        this.pointwise_filter = pointwise_filter;
	        this.bias = bias;
	    }
	    return SeparableConvParams;
	}());
	exports.SeparableConvParams = SeparableConvParams;
	//# sourceMappingURL=types.js.map

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	var env_1 = __webpack_require__(55);
	var padToSquare_1 = __webpack_require__(621);
	var utils_1 = __webpack_require__(34);
	var createCanvas_1 = __webpack_require__(265);
	var imageToSquare_1 = __webpack_require__(590);
	var NetInput = /** @class */ (function () {
	    function NetInput(inputs, treatAsBatchInput) {
	        var _this = this;
	        if (treatAsBatchInput === void 0) { treatAsBatchInput = false; }
	        this._imageTensors = [];
	        this._canvases = [];
	        this._treatAsBatchInput = false;
	        this._inputDimensions = [];
	        if (!Array.isArray(inputs)) {
	            throw new Error("NetInput.constructor - expected inputs to be an Array of TResolvedNetInput or to be instanceof tf.Tensor4D, instead have " + inputs);
	        }
	        this._treatAsBatchInput = treatAsBatchInput;
	        this._batchSize = inputs.length;
	        inputs.forEach(function (input, idx) {
	            if (utils_1.isTensor3D(input)) {
	                _this._imageTensors[idx] = input;
	                _this._inputDimensions[idx] = input.shape;
	                return;
	            }
	            if (utils_1.isTensor4D(input)) {
	                var batchSize = input.shape[0];
	                if (batchSize !== 1) {
	                    throw new Error("NetInput - tf.Tensor4D with batchSize " + batchSize + " passed, but not supported in input array");
	                }
	                _this._imageTensors[idx] = input;
	                _this._inputDimensions[idx] = input.shape.slice(1);
	                return;
	            }
	            var canvas = input instanceof env_1.env.getEnv().Canvas ? input : createCanvas_1.createCanvasFromMedia(input);
	            _this._canvases[idx] = canvas;
	            _this._inputDimensions[idx] = [canvas.height, canvas.width, 3];
	        });
	    }
	    Object.defineProperty(NetInput.prototype, "imageTensors", {
	        get: function () {
	            return this._imageTensors;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NetInput.prototype, "canvases", {
	        get: function () {
	            return this._canvases;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NetInput.prototype, "isBatchInput", {
	        get: function () {
	            return this.batchSize > 1 || this._treatAsBatchInput;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NetInput.prototype, "batchSize", {
	        get: function () {
	            return this._batchSize;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NetInput.prototype, "inputDimensions", {
	        get: function () {
	            return this._inputDimensions;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NetInput.prototype, "inputSize", {
	        get: function () {
	            return this._inputSize;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NetInput.prototype, "reshapedInputDimensions", {
	        get: function () {
	            var _this = this;
	            return utils_1.range(this.batchSize, 0, 1).map(function (_, batchIdx) { return _this.getReshapedInputDimensions(batchIdx); });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    NetInput.prototype.getInput = function (batchIdx) {
	        return this.canvases[batchIdx] || this.imageTensors[batchIdx];
	    };
	    NetInput.prototype.getInputDimensions = function (batchIdx) {
	        return this._inputDimensions[batchIdx];
	    };
	    NetInput.prototype.getInputHeight = function (batchIdx) {
	        return this._inputDimensions[batchIdx][0];
	    };
	    NetInput.prototype.getInputWidth = function (batchIdx) {
	        return this._inputDimensions[batchIdx][1];
	    };
	    NetInput.prototype.getReshapedInputDimensions = function (batchIdx) {
	        if (typeof this.inputSize !== 'number') {
	            throw new Error('getReshapedInputDimensions - inputSize not set, toBatchTensor has not been called yet');
	        }
	        var width = this.getInputWidth(batchIdx);
	        var height = this.getInputHeight(batchIdx);
	        return utils_1.computeReshapedDimensions({ width: width, height: height }, this.inputSize);
	    };
	    /**
	     * Create a batch tensor from all input canvases and tensors
	     * with size [batchSize, inputSize, inputSize, 3].
	     *
	     * @param inputSize Height and width of the tensor.
	     * @param isCenterImage (optional, default: false) If true, add an equal amount of padding on
	     * both sides of the minor dimension oof the image.
	     * @returns The batch tensor.
	     */
	    NetInput.prototype.toBatchTensor = function (inputSize, isCenterInputs) {
	        var _this = this;
	        if (isCenterInputs === void 0) { isCenterInputs = true; }
	        this._inputSize = inputSize;
	        return tf.tidy(function () {
	            var inputTensors = utils_1.range(_this.batchSize, 0, 1).map(function (batchIdx) {
	                var input = _this.getInput(batchIdx);
	                if (input instanceof tf.Tensor) {
	                    var imgTensor = utils_1.isTensor4D(input) ? input : input.expandDims();
	                    imgTensor = padToSquare_1.padToSquare(imgTensor, isCenterInputs);
	                    if (imgTensor.shape[1] !== inputSize || imgTensor.shape[2] !== inputSize) {
	                        imgTensor = tf.image.resizeBilinear(imgTensor, [inputSize, inputSize]);
	                    }
	                    return imgTensor.as3D(inputSize, inputSize, 3);
	                }
	                if (input instanceof env_1.env.getEnv().Canvas) {
	                    return tf.browser.fromPixels(imageToSquare_1.imageToSquare(input, inputSize, isCenterInputs));
	                }
	                throw new Error("toBatchTensor - at batchIdx " + batchIdx + ", expected input to be instanceof tf.Tensor or instanceof HTMLCanvasElement, instead have " + input);
	            });
	            var batchTensor = tf.stack(inputTensors.map(function (t) { return t.toFloat(); })).as4D(_this.batchSize, inputSize, inputSize, 3);
	            return batchTensor;
	        });
	    };
	    return NetInput;
	}());
	exports.NetInput = NetInput;
	//# sourceMappingURL=NetInput.js.map

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var env_1 = __webpack_require__(55);
	var isMediaLoaded_1 = __webpack_require__(383);
	function awaitMediaLoaded(media) {
	    return new Promise(function (resolve, reject) {
	        if (media instanceof env_1.env.getEnv().Canvas || isMediaLoaded_1.isMediaLoaded(media)) {
	            return resolve();
	        }
	        function onLoad(e) {
	            if (!e.currentTarget)
	                return;
	            e.currentTarget.removeEventListener('load', onLoad);
	            e.currentTarget.removeEventListener('error', onError);
	            resolve(e);
	        }
	        function onError(e) {
	            if (!e.currentTarget)
	                return;
	            e.currentTarget.removeEventListener('load', onLoad);
	            e.currentTarget.removeEventListener('error', onError);
	            reject(e);
	        }
	        media.addEventListener('load', onLoad);
	        media.addEventListener('error', onError);
	    });
	}
	exports.awaitMediaLoaded = awaitMediaLoaded;
	//# sourceMappingURL=awaitMediaLoaded.js.map

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var env_1 = __webpack_require__(55);
	function bufferToImage(buf) {
	    return new Promise(function (resolve, reject) {
	        if (!(buf instanceof Blob)) {
	            return reject('bufferToImage - expected buf to be of type: Blob');
	        }
	        var reader = new FileReader();
	        reader.onload = function () {
	            if (typeof reader.result !== 'string') {
	                return reject('bufferToImage - expected reader.result to be a string, in onload');
	            }
	            var img = env_1.env.getEnv().createImageElement();
	            img.onload = function () { return resolve(img); };
	            img.onerror = reject;
	            img.src = reader.result;
	        };
	        reader.onerror = reject;
	        reader.readAsDataURL(buf);
	    });
	}
	exports.bufferToImage = bufferToImage;
	//# sourceMappingURL=bufferToImage.js.map

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var fetchOrThrow_1 = __webpack_require__(266);
	function fetchJson(uri) {
	    return tslib_1.__awaiter(this, void 0, void 0, function () {
	        return tslib_1.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, fetchOrThrow_1.fetchOrThrow(uri)];
	                case 1: return [2 /*return*/, (_a.sent()).json()];
	            }
	        });
	    });
	}
	exports.fetchJson = fetchJson;
	//# sourceMappingURL=fetchJson.js.map

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var env_1 = __webpack_require__(55);
	var utils_1 = __webpack_require__(34);
	function imageTensorToCanvas(imgTensor, canvas) {
	    return tslib_1.__awaiter(this, void 0, void 0, function () {
	        var targetCanvas, _a, height, width, numChannels, imgTensor3D;
	        return tslib_1.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    targetCanvas = canvas || env_1.env.getEnv().createCanvasElement();
	                    _a = imgTensor.shape.slice(utils_1.isTensor4D(imgTensor) ? 1 : 0), height = _a[0], width = _a[1], numChannels = _a[2];
	                    imgTensor3D = tf.tidy(function () { return imgTensor.as3D(height, width, numChannels).toInt(); });
	                    return [4 /*yield*/, tf.browser.toPixels(imgTensor3D, targetCanvas)];
	                case 1:
	                    _b.sent();
	                    imgTensor3D.dispose();
	                    return [2 /*return*/, targetCanvas];
	            }
	        });
	    });
	}
	exports.imageTensorToCanvas = imageTensorToCanvas;
	//# sourceMappingURL=imageTensorToCanvas.js.map

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var env_1 = __webpack_require__(55);
	var createCanvas_1 = __webpack_require__(265);
	var getContext2dOrThrow_1 = __webpack_require__(139);
	var getMediaDimensions_1 = __webpack_require__(267);
	function imageToSquare(input, inputSize, centerImage) {
	    if (centerImage === void 0) { centerImage = false; }
	    var _a = env_1.env.getEnv(), Image = _a.Image, Canvas = _a.Canvas;
	    if (!(input instanceof Image || input instanceof Canvas)) {
	        throw new Error('imageToSquare - expected arg0 to be HTMLImageElement | HTMLCanvasElement');
	    }
	    var dims = getMediaDimensions_1.getMediaDimensions(input);
	    var scale = inputSize / Math.max(dims.height, dims.width);
	    var width = scale * dims.width;
	    var height = scale * dims.height;
	    var targetCanvas = createCanvas_1.createCanvas({ width: inputSize, height: inputSize });
	    var inputCanvas = input instanceof Canvas ? input : createCanvas_1.createCanvasFromMedia(input);
	    var offset = Math.abs(width - height) / 2;
	    var dx = centerImage && width < height ? offset : 0;
	    var dy = centerImage && height < width ? offset : 0;
	    getContext2dOrThrow_1.getContext2dOrThrow(targetCanvas).drawImage(inputCanvas, dx, dy, width, height);
	    return targetCanvas;
	}
	exports.imageToSquare = imageToSquare;
	//# sourceMappingURL=imageToSquare.js.map

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var env_1 = __webpack_require__(55);
	function isMediaElement(input) {
	    var _a = env_1.env.getEnv(), Image = _a.Image, Canvas = _a.Canvas, Video = _a.Video;
	    return input instanceof Image
	        || input instanceof Canvas
	        || input instanceof Video;
	}
	exports.isMediaElement = isMediaElement;
	//# sourceMappingURL=isMediaElement.js.map

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var utils_1 = __webpack_require__(34);
	var awaitMediaLoaded_1 = __webpack_require__(586);
	var isMediaElement_1 = __webpack_require__(591);
	var NetInput_1 = __webpack_require__(585);
	var resolveInput_1 = __webpack_require__(268);
	/**
	 * Validates the input to make sure, they are valid net inputs and awaits all media elements
	 * to be finished loading.
	 *
	 * @param input The input, which can be a media element or an array of different media elements.
	 * @returns A NetInput instance, which can be passed into one of the neural networks.
	 */
	function toNetInput(inputs) {
	    return tslib_1.__awaiter(this, void 0, void 0, function () {
	        var inputArgArray, getIdxHint, inputArray;
	        return tslib_1.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    if (inputs instanceof NetInput_1.NetInput) {
	                        return [2 /*return*/, inputs];
	                    }
	                    inputArgArray = Array.isArray(inputs)
	                        ? inputs
	                        : [inputs];
	                    if (!inputArgArray.length) {
	                        throw new Error('toNetInput - empty array passed as input');
	                    }
	                    getIdxHint = function (idx) { return Array.isArray(inputs) ? " at input index " + idx + ":" : ''; };
	                    inputArray = inputArgArray.map(resolveInput_1.resolveInput);
	                    inputArray.forEach(function (input, i) {
	                        if (!isMediaElement_1.isMediaElement(input) && !utils_1.isTensor3D(input) && !utils_1.isTensor4D(input)) {
	                            if (typeof inputArgArray[i] === 'string') {
	                                throw new Error("toNetInput -" + getIdxHint(i) + " string passed, but could not resolve HTMLElement for element id " + inputArgArray[i]);
	                            }
	                            throw new Error("toNetInput -" + getIdxHint(i) + " expected media to be of type HTMLImageElement | HTMLVideoElement | HTMLCanvasElement | tf.Tensor3D, or to be an element id");
	                        }
	                        if (utils_1.isTensor4D(input)) {
	                            // if tf.Tensor4D is passed in the input array, the batch size has to be 1
	                            var batchSize = input.shape[0];
	                            if (batchSize !== 1) {
	                                throw new Error("toNetInput -" + getIdxHint(i) + " tf.Tensor4D with batchSize " + batchSize + " passed, but not supported in input array");
	                            }
	                        }
	                    });
	                    // wait for all media elements being loaded
	                    return [4 /*yield*/, Promise.all(inputArray.map(function (input) { return isMediaElement_1.isMediaElement(input) && awaitMediaLoaded_1.awaitMediaLoaded(input); }))];
	                case 1:
	                    // wait for all media elements being loaded
	                    _a.sent();
	                    return [2 /*return*/, new NetInput_1.NetInput(inputArray, Array.isArray(inputs))];
	            }
	        });
	    });
	}
	exports.toNetInput = toNetInput;
	//# sourceMappingURL=toNetInput.js.map

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var classes_1 = __webpack_require__(48);
	var getContext2dOrThrow_1 = __webpack_require__(139);
	var DrawTextField_1 = __webpack_require__(384);
	var DrawBoxOptions = /** @class */ (function () {
	    function DrawBoxOptions(options) {
	        if (options === void 0) { options = {}; }
	        var boxColor = options.boxColor, lineWidth = options.lineWidth, label = options.label, drawLabelOptions = options.drawLabelOptions;
	        this.boxColor = boxColor || 'rgba(0, 0, 255, 1)';
	        this.lineWidth = lineWidth || 2;
	        this.label = label;
	        var defaultDrawLabelOptions = {
	            anchorPosition: DrawTextField_1.AnchorPosition.BOTTOM_LEFT,
	            backgroundColor: this.boxColor
	        };
	        this.drawLabelOptions = new DrawTextField_1.DrawTextFieldOptions(Object.assign({}, defaultDrawLabelOptions, drawLabelOptions));
	    }
	    return DrawBoxOptions;
	}());
	exports.DrawBoxOptions = DrawBoxOptions;
	var DrawBox = /** @class */ (function () {
	    function DrawBox(box, options) {
	        if (options === void 0) { options = {}; }
	        this.box = new classes_1.Box(box);
	        this.options = new DrawBoxOptions(options);
	    }
	    DrawBox.prototype.draw = function (canvasArg) {
	        var ctx = getContext2dOrThrow_1.getContext2dOrThrow(canvasArg);
	        var _a = this.options, boxColor = _a.boxColor, lineWidth = _a.lineWidth;
	        var _b = this.box, x = _b.x, y = _b.y, width = _b.width, height = _b.height;
	        ctx.strokeStyle = boxColor;
	        ctx.lineWidth = lineWidth;
	        ctx.strokeRect(x, y, width, height);
	        var label = this.options.label;
	        if (label) {
	            new DrawTextField_1.DrawTextField([label], { x: x - (lineWidth / 2), y: y }, this.options.drawLabelOptions).draw(canvasArg);
	        }
	    };
	    return DrawBox;
	}());
	exports.DrawBox = DrawBox;
	//# sourceMappingURL=DrawBox.js.map

/***/ },
/* 594 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function drawContour(ctx, points, isClosed) {
	    if (isClosed === void 0) { isClosed = false; }
	    ctx.beginPath();
	    points.slice(1).forEach(function (_a, prevIdx) {
	        var x = _a.x, y = _a.y;
	        var from = points[prevIdx];
	        ctx.moveTo(from.x, from.y);
	        ctx.lineTo(x, y);
	    });
	    if (isClosed) {
	        var from = points[points.length - 1];
	        var to = points[0];
	        if (!from || !to) {
	            return;
	        }
	        ctx.moveTo(from.x, from.y);
	        ctx.lineTo(to.x, to.y);
	    }
	    ctx.stroke();
	}
	exports.drawContour = drawContour;
	//# sourceMappingURL=drawContour.js.map

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function createFileSystem(fs) {
	    var requireFsError = '';
	    if (!fs) {
	        try {
	            fs = __webpack_require__(1661);
	        }
	        catch (err) {
	            requireFsError = err.toString();
	        }
	    }
	    var readFile = fs
	        ? function (filePath) {
	            return new Promise(function (res, rej) {
	                fs.readFile(filePath, function (err, buffer) {
	                    return err ? rej(err) : res(buffer);
	                });
	            });
	        }
	        : function () {
	            throw new Error("readFile - failed to require fs in nodejs environment with error: " + requireFsError);
	        };
	    return {
	        readFile: readFile
	    };
	}
	exports.createFileSystem = createFileSystem;
	//# sourceMappingURL=createFileSystem.js.map

/***/ },
/* 596 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function euclideanDistance(arr1, arr2) {
	    if (arr1.length !== arr2.length)
	        throw new Error('euclideanDistance: arr1.length !== arr2.length');
	    var desc1 = Array.from(arr1);
	    var desc2 = Array.from(arr2);
	    return Math.sqrt(desc1
	        .map(function (val, i) { return val - desc2[i]; })
	        .reduce(function (res, diff) { return res + Math.pow(diff, 2); }, 0));
	}
	exports.euclideanDistance = euclideanDistance;
	//# sourceMappingURL=euclideanDistance.js.map

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var dom_1 = __webpack_require__(54);
	var FaceFeatureExtractor_1 = __webpack_require__(599);
	var FaceProcessor_1 = __webpack_require__(605);
	var FaceExpressions_1 = __webpack_require__(385);
	var FaceExpressionNet = /** @class */ (function (_super) {
	    tslib_1.__extends(FaceExpressionNet, _super);
	    function FaceExpressionNet(faceFeatureExtractor) {
	        if (faceFeatureExtractor === void 0) { faceFeatureExtractor = new FaceFeatureExtractor_1.FaceFeatureExtractor(); }
	        return _super.call(this, 'FaceExpressionNet', faceFeatureExtractor) || this;
	    }
	    FaceExpressionNet.prototype.forwardInput = function (input) {
	        var _this = this;
	        return tf.tidy(function () { return tf.softmax(_this.runNet(input)); });
	    };
	    FaceExpressionNet.prototype.forward = function (input) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _a;
	            return tslib_1.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        _a = this.forwardInput;
	                        return [4 /*yield*/, dom_1.toNetInput(input)];
	                    case 1: return [2 /*return*/, _a.apply(this, [_b.sent()])];
	                }
	            });
	        });
	    };
	    FaceExpressionNet.prototype.predictExpressions = function (input) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var netInput, out, probabilitesByBatch, predictionsByBatch;
	            var _this = this;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, dom_1.toNetInput(input)];
	                    case 1:
	                        netInput = _a.sent();
	                        return [4 /*yield*/, this.forwardInput(netInput)];
	                    case 2:
	                        out = _a.sent();
	                        return [4 /*yield*/, Promise.all(tf.unstack(out).map(function (t) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
	                                var data;
	                                return tslib_1.__generator(this, function (_a) {
	                                    switch (_a.label) {
	                                        case 0: return [4 /*yield*/, t.data()];
	                                        case 1:
	                                            data = _a.sent();
	                                            t.dispose();
	                                            return [2 /*return*/, data];
	                                    }
	                                });
	                            }); }))];
	                    case 3:
	                        probabilitesByBatch = _a.sent();
	                        out.dispose();
	                        predictionsByBatch = probabilitesByBatch
	                            .map(function (probabilites) { return new FaceExpressions_1.FaceExpressions(probabilites); });
	                        return [2 /*return*/, netInput.isBatchInput
	                                ? predictionsByBatch
	                                : predictionsByBatch[0]];
	                }
	            });
	        });
	    };
	    FaceExpressionNet.prototype.getDefaultModelName = function () {
	        return 'face_expression_model';
	    };
	    FaceExpressionNet.prototype.getClassifierChannelsIn = function () {
	        return 256;
	    };
	    FaceExpressionNet.prototype.getClassifierChannelsOut = function () {
	        return 7;
	    };
	    return FaceExpressionNet;
	}(FaceProcessor_1.FaceProcessor));
	exports.FaceExpressionNet = FaceExpressionNet;
	//# sourceMappingURL=FaceExpressionNet.js.map

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	tslib_1.__exportStar(__webpack_require__(597), exports);
	tslib_1.__exportStar(__webpack_require__(385), exports);
	//# sourceMappingURL=index.js.map

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var dom_1 = __webpack_require__(54);
	var NeuralNetwork_1 = __webpack_require__(96);
	var ops_1 = __webpack_require__(98);
	var denseBlock_1 = __webpack_require__(600);
	var extractParams_1 = __webpack_require__(1460);
	var extractParamsFromWeigthMap_1 = __webpack_require__(1461);
	var FaceFeatureExtractor = /** @class */ (function (_super) {
	    tslib_1.__extends(FaceFeatureExtractor, _super);
	    function FaceFeatureExtractor() {
	        return _super.call(this, 'FaceFeatureExtractor') || this;
	    }
	    FaceFeatureExtractor.prototype.forwardInput = function (input) {
	        var params = this.params;
	        if (!params) {
	            throw new Error('FaceFeatureExtractor - load model before inference');
	        }
	        return tf.tidy(function () {
	            var batchTensor = input.toBatchTensor(112, true);
	            var meanRgb = [122.782, 117.001, 104.298];
	            var normalized = ops_1.normalize(batchTensor, meanRgb).div(tf.scalar(255));
	            var out = denseBlock_1.denseBlock4(normalized, params.dense0, true);
	            out = denseBlock_1.denseBlock4(out, params.dense1);
	            out = denseBlock_1.denseBlock4(out, params.dense2);
	            out = denseBlock_1.denseBlock4(out, params.dense3);
	            out = tf.avgPool(out, [7, 7], [2, 2], 'valid');
	            return out;
	        });
	    };
	    FaceFeatureExtractor.prototype.forward = function (input) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _a;
	            return tslib_1.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        _a = this.forwardInput;
	                        return [4 /*yield*/, dom_1.toNetInput(input)];
	                    case 1: return [2 /*return*/, _a.apply(this, [_b.sent()])];
	                }
	            });
	        });
	    };
	    FaceFeatureExtractor.prototype.getDefaultModelName = function () {
	        return 'face_feature_extractor_model';
	    };
	    FaceFeatureExtractor.prototype.extractParamsFromWeigthMap = function (weightMap) {
	        return extractParamsFromWeigthMap_1.extractParamsFromWeigthMap(weightMap);
	    };
	    FaceFeatureExtractor.prototype.extractParams = function (weights) {
	        return extractParams_1.extractParams(weights);
	    };
	    return FaceFeatureExtractor;
	}(NeuralNetwork_1.NeuralNetwork));
	exports.FaceFeatureExtractor = FaceFeatureExtractor;
	//# sourceMappingURL=FaceFeatureExtractor.js.map

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	var depthwiseSeparableConv_1 = __webpack_require__(579);
	function denseBlock3(x, denseBlockParams, isFirstLayer) {
	    if (isFirstLayer === void 0) { isFirstLayer = false; }
	    return tf.tidy(function () {
	        var out1 = tf.relu(isFirstLayer
	            ? tf.add(tf.conv2d(x, denseBlockParams.conv0.filters, [2, 2], 'same'), denseBlockParams.conv0.bias)
	            : depthwiseSeparableConv_1.depthwiseSeparableConv(x, denseBlockParams.conv0, [2, 2]));
	        var out2 = depthwiseSeparableConv_1.depthwiseSeparableConv(out1, denseBlockParams.conv1, [1, 1]);
	        var in3 = tf.relu(tf.add(out1, out2));
	        var out3 = depthwiseSeparableConv_1.depthwiseSeparableConv(in3, denseBlockParams.conv2, [1, 1]);
	        return tf.relu(tf.add(out1, tf.add(out2, out3)));
	    });
	}
	exports.denseBlock3 = denseBlock3;
	function denseBlock4(x, denseBlockParams, isFirstLayer, isScaleDown) {
	    if (isFirstLayer === void 0) { isFirstLayer = false; }
	    if (isScaleDown === void 0) { isScaleDown = true; }
	    return tf.tidy(function () {
	        var out1 = tf.relu(isFirstLayer
	            ? tf.add(tf.conv2d(x, denseBlockParams.conv0.filters, isScaleDown ? [2, 2] : [1, 1], 'same'), denseBlockParams.conv0.bias)
	            : depthwiseSeparableConv_1.depthwiseSeparableConv(x, denseBlockParams.conv0, isScaleDown ? [2, 2] : [1, 1]));
	        var out2 = depthwiseSeparableConv_1.depthwiseSeparableConv(out1, denseBlockParams.conv1, [1, 1]);
	        var in3 = tf.relu(tf.add(out1, out2));
	        var out3 = depthwiseSeparableConv_1.depthwiseSeparableConv(in3, denseBlockParams.conv2, [1, 1]);
	        var in4 = tf.relu(tf.add(out1, tf.add(out2, out3)));
	        var out4 = depthwiseSeparableConv_1.depthwiseSeparableConv(in4, denseBlockParams.conv3, [1, 1]);
	        return tf.relu(tf.add(out1, tf.add(out2, tf.add(out3, out4))));
	    });
	}
	exports.denseBlock4 = denseBlock4;
	//# sourceMappingURL=denseBlock.js.map

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(33);
	function extractorsFactory(extractWeights, paramMappings) {
	    var extractConvParams = common_1.extractConvParamsFactory(extractWeights, paramMappings);
	    var extractSeparableConvParams = common_1.extractSeparableConvParamsFactory(extractWeights, paramMappings);
	    function extractDenseBlock3Params(channelsIn, channelsOut, mappedPrefix, isFirstLayer) {
	        if (isFirstLayer === void 0) { isFirstLayer = false; }
	        var conv0 = isFirstLayer
	            ? extractConvParams(channelsIn, channelsOut, 3, mappedPrefix + "/conv0")
	            : extractSeparableConvParams(channelsIn, channelsOut, mappedPrefix + "/conv0");
	        var conv1 = extractSeparableConvParams(channelsOut, channelsOut, mappedPrefix + "/conv1");
	        var conv2 = extractSeparableConvParams(channelsOut, channelsOut, mappedPrefix + "/conv2");
	        return { conv0: conv0, conv1: conv1, conv2: conv2 };
	    }
	    function extractDenseBlock4Params(channelsIn, channelsOut, mappedPrefix, isFirstLayer) {
	        if (isFirstLayer === void 0) { isFirstLayer = false; }
	        var _a = extractDenseBlock3Params(channelsIn, channelsOut, mappedPrefix, isFirstLayer), conv0 = _a.conv0, conv1 = _a.conv1, conv2 = _a.conv2;
	        var conv3 = extractSeparableConvParams(channelsOut, channelsOut, mappedPrefix + "/conv3");
	        return { conv0: conv0, conv1: conv1, conv2: conv2, conv3: conv3 };
	    }
	    return {
	        extractDenseBlock3Params: extractDenseBlock3Params,
	        extractDenseBlock4Params: extractDenseBlock4Params
	    };
	}
	exports.extractorsFactory = extractorsFactory;
	//# sourceMappingURL=extractorsFactory.js.map

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(33);
	var loadConvParamsFactory_1 = __webpack_require__(583);
	function loadParamsFactory(weightMap, paramMappings) {
	    var extractWeightEntry = common_1.extractWeightEntryFactory(weightMap, paramMappings);
	    var extractConvParams = loadConvParamsFactory_1.loadConvParamsFactory(extractWeightEntry);
	    var extractSeparableConvParams = common_1.loadSeparableConvParamsFactory(extractWeightEntry);
	    function extractDenseBlock3Params(prefix, isFirstLayer) {
	        if (isFirstLayer === void 0) { isFirstLayer = false; }
	        var conv0 = isFirstLayer
	            ? extractConvParams(prefix + "/conv0")
	            : extractSeparableConvParams(prefix + "/conv0");
	        var conv1 = extractSeparableConvParams(prefix + "/conv1");
	        var conv2 = extractSeparableConvParams(prefix + "/conv2");
	        return { conv0: conv0, conv1: conv1, conv2: conv2 };
	    }
	    function extractDenseBlock4Params(prefix, isFirstLayer) {
	        if (isFirstLayer === void 0) { isFirstLayer = false; }
	        var conv0 = isFirstLayer
	            ? extractConvParams(prefix + "/conv0")
	            : extractSeparableConvParams(prefix + "/conv0");
	        var conv1 = extractSeparableConvParams(prefix + "/conv1");
	        var conv2 = extractSeparableConvParams(prefix + "/conv2");
	        var conv3 = extractSeparableConvParams(prefix + "/conv3");
	        return { conv0: conv0, conv1: conv1, conv2: conv2, conv3: conv3 };
	    }
	    return {
	        extractDenseBlock3Params: extractDenseBlock3Params,
	        extractDenseBlock4Params: extractDenseBlock4Params
	    };
	}
	exports.loadParamsFactory = loadParamsFactory;
	//# sourceMappingURL=loadParamsFactory.js.map

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var classes_1 = __webpack_require__(48);
	var FaceLandmarks68_1 = __webpack_require__(378);
	var dom_1 = __webpack_require__(54);
	var FaceProcessor_1 = __webpack_require__(605);
	var utils_1 = __webpack_require__(34);
	var FaceLandmark68NetBase = /** @class */ (function (_super) {
	    tslib_1.__extends(FaceLandmark68NetBase, _super);
	    function FaceLandmark68NetBase() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    FaceLandmark68NetBase.prototype.postProcess = function (output, inputSize, originalDimensions) {
	        var inputDimensions = originalDimensions.map(function (_a) {
	            var width = _a.width, height = _a.height;
	            var scale = inputSize / Math.max(height, width);
	            return {
	                width: width * scale,
	                height: height * scale
	            };
	        });
	        var batchSize = inputDimensions.length;
	        return tf.tidy(function () {
	            var createInterleavedTensor = function (fillX, fillY) {
	                return tf.stack([
	                    tf.fill([68], fillX),
	                    tf.fill([68], fillY)
	                ], 1).as2D(1, 136).as1D();
	            };
	            var getPadding = function (batchIdx, cond) {
	                var _a = inputDimensions[batchIdx], width = _a.width, height = _a.height;
	                return cond(width, height) ? Math.abs(width - height) / 2 : 0;
	            };
	            var getPaddingX = function (batchIdx) { return getPadding(batchIdx, function (w, h) { return w < h; }); };
	            var getPaddingY = function (batchIdx) { return getPadding(batchIdx, function (w, h) { return h < w; }); };
	            var landmarkTensors = output
	                .mul(tf.fill([batchSize, 136], inputSize))
	                .sub(tf.stack(Array.from(Array(batchSize), function (_, batchIdx) {
	                return createInterleavedTensor(getPaddingX(batchIdx), getPaddingY(batchIdx));
	            })))
	                .div(tf.stack(Array.from(Array(batchSize), function (_, batchIdx) {
	                return createInterleavedTensor(inputDimensions[batchIdx].width, inputDimensions[batchIdx].height);
	            })));
	            return landmarkTensors;
	        });
	    };
	    FaceLandmark68NetBase.prototype.forwardInput = function (input) {
	        var _this = this;
	        return tf.tidy(function () {
	            var out = _this.runNet(input);
	            return _this.postProcess(out, input.inputSize, input.inputDimensions.map(function (_a) {
	                var height = _a[0], width = _a[1];
	                return ({ height: height, width: width });
	            }));
	        });
	    };
	    FaceLandmark68NetBase.prototype.forward = function (input) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _a;
	            return tslib_1.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        _a = this.forwardInput;
	                        return [4 /*yield*/, dom_1.toNetInput(input)];
	                    case 1: return [2 /*return*/, _a.apply(this, [_b.sent()])];
	                }
	            });
	        });
	    };
	    FaceLandmark68NetBase.prototype.detectLandmarks = function (input) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var netInput, landmarkTensors, landmarksForBatch;
	            var _this = this;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, dom_1.toNetInput(input)];
	                    case 1:
	                        netInput = _a.sent();
	                        landmarkTensors = tf.tidy(function () { return tf.unstack(_this.forwardInput(netInput)); });
	                        return [4 /*yield*/, Promise.all(landmarkTensors.map(function (landmarkTensor, batchIdx) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
	                                var landmarksArray, _a, _b, xCoords, yCoords;
	                                return tslib_1.__generator(this, function (_c) {
	                                    switch (_c.label) {
	                                        case 0:
	                                            _b = (_a = Array).from;
	                                            return [4 /*yield*/, landmarkTensor.data()];
	                                        case 1:
	                                            landmarksArray = _b.apply(_a, [_c.sent()]);
	                                            xCoords = landmarksArray.filter(function (_, i) { return utils_1.isEven(i); });
	                                            yCoords = landmarksArray.filter(function (_, i) { return !utils_1.isEven(i); });
	                                            return [2 /*return*/, new FaceLandmarks68_1.FaceLandmarks68(Array(68).fill(0).map(function (_, i) { return new classes_1.Point(xCoords[i], yCoords[i]); }), {
	                                                    height: netInput.getInputHeight(batchIdx),
	                                                    width: netInput.getInputWidth(batchIdx),
	                                                })];
	                                    }
	                                });
	                            }); }))];
	                    case 2:
	                        landmarksForBatch = _a.sent();
	                        landmarkTensors.forEach(function (t) { return t.dispose(); });
	                        return [2 /*return*/, netInput.isBatchInput
	                                ? landmarksForBatch
	                                : landmarksForBatch[0]];
	                }
	            });
	        });
	    };
	    FaceLandmark68NetBase.prototype.getClassifierChannelsOut = function () {
	        return 136;
	    };
	    return FaceLandmark68NetBase;
	}(FaceProcessor_1.FaceProcessor));
	exports.FaceLandmark68NetBase = FaceLandmark68NetBase;
	//# sourceMappingURL=FaceLandmark68NetBase.js.map

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var TinyFaceFeatureExtractor_1 = __webpack_require__(1459);
	var FaceLandmark68NetBase_1 = __webpack_require__(603);
	var FaceLandmark68TinyNet = /** @class */ (function (_super) {
	    tslib_1.__extends(FaceLandmark68TinyNet, _super);
	    function FaceLandmark68TinyNet(faceFeatureExtractor) {
	        if (faceFeatureExtractor === void 0) { faceFeatureExtractor = new TinyFaceFeatureExtractor_1.TinyFaceFeatureExtractor(); }
	        return _super.call(this, 'FaceLandmark68TinyNet', faceFeatureExtractor) || this;
	    }
	    FaceLandmark68TinyNet.prototype.getDefaultModelName = function () {
	        return 'face_landmark_68_tiny_model';
	    };
	    FaceLandmark68TinyNet.prototype.getClassifierChannelsIn = function () {
	        return 128;
	    };
	    return FaceLandmark68TinyNet;
	}(FaceLandmark68NetBase_1.FaceLandmark68NetBase));
	exports.FaceLandmark68TinyNet = FaceLandmark68TinyNet;
	//# sourceMappingURL=FaceLandmark68TinyNet.js.map

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var fullyConnectedLayer_1 = __webpack_require__(264);
	var dom_1 = __webpack_require__(54);
	var NeuralNetwork_1 = __webpack_require__(96);
	var extractParams_1 = __webpack_require__(1465);
	var extractParamsFromWeigthMap_1 = __webpack_require__(1466);
	var util_1 = __webpack_require__(606);
	var FaceProcessor = /** @class */ (function (_super) {
	    tslib_1.__extends(FaceProcessor, _super);
	    function FaceProcessor(_name, faceFeatureExtractor) {
	        var _this = _super.call(this, _name) || this;
	        _this._faceFeatureExtractor = faceFeatureExtractor;
	        return _this;
	    }
	    Object.defineProperty(FaceProcessor.prototype, "faceFeatureExtractor", {
	        get: function () {
	            return this._faceFeatureExtractor;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    FaceProcessor.prototype.runNet = function (input) {
	        var _this = this;
	        var params = this.params;
	        if (!params) {
	            throw new Error(this._name + " - load model before inference");
	        }
	        return tf.tidy(function () {
	            var bottleneckFeatures = input instanceof dom_1.NetInput
	                ? _this.faceFeatureExtractor.forwardInput(input)
	                : input;
	            return fullyConnectedLayer_1.fullyConnectedLayer(bottleneckFeatures.as2D(bottleneckFeatures.shape[0], -1), params.fc);
	        });
	    };
	    FaceProcessor.prototype.dispose = function (throwOnRedispose) {
	        if (throwOnRedispose === void 0) { throwOnRedispose = true; }
	        this.faceFeatureExtractor.dispose(throwOnRedispose);
	        _super.prototype.dispose.call(this, throwOnRedispose);
	    };
	    FaceProcessor.prototype.loadClassifierParams = function (weights) {
	        var _a = this.extractClassifierParams(weights), params = _a.params, paramMappings = _a.paramMappings;
	        this._params = params;
	        this._paramMappings = paramMappings;
	    };
	    FaceProcessor.prototype.extractClassifierParams = function (weights) {
	        return extractParams_1.extractParams(weights, this.getClassifierChannelsIn(), this.getClassifierChannelsOut());
	    };
	    FaceProcessor.prototype.extractParamsFromWeigthMap = function (weightMap) {
	        var _a = util_1.seperateWeightMaps(weightMap), featureExtractorMap = _a.featureExtractorMap, classifierMap = _a.classifierMap;
	        this.faceFeatureExtractor.loadFromWeightMap(featureExtractorMap);
	        return extractParamsFromWeigthMap_1.extractParamsFromWeigthMap(classifierMap);
	    };
	    FaceProcessor.prototype.extractParams = function (weights) {
	        var cIn = this.getClassifierChannelsIn();
	        var cOut = this.getClassifierChannelsOut();
	        var classifierWeightSize = (cOut * cIn) + cOut;
	        var featureExtractorWeights = weights.slice(0, weights.length - classifierWeightSize);
	        var classifierWeights = weights.slice(weights.length - classifierWeightSize);
	        this.faceFeatureExtractor.extractWeights(featureExtractorWeights);
	        return this.extractClassifierParams(classifierWeights);
	    };
	    return FaceProcessor;
	}(NeuralNetwork_1.NeuralNetwork));
	exports.FaceProcessor = FaceProcessor;
	//# sourceMappingURL=FaceProcessor.js.map

/***/ },
/* 606 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function seperateWeightMaps(weightMap) {
	    var featureExtractorMap = {};
	    var classifierMap = {};
	    Object.keys(weightMap).forEach(function (key) {
	        var map = key.startsWith('fc') ? classifierMap : featureExtractorMap;
	        map[key] = weightMap[key];
	    });
	    return { featureExtractorMap: featureExtractorMap, classifierMap: classifierMap };
	}
	exports.seperateWeightMaps = seperateWeightMaps;
	//# sourceMappingURL=util.js.map

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	var scaleLayer_1 = __webpack_require__(1471);
	function convLayer(x, params, strides, withRelu, padding) {
	    if (padding === void 0) { padding = 'same'; }
	    var _a = params.conv, filters = _a.filters, bias = _a.bias;
	    var out = tf.conv2d(x, filters, strides, padding);
	    out = tf.add(out, bias);
	    out = scaleLayer_1.scale(out, params.scale);
	    return withRelu ? tf.relu(out) : out;
	}
	function conv(x, params) {
	    return convLayer(x, params, [1, 1], true);
	}
	exports.conv = conv;
	function convNoRelu(x, params) {
	    return convLayer(x, params, [1, 1], false);
	}
	exports.convNoRelu = convNoRelu;
	function convDown(x, params) {
	    return convLayer(x, params, [2, 2], true, 'valid');
	}
	exports.convDown = convDown;
	//# sourceMappingURL=convLayer.js.map

/***/ },
/* 608 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function isWithAge(obj) {
	    return typeof obj['age'] === 'number';
	}
	exports.isWithAge = isWithAge;
	function extendWithAge(sourceObj, age) {
	    var extension = { age: age };
	    return Object.assign({}, sourceObj, extension);
	}
	exports.extendWithAge = extendWithAge;
	//# sourceMappingURL=WithAge.js.map

/***/ },
/* 609 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function extendWithFaceDescriptor(sourceObj, descriptor) {
	    var extension = { descriptor: descriptor };
	    return Object.assign({}, sourceObj, extension);
	}
	exports.extendWithFaceDescriptor = extendWithFaceDescriptor;
	//# sourceMappingURL=WithFaceDescriptor.js.map

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(377);
	var utils_1 = __webpack_require__(34);
	function isWithGender(obj) {
	    return (obj['gender'] === types_1.Gender.MALE || obj['gender'] === types_1.Gender.FEMALE)
	        && utils_1.isValidProbablitiy(obj['genderProbability']);
	}
	exports.isWithGender = isWithGender;
	function extendWithGender(sourceObj, gender, genderProbability) {
	    var extension = { gender: gender, genderProbability: genderProbability };
	    return Object.assign({}, sourceObj, extension);
	}
	exports.extendWithGender = extendWithGender;
	//# sourceMappingURL=WithGender.js.map

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	tslib_1.__exportStar(__webpack_require__(609), exports);
	tslib_1.__exportStar(__webpack_require__(167), exports);
	tslib_1.__exportStar(__webpack_require__(388), exports);
	tslib_1.__exportStar(__webpack_require__(211), exports);
	tslib_1.__exportStar(__webpack_require__(608), exports);
	tslib_1.__exportStar(__webpack_require__(610), exports);
	//# sourceMappingURL=index.js.map

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var dom_1 = __webpack_require__(54);
	var WithFaceLandmarks_1 = __webpack_require__(211);
	var ComposableTask_1 = __webpack_require__(168);
	var ComputeFaceDescriptorsTasks_1 = __webpack_require__(269);
	var nets_1 = __webpack_require__(169);
	var PredictAgeAndGenderTask_1 = __webpack_require__(270);
	var PredictFaceExpressionsTask_1 = __webpack_require__(271);
	var DetectFaceLandmarksTaskBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DetectFaceLandmarksTaskBase, _super);
	    function DetectFaceLandmarksTaskBase(parentTask, input, useTinyLandmarkNet) {
	        var _this = _super.call(this) || this;
	        _this.parentTask = parentTask;
	        _this.input = input;
	        _this.useTinyLandmarkNet = useTinyLandmarkNet;
	        return _this;
	    }
	    Object.defineProperty(DetectFaceLandmarksTaskBase.prototype, "landmarkNet", {
	        get: function () {
	            return this.useTinyLandmarkNet
	                ? nets_1.nets.faceLandmark68TinyNet
	                : nets_1.nets.faceLandmark68Net;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return DetectFaceLandmarksTaskBase;
	}(ComposableTask_1.ComposableTask));
	exports.DetectFaceLandmarksTaskBase = DetectFaceLandmarksTaskBase;
	var DetectAllFaceLandmarksTask = /** @class */ (function (_super) {
	    tslib_1.__extends(DetectAllFaceLandmarksTask, _super);
	    function DetectAllFaceLandmarksTask() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DetectAllFaceLandmarksTask.prototype.run = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var parentResults, detections, faces, _a, faceLandmarksByFace;
	            var _this = this;
	            return tslib_1.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0: return [4 /*yield*/, this.parentTask];
	                    case 1:
	                        parentResults = _b.sent();
	                        detections = parentResults.map(function (res) { return res.detection; });
	                        if (!(this.input instanceof tf.Tensor)) return [3 /*break*/, 3];
	                        return [4 /*yield*/, dom_1.extractFaceTensors(this.input, detections)];
	                    case 2:
	                        _a = _b.sent();
	                        return [3 /*break*/, 5];
	                    case 3: return [4 /*yield*/, dom_1.extractFaces(this.input, detections)];
	                    case 4:
	                        _a = _b.sent();
	                        _b.label = 5;
	                    case 5:
	                        faces = _a;
	                        return [4 /*yield*/, Promise.all(faces.map(function (face) { return _this.landmarkNet.detectLandmarks(face); }))];
	                    case 6:
	                        faceLandmarksByFace = _b.sent();
	                        faces.forEach(function (f) { return f instanceof tf.Tensor && f.dispose(); });
	                        return [2 /*return*/, parentResults.map(function (parentResult, i) {
	                                return WithFaceLandmarks_1.extendWithFaceLandmarks(parentResult, faceLandmarksByFace[i]);
	                            })];
	                }
	            });
	        });
	    };
	    DetectAllFaceLandmarksTask.prototype.withFaceExpressions = function () {
	        return new PredictFaceExpressionsTask_1.PredictAllFaceExpressionsWithFaceAlignmentTask(this, this.input);
	    };
	    DetectAllFaceLandmarksTask.prototype.withAgeAndGender = function () {
	        return new PredictAgeAndGenderTask_1.PredictAllAgeAndGenderWithFaceAlignmentTask(this, this.input);
	    };
	    DetectAllFaceLandmarksTask.prototype.withFaceDescriptors = function () {
	        return new ComputeFaceDescriptorsTasks_1.ComputeAllFaceDescriptorsTask(this, this.input);
	    };
	    return DetectAllFaceLandmarksTask;
	}(DetectFaceLandmarksTaskBase));
	exports.DetectAllFaceLandmarksTask = DetectAllFaceLandmarksTask;
	var DetectSingleFaceLandmarksTask = /** @class */ (function (_super) {
	    tslib_1.__extends(DetectSingleFaceLandmarksTask, _super);
	    function DetectSingleFaceLandmarksTask() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DetectSingleFaceLandmarksTask.prototype.run = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var parentResult, detection, faces, _a, landmarks;
	            return tslib_1.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0: return [4 /*yield*/, this.parentTask];
	                    case 1:
	                        parentResult = _b.sent();
	                        if (!parentResult) {
	                            return [2 /*return*/];
	                        }
	                        detection = parentResult.detection;
	                        if (!(this.input instanceof tf.Tensor)) return [3 /*break*/, 3];
	                        return [4 /*yield*/, dom_1.extractFaceTensors(this.input, [detection])];
	                    case 2:
	                        _a = _b.sent();
	                        return [3 /*break*/, 5];
	                    case 3: return [4 /*yield*/, dom_1.extractFaces(this.input, [detection])];
	                    case 4:
	                        _a = _b.sent();
	                        _b.label = 5;
	                    case 5:
	                        faces = _a;
	                        return [4 /*yield*/, this.landmarkNet.detectLandmarks(faces[0])];
	                    case 6:
	                        landmarks = _b.sent();
	                        faces.forEach(function (f) { return f instanceof tf.Tensor && f.dispose(); });
	                        return [2 /*return*/, WithFaceLandmarks_1.extendWithFaceLandmarks(parentResult, landmarks)];
	                }
	            });
	        });
	    };
	    DetectSingleFaceLandmarksTask.prototype.withFaceExpressions = function () {
	        return new PredictFaceExpressionsTask_1.PredictSingleFaceExpressionsWithFaceAlignmentTask(this, this.input);
	    };
	    DetectSingleFaceLandmarksTask.prototype.withAgeAndGender = function () {
	        return new PredictAgeAndGenderTask_1.PredictSingleAgeAndGenderWithFaceAlignmentTask(this, this.input);
	    };
	    DetectSingleFaceLandmarksTask.prototype.withFaceDescriptor = function () {
	        return new ComputeFaceDescriptorsTasks_1.ComputeSingleFaceDescriptorTask(this, this.input);
	    };
	    return DetectSingleFaceLandmarksTask;
	}(DetectFaceLandmarksTaskBase));
	exports.DetectSingleFaceLandmarksTask = DetectSingleFaceLandmarksTask;
	//# sourceMappingURL=DetectFaceLandmarksTasks.js.map

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var WithFaceDetection_1 = __webpack_require__(167);
	var MtcnnOptions_1 = __webpack_require__(272);
	var SsdMobilenetv1Options_1 = __webpack_require__(273);
	var TinyFaceDetectorOptions_1 = __webpack_require__(624);
	var tinyYolov2_1 = __webpack_require__(212);
	var ComposableTask_1 = __webpack_require__(168);
	var DetectFaceLandmarksTasks_1 = __webpack_require__(612);
	var nets_1 = __webpack_require__(169);
	var PredictAgeAndGenderTask_1 = __webpack_require__(270);
	var PredictFaceExpressionsTask_1 = __webpack_require__(271);
	var DetectFacesTaskBase = /** @class */ (function (_super) {
	    tslib_1.__extends(DetectFacesTaskBase, _super);
	    function DetectFacesTaskBase(input, options) {
	        if (options === void 0) { options = new SsdMobilenetv1Options_1.SsdMobilenetv1Options(); }
	        var _this = _super.call(this) || this;
	        _this.input = input;
	        _this.options = options;
	        return _this;
	    }
	    return DetectFacesTaskBase;
	}(ComposableTask_1.ComposableTask));
	exports.DetectFacesTaskBase = DetectFacesTaskBase;
	var DetectAllFacesTask = /** @class */ (function (_super) {
	    tslib_1.__extends(DetectAllFacesTask, _super);
	    function DetectAllFacesTask() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DetectAllFacesTask.prototype.run = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _a, input, options, faceDetectionFunction;
	            return tslib_1.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        _a = this, input = _a.input, options = _a.options;
	                        if (!(options instanceof MtcnnOptions_1.MtcnnOptions)) return [3 /*break*/, 2];
	                        return [4 /*yield*/, nets_1.nets.mtcnn.forward(input, options)];
	                    case 1: return [2 /*return*/, (_b.sent())
	                            .map(function (result) { return result.detection; })];
	                    case 2:
	                        faceDetectionFunction = options instanceof TinyFaceDetectorOptions_1.TinyFaceDetectorOptions
	                            ? function (input) { return nets_1.nets.tinyFaceDetector.locateFaces(input, options); }
	                            : (options instanceof SsdMobilenetv1Options_1.SsdMobilenetv1Options
	                                ? function (input) { return nets_1.nets.ssdMobilenetv1.locateFaces(input, options); }
	                                : (options instanceof tinyYolov2_1.TinyYolov2Options
	                                    ? function (input) { return nets_1.nets.tinyYolov2.locateFaces(input, options); }
	                                    : null));
	                        if (!faceDetectionFunction) {
	                            throw new Error('detectFaces - expected options to be instance of TinyFaceDetectorOptions | SsdMobilenetv1Options | MtcnnOptions | TinyYolov2Options');
	                        }
	                        return [2 /*return*/, faceDetectionFunction(input)];
	                }
	            });
	        });
	    };
	    DetectAllFacesTask.prototype.runAndExtendWithFaceDetections = function () {
	        var _this = this;
	        return new Promise(function (res) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
	            var detections;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.run()];
	                    case 1:
	                        detections = _a.sent();
	                        return [2 /*return*/, res(detections.map(function (detection) { return WithFaceDetection_1.extendWithFaceDetection({}, detection); }))];
	                }
	            });
	        }); });
	    };
	    DetectAllFacesTask.prototype.withFaceLandmarks = function (useTinyLandmarkNet) {
	        if (useTinyLandmarkNet === void 0) { useTinyLandmarkNet = false; }
	        return new DetectFaceLandmarksTasks_1.DetectAllFaceLandmarksTask(this.runAndExtendWithFaceDetections(), this.input, useTinyLandmarkNet);
	    };
	    DetectAllFacesTask.prototype.withFaceExpressions = function () {
	        return new PredictFaceExpressionsTask_1.PredictAllFaceExpressionsTask(this.runAndExtendWithFaceDetections(), this.input);
	    };
	    DetectAllFacesTask.prototype.withAgeAndGender = function () {
	        return new PredictAgeAndGenderTask_1.PredictAllAgeAndGenderTask(this.runAndExtendWithFaceDetections(), this.input);
	    };
	    return DetectAllFacesTask;
	}(DetectFacesTaskBase));
	exports.DetectAllFacesTask = DetectAllFacesTask;
	var DetectSingleFaceTask = /** @class */ (function (_super) {
	    tslib_1.__extends(DetectSingleFaceTask, _super);
	    function DetectSingleFaceTask() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DetectSingleFaceTask.prototype.run = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var faceDetections, faceDetectionWithHighestScore;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, new DetectAllFacesTask(this.input, this.options)];
	                    case 1:
	                        faceDetections = _a.sent();
	                        faceDetectionWithHighestScore = faceDetections[0];
	                        faceDetections.forEach(function (faceDetection) {
	                            if (faceDetection.score > faceDetectionWithHighestScore.score) {
	                                faceDetectionWithHighestScore = faceDetection;
	                            }
	                        });
	                        return [2 /*return*/, faceDetectionWithHighestScore];
	                }
	            });
	        });
	    };
	    DetectSingleFaceTask.prototype.runAndExtendWithFaceDetection = function () {
	        var _this = this;
	        return new Promise(function (res) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
	            var detection;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.run()];
	                    case 1:
	                        detection = _a.sent();
	                        return [2 /*return*/, res(detection ? WithFaceDetection_1.extendWithFaceDetection({}, detection) : undefined)];
	                }
	            });
	        }); });
	    };
	    DetectSingleFaceTask.prototype.withFaceLandmarks = function (useTinyLandmarkNet) {
	        if (useTinyLandmarkNet === void 0) { useTinyLandmarkNet = false; }
	        return new DetectFaceLandmarksTasks_1.DetectSingleFaceLandmarksTask(this.runAndExtendWithFaceDetection(), this.input, useTinyLandmarkNet);
	    };
	    DetectSingleFaceTask.prototype.withFaceExpressions = function () {
	        return new PredictFaceExpressionsTask_1.PredictSingleFaceExpressionsTask(this.runAndExtendWithFaceDetection(), this.input);
	    };
	    DetectSingleFaceTask.prototype.withAgeAndGender = function () {
	        return new PredictAgeAndGenderTask_1.PredictSingleAgeAndGenderTask(this.runAndExtendWithFaceDetection(), this.input);
	    };
	    return DetectSingleFaceTask;
	}(DetectFacesTaskBase));
	exports.DetectSingleFaceTask = DetectSingleFaceTask;
	//# sourceMappingURL=DetectFacesTasks.js.map

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var SsdMobilenetv1Options_1 = __webpack_require__(273);
	var DetectFacesTasks_1 = __webpack_require__(613);
	function detectSingleFace(input, options) {
	    if (options === void 0) { options = new SsdMobilenetv1Options_1.SsdMobilenetv1Options(); }
	    return new DetectFacesTasks_1.DetectSingleFaceTask(input, options);
	}
	exports.detectSingleFace = detectSingleFace;
	function detectAllFaces(input, options) {
	    if (options === void 0) { options = new SsdMobilenetv1Options_1.SsdMobilenetv1Options(); }
	    return new DetectFacesTasks_1.DetectAllFacesTask(input, options);
	}
	exports.detectAllFaces = detectAllFaces;
	//# sourceMappingURL=detectFaces.js.map

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var dom_1 = __webpack_require__(54);
	var env_1 = __webpack_require__(55);
	var normalize_1 = __webpack_require__(617);
	function extractImagePatches(img, boxes, _a) {
	    var width = _a.width, height = _a.height;
	    return tslib_1.__awaiter(this, void 0, void 0, function () {
	        var imgCtx, bitmaps, imagePatchesDatas;
	        var _this = this;
	        return tslib_1.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    imgCtx = dom_1.getContext2dOrThrow(img);
	                    return [4 /*yield*/, Promise.all(boxes.map(function (box) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
	                            var _a, y, ey, x, ex, fromX, fromY, imgData;
	                            return tslib_1.__generator(this, function (_b) {
	                                _a = box.padAtBorders(img.height, img.width), y = _a.y, ey = _a.ey, x = _a.x, ex = _a.ex;
	                                fromX = x - 1;
	                                fromY = y - 1;
	                                imgData = imgCtx.getImageData(fromX, fromY, (ex - fromX), (ey - fromY));
	                                return [2 /*return*/, env_1.env.isNodejs() ? dom_1.createCanvasFromMedia(imgData) : createImageBitmap(imgData)];
	                            });
	                        }); }))];
	                case 1:
	                    bitmaps = _b.sent();
	                    imagePatchesDatas = [];
	                    bitmaps.forEach(function (bmp) {
	                        var patch = dom_1.createCanvas({ width: width, height: height });
	                        var patchCtx = dom_1.getContext2dOrThrow(patch);
	                        patchCtx.drawImage(bmp, 0, 0, width, height);
	                        var data = patchCtx.getImageData(0, 0, width, height).data;
	                        var currData = [];
	                        // RGBA -> BGR
	                        for (var i = 0; i < data.length; i += 4) {
	                            currData.push(data[i + 2]);
	                            currData.push(data[i + 1]);
	                            currData.push(data[i]);
	                        }
	                        imagePatchesDatas.push(currData);
	                    });
	                    return [2 /*return*/, imagePatchesDatas.map(function (data) {
	                            var t = tf.tidy(function () {
	                                var imagePatchTensor = tf.transpose(tf.tensor4d(data, [1, width, height, 3]), [0, 2, 1, 3]).toFloat();
	                                return normalize_1.normalize(imagePatchTensor);
	                            });
	                            return t;
	                        })];
	            }
	        });
	    });
	}
	exports.extractImagePatches = extractImagePatches;
	//# sourceMappingURL=extractImagePatches.js.map

/***/ },
/* 616 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function getSizesForScale(scale, _a) {
	    var height = _a[0], width = _a[1];
	    return {
	        height: Math.floor(height * scale),
	        width: Math.floor(width * scale)
	    };
	}
	exports.getSizesForScale = getSizesForScale;
	//# sourceMappingURL=getSizesForScale.js.map

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	function normalize(x) {
	    return tf.tidy(function () { return tf.mul(tf.sub(x, tf.scalar(127.5)), tf.scalar(0.0078125)); });
	}
	exports.normalize = normalize;
	//# sourceMappingURL=normalize.js.map

/***/ },
/* 618 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function iou(box1, box2, isIOU) {
	    if (isIOU === void 0) { isIOU = true; }
	    var width = Math.max(0.0, Math.min(box1.right, box2.right) - Math.max(box1.left, box2.left));
	    var height = Math.max(0.0, Math.min(box1.bottom, box2.bottom) - Math.max(box1.top, box2.top));
	    var interSection = width * height;
	    return isIOU
	        ? interSection / (box1.area + box2.area - interSection)
	        : interSection / Math.min(box1.area, box2.area);
	}
	exports.iou = iou;
	//# sourceMappingURL=iou.js.map

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var iou_1 = __webpack_require__(618);
	function nonMaxSuppression(boxes, scores, iouThreshold, isIOU) {
	    if (isIOU === void 0) { isIOU = true; }
	    var indicesSortedByScore = scores
	        .map(function (score, boxIndex) { return ({ score: score, boxIndex: boxIndex }); })
	        .sort(function (c1, c2) { return c1.score - c2.score; })
	        .map(function (c) { return c.boxIndex; });
	    var pick = [];
	    var _loop_1 = function () {
	        var curr = indicesSortedByScore.pop();
	        pick.push(curr);
	        var indices = indicesSortedByScore;
	        var outputs = [];
	        for (var i = 0; i < indices.length; i++) {
	            var idx = indices[i];
	            var currBox = boxes[curr];
	            var idxBox = boxes[idx];
	            outputs.push(iou_1.iou(currBox, idxBox, isIOU));
	        }
	        indicesSortedByScore = indicesSortedByScore.filter(function (_, j) { return outputs[j] <= iouThreshold; });
	    };
	    while (indicesSortedByScore.length > 0) {
	        _loop_1();
	    }
	    return pick;
	}
	exports.nonMaxSuppression = nonMaxSuppression;
	//# sourceMappingURL=nonMaxSuppression.js.map

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	function normalize(x, meanRgb) {
	    return tf.tidy(function () {
	        var r = meanRgb[0], g = meanRgb[1], b = meanRgb[2];
	        var avg_r = tf.fill(tslib_1.__spreadArrays(x.shape.slice(0, 3), [1]), r);
	        var avg_g = tf.fill(tslib_1.__spreadArrays(x.shape.slice(0, 3), [1]), g);
	        var avg_b = tf.fill(tslib_1.__spreadArrays(x.shape.slice(0, 3), [1]), b);
	        var avg_rgb = tf.concat([avg_r, avg_g, avg_b], 3);
	        return tf.sub(x, avg_rgb);
	    });
	}
	exports.normalize = normalize;
	//# sourceMappingURL=normalize.js.map

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	/**
	 * Pads the smaller dimension of an image tensor with zeros, such that width === height.
	 *
	 * @param imgTensor The image tensor.
	 * @param isCenterImage (optional, default: false) If true, add an equal amount of padding on
	 * both sides of the minor dimension oof the image.
	 * @returns The padded tensor with width === height.
	 */
	function padToSquare(imgTensor, isCenterImage) {
	    if (isCenterImage === void 0) { isCenterImage = false; }
	    return tf.tidy(function () {
	        var _a = imgTensor.shape.slice(1), height = _a[0], width = _a[1];
	        if (height === width) {
	            return imgTensor;
	        }
	        var dimDiff = Math.abs(height - width);
	        var paddingAmount = Math.round(dimDiff * (isCenterImage ? 0.5 : 1));
	        var paddingAxis = height > width ? 2 : 1;
	        var createPaddingTensor = function (paddingAmount) {
	            var paddingTensorShape = imgTensor.shape.slice();
	            paddingTensorShape[paddingAxis] = paddingAmount;
	            return tf.fill(paddingTensorShape, 0);
	        };
	        var paddingTensorAppend = createPaddingTensor(paddingAmount);
	        var remainingPaddingAmount = dimDiff - paddingTensorAppend.shape[paddingAxis];
	        var paddingTensorPrepend = isCenterImage && remainingPaddingAmount
	            ? createPaddingTensor(remainingPaddingAmount)
	            : null;
	        var tensorsToStack = [
	            paddingTensorPrepend,
	            imgTensor,
	            paddingTensorAppend
	        ]
	            .filter(function (t) { return !!t; })
	            .map(function (t) { return t.toFloat(); });
	        return tf.concat(tensorsToStack, paddingAxis);
	    });
	}
	exports.padToSquare = padToSquare;
	//# sourceMappingURL=padToSquare.js.map

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var SsdMobilenetv1_1 = __webpack_require__(395);
	tslib_1.__exportStar(__webpack_require__(395), exports);
	tslib_1.__exportStar(__webpack_require__(273), exports);
	function createSsdMobilenetv1(weights) {
	    var net = new SsdMobilenetv1_1.SsdMobilenetv1();
	    net.extractWeights(weights);
	    return net;
	}
	exports.createSsdMobilenetv1 = createSsdMobilenetv1;
	function createFaceDetectionNet(weights) {
	    return createSsdMobilenetv1(weights);
	}
	exports.createFaceDetectionNet = createFaceDetectionNet;
	// alias for backward compatibily
	var FaceDetectionNet = /** @class */ (function (_super) {
	    tslib_1.__extends(FaceDetectionNet, _super);
	    function FaceDetectionNet() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return FaceDetectionNet;
	}(SsdMobilenetv1_1.SsdMobilenetv1));
	exports.FaceDetectionNet = FaceDetectionNet;
	//# sourceMappingURL=index.js.map

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	function pointwiseConvLayer(x, params, strides) {
	    return tf.tidy(function () {
	        var out = tf.conv2d(x, params.filters, strides, 'same');
	        out = tf.add(out, params.batch_norm_offset);
	        return tf.clipByValue(out, 0, 6);
	    });
	}
	exports.pointwiseConvLayer = pointwiseConvLayer;
	//# sourceMappingURL=pointwiseConvLayer.js.map

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tinyYolov2_1 = __webpack_require__(212);
	var TinyFaceDetectorOptions = /** @class */ (function (_super) {
	    tslib_1.__extends(TinyFaceDetectorOptions, _super);
	    function TinyFaceDetectorOptions() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._name = 'TinyFaceDetectorOptions';
	        return _this;
	    }
	    return TinyFaceDetectorOptions;
	}(tinyYolov2_1.TinyYolov2Options));
	exports.TinyFaceDetectorOptions = TinyFaceDetectorOptions;
	//# sourceMappingURL=TinyFaceDetectorOptions.js.map

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var BoundingBox_1 = __webpack_require__(573);
	var ObjectDetection_1 = __webpack_require__(379);
	var common_1 = __webpack_require__(33);
	var dom_1 = __webpack_require__(54);
	var NeuralNetwork_1 = __webpack_require__(96);
	var ops_1 = __webpack_require__(98);
	var nonMaxSuppression_1 = __webpack_require__(619);
	var normalize_1 = __webpack_require__(620);
	var config_1 = __webpack_require__(627);
	var convWithBatchNorm_1 = __webpack_require__(1501);
	var depthwiseSeparableConv_1 = __webpack_require__(1502);
	var extractParams_1 = __webpack_require__(1503);
	var extractParamsFromWeigthMap_1 = __webpack_require__(1504);
	var leaky_1 = __webpack_require__(397);
	var TinyYolov2Options_1 = __webpack_require__(626);
	var TinyYolov2Base = /** @class */ (function (_super) {
	    tslib_1.__extends(TinyYolov2Base, _super);
	    function TinyYolov2Base(config) {
	        var _this = _super.call(this, 'TinyYolov2') || this;
	        config_1.validateConfig(config);
	        _this._config = config;
	        return _this;
	    }
	    Object.defineProperty(TinyYolov2Base.prototype, "config", {
	        get: function () {
	            return this._config;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TinyYolov2Base.prototype, "withClassScores", {
	        get: function () {
	            return this.config.withClassScores || this.config.classes.length > 1;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TinyYolov2Base.prototype, "boxEncodingSize", {
	        get: function () {
	            return 5 + (this.withClassScores ? this.config.classes.length : 0);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TinyYolov2Base.prototype.runTinyYolov2 = function (x, params) {
	        var out = convWithBatchNorm_1.convWithBatchNorm(x, params.conv0);
	        out = tf.maxPool(out, [2, 2], [2, 2], 'same');
	        out = convWithBatchNorm_1.convWithBatchNorm(out, params.conv1);
	        out = tf.maxPool(out, [2, 2], [2, 2], 'same');
	        out = convWithBatchNorm_1.convWithBatchNorm(out, params.conv2);
	        out = tf.maxPool(out, [2, 2], [2, 2], 'same');
	        out = convWithBatchNorm_1.convWithBatchNorm(out, params.conv3);
	        out = tf.maxPool(out, [2, 2], [2, 2], 'same');
	        out = convWithBatchNorm_1.convWithBatchNorm(out, params.conv4);
	        out = tf.maxPool(out, [2, 2], [2, 2], 'same');
	        out = convWithBatchNorm_1.convWithBatchNorm(out, params.conv5);
	        out = tf.maxPool(out, [2, 2], [1, 1], 'same');
	        out = convWithBatchNorm_1.convWithBatchNorm(out, params.conv6);
	        out = convWithBatchNorm_1.convWithBatchNorm(out, params.conv7);
	        return common_1.convLayer(out, params.conv8, 'valid', false);
	    };
	    TinyYolov2Base.prototype.runMobilenet = function (x, params) {
	        var out = this.config.isFirstLayerConv2d
	            ? leaky_1.leaky(common_1.convLayer(x, params.conv0, 'valid', false))
	            : depthwiseSeparableConv_1.depthwiseSeparableConv(x, params.conv0);
	        out = tf.maxPool(out, [2, 2], [2, 2], 'same');
	        out = depthwiseSeparableConv_1.depthwiseSeparableConv(out, params.conv1);
	        out = tf.maxPool(out, [2, 2], [2, 2], 'same');
	        out = depthwiseSeparableConv_1.depthwiseSeparableConv(out, params.conv2);
	        out = tf.maxPool(out, [2, 2], [2, 2], 'same');
	        out = depthwiseSeparableConv_1.depthwiseSeparableConv(out, params.conv3);
	        out = tf.maxPool(out, [2, 2], [2, 2], 'same');
	        out = depthwiseSeparableConv_1.depthwiseSeparableConv(out, params.conv4);
	        out = tf.maxPool(out, [2, 2], [2, 2], 'same');
	        out = depthwiseSeparableConv_1.depthwiseSeparableConv(out, params.conv5);
	        out = tf.maxPool(out, [2, 2], [1, 1], 'same');
	        out = params.conv6 ? depthwiseSeparableConv_1.depthwiseSeparableConv(out, params.conv6) : out;
	        out = params.conv7 ? depthwiseSeparableConv_1.depthwiseSeparableConv(out, params.conv7) : out;
	        return common_1.convLayer(out, params.conv8, 'valid', false);
	    };
	    TinyYolov2Base.prototype.forwardInput = function (input, inputSize) {
	        var _this = this;
	        var params = this.params;
	        if (!params) {
	            throw new Error('TinyYolov2 - load model before inference');
	        }
	        return tf.tidy(function () {
	            var batchTensor = input.toBatchTensor(inputSize, false).toFloat();
	            batchTensor = _this.config.meanRgb
	                ? normalize_1.normalize(batchTensor, _this.config.meanRgb)
	                : batchTensor;
	            batchTensor = batchTensor.div(tf.scalar(256));
	            return _this.config.withSeparableConvs
	                ? _this.runMobilenet(batchTensor, params)
	                : _this.runTinyYolov2(batchTensor, params);
	        });
	    };
	    TinyYolov2Base.prototype.forward = function (input, inputSize) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _a;
	            return tslib_1.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        _a = this.forwardInput;
	                        return [4 /*yield*/, dom_1.toNetInput(input)];
	                    case 1: return [4 /*yield*/, _a.apply(this, [_b.sent(), inputSize])];
	                    case 2: return [2 /*return*/, _b.sent()];
	                }
	            });
	        });
	    };
	    TinyYolov2Base.prototype.detect = function (input, forwardParams) {
	        if (forwardParams === void 0) { forwardParams = {}; }
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _a, inputSize, scoreThreshold, netInput, out, out0, inputDimensions, results, boxes, scores, classScores, classNames, indices, detections;
	            var _this = this;
	            return tslib_1.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        _a = new TinyYolov2Options_1.TinyYolov2Options(forwardParams), inputSize = _a.inputSize, scoreThreshold = _a.scoreThreshold;
	                        return [4 /*yield*/, dom_1.toNetInput(input)];
	                    case 1:
	                        netInput = _b.sent();
	                        return [4 /*yield*/, this.forwardInput(netInput, inputSize)];
	                    case 2:
	                        out = _b.sent();
	                        out0 = tf.tidy(function () { return tf.unstack(out)[0].expandDims(); });
	                        inputDimensions = {
	                            width: netInput.getInputWidth(0),
	                            height: netInput.getInputHeight(0)
	                        };
	                        return [4 /*yield*/, this.extractBoxes(out0, netInput.getReshapedInputDimensions(0), scoreThreshold)];
	                    case 3:
	                        results = _b.sent();
	                        out.dispose();
	                        out0.dispose();
	                        boxes = results.map(function (res) { return res.box; });
	                        scores = results.map(function (res) { return res.score; });
	                        classScores = results.map(function (res) { return res.classScore; });
	                        classNames = results.map(function (res) { return _this.config.classes[res.label]; });
	                        indices = nonMaxSuppression_1.nonMaxSuppression(boxes.map(function (box) { return box.rescale(inputSize); }), scores, this.config.iouThreshold, true);
	                        detections = indices.map(function (idx) {
	                            return new ObjectDetection_1.ObjectDetection(scores[idx], classScores[idx], classNames[idx], boxes[idx], inputDimensions);
	                        });
	                        return [2 /*return*/, detections];
	                }
	            });
	        });
	    };
	    TinyYolov2Base.prototype.getDefaultModelName = function () {
	        return '';
	    };
	    TinyYolov2Base.prototype.extractParamsFromWeigthMap = function (weightMap) {
	        return extractParamsFromWeigthMap_1.extractParamsFromWeigthMap(weightMap, this.config);
	    };
	    TinyYolov2Base.prototype.extractParams = function (weights) {
	        var filterSizes = this.config.filterSizes || TinyYolov2Base.DEFAULT_FILTER_SIZES;
	        var numFilters = filterSizes ? filterSizes.length : undefined;
	        if (numFilters !== 7 && numFilters !== 8 && numFilters !== 9) {
	            throw new Error("TinyYolov2 - expected 7 | 8 | 9 convolutional filters, but found " + numFilters + " filterSizes in config");
	        }
	        return extractParams_1.extractParams(weights, this.config, this.boxEncodingSize, filterSizes);
	    };
	    TinyYolov2Base.prototype.extractBoxes = function (outputTensor, inputBlobDimensions, scoreThreshold) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var width, height, inputSize, correctionFactorX, correctionFactorY, numCells, numBoxes, _a, boxesTensor, scoresTensor, classScoresTensor, results, scoresData, boxesData, row, col, anchor, score, ctX, ctY, width_1, height_1, x, y, pos, _b, classScore, label, _c;
	            var _this = this;
	            return tslib_1.__generator(this, function (_d) {
	                switch (_d.label) {
	                    case 0:
	                        width = inputBlobDimensions.width, height = inputBlobDimensions.height;
	                        inputSize = Math.max(width, height);
	                        correctionFactorX = inputSize / width;
	                        correctionFactorY = inputSize / height;
	                        numCells = outputTensor.shape[1];
	                        numBoxes = this.config.anchors.length;
	                        _a = tf.tidy(function () {
	                            var reshaped = outputTensor.reshape([numCells, numCells, numBoxes, _this.boxEncodingSize]);
	                            var boxes = reshaped.slice([0, 0, 0, 0], [numCells, numCells, numBoxes, 4]);
	                            var scores = reshaped.slice([0, 0, 0, 4], [numCells, numCells, numBoxes, 1]);
	                            var classScores = _this.withClassScores
	                                ? tf.softmax(reshaped.slice([0, 0, 0, 5], [numCells, numCells, numBoxes, _this.config.classes.length]), 3)
	                                : tf.scalar(0);
	                            return [boxes, scores, classScores];
	                        }), boxesTensor = _a[0], scoresTensor = _a[1], classScoresTensor = _a[2];
	                        results = [];
	                        return [4 /*yield*/, scoresTensor.array()];
	                    case 1:
	                        scoresData = _d.sent();
	                        return [4 /*yield*/, boxesTensor.array()];
	                    case 2:
	                        boxesData = _d.sent();
	                        row = 0;
	                        _d.label = 3;
	                    case 3:
	                        if (!(row < numCells)) return [3 /*break*/, 12];
	                        col = 0;
	                        _d.label = 4;
	                    case 4:
	                        if (!(col < numCells)) return [3 /*break*/, 11];
	                        anchor = 0;
	                        _d.label = 5;
	                    case 5:
	                        if (!(anchor < numBoxes)) return [3 /*break*/, 10];
	                        score = ops_1.sigmoid(scoresData[row][col][anchor][0]);
	                        if (!(!scoreThreshold || score > scoreThreshold)) return [3 /*break*/, 9];
	                        ctX = ((col + ops_1.sigmoid(boxesData[row][col][anchor][0])) / numCells) * correctionFactorX;
	                        ctY = ((row + ops_1.sigmoid(boxesData[row][col][anchor][1])) / numCells) * correctionFactorY;
	                        width_1 = ((Math.exp(boxesData[row][col][anchor][2]) * this.config.anchors[anchor].x) / numCells) * correctionFactorX;
	                        height_1 = ((Math.exp(boxesData[row][col][anchor][3]) * this.config.anchors[anchor].y) / numCells) * correctionFactorY;
	                        x = (ctX - (width_1 / 2));
	                        y = (ctY - (height_1 / 2));
	                        pos = { row: row, col: col, anchor: anchor };
	                        if (!this.withClassScores) return [3 /*break*/, 7];
	                        return [4 /*yield*/, this.extractPredictedClass(classScoresTensor, pos)];
	                    case 6:
	                        _c = _d.sent();
	                        return [3 /*break*/, 8];
	                    case 7:
	                        _c = { classScore: 1, label: 0 };
	                        _d.label = 8;
	                    case 8:
	                        _b = _c, classScore = _b.classScore, label = _b.label;
	                        results.push(tslib_1.__assign({ box: new BoundingBox_1.BoundingBox(x, y, x + width_1, y + height_1), score: score, classScore: score * classScore, label: label }, pos));
	                        _d.label = 9;
	                    case 9:
	                        anchor++;
	                        return [3 /*break*/, 5];
	                    case 10:
	                        col++;
	                        return [3 /*break*/, 4];
	                    case 11:
	                        row++;
	                        return [3 /*break*/, 3];
	                    case 12:
	                        boxesTensor.dispose();
	                        scoresTensor.dispose();
	                        classScoresTensor.dispose();
	                        return [2 /*return*/, results];
	                }
	            });
	        });
	    };
	    TinyYolov2Base.prototype.extractPredictedClass = function (classesTensor, pos) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var row, col, anchor, classesData;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        row = pos.row, col = pos.col, anchor = pos.anchor;
	                        return [4 /*yield*/, classesTensor.array()];
	                    case 1:
	                        classesData = _a.sent();
	                        return [2 /*return*/, Array(this.config.classes.length).fill(0)
	                                .map(function (_, i) { return classesData[row][col][anchor][i]; })
	                                .map(function (classScore, label) { return ({
	                                classScore: classScore,
	                                label: label
	                            }); })
	                                .reduce(function (max, curr) { return max.classScore > curr.classScore ? max : curr; })];
	                }
	            });
	        });
	    };
	    TinyYolov2Base.DEFAULT_FILTER_SIZES = [
	        3, 16, 32, 64, 128, 256, 512, 1024, 1024
	    ];
	    return TinyYolov2Base;
	}(NeuralNetwork_1.NeuralNetwork));
	exports.TinyYolov2Base = TinyYolov2Base;
	//# sourceMappingURL=TinyYolov2Base.js.map

/***/ },
/* 626 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var TinyYolov2SizeType;
	(function (TinyYolov2SizeType) {
	    TinyYolov2SizeType[TinyYolov2SizeType["XS"] = 224] = "XS";
	    TinyYolov2SizeType[TinyYolov2SizeType["SM"] = 320] = "SM";
	    TinyYolov2SizeType[TinyYolov2SizeType["MD"] = 416] = "MD";
	    TinyYolov2SizeType[TinyYolov2SizeType["LG"] = 608] = "LG";
	})(TinyYolov2SizeType = exports.TinyYolov2SizeType || (exports.TinyYolov2SizeType = {}));
	var TinyYolov2Options = /** @class */ (function () {
	    function TinyYolov2Options(_a) {
	        var _b = _a === void 0 ? {} : _a, inputSize = _b.inputSize, scoreThreshold = _b.scoreThreshold;
	        this._name = 'TinyYolov2Options';
	        this._inputSize = inputSize || 416;
	        this._scoreThreshold = scoreThreshold || 0.5;
	        if (typeof this._inputSize !== 'number' || this._inputSize % 32 !== 0) {
	            throw new Error(this._name + " - expected inputSize to be a number divisible by 32");
	        }
	        if (typeof this._scoreThreshold !== 'number' || this._scoreThreshold <= 0 || this._scoreThreshold >= 1) {
	            throw new Error(this._name + " - expected scoreThreshold to be a number between 0 and 1");
	        }
	    }
	    Object.defineProperty(TinyYolov2Options.prototype, "inputSize", {
	        get: function () { return this._inputSize; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TinyYolov2Options.prototype, "scoreThreshold", {
	        get: function () { return this._scoreThreshold; },
	        enumerable: true,
	        configurable: true
	    });
	    return TinyYolov2Options;
	}());
	exports.TinyYolov2Options = TinyYolov2Options;
	//# sourceMappingURL=TinyYolov2Options.js.map

/***/ },
/* 627 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var isNumber = function (arg) { return typeof arg === 'number'; };
	function validateConfig(config) {
	    if (!config) {
	        throw new Error("invalid config: " + config);
	    }
	    if (typeof config.withSeparableConvs !== 'boolean') {
	        throw new Error("config.withSeparableConvs has to be a boolean, have: " + config.withSeparableConvs);
	    }
	    if (!isNumber(config.iouThreshold) || config.iouThreshold < 0 || config.iouThreshold > 1.0) {
	        throw new Error("config.iouThreshold has to be a number between [0, 1], have: " + config.iouThreshold);
	    }
	    if (!Array.isArray(config.classes)
	        || !config.classes.length
	        || !config.classes.every(function (c) { return typeof c === 'string'; })) {
	        throw new Error("config.classes has to be an array class names: string[], have: " + JSON.stringify(config.classes));
	    }
	    if (!Array.isArray(config.anchors)
	        || !config.anchors.length
	        || !config.anchors.map(function (a) { return a || {}; }).every(function (a) { return isNumber(a.x) && isNumber(a.y); })) {
	        throw new Error("config.anchors has to be an array of { x: number, y: number }, have: " + JSON.stringify(config.anchors));
	    }
	    if (config.meanRgb && (!Array.isArray(config.meanRgb)
	        || config.meanRgb.length !== 3
	        || !config.meanRgb.every(isNumber))) {
	        throw new Error("config.meanRgb has to be an array of shape [number, number, number], have: " + JSON.stringify(config.meanRgb));
	    }
	}
	exports.validateConfig = validateConfig;
	//# sourceMappingURL=config.js.map

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(99);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 629 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 630 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $Object = __webpack_require__(209);
	
	/** @type {import('./Object.getPrototypeOf')} */
	module.exports = $Object.getPrototypeOf || null;


/***/ },
/* 632 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./Reflect.getPrototypeOf')} */
	module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var origSymbol = typeof Symbol !== 'undefined' && Symbol;
	var hasSymbolSham = __webpack_require__(400);
	
	/** @type {import('.')} */
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};


/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = __webpack_require__(400);
	
	/** @type {import('.')} */
	module.exports = function hasToStringTagShams() {
		return hasSymbols() && !!Symbol.toStringTag;
	};


/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(404);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(1728);
	
	var _runTransitionHook = __webpack_require__(404);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(170);
	
	var _PathUtils = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlMessageFormat = __webpack_require__(1540)['default'];
	
	// Add all locale data to `IntlMessageFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(2071);
	
	// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlMessageFormat;
	exports['default'] = exports;


/***/ },
/* 639 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports.extend = extend;
	var hop = Object.prototype.hasOwnProperty;
	
	function extend(obj) {
	    var sources = Array.prototype.slice.call(arguments, 1),
	        i, len, source, key;
	
	    for (i = 0, len = sources.length; i < len; i += 1) {
	        source = sources[i];
	        if (!source) { continue; }
	
	        for (key in source) {
	            if (hop.call(source, key)) {
	                obj[key] = source[key];
	            }
	        }
	    }
	
	    return obj;
	}
	exports.hop = hop;
	
	//# sourceMappingURL=utils.js.map

/***/ },
/* 640 */
/***/ function(module, exports) {

	'use strict';
	
	var fnToStr = Function.prototype.toString;
	var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
	var badArrayLike;
	var isCallableMarker;
	if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
		try {
			badArrayLike = Object.defineProperty({}, 'length', {
				get: function () {
					throw isCallableMarker;
				}
			});
			isCallableMarker = {};
			// eslint-disable-next-line no-throw-literal
			reflectApply(function () { throw 42; }, null, badArrayLike);
		} catch (_) {
			if (_ !== isCallableMarker) {
				reflectApply = null;
			}
		}
	} else {
		reflectApply = null;
	}
	
	var constructorRegex = /^\s*class\b/;
	var isES6ClassFn = function isES6ClassFunction(value) {
		try {
			var fnStr = fnToStr.call(value);
			return constructorRegex.test(fnStr);
		} catch (e) {
			return false; // not a function
		}
	};
	
	var tryFunctionObject = function tryFunctionToStr(value) {
		try {
			if (isES6ClassFn(value)) { return false; }
			fnToStr.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var objectClass = '[object Object]';
	var fnClass = '[object Function]';
	var genClass = '[object GeneratorFunction]';
	var ddaClass = '[object HTMLAllCollection]'; // IE 11
	var ddaClass2 = '[object HTML document.all class]';
	var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
	var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
	
	var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing
	
	var isDDA = function isDocumentDotAll() { return false; };
	if (typeof document === 'object') {
		// Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
		var all = document.all;
		if (toStr.call(all) === toStr.call(document.all)) {
			isDDA = function isDocumentDotAll(value) {
				/* globals document: false */
				// in IE 6-8, typeof document.all is "object" and it's truthy
				if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
					try {
						var str = toStr.call(value);
						return (
							str === ddaClass
							|| str === ddaClass2
							|| str === ddaClass3 // opera 12.16
							|| str === objectClass // IE 6-8
						) && value('') == null; // eslint-disable-line eqeqeq
					} catch (e) { /**/ }
				}
				return false;
			};
		}
	}
	
	module.exports = reflectApply
		? function isCallable(value) {
			if (isDDA(value)) { return true; }
			if (!value) { return false; }
			if (typeof value !== 'function' && typeof value !== 'object') { return false; }
			try {
				reflectApply(value, null, badArrayLike);
			} catch (e) {
				if (e !== isCallableMarker) { return false; }
			}
			return !isES6ClassFn(value) && tryFunctionObject(value);
		}
		: function isCallable(value) {
			if (isDDA(value)) { return true; }
			if (!value) { return false; }
			if (typeof value !== 'function' && typeof value !== 'object') { return false; }
			if (hasToStringTag) { return tryFunctionObject(value); }
			if (isES6ClassFn(value)) { return false; }
			var strClass = toStr.call(value);
			if (strClass !== fnClass && strClass !== genClass && !(/^\[object HTML/).test(strClass)) { return false; }
			return tryFunctionObject(value);
		};


/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBound = __webpack_require__(84);
	var $toString = callBound('Object.prototype.toString');
	var hasSymbols = __webpack_require__(633)();
	var safeRegexTest = __webpack_require__(939);
	
	if (hasSymbols) {
		var $symToStr = callBound('Symbol.prototype.toString');
		var isSymString = safeRegexTest(/^Symbol\(.*\)$/);
	
		/** @type {(value: object) => value is Symbol} */
		var isSymbolObject = function isRealSymbolObject(value) {
			if (typeof value.valueOf() !== 'symbol') {
				return false;
			}
			return isSymString($symToStr(value));
		};
	
		/** @type {import('.')} */
		module.exports = function isSymbol(value) {
			if (typeof value === 'symbol') {
				return true;
			}
			if (!value || typeof value !== 'object' || $toString(value) !== '[object Symbol]') {
				return false;
			}
			try {
				return isSymbolObject(value);
			} catch (e) {
				return false;
			}
		};
	} else {
		/** @type {import('.')} */
		module.exports = function isSymbol(value) {
			// this environment does not support Symbols.
			return false && value;
		};
	}


/***/ },
/* 642 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(277),
	    stackClear = __webpack_require__(1634),
	    stackDelete = __webpack_require__(1635),
	    stackGet = __webpack_require__(1636),
	    stackHas = __webpack_require__(1637),
	    stackSet = __webpack_require__(1638);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 644 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 645 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1573),
	    keys = __webpack_require__(418);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(649),
	    toKey = __webpack_require__(214);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1582),
	    baseMatchesProperty = __webpack_require__(1583),
	    identity = __webpack_require__(1643),
	    isArray = __webpack_require__(102),
	    property = __webpack_require__(1648);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(102),
	    isKey = __webpack_require__(413),
	    stringToPath = __webpack_require__(655),
	    toString = __webpack_require__(663);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(1565),
	    arraySome = __webpack_require__(645),
	    cacheHas = __webpack_require__(1591);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 651 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(143);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 653 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 654 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1627);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 656 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1576),
	    isObjectLike = __webpack_require__(173);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(101),
	    stubFalse = __webpack_require__(1651);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)(module)))

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(172),
	    isObject = __webpack_require__(143);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1580),
	    baseUnary = __webpack_require__(1590),
	    nodeUtil = __webpack_require__(1629);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(1571),
	    baseForOwn = __webpack_require__(646),
	    baseIteratee = __webpack_require__(648);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(1640),
	    isObject = __webpack_require__(143);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1588);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 664 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./abs')} */
	module.exports = Math.abs;


/***/ },
/* 665 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./maxSafeInteger')} */
	// eslint-disable-next-line no-extra-parens
	module.exports = /** @type {import('./maxSafeInteger')} */ (Number.MAX_SAFE_INTEGER) || 9007199254740991; // Math.pow(2, 53) - 1;


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $isNaN = __webpack_require__(216);
	
	/** @type {import('./isFinite')} */
	module.exports = function isFinite(x) {
		return (typeof x === 'number' || typeof x === 'bigint')
	        && !$isNaN(x)
	        && x !== Infinity
	        && x !== -Infinity;
	};
	


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $abs = __webpack_require__(664);
	var $floor = __webpack_require__(419);
	
	var $isNaN = __webpack_require__(216);
	var $isFinite = __webpack_require__(666);
	
	/** @type {import('./isInteger')} */
	module.exports = function isInteger(argument) {
		if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
			return false;
		}
		var absValue = $abs(argument);
		return $floor(absValue) === absValue;
	};


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Libya) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Palestine) [ar-ps]
	//! author : Majd Al-Shihabi : https://github.com/majdal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arPs = moment.defineLocale('ar-ps', {
	        months: 'كانون الثاني_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_تشري الأوّل_تشرين الثاني_كانون الأوّل'.split(
	            '_'
	        ),
	        monthsShort:
	            'ك٢_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_ت١_ت٢_ك١'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .split('') // reversed since negative lookbehind not supported everywhere
	                .reverse()
	                .join('')
	                .replace(/[١٢](?![\u062a\u0643])/g, function (match) {
	                    return numberMap[match];
	                })
	                .split('')
	                .reverse()
	                .join('')
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arPs;
	
	})));


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays:
	            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	                '_'
	            ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone:
	                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone:
	                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                    '_'
	                ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	                '_'
	            ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays:
	            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	                '_'
	            ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex =
	            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! author : Rasid Redzic : https://github.com/rasidre
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 'm':
	                return withoutSuffix
	                    ? 'jedna minuta'
	                    : isFuture
	                      ? 'jednu minutu'
	                      : 'jedne minute';
	        }
	    }
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jedan sat';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: processRelativeTime,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone:
	                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                    '_'
	                ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	                '_'
	            ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                      ? 'n'
	                      : number === 3
	                        ? 'r'
	                        : number === 4
	                          ? 't'
	                          : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = {
	            standalone:
	                'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	                    '_'
	                ),
	            format: 'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
	                '_'
	            ),
	            isFormat: /DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/,
	        },
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex =
	            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex:
	            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex:
	            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays:
	            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	                '_'
	            ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                      ? 'тан'
	                      : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays:
	            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl:
	            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	                '_'
	            ),
	        monthsGenitiveEl:
	            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	                '_'
	            ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays:
	            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	                '_'
	            ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort:
	            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	                '_'
	            ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	                '_'
	            ),
	        weekdays:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast =
	            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	                ' '
	            ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort:
	            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	                '_'
	            ),
	        weekdays:
	            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	                '_'
	            ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort:
	            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone:
	                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                    '_'
	                ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone:
	                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                    '_'
	                ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort:
	            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort:
	            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse:
	            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone:
	                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex:
	            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex:
	            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone:
	                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings =
	        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone:
	                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays:
	            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	                '_'
	            ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                  ? ' '
	                                  : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                  ? ' '
	                                  : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone:
	                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                    '_'
	                ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(
	                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
	                    function ($0, $1, $2) {
	                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                    }
	                );
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort:
	            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	                '_'
	            ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort:
	            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Kurdish [ku-kmr]
	//! authors : Mazlum Özdogan : https://github.com/mergehez
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(num, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['çend sanîye', 'çend sanîyeyan'],
	            ss: [num + ' sanîye', num + ' sanîyeyan'],
	            m: ['deqîqeyek', 'deqîqeyekê'],
	            mm: [num + ' deqîqe', num + ' deqîqeyan'],
	            h: ['saetek', 'saetekê'],
	            hh: [num + ' saet', num + ' saetan'],
	            d: ['rojek', 'rojekê'],
	            dd: [num + ' roj', num + ' rojan'],
	            w: ['hefteyek', 'hefteyekê'],
	            ww: [num + ' hefte', num + ' hefteyan'],
	            M: ['mehek', 'mehekê'],
	            MM: [num + ' meh', num + ' mehan'],
	            y: ['salek', 'salekê'],
	            yy: [num + ' sal', num + ' salan'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    // function obliqueNumSuffix(num) {
	    //     if(num.includes(':'))
	    //         num = parseInt(num.split(':')[0]);
	    //     else
	    //         num = parseInt(num);
	    //     return num == 0 || num % 10 == 1 ? 'ê'
	    //                         : (num > 10 && num % 10 == 0 ? 'î' : 'an');
	    // }
	    function ezafeNumSuffix(num) {
	        num = '' + num;
	        var l = num.substring(num.length - 1),
	            ll = num.length > 1 ? num.substring(num.length - 2) : '';
	        if (
	            !(ll == 12 || ll == 13) &&
	            (l == '2' || l == '3' || ll == '50' || l == '70' || l == '80')
	        )
	            return 'yê';
	        return 'ê';
	    }
	
	    var kuKmr = moment.defineLocale('ku-kmr', {
	        // According to the spelling rules defined by the work group of Weqfa Mezopotamyayê (Mesopotamia Foundation)
	        // this should be: 'Kanûna Paşîn_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Çirîya Pêşîn_Çirîya Paşîn_Kanûna Pêşîn'
	        // But the names below are more well known and handy
	        months: 'Rêbendan_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Cotmeh_Mijdar_Berfanbar'.split(
	            '_'
	        ),
	        monthsShort: 'Rêb_Sib_Ada_Nîs_Gul_Hez_Tîr_Teb_Îlo_Cot_Mij_Ber'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'Yekşem_Duşem_Sêşem_Çarşem_Pêncşem_În_Şemî'.split('_'),
	        weekdaysShort: 'Yek_Du_Sê_Çar_Pên_În_Şem'.split('_'),
	        weekdaysMin: 'Ye_Du_Sê_Ça_Pê_În_Şe'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'bn' : 'BN';
	            } else {
	                return isLower ? 'pn' : 'PN';
	            }
	        },
	        meridiemParse: /bn|BN|pn|PN/,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[a] YYYY[an]',
	            LLL: 'Do MMMM[a] YYYY[an] HH:mm',
	            LLLL: 'dddd, Do MMMM[a] YYYY[an] HH:mm',
	            ll: 'Do MMM[.] YYYY[an]',
	            lll: 'Do MMM[.] YYYY[an] HH:mm',
	            llll: 'ddd[.], Do MMM[.] YYYY[an] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Îro di saet] LT [de]',
	            nextDay: '[Sibê di saet] LT [de]',
	            nextWeek: 'dddd [di saet] LT [de]',
	            lastDay: '[Duh di saet] LT [de]',
	            lastWeek: 'dddd[a borî di saet] LT [de]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'di %s de',
	            past: 'berî %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(?:yê|ê|\.)/,
	        ordinal: function (num, period) {
	            var p = period.toLowerCase();
	            if (p.includes('w') || p.includes('m')) return num + '.';
	
	            return num + ezafeNumSuffix(num);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return kuKmr;
	
	})));


/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays:
	            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	                '_'
	            ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	              ? forms(key)[1]
	              : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone:
	                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                    '_'
	                ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone:
	                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                    '_'
	                ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays:
	            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                  ? wordKey[1]
	                  : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort:
	            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	                '_'
	            ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	                '_'
	            ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort:
	            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays:
	            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	                '_'
	            ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'én time',
	            hh: '%d timer',
	            d: 'én dag',
	            dd: '%d dager',
	            w: 'én uke',
	            ww: '%d uker',
	            M: 'én måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^(maart|mrt\.?)$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^(maart|mrt\.?)$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone:
	                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                    '_'
	                ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                      ? 'n'
	                      : number === 3
	                        ? 'r'
	                        : number === 4
	                          ? 't'
	                          : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	                '_'
	            ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative =
	            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	                '_'
	            ),
	        monthsSubjective =
	            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	                '_'
	            ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays:
	            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort:
	            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone:
	                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                    '_'
	                ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone:
	                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                    '_'
	                ),
	        },
	        weekdays: {
	            standalone:
	                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                    '_'
	                ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex:
	            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex:
	            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort:
	            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays:
	            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	                '_'
	            ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays:
	            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	                '_'
	            ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months =
	            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	                '_'
	            ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једног минута'],
	            mm: ['минут', 'минута', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            d: ['један дан', 'једног дана'],
	            dd: ['дан', 'дана', 'дана'],
	            M: ['један месец', 'једног месеца'],
	            MM: ['месец', 'месеца', 'месеци'],
	            y: ['једну годину', 'једне године'],
	            yy: ['годину', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'једна година';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'годину') {
	                return number + ' година';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort:
	            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            d: ['jedan dan', 'jednog dana'],
	            dd: ['dan', 'dana', 'dana'],
	            M: ['jedan mesec', 'jednog meseca'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            y: ['jednu godinu', 'jedne godine'],
	            yy: ['godinu', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'jedna godina';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'godinu') {
	                return number + ' godina';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays:
	            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	                '_'
	            ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                          ? ':a'
	                          : b === 2
	                            ? ':a'
	                            : b === 3
	                              ? ':e'
	                              : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays:
	            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	                '_'
	            ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort:
	            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	                '_'
	            ),
	        weekdays:
	            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	                '_'
	            ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort:
	            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	                '_'
	            ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone:
	                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort:
	            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                  ? time.slice(0, -3) + 'waQ'
	                  : output.indexOf('DIS') !== -1
	                    ? time.slice(0, -3) + 'nem'
	                    : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                  ? time.slice(0, -3) + 'wen'
	                  : output.indexOf('DIS') !== -1
	                    ? time.slice(0, -3) + 'ben'
	                    : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort:
	            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	              ? format[key][0]
	              : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort:
	            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	                '_'
	            ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	                '_'
	            ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	                '_'
	            ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative:
	                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                        '_'
	                    ),
	                accusative:
	                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                        '_'
	                    ),
	                genitive:
	                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                        '_'
	                    ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	              ? 'genitive'
	              : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone:
	                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays:
	            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	                '_'
	            ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort:
	            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort:
	            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	                '_'
	            ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(806);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1669);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ },
/* 806 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// modified from https://github.com/es-shims/es6-shim
	var objectKeys = __webpack_require__(805);
	var hasSymbols = __webpack_require__(400)();
	var callBound = __webpack_require__(84);
	var $Object = __webpack_require__(209);
	var $push = callBound('Array.prototype.push');
	var $propIsEnumerable = callBound('Object.prototype.propertyIsEnumerable');
	var originalGetSymbols = hasSymbols ? $Object.getOwnPropertySymbols : null;
	
	// eslint-disable-next-line no-unused-vars
	module.exports = function assign(target, source1) {
		if (target == null) { throw new TypeError('target must be an object'); }
		var to = $Object(target); // step 1
		if (arguments.length === 1) {
			return to; // step 2
		}
		for (var s = 1; s < arguments.length; ++s) {
			var from = $Object(arguments[s]); // step 3.a.i
	
			// step 3.a.ii:
			var keys = objectKeys(from);
			var getSymbols = hasSymbols && ($Object.getOwnPropertySymbols || originalGetSymbols);
			if (getSymbols) {
				var syms = getSymbols(from);
				for (var j = 0; j < syms.length; ++j) {
					var key = syms[j];
					if ($propIsEnumerable(from, key)) {
						$push(keys, key);
					}
				}
			}
	
			// step 3.a.iii:
			for (var i = 0; i < keys.length; ++i) {
				var nextKey = keys[i];
				if ($propIsEnumerable(from, nextKey)) { // step 3.a.iii.2
					var propValue = from[nextKey]; // step 3.a.iii.2.a
					to[nextKey] = propValue; // step 3.a.iii.2.b
				}
			}
		}
	
		return to; // step 4
	};


/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var RequireObjectCoercible = __webpack_require__(263);
	var callBound = __webpack_require__(84);
	
	var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');
	
	module.exports = function values(O) {
		var obj = RequireObjectCoercible(O);
		var vals = [];
		for (var key in obj) {
			if ($isEnumerable(obj, key)) { // checks own-ness as well
				vals[vals.length] = obj[key];
			}
		}
		return vals;
	};


/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(808);
	
	module.exports = function getPolyfill() {
		return typeof Object.values === 'function' ? Object.values : implementation;
	};


/***/ },
/* 810 */
/***/ function(module, exports) {

	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It doesn't worth to make additional optimizationa as in original.
	// Small size is preferable.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0,
	      s2 = ((adler >>> 16) & 0xffff) |0,
	      n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;


/***/ },
/* 811 */
/***/ function(module, exports) {

	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for (var n = 0; n < 256; n++) {
	    c = n;
	    for (var k = 0; k < 8; k++) {
	      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable,
	      end = pos + len;
	
	  crc ^= -1;
	
	  for (var i = pos; i < end; i++) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;


/***/ },
/* 812 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  2:      'need dictionary',     /* Z_NEED_DICT       2  */
	  1:      'stream end',          /* Z_STREAM_END      1  */
	  0:      '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};


/***/ },
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AnnotationLayer = undefined;
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dom_utils = __webpack_require__(144);
	
	var _util = __webpack_require__(14);
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AnnotationElementFactory = function () {
	  function AnnotationElementFactory() {
	    _classCallCheck(this, AnnotationElementFactory);
	  }
	
	  _createClass(AnnotationElementFactory, null, [{
	    key: 'create',
	    value: function create(parameters) {
	      var subtype = parameters.data.annotationType;
	      switch (subtype) {
	        case _util.AnnotationType.LINK:
	          return new LinkAnnotationElement(parameters);
	        case _util.AnnotationType.TEXT:
	          return new TextAnnotationElement(parameters);
	        case _util.AnnotationType.WIDGET:
	          var fieldType = parameters.data.fieldType;
	          switch (fieldType) {
	            case 'Tx':
	              return new TextWidgetAnnotationElement(parameters);
	            case 'Btn':
	              if (parameters.data.radioButton) {
	                return new RadioButtonWidgetAnnotationElement(parameters);
	              } else if (parameters.data.checkBox) {
	                return new CheckboxWidgetAnnotationElement(parameters);
	              }
	              return new PushButtonWidgetAnnotationElement(parameters);
	            case 'Ch':
	              return new ChoiceWidgetAnnotationElement(parameters);
	          }
	          return new WidgetAnnotationElement(parameters);
	        case _util.AnnotationType.POPUP:
	          return new PopupAnnotationElement(parameters);
	        case _util.AnnotationType.LINE:
	          return new LineAnnotationElement(parameters);
	        case _util.AnnotationType.SQUARE:
	          return new SquareAnnotationElement(parameters);
	        case _util.AnnotationType.CIRCLE:
	          return new CircleAnnotationElement(parameters);
	        case _util.AnnotationType.POLYLINE:
	          return new PolylineAnnotationElement(parameters);
	        case _util.AnnotationType.POLYGON:
	          return new PolygonAnnotationElement(parameters);
	        case _util.AnnotationType.HIGHLIGHT:
	          return new HighlightAnnotationElement(parameters);
	        case _util.AnnotationType.UNDERLINE:
	          return new UnderlineAnnotationElement(parameters);
	        case _util.AnnotationType.SQUIGGLY:
	          return new SquigglyAnnotationElement(parameters);
	        case _util.AnnotationType.STRIKEOUT:
	          return new StrikeOutAnnotationElement(parameters);
	        case _util.AnnotationType.STAMP:
	          return new StampAnnotationElement(parameters);
	        case _util.AnnotationType.FILEATTACHMENT:
	          return new FileAttachmentAnnotationElement(parameters);
	        default:
	          return new AnnotationElement(parameters);
	      }
	    }
	  }]);
	
	  return AnnotationElementFactory;
	}();
	
	var AnnotationElement = function () {
	  function AnnotationElement(parameters) {
	    var isRenderable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    var ignoreBorder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    _classCallCheck(this, AnnotationElement);
	
	    this.isRenderable = isRenderable;
	    this.data = parameters.data;
	    this.layer = parameters.layer;
	    this.page = parameters.page;
	    this.viewport = parameters.viewport;
	    this.linkService = parameters.linkService;
	    this.downloadManager = parameters.downloadManager;
	    this.imageResourcesPath = parameters.imageResourcesPath;
	    this.renderInteractiveForms = parameters.renderInteractiveForms;
	    this.svgFactory = parameters.svgFactory;
	    if (isRenderable) {
	      this.container = this._createContainer(ignoreBorder);
	    }
	  }
	
	  _createClass(AnnotationElement, [{
	    key: '_createContainer',
	    value: function _createContainer() {
	      var ignoreBorder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var data = this.data,
	          page = this.page,
	          viewport = this.viewport;
	      var container = document.createElement('section');
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      container.setAttribute('data-annotation-id', data.id);
	      var rect = _util.Util.normalizeRect([data.rect[0], page.view[3] - data.rect[1] + page.view[1], data.rect[2], page.view[3] - data.rect[3] + page.view[1]]);
	      container.style.transform = 'matrix(' + viewport.transform.join(',') + ')';
	      container.style.transformOrigin = -rect[0] + 'px ' + -rect[1] + 'px';
	      if (!ignoreBorder && data.borderStyle.width > 0) {
	        container.style.borderWidth = data.borderStyle.width + 'px';
	        if (data.borderStyle.style !== _util.AnnotationBorderStyleType.UNDERLINE) {
	          width = width - 2 * data.borderStyle.width;
	          height = height - 2 * data.borderStyle.width;
	        }
	        var horizontalRadius = data.borderStyle.horizontalCornerRadius;
	        var verticalRadius = data.borderStyle.verticalCornerRadius;
	        if (horizontalRadius > 0 || verticalRadius > 0) {
	          var radius = horizontalRadius + 'px / ' + verticalRadius + 'px';
	          container.style.borderRadius = radius;
	        }
	        switch (data.borderStyle.style) {
	          case _util.AnnotationBorderStyleType.SOLID:
	            container.style.borderStyle = 'solid';
	            break;
	          case _util.AnnotationBorderStyleType.DASHED:
	            container.style.borderStyle = 'dashed';
	            break;
	          case _util.AnnotationBorderStyleType.BEVELED:
	            (0, _util.warn)('Unimplemented border style: beveled');
	            break;
	          case _util.AnnotationBorderStyleType.INSET:
	            (0, _util.warn)('Unimplemented border style: inset');
	            break;
	          case _util.AnnotationBorderStyleType.UNDERLINE:
	            container.style.borderBottomStyle = 'solid';
	            break;
	          default:
	            break;
	        }
	        if (data.color) {
	          container.style.borderColor = _util.Util.makeCssRgb(data.color[0] | 0, data.color[1] | 0, data.color[2] | 0);
	        } else {
	          container.style.borderWidth = 0;
	        }
	      }
	      container.style.left = rect[0] + 'px';
	      container.style.top = rect[1] + 'px';
	      container.style.width = width + 'px';
	      container.style.height = height + 'px';
	      return container;
	    }
	  }, {
	    key: '_createPopup',
	    value: function _createPopup(container, trigger, data) {
	      if (!trigger) {
	        trigger = document.createElement('div');
	        trigger.style.height = container.style.height;
	        trigger.style.width = container.style.width;
	        container.appendChild(trigger);
	      }
	      var popupElement = new PopupElement({
	        container: container,
	        trigger: trigger,
	        color: data.color,
	        title: data.title,
	        contents: data.contents,
	        hideWrapper: true
	      });
	      var popup = popupElement.render();
	      popup.style.left = container.style.width;
	      container.appendChild(popup);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      (0, _util.unreachable)('Abstract method `AnnotationElement.render` called');
	    }
	  }]);
	
	  return AnnotationElement;
	}();
	
	var LinkAnnotationElement = function (_AnnotationElement) {
	  _inherits(LinkAnnotationElement, _AnnotationElement);
	
	  function LinkAnnotationElement(parameters) {
	    _classCallCheck(this, LinkAnnotationElement);
	
	    var isRenderable = !!(parameters.data.url || parameters.data.dest || parameters.data.action);
	    return _possibleConstructorReturn(this, (LinkAnnotationElement.__proto__ || Object.getPrototypeOf(LinkAnnotationElement)).call(this, parameters, isRenderable));
	  }
	
	  _createClass(LinkAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'linkAnnotation';
	      var link = document.createElement('a');
	      (0, _dom_utils.addLinkAttributes)(link, {
	        url: this.data.url,
	        target: this.data.newWindow ? _dom_utils.LinkTarget.BLANK : undefined
	      });
	      if (!this.data.url) {
	        if (this.data.action) {
	          this._bindNamedAction(link, this.data.action);
	        } else {
	          this._bindLink(link, this.data.dest);
	        }
	      }
	      this.container.appendChild(link);
	      return this.container;
	    }
	  }, {
	    key: '_bindLink',
	    value: function _bindLink(link, destination) {
	      var _this2 = this;
	
	      link.href = this.linkService.getDestinationHash(destination);
	      link.onclick = function () {
	        if (destination) {
	          _this2.linkService.navigateTo(destination);
	        }
	        return false;
	      };
	      if (destination) {
	        link.className = 'internalLink';
	      }
	    }
	  }, {
	    key: '_bindNamedAction',
	    value: function _bindNamedAction(link, action) {
	      var _this3 = this;
	
	      link.href = this.linkService.getAnchorUrl('');
	      link.onclick = function () {
	        _this3.linkService.executeNamedAction(action);
	        return false;
	      };
	      link.className = 'internalLink';
	    }
	  }]);
	
	  return LinkAnnotationElement;
	}(AnnotationElement);
	
	var TextAnnotationElement = function (_AnnotationElement2) {
	  _inherits(TextAnnotationElement, _AnnotationElement2);
	
	  function TextAnnotationElement(parameters) {
	    _classCallCheck(this, TextAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (TextAnnotationElement.__proto__ || Object.getPrototypeOf(TextAnnotationElement)).call(this, parameters, isRenderable));
	  }
	
	  _createClass(TextAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'textAnnotation';
	      var image = document.createElement('img');
	      image.style.height = this.container.style.height;
	      image.style.width = this.container.style.width;
	      image.src = this.imageResourcesPath + 'annotation-' + this.data.name.toLowerCase() + '.svg';
	      image.alt = '[{{type}} Annotation]';
	      image.dataset.l10nId = 'text_annotation_type';
	      image.dataset.l10nArgs = JSON.stringify({ type: this.data.name });
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, image, this.data);
	      }
	      this.container.appendChild(image);
	      return this.container;
	    }
	  }]);
	
	  return TextAnnotationElement;
	}(AnnotationElement);
	
	var WidgetAnnotationElement = function (_AnnotationElement3) {
	  _inherits(WidgetAnnotationElement, _AnnotationElement3);
	
	  function WidgetAnnotationElement() {
	    _classCallCheck(this, WidgetAnnotationElement);
	
	    return _possibleConstructorReturn(this, (WidgetAnnotationElement.__proto__ || Object.getPrototypeOf(WidgetAnnotationElement)).apply(this, arguments));
	  }
	
	  _createClass(WidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      return this.container;
	    }
	  }]);
	
	  return WidgetAnnotationElement;
	}(AnnotationElement);
	
	var TextWidgetAnnotationElement = function (_WidgetAnnotationElem) {
	  _inherits(TextWidgetAnnotationElement, _WidgetAnnotationElem);
	
	  function TextWidgetAnnotationElement(parameters) {
	    _classCallCheck(this, TextWidgetAnnotationElement);
	
	    var isRenderable = parameters.renderInteractiveForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
	    return _possibleConstructorReturn(this, (TextWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(TextWidgetAnnotationElement)).call(this, parameters, isRenderable));
	  }
	
	  _createClass(TextWidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      var TEXT_ALIGNMENT = ['left', 'center', 'right'];
	      this.container.className = 'textWidgetAnnotation';
	      var element = null;
	      if (this.renderInteractiveForms) {
	        if (this.data.multiLine) {
	          element = document.createElement('textarea');
	          element.textContent = this.data.fieldValue;
	        } else {
	          element = document.createElement('input');
	          element.type = 'text';
	          element.setAttribute('value', this.data.fieldValue);
	        }
	        element.disabled = this.data.readOnly;
	        if (this.data.maxLen !== null) {
	          element.maxLength = this.data.maxLen;
	        }
	        if (this.data.comb) {
	          var fieldWidth = this.data.rect[2] - this.data.rect[0];
	          var combWidth = fieldWidth / this.data.maxLen;
	          element.classList.add('comb');
	          element.style.letterSpacing = 'calc(' + combWidth + 'px - 1ch)';
	        }
	      } else {
	        element = document.createElement('div');
	        element.textContent = this.data.fieldValue;
	        element.style.verticalAlign = 'middle';
	        element.style.display = 'table-cell';
	        var font = null;
	        if (this.data.fontRefName) {
	          font = this.page.commonObjs.getData(this.data.fontRefName);
	        }
	        this._setTextStyle(element, font);
	      }
	      if (this.data.textAlignment !== null) {
	        element.style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
	      }
	      this.container.appendChild(element);
	      return this.container;
	    }
	  }, {
	    key: '_setTextStyle',
	    value: function _setTextStyle(element, font) {
	      var style = element.style;
	      style.fontSize = this.data.fontSize + 'px';
	      style.direction = this.data.fontDirection < 0 ? 'rtl' : 'ltr';
	      if (!font) {
	        return;
	      }
	      style.fontWeight = font.black ? font.bold ? '900' : 'bold' : font.bold ? 'bold' : 'normal';
	      style.fontStyle = font.italic ? 'italic' : 'normal';
	      var fontFamily = font.loadedName ? '"' + font.loadedName + '", ' : '';
	      var fallbackName = font.fallbackName || 'Helvetica, sans-serif';
	      style.fontFamily = fontFamily + fallbackName;
	    }
	  }]);
	
	  return TextWidgetAnnotationElement;
	}(WidgetAnnotationElement);
	
	var CheckboxWidgetAnnotationElement = function (_WidgetAnnotationElem2) {
	  _inherits(CheckboxWidgetAnnotationElement, _WidgetAnnotationElem2);
	
	  function CheckboxWidgetAnnotationElement(parameters) {
	    _classCallCheck(this, CheckboxWidgetAnnotationElement);
	
	    return _possibleConstructorReturn(this, (CheckboxWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(CheckboxWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
	  }
	
	  _createClass(CheckboxWidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'buttonWidgetAnnotation checkBox';
	      var element = document.createElement('input');
	      element.disabled = this.data.readOnly;
	      element.type = 'checkbox';
	      if (this.data.fieldValue && this.data.fieldValue !== 'Off') {
	        element.setAttribute('checked', true);
	      }
	      this.container.appendChild(element);
	      return this.container;
	    }
	  }]);
	
	  return CheckboxWidgetAnnotationElement;
	}(WidgetAnnotationElement);
	
	var RadioButtonWidgetAnnotationElement = function (_WidgetAnnotationElem3) {
	  _inherits(RadioButtonWidgetAnnotationElement, _WidgetAnnotationElem3);
	
	  function RadioButtonWidgetAnnotationElement(parameters) {
	    _classCallCheck(this, RadioButtonWidgetAnnotationElement);
	
	    return _possibleConstructorReturn(this, (RadioButtonWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(RadioButtonWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
	  }
	
	  _createClass(RadioButtonWidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'buttonWidgetAnnotation radioButton';
	      var element = document.createElement('input');
	      element.disabled = this.data.readOnly;
	      element.type = 'radio';
	      element.name = this.data.fieldName;
	      if (this.data.fieldValue === this.data.buttonValue) {
	        element.setAttribute('checked', true);
	      }
	      this.container.appendChild(element);
	      return this.container;
	    }
	  }]);
	
	  return RadioButtonWidgetAnnotationElement;
	}(WidgetAnnotationElement);
	
	var PushButtonWidgetAnnotationElement = function (_LinkAnnotationElemen) {
	  _inherits(PushButtonWidgetAnnotationElement, _LinkAnnotationElemen);
	
	  function PushButtonWidgetAnnotationElement() {
	    _classCallCheck(this, PushButtonWidgetAnnotationElement);
	
	    return _possibleConstructorReturn(this, (PushButtonWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(PushButtonWidgetAnnotationElement)).apply(this, arguments));
	  }
	
	  _createClass(PushButtonWidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      var container = _get(PushButtonWidgetAnnotationElement.prototype.__proto__ || Object.getPrototypeOf(PushButtonWidgetAnnotationElement.prototype), 'render', this).call(this);
	      container.className = 'buttonWidgetAnnotation pushButton';
	      return container;
	    }
	  }]);
	
	  return PushButtonWidgetAnnotationElement;
	}(LinkAnnotationElement);
	
	var ChoiceWidgetAnnotationElement = function (_WidgetAnnotationElem4) {
	  _inherits(ChoiceWidgetAnnotationElement, _WidgetAnnotationElem4);
	
	  function ChoiceWidgetAnnotationElement(parameters) {
	    _classCallCheck(this, ChoiceWidgetAnnotationElement);
	
	    return _possibleConstructorReturn(this, (ChoiceWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(ChoiceWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
	  }
	
	  _createClass(ChoiceWidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'choiceWidgetAnnotation';
	      var selectElement = document.createElement('select');
	      selectElement.disabled = this.data.readOnly;
	      if (!this.data.combo) {
	        selectElement.size = this.data.options.length;
	        if (this.data.multiSelect) {
	          selectElement.multiple = true;
	        }
	      }
	      for (var i = 0, ii = this.data.options.length; i < ii; i++) {
	        var option = this.data.options[i];
	        var optionElement = document.createElement('option');
	        optionElement.textContent = option.displayValue;
	        optionElement.value = option.exportValue;
	        if (this.data.fieldValue.indexOf(option.displayValue) >= 0) {
	          optionElement.setAttribute('selected', true);
	        }
	        selectElement.appendChild(optionElement);
	      }
	      this.container.appendChild(selectElement);
	      return this.container;
	    }
	  }]);
	
	  return ChoiceWidgetAnnotationElement;
	}(WidgetAnnotationElement);
	
	var PopupAnnotationElement = function (_AnnotationElement4) {
	  _inherits(PopupAnnotationElement, _AnnotationElement4);
	
	  function PopupAnnotationElement(parameters) {
	    _classCallCheck(this, PopupAnnotationElement);
	
	    var isRenderable = !!(parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (PopupAnnotationElement.__proto__ || Object.getPrototypeOf(PopupAnnotationElement)).call(this, parameters, isRenderable));
	  }
	
	  _createClass(PopupAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      var IGNORE_TYPES = ['Line', 'Square', 'Circle', 'PolyLine', 'Polygon'];
	      this.container.className = 'popupAnnotation';
	      if (IGNORE_TYPES.indexOf(this.data.parentType) >= 0) {
	        return this.container;
	      }
	      var selector = '[data-annotation-id="' + this.data.parentId + '"]';
	      var parentElement = this.layer.querySelector(selector);
	      if (!parentElement) {
	        return this.container;
	      }
	      var popup = new PopupElement({
	        container: this.container,
	        trigger: parentElement,
	        color: this.data.color,
	        title: this.data.title,
	        contents: this.data.contents
	      });
	      var parentLeft = parseFloat(parentElement.style.left);
	      var parentWidth = parseFloat(parentElement.style.width);
	      this.container.style.transformOrigin = -(parentLeft + parentWidth) + 'px -' + parentElement.style.top;
	      this.container.style.left = parentLeft + parentWidth + 'px';
	      this.container.appendChild(popup.render());
	      return this.container;
	    }
	  }]);
	
	  return PopupAnnotationElement;
	}(AnnotationElement);
	
	var PopupElement = function () {
	  function PopupElement(parameters) {
	    _classCallCheck(this, PopupElement);
	
	    this.container = parameters.container;
	    this.trigger = parameters.trigger;
	    this.color = parameters.color;
	    this.title = parameters.title;
	    this.contents = parameters.contents;
	    this.hideWrapper = parameters.hideWrapper || false;
	    this.pinned = false;
	  }
	
	  _createClass(PopupElement, [{
	    key: 'render',
	    value: function render() {
	      var BACKGROUND_ENLIGHT = 0.7;
	      var wrapper = document.createElement('div');
	      wrapper.className = 'popupWrapper';
	      this.hideElement = this.hideWrapper ? wrapper : this.container;
	      this.hideElement.setAttribute('hidden', true);
	      var popup = document.createElement('div');
	      popup.className = 'popup';
	      var color = this.color;
	      if (color) {
	        var r = BACKGROUND_ENLIGHT * (255 - color[0]) + color[0];
	        var g = BACKGROUND_ENLIGHT * (255 - color[1]) + color[1];
	        var b = BACKGROUND_ENLIGHT * (255 - color[2]) + color[2];
	        popup.style.backgroundColor = _util.Util.makeCssRgb(r | 0, g | 0, b | 0);
	      }
	      var contents = this._formatContents(this.contents);
	      var title = document.createElement('h1');
	      title.textContent = this.title;
	      this.trigger.addEventListener('click', this._toggle.bind(this));
	      this.trigger.addEventListener('mouseover', this._show.bind(this, false));
	      this.trigger.addEventListener('mouseout', this._hide.bind(this, false));
	      popup.addEventListener('click', this._hide.bind(this, true));
	      popup.appendChild(title);
	      popup.appendChild(contents);
	      wrapper.appendChild(popup);
	      return wrapper;
	    }
	  }, {
	    key: '_formatContents',
	    value: function _formatContents(contents) {
	      var p = document.createElement('p');
	      var lines = contents.split(/(?:\r\n?|\n)/);
	      for (var i = 0, ii = lines.length; i < ii; ++i) {
	        var line = lines[i];
	        p.appendChild(document.createTextNode(line));
	        if (i < ii - 1) {
	          p.appendChild(document.createElement('br'));
	        }
	      }
	      return p;
	    }
	  }, {
	    key: '_toggle',
	    value: function _toggle() {
	      if (this.pinned) {
	        this._hide(true);
	      } else {
	        this._show(true);
	      }
	    }
	  }, {
	    key: '_show',
	    value: function _show() {
	      var pin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (pin) {
	        this.pinned = true;
	      }
	      if (this.hideElement.hasAttribute('hidden')) {
	        this.hideElement.removeAttribute('hidden');
	        this.container.style.zIndex += 1;
	      }
	    }
	  }, {
	    key: '_hide',
	    value: function _hide() {
	      var unpin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (unpin) {
	        this.pinned = false;
	      }
	      if (!this.hideElement.hasAttribute('hidden') && !this.pinned) {
	        this.hideElement.setAttribute('hidden', true);
	        this.container.style.zIndex -= 1;
	      }
	    }
	  }]);
	
	  return PopupElement;
	}();
	
	var LineAnnotationElement = function (_AnnotationElement5) {
	  _inherits(LineAnnotationElement, _AnnotationElement5);
	
	  function LineAnnotationElement(parameters) {
	    _classCallCheck(this, LineAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (LineAnnotationElement.__proto__ || Object.getPrototypeOf(LineAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(LineAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'lineAnnotation';
	      var data = this.data;
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      var svg = this.svgFactory.create(width, height);
	      var line = this.svgFactory.createElement('svg:line');
	      line.setAttribute('x1', data.rect[2] - data.lineCoordinates[0]);
	      line.setAttribute('y1', data.rect[3] - data.lineCoordinates[1]);
	      line.setAttribute('x2', data.rect[2] - data.lineCoordinates[2]);
	      line.setAttribute('y2', data.rect[3] - data.lineCoordinates[3]);
	      line.setAttribute('stroke-width', data.borderStyle.width);
	      line.setAttribute('stroke', 'transparent');
	      svg.appendChild(line);
	      this.container.append(svg);
	      this._createPopup(this.container, line, data);
	      return this.container;
	    }
	  }]);
	
	  return LineAnnotationElement;
	}(AnnotationElement);
	
	var SquareAnnotationElement = function (_AnnotationElement6) {
	  _inherits(SquareAnnotationElement, _AnnotationElement6);
	
	  function SquareAnnotationElement(parameters) {
	    _classCallCheck(this, SquareAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (SquareAnnotationElement.__proto__ || Object.getPrototypeOf(SquareAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(SquareAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'squareAnnotation';
	      var data = this.data;
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      var svg = this.svgFactory.create(width, height);
	      var borderWidth = data.borderStyle.width;
	      var square = this.svgFactory.createElement('svg:rect');
	      square.setAttribute('x', borderWidth / 2);
	      square.setAttribute('y', borderWidth / 2);
	      square.setAttribute('width', width - borderWidth);
	      square.setAttribute('height', height - borderWidth);
	      square.setAttribute('stroke-width', borderWidth);
	      square.setAttribute('stroke', 'transparent');
	      square.setAttribute('fill', 'none');
	      svg.appendChild(square);
	      this.container.append(svg);
	      this._createPopup(this.container, square, data);
	      return this.container;
	    }
	  }]);
	
	  return SquareAnnotationElement;
	}(AnnotationElement);
	
	var CircleAnnotationElement = function (_AnnotationElement7) {
	  _inherits(CircleAnnotationElement, _AnnotationElement7);
	
	  function CircleAnnotationElement(parameters) {
	    _classCallCheck(this, CircleAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (CircleAnnotationElement.__proto__ || Object.getPrototypeOf(CircleAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(CircleAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'circleAnnotation';
	      var data = this.data;
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      var svg = this.svgFactory.create(width, height);
	      var borderWidth = data.borderStyle.width;
	      var circle = this.svgFactory.createElement('svg:ellipse');
	      circle.setAttribute('cx', width / 2);
	      circle.setAttribute('cy', height / 2);
	      circle.setAttribute('rx', width / 2 - borderWidth / 2);
	      circle.setAttribute('ry', height / 2 - borderWidth / 2);
	      circle.setAttribute('stroke-width', borderWidth);
	      circle.setAttribute('stroke', 'transparent');
	      circle.setAttribute('fill', 'none');
	      svg.appendChild(circle);
	      this.container.append(svg);
	      this._createPopup(this.container, circle, data);
	      return this.container;
	    }
	  }]);
	
	  return CircleAnnotationElement;
	}(AnnotationElement);
	
	var PolylineAnnotationElement = function (_AnnotationElement8) {
	  _inherits(PolylineAnnotationElement, _AnnotationElement8);
	
	  function PolylineAnnotationElement(parameters) {
	    _classCallCheck(this, PolylineAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	
	    var _this15 = _possibleConstructorReturn(this, (PolylineAnnotationElement.__proto__ || Object.getPrototypeOf(PolylineAnnotationElement)).call(this, parameters, isRenderable, true));
	
	    _this15.containerClassName = 'polylineAnnotation';
	    _this15.svgElementName = 'svg:polyline';
	    return _this15;
	  }
	
	  _createClass(PolylineAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = this.containerClassName;
	      var data = this.data;
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      var svg = this.svgFactory.create(width, height);
	      var vertices = data.vertices;
	      var points = [];
	      for (var i = 0, ii = vertices.length; i < ii; i++) {
	        var x = vertices[i].x - data.rect[0];
	        var y = data.rect[3] - vertices[i].y;
	        points.push(x + ',' + y);
	      }
	      points = points.join(' ');
	      var borderWidth = data.borderStyle.width;
	      var polyline = this.svgFactory.createElement(this.svgElementName);
	      polyline.setAttribute('points', points);
	      polyline.setAttribute('stroke-width', borderWidth);
	      polyline.setAttribute('stroke', 'transparent');
	      polyline.setAttribute('fill', 'none');
	      svg.appendChild(polyline);
	      this.container.append(svg);
	      this._createPopup(this.container, polyline, data);
	      return this.container;
	    }
	  }]);
	
	  return PolylineAnnotationElement;
	}(AnnotationElement);
	
	var PolygonAnnotationElement = function (_PolylineAnnotationEl) {
	  _inherits(PolygonAnnotationElement, _PolylineAnnotationEl);
	
	  function PolygonAnnotationElement(parameters) {
	    _classCallCheck(this, PolygonAnnotationElement);
	
	    var _this16 = _possibleConstructorReturn(this, (PolygonAnnotationElement.__proto__ || Object.getPrototypeOf(PolygonAnnotationElement)).call(this, parameters));
	
	    _this16.containerClassName = 'polygonAnnotation';
	    _this16.svgElementName = 'svg:polygon';
	    return _this16;
	  }
	
	  return PolygonAnnotationElement;
	}(PolylineAnnotationElement);
	
	var HighlightAnnotationElement = function (_AnnotationElement9) {
	  _inherits(HighlightAnnotationElement, _AnnotationElement9);
	
	  function HighlightAnnotationElement(parameters) {
	    _classCallCheck(this, HighlightAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (HighlightAnnotationElement.__proto__ || Object.getPrototypeOf(HighlightAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(HighlightAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'highlightAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  }]);
	
	  return HighlightAnnotationElement;
	}(AnnotationElement);
	
	var UnderlineAnnotationElement = function (_AnnotationElement10) {
	  _inherits(UnderlineAnnotationElement, _AnnotationElement10);
	
	  function UnderlineAnnotationElement(parameters) {
	    _classCallCheck(this, UnderlineAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (UnderlineAnnotationElement.__proto__ || Object.getPrototypeOf(UnderlineAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(UnderlineAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'underlineAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  }]);
	
	  return UnderlineAnnotationElement;
	}(AnnotationElement);
	
	var SquigglyAnnotationElement = function (_AnnotationElement11) {
	  _inherits(SquigglyAnnotationElement, _AnnotationElement11);
	
	  function SquigglyAnnotationElement(parameters) {
	    _classCallCheck(this, SquigglyAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (SquigglyAnnotationElement.__proto__ || Object.getPrototypeOf(SquigglyAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(SquigglyAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'squigglyAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  }]);
	
	  return SquigglyAnnotationElement;
	}(AnnotationElement);
	
	var StrikeOutAnnotationElement = function (_AnnotationElement12) {
	  _inherits(StrikeOutAnnotationElement, _AnnotationElement12);
	
	  function StrikeOutAnnotationElement(parameters) {
	    _classCallCheck(this, StrikeOutAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (StrikeOutAnnotationElement.__proto__ || Object.getPrototypeOf(StrikeOutAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(StrikeOutAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'strikeoutAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  }]);
	
	  return StrikeOutAnnotationElement;
	}(AnnotationElement);
	
	var StampAnnotationElement = function (_AnnotationElement13) {
	  _inherits(StampAnnotationElement, _AnnotationElement13);
	
	  function StampAnnotationElement(parameters) {
	    _classCallCheck(this, StampAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (StampAnnotationElement.__proto__ || Object.getPrototypeOf(StampAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(StampAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'stampAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  }]);
	
	  return StampAnnotationElement;
	}(AnnotationElement);
	
	var FileAttachmentAnnotationElement = function (_AnnotationElement14) {
	  _inherits(FileAttachmentAnnotationElement, _AnnotationElement14);
	
	  function FileAttachmentAnnotationElement(parameters) {
	    _classCallCheck(this, FileAttachmentAnnotationElement);
	
	    var _this22 = _possibleConstructorReturn(this, (FileAttachmentAnnotationElement.__proto__ || Object.getPrototypeOf(FileAttachmentAnnotationElement)).call(this, parameters, true));
	
	    var file = _this22.data.file;
	    _this22.filename = (0, _dom_utils.getFilenameFromUrl)(file.filename);
	    _this22.content = file.content;
	    _this22.linkService.onFileAttachmentAnnotation({
	      id: (0, _util.stringToPDFString)(file.filename),
	      filename: file.filename,
	      content: file.content
	    });
	    return _this22;
	  }
	
	  _createClass(FileAttachmentAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'fileAttachmentAnnotation';
	      var trigger = document.createElement('div');
	      trigger.style.height = this.container.style.height;
	      trigger.style.width = this.container.style.width;
	      trigger.addEventListener('dblclick', this._download.bind(this));
	      if (!this.data.hasPopup && (this.data.title || this.data.contents)) {
	        this._createPopup(this.container, trigger, this.data);
	      }
	      this.container.appendChild(trigger);
	      return this.container;
	    }
	  }, {
	    key: '_download',
	    value: function _download() {
	      if (!this.downloadManager) {
	        (0, _util.warn)('Download cannot be started due to unavailable download manager');
	        return;
	      }
	      this.downloadManager.downloadData(this.content, this.filename, '');
	    }
	  }]);
	
	  return FileAttachmentAnnotationElement;
	}(AnnotationElement);
	
	var AnnotationLayer = function () {
	  function AnnotationLayer() {
	    _classCallCheck(this, AnnotationLayer);
	  }
	
	  _createClass(AnnotationLayer, null, [{
	    key: 'render',
	    value: function render(parameters) {
	      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
	        var data = parameters.annotations[i];
	        if (!data) {
	          continue;
	        }
	        var element = AnnotationElementFactory.create({
	          data: data,
	          layer: parameters.div,
	          page: parameters.page,
	          viewport: parameters.viewport,
	          linkService: parameters.linkService,
	          downloadManager: parameters.downloadManager,
	          imageResourcesPath: parameters.imageResourcesPath || (0, _dom_utils.getDefaultSetting)('imageResourcesPath'),
	          renderInteractiveForms: parameters.renderInteractiveForms || false,
	          svgFactory: new _dom_utils.DOMSVGFactory()
	        });
	        if (element.isRenderable) {
	          parameters.div.appendChild(element.render());
	        }
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update(parameters) {
	      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
	        var data = parameters.annotations[i];
	        var element = parameters.div.querySelector('[data-annotation-id="' + data.id + '"]');
	        if (element) {
	          element.style.transform = 'matrix(' + parameters.viewport.transform.join(',') + ')';
	        }
	      }
	      parameters.div.removeAttribute('hidden');
	    }
	  }]);
	
	  return AnnotationLayer;
	}();
	
	exports.AnnotationLayer = AnnotationLayer;

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.build = exports.version = exports.setPDFNetworkStreamFactory = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFWorker = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.getDocument = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _util = __webpack_require__(14);
	
	var _dom_utils = __webpack_require__(144);
	
	var _font_loader = __webpack_require__(1707);
	
	var _canvas = __webpack_require__(1704);
	
	var _global_scope = __webpack_require__(220);
	
	var _global_scope2 = _interopRequireDefault(_global_scope);
	
	var _metadata = __webpack_require__(825);
	
	var _transport_stream = __webpack_require__(1712);
	
	var _webgl = __webpack_require__(1713);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DEFAULT_RANGE_CHUNK_SIZE = 65536;
	var isWorkerDisabled = false;
	var workerSrc;
	var isPostMessageTransfersDisabled = false;
	var pdfjsFilePath = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : null;
	var fakeWorkerFilesLoader = null;
	var useRequireEnsure = false;
	{
	  if (typeof window === 'undefined') {
	    isWorkerDisabled = true;
	    if (false) {
	      require.ensure = require('node-ensure');
	    }
	    useRequireEnsure = true;
	  } else if (true) {
	    useRequireEnsure = true;
	  }
	  if (typeof requirejs !== 'undefined' && requirejs.toUrl) {
	    workerSrc = requirejs.toUrl('pdfjs-dist/build/pdf.worker.js');
	  }
	  var dynamicLoaderSupported = typeof requirejs !== 'undefined' && requirejs.load;
	  fakeWorkerFilesLoader = useRequireEnsure ? function (callback) {
	    __webpack_require__.e/* nsure */(1, function () {
	      var worker;
	      worker = __webpack_require__(1715);
	      callback(worker.WorkerMessageHandler);
	    });
	  } : dynamicLoaderSupported ? function (callback) {
	    requirejs(['pdfjs-dist/build/pdf.worker'], function (worker) {
	      callback(worker.WorkerMessageHandler);
	    });
	  } : null;
	}
	var createPDFNetworkStream;
	function setPDFNetworkStreamFactory(pdfNetworkStreamFactory) {
	  createPDFNetworkStream = pdfNetworkStreamFactory;
	}
	function getDocument(src) {
	  var task = new PDFDocumentLoadingTask();
	  var source;
	  if (typeof src === 'string') {
	    source = { url: src };
	  } else if ((0, _util.isArrayBuffer)(src)) {
	    source = { data: src };
	  } else if (src instanceof PDFDataRangeTransport) {
	    source = { range: src };
	  } else {
	    if ((typeof src === 'undefined' ? 'undefined' : _typeof(src)) !== 'object') {
	      throw new Error('Invalid parameter in getDocument, ' + 'need either Uint8Array, string or a parameter object');
	    }
	    if (!src.url && !src.data && !src.range) {
	      throw new Error('Invalid parameter object: need either .data, .range or .url');
	    }
	    source = src;
	  }
	  var params = {};
	  var rangeTransport = null;
	  var worker = null;
	  var CMapReaderFactory = _dom_utils.DOMCMapReaderFactory;
	  for (var key in source) {
	    if (key === 'url' && typeof window !== 'undefined') {
	      params[key] = new URL(source[key], window.location).href;
	      continue;
	    } else if (key === 'range') {
	      rangeTransport = source[key];
	      continue;
	    } else if (key === 'worker') {
	      worker = source[key];
	      continue;
	    } else if (key === 'data' && !(source[key] instanceof Uint8Array)) {
	      var pdfBytes = source[key];
	      if (typeof pdfBytes === 'string') {
	        params[key] = (0, _util.stringToBytes)(pdfBytes);
	      } else if ((typeof pdfBytes === 'undefined' ? 'undefined' : _typeof(pdfBytes)) === 'object' && pdfBytes !== null && !isNaN(pdfBytes.length)) {
	        params[key] = new Uint8Array(pdfBytes);
	      } else if ((0, _util.isArrayBuffer)(pdfBytes)) {
	        params[key] = new Uint8Array(pdfBytes);
	      } else {
	        throw new Error('Invalid PDF binary data: either typed array, ' + 'string or array-like object is expected in the ' + 'data property.');
	      }
	      continue;
	    } else if (key === 'CMapReaderFactory') {
	      CMapReaderFactory = source[key];
	      continue;
	    }
	    params[key] = source[key];
	  }
	  params.rangeChunkSize = params.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE;
	  params.ignoreErrors = params.stopAtErrors !== true;
	  var nativeImageDecoderValues = Object.values(_util.NativeImageDecoding);
	  if (params.nativeImageDecoderSupport === undefined || !nativeImageDecoderValues.includes(params.nativeImageDecoderSupport)) {
	    params.nativeImageDecoderSupport = _util.NativeImageDecoding.DECODE;
	  }
	  if (!worker) {
	    var workerPort = (0, _dom_utils.getDefaultSetting)('workerPort');
	    worker = workerPort ? PDFWorker.fromPort(workerPort) : new PDFWorker();
	    task._worker = worker;
	  }
	  var docId = task.docId;
	  worker.promise.then(function () {
	    if (task.destroyed) {
	      throw new Error('Loading aborted');
	    }
	    return _fetchDocument(worker, params, rangeTransport, docId).then(function (workerId) {
	      if (task.destroyed) {
	        throw new Error('Loading aborted');
	      }
	      var networkStream = void 0;
	      if (rangeTransport) {
	        networkStream = new _transport_stream.PDFDataTransportStream(params, rangeTransport);
	      } else if (!params.data) {
	        networkStream = createPDFNetworkStream(params);
	      }
	      var messageHandler = new _util.MessageHandler(docId, workerId, worker.port);
	      messageHandler.postMessageTransfers = worker.postMessageTransfers;
	      var transport = new WorkerTransport(messageHandler, task, networkStream, CMapReaderFactory);
	      task._transport = transport;
	      messageHandler.send('Ready', null);
	    });
	  }).catch(task._capability.reject);
	  return task;
	}
	function _fetchDocument(worker, source, pdfDataRangeTransport, docId) {
	  if (worker.destroyed) {
	    return Promise.reject(new Error('Worker was destroyed'));
	  }
	  var apiVersion = '2.0.305';
	  source.disableRange = (0, _dom_utils.getDefaultSetting)('disableRange');
	  source.disableAutoFetch = (0, _dom_utils.getDefaultSetting)('disableAutoFetch');
	  source.disableStream = (0, _dom_utils.getDefaultSetting)('disableStream');
	  if (pdfDataRangeTransport) {
	    source.length = pdfDataRangeTransport.length;
	    source.initialData = pdfDataRangeTransport.initialData;
	  }
	  return worker.messageHandler.sendWithPromise('GetDocRequest', {
	    docId: docId,
	    apiVersion: apiVersion,
	    source: {
	      data: source.data,
	      url: source.url,
	      password: source.password,
	      disableAutoFetch: source.disableAutoFetch,
	      rangeChunkSize: source.rangeChunkSize,
	      length: source.length
	    },
	    maxImageSize: (0, _dom_utils.getDefaultSetting)('maxImageSize'),
	    disableFontFace: (0, _dom_utils.getDefaultSetting)('disableFontFace'),
	    disableCreateObjectURL: (0, _dom_utils.getDefaultSetting)('disableCreateObjectURL'),
	    postMessageTransfers: (0, _dom_utils.getDefaultSetting)('postMessageTransfers') && !isPostMessageTransfersDisabled,
	    docBaseUrl: source.docBaseUrl,
	    nativeImageDecoderSupport: source.nativeImageDecoderSupport,
	    ignoreErrors: source.ignoreErrors,
	    isEvalSupported: (0, _dom_utils.getDefaultSetting)('isEvalSupported')
	  }).then(function (workerId) {
	    if (worker.destroyed) {
	      throw new Error('Worker was destroyed');
	    }
	    return workerId;
	  });
	}
	var PDFDocumentLoadingTask = function PDFDocumentLoadingTaskClosure() {
	  var nextDocumentId = 0;
	  function PDFDocumentLoadingTask() {
	    this._capability = (0, _util.createPromiseCapability)();
	    this._transport = null;
	    this._worker = null;
	    this.docId = 'd' + nextDocumentId++;
	    this.destroyed = false;
	    this.onPassword = null;
	    this.onProgress = null;
	    this.onUnsupportedFeature = null;
	  }
	  PDFDocumentLoadingTask.prototype = {
	    get promise() {
	      return this._capability.promise;
	    },
	    destroy: function destroy() {
	      var _this = this;
	
	      this.destroyed = true;
	      var transportDestroyed = !this._transport ? Promise.resolve() : this._transport.destroy();
	      return transportDestroyed.then(function () {
	        _this._transport = null;
	        if (_this._worker) {
	          _this._worker.destroy();
	          _this._worker = null;
	        }
	      });
	    },
	
	    then: function PDFDocumentLoadingTask_then(onFulfilled, onRejected) {
	      return this.promise.then.apply(this.promise, arguments);
	    }
	  };
	  return PDFDocumentLoadingTask;
	}();
	var PDFDataRangeTransport = function pdfDataRangeTransportClosure() {
	  function PDFDataRangeTransport(length, initialData) {
	    this.length = length;
	    this.initialData = initialData;
	    this._rangeListeners = [];
	    this._progressListeners = [];
	    this._progressiveReadListeners = [];
	    this._readyCapability = (0, _util.createPromiseCapability)();
	  }
	  PDFDataRangeTransport.prototype = {
	    addRangeListener: function PDFDataRangeTransport_addRangeListener(listener) {
	      this._rangeListeners.push(listener);
	    },
	    addProgressListener: function PDFDataRangeTransport_addProgressListener(listener) {
	      this._progressListeners.push(listener);
	    },
	    addProgressiveReadListener: function PDFDataRangeTransport_addProgressiveReadListener(listener) {
	      this._progressiveReadListeners.push(listener);
	    },
	    onDataRange: function PDFDataRangeTransport_onDataRange(begin, chunk) {
	      var listeners = this._rangeListeners;
	      for (var i = 0, n = listeners.length; i < n; ++i) {
	        listeners[i](begin, chunk);
	      }
	    },
	    onDataProgress: function PDFDataRangeTransport_onDataProgress(loaded) {
	      var _this2 = this;
	
	      this._readyCapability.promise.then(function () {
	        var listeners = _this2._progressListeners;
	        for (var i = 0, n = listeners.length; i < n; ++i) {
	          listeners[i](loaded);
	        }
	      });
	    },
	    onDataProgressiveRead: function PDFDataRangeTransport_onDataProgress(chunk) {
	      var _this3 = this;
	
	      this._readyCapability.promise.then(function () {
	        var listeners = _this3._progressiveReadListeners;
	        for (var i = 0, n = listeners.length; i < n; ++i) {
	          listeners[i](chunk);
	        }
	      });
	    },
	    transportReady: function PDFDataRangeTransport_transportReady() {
	      this._readyCapability.resolve();
	    },
	    requestDataRange: function PDFDataRangeTransport_requestDataRange(begin, end) {
	      (0, _util.unreachable)('Abstract method PDFDataRangeTransport.requestDataRange');
	    },
	    abort: function PDFDataRangeTransport_abort() {}
	  };
	  return PDFDataRangeTransport;
	}();
	var PDFDocumentProxy = function PDFDocumentProxyClosure() {
	  function PDFDocumentProxy(pdfInfo, transport, loadingTask) {
	    this.pdfInfo = pdfInfo;
	    this.transport = transport;
	    this.loadingTask = loadingTask;
	  }
	  PDFDocumentProxy.prototype = {
	    get numPages() {
	      return this.pdfInfo.numPages;
	    },
	    get fingerprint() {
	      return this.pdfInfo.fingerprint;
	    },
	    getPage: function getPage(pageNumber) {
	      return this.transport.getPage(pageNumber);
	    },
	
	    getPageIndex: function PDFDocumentProxy_getPageIndex(ref) {
	      return this.transport.getPageIndex(ref);
	    },
	    getDestinations: function PDFDocumentProxy_getDestinations() {
	      return this.transport.getDestinations();
	    },
	    getDestination: function PDFDocumentProxy_getDestination(id) {
	      return this.transport.getDestination(id);
	    },
	    getPageLabels: function PDFDocumentProxy_getPageLabels() {
	      return this.transport.getPageLabels();
	    },
	    getPageMode: function getPageMode() {
	      return this.transport.getPageMode();
	    },
	
	    getAttachments: function PDFDocumentProxy_getAttachments() {
	      return this.transport.getAttachments();
	    },
	    getJavaScript: function getJavaScript() {
	      return this.transport.getJavaScript();
	    },
	
	    getOutline: function PDFDocumentProxy_getOutline() {
	      return this.transport.getOutline();
	    },
	    getMetadata: function PDFDocumentProxy_getMetadata() {
	      return this.transport.getMetadata();
	    },
	    getData: function PDFDocumentProxy_getData() {
	      return this.transport.getData();
	    },
	    getDownloadInfo: function PDFDocumentProxy_getDownloadInfo() {
	      return this.transport.downloadInfoCapability.promise;
	    },
	    getStats: function PDFDocumentProxy_getStats() {
	      return this.transport.getStats();
	    },
	    cleanup: function PDFDocumentProxy_cleanup() {
	      this.transport.startCleanup();
	    },
	    destroy: function PDFDocumentProxy_destroy() {
	      return this.loadingTask.destroy();
	    }
	  };
	  return PDFDocumentProxy;
	}();
	var PDFPageProxy = function PDFPageProxyClosure() {
	  function PDFPageProxy(pageIndex, pageInfo, transport) {
	    this.pageIndex = pageIndex;
	    this.pageInfo = pageInfo;
	    this.transport = transport;
	    this._stats = (0, _dom_utils.getDefaultSetting)('enableStats') ? new _dom_utils.StatTimer() : _dom_utils.DummyStatTimer;
	    this.commonObjs = transport.commonObjs;
	    this.objs = new PDFObjects();
	    this.cleanupAfterRender = false;
	    this.pendingCleanup = false;
	    this.intentStates = Object.create(null);
	    this.destroyed = false;
	  }
	  PDFPageProxy.prototype = {
	    get pageNumber() {
	      return this.pageIndex + 1;
	    },
	    get rotate() {
	      return this.pageInfo.rotate;
	    },
	    get ref() {
	      return this.pageInfo.ref;
	    },
	    get userUnit() {
	      return this.pageInfo.userUnit;
	    },
	    get view() {
	      return this.pageInfo.view;
	    },
	    getViewport: function getViewport(scale) {
	      var rotate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.rotate;
	      var dontFlip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      return new _util.PageViewport(this.view, scale, rotate, 0, 0, dontFlip);
	    },
	
	    getAnnotations: function PDFPageProxy_getAnnotations(params) {
	      var intent = params && params.intent || null;
	      if (!this.annotationsPromise || this.annotationsIntent !== intent) {
	        this.annotationsPromise = this.transport.getAnnotations(this.pageIndex, intent);
	        this.annotationsIntent = intent;
	      }
	      return this.annotationsPromise;
	    },
	    render: function PDFPageProxy_render(params) {
	      var _this4 = this;
	
	      var stats = this._stats;
	      stats.time('Overall');
	      this.pendingCleanup = false;
	      var renderingIntent = params.intent === 'print' ? 'print' : 'display';
	      var canvasFactory = params.canvasFactory || new _dom_utils.DOMCanvasFactory();
	      var webGLContext = new _webgl.WebGLContext({ enable: !(0, _dom_utils.getDefaultSetting)('disableWebGL') });
	      if (!this.intentStates[renderingIntent]) {
	        this.intentStates[renderingIntent] = Object.create(null);
	      }
	      var intentState = this.intentStates[renderingIntent];
	      if (!intentState.displayReadyCapability) {
	        intentState.receivingOperatorList = true;
	        intentState.displayReadyCapability = (0, _util.createPromiseCapability)();
	        intentState.operatorList = {
	          fnArray: [],
	          argsArray: [],
	          lastChunk: false
	        };
	        stats.time('Page Request');
	        this.transport.messageHandler.send('RenderPageRequest', {
	          pageIndex: this.pageNumber - 1,
	          intent: renderingIntent,
	          renderInteractiveForms: params.renderInteractiveForms === true
	        });
	      }
	      var complete = function complete(error) {
	        var i = intentState.renderTasks.indexOf(internalRenderTask);
	        if (i >= 0) {
	          intentState.renderTasks.splice(i, 1);
	        }
	        if (_this4.cleanupAfterRender) {
	          _this4.pendingCleanup = true;
	        }
	        _this4._tryCleanup();
	        if (error) {
	          internalRenderTask.capability.reject(error);
	        } else {
	          internalRenderTask.capability.resolve();
	        }
	        stats.timeEnd('Rendering');
	        stats.timeEnd('Overall');
	      };
	      var internalRenderTask = new InternalRenderTask(complete, params, this.objs, this.commonObjs, intentState.operatorList, this.pageNumber, canvasFactory, webGLContext);
	      internalRenderTask.useRequestAnimationFrame = renderingIntent !== 'print';
	      if (!intentState.renderTasks) {
	        intentState.renderTasks = [];
	      }
	      intentState.renderTasks.push(internalRenderTask);
	      var renderTask = internalRenderTask.task;
	      intentState.displayReadyCapability.promise.then(function (transparency) {
	        if (_this4.pendingCleanup) {
	          complete();
	          return;
	        }
	        stats.time('Rendering');
	        internalRenderTask.initializeGraphics(transparency);
	        internalRenderTask.operatorListChanged();
	      }).catch(complete);
	      return renderTask;
	    },
	    getOperatorList: function PDFPageProxy_getOperatorList() {
	      function operatorListChanged() {
	        if (intentState.operatorList.lastChunk) {
	          intentState.opListReadCapability.resolve(intentState.operatorList);
	          var i = intentState.renderTasks.indexOf(opListTask);
	          if (i >= 0) {
	            intentState.renderTasks.splice(i, 1);
	          }
	        }
	      }
	      var renderingIntent = 'oplist';
	      if (!this.intentStates[renderingIntent]) {
	        this.intentStates[renderingIntent] = Object.create(null);
	      }
	      var intentState = this.intentStates[renderingIntent];
	      var opListTask;
	      if (!intentState.opListReadCapability) {
	        opListTask = {};
	        opListTask.operatorListChanged = operatorListChanged;
	        intentState.receivingOperatorList = true;
	        intentState.opListReadCapability = (0, _util.createPromiseCapability)();
	        intentState.renderTasks = [];
	        intentState.renderTasks.push(opListTask);
	        intentState.operatorList = {
	          fnArray: [],
	          argsArray: [],
	          lastChunk: false
	        };
	        this.transport.messageHandler.send('RenderPageRequest', {
	          pageIndex: this.pageIndex,
	          intent: renderingIntent
	        });
	      }
	      return intentState.opListReadCapability.promise;
	    },
	    streamTextContent: function streamTextContent() {
	      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var TEXT_CONTENT_CHUNK_SIZE = 100;
	      return this.transport.messageHandler.sendWithStream('GetTextContent', {
	        pageIndex: this.pageNumber - 1,
	        normalizeWhitespace: params.normalizeWhitespace === true,
	        combineTextItems: params.disableCombineTextItems !== true
	      }, {
	        highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
	        size: function size(textContent) {
	          return textContent.items.length;
	        }
	      });
	    },
	
	    getTextContent: function PDFPageProxy_getTextContent(params) {
	      params = params || {};
	      var readableStream = this.streamTextContent(params);
	      return new Promise(function (resolve, reject) {
	        function pump() {
	          reader.read().then(function (_ref) {
	            var value = _ref.value,
	                done = _ref.done;
	
	            if (done) {
	              resolve(textContent);
	              return;
	            }
	            _util.Util.extendObj(textContent.styles, value.styles);
	            _util.Util.appendToArray(textContent.items, value.items);
	            pump();
	          }, reject);
	        }
	        var reader = readableStream.getReader();
	        var textContent = {
	          items: [],
	          styles: Object.create(null)
	        };
	        pump();
	      });
	    },
	    _destroy: function PDFPageProxy_destroy() {
	      this.destroyed = true;
	      this.transport.pageCache[this.pageIndex] = null;
	      var waitOn = [];
	      Object.keys(this.intentStates).forEach(function (intent) {
	        if (intent === 'oplist') {
	          return;
	        }
	        var intentState = this.intentStates[intent];
	        intentState.renderTasks.forEach(function (renderTask) {
	          var renderCompleted = renderTask.capability.promise.catch(function () {});
	          waitOn.push(renderCompleted);
	          renderTask.cancel();
	        });
	      }, this);
	      this.objs.clear();
	      this.annotationsPromise = null;
	      this.pendingCleanup = false;
	      return Promise.all(waitOn);
	    },
	    cleanup: function cleanup() {
	      var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      this.pendingCleanup = true;
	      this._tryCleanup(resetStats);
	    },
	    _tryCleanup: function _tryCleanup() {
	      var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!this.pendingCleanup || Object.keys(this.intentStates).some(function (intent) {
	        var intentState = this.intentStates[intent];
	        return intentState.renderTasks.length !== 0 || intentState.receivingOperatorList;
	      }, this)) {
	        return;
	      }
	      Object.keys(this.intentStates).forEach(function (intent) {
	        delete this.intentStates[intent];
	      }, this);
	      this.objs.clear();
	      this.annotationsPromise = null;
	      if (resetStats && this._stats instanceof _dom_utils.StatTimer) {
	        this._stats = new _dom_utils.StatTimer();
	      }
	      this.pendingCleanup = false;
	    },
	
	    _startRenderPage: function PDFPageProxy_startRenderPage(transparency, intent) {
	      var intentState = this.intentStates[intent];
	      if (intentState.displayReadyCapability) {
	        intentState.displayReadyCapability.resolve(transparency);
	      }
	    },
	    _renderPageChunk: function PDFPageProxy_renderPageChunk(operatorListChunk, intent) {
	      var intentState = this.intentStates[intent];
	      var i, ii;
	      for (i = 0, ii = operatorListChunk.length; i < ii; i++) {
	        intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
	        intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
	      }
	      intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
	      for (i = 0; i < intentState.renderTasks.length; i++) {
	        intentState.renderTasks[i].operatorListChanged();
	      }
	      if (operatorListChunk.lastChunk) {
	        intentState.receivingOperatorList = false;
	        this._tryCleanup();
	      }
	    },
	    get stats() {
	      return this._stats instanceof _dom_utils.StatTimer ? this._stats : null;
	    }
	  };
	  return PDFPageProxy;
	}();
	
	var LoopbackPort = function () {
	  function LoopbackPort(defer) {
	    _classCallCheck(this, LoopbackPort);
	
	    this._listeners = [];
	    this._defer = defer;
	    this._deferred = Promise.resolve(undefined);
	  }
	
	  _createClass(LoopbackPort, [{
	    key: 'postMessage',
	    value: function postMessage(obj, transfers) {
	      var _this5 = this;
	
	      function cloneValue(value) {
	        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null) {
	          return value;
	        }
	        if (cloned.has(value)) {
	          return cloned.get(value);
	        }
	        var result;
	        var buffer;
	        if ((buffer = value.buffer) && (0, _util.isArrayBuffer)(buffer)) {
	          var transferable = transfers && transfers.indexOf(buffer) >= 0;
	          if (value === buffer) {
	            result = value;
	          } else if (transferable) {
	            result = new value.constructor(buffer, value.byteOffset, value.byteLength);
	          } else {
	            result = new value.constructor(value);
	          }
	          cloned.set(value, result);
	          return result;
	        }
	        result = Array.isArray(value) ? [] : {};
	        cloned.set(value, result);
	        for (var i in value) {
	          var desc,
	              p = value;
	          while (!(desc = Object.getOwnPropertyDescriptor(p, i))) {
	            p = Object.getPrototypeOf(p);
	          }
	          if (typeof desc.value === 'undefined' || typeof desc.value === 'function') {
	            continue;
	          }
	          result[i] = cloneValue(desc.value);
	        }
	        return result;
	      }
	      if (!this._defer) {
	        this._listeners.forEach(function (listener) {
	          listener.call(this, { data: obj });
	        }, this);
	        return;
	      }
	      var cloned = new WeakMap();
	      var e = { data: cloneValue(obj) };
	      this._deferred.then(function () {
	        _this5._listeners.forEach(function (listener) {
	          listener.call(this, e);
	        }, _this5);
	      });
	    }
	  }, {
	    key: 'addEventListener',
	    value: function addEventListener(name, listener) {
	      this._listeners.push(listener);
	    }
	  }, {
	    key: 'removeEventListener',
	    value: function removeEventListener(name, listener) {
	      var i = this._listeners.indexOf(listener);
	      this._listeners.splice(i, 1);
	    }
	  }, {
	    key: 'terminate',
	    value: function terminate() {
	      this._listeners = [];
	    }
	  }]);
	
	  return LoopbackPort;
	}();
	
	var PDFWorker = function PDFWorkerClosure() {
	  var nextFakeWorkerId = 0;
	  function getWorkerSrc() {
	    if (typeof workerSrc !== 'undefined') {
	      return workerSrc;
	    }
	    if ((0, _dom_utils.getDefaultSetting)('workerSrc')) {
	      return (0, _dom_utils.getDefaultSetting)('workerSrc');
	    }
	    if (pdfjsFilePath) {
	      return pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, '.worker$1$2');
	    }
	    throw new Error('No PDFJS.workerSrc specified');
	  }
	  var fakeWorkerFilesLoadedCapability = void 0;
	  function setupFakeWorkerGlobal() {
	    var WorkerMessageHandler;
	    if (fakeWorkerFilesLoadedCapability) {
	      return fakeWorkerFilesLoadedCapability.promise;
	    }
	    fakeWorkerFilesLoadedCapability = (0, _util.createPromiseCapability)();
	    var loader = fakeWorkerFilesLoader || function (callback) {
	      _util.Util.loadScript(getWorkerSrc(), function () {
	        callback(window.pdfjsDistBuildPdfWorker.WorkerMessageHandler);
	      });
	    };
	    loader(fakeWorkerFilesLoadedCapability.resolve);
	    return fakeWorkerFilesLoadedCapability.promise;
	  }
	  function createCDNWrapper(url) {
	    var wrapper = 'importScripts(\'' + url + '\');';
	    return URL.createObjectURL(new Blob([wrapper]));
	  }
	  var pdfWorkerPorts = new WeakMap();
	  function PDFWorker(name, port) {
	    if (port && pdfWorkerPorts.has(port)) {
	      throw new Error('Cannot use more than one PDFWorker per port');
	    }
	    this.name = name;
	    this.destroyed = false;
	    this.postMessageTransfers = true;
	    this._readyCapability = (0, _util.createPromiseCapability)();
	    this._port = null;
	    this._webWorker = null;
	    this._messageHandler = null;
	    if (port) {
	      pdfWorkerPorts.set(port, this);
	      this._initializeFromPort(port);
	      return;
	    }
	    this._initialize();
	  }
	  PDFWorker.prototype = {
	    get promise() {
	      return this._readyCapability.promise;
	    },
	    get port() {
	      return this._port;
	    },
	    get messageHandler() {
	      return this._messageHandler;
	    },
	    _initializeFromPort: function PDFWorker_initializeFromPort(port) {
	      this._port = port;
	      this._messageHandler = new _util.MessageHandler('main', 'worker', port);
	      this._messageHandler.on('ready', function () {});
	      this._readyCapability.resolve();
	    },
	    _initialize: function PDFWorker_initialize() {
	      var _this6 = this;
	
	      if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)('disableWorker') && typeof Worker !== 'undefined') {
	        var workerSrc = getWorkerSrc();
	        try {
	          if (!(0, _util.isSameOrigin)(window.location.href, workerSrc)) {
	            workerSrc = createCDNWrapper(new URL(workerSrc, window.location).href);
	          }
	          var worker = new Worker(workerSrc);
	          var messageHandler = new _util.MessageHandler('main', 'worker', worker);
	          var terminateEarly = function terminateEarly() {
	            worker.removeEventListener('error', onWorkerError);
	            messageHandler.destroy();
	            worker.terminate();
	            if (_this6.destroyed) {
	              _this6._readyCapability.reject(new Error('Worker was destroyed'));
	            } else {
	              _this6._setupFakeWorker();
	            }
	          };
	          var onWorkerError = function onWorkerError() {
	            if (!_this6._webWorker) {
	              terminateEarly();
	            }
	          };
	          worker.addEventListener('error', onWorkerError);
	          messageHandler.on('test', function (data) {
	            worker.removeEventListener('error', onWorkerError);
	            if (_this6.destroyed) {
	              terminateEarly();
	              return;
	            }
	            var supportTypedArray = data && data.supportTypedArray;
	            if (supportTypedArray) {
	              _this6._messageHandler = messageHandler;
	              _this6._port = worker;
	              _this6._webWorker = worker;
	              if (!data.supportTransfers) {
	                _this6.postMessageTransfers = false;
	                isPostMessageTransfersDisabled = true;
	              }
	              _this6._readyCapability.resolve();
	              messageHandler.send('configure', { verbosity: (0, _util.getVerbosityLevel)() });
	            } else {
	              _this6._setupFakeWorker();
	              messageHandler.destroy();
	              worker.terminate();
	            }
	          });
	          messageHandler.on('ready', function (data) {
	            worker.removeEventListener('error', onWorkerError);
	            if (_this6.destroyed) {
	              terminateEarly();
	              return;
	            }
	            try {
	              sendTest();
	            } catch (e) {
	              _this6._setupFakeWorker();
	            }
	          });
	          var sendTest = function sendTest() {
	            var postMessageTransfers = (0, _dom_utils.getDefaultSetting)('postMessageTransfers') && !isPostMessageTransfersDisabled;
	            var testObj = new Uint8Array([postMessageTransfers ? 255 : 0]);
	            try {
	              messageHandler.send('test', testObj, [testObj.buffer]);
	            } catch (ex) {
	              (0, _util.info)('Cannot use postMessage transfers');
	              testObj[0] = 0;
	              messageHandler.send('test', testObj);
	            }
	          };
	          sendTest();
	          return;
	        } catch (e) {
	          (0, _util.info)('The worker has been disabled.');
	        }
	      }
	      this._setupFakeWorker();
	    },
	    _setupFakeWorker: function PDFWorker_setupFakeWorker() {
	      var _this7 = this;
	
	      if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)('disableWorker')) {
	        (0, _util.warn)('Setting up fake worker.');
	        isWorkerDisabled = true;
	      }
	      setupFakeWorkerGlobal().then(function (WorkerMessageHandler) {
	        if (_this7.destroyed) {
	          _this7._readyCapability.reject(new Error('Worker was destroyed'));
	          return;
	        }
	        var isTypedArraysPresent = Uint8Array !== Float32Array;
	        var port = new LoopbackPort(isTypedArraysPresent);
	        _this7._port = port;
	        var id = 'fake' + nextFakeWorkerId++;
	        var workerHandler = new _util.MessageHandler(id + '_worker', id, port);
	        WorkerMessageHandler.setup(workerHandler, port);
	        var messageHandler = new _util.MessageHandler(id, id + '_worker', port);
	        _this7._messageHandler = messageHandler;
	        _this7._readyCapability.resolve();
	      });
	    },
	    destroy: function PDFWorker_destroy() {
	      this.destroyed = true;
	      if (this._webWorker) {
	        this._webWorker.terminate();
	        this._webWorker = null;
	      }
	      pdfWorkerPorts.delete(this._port);
	      this._port = null;
	      if (this._messageHandler) {
	        this._messageHandler.destroy();
	        this._messageHandler = null;
	      }
	    }
	  };
	  PDFWorker.fromPort = function (port) {
	    if (pdfWorkerPorts.has(port)) {
	      return pdfWorkerPorts.get(port);
	    }
	    return new PDFWorker(null, port);
	  };
	  return PDFWorker;
	}();
	var WorkerTransport = function WorkerTransportClosure() {
	  function WorkerTransport(messageHandler, loadingTask, networkStream, CMapReaderFactory) {
	    this.messageHandler = messageHandler;
	    this.loadingTask = loadingTask;
	    this.commonObjs = new PDFObjects();
	    this.fontLoader = new _font_loader.FontLoader(loadingTask.docId);
	    this.CMapReaderFactory = new CMapReaderFactory({
	      baseUrl: (0, _dom_utils.getDefaultSetting)('cMapUrl'),
	      isCompressed: (0, _dom_utils.getDefaultSetting)('cMapPacked')
	    });
	    this.destroyed = false;
	    this.destroyCapability = null;
	    this._passwordCapability = null;
	    this._networkStream = networkStream;
	    this._fullReader = null;
	    this._lastProgress = null;
	    this.pageCache = [];
	    this.pagePromises = [];
	    this.downloadInfoCapability = (0, _util.createPromiseCapability)();
	    this.setupMessageHandler();
	  }
	  WorkerTransport.prototype = {
	    destroy: function WorkerTransport_destroy() {
	      var _this8 = this;
	
	      if (this.destroyCapability) {
	        return this.destroyCapability.promise;
	      }
	      this.destroyed = true;
	      this.destroyCapability = (0, _util.createPromiseCapability)();
	      if (this._passwordCapability) {
	        this._passwordCapability.reject(new Error('Worker was destroyed during onPassword callback'));
	      }
	      var waitOn = [];
	      this.pageCache.forEach(function (page) {
	        if (page) {
	          waitOn.push(page._destroy());
	        }
	      });
	      this.pageCache = [];
	      this.pagePromises = [];
	      var terminated = this.messageHandler.sendWithPromise('Terminate', null);
	      waitOn.push(terminated);
	      Promise.all(waitOn).then(function () {
	        _this8.fontLoader.clear();
	        if (_this8._networkStream) {
	          _this8._networkStream.cancelAllRequests();
	        }
	        if (_this8.messageHandler) {
	          _this8.messageHandler.destroy();
	          _this8.messageHandler = null;
	        }
	        _this8.destroyCapability.resolve();
	      }, this.destroyCapability.reject);
	      return this.destroyCapability.promise;
	    },
	    setupMessageHandler: function WorkerTransport_setupMessageHandler() {
	      var messageHandler = this.messageHandler;
	      var loadingTask = this.loadingTask;
	      messageHandler.on('GetReader', function (data, sink) {
	        var _this9 = this;
	
	        (0, _util.assert)(this._networkStream);
	        this._fullReader = this._networkStream.getFullReader();
	        this._fullReader.onProgress = function (evt) {
	          _this9._lastProgress = {
	            loaded: evt.loaded,
	            total: evt.total
	          };
	        };
	        sink.onPull = function () {
	          _this9._fullReader.read().then(function (_ref2) {
	            var value = _ref2.value,
	                done = _ref2.done;
	
	            if (done) {
	              sink.close();
	              return;
	            }
	            (0, _util.assert)((0, _util.isArrayBuffer)(value));
	            sink.enqueue(new Uint8Array(value), 1, [value]);
	          }).catch(function (reason) {
	            sink.error(reason);
	          });
	        };
	        sink.onCancel = function (reason) {
	          _this9._fullReader.cancel(reason);
	        };
	      }, this);
	      messageHandler.on('ReaderHeadersReady', function (data) {
	        var _this10 = this;
	
	        var headersCapability = (0, _util.createPromiseCapability)();
	        var fullReader = this._fullReader;
	        fullReader.headersReady.then(function () {
	          if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
	            if (_this10._lastProgress) {
	              var _loadingTask = _this10.loadingTask;
	              if (_loadingTask.onProgress) {
	                _loadingTask.onProgress(_this10._lastProgress);
	              }
	            }
	            fullReader.onProgress = function (evt) {
	              var loadingTask = _this10.loadingTask;
	              if (loadingTask.onProgress) {
	                loadingTask.onProgress({
	                  loaded: evt.loaded,
	                  total: evt.total
	                });
	              }
	            };
	          }
	          headersCapability.resolve({
	            isStreamingSupported: fullReader.isStreamingSupported,
	            isRangeSupported: fullReader.isRangeSupported,
	            contentLength: fullReader.contentLength
	          });
	        }, headersCapability.reject);
	        return headersCapability.promise;
	      }, this);
	      messageHandler.on('GetRangeReader', function (data, sink) {
	        (0, _util.assert)(this._networkStream);
	        var _rangeReader = this._networkStream.getRangeReader(data.begin, data.end);
	        sink.onPull = function () {
	          _rangeReader.read().then(function (_ref3) {
	            var value = _ref3.value,
	                done = _ref3.done;
	
	            if (done) {
	              sink.close();
	              return;
	            }
	            (0, _util.assert)((0, _util.isArrayBuffer)(value));
	            sink.enqueue(new Uint8Array(value), 1, [value]);
	          }).catch(function (reason) {
	            sink.error(reason);
	          });
	        };
	        sink.onCancel = function (reason) {
	          _rangeReader.cancel(reason);
	        };
	      }, this);
	      messageHandler.on('GetDoc', function transportDoc(_ref4) {
	        var pdfInfo = _ref4.pdfInfo;
	
	        this.numPages = pdfInfo.numPages;
	        var loadingTask = this.loadingTask;
	        var pdfDocument = new PDFDocumentProxy(pdfInfo, this, loadingTask);
	        this.pdfDocument = pdfDocument;
	        loadingTask._capability.resolve(pdfDocument);
	      }, this);
	      messageHandler.on('PasswordRequest', function transportPasswordRequest(exception) {
	        var _this11 = this;
	
	        this._passwordCapability = (0, _util.createPromiseCapability)();
	        if (loadingTask.onPassword) {
	          var updatePassword = function updatePassword(password) {
	            _this11._passwordCapability.resolve({ password: password });
	          };
	          loadingTask.onPassword(updatePassword, exception.code);
	        } else {
	          this._passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
	        }
	        return this._passwordCapability.promise;
	      }, this);
	      messageHandler.on('PasswordException', function transportPasswordException(exception) {
	        loadingTask._capability.reject(new _util.PasswordException(exception.message, exception.code));
	      }, this);
	      messageHandler.on('InvalidPDF', function transportInvalidPDF(exception) {
	        this.loadingTask._capability.reject(new _util.InvalidPDFException(exception.message));
	      }, this);
	      messageHandler.on('MissingPDF', function transportMissingPDF(exception) {
	        this.loadingTask._capability.reject(new _util.MissingPDFException(exception.message));
	      }, this);
	      messageHandler.on('UnexpectedResponse', function transportUnexpectedResponse(exception) {
	        this.loadingTask._capability.reject(new _util.UnexpectedResponseException(exception.message, exception.status));
	      }, this);
	      messageHandler.on('UnknownError', function transportUnknownError(exception) {
	        this.loadingTask._capability.reject(new _util.UnknownErrorException(exception.message, exception.details));
	      }, this);
	      messageHandler.on('DataLoaded', function transportPage(data) {
	        this.downloadInfoCapability.resolve(data);
	      }, this);
	      messageHandler.on('PDFManagerReady', function transportPage(data) {}, this);
	      messageHandler.on('StartRenderPage', function transportRender(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var page = this.pageCache[data.pageIndex];
	        page._stats.timeEnd('Page Request');
	        page._startRenderPage(data.transparency, data.intent);
	      }, this);
	      messageHandler.on('RenderPageChunk', function transportRender(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var page = this.pageCache[data.pageIndex];
	        page._renderPageChunk(data.operatorList, data.intent);
	      }, this);
	      messageHandler.on('commonobj', function transportObj(data) {
	        var _this12 = this;
	
	        if (this.destroyed) {
	          return;
	        }
	        var id = data[0];
	        var type = data[1];
	        if (this.commonObjs.hasData(id)) {
	          return;
	        }
	        switch (type) {
	          case 'Font':
	            var exportedData = data[2];
	            if ('error' in exportedData) {
	              var exportedError = exportedData.error;
	              (0, _util.warn)('Error during font loading: ' + exportedError);
	              this.commonObjs.resolve(id, exportedError);
	              break;
	            }
	            var fontRegistry = null;
	            if ((0, _dom_utils.getDefaultSetting)('pdfBug') && _global_scope2.default.FontInspector && _global_scope2.default['FontInspector'].enabled) {
	              fontRegistry = {
	                registerFont: function registerFont(font, url) {
	                  _global_scope2.default['FontInspector'].fontAdded(font, url);
	                }
	              };
	            }
	            var font = new _font_loader.FontFaceObject(exportedData, {
	              isEvalSupported: (0, _dom_utils.getDefaultSetting)('isEvalSupported'),
	              disableFontFace: (0, _dom_utils.getDefaultSetting)('disableFontFace'),
	              fontRegistry: fontRegistry
	            });
	            var fontReady = function fontReady(fontObjs) {
	              _this12.commonObjs.resolve(id, font);
	            };
	            this.fontLoader.bind([font], fontReady);
	            break;
	          case 'FontPath':
	            this.commonObjs.resolve(id, data[2]);
	            break;
	          default:
	            throw new Error('Got unknown common object type ' + type);
	        }
	      }, this);
	      messageHandler.on('obj', function transportObj(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var id = data[0];
	        var pageIndex = data[1];
	        var type = data[2];
	        var pageProxy = this.pageCache[pageIndex];
	        var imageData;
	        if (pageProxy.objs.hasData(id)) {
	          return;
	        }
	        switch (type) {
	          case 'JpegStream':
	            imageData = data[3];
	            (0, _util.loadJpegStream)(id, imageData, pageProxy.objs);
	            break;
	          case 'Image':
	            imageData = data[3];
	            pageProxy.objs.resolve(id, imageData);
	            var MAX_IMAGE_SIZE_TO_STORE = 8000000;
	            if (imageData && 'data' in imageData && imageData.data.length > MAX_IMAGE_SIZE_TO_STORE) {
	              pageProxy.cleanupAfterRender = true;
	            }
	            break;
	          default:
	            throw new Error('Got unknown object type ' + type);
	        }
	      }, this);
	      messageHandler.on('DocProgress', function transportDocProgress(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var loadingTask = this.loadingTask;
	        if (loadingTask.onProgress) {
	          loadingTask.onProgress({
	            loaded: data.loaded,
	            total: data.total
	          });
	        }
	      }, this);
	      messageHandler.on('PageError', function transportError(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var page = this.pageCache[data.pageNum - 1];
	        var intentState = page.intentStates[data.intent];
	        if (intentState.displayReadyCapability) {
	          intentState.displayReadyCapability.reject(data.error);
	        } else {
	          throw new Error(data.error);
	        }
	        if (intentState.operatorList) {
	          intentState.operatorList.lastChunk = true;
	          for (var i = 0; i < intentState.renderTasks.length; i++) {
	            intentState.renderTasks[i].operatorListChanged();
	          }
	        }
	      }, this);
	      messageHandler.on('UnsupportedFeature', function (data) {
	        if (this.destroyed) {
	          return;
	        }
	        var loadingTask = this.loadingTask;
	        if (loadingTask.onUnsupportedFeature) {
	          loadingTask.onUnsupportedFeature(data.featureId);
	        }
	      }, this);
	      messageHandler.on('JpegDecode', function (data) {
	        if (this.destroyed) {
	          return Promise.reject(new Error('Worker was destroyed'));
	        }
	        if (typeof document === 'undefined') {
	          return Promise.reject(new Error('"document" is not defined.'));
	        }
	        var imageUrl = data[0];
	        var components = data[1];
	        if (components !== 3 && components !== 1) {
	          return Promise.reject(new Error('Only 3 components or 1 component can be returned'));
	        }
	        return new Promise(function (resolve, reject) {
	          var img = new Image();
	          img.onload = function () {
	            var width = img.width;
	            var height = img.height;
	            var size = width * height;
	            var rgbaLength = size * 4;
	            var buf = new Uint8Array(size * components);
	            var tmpCanvas = document.createElement('canvas');
	            tmpCanvas.width = width;
	            tmpCanvas.height = height;
	            var tmpCtx = tmpCanvas.getContext('2d');
	            tmpCtx.drawImage(img, 0, 0);
	            var data = tmpCtx.getImageData(0, 0, width, height).data;
	            var i, j;
	            if (components === 3) {
	              for (i = 0, j = 0; i < rgbaLength; i += 4, j += 3) {
	                buf[j] = data[i];
	                buf[j + 1] = data[i + 1];
	                buf[j + 2] = data[i + 2];
	              }
	            } else if (components === 1) {
	              for (i = 0, j = 0; i < rgbaLength; i += 4, j++) {
	                buf[j] = data[i];
	              }
	            }
	            resolve({
	              data: buf,
	              width: width,
	              height: height
	            });
	          };
	          img.onerror = function () {
	            reject(new Error('JpegDecode failed to load image'));
	          };
	          img.src = imageUrl;
	        });
	      }, this);
	      messageHandler.on('FetchBuiltInCMap', function (data) {
	        if (this.destroyed) {
	          return Promise.reject(new Error('Worker was destroyed'));
	        }
	        return this.CMapReaderFactory.fetch({ name: data.name });
	      }, this);
	    },
	    getData: function WorkerTransport_getData() {
	      return this.messageHandler.sendWithPromise('GetData', null);
	    },
	    getPage: function getPage(pageNumber) {
	      var _this13 = this;
	
	      if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this.numPages) {
	        return Promise.reject(new Error('Invalid page request'));
	      }
	      var pageIndex = pageNumber - 1;
	      if (pageIndex in this.pagePromises) {
	        return this.pagePromises[pageIndex];
	      }
	      var promise = this.messageHandler.sendWithPromise('GetPage', { pageIndex: pageIndex }).then(function (pageInfo) {
	        if (_this13.destroyed) {
	          throw new Error('Transport destroyed');
	        }
	        var page = new PDFPageProxy(pageIndex, pageInfo, _this13);
	        _this13.pageCache[pageIndex] = page;
	        return page;
	      });
	      this.pagePromises[pageIndex] = promise;
	      return promise;
	    },
	
	    getPageIndex: function WorkerTransport_getPageIndexByRef(ref) {
	      return this.messageHandler.sendWithPromise('GetPageIndex', { ref: ref }).catch(function (reason) {
	        return Promise.reject(new Error(reason));
	      });
	    },
	    getAnnotations: function WorkerTransport_getAnnotations(pageIndex, intent) {
	      return this.messageHandler.sendWithPromise('GetAnnotations', {
	        pageIndex: pageIndex,
	        intent: intent
	      });
	    },
	    getDestinations: function WorkerTransport_getDestinations() {
	      return this.messageHandler.sendWithPromise('GetDestinations', null);
	    },
	    getDestination: function WorkerTransport_getDestination(id) {
	      return this.messageHandler.sendWithPromise('GetDestination', { id: id });
	    },
	    getPageLabels: function WorkerTransport_getPageLabels() {
	      return this.messageHandler.sendWithPromise('GetPageLabels', null);
	    },
	    getPageMode: function getPageMode() {
	      return this.messageHandler.sendWithPromise('GetPageMode', null);
	    },
	
	    getAttachments: function WorkerTransport_getAttachments() {
	      return this.messageHandler.sendWithPromise('GetAttachments', null);
	    },
	    getJavaScript: function WorkerTransport_getJavaScript() {
	      return this.messageHandler.sendWithPromise('GetJavaScript', null);
	    },
	    getOutline: function WorkerTransport_getOutline() {
	      return this.messageHandler.sendWithPromise('GetOutline', null);
	    },
	    getMetadata: function WorkerTransport_getMetadata() {
	      var _this14 = this;
	
	      return this.messageHandler.sendWithPromise('GetMetadata', null).then(function (results) {
	        return {
	          info: results[0],
	          metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
	          contentDispositionFilename: _this14._fullReader ? _this14._fullReader.filename : null
	        };
	      });
	    },
	    getStats: function WorkerTransport_getStats() {
	      return this.messageHandler.sendWithPromise('GetStats', null);
	    },
	    startCleanup: function WorkerTransport_startCleanup() {
	      var _this15 = this;
	
	      this.messageHandler.sendWithPromise('Cleanup', null).then(function () {
	        for (var i = 0, ii = _this15.pageCache.length; i < ii; i++) {
	          var page = _this15.pageCache[i];
	          if (page) {
	            page.cleanup();
	          }
	        }
	        _this15.commonObjs.clear();
	        _this15.fontLoader.clear();
	      });
	    }
	  };
	  return WorkerTransport;
	}();
	var PDFObjects = function PDFObjectsClosure() {
	  function PDFObjects() {
	    this.objs = Object.create(null);
	  }
	  PDFObjects.prototype = {
	    ensureObj: function PDFObjects_ensureObj(objId) {
	      if (this.objs[objId]) {
	        return this.objs[objId];
	      }
	      var obj = {
	        capability: (0, _util.createPromiseCapability)(),
	        data: null,
	        resolved: false
	      };
	      this.objs[objId] = obj;
	      return obj;
	    },
	    get: function PDFObjects_get(objId, callback) {
	      if (callback) {
	        this.ensureObj(objId).capability.promise.then(callback);
	        return null;
	      }
	      var obj = this.objs[objId];
	      if (!obj || !obj.resolved) {
	        throw new Error('Requesting object that isn\'t resolved yet ' + objId);
	      }
	      return obj.data;
	    },
	    resolve: function PDFObjects_resolve(objId, data) {
	      var obj = this.ensureObj(objId);
	      obj.resolved = true;
	      obj.data = data;
	      obj.capability.resolve(data);
	    },
	    isResolved: function PDFObjects_isResolved(objId) {
	      var objs = this.objs;
	      if (!objs[objId]) {
	        return false;
	      }
	      return objs[objId].resolved;
	    },
	    hasData: function PDFObjects_hasData(objId) {
	      return this.isResolved(objId);
	    },
	    getData: function PDFObjects_getData(objId) {
	      var objs = this.objs;
	      if (!objs[objId] || !objs[objId].resolved) {
	        return null;
	      }
	      return objs[objId].data;
	    },
	    clear: function PDFObjects_clear() {
	      this.objs = Object.create(null);
	    }
	  };
	  return PDFObjects;
	}();
	var RenderTask = function RenderTaskClosure() {
	  function RenderTask(internalRenderTask) {
	    this._internalRenderTask = internalRenderTask;
	    this.onContinue = null;
	  }
	  RenderTask.prototype = {
	    get promise() {
	      return this._internalRenderTask.capability.promise;
	    },
	    cancel: function RenderTask_cancel() {
	      this._internalRenderTask.cancel();
	    },
	    then: function RenderTask_then(onFulfilled, onRejected) {
	      return this.promise.then.apply(this.promise, arguments);
	    }
	  };
	  return RenderTask;
	}();
	var InternalRenderTask = function InternalRenderTaskClosure() {
	  var canvasInRendering = new WeakMap();
	  function InternalRenderTask(callback, params, objs, commonObjs, operatorList, pageNumber, canvasFactory, webGLContext) {
	    this.callback = callback;
	    this.params = params;
	    this.objs = objs;
	    this.commonObjs = commonObjs;
	    this.operatorListIdx = null;
	    this.operatorList = operatorList;
	    this.pageNumber = pageNumber;
	    this.canvasFactory = canvasFactory;
	    this.webGLContext = webGLContext;
	    this.running = false;
	    this.graphicsReadyCallback = null;
	    this.graphicsReady = false;
	    this.useRequestAnimationFrame = false;
	    this.cancelled = false;
	    this.capability = (0, _util.createPromiseCapability)();
	    this.task = new RenderTask(this);
	    this._continueBound = this._continue.bind(this);
	    this._scheduleNextBound = this._scheduleNext.bind(this);
	    this._nextBound = this._next.bind(this);
	    this._canvas = params.canvasContext.canvas;
	  }
	  InternalRenderTask.prototype = {
	    initializeGraphics: function InternalRenderTask_initializeGraphics(transparency) {
	      if (this._canvas) {
	        if (canvasInRendering.has(this._canvas)) {
	          throw new Error('Cannot use the same canvas during multiple render() operations. ' + 'Use different canvas or ensure previous operations were ' + 'cancelled or completed.');
	        }
	        canvasInRendering.set(this._canvas, this);
	      }
	      if (this.cancelled) {
	        return;
	      }
	      if ((0, _dom_utils.getDefaultSetting)('pdfBug') && _global_scope2.default.StepperManager && _global_scope2.default.StepperManager.enabled) {
	        this.stepper = _global_scope2.default.StepperManager.create(this.pageNumber - 1);
	        this.stepper.init(this.operatorList);
	        this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
	      }
	      var params = this.params;
	      this.gfx = new _canvas.CanvasGraphics(params.canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.webGLContext, params.imageLayer);
	      this.gfx.beginDrawing({
	        transform: params.transform,
	        viewport: params.viewport,
	        transparency: transparency,
	        background: params.background
	      });
	      this.operatorListIdx = 0;
	      this.graphicsReady = true;
	      if (this.graphicsReadyCallback) {
	        this.graphicsReadyCallback();
	      }
	    },
	    cancel: function InternalRenderTask_cancel() {
	      this.running = false;
	      this.cancelled = true;
	      if (this._canvas) {
	        canvasInRendering.delete(this._canvas);
	      }
	      this.callback(new _dom_utils.RenderingCancelledException('Rendering cancelled, page ' + this.pageNumber, 'canvas'));
	    },
	    operatorListChanged: function InternalRenderTask_operatorListChanged() {
	      if (!this.graphicsReady) {
	        if (!this.graphicsReadyCallback) {
	          this.graphicsReadyCallback = this._continueBound;
	        }
	        return;
	      }
	      if (this.stepper) {
	        this.stepper.updateOperatorList(this.operatorList);
	      }
	      if (this.running) {
	        return;
	      }
	      this._continue();
	    },
	    _continue: function InternalRenderTask__continue() {
	      this.running = true;
	      if (this.cancelled) {
	        return;
	      }
	      if (this.task.onContinue) {
	        this.task.onContinue(this._scheduleNextBound);
	      } else {
	        this._scheduleNext();
	      }
	    },
	    _scheduleNext: function InternalRenderTask__scheduleNext() {
	      if (this.useRequestAnimationFrame && typeof window !== 'undefined') {
	        window.requestAnimationFrame(this._nextBound);
	      } else {
	        Promise.resolve(undefined).then(this._nextBound);
	      }
	    },
	    _next: function InternalRenderTask__next() {
	      if (this.cancelled) {
	        return;
	      }
	      this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
	      if (this.operatorListIdx === this.operatorList.argsArray.length) {
	        this.running = false;
	        if (this.operatorList.lastChunk) {
	          this.gfx.endDrawing();
	          if (this._canvas) {
	            canvasInRendering.delete(this._canvas);
	          }
	          this.callback();
	        }
	      }
	    }
	  };
	  return InternalRenderTask;
	}();
	var version, build;
	{
	  exports.version = version = '2.0.305';
	  exports.build = build = '9c6a8801';
	}
	exports.getDocument = getDocument;
	exports.LoopbackPort = LoopbackPort;
	exports.PDFDataRangeTransport = PDFDataRangeTransport;
	exports.PDFWorker = PDFWorker;
	exports.PDFDocumentProxy = PDFDocumentProxy;
	exports.PDFPageProxy = PDFPageProxy;
	exports.setPDFNetworkStreamFactory = setPDFNetworkStreamFactory;
	exports.version = version;
	exports.build = build;

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Metadata = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __webpack_require__(14);
	
	var _dom_utils = __webpack_require__(144);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Metadata = function () {
	  function Metadata(data) {
	    _classCallCheck(this, Metadata);
	
	    (0, _util.assert)(typeof data === 'string', 'Metadata: input is not a string');
	    data = this._repair(data);
	    var parser = new _dom_utils.SimpleXMLParser();
	    data = parser.parseFromString(data);
	    this._metadata = Object.create(null);
	    this._parse(data);
	  }
	
	  _createClass(Metadata, [{
	    key: '_repair',
	    value: function _repair(data) {
	      return data.replace(/>\\376\\377([^<]+)/g, function (all, codes) {
	        var bytes = codes.replace(/\\([0-3])([0-7])([0-7])/g, function (code, d1, d2, d3) {
	          return String.fromCharCode(d1 * 64 + d2 * 8 + d3 * 1);
	        }).replace(/&(amp|apos|gt|lt|quot);/g, function (str, name) {
	          switch (name) {
	            case 'amp':
	              return '&';
	            case 'apos':
	              return '\'';
	            case 'gt':
	              return '>';
	            case 'lt':
	              return '<';
	            case 'quot':
	              return '\"';
	          }
	          throw new Error('_repair: ' + name + ' isn\'t defined.');
	        });
	        var chars = '';
	        for (var i = 0, ii = bytes.length; i < ii; i += 2) {
	          var code = bytes.charCodeAt(i) * 256 + bytes.charCodeAt(i + 1);
	          if (code >= 32 && code < 127 && code !== 60 && code !== 62 && code !== 38) {
	            chars += String.fromCharCode(code);
	          } else {
	            chars += '&#x' + (0x10000 + code).toString(16).substring(1) + ';';
	          }
	        }
	        return '>' + chars;
	      });
	    }
	  }, {
	    key: '_parse',
	    value: function _parse(domDocument) {
	      var rdf = domDocument.documentElement;
	      if (rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
	        rdf = rdf.firstChild;
	        while (rdf && rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
	          rdf = rdf.nextSibling;
	        }
	      }
	      var nodeName = rdf ? rdf.nodeName.toLowerCase() : null;
	      if (!rdf || nodeName !== 'rdf:rdf' || !rdf.hasChildNodes()) {
	        return;
	      }
	      var children = rdf.childNodes;
	      for (var i = 0, ii = children.length; i < ii; i++) {
	        var desc = children[i];
	        if (desc.nodeName.toLowerCase() !== 'rdf:description') {
	          continue;
	        }
	        for (var j = 0, jj = desc.childNodes.length; j < jj; j++) {
	          if (desc.childNodes[j].nodeName.toLowerCase() !== '#text') {
	            var entry = desc.childNodes[j];
	            var name = entry.nodeName.toLowerCase();
	            this._metadata[name] = entry.textContent.trim();
	          }
	        }
	      }
	    }
	  }, {
	    key: 'get',
	    value: function get(name) {
	      return this._metadata[name] || null;
	    }
	  }, {
	    key: 'getAll',
	    value: function getAll() {
	      return this._metadata;
	    }
	  }, {
	    key: 'has',
	    value: function has(name) {
	      return typeof this._metadata[name] !== 'undefined';
	    }
	  }]);
	
	  return Metadata;
	}();
	
	exports.Metadata = Metadata;

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, Buffer) {/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SVGGraphics = undefined;
	
	var _util = __webpack_require__(14);
	
	var _dom_utils = __webpack_require__(144);
	
	var _is_node = __webpack_require__(285);
	
	var _is_node2 = _interopRequireDefault(_is_node);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SVGGraphics = function SVGGraphics() {
	  throw new Error('Not implemented: SVGGraphics');
	};
	{
	  var SVG_DEFAULTS = {
	    fontStyle: 'normal',
	    fontWeight: 'normal',
	    fillColor: '#000000'
	  };
	  var convertImgDataToPng = function convertImgDataToPngClosure() {
	    var PNG_HEADER = new Uint8Array([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]);
	    var CHUNK_WRAPPER_SIZE = 12;
	    var crcTable = new Int32Array(256);
	    for (var i = 0; i < 256; i++) {
	      var c = i;
	      for (var h = 0; h < 8; h++) {
	        if (c & 1) {
	          c = 0xedB88320 ^ c >> 1 & 0x7fffffff;
	        } else {
	          c = c >> 1 & 0x7fffffff;
	        }
	      }
	      crcTable[i] = c;
	    }
	    function crc32(data, start, end) {
	      var crc = -1;
	      for (var i = start; i < end; i++) {
	        var a = (crc ^ data[i]) & 0xff;
	        var b = crcTable[a];
	        crc = crc >>> 8 ^ b;
	      }
	      return crc ^ -1;
	    }
	    function writePngChunk(type, body, data, offset) {
	      var p = offset;
	      var len = body.length;
	      data[p] = len >> 24 & 0xff;
	      data[p + 1] = len >> 16 & 0xff;
	      data[p + 2] = len >> 8 & 0xff;
	      data[p + 3] = len & 0xff;
	      p += 4;
	      data[p] = type.charCodeAt(0) & 0xff;
	      data[p + 1] = type.charCodeAt(1) & 0xff;
	      data[p + 2] = type.charCodeAt(2) & 0xff;
	      data[p + 3] = type.charCodeAt(3) & 0xff;
	      p += 4;
	      data.set(body, p);
	      p += body.length;
	      var crc = crc32(data, offset + 4, p);
	      data[p] = crc >> 24 & 0xff;
	      data[p + 1] = crc >> 16 & 0xff;
	      data[p + 2] = crc >> 8 & 0xff;
	      data[p + 3] = crc & 0xff;
	    }
	    function adler32(data, start, end) {
	      var a = 1;
	      var b = 0;
	      for (var i = start; i < end; ++i) {
	        a = (a + (data[i] & 0xff)) % 65521;
	        b = (b + a) % 65521;
	      }
	      return b << 16 | a;
	    }
	    function deflateSync(literals) {
	      if (!(0, _is_node2.default)()) {
	        return deflateSyncUncompressed(literals);
	      }
	      try {
	        var input;
	        if (parseInt(process.versions.node) >= 8) {
	          input = literals;
	        } else {
	          input = new Buffer(literals);
	        }
	        var output = __webpack_require__(513).deflateSync(input, { level: 9 });
	        return output instanceof Uint8Array ? output : new Uint8Array(output);
	      } catch (e) {
	        (0, _util.warn)('Not compressing PNG because zlib.deflateSync is unavailable: ' + e);
	      }
	      return deflateSyncUncompressed(literals);
	    }
	    function deflateSyncUncompressed(literals) {
	      var len = literals.length;
	      var maxBlockLength = 0xFFFF;
	      var deflateBlocks = Math.ceil(len / maxBlockLength);
	      var idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
	      var pi = 0;
	      idat[pi++] = 0x78;
	      idat[pi++] = 0x9c;
	      var pos = 0;
	      while (len > maxBlockLength) {
	        idat[pi++] = 0x00;
	        idat[pi++] = 0xff;
	        idat[pi++] = 0xff;
	        idat[pi++] = 0x00;
	        idat[pi++] = 0x00;
	        idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
	        pi += maxBlockLength;
	        pos += maxBlockLength;
	        len -= maxBlockLength;
	      }
	      idat[pi++] = 0x01;
	      idat[pi++] = len & 0xff;
	      idat[pi++] = len >> 8 & 0xff;
	      idat[pi++] = ~len & 0xffff & 0xff;
	      idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
	      idat.set(literals.subarray(pos), pi);
	      pi += literals.length - pos;
	      var adler = adler32(literals, 0, literals.length);
	      idat[pi++] = adler >> 24 & 0xff;
	      idat[pi++] = adler >> 16 & 0xff;
	      idat[pi++] = adler >> 8 & 0xff;
	      idat[pi++] = adler & 0xff;
	      return idat;
	    }
	    function encode(imgData, kind, forceDataSchema, isMask) {
	      var width = imgData.width;
	      var height = imgData.height;
	      var bitDepth, colorType, lineSize;
	      var bytes = imgData.data;
	      switch (kind) {
	        case _util.ImageKind.GRAYSCALE_1BPP:
	          colorType = 0;
	          bitDepth = 1;
	          lineSize = width + 7 >> 3;
	          break;
	        case _util.ImageKind.RGB_24BPP:
	          colorType = 2;
	          bitDepth = 8;
	          lineSize = width * 3;
	          break;
	        case _util.ImageKind.RGBA_32BPP:
	          colorType = 6;
	          bitDepth = 8;
	          lineSize = width * 4;
	          break;
	        default:
	          throw new Error('invalid format');
	      }
	      var literals = new Uint8Array((1 + lineSize) * height);
	      var offsetLiterals = 0,
	          offsetBytes = 0;
	      var y, i;
	      for (y = 0; y < height; ++y) {
	        literals[offsetLiterals++] = 0;
	        literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
	        offsetBytes += lineSize;
	        offsetLiterals += lineSize;
	      }
	      if (kind === _util.ImageKind.GRAYSCALE_1BPP && isMask) {
	        offsetLiterals = 0;
	        for (y = 0; y < height; y++) {
	          offsetLiterals++;
	          for (i = 0; i < lineSize; i++) {
	            literals[offsetLiterals++] ^= 0xFF;
	          }
	        }
	      }
	      var ihdr = new Uint8Array([width >> 24 & 0xff, width >> 16 & 0xff, width >> 8 & 0xff, width & 0xff, height >> 24 & 0xff, height >> 16 & 0xff, height >> 8 & 0xff, height & 0xff, bitDepth, colorType, 0x00, 0x00, 0x00]);
	      var idat = deflateSync(literals);
	      var pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
	      var data = new Uint8Array(pngLength);
	      var offset = 0;
	      data.set(PNG_HEADER, offset);
	      offset += PNG_HEADER.length;
	      writePngChunk('IHDR', ihdr, data, offset);
	      offset += CHUNK_WRAPPER_SIZE + ihdr.length;
	      writePngChunk('IDATA', idat, data, offset);
	      offset += CHUNK_WRAPPER_SIZE + idat.length;
	      writePngChunk('IEND', new Uint8Array(0), data, offset);
	      return (0, _util.createObjectURL)(data, 'image/png', forceDataSchema);
	    }
	    return function convertImgDataToPng(imgData, forceDataSchema, isMask) {
	      var kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
	      return encode(imgData, kind, forceDataSchema, isMask);
	    };
	  }();
	  var SVGExtraState = function SVGExtraStateClosure() {
	    function SVGExtraState() {
	      this.fontSizeScale = 1;
	      this.fontWeight = SVG_DEFAULTS.fontWeight;
	      this.fontSize = 0;
	      this.textMatrix = _util.IDENTITY_MATRIX;
	      this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
	      this.leading = 0;
	      this.x = 0;
	      this.y = 0;
	      this.lineX = 0;
	      this.lineY = 0;
	      this.charSpacing = 0;
	      this.wordSpacing = 0;
	      this.textHScale = 1;
	      this.textRise = 0;
	      this.fillColor = SVG_DEFAULTS.fillColor;
	      this.strokeColor = '#000000';
	      this.fillAlpha = 1;
	      this.strokeAlpha = 1;
	      this.lineWidth = 1;
	      this.lineJoin = '';
	      this.lineCap = '';
	      this.miterLimit = 0;
	      this.dashArray = [];
	      this.dashPhase = 0;
	      this.dependencies = [];
	      this.activeClipUrl = null;
	      this.clipGroup = null;
	      this.maskId = '';
	    }
	    SVGExtraState.prototype = {
	      clone: function SVGExtraState_clone() {
	        return Object.create(this);
	      },
	      setCurrentPoint: function SVGExtraState_setCurrentPoint(x, y) {
	        this.x = x;
	        this.y = y;
	      }
	    };
	    return SVGExtraState;
	  }();
	  exports.SVGGraphics = SVGGraphics = function SVGGraphicsClosure() {
	    function opListToTree(opList) {
	      var opTree = [];
	      var tmp = [];
	      var opListLen = opList.length;
	      for (var x = 0; x < opListLen; x++) {
	        if (opList[x].fn === 'save') {
	          opTree.push({
	            'fnId': 92,
	            'fn': 'group',
	            'items': []
	          });
	          tmp.push(opTree);
	          opTree = opTree[opTree.length - 1].items;
	          continue;
	        }
	        if (opList[x].fn === 'restore') {
	          opTree = tmp.pop();
	        } else {
	          opTree.push(opList[x]);
	        }
	      }
	      return opTree;
	    }
	    function pf(value) {
	      if (Number.isInteger(value)) {
	        return value.toString();
	      }
	      var s = value.toFixed(10);
	      var i = s.length - 1;
	      if (s[i] !== '0') {
	        return s;
	      }
	      do {
	        i--;
	      } while (s[i] === '0');
	      return s.substr(0, s[i] === '.' ? i : i + 1);
	    }
	    function pm(m) {
	      if (m[4] === 0 && m[5] === 0) {
	        if (m[1] === 0 && m[2] === 0) {
	          if (m[0] === 1 && m[3] === 1) {
	            return '';
	          }
	          return 'scale(' + pf(m[0]) + ' ' + pf(m[3]) + ')';
	        }
	        if (m[0] === m[3] && m[1] === -m[2]) {
	          var a = Math.acos(m[0]) * 180 / Math.PI;
	          return 'rotate(' + pf(a) + ')';
	        }
	      } else {
	        if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) {
	          return 'translate(' + pf(m[4]) + ' ' + pf(m[5]) + ')';
	        }
	      }
	      return 'matrix(' + pf(m[0]) + ' ' + pf(m[1]) + ' ' + pf(m[2]) + ' ' + pf(m[3]) + ' ' + pf(m[4]) + ' ' + pf(m[5]) + ')';
	    }
	    function SVGGraphics(commonObjs, objs, forceDataSchema) {
	      this.svgFactory = new _dom_utils.DOMSVGFactory();
	      this.current = new SVGExtraState();
	      this.transformMatrix = _util.IDENTITY_MATRIX;
	      this.transformStack = [];
	      this.extraStack = [];
	      this.commonObjs = commonObjs;
	      this.objs = objs;
	      this.pendingClip = null;
	      this.pendingEOFill = false;
	      this.embedFonts = false;
	      this.embeddedFonts = Object.create(null);
	      this.cssStyle = null;
	      this.forceDataSchema = !!forceDataSchema;
	    }
	    var XML_NS = 'http://www.w3.org/XML/1998/namespace';
	    var XLINK_NS = 'http://www.w3.org/1999/xlink';
	    var LINE_CAP_STYLES = ['butt', 'round', 'square'];
	    var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
	    var clipCount = 0;
	    var maskCount = 0;
	    SVGGraphics.prototype = {
	      save: function SVGGraphics_save() {
	        this.transformStack.push(this.transformMatrix);
	        var old = this.current;
	        this.extraStack.push(old);
	        this.current = old.clone();
	      },
	      restore: function SVGGraphics_restore() {
	        this.transformMatrix = this.transformStack.pop();
	        this.current = this.extraStack.pop();
	        this.pendingClip = null;
	        this.tgrp = null;
	      },
	      group: function SVGGraphics_group(items) {
	        this.save();
	        this.executeOpTree(items);
	        this.restore();
	      },
	      loadDependencies: function SVGGraphics_loadDependencies(operatorList) {
	        var _this = this;
	
	        var fnArray = operatorList.fnArray;
	        var fnArrayLen = fnArray.length;
	        var argsArray = operatorList.argsArray;
	        for (var i = 0; i < fnArrayLen; i++) {
	          if (_util.OPS.dependency === fnArray[i]) {
	            var deps = argsArray[i];
	            for (var n = 0, nn = deps.length; n < nn; n++) {
	              var obj = deps[n];
	              var common = obj.substring(0, 2) === 'g_';
	              var promise;
	              if (common) {
	                promise = new Promise(function (resolve) {
	                  _this.commonObjs.get(obj, resolve);
	                });
	              } else {
	                promise = new Promise(function (resolve) {
	                  _this.objs.get(obj, resolve);
	                });
	              }
	              this.current.dependencies.push(promise);
	            }
	          }
	        }
	        return Promise.all(this.current.dependencies);
	      },
	      transform: function SVGGraphics_transform(a, b, c, d, e, f) {
	        var transformMatrix = [a, b, c, d, e, f];
	        this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
	        this.tgrp = null;
	      },
	      getSVG: function SVGGraphics_getSVG(operatorList, viewport) {
	        var _this2 = this;
	
	        this.viewport = viewport;
	        var svgElement = this._initialize(viewport);
	        return this.loadDependencies(operatorList).then(function () {
	          _this2.transformMatrix = _util.IDENTITY_MATRIX;
	          var opTree = _this2.convertOpList(operatorList);
	          _this2.executeOpTree(opTree);
	          return svgElement;
	        });
	      },
	      convertOpList: function SVGGraphics_convertOpList(operatorList) {
	        var argsArray = operatorList.argsArray;
	        var fnArray = operatorList.fnArray;
	        var fnArrayLen = fnArray.length;
	        var REVOPS = [];
	        var opList = [];
	        for (var op in _util.OPS) {
	          REVOPS[_util.OPS[op]] = op;
	        }
	        for (var x = 0; x < fnArrayLen; x++) {
	          var fnId = fnArray[x];
	          opList.push({
	            'fnId': fnId,
	            'fn': REVOPS[fnId],
	            'args': argsArray[x]
	          });
	        }
	        return opListToTree(opList);
	      },
	      executeOpTree: function SVGGraphics_executeOpTree(opTree) {
	        var opTreeLen = opTree.length;
	        for (var x = 0; x < opTreeLen; x++) {
	          var fn = opTree[x].fn;
	          var fnId = opTree[x].fnId;
	          var args = opTree[x].args;
	          switch (fnId | 0) {
	            case _util.OPS.beginText:
	              this.beginText();
	              break;
	            case _util.OPS.setLeading:
	              this.setLeading(args);
	              break;
	            case _util.OPS.setLeadingMoveText:
	              this.setLeadingMoveText(args[0], args[1]);
	              break;
	            case _util.OPS.setFont:
	              this.setFont(args);
	              break;
	            case _util.OPS.showText:
	              this.showText(args[0]);
	              break;
	            case _util.OPS.showSpacedText:
	              this.showText(args[0]);
	              break;
	            case _util.OPS.endText:
	              this.endText();
	              break;
	            case _util.OPS.moveText:
	              this.moveText(args[0], args[1]);
	              break;
	            case _util.OPS.setCharSpacing:
	              this.setCharSpacing(args[0]);
	              break;
	            case _util.OPS.setWordSpacing:
	              this.setWordSpacing(args[0]);
	              break;
	            case _util.OPS.setHScale:
	              this.setHScale(args[0]);
	              break;
	            case _util.OPS.setTextMatrix:
	              this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
	              break;
	            case _util.OPS.setTextRise:
	              this.setTextRise(args[0]);
	              break;
	            case _util.OPS.setLineWidth:
	              this.setLineWidth(args[0]);
	              break;
	            case _util.OPS.setLineJoin:
	              this.setLineJoin(args[0]);
	              break;
	            case _util.OPS.setLineCap:
	              this.setLineCap(args[0]);
	              break;
	            case _util.OPS.setMiterLimit:
	              this.setMiterLimit(args[0]);
	              break;
	            case _util.OPS.setFillRGBColor:
	              this.setFillRGBColor(args[0], args[1], args[2]);
	              break;
	            case _util.OPS.setStrokeRGBColor:
	              this.setStrokeRGBColor(args[0], args[1], args[2]);
	              break;
	            case _util.OPS.setDash:
	              this.setDash(args[0], args[1]);
	              break;
	            case _util.OPS.setGState:
	              this.setGState(args[0]);
	              break;
	            case _util.OPS.fill:
	              this.fill();
	              break;
	            case _util.OPS.eoFill:
	              this.eoFill();
	              break;
	            case _util.OPS.stroke:
	              this.stroke();
	              break;
	            case _util.OPS.fillStroke:
	              this.fillStroke();
	              break;
	            case _util.OPS.eoFillStroke:
	              this.eoFillStroke();
	              break;
	            case _util.OPS.clip:
	              this.clip('nonzero');
	              break;
	            case _util.OPS.eoClip:
	              this.clip('evenodd');
	              break;
	            case _util.OPS.paintSolidColorImageMask:
	              this.paintSolidColorImageMask();
	              break;
	            case _util.OPS.paintJpegXObject:
	              this.paintJpegXObject(args[0], args[1], args[2]);
	              break;
	            case _util.OPS.paintImageXObject:
	              this.paintImageXObject(args[0]);
	              break;
	            case _util.OPS.paintInlineImageXObject:
	              this.paintInlineImageXObject(args[0]);
	              break;
	            case _util.OPS.paintImageMaskXObject:
	              this.paintImageMaskXObject(args[0]);
	              break;
	            case _util.OPS.paintFormXObjectBegin:
	              this.paintFormXObjectBegin(args[0], args[1]);
	              break;
	            case _util.OPS.paintFormXObjectEnd:
	              this.paintFormXObjectEnd();
	              break;
	            case _util.OPS.closePath:
	              this.closePath();
	              break;
	            case _util.OPS.closeStroke:
	              this.closeStroke();
	              break;
	            case _util.OPS.closeFillStroke:
	              this.closeFillStroke();
	              break;
	            case _util.OPS.closeEOFillStroke:
	              this.closeEOFillStroke();
	              break;
	            case _util.OPS.nextLine:
	              this.nextLine();
	              break;
	            case _util.OPS.transform:
	              this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
	              break;
	            case _util.OPS.constructPath:
	              this.constructPath(args[0], args[1]);
	              break;
	            case _util.OPS.endPath:
	              this.endPath();
	              break;
	            case 92:
	              this.group(opTree[x].items);
	              break;
	            default:
	              (0, _util.warn)('Unimplemented operator ' + fn);
	              break;
	          }
	        }
	      },
	      setWordSpacing: function SVGGraphics_setWordSpacing(wordSpacing) {
	        this.current.wordSpacing = wordSpacing;
	      },
	      setCharSpacing: function SVGGraphics_setCharSpacing(charSpacing) {
	        this.current.charSpacing = charSpacing;
	      },
	      nextLine: function SVGGraphics_nextLine() {
	        this.moveText(0, this.current.leading);
	      },
	      setTextMatrix: function SVGGraphics_setTextMatrix(a, b, c, d, e, f) {
	        var current = this.current;
	        this.current.textMatrix = this.current.lineMatrix = [a, b, c, d, e, f];
	        this.current.x = this.current.lineX = 0;
	        this.current.y = this.current.lineY = 0;
	        current.xcoords = [];
	        current.tspan = this.svgFactory.createElement('svg:tspan');
	        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
	        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	        current.txtElement = this.svgFactory.createElement('svg:text');
	        current.txtElement.appendChild(current.tspan);
	      },
	      beginText: function SVGGraphics_beginText() {
	        this.current.x = this.current.lineX = 0;
	        this.current.y = this.current.lineY = 0;
	        this.current.textMatrix = _util.IDENTITY_MATRIX;
	        this.current.lineMatrix = _util.IDENTITY_MATRIX;
	        this.current.tspan = this.svgFactory.createElement('svg:tspan');
	        this.current.txtElement = this.svgFactory.createElement('svg:text');
	        this.current.txtgrp = this.svgFactory.createElement('svg:g');
	        this.current.xcoords = [];
	      },
	      moveText: function SVGGraphics_moveText(x, y) {
	        var current = this.current;
	        this.current.x = this.current.lineX += x;
	        this.current.y = this.current.lineY += y;
	        current.xcoords = [];
	        current.tspan = this.svgFactory.createElement('svg:tspan');
	        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
	        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	      },
	      showText: function SVGGraphics_showText(glyphs) {
	        var current = this.current;
	        var font = current.font;
	        var fontSize = current.fontSize;
	        if (fontSize === 0) {
	          return;
	        }
	        var charSpacing = current.charSpacing;
	        var wordSpacing = current.wordSpacing;
	        var fontDirection = current.fontDirection;
	        var textHScale = current.textHScale * fontDirection;
	        var glyphsLength = glyphs.length;
	        var vertical = font.vertical;
	        var widthAdvanceScale = fontSize * current.fontMatrix[0];
	        var x = 0,
	            i;
	        for (i = 0; i < glyphsLength; ++i) {
	          var glyph = glyphs[i];
	          if (glyph === null) {
	            x += fontDirection * wordSpacing;
	            continue;
	          } else if ((0, _util.isNum)(glyph)) {
	            x += -glyph * fontSize * 0.001;
	            continue;
	          }
	          var width = glyph.width;
	          var character = glyph.fontChar;
	          var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
	          var charWidth = width * widthAdvanceScale + spacing * fontDirection;
	          if (!glyph.isInFont && !font.missingFile) {
	            x += charWidth;
	            continue;
	          }
	          current.xcoords.push(current.x + x * textHScale);
	          current.tspan.textContent += character;
	          x += charWidth;
	        }
	        if (vertical) {
	          current.y -= x * textHScale;
	        } else {
	          current.x += x * textHScale;
	        }
	        current.tspan.setAttributeNS(null, 'x', current.xcoords.map(pf).join(' '));
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
	        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
	        if (current.fontStyle !== SVG_DEFAULTS.fontStyle) {
	          current.tspan.setAttributeNS(null, 'font-style', current.fontStyle);
	        }
	        if (current.fontWeight !== SVG_DEFAULTS.fontWeight) {
	          current.tspan.setAttributeNS(null, 'font-weight', current.fontWeight);
	        }
	        if (current.fillColor !== SVG_DEFAULTS.fillColor) {
	          current.tspan.setAttributeNS(null, 'fill', current.fillColor);
	        }
	        var textMatrix = current.textMatrix;
	        if (current.textRise !== 0) {
	          textMatrix = textMatrix.slice();
	          textMatrix[5] += current.textRise;
	        }
	        current.txtElement.setAttributeNS(null, 'transform', pm(textMatrix) + ' scale(1, -1)');
	        current.txtElement.setAttributeNS(XML_NS, 'xml:space', 'preserve');
	        current.txtElement.appendChild(current.tspan);
	        current.txtgrp.appendChild(current.txtElement);
	        this._ensureTransformGroup().appendChild(current.txtElement);
	      },
	      setLeadingMoveText: function SVGGraphics_setLeadingMoveText(x, y) {
	        this.setLeading(-y);
	        this.moveText(x, y);
	      },
	      addFontStyle: function SVGGraphics_addFontStyle(fontObj) {
	        if (!this.cssStyle) {
	          this.cssStyle = this.svgFactory.createElement('svg:style');
	          this.cssStyle.setAttributeNS(null, 'type', 'text/css');
	          this.defs.appendChild(this.cssStyle);
	        }
	        var url = (0, _util.createObjectURL)(fontObj.data, fontObj.mimetype, this.forceDataSchema);
	        this.cssStyle.textContent += '@font-face { font-family: "' + fontObj.loadedName + '";' + ' src: url(' + url + '); }\n';
	      },
	      setFont: function SVGGraphics_setFont(details) {
	        var current = this.current;
	        var fontObj = this.commonObjs.get(details[0]);
	        var size = details[1];
	        this.current.font = fontObj;
	        if (this.embedFonts && fontObj.data && !this.embeddedFonts[fontObj.loadedName]) {
	          this.addFontStyle(fontObj);
	          this.embeddedFonts[fontObj.loadedName] = fontObj;
	        }
	        current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
	        var bold = fontObj.black ? fontObj.bold ? 'bolder' : 'bold' : fontObj.bold ? 'bold' : 'normal';
	        var italic = fontObj.italic ? 'italic' : 'normal';
	        if (size < 0) {
	          size = -size;
	          current.fontDirection = -1;
	        } else {
	          current.fontDirection = 1;
	        }
	        current.fontSize = size;
	        current.fontFamily = fontObj.loadedName;
	        current.fontWeight = bold;
	        current.fontStyle = italic;
	        current.tspan = this.svgFactory.createElement('svg:tspan');
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	        current.xcoords = [];
	      },
	      endText: function SVGGraphics_endText() {},
	      setLineWidth: function SVGGraphics_setLineWidth(width) {
	        this.current.lineWidth = width;
	      },
	      setLineCap: function SVGGraphics_setLineCap(style) {
	        this.current.lineCap = LINE_CAP_STYLES[style];
	      },
	      setLineJoin: function SVGGraphics_setLineJoin(style) {
	        this.current.lineJoin = LINE_JOIN_STYLES[style];
	      },
	      setMiterLimit: function SVGGraphics_setMiterLimit(limit) {
	        this.current.miterLimit = limit;
	      },
	      setStrokeAlpha: function SVGGraphics_setStrokeAlpha(strokeAlpha) {
	        this.current.strokeAlpha = strokeAlpha;
	      },
	      setStrokeRGBColor: function SVGGraphics_setStrokeRGBColor(r, g, b) {
	        var color = _util.Util.makeCssRgb(r, g, b);
	        this.current.strokeColor = color;
	      },
	      setFillAlpha: function SVGGraphics_setFillAlpha(fillAlpha) {
	        this.current.fillAlpha = fillAlpha;
	      },
	      setFillRGBColor: function SVGGraphics_setFillRGBColor(r, g, b) {
	        var color = _util.Util.makeCssRgb(r, g, b);
	        this.current.fillColor = color;
	        this.current.tspan = this.svgFactory.createElement('svg:tspan');
	        this.current.xcoords = [];
	      },
	      setDash: function SVGGraphics_setDash(dashArray, dashPhase) {
	        this.current.dashArray = dashArray;
	        this.current.dashPhase = dashPhase;
	      },
	      constructPath: function SVGGraphics_constructPath(ops, args) {
	        var current = this.current;
	        var x = current.x,
	            y = current.y;
	        current.path = this.svgFactory.createElement('svg:path');
	        var d = [];
	        var opLength = ops.length;
	        for (var i = 0, j = 0; i < opLength; i++) {
	          switch (ops[i] | 0) {
	            case _util.OPS.rectangle:
	              x = args[j++];
	              y = args[j++];
	              var width = args[j++];
	              var height = args[j++];
	              var xw = x + width;
	              var yh = y + height;
	              d.push('M', pf(x), pf(y), 'L', pf(xw), pf(y), 'L', pf(xw), pf(yh), 'L', pf(x), pf(yh), 'Z');
	              break;
	            case _util.OPS.moveTo:
	              x = args[j++];
	              y = args[j++];
	              d.push('M', pf(x), pf(y));
	              break;
	            case _util.OPS.lineTo:
	              x = args[j++];
	              y = args[j++];
	              d.push('L', pf(x), pf(y));
	              break;
	            case _util.OPS.curveTo:
	              x = args[j + 4];
	              y = args[j + 5];
	              d.push('C', pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
	              j += 6;
	              break;
	            case _util.OPS.curveTo2:
	              x = args[j + 2];
	              y = args[j + 3];
	              d.push('C', pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
	              j += 4;
	              break;
	            case _util.OPS.curveTo3:
	              x = args[j + 2];
	              y = args[j + 3];
	              d.push('C', pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
	              j += 4;
	              break;
	            case _util.OPS.closePath:
	              d.push('Z');
	              break;
	          }
	        }
	        current.path.setAttributeNS(null, 'd', d.join(' '));
	        current.path.setAttributeNS(null, 'fill', 'none');
	        this._ensureTransformGroup().appendChild(current.path);
	        current.element = current.path;
	        current.setCurrentPoint(x, y);
	      },
	      endPath: function SVGGraphics_endPath() {
	        if (!this.pendingClip) {
	          return;
	        }
	        var current = this.current;
	        var clipId = 'clippath' + clipCount;
	        clipCount++;
	        var clipPath = this.svgFactory.createElement('svg:clipPath');
	        clipPath.setAttributeNS(null, 'id', clipId);
	        clipPath.setAttributeNS(null, 'transform', pm(this.transformMatrix));
	        var clipElement = current.element.cloneNode();
	        if (this.pendingClip === 'evenodd') {
	          clipElement.setAttributeNS(null, 'clip-rule', 'evenodd');
	        } else {
	          clipElement.setAttributeNS(null, 'clip-rule', 'nonzero');
	        }
	        this.pendingClip = null;
	        clipPath.appendChild(clipElement);
	        this.defs.appendChild(clipPath);
	        if (current.activeClipUrl) {
	          current.clipGroup = null;
	          this.extraStack.forEach(function (prev) {
	            prev.clipGroup = null;
	          });
	        }
	        current.activeClipUrl = 'url(#' + clipId + ')';
	        this.tgrp = null;
	      },
	      clip: function SVGGraphics_clip(type) {
	        this.pendingClip = type;
	      },
	      closePath: function SVGGraphics_closePath() {
	        var current = this.current;
	        if (current.path) {
	          var d = current.path.getAttributeNS(null, 'd');
	          d += 'Z';
	          current.path.setAttributeNS(null, 'd', d);
	        }
	      },
	      setLeading: function SVGGraphics_setLeading(leading) {
	        this.current.leading = -leading;
	      },
	      setTextRise: function SVGGraphics_setTextRise(textRise) {
	        this.current.textRise = textRise;
	      },
	      setHScale: function SVGGraphics_setHScale(scale) {
	        this.current.textHScale = scale / 100;
	      },
	      setGState: function SVGGraphics_setGState(states) {
	        for (var i = 0, ii = states.length; i < ii; i++) {
	          var state = states[i];
	          var key = state[0];
	          var value = state[1];
	          switch (key) {
	            case 'LW':
	              this.setLineWidth(value);
	              break;
	            case 'LC':
	              this.setLineCap(value);
	              break;
	            case 'LJ':
	              this.setLineJoin(value);
	              break;
	            case 'ML':
	              this.setMiterLimit(value);
	              break;
	            case 'D':
	              this.setDash(value[0], value[1]);
	              break;
	            case 'Font':
	              this.setFont(value);
	              break;
	            case 'CA':
	              this.setStrokeAlpha(value);
	              break;
	            case 'ca':
	              this.setFillAlpha(value);
	              break;
	            default:
	              (0, _util.warn)('Unimplemented graphic state ' + key);
	              break;
	          }
	        }
	      },
	      fill: function SVGGraphics_fill() {
	        var current = this.current;
	        if (current.element) {
	          current.element.setAttributeNS(null, 'fill', current.fillColor);
	          current.element.setAttributeNS(null, 'fill-opacity', current.fillAlpha);
	        }
	      },
	      stroke: function SVGGraphics_stroke() {
	        var current = this.current;
	        if (current.element) {
	          current.element.setAttributeNS(null, 'stroke', current.strokeColor);
	          current.element.setAttributeNS(null, 'stroke-opacity', current.strokeAlpha);
	          current.element.setAttributeNS(null, 'stroke-miterlimit', pf(current.miterLimit));
	          current.element.setAttributeNS(null, 'stroke-linecap', current.lineCap);
	          current.element.setAttributeNS(null, 'stroke-linejoin', current.lineJoin);
	          current.element.setAttributeNS(null, 'stroke-width', pf(current.lineWidth) + 'px');
	          current.element.setAttributeNS(null, 'stroke-dasharray', current.dashArray.map(pf).join(' '));
	          current.element.setAttributeNS(null, 'stroke-dashoffset', pf(current.dashPhase) + 'px');
	          current.element.setAttributeNS(null, 'fill', 'none');
	        }
	      },
	      eoFill: function SVGGraphics_eoFill() {
	        if (this.current.element) {
	          this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
	        }
	        this.fill();
	      },
	      fillStroke: function SVGGraphics_fillStroke() {
	        this.stroke();
	        this.fill();
	      },
	      eoFillStroke: function SVGGraphics_eoFillStroke() {
	        if (this.current.element) {
	          this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
	        }
	        this.fillStroke();
	      },
	      closeStroke: function SVGGraphics_closeStroke() {
	        this.closePath();
	        this.stroke();
	      },
	      closeFillStroke: function SVGGraphics_closeFillStroke() {
	        this.closePath();
	        this.fillStroke();
	      },
	      closeEOFillStroke: function closeEOFillStroke() {
	        this.closePath();
	        this.eoFillStroke();
	      },
	
	      paintSolidColorImageMask: function SVGGraphics_paintSolidColorImageMask() {
	        var current = this.current;
	        var rect = this.svgFactory.createElement('svg:rect');
	        rect.setAttributeNS(null, 'x', '0');
	        rect.setAttributeNS(null, 'y', '0');
	        rect.setAttributeNS(null, 'width', '1px');
	        rect.setAttributeNS(null, 'height', '1px');
	        rect.setAttributeNS(null, 'fill', current.fillColor);
	        this._ensureTransformGroup().appendChild(rect);
	      },
	      paintJpegXObject: function SVGGraphics_paintJpegXObject(objId, w, h) {
	        var imgObj = this.objs.get(objId);
	        var imgEl = this.svgFactory.createElement('svg:image');
	        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgObj.src);
	        imgEl.setAttributeNS(null, 'width', pf(w));
	        imgEl.setAttributeNS(null, 'height', pf(h));
	        imgEl.setAttributeNS(null, 'x', '0');
	        imgEl.setAttributeNS(null, 'y', pf(-h));
	        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / w) + ' ' + pf(-1 / h) + ')');
	        this._ensureTransformGroup().appendChild(imgEl);
	      },
	      paintImageXObject: function SVGGraphics_paintImageXObject(objId) {
	        var imgData = this.objs.get(objId);
	        if (!imgData) {
	          (0, _util.warn)('Dependent image isn\'t ready yet');
	          return;
	        }
	        this.paintInlineImageXObject(imgData);
	      },
	      paintInlineImageXObject: function SVGGraphics_paintInlineImageXObject(imgData, mask) {
	        var width = imgData.width;
	        var height = imgData.height;
	        var imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
	        var cliprect = this.svgFactory.createElement('svg:rect');
	        cliprect.setAttributeNS(null, 'x', '0');
	        cliprect.setAttributeNS(null, 'y', '0');
	        cliprect.setAttributeNS(null, 'width', pf(width));
	        cliprect.setAttributeNS(null, 'height', pf(height));
	        this.current.element = cliprect;
	        this.clip('nonzero');
	        var imgEl = this.svgFactory.createElement('svg:image');
	        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgSrc);
	        imgEl.setAttributeNS(null, 'x', '0');
	        imgEl.setAttributeNS(null, 'y', pf(-height));
	        imgEl.setAttributeNS(null, 'width', pf(width) + 'px');
	        imgEl.setAttributeNS(null, 'height', pf(height) + 'px');
	        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / width) + ' ' + pf(-1 / height) + ')');
	        if (mask) {
	          mask.appendChild(imgEl);
	        } else {
	          this._ensureTransformGroup().appendChild(imgEl);
	        }
	      },
	      paintImageMaskXObject: function SVGGraphics_paintImageMaskXObject(imgData) {
	        var current = this.current;
	        var width = imgData.width;
	        var height = imgData.height;
	        var fillColor = current.fillColor;
	        current.maskId = 'mask' + maskCount++;
	        var mask = this.svgFactory.createElement('svg:mask');
	        mask.setAttributeNS(null, 'id', current.maskId);
	        var rect = this.svgFactory.createElement('svg:rect');
	        rect.setAttributeNS(null, 'x', '0');
	        rect.setAttributeNS(null, 'y', '0');
	        rect.setAttributeNS(null, 'width', pf(width));
	        rect.setAttributeNS(null, 'height', pf(height));
	        rect.setAttributeNS(null, 'fill', fillColor);
	        rect.setAttributeNS(null, 'mask', 'url(#' + current.maskId + ')');
	        this.defs.appendChild(mask);
	        this._ensureTransformGroup().appendChild(rect);
	        this.paintInlineImageXObject(imgData, mask);
	      },
	      paintFormXObjectBegin: function SVGGraphics_paintFormXObjectBegin(matrix, bbox) {
	        if (Array.isArray(matrix) && matrix.length === 6) {
	          this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
	        }
	        if (Array.isArray(bbox) && bbox.length === 4) {
	          var width = bbox[2] - bbox[0];
	          var height = bbox[3] - bbox[1];
	          var cliprect = this.svgFactory.createElement('svg:rect');
	          cliprect.setAttributeNS(null, 'x', bbox[0]);
	          cliprect.setAttributeNS(null, 'y', bbox[1]);
	          cliprect.setAttributeNS(null, 'width', pf(width));
	          cliprect.setAttributeNS(null, 'height', pf(height));
	          this.current.element = cliprect;
	          this.clip('nonzero');
	          this.endPath();
	        }
	      },
	      paintFormXObjectEnd: function SVGGraphics_paintFormXObjectEnd() {},
	      _initialize: function _initialize(viewport) {
	        var svg = this.svgFactory.create(viewport.width, viewport.height);
	        var definitions = this.svgFactory.createElement('svg:defs');
	        svg.appendChild(definitions);
	        this.defs = definitions;
	        var rootGroup = this.svgFactory.createElement('svg:g');
	        rootGroup.setAttributeNS(null, 'transform', pm(viewport.transform));
	        svg.appendChild(rootGroup);
	        this.svg = rootGroup;
	        return svg;
	      },
	
	      _ensureClipGroup: function SVGGraphics_ensureClipGroup() {
	        if (!this.current.clipGroup) {
	          var clipGroup = this.svgFactory.createElement('svg:g');
	          clipGroup.setAttributeNS(null, 'clip-path', this.current.activeClipUrl);
	          this.svg.appendChild(clipGroup);
	          this.current.clipGroup = clipGroup;
	        }
	        return this.current.clipGroup;
	      },
	      _ensureTransformGroup: function SVGGraphics_ensureTransformGroup() {
	        if (!this.tgrp) {
	          this.tgrp = this.svgFactory.createElement('svg:g');
	          this.tgrp.setAttributeNS(null, 'transform', pm(this.transformMatrix));
	          if (this.current.activeClipUrl) {
	            this._ensureClipGroup().appendChild(this.tgrp);
	          } else {
	            this.svg.appendChild(this.tgrp);
	          }
	        }
	        return this.tgrp;
	      }
	    };
	    return SVGGraphics;
	  }();
	}
	exports.SVGGraphics = SVGGraphics;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39), __webpack_require__(62).Buffer))

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderTextLayer = undefined;
	
	var _util = __webpack_require__(14);
	
	var _dom_utils = __webpack_require__(144);
	
	var renderTextLayer = function renderTextLayerClosure() {
	  var MAX_TEXT_DIVS_TO_RENDER = 100000;
	  var NonWhitespaceRegexp = /\S/;
	  function isAllWhitespace(str) {
	    return !NonWhitespaceRegexp.test(str);
	  }
	  var styleBuf = ['left: ', 0, 'px; top: ', 0, 'px; font-size: ', 0, 'px; font-family: ', '', ';'];
	  function appendText(task, geom, styles) {
	    var textDiv = document.createElement('div');
	    var textDivProperties = {
	      style: null,
	      angle: 0,
	      canvasWidth: 0,
	      isWhitespace: false,
	      originalTransform: null,
	      paddingBottom: 0,
	      paddingLeft: 0,
	      paddingRight: 0,
	      paddingTop: 0,
	      scale: 1
	    };
	    task._textDivs.push(textDiv);
	    if (isAllWhitespace(geom.str)) {
	      textDivProperties.isWhitespace = true;
	      task._textDivProperties.set(textDiv, textDivProperties);
	      return;
	    }
	    var tx = _util.Util.transform(task._viewport.transform, geom.transform);
	    var angle = Math.atan2(tx[1], tx[0]);
	    var style = styles[geom.fontName];
	    if (style.vertical) {
	      angle += Math.PI / 2;
	    }
	    var fontHeight = Math.sqrt(tx[2] * tx[2] + tx[3] * tx[3]);
	    var fontAscent = fontHeight;
	    if (style.ascent) {
	      fontAscent = style.ascent * fontAscent;
	    } else if (style.descent) {
	      fontAscent = (1 + style.descent) * fontAscent;
	    }
	    var left;
	    var top;
	    if (angle === 0) {
	      left = tx[4];
	      top = tx[5] - fontAscent;
	    } else {
	      left = tx[4] + fontAscent * Math.sin(angle);
	      top = tx[5] - fontAscent * Math.cos(angle);
	    }
	    styleBuf[1] = left;
	    styleBuf[3] = top;
	    styleBuf[5] = fontHeight;
	    styleBuf[7] = style.fontFamily;
	    textDivProperties.style = styleBuf.join('');
	    textDiv.setAttribute('style', textDivProperties.style);
	    textDiv.textContent = geom.str;
	    if ((0, _dom_utils.getDefaultSetting)('pdfBug')) {
	      textDiv.dataset.fontName = geom.fontName;
	    }
	    if (angle !== 0) {
	      textDivProperties.angle = angle * (180 / Math.PI);
	    }
	    if (geom.str.length > 1) {
	      if (style.vertical) {
	        textDivProperties.canvasWidth = geom.height * task._viewport.scale;
	      } else {
	        textDivProperties.canvasWidth = geom.width * task._viewport.scale;
	      }
	    }
	    task._textDivProperties.set(textDiv, textDivProperties);
	    if (task._textContentStream) {
	      task._layoutText(textDiv);
	    }
	    if (task._enhanceTextSelection) {
	      var angleCos = 1,
	          angleSin = 0;
	      if (angle !== 0) {
	        angleCos = Math.cos(angle);
	        angleSin = Math.sin(angle);
	      }
	      var divWidth = (style.vertical ? geom.height : geom.width) * task._viewport.scale;
	      var divHeight = fontHeight;
	      var m, b;
	      if (angle !== 0) {
	        m = [angleCos, angleSin, -angleSin, angleCos, left, top];
	        b = _util.Util.getAxialAlignedBoundingBox([0, 0, divWidth, divHeight], m);
	      } else {
	        b = [left, top, left + divWidth, top + divHeight];
	      }
	      task._bounds.push({
	        left: b[0],
	        top: b[1],
	        right: b[2],
	        bottom: b[3],
	        div: textDiv,
	        size: [divWidth, divHeight],
	        m: m
	      });
	    }
	  }
	  function render(task) {
	    if (task._canceled) {
	      return;
	    }
	    var textDivs = task._textDivs;
	    var capability = task._capability;
	    var textDivsLength = textDivs.length;
	    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
	      task._renderingDone = true;
	      capability.resolve();
	      return;
	    }
	    if (!task._textContentStream) {
	      for (var i = 0; i < textDivsLength; i++) {
	        task._layoutText(textDivs[i]);
	      }
	    }
	    task._renderingDone = true;
	    capability.resolve();
	  }
	  function expand(task) {
	    var bounds = task._bounds;
	    var viewport = task._viewport;
	    var expanded = expandBounds(viewport.width, viewport.height, bounds);
	    for (var i = 0; i < expanded.length; i++) {
	      var div = bounds[i].div;
	      var divProperties = task._textDivProperties.get(div);
	      if (divProperties.angle === 0) {
	        divProperties.paddingLeft = bounds[i].left - expanded[i].left;
	        divProperties.paddingTop = bounds[i].top - expanded[i].top;
	        divProperties.paddingRight = expanded[i].right - bounds[i].right;
	        divProperties.paddingBottom = expanded[i].bottom - bounds[i].bottom;
	        task._textDivProperties.set(div, divProperties);
	        continue;
	      }
	      var e = expanded[i],
	          b = bounds[i];
	      var m = b.m,
	          c = m[0],
	          s = m[1];
	      var points = [[0, 0], [0, b.size[1]], [b.size[0], 0], b.size];
	      var ts = new Float64Array(64);
	      points.forEach(function (p, i) {
	        var t = _util.Util.applyTransform(p, m);
	        ts[i + 0] = c && (e.left - t[0]) / c;
	        ts[i + 4] = s && (e.top - t[1]) / s;
	        ts[i + 8] = c && (e.right - t[0]) / c;
	        ts[i + 12] = s && (e.bottom - t[1]) / s;
	        ts[i + 16] = s && (e.left - t[0]) / -s;
	        ts[i + 20] = c && (e.top - t[1]) / c;
	        ts[i + 24] = s && (e.right - t[0]) / -s;
	        ts[i + 28] = c && (e.bottom - t[1]) / c;
	        ts[i + 32] = c && (e.left - t[0]) / -c;
	        ts[i + 36] = s && (e.top - t[1]) / -s;
	        ts[i + 40] = c && (e.right - t[0]) / -c;
	        ts[i + 44] = s && (e.bottom - t[1]) / -s;
	        ts[i + 48] = s && (e.left - t[0]) / s;
	        ts[i + 52] = c && (e.top - t[1]) / -c;
	        ts[i + 56] = s && (e.right - t[0]) / s;
	        ts[i + 60] = c && (e.bottom - t[1]) / -c;
	      });
	      var findPositiveMin = function findPositiveMin(ts, offset, count) {
	        var result = 0;
	        for (var i = 0; i < count; i++) {
	          var t = ts[offset++];
	          if (t > 0) {
	            result = result ? Math.min(t, result) : t;
	          }
	        }
	        return result;
	      };
	      var boxScale = 1 + Math.min(Math.abs(c), Math.abs(s));
	      divProperties.paddingLeft = findPositiveMin(ts, 32, 16) / boxScale;
	      divProperties.paddingTop = findPositiveMin(ts, 48, 16) / boxScale;
	      divProperties.paddingRight = findPositiveMin(ts, 0, 16) / boxScale;
	      divProperties.paddingBottom = findPositiveMin(ts, 16, 16) / boxScale;
	      task._textDivProperties.set(div, divProperties);
	    }
	  }
	  function expandBounds(width, height, boxes) {
	    var bounds = boxes.map(function (box, i) {
	      return {
	        x1: box.left,
	        y1: box.top,
	        x2: box.right,
	        y2: box.bottom,
	        index: i,
	        x1New: undefined,
	        x2New: undefined
	      };
	    });
	    expandBoundsLTR(width, bounds);
	    var expanded = new Array(boxes.length);
	    bounds.forEach(function (b) {
	      var i = b.index;
	      expanded[i] = {
	        left: b.x1New,
	        top: 0,
	        right: b.x2New,
	        bottom: 0
	      };
	    });
	    boxes.map(function (box, i) {
	      var e = expanded[i],
	          b = bounds[i];
	      b.x1 = box.top;
	      b.y1 = width - e.right;
	      b.x2 = box.bottom;
	      b.y2 = width - e.left;
	      b.index = i;
	      b.x1New = undefined;
	      b.x2New = undefined;
	    });
	    expandBoundsLTR(height, bounds);
	    bounds.forEach(function (b) {
	      var i = b.index;
	      expanded[i].top = b.x1New;
	      expanded[i].bottom = b.x2New;
	    });
	    return expanded;
	  }
	  function expandBoundsLTR(width, bounds) {
	    bounds.sort(function (a, b) {
	      return a.x1 - b.x1 || a.index - b.index;
	    });
	    var fakeBoundary = {
	      x1: -Infinity,
	      y1: -Infinity,
	      x2: 0,
	      y2: Infinity,
	      index: -1,
	      x1New: 0,
	      x2New: 0
	    };
	    var horizon = [{
	      start: -Infinity,
	      end: Infinity,
	      boundary: fakeBoundary
	    }];
	    bounds.forEach(function (boundary) {
	      var i = 0;
	      while (i < horizon.length && horizon[i].end <= boundary.y1) {
	        i++;
	      }
	      var j = horizon.length - 1;
	      while (j >= 0 && horizon[j].start >= boundary.y2) {
	        j--;
	      }
	      var horizonPart, affectedBoundary;
	      var q,
	          k,
	          maxXNew = -Infinity;
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        var xNew;
	        if (affectedBoundary.x2 > boundary.x1) {
	          xNew = affectedBoundary.index > boundary.index ? affectedBoundary.x1New : boundary.x1;
	        } else if (affectedBoundary.x2New === undefined) {
	          xNew = (affectedBoundary.x2 + boundary.x1) / 2;
	        } else {
	          xNew = affectedBoundary.x2New;
	        }
	        if (xNew > maxXNew) {
	          maxXNew = xNew;
	        }
	      }
	      boundary.x1New = maxXNew;
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        if (affectedBoundary.x2New === undefined) {
	          if (affectedBoundary.x2 > boundary.x1) {
	            if (affectedBoundary.index > boundary.index) {
	              affectedBoundary.x2New = affectedBoundary.x2;
	            }
	          } else {
	            affectedBoundary.x2New = maxXNew;
	          }
	        } else if (affectedBoundary.x2New > maxXNew) {
	          affectedBoundary.x2New = Math.max(maxXNew, affectedBoundary.x2);
	        }
	      }
	      var changedHorizon = [],
	          lastBoundary = null;
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        var useBoundary = affectedBoundary.x2 > boundary.x2 ? affectedBoundary : boundary;
	        if (lastBoundary === useBoundary) {
	          changedHorizon[changedHorizon.length - 1].end = horizonPart.end;
	        } else {
	          changedHorizon.push({
	            start: horizonPart.start,
	            end: horizonPart.end,
	            boundary: useBoundary
	          });
	          lastBoundary = useBoundary;
	        }
	      }
	      if (horizon[i].start < boundary.y1) {
	        changedHorizon[0].start = boundary.y1;
	        changedHorizon.unshift({
	          start: horizon[i].start,
	          end: boundary.y1,
	          boundary: horizon[i].boundary
	        });
	      }
	      if (boundary.y2 < horizon[j].end) {
	        changedHorizon[changedHorizon.length - 1].end = boundary.y2;
	        changedHorizon.push({
	          start: boundary.y2,
	          end: horizon[j].end,
	          boundary: horizon[j].boundary
	        });
	      }
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        if (affectedBoundary.x2New !== undefined) {
	          continue;
	        }
	        var used = false;
	        for (k = i - 1; !used && k >= 0 && horizon[k].start >= affectedBoundary.y1; k--) {
	          used = horizon[k].boundary === affectedBoundary;
	        }
	        for (k = j + 1; !used && k < horizon.length && horizon[k].end <= affectedBoundary.y2; k++) {
	          used = horizon[k].boundary === affectedBoundary;
	        }
	        for (k = 0; !used && k < changedHorizon.length; k++) {
	          used = changedHorizon[k].boundary === affectedBoundary;
	        }
	        if (!used) {
	          affectedBoundary.x2New = maxXNew;
	        }
	      }
	      Array.prototype.splice.apply(horizon, [i, j - i + 1].concat(changedHorizon));
	    });
	    horizon.forEach(function (horizonPart) {
	      var affectedBoundary = horizonPart.boundary;
	      if (affectedBoundary.x2New === undefined) {
	        affectedBoundary.x2New = Math.max(width, affectedBoundary.x2);
	      }
	    });
	  }
	  function TextLayerRenderTask(_ref) {
	    var textContent = _ref.textContent,
	        textContentStream = _ref.textContentStream,
	        container = _ref.container,
	        viewport = _ref.viewport,
	        textDivs = _ref.textDivs,
	        textContentItemsStr = _ref.textContentItemsStr,
	        enhanceTextSelection = _ref.enhanceTextSelection;
	
	    this._textContent = textContent;
	    this._textContentStream = textContentStream;
	    this._container = container;
	    this._viewport = viewport;
	    this._textDivs = textDivs || [];
	    this._textContentItemsStr = textContentItemsStr || [];
	    this._enhanceTextSelection = !!enhanceTextSelection;
	    this._reader = null;
	    this._layoutTextLastFontSize = null;
	    this._layoutTextLastFontFamily = null;
	    this._layoutTextCtx = null;
	    this._textDivProperties = new WeakMap();
	    this._renderingDone = false;
	    this._canceled = false;
	    this._capability = (0, _util.createPromiseCapability)();
	    this._renderTimer = null;
	    this._bounds = [];
	  }
	  TextLayerRenderTask.prototype = {
	    get promise() {
	      return this._capability.promise;
	    },
	    cancel: function TextLayer_cancel() {
	      if (this._reader) {
	        this._reader.cancel(new _util.AbortException('text layer task cancelled'));
	        this._reader = null;
	      }
	      this._canceled = true;
	      if (this._renderTimer !== null) {
	        clearTimeout(this._renderTimer);
	        this._renderTimer = null;
	      }
	      this._capability.reject('canceled');
	    },
	    _processItems: function _processItems(items, styleCache) {
	      for (var i = 0, len = items.length; i < len; i++) {
	        this._textContentItemsStr.push(items[i].str);
	        appendText(this, items[i], styleCache);
	      }
	    },
	    _layoutText: function _layoutText(textDiv) {
	      var textLayerFrag = this._container;
	      var textDivProperties = this._textDivProperties.get(textDiv);
	      if (textDivProperties.isWhitespace) {
	        return;
	      }
	      var fontSize = textDiv.style.fontSize;
	      var fontFamily = textDiv.style.fontFamily;
	      if (fontSize !== this._layoutTextLastFontSize || fontFamily !== this._layoutTextLastFontFamily) {
	        this._layoutTextCtx.font = fontSize + ' ' + fontFamily;
	        this._lastFontSize = fontSize;
	        this._lastFontFamily = fontFamily;
	      }
	      var width = this._layoutTextCtx.measureText(textDiv.textContent).width;
	      var transform = '';
	      if (textDivProperties.canvasWidth !== 0 && width > 0) {
	        textDivProperties.scale = textDivProperties.canvasWidth / width;
	        transform = 'scaleX(' + textDivProperties.scale + ')';
	      }
	      if (textDivProperties.angle !== 0) {
	        transform = 'rotate(' + textDivProperties.angle + 'deg) ' + transform;
	      }
	      if (transform !== '') {
	        textDivProperties.originalTransform = transform;
	        textDiv.style.transform = transform;
	      }
	      this._textDivProperties.set(textDiv, textDivProperties);
	      textLayerFrag.appendChild(textDiv);
	    },
	
	    _render: function TextLayer_render(timeout) {
	      var _this = this;
	
	      var capability = (0, _util.createPromiseCapability)();
	      var styleCache = Object.create(null);
	      var canvas = document.createElement('canvas');
	      canvas.mozOpaque = true;
	      this._layoutTextCtx = canvas.getContext('2d', { alpha: false });
	      if (this._textContent) {
	        var textItems = this._textContent.items;
	        var textStyles = this._textContent.styles;
	        this._processItems(textItems, textStyles);
	        capability.resolve();
	      } else if (this._textContentStream) {
	        var pump = function pump() {
	          _this._reader.read().then(function (_ref2) {
	            var value = _ref2.value,
	                done = _ref2.done;
	
	            if (done) {
	              capability.resolve();
	              return;
	            }
	            _util.Util.extendObj(styleCache, value.styles);
	            _this._processItems(value.items, styleCache);
	            pump();
	          }, capability.reject);
	        };
	        this._reader = this._textContentStream.getReader();
	        pump();
	      } else {
	        throw new Error('Neither "textContent" nor "textContentStream"' + ' parameters specified.');
	      }
	      capability.promise.then(function () {
	        styleCache = null;
	        if (!timeout) {
	          render(_this);
	        } else {
	          _this._renderTimer = setTimeout(function () {
	            render(_this);
	            _this._renderTimer = null;
	          }, timeout);
	        }
	      }, this._capability.reject);
	    },
	    expandTextDivs: function TextLayer_expandTextDivs(expandDivs) {
	      if (!this._enhanceTextSelection || !this._renderingDone) {
	        return;
	      }
	      if (this._bounds !== null) {
	        expand(this);
	        this._bounds = null;
	      }
	      for (var i = 0, ii = this._textDivs.length; i < ii; i++) {
	        var div = this._textDivs[i];
	        var divProperties = this._textDivProperties.get(div);
	        if (divProperties.isWhitespace) {
	          continue;
	        }
	        if (expandDivs) {
	          var transform = '',
	              padding = '';
	          if (divProperties.scale !== 1) {
	            transform = 'scaleX(' + divProperties.scale + ')';
	          }
	          if (divProperties.angle !== 0) {
	            transform = 'rotate(' + divProperties.angle + 'deg) ' + transform;
	          }
	          if (divProperties.paddingLeft !== 0) {
	            padding += ' padding-left: ' + divProperties.paddingLeft / divProperties.scale + 'px;';
	            transform += ' translateX(' + -divProperties.paddingLeft / divProperties.scale + 'px)';
	          }
	          if (divProperties.paddingTop !== 0) {
	            padding += ' padding-top: ' + divProperties.paddingTop + 'px;';
	            transform += ' translateY(' + -divProperties.paddingTop + 'px)';
	          }
	          if (divProperties.paddingRight !== 0) {
	            padding += ' padding-right: ' + divProperties.paddingRight / divProperties.scale + 'px;';
	          }
	          if (divProperties.paddingBottom !== 0) {
	            padding += ' padding-bottom: ' + divProperties.paddingBottom + 'px;';
	          }
	          if (padding !== '') {
	            div.setAttribute('style', divProperties.style + padding);
	          }
	          if (transform !== '') {
	            div.style.transform = transform;
	          }
	        } else {
	          div.style.padding = 0;
	          div.style.transform = divProperties.originalTransform || '';
	        }
	      }
	    }
	  };
	  function renderTextLayer(renderParameters) {
	    var task = new TextLayerRenderTask({
	      textContent: renderParameters.textContent,
	      textContentStream: renderParameters.textContentStream,
	      container: renderParameters.container,
	      viewport: renderParameters.viewport,
	      textDivs: renderParameters.textDivs,
	      textContentItemsStr: renderParameters.textContentItemsStr,
	      enhanceTextSelection: renderParameters.enhanceTextSelection
	    });
	    task._render(renderParameters.timeout);
	    return task;
	  }
	  return renderTextLayer;
	}();
	exports.renderTextLayer = renderTextLayer;

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.waitOnEventOrTimeout = exports.WaitOnType = exports.localized = exports.animationStarted = exports.normalizeWheelEventDelta = exports.binarySearchFirstItem = exports.watchScroll = exports.scrollIntoView = exports.getOutputScale = exports.approximateFraction = exports.roundToDivide = exports.getVisibleElements = exports.parseQueryString = exports.noContextMenuHandler = exports.getPDFFileNameFromURL = exports.ProgressBar = exports.EventBus = exports.NullL10n = exports.mozL10n = exports.RendererType = exports.PresentationModeState = exports.cloneObj = exports.isFileSchema = exports.isValidRotation = exports.VERTICAL_PADDING = exports.SCROLLBAR_PADDING = exports.MAX_AUTO_SCALE = exports.UNKNOWN_SCALE = exports.MAX_SCALE = exports.MIN_SCALE = exports.DEFAULT_SCALE = exports.DEFAULT_SCALE_VALUE = exports.CSS_UNITS = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _pdf = __webpack_require__(1714);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CSS_UNITS = 96.0 / 72.0;
	var DEFAULT_SCALE_VALUE = 'auto';
	var DEFAULT_SCALE = 1.0;
	var MIN_SCALE = 0.10;
	var MAX_SCALE = 10.0;
	var UNKNOWN_SCALE = 0;
	var MAX_AUTO_SCALE = 1.25;
	var SCROLLBAR_PADDING = 40;
	var VERTICAL_PADDING = 5;
	var PresentationModeState = {
	  UNKNOWN: 0,
	  NORMAL: 1,
	  CHANGING: 2,
	  FULLSCREEN: 3
	};
	var RendererType = {
	  CANVAS: 'canvas',
	  SVG: 'svg'
	};
	function formatL10nValue(text, args) {
	  if (!args) {
	    return text;
	  }
	  return text.replace(/\{\{\s*(\w+)\s*\}\}/g, function (all, name) {
	    return name in args ? args[name] : '{{' + name + '}}';
	  });
	}
	var NullL10n = {
	  getDirection: function getDirection() {
	    return Promise.resolve('ltr');
	  },
	  get: function get(property, args, fallback) {
	    return Promise.resolve(formatL10nValue(fallback, args));
	  },
	  translate: function translate(element) {
	    return Promise.resolve();
	  }
	};
	_pdf.PDFJS.disableFullscreen = _pdf.PDFJS.disableFullscreen === undefined ? false : _pdf.PDFJS.disableFullscreen;
	_pdf.PDFJS.useOnlyCssZoom = _pdf.PDFJS.useOnlyCssZoom === undefined ? false : _pdf.PDFJS.useOnlyCssZoom;
	_pdf.PDFJS.maxCanvasPixels = _pdf.PDFJS.maxCanvasPixels === undefined ? 16777216 : _pdf.PDFJS.maxCanvasPixels;
	_pdf.PDFJS.disableHistory = _pdf.PDFJS.disableHistory === undefined ? false : _pdf.PDFJS.disableHistory;
	_pdf.PDFJS.disableTextLayer = _pdf.PDFJS.disableTextLayer === undefined ? false : _pdf.PDFJS.disableTextLayer;
	{
	  _pdf.PDFJS.locale = _pdf.PDFJS.locale === undefined && typeof navigator !== 'undefined' ? navigator.language : _pdf.PDFJS.locale;
	}
	function getOutputScale(ctx) {
	  var devicePixelRatio = window.devicePixelRatio || 1;
	  var backingStoreRatio = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
	  var pixelRatio = devicePixelRatio / backingStoreRatio;
	  return {
	    sx: pixelRatio,
	    sy: pixelRatio,
	    scaled: pixelRatio !== 1
	  };
	}
	function scrollIntoView(element, spot) {
	  var skipOverflowHiddenElements = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var parent = element.offsetParent;
	  if (!parent) {
	    console.error('offsetParent is not set -- cannot scroll');
	    return;
	  }
	  var offsetY = element.offsetTop + element.clientTop;
	  var offsetX = element.offsetLeft + element.clientLeft;
	  while (parent.clientHeight === parent.scrollHeight || skipOverflowHiddenElements && getComputedStyle(parent).overflow === 'hidden') {
	    if (parent.dataset._scaleY) {
	      offsetY /= parent.dataset._scaleY;
	      offsetX /= parent.dataset._scaleX;
	    }
	    offsetY += parent.offsetTop;
	    offsetX += parent.offsetLeft;
	    parent = parent.offsetParent;
	    if (!parent) {
	      return;
	    }
	  }
	  if (spot) {
	    if (spot.top !== undefined) {
	      offsetY += spot.top;
	    }
	    if (spot.left !== undefined) {
	      offsetX += spot.left;
	      parent.scrollLeft = offsetX;
	    }
	  }
	  parent.scrollTop = offsetY;
	}
	function watchScroll(viewAreaElement, callback) {
	  var debounceScroll = function debounceScroll(evt) {
	    if (rAF) {
	      return;
	    }
	    rAF = window.requestAnimationFrame(function viewAreaElementScrolled() {
	      rAF = null;
	      var currentY = viewAreaElement.scrollTop;
	      var lastY = state.lastY;
	      if (currentY !== lastY) {
	        state.down = currentY > lastY;
	      }
	      state.lastY = currentY;
	      callback(state);
	    });
	  };
	  var state = {
	    down: true,
	    lastY: viewAreaElement.scrollTop,
	    _eventHandler: debounceScroll
	  };
	  var rAF = null;
	  viewAreaElement.addEventListener('scroll', debounceScroll, true);
	  return state;
	}
	function parseQueryString(query) {
	  var parts = query.split('&');
	  var params = Object.create(null);
	  for (var i = 0, ii = parts.length; i < ii; ++i) {
	    var param = parts[i].split('=');
	    var key = param[0].toLowerCase();
	    var value = param.length > 1 ? param[1] : null;
	    params[decodeURIComponent(key)] = decodeURIComponent(value);
	  }
	  return params;
	}
	function binarySearchFirstItem(items, condition) {
	  var minIndex = 0;
	  var maxIndex = items.length - 1;
	  if (items.length === 0 || !condition(items[maxIndex])) {
	    return items.length;
	  }
	  if (condition(items[minIndex])) {
	    return minIndex;
	  }
	  while (minIndex < maxIndex) {
	    var currentIndex = minIndex + maxIndex >> 1;
	    var currentItem = items[currentIndex];
	    if (condition(currentItem)) {
	      maxIndex = currentIndex;
	    } else {
	      minIndex = currentIndex + 1;
	    }
	  }
	  return minIndex;
	}
	function approximateFraction(x) {
	  if (Math.floor(x) === x) {
	    return [x, 1];
	  }
	  var xinv = 1 / x;
	  var limit = 8;
	  if (xinv > limit) {
	    return [1, limit];
	  } else if (Math.floor(xinv) === xinv) {
	    return [1, xinv];
	  }
	  var x_ = x > 1 ? xinv : x;
	  var a = 0,
	      b = 1,
	      c = 1,
	      d = 1;
	  while (true) {
	    var p = a + c,
	        q = b + d;
	    if (q > limit) {
	      break;
	    }
	    if (x_ <= p / q) {
	      c = p;
	      d = q;
	    } else {
	      a = p;
	      b = q;
	    }
	  }
	  var result = void 0;
	  if (x_ - a / b < c / d - x_) {
	    result = x_ === x ? [a, b] : [b, a];
	  } else {
	    result = x_ === x ? [c, d] : [d, c];
	  }
	  return result;
	}
	function roundToDivide(x, div) {
	  var r = x % div;
	  return r === 0 ? x : Math.round(x - r + div);
	}
	function getVisibleElements(scrollEl, views) {
	  var sortByVisibility = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var top = scrollEl.scrollTop,
	      bottom = top + scrollEl.clientHeight;
	  var left = scrollEl.scrollLeft,
	      right = left + scrollEl.clientWidth;
	  function isElementBottomBelowViewTop(view) {
	    var element = view.div;
	    var elementBottom = element.offsetTop + element.clientTop + element.clientHeight;
	    return elementBottom > top;
	  }
	  var visible = [],
	      view = void 0,
	      element = void 0;
	  var currentHeight = void 0,
	      viewHeight = void 0,
	      hiddenHeight = void 0,
	      percentHeight = void 0;
	  var currentWidth = void 0,
	      viewWidth = void 0;
	  var firstVisibleElementInd = views.length === 0 ? 0 : binarySearchFirstItem(views, isElementBottomBelowViewTop);
	  for (var i = firstVisibleElementInd, ii = views.length; i < ii; i++) {
	    view = views[i];
	    element = view.div;
	    currentHeight = element.offsetTop + element.clientTop;
	    viewHeight = element.clientHeight;
	    if (currentHeight > bottom) {
	      break;
	    }
	    currentWidth = element.offsetLeft + element.clientLeft;
	    viewWidth = element.clientWidth;
	    if (currentWidth + viewWidth < left || currentWidth > right) {
	      continue;
	    }
	    hiddenHeight = Math.max(0, top - currentHeight) + Math.max(0, currentHeight + viewHeight - bottom);
	    percentHeight = (viewHeight - hiddenHeight) * 100 / viewHeight | 0;
	    visible.push({
	      id: view.id,
	      x: currentWidth,
	      y: currentHeight,
	      view: view,
	      percent: percentHeight
	    });
	  }
	  var first = visible[0];
	  var last = visible[visible.length - 1];
	  if (sortByVisibility) {
	    visible.sort(function (a, b) {
	      var pc = a.percent - b.percent;
	      if (Math.abs(pc) > 0.001) {
	        return -pc;
	      }
	      return a.id - b.id;
	    });
	  }
	  return {
	    first: first,
	    last: last,
	    views: visible
	  };
	}
	function noContextMenuHandler(evt) {
	  evt.preventDefault();
	}
	function isFileSchema(url) {
	  var i = 0,
	      ii = url.length;
	  while (i < ii && url[i].trim() === '') {
	    i++;
	  }
	  return url.substr(i, 7).toLowerCase() === 'file://';
	}
	function isDataSchema(url) {
	  var i = 0,
	      ii = url.length;
	  while (i < ii && url[i].trim() === '') {
	    i++;
	  }
	  return url.substr(i, 5).toLowerCase() === 'data:';
	}
	function getPDFFileNameFromURL(url) {
	  var defaultFilename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'document.pdf';
	
	  if (isDataSchema(url)) {
	    console.warn('getPDFFileNameFromURL: ' + 'ignoring "data:" URL for performance reasons.');
	    return defaultFilename;
	  }
	  var reURI = /^(?:(?:[^:]+:)?\/\/[^\/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
	  var reFilename = /[^\/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
	  var splitURI = reURI.exec(url);
	  var suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
	  if (suggestedFilename) {
	    suggestedFilename = suggestedFilename[0];
	    if (suggestedFilename.indexOf('%') !== -1) {
	      try {
	        suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
	      } catch (ex) {}
	    }
	  }
	  return suggestedFilename || defaultFilename;
	}
	function normalizeWheelEventDelta(evt) {
	  var delta = Math.sqrt(evt.deltaX * evt.deltaX + evt.deltaY * evt.deltaY);
	  var angle = Math.atan2(evt.deltaY, evt.deltaX);
	  if (-0.25 * Math.PI < angle && angle < 0.75 * Math.PI) {
	    delta = -delta;
	  }
	  var MOUSE_DOM_DELTA_PIXEL_MODE = 0;
	  var MOUSE_DOM_DELTA_LINE_MODE = 1;
	  var MOUSE_PIXELS_PER_LINE = 30;
	  var MOUSE_LINES_PER_PAGE = 30;
	  if (evt.deltaMode === MOUSE_DOM_DELTA_PIXEL_MODE) {
	    delta /= MOUSE_PIXELS_PER_LINE * MOUSE_LINES_PER_PAGE;
	  } else if (evt.deltaMode === MOUSE_DOM_DELTA_LINE_MODE) {
	    delta /= MOUSE_LINES_PER_PAGE;
	  }
	  return delta;
	}
	function isValidRotation(angle) {
	  return Number.isInteger(angle) && angle % 90 === 0;
	}
	function cloneObj(obj) {
	  var result = Object.create(null);
	  for (var i in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, i)) {
	      result[i] = obj[i];
	    }
	  }
	  return result;
	}
	var WaitOnType = {
	  EVENT: 'event',
	  TIMEOUT: 'timeout'
	};
	function waitOnEventOrTimeout(_ref) {
	  var target = _ref.target,
	      name = _ref.name,
	      _ref$delay = _ref.delay,
	      delay = _ref$delay === undefined ? 0 : _ref$delay;
	
	  if ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) !== 'object' || !(name && typeof name === 'string') || !(Number.isInteger(delay) && delay >= 0)) {
	    return Promise.reject(new Error('waitOnEventOrTimeout - invalid paramaters.'));
	  }
	  var capability = (0, _pdf.createPromiseCapability)();
	  function handler(type) {
	    if (target instanceof EventBus) {
	      target.off(name, eventHandler);
	    } else {
	      target.removeEventListener(name, eventHandler);
	    }
	    if (timeout) {
	      clearTimeout(timeout);
	    }
	    capability.resolve(type);
	  }
	  var eventHandler = handler.bind(null, WaitOnType.EVENT);
	  if (target instanceof EventBus) {
	    target.on(name, eventHandler);
	  } else {
	    target.addEventListener(name, eventHandler);
	  }
	  var timeoutHandler = handler.bind(null, WaitOnType.TIMEOUT);
	  var timeout = setTimeout(timeoutHandler, delay);
	  return capability.promise;
	}
	var animationStarted = new Promise(function (resolve) {
	  window.requestAnimationFrame(resolve);
	});
	var mozL10n = void 0;
	var localized = Promise.resolve();
	
	var EventBus = function () {
	  function EventBus() {
	    _classCallCheck(this, EventBus);
	
	    this._listeners = Object.create(null);
	  }
	
	  _createClass(EventBus, [{
	    key: 'on',
	    value: function on(eventName, listener) {
	      var eventListeners = this._listeners[eventName];
	      if (!eventListeners) {
	        eventListeners = [];
	        this._listeners[eventName] = eventListeners;
	      }
	      eventListeners.push(listener);
	    }
	  }, {
	    key: 'off',
	    value: function off(eventName, listener) {
	      var eventListeners = this._listeners[eventName];
	      var i = void 0;
	      if (!eventListeners || (i = eventListeners.indexOf(listener)) < 0) {
	        return;
	      }
	      eventListeners.splice(i, 1);
	    }
	  }, {
	    key: 'dispatch',
	    value: function dispatch(eventName) {
	      var eventListeners = this._listeners[eventName];
	      if (!eventListeners || eventListeners.length === 0) {
	        return;
	      }
	      var args = Array.prototype.slice.call(arguments, 1);
	      eventListeners.slice(0).forEach(function (listener) {
	        listener.apply(null, args);
	      });
	    }
	  }]);
	
	  return EventBus;
	}();
	
	function clamp(v, min, max) {
	  return Math.min(Math.max(v, min), max);
	}
	
	var ProgressBar = function () {
	  function ProgressBar(id) {
	    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        height = _ref2.height,
	        width = _ref2.width,
	        units = _ref2.units;
	
	    _classCallCheck(this, ProgressBar);
	
	    this.visible = true;
	    this.div = document.querySelector(id + ' .progress');
	    this.bar = this.div.parentNode;
	    this.height = height || 100;
	    this.width = width || 100;
	    this.units = units || '%';
	    this.div.style.height = this.height + this.units;
	    this.percent = 0;
	  }
	
	  _createClass(ProgressBar, [{
	    key: '_updateBar',
	    value: function _updateBar() {
	      if (this._indeterminate) {
	        this.div.classList.add('indeterminate');
	        this.div.style.width = this.width + this.units;
	        return;
	      }
	      this.div.classList.remove('indeterminate');
	      var progressSize = this.width * this._percent / 100;
	      this.div.style.width = progressSize + this.units;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth(viewer) {
	      if (!viewer) {
	        return;
	      }
	      var container = viewer.parentNode;
	      var scrollbarWidth = container.offsetWidth - viewer.offsetWidth;
	      if (scrollbarWidth > 0) {
	        this.bar.setAttribute('style', 'width: calc(100% - ' + scrollbarWidth + 'px);');
	      }
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      if (!this.visible) {
	        return;
	      }
	      this.visible = false;
	      this.bar.classList.add('hidden');
	      document.body.classList.remove('loadingInProgress');
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      if (this.visible) {
	        return;
	      }
	      this.visible = true;
	      document.body.classList.add('loadingInProgress');
	      this.bar.classList.remove('hidden');
	    }
	  }, {
	    key: 'percent',
	    get: function get() {
	      return this._percent;
	    },
	    set: function set(val) {
	      this._indeterminate = isNaN(val);
	      this._percent = clamp(val, 0, 100);
	      this._updateBar();
	    }
	  }]);
	
	  return ProgressBar;
	}();
	
	exports.CSS_UNITS = CSS_UNITS;
	exports.DEFAULT_SCALE_VALUE = DEFAULT_SCALE_VALUE;
	exports.DEFAULT_SCALE = DEFAULT_SCALE;
	exports.MIN_SCALE = MIN_SCALE;
	exports.MAX_SCALE = MAX_SCALE;
	exports.UNKNOWN_SCALE = UNKNOWN_SCALE;
	exports.MAX_AUTO_SCALE = MAX_AUTO_SCALE;
	exports.SCROLLBAR_PADDING = SCROLLBAR_PADDING;
	exports.VERTICAL_PADDING = VERTICAL_PADDING;
	exports.isValidRotation = isValidRotation;
	exports.isFileSchema = isFileSchema;
	exports.cloneObj = cloneObj;
	exports.PresentationModeState = PresentationModeState;
	exports.RendererType = RendererType;
	exports.mozL10n = mozL10n;
	exports.NullL10n = NullL10n;
	exports.EventBus = EventBus;
	exports.ProgressBar = ProgressBar;
	exports.getPDFFileNameFromURL = getPDFFileNameFromURL;
	exports.noContextMenuHandler = noContextMenuHandler;
	exports.parseQueryString = parseQueryString;
	exports.getVisibleElements = getVisibleElements;
	exports.roundToDivide = roundToDivide;
	exports.approximateFraction = approximateFraction;
	exports.getOutputScale = getOutputScale;
	exports.scrollIntoView = scrollIntoView;
	exports.watchScroll = watchScroll;
	exports.binarySearchFirstItem = binarySearchFirstItem;
	exports.normalizeWheelEventDelta = normalizeWheelEventDelta;
	exports.animationStarted = animationStarted;
	exports.localized = localized;
	exports.WaitOnType = WaitOnType;
	exports.waitOnEventOrTimeout = waitOnEventOrTimeout;

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(1090);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(1725);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 831 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(103);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * If set to true, renders `span` instead of `a`
	   */
	  active: _propTypes2['default'].bool,
	  /**
	   * `href` attribute for the inner `a` element
	   */
	  href: _propTypes2['default'].string,
	  /**
	   * `title` attribute for the inner `a` element
	   */
	  title: _propTypes2['default'].node,
	  /**
	   * `target` attribute for the inner `a` element
	   */
	  target: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  active: false
	};
	
	var BreadcrumbItem = function (_React$Component) {
	  (0, _inherits3['default'])(BreadcrumbItem, _React$Component);
	
	  function BreadcrumbItem() {
	    (0, _classCallCheck3['default'])(this, BreadcrumbItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  BreadcrumbItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        href = _props.href,
	        title = _props.title,
	        target = _props.target,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'href', 'title', 'target', 'className']);
	
	    // Don't try to render these props on non-active <span>.
	
	    var linkProps = { href: href, title: title, target: target };
	
	    return _react2['default'].createElement(
	      'li',
	      { className: (0, _classnames2['default'])(className, { active: active }) },
	      active ? _react2['default'].createElement('span', props) : _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, linkProps))
	    );
	  };
	
	  return BreadcrumbItem;
	}(_react2['default'].Component);
	
	BreadcrumbItem.propTypes = propTypes;
	BreadcrumbItem.defaultProps = defaultProps;
	
	exports['default'] = BreadcrumbItem;
	module.exports = exports['default'];

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__(299);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _Button = __webpack_require__(221);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  vertical: _propTypes2['default'].bool,
	  justified: _propTypes2['default'].bool,
	
	  /**
	   * Display block buttons; only useful when used with the "vertical" prop.
	   * @type {bool}
	   */
	  block: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var block = _ref.block,
	        vertical = _ref.vertical;
	    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
	  })
	};
	
	var defaultProps = {
	  block: false,
	  justified: false,
	  vertical: false
	};
	
	var ButtonGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ButtonGroup, _React$Component);
	
	  function ButtonGroup() {
	    (0, _classCallCheck3['default'])(this, ButtonGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonGroup.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        block = _props.block,
	        justified = _props.justified,
	        vertical = _props.vertical,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['block', 'justified', 'vertical', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps)] = !vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'vertical')] = vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2[(0, _bootstrapUtils.prefix)(_Button2['default'].defaultProps, 'block')] = block, _extends2));
	
	    return _react2['default'].createElement('div', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ButtonGroup;
	}(_react2['default'].Component);
	
	ButtonGroup.propTypes = propTypes;
	ButtonGroup.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn-group', ButtonGroup);
	module.exports = exports['default'];

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionEvents = __webpack_require__(1801);
	
	var _TransitionEvents2 = _interopRequireDefault(_TransitionEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should use a timeout instead of TransitionEvents, or else just
	// not wait until transition end to trigger continuing animations.
	
	var propTypes = {
	  direction: _propTypes2['default'].oneOf(['prev', 'next']),
	  onAnimateOutEnd: _propTypes2['default'].func,
	  active: _propTypes2['default'].bool,
	  animateIn: _propTypes2['default'].bool,
	  animateOut: _propTypes2['default'].bool,
	  index: _propTypes2['default'].number
	};
	
	var defaultProps = {
	  active: false,
	  animateIn: false,
	  animateOut: false
	};
	
	var CarouselItem = function (_React$Component) {
	  (0, _inherits3['default'])(CarouselItem, _React$Component);
	
	  function CarouselItem(props, context) {
	    (0, _classCallCheck3['default'])(this, CarouselItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);
	
	    _this.state = {
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.active !== nextProps.active) {
	      this.setState({ direction: null });
	    }
	  };
	
	  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;
	
	    var active = this.props.active;
	
	    var prevActive = prevProps.active;
	
	    if (!active && prevActive) {
	      _TransitionEvents2['default'].addEndEventListener(_reactDom2['default'].findDOMNode(this), this.handleAnimateOutEnd);
	    }
	
	    if (active !== prevActive) {
	      setTimeout(function () {
	        return _this2.startAnimation();
	      }, 20);
	    }
	  };
	
	  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    if (this.props.onAnimateOutEnd) {
	      this.props.onAnimateOutEnd(this.props.index);
	    }
	  };
	
	  CarouselItem.prototype.startAnimation = function startAnimation() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState({
	      direction: this.props.direction === 'prev' ? 'right' : 'left'
	    });
	  };
	
	  CarouselItem.prototype.render = function render() {
	    var _props = this.props,
	        direction = _props.direction,
	        active = _props.active,
	        animateIn = _props.animateIn,
	        animateOut = _props.animateOut,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);
	
	
	    delete props.onAnimateOutEnd;
	    delete props.index;
	
	    var classes = {
	      item: true,
	      active: active && !animateIn || animateOut
	    };
	    if (direction && active && animateIn) {
	      classes[direction] = true;
	    }
	    if (this.state.direction && (animateIn || animateOut)) {
	      classes[this.state.direction] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return CarouselItem;
	}(_react2['default'].Component);
	
	CarouselItem.propTypes = propTypes;
	CarouselItem.defaultProps = defaultProps;
	
	exports['default'] = CarouselItem;
	module.exports = exports['default'];

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(221);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SafeAnchor = __webpack_require__(103);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  noCaret: _propTypes2['default'].bool,
	  open: _propTypes2['default'].bool,
	  title: _propTypes2['default'].string,
	  useAnchor: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  open: false,
	  useAnchor: false,
	  bsRole: 'toggle'
	};
	
	var DropdownToggle = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownToggle, _React$Component);
	
	  function DropdownToggle() {
	    (0, _classCallCheck3['default'])(this, DropdownToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownToggle.prototype.render = function render() {
	    var _props = this.props,
	        noCaret = _props.noCaret,
	        open = _props.open,
	        useAnchor = _props.useAnchor,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);
	
	
	    delete props.bsRole;
	
	    var Component = useAnchor ? _SafeAnchor2['default'] : _Button2['default'];
	    var useCaret = !noCaret;
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    // FIXME: Should this really fall back to `title` as children?
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, props, {
	        role: 'button',
	        className: (0, _classnames2['default'])(className, bsClass),
	        'aria-haspopup': true,
	        'aria-expanded': open
	      }),
	      children || props.title,
	      useCaret && ' ',
	      useCaret && _react2['default'].createElement('span', { className: 'caret' })
	    );
	  };
	
	  return DropdownToggle;
	}(_react2['default'].Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-toggle', DropdownToggle);
	module.exports = exports['default'];

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Turn any fixed-width grid layout into a full-width layout by this property.
	   *
	   * Adds `container-fluid` class.
	   */
	  fluid: _propTypes2['default'].bool,
	  /**
	   * You can use a custom element for this component
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  fluid: false
	};
	
	var Grid = function (_React$Component) {
	  (0, _inherits3['default'])(Grid, _React$Component);
	
	  function Grid() {
	    (0, _classCallCheck3['default'])(this, Grid);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Grid.prototype.render = function render() {
	    var _props = this.props,
	        fluid = _props.fluid,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['fluid', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.prefix)(bsProps, fluid && 'fluid');
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Grid;
	}(_react2['default'].Component);
	
	Grid.propTypes = propTypes;
	Grid.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('container', Grid);
	module.exports = exports['default'];

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(156);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].any,
	  disabled: _propTypes2['default'].any,
	  header: _propTypes2['default'].node,
	  listItem: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  href: _propTypes2['default'].string,
	  type: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  listItem: false
	};
	
	var ListGroupItem = function (_React$Component) {
	  (0, _inherits3['default'])(ListGroupItem, _React$Component);
	
	  function ListGroupItem() {
	    (0, _classCallCheck3['default'])(this, ListGroupItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
	    if (_react2['default'].isValidElement(header)) {
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2['default'])(header.props.className, headingClassName)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'h4',
	      { className: headingClassName },
	      header
	    );
	  };
	
	  ListGroupItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        className = _props.className,
	        header = _props.header,
	        listItem = _props.listItem,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active,
	      disabled: disabled
	    });
	
	    var Component = void 0;
	
	    if (elementProps.href) {
	      Component = 'a';
	    } else if (elementProps.onClick) {
	      Component = 'button';
	      elementProps.type = elementProps.type || 'button';
	    } else if (listItem) {
	      Component = 'li';
	    } else {
	      Component = 'span';
	    }
	
	    elementProps.className = (0, _classnames2['default'])(className, classes);
	
	    // TODO: Deprecate `header` prop.
	    if (header) {
	      return _react2['default'].createElement(
	        Component,
	        elementProps,
	        this.renderHeader(header, (0, _bootstrapUtils.prefix)(bsProps, 'heading')),
	        _react2['default'].createElement(
	          'p',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'text') },
	          children
	        )
	      );
	    }
	
	    return _react2['default'].createElement(
	      Component,
	      elementProps,
	      children
	    );
	  };
	
	  return ListGroupItem;
	}(_react2['default'].Component);
	
	ListGroupItem.propTypes = propTypes;
	ListGroupItem.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('list-group-item', (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), ListGroupItem));
	module.exports = exports['default'];

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalBody = function (_React$Component) {
	  (0, _inherits3['default'])(ModalBody, _React$Component);
	
	  function ModalBody() {
	    (0, _classCallCheck3['default'])(this, ModalBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalBody;
	}(_react2['default'].Component);
	
	ModalBody.propTypes = propTypes;
	ModalBody.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-body', ModalBody);
	module.exports = exports['default'];

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalFooter = function (_React$Component) {
	  (0, _inherits3['default'])(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    (0, _classCallCheck3['default'])(this, ModalFooter);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalFooter.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalFooter;
	}(_react2['default'].Component);
	
	ModalFooter.propTypes = propTypes;
	ModalFooter.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-footer', ModalFooter);
	module.exports = exports['default'];

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _createChainedFunction = __webpack_require__(50);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `aria-label` should be `closeLabel`.
	
	var propTypes = {
	  /**
	   * The 'aria-label' attribute provides an accessible label for the close
	   * button. It is used for Assistive Technology when the label text is not
	   * readable.
	   */
	  'aria-label': _propTypes2['default'].string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _propTypes2['default'].bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside
	   * a Modal component, the onHide will automatically be propagated up to the
	   * parent Modal `onHide`.
	   */
	  onHide: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  'aria-label': 'Close',
	  closeButton: false
	};
	
	var contextTypes = {
	  $bs_modal: _propTypes2['default'].shape({
	    onHide: _propTypes2['default'].func
	  })
	};
	
	var ModalHeader = function (_React$Component) {
	  (0, _inherits3['default'])(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    (0, _classCallCheck3['default'])(this, ModalHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalHeader.prototype.render = function render() {
	    var _props = this.props,
	        label = _props['aria-label'],
	        closeButton = _props.closeButton,
	        onHide = _props.onHide,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['aria-label', 'closeButton', 'onHide', 'className', 'children']);
	
	
	    var modal = this.context.$bs_modal;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      closeButton && _react2['default'].createElement(
	        'button',
	        {
	          type: 'button',
	          className: 'close',
	          'aria-label': label,
	          onClick: (0, _createChainedFunction2['default'])(modal && modal.onHide, onHide)
	        },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-hidden': 'true' },
	          '\xD7'
	        )
	      ),
	      children
	    );
	  };
	
	  return ModalHeader;
	}(_react2['default'].Component);
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	ModalHeader.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-header', ModalHeader);
	module.exports = exports['default'];

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var ModalTitle = function (_React$Component) {
	  (0, _inherits3['default'])(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    (0, _classCallCheck3['default'])(this, ModalTitle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalTitle.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalTitle;
	}(_react2['default'].Component);
	
	ModalTitle.propTypes = propTypes;
	ModalTitle.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-title', ModalTitle);
	module.exports = exports['default'];

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(407);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(299);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _createChainedFunction = __webpack_require__(50);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(71);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
	
	// TODO: This `bsStyle` is very unlike the others. Should we rename it?
	
	// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
	// Consider renaming or replacing them.
	
	var propTypes = {
	  /**
	   * Marks the NavItem with a matching `eventKey` as active. Has a
	   * higher precedence over `activeHref`.
	   */
	  activeKey: _propTypes2['default'].any,
	
	  /**
	   * Marks the child NavItem with a matching `href` prop as active.
	   */
	  activeHref: _propTypes2['default'].string,
	
	  /**
	   * NavItems are be positioned vertically.
	   */
	  stacked: _propTypes2['default'].bool,
	
	  justified: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var justified = _ref.justified,
	        navbar = _ref.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	
	  /**
	   * A callback fired when a NavItem is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * ARIA role for the Nav, in the context of a TabContainer, the default will
	   * be set to "tablist", but can be overridden by the Nav when set explicitly.
	   *
	   * When the role is set to "tablist" NavItem focus is managed according to
	   * the ARIA authoring practices for tabs:
	   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
	   */
	  role: _propTypes2['default'].string,
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _propTypes2['default'].bool,
	
	  /**
	   * Float the Nav to the right. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullRight: _propTypes2['default'].bool,
	
	  /**
	   * Float the Nav to the left. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullLeft: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    onSelect: _propTypes2['default'].func
	  }),
	
	  $bs_tabContainer: _propTypes2['default'].shape({
	    activeKey: _propTypes2['default'].any,
	    onSelect: _propTypes2['default'].func.isRequired,
	    getTabId: _propTypes2['default'].func.isRequired,
	    getPaneId: _propTypes2['default'].func.isRequired
	  })
	};
	
	var Nav = function (_React$Component) {
	  (0, _inherits3['default'])(Nav, _React$Component);
	
	  function Nav() {
	    (0, _classCallCheck3['default'])(this, Nav);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    if (!this._needsRefocus) {
	      return;
	    }
	
	    this._needsRefocus = false;
	
	    var children = this.props.children;
	
	    var _getActiveProps = this.getActiveProps(),
	        activeKey = _getActiveProps.activeKey,
	        activeHref = _getActiveProps.activeHref;
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    });
	
	    var childrenArray = _ValidComponentChildren2['default'].toArray(children);
	    var activeChildIndex = childrenArray.indexOf(activeChild);
	
	    var childNodes = _reactDom2['default'].findDOMNode(this).children;
	    var activeNode = childNodes && childNodes[activeChildIndex];
	
	    if (!activeNode || !activeNode.firstChild) {
	      return;
	    }
	
	    activeNode.firstChild.focus();
	  };
	
	  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
	    var nextActiveChild = void 0;
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.left:
	      case _keycode2['default'].codes.up:
	        nextActiveChild = this.getNextActiveChild(-1);
	        break;
	      case _keycode2['default'].codes.right:
	      case _keycode2['default'].codes.down:
	        nextActiveChild = this.getNextActiveChild(1);
	        break;
	      default:
	        // It was a different key; don't handle this keypress.
	        return;
	    }
	
	    event.preventDefault();
	
	    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
	      onSelect(nextActiveChild.props.eventKey);
	    }
	
	    this._needsRefocus = true;
	  };
	
	  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
	    var _this3 = this;
	
	    var children = this.props.children;
	
	    var validChildren = children.filter(function (child) {
	      return child.props.eventKey != null && !child.props.disabled;
	    });
	
	    var _getActiveProps2 = this.getActiveProps(),
	        activeKey = _getActiveProps2.activeKey,
	        activeHref = _getActiveProps2.activeHref;
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this3.isActive(child, activeKey, activeHref);
	    });
	
	    // This assumes the active child is not disabled.
	    var activeChildIndex = validChildren.indexOf(activeChild);
	    if (activeChildIndex === -1) {
	      // Something has gone wrong. Select the first valid child we can find.
	      return validChildren[0];
	    }
	
	    var nextIndex = activeChildIndex + offset;
	    var numValidChildren = validChildren.length;
	
	    if (nextIndex >= numValidChildren) {
	      nextIndex = 0;
	    } else if (nextIndex < 0) {
	      nextIndex = numValidChildren - 1;
	    }
	
	    return validChildren[nextIndex];
	  };
	
	  Nav.prototype.getActiveProps = function getActiveProps() {
	    var tabContainer = this.context.$bs_tabContainer;
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;
	
	      return tabContainer;
	    }
	
	    return this.props;
	  };
	
	  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
	    var props = _ref2.props;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
	    var _this4 = this;
	
	    if (!tabContainer && navRole !== 'tablist') {
	      // No tab props here.
	      return null;
	    }
	
	    var _child$props = child.props,
	        id = _child$props.id,
	        controls = _child$props['aria-controls'],
	        eventKey = _child$props.eventKey,
	        role = _child$props.role,
	        onKeyDown = _child$props.onKeyDown,
	        tabIndex = _child$props.tabIndex;
	
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      id = tabContainer.getTabId(eventKey);
	      controls = tabContainer.getPaneId(eventKey);
	    }
	
	    if (navRole === 'tablist') {
	      role = role || 'tab';
	      onKeyDown = (0, _createChainedFunction2['default'])(function (event) {
	        return _this4.handleTabKeyDown(onSelect, event);
	      }, onKeyDown);
	      tabIndex = active ? tabIndex : -1;
	    }
	
	    return {
	      id: id,
	      role: role,
	      onKeyDown: onKeyDown,
	      'aria-controls': controls,
	      tabIndex: tabIndex
	    };
	  };
	
	  Nav.prototype.render = function render() {
	    var _extends2,
	        _this5 = this;
	
	    var _props = this.props,
	        stacked = _props.stacked,
	        justified = _props.justified,
	        onSelect = _props.onSelect,
	        propsRole = _props.role,
	        propsNavbar = _props.navbar,
	        pullRight = _props.pullRight,
	        pullLeft = _props.pullLeft,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);
	
	
	    var tabContainer = this.context.$bs_tabContainer;
	    var role = propsRole || (tabContainer ? 'tablist' : null);
	
	    var _getActiveProps3 = this.getActiveProps(),
	        activeKey = _getActiveProps3.activeKey,
	        activeHref = _getActiveProps3.activeHref;
	
	    delete props.activeKey; // Accessed via this.getActiveProps().
	    delete props.activeHref; // Accessed via this.getActiveProps().
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'stacked')] = stacked, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2));
	
	    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
	    var pullLeftClassName = void 0;
	    var pullRightClassName = void 0;
	
	    if (navbar) {
	      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	      classes[(0, _bootstrapUtils.prefix)(navbarProps, 'nav')] = true;
	
	      pullRightClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'right');
	      pullLeftClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'left');
	    } else {
	      pullRightClassName = 'pull-right';
	      pullLeftClassName = 'pull-left';
	    }
	
	    classes[pullRightClassName] = pullRight;
	    classes[pullLeftClassName] = pullLeft;
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends4['default'])({}, elementProps, {
	        role: role,
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var active = _this5.isActive(child, activeKey, activeHref);
	        var childOnSelect = (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
	
	        return (0, _react.cloneElement)(child, (0, _extends4['default'])({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
	          active: active,
	          activeKey: activeKey,
	          activeHref: activeHref,
	          onSelect: childOnSelect
	        }));
	      })
	    );
	  };
	
	  return Nav;
	}(_react2['default'].Component);
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	Nav.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('nav', (0, _bootstrapUtils.bsStyles)(['tabs', 'pills'], Nav));
	module.exports = exports['default'];

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(103);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(50);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  role: _propTypes2['default'].string,
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  eventKey: _propTypes2['default'].any
	};
	
	var defaultProps = {
	  active: false,
	  disabled: false
	};
	
	var NavItem = function (_React$Component) {
	  (0, _inherits3['default'])(NavItem, _React$Component);
	
	  function NavItem(props, context) {
	    (0, _classCallCheck3['default'])(this, NavItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  NavItem.prototype.handleClick = function handleClick(e) {
	    if (this.props.onSelect) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, e);
	      }
	    }
	  };
	
	  NavItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        onClick = _props.onClick,
	        className = _props.className,
	        style = _props.style,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    // These are injected down by `<Nav>` for building `<SubNav>`s.
	    delete props.activeKey;
	    delete props.activeHref;
	
	    if (!props.role) {
	      if (props.href === '#') {
	        props.role = 'button';
	      }
	    } else if (props.role === 'tab') {
	      props['aria-selected'] = active;
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return NavItem;
	}(_react2['default'].Component);
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	
	exports['default'] = NavItem;
	module.exports = exports['default'];

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string
	  })
	};
	
	var NavbarBrand = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarBrand, _React$Component);
	
	  function NavbarBrand() {
	    (0, _classCallCheck3['default'])(this, NavbarBrand);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarBrand.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'brand');
	
	    if (_react2['default'].isValidElement(children)) {
	      return _react2['default'].cloneElement(children, {
	        className: (0, _classnames2['default'])(children.props.className, className, bsClassName)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }),
	      children
	    );
	  };
	
	  return NavbarBrand;
	}(_react2['default'].Component);
	
	NavbarBrand.contextTypes = contextTypes;
	
	exports['default'] = NavbarBrand;
	module.exports = exports['default'];

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Overlay = __webpack_require__(1910);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(287);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2['default'].bool,
	  /**
	   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2['default'].bool,
	  /**
	   * A callback invoked by the overlay when it wishes to be hidden. Required if
	   * `rootClose` is specified.
	   */
	  onHide: _propTypes2['default'].func,
	
	  /**
	   * Use animation
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * Sets the direction of the Overlay.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left'])
	});
	
	var defaultProps = {
	  animation: _Fade2['default'],
	  rootClose: false,
	  show: false,
	  placement: 'right'
	};
	
	var Overlay = function (_React$Component) {
	  (0, _inherits3['default'])(Overlay, _React$Component);
	
	  function Overlay() {
	    (0, _classCallCheck3['default'])(this, Overlay);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        animation = _props.animation,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['animation', 'children']);
	
	
	    var transition = animation === true ? _Fade2['default'] : animation || null;
	
	    var child = void 0;
	
	    if (!transition) {
	      child = (0, _react.cloneElement)(children, {
	        className: (0, _classnames2['default'])(children.props.className, 'in')
	      });
	    } else {
	      child = children;
	    }
	
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        transition: transition
	      }),
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2['default'].Component);
	
	Overlay.propTypes = propTypes;
	Overlay.defaultProps = defaultProps;
	
	exports['default'] = Overlay;
	module.exports = exports['default'];

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(103);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(50);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  disabled: _propTypes2['default'].bool,
	  previous: _propTypes2['default'].bool,
	  next: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  eventKey: _propTypes2['default'].any
	};
	
	var defaultProps = {
	  disabled: false,
	  previous: false,
	  next: false
	};
	
	var PagerItem = function (_React$Component) {
	  (0, _inherits3['default'])(PagerItem, _React$Component);
	
	  function PagerItem(props, context) {
	    (0, _classCallCheck3['default'])(this, PagerItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  PagerItem.prototype.handleSelect = function handleSelect(e) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (onSelect || disabled) {
	      e.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, e);
	    }
	  };
	
	  PagerItem.prototype.render = function render() {
	    var _props2 = this.props,
	        disabled = _props2.disabled,
	        previous = _props2.previous,
	        next = _props2.next,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: (0, _classnames2['default'])(className, { disabled: disabled, previous: previous, next: next }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleSelect)
	      }))
	    );
	  };
	
	  return PagerItem;
	}(_react2['default'].Component);
	
	PagerItem.propTypes = propTypes;
	PagerItem.defaultProps = defaultProps;
	
	exports['default'] = PagerItem;
	module.exports = exports['default'];

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _SafeAnchor = __webpack_require__(103);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(50);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should be `<Pagination.Item>`.
	
	// TODO: This should use `componentClass` like other components.
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	  className: _propTypes2['default'].string,
	  eventKey: _propTypes2['default'].any,
	  onSelect: _propTypes2['default'].func,
	  disabled: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	  onClick: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: _SafeAnchor2['default'],
	  active: false,
	  disabled: false
	};
	
	var PaginationButton = function (_React$Component) {
	  (0, _inherits3['default'])(PaginationButton, _React$Component);
	
	  function PaginationButton(props, context) {
	    (0, _classCallCheck3['default'])(this, PaginationButton);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  PaginationButton.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  PaginationButton.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    if (Component === _SafeAnchor2['default']) {
	      // Assume that custom components want `eventKey`.
	      delete props.eventKey;
	    }
	
	    delete props.onSelect;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return PaginationButton;
	}(_react2['default'].Component);
	
	PaginationButton.propTypes = propTypes;
	PaginationButton.defaultProps = defaultProps;
	
	exports['default'] = PaginationButton;
	module.exports = exports['default'];

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(333);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _createChainedFunction = __webpack_require__(50);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(71);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  accordion: _propTypes2['default'].bool,
	  activeKey: _propTypes2['default'].any,
	  defaultActiveKey: _propTypes2['default'].any,
	  onSelect: _propTypes2['default'].func,
	  role: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  accordion: false
	};
	
	// TODO: Use uncontrollable.
	
	var PanelGroup = function (_React$Component) {
	  (0, _inherits3['default'])(PanelGroup, _React$Component);
	
	  function PanelGroup(props, context) {
	    (0, _classCallCheck3['default'])(this, PanelGroup);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	
	    _this.state = {
	      activeKey: props.defaultActiveKey
	    };
	    return _this;
	  }
	
	  PanelGroup.prototype.handleSelect = function handleSelect(key, e) {
	    e.preventDefault();
	
	    if (this.props.onSelect) {
	      this.props.onSelect(key, e);
	    }
	
	    if (this.state.activeKey === key) {
	      key = null;
	    }
	
	    this.setState({ activeKey: key });
	  };
	
	  PanelGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        accordion = _props.accordion,
	        propsActiveKey = _props.activeKey,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['accordion', 'activeKey', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultActiveKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeKey = void 0;
	    if (accordion) {
	      activeKey = propsActiveKey != null ? propsActiveKey : this.state.activeKey;
	      elementProps.role = elementProps.role || 'tablist';
	    }
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var childProps = {
	          bsStyle: child.props.bsStyle || bsProps.bsStyle
	        };
	
	        if (accordion) {
	          (0, _assign2['default'])(childProps, {
	            headerRole: 'tab',
	            panelRole: 'tabpanel',
	            collapsible: true,
	            expanded: child.props.eventKey === activeKey,
	            onSelect: (0, _createChainedFunction2['default'])(_this2.handleSelect, child.props.onSelect)
	          });
	        }
	
	        return (0, _react.cloneElement)(child, childProps);
	      })
	    );
	  };
	
	  return PanelGroup;
	}(_react2['default'].Component);
	
	PanelGroup.propTypes = propTypes;
	PanelGroup.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('panel-group', PanelGroup);
	module.exports = exports['default'];

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _createChainedFunction = __webpack_require__(50);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _Fade = __webpack_require__(287);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uniquely identify the `<TabPane>` among its siblings.
	   */
	  eventKey: _propTypes2['default'].any,
	
	  /**
	   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
	   * `true` to enable the default `<Fade>` animation or any `<Transition>`
	   * component.
	   */
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	
	  /** @private **/
	  id: _propTypes2['default'].string,
	
	  /** @private **/
	  'aria-labelledby': _propTypes2['default'].string,
	
	  /**
	   * If not explicitly specified and rendered in the context of a
	   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
	   * If otherwise not explicitly specified, `tab-pane`.
	   */
	  bsClass: _propTypes2['default'].string,
	
	  /**
	   * Transition onEnter callback when animation is not `false`
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Transition onEntering callback when animation is not `false`
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Transition onEntered callback when animation is not `false`
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Transition onExit callback when animation is not `false`
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Transition onExiting callback when animation is not `false`
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Transition onExited callback when animation is not `false`
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount the tab (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2['default'].shape({
	    getTabId: _propTypes2['default'].func,
	    getPaneId: _propTypes2['default'].func
	  }),
	  $bs_tabContent: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),
	    activeKey: _propTypes2['default'].any,
	    mountOnEnter: _propTypes2['default'].bool,
	    unmountOnExit: _propTypes2['default'].bool,
	    onPaneEnter: _propTypes2['default'].func.isRequired,
	    onPaneExited: _propTypes2['default'].func.isRequired,
	    exiting: _propTypes2['default'].bool.isRequired
	  })
	};
	
	/**
	 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
	 * conflict with the top level one.
	 */
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2['default'].oneOf([null])
	};
	
	var TabPane = function (_React$Component) {
	  (0, _inherits3['default'])(TabPane, _React$Component);
	
	  function TabPane(props, context) {
	    (0, _classCallCheck3['default'])(this, TabPane);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	
	    _this['in'] = false;
	    return _this;
	  }
	
	  TabPane.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_tabContainer: null
	    };
	  };
	
	  TabPane.prototype.componentDidMount = function componentDidMount() {
	    if (this.shouldBeIn()) {
	      // In lieu of the action event firing.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this['in']) {
	      if (!this.shouldBeIn()) {
	        // We shouldn't be active any more. Notify the parent.
	        this.handleExited();
	      }
	    } else if (this.shouldBeIn()) {
	      // We are the active child. Notify the parent.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this['in']) {
	      // In lieu of the action event firing.
	      this.handleExited();
	    }
	  };
	
	  TabPane.prototype.handleEnter = function handleEnter() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    this['in'] = tabContent.onPaneEnter(this, this.props.eventKey);
	  };
	
	  TabPane.prototype.handleExited = function handleExited() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    tabContent.onPaneExited(this);
	    this['in'] = false;
	  };
	
	  TabPane.prototype.getAnimation = function getAnimation() {
	    if (this.props.animation != null) {
	      return this.props.animation;
	    }
	
	    var tabContent = this.context.$bs_tabContent;
	    return tabContent && tabContent.animation;
	  };
	
	  TabPane.prototype.isActive = function isActive() {
	    var tabContent = this.context.$bs_tabContent;
	    var activeKey = tabContent && tabContent.activeKey;
	
	    return this.props.eventKey === activeKey;
	  };
	
	  TabPane.prototype.shouldBeIn = function shouldBeIn() {
	    return this.getAnimation() && this.isActive();
	  };
	
	  TabPane.prototype.render = function render() {
	    var _props = this.props,
	        eventKey = _props.eventKey,
	        className = _props.className,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        propsMountOnEnter = _props.mountOnEnter,
	        propsUnmountOnExit = _props.unmountOnExit,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'mountOnEnter', 'unmountOnExit']);
	    var _context = this.context,
	        tabContent = _context.$bs_tabContent,
	        tabContainer = _context.$bs_tabContainer;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var active = this.isActive();
	    var animation = this.getAnimation();
	
	    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
	    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;
	
	    if (!active && !animation && unmountOnExit) {
	      return null;
	    }
	
	    var Transition = animation === true ? _Fade2['default'] : animation || null;
	
	    if (tabContent) {
	      bsProps.bsClass = (0, _bootstrapUtils.prefix)(tabContent, 'pane');
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active
	    });
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      elementProps.id = tabContainer.getPaneId(eventKey);
	      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
	    }
	
	    var pane = _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'tabpanel',
	      'aria-hidden': !active,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (Transition) {
	      var exiting = tabContent && tabContent.exiting;
	
	      return _react2['default'].createElement(
	        Transition,
	        {
	          'in': active && !exiting,
	          onEnter: (0, _createChainedFunction2['default'])(this.handleEnter, onEnter),
	          onEntering: onEntering,
	          onEntered: onEntered,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: (0, _createChainedFunction2['default'])(this.handleExited, onExited),
	          mountOnEnter: mountOnEnter,
	          unmountOnExit: unmountOnExit
	        },
	        pane
	      );
	    }
	
	    return pane;
	  };
	
	  return TabPane;
	}(_react2['default'].Component);
	
	TabPane.propTypes = propTypes;
	TabPane.contextTypes = contextTypes;
	TabPane.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab-pane', TabPane);
	module.exports = exports['default'];

/***/ },
/* 850 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = capitalize;
	function capitalize(string) {
	  return "" + string.charAt(0).toUpperCase() + string.slice(1);
	}
	module.exports = exports["default"];

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var CalendarIcon = function () {
	  function CalendarIcon(props) {
	    return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
	      d: "M107.2 1392.9h241.1v-241.1H107.2v241.1zm294.7 0h267.9v-241.1H401.9v241.1zm-294.7-294.7h241.1V830.4H107.2v267.8zm294.7 0h267.9V830.4H401.9v267.8zM107.2 776.8h241.1V535.7H107.2v241.1zm616.2 616.1h267.9v-241.1H723.4v241.1zM401.9 776.8h267.9V535.7H401.9v241.1zm642.9 616.1H1286v-241.1h-241.1v241.1zm-321.4-294.7h267.9V830.4H723.4v267.8zM428.7 375V133.9c0-7.3-2.7-13.5-8-18.8-5.3-5.3-11.6-8-18.8-8h-53.6c-7.3 0-13.5 2.7-18.8 8-5.3 5.3-8 11.6-8 18.8V375c0 7.3 2.7 13.5 8 18.8 5.3 5.3 11.6 8 18.8 8h53.6c7.3 0 13.5-2.7 18.8-8 5.3-5.3 8-11.5 8-18.8zm616.1 723.2H1286V830.4h-241.1v267.8zM723.4 776.8h267.9V535.7H723.4v241.1zm321.4 0H1286V535.7h-241.1v241.1zm26.8-401.8V133.9c0-7.3-2.7-13.5-8-18.8-5.3-5.3-11.6-8-18.8-8h-53.6c-7.3 0-13.5 2.7-18.8 8-5.3 5.3-8 11.6-8 18.8V375c0 7.3 2.7 13.5 8 18.8 5.3 5.3 11.6 8 18.8 8h53.6c7.3 0 13.5-2.7 18.8-8 5.4-5.3 8-11.5 8-18.8zm321.5-53.6v1071.4c0 29-10.6 54.1-31.8 75.3-21.2 21.2-46.3 31.8-75.3 31.8H107.2c-29 0-54.1-10.6-75.3-31.8C10.6 1447 0 1421.9 0 1392.9V321.4c0-29 10.6-54.1 31.8-75.3s46.3-31.8 75.3-31.8h107.2v-80.4c0-36.8 13.1-68.4 39.3-94.6S311.4 0 348.3 0h53.6c36.8 0 68.4 13.1 94.6 39.3 26.2 26.2 39.3 57.8 39.3 94.6v80.4h321.5v-80.4c0-36.8 13.1-68.4 39.3-94.6C922.9 13.1 954.4 0 991.3 0h53.6c36.8 0 68.4 13.1 94.6 39.3s39.3 57.8 39.3 94.6v80.4H1286c29 0 54.1 10.6 75.3 31.8 21.2 21.2 31.8 46.3 31.8 75.3z"
	    }));
	  }
	
	  return CalendarIcon;
	}();
	
	CalendarIcon.defaultProps = {
	  focusable: "false",
	  viewBox: "0 0 1393.1 1500"
	};
	var _default = CalendarIcon;
	exports["default"] = _default;

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _reactAddonsShallowCompare = _interopRequireDefault(__webpack_require__(70));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(105));
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _defaultPhrases = __webpack_require__(51);
	
	var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(60));
	
	var _CalendarWeek = _interopRequireDefault(__webpack_require__(1806));
	
	var _CalendarDay = _interopRequireDefault(__webpack_require__(433));
	
	var _calculateDimension = _interopRequireDefault(__webpack_require__(868));
	
	var _getCalendarMonthWeeks = _interopRequireDefault(__webpack_require__(1819));
	
	var _isSameDay = _interopRequireDefault(__webpack_require__(177));
	
	var _toISODateString = _interopRequireDefault(__webpack_require__(291));
	
	var _ModifiersShape = _interopRequireDefault(__webpack_require__(289));
	
	var _ScrollableOrientationShape = _interopRequireDefault(__webpack_require__(175));
	
	var _DayOfWeekShape = _interopRequireDefault(__webpack_require__(145));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () { function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); } return _getPrototypeOf; }(); return _getPrototypeOf(o); }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function () { function _setPrototypeOf(o, p) { o.__proto__ = p; return o; } return _setPrototypeOf; }(); return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
	  month: _reactMomentProptypes["default"].momentObj,
	  horizontalMonthPadding: _airbnbPropTypes.nonNegativeInteger,
	  isVisible: _propTypes["default"].bool,
	  enableOutsideDays: _propTypes["default"].bool,
	  modifiers: _propTypes["default"].objectOf(_ModifiersShape["default"]),
	  orientation: _ScrollableOrientationShape["default"],
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  onDayClick: _propTypes["default"].func,
	  onDayMouseEnter: _propTypes["default"].func,
	  onDayMouseLeave: _propTypes["default"].func,
	  onMonthSelect: _propTypes["default"].func,
	  onYearSelect: _propTypes["default"].func,
	  renderMonthText: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
	  renderCalendarDay: _propTypes["default"].func,
	  renderDayContents: _propTypes["default"].func,
	  renderMonthElement: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
	  firstDayOfWeek: _DayOfWeekShape["default"],
	  setMonthTitleHeight: _propTypes["default"].func,
	  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
	  focusedDate: _reactMomentProptypes["default"].momentObj,
	  // indicates focusable day
	  isFocused: _propTypes["default"].bool,
	  // indicates whether or not to move focus to focusable day
	  // i18n
	  monthFormat: _propTypes["default"].string,
	  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.CalendarDayPhrases)),
	  dayAriaLabelFormat: _propTypes["default"].string
	})) : {};
	var defaultProps = {
	  month: (0, _moment["default"])(),
	  horizontalMonthPadding: 13,
	  isVisible: true,
	  enableOutsideDays: false,
	  modifiers: {},
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  daySize: _constants.DAY_SIZE,
	  onDayClick: function () {
	    function onDayClick() {}
	
	    return onDayClick;
	  }(),
	  onDayMouseEnter: function () {
	    function onDayMouseEnter() {}
	
	    return onDayMouseEnter;
	  }(),
	  onDayMouseLeave: function () {
	    function onDayMouseLeave() {}
	
	    return onDayMouseLeave;
	  }(),
	  onMonthSelect: function () {
	    function onMonthSelect() {}
	
	    return onMonthSelect;
	  }(),
	  onYearSelect: function () {
	    function onYearSelect() {}
	
	    return onYearSelect;
	  }(),
	  renderMonthText: null,
	  renderCalendarDay: function () {
	    function renderCalendarDay(props) {
	      return _react["default"].createElement(_CalendarDay["default"], props);
	    }
	
	    return renderCalendarDay;
	  }(),
	  renderDayContents: null,
	  renderMonthElement: null,
	  firstDayOfWeek: null,
	  setMonthTitleHeight: null,
	  focusedDate: null,
	  isFocused: false,
	  // i18n
	  monthFormat: 'MMMM YYYY',
	  // english locale
	  phrases: _defaultPhrases.CalendarDayPhrases,
	  dayAriaLabelFormat: undefined,
	  verticalBorderSpacing: undefined
	};
	
	var CalendarMonth =
	/*#__PURE__*/
	function (_ref) {
	  _inherits(CalendarMonth, _ref);
	
	  _createClass(CalendarMonth, [{
	    key: !_react["default"].PureComponent && "shouldComponentUpdate",
	    value: function () {
	      function value(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
	      }
	
	      return value;
	    }()
	  }]);
	
	  function CalendarMonth(props) {
	    var _this;
	
	    _classCallCheck(this, CalendarMonth);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(CalendarMonth).call(this, props));
	    _this.state = {
	      weeks: (0, _getCalendarMonthWeeks["default"])(props.month, props.enableOutsideDays, props.firstDayOfWeek == null ? _moment["default"].localeData().firstDayOfWeek() : props.firstDayOfWeek)
	    };
	    _this.setCaptionRef = _this.setCaptionRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.setMonthTitleHeight = _this.setMonthTitleHeight.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    return _this;
	  }
	
	  _createClass(CalendarMonth, [{
	    key: "componentDidMount",
	    value: function () {
	      function componentDidMount() {
	        this.setMonthTitleHeightTimeout = setTimeout(this.setMonthTitleHeight, 0);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "componentWillReceiveProps",
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var month = nextProps.month,
	            enableOutsideDays = nextProps.enableOutsideDays,
	            firstDayOfWeek = nextProps.firstDayOfWeek;
	        var _this$props = this.props,
	            prevMonth = _this$props.month,
	            prevEnableOutsideDays = _this$props.enableOutsideDays,
	            prevFirstDayOfWeek = _this$props.firstDayOfWeek;
	
	        if (!month.isSame(prevMonth) || enableOutsideDays !== prevEnableOutsideDays || firstDayOfWeek !== prevFirstDayOfWeek) {
	          this.setState({
	            weeks: (0, _getCalendarMonthWeeks["default"])(month, enableOutsideDays, firstDayOfWeek == null ? _moment["default"].localeData().firstDayOfWeek() : firstDayOfWeek)
	          });
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: "componentWillUnmount",
	    value: function () {
	      function componentWillUnmount() {
	        if (this.setMonthTitleHeightTimeout) {
	          clearTimeout(this.setMonthTitleHeightTimeout);
	        }
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: "setMonthTitleHeight",
	    value: function () {
	      function setMonthTitleHeight() {
	        var setMonthTitleHeight = this.props.setMonthTitleHeight;
	
	        if (setMonthTitleHeight) {
	          var captionHeight = (0, _calculateDimension["default"])(this.captionRef, 'height', true, true);
	          setMonthTitleHeight(captionHeight);
	        }
	      }
	
	      return setMonthTitleHeight;
	    }()
	  }, {
	    key: "setCaptionRef",
	    value: function () {
	      function setCaptionRef(ref) {
	        this.captionRef = ref;
	      }
	
	      return setCaptionRef;
	    }()
	  }, {
	    key: "render",
	    value: function () {
	      function render() {
	        var _this$props2 = this.props,
	            dayAriaLabelFormat = _this$props2.dayAriaLabelFormat,
	            daySize = _this$props2.daySize,
	            focusedDate = _this$props2.focusedDate,
	            horizontalMonthPadding = _this$props2.horizontalMonthPadding,
	            isFocused = _this$props2.isFocused,
	            isVisible = _this$props2.isVisible,
	            modifiers = _this$props2.modifiers,
	            month = _this$props2.month,
	            monthFormat = _this$props2.monthFormat,
	            onDayClick = _this$props2.onDayClick,
	            onDayMouseEnter = _this$props2.onDayMouseEnter,
	            onDayMouseLeave = _this$props2.onDayMouseLeave,
	            onMonthSelect = _this$props2.onMonthSelect,
	            onYearSelect = _this$props2.onYearSelect,
	            orientation = _this$props2.orientation,
	            phrases = _this$props2.phrases,
	            renderCalendarDay = _this$props2.renderCalendarDay,
	            renderDayContents = _this$props2.renderDayContents,
	            renderMonthElement = _this$props2.renderMonthElement,
	            renderMonthText = _this$props2.renderMonthText,
	            styles = _this$props2.styles,
	            verticalBorderSpacing = _this$props2.verticalBorderSpacing;
	        var weeks = this.state.weeks;
	        var monthTitle = renderMonthText ? renderMonthText(month) : month.format(monthFormat);
	        var verticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
	        return _react["default"].createElement("div", _extends({}, (0, _reactWithStyles.css)(styles.CalendarMonth, {
	          padding: "0 ".concat(horizontalMonthPadding, "px")
	        }), {
	          "data-visible": isVisible
	        }), _react["default"].createElement("div", _extends({
	          ref: this.setCaptionRef
	        }, (0, _reactWithStyles.css)(styles.CalendarMonth_caption, verticalScrollable && styles.CalendarMonth_caption__verticalScrollable)), renderMonthElement ? renderMonthElement({
	          month: month,
	          onMonthSelect: onMonthSelect,
	          onYearSelect: onYearSelect
	        }) : _react["default"].createElement("strong", null, monthTitle)), _react["default"].createElement("table", _extends({}, (0, _reactWithStyles.css)(!verticalBorderSpacing && styles.CalendarMonth_table, verticalBorderSpacing && styles.CalendarMonth_verticalSpacing, verticalBorderSpacing && {
	          borderSpacing: "0px ".concat(verticalBorderSpacing, "px")
	        }), {
	          role: "presentation"
	        }), _react["default"].createElement("tbody", null, weeks.map(function (week, i) {
	          return _react["default"].createElement(_CalendarWeek["default"], {
	            key: i
	          }, week.map(function (day, dayOfWeek) {
	            return renderCalendarDay({
	              key: dayOfWeek,
	              day: day,
	              daySize: daySize,
	              isOutsideDay: !day || day.month() !== month.month(),
	              tabIndex: isVisible && (0, _isSameDay["default"])(day, focusedDate) ? 0 : -1,
	              isFocused: isFocused,
	              onDayMouseEnter: onDayMouseEnter,
	              onDayMouseLeave: onDayMouseLeave,
	              onDayClick: onDayClick,
	              renderDayContents: renderDayContents,
	              phrases: phrases,
	              modifiers: modifiers[(0, _toISODateString["default"])(day)],
	              ariaLabelFormat: dayAriaLabelFormat
	            });
	          }));
	        }))));
	      }
	
	      return render;
	    }()
	  }]);
	
	  return CalendarMonth;
	}(_react["default"].PureComponent || _react["default"].Component);
	
	CalendarMonth.propTypes =  false ? propTypes : {};
	CalendarMonth.defaultProps = defaultProps;
	
	var _default = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var _ref2$reactDates = _ref2.reactDates,
	      color = _ref2$reactDates.color,
	      font = _ref2$reactDates.font,
	      spacing = _ref2$reactDates.spacing;
	  return {
	    CalendarMonth: {
	      background: color.background,
	      textAlign: 'center',
	      verticalAlign: 'top',
	      userSelect: 'none'
	    },
	    CalendarMonth_table: {
	      borderCollapse: 'collapse',
	      borderSpacing: 0
	    },
	    CalendarMonth_verticalSpacing: {
	      borderCollapse: 'separate'
	    },
	    CalendarMonth_caption: {
	      color: color.text,
	      fontSize: font.captionSize,
	      textAlign: 'center',
	      paddingTop: spacing.captionPaddingTop,
	      paddingBottom: spacing.captionPaddingBottom,
	      captionSide: 'initial'
	    },
	    CalendarMonth_caption__verticalScrollable: {
	      paddingTop: 12,
	      paddingBottom: 7
	    }
	  };
	}, {
	  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
	})(CalendarMonth);
	
	exports["default"] = _default;

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _reactAddonsShallowCompare = _interopRequireDefault(__webpack_require__(70));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(105));
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _consolidatedEvents = __webpack_require__(249);
	
	var _defaultPhrases = __webpack_require__(51);
	
	var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(60));
	
	var _noflip = _interopRequireDefault(__webpack_require__(127));
	
	var _CalendarMonth = _interopRequireDefault(__webpack_require__(852));
	
	var _isTransitionEndSupported = _interopRequireDefault(__webpack_require__(1827));
	
	var _getTransformStyles = _interopRequireDefault(__webpack_require__(1823));
	
	var _getCalendarMonthWidth = _interopRequireDefault(__webpack_require__(871));
	
	var _toISOMonthString = _interopRequireDefault(__webpack_require__(292));
	
	var _isPrevMonth = _interopRequireDefault(__webpack_require__(1826));
	
	var _isNextMonth = _interopRequireDefault(__webpack_require__(1825));
	
	var _ModifiersShape = _interopRequireDefault(__webpack_require__(289));
	
	var _ScrollableOrientationShape = _interopRequireDefault(__webpack_require__(175));
	
	var _DayOfWeekShape = _interopRequireDefault(__webpack_require__(145));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () { function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); } return _getPrototypeOf; }(); return _getPrototypeOf(o); }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function () { function _setPrototypeOf(o, p) { o.__proto__ = p; return o; } return _setPrototypeOf; }(); return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
	  enableOutsideDays: _propTypes["default"].bool,
	  firstVisibleMonthIndex: _propTypes["default"].number,
	  horizontalMonthPadding: _airbnbPropTypes.nonNegativeInteger,
	  initialMonth: _reactMomentProptypes["default"].momentObj,
	  isAnimating: _propTypes["default"].bool,
	  numberOfMonths: _propTypes["default"].number,
	  modifiers: _propTypes["default"].objectOf(_propTypes["default"].objectOf(_ModifiersShape["default"])),
	  orientation: _ScrollableOrientationShape["default"],
	  onDayClick: _propTypes["default"].func,
	  onDayMouseEnter: _propTypes["default"].func,
	  onDayMouseLeave: _propTypes["default"].func,
	  onMonthTransitionEnd: _propTypes["default"].func,
	  onMonthChange: _propTypes["default"].func,
	  onYearChange: _propTypes["default"].func,
	  renderMonthText: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
	  renderCalendarDay: _propTypes["default"].func,
	  renderDayContents: _propTypes["default"].func,
	  translationValue: _propTypes["default"].number,
	  renderMonthElement: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  focusedDate: _reactMomentProptypes["default"].momentObj,
	  // indicates focusable day
	  isFocused: _propTypes["default"].bool,
	  // indicates whether or not to move focus to focusable day
	  firstDayOfWeek: _DayOfWeekShape["default"],
	  setMonthTitleHeight: _propTypes["default"].func,
	  isRTL: _propTypes["default"].bool,
	  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
	  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
	  // i18n
	  monthFormat: _propTypes["default"].string,
	  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.CalendarDayPhrases)),
	  dayAriaLabelFormat: _propTypes["default"].string
	})) : {};
	var defaultProps = {
	  enableOutsideDays: false,
	  firstVisibleMonthIndex: 0,
	  horizontalMonthPadding: 13,
	  initialMonth: (0, _moment["default"])(),
	  isAnimating: false,
	  numberOfMonths: 1,
	  modifiers: {},
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  onDayClick: function () {
	    function onDayClick() {}
	
	    return onDayClick;
	  }(),
	  onDayMouseEnter: function () {
	    function onDayMouseEnter() {}
	
	    return onDayMouseEnter;
	  }(),
	  onDayMouseLeave: function () {
	    function onDayMouseLeave() {}
	
	    return onDayMouseLeave;
	  }(),
	  onMonthChange: function () {
	    function onMonthChange() {}
	
	    return onMonthChange;
	  }(),
	  onYearChange: function () {
	    function onYearChange() {}
	
	    return onYearChange;
	  }(),
	  onMonthTransitionEnd: function () {
	    function onMonthTransitionEnd() {}
	
	    return onMonthTransitionEnd;
	  }(),
	  renderMonthText: null,
	  renderCalendarDay: undefined,
	  renderDayContents: null,
	  translationValue: null,
	  renderMonthElement: null,
	  daySize: _constants.DAY_SIZE,
	  focusedDate: null,
	  isFocused: false,
	  firstDayOfWeek: null,
	  setMonthTitleHeight: null,
	  isRTL: false,
	  transitionDuration: 200,
	  verticalBorderSpacing: undefined,
	  // i18n
	  monthFormat: 'MMMM YYYY',
	  // english locale
	  phrases: _defaultPhrases.CalendarDayPhrases,
	  dayAriaLabelFormat: undefined
	};
	
	function getMonths(initialMonth, numberOfMonths, withoutTransitionMonths) {
	  var month = initialMonth.clone();
	  if (!withoutTransitionMonths) month = month.subtract(1, 'month');
	  var months = [];
	
	  for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
	    months.push(month);
	    month = month.clone().add(1, 'month');
	  }
	
	  return months;
	}
	
	var CalendarMonthGrid =
	/*#__PURE__*/
	function (_ref) {
	  _inherits(CalendarMonthGrid, _ref);
	
	  _createClass(CalendarMonthGrid, [{
	    key: !_react["default"].PureComponent && "shouldComponentUpdate",
	    value: function () {
	      function value(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
	      }
	
	      return value;
	    }()
	  }]);
	
	  function CalendarMonthGrid(props) {
	    var _this;
	
	    _classCallCheck(this, CalendarMonthGrid);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(CalendarMonthGrid).call(this, props));
	    var withoutTransitionMonths = props.orientation === _constants.VERTICAL_SCROLLABLE;
	    _this.state = {
	      months: getMonths(props.initialMonth, props.numberOfMonths, withoutTransitionMonths)
	    };
	    _this.isTransitionEndSupported = (0, _isTransitionEndSupported["default"])();
	    _this.onTransitionEnd = _this.onTransitionEnd.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.setContainerRef = _this.setContainerRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.locale = _moment["default"].locale();
	    _this.onMonthSelect = _this.onMonthSelect.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onYearSelect = _this.onYearSelect.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    return _this;
	  }
	
	  _createClass(CalendarMonthGrid, [{
	    key: "componentDidMount",
	    value: function () {
	      function componentDidMount() {
	        this.removeEventListener = (0, _consolidatedEvents.addEventListener)(this.container, 'transitionend', this.onTransitionEnd);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "componentWillReceiveProps",
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        var initialMonth = nextProps.initialMonth,
	            numberOfMonths = nextProps.numberOfMonths,
	            orientation = nextProps.orientation;
	        var months = this.state.months;
	        var _this$props = this.props,
	            prevInitialMonth = _this$props.initialMonth,
	            prevNumberOfMonths = _this$props.numberOfMonths;
	        var hasMonthChanged = !prevInitialMonth.isSame(initialMonth, 'month');
	        var hasNumberOfMonthsChanged = prevNumberOfMonths !== numberOfMonths;
	        var newMonths = months;
	
	        if (hasMonthChanged && !hasNumberOfMonthsChanged) {
	          if ((0, _isNextMonth["default"])(prevInitialMonth, initialMonth)) {
	            newMonths = months.slice(1);
	            newMonths.push(months[months.length - 1].clone().add(1, 'month'));
	          } else if ((0, _isPrevMonth["default"])(prevInitialMonth, initialMonth)) {
	            newMonths = months.slice(0, months.length - 1);
	            newMonths.unshift(months[0].clone().subtract(1, 'month'));
	          } else {
	            var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
	            newMonths = getMonths(initialMonth, numberOfMonths, withoutTransitionMonths);
	          }
	        }
	
	        if (hasNumberOfMonthsChanged) {
	          var _withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
	
	          newMonths = getMonths(initialMonth, numberOfMonths, _withoutTransitionMonths);
	        }
	
	        var momentLocale = _moment["default"].locale();
	
	        if (this.locale !== momentLocale) {
	          this.locale = momentLocale;
	          newMonths = newMonths.map(function (m) {
	            return m.locale(_this2.locale);
	          });
	        }
	
	        this.setState({
	          months: newMonths
	        });
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: "componentDidUpdate",
	    value: function () {
	      function componentDidUpdate() {
	        var _this$props2 = this.props,
	            isAnimating = _this$props2.isAnimating,
	            transitionDuration = _this$props2.transitionDuration,
	            onMonthTransitionEnd = _this$props2.onMonthTransitionEnd; // For IE9, immediately call onMonthTransitionEnd instead of
	        // waiting for the animation to complete. Similarly, if transitionDuration
	        // is set to 0, also immediately invoke the onMonthTransitionEnd callback
	
	        if ((!this.isTransitionEndSupported || !transitionDuration) && isAnimating) {
	          onMonthTransitionEnd();
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: "componentWillUnmount",
	    value: function () {
	      function componentWillUnmount() {
	        if (this.removeEventListener) this.removeEventListener();
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: "onTransitionEnd",
	    value: function () {
	      function onTransitionEnd() {
	        var onMonthTransitionEnd = this.props.onMonthTransitionEnd;
	        onMonthTransitionEnd();
	      }
	
	      return onTransitionEnd;
	    }()
	  }, {
	    key: "onMonthSelect",
	    value: function () {
	      function onMonthSelect(currentMonth, newMonthVal) {
	        var newMonth = currentMonth.clone();
	        var _this$props3 = this.props,
	            onMonthChange = _this$props3.onMonthChange,
	            orientation = _this$props3.orientation;
	        var months = this.state.months;
	        var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
	        var initialMonthSubtraction = months.indexOf(currentMonth);
	
	        if (!withoutTransitionMonths) {
	          initialMonthSubtraction -= 1;
	        }
	
	        newMonth.set('month', newMonthVal).subtract(initialMonthSubtraction, 'months');
	        onMonthChange(newMonth);
	      }
	
	      return onMonthSelect;
	    }()
	  }, {
	    key: "onYearSelect",
	    value: function () {
	      function onYearSelect(currentMonth, newYearVal) {
	        var newMonth = currentMonth.clone();
	        var _this$props4 = this.props,
	            onYearChange = _this$props4.onYearChange,
	            orientation = _this$props4.orientation;
	        var months = this.state.months;
	        var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
	        var initialMonthSubtraction = months.indexOf(currentMonth);
	
	        if (!withoutTransitionMonths) {
	          initialMonthSubtraction -= 1;
	        }
	
	        newMonth.set('year', newYearVal).subtract(initialMonthSubtraction, 'months');
	        onYearChange(newMonth);
	      }
	
	      return onYearSelect;
	    }()
	  }, {
	    key: "setContainerRef",
	    value: function () {
	      function setContainerRef(ref) {
	        this.container = ref;
	      }
	
	      return setContainerRef;
	    }()
	  }, {
	    key: "render",
	    value: function () {
	      function render() {
	        var _this3 = this;
	
	        var _this$props5 = this.props,
	            enableOutsideDays = _this$props5.enableOutsideDays,
	            firstVisibleMonthIndex = _this$props5.firstVisibleMonthIndex,
	            horizontalMonthPadding = _this$props5.horizontalMonthPadding,
	            isAnimating = _this$props5.isAnimating,
	            modifiers = _this$props5.modifiers,
	            numberOfMonths = _this$props5.numberOfMonths,
	            monthFormat = _this$props5.monthFormat,
	            orientation = _this$props5.orientation,
	            translationValue = _this$props5.translationValue,
	            daySize = _this$props5.daySize,
	            onDayMouseEnter = _this$props5.onDayMouseEnter,
	            onDayMouseLeave = _this$props5.onDayMouseLeave,
	            onDayClick = _this$props5.onDayClick,
	            renderMonthText = _this$props5.renderMonthText,
	            renderCalendarDay = _this$props5.renderCalendarDay,
	            renderDayContents = _this$props5.renderDayContents,
	            renderMonthElement = _this$props5.renderMonthElement,
	            onMonthTransitionEnd = _this$props5.onMonthTransitionEnd,
	            firstDayOfWeek = _this$props5.firstDayOfWeek,
	            focusedDate = _this$props5.focusedDate,
	            isFocused = _this$props5.isFocused,
	            isRTL = _this$props5.isRTL,
	            styles = _this$props5.styles,
	            phrases = _this$props5.phrases,
	            dayAriaLabelFormat = _this$props5.dayAriaLabelFormat,
	            transitionDuration = _this$props5.transitionDuration,
	            verticalBorderSpacing = _this$props5.verticalBorderSpacing,
	            setMonthTitleHeight = _this$props5.setMonthTitleHeight;
	        var months = this.state.months;
	        var isVertical = orientation === _constants.VERTICAL_ORIENTATION;
	        var isVerticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
	        var isHorizontal = orientation === _constants.HORIZONTAL_ORIENTATION;
	        var calendarMonthWidth = (0, _getCalendarMonthWidth["default"])(daySize, horizontalMonthPadding);
	        var width = isVertical || isVerticalScrollable ? calendarMonthWidth : (numberOfMonths + 2) * calendarMonthWidth;
	        var transformType = isVertical || isVerticalScrollable ? 'translateY' : 'translateX';
	        var transformValue = "".concat(transformType, "(").concat(translationValue, "px)");
	        return _react["default"].createElement("div", _extends({}, (0, _reactWithStyles.css)(styles.CalendarMonthGrid, isHorizontal && styles.CalendarMonthGrid__horizontal, isVertical && styles.CalendarMonthGrid__vertical, isVerticalScrollable && styles.CalendarMonthGrid__vertical_scrollable, isAnimating && styles.CalendarMonthGrid__animating, isAnimating && transitionDuration && {
	          transition: "transform ".concat(transitionDuration, "ms ease-in-out")
	        }, _objectSpread({}, (0, _getTransformStyles["default"])(transformValue), {
	          width: width
	        })), {
	          ref: this.setContainerRef,
	          onTransitionEnd: onMonthTransitionEnd
	        }), months.map(function (month, i) {
	          var isVisible = i >= firstVisibleMonthIndex && i < firstVisibleMonthIndex + numberOfMonths;
	          var hideForAnimation = i === 0 && !isVisible;
	          var showForAnimation = i === 0 && isAnimating && isVisible;
	          var monthString = (0, _toISOMonthString["default"])(month);
	          return _react["default"].createElement("div", _extends({
	            key: monthString
	          }, (0, _reactWithStyles.css)(isHorizontal && styles.CalendarMonthGrid_month__horizontal, hideForAnimation && styles.CalendarMonthGrid_month__hideForAnimation, showForAnimation && !isVertical && !isRTL && {
	            position: 'absolute',
	            left: -calendarMonthWidth
	          }, showForAnimation && !isVertical && isRTL && {
	            position: 'absolute',
	            right: 0
	          }, showForAnimation && isVertical && {
	            position: 'absolute',
	            top: -translationValue
	          }, !isVisible && !isAnimating && styles.CalendarMonthGrid_month__hidden)), _react["default"].createElement(_CalendarMonth["default"], {
	            month: month,
	            isVisible: isVisible,
	            enableOutsideDays: enableOutsideDays,
	            modifiers: modifiers[monthString],
	            monthFormat: monthFormat,
	            orientation: orientation,
	            onDayMouseEnter: onDayMouseEnter,
	            onDayMouseLeave: onDayMouseLeave,
	            onDayClick: onDayClick,
	            onMonthSelect: _this3.onMonthSelect,
	            onYearSelect: _this3.onYearSelect,
	            renderMonthText: renderMonthText,
	            renderCalendarDay: renderCalendarDay,
	            renderDayContents: renderDayContents,
	            renderMonthElement: renderMonthElement,
	            firstDayOfWeek: firstDayOfWeek,
	            daySize: daySize,
	            focusedDate: isVisible ? focusedDate : null,
	            isFocused: isFocused,
	            phrases: phrases,
	            setMonthTitleHeight: setMonthTitleHeight,
	            dayAriaLabelFormat: dayAriaLabelFormat,
	            verticalBorderSpacing: verticalBorderSpacing,
	            horizontalMonthPadding: horizontalMonthPadding
	          }));
	        }));
	      }
	
	      return render;
	    }()
	  }]);
	
	  return CalendarMonthGrid;
	}(_react["default"].PureComponent || _react["default"].Component);
	
	CalendarMonthGrid.propTypes =  false ? propTypes : {};
	CalendarMonthGrid.defaultProps = defaultProps;
	
	var _default = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var _ref2$reactDates = _ref2.reactDates,
	      color = _ref2$reactDates.color,
	      noScrollBarOnVerticalScrollable = _ref2$reactDates.noScrollBarOnVerticalScrollable,
	      spacing = _ref2$reactDates.spacing,
	      zIndex = _ref2$reactDates.zIndex;
	  return {
	    CalendarMonthGrid: {
	      background: color.background,
	      textAlign: (0, _noflip["default"])('left'),
	      zIndex: zIndex
	    },
	    CalendarMonthGrid__animating: {
	      zIndex: zIndex + 1
	    },
	    CalendarMonthGrid__horizontal: {
	      position: 'absolute',
	      left: (0, _noflip["default"])(spacing.dayPickerHorizontalPadding)
	    },
	    CalendarMonthGrid__vertical: {
	      margin: '0 auto'
	    },
	    CalendarMonthGrid__vertical_scrollable: _objectSpread({
	      margin: '0 auto',
	      overflowY: 'scroll'
	    }, noScrollBarOnVerticalScrollable && {
	      '-webkitOverflowScrolling': 'touch',
	      '::-webkit-scrollbar': {
	        '-webkit-appearance': 'none',
	        display: 'none'
	      }
	    }),
	    CalendarMonthGrid_month__horizontal: {
	      display: 'inline-block',
	      verticalAlign: 'top',
	      minHeight: '100%'
	    },
	    CalendarMonthGrid_month__hideForAnimation: {
	      position: 'absolute',
	      zIndex: zIndex - 1,
	      opacity: 0,
	      pointerEvents: 'none'
	    },
	    CalendarMonthGrid_month__hidden: {
	      visibility: 'hidden'
	    }
	  };
	}, {
	  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
	})(CalendarMonthGrid);
	
	exports["default"] = _default;

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _reactAddonsShallowCompare = _interopRequireDefault(__webpack_require__(70));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _throttle = _interopRequireDefault(__webpack_require__(662));
	
	var _isTouchDevice = _interopRequireDefault(__webpack_require__(171));
	
	var _noflip = _interopRequireDefault(__webpack_require__(127));
	
	var _getInputHeight = _interopRequireDefault(__webpack_require__(435));
	
	var _OpenDirectionShape = _interopRequireDefault(__webpack_require__(146));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () { function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); } return _getPrototypeOf; }(); return _getPrototypeOf(o); }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function () { function _setPrototypeOf(o, p) { o.__proto__ = p; return o; } return _setPrototypeOf; }(); return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var FANG_PATH_TOP = "M0,".concat(_constants.FANG_HEIGHT_PX, " ").concat(_constants.FANG_WIDTH_PX, ",").concat(_constants.FANG_HEIGHT_PX, " ").concat(_constants.FANG_WIDTH_PX / 2, ",0z");
	var FANG_STROKE_TOP = "M0,".concat(_constants.FANG_HEIGHT_PX, " ").concat(_constants.FANG_WIDTH_PX / 2, ",0 ").concat(_constants.FANG_WIDTH_PX, ",").concat(_constants.FANG_HEIGHT_PX);
	var FANG_PATH_BOTTOM = "M0,0 ".concat(_constants.FANG_WIDTH_PX, ",0 ").concat(_constants.FANG_WIDTH_PX / 2, ",").concat(_constants.FANG_HEIGHT_PX, "z");
	var FANG_STROKE_BOTTOM = "M0,0 ".concat(_constants.FANG_WIDTH_PX / 2, ",").concat(_constants.FANG_HEIGHT_PX, " ").concat(_constants.FANG_WIDTH_PX, ",0");
	var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
	  id: _propTypes["default"].string.isRequired,
	  placeholder: _propTypes["default"].string,
	  // also used as label
	  displayValue: _propTypes["default"].string,
	  screenReaderMessage: _propTypes["default"].string,
	  focused: _propTypes["default"].bool,
	  disabled: _propTypes["default"].bool,
	  required: _propTypes["default"].bool,
	  readOnly: _propTypes["default"].bool,
	  openDirection: _OpenDirectionShape["default"],
	  showCaret: _propTypes["default"].bool,
	  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
	  small: _propTypes["default"].bool,
	  block: _propTypes["default"].bool,
	  regular: _propTypes["default"].bool,
	  onChange: _propTypes["default"].func,
	  onFocus: _propTypes["default"].func,
	  onKeyDownShiftTab: _propTypes["default"].func,
	  onKeyDownTab: _propTypes["default"].func,
	  onKeyDownArrowDown: _propTypes["default"].func,
	  onKeyDownQuestionMark: _propTypes["default"].func,
	  // accessibility
	  isFocused: _propTypes["default"].bool // describes actual DOM focus
	
	})) : {};
	var defaultProps = {
	  placeholder: 'Select Date',
	  displayValue: '',
	  screenReaderMessage: '',
	  focused: false,
	  disabled: false,
	  required: false,
	  readOnly: null,
	  openDirection: _constants.OPEN_DOWN,
	  showCaret: false,
	  verticalSpacing: _constants.DEFAULT_VERTICAL_SPACING,
	  small: false,
	  block: false,
	  regular: false,
	  onChange: function () {
	    function onChange() {}
	
	    return onChange;
	  }(),
	  onFocus: function () {
	    function onFocus() {}
	
	    return onFocus;
	  }(),
	  onKeyDownShiftTab: function () {
	    function onKeyDownShiftTab() {}
	
	    return onKeyDownShiftTab;
	  }(),
	  onKeyDownTab: function () {
	    function onKeyDownTab() {}
	
	    return onKeyDownTab;
	  }(),
	  onKeyDownArrowDown: function () {
	    function onKeyDownArrowDown() {}
	
	    return onKeyDownArrowDown;
	  }(),
	  onKeyDownQuestionMark: function () {
	    function onKeyDownQuestionMark() {}
	
	    return onKeyDownQuestionMark;
	  }(),
	  // accessibility
	  isFocused: false
	};
	
	var DateInput =
	/*#__PURE__*/
	function (_ref) {
	  _inherits(DateInput, _ref);
	
	  _createClass(DateInput, [{
	    key: !_react["default"].PureComponent && "shouldComponentUpdate",
	    value: function () {
	      function value(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
	      }
	
	      return value;
	    }()
	  }]);
	
	  function DateInput(props) {
	    var _this;
	
	    _classCallCheck(this, DateInput);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateInput).call(this, props));
	    _this.state = {
	      dateString: '',
	      isTouchDevice: false
	    };
	    _this.onChange = _this.onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.setInputRef = _this.setInputRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.throttledKeyDown = (0, _throttle["default"])(_this.onFinalKeyDown, 300, {
	      trailing: false
	    });
	    return _this;
	  }
	
	  _createClass(DateInput, [{
	    key: "componentDidMount",
	    value: function () {
	      function componentDidMount() {
	        this.setState({
	          isTouchDevice: (0, _isTouchDevice["default"])()
	        });
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "componentWillReceiveProps",
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var dateString = this.state.dateString;
	
	        if (dateString && nextProps.displayValue) {
	          this.setState({
	            dateString: ''
	          });
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: "componentDidUpdate",
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var _this$props = this.props,
	            focused = _this$props.focused,
	            isFocused = _this$props.isFocused;
	        if (prevProps.focused === focused && prevProps.isFocused === isFocused) return;
	
	        if (focused && isFocused) {
	          this.inputRef.focus();
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: "onChange",
	    value: function () {
	      function onChange(e) {
	        var _this$props2 = this.props,
	            onChange = _this$props2.onChange,
	            onKeyDownQuestionMark = _this$props2.onKeyDownQuestionMark;
	        var dateString = e.target.value; // In Safari, onKeyDown does not consistently fire ahead of onChange. As a result, we need to
	        // special case the `?` key so that it always triggers the appropriate callback, instead of
	        // modifying the input value
	
	        if (dateString[dateString.length - 1] === '?') {
	          onKeyDownQuestionMark(e);
	        } else {
	          this.setState({
	            dateString: dateString
	          }, function () {
	            return onChange(dateString);
	          });
	        }
	      }
	
	      return onChange;
	    }()
	  }, {
	    key: "onKeyDown",
	    value: function () {
	      function onKeyDown(e) {
	        e.stopPropagation();
	
	        if (!_constants.MODIFIER_KEY_NAMES.has(e.key)) {
	          this.throttledKeyDown(e);
	        }
	      }
	
	      return onKeyDown;
	    }()
	  }, {
	    key: "onFinalKeyDown",
	    value: function () {
	      function onFinalKeyDown(e) {
	        var _this$props3 = this.props,
	            onKeyDownShiftTab = _this$props3.onKeyDownShiftTab,
	            onKeyDownTab = _this$props3.onKeyDownTab,
	            onKeyDownArrowDown = _this$props3.onKeyDownArrowDown,
	            onKeyDownQuestionMark = _this$props3.onKeyDownQuestionMark;
	        var key = e.key;
	
	        if (key === 'Tab') {
	          if (e.shiftKey) {
	            onKeyDownShiftTab(e);
	          } else {
	            onKeyDownTab(e);
	          }
	        } else if (key === 'ArrowDown') {
	          onKeyDownArrowDown(e);
	        } else if (key === '?') {
	          e.preventDefault();
	          onKeyDownQuestionMark(e);
	        }
	      }
	
	      return onFinalKeyDown;
	    }()
	  }, {
	    key: "setInputRef",
	    value: function () {
	      function setInputRef(ref) {
	        this.inputRef = ref;
	      }
	
	      return setInputRef;
	    }()
	  }, {
	    key: "render",
	    value: function () {
	      function render() {
	        var _this$state = this.state,
	            dateString = _this$state.dateString,
	            isTouch = _this$state.isTouchDevice;
	        var _this$props4 = this.props,
	            id = _this$props4.id,
	            placeholder = _this$props4.placeholder,
	            displayValue = _this$props4.displayValue,
	            screenReaderMessage = _this$props4.screenReaderMessage,
	            focused = _this$props4.focused,
	            showCaret = _this$props4.showCaret,
	            onFocus = _this$props4.onFocus,
	            disabled = _this$props4.disabled,
	            required = _this$props4.required,
	            readOnly = _this$props4.readOnly,
	            openDirection = _this$props4.openDirection,
	            verticalSpacing = _this$props4.verticalSpacing,
	            small = _this$props4.small,
	            regular = _this$props4.regular,
	            block = _this$props4.block,
	            styles = _this$props4.styles,
	            reactDates = _this$props4.theme.reactDates;
	        var value = dateString || displayValue || '';
	        var screenReaderMessageId = "DateInput__screen-reader-message-".concat(id);
	        var withFang = showCaret && focused;
	        var inputHeight = (0, _getInputHeight["default"])(reactDates, small);
	        return _react["default"].createElement("div", (0, _reactWithStyles.css)(styles.DateInput, small && styles.DateInput__small, block && styles.DateInput__block, withFang && styles.DateInput__withFang, disabled && styles.DateInput__disabled, withFang && openDirection === _constants.OPEN_DOWN && styles.DateInput__openDown, withFang && openDirection === _constants.OPEN_UP && styles.DateInput__openUp), _react["default"].createElement("input", _extends({}, (0, _reactWithStyles.css)(styles.DateInput_input, small && styles.DateInput_input__small, regular && styles.DateInput_input__regular, readOnly && styles.DateInput_input__readOnly, focused && styles.DateInput_input__focused, disabled && styles.DateInput_input__disabled), {
	          "aria-label": placeholder,
	          type: "text",
	          id: id,
	          name: id,
	          ref: this.setInputRef,
	          value: value,
	          onChange: this.onChange,
	          onKeyDown: this.onKeyDown,
	          onFocus: onFocus,
	          placeholder: placeholder,
	          autoComplete: "off",
	          disabled: disabled,
	          readOnly: typeof readOnly === 'boolean' ? readOnly : isTouch,
	          required: required,
	          "aria-describedby": screenReaderMessage && screenReaderMessageId
	        })), withFang && _react["default"].createElement("svg", _extends({
	          role: "presentation",
	          focusable: "false"
	        }, (0, _reactWithStyles.css)(styles.DateInput_fang, openDirection === _constants.OPEN_DOWN && {
	          top: inputHeight + verticalSpacing - _constants.FANG_HEIGHT_PX - 1
	        }, openDirection === _constants.OPEN_UP && {
	          bottom: inputHeight + verticalSpacing - _constants.FANG_HEIGHT_PX - 1
	        })), _react["default"].createElement("path", _extends({}, (0, _reactWithStyles.css)(styles.DateInput_fangShape), {
	          d: openDirection === _constants.OPEN_DOWN ? FANG_PATH_TOP : FANG_PATH_BOTTOM
	        })), _react["default"].createElement("path", _extends({}, (0, _reactWithStyles.css)(styles.DateInput_fangStroke), {
	          d: openDirection === _constants.OPEN_DOWN ? FANG_STROKE_TOP : FANG_STROKE_BOTTOM
	        }))), screenReaderMessage && _react["default"].createElement("p", _extends({}, (0, _reactWithStyles.css)(styles.DateInput_screenReaderMessage), {
	          id: screenReaderMessageId
	        }), screenReaderMessage));
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DateInput;
	}(_react["default"].PureComponent || _react["default"].Component);
	
	DateInput.propTypes =  false ? propTypes : {};
	DateInput.defaultProps = defaultProps;
	
	var _default = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var _ref2$reactDates = _ref2.reactDates,
	      border = _ref2$reactDates.border,
	      color = _ref2$reactDates.color,
	      sizing = _ref2$reactDates.sizing,
	      spacing = _ref2$reactDates.spacing,
	      font = _ref2$reactDates.font,
	      zIndex = _ref2$reactDates.zIndex;
	  return {
	    DateInput: {
	      margin: 0,
	      padding: spacing.inputPadding,
	      background: color.background,
	      position: 'relative',
	      display: 'inline-block',
	      width: sizing.inputWidth,
	      verticalAlign: 'middle'
	    },
	    DateInput__small: {
	      width: sizing.inputWidth_small
	    },
	    DateInput__block: {
	      width: '100%'
	    },
	    DateInput__disabled: {
	      background: color.disabled,
	      color: color.textDisabled
	    },
	    DateInput_input: {
	      fontWeight: 200,
	      fontSize: font.input.size,
	      lineHeight: font.input.lineHeight,
	      color: color.text,
	      backgroundColor: color.background,
	      width: '100%',
	      padding: "".concat(spacing.displayTextPaddingVertical, "px ").concat(spacing.displayTextPaddingHorizontal, "px"),
	      paddingTop: spacing.displayTextPaddingTop,
	      paddingBottom: spacing.displayTextPaddingBottom,
	      paddingLeft: (0, _noflip["default"])(spacing.displayTextPaddingLeft),
	      paddingRight: (0, _noflip["default"])(spacing.displayTextPaddingRight),
	      border: border.input.border,
	      borderTop: border.input.borderTop,
	      borderRight: (0, _noflip["default"])(border.input.borderRight),
	      borderBottom: border.input.borderBottom,
	      borderLeft: (0, _noflip["default"])(border.input.borderLeft),
	      borderRadius: border.input.borderRadius
	    },
	    DateInput_input__small: {
	      fontSize: font.input.size_small,
	      lineHeight: font.input.lineHeight_small,
	      letterSpacing: font.input.letterSpacing_small,
	      padding: "".concat(spacing.displayTextPaddingVertical_small, "px ").concat(spacing.displayTextPaddingHorizontal_small, "px"),
	      paddingTop: spacing.displayTextPaddingTop_small,
	      paddingBottom: spacing.displayTextPaddingBottom_small,
	      paddingLeft: (0, _noflip["default"])(spacing.displayTextPaddingLeft_small),
	      paddingRight: (0, _noflip["default"])(spacing.displayTextPaddingRight_small)
	    },
	    DateInput_input__regular: {
	      fontWeight: 'auto'
	    },
	    DateInput_input__readOnly: {
	      userSelect: 'none'
	    },
	    DateInput_input__focused: {
	      outline: border.input.outlineFocused,
	      background: color.backgroundFocused,
	      border: border.input.borderFocused,
	      borderTop: border.input.borderTopFocused,
	      borderRight: (0, _noflip["default"])(border.input.borderRightFocused),
	      borderBottom: border.input.borderBottomFocused,
	      borderLeft: (0, _noflip["default"])(border.input.borderLeftFocused)
	    },
	    DateInput_input__disabled: {
	      background: color.disabled,
	      fontStyle: font.input.styleDisabled
	    },
	    DateInput_screenReaderMessage: {
	      border: 0,
	      clip: 'rect(0, 0, 0, 0)',
	      height: 1,
	      margin: -1,
	      overflow: 'hidden',
	      padding: 0,
	      position: 'absolute',
	      width: 1
	    },
	    DateInput_fang: {
	      position: 'absolute',
	      width: _constants.FANG_WIDTH_PX,
	      height: _constants.FANG_HEIGHT_PX,
	      left: 22,
	      // TODO: should be noflip wrapped and handled by an isRTL prop
	      zIndex: zIndex + 2
	    },
	    DateInput_fangShape: {
	      fill: color.background
	    },
	    DateInput_fangStroke: {
	      stroke: color.core.border,
	      fill: 'transparent'
	    }
	  };
	}, {
	  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
	})(DateInput);
	
	exports["default"] = _default;

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _defaultPhrases = __webpack_require__(51);
	
	var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(60));
	
	var _noflip = _interopRequireDefault(__webpack_require__(127));
	
	var _OpenDirectionShape = _interopRequireDefault(__webpack_require__(146));
	
	var _DateInput = _interopRequireDefault(__webpack_require__(854));
	
	var _IconPositionShape = _interopRequireDefault(__webpack_require__(174));
	
	var _DisabledShape = _interopRequireDefault(__webpack_require__(224));
	
	var _RightArrow = _interopRequireDefault(__webpack_require__(860));
	
	var _LeftArrow = _interopRequireDefault(__webpack_require__(859));
	
	var _CloseButton = _interopRequireDefault(__webpack_require__(222));
	
	var _CalendarIcon = _interopRequireDefault(__webpack_require__(851));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
	  children: _propTypes["default"].node,
	  startDateId: _propTypes["default"].string,
	  startDatePlaceholderText: _propTypes["default"].string,
	  screenReaderMessage: _propTypes["default"].string,
	  endDateId: _propTypes["default"].string,
	  endDatePlaceholderText: _propTypes["default"].string,
	  onStartDateFocus: _propTypes["default"].func,
	  onEndDateFocus: _propTypes["default"].func,
	  onStartDateChange: _propTypes["default"].func,
	  onEndDateChange: _propTypes["default"].func,
	  onStartDateShiftTab: _propTypes["default"].func,
	  onEndDateTab: _propTypes["default"].func,
	  onClearDates: _propTypes["default"].func,
	  onKeyDownArrowDown: _propTypes["default"].func,
	  onKeyDownQuestionMark: _propTypes["default"].func,
	  startDate: _propTypes["default"].string,
	  endDate: _propTypes["default"].string,
	  isStartDateFocused: _propTypes["default"].bool,
	  isEndDateFocused: _propTypes["default"].bool,
	  showClearDates: _propTypes["default"].bool,
	  disabled: _DisabledShape["default"],
	  required: _propTypes["default"].bool,
	  readOnly: _propTypes["default"].bool,
	  openDirection: _OpenDirectionShape["default"],
	  showCaret: _propTypes["default"].bool,
	  showDefaultInputIcon: _propTypes["default"].bool,
	  inputIconPosition: _IconPositionShape["default"],
	  customInputIcon: _propTypes["default"].node,
	  customArrowIcon: _propTypes["default"].node,
	  customCloseIcon: _propTypes["default"].node,
	  noBorder: _propTypes["default"].bool,
	  block: _propTypes["default"].bool,
	  small: _propTypes["default"].bool,
	  regular: _propTypes["default"].bool,
	  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
	  // accessibility
	  isFocused: _propTypes["default"].bool,
	  // describes actual DOM focus
	  // i18n
	  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.DateRangePickerInputPhrases)),
	  isRTL: _propTypes["default"].bool
	})) : {};
	var defaultProps = {
	  children: null,
	  startDateId: _constants.START_DATE,
	  endDateId: _constants.END_DATE,
	  startDatePlaceholderText: 'Start Date',
	  endDatePlaceholderText: 'End Date',
	  screenReaderMessage: '',
	  onStartDateFocus: function () {
	    function onStartDateFocus() {}
	
	    return onStartDateFocus;
	  }(),
	  onEndDateFocus: function () {
	    function onEndDateFocus() {}
	
	    return onEndDateFocus;
	  }(),
	  onStartDateChange: function () {
	    function onStartDateChange() {}
	
	    return onStartDateChange;
	  }(),
	  onEndDateChange: function () {
	    function onEndDateChange() {}
	
	    return onEndDateChange;
	  }(),
	  onStartDateShiftTab: function () {
	    function onStartDateShiftTab() {}
	
	    return onStartDateShiftTab;
	  }(),
	  onEndDateTab: function () {
	    function onEndDateTab() {}
	
	    return onEndDateTab;
	  }(),
	  onClearDates: function () {
	    function onClearDates() {}
	
	    return onClearDates;
	  }(),
	  onKeyDownArrowDown: function () {
	    function onKeyDownArrowDown() {}
	
	    return onKeyDownArrowDown;
	  }(),
	  onKeyDownQuestionMark: function () {
	    function onKeyDownQuestionMark() {}
	
	    return onKeyDownQuestionMark;
	  }(),
	  startDate: '',
	  endDate: '',
	  isStartDateFocused: false,
	  isEndDateFocused: false,
	  showClearDates: false,
	  disabled: false,
	  required: false,
	  readOnly: false,
	  openDirection: _constants.OPEN_DOWN,
	  showCaret: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  customInputIcon: null,
	  customArrowIcon: null,
	  customCloseIcon: null,
	  noBorder: false,
	  block: false,
	  small: false,
	  regular: false,
	  verticalSpacing: undefined,
	  // accessibility
	  isFocused: false,
	  // i18n
	  phrases: _defaultPhrases.DateRangePickerInputPhrases,
	  isRTL: false
	};
	
	function DateRangePickerInput(_ref) {
	  var children = _ref.children,
	      startDate = _ref.startDate,
	      startDateId = _ref.startDateId,
	      startDatePlaceholderText = _ref.startDatePlaceholderText,
	      screenReaderMessage = _ref.screenReaderMessage,
	      isStartDateFocused = _ref.isStartDateFocused,
	      onStartDateChange = _ref.onStartDateChange,
	      onStartDateFocus = _ref.onStartDateFocus,
	      onStartDateShiftTab = _ref.onStartDateShiftTab,
	      endDate = _ref.endDate,
	      endDateId = _ref.endDateId,
	      endDatePlaceholderText = _ref.endDatePlaceholderText,
	      isEndDateFocused = _ref.isEndDateFocused,
	      onEndDateChange = _ref.onEndDateChange,
	      onEndDateFocus = _ref.onEndDateFocus,
	      onEndDateTab = _ref.onEndDateTab,
	      onKeyDownArrowDown = _ref.onKeyDownArrowDown,
	      onKeyDownQuestionMark = _ref.onKeyDownQuestionMark,
	      onClearDates = _ref.onClearDates,
	      showClearDates = _ref.showClearDates,
	      disabled = _ref.disabled,
	      required = _ref.required,
	      readOnly = _ref.readOnly,
	      showCaret = _ref.showCaret,
	      openDirection = _ref.openDirection,
	      showDefaultInputIcon = _ref.showDefaultInputIcon,
	      inputIconPosition = _ref.inputIconPosition,
	      customInputIcon = _ref.customInputIcon,
	      customArrowIcon = _ref.customArrowIcon,
	      customCloseIcon = _ref.customCloseIcon,
	      isFocused = _ref.isFocused,
	      phrases = _ref.phrases,
	      isRTL = _ref.isRTL,
	      noBorder = _ref.noBorder,
	      block = _ref.block,
	      verticalSpacing = _ref.verticalSpacing,
	      small = _ref.small,
	      regular = _ref.regular,
	      styles = _ref.styles;
	
	  var calendarIcon = customInputIcon || _react["default"].createElement(_CalendarIcon["default"], (0, _reactWithStyles.css)(styles.DateRangePickerInput_calendarIcon_svg));
	
	  var arrowIcon = customArrowIcon || _react["default"].createElement(_RightArrow["default"], (0, _reactWithStyles.css)(styles.DateRangePickerInput_arrow_svg));
	
	  if (isRTL) arrowIcon = _react["default"].createElement(_LeftArrow["default"], (0, _reactWithStyles.css)(styles.DateRangePickerInput_arrow_svg));
	  if (small) arrowIcon = '-';
	
	  var closeIcon = customCloseIcon || _react["default"].createElement(_CloseButton["default"], (0, _reactWithStyles.css)(styles.DateRangePickerInput_clearDates_svg, small && styles.DateRangePickerInput_clearDates_svg__small));
	
	  var screenReaderText = screenReaderMessage || phrases.keyboardNavigationInstructions;
	
	  var inputIcon = (showDefaultInputIcon || customInputIcon !== null) && _react["default"].createElement("button", _extends({}, (0, _reactWithStyles.css)(styles.DateRangePickerInput_calendarIcon), {
	    type: "button",
	    disabled: disabled,
	    "aria-label": phrases.focusStartDate,
	    onClick: onKeyDownArrowDown
	  }), calendarIcon);
	
	  var startDateDisabled = disabled === _constants.START_DATE || disabled === true;
	  var endDateDisabled = disabled === _constants.END_DATE || disabled === true;
	  return _react["default"].createElement("div", (0, _reactWithStyles.css)(styles.DateRangePickerInput, disabled && styles.DateRangePickerInput__disabled, isRTL && styles.DateRangePickerInput__rtl, !noBorder && styles.DateRangePickerInput__withBorder, block && styles.DateRangePickerInput__block, showClearDates && styles.DateRangePickerInput__showClearDates), inputIconPosition === _constants.ICON_BEFORE_POSITION && inputIcon, _react["default"].createElement(_DateInput["default"], {
	    id: startDateId,
	    placeholder: startDatePlaceholderText,
	    displayValue: startDate,
	    screenReaderMessage: screenReaderText,
	    focused: isStartDateFocused,
	    isFocused: isFocused,
	    disabled: startDateDisabled,
	    required: required,
	    readOnly: readOnly,
	    showCaret: showCaret,
	    openDirection: openDirection,
	    onChange: onStartDateChange,
	    onFocus: onStartDateFocus,
	    onKeyDownShiftTab: onStartDateShiftTab,
	    onKeyDownArrowDown: onKeyDownArrowDown,
	    onKeyDownQuestionMark: onKeyDownQuestionMark,
	    verticalSpacing: verticalSpacing,
	    small: small,
	    regular: regular
	  }), _react["default"].createElement("div", _extends({}, (0, _reactWithStyles.css)(styles.DateRangePickerInput_arrow), {
	    "aria-hidden": "true",
	    role: "presentation"
	  }), arrowIcon), isStartDateFocused && children, _react["default"].createElement(_DateInput["default"], {
	    id: endDateId,
	    placeholder: endDatePlaceholderText,
	    displayValue: endDate,
	    screenReaderMessage: screenReaderText,
	    focused: isEndDateFocused,
	    isFocused: isFocused,
	    disabled: endDateDisabled,
	    required: required,
	    readOnly: readOnly,
	    showCaret: showCaret,
	    openDirection: openDirection,
	    onChange: onEndDateChange,
	    onFocus: onEndDateFocus,
	    onKeyDownArrowDown: onKeyDownArrowDown,
	    onKeyDownQuestionMark: onKeyDownQuestionMark,
	    onKeyDownTab: onEndDateTab,
	    verticalSpacing: verticalSpacing,
	    small: small,
	    regular: regular
	  }), isEndDateFocused && children, showClearDates && _react["default"].createElement("button", _extends({
	    type: "button",
	    "aria-label": phrases.clearDates
	  }, (0, _reactWithStyles.css)(styles.DateRangePickerInput_clearDates, small && styles.DateRangePickerInput_clearDates__small, !customCloseIcon && styles.DateRangePickerInput_clearDates_default, !(startDate || endDate) && styles.DateRangePickerInput_clearDates__hide), {
	    onClick: onClearDates,
	    disabled: disabled
	  }), closeIcon), inputIconPosition === _constants.ICON_AFTER_POSITION && inputIcon);
	}
	
	DateRangePickerInput.propTypes =  false ? propTypes : {};
	DateRangePickerInput.defaultProps = defaultProps;
	
	var _default = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var _ref2$reactDates = _ref2.reactDates,
	      border = _ref2$reactDates.border,
	      color = _ref2$reactDates.color,
	      sizing = _ref2$reactDates.sizing;
	  return {
	    DateRangePickerInput: {
	      backgroundColor: color.background,
	      display: 'inline-block'
	    },
	    DateRangePickerInput__disabled: {
	      background: color.disabled
	    },
	    DateRangePickerInput__withBorder: {
	      borderColor: color.border,
	      borderWidth: border.pickerInput.borderWidth,
	      borderStyle: border.pickerInput.borderStyle,
	      borderRadius: border.pickerInput.borderRadius
	    },
	    DateRangePickerInput__rtl: {
	      direction: (0, _noflip["default"])('rtl')
	    },
	    DateRangePickerInput__block: {
	      display: 'block'
	    },
	    DateRangePickerInput__showClearDates: {
	      paddingRight: 30 // TODO: should be noflip wrapped and handled by an isRTL prop
	
	    },
	    DateRangePickerInput_arrow: {
	      display: 'inline-block',
	      verticalAlign: 'middle',
	      color: color.text
	    },
	    DateRangePickerInput_arrow_svg: {
	      verticalAlign: 'middle',
	      fill: color.text,
	      height: sizing.arrowWidth,
	      width: sizing.arrowWidth
	    },
	    DateRangePickerInput_clearDates: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	      cursor: 'pointer',
	      padding: 10,
	      margin: '0 10px 0 5px',
	      // TODO: should be noflip wrapped and handled by an isRTL prop
	      position: 'absolute',
	      right: 0,
	      // TODO: should be noflip wrapped and handled by an isRTL prop
	      top: '50%',
	      transform: 'translateY(-50%)'
	    },
	    DateRangePickerInput_clearDates__small: {
	      padding: 6
	    },
	    DateRangePickerInput_clearDates_default: {
	      ':focus': {
	        background: color.core.border,
	        borderRadius: '50%'
	      },
	      ':hover': {
	        background: color.core.border,
	        borderRadius: '50%'
	      }
	    },
	    DateRangePickerInput_clearDates__hide: {
	      visibility: 'hidden'
	    },
	    DateRangePickerInput_clearDates_svg: {
	      fill: color.core.grayLight,
	      height: 12,
	      width: 15,
	      verticalAlign: 'middle'
	    },
	    DateRangePickerInput_clearDates_svg__small: {
	      height: 9
	    },
	    DateRangePickerInput_calendarIcon: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	      cursor: 'pointer',
	      display: 'inline-block',
	      verticalAlign: 'middle',
	      padding: 10,
	      margin: '0 5px 0 10px' // TODO: should be noflip wrapped and handled by an isRTL prop
	
	    },
	    DateRangePickerInput_calendarIcon_svg: {
	      fill: color.core.grayLight,
	      height: 15,
	      width: 14,
	      verticalAlign: 'middle'
	    }
	  };
	}, {
	  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
	})(DateRangePickerInput);
	
	exports["default"] = _default;

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _reactAddonsShallowCompare = _interopRequireDefault(__webpack_require__(70));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(105));
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _OpenDirectionShape = _interopRequireDefault(__webpack_require__(146));
	
	var _defaultPhrases = __webpack_require__(51);
	
	var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(60));
	
	var _DateRangePickerInput = _interopRequireDefault(__webpack_require__(855));
	
	var _IconPositionShape = _interopRequireDefault(__webpack_require__(174));
	
	var _DisabledShape = _interopRequireDefault(__webpack_require__(224));
	
	var _toMomentObject = _interopRequireDefault(__webpack_require__(178));
	
	var _toLocalizedDateString = _interopRequireDefault(__webpack_require__(437));
	
	var _isInclusivelyAfterDay = _interopRequireDefault(__webpack_require__(176));
	
	var _isBeforeDay = _interopRequireDefault(__webpack_require__(225));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () { function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); } return _getPrototypeOf; }(); return _getPrototypeOf(o); }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function () { function _setPrototypeOf(o, p) { o.__proto__ = p; return o; } return _setPrototypeOf; }(); return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)({
	  children: _propTypes["default"].node,
	  startDate: _reactMomentProptypes["default"].momentObj,
	  startDateId: _propTypes["default"].string,
	  startDatePlaceholderText: _propTypes["default"].string,
	  isStartDateFocused: _propTypes["default"].bool,
	  endDate: _reactMomentProptypes["default"].momentObj,
	  endDateId: _propTypes["default"].string,
	  endDatePlaceholderText: _propTypes["default"].string,
	  isEndDateFocused: _propTypes["default"].bool,
	  screenReaderMessage: _propTypes["default"].string,
	  showClearDates: _propTypes["default"].bool,
	  showCaret: _propTypes["default"].bool,
	  showDefaultInputIcon: _propTypes["default"].bool,
	  inputIconPosition: _IconPositionShape["default"],
	  disabled: _DisabledShape["default"],
	  required: _propTypes["default"].bool,
	  readOnly: _propTypes["default"].bool,
	  openDirection: _OpenDirectionShape["default"],
	  noBorder: _propTypes["default"].bool,
	  block: _propTypes["default"].bool,
	  small: _propTypes["default"].bool,
	  regular: _propTypes["default"].bool,
	  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
	  keepOpenOnDateSelect: _propTypes["default"].bool,
	  reopenPickerOnClearDates: _propTypes["default"].bool,
	  withFullScreenPortal: _propTypes["default"].bool,
	  minimumNights: _airbnbPropTypes.nonNegativeInteger,
	  isOutsideRange: _propTypes["default"].func,
	  displayFormat: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
	  onFocusChange: _propTypes["default"].func,
	  onClose: _propTypes["default"].func,
	  onDatesChange: _propTypes["default"].func,
	  onKeyDownArrowDown: _propTypes["default"].func,
	  onKeyDownQuestionMark: _propTypes["default"].func,
	  customInputIcon: _propTypes["default"].node,
	  customArrowIcon: _propTypes["default"].node,
	  customCloseIcon: _propTypes["default"].node,
	  // accessibility
	  isFocused: _propTypes["default"].bool,
	  // i18n
	  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.DateRangePickerInputPhrases)),
	  isRTL: _propTypes["default"].bool
	}) : {};
	var defaultProps = {
	  children: null,
	  startDate: null,
	  startDateId: _constants.START_DATE,
	  startDatePlaceholderText: 'Start Date',
	  isStartDateFocused: false,
	  endDate: null,
	  endDateId: _constants.END_DATE,
	  endDatePlaceholderText: 'End Date',
	  isEndDateFocused: false,
	  screenReaderMessage: '',
	  showClearDates: false,
	  showCaret: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  disabled: false,
	  required: false,
	  readOnly: false,
	  openDirection: _constants.OPEN_DOWN,
	  noBorder: false,
	  block: false,
	  small: false,
	  regular: false,
	  verticalSpacing: undefined,
	  keepOpenOnDateSelect: false,
	  reopenPickerOnClearDates: false,
	  withFullScreenPortal: false,
	  minimumNights: 1,
	  isOutsideRange: function () {
	    function isOutsideRange(day) {
	      return !(0, _isInclusivelyAfterDay["default"])(day, (0, _moment["default"])());
	    }
	
	    return isOutsideRange;
	  }(),
	  displayFormat: function () {
	    function displayFormat() {
	      return _moment["default"].localeData().longDateFormat('L');
	    }
	
	    return displayFormat;
	  }(),
	  onFocusChange: function () {
	    function onFocusChange() {}
	
	    return onFocusChange;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	  onDatesChange: function () {
	    function onDatesChange() {}
	
	    return onDatesChange;
	  }(),
	  onKeyDownArrowDown: function () {
	    function onKeyDownArrowDown() {}
	
	    return onKeyDownArrowDown;
	  }(),
	  onKeyDownQuestionMark: function () {
	    function onKeyDownQuestionMark() {}
	
	    return onKeyDownQuestionMark;
	  }(),
	  customInputIcon: null,
	  customArrowIcon: null,
	  customCloseIcon: null,
	  // accessibility
	  isFocused: false,
	  // i18n
	  phrases: _defaultPhrases.DateRangePickerInputPhrases,
	  isRTL: false
	};
	
	var DateRangePickerInputController =
	/*#__PURE__*/
	function (_ref) {
	  _inherits(DateRangePickerInputController, _ref);
	
	  _createClass(DateRangePickerInputController, [{
	    key: !_react["default"].PureComponent && "shouldComponentUpdate",
	    value: function () {
	      function value(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
	      }
	
	      return value;
	    }()
	  }]);
	
	  function DateRangePickerInputController(props) {
	    var _this;
	
	    _classCallCheck(this, DateRangePickerInputController);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateRangePickerInputController).call(this, props));
	    _this.onClearFocus = _this.onClearFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onStartDateChange = _this.onStartDateChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onStartDateFocus = _this.onStartDateFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onEndDateChange = _this.onEndDateChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onEndDateFocus = _this.onEndDateFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.clearDates = _this.clearDates.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    return _this;
	  }
	
	  _createClass(DateRangePickerInputController, [{
	    key: "onClearFocus",
	    value: function () {
	      function onClearFocus() {
	        var _this$props = this.props,
	            onFocusChange = _this$props.onFocusChange,
	            onClose = _this$props.onClose,
	            startDate = _this$props.startDate,
	            endDate = _this$props.endDate;
	        onFocusChange(null);
	        onClose({
	          startDate: startDate,
	          endDate: endDate
	        });
	      }
	
	      return onClearFocus;
	    }()
	  }, {
	    key: "onEndDateChange",
	    value: function () {
	      function onEndDateChange(endDateString) {
	        var _this$props2 = this.props,
	            startDate = _this$props2.startDate,
	            isOutsideRange = _this$props2.isOutsideRange,
	            minimumNights = _this$props2.minimumNights,
	            keepOpenOnDateSelect = _this$props2.keepOpenOnDateSelect,
	            onDatesChange = _this$props2.onDatesChange;
	        var endDate = (0, _toMomentObject["default"])(endDateString, this.getDisplayFormat());
	        var isEndDateValid = endDate && !isOutsideRange(endDate) && !(startDate && (0, _isBeforeDay["default"])(endDate, startDate.clone().add(minimumNights, 'days')));
	
	        if (isEndDateValid) {
	          onDatesChange({
	            startDate: startDate,
	            endDate: endDate
	          });
	          if (!keepOpenOnDateSelect) this.onClearFocus();
	        } else {
	          onDatesChange({
	            startDate: startDate,
	            endDate: null
	          });
	        }
	      }
	
	      return onEndDateChange;
	    }()
	  }, {
	    key: "onEndDateFocus",
	    value: function () {
	      function onEndDateFocus() {
	        var _this$props3 = this.props,
	            startDate = _this$props3.startDate,
	            onFocusChange = _this$props3.onFocusChange,
	            withFullScreenPortal = _this$props3.withFullScreenPortal,
	            disabled = _this$props3.disabled;
	
	        if (!startDate && withFullScreenPortal && (!disabled || disabled === _constants.END_DATE)) {
	          // When the datepicker is full screen, we never want to focus the end date first
	          // because there's no indication that that is the case once the datepicker is open and it
	          // might confuse the user
	          onFocusChange(_constants.START_DATE);
	        } else if (!disabled || disabled === _constants.START_DATE) {
	          onFocusChange(_constants.END_DATE);
	        }
	      }
	
	      return onEndDateFocus;
	    }()
	  }, {
	    key: "onStartDateChange",
	    value: function () {
	      function onStartDateChange(startDateString) {
	        var endDate = this.props.endDate;
	        var _this$props4 = this.props,
	            isOutsideRange = _this$props4.isOutsideRange,
	            minimumNights = _this$props4.minimumNights,
	            onDatesChange = _this$props4.onDatesChange,
	            onFocusChange = _this$props4.onFocusChange,
	            disabled = _this$props4.disabled;
	        var startDate = (0, _toMomentObject["default"])(startDateString, this.getDisplayFormat());
	        var isEndDateBeforeStartDate = startDate && (0, _isBeforeDay["default"])(endDate, startDate.clone().add(minimumNights, 'days'));
	        var isStartDateValid = startDate && !isOutsideRange(startDate) && !(disabled === _constants.END_DATE && isEndDateBeforeStartDate);
	
	        if (isStartDateValid) {
	          if (isEndDateBeforeStartDate) {
	            endDate = null;
	          }
	
	          onDatesChange({
	            startDate: startDate,
	            endDate: endDate
	          });
	          onFocusChange(_constants.END_DATE);
	        } else {
	          onDatesChange({
	            startDate: null,
	            endDate: endDate
	          });
	        }
	      }
	
	      return onStartDateChange;
	    }()
	  }, {
	    key: "onStartDateFocus",
	    value: function () {
	      function onStartDateFocus() {
	        var _this$props5 = this.props,
	            disabled = _this$props5.disabled,
	            onFocusChange = _this$props5.onFocusChange;
	
	        if (!disabled || disabled === _constants.END_DATE) {
	          onFocusChange(_constants.START_DATE);
	        }
	      }
	
	      return onStartDateFocus;
	    }()
	  }, {
	    key: "getDisplayFormat",
	    value: function () {
	      function getDisplayFormat() {
	        var displayFormat = this.props.displayFormat;
	        return typeof displayFormat === 'string' ? displayFormat : displayFormat();
	      }
	
	      return getDisplayFormat;
	    }()
	  }, {
	    key: "getDateString",
	    value: function () {
	      function getDateString(date) {
	        var displayFormat = this.getDisplayFormat();
	
	        if (date && displayFormat) {
	          return date && date.format(displayFormat);
	        }
	
	        return (0, _toLocalizedDateString["default"])(date);
	      }
	
	      return getDateString;
	    }()
	  }, {
	    key: "clearDates",
	    value: function () {
	      function clearDates() {
	        var _this$props6 = this.props,
	            onDatesChange = _this$props6.onDatesChange,
	            reopenPickerOnClearDates = _this$props6.reopenPickerOnClearDates,
	            onFocusChange = _this$props6.onFocusChange;
	        onDatesChange({
	          startDate: null,
	          endDate: null
	        });
	
	        if (reopenPickerOnClearDates) {
	          onFocusChange(_constants.START_DATE);
	        }
	      }
	
	      return clearDates;
	    }()
	  }, {
	    key: "render",
	    value: function () {
	      function render() {
	        var _this$props7 = this.props,
	            children = _this$props7.children,
	            startDate = _this$props7.startDate,
	            startDateId = _this$props7.startDateId,
	            startDatePlaceholderText = _this$props7.startDatePlaceholderText,
	            isStartDateFocused = _this$props7.isStartDateFocused,
	            endDate = _this$props7.endDate,
	            endDateId = _this$props7.endDateId,
	            endDatePlaceholderText = _this$props7.endDatePlaceholderText,
	            isEndDateFocused = _this$props7.isEndDateFocused,
	            screenReaderMessage = _this$props7.screenReaderMessage,
	            showClearDates = _this$props7.showClearDates,
	            showCaret = _this$props7.showCaret,
	            showDefaultInputIcon = _this$props7.showDefaultInputIcon,
	            inputIconPosition = _this$props7.inputIconPosition,
	            customInputIcon = _this$props7.customInputIcon,
	            customArrowIcon = _this$props7.customArrowIcon,
	            customCloseIcon = _this$props7.customCloseIcon,
	            disabled = _this$props7.disabled,
	            required = _this$props7.required,
	            readOnly = _this$props7.readOnly,
	            openDirection = _this$props7.openDirection,
	            isFocused = _this$props7.isFocused,
	            phrases = _this$props7.phrases,
	            onKeyDownArrowDown = _this$props7.onKeyDownArrowDown,
	            onKeyDownQuestionMark = _this$props7.onKeyDownQuestionMark,
	            isRTL = _this$props7.isRTL,
	            noBorder = _this$props7.noBorder,
	            block = _this$props7.block,
	            small = _this$props7.small,
	            regular = _this$props7.regular,
	            verticalSpacing = _this$props7.verticalSpacing;
	        var startDateString = this.getDateString(startDate);
	        var endDateString = this.getDateString(endDate);
	        return _react["default"].createElement(_DateRangePickerInput["default"], {
	          startDate: startDateString,
	          startDateId: startDateId,
	          startDatePlaceholderText: startDatePlaceholderText,
	          isStartDateFocused: isStartDateFocused,
	          endDate: endDateString,
	          endDateId: endDateId,
	          endDatePlaceholderText: endDatePlaceholderText,
	          isEndDateFocused: isEndDateFocused,
	          isFocused: isFocused,
	          disabled: disabled,
	          required: required,
	          readOnly: readOnly,
	          openDirection: openDirection,
	          showCaret: showCaret,
	          showDefaultInputIcon: showDefaultInputIcon,
	          inputIconPosition: inputIconPosition,
	          customInputIcon: customInputIcon,
	          customArrowIcon: customArrowIcon,
	          customCloseIcon: customCloseIcon,
	          phrases: phrases,
	          onStartDateChange: this.onStartDateChange,
	          onStartDateFocus: this.onStartDateFocus,
	          onStartDateShiftTab: this.onClearFocus,
	          onEndDateChange: this.onEndDateChange,
	          onEndDateFocus: this.onEndDateFocus,
	          showClearDates: showClearDates,
	          onClearDates: this.clearDates,
	          screenReaderMessage: screenReaderMessage,
	          onKeyDownArrowDown: onKeyDownArrowDown,
	          onKeyDownQuestionMark: onKeyDownQuestionMark,
	          isRTL: isRTL,
	          noBorder: noBorder,
	          block: block,
	          small: small,
	          regular: regular,
	          verticalSpacing: verticalSpacing
	        }, children);
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DateRangePickerInputController;
	}(_react["default"].PureComponent || _react["default"].Component);
	
	exports["default"] = DateRangePickerInputController;
	DateRangePickerInputController.propTypes =  false ? propTypes : {};
	DateRangePickerInputController.defaultProps = defaultProps;

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _reactAddonsShallowCompare = _interopRequireDefault(__webpack_require__(70));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(105));
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _object = _interopRequireDefault(__webpack_require__(422));
	
	var _isTouchDevice = _interopRequireDefault(__webpack_require__(171));
	
	var _defaultPhrases = __webpack_require__(51);
	
	var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(60));
	
	var _isInclusivelyAfterDay = _interopRequireDefault(__webpack_require__(176));
	
	var _isNextDay = _interopRequireDefault(__webpack_require__(875));
	
	var _isSameDay = _interopRequireDefault(__webpack_require__(177));
	
	var _isAfterDay = _interopRequireDefault(__webpack_require__(290));
	
	var _isBeforeDay = _interopRequireDefault(__webpack_require__(225));
	
	var _getVisibleDays = _interopRequireDefault(__webpack_require__(874));
	
	var _isDayVisible = _interopRequireDefault(__webpack_require__(436));
	
	var _getSelectedDateOffset = _interopRequireDefault(__webpack_require__(1822));
	
	var _toISODateString = _interopRequireDefault(__webpack_require__(291));
	
	var _toISOMonthString = _interopRequireDefault(__webpack_require__(292));
	
	var _DisabledShape = _interopRequireDefault(__webpack_require__(224));
	
	var _FocusedInputShape = _interopRequireDefault(__webpack_require__(864));
	
	var _ScrollableOrientationShape = _interopRequireDefault(__webpack_require__(175));
	
	var _DayOfWeekShape = _interopRequireDefault(__webpack_require__(145));
	
	var _CalendarInfoPositionShape = _interopRequireDefault(__webpack_require__(223));
	
	var _constants = __webpack_require__(21);
	
	var _DayPicker = _interopRequireDefault(__webpack_require__(434));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () { function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); } return _getPrototypeOf; }(); return _getPrototypeOf(o); }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function () { function _setPrototypeOf(o, p) { o.__proto__ = p; return o; } return _setPrototypeOf; }(); return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)({
	  startDate: _reactMomentProptypes["default"].momentObj,
	  endDate: _reactMomentProptypes["default"].momentObj,
	  onDatesChange: _propTypes["default"].func,
	  startDateOffset: _propTypes["default"].func,
	  endDateOffset: _propTypes["default"].func,
	  minDate: _reactMomentProptypes["default"].momentObj,
	  maxDate: _reactMomentProptypes["default"].momentObj,
	  focusedInput: _FocusedInputShape["default"],
	  onFocusChange: _propTypes["default"].func,
	  onClose: _propTypes["default"].func,
	  keepOpenOnDateSelect: _propTypes["default"].bool,
	  minimumNights: _propTypes["default"].number,
	  disabled: _DisabledShape["default"],
	  isOutsideRange: _propTypes["default"].func,
	  isDayBlocked: _propTypes["default"].func,
	  isDayHighlighted: _propTypes["default"].func,
	  // DayPicker props
	  renderMonthText: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
	  renderMonthElement: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
	  enableOutsideDays: _propTypes["default"].bool,
	  numberOfMonths: _propTypes["default"].number,
	  orientation: _ScrollableOrientationShape["default"],
	  withPortal: _propTypes["default"].bool,
	  initialVisibleMonth: _propTypes["default"].func,
	  hideKeyboardShortcutsPanel: _propTypes["default"].bool,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  noBorder: _propTypes["default"].bool,
	  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
	  horizontalMonthPadding: _airbnbPropTypes.nonNegativeInteger,
	  navPrev: _propTypes["default"].node,
	  navNext: _propTypes["default"].node,
	  noNavButtons: _propTypes["default"].bool,
	  onPrevMonthClick: _propTypes["default"].func,
	  onNextMonthClick: _propTypes["default"].func,
	  onOutsideClick: _propTypes["default"].func,
	  renderCalendarDay: _propTypes["default"].func,
	  renderDayContents: _propTypes["default"].func,
	  renderCalendarInfo: _propTypes["default"].func,
	  calendarInfoPosition: _CalendarInfoPositionShape["default"],
	  firstDayOfWeek: _DayOfWeekShape["default"],
	  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
	  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
	  // accessibility
	  onBlur: _propTypes["default"].func,
	  isFocused: _propTypes["default"].bool,
	  showKeyboardShortcuts: _propTypes["default"].bool,
	  onTab: _propTypes["default"].func,
	  onShiftTab: _propTypes["default"].func,
	  // i18n
	  monthFormat: _propTypes["default"].string,
	  weekDayFormat: _propTypes["default"].string,
	  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.DayPickerPhrases)),
	  dayAriaLabelFormat: _propTypes["default"].string,
	  isRTL: _propTypes["default"].bool
	}) : {};
	var defaultProps = {
	  startDate: undefined,
	  // TODO: use null
	  endDate: undefined,
	  // TODO: use null
	  minDate: null,
	  maxDate: null,
	  onDatesChange: function () {
	    function onDatesChange() {}
	
	    return onDatesChange;
	  }(),
	  startDateOffset: undefined,
	  endDateOffset: undefined,
	  focusedInput: null,
	  onFocusChange: function () {
	    function onFocusChange() {}
	
	    return onFocusChange;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	  keepOpenOnDateSelect: false,
	  minimumNights: 1,
	  disabled: false,
	  isOutsideRange: function () {
	    function isOutsideRange() {}
	
	    return isOutsideRange;
	  }(),
	  isDayBlocked: function () {
	    function isDayBlocked() {}
	
	    return isDayBlocked;
	  }(),
	  isDayHighlighted: function () {
	    function isDayHighlighted() {}
	
	    return isDayHighlighted;
	  }(),
	  // DayPicker props
	  renderMonthText: null,
	  enableOutsideDays: false,
	  numberOfMonths: 1,
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  withPortal: false,
	  hideKeyboardShortcutsPanel: false,
	  initialVisibleMonth: null,
	  daySize: _constants.DAY_SIZE,
	  navPrev: null,
	  navNext: null,
	  noNavButtons: false,
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	  onOutsideClick: function () {
	    function onOutsideClick() {}
	
	    return onOutsideClick;
	  }(),
	  renderCalendarDay: undefined,
	  renderDayContents: null,
	  renderCalendarInfo: null,
	  renderMonthElement: null,
	  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
	  firstDayOfWeek: null,
	  verticalHeight: null,
	  noBorder: false,
	  transitionDuration: undefined,
	  verticalBorderSpacing: undefined,
	  horizontalMonthPadding: 13,
	  // accessibility
	  onBlur: function () {
	    function onBlur() {}
	
	    return onBlur;
	  }(),
	  isFocused: false,
	  showKeyboardShortcuts: false,
	  onTab: function () {
	    function onTab() {}
	
	    return onTab;
	  }(),
	  onShiftTab: function () {
	    function onShiftTab() {}
	
	    return onShiftTab;
	  }(),
	  // i18n
	  monthFormat: 'MMMM YYYY',
	  weekDayFormat: 'dd',
	  phrases: _defaultPhrases.DayPickerPhrases,
	  dayAriaLabelFormat: undefined,
	  isRTL: false
	};
	
	var getChooseAvailableDatePhrase = function getChooseAvailableDatePhrase(phrases, focusedInput) {
	  if (focusedInput === _constants.START_DATE) {
	    return phrases.chooseAvailableStartDate;
	  }
	
	  if (focusedInput === _constants.END_DATE) {
	    return phrases.chooseAvailableEndDate;
	  }
	
	  return phrases.chooseAvailableDate;
	};
	
	var DayPickerRangeController =
	/*#__PURE__*/
	function (_ref) {
	  _inherits(DayPickerRangeController, _ref);
	
	  _createClass(DayPickerRangeController, [{
	    key: !_react["default"].PureComponent && "shouldComponentUpdate",
	    value: function () {
	      function value(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
	      }
	
	      return value;
	    }()
	  }]);
	
	  function DayPickerRangeController(props) {
	    var _this;
	
	    _classCallCheck(this, DayPickerRangeController);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(DayPickerRangeController).call(this, props));
	    _this.isTouchDevice = (0, _isTouchDevice["default"])();
	    _this.today = (0, _moment["default"])();
	    _this.modifiers = {
	      today: function () {
	        function today(day) {
	          return _this.isToday(day);
	        }
	
	        return today;
	      }(),
	      blocked: function () {
	        function blocked(day) {
	          return _this.isBlocked(day);
	        }
	
	        return blocked;
	      }(),
	      'blocked-calendar': function () {
	        function blockedCalendar(day) {
	          return props.isDayBlocked(day);
	        }
	
	        return blockedCalendar;
	      }(),
	      'blocked-out-of-range': function () {
	        function blockedOutOfRange(day) {
	          return props.isOutsideRange(day);
	        }
	
	        return blockedOutOfRange;
	      }(),
	      'highlighted-calendar': function () {
	        function highlightedCalendar(day) {
	          return props.isDayHighlighted(day);
	        }
	
	        return highlightedCalendar;
	      }(),
	      valid: function () {
	        function valid(day) {
	          return !_this.isBlocked(day);
	        }
	
	        return valid;
	      }(),
	      'selected-start': function () {
	        function selectedStart(day) {
	          return _this.isStartDate(day);
	        }
	
	        return selectedStart;
	      }(),
	      'selected-end': function () {
	        function selectedEnd(day) {
	          return _this.isEndDate(day);
	        }
	
	        return selectedEnd;
	      }(),
	      'blocked-minimum-nights': function () {
	        function blockedMinimumNights(day) {
	          return _this.doesNotMeetMinimumNights(day);
	        }
	
	        return blockedMinimumNights;
	      }(),
	      'selected-span': function () {
	        function selectedSpan(day) {
	          return _this.isInSelectedSpan(day);
	        }
	
	        return selectedSpan;
	      }(),
	      'last-in-range': function () {
	        function lastInRange(day) {
	          return _this.isLastInRange(day);
	        }
	
	        return lastInRange;
	      }(),
	      hovered: function () {
	        function hovered(day) {
	          return _this.isHovered(day);
	        }
	
	        return hovered;
	      }(),
	      'hovered-span': function () {
	        function hoveredSpan(day) {
	          return _this.isInHoveredSpan(day);
	        }
	
	        return hoveredSpan;
	      }(),
	      'hovered-offset': function () {
	        function hoveredOffset(day) {
	          return _this.isInHoveredSpan(day);
	        }
	
	        return hoveredOffset;
	      }(),
	      'after-hovered-start': function () {
	        function afterHoveredStart(day) {
	          return _this.isDayAfterHoveredStartDate(day);
	        }
	
	        return afterHoveredStart;
	      }(),
	      'first-day-of-week': function () {
	        function firstDayOfWeek(day) {
	          return _this.isFirstDayOfWeek(day);
	        }
	
	        return firstDayOfWeek;
	      }(),
	      'last-day-of-week': function () {
	        function lastDayOfWeek(day) {
	          return _this.isLastDayOfWeek(day);
	        }
	
	        return lastDayOfWeek;
	      }()
	    };
	
	    var _this$getStateForNewM = _this.getStateForNewMonth(props),
	        currentMonth = _this$getStateForNewM.currentMonth,
	        visibleDays = _this$getStateForNewM.visibleDays; // initialize phrases
	    // set the appropriate CalendarDay phrase based on focusedInput
	
	
	    var chooseAvailableDate = getChooseAvailableDatePhrase(props.phrases, props.focusedInput);
	    _this.state = {
	      hoverDate: null,
	      currentMonth: currentMonth,
	      phrases: _objectSpread({}, props.phrases, {
	        chooseAvailableDate: chooseAvailableDate
	      }),
	      visibleDays: visibleDays,
	      disablePrev: _this.shouldDisableMonthNavigation(props.minDate, currentMonth),
	      disableNext: _this.shouldDisableMonthNavigation(props.maxDate, currentMonth)
	    };
	    _this.onDayClick = _this.onDayClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onDayMouseEnter = _this.onDayMouseEnter.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onDayMouseLeave = _this.onDayMouseLeave.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onNextMonthClick = _this.onNextMonthClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onMonthChange = _this.onMonthChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onYearChange = _this.onYearChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onMultiplyScrollableMonths = _this.onMultiplyScrollableMonths.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    return _this;
	  }
	
	  _createClass(DayPickerRangeController, [{
	    key: "componentWillReceiveProps",
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        var startDate = nextProps.startDate,
	            endDate = nextProps.endDate,
	            focusedInput = nextProps.focusedInput,
	            minimumNights = nextProps.minimumNights,
	            isOutsideRange = nextProps.isOutsideRange,
	            isDayBlocked = nextProps.isDayBlocked,
	            isDayHighlighted = nextProps.isDayHighlighted,
	            phrases = nextProps.phrases,
	            initialVisibleMonth = nextProps.initialVisibleMonth,
	            numberOfMonths = nextProps.numberOfMonths,
	            enableOutsideDays = nextProps.enableOutsideDays;
	        var _this$props = this.props,
	            prevStartDate = _this$props.startDate,
	            prevEndDate = _this$props.endDate,
	            prevFocusedInput = _this$props.focusedInput,
	            prevMinimumNights = _this$props.minimumNights,
	            prevIsOutsideRange = _this$props.isOutsideRange,
	            prevIsDayBlocked = _this$props.isDayBlocked,
	            prevIsDayHighlighted = _this$props.isDayHighlighted,
	            prevPhrases = _this$props.phrases,
	            prevInitialVisibleMonth = _this$props.initialVisibleMonth,
	            prevNumberOfMonths = _this$props.numberOfMonths,
	            prevEnableOutsideDays = _this$props.enableOutsideDays;
	        var visibleDays = this.state.visibleDays;
	        var recomputeOutsideRange = false;
	        var recomputeDayBlocked = false;
	        var recomputeDayHighlighted = false;
	
	        if (isOutsideRange !== prevIsOutsideRange) {
	          this.modifiers['blocked-out-of-range'] = function (day) {
	            return isOutsideRange(day);
	          };
	
	          recomputeOutsideRange = true;
	        }
	
	        if (isDayBlocked !== prevIsDayBlocked) {
	          this.modifiers['blocked-calendar'] = function (day) {
	            return isDayBlocked(day);
	          };
	
	          recomputeDayBlocked = true;
	        }
	
	        if (isDayHighlighted !== prevIsDayHighlighted) {
	          this.modifiers['highlighted-calendar'] = function (day) {
	            return isDayHighlighted(day);
	          };
	
	          recomputeDayHighlighted = true;
	        }
	
	        var recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;
	        var didStartDateChange = startDate !== prevStartDate;
	        var didEndDateChange = endDate !== prevEndDate;
	        var didFocusChange = focusedInput !== prevFocusedInput;
	
	        if (numberOfMonths !== prevNumberOfMonths || enableOutsideDays !== prevEnableOutsideDays || initialVisibleMonth !== prevInitialVisibleMonth && !prevFocusedInput && didFocusChange) {
	          var newMonthState = this.getStateForNewMonth(nextProps);
	          var currentMonth = newMonthState.currentMonth;
	          visibleDays = newMonthState.visibleDays;
	          this.setState({
	            currentMonth: currentMonth,
	            visibleDays: visibleDays
	          });
	        }
	
	        var modifiers = {};
	
	        if (didStartDateChange) {
	          modifiers = this.deleteModifier(modifiers, prevStartDate, 'selected-start');
	          modifiers = this.addModifier(modifiers, startDate, 'selected-start');
	
	          if (prevStartDate) {
	            var startSpan = prevStartDate.clone().add(1, 'day');
	            var endSpan = prevStartDate.clone().add(prevMinimumNights + 1, 'days');
	            modifiers = this.deleteModifierFromRange(modifiers, startSpan, endSpan, 'after-hovered-start');
	          }
	        }
	
	        if (didEndDateChange) {
	          modifiers = this.deleteModifier(modifiers, prevEndDate, 'selected-end');
	          modifiers = this.addModifier(modifiers, endDate, 'selected-end');
	        }
	
	        if (didStartDateChange || didEndDateChange) {
	          if (prevStartDate && prevEndDate) {
	            modifiers = this.deleteModifierFromRange(modifiers, prevStartDate, prevEndDate.clone().add(1, 'day'), 'selected-span');
	          }
	
	          if (startDate && endDate) {
	            modifiers = this.deleteModifierFromRange(modifiers, startDate, endDate.clone().add(1, 'day'), 'hovered-span');
	            modifiers = this.addModifierToRange(modifiers, startDate.clone().add(1, 'day'), endDate, 'selected-span');
	          }
	        }
	
	        if (!this.isTouchDevice && didStartDateChange && startDate && !endDate) {
	          var _startSpan = startDate.clone().add(1, 'day');
	
	          var _endSpan = startDate.clone().add(minimumNights + 1, 'days');
	
	          modifiers = this.addModifierToRange(modifiers, _startSpan, _endSpan, 'after-hovered-start');
	        }
	
	        if (prevMinimumNights > 0) {
	          if (didFocusChange || didStartDateChange || minimumNights !== prevMinimumNights) {
	            var _startSpan2 = prevStartDate || this.today;
	
	            modifiers = this.deleteModifierFromRange(modifiers, _startSpan2, _startSpan2.clone().add(prevMinimumNights, 'days'), 'blocked-minimum-nights');
	            modifiers = this.deleteModifierFromRange(modifiers, _startSpan2, _startSpan2.clone().add(prevMinimumNights, 'days'), 'blocked');
	          }
	        }
	
	        if (didFocusChange || recomputePropModifiers) {
	          (0, _object["default"])(visibleDays).forEach(function (days) {
	            Object.keys(days).forEach(function (day) {
	              var momentObj = (0, _moment["default"])(day);
	              var isBlocked = false;
	
	              if (didFocusChange || recomputeOutsideRange) {
	                if (isOutsideRange(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
	                  isBlocked = true;
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
	                }
	              }
	
	              if (didFocusChange || recomputeDayBlocked) {
	                if (isDayBlocked(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
	                  isBlocked = true;
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
	                }
	              }
	
	              if (isBlocked) {
	                modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
	              } else {
	                modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
	              }
	
	              if (didFocusChange || recomputeDayHighlighted) {
	                if (isDayHighlighted(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
	                }
	              }
	            });
	          });
	        }
	
	        if (minimumNights > 0 && startDate && focusedInput === _constants.END_DATE) {
	          modifiers = this.addModifierToRange(modifiers, startDate, startDate.clone().add(minimumNights, 'days'), 'blocked-minimum-nights');
	          modifiers = this.addModifierToRange(modifiers, startDate, startDate.clone().add(minimumNights, 'days'), 'blocked');
	        }
	
	        var today = (0, _moment["default"])();
	
	        if (!(0, _isSameDay["default"])(this.today, today)) {
	          modifiers = this.deleteModifier(modifiers, this.today, 'today');
	          modifiers = this.addModifier(modifiers, today, 'today');
	          this.today = today;
	        }
	
	        if (Object.keys(modifiers).length > 0) {
	          this.setState({
	            visibleDays: _objectSpread({}, visibleDays, modifiers)
	          });
	        }
	
	        if (didFocusChange || phrases !== prevPhrases) {
	          // set the appropriate CalendarDay phrase based on focusedInput
	          var chooseAvailableDate = getChooseAvailableDatePhrase(phrases, focusedInput);
	          this.setState({
	            phrases: _objectSpread({}, phrases, {
	              chooseAvailableDate: chooseAvailableDate
	            })
	          });
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: "onDayClick",
	    value: function () {
	      function onDayClick(day, e) {
	        var _this$props2 = this.props,
	            keepOpenOnDateSelect = _this$props2.keepOpenOnDateSelect,
	            minimumNights = _this$props2.minimumNights,
	            onBlur = _this$props2.onBlur,
	            focusedInput = _this$props2.focusedInput,
	            onFocusChange = _this$props2.onFocusChange,
	            onClose = _this$props2.onClose,
	            onDatesChange = _this$props2.onDatesChange,
	            startDateOffset = _this$props2.startDateOffset,
	            endDateOffset = _this$props2.endDateOffset,
	            disabled = _this$props2.disabled;
	        if (e) e.preventDefault();
	        if (this.isBlocked(day)) return;
	        var _this$props3 = this.props,
	            startDate = _this$props3.startDate,
	            endDate = _this$props3.endDate;
	
	        if (startDateOffset || endDateOffset) {
	          startDate = (0, _getSelectedDateOffset["default"])(startDateOffset, day);
	          endDate = (0, _getSelectedDateOffset["default"])(endDateOffset, day);
	
	          if (this.isBlocked(startDate) || this.isBlocked(endDate)) {
	            return;
	          }
	
	          if (!keepOpenOnDateSelect) {
	            onFocusChange(null);
	            onClose({
	              startDate: startDate,
	              endDate: endDate
	            });
	          }
	        } else if (focusedInput === _constants.START_DATE) {
	          var lastAllowedStartDate = endDate && endDate.clone().subtract(minimumNights, 'days');
	          var isStartDateAfterEndDate = (0, _isBeforeDay["default"])(lastAllowedStartDate, day) || (0, _isAfterDay["default"])(startDate, endDate);
	          var isEndDateDisabled = disabled === _constants.END_DATE;
	
	          if (!isEndDateDisabled || !isStartDateAfterEndDate) {
	            startDate = day;
	
	            if (isStartDateAfterEndDate) {
	              endDate = null;
	            }
	          }
	
	          if (isEndDateDisabled && !isStartDateAfterEndDate) {
	            onFocusChange(null);
	            onClose({
	              startDate: startDate,
	              endDate: endDate
	            });
	          } else if (!isEndDateDisabled) {
	            onFocusChange(_constants.END_DATE);
	          }
	        } else if (focusedInput === _constants.END_DATE) {
	          var firstAllowedEndDate = startDate && startDate.clone().add(minimumNights, 'days');
	
	          if (!startDate) {
	            endDate = day;
	            onFocusChange(_constants.START_DATE);
	          } else if ((0, _isInclusivelyAfterDay["default"])(day, firstAllowedEndDate)) {
	            endDate = day;
	
	            if (!keepOpenOnDateSelect) {
	              onFocusChange(null);
	              onClose({
	                startDate: startDate,
	                endDate: endDate
	              });
	            }
	          } else if (disabled !== _constants.START_DATE) {
	            startDate = day;
	            endDate = null;
	          }
	        }
	
	        onDatesChange({
	          startDate: startDate,
	          endDate: endDate
	        });
	        onBlur();
	      }
	
	      return onDayClick;
	    }()
	  }, {
	    key: "onDayMouseEnter",
	    value: function () {
	      function onDayMouseEnter(day) {
	        /* eslint react/destructuring-assignment: 1 */
	        if (this.isTouchDevice) return;
	        var _this$props4 = this.props,
	            startDate = _this$props4.startDate,
	            endDate = _this$props4.endDate,
	            focusedInput = _this$props4.focusedInput,
	            minimumNights = _this$props4.minimumNights,
	            startDateOffset = _this$props4.startDateOffset,
	            endDateOffset = _this$props4.endDateOffset;
	        var _this$state = this.state,
	            hoverDate = _this$state.hoverDate,
	            visibleDays = _this$state.visibleDays,
	            dateOffset = _this$state.dateOffset;
	        var nextDateOffset = null;
	
	        if (focusedInput) {
	          var hasOffset = startDateOffset || endDateOffset;
	          var modifiers = {};
	
	          if (hasOffset) {
	            var start = (0, _getSelectedDateOffset["default"])(startDateOffset, day);
	            var end = (0, _getSelectedDateOffset["default"])(endDateOffset, day, function (rangeDay) {
	              return rangeDay.add(1, 'day');
	            });
	            nextDateOffset = {
	              start: start,
	              end: end
	            }; // eslint-disable-next-line react/destructuring-assignment
	
	            if (dateOffset && dateOffset.start && dateOffset.end) {
	              modifiers = this.deleteModifierFromRange(modifiers, dateOffset.start, dateOffset.end, 'hovered-offset');
	            }
	
	            modifiers = this.addModifierToRange(modifiers, start, end, 'hovered-offset');
	          }
	
	          if (!hasOffset) {
	            modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');
	            modifiers = this.addModifier(modifiers, day, 'hovered');
	
	            if (startDate && !endDate && focusedInput === _constants.END_DATE) {
	              if ((0, _isAfterDay["default"])(hoverDate, startDate)) {
	                var endSpan = hoverDate.clone().add(1, 'day');
	                modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
	              }
	
	              if (!this.isBlocked(day) && (0, _isAfterDay["default"])(day, startDate)) {
	                var _endSpan2 = day.clone().add(1, 'day');
	
	                modifiers = this.addModifierToRange(modifiers, startDate, _endSpan2, 'hovered-span');
	              }
	            }
	
	            if (!startDate && endDate && focusedInput === _constants.START_DATE) {
	              if ((0, _isBeforeDay["default"])(hoverDate, endDate)) {
	                modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
	              }
	
	              if (!this.isBlocked(day) && (0, _isBeforeDay["default"])(day, endDate)) {
	                modifiers = this.addModifierToRange(modifiers, day, endDate, 'hovered-span');
	              }
	            }
	
	            if (startDate) {
	              var startSpan = startDate.clone().add(1, 'day');
	
	              var _endSpan3 = startDate.clone().add(minimumNights + 1, 'days');
	
	              modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan3, 'after-hovered-start');
	
	              if ((0, _isSameDay["default"])(day, startDate)) {
	                var newStartSpan = startDate.clone().add(1, 'day');
	                var newEndSpan = startDate.clone().add(minimumNights + 1, 'days');
	                modifiers = this.addModifierToRange(modifiers, newStartSpan, newEndSpan, 'after-hovered-start');
	              }
	            }
	          }
	
	          this.setState({
	            hoverDate: day,
	            dateOffset: nextDateOffset,
	            visibleDays: _objectSpread({}, visibleDays, modifiers)
	          });
	        }
	      }
	
	      return onDayMouseEnter;
	    }()
	  }, {
	    key: "onDayMouseLeave",
	    value: function () {
	      function onDayMouseLeave(day) {
	        var _this$props5 = this.props,
	            startDate = _this$props5.startDate,
	            endDate = _this$props5.endDate,
	            minimumNights = _this$props5.minimumNights;
	        var _this$state2 = this.state,
	            hoverDate = _this$state2.hoverDate,
	            visibleDays = _this$state2.visibleDays,
	            dateOffset = _this$state2.dateOffset;
	        if (this.isTouchDevice || !hoverDate) return;
	        var modifiers = {};
	        modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');
	
	        if (dateOffset) {
	          modifiers = this.deleteModifierFromRange(modifiers, dateOffset.start, dateOffset.end, 'hovered-offset');
	        }
	
	        if (startDate && !endDate && (0, _isAfterDay["default"])(hoverDate, startDate)) {
	          var endSpan = hoverDate.clone().add(1, 'day');
	          modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
	        }
	
	        if (!startDate && endDate && (0, _isAfterDay["default"])(endDate, hoverDate)) {
	          modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
	        }
	
	        if (startDate && (0, _isSameDay["default"])(day, startDate)) {
	          var startSpan = startDate.clone().add(1, 'day');
	
	          var _endSpan4 = startDate.clone().add(minimumNights + 1, 'days');
	
	          modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan4, 'after-hovered-start');
	        }
	
	        this.setState({
	          hoverDate: null,
	          visibleDays: _objectSpread({}, visibleDays, modifiers)
	        });
	      }
	
	      return onDayMouseLeave;
	    }()
	  }, {
	    key: "onPrevMonthClick",
	    value: function () {
	      function onPrevMonthClick() {
	        var _this$props6 = this.props,
	            enableOutsideDays = _this$props6.enableOutsideDays,
	            maxDate = _this$props6.maxDate,
	            minDate = _this$props6.minDate,
	            numberOfMonths = _this$props6.numberOfMonths,
	            onPrevMonthClick = _this$props6.onPrevMonthClick;
	        var _this$state3 = this.state,
	            currentMonth = _this$state3.currentMonth,
	            visibleDays = _this$state3.visibleDays;
	        var newVisibleDays = {};
	        Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach(function (month) {
	          newVisibleDays[month] = visibleDays[month];
	        });
	        var prevMonth = currentMonth.clone().subtract(2, 'months');
	        var prevMonthVisibleDays = (0, _getVisibleDays["default"])(prevMonth, 1, enableOutsideDays, true);
	        var newCurrentMonth = currentMonth.clone().subtract(1, 'month');
	        this.setState({
	          currentMonth: newCurrentMonth,
	          disablePrev: this.shouldDisableMonthNavigation(minDate, newCurrentMonth),
	          disableNext: this.shouldDisableMonthNavigation(maxDate, newCurrentMonth),
	          visibleDays: _objectSpread({}, newVisibleDays, this.getModifiers(prevMonthVisibleDays))
	        }, function () {
	          onPrevMonthClick(newCurrentMonth.clone());
	        });
	      }
	
	      return onPrevMonthClick;
	    }()
	  }, {
	    key: "onNextMonthClick",
	    value: function () {
	      function onNextMonthClick() {
	        var _this$props7 = this.props,
	            enableOutsideDays = _this$props7.enableOutsideDays,
	            maxDate = _this$props7.maxDate,
	            minDate = _this$props7.minDate,
	            numberOfMonths = _this$props7.numberOfMonths,
	            onNextMonthClick = _this$props7.onNextMonthClick;
	        var _this$state4 = this.state,
	            currentMonth = _this$state4.currentMonth,
	            visibleDays = _this$state4.visibleDays;
	        var newVisibleDays = {};
	        Object.keys(visibleDays).sort().slice(1).forEach(function (month) {
	          newVisibleDays[month] = visibleDays[month];
	        });
	        var nextMonth = currentMonth.clone().add(numberOfMonths + 1, 'month');
	        var nextMonthVisibleDays = (0, _getVisibleDays["default"])(nextMonth, 1, enableOutsideDays, true);
	        var newCurrentMonth = currentMonth.clone().add(1, 'month');
	        this.setState({
	          currentMonth: newCurrentMonth,
	          disablePrev: this.shouldDisableMonthNavigation(minDate, newCurrentMonth),
	          disableNext: this.shouldDisableMonthNavigation(maxDate, newCurrentMonth),
	          visibleDays: _objectSpread({}, newVisibleDays, this.getModifiers(nextMonthVisibleDays))
	        }, function () {
	          onNextMonthClick(newCurrentMonth.clone());
	        });
	      }
	
	      return onNextMonthClick;
	    }()
	  }, {
	    key: "onMonthChange",
	    value: function () {
	      function onMonthChange(newMonth) {
	        var _this$props8 = this.props,
	            numberOfMonths = _this$props8.numberOfMonths,
	            enableOutsideDays = _this$props8.enableOutsideDays,
	            orientation = _this$props8.orientation;
	        var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
	        var newVisibleDays = (0, _getVisibleDays["default"])(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
	        this.setState({
	          currentMonth: newMonth.clone(),
	          visibleDays: this.getModifiers(newVisibleDays)
	        });
	      }
	
	      return onMonthChange;
	    }()
	  }, {
	    key: "onYearChange",
	    value: function () {
	      function onYearChange(newMonth) {
	        var _this$props9 = this.props,
	            numberOfMonths = _this$props9.numberOfMonths,
	            enableOutsideDays = _this$props9.enableOutsideDays,
	            orientation = _this$props9.orientation;
	        var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
	        var newVisibleDays = (0, _getVisibleDays["default"])(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
	        this.setState({
	          currentMonth: newMonth.clone(),
	          visibleDays: this.getModifiers(newVisibleDays)
	        });
	      }
	
	      return onYearChange;
	    }()
	  }, {
	    key: "onMultiplyScrollableMonths",
	    value: function () {
	      function onMultiplyScrollableMonths() {
	        var _this$props10 = this.props,
	            numberOfMonths = _this$props10.numberOfMonths,
	            enableOutsideDays = _this$props10.enableOutsideDays;
	        var _this$state5 = this.state,
	            currentMonth = _this$state5.currentMonth,
	            visibleDays = _this$state5.visibleDays;
	        var numberOfVisibleMonths = Object.keys(visibleDays).length;
	        var nextMonth = currentMonth.clone().add(numberOfVisibleMonths, 'month');
	        var newVisibleDays = (0, _getVisibleDays["default"])(nextMonth, numberOfMonths, enableOutsideDays, true);
	        this.setState({
	          visibleDays: _objectSpread({}, visibleDays, this.getModifiers(newVisibleDays))
	        });
	      }
	
	      return onMultiplyScrollableMonths;
	    }()
	  }, {
	    key: "getFirstFocusableDay",
	    value: function () {
	      function getFirstFocusableDay(newMonth) {
	        var _this3 = this;
	
	        var _this$props11 = this.props,
	            startDate = _this$props11.startDate,
	            endDate = _this$props11.endDate,
	            focusedInput = _this$props11.focusedInput,
	            minimumNights = _this$props11.minimumNights,
	            numberOfMonths = _this$props11.numberOfMonths;
	        var focusedDate = newMonth.clone().startOf('month');
	
	        if (focusedInput === _constants.START_DATE && startDate) {
	          focusedDate = startDate.clone();
	        } else if (focusedInput === _constants.END_DATE && !endDate && startDate) {
	          focusedDate = startDate.clone().add(minimumNights, 'days');
	        } else if (focusedInput === _constants.END_DATE && endDate) {
	          focusedDate = endDate.clone();
	        }
	
	        if (this.isBlocked(focusedDate)) {
	          var days = [];
	          var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
	          var currentDay = focusedDate.clone();
	
	          while (!(0, _isAfterDay["default"])(currentDay, lastVisibleDay)) {
	            currentDay = currentDay.clone().add(1, 'day');
	            days.push(currentDay);
	          }
	
	          var viableDays = days.filter(function (day) {
	            return !_this3.isBlocked(day);
	          });
	
	          if (viableDays.length > 0) {
	            var _viableDays = _slicedToArray(viableDays, 1);
	
	            focusedDate = _viableDays[0];
	          }
	        }
	
	        return focusedDate;
	      }
	
	      return getFirstFocusableDay;
	    }()
	  }, {
	    key: "getModifiers",
	    value: function () {
	      function getModifiers(visibleDays) {
	        var _this4 = this;
	
	        var modifiers = {};
	        Object.keys(visibleDays).forEach(function (month) {
	          modifiers[month] = {};
	          visibleDays[month].forEach(function (day) {
	            modifiers[month][(0, _toISODateString["default"])(day)] = _this4.getModifiersForDay(day);
	          });
	        });
	        return modifiers;
	      }
	
	      return getModifiers;
	    }()
	  }, {
	    key: "getModifiersForDay",
	    value: function () {
	      function getModifiersForDay(day) {
	        var _this5 = this;
	
	        return new Set(Object.keys(this.modifiers).filter(function (modifier) {
	          return _this5.modifiers[modifier](day);
	        }));
	      }
	
	      return getModifiersForDay;
	    }()
	  }, {
	    key: "getStateForNewMonth",
	    value: function () {
	      function getStateForNewMonth(nextProps) {
	        var _this6 = this;
	
	        var initialVisibleMonth = nextProps.initialVisibleMonth,
	            numberOfMonths = nextProps.numberOfMonths,
	            enableOutsideDays = nextProps.enableOutsideDays,
	            orientation = nextProps.orientation,
	            startDate = nextProps.startDate;
	        var initialVisibleMonthThunk = initialVisibleMonth || (startDate ? function () {
	          return startDate;
	        } : function () {
	          return _this6.today;
	        });
	        var currentMonth = initialVisibleMonthThunk();
	        var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
	        var visibleDays = this.getModifiers((0, _getVisibleDays["default"])(currentMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths));
	        return {
	          currentMonth: currentMonth,
	          visibleDays: visibleDays
	        };
	      }
	
	      return getStateForNewMonth;
	    }()
	  }, {
	    key: "shouldDisableMonthNavigation",
	    value: function () {
	      function shouldDisableMonthNavigation(date, visibleMonth) {
	        if (!date) return false;
	        var _this$props12 = this.props,
	            numberOfMonths = _this$props12.numberOfMonths,
	            enableOutsideDays = _this$props12.enableOutsideDays;
	        return (0, _isDayVisible["default"])(date, visibleMonth, numberOfMonths, enableOutsideDays);
	      }
	
	      return shouldDisableMonthNavigation;
	    }()
	  }, {
	    key: "addModifier",
	    value: function () {
	      function addModifier(updatedDays, day, modifier) {
	        var _this$props13 = this.props,
	            numberOfVisibleMonths = _this$props13.numberOfMonths,
	            enableOutsideDays = _this$props13.enableOutsideDays,
	            orientation = _this$props13.orientation;
	        var _this$state6 = this.state,
	            firstVisibleMonth = _this$state6.currentMonth,
	            visibleDays = _this$state6.visibleDays;
	        var currentMonth = firstVisibleMonth;
	        var numberOfMonths = numberOfVisibleMonths;
	
	        if (orientation === _constants.VERTICAL_SCROLLABLE) {
	          numberOfMonths = Object.keys(visibleDays).length;
	        } else {
	          currentMonth = currentMonth.clone().subtract(1, 'month');
	          numberOfMonths += 2;
	        }
	
	        if (!day || !(0, _isDayVisible["default"])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
	          return updatedDays;
	        }
	
	        var iso = (0, _toISODateString["default"])(day);
	
	        var updatedDaysAfterAddition = _objectSpread({}, updatedDays);
	
	        if (enableOutsideDays) {
	          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
	            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
	          });
	          updatedDaysAfterAddition = monthsToUpdate.reduce(function (days, monthIso) {
	            var month = updatedDays[monthIso] || visibleDays[monthIso];
	            var modifiers = new Set(month[iso]);
	            modifiers.add(modifier);
	            return _objectSpread({}, days, _defineProperty({}, monthIso, _objectSpread({}, month, _defineProperty({}, iso, modifiers))));
	          }, updatedDaysAfterAddition);
	        } else {
	          var monthIso = (0, _toISOMonthString["default"])(day);
	          var month = updatedDays[monthIso] || visibleDays[monthIso];
	          var modifiers = new Set(month[iso]);
	          modifiers.add(modifier);
	          updatedDaysAfterAddition = _objectSpread({}, updatedDaysAfterAddition, _defineProperty({}, monthIso, _objectSpread({}, month, _defineProperty({}, iso, modifiers))));
	        }
	
	        return updatedDaysAfterAddition;
	      }
	
	      return addModifier;
	    }()
	  }, {
	    key: "addModifierToRange",
	    value: function () {
	      function addModifierToRange(updatedDays, start, end, modifier) {
	        var days = updatedDays;
	        var spanStart = start.clone();
	
	        while ((0, _isBeforeDay["default"])(spanStart, end)) {
	          days = this.addModifier(days, spanStart, modifier);
	          spanStart = spanStart.clone().add(1, 'day');
	        }
	
	        return days;
	      }
	
	      return addModifierToRange;
	    }()
	  }, {
	    key: "deleteModifier",
	    value: function () {
	      function deleteModifier(updatedDays, day, modifier) {
	        var _this$props14 = this.props,
	            numberOfVisibleMonths = _this$props14.numberOfMonths,
	            enableOutsideDays = _this$props14.enableOutsideDays,
	            orientation = _this$props14.orientation;
	        var _this$state7 = this.state,
	            firstVisibleMonth = _this$state7.currentMonth,
	            visibleDays = _this$state7.visibleDays;
	        var currentMonth = firstVisibleMonth;
	        var numberOfMonths = numberOfVisibleMonths;
	
	        if (orientation === _constants.VERTICAL_SCROLLABLE) {
	          numberOfMonths = Object.keys(visibleDays).length;
	        } else {
	          currentMonth = currentMonth.clone().subtract(1, 'month');
	          numberOfMonths += 2;
	        }
	
	        if (!day || !(0, _isDayVisible["default"])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
	          return updatedDays;
	        }
	
	        var iso = (0, _toISODateString["default"])(day);
	
	        var updatedDaysAfterDeletion = _objectSpread({}, updatedDays);
	
	        if (enableOutsideDays) {
	          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
	            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
	          });
	          updatedDaysAfterDeletion = monthsToUpdate.reduce(function (days, monthIso) {
	            var month = updatedDays[monthIso] || visibleDays[monthIso];
	            var modifiers = new Set(month[iso]);
	            modifiers["delete"](modifier);
	            return _objectSpread({}, days, _defineProperty({}, monthIso, _objectSpread({}, month, _defineProperty({}, iso, modifiers))));
	          }, updatedDaysAfterDeletion);
	        } else {
	          var monthIso = (0, _toISOMonthString["default"])(day);
	          var month = updatedDays[monthIso] || visibleDays[monthIso];
	          var modifiers = new Set(month[iso]);
	          modifiers["delete"](modifier);
	          updatedDaysAfterDeletion = _objectSpread({}, updatedDaysAfterDeletion, _defineProperty({}, monthIso, _objectSpread({}, month, _defineProperty({}, iso, modifiers))));
	        }
	
	        return updatedDaysAfterDeletion;
	      }
	
	      return deleteModifier;
	    }()
	  }, {
	    key: "deleteModifierFromRange",
	    value: function () {
	      function deleteModifierFromRange(updatedDays, start, end, modifier) {
	        var days = updatedDays;
	        var spanStart = start.clone();
	
	        while ((0, _isBeforeDay["default"])(spanStart, end)) {
	          days = this.deleteModifier(days, spanStart, modifier);
	          spanStart = spanStart.clone().add(1, 'day');
	        }
	
	        return days;
	      }
	
	      return deleteModifierFromRange;
	    }()
	  }, {
	    key: "doesNotMeetMinimumNights",
	    value: function () {
	      function doesNotMeetMinimumNights(day) {
	        var _this$props15 = this.props,
	            startDate = _this$props15.startDate,
	            isOutsideRange = _this$props15.isOutsideRange,
	            focusedInput = _this$props15.focusedInput,
	            minimumNights = _this$props15.minimumNights;
	        if (focusedInput !== _constants.END_DATE) return false;
	
	        if (startDate) {
	          var dayDiff = day.diff(startDate.clone().startOf('day').hour(12), 'days');
	          return dayDiff < minimumNights && dayDiff >= 0;
	        }
	
	        return isOutsideRange((0, _moment["default"])(day).subtract(minimumNights, 'days'));
	      }
	
	      return doesNotMeetMinimumNights;
	    }()
	  }, {
	    key: "isDayAfterHoveredStartDate",
	    value: function () {
	      function isDayAfterHoveredStartDate(day) {
	        var _this$props16 = this.props,
	            startDate = _this$props16.startDate,
	            endDate = _this$props16.endDate,
	            minimumNights = _this$props16.minimumNights;
	
	        var _ref2 = this.state || {},
	            hoverDate = _ref2.hoverDate;
	
	        return !!startDate && !endDate && !this.isBlocked(day) && (0, _isNextDay["default"])(hoverDate, day) && minimumNights > 0 && (0, _isSameDay["default"])(hoverDate, startDate);
	      }
	
	      return isDayAfterHoveredStartDate;
	    }()
	  }, {
	    key: "isEndDate",
	    value: function () {
	      function isEndDate(day) {
	        var endDate = this.props.endDate;
	        return (0, _isSameDay["default"])(day, endDate);
	      }
	
	      return isEndDate;
	    }()
	  }, {
	    key: "isHovered",
	    value: function () {
	      function isHovered(day) {
	        var _ref3 = this.state || {},
	            hoverDate = _ref3.hoverDate;
	
	        var focusedInput = this.props.focusedInput;
	        return !!focusedInput && (0, _isSameDay["default"])(day, hoverDate);
	      }
	
	      return isHovered;
	    }()
	  }, {
	    key: "isInHoveredSpan",
	    value: function () {
	      function isInHoveredSpan(day) {
	        var _this$props17 = this.props,
	            startDate = _this$props17.startDate,
	            endDate = _this$props17.endDate;
	
	        var _ref4 = this.state || {},
	            hoverDate = _ref4.hoverDate;
	
	        var isForwardRange = !!startDate && !endDate && (day.isBetween(startDate, hoverDate) || (0, _isSameDay["default"])(hoverDate, day));
	        var isBackwardRange = !!endDate && !startDate && (day.isBetween(hoverDate, endDate) || (0, _isSameDay["default"])(hoverDate, day));
	        var isValidDayHovered = hoverDate && !this.isBlocked(hoverDate);
	        return (isForwardRange || isBackwardRange) && isValidDayHovered;
	      }
	
	      return isInHoveredSpan;
	    }()
	  }, {
	    key: "isInSelectedSpan",
	    value: function () {
	      function isInSelectedSpan(day) {
	        var _this$props18 = this.props,
	            startDate = _this$props18.startDate,
	            endDate = _this$props18.endDate;
	        return day.isBetween(startDate, endDate);
	      }
	
	      return isInSelectedSpan;
	    }()
	  }, {
	    key: "isLastInRange",
	    value: function () {
	      function isLastInRange(day) {
	        var endDate = this.props.endDate;
	        return this.isInSelectedSpan(day) && (0, _isNextDay["default"])(day, endDate);
	      }
	
	      return isLastInRange;
	    }()
	  }, {
	    key: "isStartDate",
	    value: function () {
	      function isStartDate(day) {
	        var startDate = this.props.startDate;
	        return (0, _isSameDay["default"])(day, startDate);
	      }
	
	      return isStartDate;
	    }()
	  }, {
	    key: "isBlocked",
	    value: function () {
	      function isBlocked(day) {
	        var _this$props19 = this.props,
	            isDayBlocked = _this$props19.isDayBlocked,
	            isOutsideRange = _this$props19.isOutsideRange;
	        return isDayBlocked(day) || isOutsideRange(day) || this.doesNotMeetMinimumNights(day);
	      }
	
	      return isBlocked;
	    }()
	  }, {
	    key: "isToday",
	    value: function () {
	      function isToday(day) {
	        return (0, _isSameDay["default"])(day, this.today);
	      }
	
	      return isToday;
	    }()
	  }, {
	    key: "isFirstDayOfWeek",
	    value: function () {
	      function isFirstDayOfWeek(day) {
	        var firstDayOfWeek = this.props.firstDayOfWeek;
	        return day.day() === (firstDayOfWeek || _moment["default"].localeData().firstDayOfWeek());
	      }
	
	      return isFirstDayOfWeek;
	    }()
	  }, {
	    key: "isLastDayOfWeek",
	    value: function () {
	      function isLastDayOfWeek(day) {
	        var firstDayOfWeek = this.props.firstDayOfWeek;
	        return day.day() === ((firstDayOfWeek || _moment["default"].localeData().firstDayOfWeek()) + 6) % 7;
	      }
	
	      return isLastDayOfWeek;
	    }()
	  }, {
	    key: "render",
	    value: function () {
	      function render() {
	        var _this$props20 = this.props,
	            numberOfMonths = _this$props20.numberOfMonths,
	            orientation = _this$props20.orientation,
	            monthFormat = _this$props20.monthFormat,
	            renderMonthText = _this$props20.renderMonthText,
	            navPrev = _this$props20.navPrev,
	            navNext = _this$props20.navNext,
	            noNavButtons = _this$props20.noNavButtons,
	            onOutsideClick = _this$props20.onOutsideClick,
	            withPortal = _this$props20.withPortal,
	            enableOutsideDays = _this$props20.enableOutsideDays,
	            firstDayOfWeek = _this$props20.firstDayOfWeek,
	            hideKeyboardShortcutsPanel = _this$props20.hideKeyboardShortcutsPanel,
	            daySize = _this$props20.daySize,
	            focusedInput = _this$props20.focusedInput,
	            renderCalendarDay = _this$props20.renderCalendarDay,
	            renderDayContents = _this$props20.renderDayContents,
	            renderCalendarInfo = _this$props20.renderCalendarInfo,
	            renderMonthElement = _this$props20.renderMonthElement,
	            calendarInfoPosition = _this$props20.calendarInfoPosition,
	            onBlur = _this$props20.onBlur,
	            onShiftTab = _this$props20.onShiftTab,
	            onTab = _this$props20.onTab,
	            isFocused = _this$props20.isFocused,
	            showKeyboardShortcuts = _this$props20.showKeyboardShortcuts,
	            isRTL = _this$props20.isRTL,
	            weekDayFormat = _this$props20.weekDayFormat,
	            dayAriaLabelFormat = _this$props20.dayAriaLabelFormat,
	            verticalHeight = _this$props20.verticalHeight,
	            noBorder = _this$props20.noBorder,
	            transitionDuration = _this$props20.transitionDuration,
	            verticalBorderSpacing = _this$props20.verticalBorderSpacing,
	            horizontalMonthPadding = _this$props20.horizontalMonthPadding;
	        var _this$state8 = this.state,
	            currentMonth = _this$state8.currentMonth,
	            phrases = _this$state8.phrases,
	            visibleDays = _this$state8.visibleDays,
	            disablePrev = _this$state8.disablePrev,
	            disableNext = _this$state8.disableNext;
	        return _react["default"].createElement(_DayPicker["default"], {
	          orientation: orientation,
	          enableOutsideDays: enableOutsideDays,
	          modifiers: visibleDays,
	          numberOfMonths: numberOfMonths,
	          onDayClick: this.onDayClick,
	          onDayMouseEnter: this.onDayMouseEnter,
	          onDayMouseLeave: this.onDayMouseLeave,
	          onPrevMonthClick: this.onPrevMonthClick,
	          onNextMonthClick: this.onNextMonthClick,
	          onMonthChange: this.onMonthChange,
	          onTab: onTab,
	          onShiftTab: onShiftTab,
	          onYearChange: this.onYearChange,
	          onMultiplyScrollableMonths: this.onMultiplyScrollableMonths,
	          monthFormat: monthFormat,
	          renderMonthText: renderMonthText,
	          withPortal: withPortal,
	          hidden: !focusedInput,
	          initialVisibleMonth: function () {
	            function initialVisibleMonth() {
	              return currentMonth;
	            }
	
	            return initialVisibleMonth;
	          }(),
	          daySize: daySize,
	          onOutsideClick: onOutsideClick,
	          disablePrev: disablePrev,
	          disableNext: disableNext,
	          navPrev: navPrev,
	          navNext: navNext,
	          noNavButtons: noNavButtons,
	          renderCalendarDay: renderCalendarDay,
	          renderDayContents: renderDayContents,
	          renderCalendarInfo: renderCalendarInfo,
	          renderMonthElement: renderMonthElement,
	          calendarInfoPosition: calendarInfoPosition,
	          firstDayOfWeek: firstDayOfWeek,
	          hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	          isFocused: isFocused,
	          getFirstFocusableDay: this.getFirstFocusableDay,
	          onBlur: onBlur,
	          showKeyboardShortcuts: showKeyboardShortcuts,
	          phrases: phrases,
	          isRTL: isRTL,
	          weekDayFormat: weekDayFormat,
	          dayAriaLabelFormat: dayAriaLabelFormat,
	          verticalHeight: verticalHeight,
	          verticalBorderSpacing: verticalBorderSpacing,
	          noBorder: noBorder,
	          transitionDuration: transitionDuration,
	          horizontalMonthPadding: horizontalMonthPadding
	        });
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DayPickerRangeController;
	}(_react["default"].PureComponent || _react["default"].Component);
	
	exports["default"] = DayPickerRangeController;
	DayPickerRangeController.propTypes =  false ? propTypes : {};
	DayPickerRangeController.defaultProps = defaultProps;

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _reactAddonsShallowCompare = _interopRequireDefault(__webpack_require__(70));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(105));
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _object = _interopRequireDefault(__webpack_require__(422));
	
	var _isTouchDevice = _interopRequireDefault(__webpack_require__(171));
	
	var _defaultPhrases = __webpack_require__(51);
	
	var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(60));
	
	var _isSameDay = _interopRequireDefault(__webpack_require__(177));
	
	var _isAfterDay = _interopRequireDefault(__webpack_require__(290));
	
	var _getVisibleDays = _interopRequireDefault(__webpack_require__(874));
	
	var _isDayVisible = _interopRequireDefault(__webpack_require__(436));
	
	var _toISODateString = _interopRequireDefault(__webpack_require__(291));
	
	var _toISOMonthString = _interopRequireDefault(__webpack_require__(292));
	
	var _ScrollableOrientationShape = _interopRequireDefault(__webpack_require__(175));
	
	var _DayOfWeekShape = _interopRequireDefault(__webpack_require__(145));
	
	var _CalendarInfoPositionShape = _interopRequireDefault(__webpack_require__(223));
	
	var _constants = __webpack_require__(21);
	
	var _DayPicker = _interopRequireDefault(__webpack_require__(434));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () { function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); } return _getPrototypeOf; }(); return _getPrototypeOf(o); }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function () { function _setPrototypeOf(o, p) { o.__proto__ = p; return o; } return _setPrototypeOf; }(); return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)({
	  date: _reactMomentProptypes["default"].momentObj,
	  onDateChange: _propTypes["default"].func,
	  focused: _propTypes["default"].bool,
	  onFocusChange: _propTypes["default"].func,
	  onClose: _propTypes["default"].func,
	  keepOpenOnDateSelect: _propTypes["default"].bool,
	  isOutsideRange: _propTypes["default"].func,
	  isDayBlocked: _propTypes["default"].func,
	  isDayHighlighted: _propTypes["default"].func,
	  // DayPicker props
	  renderMonthText: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
	  renderMonthElement: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
	  enableOutsideDays: _propTypes["default"].bool,
	  numberOfMonths: _propTypes["default"].number,
	  orientation: _ScrollableOrientationShape["default"],
	  withPortal: _propTypes["default"].bool,
	  initialVisibleMonth: _propTypes["default"].func,
	  firstDayOfWeek: _DayOfWeekShape["default"],
	  hideKeyboardShortcutsPanel: _propTypes["default"].bool,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
	  noBorder: _propTypes["default"].bool,
	  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
	  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
	  horizontalMonthPadding: _airbnbPropTypes.nonNegativeInteger,
	  navPrev: _propTypes["default"].node,
	  navNext: _propTypes["default"].node,
	  onPrevMonthClick: _propTypes["default"].func,
	  onNextMonthClick: _propTypes["default"].func,
	  onOutsideClick: _propTypes["default"].func,
	  renderCalendarDay: _propTypes["default"].func,
	  renderDayContents: _propTypes["default"].func,
	  renderCalendarInfo: _propTypes["default"].func,
	  calendarInfoPosition: _CalendarInfoPositionShape["default"],
	  // accessibility
	  onBlur: _propTypes["default"].func,
	  isFocused: _propTypes["default"].bool,
	  showKeyboardShortcuts: _propTypes["default"].bool,
	  onTab: _propTypes["default"].func,
	  onShiftTab: _propTypes["default"].func,
	  // i18n
	  monthFormat: _propTypes["default"].string,
	  weekDayFormat: _propTypes["default"].string,
	  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.DayPickerPhrases)),
	  dayAriaLabelFormat: _propTypes["default"].string,
	  isRTL: _propTypes["default"].bool
	}) : {};
	var defaultProps = {
	  date: undefined,
	  // TODO: use null
	  onDateChange: function () {
	    function onDateChange() {}
	
	    return onDateChange;
	  }(),
	  focused: false,
	  onFocusChange: function () {
	    function onFocusChange() {}
	
	    return onFocusChange;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	  keepOpenOnDateSelect: false,
	  isOutsideRange: function () {
	    function isOutsideRange() {}
	
	    return isOutsideRange;
	  }(),
	  isDayBlocked: function () {
	    function isDayBlocked() {}
	
	    return isDayBlocked;
	  }(),
	  isDayHighlighted: function () {
	    function isDayHighlighted() {}
	
	    return isDayHighlighted;
	  }(),
	  // DayPicker props
	  renderMonthText: null,
	  enableOutsideDays: false,
	  numberOfMonths: 1,
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  withPortal: false,
	  hideKeyboardShortcutsPanel: false,
	  initialVisibleMonth: null,
	  firstDayOfWeek: null,
	  daySize: _constants.DAY_SIZE,
	  verticalHeight: null,
	  noBorder: false,
	  verticalBorderSpacing: undefined,
	  transitionDuration: undefined,
	  horizontalMonthPadding: 13,
	  navPrev: null,
	  navNext: null,
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	  onOutsideClick: function () {
	    function onOutsideClick() {}
	
	    return onOutsideClick;
	  }(),
	  renderCalendarDay: undefined,
	  renderDayContents: null,
	  renderCalendarInfo: null,
	  renderMonthElement: null,
	  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
	  // accessibility
	  onBlur: function () {
	    function onBlur() {}
	
	    return onBlur;
	  }(),
	  isFocused: false,
	  showKeyboardShortcuts: false,
	  onTab: function () {
	    function onTab() {}
	
	    return onTab;
	  }(),
	  onShiftTab: function () {
	    function onShiftTab() {}
	
	    return onShiftTab;
	  }(),
	  // i18n
	  monthFormat: 'MMMM YYYY',
	  weekDayFormat: 'dd',
	  phrases: _defaultPhrases.DayPickerPhrases,
	  dayAriaLabelFormat: undefined,
	  isRTL: false
	};
	
	var DayPickerSingleDateController =
	/*#__PURE__*/
	function (_ref) {
	  _inherits(DayPickerSingleDateController, _ref);
	
	  _createClass(DayPickerSingleDateController, [{
	    key: !_react["default"].PureComponent && "shouldComponentUpdate",
	    value: function () {
	      function value(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
	      }
	
	      return value;
	    }()
	  }]);
	
	  function DayPickerSingleDateController(props) {
	    var _this;
	
	    _classCallCheck(this, DayPickerSingleDateController);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(DayPickerSingleDateController).call(this, props));
	    _this.isTouchDevice = false;
	    _this.today = (0, _moment["default"])();
	    _this.modifiers = {
	      today: function () {
	        function today(day) {
	          return _this.isToday(day);
	        }
	
	        return today;
	      }(),
	      blocked: function () {
	        function blocked(day) {
	          return _this.isBlocked(day);
	        }
	
	        return blocked;
	      }(),
	      'blocked-calendar': function () {
	        function blockedCalendar(day) {
	          return props.isDayBlocked(day);
	        }
	
	        return blockedCalendar;
	      }(),
	      'blocked-out-of-range': function () {
	        function blockedOutOfRange(day) {
	          return props.isOutsideRange(day);
	        }
	
	        return blockedOutOfRange;
	      }(),
	      'highlighted-calendar': function () {
	        function highlightedCalendar(day) {
	          return props.isDayHighlighted(day);
	        }
	
	        return highlightedCalendar;
	      }(),
	      valid: function () {
	        function valid(day) {
	          return !_this.isBlocked(day);
	        }
	
	        return valid;
	      }(),
	      hovered: function () {
	        function hovered(day) {
	          return _this.isHovered(day);
	        }
	
	        return hovered;
	      }(),
	      selected: function () {
	        function selected(day) {
	          return _this.isSelected(day);
	        }
	
	        return selected;
	      }(),
	      'first-day-of-week': function () {
	        function firstDayOfWeek(day) {
	          return _this.isFirstDayOfWeek(day);
	        }
	
	        return firstDayOfWeek;
	      }(),
	      'last-day-of-week': function () {
	        function lastDayOfWeek(day) {
	          return _this.isLastDayOfWeek(day);
	        }
	
	        return lastDayOfWeek;
	      }()
	    };
	
	    var _this$getStateForNewM = _this.getStateForNewMonth(props),
	        currentMonth = _this$getStateForNewM.currentMonth,
	        visibleDays = _this$getStateForNewM.visibleDays;
	
	    _this.state = {
	      hoverDate: null,
	      currentMonth: currentMonth,
	      visibleDays: visibleDays
	    };
	    _this.onDayMouseEnter = _this.onDayMouseEnter.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onDayMouseLeave = _this.onDayMouseLeave.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onDayClick = _this.onDayClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onNextMonthClick = _this.onNextMonthClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onMonthChange = _this.onMonthChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onYearChange = _this.onYearChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    return _this;
	  }
	
	  _createClass(DayPickerSingleDateController, [{
	    key: "componentDidMount",
	    value: function () {
	      function componentDidMount() {
	        this.isTouchDevice = (0, _isTouchDevice["default"])();
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "componentWillReceiveProps",
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        var date = nextProps.date,
	            focused = nextProps.focused,
	            isOutsideRange = nextProps.isOutsideRange,
	            isDayBlocked = nextProps.isDayBlocked,
	            isDayHighlighted = nextProps.isDayHighlighted,
	            initialVisibleMonth = nextProps.initialVisibleMonth,
	            numberOfMonths = nextProps.numberOfMonths,
	            enableOutsideDays = nextProps.enableOutsideDays;
	        var _this$props = this.props,
	            prevIsOutsideRange = _this$props.isOutsideRange,
	            prevIsDayBlocked = _this$props.isDayBlocked,
	            prevIsDayHighlighted = _this$props.isDayHighlighted,
	            prevNumberOfMonths = _this$props.numberOfMonths,
	            prevEnableOutsideDays = _this$props.enableOutsideDays,
	            prevInitialVisibleMonth = _this$props.initialVisibleMonth,
	            prevFocused = _this$props.focused,
	            prevDate = _this$props.date;
	        var visibleDays = this.state.visibleDays;
	        var recomputeOutsideRange = false;
	        var recomputeDayBlocked = false;
	        var recomputeDayHighlighted = false;
	
	        if (isOutsideRange !== prevIsOutsideRange) {
	          this.modifiers['blocked-out-of-range'] = function (day) {
	            return isOutsideRange(day);
	          };
	
	          recomputeOutsideRange = true;
	        }
	
	        if (isDayBlocked !== prevIsDayBlocked) {
	          this.modifiers['blocked-calendar'] = function (day) {
	            return isDayBlocked(day);
	          };
	
	          recomputeDayBlocked = true;
	        }
	
	        if (isDayHighlighted !== prevIsDayHighlighted) {
	          this.modifiers['highlighted-calendar'] = function (day) {
	            return isDayHighlighted(day);
	          };
	
	          recomputeDayHighlighted = true;
	        }
	
	        var recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;
	
	        if (numberOfMonths !== prevNumberOfMonths || enableOutsideDays !== prevEnableOutsideDays || initialVisibleMonth !== prevInitialVisibleMonth && !prevFocused && focused) {
	          var newMonthState = this.getStateForNewMonth(nextProps);
	          var currentMonth = newMonthState.currentMonth;
	          visibleDays = newMonthState.visibleDays;
	          this.setState({
	            currentMonth: currentMonth,
	            visibleDays: visibleDays
	          });
	        }
	
	        var didDateChange = date !== prevDate;
	        var didFocusChange = focused !== prevFocused;
	        var modifiers = {};
	
	        if (didDateChange) {
	          modifiers = this.deleteModifier(modifiers, prevDate, 'selected');
	          modifiers = this.addModifier(modifiers, date, 'selected');
	        }
	
	        if (didFocusChange || recomputePropModifiers) {
	          (0, _object["default"])(visibleDays).forEach(function (days) {
	            Object.keys(days).forEach(function (day) {
	              var momentObj = (0, _moment["default"])(day);
	
	              if (_this2.isBlocked(momentObj)) {
	                modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
	              } else {
	                modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
	              }
	
	              if (didFocusChange || recomputeOutsideRange) {
	                if (isOutsideRange(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
	                }
	              }
	
	              if (didFocusChange || recomputeDayBlocked) {
	                if (isDayBlocked(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
	                }
	              }
	
	              if (didFocusChange || recomputeDayHighlighted) {
	                if (isDayHighlighted(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
	                }
	              }
	            });
	          });
	        }
	
	        var today = (0, _moment["default"])();
	
	        if (!(0, _isSameDay["default"])(this.today, today)) {
	          modifiers = this.deleteModifier(modifiers, this.today, 'today');
	          modifiers = this.addModifier(modifiers, today, 'today');
	          this.today = today;
	        }
	
	        if (Object.keys(modifiers).length > 0) {
	          this.setState({
	            visibleDays: _objectSpread({}, visibleDays, modifiers)
	          });
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: "componentWillUpdate",
	    value: function () {
	      function componentWillUpdate() {
	        this.today = (0, _moment["default"])();
	      }
	
	      return componentWillUpdate;
	    }()
	  }, {
	    key: "onDayClick",
	    value: function () {
	      function onDayClick(day, e) {
	        if (e) e.preventDefault();
	        if (this.isBlocked(day)) return;
	        var _this$props2 = this.props,
	            onDateChange = _this$props2.onDateChange,
	            keepOpenOnDateSelect = _this$props2.keepOpenOnDateSelect,
	            onFocusChange = _this$props2.onFocusChange,
	            onClose = _this$props2.onClose;
	        onDateChange(day);
	
	        if (!keepOpenOnDateSelect) {
	          onFocusChange({
	            focused: false
	          });
	          onClose({
	            date: day
	          });
	        }
	      }
	
	      return onDayClick;
	    }()
	  }, {
	    key: "onDayMouseEnter",
	    value: function () {
	      function onDayMouseEnter(day) {
	        if (this.isTouchDevice) return;
	        var _this$state = this.state,
	            hoverDate = _this$state.hoverDate,
	            visibleDays = _this$state.visibleDays;
	        var modifiers = this.deleteModifier({}, hoverDate, 'hovered');
	        modifiers = this.addModifier(modifiers, day, 'hovered');
	        this.setState({
	          hoverDate: day,
	          visibleDays: _objectSpread({}, visibleDays, modifiers)
	        });
	      }
	
	      return onDayMouseEnter;
	    }()
	  }, {
	    key: "onDayMouseLeave",
	    value: function () {
	      function onDayMouseLeave() {
	        var _this$state2 = this.state,
	            hoverDate = _this$state2.hoverDate,
	            visibleDays = _this$state2.visibleDays;
	        if (this.isTouchDevice || !hoverDate) return;
	        var modifiers = this.deleteModifier({}, hoverDate, 'hovered');
	        this.setState({
	          hoverDate: null,
	          visibleDays: _objectSpread({}, visibleDays, modifiers)
	        });
	      }
	
	      return onDayMouseLeave;
	    }()
	  }, {
	    key: "onPrevMonthClick",
	    value: function () {
	      function onPrevMonthClick() {
	        var _this$props3 = this.props,
	            onPrevMonthClick = _this$props3.onPrevMonthClick,
	            numberOfMonths = _this$props3.numberOfMonths,
	            enableOutsideDays = _this$props3.enableOutsideDays;
	        var _this$state3 = this.state,
	            currentMonth = _this$state3.currentMonth,
	            visibleDays = _this$state3.visibleDays;
	        var newVisibleDays = {};
	        Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach(function (month) {
	          newVisibleDays[month] = visibleDays[month];
	        });
	        var prevMonth = currentMonth.clone().subtract(1, 'month');
	        var prevMonthVisibleDays = (0, _getVisibleDays["default"])(prevMonth, 1, enableOutsideDays);
	        this.setState({
	          currentMonth: prevMonth,
	          visibleDays: _objectSpread({}, newVisibleDays, this.getModifiers(prevMonthVisibleDays))
	        }, function () {
	          onPrevMonthClick(prevMonth.clone());
	        });
	      }
	
	      return onPrevMonthClick;
	    }()
	  }, {
	    key: "onNextMonthClick",
	    value: function () {
	      function onNextMonthClick() {
	        var _this$props4 = this.props,
	            onNextMonthClick = _this$props4.onNextMonthClick,
	            numberOfMonths = _this$props4.numberOfMonths,
	            enableOutsideDays = _this$props4.enableOutsideDays;
	        var _this$state4 = this.state,
	            currentMonth = _this$state4.currentMonth,
	            visibleDays = _this$state4.visibleDays;
	        var newVisibleDays = {};
	        Object.keys(visibleDays).sort().slice(1).forEach(function (month) {
	          newVisibleDays[month] = visibleDays[month];
	        });
	        var nextMonth = currentMonth.clone().add(numberOfMonths, 'month');
	        var nextMonthVisibleDays = (0, _getVisibleDays["default"])(nextMonth, 1, enableOutsideDays);
	        var newCurrentMonth = currentMonth.clone().add(1, 'month');
	        this.setState({
	          currentMonth: newCurrentMonth,
	          visibleDays: _objectSpread({}, newVisibleDays, this.getModifiers(nextMonthVisibleDays))
	        }, function () {
	          onNextMonthClick(newCurrentMonth.clone());
	        });
	      }
	
	      return onNextMonthClick;
	    }()
	  }, {
	    key: "onMonthChange",
	    value: function () {
	      function onMonthChange(newMonth) {
	        var _this$props5 = this.props,
	            numberOfMonths = _this$props5.numberOfMonths,
	            enableOutsideDays = _this$props5.enableOutsideDays,
	            orientation = _this$props5.orientation;
	        var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
	        var newVisibleDays = (0, _getVisibleDays["default"])(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
	        this.setState({
	          currentMonth: newMonth.clone(),
	          visibleDays: this.getModifiers(newVisibleDays)
	        });
	      }
	
	      return onMonthChange;
	    }()
	  }, {
	    key: "onYearChange",
	    value: function () {
	      function onYearChange(newMonth) {
	        var _this$props6 = this.props,
	            numberOfMonths = _this$props6.numberOfMonths,
	            enableOutsideDays = _this$props6.enableOutsideDays,
	            orientation = _this$props6.orientation;
	        var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
	        var newVisibleDays = (0, _getVisibleDays["default"])(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
	        this.setState({
	          currentMonth: newMonth.clone(),
	          visibleDays: this.getModifiers(newVisibleDays)
	        });
	      }
	
	      return onYearChange;
	    }()
	  }, {
	    key: "getFirstFocusableDay",
	    value: function () {
	      function getFirstFocusableDay(newMonth) {
	        var _this3 = this;
	
	        var _this$props7 = this.props,
	            date = _this$props7.date,
	            numberOfMonths = _this$props7.numberOfMonths;
	        var focusedDate = newMonth.clone().startOf('month');
	
	        if (date) {
	          focusedDate = date.clone();
	        }
	
	        if (this.isBlocked(focusedDate)) {
	          var days = [];
	          var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
	          var currentDay = focusedDate.clone();
	
	          while (!(0, _isAfterDay["default"])(currentDay, lastVisibleDay)) {
	            currentDay = currentDay.clone().add(1, 'day');
	            days.push(currentDay);
	          }
	
	          var viableDays = days.filter(function (day) {
	            return !_this3.isBlocked(day) && (0, _isAfterDay["default"])(day, focusedDate);
	          });
	
	          if (viableDays.length > 0) {
	            var _viableDays = _slicedToArray(viableDays, 1);
	
	            focusedDate = _viableDays[0];
	          }
	        }
	
	        return focusedDate;
	      }
	
	      return getFirstFocusableDay;
	    }()
	  }, {
	    key: "getModifiers",
	    value: function () {
	      function getModifiers(visibleDays) {
	        var _this4 = this;
	
	        var modifiers = {};
	        Object.keys(visibleDays).forEach(function (month) {
	          modifiers[month] = {};
	          visibleDays[month].forEach(function (day) {
	            modifiers[month][(0, _toISODateString["default"])(day)] = _this4.getModifiersForDay(day);
	          });
	        });
	        return modifiers;
	      }
	
	      return getModifiers;
	    }()
	  }, {
	    key: "getModifiersForDay",
	    value: function () {
	      function getModifiersForDay(day) {
	        var _this5 = this;
	
	        return new Set(Object.keys(this.modifiers).filter(function (modifier) {
	          return _this5.modifiers[modifier](day);
	        }));
	      }
	
	      return getModifiersForDay;
	    }()
	  }, {
	    key: "getStateForNewMonth",
	    value: function () {
	      function getStateForNewMonth(nextProps) {
	        var _this6 = this;
	
	        var initialVisibleMonth = nextProps.initialVisibleMonth,
	            date = nextProps.date,
	            numberOfMonths = nextProps.numberOfMonths,
	            enableOutsideDays = nextProps.enableOutsideDays;
	        var initialVisibleMonthThunk = initialVisibleMonth || (date ? function () {
	          return date;
	        } : function () {
	          return _this6.today;
	        });
	        var currentMonth = initialVisibleMonthThunk();
	        var visibleDays = this.getModifiers((0, _getVisibleDays["default"])(currentMonth, numberOfMonths, enableOutsideDays));
	        return {
	          currentMonth: currentMonth,
	          visibleDays: visibleDays
	        };
	      }
	
	      return getStateForNewMonth;
	    }()
	  }, {
	    key: "addModifier",
	    value: function () {
	      function addModifier(updatedDays, day, modifier) {
	        var _this$props8 = this.props,
	            numberOfVisibleMonths = _this$props8.numberOfMonths,
	            enableOutsideDays = _this$props8.enableOutsideDays,
	            orientation = _this$props8.orientation;
	        var _this$state5 = this.state,
	            firstVisibleMonth = _this$state5.currentMonth,
	            visibleDays = _this$state5.visibleDays;
	        var currentMonth = firstVisibleMonth;
	        var numberOfMonths = numberOfVisibleMonths;
	
	        if (orientation === _constants.VERTICAL_SCROLLABLE) {
	          numberOfMonths = Object.keys(visibleDays).length;
	        } else {
	          currentMonth = currentMonth.clone().subtract(1, 'month');
	          numberOfMonths += 2;
	        }
	
	        if (!day || !(0, _isDayVisible["default"])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
	          return updatedDays;
	        }
	
	        var iso = (0, _toISODateString["default"])(day);
	
	        var updatedDaysAfterAddition = _objectSpread({}, updatedDays);
	
	        if (enableOutsideDays) {
	          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
	            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
	          });
	          updatedDaysAfterAddition = monthsToUpdate.reduce(function (days, monthIso) {
	            var month = updatedDays[monthIso] || visibleDays[monthIso];
	            var modifiers = new Set(month[iso]);
	            modifiers.add(modifier);
	            return _objectSpread({}, days, _defineProperty({}, monthIso, _objectSpread({}, month, _defineProperty({}, iso, modifiers))));
	          }, updatedDaysAfterAddition);
	        } else {
	          var monthIso = (0, _toISOMonthString["default"])(day);
	          var month = updatedDays[monthIso] || visibleDays[monthIso];
	          var modifiers = new Set(month[iso]);
	          modifiers.add(modifier);
	          updatedDaysAfterAddition = _objectSpread({}, updatedDaysAfterAddition, _defineProperty({}, monthIso, _objectSpread({}, month, _defineProperty({}, iso, modifiers))));
	        }
	
	        return updatedDaysAfterAddition;
	      }
	
	      return addModifier;
	    }()
	  }, {
	    key: "deleteModifier",
	    value: function () {
	      function deleteModifier(updatedDays, day, modifier) {
	        var _this$props9 = this.props,
	            numberOfVisibleMonths = _this$props9.numberOfMonths,
	            enableOutsideDays = _this$props9.enableOutsideDays,
	            orientation = _this$props9.orientation;
	        var _this$state6 = this.state,
	            firstVisibleMonth = _this$state6.currentMonth,
	            visibleDays = _this$state6.visibleDays;
	        var currentMonth = firstVisibleMonth;
	        var numberOfMonths = numberOfVisibleMonths;
	
	        if (orientation === _constants.VERTICAL_SCROLLABLE) {
	          numberOfMonths = Object.keys(visibleDays).length;
	        } else {
	          currentMonth = currentMonth.clone().subtract(1, 'month');
	          numberOfMonths += 2;
	        }
	
	        if (!day || !(0, _isDayVisible["default"])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
	          return updatedDays;
	        }
	
	        var iso = (0, _toISODateString["default"])(day);
	
	        var updatedDaysAfterDeletion = _objectSpread({}, updatedDays);
	
	        if (enableOutsideDays) {
	          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
	            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
	          });
	          updatedDaysAfterDeletion = monthsToUpdate.reduce(function (days, monthIso) {
	            var month = updatedDays[monthIso] || visibleDays[monthIso];
	            var modifiers = new Set(month[iso]);
	            modifiers["delete"](modifier);
	            return _objectSpread({}, days, _defineProperty({}, monthIso, _objectSpread({}, month, _defineProperty({}, iso, modifiers))));
	          }, updatedDaysAfterDeletion);
	        } else {
	          var monthIso = (0, _toISOMonthString["default"])(day);
	          var month = updatedDays[monthIso] || visibleDays[monthIso];
	          var modifiers = new Set(month[iso]);
	          modifiers["delete"](modifier);
	          updatedDaysAfterDeletion = _objectSpread({}, updatedDaysAfterDeletion, _defineProperty({}, monthIso, _objectSpread({}, month, _defineProperty({}, iso, modifiers))));
	        }
	
	        return updatedDaysAfterDeletion;
	      }
	
	      return deleteModifier;
	    }()
	  }, {
	    key: "isBlocked",
	    value: function () {
	      function isBlocked(day) {
	        var _this$props10 = this.props,
	            isDayBlocked = _this$props10.isDayBlocked,
	            isOutsideRange = _this$props10.isOutsideRange;
	        return isDayBlocked(day) || isOutsideRange(day);
	      }
	
	      return isBlocked;
	    }()
	  }, {
	    key: "isHovered",
	    value: function () {
	      function isHovered(day) {
	        var _ref2 = this.state || {},
	            hoverDate = _ref2.hoverDate;
	
	        return (0, _isSameDay["default"])(day, hoverDate);
	      }
	
	      return isHovered;
	    }()
	  }, {
	    key: "isSelected",
	    value: function () {
	      function isSelected(day) {
	        var date = this.props.date;
	        return (0, _isSameDay["default"])(day, date);
	      }
	
	      return isSelected;
	    }()
	  }, {
	    key: "isToday",
	    value: function () {
	      function isToday(day) {
	        return (0, _isSameDay["default"])(day, this.today);
	      }
	
	      return isToday;
	    }()
	  }, {
	    key: "isFirstDayOfWeek",
	    value: function () {
	      function isFirstDayOfWeek(day) {
	        var firstDayOfWeek = this.props.firstDayOfWeek;
	        return day.day() === (firstDayOfWeek || _moment["default"].localeData().firstDayOfWeek());
	      }
	
	      return isFirstDayOfWeek;
	    }()
	  }, {
	    key: "isLastDayOfWeek",
	    value: function () {
	      function isLastDayOfWeek(day) {
	        var firstDayOfWeek = this.props.firstDayOfWeek;
	        return day.day() === ((firstDayOfWeek || _moment["default"].localeData().firstDayOfWeek()) + 6) % 7;
	      }
	
	      return isLastDayOfWeek;
	    }()
	  }, {
	    key: "render",
	    value: function () {
	      function render() {
	        var _this$props11 = this.props,
	            numberOfMonths = _this$props11.numberOfMonths,
	            orientation = _this$props11.orientation,
	            monthFormat = _this$props11.monthFormat,
	            renderMonthText = _this$props11.renderMonthText,
	            navPrev = _this$props11.navPrev,
	            navNext = _this$props11.navNext,
	            onOutsideClick = _this$props11.onOutsideClick,
	            onShiftTab = _this$props11.onShiftTab,
	            onTab = _this$props11.onTab,
	            withPortal = _this$props11.withPortal,
	            focused = _this$props11.focused,
	            enableOutsideDays = _this$props11.enableOutsideDays,
	            hideKeyboardShortcutsPanel = _this$props11.hideKeyboardShortcutsPanel,
	            daySize = _this$props11.daySize,
	            firstDayOfWeek = _this$props11.firstDayOfWeek,
	            renderCalendarDay = _this$props11.renderCalendarDay,
	            renderDayContents = _this$props11.renderDayContents,
	            renderCalendarInfo = _this$props11.renderCalendarInfo,
	            renderMonthElement = _this$props11.renderMonthElement,
	            calendarInfoPosition = _this$props11.calendarInfoPosition,
	            isFocused = _this$props11.isFocused,
	            isRTL = _this$props11.isRTL,
	            phrases = _this$props11.phrases,
	            dayAriaLabelFormat = _this$props11.dayAriaLabelFormat,
	            onBlur = _this$props11.onBlur,
	            showKeyboardShortcuts = _this$props11.showKeyboardShortcuts,
	            weekDayFormat = _this$props11.weekDayFormat,
	            verticalHeight = _this$props11.verticalHeight,
	            noBorder = _this$props11.noBorder,
	            transitionDuration = _this$props11.transitionDuration,
	            verticalBorderSpacing = _this$props11.verticalBorderSpacing,
	            horizontalMonthPadding = _this$props11.horizontalMonthPadding;
	        var _this$state7 = this.state,
	            currentMonth = _this$state7.currentMonth,
	            visibleDays = _this$state7.visibleDays;
	        return _react["default"].createElement(_DayPicker["default"], {
	          orientation: orientation,
	          enableOutsideDays: enableOutsideDays,
	          modifiers: visibleDays,
	          numberOfMonths: numberOfMonths,
	          onDayClick: this.onDayClick,
	          onDayMouseEnter: this.onDayMouseEnter,
	          onDayMouseLeave: this.onDayMouseLeave,
	          onPrevMonthClick: this.onPrevMonthClick,
	          onNextMonthClick: this.onNextMonthClick,
	          onMonthChange: this.onMonthChange,
	          onYearChange: this.onYearChange,
	          monthFormat: monthFormat,
	          withPortal: withPortal,
	          hidden: !focused,
	          hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	          initialVisibleMonth: function () {
	            function initialVisibleMonth() {
	              return currentMonth;
	            }
	
	            return initialVisibleMonth;
	          }(),
	          firstDayOfWeek: firstDayOfWeek,
	          onOutsideClick: onOutsideClick,
	          navPrev: navPrev,
	          navNext: navNext,
	          renderMonthText: renderMonthText,
	          renderCalendarDay: renderCalendarDay,
	          renderDayContents: renderDayContents,
	          renderCalendarInfo: renderCalendarInfo,
	          renderMonthElement: renderMonthElement,
	          calendarInfoPosition: calendarInfoPosition,
	          isFocused: isFocused,
	          getFirstFocusableDay: this.getFirstFocusableDay,
	          onBlur: onBlur,
	          onTab: onTab,
	          onShiftTab: onShiftTab,
	          phrases: phrases,
	          daySize: daySize,
	          isRTL: isRTL,
	          showKeyboardShortcuts: showKeyboardShortcuts,
	          weekDayFormat: weekDayFormat,
	          dayAriaLabelFormat: dayAriaLabelFormat,
	          verticalHeight: verticalHeight,
	          noBorder: noBorder,
	          transitionDuration: transitionDuration,
	          verticalBorderSpacing: verticalBorderSpacing,
	          horizontalMonthPadding: horizontalMonthPadding
	        });
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DayPickerSingleDateController;
	}(_react["default"].PureComponent || _react["default"].Component);
	
	exports["default"] = DayPickerSingleDateController;
	DayPickerSingleDateController.propTypes =  false ? propTypes : {};
	DayPickerSingleDateController.defaultProps = defaultProps;

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var LeftArrow = function () {
	  function LeftArrow(props) {
	    return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
	      d: "M336.2 274.5l-210.1 210h805.4c13 0 23 10 23 23s-10 23-23 23H126.1l210.1 210.1c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7l-249.1-249c-11-11-11-21 0-32l249.1-249.1c21-21.1 53 10.9 32 32z"
	    }));
	  }
	
	  return LeftArrow;
	}();
	
	LeftArrow.defaultProps = {
	  focusable: "false",
	  viewBox: "0 0 1000 1000"
	};
	var _default = LeftArrow;
	exports["default"] = _default;

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var RightArrow = function () {
	  function RightArrow(props) {
	    return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
	      d: "M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z"
	    }));
	  }
	
	  return RightArrow;
	}();
	
	RightArrow.defaultProps = {
	  focusable: "false",
	  viewBox: "0 0 1000 1000"
	};
	var _default = RightArrow;
	exports["default"] = _default;

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _defaultPhrases = __webpack_require__(51);
	
	var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(60));
	
	var _noflip = _interopRequireDefault(__webpack_require__(127));
	
	var _DateInput = _interopRequireDefault(__webpack_require__(854));
	
	var _IconPositionShape = _interopRequireDefault(__webpack_require__(174));
	
	var _CloseButton = _interopRequireDefault(__webpack_require__(222));
	
	var _CalendarIcon = _interopRequireDefault(__webpack_require__(851));
	
	var _OpenDirectionShape = _interopRequireDefault(__webpack_require__(146));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
	  id: _propTypes["default"].string.isRequired,
	  children: _propTypes["default"].node,
	  placeholder: _propTypes["default"].string,
	  // also used as label
	  displayValue: _propTypes["default"].string,
	  screenReaderMessage: _propTypes["default"].string,
	  focused: _propTypes["default"].bool,
	  isFocused: _propTypes["default"].bool,
	  // describes actual DOM focus
	  disabled: _propTypes["default"].bool,
	  required: _propTypes["default"].bool,
	  readOnly: _propTypes["default"].bool,
	  openDirection: _OpenDirectionShape["default"],
	  showCaret: _propTypes["default"].bool,
	  showClearDate: _propTypes["default"].bool,
	  customCloseIcon: _propTypes["default"].node,
	  showDefaultInputIcon: _propTypes["default"].bool,
	  inputIconPosition: _IconPositionShape["default"],
	  customInputIcon: _propTypes["default"].node,
	  isRTL: _propTypes["default"].bool,
	  noBorder: _propTypes["default"].bool,
	  block: _propTypes["default"].bool,
	  small: _propTypes["default"].bool,
	  regular: _propTypes["default"].bool,
	  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
	  onChange: _propTypes["default"].func,
	  onClearDate: _propTypes["default"].func,
	  onFocus: _propTypes["default"].func,
	  onKeyDownShiftTab: _propTypes["default"].func,
	  onKeyDownTab: _propTypes["default"].func,
	  onKeyDownArrowDown: _propTypes["default"].func,
	  onKeyDownQuestionMark: _propTypes["default"].func,
	  // i18n
	  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.SingleDatePickerInputPhrases))
	})) : {};
	var defaultProps = {
	  children: null,
	  placeholder: 'Select Date',
	  displayValue: '',
	  screenReaderMessage: '',
	  focused: false,
	  isFocused: false,
	  disabled: false,
	  required: false,
	  readOnly: false,
	  openDirection: _constants.OPEN_DOWN,
	  showCaret: false,
	  showClearDate: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  customCloseIcon: null,
	  customInputIcon: null,
	  isRTL: false,
	  noBorder: false,
	  block: false,
	  small: false,
	  regular: false,
	  verticalSpacing: undefined,
	  onChange: function () {
	    function onChange() {}
	
	    return onChange;
	  }(),
	  onClearDate: function () {
	    function onClearDate() {}
	
	    return onClearDate;
	  }(),
	  onFocus: function () {
	    function onFocus() {}
	
	    return onFocus;
	  }(),
	  onKeyDownShiftTab: function () {
	    function onKeyDownShiftTab() {}
	
	    return onKeyDownShiftTab;
	  }(),
	  onKeyDownTab: function () {
	    function onKeyDownTab() {}
	
	    return onKeyDownTab;
	  }(),
	  onKeyDownArrowDown: function () {
	    function onKeyDownArrowDown() {}
	
	    return onKeyDownArrowDown;
	  }(),
	  onKeyDownQuestionMark: function () {
	    function onKeyDownQuestionMark() {}
	
	    return onKeyDownQuestionMark;
	  }(),
	  // i18n
	  phrases: _defaultPhrases.SingleDatePickerInputPhrases
	};
	
	function SingleDatePickerInput(_ref) {
	  var id = _ref.id,
	      children = _ref.children,
	      placeholder = _ref.placeholder,
	      displayValue = _ref.displayValue,
	      focused = _ref.focused,
	      isFocused = _ref.isFocused,
	      disabled = _ref.disabled,
	      required = _ref.required,
	      readOnly = _ref.readOnly,
	      showCaret = _ref.showCaret,
	      showClearDate = _ref.showClearDate,
	      showDefaultInputIcon = _ref.showDefaultInputIcon,
	      inputIconPosition = _ref.inputIconPosition,
	      phrases = _ref.phrases,
	      onClearDate = _ref.onClearDate,
	      onChange = _ref.onChange,
	      onFocus = _ref.onFocus,
	      onKeyDownShiftTab = _ref.onKeyDownShiftTab,
	      onKeyDownTab = _ref.onKeyDownTab,
	      onKeyDownArrowDown = _ref.onKeyDownArrowDown,
	      onKeyDownQuestionMark = _ref.onKeyDownQuestionMark,
	      screenReaderMessage = _ref.screenReaderMessage,
	      customCloseIcon = _ref.customCloseIcon,
	      customInputIcon = _ref.customInputIcon,
	      openDirection = _ref.openDirection,
	      isRTL = _ref.isRTL,
	      noBorder = _ref.noBorder,
	      block = _ref.block,
	      small = _ref.small,
	      regular = _ref.regular,
	      verticalSpacing = _ref.verticalSpacing,
	      styles = _ref.styles;
	
	  var calendarIcon = customInputIcon || _react["default"].createElement(_CalendarIcon["default"], (0, _reactWithStyles.css)(styles.SingleDatePickerInput_calendarIcon_svg));
	
	  var closeIcon = customCloseIcon || _react["default"].createElement(_CloseButton["default"], (0, _reactWithStyles.css)(styles.SingleDatePickerInput_clearDate_svg, small && styles.SingleDatePickerInput_clearDate_svg__small));
	
	  var screenReaderText = screenReaderMessage || phrases.keyboardNavigationInstructions;
	
	  var inputIcon = (showDefaultInputIcon || customInputIcon !== null) && _react["default"].createElement("button", _extends({}, (0, _reactWithStyles.css)(styles.SingleDatePickerInput_calendarIcon), {
	    type: "button",
	    disabled: disabled,
	    "aria-label": phrases.focusStartDate,
	    onClick: onFocus
	  }), calendarIcon);
	
	  return _react["default"].createElement("div", (0, _reactWithStyles.css)(styles.SingleDatePickerInput, disabled && styles.SingleDatePickerInput__disabled, isRTL && styles.SingleDatePickerInput__rtl, !noBorder && styles.SingleDatePickerInput__withBorder, block && styles.SingleDatePickerInput__block, showClearDate && styles.SingleDatePickerInput__showClearDate), inputIconPosition === _constants.ICON_BEFORE_POSITION && inputIcon, _react["default"].createElement(_DateInput["default"], {
	    id: id,
	    placeholder: placeholder // also used as label
	    ,
	    displayValue: displayValue,
	    screenReaderMessage: screenReaderText,
	    focused: focused,
	    isFocused: isFocused,
	    disabled: disabled,
	    required: required,
	    readOnly: readOnly,
	    showCaret: showCaret,
	    onChange: onChange,
	    onFocus: onFocus,
	    onKeyDownShiftTab: onKeyDownShiftTab,
	    onKeyDownTab: onKeyDownTab,
	    onKeyDownArrowDown: onKeyDownArrowDown,
	    onKeyDownQuestionMark: onKeyDownQuestionMark,
	    openDirection: openDirection,
	    verticalSpacing: verticalSpacing,
	    small: small,
	    regular: regular,
	    block: block
	  }), children, showClearDate && _react["default"].createElement("button", _extends({}, (0, _reactWithStyles.css)(styles.SingleDatePickerInput_clearDate, small && styles.SingleDatePickerInput_clearDate__small, !customCloseIcon && styles.SingleDatePickerInput_clearDate__default, !displayValue && styles.SingleDatePickerInput_clearDate__hide), {
	    type: "button",
	    "aria-label": phrases.clearDate,
	    disabled: disabled,
	    onClick: onClearDate
	  }), closeIcon), inputIconPosition === _constants.ICON_AFTER_POSITION && inputIcon);
	}
	
	SingleDatePickerInput.propTypes =  false ? propTypes : {};
	SingleDatePickerInput.defaultProps = defaultProps;
	
	var _default = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var _ref2$reactDates = _ref2.reactDates,
	      border = _ref2$reactDates.border,
	      color = _ref2$reactDates.color;
	  return {
	    SingleDatePickerInput: {
	      display: 'inline-block',
	      backgroundColor: color.background
	    },
	    SingleDatePickerInput__withBorder: {
	      borderColor: color.border,
	      borderWidth: border.pickerInput.borderWidth,
	      borderStyle: border.pickerInput.borderStyle,
	      borderRadius: border.pickerInput.borderRadius
	    },
	    SingleDatePickerInput__rtl: {
	      direction: (0, _noflip["default"])('rtl')
	    },
	    SingleDatePickerInput__disabled: {
	      backgroundColor: color.disabled
	    },
	    SingleDatePickerInput__block: {
	      display: 'block'
	    },
	    SingleDatePickerInput__showClearDate: {
	      paddingRight: 30 // TODO: should be noflip wrapped and handled by an isRTL prop
	
	    },
	    SingleDatePickerInput_clearDate: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	      cursor: 'pointer',
	      padding: 10,
	      margin: '0 10px 0 5px',
	      // TODO: should be noflip wrapped and handled by an isRTL prop
	      position: 'absolute',
	      right: 0,
	      // TODO: should be noflip wrapped and handled by an isRTL prop
	      top: '50%',
	      transform: 'translateY(-50%)'
	    },
	    SingleDatePickerInput_clearDate__default: {
	      ':focus': {
	        background: color.core.border,
	        borderRadius: '50%'
	      },
	      ':hover': {
	        background: color.core.border,
	        borderRadius: '50%'
	      }
	    },
	    SingleDatePickerInput_clearDate__small: {
	      padding: 6
	    },
	    SingleDatePickerInput_clearDate__hide: {
	      visibility: 'hidden'
	    },
	    SingleDatePickerInput_clearDate_svg: {
	      fill: color.core.grayLight,
	      height: 12,
	      width: 15,
	      verticalAlign: 'middle'
	    },
	    SingleDatePickerInput_clearDate_svg__small: {
	      height: 9
	    },
	    SingleDatePickerInput_calendarIcon: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	      cursor: 'pointer',
	      display: 'inline-block',
	      verticalAlign: 'middle',
	      padding: 10,
	      margin: '0 5px 0 10px' // TODO: should be noflip wrapped and handled by an isRTL prop
	
	    },
	    SingleDatePickerInput_calendarIcon_svg: {
	      fill: color.core.grayLight,
	      height: 15,
	      width: 14,
	      verticalAlign: 'middle'
	    }
	  };
	}, {
	  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
	})(SingleDatePickerInput);
	
	exports["default"] = _default;

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _propTypes["default"].oneOf([_constants.ANCHOR_LEFT, _constants.ANCHOR_RIGHT]);
	
	exports["default"] = _default;

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(105));
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _defaultPhrases = __webpack_require__(51);
	
	var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(60));
	
	var _FocusedInputShape = _interopRequireDefault(__webpack_require__(864));
	
	var _IconPositionShape = _interopRequireDefault(__webpack_require__(174));
	
	var _OrientationShape = _interopRequireDefault(__webpack_require__(865));
	
	var _DisabledShape = _interopRequireDefault(__webpack_require__(224));
	
	var _AnchorDirectionShape = _interopRequireDefault(__webpack_require__(862));
	
	var _OpenDirectionShape = _interopRequireDefault(__webpack_require__(146));
	
	var _DayOfWeekShape = _interopRequireDefault(__webpack_require__(145));
	
	var _CalendarInfoPositionShape = _interopRequireDefault(__webpack_require__(223));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = {
	  // required props for a functional interactive DateRangePicker
	  startDate: _reactMomentProptypes["default"].momentObj,
	  endDate: _reactMomentProptypes["default"].momentObj,
	  onDatesChange: _propTypes["default"].func.isRequired,
	  focusedInput: _FocusedInputShape["default"],
	  onFocusChange: _propTypes["default"].func.isRequired,
	  onClose: _propTypes["default"].func,
	  // input related props
	  startDateId: _propTypes["default"].string.isRequired,
	  startDatePlaceholderText: _propTypes["default"].string,
	  startDateOffset: _propTypes["default"].func,
	  endDateOffset: _propTypes["default"].func,
	  endDateId: _propTypes["default"].string.isRequired,
	  endDatePlaceholderText: _propTypes["default"].string,
	  disabled: _DisabledShape["default"],
	  required: _propTypes["default"].bool,
	  readOnly: _propTypes["default"].bool,
	  screenReaderInputMessage: _propTypes["default"].string,
	  showClearDates: _propTypes["default"].bool,
	  showDefaultInputIcon: _propTypes["default"].bool,
	  inputIconPosition: _IconPositionShape["default"],
	  customInputIcon: _propTypes["default"].node,
	  customArrowIcon: _propTypes["default"].node,
	  customCloseIcon: _propTypes["default"].node,
	  noBorder: _propTypes["default"].bool,
	  block: _propTypes["default"].bool,
	  small: _propTypes["default"].bool,
	  regular: _propTypes["default"].bool,
	  keepFocusOnInput: _propTypes["default"].bool,
	  // calendar presentation and interaction related props
	  renderMonthText: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
	  renderMonthElement: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
	  orientation: _OrientationShape["default"],
	  anchorDirection: _AnchorDirectionShape["default"],
	  openDirection: _OpenDirectionShape["default"],
	  horizontalMargin: _propTypes["default"].number,
	  withPortal: _propTypes["default"].bool,
	  withFullScreenPortal: _propTypes["default"].bool,
	  appendToBody: _propTypes["default"].bool,
	  disableScroll: _propTypes["default"].bool,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  isRTL: _propTypes["default"].bool,
	  firstDayOfWeek: _DayOfWeekShape["default"],
	  initialVisibleMonth: _propTypes["default"].func,
	  numberOfMonths: _propTypes["default"].number,
	  keepOpenOnDateSelect: _propTypes["default"].bool,
	  reopenPickerOnClearDates: _propTypes["default"].bool,
	  renderCalendarInfo: _propTypes["default"].func,
	  calendarInfoPosition: _CalendarInfoPositionShape["default"],
	  hideKeyboardShortcutsPanel: _propTypes["default"].bool,
	  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
	  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
	  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
	  horizontalMonthPadding: _airbnbPropTypes.nonNegativeInteger,
	  // navigation related props
	  navPrev: _propTypes["default"].node,
	  navNext: _propTypes["default"].node,
	  onPrevMonthClick: _propTypes["default"].func,
	  onNextMonthClick: _propTypes["default"].func,
	  // day presentation and interaction related props
	  renderCalendarDay: _propTypes["default"].func,
	  renderDayContents: _propTypes["default"].func,
	  minimumNights: _propTypes["default"].number,
	  enableOutsideDays: _propTypes["default"].bool,
	  isDayBlocked: _propTypes["default"].func,
	  isOutsideRange: _propTypes["default"].func,
	  isDayHighlighted: _propTypes["default"].func,
	  // internationalization props
	  displayFormat: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
	  monthFormat: _propTypes["default"].string,
	  weekDayFormat: _propTypes["default"].string,
	  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.DateRangePickerPhrases)),
	  dayAriaLabelFormat: _propTypes["default"].string
	};
	exports["default"] = _default;

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _propTypes["default"].oneOf([_constants.START_DATE, _constants.END_DATE]);
	
	exports["default"] = _default;

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _propTypes["default"].oneOf([_constants.HORIZONTAL_ORIENTATION, _constants.VERTICAL_ORIENTATION]);
	
	exports["default"] = _default;

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(105));
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _defaultPhrases = __webpack_require__(51);
	
	var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(60));
	
	var _IconPositionShape = _interopRequireDefault(__webpack_require__(174));
	
	var _OrientationShape = _interopRequireDefault(__webpack_require__(865));
	
	var _AnchorDirectionShape = _interopRequireDefault(__webpack_require__(862));
	
	var _OpenDirectionShape = _interopRequireDefault(__webpack_require__(146));
	
	var _DayOfWeekShape = _interopRequireDefault(__webpack_require__(145));
	
	var _CalendarInfoPositionShape = _interopRequireDefault(__webpack_require__(223));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = {
	  // required props for a functional interactive SingleDatePicker
	  date: _reactMomentProptypes["default"].momentObj,
	  onDateChange: _propTypes["default"].func.isRequired,
	  focused: _propTypes["default"].bool,
	  onFocusChange: _propTypes["default"].func.isRequired,
	  // input related props
	  id: _propTypes["default"].string.isRequired,
	  placeholder: _propTypes["default"].string,
	  disabled: _propTypes["default"].bool,
	  required: _propTypes["default"].bool,
	  readOnly: _propTypes["default"].bool,
	  screenReaderInputMessage: _propTypes["default"].string,
	  showClearDate: _propTypes["default"].bool,
	  customCloseIcon: _propTypes["default"].node,
	  showDefaultInputIcon: _propTypes["default"].bool,
	  inputIconPosition: _IconPositionShape["default"],
	  customInputIcon: _propTypes["default"].node,
	  noBorder: _propTypes["default"].bool,
	  block: _propTypes["default"].bool,
	  small: _propTypes["default"].bool,
	  regular: _propTypes["default"].bool,
	  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
	  keepFocusOnInput: _propTypes["default"].bool,
	  // calendar presentation and interaction related props
	  renderMonthText: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
	  renderMonthElement: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
	  orientation: _OrientationShape["default"],
	  anchorDirection: _AnchorDirectionShape["default"],
	  openDirection: _OpenDirectionShape["default"],
	  horizontalMargin: _propTypes["default"].number,
	  withPortal: _propTypes["default"].bool,
	  withFullScreenPortal: _propTypes["default"].bool,
	  appendToBody: _propTypes["default"].bool,
	  disableScroll: _propTypes["default"].bool,
	  initialVisibleMonth: _propTypes["default"].func,
	  firstDayOfWeek: _DayOfWeekShape["default"],
	  numberOfMonths: _propTypes["default"].number,
	  keepOpenOnDateSelect: _propTypes["default"].bool,
	  reopenPickerOnClearDate: _propTypes["default"].bool,
	  renderCalendarInfo: _propTypes["default"].func,
	  calendarInfoPosition: _CalendarInfoPositionShape["default"],
	  hideKeyboardShortcutsPanel: _propTypes["default"].bool,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  isRTL: _propTypes["default"].bool,
	  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
	  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
	  horizontalMonthPadding: _airbnbPropTypes.nonNegativeInteger,
	  // navigation related props
	  navPrev: _propTypes["default"].node,
	  navNext: _propTypes["default"].node,
	  onPrevMonthClick: _propTypes["default"].func,
	  onNextMonthClick: _propTypes["default"].func,
	  onClose: _propTypes["default"].func,
	  // day presentation and interaction related props
	  renderCalendarDay: _propTypes["default"].func,
	  renderDayContents: _propTypes["default"].func,
	  enableOutsideDays: _propTypes["default"].bool,
	  isDayBlocked: _propTypes["default"].func,
	  isOutsideRange: _propTypes["default"].func,
	  isDayHighlighted: _propTypes["default"].func,
	  // internationalization props
	  displayFormat: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
	  monthFormat: _propTypes["default"].string,
	  weekDayFormat: _propTypes["default"].string,
	  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.SingleDatePickerPhrases)),
	  dayAriaLabelFormat: _propTypes["default"].string
	};
	exports["default"] = _default;

/***/ },
/* 867 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var core = {
	  white: '#fff',
	  gray: '#484848',
	  grayLight: '#82888a',
	  grayLighter: '#cacccd',
	  grayLightest: '#f2f2f2',
	  borderMedium: '#c4c4c4',
	  border: '#dbdbdb',
	  borderLight: '#e4e7e7',
	  borderLighter: '#eceeee',
	  borderBright: '#f4f5f5',
	  primary: '#00a699',
	  primaryShade_1: '#33dacd',
	  primaryShade_2: '#66e2da',
	  primaryShade_3: '#80e8e0',
	  primaryShade_4: '#b2f1ec',
	  primary_dark: '#008489',
	  secondary: '#007a87',
	  yellow: '#ffe8bc',
	  yellow_dark: '#ffce71'
	};
	var _default = {
	  reactDates: {
	    zIndex: 0,
	    border: {
	      input: {
	        border: 0,
	        borderTop: 0,
	        borderRight: 0,
	        borderBottom: '2px solid transparent',
	        borderLeft: 0,
	        outlineFocused: 0,
	        borderFocused: 0,
	        borderTopFocused: 0,
	        borderLeftFocused: 0,
	        borderBottomFocused: "2px solid ".concat(core.primary_dark),
	        borderRightFocused: 0,
	        borderRadius: 0
	      },
	      pickerInput: {
	        borderWidth: 1,
	        borderStyle: 'solid',
	        borderRadius: 2
	      }
	    },
	    color: {
	      core: core,
	      disabled: core.grayLightest,
	      background: core.white,
	      backgroundDark: '#f2f2f2',
	      backgroundFocused: core.white,
	      border: 'rgb(219, 219, 219)',
	      text: core.gray,
	      textDisabled: core.border,
	      textFocused: '#007a87',
	      placeholderText: '#757575',
	      outside: {
	        backgroundColor: core.white,
	        backgroundColor_active: core.white,
	        backgroundColor_hover: core.white,
	        color: core.gray,
	        color_active: core.gray,
	        color_hover: core.gray
	      },
	      highlighted: {
	        backgroundColor: core.yellow,
	        backgroundColor_active: core.yellow_dark,
	        backgroundColor_hover: core.yellow_dark,
	        color: core.gray,
	        color_active: core.gray,
	        color_hover: core.gray
	      },
	      minimumNights: {
	        backgroundColor: core.white,
	        backgroundColor_active: core.white,
	        backgroundColor_hover: core.white,
	        borderColor: core.borderLighter,
	        color: core.grayLighter,
	        color_active: core.grayLighter,
	        color_hover: core.grayLighter
	      },
	      hoveredSpan: {
	        backgroundColor: core.primaryShade_4,
	        backgroundColor_active: core.primaryShade_3,
	        backgroundColor_hover: core.primaryShade_4,
	        borderColor: core.primaryShade_3,
	        borderColor_active: core.primaryShade_3,
	        borderColor_hover: core.primaryShade_3,
	        color: core.secondary,
	        color_active: core.secondary,
	        color_hover: core.secondary
	      },
	      selectedSpan: {
	        backgroundColor: core.primaryShade_2,
	        backgroundColor_active: core.primaryShade_1,
	        backgroundColor_hover: core.primaryShade_1,
	        borderColor: core.primaryShade_1,
	        borderColor_active: core.primary,
	        borderColor_hover: core.primary,
	        color: core.white,
	        color_active: core.white,
	        color_hover: core.white
	      },
	      selected: {
	        backgroundColor: core.primary,
	        backgroundColor_active: core.primary,
	        backgroundColor_hover: core.primary,
	        borderColor: core.primary,
	        borderColor_active: core.primary,
	        borderColor_hover: core.primary,
	        color: core.white,
	        color_active: core.white,
	        color_hover: core.white
	      },
	      blocked_calendar: {
	        backgroundColor: core.grayLighter,
	        backgroundColor_active: core.grayLighter,
	        backgroundColor_hover: core.grayLighter,
	        borderColor: core.grayLighter,
	        borderColor_active: core.grayLighter,
	        borderColor_hover: core.grayLighter,
	        color: core.grayLight,
	        color_active: core.grayLight,
	        color_hover: core.grayLight
	      },
	      blocked_out_of_range: {
	        backgroundColor: core.white,
	        backgroundColor_active: core.white,
	        backgroundColor_hover: core.white,
	        borderColor: core.borderLight,
	        borderColor_active: core.borderLight,
	        borderColor_hover: core.borderLight,
	        color: core.grayLighter,
	        color_active: core.grayLighter,
	        color_hover: core.grayLighter
	      }
	    },
	    spacing: {
	      dayPickerHorizontalPadding: 9,
	      captionPaddingTop: 22,
	      captionPaddingBottom: 37,
	      inputPadding: 0,
	      displayTextPaddingVertical: undefined,
	      displayTextPaddingTop: 11,
	      displayTextPaddingBottom: 9,
	      displayTextPaddingHorizontal: undefined,
	      displayTextPaddingLeft: 11,
	      displayTextPaddingRight: 11,
	      displayTextPaddingVertical_small: undefined,
	      displayTextPaddingTop_small: 7,
	      displayTextPaddingBottom_small: 5,
	      displayTextPaddingHorizontal_small: undefined,
	      displayTextPaddingLeft_small: 7,
	      displayTextPaddingRight_small: 7
	    },
	    sizing: {
	      inputWidth: 130,
	      inputWidth_small: 97,
	      arrowWidth: 24
	    },
	    noScrollBarOnVerticalScrollable: false,
	    font: {
	      size: 14,
	      captionSize: 18,
	      input: {
	        size: 19,
	        lineHeight: '24px',
	        size_small: 15,
	        lineHeight_small: '18px',
	        letterSpacing_small: '0.2px',
	        styleDisabled: 'italic'
	      }
	    }
	  }
	};
	exports["default"] = _default;

/***/ },
/* 868 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = calculateDimension;
	
	function calculateDimension(el, axis) {
	  var borderBox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  var withMargin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!el) {
	    return 0;
	  }
	
	  var axisStart = axis === 'width' ? 'Left' : 'Top';
	  var axisEnd = axis === 'width' ? 'Right' : 'Bottom'; // Only read styles if we need to
	
	  var style = !borderBox || withMargin ? window.getComputedStyle(el) : null; // Offset includes border and padding
	
	  var offsetWidth = el.offsetWidth,
	      offsetHeight = el.offsetHeight;
	  var size = axis === 'width' ? offsetWidth : offsetHeight; // Get the inner size
	
	  if (!borderBox) {
	    size -= parseFloat(style["padding".concat(axisStart)]) + parseFloat(style["padding".concat(axisEnd)]) + parseFloat(style["border".concat(axisStart, "Width")]) + parseFloat(style["border".concat(axisEnd, "Width")]);
	  } // Apply margin
	
	
	  if (withMargin) {
	    size += parseFloat(style["margin".concat(axisStart)]) + parseFloat(style["margin".concat(axisEnd)]);
	  }
	
	  return size;
	}

/***/ },
/* 869 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getScrollParent = getScrollParent;
	exports.getScrollAncestorsOverflowY = getScrollAncestorsOverflowY;
	exports["default"] = disableScroll;
	
	var getScrollingRoot = function getScrollingRoot() {
	  return document.scrollingElement || document.documentElement;
	};
	/**
	 * Recursively finds the scroll parent of a node. The scroll parrent of a node
	 * is the closest node that is scrollable. A node is scrollable if:
	 *  - it is allowed to scroll via CSS ('overflow-y' not visible or hidden);
	 *  - and its children/content are "bigger" than the node's box height.
	 *
	 * The root of the document always scrolls by default.
	 *
	 * @param {HTMLElement} node Any DOM element.
	 * @return {HTMLElement} The scroll parent element.
	 */
	
	
	function getScrollParent(node) {
	  var parent = node.parentElement;
	  if (parent == null) return getScrollingRoot();
	
	  var _window$getComputedSt = window.getComputedStyle(parent),
	      overflowY = _window$getComputedSt.overflowY;
	
	  var canScroll = overflowY !== 'visible' && overflowY !== 'hidden';
	
	  if (canScroll && parent.scrollHeight > parent.clientHeight) {
	    return parent;
	  }
	
	  return getScrollParent(parent);
	}
	/**
	 * Recursively traverses the tree upwards from the given node, capturing all
	 * ancestor nodes that scroll along with their current 'overflow-y' CSS
	 * property.
	 *
	 * @param {HTMLElement} node Any DOM element.
	 * @param {Map<HTMLElement,string>} [acc] Accumulator map.
	 * @return {Map<HTMLElement,string>} Map of ancestors with their 'overflow-y' value.
	 */
	
	
	function getScrollAncestorsOverflowY(node) {
	  var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
	  var scrollingRoot = getScrollingRoot();
	  var scrollParent = getScrollParent(node);
	  acc.set(scrollParent, scrollParent.style.overflowY);
	  if (scrollParent === scrollingRoot) return acc;
	  return getScrollAncestorsOverflowY(scrollParent, acc);
	}
	/**
	 * Disabling the scroll on a node involves finding all the scrollable ancestors
	 * and set their 'overflow-y' CSS property to 'hidden'. When all ancestors have
	 * 'overflow-y: hidden' (up to the document element) there is no scroll
	 * container, thus all the scroll outside of the node is disabled. In order to
	 * enable scroll again, we store the previous value of the 'overflow-y' for
	 * every ancestor in a closure and reset it back.
	 *
	 * @param {HTMLElement} node Any DOM element.
	 */
	
	
	function disableScroll(node) {
	  var scrollAncestorsOverflowY = getScrollAncestorsOverflowY(node);
	
	  var toggle = function toggle(on) {
	    return scrollAncestorsOverflowY.forEach(function (overflowY, ancestor) {
	      ancestor.style.setProperty('overflow-y', on ? 'hidden' : overflowY);
	    });
	  };
	
	  toggle(true);
	  return function () {
	    return toggle(false);
	  };
	}

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getCalendarDaySettings;
	
	var _getPhrase = _interopRequireDefault(__webpack_require__(1821));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getCalendarDaySettings(day, ariaLabelFormat, daySize, modifiers, phrases) {
	  var chooseAvailableDate = phrases.chooseAvailableDate,
	      dateIsUnavailable = phrases.dateIsUnavailable,
	      dateIsSelected = phrases.dateIsSelected,
	      dateIsSelectedAsStartDate = phrases.dateIsSelectedAsStartDate,
	      dateIsSelectedAsEndDate = phrases.dateIsSelectedAsEndDate;
	  var daySizeStyles = {
	    width: daySize,
	    height: daySize - 1
	  };
	  var useDefaultCursor = modifiers.has('blocked-minimum-nights') || modifiers.has('blocked-calendar') || modifiers.has('blocked-out-of-range');
	  var selected = modifiers.has('selected') || modifiers.has('selected-start') || modifiers.has('selected-end');
	  var hoveredSpan = !selected && (modifiers.has('hovered-span') || modifiers.has('after-hovered-start'));
	  var isOutsideRange = modifiers.has('blocked-out-of-range');
	  var formattedDate = {
	    date: day.format(ariaLabelFormat)
	  };
	  var ariaLabel = (0, _getPhrase["default"])(chooseAvailableDate, formattedDate);
	
	  if (selected) {
	    if (modifiers.has('selected-start') && dateIsSelectedAsStartDate) {
	      ariaLabel = (0, _getPhrase["default"])(dateIsSelectedAsStartDate, formattedDate);
	    } else if (modifiers.has('selected-end') && dateIsSelectedAsEndDate) {
	      ariaLabel = (0, _getPhrase["default"])(dateIsSelectedAsEndDate, formattedDate);
	    } else {
	      ariaLabel = (0, _getPhrase["default"])(dateIsSelected, formattedDate);
	    }
	  } else if (modifiers.has(_constants.BLOCKED_MODIFIER)) {
	    ariaLabel = (0, _getPhrase["default"])(dateIsUnavailable, formattedDate);
	  }
	
	  return {
	    daySizeStyles: daySizeStyles,
	    useDefaultCursor: useDefaultCursor,
	    selected: selected,
	    hoveredSpan: hoveredSpan,
	    isOutsideRange: isOutsideRange,
	    ariaLabel: ariaLabel
	  };
	}

/***/ },
/* 871 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getCalendarMonthWidth;
	
	function getCalendarMonthWidth(daySize) {
	  var calendarMonthPadding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  return 7 * daySize + 2 * calendarMonthPadding + 1;
	}

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getDetachedContainerStyles;
	
	var _constants = __webpack_require__(21);
	
	/**
	 * Calculate and return a CSS transform style to position a detached element
	 * next to a reference element. The open and anchor direction indicate wether
	 * it should be positioned above/below and/or to the left/right of the
	 * reference element.
	 *
	 * Assuming r(0,0), r(1,1), d(0,0), d(1,1) for the bottom-left and top-right
	 * corners of the reference and detached elements, respectively:
	 *  - openDirection = DOWN, anchorDirection = LEFT => d(0,1) == r(0,1)
	 *  - openDirection = UP, anchorDirection = LEFT => d(0,0) == r(0,0)
	 *  - openDirection = DOWN, anchorDirection = RIGHT => d(1,1) == r(1,1)
	 *  - openDirection = UP, anchorDirection = RIGHT => d(1,0) == r(1,0)
	 *
	 * By using a CSS transform, we allow to further position it using
	 * top/bottom CSS properties for the anchor gutter.
	 *
	 * @param {string} openDirection The vertical positioning of the popup
	 * @param {string} anchorDirection The horizontal position of the popup
	 * @param {HTMLElement} referenceEl The reference element
	 */
	function getDetachedContainerStyles(openDirection, anchorDirection, referenceEl) {
	  var referenceRect = referenceEl.getBoundingClientRect();
	  var offsetX = referenceRect.left;
	  var offsetY = referenceRect.top;
	
	  if (openDirection === _constants.OPEN_UP) {
	    offsetY = -(window.innerHeight - referenceRect.bottom);
	  }
	
	  if (anchorDirection === _constants.ANCHOR_RIGHT) {
	    offsetX = -(window.innerWidth - referenceRect.right);
	  }
	
	  return {
	    transform: "translate3d(".concat(Math.round(offsetX), "px, ").concat(Math.round(offsetY), "px, 0)")
	  };
	}

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getResponsiveContainerStyles;
	
	var _constants = __webpack_require__(21);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getResponsiveContainerStyles(anchorDirection, currentOffset, containerEdge, margin) {
	  var windowWidth = typeof window !== 'undefined' ? window.innerWidth : 0;
	  var calculatedOffset = anchorDirection === _constants.ANCHOR_LEFT ? windowWidth - containerEdge : containerEdge;
	  var calculatedMargin = margin || 0;
	  return _defineProperty({}, anchorDirection, Math.min(currentOffset + calculatedOffset - calculatedMargin, 0));
	}

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getVisibleDays;
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _toISOMonthString = _interopRequireDefault(__webpack_require__(292));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getVisibleDays(month, numberOfMonths, enableOutsideDays, withoutTransitionMonths) {
	  if (!_moment["default"].isMoment(month)) return {};
	  var visibleDaysByMonth = {};
	  var currentMonth = withoutTransitionMonths ? month.clone() : month.clone().subtract(1, 'month');
	
	  for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
	    var visibleDays = []; // set utc offset to get correct dates in future (when timezone changes)
	
	    var baseDate = currentMonth.clone();
	    var firstOfMonth = baseDate.clone().startOf('month').hour(12);
	    var lastOfMonth = baseDate.clone().endOf('month').hour(12);
	    var currentDay = firstOfMonth.clone(); // days belonging to the previous month
	
	    if (enableOutsideDays) {
	      for (var j = 0; j < currentDay.weekday(); j += 1) {
	        var prevDay = currentDay.clone().subtract(j + 1, 'day');
	        visibleDays.unshift(prevDay);
	      }
	    }
	
	    while (currentDay < lastOfMonth) {
	      visibleDays.push(currentDay.clone());
	      currentDay.add(1, 'day');
	    }
	
	    if (enableOutsideDays) {
	      // weekday() returns the index of the day of the week according to the locale
	      // this means if the week starts on Monday, weekday() will return 0 for a Monday date, not 1
	      if (currentDay.weekday() !== 0) {
	        // days belonging to the next month
	        for (var k = currentDay.weekday(), count = 0; k < 7; k += 1, count += 1) {
	          var nextDay = currentDay.clone().add(count, 'day');
	          visibleDays.push(nextDay);
	        }
	      }
	    }
	
	    visibleDaysByMonth[(0, _toISOMonthString["default"])(currentMonth)] = visibleDays;
	    currentMonth = currentMonth.clone().add(1, 'month');
	  }
	
	  return visibleDaysByMonth;
	}

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isNextDay;
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _isSameDay = _interopRequireDefault(__webpack_require__(177));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function isNextDay(a, b) {
	  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
	  var nextDay = (0, _moment["default"])(a).add(1, 'day');
	  return (0, _isSameDay["default"])(nextDay, b);
	}

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isSameMonth;
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function isSameMonth(a, b) {
	  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false; // Compare least significant, most likely to change units first
	  // Moment's isSame clones moment inputs and is a tad slow
	
	  return a.month() === b.month() && a.year() === b.year();
	}

/***/ },
/* 877 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(147);
	
	var invariant = __webpack_require__(20);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(180);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactInstrumentation = __webpack_require__(86);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1891);
	var warning = __webpack_require__(25);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 880 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(47);
	
	var LinkedValueUtils = __webpack_require__(443);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(104);
	
	var warning = __webpack_require__(25);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 882 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 883 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(20);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1851);
	
	var containsNode = __webpack_require__(1510);
	var focusNode = __webpack_require__(629);
	var getActiveElement = __webpack_require__(630);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var DOMLazyTree = __webpack_require__(179);
	var DOMProperty = __webpack_require__(180);
	var React = __webpack_require__(184);
	var ReactBrowserEventEmitter = __webpack_require__(293);
	var ReactCurrentOwner = __webpack_require__(118);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactDOMContainerInfo = __webpack_require__(1845);
	var ReactDOMFeatureFlags = __webpack_require__(1847);
	var ReactFeatureFlags = __webpack_require__(883);
	var ReactInstanceMap = __webpack_require__(228);
	var ReactInstrumentation = __webpack_require__(86);
	var ReactMarkupChecksum = __webpack_require__(1861);
	var ReactReconciler = __webpack_require__(181);
	var ReactUpdateQueue = __webpack_require__(446);
	var ReactUpdates = __webpack_require__(104);
	
	var emptyObject = __webpack_require__(398);
	var instantiateReactComponent = __webpack_require__(894);
	var invariant = __webpack_require__(20);
	var setInnerHTML = __webpack_require__(297);
	var shouldUpdateReactComponent = __webpack_require__(452);
	var warning = __webpack_require__(25);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var React = __webpack_require__(184);
	
	var invariant = __webpack_require__(20);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 888 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(20);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 890 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(887);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(67);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(44);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(47);
	
	var ReactCompositeComponent = __webpack_require__(1842);
	var ReactEmptyComponent = __webpack_require__(882);
	var ReactHostComponent = __webpack_require__(884);
	
	var getNextDebugID = __webpack_require__(1973);
	var invariant = __webpack_require__(20);
	var warning = __webpack_require__(25);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 895 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(67);
	var escapeTextContentForBrowser = __webpack_require__(296);
	var setInnerHTML = __webpack_require__(297);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactCurrentOwner = __webpack_require__(118);
	var REACT_ELEMENT_TYPE = __webpack_require__(1857);
	
	var getIteratorFn = __webpack_require__(1888);
	var invariant = __webpack_require__(20);
	var KeyEscapeUtils = __webpack_require__(442);
	var warning = __webpack_require__(25);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1894);
	} else {
	  module.exports = require('./cjs/index.js');
	}


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetState = resetState;
	exports.log = log;
	exports.assertNodeList = assertNodeList;
	exports.setElement = setElement;
	exports.validateElement = validateElement;
	exports.hide = hide;
	exports.show = show;
	exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
	
	var _warning = __webpack_require__(1904);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _safeHTMLElement = __webpack_require__(456);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalElement = null;
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function resetState() {
	  if (globalElement) {
	    if (globalElement.removeAttribute) {
	      globalElement.removeAttribute("aria-hidden");
	    } else if (globalElement.length != null) {
	      globalElement.forEach(function (element) {
	        return element.removeAttribute("aria-hidden");
	      });
	    } else {
	      document.querySelectorAll(globalElement).forEach(function (element) {
	        return element.removeAttribute("aria-hidden");
	      });
	    }
	  }
	  globalElement = null;
	}
	
	/* istanbul ignore next */
	function log() {
	  if (false) {
	    var check = globalElement || {};
	    console.log("ariaAppHider ----------");
	    console.log(check.nodeName, check.className, check.id);
	    console.log("end ariaAppHider ----------");
	  }
	}
	/* eslint-enable no-console */
	
	function assertNodeList(nodeList, selector) {
	  if (!nodeList || !nodeList.length) {
	    throw new Error("react-modal: No elements were found for selector " + selector + ".");
	  }
	}
	
	function setElement(element) {
	  var useElement = element;
	  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
	    var el = document.querySelectorAll(useElement);
	    assertNodeList(el, useElement);
	    useElement = el;
	  }
	  globalElement = useElement || globalElement;
	  return globalElement;
	}
	
	function validateElement(appElement) {
	  var el = appElement || globalElement;
	  if (el) {
	    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
	  } else {
	    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
	
	    return [];
	  }
	}
	
	function hide(appElement) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var el = _step.value;
	
	      el.setAttribute("aria-hidden", "true");
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	}
	
	function show(appElement) {
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var el = _step2.value;
	
	      el.removeAttribute("aria-hidden");
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	}
	
	function documentNotReadyOrSSRTesting() {
	  globalElement = null;
	}

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.log = log;
	exports.resetState = resetState;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Tracks portals that are open and emits events to subscribers
	
	var PortalOpenInstances = function PortalOpenInstances() {
	  var _this = this;
	
	  _classCallCheck(this, PortalOpenInstances);
	
	  this.register = function (openInstance) {
	    if (_this.openInstances.indexOf(openInstance) !== -1) {
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn("React-Modal: Cannot register modal instance that's already open");
	      }
	      return;
	    }
	    _this.openInstances.push(openInstance);
	    _this.emit("register");
	  };
	
	  this.deregister = function (openInstance) {
	    var index = _this.openInstances.indexOf(openInstance);
	    if (index === -1) {
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
	      }
	      return;
	    }
	    _this.openInstances.splice(index, 1);
	    _this.emit("deregister");
	  };
	
	  this.subscribe = function (callback) {
	    _this.subscribers.push(callback);
	  };
	
	  this.emit = function (eventType) {
	    _this.subscribers.forEach(function (subscriber) {
	      return subscriber(eventType,
	      // shallow copy to avoid accidental mutation
	      _this.openInstances.slice());
	    });
	  };
	
	  this.openInstances = [];
	  this.subscribers = [];
	};
	
	var portalOpenInstances = new PortalOpenInstances();
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function log() {
	  console.log("portalOpenInstances ----------");
	  console.log(portalOpenInstances.openInstances.length);
	  portalOpenInstances.openInstances.forEach(function (p) {
	    return console.log(p);
	  });
	  console.log("end portalOpenInstances ----------");
	}
	
	/* istanbul ignore next */
	function resetState() {
	  portalOpenInstances = new PortalOpenInstances();
	}
	/* eslint-enable no-console */
	
	exports.default = portalOpenInstances;

/***/ },
/* 901 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findTabbableDescendants;
	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	var DISPLAY_NONE = "none";
	var DISPLAY_CONTENTS = "contents";
	
	// match the whole word to prevent fuzzy searching
	var tabbableNode = /^(input|select|textarea|button|object|iframe)$/;
	
	function isNotOverflowing(element, style) {
	  return style.getPropertyValue("overflow") !== "visible" ||
	  // if 'overflow: visible' set, check if there is actually any overflow
	  element.scrollWidth <= 0 && element.scrollHeight <= 0;
	}
	
	function hidesContents(element) {
	  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
	
	  // If the node is empty, this is good enough
	  if (zeroSize && !element.innerHTML) return true;
	
	  try {
	    // Otherwise we need to check some styles
	    var style = window.getComputedStyle(element);
	    var displayValue = style.getPropertyValue("display");
	    return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
	  } catch (exception) {
	    // eslint-disable-next-line no-console
	    console.warn("Failed to inspect element style");
	    return false;
	  }
	}
	
	function visible(element) {
	  var parentElement = element;
	  var rootNode = element.getRootNode && element.getRootNode();
	  while (parentElement) {
	    if (parentElement === document.body) break;
	
	    // if we are not hidden yet, skip to checking outside the Web Component
	    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
	
	    if (hidesContents(parentElement)) return false;
	    parentElement = parentElement.parentNode;
	  }
	  return true;
	}
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
	  return res && visible(element);
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute("tabindex");
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
	    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
	  }, []);
	  return descendants.filter(tabbable);
	}
	module.exports = exports["default"];

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(459);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _ownerDocument = __webpack_require__(230);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _getContainer = __webpack_require__(458);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = _react2.default.createClass({
	
	  displayName: 'Portal',
	
	  propTypes: {
	    /**
	     * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	     * appended to it.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func])
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._renderOverlay();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._renderOverlay();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  },
	  _mountOverlayTarget: function _mountOverlayTarget() {
	    if (!this._overlayTarget) {
	      this._overlayTarget = document.createElement('div');
	      this._portalContainerNode = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  _unmountOverlayTarget: function _unmountOverlayTarget() {
	    if (this._overlayTarget) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._overlayTarget = null;
	    }
	    this._portalContainerNode = null;
	  },
	  _renderOverlay: function _renderOverlay() {
	
	    var overlay = !this.props.children ? null : _react2.default.Children.only(this.props.children);
	
	    // Save reference for future access.
	    if (overlay !== null) {
	      this._mountOverlayTarget();
	      this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
	    } else {
	      // Unrender if the component is null for transitions to null
	      this._unrenderOverlay();
	      this._unmountOverlayTarget();
	    }
	  },
	  _unrenderOverlay: function _unrenderOverlay() {
	    if (this._overlayTarget) {
	      _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
	      this._overlayInstance = null;
	    }
	  },
	  render: function render() {
	    return null;
	  },
	  getMountNode: function getMountNode() {
	    return this._overlayTarget;
	  },
	  getOverlayDOMNode: function getOverlayDOMNode() {
	    if (!this.isMounted()) {
	      throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
	    }
	
	    if (this._overlayInstance) {
	      return _reactDom2.default.findDOMNode(this._overlayInstance);
	    }
	
	    return null;
	  }
	});
	
	exports.default = Portal;
	module.exports = exports['default'];

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _contains = __webpack_require__(164);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(905);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ownerDocument = __webpack_require__(230);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var escapeKeyCode = 27;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * The `<RootCloseWrapper/>` component registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 */
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props, context) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, (RootCloseWrapper.__proto__ || Object.getPrototypeOf(RootCloseWrapper)).call(this, props, context));
	
	    _this.handleMouseCapture = function (e) {
	      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
	    };
	
	    _this.handleMouse = function (e) {
	      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.handleKeyUp = function (e) {
	      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.preventMouseRootClose = false;
	    return _this;
	  }
	
	  _createClass(RootCloseWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.disabled) {
	        this.addEventListeners();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!this.props.disabled && prevProps.disabled) {
	        this.addEventListeners();
	      } else if (this.props.disabled && !prevProps.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.props.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'addEventListeners',
	    value: function addEventListeners() {
	      var event = this.props.event;
	
	      var doc = (0, _ownerDocument2.default)(this);
	
	      // Use capture for this listener so it fires before React's listener, to
	      // avoid false positives in the contains() check below if the target DOM
	      // element is removed in the React mouse callback.
	      this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, this.handleMouseCapture, true);
	
	      this.documentMouseListener = (0, _addEventListener2.default)(doc, event, this.handleMouse);
	
	      this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleKeyUp);
	    }
	  }, {
	    key: 'removeEventListeners',
	    value: function removeEventListeners() {
	      if (this.documentMouseCaptureListener) {
	        this.documentMouseCaptureListener.remove();
	      }
	
	      if (this.documentMouseListener) {
	        this.documentMouseListener.remove();
	      }
	
	      if (this.documentKeyupListener) {
	        this.documentKeyupListener.remove();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  /**
	   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
	   */
	  onRootClose: _react2.default.PropTypes.func,
	  /**
	   * Children to render.
	   */
	  children: _react2.default.PropTypes.element,
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
	   */
	  disabled: _react2.default.PropTypes.bool,
	  /**
	   * Choose which document mouse event to bind to.
	   */
	  event: _react2.default.PropTypes.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	
	exports.default = RootCloseWrapper;
	module.exports = exports['default'];

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _on = __webpack_require__(258);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _properties = __webpack_require__(557);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionEndEvent = _properties2.default.end;
	
	var UNMOUNTED = exports.UNMOUNTED = 0;
	var EXITED = exports.EXITED = 1;
	var ENTERING = exports.ENTERING = 2;
	var ENTERED = exports.ENTERED = 3;
	var EXITING = exports.EXITING = 4;
	
	/**
	 * The Transition component lets you define and run css transitions with a simple declarative api.
	 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecycle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).call(this, props, context));
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (props.transitionAppear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  _createClass(Transition, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var status = this.state.status;
	
	
	      if (nextProps.in) {
	        if (status === UNMOUNTED) {
	          this.setState({ status: EXITED });
	        }
	        if (status !== ENTERING && status !== ENTERED) {
	          this.nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          this.nextStatus = EXITING;
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.cancelNextCallback();
	    }
	  }, {
	    key: 'updateStatus',
	    value: function updateStatus() {
	      var _this2 = this;
	
	      if (this.nextStatus !== null) {
	        // nextStatus will always be ENTERING or EXITING.
	        this.cancelNextCallback();
	        var node = _reactDom2.default.findDOMNode(this);
	
	        if (this.nextStatus === ENTERING) {
	          this.props.onEnter(node);
	
	          this.safeSetState({ status: ENTERING }, function () {
	            _this2.props.onEntering(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: ENTERED }, function () {
	                _this2.props.onEntered(node);
	              });
	            });
	          });
	        } else {
	          this.props.onExit(node);
	
	          this.safeSetState({ status: EXITING }, function () {
	            _this2.props.onExiting(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: EXITED }, function () {
	                _this2.props.onExited(node);
	              });
	            });
	          });
	        }
	
	        this.nextStatus = null;
	      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	        this.setState({ status: UNMOUNTED });
	      }
	    }
	  }, {
	    key: 'cancelNextCallback',
	    value: function cancelNextCallback() {
	      if (this.nextCallback !== null) {
	        this.nextCallback.cancel();
	        this.nextCallback = null;
	      }
	    }
	  }, {
	    key: 'safeSetState',
	    value: function safeSetState(nextState, callback) {
	      // This shouldn't be necessary, but there are weird race conditions with
	      // setState callbacks and unmounting in testing, so always make sure that
	      // we can cancel any pending setState callbacks after we unmount.
	      this.setState(nextState, this.setNextCallback(callback));
	    }
	  }, {
	    key: 'setNextCallback',
	    value: function setNextCallback(callback) {
	      var _this3 = this;
	
	      var active = true;
	
	      this.nextCallback = function (event) {
	        if (active) {
	          active = false;
	          _this3.nextCallback = null;
	
	          callback(event);
	        }
	      };
	
	      this.nextCallback.cancel = function () {
	        active = false;
	      };
	
	      return this.nextCallback;
	    }
	  }, {
	    key: 'onTransitionEnd',
	    value: function onTransitionEnd(node, handler) {
	      this.setNextCallback(handler);
	
	      if (node) {
	        (0, _on2.default)(node, transitionEndEvent, this.nextCallback);
	        setTimeout(this.nextCallback, this.props.timeout);
	      } else {
	        setTimeout(this.nextCallback, 0);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var status = this.state.status;
	      if (status === UNMOUNTED) {
	        return null;
	      }
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          childProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	      Object.keys(Transition.propTypes).forEach(function (key) {
	        return delete childProps[key];
	      });
	
	      var transitionClassName = void 0;
	      if (status === EXITED) {
	        transitionClassName = this.props.exitedClassName;
	      } else if (status === ENTERING) {
	        transitionClassName = this.props.enteringClassName;
	      } else if (status === ENTERED) {
	        transitionClassName = this.props.enteredClassName;
	      } else if (status === EXITING) {
	        transitionClassName = this.props.exitingClassName;
	      }
	
	      var child = _react2.default.Children.only(children);
	      return _react2.default.cloneElement(child, _extends({}, childProps, {
	        className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
	      }));
	    }
	  }]);
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.propTypes = {
	  /**
	   * Show the component; triggers the enter or exit animation
	   */
	  in: _react2.default.PropTypes.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _react2.default.PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is not shown
	   */
	  unmountOnExit: _react2.default.PropTypes.bool,
	
	  /**
	   * Run the enter animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2.default.PropTypes.bool,
	
	  /**
	   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
	   * transition indefinately if the browser transitionEnd events are
	   * canceled or interrupted.
	   *
	   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
	   * setting this to the duration of your animation (or a bit above it).
	   */
	  timeout: _react2.default.PropTypes.number,
	
	  /**
	   * CSS class or classes applied when the component is exited
	   */
	  exitedClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is exiting
	   */
	  exitingClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied when the component is entered
	   */
	  enteredClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is entering
	   */
	  enteringClassName: _react2.default.PropTypes.string,
	
	  /**
	   * Callback fired before the "entering" classes are applied
	   */
	  onEnter: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "entering" classes are applied
	   */
	  onEntering: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "enter" classes are applied
	   */
	  onEntered: _react2.default.PropTypes.func,
	  /**
	   * Callback fired before the "exiting" classes are applied
	   */
	  onExit: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exiting" classes are applied
	   */
	  onExiting: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exited" classes are applied
	   */
	  onExited: _react2.default.PropTypes.func
	};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.displayName = 'Transition';
	
	Transition.defaultProps = {
	  in: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  timeout: 5000,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	exports.default = Transition;

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(258);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(370);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(259);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(163);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pdf_link_service = __webpack_require__(1719);
	
	exports.default = _pdf_link_service.PDFLinkService;

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Portal = __webpack_require__(1928);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _LegacyPortal = __webpack_require__(1927);
	
	var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Portal = void 0;
	
	if (_reactDom2.default.createPortal) {
	  Portal = _Portal2.default;
	} else {
	  Portal = _LegacyPortal2.default;
	}
	
	exports.default = Portal;

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PortalWithState = exports.Portal = undefined;
	
	var _PortalCompat = __webpack_require__(908);
	
	var _PortalCompat2 = _interopRequireDefault(_PortalCompat);
	
	var _PortalWithState = __webpack_require__(1929);
	
	var _PortalWithState2 = _interopRequireDefault(_PortalWithState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Portal = _PortalCompat2.default;
	exports.PortalWithState = _PortalWithState2.default;

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	exports["default"] = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  getState: _react.PropTypes.func.isRequired
	});

/***/ },
/* 911 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(115);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(462);
	
	var _ContextUtils = __webpack_require__(461);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string,
	    innerRef: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, (0, _propTypes.shape)({ current: _propTypes.elementType })])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex', 'innerRef']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', _extends({}, props, { ref: innerRef }));
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, ref: innerRef }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 913 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(115);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(128);
	
	var _PatternUtils = __webpack_require__(182);
	
	var _InternalPropTypes = __webpack_require__(231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 915 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(637);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(636);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(1530);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(919);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(183);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(1947);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1944);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(1951);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1948);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1953);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(637);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(636);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var styleInterface = void 0;
	var styleTheme = void 0;
	
	var START_MARK = 'react-with-styles.resolve.start';
	var END_MARK = 'react-with-styles.resolve.end';
	var MEASURE_MARK = '\uD83D\uDC69\u200D\uD83C\uDFA8 [resolve]';
	
	function registerTheme(theme) {
	  styleTheme = theme;
	}
	
	function registerInterface(interfaceToRegister) {
	  styleInterface = interfaceToRegister;
	}
	
	function create(makeFromTheme, createWithDirection) {
	  var styles = createWithDirection(makeFromTheme(styleTheme));
	  return function () {
	    return styles;
	  };
	}
	
	function createLTR(makeFromTheme) {
	  return create(makeFromTheme, styleInterface.createLTR || styleInterface.create);
	}
	
	function createRTL(makeFromTheme) {
	  return create(makeFromTheme, styleInterface.createRTL || styleInterface.create);
	}
	
	function get() {
	  return styleTheme;
	}
	
	function resolve() {
	  if (false) {
	    performance.clearMarks(START_MARK);
	    performance.mark(START_MARK);
	  }
	
	  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
	    styles[_key] = arguments[_key];
	  }
	
	  var result = styleInterface.resolve(styles);
	
	  if (false) {
	    performance.clearMarks(END_MARK);
	    performance.mark(END_MARK);
	
	    performance.measure(MEASURE_MARK, START_MARK, END_MARK);
	    performance.clearMarks(MEASURE_MARK);
	  }
	
	  return result;
	}
	
	function resolveLTR() {
	  for (var _len2 = arguments.length, styles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    styles[_key2] = arguments[_key2];
	  }
	
	  if (styleInterface.resolveLTR) {
	    return styleInterface.resolveLTR(styles);
	  }
	
	  return resolve(styles);
	}
	
	function resolveRTL() {
	  for (var _len3 = arguments.length, styles = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    styles[_key3] = arguments[_key3];
	  }
	
	  if (styleInterface.resolveRTL) {
	    return styleInterface.resolveRTL(styles);
	  }
	
	  return resolve(styles);
	}
	
	function flush() {
	  if (styleInterface.flush) {
	    styleInterface.flush();
	  }
	}
	
	exports['default'] = {
	  registerTheme: registerTheme,
	  registerInterface: registerInterface,
	  create: createLTR,
	  createLTR: createLTR,
	  createRTL: createRTL,
	  get: get,
	  resolve: resolveLTR,
	  resolveLTR: resolveLTR,
	  resolveRTL: resolveRTL,
	  flush: flush
	};

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(232),
	    _assign = __webpack_require__(464);
	
	var ReactNoopUpdateQueue = __webpack_require__(924);
	
	var canDefineProperty = __webpack_require__(925);
	var emptyObject = __webpack_require__(398);
	var invariant = __webpack_require__(20);
	var lowPriorityWarning = __webpack_require__(1974);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(232);
	
	var ReactCurrentOwner = __webpack_require__(118);
	
	var invariant = __webpack_require__(20);
	var warning = __webpack_require__(25);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 923 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(25);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _es6Error = __webpack_require__(1396);
	
	var _es6Error2 = _interopRequireDefault(_es6Error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubmissionError = function (_ExtendableError) {
	  _inherits(SubmissionError, _ExtendableError);
	
	  function SubmissionError(errors) {
	    _classCallCheck(this, SubmissionError);
	
	    var _this = _possibleConstructorReturn(this, (SubmissionError.__proto__ || Object.getPrototypeOf(SubmissionError)).call(this, 'Submit Validation Failed'));
	
	    _this.errors = errors;
	    return _this;
	  }
	
	  return SubmissionError;
	}(_es6Error2.default);
	
	exports.default = SubmissionError;

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateSyncWarnings = exports.updateSyncErrors = exports.untouch = exports.unregisterField = exports.touch = exports.setSubmitSucceeded = exports.setSubmitFailed = exports.submit = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.registerField = exports.initialize = exports.focus = exports.destroy = exports.clearSubmit = exports.change = exports.blur = exports.autofill = exports.arrayUnshift = exports.arraySwap = exports.arraySplice = exports.arrayShift = exports.arrayRemoveAll = exports.arrayRemove = exports.arrayPush = exports.arrayPop = exports.arrayMove = exports.arrayInsert = undefined;
	
	var _actionTypes = __webpack_require__(465);
	
	var arrayInsert = exports.arrayInsert = function arrayInsert(form, field, index, value) {
	  return { type: _actionTypes.ARRAY_INSERT, meta: { form: form, field: field, index: index }, payload: value };
	};
	
	var arrayMove = exports.arrayMove = function arrayMove(form, field, from, to) {
	  return { type: _actionTypes.ARRAY_MOVE, meta: { form: form, field: field, from: from, to: to } };
	};
	
	var arrayPop = exports.arrayPop = function arrayPop(form, field) {
	  return { type: _actionTypes.ARRAY_POP, meta: { form: form, field: field } };
	};
	
	var arrayPush = exports.arrayPush = function arrayPush(form, field, value) {
	  return { type: _actionTypes.ARRAY_PUSH, meta: { form: form, field: field }, payload: value };
	};
	
	var arrayRemove = exports.arrayRemove = function arrayRemove(form, field, index) {
	  return { type: _actionTypes.ARRAY_REMOVE, meta: { form: form, field: field, index: index } };
	};
	
	var arrayRemoveAll = exports.arrayRemoveAll = function arrayRemoveAll(form, field) {
	  return { type: _actionTypes.ARRAY_REMOVE_ALL, meta: { form: form, field: field } };
	};
	
	var arrayShift = exports.arrayShift = function arrayShift(form, field) {
	  return { type: _actionTypes.ARRAY_SHIFT, meta: { form: form, field: field } };
	};
	
	var arraySplice = exports.arraySplice = function arraySplice(form, field, index, removeNum, value) {
	  var action = {
	    type: _actionTypes.ARRAY_SPLICE,
	    meta: { form: form, field: field, index: index, removeNum: removeNum }
	  };
	  if (value !== undefined) {
	    action.payload = value;
	  }
	  return action;
	};
	
	var arraySwap = exports.arraySwap = function arraySwap(form, field, indexA, indexB) {
	  if (indexA === indexB) {
	    throw new Error('Swap indices cannot be equal');
	  }
	  if (indexA < 0 || indexB < 0) {
	    throw new Error('Swap indices cannot be negative');
	  }
	  return { type: _actionTypes.ARRAY_SWAP, meta: { form: form, field: field, indexA: indexA, indexB: indexB } };
	};
	
	var arrayUnshift = exports.arrayUnshift = function arrayUnshift(form, field, value) {
	  return { type: _actionTypes.ARRAY_UNSHIFT, meta: { form: form, field: field }, payload: value };
	};
	
	var autofill = exports.autofill = function autofill(form, field, value) {
	  return { type: _actionTypes.AUTOFILL, meta: { form: form, field: field }, payload: value };
	};
	
	var blur = exports.blur = function blur(form, field, value, touch) {
	  return { type: _actionTypes.BLUR, meta: { form: form, field: field, touch: touch }, payload: value };
	};
	
	var change = exports.change = function change(form, field, value, touch, persistentSubmitErrors) {
	  return { type: _actionTypes.CHANGE, meta: { form: form, field: field, touch: touch, persistentSubmitErrors: persistentSubmitErrors }, payload: value };
	};
	
	var clearSubmit = exports.clearSubmit = function clearSubmit(form) {
	  return { type: _actionTypes.CLEAR_SUBMIT, meta: { form: form } };
	};
	
	var destroy = exports.destroy = function destroy(form) {
	  return { type: _actionTypes.DESTROY, meta: { form: form } };
	};
	
	var focus = exports.focus = function focus(form, field) {
	  return { type: _actionTypes.FOCUS, meta: { form: form, field: field } };
	};
	
	var initialize = exports.initialize = function initialize(form, values, keepDirty) {
	  return { type: _actionTypes.INITIALIZE, meta: { form: form, keepDirty: keepDirty }, payload: values };
	};
	
	var registerField = exports.registerField = function registerField(form, name, type) {
	  return { type: _actionTypes.REGISTER_FIELD, meta: { form: form }, payload: { name: name, type: type } };
	};
	
	var reset = exports.reset = function reset(form) {
	  return { type: _actionTypes.RESET, meta: { form: form } };
	};
	
	var startAsyncValidation = exports.startAsyncValidation = function startAsyncValidation(form, field) {
	  return { type: _actionTypes.START_ASYNC_VALIDATION, meta: { form: form, field: field } };
	};
	
	var startSubmit = exports.startSubmit = function startSubmit(form) {
	  return { type: _actionTypes.START_SUBMIT, meta: { form: form } };
	};
	
	var stopAsyncValidation = exports.stopAsyncValidation = function stopAsyncValidation(form, errors) {
	  var action = {
	    type: _actionTypes.STOP_ASYNC_VALIDATION,
	    meta: { form: form },
	    payload: errors
	  };
	  if (errors && Object.keys(errors).length) {
	    action.error = true;
	  }
	  return action;
	};
	
	var stopSubmit = exports.stopSubmit = function stopSubmit(form, errors) {
	  var action = {
	    type: _actionTypes.STOP_SUBMIT,
	    meta: { form: form },
	    payload: errors
	  };
	  if (errors && Object.keys(errors).length) {
	    action.error = true;
	  }
	  return action;
	};
	
	var submit = exports.submit = function submit(form) {
	  return { type: _actionTypes.SUBMIT, meta: { form: form } };
	};
	
	var setSubmitFailed = exports.setSubmitFailed = function setSubmitFailed(form) {
	  for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    fields[_key - 1] = arguments[_key];
	  }
	
	  return { type: _actionTypes.SET_SUBMIT_FAILED, meta: { form: form, fields: fields }, error: true };
	};
	
	var setSubmitSucceeded = exports.setSubmitSucceeded = function setSubmitSucceeded(form) {
	  for (var _len2 = arguments.length, fields = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    fields[_key2 - 1] = arguments[_key2];
	  }
	
	  return { type: _actionTypes.SET_SUBMIT_SUCCEEDED, meta: { form: form, fields: fields }, error: false };
	};
	
	var touch = exports.touch = function touch(form) {
	  for (var _len3 = arguments.length, fields = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    fields[_key3 - 1] = arguments[_key3];
	  }
	
	  return { type: _actionTypes.TOUCH, meta: { form: form, fields: fields } };
	};
	
	var unregisterField = exports.unregisterField = function unregisterField(form, name) {
	  return { type: _actionTypes.UNREGISTER_FIELD, meta: { form: form }, payload: { name: name } };
	};
	
	var untouch = exports.untouch = function untouch(form) {
	  for (var _len4 = arguments.length, fields = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    fields[_key4 - 1] = arguments[_key4];
	  }
	
	  return { type: _actionTypes.UNTOUCH, meta: { form: form, fields: fields } };
	};
	
	var updateSyncErrors = exports.updateSyncErrors = function updateSyncErrors(form) {
	  var syncErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var error = arguments[2];
	  return { type: _actionTypes.UPDATE_SYNC_ERRORS, meta: { form: form }, payload: { syncErrors: syncErrors, error: error } };
	};
	
	var updateSyncWarnings = exports.updateSyncWarnings = function updateSyncWarnings(form) {
	  var syncWarnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var warning = arguments[2];
	  return { type: _actionTypes.UPDATE_SYNC_WARNINGS, meta: { form: form }, payload: { syncWarnings: syncWarnings, warning: warning } };
	};

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _noop2 = __webpack_require__(1646);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createOnBlur = __webpack_require__(1990);
	
	var _createOnBlur2 = _interopRequireDefault(_createOnBlur);
	
	var _createOnChange = __webpack_require__(1991);
	
	var _createOnChange2 = _interopRequireDefault(_createOnChange);
	
	var _createOnDragStart = __webpack_require__(929);
	
	var _createOnDragStart2 = _interopRequireDefault(_createOnDragStart);
	
	var _createOnDrop = __webpack_require__(1992);
	
	var _createOnDrop2 = _interopRequireDefault(_createOnDrop);
	
	var _createOnFocus = __webpack_require__(1993);
	
	var _createOnFocus2 = _interopRequireDefault(_createOnFocus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var processProps = function processProps(type, props, _value) {
	  var value = props.value;
	
	  if (type === 'checkbox') {
	    return _extends({}, props, {
	      checked: !!value
	    });
	  }
	  if (type === 'radio') {
	    return _extends({}, props, {
	      checked: value === _value,
	      value: _value
	    });
	  }
	  if (type === 'select-multiple') {
	    return _extends({}, props, {
	      value: value || []
	    });
	  }
	  if (type === 'file') {
	    return _extends({}, props, {
	      value: undefined
	    });
	  }
	  return props;
	};
	
	var createFieldProps = function createFieldProps(getIn, name, _ref) {
	  var asyncError = _ref.asyncError,
	      asyncValidating = _ref.asyncValidating,
	      blur = _ref.blur,
	      change = _ref.change,
	      dirty = _ref.dirty,
	      dispatch = _ref.dispatch,
	      focus = _ref.focus,
	      format = _ref.format,
	      normalize = _ref.normalize,
	      parse = _ref.parse,
	      pristine = _ref.pristine,
	      props = _ref.props,
	      state = _ref.state,
	      submitError = _ref.submitError,
	      submitting = _ref.submitting,
	      value = _ref.value,
	      _value = _ref._value,
	      syncError = _ref.syncError,
	      syncWarning = _ref.syncWarning,
	      custom = _objectWithoutProperties(_ref, ['asyncError', 'asyncValidating', 'blur', 'change', 'dirty', 'dispatch', 'focus', 'format', 'normalize', 'parse', 'pristine', 'props', 'state', 'submitError', 'submitting', 'value', '_value', 'syncError', 'syncWarning']);
	
	  var asyncValidate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _noop3.default;
	
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	  var boundParse = parse && function (value) {
	    return parse(value, name);
	  };
	  var boundNormalize = normalize && function (value) {
	    return normalize(name, value);
	  };
	  var boundChange = function boundChange(value) {
	    return dispatch(change(name, value));
	  };
	  var onChange = (0, _createOnChange2.default)(boundChange, {
	    normalize: boundNormalize,
	    parse: boundParse
	  });
	
	  var formatFieldValue = function formatFieldValue(value, format) {
	    if (format === null) {
	      return value;
	    }
	    var defaultFormattedValue = value == null ? '' : value;
	    return format ? format(value, name) : defaultFormattedValue;
	  };
	
	  var formattedFieldValue = formatFieldValue(value, format);
	
	  return {
	    input: processProps(custom.type, {
	      name: name,
	      onBlur: (0, _createOnBlur2.default)(function (value) {
	        return dispatch(blur(name, value));
	      }, {
	        normalize: boundNormalize,
	        parse: boundParse,
	        after: asyncValidate.bind(null, name)
	      }),
	      onChange: onChange,
	      onDragStart: (0, _createOnDragStart2.default)(name, formattedFieldValue),
	      onDrop: (0, _createOnDrop2.default)(name, boundChange),
	      onFocus: (0, _createOnFocus2.default)(name, function () {
	        return dispatch(focus(name));
	      }),
	      value: formattedFieldValue
	    }, _value),
	    meta: _extends({}, state, {
	      active: !!(state && getIn(state, 'active')),
	      asyncValidating: asyncValidating,
	      autofilled: !!(state && getIn(state, 'autofilled')),
	      dirty: dirty,
	      dispatch: dispatch,
	      error: error,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: !!submitting,
	      touched: !!(state && getIn(state, 'touched')),
	      valid: !error,
	      visited: !!(state && getIn(state, 'visited'))
	    }),
	    custom: _extends({}, custom, props)
	  };
	};
	
	exports.default = createFieldProps;

/***/ },
/* 929 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var dataKey = exports.dataKey = 'text';
	var createOnDragStart = function createOnDragStart(name, value) {
	  return function (event) {
	    event.dataTransfer.setData(dataKey, value);
	  };
	};
	
	exports.default = createOnDragStart;

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEvent = __webpack_require__(931);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	  return result;
	};
	
	var getValue = function getValue(event, isReactNative) {
	  if ((0, _isEvent2.default)(event)) {
	    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	      return event.nativeEvent.text;
	    }
	    if (isReactNative && event.nativeEvent !== undefined) {
	      return event.nativeEvent.text;
	    }
	    var _event$target = event.target,
	        type = _event$target.type,
	        value = _event$target.value,
	        checked = _event$target.checked,
	        files = _event$target.files,
	        dataTransfer = event.dataTransfer;
	
	    if (type === 'checkbox') {
	      return checked;
	    }
	    if (type === 'file') {
	      return files || dataTransfer && dataTransfer.files;
	    }
	    if (type === 'select-multiple') {
	      return getSelectedValues(event.target.options);
	    }
	    return value;
	  }
	  return event;
	};
	
	exports.default = getValue;

/***/ },
/* 931 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isEvent = function isEvent(candidate) {
	  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
	};
	
	exports.default = isEvent;

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEvent = __webpack_require__(931);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvent = function silenceEvent(event) {
	  var is = (0, _isEvent2.default)(event);
	  if (is) {
	    event.preventDefault();
	  }
	  return is;
	};
	
	exports.default = silenceEvent;

/***/ },
/* 933 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	
	exports.default = isReactNative;

/***/ },
/* 934 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createIsPristine = function createIsPristine(_ref) {
	  var deepEqual = _ref.deepEqual,
	      empty = _ref.empty,
	      getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      var formState = getFormState(state);
	      var initial = getIn(formState, form + '.initial') || empty;
	      var values = getIn(formState, form + '.values') || initial;
	      return deepEqual(initial, values);
	    };
	  };
	};
	
	exports.default = createIsPristine;

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(282);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getIn = function getIn(state, field) {
	  if (!state) {
	    return state;
	  }
	
	  var path = (0, _toPath3.default)(field);
	  var length = path.length;
	  if (!length) {
	    return undefined;
	  }
	
	  var result = state;
	  for (var i = 0; i < length && !!result; ++i) {
	    result = result[path[i]];
	  }
	
	  return result;
	};
	
	exports.default = getIn;

/***/ },
/* 936 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  var last = funcs[funcs.length - 1];
	  var rest = funcs.slice(0, -1);
	  return function () {
	    return rest.reduceRight(function (composed, f) {
	      return f(composed);
	    }, last.apply(undefined, arguments));
	  };
	}

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(417);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(2048);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 938 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBound = __webpack_require__(84);
	var isRegex = __webpack_require__(1549);
	
	var $exec = callBound('RegExp.prototype.exec');
	var $TypeError = __webpack_require__(22);
	
	/** @type {import('.')} */
	module.exports = function regexTester(regex) {
		if (!isRegex(regex)) {
			throw new $TypeError('`regex` must be a RegExp');
		}
		return function test(s) {
			return $exec(regex, s) !== null;
		};
	};


/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	// A library of seedable RNGs implemented in Javascript.
	//
	// Usage:
	//
	// var seedrandom = require('seedrandom');
	// var random = seedrandom(1); // or any seed.
	// var x = random();       // 0 <= x < 1.  Every bit is random.
	// var x = random.quick(); // 0 <= x < 1.  32 bits of randomness.
	
	// alea, a 53-bit multiply-with-carry generator by Johannes Baagøe.
	// Period: ~2^116
	// Reported to pass all BigCrush tests.
	var alea = __webpack_require__(2021);
	
	// xor128, a pure xor-shift generator by George Marsaglia.
	// Period: 2^128-1.
	// Reported to fail: MatrixRank and LinearComp.
	var xor128 = __webpack_require__(2023);
	
	// xorwow, George Marsaglia's 160-bit xor-shift combined plus weyl.
	// Period: 2^192-2^32
	// Reported to fail: CollisionOver, SimpPoker, and LinearComp.
	var xorwow = __webpack_require__(2026);
	
	// xorshift7, by François Panneton and Pierre L'ecuyer, takes
	// a different approach: it adds robustness by allowing more shifts
	// than Marsaglia's original three.  It is a 7-shift generator
	// with 256 bits, that passes BigCrush with no systmatic failures.
	// Period 2^256-1.
	// No systematic BigCrush failures reported.
	var xorshift7 = __webpack_require__(2025);
	
	// xor4096, by Richard Brent, is a 4096-bit xor-shift with a
	// very long period that also adds a Weyl generator. It also passes
	// BigCrush with no systematic failures.  Its long period may
	// be useful if you have many generators and need to avoid
	// collisions.
	// Period: 2^4128-2^32.
	// No systematic BigCrush failures reported.
	var xor4096 = __webpack_require__(2024);
	
	// Tyche-i, by Samuel Neves and Filipe Araujo, is a bit-shifting random
	// number generator derived from ChaCha, a modern stream cipher.
	// https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf
	// Period: ~2^127
	// No systematic BigCrush failures reported.
	var tychei = __webpack_require__(2022);
	
	// The original ARC4-based prng included in this library.
	// Period: ~2^1600
	var sr = __webpack_require__(2027);
	
	sr.alea = alea;
	sr.xor128 = xor128;
	sr.xorwow = xorwow;
	sr.xorshift7 = xorshift7;
	sr.xor4096 = xor4096;
	sr.tychei = tychei;
	
	module.exports = sr;


/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(468);
	
	/*<replacement>*/
	var util = __webpack_require__(114);
	util.inherits = __webpack_require__(100);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough))
	    return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function(chunk, encoding, cb) {
	  cb(null, chunk);
	};


/***/ },
/* 942 */
[2139, 2035, 2083, 149, 149],
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var RequireObjectCoercible = __webpack_require__(263);
	var ToString = __webpack_require__(564);
	var callBound = __webpack_require__(84);
	var $replace = callBound('String.prototype.replace');
	
	var mvsIsWS = (/^\s$/).test('\u180E');
	/* eslint-disable no-control-regex */
	var leftWhitespace = mvsIsWS
		? /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/
		: /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
	var rightWhitespace = mvsIsWS
		? /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/
		: /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;
	/* eslint-enable no-control-regex */
	
	module.exports = function trim() {
		var S = ToString(RequireObjectCoercible(this));
		return $replace($replace(S, leftWhitespace, ''), rightWhitespace, '');
	};


/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(943);
	
	var zeroWidthSpace = '\u200b';
	var mongolianVowelSeparator = '\u180E';
	
	module.exports = function getPolyfill() {
		if (
			String.prototype.trim
			&& zeroWidthSpace.trim() === zeroWidthSpace
			&& mongolianVowelSeparator.trim() === mongolianVowelSeparator
			&& ('_' + mongolianVowelSeparator).trim() === ('_' + mongolianVowelSeparator)
			&& (mongolianVowelSeparator + '_').trim() === (mongolianVowelSeparator + '_')
		) {
			return String.prototype.trim;
		}
		return implementation;
	};


/***/ },
/* 945 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return null !== obj && 'object' === typeof obj;
	}
	
	module.exports = isObject;


/***/ },
/* 946 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 947 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 948 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 949 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 950 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var punycode = __webpack_require__(2064);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(1732);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a puny coded representation of "domain".
	      // It only converts the part of the domain name that
	      // has non ASCII characters. I.e. it dosent matter if
	      // you call it with a domain that already is in ASCII.
	      var domainArray = this.hostname.split('.');
	      var newOut = [];
	      for (var i = 0; i < domainArray.length; ++i) {
	        var s = domainArray[i];
	        newOut.push(s.match(/[^A-Za-z0-9_-]/) ?
	            'xn--' + punycode.encode(s) : s);
	      }
	      this.hostname = newOut.join('.');
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  Object.keys(this).forEach(function(k) {
	    result[k] = this[k];
	  }, this);
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    Object.keys(relative).forEach(function(k) {
	      if (k !== 'protocol')
	        result[k] = relative[k];
	    });
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      Object.keys(relative).forEach(function(k) {
	        result[k] = relative[k];
	      });
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especialy happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!isNull(result.pathname) || !isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host) && (last === '.' || last === '..') ||
	      last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last == '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especialy happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!isNull(result.pathname) || !isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};
	
	function isString(arg) {
	  return typeof arg === "string";
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isNull(arg) {
	  return arg === null;
	}
	function isNullOrUndefined(arg) {
	  return  arg == null;
	}


/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production","API_URL":"https://api-dev.montemar.com.ar/0.3","PAGE_TITLE":"Calf Pay - Montemar","PUBLIC_URL":"","PAGE":"montemar-card-calf","REACT_APP_PAGE_TITLE":"Calf Pay - Montemar","REACT_APP_PHONE_NUMBER":"2616362912","REACT_APP_API_URL":"https://api-dev.montemar.com.ar/0.3"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(2066);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(2065);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(39)))

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(1722).enable();
	  window.Promise = __webpack_require__(1721);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(2067);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(1667);


/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(956);
	function _inheritsLoose(t, o) {
	  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, setPrototypeOf(t, o);
	}
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 955 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(r, e) {
	  if (null == r) return {};
	  var t = {};
	  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
	    if (-1 !== e.indexOf(n)) continue;
	    t[n] = r[n];
	  }
	  return t;
	}
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 956 */
/***/ function(module, exports) {

	function _setPrototypeOf(t, e) {
	  return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
	    return t.__proto__ = e, t;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 957 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Inserts a value into a sorted array. This method allows duplicate, meaning it
	 * allows inserting duplicate value, in which case, the element will be inserted
	 * at the lowest index of the value.
	 * @param arr The array to modify.
	 * @param element The element to insert.
	 * @param comparator Optional. If no comparator is specified, elements are
	 * compared using array_util.defaultComparator, which is suitable for Strings
	 * and Numbers in ascending arrays. If the array contains multiple instances of
	 * the target value, the left-most instance will be returned. To provide a
	 * comparator, it should take 2 arguments to compare and return a negative,
	 * zero, or a positive number.
	 */
	function binaryInsert(arr, element, comparator) {
	    var index = binarySearch(arr, element, comparator);
	    var insertionPoint = index < 0 ? -(index + 1) : index;
	    arr.splice(insertionPoint, 0, element);
	}
	exports.binaryInsert = binaryInsert;
	/**
	 * Searches the array for the target using binary search, returns the index
	 * of the found element, or position to insert if element not found. If no
	 * comparator is specified, elements are compared using array_
	 * util.defaultComparator, which is suitable for Strings and Numbers in
	 * ascending arrays. If the array contains multiple instances of the target
	 * value, the left-most instance will be returned.
	 * @param arr The array to be searched in.
	 * @param target The target to be searched for.
	 * @param comparator Should take 2 arguments to compare and return a negative,
	 *    zero, or a positive number.
	 * @return Lowest index of the target value if found, otherwise the insertion
	 *    point where the target should be inserted, in the form of
	 *    (-insertionPoint - 1).
	 */
	function binarySearch(arr, target, comparator) {
	    return binarySearch_(arr, target, comparator || defaultComparator);
	}
	exports.binarySearch = binarySearch;
	/**
	 * Compares its two arguments for order.
	 * @param a The first element to be compared.
	 * @param b The second element to be compared.
	 * @return A negative number, zero, or a positive number as the first
	 *     argument is less than, equal to, or greater than the second.
	 */
	function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	}
	function binarySearch_(arr, target, comparator) {
	    var left = 0;
	    var right = arr.length;
	    var middle = 0;
	    var found = false;
	    while (left < right) {
	        middle = left + ((right - left) >>> 1);
	        var compareResult = comparator(target, arr[middle]);
	        if (compareResult > 0) {
	            left = middle + 1;
	        }
	        else {
	            right = middle;
	            // If compareResult is 0, the value is found. We record it is found,
	            // and then keep looking because there may be duplicate.
	            found = !compareResult;
	        }
	    }
	    return found ? left : -left - 1;
	}
	//# sourceMappingURL=array_util.js.map

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var seedrandom = __webpack_require__(940);
	var engine_1 = __webpack_require__(15);
	var environment_1 = __webpack_require__(28);
	var log_1 = __webpack_require__(313);
	var array_ops_util = __webpack_require__(486);
	var axis_util = __webpack_require__(108);
	var broadcast_util = __webpack_require__(57);
	var complex_ops_1 = __webpack_require__(191);
	var concat_util = __webpack_require__(153);
	var erf_util = __webpack_require__(488);
	var gather_nd_util = __webpack_require__(315);
	var ops = __webpack_require__(74);
	var ops_1 = __webpack_require__(74);
	var scatter_nd_util = __webpack_require__(239);
	var selu_util = __webpack_require__(317);
	var slice_util_1 = __webpack_require__(192);
	var tensor_1 = __webpack_require__(75);
	var types_1 = __webpack_require__(193);
	var util = __webpack_require__(10);
	var util_1 = __webpack_require__(10);
	var backend_1 = __webpack_require__(306);
	var backend_util = __webpack_require__(234);
	var complex_util = __webpack_require__(474);
	var non_max_suppression_impl_1 = __webpack_require__(188);
	var split_shared_1 = __webpack_require__(475);
	var tile_impl_1 = __webpack_require__(476);
	var topk_impl_1 = __webpack_require__(477);
	var where_impl_1 = __webpack_require__(310);
	var cpu_util_1 = __webpack_require__(235);
	function mapActivation(backend, x, activation, preluActivationWeights) {
	    if (activation === 'linear') {
	        return backend.linear(x);
	    }
	    else if (activation === 'relu') {
	        return backend.relu(x);
	    }
	    else if (activation === 'elu') {
	        return backend.elu(x);
	    }
	    else if (activation === 'relu6') {
	        return backend.relu6(x);
	    }
	    else if (activation === 'prelu') {
	        return backend.prelu(x, preluActivationWeights);
	    }
	    throw new Error("Activation " + activation + " has not been implemented for the CPU backend.");
	}
	var MathBackendCPU = /** @class */ (function (_super) {
	    __extends(MathBackendCPU, _super);
	    function MathBackendCPU() {
	        var _this = _super.call(this) || this;
	        _this.blockSize = 48;
	        _this.firstUse = true;
	        _this.data = new backend_1.DataStorage(_this, engine_1.ENGINE);
	        return _this;
	    }
	    MathBackendCPU.prototype.write = function (values, shape, dtype) {
	        if (this.firstUse) {
	            this.firstUse = false;
	            if (environment_1.env().get('IS_NODE')) {
	                log_1.warn('\n============================\n' +
	                    'Hi there 👋. Looks like you are running TensorFlow.js in ' +
	                    'Node.js. To speed things up dramatically, install our node ' +
	                    'backend, which binds to TensorFlow C++, by running ' +
	                    'npm i @tensorflow/tfjs-node, ' +
	                    'or npm i @tensorflow/tfjs-node-gpu if you have CUDA. ' +
	                    'Then call require(\'@tensorflow/tfjs-node\'); (-gpu ' +
	                    'suffix for CUDA) at the start of your program. ' +
	                    'Visit https://github.com/tensorflow/tfjs-node for more details.' +
	                    '\n============================');
	            }
	        }
	        var dataId = {};
	        this.data.set(dataId, { values: values, dtype: dtype });
	        return dataId;
	    };
	    MathBackendCPU.prototype.move = function (dataId, values, shape, dtype) {
	        this.data.set(dataId, { values: values, dtype: dtype });
	    };
	    MathBackendCPU.prototype.numDataIds = function () {
	        return this.data.numDataIds();
	    };
	    MathBackendCPU.prototype.read = function (dataId) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                return [2 /*return*/, this.readSync(dataId)];
	            });
	        });
	    };
	    MathBackendCPU.prototype.readSync = function (dataId) {
	        var _a = this.data.get(dataId), dtype = _a.dtype, complexTensors = _a.complexTensors;
	        if (dtype === 'complex64') {
	            var realValues = this.readSync(complexTensors.real.dataId);
	            var imagValues = this.readSync(complexTensors.imag.dataId);
	            return complex_util.mergeRealAndImagArrays(realValues, imagValues);
	        }
	        return this.data.get(dataId).values;
	    };
	    MathBackendCPU.prototype.bufferSync = function (t) {
	        var data = this.readSync(t.dataId);
	        var decodedData = data;
	        if (t.dtype === 'string') {
	            try {
	                // Decode the bytes into string.
	                decodedData = data.map(function (d) { return util.decodeString(d); });
	            }
	            catch (_a) {
	                throw new Error('Failed to decode encoded string bytes into utf-8');
	            }
	        }
	        return ops_1.buffer(t.shape, t.dtype, decodedData);
	    };
	    MathBackendCPU.prototype.makeOutput = function (values, shape, dtype) {
	        var dataId = this.write(values, shape, dtype);
	        return engine_1.ENGINE.makeTensorFromDataId(dataId, shape, dtype, this);
	    };
	    MathBackendCPU.prototype.disposeData = function (dataId) {
	        if (this.data.has(dataId)) {
	            var complexTensors = this.data.get(dataId).complexTensors;
	            if (complexTensors != null) {
	                complexTensors.real.dispose();
	                complexTensors.imag.dispose();
	            }
	            this.data.delete(dataId);
	        }
	    };
	    MathBackendCPU.prototype.time = function (f) {
	        return __awaiter(this, void 0, void 0, function () {
	            var start, kernelMs;
	            return __generator(this, function (_a) {
	                start = util_1.now();
	                f();
	                kernelMs = util_1.now() - start;
	                return [2 /*return*/, { kernelMs: kernelMs }];
	            });
	        });
	    };
	    MathBackendCPU.prototype.memory = function () {
	        return {
	            // Unreliable due to automatic gc. The numbers above are cumulative.
	            unreliable: true,
	            reasons: ['The reported memory is an upper bound. Due to automatic garbage ' +
	                    'collection, the true allocated memory may be less.']
	        };
	    };
	    MathBackendCPU.prototype.complex = function (real, imag) {
	        var result = this.makeOutput(null, real.shape, 'complex64');
	        var resultData = this.data.get(result.dataId);
	        // The backend owns the reference to the underlying real and imaginary
	        // clones. These will explicitly get disposed when the complex tensor is
	        // disposed.
	        resultData.complexTensors = {
	            real: engine_1.ENGINE.keep(real.clone()),
	            imag: engine_1.ENGINE.keep(imag.clone())
	        };
	        return result;
	    };
	    MathBackendCPU.prototype.real = function (input) {
	        var resultData = this.data.get(input.dataId);
	        return resultData.complexTensors.real.clone();
	    };
	    MathBackendCPU.prototype.imag = function (input) {
	        var resultData = this.data.get(input.dataId);
	        return resultData.complexTensors.imag.clone();
	    };
	    MathBackendCPU.prototype.slice = function (x, begin, size) {
	        cpu_util_1.assertNotComplex(x, 'slice');
	        var isContinous = slice_util_1.isSliceContinous(x.shape, begin, size);
	        if (isContinous) {
	            var flatOffset = slice_util_1.computeFlatOffset(begin, x.strides);
	            var length_1 = util.sizeFromShape(size);
	            var vals = this.readSync(x.dataId);
	            return ops_1.tensor(vals.subarray(flatOffset, flatOffset + length_1), size, x.dtype);
	        }
	        var buffer = ops.buffer(size, x.dtype);
	        var xBuf = this.bufferSync(x);
	        for (var i = 0; i < buffer.size; ++i) {
	            var loc = buffer.indexToLoc(i);
	            var xLoc = loc.map(function (idx, j) { return idx + begin[j]; });
	            buffer.values[i] = xBuf.get.apply(xBuf, xLoc);
	        }
	        return buffer.toTensor();
	    };
	    MathBackendCPU.prototype.stridedSlice = function (x, begin, end, strides) {
	        cpu_util_1.assertNotComplex(x, 'stridedSlice');
	        var outShape = slice_util_1.computeOutShape(begin, end, strides);
	        if (outShape.some(function (axis) { return axis === 0; })) {
	            return ops.tensor([], outShape);
	        }
	        var buffer = ops.buffer(outShape, x.dtype);
	        var xBuf = this.bufferSync(x);
	        for (var i = 0; i < buffer.size; i++) {
	            var loc = buffer.indexToLoc(i);
	            var newLoc = new Array(loc.length);
	            for (var j = 0; j < newLoc.length; j++) {
	                newLoc[j] = loc[j] * strides[j] + begin[j];
	            }
	            buffer.set.apply(buffer, [xBuf.get.apply(xBuf, newLoc)].concat(loc));
	        }
	        return buffer.toTensor();
	    };
	    MathBackendCPU.prototype.diag = function (x) {
	        var xVals = this.readSync(x.dataId);
	        var buffer = ops.buffer([x.size, x.size], x.dtype);
	        var vals = buffer.values;
	        for (var i = 0; i < xVals.length; i++) {
	            vals[i * x.size + i] = xVals[i];
	        }
	        return buffer.toTensor();
	    };
	    MathBackendCPU.prototype.unstack = function (x, axis) {
	        var num = x.shape[axis];
	        var outShape = new Array(x.rank - 1);
	        var outIndex = 0;
	        for (var i = 0; i < x.rank; i++) {
	            if (i !== axis) {
	                outShape[outIndex++] = x.shape[i];
	            }
	        }
	        var begin = new Array(x.rank).fill(0);
	        var size = x.shape.slice();
	        size[axis] = 1;
	        var res = new Array(num);
	        for (var i = 0; i < res.length; i++) {
	            begin[axis] = i;
	            res[i] = this.slice(x, begin, size).reshape(outShape);
	        }
	        return res;
	    };
	    MathBackendCPU.prototype.reverse = function (x, axis) {
	        cpu_util_1.assertNotComplex(x, 'reverse');
	        var buffer = ops.buffer(x.shape, x.dtype);
	        var xBuf = this.bufferSync(x);
	        var _loop_1 = function (i) {
	            var outLoc = buffer.indexToLoc(i);
	            var inLoc = outLoc.slice();
	            axis.forEach(function (ax) { return inLoc[ax] = x.shape[ax] - 1 - inLoc[ax]; });
	            buffer.set.apply(buffer, [xBuf.get.apply(xBuf, inLoc)].concat(outLoc));
	        };
	        for (var i = 0; i < buffer.size; i++) {
	            _loop_1(i);
	        }
	        return buffer.toTensor();
	    };
	    MathBackendCPU.prototype.concat = function (tensors, axis) {
	        var _this = this;
	        if (tensors[0].dtype === 'complex64') {
	            var reals = tensors.map(function (t) { return complex_ops_1.real(t); });
	            var imags = tensors.map(function (t) { return complex_ops_1.imag(t); });
	            return complex_ops_1.complex(this.concat(reals, axis), this.concat(imags, axis));
	        }
	        var tensors2D = tensors.map(function (t) {
	            var innerSize = util.sizeFromShape(t.shape.slice(axis));
	            return t.as2D(-1, innerSize);
	        });
	        var outShape = concat_util.computeOutShape(tensors2D.map(function (t) { return t.shape; }), 1 /* axis */);
	        var values = ops.buffer(outShape, tensors[0].dtype)
	            .values;
	        if (tensors2D[0].shape[0] === 1) {
	            // Use built-in TypedArray.set() method for speed.
	            var offset_1 = 0;
	            tensors2D.forEach(function (t) {
	                values.set(_this.readSync(t.dataId), offset_1);
	                offset_1 += t.size;
	            });
	        }
	        else {
	            var colOffset_1 = 0;
	            tensors2D.forEach(function (t) {
	                var tVals = _this.readSync(t.dataId);
	                var tIdx = 0;
	                for (var row = 0; row < t.shape[0]; ++row) {
	                    var resIdx = row * outShape[1] + colOffset_1;
	                    for (var col = 0; col < t.shape[1]; ++col) {
	                        values[resIdx + col] = tVals[tIdx++];
	                    }
	                }
	                colOffset_1 += t.shape[1];
	            });
	        }
	        var finalOutShape = concat_util.computeOutShape(tensors.map(function (t) { return t.shape; }), axis);
	        return ops_1.tensor(values, finalOutShape, tensors[0].dtype);
	    };
	    MathBackendCPU.prototype.neg = function (x) {
	        cpu_util_1.assertNotComplex(x, 'neg');
	        return this.multiply(ops.scalar(-1), x);
	    };
	    MathBackendCPU.prototype.add = function (a, b) {
	        if (a.dtype === 'complex64' || b.dtype === 'complex64') {
	            return this.broadcastedBinaryComplexOp(a.cast('complex64'), b.cast('complex64'), function (aReal, aImag, bReal, bImag) {
	                return { real: aReal + bReal, imag: aImag + bImag };
	            });
	        }
	        return this.broadcastedBinaryOp(a, b, types_1.upcastType(a.dtype, b.dtype), function (aValue, bValue) { return aValue + bValue; });
	    };
	    MathBackendCPU.prototype.addN = function (tensors) {
	        var _this = this;
	        cpu_util_1.assertNotComplex(tensors, 'addN');
	        var vals = tensors.map(function (t) { return _this.readSync(t.dataId); });
	        var result = ops.buffer(tensors[0].shape, tensors[0].dtype);
	        var resultVals = result.values;
	        for (var i = 0; i < tensors.length; i++) {
	            var currVals = vals[i];
	            for (var j = 0; j < resultVals.length; j++) {
	                resultVals[j] += currVals[j];
	            }
	        }
	        return result.toTensor();
	    };
	    MathBackendCPU.prototype.softmax = function (logits, dim) {
	        var axes = util.parseAxisParam([dim], logits.shape);
	        var maxLogit = this.max(logits, axes);
	        var expandedShape = axis_util.expandShapeToKeepDim(maxLogit.shape, axes);
	        var a = this.subtract(logits, maxLogit.reshape(expandedShape));
	        var b = this.exp(a);
	        var sumExp = this.sum(b, axes).reshape(expandedShape);
	        return this.realDivide(b, sumExp);
	    };
	    MathBackendCPU.prototype.subtract = function (a, b) {
	        if (a.dtype === 'complex64' || b.dtype === 'complex64') {
	            return this.broadcastedBinaryComplexOp(a.cast('complex64'), b.cast('complex64'), function (aReal, aImag, bReal, bImag) {
	                return { real: aReal - bReal, imag: aImag - bImag };
	            });
	        }
	        return this.broadcastedBinaryOp(a, b, types_1.upcastType(a.dtype, b.dtype), function (aValue, bValue) { return aValue - bValue; });
	    };
	    MathBackendCPU.prototype.pow = function (a, b) {
	        cpu_util_1.assertNotComplex([a, b], 'pow');
	        return this.broadcastedBinaryOp(a, b, a.dtype, function (aValue, bValue) { return Math.pow(aValue, bValue); });
	    };
	    MathBackendCPU.prototype.batchMatMul = function (a, b, transposeA, transposeB) {
	        cpu_util_1.assertNotComplex([a, b], 'matMul');
	        var sharedDim = transposeA ? a.shape[1] : a.shape[2];
	        var leftDim = transposeA ? a.shape[2] : a.shape[1];
	        var rightDim = transposeB ? b.shape[1] : b.shape[2];
	        var batchDim = a.shape[0];
	        var aValues = this.readSync(a.dataId);
	        var bValues = this.readSync(b.dataId);
	        var _a = transposeA ?
	            [a.strides[0], 1, a.strides[1]] :
	            [a.strides[0], a.strides[1], 1], aBatch = _a[0], aOuterStep = _a[1], aInnerStep = _a[2];
	        var _b = transposeB ?
	            [1, b.strides[1], b.strides[0]] :
	            [b.strides[1], 1, b.strides[0]], bInnerStep = _b[0], bOuterStep = _b[1], bBatch = _b[2];
	        var size = leftDim * rightDim;
	        var result = ops_1.buffer([batchDim, leftDim, rightDim], a.dtype);
	        var resVals = result.values;
	        var blockSize = this.blockSize;
	        for (var b_1 = 0; b_1 < batchDim; b_1++) {
	            for (var i0 = 0; i0 < leftDim; i0 += blockSize) {
	                for (var j0 = 0; j0 < rightDim; j0 += blockSize) {
	                    for (var k0 = 0; k0 < sharedDim; k0 += blockSize) {
	                        // for when blockSize doesn't evenly divide the input
	                        var iBlock = Math.min(i0 + blockSize, leftDim);
	                        var jBlock = Math.min(j0 + blockSize, rightDim);
	                        var kBlock = Math.min(k0 + blockSize, sharedDim);
	                        for (var i = i0; i < iBlock; i++) {
	                            for (var j = j0; j < jBlock; j++) {
	                                var sum = 0.0;
	                                for (var k = k0; k < kBlock; k++) {
	                                    sum += aValues[b_1 * aBatch + i * aOuterStep + k * aInnerStep] *
	                                        bValues[k * bInnerStep + j * bOuterStep + b_1 * bBatch];
	                                }
	                                resVals[b_1 * size + (i * rightDim + j)] += sum;
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        return result.toTensor();
	    };
	    MathBackendCPU.prototype.fusedBatchMatMul = function (_a) {
	        var a = _a.a, b = _a.b, transposeA = _a.transposeA, transposeB = _a.transposeB, bias = _a.bias, activation = _a.activation, preluActivationWeights = _a.preluActivationWeights;
	        var result = this.batchMatMul(a, b, transposeA, transposeB);
	        if (bias) {
	            result = this.add(result, bias);
	        }
	        if (activation) {
	            result =
	                mapActivation(this, result, activation, preluActivationWeights);
	        }
	        return result;
	    };
	    MathBackendCPU.prototype.multiply = function (a, b) {
	        if (a.dtype === 'complex64' || b.dtype === 'complex64') {
	            return this.broadcastedBinaryComplexOp(a.cast('complex64'), b.cast('complex64'), function (aReal, aImag, bReal, bImag) {
	                return {
	                    real: aReal * bReal - aImag * bImag,
	                    imag: aReal * bImag + aImag * bReal
	                };
	            });
	        }
	        return this.broadcastedBinaryOp(a, b, types_1.upcastType(a.dtype, b.dtype), function (aValue, bValue) { return aValue * bValue; });
	    };
	    MathBackendCPU.prototype.realDivide = function (a, b) {
	        cpu_util_1.assertNotComplex([a, b], 'realDivide');
	        var op = function (a, b) { return a / b; };
	        var outputDtype = 'float32';
	        return this.broadcastedBinaryOp(a, b, outputDtype, op);
	    };
	    MathBackendCPU.prototype.floorDiv = function (a, b) {
	        cpu_util_1.assertNotComplex([a, b], 'floorDiv');
	        var op = function (a, b) { return Math.floor(a / b); };
	        var outputDtype = 'int32';
	        return this.broadcastedBinaryOp(a, b, outputDtype, op);
	    };
	    MathBackendCPU.prototype.sum = function (x, axes) {
	        cpu_util_1.assertNotComplex(x, 'sum');
	        axis_util.assertAxesAreInnerMostDims('sum', axes, x.rank);
	        var _a = axis_util.computeOutAndReduceShapes(x.shape, axes), outShape = _a[0], reduceShape = _a[1];
	        var resultDtype = types_1.upcastType(x.dtype, 'int32');
	        var result = ops.zeros(outShape, resultDtype);
	        var reduceSize = util.sizeFromShape(reduceShape);
	        var vals = this.readSync(result.dataId);
	        var aVals = this.readSync(x.dataId);
	        for (var i = 0; i < vals.length; ++i) {
	            var offset = i * reduceSize;
	            var sum = 0;
	            for (var j = 0; j < reduceSize; ++j) {
	                sum += aVals[offset + j];
	            }
	            vals[i] = sum;
	        }
	        return result;
	    };
	    MathBackendCPU.prototype.prod = function (x, axes) {
	        cpu_util_1.assertNotComplex(x, 'sum');
	        var _a = axis_util.computeOutAndReduceShapes(x.shape, axes), outShape = _a[0], reduceShape = _a[1];
	        var resultDtype = types_1.upcastType(x.dtype, 'int32');
	        var result = ops.zeros(outShape, resultDtype);
	        var reduceSize = util.sizeFromShape(reduceShape);
	        var vals = this.readSync(result.dataId);
	        var aVals = this.readSync(x.dataId);
	        for (var i = 0; i < vals.length; ++i) {
	            var offset = i * reduceSize;
	            var prod = 1;
	            for (var j = 0; j < reduceSize; ++j) {
	                prod *= aVals[offset + j];
	            }
	            vals[i] = prod;
	        }
	        return result;
	    };
	    MathBackendCPU.prototype.unsortedSegmentSum = function (x, segmentIds, numSegments) {
	        cpu_util_1.assertNotComplex(x, 'unsortedSegmentSum');
	        var res = [];
	        // Reshape the segment id's so that they can be broadcast with
	        // x. The new shape should be [segmentIds.shape, 1, ..., 1]
	        var numIters = x.rank - segmentIds.rank;
	        for (var i = 0; i < numIters; ++i) {
	            segmentIds = segmentIds.expandDims(i + 1);
	        }
	        for (var i = 0; i < numSegments; ++i) {
	            var segmentId = ops.scalar(i, 'int32');
	            var mask = ops.equal(segmentId, segmentIds).asType('float32');
	            var sum = mask.mul(x).sum(0);
	            res.push(sum);
	        }
	        return ops.stack(res);
	    };
	    MathBackendCPU.prototype.argMin = function (x, axis) {
	        cpu_util_1.assertNotComplex(x, 'argMin');
	        var axes = [axis];
	        axis_util.assertAxesAreInnerMostDims('argMin', axes, x.rank);
	        var _a = axis_util.computeOutAndReduceShapes(x.shape, axes), outShape = _a[0], reduceShape = _a[1];
	        var result = ops.zeros(outShape, 'int32');
	        var reduceSize = util.sizeFromShape(reduceShape);
	        var vals = this.readSync(result.dataId);
	        var aVals = this.readSync(x.dataId);
	        for (var i = 0; i < vals.length; ++i) {
	            var offset = i * reduceSize;
	            var min = aVals[offset];
	            var minIndex = 0;
	            for (var j = 0; j < reduceSize; ++j) {
	                var value = aVals[offset + j];
	                if (value < min) {
	                    min = value;
	                    minIndex = j;
	                }
	            }
	            vals[i] = minIndex;
	        }
	        return result;
	    };
	    MathBackendCPU.prototype.argMax = function (x, axis) {
	        cpu_util_1.assertNotComplex(x, 'argMax');
	        var axes = [axis];
	        axis_util.assertAxesAreInnerMostDims('argMax', axes, x.rank);
	        var _a = axis_util.computeOutAndReduceShapes(x.shape, axes), outShape = _a[0], reduceShape = _a[1];
	        var result = ops.zeros(outShape, 'int32');
	        var reduceSize = util.sizeFromShape(reduceShape);
	        var vals = this.readSync(result.dataId);
	        var aVals = this.readSync(x.dataId);
	        for (var i = 0; i < vals.length; ++i) {
	            var offset = i * reduceSize;
	            var max = aVals[offset];
	            var maxIndex = 0;
	            for (var j = 0; j < reduceSize; ++j) {
	                var value = aVals[offset + j];
	                if (value > max) {
	                    max = value;
	                    maxIndex = j;
	                }
	            }
	            vals[i] = maxIndex;
	        }
	        return result;
	    };
	    MathBackendCPU.prototype.cumsum = function (x, axis, exclusive, reverse) {
	        cpu_util_1.assertNotComplex(x, 'cumsum');
	        if (axis !== x.rank - 1) {
	            throw new Error("backend.cumsum in CPU expects an inner-most axis=" + (x.rank - 1) + " " +
	                ("but got axis=" + axis));
	        }
	        var resultDtype = types_1.upcastType(x.dtype, 'int32');
	        var result = ops.zeros(x.shape, resultDtype);
	        var vals = this.readSync(result.dataId);
	        var aVals = this.readSync(x.dataId);
	        var finalDim = x.shape[x.rank - 1];
	        var indexAdjuster = reverse ?
	            function (i, j) { return i + finalDim - j - 1; } :
	            function (i, j) { return i + j; };
	        for (var i = 0; i < aVals.length; i += finalDim) {
	            for (var j = 0; j < finalDim; j++) {
	                var idx = indexAdjuster(i, j);
	                if (j === 0) {
	                    vals[idx] = exclusive ? 0 : aVals[idx];
	                }
	                else {
	                    var prevIdx = indexAdjuster(i, j - 1);
	                    vals[idx] = exclusive ? aVals[prevIdx] + vals[prevIdx] :
	                        aVals[idx] + vals[prevIdx];
	                }
	            }
	        }
	        return result;
	    };
	    MathBackendCPU.prototype.equal = function (a, b) {
	        cpu_util_1.assertNotComplex([a, b], 'equal');
	        return this.broadcastedBinaryOp(a, b, 'bool', function (aVal, bVal) {
	            return (aVal === bVal) ? 1 : 0;
	        });
	    };
	    MathBackendCPU.prototype.notEqual = function (a, b) {
	        cpu_util_1.assertNotComplex([a, b], 'notEqual');
	        return this.broadcastedBinaryOp(a, b, 'bool', function (aVal, bVal) {
	            return (aVal !== bVal) ? 1 : 0;
	        });
	    };
	    MathBackendCPU.prototype.less = function (a, b) {
	        cpu_util_1.assertNotComplex([a, b], 'less');
	        return this.broadcastedBinaryOp(a, b, 'bool', function (aVal, bVal) {
	            return (aVal < bVal) ? 1 : 0;
	        });
	    };
	    MathBackendCPU.prototype.lessEqual = function (a, b) {
	        cpu_util_1.assertNotComplex([a, b], 'lessEqual');
	        return this.broadcastedBinaryOp(a, b, 'bool', function (aVal, bVal) {
	            return (aVal <= bVal) ? 1 : 0;
	        });
	    };
	    MathBackendCPU.prototype.greater = function (a, b) {
	        cpu_util_1.assertNotComplex([a, b], 'greater');
	        return this.broadcastedBinaryOp(a, b, 'bool', function (aVal, bVal) {
	            return (aVal > bVal) ? 1 : 0;
	        });
	    };
	    MathBackendCPU.prototype.greaterEqual = function (a, b) {
	        cpu_util_1.assertNotComplex([a, b], 'greaterEqual');
	        return this.broadcastedBinaryOp(a, b, 'bool', function (aVal, bVal) {
	            return (aVal >= bVal) ? 1 : 0;
	        });
	    };
	    MathBackendCPU.prototype.logicalNot = function (x) {
	        cpu_util_1.assertNotComplex(x, 'logicalNot');
	        var values = this.readSync(x.dataId);
	        var newValues = new Uint8Array(values.length);
	        for (var i = 0; i < values.length; ++i) {
	            newValues[i] = values[i] ? 0 : 1;
	        }
	        return this.makeOutput(newValues, x.shape, 'bool');
	    };
	    MathBackendCPU.prototype.logicalAnd = function (a, b) {
	        cpu_util_1.assertNotComplex([a, b], 'logicalAnd');
	        return this.broadcastedBinaryOp(a, b, 'bool', function (aVal, bVal) {
	            return aVal && bVal;
	        });
	    };
	    MathBackendCPU.prototype.logicalOr = function (a, b) {
	        cpu_util_1.assertNotComplex([a, b], 'logicalOr');
	        return this.broadcastedBinaryOp(a, b, 'bool', function (aVal, bVal) {
	            return aVal || bVal;
	        });
	    };
	    MathBackendCPU.prototype.select = function (condition, a, b) {
	        cpu_util_1.assertNotComplex([condition, a, b], 'select');
	        var values = this.readSync(condition.dataId);
	        var aValues = this.readSync(a.dataId);
	        var bValues = this.readSync(b.dataId);
	        var result = ops.zeros(a.shape, types_1.upcastType(a.dtype, b.dtype));
	        var newValues = this.readSync(result.dataId);
	        var index = 0;
	        var offset = condition.rank === 0 || condition.rank > 1 || a.rank === 1 ?
	            1 :
	            util.sizeFromShape(a.shape.slice(1));
	        for (var i = 0; i < values.length; i++) {
	            for (var j = 0; j < offset; j++) {
	                if (values[i] === 1) {
	                    newValues[index++] = aValues[i];
	                }
	                else {
	                    newValues[index++] = bValues[i];
	                }
	            }
	        }
	        return result;
	    };
	    MathBackendCPU.prototype.where = function (condition) {
	        cpu_util_1.assertNotComplex([condition], 'where');
	        var condVals = this.readSync(condition.dataId);
	        return where_impl_1.whereImpl(condition.shape, condVals);
	    };
	    MathBackendCPU.prototype.topk = function (x, k, sorted) {
	        cpu_util_1.assertNotComplex(x, 'topk');
	        var xVals = this.readSync(x.dataId);
	        return topk_impl_1.topkImpl(xVals, x.shape, x.dtype, k, sorted);
	    };
	    MathBackendCPU.prototype.min = function (x, axes) {
	        cpu_util_1.assertNotComplex(x, 'min');
	        axis_util.assertAxesAreInnerMostDims('min', axes, x.rank);
	        var _a = axis_util.computeOutAndReduceShapes(x.shape, axes), outShape = _a[0], reduceShape = _a[1];
	        var result = ops.zeros(outShape, x.dtype);
	        var reduceSize = util.sizeFromShape(reduceShape);
	        var vals = this.readSync(result.dataId);
	        var aVals = this.readSync(x.dataId);
	        for (var i = 0; i < vals.length; ++i) {
	            var offset = i * reduceSize;
	            var min = aVals[offset];
	            for (var j = 0; j < reduceSize; ++j) {
	                var value = aVals[offset + j];
	                if (value < min) {
	                    min = value;
	                }
	            }
	            vals[i] = min;
	        }
	        return result;
	    };
	    MathBackendCPU.prototype.minimum = function (a, b) {
	        cpu_util_1.assertNotComplex([a, b], 'minimum');
	        return this.broadcastedBinaryOp(a, b, a.dtype, function (aVal, bVal) { return Math.min(aVal, bVal); });
	    };
	    MathBackendCPU.prototype.mod = function (a, b) {
	        cpu_util_1.assertNotComplex([a, b], 'mod');
	        return this.broadcastedBinaryOp(a, b, a.dtype, function (aVal, bVal) {
	            var rem = aVal % bVal;
	            if ((aVal < 0 && bVal < 0) || (aVal >= 0 && bVal >= 0)) {
	                return rem;
	            }
	            else {
	                return (rem + bVal) % bVal;
	            }
	        });
	    };
	    MathBackendCPU.prototype.max = function (x, axes) {
	        cpu_util_1.assertNotComplex(x, 'max');
	        axis_util.assertAxesAreInnerMostDims('max', axes, x.rank);
	        var _a = axis_util.computeOutAndReduceShapes(x.shape, axes), outShape = _a[0], reduceShape = _a[1];
	        var result = ops.zeros(outShape, x.dtype);
	        var reduceSize = util.sizeFromShape(reduceShape);
	        var vals = this.readSync(result.dataId);
	        var aVals = this.readSync(x.dataId);
	        for (var i = 0; i < vals.length; ++i) {
	            var offset = i * reduceSize;
	            var max = aVals[offset];
	            for (var j = 0; j < reduceSize; ++j) {
	                var value = aVals[offset + j];
	                if (value > max) {
	                    max = value;
	                }
	            }
	            vals[i] = max;
	        }
	        return result;
	    };
	    MathBackendCPU.prototype.maximum = function (a, b) {
	        cpu_util_1.assertNotComplex([a, b], 'maximum');
	        return this.broadcastedBinaryOp(a, b, a.dtype, function (aVal, bVal) { return Math.max(aVal, bVal); });
	    };
	    MathBackendCPU.prototype.all = function (x, axes) {
	        cpu_util_1.assertNotComplex(x, 'all');
	        axis_util.assertAxesAreInnerMostDims('all', axes, x.rank);
	        var _a = axis_util.computeOutAndReduceShapes(x.shape, axes), outShape = _a[0], reduceShape = _a[1];
	        var result = ops.zeros(outShape, x.dtype);
	        var reduceSize = util.sizeFromShape(reduceShape);
	        var vals = this.readSync(result.dataId);
	        var aVals = this.readSync(x.dataId);
	        for (var i = 0; i < vals.length; ++i) {
	            var offset = i * reduceSize;
	            var all = aVals[offset];
	            for (var j = 0; j < reduceSize; ++j) {
	                var value = aVals[offset + j];
	                all = all && value;
	            }
	            vals[i] = all;
	        }
	        return result;
	    };
	    MathBackendCPU.prototype.any = function (x, axes) {
	        cpu_util_1.assertNotComplex(x, 'any');
	        axis_util.assertAxesAreInnerMostDims('any', axes, x.rank);
	        var _a = axis_util.computeOutAndReduceShapes(x.shape, axes), outShape = _a[0], reduceShape = _a[1];
	        var result = ops.zeros(outShape, x.dtype);
	        var reduceSize = util.sizeFromShape(reduceShape);
	        var vals = this.readSync(result.dataId);
	        var aVals = this.readSync(x.dataId);
	        for (var i = 0; i < vals.length; ++i) {
	            var offset = i * reduceSize;
	            var anyVal = aVals[offset];
	            for (var j = 0; j < reduceSize; ++j) {
	                var value = aVals[offset + j];
	                anyVal = anyVal || value;
	            }
	            vals[i] = anyVal;
	        }
	        return result;
	    };
	    MathBackendCPU.prototype.squaredDifference = function (a, b) {
	        cpu_util_1.assertNotComplex([a, b], 'squaredDifference');
	        return this.broadcastedBinaryOp(a, b, a.dtype, function (aVal, bVal) {
	            var diff = aVal - bVal;
	            return diff * diff;
	        });
	    };
	    MathBackendCPU.prototype.ceil = function (x) {
	        cpu_util_1.assertNotComplex(x, 'ceil');
	        var values = this.readSync(x.dataId);
	        var newValues = new Float32Array(values.length);
	        for (var i = 0; i < values.length; ++i) {
	            newValues[i] = Math.ceil(values[i]);
	        }
	        return this.makeOutput(newValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.floor = function (x) {
	        cpu_util_1.assertNotComplex(x, 'floor');
	        var values = this.readSync(x.dataId);
	        var newValues = new Float32Array(values.length);
	        for (var i = 0; i < values.length; ++i) {
	            newValues[i] = Math.floor(values[i]);
	        }
	        return this.makeOutput(newValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.sign = function (x) {
	        cpu_util_1.assertNotComplex(x, 'x');
	        var values = this.readSync(x.dataId);
	        var newValues = new Float32Array(values.length);
	        for (var i = 0; i < values.length; ++i) {
	            if (values[i] < 0) {
	                newValues[i] = -1;
	            }
	            else if (values[i] > 0) {
	                newValues[i] = 1;
	            }
	            else {
	                newValues[i] = 0;
	            }
	        }
	        return this.makeOutput(newValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.isNaN = function (x) {
	        cpu_util_1.assertNotComplex(x, 'x');
	        var values = this.readSync(x.dataId);
	        var newValues = new Uint8Array(values.length);
	        for (var i = 0; i < values.length; ++i) {
	            if (Number.isNaN(values[i])) {
	                newValues[i] = 1;
	            }
	        }
	        return this.makeOutput(newValues, x.shape, 'bool');
	    };
	    MathBackendCPU.prototype.isInf = function (x) {
	        cpu_util_1.assertNotComplex(x, 'x');
	        var values = this.readSync(x.dataId);
	        var newValues = new Uint8Array(values.length);
	        for (var i = 0; i < values.length; ++i) {
	            if (Math.abs(values[i]) === Infinity) {
	                newValues[i] = 1;
	            }
	        }
	        return this.makeOutput(newValues, x.shape, 'bool');
	    };
	    MathBackendCPU.prototype.isFinite = function (x) {
	        cpu_util_1.assertNotComplex(x, 'x');
	        var values = this.readSync(x.dataId);
	        var newValues = new Uint8Array(values.length);
	        for (var i = 0; i < values.length; ++i) {
	            if (Number.isFinite(values[i])) {
	                newValues[i] = 1;
	            }
	        }
	        return this.makeOutput(newValues, x.shape, 'bool');
	    };
	    MathBackendCPU.prototype.round = function (x) {
	        cpu_util_1.assertNotComplex(x, 'round');
	        var values = this.readSync(x.dataId);
	        var newValues = new Float32Array(values.length);
	        for (var i = 0; i < values.length; ++i) {
	            // The algorithm is based on banker's rounding.
	            var base = Math.floor(values[i]);
	            if (values[i] - base < 0.5) {
	                newValues[i] = Math.floor(values[i]);
	            }
	            else if (values[i] - base > 0.5) {
	                newValues[i] = Math.ceil(values[i]);
	            }
	            else {
	                if (base % 2.0 === 0.0) {
	                    newValues[i] = base;
	                }
	                else {
	                    newValues[i] = base + 1.0;
	                }
	            }
	        }
	        return this.makeOutput(newValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.exp = function (x) {
	        cpu_util_1.assertNotComplex(x, 'exp');
	        var values = this.readSync(x.dataId);
	        var newValues = new Float32Array(values.length);
	        for (var i = 0; i < values.length; ++i) {
	            newValues[i] = Math.exp(values[i]);
	        }
	        return this.makeOutput(newValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.expm1 = function (x) {
	        cpu_util_1.assertNotComplex(x, 'expm1');
	        var values = this.readSync(x.dataId);
	        var newValues = new Float32Array(values.length);
	        for (var i = 0; i < values.length; ++i) {
	            newValues[i] = Math.expm1(values[i]);
	        }
	        return this.makeOutput(newValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.log = function (x) {
	        cpu_util_1.assertNotComplex(x, 'log');
	        var values = this.readSync(x.dataId);
	        var newValues = new Float32Array(values.length);
	        for (var i = 0; i < values.length; ++i) {
	            var value = values[i];
	            newValues[i] = Math.log(value);
	        }
	        return this.makeOutput(newValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.log1p = function (x) {
	        cpu_util_1.assertNotComplex(x, 'log1p');
	        var values = this.readSync(x.dataId);
	        var newValues = new Float32Array(values.length);
	        for (var i = 0; i < values.length; ++i) {
	            var value = values[i];
	            newValues[i] = Math.log1p(value);
	        }
	        return this.makeOutput(newValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.sqrt = function (x) {
	        cpu_util_1.assertNotComplex(x, 'sqrt');
	        var values = this.readSync(x.dataId);
	        var newValues = new Float32Array(values.length);
	        for (var i = 0; i < values.length; ++i) {
	            var value = values[i];
	            newValues[i] = Math.sqrt(value);
	        }
	        return this.makeOutput(newValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.rsqrt = function (x) {
	        cpu_util_1.assertNotComplex(x, 'rsqrt');
	        var values = this.readSync(x.dataId);
	        var newValues = new Float32Array(values.length);
	        for (var i = 0; i < values.length; ++i) {
	            var value = values[i];
	            newValues[i] = 1 / Math.sqrt(value);
	        }
	        return this.makeOutput(newValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.reciprocal = function (x) {
	        cpu_util_1.assertNotComplex(x, 'reciprocal');
	        var values = this.readSync(x.dataId);
	        var newValues = new Float32Array(values.length);
	        for (var i = 0; i < values.length; ++i) {
	            newValues[i] = 1 / values[i];
	        }
	        return this.makeOutput(newValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.linear = function (x) {
	        return x;
	    };
	    MathBackendCPU.prototype.relu = function (x) {
	        cpu_util_1.assertNotComplex(x, 'relu');
	        var res = ops.zeros(x.shape, x.dtype);
	        var resVals = this.readSync(res.dataId);
	        var inVals = this.readSync(x.dataId);
	        for (var i = 0; i < inVals.length; ++i) {
	            resVals[i] = Math.max(0, inVals[i]);
	        }
	        return res;
	    };
	    MathBackendCPU.prototype.relu6 = function (x) {
	        cpu_util_1.assertNotComplex(x, 'relu');
	        var res = ops.zeros(x.shape, x.dtype);
	        var resVals = this.readSync(res.dataId);
	        var inVals = this.readSync(x.dataId);
	        for (var i = 0; i < inVals.length; ++i) {
	            resVals[i] = Math.min(Math.max(0, inVals[i]), 6);
	        }
	        return res;
	    };
	    MathBackendCPU.prototype.prelu = function (x, a) {
	        cpu_util_1.assertNotComplex([x, a], 'prelu');
	        return this.broadcastedBinaryOp(x, a, x.dtype, function (xValue, aValue) { return xValue < 0 ? aValue * xValue : xValue; });
	    };
	    MathBackendCPU.prototype.elu = function (x) {
	        cpu_util_1.assertNotComplex(x, 'elu');
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            var v = values[i];
	            if (v >= 0) {
	                resultValues[i] = v;
	            }
	            else {
	                resultValues[i] = (Math.exp(v) - 1);
	            }
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.eluDer = function (dy, y) {
	        cpu_util_1.assertNotComplex([dy, y], 'eluDer');
	        var resultValues = new Float32Array(y.size);
	        var values = this.readSync(y.dataId);
	        var dyValues = this.readSync(dy.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            var v = values[i];
	            if (v >= 1) {
	                resultValues[i] = dyValues[i];
	            }
	            else {
	                resultValues[i] = dyValues[i] * (v + 1);
	            }
	        }
	        return this.makeOutput(resultValues, y.shape, 'float32');
	    };
	    MathBackendCPU.prototype.selu = function (x) {
	        cpu_util_1.assertNotComplex(x, 'selu');
	        // Stable and Attracting Fixed Point (0, 1) for Normalized Weights.
	        // see: https://arxiv.org/abs/1706.02515
	        var scaleAlpha = selu_util.SELU_SCALEALPHA;
	        var scale = selu_util.SELU_SCALE;
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            var v = values[i];
	            if (v >= 0) {
	                resultValues[i] = scale * v;
	            }
	            else {
	                resultValues[i] = scaleAlpha * (Math.exp(v) - 1);
	            }
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.clip = function (x, min, max) {
	        cpu_util_1.assertNotComplex(x, 'clip');
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            var v = values[i];
	            resultValues[i] = v > max ? max : (v < min ? min : v);
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.abs = function (x) {
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            resultValues[i] = Math.abs(values[i]);
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.complexAbs = function (x) {
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < x.size; ++i) {
	            var real_1 = values[i * 2];
	            var imag_1 = values[i * 2 + 1];
	            resultValues[i] = Math.hypot(real_1, imag_1);
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.int = function (x) {
	        cpu_util_1.assertNotComplex(x, 'int');
	        var resultValues = new Int32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            resultValues[i] = values[i];
	        }
	        return this.makeOutput(resultValues, x.shape, 'int32');
	    };
	    MathBackendCPU.prototype.sigmoid = function (x) {
	        cpu_util_1.assertNotComplex(x, 'sigmoid');
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            resultValues[i] = 1 / (1 + Math.exp(-values[i]));
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.softplus = function (x) {
	        cpu_util_1.assertNotComplex(x, 'softplus');
	        // mirrors the implementation of tf.nn.softplus: https://goo.gl/vkcvwX
	        // epsilon is the difference between 1.0 and the next representable float.
	        // For a single precision 32 bit float this should be 2^-23, see:
	        // https://math.byu.edu/~schow/work/IEEEFloatingPoint.htm
	        var epsilon = 1.1920928955078125e-7;
	        var threshold = Math.log(epsilon) + 2.0;
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            // Value above which exp(x) may overflow, but softplus(x) == x
	            // is within machine epsilon.
	            var tooLarge = values[i] > -threshold;
	            // Value below which exp(x) may underflow, but softplus(x) == exp(x)
	            // is within machine epsilon.
	            var tooSmall = values[i] < threshold;
	            var expX = Math.exp(values[i]);
	            var result = void 0;
	            if (tooSmall) {
	                result = expX;
	            }
	            else if (tooLarge) {
	                result = values[i];
	            }
	            else {
	                result = Math.log(1.0 + expX);
	            }
	            resultValues[i] = result;
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.sin = function (x) {
	        cpu_util_1.assertNotComplex(x, 'sin');
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            resultValues[i] = Math.sin(values[i]);
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.cos = function (x) {
	        cpu_util_1.assertNotComplex(x, 'cos');
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            resultValues[i] = Math.cos(values[i]);
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.tan = function (x) {
	        cpu_util_1.assertNotComplex(x, 'tan');
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            resultValues[i] = Math.tan(values[i]);
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.asin = function (x) {
	        cpu_util_1.assertNotComplex(x, 'asin');
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            resultValues[i] = Math.asin(values[i]);
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.acos = function (x) {
	        cpu_util_1.assertNotComplex(x, 'acos');
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            resultValues[i] = Math.acos(values[i]);
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.atan = function (x) {
	        cpu_util_1.assertNotComplex(x, 'atan');
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            resultValues[i] = Math.atan(values[i]);
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.atan2 = function (a, b) {
	        cpu_util_1.assertNotComplex([a, b], 'atan2');
	        return this.broadcastedBinaryOp(a, b, a.dtype, function (aValue, bValue) { return Math.atan2(aValue, bValue); });
	    };
	    MathBackendCPU.prototype.sinh = function (x) {
	        cpu_util_1.assertNotComplex(x, 'sinh');
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            resultValues[i] = Math.sinh(values[i]);
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.cosh = function (x) {
	        cpu_util_1.assertNotComplex(x, 'cosh');
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            resultValues[i] = Math.cosh(values[i]);
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.tanh = function (x) {
	        cpu_util_1.assertNotComplex(x, 'tanh');
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            resultValues[i] = util.tanh(values[i]);
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.asinh = function (x) {
	        cpu_util_1.assertNotComplex(x, 'asinh');
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            resultValues[i] = Math.asinh(values[i]);
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.acosh = function (x) {
	        cpu_util_1.assertNotComplex(x, 'acosh');
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            resultValues[i] = Math.acosh(values[i]);
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.atanh = function (x) {
	        cpu_util_1.assertNotComplex(x, 'atanh');
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            resultValues[i] = Math.atanh(values[i]);
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.erf = function (x) {
	        cpu_util_1.assertNotComplex(x, 'erf');
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        var p = erf_util.ERF_P;
	        var a1 = erf_util.ERF_A1;
	        var a2 = erf_util.ERF_A2;
	        var a3 = erf_util.ERF_A3;
	        var a4 = erf_util.ERF_A4;
	        var a5 = erf_util.ERF_A5;
	        for (var i = 0; i < values.length; ++i) {
	            var sign = Math.sign(values[i]);
	            var v = Math.abs(values[i]);
	            var t = 1.0 / (1.0 + p * v);
	            resultValues[i] = sign *
	                (1.0 -
	                    (((((a5 * t + a4) * t) + a3) * t + a2) * t + a1) * t *
	                        Math.exp(-v * v));
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.step = function (x, alpha) {
	        if (alpha === void 0) { alpha = 0; }
	        cpu_util_1.assertNotComplex(x, 'step');
	        var resultValues = new Float32Array(x.size);
	        var values = this.readSync(x.dataId);
	        for (var i = 0; i < values.length; ++i) {
	            var value = values[i];
	            if (isNaN(value)) {
	                resultValues[i] = NaN;
	            }
	            else {
	                resultValues[i] = value > 0 ? 1 : alpha;
	            }
	        }
	        return this.makeOutput(resultValues, x.shape, 'float32');
	    };
	    MathBackendCPU.prototype.fusedConv2d = function (_a) {
	        var input = _a.input, filter = _a.filter, convInfo = _a.convInfo, bias = _a.bias, activation = _a.activation, preluActivationWeights = _a.preluActivationWeights;
	        var result = this.conv2d(input, filter, convInfo);
	        if (bias) {
	            result = this.add(result, bias);
	        }
	        if (activation) {
	            result =
	                mapActivation(this, result, activation, preluActivationWeights);
	        }
	        return result;
	    };
	    MathBackendCPU.prototype.conv2d = function (x, filter, convInfo) {
	        cpu_util_1.assertNotComplex([x, filter], 'conv2d');
	        var filterHeight = convInfo.filterHeight;
	        var filterWidth = convInfo.filterWidth;
	        var dilationHeight = convInfo.dilationHeight;
	        var dilationWidth = convInfo.dilationWidth;
	        var padLeft = convInfo.padInfo.left;
	        var padTop = convInfo.padInfo.top;
	        var isChannelsLast = convInfo.dataFormat === 'channelsLast';
	        var y = ops.buffer(convInfo.outShape, x.dtype);
	        var xBatchStride = x.strides[0];
	        var xRowStride = isChannelsLast ? x.strides[1] : x.strides[2];
	        var xColStride = isChannelsLast ? x.strides[2] : 1;
	        var xChannelStride = isChannelsLast ? 1 : x.strides[1];
	        var yBatchStride = y.strides[0];
	        var yRowStride = isChannelsLast ? y.strides[1] : y.strides[2];
	        var yColStride = isChannelsLast ? y.strides[2] : 1;
	        var yChannelStride = isChannelsLast ? 1 : y.strides[1];
	        var xVals = this.readSync(x.dataId);
	        var wVals = this.readSync(filter.dataId);
	        var yVals = y.values;
	        for (var b = 0; b < convInfo.batchSize; ++b) {
	            var xOffset1 = b * xBatchStride;
	            var yOffset1 = b * yBatchStride;
	            for (var yR = 0; yR < convInfo.outHeight; ++yR) {
	                var yOffset2 = yOffset1 + yR * yRowStride;
	                var xRCorner = yR * convInfo.strideHeight - padTop;
	                for (var wR = 0; wR < filterHeight; wR++) {
	                    var xR = xRCorner + wR * dilationHeight;
	                    if (xR < 0 || xR >= convInfo.inHeight) {
	                        continue;
	                    }
	                    var wOffset1 = wR * filter.strides[0];
	                    var xOffset2 = xOffset1 + xR * xRowStride;
	                    for (var yC = 0; yC < convInfo.outWidth; ++yC) {
	                        var yOffset3 = yOffset2 + yC * yColStride;
	                        var xCCorner = yC * convInfo.strideWidth - padLeft;
	                        for (var wC = 0; wC < filterWidth; wC++) {
	                            var xC = xCCorner + wC * dilationWidth;
	                            if (xC < 0 || xC >= convInfo.inWidth) {
	                                continue;
	                            }
	                            var wOffset2 = wOffset1 + wC * filter.strides[1];
	                            var xOffset3 = xOffset2 + xC * xColStride;
	                            var wOffset3 = wOffset2;
	                            for (var d1 = 0; d1 < convInfo.inChannels; ++d1) {
	                                var xVal = xVals[xOffset3 + d1 * xChannelStride];
	                                for (var d2 = 0; d2 < convInfo.outChannels; ++d2) {
	                                    yVals[yOffset3 + d2 * yChannelStride] +=
	                                        xVal * wVals[wOffset3 + d2];
	                                }
	                                wOffset3 += convInfo.outChannels;
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        return y.toTensor();
	    };
	    MathBackendCPU.prototype.conv3d = function (x, filter, convInfo) {
	        var filterDepth = convInfo.filterDepth;
	        var filterHeight = convInfo.filterHeight;
	        var filterWidth = convInfo.filterWidth;
	        var dilationDepth = convInfo.dilationDepth;
	        var dilationHeight = convInfo.dilationHeight;
	        var dilationWidth = convInfo.dilationWidth;
	        var padFront = convInfo.padInfo.front;
	        var padLeft = convInfo.padInfo.left;
	        var padTop = convInfo.padInfo.top;
	        var y = ops.buffer(convInfo.outShape, x.dtype);
	        var xVals = this.readSync(x.dataId);
	        var wVals = this.readSync(filter.dataId);
	        var yVals = y.values;
	        for (var b = 0; b < convInfo.batchSize; ++b) {
	            var xOffset1 = b * x.strides[0];
	            var yOffset1 = b * y.strides[0];
	            for (var yF = 0; yF < convInfo.outDepth; ++yF) {
	                var yOffset2 = yOffset1 + yF * y.strides[1];
	                var xFCorner = yF * convInfo.strideDepth - padFront;
	                for (var wF = 0; wF < filterDepth; wF++) {
	                    var xF = xFCorner + wF * dilationDepth;
	                    if (xF < 0 || xF >= convInfo.inDepth) {
	                        continue;
	                    }
	                    var wOffset1 = wF * filter.strides[0];
	                    var xOffset2 = xOffset1 + xF * x.strides[1];
	                    for (var yR = 0; yR < convInfo.outHeight; ++yR) {
	                        var yOffset3 = yOffset2 + yR * y.strides[2];
	                        var xRCorner = yR * convInfo.strideHeight - padTop;
	                        for (var wR = 0; wR < filterHeight; wR++) {
	                            var xR = xRCorner + wR * dilationHeight;
	                            if (xR < 0 || xR >= convInfo.inHeight) {
	                                continue;
	                            }
	                            var wOffset2 = wOffset1 + wR * filter.strides[1];
	                            var xOffset3 = xOffset2 + xR * x.strides[2];
	                            for (var yC = 0; yC < convInfo.outWidth; ++yC) {
	                                var yOffset4 = yOffset3 + yC * convInfo.outChannels;
	                                var xCCorner = yC * convInfo.strideWidth - padLeft;
	                                for (var wC = 0; wC < filterWidth; wC++) {
	                                    var xC = xCCorner + wC * dilationWidth;
	                                    if (xC < 0 || xC >= convInfo.inWidth) {
	                                        continue;
	                                    }
	                                    var wOffset3 = wOffset2 + wC * filter.strides[2];
	                                    var xOffset4 = xOffset3 + xC * convInfo.inChannels;
	                                    var wOffset4 = wOffset3;
	                                    for (var d1 = 0; d1 < convInfo.inChannels; ++d1) {
	                                        var xVal = xVals[xOffset4 + d1];
	                                        for (var d2 = 0; d2 < convInfo.outChannels; ++d2) {
	                                            yVals[yOffset4 + d2] += xVal * wVals[wOffset4 + d2];
	                                        }
	                                        wOffset4 += convInfo.outChannels;
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        return y.toTensor();
	    };
	    MathBackendCPU.prototype.conv2dDerInput = function (dy, filter, convInfo) {
	        cpu_util_1.assertNotComplex([dy, filter], 'conv2dDerInput');
	        var dx = ops.buffer(convInfo.inShape, 'float32');
	        var dxValues = dx.values;
	        var dyValues = this.readSync(dy.dataId);
	        var fltValues = this.readSync(filter.dataId);
	        var _a = filter.strides, fltS0 = _a[0], fltS1 = _a[1], fltS2 = _a[2];
	        var batchSize = convInfo.batchSize, filterHeight = convInfo.filterHeight, filterWidth = convInfo.filterWidth, inChannels = convInfo.inChannels, inHeight = convInfo.inHeight, inWidth = convInfo.inWidth, outChannels = convInfo.outChannels, outHeight = convInfo.outHeight, outWidth = convInfo.outWidth, strideHeight = convInfo.strideHeight, strideWidth = convInfo.strideWidth, dataFormat = convInfo.dataFormat;
	        var topPad = filterHeight - 1 - convInfo.padInfo.top;
	        var leftPad = filterWidth - 1 - convInfo.padInfo.left;
	        var isChannelsLast = dataFormat === 'channelsLast';
	        var xBatchStride = dx.strides[0];
	        var xRowStride = isChannelsLast ? dx.strides[1] : dx.strides[2];
	        var xColStride = isChannelsLast ? dx.strides[2] : 1;
	        var xChannelStride = isChannelsLast ? 1 : dx.strides[1];
	        var yBatchStride = dy.strides[0];
	        var yRowStride = isChannelsLast ? dy.strides[1] : dy.strides[2];
	        var yColStride = isChannelsLast ? dy.strides[2] : 1;
	        var yChannelStride = isChannelsLast ? 1 : dy.strides[1];
	        for (var b = 0; b < batchSize; ++b) {
	            for (var d1 = 0; d1 < inChannels; ++d1) {
	                for (var xR = 0; xR < inHeight; ++xR) {
	                    var xRCorner = xR - topPad;
	                    var xRMin = Math.max(0, Math.ceil(xRCorner / strideHeight));
	                    var yRMax = Math.min(outHeight, (filterHeight + xRCorner) / strideHeight);
	                    for (var xC = 0; xC < inWidth; ++xC) {
	                        var xCCorner = xC - leftPad;
	                        var xCMin = Math.max(0, Math.ceil(xCCorner / strideWidth));
	                        var yCMax = Math.min(outWidth, (filterWidth + xCCorner) / strideWidth);
	                        var dotProd = 0;
	                        for (var yR = xRMin; yR < yRMax; ++yR) {
	                            var wR = yR * strideHeight - xRCorner;
	                            for (var yC = xCMin; yC < yCMax; ++yC) {
	                                var wC = yC * strideWidth - xCCorner;
	                                var dyOffset = yBatchStride * b + yRowStride * yR + yColStride * yC;
	                                var fltOffset = fltS0 * (filterHeight - 1 - wR) +
	                                    fltS1 * (filterWidth - 1 - wC) + fltS2 * d1;
	                                for (var d2 = 0; d2 < outChannels; ++d2) {
	                                    var pixel = dyValues[dyOffset + yChannelStride * d2];
	                                    var weight = fltValues[fltOffset + d2];
	                                    dotProd += pixel * weight;
	                                }
	                            }
	                        }
	                        var dxOffset = xBatchStride * b + xRowStride * xR +
	                            xColStride * xC + xChannelStride * d1;
	                        dxValues[dxOffset] = dotProd;
	                    }
	                }
	            }
	        }
	        return dx.toTensor();
	    };
	    MathBackendCPU.prototype.conv3dDerInput = function (dy, filter, convInfo) {
	        var dx = ops.buffer(convInfo.inShape, 'float32');
	        var dxValues = dx.values;
	        var _a = dx.strides, dxS0 = _a[0], dxS1 = _a[1], dxS2 = _a[2], dxS3 = _a[3];
	        var dyValues = this.readSync(dy.dataId);
	        var _b = dy.strides, dyS0 = _b[0], dyS1 = _b[1], dyS2 = _b[2], dyS3 = _b[3];
	        var fltValues = this.readSync(filter.dataId);
	        var _c = filter.strides, fltS0 = _c[0], fltS1 = _c[1], fltS2 = _c[2], fltS3 = _c[3];
	        var batchSize = convInfo.batchSize, filterDepth = convInfo.filterDepth, filterHeight = convInfo.filterHeight, filterWidth = convInfo.filterWidth, inChannels = convInfo.inChannels, inDepth = convInfo.inDepth, inHeight = convInfo.inHeight, inWidth = convInfo.inWidth, outChannels = convInfo.outChannels, outDepth = convInfo.outDepth, outHeight = convInfo.outHeight, outWidth = convInfo.outWidth, strideDepth = convInfo.strideDepth, strideHeight = convInfo.strideHeight, strideWidth = convInfo.strideWidth;
	        var frontPad = filterDepth - 1 - convInfo.padInfo.front;
	        var topPad = filterHeight - 1 - convInfo.padInfo.top;
	        var leftPad = filterWidth - 1 - convInfo.padInfo.left;
	        for (var b = 0; b < batchSize; ++b) {
	            for (var d1 = 0; d1 < inChannels; ++d1) {
	                // Frames of depth
	                for (var xF = 0; xF < inDepth; ++xF) {
	                    var xFCorner = xF - frontPad;
	                    var xFMin = Math.max(0, Math.ceil(xFCorner / strideDepth));
	                    var yFMax = Math.min(outDepth, (filterDepth + xFCorner) / strideDepth);
	                    // Rows as per standard 2d matrix notation
	                    for (var xR = 0; xR < inHeight; ++xR) {
	                        var xRCorner = xR - topPad;
	                        var xRMin = Math.max(0, Math.ceil(xRCorner / strideHeight));
	                        var yRMax = Math.min(outHeight, (filterHeight + xRCorner) / strideHeight);
	                        // Columns as per standard 2d matrix notation
	                        for (var xC = 0; xC < inWidth; ++xC) {
	                            var xCCorner = xC - leftPad;
	                            var xCMin = Math.max(0, Math.ceil(xCCorner / strideWidth));
	                            var yCMax = Math.min(outWidth, (filterWidth + xCCorner) / strideWidth);
	                            var dotProd = 0;
	                            for (var yF = xFMin; yF < yFMax; ++yF) {
	                                var wF = yF * strideDepth - xFCorner;
	                                for (var yR = xRMin; yR < yRMax; ++yR) {
	                                    var wR = yR * strideHeight - xRCorner;
	                                    for (var yC = xCMin; yC < yCMax; ++yC) {
	                                        var wC = yC * strideWidth - xCCorner;
	                                        var dyOffset = dyS0 * b + dyS1 * yF + dyS2 * yR + dyS3 * yC;
	                                        var fltOffset = fltS0 * (filterDepth - 1 - wF) +
	                                            fltS1 * (filterHeight - 1 - wR) +
	                                            fltS2 * (filterWidth - 1 - wC) + fltS3 * d1;
	                                        for (var d2 = 0; d2 < outChannels; ++d2) {
	                                            var pixel = dyValues[dyOffset + d2];
	                                            var weight = fltValues[fltOffset + d2];
	                                            dotProd += pixel * weight;
	                                        }
	                                    }
	                                }
	                            }
	                            dxValues[dxS0 * b + dxS1 * xF + dxS2 * xR + dxS3 * xC + d1] =
	                                dotProd;
	                        }
	                    }
	                }
	            }
	        }
	        return dx.toTensor();
	    };
	    MathBackendCPU.prototype.conv2dDerFilter = function (x, dy, convInfo) {
	        cpu_util_1.assertNotComplex([x, dy], 'conv2dDerFilter');
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var filterHeight = convInfo.filterHeight;
	        var filterWidth = convInfo.filterWidth;
	        var isChannelsLast = convInfo.dataFormat === 'channelsLast';
	        var dW = ops.buffer(convInfo.filterShape, 'float32');
	        var leftPad = convInfo.padInfo.left;
	        var topPad = convInfo.padInfo.top;
	        var xBuf = this.bufferSync(x);
	        var dyBuf = this.bufferSync(dy);
	        for (var wR = 0; wR < filterHeight; ++wR) {
	            var yRMin = Math.max(0, Math.ceil((topPad - wR) / strideHeight));
	            var yRMax = Math.min(convInfo.outHeight, (convInfo.inHeight + topPad - wR) / strideHeight);
	            for (var wC = 0; wC < filterWidth; ++wC) {
	                var yCMin = Math.max(0, Math.ceil((leftPad - wC) / strideWidth));
	                var yCMax = Math.min(convInfo.outWidth, (convInfo.inWidth + leftPad - wC) / strideWidth);
	                for (var d1 = 0; d1 < convInfo.inChannels; ++d1) {
	                    for (var d2 = 0; d2 < convInfo.outChannels; ++d2) {
	                        // Need to convolve.
	                        var dotProd = 0;
	                        for (var b = 0; b < convInfo.batchSize; ++b) {
	                            for (var yR = yRMin; yR < yRMax; ++yR) {
	                                var xR = wR + yR * strideHeight - topPad;
	                                for (var yC = yCMin; yC < yCMax; ++yC) {
	                                    var xC = wC + yC * strideWidth - leftPad;
	                                    if (isChannelsLast) {
	                                        dotProd +=
	                                            xBuf.get(b, xR, xC, d1) * dyBuf.get(b, yR, yC, d2);
	                                    }
	                                    else {
	                                        dotProd +=
	                                            xBuf.get(b, d1, xR, xC) * dyBuf.get(b, d2, yR, yC);
	                                    }
	                                }
	                            }
	                        }
	                        dW.set(dotProd, wR, wC, d1, d2);
	                    }
	                }
	            }
	        }
	        return dW.toTensor();
	    };
	    MathBackendCPU.prototype.conv3dDerFilter = function (x, dy, convInfo) {
	        var strideDepth = convInfo.strideDepth;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var filterDepth = convInfo.filterDepth;
	        var filterHeight = convInfo.filterHeight;
	        var filterWidth = convInfo.filterWidth;
	        var dw = ops.buffer(convInfo.filterShape, 'float32');
	        var dwValues = dw.values;
	        var _a = dw.strides, dwS0 = _a[0], dwS1 = _a[1], dwS2 = _a[2], dwS3 = _a[3];
	        var dyValues = this.readSync(dy.dataId);
	        var _b = dy.strides, dyS0 = _b[0], dyS1 = _b[1], dyS2 = _b[2], dyS3 = _b[3];
	        var xValues = this.readSync(x.dataId);
	        var _c = x.strides, xS0 = _c[0], xS1 = _c[1], xS2 = _c[2], xS3 = _c[3];
	        var frontPad = convInfo.padInfo.front;
	        var leftPad = convInfo.padInfo.left;
	        var topPad = convInfo.padInfo.top;
	        for (var wF = 0; wF < filterDepth; ++wF) {
	            var yFMin = Math.max(0, Math.ceil((frontPad - wF) / strideDepth));
	            var yFMax = Math.min(convInfo.outDepth, (convInfo.inDepth + frontPad - wF) / strideDepth);
	            var wOffset1 = wF * dwS0;
	            for (var wR = 0; wR < filterHeight; ++wR) {
	                var yRMin = Math.max(0, Math.ceil((topPad - wR) / strideHeight));
	                var yRMax = Math.min(convInfo.outHeight, (convInfo.inHeight + topPad - wR) / strideHeight);
	                var wOffset2 = wR * dwS1 + wOffset1;
	                for (var wC = 0; wC < filterWidth; ++wC) {
	                    var yCMin = Math.max(0, Math.ceil((leftPad - wC) / strideWidth));
	                    var yCMax = Math.min(convInfo.outWidth, (convInfo.inWidth + leftPad - wC) / strideWidth);
	                    var wOffset3 = wC * dwS2 + wOffset2;
	                    for (var d1 = 0; d1 < convInfo.inChannels; ++d1) {
	                        var wOffset4 = d1 * dwS3 + wOffset3;
	                        for (var d2 = 0; d2 < convInfo.outChannels; ++d2) {
	                            var dotProd = 0;
	                            for (var b = 0; b < convInfo.batchSize; ++b) {
	                                var xOffset1 = b * xS0;
	                                var yOffset1 = b * dyS0;
	                                for (var yF = yFMin; yF < yFMax; ++yF) {
	                                    var xF = wF + yF * strideDepth - frontPad;
	                                    var xOffset2 = xF * xS1 + xOffset1;
	                                    var yOffset2 = yF * dyS1 + yOffset1;
	                                    for (var yR = yRMin; yR < yRMax; ++yR) {
	                                        var xR = wR + yR * strideHeight - topPad;
	                                        var xOffset3 = xR * xS2 + xOffset2;
	                                        var yOffset3 = yR * dyS2 + yOffset2;
	                                        for (var yC = yCMin; yC < yCMax; ++yC) {
	                                            var xC = wC + yC * strideWidth - leftPad;
	                                            var xOffset4 = xC * xS3 + xOffset3;
	                                            var yOffset4 = yC * dyS3 + yOffset3;
	                                            dotProd +=
	                                                xValues[xOffset4 + d1] * dyValues[yOffset4 + d2];
	                                        }
	                                    }
	                                }
	                            }
	                            dwValues[wOffset4 + d2] = dotProd;
	                        }
	                    }
	                }
	            }
	        }
	        return dw.toTensor();
	    };
	    MathBackendCPU.prototype.fusedDepthwiseConv2D = function (_a) {
	        var input = _a.input, filter = _a.filter, convInfo = _a.convInfo, bias = _a.bias, activation = _a.activation, preluActivationWeights = _a.preluActivationWeights;
	        var result = this.depthwiseConv2D(input, filter, convInfo);
	        if (bias) {
	            result = this.add(result, bias);
	        }
	        if (activation) {
	            result =
	                mapActivation(this, result, activation, preluActivationWeights);
	        }
	        return result;
	    };
	    MathBackendCPU.prototype.depthwiseConv2D = function (x, filter, convInfo) {
	        cpu_util_1.assertNotComplex([x, filter], 'depthwiseConv2D');
	        var filterHeight = convInfo.filterHeight;
	        var filterWidth = convInfo.filterWidth;
	        var dilationHeight = convInfo.dilationHeight;
	        var dilationWidth = convInfo.dilationWidth;
	        var padLeft = convInfo.padInfo.left;
	        var padTop = convInfo.padInfo.top;
	        var chMul = convInfo.outChannels / convInfo.inChannels;
	        var y = ops.buffer(convInfo.outShape, x.dtype);
	        var xVals = this.readSync(x.dataId);
	        var wVals = this.readSync(filter.dataId);
	        var yVals = y.values;
	        for (var b = 0; b < convInfo.batchSize; ++b) {
	            var xOffset1 = b * x.strides[0];
	            var yOffset1 = b * y.strides[0];
	            for (var yR = 0; yR < convInfo.outHeight; ++yR) {
	                var yOffset2 = yOffset1 + yR * y.strides[1];
	                var xRCorner = yR * convInfo.strideHeight - padLeft;
	                for (var wR = 0; wR < filterHeight; ++wR) {
	                    var xR = xRCorner + wR * dilationHeight;
	                    if (xR < 0 || xR >= convInfo.inHeight) {
	                        continue;
	                    }
	                    var wOffset1 = wR * filter.strides[0];
	                    var xOffset2 = xOffset1 + xR * x.strides[1];
	                    for (var yC = 0; yC < convInfo.outWidth; ++yC) {
	                        var yOffset3 = yOffset2 + yC * y.strides[2];
	                        var xCCorner = yC * convInfo.strideWidth - padTop;
	                        for (var wC = 0; wC < filterWidth; ++wC) {
	                            var xC = xCCorner + wC * dilationWidth;
	                            if (xC < 0 || xC >= convInfo.inWidth) {
	                                continue;
	                            }
	                            var wOffset2 = wOffset1 + wC * filter.strides[1];
	                            var xOffset3 = xOffset2 + xC * convInfo.inChannels;
	                            var yOffset4 = yOffset3;
	                            var wOffset3 = wOffset2;
	                            for (var d1 = 0; d1 < convInfo.inChannels; ++d1) {
	                                var xVal = xVals[xOffset3 + d1];
	                                for (var q = 0; q < chMul; ++q) {
	                                    yVals[yOffset4 + q] += xVal * wVals[wOffset3 + q];
	                                }
	                                yOffset4 += chMul;
	                                wOffset3 += chMul;
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        return y.toTensor();
	    };
	    MathBackendCPU.prototype.depthwiseConv2DDerInput = function (dy, filter, convInfo) {
	        cpu_util_1.assertNotComplex([dy, filter], 'depthwiseConv2DDerInput');
	        var dx = ops.buffer(convInfo.inShape, 'float32');
	        var dxValues = dx.values;
	        var _a = dx.strides, dxS0 = _a[0], dxS1 = _a[1], dxS2 = _a[2];
	        var dyValues = this.readSync(dy.dataId);
	        var _b = dy.strides, dyS0 = _b[0], dyS1 = _b[1], dyS2 = _b[2];
	        var fltValues = this.readSync(filter.dataId);
	        var _c = filter.strides, fltS0 = _c[0], fltS1 = _c[1], fltS2 = _c[2];
	        var batchSize = convInfo.batchSize, filterHeight = convInfo.filterHeight, filterWidth = convInfo.filterWidth, inChannels = convInfo.inChannels, inHeight = convInfo.inHeight, inWidth = convInfo.inWidth, outChannels = convInfo.outChannels, outHeight = convInfo.outHeight, outWidth = convInfo.outWidth, strideHeight = convInfo.strideHeight, strideWidth = convInfo.strideWidth;
	        var topPad = filterHeight - 1 - convInfo.padInfo.top;
	        var leftPad = filterWidth - 1 - convInfo.padInfo.left;
	        var chMul = outChannels / inChannels;
	        for (var b = 0; b < batchSize; ++b) {
	            for (var d1 = 0; d1 < inChannels; ++d1) {
	                for (var xR = 0; xR < inHeight; ++xR) {
	                    var xRCorner = xR - topPad;
	                    var xRMin = Math.max(0, Math.ceil(xRCorner / strideHeight));
	                    var yRMax = Math.min(outHeight, (filterHeight + xRCorner) / strideHeight);
	                    for (var xC = 0; xC < inWidth; ++xC) {
	                        var xCCorner = xC - leftPad;
	                        var xCMin = Math.max(0, Math.ceil(xCCorner / strideWidth));
	                        var yCMax = Math.min(outWidth, (filterWidth + xCCorner) / strideWidth);
	                        var dotProd = 0;
	                        for (var yR = xRMin; yR < yRMax; ++yR) {
	                            var wR = yR * strideHeight - xRCorner;
	                            for (var yC = xCMin; yC < yCMax; ++yC) {
	                                var wC = yC * strideWidth - xCCorner;
	                                var dyOffset = dyS0 * b + dyS1 * yR + dyS2 * yC;
	                                var fltOffset = fltS0 * (filterHeight - 1 - wR) +
	                                    fltS1 * (filterWidth - 1 - wC) + fltS2 * d1;
	                                for (var dm = 0; dm < chMul; ++dm) {
	                                    var d2 = d1 * chMul + dm;
	                                    var pixel = dyValues[dyOffset + d2];
	                                    var weight = fltValues[fltOffset + dm];
	                                    dotProd += pixel * weight;
	                                }
	                            }
	                        }
	                        dxValues[dxS0 * b + dxS1 * xR + dxS2 * xC + d1] = dotProd;
	                    }
	                }
	            }
	        }
	        return dx.toTensor();
	    };
	    MathBackendCPU.prototype.depthwiseConv2DDerFilter = function (x, dy, convInfo) {
	        cpu_util_1.assertNotComplex([x, dy], 'depthwiseConv2DDerFilter');
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var filterHeight = convInfo.filterHeight;
	        var filterWidth = convInfo.filterWidth;
	        var dW = ops.buffer(convInfo.filterShape, 'float32');
	        var leftPad = convInfo.padInfo.left;
	        var topPad = convInfo.padInfo.top;
	        var chMul = convInfo.outChannels / convInfo.inChannels;
	        var xBuf = this.bufferSync(x);
	        var dyBuf = this.bufferSync(dy);
	        for (var wR = 0; wR < filterHeight; ++wR) {
	            var yRMin = Math.max(0, Math.ceil((topPad - wR) / strideHeight));
	            var yRMax = Math.min(convInfo.outHeight, (convInfo.inHeight + topPad - wR) / strideHeight);
	            for (var wC = 0; wC < filterWidth; ++wC) {
	                var yCMin = Math.max(0, Math.ceil((leftPad - wC) / strideWidth));
	                var yCMax = Math.min(convInfo.outWidth, (convInfo.inWidth + leftPad - wC) / strideWidth);
	                for (var d2 = 0; d2 < convInfo.outChannels; ++d2) {
	                    var d1 = Math.trunc(d2 / chMul);
	                    var dm = d2 % chMul;
	                    var dotProd = 0;
	                    for (var b = 0; b < convInfo.batchSize; ++b) {
	                        for (var yR = yRMin; yR < yRMax; ++yR) {
	                            var xR = wR + yR * strideHeight - topPad;
	                            for (var yC = yCMin; yC < yCMax; ++yC) {
	                                var xC = wC + yC * strideWidth - leftPad;
	                                dotProd += xBuf.get(b, xR, xC, d1) * dyBuf.get(b, yR, yC, d2);
	                            }
	                        }
	                    }
	                    dW.set(dotProd, wR, wC, d1, dm);
	                }
	            }
	        }
	        return dW.toTensor();
	    };
	    MathBackendCPU.prototype.tile = function (x, reps) {
	        cpu_util_1.assertNotComplex(x, 'tile');
	        return tile_impl_1.tile(this.bufferSync(x), reps);
	    };
	    MathBackendCPU.prototype.pad = function (x, paddings, constantValue) {
	        cpu_util_1.assertNotComplex(x, 'pad');
	        var outShape = paddings.map(function (p, i) { return p[0] /* beforePad */ + x.shape[i] + p[1]; } /* afterPad */);
	        var start = paddings.map(function (p) { return p[0]; });
	        var xBuffer = this.bufferSync(x);
	        var buffer = ops.buffer(outShape, x.dtype);
	        if (constantValue !== 0) {
	            buffer.values.fill(constantValue);
	        }
	        for (var i = 0; i < x.size; i++) {
	            var coords = xBuffer.indexToLoc(i);
	            var outCoords = coords.map(function (c, i) { return c + start[i]; });
	            buffer.set.apply(buffer, [xBuffer.get.apply(xBuffer, coords)].concat(outCoords));
	        }
	        return buffer.toTensor();
	    };
	    MathBackendCPU.prototype.transpose = function (x, perm) {
	        cpu_util_1.assertNotComplex(x, 'transpose');
	        var newShape = new Array(x.rank);
	        for (var i = 0; i < newShape.length; i++) {
	            newShape[i] = x.shape[perm[i]];
	        }
	        var values = this.readSync(x.dataId);
	        var result = ops_1.buffer(newShape, x.dtype);
	        var xBuf = this.bufferSync(x);
	        for (var i = 0; i < x.size; ++i) {
	            var loc = xBuf.indexToLoc(i);
	            // Permute location.
	            var newLoc = new Array(loc.length);
	            for (var i_1 = 0; i_1 < newLoc.length; i_1++) {
	                newLoc[i_1] = loc[perm[i_1]];
	            }
	            var newIndex = result.locToIndex(newLoc);
	            result.values[newIndex] = values[i];
	        }
	        return result.toTensor();
	    };
	    MathBackendCPU.prototype.gather = function (x, indices, axis) {
	        cpu_util_1.assertNotComplex([x, indices], 'gather');
	        var newShape = x.shape.slice();
	        var indicesValues = this.readSync(indices.dataId);
	        newShape[axis] = indicesValues.length;
	        var result = ops_1.buffer(newShape, x.dtype);
	        var xBuf = this.bufferSync(x);
	        for (var i = 0; i < result.size; ++i) {
	            var newLoc = result.indexToLoc(i);
	            var originalLoc = newLoc.slice();
	            originalLoc[axis] = indicesValues[newLoc[axis]];
	            var originalIndex = xBuf.locToIndex(originalLoc);
	            result.values[i] = xBuf.values[originalIndex];
	        }
	        return result.toTensor();
	    };
	    MathBackendCPU.prototype.batchToSpaceND = function (x, blockShape, crops) {
	        cpu_util_1.assertNotComplex([x], 'batchToSpaceND');
	        var prod = blockShape.reduce(function (a, b) { return a * b; });
	        var reshaped = array_ops_util.getReshaped(x.shape, blockShape, prod);
	        var permuted = array_ops_util.getPermuted(reshaped.length, blockShape.length);
	        var reshapedPermuted = array_ops_util.getReshapedPermuted(x.shape, blockShape, prod);
	        var sliceBeginCoords = array_ops_util.getSliceBeginCoords(crops, blockShape.length);
	        var sliceSize = array_ops_util.getSliceSize(reshapedPermuted, crops, blockShape.length);
	        return x.reshape(reshaped)
	            .transpose(permuted)
	            .reshape(reshapedPermuted)
	            .slice(sliceBeginCoords, sliceSize);
	    };
	    MathBackendCPU.prototype.spaceToBatchND = function (x, blockShape, paddings) {
	        cpu_util_1.assertNotComplex([x], 'spaceToBatchND');
	        var prod = blockShape.reduce(function (a, b) { return a * b; });
	        var completePaddings = [[0, 0]];
	        completePaddings.push.apply(completePaddings, paddings);
	        for (var i = 1 + blockShape.length; i < x.shape.length; ++i) {
	            completePaddings.push([0, 0]);
	        }
	        var paddedX = x.pad(completePaddings);
	        var reshapedPaddedShape = array_ops_util.getReshaped(paddedX.shape, blockShape, prod, false);
	        var permutedReshapedPaddedPermutation = array_ops_util.getPermuted(reshapedPaddedShape.length, blockShape.length, false);
	        var flattenShape = array_ops_util.getReshapedPermuted(paddedX.shape, blockShape, prod, false);
	        return paddedX.reshape(reshapedPaddedShape)
	            .transpose(permutedReshapedPaddedPermutation)
	            .reshape(flattenShape);
	    };
	    MathBackendCPU.prototype.pool = function (x, convInfo, poolType) {
	        cpu_util_1.assertNotComplex(x, 'pool');
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var dilationHeight = convInfo.dilationHeight;
	        var dilationWidth = convInfo.dilationWidth;
	        var effectiveFilterHeight = convInfo.effectiveFilterHeight;
	        var effectiveFilterWidth = convInfo.effectiveFilterWidth;
	        var padTop = convInfo.padInfo.top;
	        var padLeft = convInfo.padInfo.left;
	        var initialValue = (poolType === 'max' ? Number.NEGATIVE_INFINITY :
	            Number.POSITIVE_INFINITY);
	        var xValues = this.readSync(x.dataId);
	        var output = ops.buffer(convInfo.outShape, x.dtype);
	        var outputVals = output.values;
	        var outputBatchStrides = convInfo.outShape[1] * convInfo.outShape[2] * convInfo.outShape[3];
	        var outputRowStrides = convInfo.outShape[2] * convInfo.outShape[3];
	        var outputColStrides = convInfo.outShape[3];
	        for (var b = 0; b < convInfo.batchSize; ++b) {
	            var outputBatchOffset = b * outputBatchStrides;
	            var inputBatchOffset = b * x.strides[0];
	            for (var d = 0; d < convInfo.inChannels; ++d) {
	                for (var yR = 0; yR < convInfo.outHeight; ++yR) {
	                    var xRCorner = yR * strideHeight - padTop;
	                    var xRMin = Math.max(0, xRCorner);
	                    var xRMax = Math.min(convInfo.inHeight, effectiveFilterHeight + xRCorner);
	                    var outputRowOffset = outputBatchOffset + yR * outputRowStrides;
	                    for (var yC = 0; yC < convInfo.outWidth; ++yC) {
	                        var xCCorner = yC * strideWidth - padLeft;
	                        var xCMin = Math.max(0, xCCorner);
	                        var xCMax = Math.min(convInfo.inWidth, effectiveFilterWidth + xCCorner);
	                        var minMaxValue = initialValue;
	                        var avgValue = 0;
	                        var count = 0;
	                        for (var xR = xRMin; xR < xRMax; xR += dilationHeight) {
	                            var xROffset = inputBatchOffset + xR * x.strides[1];
	                            for (var xC = xCMin; xC < xCMax; xC += dilationWidth) {
	                                var xCOffset = xROffset + xC * x.strides[2];
	                                var pixel = xValues[xCOffset + d];
	                                if ((poolType === 'max' && pixel > minMaxValue)) {
	                                    minMaxValue = pixel;
	                                }
	                                else if (poolType === 'avg') {
	                                    avgValue += pixel;
	                                    count++;
	                                }
	                            }
	                            if (isNaN(minMaxValue)) {
	                                break;
	                            }
	                        }
	                        var outputOffset = outputRowOffset + yC * outputColStrides + d;
	                        outputVals[outputOffset] =
	                            poolType === 'avg' ? avgValue / count : minMaxValue;
	                    }
	                }
	            }
	        }
	        return output.toTensor();
	    };
	    MathBackendCPU.prototype.maxPool = function (x, convInfo) {
	        return this.pool(x, convInfo, 'max');
	    };
	    MathBackendCPU.prototype.maxPoolPositions = function (x, convInfo) {
	        var maxPositions = ops.buffer(convInfo.outShape, 'int32');
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var dilationHeight = convInfo.dilationHeight;
	        var dilationWidth = convInfo.dilationWidth;
	        var effectiveFilterHeight = convInfo.effectiveFilterHeight;
	        var effectiveFilterWidth = convInfo.effectiveFilterWidth;
	        var padTop = convInfo.padInfo.top;
	        var padLeft = convInfo.padInfo.left;
	        var xBuf = this.bufferSync(x);
	        for (var b = 0; b < convInfo.batchSize; ++b) {
	            for (var d = 0; d < convInfo.inChannels; ++d) {
	                for (var yR = 0; yR < convInfo.outHeight; ++yR) {
	                    var xRCorner = yR * strideHeight - padTop;
	                    var xRMin = xRCorner;
	                    while (xRMin < 0) {
	                        xRMin += dilationHeight;
	                    }
	                    // const xRMin = Math.max(0, xRCorner);
	                    var xRMax = Math.min(convInfo.inHeight, effectiveFilterHeight + xRCorner);
	                    for (var yC = 0; yC < convInfo.outWidth; ++yC) {
	                        var xCCorner = yC * strideWidth - padLeft;
	                        var xCMin = xCCorner;
	                        while (xCMin < 0) {
	                            xCMin += dilationWidth;
	                        }
	                        var xCMax = Math.min(convInfo.inWidth, effectiveFilterWidth + xCCorner);
	                        var maxValue = Number.NEGATIVE_INFINITY;
	                        var maxPosition = -1;
	                        for (var xR = xRMin; xR < xRMax; xR += dilationHeight) {
	                            var wR = xR - xRCorner;
	                            for (var xC = xCMin; xC < xCMax; xC += dilationWidth) {
	                                var wC = xC - xCCorner;
	                                var pixel = xBuf.get(b, xR, xC, d);
	                                if (pixel > maxValue) {
	                                    maxValue = pixel;
	                                    maxPosition = wR * effectiveFilterWidth + wC;
	                                }
	                            }
	                        }
	                        maxPositions.set(maxPosition, b, yR, yC, d);
	                    }
	                }
	            }
	        }
	        return maxPositions.toTensor();
	    };
	    MathBackendCPU.prototype.maxPoolBackprop = function (dy, x, y, convInfo) {
	        cpu_util_1.assertNotComplex([x, y], 'maxPoolBackprop');
	        var maxPositions = this.maxPoolPositions(x, convInfo);
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var dilationHeight = convInfo.dilationHeight;
	        var dilationWidth = convInfo.dilationWidth;
	        var effectiveFilterHeight = convInfo.effectiveFilterHeight;
	        var effectiveFilterWidth = convInfo.effectiveFilterWidth;
	        var padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
	        var padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
	        var dx = ops.buffer(x.shape, 'float32');
	        var maxPosBuf = this.bufferSync(maxPositions);
	        var dyBuf = this.bufferSync(dy);
	        for (var b = 0; b < convInfo.batchSize; ++b) {
	            for (var d = 0; d < convInfo.inChannels; ++d) {
	                for (var dxR = 0; dxR < convInfo.inHeight; ++dxR) {
	                    for (var dxC = 0; dxC < convInfo.inWidth; ++dxC) {
	                        // Shader code begins.
	                        var dyRCorner = dxR - padTop;
	                        var dyCCorner = dxC - padLeft;
	                        var dotProd = 0;
	                        for (var wR = 0; wR < effectiveFilterHeight; wR += dilationHeight) {
	                            var dyR = (dyRCorner + wR) / strideHeight;
	                            if (dyR < 0 || dyR >= convInfo.outHeight ||
	                                Math.floor(dyR) !== dyR) {
	                                continue;
	                            }
	                            for (var wC = 0; wC < effectiveFilterWidth; wC += dilationWidth) {
	                                var dyC = (dyCCorner + wC) / strideWidth;
	                                if (dyC < 0 || dyC >= convInfo.outWidth ||
	                                    Math.floor(dyC) !== dyC) {
	                                    continue;
	                                }
	                                var maxPos = effectiveFilterHeight * effectiveFilterWidth -
	                                    1 - maxPosBuf.get(b, dyR, dyC, d);
	                                var curPos = wR * effectiveFilterWidth + wC;
	                                var mask = maxPos === curPos ? 1 : 0;
	                                if (mask === 0) {
	                                    continue;
	                                }
	                                var pixel = dyBuf.get(b, dyR, dyC, d);
	                                dotProd += pixel * mask;
	                            }
	                        }
	                        dx.set(dotProd, b, dxR, dxC, d);
	                    }
	                }
	            }
	        }
	        return dx.toTensor();
	    };
	    MathBackendCPU.prototype.avgPoolBackprop = function (dy, x, convInfo) {
	        cpu_util_1.assertNotComplex([dy, x], 'avgPoolBackprop');
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var filterHeight = convInfo.filterHeight;
	        var filterWidth = convInfo.filterWidth;
	        var dilationHeight = convInfo.dilationHeight;
	        var dilationWidth = convInfo.dilationWidth;
	        var effectiveFilterHeight = convInfo.effectiveFilterHeight;
	        var effectiveFilterWidth = convInfo.effectiveFilterWidth;
	        var padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
	        var padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
	        var dx = ops.buffer(x.shape, 'float32');
	        var avgMultiplier = 1 / (filterHeight * filterWidth);
	        var dyBuf = this.bufferSync(dy);
	        for (var b = 0; b < convInfo.batchSize; ++b) {
	            for (var d = 0; d < convInfo.inChannels; ++d) {
	                for (var dxR = 0; dxR < convInfo.inHeight; ++dxR) {
	                    for (var dxC = 0; dxC < convInfo.inWidth; ++dxC) {
	                        // Shader code begins.
	                        var dyRCorner = dxR - padTop;
	                        var dyCCorner = dxC - padLeft;
	                        var dotProd = 0;
	                        for (var wR = 0; wR < effectiveFilterHeight; wR += dilationHeight) {
	                            var dyR = (dyRCorner + wR) / strideHeight;
	                            if (dyR < 0 || dyR >= convInfo.outHeight ||
	                                Math.floor(dyR) !== dyR) {
	                                continue;
	                            }
	                            for (var wC = 0; wC < effectiveFilterWidth; wC += dilationWidth) {
	                                var dyC = (dyCCorner + wC) / strideWidth;
	                                if (dyC < 0 || dyC >= convInfo.outWidth ||
	                                    Math.floor(dyC) !== dyC) {
	                                    continue;
	                                }
	                                var pixel = dyBuf.get(b, dyR, dyC, d);
	                                dotProd += pixel;
	                            }
	                        }
	                        dx.set(dotProd * avgMultiplier, b, dxR, dxC, d);
	                    }
	                }
	            }
	        }
	        return dx.toTensor();
	    };
	    MathBackendCPU.prototype.pool3d = function (x, convInfo, poolType) {
	        cpu_util_1.assertNotComplex(x, 'pool3d');
	        var strideDepth = convInfo.strideDepth;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var dilationDepth = convInfo.dilationDepth;
	        var dilationHeight = convInfo.dilationHeight;
	        var dilationWidth = convInfo.dilationWidth;
	        var effectiveFilterDepth = convInfo.effectiveFilterDepth;
	        var effectiveFilterHeight = convInfo.effectiveFilterHeight;
	        var effectiveFilterWidth = convInfo.effectiveFilterWidth;
	        var padFront = convInfo.padInfo.front;
	        var padTop = convInfo.padInfo.top;
	        var padLeft = convInfo.padInfo.left;
	        var initialValue = (poolType === 'max' ? Number.NEGATIVE_INFINITY :
	            Number.POSITIVE_INFINITY);
	        var xValues = this.readSync(x.dataId);
	        var output = ops.buffer(convInfo.outShape, x.dtype);
	        var outputVals = output.values;
	        var outputBatchStrides = convInfo.outShape[1] * convInfo.outShape[2] *
	            convInfo.outShape[3] * convInfo.outShape[4];
	        var outputDepthStrides = convInfo.outShape[2] * convInfo.outShape[3] * convInfo.outShape[4];
	        var outputRowStrides = convInfo.outShape[3] * convInfo.outShape[4];
	        var outputColStrides = convInfo.outShape[4];
	        for (var batch = 0; batch < convInfo.batchSize; ++batch) {
	            var outputBatchOffset = batch * outputBatchStrides;
	            var inputBatchOffset = batch * x.strides[0];
	            for (var channel = 0; channel < convInfo.inChannels; ++channel) {
	                for (var yDepth = 0; yDepth < convInfo.outDepth; ++yDepth) {
	                    var xDepthCorner = yDepth * strideDepth - padFront;
	                    var xDepthMin = xDepthCorner;
	                    while (xDepthMin < 0) {
	                        xDepthMin += dilationDepth;
	                    }
	                    var xDepthMax = Math.min(convInfo.inDepth, effectiveFilterDepth + xDepthCorner);
	                    var outputDepthOffset = outputBatchOffset + yDepth * outputDepthStrides;
	                    for (var yRow = 0; yRow < convInfo.outHeight; ++yRow) {
	                        var xRowCorner = yRow * strideHeight - padTop;
	                        var xRowMin = xRowCorner;
	                        while (xRowMin < 0) {
	                            xRowMin += dilationHeight;
	                        }
	                        var xRowMax = Math.min(convInfo.inHeight, effectiveFilterHeight + xRowCorner);
	                        var outputRowOffset = outputDepthOffset + yRow * outputRowStrides;
	                        for (var yCol = 0; yCol < convInfo.outWidth; ++yCol) {
	                            var xColCorner = yCol * strideWidth - padLeft;
	                            var xColMin = xColCorner;
	                            while (xColMin < 0) {
	                                xColMin += dilationWidth;
	                            }
	                            var xColMax = Math.min(convInfo.inWidth, effectiveFilterWidth + xColCorner);
	                            // Shader code begins
	                            var outputColOffset = outputRowOffset + yCol * outputColStrides;
	                            var minMaxValue = initialValue;
	                            var avgValue = 0;
	                            var count = 0;
	                            for (var xDepth = xDepthMin; xDepth < xDepthMax; xDepth += dilationDepth) {
	                                var xDepthOffset = inputBatchOffset + xDepth * x.strides[1];
	                                for (var xRow = xRowMin; xRow < xRowMax; xRow += dilationHeight) {
	                                    var xRowOffset = xDepthOffset + xRow * x.strides[2];
	                                    for (var xCol = xColMin; xCol < xColMax; xCol += dilationWidth) {
	                                        var xColOffset = xRowOffset + xCol * x.strides[3];
	                                        var pixel = xValues[xColOffset + channel];
	                                        if ((poolType === 'max' && pixel > minMaxValue)) {
	                                            minMaxValue = pixel;
	                                        }
	                                        else if (poolType === 'avg') {
	                                            avgValue += pixel;
	                                            count++;
	                                        }
	                                        if (isNaN(minMaxValue)) {
	                                            break;
	                                        }
	                                    }
	                                    if (isNaN(minMaxValue)) {
	                                        break;
	                                    }
	                                }
	                                if (isNaN(minMaxValue)) {
	                                    break;
	                                }
	                            }
	                            var outputOffset = outputColOffset + channel;
	                            outputVals[outputOffset] =
	                                poolType === 'avg' ? avgValue / count : minMaxValue;
	                        }
	                    }
	                }
	            }
	        }
	        return output.toTensor();
	    };
	    MathBackendCPU.prototype.avgPool3d = function (x, convInfo) {
	        cpu_util_1.assertNotComplex(x, 'avgPool3d');
	        return this.pool3d(x, convInfo, 'avg').toFloat();
	    };
	    MathBackendCPU.prototype.avgPool3dBackprop = function (dy, x, convInfo) {
	        cpu_util_1.assertNotComplex([dy, x], 'avgPool3dBackprop');
	        var strideDepth = convInfo.strideDepth;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var filterDepth = convInfo.filterDepth;
	        var filterHeight = convInfo.filterHeight;
	        var filterWidth = convInfo.filterWidth;
	        var dilationDepth = convInfo.dilationDepth;
	        var dilationHeight = convInfo.dilationHeight;
	        var dilationWidth = convInfo.dilationWidth;
	        var effectiveFilterDepth = convInfo.effectiveFilterDepth;
	        var effectiveFilterHeight = convInfo.effectiveFilterHeight;
	        var effectiveFilterWidth = convInfo.effectiveFilterWidth;
	        var padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
	        var padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
	        var padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
	        var dx = ops.buffer(x.shape, 'float32');
	        var avgMultiplier = 1 / (filterDepth * filterHeight * filterWidth);
	        var dyBuf = this.bufferSync(dy);
	        for (var batch = 0; batch < convInfo.batchSize; ++batch) {
	            for (var channel = 0; channel < convInfo.inChannels; ++channel) {
	                for (var dxDepth = 0; dxDepth < convInfo.inDepth; ++dxDepth) {
	                    for (var dxRow = 0; dxRow < convInfo.inHeight; ++dxRow) {
	                        for (var dxCol = 0; dxCol < convInfo.inWidth; ++dxCol) {
	                            // Shader code begins.
	                            var dyDepthCorner = dxDepth - padFront;
	                            var dyRowCorner = dxRow - padTop;
	                            var dyColCorner = dxCol - padLeft;
	                            var dotProd = 0;
	                            for (var wDepth = 0; wDepth < effectiveFilterDepth; wDepth += dilationDepth) {
	                                var dyDepth = (dyDepthCorner + wDepth) / strideDepth;
	                                if (dyDepth < 0 || dyDepth >= convInfo.outDepth ||
	                                    Math.floor(dyDepth) !== dyDepth) {
	                                    continue;
	                                }
	                                for (var wRow = 0; wRow < effectiveFilterHeight; wRow += dilationHeight) {
	                                    var dyRow = (dyRowCorner + wRow) / strideHeight;
	                                    if (dyRow < 0 || dyRow >= convInfo.outHeight ||
	                                        Math.floor(dyRow) !== dyRow) {
	                                        continue;
	                                    }
	                                    for (var wCol = 0; wCol < effectiveFilterWidth; wCol += dilationWidth) {
	                                        var dyCol = (dyColCorner + wCol) / strideWidth;
	                                        if (dyCol < 0 || dyCol >= convInfo.outWidth ||
	                                            Math.floor(dyCol) !== dyCol) {
	                                            continue;
	                                        }
	                                        var pixel = dyBuf.get(batch, dyDepth, dyRow, dyCol, channel);
	                                        dotProd += pixel;
	                                    }
	                                }
	                            }
	                            dx.set(dotProd * avgMultiplier, batch, dxDepth, dxRow, dxCol, channel);
	                        }
	                    }
	                }
	            }
	        }
	        return dx.toTensor();
	    };
	    MathBackendCPU.prototype.maxPool3d = function (x, convInfo) {
	        cpu_util_1.assertNotComplex(x, 'maxPool3d');
	        return this.pool3d(x, convInfo, 'max').toFloat();
	    };
	    MathBackendCPU.prototype.maxPool3dPositions = function (x, convInfo) {
	        var maxPositions = ops.buffer(convInfo.outShape, 'int32');
	        var strideDepth = convInfo.strideDepth;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var dilationDepth = convInfo.dilationDepth;
	        var dilationHeight = convInfo.dilationHeight;
	        var dilationWidth = convInfo.dilationWidth;
	        var effectiveFilterDepth = convInfo.effectiveFilterDepth;
	        var effectiveFilterHeight = convInfo.effectiveFilterHeight;
	        var effectiveFilterWidth = convInfo.effectiveFilterWidth;
	        var padFront = convInfo.padInfo.front;
	        var padTop = convInfo.padInfo.top;
	        var padLeft = convInfo.padInfo.left;
	        var xBuf = this.bufferSync(x);
	        for (var batch = 0; batch < convInfo.batchSize; ++batch) {
	            for (var channel = 0; channel < convInfo.inChannels; ++channel) {
	                for (var yDepth = 0; yDepth < convInfo.outDepth; ++yDepth) {
	                    var xDepthCorner = yDepth * strideDepth - padFront;
	                    var xDepthMin = xDepthCorner;
	                    while (xDepthMin < 0) {
	                        xDepthMin += dilationDepth;
	                    }
	                    var xDepthMax = Math.min(convInfo.inDepth, effectiveFilterDepth + xDepthCorner);
	                    for (var yRow = 0; yRow < convInfo.outHeight; ++yRow) {
	                        var xRowCorner = yRow * strideHeight - padTop;
	                        var xRowMin = xRowCorner;
	                        while (xRowMin < 0) {
	                            xRowMin += dilationHeight;
	                        }
	                        var xRowMax = Math.min(convInfo.inHeight, effectiveFilterHeight + xRowCorner);
	                        for (var yCol = 0; yCol < convInfo.outWidth; ++yCol) {
	                            var xColCorner = yCol * strideWidth - padLeft;
	                            var xColMin = xColCorner;
	                            while (xColMin < 0) {
	                                xColMin += dilationWidth;
	                            }
	                            var xColMax = Math.min(convInfo.inWidth, effectiveFilterWidth + xColCorner);
	                            // Shader code begins
	                            var maxValue = Number.NEGATIVE_INFINITY;
	                            var maxPosition = -1;
	                            for (var xDepth = xDepthMin; xDepth < xDepthMax; xDepth += dilationDepth) {
	                                var wDepth = xDepth - xDepthCorner;
	                                for (var xRow = xRowMin; xRow < xRowMax; xRow += dilationHeight) {
	                                    var wRow = xRow - xRowCorner;
	                                    for (var xCol = xColMin; xCol < xColMax; xCol += dilationWidth) {
	                                        var wCol = xCol - xColCorner;
	                                        var pixel = xBuf.get(batch, xDepth, xRow, xCol, channel);
	                                        if (pixel >= maxValue) {
	                                            maxValue = pixel;
	                                            maxPosition = wDepth * effectiveFilterHeight *
	                                                effectiveFilterWidth +
	                                                wRow * effectiveFilterHeight + wCol;
	                                        }
	                                    }
	                                }
	                            }
	                            maxPositions.set(maxPosition, batch, yDepth, yRow, yCol, channel);
	                        }
	                    }
	                }
	            }
	        }
	        return maxPositions.toTensor();
	    };
	    MathBackendCPU.prototype.maxPool3dBackprop = function (dy, x, y, convInfo) {
	        cpu_util_1.assertNotComplex([x, y], 'maxPool3dBackprop');
	        var maxPositions = this.maxPool3dPositions(x, convInfo);
	        var strideDepth = convInfo.strideDepth;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var dilationDepth = convInfo.dilationDepth;
	        var dilationHeight = convInfo.dilationHeight;
	        var dilationWidth = convInfo.dilationWidth;
	        var effectiveFilterDepth = convInfo.effectiveFilterDepth;
	        var effectiveFilterHeight = convInfo.effectiveFilterHeight;
	        var effectiveFilterWidth = convInfo.effectiveFilterWidth;
	        var padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
	        var padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
	        var padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
	        var dx = ops.buffer(x.shape, 'float32');
	        var maxPosBuf = this.bufferSync(maxPositions);
	        var dyBuf = this.bufferSync(dy);
	        for (var batch = 0; batch < convInfo.batchSize; ++batch) {
	            for (var channel = 0; channel < convInfo.inChannels; ++channel) {
	                for (var dxDepth = 0; dxDepth < convInfo.inDepth; ++dxDepth) {
	                    for (var dxRow = 0; dxRow < convInfo.inHeight; ++dxRow) {
	                        for (var dxCol = 0; dxCol < convInfo.inWidth; ++dxCol) {
	                            // Shader code begins
	                            var dyDepthCorner = dxDepth - padFront;
	                            var dyRowCorner = dxRow - padTop;
	                            var dyColCorner = dxCol - padLeft;
	                            var dotProd = 0;
	                            for (var wDepth = 0; wDepth < effectiveFilterDepth; wDepth += dilationDepth) {
	                                var dyDepth = (dyDepthCorner + wDepth) / strideDepth;
	                                if (dyDepth < 0 || dyDepth >= convInfo.outDepth ||
	                                    Math.floor(dyDepth) !== dyDepth) {
	                                    continue;
	                                }
	                                for (var wRow = 0; wRow < effectiveFilterHeight; wRow += dilationHeight) {
	                                    var dyRow = (dyRowCorner + wRow) / strideHeight;
	                                    if (dyRow < 0 || dyRow >= convInfo.outHeight ||
	                                        Math.floor(dyRow) !== dyRow) {
	                                        continue;
	                                    }
	                                    for (var wCol = 0; wCol < effectiveFilterWidth; wCol += dilationWidth) {
	                                        var dyCol = (dyColCorner + wCol) / strideWidth;
	                                        if (dyCol < 0 || dyCol >= convInfo.outWidth ||
	                                            Math.floor(dyCol) !== dyCol) {
	                                            continue;
	                                        }
	                                        var maxPos = effectiveFilterDepth *
	                                            effectiveFilterHeight * effectiveFilterWidth -
	                                            1 -
	                                            maxPosBuf.get(batch, dyDepth, dyRow, dyCol, channel);
	                                        var curPos = wDepth * effectiveFilterHeight * effectiveFilterWidth +
	                                            wRow * effectiveFilterWidth + wCol;
	                                        var mask = maxPos === curPos ? 1 : 0;
	                                        if (mask === 0) {
	                                            continue;
	                                        }
	                                        var pixel = dyBuf.get(batch, dyDepth, dyRow, dyCol, channel);
	                                        dotProd += pixel * mask;
	                                    }
	                                }
	                            }
	                            dx.set(dotProd, batch, dxDepth, dxRow, dxCol, channel);
	                        }
	                    }
	                }
	            }
	        }
	        return dx.toTensor();
	    };
	    MathBackendCPU.prototype.cast = function (x, dtype) {
	        return backend_util.castTensor(x, dtype, this);
	    };
	    MathBackendCPU.prototype.reshape = function (x, shape) {
	        return backend_util.reshapeTensor(x, shape);
	    };
	    MathBackendCPU.prototype.avgPool = function (x, convInfo) {
	        cpu_util_1.assertNotComplex(x, 'avgPool');
	        return this.pool(x, convInfo, 'avg').toFloat();
	    };
	    MathBackendCPU.prototype.resizeBilinear = function (x, newHeight, newWidth, alignCorners) {
	        cpu_util_1.assertNotComplex(x, 'resizeBilinear');
	        var _a = x.shape, batch = _a[0], oldHeight = _a[1], oldWidth = _a[2], numChannels = _a[3];
	        var xValues = this.readSync(x.dataId);
	        var result = new Float32Array(util.sizeFromShape([batch, newHeight, newWidth, numChannels]));
	        var effectiveInputSize = [
	            (alignCorners && newHeight > 1) ? oldHeight - 1 : oldHeight,
	            (alignCorners && newWidth > 1) ? oldWidth - 1 : oldWidth
	        ];
	        var effectiveOutputSize = [
	            (alignCorners && newHeight > 1) ? newHeight - 1 : newHeight,
	            (alignCorners && newWidth > 1) ? newWidth - 1 : newWidth
	        ];
	        var outputIdx = 0;
	        var effectiveRowSizeRatio = effectiveInputSize[0] / effectiveOutputSize[0];
	        var effectiveColSizeRatio = effectiveInputSize[1] / effectiveOutputSize[1];
	        for (var b = 0; b < batch; b++) {
	            for (var r = 0; r < newHeight; r++) {
	                var sourceFracRow = effectiveRowSizeRatio * r;
	                var sourceRowFloor = Math.floor(sourceFracRow);
	                var rowFrac = sourceFracRow - sourceRowFloor;
	                var sourceRowCeil = Math.min(oldHeight - 1, Math.ceil(sourceFracRow));
	                var topRowOffset = b * x.strides[0] + sourceRowFloor * x.strides[1];
	                var botRowOffset = b * x.strides[0] + sourceRowCeil * x.strides[1];
	                for (var c = 0; c < newWidth; c++) {
	                    var sourceFracCol = effectiveColSizeRatio * c;
	                    var sourceColFloor = Math.floor(sourceFracCol);
	                    var colFrac = sourceFracCol - sourceColFloor;
	                    var sourceColCeil = Math.min(oldWidth - 1, Math.ceil(sourceFracCol));
	                    var topLeftOffest = topRowOffset + sourceColFloor * x.strides[2];
	                    var botLeftOffset = botRowOffset + sourceColFloor * x.strides[2];
	                    var topRightOffset = topRowOffset + sourceColCeil * x.strides[2];
	                    var botRightOffest = botRowOffset + sourceColCeil * x.strides[2];
	                    for (var d = 0; d < numChannels; d++) {
	                        // Begin shader.
	                        // Compute the fractional index of the source.
	                        var topLeft = xValues[topLeftOffest + d];
	                        var bottomLeft = xValues[botLeftOffset + d];
	                        var topRight = xValues[topRightOffset + d];
	                        var bottomRight = xValues[botRightOffest + d];
	                        var top_1 = topLeft + (topRight - topLeft) * colFrac;
	                        var bottom = bottomLeft + (bottomRight - bottomLeft) * colFrac;
	                        var newValue = top_1 + (bottom - top_1) * rowFrac;
	                        result[outputIdx++] = newValue;
	                    }
	                }
	            }
	        }
	        return ops.tensor(result, [batch, newHeight, newWidth, numChannels]);
	    };
	    MathBackendCPU.prototype.resizeBilinearBackprop = function (dy, x, alignCorners) {
	        cpu_util_1.assertNotComplex([dy, x], 'resizeBilinearBackprop');
	        var _a = x.shape, batch = _a[0], xHeight = _a[1], xWidth = _a[2], depth = _a[3];
	        var _b = dy.shape, yHeight = _b[1], yWidth = _b[2];
	        var output = new Float32Array(batch * xHeight * xWidth * depth);
	        // In the backwards pass, we want to find the pixels that were generated
	        // for each pixel in the input image the forward pass and add the
	        // corresponding coefficient from dy to the gradient (with some
	        // interpolation).
	        var effectiveXSize = [
	            (alignCorners && yHeight > 1) ? xHeight - 1 : xHeight,
	            (alignCorners && yWidth > 1) ? xWidth - 1 : xWidth
	        ];
	        var effectiveYSize = [
	            (alignCorners && yHeight > 1) ? yHeight - 1 : yHeight,
	            (alignCorners && yWidth > 1) ? yWidth - 1 : yWidth
	        ];
	        var heightScale = effectiveXSize[0] / effectiveYSize[0];
	        var widthScale = effectiveXSize[1] / effectiveYSize[1];
	        // Reference implementation
	        // tslint:disable-next-line:max-line-length
	        // https://github.com/tensorflow/tensorflow/blob/3039375c86a5bbc9610c7725dcaa95d635f87ba2/tensorflow/core/kernels/resize_bilinear_op.cc#L275
	        var dyValues = this.readSync(dy.dataId);
	        var offset = 0;
	        for (var b = 0; b < batch; b++) {
	            var bOffset = b * x.strides[0];
	            for (var r = 0; r < yHeight; r++) {
	                var dxR = r * heightScale;
	                var topDxRIndex = Math.floor(dxR);
	                var bottomDxRIndex = Math.min(Math.ceil(dxR), xHeight - 1);
	                var topDxROffset = bOffset + topDxRIndex * x.strides[1];
	                var bottomDxROffset = bOffset + bottomDxRIndex * x.strides[1];
	                var dxRLerp = dxR - topDxRIndex;
	                var inverseDxRLerp = 1.0 - dxRLerp;
	                for (var c = 0; c < yWidth; c++) {
	                    var dxC = c * widthScale;
	                    var leftDxCIndex = Math.floor(dxC);
	                    var rightDxCIndex = Math.min(Math.ceil(dxC), xWidth - 1);
	                    var dxCLerp = dxC - leftDxCIndex;
	                    var inverseDxCLerp = 1.0 - dxCLerp;
	                    var topLeftRCOffset = topDxROffset + leftDxCIndex * x.strides[2];
	                    var topRightRCOffset = topDxROffset + rightDxCIndex * x.strides[2];
	                    var bottomLeftRCOffset = bottomDxROffset + leftDxCIndex * x.strides[2];
	                    var bottomRightRCOffset = bottomDxROffset + rightDxCIndex * x.strides[2];
	                    var inverseDxRLerpTimesInverseDxCLerp = inverseDxRLerp * inverseDxCLerp;
	                    var inverseDxRLerpTimesDxCLerp = inverseDxRLerp * dxCLerp;
	                    var dxRLerpTimesInverseDxCLerp = dxRLerp * inverseDxCLerp;
	                    var dxRLerpTimesDxCLerp = dxRLerp * dxCLerp;
	                    for (var d = 0; d < depth; d++) {
	                        var dyVal = dyValues[offset++];
	                        output[topLeftRCOffset + d] +=
	                            dyVal * inverseDxRLerpTimesInverseDxCLerp;
	                        output[topRightRCOffset + d] += dyVal * inverseDxRLerpTimesDxCLerp;
	                        output[bottomLeftRCOffset + d] +=
	                            dyVal * dxRLerpTimesInverseDxCLerp;
	                        output[bottomRightRCOffset + d] += dyVal * dxRLerpTimesDxCLerp;
	                    }
	                }
	            }
	        }
	        return ops.tensor4d(output, [batch, xWidth, xHeight, depth], x.dtype);
	    };
	    MathBackendCPU.prototype.resizeNearestNeighbor = function (x, newHeight, newWidth, alignCorners) {
	        cpu_util_1.assertNotComplex(x, 'resizeNearestNeighbor');
	        var _a = x.shape, batch = _a[0], oldHeight = _a[1], oldWidth = _a[2], numChannels = _a[3];
	        var xValues = this.readSync(x.dataId);
	        var output = new Float32Array(batch * newHeight * newWidth * numChannels);
	        var effectiveInputSize = [
	            (alignCorners && newHeight > 1) ? oldHeight - 1 : oldHeight,
	            (alignCorners && newWidth > 1) ? oldWidth - 1 : oldWidth
	        ];
	        var effectiveOutputSize = [
	            (alignCorners && newHeight > 1) ? newHeight - 1 : newHeight,
	            (alignCorners && newWidth > 1) ? newWidth - 1 : newWidth
	        ];
	        var effectiveRowSizeRatio = effectiveInputSize[0] / effectiveOutputSize[0];
	        var effectiveColSizeRatio = effectiveInputSize[1] / effectiveOutputSize[1];
	        var outputOffset = 0;
	        for (var b = 0; b < batch; b++) {
	            var batchOffset = b * x.strides[0];
	            for (var r = 0; r < newHeight; r++) {
	                var sourceFracRow = effectiveRowSizeRatio * r;
	                var sourceNearestRow = Math.min(oldHeight - 1, alignCorners ? Math.round(sourceFracRow) :
	                    Math.floor(sourceFracRow));
	                var rowOffset = batchOffset + sourceNearestRow * x.strides[1];
	                for (var c = 0; c < newWidth; c++) {
	                    var sourceFracCol = effectiveColSizeRatio * c;
	                    var sourceNearestCol = Math.min(oldWidth - 1, alignCorners ? Math.round(sourceFracCol) :
	                        Math.floor(sourceFracCol));
	                    var colOffset = rowOffset + sourceNearestCol * x.strides[2];
	                    for (var d = 0; d < numChannels; d++) {
	                        // Begin shader.
	                        // Compute the fractional index of the source.
	                        var newVal = xValues[colOffset + d];
	                        output[outputOffset++] = newVal;
	                    }
	                }
	            }
	        }
	        return ops.tensor(output, [batch, newHeight, newWidth, numChannels], x.dtype);
	    };
	    MathBackendCPU.prototype.resizeNearestNeighborBackprop = function (dy, x, alignCorners) {
	        cpu_util_1.assertNotComplex([dy, x], 'resizeNearestNeighborBackprop');
	        var _a = x.shape, batch = _a[0], xHeight = _a[1], xWidth = _a[2], depth = _a[3];
	        var _b = dy.shape, yHeight = _b[1], yWidth = _b[2];
	        var output = new Float32Array(batch * xHeight * xWidth * depth);
	        var dyValues = this.readSync(dy.dataId);
	        // In the backwards pass, we want to find the pixels that were generated
	        // for each pixel in the input image the forward pass
	        var effectiveXSize = [
	            (alignCorners && yHeight > 1) ? xHeight - 1 : xHeight,
	            (alignCorners && yWidth > 1) ? xWidth - 1 : xWidth
	        ];
	        var effectiveYSize = [
	            (alignCorners && yHeight > 1) ? yHeight - 1 : yHeight,
	            (alignCorners && yWidth > 1) ? yWidth - 1 : yWidth
	        ];
	        var heightScale = effectiveXSize[0] / effectiveYSize[0];
	        var widthScale = effectiveXSize[1] / effectiveYSize[1];
	        var invHeightScale = 1 / heightScale;
	        var invWidthScale = 1 / widthScale;
	        // This defines the size of the window of values around a particular
	        // index in dy that we want to search for contributions to dx.
	        var winHeight = (Math.ceil(invHeightScale) * 2) + 2;
	        var winWidth = (Math.ceil(invWidthScale) * 2) + 2;
	        // Loop over the output space.
	        for (var b = 0; b < batch; b++) {
	            var batchOffset = b * x.strides[0];
	            for (var r = 0; r < xHeight; r++) {
	                var rowOffset = batchOffset + r * x.strides[1];
	                // Compute bounds for where in dy we will look
	                var startRLerp = Math.floor(r * invHeightScale);
	                var startDyR = Math.floor(startRLerp - (winHeight / 2));
	                for (var c = 0; c < xWidth; c++) {
	                    var colOffset = rowOffset + c * x.strides[2];
	                    // Compute bounds for where in dy we will look
	                    var startCLerp = Math.floor(c * invWidthScale);
	                    var startDyC = Math.floor(startCLerp - (winWidth / 2));
	                    for (var d = 0; d < depth; d++) {
	                        var accum = 0;
	                        // loop over dy
	                        for (var dyRIndex = 0; dyRIndex < winHeight; dyRIndex++) {
	                            var dyR = dyRIndex + startDyR;
	                            // Guard against the window exceeding the bounds of dy
	                            if (dyR < 0 || dyR >= yHeight) {
	                                continue;
	                            }
	                            var dyROffset = batchOffset + dyR * dy.strides[1];
	                            var sourceFracRow = dyR * heightScale;
	                            var sourceNearestRow = Math.min(xHeight - 1, alignCorners ? Math.round(sourceFracRow) :
	                                Math.floor(sourceFracRow));
	                            if (r !== sourceNearestRow) {
	                                continue;
	                            }
	                            for (var dyCIndex = 0; dyCIndex < winWidth; dyCIndex++) {
	                                var dyC = dyCIndex + startDyC;
	                                // Guard against the window exceeding the bounds of dy
	                                if (dyC < 0 || dyC >= yWidth) {
	                                    continue;
	                                }
	                                var dyCOffset = dyROffset + dyC * dy.strides[2];
	                                var sourceFracCol = dyC * widthScale;
	                                var sourceNearestCol = Math.min(xWidth - 1, alignCorners ? Math.round(sourceFracCol) :
	                                    Math.floor(sourceFracCol));
	                                if (c === sourceNearestCol) {
	                                    accum += dyValues[dyCOffset + d];
	                                }
	                            }
	                        }
	                        output[colOffset + d] = accum;
	                    }
	                }
	            }
	        }
	        return ops.tensor4d(output, x.shape, x.dtype);
	    };
	    MathBackendCPU.prototype.batchNormalization = function (x, mean, variance, varianceEpsilon, scale, offset) {
	        cpu_util_1.assertNotComplex([x, mean, variance, scale, offset], 'batchNorm');
	        var xVals = this.readSync(x.dataId);
	        var mVals = this.readSync(mean.dataId);
	        var varVals = this.readSync(variance.dataId);
	        var sVals = scale ? this.readSync(scale.dataId) :
	            new Float32Array([1]);
	        var offVals = offset ? this.readSync(offset.dataId) :
	            new Float32Array([0]);
	        var outVals = new Float32Array(xVals.length);
	        var offValsLength = offVals.length;
	        var sValsLength = sVals.length;
	        var varValsLength = varVals.length;
	        var mValsLength = mVals.length;
	        var offi = 0;
	        var mi = 0;
	        var si = 0;
	        var vi = 0;
	        for (var i = 0; i < xVals.length; ++i) {
	            outVals[i] = offVals[offi++] +
	                (xVals[i] - mVals[mi++]) * sVals[si++] /
	                    Math.sqrt(varVals[vi++] + varianceEpsilon);
	            if (offi >= offValsLength) {
	                offi = 0;
	            }
	            if (mi >= mValsLength) {
	                mi = 0;
	            }
	            if (si >= sValsLength) {
	                si = 0;
	            }
	            if (vi >= varValsLength) {
	                vi = 0;
	            }
	        }
	        return ops_1.tensor4d(outVals, x.shape);
	    };
	    MathBackendCPU.prototype.localResponseNormalization4D = function (x, depthRadius, bias, alpha, beta) {
	        cpu_util_1.assertNotComplex(x, 'localResponseNormalization4D');
	        var channels = x.shape[3];
	        var maxD = channels - 1;
	        var xValues = this.readSync(x.dataId);
	        var size = x.size;
	        var result = new Float32Array(size);
	        function sumAcrossChannels(offset) {
	            var currentChannel = offset % channels;
	            var beginSumOffset = offset - currentChannel + Math.max(0, currentChannel - depthRadius);
	            var endSumOffset = offset - currentChannel +
	                Math.min(currentChannel + depthRadius, maxD);
	            var sum = 0.0;
	            for (; beginSumOffset <= endSumOffset; beginSumOffset++) {
	                var z = xValues[beginSumOffset];
	                sum += z * z;
	            }
	            return sum;
	        }
	        for (var offset = 0; offset < size; offset++) {
	            var sum = sumAcrossChannels(offset);
	            var val = xValues[offset] * Math.pow(bias + alpha * sum, -beta);
	            result[offset] = val;
	        }
	        return ops.tensor4d(result, x.shape);
	    };
	    MathBackendCPU.prototype.LRNGrad = function (dy, inputImage, outputImage, depthRadius, bias, alpha, beta) {
	        cpu_util_1.assertNotComplex(dy, 'LRNGrad');
	        var channels = dy.shape[3];
	        var dyValues = this.readSync(dy.dataId);
	        var inputImageValues = this.readSync(inputImage.dataId);
	        var outputImageValues = this.readSync(outputImage.dataId);
	        var result = new Float32Array(dy.size);
	        var size = dy.size;
	        for (var offset = 0; offset < size; offset++) {
	            var currentChannel = offset % channels;
	            var depthBegin = (offset - currentChannel) + Math.max(0, currentChannel - depthRadius);
	            var depthEnd = (offset - currentChannel) +
	                Math.min(channels, currentChannel + depthRadius + 1);
	            var norm = 0;
	            for (var k = depthBegin; k < depthEnd; k++) {
	                norm += Math.pow(inputImageValues[k], 2);
	            }
	            norm = alpha * norm + bias;
	            for (var k = depthBegin; k < depthEnd; k++) {
	                var dyi = -2 * alpha * beta * inputImageValues[k] *
	                    outputImageValues[offset] / norm;
	                if (offset === k) {
	                    dyi += Math.pow(norm, -beta);
	                }
	                dyi *= dyValues[offset];
	                result[k] += dyi;
	            }
	        }
	        return ops.tensor4d(result, dy.shape);
	    };
	    MathBackendCPU.prototype.multinomial = function (logits, normalized, numSamples, seed) {
	        cpu_util_1.assertNotComplex(logits, 'multinomial');
	        var probabilities = normalized ? logits : ops.softmax(logits);
	        var batchSize = probabilities.shape[0];
	        var numEvents = probabilities.shape[1];
	        var res = ops.zeros([batchSize, numSamples], 'int32');
	        var resVals = this.readSync(res.dataId);
	        var probVals = this.readSync(probabilities.dataId);
	        for (var b = 0; b < batchSize; ++b) {
	            var offset = b * numEvents;
	            // The cdf won't include the last event. It will be implicit if no other
	            // event happened.
	            var cdf = new Float32Array(numEvents - 1);
	            cdf[0] = probVals[offset];
	            for (var event_1 = 1; event_1 < cdf.length; ++event_1) {
	                cdf[event_1] = cdf[event_1 - 1] + probVals[offset + event_1];
	            }
	            var random = seedrandom.alea(seed.toString());
	            var outOffset = b * numSamples;
	            for (var sampleId = 0; sampleId < numSamples; ++sampleId) {
	                var r = random();
	                // Assume last event happened by default.
	                resVals[outOffset + sampleId] = cdf.length;
	                for (var event_2 = 0; event_2 < cdf.length; event_2++) {
	                    if (r < cdf[event_2]) {
	                        resVals[outOffset + sampleId] = event_2;
	                        break;
	                    }
	                }
	            }
	        }
	        return res;
	    };
	    MathBackendCPU.prototype.oneHot = function (indices, depth, onValue, offValue) {
	        cpu_util_1.assertNotComplex(indices, 'oneHot');
	        var res = new Float32Array(indices.size * depth);
	        res.fill(offValue);
	        var indicesVal = this.readSync(indices.dataId);
	        for (var event_3 = 0; event_3 < indices.size; ++event_3) {
	            if (indicesVal[event_3] >= 0 && indicesVal[event_3] < depth) {
	                res[event_3 * depth + indicesVal[event_3]] = onValue;
	            }
	        }
	        return ops.tensor2d(res, [indices.size, depth], 'int32');
	    };
	    MathBackendCPU.prototype.nonMaxSuppression = function (boxes, scores, maxOutputSize, iouThreshold, scoreThreshold) {
	        cpu_util_1.assertNotComplex(boxes, 'nonMaxSuppression');
	        var boxesVals = this.readSync(boxes.dataId);
	        var scoresVals = this.readSync(scores.dataId);
	        return non_max_suppression_impl_1.nonMaxSuppressionV3(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold);
	    };
	    MathBackendCPU.prototype.fft = function (x) {
	        return this.fftBatch(x, false);
	    };
	    MathBackendCPU.prototype.ifft = function (x) {
	        return this.fftBatch(x, true);
	    };
	    /**
	     * Calculate FFT of inner most elements of batch tensor.
	     */
	    MathBackendCPU.prototype.fftBatch = function (x, inverse) {
	        var batch = x.shape[0];
	        var innerDim = x.shape[1];
	        // Collects real and imaginary values separately.
	        var realResult = ops.buffer(x.shape, 'float32');
	        var imagResult = ops.buffer(x.shape, 'float32');
	        var real = ops.real(x).as2D(batch, innerDim);
	        var imag = ops.imag(x).as2D(batch, innerDim);
	        for (var b = 0; b < batch; b++) {
	            // TODO: Support slice ops for complex type.
	            var r = real.slice([b, 0], [1, innerDim]);
	            var i = imag.slice([b, 0], [1, innerDim]);
	            var input = ops.complex(r, i);
	            // Run FFT by batch element.
	            var res = this.readSync(this.fftImpl(input, inverse).dataId);
	            for (var d = 0; d < innerDim; d++) {
	                var c = complex_util.getComplexWithIndex(res, d);
	                realResult.values[b * innerDim + d] = c.real;
	                imagResult.values[b * innerDim + d] = c.imag;
	            }
	        }
	        var t = ops.complex(realResult.toTensor(), imagResult.toTensor());
	        return t.as2D(batch, innerDim);
	    };
	    MathBackendCPU.prototype.fftImpl = function (x, inverse) {
	        var x1D = x.as1D();
	        var n = x1D.size;
	        if (this.isExponentOf2(n)) {
	            var result = this.fftRadix2(x1D, n, inverse).as2D(x.shape[0], x.shape[1]);
	            if (inverse) {
	                result = ops.complex(ops.real(result).div(ops_1.scalar(n)), ops.imag(result).div(ops_1.scalar(n)));
	            }
	            return result;
	        }
	        else {
	            var data = this.readSync(x.dataId);
	            var rawOutput = this.fourierTransformByMatmul(data, n, inverse);
	            var output = complex_util.splitRealAndImagArrays(rawOutput);
	            return ops.complex(output.real, output.imag).as2D(x.shape[0], x.shape[1]);
	        }
	    };
	    MathBackendCPU.prototype.isExponentOf2 = function (size) {
	        return (size & size - 1) === 0;
	    };
	    // FFT using Cooley-Tukey algorithm on radix 2 dimensional input.
	    MathBackendCPU.prototype.fftRadix2 = function (input, size, inverse) {
	        if (size === 1) {
	            return input;
	        }
	        var data = this.readSync(input.dataId);
	        var half = size / 2;
	        var evenComplex = complex_util.complexWithEvenIndex(data);
	        var evenTensor = ops.complex(evenComplex.real, evenComplex.imag).as1D();
	        var oddComplex = complex_util.complexWithOddIndex(data);
	        var oddTensor = ops.complex(oddComplex.real, oddComplex.imag).as1D();
	        // Recursive call for half part of original input.
	        evenTensor = this.fftRadix2(evenTensor, half, inverse);
	        oddTensor = this.fftRadix2(oddTensor, half, inverse);
	        var e = complex_util.exponents(size, inverse);
	        var exponent = ops.complex(e.real, e.imag).mul(oddTensor);
	        var addPart = evenTensor.add(exponent);
	        var subPart = evenTensor.sub(exponent);
	        var realTensor = ops.real(addPart).concat(ops.real(subPart));
	        var imagTensor = ops.imag(addPart).concat(ops.imag(subPart));
	        return ops.complex(realTensor, imagTensor).as1D();
	    };
	    // Calculate fourier transform by multplying sinusoid matrix.
	    MathBackendCPU.prototype.fourierTransformByMatmul = function (data, size, inverse) {
	        var ret = new Float32Array(size * 2);
	        // TODO: Use matmul instead once it supports complex64 type.
	        for (var r = 0; r < size; r++) {
	            var real_2 = 0.0;
	            var imag_2 = 0.0;
	            for (var c = 0; c < size; c++) {
	                var e = complex_util.exponent(r * c, size, inverse);
	                var term = complex_util.getComplexWithIndex(data, c);
	                real_2 += term.real * e.real - term.imag * e.imag;
	                imag_2 += term.real * e.imag + term.imag * e.real;
	            }
	            if (inverse) {
	                real_2 /= size;
	                imag_2 /= size;
	            }
	            complex_util.assignToTypedArray(ret, real_2, imag_2, r);
	        }
	        return ret;
	    };
	    MathBackendCPU.prototype.depthToSpace = function (x, blockSize, dataFormat) {
	        util.assert(dataFormat === 'NHWC', function () { return "Only NHWC dataFormat supported on CPU for depthToSpace. Got " + dataFormat; });
	        util.assert(blockSize > 1, function () {
	            return "blockSize should be > 1 for depthToSpace, but was: " + blockSize;
	        });
	        var batchSize = x.shape[0];
	        var inputHeight = x.shape[1];
	        var inputWidth = x.shape[2];
	        var inputDepth = x.shape[3];
	        var outputHeight = inputHeight * blockSize;
	        var outputWidth = inputWidth * blockSize;
	        var outputDepth = inputDepth / (blockSize * blockSize);
	        var xValues = this.readSync(x.dataId);
	        var result = new Float32Array(batchSize * outputHeight * outputWidth * outputDepth);
	        var outputIdx = 0;
	        for (var b = 0; b < batchSize; ++b) {
	            for (var h = 0; h < outputHeight; ++h) {
	                var inH = Math.floor(h / blockSize);
	                var offsetH = (h % blockSize);
	                for (var w = 0; w < outputWidth; ++w) {
	                    var inW = Math.floor(w / blockSize);
	                    var offsetW = (w % blockSize);
	                    var offsetD = (offsetH * blockSize + offsetW) * outputDepth;
	                    for (var d = 0; d < outputDepth; ++d) {
	                        var inD = d + offsetD;
	                        var inputIdx = inD + inputDepth * (inW + inputWidth * (inH + inputHeight * b));
	                        result[outputIdx++] = xValues[inputIdx];
	                    }
	                }
	            }
	        }
	        return ops.tensor4d(result, [batchSize, outputHeight, outputWidth, outputDepth]);
	    };
	    MathBackendCPU.prototype.broadcastedBinaryOp = function (a, b, dtype, op) {
	        var newShape = broadcast_util.assertAndGetBroadcastShape(a.shape, b.shape);
	        var result = ops.buffer(newShape, dtype);
	        var aVals = this.readSync(a.dataId);
	        var bVals = this.readSync(b.dataId);
	        var aBroadcastDims = broadcast_util.getBroadcastDims(a.shape, newShape);
	        var bBroadcastDims = broadcast_util.getBroadcastDims(b.shape, newShape);
	        var resVals = result.values;
	        if (aBroadcastDims.length + bBroadcastDims.length === 0) {
	            for (var i = 0; i < resVals.length; ++i) {
	                resVals[i] = op(aVals[i % aVals.length], bVals[i % bVals.length]);
	            }
	        }
	        else {
	            var aBuf = this.bufferSync(a);
	            var bBuf = this.bufferSync(b);
	            var _loop_2 = function (i) {
	                var loc = result.indexToLoc(i);
	                var aLoc = loc.slice(-a.rank);
	                aBroadcastDims.forEach(function (d) { return aLoc[d] = 0; });
	                var aIndex = aBuf.locToIndex(aLoc);
	                var bLoc = loc.slice(-b.rank);
	                bBroadcastDims.forEach(function (d) { return bLoc[d] = 0; });
	                var bIndex = bBuf.locToIndex(bLoc);
	                resVals[i] = op(aVals[aIndex], bVals[bIndex]);
	            };
	            for (var i = 0; i < resVals.length; ++i) {
	                _loop_2(i);
	            }
	        }
	        return result.toTensor();
	    };
	    MathBackendCPU.prototype.broadcastedBinaryComplexOp = function (a, b, op) {
	        var newShape = broadcast_util.assertAndGetBroadcastShape(a.shape, b.shape);
	        var realResult = ops.buffer(newShape, 'float32');
	        var imagResult = ops.buffer(newShape, 'float32');
	        var aVals = this.readSync(a.dataId);
	        var bVals = this.readSync(b.dataId);
	        var aBroadcastDims = broadcast_util.getBroadcastDims(a.shape, newShape);
	        var bBroadcastDims = broadcast_util.getBroadcastDims(b.shape, newShape);
	        var realVals = realResult.values;
	        var imagVals = imagResult.values;
	        if (aBroadcastDims.length + bBroadcastDims.length === 0) {
	            for (var i = 0; i < realVals.length; i++) {
	                var aIdx = i % aVals.length;
	                var bIdx = i % bVals.length;
	                var result = op(aVals[aIdx * 2], aVals[aIdx * 2 + 1], bVals[bIdx * 2], bVals[bIdx * 2 + 1]);
	                realVals[i] = result.real;
	                imagVals[i] = result.imag;
	            }
	        }
	        else {
	            var aRealBuf = this.bufferSync(this.data.get(a.dataId).complexTensors.real);
	            var bRealBuf = this.bufferSync(this.data.get(b.dataId).complexTensors.real);
	            var _loop_3 = function (i) {
	                var loc = realResult.indexToLoc(i);
	                var aLoc = loc.slice(-a.rank);
	                aBroadcastDims.forEach(function (d) { return aLoc[d] = 0; });
	                var aIndex = aRealBuf.locToIndex(aLoc);
	                var bLoc = loc.slice(-b.rank);
	                bBroadcastDims.forEach(function (d) { return bLoc[d] = 0; });
	                var bIndex = bRealBuf.locToIndex(bLoc);
	                var opResult = op(aVals[aIndex * 2], aVals[aIndex * 2 + 1], bVals[bIndex * 2], bVals[bIndex * 2 + 1]);
	                realVals[i] = opResult.real;
	                imagVals[i] = opResult.imag;
	            };
	            for (var i = 0; i < realVals.length; i++) {
	                _loop_3(i);
	            }
	        }
	        return this.complex(realResult.toTensor(), imagResult.toTensor());
	    };
	    MathBackendCPU.prototype.split = function (x, sizeSplits, axis) {
	        return split_shared_1.split(x, sizeSplits, axis);
	    };
	    MathBackendCPU.prototype.dispose = function () { };
	    MathBackendCPU.prototype.floatPrecision = function () {
	        return 32;
	    };
	    /** Returns the smallest representable number.  */
	    MathBackendCPU.prototype.epsilon = function () {
	        return backend_1.EPSILON_FLOAT32;
	    };
	    MathBackendCPU.prototype.cropAndResize = function (images, boxes, boxIndex, cropSize, method, extrapolationValue) {
	        var _a = images.shape, batch = _a[0], imageHeight = _a[1], imageWidth = _a[2], numChannels = _a[3];
	        var numBoxes = boxes.shape[0];
	        var cropHeight = cropSize[0], cropWidth = cropSize[1];
	        var output = ops.buffer([numBoxes, cropHeight, cropWidth, numChannels], 'float32');
	        var boxVals = this.readSync(boxes.dataId);
	        var boxIndVals = this.readSync(boxIndex.dataId);
	        var imageVals = this.readSync(images.dataId);
	        var inStride = images.strides; // to calculate flat indexes into image
	        var outStride = output.strides; // to calculate flat indexes into output
	        // Reference implementation
	        // tslint:disable-next-line:max-line-length
	        // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/crop_and_resize_op.cc
	        for (var b = 0; b < numBoxes; b++) {
	            var startInd = b * 4;
	            var y1 = boxVals[startInd];
	            var x1 = boxVals[startInd + 1];
	            var y2 = boxVals[startInd + 2];
	            var x2 = boxVals[startInd + 3];
	            var bInd = boxIndVals[b];
	            if (bInd >= batch) {
	                continue;
	            }
	            var heightScale = (cropHeight > 1) ?
	                (y2 - y1) * (imageHeight - 1) / (cropHeight - 1) :
	                0;
	            var widthScale = (cropWidth > 1) ? (x2 - x1) * (imageWidth - 1) / (cropWidth - 1) : 0;
	            for (var y = 0; y < cropHeight; y++) {
	                var yInd = (cropHeight > 1) ?
	                    y1 * (imageHeight - 1) + y * (heightScale) :
	                    0.5 * (y1 + y2) * (imageHeight - 1);
	                if (yInd < 0 || yInd > imageHeight - 1) {
	                    for (var x = 0; x < cropWidth; x++) {
	                        for (var c = 0; c < numChannels; c++) {
	                            var ind = c + x * outStride[2] + y * outStride[1] + b * outStride[0];
	                            output.values[ind] = extrapolationValue;
	                        }
	                    }
	                    continue;
	                }
	                if (method === 'bilinear') {
	                    var topInd = Math.floor(yInd);
	                    var bottomInd = Math.ceil(yInd);
	                    var yLerp = yInd - topInd;
	                    for (var x = 0; x < cropWidth; x++) {
	                        var xInd = (cropWidth > 1) ?
	                            x1 * (imageWidth - 1) + x * widthScale :
	                            0.5 * (x1 + x2) * (imageWidth - 1);
	                        if (xInd < 0 || xInd > imageWidth - 1) {
	                            for (var c = 0; c < numChannels; c++) {
	                                var ind = c + x * outStride[2] + y * outStride[1] + b * outStride[0];
	                                output.values[ind] = extrapolationValue;
	                            }
	                            continue;
	                        }
	                        var leftInd = Math.floor(xInd);
	                        var rightInd = Math.ceil(xInd);
	                        var xLerp = xInd - leftInd;
	                        for (var c = 0; c < numChannels; c++) {
	                            var ind = c + leftInd * inStride[2] + topInd * inStride[1] +
	                                bInd * inStride[0];
	                            var topLeft = imageVals[ind];
	                            ind = c + rightInd * inStride[2] + topInd * inStride[1] +
	                                bInd * inStride[0];
	                            var topRight = imageVals[ind];
	                            ind = c + leftInd * inStride[2] + bottomInd * inStride[1] +
	                                bInd * inStride[0];
	                            var bottomLeft = imageVals[ind];
	                            ind = c + rightInd * inStride[2] + bottomInd * inStride[1] +
	                                bInd * inStride[0];
	                            var bottomRight = imageVals[ind];
	                            var top_2 = topLeft + (topRight - topLeft) * xLerp;
	                            var bottom = bottomLeft + (bottomRight - bottomLeft) * xLerp;
	                            ind = c + x * outStride[2] + y * outStride[1] + b * outStride[0];
	                            output.values[ind] = top_2 + ((bottom - top_2) * yLerp);
	                        }
	                    }
	                }
	                else { // method == "nearest"
	                    for (var x = 0; x < cropWidth; ++x) {
	                        var xInd = (cropWidth > 1) ?
	                            x1 * (imageWidth - 1) + x * widthScale :
	                            0.5 * (x1 + x2) * (imageWidth - 1);
	                        if (xInd < 0 || xInd > imageWidth - 1) {
	                            for (var c = 0; c < numChannels; c++) {
	                                var ind = c + x * outStride[2] + y * outStride[1] + b * outStride[0];
	                                output.values[ind] = extrapolationValue;
	                            }
	                            continue;
	                        }
	                        var closestX = Math.round(xInd);
	                        var closestY = Math.round(yInd);
	                        for (var c = 0; c < numChannels; c++) {
	                            var inInd = c + closestX * inStride[2] +
	                                closestY * inStride[1] + bInd * inStride[0];
	                            var outInd = c + x * outStride[2] + y * outStride[1] + b * outStride[0];
	                            output.values[outInd] = imageVals[inInd];
	                        }
	                    }
	                }
	            }
	        }
	        return output.toTensor();
	    };
	    MathBackendCPU.prototype.sparseToDense = function (sparseIndices, sparseValues, outputShape, defaultValue) {
	        var _a = scatter_nd_util.calculateShapes(sparseValues, sparseIndices, outputShape), sliceRank = _a.sliceRank, numUpdates = _a.numUpdates, sliceSize = _a.sliceSize, strides = _a.strides, outputSize = _a.outputSize;
	        var sumDupeIndices = false;
	        return this.scatter(sparseIndices, sparseValues, outputShape, outputSize, sliceSize, numUpdates, sliceRank, strides, defaultValue, sumDupeIndices);
	    };
	    MathBackendCPU.prototype.gatherND = function (x, indices) {
	        var indicesShape = indices.shape;
	        var sliceRank = indicesShape[indicesShape.length - 1];
	        var _a = gather_nd_util.prepareAndValidate(x, indices), resultShape = _a[0], numSlices = _a[1], sliceSize = _a[2], strides = _a[3];
	        if (numSlices === 0) {
	            return ops_1.tensor([], resultShape, x.dtype);
	        }
	        var buffer = new tensor_1.TensorBuffer([numSlices, sliceSize], x.dtype);
	        var indicesData = this.readSync(indices.dataId);
	        var xData = this.readSync(x.dataId);
	        for (var i = 0; i < numSlices; i++) {
	            var index = [];
	            var flattenIndex = 0;
	            for (var j = 0; j < sliceRank; j++) {
	                var dim = indicesData[i * sliceRank + j];
	                flattenIndex += dim * strides[j];
	                index.push(dim);
	            }
	            if (flattenIndex < 0 || flattenIndex >= x.size / sliceSize) {
	                throw new Error("Invalid indices: " + index + " does not index into " + x.shape);
	            }
	            for (var k = 0; k < sliceSize; k++) {
	                buffer.values[i * sliceSize + k] = xData[flattenIndex * sliceSize + k];
	            }
	        }
	        return buffer.toTensor().reshape(resultShape);
	    };
	    MathBackendCPU.prototype.scatterND = function (indices, updates, shape) {
	        var _a = scatter_nd_util.calculateShapes(updates, indices, shape), sliceRank = _a.sliceRank, numUpdates = _a.numUpdates, sliceSize = _a.sliceSize, strides = _a.strides, outputSize = _a.outputSize;
	        var defaultValue = ops_1.scalar(0);
	        var sumDupeIndices = true;
	        return this.scatter(indices, updates, shape, outputSize, sliceSize, numUpdates, sliceRank, strides, defaultValue, sumDupeIndices);
	    };
	    MathBackendCPU.prototype.fill = function (shape, value, dtype) {
	        dtype = dtype || util_1.inferDtype(value);
	        var values = util_1.getArrayFromDType(dtype, util_1.sizeFromShape(shape));
	        values.fill(value);
	        return engine_1.ENGINE.makeTensor(values, shape, dtype, this);
	    };
	    MathBackendCPU.prototype.onesLike = function (x) {
	        if (x.dtype === 'string') {
	            throw new Error('onesLike is not supported for string tensors');
	        }
	        else {
	            return this.fill(x.shape, 1, x.dtype);
	        }
	    };
	    MathBackendCPU.prototype.zerosLike = function (x) {
	        var values = util_1.getArrayFromDType(x.dtype, util_1.sizeFromShape(x.shape));
	        return this.makeOutput(values, x.shape, x.dtype);
	    };
	    MathBackendCPU.prototype.linspace = function (start, stop, num) {
	        return backend_util.linspaceImpl(start, stop, num);
	    };
	    MathBackendCPU.prototype.scatter = function (indices, updates, shape, outputSize, sliceSize, numUpdates, sliceRank, strides, defaultValue, sumDupeIndices) {
	        var flattenShape = [outputSize / sliceSize, sliceSize];
	        var indicesData = this.readSync(indices.dataId);
	        var updatesData = this.readSync(updates.dataId);
	        if (outputSize === 0) {
	            return ops_1.tensor([], shape, updates.dtype);
	        }
	        var buffer = new tensor_1.TensorBuffer(flattenShape, updates.dtype);
	        buffer.values.fill(this.readSync(defaultValue.dataId)[0]);
	        for (var i = 0; i < numUpdates; i++) {
	            var index = [];
	            var flattenIndex = 0;
	            for (var j = 0; j < sliceRank; j++) {
	                var dim = indicesData[i * sliceRank + j];
	                index.push(dim);
	                flattenIndex += dim * strides[j];
	            }
	            if (flattenIndex < 0 || flattenIndex >= outputSize / sliceSize) {
	                throw new Error("Invalid indices: " + index + " does not index into " + shape);
	            }
	            for (var k = 0; k < sliceSize; k++) {
	                if (sumDupeIndices) {
	                    buffer.values[flattenIndex * sliceSize + k] +=
	                        updatesData[i * sliceSize + k];
	                }
	                else {
	                    buffer.values[flattenIndex * sliceSize + k] = updates.rank === 0 ?
	                        updatesData[0] :
	                        updatesData[i * sliceSize + k];
	                }
	            }
	        }
	        return buffer.toTensor().reshape(shape);
	    };
	    return MathBackendCPU;
	}(backend_1.KernelBackend));
	exports.MathBackendCPU = MathBackendCPU;
	engine_1.ENGINE.registerBackend('cpu', function () { return new MathBackendCPU(); }, 1 /* priority */);
	//# sourceMappingURL=backend_cpu.js.map

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var kernel_names_1 = __webpack_require__(88);
	var non_max_suppression_impl_1 = __webpack_require__(188);
	var cpu_util_1 = __webpack_require__(235);
	exports.nonMaxSuppressionV5Config = {
	    kernelName: kernel_names_1.NonMaxSuppressionV5,
	    backendName: 'cpu',
	    kernelFunc: function (_a) {
	        var inputs = _a.inputs, backend = _a.backend, attrs = _a.attrs;
	        var _b = inputs, boxes = _b.boxes, scores = _b.scores;
	        var _c = attrs, maxOutputSize = _c.maxOutputSize, iouThreshold = _c.iouThreshold, scoreThreshold = _c.scoreThreshold, softNmsSigma = _c.softNmsSigma;
	        var cpuBackend = backend;
	        cpu_util_1.assertNotComplex(boxes, 'NonMaxSuppressionWithScore');
	        var boxesVals = cpuBackend.data.get(boxes.dataId).values;
	        var scoresVals = cpuBackend.data.get(scores.dataId).values;
	        var maxOutputSizeVal = maxOutputSize;
	        var iouThresholdVal = iouThreshold;
	        var scoreThresholdVal = scoreThreshold;
	        var softNmsSigmaVal = softNmsSigma;
	        var _d = non_max_suppression_impl_1.nonMaxSuppressionV5(boxesVals, scoresVals, maxOutputSizeVal, iouThresholdVal, scoreThresholdVal, softNmsSigmaVal), selectedIndices = _d.selectedIndices, selectedScores = _d.selectedScores;
	        return [selectedIndices, selectedScores];
	    }
	};
	//# sourceMappingURL=NonMaxSuppressionV5.js.map

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var kernel_names_1 = __webpack_require__(88);
	var cpu_util_1 = __webpack_require__(235);
	exports.squareConfig = {
	    kernelName: kernel_names_1.Square,
	    backendName: 'cpu',
	    kernelFunc: function (_a) {
	        var inputs = _a.inputs, backend = _a.backend;
	        var x = inputs.x;
	        var cpuBackend = backend;
	        cpu_util_1.assertNotComplex(x, 'square');
	        var values = cpuBackend.data.get(x.dataId).values;
	        var newValues = new Float32Array(values.length);
	        for (var i = 0; i < values.length; ++i) {
	            var value = values[i];
	            newValues[i] = value * value;
	        }
	        var dataId = cpuBackend.write(newValues, x.shape, x.dtype);
	        return { dataId: dataId, shape: x.shape, dtype: x.dtype };
	    }
	};
	//# sourceMappingURL=Square.js.map

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2020 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var kernel_names_1 = __webpack_require__(88);
	var cpu_util_1 = __webpack_require__(235);
	var kernel_utils_1 = __webpack_require__(963);
	exports.squaredDifferenceConfig = {
	    kernelName: kernel_names_1.SquaredDifference,
	    backendName: 'cpu',
	    kernelFunc: function (_a) {
	        var inputs = _a.inputs, backend = _a.backend;
	        var _b = inputs, a = _b.a, b = _b.b;
	        var cpuBackend = backend;
	        cpu_util_1.assertNotComplex([a, b], kernel_names_1.SquaredDifference);
	        var aVals = cpuBackend.data.get(a.dataId).values;
	        var bVals = cpuBackend.data.get(b.dataId).values;
	        var _c = kernel_utils_1.broadcastedBinaryOp(a.shape, b.shape, aVals, bVals, a.dtype, function (aVal, bVal) {
	            var diff = aVal - bVal;
	            return diff * diff;
	        }), resultData = _c[0], resultShape = _c[1];
	        var dataId = cpuBackend.write(resultData, resultShape, a.dtype);
	        return { dataId: dataId, shape: resultShape, dtype: a.dtype };
	    }
	};
	//# sourceMappingURL=SquaredDifference.js.map

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @license
	 * Copyright 2020 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	// We explicitly import the modular kernels so they get registered in the
	// global registry when we compile the library. A modular build would replace
	// the contents of this file and import only the kernels that are needed.
	var kernel_registry_1 = __webpack_require__(152);
	var NonMaxSuppressionV5_1 = __webpack_require__(959);
	var Square_1 = __webpack_require__(960);
	var SquaredDifference_1 = __webpack_require__(961);
	// List all kernel configs here
	var kernelConfigs = [
	    NonMaxSuppressionV5_1.nonMaxSuppressionV5Config,
	    Square_1.squareConfig,
	    SquaredDifference_1.squaredDifferenceConfig,
	];
	for (var _i = 0, kernelConfigs_1 = kernelConfigs; _i < kernelConfigs_1.length; _i++) {
	    var kernelConfig = kernelConfigs_1[_i];
	    kernel_registry_1.registerKernel(kernelConfig);
	}
	//# sourceMappingURL=register_all_kernels.js.map

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2020 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var backend_util = __webpack_require__(234);
	var util = __webpack_require__(10);
	function broadcastedBinaryOp(aShape, bShape, aVals, bVals, dtype, op) {
	    var newShape = backend_util.assertAndGetBroadcastShape(aShape, bShape);
	    var resultRank = newShape.length;
	    var resultStrides = util.computeStrides(newShape);
	    var resultSize = util.sizeFromShape(newShape);
	    var result = util.getTypedArrayFromDType(dtype, resultSize);
	    var aRank = aShape.length;
	    var bRank = bShape.length;
	    var aStrides = util.computeStrides(aShape);
	    var bStrides = util.computeStrides(bShape);
	    var aBroadcastDims = backend_util.getBroadcastDims(aShape, newShape);
	    var bBroadcastDims = backend_util.getBroadcastDims(bShape, newShape);
	    if (aBroadcastDims.length + bBroadcastDims.length === 0) {
	        for (var i = 0; i < result.length; ++i) {
	            result[i] = op(aVals[i % aVals.length], bVals[i % bVals.length]);
	        }
	    }
	    else {
	        var _loop_1 = function (i) {
	            var loc = util.indexToLoc(i, resultRank, resultStrides);
	            var aLoc = loc.slice(-aRank);
	            aBroadcastDims.forEach(function (d) { return aLoc[d] = 0; });
	            var aIndex = util.locToIndex(aLoc, aRank, aStrides);
	            var bLoc = loc.slice(-bRank);
	            bBroadcastDims.forEach(function (d) { return bLoc[d] = 0; });
	            var bIndex = util.locToIndex(bLoc, bRank, bStrides);
	            result[i] = op(aVals[aIndex], bVals[bIndex]);
	        };
	        for (var i = 0; i < result.length; ++i) {
	            _loop_1(i);
	        }
	    }
	    return [result, newShape];
	}
	exports.broadcastedBinaryOp = broadcastedBinaryOp;
	//# sourceMappingURL=kernel_utils.js.map

/***/ },
/* 964 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var AddNProgram = /** @class */ (function () {
	    function AddNProgram(outputShape, shapes) {
	        this.outputShape = [];
	        this.outputShape = outputShape;
	        this.variableNames = shapes.map(function (_, i) { return "T" + i; });
	        var snippets = [];
	        // Get target elements from every input tensor.
	        this.variableNames.forEach(function (variable) {
	            snippets.push("float v" + variable + " = get" + variable + "AtOutCoords();");
	        });
	        // Calculate the sum of all elements.
	        var operation = this.variableNames
	            .map(function (variable) {
	            return "v" + variable;
	        })
	            .join(' + ');
	        this.userCode = "\n      void main() {\n        " + snippets.join('\n        ') + "\n\n        float result = " + operation + ";\n        setOutput(result);\n      }\n    ";
	    }
	    return AddNProgram;
	}());
	exports.AddNProgram = AddNProgram;
	//# sourceMappingURL=addn_gpu.js.map

/***/ },
/* 965 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var AddNPackedProgram = /** @class */ (function () {
	    function AddNPackedProgram(outputShape, shapes) {
	        this.outputShape = [];
	        this.packedInputs = true;
	        this.packedOutput = true;
	        this.outputShape = outputShape;
	        this.variableNames = shapes.map(function (_, i) { return "T" + i; });
	        var snippets = [];
	        // Get target elements from every input tensor.
	        this.variableNames.forEach(function (variable) {
	            snippets.push("vec4 v" + variable + " = get" + variable + "AtOutCoords();");
	        });
	        // Calculate the sum of all elements.
	        var operation = this.variableNames
	            .map(function (variable) {
	            return "v" + variable;
	        })
	            .join(' + ');
	        this.userCode = "\n      void main() {\n        " + snippets.join('\n        ') + "\n\n        vec4 result = " + operation + ";\n        setOutput(result);\n      }\n    ";
	    }
	    return AddNPackedProgram;
	}());
	exports.AddNPackedProgram = AddNPackedProgram;
	//# sourceMappingURL=addn_packed_gpu.js.map

/***/ },
/* 966 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ArgMinMaxProgram = /** @class */ (function () {
	    function ArgMinMaxProgram(reduceInfo, op, firstPass) {
	        this.variableNames = ['A'];
	        var windowSize = reduceInfo.windowSize;
	        var batchSize = reduceInfo.batchSize;
	        var inSize = reduceInfo.inSize;
	        var outSize = Math.ceil(inSize / windowSize);
	        if (!firstPass) {
	            this.variableNames.push('bestIndicesA');
	        }
	        this.outputShape = [batchSize, outSize];
	        var compOp = (op === 'max') ? '>' : '<';
	        var indexSnippet = firstPass ?
	            'inOffset + i;' :
	            'round(getBestIndicesA(batch, inOffset + i));';
	        this.userCode = "\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = outIdx * " + windowSize + ";\n\n        int bestIndex = inOffset;\n        float bestValue = getA(batch, bestIndex);\n\n        for (int i = 0; i < " + windowSize + "; i++) {\n          int inIdx = " + indexSnippet + ";\n          float candidate = getA(batch, inIdx);\n          if (candidate " + compOp + " bestValue) {\n            bestValue = candidate;\n            bestIndex = inIdx;\n          }\n        }\n        setOutput(float(bestIndex));\n      }\n    ";
	    }
	    return ArgMinMaxProgram;
	}());
	exports.ArgMinMaxProgram = ArgMinMaxProgram;
	//# sourceMappingURL=argminmax_gpu.js.map

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(10);
	var packing_util_1 = __webpack_require__(107);
	var shader_compiler_1 = __webpack_require__(41);
	var ArgMinMaxPackedProgram = /** @class */ (function () {
	    function ArgMinMaxPackedProgram(shape, windowSize, op, firstPass) {
	        this.variableNames = ['A'];
	        this.packedInputs = true;
	        this.packedOutput = true;
	        util_1.assert(shape.length > 2, function () { return "Packed arg" + (op.charAt(0).toUpperCase() +
	            op.slice(1)) + " supports only inputs with rank above 2."; });
	        var inSize = shape[shape.length - 1];
	        var outSize = Math.ceil(inSize / windowSize);
	        this.outputShape = shape.slice(0, -1);
	        if (outSize > 1) {
	            this.outputShape.push(outSize);
	        }
	        if (!firstPass) {
	            this.variableNames.push('bestIndicesA');
	        }
	        var outShape = this.outputShape;
	        var rank = outShape.length;
	        var dtype = shader_compiler_1.getCoordsDataType(rank);
	        var coords = packing_util_1.getChannels('coords', rank);
	        var sourceLocSetup;
	        var sourceRank;
	        if (outSize === 1) {
	            sourceRank = rank + 1;
	            var sourceLocDType = shader_compiler_1.getCoordsDataType(sourceRank);
	            sourceLocSetup = "\n        " + sourceLocDType + " sourceLocR = " + sourceLocDType + "(" + coords.join() + ", 0);\n        ++" + coords[rank - 1] + ";\n        " + sourceLocDType + " sourceLocG = " + sourceLocDType + "(" + coords.join() + ", 0);\n        ++" + coords[rank - 2] + ";\n        " + sourceLocDType + " sourceLocA = " + sourceLocDType + "(" + coords.join() + ", 0);\n        --" + coords[rank - 1] + ";\n        " + sourceLocDType + " sourceLocB = " + sourceLocDType + "(" + coords.join() + ", 0);\n        --" + coords[rank - 2] + ";";
	        }
	        else {
	            sourceRank = rank;
	            sourceLocSetup = "\n        " + dtype + " sourceLocR = coords;\n        ++" + coords[rank - 1] + ";\n        " + dtype + " sourceLocG = coords;\n        ++" + coords[rank - 2] + ";\n        " + dtype + " sourceLocA = coords;\n        --" + coords[rank - 1] + ";\n        " + dtype + " sourceLocB = coords;\n        --" + coords[rank - 2] + ";";
	        }
	        var channels = ['x', 'y', 'z', 'w', 'u', 'v'].slice(0, sourceRank);
	        var inChannel = '.' + channels[sourceRank - 1]; // e.g. ".b" for rank 3.
	        var intChannels = channels.map(function (x) { return 'int ' + x; });
	        var srcRCoords = packing_util_1.getChannels('sourceLocR', sourceRank - 1).concat('inIdx.r');
	        var srcGCoords = packing_util_1.getChannels('sourceLocG', sourceRank - 1).concat('inIdx.g');
	        var srcBCoords = packing_util_1.getChannels('sourceLocB', sourceRank - 1).concat('inIdx.b');
	        var srcACoords = packing_util_1.getChannels('sourceLocA', sourceRank - 1).concat('inIdx.a');
	        var compOp = (op === 'max') ? 'greaterThan' : 'lessThan';
	        var fetchCandidateIdx = firstPass ? '' : "\n          inIdx = round(vec4(getBestIndicesAChannel(" + srcRCoords.join() + "),\n                             getBestIndicesAChannel(" + srcGCoords.join() + "),\n                             getBestIndicesAChannel(" + srcBCoords.join() + "),\n                             getBestIndicesAChannel(" + srcACoords.join() + ")));";
	        var fetchValue = "vec4(\n            getAChannel(" + srcRCoords.join() + "),\n            hasNextCol ? getAChannel(" + srcGCoords.join() + ") : 0.,\n            hasNextRow ? getAChannel(" + srcBCoords.join() + ") : 0.,\n            hasNextRow && hasNextCol ? getAChannel(" + srcACoords.join() + ") : 0.)";
	        var getBestIndicesAChannelSnippet = firstPass ? '' : "\n      float getBestIndicesAChannel(" + intChannels.join() + ") {\n        return getChannel(getBestIndicesA(" + channels.join() + "),\n                                          vec2(" + channels.slice(-2).join() + "));\n      }";
	        this.userCode = "\n      float getAChannel(" + intChannels.join() + ") {\n        return getChannel(getA(" + channels.join() + "),\n                               vec2(" + channels.slice(-2).join() + "));\n      }\n      " + getBestIndicesAChannelSnippet + "\n      void main() {\n        " + dtype + " coords = getOutputCoords();\n        bool hasNextCol = " + coords[rank - 1] + " < " + (outShape[rank - 1] - 1) + ";\n        bool hasNextRow = " + coords[rank - 2] + " < " + (outShape[rank - 2] - 1) + ";\n        " + sourceLocSetup + "\n        ivec4 srcIdx = ivec4(sourceLocR" + inChannel + ", sourceLocG" + inChannel + ",\n          sourceLocB" + inChannel + ", sourceLocA" + inChannel + ") * " + windowSize + ";\n        ivec4 inIdx = srcIdx;\n        vec4 bestIndex = vec4(inIdx);\n        vec4 bestValue = " + fetchValue + ";\n\n        for (int i = 0; i < " + windowSize + "; i++) {\n          inIdx = srcIdx;\n          " + fetchCandidateIdx + "\n          vec4 candidate = " + fetchValue + ";\n          bvec4 nan = isnan(candidate);\n          bvec4 replace = bvec4(\n            vec4(" + compOp + "(candidate, bestValue)) * (vec4(1.0) - vec4(nan)));\n\n          bestValue = vec4(replace.x  ? candidate.x : bestValue.x,\n                           replace.y  ? candidate.y : bestValue.y,\n                           replace.z  ? candidate.z : bestValue.z,\n                           replace.w  ? candidate.w : bestValue.w);\n          bestIndex = mix(bestIndex, vec4(inIdx), vec4(replace));\n          srcIdx++;\n        }\n        setOutput(bestIndex);\n      }\n    ";
	    }
	    return ArgMinMaxPackedProgram;
	}());
	exports.ArgMinMaxPackedProgram = ArgMinMaxPackedProgram;
	//# sourceMappingURL=argminmax_packed_gpu.js.map

/***/ },
/* 968 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var AvgPool2DBackpropProgram = /** @class */ (function () {
	    function AvgPool2DBackpropProgram(convInfo) {
	        this.variableNames = ['dy'];
	        this.outputShape = convInfo.inShape;
	        var filterHeight = convInfo.filterHeight;
	        var filterWidth = convInfo.filterWidth;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var dilationHeight = convInfo.dilationHeight;
	        var dilationWidth = convInfo.dilationWidth;
	        var effectiveFilterHeight = convInfo.effectiveFilterHeight;
	        var effectiveFilterWidth = convInfo.effectiveFilterWidth;
	        var padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
	        var padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
	        var avgMultiplier = 1 / (filterHeight * filterWidth);
	        this.userCode = "\n      const ivec2 pads = ivec2(" + padTop + ", " + padLeft + ");\n      const float avgMultiplier = float(" + avgMultiplier + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n\n        ivec2 dyRCCorner = coords.yz - pads;\n        int dyRCorner = dyRCCorner.x;\n        int dyCCorner = dyRCCorner.y;\n\n        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < " + effectiveFilterHeight + ";\n            wR += " + dilationHeight + ") {\n          float dyR = float(dyRCorner + wR) / " + strideHeight + ".0;\n\n          if (dyR < 0.0 || dyR >= " + convInfo.outHeight + ".0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          for (int wC = 0; wC < " + effectiveFilterWidth + ";\n            wC+= " + dilationWidth + ") {\n            float dyC = float(dyCCorner + wC) / " + strideWidth + ".0;\n\n            if (dyC < 0.0 || dyC >= " + convInfo.outWidth + ".0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            float dyValue = getDy(b, idyR, idyC, d);\n\n            dotProd += dyValue * avgMultiplier;\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
	    }
	    return AvgPool2DBackpropProgram;
	}());
	exports.AvgPool2DBackpropProgram = AvgPool2DBackpropProgram;
	var AvgPool3DBackpropProgram = /** @class */ (function () {
	    function AvgPool3DBackpropProgram(convInfo) {
	        this.variableNames = ['dy'];
	        this.outputShape = convInfo.inShape;
	        var filterDepth = convInfo.filterDepth;
	        var filterHeight = convInfo.filterHeight;
	        var filterWidth = convInfo.filterWidth;
	        var strideDepth = convInfo.strideDepth;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var dilationDepth = convInfo.dilationDepth;
	        var dilationHeight = convInfo.dilationHeight;
	        var dilationWidth = convInfo.dilationWidth;
	        var effectiveFilterDepth = convInfo.effectiveFilterDepth;
	        var effectiveFilterHeight = convInfo.effectiveFilterHeight;
	        var effectiveFilterWidth = convInfo.effectiveFilterWidth;
	        var padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
	        var padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
	        var padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
	        var avgMultiplier = 1 / (filterDepth * filterHeight * filterWidth);
	        this.userCode = "\n      const ivec3 pads = ivec3(" + padFront + ", " + padTop + ", " + padLeft + ");\n      const float avgMultiplier = float(" + avgMultiplier + ");\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int ch = coords.u;\n\n        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;\n        int dyDCorner = dyCorner.x;\n        int dyRCorner = dyCorner.y;\n        int dyCCorner = dyCorner.z;\n\n        // Convolve dy(?, ?, ?, d) with pos mask(:, :, :, ch) to get\n        // dx(xD, xR, xC, ch).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n\n        for (int wD = 0; wD < " + effectiveFilterDepth + ";\n            wD += " + dilationDepth + ") {\n          float dyD = float(dyDCorner + wD) / " + strideDepth + ".0;\n\n          if (dyD < 0.0 || dyD >= " + convInfo.outDepth + ".0 || fract(dyD) > 0.0) {\n            continue;\n          }\n          int idyD = int(dyD);\n\n          for (int wR = 0; wR < " + effectiveFilterHeight + ";\n              wR += " + dilationHeight + ") {\n            float dyR = float(dyRCorner + wR) / " + strideHeight + ".0;\n\n            if (dyR < 0.0 || dyR >= " + convInfo.outHeight + ".0 ||\n                fract(dyR) > 0.0) {\n              continue;\n            }\n            int idyR = int(dyR);\n\n            for (int wC = 0; wC < " + effectiveFilterWidth + ";\n                wC += " + dilationWidth + ") {\n              float dyC = float(dyCCorner + wC) / " + strideWidth + ".0;\n\n              if (dyC < 0.0 || dyC >= " + convInfo.outWidth + ".0 ||\n                  fract(dyC) > 0.0) {\n                continue;\n              }\n              int idyC = int(dyC);\n\n              float dyValue = getDy(batch, idyD, idyR, idyC, ch);\n\n              dotProd += dyValue * avgMultiplier;\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
	    }
	    return AvgPool3DBackpropProgram;
	}());
	exports.AvgPool3DBackpropProgram = AvgPool3DBackpropProgram;
	//# sourceMappingURL=avg_pool_backprop_gpu.js.map

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var broadcast_util = __webpack_require__(57);
	var BatchNormProgram = /** @class */ (function () {
	    function BatchNormProgram(xShape, meanShape, varianceShape, offsetShape, scaleShape, varianceEpsilon) {
	        this.outputShape = [];
	        this.variableNames = ['x', 'mean', 'variance'];
	        broadcast_util.assertAndGetBroadcastShape(xShape, meanShape);
	        broadcast_util.assertAndGetBroadcastShape(xShape, varianceShape);
	        var offsetSnippet = '0.0';
	        if (offsetShape != null) {
	            broadcast_util.assertAndGetBroadcastShape(xShape, offsetShape);
	            this.variableNames.push('offset');
	            offsetSnippet = 'getOffsetAtOutCoords()';
	        }
	        var scaleSnippet = '1.0';
	        if (scaleShape != null) {
	            broadcast_util.assertAndGetBroadcastShape(xShape, scaleShape);
	            this.variableNames.push('scale');
	            scaleSnippet = 'getScaleAtOutCoords()';
	        }
	        this.outputShape = xShape;
	        this.userCode = "\n      void main() {\n        float x = getXAtOutCoords();\n        float mean = getMeanAtOutCoords();\n        float variance = getVarianceAtOutCoords();\n        float offset = " + offsetSnippet + ";\n        float scale = " + scaleSnippet + ";\n        float inv = scale * inversesqrt(variance + float(" + varianceEpsilon + "));\n        setOutput(dot(vec3(x, -mean, offset), vec3(inv, inv, 1)));\n      }\n    ";
	    }
	    return BatchNormProgram;
	}());
	exports.BatchNormProgram = BatchNormProgram;
	//# sourceMappingURL=batchnorm_gpu.js.map

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var broadcast_util = __webpack_require__(57);
	var BatchNormPackedProgram = /** @class */ (function () {
	    function BatchNormPackedProgram(xShape, meanShape, varianceShape, offsetShape, scaleShape, varianceEpsilon) {
	        this.packedInputs = true;
	        this.packedOutput = true;
	        this.variableNames = ['x', 'mean', 'variance'];
	        broadcast_util.assertAndGetBroadcastShape(xShape, meanShape);
	        broadcast_util.assertAndGetBroadcastShape(xShape, varianceShape);
	        var offsetSnippet = 'vec4(0.0)';
	        if (offsetShape != null) {
	            broadcast_util.assertAndGetBroadcastShape(xShape, offsetShape);
	            this.variableNames.push('offset');
	            offsetSnippet = 'getOffsetAtOutCoords()';
	        }
	        var scaleSnippet = 'vec4(1.0)';
	        if (scaleShape != null) {
	            broadcast_util.assertAndGetBroadcastShape(xShape, scaleShape);
	            this.variableNames.push('scale');
	            scaleSnippet = 'getScaleAtOutCoords()';
	        }
	        this.outputShape = xShape;
	        this.userCode = "\n      void main() {\n        vec4 offset = " + offsetSnippet + ";\n        vec4 scale = " + scaleSnippet + ";\n\n        vec4 x = getXAtOutCoords();\n        vec4 mean = getMeanAtOutCoords();\n        vec4 variance = getVarianceAtOutCoords();\n\n        vec4 inv = scale * inversesqrt(variance + vec4(" + varianceEpsilon + "));\n\n        setOutput((x - mean) * inv + offset);\n      }\n    ";
	    }
	    return BatchNormPackedProgram;
	}());
	exports.BatchNormPackedProgram = BatchNormPackedProgram;
	//# sourceMappingURL=batchnorm_packed_gpu.js.map

/***/ },
/* 971 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ClipProgram = /** @class */ (function () {
	    function ClipProgram(aShape) {
	        this.variableNames = ['A'];
	        this.outputShape = aShape;
	        this.userCode = "\n      uniform float minVal;\n      uniform float maxVal;\n\n      void main() {\n        float value = getAAtOutCoords();\n        if (isnan(value)) {\n          setOutput(value);\n          return;\n        }\n\n        setOutput(clamp(value, minVal, maxVal));\n      }\n    ";
	    }
	    ClipProgram.prototype.getCustomSetupFunc = function (min, max) {
	        var _this = this;
	        return function (gpgpu, webGLProgram) {
	            if (_this.minLoc == null) {
	                _this.minLoc = gpgpu.getUniformLocationNoThrow(webGLProgram, 'minVal');
	                _this.maxLoc = gpgpu.getUniformLocationNoThrow(webGLProgram, 'maxVal');
	            }
	            gpgpu.gl.uniform1f(_this.minLoc, min);
	            gpgpu.gl.uniform1f(_this.maxLoc, max);
	        };
	    };
	    return ClipProgram;
	}());
	exports.ClipProgram = ClipProgram;
	//# sourceMappingURL=clip_gpu.js.map

/***/ },
/* 972 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ClipPackedProgram = /** @class */ (function () {
	    function ClipPackedProgram(aShape) {
	        this.variableNames = ['A'];
	        this.packedInputs = true;
	        this.packedOutput = true;
	        this.outputShape = aShape;
	        this.userCode = "\n      uniform float minVal;\n      uniform float maxVal;\n\n      void main() {\n        vec4 value = getAAtOutCoords();\n\n        if (any(isnan(value))) {\n          setOutput(value);\n          return;\n        }\n\n        setOutput(clamp(value, vec4(minVal), vec4(maxVal)));\n      }\n    ";
	    }
	    ClipPackedProgram.prototype.getCustomSetupFunc = function (min, max) {
	        var _this = this;
	        return function (gpgpu, webGLProgram) {
	            if (_this.minLoc == null) {
	                _this.minLoc = gpgpu.getUniformLocationNoThrow(webGLProgram, 'minVal');
	                _this.maxLoc = gpgpu.getUniformLocationNoThrow(webGLProgram, 'maxVal');
	            }
	            gpgpu.gl.uniform1f(_this.minLoc, min);
	            gpgpu.gl.uniform1f(_this.maxLoc, max);
	        };
	    };
	    return ClipPackedProgram;
	}());
	exports.ClipPackedProgram = ClipPackedProgram;
	//# sourceMappingURL=clip_packed_gpu.js.map

/***/ },
/* 973 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ComplexAbsProgram = /** @class */ (function () {
	    function ComplexAbsProgram(shape) {
	        this.variableNames = ['real', 'imag'];
	        this.outputShape = shape;
	        this.userCode = "\n      void main() {\n        float re = abs(getRealAtOutCoords());\n        float im = abs(getImagAtOutCoords());\n        float mx = max(re, im);\n\n        // sadly the length function in glsl is not underflow-safe\n        // (at least not on Intel GPUs). So the safe solution is\n        // to ensure underflow-safety in all cases.\n        setOutput(\n          mx == 0.0 ? 0.0 : mx * length(vec2(1, min(re, im)/mx))\n        );\n      }\n    ";
	    }
	    return ComplexAbsProgram;
	}());
	exports.ComplexAbsProgram = ComplexAbsProgram;
	//# sourceMappingURL=complex_abs_gpu.js.map

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var concat_util = __webpack_require__(153);
	var ConcatProgram = /** @class */ (function () {
	    // Concats 2d tensors along axis=1. See comments in MathBackendWebGL.concat().
	    function ConcatProgram(shapes) {
	        this.outputShape = [];
	        this.outputShape = concat_util.computeOutShape(shapes, 1 /* axis */);
	        this.variableNames = shapes.map(function (_, i) { return "T" + i; });
	        var offsets = new Array(shapes.length - 1);
	        offsets[0] = shapes[0][1];
	        for (var i = 1; i < offsets.length; i++) {
	            offsets[i] = offsets[i - 1] + shapes[i][1];
	        }
	        var snippets = ["if (yC < " + offsets[0] + ") setOutput(getT0(yR, yC));"];
	        for (var i = 1; i < offsets.length; i++) {
	            var shift = offsets[i - 1];
	            snippets.push("else if (yC < " + offsets[i] + ") " +
	                ("setOutput(getT" + i + "(yR, yC-" + shift + "));"));
	        }
	        var lastIndex = offsets.length;
	        var lastShift = offsets[offsets.length - 1];
	        snippets.push("else setOutput(getT" + lastIndex + "(yR, yC-" + lastShift + "));");
	        this.userCode = "\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int yR = coords.x;\n        int yC = coords.y;\n\n        " + snippets.join('\n        ') + "\n      }\n    ";
	    }
	    return ConcatProgram;
	}());
	exports.ConcatProgram = ConcatProgram;
	//# sourceMappingURL=concat_gpu.js.map

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var concat_util = __webpack_require__(153);
	var packing_util_1 = __webpack_require__(107);
	var shader_compiler_1 = __webpack_require__(41);
	var ConcatPackedProgram = /** @class */ (function () {
	    function ConcatPackedProgram(shapes, axis) {
	        this.packedInputs = true;
	        this.packedOutput = true;
	        this.outputShape = [];
	        this.outputShape = concat_util.computeOutShape(shapes, axis);
	        var shape = this.outputShape;
	        var rank = shape.length;
	        var dtype = shader_compiler_1.getCoordsDataType(rank);
	        var coords = packing_util_1.getChannels('coords', rank);
	        var channels = ['x', 'y', 'z', 'w', 'u', 'v'].slice(0, rank);
	        this.variableNames = shapes.map(function (_, i) { return "T" + i; });
	        var offsets = new Array(shapes.length - 1);
	        offsets[0] = shapes[0][axis];
	        for (var i = 1; i < offsets.length; i++) {
	            offsets[i] = offsets[i - 1] + shapes[i][axis];
	        }
	        var channel = channels[axis];
	        var lastChannels = channels.slice(-2);
	        var allChannels = channels.join();
	        var getValueSnippet = "if (" + channel + " < " + offsets[0] + ") {\n        return getChannel(\n            getT0(" + allChannels + "), vec2(" + lastChannels.join() + "));\n        }";
	        for (var i = 1; i < offsets.length; i++) {
	            var shift_1 = offsets[i - 1];
	            // Note: the >= comparison below may seem unnecessary given the check
	            // above but is needed to workaround branch execution issues on some
	            // devices. It makes all the conditions exclusive without relying on
	            // execution order.
	            getValueSnippet += "\n        if (" + channel + " < " + offsets[i] + "  && " + channel + " >= " + offsets[i - 1] + ") {\n          return getChannel(\n            getT" + i + "(" + shiftedChannels(channels, channel, shift_1) + "),\n            vec2(" + shiftedChannels(lastChannels, channel, shift_1) + "));\n        }";
	        }
	        var lastIndex = offsets.length;
	        var shift = offsets[offsets.length - 1];
	        getValueSnippet += "\n        return getChannel(\n          getT" + lastIndex + "(" + shiftedChannels(channels, channel, shift) + "),\n          vec2(" + shiftedChannels(lastChannels, channel, shift) + "));";
	        this.userCode = "\n      float getValue(" + channels.map(function (x) { return 'int ' + x; }) + ") {\n        " + getValueSnippet + "\n      }\n\n      void main() {\n        " + dtype + " coords = getOutputCoords();\n        vec4 result = vec4(getValue(" + coords + "), 0., 0., 0.);\n\n        " + coords[rank - 1] + " = " + coords[rank - 1] + " + 1;\n        if (" + coords[rank - 1] + " < " + shape[rank - 1] + ") {\n          result.g = getValue(" + coords + ");\n        }\n\n        " + coords[rank - 2] + " = " + coords[rank - 2] + " + 1;\n        if (" + coords[rank - 2] + " < " + shape[rank - 2] + ") {\n          result.a = getValue(" + coords + ");\n        }\n\n        " + coords[rank - 1] + " = " + coords[rank - 1] + " - 1;\n        if (" + coords[rank - 2] + " < " + shape[rank - 2] + " &&\n            " + coords[rank - 1] + " < " + shape[rank - 1] + ") {\n          result.b = getValue(" + coords + ");\n        }\n        setOutput(result);\n      }\n    ";
	    }
	    return ConcatPackedProgram;
	}());
	exports.ConcatPackedProgram = ConcatPackedProgram;
	/**
	 * Return an expression for coordinates into a vector where a given channel
	 * will be offset by [shift].
	 *
	 * @param channels the channels to consider
	 * @param channel the channel we want shifted
	 * @param shift  the amount to subtract from the channel.
	 *
	 * @returns a string of the form 'x, y-[shift], z' where any one channel can
	 * have the shift applied.
	 */
	function shiftedChannels(channels, channel, shift) {
	    var channelIdx = channels.indexOf(channel);
	    var res = channels.map(function (c, idx) {
	        if (idx === channelIdx) {
	            return c + " - " + shift;
	        }
	        else {
	            return c;
	        }
	    });
	    return res.join();
	}
	//# sourceMappingURL=concat_packed_gpu.js.map

/***/ },
/* 976 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Conv2DDerFilterProgram = /** @class */ (function () {
	    function Conv2DDerFilterProgram(convInfo) {
	        this.variableNames = ['x', 'dy'];
	        this.outputShape = convInfo.filterShape;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var padTop = convInfo.padInfo.top;
	        var padLeft = convInfo.padInfo.left;
	        var isChannelsLast = convInfo.dataFormat === 'channelsLast';
	        this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int wR = coords.x;\n        int wC = coords.y;\n        int d1 = coords.z;\n        int d2 = coords.w;\n\n        // Convolve x(?, ?, d1) with dy(:, :, d2) to get dw(wR, wC, d1, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n\n        for (int b = 0; b < " + convInfo.batchSize + "; b++) {\n          for (int yR = 0; yR < " + convInfo.outHeight + "; yR++) {\n            int xR = wR + yR * " + strideHeight + " - " + padTop + ";\n\n            if (xR < 0 || xR >= " + convInfo.inHeight + ") {\n              continue;\n            }\n\n            for (int yC = 0; yC < " + convInfo.outWidth + "; yC++) {\n              int xC = wC + yC * " + strideWidth + " - " + padLeft + ";\n\n              if (xC < 0 || xC >= " + convInfo.inWidth + ") {\n                continue;\n              }\n\n              if (" + isChannelsLast + ") {\n                float dyValue = getDy(b, yR, yC, d2);\n                float xValue = getX(b, xR, xC, d1);\n                dotProd += (xValue * dyValue);\n              } else {\n                float dyValue = getDy(b, d2, yR, yC);\n                float xValue = getX(b, d1, xR, xC);\n                dotProd += (xValue * dyValue);\n              }\n\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
	    }
	    return Conv2DDerFilterProgram;
	}());
	exports.Conv2DDerFilterProgram = Conv2DDerFilterProgram;
	var Conv2DDerInputProgram = /** @class */ (function () {
	    function Conv2DDerInputProgram(convInfo) {
	        this.variableNames = ['dy', 'W'];
	        this.outputShape = convInfo.inShape;
	        var filterHeight = convInfo.filterHeight;
	        var filterWidth = convInfo.filterWidth;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var isChannelsLast = convInfo.dataFormat === 'channelsLast';
	        var padTop = filterHeight - 1 - convInfo.padInfo.top;
	        var padLeft = filterWidth - 1 - convInfo.padInfo.left;
	        var rowDim = isChannelsLast ? 1 : 2;
	        var colDim = isChannelsLast ? 2 : 3;
	        var channelDim = isChannelsLast ? 3 : 1;
	        this.userCode = "\n      const ivec2 pads = ivec2(" + padTop + ", " + padLeft + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d1 = coords[" + channelDim + "];\n\n        ivec2 dyCorner = ivec2(coords[" + rowDim + "], coords[" + colDim + "]) - pads;\n        int dyRCorner = dyCorner.x;\n        int dyCCorner = dyCorner.y;\n\n        // Convolve dy(?, ?, d2) with w(:, :, d1, d2) to compute dx(xR, xC, d1).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < " + filterHeight + "; wR++) {\n          float dyR = float(dyRCorner + wR) / " + strideHeight + ".0;\n\n          if (dyR < 0.0 || dyR >= " + convInfo.outHeight + ".0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          int wRPerm = " + filterHeight + " - 1 - wR;\n\n          for (int wC = 0; wC < " + filterWidth + "; wC++) {\n            float dyC = float(dyCCorner + wC) / " + strideWidth + ".0;\n\n            if (dyC < 0.0 || dyC >= " + convInfo.outWidth + ".0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            int wCPerm = " + filterWidth + " - 1 - wC;\n\n            for (int d2 = 0; d2 < " + convInfo.outChannels + "; d2++) {\n\n              if (" + isChannelsLast + ") {\n                float xValue = getDy(batch, idyR, idyC, d2);\n                float wValue = getW(wRPerm, wCPerm, d1, d2);\n                dotProd += xValue * wValue;\n              } else {\n                float xValue = getDy(batch, d2, idyR, idyC);\n                float wValue = getW(wRPerm, wCPerm, d1, d2);\n                dotProd += xValue * wValue;\n              }\n\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
	    }
	    return Conv2DDerInputProgram;
	}());
	exports.Conv2DDerInputProgram = Conv2DDerInputProgram;
	var Conv3DDerFilterProgram = /** @class */ (function () {
	    function Conv3DDerFilterProgram(convInfo) {
	        this.variableNames = ['x', 'dy'];
	        this.outputShape = convInfo.filterShape;
	        var strideDepth = convInfo.strideDepth;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var padFront = convInfo.padInfo.front;
	        var padTop = convInfo.padInfo.top;
	        var padLeft = convInfo.padInfo.left;
	        this.userCode = "\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int wF = coords.x;\n        int wR = coords.y;\n        int wC = coords.z;\n        int d1 = coords.w;\n        int d2 = coords.u;\n\n        float dotProd = 0.0;\n\n        for (int b = 0; b < " + convInfo.batchSize + "; b++) {\n          for (int yF = 0; yF < " + convInfo.outDepth + "; yF++) {\n            int xF = wF + yF * " + strideDepth + " - " + padFront + ";\n\n            if (xF < 0 || xF >= " + convInfo.inDepth + ") {\n              continue;\n            }\n\n            for (int yR = 0; yR < " + convInfo.outHeight + "; yR++) {\n              int xR = wR + yR * " + strideHeight + " - " + padTop + ";\n\n              if (xR < 0 || xR >= " + convInfo.inHeight + ") {\n                continue;\n              }\n\n              for (int yC = 0; yC < " + convInfo.outWidth + "; yC++) {\n                int xC = wC + yC * " + strideWidth + " - " + padLeft + ";\n\n                if (xC < 0 || xC >= " + convInfo.inWidth + ") {\n                  continue;\n                }\n\n                float dyValue = getDy(b, yF, yR, yC, d2);\n                float xValue = getX(b, xF, xR, xC, d1);\n                dotProd += (xValue * dyValue);\n              }\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
	    }
	    return Conv3DDerFilterProgram;
	}());
	exports.Conv3DDerFilterProgram = Conv3DDerFilterProgram;
	var Conv3DDerInputProgram = /** @class */ (function () {
	    function Conv3DDerInputProgram(convInfo) {
	        this.variableNames = ['dy', 'W'];
	        this.outputShape = convInfo.inShape;
	        var filterDepth = convInfo.filterDepth;
	        var filterHeight = convInfo.filterHeight;
	        var filterWidth = convInfo.filterWidth;
	        var strideDepth = convInfo.strideDepth;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var padFront = filterDepth - 1 - convInfo.padInfo.front;
	        var padTop = filterHeight - 1 - convInfo.padInfo.top;
	        var padLeft = filterWidth - 1 - convInfo.padInfo.left;
	        this.userCode = "\n      const ivec3 pads = ivec3(" + padFront + ", " + padTop + ", " + padLeft + ");\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int d1 = coords.u;\n\n\n        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;\n        int dyFCorner = dyCorner.x;\n        int dyRCorner = dyCorner.y;\n        int dyCCorner = dyCorner.z;\n\n        float dotProd = 0.0;\n        for (int wF = 0; wF < " + filterDepth + "; wF++) {\n          float dyF = float(dyFCorner + wF) / " + strideDepth + ".0;\n\n          if (dyF < 0.0 || dyF >= " + convInfo.outDepth + ".0 || fract(dyF) > 0.0) {\n            continue;\n          }\n          int idyF = int(dyF);\n\n          int wFPerm = " + filterDepth + " - 1 - wF;\n\n          for (int wR = 0; wR < " + filterHeight + "; wR++) {\n            float dyR = float(dyRCorner + wR) / " + strideHeight + ".0;\n\n            if (dyR < 0.0 || dyR >= " + convInfo.outHeight + ".0 ||\n              fract(dyR) > 0.0) {\n              continue;\n            }\n            int idyR = int(dyR);\n\n            int wRPerm = " + filterHeight + " - 1 - wR;\n\n            for (int wC = 0; wC < " + filterWidth + "; wC++) {\n              float dyC = float(dyCCorner + wC) / " + strideWidth + ".0;\n\n              if (dyC < 0.0 || dyC >= " + convInfo.outWidth + ".0 ||\n                  fract(dyC) > 0.0) {\n                continue;\n              }\n              int idyC = int(dyC);\n\n              int wCPerm = " + filterWidth + " - 1 - wC;\n\n              for (int d2 = 0; d2 < " + convInfo.outChannels + "; d2++) {\n                float xValue = getDy(batch, idyF, idyR, idyC, d2);\n                float wValue = getW(wFPerm, wRPerm, wCPerm, d1, d2);\n                dotProd += xValue * wValue;\n              }\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
	    }
	    return Conv3DDerInputProgram;
	}());
	exports.Conv3DDerInputProgram = Conv3DDerInputProgram;
	//# sourceMappingURL=conv_backprop_gpu.js.map

/***/ },
/* 977 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var DepthwiseConv2DDerFilterProgram = /** @class */ (function () {
	    function DepthwiseConv2DDerFilterProgram(convInfo) {
	        this.variableNames = ['x', 'dy'];
	        this.outputShape = convInfo.filterShape;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var padTop = convInfo.padInfo.top;
	        var padLeft = convInfo.padInfo.left;
	        var channelMul = convInfo.outChannels / convInfo.inChannels;
	        this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int wR = coords.x;\n        int wC = coords.y;\n        int d1 = coords.z;\n        int dm = coords.w;\n        int d2 = d1 * " + channelMul + " + dm;\n\n        float dotProd = 0.0;\n\n        // TO DO: Vec4 over the batch size\n        for (int b = 0; b < " + convInfo.batchSize + "; b++) {\n          for (int yR = 0; yR < " + convInfo.outHeight + "; yR++) {\n            int xR = wR + yR * " + strideHeight + " - " + padTop + ";\n\n            if (xR < 0 || xR >= " + convInfo.inHeight + ") {\n              continue;\n            }\n\n            for (int yC = 0; yC < " + convInfo.outWidth + "; yC++) {\n              int xC = wC + yC * " + strideWidth + " - " + padLeft + ";\n\n              if (xC < 0 || xC >= " + convInfo.inWidth + ") {\n                continue;\n              }\n\n              float dyValue = getDy(b, yR, yC, d2);\n              float xValue = getX(b, xR, xC, d1);\n              dotProd += (xValue * dyValue);\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
	    }
	    return DepthwiseConv2DDerFilterProgram;
	}());
	exports.DepthwiseConv2DDerFilterProgram = DepthwiseConv2DDerFilterProgram;
	var DepthwiseConv2DDerInputProgram = /** @class */ (function () {
	    function DepthwiseConv2DDerInputProgram(convInfo) {
	        this.variableNames = ['dy', 'W'];
	        this.outputShape = convInfo.inShape;
	        var filterHeight = convInfo.filterHeight;
	        var filterWidth = convInfo.filterWidth;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var padTop = filterHeight - 1 - convInfo.padInfo.top;
	        var padLeft = filterWidth - 1 - convInfo.padInfo.left;
	        var channelMul = convInfo.outChannels / convInfo.inChannels;
	        this.userCode = "\n      const ivec2 pads = ivec2(" + padTop + ", " + padLeft + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d1 = coords[3];\n        ivec2 dyCorner = coords.yz - pads;\n        int dyRCorner = dyCorner.x;\n        int dyCCorner = dyCorner.y;\n\n        float dotProd = 0.0;\n\n        for (int wR = 0; wR < " + filterHeight + "; wR++) {\n          float dyR = float(dyRCorner + wR) / " + strideHeight + ".0;\n\n          if (dyR < 0.0 || dyR >= " + convInfo.outHeight + ".0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          int wRPerm = " + filterHeight + " - 1 - wR;\n\n          for (int wC = 0; wC < " + filterWidth + "; wC++) {\n            float dyC = float(dyCCorner + wC) / " + strideWidth + ".0;\n\n            if (dyC < 0.0 || dyC >= " + convInfo.outWidth + ".0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            int wCPerm = " + filterWidth + " - 1 - wC;\n\n            // TO DO: Vec4 over the channelMul\n            for (int dm = 0; dm < " + channelMul + "; dm++) {\n              int d2 = d1 * " + channelMul + " + dm;\n              float xValue = getDy(batch, idyR, idyC, d2);\n              float wValue = getW(wRPerm, wCPerm, d1, dm);\n              dotProd += xValue * wValue;\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
	    }
	    return DepthwiseConv2DDerInputProgram;
	}());
	exports.DepthwiseConv2DDerInputProgram = DepthwiseConv2DDerInputProgram;
	//# sourceMappingURL=conv_backprop_gpu_depthwise.js.map

/***/ },
/* 978 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Conv2DProgram = /** @class */ (function () {
	    function Conv2DProgram(convInfo, addBias, activation, hasPreluActivationWeights) {
	        if (addBias === void 0) { addBias = false; }
	        if (activation === void 0) { activation = null; }
	        if (hasPreluActivationWeights === void 0) { hasPreluActivationWeights = false; }
	        this.variableNames = ['x', 'W'];
	        this.outputShape = convInfo.outShape;
	        var padTop = convInfo.padInfo.top;
	        var padLeft = convInfo.padInfo.left;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var dilationHeight = convInfo.dilationHeight;
	        var dilationWidth = convInfo.dilationWidth;
	        var filterHeight = convInfo.filterHeight;
	        var filterWidth = convInfo.filterWidth;
	        var inputDepthNearestVec4 = Math.floor(convInfo.inChannels / 4) * 4;
	        var inputDepthVec4Remainder = convInfo.inChannels % 4;
	        var isChannelsLast = convInfo.dataFormat === 'channelsLast';
	        var rowDim = isChannelsLast ? 1 : 2;
	        var colDim = isChannelsLast ? 2 : 3;
	        var channelDim = isChannelsLast ? 3 : 1;
	        var activationSnippet = '', applyActivationSnippet = '';
	        if (activation) {
	            if (hasPreluActivationWeights) {
	                activationSnippet = "float activation(float a) {\n          float b = getPreluActivationWeightsAtOutCoords();\n          " + activation + "\n        }";
	            }
	            else {
	                activationSnippet = "\n          float activation(float x) {\n            " + activation + "\n          }\n        ";
	            }
	            applyActivationSnippet = "result = activation(result);";
	        }
	        var addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
	        if (addBias) {
	            this.variableNames.push('bias');
	        }
	        if (hasPreluActivationWeights) {
	            this.variableNames.push('preluActivationWeights');
	        }
	        this.userCode = "\n      " + activationSnippet + "\n\n      const ivec2 strides = ivec2(" + strideHeight + ", " + strideWidth + ");\n      const ivec2 pads = ivec2(" + padTop + ", " + padLeft + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d2 = coords[" + channelDim + "];\n\n        ivec2 xRCCorner =\n            ivec2(coords[" + rowDim + "], coords[" + colDim + "]) * strides - pads;\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // Convolve x(?, ?, d1) with w(:, :, d1, d2) to get y(yR, yC, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < " + filterHeight + "; wR++) {\n          int xR = xRCorner + wR * " + dilationHeight + ";\n\n          if (xR < 0 || xR >= " + convInfo.inHeight + ") {\n            continue;\n          }\n\n          for (int wC = 0; wC < " + filterWidth + "; wC++) {\n            int xC = xCCorner + wC * " + dilationWidth + ";\n\n            if (xC < 0 || xC >= " + convInfo.inWidth + ") {\n              continue;\n            }\n\n            for (int d1 = 0; d1 < " + inputDepthNearestVec4 + "; d1 += 4) {\n              vec4 wValues = vec4(\n                getW(wR, wC, d1, d2),\n                getW(wR, wC, d1 + 1, d2),\n                getW(wR, wC, d1 + 2, d2),\n                getW(wR, wC, d1 + 3, d2)\n              );\n\n              if (" + isChannelsLast + ") {\n                vec4 xValues = vec4(\n                  getX(batch, xR, xC, d1),\n                  getX(batch, xR, xC, d1 + 1),\n                  getX(batch, xR, xC, d1 + 2),\n                  getX(batch, xR, xC, d1 + 3)\n                );\n                dotProd += dot(xValues, wValues);\n              } else {\n                vec4 xValues = vec4(\n                  getX(batch, d1, xR, xC),\n                  getX(batch, d1 + 1, xR, xC),\n                  getX(batch, d1 + 2, xR, xC),\n                  getX(batch, d1 + 3, xR, xC)\n                );\n                dotProd += dot(xValues, wValues);\n              }\n            }\n\n            if (" + (inputDepthVec4Remainder === 1) + ") {\n\n              if (" + isChannelsLast + ") {\n                dotProd +=\n                    getX(batch, xR, xC, " + inputDepthNearestVec4 + ") *\n                    getW(wR, wC, " + inputDepthNearestVec4 + ", d2);\n              } else {\n                dotProd +=\n                    getX(batch, " + inputDepthNearestVec4 + ", xR, xC) *\n                    getW(wR, wC, " + inputDepthNearestVec4 + ", d2);\n              }\n\n            } else if (" + (inputDepthVec4Remainder === 2) + ") {\n              vec2 wValues = vec2(\n                getW(wR, wC, " + inputDepthNearestVec4 + ", d2),\n                getW(wR, wC, " + inputDepthNearestVec4 + " + 1, d2)\n              );\n\n              if (" + isChannelsLast + ") {\n                vec2 xValues = vec2(\n                  getX(batch, xR, xC, " + inputDepthNearestVec4 + "),\n                  getX(batch, xR, xC, " + inputDepthNearestVec4 + " + 1)\n                );\n                dotProd += dot(xValues, wValues);\n              } else {\n                vec2 xValues = vec2(\n                  getX(batch, " + inputDepthNearestVec4 + ", xR, xC),\n                  getX(batch, " + inputDepthNearestVec4 + " + 1, xR, xC)\n                );\n                dotProd += dot(xValues, wValues);\n              }\n\n            } else if (" + (inputDepthVec4Remainder === 3) + ") {\n              vec3 wValues = vec3(\n                getW(wR, wC, " + inputDepthNearestVec4 + ", d2),\n                getW(wR, wC, " + inputDepthNearestVec4 + " + 1, d2),\n                getW(wR, wC, " + inputDepthNearestVec4 + " + 2, d2)\n              );\n\n              if (" + isChannelsLast + ") {\n                vec3 xValues = vec3(\n                  getX(batch, xR, xC, " + inputDepthNearestVec4 + "),\n                  getX(batch, xR, xC, " + inputDepthNearestVec4 + " + 1),\n                  getX(batch, xR, xC, " + inputDepthNearestVec4 + " + 2)\n                );\n                dotProd += dot(xValues, wValues);\n              } else {\n                vec3 xValues = vec3(\n                  getX(batch, " + inputDepthNearestVec4 + ", xR, xC),\n                  getX(batch, " + inputDepthNearestVec4 + " + 1, xR, xC),\n                  getX(batch, " + inputDepthNearestVec4 + " + 2, xR, xC)\n                );\n                dotProd += dot(xValues, wValues);\n              }\n\n            }\n          }\n        }\n\n        float result = dotProd;\n        " + addBiasSnippet + "\n        " + applyActivationSnippet + "\n        setOutput(result);\n      }\n    ";
	    }
	    return Conv2DProgram;
	}());
	exports.Conv2DProgram = Conv2DProgram;
	var Conv3DProgram = /** @class */ (function () {
	    function Conv3DProgram(convInfo) {
	        this.variableNames = ['x', 'W'];
	        this.outputShape = convInfo.outShape;
	        var padFront = convInfo.padInfo.front;
	        var padTop = convInfo.padInfo.top;
	        var padLeft = convInfo.padInfo.left;
	        var strideDepth = convInfo.strideDepth;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var dilationDepth = convInfo.dilationDepth;
	        var dilationHeight = convInfo.dilationHeight;
	        var dilationWidth = convInfo.dilationWidth;
	        var filterDepth = convInfo.filterDepth;
	        var filterHeight = convInfo.filterHeight;
	        var filterWidth = convInfo.filterWidth;
	        var inputDepthNearestVec4 = Math.floor(convInfo.inChannels / 4) * 4;
	        var inputDepthVec4Remainder = convInfo.inChannels % 4;
	        this.userCode = "\n      const ivec3 strides = ivec3(" + strideDepth + ", " + strideHeight + ", " + strideWidth + ");\n      const ivec3 pads = ivec3(" + padFront + ", " + padTop + ", " + padLeft + ");\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int d2 = coords.u;\n\n        ivec3 xFRCCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;\n        int xFCorner = xFRCCorner.x;\n        int xRCorner = xFRCCorner.y;\n        int xCCorner = xFRCCorner.z;\n\n        // Convolve x(?, ?, ?, d1) with w(:, :, :, d1, d2) to get\n        // y(yF, yR, yC, d2). ? = to be determined. : = across all\n        // values in that axis.\n        float dotProd = 0.0;\n        for (int wF = 0; wF < " + filterDepth + "; wF++) {\n          int xF = xFCorner + wF * " + dilationDepth + ";\n\n          if (xF < 0 || xF >= " + convInfo.inDepth + ") {\n            continue;\n          }\n\n          for (int wR = 0; wR < " + filterHeight + "; wR++) {\n            int xR = xRCorner + wR * " + dilationHeight + ";\n\n            if (xR < 0 || xR >= " + convInfo.inHeight + ") {\n              continue;\n            }\n\n            for (int wC = 0; wC < " + filterWidth + "; wC++) {\n              int xC = xCCorner + wC * " + dilationWidth + ";\n\n              if (xC < 0 || xC >= " + convInfo.inWidth + ") {\n                continue;\n              }\n\n              for (int d1 = 0; d1 < " + inputDepthNearestVec4 + "; d1 += 4) {\n                vec4 xValues = vec4(\n                  getX(batch, xF, xR, xC, d1),\n                  getX(batch, xF, xR, xC, d1 + 1),\n                  getX(batch, xF, xR, xC, d1 + 2),\n                  getX(batch, xF, xR, xC, d1 + 3)\n                );\n                vec4 wValues = vec4(\n                  getW(wF, wR, wC, d1, d2),\n                  getW(wF, wR, wC, d1 + 1, d2),\n                  getW(wF, wR, wC, d1 + 2, d2),\n                  getW(wF, wR, wC, d1 + 3, d2)\n                );\n\n                dotProd += dot(xValues, wValues);\n              }\n\n              if (" + (inputDepthVec4Remainder === 1) + ") {\n                dotProd +=\n                  getX(batch, xF, xR, xC, " + inputDepthNearestVec4 + ") *\n                  getW(wF, wR, wC, " + inputDepthNearestVec4 + ", d2);\n              } else if (" + (inputDepthVec4Remainder === 2) + ") {\n                vec2 xValues = vec2(\n                  getX(batch, xF, xR, xC, " + inputDepthNearestVec4 + "),\n                  getX(batch, xF, xR, xC, " + inputDepthNearestVec4 + " + 1)\n                );\n                vec2 wValues = vec2(\n                  getW(wF, wR, wC, " + inputDepthNearestVec4 + ", d2),\n                  getW(wF, wR, wC, " + inputDepthNearestVec4 + " + 1, d2)\n                );\n                dotProd += dot(xValues, wValues);\n              } else if (" + (inputDepthVec4Remainder === 3) + ") {\n                vec3 xValues = vec3(\n                  getX(batch, xF, xR, xC, " + inputDepthNearestVec4 + "),\n                  getX(batch, xF, xR, xC, " + inputDepthNearestVec4 + " + 1),\n                  getX(batch, xF, xR, xC, " + inputDepthNearestVec4 + " + 2)\n                );\n                vec3 wValues = vec3(\n                  getW(wF, wR, wC, " + inputDepthNearestVec4 + ", d2),\n                  getW(wF, wR, wC, " + inputDepthNearestVec4 + " + 1, d2),\n                  getW(wF, wR, wC, " + inputDepthNearestVec4 + " + 2, d2)\n                );\n                dotProd += dot(xValues, wValues);\n              }\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
	    }
	    return Conv3DProgram;
	}());
	exports.Conv3DProgram = Conv3DProgram;
	//# sourceMappingURL=conv_gpu.js.map

/***/ },
/* 979 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var DepthwiseConv2DProgram = /** @class */ (function () {
	    function DepthwiseConv2DProgram(convInfo, addBias, activation, hasPreluActivation) {
	        if (addBias === void 0) { addBias = false; }
	        if (activation === void 0) { activation = null; }
	        if (hasPreluActivation === void 0) { hasPreluActivation = false; }
	        this.variableNames = ['x', 'W'];
	        this.outputShape = convInfo.outShape;
	        var xNumRows = convInfo.inHeight;
	        var xNumCols = convInfo.inWidth;
	        var padTop = convInfo.padInfo.top;
	        var padLeft = convInfo.padInfo.left;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var dilationHeight = convInfo.dilationHeight;
	        var dilationWidth = convInfo.dilationWidth;
	        var filterHeight = convInfo.filterHeight;
	        var filterWidth = convInfo.filterWidth;
	        var channelMul = convInfo.outChannels / convInfo.inChannels;
	        var activationSnippet = '', applyActivationSnippet = '';
	        if (activation) {
	            if (hasPreluActivation) {
	                activationSnippet = "float activation(float a) {\n          float b = getPreluActivationWeightsAtOutCoords();\n          " + activation + "\n        }";
	            }
	            else {
	                activationSnippet = "\n          float activation(float x) {\n            " + activation + "\n          }\n        ";
	            }
	            applyActivationSnippet = "result = activation(result);";
	        }
	        var addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
	        if (addBias) {
	            this.variableNames.push('bias');
	        }
	        if (hasPreluActivation) {
	            this.variableNames.push('preluActivationWeights');
	        }
	        this.userCode = "\n      " + activationSnippet + "\n\n      const ivec2 strides = ivec2(" + strideHeight + ", " + strideWidth + ");\n      const ivec2 pads = ivec2(" + padTop + ", " + padLeft + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords.x;\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int d2 = coords.w;\n        int d1 = d2 / " + channelMul + ";\n        int q = d2 - d1 * " + channelMul + ";\n\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // Convolve x(?, ?, d1) with w(:, :, d1, q) to get y(yR, yC, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        // TO DO(dsmilkov): Flatten the two for loops and vec4 the operations.\n        for (int wR = 0; wR < " + filterHeight + "; wR++) {\n          int xR = xRCorner + wR * " + dilationHeight + ";\n\n          if (xR < 0 || xR >= " + xNumRows + ") {\n            continue;\n          }\n\n          for (int wC = 0; wC < " + filterWidth + "; wC++) {\n            int xC = xCCorner + wC * " + dilationWidth + ";\n\n            if (xC < 0 || xC >= " + xNumCols + ") {\n              continue;\n            }\n\n            float xVal = getX(batch, xR, xC, d1);\n            float wVal = getW(wR, wC, d1, q);\n            dotProd += xVal * wVal;\n          }\n        }\n\n        float result = dotProd;\n        " + addBiasSnippet + "\n        " + applyActivationSnippet + "\n        setOutput(result);\n      }\n    ";
	    }
	    return DepthwiseConv2DProgram;
	}());
	exports.DepthwiseConv2DProgram = DepthwiseConv2DProgram;
	//# sourceMappingURL=conv_gpu_depthwise.js.map

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util = __webpack_require__(10);
	var DepthwiseConvPacked2DProgram = /** @class */ (function () {
	    function DepthwiseConvPacked2DProgram(convInfo, addBias, activation, hasPreluActivation) {
	        if (addBias === void 0) { addBias = false; }
	        if (activation === void 0) { activation = null; }
	        if (hasPreluActivation === void 0) { hasPreluActivation = false; }
	        this.variableNames = ['x', 'W'];
	        this.packedInputs = true;
	        this.packedOutput = true;
	        this.outputShape = convInfo.outShape;
	        var xNumRows = convInfo.inHeight;
	        var xNumCols = convInfo.inWidth;
	        var padTop = convInfo.padInfo.top;
	        var padLeft = convInfo.padInfo.left;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var dilationHeight = convInfo.dilationHeight;
	        var dilationWidth = convInfo.dilationWidth;
	        var filterHeight = convInfo.filterHeight;
	        var filterWidth = convInfo.filterWidth;
	        var texelsAcross = filterWidth;
	        var mainLoop = "int xR; int xC; int xCOffset;";
	        for (var r = 0; r < filterHeight; r++) {
	            for (var c = 0; c < filterWidth; c++) {
	                mainLoop += "\n          vec4 xTexelR" + r + "C" + c * 2 + " = vec4(0.);\n          vec4 wR" + r + "C" + c + " = vec4(0.);\n          vec4 xR" + r + "C" + c + " = vec4(0.);";
	            }
	        }
	        /**
	         * This vectorized implementation works by gathering the values needed for
	         * each output channel's dot product into vec4's and then multiplying them
	         * all together (this happens in the final double for-loop below). Most of
	         * the main loop consists of constructing these vec4's with the minimum
	         * number of texture2D calls, which means making use of all four returned
	         * values from a texture2D call at once.
	         */
	        for (var r = 0; r < filterHeight; r++) {
	            for (var texelC = 0; texelC < texelsAcross; texelC++) {
	                var c = texelC * 2;
	                mainLoop += "\n          xR = xRCorner + " + r * dilationHeight + ";\n          xC = xCCorner + " + c * dilationWidth + ";\n        ";
	                if (strideWidth === 1) {
	                    if (c < filterWidth) {
	                        // If padding is odd, the outer texels have to be composed.
	                        if (padLeft % 2 === 1) {
	                            // TODO: Ensure vec4 previous does not result in redundant sample,
	                            // and avoid setting xTexelRC's that exceed the boundary in the
	                            // first place rather than resetting them to vec4(0)).
	                            // To compute xCOffset:
	                            // - If padding is odd, we must add 1 to ensure we ask for an
	                            // even-numbered row.
	                            // - We subtract 2 to access the previous texel.
	                            mainLoop += "\n                xCOffset = xC + 1;\n                if(xR >= 0 && xR < " + xNumRows + " && xCOffset >= 0 && xCOffset < " + xNumCols + ") {\n                  xTexelR" + r + "C" + c + " = getX(batch, xR, xCOffset, d1);\n\n                  // Need to manually clear unused channels in case\n                  // we're reading from recycled texture.\n                  if(xCOffset + 1 >= " + xNumCols + ") {\n                    xTexelR" + r + "C" + c + ".zw = vec2(0.);\n                  }\n                } else {\n                  xTexelR" + r + "C" + c + " = vec4(0.);\n                }\n\n                xCOffset = xC + 1 - 2;\n                if(xR >= 0 && xR < " + xNumRows + " && xCOffset >= 0 && xCOffset < " + xNumCols + ") {\n                  vec4 previous = getX(batch, xR, xCOffset, d1);\n\n                  // Need to manually clear unused channels in case\n                  // we're reading from recycled texture.\n                  if(xCOffset + 1 >= " + xNumCols + ") {\n                    previous.zw = vec2(0.);\n                  }\n\n                  xR" + r + "C" + c + " = vec4(previous.zw, xTexelR" + r + "C" + c + ".xy);\n                } else {\n                  xR" + r + "C" + c + " = vec4(0, 0, xTexelR" + r + "C" + c + ".xy);\n                }\n              ";
	                        }
	                        else {
	                            // Padding is even, so xRC corresponds to a single texel.
	                            mainLoop += "\n                if(xR >= 0 && xR < " + xNumRows + " && xC >= 0 && xC < " + xNumCols + ") {\n                  xTexelR" + r + "C" + c + " = getX(batch, xR, xC, d1);\n                } else {\n                  xTexelR" + r + "C" + c + " = vec4(0.);\n                }\n\n                xR" + r + "C" + c + " = xTexelR" + r + "C" + c + ";\n              ";
	                        }
	                        if (c + 1 < filterWidth) {
	                            // If dilation is even, the second entry should match the first
	                            // (either both are composed or both are single samples). But if
	                            // dilation is odd, then the second entry should be the opposite
	                            // of the first (if the first is composed, the second is a single
	                            // sample, and vice versa.)
	                            var nextTexelOffset = padLeft % 2 === 0 ?
	                                util.nearestLargerEven(dilationWidth) :
	                                dilationWidth;
	                            if ((dilationWidth % 2 === 0 && padLeft % 2 === 1) ||
	                                (dilationWidth % 2 !== 0 && padLeft % 2 !== 1)) {
	                                mainLoop += "\n                  xCOffset = xC + " + padLeft % 2 + " + " + nextTexelOffset + ";\n\n                  if(xR >= 0 && xR < " + xNumRows + " &&\n                    xCOffset >= 0 && xCOffset < " + xNumCols + ") {\n                    xTexelR" + r + "C" + (c + 2) + " = getX(batch, xR, xCOffset, d1);\n                  }\n                ";
	                                // If dilation > 1 then the xRC's will not be able to share any
	                                // values, so each xRC will require two unique calls to getX.
	                                if (dilationWidth > 1) {
	                                    mainLoop += "\n                    xCOffset -= 2;\n                    if(xR >= 0 && xR < " + xNumRows + " &&\n                      xCOffset >= 0 && xCOffset < " + xNumCols + ") {\n                      xTexelR" + r + "C" + c + " = getX(batch, xR, xCOffset, d1);\n                    } else {\n                      xTexelR" + r + "C" + c + " = vec4(0.);\n                    }\n                  ";
	                                }
	                                mainLoop += "\n                  xR" + r + "C" + (c + 1) + " = vec4(\n                    xTexelR" + r + "C" + c + ".zw, xTexelR" + r + "C" + (c + 2) + ".xy);\n                ";
	                            }
	                            else {
	                                mainLoop += "\n                  xCOffset = xC + " + nextTexelOffset + ";\n\n                  if(xR >= 0 && xR < " + xNumRows + " &&\n                    xCOffset >= 0 && xCOffset < " + xNumCols + ") {\n                    xTexelR" + r + "C" + (c + 2) + " = getX(batch, xR, xCOffset, d1);\n                  }\n\n                  xR" + r + "C" + (c + 1) + " = xTexelR" + r + "C" + (c + 2) + ";\n                ";
	                            }
	                        }
	                    }
	                }
	                else { // stride > 1
	                    if (c < filterWidth) {
	                        mainLoop += "\n              if(xR >= 0 && xR < " + xNumRows + ") {\n            ";
	                        // Depending on whether padLeft is even or odd, we want either the
	                        // xy or zw channels from X texels for xR${r}C${c}. If padLeft is
	                        // even, xR${r}C${c + 1} is simply the zw channels of texels we've
	                        // already sampled. But if padLeft is odd, xR${r}C{$c + 1}.zw will
	                        // need to come from the xy channels of a new texel, hence the `vec4
	                        // final` initialized below.
	                        if (padLeft % 2 === 1) {
	                            mainLoop += "\n                xCOffset = xC + 1 - " + strideWidth + ";\n                if(xCOffset >= 0 && xCOffset < " + xNumCols + ") {\n                  xTexelR" + r + "C" + c + " = getX(batch, xR, xCOffset, d1);\n                } else {\n                  xTexelR" + r + "C" + c + " = vec4(0.);\n                }\n\n                if(xC + 1 >= 0 && xC + 1 < " + xNumCols + ") {\n                  xTexelR" + r + "C" + (c + 2) + " = getX(batch, xR, xC + 1, d1);\n                } else {\n                  xTexelR" + r + "C" + (c + 2) + " = vec4(0.);\n                }\n\n                xR" + r + "C" + c + " = vec4(\n                  xTexelR" + r + "C" + c + ".zw, xTexelR" + r + "C" + (c + 2) + ".zw);\n              ";
	                            if (c + 1 < filterWidth) {
	                                mainLoop += "\n                  vec4 final = vec4(0.);\n                  xCOffset = xC + 1 + " + strideWidth + ";\n                  if(xCOffset >= 0 && xCOffset < " + xNumCols + ") {\n                    final = getX(batch, xR, xCOffset, d1);\n                  }\n                  xR" + r + "C" + (c + 1) + " = vec4(xTexelR" + r + "C" + (c + 2) + ".xy, final.xy);\n                ";
	                            }
	                        }
	                        else {
	                            mainLoop += "\n                if(xC >= 0 && xC < " + xNumCols + ") {\n                  xTexelR" + r + "C" + c + " = getX(batch, xR, xC, d1);\n                } else {\n                  xTexelR" + r + "C" + c + " = vec4(0.);\n                }\n\n                xCOffset = xC + " + strideWidth + ";\n                if(xCOffset >= 0 && xCOffset < " + xNumCols + ") {\n                  xTexelR" + r + "C" + (c + 2) + " = getX(batch, xR, xCOffset, d1);\n                } else {\n                  xTexelR" + r + "C" + (c + 2) + " = vec4(0.);\n                }\n\n                xR" + r + "C" + c + " = vec4(\n                  xTexelR" + r + "C" + c + ".xy, xTexelR" + r + "C" + (c + 2) + ".xy);\n              ";
	                            if (c + 1 < filterWidth) {
	                                mainLoop += "\n                  xR" + r + "C" + (c + 1) + " = vec4(\n                    xTexelR" + r + "C" + c + ".zw, xTexelR" + r + "C" + (c + 2) + ".zw);\n                ";
	                            }
	                        }
	                        mainLoop += "}";
	                    }
	                }
	                if (c < filterWidth) {
	                    mainLoop += "\n            vec4 wTexelR" + r + "C" + c + " = getW(" + r + ", " + c + ", d1, q);\n            wR" + r + "C" + c + " = vec4(wTexelR" + r + "C" + c + ".xz, wTexelR" + r + "C" + c + ".xz);\n          ";
	                    if (c + 1 < filterWidth) {
	                        mainLoop += "\n              vec4 wTexelR" + r + "C" + (c + 1) + " = getW(" + r + ", " + (c + 1) + ", d1, q);\n              wR" + r + "C" + (c + 1) + " =\n                vec4(wTexelR" + r + "C" + (c + 1) + ".xz, wTexelR" + r + "C" + (c + 1) + ".xz);";
	                    }
	                }
	            }
	        }
	        for (var r = 0; r < filterHeight; r++) {
	            for (var c = 0; c < filterWidth; c++) {
	                mainLoop += "dotProd += xR" + r + "C" + c + " * wR" + r + "C" + c + ";";
	            }
	        }
	        var activationSnippet = '', applyActivationSnippet = '';
	        if (activation) {
	            if (hasPreluActivation) {
	                activationSnippet = "vec4 activation(vec4 a) {\n          vec4 b = getPreluActivationWeightsAtOutCoords();\n          " + activation + "\n        }";
	            }
	            else {
	                activationSnippet = "vec4 activation(vec4 x) {\n          " + activation + "\n        }";
	            }
	            applyActivationSnippet = "result = activation(result);";
	        }
	        var addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
	        if (addBias) {
	            this.variableNames.push('bias');
	        }
	        if (hasPreluActivation) {
	            this.variableNames.push('preluActivationWeights');
	        }
	        this.userCode = "\n      " + activationSnippet + "\n\n      const ivec2 strides = ivec2(" + strideHeight + ", " + strideWidth + ");\n      const ivec2 pads = ivec2(" + padTop + ", " + padLeft + ");\n\n      void main() {\n\n        ivec4 coords = getOutputCoords();\n        int batch = coords.x;\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int d2 = coords.w;\n        int d1 = d2;\n        int q = 0;\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        vec4 dotProd = vec4(0.);\n\n        " + mainLoop + "\n\n        vec4 result = dotProd;\n        " + addBiasSnippet + "\n        " + applyActivationSnippet + "\n        setOutput(result);\n      }\n    ";
	    }
	    return DepthwiseConvPacked2DProgram;
	}());
	exports.DepthwiseConvPacked2DProgram = DepthwiseConvPacked2DProgram;
	//# sourceMappingURL=conv_packed_gpu_depthwise.js.map

/***/ },
/* 981 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var CropAndResizeProgram = /** @class */ (function () {
	    function CropAndResizeProgram(imageShape, boxShape, cropSize, method, extrapolationValue) {
	        this.variableNames = ['Image', 'Boxes', 'BoxInd'];
	        this.outputShape = [];
	        var batch = imageShape[0], imageHeight = imageShape[1], imageWidth = imageShape[2], depth = imageShape[3];
	        var numBoxes = boxShape[0];
	        var cropHeight = cropSize[0], cropWidth = cropSize[1];
	        this.outputShape = [numBoxes, cropHeight, cropWidth, depth];
	        var methodId = method === 'bilinear' ? 1 : 0;
	        var _a = [imageHeight - 1 + ".0", imageWidth - 1 + ".0"], inputHeightFloat = _a[0], inputWidthFloat = _a[1];
	        var _b = cropHeight > 1 ?
	            [
	                "" + (imageHeight - 1) / (cropHeight - 1),
	                '(y2-y1) * height_ratio',
	                "y1*" + inputHeightFloat + " + float(y)*(height_scale)",
	            ] :
	            [
	                '0.0',
	                '0.0',
	                "0.5 * (y1+y2) * " + inputHeightFloat,
	            ], heightRatio = _b[0], heightScale = _b[1], inY = _b[2];
	        var _c = cropWidth > 1 ?
	            [
	                "" + (imageWidth - 1) / (cropWidth - 1),
	                '(x2-x1) * width_ratio',
	                "x1*" + inputWidthFloat + " + float(x)*(width_scale)",
	            ] :
	            [
	                '0.0',
	                '0.0',
	                "0.5 * (x1+x2) * " + inputWidthFloat,
	            ], widthRatio = _c[0], widthScale = _c[1], inX = _c[2];
	        // Reference implementation
	        // tslint:disable-next-line:max-line-length
	        // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/crop_and_resize_op_gpu.cu.cc
	        this.userCode = "\n      const float height_ratio = float(" + heightRatio + ");\n      const float width_ratio = float(" + widthRatio + ");\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int y = coords[1];\n        int x = coords[2];\n        int d = coords[3];\n\n        // get box vals\n        float y1 = getBoxes(b,0);\n        float x1 = getBoxes(b,1);\n        float y2 = getBoxes(b,2);\n        float x2 = getBoxes(b,3);\n\n        // get image in batch index\n        int bInd = round(getBoxInd(b));\n        if(bInd < 0 || bInd >= " + batch + ") {\n          return;\n        }\n\n        float height_scale = " + heightScale + ";\n        float width_scale = " + widthScale + ";\n\n        float in_y = " + inY + ";\n        if( in_y < 0.0 || in_y > " + inputHeightFloat + " ) {\n          setOutput(float(" + extrapolationValue + "));\n          return;\n        }\n        float in_x = " + inX + ";\n        if( in_x < 0.0 || in_x > " + inputWidthFloat + " ) {\n          setOutput(float(" + extrapolationValue + "));\n          return;\n        }\n\n        vec2 sourceFracIndexCR = vec2(in_x,in_y);\n        if(" + methodId + " == 1) {\n          // Compute the four integer indices.\n          ivec2 sourceFloorCR = ivec2(sourceFracIndexCR);\n          ivec2 sourceCeilCR = ivec2(ceil(sourceFracIndexCR));\n\n          float topLeft = getImage(b, sourceFloorCR.y, sourceFloorCR.x, d);\n          float bottomLeft = getImage(b, sourceCeilCR.y, sourceFloorCR.x, d);\n          float topRight = getImage(b, sourceFloorCR.y, sourceCeilCR.x, d);\n          float bottomRight = getImage(b, sourceCeilCR.y, sourceCeilCR.x, d);\n\n          vec2 fracCR = sourceFracIndexCR - vec2(sourceFloorCR);\n\n          float top = topLeft + (topRight - topLeft) * fracCR.x;\n          float bottom = bottomLeft + (bottomRight - bottomLeft) * fracCR.x;\n          float newValue = top + (bottom - top) * fracCR.y;\n          setOutput(newValue);\n        } else {\n          // Compute the coordinators of nearest neighbor point.\n          ivec2 sourceNearestCR = ivec2(floor(\n            sourceFracIndexCR + vec2(0.5,0.5)));\n          float newValue = getImage(b, sourceNearestCR.y, sourceNearestCR.x, d);\n          setOutput(newValue);\n        }\n      }\n    ";
	    }
	    return CropAndResizeProgram;
	}());
	exports.CropAndResizeProgram = CropAndResizeProgram;
	//# sourceMappingURL=crop_and_resize_gpu.js.map

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var shader_compiler_1 = __webpack_require__(41);
	var CumSumProgram = /** @class */ (function () {
	    function CumSumProgram(shape, exclusive, reverse) {
	        this.variableNames = ['x'];
	        this.outputShape = shape;
	        var rank = shape.length;
	        var finalDim = shape[shape.length - 1];
	        var comparator = reverse ? '<' : '>';
	        this.userCode = "\n      int getIndex(int i) {\n        " + (reverse ? "return " + finalDim + " -i - 1;" : 'return i;') + "\n      }\n\n      void main() {\n        " + shader_compiler_1.getCoordsDataType(rank) + " coords = getOutputCoords();\n        int end = " + getFinalCoord(rank, 'coords') + ";\n        float val = 0.0;\n        for (int i = " + finalDim + " - 1; i >= 0; i -= 1) {\n          int idx = getIndex(i);\n          if (idx " + comparator + " end) {\n            continue;\n          }\n          if (idx == end && " + exclusive + ") {\n            continue;\n          }\n          " + getFinalCoord(rank, 'coords') + " = idx;\n          val += getX(" + getCoords(rank, 'coords') + ");\n        }\n        setOutput(val);\n      }\n    ";
	    }
	    return CumSumProgram;
	}());
	exports.CumSumProgram = CumSumProgram;
	function getCoords(rank, name) {
	    if (rank === 1) {
	        return "" + name;
	    }
	    else if (rank === 2) {
	        return name + ".x, " + name + ".y";
	    }
	    else if (rank === 3) {
	        return name + ".x, " + name + ".y, " + name + ".z";
	    }
	    else if (rank === 4) {
	        return name + ".x, " + name + ".y, " + name + ".z, " + name + ".w";
	    }
	    else {
	        throw Error("Cumulative sum for rank " + rank + " is not yet supported");
	    }
	}
	function getFinalCoord(rank, name) {
	    if (rank === 1) {
	        return "" + name;
	    }
	    else if (rank === 2) {
	        return name + ".y";
	    }
	    else if (rank === 3) {
	        return name + ".z";
	    }
	    else if (rank === 4) {
	        return name + ".w";
	    }
	    else {
	        throw Error("Cumulative sum for rank " + rank + " is not yet supported");
	    }
	}
	//# sourceMappingURL=cumsum_gpu.js.map

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var glsl_version_1 = __webpack_require__(81);
	var shader_util = __webpack_require__(120);
	var tex_util_1 = __webpack_require__(82);
	var DecodeMatrixProgram = /** @class */ (function () {
	    function DecodeMatrixProgram(outputShape) {
	        this.variableNames = ['A'];
	        this.packedInputs = false;
	        this.packedOutput = true;
	        this.outPackingScheme = tex_util_1.PackingScheme.DENSE;
	        var texShape = tex_util_1.getDenseTexShape(outputShape);
	        var glsl = glsl_version_1.getGlslDifferences();
	        this.outputShape = outputShape;
	        this.userCode = "\n      ivec3 outCoordsFromFlatIndex(int index) {\n        " + shader_util.getLogicalCoordinatesFromFlatIndex(['r', 'c', 'd'], outputShape) + "\n        return ivec3(r, c, d);\n      }\n\n      void main() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n          vec2(" + texShape[0] + ", " + texShape[1] + "));\n        int index = 4 * (resTexRC.x * " + texShape[1] + " + resTexRC.y);\n\n        vec4 result = vec4(0.);\n\n        for (int i=0; i<4; i++) {\n          int flatIndex = index + i;\n          ivec3 rc = outCoordsFromFlatIndex(flatIndex);\n          result[i] = getA(rc.x, rc.y, rc.z);\n        }\n\n        " + glsl.output + " = result;\n      }\n    ";
	    }
	    return DecodeMatrixProgram;
	}());
	exports.DecodeMatrixProgram = DecodeMatrixProgram;
	//# sourceMappingURL=decode_matrix_gpu.js.map

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var glsl_version_1 = __webpack_require__(81);
	var shader_util = __webpack_require__(120);
	var tex_util_1 = __webpack_require__(82);
	var DecodeMatrixPackedProgram = /** @class */ (function () {
	    function DecodeMatrixPackedProgram(outputShape) {
	        this.variableNames = ['A'];
	        this.packedInputs = true;
	        this.packedOutput = true;
	        this.outPackingScheme = tex_util_1.PackingScheme.DENSE;
	        var texShape = tex_util_1.getDenseTexShape(outputShape);
	        var glsl = glsl_version_1.getGlslDifferences();
	        this.outputShape = outputShape;
	        this.userCode = "\n      ivec3 outCoordsFromFlatIndex(int index) {\n        " + shader_util.getLogicalCoordinatesFromFlatIndex(['r', 'c', 'd'], outputShape) + "\n        return ivec3(r, c, d);\n      }\n\n      void main() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n          vec2(" + texShape[0] + ", " + texShape[1] + "));\n        int index = 4 * (resTexRC.x * " + texShape[1] + " + resTexRC.y);\n\n        vec4 result = vec4(0.);\n\n        for (int i=0; i<4; i++) {\n          int flatIndex = index + i;\n          ivec3 rc = outCoordsFromFlatIndex(flatIndex);\n          result[i] = getChannel(getA(rc.x, rc.y, rc.z), vec2(rc.y, rc.z));\n        }\n\n        " + glsl.output + " = result;\n      }\n    ";
	    }
	    return DecodeMatrixPackedProgram;
	}());
	exports.DecodeMatrixPackedProgram = DecodeMatrixPackedProgram;
	//# sourceMappingURL=decode_matrix_packed_gpu.js.map

/***/ },
/* 985 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var DepthToSpaceProgram = /** @class */ (function () {
	    function DepthToSpaceProgram(outputShape, blockSize, dataFormat) {
	        this.variableNames = ['x'];
	        this.outputShape = [];
	        this.outputShape = outputShape;
	        this.blockSize = blockSize;
	        this.dataFormat = dataFormat;
	        this.userCode = "\n    void main() {\n      ivec4 coords = getOutputCoords();\n      int b = coords[0];\n      int h = " + this.getHeightCoordString() + ";\n      int w = " + this.getWidthCoordString() + ";\n      int d = " + this.getDepthCoordString() + ";\n\n      int in_h = h / " + blockSize + ";\n      int offset_h = imod(h, " + blockSize + ");\n      int in_w = w / " + blockSize + ";\n      int offset_w = imod(w, " + blockSize + ");\n      int offset_d = (offset_h * " + blockSize + " + offset_w) *\n        " + this.getOutputDepthSize() + ";\n      int in_d = d + offset_d;\n\n      float result = " + this.getInputSamplingString() + ";\n      setOutput(result);\n    }\n  ";
	    }
	    DepthToSpaceProgram.prototype.getHeightCoordString = function () {
	        if (this.dataFormat === 'NHWC') {
	            return "coords[1]";
	        }
	        else {
	            return "coords[2]";
	        }
	    };
	    DepthToSpaceProgram.prototype.getWidthCoordString = function () {
	        if (this.dataFormat === 'NHWC') {
	            return "coords[2]";
	        }
	        else {
	            return "coords[3]";
	        }
	    };
	    DepthToSpaceProgram.prototype.getDepthCoordString = function () {
	        if (this.dataFormat === 'NHWC') {
	            return "coords[3]";
	        }
	        else {
	            return "coords[1]";
	        }
	    };
	    DepthToSpaceProgram.prototype.getOutputDepthSize = function () {
	        if (this.dataFormat === 'NHWC') {
	            return this.outputShape[3];
	        }
	        else {
	            return this.outputShape[1];
	        }
	    };
	    DepthToSpaceProgram.prototype.getInputSamplingString = function () {
	        if (this.dataFormat === 'NHWC') {
	            return "getX(b, in_h, in_w, in_d)";
	        }
	        else {
	            return "getX(b, in_d, in_h, in_w)";
	        }
	    };
	    return DepthToSpaceProgram;
	}());
	exports.DepthToSpaceProgram = DepthToSpaceProgram;
	//# sourceMappingURL=depth_to_space_gpu.js.map

/***/ },
/* 986 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var DiagProgram = /** @class */ (function () {
	    function DiagProgram(size) {
	        this.variableNames = ['X'];
	        this.outputShape = [size, size];
	        this.userCode = "\n      void main() {\n          ivec2 coords = getOutputCoords();\n          float val = coords[0] == coords[1] ? getX(coords[0]) : 0.0;\n          setOutput(val);\n      }\n    ";
	    }
	    return DiagProgram;
	}());
	exports.DiagProgram = DiagProgram;
	//# sourceMappingURL=diag_gpu.js.map

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var glsl_version_1 = __webpack_require__(81);
	var shader_compiler_util_1 = __webpack_require__(120);
	var tex_util_1 = __webpack_require__(82);
	var EncodeFloatProgram = /** @class */ (function () {
	    function EncodeFloatProgram(outputShape) {
	        this.variableNames = ['A'];
	        this.outTexUsage = tex_util_1.TextureUsage.DOWNLOAD;
	        var glsl = glsl_version_1.getGlslDifferences();
	        this.outputShape = outputShape;
	        this.userCode = "\n      " + shader_compiler_util_1.ENCODE_FLOAT_SNIPPET + "\n\n      void main() {\n        float x = getAAtOutCoords();\n        " + glsl.output + " = encode_float(x);\n      }\n    ";
	    }
	    return EncodeFloatProgram;
	}());
	exports.EncodeFloatProgram = EncodeFloatProgram;
	//# sourceMappingURL=encode_float_gpu.js.map

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var glsl_version_1 = __webpack_require__(81);
	var shader_compiler_util_1 = __webpack_require__(120);
	var tex_util_1 = __webpack_require__(82);
	var EncodeFloatPackedProgram = /** @class */ (function () {
	    function EncodeFloatPackedProgram(outputShape) {
	        this.variableNames = ['A'];
	        this.packedInputs = true;
	        this.packedOutput = false;
	        this.outTexUsage = tex_util_1.TextureUsage.DOWNLOAD;
	        var glsl = glsl_version_1.getGlslDifferences();
	        this.outputShape = outputShape;
	        this.userCode = "\n      " + shader_compiler_util_1.ENCODE_FLOAT_SNIPPET + "\n\n      void main() {\n        ivec3 coords = getOutputCoords();\n        float x = getChannel(getAAtOutCoords(), vec2(coords.y, coords.z));\n        " + glsl.output + " = encode_float(x);\n      }\n    ";
	    }
	    return EncodeFloatPackedProgram;
	}());
	exports.EncodeFloatPackedProgram = EncodeFloatPackedProgram;
	//# sourceMappingURL=encode_float_packed_gpu.js.map

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var glsl_version_1 = __webpack_require__(81);
	var shader_util = __webpack_require__(120);
	var EncodeMatrixProgram = /** @class */ (function () {
	    function EncodeMatrixProgram(outputShape, texShape, inputIsUnsignedByte) {
	        if (inputIsUnsignedByte === void 0) { inputIsUnsignedByte = false; }
	        this.variableNames = ['A'];
	        var glsl = glsl_version_1.getGlslDifferences();
	        var height = texShape[0], width = texShape[1];
	        this.outputShape = outputShape;
	        var output = "result";
	        if (inputIsUnsignedByte) {
	            output = "floor(result * 255. + 0.5)";
	        }
	        this.userCode = "\n      " + shader_util.getFlatIndexFrom3D(outputShape) + "\n\n      void main() {\n        ivec3 coords = getOutputCoords();\n\n        int flatIndex = getFlatIndex(coords);\n        int offset = imod(flatIndex, 4);\n\n        flatIndex = idiv(flatIndex, 4, 1.);\n        \n        int r = flatIndex / " + width + ";\n        int c = imod(flatIndex, " + width + ");\n        vec2 uv = (vec2(c, r) + halfCR) / vec2(" + width + ".0, " + height + ".0);\n        vec4 values = " + glsl.texture2D + "(A, uv);\n\n        float result;\n\n        if(offset == 0) {\n          result = values[0];\n        } else if(offset == 1) {\n          result = values[1];\n        } else if(offset == 2) {\n          result = values[2];\n        } else {\n          result = values[3];\n        }\n\n        " + glsl.output + " = vec4(" + output + ", 0., 0., 0.);\n      }\n    ";
	    }
	    return EncodeMatrixProgram;
	}());
	exports.EncodeMatrixProgram = EncodeMatrixProgram;
	//# sourceMappingURL=encode_matrix_gpu.js.map

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var glsl_version_1 = __webpack_require__(81);
	var shader_util = __webpack_require__(120);
	/*
	This is how the shader encodes a tensor with shape = [2, 3, 5]
	(indices are [batch, row, col]).
	
	000|001   002|003   004|xxx   020|021   022|023   024|xxx
	-------   -------   -------   -------   -------   -------
	010|011   012|013   014|xxx   xxx|xxx   xxx|xxx   xxx|xxx
	
	100|101   102|103   104|xxx   120|121   122|123   124|xxx
	-------   -------   -------   -------   -------   -------
	110|111   112|113   114|xxx   xxx|xxx   xxx|xxx   xxx|xxx
	
	Single texels contain only values from the same batch, and from adjacent rows
	and columns.
	 */
	var EncodeMatrixPackedProgram = /** @class */ (function () {
	    function EncodeMatrixPackedProgram(outputShape, texShape, inputIsUnsignedByte) {
	        if (inputIsUnsignedByte === void 0) { inputIsUnsignedByte = false; }
	        this.variableNames = ['A'];
	        this.packedInputs = false;
	        this.packedOutput = true;
	        var glsl = glsl_version_1.getGlslDifferences();
	        var height = texShape[0], width = texShape[1];
	        this.outputShape = outputShape;
	        var mainLoop = '';
	        var output = 'result';
	        if (inputIsUnsignedByte) {
	            output = 'floor(result * 255. + 0.5)';
	        }
	        for (var row = 0; row <= 1; row++) {
	            for (var col = 0; col <= 1; col++) {
	                var channel = row * 2 + col;
	                mainLoop += "\n          localCoords = coords;\n          if(localCoords[2] + " + col + " < " + outputShape[2] + ") {\n            localCoords[2] += " + col + ";\n            if(localCoords[1] + " + row + " < " + outputShape[1] + ") {\n              localCoords[1] += " + row + ";\n\n              flatIndex = getFlatIndex(localCoords);\n              offset = imod(flatIndex, 4);\n\n              flatIndex = idiv(flatIndex, 4, 1.);\n\n              r = flatIndex / " + width + ";\n              c = imod(flatIndex, " + width + ");\n              uv = (vec2(c, r) + halfCR) / vec2(" + width + ".0, " + height + ".0);\n              values = " + glsl.texture2D + "(A, uv);\n\n              if(offset == 0) {\n                result[" + channel + "] = values[0];\n              } else if(offset == 1) {\n                result[" + channel + "] = values[1];\n              } else if(offset == 2) {\n                result[" + channel + "] = values[2];\n              } else {\n                result[" + channel + "] = values[3];\n              }\n            }\n          }\n        ";
	            }
	        }
	        this.userCode = "\n      " + shader_util.getFlatIndexFrom3D(outputShape) + "\n\n      void main() {\n        ivec3 coords = getOutputCoords();\n\n        vec4 result = vec4(0.);\n        int flatIndex, r, c, offset;\n        ivec3 localCoords;\n        vec2 uv;\n        vec4 values;\n\n        " + mainLoop + "\n\n        " + glsl.output + " = " + output + ";\n      }\n    ";
	    }
	    return EncodeMatrixPackedProgram;
	}());
	exports.EncodeMatrixPackedProgram = EncodeMatrixPackedProgram;
	//# sourceMappingURL=encode_matrix_packed_gpu.js.map

/***/ },
/* 991 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var FillProgram = /** @class */ (function () {
	    function FillProgram(shape, value) {
	        this.outputShape = [];
	        this.variableNames = ['x'];
	        this.outputShape = shape;
	        this.userCode = "\n      uniform float value;\n      void main() {\n        // Input can be obtained from uniform value.\n        setOutput(value);\n      }\n    ";
	    }
	    FillProgram.prototype.getCustomSetupFunc = function (value) {
	        var _this = this;
	        return function (gpgpu, webGLProgram) {
	            if (_this.valueLoc == null) {
	                _this.valueLoc = gpgpu.getUniformLocationNoThrow(webGLProgram, 'value');
	            }
	            gpgpu.gl.uniform1f(_this.valueLoc, value);
	        };
	    };
	    return FillProgram;
	}());
	exports.FillProgram = FillProgram;
	//# sourceMappingURL=fill_gpu.js.map

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var device_util = __webpack_require__(311);
	var environment_1 = __webpack_require__(28);
	var webgl_util = __webpack_require__(189);
	var ENV = environment_1.env();
	/**
	 * This file contains WebGL-specific flag registrations.
	 */
	/**
	 * True if WebGL is supported.
	 */
	ENV.registerFlag('HAS_WEBGL', function () { return ENV.getNumber('WEBGL_VERSION') > 0; });
	/** 0: No WebGL, 1: WebGL 1.0, 2: WebGL 2.0. */
	ENV.registerFlag('WEBGL_VERSION', function () {
	    if (webgl_util.isWebGLVersionEnabled(2)) {
	        return 2;
	    }
	    else if (webgl_util.isWebGLVersionEnabled(1)) {
	        return 1;
	    }
	    return 0;
	});
	ENV.registerFlag('WEBGL_BUFFER_SUPPORTED', function () { return ENV.get('WEBGL_VERSION') === 2; });
	/** Whether the WebGL backend will sometimes forward ops to the CPU. */
	ENV.registerFlag('WEBGL_CPU_FORWARD', function () { return true; });
	/** Whether the WebGL backend will always use f16 textures for rendering. */
	ENV.registerFlag('WEBGL_FORCE_F16_TEXTURES', function () { return false; });
	/** Whether to turn all packing related flags on. */
	ENV.registerFlag('WEBGL_PACK', function () { return ENV.getBool('HAS_WEBGL'); });
	/** Whether we will pack the batchnormalization op. */
	ENV.registerFlag('WEBGL_PACK_NORMALIZATION', function () { return ENV.getBool('WEBGL_PACK'); });
	/** Whether we will pack the clip op. */
	ENV.registerFlag('WEBGL_PACK_CLIP', function () { return ENV.getBool('WEBGL_PACK'); });
	/** Whether we will pack the depthwise conv op. */
	// TODO: https://github.com/tensorflow/tfjs/issues/1679
	ENV.registerFlag('WEBGL_PACK_DEPTHWISECONV', function () { return false; });
	/** Whether we will pack binary ops. */
	ENV.registerFlag('WEBGL_PACK_BINARY_OPERATIONS', function () { return ENV.getBool('WEBGL_PACK'); });
	/** Whether we will pack unary ops. */
	ENV.registerFlag('WEBGL_PACK_UNARY_OPERATIONS', function () { return ENV.getBool('WEBGL_PACK'); });
	/** Whether we will pack array ops. */
	ENV.registerFlag('WEBGL_PACK_ARRAY_OPERATIONS', function () { return ENV.getBool('WEBGL_PACK'); });
	/** Whether we will pack image ops. */
	ENV.registerFlag('WEBGL_PACK_IMAGE_OPERATIONS', function () { return ENV.getBool('WEBGL_PACK'); });
	/** Whether we will pack reduce ops. */
	ENV.registerFlag('WEBGL_PACK_REDUCE', function () { return ENV.getBool('WEBGL_PACK'); });
	/** Whether packed WebGL kernels lazily unpack their outputs. */
	ENV.registerFlag('WEBGL_LAZILY_UNPACK', function () { return ENV.getBool('WEBGL_PACK'); });
	/** Whether we will use the im2col algorithm to speed up convolutions. */
	ENV.registerFlag('WEBGL_CONV_IM2COL', function () { return ENV.getBool('WEBGL_PACK'); });
	/** The maximum texture dimension. */
	ENV.registerFlag('WEBGL_MAX_TEXTURE_SIZE', function () { return webgl_util.getWebGLMaxTextureSize(ENV.getNumber('WEBGL_VERSION')); });
	/** The maximum texture dimension. */
	ENV.registerFlag('WEBGL_MAX_TEXTURES_IN_SHADER', function () { return webgl_util.getMaxTexturesInShader(ENV.getNumber('WEBGL_VERSION')); });
	/**
	 * The disjoint_query_timer extension version.
	 * 0: disabled, 1: EXT_disjoint_timer_query, 2:
	 * EXT_disjoint_timer_query_webgl2.
	 * In Firefox with WebGL 2.0,
	 * EXT_disjoint_timer_query_webgl2 is not available, so we must use the
	 * WebGL 1.0 extension.
	 */
	ENV.registerFlag('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION', function () {
	    var webGLVersion = ENV.getNumber('WEBGL_VERSION');
	    if (webGLVersion === 0) {
	        return 0;
	    }
	    return webgl_util.getWebGLDisjointQueryTimerVersion(webGLVersion);
	});
	/**
	 * Whether the timer object from the disjoint_query_timer extension gives
	 * timing information that is reliable.
	 */
	ENV.registerFlag('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE', function () { return ENV.getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') > 0 &&
	    !device_util.isMobile(); });
	/**
	 * Whether the device is physically capable of rendering to float32 textures.
	 */
	ENV.registerFlag('WEBGL_RENDER_FLOAT32_CAPABLE', function () { return webgl_util.isCapableOfRenderingToFloatTexture(ENV.getNumber('WEBGL_VERSION')); });
	/**
	 * Whether rendering to float32 textures is enabled. If disabled, renders to
	 * float16 textures.
	 */
	ENV.registerFlag('WEBGL_RENDER_FLOAT32_ENABLED', function () {
	    return ENV.getBool('WEBGL_FORCE_F16_TEXTURES') ?
	        false :
	        ENV.getBool('WEBGL_RENDER_FLOAT32_CAPABLE');
	});
	/**
	 * Whether downloading float textures is enabled (16 or 32 bit). If disabled,
	 * uses IEEE 754 encoding of the float32 values to 4 uint8 when downloading.
	 */
	ENV.registerFlag('WEBGL_DOWNLOAD_FLOAT_ENABLED', function () { return webgl_util.isDownloadFloatTextureEnabled(ENV.getNumber('WEBGL_VERSION')); });
	/** Whether the fence API is available. */
	ENV.registerFlag('WEBGL_FENCE_API_ENABLED', function () { return webgl_util.isWebGLFenceEnabled(ENV.getNumber('WEBGL_VERSION')); });
	/**
	 * Tensors with size <= than this will be uploaded as uniforms, not textures.
	 */
	ENV.registerFlag('WEBGL_SIZE_UPLOAD_UNIFORM', function () {
	    // Use uniform uploads only when 32bit floats are supported. In
	    // 16bit
	    // environments there are problems with comparing a 16bit texture value
	    // with a 32bit uniform value.
	    var useUniforms = ENV.getBool('WEBGL_RENDER_FLOAT32_ENABLED');
	    return useUniforms ? 4 : 0;
	});
	//# sourceMappingURL=flags_webgl.js.map

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var shader_compiler_1 = __webpack_require__(41);
	var GatherProgram = /** @class */ (function () {
	    function GatherProgram(aShape, indicesLength, axis) {
	        this.variableNames = ['A', 'indices'];
	        var outputShape = aShape.slice();
	        outputShape[axis] = indicesLength;
	        this.outputShape = outputShape;
	        this.rank = outputShape.length;
	        var dtype = shader_compiler_1.getCoordsDataType(this.rank);
	        var sourceCoords = getSourceCoords(aShape, axis);
	        this.userCode = "\n      void main() {\n        " + dtype + " resRC = getOutputCoords();\n        setOutput(getA(" + sourceCoords + "));\n      }\n    ";
	    }
	    return GatherProgram;
	}());
	exports.GatherProgram = GatherProgram;
	function getSourceCoords(aShape, axis) {
	    var rank = aShape.length;
	    if (rank > 4) {
	        throw Error("Gather for rank " + rank + " is not yet supported");
	    }
	    if (rank === 1) {
	        return "int(getIndices(resRC))";
	    }
	    var currentCoords = ['resRC.x', 'resRC.y', 'resRC.z', 'resRC.w'];
	    var sourceCoords = [];
	    for (var i = 0; i < aShape.length; i++) {
	        if (i === axis) {
	            sourceCoords.push("int(getIndices(" + currentCoords[i] + "))");
	        }
	        else {
	            sourceCoords.push("" + currentCoords[i]);
	        }
	    }
	    return sourceCoords.join();
	}
	//# sourceMappingURL=gather_gpu.js.map

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var shader_compiler_1 = __webpack_require__(41);
	var GatherNDProgram = /** @class */ (function () {
	    function GatherNDProgram(sliceDim, strides, shape) {
	        this.sliceDim = sliceDim;
	        this.strides = strides;
	        this.variableNames = ['x', 'indices'];
	        this.outputShape = shape;
	        var stridesType = shader_compiler_1.getCoordsDataType(strides.length);
	        var dtype = shader_compiler_1.getCoordsDataType(shape.length);
	        var strideString = this.sliceDim > 1 ? 'strides[j]' : 'strides';
	        this.userCode = "\n        " + stridesType + " strides = " + stridesType + "(" + this.strides + ");\n         void main() {\n          " + dtype + " coords = getOutputCoords();\n          int flattenIndex = 0;\n          for (int j = 0; j < " + this.sliceDim + "; j++) {\n            int index = round(getIndices(coords[0], j));\n            flattenIndex += index * " + strideString + ";\n          }\n          setOutput(getX(flattenIndex, coords[1]));\n        }\n      ";
	    }
	    return GatherNDProgram;
	}());
	exports.GatherNDProgram = GatherNDProgram;
	//# sourceMappingURL=gather_nd_gpu.js.map

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var environment_1 = __webpack_require__(28);
	var util = __webpack_require__(10);
	var shader_compiler = __webpack_require__(41);
	function compileProgram(gpgpu, program, inputs, output) {
	    var userCode = program.userCode;
	    var inputInfos = inputs.map(function (input, i) {
	        var shapeInfo = {
	            logicalShape: input.shape,
	            texShape: input.isUniform ? null : input.texData.texShape,
	            isUniform: input.isUniform,
	            isPacked: input.isUniform ? false : input.texData.isPacked,
	            flatOffset: null
	        };
	        if (input.texData != null && input.texData.slice != null &&
	            input.texData.slice.flatOffset > 0) {
	            shapeInfo.flatOffset = input.texData.slice.flatOffset;
	        }
	        return { name: program.variableNames[i], shapeInfo: shapeInfo };
	    });
	    var inShapeInfos = inputInfos.map(function (x) { return x.shapeInfo; });
	    var outShapeInfo = {
	        logicalShape: output.shape,
	        texShape: output.texData.texShape,
	        isUniform: false,
	        isPacked: output.texData.isPacked,
	        flatOffset: null
	    };
	    var source = shader_compiler.makeShader(inputInfos, outShapeInfo, userCode, program.packedInputs);
	    var webGLProgram = gpgpu.createProgram(source);
	    // Add special uniforms (NAN, INFINITY)
	    var infLoc = null;
	    var nanLoc = gpgpu.getUniformLocation(webGLProgram, 'NAN', false);
	    if (environment_1.env().getNumber('WEBGL_VERSION') === 1) {
	        infLoc = gpgpu.getUniformLocation(webGLProgram, 'INFINITY', false);
	    }
	    // Add user-defined uniforms
	    var uniformLocations = {};
	    for (var i = 0; i < program.variableNames.length; i++) {
	        var varName = program.variableNames[i];
	        var shouldThrow = false;
	        uniformLocations[varName] =
	            gpgpu.getUniformLocation(webGLProgram, varName, shouldThrow);
	        uniformLocations["offset" + varName] =
	            gpgpu.getUniformLocation(webGLProgram, "offset" + varName, shouldThrow);
	    }
	    return {
	        program: program,
	        source: source,
	        webGLProgram: webGLProgram,
	        uniformLocations: uniformLocations,
	        inShapeInfos: inShapeInfos,
	        outShapeInfo: outShapeInfo,
	        infLoc: infLoc,
	        nanLoc: nanLoc,
	    };
	}
	exports.compileProgram = compileProgram;
	function validateBinaryAndProgram(shapeInfos, inputs) {
	    if (shapeInfos.length !== inputs.length) {
	        throw Error("Binary was compiled with " + shapeInfos.length + " inputs, but " +
	            ("was executed with " + inputs.length + " inputs"));
	    }
	    shapeInfos.forEach(function (s, i) {
	        var shapeA = s.logicalShape;
	        var input = inputs[i];
	        var shapeB = input.shape;
	        if (!util.arraysEqual(shapeA, shapeB)) {
	            throw Error("Binary was compiled with different shapes than " +
	                ("the current args. Shapes " + shapeA + " and " + shapeB + " must match"));
	        }
	        // The input is uploaded as uniform.
	        if (s.isUniform && input.isUniform) {
	            return;
	        }
	        var texShapeA = s.texShape;
	        var texShapeB = input.isUniform ? null : input.texData.texShape;
	        if (!util.arraysEqual(texShapeA, texShapeB)) {
	            throw Error("Binary was compiled with different texture shapes than the" +
	                (" current args. Shape " + texShapeA + " and " + texShapeB + " must match"));
	        }
	    });
	}
	function runProgram(gpgpu, binary, inputs, output, customSetup) {
	    validateBinaryAndProgram(binary.inShapeInfos, inputs);
	    validateBinaryAndProgram([binary.outShapeInfo], [output]);
	    var outTex = output.texData.texture;
	    var outTexShape = output.texData.texShape;
	    if (output.texData.isPacked) {
	        gpgpu.setOutputPackedMatrixTexture(outTex, outTexShape[0], outTexShape[1]);
	    }
	    else {
	        gpgpu.setOutputMatrixTexture(outTex, outTexShape[0], outTexShape[1]);
	    }
	    gpgpu.setProgram(binary.webGLProgram);
	    // Set special uniforms (NAN, INFINITY)
	    if (environment_1.env().getNumber('WEBGL_VERSION') === 1) {
	        if (binary.infLoc !== null) {
	            gpgpu.gl.uniform1f(binary.infLoc, Infinity);
	        }
	    }
	    if (binary.nanLoc !== null) {
	        gpgpu.gl.uniform1f(binary.nanLoc, NaN);
	    }
	    // Set user-defined inputs
	    inputs.forEach(function (input, i) {
	        var varName = binary.program.variableNames[i];
	        var varLoc = binary.uniformLocations[varName];
	        var varOffsetLoc = binary.uniformLocations["offset" + varName];
	        if (varLoc == null) {
	            // The compiler inferred that this variable is not used in this shader.
	            return;
	        }
	        if (input.isUniform) {
	            // Upload the values of the tensor as uniform.
	            if (util.sizeFromShape(input.shape) < 2) {
	                gpgpu.gl.uniform1f(varLoc, input.uniformValues[0]);
	            }
	            else {
	                var vals = input.uniformValues;
	                if (!(vals instanceof Float32Array)) {
	                    vals = new Float32Array(vals);
	                }
	                gpgpu.gl.uniform1fv(varLoc, vals);
	            }
	            return;
	        }
	        // If the input was sliced, upload the flat offset index.
	        if (input.texData.slice != null && varOffsetLoc != null) {
	            gpgpu.gl.uniform1i(varOffsetLoc, input.texData.slice.flatOffset);
	        }
	        gpgpu.setInputMatrixTexture(input.texData.texture, varLoc, i);
	    });
	    if (customSetup != null) {
	        customSetup(gpgpu, binary.webGLProgram);
	    }
	    gpgpu.executeProgram();
	}
	exports.runProgram = runProgram;
	function makeShaderKey(program, inputs, output) {
	    var keyInputs = '';
	    inputs.concat(output).forEach(function (x) {
	        var hasOffset = x.texData != null && x.texData.slice != null &&
	            x.texData.slice.flatOffset > 0;
	        var texShape = x.isUniform ? 'uniform' : x.texData.texShape;
	        keyInputs += x.shape + "_" + texShape + "_" + hasOffset;
	    });
	    var keyUserCode = program.userCode;
	    var key = program.constructor.name;
	    // Fast string concat. See https://jsperf.com/string-concatenation/14.
	    key += '_' + keyInputs + '_' + keyUserCode;
	    return key;
	}
	exports.makeShaderKey = makeShaderKey;
	//# sourceMappingURL=gpgpu_math.js.map

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var glsl_version_1 = __webpack_require__(81);
	var Im2ColPackedProgram = /** @class */ (function () {
	    function Im2ColPackedProgram(outputShape, inputShape, convInfo) {
	        this.variableNames = ['A'];
	        this.packedInputs = true;
	        this.packedOutput = true;
	        this.outputShape = outputShape;
	        var filterWidth = convInfo.filterWidth, inChannels = convInfo.inChannels, strideWidth = convInfo.strideWidth, strideHeight = convInfo.strideHeight, padInfo = convInfo.padInfo, outWidth = convInfo.outWidth, dilationWidth = convInfo.dilationWidth, dilationHeight = convInfo.dilationHeight, dataFormat = convInfo.dataFormat;
	        var left = padInfo.left, top = padInfo.top;
	        var itemsPerBlockRow = inChannels * filterWidth;
	        var glsl = glsl_version_1.getGlslDifferences();
	        var isChannelsLast = dataFormat === 'channelsLast';
	        var rowDim = isChannelsLast ? 0 : 1;
	        var colDim = isChannelsLast ? 1 : 2;
	        var unrolled = "";
	        for (var row = 0; row <= 1; row++) {
	            for (var col = 0; col <= 1; col++) {
	                unrolled += "\n          blockIndex = rc.y + " + col + ";\n          pos = rc.x + " + row + ";\n\n          if(blockIndex < " + outputShape[1] + " && pos < " + outputShape[0] + ") {\n            offsetY = int(blockIndex / (" + outWidth + ")) * " + strideHeight + " - " + top + ";\n            d0 = offsetY + " + dilationHeight + " * (pos / " + itemsPerBlockRow + ");\n\n            if(d0 < " + inputShape[rowDim] + " && d0 >= 0) {\n\n              offsetX = int(mod(float(blockIndex), " + outWidth + ".) * " + strideWidth + ". - " + left + ".);\n              d1 = offsetX + " + dilationWidth + " * (int(mod(float(pos), " + itemsPerBlockRow + ".) / " + inChannels + ".));\n\n              if(d1 < " + inputShape[colDim] + " && d1 >= 0) {\n\n                ch = int(mod(float(pos), " + inChannels + ".));\n\n                if (" + isChannelsLast + ") {\n                  innerDims = vec2(d1, ch);\n                  result[" + (row * 2 + col) + "] = getChannel(\n                    getA(d0, int(innerDims.x),\n                    int(innerDims.y)), innerDims);\n                } else {\n                  innerDims = vec2(d0, d1);\n                  result[" + (row * 2 + col) + "] = getChannel(\n                    getA(ch, int(innerDims.x),\n                    int(innerDims.y)), innerDims);\n                }\n              }\n            }\n          }\n        ";
	            }
	        }
	        this.userCode = "\n      void main() {\n        ivec2 rc = getOutputCoords();\n\n        vec4 result = vec4(0);\n\n        int blockIndex, pos, offsetY, d0, offsetX, d1, ch;\n        vec2 innerDims;\n\n        " + unrolled + "\n\n        " + glsl.output + " = result;\n      }\n    ";
	    }
	    return Im2ColPackedProgram;
	}());
	exports.Im2ColPackedProgram = Im2ColPackedProgram;
	//# sourceMappingURL=im2col_packed_gpu.js.map

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var environment_1 = __webpack_require__(28);
	var kernel_names_1 = __webpack_require__(88);
	var tex_util_1 = __webpack_require__(82);
	var from_pixels_gpu_1 = __webpack_require__(998);
	var from_pixels_packed_gpu_1 = __webpack_require__(999);
	exports.fromPixelsConfig = {
	    kernelName: kernel_names_1.FromPixels,
	    backendName: 'webgl',
	    kernelFunc: fromPixels,
	};
	var fromPixels2DContext;
	function fromPixels(args) {
	    var inputs = args.inputs, backend = args.backend, attrs = args.attrs;
	    var pixels = inputs.pixels;
	    var numChannels = attrs.numChannels;
	    var isVideo = typeof (HTMLVideoElement) !== 'undefined' &&
	        pixels instanceof HTMLVideoElement;
	    var isImage = typeof (HTMLImageElement) !== 'undefined' &&
	        pixels instanceof HTMLImageElement;
	    var _a = isVideo ?
	        [
	            pixels.videoWidth,
	            pixels.videoHeight
	        ] :
	        [pixels.width, pixels.height], width = _a[0], height = _a[1];
	    var texShape = [height, width];
	    var outShape = [height, width, numChannels];
	    if (isImage || isVideo) {
	        if (fromPixels2DContext == null) {
	            fromPixels2DContext = document.createElement('canvas').getContext('2d');
	        }
	        fromPixels2DContext.canvas.width = width;
	        fromPixels2DContext.canvas.height = height;
	        fromPixels2DContext.drawImage(pixels, 0, 0, width, height);
	        pixels = fromPixels2DContext.canvas;
	    }
	    var tempPixelHandle = backend.makeTensorInfo(texShape, 'int32');
	    // This is a byte texture with pixels.
	    backend.texData.get(tempPixelHandle.dataId).usage = tex_util_1.TextureUsage.PIXELS;
	    backend.gpgpu.uploadPixelDataToTexture(backend.getTexture(tempPixelHandle.dataId), pixels);
	    var program = environment_1.env().getBool('WEBGL_PACK') ?
	        new from_pixels_packed_gpu_1.FromPixelsPackedProgram(outShape) :
	        new from_pixels_gpu_1.FromPixelsProgram(outShape);
	    var res = backend.runWebGLProgram(program, [tempPixelHandle], 'int32');
	    backend.disposeData(tempPixelHandle.dataId);
	    return res;
	}
	//# sourceMappingURL=FromPixels.js.map

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var glsl_version_1 = __webpack_require__(81);
	var FromPixelsProgram = /** @class */ (function () {
	    function FromPixelsProgram(outputShape) {
	        this.variableNames = ['A'];
	        var glsl = glsl_version_1.getGlslDifferences();
	        var height = outputShape[0], width = outputShape[1];
	        this.outputShape = outputShape;
	        this.userCode = "\n      void main() {\n        ivec3 coords = getOutputCoords();\n        int texR = coords[0];\n        int texC = coords[1];\n        int depth = coords[2];\n        vec2 uv = (vec2(texC, texR) + halfCR) / vec2(" + width + ".0, " + height + ".0);\n\n        vec4 values = " + glsl.texture2D + "(A, uv);\n        float value;\n        if (depth == 0) {\n          value = values.r;\n        } else if (depth == 1) {\n          value = values.g;\n        } else if (depth == 2) {\n          value = values.b;\n        } else if (depth == 3) {\n          value = values.a;\n        }\n\n        setOutput(floor(value * 255.0 + 0.5));\n      }\n    ";
	    }
	    return FromPixelsProgram;
	}());
	exports.FromPixelsProgram = FromPixelsProgram;
	//# sourceMappingURL=from_pixels_gpu.js.map

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var glsl_version_1 = __webpack_require__(81);
	var FromPixelsPackedProgram = /** @class */ (function () {
	    function FromPixelsPackedProgram(outputShape) {
	        this.variableNames = ['A'];
	        this.packedInputs = false;
	        this.packedOutput = true;
	        var glsl = glsl_version_1.getGlslDifferences();
	        var height = outputShape[0], width = outputShape[1];
	        this.outputShape = outputShape;
	        this.userCode = "\n      void main() {\n        ivec3 coords = getOutputCoords();\n        int texR = coords[0];\n        int texC = coords[1];\n        int depth = coords[2];\n\n        vec4 result = vec4(0.);\n\n        for(int row=0; row<=1; row++) {\n          for(int col=0; col<=1; col++) {\n            texC = coords[1] + row;\n            depth = coords[2] + col;\n\n            vec2 uv = (vec2(texC, texR) + halfCR) /\n                       vec2(" + width + ".0, " + height + ".0);\n            vec4 values = " + glsl.texture2D + "(A, uv);\n            float value;\n            if (depth == 0) {\n              value = values.r;\n            } else if (depth == 1) {\n              value = values.g;\n            } else if (depth == 2) {\n              value = values.b;\n            } else if (depth == 3) {\n              value = values.a;\n            }\n\n            result[row * 2 + col] = floor(value * 255.0 + 0.5);\n          }\n        }\n\n        " + glsl.output + " = result;\n      }\n    ";
	    }
	    return FromPixelsPackedProgram;
	}());
	exports.FromPixelsPackedProgram = FromPixelsPackedProgram;
	//# sourceMappingURL=from_pixels_packed_gpu.js.map

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var kernel_names_1 = __webpack_require__(88);
	var log_1 = __webpack_require__(313);
	var non_max_suppression_impl_1 = __webpack_require__(188);
	exports.nonMaxSuppressionV5Config = {
	    kernelName: kernel_names_1.NonMaxSuppressionV5,
	    backendName: 'webgl',
	    kernelFunc: function (_a) {
	        var inputs = _a.inputs, backend = _a.backend, attrs = _a.attrs;
	        log_1.warn('tf.nonMaxSuppression() in webgl locks the UI thread. ' +
	            'Call tf.nonMaxSuppressionAsync() instead');
	        var _b = inputs, boxes = _b.boxes, scores = _b.scores;
	        var _c = attrs, maxOutputSize = _c.maxOutputSize, iouThreshold = _c.iouThreshold, scoreThreshold = _c.scoreThreshold, softNmsSigma = _c.softNmsSigma;
	        var gpuBackend = backend;
	        var boxesVals = gpuBackend.readSync(boxes.dataId);
	        var scoresVals = gpuBackend.readSync(scores.dataId);
	        var maxOutputSizeVal = maxOutputSize;
	        var iouThresholdVal = iouThreshold;
	        var scoreThresholdVal = scoreThreshold;
	        var softNmsSigmaVal = softNmsSigma;
	        var _d = non_max_suppression_impl_1.nonMaxSuppressionV5(boxesVals, scoresVals, maxOutputSizeVal, iouThresholdVal, scoreThresholdVal, softNmsSigmaVal), selectedIndices = _d.selectedIndices, selectedScores = _d.selectedScores;
	        return [selectedIndices, selectedScores];
	    }
	};
	//# sourceMappingURL=NonMaxSuppressionV5.js.map

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var kernel_names_1 = __webpack_require__(88);
	var unaryop_gpu_1 = __webpack_require__(309);
	exports.squareConfig = {
	    kernelName: kernel_names_1.Square,
	    backendName: 'webgl',
	    kernelFunc: function (_a) {
	        var inputs = _a.inputs, backend = _a.backend;
	        var x = inputs.x;
	        var webglBackend = backend;
	        var program = new unaryop_gpu_1.UnaryOpProgram(x.shape, unaryop_gpu_1.SQUARE);
	        return webglBackend.runWebGLProgram(program, [x], x.dtype);
	    }
	};
	//# sourceMappingURL=Square.js.map

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2020 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var environment_1 = __webpack_require__(28);
	var kernel_names_1 = __webpack_require__(88);
	var binaryop_gpu_1 = __webpack_require__(307);
	var binaryop_packed_gpu_1 = __webpack_require__(308);
	exports.squaredDifferenceConfig = {
	    kernelName: kernel_names_1.SquaredDifference,
	    backendName: 'webgl',
	    kernelFunc: function (_a) {
	        var inputs = _a.inputs, backend = _a.backend;
	        var _b = inputs, a = _b.a, b = _b.b;
	        var SQUARED_DIFFERENCE = 'return (a - b) * (a - b);';
	        var webGLBackend = backend;
	        var program = environment_1.env().getBool('WEBGL_PACK_BINARY_OPERATIONS') ?
	            new binaryop_packed_gpu_1.BinaryOpPackedProgram(SQUARED_DIFFERENCE, a.shape, b.shape) :
	            new binaryop_gpu_1.BinaryOpProgram(SQUARED_DIFFERENCE, a.shape, b.shape);
	        return webGLBackend.compileAndRun(program, [a, b]);
	    }
	};
	//# sourceMappingURL=SquaredDifference.js.map

/***/ },
/* 1003 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var LRNProgram = /** @class */ (function () {
	    function LRNProgram(xShape, radius, bias, alpha, beta) {
	        this.variableNames = ['x'];
	        this.outputShape = [];
	        var rad = radius;
	        var maxD = xShape[3] - 1;
	        this.outputShape = xShape;
	        // optimize pow(bias + alpha * sum, -beta)
	        // src: https://github.com/tensorflow/tensorflow/..
	        // blob/26033a1644a9c4a5fbe3170ab2e864b6a4ccd4ca/..
	        // tensorflow/core/kernels/mkl_lrn_op.cc#L320
	        var powOperator;
	        var basis = "float(" + bias + ") + float(" + alpha + ") * sum";
	        if (beta === 0.5) {
	            powOperator = "inversesqrt(" + basis + ")";
	        }
	        else if (beta === 1.0) {
	            powOperator = "1.0/(" + basis + ")";
	        }
	        else {
	            powOperator = "exp(log(" + basis + ") * float(-" + beta + "));";
	        }
	        this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int r = coords[1];\n        int c = coords[2];\n        int d = coords[3];\n        float x = getX(b, r, c, d);\n        float sum = 0.0;\n        for (int j = -" + rad + "; j <= " + rad + "; j++) {\n          int idx = d + j;\n          if (idx >= 0 && idx <=  " + maxD + ") {\n            float z = getX(b, r, c, idx);\n            sum += z * z;\n          }\n        }\n        float val = x * " + powOperator + ";\n        setOutput(val);\n      }\n    ";
	    }
	    return LRNProgram;
	}());
	exports.LRNProgram = LRNProgram;
	//# sourceMappingURL=lrn_gpu.js.map

/***/ },
/* 1004 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var LRNGradProgram = /** @class */ (function () {
	    function LRNGradProgram(inputShape, depthRadius, bias, alpha, beta) {
	        this.variableNames = ['inputImage', 'outputImage', 'dy'];
	        this.outputShape = [];
	        this.outputShape = inputShape;
	        this.depth = inputShape[3];
	        this.depthRadius = depthRadius;
	        this.bias = bias;
	        this.alpha = alpha;
	        this.beta = beta;
	        this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int r = coords[1];\n        int c = coords[2];\n\n        float result = 0.0;\n        for (int d = 0; d < " + this.depth + "; ++d) {\n          int depthBegin = int(max(0.0, float(d - " + depthRadius + ")));\n          int depthEnd = int(min(float(" + this.depth + "),\n              float(d + " + depthRadius + " + 1)));\n\n          const int MIN_DEPTH_BEGIN = 0;\n          const int MAX_DEPTH_END = " + this.depth + ";\n\n          float norm = 0.0;\n          for (int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k) {\n            if (k < depthBegin){\n              continue;\n            }\n            else if (k >= depthBegin && k < depthEnd) {\n              norm += getInputImage(b, r, c, k) * getInputImage(b, r, c, k);\n            }\n            else {\n              break;\n            }\n          }\n\n          norm = float(" + alpha + ") * norm + float(" + bias + ");\n\n          for(int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k){\n            if (k < depthBegin){\n              continue;\n            }\n            else if (k >= depthBegin && k < depthEnd){\n              float dyi = -2.0 * float(" + alpha + ")\n                * float(" + beta + ")\n                * getInputImage(b ,r ,c, k) * getOutputImage(b, r, c, d)\n                / norm;\n              if (k == d) {\n                dyi += pow(norm, -1.0 * " + beta + ");\n              }\n              if (k == coords[3]) {\n                dyi *= getDy(b, r, c, d);\n                result += dyi;\n              }\n            }\n            else {\n              break;\n            }\n          }\n      }\n      setOutput(result);\n      }\n    ";
	    }
	    return LRNGradProgram;
	}());
	exports.LRNGradProgram = LRNGradProgram;
	//# sourceMappingURL=lrn_grad_gpu.js.map

/***/ },
/* 1005 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var LRNPackedProgram = /** @class */ (function () {
	    function LRNPackedProgram(xShape, radius, bias, alpha, beta) {
	        this.variableNames = ['x'];
	        this.outputShape = [];
	        this.packedInputs = true;
	        this.packedOutput = true;
	        var rad = radius;
	        var maxD = xShape[3] - 1;
	        this.outputShape = xShape;
	        // optimize pow(bias + alpha * sum, -beta)
	        // src: https://github.com/tensorflow/tensorflow/..
	        // blob/26033a1644a9c4a5fbe3170ab2e864b6a4ccd4ca/..
	        // tensorflow/core/kernels/mkl_lrn_op.cc#L320
	        var powOperator;
	        var basis = "float(" + bias + ") + float(" + alpha + ") * sum";
	        if (beta === 0.5) {
	            powOperator = "inversesqrt(" + basis + ")";
	        }
	        else if (beta === 1.0) {
	            powOperator = "1.0/(" + basis + ")";
	        }
	        else {
	            powOperator = "exp(log(" + basis + ") * float(-" + beta + "));";
	        }
	        this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords.x;\n        int r = coords.y;\n        int c = coords.z;\n        int d = coords.w;\n\n        bool hasNextCol = d < " + this.outputShape[3] + ";\n        bool hasNextRow = c < " + this.outputShape[2] + ";\n\n        vec4 sum = vec4(0.);\n        vec4 xFragAtOutputCoords = getX(b, r, c, d);\n\n        vec4 xAtOutputCoords = vec4(\n          getChannel(xFragAtOutputCoords, vec2(c, d)),\n          hasNextCol ?\n            getChannel(xFragAtOutputCoords, vec2(c, d + 1)) : 0.0,\n          hasNextRow ?\n            getChannel(xFragAtOutputCoords , vec2(c + 1, d)) : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getChannel(xFragAtOutputCoords, vec2(c + 1, d + 1)) : 0.0\n        );\n\n        int firstChannel = d - " + rad + ";\n        vec2 cache = vec2(0.);\n        if(firstChannel >= 0){\n          vec4 firstChannelFrag = getX(b, r, c, firstChannel);\n          cache.x = getChannel(firstChannelFrag, vec2(c, firstChannel));\n            if(hasNextRow){\n              cache.y = getChannel(firstChannelFrag, vec2(c + 1, firstChannel));\n            }\n        }\n\n        ivec2 depth = ivec2(d, d + 1);\n        for (int j = - " + rad + "; j <= " + rad + "; j++) {\n          ivec2 idx = depth + j;\n          bvec2 aboveLowerBound = greaterThanEqual(idx, ivec2(0));\n          bvec2 belowUpperBound = lessThanEqual(idx, ivec2(" + maxD + "));\n\n          bool depthInRange = aboveLowerBound.x && belowUpperBound.x;\n          bool depthPlusOneInRange = aboveLowerBound.y && belowUpperBound.y;\n\n          if(depthInRange || depthPlusOneInRange){\n            vec4 z = vec4(0.);\n            vec4 xFragAtCurrentDepth;\n            z.xz = cache.xy;\n            if(depthPlusOneInRange && hasNextCol){\n              xFragAtCurrentDepth = idx.y != d ?\n                getX(b, r, c, idx.y) : xFragAtOutputCoords;\n              z.y = getChannel(xFragAtCurrentDepth, vec2(c, idx.y));\n              if(hasNextRow){\n                z.w = getChannel(xFragAtCurrentDepth, vec2(c + 1, idx.y));\n              }\n            }\n            cache.xy = z.yw;\n            sum += z * z;\n          }\n        }\n        vec4 result = xAtOutputCoords * " + powOperator + ";\n        setOutput(result);\n      }\n    ";
	    }
	    return LRNPackedProgram;
	}());
	exports.LRNPackedProgram = LRNPackedProgram;
	//# sourceMappingURL=lrn_packed_gpu.js.map

/***/ },
/* 1006 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var MaxPool2DBackpropProgram = /** @class */ (function () {
	    function MaxPool2DBackpropProgram(convInfo) {
	        this.variableNames = ['dy', 'maxPos'];
	        this.outputShape = convInfo.inShape;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var dilationHeight = convInfo.dilationHeight;
	        var effectiveFilterHeight = convInfo.effectiveFilterHeight;
	        var effectiveFilterWidth = convInfo.effectiveFilterWidth;
	        var padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
	        var padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
	        var lastIndex = effectiveFilterHeight * effectiveFilterWidth - 1;
	        this.userCode = "\n      const ivec2 pads = ivec2(" + padTop + ", " + padLeft + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n\n        ivec2 dyRCCorner = coords.yz - pads;\n        int dyRCorner = dyRCCorner.x;\n        int dyCCorner = dyRCCorner.y;\n\n        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < " + effectiveFilterHeight + ";\n          wR += " + dilationHeight + ") {\n          float dyR = float(dyRCorner + wR) / " + strideHeight + ".0;\n\n          if (dyR < 0.0 || dyR >= " + convInfo.outHeight + ".0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          for (int wC = 0; wC < " + effectiveFilterWidth + "; wC++) {\n            float dyC = float(dyCCorner + wC) / " + strideWidth + ".0;\n\n            if (dyC < 0.0 || dyC >= " + convInfo.outWidth + ".0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            float dyValue = getDy(b, idyR, idyC, d);\n            int maxPosValue = " + lastIndex + " - int(getMaxPos(b, idyR, idyC, d));\n\n            // Get the current value, check it against the value from the\n            // position matrix.\n            int curPosValue = wR * " + effectiveFilterWidth + " + wC;\n            float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);\n\n            dotProd += dyValue * mask;\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
	    }
	    return MaxPool2DBackpropProgram;
	}());
	exports.MaxPool2DBackpropProgram = MaxPool2DBackpropProgram;
	var MaxPool3DBackpropProgram = /** @class */ (function () {
	    function MaxPool3DBackpropProgram(convInfo) {
	        this.variableNames = ['dy', 'maxPos'];
	        this.outputShape = convInfo.inShape;
	        var strideDepth = convInfo.strideDepth;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var dilationDepth = convInfo.dilationDepth;
	        var dilationHeight = convInfo.dilationHeight;
	        var dilationWidth = convInfo.dilationWidth;
	        var effectiveFilterDepth = convInfo.effectiveFilterDepth;
	        var effectiveFilterHeight = convInfo.effectiveFilterHeight;
	        var effectiveFilterWidth = convInfo.effectiveFilterWidth;
	        var padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
	        var padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
	        var padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
	        var lastIndex = effectiveFilterDepth * effectiveFilterHeight * effectiveFilterWidth - 1;
	        this.userCode = "\n      const ivec3 pads = ivec3(" + padFront + ", " + padTop + ", " + padLeft + ");\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int ch = coords.u;\n\n        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;\n        int dyDCorner = dyCorner.x;\n        int dyRCorner = dyCorner.y;\n        int dyCCorner = dyCorner.z;\n\n        // Convolve dy(?, ?, ?, ch) with pos mask(:, :, :, d) to get\n        // dx(xD, xR, xC, ch).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n\n        for (int wD = 0; wD < " + effectiveFilterDepth + ";\n           wD += " + dilationDepth + ") {\n          float dyD = float(dyDCorner + wD) / " + strideDepth + ".0;\n\n          if (dyD < 0.0 || dyD >= " + convInfo.outDepth + ".0 || fract(dyD) > 0.0) {\n            continue;\n          }\n          int idyD = int(dyD);\n\n          for (int wR = 0; wR < " + effectiveFilterHeight + ";\n              wR += " + dilationHeight + ") {\n            float dyR = float(dyRCorner + wR) / " + strideHeight + ".0;\n\n            if (dyR < 0.0 || dyR >= " + convInfo.outHeight + ".0 ||\n                fract(dyR) > 0.0) {\n              continue;\n            }\n            int idyR = int(dyR);\n\n            for (int wC = 0; wC < " + effectiveFilterWidth + ";\n                wC += " + dilationWidth + ") {\n              float dyC = float(dyCCorner + wC) / " + strideWidth + ".0;\n\n              if (dyC < 0.0 || dyC >= " + convInfo.outWidth + ".0 ||\n                  fract(dyC) > 0.0) {\n                continue;\n              }\n              int idyC = int(dyC);\n\n              float dyValue = getDy(batch, idyD, idyR, idyC, ch);\n              int maxPosValue = " + lastIndex + " -\n                  int(getMaxPos(batch, idyD, idyR, idyC, ch));\n\n              // Get the current value, check it against the value from the\n              // position matrix.\n              int curPosValue =\n                  wD * " + effectiveFilterHeight + " * " + effectiveFilterWidth + " +\n                  wR * " + effectiveFilterWidth + " + wC;\n              float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);\n\n              dotProd += dyValue * mask;\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
	    }
	    return MaxPool3DBackpropProgram;
	}());
	exports.MaxPool3DBackpropProgram = MaxPool3DBackpropProgram;
	//# sourceMappingURL=max_pool_backprop_gpu.js.map

/***/ },
/* 1007 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var MatMulPackedProgram = /** @class */ (function () {
	    function MatMulPackedProgram(aShape, outputShape, transposeA, transposeB, addBias, activation, hasPreluActivation) {
	        if (transposeA === void 0) { transposeA = false; }
	        if (transposeB === void 0) { transposeB = false; }
	        if (addBias === void 0) { addBias = false; }
	        if (activation === void 0) { activation = null; }
	        if (hasPreluActivation === void 0) { hasPreluActivation = false; }
	        this.variableNames = ['matrixA', 'matrixB'];
	        this.packedInputs = true;
	        this.packedOutput = true;
	        this.outputShape = outputShape;
	        var sharedDim = transposeA ? aShape[1] : aShape[2];
	        var sharedDimensionPacked = Math.ceil(sharedDim / 2);
	        var aSample = transposeA ? 'i * 2, rc.y' : 'rc.y, i * 2';
	        var bSample = transposeB ? 'rc.z, i * 2' : 'i * 2, rc.z';
	        var aSwizzle = transposeA ? ['a.xxyy', 'a.zzww'] : ['a.xxzz', 'a.yyww'];
	        var bSwizzle = transposeB ? ['b.xzxz', 'b.ywyw'] : ['b.xyxy', 'b.zwzw'];
	        var activationSnippet = '', applyActivationSnippet = '';
	        if (activation) {
	            if (hasPreluActivation) {
	                activationSnippet = "vec4 activation(vec4 a) {\n          vec4 b = getPreluActivationWeightsAtOutCoords();\n          " + activation + "\n        }";
	            }
	            else {
	                activationSnippet = "vec4 activation(vec4 x) {\n          " + activation + "\n        }";
	            }
	            applyActivationSnippet = "result = activation(result);";
	        }
	        var addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
	        if (addBias) {
	            this.variableNames.push('bias');
	        }
	        if (hasPreluActivation) {
	            this.variableNames.push('preluActivationWeights');
	        }
	        this.userCode = "\n      " + activationSnippet + "\n\n      const float sharedDimension = " + sharedDimensionPacked + ".0;\n\n      vec4 dot2x2ARowBCol(ivec3 rc) {\n        vec4 result = vec4(0);\n        for (int i = 0; i < " + sharedDimensionPacked + "; i++) {\n          vec4 a = getMatrixA(rc.x, " + aSample + ");\n          vec4 b = getMatrixB(rc.x, " + bSample + ");\n\n          // These swizzled products need to be separately added.\n          // See: https://github.com/tensorflow/tfjs/issues/1735\n          result += (" + aSwizzle[0] + " * " + bSwizzle[0] + ");\n          result += (" + aSwizzle[1] + " * " + bSwizzle[1] + ");\n        }\n        return result;\n      }\n\n      void main() {\n        ivec3 rc = getOutputCoords();\n        vec4 result = dot2x2ARowBCol(rc);\n\n        " + addBiasSnippet + "\n\n        " + applyActivationSnippet + "\n\n        setOutput(result);\n      }\n    ";
	    }
	    return MatMulPackedProgram;
	}());
	exports.MatMulPackedProgram = MatMulPackedProgram;
	//# sourceMappingURL=mulmat_packed_gpu.js.map

/***/ },
/* 1008 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var MultinomialProgram = /** @class */ (function () {
	    function MultinomialProgram(batchSize, numOutcomes, numSamples) {
	        this.variableNames = ['probs'];
	        this.outputShape = [batchSize, numSamples];
	        this.userCode = "\n      uniform float seed;\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n\n        float r = random(seed);\n        float cdf = 0.0;\n\n        for (int i = 0; i < " + (numOutcomes - 1) + "; i++) {\n          cdf += getProbs(batch, i);\n\n          if (r < cdf) {\n            setOutput(float(i));\n            return;\n          }\n        }\n\n        // If no other event happened, last event happened.\n        setOutput(float(" + (numOutcomes - 1) + "));\n      }\n    ";
	    }
	    MultinomialProgram.prototype.getCustomSetupFunc = function (seed) {
	        var _this = this;
	        return function (gpgpu, webGLProgram) {
	            if (_this.seedLoc == null) {
	                _this.seedLoc = gpgpu.getUniformLocation(webGLProgram, 'seed');
	            }
	            gpgpu.gl.uniform1f(_this.seedLoc, seed);
	        };
	    };
	    return MultinomialProgram;
	}());
	exports.MultinomialProgram = MultinomialProgram;
	//# sourceMappingURL=multinomial_gpu.js.map

/***/ },
/* 1009 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var OneHotProgram = /** @class */ (function () {
	    function OneHotProgram(numIndices, depth, onValue, offValue) {
	        this.variableNames = ['indices'];
	        this.outputShape = [numIndices, depth];
	        this.userCode = "\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int index = round(getIndices(coords.x));\n        setOutput(mix(float(" + offValue + "), float(" + onValue + "),\n                      float(index == coords.y)));\n      }\n    ";
	    }
	    return OneHotProgram;
	}());
	exports.OneHotProgram = OneHotProgram;
	//# sourceMappingURL=onehot_gpu.js.map

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var packing_util_1 = __webpack_require__(107);
	var shader_compiler_1 = __webpack_require__(41);
	var PackProgram = /** @class */ (function () {
	    function PackProgram(outputShape) {
	        this.variableNames = ['A'];
	        this.packedInputs = false;
	        this.packedOutput = true;
	        // Only input / output 3D tensors.
	        this.outputShape = outputShape;
	        var rank = outputShape.length;
	        if (rank === 0) {
	            this.userCode = "\n        void main() {\n          setOutput(vec4(getA(), 0., 0., 0.));\n        }\n      ";
	        }
	        else {
	            var channels = packing_util_1.getChannels('rc', rank);
	            var dtype = shader_compiler_1.getCoordsDataType(rank);
	            var outOfBoundsCondition = getOutOfBoundsCondition(rank, outputShape, channels);
	            var setup = getSetup(rank, outputShape[outputShape.length - 1], outputShape[outputShape.length - 2], channels);
	            var output = getOutput(outputShape, channels);
	            this.userCode = "\n        void main() {\n          " + dtype + " rc = getOutputCoords();\n\n          if(" + outOfBoundsCondition + ") {\n            setOutput(vec4(0));\n          } else {\n            " + setup + "\n\n            setOutput(vec4(" + output + "));\n          }\n        }\n      ";
	        }
	    }
	    return PackProgram;
	}());
	exports.PackProgram = PackProgram;
	function getSourceCoordsArr(rank, dims) {
	    var coords = [];
	    for (var row = 0; row <= 1; row++) {
	        for (var col = 0; col <= 1; col++) {
	            var coord = (row === 0 ? 'r' : 'rp1') + ", " + (col === 0 ? 'c' : 'cp1');
	            for (var d = 2; d < rank; d++) {
	                coord = dims[dims.length - 1 - d] + "," + coord;
	            }
	            coords.push(coord);
	        }
	    }
	    return coords;
	}
	function getOutOfBoundsCondition(rank, shape, dims) {
	    if (rank === 1) {
	        return "rc > " + shape[0];
	    }
	    var cond = '';
	    for (var i = rank - 2; i < rank; i++) {
	        cond += dims[i] + " >= " + shape[i];
	        if (i < rank - 1) {
	            cond += '||';
	        }
	    }
	    return cond;
	}
	function getSetup(rank, cols, rows, dims) {
	    if (rank === 1) {
	        return '';
	    }
	    var innerDims = dims.slice(-2);
	    return "\n    int r = " + innerDims[0] + ";\n    int c = " + innerDims[1] + ";\n    int rp1 = r + 1;\n    int cp1 = c + 1;\n\n    bool cEdge = cp1 >= " + cols + ";\n    bool rEdge = rp1 >= " + rows + ";\n  ";
	}
	function getOutput(shape, dims) {
	    var rank = shape.length;
	    var sourceCoords = getSourceCoordsArr(rank, dims);
	    if (rank === 1) {
	        return "getA(rc),\n            rc + 1 >= " + shape[0] + " ? 0. : getA(rc + 1),\n            0, 0";
	    }
	    return "getA(" + sourceCoords[0] + "),\n          cEdge ? 0. : getA(" + sourceCoords[1] + "),\n          rEdge ? 0. : getA(" + sourceCoords[2] + "),\n          rEdge || cEdge ? 0. : getA(" + sourceCoords[3] + ")";
	}
	//# sourceMappingURL=pack_gpu.js.map

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var shader_compiler_1 = __webpack_require__(41);
	var PadProgram = /** @class */ (function () {
	    function PadProgram(xShape, paddings, constantValue) {
	        this.variableNames = ['x'];
	        this.outputShape = paddings.map(function (p, i) { return p[0] /* beforePad */ + xShape[i] + p[1]; } /* afterPad */);
	        var rank = xShape.length;
	        var type = shader_compiler_1.getCoordsDataType(rank);
	        var start = paddings.map(function (p) { return p[0]; }).join(',');
	        var end = paddings.map(function (p, i) { return p[0] + xShape[i]; }).join(',');
	        var unpackedCoords = ['coords[0]', 'coords[1]', 'coords[2]', 'coords[3]'].slice(0, rank);
	        if (rank === 1) {
	            this.userCode = "\n        int start = " + start + ";\n        int end = " + end + ";\n\n        void main() {\n          int outC = getOutputCoords();\n          if (outC < start || outC >= end) {\n            setOutput(float(" + constantValue + "));\n          } else {\n            setOutput(getX(outC - start));\n          }\n        }\n      ";
	            return;
	        }
	        this.userCode = "\n      " + type + " start = " + type + "(" + start + ");\n      " + type + " end = " + type + "(" + end + ");\n\n      void main() {\n        " + type + " outC = getOutputCoords();\n        if (any(lessThan(outC, start)) || any(greaterThanEqual(outC, end))) {\n          setOutput(float(" + constantValue + "));\n        } else {\n          " + type + " coords = outC - start;\n          setOutput(getX(" + unpackedCoords + "));\n        }\n      }\n    ";
	    }
	    return PadProgram;
	}());
	exports.PadProgram = PadProgram;
	//# sourceMappingURL=pad_gpu.js.map

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var packing_util_1 = __webpack_require__(107);
	var shader_compiler_1 = __webpack_require__(41);
	var PadPackedProgram = /** @class */ (function () {
	    function PadPackedProgram(xShape, paddings, constantValue) {
	        this.variableNames = ['x'];
	        this.packedInputs = true;
	        this.packedOutput = true;
	        this.outputShape = paddings.map(function (p, i) { return p[0] /* beforePad */ + xShape[i] + p[1]; } /* afterPad */);
	        var rank = xShape.length;
	        var dtype = shader_compiler_1.getCoordsDataType(rank);
	        var start = paddings.map(function (p) { return p[0]; }).join(',');
	        var end = paddings.map(function (p, i) { return p[0] + xShape[i]; }).join(',');
	        var coords = packing_util_1.getChannels('rc', rank);
	        var source = packing_util_1.getChannels('source', rank);
	        var cLimit = coords[rank - 1] + " < " + this.outputShape[rank - 1];
	        var innerDims = rank === 1 ? 'source' : "vec2(" + source.slice(-2).join() + ")";
	        var componentSetup = [
	            dtype + " rc = outputLoc;", coords[rank - 1] + " += 1;\n       if(" + cLimit + ") {\n      ",
	            rank === 1 ? '' : "}\n       rc = outputLoc;\n       " + coords[rank - 2] + " += 1;\n       if(" + coords[rank - 2] + " < " + this.outputShape[rank - 2] + ") {",
	            rank === 1 ? '' : "  " + coords[rank - 1] + " += 1;\n         if(" + cLimit + ") {"
	        ];
	        var paddingArea = rank === 1 ?
	            'rc < start || rc >= end' :
	            'any(lessThan(rc, start)) || any(greaterThanEqual(rc, end))';
	        var mainLoop = '';
	        for (var i = 0, j = rank === 1 ? 2 : 4; i < j; i++) {
	            mainLoop += "\n        " + componentSetup[i] + "\n        if (" + paddingArea + ") {\n          result[" + i + "] = float(" + constantValue + ");\n        } else {\n          " + dtype + " source = rc - start;\n          result[" + i + "] = getChannel(getX(" + source.join() + "), " + innerDims + ");\n        }\n      ";
	        }
	        mainLoop += (rank === 1 ? "} " : "}}");
	        this.userCode = "\n      const " + dtype + " start = " + dtype + "(" + start + ");\n      const " + dtype + " end = " + dtype + "(" + end + ");\n\n      void main() {\n        " + dtype + " outputLoc = getOutputCoords();\n        vec4 result = vec4(0.);\n        " + mainLoop + "\n        setOutput(result);\n      }\n    ";
	    }
	    return PadPackedProgram;
	}());
	exports.PadPackedProgram = PadPackedProgram;
	//# sourceMappingURL=pad_packed_gpu.js.map

/***/ },
/* 1013 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Pool2DProgram = /** @class */ (function () {
	    function Pool2DProgram(convInfo, poolType, computePositions) {
	        this.variableNames = ['x'];
	        if (poolType === 'avg' && computePositions) {
	            throw new Error('Cannot compute positions for average pool.');
	        }
	        var filterWidth = convInfo.filterWidth;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var dilationHeight = convInfo.dilationHeight;
	        var dilationWidth = convInfo.dilationWidth;
	        var effectiveFilterHeight = convInfo.effectiveFilterHeight;
	        var effectiveFilterWidth = convInfo.effectiveFilterWidth;
	        var padTop = convInfo.padInfo.top;
	        var padLeft = convInfo.padInfo.left;
	        this.outputShape = convInfo.outShape;
	        var isAvgPool = poolType === 'avg';
	        var initializationValue = '0.0';
	        if (!isAvgPool) {
	            // WebGL on Firefox Linux can't compile 1/0 so we do 1/eps.
	            initializationValue = '-1.0 / 1e-20';
	        }
	        if (computePositions) {
	            var compareOp_1 = '>=';
	            this.userCode = "\n        const ivec2 strides = ivec2(" + strideHeight + ", " + strideWidth + ");\n        const ivec2 pads = ivec2(" + padTop + ", " + padLeft + ");\n\n        void main() {\n          ivec4 coords = getOutputCoords();\n          int batch = coords[0];\n          int d = coords[3];\n\n          ivec2 xRCCorner = coords.yz * strides - pads;\n          int xRCorner = xRCCorner.x;\n          int xCCorner = xRCCorner.y;\n\n          // max/min x(?, ?, d) to get y(yR, yC, d).\n          // ? = to be determined\n          float minMaxValue = 0.0;\n          float minMaxValueFound = 0.0;\n          int minMaxPosition = 0;\n          float avgValue = 0.0;\n\n          for (int wR = 0; wR < " + effectiveFilterHeight + ";\n              wR += " + dilationHeight + ") {\n            int xR = xRCorner + wR;\n\n            if (xR < 0 || xR >= " + convInfo.inHeight + ") {\n              continue;\n            }\n\n            for (int wC = 0; wC < " + effectiveFilterWidth + ";\n                wC += " + dilationWidth + ") {\n              int xC = xCCorner + wC;\n\n              if (xC < 0 || xC >= " + convInfo.inWidth + ") {\n                continue;\n              }\n\n              float value = getX(batch, xR, xC, d);\n\n              // If a min / max value has already been found, use it. If not,\n              // use the current value.\n              float currMinMaxValue = mix(\n                  value, minMaxValue, minMaxValueFound);\n              if (value " + compareOp_1 + " currMinMaxValue) {\n                minMaxValue = value;\n                minMaxValueFound = 1.0;\n                minMaxPosition = wR * " + effectiveFilterWidth + " + wC;\n              }\n            }\n          }\n          setOutput(float(minMaxPosition));\n        }\n      ";
	            return;
	        }
	        var compareOp = 'max';
	        var returnValue = poolType + "(" + poolType + "(" + poolType + "(" +
	            'minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])';
	        if (poolType === 'avg') {
	            returnValue = "avgValue / count";
	        }
	        var filterWidthNearestVec4 = Math.floor(filterWidth / 4) * 4;
	        var filterWidthVec4Remainder = filterWidth % 4;
	        var updateSnippet = "\n      if (" + isAvgPool + ") {\n        avgValue += dot(values, ones);\n      } else {\n        minMaxValue = " + compareOp + "(values, minMaxValue);\n      }\n    ";
	        this.userCode = "\n      const ivec2 strides = ivec2(" + strideHeight + ", " + strideWidth + ");\n      const ivec2 pads = ivec2(" + padTop + ", " + padLeft + ");\n      const float initializationValue = " + initializationValue + ";\n      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);\n\n      float count = 0.0;\n\n      float getValue(int batch, int xR, int xC, int d) {\n        if (xC < 0 || xC >= " + convInfo.inWidth + ") {\n          return initializationValue;\n        }\n        count += 1.0;\n        return getX(batch, xR, xC, d);\n      }\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d = coords[3];\n\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // max/min x(?, ?, d) to get y(yR, yC, d).\n        // ? = to be determined\n        vec4 minMaxValue = vec4(" + initializationValue + ");\n        float avgValue = 0.0;\n        count = 0.0;\n\n        for (int wR = 0; wR < " + effectiveFilterHeight + ";\n            wR += " + dilationHeight + ") {\n          int xR = xRCorner + wR;\n\n          if (xR < 0 || xR >= " + convInfo.inHeight + ") {\n            continue;\n          }\n\n          for (int wC = 0; wC < " + filterWidthNearestVec4 + "; wC += 4) {\n            int xC = xCCorner + wC * " + dilationWidth + ";\n\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + " + dilationWidth + ", d),\n              getValue(batch, xR, xC + 2 * " + dilationWidth + ", d),\n              getValue(batch, xR, xC + 3 * " + dilationWidth + ", d)\n            );\n\n            " + updateSnippet + "\n          }\n\n          int xC = xCCorner + " + filterWidthNearestVec4 + ";\n          if (" + (filterWidthVec4Remainder === 1) + ") {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              initializationValue,\n              initializationValue,\n              initializationValue\n            );\n\n            " + updateSnippet + "\n          } else if (" + (filterWidthVec4Remainder === 2) + ") {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + " + dilationWidth + ", d),\n              initializationValue,\n              initializationValue\n            );\n\n            " + updateSnippet + "\n          } else if (" + (filterWidthVec4Remainder === 3) + ") {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + " + dilationWidth + ", d),\n              getValue(batch, xR, xC + 2 * " + dilationWidth + ", d),\n              initializationValue\n            );\n\n            " + updateSnippet + "\n          }\n        }\n        setOutput(" + returnValue + ");\n      }\n    ";
	    }
	    return Pool2DProgram;
	}());
	exports.Pool2DProgram = Pool2DProgram;
	var Pool3DProgram = /** @class */ (function () {
	    function Pool3DProgram(convInfo, poolType, computePositions) {
	        this.variableNames = ['x'];
	        if (poolType === 'avg' && computePositions) {
	            throw new Error('Cannot compute positions for average pool.');
	        }
	        var filterWidth = convInfo.filterWidth;
	        var strideDepth = convInfo.strideDepth;
	        var strideHeight = convInfo.strideHeight;
	        var strideWidth = convInfo.strideWidth;
	        var dilationDepth = convInfo.dilationDepth;
	        var dilationHeight = convInfo.dilationHeight;
	        var dilationWidth = convInfo.dilationWidth;
	        var effectiveFilterDepth = convInfo.effectiveFilterDepth;
	        var effectiveFilterHeight = convInfo.effectiveFilterHeight;
	        var effectiveFilterWidth = convInfo.effectiveFilterWidth;
	        var padFront = convInfo.padInfo.front;
	        var padTop = convInfo.padInfo.top;
	        var padLeft = convInfo.padInfo.left;
	        this.outputShape = convInfo.outShape;
	        var isAvgPool = poolType === 'avg';
	        var initializationValue = '0.0';
	        if (!isAvgPool) {
	            // WebGL on Firefox Linux can't compile 1/0 so we do 1/eps.
	            initializationValue = '-1.0 / 1e-20';
	        }
	        if (computePositions) {
	            var compareOp_2 = '>=';
	            this.userCode = "\n        const ivec3 strides =\n            ivec3(" + strideDepth + ", " + strideHeight + ", " + strideWidth + ");\n        const ivec3 pads = ivec3(" + padFront + ", " + padTop + ", " + padLeft + ");\n\n        void main() {\n          ivec5 coords = getOutputCoords();\n          int batch = coords.x;\n          int ch = coords.u;\n\n          ivec3 xCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;\n          int xDCorner = xCorner.x;\n          int xRCorner = xCorner.y;\n          int xCCorner = xCorner.z;\n\n          // max/min x(?, ?, ?, ch) to get y(yD, yR, yC, ch).\n          // ? = to be determined\n          float minMaxValue = 0.0;\n          float minMaxValueFound = 0.0;\n          int minMaxPosition = 0;\n\n          for (int wD = 0; wD < " + effectiveFilterDepth + ";\n              wD += " + dilationDepth + ") {\n            int xD = xDCorner + wD;\n\n            if (xD < 0 || xD >= " + convInfo.inDepth + ") {\n              continue;\n            }\n\n            for (int wR = 0; wR < " + effectiveFilterHeight + ";\n                wR += " + dilationHeight + ") {\n              int xR = xRCorner + wR;\n\n              if (xR < 0 || xR >= " + convInfo.inHeight + ") {\n                continue;\n              }\n\n              for (int wC = 0; wC < " + effectiveFilterWidth + ";\n                  wC += " + dilationWidth + ") {\n                int xC = xCCorner + wC;\n\n                if (xC < 0 || xC >= " + convInfo.inWidth + ") {\n                  continue;\n                }\n\n                float value = getX(batch, xD, xR, xC, ch);\n\n                // If a min / max value has already been found, use it. If not,\n                // use the current value.\n                float currMinMaxValue = mix(\n                    value, minMaxValue, minMaxValueFound);\n                if (value " + compareOp_2 + " currMinMaxValue) {\n                  minMaxValue = value;\n                  minMaxValueFound = 1.0;\n                  minMaxPosition =\n                      wD * " + effectiveFilterHeight + " * " + effectiveFilterWidth + " +\n                      wR * " + effectiveFilterWidth + " + wC;;\n                }\n              }\n            }\n          }\n          setOutput(float(minMaxPosition));\n        }\n      ";
	            return;
	        }
	        var compareOp = 'max';
	        var returnValue = poolType + "(" + poolType + "(" + poolType + "(" +
	            'minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])';
	        if (poolType === 'avg') {
	            returnValue = "avgValue / count";
	        }
	        var filterWidthNearestVec4 = Math.floor(filterWidth / 4) * 4;
	        var filterWidthVec4Remainder = filterWidth % 4;
	        var updateSnippet = "\n      if (" + isAvgPool + ") {\n        avgValue += dot(values, ones);\n      } else {\n        minMaxValue = " + compareOp + "(values, minMaxValue);\n      }\n    ";
	        this.userCode = "\n      const ivec3 strides =\n        ivec3(" + strideDepth + ", " + strideHeight + ", " + strideWidth + ");\n      const ivec3 pads = ivec3(" + padFront + ", " + padTop + ", " + padLeft + ");\n      const float initializationValue = " + initializationValue + ";\n      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);\n\n      float count = 0.0;\n\n      float getValue(int batch, int xD, int xR, int xC, int ch) {\n        if (xC < 0 || xC >= " + convInfo.inWidth + ") {\n          return initializationValue;\n        }\n        count += 1.0;\n        return getX(batch, xD, xR, xC, ch);\n      }\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int ch = coords.u;\n\n        ivec3 xCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;\n        int xDCorner = xCorner.x;\n        int xRCorner = xCorner.y;\n        int xCCorner = xCorner.z;\n\n        // max/min x(?, ?, ?, d) to get y(yD, yR, yC, ch).\n        // ? = to be determined\n        vec4 minMaxValue = vec4(" + initializationValue + ");\n        float avgValue = 0.0;\n        count = 0.0;\n\n        for (int wD = 0; wD < " + effectiveFilterDepth + ";\n            wD += " + dilationDepth + ") {\n          int xD = xDCorner + wD;\n\n          if (xD < 0 || xD >= " + convInfo.inDepth + ") {\n            continue;\n          }\n\n          for (int wR = 0; wR < " + effectiveFilterHeight + ";\n            wR += " + dilationHeight + ") {\n            int xR = xRCorner + wR;\n\n            if (xR < 0 || xR >= " + convInfo.inHeight + ") {\n              continue;\n            }\n\n            for (int wC = 0; wC < " + filterWidthNearestVec4 + "; wC += 4) {\n              int xC = xCCorner + wC * " + dilationWidth + ";\n\n              vec4 values = vec4(\n                getValue(batch, xD, xR, xC, ch),\n                getValue(batch, xD, xR, xC + " + dilationWidth + ", ch),\n                getValue(batch, xD, xR, xC + 2 * " + dilationWidth + ", ch),\n                getValue(batch, xD, xR, xC + 3 * " + dilationWidth + ", ch)\n              );\n\n              " + updateSnippet + "\n            }\n\n            int xC = xCCorner + " + filterWidthNearestVec4 + ";\n            if (" + (filterWidthVec4Remainder === 1) + ") {\n              vec4 values = vec4(\n                getValue(batch, xD, xR, xC, ch),\n                initializationValue,\n                initializationValue,\n                initializationValue\n              );\n\n              " + updateSnippet + "\n            } else if (" + (filterWidthVec4Remainder === 2) + ") {\n              vec4 values = vec4(\n                getValue(batch, xD, xR, xC, ch),\n                getValue(batch, xD, xR, xC + " + dilationWidth + ", ch),\n                initializationValue,\n                initializationValue\n              );\n\n              " + updateSnippet + "\n            } else if (" + (filterWidthVec4Remainder === 3) + ") {\n              vec4 values = vec4(\n                getValue(batch, xD, xR, xC, ch),\n                getValue(batch, xD, xR, xC + " + dilationWidth + ", ch),\n                getValue(batch, xD, xR, xC + 2 * " + dilationWidth + ", ch),\n                initializationValue\n              );\n\n              " + updateSnippet + "\n            }\n          }\n          setOutput(" + returnValue + ");\n        }\n      }\n    ";
	    }
	    return Pool3DProgram;
	}());
	exports.Pool3DProgram = Pool3DProgram;
	//# sourceMappingURL=pool_gpu.js.map

/***/ },
/* 1014 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReduceProgram = /** @class */ (function () {
	    function ReduceProgram(reduceInfo, reduceType) {
	        this.variableNames = ['x'];
	        var windowSize = reduceInfo.windowSize;
	        var batchSize = reduceInfo.batchSize;
	        var inSize = reduceInfo.inSize;
	        var outSize = Math.ceil(inSize / windowSize);
	        this.outputShape = [batchSize, outSize];
	        var initializationValue = '0.0';
	        var compareOp = "";
	        if (reduceType === 'prod') {
	            initializationValue = '1.0';
	        }
	        else if (reduceType === 'min') {
	            // WebGL on Firefox Linux can't compile 1/0 so we do 1/eps.
	            initializationValue = '1.0 / 1e-20';
	            compareOp = "min";
	        }
	        else if (reduceType === 'max') {
	            // WebGL on Firefox Linux can't compile 1/0 so we do 1/eps.
	            initializationValue = '-1.0 / 1e-20';
	            compareOp = "max";
	        }
	        var returnValue = reduceType + "(" + reduceType + "(" + reduceType + "(" +
	            'minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])';
	        if (reduceType === 'sum') {
	            returnValue = "sumValue";
	        }
	        else if (reduceType === 'prod') {
	            returnValue = "prodValue";
	        }
	        else if (reduceType === 'all') {
	            returnValue = "allValue";
	        }
	        else if (reduceType === 'any') {
	            returnValue = "anyValue";
	        }
	        var windowSizeNearestVec4 = Math.floor(windowSize / 4) * 4;
	        var windowSizeVec4Remainder = windowSize % 4;
	        var updateSnippet = "\n      if (" + (reduceType === 'sum') + ") {\n        sumValue += dot(values, ones);\n      } else if (" + (reduceType === 'prod') + ") {\n        vec2 tmp = vec2(values[0], values[1]) * vec2(values[2], values[3]);\n        prodValue *= tmp[0] * tmp[1];\n      } else {\n        minMaxValue = " + compareOp + "(values, minMaxValue);\n      }\n    ";
	        var vecType = "vec4";
	        if (reduceType === 'all') {
	            initializationValue = '1.0';
	            updateSnippet = "\n        bool reducedAllValue = all(values);\n        float floatedReducedAllValue = float(reducedAllValue);\n        allValue = float(allValue >= 1.0 && floatedReducedAllValue >= 1.0);\n      ";
	            vecType = "bvec4";
	        }
	        else if (reduceType === 'any') {
	            initializationValue = '0.0';
	            updateSnippet = "\n        bool reducedAnyValue = any(values);\n        float floatedReducedAnyValue = float(reducedAnyValue);\n        anyValue = float(anyValue >= 1.0 || floatedReducedAnyValue >= 1.0);\n      ";
	            vecType = "bvec4";
	        }
	        var checkOutOfBounds = '';
	        if (inSize % windowSize > 0) {
	            checkOutOfBounds = "\n        if (inIdx < 0 || inIdx >= " + inSize + ") {\n          return initializationValue;\n        }\n      ";
	        }
	        this.userCode = "\n      const float initializationValue = " + initializationValue + ";\n      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);\n\n      float getValue(int batch, int inIdx) {\n        " + checkOutOfBounds + "\n        return getX(batch, inIdx);\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = outIdx * " + windowSize + ";\n\n        vec4 minMaxValue = vec4(" + initializationValue + ");\n        float prodValue = 1.0;\n        float sumValue = 0.0;\n        float allValue = 1.0;\n        float anyValue = 0.0;\n\n        for (int i = 0; i < " + windowSizeNearestVec4 + "; i += 4) {\n          int inIdx = inOffset + i;\n          " + vecType + " values = " + vecType + "(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            getValue(batch, inIdx + 3)\n          );\n\n          " + updateSnippet + "\n        }\n\n        int inIdx = inOffset + " + windowSizeNearestVec4 + ";\n        if (" + (windowSizeVec4Remainder === 1) + ") {\n          " + vecType + " values = " + vecType + "(\n            getValue(batch, inIdx),\n            initializationValue,\n            initializationValue,\n            initializationValue\n          );\n\n          " + updateSnippet + "\n        } else if (" + (windowSizeVec4Remainder === 2) + ") {\n          " + vecType + " values = " + vecType + "(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            initializationValue,\n            initializationValue\n          );\n\n          " + updateSnippet + "\n        } else if (" + (windowSizeVec4Remainder === 3) + ") {\n          " + vecType + " values = " + vecType + "(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            initializationValue\n          );\n\n          " + updateSnippet + "\n        }\n        setOutput(" + returnValue + ");\n      }\n    ";
	    }
	    return ReduceProgram;
	}());
	exports.ReduceProgram = ReduceProgram;
	//# sourceMappingURL=reduce_gpu.js.map

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @license
	 * Copyright 2020 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var kernel_registry_1 = __webpack_require__(152);
	var FromPixels_1 = __webpack_require__(997);
	var NonMaxSuppressionV5_1 = __webpack_require__(1000);
	var Square_1 = __webpack_require__(1001);
	var SquaredDifference_1 = __webpack_require__(1002);
	// List all kernel configs here
	var kernelConfigs = [
	    FromPixels_1.fromPixelsConfig,
	    NonMaxSuppressionV5_1.nonMaxSuppressionV5Config,
	    Square_1.squareConfig,
	    SquaredDifference_1.squaredDifferenceConfig,
	];
	for (var _i = 0, kernelConfigs_1 = kernelConfigs; _i < kernelConfigs_1.length; _i++) {
	    var kernelConfig = kernelConfigs_1[_i];
	    kernel_registry_1.registerKernel(kernelConfig);
	}
	//# sourceMappingURL=register_all_kernels.js.map

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var shader_util = __webpack_require__(120);
	var ReshapePackedProgram = /** @class */ (function () {
	    function ReshapePackedProgram(outputShape, inputShape) {
	        this.variableNames = ['A'];
	        this.packedInputs = true;
	        this.packedOutput = true;
	        this.outputShape = outputShape;
	        var mainLoop = "";
	        for (var i = 0; i < 4; i++) {
	            var thisRC = "thisRC = rc;";
	            if (i % 2 === 1) {
	                thisRC += "thisRC.z += 1;";
	            }
	            if (i > 1) {
	                thisRC += "thisRC.y += 1;";
	            }
	            mainLoop += "\n        " + thisRC + "\n        " + (i > 0 ? "if(thisRC.y < rows && thisRC.z < cols){" : '') + "\n          int flatIndex = getFlatIndex(thisRC);\n\n          ivec3 inputRC = inputCoordsFromReshapedOutCoords(flatIndex);\n          vec2 inputRCInnerDims = vec2(float(inputRC.y),float(inputRC.z));\n\n          result[" + i + "] =\n            getChannel(getA(inputRC.x, inputRC.y, inputRC.z), inputRCInnerDims);\n        " + (i > 0 ? '}' : '') + "\n      ";
	        }
	        this.userCode = "\n      " + getReshapedInputCoords(inputShape) + "\n      " + shader_util.getFlatIndexFrom3D(outputShape) + "\n\n      void main() {\n        ivec3 rc = getOutputCoords();\n\n        vec4 result = vec4(0.);\n\n        ivec3 thisRC;\n        int rows = " + outputShape[1] + ";\n        int cols = " + outputShape[2] + ";\n\n        " + mainLoop + "\n\n        setOutput(result);\n      }\n    ";
	    }
	    return ReshapePackedProgram;
	}());
	exports.ReshapePackedProgram = ReshapePackedProgram;
	function getReshapedInputCoords(shape) {
	    var coordsFromIndexSnippet = shader_util.getLogicalCoordinatesFromFlatIndex(['r', 'c', 'd'], shape);
	    return "\n    ivec3 inputCoordsFromReshapedOutCoords(int index) {\n      " + coordsFromIndexSnippet + "\n      return ivec3(r, c, d);\n    }\n  ";
	}
	//# sourceMappingURL=reshape_packed_gpu.js.map

/***/ },
/* 1017 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ResizeBilinearBackpropProgram = /** @class */ (function () {
	    function ResizeBilinearBackpropProgram(dy, x, alignCorners) {
	        this.variableNames = ['dy'];
	        this.outputShape = [];
	        this.outputShape = x.shape;
	        var _a = x.shape, xHeight = _a[1], xWidth = _a[2];
	        var _b = dy.shape, yHeight = _b[1], yWidth = _b[2];
	        // In the backwards pass, we want to find the pixels that were generated for
	        // each pixel in the input image the forward pass and add the corresponding
	        // coefficient from dy to the gradient (with some interpolation).
	        var effectiveXSize = [
	            (alignCorners && yHeight > 1) ? xHeight - 1 : xHeight,
	            (alignCorners && yWidth > 1) ? xWidth - 1 : xWidth
	        ];
	        var effectiveYSize = [
	            (alignCorners && yHeight > 1) ? yHeight - 1 : yHeight,
	            (alignCorners && yWidth > 1) ? yWidth - 1 : yWidth
	        ];
	        var heightScale = effectiveXSize[0] / effectiveYSize[0];
	        var widthScale = effectiveXSize[1] / effectiveYSize[1];
	        var invHeightScale = 1 / heightScale;
	        var invWidthScale = 1 / widthScale;
	        // This defines the size of the window of values around a particular
	        // index in dy that we want to search for contributions to dx.
	        var winHeight = (Math.ceil(invHeightScale) * 2) + 2;
	        var winWidth = (Math.ceil(invWidthScale) * 2) + 2;
	        this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        int r = coords[1];\n        int c = coords[2];\n\n        float accumulator = 0.0;\n\n        const float heightScale = float(" + heightScale + ");\n        const float widthScale = float(" + widthScale + ");\n\n        const float invHeightScale = float(" + invHeightScale + ");\n        const float invWidthScale = float(" + invWidthScale + ");\n\n        const int winHeight = int(" + winHeight + ");\n        const int winWidth = int(" + winWidth + ");\n\n        // Compute bounds for where in dy we will look\n        float startRLerp = floor(float(r) * invHeightScale);\n        int startDyR = int(startRLerp - float(winHeight / 2));\n\n        float startCLerp = floor(float(c) * invWidthScale);\n        int startDyC = int(startCLerp - float(winWidth / 2));\n\n        // Loop over dy\n        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {\n          int dyR = dyROffset + startDyR;\n\n          // Guard against the window exceeding the bounds of dy\n          if (dyR < 0 || dyR >= " + yHeight + ") {\n            continue;\n          }\n\n          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {\n            int dyC = dyCOffset + startDyC;\n\n            // Guard against the window exceeding the bounds of dy\n            if (dyC < 0 || dyC >= " + yWidth + ") {\n              continue;\n            }\n\n            float dxR = float(dyR) * heightScale;\n            int topDxRIndex = int(floor(dxR));\n            int bottomDxRIndex = int(min(ceil(dxR), " + (xHeight - 1) + ".0));\n            float dxRLerp = dxR - float(topDxRIndex);\n            float inverseDxRLerp = 1.0 - dxRLerp;\n\n            float dxC = float(dyC) * widthScale;\n            int leftDxCIndex = int(floor(dxC));\n            int rightDxCIndex = int(min(ceil(dxC), " + (xWidth - 1) + ".0));\n            float dxCLerp = dxC - float(leftDxCIndex);\n            float inverseDxCLerp = 1.0 - dxCLerp;\n\n            if (r == topDxRIndex && c == leftDxCIndex) {\n              // topLeft\n              accumulator +=\n                getDy(b, dyR, dyC, d) * inverseDxRLerp * inverseDxCLerp;\n            }\n\n            if (r == topDxRIndex && c == rightDxCIndex) {\n              // topRight\n              accumulator += getDy(b, dyR, dyC, d) * inverseDxRLerp * dxCLerp;\n            }\n\n            if (r == bottomDxRIndex && c == leftDxCIndex) {\n              // bottomLeft\n              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * inverseDxCLerp;\n            }\n\n            if (r == bottomDxRIndex && c == rightDxCIndex) {\n              // bottomRight\n              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * dxCLerp;\n            }\n          }\n        }\n        // End loop over dy\n\n        setOutput(accumulator);\n      }\n    ";
	    }
	    return ResizeBilinearBackpropProgram;
	}());
	exports.ResizeBilinearBackpropProgram = ResizeBilinearBackpropProgram;
	//# sourceMappingURL=resize_bilinear_backprop_gpu.js.map

/***/ },
/* 1018 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ResizeBilinearProgram = /** @class */ (function () {
	    function ResizeBilinearProgram(inputShape, newHeight, newWidth, alignCorners) {
	        this.variableNames = ['A'];
	        this.outputShape = [];
	        var batch = inputShape[0], oldHeight = inputShape[1], oldWidth = inputShape[2], depth = inputShape[3];
	        this.outputShape = [batch, newHeight, newWidth, depth];
	        var effectiveInSize = [
	            (alignCorners && newHeight > 1) ? oldHeight - 1 : oldHeight,
	            (alignCorners && newWidth > 1) ? oldWidth - 1 : oldWidth
	        ];
	        var effectiveOutSize = [
	            (alignCorners && newHeight > 1) ? newHeight - 1 : newHeight,
	            (alignCorners && newWidth > 1) ? newWidth - 1 : newWidth
	        ];
	        this.userCode = "\n      const vec2 effectiveInputOverOutputRatioRC = vec2(\n          " + effectiveInSize[0] / effectiveOutSize[0] + ",\n          " + effectiveInSize[1] / effectiveOutSize[1] + ");\n      const vec2 inputShapeRC = vec2(" + oldHeight + ".0, " + oldWidth + ".0);\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        ivec2 yRC = coords.yz;\n\n        // Fractional source index.\n        vec2 sourceFracIndexRC = vec2(yRC) * effectiveInputOverOutputRatioRC;\n\n        // Compute the four integer indices.\n        ivec2 sourceFloorRC = ivec2(sourceFracIndexRC);\n        ivec2 sourceCeilRC = ivec2(\n          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));\n\n        float topLeft = getA(b, sourceFloorRC.x, sourceFloorRC.y, d);\n        float bottomLeft = getA(b, sourceCeilRC.x, sourceFloorRC.y, d);\n        float topRight = getA(b, sourceFloorRC.x, sourceCeilRC.y, d);\n        float bottomRight = getA(b, sourceCeilRC.x, sourceCeilRC.y, d);\n\n        vec2 fracRC = sourceFracIndexRC - vec2(sourceFloorRC);\n\n        float top = topLeft + (topRight - topLeft) * fracRC.y;\n        float bottom = bottomLeft + (bottomRight - bottomLeft) * fracRC.y;\n        float newValue = top + (bottom - top) * fracRC.x;\n\n        setOutput(newValue);\n      }\n    ";
	    }
	    return ResizeBilinearProgram;
	}());
	exports.ResizeBilinearProgram = ResizeBilinearProgram;
	//# sourceMappingURL=resize_bilinear_gpu.js.map

/***/ },
/* 1019 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ResizeBilinearPackedProgram = /** @class */ (function () {
	    function ResizeBilinearPackedProgram(inputShape, newHeight, newWidth, alignCorners) {
	        this.variableNames = ['A'];
	        this.packedInputs = true;
	        this.packedOutput = true;
	        this.outputShape = [];
	        var batch = inputShape[0], oldHeight = inputShape[1], oldWidth = inputShape[2], depth = inputShape[3];
	        this.outputShape = [batch, newHeight, newWidth, depth];
	        var effectiveInSize = [
	            (alignCorners && newHeight > 1) ? oldHeight - 1 : oldHeight,
	            (alignCorners && newWidth > 1) ? oldWidth - 1 : oldWidth
	        ];
	        var effectiveOutSize = [
	            (alignCorners && newHeight > 1) ? newHeight - 1 : newHeight,
	            (alignCorners && newWidth > 1) ? newWidth - 1 : newWidth
	        ];
	        this.userCode = "\n      const vec3 effectiveInputOverOutputRatioRC = vec3(\n          " + effectiveInSize[0] / effectiveOutSize[0] + ",\n          " + effectiveInSize[1] / effectiveOutSize[1] + ",\n          " + effectiveInSize[1] / effectiveOutSize[1] + ");\n      const vec3 inputShapeRC = vec3(" + oldHeight + ".0, " + oldWidth + ".0,\n                                     " + oldWidth + ".0);\n\n      float getAValue(int b, int r, int c, int d) {\n        return getChannel(getA(b, r, c, d), vec2(c, d));\n      }\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        // Calculate values for next column in yRC.z.\n        ivec3 yRC = coords.yzz + ivec3(0, 0, 1);\n\n        // Fractional source index.\n        vec3 sourceFracIndexRC = vec3(yRC) * effectiveInputOverOutputRatioRC;\n\n        // Compute the four integer indices.\n        ivec3 sourceFloorRC = ivec3(sourceFracIndexRC);\n        ivec3 sourceCeilRC = ivec3(\n          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));\n\n        // Should we calculate next column and row elements in 2x2 packed cell.\n        bool hasNextCol = d < " + (depth - 1) + ";\n        bool hasNextRow = coords.z < " + (newWidth - 1) + ";\n\n        // In parallel, construct four corners for all four components in\n        // packed 2x2 cell.\n        vec4 topLeft = vec4(\n          getAValue(b, sourceFloorRC.x, sourceFloorRC.y, d),\n          hasNextCol ? getAValue(b, sourceFloorRC.x, sourceFloorRC.y, d + 1)\n                     : 0.0,\n          hasNextRow ? getAValue(b, sourceFloorRC.x, sourceFloorRC.z, d)\n                     : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getAValue(b, sourceFloorRC.x, sourceFloorRC.z, d + 1) : 0.0);\n\n        vec4 bottomLeft = vec4(\n          getAValue(b, sourceCeilRC.x, sourceFloorRC.y, d),\n          hasNextCol ? getAValue(b, sourceCeilRC.x, sourceFloorRC.y, d + 1)\n                     : 0.0,\n          hasNextRow ? getAValue(b, sourceCeilRC.x, sourceFloorRC.z, d)\n                     : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getAValue(b, sourceCeilRC.x, sourceFloorRC.z, d + 1) : 0.0);\n\n        vec4 topRight = vec4(\n          getAValue(b, sourceFloorRC.x, sourceCeilRC.y, d),\n          hasNextCol ? getAValue(b, sourceFloorRC.x, sourceCeilRC.y, d + 1)\n                     : 0.0,\n          hasNextRow ? getAValue(b, sourceFloorRC.x, sourceCeilRC.z, d)\n                     : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getAValue(b, sourceFloorRC.x, sourceCeilRC.z, d + 1) : 0.0);\n\n        vec4 bottomRight = vec4(\n          getAValue(b, sourceCeilRC.x, sourceCeilRC.y, d),\n          hasNextCol ? getAValue(b, sourceCeilRC.x, sourceCeilRC.y, d + 1)\n                     : 0.0,\n          hasNextRow ? getAValue(b, sourceCeilRC.x, sourceCeilRC.z, d)\n                     : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getAValue(b, sourceCeilRC.x, sourceCeilRC.z, d + 1) : 0.0);\n\n        vec3 fracRC = sourceFracIndexRC - vec3(sourceFloorRC);\n\n        vec4 top = mix(topLeft, topRight, fracRC.yyzz);\n        vec4 bottom = mix(bottomLeft, bottomRight, fracRC.yyzz);\n        vec4 newValue = mix(top, bottom, fracRC.x);\n\n        setOutput(newValue);\n      }\n    ";
	    }
	    return ResizeBilinearPackedProgram;
	}());
	exports.ResizeBilinearPackedProgram = ResizeBilinearPackedProgram;
	//# sourceMappingURL=resize_bilinear_packed_gpu.js.map

/***/ },
/* 1020 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ResizeNearestNeigborBackpropProgram = /** @class */ (function () {
	    function ResizeNearestNeigborBackpropProgram(dy, x, alignCorners) {
	        this.variableNames = ['dy'];
	        this.outputShape = [];
	        this.outputShape = x.shape;
	        var _a = x.shape, xHeight = _a[1], xWidth = _a[2];
	        var _b = dy.shape, yHeight = _b[1], yWidth = _b[2];
	        // In the backwards pass, we want to find the pixels that were generated for
	        // each pixel in the input image the forward pass and add the corresponding
	        // coefficient from dy to the gradient (with some interpolation).
	        var effectiveXSize = [
	            (alignCorners && yHeight > 1) ? xHeight - 1 : xHeight,
	            (alignCorners && yWidth > 1) ? xWidth - 1 : xWidth
	        ];
	        var effectiveYSize = [
	            (alignCorners && yHeight > 1) ? yHeight - 1 : yHeight,
	            (alignCorners && yWidth > 1) ? yWidth - 1 : yWidth
	        ];
	        var heightScale = effectiveXSize[0] / effectiveYSize[0];
	        var widthScale = effectiveXSize[1] / effectiveYSize[1];
	        var invHeightScale = 1 / heightScale;
	        var invWidthScale = 1 / widthScale;
	        // This defines the size of the window of values around a particular
	        // index in dy that we want to search for contributions to dx.
	        var winHeight = (Math.ceil(invHeightScale) * 2) + 2;
	        var winWidth = (Math.ceil(invWidthScale) * 2) + 2;
	        this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        int r = coords[1];\n        int c = coords[2];\n\n        float accumulator = 0.0;\n\n        const float heightScale = float(" + heightScale + ");\n        const float widthScale = float(" + widthScale + ");\n\n        const float invHeightScale = float(" + invHeightScale + ");\n        const float invWidthScale = float(" + invWidthScale + ");\n\n        const int winHeight = int(" + winHeight + ");\n        const int winWidth = int(" + winWidth + ");\n\n        // Compute bounds for where in dy we will look\n        float startRLerp = floor(float(r) * invHeightScale);\n        int startDyR = int(floor(startRLerp - float(winHeight / 2)));\n\n        float startCLerp = floor(float(c) * invWidthScale);\n        int startDyC = int(floor(startCLerp - float(winWidth / 2)));\n\n        // Loop over dy\n        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {\n          int dyR = dyROffset + startDyR;\n\n          // Guard against the window exceeding the bounds of dy\n          if (dyR < 0 || dyR >= " + yHeight + ") {\n            continue;\n          }\n\n          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {\n            int dyC = dyCOffset + startDyC;\n\n            // Guard against the window exceeding the bounds of dy\n            if (dyC < 0 || dyC >= " + yWidth + ") {\n              continue;\n            }\n\n            float sourceFracRow =\n              float(" + effectiveXSize[0] + ") *\n                (float(dyR) / float(" + effectiveYSize[0] + "));\n\n            float sourceFracCol =\n                float(" + effectiveXSize[1] + ") *\n                  (float(dyC) / float(" + effectiveYSize[1] + "));\n\n            int sourceNearestRow = int(min(\n                float(int(" + xHeight + ") - 1),\n                " + alignCorners + " ? float(round(sourceFracRow)) :\n                                  float(floor(sourceFracRow))));\n\n            int sourceNearestCol = int(min(\n                float(int(" + xWidth + ") - 1),\n                " + alignCorners + " ? float(round(sourceFracCol)) :\n                                  float(floor(sourceFracCol))));\n\n            if (r == sourceNearestRow && c == sourceNearestCol) {\n              accumulator += getDy(b, dyR, dyC, d);\n            }\n          }\n        }\n        // End loop over dy\n\n        setOutput(accumulator);\n      }\n    ";
	    }
	    return ResizeNearestNeigborBackpropProgram;
	}());
	exports.ResizeNearestNeigborBackpropProgram = ResizeNearestNeigborBackpropProgram;
	//# sourceMappingURL=resize_nearest_neighbor_backprop_gpu.js.map

/***/ },
/* 1021 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ResizeNearestNeighborProgram = /** @class */ (function () {
	    function ResizeNearestNeighborProgram(inputShape, newHeight, newWidth, alignCorners) {
	        this.variableNames = ['A'];
	        this.outputShape = [];
	        var batch = inputShape[0], oldHeight = inputShape[1], oldWidth = inputShape[2], depth = inputShape[3];
	        this.outputShape = [batch, newHeight, newWidth, depth];
	        var effectiveInSize = [
	            (alignCorners && newHeight > 1) ? oldHeight - 1 : oldHeight,
	            (alignCorners && newWidth > 1) ? oldWidth - 1 : oldWidth
	        ];
	        var effectiveOutSize = [
	            (alignCorners && newHeight > 1) ? newHeight - 1 : newHeight,
	            (alignCorners && newWidth > 1) ? newWidth - 1 : newWidth
	        ];
	        // When align corners is false, we rounds the value with floor.
	        var roundBase = alignCorners ? '0.5' : '0.0';
	        this.userCode = "\n      const vec2 effectiveInputOverOutputRatioRC = vec2(\n          " + effectiveInSize[0] / effectiveOutSize[0] + ",\n          " + effectiveInSize[1] / effectiveOutSize[1] + ");\n      const vec2 inputShapeRC = vec2(" + oldHeight + ".0, " + oldWidth + ".0);\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        ivec2 yRC = coords.yz;\n\n        // Fractional source index.\n        vec2 sourceFracIndexRC = vec2(yRC) * effectiveInputOverOutputRatioRC;\n\n        // Compute the coordinators of nearest neighbor point.\n        ivec2 sourceNearestRC = ivec2(\n          min(inputShapeRC - 1.0, floor(sourceFracIndexRC + " + roundBase + ")));\n\n        float newValue = getA(b, sourceNearestRC.x, sourceNearestRC.y, d);\n\n        setOutput(newValue);\n      }\n    ";
	    }
	    return ResizeNearestNeighborProgram;
	}());
	exports.ResizeNearestNeighborProgram = ResizeNearestNeighborProgram;
	//# sourceMappingURL=resize_nearest_neighbor_gpu.js.map

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var shader_compiler_1 = __webpack_require__(41);
	var ReverseProgram = /** @class */ (function () {
	    function ReverseProgram(xShape, axis) {
	        this.variableNames = ['x'];
	        var rank = xShape.length;
	        if (rank > 4) {
	            throw new Error("WebGL backend: Reverse of rank-" + rank + " tensor is not yet supported");
	        }
	        this.outputShape = xShape;
	        if (rank === 1) {
	            this.userCode = "\n        void main() {\n          int coord = getOutputCoords();\n          setOutput(getX(" + xShape[0] + " - coord - 1));\n        }\n      ";
	            return;
	        }
	        var getInCoord = function (i) {
	            if (axis.indexOf(i) !== -1 && xShape[i] !== 1) {
	                return xShape[i] + " - coords[" + i + "] - 1";
	            }
	            return "coords[" + i + "]";
	        };
	        var inCoords = xShape.map(function (_, i) { return getInCoord(i); }).join(',');
	        var type = shader_compiler_1.getCoordsDataType(rank);
	        this.userCode = "\n      void main() {\n        " + type + " coords = getOutputCoords();\n        setOutput(getX(" + inCoords + "));\n      }\n    ";
	    }
	    return ReverseProgram;
	}());
	exports.ReverseProgram = ReverseProgram;
	//# sourceMappingURL=reverse_gpu.js.map

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var packing_util_1 = __webpack_require__(107);
	var shader_compiler_1 = __webpack_require__(41);
	var ReversePackedProgram = /** @class */ (function () {
	    function ReversePackedProgram(xShape, axis) {
	        this.variableNames = ['x'];
	        this.packedInputs = true;
	        this.packedOutput = true;
	        var rank = xShape.length;
	        if (rank > 4) {
	            throw new Error("WebGL backend: Reverse of rank-" + rank + " tensor is not yet supported");
	        }
	        this.outputShape = xShape;
	        var channels = packing_util_1.getChannels('rc', rank);
	        var nextColumn = channels[rank - 1] + " + 1 < " + this.outputShape[rank - 1];
	        var nextRow = channels[rank - 2] + " + 1 < " + this.outputShape[rank - 2];
	        var type = shader_compiler_1.getCoordsDataType(rank);
	        if (rank === 1) {
	            this.userCode = "\n        void main(){\n          int rc = getOutputCoords();\n          vec4 result = vec4(0.);\n          result.r = getChannel(getX(" + xShape[0] + " - rc - 1),\n            " + xShape[0] + " - rc - 1);\n          if(" + nextColumn + "){\n              result.g = getChannel(getX(" + xShape[0] + " - (rc  + 1) - 1),\n                " + xShape[0] + " - (rc  + 1) - 1);\n          }\n          setOutput(result);\n        }\n      ";
	        }
	        else {
	            this.userCode = "\n        void main() {\n          " + type + " rc = getOutputCoords();\n          vec4 result = vec4(0.);\n          result.r = " + getR(channels.slice()) + ";\n          if(" + nextColumn + "){\n            result.g = " + getG(channels.slice()) + ";\n          }\n          if(" + nextRow + ") {\n            result.b = " + getB(channels.slice()) + ";\n            if(" + nextColumn + ") {\n              result.a = " + getA(channels.slice()) + ";\n            }\n          }\n          setOutput(result);\n        }\n    ";
	        }
	        function getR(channels) {
	            return getChannel(channels);
	        }
	        function getG(channels) {
	            channels[rank - 1] = '(' + channels[rank - 1] + " + 1)";
	            return getChannel(channels);
	        }
	        function getB(channels) {
	            channels[rank - 2] = '(' + channels[rank - 2] + " + 1)";
	            return getChannel(channels);
	        }
	        function getA(channels) {
	            channels[rank - 1] = '(' + channels[rank - 1] + " + 1)";
	            channels[rank - 2] = '(' + channels[rank - 2] + " + 1)";
	            return getChannel(channels);
	        }
	        function getChannel(channels) {
	            var inCoordsArray = xShape.map(function (_, i) { return getInCoord(i, channels); });
	            var inCoords = inCoordsArray.join(',');
	            var innerDims = inCoordsArray.slice(-2).join(',');
	            return "getChannel(getX(" + inCoords + "), vec2(" + innerDims + "))";
	        }
	        function getInCoord(i, channels1) {
	            if (axis.indexOf(i) !== -1 && xShape[i] !== 1) {
	                return xShape[i] + " - " + channels1[i] + " - 1";
	            }
	            else {
	                return "" + channels1[i];
	            }
	        }
	    }
	    return ReversePackedProgram;
	}());
	exports.ReversePackedProgram = ReversePackedProgram;
	//# sourceMappingURL=reverse_packed_gpu.js.map

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var shader_compiler_1 = __webpack_require__(41);
	var ScatterProgram = /** @class */ (function () {
	    function ScatterProgram(updateSize, sliceDim, indicesRank, updatesRank, strides, shape, summingDupeIndex) {
	        if (summingDupeIndex === void 0) { summingDupeIndex = true; }
	        this.variableNames = ['updates', 'indices', 'defaultValue'];
	        this.outputShape = shape;
	        var stridesType = shader_compiler_1.getCoordsDataType(strides.length);
	        var dtype = shader_compiler_1.getCoordsDataType(shape.length);
	        var indicesString = '';
	        if (indicesRank === 1) {
	            indicesString = 'i';
	        }
	        else if (indicesRank === 2) {
	            indicesString = 'i, j';
	        }
	        var indicesSnippet = "getIndices(" + indicesString + ")";
	        var updatesString = '';
	        if (updatesRank === 1) {
	            updatesString = 'i';
	        }
	        else if (updatesRank === 2) {
	            updatesString = 'i, coords[1]';
	        }
	        var updatesSnippet = "getUpdates(" + updatesString + ")";
	        var strideString = sliceDim > 1 ? 'strides[j]' : 'strides';
	        this.userCode = "\n        " + stridesType + " strides = " + stridesType + "(" + strides + ");\n\n        void main() {\n          " + dtype + " coords = getOutputCoords();\n          float sum = 0.0;\n          bool found = false;\n          for (int i = 0; i < " + updateSize + "; i++) {\n            int flattenedIndex = 0;\n            for (int j = 0; j < " + sliceDim + "; j++) {\n              int index = round(" + indicesSnippet + ");\n              flattenedIndex += index * " + strideString + ";\n            }\n            if (flattenedIndex == coords[0]) {\n              sum += " + updatesSnippet + ";\n              found = true;\n            }\n          }\n          setOutput(mix(getDefaultValue(), sum, float(found)));\n        }\n      ";
	    }
	    return ScatterProgram;
	}());
	exports.ScatterProgram = ScatterProgram;
	//# sourceMappingURL=scatter_gpu.js.map

/***/ },
/* 1025 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var SegmentOpProgram = /** @class */ (function () {
	    function SegmentOpProgram(segOpInfo, segOpType) {
	        this.variableNames = ['x', 'segmentIds'];
	        var windowSize = segOpInfo.windowSize;
	        var batchSize = segOpInfo.batchSize;
	        var inSize = segOpInfo.inSize;
	        var numSegments = segOpInfo.numSegments;
	        var outSize = numSegments * Math.ceil(inSize / windowSize);
	        this.outputShape = [batchSize, outSize];
	        var initializationValue = '0.0';
	        var returnValue = "sumValue";
	        var windowSizeNearestVec4 = Math.floor(windowSize / 4) * 4;
	        var windowSizeVec4Remainder = windowSize % 4;
	        var updateSnippet = "\n        sumValue += dot(values, segFilter);\n    ";
	        var checkValueOutOfBounds = '';
	        if (inSize % windowSize > 0) {
	            checkValueOutOfBounds = "\n        if (inIdx < 0 || inIdx >= " + inSize + ") {\n          return initializationValue;\n        }\n      ";
	        }
	        var checkSegmentIdOutOfBounds = '';
	        if (inSize % windowSize > 0) {
	            checkSegmentIdOutOfBounds = "\n        if (inIdx < 0 || inIdx >= " + inSize + ") {\n          return -1.0;\n        }\n      ";
	        }
	        this.userCode = "\n      const float initializationValue = " + initializationValue + ";\n\n      float getValue(int batch, int inIdx) {\n        " + checkValueOutOfBounds + "\n        return getX(batch, inIdx);\n      }\n\n      float getSegmentIdAtIndex(int inIdx) {\n        " + checkSegmentIdOutOfBounds + "\n        return getSegmentIds(inIdx);\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = int(floor(float(outIdx) / float(\n          " + numSegments + ")) * float(" + windowSize + "));\n        int currentSeg = int(mod(float(outIdx), float(" + numSegments + ")));\n\n        float sumValue = 0.0;\n\n        for (int i = 0; i < " + windowSizeNearestVec4 + "; i += 4) {\n          int inIdx = inOffset + i;\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            getValue(batch, inIdx + 3)\n          );\n\n          vec4 segFilter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 3)) == currentSeg ? 1 : 0\n          );\n\n          " + updateSnippet + "\n        }\n\n        int inIdx = inOffset + " + windowSizeNearestVec4 + ";\n        if (" + (windowSizeVec4Remainder === 1) + ") {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            initializationValue,\n            initializationValue,\n            initializationValue\n          );\n\n          int inIdxSeg = int(getSegmentIdAtIndex(inIdx));\n\n          vec4 segFilter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            0,\n            0,\n            0\n          );\n\n          " + updateSnippet + "\n        } else if (" + (windowSizeVec4Remainder === 2) + ") {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            initializationValue,\n            initializationValue\n          );\n\n          vec4 segFilter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n              0,\n              0\n          );\n\n          " + updateSnippet + "\n        } else if (" + (windowSizeVec4Remainder === 3) + ") {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            initializationValue\n          );\n\n          vec4 segFilter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,\n            0\n          );\n\n          " + updateSnippet + "\n        }\n        setOutput(" + returnValue + ");\n      }\n    ";
	    }
	    return SegmentOpProgram;
	}());
	exports.SegmentOpProgram = SegmentOpProgram;
	//# sourceMappingURL=segment_gpu.js.map

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var shader_compiler_1 = __webpack_require__(41);
	var SelectProgram = /** @class */ (function () {
	    function SelectProgram(cRank, shape, rank) {
	        this.variableNames = ['c', 'a', 'b'];
	        this.outputShape = shape;
	        var cCoords;
	        var abCoords;
	        if (rank > 4) {
	            throw Error("Where for rank " + rank + " is not yet supported");
	        }
	        if (rank === 1) {
	            abCoords = "resRC";
	            cCoords = "resRC";
	        }
	        else {
	            var currentCoords = ['resRC.x', 'resRC.y', 'resRC.z', 'resRC.w'];
	            var cCoordVars = [];
	            var abCoordVars = [];
	            for (var i = 0; i < shape.length; i++) {
	                abCoordVars.push("" + currentCoords[i]);
	                if (i < cRank) {
	                    cCoordVars.push("" + currentCoords[i]);
	                }
	            }
	            cCoords = cCoordVars.join();
	            abCoords = abCoordVars.join();
	        }
	        var dtype = shader_compiler_1.getCoordsDataType(rank);
	        this.userCode = "\n      void main() {\n        " + dtype + " resRC = getOutputCoords();\n        float cVal = getC(" + cCoords + ");\n        if (cVal >= 1.0) {\n          setOutput(getA(" + abCoords + "));\n        } else {\n          setOutput(getB(" + abCoords + "));\n        }\n      }\n    ";
	    }
	    return SelectProgram;
	}());
	exports.SelectProgram = SelectProgram;
	//# sourceMappingURL=select_gpu.js.map

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var shader_compiler_1 = __webpack_require__(41);
	var SliceProgram = /** @class */ (function () {
	    function SliceProgram(destSize) {
	        this.variableNames = ['source'];
	        this.outputShape = destSize;
	        this.rank = destSize.length;
	        var dtype = shader_compiler_1.getCoordsDataType(this.rank);
	        var uniformPart = "uniform int start[" + this.rank + "];";
	        var sourceCoords = getCoords(this.rank);
	        var body;
	        var coordSum = destSize.map(function (_, i) {
	            return "sourceLoc." + coords[i] + " = start[" + i + "] + coords." + coords[i] + ";";
	        });
	        body = "\n        " + dtype + " sourceLoc;\n        " + dtype + " coords = getOutputCoords();\n        " + coordSum.join('\n') + "\n      ";
	        this.userCode = "\n      " + uniformPart + "\n      void main() {\n        " + body + "\n        setOutput(getSource(" + sourceCoords + "));\n      }\n    ";
	    }
	    SliceProgram.prototype.getCustomSetupFunc = function (start) {
	        var _this = this;
	        if (start.length !== this.rank) {
	            throw Error("The rank (" + this.rank + ") of the program must match the " +
	                ("length of start (" + start.length + ")"));
	        }
	        return function (gpgpu, webGLProgram) {
	            if (_this.startLoc == null) {
	                _this.startLoc = gpgpu.getUniformLocationNoThrow(webGLProgram, 'start');
	                if (_this.startLoc == null) {
	                    // This means the compiler has optimized and realized it doesn't need
	                    // the uniform.
	                    return;
	                }
	            }
	            gpgpu.gl.uniform1iv(_this.startLoc, start);
	        };
	    };
	    return SliceProgram;
	}());
	exports.SliceProgram = SliceProgram;
	var coords = ['x', 'y', 'z', 'w', 'u', 'v'];
	function getCoords(rank) {
	    if (rank === 1) {
	        return 'sourceLoc';
	    }
	    else if (rank <= 6) {
	        return coords.slice(0, rank).map(function (x) { return 'sourceLoc.' + x; }).join(',');
	    }
	    else {
	        throw Error("Slicing for rank " + rank + " is not yet supported");
	    }
	}
	//# sourceMappingURL=slice_gpu.js.map

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var packing_util_1 = __webpack_require__(107);
	var shader_compiler_1 = __webpack_require__(41);
	var SlicePackedProgram = /** @class */ (function () {
	    function SlicePackedProgram(destSize) {
	        this.variableNames = ['source'];
	        this.packedInputs = true;
	        this.packedOutput = true;
	        this.outputShape = destSize;
	        this.rank = destSize.length;
	        var dtype = shader_compiler_1.getCoordsDataType(this.rank);
	        var coords = packing_util_1.getChannels('coords', this.rank);
	        var sourceLoc = packing_util_1.getChannels('sourceLoc', this.rank);
	        var innerDims = this.rank === 1 ? 'sourceLoc' : "vec2(" + sourceLoc.slice(-2).join() + ")";
	        var getChannel = "getChannel(getSource(" + sourceLoc.join() + "), " + innerDims + ")";
	        var upperRow = "\n      result.x = " + getChannel + ";\n      if (++" + coords[this.rank - 1] + " < " + destSize[this.rank - 1] + ") {\n        ++" + sourceLoc[this.rank - 1] + ";\n        result.y = " + getChannel + ";\n        --" + sourceLoc[this.rank - 1] + ";\n      }\n    ";
	        var lowerRow = this.rank === 1 ? '' : "\n      --" + coords[this.rank - 1] + ";\n      if (++" + coords[this.rank - 2] + " < " + destSize[this.rank - 2] + ") {\n        ++" + sourceLoc[this.rank - 2] + ";\n        result.z = " + getChannel + ";\n        if (++" + coords[this.rank - 1] + " < " + destSize[this.rank - 1] + ") {\n          ++" + sourceLoc[this.rank - 1] + ";\n          result.w = " + getChannel + ";\n        }\n      }\n    ";
	        var sourceLocSetup = this.rank <= 4 ?
	            "sourceLoc = coords +\n            " + dtype + "(" + destSize.map(function (_, i) { return "start[" + i + "]"; }).join() + ");" :
	            destSize.map(function (_, i) { return sourceLoc[i] + " = " + coords[i] + " + start[" + i + "];"; })
	                .join('\n');
	        this.userCode = "\n      uniform int start[" + this.rank + "];\n      void main() {\n        " + dtype + " coords = getOutputCoords();\n        " + dtype + " sourceLoc;\n        " + sourceLocSetup + "\n        vec4 result = vec4(0.);\n        " + upperRow + "\n        " + lowerRow + "\n        setOutput(result);\n      }\n    ";
	    }
	    SlicePackedProgram.prototype.getCustomSetupFunc = function (start) {
	        var _this = this;
	        if (start.length !== this.rank) {
	            throw Error("The rank (" + this.rank + ") of the program must match the " +
	                ("length of start (" + start.length + ")"));
	        }
	        return function (gpgpu, webGLProgram) {
	            if (_this.startLoc == null) {
	                _this.startLoc = gpgpu.getUniformLocationNoThrow(webGLProgram, 'start');
	                if (_this.startLoc == null) {
	                    // This means the compiler has optimized and realized it doesn't need
	                    // the uniform.
	                    return;
	                }
	            }
	            gpgpu.gl.uniform1iv(_this.startLoc, start);
	        };
	    };
	    return SlicePackedProgram;
	}());
	exports.SlicePackedProgram = SlicePackedProgram;
	//# sourceMappingURL=slice_packed_gpu.js.map

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var shader_compiler_1 = __webpack_require__(41);
	var StridedSliceProgram = /** @class */ (function () {
	    function StridedSliceProgram(begin, strides, size) {
	        this.variableNames = ['x'];
	        this.outputShape = size;
	        var rank = size.length;
	        var inputDtype = shader_compiler_1.getCoordsDataType(size.length);
	        var dtype = shader_compiler_1.getCoordsDataType(size.length);
	        var newCoords = '';
	        if (rank === 1) {
	            newCoords = 'coords * strides + begin';
	        }
	        else {
	            var outputAxis_1 = 0;
	            newCoords =
	                size.map(function (_, i) {
	                    outputAxis_1++;
	                    return size.length === 1 ?
	                        "coords * strides[" + i + "] + begin[" + i + "]" :
	                        "coords[" + (outputAxis_1 - 1) + "] * strides[" + i + "] + begin[" + i + "]";
	                })
	                    .join(',');
	        }
	        this.userCode = "\n      " + inputDtype + " begin = " + inputDtype + "(" + begin + ");\n      " + inputDtype + " strides = " + inputDtype + "(" + strides + ");\n\n      void main() {\n        " + dtype + " coords = getOutputCoords();\n        setOutput(getX(" + newCoords + "));\n      }\n    ";
	    }
	    return StridedSliceProgram;
	}());
	exports.StridedSliceProgram = StridedSliceProgram;
	//# sourceMappingURL=strided_slice_gpu.js.map

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var environment_1 = __webpack_require__(28);
	var tex_util_1 = __webpack_require__(82);
	var TextureManager = /** @class */ (function () {
	    function TextureManager(gpgpu) {
	        this.gpgpu = gpgpu;
	        this.numUsedTextures = 0;
	        this.numFreeTextures = 0;
	        this.freeTextures = {};
	        this.logEnabled = false;
	        this.usedTextures = {};
	    }
	    TextureManager.prototype.acquireTexture = function (shapeRC, usage, isPacked) {
	        var physicalTexType = getPhysicalFromLogicalTextureType(usage, isPacked);
	        var shapeKey = getKeyFromTextureShape(shapeRC, physicalTexType, isPacked);
	        if (!(shapeKey in this.freeTextures)) {
	            this.freeTextures[shapeKey] = [];
	        }
	        if (!(shapeKey in this.usedTextures)) {
	            this.usedTextures[shapeKey] = [];
	        }
	        if (this.freeTextures[shapeKey].length > 0) {
	            this.numFreeTextures--;
	            this.numUsedTextures++;
	            this.log();
	            var newTexture_1 = this.freeTextures[shapeKey].shift();
	            this.usedTextures[shapeKey].push(newTexture_1);
	            return newTexture_1;
	        }
	        this.numUsedTextures++;
	        this.log();
	        var newTexture;
	        if (physicalTexType === tex_util_1.PhysicalTextureType.PACKED_2X2_FLOAT32) {
	            newTexture = this.gpgpu.createPackedMatrixTexture(shapeRC[0], shapeRC[1]);
	        }
	        else if (physicalTexType === tex_util_1.PhysicalTextureType.PACKED_2X2_FLOAT16) {
	            newTexture =
	                this.gpgpu.createFloat16PackedMatrixTexture(shapeRC[0], shapeRC[1]);
	        }
	        else if (physicalTexType === tex_util_1.PhysicalTextureType.UNPACKED_FLOAT32) {
	            newTexture =
	                this.gpgpu.createFloat32MatrixTexture(shapeRC[0], shapeRC[1]);
	        }
	        else if (physicalTexType === tex_util_1.PhysicalTextureType.UNPACKED_FLOAT16) {
	            newTexture =
	                this.gpgpu.createFloat16MatrixTexture(shapeRC[0], shapeRC[1]);
	        }
	        else if (physicalTexType === tex_util_1.PhysicalTextureType.PACKED_4X1_UNSIGNED_BYTE) {
	            newTexture =
	                this.gpgpu.createUnsignedBytesMatrixTexture(shapeRC[0], shapeRC[1]);
	        }
	        this.usedTextures[shapeKey].push(newTexture);
	        return newTexture;
	    };
	    TextureManager.prototype.releaseTexture = function (texture, shape, logicalTexType, isPacked) {
	        if (this.freeTextures == null) {
	            // Already disposed.
	            return;
	        }
	        var physicalTexType = getPhysicalFromLogicalTextureType(logicalTexType, isPacked);
	        var shapeKey = getKeyFromTextureShape(shape, physicalTexType, isPacked);
	        if (!(shapeKey in this.freeTextures)) {
	            this.freeTextures[shapeKey] = [];
	        }
	        this.freeTextures[shapeKey].push(texture);
	        this.numFreeTextures++;
	        this.numUsedTextures--;
	        var texList = this.usedTextures[shapeKey];
	        var texIndex = texList.indexOf(texture);
	        if (texIndex < 0) {
	            throw new Error('Cannot release a texture that was never provided by this ' +
	                'texture manager');
	        }
	        texList.splice(texIndex, 1);
	        this.log();
	    };
	    TextureManager.prototype.log = function () {
	        if (!this.logEnabled) {
	            return;
	        }
	        var total = this.numFreeTextures + this.numUsedTextures;
	        console.log('Free/Used', this.numFreeTextures + " / " + this.numUsedTextures, "(" + total + ")");
	    };
	    TextureManager.prototype.getNumUsedTextures = function () {
	        return this.numUsedTextures;
	    };
	    TextureManager.prototype.getNumFreeTextures = function () {
	        return this.numFreeTextures;
	    };
	    TextureManager.prototype.dispose = function () {
	        var _this = this;
	        if (this.freeTextures == null) {
	            // Already disposed.
	            return;
	        }
	        for (var texShape in this.freeTextures) {
	            this.freeTextures[texShape].forEach(function (tex) {
	                _this.gpgpu.deleteMatrixTexture(tex);
	            });
	        }
	        for (var texShape in this.usedTextures) {
	            this.usedTextures[texShape].forEach(function (tex) {
	                _this.gpgpu.deleteMatrixTexture(tex);
	            });
	        }
	        this.freeTextures = null;
	        this.usedTextures = null;
	        this.numUsedTextures = 0;
	        this.numFreeTextures = 0;
	    };
	    return TextureManager;
	}());
	exports.TextureManager = TextureManager;
	function getPhysicalTextureForRendering(isPacked) {
	    if (environment_1.env().getBool('WEBGL_RENDER_FLOAT32_ENABLED')) {
	        if (isPacked) {
	            return tex_util_1.PhysicalTextureType.PACKED_2X2_FLOAT32;
	        }
	        return tex_util_1.PhysicalTextureType.UNPACKED_FLOAT32;
	    }
	    if (isPacked) {
	        return tex_util_1.PhysicalTextureType.PACKED_2X2_FLOAT16;
	    }
	    return tex_util_1.PhysicalTextureType.UNPACKED_FLOAT16;
	}
	function getPhysicalFromLogicalTextureType(logicalTexType, isPacked) {
	    if (logicalTexType === tex_util_1.TextureUsage.UPLOAD) {
	        return tex_util_1.PhysicalTextureType.PACKED_2X2_FLOAT32;
	    }
	    else if (logicalTexType === tex_util_1.TextureUsage.RENDER || logicalTexType == null) {
	        return getPhysicalTextureForRendering(isPacked);
	    }
	    else if (logicalTexType === tex_util_1.TextureUsage.DOWNLOAD ||
	        logicalTexType === tex_util_1.TextureUsage.PIXELS) {
	        return tex_util_1.PhysicalTextureType.PACKED_4X1_UNSIGNED_BYTE;
	    }
	    throw new Error("Unknown logical texture type " + logicalTexType);
	}
	function getKeyFromTextureShape(shapeRowsCol, physicalTexType, isPacked) {
	    return shapeRowsCol[0] + "_" + shapeRowsCol[1] + "_" + physicalTexType + "_" + isPacked;
	}
	//# sourceMappingURL=texture_manager.js.map

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var shader_compiler_1 = __webpack_require__(41);
	var TileProgram = /** @class */ (function () {
	    function TileProgram(aShape, reps) {
	        this.variableNames = ['A'];
	        var outputShape = new Array(aShape.length);
	        for (var i = 0; i < outputShape.length; i++) {
	            outputShape[i] = aShape[i] * reps[i];
	        }
	        this.outputShape = outputShape;
	        this.rank = outputShape.length;
	        var dtype = shader_compiler_1.getCoordsDataType(this.rank);
	        var sourceCoords = getSourceCoords(aShape);
	        this.userCode = "\n      void main() {\n        " + dtype + " resRC = getOutputCoords();\n        setOutput(getA(" + sourceCoords + "));\n      }\n    ";
	    }
	    return TileProgram;
	}());
	exports.TileProgram = TileProgram;
	function getSourceCoords(aShape) {
	    var rank = aShape.length;
	    if (rank > 5) {
	        throw Error("Tile for rank " + rank + " is not yet supported");
	    }
	    if (rank === 1) {
	        return "imod(resRC, " + aShape[0] + ")";
	    }
	    var currentCoords = ['resRC.x', 'resRC.y', 'resRC.z', 'resRC.w', 'resRC.u'];
	    var sourceCoords = [];
	    for (var i = 0; i < aShape.length; i++) {
	        sourceCoords.push("imod(" + currentCoords[i] + ", " + aShape[i] + ")");
	    }
	    return sourceCoords.join();
	}
	//# sourceMappingURL=tile_gpu.js.map

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var shader_compiler_1 = __webpack_require__(41);
	var TransposeProgram = /** @class */ (function () {
	    function TransposeProgram(aShape, newDim) {
	        this.variableNames = ['A'];
	        var outputShape = new Array(aShape.length);
	        for (var i = 0; i < outputShape.length; i++) {
	            outputShape[i] = aShape[newDim[i]];
	        }
	        this.outputShape = outputShape;
	        this.rank = outputShape.length;
	        var dtype = shader_compiler_1.getCoordsDataType(this.rank);
	        var switched = getSwitchedCoords(newDim);
	        this.userCode = "\n    void main() {\n      " + dtype + " resRC = getOutputCoords();\n      setOutput(getA(" + switched + "));\n    }\n    ";
	    }
	    return TransposeProgram;
	}());
	exports.TransposeProgram = TransposeProgram;
	function getSwitchedCoords(newDim) {
	    var rank = newDim.length;
	    if (rank > 6) {
	        throw Error("Transpose for rank " + rank + " is not yet supported");
	    }
	    var originalOrder = ['resRC.x', 'resRC.y', 'resRC.z', 'resRC.w', 'resRC.u', 'resRC.v'];
	    var switchedCoords = new Array(rank);
	    for (var i = 0; i < newDim.length; i++) {
	        switchedCoords[newDim[i]] = originalOrder[i];
	    }
	    return switchedCoords.join();
	}
	//# sourceMappingURL=transpose_gpu.js.map

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var packing_util_1 = __webpack_require__(107);
	var shader_compiler_1 = __webpack_require__(41);
	var TransposePackedProgram = /** @class */ (function () {
	    function TransposePackedProgram(aShape, newDim) {
	        this.variableNames = ['A'];
	        this.packedInputs = true;
	        this.packedOutput = true;
	        var outputShape = new Array(aShape.length);
	        for (var i = 0; i < outputShape.length; i++) {
	            outputShape[i] = aShape[newDim[i]];
	        }
	        this.outputShape = outputShape;
	        this.rank = outputShape.length;
	        if (this.rank > 6) {
	            throw Error("Packed transpose for rank " + this.rank + " is not yet supported.");
	        }
	        var dtype = shader_compiler_1.getCoordsDataType(this.rank);
	        var outputOrder = packing_util_1.getVecChannels('rc', this.rank);
	        var switchedOrder = new Array(this.rank);
	        for (var i = 0; i < newDim.length; i++) {
	            switchedOrder[newDim[i]] = outputOrder[i];
	        }
	        var innerDims = "vec2(" + switchedOrder.slice(-2).join() + ")";
	        var nextColumn = "++" + outputOrder[this.rank - 1] + " < " + outputShape[this.rank - 1];
	        var getc = "getChannel(getA(" + switchedOrder.join() + "), " + innerDims + ")";
	        this.userCode = "\n    void main() {\n      " + dtype + " rc = getOutputCoords();\n      vec4 result = vec4(0.);\n      result[0] = " + getc + ";\n      if(" + nextColumn + ") {\n        result[1] = " + getc + ";\n      }\n      --" + outputOrder[this.rank - 1] + ";\n      if(++" + outputOrder[this.rank - 2] + " < " + outputShape[this.rank - 2] + ") {\n        result[2] = " + getc + ";\n        if(" + nextColumn + ") {\n          result[3] = " + getc + ";\n        }\n      }\n      setOutput(result);\n    }\n    ";
	    }
	    return TransposePackedProgram;
	}());
	exports.TransposePackedProgram = TransposePackedProgram;
	//# sourceMappingURL=transpose_packed_gpu.js.map

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var packing_util_1 = __webpack_require__(107);
	var shader_compiler_1 = __webpack_require__(41);
	var UnpackProgram = /** @class */ (function () {
	    function UnpackProgram(outputShape) {
	        this.variableNames = ['A'];
	        this.packedInputs = true;
	        this.packedOutput = false;
	        this.outputShape = outputShape;
	        var rank = outputShape.length;
	        var channels = packing_util_1.getChannels('rc', rank);
	        var dtype = shader_compiler_1.getCoordsDataType(rank);
	        var sourceCoords = packing_util_1.getSourceCoords(rank, channels);
	        var innerDims = channels.slice(-2);
	        var coords = rank <= 1 ? 'rc' : "vec2(" + innerDims.join(',') + ")";
	        this.userCode = "\n      void main() {\n        " + dtype + " rc = getOutputCoords();\n        vec4 packedInput = getA(" + sourceCoords + ");\n\n        setOutput(getChannel(packedInput, " + coords + "));\n      }\n    ";
	    }
	    return UnpackProgram;
	}());
	exports.UnpackProgram = UnpackProgram;
	//# sourceMappingURL=unpack_gpu.js.map

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var delayCallback = (function () {
	    if (typeof requestAnimationFrame !== 'undefined') {
	        return requestAnimationFrame;
	    }
	    else if (typeof setImmediate !== 'undefined') {
	        return setImmediate;
	    }
	    return function (f) { return f(); }; // no delays
	})();
	/**
	 * Returns a promise that resolve when a requestAnimationFrame has completed.
	 *
	 * On Node.js this uses setImmediate instead of requestAnimationFrame.
	 *
	 * This is simply a sugar method so that users can do the following:
	 * `await tf.nextFrame();`
	 */
	/** @doc {heading: 'Performance', subheading: 'Timing'} */
	function nextFrame() {
	    return new Promise(function (resolve) { return delayCallback(function () { return resolve(); }); });
	}
	exports.nextFrame = nextFrame;
	//# sourceMappingURL=browser_util.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(470).setImmediate))

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @license
	 * Copyright 2019 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var device_util = __webpack_require__(311);
	var environment_1 = __webpack_require__(28);
	var ENV = environment_1.env();
	/**
	 * This file contains environment-related flag registrations.
	 */
	/** Whether to enable debug mode. */
	ENV.registerFlag('DEBUG', function () { return false; }, function (debugValue) {
	    if (debugValue) {
	        console.warn('Debugging mode is ON. The output of every math call will ' +
	            'be downloaded to CPU and checked for NaNs. ' +
	            'This significantly impacts performance.');
	    }
	});
	/** Whether we are in a browser (as versus, say, node.js) environment. */
	ENV.registerFlag('IS_BROWSER', function () { return device_util.isBrowser(); });
	/** Whether we are in a browser (as versus, say, node.js) environment. */
	ENV.registerFlag('IS_NODE', function () { return (typeof process !== 'undefined') &&
	    (typeof process.versions !== 'undefined') &&
	    (typeof process.versions.node !== 'undefined'); });
	/** Whether this browser is Chrome. */
	ENV.registerFlag('IS_CHROME', function () { return typeof navigator !== 'undefined' && navigator != null &&
	    navigator.userAgent != null && /Chrome/.test(navigator.userAgent) &&
	    /Google Inc/.test(navigator.vendor); });
	/**
	 * True when the environment is "production" where we disable safety checks
	 * to gain performance.
	 */
	ENV.registerFlag('PROD', function () { return false; });
	/**
	 * Whether to do sanity checks when inferring a shape from user-provided
	 * values, used when creating a new tensor.
	 */
	ENV.registerFlag('TENSORLIKE_CHECK_SHAPE_CONSISTENCY', function () { return ENV.getBool('DEBUG'); });
	/** Whether deprecation warnings are enabled. */
	ENV.registerFlag('DEPRECATION_WARNINGS_ENABLED', function () { return true; });
	/** True if running unit tests. */
	ENV.registerFlag('IS_TEST', function () { return false; });
	//# sourceMappingURL=flags.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var kernel_names_1 = __webpack_require__(88);
	exports.squareGradConfig = {
	    kernelName: kernel_names_1.Square,
	    gradFunc: function (dy, saved) {
	        var x = saved[0];
	        return { x: function () { return dy.mul(x.toFloat().mul(2)); } };
	    }
	};
	//# sourceMappingURL=Square_grad.js.map

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2020 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var kernel_names_1 = __webpack_require__(88);
	var binary_ops_1 = __webpack_require__(109);
	var tensor_ops_1 = __webpack_require__(31);
	exports.squaredDifferenceGradConfig = {
	    kernelName: kernel_names_1.SquaredDifference,
	    gradFunc: function (dy, saved) {
	        var a = saved[0], b = saved[1];
	        var two = tensor_ops_1.scalar(2);
	        var derA = function () { return binary_ops_1.mul(dy, binary_ops_1.mul(two, binary_ops_1.sub(a, b))); };
	        var derB = function () { return binary_ops_1.mul(dy, binary_ops_1.mul(two, binary_ops_1.sub(b, a))); };
	        return { a: derA, b: derB };
	    }
	};
	//# sourceMappingURL=SquaredDifference_grad.js.map

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * IOHandlers related to files, such as browser-triggered file downloads,
	 * user-selected files in browser.
	 */
	var environment_1 = __webpack_require__(28);
	var io_utils_1 = __webpack_require__(150);
	var router_registry_1 = __webpack_require__(151);
	var DEFAULT_FILE_NAME_PREFIX = 'model';
	var DEFAULT_JSON_EXTENSION_NAME = '.json';
	var DEFAULT_WEIGHT_DATA_EXTENSION_NAME = '.weights.bin';
	function defer(f) {
	    return new Promise(function (resolve) { return setTimeout(resolve); }).then(f);
	}
	var BrowserDownloads = /** @class */ (function () {
	    function BrowserDownloads(fileNamePrefix) {
	        if (!environment_1.env().getBool('IS_BROWSER')) {
	            // TODO(cais): Provide info on what IOHandlers are available under the
	            //   current environment.
	            throw new Error('browserDownloads() cannot proceed because the current environment ' +
	                'is not a browser.');
	        }
	        if (fileNamePrefix.startsWith(BrowserDownloads.URL_SCHEME)) {
	            fileNamePrefix = fileNamePrefix.slice(BrowserDownloads.URL_SCHEME.length);
	        }
	        if (fileNamePrefix == null || fileNamePrefix.length === 0) {
	            fileNamePrefix = DEFAULT_FILE_NAME_PREFIX;
	        }
	        this.modelTopologyFileName = fileNamePrefix + DEFAULT_JSON_EXTENSION_NAME;
	        this.weightDataFileName =
	            fileNamePrefix + DEFAULT_WEIGHT_DATA_EXTENSION_NAME;
	    }
	    BrowserDownloads.prototype.save = function (modelArtifacts) {
	        return __awaiter(this, void 0, void 0, function () {
	            var weightsURL, weightsManifest, modelTopologyAndWeightManifest, modelTopologyAndWeightManifestURL, jsonAnchor_1, weightDataAnchor_1;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (typeof (document) === 'undefined') {
	                            throw new Error('Browser downloads are not supported in ' +
	                                'this environment since `document` is not present');
	                        }
	                        weightsURL = window.URL.createObjectURL(new Blob([modelArtifacts.weightData], { type: 'application/octet-stream' }));
	                        if (!(modelArtifacts.modelTopology instanceof ArrayBuffer)) return [3 /*break*/, 1];
	                        throw new Error('BrowserDownloads.save() does not support saving model topology ' +
	                            'in binary formats yet.');
	                    case 1:
	                        weightsManifest = [{
	                                paths: ['./' + this.weightDataFileName],
	                                weights: modelArtifacts.weightSpecs
	                            }];
	                        modelTopologyAndWeightManifest = {
	                            modelTopology: modelArtifacts.modelTopology,
	                            format: modelArtifacts.format,
	                            generatedBy: modelArtifacts.generatedBy,
	                            convertedBy: modelArtifacts.convertedBy,
	                            weightsManifest: weightsManifest
	                        };
	                        modelTopologyAndWeightManifestURL = window.URL.createObjectURL(new Blob([JSON.stringify(modelTopologyAndWeightManifest)], { type: 'application/json' }));
	                        jsonAnchor_1 = this.jsonAnchor == null ? document.createElement('a') :
	                            this.jsonAnchor;
	                        jsonAnchor_1.download = this.modelTopologyFileName;
	                        jsonAnchor_1.href = modelTopologyAndWeightManifestURL;
	                        // Trigger downloads by evoking a click event on the download anchors.
	                        // When multiple downloads are started synchronously, Firefox will only
	                        // save the last one.
	                        return [4 /*yield*/, defer(function () { return jsonAnchor_1.dispatchEvent(new MouseEvent('click')); })];
	                    case 2:
	                        // Trigger downloads by evoking a click event on the download anchors.
	                        // When multiple downloads are started synchronously, Firefox will only
	                        // save the last one.
	                        _a.sent();
	                        if (!(modelArtifacts.weightData != null)) return [3 /*break*/, 4];
	                        weightDataAnchor_1 = this.weightDataAnchor == null ?
	                            document.createElement('a') :
	                            this.weightDataAnchor;
	                        weightDataAnchor_1.download = this.weightDataFileName;
	                        weightDataAnchor_1.href = weightsURL;
	                        return [4 /*yield*/, defer(function () { return weightDataAnchor_1.dispatchEvent(new MouseEvent('click')); })];
	                    case 3:
	                        _a.sent();
	                        _a.label = 4;
	                    case 4: return [2 /*return*/, { modelArtifactsInfo: io_utils_1.getModelArtifactsInfoForJSON(modelArtifacts) }];
	                }
	            });
	        });
	    };
	    BrowserDownloads.URL_SCHEME = 'downloads://';
	    return BrowserDownloads;
	}());
	exports.BrowserDownloads = BrowserDownloads;
	var BrowserFiles = /** @class */ (function () {
	    function BrowserFiles(files) {
	        if (files == null || files.length < 1) {
	            throw new Error("When calling browserFiles, at least 1 file is required, " +
	                ("but received " + files));
	        }
	        this.files = files;
	    }
	    BrowserFiles.prototype.load = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var jsonFile, weightFiles;
	            var _this = this;
	            return __generator(this, function (_a) {
	                jsonFile = this.files[0];
	                weightFiles = this.files.slice(1);
	                return [2 /*return*/, new Promise(function (resolve, reject) {
	                        var jsonReader = new FileReader();
	                        jsonReader.onload = function (event) {
	                            // tslint:disable-next-line:no-any
	                            var modelJSON = JSON.parse(event.target.result);
	                            var modelTopology = modelJSON.modelTopology;
	                            if (modelTopology == null) {
	                                reject(new Error("modelTopology field is missing from file " + jsonFile.name));
	                                return;
	                            }
	                            if (weightFiles.length === 0) {
	                                resolve({ modelTopology: modelTopology });
	                            }
	                            var weightsManifest = modelJSON.weightsManifest;
	                            if (weightsManifest == null) {
	                                reject(new Error("weightManifest field is missing from file " + jsonFile.name));
	                                return;
	                            }
	                            var pathToFile;
	                            try {
	                                pathToFile =
	                                    _this.checkManifestAndWeightFiles(weightsManifest, weightFiles);
	                            }
	                            catch (err) {
	                                reject(err);
	                                return;
	                            }
	                            var weightSpecs = [];
	                            var paths = [];
	                            var perFileBuffers = [];
	                            weightsManifest.forEach(function (weightsGroup) {
	                                weightsGroup.paths.forEach(function (path) {
	                                    paths.push(path);
	                                    perFileBuffers.push(null);
	                                });
	                                weightSpecs.push.apply(weightSpecs, weightsGroup.weights);
	                            });
	                            weightsManifest.forEach(function (weightsGroup) {
	                                weightsGroup.paths.forEach(function (path) {
	                                    var weightFileReader = new FileReader();
	                                    weightFileReader.onload = function (event) {
	                                        // tslint:disable-next-line:no-any
	                                        var weightData = event.target.result;
	                                        var index = paths.indexOf(path);
	                                        perFileBuffers[index] = weightData;
	                                        if (perFileBuffers.indexOf(null) === -1) {
	                                            resolve({
	                                                modelTopology: modelTopology,
	                                                weightSpecs: weightSpecs,
	                                                weightData: io_utils_1.concatenateArrayBuffers(perFileBuffers),
	                                                format: modelJSON.format,
	                                                generatedBy: modelJSON.generatedBy,
	                                                convertedBy: modelJSON.convertedBy,
	                                                userDefinedMetadata: modelJSON.userDefinedMetadata
	                                            });
	                                        }
	                                    };
	                                    weightFileReader.onerror = function (error) {
	                                        return reject("Failed to weights data from file of path '" + path + "'.");
	                                    };
	                                    weightFileReader.readAsArrayBuffer(pathToFile[path]);
	                                });
	                            });
	                        };
	                        jsonReader.onerror = function (error) { return reject("Failed to read model topology and weights manifest JSON " +
	                            ("from file '" + jsonFile.name + "'. BrowserFiles supports loading ") +
	                            "Keras-style tf.Model artifacts only."); };
	                        jsonReader.readAsText(jsonFile);
	                    })];
	            });
	        });
	    };
	    /**
	     * Check the compatibility between weights manifest and weight files.
	     */
	    BrowserFiles.prototype.checkManifestAndWeightFiles = function (manifest, files) {
	        var basenames = [];
	        var fileNames = files.map(function (file) { return io_utils_1.basename(file.name); });
	        var pathToFile = {};
	        for (var _i = 0, manifest_1 = manifest; _i < manifest_1.length; _i++) {
	            var group = manifest_1[_i];
	            group.paths.forEach(function (path) {
	                var pathBasename = io_utils_1.basename(path);
	                if (basenames.indexOf(pathBasename) !== -1) {
	                    throw new Error("Duplicate file basename found in weights manifest: " +
	                        ("'" + pathBasename + "'"));
	                }
	                basenames.push(pathBasename);
	                if (fileNames.indexOf(pathBasename) === -1) {
	                    throw new Error("Weight file with basename '" + pathBasename + "' is not provided.");
	                }
	                else {
	                    pathToFile[path] = files[fileNames.indexOf(pathBasename)];
	                }
	            });
	        }
	        if (basenames.length !== files.length) {
	            throw new Error("Mismatch in the number of files in weights manifest " +
	                ("(" + basenames.length + ") and the number of weight files provided ") +
	                ("(" + files.length + ")."));
	        }
	        return pathToFile;
	    };
	    return BrowserFiles;
	}());
	exports.browserDownloadsRouter = function (url) {
	    if (!environment_1.env().getBool('IS_BROWSER')) {
	        return null;
	    }
	    else {
	        if (!Array.isArray(url) && url.startsWith(BrowserDownloads.URL_SCHEME)) {
	            return browserDownloads(url.slice(BrowserDownloads.URL_SCHEME.length));
	        }
	        else {
	            return null;
	        }
	    }
	};
	router_registry_1.IORouterRegistry.registerSaveRouter(exports.browserDownloadsRouter);
	/**
	 * Creates an IOHandler that triggers file downloads from the browser.
	 *
	 * The returned `IOHandler` instance can be used as model exporting methods such
	 * as `tf.Model.save` and supports only saving.
	 *
	 * ```js
	 * const model = tf.sequential();
	 * model.add(tf.layers.dense(
	 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
	 * const saveResult = await model.save('downloads://mymodel');
	 * // This will trigger downloading of two files:
	 * //   'mymodel.json' and 'mymodel.weights.bin'.
	 * console.log(saveResult);
	 * ```
	 *
	 * @param fileNamePrefix Prefix name of the files to be downloaded. For use with
	 *   `tf.Model`, `fileNamePrefix` should follow either of the following two
	 *   formats:
	 *   1. `null` or `undefined`, in which case the default file
	 *      names will be used:
	 *      - 'model.json' for the JSON file containing the model topology and
	 *        weights manifest.
	 *      - 'model.weights.bin' for the binary file containing the binary weight
	 *        values.
	 *   2. A single string or an Array of a single string, as the file name prefix.
	 *      For example, if `'foo'` is provided, the downloaded JSON
	 *      file and binary weights file will be named 'foo.json' and
	 *      'foo.weights.bin', respectively.
	 * @param config Additional configuration for triggering downloads.
	 * @returns An instance of `BrowserDownloads` `IOHandler`.
	 */
	/**
	 * @doc {
	 *   heading: 'Models',
	 *   subheading: 'Loading',
	 *   namespace: 'io',
	 *   ignoreCI: true
	 * }
	 */
	function browserDownloads(fileNamePrefix) {
	    if (fileNamePrefix === void 0) { fileNamePrefix = 'model'; }
	    return new BrowserDownloads(fileNamePrefix);
	}
	exports.browserDownloads = browserDownloads;
	/**
	 * Creates an IOHandler that loads model artifacts from user-selected files.
	 *
	 * This method can be used for loading from files such as user-selected files
	 * in the browser.
	 * When used in conjunction with `tf.loadLayersModel`, an instance of
	 * `tf.LayersModel` (Keras-style) can be constructed from the loaded artifacts.
	 *
	 * ```js
	 * // Note: This code snippet won't run properly without the actual file input
	 * //   elements in the HTML DOM.
	 *
	 * // Suppose there are two HTML file input (`<input type="file" ...>`)
	 * // elements.
	 * const uploadJSONInput = document.getElementById('upload-json');
	 * const uploadWeightsInput = document.getElementById('upload-weights');
	 * const model = await tf.loadLayersModel(tf.io.browserFiles(
	 *     [uploadJSONInput.files[0], uploadWeightsInput.files[0]]));
	 * ```
	 *
	 * @param files `File`s to load from. Currently, this function supports only
	 *   loading from files that contain Keras-style models (i.e., `tf.Model`s), for
	 *   which an `Array` of `File`s is expected (in that order):
	 *   - A JSON file containing the model topology and weight manifest.
	 *   - Optionally, One or more binary files containing the binary weights.
	 *     These files must have names that match the paths in the `weightsManifest`
	 *     contained by the aforementioned JSON file, or errors will be thrown
	 *     during loading. These weights files have the same format as the ones
	 *     generated by `tensorflowjs_converter` that comes with the `tensorflowjs`
	 *     Python PIP package. If no weights files are provided, only the model
	 *     topology will be loaded from the JSON file above.
	 * @returns An instance of `Files` `IOHandler`.
	 */
	/**
	 * @doc {
	 *   heading: 'Models',
	 *   subheading: 'Loading',
	 *   namespace: 'io',
	 *   ignoreCI: true
	 * }
	 */
	function browserFiles(files) {
	    return new BrowserFiles(files);
	}
	exports.browserFiles = browserFiles;
	//# sourceMappingURL=browser_files.js.map

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * IOHandler implementations based on HTTP requests in the web browser.
	 *
	 * Uses [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
	 */
	var environment_1 = __webpack_require__(28);
	var util_1 = __webpack_require__(10);
	var io_utils_1 = __webpack_require__(150);
	var router_registry_1 = __webpack_require__(151);
	var weights_loader_1 = __webpack_require__(485);
	var OCTET_STREAM_MIME_TYPE = 'application/octet-stream';
	var JSON_TYPE = 'application/json';
	var HTTPRequest = /** @class */ (function () {
	    function HTTPRequest(path, loadOptions) {
	        this.DEFAULT_METHOD = 'POST';
	        if (loadOptions == null) {
	            loadOptions = {};
	        }
	        this.weightPathPrefix = loadOptions.weightPathPrefix;
	        this.onProgress = loadOptions.onProgress;
	        if (loadOptions.fetchFunc != null) {
	            util_1.assert(typeof loadOptions.fetchFunc === 'function', function () { return 'Must pass a function that matches the signature of ' +
	                '`fetch` (see ' +
	                'https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API)'; });
	            this.fetch = loadOptions.fetchFunc;
	        }
	        else {
	            this.fetch = environment_1.env().platform.fetch;
	        }
	        util_1.assert(path != null && path.length > 0, function () { return 'URL path for http must not be null, undefined or ' +
	            'empty.'; });
	        if (Array.isArray(path)) {
	            util_1.assert(path.length === 2, function () { return 'URL paths for http must have a length of 2, ' +
	                ("(actual length is " + path.length + ")."); });
	        }
	        this.path = path;
	        if (loadOptions.requestInit != null &&
	            loadOptions.requestInit.body != null) {
	            throw new Error('requestInit is expected to have no pre-existing body, but has one.');
	        }
	        this.requestInit = loadOptions.requestInit || {};
	    }
	    HTTPRequest.prototype.save = function (modelArtifacts) {
	        return __awaiter(this, void 0, void 0, function () {
	            var init, weightsManifest, modelTopologyAndWeightManifest, response;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (modelArtifacts.modelTopology instanceof ArrayBuffer) {
	                            throw new Error('BrowserHTTPRequest.save() does not support saving model topology ' +
	                                'in binary formats yet.');
	                        }
	                        init = Object.assign({ method: this.DEFAULT_METHOD }, this.requestInit);
	                        init.body = new FormData();
	                        weightsManifest = [{
	                                paths: ['./model.weights.bin'],
	                                weights: modelArtifacts.weightSpecs,
	                            }];
	                        modelTopologyAndWeightManifest = {
	                            modelTopology: modelArtifacts.modelTopology,
	                            format: modelArtifacts.format,
	                            generatedBy: modelArtifacts.generatedBy,
	                            convertedBy: modelArtifacts.convertedBy,
	                            userDefinedMetadata: modelArtifacts.userDefinedMetadata,
	                            weightsManifest: weightsManifest
	                        };
	                        init.body.append('model.json', new Blob([JSON.stringify(modelTopologyAndWeightManifest)], { type: JSON_TYPE }), 'model.json');
	                        if (modelArtifacts.weightData != null) {
	                            init.body.append('model.weights.bin', new Blob([modelArtifacts.weightData], { type: OCTET_STREAM_MIME_TYPE }), 'model.weights.bin');
	                        }
	                        return [4 /*yield*/, this.fetch(this.path, init)];
	                    case 1:
	                        response = _a.sent();
	                        if (response.ok) {
	                            return [2 /*return*/, {
	                                    modelArtifactsInfo: io_utils_1.getModelArtifactsInfoForJSON(modelArtifacts),
	                                    responses: [response],
	                                }];
	                        }
	                        else {
	                            throw new Error("BrowserHTTPRequest.save() failed due to HTTP response status " +
	                                (response.status + "."));
	                        }
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Load model artifacts via HTTP request(s).
	     *
	     * See the documentation to `tf.io.http` for details on the saved
	     * artifacts.
	     *
	     * @returns The loaded model artifacts (if loading succeeds).
	     */
	    HTTPRequest.prototype.load = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var modelConfigRequest, modelConfig, e_1, message, modelTopology, weightsManifest, generatedBy, convertedBy, format, userDefinedMetadata, weightSpecs, weightData, results;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.fetch(this.path, this.requestInit)];
	                    case 1:
	                        modelConfigRequest = _a.sent();
	                        if (!modelConfigRequest.ok) {
	                            throw new Error("Request to " + this.path + " failed with status code " +
	                                (modelConfigRequest.status + ". Please verify this URL points to ") +
	                                "the model JSON of the model to load.");
	                        }
	                        _a.label = 2;
	                    case 2:
	                        _a.trys.push([2, 4, , 5]);
	                        return [4 /*yield*/, modelConfigRequest.json()];
	                    case 3:
	                        modelConfig = _a.sent();
	                        return [3 /*break*/, 5];
	                    case 4:
	                        e_1 = _a.sent();
	                        message = "Failed to parse model JSON of response from " + this.path + ".";
	                        // TODO(nsthorat): Remove this after some time when we're comfortable that
	                        // .pb files are mostly gone.
	                        if (this.path.endsWith('.pb')) {
	                            message += ' Your path contains a .pb file extension. ' +
	                                'Support for .pb models have been removed in TensorFlow.js 1.0 ' +
	                                'in favor of .json models. You can re-convert your Python ' +
	                                'TensorFlow model using the TensorFlow.js 1.0 conversion scripts ' +
	                                'or you can convert your.pb models with the \'pb2json\'' +
	                                'NPM script in the tensorflow/tfjs-converter repository.';
	                        }
	                        else {
	                            message += ' Please make sure the server is serving valid ' +
	                                'JSON for this request.';
	                        }
	                        throw new Error(message);
	                    case 5:
	                        modelTopology = modelConfig.modelTopology;
	                        weightsManifest = modelConfig.weightsManifest;
	                        generatedBy = modelConfig.generatedBy;
	                        convertedBy = modelConfig.convertedBy;
	                        format = modelConfig.format;
	                        userDefinedMetadata = modelConfig.userDefinedMetadata;
	                        // We do not allow both modelTopology and weightsManifest to be missing.
	                        if (modelTopology == null && weightsManifest == null) {
	                            throw new Error("The JSON from HTTP path " + this.path + " contains neither model " +
	                                "topology or manifest for weights.");
	                        }
	                        if (!(weightsManifest != null)) return [3 /*break*/, 7];
	                        return [4 /*yield*/, this.loadWeights(weightsManifest)];
	                    case 6:
	                        results = _a.sent();
	                        weightSpecs = results[0], weightData = results[1];
	                        _a.label = 7;
	                    case 7: return [2 /*return*/, {
	                            modelTopology: modelTopology,
	                            weightSpecs: weightSpecs,
	                            weightData: weightData,
	                            userDefinedMetadata: userDefinedMetadata,
	                            generatedBy: generatedBy,
	                            convertedBy: convertedBy,
	                            format: format
	                        }];
	                }
	            });
	        });
	    };
	    HTTPRequest.prototype.loadWeights = function (weightsManifest) {
	        return __awaiter(this, void 0, void 0, function () {
	            var weightPath, _a, prefix, suffix, pathPrefix, weightSpecs, _i, weightsManifest_1, entry, fetchURLs, buffers;
	            return __generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        weightPath = Array.isArray(this.path) ? this.path[1] : this.path;
	                        _a = parseUrl(weightPath), prefix = _a[0], suffix = _a[1];
	                        pathPrefix = this.weightPathPrefix || prefix;
	                        weightSpecs = [];
	                        for (_i = 0, weightsManifest_1 = weightsManifest; _i < weightsManifest_1.length; _i++) {
	                            entry = weightsManifest_1[_i];
	                            weightSpecs.push.apply(weightSpecs, entry.weights);
	                        }
	                        fetchURLs = [];
	                        weightsManifest.forEach(function (weightsGroup) {
	                            weightsGroup.paths.forEach(function (path) {
	                                fetchURLs.push(pathPrefix + path + suffix);
	                            });
	                        });
	                        return [4 /*yield*/, weights_loader_1.loadWeightsAsArrayBuffer(fetchURLs, {
	                                requestInit: this.requestInit,
	                                fetchFunc: this.fetch,
	                                onProgress: this.onProgress
	                            })];
	                    case 1:
	                        buffers = _b.sent();
	                        return [2 /*return*/, [weightSpecs, io_utils_1.concatenateArrayBuffers(buffers)]];
	                }
	            });
	        });
	    };
	    HTTPRequest.URL_SCHEME_REGEX = /^https?:\/\//;
	    return HTTPRequest;
	}());
	exports.HTTPRequest = HTTPRequest;
	/**
	 * Extract the prefix and suffix of the url, where the prefix is the path before
	 * the last file, and suffix is the search params after the last file.
	 * ```
	 * const url = 'http://tfhub.dev/model/1/tensorflowjs_model.pb?tfjs-format=file'
	 * [prefix, suffix] = parseUrl(url)
	 * // prefix = 'http://tfhub.dev/model/1/'
	 * // suffix = '?tfjs-format=file'
	 * ```
	 * @param url the model url to be parsed.
	 */
	function parseUrl(url) {
	    var lastSlash = url.lastIndexOf('/');
	    var lastSearchParam = url.lastIndexOf('?');
	    var prefix = url.substring(0, lastSlash);
	    var suffix = lastSearchParam > lastSlash ? url.substring(lastSearchParam) : '';
	    return [prefix + '/', suffix];
	}
	exports.parseUrl = parseUrl;
	function isHTTPScheme(url) {
	    return url.match(HTTPRequest.URL_SCHEME_REGEX) != null;
	}
	exports.isHTTPScheme = isHTTPScheme;
	exports.httpRouter = function (url, onProgress) {
	    if (typeof fetch === 'undefined') {
	        // `http` uses `fetch` or `node-fetch`, if one wants to use it in
	        // an environment that is not the browser or node they have to setup a
	        // global fetch polyfill.
	        return null;
	    }
	    else {
	        var isHTTP = true;
	        if (Array.isArray(url)) {
	            isHTTP = url.every(function (urlItem) { return isHTTPScheme(urlItem); });
	        }
	        else {
	            isHTTP = isHTTPScheme(url);
	        }
	        if (isHTTP) {
	            return http(url, { onProgress: onProgress });
	        }
	    }
	    return null;
	};
	router_registry_1.IORouterRegistry.registerSaveRouter(exports.httpRouter);
	router_registry_1.IORouterRegistry.registerLoadRouter(exports.httpRouter);
	/**
	 * Creates an IOHandler subtype that sends model artifacts to HTTP server.
	 *
	 * An HTTP request of the `multipart/form-data` mime type will be sent to the
	 * `path` URL. The form data includes artifacts that represent the topology
	 * and/or weights of the model. In the case of Keras-style `tf.Model`, two
	 * blobs (files) exist in form-data:
	 *   - A JSON file consisting of `modelTopology` and `weightsManifest`.
	 *   - A binary weights file consisting of the concatenated weight values.
	 * These files are in the same format as the one generated by
	 * [tfjs_converter](https://js.tensorflow.org/tutorials/import-keras.html).
	 *
	 * The following code snippet exemplifies the client-side code that uses this
	 * function:
	 *
	 * ```js
	 * const model = tf.sequential();
	 * model.add(
	 *     tf.layers.dense({units: 1, inputShape: [100], activation: 'sigmoid'}));
	 *
	 * const saveResult = await model.save(tf.io.http(
	 *     'http://model-server:5000/upload', {requestInit: {method: 'PUT'}}));
	 * console.log(saveResult);
	 * ```
	 *
	 * If the default `POST` method is to be used, without any custom parameters
	 * such as headers, you can simply pass an HTTP or HTTPS URL to `model.save`:
	 *
	 * ```js
	 * const saveResult = await model.save('http://model-server:5000/upload');
	 * ```
	 *
	 * The following GitHub Gist
	 * https://gist.github.com/dsmilkov/1b6046fd6132d7408d5257b0976f7864
	 * implements a server based on [flask](https://github.com/pallets/flask) that
	 * can receive the request. Upon receiving the model artifacts via the requst,
	 * this particular server reconsistutes instances of [Keras
	 * Models](https://keras.io/models/model/) in memory.
	 *
	 *
	 * @param path A URL path to the model.
	 *   Can be an absolute HTTP path (e.g.,
	 *   'http://localhost:8000/model-upload)') or a relative path (e.g.,
	 *   './model-upload').
	 * @param requestInit Request configurations to be used when sending
	 *    HTTP request to server using `fetch`. It can contain fields such as
	 *    `method`, `credentials`, `headers`, `mode`, etc. See
	 *    https://developer.mozilla.org/en-US/docs/Web/API/Request/Request
	 *    for more information. `requestInit` must not have a body, because the
	 * body will be set by TensorFlow.js. File blobs representing the model
	 * topology (filename: 'model.json') and the weights of the model (filename:
	 * 'model.weights.bin') will be appended to the body. If `requestInit` has a
	 * `body`, an Error will be thrown.
	 * @param loadOptions Optional configuration for the loading. It includes the
	 *   following fields:
	 *   - weightPathPrefix Optional, this specifies the path prefix for weight
	 *     files, by default this is calculated from the path param.
	 *   - fetchFunc Optional, custom `fetch` function. E.g., in Node.js,
	 *     the `fetch` from node-fetch can be used here.
	 *   - onProgress Optional, progress callback function, fired periodically
	 *     before the load is completed.
	 * @returns An instance of `IOHandler`.
	 */
	/**
	 * @doc {
	 *   heading: 'Models',
	 *   subheading: 'Loading',
	 *   namespace: 'io',
	 *   ignoreCI: true
	 * }
	 */
	function http(path, loadOptions) {
	    return new HTTPRequest(path, loadOptions);
	}
	exports.http = http;
	/**
	 * Deprecated. Use `tf.io.http`.
	 * @param path
	 * @param loadOptions
	 */
	function browserHTTPRequest(path, loadOptions) {
	    return http(path, loadOptions);
	}
	exports.browserHTTPRequest = browserHTTPRequest;
	//# sourceMappingURL=http.js.map

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var environment_1 = __webpack_require__(28);
	var io_utils_1 = __webpack_require__(150);
	var model_management_1 = __webpack_require__(312);
	var router_registry_1 = __webpack_require__(151);
	var DATABASE_NAME = 'tensorflowjs';
	var DATABASE_VERSION = 1;
	// Model data and ModelArtifactsInfo (metadata) are stored in two separate
	// stores for efficient access of the list of stored models and their metadata.
	// 1. The object store for model data: topology, weights and weight manifests.
	var MODEL_STORE_NAME = 'models_store';
	// 2. The object store for ModelArtifactsInfo, including meta-information such
	//    as the type of topology (JSON vs binary), byte size of the topology, byte
	//    size of the weights, etc.
	var INFO_STORE_NAME = 'model_info_store';
	/**
	 * Delete the entire database for tensorflow.js, including the models store.
	 */
	function deleteDatabase() {
	    return __awaiter(this, void 0, void 0, function () {
	        var idbFactory;
	        return __generator(this, function (_a) {
	            idbFactory = getIndexedDBFactory();
	            return [2 /*return*/, new Promise(function (resolve, reject) {
	                    var deleteRequest = idbFactory.deleteDatabase(DATABASE_NAME);
	                    deleteRequest.onsuccess = function () { return resolve(); };
	                    deleteRequest.onerror = function (error) { return reject(error); };
	                })];
	        });
	    });
	}
	exports.deleteDatabase = deleteDatabase;
	function getIndexedDBFactory() {
	    if (!environment_1.env().getBool('IS_BROWSER')) {
	        // TODO(cais): Add more info about what IOHandler subtypes are available.
	        //   Maybe point to a doc page on the web and/or automatically determine
	        //   the available IOHandlers and print them in the error message.
	        throw new Error('Failed to obtain IndexedDB factory because the current environment' +
	            'is not a web browser.');
	    }
	    // tslint:disable-next-line:no-any
	    var theWindow = window || self;
	    var factory = theWindow.indexedDB || theWindow.mozIndexedDB ||
	        theWindow.webkitIndexedDB || theWindow.msIndexedDB ||
	        theWindow.shimIndexedDB;
	    if (factory == null) {
	        throw new Error('The current browser does not appear to support IndexedDB.');
	    }
	    return factory;
	}
	function setUpDatabase(openRequest) {
	    var db = openRequest.result;
	    db.createObjectStore(MODEL_STORE_NAME, { keyPath: 'modelPath' });
	    db.createObjectStore(INFO_STORE_NAME, { keyPath: 'modelPath' });
	}
	/**
	 * IOHandler subclass: Browser IndexedDB.
	 *
	 * See the doc string of `browserIndexedDB` for more details.
	 */
	var BrowserIndexedDB = /** @class */ (function () {
	    function BrowserIndexedDB(modelPath) {
	        this.indexedDB = getIndexedDBFactory();
	        if (modelPath == null || !modelPath) {
	            throw new Error('For IndexedDB, modelPath must not be null, undefined or empty.');
	        }
	        this.modelPath = modelPath;
	    }
	    BrowserIndexedDB.prototype.save = function (modelArtifacts) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                // TODO(cais): Support saving GraphDef models.
	                if (modelArtifacts.modelTopology instanceof ArrayBuffer) {
	                    throw new Error('BrowserLocalStorage.save() does not support saving model topology ' +
	                        'in binary formats yet.');
	                }
	                return [2 /*return*/, this.databaseAction(this.modelPath, modelArtifacts)];
	            });
	        });
	    };
	    BrowserIndexedDB.prototype.load = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                return [2 /*return*/, this.databaseAction(this.modelPath)];
	            });
	        });
	    };
	    /**
	     * Perform database action to put model artifacts into or read model artifacts
	     * from IndexedDB object store.
	     *
	     * Whether the action is put or get depends on whether `modelArtifacts` is
	     * specified. If it is specified, the action will be put; otherwise the action
	     * will be get.
	     *
	     * @param modelPath A unique string path for the model.
	     * @param modelArtifacts If specified, it will be the model artifacts to be
	     *   stored in IndexedDB.
	     * @returns A `Promise` of `SaveResult`, if the action is put, or a `Promise`
	     *   of `ModelArtifacts`, if the action is get.
	     */
	    BrowserIndexedDB.prototype.databaseAction = function (modelPath, modelArtifacts) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            var openRequest = _this.indexedDB.open(DATABASE_NAME, DATABASE_VERSION);
	            openRequest.onupgradeneeded = function () { return setUpDatabase(openRequest); };
	            openRequest.onsuccess = function () {
	                var db = openRequest.result;
	                if (modelArtifacts == null) {
	                    // Read model out from object store.
	                    var modelTx = db.transaction(MODEL_STORE_NAME, 'readonly');
	                    var modelStore = modelTx.objectStore(MODEL_STORE_NAME);
	                    var getRequest_1 = modelStore.get(_this.modelPath);
	                    getRequest_1.onsuccess = function () {
	                        if (getRequest_1.result == null) {
	                            db.close();
	                            return reject(new Error("Cannot find model with path '" + _this.modelPath + "' " +
	                                "in IndexedDB."));
	                        }
	                        else {
	                            resolve(getRequest_1.result.modelArtifacts);
	                        }
	                    };
	                    getRequest_1.onerror = function (error) {
	                        db.close();
	                        return reject(getRequest_1.error);
	                    };
	                    modelTx.oncomplete = function () { return db.close(); };
	                }
	                else {
	                    // Put model into object store.
	                    var modelArtifactsInfo_1 = io_utils_1.getModelArtifactsInfoForJSON(modelArtifacts);
	                    // First, put ModelArtifactsInfo into info store.
	                    var infoTx_1 = db.transaction(INFO_STORE_NAME, 'readwrite');
	                    var infoStore_1 = infoTx_1.objectStore(INFO_STORE_NAME);
	                    var putInfoRequest_1 = infoStore_1.put({ modelPath: _this.modelPath, modelArtifactsInfo: modelArtifactsInfo_1 });
	                    var modelTx_1;
	                    putInfoRequest_1.onsuccess = function () {
	                        // Second, put model data into model store.
	                        modelTx_1 = db.transaction(MODEL_STORE_NAME, 'readwrite');
	                        var modelStore = modelTx_1.objectStore(MODEL_STORE_NAME);
	                        var putModelRequest = modelStore.put({
	                            modelPath: _this.modelPath,
	                            modelArtifacts: modelArtifacts,
	                            modelArtifactsInfo: modelArtifactsInfo_1
	                        });
	                        putModelRequest.onsuccess = function () { return resolve({ modelArtifactsInfo: modelArtifactsInfo_1 }); };
	                        putModelRequest.onerror = function (error) {
	                            // If the put-model request fails, roll back the info entry as
	                            // well.
	                            infoStore_1 = infoTx_1.objectStore(INFO_STORE_NAME);
	                            var deleteInfoRequest = infoStore_1.delete(_this.modelPath);
	                            deleteInfoRequest.onsuccess = function () {
	                                db.close();
	                                return reject(putModelRequest.error);
	                            };
	                            deleteInfoRequest.onerror = function (error) {
	                                db.close();
	                                return reject(putModelRequest.error);
	                            };
	                        };
	                    };
	                    putInfoRequest_1.onerror = function (error) {
	                        db.close();
	                        return reject(putInfoRequest_1.error);
	                    };
	                    infoTx_1.oncomplete = function () {
	                        if (modelTx_1 == null) {
	                            db.close();
	                        }
	                        else {
	                            modelTx_1.oncomplete = function () { return db.close(); };
	                        }
	                    };
	                }
	            };
	            openRequest.onerror = function (error) { return reject(openRequest.error); };
	        });
	    };
	    BrowserIndexedDB.URL_SCHEME = 'indexeddb://';
	    return BrowserIndexedDB;
	}());
	exports.BrowserIndexedDB = BrowserIndexedDB;
	exports.indexedDBRouter = function (url) {
	    if (!environment_1.env().getBool('IS_BROWSER')) {
	        return null;
	    }
	    else {
	        if (!Array.isArray(url) && url.startsWith(BrowserIndexedDB.URL_SCHEME)) {
	            return browserIndexedDB(url.slice(BrowserIndexedDB.URL_SCHEME.length));
	        }
	        else {
	            return null;
	        }
	    }
	};
	router_registry_1.IORouterRegistry.registerSaveRouter(exports.indexedDBRouter);
	router_registry_1.IORouterRegistry.registerLoadRouter(exports.indexedDBRouter);
	/**
	 * Creates a browser IndexedDB IOHandler for saving and loading models.
	 *
	 * ```js
	 * const model = tf.sequential();
	 * model.add(
	 *     tf.layers.dense({units: 1, inputShape: [100], activation: 'sigmoid'}));
	 *
	 * const saveResult = await model.save('indexeddb://MyModel'));
	 * console.log(saveResult);
	 * ```
	 *
	 * @param modelPath A unique identifier for the model to be saved. Must be a
	 *   non-empty string.
	 * @returns An instance of `BrowserIndexedDB` (sublcass of `IOHandler`),
	 *   which can be used with, e.g., `tf.Model.save`.
	 */
	function browserIndexedDB(modelPath) {
	    return new BrowserIndexedDB(modelPath);
	}
	exports.browserIndexedDB = browserIndexedDB;
	function maybeStripScheme(key) {
	    return key.startsWith(BrowserIndexedDB.URL_SCHEME) ?
	        key.slice(BrowserIndexedDB.URL_SCHEME.length) :
	        key;
	}
	var BrowserIndexedDBManager = /** @class */ (function () {
	    function BrowserIndexedDBManager() {
	        this.indexedDB = getIndexedDBFactory();
	    }
	    BrowserIndexedDBManager.prototype.listModels = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            return __generator(this, function (_a) {
	                return [2 /*return*/, new Promise(function (resolve, reject) {
	                        var openRequest = _this.indexedDB.open(DATABASE_NAME, DATABASE_VERSION);
	                        openRequest.onupgradeneeded = function () { return setUpDatabase(openRequest); };
	                        openRequest.onsuccess = function () {
	                            var db = openRequest.result;
	                            var tx = db.transaction(INFO_STORE_NAME, 'readonly');
	                            var store = tx.objectStore(INFO_STORE_NAME);
	                            // tslint:disable:max-line-length
	                            // Need to cast `store` as `any` here because TypeScript's DOM
	                            // library does not have the `getAll()` method even though the
	                            // method is supported in the latest version of most mainstream
	                            // browsers:
	                            // https://developer.mozilla.org/en-US/docs/Web/API/IDBObjectStore/getAll
	                            // tslint:enable:max-line-length
	                            // tslint:disable-next-line:no-any
	                            var getAllInfoRequest = store.getAll();
	                            getAllInfoRequest.onsuccess = function () {
	                                var out = {};
	                                for (var _i = 0, _a = getAllInfoRequest.result; _i < _a.length; _i++) {
	                                    var item = _a[_i];
	                                    out[item.modelPath] = item.modelArtifactsInfo;
	                                }
	                                resolve(out);
	                            };
	                            getAllInfoRequest.onerror = function (error) {
	                                db.close();
	                                return reject(getAllInfoRequest.error);
	                            };
	                            tx.oncomplete = function () { return db.close(); };
	                        };
	                        openRequest.onerror = function (error) { return reject(openRequest.error); };
	                    })];
	            });
	        });
	    };
	    BrowserIndexedDBManager.prototype.removeModel = function (path) {
	        return __awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            return __generator(this, function (_a) {
	                path = maybeStripScheme(path);
	                return [2 /*return*/, new Promise(function (resolve, reject) {
	                        var openRequest = _this.indexedDB.open(DATABASE_NAME, DATABASE_VERSION);
	                        openRequest.onupgradeneeded = function () { return setUpDatabase(openRequest); };
	                        openRequest.onsuccess = function () {
	                            var db = openRequest.result;
	                            var infoTx = db.transaction(INFO_STORE_NAME, 'readwrite');
	                            var infoStore = infoTx.objectStore(INFO_STORE_NAME);
	                            var getInfoRequest = infoStore.get(path);
	                            var modelTx;
	                            getInfoRequest.onsuccess = function () {
	                                if (getInfoRequest.result == null) {
	                                    db.close();
	                                    return reject(new Error("Cannot find model with path '" + path + "' " +
	                                        "in IndexedDB."));
	                                }
	                                else {
	                                    // First, delete the entry in the info store.
	                                    var deleteInfoRequest = infoStore.delete(path);
	                                    var deleteModelData_1 = function () {
	                                        // Second, delete the entry in the model store.
	                                        modelTx = db.transaction(MODEL_STORE_NAME, 'readwrite');
	                                        var modelStore = modelTx.objectStore(MODEL_STORE_NAME);
	                                        var deleteModelRequest = modelStore.delete(path);
	                                        deleteModelRequest.onsuccess = function () {
	                                            return resolve(getInfoRequest.result.modelArtifactsInfo);
	                                        };
	                                        deleteModelRequest.onerror = function (error) {
	                                            return reject(getInfoRequest.error);
	                                        };
	                                    };
	                                    // Proceed with deleting model data regardless of whether deletion
	                                    // of info data succeeds or not.
	                                    deleteInfoRequest.onsuccess = deleteModelData_1;
	                                    deleteInfoRequest.onerror = function (error) {
	                                        deleteModelData_1();
	                                        db.close();
	                                        return reject(getInfoRequest.error);
	                                    };
	                                }
	                            };
	                            getInfoRequest.onerror = function (error) {
	                                db.close();
	                                return reject(getInfoRequest.error);
	                            };
	                            infoTx.oncomplete = function () {
	                                if (modelTx == null) {
	                                    db.close();
	                                }
	                                else {
	                                    modelTx.oncomplete = function () { return db.close(); };
	                                }
	                            };
	                        };
	                        openRequest.onerror = function (error) { return reject(openRequest.error); };
	                    })];
	            });
	        });
	    };
	    return BrowserIndexedDBManager;
	}());
	exports.BrowserIndexedDBManager = BrowserIndexedDBManager;
	if (environment_1.env().getBool('IS_BROWSER')) {
	    // Wrap the construction and registration, to guard against browsers that
	    // don't support Local Storage.
	    try {
	        model_management_1.ModelStoreManagerRegistry.registerManager(BrowserIndexedDB.URL_SCHEME, new BrowserIndexedDBManager());
	    }
	    catch (err) {
	    }
	}
	//# sourceMappingURL=indexed_db.js.map

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// Importing local_storage and indexed_db is necessary for the routers to be
	// registered.
	__webpack_require__(1041);
	__webpack_require__(1043);
	var browser_files_1 = __webpack_require__(1039);
	exports.browserFiles = browser_files_1.browserFiles;
	var http_1 = __webpack_require__(1040);
	exports.browserHTTPRequest = http_1.browserHTTPRequest;
	exports.http = http_1.http;
	exports.isHTTPScheme = http_1.isHTTPScheme;
	var io_utils_1 = __webpack_require__(150);
	exports.concatenateArrayBuffers = io_utils_1.concatenateArrayBuffers;
	exports.decodeWeights = io_utils_1.decodeWeights;
	exports.encodeWeights = io_utils_1.encodeWeights;
	exports.getModelArtifactsInfoForJSON = io_utils_1.getModelArtifactsInfoForJSON;
	var passthrough_1 = __webpack_require__(1044);
	exports.fromMemory = passthrough_1.fromMemory;
	exports.withSaveHandler = passthrough_1.withSaveHandler;
	var router_registry_1 = __webpack_require__(151);
	exports.getLoadHandlers = router_registry_1.getLoadHandlers;
	exports.getSaveHandlers = router_registry_1.getSaveHandlers;
	exports.registerLoadRouter = router_registry_1.registerLoadRouter;
	exports.registerSaveRouter = router_registry_1.registerSaveRouter;
	var weights_loader_1 = __webpack_require__(485);
	exports.loadWeights = weights_loader_1.loadWeights;
	exports.weightsLoaderFactory = weights_loader_1.weightsLoaderFactory;
	var model_management_1 = __webpack_require__(312);
	exports.copyModel = model_management_1.copyModel;
	exports.listModels = model_management_1.listModels;
	exports.moveModel = model_management_1.moveModel;
	exports.removeModel = model_management_1.removeModel;
	//# sourceMappingURL=io.js.map

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var environment_1 = __webpack_require__(28);
	var util_1 = __webpack_require__(10);
	var io_utils_1 = __webpack_require__(150);
	var model_management_1 = __webpack_require__(312);
	var router_registry_1 = __webpack_require__(151);
	var PATH_SEPARATOR = '/';
	var PATH_PREFIX = 'tensorflowjs_models';
	var INFO_SUFFIX = 'info';
	var MODEL_TOPOLOGY_SUFFIX = 'model_topology';
	var WEIGHT_SPECS_SUFFIX = 'weight_specs';
	var WEIGHT_DATA_SUFFIX = 'weight_data';
	var MODEL_METADATA_SUFFIX = 'model_metadata';
	/**
	 * Purge all tensorflow.js-saved model artifacts from local storage.
	 *
	 * @returns Paths of the models purged.
	 */
	function purgeLocalStorageArtifacts() {
	    if (!environment_1.env().getBool('IS_BROWSER') ||
	        typeof window === 'undefined' ||
	        typeof window.localStorage === 'undefined') {
	        throw new Error('purgeLocalStorageModels() cannot proceed because local storage is ' +
	            'unavailable in the current environment.');
	    }
	    var LS = window.localStorage;
	    var purgedModelPaths = [];
	    for (var i = 0; i < LS.length; ++i) {
	        var key = LS.key(i);
	        var prefix = PATH_PREFIX + PATH_SEPARATOR;
	        if (key.startsWith(prefix) && key.length > prefix.length) {
	            LS.removeItem(key);
	            var modelName = getModelPathFromKey(key);
	            if (purgedModelPaths.indexOf(modelName) === -1) {
	                purgedModelPaths.push(modelName);
	            }
	        }
	    }
	    return purgedModelPaths;
	}
	exports.purgeLocalStorageArtifacts = purgeLocalStorageArtifacts;
	function getModelKeys(path) {
	    return {
	        info: [PATH_PREFIX, path, INFO_SUFFIX].join(PATH_SEPARATOR),
	        topology: [PATH_PREFIX, path, MODEL_TOPOLOGY_SUFFIX].join(PATH_SEPARATOR),
	        weightSpecs: [PATH_PREFIX, path, WEIGHT_SPECS_SUFFIX].join(PATH_SEPARATOR),
	        weightData: [PATH_PREFIX, path, WEIGHT_DATA_SUFFIX].join(PATH_SEPARATOR),
	        modelMetadata: [PATH_PREFIX, path, MODEL_METADATA_SUFFIX].join(PATH_SEPARATOR)
	    };
	}
	/**
	 * Get model path from a local-storage key.
	 *
	 * E.g., 'tensorflowjs_models/my/model/1/info' --> 'my/model/1'
	 *
	 * @param key
	 */
	function getModelPathFromKey(key) {
	    var items = key.split(PATH_SEPARATOR);
	    if (items.length < 3) {
	        throw new Error("Invalid key format: " + key);
	    }
	    return items.slice(1, items.length - 1).join(PATH_SEPARATOR);
	}
	function maybeStripScheme(key) {
	    return key.startsWith(BrowserLocalStorage.URL_SCHEME) ?
	        key.slice(BrowserLocalStorage.URL_SCHEME.length) :
	        key;
	}
	/**
	 * IOHandler subclass: Browser Local Storage.
	 *
	 * See the doc string to `browserLocalStorage` for more details.
	 */
	var BrowserLocalStorage = /** @class */ (function () {
	    function BrowserLocalStorage(modelPath) {
	        if (!environment_1.env().getBool('IS_BROWSER') ||
	            typeof window === 'undefined' ||
	            typeof window.localStorage === 'undefined') {
	            // TODO(cais): Add more info about what IOHandler subtypes are
	            // available.
	            //   Maybe point to a doc page on the web and/or automatically determine
	            //   the available IOHandlers and print them in the error message.
	            throw new Error('The current environment does not support local storage.');
	        }
	        this.LS = window.localStorage;
	        if (modelPath == null || !modelPath) {
	            throw new Error('For local storage, modelPath must not be null, undefined or empty.');
	        }
	        this.modelPath = modelPath;
	        this.keys = getModelKeys(this.modelPath);
	    }
	    /**
	     * Save model artifacts to browser local storage.
	     *
	     * See the documentation to `browserLocalStorage` for details on the saved
	     * artifacts.
	     *
	     * @param modelArtifacts The model artifacts to be stored.
	     * @returns An instance of SaveResult.
	     */
	    BrowserLocalStorage.prototype.save = function (modelArtifacts) {
	        return __awaiter(this, void 0, void 0, function () {
	            var topology, weightSpecs, modelArtifactsInfo;
	            return __generator(this, function (_a) {
	                if (modelArtifacts.modelTopology instanceof ArrayBuffer) {
	                    throw new Error('BrowserLocalStorage.save() does not support saving model topology ' +
	                        'in binary formats yet.');
	                }
	                else {
	                    topology = JSON.stringify(modelArtifacts.modelTopology);
	                    weightSpecs = JSON.stringify(modelArtifacts.weightSpecs);
	                    modelArtifactsInfo = io_utils_1.getModelArtifactsInfoForJSON(modelArtifacts);
	                    try {
	                        this.LS.setItem(this.keys.info, JSON.stringify(modelArtifactsInfo));
	                        this.LS.setItem(this.keys.topology, topology);
	                        this.LS.setItem(this.keys.weightSpecs, weightSpecs);
	                        this.LS.setItem(this.keys.weightData, io_utils_1.arrayBufferToBase64String(modelArtifacts.weightData));
	                        this.LS.setItem(this.keys.modelMetadata, JSON.stringify({
	                            format: modelArtifacts.format,
	                            generatedBy: modelArtifacts.generatedBy,
	                            convertedBy: modelArtifacts.convertedBy,
	                            userDefinedMetadata: modelArtifacts.userDefinedMetadata
	                        }));
	                        return [2 /*return*/, { modelArtifactsInfo: modelArtifactsInfo }];
	                    }
	                    catch (err) {
	                        // If saving failed, clean up all items saved so far.
	                        this.LS.removeItem(this.keys.info);
	                        this.LS.removeItem(this.keys.topology);
	                        this.LS.removeItem(this.keys.weightSpecs);
	                        this.LS.removeItem(this.keys.weightData);
	                        this.LS.removeItem(this.keys.modelMetadata);
	                        throw new Error("Failed to save model '" + this.modelPath + "' to local storage: " +
	                            "size quota being exceeded is a possible cause of this failure: " +
	                            ("modelTopologyBytes=" + modelArtifactsInfo.modelTopologyBytes + ", ") +
	                            ("weightSpecsBytes=" + modelArtifactsInfo.weightSpecsBytes + ", ") +
	                            ("weightDataBytes=" + modelArtifactsInfo.weightDataBytes + "."));
	                    }
	                }
	                return [2 /*return*/];
	            });
	        });
	    };
	    /**
	     * Load a model from local storage.
	     *
	     * See the documentation to `browserLocalStorage` for details on the saved
	     * artifacts.
	     *
	     * @returns The loaded model (if loading succeeds).
	     */
	    BrowserLocalStorage.prototype.load = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var info, out, topology, weightSpecs, metadataString, metadata, weightDataBase64;
	            return __generator(this, function (_a) {
	                info = JSON.parse(this.LS.getItem(this.keys.info));
	                if (info == null) {
	                    throw new Error("In local storage, there is no model with name '" + this.modelPath + "'");
	                }
	                if (info.modelTopologyType !== 'JSON') {
	                    throw new Error('BrowserLocalStorage does not support loading non-JSON model ' +
	                        'topology yet.');
	                }
	                out = {};
	                topology = JSON.parse(this.LS.getItem(this.keys.topology));
	                if (topology == null) {
	                    throw new Error("In local storage, the topology of model '" + this.modelPath + "' " +
	                        "is missing.");
	                }
	                out.modelTopology = topology;
	                weightSpecs = JSON.parse(this.LS.getItem(this.keys.weightSpecs));
	                if (weightSpecs == null) {
	                    throw new Error("In local storage, the weight specs of model '" + this.modelPath + "' " +
	                        "are missing.");
	                }
	                out.weightSpecs = weightSpecs;
	                metadataString = this.LS.getItem(this.keys.modelMetadata);
	                if (metadataString != null) {
	                    metadata = JSON.parse(metadataString);
	                    out.format = metadata['format'];
	                    out.generatedBy = metadata['generatedBy'];
	                    out.convertedBy = metadata['convertedBy'];
	                    out.userDefinedMetadata = metadata['userDefinedMetadata'];
	                }
	                weightDataBase64 = this.LS.getItem(this.keys.weightData);
	                if (weightDataBase64 == null) {
	                    throw new Error("In local storage, the binary weight values of model " +
	                        ("'" + this.modelPath + "' are missing."));
	                }
	                out.weightData = io_utils_1.base64StringToArrayBuffer(weightDataBase64);
	                return [2 /*return*/, out];
	            });
	        });
	    };
	    BrowserLocalStorage.URL_SCHEME = 'localstorage://';
	    return BrowserLocalStorage;
	}());
	exports.BrowserLocalStorage = BrowserLocalStorage;
	exports.localStorageRouter = function (url) {
	    if (!environment_1.env().getBool('IS_BROWSER')) {
	        return null;
	    }
	    else {
	        if (!Array.isArray(url) && url.startsWith(BrowserLocalStorage.URL_SCHEME)) {
	            return browserLocalStorage(url.slice(BrowserLocalStorage.URL_SCHEME.length));
	        }
	        else {
	            return null;
	        }
	    }
	};
	router_registry_1.IORouterRegistry.registerSaveRouter(exports.localStorageRouter);
	router_registry_1.IORouterRegistry.registerLoadRouter(exports.localStorageRouter);
	/**
	 * Factory function for local storage IOHandler.
	 *
	 * This `IOHandler` supports both `save` and `load`.
	 *
	 * For each model's saved artifacts, four items are saved to local storage.
	 *   - `${PATH_SEPARATOR}/${modelPath}/info`: Contains meta-info about the
	 *     model, such as date saved, type of the topology, size in bytes, etc.
	 *   - `${PATH_SEPARATOR}/${modelPath}/topology`: Model topology. For Keras-
	 *     style models, this is a stringized JSON.
	 *   - `${PATH_SEPARATOR}/${modelPath}/weight_specs`: Weight specs of the
	 *     model, can be used to decode the saved binary weight values (see
	 *     item below).
	 *   - `${PATH_SEPARATOR}/${modelPath}/weight_data`: Concatenated binary
	 *     weight values, stored as a base64-encoded string.
	 *
	 * Saving may throw an `Error` if the total size of the artifacts exceed the
	 * browser-specific quota.
	 *
	 * @param modelPath A unique identifier for the model to be saved. Must be a
	 *   non-empty string.
	 * @returns An instance of `IOHandler`, which can be used with, e.g.,
	 *   `tf.Model.save`.
	 */
	function browserLocalStorage(modelPath) {
	    return new BrowserLocalStorage(modelPath);
	}
	exports.browserLocalStorage = browserLocalStorage;
	var BrowserLocalStorageManager = /** @class */ (function () {
	    function BrowserLocalStorageManager() {
	        util_1.assert(environment_1.env().getBool('IS_BROWSER'), function () { return 'Current environment is not a web browser'; });
	        util_1.assert(typeof window === 'undefined' ||
	            typeof window.localStorage !== 'undefined', function () { return 'Current browser does not appear to support localStorage'; });
	        this.LS = window.localStorage;
	    }
	    BrowserLocalStorageManager.prototype.listModels = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var out, prefix, suffix, i, key, modelPath;
	            return __generator(this, function (_a) {
	                out = {};
	                prefix = PATH_PREFIX + PATH_SEPARATOR;
	                suffix = PATH_SEPARATOR + INFO_SUFFIX;
	                for (i = 0; i < this.LS.length; ++i) {
	                    key = this.LS.key(i);
	                    if (key.startsWith(prefix) && key.endsWith(suffix)) {
	                        modelPath = getModelPathFromKey(key);
	                        out[modelPath] = JSON.parse(this.LS.getItem(key));
	                    }
	                }
	                return [2 /*return*/, out];
	            });
	        });
	    };
	    BrowserLocalStorageManager.prototype.removeModel = function (path) {
	        return __awaiter(this, void 0, void 0, function () {
	            var keys, info;
	            return __generator(this, function (_a) {
	                path = maybeStripScheme(path);
	                keys = getModelKeys(path);
	                if (this.LS.getItem(keys.info) == null) {
	                    throw new Error("Cannot find model at path '" + path + "'");
	                }
	                info = JSON.parse(this.LS.getItem(keys.info));
	                this.LS.removeItem(keys.info);
	                this.LS.removeItem(keys.topology);
	                this.LS.removeItem(keys.weightSpecs);
	                this.LS.removeItem(keys.weightData);
	                return [2 /*return*/, info];
	            });
	        });
	    };
	    return BrowserLocalStorageManager;
	}());
	exports.BrowserLocalStorageManager = BrowserLocalStorageManager;
	if (environment_1.env().getBool('IS_BROWSER')) {
	    // Wrap the construction and registration, to guard against browsers that
	    // don't support Local Storage.
	    try {
	        model_management_1.ModelStoreManagerRegistry.registerManager(BrowserLocalStorage.URL_SCHEME, new BrowserLocalStorageManager());
	    }
	    catch (err) {
	    }
	}
	//# sourceMappingURL=local_storage.js.map

/***/ },
/* 1044 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var PassthroughLoader = /** @class */ (function () {
	    function PassthroughLoader(modelArtifacts) {
	        this.modelArtifacts = modelArtifacts;
	    }
	    PassthroughLoader.prototype.load = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                return [2 /*return*/, this.modelArtifacts];
	            });
	        });
	    };
	    return PassthroughLoader;
	}());
	var PassthroughSaver = /** @class */ (function () {
	    function PassthroughSaver(saveHandler) {
	        this.saveHandler = saveHandler;
	    }
	    PassthroughSaver.prototype.save = function (modelArtifacts) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                return [2 /*return*/, this.saveHandler(modelArtifacts)];
	            });
	        });
	    };
	    return PassthroughSaver;
	}());
	/**
	 * Creates an IOHandler that loads model artifacts from memory.
	 *
	 * When used in conjunction with `tf.loadLayersModel`, an instance of
	 * `tf.LayersModel` (Keras-style) can be constructed from the loaded artifacts.
	 *
	 * ```js
	 * const model = await tf.loadLayersModel(tf.io.fromMemory(
	 *     modelTopology, weightSpecs, weightData));
	 * ```
	 *
	 * @param modelArtifacts a object containing model topology (i.e., parsed from
	 *   the JSON format).
	 * @param weightSpecs An array of `WeightsManifestEntry` objects describing the
	 *   names, shapes, types, and quantization of the weight data.
	 * @param weightData A single `ArrayBuffer` containing the weight data,
	 *   concatenated in the order described by the weightSpecs.
	 * @param trainingConfig Model training configuration. Optional.
	 *
	 * @returns A passthrough `IOHandler` that simply loads the provided data.
	 */
	function fromMemory(modelArtifacts, weightSpecs, weightData, trainingConfig) {
	    if (arguments.length === 1) {
	        var isModelArtifacts = modelArtifacts.modelTopology != null ||
	            modelArtifacts.weightSpecs != null;
	        if (isModelArtifacts) {
	            return new PassthroughLoader(modelArtifacts);
	        }
	        else {
	            // Legacy support: with only modelTopology.
	            // TODO(cais): Remove this deprecated API.
	            console.warn('Please call tf.io.fromMemory() with only one argument. ' +
	                'The argument should be of type ModelArtifacts. ' +
	                'The multi-argument signature of tf.io.fromMemory() has been ' +
	                'deprecated and will be removed in a future release.');
	            return new PassthroughLoader({ modelTopology: modelArtifacts });
	        }
	    }
	    else {
	        // Legacy support.
	        // TODO(cais): Remove this deprecated API.
	        console.warn('Please call tf.io.fromMemory() with only one argument. ' +
	            'The argument should be of type ModelArtifacts. ' +
	            'The multi-argument signature of tf.io.fromMemory() has been ' +
	            'deprecated and will be removed in a future release.');
	        return new PassthroughLoader({
	            modelTopology: modelArtifacts,
	            weightSpecs: weightSpecs,
	            weightData: weightData,
	            trainingConfig: trainingConfig
	        });
	    }
	}
	exports.fromMemory = fromMemory;
	/**
	 * Creates an IOHandler that passes saved model artifacts to a callback.
	 *
	 * ```js
	 * function handleSave(artifacts) {
	 *   // ... do something with the artifacts ...
	 *   return {modelArtifactsInfo: {...}, ...};
	 * }
	 *
	 * const saveResult = model.save(tf.io.withSaveHandler(handleSave));
	 * ```
	 *
	 * @param saveHandler A function that accepts a `ModelArtifacts` and returns a
	 *     `SaveResult`.
	 */
	function withSaveHandler(saveHandler) {
	    return new PassthroughSaver(saveHandler);
	}
	exports.withSaveHandler = withSaveHandler;
	//# sourceMappingURL=passthrough.js.map

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(10);
	/**
	 * Monitor Promise.all progress, fire onProgress callback function.
	 *
	 * @param promises Promise list going to be monitored
	 * @param onProgress Callback function. Fired when a promise resolved.
	 * @param startFraction Optional fraction start. Default to 0.
	 * @param endFraction Optional fraction end. Default to 1.
	 */
	function monitorPromisesProgress(promises, onProgress, startFraction, endFraction) {
	    checkPromises(promises);
	    startFraction = startFraction == null ? 0 : startFraction;
	    endFraction = endFraction == null ? 1 : endFraction;
	    checkFraction(startFraction, endFraction);
	    var resolvedPromise = 0;
	    var registerMonitor = function (promise) {
	        promise.then(function (value) {
	            var fraction = startFraction +
	                ++resolvedPromise / promises.length * (endFraction - startFraction);
	            // pass fraction as parameter to callback function.
	            onProgress(fraction);
	            return value;
	        });
	        return promise;
	    };
	    function checkPromises(promises) {
	        util_1.assert(promises != null && Array.isArray(promises) && promises.length > 0, function () { return 'promises must be a none empty array'; });
	    }
	    function checkFraction(startFraction, endFraction) {
	        util_1.assert(startFraction >= 0 && startFraction <= 1, function () { return "Progress fraction must be in range [0, 1], but " +
	            ("got startFraction " + startFraction); });
	        util_1.assert(endFraction >= 0 && endFraction <= 1, function () { return "Progress fraction must be in range [0, 1], but " +
	            ("got endFraction " + endFraction); });
	        util_1.assert(endFraction >= startFraction, function () { return "startFraction must be no more than endFraction, but " +
	            ("got startFraction " + startFraction + " and endFraction ") +
	            ("" + endFraction); });
	    }
	    return Promise.all(promises.map(registerMonitor));
	}
	exports.monitorPromisesProgress = monitorPromisesProgress;
	//# sourceMappingURL=progress.js.map

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Exports under the tf.math.* namespace.
	 */
	var confusion_matrix_1 = __webpack_require__(1050);
	exports.confusionMatrix = confusion_matrix_1.confusionMatrix;
	//# sourceMappingURL=math.js.map

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var globals_1 = __webpack_require__(73);
	var tensor_util_env_1 = __webpack_require__(17);
	var util = __webpack_require__(10);
	var array_ops_1 = __webpack_require__(89);
	var broadcast_util_1 = __webpack_require__(57);
	var operation_1 = __webpack_require__(18);
	var tensor_ops_1 = __webpack_require__(31);
	var unary_ops_1 = __webpack_require__(320);
	/**
	 * Batch normalization, strictly for 2D. For the more relaxed version, see
	 * `tf.batchNorm`.
	 *
	 * @param x The input Tensor.
	 * @param mean A mean Tensor.
	 * @param variance A variance Tensor.
	 * @param offset An offset Tensor.
	 * @param scale A scale Tensor.
	 * @param varianceEpsilon A small float number to avoid dividing by 0.
	 */
	function batchNorm2d_(x, mean, variance, offset, scale, varianceEpsilon) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'batchNorm');
	    var $mean = tensor_util_env_1.convertToTensor(mean, 'mean', 'batchNorm');
	    var $variance = tensor_util_env_1.convertToTensor(variance, 'variance', 'batchNorm');
	    var $scale;
	    if (scale != null) {
	        $scale = tensor_util_env_1.convertToTensor(scale, 'scale', 'batchNorm');
	    }
	    var $offset;
	    if (offset != null) {
	        $offset = tensor_util_env_1.convertToTensor(offset, 'offset', 'batchNorm');
	    }
	    util.assert($x.rank === 2, function () { return "Error in batchNorm3D: x must be rank 3 but got rank " +
	        ($x.rank + "."); });
	    util.assert($mean.rank === 2 || $mean.rank === 1, function () { return "Error in batchNorm2D: mean must be rank 2 or rank 1 but " +
	        ("got rank " + $mean.rank + "."); });
	    util.assert($variance.rank === 2 || $variance.rank === 1, function () { return "Error in batchNorm2D: variance must be rank 2 or rank 1 " +
	        ("but got rank " + $variance.rank + "."); });
	    if ($scale != null) {
	        util.assert($scale.rank === 2 || $scale.rank === 1, function () { return "Error in batchNorm2D: scale must be rank 2 or rank 1 " +
	            ("but got rank " + $scale.rank + "."); });
	    }
	    if ($offset != null) {
	        util.assert($offset.rank === 2 || $offset.rank === 1, function () { return "Error in batchNorm2D: offset must be rank 2 or rank 1 " +
	            ("but got rank " + $offset.rank + "."); });
	    }
	    return batchNorm_($x, $mean, $variance, $offset, $scale, varianceEpsilon);
	}
	/**
	 * Batch normalization, strictly for 3D. For the more relaxed version, see
	 * `tf.batchNorm`.
	 *
	 * @param x The input Tensor.
	 * @param mean A mean Tensor.
	 * @param variance A variance Tensor.
	 * @param offset An offset Tensor.
	 * @param scale A scale Tensor.
	 * @param varianceEpsilon A small float number to avoid dividing by 0.
	 */
	function batchNorm3d_(x, mean, variance, offset, scale, varianceEpsilon) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'batchNorm');
	    var $mean = tensor_util_env_1.convertToTensor(mean, 'mean', 'batchNorm');
	    var $variance = tensor_util_env_1.convertToTensor(variance, 'variance', 'batchNorm');
	    var $scale;
	    if (scale != null) {
	        $scale = tensor_util_env_1.convertToTensor(scale, 'scale', 'batchNorm');
	    }
	    var $offset;
	    if (offset != null) {
	        $offset = tensor_util_env_1.convertToTensor(offset, 'offset', 'batchNorm');
	    }
	    util.assert($x.rank === 3, function () { return "Error in batchNorm3D: x must be rank 3 but got rank " +
	        ($x.rank + "."); });
	    util.assert($mean.rank === 3 || $mean.rank === 1, function () { return "Error in batchNorm3D: mean must be rank 3 or rank 1 but " +
	        ("got rank " + $mean.rank + "."); });
	    util.assert($variance.rank === 3 || $variance.rank === 1, function () { return "Error in batchNorm3D: variance must be rank 3 or rank 1 " +
	        ("but got rank " + $variance.rank + "."); });
	    if ($scale != null) {
	        util.assert($scale.rank === 3 || $scale.rank === 1, function () { return "Error in batchNorm3D: scale must be rank 3 or rank 1 " +
	            ("but got rank " + $scale.rank + "."); });
	    }
	    if ($offset != null) {
	        util.assert($offset.rank === 3 || $offset.rank === 1, function () { return "Error in batchNorm3D: offset must be rank 3 or rank 1 " +
	            ("but got rank " + $offset.rank + "."); });
	    }
	    return batchNorm_($x, $mean, $variance, $offset, $scale, varianceEpsilon);
	}
	/**
	 * Batch normalization, strictly for 4D. For the more relaxed version, see
	 * `tf.batchNorm`.
	 *
	 * @param x The input Tensor.
	 * @param mean A mean Tensor.
	 * @param variance A variance Tensor.
	 * @param offset An offset Tensor.
	 * @param scale A scale Tensor.
	 * @param varianceEpsilon A small float number to avoid dividing by 0.
	 */
	function batchNorm4d_(x, mean, variance, offset, scale, varianceEpsilon) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'batchNorm');
	    var $mean = tensor_util_env_1.convertToTensor(mean, 'mean', 'batchNorm');
	    var $variance = tensor_util_env_1.convertToTensor(variance, 'variance', 'batchNorm');
	    var $scale;
	    if (scale != null) {
	        $scale = tensor_util_env_1.convertToTensor(scale, 'scale', 'batchNorm');
	    }
	    var $offset;
	    if (offset != null) {
	        $offset = tensor_util_env_1.convertToTensor(offset, 'offset', 'batchNorm');
	    }
	    util.assert($x.rank === 4, function () { return "Error in batchNorm4D: x must be rank 4 but got rank " +
	        ($x.rank + "."); });
	    util.assert($mean.rank === 4 || $mean.rank === 1, function () { return "Error in batchNorm4D: mean must be rank 4 or rank 1 but " +
	        ("got rank " + $mean.rank + "."); });
	    util.assert($variance.rank === 4 || $variance.rank === 1, function () { return "Error in batchNorm4D: variance must be rank 4 or rank 1 " +
	        ("but got rank " + $variance.rank + "."); });
	    if ($scale != null) {
	        util.assert($scale.rank === 4 || $scale.rank === 1, function () { return "Error in batchNorm4D: scale must be rank 4 or rank 1 " +
	            ("but got rank " + $scale.rank + "."); });
	    }
	    if ($offset != null) {
	        util.assert($offset.rank === 4 || $offset.rank === 1, function () { return "Error in batchNorm4D: offset must be rank 4 or rank 1 " +
	            ("but got rank " + $offset.rank + "."); });
	    }
	    return batchNorm_($x, $mean, $variance, $offset, $scale, varianceEpsilon);
	}
	/**
	 * @deprecated Please use `tf.batchNorm` instead and note the positional
	 *     argument change of scale, offset, and varianceEpsilon.
	 */
	function batchNormalization_(x, mean, variance, varianceEpsilon, scale, offset) {
	    if (varianceEpsilon === void 0) { varianceEpsilon = .001; }
	    warnDeprecation();
	    return batchNorm_(x, mean, variance, offset, scale, varianceEpsilon);
	}
	/**
	 * Batch normalization.
	 *
	 * As described in
	 * [http://arxiv.org/abs/1502.03167](http://arxiv.org/abs/1502.03167).
	 *
	 * Mean, variance, scale, and offset can be of two shapes:
	 *   - The same shape as the input.
	 *   - In the common case, the depth dimension is the last dimension of x, so
	 *     the values would be an `tf.Tensor1D` of shape [depth].
	 *
	 * Also available are stricter rank-specific methods with the same signature
	 * as this method that assert that parameters passed are of given rank
	 *   - `tf.batchNorm2d`
	 *   - `tf.batchNorm3d`
	 *   - `tf.batchNorm4d`
	 *
	 * @param x The input Tensor.
	 * @param mean A mean Tensor.
	 * @param variance A variance Tensor.
	 * @param offset An offset Tensor.
	 * @param scale A scale Tensor.
	 * @param varianceEpsilon A small float number to avoid dividing by 0.
	 */
	/** @doc {heading: 'Operations', subheading: 'Normalization'} */
	function batchNorm_(x, mean, variance, offset, scale, varianceEpsilon) {
	    if (varianceEpsilon == null) {
	        varianceEpsilon = 0.001;
	    }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'batchNorm');
	    var $mean = tensor_util_env_1.convertToTensor(mean, 'mean', 'batchNorm');
	    var $variance = tensor_util_env_1.convertToTensor(variance, 'variance', 'batchNorm');
	    var $scale;
	    if (scale != null) {
	        $scale = tensor_util_env_1.convertToTensor(scale, 'scale', 'batchNorm');
	    }
	    var $offset;
	    if (offset != null) {
	        $offset = tensor_util_env_1.convertToTensor(offset, 'offset', 'batchNorm');
	    }
	    util.assert($mean.rank === $variance.rank, function () { return 'Batch normalization gradient requires mean and variance to have ' +
	        'equal ranks.'; });
	    util.assert($offset == null || $mean.rank === $offset.rank, function () { return 'Batch normalization gradient requires mean and offset to have ' +
	        'equal ranks.'; });
	    util.assert($scale == null || $mean.rank === $scale.rank, function () { return 'Batch normalization gradient requires mean and scale to have ' +
	        'equal ranks.'; });
	    var x4D;
	    if ($x.rank === 0 || $x.rank === 1) {
	        x4D = $x.as4D(1, 1, 1, $x.size);
	    }
	    else if ($x.rank === 2) {
	        x4D = $x.as4D(1, 1, $x.shape[0], $x.shape[1]);
	    }
	    else if ($x.rank === 3) {
	        x4D = $x.as4D(1, $x.shape[0], $x.shape[1], $x.shape[2]);
	    }
	    else {
	        x4D = $x;
	    }
	    var der = function (dy, saved) {
	        var _a = saved, $x = _a[0], $mean = _a[1], $variance = _a[2], $scale = _a[3];
	        var scaleValue = $scale == null ? tensor_ops_1.scalar(1) : $scale;
	        var reductionAxes = broadcast_util_1.getReductionAxes($mean.shape, x4D.shape);
	        var tileShape = [];
	        if ($mean.rank === 1) {
	            for (var i = 0; i < x4D.shape.length - 1; ++i) {
	                tileShape.push(x4D.shape[i]);
	            }
	            tileShape.push(1);
	        }
	        var xMinusMean = $x.sub($mean);
	        var dyTimesScaleValue = dy.mul(scaleValue);
	        var oneOverSqrtVariance = unary_ops_1.rsqrt($variance.add(tensor_ops_1.scalar(varianceEpsilon)));
	        var minusHalfRCube = oneOverSqrtVariance.mul(oneOverSqrtVariance)
	            .mul(oneOverSqrtVariance)
	            .mul(tensor_ops_1.scalar(-0.5));
	        var derX = function () {
	            if ($mean.rank === 1) {
	                return dy
	                    .mul(array_ops_1.tile(oneOverSqrtVariance.as4D(1, 1, 1, $mean.shape[0]), tileShape))
	                    .mul(scaleValue)
	                    .reshape($x.shape);
	            }
	            else {
	                return dy.mul(oneOverSqrtVariance).mul(scaleValue).reshape($x.shape);
	            }
	        };
	        var derMean = function () {
	            var meanDer = oneOverSqrtVariance.mul(tensor_ops_1.scalar(-1)).mul(dyTimesScaleValue);
	            if ($mean.rank === 1) {
	                meanDer = meanDer.sum(reductionAxes);
	            }
	            return meanDer.reshape($mean.shape);
	        };
	        var derVariance = function () {
	            var varianceDer = minusHalfRCube.mul(xMinusMean).mul(dyTimesScaleValue);
	            if ($mean.rank === 1) {
	                varianceDer = varianceDer.sum(reductionAxes);
	            }
	            return varianceDer.reshape($mean.shape);
	        };
	        var derScale = function () {
	            var xMinusMean2TimesRsqrt = xMinusMean.mul(oneOverSqrtVariance);
	            var scaleDer = dy.mul(xMinusMean2TimesRsqrt);
	            if ($mean.rank === 1) {
	                scaleDer = scaleDer.sum(reductionAxes);
	            }
	            return scaleDer.reshape($mean.shape);
	        };
	        var derOffset = function () {
	            var offsetDer = dy;
	            if ($mean.rank === 1) {
	                offsetDer = offsetDer.sum(reductionAxes);
	            }
	            return offsetDer.reshape($mean.shape);
	        };
	        return {
	            x: derX,
	            mean: derMean,
	            variance: derVariance,
	            scale: derScale,
	            offset: derOffset
	        };
	    };
	    var inputsToSave = [$x, $mean, $variance, $scale];
	    var res = engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.batchNormalization(x4D, batchnormReshape4D($mean), batchnormReshape4D($variance), varianceEpsilon, batchnormReshape4D($scale), batchnormReshape4D($offset));
	        save([$x, $mean, $variance, $scale]);
	        return res;
	    }, { x: $x, mean: $mean, variance: $variance, scale: $scale, offset: $offset }, der, 'BatchNormalization', { varianceEpsilon: varianceEpsilon }, inputsToSave);
	    return res.reshape($x.shape);
	}
	function batchnormReshape4D(x) {
	    if (x == null) {
	        return null;
	    }
	    if (x.rank === 0) {
	        return x.as1D();
	    }
	    else if (x.rank === 1) {
	        return x;
	    }
	    else if (x.rank === 2) {
	        return x.as4D(1, 1, x.shape[0], x.shape[1]);
	    }
	    else if (x.rank === 3) {
	        return x.as4D(1, x.shape[0], x.shape[1], x.shape[2]);
	    }
	    return x;
	}
	/**
	 * @deprecated Please use `tf.batchNorm2d` instead and note the positional
	 *     argument change of scale, offset, and varianceEpsilon.
	 */
	function batchNormalization2d_(x, mean, variance, varianceEpsilon, scale, offset) {
	    if (varianceEpsilon === void 0) { varianceEpsilon = .001; }
	    warnDeprecation();
	    return batchNorm2d_(x, mean, variance, offset, scale, varianceEpsilon);
	}
	/**
	 * @deprecated Please use `tf.batchNorm3d` instead and note the positional
	 *     argument change of scale, offset, and varianceEpsilon.
	 */
	function batchNormalization3d_(x, mean, variance, varianceEpsilon, scale, offset) {
	    if (varianceEpsilon === void 0) { varianceEpsilon = .001; }
	    warnDeprecation();
	    return batchNorm3d_(x, mean, variance, offset, scale, varianceEpsilon);
	}
	/**
	 * @deprecated Please use `tf.batchNorm4d` instead and note the positional
	 *     argument change of scale, offset, and varianceEpsilon.
	 */
	function batchNormalization4d_(x, mean, variance, varianceEpsilon, scale, offset) {
	    if (varianceEpsilon === void 0) { varianceEpsilon = .001; }
	    warnDeprecation();
	    return batchNorm4d_(x, mean, variance, offset, scale, varianceEpsilon);
	}
	function warnDeprecation() {
	    globals_1.deprecationWarn('tf.batchNormalization() is going away. ' +
	        'Use tf.batchNorm() instead, and note the positional argument change ' +
	        'of scale, offset, and varianceEpsilon');
	}
	exports.batchNormalization2d = operation_1.op({ batchNormalization2d_: batchNormalization2d_ });
	exports.batchNormalization3d = operation_1.op({ batchNormalization3d_: batchNormalization3d_ });
	exports.batchNormalization4d = operation_1.op({ batchNormalization4d_: batchNormalization4d_ });
	exports.batchNormalization = operation_1.op({ batchNormalization_: batchNormalization_ });
	exports.batchNorm = operation_1.op({ batchNorm_: batchNorm_ });
	exports.batchNorm2d = operation_1.op({ batchNorm2d_: batchNorm2d_ });
	exports.batchNorm3d = operation_1.op({ batchNorm3d_: batchNorm3d_ });
	exports.batchNorm4d = operation_1.op({ batchNorm4d_: batchNorm4d_ });
	//# sourceMappingURL=batchnorm.js.map

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var tensor_util_env_1 = __webpack_require__(17);
	var util = __webpack_require__(10);
	var logical_ops_1 = __webpack_require__(154);
	var segment_ops_1 = __webpack_require__(494);
	/**
	 * Apply boolean mask to tensor.
	 *
	 * ```js
	 * const tensor = tf.tensor2d([1, 2, 3, 4, 5, 6], [3, 2]);
	 * const mask = tf.tensor1d([1, 0, 1], 'bool');
	 * const result = await tf.booleanMaskAsync(tensor, mask);
	 * result.print();
	 * ```
	 *
	 * @param tensor N-D tensor.
	 * @param mask K-D boolean tensor, K <= N and K must be known statically.
	 * @param axis A 0-D int Tensor representing the axis in tensor to mask from.
	 *     By default, axis is 0 which will mask from the first dimension.
	 *     Otherwise K + axis <= N.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Slicing and Joining'} */
	function booleanMaskAsync_(tensor, mask, axis) {
	    return __awaiter(this, void 0, void 0, function () {
	        var $tensor, $mask, axisFrom, maskDim, tensorShape, leadingSize, i, targetTensorShape, reshapedTensor, reshapedMask, positivePositions, indices, res;
	        return __generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    $tensor = tensor_util_env_1.convertToTensor(tensor, 'tensor', 'boolMask');
	                    $mask = tensor_util_env_1.convertToTensor(mask, 'mask', 'boolMask', 'bool');
	                    axisFrom = axis == null ? 0 : axis;
	                    maskDim = $mask.rank;
	                    tensorShape = $tensor.shape;
	                    util.assert(maskDim > 0, function () { return 'mask cannot be scalar'; });
	                    util.assertShapesMatch(tensorShape.slice(axisFrom, axisFrom + maskDim), $mask.shape, "mask's shape must match the first K dimensions of tensor's shape,");
	                    leadingSize = 1;
	                    for (i = axisFrom; i < axisFrom + maskDim; i++) {
	                        leadingSize *= tensorShape[i];
	                    }
	                    targetTensorShape = tensorShape.slice(0, axisFrom)
	                        .concat([leadingSize], tensorShape.slice(axisFrom + maskDim));
	                    reshapedTensor = $tensor.reshape(targetTensorShape);
	                    reshapedMask = $mask.reshape([-1]);
	                    return [4 /*yield*/, logical_ops_1.whereAsync(reshapedMask)];
	                case 1:
	                    positivePositions = _a.sent();
	                    indices = positivePositions.squeeze([1]);
	                    res = segment_ops_1.gather(reshapedTensor, indices, axisFrom);
	                    // Ensure no memory leak.
	                    if (tensor !== $tensor) {
	                        $tensor.dispose();
	                    }
	                    if (mask !== $mask) {
	                        $mask.dispose();
	                    }
	                    indices.dispose();
	                    reshapedTensor.dispose();
	                    reshapedMask.dispose();
	                    positivePositions.dispose();
	                    return [2 /*return*/, res];
	            }
	        });
	    });
	}
	exports.booleanMaskAsync = booleanMaskAsync_;
	//# sourceMappingURL=boolean_mask.js.map

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var kernel_registry_1 = __webpack_require__(152);
	var tensor_1 = __webpack_require__(75);
	var tensor_util_env_1 = __webpack_require__(17);
	var operation_1 = __webpack_require__(18);
	var tensor_ops_1 = __webpack_require__(31);
	var fromPixels2DContext;
	/**
	 * Creates a `tf.Tensor` from an image.
	 *
	 * ```js
	 * const image = new ImageData(1, 1);
	 * image.data[0] = 100;
	 * image.data[1] = 150;
	 * image.data[2] = 200;
	 * image.data[3] = 255;
	 *
	 * tf.browser.fromPixels(image).print();
	 * ```
	 *
	 * @param pixels The input image to construct the tensor from. The
	 * supported image types are all 4-channel. You can also pass in an image
	 * object with following attributes:
	 * `{data: Uint8Array; width: number; height: number}`
	 * @param numChannels The number of channels of the output tensor. A
	 * numChannels value less than 4 allows you to ignore channels. Defaults to
	 * 3 (ignores alpha channel of input image).
	 */
	/** @doc {heading: 'Browser', namespace: 'browser', ignoreCI: true} */
	function fromPixels_(pixels, numChannels) {
	    if (numChannels === void 0) { numChannels = 3; }
	    // Sanity checks.
	    if (numChannels > 4) {
	        throw new Error('Cannot construct Tensor with more than 4 channels from pixels.');
	    }
	    if (pixels == null) {
	        throw new Error('pixels passed to tf.browser.fromPixels() can not be null');
	    }
	    var isPixelData = false;
	    var isImageData = false;
	    var isVideo = false;
	    var isImage = false;
	    var isCanvasLike = false;
	    if (pixels.data instanceof Uint8Array) {
	        isPixelData = true;
	    }
	    else if (typeof (ImageData) !== 'undefined' && pixels instanceof ImageData) {
	        isImageData = true;
	    }
	    else if (typeof (HTMLVideoElement) !== 'undefined' &&
	        pixels instanceof HTMLVideoElement) {
	        isVideo = true;
	    }
	    else if (typeof (HTMLImageElement) !== 'undefined' &&
	        pixels instanceof HTMLImageElement) {
	        isImage = true;
	        // tslint:disable-next-line: no-any
	    }
	    else if (pixels.getContext != null) {
	        isCanvasLike = true;
	    }
	    else {
	        throw new Error('pixels passed to tf.browser.fromPixels() must be either an ' +
	            "HTMLVideoElement, HTMLImageElement, HTMLCanvasElement, ImageData " +
	            "in browser, or OffscreenCanvas, ImageData in webworker" +
	            " or {data: Uint32Array, width: number, height: number}, " +
	            ("but was " + pixels.constructor.name));
	    }
	    if (isVideo) {
	        var HAVE_CURRENT_DATA_READY_STATE = 2;
	        if (isVideo &&
	            pixels.readyState <
	                HAVE_CURRENT_DATA_READY_STATE) {
	            throw new Error('The video element has not loaded data yet. Please wait for ' +
	                '`loadeddata` event on the <video> element.');
	        }
	    }
	    // If the current backend has 'FromPixels' registered, it has a more
	    // efficient way of handling pixel uploads, so we call that.
	    var kernel = kernel_registry_1.getKernel('FromPixels', engine_1.ENGINE.backendName);
	    if (kernel != null) {
	        return engine_1.ENGINE.runKernel('FromPixels', { pixels: pixels }, { numChannels: numChannels });
	    }
	    var _a = isVideo ?
	        [
	            pixels.videoWidth,
	            pixels.videoHeight
	        ] :
	        [pixels.width, pixels.height], width = _a[0], height = _a[1];
	    var vals;
	    if (isCanvasLike) {
	        vals =
	            // tslint:disable-next-line:no-any
	            pixels.getContext('2d').getImageData(0, 0, width, height).data;
	    }
	    else if (isImageData || isPixelData) {
	        vals = pixels.data;
	    }
	    else if (isImage || isVideo) {
	        if (fromPixels2DContext == null) {
	            fromPixels2DContext = document.createElement('canvas').getContext('2d');
	        }
	        fromPixels2DContext.canvas.width = width;
	        fromPixels2DContext.canvas.height = height;
	        fromPixels2DContext.drawImage(pixels, 0, 0, width, height);
	        vals = fromPixels2DContext.getImageData(0, 0, width, height).data;
	    }
	    var values;
	    if (numChannels === 4) {
	        values = new Int32Array(vals);
	    }
	    else {
	        var numPixels = width * height;
	        values = new Int32Array(numPixels * numChannels);
	        for (var i = 0; i < numPixels; i++) {
	            for (var channel = 0; channel < numChannels; ++channel) {
	                values[i * numChannels + channel] = vals[i * 4 + channel];
	            }
	        }
	    }
	    var outShape = [height, width, numChannels];
	    return tensor_ops_1.tensor3d(values, outShape, 'int32');
	}
	/**
	 * Draws a `tf.Tensor` of pixel values to a byte array or optionally a
	 * canvas.
	 *
	 * When the dtype of the input is 'float32', we assume values in the range
	 * [0-1]. Otherwise, when input is 'int32', we assume values in the range
	 * [0-255].
	 *
	 * Returns a promise that resolves when the canvas has been drawn to.
	 *
	 * @param img A rank-2 or rank-3 tensor. If rank-2, draws grayscale. If
	 *     rank-3, must have depth of 1, 3 or 4. When depth of 1, draws
	 * grayscale. When depth of 3, we draw with the first three components of
	 * the depth dimension corresponding to r, g, b and alpha = 1. When depth of
	 * 4, all four components of the depth dimension correspond to r, g, b, a.
	 * @param canvas The canvas to draw to.
	 */
	/** @doc {heading: 'Browser', namespace: 'browser'} */
	function toPixels(img, canvas) {
	    return __awaiter(this, void 0, void 0, function () {
	        var $img, _a, height, width, depth, data, minTensor, maxTensor, vals, minVals, maxVals, min, max, multiplier, bytes, i, r, g, b, a, j, ctx, imageData;
	        return __generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    $img = tensor_util_env_1.convertToTensor(img, 'img', 'toPixels');
	                    if (!(img instanceof tensor_1.Tensor)) {
	                        // Assume int32 if user passed a native array.
	                        $img = $img.toInt();
	                    }
	                    if ($img.rank !== 2 && $img.rank !== 3) {
	                        throw new Error("toPixels only supports rank 2 or 3 tensors, got rank " + $img.rank + ".");
	                    }
	                    _a = $img.shape.slice(0, 2), height = _a[0], width = _a[1];
	                    depth = $img.rank === 2 ? 1 : $img.shape[2];
	                    if (depth > 4 || depth === 2) {
	                        throw new Error("toPixels only supports depth of size " +
	                            ("1, 3 or 4 but got " + depth));
	                    }
	                    return [4 /*yield*/, $img.data()];
	                case 1:
	                    data = _b.sent();
	                    minTensor = $img.min();
	                    maxTensor = $img.max();
	                    return [4 /*yield*/, Promise.all([minTensor.data(), maxTensor.data()])];
	                case 2:
	                    vals = _b.sent();
	                    minVals = vals[0];
	                    maxVals = vals[1];
	                    min = minVals[0];
	                    max = maxVals[0];
	                    minTensor.dispose();
	                    maxTensor.dispose();
	                    if ($img.dtype === 'float32') {
	                        if (min < 0 || max > 1) {
	                            throw new Error("Tensor values for a float32 Tensor must be in the " +
	                                ("range [0 - 1] but got range [" + min + " - " + max + "]."));
	                        }
	                    }
	                    else if ($img.dtype === 'int32') {
	                        if (min < 0 || max > 255) {
	                            throw new Error("Tensor values for a int32 Tensor must be in the " +
	                                ("range [0 - 255] but got range [" + min + " - " + max + "]."));
	                        }
	                    }
	                    else {
	                        throw new Error("Unsupported type for toPixels: " + $img.dtype + "." +
	                            " Please use float32 or int32 tensors.");
	                    }
	                    multiplier = $img.dtype === 'float32' ? 255 : 1;
	                    bytes = new Uint8ClampedArray(width * height * 4);
	                    for (i = 0; i < height * width; ++i) {
	                        r = void 0, g = void 0, b = void 0, a = void 0;
	                        if (depth === 1) {
	                            r = data[i] * multiplier;
	                            g = data[i] * multiplier;
	                            b = data[i] * multiplier;
	                            a = 255;
	                        }
	                        else if (depth === 3) {
	                            r = data[i * 3] * multiplier;
	                            g = data[i * 3 + 1] * multiplier;
	                            b = data[i * 3 + 2] * multiplier;
	                            a = 255;
	                        }
	                        else if (depth === 4) {
	                            r = data[i * 4] * multiplier;
	                            g = data[i * 4 + 1] * multiplier;
	                            b = data[i * 4 + 2] * multiplier;
	                            a = data[i * 4 + 3] * multiplier;
	                        }
	                        j = i * 4;
	                        bytes[j + 0] = Math.round(r);
	                        bytes[j + 1] = Math.round(g);
	                        bytes[j + 2] = Math.round(b);
	                        bytes[j + 3] = Math.round(a);
	                    }
	                    if (canvas != null) {
	                        canvas.width = width;
	                        canvas.height = height;
	                        ctx = canvas.getContext('2d');
	                        imageData = new ImageData(bytes, width, height);
	                        ctx.putImageData(imageData, 0, 0);
	                    }
	                    if ($img !== img) {
	                        $img.dispose();
	                    }
	                    return [2 /*return*/, bytes];
	            }
	        });
	    });
	}
	exports.toPixels = toPixels;
	exports.fromPixels = operation_1.op({ fromPixels_: fromPixels_ });
	//# sourceMappingURL=browser.js.map

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tensor_util_env_1 = __webpack_require__(17);
	var util = __webpack_require__(10);
	var array_ops_1 = __webpack_require__(89);
	var operation_1 = __webpack_require__(18);
	/**
	 * Computes the confusion matrix from true labels and predicted labels.
	 *
	 * ```js
	 * const labels = tf.tensor1d([0, 1, 2, 1, 0], 'int32');
	 * const predictions = tf.tensor1d([0, 2, 2, 1, 0], 'int32');
	 * const numClasses = 3;
	 * const out = tf.math.confusionMatrix(labels, predictions, numClasses);
	 * out.print();
	 * // Expected output matrix:
	 * // [[2, 0, 0],
	 * //  [0, 1, 1],
	 * //  [0, 0, 1]]
	 * ```
	 *
	 * @param labels The target labels, assumed to be 0-based integers
	 *   for the classes. The shape is `[numExamples]`, where
	 *   `numExamples` is the number of examples included.
	 * @param predictions The predicted classes, assumed to be
	 *   0-based integers for the classes. Must have the same shape as `labels`.
	 * @param numClasses Number of all classes, as an integer.
	 *   Its value must be larger than the largest element in `labels` and
	 *   `predictions`.
	 * @returns The confusion matrix as a int32-type 2D tensor. The value at
	 *   row `r` and column `c` is the number of times examples of actual class
	 *   `r` were predicted as class `c`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Evaluation'} */
	function confusionMatrix_(labels, predictions, numClasses) {
	    var $labels = tensor_util_env_1.convertToTensor(labels, 'labels', 'confusionMatrix');
	    var $predictions = tensor_util_env_1.convertToTensor(predictions, 'predictions', 'confusionMatrix');
	    util.assert(numClasses == null || numClasses > 0 && Number.isInteger(numClasses), function () { return "If provided, numClasses must be a positive integer, " +
	        ("but got " + numClasses); });
	    util.assert($labels.rank === 1, function () { return "Expected the rank of labels to be 1, but got " + $labels.rank; });
	    util.assert($predictions.rank === 1, function () { return "Expected the rank of predictions to be 1, " +
	        ("but got " + $predictions.rank); });
	    util.assert($labels.shape[0] === $predictions.shape[0], function () { return "Mismatch in the number of examples: " +
	        ($labels.shape[0] + " vs. " + $predictions.shape[0] + ". ") +
	        "Labels and predictions should have the same number of elements."; });
	    util.assert(numClasses > 0 && Number.isInteger(numClasses), function () { return "numClasses is required to be a positive integer, but got " +
	        ("" + numClasses); });
	    // TODO(cais): In the future, if oneHot supports tensors inputs for
	    //   `numClasses`, `confusionMatrix` can make `numClasses` optional.
	    var oneHotLabels = array_ops_1.oneHot($labels.asType('int32'), numClasses);
	    var oneHotPredictions = array_ops_1.oneHot($predictions.asType('int32'), numClasses);
	    return oneHotLabels.transpose().matMul(oneHotPredictions).asType('int32');
	}
	exports.confusionMatrix_ = confusionMatrix_;
	exports.confusionMatrix = operation_1.op({ confusionMatrix_: confusionMatrix_ });
	//# sourceMappingURL=confusion_matrix.js.map

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_util_env_1 = __webpack_require__(17);
	var operation_1 = __webpack_require__(18);
	/**
	 * Returns a diagonal tensor with a given diagonal values.
	 *
	 * Given a diagonal, this operation returns a tensor with the diagonal and
	 * everything else padded with zeros.
	 *
	 * Assume the input has dimensions `[D1,..., Dk]`, then the output is a tensor
	 * of rank 2k with dimensions `[D1,..., Dk, D1,..., Dk]`
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, 3, 4]);
	 *
	 * tf.diag(x).print()
	 * ```
	 * ```js
	 * const x = tf.tensor1d([1, 2, 3, 4, 5, 6, 6, 8], [4, 2])
	 *
	 * tf.diag(x).print()
	 * ```
	 * @param x The input tensor.
	 */
	function diag_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'diag').flatten();
	    var outShape = x.shape.concat(x.shape);
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.diag($x); }, { $x: $x })
	        .reshape(outShape);
	}
	exports.diag = operation_1.op({ diag_: diag_ });
	//# sourceMappingURL=diag.js.map

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tensor_1 = __webpack_require__(75);
	var tensor_util_env_1 = __webpack_require__(17);
	var util = __webpack_require__(10);
	var array_ops_1 = __webpack_require__(89);
	var dropout_util_1 = __webpack_require__(1053);
	var operation_1 = __webpack_require__(18);
	/**
	 * Computes dropout.
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, 2, 1]);
	 * const rate = 0.75;
	 * const output = tf.dropout(x, rate);
	 * output.print();
	 * ```
	 *
	 * @param x A floating point Tensor or TensorLike.
	 * @param rate A float in the range [0, 1). The probability that each element
	 *   of x is discarded.
	 * @param noiseShape An array of numbers of type int32, representing the
	 * shape for randomly generated keep/drop flags. If the noiseShape has null
	 * value, it will be automatically replaced with the x's relative dimension
	 * size. Optional.
	 * @param seed Used to create random seeds. Optional.
	 * @returns A Tensor of the same shape of x.
	 */
	/** @doc {heading: 'Operations', subheading: 'Dropout'} */
	function dropout_(x, rate, noiseShape, seed) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'dropout');
	    util.assert($x.dtype === 'float32', function () { return "x has to be a floating point tensor since it's going to be " +
	        ("scaled, but got a " + $x.dtype + " tensor instead."); });
	    util.assert(rate >= 0 && rate < 1, function () { return "rate must be a float in the range [0, 1), but got " + rate + "."; });
	    if (rate === 0) {
	        return x instanceof tensor_1.Tensor ? $x.clone() : $x;
	    }
	    var $noiseShape = dropout_util_1.getNoiseShape($x, noiseShape);
	    var keepProb = 1 - rate;
	    var multiplier = array_ops_1.randomUniform($noiseShape, 0, 1, 'float32', seed)
	        .add(keepProb)
	        .floor()
	        .div(keepProb);
	    return $x.mul(multiplier);
	}
	exports.dropout = operation_1.op({ dropout_: dropout_ });
	//# sourceMappingURL=dropout.js.map

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util = __webpack_require__(10);
	/**
	 * Normalize noise shape based on provided tensor and noise shape.
	 *
	 * @param x Tensor.
	 * @param noiseShape The shape for the randomly generated keep/drop flags, as
	 *   an array of numbers. Optional.
	 * @returns Normalized noise shape.
	 */
	function getNoiseShape(x, noiseShape) {
	    if (noiseShape == null) {
	        return x.shape.slice();
	    }
	    if (util.arraysEqual(x.shape, noiseShape)) {
	        return noiseShape;
	    }
	    if (x.shape.length === noiseShape.length) {
	        var newDimension = [];
	        for (var i = 0; i < x.shape.length; i++) {
	            if (noiseShape[i] == null && x.shape[i] != null) {
	                newDimension.push(x.shape[i]);
	            }
	            else {
	                newDimension.push(noiseShape[i]);
	            }
	        }
	        return newDimension;
	    }
	    return noiseShape;
	}
	exports.getNoiseShape = getNoiseShape;
	//# sourceMappingURL=dropout_util.js.map

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var conv_1 = __webpack_require__(314);
	var conv_util = __webpack_require__(238);
	var operation_1 = __webpack_require__(18);
	var tensor_util_1 = __webpack_require__(111);
	var tensor_util_env_1 = __webpack_require__(17);
	var util = __webpack_require__(10);
	var binary_ops_1 = __webpack_require__(109);
	var broadcast_util = __webpack_require__(57);
	var conv_2 = __webpack_require__(314);
	var fused_util_1 = __webpack_require__(1055);
	var matmul_1 = __webpack_require__(490);
	var relu_ops_1 = __webpack_require__(493);
	// Returns gradient for fused activation.
	var getFusedDyActivation = function (dy, y, activation) {
	    if (activation == null || activation === 'linear') {
	        return dy;
	    }
	    if (activation === 'relu') {
	        return dy.mul(y.step());
	    }
	    throw new Error("Gradient for activation " + activation + " has not been " +
	        "implemented yet.");
	};
	// Returns gradient for fused bias.
	var getFusedBiasGradient = function (bias, dyActivation) {
	    var res = dyActivation;
	    var reduceAxes = broadcast_util.getReductionAxes(bias.shape, dyActivation.shape);
	    if (reduceAxes.length > 0) {
	        res = res.sum(reduceAxes);
	    }
	    return res.reshape(bias.shape);
	};
	var applyActivation = function (x, activation, preluActivationWeights) {
	    if (activation === 'linear') {
	        return x;
	    }
	    else if (activation === 'relu') {
	        return relu_ops_1.relu(x);
	    }
	    else if (activation === 'elu') {
	        return relu_ops_1.elu(x);
	    }
	    else if (activation === 'relu6') {
	        return relu_ops_1.relu6(x);
	    }
	    else if (activation === 'prelu') {
	        return relu_ops_1.prelu(x, preluActivationWeights);
	    }
	    throw new Error("Unknown fused activation " + activation + ".");
	};
	/**
	 * Computes the dot product of two matrices with optional activation and bias.
	 *
	 * ```js
	 * const a = tf.tensor2d([-1, -2], [1, 2]);
	 * const b = tf.tensor2d([1, 2, 3, 4], [2, 2]);
	 * const bias = tf.tensor2d([1, 2], [1, 2]);
	 *
	 * tf.fused.matMul({a, b, bias, activation: 'relu'}).print();
	 * ```
	 *
	 * @param obj An object with the following properties:
	 * - `a` First matrix in dot product operation.
	 * - `b` Second matrix in dot product operation.
	 * - `transposeA` If true, `a` is transposed before multiplication.
	 * - `transposeB` If true, `b` is transposed before multiplication.
	 * - `bias` Matrix to be added to the result.
	 * - `activation` Name of activation kernel (defaults to `linear`).
	 * - `preluActivationWeights` Tensor of prelu weights.
	 */
	function fusedMatMul_(_a) {
	    var _b;
	    var a = _a.a, b = _a.b, _c = _a.transposeA, transposeA = _c === void 0 ? false : _c, _d = _a.transposeB, transposeB = _d === void 0 ? false : _d, bias = _a.bias, _e = _a.activation, activation = _e === void 0 ? 'linear' : _e, preluActivationWeights = _a.preluActivationWeights;
	    if (fused_util_1.shouldFuse(engine_1.ENGINE.state.gradientDepth, activation) === false) {
	        var result = matmul_1.matMul(a, b, transposeA, transposeB);
	        if (bias != null) {
	            result = binary_ops_1.add(result, bias);
	        }
	        return applyActivation(result, activation, preluActivationWeights);
	    }
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'fused matMul');
	    var $b = tensor_util_env_1.convertToTensor(b, 'b', 'fused matMul');
	    _b = tensor_util_1.makeTypesMatch($a, $b), $a = _b[0], $b = _b[1];
	    var innerShapeA = transposeA ? $a.shape[$a.rank - 2] : $a.shape[$a.rank - 1];
	    var innerShapeB = transposeB ? $b.shape[$b.rank - 1] : $b.shape[$b.rank - 2];
	    var outerShapeA = transposeA ? $a.shape[$a.rank - 1] : $a.shape[$a.rank - 2];
	    var outerShapeB = transposeB ? $b.shape[$b.rank - 2] : $b.shape[$b.rank - 1];
	    var outerDimsA = $a.shape.slice(0, -2);
	    var outerDimsB = $b.shape.slice(0, -2);
	    var batchDimA = util.sizeFromShape(outerDimsA);
	    var batchDimB = util.sizeFromShape(outerDimsB);
	    util.assert($a.rank >= 2 && $b.rank >= 2 && $a.rank === $b.rank, function () {
	        return "Error in fused matMul: inputs must have the same rank of at least " +
	            ("2, got ranks " + $a.rank + " and " + $b.rank + ".");
	    });
	    util.assert(util.arraysEqual(outerDimsA, outerDimsB), function () { return "Error in fused matMul: outer dimensions (" + outerDimsA + ") and (" +
	        (outerDimsB + ") of Tensors with shapes " + $a.shape + " and ") +
	        ($b.shape + " must match."); });
	    util.assert(innerShapeA === innerShapeB, function () { return "Error in fused matMul: inner shapes (" + innerShapeA + ") and (" +
	        (innerShapeB + ") of Tensors with shapes " + $a.shape + " and ") +
	        ($b.shape + " and transposeA=" + transposeA) +
	        (" and transposeB=" + transposeB + " must match."); });
	    var outShape = $a.shape.slice(0, -2).concat([outerShapeA, outerShapeB]);
	    var a3D = transposeA ? $a.as3D(batchDimA, innerShapeA, outerShapeA) :
	        $a.as3D(batchDimA, outerShapeA, innerShapeA);
	    var b3D = transposeB ? $b.as3D(batchDimB, outerShapeB, innerShapeB) :
	        $b.as3D(batchDimB, innerShapeB, outerShapeB);
	    var $bias;
	    if (bias != null) {
	        $bias = tensor_util_env_1.convertToTensor(bias, 'bias', 'fused matMul');
	        $bias = tensor_util_1.makeTypesMatch($bias, $a)[0];
	        broadcast_util.assertAndGetBroadcastShape(outShape, $bias.shape);
	    }
	    var $preluActivationWeights;
	    if (preluActivationWeights != null) {
	        $preluActivationWeights = tensor_util_env_1.convertToTensor(preluActivationWeights, 'prelu weights', 'fused matMul');
	    }
	    var grad = function (dy, saved) {
	        var a3D = saved[0], b3D = saved[1], y = saved[2];
	        var dyActivation = getFusedDyActivation(dy, y, activation);
	        var biasGradient = {};
	        if (bias != null) {
	            biasGradient = { bias: function () { return getFusedBiasGradient($bias, dyActivation); } };
	        }
	        if (!transposeA && !transposeB) {
	            return Object.assign({
	                a: function () { return dyActivation.matMul(b3D, false, true); },
	                b: function () { return a3D.matMul(dyActivation, true, false); }
	            }, biasGradient);
	        }
	        else if (!transposeA && transposeB) {
	            return Object.assign({
	                a: function () { return dyActivation.matMul(b3D, false, false); },
	                b: function () { return dyActivation.matMul(a3D, true, false); }
	            }, biasGradient);
	        }
	        else if (transposeA && !transposeB) {
	            return Object.assign({
	                a: function () { return b3D.matMul(dyActivation, false, true); },
	                b: function () { return a3D.matMul(dyActivation, false, false); }
	            }, biasGradient);
	        }
	        else {
	            return Object.assign({
	                a: function () { return b3D.matMul(dyActivation, true, true); },
	                b: function () { return dyActivation.matMul(a3D, true, true); }
	            }, biasGradient);
	        }
	    };
	    var inputs = { a: a3D, b: b3D };
	    if (bias != null) {
	        inputs.bias = $bias;
	    }
	    if (preluActivationWeights != null) {
	        inputs.preluActivationWeights = $preluActivationWeights;
	    }
	    var inputsToSave = [a3D, b3D];
	    var outputsToSave = [true];
	    var res = engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var y = backend.fusedBatchMatMul({
	            a: a3D,
	            b: b3D,
	            transposeA: transposeA,
	            transposeB: transposeB,
	            bias: $bias,
	            activation: activation,
	            preluActivationWeights: $preluActivationWeights
	        });
	        save([a3D, b3D, y]);
	        return y;
	    }, inputs, grad, '_FusedMatMul', { transposeA: transposeA, transposeB: transposeB, activation: activation }, inputsToSave, outputsToSave);
	    return res.reshape(outShape);
	}
	/**
	 * Computes a 2D convolution over the input x, optionally fused with adding a
	 * bias and applying an activation.
	 *
	 * ```js
	 * const inputDepth = 2;
	 * const inShape = [2, 2, 2, inputDepth];
	 * const outputDepth = 2;
	 * const fSize = 1;
	 * const pad = 0;
	 * const strides = 1;
	 *
	 * const x = tf.tensor4d( [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
	 * 16], inShape);
	 * const w = tf.tensor4d([-1, 1, -2, 0.5], [fSize, fSize, inputDepth,
	 * outputDepth]);
	 *
	 * tf.fused.conv2d({ x, filter: w, strides, pad, dataFormat: 'NHWC',
	 * dilations: [1, 1], bias: tf.scalar(5), activation: 'relu' }).print();
	 * ```
	 *
	 * @param obj An object with the following properties:
	 * @param x The input tensor, of rank 4 or rank 3, of shape
	 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
	 * assumed.
	 * @param filter The filter, rank 4, of shape
	 *     `[filterHeight, filterWidth, inDepth, outDepth]`.
	 * @param strides The strides of the convolution: `[strideHeight,
	 * strideWidth]`.
	 * @param pad The type of padding algorithm.
	 *   - `same` and stride 1: output will be of same size as input,
	 *       regardless of filter size.
	 *   - `valid` output will be smaller than input if filter is larger
	 *       than 1x1.
	 *   - For more info, see this guide:
	 *     [https://www.tensorflow.org/api_guides/python/nn#Convolution](
	 *          https://www.tensorflow.org/api_guides/python/nn#Convolution)
	 * @param dataFormat An optional string from: "NHWC", "NCHW". Defaults to
	 *     "NHWC". Specify the data format of the input and output data. With the
	 *     default format "NHWC", the data is stored in the order of: [batch,
	 *     height, width, channels]. Only "NHWC" is currently supported.
	 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
	 *     in which we sample input values across the height and width dimensions
	 *     in atrous convolution. Defaults to `[1, 1]`. If `dilations` is a single
	 *     number, then `dilationHeight == dilationWidth`. If it is greater than
	 *     1, then all values of `strides` must be 1.
	 * @param dimRoundingMode The rounding mode used when computing output
	 *     dimensions if pad is a number. If none is provided, it will not round
	 *     and error if the output is of fractional size.
	 * @param bias Tensor to be added to the result.
	 * @param activation Name of activation kernel (defaults to `linear`) to be
	 *     applied
	 *      after biasAdd.
	 * @param preluActivationWeights Tensor of prelu weights to be applied as part
	 *     of a `prelu` activation, typically the same shape as `x`.
	 */
	function fusedConv2d_(_a) {
	    var x = _a.x, filter = _a.filter, strides = _a.strides, pad = _a.pad, _b = _a.dataFormat, dataFormat = _b === void 0 ? 'NHWC' : _b, _c = _a.dilations, dilations = _c === void 0 ? [1, 1] : _c, dimRoundingMode = _a.dimRoundingMode, bias = _a.bias, _d = _a.activation, activation = _d === void 0 ? 'linear' : _d, preluActivationWeights = _a.preluActivationWeights;
	    activation = activation || 'linear';
	    if (fused_util_1.shouldFuse(engine_1.ENGINE.state.gradientDepth, activation) === false) {
	        var result = conv_2.conv2d(x, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
	        if (bias != null) {
	            result = binary_ops_1.add(result, bias);
	        }
	        return applyActivation(result, activation, preluActivationWeights);
	    }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'conv2d');
	    var $filter = tensor_util_env_1.convertToTensor(filter, 'filter', 'conv2d');
	    var x4D = $x;
	    var reshapedTo4D = false;
	    if ($x.rank === 3) {
	        reshapedTo4D = true;
	        x4D = $x.as4D(1, $x.shape[0], $x.shape[1], $x.shape[2]);
	    }
	    util.assert(x4D.rank === 4, function () { return "Error in fused conv2d: input must be rank 4, but got rank " +
	        (x4D.rank + "."); });
	    util.assert($filter.rank === 4, function () { return "Error in fused conv2d: filter must be rank 4, but got rank " +
	        ($filter.rank + "."); });
	    if (dimRoundingMode != null) {
	        util.assert(util.isInt(pad), function () { return "Error in fused conv2d: pad must be an integer when using, " +
	            ("dimRoundingMode " + dimRoundingMode + " but got pad " + pad + "."); });
	    }
	    util.assert(x4D.shape[3] === $filter.shape[2], function () { return "Error in conv2d: depth of input (" + x4D.shape[3] + ") must match " +
	        ("input depth for filter " + $filter.shape[2] + "."); });
	    util.assert(conv_util.eitherStridesOrDilationsAreOne(strides, dilations), function () { return 'Error in conv2D: Either strides or dilations must be 1. ' +
	        ("Got strides " + strides + " and dilations '" + dilations + "'"); });
	    util.assert(dataFormat === 'NHWC', function () { return "Error in conv2d: got dataFormat of " + dataFormat + " but only NHWC is currently supported."; });
	    var convInfo = conv_util.computeConv2DInfo(x4D.shape, $filter.shape, strides, dilations, pad, dimRoundingMode);
	    var $bias;
	    if (bias != null) {
	        $bias = tensor_util_env_1.convertToTensor(bias, 'bias', 'fused conv2d');
	        $bias = tensor_util_1.makeTypesMatch($bias, $x)[0];
	        broadcast_util.assertAndGetBroadcastShape(convInfo.outShape, $bias.shape);
	    }
	    var $preluActivationWeights;
	    if (preluActivationWeights != null) {
	        $preluActivationWeights = tensor_util_env_1.convertToTensor(preluActivationWeights, 'prelu weights', 'fused conv2d');
	    }
	    var grad = function (dy, saved) {
	        var _a = saved, $filter = _a[0], x4D = _a[1], y = _a[2];
	        var dyActivation = getFusedDyActivation(dy, y, activation);
	        util.assert(conv_util.tupleValuesAreOne(dilations), function () { return 'Error in gradient of fused conv2D: ' +
	            "dilation rates greater than 1 " +
	            ("are not yet supported in gradients. Got dilations '" + dilations + "'"); });
	        var biasGradient = {};
	        if (bias != null) {
	            biasGradient = { bias: function () { return getFusedBiasGradient($bias, dyActivation); } };
	        }
	        return Object.assign({
	            x: function () {
	                return conv_1.conv2dDerInput(x4D.shape, dyActivation, $filter, strides, pad);
	            },
	            filter: function () {
	                return conv_1.conv2dDerFilter(x4D, dyActivation, $filter.shape, strides, pad);
	            }
	        }, biasGradient);
	    };
	    var inputs = { x: x4D, filter: $filter };
	    if (bias != null) {
	        inputs.bias = $bias;
	    }
	    if (preluActivationWeights != null) {
	        inputs.preluActivationWeights = $preluActivationWeights;
	    }
	    var inputsToSave = [$filter, x4D];
	    var outputsToSave = [true]; // Save the only output.
	    var res = engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.fusedConv2d({
	            input: x4D,
	            filter: $filter,
	            convInfo: convInfo,
	            bias: $bias,
	            activation: activation,
	            preluActivationWeights: $preluActivationWeights
	        });
	        save([$filter, x4D, res]);
	        return res;
	    }, inputs, grad, 'FusedConv2D', { convInfo: convInfo, activation: activation }, inputsToSave, outputsToSave);
	    if (reshapedTo4D) {
	        return res.as3D(res.shape[1], res.shape[2], res.shape[3]);
	    }
	    return res;
	}
	/**
	 * Computes depthwise 2D convolution, optionally fused with adding a
	 * bias and applying an activation.
	 *
	 * Given a 4D `input` array and a `filter` array of shape
	 * `[filterHeight, filterWidth, inChannels, channelMultiplier]` containing
	 * `inChannels` convolutional filters of depth 1, this op applies a
	 * different filter to each input channel (expanding from 1 channel to
	 * `channelMultiplier` channels for each), then concatenates the results
	 * together. The output has `inChannels * channelMultiplier` channels.
	 *
	 * See
	 * [https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d](
	 *     https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d)
	 * for more details.
	 *
	 * @param obj An object with the following properties:
	 * @param x The input tensor, of rank 4 or rank 3, of shape
	 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
	 * assumed.
	 * @param filter The filter tensor, rank 4, of shape
	 *     `[filterHeight, filterWidth, inChannels, channelMultiplier]`.
	 * @param strides The strides of the convolution: `[strideHeight,
	 * strideWidth]`. If strides is a single number, then `strideHeight ==
	 * strideWidth`.
	 * @param pad The type of padding algorithm.
	 *   - `same` and stride 1: output will be of same size as input,
	 *       regardless of filter size.
	 *   - `valid`: output will be smaller than input if filter is larger
	 *       than 1x1.
	 *   - For more info, see this guide:
	 *     [https://www.tensorflow.org/api_guides/python/nn#Convolution](
	 *          https://www.tensorflow.org/api_guides/python/nn#Convolution)
	 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
	 *     in which we sample input values across the height and width dimensions
	 *     in atrous convolution. Defaults to `[1, 1]`. If `rate` is a single
	 *     number, then `dilationHeight == dilationWidth`. If it is greater than
	 *     1, then all values of `strides` must be 1.
	 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
	 *     "NHWC". Specify the data format of the input and output data. With the
	 *     default format "NHWC", the data is stored in the order of: [batch,
	 *     height, width, channels]. Only "NHWC" is currently supported.
	 * @param dimRoundingMode The rounding mode used when computing output
	 *     dimensions if pad is a number. If none is provided, it will not round
	 *     and error if the output is of fractional size.
	 * @param bias Tensor to be added to the result.
	 * @param activation Name of activation kernel (defaults to `linear`).
	 * @param preluActivationWeights Tensor of prelu weights to be applied as part
	 *     of a `prelu` activation, typically the same shape as `x`.
	 */
	function fusedDepthwiseConv2d_(_a) {
	    var x = _a.x, filter = _a.filter, strides = _a.strides, pad = _a.pad, _b = _a.dataFormat, dataFormat = _b === void 0 ? 'NHWC' : _b, _c = _a.dilations, dilations = _c === void 0 ? [1, 1] : _c, dimRoundingMode = _a.dimRoundingMode, bias = _a.bias, _d = _a.activation, activation = _d === void 0 ? 'linear' : _d, preluActivationWeights = _a.preluActivationWeights;
	    if (fused_util_1.shouldFuse(engine_1.ENGINE.state.gradientDepth, activation) === false) {
	        var result = conv_2.depthwiseConv2d(x, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
	        if (bias != null) {
	            result = binary_ops_1.add(result, bias);
	        }
	        return applyActivation(result, activation, preluActivationWeights);
	    }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'depthwiseConv2d');
	    var $filter = tensor_util_env_1.convertToTensor(filter, 'filter', 'depthwiseConv2d');
	    var x4D = $x;
	    var reshapedTo4D = false;
	    if ($x.rank === 3) {
	        reshapedTo4D = true;
	        x4D = $x.as4D(1, $x.shape[0], $x.shape[1], $x.shape[2]);
	    }
	    util.assert(x4D.rank === 4, function () { return "Error in fused depthwiseConv2d: input must be rank 4, but got " +
	        ("rank " + x4D.rank + "."); });
	    util.assert($filter.rank === 4, function () { return "Error in fused depthwiseConv2d: filter must be rank 4, " +
	        ("but got rank " + $filter.rank + "."); });
	    util.assert(x4D.shape[3] === $filter.shape[2], function () { return "Error in fused depthwiseConv2d: number of input channels " +
	        ("(" + x4D.shape[3] + ") must match the inChannels dimension in ") +
	        ("filter " + $filter.shape[2] + "."); });
	    if (dilations == null) {
	        dilations = [1, 1];
	    }
	    util.assert(conv_util.eitherStridesOrDilationsAreOne(strides, dilations), function () {
	        return 'Error in fused depthwiseConv2d: Either strides or dilations must ' +
	            ("be 1. Got strides " + strides + " and dilations '" + dilations + "'");
	    });
	    if (dimRoundingMode != null) {
	        util.assert(util.isInt(pad), function () { return "Error in fused depthwiseConv2d: pad must be an integer when " +
	            ("using dimRoundingMode " + dimRoundingMode + " but got pad " + pad + "."); });
	    }
	    var convInfo = conv_util.computeConv2DInfo(x4D.shape, $filter.shape, strides, dilations, pad, dimRoundingMode, true /* depthwise */);
	    var $bias;
	    if (bias != null) {
	        $bias = tensor_util_env_1.convertToTensor(bias, 'bias', 'fused conv2d');
	        $bias = tensor_util_1.makeTypesMatch($bias, $x)[0];
	        broadcast_util.assertAndGetBroadcastShape(convInfo.outShape, $bias.shape);
	    }
	    var $preluActivationWeights;
	    if (preluActivationWeights != null) {
	        $preluActivationWeights = tensor_util_env_1.convertToTensor(preluActivationWeights, 'prelu weights', 'fused depthwiseConv2d');
	    }
	    var grad = function (dy, saved) {
	        util.assert(conv_util.tupleValuesAreOne(dilations), function () { return 'Error in gradient of fused depthwiseConv2d: dilation rates ' +
	            "greater than 1 are not yet supported. Got dilations " +
	            ("'" + dilations + "'"); });
	        var $filter = saved[0], x4D = saved[1], y = saved[2];
	        var dyActivation = getFusedDyActivation(dy, y, activation);
	        var biasGradient = {};
	        if (bias != null) {
	            biasGradient = { bias: function () { return getFusedBiasGradient($bias, dyActivation); } };
	        }
	        return Object.assign({
	            x: function () { return conv_1.depthwiseConv2dDerInput(x4D.shape, dyActivation, $filter, convInfo); },
	            filter: function () { return conv_1.depthwiseConv2dDerFilter(x4D, dyActivation, $filter.shape, convInfo); },
	        }, biasGradient);
	    };
	    var inputs = { x: x4D, filter: $filter };
	    if (bias != null) {
	        inputs.bias = $bias;
	    }
	    if (preluActivationWeights != null) {
	        inputs.preluActivationWeights = $preluActivationWeights;
	    }
	    var inputsToSave = [$filter, x4D];
	    var outputsToSave = [true];
	    var res = engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var res = backend.fusedDepthwiseConv2D({
	            input: x4D,
	            filter: $filter,
	            convInfo: convInfo,
	            bias: $bias,
	            activation: activation,
	            preluActivationWeights: $preluActivationWeights
	        });
	        save([$filter, x4D, res]);
	        return res;
	    }, inputs, grad, 'FusedDepthwiseConv2D', { convInfo: convInfo, activation: activation }, inputsToSave, outputsToSave);
	    if (reshapedTo4D) {
	        return res.as3D(res.shape[1], res.shape[2], res.shape[3]);
	    }
	    return res;
	}
	exports.matMul = operation_1.op({ fusedMatMul_: fusedMatMul_ });
	exports.conv2d = operation_1.op({ fusedConv2d_: fusedConv2d_ });
	exports.depthwiseConv2d = operation_1.op({ fusedDepthwiseConv2d_: fusedDepthwiseConv2d_ });
	//# sourceMappingURL=fused_ops.js.map

/***/ },
/* 1055 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// Whether we should call fused ops.
	exports.shouldFuse = function (gradientDepth, activation) {
	    var gradientMode = gradientDepth > 0;
	    return !gradientMode || activation === 'linear';
	};
	//# sourceMappingURL=fused_util.js.map

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var engine_1 = __webpack_require__(15);
	var tensor_util_env_1 = __webpack_require__(17);
	var operation_1 = __webpack_require__(18);
	/**
	 * Gather slices from input tensor into a Tensor with shape specified by
	 * `indices`.
	 *
	 * `indices` is an K-dimensional integer tensor, best thought of as a
	 * (K-1)-dimensional tensor of indices into input, where each element defines a
	 * slice of input:
	 * output[\\(i_0, ..., i_{K-2}\\)] = input[indices[\\(i_0, ..., i_{K-2}\\)]]
	 *
	 * Whereas in `tf.gather`, `indices` defines slices into the first dimension of
	 * input, in `tf.gatherND`, `indices` defines slices into the first N dimensions
	 * of input, where N = indices.shape[-1].
	 *
	 * The last dimension of indices can be at most the rank of input:
	 * indices.shape[-1] <= input.rank
	 *
	 * The last dimension of `indices` corresponds to elements
	 * (if indices.shape[-1] == input.rank) or slices
	 * (if indices.shape[-1] < input.rank) along dimension indices.shape[-1] of
	 * input.
	 * The output tensor has shape
	 * indices.shape[:-1] + input.shape[indices.shape[-1]:]
	 *
	 * Note that on CPU, if an out of bound index is found, an error is returned. On
	 * GPU, if an out of bound index is found, a 0 is stored in the corresponding
	 * output value.
	 *
	 * ```js
	 * const indices = tf.tensor2d([0, 1, 1, 0], [2,2], 'int32');
	 * const input = tf.tensor2d([9, 10, 11, 12], [2, 2]);
	 * tf.gatherND(input, indices).print() // [10, 11]
	 * ```
	 *
	 * @param x The tensor from which to gather values.
	 * @param indices Index tensor, must be of type int32.
	 */
	/** @doc {heading: 'Operations', subheading: 'Slicing and Joining'} */
	function gatherND_(x, indices) {
	    var $indices = tensor_util_env_1.convertToTensor(indices, 'indices', 'gatherND', 'int32');
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'gatherND');
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.gatherND($x, $indices); }, { x: $x, indices: $indices }, null /* backward */, 'GatherNd');
	}
	exports.gatherND = operation_1.op({ gatherND_: gatherND_ });
	//# sourceMappingURL=gather_nd.js.map

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var non_max_suppression_impl_1 = __webpack_require__(188);
	var engine_1 = __webpack_require__(15);
	var tensor_util_env_1 = __webpack_require__(17);
	var util = __webpack_require__(10);
	var operation_1 = __webpack_require__(18);
	/**
	 * Bilinear resize a batch of 3D images to a new shape.
	 *
	 * @param images The images, of rank 4 or rank 3, of shape
	 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
	 * @param size The new shape `[newHeight, newWidth]` to resize the
	 *     images to. Each channel is resized individually.
	 * @param alignCorners Defaults to False. If true, rescale
	 *     input by `(new_height - 1) / (height - 1)`, which exactly aligns the 4
	 *     corners of images and resized images. If false, rescale by
	 *     `new_height / height`. Treat similarly the width dimension.
	 */
	/** @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'} */
	function resizeBilinear_(images, size, alignCorners) {
	    if (alignCorners === void 0) { alignCorners = false; }
	    var $images = tensor_util_env_1.convertToTensor(images, 'images', 'resizeBilinear');
	    util.assert($images.rank === 3 || $images.rank === 4, function () { return "Error in resizeBilinear: x must be rank 3 or 4, but got " +
	        ("rank " + $images.rank + "."); });
	    util.assert(size.length === 2, function () { return "Error in resizeBilinear: new shape must 2D, but got shape " +
	        (size + "."); });
	    var batchImages = $images;
	    var reshapedTo4D = false;
	    if ($images.rank === 3) {
	        reshapedTo4D = true;
	        batchImages =
	            $images.as4D(1, $images.shape[0], $images.shape[1], $images.shape[2]);
	    }
	    var newHeight = size[0], newWidth = size[1];
	    var forward = function (backend, save) {
	        save([batchImages]);
	        return backend.resizeBilinear(batchImages, newHeight, newWidth, alignCorners);
	    };
	    var backward = function (dy, saved) {
	        return {
	            x: function () { return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.resizeBilinearBackprop(dy, saved[0], alignCorners); }, {}); }
	        };
	    };
	    var res = engine_1.ENGINE.runKernelFunc(forward, { x: batchImages }, backward, 'ResizeBilinear', { alignCorners: alignCorners, newHeight: newHeight, newWidth: newWidth });
	    if (reshapedTo4D) {
	        return res.as3D(res.shape[1], res.shape[2], res.shape[3]);
	    }
	    return res;
	}
	/**
	 * NearestNeighbor resize a batch of 3D images to a new shape.
	 *
	 * @param images The images, of rank 4 or rank 3, of shape
	 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
	 * @param size The new shape `[newHeight, newWidth]` to resize the
	 *     images to. Each channel is resized individually.
	 * @param alignCorners Defaults to False. If true, rescale
	 *     input by `(new_height - 1) / (height - 1)`, which exactly aligns the 4
	 *     corners of images and resized images. If false, rescale by
	 *     `new_height / height`. Treat similarly the width dimension.
	 */
	/** @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'} */
	function resizeNearestNeighbor_(images, size, alignCorners) {
	    if (alignCorners === void 0) { alignCorners = false; }
	    var $images = tensor_util_env_1.convertToTensor(images, 'images', 'resizeNearestNeighbor');
	    util.assert($images.rank === 3 || $images.rank === 4, function () { return "Error in resizeNearestNeighbor: x must be rank 3 or 4, but got " +
	        ("rank " + $images.rank + "."); });
	    util.assert(size.length === 2, function () {
	        return "Error in resizeNearestNeighbor: new shape must 2D, but got shape " +
	            (size + ".");
	    });
	    util.assert($images.dtype === 'float32' || $images.dtype === 'int32', function () { return '`images` must have `int32` or `float32` as dtype'; });
	    var batchImages = $images;
	    var reshapedTo4D = false;
	    if ($images.rank === 3) {
	        reshapedTo4D = true;
	        batchImages =
	            $images.as4D(1, $images.shape[0], $images.shape[1], $images.shape[2]);
	    }
	    var newHeight = size[0], newWidth = size[1];
	    var forward = function (backend, save) {
	        save([batchImages]);
	        return backend.resizeNearestNeighbor(batchImages, newHeight, newWidth, alignCorners);
	    };
	    var backward = function (dy, saved) {
	        return {
	            batchImages: function () { return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.resizeNearestNeighborBackprop(dy, saved[0], alignCorners); }, {}); }
	        };
	    };
	    var res = engine_1.ENGINE.runKernelFunc(forward, { batchImages: batchImages }, backward);
	    if (reshapedTo4D) {
	        return res.as3D(res.shape[1], res.shape[2], res.shape[3]);
	    }
	    return res;
	}
	/**
	 * Performs non maximum suppression of bounding boxes based on
	 * iou (intersection over union).
	 *
	 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
	 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
	 *     the bounding box.
	 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
	 * @param maxOutputSize The maximum number of boxes to be selected.
	 * @param iouThreshold A float representing the threshold for deciding whether
	 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
	 *     Defaults to 0.5 (50% box overlap).
	 * @param scoreThreshold A threshold for deciding when to remove boxes based
	 *     on score. Defaults to -inf, which means any score is accepted.
	 * @return A 1D tensor with the selected box indices.
	 */
	/** @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'} */
	function nonMaxSuppression_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold) {
	    if (iouThreshold === void 0) { iouThreshold = 0.5; }
	    if (scoreThreshold === void 0) { scoreThreshold = Number.NEGATIVE_INFINITY; }
	    var $boxes = tensor_util_env_1.convertToTensor(boxes, 'boxes', 'nonMaxSuppression');
	    var $scores = tensor_util_env_1.convertToTensor(scores, 'scores', 'nonMaxSuppression');
	    var inputs = nonMaxSuppSanityCheck($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold);
	    maxOutputSize = inputs.maxOutputSize;
	    iouThreshold = inputs.iouThreshold;
	    scoreThreshold = inputs.scoreThreshold;
	    var attrs = { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold };
	    return engine_1.ENGINE.runKernelFunc(function (b) { return b.nonMaxSuppression($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold); }, { boxes: $boxes, scores: $scores }, null /* grad */, 'NonMaxSuppressionV3', attrs);
	}
	/** This is the async version of `nonMaxSuppression` */
	function nonMaxSuppressionAsync_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold) {
	    if (iouThreshold === void 0) { iouThreshold = 0.5; }
	    if (scoreThreshold === void 0) { scoreThreshold = Number.NEGATIVE_INFINITY; }
	    return __awaiter(this, void 0, void 0, function () {
	        var $boxes, $scores, inputs, boxesAndScores, boxesVals, scoresVals, res;
	        return __generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    $boxes = tensor_util_env_1.convertToTensor(boxes, 'boxes', 'nonMaxSuppressionAsync');
	                    $scores = tensor_util_env_1.convertToTensor(scores, 'scores', 'nonMaxSuppressionAsync');
	                    inputs = nonMaxSuppSanityCheck($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold);
	                    maxOutputSize = inputs.maxOutputSize;
	                    iouThreshold = inputs.iouThreshold;
	                    scoreThreshold = inputs.scoreThreshold;
	                    return [4 /*yield*/, Promise.all([$boxes.data(), $scores.data()])];
	                case 1:
	                    boxesAndScores = _a.sent();
	                    boxesVals = boxesAndScores[0];
	                    scoresVals = boxesAndScores[1];
	                    res = non_max_suppression_impl_1.nonMaxSuppressionV3(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold);
	                    if ($boxes !== boxes) {
	                        $boxes.dispose();
	                    }
	                    if ($scores !== scores) {
	                        $scores.dispose();
	                    }
	                    return [2 /*return*/, res];
	            }
	        });
	    });
	}
	/**
	 * Performs non maximum suppression of bounding boxes based on
	 * iou (intersection over union).
	 *
	 * This op also supports a Soft-NMS mode (c.f.
	 * Bodla et al, https://arxiv.org/abs/1704.04503) where boxes reduce the score
	 * of other overlapping boxes, therefore favoring different regions of the image
	 * with high scores. To enable this Soft-NMS mode, set the `softNmsSigma`
	 * parameter to be larger than 0.
	 *
	 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
	 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
	 *     the bounding box.
	 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
	 * @param maxOutputSize The maximum number of boxes to be selected.
	 * @param iouThreshold A float representing the threshold for deciding whether
	 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
	 *     Defaults to 0.5 (50% box overlap).
	 * @param scoreThreshold A threshold for deciding when to remove boxes based
	 *     on score. Defaults to -inf, which means any score is accepted.
	 * @param softNmsSigma A float representing the sigma parameter for Soft NMS.
	 *     When sigma is 0, it falls back to nonMaxSuppression.
	 * @return A map with the following properties:
	 *     - selectedIndices: A 1D tensor with the selected box indices.
	 *     - selectedScores: A 1D tensor with the corresponding scores for each
	 *       selected box.
	 */
	/** @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'} */
	function nonMaxSuppressionWithScore_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma) {
	    if (iouThreshold === void 0) { iouThreshold = 0.5; }
	    if (scoreThreshold === void 0) { scoreThreshold = Number.NEGATIVE_INFINITY; }
	    if (softNmsSigma === void 0) { softNmsSigma = 0.0; }
	    var $boxes = tensor_util_env_1.convertToTensor(boxes, 'boxes', 'nonMaxSuppression');
	    var $scores = tensor_util_env_1.convertToTensor(scores, 'scores', 'nonMaxSuppression');
	    var inputs = nonMaxSuppSanityCheck($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
	    maxOutputSize = inputs.maxOutputSize;
	    iouThreshold = inputs.iouThreshold;
	    scoreThreshold = inputs.scoreThreshold;
	    softNmsSigma = inputs.softNmsSigma;
	    var attrs = { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, softNmsSigma: softNmsSigma };
	    var result = engine_1.ENGINE.runKernel('NonMaxSuppressionV5', { boxes: $boxes, scores: $scores }, attrs);
	    return { selectedIndices: result[0], selectedScores: result[1] };
	}
	/** This is the async version of `nonMaxSuppressionWithScore` */
	function nonMaxSuppressionWithScoreAsync_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma) {
	    if (iouThreshold === void 0) { iouThreshold = 0.5; }
	    if (scoreThreshold === void 0) { scoreThreshold = Number.NEGATIVE_INFINITY; }
	    if (softNmsSigma === void 0) { softNmsSigma = 0.0; }
	    return __awaiter(this, void 0, void 0, function () {
	        var $boxes, $scores, inputs, boxesAndScores, boxesVals, scoresVals, res;
	        return __generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    $boxes = tensor_util_env_1.convertToTensor(boxes, 'boxes', 'nonMaxSuppressionAsync');
	                    $scores = tensor_util_env_1.convertToTensor(scores, 'scores', 'nonMaxSuppressionAsync');
	                    inputs = nonMaxSuppSanityCheck($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
	                    maxOutputSize = inputs.maxOutputSize;
	                    iouThreshold = inputs.iouThreshold;
	                    scoreThreshold = inputs.scoreThreshold;
	                    softNmsSigma = inputs.softNmsSigma;
	                    return [4 /*yield*/, Promise.all([$boxes.data(), $scores.data()])];
	                case 1:
	                    boxesAndScores = _a.sent();
	                    boxesVals = boxesAndScores[0];
	                    scoresVals = boxesAndScores[1];
	                    res = non_max_suppression_impl_1.nonMaxSuppressionV5(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
	                    if ($boxes !== boxes) {
	                        $boxes.dispose();
	                    }
	                    if ($scores !== scores) {
	                        $scores.dispose();
	                    }
	                    return [2 /*return*/, res];
	            }
	        });
	    });
	}
	function nonMaxSuppSanityCheck(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma) {
	    if (iouThreshold == null) {
	        iouThreshold = 0.5;
	    }
	    if (scoreThreshold == null) {
	        scoreThreshold = Number.NEGATIVE_INFINITY;
	    }
	    if (softNmsSigma == null) {
	        softNmsSigma = 0.0;
	    }
	    var numBoxes = boxes.shape[0];
	    maxOutputSize = Math.min(maxOutputSize, numBoxes);
	    util.assert(0 <= iouThreshold && iouThreshold <= 1, function () { return "iouThreshold must be in [0, 1], but was '" + iouThreshold + "'"; });
	    util.assert(boxes.rank === 2, function () { return "boxes must be a 2D tensor, but was of rank '" + boxes.rank + "'"; });
	    util.assert(boxes.shape[1] === 4, function () {
	        return "boxes must have 4 columns, but 2nd dimension was " + boxes.shape[1];
	    });
	    util.assert(scores.rank === 1, function () { return 'scores must be a 1D tensor'; });
	    util.assert(scores.shape[0] === numBoxes, function () { return "scores has incompatible shape with boxes. Expected " + numBoxes + ", " +
	        ("but was " + scores.shape[0]); });
	    util.assert(0 <= softNmsSigma && softNmsSigma <= 1, function () { return "softNmsSigma must be in [0, 1], but was '" + softNmsSigma + "'"; });
	    return { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, softNmsSigma: softNmsSigma };
	}
	/**
	 * Extracts crops from the input image tensor and resizes them using bilinear
	 * sampling or nearest neighbor sampling (possibly with aspect ratio change)
	 * to a common output size specified by crop_size.
	 *
	 * @param image 4d tensor of shape `[batch,imageHeight,imageWidth, depth]`,
	 *     where imageHeight and imageWidth must be positive, specifying the
	 *     batch of images from which to take crops
	 * @param boxes 2d float32 tensor of shape `[numBoxes, 4]`. Each entry is
	 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the normalized
	 *     coordinates of the box in the boxInd[i]'th image in the batch
	 * @param boxInd 1d int32 tensor of shape `[numBoxes]` with values in range
	 *     `[0, batch)` that specifies the image that the `i`-th box refers to.
	 * @param cropSize 1d int32 tensor of 2 elements `[cropHeigh, cropWidth]`
	 *     specifying the size to which all crops are resized to.
	 * @param method Optional string from `'bilinear' | 'nearest'`,
	 *     defaults to bilinear, which specifies the sampling method for resizing
	 * @param extrapolationValue A threshold for deciding when to remove boxes based
	 *     on score. Defaults to 0.
	 * @return A 4D tensor of the shape `[numBoxes,cropHeight,cropWidth,depth]`
	 */
	/** @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'} */
	function cropAndResize_(image, boxes, boxInd, cropSize, method, extrapolationValue) {
	    var $image = tensor_util_env_1.convertToTensor(image, 'image', 'cropAndResize');
	    var $boxes = tensor_util_env_1.convertToTensor(boxes, 'boxes', 'cropAndResize', 'float32');
	    var $boxInd = tensor_util_env_1.convertToTensor(boxInd, 'boxInd', 'cropAndResize', 'int32');
	    method = method || 'bilinear';
	    extrapolationValue = extrapolationValue || 0;
	    var numBoxes = $boxes.shape[0];
	    util.assert($image.rank === 4, function () { return 'Error in cropAndResize: image must be rank 4,' +
	        ("but got rank " + $image.rank + "."); });
	    util.assert($boxes.rank === 2 && $boxes.shape[1] === 4, function () { return "Error in cropAndResize: boxes must be have size [" + numBoxes + ",4] " +
	        ("but had shape " + $boxes.shape + "."); });
	    util.assert($boxInd.rank === 1 && $boxInd.shape[0] === numBoxes, function () { return "Error in cropAndResize: boxInd must be have size [" + numBoxes + "] " +
	        ("but had shape " + $boxes.shape + "."); });
	    util.assert(cropSize.length === 2, function () { return "Error in cropAndResize: cropSize must be of length 2, but got " +
	        ("length " + cropSize.length + "."); });
	    util.assert(cropSize[0] >= 1 && cropSize[1] >= 1, function () { return "cropSize must be atleast [1,1], but was " + cropSize; });
	    util.assert(method === 'bilinear' || method === 'nearest', function () { return "method must be bilinear or nearest, but was " + method; });
	    var forward = function (backend, save) {
	        return backend.cropAndResize($image, $boxes, $boxInd, cropSize, method, extrapolationValue);
	    };
	    var res = engine_1.ENGINE.runKernelFunc(forward, { images: $image, boxes: $boxes, boxInd: $boxInd }, null /* der */, 'CropAndResize', { method: method, extrapolationValue: extrapolationValue, cropSize: cropSize });
	    return res;
	}
	exports.resizeBilinear = operation_1.op({ resizeBilinear_: resizeBilinear_ });
	exports.resizeNearestNeighbor = operation_1.op({ resizeNearestNeighbor_: resizeNearestNeighbor_ });
	exports.nonMaxSuppression = operation_1.op({ nonMaxSuppression_: nonMaxSuppression_ });
	exports.nonMaxSuppressionAsync = nonMaxSuppressionAsync_;
	exports.nonMaxSuppressionWithScore = operation_1.op({ nonMaxSuppressionWithScore_: nonMaxSuppressionWithScore_ });
	exports.nonMaxSuppressionWithScoreAsync = nonMaxSuppressionWithScoreAsync_;
	exports.cropAndResize = operation_1.op({ cropAndResize_: cropAndResize_ });
	//# sourceMappingURL=image_ops.js.map

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var tensor_util_env_1 = __webpack_require__(17);
	var util_1 = __webpack_require__(10);
	var tensor_ops_1 = __webpack_require__(31);
	/**
	 * Returns whether the targets are in the top K predictions.
	 *
	 * ```js
	 * const predictions = tf.tensor2d([[20, 10, 40, 30], [30, 50, -20, 10]]);
	 * const targets = tf.tensor1d([2, 0]);
	 * const precision = await tf.inTopKAsync(predictions, targets);
	 * precision.print();
	 * ```
	 * @param predictions 2-D or higher `tf.Tensor` with last dimension being
	 *     at least `k`.
	 * @param targets 1-D or higher `tf.Tensor`.
	 * @param k Optional Number of top elements to look at for computing precision,
	 *     default to 1.
	 */
	/** @doc {heading: 'Operations', subheading: 'Evaluation'} */
	function inTopKAsync_(predictions, targets, k) {
	    if (k === void 0) { k = 1; }
	    return __awaiter(this, void 0, void 0, function () {
	        var $predictions, $targets, lastDim, predictionsVals, targetsVals, _a, batch, size, precision, b, offset, vals, valAndInd, i, i;
	        return __generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    $predictions = tensor_util_env_1.convertToTensor(predictions, 'predictions', 'inTopK');
	                    $targets = tensor_util_env_1.convertToTensor(targets, 'targets', 'inTopK');
	                    util_1.assert($predictions.rank > 1, function () { return 'inTopK() expects the predictions to be of rank 2 or higher, ' +
	                        ("but got " + $predictions.rank); });
	                    util_1.assert($predictions.rank - 1 === $targets.rank, function () { return "predictions rank should be 1 larger than " +
	                        "targets rank, but got predictions rank " +
	                        ($predictions.rank + " and targets rank " + $targets.rank); });
	                    util_1.assertShapesMatch($predictions.shape.slice(0, $predictions.shape.length - 1), $targets.shape, "predictions's shape should be align with the targets' shape, " +
	                        'except the last dimension.');
	                    lastDim = $predictions.shape[$predictions.shape.length - 1];
	                    util_1.assert(k > 0 && k <= lastDim, function () { return "'k' passed to inTopK() must be > 0 && <= the predictions last " +
	                        ("dimension (" + lastDim + "), but got " + k); });
	                    return [4 /*yield*/, $predictions.data()];
	                case 1:
	                    predictionsVals = _b.sent();
	                    return [4 /*yield*/, $targets.data()];
	                case 2:
	                    targetsVals = _b.sent();
	                    _a = [predictionsVals.length / lastDim, lastDim], batch = _a[0], size = _a[1];
	                    precision = util_1.getTypedArrayFromDType('bool', batch);
	                    for (b = 0; b < batch; b++) {
	                        offset = b * size;
	                        vals = predictionsVals.subarray(offset, offset + size);
	                        valAndInd = [];
	                        for (i = 0; i < vals.length; i++) {
	                            valAndInd.push({ value: vals[i], index: i });
	                        }
	                        valAndInd.sort(function (a, b) { return b.value - a.value; });
	                        precision[b] = 0;
	                        for (i = 0; i < k; i++) {
	                            if (valAndInd[i].index === targetsVals[b]) {
	                                precision[b] = 1;
	                                break;
	                            }
	                        }
	                    }
	                    if (predictions !== $predictions) {
	                        $predictions.dispose();
	                    }
	                    if (targets !== $targets) {
	                        $targets.dispose();
	                    }
	                    // Output precision has the same shape as targets.
	                    return [2 /*return*/, tensor_ops_1.tensor(precision, $targets.shape, 'bool')];
	            }
	        });
	    });
	}
	exports.inTopKAsync = inTopKAsync_;
	//# sourceMappingURL=in_top_k.js.map

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Linear algebra ops.
	 */
	var engine_1 = __webpack_require__(15);
	var globals_1 = __webpack_require__(73);
	var tensor_util_env_1 = __webpack_require__(17);
	var util_1 = __webpack_require__(10);
	var array_ops_1 = __webpack_require__(89);
	var binary_ops_1 = __webpack_require__(109);
	var concat_split_1 = __webpack_require__(237);
	var logical_ops_1 = __webpack_require__(154);
	var norm_1 = __webpack_require__(491);
	var operation_1 = __webpack_require__(18);
	var reduction_ops_1 = __webpack_require__(492);
	var tensor_ops_1 = __webpack_require__(31);
	/**
	 * Copy a tensor setting everything outside a central band in each innermost
	 * matrix to zero.
	 *
	 * The band part is computed as follows: Assume input has `k` dimensions
	 * `[I, J, K, ..., M, N]`, then the output is a tensor with the same shape where
	 * `band[i, j, k, ..., m, n] = in_band(m, n) * input[i, j, k, ..., m, n]`.
	 * The indicator function
	 * `in_band(m, n) = (num_lower < 0 || (m-n) <= num_lower))`
	 * `&& (num_upper < 0 || (n-m) <= num_upper)`
	 *
	 * ```js
	 * const x = tf.tensor2d([[ 0,  1,  2, 3],
	 *                        [-1,  0,  1, 2],
	 *                        [-2, -1,  0, 1],
	 *                        [-3, -2, -1, 0]]);
	 * let y = tf.linalg.bandPart(x, 1, -1);
	 * y.print(); // [[ 0,  1,  2, 3],
	 *            //  [-1,  0,  1, 2],
	 *            //  [ 0, -1,  0, 1],
	 *            //  [ 0, 0 , -1, 0]]
	 * let z = tf.linalg.bandPart(x, 2, 1);
	 * z.print(); // [[ 0,  1,  0, 0],
	 *            //  [-1,  0,  1, 0],
	 *            //  [-2, -1,  0, 1],
	 *            //  [ 0, -2, -1, 0]]
	 * ```
	 *
	 * @param x Rank `k` tensor
	 * @param numLower Number of subdiagonals to keep.
	 *   If negative, keep entire lower triangle.
	 * @param numUpper Number of subdiagonals to keep.
	 *   If negative, keep entire upper triangle.
	 * @returns Rank `k` tensor of the same shape as input.
	 *   The extracted banded tensor.
	 */
	/**
	 * @doc {heading:'Operations',
	 *       subheading:'Linear Algebra',
	 *       namespace:'linalg'}
	 */
	function bandPart_(a, numLower, numUpper) {
	    if (numLower % 1 !== 0) {
	        throw new Error("bandPart(): numLower must be an integer, got " + numLower + ".");
	    }
	    if (numUpper % 1 !== 0) {
	        throw new Error("bandPart(): numUpper must be an integer, got " + numUpper + ".");
	    }
	    var $a = tensor_util_env_1.convertToTensor(a, 'a', 'bandPart');
	    if ($a.rank < 2) {
	        throw new Error("bandPart(): Rank must be at least 2, got " + $a.rank + ".");
	    }
	    var shape = $a.shape, _a = $a.shape.slice(-2), M = _a[0], N = _a[1];
	    if (!(numLower <= M)) {
	        throw new Error("bandPart(): numLower (" + numLower + ")" +
	            (" must not be greater than the number of rows (" + M + ")."));
	    }
	    if (!(numUpper <= N)) {
	        throw new Error("bandPart(): numUpper (" + numUpper + ")" +
	            (" must not be greater than the number of columns (" + N + ")."));
	    }
	    if (numLower < 0) {
	        numLower = M;
	    }
	    if (numUpper < 0) {
	        numUpper = N;
	    }
	    var i = tensor_ops_1.range(0, M, 1, 'int32').reshape([-1, 1]), j = tensor_ops_1.range(0, N, 1, 'int32'), ij = binary_ops_1.sub(i, j);
	    var inBand = logical_ops_1.logicalAnd(ij.lessEqual(tensor_ops_1.scalar(+numLower, 'int32')), ij.greaterEqual(tensor_ops_1.scalar(-numUpper, 'int32')));
	    var zero = tensor_ops_1.zeros([M, N], $a.dtype);
	    return array_ops_1.stack(array_ops_1.unstack($a.reshape([-1, M, N])).map(function (mat) { return logical_ops_1.where(inBand, mat, zero); })).reshape(shape);
	}
	/**
	 * Gram-Schmidt orthogonalization.
	 *
	 * ```js
	 * const x = tf.tensor2d([[1, 2], [3, 4]]);
	 * let y = tf.linalg.gramSchmidt(x);
	 * y.print();
	 * console.log('Othogonalized:');
	 * y.dot(y.transpose()).print();  // should be nearly the identity matrix.
	 * console.log('First row direction maintained:');
	 * const data = await y.array();
	 * console.log(data[0][1] / data[0][0]);  // should be nearly 2.
	 * ```
	 *
	 * @param xs The vectors to be orthogonalized, in one of the two following
	 *   formats:
	 *   - An Array of `tf.Tensor1D`.
	 *   - A `tf.Tensor2D`, i.e., a matrix, in which case the vectors are the rows
	 *     of `xs`.
	 *   In each case, all the vectors must have the same length and the length
	 *   must be greater than or equal to the number of vectors.
	 * @returns The orthogonalized and normalized vectors or matrix.
	 *   Orthogonalization means that the vectors or the rows of the matrix
	 *   are orthogonal (zero inner products). Normalization means that each
	 *   vector or each row of the matrix has an L2 norm that equals `1`.
	 */
	/**
	 * @doc {heading:'Operations',
	 *       subheading:'Linear Algebra',
	 *       namespace:'linalg'}
	 */
	function gramSchmidt_(xs) {
	    var inputIsTensor2D;
	    if (Array.isArray(xs)) {
	        inputIsTensor2D = false;
	        util_1.assert(xs != null && xs.length > 0, function () { return 'Gram-Schmidt process: input must not be null, undefined, or ' +
	            'empty'; });
	        var dim_1 = xs[0].shape[0];
	        var _loop_1 = function (i) {
	            util_1.assert(xs[i].shape[0] === dim_1, function () {
	                return 'Gram-Schmidt: Non-unique lengths found in the input vectors: ' +
	                    ("(" + xs[i].shape[0] + " vs. " + dim_1 + ")");
	            });
	        };
	        for (var i = 1; i < xs.length; ++i) {
	            _loop_1(i);
	        }
	    }
	    else {
	        inputIsTensor2D = true;
	        xs = concat_split_1.split(xs, xs.shape[0], 0).map(function (x) { return array_ops_1.squeeze(x, [0]); });
	    }
	    util_1.assert(xs.length <= xs[0].shape[0], function () { return "Gram-Schmidt: Number of vectors (" + xs.length + ") exceeds " +
	        ("number of dimensions (" + xs[0].shape[0] + ")."); });
	    var ys = [];
	    var xs1d = xs;
	    var _loop_2 = function (i) {
	        ys.push(engine_1.ENGINE.tidy(function () {
	            var x = xs1d[i];
	            if (i > 0) {
	                for (var j = 0; j < i; ++j) {
	                    var proj = reduction_ops_1.sum(ys[j].mulStrict(x)).mul(ys[j]);
	                    x = x.sub(proj);
	                }
	            }
	            return x.div(norm_1.norm(x, 'euclidean'));
	        }));
	    };
	    for (var i = 0; i < xs.length; ++i) {
	        _loop_2(i);
	    }
	    if (inputIsTensor2D) {
	        return array_ops_1.stack(ys, 0);
	    }
	    else {
	        return ys;
	    }
	}
	/**
	 * Compute QR decomposition of m-by-n matrix using Householder transformation.
	 *
	 * Implementation based on
	 *   [http://www.cs.cornell.edu/~bindel/class/cs6210-f09/lec18.pdf]
	 * (http://www.cs.cornell.edu/~bindel/class/cs6210-f09/lec18.pdf)
	 *
	 * ```js
	 * const a = tf.tensor2d([[1, 2], [3, 4]]);
	 * let [q, r] = tf.linalg.qr(a);
	 * console.log('Q');
	 * q.print();
	 * console.log('R');
	 * r.print();
	 * console.log('Orthogonalized');
	 * q.dot(q.transpose()).print()  // should be nearly the identity matrix.
	 * console.log('Reconstructed');
	 * q.dot(r).print(); // should be nearly [[1, 2], [3, 4]];
	 * ```
	 *
	 * @param x The `tf.Tensor` to be QR-decomposed. Must have rank >= 2. Suppose
	 *   it has the shape `[..., M, N]`.
	 * @param fullMatrices An optional boolean parameter. Defaults to `false`.
	 *   If `true`, compute full-sized `Q`. If `false` (the default),
	 *   compute only the leading N columns of `Q` and `R`.
	 * @returns An `Array` of two `tf.Tensor`s: `[Q, R]`. `Q` is a unitary matrix,
	 *   i.e., its columns all have unit norm and are mutually orthogonal.
	 *   If `M >= N`,
	 *     If `fullMatrices` is `false` (default),
	 *       - `Q` has a shape of `[..., M, N]`,
	 *       - `R` has a shape of `[..., N, N]`.
	 *     If `fullMatrices` is `true` (default),
	 *       - `Q` has a shape of `[..., M, M]`,
	 *       - `R` has a shape of `[..., M, N]`.
	 *   If `M < N`,
	 *     - `Q` has a shape of `[..., M, M]`,
	 *     - `R` has a shape of `[..., M, N]`.
	 * @throws If the rank of `x` is less than 2.
	 */
	/**
	 * @doc {heading:'Operations',
	 *       subheading:'Linear Algebra',
	 *       namespace:'linalg'}
	 */
	function qr_(x, fullMatrices) {
	    if (fullMatrices === void 0) { fullMatrices = false; }
	    if (x.rank < 2) {
	        throw new Error("qr() requires input tensor to have a rank >= 2, but got rank " + x.rank);
	    }
	    else if (x.rank === 2) {
	        return qr2d(x, fullMatrices);
	    }
	    else {
	        // Rank > 2.
	        // TODO(cais): Below we split the input into individual 2D tensors,
	        //   perform QR decomposition on them and then stack the results back
	        //   together. We should explore whether this can be parallelized.
	        var outerDimsProd = x.shape.slice(0, x.shape.length - 2)
	            .reduce(function (value, prev) { return value * prev; });
	        var x2ds = array_ops_1.unstack(x.reshape([
	            outerDimsProd, x.shape[x.shape.length - 2],
	            x.shape[x.shape.length - 1]
	        ]), 0);
	        var q2ds_1 = [];
	        var r2ds_1 = [];
	        x2ds.forEach(function (x2d) {
	            var _a = qr2d(x2d, fullMatrices), q2d = _a[0], r2d = _a[1];
	            q2ds_1.push(q2d);
	            r2ds_1.push(r2d);
	        });
	        var q = array_ops_1.stack(q2ds_1, 0).reshape(x.shape);
	        var r = array_ops_1.stack(r2ds_1, 0).reshape(x.shape);
	        return [q, r];
	    }
	}
	function qr2d(x, fullMatrices) {
	    if (fullMatrices === void 0) { fullMatrices = false; }
	    return engine_1.ENGINE.tidy(function () {
	        if (x.shape.length !== 2) {
	            throw new Error("qr2d() requires a 2D Tensor, but got a " + x.shape.length + "D Tensor.");
	        }
	        var m = x.shape[0];
	        var n = x.shape[1];
	        var q = array_ops_1.eye(m); // Orthogonal transform so far.
	        var r = x.clone(); // Transformed matrix so far.
	        var one2D = tensor_ops_1.tensor2d([[1]], [1, 1]);
	        var w = one2D.clone();
	        var iters = m >= n ? n : m;
	        var _loop_3 = function (j) {
	            var _a;
	            // This tidy within the for-loop ensures we clean up temporary
	            // tensors as soon as they are no longer needed.
	            var rTemp = r;
	            var wTemp = w;
	            var qTemp = q;
	            _a = engine_1.ENGINE.tidy(function () {
	                // Find H = I - tau * w * w', to put zeros below R(j, j).
	                var rjEnd1 = r.slice([j, j], [m - j, 1]);
	                var normX = rjEnd1.norm();
	                var rjj = r.slice([j, j], [1, 1]);
	                // The sign() function returns 0 on 0, which causes division by zero.
	                var s = tensor_ops_1.tensor2d([[-1]]).where(rjj.greater(0), tensor_ops_1.tensor2d([[1]]));
	                var u1 = rjj.sub(s.mul(normX));
	                var wPre = rjEnd1.div(u1);
	                if (wPre.shape[0] === 1) {
	                    w = one2D.clone();
	                }
	                else {
	                    w = one2D.concat(wPre.slice([1, 0], [wPre.shape[0] - 1, wPre.shape[1]]), 0);
	                }
	                var tau = s.matMul(u1).div(normX).neg();
	                // -- R := HR, Q := QH.
	                var rjEndAll = r.slice([j, 0], [m - j, n]);
	                var tauTimesW = tau.mul(w);
	                if (j === 0) {
	                    r = rjEndAll.sub(tauTimesW.matMul(w.transpose().matMul(rjEndAll)));
	                }
	                else {
	                    var rTimesTau = rjEndAll.sub(tauTimesW.matMul(w.transpose().matMul(rjEndAll)));
	                    r = r.slice([0, 0], [j, n]).concat(rTimesTau, 0);
	                }
	                var qAllJEnd = q.slice([0, j], [m, q.shape[1] - j]);
	                if (j === 0) {
	                    q = qAllJEnd.sub(qAllJEnd.matMul(w).matMul(tauTimesW.transpose()));
	                }
	                else {
	                    var qTimesTau = qAllJEnd.sub(qAllJEnd.matMul(w).matMul(tauTimesW.transpose()));
	                    q = q.slice([0, 0], [m, j]).concat(qTimesTau, 1);
	                }
	                return [w, r, q];
	            }), w = _a[0], r = _a[1], q = _a[2];
	            globals_1.dispose([rTemp, wTemp, qTemp]);
	        };
	        for (var j = 0; j < iters; ++j) {
	            _loop_3(j);
	        }
	        if (!fullMatrices && m > n) {
	            q = q.slice([0, 0], [m, n]);
	            r = r.slice([0, 0], [n, n]);
	        }
	        return [q, r];
	    });
	}
	exports.bandPart = operation_1.op({ bandPart_: bandPart_ });
	exports.gramSchmidt = operation_1.op({ gramSchmidt_: gramSchmidt_ });
	exports.qr = operation_1.op({ qr_: qr_ });
	//# sourceMappingURL=linalg_ops.js.map

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_util_env_1 = __webpack_require__(17);
	var util = __webpack_require__(10);
	var operation_1 = __webpack_require__(18);
	/**
	 * Normalizes the activation of a local neighborhood across or within
	 * channels.
	 *
	 * @param x The input tensor. The 4-D input tensor is treated as a 3-D array
	 *     of 1D vectors (along the last dimension), and each vector is
	 *     normalized independently.
	 * @param depthRadius The number of adjacent channels in the 1D normalization
	 *     window.
	 * @param bias A constant bias term for the basis.
	 * @param alpha A scale factor, usually positive.
	 * @param beta An exponent.
	 */
	/** @doc {heading: 'Operations', subheading: 'Normalization'} */
	function localResponseNormalization_(x, depthRadius, bias, alpha, beta) {
	    if (depthRadius === void 0) { depthRadius = 5; }
	    if (bias === void 0) { bias = 1; }
	    if (alpha === void 0) { alpha = 1; }
	    if (beta === void 0) { beta = 0.5; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'localResponseNormalization');
	    util.assert($x.rank === 4 || $x.rank === 3, function () { return "Error in localResponseNormalization: x must be rank 3 or 4 but got\n               rank " + $x.rank + "."; });
	    util.assert(util.isInt(depthRadius), function () { return "Error in localResponseNormalization: depthRadius must be an " +
	        ("integer but got depthRadius " + depthRadius + "."); });
	    var x4D = $x;
	    var reshapedTo4D = false;
	    if ($x.rank === 3) {
	        reshapedTo4D = true;
	        x4D = $x.as4D(1, $x.shape[0], $x.shape[1], $x.shape[2]);
	    }
	    var backward = function (dy, saved) {
	        var x4D = saved[0], y = saved[1];
	        return {
	            x4D: function () { return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.LRNGrad(dy, x4D, y, depthRadius, bias, alpha, beta); }, {}); }
	        };
	    };
	    var res = engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var y = backend.localResponseNormalization4D(x4D, depthRadius, bias, alpha, beta);
	        save([x4D, y]);
	        return y;
	    }, { x4D: x4D }, backward);
	    if (reshapedTo4D) {
	        return res.as3D(res.shape[1], res.shape[2], res.shape[3]);
	    }
	    else {
	        return res;
	    }
	}
	exports.localResponseNormalization = operation_1.op({ localResponseNormalization_: localResponseNormalization_ });
	//# sourceMappingURL=lrn.js.map

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tensor_util_env_1 = __webpack_require__(17);
	var operation_1 = __webpack_require__(18);
	/**
	 * Computes the next states and outputs of a stack of LSTMCells.
	 *
	 * Each cell output is used as input to the next cell.
	 *
	 * Returns `[cellState, cellOutput]`.
	 *
	 * Derived from tf.contrib.rn.MultiRNNCell.
	 *
	 * @param lstmCells Array of LSTMCell functions.
	 * @param data The input to the cell.
	 * @param c Array of previous cell states.
	 * @param h Array of previous cell outputs.
	 */
	/** @doc {heading: 'Operations', subheading: 'RNN'} */
	function multiRNNCell_(lstmCells, data, c, h) {
	    var $data = tensor_util_env_1.convertToTensor(data, 'data', 'multiRNNCell');
	    var $c = tensor_util_env_1.convertToTensorArray(c, 'c', 'multiRNNCell');
	    var $h = tensor_util_env_1.convertToTensorArray(h, 'h', 'multiRNNCell');
	    var input = $data;
	    var newStates = [];
	    for (var i = 0; i < lstmCells.length; i++) {
	        var output = lstmCells[i](input, $c[i], $h[i]);
	        newStates.push(output[0]);
	        newStates.push(output[1]);
	        input = output[1];
	    }
	    var newC = [];
	    var newH = [];
	    for (var i = 0; i < newStates.length; i += 2) {
	        newC.push(newStates[i]);
	        newH.push(newStates[i + 1]);
	    }
	    return [newC, newH];
	}
	/**
	 * Computes the next state and output of a BasicLSTMCell.
	 *
	 * Returns `[newC, newH]`.
	 *
	 * Derived from tf.contrib.rnn.BasicLSTMCell.
	 *
	 * @param forgetBias Forget bias for the cell.
	 * @param lstmKernel The weights for the cell.
	 * @param lstmBias The bias for the cell.
	 * @param data The input to the cell.
	 * @param c Previous cell state.
	 * @param h Previous cell output.
	 */
	/** @doc {heading: 'Operations', subheading: 'RNN'} */
	function basicLSTMCell_(forgetBias, lstmKernel, lstmBias, data, c, h) {
	    var $forgetBias = tensor_util_env_1.convertToTensor(forgetBias, 'forgetBias', 'basicLSTMCell');
	    var $lstmKernel = tensor_util_env_1.convertToTensor(lstmKernel, 'lstmKernel', 'basicLSTMCell');
	    var $lstmBias = tensor_util_env_1.convertToTensor(lstmBias, 'lstmBias', 'basicLSTMCell');
	    var $data = tensor_util_env_1.convertToTensor(data, 'data', 'basicLSTMCell');
	    var $c = tensor_util_env_1.convertToTensor(c, 'c', 'basicLSTMCell');
	    var $h = tensor_util_env_1.convertToTensor(h, 'h', 'basicLSTMCell');
	    var combined = $data.concat($h, 1);
	    var weighted = combined.matMul($lstmKernel);
	    var res = weighted.add($lstmBias);
	    // i = input_gate, j = new_input, f = forget_gate, o = output_gate
	    var batchSize = res.shape[0];
	    var sliceCols = res.shape[1] / 4;
	    var sliceSize = [batchSize, sliceCols];
	    var i = res.slice([0, 0], sliceSize);
	    var j = res.slice([0, sliceCols], sliceSize);
	    var f = res.slice([0, sliceCols * 2], sliceSize);
	    var o = res.slice([0, sliceCols * 3], sliceSize);
	    var newC = i.sigmoid().mulStrict(j.tanh()).addStrict($c.mulStrict($forgetBias.add(f).sigmoid()));
	    var newH = newC.tanh().mulStrict(o.sigmoid());
	    return [newC, newH];
	}
	exports.basicLSTMCell = operation_1.op({ basicLSTMCell_: basicLSTMCell_ });
	exports.multiRNNCell = operation_1.op({ multiRNNCell_: multiRNNCell_ });
	//# sourceMappingURL=lstm.js.map

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tensor_util_1 = __webpack_require__(111);
	var tensor_util_env_1 = __webpack_require__(17);
	var util = __webpack_require__(10);
	var binary_ops_1 = __webpack_require__(109);
	var operation_1 = __webpack_require__(18);
	var tensor_ops_1 = __webpack_require__(31);
	/**
	 * Compute the moving average of a variable.
	 *
	 * Without zeroDebias, the moving average operation is defined by:
	 *   `v += delta`
	 * where
	 *   `delta = (1 - decay) * (x - v)`
	 *
	 * With zeroDebias (default), the `delta` term is scaled to debias the
	 * effect of the (assumed) zero-initialization of `v`.
	 *   `delta /= (1 - decay ^ step)`
	 *
	 * For more details on the zero-debiasing algorithm, see:
	 *   https://arxiv.org/abs/1412.6980
	 *
	 * Note that this function is completely stateless and does not keep track of
	 * step count. The step count needs to be maintained by the caller and passed
	 * in as `step`.
	 *
	 * @param v The current moving average value.
	 * @param x New input value, must have the same shape and dtype as `v`.
	 * @param decay The decay factor. Typical values are 0.95 and 0.99.
	 * @param step Step count.
	 * @param zeroDebias: Whether zeroDebias is to be performed (default: `true`).
	 * @returns The new moving average value.
	 */
	/** @doc {heading: 'Operations', subheading: 'Moving Average'} */
	function movingAverage_(v, x, decay, step, zeroDebias) {
	    if (zeroDebias === void 0) { zeroDebias = true; }
	    var $v = tensor_util_env_1.convertToTensor(v, 'v', 'movingAverage');
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'movingAverage');
	    var $decay = tensor_util_env_1.convertToTensor(decay, 'decay', 'movingAverage');
	    tensor_util_1.assertTypesMatch($v, $x);
	    util.assert(util.arraysEqual($v.shape, $x.shape), function () { return 'Shape mismatch in v and x'; });
	    var one = tensor_ops_1.scalar(1);
	    var oneMinusDecay = one.sub($decay);
	    var update = $x.sub($v).mul(oneMinusDecay);
	    if (zeroDebias) {
	        util.assert(step != null, function () { return 'When using zeroDebias: true, step is required.'; });
	        var $step = tensor_util_env_1.convertToTensor(step, 'step', 'movingAverage');
	        update = update.div(one.sub(binary_ops_1.pow($decay, $step)));
	    }
	    return $v.add(update);
	}
	exports.movingAverage = operation_1.op({ movingAverage_: movingAverage_ });
	//# sourceMappingURL=moving_average.js.map

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_util_env_1 = __webpack_require__(17);
	var util = __webpack_require__(10);
	var array_ops_1 = __webpack_require__(89);
	var conv_util = __webpack_require__(238);
	var operation_1 = __webpack_require__(18);
	/**
	 * Computes the 2D max pooling of an image.
	 *
	 * @param x The input tensor, of rank 4 or rank 3 of shape
	 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
	 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
	 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
	 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
	 *     `strides` is a single number, then `strideHeight == strideWidth`.
	 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
	 *     in which we sample input values across the height and width dimensions
	 *     in dilated pooling. Defaults to `[1, 1]`. If `dilations` is a single
	 *     number, then `dilationHeight == dilationWidth`. If it is greater than
	 *     1, then all values of `strides` must be 1.
	 * @param pad The type of padding algorithm.
	 *    - `same` and stride 1: output will be of same size as input,
	 *       regardless of filter size.
	 *    - `valid`: output will be smaller than input if filter is larger
	 *       than 1x1.
	 *    - For more info, see this guide:
	 *     [https://www.tensorflow.org/api_guides/python/nn#Convolution](
	 *          https://www.tensorflow.org/api_guides/python/nn#Convolution)
	 * @param dimRoundingMode The rounding mode used when computing output
	 *     dimensions if pad is a number. If none is provided, it will not round
	 *     and error if the output is of fractional size.
	 */
	function maxPoolImpl_(x, filterSize, strides, dilations, pad, dimRoundingMode) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'maxPool');
	    var x4D = $x;
	    var reshapedTo4D = false;
	    if ($x.rank === 3) {
	        reshapedTo4D = true;
	        x4D = $x.as4D(1, $x.shape[0], $x.shape[1], $x.shape[2]);
	    }
	    if (dilations == null) {
	        dilations = [1, 1];
	    }
	    util.assert(x4D.rank === 4, function () { return "Error in maxPool: input must be rank 4 but got rank " + x4D.rank + "."; });
	    util.assert(conv_util.eitherStridesOrDilationsAreOne(strides, dilations), function () { return 'Error in maxPool: Either strides or dilations must be 1. ' +
	        ("Got strides " + strides + " and dilations '" + dilations + "'"); });
	    if (dimRoundingMode != null) {
	        util.assert(util.isInt(pad), function () { return "Error in maxPool: pad must be an integer when using, " +
	            ("dimRoundingMode " + dimRoundingMode + " but got pad " + pad + "."); });
	    }
	    var convInfo = conv_util.computePool2DInfo(x4D.shape, filterSize, strides, dilations, pad, dimRoundingMode);
	    if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 &&
	        util.arraysEqual(convInfo.inShape, convInfo.outShape)) {
	        return $x.clone();
	    }
	    var grad = function (dy, saved) {
	        var x4D = saved[0], y = saved[1];
	        return {
	            x: function () { return maxPoolBackprop(dy, x4D, y, filterSize, strides, dilations, pad); }
	        };
	    };
	    var inputsToSave = [x4D];
	    var res = engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var y = backend.maxPool(x4D, convInfo);
	        save([x4D, y]);
	        return y;
	    }, { x: x4D }, grad, 'MaxPool', convInfo, inputsToSave);
	    if (reshapedTo4D) {
	        return res.as3D(res.shape[1], res.shape[2], res.shape[3]);
	    }
	    return res;
	}
	/**
	 * Computes the 2D max pooling of an image.
	 *
	 * @param x The input tensor, of rank 4 or rank 3 of shape
	 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
	 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
	 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
	 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
	 *     `strides` is a single number, then `strideHeight == strideWidth`.
	 * @param pad The type of padding algorithm.
	 *    - `same` and stride 1: output will be of same size as input,
	 *       regardless of filter size.
	 *    - `valid`: output will be smaller than input if filter is larger
	 *       than 1x1.
	 *    - For more info, see this guide:
	 *     [https://www.tensorflow.org/api_guides/python/nn#Convolution](
	 *          https://www.tensorflow.org/api_guides/python/nn#Convolution)
	 * @param dimRoundingMode The rounding mode used when computing output
	 *     dimensions if pad is a number. If none is provided, it will not round
	 *     and error if the output is of fractional size.
	 */
	/** @doc {heading: 'Operations', subheading: 'Convolution'} */
	function maxPool_(x, filterSize, strides, pad, dimRoundingMode) {
	    return maxPoolImpl_(x, filterSize, strides, 1, pad, dimRoundingMode);
	}
	/**
	 * Computes the 2D average pooling of an image.
	 *
	 * @param x The input tensor, of rank 4 or rank 3 of shape
	 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
	 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
	 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
	 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
	 *     `strides` is a single number, then `strideHeight == strideWidth`.
	 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
	 *     in which we sample input values across the height and width dimensions
	 *     in dilated pooling. Defaults to `[1, 1]`. If `dilations` is a single
	 *     number, then `dilationHeight == dilationWidth`. If it is greater than
	 *     1, then all values of `strides` must be 1.
	 * @param pad The type of padding algorithm:
	 *    - `same` and stride 1: output will be of same size as input,
	 *       regardless of filter size.
	 *    - `valid`: output will be smaller than input if filter is larger
	 *       than 1x1.
	 *    - For more info, see this guide:
	 *     [https://www.tensorflow.org/api_guides/python/nn#Convolution](
	 *         https://www.tensorflow.org/api_guides/python/nn#Convolution)
	 * @param dimRoundingMode The rounding mode used when computing output
	 *     dimensions if pad is a number. If none is provided, it will not round
	 *     and error if the output is of fractional size.
	 */
	function avgPoolImpl_(x, filterSize, strides, dilations, pad, dimRoundingMode) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'avgPool', 'float32');
	    if (dilations == null) {
	        dilations = [1, 1];
	    }
	    util.assert(conv_util.eitherStridesOrDilationsAreOne(strides, dilations), function () { return 'Error in avgPool: Either strides or dilations must be 1. ' +
	        ("Got strides " + strides + " and dilations '" + dilations + "'"); });
	    var x4D = $x;
	    var reshapedTo4D = false;
	    if ($x.rank === 3) {
	        reshapedTo4D = true;
	        x4D = $x.as4D(1, $x.shape[0], $x.shape[1], $x.shape[2]);
	    }
	    util.assert(x4D.rank === 4, function () { return "Error in avgPool: x must be rank 4 but got rank " + x4D.rank + "."; });
	    if (dimRoundingMode != null) {
	        util.assert(util.isInt(pad), function () { return "Error in avgPool: pad must be an integer when using, " +
	            ("dimRoundingMode " + dimRoundingMode + " but got pad " + pad + "."); });
	    }
	    var convInfo = conv_util.computePool2DInfo(x4D.shape, filterSize, strides, dilations, pad, dimRoundingMode);
	    if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 &&
	        util.arraysEqual(convInfo.inShape, convInfo.outShape)) {
	        return $x.clone();
	    }
	    var grad = function (dy) {
	        return {
	            x: function () { return avgPoolBackprop(dy, x4D, filterSize, strides, dilations, pad); }
	        };
	    };
	    var res = engine_1.ENGINE.runKernelFunc(function (backend) { return backend.avgPool(x4D, convInfo); }, { x: x4D }, grad, 'AvgPool', convInfo);
	    res = res.cast($x.dtype);
	    if (reshapedTo4D) {
	        return res.as3D(res.shape[1], res.shape[2], res.shape[3]);
	    }
	    return res;
	}
	/**
	 * Computes the 2D average pooling of an image.
	 *
	 * @param x The input tensor, of rank 4 or rank 3 of shape
	 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
	 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
	 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
	 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
	 *     `strides` is a single number, then `strideHeight == strideWidth`.
	 * @param pad The type of padding algorithm:
	 *    - `same` and stride 1: output will be of same size as input,
	 *       regardless of filter size.
	 *    - `valid`: output will be smaller than input if filter is larger
	 *       than 1x1.
	 *    - For more info, see this guide:
	 *     [https://www.tensorflow.org/api_guides/python/nn#Convolution](
	 *         https://www.tensorflow.org/api_guides/python/nn#Convolution)
	 * @param dimRoundingMode The rounding mode used when computing output
	 *     dimensions if pad is a number. If none is provided, it will not round
	 *     and error if the output is of fractional size.
	 */
	/** @doc {heading: 'Operations', subheading: 'Convolution'} */
	function avgPool_(x, filterSize, strides, pad, dimRoundingMode) {
	    return avgPoolImpl_(x, filterSize, strides, 1, pad, dimRoundingMode);
	}
	/**
	 * Performs an N-D pooling operation
	 *
	 * @param input The input tensor, of rank 4 or rank 3 of shape
	 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
	 * @param windowShape The filter size: `[filterHeight, filterWidth]`. If
	 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
	 * @param poolingType The type of pooling, either 'max' or 'avg'.
	 * @param pad The type of padding algorithm:
	 *    - `same` and stride 1: output will be of same size as input,
	 *       regardless of filter size.
	 *    - `valid`: output will be smaller than input if filter is larger
	 *       than 1x1.
	 *    - For more info, see this guide:
	 *     [https://www.tensorflow.org/api_guides/python/nn#Convolution](
	 *         https://www.tensorflow.org/api_guides/python/nn#Convolution)
	 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
	 *     in which we sample input values across the height and width dimensions
	 *     in dilated pooling. Defaults to `[1, 1]`. If `dilationRate` is a single
	 *     number, then `dilationHeight == dilationWidth`. If it is greater than
	 *     1, then all values of `strides` must be 1.
	 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
	 *     `strides` is a single number, then `strideHeight == strideWidth`.
	 */
	/** @doc {heading: 'Operations', subheading: 'Convolution'} */
	function pool_(input, windowShape, poolingType, pad, dilations, strides) {
	    if (dilations == null) {
	        dilations = [1, 1];
	    }
	    if (strides == null) {
	        strides = 1;
	    }
	    if (pad === 0) {
	        pad = 'valid';
	    }
	    var $x = tensor_util_env_1.convertToTensor(input, 'x', 'maxPool');
	    var x4D = $x;
	    var reshapedTo4D = false;
	    if ($x.rank === 3) {
	        reshapedTo4D = true;
	        x4D = $x.as4D(1, $x.shape[0], $x.shape[1], $x.shape[2]);
	    }
	    util.assert(conv_util.eitherStridesOrDilationsAreOne(strides, dilations), function () { return 'Error in pool: Either strides or dilations must be 1. ' +
	        ("Got strides " + strides + " and dilations '" + dilations + "'"); });
	    var convInfo = conv_util.computePool2DInfo(x4D.shape, windowShape, strides, dilations, pad);
	    var dilation = [convInfo.dilationHeight, convInfo.dilationWidth];
	    // The following implementation does batchToSpace(pool(spaceToBatch(x)))
	    // whenever dilation > 1 since the TF kernels do not support dilation > 1.
	    // tslint:disable-next-line:max-line-length
	    // https://github.com/tensorflow/tensorflow/blob/50f6bb67dc98c9b74630b6047aae7a4f8a40fd02/tensorflow/python/ops/nn_ops.py#L1037
	    var basePadding;
	    if (pad === 'same') {
	        basePadding = withSpaceToBatchBasePaddings([convInfo.filterHeight, convInfo.filterWidth], dilation);
	    }
	    else {
	        basePadding = [[0, 0], [0, 0]];
	    }
	    var isDilationOne = dilation[0] === 1 && dilation[1] === 1;
	    var _a = requiredSpaceToBatchPaddings([convInfo.inHeight, convInfo.inWidth], dilation, basePadding), adjustedPadding = _a[0], adjustedCrops = _a[1];
	    var convertedPad = isDilationOne ? pad : 'valid';
	    var convertedX = isDilationOne ? x4D : array_ops_1.spaceToBatchND(x4D, dilation, adjustedPadding);
	    var forwardOp = poolingType === 'avg' ?
	        function () { return avgPoolImpl_(convertedX, windowShape, strides, 1 /* dilation */, convertedPad); } :
	        function () { return maxPoolImpl_(convertedX, windowShape, strides, 1 /* dilation */, convertedPad); };
	    var y = forwardOp();
	    var res = isDilationOne ? y : array_ops_1.batchToSpaceND(y, dilation, adjustedCrops);
	    if (reshapedTo4D) {
	        return res.as3D(res.shape[1], res.shape[2], res.shape[3]);
	    }
	    return res;
	}
	/**
	 * Computes the backprop of a 2D max pool.
	 *
	 * @param dy The dy error, of rank 4 or rank 3 of shape
	 *     [batchSize, height, width, channels]. If rank 3, batch of 1 is
	 * assumed.
	 * @param input The original input image, of rank 4, of shape
	 *     [batchSize, height, width, channels].
	 * @param output The original output image, of rank 4, of shape
	 *     [batchSize, outHeight, outWidth, channels].
	 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
	 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
	 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
	 *     `strides` is a single number, then `strideHeight == strideWidth`.
	 * @param pad A string from: 'same', 'valid'. The type of padding algorithm
	 *     used in the forward prop of the op.
	 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. The
	 *     rounding mode used when computing output dimensions if pad is a
	 *     number. If none is provided, it will not round and error if the output
	 *     is of fractional size.
	 */
	function maxPoolBackprop(dy, input, output, filterSize, strides, dilations, pad, dimRoundingMode) {
	    var $dy = tensor_util_env_1.convertToTensor(dy, 'dy', 'maxPoolBackprop');
	    var $input = tensor_util_env_1.convertToTensor(input, 'input', 'maxPoolBackprop');
	    var $output = tensor_util_env_1.convertToTensor(output, 'output', 'maxPoolBackprop');
	    util.assert($input.rank === $dy.rank, function () { return "Rank of input (" + $input.rank + ") does not match rank of dy " +
	        ("(" + $dy.rank + ")"); });
	    if (dilations == null) {
	        dilations = [1, 1];
	    }
	    util.assert(conv_util.eitherStridesOrDilationsAreOne(strides, dilations), function () {
	        return 'Error in maxPoolBackProp: Either strides or dilations must be 1. ' +
	            ("Got strides " + strides + " and dilations '" + dilations + "'");
	    });
	    util.assert($dy.rank === 4, function () { return "Error in maxPoolBackprop: dy must be rank 4 but got rank " +
	        ($dy.rank + "."); });
	    util.assert($input.rank === 4, function () { return "Error in maxPoolBackprop: input must be rank 4 but got rank " +
	        ($input.rank + "."); });
	    if (dimRoundingMode != null) {
	        util.assert(util.isInt(pad), function () { return "Error in maxPoolBackprop: pad must be an integer when using, " +
	            ("dimRoundingMode " + dimRoundingMode + " but got pad " + pad + "."); });
	    }
	    var convInfo = conv_util.computePool2DInfo($input.shape, filterSize, strides, dilations, pad, dimRoundingMode);
	    var res = engine_1.ENGINE.runKernelFunc(function (backend) { return backend.maxPoolBackprop($dy, $input, $output, convInfo); }, { $dy: $dy, $input: $input });
	    return res;
	}
	/**
	 * Computes the backprop of an 2D avg pool.
	 *
	 * @param dy The dy error, of rank 4 or rank 3 of shape
	 *     [batchSize, height, width, channels]. If rank 3, batch of 1 is
	 * assumed.
	 * @param input The input image, of rank 4 or rank 3 of shape
	 *     [batchSize, height, width, channels]. If rank 3, batch of 1 is
	 * assumed.
	 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
	 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
	 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
	 *     `strides` is a single number, then `strideHeight == strideWidth`.
	 * @param pad A string from: 'same', 'valid'. The type of padding algorithm
	 *     used in the forward prop of the op.
	 */
	function avgPoolBackprop(dy, input, filterSize, strides, dilations, pad) {
	    var $dy = tensor_util_env_1.convertToTensor(dy, 'dy', 'avgPoolBackprop');
	    var $input = tensor_util_env_1.convertToTensor(input, 'input', 'avgPoolBackprop');
	    util.assert($input.rank === $dy.rank, function () { return "Rank of input (" + $input.rank + ") does not match rank of dy (" + $dy.rank + ")"; });
	    if (dilations == null) {
	        dilations = [1, 1];
	    }
	    util.assert(conv_util.eitherStridesOrDilationsAreOne(strides, dilations), function () {
	        return 'Error in avgPoolBackprop: Either strides or dilations must be 1. ' +
	            ("Got strides " + strides + " and dilations '" + dilations + "'");
	    });
	    var input4D = $input;
	    var dy4D = $dy;
	    var reshapedTo4D = false;
	    if ($input.rank === 3) {
	        reshapedTo4D = true;
	        input4D = $input.as4D(1, $input.shape[0], $input.shape[1], $input.shape[2]);
	        dy4D = $dy.as4D(1, $dy.shape[0], $dy.shape[1], $dy.shape[2]);
	    }
	    util.assert(dy4D.rank === 4, function () { return "Error in avgPoolBackprop: dy must be rank 4 but got rank " +
	        (dy4D.rank + "."); });
	    util.assert(input4D.rank === 4, function () { return "Error in avgPoolBackprop: input must be rank 4 but got rank " +
	        (input4D.rank + "."); });
	    var convInfo = conv_util.computePool2DInfo(input4D.shape, filterSize, strides, dilations, pad);
	    var res = engine_1.ENGINE.runKernelFunc(function (backend) { return backend.avgPoolBackprop(dy4D, input4D, convInfo); }, { dy4D: dy4D, input4D: input4D });
	    if (reshapedTo4D) {
	        return res.as3D(res.shape[1], res.shape[2], res.shape[3]);
	    }
	    return res;
	}
	// Helper function to compute crops and paddings for pool with dilation > 1.
	// tslint:disable-next-line:max-line-length
	// https://github.com/tensorflow/tensorflow/blob/50f6bb67dc98c9b74630b6047aae7a4f8a40fd02/tensorflow/python/ops/array_ops.py#L2184
	function requiredSpaceToBatchPaddings(inputShape, blockShape, basePadding) {
	    var padStart = basePadding.map(function (b) { return b[0]; });
	    var origPadEnd = basePadding.map(function (b) { return b[1]; });
	    var fullInputShape = inputShape.concat(padStart, origPadEnd);
	    var padEndExtra = blockShape.map(function (b, i) { return (b - fullInputShape[i] % b) % b; });
	    var padEnd = origPadEnd.map(function (s, i) { return s + padEndExtra[i]; });
	    var paddings = blockShape.map(function (_, i) { return [padStart[i], padEnd[i]]; });
	    var crops = blockShape.map(function (_, i) { return [0, padEndExtra[i]]; });
	    return [paddings, crops];
	}
	// Helper function to compute base paddings for pool with dilation > 1.
	// tslint:disable-next-line:max-line-length
	// https://github.com/tensorflow/tensorflow/blob/50f6bb67dc98c9b74630b6047aae7a4f8a40fd02/tensorflow/python/ops/nn_ops.py#L524
	function withSpaceToBatchBasePaddings(filterShape, dilation) {
	    // Spatial dimensions of the filters and the upsampled filters in which we
	    // introduce (rate - 1) zeros between consecutive filter values.
	    var dilatedFilterShape = filterShape.map(function (s, i) {
	        return s + (s - 1) * (dilation[i] - 1);
	    });
	    var padExtraShape = dilatedFilterShape.map(function (s) { return s - 1; });
	    // When padding is odd, we pad more at end, following the same
	    // convention as conv2d.
	    var padExtraStart = padExtraShape.map(function (s) { return Math.floor(s / 2); });
	    var padExtraEnd = padExtraShape.map(function (s, i) { return s - padExtraStart[i]; });
	    return padExtraShape.map(function (_, i) {
	        return [padExtraStart[i], padExtraEnd[i]];
	    });
	}
	/**
	 * Computes the 3D average pooling.
	 *
	 * ```js
	 * const x = tf.tensor5d([1, 2, 3, 4, 5, 6, 7, 8], [1, 2, 2, 2, 1]);
	 * const result = tf.avgPool3d(x, 2, 1, 'valid');
	 * result.print();
	 * ```
	 *
	 * @param x The input tensor, of rank 5 or rank 4 of shape
	 *     `[batch, depth, height, width, inChannels]`.
	 * @param filterSize The filter size:
	 *     `[filterDepth, filterHeight, filterWidth]`.
	 *     If `filterSize` is a single number,
	 *     then `filterDepth == filterHeight == filterWidth`.
	 * @param strides The strides of the pooling:
	 *     `[strideDepth, strideHeight, strideWidth]`.
	 *     If `strides` is a single number,
	 *     then `strideDepth == strideHeight == strideWidth`.
	 * @param pad The type of padding algorithm.
	 *    - `same` and stride 1: output will be of same size as input,
	 *       regardless of filter size.
	 *    - `valid`: output will be smaller than input if filter is larger
	 *       than 1*1x1.
	 *    - For more info, see this guide:
	 *     [https://www.tensorflow.org/api_guides/python/nn#Convolution](
	 *          https://www.tensorflow.org/api_guides/python/nn#Convolution)
	 * @param dimRoundingMode The rounding mode used when computing output
	 *     dimensions if pad is a number. If none is provided, it will not round
	 *     and error if the output is of fractional size.
	 * @param dataFormat An optional string from: "NDHWC", "NCDHW". Defaults to
	 *     "NDHWC". Specify the data format of the input and output data. With the
	 *     default format "NDHWC", the data is stored in the order of: [batch,
	 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
	 * @param dilations The dilation rates:
	 *     `[dilationDepth, dilationHeight, dilationWidth]`
	 *     in which we sample input values across the depth, height and width
	 *     dimensions in dilated pooling.
	 *     Defaults to `[1, 1, 1]`. If `dilations` is a single number,
	 *     then `dilationDepth == dilationHeight == dilationWidth`.
	 *     If it is greater than 1, then all values of `strides` must be 1.
	 */
	/** @doc {heading: 'Operations', subheading: 'Convolution'} */
	function avgPool3d_(x, filterSize, strides, pad, dimRoundingMode, dataFormat, dilations) {
	    if (dataFormat === void 0) { dataFormat = 'NDHWC'; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'avgPool3d', 'float32');
	    var x5D = $x;
	    var reshapedTo5D = false;
	    if ($x.rank === 4) {
	        reshapedTo5D = true;
	        x5D = $x.as5D(1, $x.shape[0], $x.shape[1], $x.shape[2], $x.shape[3]);
	    }
	    if (dilations == null) {
	        dilations = [1, 1, 1];
	    }
	    util.assert(x5D.rank === 5, function () { return "Error in avgPool3d: x must be rank 5 but got rank " + x5D.rank + "."; });
	    util.assert(dataFormat === 'NDHWC', function () { return "Error in avgPool3d: Only NDHWC is currently supported, " +
	        ("but got dataFormat of " + dataFormat); });
	    util.assert(conv_util.eitherStridesOrDilationsAreOne(strides, dilations), function () { return 'Error in avgPool3d: Either strides or dilations must be 1. ' +
	        ("Got strides " + strides + " and dilations '" + dilations + "'"); });
	    if (dimRoundingMode != null) {
	        util.assert(util.isInt(pad), function () { return "Error in avgPool3d: pad must be an integer when using, " +
	            ("dimRoundingMode " + dimRoundingMode + " but got pad " + pad + "."); });
	    }
	    var convInfo = conv_util.computePool3DInfo(x5D.shape, filterSize, strides, dilations, pad, dimRoundingMode, dataFormat);
	    var grad = function (dy) {
	        return {
	            x: function () { return avgPool3dBackprop(dy, x5D, filterSize, strides, dilations, pad, dimRoundingMode); }
	        };
	    };
	    var res = engine_1.ENGINE.runKernelFunc(function (backend) { return backend.avgPool3d(x5D, convInfo); }, { x: x5D }, grad);
	    res = res.cast(x5D.dtype);
	    if (reshapedTo5D) {
	        return res.as4D(res.shape[1], res.shape[2], res.shape[3], res.shape[4]);
	    }
	    return res;
	}
	/**
	 * Computes the backprop of a 3d avg pool.
	 *
	 * @param dy The dy error, of rank 5 of shape
	 *     [batchSize, depth, height, width, channels].
	 * assumed.
	 * @param input The original input image, of rank 5 or rank4 of shape
	 *     [batchSize, depth, height, width, channels].
	 * @param filterSize The filter size:
	 *     `[filterDepth, filterHeight, filterWidth]`.
	 *     `filterSize` is a single number,
	 *     then `filterDepth == filterHeight == filterWidth`.
	 * @param strides The strides of the pooling:
	 *     `[strideDepth, strideHeight, strideWidth]`. If
	 *     `strides` is a single number, then `strideHeight == strideWidth`.
	 * @param dilations The dilation rates:
	 *     `[dilationDepth, dilationHeight, dilationWidth]`
	 *     in which we sample input values across the depth, height and width
	 *     dimensions in dilated pooling.
	 *     Defaults to `[1, 1, 1]`. If `dilations` is a single number,
	 *     then `dilationDepth == dilationHeight == dilationWidth`.
	 *     If it is greater than 1, then all values of `strides` must be 1.
	 * @param pad A string from: 'same', 'valid'. The type of padding algorithm
	 *     used in the forward prop of the op.
	 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. The
	 *     rounding mode used when computing output dimensions if pad is a
	 *     number. If none is provided, it will not round and error if the output
	 *     is of fractional size.
	 */
	function avgPool3dBackprop(dy, input, filterSize, strides, dilations, pad, dimRoundingMode) {
	    var $dy = tensor_util_env_1.convertToTensor(dy, 'dy', 'avgPool3dBackprop');
	    var $input = tensor_util_env_1.convertToTensor(input, 'input', 'avgPool3dBackprop');
	    var dy5D = $dy;
	    var input5D = $input;
	    var reshapedTo5D = false;
	    if ($input.rank === 4) {
	        reshapedTo5D = true;
	        dy5D = $dy.as5D(1, $dy.shape[0], $dy.shape[1], $dy.shape[2], $dy.shape[3]);
	        input5D = $input.as5D(1, $input.shape[0], $input.shape[1], $input.shape[2], $input.shape[3]);
	    }
	    util.assert(dy5D.rank === 5, function () { return "Error in avgPool3dBackprop: dy must be rank 5 but got rank " +
	        (dy5D.rank + "."); });
	    util.assert(input5D.rank === 5, function () { return "Error in avgPool3dBackprop: input must be rank 5 but got rank " +
	        (input5D.rank + "."); });
	    if (dilations == null) {
	        dilations = [1, 1, 1];
	    }
	    util.assert(conv_util.eitherStridesOrDilationsAreOne(strides, dilations), function () { return 'Error in avgPool3dBackprop: Either strides or dilations ' +
	        ("must be 1. Got strides " + strides + " and dilations '" + dilations + "'"); });
	    if (dimRoundingMode != null) {
	        util.assert(util.isInt(pad), function () { return "Error in maxPool3dBackprop: pad must be an integer when " +
	            ("using, dimRoundingMode " + dimRoundingMode + " but got pad " + pad + "."); });
	    }
	    var convInfo = conv_util.computePool3DInfo(input5D.shape, filterSize, strides, dilations, pad, dimRoundingMode);
	    var res = engine_1.ENGINE.runKernelFunc(function (backend) { return backend.avgPool3dBackprop(dy5D, input5D, convInfo); }, { dy5D: dy5D, input5D: input5D });
	    if (reshapedTo5D) {
	        return res.as4D(res.shape[1], res.shape[2], res.shape[3], res.shape[4]);
	    }
	    return res;
	}
	/**
	 * Computes the 3D max pooling.
	 *
	 * ```js
	 * const x = tf.tensor5d([1, 2, 3, 4, 5, 6, 7, 8], [1, 2, 2, 2, 1]);
	 * const result = tf.maxPool3d(x, 2, 1, 'valid');
	 * result.print();
	 * ```
	 *
	 * @param x The input tensor, of rank 5 or rank 4 of shape
	 *     `[batch, depth, height, width, inChannels]`.
	 * @param filterSize The filter size:
	 *     `[filterDepth, filterHeight, filterWidth]`.
	 *     If `filterSize` is a single number,
	 *     then `filterDepth == filterHeight == filterWidth`.
	 * @param strides The strides of the pooling:
	 *     `[strideDepth, strideHeight, strideWidth]`.
	 *     If `strides` is a single number,
	 *     then `strideDepth == strideHeight == strideWidth`.
	 * @param pad The type of padding algorithm.
	 *    - `same` and stride 1: output will be of same size as input,
	 *       regardless of filter size.
	 *    - `valid`: output will be smaller than input if filter is larger
	 *       than 1*1x1.
	 *    - For more info, see this guide:
	 *     [https://www.tensorflow.org/api_guides/python/nn#Convolution](
	 *          https://www.tensorflow.org/api_guides/python/nn#Convolution)
	 * @param dimRoundingMode The rounding mode used when computing output
	 *     dimensions if pad is a number. If none is provided, it will not round
	 *     and error if the output is of fractional size.
	 * @param dataFormat An optional string from: "NDHWC", "NCDHW". Defaults to
	 *     "NDHWC". Specify the data format of the input and output data. With the
	 *     default format "NDHWC", the data is stored in the order of: [batch,
	 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
	 * @param dilations The dilation rates:
	 *     `[dilationDepth, dilationHeight, dilationWidth]`
	 *     in which we sample input values across the depth, height and width
	 *     dimensions in dilated pooling.
	 *     Defaults to `[1, 1, 1]`. If `dilations` is a single number,
	 *     then `dilationDepth == dilationHeight == dilationWidth`.
	 *     If it is greater than 1, then all values of `strides` must be 1.
	 */
	/** @doc {heading: 'Operations', subheading: 'Convolution'} */
	function maxPool3d_(x, filterSize, strides, pad, dimRoundingMode, dataFormat, dilations) {
	    if (dataFormat === void 0) { dataFormat = 'NDHWC'; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'maxPool3d');
	    var x5D = $x;
	    var reshapedTo5D = false;
	    if ($x.rank === 4) {
	        reshapedTo5D = true;
	        x5D = $x.as5D(1, $x.shape[0], $x.shape[1], $x.shape[2], $x.shape[3]);
	    }
	    if (dilations == null) {
	        dilations = [1, 1, 1];
	    }
	    util.assert(x5D.rank === 5, function () { return "Error in maxPool3d: x must be rank 5 but got rank " + x5D.rank + "."; });
	    util.assert(dataFormat === 'NDHWC', function () { return "Error in maxPool3d: Only NDHWC is currently supported, " +
	        ("but got dataFormat of " + dataFormat); });
	    util.assert(conv_util.eitherStridesOrDilationsAreOne(strides, dilations), function () { return 'Error in maxPool3d: Either strides or dilations must be 1. ' +
	        ("Got strides " + strides + " and dilations '" + dilations + "'"); });
	    if (dimRoundingMode != null) {
	        util.assert(util.isInt(pad), function () { return "Error in maxPool3d: pad must be an integer when using, " +
	            ("dimRoundingMode " + dimRoundingMode + " but got pad " + pad + "."); });
	    }
	    var convInfo = conv_util.computePool3DInfo(x5D.shape, filterSize, strides, dilations, pad, dimRoundingMode, dataFormat);
	    var grad = function (dy, saved) {
	        var x5D = saved[0], y = saved[1];
	        return {
	            x: function () { return maxPool3dBackprop(dy, x5D, y, filterSize, strides, dilations, pad, dimRoundingMode); }
	        };
	    };
	    var res = engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        var y = backend.maxPool3d(x5D, convInfo);
	        save([x5D, y]);
	        return y;
	    }, { x: x5D }, grad);
	    if (reshapedTo5D) {
	        return res.as4D(res.shape[1], res.shape[2], res.shape[3], res.shape[4]);
	    }
	    return res;
	}
	/**
	 * Computes the backprop of a 3d max pool.
	 *
	 * @param dy The dy error, of rank 5 of shape
	 *     [batchSize, depth, height, width, channels].
	 * assumed.
	 * @param input The original input image, of rank 5 or rank 4 of shape
	 *     [batchSize, depth, height, width, channels].
	 * @param output The original output image, of rank 5 of shape
	 *     [batchSize, outDepth, outHeight, outWidth, channels].
	 * @param filterSize The filter size:
	 *     `[filterDepth, filterHeight, filterWidth]`.
	 *     `filterSize` is a single number,
	 *     then `filterDepth == filterHeight == filterWidth`.
	 * @param strides The strides of the pooling:
	 *     `[strideDepth, strideHeight, strideWidth]`. If
	 *     `strides` is a single number, then `strideHeight == strideWidth`.
	 * @param dilations The dilation rates:
	 *     `[dilationDepth, dilationHeight, dilationWidth]`
	 *     in which we sample input values across the depth, height and width
	 *     dimensions in dilated pooling.
	 *     Defaults to `[1, 1, 1]`. If `dilations` is a single number,
	 *     then `dilationDepth == dilationHeight == dilationWidth`.
	 *     If it is greater than 1, then all values of `strides` must be 1.
	 * @param pad A string from: 'same', 'valid'. The type of padding algorithm
	 *     used in the forward prop of the op.
	 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. The
	 *     rounding mode used when computing output dimensions if pad is a
	 *     number. If none is provided, it will not round and error if the output
	 *     is of fractional size.
	 */
	function maxPool3dBackprop(dy, input, output, filterSize, strides, dilations, pad, dimRoundingMode) {
	    var $dy = tensor_util_env_1.convertToTensor(dy, 'dy', 'maxPool3dBackprop');
	    var $input = tensor_util_env_1.convertToTensor(input, 'input', 'maxPool3dBackprop');
	    var $output = tensor_util_env_1.convertToTensor(output, 'output', 'maxPool3dBackprop');
	    var dy5D = $dy;
	    var input5D = $input;
	    var output5D = $output;
	    var reshapedTo5D = false;
	    if ($input.rank === 4) {
	        reshapedTo5D = true;
	        dy5D = $dy.as5D(1, $dy.shape[0], $dy.shape[1], $dy.shape[2], $dy.shape[3]);
	        input5D = $input.as5D(1, $input.shape[0], $input.shape[1], $input.shape[2], $input.shape[3]);
	        output5D = $output.as5D(1, $output.shape[0], $output.shape[1], $output.shape[2], $output.shape[3]);
	    }
	    util.assert(dy5D.rank === 5, function () { return "Error in maxPool3dBackprop: dy must be rank 5 but got rank " +
	        (dy5D.rank + "."); });
	    util.assert(input5D.rank === 5, function () { return "Error in maxPool3dBackprop: input must be rank 5 but got rank " +
	        (input5D.rank + "."); });
	    util.assert(output5D.rank === 5, function () { return "Error in maxPool3dBackprop: output must be rank 5 but got rank " +
	        (output5D.rank + "."); });
	    if (dilations == null) {
	        dilations = [1, 1, 1];
	    }
	    util.assert(conv_util.eitherStridesOrDilationsAreOne(strides, dilations), function () { return 'Error in maxPool3dBackprop: Either strides or dilations ' +
	        ("must be 1. Got strides " + strides + " and dilations '" + dilations + "'"); });
	    if (dimRoundingMode != null) {
	        util.assert(util.isInt(pad), function () { return "Error in maxPool3dBackprop: pad must be an integer when " +
	            ("using, dimRoundingMode " + dimRoundingMode + " but got pad " + pad + "."); });
	    }
	    var convInfo = conv_util.computePool3DInfo(input5D.shape, filterSize, strides, dilations, pad, dimRoundingMode);
	    var res = engine_1.ENGINE.runKernelFunc(function (backend) { return backend.maxPool3dBackprop(dy5D, input5D, output5D, convInfo); }, { dy5D: dy5D, input5D: input5D });
	    if (reshapedTo5D) {
	        return res.as4D(res.shape[1], res.shape[2], res.shape[3], res.shape[4]);
	    }
	    return res;
	}
	exports.maxPool = operation_1.op({ maxPool_: maxPool_ });
	exports.avgPool = operation_1.op({ avgPool_: avgPool_ });
	exports.pool = operation_1.op({ pool_: pool_ });
	exports.maxPool3d = operation_1.op({ maxPool3d_: maxPool3d_ });
	exports.avgPool3d = operation_1.op({ avgPool3d_: avgPool3d_ });
	//# sourceMappingURL=pool.js.map

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var seedrandom = __webpack_require__(940);
	// https://en.wikipedia.org/wiki/Marsaglia_polar_method
	var MPRandGauss = /** @class */ (function () {
	    function MPRandGauss(mean, stdDeviation, dtype, truncated, seed) {
	        this.mean = mean;
	        this.stdDev = stdDeviation;
	        this.dtype = dtype;
	        this.nextVal = NaN;
	        this.truncated = truncated;
	        if (this.truncated) {
	            this.upper = this.mean + this.stdDev * 2;
	            this.lower = this.mean - this.stdDev * 2;
	        }
	        var seedValue = seed ? seed : Math.random();
	        this.random = seedrandom.alea(seedValue.toString());
	    }
	    /** Returns next sample from a Gaussian distribution. */
	    MPRandGauss.prototype.nextValue = function () {
	        if (!isNaN(this.nextVal)) {
	            var value = this.nextVal;
	            this.nextVal = NaN;
	            return value;
	        }
	        var resultX, resultY;
	        var isValid = false;
	        while (!isValid) {
	            var v1 = void 0, v2 = void 0, s = void 0;
	            do {
	                v1 = 2 * this.random() - 1;
	                v2 = 2 * this.random() - 1;
	                s = v1 * v1 + v2 * v2;
	            } while (s >= 1 || s === 0);
	            var mul = Math.sqrt(-2.0 * Math.log(s) / s);
	            resultX = this.mean + this.stdDev * v1 * mul;
	            resultY = this.mean + this.stdDev * v2 * mul;
	            if (!this.truncated || this.isValidTruncated(resultX)) {
	                isValid = true;
	            }
	        }
	        if (!this.truncated || this.isValidTruncated(resultY)) {
	            this.nextVal = this.convertValue(resultY);
	        }
	        return this.convertValue(resultX);
	    };
	    /** Handles proper rounding for non-floating-point numbers. */
	    MPRandGauss.prototype.convertValue = function (value) {
	        if (this.dtype == null || this.dtype === 'float32') {
	            return value;
	        }
	        return Math.round(value);
	    };
	    /** Returns true if less than 2-standard-deviations from the mean. */
	    MPRandGauss.prototype.isValidTruncated = function (value) {
	        return value <= this.upper && value >= this.lower;
	    };
	    return MPRandGauss;
	}());
	exports.MPRandGauss = MPRandGauss;
	// Marsaglia, George, and Wai Wan Tsang. 2000. "A Simple Method for Generating
	// Gamma Variables."
	var RandGamma = /** @class */ (function () {
	    function RandGamma(alpha, beta, dtype, seed) {
	        this.alpha = alpha;
	        this.beta = 1 / beta; // convert rate to scale parameter
	        this.dtype = dtype;
	        var seedValue = seed ? seed : Math.random();
	        this.randu = seedrandom.alea(seedValue.toString());
	        this.randn = new MPRandGauss(0, 1, dtype, false, this.randu());
	        if (alpha < 1) {
	            this.d = alpha + (2 / 3);
	        }
	        else {
	            this.d = alpha - (1 / 3);
	        }
	        this.c = 1 / Math.sqrt(9 * this.d);
	    }
	    /** Returns next sample from a gamma distribution. */
	    RandGamma.prototype.nextValue = function () {
	        var x2, v0, v1, x, u, v;
	        while (true) {
	            do {
	                x = this.randn.nextValue();
	                v = 1 + (this.c * x);
	            } while (v <= 0);
	            v *= v * v;
	            x2 = x * x;
	            v0 = 1 - (0.331 * x2 * x2);
	            v1 = (0.5 * x2) + (this.d * (1 - v + Math.log(v)));
	            u = this.randu();
	            if (u < v0 || Math.log(u) < v1) {
	                break;
	            }
	        }
	        v = (1 / this.beta) * this.d * v;
	        if (this.alpha < 1) {
	            v *= Math.pow(this.randu(), 1 / this.alpha);
	        }
	        return this.convertValue(v);
	    };
	    /** Handles proper rounding for non-floating-point numbers. */
	    RandGamma.prototype.convertValue = function (value) {
	        if (this.dtype === 'float32') {
	            return value;
	        }
	        return Math.round(value);
	    };
	    return RandGamma;
	}());
	exports.RandGamma = RandGamma;
	var UniformRandom = /** @class */ (function () {
	    function UniformRandom(min, max, dtype, seed) {
	        var _this = this;
	        if (min === void 0) { min = 0; }
	        if (max === void 0) { max = 1; }
	        /** Handles proper rounding for non floating point numbers. */
	        this.canReturnFloat = function () {
	            return (_this.dtype == null || _this.dtype === 'float32');
	        };
	        this.min = min;
	        this.range = max - min;
	        this.dtype = dtype;
	        if (seed == null) {
	            seed = Math.random();
	        }
	        if (typeof seed === 'number') {
	            seed = seed.toString();
	        }
	        if (!this.canReturnFloat() && this.range <= 1) {
	            throw new Error("The difference between " + min + " - " + max + " <= 1 and dtype is not float");
	        }
	        this.random = seedrandom.alea(seed);
	    }
	    UniformRandom.prototype.convertValue = function (value) {
	        if (this.canReturnFloat()) {
	            return value;
	        }
	        return Math.round(value);
	    };
	    UniformRandom.prototype.nextValue = function () {
	        return this.convertValue(this.min + this.range * this.random());
	    };
	    return UniformRandom;
	}());
	exports.UniformRandom = UniformRandom;
	//# sourceMappingURL=rand.js.map

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_util_env_1 = __webpack_require__(17);
	var util = __webpack_require__(10);
	var operation_1 = __webpack_require__(18);
	/**
	 * Reverses a `tf.Tensor1D`.
	 *
	 * @param x The input tensor.
	 */
	function reverse1d_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'reverse');
	    util.assert($x.rank === 1, function () { return "Error in reverse1D: x must be rank 1 but got rank " + $x.rank + "."; });
	    return exports.reverse($x, 0);
	}
	/**
	 * Reverses a `tf.Tensor2D` along a specified axis.
	 *
	 * @param x The input tensor.
	 * @param axis The set of dimensions to reverse. Must be in the
	 *     range [-rank(x), rank(x)). Defaults to all axes.
	 */
	function reverse2d_(x, axis) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'reverse');
	    util.assert($x.rank === 2, function () { return "Error in reverse2D: x must be rank 2 but got rank " + $x.rank + "."; });
	    return exports.reverse($x, axis);
	}
	/**
	 * Reverses a `tf.Tensor3D` along a specified axis.
	 *
	 * @param x The input tensor.
	 * @param axis The set of dimensions to reverse. Must be in the
	 *     range [-rank(x), rank(x)). Defaults to all axes.
	 */
	function reverse3d_(x, axis) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'reverse');
	    util.assert($x.rank === 3, function () { return "Error in reverse3D: x must be rank 3 but got rank " + $x.rank + "."; });
	    return exports.reverse($x, axis);
	}
	/**
	 * Reverses a `tf.Tensor4D` along a specified axis.
	 *
	 * @param x The input tensor.
	 * @param axis The set of dimensions to reverse. Must be in the
	 *     range [-rank(x), rank(x)). Defaults to all axes.
	 */
	function reverse4d_(x, axis) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'reverse');
	    util.assert($x.rank === 4, function () { return "Error in reverse4D: x must be rank 4 but got rank " + $x.rank + "."; });
	    return exports.reverse($x, axis);
	}
	/**
	 * Reverses a `tf.Tensor` along a specified axis.
	 *
	 * Also available are stricter rank-specific methods that assert that `x` is
	 * of the given rank:
	 *   - `tf.reverse1d`
	 *   - `tf.reverse2d`
	 *   - `tf.reverse3d`
	 *   - `tf.reverse4d`
	 *
	 * Except `tf.reverse1d` (which does not have axis param), all methods have
	 * same signature as this method.
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, 3, 4]);
	 *
	 * x.reverse().print();
	 * ```
	 *
	 * ```js
	 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
	 *
	 * const axis = 1;
	 * x.reverse(axis).print();
	 * ```
	 * @param x The input tensor to be reversed.
	 * @param axis The set of dimensions to reverse. Must be in the
	 *     range [-rank(x), rank(x)). Defaults to all axes.
	 */
	/** @doc {heading: 'Tensors', subheading: 'Slicing and Joining'} */
	function reverse_(x, axis) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'reverse');
	    if ($x.rank === 0) {
	        return $x.clone();
	    }
	    var axes = util.parseAxisParam(axis, $x.shape);
	    var grad = function (dy) {
	        return { $x: function () { return dy.reverse(axes); } };
	    };
	    var res = engine_1.ENGINE.runKernelFunc(function (backend) { return backend.reverse($x, axes); }, { $x: $x }, grad);
	    return res.reshapeAs($x);
	}
	exports.reverse = operation_1.op({ reverse_: reverse_ });
	exports.reverse1d = operation_1.op({ reverse1d_: reverse1d_ });
	exports.reverse2d = operation_1.op({ reverse2d_: reverse2d_ });
	exports.reverse3d = operation_1.op({ reverse3d_: reverse3d_ });
	exports.reverse4d = operation_1.op({ reverse4d_: reverse4d_ });
	//# sourceMappingURL=reverse.js.map

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_util_env_1 = __webpack_require__(17);
	var operation_1 = __webpack_require__(18);
	var scatter_nd_util = __webpack_require__(239);
	/**
	 * Creates a new tensor by applying sparse updates to individual
	 * values or slices within a zero tensor of the given shape tensor according to
	 * indices. This operator is the inverse of the `tf.gatherND` operator which
	 * extracts values or slices from a given tensor.
	 *
	 * ```js
	 * const indices = tf.tensor2d([4, 3, 1, 7], [4, 1], 'int32');
	 * const updates = tf.tensor1d([9, 10, 11, 12]);
	 * const shape = [8];
	 * tf.scatterND(indices, updates, shape).print() //[0, 11, 0, 10, 9, 0, 0, 12]
	 * ```
	 *
	 * @param indices The tensor contains the indices into the output tensor.
	 * @param updates The tensor contains the value for the indices.
	 * @param shape: The shape of the output tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Slicing and Joining'} */
	function scatterND_(indices, updates, shape) {
	    var $indices = tensor_util_env_1.convertToTensor(indices, 'indices', 'scatterND', 'int32');
	    var $updates = tensor_util_env_1.convertToTensor(updates, 'updates', 'scatterND');
	    scatter_nd_util.validateInput($updates, $indices, shape);
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.scatterND($indices, $updates, shape); }, { indices: $indices, updates: $updates }, null /* backward */, 'ScatterNd', { shape: shape });
	}
	exports.scatterND = operation_1.op({ scatterND_: scatterND_ });
	//# sourceMappingURL=scatter_nd.js.map

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var sparse_to_dense = __webpack_require__(1068);
	var tensor_util_env_1 = __webpack_require__(17);
	var operation_1 = __webpack_require__(18);
	/**
	 * Converts a sparse representation into a dense tensor.
	 *
	 * Builds an array dense with shape outputShape such that:
	 *
	 * // If sparseIndices is scalar
	 * dense[i] = (i == sparseIndices ? sparseValues : defaultValue)
	 *
	 * // If sparseIndices is a vector, then for each i
	 * dense[sparseIndices[i]] = sparseValues[i]
	 *
	 * // If sparseIndices is an n by d matrix, then for each i in [0, n)
	 * dense[sparseIndices[i][0], ..., sparseIndices[i][d-1]] = sparseValues[i]
	 * All other values in dense are set to defaultValue. If sparseValues is a
	 * scalar, all sparse indices are set to this single value.
	 *
	 * If indices are repeated the final value is summed over all values for those
	 * indices.
	 *
	 * ```js
	 * const indices = tf.tensor1d([4, 5, 6, 1, 2, 3], 'int32');
	 * const values = tf.tensor1d([10, 11, 12, 13, 14, 15], 'float32');
	 * const shape = [8];
	 * tf.sparseToDense(indices, values, shape).print();
	 * ```
	 *
	 * @param sparseIndices A 0-D, 1-D, or 2-D Tensor of type int32.
	 * sparseIndices[i] contains the complete index where sparseValues[i] will be
	 * placed.
	 * @param sparseValues A 0-D or 1-D Tensor. Values
	 * corresponding to each row of sparseIndices, or a scalar value to be used for
	 * all sparse indices.
	 * @param outputShape Shape of the dense output tensor. the type is inferred.
	 * @param defaultValue Scalar. Value to set for indices not specified in
	 * sparseIndices. Defaults to zero.
	 */
	/** @doc {heading: 'Operations', subheading: 'Normalization'} */
	function sparseToDense_(sparseIndices, sparseValues, outputShape, defaultValue) {
	    if (defaultValue === void 0) { defaultValue = 0; }
	    var $sparseIndices = tensor_util_env_1.convertToTensor(sparseIndices, 'sparseIndices', 'sparseToDense', 'int32');
	    var $sparseValues = tensor_util_env_1.convertToTensor(sparseValues, 'sparseValues', 'sparseToDense');
	    var $defaultValue = tensor_util_env_1.convertToTensor(defaultValue, 'defaultValue', 'sparseToDense', $sparseValues.dtype);
	    sparse_to_dense.validateInput($sparseIndices, $sparseValues, outputShape, $defaultValue);
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.sparseToDense($sparseIndices, $sparseValues, outputShape, $defaultValue); }, { $sparseIndices: $sparseIndices, $sparseValues: $sparseValues, $defaultValue: $defaultValue });
	}
	exports.sparseToDense = operation_1.op({ sparseToDense_: sparseToDense_ });
	//# sourceMappingURL=sparse_to_dense.js.map

/***/ },
/* 1068 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Validate sparseToDense inputs.
	 *
	 * @param sparseIndices A 0-D, 1-D, or 2-D Tensor of type int32.
	 * sparseIndices[i] contains the complete index where sparseValues[i] will be
	 * placed.
	 * @param sparseValues A 0-D or 1-D Tensor. Values
	 * corresponding to each row of sparseIndices, or a scalar value to be used for
	 * all sparse indices.
	 * @param outputShape number[]. Shape of the dense output tensor.
	 * @param validateIndices boolean. indice validation is not supported, error
	 * will be thrown if it is set.
	 */
	function validateInput(sparseIndices, sparseValues, outputShape, defaultValues) {
	    if (sparseIndices.dtype !== 'int32') {
	        throw new Error('tf.sparseToDense() expects the indices to be int32 type,' +
	            (" but the dtype was " + sparseIndices.dtype + "."));
	    }
	    if (sparseIndices.rank > 2) {
	        throw new Error('sparseIndices should be a scalar, vector, or matrix,' +
	            (" but got shape " + sparseIndices.shape + "."));
	    }
	    var numElems = sparseIndices.rank > 0 ? sparseIndices.shape[0] : 1;
	    var numDims = sparseIndices.rank > 1 ? sparseIndices.shape[1] : 1;
	    if (outputShape.length !== numDims) {
	        throw new Error('outputShape has incorrect number of elements:,' +
	            (" " + outputShape.length + ", should be: " + numDims + "."));
	    }
	    var numValues = sparseValues.size;
	    if (!(sparseValues.rank === 0 ||
	        sparseValues.rank === 1 && numValues === numElems)) {
	        throw new Error('sparseValues has incorrect shape ' +
	            (sparseValues.shape + ", should be [] or [" + numElems + "]"));
	    }
	    if (sparseValues.dtype !== defaultValues.dtype) {
	        throw new Error('sparseValues.dtype must match defaultValues.dtype');
	    }
	}
	exports.validateInput = validateInput;
	//# sourceMappingURL=sparse_to_dense_util.js.map

/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_util_env_1 = __webpack_require__(17);
	var operation_1 = __webpack_require__(18);
	/**
	 * Computes square of `x` element-wise: `x ^ 2`
	 *
	 * ```js
	 * const x = tf.tensor1d([1, 2, Math.sqrt(2), -1]);
	 *
	 * x.square().print();  // or tf.square(x)
	 * ```
	 * @param x The input Tensor.
	 */
	/** @doc {heading: 'Operations', subheading: 'Basic math'} */
	function square_(x) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'square');
	    var attrs = {};
	    var inputsToSave = [$x];
	    var outputsToSave = [];
	    return engine_1.ENGINE.runKernelFunc(function (backend, save) {
	        save([$x]);
	        return backend.square($x);
	    }, { x: $x }, null /* grad */, 'Square', attrs, inputsToSave, outputsToSave);
	}
	exports.square = operation_1.op({ square_: square_ });
	//# sourceMappingURL=square.js.map

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_util_env_1 = __webpack_require__(17);
	var operation_1 = __webpack_require__(18);
	var slice_1 = __webpack_require__(318);
	var slice_util_1 = __webpack_require__(192);
	/**
	 * Extracts a strided slice of a tensor.
	 *
	 * Roughly speaking, this op extracts a slice of size (end-begin)/stride from
	 * the given input tensor (x). Starting at the location specified by begin the
	 * slice continues by adding stride to the index until all dimensions are not
	 * less than end. Note that a stride can be negative, which causes a reverse
	 * slice.
	 *
	 * ```js
	 * const t = tf.tensor3d([1, 1, 1 ,2, 2, 2, 3, 3, 3, 4, 4, 4, 5, 5, 5, 6, 6, 6],
	 *    [3, 2, 3]);
	 * t.stridedSlice([1, 0, 0], [2, 1, 3], [1, 1, 1]).print()  // [[[3, 3, 3]]]
	 * t.stridedSlice([1, 0, 0], [2, 2, 3], [1, 1, 1]).print()  // [[[3, 3, 3],
	 *                                                     // [4, 4, 4]]]
	 * t.stridedSlice([1, -1, 0], [2, -3, 3], [1, -1, 1]).print() // [[[4, 4, 4],
	 *                                                     // [3, 3, 3]]]
	 * ```
	 *
	 * @param x The tensor to stride slice.
	 * @param begin The coordinates to start the slice from.
	 * @param end: The coordinates to end the slice at.
	 * @param strides: The size of the slice.
	 * @param beginMask: If the ith bit of beginMask is set, begin[i] is ignored
	 *      and the fullest possible range in that dimension is used instead.
	 * @param endMask: If the ith bit of endMask is set, end[i] is ignored
	 *      and the fullest possible range in that dimension is used instead.
	 * @param shrinkAxisMask: a bitmask where bit i implies that
	 * the ith specification should shrink the dimensionality. begin and end must
	 * imply a slice of size 1 in the dimension.
	 */
	/** @doc {heading: 'Operations', subheading: 'Slicing and Joining'} */
	function stridedSlice_(x, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask) {
	    if (beginMask === void 0) { beginMask = 0; }
	    if (endMask === void 0) { endMask = 0; }
	    if (ellipsisMask === void 0) { ellipsisMask = 0; }
	    if (newAxisMask === void 0) { newAxisMask = 0; }
	    if (shrinkAxisMask === void 0) { shrinkAxisMask = 0; }
	    if (strides == null) {
	        strides = new Array(begin.length);
	    }
	    if (ellipsisMask !== 0) {
	        throw new Error('ellipsis mask is not yet supported');
	    }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'stridedSlice');
	    // Expand the dims of x based on the newAxisMask.
	    var expandAxes = slice_util_1.maskToAxes(newAxisMask);
	    var newShape = $x.shape.slice();
	    expandAxes.forEach(function (axis) {
	        begin[axis] = 0;
	        end[axis] = 1;
	        newShape.splice(axis, 0, 1);
	    });
	    $x = $x.reshape(newShape);
	    // Normalize the start, end and strides.
	    for (var axis = 0; axis < $x.rank; axis++) {
	        begin[axis] = slice_util_1.startForAxis(beginMask, begin, strides, $x.shape, axis);
	        end[axis] = slice_util_1.stopForAxis(endMask, end, strides, $x.shape, axis);
	        strides[axis] = strides[axis] || 1;
	    }
	    var shrinkAxes = slice_util_1.maskToAxes(shrinkAxisMask);
	    // Adjust the ends based on the shrink mask.
	    shrinkAxes.forEach(function (axis) {
	        end[axis] = begin[axis] + 1;
	        strides[axis] = 1;
	    });
	    // Figure out the output shape.
	    var size = slice_util_1.computeOutShape(begin, end, strides);
	    // Remove the axes based on shrinkMask.
	    var outShape = size.filter(function (_, axis) { return shrinkAxes.indexOf(axis) === -1; });
	    var nonStrided = strides.every(function (v) { return v === 1; });
	    if (nonStrided) {
	        return slice_1.slice($x, begin, size).reshape(outShape);
	    }
	    var res = engine_1.ENGINE.runKernelFunc(function (backend) { return backend.stridedSlice($x, begin, end, strides); }, { $x: $x });
	    return res.reshape(outShape);
	}
	exports.stridedSlice = operation_1.op({ stridedSlice_: stridedSlice_ });
	//# sourceMappingURL=strided_slice.js.map

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_util_env_1 = __webpack_require__(17);
	var operation_1 = __webpack_require__(18);
	/**
	 * Finds the values and indices of the `k` largest entries along the last
	 * dimension.
	 *
	 * If the input is a vector (rank=1), finds the k largest entries in the vector
	 * and outputs their values and indices as vectors. Thus values[j] is the j-th
	 * largest entry in input, and its index is indices[j].
	 * For higher rank inputs, computes the top k entries along the last dimension.
	 *
	 * If two elements are equal, the lower-index element appears first.
	 *
	 * ```js
	 * const a = tf.tensor2d([[1, 5], [4, 3]]);
	 * const {values, indices} = tf.topk(a);
	 * values.print();
	 * indices.print();
	 * ```
	 * @param x 1-D or higher `tf.Tensor` with last dimension being at least `k`.
	 * @param k Number of top elements to look for along the last dimension.
	 * @param sorted If true, the resulting `k` elements will be sorted by the
	 *     values in descending order.
	 */
	/** @doc {heading: 'Operations', subheading: 'Evaluation'} */
	function topk_(x, k, sorted) {
	    if (k === void 0) { k = 1; }
	    if (sorted === void 0) { sorted = true; }
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'topk');
	    if ($x.rank === 0) {
	        throw new Error('topk() expects the input to be of rank 1 or higher');
	    }
	    var lastDim = $x.shape[$x.shape.length - 1];
	    if (k > lastDim) {
	        throw new Error("'k' passed to topk() must be <= the last dimension (" + lastDim + ") " +
	            ("but got " + k));
	    }
	    var _a = engine_1.ENGINE.runKernelFunc(function (b) { return b.topk($x, k, sorted); }, { $x: $x }), values = _a[0], indices = _a[1];
	    return { values: values, indices: indices };
	}
	exports.topk = operation_1.op({ topk_: topk_ });
	//# sourceMappingURL=topk.js.map

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_util_env_1 = __webpack_require__(17);
	var util = __webpack_require__(10);
	var axis_util = __webpack_require__(108);
	var operation_1 = __webpack_require__(18);
	/**
	 * Transposes the `tf.Tensor`. Permutes the dimensions according to `perm`.
	 *
	 * The returned `tf.Tensor`'s dimension `i` will correspond to the input
	 * dimension `perm[i]`. If `perm` is not given, it is set to `[n-1...0]`,
	 * where `n` is the rank of the input `tf.Tensor`. Hence by default, this
	 * operation performs a regular matrix transpose on 2-D input `tf.Tensor`s.
	 *
	 * ```js
	 * const a = tf.tensor2d([1, 2, 3, 4, 5, 6], [2, 3]);
	 *
	 * a.transpose().print();  // or tf.transpose(a)
	 * ```
	 *
	 * @param x The tensor to transpose.
	 * @param perm The permutation of the dimensions of a.
	 */
	/** @doc {heading: 'Operations', subheading: 'Matrices'} */
	function transpose_(x, perm) {
	    var $x = tensor_util_env_1.convertToTensor(x, 'x', 'transpose');
	    if (perm == null) {
	        perm = $x.shape.map(function (s, i) { return i; }).reverse();
	    }
	    util.assert($x.rank === perm.length, function () { return "Error in transpose: rank of input " + $x.rank + " " +
	        ("must match length of perm " + perm + "."); });
	    perm.forEach(function (axis) {
	        util.assert(axis >= 0 && axis < $x.rank, function () { return "All entries in 'perm' must be between 0 and " + ($x.rank - 1) +
	            (" but got " + perm); });
	    });
	    if ($x.rank <= 1) {
	        return $x.clone();
	    }
	    var der = function (dy) {
	        var undoPerm = axis_util.getUndoAxesPermutation(perm);
	        return { x: function () { return dy.transpose(undoPerm); } };
	    };
	    var attrs = { perm: perm };
	    return engine_1.ENGINE.runKernelFunc(function (backend) { return backend.transpose($x, perm); }, { x: $x }, der, 'Transpose', attrs);
	}
	exports.transpose = operation_1.op({ transpose_: transpose_ });
	//# sourceMappingURL=transpose.js.map

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var adadelta_optimizer_1 = __webpack_require__(321);
	var adagrad_optimizer_1 = __webpack_require__(322);
	var adam_optimizer_1 = __webpack_require__(323);
	var adamax_optimizer_1 = __webpack_require__(324);
	var momentum_optimizer_1 = __webpack_require__(325);
	var rmsprop_optimizer_1 = __webpack_require__(326);
	var sgd_optimizer_1 = __webpack_require__(240);
	var OptimizerConstructors = /** @class */ (function () {
	    function OptimizerConstructors() {
	    }
	    /**
	     * Constructs a `tf.SGDOptimizer` that uses stochastic gradient descent.
	     *
	     * ```js
	     * // Fit a quadratic function by learning the coefficients a, b, c.
	     * const xs = tf.tensor1d([0, 1, 2, 3]);
	     * const ys = tf.tensor1d([1.1, 5.9, 16.8, 33.9]);
	     *
	     * const a = tf.scalar(Math.random()).variable();
	     * const b = tf.scalar(Math.random()).variable();
	     * const c = tf.scalar(Math.random()).variable();
	     *
	     * // y = a * x^2 + b * x + c.
	     * const f = x => a.mul(x.square()).add(b.mul(x)).add(c);
	     * const loss = (pred, label) => pred.sub(label).square().mean();
	     *
	     * const learningRate = 0.01;
	     * const optimizer = tf.train.sgd(learningRate);
	     *
	     * // Train the model.
	     * for (let i = 0; i < 10; i++) {
	     *   optimizer.minimize(() => loss(f(xs), ys));
	     * }
	     *
	     * // Make predictions.
	     * console.log(
	     *     `a: ${a.dataSync()}, b: ${b.dataSync()}, c: ${c.dataSync()}`);
	     * const preds = f(xs).dataSync();
	     * preds.forEach((pred, i) => {
	     *   console.log(`x: ${i}, pred: ${pred}`);
	     * });
	     * ```
	     *
	     * @param learningRate The learning rate to use for the SGD algorithm.
	     */
	    /**
	     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
	     */
	    OptimizerConstructors.sgd = function (learningRate) {
	        return new sgd_optimizer_1.SGDOptimizer(learningRate);
	    };
	    /**
	     * Constructs a `tf.MomentumOptimizer` that uses momentum gradient
	     * descent.
	     *
	     * See
	     * [http://proceedings.mlr.press/v28/sutskever13.pdf](
	     * http://proceedings.mlr.press/v28/sutskever13.pdf)
	     *
	     * @param learningRate The learning rate to use for the Momentum gradient
	     * descent algorithm.
	     * @param momentum The momentum to use for the momentum gradient descent
	     * algorithm.
	     */
	    /**
	     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
	     */
	    OptimizerConstructors.momentum = function (learningRate, momentum, useNesterov) {
	        if (useNesterov === void 0) { useNesterov = false; }
	        return new momentum_optimizer_1.MomentumOptimizer(learningRate, momentum, useNesterov);
	    };
	    /**
	     * Constructs a `tf.RMSPropOptimizer` that uses RMSProp gradient
	     * descent. This implementation uses plain momentum and is not centered
	     * version of RMSProp.
	     *
	     * See
	     * [http://www.cs.toronto.edu/~tijmen/csc321/slides/lecture_slides_lec6.pdf](
	     * http://www.cs.toronto.edu/~tijmen/csc321/slides/lecture_slides_lec6.pdf)
	     *
	     * @param learningRate The learning rate to use for the RMSProp gradient
	     * descent algorithm.
	     * @param decay The discounting factor for the history/coming gradient.
	     * @param momentum The momentum to use for the RMSProp gradient descent
	     * algorithm.
	     * @param epsilon Small value to avoid zero denominator.
	     * @param centered If true, gradients are normalized by the estimated
	     * variance of the gradient.
	     */
	    /**
	     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
	     */
	    OptimizerConstructors.rmsprop = function (learningRate, decay, momentum, epsilon, centered) {
	        if (decay === void 0) { decay = .9; }
	        if (momentum === void 0) { momentum = 0.0; }
	        if (epsilon === void 0) { epsilon = null; }
	        if (centered === void 0) { centered = false; }
	        return new rmsprop_optimizer_1.RMSPropOptimizer(learningRate, decay, momentum, epsilon, centered);
	    };
	    /**
	     * Constructs a `tf.AdamOptimizer` that uses the Adam algorithm.
	     * See [https://arxiv.org/abs/1412.6980](https://arxiv.org/abs/1412.6980)
	     *
	     * @param learningRate The learning rate to use for the Adam gradient
	     * descent algorithm.
	     * @param beta1 The exponential decay rate for the 1st moment estimates.
	     * @param beta2 The exponential decay rate for the 2nd moment estimates.
	     * @param epsilon A small constant for numerical stability.
	     */
	    /**
	     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
	     */
	    OptimizerConstructors.adam = function (learningRate, beta1, beta2, epsilon) {
	        if (learningRate === void 0) { learningRate = 0.001; }
	        if (beta1 === void 0) { beta1 = 0.9; }
	        if (beta2 === void 0) { beta2 = 0.999; }
	        if (epsilon === void 0) { epsilon = null; }
	        return new adam_optimizer_1.AdamOptimizer(learningRate, beta1, beta2, epsilon);
	    };
	    /**
	     * Constructs a `tf.AdadeltaOptimizer` that uses the Adadelta algorithm.
	     * See [https://arxiv.org/abs/1212.5701](https://arxiv.org/abs/1212.5701)
	     *
	     * @param learningRate The learning rate to use for the Adadelta gradient
	     * descent algorithm.
	     * @param rho The learning rate decay over each update.
	     * @param epsilon A constant epsilon used to better condition the grad
	     * update.
	     */
	    /**
	     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
	     */
	    OptimizerConstructors.adadelta = function (learningRate, rho, epsilon) {
	        if (learningRate === void 0) { learningRate = .001; }
	        if (rho === void 0) { rho = .95; }
	        if (epsilon === void 0) { epsilon = null; }
	        return new adadelta_optimizer_1.AdadeltaOptimizer(learningRate, rho, epsilon);
	    };
	    /**
	     * Constructs a `tf.AdamaxOptimizer` that uses the Adamax algorithm.
	     * See [https://arxiv.org/abs/1412.6980](https://arxiv.org/abs/1412.6980)
	     *
	     * @param learningRate The learning rate to use for the Adamax gradient
	     * descent algorithm.
	     * @param beta1 The exponential decay rate for the 1st moment estimates.
	     * @param beta2 The exponential decay rate for the 2nd moment estimates.
	     * @param epsilon A small constant for numerical stability.
	     * @param decay The learning rate decay over each update.
	     */
	    /**
	     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
	     */
	    OptimizerConstructors.adamax = function (learningRate, beta1, beta2, epsilon, decay) {
	        if (learningRate === void 0) { learningRate = 0.002; }
	        if (beta1 === void 0) { beta1 = 0.9; }
	        if (beta2 === void 0) { beta2 = 0.999; }
	        if (epsilon === void 0) { epsilon = null; }
	        if (decay === void 0) { decay = 0.0; }
	        return new adamax_optimizer_1.AdamaxOptimizer(learningRate, beta1, beta2, epsilon, decay);
	    };
	    /**
	     * Constructs a `tf.AdagradOptimizer` that uses the Adagrad algorithm.
	     * See
	     * [http://www.jmlr.org/papers/volume12/duchi11a/duchi11a.pdf](
	     * http://www.jmlr.org/papers/volume12/duchi11a/duchi11a.pdf)
	     * or
	     * [http://ruder.io/optimizing-gradient-descent/index.html#adagrad](
	     * http://ruder.io/optimizing-gradient-descent/index.html#adagrad)
	     *
	     * @param learningRate The learning rate to use for the Adagrad gradient
	     * descent algorithm.
	     * @param initialAccumulatorValue Starting value for the accumulators, must be
	     * positive.
	     */
	    /**
	     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
	     */
	    OptimizerConstructors.adagrad = function (learningRate, initialAccumulatorValue) {
	        if (initialAccumulatorValue === void 0) { initialAccumulatorValue = 0.1; }
	        return new adagrad_optimizer_1.AdagradOptimizer(learningRate, initialAccumulatorValue);
	    };
	    return OptimizerConstructors;
	}());
	exports.OptimizerConstructors = OptimizerConstructors;
	//# sourceMappingURL=optimizer_constructors.js.map

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var environment_1 = __webpack_require__(28);
	var PlatformBrowser = /** @class */ (function () {
	    function PlatformBrowser() {
	    }
	    PlatformBrowser.prototype.fetch = function (path, init) {
	        return fetch(path, init);
	    };
	    PlatformBrowser.prototype.now = function () {
	        return performance.now();
	    };
	    PlatformBrowser.prototype.encode = function (text, encoding) {
	        if (encoding !== 'utf-8' && encoding !== 'utf8') {
	            throw new Error("Browser's encoder only supports utf-8, but got " + encoding);
	        }
	        if (this.textEncoder == null) {
	            this.textEncoder = new TextEncoder();
	        }
	        return this.textEncoder.encode(text);
	    };
	    PlatformBrowser.prototype.decode = function (bytes, encoding) {
	        return new TextDecoder(encoding).decode(bytes);
	    };
	    return PlatformBrowser;
	}());
	exports.PlatformBrowser = PlatformBrowser;
	if (environment_1.env().get('IS_BROWSER')) {
	    environment_1.env().setPlatform('browser', new PlatformBrowser());
	}
	//# sourceMappingURL=platform_browser.js.map

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @license
	 * Copyright 2019 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var environment_1 = __webpack_require__(28);
	// We are wrapping this within an object so it can be stubbed by Jasmine.
	exports.getNodeFetch = {
	    // tslint:disable-next-line:no-require-imports
	    importFetch: function () { return __webpack_require__(2069); }
	};
	var systemFetch;
	// These getters and setters are for testing so we don't export a mutable
	// variable.
	function resetSystemFetch() {
	    systemFetch = null;
	}
	exports.resetSystemFetch = resetSystemFetch;
	function setSystemFetch(fetchFn) {
	    systemFetch = fetchFn;
	}
	exports.setSystemFetch = setSystemFetch;
	function getSystemFetch() {
	    return systemFetch;
	}
	exports.getSystemFetch = getSystemFetch;
	var PlatformNode = /** @class */ (function () {
	    function PlatformNode() {
	        // tslint:disable-next-line:no-require-imports
	        this.util = __webpack_require__(2070);
	        // According to the spec, the built-in encoder can do only UTF-8 encoding.
	        // https://developer.mozilla.org/en-US/docs/Web/API/TextEncoder/TextEncoder
	        this.textEncoder = new this.util.TextEncoder();
	    }
	    PlatformNode.prototype.fetch = function (path, requestInits) {
	        if (environment_1.env().global.fetch != null) {
	            return environment_1.env().global.fetch(path, requestInits);
	        }
	        if (systemFetch == null) {
	            systemFetch = exports.getNodeFetch.importFetch();
	        }
	        return systemFetch(path, requestInits);
	    };
	    PlatformNode.prototype.now = function () {
	        var time = process.hrtime();
	        return time[0] * 1000 + time[1] / 1000000;
	    };
	    PlatformNode.prototype.encode = function (text, encoding) {
	        if (encoding !== 'utf-8' && encoding !== 'utf8') {
	            throw new Error("Node built-in encoder only supports utf-8, but got " + encoding);
	        }
	        return this.textEncoder.encode(text);
	    };
	    PlatformNode.prototype.decode = function (bytes, encoding) {
	        if (bytes.length === 0) {
	            return '';
	        }
	        return new this.util.TextDecoder(encoding).decode(bytes);
	    };
	    return PlatformNode;
	}());
	exports.PlatformNode = PlatformNode;
	if (environment_1.env().get('IS_NODE')) {
	    environment_1.env().setPlatform('node', new PlatformNode());
	}
	//# sourceMappingURL=platform_node.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util = __webpack_require__(10);
	var Profiler = /** @class */ (function () {
	    function Profiler(backendTimer, logger) {
	        this.backendTimer = backendTimer;
	        this.logger = logger;
	        if (logger == null) {
	            this.logger = new Logger();
	        }
	    }
	    Profiler.prototype.profileKernel = function (kernelName, inputs, f) {
	        var _this = this;
	        var outputs;
	        var holdResultWrapperFn = function () {
	            outputs = f();
	        };
	        var timer = this.backendTimer.time(holdResultWrapperFn);
	        outputs.forEach(function (r) {
	            // Dangling promise here because we don't want to propagate up
	            // asynchronicity.
	            r.data().then(function (vals) {
	                checkComputationForErrors(vals, r.dtype, kernelName);
	                timer.then(function (timing) {
	                    var extraInfo = '';
	                    if (timing.getExtraProfileInfo != null) {
	                        extraInfo = timing.getExtraProfileInfo();
	                    }
	                    _this.logger.logKernelProfile(kernelName, r, vals, timing.kernelMs, inputs, extraInfo);
	                });
	            });
	        });
	        return outputs;
	    };
	    return Profiler;
	}());
	exports.Profiler = Profiler;
	function checkComputationForErrors(vals, dtype, kernelName) {
	    if (dtype !== 'float32') {
	        // Only floating point computations will generate NaN values
	        return false;
	    }
	    for (var i = 0; i < vals.length; i++) {
	        var num = vals[i];
	        if (isNaN(num) || !isFinite(num)) {
	            // Throwing custom exception so behavior is testable.
	            console.warn("Found " + num + " in the result of '" + kernelName + "'");
	            return true;
	        }
	    }
	    return false;
	}
	exports.checkComputationForErrors = checkComputationForErrors;
	var Logger = /** @class */ (function () {
	    function Logger() {
	    }
	    Logger.prototype.logKernelProfile = function (name, result, vals, timeMs, inputs, extraInfo) {
	        var time = typeof timeMs === 'number' ? util.rightPad(timeMs + "ms", 9) :
	            timeMs['error'];
	        var paddedName = util.rightPad(name, 25);
	        var rank = result.rank;
	        var size = result.size;
	        var shape = util.rightPad(result.shape.toString(), 14);
	        var inputShapesDescription = '';
	        for (var name_1 in inputs) {
	            var input = inputs[name_1];
	            // The input might be a non-tensor (e.g HTMLImageElement), in which case
	            // we claim the output shape as input shape.
	            var inputShape = input.shape || result.shape;
	            var inputRank = inputShape.length;
	            inputShapesDescription +=
	                name_1 + ": " + inputRank + "D " + (inputRank > 0 ? inputShape : '') + " ";
	        }
	        console.log("%c" + paddedName + "\t%c" + time + "\t%c" + rank + "D " + shape + "\t%c" + size + "\t%c" + inputShapesDescription + "\t%c" + extraInfo, 'font-weight:bold', 'color:red', 'color:blue', 'color: orange', 'color: green', 'color: steelblue');
	    };
	    return Logger;
	}());
	exports.Logger = Logger;
	//# sourceMappingURL=profiler.js.map

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2020 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	__webpack_require__(1078);
	//# sourceMappingURL=register_all_chained_ops.js.map

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2020 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var squared_difference_1 = __webpack_require__(498);
	var tensor_1 = __webpack_require__(75);
	tensor_1.Tensor.prototype.squaredDifference = function (b) {
	    return squared_difference_1.squaredDifference(this, b);
	};
	//# sourceMappingURL=squared_difference.js.map

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @license
	 * Copyright 2020 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	var Square_grad_1 = __webpack_require__(1037);
	var SquaredDifference_grad_1 = __webpack_require__(1038);
	var kernel_registry_1 = __webpack_require__(152);
	// Export all kernel configs here so that the package can auto register them
	var gradConfigs = [
	    Square_grad_1.squareGradConfig,
	    SquaredDifference_grad_1.squaredDifferenceGradConfig,
	];
	for (var _i = 0, gradConfigs_1 = gradConfigs; _i < gradConfigs_1.length; _i++) {
	    var gradientConfig = gradConfigs_1[_i];
	    kernel_registry_1.registerGradient(gradientConfig);
	}
	//# sourceMappingURL=register_all_gradients.js.map

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util = __webpack_require__(10);
	/**
	 * Computes a list of TapeNodes that connect x to y, filtering everything else
	 * out and preserving the order of the original tape elements.
	 *
	 * @param tape The tape elements to filter.
	 * @param xs The input Tensors.
	 * @param y The output Tensor.
	 */
	function getFilteredNodesXToY(tape, xs, y) {
	    // Forward pass to compute all the nodes and Tensors that are transitively a
	    // function of x.
	    var tensorsFromX = {};
	    var nodesFromX = {};
	    for (var i = 0; i < xs.length; i++) {
	        tensorsFromX[xs[i].id] = true;
	    }
	    for (var i = 0; i < tape.length; i++) {
	        var node = tape[i];
	        var nodeInputs = node.inputs;
	        for (var inputName in nodeInputs) {
	            var input = nodeInputs[inputName];
	            var anyInputFromX = false;
	            for (var j = 0; j < xs.length; j++) {
	                if (tensorsFromX[input.id]) {
	                    node.outputs.forEach(function (output) { return tensorsFromX[output.id] = true; });
	                    anyInputFromX = true;
	                    nodesFromX[node.id] = true;
	                    break;
	                }
	            }
	            if (anyInputFromX) {
	                break;
	            }
	        }
	    }
	    // Backward pass to find all of the nodes and Tensors that lead to y.
	    var tensorsLeadToY = {};
	    tensorsLeadToY[y.id] = true;
	    var nodesToY = {};
	    for (var i = tape.length - 1; i >= 0; i--) {
	        var node = tape[i];
	        var nodeInputs = node.inputs;
	        // If any of the outputs lead to y, mark all of the inputs as leading to y.
	        for (var j = 0; j < node.outputs.length; j++) {
	            if (tensorsLeadToY[node.outputs[j].id]) {
	                for (var inputName in nodeInputs) {
	                    tensorsLeadToY[nodeInputs[inputName].id] = true;
	                    nodesToY[node.id] = true;
	                }
	                break;
	            }
	        }
	    }
	    // Return the paths that come from x and lead to y.
	    var filteredTape = [];
	    for (var i = 0; i < tape.length; i++) {
	        var node = tape[i];
	        if (nodesFromX[node.id] && nodesToY[node.id]) {
	            // Prune the inputs from the node that aren't a function of x.
	            var prunedInputs = {};
	            for (var inputName in node.inputs) {
	                var nodeInput = node.inputs[inputName];
	                if (tensorsFromX[nodeInput.id]) {
	                    prunedInputs[inputName] = nodeInput;
	                }
	            }
	            // Copy the node and overwrite inputsAndArgs to the pruned version.
	            var prunedNode = Object.assign({}, node);
	            prunedNode.inputs = prunedInputs;
	            prunedNode.outputs = node.outputs;
	            filteredTape.push(prunedNode);
	        }
	    }
	    return filteredTape;
	}
	exports.getFilteredNodesXToY = getFilteredNodesXToY;
	/**
	 * Backpropagate gradients through the filtered TapeNodes.
	 *
	 * @param tensorAccumulatedGradientMap A map of Tensor to its gradient. This map
	 * is mutated by this method.
	 * @param filteredTape The filtered TapeNodes to backprop through.
	 */
	function backpropagateGradients(tensorAccumulatedGradientMap, filteredTape, tidy) {
	    var _loop_1 = function (i) {
	        var node = filteredTape[i];
	        var dys = [];
	        node.outputs.forEach(function (o) {
	            var gradTensor = tensorAccumulatedGradientMap[o.id];
	            if (gradTensor != null) {
	                dys.push(gradTensor);
	            }
	            else {
	                // This particular output is not in the back-propagation subgraph, so it
	                // does not affect the final output, thus we put null for its dy.
	                dys.push(null);
	            }
	        });
	        if (node.gradient == null) {
	            throw new Error("Cannot compute gradient: gradient function not found " +
	                ("for " + node.kernelName + "."));
	        }
	        // Backprop dy through this node and accumulate gradients over the inputs.
	        var inputGradients = node.gradient(dys);
	        var _loop_2 = function (inputName) {
	            if (!(inputName in inputGradients)) {
	                throw new Error("Cannot backprop through input " + inputName + ". " +
	                    ("Available gradients found: " + Object.keys(inputGradients) + "."));
	            }
	            // Call the gradient function.
	            var dx = tidy(function () { return inputGradients[inputName](); });
	            if (dx.dtype !== 'float32') {
	                throw new Error("Error in gradient for op " + node.kernelName + ". The gradient of input " +
	                    (inputName + " must have 'float32' dtype, but has '" + dx.dtype + "'"));
	            }
	            var x = node.inputs[inputName];
	            if (!util.arraysEqual(dx.shape, x.shape)) {
	                throw new Error("Error in gradient for op " + node.kernelName + ". The gradient of input " +
	                    ("'" + inputName + "' has shape '" + dx.shape + "', which does not match ") +
	                    ("the shape of the input '" + x.shape + "'"));
	            }
	            if (tensorAccumulatedGradientMap[x.id] == null) {
	                tensorAccumulatedGradientMap[x.id] = dx;
	            }
	            else {
	                var curGradient = tensorAccumulatedGradientMap[x.id];
	                tensorAccumulatedGradientMap[x.id] = curGradient.add(dx);
	                curGradient.dispose();
	            }
	        };
	        for (var inputName in node.inputs) {
	            _loop_2(inputName);
	        }
	    };
	    // Walk the tape backward and keep a map of Tensor to its gradient.
	    for (var i = filteredTape.length - 1; i >= 0; i--) {
	        _loop_1(i);
	    }
	}
	exports.backpropagateGradients = backpropagateGradients;
	//# sourceMappingURL=tape.js.map

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(10);
	// Maximum number of values before we decide to show ellipsis.
	var FORMAT_LIMIT_NUM_VALS = 20;
	// Number of first and last values to show when displaying a, b,...,y, z.
	var FORMAT_NUM_FIRST_LAST_VALS = 3;
	// Number of significant digits to show.
	var FORMAT_NUM_SIG_DIGITS = 7;
	function tensorToString(vals, shape, dtype, verbose) {
	    var strides = util_1.computeStrides(shape);
	    var padPerCol = computeMaxSizePerColumn(vals, shape, dtype, strides);
	    var rank = shape.length;
	    var valsLines = subTensorToString(vals, shape, dtype, strides, padPerCol);
	    var lines = ['Tensor'];
	    if (verbose) {
	        lines.push("  dtype: " + dtype);
	        lines.push("  rank: " + rank);
	        lines.push("  shape: [" + shape + "]");
	        lines.push("  values:");
	    }
	    lines.push(valsLines.map(function (l) { return '    ' + l; }).join('\n'));
	    return lines.join('\n');
	}
	exports.tensorToString = tensorToString;
	function computeMaxSizePerColumn(vals, shape, dtype, strides) {
	    var n = util_1.sizeFromShape(shape);
	    var numCols = strides[strides.length - 1];
	    var padPerCol = new Array(numCols).fill(0);
	    var rank = shape.length;
	    var valuesOrTuples = dtype === 'complex64' ? createComplexTuples(vals) : vals;
	    if (rank > 1) {
	        for (var row = 0; row < n / numCols; row++) {
	            var offset = row * numCols;
	            for (var j = 0; j < numCols; j++) {
	                padPerCol[j] = Math.max(padPerCol[j], valToString(valuesOrTuples[offset + j], 0, dtype).length);
	            }
	        }
	    }
	    return padPerCol;
	}
	function valToString(val, pad, dtype) {
	    var valStr;
	    if (Array.isArray(val)) {
	        valStr = parseFloat(val[0].toFixed(FORMAT_NUM_SIG_DIGITS)) + " + " +
	            (parseFloat(val[1].toFixed(FORMAT_NUM_SIG_DIGITS)) + "j");
	    }
	    else if (util_1.isString(val)) {
	        valStr = "'" + val + "'";
	    }
	    else if (dtype === 'bool') {
	        valStr = boolNumToString(val);
	    }
	    else {
	        valStr = parseFloat(val.toFixed(FORMAT_NUM_SIG_DIGITS)).toString();
	    }
	    return util_1.rightPad(valStr, pad);
	}
	function boolNumToString(v) {
	    return v === 0 ? 'false' : 'true';
	}
	function subTensorToString(vals, shape, dtype, strides, padPerCol, isLast) {
	    if (isLast === void 0) { isLast = true; }
	    var storagePerElement = dtype === 'complex64' ? 2 : 1;
	    var size = shape[0];
	    var rank = shape.length;
	    if (rank === 0) {
	        if (dtype === 'complex64') {
	            var complexTuple = createComplexTuples(vals);
	            return [valToString(complexTuple[0], 0, dtype)];
	        }
	        if (dtype === 'bool') {
	            return [boolNumToString(vals[0])];
	        }
	        return [vals[0].toString()];
	    }
	    if (rank === 1) {
	        if (size > FORMAT_LIMIT_NUM_VALS) {
	            var firstValsSize = FORMAT_NUM_FIRST_LAST_VALS * storagePerElement;
	            var firstVals = Array.from(vals.slice(0, firstValsSize));
	            var lastVals = Array.from(vals.slice((size - FORMAT_NUM_FIRST_LAST_VALS) * storagePerElement, size * storagePerElement));
	            if (dtype === 'complex64') {
	                firstVals = createComplexTuples(firstVals);
	                lastVals = createComplexTuples(lastVals);
	            }
	            return [
	                '[' +
	                    firstVals.map(function (x, i) { return valToString(x, padPerCol[i], dtype); })
	                        .join(', ') +
	                    ', ..., ' +
	                    lastVals
	                        .map(function (x, i) { return valToString(x, padPerCol[size - FORMAT_NUM_FIRST_LAST_VALS + i], dtype); })
	                        .join(', ') +
	                    ']'
	            ];
	        }
	        var displayVals = dtype === 'complex64' ? createComplexTuples(vals) :
	            Array.from(vals);
	        return [
	            '[' +
	                displayVals.map(function (x, i) { return valToString(x, padPerCol[i], dtype); })
	                    .join(', ') +
	                ']'
	        ];
	    }
	    // The array is rank 2 or more.
	    var subshape = shape.slice(1);
	    var substrides = strides.slice(1);
	    var stride = strides[0] * storagePerElement;
	    var lines = [];
	    if (size > FORMAT_LIMIT_NUM_VALS) {
	        for (var i = 0; i < FORMAT_NUM_FIRST_LAST_VALS; i++) {
	            var start = i * stride;
	            var end = start + stride;
	            lines.push.apply(lines, subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, false /* isLast */));
	        }
	        lines.push('...');
	        for (var i = size - FORMAT_NUM_FIRST_LAST_VALS; i < size; i++) {
	            var start = i * stride;
	            var end = start + stride;
	            lines.push.apply(lines, subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, i === size - 1 /* isLast */));
	        }
	    }
	    else {
	        for (var i = 0; i < size; i++) {
	            var start = i * stride;
	            var end = start + stride;
	            lines.push.apply(lines, subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, i === size - 1 /* isLast */));
	        }
	    }
	    var sep = rank === 2 ? ',' : '';
	    lines[0] = '[' + lines[0] + sep;
	    for (var i = 1; i < lines.length - 1; i++) {
	        lines[i] = ' ' + lines[i] + sep;
	    }
	    var newLineSep = ',\n';
	    for (var i = 2; i < rank; i++) {
	        newLineSep += '\n';
	    }
	    lines[lines.length - 1] =
	        ' ' + lines[lines.length - 1] + ']' + (isLast ? '' : newLineSep);
	    return lines;
	}
	function createComplexTuples(vals) {
	    var complexTuples = [];
	    for (var i = 0; i < vals.length; i += 2) {
	        complexTuples.push([vals[i], vals[i + 1]]);
	    }
	    return complexTuples;
	}
	//# sourceMappingURL=tensor_format.js.map

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2017 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var engine_1 = __webpack_require__(15);
	var tensor_util_env_1 = __webpack_require__(17);
	var util_1 = __webpack_require__(10);
	var TEST_EPSILON_FLOAT32 = 1e-3;
	exports.TEST_EPSILON_FLOAT16 = 1e-1;
	function expectArraysClose(actual, expected, epsilon) {
	    if (epsilon == null) {
	        epsilon = testEpsilon();
	    }
	    return expectArraysPredicate(actual, expected, function (a, b) { return areClose(a, b, epsilon); });
	}
	exports.expectArraysClose = expectArraysClose;
	function testEpsilon() {
	    return engine_1.ENGINE.backend.floatPrecision() === 32 ? TEST_EPSILON_FLOAT32 :
	        exports.TEST_EPSILON_FLOAT16;
	}
	exports.testEpsilon = testEpsilon;
	function expectArraysPredicate(actual, expected, predicate) {
	    var checkClassType = true;
	    if (util_1.isTypedArray(actual) || util_1.isTypedArray(expected)) {
	        checkClassType = false;
	    }
	    if (util_1.isTypedArray(actual) && util_1.isTypedArray(expected)) {
	        checkClassType = true;
	    }
	    if (checkClassType) {
	        var aType = actual.constructor.name;
	        var bType = expected.constructor.name;
	        if (aType !== bType) {
	            throw new Error("Arrays are of different type. Actual: " + aType + ". " +
	                ("Expected: " + bType));
	        }
	    }
	    if (Array.isArray(actual) && Array.isArray(expected)) {
	        var actualShape = tensor_util_env_1.inferShape(actual);
	        var expectedShape = tensor_util_env_1.inferShape(expected);
	        if (!util_1.arraysEqual(actualShape, expectedShape)) {
	            throw new Error("Arrays have different shapes. " +
	                ("Actual: [" + actualShape + "]. Expected: [" + expectedShape + "]"));
	        }
	    }
	    var actualFlat = util_1.isTypedArray(actual) ? actual : util_1.flatten(actual);
	    var expectedFlat = util_1.isTypedArray(expected) ?
	        expected :
	        util_1.flatten(expected);
	    if (actualFlat.length !== expectedFlat.length) {
	        throw new Error("Arrays have different lengths actual: " + actualFlat.length + " vs " +
	            ("expected: " + expectedFlat.length + ".\n") +
	            ("Actual:   " + actualFlat + ".\n") +
	            ("Expected: " + expectedFlat + "."));
	    }
	    for (var i = 0; i < expectedFlat.length; ++i) {
	        var a = actualFlat[i];
	        var e = expectedFlat[i];
	        if (!predicate(a, e)) {
	            throw new Error("Arrays differ: actual[" + i + "] = " + a + ", expected[" + i + "] = " + e + ".\n" +
	                ("Actual:   " + actualFlat + ".\n") +
	                ("Expected: " + expectedFlat + "."));
	        }
	    }
	}
	function expectPromiseToFail(fn, done) {
	    fn().then(function () { return done.fail(); }, function () { return done(); });
	}
	exports.expectPromiseToFail = expectPromiseToFail;
	function expectArraysEqual(actual, expected) {
	    var exp = typeof expected === 'string' || typeof expected === 'number' ||
	        typeof expected === 'boolean' ?
	        [expected] :
	        expected;
	    if (util_1.isString(actual) || util_1.isString(actual[0]) ||
	        util_1.isString(expected) || util_1.isString(expected[0])) {
	        // tslint:disable-next-line: triple-equals
	        return expectArraysPredicate(actual, exp, function (a, b) { return a == b; });
	    }
	    return expectArraysPredicate(actual, expected, function (a, b) { return areClose(a, b, 0); });
	}
	exports.expectArraysEqual = expectArraysEqual;
	function expectNumbersClose(a, e, epsilon) {
	    if (epsilon == null) {
	        epsilon = testEpsilon();
	    }
	    if (!areClose(a, e, epsilon)) {
	        throw new Error("Numbers differ: actual === " + a + ", expected === " + e);
	    }
	}
	exports.expectNumbersClose = expectNumbersClose;
	function areClose(a, e, epsilon) {
	    if (!isFinite(a) && !isFinite(e)) {
	        return true;
	    }
	    if (isNaN(a) || isNaN(e) || Math.abs(a - e) > epsilon) {
	        return false;
	    }
	    return true;
	}
	function expectValuesInRange(actual, low, high) {
	    for (var i = 0; i < actual.length; i++) {
	        if (actual[i] < low || actual[i] > high) {
	            throw new Error("Value out of range:" + actual[i] + " low: " + low + ", high: " + high);
	        }
	    }
	}
	exports.expectValuesInRange = expectValuesInRange;
	function expectArrayBuffersEqual(actual, expected) {
	    // Safari & Jasmine don't like comparing ArrayBuffers directly. Wrapping in
	    // a Float32Array solves this issue.
	    expect(new Float32Array(actual)).toEqual(new Float32Array(expected));
	}
	exports.expectArrayBuffersEqual = expectArrayBuffersEqual;
	//# sourceMappingURL=test_util.js.map

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2018 Google Inc. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// So typings can propagate.
	var adadelta_optimizer_1 = __webpack_require__(321);
	var adagrad_optimizer_1 = __webpack_require__(322);
	var adam_optimizer_1 = __webpack_require__(323);
	var adamax_optimizer_1 = __webpack_require__(324);
	var momentum_optimizer_1 = __webpack_require__(325);
	var optimizer_constructors_1 = __webpack_require__(1073);
	var rmsprop_optimizer_1 = __webpack_require__(326);
	var sgd_optimizer_1 = __webpack_require__(240);
	// tslint:disable-next-line:no-unused-expression
	[momentum_optimizer_1.MomentumOptimizer, sgd_optimizer_1.SGDOptimizer, adadelta_optimizer_1.AdadeltaOptimizer, adagrad_optimizer_1.AdagradOptimizer,
	    rmsprop_optimizer_1.RMSPropOptimizer, adamax_optimizer_1.AdamaxOptimizer, adam_optimizer_1.AdamOptimizer];
	exports.train = {
	    sgd: optimizer_constructors_1.OptimizerConstructors.sgd,
	    momentum: optimizer_constructors_1.OptimizerConstructors.momentum,
	    adadelta: optimizer_constructors_1.OptimizerConstructors.adadelta,
	    adagrad: optimizer_constructors_1.OptimizerConstructors.adagrad,
	    rmsprop: optimizer_constructors_1.OptimizerConstructors.rmsprop,
	    adamax: optimizer_constructors_1.OptimizerConstructors.adamax,
	    adam: optimizer_constructors_1.OptimizerConstructors.adam
	};
	//# sourceMappingURL=train.js.map

/***/ },
/* 1084 */
/***/ function(module, exports) {

	"use strict";
	/** @license See the LICENSE file. */
	Object.defineProperty(exports, "__esModule", { value: true });
	// This code is auto-generated, do not modify this file!
	var version = '1.7.0';
	exports.version = version;
	//# sourceMappingURL=version.js.map

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * @license
	 * Copyright 2019 Google LLC. All Rights Reserved.
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * =============================================================================
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var gpgpu_util = __webpack_require__(482);
	exports.gpgpu_util = gpgpu_util;
	var webgl_util = __webpack_require__(189);
	exports.webgl_util = webgl_util;
	var environment_1 = __webpack_require__(28);
	var backend_webgl_1 = __webpack_require__(478);
	exports.MathBackendWebGL = backend_webgl_1.MathBackendWebGL;
	var canvas_util_1 = __webpack_require__(236);
	exports.setWebGLContext = canvas_util_1.setWebGLContext;
	var gpgpu_context_1 = __webpack_require__(481);
	exports.GPGPUContext = gpgpu_context_1.GPGPUContext;
	/**
	 * Enforce use of half precision textures if available on the platform.
	 */
	/** @doc {heading: 'Environment', namespace: 'webgl'} */
	function forceHalfFloat() {
	    environment_1.env().set('WEBGL_FORCE_F16_TEXTURES', true);
	}
	exports.forceHalfFloat = forceHalfFloat;
	//# sourceMappingURL=webgl.js.map

/***/ },
/* 1086 */
/***/ function(module, exports) {

	"use strict";
	
	function noop() {
	  return null;
	}
	
	noop.isRequired = noop;
	
	function noopThunk() {
	  return noop;
	}
	
	module.exports = {
	  and: noopThunk,
	  between: noopThunk,
	  booleanSome: noopThunk,
	  childrenHavePropXorChildren: noopThunk,
	  childrenOf: noopThunk,
	  childrenOfType: noopThunk,
	  childrenSequenceOf: noopThunk,
	  componentWithName: noopThunk,
	  disallowedIf: noopThunk,
	  elementType: noopThunk,
	  empty: noopThunk,
	  explicitNull: noopThunk,
	  forbidExtraProps: Object,
	  integer: noopThunk,
	  keysOf: noopThunk,
	  mutuallyExclusiveProps: noopThunk,
	  mutuallyExclusiveTrueProps: noopThunk,
	  nChildren: noopThunk,
	  nonNegativeInteger: noop,
	  nonNegativeNumber: noopThunk,
	  numericString: noopThunk,
	  object: noopThunk,
	  or: noopThunk,
	  predicate: noopThunk,
	  range: noopThunk,
	  ref: noopThunk,
	  requiredBy: noopThunk,
	  restrictedProp: noopThunk,
	  sequenceOf: noopThunk,
	  shape: noopThunk,
	  stringEndsWith: noopThunk,
	  stringStartsWith: noopThunk,
	  uniqueArray: noopThunk,
	  uniqueArrayOf: noopThunk,
	  valuesOf: noopThunk,
	  withShape: noopThunk
	};
	//# sourceMappingURL=index.js.map

/***/ },
/* 1087 */
/***/ function(module, exports) {

	/**
	 * Array.prototype.findIndex
	 *
	 * @ref https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
	 */
	
	module.exports = (function() {
	    if (!Array.prototype.findIndex) {
	        Array.prototype.findIndex = function(predicate) {
	            if (this === null) {
	                throw new TypeError('Array.prototype.findIndex called on null or undefined');
	            }
	
	            if (typeof predicate !== 'function') {
	                throw new TypeError('predicate must be a function');
	            }
	
	            var list = Object(this);
	            var length = list.length >>> 0;
	            var thisArg = arguments[1];
	            var value;
	
	            for (var i = 0; i < length; i++) {
	                value = list[i];
	                if (predicate.call(thisArg, value, i, list)) {
	                    return i;
	                }
	            }
	
	            return -1;
	        };
	    }
	})();


/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(94);
	var callBind = __webpack_require__(248);
	
	var implementation = __webpack_require__(499);
	var getPolyfill = __webpack_require__(500);
	var polyfill = getPolyfill();
	var shim = __webpack_require__(1089);
	
	var boundFlat = callBind(polyfill);
	
	define(boundFlat, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = boundFlat;


/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(94);
	var shimUnscopables = __webpack_require__(1393);
	
	var getPolyfill = __webpack_require__(500);
	
	module.exports = function shimFlat() {
		var polyfill = getPolyfill();
	
		define(
			Array.prototype,
			{ flat: polyfill },
			{ flat: function () { return Array.prototype.flat !== polyfill; } }
		);
	
		shimUnscopables('flat');
	
		return polyfill;
	};


/***/ },
/* 1090 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var objectAssign = __webpack_require__(421)();
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	// NB: The URL to the CommonJS spec is kept just for tradition.
	//     node-assert has evolved a lot since then, both in API and behavior.
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(952);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	// Expose a strict only variant of assert
	function strict(value, message) {
	  if (!value) fail(value, true, message, '==', strict);
	}
	assert.strict = objectAssign(strict, assert, {
	  equal: assert.strictEqual,
	  deepEqual: assert.deepStrictEqual,
	  notEqual: assert.notStrictEqual,
	  notDeepEqual: assert.notDeepStrictEqual
	});
	assert.strict.strict = assert.strict;
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(76);
	var bind = __webpack_require__(505);
	var Axios = __webpack_require__(1094);
	var defaults = __webpack_require__(327);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(502);
	axios.CancelToken = __webpack_require__(1093);
	axios.isCancel = __webpack_require__(503);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(1108);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(502);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(327);
	var utils = __webpack_require__(76);
	var InterceptorManager = __webpack_require__(1095);
	var dispatchRequest = __webpack_require__(1096);
	var isAbsoluteURL = __webpack_require__(1104);
	var combineURLs = __webpack_require__(1102);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(76);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(76);
	var transformData = __webpack_require__(1099);
	var isCancel = __webpack_require__(503);
	var defaults = __webpack_require__(327);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 1097 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.response = response;
	  return error;
	};


/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(504);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response
	    ));
	  }
	};


/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(76);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 1100 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(76);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 1102 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(76);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 1104 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(76);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(76);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(76);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 1108 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(19);
	
	var _reduxForm = __webpack_require__(16);
	
	var _reactIntl = __webpack_require__(26);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _TopScrolleable = __webpack_require__(53);
	
	var _TopScrolleable2 = _interopRequireDefault(_TopScrolleable);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	var _RenderField = __webpack_require__(78);
	
	var _RenderField2 = _interopRequireDefault(_RenderField);
	
	var _CustomAlert = __webpack_require__(77);
	
	var _CustomAlert2 = _interopRequireDefault(_CustomAlert);
	
	var _CustomAutosuggestMobileFriendly = __webpack_require__(1119);
	
	var _CustomAutosuggestMobileFriendly2 = _interopRequireDefault(_CustomAutosuggestMobileFriendly);
	
	var _FlowProgressBar = __webpack_require__(83);
	
	var _FlowProgressBar2 = _interopRequireDefault(_FlowProgressBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddressForm = function (_Component) {
	    _inherits(AddressForm, _Component);
	
	    function AddressForm(props) {
	        _classCallCheck(this, AddressForm);
	
	        var _this = _possibleConstructorReturn(this, (AddressForm.__proto__ || Object.getPrototypeOf(AddressForm)).call(this, props));
	
	        _this.state = {
	            state_id: null,
	            cities: null,
	            loadingState: true
	        };
	
	        _this.handleCitySelect = _this.handleCitySelect.bind(_this);
	        return _this;
	    }
	
	    _createClass(AddressForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            var config = {
	                headers: {
	                    'Content-Type': 'application/json',
	                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                }
	            };
	            _axios2.default.get(ROOT_URL + '/leads/details', config).then(function (response) {
	                _this2.setState({
	                    state_id: response.data.state_id,
	                    loadingState: false
	                });
	            });
	        }
	    }, {
	        key: 'handleCitySelect',
	        value: function handleCitySelect(city) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                form = _props.form;
	
	
	            dispatch((0, _reduxForm.change)(form, 'zip_code', city.zip_code));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                handleSubmit = _props2.handleSubmit,
	                submitting = _props2.submitting,
	                isLoading = _props2.isLoading,
	                error = _props2.error;
	            var _state = this.state,
	                loadingState = _state.loadingState,
	                state_id = _state.state_id;
	
	
	            var incomeField = _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 col-md-12 col-lg-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'income', autoComplete: 'off', component: _RenderField2.default, type: 'number', label: 'Ingreso Neto Mensual' })
	                    )
	                )
	            );
	
	            return _react2.default.createElement(
	                _Section2.default,
	                { className: 'intro_form' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-left col-md-5 col-lg-5 text-center' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-img' },
	                            _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(61) })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-message' },
	                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.step_address', description: 'Personal info' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-right col-sm-12 col-md-7 col-lg-7' },
	                        _react2.default.createElement(_FlowProgressBar2.default, null),
	                        _react2.default.createElement(
	                            'form',
	                            { onSubmit: handleSubmit(this.props.saveAddress), className: 'pvc-form', autoComplete: 'asd' },
	                            (isLoading || loadingState) && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	                            error && _react2.default.createElement(_CustomAlert2.default, { bsStyle: 'danger', message: error }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'form_locality', autoComplete: 'asd', component: _CustomAutosuggestMobileFriendly2.default, selectedState: state_id, onChange: this.handleCitySelect, type: 'text', label: 'Localidad' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'address_street', autoComplete: 'off', component: _RenderField2.default, type: 'text', label: 'Calle y N\xFAmero' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'address_description', autoComplete: 'off', component: _RenderField2.default, type: 'text', label: 'N\xB0 dpto, N\xB0 piso, etc' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'zip_code', autoComplete: 'off', component: _RenderField2.default, type: 'number', label: 'C\xF3digo Postal' })
	                                    )
	                                )
	                            ),
	                            ("montemar-card-calf") !== 'montemar' && incomeField,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'submit', className: 'btn btn-warning btn-lg pd-button pd-form', disabled: submitting },
	                                        'Seguir'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AddressForm;
	}(_react.Component);
	
	AddressForm = (0, _TopScrolleable2.default)(AddressForm);
	
	AddressForm = (0, _reduxForm.reduxForm)({
	    form: 'AddressForm' // a unique name for this form
	})(AddressForm);
	
	AddressForm = (0, _Auth2.default)(AddressForm);
	
	exports.default = AddressForm;

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(16);
	
	var _reactIntl = __webpack_require__(26);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _TopScrolleable = __webpack_require__(53);
	
	var _TopScrolleable2 = _interopRequireDefault(_TopScrolleable);
	
	var _generateValidator = __webpack_require__(130);
	
	var _generateValidator2 = _interopRequireDefault(_generateValidator);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _RenderField = __webpack_require__(78);
	
	var _RenderField2 = _interopRequireDefault(_RenderField);
	
	var _SelectField = __webpack_require__(121);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _AttributeOptions = __webpack_require__(194);
	
	var _AttributeOptions2 = _interopRequireDefault(_AttributeOptions);
	
	var _FieldInformation = __webpack_require__(329);
	
	var _FieldInformation2 = _interopRequireDefault(_FieldInformation);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	var _CustomAlert = __webpack_require__(77);
	
	var _CustomAlert2 = _interopRequireDefault(_CustomAlert);
	
	var _FlowProgressBar = __webpack_require__(83);
	
	var _FlowProgressBar2 = _interopRequireDefault(_FlowProgressBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Affidavit = function (_Component) {
	    _inherits(Affidavit, _Component);
	
	    function Affidavit(props) {
	        _classCallCheck(this, Affidavit);
	
	        var _this = _possibleConstructorReturn(this, (Affidavit.__proto__ || Object.getPrototypeOf(Affidavit)).call(this, props));
	
	        _this.state = {
	            showSourceOfFundsDetail: false
	        };
	        _this.checkSourceOfFundsValue = _this.checkSourceOfFundsValue.bind(_this);
	        return _this;
	    }
	
	    _createClass(Affidavit, [{
	        key: 'checkSourceOfFundsValue',
	        value: function checkSourceOfFundsValue(value) {
	            if (value == 3) {
	                this.setState({ showSourceOfFundsDetail: true });
	            } else {
	                this.setState({ showSourceOfFundsDetail: false });
	                this.props.deleteReduxFormField('source_of_funds_description');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var showSourceOfFundsDetail = this.state.showSourceOfFundsDetail;
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting,
	                error = _props.error;
	
	
	            var sourceOfFundsDetailField = _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12 col-lg-12 vcenter' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2.default.createElement(_reduxForm.Field, {
	                        className: 'form-control',
	                        name: 'source_of_funds_description',
	                        autoComplete: 'off',
	                        component: _RenderField2.default,
	                        label: 'Detallar el origen de fondos',
	                        type: 'textarea',
	                        fieldInfo: {
	                            title: 'Detalle de origen de fondos',
	                            info: 'Adicionalmente la Entidad podrá solicitar la documentación respaldatoria que justifica el origen de fondos.'
	                        }
	                    })
	                )
	            );
	            return _react2.default.createElement(
	                _Section2.default,
	                { className: 'intro_form' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-left col-md-5 col-lg-5 text-center' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-img' },
	                            _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(61) })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-message' },
	                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.step_affidavit', description: 'Affidavit info' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-right col-sm-12 col-md-7 col-lg-7' },
	                        _react2.default.createElement(_FlowProgressBar2.default, null),
	                        _react2.default.createElement(
	                            'form',
	                            { onSubmit: handleSubmit(this.props.sentAffidavit), className: 'pvc-form' },
	                            this.props.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	                            error && _react2.default.createElement(_CustomAlert2.default, { bsStyle: 'danger', message: error }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_reduxForm.Field, {
	                                            className: 'form-control',
	                                            name: 'public_figure',
	                                            component: _RenderField2.default,
	                                            showLabel: false,
	                                            type: 'switch',
	                                            label: '\xBFSos una persona expuesta pol\xEDticamente (P.E.P.)?',
	                                            fieldInfo: {
	                                                title: '¿Qué significa ser una Persona Expuesta Políticamente?',
	                                                info: 'Son los funcionarios públicos, diplomáticos, sus cónyugues o convivientes reconocidos legalmente y familiares en línea ascendiente, descendiente o colateral hasta el tercer grado.'
	                                            }
	                                        })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_reduxForm.Field, {
	                                            className: 'form-control',
	                                            name: 'bound_subject',
	                                            component: _RenderField2.default,
	                                            type: 'switch',
	                                            label: '\xBFSos Sujeto Obligado ante la U.I.F.?',
	                                            fieldInfo: {
	                                                title: '¿Qué significa ser Sujeto Obligado?',
	                                                info: 'Son las personas que están obligadas al cumplimiento de obligaciones destinadas a prevenir, impedir y detectar el lavado de dinero.'
	                                            }
	                                        })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_reduxForm.Field, {
	                                            className: 'form-control',
	                                            name: 'foreign_tax_residence',
	                                            component: _RenderField2.default,
	                                            type: 'switch',
	                                            label: '\xBFSos residente fiscal en un pa\xEDs distinto de la Rep\xFAblica Agentina?',
	                                            fieldInfo: {
	                                                title: 'Debés responder afirmativamente si reunís alguna de las siguientes condiciones:',
	                                                info: '1) Pagás impuestos por tenencia de bienes o actividades realizadas en otro/s país/es.<br/>2) Tenés un número de identificación tributaria emitido por otro/s país/es.'
	                                            }
	                                        })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_reduxForm.Field, {
	                                            className: 'form-control',
	                                            name: 'american_person',
	                                            component: _RenderField2.default,
	                                            type: 'switch',
	                                            label: '\xBFSos persona estadounidense a los efectos de F.A.C.T.A.?',
	                                            fieldInfo: {
	                                                title: 'Debés responder afirmativamente si reunís alguna de las siguientes condiciones:',
	                                                info: '1) Ciudadano estadounidense con Pasaporte estadounidense.<br/>2) Residente en Estados Unidos o sus estados asociados con Tarjeta de Residencia (Green Card)<br/>3) Residente Parcial en Estados Unidos o sus estados asociados (183 días en 1 año calendario, o 122 días en promedio en los últimos 3 años calendario.)'
	                                            }
	                                        })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row', style: { marginTop: '15px' } },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 col-lg-12' },
	                                    'Origen de fondos: ',
	                                    _react2.default.createElement(_FieldInformation2.default, { title: 'Origen de fondos', info: 'Por el presente manifiesto bajo juramento de decir la verdad en cuanto a que todos los fondos y valores entregados o que se entreguen en el futuro a Montemar C.F.S.A., son y serán de fuente lícita.<br/>Asimismo, manifiesto que toda información proporcionada a Montemar C.F.S.A., es exacta, completa y verdadera y me comprometo a informar de inmediato cualquier cambio que se produzca en el futuro; asimismo reconozco y acepto que Montemar C.F.S.A. podrá en cualquier momento solicitar información adicional y/o actualización de la misma en cumplimiento con lo establecido por la ley 25.246 y las Resoluciones vigentes emitidas por la UIF.' })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-12 col-sm-12 col-md-5 col-lg-5 vcenter' },
	                                    ' Mis fondos provienen de:'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-12 col-md-7 col-lg-7 vcenter' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_AttributeOptions2.default, {
	                                            name: 'source_of_funds',
	                                            defaultValue: 'Seleccionar un Origen',
	                                            label: 'Seleccionar un Origen',
	                                            attributeName: 'source_of_funds',
	                                            attributeOptions: [{ id: 1, name: 'Ingresos/Ahorros personales provenientes de la actividad profesional' }, { id: 2, name: 'Laboral o comercial' }, { id: 3, name: 'Otro' }],
	                                            onChange: this.checkSourceOfFundsValue
	                                        })
	                                    )
	                                ),
	                                showSourceOfFundsDetail && sourceOfFundsDetailField
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'submit', className: 'btn btn-warning btn-lg pd-button pd-form', disabled: submitting },
	                                        'Seguir'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Affidavit;
	}(_react.Component);
	
	var validate = (0, _generateValidator2.default)([{ name: 'source_of_funds', required: true }, { name: 'source_of_funds_description', required: true }]);
	
	Affidavit = (0, _TopScrolleable2.default)(Affidavit);
	
	Affidavit = (0, _reduxForm.reduxForm)({
	    initialValues: {
	        public_figure: false,
	        bound_subject: false,
	        foreign_tax_residence: false,
	        american_person: false
	    },
	    form: 'Affidavit', // a unique name for this form
	    validate: validate
	})(Affidavit);
	
	Affidavit = (0, _Auth2.default)(Affidavit);
	
	exports.default = Affidavit;

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(16);
	
	var _CustomAlert = __webpack_require__(77);
	
	var _CustomAlert2 = _interopRequireDefault(_CustomAlert);
	
	var _RenderField = __webpack_require__(78);
	
	var _RenderField2 = _interopRequireDefault(_RenderField);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AuthForm = function (_Component) {
	    _inherits(AuthForm, _Component);
	
	    function AuthForm() {
	        _classCallCheck(this, AuthForm);
	
	        return _possibleConstructorReturn(this, (AuthForm.__proto__ || Object.getPrototypeOf(AuthForm)).apply(this, arguments));
	    }
	
	    _createClass(AuthForm, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: handleSubmit(this.props.changeSubscriptionEmail), className: 'pvc-form' },
	                    this.props.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	                    !this.props.error && _react2.default.createElement(_CustomAlert2.default, { bsStyle: 'warning', message: 'Este documento est\xE1 asociado a otro email.', description: 'Por favor ingrese el email que se utiliz\xF3 para su primer solicitud.' }),
	                    this.props.error && _react2.default.createElement(_CustomAlert2.default, { bsStyle: 'danger', message: this.props.error }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-lg-12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'form-group' },
	                                _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'email', autoComplete: 'off', component: _RenderField2.default, type: 'email', label: 'Email', showSuccess: true })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { type: 'submit', className: 'btn btn-warning btn-lg pd-button pd-form loan', disabled: submitting },
	                        'Verificar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AuthForm;
	}(_react.Component);
	
	AuthForm = (0, _reduxForm.reduxForm)({
	    form: 'auth-form'
	})(AuthForm);
	
	exports.default = AuthForm;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(16);
	
	var _reactIntl = __webpack_require__(26);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _RenderField = __webpack_require__(78);
	
	var _RenderField2 = _interopRequireDefault(_RenderField);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	var _CustomAlert = __webpack_require__(77);
	
	var _CustomAlert2 = _interopRequireDefault(_CustomAlert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CbuForm = function (_Component) {
	    _inherits(CbuForm, _Component);
	
	    function CbuForm() {
	        _classCallCheck(this, CbuForm);
	
	        return _possibleConstructorReturn(this, (CbuForm.__proto__ || Object.getPrototypeOf(CbuForm)).apply(this, arguments));
	    }
	
	    _createClass(CbuForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            setTimeout(function () {
	                window.scrollTo(0, 0);
	            }, 2000);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting,
	                error = _props.error;
	
	            return _react2.default.createElement(
	                _Section2.default,
	                { className: 'intro_form' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-left col-md-5 col-lg-5 text-center' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-img' },
	                            _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(61) })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-message' },
	                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.step_cbu', description: 'Cbu info' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-right short-content col-sm-12 col-md-7 col-lg-7' },
	                        _react2.default.createElement(
	                            'form',
	                            { onSubmit: handleSubmit(this.props.verifyCbu), className: 'pvc-form' },
	                            this.props.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	                            error && _react2.default.createElement(_CustomAlert2.default, { bsStyle: 'danger', message: error }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'cbu', autoComplete: 'off', component: _RenderField2.default, type: 'number', label: 'CBU Cuenta Sueldo' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'submit', className: 'btn btn-warning btn-lg pd-button pd-form', disabled: submitting },
	                                        'Seguir'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CbuForm;
	}(_react.Component);
	
	CbuForm = (0, _reduxForm.reduxForm)({
	    form: 'CbuForm' // a unique name for this form
	})(CbuForm);
	
	CbuForm = (0, _Auth2.default)(CbuForm);
	
	exports.default = CbuForm;

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Summary = __webpack_require__(1175);
	
	var _Summary2 = _interopRequireDefault(_Summary);
	
	var _MontemarSummary = __webpack_require__(1144);
	
	var _MontemarSummary2 = _interopRequireDefault(_MontemarSummary);
	
	var _MontemarOnlineSummary = __webpack_require__(1143);
	
	var _MontemarOnlineSummary2 = _interopRequireDefault(_MontemarOnlineSummary);
	
	var _ContractsContainer = __webpack_require__(1192);
	
	var _ContractsContainer2 = _interopRequireDefault(_ContractsContainer);
	
	var _reactBootstrap = __webpack_require__(40);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _TopScrolleable = __webpack_require__(53);
	
	var _TopScrolleable2 = _interopRequireDefault(_TopScrolleable);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _FlowProgressBar = __webpack_require__(83);
	
	var _FlowProgressBar2 = _interopRequireDefault(_FlowProgressBar);
	
	var _LeadInfo = __webpack_require__(244);
	
	var _LeadInfo2 = _interopRequireDefault(_LeadInfo);
	
	var _reactIntl = __webpack_require__(26);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(1400);
	
	var CheckOut = function (_Component) {
	    _inherits(CheckOut, _Component);
	
	    function CheckOut(props) {
	        _classCallCheck(this, CheckOut);
	
	        var _this = _possibleConstructorReturn(this, (CheckOut.__proto__ || Object.getPrototypeOf(CheckOut)).call(this, props));
	
	        _this.state = {
	            digital_loan: null
	        };
	        return _this;
	    }
	
	    _createClass(CheckOut, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            var config = {
	                headers: {
	                    'Content-Type': 'application/json',
	                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                }
	            };
	
	            _axios2.default.get(ROOT_URL + '/leads/digital', config).then(function (res) {
	                var data = res.data;
	                _this2.setState(Object.assign({}, _this2.state, {
	                    digital_loan: data.result
	                }));
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var clientName = this.props.clientName;
	
	            var summaryComponent = void 0;
	
	            switch (("montemar-card-calf")) {
	                case 'montemar':
	                    if (this.state.digital_loan) {
	                        summaryComponent = _react2.default.createElement(_MontemarOnlineSummary2.default, null);
	                    } else {
	                        summaryComponent = _react2.default.createElement(_MontemarSummary2.default, null);
	                    }
	                    break;
	                default:
	                    summaryComponent = _react2.default.createElement(_Summary2.default, null);
	            }
	
	            return _react2.default.createElement(
	                _Section2.default,
	                { className: 'intro_form' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-lg-12 text-center checkout-header' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-img' },
	                            _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(61) })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-message' },
	                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.step_checkout', description: 'Checkout info', values: { nameClient: clientName } })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'show-mobile-progress-bar' },
	                            _react2.default.createElement(_FlowProgressBar2.default, null)
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'checkout-form' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary-container', xs: 12, md: 8, lg: 5 },
	                            summaryComponent
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12, md: 4, lg: 7 },
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { className: 'terms-container', xs: 12, md: 4, lg: 11 },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'show-desktop-progress-bar' },
	                                        _react2.default.createElement(_FlowProgressBar2.default, null)
	                                    ),
	                                    _react2.default.createElement(_ContractsContainer2.default, null)
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CheckOut;
	}(_react.Component);
	
	CheckOut = (0, _TopScrolleable2.default)(CheckOut);
	
	CheckOut = (0, _LeadInfo2.default)(CheckOut);
	
	CheckOut = (0, _Auth2.default)(CheckOut);
	
	exports.default = CheckOut;

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CheckStubForm = __webpack_require__(1115);
	
	var _CheckStubForm2 = _interopRequireDefault(_CheckStubForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CheckStubArrayForm = function CheckStubArrayForm(_ref) {
	    var fields = _ref.fields,
	        deleteReduxFormField = _ref.deleteReduxFormField,
	        _ref$meta = _ref.meta,
	        error = _ref$meta.error,
	        submitFailed = _ref$meta.submitFailed;
	
	    var descriptions = [];
	    switch (fields.length) {
	        case 1:
	            descriptions = ['Datos de tu recibo de sueldo'];
	            break;
	        case 2:
	            descriptions = ['1º Quincena', '2º Quincena'];
	            break;
	        default:
	            descriptions = [];
	
	    }
	    return _react2.default.createElement(
	        'div',
	        null,
	        fields.map(function (member, index) {
	            return _react2.default.createElement(_CheckStubForm2.default, { member: member, key: index, description: descriptions[index], deleteReduxFormField: deleteReduxFormField });
	        })
	    );
	};
	
	exports.default = CheckStubArrayForm;

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(16);
	
	var _RenderField = __webpack_require__(78);
	
	var _RenderField2 = _interopRequireDefault(_RenderField);
	
	var _CustomIncomeDateSelect = __webpack_require__(1123);
	
	var _CustomIncomeDateSelect2 = _interopRequireDefault(_CustomIncomeDateSelect);
	
	var _TextWithLine = __webpack_require__(332);
	
	var _TextWithLine2 = _interopRequireDefault(_TextWithLine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckStubForm = function (_Component) {
	    _inherits(CheckStubForm, _Component);
	
	    function CheckStubForm(props) {
	        _classCallCheck(this, CheckStubForm);
	
	        var _this = _possibleConstructorReturn(this, (CheckStubForm.__proto__ || Object.getPrototypeOf(CheckStubForm)).call(this, props));
	
	        _this.state = {
	            show_secondary_row: false,
	            full_remuneration: 0,
	            discounts: 0
	
	        };
	        _this.checkDiscountValue = _this.checkDiscountValue.bind(_this);
	        _this.renderDiscountField = _this.renderDiscountField.bind(_this);
	        _this.checkFullRemunerationValue = _this.checkFullRemunerationValue.bind(_this);
	        _this.renderFullRemunerationField = _this.renderFullRemunerationField.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(CheckStubForm, [{
	        key: 'checkDiscountValue',
	        value: function checkDiscountValue(value) {
	            if (value > this.state.full_remuneration * 0.20) {
	                this.setState({ show_secondary_row: true, discounts: value });
	            } else {
	                this.setState({ show_secondary_row: false, discounts: value });
	                this.props.deleteReduxFormField(this.props.member + '.loan_installment');
	                this.props.deleteReduxFormField(this.props.member + '.foreclosures_amount');
	                this.props.deleteReduxFormField(this.props.member + '.alimony');
	                this.props.deleteReduxFormField(this.props.member + '.another_charges');
	            }
	        }
	    }, {
	        key: 'checkFullRemunerationValue',
	        value: function checkFullRemunerationValue(value) {
	            if (value * 0.20 < this.state.discounts) {
	                this.setState({ show_secondary_row: true, full_remuneration: value });
	            } else {
	                this.setState({ show_secondary_row: false, full_remuneration: value });
	                this.props.deleteReduxFormField(this.props.member + '.loan_installment');
	                this.props.deleteReduxFormField(this.props.member + '.foreclosures_amount');
	                this.props.deleteReduxFormField(this.props.member + '.alimony');
	                this.props.deleteReduxFormField(this.props.member + '.another_charges');
	            }
	        }
	    }, {
	        key: 'renderDiscountField',
	        value: function renderDiscountField(props) {
	            var _this2 = this;
	
	            var customOnChange = function customOnChange(event) {
	                props.input.onChange(event);
	                _this2.checkDiscountValue(event);
	            };
	            var field_props = Object.assign({}, props, { input: Object.assign({}, props.input, { onChange: customOnChange }) });
	            return _react2.default.createElement(_RenderField2.default, field_props);
	        }
	    }, {
	        key: 'renderFullRemunerationField',
	        value: function renderFullRemunerationField(props) {
	            var _this3 = this;
	
	            var customOnChange = function customOnChange(event) {
	                props.input.onChange(event);
	                _this3.checkFullRemunerationValue(event);
	            };
	            var field_props = Object.assign({}, props, { input: Object.assign({}, props.input, { onChange: customOnChange }) });
	            return _react2.default.createElement(_RenderField2.default, field_props);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                member = _props.member,
	                description = _props.description;
	
	            var discounts_detail = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 col-md-12 col-lg-12' },
	                        _react2.default.createElement(_TextWithLine2.default, { value: 'Detall\xE1 monto de los descuentos:' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 col-md-6 col-lg-6' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: member + '.loan_installment', autoComplete: 'off', component: _RenderField2.default, type: 'currency', label: 'Cuotas Pr\xE9stamos' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 col-md-6 col-lg-6' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: member + '.alimony', autoComplete: 'off', component: _RenderField2.default, type: 'currency', label: 'Cuotas Manuntenci\xF3n/Alimentos' })
	                        )
	                    )
	                )
	            );
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 col-md-12 col-lg-12' },
	                        _react2.default.createElement(_TextWithLine2.default, { value: description })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 col-md-4 col-lg-4' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(_reduxForm.Field, { name: member + '.remuneration_date', props: { placeholder: 'Fecha' }, component: _CustomIncomeDateSelect2.default, label: 'Fecha Cobro' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 col-md-4 col-lg-4' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(_reduxForm.Field, { className: 'form-control',
	                                name: member + '.full_remuneration',
	                                autoComplete: 'off',
	                                component: this.renderFullRemunerationField,
	                                type: 'currency',
	                                label: 'Monto Bruto' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 col-md-4 col-lg-4' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            _react2.default.createElement(_reduxForm.Field, { className: 'form-control',
	                                name: member + '.discounts',
	                                autoComplete: 'off',
	                                component: this.renderDiscountField,
	                                type: 'currency',
	                                label: 'Descuentos' })
	                        )
	                    )
	                ),
	                this.state.show_secondary_row && discounts_detail
	            );
	        }
	    }]);
	
	    return CheckStubForm;
	}(_react.Component);
	
	exports.default = CheckStubForm;

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _TopScrolleable = __webpack_require__(53);
	
	var _TopScrolleable2 = _interopRequireDefault(_TopScrolleable);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactIntl = __webpack_require__(26);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	var _FlowProgressBar = __webpack_require__(83);
	
	var _FlowProgressBar2 = _interopRequireDefault(_FlowProgressBar);
	
	var _LeadInfo = __webpack_require__(244);
	
	var _LeadInfo2 = _interopRequireDefault(_LeadInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Congratulations = function (_Component) {
	    _inherits(Congratulations, _Component);
	
	    function Congratulations(props) {
	        _classCallCheck(this, Congratulations);
	
	        var _this = _possibleConstructorReturn(this, (Congratulations.__proto__ || Object.getPrototypeOf(Congratulations)).call(this, props));
	
	        _this.state = {
	            hash_id: null,
	            provider_phone: null
	        };
	        return _this;
	    }
	
	    _createClass(Congratulations, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            var config = {
	                headers: {
	                    'Content-Type': 'application/json',
	                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                }
	            };
	
	            _axios2.default.get(ROOT_URL + '/leads/details', config).then(function (res) {
	                var data = res.data;
	                _this2.setState({ 'hash_id': data.id });
	            });
	
	            _axios2.default.get(ROOT_URL + '/providers/lead', config).then(function (response) {
	                var provider = response.data;
	                _this2.setState({ 'provider_phone': provider.phone });
	            });
	
	            _axios2.default.get(ROOT_URL + '/leads/congratulations', config);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var clientName = this.props.clientName;
	
	
	            return _react2.default.createElement(
	                _Section2.default,
	                { className: 'intro_form' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-left col-md-5 col-lg-5 text-center' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-img' },
	                            _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(61) })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-message' },
	                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.step_congratulations', description: 'Congratulations info', values: { nameClient: clientName } })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-right col-sm-12 col-md-7 col-lg-7' },
	                        this.props.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	                        _react2.default.createElement(_FlowProgressBar2.default, null),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'pvc-container text-center' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'En breve, te vamos a contactar a tu celular para una \xFAltima verificaci\xF3n. Guard\xE1 el n\xFAmero de referencia de tu pr\xE9stamo:'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'h4',
	                                { className: 'pd-hash-value' },
	                                this.state.hash_id || "Cargando..."
	                            ),
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'GRACIAS y DISFRUT\xC1 de tu Dinero'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Congratulations;
	}(_react.Component);
	
	Congratulations = (0, _TopScrolleable2.default)(Congratulations);
	
	Congratulations = (0, _LeadInfo2.default)(Congratulations);
	
	Congratulations = (0, _Auth2.default)(Congratulations);
	
	exports.default = Congratulations;

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reduxForm = __webpack_require__(16);
	
	var _reactBootstrap = __webpack_require__(40);
	
	var _PdfBody = __webpack_require__(1146);
	
	var _PdfBody2 = _interopRequireDefault(_PdfBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(1424);
	__webpack_require__(1428);
	
	var Contract = function (_Component) {
	    _inherits(Contract, _Component);
	
	    function Contract(props) {
	        _classCallCheck(this, Contract);
	
	        var _this = _possibleConstructorReturn(this, (Contract.__proto__ || Object.getPrototypeOf(Contract)).call(this, props));
	
	        _this.state = {
	            showModal: false,
	            contractText: false,
	            link: null,
	            contract_accepted: false
	        };
	
	        _this.acceptContract = _this.acceptContract.bind(_this);
	        _this.closeContract = _this.closeContract.bind(_this);
	        _this.openContract = _this.openContract.bind(_this);
	        return _this;
	    }
	
	    _createClass(Contract, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            if (!this.props.hasOwnProperty('text')) {
	                var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	                var config = {
	                    headers: {
	                        'Content-Type': 'application/json',
	                        'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                    }
	                };
	                _axios2.default.get(ROOT_URL + '/leads/contracts/' + this.props.form, config).then(function (response) {
	                    _this2.setState({
	                        contractText: response.data.body,
	                        link: response.data.link
	                    });
	                    _this2.props.dispatch((0, _reduxForm.change)(_this2.props.form, 'contract_accepted', response.data.accepted));
	                });
	            }
	        }
	    }, {
	        key: 'closeContract',
	        value: function closeContract() {
	            this.setState(Object.assign({}, this.state, { showModal: false }));
	        }
	    }, {
	        key: 'openContract',
	        value: function openContract() {
	            this.setState(Object.assign({}, this.state, { showModal: true }));
	        }
	    }, {
	        key: 'acceptContract',
	        value: function acceptContract(dispatch) {
	            this.props.dispatch((0, _reduxForm.change)(this.props.form, 'contract_accepted', true));
	            this.setState({
	                showModal: false
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                onSubmit = _props.onSubmit,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting,
	                checked = _props.checked,
	                text = _props.text,
	                label = _props.label;
	            //const { handleSubmit, submitting, checked } = this.props;
	
	            var _state = this.state,
	                link = _state.link,
	                contractText = _state.contractText,
	                showModal = _state.showModal;
	
	
	            var contractBody = link ? _react2.default.createElement(_PdfBody2.default, { urlFile: link }) : _react2.default.createElement('div', {
	                dangerouslySetInnerHTML: { __html: contractText || text } });
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'terms_row' },
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: 'terms_col terms_checkbox text-center', xs: 12, md: 6, lg: 6 },
	                    _react2.default.createElement(_reduxForm.Field, {
	                        name: 'contract_accepted',
	                        label: label,
	                        component: function component(props) {
	                            return _react2.default.createElement(
	                                _reactBootstrap.Checkbox,
	                                { checked: props.input.value, onClick: _this3.openContract },
	                                label,
	                                ' '
	                            );
	                        }
	                    })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: 'terms_col', xs: 12, md: 6, lg: 6 },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { className: "btn btn-warning btn-sm pd-simple-button pd-button-contract " + (checked ? 'pd-button-accepted-contract' : ''), onClick: this.openContract, disabled: submitting },
	                        submitting ? 'Cargando...' : checked ? 'Leído y aceptado' : 'Por favor, leer y aceptar'
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal,
	                        { className: 'custom-modal', show: showModal, onHide: this.closeContract, bsSize: 'large' },
	                        _react2.default.createElement(
	                            'form',
	                            { onSubmit: handleSubmit(onSubmit) },
	                            _react2.default.createElement(
	                                _reactBootstrap.Modal.Header,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Modal.Title,
	                                    null,
	                                    label
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Modal.Body,
	                                { className: 'custom-modal-body' },
	                                contractBody
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Modal.Footer,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        type: 'submit',
	                                        bsStyle: 'success',
	                                        onClick: this.acceptContract,
	                                        disabled: submitting || !this.props.hasOwnProperty('text') && !contractText && !link },
	                                    'Estoy de Acuerdo'
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    { onClick: this.closeContract },
	                                    'Cancelar'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Contract;
	}(_react.Component);
	
	Contract = (0, _reduxForm.reduxForm)()(Contract);
	
	exports.default = Contract;

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(19);
	
	var _reduxForm = __webpack_require__(16);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactBootstrap = __webpack_require__(40);
	
	var _reactIntl = __webpack_require__(26);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	var _SignatureForm = __webpack_require__(1171);
	
	var _SignatureForm2 = _interopRequireDefault(_SignatureForm);
	
	var _ContractContainer = __webpack_require__(1191);
	
	var _ContractContainer2 = _interopRequireDefault(_ContractContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(1401);
	
	var Contracts = function (_Component) {
	    _inherits(Contracts, _Component);
	
	    function Contracts(props) {
	        _classCallCheck(this, Contracts);
	
	        var _this = _possibleConstructorReturn(this, (Contracts.__proto__ || Object.getPrototypeOf(Contracts)).call(this, props));
	
	        _this.getContracts = function () {
	            var contractsForm = [];
	            var myContracts = _this.props.myContracts;
	
	
	            for (var index in _this.state.contracts) {
	                var accepted = false;
	                var name = _this.state.contracts[index].contract_type;
	                var label = _this.state.contracts[index].title;
	
	                if (name in myContracts) {
	                    accepted = myContracts[name].values && myContracts[name].values.contract_accepted;
	                }
	
	                var contract = _react2.default.createElement(_ContractContainer2.default, { key: index, form: name, onSubmit: _this.props.submitContract,
	                    checked: accepted, label: label });
	                contractsForm.push(contract);
	            }
	
	            return contractsForm;
	        };
	
	        _this.setSignature = function (hasSignature) {
	            _this.setState({
	                hasSignature: hasSignature
	            });
	        };
	
	        _this.state = {
	            contracts: [],
	            hasSignature: false,
	            signatureRequired: null
	        };
	
	        _this.setSignature = _this.setSignature.bind(_this);
	        return _this;
	    }
	
	    _createClass(Contracts, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            var config = {
	                headers: {
	                    'Content-Type': 'application/json',
	                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                }
	            };
	
	            _axios2.default.get(ROOT_URL + '/leads/contracts', config).then(function (response) {
	                _this2.setState({
	                    contracts: response.data.contracts
	                });
	            });
	
	            _axios2.default.get(ROOT_URL + '/leads/signature', config).then(function (response) {
	                _this2.setState({
	                    signatureRequired: response.data.required
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                acceptedAllContracts = _props.acceptedAllContracts;
	            var _state = this.state,
	                signatureRequired = _state.signatureRequired,
	                hasSignature = _state.hasSignature,
	                contracts = _state.contracts;
	
	
	            var contractsForm = this.getContracts();
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'terms text-center' },
	                this.props.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Consentimiento Legal'
	                ),
	                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.contract_advice', defaultMessage: '<p>Por favor, abrir, leer y acordar.</p>', description: 'Advice' }),
	                contractsForm,
	                signatureRequired && _react2.default.createElement(_SignatureForm2.default, { onChange: this.setSignature, disabled: contracts.length === 0 || !acceptedAllContracts }),
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: handleSubmit(this.props.getStep) },
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'terms_row' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'terms_col text-center', xs: 12, md: 12, lg: 12 },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    type: 'submit',
	                                    className: 'btn btn-warning btn-lg pd-button pd-form loan',
	                                    disabled: !acceptedAllContracts || signatureRequired && !hasSignature
	                                },
	                                'Finalizar'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Contracts;
	}(_react.Component);
	
	var selectorTos = (0, _reduxForm.formValueSelector)('tos');
	
	Contracts = (0, _reactRedux.connect)(function (state) {
	    return {
	        myContracts: state.form,
	        acceptedAllContracts: Object.values(state.form).filter(function (x) {
	            return x.values && x.values.contract_accepted === false;
	        }).length === 0
	    };
	})(Contracts);
	
	Contracts = (0, _reduxForm.reduxForm)({
	    form: 'Contracts' // a unique name for this form
	})(Contracts);
	
	exports.default = Contracts;

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactAutosuggest = __webpack_require__(1734);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	var _reactModal = __webpack_require__(1903);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _DynamicLabelInput = __webpack_require__(243);
	
	var _DynamicLabelInput2 = _interopRequireDefault(_DynamicLabelInput);
	
	__webpack_require__(1435);
	
	__webpack_require__(1434);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// When suggestion is clicked, Autosuggest needs to populate the input
	// based on the clicked suggestion. Teach Autosuggest how to calculate the
	// input value for every given suggestion.
	var getSuggestionValue = function getSuggestionValue(suggestion) {
	    return suggestion.name;
	};
	
	// Use your imagination to render suggestions.
	var renderSuggestion = function renderSuggestion(suggestion) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'custom-autosuggest-suggestion' },
	        suggestion.name
	    );
	};
	
	var renderSuggestionsContainer = function renderSuggestionsContainer(_ref) {
	    var containerProps = _ref.containerProps,
	        children = _ref.children,
	        query = _ref.query;
	
	    return _react2.default.createElement(
	        'div',
	        Object.assign({}, containerProps, { className: 'custom-autosuggest-container' }),
	        children
	    );
	};
	
	var modalStyle = {
	    overlay: {
	        position: 'fixed',
	        zIndex: 100,
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0,
	        backgroundColor: '#fff',
	        fontFamily: '"Open Sans", sans-serif'
	    },
	    content: {
	        position: 'absolute',
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0,
	        border: 0,
	        padding: 0,
	        overflow: 'hidden',
	        outline: 'none',
	        height: '100%'
	    }
	};
	
	var CustomAutosuggestMobileFriendly = function (_Component) {
	    _inherits(CustomAutosuggestMobileFriendly, _Component);
	
	    function CustomAutosuggestMobileFriendly(props) {
	        _classCallCheck(this, CustomAutosuggestMobileFriendly);
	
	        var _this = _possibleConstructorReturn(this, (CustomAutosuggestMobileFriendly.__proto__ || Object.getPrototypeOf(CustomAutosuggestMobileFriendly)).call(this, props));
	
	        _this.onSuggestionsFetchRequested = function (rs) {
	            if (rs.value.length < 1 || _this.state.value.id) {
	                _this.setState({
	                    cities: []
	                });
	            } else {
	                _this.getCities(rs.value);
	            }
	        };
	
	        _this.onSuggestionsClearRequested = function () {
	            _this.setState({
	                cities: []
	            });
	        };
	
	        _this.onSuggestionSelected = function (event, item) {
	
	            _this.setState({
	                value: item.suggestion,
	                cities: []
	            });
	
	            if (_this.props.onChange) {
	                _this.props.onChange(item.suggestion);
	            }
	
	            _this.props.input.onChange(item.suggestion.name);
	
	            _this.closeModal();
	        };
	
	        _this.cleanValueIfNotSelected = function () {
	            var value = _this.state.value;
	
	            if (!value.id) {
	                _this.setState({ value: {
	                        name: '',
	                        id: null
	                    } });
	            }
	        };
	
	        _this.openModal = function () {
	            _this.setState({
	                isModalOpen: true,
	                cities: []
	            });
	        };
	
	        _this.closeModal = function () {
	            _this.setState({
	                isModalOpen: false
	            });
	        };
	
	        _this.onChange = function (event, value) {
	            _this.setState({
	                value: {
	                    id: null,
	                    name: value.newValue
	                }
	            });
	
	            if (_this.state.value.id) {
	                _this.props.input.onChange(null);
	            }
	        };
	
	        _this.state = {
	            cities: [],
	            value: {
	                name: '',
	                id: null
	            },
	            isModalOpen: false
	        };
	        _this.onSuggestionsClearRequested = _this.onSuggestionsClearRequested.bind(_this);
	        _this.onSuggestionsFetchRequested = _this.onSuggestionsFetchRequested.bind(_this);
	        _this.onSuggestionSelected = _this.onSuggestionSelected.bind(_this);
	        _this.cleanValueIfNotSelected = _this.cleanValueIfNotSelected.bind(_this);
	        _this.openModal = _this.openModal.bind(_this);
	        _this.closeModal = _this.closeModal.bind(_this);
	        _this.onChange = _this.onChange.bind(_this);
	        _this.getCities = _this.getCities.bind(_this);
	        return _this;
	    }
	
	    // Autosuggest will call this function every time you need to clear suggestions.
	
	
	    _createClass(CustomAutosuggestMobileFriendly, [{
	        key: 'getCities',
	        value: function getCities(query) {
	            var _this2 = this;
	
	            var selectedState = this.props.selectedState;
	
	
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            var config = {
	                headers: {
	                    'Content-Type': 'application/json',
	                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                }
	            };
	            _axios2.default.get(ROOT_URL + '/states/' + selectedState + '/cities/_search/' + query, config).then(function (response) {
	                _this2.setState({
	                    cities: response.data.cities
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                cities = _state.cities,
	                isModalOpen = _state.isModalOpen;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_DynamicLabelInput2.default, {
	                    name: 'locality',
	                    className: 'form-control',
	                    showLabel: ("montemar-card-calf") === 'montemar',
	                    placeholder: 'Localidad',
	                    type: 'text',
	                    autoComplete: 'asd',
	                    value: this.props.input.value,
	                    onClick: this.openModal,
	                    onChange: function onChange(value) {} }),
	                _react2.default.createElement(
	                    _reactModal2.default,
	                    {
	                        isOpen: isModalOpen,
	                        contentLabel: 'Modal',
	                        onRequestClose: this.closeModal,
	                        shouldCloseOnOverlayClick: false,
	                        closeTimeoutMS: 1 /* otherwise the modal is not closed when suggestion is selected by pressing Enter */
	                        ,
	                        style: modalStyle
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'modal-autosuggest-title' },
	                        'Por favor escribe una localidad:'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'modal-autosuggest-container' },
	                        _react2.default.createElement(_reactAutosuggest2.default, {
	                            suggestions: cities,
	                            alwaysRenderSuggestions: true,
	                            onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
	                            onSuggestionsClearRequested: this.onSuggestionsClearRequested,
	                            onSuggestionSelected: this.onSuggestionSelected,
	                            getSuggestionValue: getSuggestionValue,
	                            renderSuggestion: renderSuggestion,
	                            renderSuggestionsContainer: renderSuggestionsContainer,
	                            inputProps: {
	                                autoComplete: 'asd',
	                                className: 'form-control',
	                                value: this.state.value.name,
	                                onChange: this.onChange,
	                                onBlur: this.cleanValueIfNotSelected,
	                                autoFocus: true
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'modal-cancel-button', onClick: this.closeModal },
	                        'Cancelar'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CustomAutosuggestMobileFriendly;
	}(_react.Component);
	
	exports.default = CustomAutosuggestMobileFriendly;

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(1236);
	
	var _react4 = _interopRequireDefault(_react3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomCurrencyInput = function (_Component) {
	    _inherits(CustomCurrencyInput, _Component);
	
	    function CustomCurrencyInput(props) {
	        _classCallCheck(this, CustomCurrencyInput);
	
	        var _this = _possibleConstructorReturn(this, (CustomCurrencyInput.__proto__ || Object.getPrototypeOf(CustomCurrencyInput)).call(this, props));
	
	        _this.onChangeHandler = _this.onChangeHandler.bind(_this);
	        return _this;
	    }
	
	    _createClass(CustomCurrencyInput, [{
	        key: 'onChangeHandler',
	        value: function onChangeHandler(event) {
	            this.props.onChange(parseFloat(event.target.rawValue));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_react4.default, { className: this.props.className, inputMode: 'decimal', placeholder: this.props.placeholder, onChange: this.onChangeHandler, options: { numeral: true, numelThousandsGroupStyle: 'thousand', numeralDecimalScale: 2, numeralDecimalMark: ',', delimiter: '.', prefix: '$', noImmediatePrefix: true, rawValueTrimPrefix: true } })
	            );
	        }
	    }]);
	
	    return CustomCurrencyInput;
	}(_react.Component);
	
	exports.default = CustomCurrencyInput;

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(569);
	
	var _DynamicLabelInput = __webpack_require__(243);
	
	var _DynamicLabelInput2 = _interopRequireDefault(_DynamicLabelInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(570);
	
	// CSS Modules, react-datepicker-cssmodules.css
	// import 'react-datepicker/dist/react-datepicker-cssmodules.css';
	
	var CustomDatePicker = function (_Component) {
	    _inherits(CustomDatePicker, _Component);
	
	    function CustomDatePicker(props) {
	        _classCallCheck(this, CustomDatePicker);
	
	        var _this = _possibleConstructorReturn(this, (CustomDatePicker.__proto__ || Object.getPrototypeOf(CustomDatePicker)).call(this, props));
	
	        _this.state = {
	            focused: false
	        };
	        return _this;
	    }
	
	    _createClass(CustomDatePicker, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                input = _props.input,
	                label = _props.label,
	                renderMonthElement = _props.renderMonthElement,
	                showSuccess = _props.showSuccess,
	                _props$meta = _props.meta,
	                touched = _props$meta.touched,
	                error = _props$meta.error,
	                valid = _props$meta.valid,
	                invalid = _props$meta.invalid,
	                warning = _props$meta.warning;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'form-group ' + (touched && invalid ? 'has-error' : '') + ' ' + (touched && valid && showSuccess ? 'has-success' : '') },
	                _react2.default.createElement(_DynamicLabelInput2.default, Object.assign({}, input, {
	                    renderMonthElement: renderMonthElement,
	                    type: 'calendar',
	                    focused: this.state.focused,
	                    placeholder: label,
	                    showLabel: ("montemar-card-calf") === 'montemar',
	                    onFocusChange: function onFocusChange(_ref) {
	                        var focused = _ref.focused;
	                        return _this2.setState({ focused: focused });
	                    }
	                })),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'help-block' },
	                    touched && (error && _react2.default.createElement(
	                        'span',
	                        null,
	                        error
	                    ) || warning && _react2.default.createElement(
	                        'span',
	                        null,
	                        warning
	                    ))
	                )
	            );
	        }
	    }]);
	
	    return CustomDatePicker;
	}(_react.Component);
	
	exports.default = CustomDatePicker;

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(16);
	
	var _SelectField = __webpack_require__(121);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomDateSelect = function (_Component) {
	  _inherits(CustomDateSelect, _Component);
	
	  function CustomDateSelect(props) {
	    _classCallCheck(this, CustomDateSelect);
	
	    var _this = _possibleConstructorReturn(this, (CustomDateSelect.__proto__ || Object.getPrototypeOf(CustomDateSelect)).call(this, props));
	
	    _this.state = { initDates: [] };
	    return _this;
	  }
	
	  _createClass(CustomDateSelect, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state.initDates = [{
	        "id": 0,
	        "name": "Menos de 6 meses"
	      }, {
	        "id": 6,
	        "name": "Entre 6 meses - 1 año"
	      }, {
	        "id": 12,
	        "name": "1 año - 1 año y medio"
	      }, {
	        "id": 18,
	        "name": "1 año y medio - 2 años"
	      }, {
	        "id": 24,
	        "name": "2 años - 2 años y medio"
	      }, {
	        "id": 30,
	        "name": "2 años y medio - 3 años"
	      }, {
	        "id": 36,
	        "name": "3 años - 3 años y medio"
	      }, {
	        "id": 42,
	        "name": "3 años y medio - 4 años"
	      }, {
	        "id": 48,
	        "name": "Más de 4 años"
	      }];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_reduxForm.Field, {
	        className: 'form-control',
	        name: 'init_date',
	        component: _SelectField2.default,
	        options: this.state.initDates,
	        defaultValue: 'Antigüedad laboral:',
	        label: 'Antigüedad',
	        type: this.props.type
	      });
	    }
	  }]);
	
	  return CustomDateSelect;
	}(_react.Component);
	
	exports.default = CustomDateSelect;

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(16);
	
	var _SelectField = __webpack_require__(121);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomIncomeDateSelect = function (_Component) {
	    _inherits(CustomIncomeDateSelect, _Component);
	
	    function CustomIncomeDateSelect(props) {
	        _classCallCheck(this, CustomIncomeDateSelect);
	
	        var _this = _possibleConstructorReturn(this, (CustomIncomeDateSelect.__proto__ || Object.getPrototypeOf(CustomIncomeDateSelect)).call(this, props));
	
	        _this.state = { paymentDates: [] };
	        return _this;
	    }
	
	    _createClass(CustomIncomeDateSelect, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.state.paymentDates = [{
	                "id": 2,
	                "name": "Del 1 al 5 de cada mes"
	            }, {
	                "id": 7,
	                "name": "Del 6 al 10 de cada mes"
	            }, {
	                "id": 22,
	                "name": "Del 11 al 31 de cada mes"
	            }];
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_reduxForm.Field, {
	                className: 'form-control',
	                name: this.props.name,
	                component: _SelectField2.default,
	                options: this.state.paymentDates,
	                defaultValue: 'Fecha Cobro',
	                type: this.props.type
	            });
	        }
	    }]);
	
	    return CustomIncomeDateSelect;
	}(_react.Component);
	
	exports.default = CustomIncomeDateSelect;

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1408);
	
	var CustomProgressBar = function CustomProgressBar(_ref) {
	    var label = _ref.label,
	        percentage = _ref.percentage;
	    return _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12, md: 12, lg: 12, className: 'text-center' },
	            label
	        ),
	        _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12, md: 12, lg: 12 },
	            _react2.default.createElement(_reactBootstrap.ProgressBar, { now: percentage, label: percentage + '%', className: 'custom-progress-bar' })
	        )
	    );
	};
	
	exports.default = CustomProgressBar;

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRangeslider = __webpack_require__(1932);
	
	var _reactRangeslider2 = _interopRequireDefault(_reactRangeslider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(571);
	
	var CustomSlider = function (_Component) {
	    _inherits(CustomSlider, _Component);
	
	    function CustomSlider(props) {
	        _classCallCheck(this, CustomSlider);
	
	        var _this = _possibleConstructorReturn(this, (CustomSlider.__proto__ || Object.getPrototypeOf(CustomSlider)).call(this, props));
	
	        _this.onChange = _this.onChange.bind(_this);
	        _this.state = {
	            value: null
	        };
	        return _this;
	    }
	
	    _createClass(CustomSlider, [{
	        key: 'onChange',
	        value: function onChange(value) {
	            var selectedValue = this.props.productList[value - 1];
	            this.props.input.onChange(Number(selectedValue));
	            this.setState({ value: Number(value) });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.initialValue && nextProps.productList) {
	                var currentValue = nextProps.productList.indexOf(nextProps.initialValue.toString());
	                this.setState({ value: Number(currentValue + 1) });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return this.props.productList && _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                    'label',
	                    { className: 'control-label' },
	                    this.props.label
	                ),
	                _react2.default.createElement(_reactRangeslider2.default, Object.assign({}, this.props.input, {
	                    orientation: 'horizontal',
	                    min: 1,
	                    max: this.props.productList.length,
	                    step: 1,
	                    onChange: this.onChange,
	                    value: this.state.value
	                }))
	            );
	        }
	    }]);
	
	    return CustomSlider;
	}(_react.Component);
	
	exports.default = CustomSlider;

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FieldInformation = __webpack_require__(329);
	
	var _FieldInformation2 = _interopRequireDefault(_FieldInformation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1409);
	
	var CustomSwitchInput = function CustomSwitchInput(_ref) {
	    var value = _ref.value,
	        onChange = _ref.onChange,
	        label = _ref.label,
	        options = _ref.options,
	        fieldInfo = _ref.fieldInfo;
	
	    var moreInfo = fieldInfo ? _react2.default.createElement(_FieldInformation2.default, { title: fieldInfo.title, info: fieldInfo.info }) : '';
	    return _react2.default.createElement(
	        'div',
	        { className: 'container-switch-input' },
	        _react2.default.createElement(
	            'div',
	            { className: 'custom-switch-input' },
	            _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    label + '  ',
	                    moreInfo
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'custom-switch-input-option' },
	                ' NO '
	            ),
	            _react2.default.createElement(
	                'label',
	                { className: 'switch' },
	                _react2.default.createElement('input', { type: 'checkbox', value: value, onChange: onChange }),
	                _react2.default.createElement('span', { className: 'slider round' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'custom-switch-input-option' },
	                ' SI '
	            )
	        )
	    );
	};
	
	exports.default = CustomSwitchInput;

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(26);
	
	var _BasicTemplate = __webpack_require__(242);
	
	var _BasicTemplate2 = _interopRequireDefault(_BasicTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Disapproved(props) {
		return _react2.default.createElement(
			_BasicTemplate2.default,
			null,
			_react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.disapproved', description: ' ' })
		);
	}
	
	exports.default = Disapproved;

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(40);
	
	var _FileField = __webpack_require__(1134);
	
	var _FileField2 = _interopRequireDefault(_FileField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DocumentField = function (_Component) {
	  _inherits(DocumentField, _Component);
	
	  function DocumentField(props) {
	    _classCallCheck(this, DocumentField);
	
	    var _this = _possibleConstructorReturn(this, (DocumentField.__proto__ || Object.getPrototypeOf(DocumentField)).call(this, props));
	
	    _this.state = {
	      file: {
	        url: null,
	        type: null,
	        size: null,
	        name: null,
	        blob: null
	      }
	    };
	    _this.handleOnChange = _this.handleOnChange.bind(_this);
	    _this.deleteFile = _this.deleteFile.bind(_this);
	    return _this;
	  }
	
	  _createClass(DocumentField, [{
	    key: 'deleteFile',
	    value: function deleteFile(event) {
	      event.preventDefault();
	      this.setState(Object.assign({}, this.state, {
	        file: {
	          url: null,
	          type: null,
	          size: null,
	          name: null,
	          blob: null
	        }
	      }));
	      this.props.onChange(null);
	    }
	  }, {
	    key: 'handleOnChange',
	    value: function handleOnChange(value) {
	      this.setState(Object.assign({}, this.state, {
	        file: {
	          url: URL.createObjectURL(value),
	          type: value.type,
	          size: value.size,
	          name: value.name,
	          blob: value
	        }
	      }));
	      this.props.onChange(value);
	    }
	  }, {
	    key: 'shortFileName',
	    value: function shortFileName(fileName) {
	      if (fileName.length > 17) {
	        return fileName.slice(0, 16) + '...';
	      } else {
	        return fileName;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = Object.assign({}, this.state),
	          file = _state.file;
	
	      var imagePreviewStyle = {
	        width: 'initial',
	        height: 'initial'
	      };
	      if (file) {
	        if (file.width > file.height) {
	          imagePreviewStyle['maxWidth'] = '50px';
	        } else {
	          imagePreviewStyle['maxHeight'] = '50px';
	        }
	      }
	
	      var cancelButton = _react2.default.createElement(
	        'button',
	        { className: 'btn btn-default', onClick: this.deleteFile },
	        _react2.default.createElement('span', { className: 'glyphicon glyphicon-remove', 'aria-hidden': 'true' })
	      );
	
	      var actionButton = void 0;
	      if (this.props.updating) {
	        actionButton = _react2.default.createElement(
	          'button',
	          { className: 'btn btn-default', disabled: true },
	          _react2.default.createElement('i', { className: 'fa fa-refresh fa-spin fa-lg fa-fw' })
	        );
	      } else if (file.blob) {
	        actionButton = cancelButton;
	      } else {
	        actionButton = _react2.default.createElement(_FileField2.default, { onChange: this.handleOnChange });
	      }
	
	      var description = _react2.default.createElement(
	        _reactBootstrap.Row,
	        { className: 'terms_row' },
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { className: 'terms_col terms_checkbox pd-vcenter', xs: 9, md: 10, lg: 10 },
	          _react2.default.createElement(
	            'span',
	            null,
	            this.props.label
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { className: 'terms_col pd-vcenter', xs: 3, md: 2, lg: 2 },
	          _react2.default.createElement(
	            'div',
	            { className: 'btn-group', role: 'group' },
	            actionButton
	          )
	        )
	      );
	      if (file.blob) {
	        var imageRepresetation = void 0;
	
	        if (file.type.search("image/") > -1) {
	          imageRepresetation = _react2.default.createElement('img', { src: file.url, key: file.url, style: imagePreviewStyle });
	        } else if (file.type.search("/pdf") > -1) {
	          imageRepresetation = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('i', { className: 'fa fa-file-pdf-o fa-3x fa-fw' })
	          );
	        } else {
	          imageRepresetation = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('i', { className: 'fa fa-file fa-3x fa-fw' })
	          );
	        }
	        description = _react2.default.createElement(
	          _reactBootstrap.Row,
	          { className: 'terms_row' },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { className: 'terms_col terms_checkbox pd-vcenter text-center', xs: 2, md: 2, lg: 2 },
	            imageRepresetation
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { className: 'terms_col terms_checkbox pd-vcenter', xs: 7, md: 8, lg: 8 },
	            _react2.default.createElement(
	              'span',
	              null,
	              this.shortFileName(file.name)
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { className: 'terms_col pd-vcenter', xs: 3, md: 2, lg: 2 },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'btn-group', role: 'group' },
	              actionButton
	            )
	          )
	        );
	      }
	
	      return description;
	    }
	  }]);
	
	  return DocumentField;
	}(_react.Component);
	
	module.exports = DocumentField;

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(16);
	
	var _reactIntl = __webpack_require__(26);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _TopScrolleable = __webpack_require__(53);
	
	var _TopScrolleable2 = _interopRequireDefault(_TopScrolleable);
	
	var _generateValidator = __webpack_require__(130);
	
	var _generateValidator2 = _interopRequireDefault(_generateValidator);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	var _RenderField = __webpack_require__(78);
	
	var _RenderField2 = _interopRequireDefault(_RenderField);
	
	var _CustomAlert = __webpack_require__(77);
	
	var _CustomAlert2 = _interopRequireDefault(_CustomAlert);
	
	var _Button = __webpack_require__(155);
	
	var _FlowProgressBar = __webpack_require__(83);
	
	var _FlowProgressBar2 = _interopRequireDefault(_FlowProgressBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmailForm = function (_Component) {
	    _inherits(EmailForm, _Component);
	
	    function EmailForm(props) {
	        _classCallCheck(this, EmailForm);
	
	        var _this = _possibleConstructorReturn(this, (EmailForm.__proto__ || Object.getPrototypeOf(EmailForm)).call(this, props));
	
	        _this.state = { cities: null };
	        return _this;
	    }
	
	    _createClass(EmailForm, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting,
	                error = _props.error;
	
	
	            return _react2.default.createElement(
	                _Section2.default,
	                { className: 'intro_form' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-left col-md-5 col-lg-5 text-center' },
	                        _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(119) }),
	                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.step_email', description: 'Email Form' }),
	                        _react2.default.createElement(_Button.WAButton, { phone: '542612554220', text: 'Tengo+una+consulta', value: '261-2554-220', gaEvent: 'true', gaCategory: 'CallToAction', gaAction: 'WhatsApp Tapping' }),
	                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.whatsapp_timetable', description: 'Wp timetable' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-right col-sm-12 col-md-7 col-lg-7' },
	                        _react2.default.createElement(_FlowProgressBar2.default, null),
	                        _react2.default.createElement(
	                            'form',
	                            { onSubmit: handleSubmit(this.props.saveEmail), className: 'pvc-form' },
	                            this.props.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	                            error && _react2.default.createElement(_CustomAlert2.default, { bsStyle: 'danger', message: error }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'email', autoComplete: 'off', component: _RenderField2.default, type: 'email', label: 'Email' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'submit', className: 'btn btn-warning btn-lg pd-button pd-form', disabled: submitting },
	                                        'Seguir'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EmailForm;
	}(_react.Component);
	
	var validate = (0, _generateValidator2.default)([{ name: 'email', required: true }]);
	
	EmailForm = (0, _TopScrolleable2.default)(EmailForm);
	
	EmailForm = (0, _reduxForm.reduxForm)({
	    form: 'EmailForm', // a unique name for this form
	    validate: validate
	})(EmailForm);
	
	EmailForm = (0, _Auth2.default)(EmailForm);
	
	exports.default = EmailForm;

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactIntl = __webpack_require__(26);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _TopScrolleable = __webpack_require__(53);
	
	var _TopScrolleable2 = _interopRequireDefault(_TopScrolleable);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	var _FlowProgressBar = __webpack_require__(83);
	
	var _FlowProgressBar2 = _interopRequireDefault(_FlowProgressBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmailPending = function (_Component) {
	    _inherits(EmailPending, _Component);
	
	    function EmailPending(props) {
	        _classCallCheck(this, EmailPending);
	
	        var _this = _possibleConstructorReturn(this, (EmailPending.__proto__ || Object.getPrototypeOf(EmailPending)).call(this, props));
	
	        _this.state = {
	            verified: false
	        };
	        return _this;
	    }
	
	    _createClass(EmailPending, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.props.setIsLoading(true);
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            var jwt = sessionStorage.getItem('jwtUrl');
	
	            var config = {
	                headers: {
	                    'Content-Type': 'application/json',
	                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                }
	            };
	
	            if (sessionStorage.getItem('jwtUrl')) {
	
	                _axios2.default.get(ROOT_URL + '/leads/email_pending/' + jwt, config).then(function (res) {
	                    _this2.props.throwNextStep();
	                }).catch(function (error) {
	                    _this2.props.setIsLoading(false);
	                    switch (error.response.status) {
	                        case 401:
	                            _this2.setState({
	                                verified: false
	                            });
	                            break;
	                        default:
	                            _this2.setState({
	                                verified: false
	                            });
	                            break;
	                    }
	                });
	            } else {
	                this.props.setIsLoading(false);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Section2.default,
	                { className: 'intro_form' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-left col-md-5 col-lg-5 text-center' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-img' },
	                            _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(61) })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-message' },
	                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.step_email_pending', description: 'Email pending' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-right col-sm-12 col-md-7 col-lg-7' },
	                        this.props.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	                        _react2.default.createElement(_FlowProgressBar2.default, null),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'pvc-container text-center' },
	                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.step_email_pending_info', description: 'Email Pending info' })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EmailPending;
	}(_react.Component);
	
	EmailPending = (0, _TopScrolleable2.default)(EmailPending);
	
	EmailPending = (0, _Auth2.default)(EmailPending);
	
	exports.default = EmailPending;

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactIntl = __webpack_require__(26);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _TopScrolleable = __webpack_require__(53);
	
	var _TopScrolleable2 = _interopRequireDefault(_TopScrolleable);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	var _FlowProgressBar = __webpack_require__(83);
	
	var _FlowProgressBar2 = _interopRequireDefault(_FlowProgressBar);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(1402);
	
	var EmailVerification = function (_Component) {
	    _inherits(EmailVerification, _Component);
	
	    function EmailVerification(props) {
	        _classCallCheck(this, EmailVerification);
	
	        var _this = _possibleConstructorReturn(this, (EmailVerification.__proto__ || Object.getPrototypeOf(EmailVerification)).call(this, props));
	
	        _this.state = {
	            verified: false
	        };
	        return _this;
	    }
	
	    _createClass(EmailVerification, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.props.setIsLoading(true);
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            var jwt = sessionStorage.getItem('jwtUrl');
	
	            var config = {
	                headers: {
	                    'Content-Type': 'application/json',
	                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                }
	            };
	
	            if (sessionStorage.getItem('jwtUrl')) {
	
	                _axios2.default.get(ROOT_URL + '/leads/email_verification/' + jwt, config).then(function (res) {
	                    _this2.props.throwNextStep();
	                }).catch(function (error) {
	                    _this2.props.setIsLoading(false);
	                    switch (error.response.status) {
	                        case 401:
	                            _this2.setState({
	                                verified: false
	                            });
	                            break;
	                        default:
	                            _this2.setState({
	                                verified: false
	                            });
	                            break;
	                    }
	                });
	            } else {
	                this.props.setIsLoading(false);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Section2.default,
	                { className: 'intro_form' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-left col-md-5 col-lg-5 text-center' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-img' },
	                            _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(61) })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-message' },
	                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.step_email_verification', description: 'Email Verification info' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-right col-sm-12 col-md-7 col-lg-7' },
	                        this.props.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	                        _react2.default.createElement(_FlowProgressBar2.default, null),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'pvc-container text-center' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Para finalizar con la solicitud de tu pr\xE9stamo, hac\xE9 click en el enlace que te enviamos a tu correo el\xE9ctr\xF3nico'
	                                )
	                            ),
	                            _react2.default.createElement('img', { alt: 'Logo', className: 'email-image', src: __webpack_require__(2058) })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EmailVerification;
	}(_react.Component);
	
	EmailVerification = (0, _TopScrolleable2.default)(EmailVerification);
	
	EmailVerification = (0, _Auth2.default)(EmailVerification);
	
	exports.default = EmailVerification;

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _superagent = __webpack_require__(304);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _reduxForm = __webpack_require__(16);
	
	var _SelectField = __webpack_require__(121);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmploymentsList = function (_Component) {
	    _inherits(EmploymentsList, _Component);
	
	    function EmploymentsList(props) {
	        _classCallCheck(this, EmploymentsList);
	
	        var _this = _possibleConstructorReturn(this, (EmploymentsList.__proto__ || Object.getPrototypeOf(EmploymentsList)).call(this, props));
	
	        _this.state = { employments: [] };
	        return _this;
	    }
	
	    _createClass(EmploymentsList, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	
	            _superagent2.default.get(ROOT_URL + '/employments').end(function (error, response) {
	                if (!error && response) {
	                    _this2.setState({ employments: response.body.employments });
	                } else {
	                    console.log('There was an error fetching from API', error);
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-lg-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2.default.createElement(_reduxForm.Field, {
	                        className: 'form-control',
	                        name: 'employment_id',
	                        component: _SelectField2.default,
	                        options: this.state.employments,
	                        defaultValue: 'Situación Laboral',
	                        label: 'Tipo de Empleo',
	                        type: this.props.type
	                    })
	                )
	            );
	        }
	    }]);
	
	    return EmploymentsList;
	}(_react.Component);
	
	exports.default = EmploymentsList;

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(26);
	
	var _RequireLoanButton = __webpack_require__(331);
	
	var _RequireLoanButton2 = _interopRequireDefault(_RequireLoanButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1411);
	
	
	function Faq(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	            'div',
	            { className: 'pd-main container relative' },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 text-center' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Preguntas frecuentes'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row faq-row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-offset-1 col-xs-10 col-sm-offset-0 col-sm-12 col-md-6 faq' },
	                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.faq1', description: 'faq' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-offset-1 col-xs-10 col-sm-offset-0 col-sm-12 col-md-6 faq' },
	                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.faq2', description: 'faq' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row how_it_works__row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 text-center' },
	                        _react2.default.createElement(_RequireLoanButton2.default, null)
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Faq;

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Upload = function (_Component) {
	  _inherits(Upload, _Component);
	
	  function Upload(props) {
	    _classCallCheck(this, Upload);
	
	    var _this = _possibleConstructorReturn(this, (Upload.__proto__ || Object.getPrototypeOf(Upload)).call(this, props));
	
	    _this.state = {
	      files: null,
	      file: {
	        url: null,
	        type: null,
	        size: null,
	        name: null
	      }
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(Upload, [{
	    key: 'handleChange',
	    value: function handleChange(event) {
	      this.setState(Object.assign({}, this.state, {
	        file: {
	          url: URL.createObjectURL(event.target.files[0]),
	          type: event.target.files[0].type,
	          size: event.target.files[0].size,
	          name: event.target.files[0].name,
	          blob: event.target.files[0]
	        },
	        files: event.target.files
	      }));
	      this.props.onChange(event.target.files[0]);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = Object.assign({}, this.state),
	          file = _state.file;
	
	      return _react2.default.createElement(
	        'label',
	        { className: 'btn btn-default' },
	        _react2.default.createElement('input', { type: 'file',
	          style: { display: 'none' },
	          onChange: this.handleChange }),
	        _react2.default.createElement('span', { className: 'glyphicon glyphicon-folder-open', 'aria-hidden': 'true' })
	      );
	    }
	  }]);
	
	  return Upload;
	}(_react.Component);
	
	module.exports = Upload;

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(26);
	
	var _reactBootstrap = __webpack_require__(40);
	
	var _RequireLoanButton = __webpack_require__(331);
	
	var _RequireLoanButton2 = _interopRequireDefault(_RequireLoanButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(1403);
	
	var HowItWorks = function (_Component) {
	    _inherits(HowItWorks, _Component);
	
	    function HowItWorks() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, HowItWorks);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HowItWorks.__proto__ || Object.getPrototypeOf(HowItWorks)).call.apply(_ref, [this].concat(args))), _this), _this.showCodeField = function () {
	            _this.props.showCodeField(true);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(HowItWorks, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'how_it_works' },
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'how_it_works__row' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12, md: 12, lg: 12 },
	                            _react2.default.createElement(
	                                'h2',
	                                { onClick: this.showCodeField, className: 'how_it_works__title' },
	                                'C\xF3mo funciona'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'how_it_works__row' },
	                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	                            id: 'app.how_it_works',
	                            defaultMessage: 'pasos',
	                            description: 'Pasos a seguir',
	                            values: { step_1_url: __webpack_require__(2059),
	                                step_2_url: __webpack_require__(2060),
	                                step_3_url: __webpack_require__(2061),
	                                step_4_url: __webpack_require__(2062)
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'how_it_works__row' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12, md: 12, lg: 12, className: "text-center" },
	                            _react2.default.createElement(_RequireLoanButton2.default, null)
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return HowItWorks;
	}(_react.Component);
	
	exports.default = HowItWorks;

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(16);
	
	var _CustomDatePicker = __webpack_require__(1121);
	
	var _CustomDatePicker2 = _interopRequireDefault(_CustomDatePicker);
	
	var _TextWithLine = __webpack_require__(332);
	
	var _TextWithLine2 = _interopRequireDefault(_TextWithLine);
	
	var _RenderField = __webpack_require__(78);
	
	var _RenderField2 = _interopRequireDefault(_RenderField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IncomeInformationForm = function IncomeInformationForm(props) {
	    var member = props.member;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 col-md-12 col-lg-12' },
	                _react2.default.createElement(_TextWithLine2.default, { value: 'Declaraci\xF3n de Ingresos Mensual' })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 col-md-3 col-lg-3' },
	                _react2.default.createElement(_reduxForm.Field, { name: member + '.income_date', props: { placeholder: 'Fecha' }, component: _CustomDatePicker2.default, label: 'Fecha' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 col-md-3 col-lg-3' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: member + '.net_income_tax', autoComplete: 'off', component: _RenderField2.default, type: 'number', label: 'Imp. Ing. Brutos' })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 col-md-3 col-lg-3' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: member + '.self_employment_payment', autoComplete: 'off', component: _RenderField2.default, type: 'number', label: props.selfEmploymentType === 'Monotributista' && 'Pago Monotributo' || 'Pago Responsable ins.' })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 col-md-3 col-lg-3' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: member + '.net_income', autoComplete: 'off', component: _RenderField2.default, type: 'number', label: 'Ingresos Brutos' })
	                )
	            )
	        )
	    );
	};
	
	exports.default = IncomeInformationForm;

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(16);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _generateValidator = __webpack_require__(130);
	
	var _generateValidator2 = _interopRequireDefault(_generateValidator);
	
	var _reactIntl = __webpack_require__(26);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _TopScrolleable = __webpack_require__(53);
	
	var _TopScrolleable2 = _interopRequireDefault(_TopScrolleable);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	var _LoadField = __webpack_require__(245);
	
	var _LoadField2 = _interopRequireDefault(_LoadField);
	
	var _CustomAlert = __webpack_require__(77);
	
	var _CustomAlert2 = _interopRequireDefault(_CustomAlert);
	
	var _WorkDependenceForm = __webpack_require__(1185);
	
	var _WorkDependenceForm2 = _interopRequireDefault(_WorkDependenceForm);
	
	var _SelfEmploymentForm = __webpack_require__(1163);
	
	var _SelfEmploymentForm2 = _interopRequireDefault(_SelfEmploymentForm);
	
	var _Button = __webpack_require__(155);
	
	var _FlowProgressBar = __webpack_require__(83);
	
	var _FlowProgressBar2 = _interopRequireDefault(_FlowProgressBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IncomesForm = function (_Component) {
	    _inherits(IncomesForm, _Component);
	
	    function IncomesForm(props) {
	        _classCallCheck(this, IncomesForm);
	
	        var _this = _possibleConstructorReturn(this, (IncomesForm.__proto__ || Object.getPrototypeOf(IncomesForm)).call(this, props));
	
	        _this.checkEmploymentType = _this.checkEmploymentType.bind(_this);
	        _this.state = {
	            employment: false,
	            type: false
	        };
	        return _this;
	    }
	
	    _createClass(IncomesForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.setDefaultValue({ salary_type: 1 });
	            this.checkEmploymentType();
	        }
	    }, {
	        key: 'checkEmploymentType',
	        value: function checkEmploymentType() {
	            var _this2 = this;
	
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	
	            var config = {
	                headers: {
	                    'Content-Type': 'application/json',
	                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                }
	            };
	            /*TODO: REFACTOR this */
	            _axios2.default.get(ROOT_URL + '/subscribers/employment_type', config).then(function (res) {
	                var data = res.data;
	                if (data.type === 'work_dependence') {
	                    _this2.props.setDefaultValue({ salary_type: '0', check_stubs: [{}] });
	                } else {
	                    _this2.props.setDefaultValue({ self_employment_incomes: [{}] });
	                }
	                _this2.setState({ employment: data.name,
	                    type: data.type });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting,
	                error = _props.error;
	
	            return _react2.default.createElement(
	                _Section2.default,
	                { className: 'intro_form' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-left col-md-5 col-lg-5 text-center' },
	                        _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(119) }),
	                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.step_incomes', description: 'Incomes info' }),
	                        _react2.default.createElement(_Button.WAButton, { phone: '542612554220', text: 'Tengo+una+consulta', value: '261-2554-220', gaEvent: 'true', gaCategory: 'CallToAction', gaAction: 'WhatsApp Tapping' }),
	                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.whatsapp_timetable', description: 'Wp timetable' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-right col-sm-12 col-md-7 col-lg-7' },
	                        _react2.default.createElement(_FlowProgressBar2.default, null),
	                        _react2.default.createElement(
	                            'form',
	                            { onSubmit: handleSubmit(this.props.saveIncomes), className: 'pvc-form' },
	                            this.props.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	                            error && _react2.default.createElement(_CustomAlert2.default, { bsStyle: 'danger', message: error }),
	                            _react2.default.createElement(
	                                _LoadField2.default,
	                                null,
	                                this.state.type && (this.state.type === 'work_dependence' && _react2.default.createElement(_WorkDependenceForm2.default, { deleteReduxFormField: this.props.deleteReduxFormField }) || this.state.type === 'self_employment' && _react2.default.createElement(_SelfEmploymentForm2.default, { selfEmploymentType: this.state.employment, deleteReduxFormField: this.props.deleteReduxFormField }))
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'submit', className: 'btn btn-warning btn-lg pd-button pd-form', disabled: submitting },
	                                        'Seguir'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return IncomesForm;
	}(_react.Component);
	
	var validate = (0, _generateValidator2.default)([{ name: 'check_stubs', value: [{ name: 0, value: [{ 'required': true, 'name': 'remuneration_date' }, { 'required': true, 'range': { 'min': 0 }, 'name': 'full_remuneration' }, { 'required': true, 'range': { 'min': 0 }, 'name': 'discounts' }] }, { name: 1, value: [{ 'required': true, 'name': 'remuneration_date' }, { 'required': true, 'range': { 'min': 0 }, 'name': 'full_remuneration' }, { 'required': true, 'range': { 'min': 0 }, 'name': 'discounts' }] }] }, { name: 'monotributo_category', required: true }, { name: 'monthly_costs', 'range': { 'min': 0 }, required: true }, { name: 'number_of_employees', 'range': { 'min': 0 }, required: true }, { name: 'leasing_type', required: true }, { name: 'leasing_value', required: true }, { name: 'self_employment_incomes', value: [{ name: 0, value: [{ required: true, name: 'date' }, { required: true, 'range': { 'min': 0 }, 'name': 'net_income_tax' }, { required: true, 'range': { 'min': 0 }, 'name': 'self_employment_payment' }, { required: true, 'range': { 'min': 0 }, 'name': 'net_income' }] }] }]);
	
	IncomesForm = (0, _TopScrolleable2.default)(IncomesForm);
	
	IncomesForm = (0, _reduxForm.reduxForm)({
	    form: 'IncomesForm', // a unique name for this form
	    validate: validate
	})(IncomesForm);
	
	IncomesForm = (0, _Auth2.default)(IncomesForm);
	
	exports.default = IncomesForm;

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BasicTemplate = __webpack_require__(242);
	
	var _BasicTemplate2 = _interopRequireDefault(_BasicTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Inspected(props) {
	    return _react2.default.createElement(
	        _BasicTemplate2.default,
	        null,
	        _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(
	                'b',
	                null,
	                'Gracias por tomarse el tiempo de llenar el formulario.'
	            )
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'En breve un representante se comunicar\xE1 con usted.'
	        )
	    );
	};
	exports.default = Inspected;

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(16);
	
	var _reactIntl = __webpack_require__(26);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _TopScrolleable = __webpack_require__(53);
	
	var _TopScrolleable2 = _interopRequireDefault(_TopScrolleable);
	
	var _generateValidator = __webpack_require__(130);
	
	var _generateValidator2 = _interopRequireDefault(_generateValidator);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	var _RenderField = __webpack_require__(78);
	
	var _RenderField2 = _interopRequireDefault(_RenderField);
	
	var _AttributeOptions = __webpack_require__(194);
	
	var _AttributeOptions2 = _interopRequireDefault(_AttributeOptions);
	
	var _CustomDateSelect = __webpack_require__(1122);
	
	var _CustomDateSelect2 = _interopRequireDefault(_CustomDateSelect);
	
	var _CustomAlert = __webpack_require__(77);
	
	var _CustomAlert2 = _interopRequireDefault(_CustomAlert);
	
	var _FlowProgressBar = __webpack_require__(83);
	
	var _FlowProgressBar2 = _interopRequireDefault(_FlowProgressBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobInfoForm = function (_Component) {
	    _inherits(JobInfoForm, _Component);
	
	    function JobInfoForm(props) {
	        _classCallCheck(this, JobInfoForm);
	
	        var _this = _possibleConstructorReturn(this, (JobInfoForm.__proto__ || Object.getPrototypeOf(JobInfoForm)).call(this, props));
	
	        _this.state = { cities: null };
	        return _this;
	    }
	
	    _createClass(JobInfoForm, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting,
	                error = _props.error;
	
	
	            var vehicle = [{ id: 0, name: 'Auto' }, { id: 1, name: 'Moto' }, { id: 2, name: 'No' }];
	            var type_job = [{ id: 0, name: 'Empleado Público Planta Permanente' }, { id: 1, name: 'Empleado Público No Permanente' }, { id: 2, name: 'Empleado En Empresa Privada' }, { id: 3, name: 'Jubliado / Pensionado' }];
	
	            return _react2.default.createElement(
	                _Section2.default,
	                { className: 'intro_form' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-left col-md-5 col-lg-5 text-center' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-img' },
	                            _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(61) })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-message' },
	                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.step_job_info', description: 'Personal info' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-right col-sm-12 col-md-7 col-lg-7' },
	                        _react2.default.createElement(_FlowProgressBar2.default, null),
	                        _react2.default.createElement(
	                            'form',
	                            { onSubmit: handleSubmit(this.props.saveJobInfo), className: 'pvc-form' },
	                            this.props.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	                            error && _react2.default.createElement(_CustomAlert2.default, { bsStyle: 'danger', message: error }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_AttributeOptions2.default, { name: 'vehicle', defaultValue: '\xBFTen\xE9s veh\xEDculo?', label: '\xBFTen\xE9s veh\xEDculo?', attributeName: 'vehicle', attributeOptions: vehicle })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_AttributeOptions2.default, { name: 'job_type', defaultValue: 'Tipo de trabajo:', label: 'Tipo de trabajo:', attributeName: 'type_job', attributeOptions: type_job })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_CustomDateSelect2.default, { type: 'select' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_reduxForm.Field, { className: 'form-control',
	                                            name: "remuneration_without_taxes",
	                                            autoComplete: 'off',
	                                            component: _RenderField2.default,
	                                            type: 'currency',
	                                            label: '\xBFCuanto cobr\xE1s en mano?' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'submit', className: 'btn btn-warning btn-lg pd-button pd-form', disabled: submitting },
	                                        'Seguir'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return JobInfoForm;
	}(_react.Component);
	
	var validate = (0, _generateValidator2.default)([{ name: 'vehicle', required: true }, { name: 'job_type', required: true }, { name: 'init_date', required: true }, { name: 'remuneration_without_taxes', required: true }]);
	
	JobInfoForm = (0, _TopScrolleable2.default)(JobInfoForm);
	
	JobInfoForm = (0, _reduxForm.reduxForm)({
	    form: 'JobInfoForm', // a unique name for this form
	    validate: validate
	})(JobInfoForm);
	
	//JobInfoForm = withAuthControl(JobInfoForm);
	
	exports.default = JobInfoForm;

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(26);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _MainFormContainer = __webpack_require__(1200);
	
	var _MainFormContainer2 = _interopRequireDefault(_MainFormContainer);
	
	var _AuthFormContainer = __webpack_require__(1189);
	
	var _AuthFormContainer2 = _interopRequireDefault(_AuthFormContainer);
	
	var _HowItWorks = __webpack_require__(1135);
	
	var _HowItWorks2 = _interopRequireDefault(_HowItWorks);
	
	var _MinSpecs = __webpack_require__(1142);
	
	var _MinSpecs2 = _interopRequireDefault(_MinSpecs);
	
	var _Faq = __webpack_require__(1133);
	
	var _Faq2 = _interopRequireDefault(_Faq);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Main = function (_Component) {
	    _inherits(Main, _Component);
	
	    function Main(props) {
	        _classCallCheck(this, Main);
	
	        var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this, props));
	
	        _this.showCodeField = function (childData) {
	            _this.setState({ sellerCode: childData });
	        };
	
	        _this.authFromToken = _this.authFromToken.bind(_this);
	        _this.state = {
	            isEmailMissing: false,
	            errorMessage: null,
	            isLoading: false,
	            accessToken: null,
	            sellerCode: false
	        };
	        return _this;
	    }
	
	    _createClass(Main, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (this.props.location.query.token) {
	                this.setState({ isLoading: true });
	                this.authFromToken();
	            }
	        }
	    }, {
	        key: 'authFromToken',
	        value: function authFromToken() {
	            var _this2 = this;
	
	            var jwt = this.props.location.query.token;
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            var config = {
	                headers: {
	                    'Content-Type': 'application/json'
	                }
	            };
	
	            _axios2.default.get(ROOT_URL + '/leads/jwt/' + jwt, config).then(function (res) {
	                _this2.setState({
	                    accessToken: res.data['access_token']
	                });
	                sessionStorage.setItem('jwtToken', res.data['access_token']);
	                sessionStorage.setItem('jwtUrl', jwt);
	                _this2.props.requestNextStep();
	            }).catch(function (error) {
	                switch (error.response.status) {
	                    case 422:
	                        _this2.setState({
	                            isLoading: false,
	                            isEmailMissing: false
	                        });
	                        break;
	                    case 404:
	                        _this2.setState({
	                            isLoading: false,
	                            isEmailMissing: false
	                        });
	                        break;
	                    case 401:
	                        sessionStorage.setItem('jwtAuthToken', jwt);
	                        _this2.setState({
	                            isLoading: false,
	                            isEmailMissing: true,
	                            errorMessage: error.response.data.email[0]
	                        });
	                        break;
	                    case 409:
	                        _this2.setState({
	                            isLoading: false,
	                            isEmailMissing: false
	                        });
	                        break;
	                    default:
	                        _this2.setState({
	                            isLoading: false,
	                            isEmailMissing: false
	                        });
	                        break;
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _Section2.default,
	                    { className: 'intro_form' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'pd-content-left col-md-5 col-lg-5 text-center' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'header-img' },
	                                _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(61) })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'header-message custom-padding-titles' },
	                                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.intro', description: 'Introducci\xF3n' }),
	                                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.intro_start', description: 'Introducci\xF3n' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'pd-content-right col-sm-12 col-md-7 col-lg-7' },
	                            this.state.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere.... Por favor espere...' }),
	                            this.state.isEmailMissing ? _react2.default.createElement(_AuthFormContainer2.default, null) : _react2.default.createElement(_MainFormContainer2.default, { sellerCode: this.state.sellerCode })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Main;
	}(_react.Component);
	
	exports.default = Main;

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(19);
	
	var _reduxForm = __webpack_require__(16);
	
	var _reactRouter = __webpack_require__(32);
	
	var _StatesContainer = __webpack_require__(1210);
	
	var _StatesContainer2 = _interopRequireDefault(_StatesContainer);
	
	var _EmploymentsContainer = __webpack_require__(1196);
	
	var _EmploymentsContainer2 = _interopRequireDefault(_EmploymentsContainer);
	
	var _CustomAlert = __webpack_require__(77);
	
	var _CustomAlert2 = _interopRequireDefault(_CustomAlert);
	
	var _asyncValidationsMainForm = __webpack_require__(1181);
	
	var _asyncValidationsMainForm2 = _interopRequireDefault(_asyncValidationsMainForm);
	
	var _RenderField = __webpack_require__(78);
	
	var _RenderField2 = _interopRequireDefault(_RenderField);
	
	var _SelectField = __webpack_require__(121);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	var _reactHotkeys = __webpack_require__(898);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainForm = function (_Component) {
	    _inherits(MainForm, _Component);
	
	    function MainForm(props) {
	        _classCallCheck(this, MainForm);
	
	        var _this = _possibleConstructorReturn(this, (MainForm.__proto__ || Object.getPrototypeOf(MainForm)).call(this, props));
	
	        _this.state = {
	            fields: {},
	            showCodeField: false
	        };
	        _this.showCodeField = _this.showCodeField.bind(_this);
	        return _this;
	    }
	
	    _createClass(MainForm, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.emailValue !== prevProps.emailValue && this.props.formSubmitErrors && this.props.formSubmitErrors.document_number) {
	                this.props.dispatch((0, _reduxForm.change)('main', 'document_number', this.props.documentValue));
	            }
	        }
	    }, {
	        key: 'showCodeField',
	        value: function showCodeField() {
	            var currentState = Object.assign({}, this.state, { showCodeField: !this.state.showCodeField });
	            if (!currentState.showCodeField) {
	                this.props.deleteReduxFormField('seller_code');
	            }
	            this.setState(currentState);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting,
	                error = _props.error;
	
	
	            var sellerCodeField = _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-lg-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'seller_code', autoComplete: 'off', component: _RenderField2.default, type: 'text', label: 'C\xF3digo' })
	                    )
	                )
	            );
	
	            return _react2.default.createElement(
	                _reactHotkeys.HotKeys,
	                { handlers: { SHOW_SELLER_CODE: this.showCodeField } },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { onSubmit: handleSubmit(this.props.addSubscriber), className: 'pvc-form' },
	                        this.props.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	                        error && _react2.default.createElement(_CustomAlert2.default, { bsStyle: 'danger', message: error }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: this.state.fields.hasOwnProperty('email') && this.state.fields.hasOwnProperty('document_number') ? 'row-hidden' : 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 col-lg-12' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group' },
	                                    _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'email', autoComplete: 'off', component: _RenderField2.default, type: this.state.fields.hasOwnProperty('email') ? 'hidden' : 'email', label: 'Correo Electr\xF3nico', showSuccess: true })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 col-lg-12' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group' },
	                                    _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'document_number', autoComplete: 'off', component: _RenderField2.default, type: this.state.fields.hasOwnProperty('document_number') ? 'hidden' : 'number', label: 'N\xFAmero de Documento' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: this.state.fields.hasOwnProperty('name') && this.state.fields.hasOwnProperty('gender') ? 'row-hidden' : 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 col-lg-12' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group' },
	                                    _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'name', autoComplete: 'off', component: _RenderField2.default, type: this.state.fields.hasOwnProperty('name') ? 'hidden' : 'text', label: 'Nombre y Apellido' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 col-lg-12' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group' },
	                                    _react2.default.createElement(_reduxForm.Field, {
	                                        className: 'form-control',
	                                        name: 'gender',
	                                        autoComplete: 'off',
	                                        component: _SelectField2.default,
	                                        options: [{ id: 'm', name: 'Masculino' }, { id: 'f', name: 'Femenino' }],
	                                        defaultValue: 'Sexo según tu DNI',
	                                        label: 'Género',
	                                        type: this.state.fields.hasOwnProperty('gender') ? 'hidden' : 'select'
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: this.state.fields.hasOwnProperty('area_code') && this.state.fields.hasOwnProperty('number') ? 'row-hidden' : 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-4 col-lg-4' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group' },
	                                    _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'area_code', autoComplete: 'off', component: _RenderField2.default, type: this.state.fields.hasOwnProperty('area_code') ? 'hidden' : 'number', label: 'C\xF3digo de Area', showSuccess: true })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-8 col-lg-8' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group' },
	                                    _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'number', autoComplete: 'off', component: _RenderField2.default, type: this.state.fields.hasOwnProperty('number') ? 'hidden' : 'number', label: 'N\xFAmero de Celular', showSuccess: true })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: this.state.fields.hasOwnProperty('employment_id') && this.state.fields.hasOwnProperty('state_id') ? 'row-hidden' : 'row' },
	                            _react2.default.createElement(_EmploymentsContainer2.default, { type: this.state.fields.hasOwnProperty('employment_id') ? 'hidden' : 'select' }),
	                            _react2.default.createElement(_StatesContainer2.default, { type: this.state.fields.hasOwnProperty('state_id') ? 'hidden' : 'select' }),
	                            _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'site', autoComplete: 'off', component: _RenderField2.default, type: 'hidden' })
	                        ),
	                        (this.state.showCodeField || this.props.sellerCode) && sellerCodeField,
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'btn btn-warning btn-lg pd-button pd-form loan', disabled: submitting },
	                            'Solicitar'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MainForm;
	}(_react.Component);
	
	var selector = (0, _reduxForm.formValueSelector)('main');
	
	MainForm = (0, _reactRedux.connect)(function (state) {
	    var documentValue = selector(state, 'document_number');
	    var emailValue = selector(state, 'email');
	    var formSubmitErrors = (0, _reduxForm.getFormSubmitErrors)('main')(state);
	
	    return {
	        documentValue: documentValue,
	        emailValue: emailValue,
	        formSubmitErrors: formSubmitErrors
	    };
	})(MainForm);
	
	MainForm = (0, _reduxForm.reduxForm)({
	    initialValues: {
	        site: ("montemar-card-calf") === 'montemar' && 'Montemar.com.ar' || ("montemar-card-calf") === 'montemar-card-calf' && 'Calf.card.montemar.com.ar' || ("montemar-card-calf") === 'puedo' && 'Puedo.com.ar' || ("montemar-card-calf") === 'demo' && 'Demo-Creditos.com.ar'
	    },
	    form: 'main', // a unique name for this form
	    asyncValidate: _asyncValidationsMainForm2.default,
	    asyncBlurFields: ['email', 'area_code', 'number']
	})(MainForm);
	
	MainForm = (0, _reactRouter.withRouter)(MainForm);
	
	exports.default = MainForm;

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(26);
	
	__webpack_require__(1436);
	
	var _RequireLoanButton = __webpack_require__(331);
	
	var _RequireLoanButton2 = _interopRequireDefault(_RequireLoanButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1413);
	
	
	function MinSpecs(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'section dark' },
	        _react2.default.createElement(
	            'div',
	            { className: 'pd-main container relative' },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-offset-1 col-xs-10 col-sm-offset-0 col-sm-12 text-center' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'M\xEDnimos requisitos'
	                        ),
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'Obten\xE9 tu pr\xE9stamo aprobado al instante'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row faq-row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-offset-1 col-xs-10 col-sm-offset-0 col-sm-12 col-md-12 faq text-center' },
	                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.min_specs', description: 'min_specs' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row how_it_works__row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 text-center' },
	                        _react2.default.createElement(_RequireLoanButton2.default, null)
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = MinSpecs;

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(26);
	
	var _reactBootstrap = __webpack_require__(40);
	
	var _LoadField = __webpack_require__(245);
	
	var _LoadField2 = _interopRequireDefault(_LoadField);
	
	var _MoneyField = __webpack_require__(330);
	
	var _MoneyField2 = _interopRequireDefault(_MoneyField);
	
	var _Button = __webpack_require__(155);
	
	var _utils = __webpack_require__(38);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tjtMontemar = __webpack_require__(472);
	var tjtMc = __webpack_require__(471);
	__webpack_require__(376);
	
	var MontemarSummary = function (_Component) {
	    _inherits(MontemarSummary, _Component);
	
	    function MontemarSummary(props) {
	        _classCallCheck(this, MontemarSummary);
	
	        var _this = _possibleConstructorReturn(this, (MontemarSummary.__proto__ || Object.getPrototypeOf(MontemarSummary)).call(this, props));
	
	        _this.state = {
	
	            requested_amount: null,
	            requested_quotas: null,
	            total_amount: null,
	            quota_amount: null,
	            interest: null,
	            interest_tax: null,
	            first_payment_date: null,
	            monthly_discount: null,
	            package_comission: null,
	            operation_id: null,
	            monthly_total: null,
	            total_quota: null,
	            credit_cards: []
	        };
	        return _this;
	    }
	
	    _createClass(MontemarSummary, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            var config = {
	                headers: {
	                    'Content-Type': 'application/json',
	                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                }
	            };
	
	            _axios2.default.get(ROOT_URL + '/leads/details', config).then(function (res) {
	                var data = res.data;
	                var total_amount = data.requested_quotas * data.quota_amount;
	                var interest_tax = (total_amount - data.requested_amount) * 0.21 / 1.21;
	                var interest = total_amount - data.requested_amount - interest_tax;
	                _this2.setState(Object.assign({}, _this2.state, {
	                    requested_amount: data.requested_amount,
	                    requested_quotas: data.requested_quotas,
	                    quota_amount: data.quota_amount,
	                    total_amount: data.total_amount,
	                    interest: data.interest,
	                    interest_tax: data.interest_tax,
	                    first_payment_date: data.first_payment_date,
	                    package_comission: data.package_comission,
	                    monthly_discount: data.monthly_discount,
	                    operation_id: data.operation_id,
	                    monthly_total: data.monthly_total,
	                    total_quota: data.total_quota,
	                    credit_cards: data.credit_card_offers
	                }));
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var credit_cards = this.state.credit_cards;
	
	            var creditCardsComponent = credit_cards.map(function (card, index) {
	                return _react2.default.createElement(
	                    'div',
	                    { key: index },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'credit-card-img' },
	                        _react2.default.createElement('img', { src: card.type === 'mc' ? tjtMc : tjtMontemar })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'credit-card-amount' },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Tarjeta ' + (card.type === 'mc' ? 'Mastercard' : 'Montemar')
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Sin cargo de mantenimiento ni renovaci\xF3n.'
	                        )
	                    )
	                );
	            });
	            return _react2.default.createElement(
	                'div',
	                { className: 'summary text-center' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'summary_details' },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        ' Resumen de tu solicitud '
	                    ),
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        ' Pr\xE9stamo Personal '
	                    ),
	                    _react2.default.createElement('div', { className: 'summary_line' }),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row summary_row_vertical_align' },
	                        _react2.default.createElement('moneyField', null),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 6, md: 6, lg: 6 },
	                            'Dinero en mano: '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-right', xs: 6, md: 3, lg: 6 },
	                            _react2.default.createElement(
	                                _LoadField2.default,
	                                null,
	                                this.state.requested_amount && _react2.default.createElement(
	                                    _MoneyField2.default,
	                                    null,
	                                    this.state.requested_amount
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 6, md: 6, lg: 6 },
	                            'Usted pagar\xE1 por mes: '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-right', xs: 6, md: 3, lg: 6 },
	                            _react2.default.createElement(
	                                _LoadField2.default,
	                                null,
	                                this.state.quota_amount && _react2.default.createElement(
	                                    _MoneyField2.default,
	                                    null,
	                                    this.state.quota_amount
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 6, md: 6, lg: 6 },
	                            'Nro. Operaci\xF3n: '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-right', xs: 6, md: 3, lg: 6 },
	                            _react2.default.createElement(
	                                _LoadField2.default,
	                                null,
	                                this.state.operation_id
	                            )
	                        )
	                    ),
	                    credit_cards.length > 0 ? _react2.default.createElement(
	                        'h4',
	                        null,
	                        ' Tarjetas '
	                    ) : '',
	                    _react2.default.createElement('div', { className: 'summary_line' }),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row summary_row_vertical_align' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12, md: 12, lg: 12 },
	                            creditCardsComponent
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        ' Detalle de los conceptos '
	                    ),
	                    _react2.default.createElement('div', { className: 'summary_line' }),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row summary_row_vertical_align' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 6, md: 6, lg: 6 },
	                            'Cantidad de cuotas: '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-right', xs: 6, md: 3, lg: 6 },
	                            _react2.default.createElement(
	                                _LoadField2.default,
	                                null,
	                                this.state.requested_quotas
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 6, md: 6, lg: 6 },
	                            'Vencimiento 1er cuota: '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-right', xs: 6, md: 3, lg: 6 },
	                            _react2.default.createElement(
	                                _LoadField2.default,
	                                null,
	                                this.state.first_payment_date
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 6, md: 6, lg: 6 },
	                            'Importe cuota total: '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-right', xs: 6, md: 3, lg: 6 },
	                            _react2.default.createElement(
	                                _LoadField2.default,
	                                null,
	                                this.state.total_quota && '' + (0, _utils.formatMoney)(this.state.total_quota, 2, ',', '.')
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 6, md: 6, lg: 6 },
	                            'Comisi\xF3n PAQUETE PLUS: '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-right', xs: 6, md: 3, lg: 6 },
	                            _react2.default.createElement(
	                                _LoadField2.default,
	                                null,
	                                this.state.package_comission && (0, _utils.formatMoney)(this.state.package_comission, 2, ',', '.') + ' '
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 6, md: 6, lg: 6 },
	                            'Costo Total Mensual sin descuento: '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-right', xs: 6, md: 3, lg: 6 },
	                            _react2.default.createElement(
	                                _LoadField2.default,
	                                null,
	                                this.state.monthly_total && '' + (0, _utils.formatMoney)(this.state.monthly_total, 2, ',', '.')
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: 'summary_line' }),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row summary_discount summary_row_vertical_align' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 6, md: 6, lg: 6 },
	                            'Su descuento Montemar Plus: '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-right', xs: 6, md: 3, lg: 6 },
	                            _react2.default.createElement(
	                                _LoadField2.default,
	                                { style: { marginRight: '5px' } },
	                                this.state.monthly_discount && (0, _utils.formatMoney)(this.state.monthly_discount, 2, ',', '.') + '*'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row summary_discount' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 6, md: 6, lg: 6 },
	                            'Usted pagar\xE1 por mes: '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-right', xs: 6, md: 3, lg: 6 },
	                            _react2.default.createElement(
	                                _LoadField2.default,
	                                { style: { marginRight: '5px' } },
	                                this.state.quota_amount && _react2.default.createElement(
	                                    _MoneyField2.default,
	                                    null,
	                                    this.state.quota_amount
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row summary_row_vertical_align' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12, md: 12, lg: 12, className: 'text-center' },
	                            '*Ver legales de la bonificaci\xF3n mensual'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MontemarSummary;
	}(_react.Component);
	
	exports.default = MontemarSummary;

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(26);
	
	var _reactBootstrap = __webpack_require__(40);
	
	var _LoadField = __webpack_require__(245);
	
	var _LoadField2 = _interopRequireDefault(_LoadField);
	
	var _MoneyField = __webpack_require__(330);
	
	var _MoneyField2 = _interopRequireDefault(_MoneyField);
	
	var _utils = __webpack_require__(38);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tjtMontemar = __webpack_require__(472);
	var tjtMc = __webpack_require__(471);
	__webpack_require__(376);
	
	var MontemarSummary = function (_Component) {
	    _inherits(MontemarSummary, _Component);
	
	    function MontemarSummary(props) {
	        _classCallCheck(this, MontemarSummary);
	
	        var _this = _possibleConstructorReturn(this, (MontemarSummary.__proto__ || Object.getPrototypeOf(MontemarSummary)).call(this, props));
	
	        _this.state = {
	
	            requested_amount: null,
	            requested_quotas: null,
	            total_amount: null,
	            quota_amount: null,
	            interest: null,
	            interest_tax: null,
	            first_payment_date: null,
	            monthly_discount: null,
	            package_comission: null,
	            credit_cards: []
	        };
	        return _this;
	    }
	
	    _createClass(MontemarSummary, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            var config = {
	                headers: {
	                    'Content-Type': 'application/json',
	                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                }
	            };
	
	            _axios2.default.get(ROOT_URL + '/leads/details', config).then(function (res) {
	                var data = res.data;
	                var total_amount = data.requested_quotas * data.quota_amount;
	                var interest_tax = (total_amount - data.requested_amount) * 0.21 / 1.21;
	                var interest = total_amount - data.requested_amount - interest_tax;
	                _this2.setState(Object.assign({}, _this2.state, {
	                    requested_amount: data.requested_amount,
	                    requested_quotas: data.requested_quotas,
	                    quota_amount: data.quota_amount,
	                    total_amount: data.total_amount,
	                    interest: data.interest,
	                    interest_tax: data.interest_tax,
	                    first_payment_date: data.first_payment_date,
	                    package_comission: data.package_comission,
	                    monthly_discount: data.monthly_discount,
	                    credit_cards: data.credit_card_offers
	                }));
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var credit_cards = this.state.credit_cards;
	
	            var creditCardsComponent = credit_cards.map(function (card, index) {
	                return _react2.default.createElement(
	                    'div',
	                    { key: index },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'credit-card-img' },
	                        _react2.default.createElement('img', { src: card.type === 'mc' ? tjtMc : tjtMontemar })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'credit-card-amount' },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Tarjeta ' + (card.type === 'mc' ? 'Mastercard' : 'Montemar')
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Sin cargo de mantenimiento ni renovaci\xF3n.'
	                        )
	                    )
	                );
	            });
	            return _react2.default.createElement(
	                'div',
	                { className: 'summary text-center' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'summary_details' },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        ' Resumen de tu solicitud '
	                    ),
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        ' Prestamo Personal '
	                    ),
	                    _react2.default.createElement('div', { className: 'summary_line' }),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row summary_row_vertical_align' },
	                        _react2.default.createElement('moneyField', null),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 6, md: 6, lg: 6 },
	                            'Monto del Pr\xE9stamo: '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-right', xs: 6, md: 3, lg: 6 },
	                            _react2.default.createElement(
	                                _LoadField2.default,
	                                null,
	                                this.state.requested_amount && _react2.default.createElement(
	                                    _MoneyField2.default,
	                                    null,
	                                    this.state.requested_amount
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 6, md: 6, lg: 6 },
	                            'Valor de la cuota: '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-right', xs: 6, md: 3, lg: 6 },
	                            _react2.default.createElement(
	                                _LoadField2.default,
	                                null,
	                                this.state.quota_amount && _react2.default.createElement(
	                                    _MoneyField2.default,
	                                    null,
	                                    this.state.quota_amount
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 6, md: 6, lg: 6 },
	                            'Cuotas: '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-right', xs: 6, md: 3, lg: 6 },
	                            _react2.default.createElement(
	                                _LoadField2.default,
	                                null,
	                                this.state.requested_quotas
	                            )
	                        )
	                    ),
	                    credit_cards.length > 0 ? _react2.default.createElement(
	                        'h4',
	                        null,
	                        ' Tarjetas '
	                    ) : '',
	                    _react2.default.createElement('div', { className: 'summary_line' }),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row summary_row_vertical_align' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12, md: 12, lg: 12 },
	                            creditCardsComponent
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        ' Paquete Aprobado: Plus '
	                    ),
	                    _react2.default.createElement('div', { className: 'summary_line' }),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row summary_row_vertical_align' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 6, md: 6, lg: 6 },
	                            'Comisi\xF3n del paquete: '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-right', xs: 6, md: 3, lg: 6 },
	                            _react2.default.createElement(
	                                _LoadField2.default,
	                                { style: { marginRight: '5px' } },
	                                this.state.package_comission && (0, _utils.formatMoney)(this.state.package_comission, 2, ',', '.') + ' '
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row summary_row_vertical_align' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 6, md: 6, lg: 6 },
	                            'Bonificaci\xF3n mensual: '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-right', xs: 6, md: 3, lg: 6 },
	                            _react2.default.createElement(
	                                _LoadField2.default,
	                                null,
	                                this.state.monthly_discount && (0, _utils.formatMoney)(this.state.monthly_discount, 2, ',', '.') + '*'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row summary_row_vertical_align' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12, md: 12, lg: 12, className: 'text-center' },
	                            '*Ver legales de la bonificaci\xF3n mensual'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MontemarSummary;
	}(_react.Component);
	
	exports.default = MontemarSummary;

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tjtMontemar = __webpack_require__(472);
	var tjtMc = __webpack_require__(471);
	
	__webpack_require__(1414);
	
	var NewCreditCards = function NewCreditCards(_ref) {
	    var cards = _ref.cards;
	
	    var singleCar = cards.length === 1;
	    var creditCardDetails = cards.map(function (card) {
	        var colSize = singleCar ? '12' : '6';
	        return _react2.default.createElement(
	            'div',
	            { className: 'col-lg-' + colSize + ' col-md-' + colSize + ' col-sm-' + colSize + ' col-xs-' + colSize + ' new_credit_cards_container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'credit_card_img' },
	                _react2.default.createElement('img', { src: card.type === 'mc' ? tjtMc : tjtMontemar })
	            )
	        );
	    });
	    return _react2.default.createElement(
	        'div',
	        { className: 'row new_credit_cards_wrapper' },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
	            _react2.default.createElement(
	                'p',
	                null,
	                'Con tu pr\xE9stamo tambi\xE9n te llev\xE1s nuestro paquete de productos:'
	            )
	        ),
	        creditCardDetails,
	        _react2.default.createElement(
	            'div',
	            { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
	            _react2.default.createElement(
	                'p',
	                null,
	                'Con los siguientes beneficios:'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('i', { className: 'fa fa-check', 'aria-hidden': 'true' }),
	                'Tasas preferenciales para pr\xE9stamos'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('i', { className: 'fa fa-check', 'aria-hidden': 'true' }),
	                'Tarjeta Montemar para sacar adelantos'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('i', { className: 'fa fa-check', 'aria-hidden': 'true' }),
	                'MasterCard para compras en todo el pa\xEDs'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('i', { className: 'fa fa-check', 'aria-hidden': 'true' }),
	                'Plazos fijos con tasas m\xE1s altas'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('i', { className: 'fa fa-check', 'aria-hidden': 'true' }),
	                'Caja de ahorro en d\xF3lares gratuita'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('i', { className: 'fa fa-check', 'aria-hidden': 'true' }),
	                '20% de descuento en tu Seguro Combinado Familiar'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('i', { className: 'fa fa-check', 'aria-hidden': 'true' }),
	                '2 Meses bonificados del servicio'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('i', { className: 'fa fa-check', 'aria-hidden': 'true' }),
	                '2 Meses bonificados del Servicio de Asistencia Montemar Tranqui!'
	            )
	        )
	    );
	};
	
	exports.default = NewCreditCards;

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _entry = __webpack_require__(1925);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(1415);
	
	var PdfBody = function (_Component) {
	  _inherits(PdfBody, _Component);
	
	  function PdfBody(props) {
	    _classCallCheck(this, PdfBody);
	
	    var _this = _possibleConstructorReturn(this, (PdfBody.__proto__ || Object.getPrototypeOf(PdfBody)).call(this, props));
	
	    _this.state = {
	      numPages: null,
	      pageNumber: 1
	    };
	
	    _this.onDocumentLoadSuccess = _this.onDocumentLoadSuccess.bind(_this);
	    _this.changePage = _this.changePage.bind(_this);
	    return _this;
	  }
	
	  _createClass(PdfBody, [{
	    key: 'onDocumentLoadSuccess',
	    value: function onDocumentLoadSuccess(_ref) {
	      var numPages = _ref.numPages;
	
	      this.setState({ numPages: numPages });
	    }
	  }, {
	    key: 'changePage',
	    value: function changePage(page) {
	      this.setState({ pageNumber: page });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var urlFile = this.props.urlFile;
	      var _state = this.state,
	          pageNumber = _state.pageNumber,
	          numPages = _state.numPages;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'pdf-body' },
	        _react2.default.createElement(
	          _entry.Document,
	          {
	            className: 'pdf-body-document',
	            file: urlFile,
	            onLoadSuccess: this.onDocumentLoadSuccess
	          },
	          _react2.default.createElement(_entry.Page, { pageNumber: pageNumber })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pdf-body-page-control' },
	          _react2.default.createElement(
	            'button',
	            { disabled: pageNumber - 1 < 1, type: 'button', onClick: function onClick() {
	                return _this2.changePage(pageNumber - 1);
	              } },
	            '\u2039'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            pageNumber,
	            ' de ',
	            numPages
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: pageNumber + 1 > numPages, type: 'button', onClick: function onClick() {
	                return _this2.changePage(pageNumber + 1);
	              } },
	            '\u203A'
	          )
	        )
	      );
	    }
	  }]);
	
	  return PdfBody;
	}(_react.Component);
	
	exports.default = PdfBody;

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _TopScrolleable = __webpack_require__(53);
	
	var _TopScrolleable2 = _interopRequireDefault(_TopScrolleable);
	
	var _BasicTemplate = __webpack_require__(242);
	
	var _BasicTemplate2 = _interopRequireDefault(_BasicTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pending = function (_Component) {
	    _inherits(Pending, _Component);
	
	    function Pending(props) {
	        _classCallCheck(this, Pending);
	
	        var _this = _possibleConstructorReturn(this, (Pending.__proto__ || Object.getPrototypeOf(Pending)).call(this, props));
	
	        _this.state = { pending: '' };
	        return _this;
	    }
	
	    _createClass(Pending, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _BasicTemplate2.default,
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        'Gracias por tomarse el tiempo de llenar el formulario.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Luego de analizar su ',
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        'Perfil Crediticio'
	                    ),
	                    ', no hemos encontrado un Pr\xE9stamo Online para ofrecerle '
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Estamos analizando su ',
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        'Perfil'
	                    ),
	                    ' Crediticio m\xE1s detenidamente, para ver si contamos con alguna otra alternativa para ofrecerle.'
	                )
	            );
	        }
	    }]);
	
	    return Pending;
	}(_react.Component);
	
	Pending = (0, _TopScrolleable2.default)(Pending);
	
	Pending = (0, _Auth2.default)(Pending);
	
	exports.default = Pending;

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(16);
	
	var _reactIntl = __webpack_require__(26);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _TopScrolleable = __webpack_require__(53);
	
	var _TopScrolleable2 = _interopRequireDefault(_TopScrolleable);
	
	var _generateValidator = __webpack_require__(130);
	
	var _generateValidator2 = _interopRequireDefault(_generateValidator);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	var _RenderField = __webpack_require__(78);
	
	var _RenderField2 = _interopRequireDefault(_RenderField);
	
	var _AttributeOptions = __webpack_require__(194);
	
	var _AttributeOptions2 = _interopRequireDefault(_AttributeOptions);
	
	var _CustomAlert = __webpack_require__(77);
	
	var _CustomAlert2 = _interopRequireDefault(_CustomAlert);
	
	var _FlowProgressBar = __webpack_require__(83);
	
	var _FlowProgressBar2 = _interopRequireDefault(_FlowProgressBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PersonalInfoForm = function (_Component) {
	    _inherits(PersonalInfoForm, _Component);
	
	    function PersonalInfoForm(props) {
	        _classCallCheck(this, PersonalInfoForm);
	
	        var _this = _possibleConstructorReturn(this, (PersonalInfoForm.__proto__ || Object.getPrototypeOf(PersonalInfoForm)).call(this, props));
	
	        _this.state = {
	            has_couple: false,
	            couple_has_employment: false,
	            has_children: false,
	            has_children_in_school: false,
	            children_options: [{ id: 0, name: '0' }, { id: 1, name: '1' }, { id: 2, name: '2' }, { id: 3, name: '3' }, { id: 4, name: '4' }, { id: 5, name: '5' }, { id: 6, name: '6' }, { id: 7, name: 'más de 6' }, { id: 8, name: 'No desea contestar' }],
	            children_filtered_options: [],
	            people_in_house_filtered_options: []
	        };
	        _this.checkIfHasChildren = _this.checkIfHasChildren.bind(_this);
	        _this.checkIfHasChildrenInSchool = _this.checkIfHasChildrenInSchool.bind(_this);
	        _this.checkIfHasCouple = _this.checkIfHasCouple.bind(_this);
	        _this.checkIfCoupleHasEmployment = _this.checkIfCoupleHasEmployment.bind(_this);
	        _this.filterPeopleInHouseOptions = _this.filterPeopleInHouseOptions.bind(_this);
	        _this.changeMaritalStatusFields = _this.changeMaritalStatusFields.bind(_this);
	        _this.peopleInHouse = [{ id: 0, name: 'Solo' }, { id: 1, name: 'Padres' }, { id: 2, name: 'Esposa e Hijos' }, { id: 3, name: 'Pareja e Hijos' }, { id: 4, name: 'Comparten con 3eros' }, { id: 5, name: 'Hijos' }, { id: 6, name: 'Otros' }];
	        _this.peopleInHouseByMaritalStatus = {
	            0: [0, 1, 4, 5, 6],
	            1: [2, 1, 4, 6],
	            2: [3, 1, 4, 6],
	            3: [0, 1, 4, 5, 6],
	            4: [0, 1, 4, 5, 6],
	            5: [2, 1, 4, 6]
	        };
	        return _this;
	    }
	
	    _createClass(PersonalInfoForm, [{
	        key: 'checkIfHasChildren',
	        value: function checkIfHasChildren(value) {
	            if (['false', '0', '8'].includes(value)) {
	                this.setState({ has_children: false });
	                this.props.deleteReduxFormField('dependent_children');
	                this.props.deleteReduxFormField('children_in_school');
	                this.props.deleteReduxFormField('children_institution_type');
	            } else {
	                var children_filtered_options = this.state.children_options.filter(function (option) {
	                    return option.id <= parseInt(value, 10);
	                });
	                this.setState({ has_children: true,
	                    children_filtered_options: children_filtered_options });
	            }
	        }
	    }, {
	        key: 'checkIfHasChildrenInSchool',
	        value: function checkIfHasChildrenInSchool(value) {
	            if (['false', '0'].includes(value)) {
	                this.setState({ has_children_in_school: false });
	                this.props.deleteReduxFormField('children_in_school');
	            } else {
	                this.setState({ has_children_in_school: true });
	            }
	        }
	    }, {
	        key: 'checkIfHasCouple',
	        value: function checkIfHasCouple(value) {
	            if ([1, 2].includes(parseInt(value, 10))) {
	                this.setState({ has_couple: true });
	            } else {
	                this.setState({ has_couple: false, couple_has_employment: false });
	                this.props.deleteReduxFormField('couple_has_employment');
	                this.props.deleteReduxFormField('partner_incomes');
	            }
	        }
	    }, {
	        key: 'checkIfCoupleHasEmployment',
	        value: function checkIfCoupleHasEmployment(value) {
	            if (parseInt(value, 10) === 0) {
	                this.setState({ couple_has_employment: true });
	            } else {
	                this.setState({ couple_has_employment: false });
	                this.props.deleteReduxFormField('partner_incomes');
	            }
	        }
	    }, {
	        key: 'filterPeopleInHouseOptions',
	        value: function filterPeopleInHouseOptions(value) {
	            var _this2 = this;
	
	            this.setState({
	                people_in_house_filtered_options: this.peopleInHouse.filter(function (item) {
	                    return _this2.peopleInHouseByMaritalStatus[value].includes(item.id);
	                })
	            });
	        }
	    }, {
	        key: 'changeMaritalStatusFields',
	        value: function changeMaritalStatusFields(value) {
	            this.checkIfHasCouple(value);
	            this.filterPeopleInHouseOptions(value);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting,
	                error = _props.error;
	
	            var marital_status = [{ id: 0, name: 'Soltero' }, { id: 1, name: 'Casado' }, { id: 2, name: 'Convive' }, { id: 3, name: 'Divorciado / Separado' }, { id: 4, name: 'Viudo' }, { id: 5, name: 'Otro' }];
	            var couple_has_employment = [{ id: 0, name: 'Sí' }, { id: 1, name: 'No' }];
	            var people_in_house = [{ id: 0, name: 'Solo' }, { id: 1, name: 'Padres' }, { id: 2, name: 'Esposa e Hijos' }, { id: 3, name: 'Pareja e Hijos' }, { id: 4, name: 'Comparten con 3eros' }, { id: 5, name: 'Hijos' }, { id: 6, name: 'Otros' }];
	            var breadwinner = [{ id: 0, name: 'Sí' }, { id: 1, name: 'No' }];
	            var house_condition = [{ id: 0, name: 'Propietario' }, { id: 1, name: 'Alquila' }, { id: 2, name: 'Otro' }];
	            var bathrooms = [{ id: 0, name: '1' }, { id: 1, name: '2' }, { id: 2, name: '3' }, { id: 3, name: '4' }, { id: 4, name: '5' }, { id: 5, name: '6' }, { id: 6, name: 'más de 6' }, { id: 7, name: 'No desea contestar' }];
	            var bedrooms = [{ id: 0, name: '1' }, { id: 1, name: '2' }, { id: 2, name: '3' }, { id: 3, name: '4' }, { id: 4, name: 'más de 4' }, { id: 5, name: 'No desea contestar' }];
	            var children_institution_type = [{ id: 0, name: 'Pública' }, { id: 1, name: 'Privada' }, { id: 2, name: 'Mixta' }, { id: 3, name: 'No desea contestar' }];
	
	            var couple_field = _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(_AttributeOptions2.default, { name: 'couple_has_employment', defaultValue: '\xBFTu pareja trabaja?', label: '\xBFTu pareja trabaja?', attributeName: 'couple_has_employment', attributeOptions: couple_has_employment, onChange: this.checkIfCoupleHasEmployment })
	            );
	            var couple_incomes_fields = _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'partner_incomes', autoComplete: 'off', component: _RenderField2.default, type: 'currency', label: '\xBFCu\xE1nto cobra en mano tu pareja?' })
	            );
	            var dependent_children_field = _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(_AttributeOptions2.default, { name: 'dependent_children', defaultValue: '\xBFHijos que viven con vos?', label: '\xBFHijos que viven con vos?', attributeName: 'dependent_children', attributeOptions: this.state.children_filtered_options })
	            );
	            var children_in_school_field = _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(_AttributeOptions2.default, { name: 'children_in_school', defaultValue: '\xBFHijos que van a la escuela?', label: '\xBFHijos que van a la escuela?', attributeName: 'children_in_school', attributeOptions: this.state.children_filtered_options, onChange: this.checkIfHasChildrenInSchool })
	            );
	            var children_institution_type_field = _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(_AttributeOptions2.default, { name: 'children_institution_type', defaultValue: '\xBFEscuela p\xFAblica o privada?', label: '\xBFEscuela p\xFAblica o privada?', attributeName: 'children_institution_type', attributeOptions: children_institution_type })
	            );
	            return _react2.default.createElement(
	                _Section2.default,
	                { className: 'intro_form' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-left col-md-5 col-lg-5 text-center' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-img' },
	                            _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(61) })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-message' },
	                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.step_personal_info', description: 'Personal info' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-right col-sm-12 col-md-7 col-lg-7' },
	                        _react2.default.createElement(_FlowProgressBar2.default, null),
	                        _react2.default.createElement(
	                            'form',
	                            { onSubmit: handleSubmit(this.props.savePersonalInfo), className: 'pvc-form' },
	                            this.props.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	                            error && _react2.default.createElement(_CustomAlert2.default, { bsStyle: 'danger', message: error }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-6 col-lg-6' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_AttributeOptions2.default, { name: 'marital_status', defaultValue: '\xBFCu\xE1l es tu situaci\xF3n?', label: '\xBFC\xFAal es tu situaci\xF3n?', attributeName: 'marital_status', attributeOptions: marital_status, onChange: this.changeMaritalStatusFields })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-6 col-lg-6' },
	                                    this.state.has_couple && couple_field
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12' },
	                                    this.state.couple_has_employment && couple_incomes_fields
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-6 col-lg-6' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_AttributeOptions2.default, { name: 'people_in_house', defaultValue: '\xBFCon qui\xE9n viv\xEDs?', label: '\xBFCon qui\xE9n viv\xEDs?', attributeName: 'people_in_house', attributeOptions: this.state.people_in_house_filtered_options })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-6 col-lg-6' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_AttributeOptions2.default, { name: 'house_condition', defaultValue: '\xBFSos propietario o alquil\xE1s?', label: '\xBFSos propietario o alquil\xE1s?', attributeName: 'house_condition', attributeOptions: house_condition })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_AttributeOptions2.default, { name: 'breadwinner', defaultValue: '\xBFSos \xFAnico sost\xE9n econ\xF3mico?', label: 'Sos \xFAnico sost\xE9n econ\xF3mico de hogar/familia?', attributeName: 'breadwinner', attributeOptions: breadwinner })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-6 col-lg-6' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_AttributeOptions2.default, { name: 'bathrooms', defaultValue: '\xBFCu\xE1ntos ba\xF1os ten\xE9s?', label: '\xBFCu\xE1ntos ba\xF1os ten\xE9s?', attributeName: 'bathrooms', attributeOptions: bathrooms })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-6 col-lg-6' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_AttributeOptions2.default, { name: 'bedrooms', defaultValue: '\xBFC\xFAantos dormitorios ten\xE9s?', label: '\xBFC\xFAantos dormitorios ten\xE9s?', attributeName: 'bedrooms', attributeOptions: bedrooms })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-6 col-lg-6' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_AttributeOptions2.default, { name: 'children', defaultValue: '\xBFCu\xE1ntos hijos ten\xE9s?', label: '\xBFCu\xE1ntos hijos ten\xE9s?', attributeName: 'children', attributeOptions: this.state.children_options, onChange: this.checkIfHasChildren })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-6 col-lg-6' },
	                                    this.state.has_children && dependent_children_field
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-6 col-lg-6' },
	                                    this.state.has_children && children_in_school_field
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-6 col-lg-6' },
	                                    this.state.has_children && this.state.has_children_in_school && children_institution_type_field
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'submit', className: 'btn btn-warning btn-lg pd-button pd-form', disabled: submitting },
	                                        'Seguir'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PersonalInfoForm;
	}(_react.Component);
	
	var validate = (0, _generateValidator2.default)([{ name: 'marital_status', required: true }, { name: 'couple_has_employment', required: true }, { name: 'partner_incomes', required: true }, { name: 'people_in_house', required: true }, { name: 'house_condition', required: true }, { name: 'breadwinner', required: true }, { name: 'bathrooms', required: true }, { name: 'bedrooms', required: true }, { name: 'children', required: true }, { name: 'dependent_children', required: true }, { name: 'children_in_school', required: true }, { name: 'children_institution_type', required: true }]);
	PersonalInfoForm = (0, _TopScrolleable2.default)(PersonalInfoForm);
	
	PersonalInfoForm = (0, _reduxForm.reduxForm)({
	    form: 'PersonalInfoForm', // a unique name for this form
	    validate: validate
	})(PersonalInfoForm);
	
	PersonalInfoForm = (0, _Auth2.default)(PersonalInfoForm);
	
	exports.default = PersonalInfoForm;

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(32);
	
	var _reactRedux = __webpack_require__(19);
	
	var _reduxForm = __webpack_require__(16);
	
	var _reactIntl = __webpack_require__(26);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _utils = __webpack_require__(38);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _TopScrolleable = __webpack_require__(53);
	
	var _TopScrolleable2 = _interopRequireDefault(_TopScrolleable);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	var _CustomSlider = __webpack_require__(1125);
	
	var _CustomSlider2 = _interopRequireDefault(_CustomSlider);
	
	var _ProductOption = __webpack_require__(1150);
	
	var _ProductOption2 = _interopRequireDefault(_ProductOption);
	
	var _NewCreditCards = __webpack_require__(1145);
	
	var _NewCreditCards2 = _interopRequireDefault(_NewCreditCards);
	
	var _LeadInfo = __webpack_require__(244);
	
	var _LeadInfo2 = _interopRequireDefault(_LeadInfo);
	
	var _reactBootstrap = __webpack_require__(40);
	
	__webpack_require__(1399);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(571);
	__webpack_require__(1417);
	
	var Product = function (_Component) {
	    _inherits(Product, _Component);
	
	    function Product(props) {
	        _classCallCheck(this, Product);
	
	        var _this = _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).call(this, props));
	
	        _this.state = {
	            loan_quota: null,
	            loan_quota_discounts: null,
	            product_discounts: null,
	            credit_cards: [],
	            leadName: '',
	            productUnselected: true,
	            maxAmount: null,
	            minAmount: null
	        };
	        _this.selectProductOption = _this.selectProductOption.bind(_this);
	        _this.getProductWithDiscounts = _this.getProductWithDiscounts.bind(_this);
	        _this.handleSubmitSelectedProduct = _this.handleSubmitSelectedProduct.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(Product, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            var config = {
	                headers: {
	                    'Content-Type': 'application/json',
	                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                }
	            };
	
	            _axios2.default.get(ROOT_URL + '/steps/params', config).then(function (response) {
	                _this2.props.setDefaultValue({
	                    requested_amount: Object.keys(response.data.product)[Object.keys(response.data.product).length - 1],
	                    requested_quotas: Object.keys(response.data.product[Object.keys(response.data.product)[(0, _utils.getMiddleIndexValue)(Object.keys(response.data.product))]])[0]
	                });
	                var _response$data = response.data,
	                    product = _response$data.product,
	                    product_discounts = _response$data.product_discounts,
	                    credit_card_offers = _response$data.credit_card_offers;
	
	
	                var isDiscount = Object.values(product_discounts).some(function (discounts) {
	                    return Object.values(discounts).some(function (value) {
	                        return value !== 0.0;
	                    });
	                });
	
	                _this2.setState({
	                    loan_quota: product,
	                    loan_quota_discounts: isDiscount ? _this2.getProductWithDiscounts(product, product_discounts) : null,
	                    credit_cards: credit_card_offers,
	                    maxAmount: (0, _utils.getMaxMinAmountValue)(product, 'max'),
	                    minAmount: (0, _utils.getMaxMinAmountValue)(product, 'min')
	                });
	            });
	
	            _axios2.default.get(ROOT_URL + '/leads/details', config).then(function (response) {
	                _this2.setState(Object.assign({}, _this2.state, {
	                    leadName: response.data.name
	                }));
	
	                if (response.data.internal_score) {
	                    _reactRouter.browserHistory.push({
	                        pathname: '/product',
	                        search: '?sint=' + response.data.internal_score
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'getProductWithDiscounts',
	        value: function getProductWithDiscounts(products) {
	            var discounts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            if (!discounts) {
	                return null;
	            }
	            var financing = {};
	            for (var productKey in products) {
	                if (products.hasOwnProperty(productKey)) {
	                    financing[productKey] = {};
	                    for (var installmentKey in products[productKey]) {
	                        financing[productKey][installmentKey] = products[productKey][installmentKey] - discounts[productKey][installmentKey];
	                    }
	                }
	            }
	            return financing;
	        }
	    }, {
	        key: 'selectProductOption',
	        value: function selectProductOption(quota, amountQuota) {
	            this.setState({ productUnselected: false });
	            this.props.dispatch((0, _reduxForm.change)(this.props.form, 'requested_quotas', quota));
	        }
	    }, {
	        key: 'handleSubmitSelectedProduct',
	        value: function handleSubmitSelectedProduct() {
	            this.setState({ productUnselected: true });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                loan_amount_value = _props.loan_amount_value,
	                loan_quotas_value = _props.loan_quotas_value,
	                clientName = _props.clientName;
	            var _state = this.state,
	                credit_cards = _state.credit_cards,
	                loan_quota_discounts = _state.loan_quota_discounts,
	                maxAmount = _state.maxAmount,
	                minAmount = _state.minAmount;
	
	
	            var selectedAmount = typeof loan_amount_value !== 'undefined' ? (0, _utils.formatMoney)(loan_amount_value, 0, ',', '.') : '';
	
	            var minAmountAvailable = typeof minAmount !== 'undefined' ? (0, _utils.formatMoney)(minAmount, 0, ',', '.', false) : '';
	
	            var maxAmountAvailable = typeof maxAmount !== 'undefined' ? (0, _utils.formatMoney)(maxAmount, 0, ',', '.', false) : '';
	
	            var quotasStyle = { 1: "col-md-12 col-lg-12 col-sm-12 col-xs-12", 2: "col-md-6 col-lg-6 col-sm-6 col-xs-6", 3: "col-md-4 col-lg-4 col-sm-4 col-xs-4" };
	
	            var quotas = this.state.loan_quota && loan_amount_value && (0, _utils.objectToArrayKeepObject)(this.state.loan_quota[loan_amount_value]).map(function (product, index, array) {
	                var quotaOption = Object.keys(product)[0];
	                var amountQuotaOption = product[quotaOption];
	                return _react2.default.createElement(
	                    'div',
	                    { className: quotasStyle[array.length] + ' text-center no-gutters', key: index },
	                    _react2.default.createElement(_ProductOption2.default, { quotaOption: parseInt(quotaOption, 10),
	                        amountQuotaOption: parseInt(amountQuotaOption, 10),
	                        currentQuota: loan_quotas_value,
	                        currentAmount: loan_amount_value,
	                        isDiscount: loan_quota_discounts,
	                        handleSubmitSelectedProduct: _this3.handleSubmitSelectedProduct,
	                        onClick: _this3.selectProductOption,
	                        gaEvent: 'true',
	                        gaCategory: 'FunnelSteps',
	                        gaAction: 'ProductSelected',
	                        gaValue: loan_amount_value,
	                        gaLabel: 'Btn-10000a-12c' })
	                );
	            });
	
	            var quotasDiscount = loan_quota_discounts && loan_amount_value && (0, _utils.objectToArrayKeepObject)(loan_quota_discounts[loan_amount_value]).map(function (product, index, array) {
	                var quotaOption = Object.keys(product)[0];
	                var amountQuotaOption = product[quotaOption];
	                return _react2.default.createElement(
	                    'div',
	                    { className: quotasStyle[array.length] + ' text-center no-gutters', key: index },
	                    _react2.default.createElement(_ProductOption2.default, { quotaOption: parseInt(quotaOption, 10),
	                        amountQuotaOption: parseInt(amountQuotaOption, 10),
	                        currentQuota: loan_quotas_value,
	                        currentAmount: loan_amount_value,
	                        handleSubmitSelectedProduct: _this3.handleSubmitSelectedProduct,
	                        onClick: _this3.selectProductOption,
	                        gaEvent: 'true',
	                        gaCategory: 'FunnelSteps',
	                        gaAction: 'ProductSelected',
	                        gaValue: loan_amount_value,
	                        gaLabel: 'Btn-10000a-12c' })
	                );
	            });
	
	            var creditCards = _react2.default.createElement(_NewCreditCards2.default, { cards: credit_cards });
	
	            return _react2.default.createElement(
	                _Section2.default,
	                { className: 'intro_form' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-left col-md-5 col-lg-5 text-center' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-img' },
	                            _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(61) })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-message' },
	                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.step_product', description: 'Product info', values: { nameClient: clientName } }),
	                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.step_product_description', description: 'Product step description', values: { maxAmount: maxAmountAvailable } }),
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'wp-product-div' },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        'o hasta ',
	                                        _react2.default.createElement(
	                                            'span',
	                                            { className: 'custom-orange-font' },
	                                            '$10.000.000'
	                                        ),
	                                        _react2.default.createElement('br', null),
	                                        'haciendo ',
	                                        _react2.default.createElement(
	                                            'a',
	                                            { href: "https://wa.me/5492613866900?text=Me%20interesan%20los%2010%20millones", target: '_blank', style: { color: '#5EABEF', textDecoration: 'underline' } },
	                                            ' click ac\xE1'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        { className: 'd-flex justify-content-center border-0', onClick: function onClick() {
	                                                return _this3.onClick();
	                                            } },
	                                        _react2.default.createElement(
	                                            'a',
	                                            { href: "https://wa.me/5492613866900?text=Me%20interesan%20los%2010%20millones", className: 'wp-product', target: '_blank', rel: 'noreferrer' },
	                                            _react2.default.createElement('i', { className: 'fa fa-whatsapp wp-product-icon' })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-right col-sm-12 col-md-7 col-lg-7' },
	                        _react2.default.createElement(
	                            'form',
	                            { onSubmit: handleSubmit(this.props.addProduct), className: 'pvc-form' },
	                            this.props.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row text-center' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'help-font' },
	                                    'Seleccion\xE1 el Monto y las Cuotas fijas en pesos'
	                                )
	                            ),
	                            _react2.default.createElement(_reduxForm.Field, { name: 'requested_amount',
	                                component: _CustomSlider2.default,
	                                productList: this.state.loan_quota && Object.keys(this.state.loan_quota),
	                                initialValue: loan_amount_value
	                            }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-3 col-lg-3 col-sm-3 col-xs-3 text-left no-gutters amounts-available' },
	                                    minAmountAvailable
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-6 col-lg-6 col-sm-6 col-xs-6 text-center' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'pd-slider-labels text-center' },
	                                        _react2.default.createElement(
	                                            'p',
	                                            { className: 'pd-slider-value' },
	                                            selectedAmount
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-3 col-lg-3 col-sm-3 col-xs-3 text-right no-gutters amounts-available' },
	                                    maxAmountAvailable
	                                )
	                            ),
	                            this.state.loan_quota && _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                quotas
	                            ),
	                            loan_quota_discounts && _react2.default.createElement(
	                                'div',
	                                { className: 'no-gutters' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row text-center' },
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'pd-slider-preference-description' },
	                                        '\xA1Solo por hoy tu Descuento Preferencial!'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: ' row product-container no-gutters' },
	                                    quotasDiscount
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'submit', className: 'btn btn-warning btn-lg pd-button pd-form', disabled: this.state.productUnselected },
	                                        'Seguir'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    window.innerWidth < 768 && credit_cards.length > 0 ? _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-lg-12 col-sm-12 text-center' },
	                            creditCards
	                        )
	                    ) : ''
	                )
	            );
	        }
	    }]);
	
	    return Product;
	}(_react.Component);
	
	var selector = (0, _reduxForm.formValueSelector)('product');
	
	Product = (0, _reactRedux.connect)(function (state) {
	    var loan_amount_value = selector(state, 'requested_amount');
	    var loan_quotas_value = selector(state, 'requested_quotas');
	    return {
	        loan_amount_value: loan_amount_value,
	        loan_quotas_value: loan_quotas_value
	    };
	})(Product);
	
	Product = (0, _TopScrolleable2.default)(Product);
	
	Product = (0, _reduxForm.reduxForm)({
	    form: 'product' // a unique name for this form
	})(Product);
	
	Product = (0, _LeadInfo2.default)(Product);
	
	Product = (0, _Auth2.default)(Product);
	
	exports.default = Product;

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(40);
	
	var _utils = __webpack_require__(38);
	
	var _App = __webpack_require__(241);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(1432);
	
	var ProductOption = function (_Component) {
	    _inherits(ProductOption, _Component);
	
	    function ProductOption(props) {
	        _classCallCheck(this, ProductOption);
	
	        var _this = _possibleConstructorReturn(this, (ProductOption.__proto__ || Object.getPrototypeOf(ProductOption)).call(this, props));
	
	        _this.state = {
	            isActive: false
	        };
	        _this.selectProduct = _this.selectProduct.bind(_this);
	        return _this;
	    }
	
	    _createClass(ProductOption, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _props = this.props,
	                currentAmount = _props.currentAmount,
	                handleSubmitSelectedProduct = _props.handleSubmitSelectedProduct;
	
	            if (currentAmount !== nextProps.currentAmount) {
	                handleSubmitSelectedProduct();
	                this.setState({ isActive: false });
	            }
	        }
	    }, {
	        key: 'trackGAEvent',
	        value: function trackGAEvent() {
	            var gaEvent = {};
	            if (this.props.gaCategory) gaEvent.category = this.props.gaCategory;
	            if (this.props.gaAction) gaEvent.action = this.props.gaAction;
	            if (this.props.gaValue) gaEvent.value = parseInt(this.props.gaValue, 10);
	            if (this.props.gaLabel) gaEvent.label = this.props.gaLabel;
	            _App.ReactGA.event(gaEvent);
	        }
	    }, {
	        key: 'selectProduct',
	        value: function selectProduct() {
	            this.setState({ isActive: true });
	            this.props.onClick(this.props.quotaOption.toString(), this.props.amountQuotaOption);
	            this.trackGAEvent();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                quotaOption = _props2.quotaOption,
	                amountQuotaOption = _props2.amountQuotaOption,
	                isDiscount = _props2.isDiscount;
	            var isActive = this.state.isActive;
	
	
	            var quotaOptionFormatted = quotaOption.toString();
	            var amountQuotaOptionFormatted = (0, _utils.formatMoney)(amountQuotaOption, 0, ',', '.');
	
	            var buttonClasses = 'btn pd-choise-button ' + (isActive ? 'active' : '');
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'product-option' },
	                _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                        className: buttonClasses,
	                        onClick: this.selectProduct,
	                        disabled: isDiscount ? true : false },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'quotas' },
	                        quotaOptionFormatted + ' cuotas fijas'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'amount' },
	                        'de ',
	                        amountQuotaOptionFormatted
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProductOption;
	}(_react.Component);
	
	exports.default = ProductOption;

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BasicTemplate = __webpack_require__(242);
	
	var _BasicTemplate2 = _interopRequireDefault(_BasicTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Rejected(props) {
	    return _react2.default.createElement(
	        _BasicTemplate2.default,
	        null,
	        _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(
	                'b',
	                null,
	                'Gracias.'
	            )
	        ),
	        _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(
	                'p',
	                null,
	                'Por el momento no tenemos una oferta de cr\xE9dito que se ajuste a su perfil.'
	            )
	        )
	    );
	};
	exports.default = Rejected;

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _dorso_seleccionado = __webpack_require__(2054);
	
	var _dorso_seleccionado2 = _interopRequireDefault(_dorso_seleccionado);
	
	var _DocumentCamera = __webpack_require__(508);
	
	var _DocumentCamera2 = _interopRequireDefault(_DocumentCamera);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(138);
	
	var RenaperAddBack = function (_Component) {
	  _inherits(RenaperAddBack, _Component);
	
	  function RenaperAddBack(props) {
	    _classCallCheck(this, RenaperAddBack);
	
	    var _this = _possibleConstructorReturn(this, (RenaperAddBack.__proto__ || Object.getPrototypeOf(RenaperAddBack)).call(this, props));
	
	    _this.state = {
	      file: null,
	      loading: false,
	      identityStatus: null
	    };
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.getNextStep = _this.getNextStep.bind(_this);
	    return _this;
	  }
	
	  _createClass(RenaperAddBack, [{
	    key: 'handleChange',
	    value: function handleChange(file) {
	      var _this2 = this;
	
	      this.setState(Object.assign({}, this.state, {
	        loading: true
	      }));
	
	      var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	
	      var config = {
	        headers: {
	          'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken'),
	          'Content-Type': 'multipart/form-data'
	        }
	      };
	
	      var formData = new FormData();
	
	      formData.append('file', file);
	
	      _axios2.default.post(ROOT_URL + '/identity/renaper/add_back', formData, config).then(function (response) {
	        var identityStatus = 'rejected';
	        if (response.status >= 200 && response.status <= 300) {
	          if (response.data.status) {
	            identityStatus = 'approved';
	            setTimeout(_this2.props.onFinish, 5 * 1000);
	          } else {
	            setTimeout(_this2.props.onRollback, 5 * 1000);
	          }
	        }
	        _this2.setState(Object.assign({}, _this2.state, {
	          loading: false,
	          identityStatus: identityStatus
	        }));
	        //this.props.onFinish();
	        /*Mostrar aprobado*/
	      }).catch(function (error) {
	        _this2.setState(Object.assign({}, _this2.state, {
	          loading: false,
	          identityStatus: 'rejected'
	        }));
	        setTimeout(_this2.props.onRollback, 5 * 1000);
	      });;
	    }
	  }, {
	    key: 'getNextStep',
	    value: function getNextStep() {
	      this.props.onFinish();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          identityStatus = _state.identityStatus;
	
	
	      var approvedMessage = _react2.default.createElement(
	        'p',
	        { className: 'success' },
	        ' Identidad Validada ',
	        _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok', 'aria-hidden': 'true' })
	      );
	
	      var rejectedMessage = _react2.default.createElement(
	        'p',
	        { className: 'error' },
	        ' No pudimos leer los datos ',
	        _react2.default.createElement('span', { className: 'glyphicon glyphicon-remove', 'aria-hidden': 'true' })
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { style: {
	            position: "fixed",
	            left: 0,
	            top: 0,
	            height: "100%",
	            width: "100%",
	            background: "#000"
	          } },
	        _react2.default.createElement(_DocumentCamera2.default, {
	          headerTitle: 'Dorso',
	          headerIcon: _dorso_seleccionado2.default,
	          onChange: this.handleChange,
	          shapeStyle: {
	            aspectRatio: 1,
	            defaultFixedSide: 'height',
	            borderRadius: '15px'
	          } }),
	        loading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Cargando documento...' }),
	        identityStatus && _react2.default.createElement(_CustomSpinner2.default, { message: identityStatus && (identityStatus == 'rejected' && rejectedMessage || identityStatus === 'approved' && approvedMessage) })
	      );
	    }
	  }]);
	
	  return RenaperAddBack;
	}(_react.Component);
	
	module.exports = RenaperAddBack;

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _frente_seleccionado = __webpack_require__(2055);
	
	var _frente_seleccionado2 = _interopRequireDefault(_frente_seleccionado);
	
	var _RenaperStepErrorMessage = __webpack_require__(246);
	
	var _RenaperStepErrorMessage2 = _interopRequireDefault(_RenaperStepErrorMessage);
	
	var _DocumentCamera = __webpack_require__(508);
	
	var _DocumentCamera2 = _interopRequireDefault(_DocumentCamera);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(138);
	
	var RenaperAddFront = function (_Component) {
	  _inherits(RenaperAddFront, _Component);
	
	  function RenaperAddFront(props) {
	    _classCallCheck(this, RenaperAddFront);
	
	    var _this = _possibleConstructorReturn(this, (RenaperAddFront.__proto__ || Object.getPrototypeOf(RenaperAddFront)).call(this, props));
	
	    _this.state = {
	      file: null,
	      loading: false,
	      stepError: false
	    };
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(RenaperAddFront, [{
	    key: 'handleChange',
	    value: function handleChange(file) {
	      var _this2 = this;
	
	      this.setState(Object.assign({}, this.state, {
	        loading: true
	      }));
	
	      var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	
	      var config = {
	        headers: {
	          'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken'),
	          'Content-Type': 'multipart/form-data'
	        }
	      };
	
	      var formData = new FormData();
	
	      formData.append('file', file);
	
	      _axios2.default.post(ROOT_URL + '/identity/renaper/add_front', formData, config).then(function (response) {
	        if (response.status >= 200 && response.status <= 300) {
	          if (!response.data.status) {
	            _this2.setState(Object.assign({}, _this2.state, {
	              stepError: true
	            }));
	            setTimeout(_this2.props.onRollback, 5 * 1000);
	          } else {
	            _this2.props.onFinish();
	          }
	        }
	      }).catch(function (error) {
	        _this2.setState(Object.assign({}, _this2.state, {
	          stepError: true
	        }));
	        setTimeout(_this2.props.onRollback, 5 * 1000);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          stepError = _state.stepError;
	
	
	      var errorMessage = _react2.default.createElement(_RenaperStepErrorMessage2.default, null);
	
	      return _react2.default.createElement(
	        'div',
	        { style: {
	            position: "fixed",
	            left: 0,
	            top: 0,
	            height: "100%",
	            width: "100%",
	            background: "#000"
	          } },
	        _react2.default.createElement(_DocumentCamera2.default, {
	          headerTitle: 'Frente',
	          headerIcon: _frente_seleccionado2.default,
	          onChange: this.handleChange,
	          shapeStyle: {
	            aspectRatio: 1,
	            defaultFixedSide: 'height',
	            borderRadius: '15px'
	          } }),
	        loading && _react2.default.createElement(_CustomSpinner2.default, { message: stepError ? errorMessage : 'Estamos analizando los datos. Por favor espere...' })
	      );
	    }
	  }]);
	
	  return RenaperAddFront;
	}(_react.Component);
	
	module.exports = RenaperAddFront;

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _RenaperStepErrorMessage = __webpack_require__(246);
	
	var _RenaperStepErrorMessage2 = _interopRequireDefault(_RenaperStepErrorMessage);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(1404);
	
	var RenaperAddTramitNumber = function (_Component) {
	  _inherits(RenaperAddTramitNumber, _Component);
	
	  function RenaperAddTramitNumber(props) {
	    _classCallCheck(this, RenaperAddTramitNumber);
	
	    var _this = _possibleConstructorReturn(this, (RenaperAddTramitNumber.__proto__ || Object.getPrototypeOf(RenaperAddTramitNumber)).call(this, props));
	
	    _this.handleInputChange = function (event) {
	      _this.setState(Object.assign({}, _this.state, {
	        tramit_number: _this.escapeRegExp(event.target.value),
	        error: event.target.value.length == 11 || event.target.value.length == 15 ? false : _this.state.error
	      }));
	    };
	
	    _this.state = {
	      file: null,
	      loading: false,
	      stepError: false,
	      error: false,
	      tramit_number: null
	    };
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(RenaperAddTramitNumber, [{
	    key: 'escapeRegExp',
	    value: function escapeRegExp(string) {
	      return string.replace(/[a-zA-Z.!¡*+\-?^${}()|[\]\\]/g, '');
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var _this2 = this;
	
	      event.preventDefault();
	      if (this.state.tramit_number && (this.state.tramit_number.length == 11 || this.state.tramit_number.length == 15)) {
	        this.setState(Object.assign({}, this.state, {
	          loading: true
	        }));
	
	        var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	
	        var config = {
	          headers: {
	            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	          }
	        };
	
	        _axios2.default.post(ROOT_URL + '/identity/renaper/tramit_number', { "tramit_number": this.state.tramit_number }, config).then(function (response) {
	          if (response.status >= 200 && response.status <= 300) {
	            if (!response.data.status) {
	              _this2.setState(Object.assign({}, _this2.state, {
	                stepError: true
	              }));
	              setTimeout(_this2.props.onRollback, 5 * 1000);
	            } else {
	              setTimeout(_this2.props.onFinish(), 5 * 1000);
	            }
	          }
	        }).catch(function (error) {
	          _this2.setState(Object.assign({}, _this2.state, {
	            stepError: true
	          }));
	          setTimeout(_this2.props.onRollback, 5 * 1000);
	        });
	      } else {
	        this.setState(Object.assign({}, this.state, {
	          error: true
	        }));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          stepError = _state.stepError,
	          error = _state.error;
	
	
	      var errorMessage = _react2.default.createElement(_RenaperStepErrorMessage2.default, { message: 'Numero de tramite incorrecto. Por favor reintenta el paso nuevamente' });
	      return _react2.default.createElement(
	        'div',
	        { style: {
	            position: "relative",
	            display: "block",
	            width: "100%",
	            height: "100%",
	            overflowY: "scroll",
	            background: "#0a2540"
	          } },
	        _react2.default.createElement(
	          _Section2.default,
	          { className: 'intro_form' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-7 col-lg-10 col-md-offset-3 col-lg-offset-1 text-center' },
	              _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(119) })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-10 col-md-7 col-lg-10 col-sm-offset-1 col-md-offset-3 col-lg-offset-1 text-center renaper-message' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'Ingres\xE1 el N\xFAmero de Tr\xE1mite del DNI'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-7 col-lg-8 col-md-offset-3 col-lg-offset-2 text-center tramit-number-container' },
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this.handleChange, className: 'pvc-form' },
	                loading && _react2.default.createElement(_CustomSpinner2.default, { message: stepError ? errorMessage : 'Estamos analizando los datos. Por favor espere...' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group ' + (error ? 'has-error' : '') },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-sm-12 col-md-12 col-lg-12' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        _react2.default.createElement('input', { type: 'text', placeholder: 'N\xFAmero de Tr\xE1mite', className: 'form-control', value: this.state.tramit_number, onChange: this.handleInputChange, name: 'tramit_number' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'help-block' },
	                        error && _react2.default.createElement(
	                          'span',
	                          null,
	                          'El número de trámite no es válido.'
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'submit', className: 'btn btn-warning btn-lg pd-button pd-form' },
	                      'Seguir'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-10 col-md-10 col-lg-8 col-sm-offset-1 col-md-offset-1 col-lg-offset-2 text-center dni-img-container' },
	                _react2.default.createElement('img', { alt: 'Numero de Tr\xE1mite', src: __webpack_require__(2057) })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RenaperAddTramitNumber;
	}(_react.Component);
	
	module.exports = RenaperAddTramitNumber;

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(16);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	var _CustomAlertModal = __webpack_require__(328);
	
	var _CustomAlertModal2 = _interopRequireDefault(_CustomAlertModal);
	
	var _RenaperAddFront = __webpack_require__(1153);
	
	var _RenaperAddFront2 = _interopRequireDefault(_RenaperAddFront);
	
	var _RenaperAddTramitNumber = __webpack_require__(1154);
	
	var _RenaperAddTramitNumber2 = _interopRequireDefault(_RenaperAddTramitNumber);
	
	var _RenaperAddBack = __webpack_require__(1152);
	
	var _RenaperAddBack2 = _interopRequireDefault(_RenaperAddBack);
	
	var _RenaperScanDocumentTips = __webpack_require__(1159);
	
	var _RenaperScanDocumentTips2 = _interopRequireDefault(_RenaperScanDocumentTips);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(1433);
	
	var RENAPER_STEPS = ['addTramitNumber', 'addBack', 'addFront', 'scanDocumentTips'];
	
	var RenaperDni = function (_Component) {
	  _inherits(RenaperDni, _Component);
	
	  function RenaperDni(props) {
	    _classCallCheck(this, RenaperDni);
	
	    var _this = _possibleConstructorReturn(this, (RenaperDni.__proto__ || Object.getPrototypeOf(RenaperDni)).call(this, props));
	
	    _this.state = {
	      attempt: 1,
	      processedSteps: [],
	      currentStep: RENAPER_STEPS.pop(),
	      missingSteps: [].concat(RENAPER_STEPS),
	      incompatibleSettings: false
	    };
	
	    _this.resetSteps = _this.resetSteps.bind(_this);
	    _this.updateStep = _this.updateStep.bind(_this);
	    _this.checkBrowserCompatibility = _this.checkBrowserCompatibility.bind(_this);
	    return _this;
	  }
	
	  _createClass(RenaperDni, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var body = document.getElementsByTagName("BODY")[0];
	      body.style.position = "fixed";
	      this.checkBrowserCompatibility();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var body = document.getElementsByTagName("BODY")[0];
	      body.style.position = "inherit";
	    }
	  }, {
	    key: 'updateStep',
	    value: function updateStep() {
	      var _state = this.state,
	          currentStep = _state.currentStep,
	          missingSteps = _state.missingSteps,
	          processedSteps = _state.processedSteps;
	
	      this.setState(Object.assign({}, this.state, {
	        processedSteps: [].concat(_toConsumableArray(processedSteps), [currentStep])
	      }));
	
	      if (missingSteps.length === 0) {
	        this.props.dispatch(this.props.getStep({}, this.props.dispatch));
	      }
	
	      this.setState(Object.assign({}, this.state, {
	        currentStep: missingSteps.pop(),
	        missingSteps: [].concat(_toConsumableArray(missingSteps))
	      }));
	    }
	  }, {
	    key: 'checkBrowserCompatibility',
	    value: function checkBrowserCompatibility() {
	      if (/iPhone|iPad/.test(navigator.userAgent)) {
	        if (!/Version\//.test(navigator.userAgent)) {
	          this.setState(Object.assign({}, this.state, {
	            incompatibleSettings: true
	          }));
	        }
	      }
	    }
	  }, {
	    key: 'resetSteps',
	    value: function resetSteps() {
	      this.setState({
	        attempt: this.state.attempt + 1,
	        processedSteps: [],
	        currentStep: 'scanDocumentTips',
	        missingSteps: [].concat(RENAPER_STEPS)
	      });
	
	      this.props.dispatch(this.props.getStep({}, this.props.dispatch));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          currentStep = _state2.currentStep,
	          incompatibleSettings = _state2.incompatibleSettings,
	          attempt = _state2.attempt;
	
	
	      var stepComponent = null;
	
	      switch (currentStep) {
	        case 'scanDocumentTips':
	          stepComponent = _react2.default.createElement(_RenaperScanDocumentTips2.default, { onFinish: this.updateStep });
	          break;
	        case 'addFront':
	          stepComponent = _react2.default.createElement(_RenaperAddFront2.default, { onFinish: this.updateStep, onRollback: this.resetSteps, key: attempt });
	          break;
	        case 'addBack':
	          stepComponent = _react2.default.createElement(_RenaperAddBack2.default, { onFinish: this.resetSteps, onRollback: this.state.attempt >= 1 ? this.updateStep : this.resetSteps, key: attempt });
	          break;
	        case 'addTramitNumber':
	          stepComponent = _react2.default.createElement(_RenaperAddTramitNumber2.default, { onFinish: this.updateStep, onRollback: this.resetSteps, key: attempt });
	          break;
	        default:
	          stepComponent = '';
	      }
	
	      return _react2.default.createElement(
	        _Section2.default,
	        { className: 'intro_form' },
	        this.props.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pd-content-left col-md-12 col-lg-12 text-center' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Coloca tus datos como figuran en el DNI.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pd-content-right col-sm-12 col-md-12 col-lg-12' },
	            _react2.default.createElement(
	              'form',
	              { className: 'pvc-form' },
	              _react2.default.createElement(
	                'div',
	                { style: {
	                    position: "fixed",
	                    left: 0,
	                    top: 0,
	                    height: "100vh",
	                    width: "100%",
	                    background: "#000",
	                    zIndex: "1000"
	                  } },
	                stepComponent,
	                incompatibleSettings && _react2.default.createElement(
	                  _CustomAlertModal2.default,
	                  null,
	                  'Para poder acceder a la c\xE1mara de su dispositivo necesitamos que por favor reingrese desde Safari'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RenaperDni;
	}(_react.Component);
	
	RenaperDni = (0, _reduxForm.reduxForm)({
	  form: 'RenaperDni' // a unique name for this form
	})(RenaperDni);
	
	RenaperDni = (0, _Auth2.default)(RenaperDni);
	
	exports.default = RenaperDni;

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(16);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	var _CustomAlertModal = __webpack_require__(328);
	
	var _CustomAlertModal2 = _interopRequireDefault(_CustomAlertModal);
	
	var _RenaperRegister = __webpack_require__(1158);
	
	var _RenaperRegister2 = _interopRequireDefault(_RenaperRegister);
	
	var _RenaperIntroduction = __webpack_require__(1157);
	
	var _RenaperIntroduction2 = _interopRequireDefault(_RenaperIntroduction);
	
	var _RenaperSelfieTips = __webpack_require__(1160);
	
	var _RenaperSelfieTips2 = _interopRequireDefault(_RenaperSelfieTips);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RENAPER_STEPS = ['register', 'selfieTips', 'introduction'];
	
	var RenaperFace = function (_Component) {
	  _inherits(RenaperFace, _Component);
	
	  function RenaperFace(props) {
	    _classCallCheck(this, RenaperFace);
	
	    var _this = _possibleConstructorReturn(this, (RenaperFace.__proto__ || Object.getPrototypeOf(RenaperFace)).call(this, props));
	
	    _this.state = {
	      attempt: 1,
	      processedSteps: [],
	      currentStep: RENAPER_STEPS.pop(),
	      missingSteps: [].concat(RENAPER_STEPS),
	      incompatibleSettings: false
	    };
	
	    _this.resetSteps = _this.resetSteps.bind(_this);
	    _this.updateStep = _this.updateStep.bind(_this);
	    _this.checkBrowserCompatibility = _this.checkBrowserCompatibility.bind(_this);
	    return _this;
	  }
	
	  _createClass(RenaperFace, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var body = document.getElementsByTagName("BODY")[0];
	      body.style.position = "fixed";
	      this.checkBrowserCompatibility();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var body = document.getElementsByTagName("BODY")[0];
	      body.style.position = "inherit";
	    }
	  }, {
	    key: 'updateStep',
	    value: function updateStep() {
	      var _state = this.state,
	          currentStep = _state.currentStep,
	          missingSteps = _state.missingSteps,
	          processedSteps = _state.processedSteps;
	
	
	      this.setState(Object.assign({}, this.state, {
	        processedSteps: [].concat(_toConsumableArray(processedSteps), [currentStep])
	      }));
	
	      if (missingSteps.length === 0) {
	        this.props.dispatch(this.props.getStep({}, this.props.dispatch));
	      }
	
	      this.setState(Object.assign({}, this.state, {
	        currentStep: missingSteps.pop(),
	        missingSteps: [].concat(_toConsumableArray(missingSteps))
	      }));
	    }
	  }, {
	    key: 'checkBrowserCompatibility',
	    value: function checkBrowserCompatibility() {
	      if (/iPhone|iPad/.test(navigator.userAgent)) {
	        if (!/Version\//.test(navigator.userAgent)) {
	          this.setState(Object.assign({}, this.state, {
	            incompatibleSettings: true
	          }));
	        }
	      }
	    }
	  }, {
	    key: 'resetSteps',
	    value: function resetSteps() {
	      this.setState({
	        attempt: this.state.attempt + 1,
	        processedSteps: [],
	        currentStep: 'introduction',
	        missingSteps: [].concat(RENAPER_STEPS)
	      });
	
	      this.props.dispatch(this.props.getStep({}, this.props.dispatch));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          currentStep = _state2.currentStep,
	          incompatibleSettings = _state2.incompatibleSettings,
	          attempt = _state2.attempt;
	
	
	      var stepComponent = null;
	
	      switch (currentStep) {
	        case 'introduction':
	          stepComponent = _react2.default.createElement(_RenaperIntroduction2.default, { onFinish: this.updateStep });
	          break;
	        case 'selfieTips':
	          stepComponent = _react2.default.createElement(_RenaperSelfieTips2.default, { onFinish: this.updateStep });
	          break;
	        case 'register':
	          stepComponent = _react2.default.createElement(_RenaperRegister2.default, { onFinish: this.updateStep, onRollback: this.resetSteps, key: attempt });
	          break;
	        default:
	          stepComponent = '';
	      }
	
	      return _react2.default.createElement(
	        _Section2.default,
	        { className: 'intro_form' },
	        this.props.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pd-content-left col-md-12 col-lg-12 text-center' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Coloca tus datos como figuran en el DNI.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pd-content-right col-sm-12 col-md-12 col-lg-12' },
	            _react2.default.createElement(
	              'form',
	              { className: 'pvc-form' },
	              _react2.default.createElement(
	                'div',
	                { style: {
	                    position: "fixed",
	                    left: 0,
	                    top: 0,
	                    height: "100vh",
	                    width: "100%",
	                    background: "#000",
	                    zIndex: "1000"
	                  } },
	                stepComponent,
	                incompatibleSettings && _react2.default.createElement(
	                  _CustomAlertModal2.default,
	                  null,
	                  'Para poder acceder a la c\xE1mara de su dispositivo necesitamos que por favor reingrese desde Safari'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RenaperFace;
	}(_react.Component);
	
	RenaperFace = (0, _reduxForm.reduxForm)({
	  form: 'RenaperFace' // a unique name for this form
	})(RenaperFace);
	
	RenaperFace = (0, _Auth2.default)(RenaperFace);
	
	exports.default = RenaperFace;

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RenaperIntroduction = function RenaperIntroduction(_ref) {
	  var onFinish = _ref.onFinish;
	
	  return _react2.default.createElement(
	    'div',
	    { style: {
	        position: "relative",
	        display: "block",
	        width: "100%",
	        height: "100%",
	        overflowY: "scroll",
	        background: "#0a2540"
	      } },
	    _react2.default.createElement(
	      _Section2.default,
	      { className: 'intro_form' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	          _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(119) })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-10 col-md-10 col-lg-10 col-sm-offset-1 col-md-offset-1 col-lg-offset-1 text-center renaper-message' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              'Para validar tu identidad es necesario que tengas tu DNI a mano. Asegurate de estar en un lugar tranquilo y con buena luz.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-10 col-md-10 col-lg-10 col-sm-offset-1 col-md-offset-1 col-lg-offset-1 text-center' },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'p',
	              { style: {
	                  fontFamily: "Rubik,sans-serif!important",
	                  fontSize: "16px",
	                  fontWeight: "400",
	                  lineHeight: "150%"
	                } },
	              _react2.default.createElement('i', { className: 'fa fa-check', ariaHidden: 'true' }),
	              ' Validamos tu identidad'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: {
	                  fontFamily: "Rubik,sans-serif!important",
	                  fontSize: "16px",
	                  fontWeight: "400",
	                  lineHeight: "150%"
	                } },
	              _react2.default.createElement('i', { className: 'fa fa-check', ariaHidden: 'true' }),
	              ' Escaneamos tu DNI'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: {
	                  fontFamily: "Rubik,sans-serif!important",
	                  fontSize: "16px",
	                  fontWeight: "400",
	                  lineHeight: "150%"
	                } },
	              _react2.default.createElement('i', { className: 'fa fa-check', ariaHidden: 'true' }),
	              ' Chequeamos tus datos'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'submit',
	                className: 'btn btn-warning btn-lg pd-button pd-form',
	                onClick: function onClick(event) {
	                  event.preventDefault();
	                  onFinish();
	                } },
	              'Entendido'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = RenaperIntroduction;

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(195);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _utils = __webpack_require__(38);
	
	var _RenaperStepErrorMessage = __webpack_require__(246);
	
	var _RenaperStepErrorMessage2 = _interopRequireDefault(_RenaperStepErrorMessage);
	
	var _SelfieCamera = __webpack_require__(1164);
	
	var _SelfieCamera2 = _interopRequireDefault(_SelfieCamera);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(138);
	
	var SELFIE_TYPES = [{
	  type: "SN",
	  description: "Poné tu rostro neutral",
	  icon: __webpack_require__(948),
	  successIcon: __webpack_require__(947)
	}, {
	  type: "SS",
	  description: "Sonreí",
	  icon: __webpack_require__(950),
	  successIcon: __webpack_require__(949)
	}, {
	  type: "SN-alt",
	  description: "Poné tu rostro neutral",
	  icon: __webpack_require__(948),
	  successIcon: __webpack_require__(947)
	}, {
	  type: "SS-alt",
	  description: "Sonreí",
	  icon: __webpack_require__(950),
	  successIcon: __webpack_require__(949)
	}];
	
	var RenaperRegister = function (_Component) {
	  _inherits(RenaperRegister, _Component);
	
	  function RenaperRegister(props) {
	    _classCallCheck(this, RenaperRegister);
	
	    var _this = _possibleConstructorReturn(this, (RenaperRegister.__proto__ || Object.getPrototypeOf(RenaperRegister)).call(this, props));
	
	    _this.state = {
	      files: [],
	      currentType: null,
	      lastType: false,
	      selfiesTypes: [],
	      play: false,
	      loading: false,
	      browserFingerPrint: null,
	      stepError: false,
	      errorMessage: null
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.setBrowserFingerPrint = _this.setBrowserFingerPrint.bind(_this);
	    _this.handleDetectionFail = _this.handleDetectionFail.bind(_this);
	    return _this;
	  }
	
	  _createClass(RenaperRegister, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var selfiesTypes, vuFp;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                selfiesTypes = this.getSelfiesTypesByIndex();
	
	
	                this.setState({
	                  currentType: selfiesTypes.pop(),
	                  selfiesTypes: selfiesTypes
	                });
	                vuFp = new window.VUBrowserFP();
	
	                vuFp.getFingerprintInfoWithSeed(this.setBrowserFingerPrint);
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'handleChange',
	    value: function handleChange(file) {
	      var _this2 = this;
	
	      var _state = this.state,
	          currentType = _state.currentType,
	          selfiesTypes = _state.selfiesTypes,
	          files = _state.files,
	          browserFingerPrint = _state.browserFingerPrint;
	
	      files.push({
	        imageType: currentType.type,
	        file: file
	      });
	
	      this.setState(Object.assign({}, this.state, {
	        files: files
	      }));
	
	      if (selfiesTypes.length === 1) {
	        this.setState({
	          lastType: true
	        });
	      }
	
	      if (selfiesTypes.length === 0) {
	        this.setState(Object.assign({}, this.state, {
	          loading: true
	        }));
	        var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	
	        var config = {
	          headers: {
	            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken'),
	            'Content-Type': 'multipart/form-data'
	          }
	        };
	
	        var formData = new FormData();
	
	        formData.append('renaper_browser_fingerprint', browserFingerPrint);
	
	        files.forEach(function (selfie) {
	          formData.append(selfie.imageType, selfie.file);
	        });
	
	        _axios2.default.post(ROOT_URL + '/identity/renaper/register', formData, config).then(function (response) {
	          if (response.status >= 200 && response.status <= 300) {
	            if (!response.data.status) {
	              _this2.setState(Object.assign({}, _this2.state, {
	                stepError: true
	              }));
	              setTimeout(_this2.props.onRollback, 5 * 1000);
	            } else {
	              _this2.props.onFinish();
	            }
	          }
	        }).catch(function (error) {
	          _this2.setState(Object.assign({}, _this2.state, {
	            stepError: true
	          }));
	          setTimeout(_this2.props.onRollback, 5 * 1000);
	        });
	      } else {
	        this.setState(Object.assign({}, this.state, {
	          currentType: selfiesTypes.pop(),
	          selfiesTypes: selfiesTypes
	        }));
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      event.preventDefault();
	      this.setState(Object.assign({}, this.state, {
	        play: true,
	        stepError: false
	      }));
	    }
	  }, {
	    key: 'getSelfiesTypesByIndex',
	    value: function getSelfiesTypesByIndex() {
	      var selectedSelfiesTypesByIndex = [0];
	      for (var i = 0; i < 2; i++) {
	        var randomIndex = null;
	        do {
	          randomIndex = (0, _utils.getRandomNumber)(1, 4, true);
	        } while (selectedSelfiesTypesByIndex.includes(randomIndex));
	        selectedSelfiesTypesByIndex.push(randomIndex);
	      }
	      return (0, _utils.shuffle)(selectedSelfiesTypesByIndex.map(function (index) {
	        return SELFIE_TYPES[index];
	      }));
	    }
	  }, {
	    key: 'setBrowserFingerPrint',
	    value: function setBrowserFingerPrint(browserInfo) {
	
	      var result = browserInfo.fingerprint; //Información a enviar al server en Base64
	      this.setState(Object.assign({}, this.state, {
	        browserFingerPrint: result
	      }));
	    }
	  }, {
	    key: 'handleDetectionFail',
	    value: function handleDetectionFail() {
	      var _this3 = this;
	
	      this.setState(Object.assign({}, this.state, {
	        loading: true,
	        stepError: true,
	        errorMessage: "No se ha detectado expresión, por favor intente de nuevo"
	      }));
	      setTimeout(function () {
	        setTimeout(_this3.props.onRollback, 5 * 1000);
	      }, 3000);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          currentType = _state2.currentType,
	          lastType = _state2.lastType,
	          play = _state2.play,
	          loading = _state2.loading,
	          stepError = _state2.stepError;
	
	
	      var startButton = _react2.default.createElement(
	        'div',
	        { style: {
	            textAlign: "center"
	          } },
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Coloc\xE1 tu rostro en el c\xEDrculo y puls\xE1 el bot\xF3n comenzar'
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            onClick: this.handleClick,
	            className: 'btn btn-primary btn-lg action-button' },
	          'Comenzar'
	        )
	      );
	
	      var errorMessage = _react2.default.createElement(_RenaperStepErrorMessage2.default, { message: this.state.errorMessage });
	
	      return _react2.default.createElement(
	        'div',
	        { style: {
	            position: "fixed",
	            left: 0,
	            top: 0,
	            height: "100%",
	            width: "100%",
	            background: "#000"
	          } },
	        loading && _react2.default.createElement(_CustomSpinner2.default, { message: stepError ? errorMessage : 'Estamos analizando los datos. Por favor espere...' }),
	        _react2.default.createElement(_SelfieCamera2.default, {
	          play: play,
	          fileType: currentType,
	          lastType: lastType,
	          onChange: this.handleChange,
	          onStart: this.handleClick,
	          handleDetectionFail: this.handleDetectionFail,
	          interval: 12,
	          shapeStyle: {
	            aspectRatio: 1,
	            defaultFixedSide: 'height',
	            borderRadius: '50%',
	            captureOptions: {
	              audio: false,
	              video: true
	            }
	          } }),
	        !play && startButton
	      );
	    }
	  }]);
	
	  return RenaperRegister;
	}(_react.Component);
	
	module.exports = RenaperRegister;

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RenaperScanDocumentTips = function RenaperScanDocumentTips(_ref) {
	    var onFinish = _ref.onFinish;
	
	    return _react2.default.createElement(
	        'div',
	        { style: {
	                position: "relative",
	                display: "block",
	                width: "100%",
	                height: "100%",
	                overflowY: "scroll",
	                background: "#0a2540"
	            } },
	        _react2.default.createElement(
	            _Section2.default,
	            { className: 'intro_form' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	                    _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(119) })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-10 col-md-10 col-lg-10 col-sm-offset-1 col-md-offset-1 col-lg-offset-1 text-center renaper-message' },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'Ubic\xE1 el frente de tu DNI dentro del rect\xE1ngulo para escanearlo.'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	                        _react2.default.createElement(
	                            'button',
	                            {
	                                type: 'submit',
	                                className: 'btn btn-warning btn-lg pd-button pd-form',
	                                onClick: function onClick(event) {
	                                    event.preventDefault();
	                                    onFinish();
	                                } },
	                            'Continuar'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	module.exports = RenaperScanDocumentTips;

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RenaperSelfieTips = function RenaperSelfieTips(_ref) {
	  var onFinish = _ref.onFinish;
	
	  return _react2.default.createElement(
	    'div',
	    { style: {
	        position: "relative",
	        display: "block",
	        width: "100%",
	        height: "100%",
	        overflowY: "scroll",
	        background: "#0a2540"
	      } },
	    _react2.default.createElement(
	      _Section2.default,
	      { className: 'intro_form' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	          _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(119) })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-10 col-md-10 col-lg-10 col-sm-offset-1 col-md-offset-1 col-lg-offset-1 text-center' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              'Necesitamos que hagas algunos gestos.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-10 col-md-10 col-lg-10 col-sm-offset-1 col-md-offset-1 col-lg-offset-1 text-center' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              'Sirve para confirmar que sos la persona que indica tu DNI.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'submit',
	                className: 'btn btn-warning btn-lg pd-button pd-form',
	                onClick: function onClick(event) {
	                  event.preventDefault();
	                  onFinish();
	                } },
	              'Entendido'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = RenaperSelfieTips;

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactBootstrap = __webpack_require__(40);
	
	var _DocumentField = __webpack_require__(1128);
	
	var _DocumentField2 = _interopRequireDefault(_DocumentField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RequiredDocForm = function (_Component) {
	    _inherits(RequiredDocForm, _Component);
	
	    function RequiredDocForm(props) {
	        _classCallCheck(this, RequiredDocForm);
	
	        var _this = _possibleConstructorReturn(this, (RequiredDocForm.__proto__ || Object.getPrototypeOf(RequiredDocForm)).call(this, props));
	
	        _this.state = {
	            isLoaded: false,
	            file: null,
	            updating: false,
	            errors: []
	        };
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.validateFile = _this.validateFile.bind(_this);
	        _this.handleChange = _this.handleChange.bind(_this);
	        return _this;
	    }
	
	    _createClass(RequiredDocForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            var config = {
	                headers: {
	                    'Content-Type': 'application/json',
	                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                }
	            };
	            _axios2.default.get(ROOT_URL + '/leads/upload_documents/' + this.props.documentType, config).then(function (response) {
	                _this2.setState({
	                    isLoaded: true
	                });
	                _this2.props.onUpdateStatus(_this2.props.documentType);
	            });
	        }
	    }, {
	        key: 'validateFile',
	        value: function validateFile() {
	            var errors = [];
	            if (!this.props.fileTypes.includes(this.state.file.type)) {
	                errors.push('Formato de archivo no válido.');
	            }
	            if (this.state.file.size > this.props.maxSize) {
	                errors.push('El tamaño del archivo supera el valor permitido.');
	            }
	            if (errors.length > 0) {
	                this.setState(Object.assign({}, this.state, { errors: errors }));
	                return false;
	            }
	            return true;
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(event) {
	            var _this3 = this;
	
	            event.preventDefault();
	            if (!this.validateFile()) {
	                return;
	            }
	            this.setState(Object.assign({}, this.state, { updating: true }));
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            var config = {
	                headers: {
	                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken'),
	                    'Content-Type': 'multipart/form-data'
	                }
	            };
	            var formData = new FormData();
	            formData.append('file', this.state.file);
	            _axios2.default.post(ROOT_URL + '/leads/upload_documents/' + this.props.documentType, formData, config).then(function (response) {
	                _this3.setState({
	                    isLoaded: true
	                });
	                _this3.props.onUpdateStatus(_this3.props.documentType);
	            });
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(file) {
	            this.setState(Object.assign({}, this.state, {
	                file: file,
	                errors: []
	            }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = Object.assign({}, this.state),
	                updating = _state.updating,
	                file = _state.file,
	                isLoaded = _state.isLoaded,
	                errors = _state.errors;
	
	            var field = _react2.default.createElement(_DocumentField2.default, { label: this.props.label, onChange: this.handleChange, updating: updating });
	
	            var errorComponent = errors.map(function (error) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'terms_row' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'col-lg-offset-7 col-md-offset-7 col-xs-offset-7', xs: 5, md: 5, lg: 5 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'help-block', style: { color: '#c00' } },
	                            error
	                        )
	                    )
	                );
	            });
	            var documentForm = _react2.default.createElement(
	                'div',
	                { style: { padding: '10px 0px 10px 0px' } },
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'terms_row' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'terms_col terms_checkbox pd-vcenter', xs: 12, md: 10, lg: 10 },
	                        field
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'terms_col pd-vcenter text-center', xs: 12, md: 2, lg: 2 },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-default', disabled: updating || !file, onClick: this.handleSubmit },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                updating ? 'Enviando' : 'Enviar'
	                            )
	                        )
	                    )
	                ),
	                errors ? errorComponent : ''
	            );
	
	            var loadedComponent = _react2.default.createElement(
	                'div',
	                { style: { padding: '10px 0px 10px 0px' } },
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    { className: 'terms_row' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'terms_col terms_checkbox pd-vcenter', xs: 12, md: 10, lg: 10 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            { className: 'terms_row' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { className: 'terms_col terms_checkbox pd-vcenter text-center', xs: 12, md: 12, lg: 12 },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    this.props.label
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { className: 'terms_col pd-vcenter text-center', xs: 12, md: 2, lg: 2 },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-success', disabled: true },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'Enviado'
	                            )
	                        )
	                    )
	                ),
	                errors ? errorComponent : ''
	            );
	
	            var component = isLoaded ? loadedComponent : documentForm;
	
	            return component;
	        }
	    }]);
	
	    return RequiredDocForm;
	}(_react.Component);
	
	exports.default = RequiredDocForm;

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(19);
	
	var _reduxForm = __webpack_require__(16);
	
	var _SelectField = __webpack_require__(121);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SalaryTypeSelect = function (_Component) {
	    _inherits(SalaryTypeSelect, _Component);
	
	    function SalaryTypeSelect(props) {
	        _classCallCheck(this, SalaryTypeSelect);
	
	        var _this = _possibleConstructorReturn(this, (SalaryTypeSelect.__proto__ || Object.getPrototypeOf(SalaryTypeSelect)).call(this, props));
	
	        _this.customOnChange = _this.customOnChange.bind(_this);
	        return _this;
	    }
	
	    _createClass(SalaryTypeSelect, [{
	        key: 'customOnChange',
	        value: function customOnChange(event) {
	            this.props.dispatch((0, _reduxForm.arrayRemoveAll)("IncomesForm", "check_stubs"));
	            switch (event.target.value) {
	                case '0':
	                    this.props.dispatch((0, _reduxForm.arrayPush)("IncomesForm", "check_stubs", {}));
	                    break;
	                case '1':
	                    this.props.dispatch((0, _reduxForm.arrayPush)("IncomesForm", "check_stubs", {}));
	                    this.props.dispatch((0, _reduxForm.arrayPush)("IncomesForm", "check_stubs", {}));
	                    break;
	                default:
	                    this.props.dispatch((0, _reduxForm.arrayPush)("IncomesForm", "check_stubs", {}));
	            }
	            this.props.input.onChange(event);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var props = Object.assign({}, this.props, { input: { onChange: this.customOnChange } });
	            return _react2.default.createElement(_SelectField2.default, props);
	        }
	    }]);
	
	    return SalaryTypeSelect;
	}(_react.Component);
	
	var selector = (0, _reduxForm.formValueSelector)('IncomesForm');
	
	SalaryTypeSelect = (0, _reactRedux.connect)(function (state) {
	    var salary_type = selector(state, 'salary_type');
	    return {
	        salary_type: salary_type
	    };
	})(SalaryTypeSelect);
	
	exports.default = SalaryTypeSelect;

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(16);
	
	var _RenderField = __webpack_require__(78);
	
	var _RenderField2 = _interopRequireDefault(_RenderField);
	
	var _TextWithLine = __webpack_require__(332);
	
	var _TextWithLine2 = _interopRequireDefault(_TextWithLine);
	
	var _AttributeOptions = __webpack_require__(194);
	
	var _AttributeOptions2 = _interopRequireDefault(_AttributeOptions);
	
	var _IncomeInformationForm = __webpack_require__(1136);
	
	var _IncomeInformationForm2 = _interopRequireDefault(_IncomeInformationForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelfEmploymentForm = function (_Component) {
	    _inherits(SelfEmploymentForm, _Component);
	
	    function SelfEmploymentForm(props) {
	        _classCallCheck(this, SelfEmploymentForm);
	
	        var _this = _possibleConstructorReturn(this, (SelfEmploymentForm.__proto__ || Object.getPrototypeOf(SelfEmploymentForm)).call(this, props));
	
	        _this.state = {
	            show_leasing_value_field: false
	
	        };
	        _this.checkLeaseValue = _this.checkLeaseValue.bind(_this);
	        _this.renderIncomeInformation = _this.renderIncomeInformation.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(SelfEmploymentForm, [{
	        key: 'checkLeaseValue',
	        value: function checkLeaseValue(value) {
	            if (value === 1) {
	                this.setState({ show_leasing_value_field: true });
	            } else {
	                this.setState({ show_leasing_value_field: false });
	                this.props.deleteReduxFormField('leasing_value');
	            }
	        }
	    }, {
	        key: 'renderIncomeInformation',
	        value: function renderIncomeInformation(_ref) {
	            var _this2 = this;
	
	            var fields = _ref.fields;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                fields.map(function (member, index, fields) {
	                    return _react2.default.createElement(_IncomeInformationForm2.default, { member: member, selfEmploymentType: _this2.props.selfEmploymentType, key: index });
	                })
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var monotributo_categories = [{ id: 0, name: 'A' }, { id: 1, name: 'B' }, { id: 2, name: 'C' }, { id: 3, name: 'D' }, { id: 4, name: 'E' }, { id: 5, name: 'F' }, { id: 6, name: 'G' }, { id: 7, name: 'H' }, { id: 8, name: 'I' }, { id: 9, name: 'J' }, { id: 10, name: 'K' }];
	            var leasing_types = [{ id: 0, name: 'Alquila' }, { id: 1, name: 'Propietario' }];
	
	            var leasing_value_field = _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 col-md-4 col-lg-4' },
	                _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'leasing_value', autoComplete: 'off', component: _RenderField2.default, type: 'currency', label: 'Valor Alquiler' })
	            );
	
	            var monotributo_category_field = _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 col-md-4 col-lg-4' },
	                _react2.default.createElement(_AttributeOptions2.default, { name: 'monotributo_category', defaultValue: 'Categor\xEDa', label: 'Categor\xEDa', attributeName: 'monotributo_category', attributeOptions: monotributo_categories })
	            );
	
	            var monthly_costs_field = _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 col-md-12 col-lg-4' },
	                _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'monthly_costs', autoComplete: 'off', component: _RenderField2.default, type: 'currency', label: 'Costos mensuales aprox.' })
	            );
	
	            var number_of_employees_field = _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 col-md-12 col-lg-4' },
	                _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'number_of_employees', autoComplete: 'off', component: _RenderField2.default, type: 'number', label: 'Cantidad de Personal' })
	            );
	
	            var leasing_type_field = _react2.default.createElement(
	                'div',
	                { className: 'col-sm-12 col-md-12 col-lg-4' },
	                _react2.default.createElement(_AttributeOptions2.default, { name: 'leasing_type', defaultValue: 'Locaci\xF3n de Trabajo', label: 'Locaci\xF3n de Trabajo', attributeName: 'leasing_types', attributeOptions: leasing_types, onChange: this.checkLeaseValue })
	            );
	
	            var monotributo_fields = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    monotributo_category_field,
	                    monthly_costs_field,
	                    number_of_employees_field
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    leasing_type_field,
	                    this.state.show_leasing_value_field && leasing_value_field
	                )
	            );
	
	            var resp_inscripto_fields = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    monthly_costs_field,
	                    number_of_employees_field,
	                    leasing_type_field
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    this.state.show_leasing_value_field && leasing_value_field
	                )
	            );
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-sm-12 col-md-12 col-lg-12' },
	                        _react2.default.createElement(_TextWithLine2.default, { value: 'Ingresos ' + this.props.selfEmploymentType })
	                    )
	                ),
	                this.props.selfEmploymentType === 'Monotributista' && monotributo_fields || resp_inscripto_fields,
	                _react2.default.createElement(_reduxForm.FieldArray, { name: 'self_employment_incomes', component: this.renderIncomeInformation })
	            );
	        }
	    }]);
	
	    return SelfEmploymentForm;
	}(_react.Component);
	
	exports.default = SelfEmploymentForm;

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(195);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMeasure = __webpack_require__(455);
	
	var _reactMeasure2 = _interopRequireDefault(_reactMeasure);
	
	var _faceApi = __webpack_require__(1475);
	
	var faceapi = _interopRequireWildcard(_faceApi);
	
	var _reactBootstrap = __webpack_require__(40);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(138);
	
	
	var CAPTURE_OPTIONS = {
	  audio: false,
	  video: {
	    facingMode: 'user'
	  }
	};
	
	var SelfieCamera = function (_Component) {
	  _inherits(SelfieCamera, _Component);
	
	  function SelfieCamera(props) {
	    _classCallCheck(this, SelfieCamera);
	
	    var _this = _possibleConstructorReturn(this, (SelfieCamera.__proto__ || Object.getPrototypeOf(SelfieCamera)).call(this, props));
	
	    _this.state = {
	      stream: null,
	      picture: null,
	      changedType: true,
	      currentSecond: 0,
	      countDown: null,
	      shutted: false,
	      checked: false,
	      pictureUrl: null,
	      saved: false,
	      playing: false,
	      hasCameraPermission: false,
	      mediaSize: {
	        height: 0,
	        width: 0,
	        aspectRatio: 1.586
	      },
	      resizedVideo: {
	        height: null,
	        width: null
	      },
	      modelsLoaded: null
	    };
	    _this.video = null;
	    _this.containerVideo = null;
	    _this.canvas = null;
	    _this.handleOnChange = _this.handleOnChange.bind(_this);
	    _this.handleCanPlay = _this.handleCanPlay.bind(_this);
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.onCapture = _this.onCapture.bind(_this);
	    _this.handleCapture = _this.handleCapture.bind(_this);
	    _this.onClear = _this.onClear.bind(_this);
	    _this.handleClear = _this.handleClear.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.manageTimer = _this.manageTimer.bind(_this);
	    return _this;
	  }
	
	  _createClass(SelfieCamera, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this2 = this;
	
	        var loadModels, vw, captureOptions;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                loadModels = function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                    var MODEL_URL;
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            MODEL_URL = './models';
	                            _context.prev = 1;
	                            _context.next = 4;
	                            return Promise.all([faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL), faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL), faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL), faceapi.nets.faceExpressionNet.loadFromUri(MODEL_URL)]);
	
	                          case 4:
	                            _this2.setState({ modelsLoaded: true });
	                            _context.next = 10;
	                            break;
	
	                          case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context['catch'](1);
	
	                            console.error("Error al cargar modelos:", _context.t0);
	
	                          case 10:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2, [[1, 7]]);
	                  }));
	
	                  return function loadModels() {
	                    return _ref2.apply(this, arguments);
	                  };
	                }();
	
	                if (!this.state.modelsLoaded) loadModels();
	                vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
	                captureOptions = this.props.captureOptions || Object.assign({}, CAPTURE_OPTIONS, {
	                  video: vw > 992 ? {
	                    facingMode: 'user',
	                    width: { ideal: 4096 },
	                    height: { ideal: 2160 }
	                  } : { facingMode: 'user' }
	                });
	
	                navigator.mediaDevices.getUserMedia(captureOptions).then(function (stream) {
	                  _this2.setState(Object.assign({}, _this2.state, {
	                    stream: stream,
	                    hasCameraPermission: true
	                  }));
	                });
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	      this.state.stream.getTracks().forEach(function (track) {
	        track.stop();
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var hasCameraPermission = this.state.hasCameraPermission;
	      var _props = this.props,
	          fileType = _props.fileType,
	          play = _props.play,
	          interval = _props.interval;
	
	      var prevFileType = prevProps.fileType;
	      if (hasCameraPermission && play && play !== prevProps.play || play && fileType && prevFileType && fileType.type !== prevFileType.type) {
	
	        clearInterval(this.timer);
	        this.setState(Object.assign({}, this.state, {
	          currentSecond: 0,
	          shutted: false,
	          checked: false
	        }));
	
	        this.timer = setInterval(this.manageTimer, 1000);
	      }
	    }
	  }, {
	    key: 'handleOnChange',
	    value: function handleOnChange(event) {
	      event.preventDefault();
	      if (this.props.onChange) {
	        this.props.onChange(this.state.picture);
	      }
	      this.setState(Object.assign({}, this.state, {
	        saved: true
	      }));
	    }
	  }, {
	    key: 'handleCapture',
	    value: function handleCapture(event) {
	      var _this3 = this;
	
	      var mediaSize = this.state.mediaSize;
	
	      var offset = this.calculateOffset(mediaSize, this.video);
	      if (event) {
	        event.preventDefault();
	      }
	
	      var hiddenCanvas = document.createElement('canvas');
	      this.canvas = hiddenCanvas;
	      hiddenCanvas.height = this.video.videoHeight;
	      hiddenCanvas.width = this.video.videoWidth;
	      var hiddenContext = hiddenCanvas.getContext('2d');
	      hiddenContext.drawImage(this.video, 0, 0, this.video.videoWidth, this.video.videoHeight, 0, 0, this.video.videoWidth, this.video.videoHeight);
	
	      hiddenCanvas.toBlob(function (blob) {
	        return _this3.onCapture(blob);
	      }, "image/jpeg", 1);
	
	      this.setState(Object.assign({}, this.state, {
	        pictureUrl: hiddenCanvas.toDataURL('image/jpeg', 1),
	        shutted: true
	      }));
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(contentRect) {
	      var _state = this.state,
	          mediaSize = _state.mediaSize,
	          stream = _state.stream;
	
	
	      var calculatedSize = {};
	
	      if (contentRect.entry) {
	
	        if (this.video) {
	          var browserVideoSize = stream.getVideoTracks()[0].getSettings();
	          var videoAspectRatio = null;
	          var resizedVideo = {};
	          var originalVideoSize = {
	            width: browserVideoSize.width,
	            height: browserVideoSize.height
	          };
	
	          if (contentRect.entry.height > contentRect.entry.width) {
	            originalVideoSize = {
	              width: browserVideoSize.width > browserVideoSize.height ? browserVideoSize.height : browserVideoSize.width,
	              height: browserVideoSize.width > browserVideoSize.height ? browserVideoSize.width : browserVideoSize.height
	            };
	          }
	
	          videoAspectRatio = originalVideoSize.width / originalVideoSize.height;
	
	          var capturedScreenHeight = originalVideoSize.height * 100 / contentRect.entry.height;
	          var capturdScreenWidth = originalVideoSize.width * 100 / contentRect.entry.width;
	
	          if (capturedScreenHeight > capturdScreenWidth) {
	            resizedVideo = {
	              width: contentRect.entry.width,
	              height: contentRect.entry.width / videoAspectRatio
	            };
	          } else {
	            resizedVideo = {
	              width: contentRect.entry.height * videoAspectRatio,
	              height: contentRect.entry.height
	            };
	          }
	
	          this.setState(Object.assign({}, this.state, {
	            resizedVideo: Object.assign({}, resizedVideo)
	          }));
	        }
	      }
	    }
	  }, {
	    key: 'onCapture',
	    value: function onCapture(blob) {
	      this.setState(Object.assign({}, this.state, {
	        picture: blob
	      }));
	    }
	  }, {
	    key: 'handleClear',
	    value: function handleClear() {
	      var context = this.canvas.getContext("2d");
	      context.clearRect(0, 0, this.canvas.width, this.canvas.height);
	      this.onClear();
	    }
	  }, {
	    key: 'onClear',
	    value: function onClear(blob) {
	      this.setState(Object.assign({}, this.state, { picture: undefined }));
	    }
	  }, {
	    key: 'startFacialExpressionDetection',
	    value: function startFacialExpressionDetection(type) {
	      var _this4 = this;
	
	      var detectExpressions = function () {
	        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	          var detections, expressions, expressionDetected;
	          return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  if (!(!_this4.video || _this4.video.paused || _this4.video.ended || !_this4.state.playing)) {
	                    _context3.next = 2;
	                    break;
	                  }
	
	                  return _context3.abrupt('return');
	
	                case 2:
	                  _context3.next = 4;
	                  return faceapi.detectAllFaces(_this4.video, new faceapi.TinyFaceDetectorOptions()).withFaceLandmarks().withFaceExpressions();
	
	                case 4:
	                  detections = _context3.sent;
	
	                  if (!(detections.length > 0)) {
	                    _context3.next = 16;
	                    break;
	                  }
	
	                  expressions = detections[0].expressions;
	                  expressionDetected = false;
	                  _context3.t0 = type;
	                  _context3.next = _context3.t0 === 'SN' ? 11 : _context3.t0 === 'SN-alt' ? 11 : _context3.t0 === 'SS' ? 13 : _context3.t0 === 'SS-alt' ? 13 : 15;
	                  break;
	
	                case 11:
	                  // Neutral
	                  expressionDetected = expressions.neutral > 0.5;
	                  return _context3.abrupt('break', 15);
	
	                case 13:
	                  // Smile
	                  expressionDetected = expressions.happy > 0.5;
	                  return _context3.abrupt('break', 15);
	
	                case 15:
	                  if (expressionDetected) {
	                    _this4.handleCapture();
	                    _this4.setState(Object.assign({}, _this4.state, {
	                      checked: true
	                    }));
	                    setTimeout(function () {
	                      _this4.handleChange();
	                    }, 1000);
	                  }
	
	                case 16:
	                  if (!_this4.state.shutted) {
	                    setTimeout(detectExpressions, 100);
	                  }
	
	                case 17:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this4);
	        }));
	
	        return function detectExpressions() {
	          return _ref3.apply(this, arguments);
	        };
	      }();
	      detectExpressions();
	    }
	  }, {
	    key: 'handleCanPlay',
	    value: function handleCanPlay() {
	      var mediaSize = this.state.mediaSize;
	
	      var newAspectRatio = this.calculateRatio(this.video.videoHeight, this.video.videoWidth);
	
	      this.setState(Object.assign({}, this.state, {
	        playing: true,
	        mediaSize: Object.assign({}, mediaSize, {
	          aspectRatio: newAspectRatio || mediaSize.aspectRatio
	        })
	      }));
	      this.video.play();
	    }
	  }, {
	    key: 'calculateRatio',
	    value: function calculateRatio(height, width) {
	      if (height && width) {
	        var isLandscape = height <= width;
	        var ratio = isLandscape ? width / height : height / width;
	        return ratio;
	      }
	    }
	  }, {
	    key: 'calculateDocumentFrame',
	    value: function calculateDocumentFrame(containerWidth, containerHeight, frameAspectRatio) {
	      var defaultFixedSide = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	      var fixedSide = containerWidth >= containerHeight ? containerWidth : containerHeight;
	      if (defaultFixedSide) {
	        fixedSide = defaultFixedSide === 'width' ? containerWidth : containerHeight;
	      }
	      var variableSide = fixedSide == containerWidth ? containerHeight : containerWidth;
	      var fixedSideFrame = 20;
	      var fixedContentSize = Math.round(fixedSide - fixedSideFrame * 2);
	      var variableContentSize = Math.round(fixedContentSize / frameAspectRatio);
	      var variableSideFrame = (variableSide - variableContentSize) / 2;
	      return {
	        frameWidth: fixedSide === containerWidth ? fixedSideFrame : variableSideFrame,
	        frameHeight: fixedSide === containerHeight ? fixedSideFrame : variableSideFrame
	      };
	    }
	  }, {
	    key: 'calculateOffset',
	    value: function calculateOffset(videoContainer, video) {
	      if (video && videoContainer) {
	        return {
	          x: video.videoWidth > videoContainer.width ? Math.round((video.videoWidth - videoContainer.width) / 2) : 0,
	          y: video.videoHeight > videoContainer.height ? Math.round((video.videoHeight - videoContainer.height) / 2) : 0
	        };
	      }
	    }
	  }, {
	    key: 'manageTimer',
	    value: function manageTimer() {
	      var _state2 = this.state,
	          currentSecond = _state2.currentSecond,
	          countDown = _state2.countDown;
	      var interval = this.props.interval;
	
	
	      currentSecond += 1;
	      countDown = null;
	
	      if (currentSecond === 2) {
	        this.startFacialExpressionDetection(this.props.fileType.type);
	      }
	      if (currentSecond === interval) {
	        if (!this.state.checked) {
	          this.props.handleDetectionFail();
	        }
	      }
	      this.setState(Object.assign({}, this.state, {
	        currentSecond: currentSecond,
	        countDown: countDown,
	        changedType: false
	      }));
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange() {
	      var onChange = this.props.onChange;
	      var picture = this.state.picture;
	
	
	      onChange(picture);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _state3 = this.state,
	          mediaSize = _state3.mediaSize,
	          hasCameraPermission = _state3.hasCameraPermission,
	          resizedVideo = _state3.resizedVideo,
	          shutted = _state3.shutted,
	          currentSecond = _state3.currentSecond,
	          checked = _state3.checked,
	          countDown = _state3.countDown;
	      var _props2 = this.props,
	          shapeStyle = _props2.shapeStyle,
	          fileType = _props2.fileType,
	          play = _props2.play,
	          interval = _props2.interval;
	
	      if (this.state.stream && this.video && !this.video.srcObject) {
	        this.video.srcObject = this.state.stream;
	      }
	      var selfieIcon = _react2.default.createElement(
	        'div',
	        {
	          style: {
	            textAlign: "center",
	            padding: '10px'
	          } },
	        _react2.default.createElement('img', {
	          src: hasCameraPermission && play && fileType && (checked && fileType.successIcon || fileType.icon) || '',
	          style: {
	            maxWidth: "48px",
	            width: "100%"
	          } })
	      );
	
	      var selfieTip = _react2.default.createElement(
	        'div',
	        {
	          style: {
	            textAlign: "center"
	          } },
	        _react2.default.createElement(
	          'h3',
	          { style: {
	              margin: "0 auto",
	              color: "#FFF"
	            } },
	          hasCameraPermission && play && fileType && fileType.description || ''
	        )
	      );
	
	      var documentFrames = this.calculateDocumentFrame(mediaSize.width, mediaSize.height, shapeStyle.aspectRatio, shapeStyle.defaultFixedSide);
	      var videoOffset = this.calculateOffset(mediaSize, this.video);
	
	      var ConfirmButtons = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary action-button', onClick: this.handleOnChange },
	          _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok', 'aria-hidden': 'true' })
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary action-button', onClick: this.handleClear },
	          _react2.default.createElement('span', { className: 'glyphicon glyphicon-remove', 'aria-hidden': 'true' })
	        )
	      );
	      var shownButtons = this.state.picture ? ConfirmButtons : _react2.default.createElement(
	        'button',
	        { onClick: this.handleCapture, className: 'btn btn-primary btn-lg action-button' },
	        _react2.default.createElement('span', { className: 'glyphicon glyphicon-camera', 'aria-hidden': 'true' })
	      );
	      var alert = _react2.default.createElement(
	        'div',
	        { className: 'alert alert-warning', role: 'alert' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Debes aceptar el permiso para poder acceder a tu camara.'
	        )
	      );
	
	      var startButton = _react2.default.createElement(
	        'div',
	        { style: {
	            textAlign: "center"
	          } },
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Coloca tu rostro en el c\xEDrculo y pulsa el boton comenzar'
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            onClick: this.props.onStart,
	            className: 'btn btn-primary btn-lg action-button' },
	          'Comenzar'
	        )
	      );
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: {
	            height: "100%",
	            width: "100%",
	            background: "#000"
	          } },
	        _react2.default.createElement(
	          'div',
	          { style: {
	              height: "100%",
	              width: "100%",
	              margin: "0 auto"
	            } },
	          !hasCameraPermission && alert || _react2.default.createElement(
	            _reactMeasure2.default,
	            { onResize: this.handleResize },
	            function (_ref4) {
	              var measureRef = _ref4.measureRef;
	              return _react2.default.createElement(
	                'div',
	                {
	                  ref: measureRef,
	                  style: {
	                    position: "relative",
	                    height: "100%",
	                    width: "100%",
	                    overflow: "hidden"
	                  } },
	                _react2.default.createElement('video', {
	                  ref: function ref(component) {
	                    _this5.video = component;
	                  },
	                  onPlay: _this5.handleCanPlay,
	                  style: {
	                    position: 'absolute',
	                    width: resizedVideo && resizedVideo.width || "100%",
	                    height: resizedVideo && resizedVideo.height || "100%",
	                    objectFit: "fill",
	                    top: "50%",
	                    left: "50%",
	                    transform: "translate(-50%,-50%)scaleX(-1)"
	                  },
	                  hidden: false,
	                  autoPlay: true,
	                  playsInline: true,
	                  muted: true
	                }),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: shutted ? 'shutted' : '',
	                    style: {
	                      position: 'absolute',
	                      width: "100%",
	                      height: "100%"
	                    } },
	                  _react2.default.createElement('div', { style: Object.assign({
	                      position: 'absolute',
	                      marginLeft: "50%",
	                      top: "45%",
	                      transform: "translate(-50%, -50%)",
	                      width: resizedVideo.width > resizedVideo.height ? "70vh" : "90vw",
	                      height: resizedVideo.width > resizedVideo.height ? "70vh" : "90vw",
	                      boxShadow: '0px 0px 20px 900px rgba(0, 0, 0, 0.6)',
	                      border: '1px solid #ffffff',
	                      borderRadius: 10
	                    }, shapeStyle) })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: {
	                      position: 'absolute',
	                      marginLeft: "50%",
	                      top: "45%",
	                      transform: "translate(-50%, -50%)",
	                      fontSize: '10vh',
	                      color: '#fff'
	                    } },
	                  countDown || ''
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    style: {
	                      position: "absolute",
	                      marginLeft: "50%",
	                      transform: "translateX(-50%)",
	                      top: "10px",
	                      textAlign: "center"
	                    } },
	                  hasCameraPermission && play && fileType && selfieIcon
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    style: {
	                      position: "absolute",
	                      marginLeft: "50%",
	                      transform: "translateX(-50%)",
	                      bottom: "10px",
	                      textAlign: "center"
	                    } },
	                  hasCameraPermission && play && fileType && selfieTip,
	                  hasCameraPermission && play && fileType && fileType.description && _react2.default.createElement(_reactBootstrap.ProgressBar, {
	                    className: '' + (checked ? 'progress-success' : ''),
	                    style: { width: "60vw" },
	                    now: currentSecond / interval * 100
	                  }),
	                  hasCameraPermission && !play && startButton
	                ),
	                _react2.default.createElement('canvas', {
	                  ref: function ref(component) {
	                    _this5.canvas = component;
	                  },
	                  style: {
	                    position: 'absolute',
	                    marginLeft: "50%",
	                    transform: "translateX(-50%)"
	                  },
	                  width: _this5.state.mediaSize.width,
	                  height: _this5.state.mediaSize.height,
	                  hidden: true
	                })
	              );
	            }
	          )
	        )
	      );
	    }
	  }]);
	
	  return SelfieCamera;
	}(_react.Component);
	
	module.exports = SelfieCamera;

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(16);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	var _CustomAlertModal = __webpack_require__(328);
	
	var _CustomAlertModal2 = _interopRequireDefault(_CustomAlertModal);
	
	var _SelfieWithDocumentRegister = __webpack_require__(1167);
	
	var _SelfieWithDocumentRegister2 = _interopRequireDefault(_SelfieWithDocumentRegister);
	
	var _SelfieWithDocumentIntroduction = __webpack_require__(1166);
	
	var _SelfieWithDocumentIntroduction2 = _interopRequireDefault(_SelfieWithDocumentIntroduction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PHOTO_STEPS = ['register', 'introduction'];
	
	var SelfieWithDocument = function (_Component) {
	  _inherits(SelfieWithDocument, _Component);
	
	  function SelfieWithDocument(props) {
	    _classCallCheck(this, SelfieWithDocument);
	
	    var _this = _possibleConstructorReturn(this, (SelfieWithDocument.__proto__ || Object.getPrototypeOf(SelfieWithDocument)).call(this, props));
	
	    _this.state = {
	      attempt: 1,
	      processedSteps: [],
	      currentStep: PHOTO_STEPS.pop(),
	      missingSteps: [].concat(PHOTO_STEPS),
	      incompatibleSettings: false
	    };
	
	    _this.resetSteps = _this.resetSteps.bind(_this);
	    _this.updateStep = _this.updateStep.bind(_this);
	    _this.checkBrowserCompatibility = _this.checkBrowserCompatibility.bind(_this);
	    return _this;
	  }
	
	  _createClass(SelfieWithDocument, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var body = document.getElementsByTagName("BODY")[0];
	      body.style.position = "fixed";
	      this.checkBrowserCompatibility();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var body = document.getElementsByTagName("BODY")[0];
	      body.style.position = "inherit";
	    }
	  }, {
	    key: 'updateStep',
	    value: function updateStep() {
	      var _state = this.state,
	          currentStep = _state.currentStep,
	          missingSteps = _state.missingSteps,
	          processedSteps = _state.processedSteps;
	
	      this.setState(Object.assign({}, this.state, {
	        processedSteps: [].concat(_toConsumableArray(processedSteps), [currentStep])
	      }));
	
	      if (missingSteps.length === 0) {
	
	        this.props.dispatch(this.props.getStep({}, this.props.dispatch));
	      }
	
	      this.setState(Object.assign({}, this.state, {
	        currentStep: missingSteps.pop(),
	        missingSteps: [].concat(_toConsumableArray(missingSteps))
	      }));
	    }
	  }, {
	    key: 'checkBrowserCompatibility',
	    value: function checkBrowserCompatibility() {
	      if (/iPhone|iPad/.test(navigator.userAgent)) {
	        if (!/Version\//.test(navigator.userAgent)) {
	          this.setState(Object.assign({}, this.state, {
	            incompatibleSettings: true
	          }));
	        }
	      }
	    }
	  }, {
	    key: 'resetSteps',
	    value: function resetSteps() {
	      this.setState({
	        attempt: this.state.attempt + 1,
	        processedSteps: [],
	        currentStep: 'introduction',
	        missingSteps: [].concat(PHOTO_STEPS)
	      });
	
	      this.props.dispatch(this.props.getStep({}, this.props.dispatch));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          currentStep = _state2.currentStep,
	          incompatibleSettings = _state2.incompatibleSettings,
	          attempt = _state2.attempt;
	
	
	      var stepComponent = null;
	
	      switch (currentStep) {
	        case 'introduction':
	          stepComponent = _react2.default.createElement(_SelfieWithDocumentIntroduction2.default, { onFinish: this.updateStep });
	          break;
	        case 'register':
	          stepComponent = _react2.default.createElement(_SelfieWithDocumentRegister2.default, { onFinish: this.updateStep, onRollback: this.resetSteps, key: attempt });
	          break;
	        default:
	          stepComponent = '';
	      }
	
	      return _react2.default.createElement(
	        _Section2.default,
	        { className: 'intro_form' },
	        this.props.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pd-content-right col-sm-12 col-md-12 col-lg-12' },
	            _react2.default.createElement(
	              'form',
	              { className: 'pvc-form' },
	              _react2.default.createElement(
	                'div',
	                { style: {
	                    position: "fixed",
	                    left: 0,
	                    top: 0,
	                    height: "100vh",
	                    width: "100%",
	                    background: "#000",
	                    zIndex: "1000"
	                  } },
	                stepComponent,
	                incompatibleSettings && _react2.default.createElement(
	                  _CustomAlertModal2.default,
	                  null,
	                  'Para poder acceder a la c\xE1mara de su dispositivo necesitamos que por favor reingrese desde Safari'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SelfieWithDocument;
	}(_react.Component);
	
	SelfieWithDocument = (0, _reduxForm.reduxForm)({
	  form: 'SelfieWithDocument' // a unique name for this form
	})(SelfieWithDocument);
	
	SelfieWithDocument = (0, _Auth2.default)(SelfieWithDocument);
	
	exports.default = SelfieWithDocument;

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1416);
	
	var SelfieWithDocumentIntroduction = function SelfieWithDocumentIntroduction(_ref) {
	  var onFinish = _ref.onFinish;
	
	  return _react2.default.createElement(
	    'div',
	    { style: {
	        position: "relative",
	        display: "block",
	        width: "100%",
	        height: "100%",
	        overflowY: "scroll",
	        background: "#0a2540"
	      } },
	    _react2.default.createElement(
	      _Section2.default,
	      { className: 'intro_form' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	          _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(119) })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-10 col-md-10 col-lg-10 col-sm-offset-1 col-md-offset-1 col-lg-offset-1 text-center selfie-message', style: { marginTop: "50px; !important" } },
	          _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              'Necesitamos una selfie con tu DNI en mano. Tal como figura en la imagen.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-10 col-md-10 col-lg-10 col-sm-offset-1 col-md-offset-1 col-lg-offset-1 text-center' },
	          '                ',
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-10 col-md-10 col-lg-8 col-sm-offset-1 col-md-offset-1 col-lg-offset-2 text-center dni-img-container' },
	            _react2.default.createElement('img', { alt: 'Selfie con instrucciones', src: __webpack_require__(2053) })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'submit',
	                className: 'btn btn-warning btn-lg pd-button pd-form',
	                onClick: function onClick(event) {
	                  event.preventDefault();
	                  onFinish();
	                } },
	              'Entendido'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = SelfieWithDocumentIntroduction;

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(195);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _RenaperStepErrorMessage = __webpack_require__(246);
	
	var _RenaperStepErrorMessage2 = _interopRequireDefault(_RenaperStepErrorMessage);
	
	var _SelfieWithDocumentSelfieCamera = __webpack_require__(1168);
	
	var _SelfieWithDocumentSelfieCamera2 = _interopRequireDefault(_SelfieWithDocumentSelfieCamera);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(138);
	
	var SELFIE_TYPES = [{
	  type: "SCD",
	  description: "Sostené tu dni de frente",
	  icon: __webpack_require__(946),
	  successIcon: __webpack_require__(946)
	}];
	
	var SelfieWithDocumentRegister = function (_Component) {
	  _inherits(SelfieWithDocumentRegister, _Component);
	
	  function SelfieWithDocumentRegister(props) {
	    _classCallCheck(this, SelfieWithDocumentRegister);
	
	    var _this = _possibleConstructorReturn(this, (SelfieWithDocumentRegister.__proto__ || Object.getPrototypeOf(SelfieWithDocumentRegister)).call(this, props));
	
	    _this.state = {
	      files: [],
	      currentType: null,
	      lastType: false,
	      selfiesTypes: [],
	      play: false,
	      loading: false,
	      browserFingerPrint: null,
	      stepError: false,
	      errorMessage: null
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.setBrowserFingerPrint = _this.setBrowserFingerPrint.bind(_this);
	    return _this;
	  }
	
	  _createClass(SelfieWithDocumentRegister, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var vuFp;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                this.setState({
	                  currentType: SELFIE_TYPES[0]
	                });
	                vuFp = new window.VUBrowserFP();
	
	                vuFp.getFingerprintInfoWithSeed(this.setBrowserFingerPrint);
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'handleChange',
	    value: function handleChange(file) {
	      var _this2 = this;
	
	      var _state = this.state,
	          currentType = _state.currentType,
	          selfiesTypes = _state.selfiesTypes,
	          files = _state.files,
	          browserFingerPrint = _state.browserFingerPrint;
	
	      files.push({
	        imageType: currentType.type,
	        file: file
	      });
	
	      this.setState(Object.assign({}, this.state, {
	        files: files
	      }));
	
	      this.setState(Object.assign({}, this.state, {
	        lastType: true,
	        loading: true
	      }));
	      var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	
	      var config = {
	        headers: {
	          'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken'),
	          'Content-Type': 'multipart/form-data'
	        }
	      };
	
	      var formData = new FormData();
	
	      formData.append('renaper_browser_fingerprint', browserFingerPrint);
	
	      files.forEach(function (selfie) {
	        formData.append(selfie.imageType, selfie.file);
	      });
	
	      _axios2.default.post(ROOT_URL + '/identity/selfiewithdocument/register', formData, config).then(function (response) {
	        if (response.status >= 200 && response.status <= 300) {
	          if (!response.data.status) {
	            _this2.setState(Object.assign({}, _this2.state, {
	              stepError: true
	            }));
	            setTimeout(_this2.props.onRollback, 5 * 1000);
	          } else {
	            _this2.props.onFinish();
	          }
	        }
	      }).catch(function (error) {
	        _this2.setState(Object.assign({}, _this2.state, {
	          stepError: true
	        }));
	        setTimeout(_this2.props.onRollback, 5 * 1000);
	      });
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      event.preventDefault();
	      this.setState(Object.assign({}, this.state, {
	        play: true,
	        stepError: false
	      }));
	    }
	  }, {
	    key: 'setBrowserFingerPrint',
	    value: function setBrowserFingerPrint(browserInfo) {
	
	      var result = browserInfo.fingerprint;
	      this.setState(Object.assign({}, this.state, {
	        browserFingerPrint: result
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          currentType = _state2.currentType,
	          lastType = _state2.lastType,
	          play = _state2.play,
	          loading = _state2.loading,
	          stepError = _state2.stepError;
	
	
	      var startButton = _react2.default.createElement(
	        'div',
	        { style: {
	            textAlign: "center"
	          } },
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Coloc\xE1 tu rostro en el c\xEDrculo y puls\xE1 el bot\xF3n comenzar'
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            onClick: this.handleClick,
	            className: 'btn btn-primary btn-lg action-button' },
	          'Comenzar'
	        )
	      );
	
	      var errorMessage = _react2.default.createElement(_RenaperStepErrorMessage2.default, null);
	
	      return _react2.default.createElement(
	        'div',
	        { style: {
	            position: "fixed",
	            left: 0,
	            top: 0,
	            height: "100%",
	            width: "100%",
	            background: "#000"
	          } },
	        loading && _react2.default.createElement(_CustomSpinner2.default, { message: stepError ? errorMessage : 'Estamos analizando los datos. Por favor espere...' }),
	        _react2.default.createElement(_SelfieWithDocumentSelfieCamera2.default, {
	          play: play,
	          fileType: currentType,
	          lastType: lastType,
	          onChange: this.handleChange,
	          onStart: this.handleClick,
	          interval: 8,
	          shapeStyle: {
	            aspectRatio: 1,
	            defaultFixedSide: 'height',
	            borderRadius: '0%',
	            captureOptions: {
	              audio: false,
	              video: true
	            }
	          } }),
	        !play && startButton
	      );
	    }
	  }]);
	
	  return SelfieWithDocumentRegister;
	}(_react.Component);
	
	module.exports = SelfieWithDocumentRegister;

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMeasure = __webpack_require__(455);
	
	var _reactMeasure2 = _interopRequireDefault(_reactMeasure);
	
	var _reactBootstrap = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(138);
	
	var CAPTURE_OPTIONS = {
	  audio: false,
	  video: {
	    facingMode: 'user'
	  }
	};
	
	var SelfieWithDocument = function (_Component) {
	  _inherits(SelfieWithDocument, _Component);
	
	  function SelfieWithDocument(props) {
	    _classCallCheck(this, SelfieWithDocument);
	
	    var _this = _possibleConstructorReturn(this, (SelfieWithDocument.__proto__ || Object.getPrototypeOf(SelfieWithDocument)).call(this, props));
	
	    _this.state = {
	      stream: null,
	      picture: null,
	      changedType: true,
	      currentSecond: 0,
	      countDown: null,
	      shutted: false,
	      checked: false,
	      pictureUrl: null,
	      saved: false,
	      playing: false,
	      hasCameraPermission: false,
	      mediaSize: {
	        height: 0,
	        width: 0,
	        aspectRatio: 1.586
	      },
	      resizedVideo: {
	        height: null,
	        width: null
	      }
	    };
	    _this.video = null;
	    _this.containerVideo = null;
	    _this.canvas = null;
	    _this.handleOnChange = _this.handleOnChange.bind(_this);
	    _this.handleCanPlay = _this.handleCanPlay.bind(_this);
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.onCapture = _this.onCapture.bind(_this);
	    _this.handleCapture = _this.handleCapture.bind(_this);
	    _this.onClear = _this.onClear.bind(_this);
	    _this.handleClear = _this.handleClear.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.manageTimer = _this.manageTimer.bind(_this);
	    return _this;
	  }
	
	  _createClass(SelfieWithDocument, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
	
	      var captureOptions = this.props.captureOptions || Object.assign({}, CAPTURE_OPTIONS, {
	        video: vw > 992 ? {
	          facingMode: 'user',
	          width: { ideal: 4096 },
	          height: { ideal: 2160 }
	        } : { facingMode: 'user' }
	      });
	      navigator.mediaDevices.getUserMedia(captureOptions).then(function (stream) {
	        _this2.setState(Object.assign({}, _this2.state, {
	          stream: stream,
	          hasCameraPermission: true
	        }));
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.state.stream.getTracks().forEach(function (track) {
	        track.stop();
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var hasCameraPermission = this.state.hasCameraPermission;
	      var _props = this.props,
	          fileType = _props.fileType,
	          play = _props.play,
	          interval = _props.interval;
	
	      var prevFileType = prevProps.fileType;
	      if (hasCameraPermission && play && play !== prevProps.play || play && fileType && prevFileType && fileType.type !== prevFileType.type) {
	
	        clearInterval(this.timer);
	        this.setState(Object.assign({}, this.state, {
	          currentSecond: 0,
	          shutted: false,
	          checked: false
	        }));
	
	        this.timer = setInterval(this.manageTimer, 1000);
	      }
	    }
	  }, {
	    key: 'handleOnChange',
	    value: function handleOnChange(event) {
	      event.preventDefault();
	      if (this.props.onChange) {
	        this.props.onChange(this.state.picture);
	      }
	      this.setState(Object.assign({}, this.state, {
	        saved: true
	      }));
	    }
	  }, {
	    key: 'handleCapture',
	    value: function handleCapture(event) {
	      var _this3 = this;
	
	      var mediaSize = this.state.mediaSize;
	
	      var offset = this.calculateOffset(mediaSize, this.video);
	      if (event) {
	        event.preventDefault();
	      }
	
	      var hiddenCanvas = document.createElement('canvas');
	      this.canvas = hiddenCanvas;
	      hiddenCanvas.height = this.video.videoHeight;
	      hiddenCanvas.width = this.video.videoWidth;
	      var hiddenContext = hiddenCanvas.getContext('2d');
	      hiddenContext.drawImage(this.video, 0, 0, this.video.videoWidth, this.video.videoHeight, 0, 0, this.video.videoWidth, this.video.videoHeight);
	
	      hiddenCanvas.toBlob(function (blob) {
	        return _this3.onCapture(blob);
	      }, "image/jpeg", 1);
	
	      this.setState(Object.assign({}, this.state, {
	        pictureUrl: hiddenCanvas.toDataURL('image/jpeg', 1),
	        shutted: true
	      }));
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(contentRect) {
	      var _state = this.state,
	          mediaSize = _state.mediaSize,
	          stream = _state.stream;
	
	
	      var calculatedSize = {};
	
	      if (contentRect.entry) {
	
	        if (this.video) {
	          var browserVideoSize = stream.getVideoTracks()[0].getSettings();
	          var videoAspectRatio = null;
	          var resizedVideo = {};
	          var originalVideoSize = {
	            width: browserVideoSize.width,
	            height: browserVideoSize.height
	          };
	
	          if (contentRect.entry.height > contentRect.entry.width) {
	            originalVideoSize = {
	              width: browserVideoSize.width > browserVideoSize.height ? browserVideoSize.height : browserVideoSize.width,
	              height: browserVideoSize.width > browserVideoSize.height ? browserVideoSize.width : browserVideoSize.height
	            };
	          }
	
	          videoAspectRatio = originalVideoSize.width / originalVideoSize.height;
	
	          var capturedScreenHeight = originalVideoSize.height * 100 / contentRect.entry.height;
	          var capturdScreenWidth = originalVideoSize.width * 100 / contentRect.entry.width;
	
	          if (capturedScreenHeight > capturdScreenWidth) {
	            resizedVideo = {
	              width: contentRect.entry.width,
	              height: contentRect.entry.width / videoAspectRatio
	            };
	          } else {
	            resizedVideo = {
	              width: contentRect.entry.height * videoAspectRatio,
	              height: contentRect.entry.height
	            };
	          }
	
	          this.setState(Object.assign({}, this.state, {
	            resizedVideo: Object.assign({}, resizedVideo)
	          }));
	        }
	      }
	    }
	  }, {
	    key: 'onCapture',
	    value: function onCapture(blob) {
	      this.setState(Object.assign({}, this.state, {
	        picture: blob
	      }));
	    }
	  }, {
	    key: 'handleClear',
	    value: function handleClear() {
	      var context = this.canvas.getContext("2d");
	      context.clearRect(0, 0, this.canvas.width, this.canvas.height);
	      this.onClear();
	    }
	  }, {
	    key: 'onClear',
	    value: function onClear(blob) {
	      this.setState(Object.assign({}, this.state, { picture: undefined }));
	    }
	  }, {
	    key: 'handleCanPlay',
	    value: function handleCanPlay() {
	      var mediaSize = this.state.mediaSize;
	
	      var newAspectRatio = this.calculateRatio(this.video.videoHeight, this.video.videoWidth);
	
	      this.setState(Object.assign({}, this.state, {
	        playing: true,
	        mediaSize: Object.assign({}, mediaSize, {
	          aspectRatio: newAspectRatio || mediaSize.aspectRatio
	        })
	      }));
	      this.video.play();
	    }
	  }, {
	    key: 'calculateRatio',
	    value: function calculateRatio(height, width) {
	      if (height && width) {
	        var isLandscape = height <= width;
	        var ratio = isLandscape ? width / height : height / width;
	        return ratio;
	      }
	    }
	  }, {
	    key: 'calculateDocumentFrame',
	    value: function calculateDocumentFrame(containerWidth, containerHeight, frameAspectRatio) {
	      var defaultFixedSide = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	      var fixedSide = containerWidth >= containerHeight ? containerWidth : containerHeight;
	      if (defaultFixedSide) {
	        fixedSide = defaultFixedSide === 'width' ? containerWidth : containerHeight;
	      }
	      var variableSide = fixedSide == containerWidth ? containerHeight : containerWidth;
	      var fixedSideFrame = 20;
	      var fixedContentSize = Math.round(fixedSide - fixedSideFrame * 2);
	      var variableContentSize = Math.round(fixedContentSize / frameAspectRatio);
	      var variableSideFrame = (variableSide - variableContentSize) / 2;
	      return {
	        frameWidth: fixedSide === containerWidth ? fixedSideFrame : variableSideFrame,
	        frameHeight: fixedSide === containerHeight ? fixedSideFrame : variableSideFrame
	      };
	    }
	  }, {
	    key: 'calculateOffset',
	    value: function calculateOffset(videoContainer, video) {
	      if (video && videoContainer) {
	        return {
	          x: video.videoWidth > videoContainer.width ? Math.round((video.videoWidth - videoContainer.width) / 2) : 0,
	          y: video.videoHeight > videoContainer.height ? Math.round((video.videoHeight - videoContainer.height) / 2) : 0
	        };
	      }
	    }
	  }, {
	    key: 'manageTimer',
	    value: function manageTimer() {
	      var _state2 = this.state,
	          currentSecond = _state2.currentSecond,
	          changedType = _state2.changedType,
	          countDown = _state2.countDown;
	      var interval = this.props.interval;
	
	      var checked = false;
	
	      currentSecond += 1;
	      countDown = null;
	
	      if (changedType) {
	        currentSecond = 0;
	      }
	
	      if (currentSecond > interval - 6 && currentSecond < interval - 2) {
	        countDown = interval - 2 - currentSecond;
	      }
	
	      if (currentSecond === interval - 2) {
	        this.handleCapture();
	      }
	
	      if (currentSecond === interval - 1) {
	        this.setState(Object.assign({}, this.state, {
	          checked: true
	        }));
	      }
	
	      if (currentSecond === interval + 1) {
	        if (this.props.lastType === false) {
	          currentSecond = 0;
	        }
	        this.handleChange();
	      }
	
	      this.setState(Object.assign({}, this.state, {
	        currentSecond: currentSecond,
	        countDown: countDown,
	        changedType: false
	      }));
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange() {
	      var _props2 = this.props,
	          fileType = _props2.fileType,
	          onChange = _props2.onChange;
	      var picture = this.state.picture;
	
	
	      onChange(picture);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state3 = this.state,
	          mediaSize = _state3.mediaSize,
	          hasCameraPermission = _state3.hasCameraPermission,
	          resizedVideo = _state3.resizedVideo,
	          shutted = _state3.shutted,
	          currentSecond = _state3.currentSecond,
	          checked = _state3.checked,
	          countDown = _state3.countDown;
	      var _props3 = this.props,
	          shapeStyle = _props3.shapeStyle,
	          fileType = _props3.fileType,
	          play = _props3.play,
	          interval = _props3.interval;
	
	      if (this.state.stream && this.video && !this.video.srcObject) {
	        this.video.srcObject = this.state.stream;
	      }
	      var selfieIcon = _react2.default.createElement(
	        'div',
	        {
	          style: {
	            textAlign: "center",
	            padding: '0px'
	          } },
	        _react2.default.createElement('img', {
	          src: hasCameraPermission && play && fileType && (checked && fileType.successIcon || fileType.icon) || '',
	          style: {
	            maxWidth: "48px",
	            width: "100%"
	          } })
	      );
	
	      var selfieTip = _react2.default.createElement(
	        'div',
	        {
	          style: {
	            textAlign: "center"
	          } },
	        _react2.default.createElement(
	          'h3',
	          { style: {
	              margin: "0 auto",
	              color: "#FFF"
	            } },
	          hasCameraPermission && play && fileType && fileType.description || ''
	        )
	      );
	
	      var documentFrames = this.calculateDocumentFrame(mediaSize.width, mediaSize.height, shapeStyle.aspectRatio, shapeStyle.defaultFixedSide);
	      var videoOffset = this.calculateOffset(mediaSize, this.video);
	
	      var ConfirmButtons = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary action-button', onClick: this.handleOnChange },
	          _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok', 'aria-hidden': 'true' })
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary action-button', onClick: this.handleClear },
	          _react2.default.createElement('span', { className: 'glyphicon glyphicon-remove', 'aria-hidden': 'true' })
	        )
	      );
	      var shownButtons = this.state.picture ? ConfirmButtons : _react2.default.createElement(
	        'button',
	        { onClick: this.handleCapture, className: 'btn btn-primary btn-lg action-button' },
	        _react2.default.createElement('span', { className: 'glyphicon glyphicon-camera', 'aria-hidden': 'true' })
	      );
	      var alert = _react2.default.createElement(
	        'div',
	        { className: 'alert alert-warning', role: 'alert' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Debes aceptar el permiso para poder acceder a tu camara.'
	        )
	      );
	
	      var startButton = _react2.default.createElement(
	        'div',
	        { style: {
	            textAlign: "center"
	          } },
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Colocate sosteniendo tu dni en el rect\xE1ngulo y pulsa el boton comenzar'
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            onClick: this.props.onStart,
	            className: 'btn btn-primary btn-lg action-button' },
	          'Comenzar'
	        )
	      );
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: {
	            height: "100%",
	            width: "100%",
	            background: "#000"
	          } },
	        _react2.default.createElement(
	          'div',
	          { style: {
	              height: "100%",
	              width: "100%",
	              margin: "0 auto"
	            } },
	          !hasCameraPermission && alert || _react2.default.createElement(
	            _reactMeasure2.default,
	            { onResize: this.handleResize },
	            function (_ref) {
	              var measureRef = _ref.measureRef;
	              return _react2.default.createElement(
	                'div',
	                {
	                  ref: measureRef,
	                  style: {
	                    position: "relative",
	                    height: "100%",
	                    width: "100%",
	                    overflow: "hidden"
	                  } },
	                _react2.default.createElement('video', {
	                  ref: function ref(component) {
	                    _this4.video = component;
	                  },
	                  onPlay: _this4.handleCanPlay,
	                  style: {
	                    position: 'absolute',
	                    width: resizedVideo && resizedVideo.width || "100%",
	                    height: resizedVideo && resizedVideo.height || "100%",
	                    objectFit: "fill",
	                    top: "50%",
	                    left: "50%",
	                    transform: "translate(-50%,-50%)scaleX(-1)"
	                  },
	                  hidden: false,
	                  autoPlay: true,
	                  playsInline: true,
	                  muted: true
	                }),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: shutted ? 'shutted' : '',
	                    style: {
	                      position: 'absolute',
	                      width: "100%",
	                      height: "100%"
	                    } },
	                  _react2.default.createElement('div', { style: Object.assign({
	                      position: 'absolute',
	                      marginLeft: "50%",
	                      top: "45%",
	                      transform: "translate(-50%, -50%)",
	                      width: resizedVideo.width > resizedVideo.height ? "120vh" : "95vw",
	                      height: resizedVideo.width > resizedVideo.height ? "80vh" : "100vw",
	                      boxShadow: '0px 0px 20px 900px rgba(0, 0, 0, 0.6)',
	                      border: '1px solid #ffffff',
	                      borderRadius: 10
	                    }, shapeStyle) })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: {
	                      position: 'absolute',
	                      marginLeft: "50%",
	                      top: "45%",
	                      transform: "translate(-50%, -50%)",
	                      fontSize: '10vh',
	                      color: '#fff'
	                    } },
	                  countDown || ''
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    style: {
	                      position: "absolute",
	                      marginLeft: "50%",
	                      transform: "translateX(-50%)",
	                      top: "10px",
	                      textAlign: "center"
	                    } },
	                  hasCameraPermission && play && fileType && selfieIcon
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    style: {
	                      position: "absolute",
	                      marginLeft: "50%",
	                      transform: "translateX(-50%)",
	                      bottom: "10px",
	                      textAlign: "center"
	                    } },
	                  hasCameraPermission && play && fileType && selfieTip,
	                  hasCameraPermission && play && fileType && fileType.description && _react2.default.createElement(_reactBootstrap.ProgressBar, {
	                    className: '' + (checked ? 'progress-success' : ''),
	                    style: { width: "60vw" },
	                    now: currentSecond / (interval - 2) * 100
	                  }),
	                  hasCameraPermission && !play && startButton
	                ),
	                _react2.default.createElement('canvas', {
	                  ref: function ref(component) {
	                    _this4.canvas = component;
	                  },
	                  style: {
	                    position: 'absolute',
	                    marginLeft: "50%",
	                    transform: "translateX(-50%)"
	                  },
	                  width: _this4.state.mediaSize.width,
	                  height: _this4.state.mediaSize.height,
	                  hidden: true
	                })
	              );
	            }
	          )
	        )
	      );
	    }
	  }]);
	
	  return SelfieWithDocument;
	}(_react.Component);
	
	module.exports = SelfieWithDocument;

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(16);
	
	var _reactIntl = __webpack_require__(26);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _TopScrolleable = __webpack_require__(53);
	
	var _TopScrolleable2 = _interopRequireDefault(_TopScrolleable);
	
	var _generateValidator = __webpack_require__(130);
	
	var _generateValidator2 = _interopRequireDefault(_generateValidator);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	var _AttributeOptions = __webpack_require__(194);
	
	var _AttributeOptions2 = _interopRequireDefault(_AttributeOptions);
	
	var _CustomAlert = __webpack_require__(77);
	
	var _CustomAlert2 = _interopRequireDefault(_CustomAlert);
	
	var _Button = __webpack_require__(155);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ServiceInfoForm = function (_Component) {
	    _inherits(ServiceInfoForm, _Component);
	
	    function ServiceInfoForm(props) {
	        _classCallCheck(this, ServiceInfoForm);
	
	        var _this = _possibleConstructorReturn(this, (ServiceInfoForm.__proto__ || Object.getPrototypeOf(ServiceInfoForm)).call(this, props));
	
	        _this.state = { cities: null };
	        return _this;
	    }
	
	    _createClass(ServiceInfoForm, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting,
	                error = _props.error;
	
	
	            var vehicle = [{ id: 0, name: 'Auto' }, { id: 1, name: 'Moto' }, { id: 2, name: 'No' }];
	            var car_insurance = [{ id: 0, name: 'Sí' }, { id: 1, name: 'No' }];
	
	            return _react2.default.createElement(
	                _Section2.default,
	                { className: 'intro_form' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-left col-md-5 col-lg-5 text-center' },
	                        _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(119) }),
	                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.step_service_info', description: 'Service info' }),
	                        _react2.default.createElement(_Button.WAButton, { phone: '542612554220', text: 'Tengo+una+consulta', value: '261-2554-220', gaEvent: 'true', gaCategory: 'CallToAction', gaAction: 'WhatsApp Tapping' }),
	                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.whatsapp_timetable', description: 'Wp timetable' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-right col-sm-12 col-md-7 col-lg-7' },
	                        _react2.default.createElement(
	                            'form',
	                            { onSubmit: handleSubmit(this.props.saveServiceInfoForm), className: 'pvc-form' },
	                            this.props.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	                            error && _react2.default.createElement(_CustomAlert2.default, { bsStyle: 'danger', message: error }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-6 col-lg-6' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_AttributeOptions2.default, { name: 'vehicle', defaultValue: 'Veh\xEDculo', label: 'Veh\xEDculo', attributeName: 'vehicle', attributeOptions: vehicle })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-6 col-lg-6' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_AttributeOptions2.default, { name: 'car_insurance', defaultValue: 'Seguro Automotor', label: 'Seguro Automotor', attributeName: 'car_insurance', attributeOptions: car_insurance })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'submit', className: 'btn btn-warning btn-lg pd-button pd-form', disabled: submitting },
	                                        'Seguir'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ServiceInfoForm;
	}(_react.Component);
	
	var validate = (0, _generateValidator2.default)([{ name: 'vehicle', required: true }, { name: 'car_insurance', required: true }]);
	
	ServiceInfoForm = (0, _TopScrolleable2.default)(ServiceInfoForm);
	
	ServiceInfoForm = (0, _reduxForm.reduxForm)({
	    form: 'JobInfoForm', // a unique name for this form
	    validate: validate
	})(ServiceInfoForm);
	
	ServiceInfoForm = (0, _Auth2.default)(ServiceInfoForm);
	
	exports.default = ServiceInfoForm;

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(40);
	
	var _md = __webpack_require__(1659);
	
	var _md2 = _interopRequireDefault(_md);
	
	var _reactSignatureCanvas = __webpack_require__(1955);
	
	var _reactSignatureCanvas2 = _interopRequireDefault(_reactSignatureCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(1419);
	
	var SignatureField = function (_Component) {
	  _inherits(SignatureField, _Component);
	
	  function SignatureField(props) {
	    _classCallCheck(this, SignatureField);
	
	    var _this = _possibleConstructorReturn(this, (SignatureField.__proto__ || Object.getPrototypeOf(SignatureField)).call(this, props));
	
	    _this.state = {
	      signaturePad: false,
	      signature: {
	        blobFile: null,
	        md5Sum: null
	      }
	    };
	
	    _this.signatureCanvasRef = null;
	
	    _this.showSignaturePad = _this.showSignaturePad.bind(_this);
	    _this.hideSignaturePad = _this.hideSignaturePad.bind(_this);
	    _this.handleConfirmation = _this.handleConfirmation.bind(_this);
	    _this.handleClean = _this.handleClean.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(SignatureField, [{
	    key: 'showSignaturePad',
	    value: function showSignaturePad() {
	      this.setState({ signaturePad: true });
	    }
	  }, {
	    key: 'hideSignaturePad',
	    value: function hideSignaturePad() {
	      this.setState({ signaturePad: false });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(fileData) {
	      var onChange = this.props.onChange;
	
	      if (onChange) {
	        onChange(fileData);
	      }
	    }
	  }, {
	    key: 'handleConfirmation',
	    value: function handleConfirmation() {
	      var _this2 = this;
	
	      if (this.signatureCanvasRef) {
	        if (!this.signatureCanvasRef.isEmpty()) {
	          var currentCanvas = this.signatureCanvasRef.getTrimmedCanvas();
	          currentCanvas.toBlob(function (blob) {
	            _this2.handleChange({
	              blobFile: blob,
	              md5Sum: (0, _md2.default)(blob),
	              dataurl: currentCanvas.toDataURL()
	            });
	            _this2.hideSignaturePad();
	          });
	        }
	      }
	    }
	  }, {
	    key: 'handleClean',
	    value: function handleClean() {
	      if (this.signatureCanvasRef) {
	        this.signatureCanvasRef.clear();
	        this.hideSignaturePad();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var signaturePad = this.state.signaturePad;
	      var _props = this.props,
	          className = _props.className,
	          disabled = _props.disabled;
	
	
	      var ConfirmButtons = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary action-button', style: { margin: '10px' }, onClick: this.handleConfirmation },
	          _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok', 'aria-hidden': 'true' })
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary action-button', style: { margin: '10px' }, onClick: this.handleClean },
	          _react2.default.createElement('span', { className: 'glyphicon glyphicon-remove', 'aria-hidden': 'true' })
	        )
	      );
	
	      return !signaturePad ? _react2.default.createElement(
	        _reactBootstrap.Button,
	        { className: 'btn btn-warning btn-sm pd-simple-button ' + className + ' ', onClick: this.showSignaturePad, disabled: disabled },
	        'Firmar'
	      ) : _react2.default.createElement(
	        'div',
	        {
	          style: {
	            position: "fixed",
	            left: 0,
	            top: 0,
	            height: "100vh",
	            width: "100%",
	            background: "#000",
	            zIndex: "1000"
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              position: "relative",
	              height: "100%",
	              width: "100%",
	              overflow: "hidden",
	              textAlign: "center"
	            }
	          },
	          _react2.default.createElement(_reactSignatureCanvas2.default, {
	            backgroundColor: '#ffff',
	            canvasProps: {
	              width: 350,
	              height: 190,
	              style: {
	                position: "absolute",
	                transform: "translateX(-50%)",
	                top: "40%"
	              }
	            },
	            clearOnResize: false,
	            ref: function ref(_ref) {
	              _this3.signatureCanvasRef = _ref;
	            }
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                position: "absolute",
	                marginLeft: "50%",
	                transform: "translateX(-50%)",
	                top: "5%",
	                textAlign: "center"
	              } },
	            _react2.default.createElement('img', {
	              src: __webpack_require__(2056),
	              style: {
	                maxHeight: "48px",
	                maxWidth: "63px"
	              } }),
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'signature-field-text' },
	                  this.props.headerTitle
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                position: "absolute",
	                marginLeft: "50%",
	                transform: "translateX(-50%)",
	                bottom: "4%",
	                textAlign: "center",
	                color: "#FFF"
	              } },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'signature-field-text' },
	                  'Por favor firm\xE1 dentro del recuadro blanco'
	                )
	              )
	            ),
	            ConfirmButtons
	          )
	        )
	      );
	    }
	  }]);
	
	  return SignatureField;
	}(_react.Component);
	
	exports.default = SignatureField;

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactBootstrap = __webpack_require__(40);
	
	var _SignatureField = __webpack_require__(1170);
	
	var _SignatureField2 = _interopRequireDefault(_SignatureField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(1420);
	
	var SignatureForm = function (_Component) {
	    _inherits(SignatureForm, _Component);
	
	    function SignatureForm(props) {
	        _classCallCheck(this, SignatureForm);
	
	        var _this = _possibleConstructorReturn(this, (SignatureForm.__proto__ || Object.getPrototypeOf(SignatureForm)).call(this, props));
	
	        _this.state = {
	            signed: false,
	            loading: false
	        };
	
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        return _this;
	    }
	
	    _createClass(SignatureForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var onChange = this.props.onChange;
	
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            var config = {
	                headers: {
	                    'Content-Type': 'application/json',
	                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                }
	            };
	
	            _axios2.default.get(ROOT_URL + '/leads/signature', config).then(function (response) {
	                _this2.setState({
	                    signed: response.data.signed,
	                    loading: false
	                });
	                onChange(response.data.signed);
	            });
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(signature) {
	            var _this3 = this;
	
	            var onChange = this.props.onChange;
	
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            var config = {
	                headers: {
	                    'Content-Type': 'application/json',
	                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                }
	            };
	
	            this.setState({ loading: true });
	
	            var formData = new FormData();
	            formData.append('file', signature.blobFile);
	            formData.append('md5', signature.md5Sum);
	
	            _axios2.default.post(ROOT_URL + '/leads/signature', formData, config).then(function (response) {
	                _this3.setState({
	                    loading: false,
	                    signed: true
	                });
	                onChange(true);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var disabled = this.props.disabled;
	            var _state = this.state,
	                loading = _state.loading,
	                signed = _state.signed;
	
	
	            var button = _react2.default.createElement(_SignatureField2.default, {
	                onChange: this.handleSubmit,
	                className: 'signature-button',
	                headerTitle: 'Al firmar lo estoy haciendo por todos los documentos mostrados en la pantalla anterior',
	                disabled: disabled
	            });
	
	            if (loading || signed) {
	                button = _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                        className: "btn btn-warning btn-sm pd-simple-button signature-button" + (signed ? ' pd-button-accepted-contract ' : ''),
	                        disabled: true
	                    },
	                    loading ? 'Verificando firma' : 'Firmado'
	                );
	            }
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'terms_row' },
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { className: 'terms_col terms_checkbox text-center', xs: 12, md: 12, lg: 12 },
	                    button
	                )
	            );
	        }
	    }]);
	
	    return SignatureForm;
	}(_react.Component);
	
	exports.default = SignatureForm;

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(16);
	
	var _reactIntl = __webpack_require__(26);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _TopScrolleable = __webpack_require__(53);
	
	var _TopScrolleable2 = _interopRequireDefault(_TopScrolleable);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _RenderField = __webpack_require__(78);
	
	var _RenderField2 = _interopRequireDefault(_RenderField);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	var _CustomAlert = __webpack_require__(77);
	
	var _CustomAlert2 = _interopRequireDefault(_CustomAlert);
	
	var _FlowProgressBar = __webpack_require__(83);
	
	var _FlowProgressBar2 = _interopRequireDefault(_FlowProgressBar);
	
	var _TempLink = __webpack_require__(1176);
	
	var _TempLink2 = _interopRequireDefault(_TempLink);
	
	var _LeadInfo = __webpack_require__(244);
	
	var _LeadInfo2 = _interopRequireDefault(_LeadInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var moment = __webpack_require__(2);
	
	__webpack_require__(1405);
	
	var SmsForm = function (_Component) {
	    _inherits(SmsForm, _Component);
	
	    function SmsForm(props) {
	        _classCallCheck(this, SmsForm);
	
	        var _this = _possibleConstructorReturn(this, (SmsForm.__proto__ || Object.getPrototypeOf(SmsForm)).call(this, props));
	
	        _this.state = {
	            code: '',
	            lastSentDate: null
	        };
	
	        _this.getSmsCode = _this.getSmsCode.bind(_this);
	        return _this;
	    }
	
	    _createClass(SmsForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            var config = {
	                headers: {
	                    'Content-Type': 'application/json',
	                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                }
	            };
	
	            _axios2.default.get(ROOT_URL + '/sms/send_code', config).then(function (res) {
	                var code = res.data.code;
	                _this2.setState({
	                    code: code,
	                    lastSentDate: res.data.sms_code_timestamp
	                });
	            });
	        }
	    }, {
	        key: 'getSmsCode',
	        value: function getSmsCode() {
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            var config = {
	                headers: {
	                    'Content-Type': 'application/json',
	                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                }
	            };
	
	            return _axios2.default.get(ROOT_URL + '/sms/send_code?required=true', config);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting,
	                error = _props.error,
	                clientName = _props.clientName;
	            var lastSentDate = this.state.lastSentDate;
	
	
	            var nextDateToSent = lastSentDate ? moment(lastSentDate).add(120, 'seconds') : null;
	            var remaningSeconds = lastSentDate ? nextDateToSent.diff(moment(), 'seconds') : null;
	            var TempLinkComponent = void 0;
	
	            if (remaningSeconds) {
	                TempLinkComponent = _react2.default.createElement(
	                    _TempLink2.default,
	                    { actionText: 'Reenviar sms', onTime: this.getSmsCode, seconds: remaningSeconds },
	                    '\xBFTodav\xEDa no recibiste tu c\xF3digo? '
	                );
	            }
	
	            return _react2.default.createElement(
	                _Section2.default,
	                { className: 'intro_form' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-left col-md-5 col-lg-5 text-center' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-img' },
	                            _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(61) })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-message' },
	                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.step_sms', description: 'Sms info' }),
	                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.step_sms_info', description: 'Sms info', values: { nameClient: clientName } })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-right short-content col-sm-12 col-md-7 col-lg-7' },
	                        _react2.default.createElement(_FlowProgressBar2.default, null),
	                        _react2.default.createElement(
	                            'form',
	                            { onSubmit: handleSubmit(this.props.sendCode), className: 'pvc-form' },
	                            this.props.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	                            error && _react2.default.createElement(_CustomAlert2.default, { bsStyle: 'danger', message: error }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-group' },
	                                        _react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'sms_code', autoComplete: 'off', component: _RenderField2.default, type: 'number', label: 'Ingres\xE1 el c\xF3digo del SMS' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'submit', className: 'btn btn-warning btn-lg pd-button pd-form', disabled: submitting },
	                                        'Seguir'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'pd-content-left col-md-5 col-lg-5 text-center sms-tempLink' },
	                            TempLinkComponent
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SmsForm;
	}(_react.Component);
	
	SmsForm = (0, _TopScrolleable2.default)(SmsForm);
	
	SmsForm = (0, _reduxForm.reduxForm)({
	    form: 'SmsForm' // a unique name for this form
	})(SmsForm);
	
	SmsForm = (0, _LeadInfo2.default)(SmsForm);
	SmsForm = (0, _Auth2.default)(SmsForm);
	
	exports.default = SmsForm;

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(26);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Start = function (_Component) {
	    _inherits(Start, _Component);
	
	    function Start() {
	        _classCallCheck(this, Start);
	
	        return _possibleConstructorReturn(this, (Start.__proto__ || Object.getPrototypeOf(Start)).apply(this, arguments));
	    }
	
	    _createClass(Start, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Section2.default,
	                { className: 'intro_form' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-left col-md-5 col-lg-5 text-center' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-img' },
	                            _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(61) })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-right col-sm-12 col-md-7 col-lg-7' },
	                        _react2.default.createElement(
	                            'form',
	                            { className: 'pvc-form' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'text-center' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    { style: { color: '#000' } },
	                                    'Est\xE1s a un paso de solicitar la Tarjeta Mastercard'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { style: { margin: '40px 0' } },
	                                    _react2.default.createElement('img', {
	                                        alt: 'Tarjeta Mastercard',
	                                        src: __webpack_require__(2063),
	                                        style: { maxWidth: '300px', width: '100%' }
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'h4',
	                                    { style: { color: '#555', marginBottom: '30px' } },
	                                    'Durante los siguientes pasos te solicitaremos informaci\xF3n y documentaci\xF3n para finalizar el tr\xE1mite'
	                                ),
	                                _react2.default.createElement(
	                                    'button',
	                                    {
	                                        type: 'button',
	                                        className: 'btn btn-warning btn-lg pd-button pd-form',
	                                        onClick: this.props.sentStart
	                                    },
	                                    'Seguir'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Start;
	}(_react.Component);
	
	Start = (0, _Auth2.default)(Start);
	
	exports.default = Start;

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _superagent = __webpack_require__(304);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _reduxForm = __webpack_require__(16);
	
	var _SelectField = __webpack_require__(121);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StatesList = function (_Component) {
	    _inherits(StatesList, _Component);
	
	    function StatesList(props) {
	        _classCallCheck(this, StatesList);
	
	        var _this = _possibleConstructorReturn(this, (StatesList.__proto__ || Object.getPrototypeOf(StatesList)).call(this, props));
	
	        _this.state = { states: [] };
	        return _this;
	    }
	
	    _createClass(StatesList, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            _superagent2.default.get(ROOT_URL + '/states').end(function (error, response) {
	                if (!error && response) {
	                    _this2.setState({ states: response.body.states });
	                } else {
	                    console.log('There was an error fetching from API', error);
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-lg-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    _react2.default.createElement(_reduxForm.Field, {
	                        className: 'form-control',
	                        name: 'state_id',
	                        component: _SelectField2.default,
	                        options: this.state.states,
	                        defaultValue: 'Provincias',
	                        label: 'Provincia',
	                        type: this.props.type
	                    })
	                )
	            );
	        }
	    }]);
	
	    return StatesList;
	}(_react.Component);
	
	exports.default = StatesList;

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(26);
	
	var _reactBootstrap = __webpack_require__(40);
	
	var _LoadField = __webpack_require__(245);
	
	var _LoadField2 = _interopRequireDefault(_LoadField);
	
	var _MoneyField = __webpack_require__(330);
	
	var _MoneyField2 = _interopRequireDefault(_MoneyField);
	
	var _Button = __webpack_require__(155);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(376);
	
	var Summary = function (_Component) {
	    _inherits(Summary, _Component);
	
	    function Summary(props) {
	        _classCallCheck(this, Summary);
	
	        var _this = _possibleConstructorReturn(this, (Summary.__proto__ || Object.getPrototypeOf(Summary)).call(this, props));
	
	        _this.state = {
	
	            requested_amount: null,
	            requested_quotas: null,
	            total_amount: null,
	            quota_amount: null,
	            interest: null,
	            interest_tax: null,
	            first_payment_date: null
	        };
	        return _this;
	    }
	
	    _createClass(Summary, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	            var config = {
	                headers: {
	                    'Content-Type': 'application/json',
	                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                }
	            };
	
	            _axios2.default.get(ROOT_URL + '/leads/details', config).then(function (res) {
	                var data = res.data;
	                var total_amount = data.requested_quotas * data.quota_amount;
	                var interest_tax = (total_amount - data.requested_amount) * 0.21 / 1.21;
	                var interest = total_amount - data.requested_amount - interest_tax;
	                _this2.setState({ 'requested_amount': data.requested_amount });
	                _this2.setState({ 'requested_quotas': data.requested_quotas });
	                _this2.setState({ 'quota_amount': data.quota_amount });
	                _this2.setState({ 'total_amount': total_amount });
	                _this2.setState({ 'interest': interest });
	                _this2.setState({ 'interest_tax': interest_tax });
	                _this2.setState({ 'first_payment_date': data.first_payment_date });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'summary text-center' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'summary_details' },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        ' Resumen de tu solicitud '
	                    ),
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        ' Pr\xE9stamo Personal '
	                    ),
	                    _react2.default.createElement('div', { className: 'summary_line' }),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row summary_row_vertical_align' },
	                        _react2.default.createElement('moneyField', null),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 6, md: 6, lg: 6 },
	                            'Monto del Pr\xE9stamo: '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-right', xs: 6, md: 3, lg: 6 },
	                            _react2.default.createElement(
	                                _LoadField2.default,
	                                null,
	                                this.state.requested_amount && _react2.default.createElement(
	                                    _MoneyField2.default,
	                                    { decimals: 0 },
	                                    this.state.requested_amount
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: 'summary_line' }),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 6, md: 6, lg: 6 },
	                            'Valor de la cuota: '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-right', xs: 6, md: 3, lg: 6 },
	                            _react2.default.createElement(
	                                _LoadField2.default,
	                                null,
	                                this.state.quota_amount && _react2.default.createElement(
	                                    _MoneyField2.default,
	                                    null,
	                                    this.state.quota_amount
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 6, md: 6, lg: 6 },
	                            'Cuotas: '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-right', xs: 6, md: 3, lg: 6 },
	                            _react2.default.createElement(
	                                _LoadField2.default,
	                                null,
	                                this.state.requested_quotas
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: 'summary_line' }),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row summary_row_vertical_align' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 6, md: 6, lg: 6 },
	                            'Costos Administrativos: '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-right', xs: 6, md: 3, lg: 6 },
	                            '$ 0'
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: 'summary_line' }),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row summary_row_vertical_align' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 6, md: 6, lg: 6 },
	                            'Pago de la cuota: '
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-right', xs: 6, md: 3, lg: 6 },
	                            'Del 1 al 10 de cada mes.'
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: 'summary_line' }),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'summary_row' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { className: 'summary_col text-left', xs: 12, md: 12, lg: 12 },
	                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.step_checkout_info', description: 'Checkout advice' })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Summary;
	}(_react.Component);
	
	exports.default = Summary;

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var moment = __webpack_require__(2);
	
	__webpack_require__(1406);
	
	var TempLink = function (_Component) {
	    _inherits(TempLink, _Component);
	
	    function TempLink(props) {
	        _classCallCheck(this, TempLink);
	
	        var _this = _possibleConstructorReturn(this, (TempLink.__proto__ || Object.getPrototypeOf(TempLink)).call(this, props));
	
	        _this.state = {
	            seconds: props.seconds,
	            secondsToWait: 120
	        };
	
	        _this.manageTimer = _this.manageTimer.bind(_this);
	        _this.performAction = _this.performAction.bind(_this);
	        return _this;
	    }
	
	    _createClass(TempLink, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.state.seconds > 0) {
	                this.timer = setInterval(this.manageTimer, 1000);
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (prevState.seconds <= 0 && this.state.seconds > 0) {
	                this.timer = setInterval(this.manageTimer, 1000);
	            }
	        }
	    }, {
	        key: 'manageTimer',
	        value: function manageTimer() {
	            var seconds = this.state.seconds;
	
	
	            this.setState({
	                seconds: seconds - 1
	            });
	
	            if (seconds - 1 <= 0) {
	                clearInterval(this.timer);
	            }
	        }
	    }, {
	        key: 'performAction',
	        value: function performAction(event) {
	            var secondsToWait = this.state.secondsToWait;
	
	            this.props.onTime();
	            this.setState({
	                seconds: secondsToWait
	            });
	        }
	    }, {
	        key: 'castSecondsToMinute',
	        value: function castSecondsToMinute(seconds) {
	            return moment().startOf('day').add(seconds, 'seconds').format('mm:ss');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                url = _props.url,
	                actionText = _props.actionText;
	            var seconds = this.state.seconds;
	
	            var actionLink = seconds > 0 ? _react2.default.createElement(
	                'div',
	                { className: 'wait-msg' },
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'custom-orange-font' },
	                        'Por favor esper\xE1 ' + this.castSecondsToMinute(seconds) + ' minutos'
	                    )
	                )
	            ) : _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'a',
	                    { className: 'btn btn-re-action', onClick: this.performAction },
	                    actionText
	                )
	            );
	            return _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    this.props.children,
	                    actionLink
	                )
	            );
	        }
	    }]);
	
	    return TempLink;
	}(_react.Component);
	
	exports.default = TempLink;

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(16);
	
	var _reactIntl = __webpack_require__(26);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _TopScrolleable = __webpack_require__(53);
	
	var _TopScrolleable2 = _interopRequireDefault(_TopScrolleable);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _RequiredDocForm = __webpack_require__(1161);
	
	var _RequiredDocForm2 = _interopRequireDefault(_RequiredDocForm);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(1422);
	
	var UploadDocuments = function (_Component) {
	    _inherits(UploadDocuments, _Component);
	
	    function UploadDocuments(props) {
	        _classCallCheck(this, UploadDocuments);
	
	        var _this = _possibleConstructorReturn(this, (UploadDocuments.__proto__ || Object.getPrototypeOf(UploadDocuments)).call(this, props));
	
	        _this.state = {
	            requiredDocuments: {
	                payment_invoice: false,
	                bank_transactions_details: false
	            }
	        };
	        _this.updateDocumentStatus = _this.updateDocumentStatus.bind(_this);
	        return _this;
	    }
	
	    _createClass(UploadDocuments, [{
	        key: 'updateDocumentStatus',
	        value: function updateDocumentStatus(documentType) {
	            var newState = Object.assign({}, this.state);
	            newState.requiredDocuments[documentType] = true;
	            this.setState(Object.assign({}, newState));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting,
	                error = _props.error;
	            var _state$requiredDocume = this.state.requiredDocuments,
	                payment_invoice = _state$requiredDocume.payment_invoice,
	                bank_transactions_details = _state$requiredDocume.bank_transactions_details;
	
	            return _react2.default.createElement(
	                _Section2.default,
	                { className: 'intro_form' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-left col-md-5 col-lg-5 text-center' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-img' },
	                            _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(61) })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'header-message' },
	                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.step_upload_documents', description: 'Upload Document Information' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-right short-content col-sm-12 col-md-7 col-lg-7' },
	                        _react2.default.createElement(
	                            'form',
	                            { className: 'pvc-form', onSubmit: handleSubmit(this.props.getStep) },
	                            this.props.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'upload-title' },
	                                        'Adjunt\xE1 los siguiente documentos:'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12' },
	                                    _react2.default.createElement(_RequiredDocForm2.default, {
	                                        label: 'Último Bono de Sueldo',
	                                        documentType: 'payment_invoice',
	                                        maxSize: 10000000,
	                                        fileTypes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'],
	                                        onUpdateStatus: this.updateDocumentStatus }),
	                                    _react2.default.createElement(_RequiredDocForm2.default, {
	                                        label: 'Últimos Movimientos Cuenta Sueldo',
	                                        documentType: 'bank_transactions_details',
	                                        maxSize: 10000000,
	                                        fileTypes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'],
	                                        onUpdateStatus: this.updateDocumentStatus })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'submit', className: 'btn btn-warning btn-lg pd-button pd-form', disabled: !(payment_invoice && bank_transactions_details) },
	                                        'Seguir'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UploadDocuments;
	}(_react.Component);
	
	UploadDocuments.contextTypes = {
	    intl: _react2.default.PropTypes.object.isRequired
	};
	
	UploadDocuments = (0, _TopScrolleable2.default)(UploadDocuments);
	
	UploadDocuments = (0, _reduxForm.reduxForm)({
	    form: 'UploadDocuments' // a unique name for this form
	})(UploadDocuments);
	
	UploadDocuments = (0, _Auth2.default)(UploadDocuments);
	
	exports.default = UploadDocuments;

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(1423);
	
	var UploadFileButton = function (_Component) {
	  _inherits(UploadFileButton, _Component);
	
	  function UploadFileButton(props) {
	    _classCallCheck(this, UploadFileButton);
	
	    var _this = _possibleConstructorReturn(this, (UploadFileButton.__proto__ || Object.getPrototypeOf(UploadFileButton)).call(this, props));
	
	    _this.state = { file_name: null,
	      has_file: false };
	    _this.onUploadHandler = _this.onUploadHandler.bind(_this);
	    return _this;
	  }
	
	  _createClass(UploadFileButton, [{
	    key: 'onUploadHandler',
	    value: function onUploadHandler(event) {
	      if (event.target.files && event.target.files.length > 0) {
	        this.setState({ file_name: event.target.files[0].name,
	          has_file: true });
	      }
	      this.props.onChange(event);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: "upload-wrapper" },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { className: "btn btn-warning btn-sm pd-simple-button " + (this.state.has_file ? 'pd-button-accepted-contract' : '') },
	            this.state.has_file ? 'Listo!' : 'Subir'
	          ),
	          _react2.default.createElement('input', { type: 'file', name: this.props.name, onChange: this.onUploadHandler })
	        )
	      );
	    }
	  }]);
	
	  return UploadFileButton;
	}(_react.Component);
	
	exports.default = UploadFileButton;

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(19);
	
	var _reduxForm = __webpack_require__(16);
	
	var _reactIntl = __webpack_require__(26);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Auth = __webpack_require__(42);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _TopScrolleable = __webpack_require__(53);
	
	var _TopScrolleable2 = _interopRequireDefault(_TopScrolleable);
	
	var _generateValidator = __webpack_require__(130);
	
	var _generateValidator2 = _interopRequireDefault(_generateValidator);
	
	var _CustomSpinner = __webpack_require__(29);
	
	var _CustomSpinner2 = _interopRequireDefault(_CustomSpinner);
	
	var _CustomAlert = __webpack_require__(77);
	
	var _CustomAlert2 = _interopRequireDefault(_CustomAlert);
	
	var _CustomProgressBar = __webpack_require__(1124);
	
	var _CustomProgressBar2 = _interopRequireDefault(_CustomProgressBar);
	
	var _Section = __webpack_require__(30);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Button = __webpack_require__(155);
	
	var _UploaderField = __webpack_require__(1180);
	
	var _UploaderField2 = _interopRequireDefault(_UploaderField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UploadForm = function (_Component) {
	    _inherits(UploadForm, _Component);
	
	    function UploadForm(props) {
	        _classCallCheck(this, UploadForm);
	
	        var _this = _possibleConstructorReturn(this, (UploadForm.__proto__ || Object.getPrototypeOf(UploadForm)).call(this, props));
	
	        _this.state = {
	            type: false,
	            salary_type: false
	        };
	        _this.getFilesPercentage = _this.getFilesPercentage.bind(_this);
	        _this.checkEmploymentType = _this.checkEmploymentType.bind(_this);
	        return _this;
	    }
	
	    _createClass(UploadForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.checkEmploymentType();
	        }
	    }, {
	        key: 'getFilesPercentage',
	        value: function getFilesPercentage() {
	            var files = this.props.files;
	
	            var common_files = ['document_number_front', 'document_number_back', 'tax'];
	            if (this.state.type === 'work_dependence') {
	                switch (this.state.salary_type) {
	                    case 1:
	                        common_files = common_files.concat(['cbu_document', 'last_pay_check']);
	                        break;
	                    case 2:
	                        common_files = common_files.concat(['cbu_document', 'first_half_month_paycheck_field', 'second_half_month_paycheck_field']);
	                        break;
	                    default:
	                        common_files = common_files.concat(['cbu_document', 'last_pay_check']);
	                        break;
	                }
	            } else {
	                common_files = common_files.concat(['net_incomes_paycheck']);
	            }
	
	            var currentFiles = files.filter(function (file) {
	                return file;
	            });
	            return currentFiles.length / common_files.length * 100;
	        }
	    }, {
	        key: 'checkEmploymentType',
	        value: function checkEmploymentType() {
	            var _this2 = this;
	
	            var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	
	            var config = {
	                headers: {
	                    'Content-Type': 'application/json',
	                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
	                }
	            };
	            /*TODO: REFACTOR this */
	            _axios2.default.get(ROOT_URL + '/subscribers/employment_type', config).then(function (res) {
	                var data = res.data;
	                _this2.setState({ type: data.type,
	                    salary_type: data.salary_type });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting,
	                error = _props.error;
	
	            var cbu_document_field = _react2.default.createElement(_reduxForm.Field, { name: 'cbu_document', label: 'Comprobante de CBU Home Banking', component: _UploaderField2.default });
	            var last_pay_check_field = _react2.default.createElement(_reduxForm.Field, { name: 'last_pay_check', label: 'Ultimo bono de sueldo', component: _UploaderField2.default });
	            var first_half_month_paycheck_field = _react2.default.createElement(_reduxForm.Field, { name: 'first_half_month_paycheck_field', label: '1º Quincena', component: _UploaderField2.default });
	            var second_half_month_paycheck_field = _react2.default.createElement(_reduxForm.Field, { name: 'second_half_month_paycheck_field', label: '2º Quincena', component: _UploaderField2.default });
	            var net_incomes_paycheck = _react2.default.createElement(_reduxForm.Field, { name: 'net_incomes_paycheck', label: 'IBB/IVA/Monotrib', component: _UploaderField2.default });
	            var workDependenceDocumentsbyMonth = _react2.default.createElement(
	                'div',
	                null,
	                cbu_document_field,
	                last_pay_check_field
	            );
	            var workDependenceDocumentsbyHalfMonth = _react2.default.createElement(
	                'div',
	                null,
	                cbu_document_field,
	                first_half_month_paycheck_field,
	                second_half_month_paycheck_field
	            );
	            var selfEmploymentDocuments = _react2.default.createElement(
	                'div',
	                null,
	                net_incomes_paycheck
	            );
	            return _react2.default.createElement(
	                _Section2.default,
	                { className: 'intro_form' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-left col-md-5 col-lg-5 text-center' },
	                        _react2.default.createElement('img', { alt: 'Logo', className: 'center-block intro_logo', src: __webpack_require__(119) }),
	                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'app.step_upload_info', description: 'Job info' }),
	                        _react2.default.createElement(_Button.WAButton, { phone: '542612554220', text: 'Tengo+una+consulta', value: '261-2554-220', gaEvent: 'true', gaCategory: 'CallToAction', gaAction: 'WhatsApp Tapping' }),
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'pd-opening-hours' },
	                            'Lunes a Viernes 09 - 17hs '
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'pd-content-right col-sm-12 col-md-7 col-lg-7' },
	                        _react2.default.createElement(
	                            'form',
	                            { onSubmit: handleSubmit(this.props.saveFiles), className: 'pvc-form form-horizontal' },
	                            this.props.isLoading && _react2.default.createElement(_CustomSpinner2.default, { message: 'Estamos analizando su solicitud. Por favor espere...' }),
	                            error && _react2.default.createElement(_CustomAlert2.default, { bsStyle: 'danger', message: error }),
	                            _react2.default.createElement(_CustomProgressBar2.default, { label: 'Subí todos los archivos para completar el 100%!', percentage: Math.round(this.getFilesPercentage()) }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(_reduxForm.Field, { name: 'document_number_front', label: 'DNI Frente', component: _UploaderField2.default }),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'document_number_back', label: 'DNI Dorso', component: _UploaderField2.default }),
	                                _react2.default.createElement(_reduxForm.Field, { name: 'tax', label: 'Impuesto o Servicio Actual', component: _UploaderField2.default }),
	                                this.state.type === 'self_employment' && selfEmploymentDocuments || this.state.type === 'work_dependence' && (this.state.salary_type === '1' && workDependenceDocumentsbyMonth || this.state.salary_type === '2' && workDependenceDocumentsbyHalfMonth),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-md-12 col-lg-12 text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { type: 'submit', className: 'btn btn-warning btn-lg pd-button pd-form', disabled: this.getFilesPercentage() < 100 || submitting },
	                                        'Seguir'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UploadForm;
	}(_react.Component);
	
	var validate = (0, _generateValidator2.default)([{ name: 'document_number_front', required: true, accepted_types: ['jpg', 'pdf', 'png'] }, { name: 'document_number_back', required: true, accepted_types: ['jpg', 'pdf', 'png'] }, { name: 'tax', required: true, accepted_types: ['jpg', 'pdf', 'png'] }, { name: 'cbu_document', required: true, accepted_types: ['jpg', 'pdf', 'png'] }, { name: 'last_pay_check', required: true, accepted_types: ['jpg', 'pdf', 'png'] }, { name: 'first_half_month_paycheck_field', required: true, accepted_types: ['jpg', 'pdf', 'png'] }, { name: 'second_half_month_paycheck_field', required: true, accepted_types: ['jpg', 'pdf', 'png'] }, { name: 'net_incomes_paycheck', required: true, accepted_types: ['jpg', 'pdf', 'png'] }]);
	
	var selector = (0, _reduxForm.formValueSelector)('UploadForm');
	
	UploadForm = (0, _reactRedux.connect)(function (state) {
	    var document_number_front = selector(state, 'document_number_front');
	    var document_number_back = selector(state, 'document_number_back');
	    var tax = selector(state, 'tax');
	    var cbu_document = selector(state, 'cbu_document');
	    var last_pay_check = selector(state, 'last_pay_check');
	    var first_half_month_paycheck_field = selector(state, 'first_half_month_paycheck_field');
	    var second_half_month_paycheck_field = selector(state, 'second_half_month_paycheck_field');
	    var net_incomes_paycheck = selector(state, 'net_incomes_paycheck');
	
	    return {
	        files: [document_number_front, document_number_back, tax, cbu_document, last_pay_check, first_half_month_paycheck_field, second_half_month_paycheck_field, net_incomes_paycheck]
	    };
	})(UploadForm);
	
	UploadForm = (0, _TopScrolleable2.default)(UploadForm);
	
	UploadForm = (0, _reduxForm.reduxForm)({
	    form: 'UploadForm', // a unique name for this form
	    validate: validate
	})(UploadForm);
	
	UploadForm = (0, _Auth2.default)(UploadForm);
	
	exports.default = UploadForm;

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UploadFileButton = __webpack_require__(1178);
	
	var _UploadFileButton2 = _interopRequireDefault(_UploadFileButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UploaderField = function UploaderField(_ref) {
	    var input = _ref.input,
	        label = _ref.label,
	        showSuccess = _ref.showSuccess,
	        type = _ref.type,
	        autoComplete = _ref.autoComplete,
	        _ref$meta = _ref.meta,
	        asyncValidating = _ref$meta.asyncValidating,
	        touched = _ref$meta.touched,
	        error = _ref$meta.error,
	        valid = _ref$meta.valid,
	        invalid = _ref$meta.invalid,
	        warning = _ref$meta.warning;
	    return _react2.default.createElement(
	        'div',
	        { className: 'form-group ' + (touched && invalid ? 'has-error' : '') + ' ' + (touched && valid && showSuccess ? 'has-success' : '') },
	        _react2.default.createElement(
	            'div',
	            { className: asyncValidating ? 'async-validating' : '' },
	            _react2.default.createElement(
	                'label',
	                { className: 'col-sm-8 col-md-8 col-lg-8 control-label' },
	                label
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-sm-4 col-md-4 col-lg-4' },
	                _react2.default.createElement(_UploadFileButton2.default, { labe: label, name: input.name, onChange: input.onChange })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-sm-8 col-md-8 col-lg-8' },
	                touched && (error && _react2.default.createElement(
	                    'span',
	                    { className: 'help-block' },
	                    error
	                ) || warning && _react2.default.createElement(
	                    'span',
	                    { className: 'help-block' },
	                    warning
	                ))
	            )
	        )
	    );
	};
	
	exports.default = UploaderField;

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _superagent = __webpack_require__(304);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	var sleep = function sleep(ms) {
	    return new Promise(function (resolve) {
	        return setTimeout(resolve, ms);
	    });
	};
	
	var asyncValidate = function asyncValidate(values, dispatch, props, field) {
	
	    if (field === 'email') {
	        return (0, _superagent2.default)('GET', ROOT_URL + '/emails/verification/' + values.email).then(function (result) {}, function (err) {
	            throw { email: 'El email no es válido.', _error: 'Revisá los campos indicados.' };
	        });
	    }
	
	    if (field === 'area_code') {
	        return (0, _superagent2.default)('GET', ROOT_URL + '/area_codes/_code/' + values.area_code).then(function (result) {}, function (err) {
	            throw { area_code: 'El código de area no es válido.', _error: 'Revisá los campos indicados.' };
	        });
	    }
	
	    if (field === 'number') {
	        if (values.area_code && values.number) {
	            return (0, _superagent2.default)('GET', ROOT_URL + '/subscribers/_check/' + values.area_code + values.number).then(function (result) {}, function (err) {
	                throw { number: 'El número no es válido.', _error: 'Revisá los campos indicados.' };
	            });
	        }
	    }
	    return sleep(1);
	};
	
	exports.default = asyncValidate;

/***/ },
/* 1182 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var validate = function validate(values) {
		var errors = {};
		if (!values.email) {
			errors.email = 'Este Campo es Obligatorio';
		}
		return errors;
	};
	
	exports.default = validate;

/***/ },
/* 1183 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var validate = function validate(values) {
		var errors = {};
		if (!values.email) {
			errors.email = 'Este Campo es Obligatorio';
		}
		if (!values.name) {
			errors.name = 'Este Campo es Obligatorio';
		}
		if (!values.document_number) {
			errors.document_number = 'Este Campo es Obligatorio';
		}
		if (!/(\d{7}|\d{8})$/.test(values.document_number)) {
			errors.document_number = 'El documento no es válido';
		}
		if (!values.area_code) {
			errors.area_code = 'Este Campo es Obligatorio';
		}
		if (!values.number) {
			errors.number = 'Este Campo es Obligatorio';
		}
		if (!values.gender || values.gender === 'false') {
			errors.gender = 'Este Campo es Obligatorio';
		}
		if (!values.state_id || values.state_id === 'false') {
			errors.state_id = 'Este Campo es Obligatorio';
		}
		if (!values.employment_id || values.employment_id === 'false') {
			errors.employment_id = 'Este Campo es Obligatorio';
		}
		return errors;
	};
	
	exports.default = validate;

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(40);
	
	var _App = __webpack_require__(241);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(1407);
	
	var Whatsapp = function (_Component) {
	  _inherits(Whatsapp, _Component);
	
	  function Whatsapp(props) {
	    _classCallCheck(this, Whatsapp);
	
	    var _this = _possibleConstructorReturn(this, (Whatsapp.__proto__ || Object.getPrototypeOf(Whatsapp)).call(this, props));
	
	    _this.state = {
	      number: "",
	      message: ""
	    };
	    _this.replaceSpaces = _this.replaceSpaces.bind(_this);
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Whatsapp, [{
	    key: 'trackGAEvent',
	    value: function trackGAEvent() {
	      var gaEvent = {};
	      if (this.props.gaCategory) gaEvent.category = this.props.gaCategory;
	      if (this.props.gaAction) gaEvent.action = this.props.gaAction;
	      if (this.props.gaValue) gaEvent.value = parseInt(this.props.gaValue, 10);
	      if (this.props.gaLabel) gaEvent.label = this.props.gaLabel;
	      _App.ReactGA.event(gaEvent);
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick() {
	      if (this.props.gaEvent) this.trackGAEvent();
	    }
	  }, {
	    key: 'replaceSpaces',
	    value: function replaceSpaces(text) {
	      this.setState({ message: text.replace(/\s/g, "%20") });
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          number = _props.number,
	          text = _props.text;
	
	
	      number && this.setState({ number: number });
	      text && this.replaceSpaces(text);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'fixed-wp-div' },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { className: 'nextButton d-flex justify-content-center border-0 bg-transparent btn-primary', onClick: function onClick() {
	              return _this2.onClick();
	            } },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://wa.me/549' + this.state.number + '?text=' + this.state.message, className: 'whatsapp', target: '_blank', rel: 'noreferrer' },
	            _react2.default.createElement('i', { className: 'fa fa-whatsapp whatsapp-icon' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Whatsapp;
	}(_react.Component);
	
	exports.default = Whatsapp;

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(16);
	
	var _SalaryTypeSelect = __webpack_require__(1162);
	
	var _SalaryTypeSelect2 = _interopRequireDefault(_SalaryTypeSelect);
	
	var _CheckStubArrayForm = __webpack_require__(1114);
	
	var _CheckStubArrayForm2 = _interopRequireDefault(_CheckStubArrayForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WorkDependenceForm = function WorkDependenceForm(props) {
		var salary_types = [{ id: 0, name: 'Mensual' }, { id: 1, name: 'Quincenal' }];
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'div',
				{ className: 'row' },
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-12 col-md-4 col-lg-4' },
					_react2.default.createElement(
						'div',
						{ className: 'form-group' },
						_react2.default.createElement(_reduxForm.Field, { className: 'form-control', name: 'salary_type', component: _SalaryTypeSelect2.default, options: salary_types, type: 'select' })
					)
				)
			),
			_react2.default.createElement(_reduxForm.FieldArray, { name: 'check_stubs', component: _CheckStubArrayForm2.default, props: { deleteReduxFormField: props.deleteReduxFormField } })
		);
	};
	
	exports.default = WorkDependenceForm;

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reactRouter = __webpack_require__(32);
	
	var _reduxForm = __webpack_require__(16);
	
	var _users = __webpack_require__(35);
	
	var _utils = __webpack_require__(38);
	
	var _AddressForm = __webpack_require__(1109);
	
	var _AddressForm2 = _interopRequireDefault(_AddressForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	
	    return {
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        saveAddress: function saveAddress(values, dispatch) {
	            dispatch((0, _users.submitForm)());
	            return dispatch((0, _users.saveAddress)(values)).then(function (result) {
	                if (result.payload.status !== 200) {
	                    dispatch((0, _users.stopSubmitForm)());
	                    throw new _reduxForm.SubmissionError(Object.assign({}, (0, _utils.getErrorsApiToReduxForm)(result.payload.response.data), { _error: 'Revisá los campos indicados.' }));
	                } else {
	                    dispatch((0, _users.getNextStep)()).then(function (result) {
	                        if (typeof result.payload.data.endpoint !== 'undefined') {
	                            sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                            dispatch((0, _users.stopSubmitForm)());
	                            _reactRouter.browserHistory.push(result.payload.data.endpoint);
	                        }
	                    });
	                }
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_AddressForm2.default);

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reactRouter = __webpack_require__(32);
	
	var _reduxForm = __webpack_require__(16);
	
	var _users = __webpack_require__(35);
	
	var _utils = __webpack_require__(38);
	
	var _Affidavit = __webpack_require__(1110);
	
	var _Affidavit2 = _interopRequireDefault(_Affidavit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	
	    return {
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        deleteReduxFormField: function deleteReduxFormField(fieldName) {
	            dispatch((0, _reduxForm.change)('Affidavit', fieldName, null));
	            dispatch((0, _reduxForm.untouch)('Affidavit', fieldName));
	        },
	        sentAffidavit: function sentAffidavit(values) {
	            dispatch((0, _users.submitForm)());
	            return dispatch((0, _users.saveAffidavit)(values)).then(function (result) {
	
	                if (typeof result.payload.response !== 'undefined') {
	                    if (result.payload.response.status === 400) {
	                        dispatch((0, _users.stopSubmitForm)());
	                        throw new _reduxForm.SubmissionError(Object.assign({}, (0, _utils.getErrorsApiToReduxForm)(result.payload.response.data), { _error: 'Revisá los campos indicados.' }));
	                    }
	                } else {
	                    dispatch((0, _users.getNextStep)()).then(function (result) {
	                        if (typeof result.payload.data.endpoint !== "undefined") {
	                            sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                            dispatch((0, _users.stopSubmitForm)());
	                            _reactRouter.browserHistory.push(result.payload.data.endpoint);
	                        }
	                    });
	                }
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Affidavit2.default);

/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _App = __webpack_require__(241);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {};
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_App2.default);

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reduxForm = __webpack_require__(16);
	
	var _reactRouter = __webpack_require__(32);
	
	var _axios = __webpack_require__(24);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _users = __webpack_require__(35);
	
	var _submitValidationsAuthForm = __webpack_require__(1182);
	
	var _submitValidationsAuthForm2 = _interopRequireDefault(_submitValidationsAuthForm);
	
	var _utils = __webpack_require__(38);
	
	var _AuthForm = __webpack_require__(1111);
	
	var _AuthForm2 = _interopRequireDefault(_AuthForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	
	    return {
	        isValidating: false,
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        //For any field errors upon submission (i.e. not instant check)
	        changeSubscriptionEmail: function changeSubscriptionEmail(values, dispatch, ownProps) {
	            dispatch((0, _users.submitForm)());
	
	            var errors = (0, _submitValidationsAuthForm2.default)(values);
	
	            if (Object.keys(errors).length !== 0) {
	                var sleep = function sleep(ms) {
	                    return new Promise(function (resolve) {
	                        return setTimeout(resolve, ms);
	                    });
	                };
	                return sleep(10).then(function () {
	                    dispatch((0, _users.stopSubmitForm)());
	                    throw new _reduxForm.SubmissionError(Object.assign({}, errors, { _error: 'Revisá los campos indicados.' }));
	                });
	            }
	            return dispatch((0, _users.setSubscriptionEmail)(Object.assign({}, values))).then(function (result) {
	                var jwt = sessionStorage.getItem('jwtAuthToken');
	                var ROOT_URL = ("https://api-dev.montemar.com.ar/0.3");
	                var config = {
	                    headers: {
	                        'Content-Type': 'application/json'
	                    }
	                };
	
	                return _axios2.default.get(ROOT_URL + '/leads/jwt/' + jwt, config).then(function (res) {
	                    sessionStorage.setItem('jwtToken', res.data['access_token']);
	                    dispatch((0, _users.getNextStep)()).then(function (result) {
	                        if (typeof result.payload.data.endpoint !== 'undefined') {
	                            sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                            dispatch((0, _users.stopSubmitForm)());
	                            _reactRouter.browserHistory.push({
	                                pathname: result.payload.data.endpoint
	                            });
	                        }
	                    });
	                });
	            }).catch(function (result) {
	                if (result.response && result.response.status !== 200) {
	                    dispatch((0, _users.stopSubmitForm)());
	                    throw new _reduxForm.SubmissionError(Object.assign({}, (0, _utils.getErrorsApiToReduxForm)(result.response.data), { _error: 'Revisá los campos indicados.' }));
	                }
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_AuthForm2.default);

/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reactRouter = __webpack_require__(32);
	
	var _reduxForm = __webpack_require__(16);
	
	var _users = __webpack_require__(35);
	
	var _utils = __webpack_require__(38);
	
	var _Cbu = __webpack_require__(1112);
	
	var _Cbu2 = _interopRequireDefault(_Cbu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	
	    return {
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        verifyCbu: function verifyCbu(values) {
	            dispatch((0, _users.submitForm)());
	            return dispatch((0, _users.loadCbu)(values)).then(function (result) {
	
	                if (typeof result.payload.response !== 'undefined') {
	                    if (result.payload.response.status === 400) {
	                        dispatch((0, _users.stopSubmitForm)());
	                        throw new _reduxForm.SubmissionError(Object.assign({}, (0, _utils.getErrorsApiToReduxForm)(result.payload.response.data), { _error: 'Revisá los campos indicados.' }));
	                    }
	                } else {
	                    dispatch((0, _users.getNextStep)()).then(function (result) {
	                        if (typeof result.payload.data.endpoint !== "undefined") {
	                            sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                            dispatch((0, _users.stopSubmitForm)());
	                            _reactRouter.browserHistory.push(result.payload.data.endpoint);
	                        }
	                    });
	                }
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Cbu2.default);

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reduxForm = __webpack_require__(16);
	
	var _Contract = __webpack_require__(1117);
	
	var _Contract2 = _interopRequireDefault(_Contract);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, initialProps) {
	    var contract_accepted = (0, _reduxForm.formValueSelector)(initialProps.form)(state, 'contract_accepted');
	    return {
	        contractValue: typeof contract_accepted !== 'undefined' && true
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(_Contract2.default);

/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reactRouter = __webpack_require__(32);
	
	var _reduxForm = __webpack_require__(16);
	
	var _users = __webpack_require__(35);
	
	var _Contracts = __webpack_require__(1118);
	
	var _Contracts2 = _interopRequireDefault(_Contracts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        submitContract: function submitContract(values, dispatch, ownProps) {
	            return dispatch((0, _users.acceptContract)(Object.assign({}, values, { endpoint: ownProps.form }))).then(function (result) {
	                if (result.error && result.payload.response.status !== 409) {
	                    dispatch((0, _reduxForm.change)(ownProps.form, 'contract_accepted', false));
	                }
	            });
	        },
	        getStep: function getStep(values, dispatch) {
	            dispatch((0, _users.submitForm)());
	            return dispatch((0, _users.getNextStep)()).then(function (result) {
	                if (typeof result.payload.data.endpoint !== "undefined") {
	                    sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                    dispatch((0, _users.stopSubmitForm)());
	                    _reactRouter.browserHistory.push(result.payload.data.endpoint);
	                }
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Contracts2.default);

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reactRouter = __webpack_require__(32);
	
	var _reduxForm = __webpack_require__(16);
	
	var _users = __webpack_require__(35);
	
	var _utils = __webpack_require__(38);
	
	var _EmailForm = __webpack_require__(1129);
	
	var _EmailForm2 = _interopRequireDefault(_EmailForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	
	    return {
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        saveEmail: function saveEmail(values, dispatch) {
	            dispatch((0, _users.submitForm)());
	            return dispatch((0, _users.saveEmail)(values)).then(function (result) {
	                if (result.payload.status !== 200) {
	                    dispatch((0, _users.stopSubmitForm)());
	                    throw new _reduxForm.SubmissionError(Object.assign({}, (0, _utils.getErrorsApiToReduxForm)(result.payload.response.data), { _error: 'Revisá los campos indicados.' }));
	                } else {
	                    dispatch((0, _users.getNextStep)()).then(function (result) {
	                        if (typeof result.payload.data.endpoint !== 'undefined') {
	                            sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                            dispatch((0, _users.stopSubmitForm)());
	                            _reactRouter.browserHistory.push(result.payload.data.endpoint);
	                        }
	                    });
	                }
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_EmailForm2.default);

/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reactRouter = __webpack_require__(32);
	
	var _users = __webpack_require__(35);
	
	var _EmailPending = __webpack_require__(1130);
	
	var _EmailPending2 = _interopRequireDefault(_EmailPending);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	
	    return {
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setIsLoading: function setIsLoading(loading) {
	            if (loading) {
	                dispatch((0, _users.submitForm)());
	            } else {
	                dispatch((0, _users.stopSubmitForm)());
	            }
	        },
	        throwNextStep: function throwNextStep() {
	            dispatch((0, _users.submitForm)());
	            dispatch((0, _users.getNextStep)()).then(function (result) {
	                sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                dispatch((0, _users.stopSubmitForm)());
	                _reactRouter.browserHistory.push(result.payload.data.endpoint);
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_EmailPending2.default);

/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reactRouter = __webpack_require__(32);
	
	var _users = __webpack_require__(35);
	
	var _EmailVerification = __webpack_require__(1131);
	
	var _EmailVerification2 = _interopRequireDefault(_EmailVerification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	
	    return {
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setIsLoading: function setIsLoading(loading) {
	            if (loading) {
	                dispatch((0, _users.submitForm)());
	            } else {
	                dispatch((0, _users.stopSubmitForm)());
	            }
	        },
	        throwNextStep: function throwNextStep() {
	            dispatch((0, _users.submitForm)());
	            dispatch((0, _users.getNextStep)()).then(function (result) {
	                sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                dispatch((0, _users.stopSubmitForm)());
	                _reactRouter.browserHistory.push(result.payload.data.endpoint);
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_EmailVerification2.default);

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _employments = __webpack_require__(506);
	
	var _Employments = __webpack_require__(1132);
	
	var _Employments2 = _interopRequireDefault(_Employments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        employmentsList: state.employments.employmentsList
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        fetchEmployments: function fetchEmployments() {
	            dispatch((0, _employments.fetchEmployments)()).then(function (response) {
	                !response.error ? dispatch((0, _employments.fetchEmploymentsSuccess)(response.payload.data)) : dispatch((0, _employments.fetchEmploymentsFailure)(response.payload.data));
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Employments2.default);

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reactRouter = __webpack_require__(32);
	
	var _reduxForm = __webpack_require__(16);
	
	var _users = __webpack_require__(35);
	
	var _utils = __webpack_require__(38);
	
	var _IncomesForm = __webpack_require__(1137);
	
	var _IncomesForm2 = _interopRequireDefault(_IncomesForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	
	    return {
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setDefaultValue: function setDefaultValue(values) {
	            dispatch((0, _reduxForm.initialize)('IncomesForm', values, null));
	        },
	        deleteReduxFormField: function deleteReduxFormField(fieldName) {
	            dispatch((0, _reduxForm.change)('IncomesForm', fieldName, null));
	            dispatch((0, _reduxForm.untouch)('IncomesForm', fieldName));
	        },
	        saveIncomes: function saveIncomes(values, dispatch) {
	            dispatch((0, _users.submitForm)());
	            return dispatch((0, _users.saveIncomes)(values)).then(function (result) {
	                if (result.payload.status !== 200) {
	                    dispatch((0, _users.stopSubmitForm)());
	                    throw new _reduxForm.SubmissionError(Object.assign({}, (0, _utils.getErrorsApiToReduxForm)(result.payload.response.data), { _error: 'Revisá los campos indicados.' }));
	                } else {
	                    dispatch((0, _users.getNextStep)()).then(function (result) {
	                        if (typeof result.payload.data.endpoint !== 'undefined') {
	                            sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                            dispatch((0, _users.stopSubmitForm)());
	                            _reactRouter.browserHistory.push(result.payload.data.endpoint);
	                        }
	                    });
	                }
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_IncomesForm2.default);

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reactRouter = __webpack_require__(32);
	
	var _reduxForm = __webpack_require__(16);
	
	var _users = __webpack_require__(35);
	
	var _utils = __webpack_require__(38);
	
	var _JobInfoForm = __webpack_require__(1139);
	
	var _JobInfoForm2 = _interopRequireDefault(_JobInfoForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	
	    return {
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        saveJobInfo: function saveJobInfo(values, dispatch) {
	            dispatch((0, _users.submitForm)());
	            return dispatch((0, _users.saveJobInfo)(values)).then(function (result) {
	                if (result.payload.status !== 200) {
	                    dispatch((0, _users.stopSubmitForm)());
	                    throw new _reduxForm.SubmissionError(Object.assign({}, (0, _utils.getErrorsApiToReduxForm)(result.payload.response.data), { _error: 'Revisá los campos indicados.' }));
	                } else {
	                    dispatch((0, _users.getNextStep)()).then(function (result) {
	                        if (typeof result.payload.data.endpoint !== 'undefined') {
	                            sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                            dispatch((0, _users.stopSubmitForm)());
	                            _reactRouter.browserHistory.push(result.payload.data.endpoint);
	                        }
	                    });
	                }
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_JobInfoForm2.default);

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reactRouter = __webpack_require__(32);
	
	var _users = __webpack_require__(35);
	
	var _Main = __webpack_require__(1140);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        requestNextStep: function requestNextStep() {
	            dispatch((0, _users.getNextStep)()).then(function (result) {
	                if (typeof result.payload.data.endpoint !== 'undefined') {
	                    sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                    _reactRouter.browserHistory.push({
	                        pathname: result.payload.data.endpoint
	                    });
	                }
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_Main2.default);

/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reduxForm = __webpack_require__(16);
	
	var _reactRouter = __webpack_require__(32);
	
	var _users = __webpack_require__(35);
	
	var _submitValidationsMainForm = __webpack_require__(1183);
	
	var _submitValidationsMainForm2 = _interopRequireDefault(_submitValidationsMainForm);
	
	var _utils = __webpack_require__(38);
	
	var _MainForm = __webpack_require__(1141);
	
	var _MainForm2 = _interopRequireDefault(_MainForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	
	    return {
	        isValidating: false,
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        //For any field errors upon submission (i.e. not instant check)
	        addSubscriber: function addSubscriber(values, dispatch, ownProps) {
	            dispatch((0, _users.submitForm)());
	            var errors = (0, _submitValidationsMainForm2.default)(values);
	            if (Object.keys(errors).length !== 0) {
	                var sleep = function sleep(ms) {
	                    return new Promise(function (resolve) {
	                        return setTimeout(resolve, ms);
	                    });
	                };
	                return sleep(10).then(function () {
	                    dispatch((0, _users.stopSubmitForm)());
	                    throw new _reduxForm.SubmissionError(Object.assign({}, errors, { _error: 'Revisá los campos indicados.' }));
	                });
	            }
	            return dispatch((0, _users.processSubscriber)(Object.assign({}, values, { tracking: (0, _utils.sanetizeMktParams)(ownProps.location.query) }))).then(function (result) {
	                // Note: Error's "data" is in result.payload.response.data (inside "response")
	                // success's "data" is in result.payload.data{}
	                if (result.payload.response && result.payload.response.status !== 200) {
	                    dispatch((0, _users.stopSubmitForm)());
	                    throw new _reduxForm.SubmissionError(Object.assign({}, (0, _utils.getErrorsApiToReduxForm)(result.payload.response.data), { _error: 'Revisá los campos indicados.' }));
	                }
	
	                //let other components know that everything is fine by updating the redux` state
	                var extraParams = typeof result.payload.data.extra !== 'undefined' ? result.payload.data.extra : false;
	                var providerSlug = typeof result.payload.data.body.name !== 'undefined' ? result.payload.data.body.name : false;
	                var isRecurrent = typeof result.payload.data.body.recurrent !== 'undefined' ? result.payload.data.body.recurrent : false;
	                var sanetizedString = {};
	                if (!isRecurrent) {
	                    sanetizedString = Object.assign({}, extraParams, { pv: providerSlug });
	                } else {
	                    sanetizedString = Object.assign({ untracked: true }, extraParams, { pv: providerSlug });
	                }
	
	                if (result.payload.data.leads) {
	                    //Store JWT Token to browser session storage
	                    //If you use localStorage instead of sessionStorage, then this w/ persisted across tabs and new windows.
	                    //sessionStorage = persisted only in current tab
	                    sessionStorage.setItem('jwtToken', result.payload.data.body.access_token);
	                    localStorage.removeItem('sanitizedName');
	                    localStorage.removeItem('formName');
	                    localStorage.setItem('formName', values.name);
	
	                    dispatch((0, _users.getNextStep)()).then(function (result) {
	                        if (typeof result.payload.data.endpoint !== 'undefined') {
	                            sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                            dispatch((0, _users.stopSubmitForm)());
	                            _reactRouter.browserHistory.push({
	                                pathname: result.payload.data.endpoint,
	                                search: (0, _utils.getQueryString)(sanetizedString)
	                            });
	                        }
	                    });
	                } else {
	                    _reactRouter.browserHistory.push({
	                        pathname: '/disapproved',
	                        search: (0, _utils.getQueryString)(sanetizedString)
	                    });
	                }
	            });
	        },
	        deleteReduxFormField: function deleteReduxFormField(fieldName) {
	            dispatch((0, _reduxForm.change)('IncomesForm', fieldName, null));
	            dispatch((0, _reduxForm.untouch)('IncomesForm', fieldName));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_MainForm2.default);

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _Pending = __webpack_require__(1147);
	
	var _Pending2 = _interopRequireDefault(_Pending);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Pending2.default);

/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reactRouter = __webpack_require__(32);
	
	var _reduxForm = __webpack_require__(16);
	
	var _users = __webpack_require__(35);
	
	var _utils = __webpack_require__(38);
	
	var _PersonalInfoForm = __webpack_require__(1148);
	
	var _PersonalInfoForm2 = _interopRequireDefault(_PersonalInfoForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	
	    return {
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        deleteReduxFormField: function deleteReduxFormField(fieldName) {
	            dispatch((0, _reduxForm.change)('PersonalInfoForm', fieldName, null));
	            dispatch((0, _reduxForm.untouch)('PersonalInfoForm', fieldName));
	        },
	        savePersonalInfo: function savePersonalInfo(values, dispatch) {
	            dispatch((0, _users.submitForm)());
	            return dispatch((0, _users.savePersonalInfo)(values)).then(function (result) {
	                if (result.payload.status !== 200) {
	                    dispatch((0, _users.stopSubmitForm)());
	                    throw new _reduxForm.SubmissionError(Object.assign({}, (0, _utils.getErrorsApiToReduxForm)(result.payload.response.data), { _error: 'Revisá los campos indicados.' }));
	                } else {
	                    dispatch((0, _users.getNextStep)()).then(function (result) {
	                        if (typeof result.payload.data.endpoint !== 'undefined') {
	                            sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                            dispatch((0, _users.stopSubmitForm)());
	                            _reactRouter.browserHistory.push(result.payload.data.endpoint);
	                        }
	                    });
	                }
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_PersonalInfoForm2.default);

/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reduxForm = __webpack_require__(16);
	
	var _reactRouter = __webpack_require__(32);
	
	var _users = __webpack_require__(35);
	
	var _Product = __webpack_require__(1149);
	
	var _Product2 = _interopRequireDefault(_Product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	
	    return {
	        loan_amount_value: 10,
	        loan_quotas_value: 20,
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setDefaultValue: function setDefaultValue(values) {
	            dispatch((0, _reduxForm.initialize)('product', values, null));
	        },
	        addProduct: function addProduct(values, dispatch) {
	            values = Object.assign({}, values, { requested_amount: values.requested_amount.toString() });
	            dispatch((0, _users.submitForm)());
	            return dispatch((0, _users.loadProduct)(values)).then(function (result) {
	                if (result.payload.response && result.payload.response.status !== 200) {
	                    dispatch((0, _users.stopSubmitForm)());
	                    throw new _reduxForm.SubmissionError(result.payload.response.data);
	                }
	                dispatch((0, _users.getNextStep)()).then(function (result) {
	                    if (typeof result.payload.data.endpoint !== 'undefined') {
	                        sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                        dispatch((0, _users.stopSubmitForm)());
	                        _reactRouter.browserHistory.push(result.payload.data.endpoint);
	                    }
	                });
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Product2.default);

/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reactRouter = __webpack_require__(32);
	
	var _users = __webpack_require__(35);
	
	var _RenaperDni = __webpack_require__(1155);
	
	var _RenaperDni2 = _interopRequireDefault(_RenaperDni);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        getStep: function getStep(values, dispatch) {
	            dispatch((0, _users.submitForm)());
	            return dispatch((0, _users.getNextStep)()).then(function (result) {
	                if (typeof result.payload.data.endpoint !== "undefined") {
	                    sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                    dispatch((0, _users.stopSubmitForm)());
	                    _reactRouter.browserHistory.push(result.payload.data.endpoint);
	                }
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_RenaperDni2.default);

/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reactRouter = __webpack_require__(32);
	
	var _users = __webpack_require__(35);
	
	var _RenaperFace = __webpack_require__(1156);
	
	var _RenaperFace2 = _interopRequireDefault(_RenaperFace);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        getStep: function getStep(values, dispatch) {
	            dispatch((0, _users.submitForm)());
	            return dispatch((0, _users.getNextStep)()).then(function (result) {
	                if (typeof result.payload.data.endpoint !== "undefined") {
	                    sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                    dispatch((0, _users.stopSubmitForm)());
	                    _reactRouter.browserHistory.push(result.payload.data.endpoint);
	                }
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_RenaperFace2.default);

/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reactRouter = __webpack_require__(32);
	
	var _users = __webpack_require__(35);
	
	var _SelfieWithDocument = __webpack_require__(1165);
	
	var _SelfieWithDocument2 = _interopRequireDefault(_SelfieWithDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        getStep: function getStep(values, dispatch) {
	            dispatch((0, _users.submitForm)());
	            return dispatch((0, _users.getNextStep)()).then(function (result) {
	                if (typeof result.payload.data.endpoint !== "undefined") {
	                    sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                    dispatch((0, _users.stopSubmitForm)());
	                    _reactRouter.browserHistory.push(result.payload.data.endpoint);
	                }
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SelfieWithDocument2.default);

/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reactRouter = __webpack_require__(32);
	
	var _reduxForm = __webpack_require__(16);
	
	var _users = __webpack_require__(35);
	
	var _utils = __webpack_require__(38);
	
	var _ServiceInfoForm = __webpack_require__(1169);
	
	var _ServiceInfoForm2 = _interopRequireDefault(_ServiceInfoForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	
	    return {
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        saveServiceInfoForm: function saveServiceInfoForm(values, dispatch) {
	            dispatch((0, _users.submitForm)());
	            return dispatch((0, _users.saveServiceInfo)(values)).then(function (result) {
	                if (result.payload.status !== 200) {
	                    dispatch((0, _users.stopSubmitForm)());
	                    throw new _reduxForm.SubmissionError(Object.assign({}, (0, _utils.getErrorsApiToReduxForm)(result.payload.response.data), { _error: 'Revisá los campos indicados.' }));
	                } else {
	                    dispatch((0, _users.getNextStep)()).then(function (result) {
	                        if (typeof result.payload.data.endpoint !== 'undefined') {
	                            sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                            dispatch((0, _users.stopSubmitForm)());
	                            _reactRouter.browserHistory.push(result.payload.data.endpoint);
	                        }
	                    });
	                }
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ServiceInfoForm2.default);

/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reactRouter = __webpack_require__(32);
	
	var _reduxForm = __webpack_require__(16);
	
	var _users = __webpack_require__(35);
	
	var _utils = __webpack_require__(38);
	
	var _SmsForm = __webpack_require__(1172);
	
	var _SmsForm2 = _interopRequireDefault(_SmsForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        sendCode: function sendCode(values, dispatch) {
	            dispatch((0, _users.submitForm)());
	            var sms_code = values.sms_code;
	            return dispatch((0, _users.verifyCode)(sms_code)).then(function (result) {
	                if (result.payload.status !== 200) {
	                    dispatch((0, _users.stopSubmitForm)());
	                    throw new _reduxForm.SubmissionError(Object.assign({}, (0, _utils.getErrorsApiToReduxForm)(result.payload.response.data), { _error: 'Revisá los campos indicados.' }));
	                } else {
	                    dispatch((0, _users.getNextStep)()).then(function (result) {
	                        if (typeof result.payload.data.endpoint !== 'undefined') {
	                            sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                            dispatch((0, _users.stopSubmitForm)());
	                            _reactRouter.browserHistory.push(result.payload.data.endpoint);
	                        }
	                    });
	                }
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SmsForm2.default);

/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reactRouter = __webpack_require__(32);
	
	var _reduxForm = __webpack_require__(16);
	
	var _users = __webpack_require__(35);
	
	var _utils = __webpack_require__(38);
	
	var _Start = __webpack_require__(1173);
	
	var _Start2 = _interopRequireDefault(_Start);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	
	    return {
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        sentStart: function sentStart(values) {
	            dispatch((0, _users.submitForm)());
	            return dispatch((0, _users.setStart)()).then(function (result) {
	
	                if (typeof result.payload.response !== 'undefined') {
	                    if (result.payload.response.status === 400) {
	                        dispatch((0, _users.stopSubmitForm)());
	                        throw new _reduxForm.SubmissionError(Object.assign({}, (0, _utils.getErrorsApiToReduxForm)(result.payload.response.data), { _error: 'Revisá los campos indicados.' }));
	                    }
	                } else {
	                    dispatch((0, _users.getNextStep)()).then(function (result) {
	                        if (typeof result.payload.data.endpoint !== "undefined") {
	                            sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                            dispatch((0, _users.stopSubmitForm)());
	                            _reactRouter.browserHistory.push(result.payload.data.endpoint);
	                        }
	                    });
	                }
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Start2.default);

/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _states = __webpack_require__(507);
	
	var _States = __webpack_require__(1174);
	
	var _States2 = _interopRequireDefault(_States);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        statesList: state.states.statesList
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        fetchStates: function fetchStates() {
	            dispatch((0, _states.fetchStates)()).then(function (response) {
	                !response.error ? dispatch((0, _states.fetchStatesSuccess)(response.payload.data)) : dispatch((0, _states.fetchStatesFailure)(response.payload.data));
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_States2.default);

/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reactRouter = __webpack_require__(32);
	
	var _users = __webpack_require__(35);
	
	var _UploadDocuments = __webpack_require__(1177);
	
	var _UploadDocuments2 = _interopRequireDefault(_UploadDocuments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        getStep: function getStep(values, dispatch) {
	            dispatch((0, _users.submitForm)());
	            return dispatch((0, _users.getNextStep)()).then(function (result) {
	                if (typeof result.payload.data.endpoint !== "undefined") {
	                    sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                    dispatch((0, _users.stopSubmitForm)());
	                    _reactRouter.browserHistory.push(result.payload.data.endpoint);
	                }
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_UploadDocuments2.default);

/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(19);
	
	var _reactRouter = __webpack_require__(32);
	
	var _reduxForm = __webpack_require__(16);
	
	var _users = __webpack_require__(35);
	
	var _utils = __webpack_require__(38);
	
	var _UploadForm = __webpack_require__(1179);
	
	var _UploadForm2 = _interopRequireDefault(_UploadForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	
	    return {
	        isLoading: state.users.isLoading
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        saveFiles: function saveFiles(values, dispatch) {
	            dispatch((0, _users.submitForm)());
	            return dispatch((0, _users.saveFiles)(values)).then(function (result) {
	                if (result.payload.status !== 200) {
	                    dispatch((0, _users.stopSubmitForm)());
	                    throw new _reduxForm.SubmissionError(Object.assign({}, (0, _utils.getErrorsApiToReduxForm)(result.payload.response.data), { _error: 'Revisá los campos indicados.' }));
	                } else {
	                    dispatch((0, _users.getNextStep)()).then(function (result) {
	                        if (typeof result.payload.data.endpoint !== 'undefined') {
	                            sessionStorage.setItem('endpoint', result.payload.data.endpoint);
	                            dispatch((0, _users.stopSubmitForm)());
	                            _reactRouter.browserHistory.push(result.payload.data.endpoint);
	                        }
	                    });
	                }
	            });
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_UploadForm2.default);

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(19);
	
	var _reactIntl = __webpack_require__(26);
	
	var _configureStore = __webpack_require__(1218);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _AppContainer = __webpack_require__(1188);
	
	var _AppContainer2 = _interopRequireDefault(_AppContainer);
	
	__webpack_require__(1398);
	
	__webpack_require__(1437);
	
	var _montemar = __webpack_require__(1553);
	
	var _montemar2 = _interopRequireDefault(_montemar);
	
	var _montemarCardCalf = __webpack_require__(1552);
	
	var _montemarCardCalf2 = _interopRequireDefault(_montemarCardCalf);
	
	var _puedo = __webpack_require__(1554);
	
	var _puedo2 = _interopRequireDefault(_puedo);
	
	var _demo = __webpack_require__(1551);
	
	var _demo2 = _interopRequireDefault(_demo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1431);
	__webpack_require__(1427);
	__webpack_require__(1430);
	
	
	var messages = {
					'montemar': _montemar2.default,
					'montemar-card-calf': _montemarCardCalf2.default,
					'puedo': _puedo2.default,
					'demo': _demo2.default
	};
	
	var store = (0, _configureStore2.default)();
	
	_reactDom2.default.render(_react2.default.createElement(
					_reactIntl.IntlProvider,
					{ locale: 'en', messages: messages[("montemar-card-calf")] },
					_react2.default.createElement(
									_reactRedux.Provider,
									{ store: store },
									_react2.default.createElement(_AppContainer2.default, null)
					)
	), document.getElementById('root'));

/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _redux = __webpack_require__(233);
	
	var _reducer_states = __webpack_require__(1216);
	
	var _reducer_states2 = _interopRequireDefault(_reducer_states);
	
	var _reducer_users = __webpack_require__(1217);
	
	var _reducer_users2 = _interopRequireDefault(_reducer_users);
	
	var _reducer_employments = __webpack_require__(1215);
	
	var _reducer_employments2 = _interopRequireDefault(_reducer_employments);
	
	var _reduxForm = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootReducer = (0, _redux.combineReducers)({
		employments: _reducer_employments2.default, //<-- Employments
		states: _reducer_states2.default, //<-- States
		users: _reducer_users2.default, //<-- Users
		form: _reduxForm.reducer // <--- Form Reducer
	});
	
	exports.default = rootReducer;

/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    var error = void 0;
	    switch (action.type) {
	        case _employments.FETCH_EMPLOYMENTS:
	            // start fetching employments and set loading = true
	            return Object.assign({}, state, { employmentsList: { employments: [], error: null, loading: true } });
	        case _employments.FETCH_EMPLOYMENTS_SUCCESS:
	            // return list of employments and make loading = false
	            return Object.assign({}, state, { employmentsList: { employments: action.payload, error: null, loading: false } });
	        case _employments.FETCH_EMPLOYMENTS_FAILURE:
	            // return error and make loading = false
	            error = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return Object.assign({}, state, { employmentsList: { employments: [], error: error, loading: false } });
	        case _employments.RESET_EMPLOYMENTS:
	            // reset employmentsList to initial state
	            return Object.assign({}, state, { employmentsList: { employments: [], error: null, loading: false } });
	        default:
	            return state;
	    }
	};
	
	var _employments = __webpack_require__(506);
	
	var INITIAL_STATE = {
	    employmentsList: { employments: [], error: null, loading: false }
	};

/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    var error = void 0;
	    switch (action.type) {
	        case _states.FETCH_STATES:
	            // start fetching states and set loading = true
	            return Object.assign({}, state, { statesList: { states: [], error: null, loading: true } });
	        case _states.FETCH_STATES_SUCCESS:
	            // return list of states and make loading = false
	            return Object.assign({}, state, { statesList: { states: action.payload, error: null, loading: false } });
	        case _states.FETCH_STATES_FAILURE:
	            // return error and make loading = false
	            error = action.payload || { message: action.payload.message }; //2nd one is network or server down errors
	            return Object.assign({}, state, { statesList: { states: [], error: error, loading: false } });
	        case _states.RESET_STATES:
	            // reset statesList to initial state
	            return Object.assign({}, state, { statesList: { states: [], error: null, loading: false } });
	        default:
	            return state;
	    }
	};
	
	var _states = __webpack_require__(507);
	
	var INITIAL_STATE = {
	    statesList: { states: [], error: null, loading: false }
	};

/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _users = __webpack_require__(35);
	
	var INITIAL_STATE = {
	    isLoading: false
	};
	
	function UsersReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _users.SUBMIT_SMS_FORM:
	            return Object.assign({}, state, { isLoading: true });
	        case _users.SUBMIT_FORM:
	            return Object.assign({}, state, { isLoading: true });
	        case _users.STOP_SUBMIT_FORM:
	            return Object.assign({}, state, { isLoading: false });
	        case _users.PROCESSED_SUBSCRIBER:
	            return Object.assign({}, state, { isLoading: true });
	        case _users.SET_SUBSCRIPTION_EMAIL:
	            return Object.assign({}, state, { isLoading: true });
	        default:
	            return state;
	    }
	}
	
	exports.default = UsersReducer;

/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = configureStore;
	
	var _redux = __webpack_require__(233);
	
	var _reducers = __webpack_require__(1214);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _reduxPromise = __webpack_require__(2013);
	
	var _reduxPromise2 = _interopRequireDefault(_reduxPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var composeEnhancers = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
	  // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
	}) : _redux.compose;
	
	// Middleware you want to use in production:
	var enhancer = composeEnhancers((0, _redux.applyMiddleware)(_reduxPromise2.default));
	
	function configureStore(initialState) {
	
	  // Note: only Redux >= 3.1.0 supports passing enhancer as third argument.
	  // See https://github.com/rackt/redux/releases/tag/v3.1.0
	  return (0, _redux.createStore)(_reducers2.default, initialState, enhancer);
	};

/***/ },
/* 1219 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var checkUserMediaCompatibility = exports.checkUserMediaCompatibility = function checkUserMediaCompatibility() {
	    if (/iPhone|iPad/.test(navigator.userAgent)) {
	        if (!/Version\//.test(navigator.userAgent)) {
	            return false;
	        }
	    }
	    return true;
	};
	
	var checkUserMediaContrainsCompatibility = exports.checkUserMediaContrainsCompatibility = function checkUserMediaContrainsCompatibility() {
	    var incompatibleDevices = ['SM-A305F', 'SM-G975F', 'SM-G610M', 'Redmi Note 8', 'Android 11', 'Android 12'];
	
	    var reg = RegExp(incompatibleDevices.join('|'));
	    return !reg.test(navigator.userAgent);
	};

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(1221);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1221 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1245), __esModule: true };

/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1246), __esModule: true };

/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1247), __esModule: true };

/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1249), __esModule: true };

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1250), __esModule: true };

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1253), __esModule: true };

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1254), __esModule: true };

/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1257), __esModule: true };

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1258), __esModule: true };

/***/ },
/* 1231 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, Buffer) {var msg = __webpack_require__(812);
	var zstream = __webpack_require__(1679);
	var zlib_deflate = __webpack_require__(1674);
	var zlib_inflate = __webpack_require__(1676);
	var constants = __webpack_require__(1673);
	
	for (var key in constants) {
	  exports[key] = constants[key];
	}
	
	// zlib modes
	exports.NONE = 0;
	exports.DEFLATE = 1;
	exports.INFLATE = 2;
	exports.GZIP = 3;
	exports.GUNZIP = 4;
	exports.DEFLATERAW = 5;
	exports.INFLATERAW = 6;
	exports.UNZIP = 7;
	
	/**
	 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
	 */
	function Zlib(mode) {
	  if (mode < exports.DEFLATE || mode > exports.UNZIP)
	    throw new TypeError("Bad argument");
	    
	  this.mode = mode;
	  this.init_done = false;
	  this.write_in_progress = false;
	  this.pending_close = false;
	  this.windowBits = 0;
	  this.level = 0;
	  this.memLevel = 0;
	  this.strategy = 0;
	  this.dictionary = null;
	}
	
	Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
	  this.windowBits = windowBits;
	  this.level = level;
	  this.memLevel = memLevel;
	  this.strategy = strategy;
	  // dictionary not supported.
	  
	  if (this.mode === exports.GZIP || this.mode === exports.GUNZIP)
	    this.windowBits += 16;
	    
	  if (this.mode === exports.UNZIP)
	    this.windowBits += 32;
	    
	  if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW)
	    this.windowBits = -this.windowBits;
	    
	  this.strm = new zstream();
	  
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.GZIP:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflateInit2(
	        this.strm,
	        this.level,
	        exports.Z_DEFLATED,
	        this.windowBits,
	        this.memLevel,
	        this.strategy
	      );
	      break;
	    case exports.INFLATE:
	    case exports.GUNZIP:
	    case exports.INFLATERAW:
	    case exports.UNZIP:
	      var status  = zlib_inflate.inflateInit2(
	        this.strm,
	        this.windowBits
	      );
	      break;
	    default:
	      throw new Error("Unknown mode " + this.mode);
	  }
	  
	  if (status !== exports.Z_OK) {
	    this._error(status);
	    return;
	  }
	  
	  this.write_in_progress = false;
	  this.init_done = true;
	};
	
	Zlib.prototype.params = function() {
	  throw new Error("deflateParams Not supported");
	};
	
	Zlib.prototype._writeCheck = function() {
	  if (!this.init_done)
	    throw new Error("write before init");
	    
	  if (this.mode === exports.NONE)
	    throw new Error("already finalized");
	    
	  if (this.write_in_progress)
	    throw new Error("write already in progress");
	    
	  if (this.pending_close)
	    throw new Error("close is pending");
	};
	
	Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {    
	  this._writeCheck();
	  this.write_in_progress = true;
	  
	  var self = this;
	  process.nextTick(function() {
	    self.write_in_progress = false;
	    var res = self._write(flush, input, in_off, in_len, out, out_off, out_len);
	    self.callback(res[0], res[1]);
	    
	    if (self.pending_close)
	      self.close();
	  });
	  
	  return this;
	};
	
	// set method for Node buffers, used by pako
	function bufferSet(data, offset) {
	  for (var i = 0; i < data.length; i++) {
	    this[offset + i] = data[i];
	  }
	}
	
	Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
	  this._writeCheck();
	  return this._write(flush, input, in_off, in_len, out, out_off, out_len);
	};
	
	Zlib.prototype._write = function(flush, input, in_off, in_len, out, out_off, out_len) {
	  this.write_in_progress = true;
	  
	  if (flush !== exports.Z_NO_FLUSH &&
	      flush !== exports.Z_PARTIAL_FLUSH &&
	      flush !== exports.Z_SYNC_FLUSH &&
	      flush !== exports.Z_FULL_FLUSH &&
	      flush !== exports.Z_FINISH &&
	      flush !== exports.Z_BLOCK) {
	    throw new Error("Invalid flush value");
	  }
	  
	  if (input == null) {
	    input = new Buffer(0);
	    in_len = 0;
	    in_off = 0;
	  }
	  
	  if (out._set)
	    out.set = out._set;
	  else
	    out.set = bufferSet;
	  
	  var strm = this.strm;
	  strm.avail_in = in_len;
	  strm.input = input;
	  strm.next_in = in_off;
	  strm.avail_out = out_len;
	  strm.output = out;
	  strm.next_out = out_off;
	  
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.GZIP:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflate(strm, flush);
	      break;
	    case exports.UNZIP:
	    case exports.INFLATE:
	    case exports.GUNZIP:
	    case exports.INFLATERAW:
	      var status = zlib_inflate.inflate(strm, flush);
	      break;
	    default:
	      throw new Error("Unknown mode " + this.mode);
	  }
	  
	  if (status !== exports.Z_STREAM_END && status !== exports.Z_OK) {
	    this._error(status);
	  }
	  
	  this.write_in_progress = false;
	  return [strm.avail_in, strm.avail_out];
	};
	
	Zlib.prototype.close = function() {
	  if (this.write_in_progress) {
	    this.pending_close = true;
	    return;
	  }
	  
	  this.pending_close = false;
	  
	  if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) {
	    zlib_deflate.deflateEnd(this.strm);
	  } else {
	    zlib_inflate.inflateEnd(this.strm);
	  }
	  
	  this.mode = exports.NONE;
	};
	
	Zlib.prototype.reset = function() {
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflateReset(this.strm);
	      break;
	    case exports.INFLATE:
	    case exports.INFLATERAW:
	      var status = zlib_inflate.inflateReset(this.strm);
	      break;
	  }
	  
	  if (status !== exports.Z_OK) {
	    this._error(status);
	  }
	};
	
	Zlib.prototype._error = function(status) {
	  this.onerror(msg[status] + ': ' + this.strm.msg, status);
	  
	  this.write_in_progress = false;
	  if (this.pending_close)
	    this.close();
	};
	
	exports.Zlib = Zlib;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39), __webpack_require__(62).Buffer))

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(213);
	var $apply = __webpack_require__(335);
	var actualApply = __webpack_require__(514);
	
	/** @type {import('./applyBind')} */
	module.exports = function applyBind() {
		return actualApply(bind, $apply, arguments);
	};


/***/ },
/* 1234 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./reflectApply')} */
	module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1));
		else if(typeof define === 'function' && define.amd)
			define(["react"], factory);
		else if(typeof exports === 'object')
			exports["Cleave"] = factory(require("react"));
		else
			root["Cleave"] = factory(root["React"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
		var React = __webpack_require__(1); // eslint-disable-line no-unused-vars
		var CreateReactClass = __webpack_require__(2);
	
		var NumeralFormatter = __webpack_require__(9);
		var DateFormatter = __webpack_require__(10);
		var TimeFormatter = __webpack_require__(11);
		var PhoneFormatter = __webpack_require__(12);
		var CreditCardDetector = __webpack_require__(13);
		var Util = __webpack_require__(14);
		var DefaultProperties = __webpack_require__(15);
	
		var cleaveReactClass = CreateReactClass({
		    componentDidMount: function componentDidMount() {
		        this.init();
		    },
	
		    componentDidUpdate: function componentDidUpdate(prevProps) {
		        var owner = this,
		            phoneRegionCode = (owner.props.options || {}).phoneRegionCode,
		            newValue = owner.props.value,
		            pps = owner.properties;
	
		        owner.updateRegisteredEvents(owner.props);
		        if (prevProps.value !== newValue && newValue !== undefined && newValue !== null) {
		            newValue = newValue.toString();
	
		            if (newValue !== owner.properties.result) {
		                owner.properties.initValue = newValue;
		                owner.onInput(newValue, true);
		            }
		        }
	
		        // update phone region code
		        var prevPhoneRegionCode = (prevProps.options || {}).phoneRegionCode;
		        if (prevPhoneRegionCode !== phoneRegionCode && phoneRegionCode && phoneRegionCode !== owner.properties.phoneRegionCode) {
		            owner.properties.phoneRegionCode = phoneRegionCode;
		            owner.initPhoneFormatter();
		            owner.onInput(owner.properties.result);
		        }
	
		        Util.setSelection(owner.element, owner.state.cursorPosition, pps.document);
		    },
	
		    updateRegisteredEvents: function updateRegisteredEvents(props) {
		        var owner = this,
		            _owner$registeredEven = owner.registeredEvents,
		            onKeyDown = _owner$registeredEven.onKeyDown,
		            onChange = _owner$registeredEven.onChange,
		            onFocus = _owner$registeredEven.onFocus,
		            onBlur = _owner$registeredEven.onBlur,
		            onInit = _owner$registeredEven.onInit;
	
	
		        if (props.onInit && props.onInit !== onInit) owner.registeredEvents.onInit = props.onInit;
		        if (props.onChange && props.onChange !== onChange) owner.registeredEvents.onChange = props.onChange;
		        if (props.onFocus && props.onFocus !== onFocus) owner.registeredEvents.onFocus = props.onFocus;
		        if (props.onBlur && props.onBlur !== onBlur) owner.registeredEvents.onBlur = props.onBlur;
		        if (props.onKeyDown && props.onKeyDown !== onKeyDown) owner.registeredEvents.onKeyDown = props.onKeyDown;
		    },
	
		    getInitialState: function getInitialState() {
		        var owner = this,
		            _owner$props = owner.props,
		            value = _owner$props.value,
		            options = _owner$props.options,
		            onKeyDown = _owner$props.onKeyDown,
		            onChange = _owner$props.onChange,
		            onFocus = _owner$props.onFocus,
		            onBlur = _owner$props.onBlur,
		            onInit = _owner$props.onInit;
	
	
		        owner.registeredEvents = {
		            onInit: onInit || Util.noop,
		            onChange: onChange || Util.noop,
		            onFocus: onFocus || Util.noop,
		            onBlur: onBlur || Util.noop,
		            onKeyDown: onKeyDown || Util.noop
		        };
	
		        if (!options) {
		            options = {};
		        }
	
		        options.initValue = value;
	
		        owner.properties = DefaultProperties.assign({}, options);
	
		        return {
		            value: owner.properties.result,
		            cursorPosition: 0
		        };
		    },
	
		    init: function init() {
		        var owner = this,
		            pps = owner.properties;
	
		        // so no need for this lib at all
		        if (!pps.numeral && !pps.phone && !pps.creditCard && !pps.time && !pps.date && pps.blocksLength === 0 && !pps.prefix) {
		            owner.onInput(pps.initValue);
		            owner.registeredEvents.onInit(owner);
	
		            return;
		        }
	
		        pps.maxLength = Util.getMaxLength(pps.blocks);
	
		        owner.isAndroid = Util.isAndroid();
	
		        owner.initPhoneFormatter();
		        owner.initDateFormatter();
		        owner.initTimeFormatter();
		        owner.initNumeralFormatter();
	
		        // avoid touch input field if value is null
		        // otherwise Firefox will add red box-shadow for <input required />
		        if (pps.initValue || pps.prefix && !pps.noImmediatePrefix) {
		            owner.onInput(pps.initValue);
		        }
	
		        owner.registeredEvents.onInit(owner);
		    },
	
		    initNumeralFormatter: function initNumeralFormatter() {
		        var owner = this,
		            pps = owner.properties;
	
		        if (!pps.numeral) {
		            return;
		        }
	
		        pps.numeralFormatter = new NumeralFormatter(pps.numeralDecimalMark, pps.numeralIntegerScale, pps.numeralDecimalScale, pps.numeralThousandsGroupStyle, pps.numeralPositiveOnly, pps.stripLeadingZeroes, pps.prefix, pps.signBeforePrefix, pps.tailPrefix, pps.delimiter);
		    },
	
		    initTimeFormatter: function initTimeFormatter() {
		        var owner = this,
		            pps = owner.properties;
	
		        if (!pps.time) {
		            return;
		        }
	
		        pps.timeFormatter = new TimeFormatter(pps.timePattern, pps.timeFormat);
		        pps.blocks = pps.timeFormatter.getBlocks();
		        pps.blocksLength = pps.blocks.length;
		        pps.maxLength = Util.getMaxLength(pps.blocks);
		    },
	
		    initDateFormatter: function initDateFormatter() {
		        var owner = this,
		            pps = owner.properties;
	
		        if (!pps.date) {
		            return;
		        }
	
		        pps.dateFormatter = new DateFormatter(pps.datePattern, pps.dateMin, pps.dateMax);
		        pps.blocks = pps.dateFormatter.getBlocks();
		        pps.blocksLength = pps.blocks.length;
		        pps.maxLength = Util.getMaxLength(pps.blocks);
		    },
	
		    initPhoneFormatter: function initPhoneFormatter() {
		        var owner = this,
		            pps = owner.properties;
	
		        if (!pps.phone) {
		            return;
		        }
	
		        // Cleave.AsYouTypeFormatter should be provided by
		        // external google closure lib
		        try {
		            pps.phoneFormatter = new PhoneFormatter(new pps.root.Cleave.AsYouTypeFormatter(pps.phoneRegionCode), pps.delimiter);
		        } catch (ex) {
		            throw new Error('Please include phone-type-formatter.{country}.js lib');
		        }
		    },
	
		    setRawValue: function setRawValue(value) {
		        var owner = this,
		            pps = owner.properties;
	
		        value = value !== undefined && value !== null ? value.toString() : '';
	
		        if (pps.numeral) {
		            value = value.replace('.', pps.numeralDecimalMark);
		        }
	
		        pps.postDelimiterBackspace = false;
	
		        owner.onChange({
		            target: { value: value },
	
		            // Methods to better resemble a SyntheticEvent
		            stopPropagation: Util.noop,
		            preventDefault: Util.noop,
		            persist: Util.noop
		        });
		    },
	
		    getRawValue: function getRawValue() {
		        var owner = this,
		            pps = owner.properties,
		            rawValue = pps.result;
	
		        if (pps.rawValueTrimPrefix) {
		            rawValue = Util.getPrefixStrippedValue(rawValue, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters, pps.noImmediatePrefix, pps.tailPrefix, pps.signBeforePrefix);
		        }
	
		        if (pps.numeral) {
		            rawValue = pps.numeralFormatter ? pps.numeralFormatter.getRawValue(rawValue) : '';
		        } else {
		            rawValue = Util.stripDelimiters(rawValue, pps.delimiter, pps.delimiters);
		        }
	
		        return rawValue;
		    },
	
		    getISOFormatDate: function getISOFormatDate() {
		        var owner = this,
		            pps = owner.properties;
	
		        return pps.date ? pps.dateFormatter.getISOFormatDate() : '';
		    },
	
		    getISOFormatTime: function getISOFormatTime() {
		        var owner = this,
		            pps = owner.properties;
	
		        return pps.time ? pps.timeFormatter.getISOFormatTime() : '';
		    },
	
		    onInit: function onInit(owner) {
		        return owner;
		    },
	
		    onKeyDown: function onKeyDown(event) {
		        var owner = this,
		            pps = owner.properties,
		            charCode = event.which || event.keyCode;
	
		        owner.lastInputValue = pps.result;
		        owner.isBackward = charCode === 8;
	
		        owner.registeredEvents.onKeyDown(event);
		    },
	
		    onFocus: function onFocus(event) {
		        var owner = this,
		            pps = owner.properties;
	
		        if (pps.prefix && pps.noImmediatePrefix && !event.target.value) {
		            owner.onInput(pps.prefix);
		        }
	
		        event.target.rawValue = owner.getRawValue();
		        event.target.value = pps.result;
	
		        owner.registeredEvents.onFocus(event);
	
		        Util.fixPrefixCursor(owner.element, pps.prefix, pps.delimiter, pps.delimiters);
		    },
	
		    onBlur: function onBlur(event) {
		        var owner = this,
		            pps = owner.properties;
	
		        event.target.rawValue = owner.getRawValue();
		        event.target.value = pps.result;
	
		        owner.registeredEvents.onBlur(event);
		    },
	
		    onChange: function onChange(event) {
		        var owner = this,
		            pps = owner.properties;
	
		        owner.isBackward = owner.isBackward || event.inputType === 'deleteContentBackward';
		        // hit backspace when last character is delimiter
		        var postDelimiter = Util.getPostDelimiter(owner.lastInputValue, pps.delimiter, pps.delimiters);
	
		        if (owner.isBackward && postDelimiter) {
		            pps.postDelimiterBackspace = postDelimiter;
		        } else {
		            pps.postDelimiterBackspace = false;
		        }
	
		        owner.onInput(event.target.value);
	
		        event.target.rawValue = owner.getRawValue();
		        event.target.value = pps.result;
	
		        owner.registeredEvents.onChange(event);
		    },
	
		    onInput: function onInput(value, fromProps) {
		        var owner = this,
		            pps = owner.properties;
	
		        // case 1: delete one more character "4"
		        // 1234*| -> hit backspace -> 123|
		        // case 2: last character is not delimiter which is:
		        // 12|34* -> hit backspace -> 1|34*
		        var postDelimiterAfter = Util.getPostDelimiter(value, pps.delimiter, pps.delimiters);
		        if (!fromProps && !pps.numeral && pps.postDelimiterBackspace && !postDelimiterAfter) {
		            value = Util.headStr(value, value.length - pps.postDelimiterBackspace.length);
		        }
	
		        // phone formatter
		        if (pps.phone) {
		            if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
		                pps.result = pps.prefix + pps.phoneFormatter.format(value).slice(pps.prefix.length);
		            } else {
		                pps.result = pps.phoneFormatter.format(value);
		            }
		            owner.updateValueState();
	
		            return;
		        }
	
		        // numeral formatter
		        if (pps.numeral) {
		            // Do not show prefix when noImmediatePrefix is specified
		            // This mostly because we need to show user the native input placeholder
		            if (pps.prefix && pps.noImmediatePrefix && value.length === 0) {
		                pps.result = '';
		            } else {
		                pps.result = pps.numeralFormatter.format(value);
		            }
		            owner.updateValueState();
	
		            return;
		        }
	
		        // date
		        if (pps.date) {
		            value = pps.dateFormatter.getValidatedDate(value);
		        }
	
		        // time
		        if (pps.time) {
		            value = pps.timeFormatter.getValidatedTime(value);
		        }
	
		        // strip delimiters
		        value = Util.stripDelimiters(value, pps.delimiter, pps.delimiters);
	
		        // strip prefix
		        value = Util.getPrefixStrippedValue(value, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters, pps.noImmediatePrefix, pps.tailPrefix, pps.signBeforePrefix);
	
		        // strip non-numeric characters
		        value = pps.numericOnly ? Util.strip(value, /[^\d]/g) : value;
	
		        // convert case
		        value = pps.uppercase ? value.toUpperCase() : value;
		        value = pps.lowercase ? value.toLowerCase() : value;
	
		        // prevent from showing prefix when no immediate option enabled with empty input value
		        if (pps.prefix) {
		            if (pps.tailPrefix) {
		                value = value + pps.prefix;
		            } else {
		                value = pps.prefix + value;
		            }
	
		            // no blocks specified, no need to do formatting
		            if (pps.blocksLength === 0) {
		                pps.result = value;
		                owner.updateValueState();
	
		                return;
		            }
		        }
	
		        // update credit card props
		        if (pps.creditCard) {
		            owner.updateCreditCardPropsByValue(value);
		        }
	
		        // strip over length characters
		        value = pps.maxLength > 0 ? Util.headStr(value, pps.maxLength) : value;
	
		        // apply blocks
		        pps.result = Util.getFormattedValue(value, pps.blocks, pps.blocksLength, pps.delimiter, pps.delimiters, pps.delimiterLazyShow);
	
		        owner.updateValueState();
		    },
	
		    updateCreditCardPropsByValue: function updateCreditCardPropsByValue(value) {
		        var owner = this,
		            pps = owner.properties,
		            creditCardInfo;
	
		        // At least one of the first 4 characters has changed
		        if (Util.headStr(pps.result, 4) === Util.headStr(value, 4)) {
		            return;
		        }
	
		        creditCardInfo = CreditCardDetector.getInfo(value, pps.creditCardStrictMode);
	
		        pps.blocks = creditCardInfo.blocks;
		        pps.blocksLength = pps.blocks.length;
		        pps.maxLength = Util.getMaxLength(pps.blocks);
	
		        // credit card type changed
		        if (pps.creditCardType !== creditCardInfo.type) {
		            pps.creditCardType = creditCardInfo.type;
	
		            pps.onCreditCardTypeChanged.call(owner, pps.creditCardType);
		        }
		    },
	
		    updateValueState: function updateValueState() {
		        var owner = this,
		            pps = owner.properties;
	
		        if (!owner.element) {
		            owner.setState({ value: pps.result });
		            return;
		        }
	
		        var endPos = owner.element.selectionEnd;
		        var oldValue = owner.element.value;
		        var newValue = pps.result;
	
		        owner.lastInputValue = newValue;
	
		        endPos = Util.getNextCursorPosition(endPos, oldValue, newValue, pps.delimiter, pps.delimiters);
	
		        if (owner.isAndroid) {
		            window.setTimeout(function () {
		                owner.setState({ value: newValue, cursorPosition: endPos });
		            }, 1);
	
		            return;
		        }
	
		        owner.setState({ value: newValue, cursorPosition: endPos });
		    },
	
		    render: function render() {
		        var owner = this;
		        // eslint-disable-next-line
	
		        var _owner$props2 = owner.props,
		            value = _owner$props2.value,
		            options = _owner$props2.options,
		            onKeyDown = _owner$props2.onKeyDown,
		            onFocus = _owner$props2.onFocus,
		            onBlur = _owner$props2.onBlur,
		            onChange = _owner$props2.onChange,
		            onInit = _owner$props2.onInit,
		            htmlRef = _owner$props2.htmlRef,
		            propsToTransfer = _objectWithoutProperties(_owner$props2, ['value', 'options', 'onKeyDown', 'onFocus', 'onBlur', 'onChange', 'onInit', 'htmlRef']);
	
		        return React.createElement('input', _extends({
		            type: 'text',
		            ref: function ref(_ref) {
		                owner.element = _ref;
	
		                if (!htmlRef) {
		                    return;
		                }
	
		                htmlRef.apply(this, arguments);
		            },
		            value: owner.state.value,
		            onKeyDown: owner.onKeyDown,
		            onChange: owner.onChange,
		            onFocus: owner.onFocus,
		            onBlur: owner.onBlur
		        }, propsToTransfer));
		    }
		});
	
		module.exports = cleaveReactClass;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 */
	
		'use strict';
	
		var React = __webpack_require__(1);
		var factory = __webpack_require__(3);
	
		if (typeof React === 'undefined') {
		  throw Error(
		    'create-react-class could not find the React object. If you are using script tags, ' +
		      'make sure that React is being loaded before create-react-class.'
		  );
		}
	
		// Hack to grab NoopUpdateQueue from isomorphic React
		var ReactNoopUpdateQueue = new React.Component().updater;
	
		module.exports = factory(
		  React.Component,
		  React.isValidElement,
		  ReactNoopUpdateQueue
		);
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 */
	
		'use strict';
	
		var _assign = __webpack_require__(4);
	
		var emptyObject = __webpack_require__(5);
		var _invariant = __webpack_require__(6);
	
		if (false) {
		  var warning = __webpack_require__(7);
		}
	
		var MIXINS_KEY = 'mixins';
	
		// Helper function to allow the creation of anonymous functions which do not
		// have .name set to the name of the variable being assigned to.
		function identity(fn) {
		  return fn;
		}
	
		var ReactPropTypeLocationNames;
		if (false) {
		  ReactPropTypeLocationNames = {
		    prop: 'prop',
		    context: 'context',
		    childContext: 'child context'
		  };
		} else {
		  ReactPropTypeLocationNames = {};
		}
	
		function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
		  /**
		   * Policies that describe methods in `ReactClassInterface`.
		   */
	
		  var injectedMixins = [];
	
		  /**
		   * Composite components are higher-level components that compose other composite
		   * or host components.
		   *
		   * To create a new type of `ReactClass`, pass a specification of
		   * your new class to `React.createClass`. The only requirement of your class
		   * specification is that you implement a `render` method.
		   *
		   *   var MyComponent = React.createClass({
		   *     render: function() {
		   *       return <div>Hello World</div>;
		   *     }
		   *   });
		   *
		   * The class specification supports a specific protocol of methods that have
		   * special meaning (e.g. `render`). See `ReactClassInterface` for
		   * more the comprehensive protocol. Any other properties and methods in the
		   * class specification will be available on the prototype.
		   *
		   * @interface ReactClassInterface
		   * @internal
		   */
		  var ReactClassInterface = {
		    /**
		     * An array of Mixin objects to include when defining your component.
		     *
		     * @type {array}
		     * @optional
		     */
		    mixins: 'DEFINE_MANY',
	
		    /**
		     * An object containing properties and methods that should be defined on
		     * the component's constructor instead of its prototype (static methods).
		     *
		     * @type {object}
		     * @optional
		     */
		    statics: 'DEFINE_MANY',
	
		    /**
		     * Definition of prop types for this component.
		     *
		     * @type {object}
		     * @optional
		     */
		    propTypes: 'DEFINE_MANY',
	
		    /**
		     * Definition of context types for this component.
		     *
		     * @type {object}
		     * @optional
		     */
		    contextTypes: 'DEFINE_MANY',
	
		    /**
		     * Definition of context types this component sets for its children.
		     *
		     * @type {object}
		     * @optional
		     */
		    childContextTypes: 'DEFINE_MANY',
	
		    // ==== Definition methods ====
	
		    /**
		     * Invoked when the component is mounted. Values in the mapping will be set on
		     * `this.props` if that prop is not specified (i.e. using an `in` check).
		     *
		     * This method is invoked before `getInitialState` and therefore cannot rely
		     * on `this.state` or use `this.setState`.
		     *
		     * @return {object}
		     * @optional
		     */
		    getDefaultProps: 'DEFINE_MANY_MERGED',
	
		    /**
		     * Invoked once before the component is mounted. The return value will be used
		     * as the initial value of `this.state`.
		     *
		     *   getInitialState: function() {
		     *     return {
		     *       isOn: false,
		     *       fooBaz: new BazFoo()
		     *     }
		     *   }
		     *
		     * @return {object}
		     * @optional
		     */
		    getInitialState: 'DEFINE_MANY_MERGED',
	
		    /**
		     * @return {object}
		     * @optional
		     */
		    getChildContext: 'DEFINE_MANY_MERGED',
	
		    /**
		     * Uses props from `this.props` and state from `this.state` to render the
		     * structure of the component.
		     *
		     * No guarantees are made about when or how often this method is invoked, so
		     * it must not have side effects.
		     *
		     *   render: function() {
		     *     var name = this.props.name;
		     *     return <div>Hello, {name}!</div>;
		     *   }
		     *
		     * @return {ReactComponent}
		     * @required
		     */
		    render: 'DEFINE_ONCE',
	
		    // ==== Delegate methods ====
	
		    /**
		     * Invoked when the component is initially created and about to be mounted.
		     * This may have side effects, but any external subscriptions or data created
		     * by this method must be cleaned up in `componentWillUnmount`.
		     *
		     * @optional
		     */
		    componentWillMount: 'DEFINE_MANY',
	
		    /**
		     * Invoked when the component has been mounted and has a DOM representation.
		     * However, there is no guarantee that the DOM node is in the document.
		     *
		     * Use this as an opportunity to operate on the DOM when the component has
		     * been mounted (initialized and rendered) for the first time.
		     *
		     * @param {DOMElement} rootNode DOM element representing the component.
		     * @optional
		     */
		    componentDidMount: 'DEFINE_MANY',
	
		    /**
		     * Invoked before the component receives new props.
		     *
		     * Use this as an opportunity to react to a prop transition by updating the
		     * state using `this.setState`. Current props are accessed via `this.props`.
		     *
		     *   componentWillReceiveProps: function(nextProps, nextContext) {
		     *     this.setState({
		     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
		     *     });
		     *   }
		     *
		     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
		     * transition may cause a state change, but the opposite is not true. If you
		     * need it, you are probably looking for `componentWillUpdate`.
		     *
		     * @param {object} nextProps
		     * @optional
		     */
		    componentWillReceiveProps: 'DEFINE_MANY',
	
		    /**
		     * Invoked while deciding if the component should be updated as a result of
		     * receiving new props, state and/or context.
		     *
		     * Use this as an opportunity to `return false` when you're certain that the
		     * transition to the new props/state/context will not require a component
		     * update.
		     *
		     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
		     *     return !equal(nextProps, this.props) ||
		     *       !equal(nextState, this.state) ||
		     *       !equal(nextContext, this.context);
		     *   }
		     *
		     * @param {object} nextProps
		     * @param {?object} nextState
		     * @param {?object} nextContext
		     * @return {boolean} True if the component should update.
		     * @optional
		     */
		    shouldComponentUpdate: 'DEFINE_ONCE',
	
		    /**
		     * Invoked when the component is about to update due to a transition from
		     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
		     * and `nextContext`.
		     *
		     * Use this as an opportunity to perform preparation before an update occurs.
		     *
		     * NOTE: You **cannot** use `this.setState()` in this method.
		     *
		     * @param {object} nextProps
		     * @param {?object} nextState
		     * @param {?object} nextContext
		     * @param {ReactReconcileTransaction} transaction
		     * @optional
		     */
		    componentWillUpdate: 'DEFINE_MANY',
	
		    /**
		     * Invoked when the component's DOM representation has been updated.
		     *
		     * Use this as an opportunity to operate on the DOM when the component has
		     * been updated.
		     *
		     * @param {object} prevProps
		     * @param {?object} prevState
		     * @param {?object} prevContext
		     * @param {DOMElement} rootNode DOM element representing the component.
		     * @optional
		     */
		    componentDidUpdate: 'DEFINE_MANY',
	
		    /**
		     * Invoked when the component is about to be removed from its parent and have
		     * its DOM representation destroyed.
		     *
		     * Use this as an opportunity to deallocate any external resources.
		     *
		     * NOTE: There is no `componentDidUnmount` since your component will have been
		     * destroyed by that point.
		     *
		     * @optional
		     */
		    componentWillUnmount: 'DEFINE_MANY',
	
		    /**
		     * Replacement for (deprecated) `componentWillMount`.
		     *
		     * @optional
		     */
		    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
		    /**
		     * Replacement for (deprecated) `componentWillReceiveProps`.
		     *
		     * @optional
		     */
		    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
		    /**
		     * Replacement for (deprecated) `componentWillUpdate`.
		     *
		     * @optional
		     */
		    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
		    // ==== Advanced methods ====
	
		    /**
		     * Updates the component's currently mounted DOM representation.
		     *
		     * By default, this implements React's rendering and reconciliation algorithm.
		     * Sophisticated clients may wish to override this.
		     *
		     * @param {ReactReconcileTransaction} transaction
		     * @internal
		     * @overridable
		     */
		    updateComponent: 'OVERRIDE_BASE'
		  };
	
		  /**
		   * Similar to ReactClassInterface but for static methods.
		   */
		  var ReactClassStaticInterface = {
		    /**
		     * This method is invoked after a component is instantiated and when it
		     * receives new props. Return an object to update state in response to
		     * prop changes. Return null to indicate no change to state.
		     *
		     * If an object is returned, its keys will be merged into the existing state.
		     *
		     * @return {object || null}
		     * @optional
		     */
		    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
		  };
	
		  /**
		   * Mapping from class specification keys to special processing functions.
		   *
		   * Although these are declared like instance properties in the specification
		   * when defining classes using `React.createClass`, they are actually static
		   * and are accessible on the constructor instead of the prototype. Despite
		   * being static, they must be defined outside of the "statics" key under
		   * which all other static methods are defined.
		   */
		  var RESERVED_SPEC_KEYS = {
		    displayName: function(Constructor, displayName) {
		      Constructor.displayName = displayName;
		    },
		    mixins: function(Constructor, mixins) {
		      if (mixins) {
		        for (var i = 0; i < mixins.length; i++) {
		          mixSpecIntoComponent(Constructor, mixins[i]);
		        }
		      }
		    },
		    childContextTypes: function(Constructor, childContextTypes) {
		      if (false) {
		        validateTypeDef(Constructor, childContextTypes, 'childContext');
		      }
		      Constructor.childContextTypes = _assign(
		        {},
		        Constructor.childContextTypes,
		        childContextTypes
		      );
		    },
		    contextTypes: function(Constructor, contextTypes) {
		      if (false) {
		        validateTypeDef(Constructor, contextTypes, 'context');
		      }
		      Constructor.contextTypes = _assign(
		        {},
		        Constructor.contextTypes,
		        contextTypes
		      );
		    },
		    /**
		     * Special case getDefaultProps which should move into statics but requires
		     * automatic merging.
		     */
		    getDefaultProps: function(Constructor, getDefaultProps) {
		      if (Constructor.getDefaultProps) {
		        Constructor.getDefaultProps = createMergedResultFunction(
		          Constructor.getDefaultProps,
		          getDefaultProps
		        );
		      } else {
		        Constructor.getDefaultProps = getDefaultProps;
		      }
		    },
		    propTypes: function(Constructor, propTypes) {
		      if (false) {
		        validateTypeDef(Constructor, propTypes, 'prop');
		      }
		      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
		    },
		    statics: function(Constructor, statics) {
		      mixStaticSpecIntoComponent(Constructor, statics);
		    },
		    autobind: function() {}
		  };
	
		  function validateTypeDef(Constructor, typeDef, location) {
		    for (var propName in typeDef) {
		      if (typeDef.hasOwnProperty(propName)) {
		        // use a warning instead of an _invariant so components
		        // don't show up in prod but only in __DEV__
		        if (false) {
		          warning(
		            typeof typeDef[propName] === 'function',
		            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
		              'React.PropTypes.',
		            Constructor.displayName || 'ReactClass',
		            ReactPropTypeLocationNames[location],
		            propName
		          );
		        }
		      }
		    }
		  }
	
		  function validateMethodOverride(isAlreadyDefined, name) {
		    var specPolicy = ReactClassInterface.hasOwnProperty(name)
		      ? ReactClassInterface[name]
		      : null;
	
		    // Disallow overriding of base class methods unless explicitly allowed.
		    if (ReactClassMixin.hasOwnProperty(name)) {
		      _invariant(
		        specPolicy === 'OVERRIDE_BASE',
		        'ReactClassInterface: You are attempting to override ' +
		          '`%s` from your class specification. Ensure that your method names ' +
		          'do not overlap with React methods.',
		        name
		      );
		    }
	
		    // Disallow defining methods more than once unless explicitly allowed.
		    if (isAlreadyDefined) {
		      _invariant(
		        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
		        'ReactClassInterface: You are attempting to define ' +
		          '`%s` on your component more than once. This conflict may be due ' +
		          'to a mixin.',
		        name
		      );
		    }
		  }
	
		  /**
		   * Mixin helper which handles policy validation and reserved
		   * specification keys when building React classes.
		   */
		  function mixSpecIntoComponent(Constructor, spec) {
		    if (!spec) {
		      if (false) {
		        var typeofSpec = typeof spec;
		        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
		        if (process.env.NODE_ENV !== 'production') {
		          warning(
		            isMixinValid,
		            "%s: You're attempting to include a mixin that is either null " +
		              'or not an object. Check the mixins included by the component, ' +
		              'as well as any mixins they include themselves. ' +
		              'Expected object but got %s.',
		            Constructor.displayName || 'ReactClass',
		            spec === null ? null : typeofSpec
		          );
		        }
		      }
	
		      return;
		    }
	
		    _invariant(
		      typeof spec !== 'function',
		      "ReactClass: You're attempting to " +
		        'use a component class or function as a mixin. Instead, just use a ' +
		        'regular object.'
		    );
		    _invariant(
		      !isValidElement(spec),
		      "ReactClass: You're attempting to " +
		        'use a component as a mixin. Instead, just use a regular object.'
		    );
	
		    var proto = Constructor.prototype;
		    var autoBindPairs = proto.__reactAutoBindPairs;
	
		    // By handling mixins before any other properties, we ensure the same
		    // chaining order is applied to methods with DEFINE_MANY policy, whether
		    // mixins are listed before or after these methods in the spec.
		    if (spec.hasOwnProperty(MIXINS_KEY)) {
		      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
		    }
	
		    for (var name in spec) {
		      if (!spec.hasOwnProperty(name)) {
		        continue;
		      }
	
		      if (name === MIXINS_KEY) {
		        // We have already handled mixins in a special case above.
		        continue;
		      }
	
		      var property = spec[name];
		      var isAlreadyDefined = proto.hasOwnProperty(name);
		      validateMethodOverride(isAlreadyDefined, name);
	
		      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
		        RESERVED_SPEC_KEYS[name](Constructor, property);
		      } else {
		        // Setup methods on prototype:
		        // The following member methods should not be automatically bound:
		        // 1. Expected ReactClass methods (in the "interface").
		        // 2. Overridden methods (that were mixed in).
		        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
		        var isFunction = typeof property === 'function';
		        var shouldAutoBind =
		          isFunction &&
		          !isReactClassMethod &&
		          !isAlreadyDefined &&
		          spec.autobind !== false;
	
		        if (shouldAutoBind) {
		          autoBindPairs.push(name, property);
		          proto[name] = property;
		        } else {
		          if (isAlreadyDefined) {
		            var specPolicy = ReactClassInterface[name];
	
		            // These cases should already be caught by validateMethodOverride.
		            _invariant(
		              isReactClassMethod &&
		                (specPolicy === 'DEFINE_MANY_MERGED' ||
		                  specPolicy === 'DEFINE_MANY'),
		              'ReactClass: Unexpected spec policy %s for key %s ' +
		                'when mixing in component specs.',
		              specPolicy,
		              name
		            );
	
		            // For methods which are defined more than once, call the existing
		            // methods before calling the new property, merging if appropriate.
		            if (specPolicy === 'DEFINE_MANY_MERGED') {
		              proto[name] = createMergedResultFunction(proto[name], property);
		            } else if (specPolicy === 'DEFINE_MANY') {
		              proto[name] = createChainedFunction(proto[name], property);
		            }
		          } else {
		            proto[name] = property;
		            if (false) {
		              // Add verbose displayName to the function, which helps when looking
		              // at profiling tools.
		              if (typeof property === 'function' && spec.displayName) {
		                proto[name].displayName = spec.displayName + '_' + name;
		              }
		            }
		          }
		        }
		      }
		    }
		  }
	
		  function mixStaticSpecIntoComponent(Constructor, statics) {
		    if (!statics) {
		      return;
		    }
	
		    for (var name in statics) {
		      var property = statics[name];
		      if (!statics.hasOwnProperty(name)) {
		        continue;
		      }
	
		      var isReserved = name in RESERVED_SPEC_KEYS;
		      _invariant(
		        !isReserved,
		        'ReactClass: You are attempting to define a reserved ' +
		          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
		          'as an instance property instead; it will still be accessible on the ' +
		          'constructor.',
		        name
		      );
	
		      var isAlreadyDefined = name in Constructor;
		      if (isAlreadyDefined) {
		        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
		          ? ReactClassStaticInterface[name]
		          : null;
	
		        _invariant(
		          specPolicy === 'DEFINE_MANY_MERGED',
		          'ReactClass: You are attempting to define ' +
		            '`%s` on your component more than once. This conflict may be ' +
		            'due to a mixin.',
		          name
		        );
	
		        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
		        return;
		      }
	
		      Constructor[name] = property;
		    }
		  }
	
		  /**
		   * Merge two objects, but throw if both contain the same key.
		   *
		   * @param {object} one The first object, which is mutated.
		   * @param {object} two The second object
		   * @return {object} one after it has been mutated to contain everything in two.
		   */
		  function mergeIntoWithNoDuplicateKeys(one, two) {
		    _invariant(
		      one && two && typeof one === 'object' && typeof two === 'object',
		      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
		    );
	
		    for (var key in two) {
		      if (two.hasOwnProperty(key)) {
		        _invariant(
		          one[key] === undefined,
		          'mergeIntoWithNoDuplicateKeys(): ' +
		            'Tried to merge two objects with the same key: `%s`. This conflict ' +
		            'may be due to a mixin; in particular, this may be caused by two ' +
		            'getInitialState() or getDefaultProps() methods returning objects ' +
		            'with clashing keys.',
		          key
		        );
		        one[key] = two[key];
		      }
		    }
		    return one;
		  }
	
		  /**
		   * Creates a function that invokes two functions and merges their return values.
		   *
		   * @param {function} one Function to invoke first.
		   * @param {function} two Function to invoke second.
		   * @return {function} Function that invokes the two argument functions.
		   * @private
		   */
		  function createMergedResultFunction(one, two) {
		    return function mergedResult() {
		      var a = one.apply(this, arguments);
		      var b = two.apply(this, arguments);
		      if (a == null) {
		        return b;
		      } else if (b == null) {
		        return a;
		      }
		      var c = {};
		      mergeIntoWithNoDuplicateKeys(c, a);
		      mergeIntoWithNoDuplicateKeys(c, b);
		      return c;
		    };
		  }
	
		  /**
		   * Creates a function that invokes two functions and ignores their return vales.
		   *
		   * @param {function} one Function to invoke first.
		   * @param {function} two Function to invoke second.
		   * @return {function} Function that invokes the two argument functions.
		   * @private
		   */
		  function createChainedFunction(one, two) {
		    return function chainedFunction() {
		      one.apply(this, arguments);
		      two.apply(this, arguments);
		    };
		  }
	
		  /**
		   * Binds a method to the component.
		   *
		   * @param {object} component Component whose method is going to be bound.
		   * @param {function} method Method to be bound.
		   * @return {function} The bound method.
		   */
		  function bindAutoBindMethod(component, method) {
		    var boundMethod = method.bind(component);
		    if (false) {
		      boundMethod.__reactBoundContext = component;
		      boundMethod.__reactBoundMethod = method;
		      boundMethod.__reactBoundArguments = null;
		      var componentName = component.constructor.displayName;
		      var _bind = boundMethod.bind;
		      boundMethod.bind = function(newThis) {
		        for (
		          var _len = arguments.length,
		            args = Array(_len > 1 ? _len - 1 : 0),
		            _key = 1;
		          _key < _len;
		          _key++
		        ) {
		          args[_key - 1] = arguments[_key];
		        }
	
		        // User is trying to bind() an autobound method; we effectively will
		        // ignore the value of "this" that the user is trying to use, so
		        // let's warn.
		        if (newThis !== component && newThis !== null) {
		          if (process.env.NODE_ENV !== 'production') {
		            warning(
		              false,
		              'bind(): React component methods may only be bound to the ' +
		                'component instance. See %s',
		              componentName
		            );
		          }
		        } else if (!args.length) {
		          if (process.env.NODE_ENV !== 'production') {
		            warning(
		              false,
		              'bind(): You are binding a component method to the component. ' +
		                'React does this for you automatically in a high-performance ' +
		                'way, so you can safely remove this call. See %s',
		              componentName
		            );
		          }
		          return boundMethod;
		        }
		        var reboundMethod = _bind.apply(boundMethod, arguments);
		        reboundMethod.__reactBoundContext = component;
		        reboundMethod.__reactBoundMethod = method;
		        reboundMethod.__reactBoundArguments = args;
		        return reboundMethod;
		      };
		    }
		    return boundMethod;
		  }
	
		  /**
		   * Binds all auto-bound methods in a component.
		   *
		   * @param {object} component Component whose method is going to be bound.
		   */
		  function bindAutoBindMethods(component) {
		    var pairs = component.__reactAutoBindPairs;
		    for (var i = 0; i < pairs.length; i += 2) {
		      var autoBindKey = pairs[i];
		      var method = pairs[i + 1];
		      component[autoBindKey] = bindAutoBindMethod(component, method);
		    }
		  }
	
		  var IsMountedPreMixin = {
		    componentDidMount: function() {
		      this.__isMounted = true;
		    }
		  };
	
		  var IsMountedPostMixin = {
		    componentWillUnmount: function() {
		      this.__isMounted = false;
		    }
		  };
	
		  /**
		   * Add more to the ReactClass base class. These are all legacy features and
		   * therefore not already part of the modern ReactComponent.
		   */
		  var ReactClassMixin = {
		    /**
		     * TODO: This will be deprecated because state should always keep a consistent
		     * type signature and the only use case for this, is to avoid that.
		     */
		    replaceState: function(newState, callback) {
		      this.updater.enqueueReplaceState(this, newState, callback);
		    },
	
		    /**
		     * Checks whether or not this composite component is mounted.
		     * @return {boolean} True if mounted, false otherwise.
		     * @protected
		     * @final
		     */
		    isMounted: function() {
		      if (false) {
		        warning(
		          this.__didWarnIsMounted,
		          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
		            'subscriptions and pending requests in componentWillUnmount to ' +
		            'prevent memory leaks.',
		          (this.constructor && this.constructor.displayName) ||
		            this.name ||
		            'Component'
		        );
		        this.__didWarnIsMounted = true;
		      }
		      return !!this.__isMounted;
		    }
		  };
	
		  var ReactClassComponent = function() {};
		  _assign(
		    ReactClassComponent.prototype,
		    ReactComponent.prototype,
		    ReactClassMixin
		  );
	
		  /**
		   * Creates a composite component class given a class specification.
		   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
		   *
		   * @param {object} spec Class specification (which must define `render`).
		   * @return {function} Component constructor function.
		   * @public
		   */
		  function createClass(spec) {
		    // To keep our warnings more understandable, we'll use a little hack here to
		    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
		    // unnecessarily identify a class without displayName as 'Constructor'.
		    var Constructor = identity(function(props, context, updater) {
		      // This constructor gets overridden by mocks. The argument is used
		      // by mocks to assert on what gets mounted.
	
		      if (false) {
		        warning(
		          this instanceof Constructor,
		          'Something is calling a React component directly. Use a factory or ' +
		            'JSX instead. See: https://fb.me/react-legacyfactory'
		        );
		      }
	
		      // Wire up auto-binding
		      if (this.__reactAutoBindPairs.length) {
		        bindAutoBindMethods(this);
		      }
	
		      this.props = props;
		      this.context = context;
		      this.refs = emptyObject;
		      this.updater = updater || ReactNoopUpdateQueue;
	
		      this.state = null;
	
		      // ReactClasses doesn't have constructors. Instead, they use the
		      // getInitialState and componentWillMount methods for initialization.
	
		      var initialState = this.getInitialState ? this.getInitialState() : null;
		      if (false) {
		        // We allow auto-mocks to proceed as if they're returning null.
		        if (
		          initialState === undefined &&
		          this.getInitialState._isMockFunction
		        ) {
		          // This is probably bad practice. Consider warning here and
		          // deprecating this convenience.
		          initialState = null;
		        }
		      }
		      _invariant(
		        typeof initialState === 'object' && !Array.isArray(initialState),
		        '%s.getInitialState(): must return an object or null',
		        Constructor.displayName || 'ReactCompositeComponent'
		      );
	
		      this.state = initialState;
		    });
		    Constructor.prototype = new ReactClassComponent();
		    Constructor.prototype.constructor = Constructor;
		    Constructor.prototype.__reactAutoBindPairs = [];
	
		    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
		    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
		    mixSpecIntoComponent(Constructor, spec);
		    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
		    // Initialize the defaultProps property after all mixins have been merged.
		    if (Constructor.getDefaultProps) {
		      Constructor.defaultProps = Constructor.getDefaultProps();
		    }
	
		    if (false) {
		      // This is a tag to indicate that the use of these method names is ok,
		      // since it's used with createClass. If it's not, then it's likely a
		      // mistake so we'll warn you to use the static property, property
		      // initializer or constructor respectively.
		      if (Constructor.getDefaultProps) {
		        Constructor.getDefaultProps.isReactClassApproved = {};
		      }
		      if (Constructor.prototype.getInitialState) {
		        Constructor.prototype.getInitialState.isReactClassApproved = {};
		      }
		    }
	
		    _invariant(
		      Constructor.prototype.render,
		      'createClass(...): Class specification must implement a `render` method.'
		    );
	
		    if (false) {
		      warning(
		        !Constructor.prototype.componentShouldUpdate,
		        '%s has a method called ' +
		          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
		          'The name is phrased as a question because the function is ' +
		          'expected to return a value.',
		        spec.displayName || 'A component'
		      );
		      warning(
		        !Constructor.prototype.componentWillRecieveProps,
		        '%s has a method called ' +
		          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
		        spec.displayName || 'A component'
		      );
		      warning(
		        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
		        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
		          'Did you mean UNSAFE_componentWillReceiveProps()?',
		        spec.displayName || 'A component'
		      );
		    }
	
		    // Reduce time spent doing lookups by setting these on the prototype.
		    for (var methodName in ReactClassInterface) {
		      if (!Constructor.prototype[methodName]) {
		        Constructor.prototype[methodName] = null;
		      }
		    }
	
		    return Constructor;
		  }
	
		  return createClass;
		}
	
		module.exports = factory;
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
		/*
		object-assign
		(c) Sindre Sorhus
		@license MIT
		*/
	
		'use strict';
		/* eslint-disable no-unused-vars */
		var getOwnPropertySymbols = Object.getOwnPropertySymbols;
		var hasOwnProperty = Object.prototype.hasOwnProperty;
		var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
		function toObject(val) {
			if (val === null || val === undefined) {
				throw new TypeError('Object.assign cannot be called with null or undefined');
			}
	
			return Object(val);
		}
	
		function shouldUseNative() {
			try {
				if (!Object.assign) {
					return false;
				}
	
				// Detect buggy property enumeration order in older V8 versions.
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=4118
				var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
				test1[5] = 'de';
				if (Object.getOwnPropertyNames(test1)[0] === '5') {
					return false;
				}
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test2 = {};
				for (var i = 0; i < 10; i++) {
					test2['_' + String.fromCharCode(i)] = i;
				}
				var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
					return test2[n];
				});
				if (order2.join('') !== '0123456789') {
					return false;
				}
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test3 = {};
				'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
					test3[letter] = letter;
				});
				if (Object.keys(Object.assign({}, test3)).join('') !==
						'abcdefghijklmnopqrst') {
					return false;
				}
	
				return true;
			} catch (err) {
				// We don't expect any of the above to throw, but better to be safe.
				return false;
			}
		}
	
		module.exports = shouldUseNative() ? Object.assign : function (target, source) {
			var from;
			var to = toObject(target);
			var symbols;
	
			for (var s = 1; s < arguments.length; s++) {
				from = Object(arguments[s]);
	
				for (var key in from) {
					if (hasOwnProperty.call(from, key)) {
						to[key] = from[key];
					}
				}
	
				if (getOwnPropertySymbols) {
					symbols = getOwnPropertySymbols(from);
					for (var i = 0; i < symbols.length; i++) {
						if (propIsEnumerable.call(from, symbols[i])) {
							to[symbols[i]] = from[symbols[i]];
						}
					}
				}
			}
	
			return to;
		};
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 */
	
		'use strict';
	
		var emptyObject = {};
	
		if (false) {
		  Object.freeze(emptyObject);
		}
	
		module.exports = emptyObject;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 */
	
		'use strict';
	
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
	
		var validateFormat = function validateFormat(format) {};
	
		if (false) {
		  validateFormat = function validateFormat(format) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  };
		}
	
		function invariant(condition, format, a, b, c, d, e, f) {
		  validateFormat(format);
	
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
	
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
	
		module.exports = invariant;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright (c) 2014-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(8);
	
		/**
		 * Similar to invariant but only logs a warning if the condition is not met.
		 * This can be used to log issues in development environments in critical
		 * paths. Removing the logging code for production environments will keep the
		 * same logic and follow the same code paths.
		 */
	
		var warning = emptyFunction;
	
		if (false) {
		  var printWarning = function printWarning(format) {
		    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		      args[_key - 1] = arguments[_key];
		    }
	
		    var argIndex = 0;
		    var message = 'Warning: ' + format.replace(/%s/g, function () {
		      return args[argIndex++];
		    });
		    if (typeof console !== 'undefined') {
		      console.error(message);
		    }
		    try {
		      // --- Welcome to debugging React ---
		      // This error was thrown as a convenience so that you can use this stack
		      // to find the callsite that caused this warning to fire.
		      throw new Error(message);
		    } catch (x) {}
		  };
	
		  warning = function warning(condition, format) {
		    if (format === undefined) {
		      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
		    }
	
		    if (format.indexOf('Failed Composite propType: ') === 0) {
		      return; // Ignore CompositeComponent proptype check.
		    }
	
		    if (!condition) {
		      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		        args[_key2 - 2] = arguments[_key2];
		      }
	
		      printWarning.apply(undefined, [format].concat(args));
		    }
		  };
		}
	
		module.exports = warning;
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 * 
		 */
	
		function makeEmptyFunction(arg) {
		  return function () {
		    return arg;
		  };
		}
	
		/**
		 * This function accepts and discards inputs; it has no side effects. This is
		 * primarily useful idiomatically for overridable function endpoints which
		 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
		 */
		var emptyFunction = function emptyFunction() {};
	
		emptyFunction.thatReturns = makeEmptyFunction;
		emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
		emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
		emptyFunction.thatReturnsNull = makeEmptyFunction(null);
		emptyFunction.thatReturnsThis = function () {
		  return this;
		};
		emptyFunction.thatReturnsArgument = function (arg) {
		  return arg;
		};
	
		module.exports = emptyFunction;
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var NumeralFormatter = function NumeralFormatter(numeralDecimalMark, numeralIntegerScale, numeralDecimalScale, numeralThousandsGroupStyle, numeralPositiveOnly, stripLeadingZeroes, prefix, signBeforePrefix, tailPrefix, delimiter) {
		    var owner = this;
	
		    owner.numeralDecimalMark = numeralDecimalMark || '.';
		    owner.numeralIntegerScale = numeralIntegerScale > 0 ? numeralIntegerScale : 0;
		    owner.numeralDecimalScale = numeralDecimalScale >= 0 ? numeralDecimalScale : 2;
		    owner.numeralThousandsGroupStyle = numeralThousandsGroupStyle || NumeralFormatter.groupStyle.thousand;
		    owner.numeralPositiveOnly = !!numeralPositiveOnly;
		    owner.stripLeadingZeroes = stripLeadingZeroes !== false;
		    owner.prefix = prefix || prefix === '' ? prefix : '';
		    owner.signBeforePrefix = !!signBeforePrefix;
		    owner.tailPrefix = !!tailPrefix;
		    owner.delimiter = delimiter || delimiter === '' ? delimiter : ',';
		    owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';
		};
	
		NumeralFormatter.groupStyle = {
		    thousand: 'thousand',
		    lakh: 'lakh',
		    wan: 'wan',
		    none: 'none'
		};
	
		NumeralFormatter.prototype = {
		    getRawValue: function getRawValue(value) {
		        return value.replace(this.delimiterRE, '').replace(this.numeralDecimalMark, '.');
		    },
	
		    format: function format(value) {
		        var owner = this,
		            parts,
		            partSign,
		            partSignAndPrefix,
		            partInteger,
		            partDecimal = '';
	
		        // strip alphabet letters
		        value = value.replace(/[A-Za-z]/g, '')
		        // replace the first decimal mark with reserved placeholder
		        .replace(owner.numeralDecimalMark, 'M')
	
		        // strip non numeric letters except minus and "M"
		        // this is to ensure prefix has been stripped
		        .replace(/[^\dM-]/g, '')
	
		        // replace the leading minus with reserved placeholder
		        .replace(/^\-/, 'N')
	
		        // strip the other minus sign (if present)
		        .replace(/\-/g, '')
	
		        // replace the minus sign (if present)
		        .replace('N', owner.numeralPositiveOnly ? '' : '-')
	
		        // replace decimal mark
		        .replace('M', owner.numeralDecimalMark);
	
		        // strip any leading zeros
		        if (owner.stripLeadingZeroes) {
		            value = value.replace(/^(-)?0+(?=\d)/, '$1');
		        }
	
		        partSign = value.slice(0, 1) === '-' ? '-' : '';
		        if (typeof owner.prefix != 'undefined') {
		            if (owner.signBeforePrefix) {
		                partSignAndPrefix = partSign + owner.prefix;
		            } else {
		                partSignAndPrefix = owner.prefix + partSign;
		            }
		        } else {
		            partSignAndPrefix = partSign;
		        }
	
		        partInteger = value;
	
		        if (value.indexOf(owner.numeralDecimalMark) >= 0) {
		            parts = value.split(owner.numeralDecimalMark);
		            partInteger = parts[0];
		            partDecimal = owner.numeralDecimalMark + parts[1].slice(0, owner.numeralDecimalScale);
		        }
	
		        if (partSign === '-') {
		            partInteger = partInteger.slice(1);
		        }
	
		        if (owner.numeralIntegerScale > 0) {
		            partInteger = partInteger.slice(0, owner.numeralIntegerScale);
		        }
	
		        switch (owner.numeralThousandsGroupStyle) {
		            case NumeralFormatter.groupStyle.lakh:
		                partInteger = partInteger.replace(/(\d)(?=(\d\d)+\d$)/g, '$1' + owner.delimiter);
	
		                break;
	
		            case NumeralFormatter.groupStyle.wan:
		                partInteger = partInteger.replace(/(\d)(?=(\d{4})+$)/g, '$1' + owner.delimiter);
	
		                break;
	
		            case NumeralFormatter.groupStyle.thousand:
		                partInteger = partInteger.replace(/(\d)(?=(\d{3})+$)/g, '$1' + owner.delimiter);
	
		                break;
		        }
	
		        if (owner.tailPrefix) {
		            return partSign + partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : '') + owner.prefix;
		        }
	
		        return partSignAndPrefix + partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : '');
		    }
		};
	
		module.exports = NumeralFormatter;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var DateFormatter = function DateFormatter(datePattern, dateMin, dateMax) {
		    var owner = this;
	
		    owner.date = [];
		    owner.blocks = [];
		    owner.datePattern = datePattern;
		    owner.dateMin = dateMin.split('-').reverse().map(function (x) {
		        return parseInt(x, 10);
		    });
		    if (owner.dateMin.length === 2) owner.dateMin.unshift(0);
	
		    owner.dateMax = dateMax.split('-').reverse().map(function (x) {
		        return parseInt(x, 10);
		    });
		    if (owner.dateMax.length === 2) owner.dateMax.unshift(0);
	
		    owner.initBlocks();
		};
	
		DateFormatter.prototype = {
		    initBlocks: function initBlocks() {
		        var owner = this;
		        owner.datePattern.forEach(function (value) {
		            if (value === 'Y') {
		                owner.blocks.push(4);
		            } else {
		                owner.blocks.push(2);
		            }
		        });
		    },
	
		    getISOFormatDate: function getISOFormatDate() {
		        var owner = this,
		            date = owner.date;
	
		        return date[2] ? date[2] + '-' + owner.addLeadingZero(date[1]) + '-' + owner.addLeadingZero(date[0]) : '';
		    },
	
		    getBlocks: function getBlocks() {
		        return this.blocks;
		    },
	
		    getValidatedDate: function getValidatedDate(value) {
		        var owner = this,
		            result = '';
	
		        value = value.replace(/[^\d]/g, '');
	
		        owner.blocks.forEach(function (length, index) {
		            if (value.length > 0) {
		                var sub = value.slice(0, length),
		                    sub0 = sub.slice(0, 1),
		                    rest = value.slice(length);
	
		                switch (owner.datePattern[index]) {
		                    case 'd':
		                        if (sub === '00') {
		                            sub = '01';
		                        } else if (parseInt(sub0, 10) > 3) {
		                            sub = '0' + sub0;
		                        } else if (parseInt(sub, 10) > 31) {
		                            sub = '31';
		                        }
	
		                        break;
	
		                    case 'm':
		                        if (sub === '00') {
		                            sub = '01';
		                        } else if (parseInt(sub0, 10) > 1) {
		                            sub = '0' + sub0;
		                        } else if (parseInt(sub, 10) > 12) {
		                            sub = '12';
		                        }
	
		                        break;
		                }
	
		                result += sub;
	
		                // update remaining string
		                value = rest;
		            }
		        });
	
		        return this.getFixedDateString(result);
		    },
	
		    getFixedDateString: function getFixedDateString(value) {
		        var owner = this,
		            datePattern = owner.datePattern,
		            date = [],
		            dayIndex = 0,
		            monthIndex = 0,
		            yearIndex = 0,
		            dayStartIndex = 0,
		            monthStartIndex = 0,
		            yearStartIndex = 0,
		            day,
		            month,
		            year,
		            fullYearDone = false;
	
		        // mm-dd || dd-mm
		        if (value.length === 4 && datePattern[0].toLowerCase() !== 'y' && datePattern[1].toLowerCase() !== 'y') {
		            dayStartIndex = datePattern[0] === 'd' ? 0 : 2;
		            monthStartIndex = 2 - dayStartIndex;
		            day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
		            month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
	
		            date = this.getFixedDate(day, month, 0);
		        }
	
		        // yyyy-mm-dd || yyyy-dd-mm || mm-dd-yyyy || dd-mm-yyyy || dd-yyyy-mm || mm-yyyy-dd
		        if (value.length === 8) {
		            datePattern.forEach(function (type, index) {
		                switch (type) {
		                    case 'd':
		                        dayIndex = index;
		                        break;
		                    case 'm':
		                        monthIndex = index;
		                        break;
		                    default:
		                        yearIndex = index;
		                        break;
		                }
		            });
	
		            yearStartIndex = yearIndex * 2;
		            dayStartIndex = dayIndex <= yearIndex ? dayIndex * 2 : dayIndex * 2 + 2;
		            monthStartIndex = monthIndex <= yearIndex ? monthIndex * 2 : monthIndex * 2 + 2;
	
		            day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
		            month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
		            year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);
	
		            fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;
	
		            date = this.getFixedDate(day, month, year);
		        }
	
		        // mm-yy || yy-mm
		        if (value.length === 4 && (datePattern[0] === 'y' || datePattern[1] === 'y')) {
		            monthStartIndex = datePattern[0] === 'm' ? 0 : 2;
		            yearStartIndex = 2 - monthStartIndex;
		            month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
		            year = parseInt(value.slice(yearStartIndex, yearStartIndex + 2), 10);
	
		            fullYearDone = value.slice(yearStartIndex, yearStartIndex + 2).length === 2;
	
		            date = [0, month, year];
		        }
	
		        // mm-yyyy || yyyy-mm
		        if (value.length === 6 && (datePattern[0] === 'Y' || datePattern[1] === 'Y')) {
		            monthStartIndex = datePattern[0] === 'm' ? 0 : 4;
		            yearStartIndex = 2 - 0.5 * monthStartIndex;
		            month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
		            year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);
	
		            fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;
	
		            date = [0, month, year];
		        }
	
		        date = owner.getRangeFixedDate(date);
		        owner.date = date;
	
		        var result = date.length === 0 ? value : datePattern.reduce(function (previous, current) {
		            switch (current) {
		                case 'd':
		                    return previous + (date[0] === 0 ? '' : owner.addLeadingZero(date[0]));
		                case 'm':
		                    return previous + (date[1] === 0 ? '' : owner.addLeadingZero(date[1]));
		                case 'y':
		                    return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2], false) : '');
		                case 'Y':
		                    return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2], true) : '');
		            }
		        }, '');
	
		        return result;
		    },
	
		    getRangeFixedDate: function getRangeFixedDate(date) {
		        var owner = this,
		            datePattern = owner.datePattern,
		            dateMin = owner.dateMin || [],
		            dateMax = owner.dateMax || [];
	
		        if (!date.length || dateMin.length < 3 && dateMax.length < 3) return date;
	
		        if (datePattern.find(function (x) {
		            return x.toLowerCase() === 'y';
		        }) && date[2] === 0) return date;
	
		        if (dateMax.length && (dateMax[2] < date[2] || dateMax[2] === date[2] && (dateMax[1] < date[1] || dateMax[1] === date[1] && dateMax[0] < date[0]))) return dateMax;
	
		        if (dateMin.length && (dateMin[2] > date[2] || dateMin[2] === date[2] && (dateMin[1] > date[1] || dateMin[1] === date[1] && dateMin[0] > date[0]))) return dateMin;
	
		        return date;
		    },
	
		    getFixedDate: function getFixedDate(day, month, year) {
		        day = Math.min(day, 31);
		        month = Math.min(month, 12);
		        year = parseInt(year || 0, 10);
	
		        if (month < 7 && month % 2 === 0 || month > 8 && month % 2 === 1) {
		            day = Math.min(day, month === 2 ? this.isLeapYear(year) ? 29 : 28 : 30);
		        }
	
		        return [day, month, year];
		    },
	
		    isLeapYear: function isLeapYear(year) {
		        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
		    },
	
		    addLeadingZero: function addLeadingZero(number) {
		        return (number < 10 ? '0' : '') + number;
		    },
	
		    addLeadingZeroForYear: function addLeadingZeroForYear(number, fullYearMode) {
		        if (fullYearMode) {
		            return (number < 10 ? '000' : number < 100 ? '00' : number < 1000 ? '0' : '') + number;
		        }
	
		        return (number < 10 ? '0' : '') + number;
		    }
		};
	
		module.exports = DateFormatter;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var TimeFormatter = function TimeFormatter(timePattern, timeFormat) {
		    var owner = this;
	
		    owner.time = [];
		    owner.blocks = [];
		    owner.timePattern = timePattern;
		    owner.timeFormat = timeFormat;
		    owner.initBlocks();
		};
	
		TimeFormatter.prototype = {
		    initBlocks: function initBlocks() {
		        var owner = this;
		        owner.timePattern.forEach(function () {
		            owner.blocks.push(2);
		        });
		    },
	
		    getISOFormatTime: function getISOFormatTime() {
		        var owner = this,
		            time = owner.time;
	
		        return time[2] ? owner.addLeadingZero(time[0]) + ':' + owner.addLeadingZero(time[1]) + ':' + owner.addLeadingZero(time[2]) : '';
		    },
	
		    getBlocks: function getBlocks() {
		        return this.blocks;
		    },
	
		    getTimeFormatOptions: function getTimeFormatOptions() {
		        var owner = this;
		        if (String(owner.timeFormat) === '12') {
		            return {
		                maxHourFirstDigit: 1,
		                maxHours: 12,
		                maxMinutesFirstDigit: 5,
		                maxMinutes: 60
		            };
		        }
	
		        return {
		            maxHourFirstDigit: 2,
		            maxHours: 23,
		            maxMinutesFirstDigit: 5,
		            maxMinutes: 60
		        };
		    },
	
		    getValidatedTime: function getValidatedTime(value) {
		        var owner = this,
		            result = '';
	
		        value = value.replace(/[^\d]/g, '');
	
		        var timeFormatOptions = owner.getTimeFormatOptions();
	
		        owner.blocks.forEach(function (length, index) {
		            if (value.length > 0) {
		                var sub = value.slice(0, length),
		                    sub0 = sub.slice(0, 1),
		                    rest = value.slice(length);
	
		                switch (owner.timePattern[index]) {
	
		                    case 'h':
		                        if (parseInt(sub0, 10) > timeFormatOptions.maxHourFirstDigit) {
		                            sub = '0' + sub0;
		                        } else if (parseInt(sub, 10) > timeFormatOptions.maxHours) {
		                            sub = timeFormatOptions.maxHours + '';
		                        }
	
		                        break;
	
		                    case 'm':
		                    case 's':
		                        if (parseInt(sub0, 10) > timeFormatOptions.maxMinutesFirstDigit) {
		                            sub = '0' + sub0;
		                        } else if (parseInt(sub, 10) > timeFormatOptions.maxMinutes) {
		                            sub = timeFormatOptions.maxMinutes + '';
		                        }
		                        break;
		                }
	
		                result += sub;
	
		                // update remaining string
		                value = rest;
		            }
		        });
	
		        return this.getFixedTimeString(result);
		    },
	
		    getFixedTimeString: function getFixedTimeString(value) {
		        var owner = this,
		            timePattern = owner.timePattern,
		            time = [],
		            secondIndex = 0,
		            minuteIndex = 0,
		            hourIndex = 0,
		            secondStartIndex = 0,
		            minuteStartIndex = 0,
		            hourStartIndex = 0,
		            second,
		            minute,
		            hour;
	
		        if (value.length === 6) {
		            timePattern.forEach(function (type, index) {
		                switch (type) {
		                    case 's':
		                        secondIndex = index * 2;
		                        break;
		                    case 'm':
		                        minuteIndex = index * 2;
		                        break;
		                    case 'h':
		                        hourIndex = index * 2;
		                        break;
		                }
		            });
	
		            hourStartIndex = hourIndex;
		            minuteStartIndex = minuteIndex;
		            secondStartIndex = secondIndex;
	
		            second = parseInt(value.slice(secondStartIndex, secondStartIndex + 2), 10);
		            minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
		            hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);
	
		            time = this.getFixedTime(hour, minute, second);
		        }
	
		        if (value.length === 4 && owner.timePattern.indexOf('s') < 0) {
		            timePattern.forEach(function (type, index) {
		                switch (type) {
		                    case 'm':
		                        minuteIndex = index * 2;
		                        break;
		                    case 'h':
		                        hourIndex = index * 2;
		                        break;
		                }
		            });
	
		            hourStartIndex = hourIndex;
		            minuteStartIndex = minuteIndex;
	
		            second = 0;
		            minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
		            hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);
	
		            time = this.getFixedTime(hour, minute, second);
		        }
	
		        owner.time = time;
	
		        return time.length === 0 ? value : timePattern.reduce(function (previous, current) {
		            switch (current) {
		                case 's':
		                    return previous + owner.addLeadingZero(time[2]);
		                case 'm':
		                    return previous + owner.addLeadingZero(time[1]);
		                case 'h':
		                    return previous + owner.addLeadingZero(time[0]);
		            }
		        }, '');
		    },
	
		    getFixedTime: function getFixedTime(hour, minute, second) {
		        second = Math.min(parseInt(second || 0, 10), 60);
		        minute = Math.min(minute, 60);
		        hour = Math.min(hour, 60);
	
		        return [hour, minute, second];
		    },
	
		    addLeadingZero: function addLeadingZero(number) {
		        return (number < 10 ? '0' : '') + number;
		    }
		};
	
		module.exports = TimeFormatter;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var PhoneFormatter = function PhoneFormatter(formatter, delimiter) {
		    var owner = this;
	
		    owner.delimiter = delimiter || delimiter === '' ? delimiter : ' ';
		    owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';
	
		    owner.formatter = formatter;
		};
	
		PhoneFormatter.prototype = {
		    setFormatter: function setFormatter(formatter) {
		        this.formatter = formatter;
		    },
	
		    format: function format(phoneNumber) {
		        var owner = this;
	
		        owner.formatter.clear();
	
		        // only keep number and +
		        phoneNumber = phoneNumber.replace(/[^\d+]/g, '');
	
		        // strip non-leading +
		        phoneNumber = phoneNumber.replace(/^\+/, 'B').replace(/\+/g, '').replace('B', '+');
	
		        // strip delimiter
		        phoneNumber = phoneNumber.replace(owner.delimiterRE, '');
	
		        var result = '',
		            current,
		            validated = false;
	
		        for (var i = 0, iMax = phoneNumber.length; i < iMax; i++) {
		            current = owner.formatter.inputDigit(phoneNumber.charAt(i));
	
		            // has ()- or space inside
		            if (/[\s()-]/g.test(current)) {
		                result = current;
	
		                validated = true;
		            } else {
		                if (!validated) {
		                    result = current;
		                }
		                // else: over length input
		                // it turns to invalid number again
		            }
		        }
	
		        // strip ()
		        // e.g. US: 7161234567 returns (716) 123-4567
		        result = result.replace(/[()]/g, '');
		        // replace library delimiter with user customized delimiter
		        result = result.replace(/[\s-]/g, owner.delimiter);
	
		        return result;
		    }
		};
	
		module.exports = PhoneFormatter;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var CreditCardDetector = {
		    blocks: {
		        uatp: [4, 5, 6],
		        amex: [4, 6, 5],
		        diners: [4, 6, 4],
		        discover: [4, 4, 4, 4],
		        mastercard: [4, 4, 4, 4],
		        dankort: [4, 4, 4, 4],
		        instapayment: [4, 4, 4, 4],
		        jcb15: [4, 6, 5],
		        jcb: [4, 4, 4, 4],
		        maestro: [4, 4, 4, 4],
		        visa: [4, 4, 4, 4],
		        mir: [4, 4, 4, 4],
		        unionPay: [4, 4, 4, 4],
		        general: [4, 4, 4, 4]
		    },
	
		    re: {
		        // starts with 1; 15 digits, not starts with 1800 (jcb card)
		        uatp: /^(?!1800)1\d{0,14}/,
	
		        // starts with 34/37; 15 digits
		        amex: /^3[47]\d{0,13}/,
	
		        // starts with 6011/65/644-649; 16 digits
		        discover: /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/,
	
		        // starts with 300-305/309 or 36/38/39; 14 digits
		        diners: /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/,
	
		        // starts with 51-55/2221–2720; 16 digits
		        mastercard: /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/,
	
		        // starts with 5019/4175/4571; 16 digits
		        dankort: /^(5019|4175|4571)\d{0,12}/,
	
		        // starts with 637-639; 16 digits
		        instapayment: /^63[7-9]\d{0,13}/,
	
		        // starts with 2131/1800; 15 digits
		        jcb15: /^(?:2131|1800)\d{0,11}/,
	
		        // starts with 2131/1800/35; 16 digits
		        jcb: /^(?:35\d{0,2})\d{0,12}/,
	
		        // starts with 50/56-58/6304/67; 16 digits
		        maestro: /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/,
	
		        // starts with 22; 16 digits
		        mir: /^220[0-4]\d{0,12}/,
	
		        // starts with 4; 16 digits
		        visa: /^4\d{0,15}/,
	
		        // starts with 62/81; 16 digits
		        unionPay: /^(62|81)\d{0,14}/
		    },
	
		    getStrictBlocks: function getStrictBlocks(block) {
		        var total = block.reduce(function (prev, current) {
		            return prev + current;
		        }, 0);
	
		        return block.concat(19 - total);
		    },
	
		    getInfo: function getInfo(value, strictMode) {
		        var blocks = CreditCardDetector.blocks,
		            re = CreditCardDetector.re;
	
		        // Some credit card can have up to 19 digits number.
		        // Set strictMode to true will remove the 16 max-length restrain,
		        // however, I never found any website validate card number like
		        // this, hence probably you don't want to enable this option.
		        strictMode = !!strictMode;
	
		        for (var key in re) {
		            if (re[key].test(value)) {
		                var matchedBlocks = blocks[key];
		                return {
		                    type: key,
		                    blocks: strictMode ? this.getStrictBlocks(matchedBlocks) : matchedBlocks
		                };
		            }
		        }
	
		        return {
		            type: 'unknown',
		            blocks: strictMode ? this.getStrictBlocks(blocks.general) : blocks.general
		        };
		    }
		};
	
		module.exports = CreditCardDetector;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var Util = {
		    noop: function noop() {},
	
		    strip: function strip(value, re) {
		        return value.replace(re, '');
		    },
	
		    getPostDelimiter: function getPostDelimiter(value, delimiter, delimiters) {
		        // single delimiter
		        if (delimiters.length === 0) {
		            return value.slice(-delimiter.length) === delimiter ? delimiter : '';
		        }
	
		        // multiple delimiters
		        var matchedDelimiter = '';
		        delimiters.forEach(function (current) {
		            if (value.slice(-current.length) === current) {
		                matchedDelimiter = current;
		            }
		        });
	
		        return matchedDelimiter;
		    },
	
		    getDelimiterREByDelimiter: function getDelimiterREByDelimiter(delimiter) {
		        return new RegExp(delimiter.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'), 'g');
		    },
	
		    getNextCursorPosition: function getNextCursorPosition(prevPos, oldValue, newValue, delimiter, delimiters) {
		        // If cursor was at the end of value, just place it back.
		        // Because new value could contain additional chars.
		        if (oldValue.length === prevPos) {
		            return newValue.length;
		        }
	
		        return prevPos + this.getPositionOffset(prevPos, oldValue, newValue, delimiter, delimiters);
		    },
	
		    getPositionOffset: function getPositionOffset(prevPos, oldValue, newValue, delimiter, delimiters) {
		        var oldRawValue, newRawValue, lengthOffset;
	
		        oldRawValue = this.stripDelimiters(oldValue.slice(0, prevPos), delimiter, delimiters);
		        newRawValue = this.stripDelimiters(newValue.slice(0, prevPos), delimiter, delimiters);
		        lengthOffset = oldRawValue.length - newRawValue.length;
	
		        return lengthOffset !== 0 ? lengthOffset / Math.abs(lengthOffset) : 0;
		    },
	
		    stripDelimiters: function stripDelimiters(value, delimiter, delimiters) {
		        var owner = this;
	
		        // single delimiter
		        if (delimiters.length === 0) {
		            var delimiterRE = delimiter ? owner.getDelimiterREByDelimiter(delimiter) : '';
	
		            return value.replace(delimiterRE, '');
		        }
	
		        // multiple delimiters
		        delimiters.forEach(function (current) {
		            current.split('').forEach(function (letter) {
		                value = value.replace(owner.getDelimiterREByDelimiter(letter), '');
		            });
		        });
	
		        return value;
		    },
	
		    headStr: function headStr(str, length) {
		        return str.slice(0, length);
		    },
	
		    getMaxLength: function getMaxLength(blocks) {
		        return blocks.reduce(function (previous, current) {
		            return previous + current;
		        }, 0);
		    },
	
		    // strip prefix
		    // Before type  |   After type    |     Return value
		    // PEFIX-...    |   PEFIX-...     |     ''
		    // PREFIX-123   |   PEFIX-123     |     123
		    // PREFIX-123   |   PREFIX-23     |     23
		    // PREFIX-123   |   PREFIX-1234   |     1234
		    getPrefixStrippedValue: function getPrefixStrippedValue(value, prefix, prefixLength, prevResult, delimiter, delimiters, noImmediatePrefix, tailPrefix, signBeforePrefix) {
		        // No prefix
		        if (prefixLength === 0) {
		            return value;
		        }
	
		        // Value is prefix
		        if (value === prefix && value !== '') {
		            return '';
		        }
	
		        if (signBeforePrefix && value.slice(0, 1) == '-') {
		            var prev = prevResult.slice(0, 1) == '-' ? prevResult.slice(1) : prevResult;
		            return '-' + this.getPrefixStrippedValue(value.slice(1), prefix, prefixLength, prev, delimiter, delimiters, noImmediatePrefix, tailPrefix, signBeforePrefix);
		        }
	
		        // Pre result prefix string does not match pre-defined prefix
		        if (prevResult.slice(0, prefixLength) !== prefix && !tailPrefix) {
		            // Check if the first time user entered something
		            if (noImmediatePrefix && !prevResult && value) return value;
		            return '';
		        } else if (prevResult.slice(-prefixLength) !== prefix && tailPrefix) {
		            // Check if the first time user entered something
		            if (noImmediatePrefix && !prevResult && value) return value;
		            return '';
		        }
	
		        var prevValue = this.stripDelimiters(prevResult, delimiter, delimiters);
	
		        // New value has issue, someone typed in between prefix letters
		        // Revert to pre value
		        if (value.slice(0, prefixLength) !== prefix && !tailPrefix) {
		            return prevValue.slice(prefixLength);
		        } else if (value.slice(-prefixLength) !== prefix && tailPrefix) {
		            return prevValue.slice(0, -prefixLength - 1);
		        }
	
		        // No issue, strip prefix for new value
		        return tailPrefix ? value.slice(0, -prefixLength) : value.slice(prefixLength);
		    },
	
		    getFirstDiffIndex: function getFirstDiffIndex(prev, current) {
		        var index = 0;
	
		        while (prev.charAt(index) === current.charAt(index)) {
		            if (prev.charAt(index++) === '') {
		                return -1;
		            }
		        }
	
		        return index;
		    },
	
		    getFormattedValue: function getFormattedValue(value, blocks, blocksLength, delimiter, delimiters, delimiterLazyShow) {
		        var result = '',
		            multipleDelimiters = delimiters.length > 0,
		            currentDelimiter = '';
	
		        // no options, normal input
		        if (blocksLength === 0) {
		            return value;
		        }
	
		        blocks.forEach(function (length, index) {
		            if (value.length > 0) {
		                var sub = value.slice(0, length),
		                    rest = value.slice(length);
	
		                if (multipleDelimiters) {
		                    currentDelimiter = delimiters[delimiterLazyShow ? index - 1 : index] || currentDelimiter;
		                } else {
		                    currentDelimiter = delimiter;
		                }
	
		                if (delimiterLazyShow) {
		                    if (index > 0) {
		                        result += currentDelimiter;
		                    }
	
		                    result += sub;
		                } else {
		                    result += sub;
	
		                    if (sub.length === length && index < blocksLength - 1) {
		                        result += currentDelimiter;
		                    }
		                }
	
		                // update remaining string
		                value = rest;
		            }
		        });
	
		        return result;
		    },
	
		    // move cursor to the end
		    // the first time user focuses on an input with prefix
		    fixPrefixCursor: function fixPrefixCursor(el, prefix, delimiter, delimiters) {
		        if (!el) {
		            return;
		        }
	
		        var val = el.value,
		            appendix = delimiter || delimiters[0] || ' ';
	
		        if (!el.setSelectionRange || !prefix || prefix.length + appendix.length <= val.length) {
		            return;
		        }
	
		        var len = val.length * 2;
	
		        // set timeout to avoid blink
		        setTimeout(function () {
		            el.setSelectionRange(len, len);
		        }, 1);
		    },
	
		    // Check if input field is fully selected
		    checkFullSelection: function checkFullSelection(value) {
		        try {
		            var selection = window.getSelection() || document.getSelection() || {};
		            return selection.toString().length === value.length;
		        } catch (ex) {
		            // Ignore
		        }
	
		        return false;
		    },
	
		    setSelection: function setSelection(element, position, doc) {
		        if (element !== this.getActiveElement(doc)) {
		            return;
		        }
	
		        // cursor is already in the end
		        if (element && element.value.length <= position) {
		            return;
		        }
	
		        if (element.createTextRange) {
		            var range = element.createTextRange();
	
		            range.move('character', position);
		            range.select();
		        } else {
		            try {
		                element.setSelectionRange(position, position);
		            } catch (e) {
		                // eslint-disable-next-line
		                console.warn('The input element type does not support selection');
		            }
		        }
		    },
	
		    getActiveElement: function getActiveElement(parent) {
		        var activeElement = parent.activeElement;
		        if (activeElement && activeElement.shadowRoot) {
		            return this.getActiveElement(activeElement.shadowRoot);
		        }
		        return activeElement;
		    },
	
		    isAndroid: function isAndroid() {
		        return navigator && /android/i.test(navigator.userAgent);
		    },
	
		    // On Android chrome, the keyup and keydown events
		    // always return key code 229 as a composition that
		    // buffers the user’s keystrokes
		    // see https://github.com/nosir/cleave.js/issues/147
		    isAndroidBackspaceKeydown: function isAndroidBackspaceKeydown(lastInputValue, currentInputValue) {
		        if (!this.isAndroid() || !lastInputValue || !currentInputValue) {
		            return false;
		        }
	
		        return currentInputValue === lastInputValue.slice(0, -1);
		    }
		};
	
		module.exports = Util;
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		/**
		 * Props Assignment
		 *
		 * Separate this, so react module can share the usage
		 */
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var DefaultProperties = {
		    // Maybe change to object-assign
		    // for now just keep it as simple
		    assign: function assign(target, opts) {
		        target = target || {};
		        opts = opts || {};
	
		        // credit card
		        target.creditCard = !!opts.creditCard;
		        target.creditCardStrictMode = !!opts.creditCardStrictMode;
		        target.creditCardType = '';
		        target.onCreditCardTypeChanged = opts.onCreditCardTypeChanged || function () {};
	
		        // phone
		        target.phone = !!opts.phone;
		        target.phoneRegionCode = opts.phoneRegionCode || 'AU';
		        target.phoneFormatter = {};
	
		        // time
		        target.time = !!opts.time;
		        target.timePattern = opts.timePattern || ['h', 'm', 's'];
		        target.timeFormat = opts.timeFormat || '24';
		        target.timeFormatter = {};
	
		        // date
		        target.date = !!opts.date;
		        target.datePattern = opts.datePattern || ['d', 'm', 'Y'];
		        target.dateMin = opts.dateMin || '';
		        target.dateMax = opts.dateMax || '';
		        target.dateFormatter = {};
	
		        // numeral
		        target.numeral = !!opts.numeral;
		        target.numeralIntegerScale = opts.numeralIntegerScale > 0 ? opts.numeralIntegerScale : 0;
		        target.numeralDecimalScale = opts.numeralDecimalScale >= 0 ? opts.numeralDecimalScale : 2;
		        target.numeralDecimalMark = opts.numeralDecimalMark || '.';
		        target.numeralThousandsGroupStyle = opts.numeralThousandsGroupStyle || 'thousand';
		        target.numeralPositiveOnly = !!opts.numeralPositiveOnly;
		        target.stripLeadingZeroes = opts.stripLeadingZeroes !== false;
		        target.signBeforePrefix = !!opts.signBeforePrefix;
		        target.tailPrefix = !!opts.tailPrefix;
	
		        // others
		        target.swapHiddenInput = !!opts.swapHiddenInput;
	
		        target.numericOnly = target.creditCard || target.date || !!opts.numericOnly;
	
		        target.uppercase = !!opts.uppercase;
		        target.lowercase = !!opts.lowercase;
	
		        target.prefix = target.creditCard || target.date ? '' : opts.prefix || '';
		        target.noImmediatePrefix = !!opts.noImmediatePrefix;
		        target.prefixLength = target.prefix.length;
		        target.rawValueTrimPrefix = !!opts.rawValueTrimPrefix;
		        target.copyDelimiter = !!opts.copyDelimiter;
	
		        target.initValue = opts.initValue !== undefined && opts.initValue !== null ? opts.initValue.toString() : '';
	
		        target.delimiter = opts.delimiter || opts.delimiter === '' ? opts.delimiter : opts.date ? '/' : opts.time ? ':' : opts.numeral ? ',' : opts.phone ? ' ' : ' ';
		        target.delimiterLength = target.delimiter.length;
		        target.delimiterLazyShow = !!opts.delimiterLazyShow;
		        target.delimiters = opts.delimiters || [];
	
		        target.blocks = opts.blocks || [];
		        target.blocksLength = target.blocks.length;
	
		        target.root = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' && global ? global : window;
		        target.document = opts.document || target.root.document;
	
		        target.maxLength = 0;
	
		        target.backspace = false;
		        target.result = '';
	
		        target.onValueChanged = opts.onValueChanged || function () {};
	
		        return target;
		    }
		};
	
		module.exports = DefaultProperties;
	
	/***/ })
	/******/ ])
	});
	;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1235);


/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	
	  // Remove event specific arrays for event types that no
	  // one is subscribed for to avoid memory leak.
	  if (callbacks.length === 0) {
	    delete this._callbacks['$' + event];
	  }
	
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	
	  var args = new Array(arguments.length - 1)
	    , callbacks = this._callbacks['$' + event];
	
	  for (var i = 1; i < arguments.length; i++) {
	    args[i - 1] = arguments[i];
	  }
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1335);
	module.exports = __webpack_require__(69).Array.includes;


/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1329);
	module.exports = __webpack_require__(69).Math.log2;


/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1330);
	module.exports = __webpack_require__(69).Number.isInteger;


/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1331);
	module.exports = __webpack_require__(69).Number.isNaN;


/***/ },
/* 1242 */
[2085, 1336, 69],
/* 1243 */
[2086, 548, 1333, 549, 1332, 1337, 1338, 69],
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(548);
	__webpack_require__(549);
	__webpack_require__(1334);
	__webpack_require__(1340);
	__webpack_require__(1339);
	module.exports = __webpack_require__(69).WeakMap;


/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(201);
	__webpack_require__(1282);
	module.exports = __webpack_require__(43).Array.from;


/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(253);
	__webpack_require__(201);
	module.exports = __webpack_require__(1280);


/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(253);
	__webpack_require__(201);
	module.exports = __webpack_require__(1281);


/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1284);
	module.exports = __webpack_require__(43).Object.assign;


/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1285);
	var $Object = __webpack_require__(43).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1286);
	var $Object = __webpack_require__(43).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1292);
	module.exports = __webpack_require__(43).Object.entries;


/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1287);
	module.exports = __webpack_require__(43).Object.getPrototypeOf;


/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1288);
	module.exports = __webpack_require__(43).Object.keys;


/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1289);
	module.exports = __webpack_require__(43).Object.setPrototypeOf;


/***/ },
/* 1255 */
[2085, 1293, 43],
/* 1256 */
[2086, 534, 201, 253, 1290, 1294, 1295, 43],
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1291);
	__webpack_require__(534);
	__webpack_require__(1296);
	__webpack_require__(1297);
	module.exports = __webpack_require__(43).Symbol;


/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(201);
	__webpack_require__(253);
	module.exports = __webpack_require__(350).f('iterator');


/***/ },
/* 1259 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 1260 */
352,
/* 1261 */
[2088, 133, 347, 1278],
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(112);
	var createDesc = __webpack_require__(200);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(160);
	var gOPS = __webpack_require__(343);
	var pIE = __webpack_require__(199);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 1264 */
[2093, 157, 520, 519, 92, 347, 351],
/* 1265 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 1266 */
[2099, 197],
/* 1267 */
[2101, 342, 200, 251, 132, 64],
/* 1268 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 1269 */
[2104, 252, 122, 131, 112, 158],
/* 1270 */
[2105, 63, 533, 197],
/* 1271 */
[2107, 93, 160, 343, 199, 161, 518, 158],
/* 1272 */
[2110, 112, 92, 160, 93],
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(133);
	var gOPN = __webpack_require__(524).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(132);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ },
/* 1275 */
[2117, 122, 92, 157, 523],
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(63);
	var core = __webpack_require__(43);
	var dP = __webpack_require__(112);
	var DESCRIPTORS = __webpack_require__(93);
	var SPECIES = __webpack_require__(64)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 1277 */
[2122, 346, 338],
/* 1278 */
[2124, 346],
/* 1279 */
[2129, 63],
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(92);
	var get = __webpack_require__(351);
	module.exports = __webpack_require__(43).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(337);
	var ITERATOR = __webpack_require__(64)('iterator');
	var Iterators = __webpack_require__(159);
	module.exports = __webpack_require__(43).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(157);
	var $export = __webpack_require__(68);
	var toObject = __webpack_require__(161);
	var call = __webpack_require__(520);
	var isArrayIter = __webpack_require__(519);
	var toLength = __webpack_require__(347);
	var createProperty = __webpack_require__(1262);
	var getIterFn = __webpack_require__(351);
	
	$export($export.S + $export.F * !__webpack_require__(522)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 1283 */
[2132, 1259, 1268, 159, 133, 521],
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(68);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1271) });


/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(68);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(342) });


/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(68);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(93), 'Object', { defineProperty: __webpack_require__(112).f });


/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(161);
	var $getPrototypeOf = __webpack_require__(525);
	
	__webpack_require__(527)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(161);
	var $keys = __webpack_require__(160);
	
	__webpack_require__(527)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(68);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1275).set });


/***/ },
/* 1290 */
[2133, 198, 63, 157, 337, 68, 122, 250, 1260, 1264, 532, 533, 1270, 341, 529, 1279, 530, 64, 1274, 251, 1276, 43, 522],
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(63);
	var has = __webpack_require__(131);
	var DESCRIPTORS = __webpack_require__(93);
	var $export = __webpack_require__(68);
	var redefine = __webpack_require__(531);
	var META = __webpack_require__(1269).KEY;
	var $fails = __webpack_require__(158);
	var shared = __webpack_require__(345);
	var setToStringTag = __webpack_require__(251);
	var uid = __webpack_require__(252);
	var wks = __webpack_require__(64);
	var wksExt = __webpack_require__(350);
	var wksDefine = __webpack_require__(349);
	var enumKeys = __webpack_require__(1263);
	var isArray = __webpack_require__(1266);
	var anObject = __webpack_require__(92);
	var isObject = __webpack_require__(122);
	var toObject = __webpack_require__(161);
	var toIObject = __webpack_require__(133);
	var toPrimitive = __webpack_require__(348);
	var createDesc = __webpack_require__(200);
	var _create = __webpack_require__(342);
	var gOPNExt = __webpack_require__(1273);
	var $GOPD = __webpack_require__(523);
	var $GOPS = __webpack_require__(343);
	var $DP = __webpack_require__(112);
	var $keys = __webpack_require__(160);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(524).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(199).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(198)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(132)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(68);
	var $entries = __webpack_require__(528)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 1293 */
[2135, 68, 528],
/* 1294 */
[2136, 68, 43, 63, 532, 530],
/* 1295 */
[2137, 68, 341, 529],
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(349)('asyncIterator');


/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(349)('observable');


/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(65);
	var isArray = __webpack_require__(1306);
	var SPECIES = __webpack_require__(66)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(1298);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(362);
	var getWeak = __webpack_require__(358).getWeak;
	var anObject = __webpack_require__(113);
	var isObject = __webpack_require__(65);
	var anInstance = __webpack_require__(352);
	var forOf = __webpack_require__(254);
	var createArrayMethod = __webpack_require__(537);
	var $has = __webpack_require__(135);
	var validate = __webpack_require__(368);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(58);
	var $export = __webpack_require__(79);
	var redefine = __webpack_require__(136);
	var redefineAll = __webpack_require__(362);
	var meta = __webpack_require__(358);
	var forOf = __webpack_require__(254);
	var anInstance = __webpack_require__(352);
	var isObject = __webpack_require__(65);
	var fails = __webpack_require__(204);
	var $iterDetect = __webpack_require__(542);
	var setToStringTag = __webpack_require__(256);
	var inheritIfRequired = __webpack_require__(1303);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(364)('native-function-to-string', Function.toString);


/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(65);
	var setPrototypeOf = __webpack_require__(1322).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 1304 */
1265,
/* 1305 */
[2098, 205, 66],
/* 1306 */
[2099, 203],
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(65);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 1308 */
[2100, 113],
/* 1309 */
[2101, 1313, 361, 256, 162, 66],
/* 1310 */
1268,
/* 1311 */
[2105, 58, 546, 203],
/* 1312 */
[2107, 123, 255, 1316, 360, 367, 356, 204],
/* 1313 */
[2108, 113, 1314, 538, 363, 355, 539],
/* 1314 */
[2110, 206, 113, 255, 123],
/* 1315 */
[2111, 360, 361, 207, 547, 135, 540, 123],
/* 1316 */
343,
/* 1317 */
[2112, 135, 367, 363],
/* 1318 */
[2113, 135, 207, 536, 363],
/* 1319 */
[2115, 123, 255, 207, 360],
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(79);
	var aFunction = __webpack_require__(202);
	var ctx = __webpack_require__(134);
	var forOf = __webpack_require__(254);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(79);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 1322 */
[2117, 65, 113, 134, 1315],
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(58);
	var dP = __webpack_require__(206);
	var DESCRIPTORS = __webpack_require__(123);
	var SPECIES = __webpack_require__(66)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 1324 */
[2122, 365, 354],
/* 1325 */
[2124, 365],
/* 1326 */
[2129, 58],
/* 1327 */
[2131, 353, 66, 205, 69],
/* 1328 */
[2132, 535, 1310, 205, 207, 541],
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(79);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(79);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(1307) });


/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(79);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ },
/* 1332 */
[2133, 357, 58, 134, 353, 79, 65, 202, 352, 254, 545, 546, 1311, 359, 543, 1326, 544, 66, 362, 256, 1323, 69, 542],
/* 1333 */
[2134, 1324, 541],
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(58);
	var each = __webpack_require__(537)(0);
	var redefine = __webpack_require__(136);
	var meta = __webpack_require__(358);
	var assign = __webpack_require__(1312);
	var weak = __webpack_require__(1300);
	var isObject = __webpack_require__(65);
	var validate = __webpack_require__(368);
	var NATIVE_WEAK_MAP = __webpack_require__(368);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(1301)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(79);
	var $includes = __webpack_require__(536)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(535)('includes');


/***/ },
/* 1336 */
[2135, 79, 1319],
/* 1337 */
[2136, 79, 69, 58, 545, 544],
/* 1338 */
[2137, 79, 359, 543],
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(1320)('WeakMap');


/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(1321)('WeakMap');


/***/ },
/* 1341 */
47,
/* 1342 */
/***/ function(module, exports) {

	(function() {
	  var base64map
	      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
	
	  crypt = {
	    // Bit-wise rotation left
	    rotl: function(n, b) {
	      return (n << b) | (n >>> (32 - b));
	    },
	
	    // Bit-wise rotation right
	    rotr: function(n, b) {
	      return (n << (32 - b)) | (n >>> b);
	    },
	
	    // Swap big-endian to little-endian and vice versa
	    endian: function(n) {
	      // If number given, swap endian
	      if (n.constructor == Number) {
	        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
	      }
	
	      // Else, assume array and swap all items
	      for (var i = 0; i < n.length; i++)
	        n[i] = crypt.endian(n[i]);
	      return n;
	    },
	
	    // Generate an array of any length of random bytes
	    randomBytes: function(n) {
	      for (var bytes = []; n > 0; n--)
	        bytes.push(Math.floor(Math.random() * 256));
	      return bytes;
	    },
	
	    // Convert a byte array to big-endian 32-bit words
	    bytesToWords: function(bytes) {
	      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
	        words[b >>> 5] |= bytes[i] << (24 - b % 32);
	      return words;
	    },
	
	    // Convert big-endian 32-bit words to a byte array
	    wordsToBytes: function(words) {
	      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
	        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a hex string
	    bytesToHex: function(bytes) {
	      for (var hex = [], i = 0; i < bytes.length; i++) {
	        hex.push((bytes[i] >>> 4).toString(16));
	        hex.push((bytes[i] & 0xF).toString(16));
	      }
	      return hex.join('');
	    },
	
	    // Convert a hex string to a byte array
	    hexToBytes: function(hex) {
	      for (var bytes = [], c = 0; c < hex.length; c += 2)
	        bytes.push(parseInt(hex.substr(c, 2), 16));
	      return bytes;
	    },
	
	    // Convert a byte array to a base-64 string
	    bytesToBase64: function(bytes) {
	      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
	        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
	        for (var j = 0; j < 4; j++)
	          if (i * 8 + j * 6 <= bytes.length * 8)
	            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
	          else
	            base64.push('=');
	      }
	      return base64.join('');
	    },
	
	    // Convert a base-64 string to a byte array
	    base64ToBytes: function(base64) {
	      // Remove non-base-64 characters
	      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
	
	      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
	          imod4 = ++i % 4) {
	        if (imod4 == 0) continue;
	        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
	            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
	            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
	      }
	      return bytes;
	    }
	  };
	
	  module.exports = crypt;
	})();


/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(94);
	
	var implementation = __webpack_require__(551);
	var getPolyfill = __webpack_require__(552);
	var polyfill = getPolyfill();
	var shim = __webpack_require__(1344);
	
	var boundContains = function contains(node, other) {
		return polyfill.apply(node, [other]);
	};
	
	define(boundContains, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = boundContains;


/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(94);
	var getPolyfill = __webpack_require__(552);
	
	module.exports = function shimContains() {
		var polyfill = getPolyfill();
		if (typeof document !== 'undefined') {
			define(
				document,
				{ contains: polyfill },
				{ contains: function () { return document.contains !== polyfill; } }
			);
			if (typeof Element !== 'undefined') {
				define(
					Element.prototype,
					{ contains: polyfill },
					{ contains: function () { return Element.prototype.contains !== polyfill; } }
				);
			}
		}
		return polyfill;
	};


/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(45);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(554));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(45);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addClass = _interopRequireDefault(__webpack_require__(1345));
	
	exports.addClass = _addClass.default;
	
	var _removeClass = _interopRequireDefault(__webpack_require__(1347));
	
	exports.removeClass = _removeClass.default;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(554));
	
	exports.hasClass = _hasClass.default;
	var _default = {
	  addClass: _addClass.default,
	  removeClass: _removeClass.default,
	  hasClass: _hasClass.default
	};
	exports.default = _default;

/***/ },
/* 1347 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(45);
	
	exports.__esModule = true;
	exports.default = filterEvents;
	
	var _contains = _interopRequireDefault(__webpack_require__(164));
	
	var _querySelectorAll = _interopRequireDefault(__webpack_require__(1353));
	
	function filterEvents(selector, handler) {
	  return function filterHandler(e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = (0, _querySelectorAll.default)(top, selector);
	    if (matches.some(function (match) {
	      return (0, _contains.default)(match, target);
	    })) handler.call(this, e);
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(45);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _on = _interopRequireDefault(__webpack_require__(258));
	
	exports.on = _on.default;
	
	var _off = _interopRequireDefault(__webpack_require__(370));
	
	exports.off = _off.default;
	
	var _filter = _interopRequireDefault(__webpack_require__(1348));
	
	exports.filter = _filter.default;
	
	var _listen = _interopRequireDefault(__webpack_require__(1350));
	
	exports.listen = _listen.default;
	var _default = {
	  on: _on.default,
	  off: _off.default,
	  filter: _filter.default,
	  listen: _listen.default
	};
	exports.default = _default;

/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(45);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(124));
	
	var _on = _interopRequireDefault(__webpack_require__(258));
	
	var _off = _interopRequireDefault(__webpack_require__(370));
	
	var listen = function listen() {};
	
	if (_inDOM.default) {
	  listen = function listen(node, eventName, handler, capture) {
	    (0, _on.default)(node, eventName, handler, capture);
	    return function () {
	      (0, _off.default)(node, eventName, handler, capture);
	    };
	  };
	}
	
	var _default = listen;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(45);
	
	exports.__esModule = true;
	exports.default = offsetParent;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(163));
	
	var _style = _interopRequireDefault(__webpack_require__(260));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(45);
	
	exports.__esModule = true;
	exports.default = position;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(473));
	
	var _offset = _interopRequireDefault(__webpack_require__(555));
	
	var _offsetParent = _interopRequireDefault(__webpack_require__(1351));
	
	var _scrollTop = _interopRequireDefault(__webpack_require__(556));
	
	var _scrollLeft = _interopRequireDefault(__webpack_require__(1354));
	
	var _style = _interopRequireDefault(__webpack_require__(260));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = {
	    top: 0,
	    left: 0
	  },
	      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	
	  if ((0, _style.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent.default)(node);
	    offset = (0, _offset.default)(node);
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
	    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
	  } // Subtract parent offsets and node margins
	
	
	  return (0, _extends2.default)({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 1353 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = qsa;
	// Zepto.js
	// (c) 2010-2015 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/;
	var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	}
	
	module.exports = exports["default"];

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(45);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(259));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(45);
	
	exports.__esModule = true;
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(558));
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	      prop = (0, _camelizeStyle.default)(prop);
	      if (prop == 'float') prop = 'styleFloat';
	      var current = node.currentStyle[prop] || null;
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out
	
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px'; // Revert the changed values
	
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 1356 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeStyle;
	
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	
	module.exports = exports["default"];

/***/ },
/* 1357 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	
	module.exports = exports["default"];

/***/ },
/* 1358 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 1359 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hyphenate;
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	
	module.exports = exports["default"];

/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(45);
	
	exports.__esModule = true;
	exports.default = hyphenateStyleName;
	
	var _hyphenate = _interopRequireDefault(__webpack_require__(1359));
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
	}
	
	module.exports = exports["default"];

/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBind = __webpack_require__(247);
	var gOPD = __webpack_require__(140);
	
	var hasProtoAccessor;
	try {
		// eslint-disable-next-line no-extra-parens, no-proto
		hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
	} catch (e) {
		if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
			throw e;
		}
	}
	
	// eslint-disable-next-line no-extra-parens
	var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));
	
	var $Object = Object;
	var $getPrototypeOf = $Object.getPrototypeOf;
	
	/** @type {import('./get')} */
	module.exports = desc && typeof desc.get === 'function'
		? callBind([desc.get])
		: typeof $getPrototypeOf === 'function'
			? /** @type {import('./get')} */ function getDunder(value) {
				// eslint-disable-next-line eqeqeq
				return $getPrototypeOf(value == null ? value : $Object(value));
			}
			: false;


/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBind = __webpack_require__(247);
	var gOPD = __webpack_require__(140);
	var $TypeError = __webpack_require__(22);
	
	/** @type {{ __proto__?: object | null }} */
	var obj = {};
	try {
		obj.__proto__ = null; // eslint-disable-line no-proto
	} catch (e) {
		if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
			throw e;
		}
	}
	
	var hasProtoMutator = !('toString' in obj);
	
	// eslint-disable-next-line no-extra-parens
	var desc = gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));
	
	/** @type {import('./set')} */
	module.exports = hasProtoMutator && (
	// eslint-disable-next-line no-extra-parens
		(!!desc && typeof desc.set === 'function' && /** @type {import('./set')} */ (callBind([desc.set])))
		|| /** @type {import('./set')} */ function setDunder(object, proto) {
			// this is node v0.10 or older, which doesn't have Object.setPrototypeOf and has undeniable __proto__
			if (object == null) { // eslint-disable-line eqeqeq
				throw new $TypeError('set Object.prototype.__proto__ called on null or undefined');
			}
			// eslint-disable-next-line no-proto, no-param-reassign, no-extra-parens
			/** @type {{ __proto__?: object | null }} */ (object).__proto__ = proto;
			return proto;
		}
	);


/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(85);
	
	var $ArrayPrototype = GetIntrinsic('%Array.prototype%');
	var $RangeError = __webpack_require__(568);
	var $SyntaxError = __webpack_require__(262);
	var $TypeError = __webpack_require__(22);
	var isInteger = __webpack_require__(667);
	var MAX_ARRAY_LENGTH = __webpack_require__(1653);
	var $setProto = __webpack_require__(2031);
	
	// https://262.ecma-international.org/12.0/#sec-arraycreate
	
	module.exports = function ArrayCreate(length) {
		if (!isInteger(length) || length < 0) {
			throw new $TypeError('Assertion failed: `length` must be an integer Number >= 0');
		}
		if (length > MAX_ARRAY_LENGTH) {
			throw new $RangeError('length is greater than (2**32 - 1)');
		}
		var proto = arguments.length > 1 ? arguments[1] : $ArrayPrototype;
		var A = []; // steps 3, 5
		if (proto !== $ArrayPrototype) { // step 4
			if (!$setProto) {
				throw new $SyntaxError('ArrayCreate: a `proto` argument that is not `Array.prototype` is not supported in an environment that does not support setting the [[Prototype]]');
			}
			$setProto(A, proto);
		}
		if (length !== 0) { // bypasses the need for step 6
			A.length = length;
		}
		/* step 6, the above as a shortcut for the below
		OrdinaryDefineOwnProperty(A, 'length', {
			'[[Configurable]]': false,
			'[[Enumerable]]': false,
			'[[Value]]': length,
			'[[Writable]]': true
		});
		*/
		return A;
	};


/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(85);
	
	var $species = GetIntrinsic('%Symbol.species%', true);
	var $TypeError = __webpack_require__(22);
	var isInteger = __webpack_require__(667);
	var isObject = __webpack_require__(95);
	
	var ArrayCreate = __webpack_require__(1363);
	var Get = __webpack_require__(261);
	var IsArray = __webpack_require__(372);
	var IsConstructor = __webpack_require__(1372);
	
	// https://262.ecma-international.org/12.0/#sec-arrayspeciescreate
	
	module.exports = function ArraySpeciesCreate(originalArray, length) {
		if (!isInteger(length) || length < 0) {
			throw new $TypeError('Assertion failed: length must be an integer >= 0');
		}
	
		var isArray = IsArray(originalArray);
		if (!isArray) {
			return ArrayCreate(length);
		}
	
		var C = Get(originalArray, 'constructor');
		// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
		// if (IsConstructor(C)) {
		// 	if C is another realm's Array, C = undefined
		// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
		// }
		if ($species && isObject(C)) {
			C = Get(C, $species);
			if (C === null) {
				C = void 0;
			}
		}
	
		if (typeof C === 'undefined') {
			return ArrayCreate(length);
		}
		if (!IsConstructor(C)) {
			throw new $TypeError('C must be a constructor');
		}
		return new C(length); // Construct(C, length);
	};
	


/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(85);
	var callBound = __webpack_require__(84);
	
	var $TypeError = __webpack_require__(22);
	
	var IsArray = __webpack_require__(372);
	
	var $apply = GetIntrinsic('%Reflect.apply%', true) || callBound('Function.prototype.apply');
	
	// https://262.ecma-international.org/6.0/#sec-call
	
	module.exports = function Call(F, V) {
		var argumentsList = arguments.length > 2 ? arguments[2] : [];
		if (!IsArray(argumentsList)) {
			throw new $TypeError('Assertion failed: optional `argumentsList`, if provided, must be a List');
		}
		return $apply(F, V, argumentsList);
	};


/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $TypeError = __webpack_require__(22);
	var isObject = __webpack_require__(95);
	
	var isPropertyKey = __webpack_require__(137);
	var OrdinaryDefineOwnProperty = __webpack_require__(1376);
	
	// https://262.ecma-international.org/6.0/#sec-createdataproperty
	
	module.exports = function CreateDataProperty(O, P, V) {
		if (!isObject(O)) {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
		if (!isPropertyKey(P)) {
			throw new $TypeError('Assertion failed: P is not a Property Key');
		}
		var newDesc = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Value]]': V,
			'[[Writable]]': true
		};
		return OrdinaryDefineOwnProperty(O, P, newDesc);
	};


/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $TypeError = __webpack_require__(22);
	var isObject = __webpack_require__(95);
	
	var CreateDataProperty = __webpack_require__(1366);
	
	var isPropertyKey = __webpack_require__(137);
	
	// // https://262.ecma-international.org/14.0/#sec-createdatapropertyorthrow
	
	module.exports = function CreateDataPropertyOrThrow(O, P, V) {
		if (!isObject(O)) {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
		if (!isPropertyKey(P)) {
			throw new $TypeError('Assertion failed: P is not a Property Key');
		}
		var success = CreateDataProperty(O, P, V);
		if (!success) {
			throw new $TypeError('unable to create data property');
		}
	};


/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $TypeError = __webpack_require__(22);
	var isObject = __webpack_require__(95);
	
	var isPropertyDescriptor = __webpack_require__(125);
	var DefineOwnProperty = __webpack_require__(565);
	
	var FromPropertyDescriptor = __webpack_require__(560);
	var IsDataDescriptor = __webpack_require__(373);
	var isPropertyKey = __webpack_require__(137);
	var SameValue = __webpack_require__(374);
	var ToPropertyDescriptor = __webpack_require__(563);
	
	// https://262.ecma-international.org/6.0/#sec-definepropertyorthrow
	
	module.exports = function DefinePropertyOrThrow(O, P, desc) {
		if (!isObject(O)) {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
	
		if (!isPropertyKey(P)) {
			throw new $TypeError('Assertion failed: P is not a Property Key');
		}
	
		var Desc = isPropertyDescriptor(desc) ? desc : ToPropertyDescriptor(desc);
		if (!isPropertyDescriptor(Desc)) {
			throw new $TypeError('Assertion failed: Desc is not a valid Property Descriptor');
		}
	
		return DefineOwnProperty(
			IsDataDescriptor,
			SameValue,
			FromPropertyDescriptor,
			O,
			P,
			Desc
		);
	};


/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $TypeError = __webpack_require__(22);
	
	var MAX_SAFE_INTEGER = __webpack_require__(665);
	
	var Call = __webpack_require__(1365);
	var CreateDataPropertyOrThrow = __webpack_require__(1367);
	var Get = __webpack_require__(261);
	var HasProperty = __webpack_require__(1370);
	var IsArray = __webpack_require__(372);
	var LengthOfArrayLike = __webpack_require__(1375);
	var ToString = __webpack_require__(564);
	
	// https://262.ecma-international.org/11.0/#sec-flattenintoarray
	
	module.exports = function FlattenIntoArray(target, source, sourceLen, start, depth) {
		var mapperFunction;
		if (arguments.length > 5) {
			mapperFunction = arguments[5];
		}
	
		var targetIndex = start;
		var sourceIndex = 0;
		while (sourceIndex < sourceLen) {
			var P = ToString(sourceIndex);
			var exists = HasProperty(source, P);
			if (exists === true) {
				var element = Get(source, P);
				if (typeof mapperFunction !== 'undefined') {
					if (arguments.length <= 6) {
						throw new $TypeError('Assertion failed: thisArg is required when mapperFunction is provided');
					}
					element = Call(mapperFunction, arguments[6], [element, sourceIndex, source]);
				}
				var shouldFlatten = false;
				if (depth > 0) {
					shouldFlatten = IsArray(element);
				}
				if (shouldFlatten) {
					var elementLen = LengthOfArrayLike(element);
					targetIndex = FlattenIntoArray(target, element, elementLen, targetIndex, depth - 1);
				} else {
					if (targetIndex >= MAX_SAFE_INTEGER) {
						throw new $TypeError('index too large');
					}
					CreateDataPropertyOrThrow(target, ToString(targetIndex), element);
					targetIndex += 1;
				}
			}
			sourceIndex += 1;
		}
	
		return targetIndex;
	};


/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $TypeError = __webpack_require__(22);
	var isObject = __webpack_require__(95);
	
	var isPropertyKey = __webpack_require__(137);
	
	// https://262.ecma-international.org/6.0/#sec-hasproperty
	
	module.exports = function HasProperty(O, P) {
		if (!isObject(O)) {
			throw new $TypeError('Assertion failed: `O` must be an Object');
		}
		if (!isPropertyKey(P)) {
			throw new $TypeError('Assertion failed: `P` must be a Property Key');
		}
		return P in O;
	};


/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// http://262.ecma-international.org/5.1/#sec-9.11
	
	module.exports = __webpack_require__(640);


/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(1385);
	
	var $construct = GetIntrinsic('%Reflect.construct%', true);
	
	var DefinePropertyOrThrow = __webpack_require__(1368);
	try {
		DefinePropertyOrThrow({}, '', { '[[Get]]': function () {} });
	} catch (e) {
		// Accessor properties aren't supported
		DefinePropertyOrThrow = null;
	}
	
	// https://262.ecma-international.org/6.0/#sec-isconstructor
	
	if (DefinePropertyOrThrow && $construct) {
		var isConstructorMarker = {};
		var badArrayLike = {};
		DefinePropertyOrThrow(badArrayLike, 'length', {
			'[[Get]]': function () {
				throw isConstructorMarker;
			},
			'[[Enumerable]]': true
		});
	
		module.exports = function IsConstructor(argument) {
			try {
				// `Reflect.construct` invokes `IsConstructor(target)` before `Get(args, 'length')`:
				$construct(argument, badArrayLike);
			} catch (err) {
				return err === isConstructorMarker;
			}
		};
	} else {
		module.exports = function IsConstructor(argument) {
			// unfortunately there's no way to truly check this without try/catch `new argument` in old environments
			return typeof argument === 'function' && !!argument.prototype;
		};
	}


/***/ },
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(85);
	
	var $preventExtensions = GetIntrinsic('%Object.preventExtensions%', true);
	var $isExtensible = GetIntrinsic('%Object.isExtensible%', true);
	
	var isPrimitive = __webpack_require__(567);
	
	// https://262.ecma-international.org/6.0/#sec-isextensible-o
	
	module.exports = $preventExtensions
		? function IsExtensible(obj) {
			return !isPrimitive(obj) && $isExtensible(obj);
		}
		: function IsExtensible(obj) {
			return !isPrimitive(obj);
		};


/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $TypeError = __webpack_require__(22);
	
	var IsAccessorDescriptor = __webpack_require__(371);
	var IsDataDescriptor = __webpack_require__(373);
	
	var isPropertyDescriptor = __webpack_require__(125);
	
	// https://262.ecma-international.org/6.0/#sec-isgenericdescriptor
	
	module.exports = function IsGenericDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}
	
		if (!isPropertyDescriptor(Desc)) {
			throw new $TypeError('Assertion failed: `Desc` must be a Property Descriptor');
		}
	
		if (!IsAccessorDescriptor(Desc) && !IsDataDescriptor(Desc)) {
			return true;
		}
	
		return false;
	};


/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $TypeError = __webpack_require__(22);
	var isObject = __webpack_require__(95);
	
	var Get = __webpack_require__(261);
	var ToLength = __webpack_require__(562);
	
	// https://262.ecma-international.org/11.0/#sec-lengthofarraylike
	
	module.exports = function LengthOfArrayLike(obj) {
		if (!isObject(obj)) {
			throw new $TypeError('Assertion failed: `obj` must be an Object');
		}
		return ToLength(Get(obj, 'length'));
	};
	
	// TODO: use this all over


/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $gOPD = __webpack_require__(140);
	var $SyntaxError = __webpack_require__(262);
	var $TypeError = __webpack_require__(22);
	var isObject = __webpack_require__(95);
	
	var isPropertyDescriptor = __webpack_require__(125);
	
	var IsAccessorDescriptor = __webpack_require__(371);
	var IsExtensible = __webpack_require__(1373);
	var isPropertyKey = __webpack_require__(137);
	var ToPropertyDescriptor = __webpack_require__(563);
	var SameValue = __webpack_require__(374);
	var ValidateAndApplyPropertyDescriptor = __webpack_require__(1382);
	
	// https://262.ecma-international.org/6.0/#sec-ordinarydefineownproperty
	
	module.exports = function OrdinaryDefineOwnProperty(O, P, Desc) {
		if (!isObject(O)) {
			throw new $TypeError('Assertion failed: O must be an Object');
		}
		if (!isPropertyKey(P)) {
			throw new $TypeError('Assertion failed: P must be a Property Key');
		}
		if (!isPropertyDescriptor(Desc)) {
			throw new $TypeError('Assertion failed: Desc must be a Property Descriptor');
		}
		if (!$gOPD) {
			// ES3/IE 8 fallback
			if (IsAccessorDescriptor(Desc)) {
				throw new $SyntaxError('This environment does not support accessor property descriptors.');
			}
			var creatingNormalDataProperty = !(P in O)
				&& Desc['[[Writable]]']
				&& Desc['[[Enumerable]]']
				&& Desc['[[Configurable]]']
				&& '[[Value]]' in Desc;
			var settingExistingDataProperty = (P in O)
				&& (!('[[Configurable]]' in Desc) || Desc['[[Configurable]]'])
				&& (!('[[Enumerable]]' in Desc) || Desc['[[Enumerable]]'])
				&& (!('[[Writable]]' in Desc) || Desc['[[Writable]]'])
				&& '[[Value]]' in Desc;
			if (creatingNormalDataProperty || settingExistingDataProperty) {
				O[P] = Desc['[[Value]]']; // eslint-disable-line no-param-reassign
				return SameValue(O[P], Desc['[[Value]]']);
			}
			throw new $SyntaxError('This environment does not support defining non-writable, non-enumerable, or non-configurable properties');
		}
		var desc = $gOPD(O, P);
		var current = desc && ToPropertyDescriptor(desc);
		var extensible = IsExtensible(O);
		return ValidateAndApplyPropertyDescriptor(O, P, extensible, Desc, current);
	};


/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(85);
	
	var $RegExp = GetIntrinsic('%RegExp%');
	var $TypeError = __webpack_require__(22);
	var $parseInteger = GetIntrinsic('%parseInt%');
	
	var callBound = __webpack_require__(84);
	var regexTester = __webpack_require__(939);
	
	var $strSlice = callBound('String.prototype.slice');
	var isBinary = regexTester(/^0b[01]+$/i);
	var isOctal = regexTester(/^0o[0-7]+$/i);
	var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
	var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
	var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
	var hasNonWS = regexTester(nonWSregex);
	
	var $trim = __webpack_require__(2042);
	
	// https://262.ecma-international.org/13.0/#sec-stringtonumber
	
	module.exports = function StringToNumber(argument) {
		if (typeof argument !== 'string') {
			throw new $TypeError('Assertion failed: `argument` is not a String');
		}
		if (isBinary(argument)) {
			return +$parseInteger($strSlice(argument, 2), 2);
		}
		if (isOctal(argument)) {
			return +$parseInteger($strSlice(argument, 2), 8);
		}
		if (hasNonWS(argument) || isInvalidHexLiteral(argument)) {
			return NaN;
		}
		var trimmed = $trim(argument);
		if (trimmed !== argument) {
			return StringToNumber(trimmed);
		}
		return +argument;
	};


/***/ },
/* 1378 */
/***/ function(module, exports) {

	'use strict';
	
	// http://262.ecma-international.org/5.1/#sec-9.2
	
	module.exports = function ToBoolean(value) { return !!value; };


/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(85);
	
	var $TypeError = __webpack_require__(22);
	var $Number = GetIntrinsic('%Number%');
	var isPrimitive = __webpack_require__(567);
	
	var ToPrimitive = __webpack_require__(1381);
	var StringToNumber = __webpack_require__(1377);
	
	// https://262.ecma-international.org/13.0/#sec-tonumber
	
	module.exports = function ToNumber(argument) {
		var value = isPrimitive(argument) ? argument : ToPrimitive(argument, $Number);
		if (typeof value === 'symbol') {
			throw new $TypeError('Cannot convert a Symbol value to a number');
		}
		if (typeof value === 'bigint') {
			throw new $TypeError('Conversion from \'BigInt\' to \'number\' is not allowed.');
		}
		if (typeof value === 'string') {
			return StringToNumber(value);
		}
		return +value;
	};


/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://262.ecma-international.org/6.0/#sec-toobject
	
	module.exports = __webpack_require__(1392);


/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toPrimitive = __webpack_require__(1394);
	
	// https://262.ecma-international.org/6.0/#sec-toprimitive
	
	module.exports = function ToPrimitive(input) {
		if (arguments.length > 1) {
			return toPrimitive(input, arguments[1]);
		}
		return toPrimitive(input);
	};


/***/ },
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $TypeError = __webpack_require__(22);
	var isObject = __webpack_require__(95);
	
	var DefineOwnProperty = __webpack_require__(565);
	var isFullyPopulatedPropertyDescriptor = __webpack_require__(1387);
	var isPropertyDescriptor = __webpack_require__(125);
	
	var FromPropertyDescriptor = __webpack_require__(560);
	var IsAccessorDescriptor = __webpack_require__(371);
	var IsDataDescriptor = __webpack_require__(373);
	var IsGenericDescriptor = __webpack_require__(1374);
	var isPropertyKey = __webpack_require__(137);
	var SameValue = __webpack_require__(374);
	
	// https://262.ecma-international.org/13.0/#sec-validateandapplypropertydescriptor
	
	// see https://github.com/tc39/ecma262/pull/2468 for ES2022 changes
	
	// eslint-disable-next-line max-lines-per-function, max-statements
	module.exports = function ValidateAndApplyPropertyDescriptor(O, P, extensible, Desc, current) {
		if (typeof O !== 'undefined' && !isObject(O)) {
			throw new $TypeError('Assertion failed: O must be undefined or an Object');
		}
		if (!isPropertyKey(P)) {
			throw new $TypeError('Assertion failed: P must be a Property Key');
		}
		if (typeof extensible !== 'boolean') {
			throw new $TypeError('Assertion failed: extensible must be a Boolean');
		}
		if (!isPropertyDescriptor(Desc)) {
			throw new $TypeError('Assertion failed: Desc must be a Property Descriptor');
		}
		if (typeof current !== 'undefined' && !isPropertyDescriptor(current)) {
			throw new $TypeError('Assertion failed: current must be a Property Descriptor, or undefined');
		}
	
		if (typeof current === 'undefined') { // step 2
			if (!extensible) {
				return false; // step 2.a
			}
			if (typeof O === 'undefined') {
				return true; // step 2.b
			}
			if (IsAccessorDescriptor(Desc)) { // step 2.c
				return DefineOwnProperty(
					IsDataDescriptor,
					SameValue,
					FromPropertyDescriptor,
					O,
					P,
					Desc
				);
			}
			// step 2.d
			return DefineOwnProperty(
				IsDataDescriptor,
				SameValue,
				FromPropertyDescriptor,
				O,
				P,
				{
					'[[Configurable]]': !!Desc['[[Configurable]]'],
					'[[Enumerable]]': !!Desc['[[Enumerable]]'],
					'[[Value]]': Desc['[[Value]]'],
					'[[Writable]]': !!Desc['[[Writable]]']
				}
			);
		}
	
		// 3. Assert: current is a fully populated Property Descriptor.
		if (
			!isFullyPopulatedPropertyDescriptor(
				{
					IsAccessorDescriptor: IsAccessorDescriptor,
					IsDataDescriptor: IsDataDescriptor
				},
				current
			)
		) {
			throw new $TypeError('`current`, when present, must be a fully populated and valid Property Descriptor');
		}
	
		// 4. If every field in Desc is absent, return true.
		// this can't really match the assertion that it's a Property Descriptor in our JS implementation
	
		// 5. If current.[[Configurable]] is false, then
		if (!current['[[Configurable]]']) {
			if ('[[Configurable]]' in Desc && Desc['[[Configurable]]']) {
				// step 5.a
				return false;
			}
			if ('[[Enumerable]]' in Desc && !SameValue(Desc['[[Enumerable]]'], current['[[Enumerable]]'])) {
				// step 5.b
				return false;
			}
			if (!IsGenericDescriptor(Desc) && !SameValue(IsAccessorDescriptor(Desc), IsAccessorDescriptor(current))) {
				// step 5.c
				return false;
			}
			if (IsAccessorDescriptor(current)) { // step 5.d
				if ('[[Get]]' in Desc && !SameValue(Desc['[[Get]]'], current['[[Get]]'])) {
					return false;
				}
				if ('[[Set]]' in Desc && !SameValue(Desc['[[Set]]'], current['[[Set]]'])) {
					return false;
				}
			} else if (!current['[[Writable]]']) { // step 5.e
				if ('[[Writable]]' in Desc && Desc['[[Writable]]']) {
					return false;
				}
				if ('[[Value]]' in Desc && !SameValue(Desc['[[Value]]'], current['[[Value]]'])) {
					return false;
				}
			}
		}
	
		// 6. If O is not undefined, then
		if (typeof O !== 'undefined') {
			var configurable;
			var enumerable;
			if (IsDataDescriptor(current) && IsAccessorDescriptor(Desc)) { // step 6.a
				configurable = ('[[Configurable]]' in Desc ? Desc : current)['[[Configurable]]'];
				enumerable = ('[[Enumerable]]' in Desc ? Desc : current)['[[Enumerable]]'];
				// Replace the property named P of object O with an accessor property having [[Configurable]] and [[Enumerable]] attributes as described by current and each other attribute set to its default value.
				return DefineOwnProperty(
					IsDataDescriptor,
					SameValue,
					FromPropertyDescriptor,
					O,
					P,
					{
						'[[Configurable]]': !!configurable,
						'[[Enumerable]]': !!enumerable,
						'[[Get]]': ('[[Get]]' in Desc ? Desc : current)['[[Get]]'],
						'[[Set]]': ('[[Set]]' in Desc ? Desc : current)['[[Set]]']
					}
				);
			} else if (IsAccessorDescriptor(current) && IsDataDescriptor(Desc)) {
				configurable = ('[[Configurable]]' in Desc ? Desc : current)['[[Configurable]]'];
				enumerable = ('[[Enumerable]]' in Desc ? Desc : current)['[[Enumerable]]'];
				// i. Replace the property named P of object O with a data property having [[Configurable]] and [[Enumerable]] attributes as described by current and each other attribute set to its default value.
				return DefineOwnProperty(
					IsDataDescriptor,
					SameValue,
					FromPropertyDescriptor,
					O,
					P,
					{
						'[[Configurable]]': !!configurable,
						'[[Enumerable]]': !!enumerable,
						'[[Value]]': ('[[Value]]' in Desc ? Desc : current)['[[Value]]'],
						'[[Writable]]': !!('[[Writable]]' in Desc ? Desc : current)['[[Writable]]']
					}
				);
			}
	
			// For each field of Desc that is present, set the corresponding attribute of the property named P of object O to the value of the field.
			return DefineOwnProperty(
				IsDataDescriptor,
				SameValue,
				FromPropertyDescriptor,
				O,
				P,
				Desc
			);
		}
	
		return true; // step 7
	};


/***/ },
/* 1383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// var modulo = require('./modulo');
	var $floor = __webpack_require__(419);
	
	// http://262.ecma-international.org/11.0/#eqn-floor
	
	module.exports = function floor(x) {
		// return x - modulo(x, 1);
		if (typeof x === 'bigint') {
			return x;
		}
		return $floor(x);
	};


/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var floor = __webpack_require__(1383);
	
	var $TypeError = __webpack_require__(22);
	
	// https://262.ecma-international.org/14.0/#eqn-truncate
	
	module.exports = function truncate(x) {
		if (typeof x !== 'number' && typeof x !== 'bigint') {
			throw new $TypeError('argument must be a Number or a BigInt');
		}
		var result = x < 0 ? -floor(-x) : floor(x);
		return result === 0 ? 0 : result; // in the spec, these are math values, so we filter out -0 here
	};


/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// TODO: remove, semver-major
	
	module.exports = __webpack_require__(85);


/***/ },
/* 1386 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function fromPropertyDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return Desc;
		}
		var obj = {};
		if ('[[Value]]' in Desc) {
			obj.value = Desc['[[Value]]'];
		}
		if ('[[Writable]]' in Desc) {
			obj.writable = !!Desc['[[Writable]]'];
		}
		if ('[[Get]]' in Desc) {
			obj.get = Desc['[[Get]]'];
		}
		if ('[[Set]]' in Desc) {
			obj.set = Desc['[[Set]]'];
		}
		if ('[[Enumerable]]' in Desc) {
			obj.enumerable = !!Desc['[[Enumerable]]'];
		}
		if ('[[Configurable]]' in Desc) {
			obj.configurable = !!Desc['[[Configurable]]'];
		}
		return obj;
	};


/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isPropertyDescriptor = __webpack_require__(125);
	
	module.exports = function isFullyPopulatedPropertyDescriptor(ES, Desc) {
		return isPropertyDescriptor(Desc)
			&& '[[Enumerable]]' in Desc
			&& '[[Configurable]]' in Desc
			&& (ES.IsAccessorDescriptor(Desc) || ES.IsDataDescriptor(Desc));
	};


/***/ },
/* 1388 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./eval')} */
	module.exports = EvalError;


/***/ },
/* 1389 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = Error;


/***/ },
/* 1390 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./ref')} */
	module.exports = ReferenceError;


/***/ },
/* 1391 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./uri')} */
	module.exports = URIError;


/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $Object = __webpack_require__(209);
	var RequireObjectCoercible = __webpack_require__(263);
	
	/** @type {import('./ToObject')} */
	module.exports = function ToObject(value) {
		RequireObjectCoercible(value);
		return $Object(value);
	};


/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasOwn = __webpack_require__(141);
	
	var hasUnscopables = typeof Symbol === 'function' && typeof Symbol.unscopables === 'symbol';
	
	var map = hasUnscopables && Array.prototype[Symbol.unscopables];
	
	var $TypeError = TypeError;
	
	/** @type {import('.')} */
	module.exports = function shimUnscopables(method) {
		if (typeof method !== 'string' || !method) {
			throw new $TypeError('method must be a non-empty string');
		}
		if (!hasOwn(Array.prototype, method)) {
			throw new $TypeError('method must be on Array.prototype');
		}
		if (hasUnscopables && map) {
			map[method] = true;
		}
	};


/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
	
	var isPrimitive = __webpack_require__(1395);
	var isCallable = __webpack_require__(640);
	var isDate = __webpack_require__(1548);
	var isSymbol = __webpack_require__(641);
	
	/** @type {(O: { valueOf?: () => unknown, toString?: () => unknown }, hint: 'number' | 'string' | 'default') => null | undefined | string | symbol | number | boolean | bigint} */
	var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
		if (typeof O === 'undefined' || O === null) {
			throw new TypeError('Cannot call method on ' + O);
		}
		if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
			throw new TypeError('hint must be "string" or "number"');
		}
		/** @type {('toString' | 'valueOf')[]} */
		var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
		var method, result, i;
		for (i = 0; i < methodNames.length; ++i) {
			method = O[methodNames[i]];
			if (isCallable(method)) {
				result = method.call(O);
				if (isPrimitive(result)) {
					return result;
				}
			}
		}
		throw new TypeError('No default value');
	};
	
	/** @type {<K extends PropertyKey>(O: Record<K, unknown>, P: K) => Function | undefined} */
	var GetMethod = function GetMethod(O, P) {
		var func = O[P];
		if (func !== null && typeof func !== 'undefined') {
			if (!isCallable(func)) {
				throw new TypeError(func + ' returned for property ' + String(P) + ' of object ' + O + ' is not a function');
			}
			return func;
		}
		return void 0;
	};
	
	/** @type {import('./es2015')} */
	// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
	module.exports = function ToPrimitive(input) {
		if (isPrimitive(input)) {
			return input;
		}
		/** @type {'default' | 'string' | 'number'} */
		var hint = 'default';
		if (arguments.length > 1) {
			if (arguments[1] === String) {
				hint = 'string';
			} else if (arguments[1] === Number) {
				hint = 'number';
			}
		}
	
		var exoticToPrim;
		if (hasSymbols) {
			if (Symbol.toPrimitive) {
				// eslint-disable-next-line no-extra-parens
				exoticToPrim = GetMethod(/** @type {Record<PropertyKey, unknown>} */ (input), Symbol.toPrimitive);
			} else if (isSymbol(input)) {
				exoticToPrim = Symbol.prototype.valueOf;
			}
		}
		if (typeof exoticToPrim !== 'undefined') {
			var result = exoticToPrim.call(input, hint);
			if (isPrimitive(result)) {
				return result;
			}
			throw new TypeError('unable to convert exotic object to primitive');
		}
		if (hint === 'default' && (isDate(input) || isSymbol(input))) {
			hint = 'string';
		}
		// eslint-disable-next-line no-extra-parens
		return ordinaryToPrimitive(/** @type {object} */ (input), hint === 'default' ? 'number' : hint);
	};


/***/ },
/* 1395 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {(value: unknown) => value is null | undefined | string | symbol | number | boolean | bigint} */
	module.exports = function isPrimitive(value) {
		return value === null || (typeof value !== 'function' && typeof value !== 'object');
	};


/***/ },
/* 1396 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _extendableBuiltin(cls) {
	  function ExtendableBuiltin() {
	    cls.apply(this, arguments);
	  }
	
	  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
	    constructor: {
	      value: cls,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (Object.setPrototypeOf) {
	    Object.setPrototypeOf(ExtendableBuiltin, cls);
	  } else {
	    ExtendableBuiltin.__proto__ = cls;
	  }
	
	  return ExtendableBuiltin;
	}
	
	var ExtendableError = function (_extendableBuiltin2) {
	  _inherits(ExtendableError, _extendableBuiltin2);
	
	  function ExtendableError() {
	    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    _classCallCheck(this, ExtendableError);
	
	    // extending Error is weird and does not propagate `message`
	    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));
	
	    Object.defineProperty(_this, 'message', {
	      configurable: true,
	      enumerable: false,
	      value: message,
	      writable: true
	    });
	
	    Object.defineProperty(_this, 'name', {
	      configurable: true,
	      enumerable: false,
	      value: _this.constructor.name,
	      writable: true
	    });
	
	    if (Error.hasOwnProperty('captureStackTrace')) {
	      Error.captureStackTrace(_this, _this.constructor);
	      return _possibleConstructorReturn(_this);
	    }
	
	    Object.defineProperty(_this, 'stack', {
	      configurable: true,
	      enumerable: false,
	      value: new Error(message).stack,
	      writable: true
	    });
	    return _this;
	  }
	
	  return ExtendableError;
	}(_extendableBuiltin(Error));
	
	exports.default = ExtendableError;
	module.exports = exports['default'];


/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 1398 */
138,
/* 1399 */
138,
/* 1400 */
138,
/* 1401 */
138,
/* 1402 */
138,
/* 1403 */
138,
/* 1404 */
138,
/* 1405 */
138,
/* 1406 */
138,
/* 1407 */
138,
/* 1408 */
138,
/* 1409 */
138,
/* 1410 */
138,
/* 1411 */
138,
/* 1412 */
138,
/* 1413 */
138,
/* 1414 */
138,
/* 1415 */
138,
/* 1416 */
138,
/* 1417 */
138,
/* 1418 */
138,
/* 1419 */
138,
/* 1420 */
138,
/* 1421 */
138,
/* 1422 */
138,
/* 1423 */
138,
/* 1424 */
138,
/* 1425 */
138,
/* 1426 */
138,
/* 1427 */
138,
/* 1428 */
138,
/* 1429 */
138,
/* 1430 */
138,
/* 1431 */
138,
/* 1432 */
138,
/* 1433 */
138,
/* 1434 */
138,
/* 1435 */
138,
/* 1436 */
138,
/* 1437 */
138,
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(33);
	function extractParams(weights) {
	    var paramMappings = [];
	    var _a = common_1.extractWeightsFactory(weights), extractWeights = _a.extractWeights, getRemainingWeights = _a.getRemainingWeights;
	    var extractFCParams = common_1.extractFCParamsFactory(extractWeights, paramMappings);
	    var age = extractFCParams(512, 1, 'fc/age');
	    var gender = extractFCParams(512, 2, 'fc/gender');
	    if (getRemainingWeights().length !== 0) {
	        throw new Error("weights remaing after extract: " + getRemainingWeights().length);
	    }
	    return {
	        paramMappings: paramMappings,
	        params: { fc: { age: age, gender: gender } }
	    };
	}
	exports.extractParams = extractParams;
	//# sourceMappingURL=extractParams.js.map

/***/ },
/* 1439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(33);
	function extractParamsFromWeigthMap(weightMap) {
	    var paramMappings = [];
	    var extractWeightEntry = common_1.extractWeightEntryFactory(weightMap, paramMappings);
	    function extractFcParams(prefix) {
	        var weights = extractWeightEntry(prefix + "/weights", 2);
	        var bias = extractWeightEntry(prefix + "/bias", 1);
	        return { weights: weights, bias: bias };
	    }
	    var params = {
	        fc: {
	            age: extractFcParams('fc/age'),
	            gender: extractFcParams('fc/gender')
	        }
	    };
	    common_1.disposeUnusedWeightTensors(weightMap, paramMappings);
	    return { params: params, paramMappings: paramMappings };
	}
	exports.extractParamsFromWeigthMap = extractParamsFromWeigthMap;
	//# sourceMappingURL=extractParamsFromWeigthMap.js.map

/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	tslib_1.__exportStar(__webpack_require__(572), exports);
	tslib_1.__exportStar(__webpack_require__(377), exports);
	//# sourceMappingURL=index.js.map

/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var utils_1 = __webpack_require__(34);
	var LabeledBox_1 = __webpack_require__(576);
	var PredictedBox = /** @class */ (function (_super) {
	    tslib_1.__extends(PredictedBox, _super);
	    function PredictedBox(box, label, score, classScore) {
	        var _this = _super.call(this, box, label) || this;
	        _this._score = score;
	        _this._classScore = classScore;
	        return _this;
	    }
	    PredictedBox.assertIsValidPredictedBox = function (box, callee) {
	        LabeledBox_1.LabeledBox.assertIsValidLabeledBox(box, callee);
	        if (!utils_1.isValidProbablitiy(box.score)
	            || !utils_1.isValidProbablitiy(box.classScore)) {
	            throw new Error(callee + " - expected properties score (" + box.score + ") and (" + box.classScore + ") to be a number between [0, 1]");
	        }
	    };
	    Object.defineProperty(PredictedBox.prototype, "score", {
	        get: function () { return this._score; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PredictedBox.prototype, "classScore", {
	        get: function () { return this._classScore; },
	        enumerable: true,
	        configurable: true
	    });
	    return PredictedBox;
	}(LabeledBox_1.LabeledBox));
	exports.PredictedBox = PredictedBox;
	//# sourceMappingURL=PredictedBox.js.map

/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	function convLayer(x, params, padding, withRelu) {
	    if (padding === void 0) { padding = 'same'; }
	    if (withRelu === void 0) { withRelu = false; }
	    return tf.tidy(function () {
	        var out = tf.add(tf.conv2d(x, params.filters, [1, 1], padding), params.bias);
	        return withRelu ? tf.relu(out) : out;
	    });
	}
	exports.convLayer = convLayer;
	//# sourceMappingURL=convLayer.js.map

/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	function extractConvParamsFactory(extractWeights, paramMappings) {
	    return function (channelsIn, channelsOut, filterSize, mappedPrefix) {
	        var filters = tf.tensor4d(extractWeights(channelsIn * channelsOut * filterSize * filterSize), [filterSize, filterSize, channelsIn, channelsOut]);
	        var bias = tf.tensor1d(extractWeights(channelsOut));
	        paramMappings.push({ paramPath: mappedPrefix + "/filters" }, { paramPath: mappedPrefix + "/bias" });
	        return { filters: filters, bias: bias };
	    };
	}
	exports.extractConvParamsFactory = extractConvParamsFactory;
	//# sourceMappingURL=extractConvParamsFactory.js.map

/***/ },
/* 1444 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	function extractFCParamsFactory(extractWeights, paramMappings) {
	    return function (channelsIn, channelsOut, mappedPrefix) {
	        var fc_weights = tf.tensor2d(extractWeights(channelsIn * channelsOut), [channelsIn, channelsOut]);
	        var fc_bias = tf.tensor1d(extractWeights(channelsOut));
	        paramMappings.push({ paramPath: mappedPrefix + "/weights" }, { paramPath: mappedPrefix + "/bias" });
	        return {
	            weights: fc_weights,
	            bias: fc_bias
	        };
	    };
	}
	exports.extractFCParamsFactory = extractFCParamsFactory;
	//# sourceMappingURL=extractFCParamsFactory.js.map

/***/ },
/* 1445 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var FaceDetection_1 = __webpack_require__(97);
	var utils_1 = __webpack_require__(34);
	/**
	 * Extracts the tensors of the image regions containing the detected faces.
	 * Useful if you want to compute the face descriptors for the face images.
	 * Using this method is faster then extracting a canvas for each face and
	 * converting them to tensors individually.
	 *
	 * @param imageTensor The image tensor that face detection has been performed on.
	 * @param detections The face detection results or face bounding boxes for that image.
	 * @returns Tensors of the corresponding image region for each detected face.
	 */
	function extractFaceTensors(imageTensor, detections) {
	    return tslib_1.__awaiter(this, void 0, void 0, function () {
	        return tslib_1.__generator(this, function (_a) {
	            if (!utils_1.isTensor3D(imageTensor) && !utils_1.isTensor4D(imageTensor)) {
	                throw new Error('extractFaceTensors - expected image tensor to be 3D or 4D');
	            }
	            if (utils_1.isTensor4D(imageTensor) && imageTensor.shape[0] > 1) {
	                throw new Error('extractFaceTensors - batchSize > 1 not supported');
	            }
	            return [2 /*return*/, tf.tidy(function () {
	                    var _a = imageTensor.shape.slice(utils_1.isTensor4D(imageTensor) ? 1 : 0), imgHeight = _a[0], imgWidth = _a[1], numChannels = _a[2];
	                    var boxes = detections.map(function (det) { return det instanceof FaceDetection_1.FaceDetection
	                        ? det.forSize(imgWidth, imgHeight).box
	                        : det; })
	                        .map(function (box) { return box.clipAtImageBorders(imgWidth, imgHeight); });
	                    var faceTensors = boxes.map(function (_a) {
	                        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	                        return tf.slice3d(imageTensor.as3D(imgHeight, imgWidth, numChannels), [y, x, 0], [height, width, numChannels]);
	                    });
	                    return faceTensors;
	                })];
	        });
	    });
	}
	exports.extractFaceTensors = extractFaceTensors;
	//# sourceMappingURL=extractFaceTensors.js.map

/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var FaceDetection_1 = __webpack_require__(97);
	var env_1 = __webpack_require__(55);
	var createCanvas_1 = __webpack_require__(265);
	var getContext2dOrThrow_1 = __webpack_require__(139);
	var imageTensorToCanvas_1 = __webpack_require__(589);
	var toNetInput_1 = __webpack_require__(592);
	/**
	 * Extracts the image regions containing the detected faces.
	 *
	 * @param input The image that face detection has been performed on.
	 * @param detections The face detection results or face bounding boxes for that image.
	 * @returns The Canvases of the corresponding image region for each detected face.
	 */
	function extractFaces(input, detections) {
	    return tslib_1.__awaiter(this, void 0, void 0, function () {
	        var Canvas, canvas, netInput, tensorOrCanvas, _a, ctx, boxes;
	        return tslib_1.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    Canvas = env_1.env.getEnv().Canvas;
	                    canvas = input;
	                    if (!!(input instanceof Canvas)) return [3 /*break*/, 5];
	                    return [4 /*yield*/, toNetInput_1.toNetInput(input)];
	                case 1:
	                    netInput = _b.sent();
	                    if (netInput.batchSize > 1) {
	                        throw new Error('extractFaces - batchSize > 1 not supported');
	                    }
	                    tensorOrCanvas = netInput.getInput(0);
	                    if (!(tensorOrCanvas instanceof Canvas)) return [3 /*break*/, 2];
	                    _a = tensorOrCanvas;
	                    return [3 /*break*/, 4];
	                case 2: return [4 /*yield*/, imageTensorToCanvas_1.imageTensorToCanvas(tensorOrCanvas)];
	                case 3:
	                    _a = _b.sent();
	                    _b.label = 4;
	                case 4:
	                    canvas = _a;
	                    _b.label = 5;
	                case 5:
	                    ctx = getContext2dOrThrow_1.getContext2dOrThrow(canvas);
	                    boxes = detections.map(function (det) { return det instanceof FaceDetection_1.FaceDetection
	                        ? det.forSize(canvas.width, canvas.height).box.floor()
	                        : det; })
	                        .map(function (box) { return box.clipAtImageBorders(canvas.width, canvas.height); });
	                    return [2 /*return*/, boxes.map(function (_a) {
	                            var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	                            var faceImg = createCanvas_1.createCanvas({ width: width, height: height });
	                            getContext2dOrThrow_1.getContext2dOrThrow(faceImg)
	                                .putImageData(ctx.getImageData(x, y, width, height), 0, 0);
	                            return faceImg;
	                        })];
	            }
	        });
	    });
	}
	exports.extractFaces = extractFaces;
	//# sourceMappingURL=extractFaces.js.map

/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var bufferToImage_1 = __webpack_require__(587);
	var fetchOrThrow_1 = __webpack_require__(266);
	function fetchImage(uri) {
	    return tslib_1.__awaiter(this, void 0, void 0, function () {
	        var res, blob;
	        return tslib_1.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, fetchOrThrow_1.fetchOrThrow(uri)];
	                case 1:
	                    res = _a.sent();
	                    return [4 /*yield*/, (res).blob()];
	                case 2:
	                    blob = _a.sent();
	                    if (!blob.type.startsWith('image/')) {
	                        throw new Error("fetchImage - expected blob type to be of type image/*, instead have: " + blob.type + ", for url: " + res.url);
	                    }
	                    return [2 /*return*/, bufferToImage_1.bufferToImage(blob)];
	            }
	        });
	    });
	}
	exports.fetchImage = fetchImage;
	//# sourceMappingURL=fetchImage.js.map

/***/ },
/* 1448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var fetchOrThrow_1 = __webpack_require__(266);
	function fetchNetWeights(uri) {
	    return tslib_1.__awaiter(this, void 0, void 0, function () {
	        var _a;
	        return tslib_1.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    _a = Float32Array.bind;
	                    return [4 /*yield*/, fetchOrThrow_1.fetchOrThrow(uri)];
	                case 1: return [4 /*yield*/, (_b.sent()).arrayBuffer()];
	                case 2: return [2 /*return*/, new (_a.apply(Float32Array, [void 0, _b.sent()]))()];
	            }
	        });
	    });
	}
	exports.fetchNetWeights = fetchNetWeights;
	//# sourceMappingURL=fetchNetWeights.js.map

/***/ },
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var getModelUris_1 = __webpack_require__(382);
	var fetchJson_1 = __webpack_require__(588);
	function loadWeightMap(uri, defaultModelName) {
	    return tslib_1.__awaiter(this, void 0, void 0, function () {
	        var _a, manifestUri, modelBaseUri, manifest;
	        return tslib_1.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    _a = getModelUris_1.getModelUris(uri, defaultModelName), manifestUri = _a.manifestUri, modelBaseUri = _a.modelBaseUri;
	                    return [4 /*yield*/, fetchJson_1.fetchJson(manifestUri)];
	                case 1:
	                    manifest = _b.sent();
	                    return [2 /*return*/, tf.io.loadWeights(manifest, modelBaseUri)];
	            }
	        });
	    });
	}
	exports.loadWeightMap = loadWeightMap;
	//# sourceMappingURL=loadWeightMap.js.map

/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var getMediaDimensions_1 = __webpack_require__(267);
	function matchDimensions(input, reference, useMediaDimensions) {
	    if (useMediaDimensions === void 0) { useMediaDimensions = false; }
	    var _a = useMediaDimensions
	        ? getMediaDimensions_1.getMediaDimensions(reference)
	        : reference, width = _a.width, height = _a.height;
	    input.width = width;
	    input.height = height;
	    return { width: width, height: height };
	}
	exports.matchDimensions = matchDimensions;
	//# sourceMappingURL=matchDimensions.js.map

/***/ },
/* 1451 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var FaceLandmarks_1 = __webpack_require__(166);
	var FaceLandmarks68_1 = __webpack_require__(378);
	var getContext2dOrThrow_1 = __webpack_require__(139);
	var WithFaceLandmarks_1 = __webpack_require__(211);
	var drawContour_1 = __webpack_require__(594);
	var DrawFaceLandmarksOptions = /** @class */ (function () {
	    function DrawFaceLandmarksOptions(options) {
	        if (options === void 0) { options = {}; }
	        var _a = options.drawLines, drawLines = _a === void 0 ? true : _a, _b = options.drawPoints, drawPoints = _b === void 0 ? true : _b, lineWidth = options.lineWidth, lineColor = options.lineColor, pointSize = options.pointSize, pointColor = options.pointColor;
	        this.drawLines = drawLines;
	        this.drawPoints = drawPoints;
	        this.lineWidth = lineWidth || 1;
	        this.pointSize = pointSize || 2;
	        this.lineColor = lineColor || 'rgba(0, 255, 255, 1)';
	        this.pointColor = pointColor || 'rgba(255, 0, 255, 1)';
	    }
	    return DrawFaceLandmarksOptions;
	}());
	exports.DrawFaceLandmarksOptions = DrawFaceLandmarksOptions;
	var DrawFaceLandmarks = /** @class */ (function () {
	    function DrawFaceLandmarks(faceLandmarks, options) {
	        if (options === void 0) { options = {}; }
	        this.faceLandmarks = faceLandmarks;
	        this.options = new DrawFaceLandmarksOptions(options);
	    }
	    DrawFaceLandmarks.prototype.draw = function (canvasArg) {
	        var ctx = getContext2dOrThrow_1.getContext2dOrThrow(canvasArg);
	        var _a = this.options, drawLines = _a.drawLines, drawPoints = _a.drawPoints, lineWidth = _a.lineWidth, lineColor = _a.lineColor, pointSize = _a.pointSize, pointColor = _a.pointColor;
	        if (drawLines && this.faceLandmarks instanceof FaceLandmarks68_1.FaceLandmarks68) {
	            ctx.strokeStyle = lineColor;
	            ctx.lineWidth = lineWidth;
	            drawContour_1.drawContour(ctx, this.faceLandmarks.getJawOutline());
	            drawContour_1.drawContour(ctx, this.faceLandmarks.getLeftEyeBrow());
	            drawContour_1.drawContour(ctx, this.faceLandmarks.getRightEyeBrow());
	            drawContour_1.drawContour(ctx, this.faceLandmarks.getNose());
	            drawContour_1.drawContour(ctx, this.faceLandmarks.getLeftEye(), true);
	            drawContour_1.drawContour(ctx, this.faceLandmarks.getRightEye(), true);
	            drawContour_1.drawContour(ctx, this.faceLandmarks.getMouth(), true);
	        }
	        if (drawPoints) {
	            ctx.strokeStyle = pointColor;
	            ctx.fillStyle = pointColor;
	            var drawPoint = function (pt) {
	                ctx.beginPath();
	                ctx.arc(pt.x, pt.y, pointSize, 0, 2 * Math.PI);
	                ctx.fill();
	            };
	            this.faceLandmarks.positions.forEach(drawPoint);
	        }
	    };
	    return DrawFaceLandmarks;
	}());
	exports.DrawFaceLandmarks = DrawFaceLandmarks;
	function drawFaceLandmarks(canvasArg, faceLandmarks) {
	    var faceLandmarksArray = Array.isArray(faceLandmarks) ? faceLandmarks : [faceLandmarks];
	    faceLandmarksArray.forEach(function (f) {
	        var landmarks = f instanceof FaceLandmarks_1.FaceLandmarks
	            ? f
	            : (WithFaceLandmarks_1.isWithFaceLandmarks(f) ? f.landmarks : undefined);
	        if (!landmarks) {
	            throw new Error('drawFaceLandmarks - expected faceExpressions to be FaceLandmarks | WithFaceLandmarks<WithFaceDetection<{}>> or array thereof');
	        }
	        new DrawFaceLandmarks(landmarks).draw(canvasArg);
	    });
	}
	exports.drawFaceLandmarks = drawFaceLandmarks;
	//# sourceMappingURL=DrawFaceLandmarks.js.map

/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var classes_1 = __webpack_require__(48);
	var FaceDetection_1 = __webpack_require__(97);
	var WithFaceDetection_1 = __webpack_require__(167);
	var utils_1 = __webpack_require__(34);
	var DrawBox_1 = __webpack_require__(593);
	function drawDetections(canvasArg, detections) {
	    var detectionsArray = Array.isArray(detections) ? detections : [detections];
	    detectionsArray.forEach(function (det) {
	        var score = det instanceof FaceDetection_1.FaceDetection
	            ? det.score
	            : (WithFaceDetection_1.isWithFaceDetection(det) ? det.detection.score : undefined);
	        var box = det instanceof FaceDetection_1.FaceDetection
	            ? det.box
	            : (WithFaceDetection_1.isWithFaceDetection(det) ? det.detection.box : new classes_1.Box(det));
	        var label = score ? "" + utils_1.round(score) : undefined;
	        new DrawBox_1.DrawBox(box, { label: label }).draw(canvasArg);
	    });
	}
	exports.drawDetections = drawDetections;
	//# sourceMappingURL=drawDetections.js.map

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var classes_1 = __webpack_require__(48);
	var faceExpressionNet_1 = __webpack_require__(598);
	var WithFaceDetection_1 = __webpack_require__(167);
	var WithFaceExpressions_1 = __webpack_require__(388);
	var utils_1 = __webpack_require__(34);
	var DrawTextField_1 = __webpack_require__(384);
	function drawFaceExpressions(canvasArg, faceExpressions, minConfidence, textFieldAnchor) {
	    if (minConfidence === void 0) { minConfidence = 0.1; }
	    var faceExpressionsArray = Array.isArray(faceExpressions) ? faceExpressions : [faceExpressions];
	    faceExpressionsArray.forEach(function (e) {
	        var expr = e instanceof faceExpressionNet_1.FaceExpressions
	            ? e
	            : (WithFaceExpressions_1.isWithFaceExpressions(e) ? e.expressions : undefined);
	        if (!expr) {
	            throw new Error('drawFaceExpressions - expected faceExpressions to be FaceExpressions | WithFaceExpressions<{}> or array thereof');
	        }
	        var sorted = expr.asSortedArray();
	        var resultsToDisplay = sorted.filter(function (expr) { return expr.probability > minConfidence; });
	        var anchor = WithFaceDetection_1.isWithFaceDetection(e)
	            ? e.detection.box.bottomLeft
	            : (textFieldAnchor || new classes_1.Point(0, 0));
	        var drawTextField = new DrawTextField_1.DrawTextField(resultsToDisplay.map(function (expr) { return expr.expression + " (" + utils_1.round(expr.probability) + ")"; }), anchor);
	        drawTextField.draw(canvasArg);
	    });
	}
	exports.drawFaceExpressions = drawFaceExpressions;
	//# sourceMappingURL=drawFaceExpressions.js.map

/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	tslib_1.__exportStar(__webpack_require__(594), exports);
	tslib_1.__exportStar(__webpack_require__(1452), exports);
	tslib_1.__exportStar(__webpack_require__(1453), exports);
	tslib_1.__exportStar(__webpack_require__(593), exports);
	tslib_1.__exportStar(__webpack_require__(1451), exports);
	tslib_1.__exportStar(__webpack_require__(384), exports);
	//# sourceMappingURL=index.js.map

/***/ },
/* 1455 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function createBrowserEnv() {
	    var fetch = window['fetch'] || function () {
	        throw new Error('fetch - missing fetch implementation for browser environment');
	    };
	    var readFile = function () {
	        throw new Error('readFile - filesystem not available for browser environment');
	    };
	    return {
	        Canvas: HTMLCanvasElement,
	        CanvasRenderingContext2D: CanvasRenderingContext2D,
	        Image: HTMLImageElement,
	        ImageData: ImageData,
	        Video: HTMLVideoElement,
	        createCanvasElement: function () { return document.createElement('canvas'); },
	        createImageElement: function () { return document.createElement('img'); },
	        fetch: fetch,
	        readFile: readFile
	    };
	}
	exports.createBrowserEnv = createBrowserEnv;
	//# sourceMappingURL=createBrowserEnv.js.map

/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var createFileSystem_1 = __webpack_require__(595);
	function createNodejsEnv() {
	    var Canvas = global['Canvas'] || global['HTMLCanvasElement'];
	    var Image = global['Image'] || global['HTMLImageElement'];
	    var createCanvasElement = function () {
	        if (Canvas) {
	            return new Canvas();
	        }
	        throw new Error('createCanvasElement - missing Canvas implementation for nodejs environment');
	    };
	    var createImageElement = function () {
	        if (Image) {
	            return new Image();
	        }
	        throw new Error('createImageElement - missing Image implementation for nodejs environment');
	    };
	    var fetch = global['fetch'] || function () {
	        throw new Error('fetch - missing fetch implementation for nodejs environment');
	    };
	    var fileSystem = createFileSystem_1.createFileSystem();
	    return tslib_1.__assign({ Canvas: Canvas || /** @class */ (function () {
	            function Canvas() {
	            }
	            return Canvas;
	        }()), CanvasRenderingContext2D: global['CanvasRenderingContext2D'] || /** @class */ (function () {
	            function class_1() {
	            }
	            return class_1;
	        }()), Image: Image || /** @class */ (function () {
	            function Image() {
	            }
	            return Image;
	        }()), ImageData: global['ImageData'] || /** @class */ (function () {
	            function class_2() {
	            }
	            return class_2;
	        }()), Video: global['HTMLVideoElement'] || /** @class */ (function () {
	            function class_3() {
	            }
	            return class_3;
	        }()), createCanvasElement: createCanvasElement,
	        createImageElement: createImageElement,
	        fetch: fetch }, fileSystem);
	}
	exports.createNodejsEnv = createNodejsEnv;
	//# sourceMappingURL=createNodejsEnv.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1457 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function isBrowser() {
	    return typeof window === 'object'
	        && typeof document !== 'undefined'
	        && typeof HTMLImageElement !== 'undefined'
	        && typeof HTMLCanvasElement !== 'undefined'
	        && typeof HTMLVideoElement !== 'undefined'
	        && typeof ImageData !== 'undefined'
	        && typeof CanvasRenderingContext2D !== 'undefined';
	}
	exports.isBrowser = isBrowser;
	//# sourceMappingURL=isBrowser.js.map

/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function isNodejs() {
	    return typeof global === 'object'
	        && "function" === 'function'
	        && typeof module !== 'undefined'
	        // issues with gatsby.js: module.exports is undefined
	        // && !!module.exports
	        && typeof process !== 'undefined' && !!process.version;
	}
	exports.isNodejs = isNodejs;
	//# sourceMappingURL=isNodejs.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(39)))

/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var dom_1 = __webpack_require__(54);
	var NeuralNetwork_1 = __webpack_require__(96);
	var ops_1 = __webpack_require__(98);
	var denseBlock_1 = __webpack_require__(600);
	var extractParamsFromWeigthMapTiny_1 = __webpack_require__(1462);
	var extractParamsTiny_1 = __webpack_require__(1463);
	var TinyFaceFeatureExtractor = /** @class */ (function (_super) {
	    tslib_1.__extends(TinyFaceFeatureExtractor, _super);
	    function TinyFaceFeatureExtractor() {
	        return _super.call(this, 'TinyFaceFeatureExtractor') || this;
	    }
	    TinyFaceFeatureExtractor.prototype.forwardInput = function (input) {
	        var params = this.params;
	        if (!params) {
	            throw new Error('TinyFaceFeatureExtractor - load model before inference');
	        }
	        return tf.tidy(function () {
	            var batchTensor = input.toBatchTensor(112, true);
	            var meanRgb = [122.782, 117.001, 104.298];
	            var normalized = ops_1.normalize(batchTensor, meanRgb).div(tf.scalar(255));
	            var out = denseBlock_1.denseBlock3(normalized, params.dense0, true);
	            out = denseBlock_1.denseBlock3(out, params.dense1);
	            out = denseBlock_1.denseBlock3(out, params.dense2);
	            out = tf.avgPool(out, [14, 14], [2, 2], 'valid');
	            return out;
	        });
	    };
	    TinyFaceFeatureExtractor.prototype.forward = function (input) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _a;
	            return tslib_1.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        _a = this.forwardInput;
	                        return [4 /*yield*/, dom_1.toNetInput(input)];
	                    case 1: return [2 /*return*/, _a.apply(this, [_b.sent()])];
	                }
	            });
	        });
	    };
	    TinyFaceFeatureExtractor.prototype.getDefaultModelName = function () {
	        return 'face_feature_extractor_tiny_model';
	    };
	    TinyFaceFeatureExtractor.prototype.extractParamsFromWeigthMap = function (weightMap) {
	        return extractParamsFromWeigthMapTiny_1.extractParamsFromWeigthMapTiny(weightMap);
	    };
	    TinyFaceFeatureExtractor.prototype.extractParams = function (weights) {
	        return extractParamsTiny_1.extractParamsTiny(weights);
	    };
	    return TinyFaceFeatureExtractor;
	}(NeuralNetwork_1.NeuralNetwork));
	exports.TinyFaceFeatureExtractor = TinyFaceFeatureExtractor;
	//# sourceMappingURL=TinyFaceFeatureExtractor.js.map

/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(33);
	var extractorsFactory_1 = __webpack_require__(601);
	function extractParams(weights) {
	    var paramMappings = [];
	    var _a = common_1.extractWeightsFactory(weights), extractWeights = _a.extractWeights, getRemainingWeights = _a.getRemainingWeights;
	    var extractDenseBlock4Params = extractorsFactory_1.extractorsFactory(extractWeights, paramMappings).extractDenseBlock4Params;
	    var dense0 = extractDenseBlock4Params(3, 32, 'dense0', true);
	    var dense1 = extractDenseBlock4Params(32, 64, 'dense1');
	    var dense2 = extractDenseBlock4Params(64, 128, 'dense2');
	    var dense3 = extractDenseBlock4Params(128, 256, 'dense3');
	    if (getRemainingWeights().length !== 0) {
	        throw new Error("weights remaing after extract: " + getRemainingWeights().length);
	    }
	    return {
	        paramMappings: paramMappings,
	        params: { dense0: dense0, dense1: dense1, dense2: dense2, dense3: dense3 }
	    };
	}
	exports.extractParams = extractParams;
	//# sourceMappingURL=extractParams.js.map

/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(33);
	var loadParamsFactory_1 = __webpack_require__(602);
	function extractParamsFromWeigthMap(weightMap) {
	    var paramMappings = [];
	    var extractDenseBlock4Params = loadParamsFactory_1.loadParamsFactory(weightMap, paramMappings).extractDenseBlock4Params;
	    var params = {
	        dense0: extractDenseBlock4Params('dense0', true),
	        dense1: extractDenseBlock4Params('dense1'),
	        dense2: extractDenseBlock4Params('dense2'),
	        dense3: extractDenseBlock4Params('dense3')
	    };
	    common_1.disposeUnusedWeightTensors(weightMap, paramMappings);
	    return { params: params, paramMappings: paramMappings };
	}
	exports.extractParamsFromWeigthMap = extractParamsFromWeigthMap;
	//# sourceMappingURL=extractParamsFromWeigthMap.js.map

/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(33);
	var loadParamsFactory_1 = __webpack_require__(602);
	function extractParamsFromWeigthMapTiny(weightMap) {
	    var paramMappings = [];
	    var extractDenseBlock3Params = loadParamsFactory_1.loadParamsFactory(weightMap, paramMappings).extractDenseBlock3Params;
	    var params = {
	        dense0: extractDenseBlock3Params('dense0', true),
	        dense1: extractDenseBlock3Params('dense1'),
	        dense2: extractDenseBlock3Params('dense2')
	    };
	    common_1.disposeUnusedWeightTensors(weightMap, paramMappings);
	    return { params: params, paramMappings: paramMappings };
	}
	exports.extractParamsFromWeigthMapTiny = extractParamsFromWeigthMapTiny;
	//# sourceMappingURL=extractParamsFromWeigthMapTiny.js.map

/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(33);
	var extractorsFactory_1 = __webpack_require__(601);
	function extractParamsTiny(weights) {
	    var paramMappings = [];
	    var _a = common_1.extractWeightsFactory(weights), extractWeights = _a.extractWeights, getRemainingWeights = _a.getRemainingWeights;
	    var extractDenseBlock3Params = extractorsFactory_1.extractorsFactory(extractWeights, paramMappings).extractDenseBlock3Params;
	    var dense0 = extractDenseBlock3Params(3, 32, 'dense0', true);
	    var dense1 = extractDenseBlock3Params(32, 64, 'dense1');
	    var dense2 = extractDenseBlock3Params(64, 128, 'dense2');
	    if (getRemainingWeights().length !== 0) {
	        throw new Error("weights remaing after extract: " + getRemainingWeights().length);
	    }
	    return {
	        paramMappings: paramMappings,
	        params: { dense0: dense0, dense1: dense1, dense2: dense2 }
	    };
	}
	exports.extractParamsTiny = extractParamsTiny;
	//# sourceMappingURL=extractParamsTiny.js.map

/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var FaceLandmark68Net_1 = __webpack_require__(386);
	tslib_1.__exportStar(__webpack_require__(386), exports);
	tslib_1.__exportStar(__webpack_require__(604), exports);
	var FaceLandmarkNet = /** @class */ (function (_super) {
	    tslib_1.__extends(FaceLandmarkNet, _super);
	    function FaceLandmarkNet() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return FaceLandmarkNet;
	}(FaceLandmark68Net_1.FaceLandmark68Net));
	exports.FaceLandmarkNet = FaceLandmarkNet;
	//# sourceMappingURL=index.js.map

/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(33);
	function extractParams(weights, channelsIn, channelsOut) {
	    var paramMappings = [];
	    var _a = common_1.extractWeightsFactory(weights), extractWeights = _a.extractWeights, getRemainingWeights = _a.getRemainingWeights;
	    var extractFCParams = common_1.extractFCParamsFactory(extractWeights, paramMappings);
	    var fc = extractFCParams(channelsIn, channelsOut, 'fc');
	    if (getRemainingWeights().length !== 0) {
	        throw new Error("weights remaing after extract: " + getRemainingWeights().length);
	    }
	    return {
	        paramMappings: paramMappings,
	        params: { fc: fc }
	    };
	}
	exports.extractParams = extractParams;
	//# sourceMappingURL=extractParams.js.map

/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(33);
	function extractParamsFromWeigthMap(weightMap) {
	    var paramMappings = [];
	    var extractWeightEntry = common_1.extractWeightEntryFactory(weightMap, paramMappings);
	    function extractFcParams(prefix) {
	        var weights = extractWeightEntry(prefix + "/weights", 2);
	        var bias = extractWeightEntry(prefix + "/bias", 1);
	        return { weights: weights, bias: bias };
	    }
	    var params = {
	        fc: extractFcParams('fc')
	    };
	    common_1.disposeUnusedWeightTensors(weightMap, paramMappings);
	    return { params: params, paramMappings: paramMappings };
	}
	exports.extractParamsFromWeigthMap = extractParamsFromWeigthMap;
	//# sourceMappingURL=extractParamsFromWeigthMap.js.map

/***/ },
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	var common_1 = __webpack_require__(33);
	var utils_1 = __webpack_require__(34);
	function extractorsFactory(extractWeights, paramMappings) {
	    function extractFilterValues(numFilterValues, numFilters, filterSize) {
	        var weights = extractWeights(numFilterValues);
	        var depth = weights.length / (numFilters * filterSize * filterSize);
	        if (utils_1.isFloat(depth)) {
	            throw new Error("depth has to be an integer: " + depth + ", weights.length: " + weights.length + ", numFilters: " + numFilters + ", filterSize: " + filterSize);
	        }
	        return tf.tidy(function () { return tf.transpose(tf.tensor4d(weights, [numFilters, depth, filterSize, filterSize]), [2, 3, 1, 0]); });
	    }
	    function extractConvParams(numFilterValues, numFilters, filterSize, mappedPrefix) {
	        var filters = extractFilterValues(numFilterValues, numFilters, filterSize);
	        var bias = tf.tensor1d(extractWeights(numFilters));
	        paramMappings.push({ paramPath: mappedPrefix + "/filters" }, { paramPath: mappedPrefix + "/bias" });
	        return { filters: filters, bias: bias };
	    }
	    function extractScaleLayerParams(numWeights, mappedPrefix) {
	        var weights = tf.tensor1d(extractWeights(numWeights));
	        var biases = tf.tensor1d(extractWeights(numWeights));
	        paramMappings.push({ paramPath: mappedPrefix + "/weights" }, { paramPath: mappedPrefix + "/biases" });
	        return {
	            weights: weights,
	            biases: biases
	        };
	    }
	    function extractConvLayerParams(numFilterValues, numFilters, filterSize, mappedPrefix) {
	        var conv = extractConvParams(numFilterValues, numFilters, filterSize, mappedPrefix + "/conv");
	        var scale = extractScaleLayerParams(numFilters, mappedPrefix + "/scale");
	        return { conv: conv, scale: scale };
	    }
	    function extractResidualLayerParams(numFilterValues, numFilters, filterSize, mappedPrefix, isDown) {
	        if (isDown === void 0) { isDown = false; }
	        var conv1 = extractConvLayerParams((isDown ? 0.5 : 1) * numFilterValues, numFilters, filterSize, mappedPrefix + "/conv1");
	        var conv2 = extractConvLayerParams(numFilterValues, numFilters, filterSize, mappedPrefix + "/conv2");
	        return { conv1: conv1, conv2: conv2 };
	    }
	    return {
	        extractConvLayerParams: extractConvLayerParams,
	        extractResidualLayerParams: extractResidualLayerParams
	    };
	}
	function extractParams(weights) {
	    var _a = common_1.extractWeightsFactory(weights), extractWeights = _a.extractWeights, getRemainingWeights = _a.getRemainingWeights;
	    var paramMappings = [];
	    var _b = extractorsFactory(extractWeights, paramMappings), extractConvLayerParams = _b.extractConvLayerParams, extractResidualLayerParams = _b.extractResidualLayerParams;
	    var conv32_down = extractConvLayerParams(4704, 32, 7, 'conv32_down');
	    var conv32_1 = extractResidualLayerParams(9216, 32, 3, 'conv32_1');
	    var conv32_2 = extractResidualLayerParams(9216, 32, 3, 'conv32_2');
	    var conv32_3 = extractResidualLayerParams(9216, 32, 3, 'conv32_3');
	    var conv64_down = extractResidualLayerParams(36864, 64, 3, 'conv64_down', true);
	    var conv64_1 = extractResidualLayerParams(36864, 64, 3, 'conv64_1');
	    var conv64_2 = extractResidualLayerParams(36864, 64, 3, 'conv64_2');
	    var conv64_3 = extractResidualLayerParams(36864, 64, 3, 'conv64_3');
	    var conv128_down = extractResidualLayerParams(147456, 128, 3, 'conv128_down', true);
	    var conv128_1 = extractResidualLayerParams(147456, 128, 3, 'conv128_1');
	    var conv128_2 = extractResidualLayerParams(147456, 128, 3, 'conv128_2');
	    var conv256_down = extractResidualLayerParams(589824, 256, 3, 'conv256_down', true);
	    var conv256_1 = extractResidualLayerParams(589824, 256, 3, 'conv256_1');
	    var conv256_2 = extractResidualLayerParams(589824, 256, 3, 'conv256_2');
	    var conv256_down_out = extractResidualLayerParams(589824, 256, 3, 'conv256_down_out');
	    var fc = tf.tidy(function () { return tf.transpose(tf.tensor2d(extractWeights(256 * 128), [128, 256]), [1, 0]); });
	    paramMappings.push({ paramPath: "fc" });
	    if (getRemainingWeights().length !== 0) {
	        throw new Error("weights remaing after extract: " + getRemainingWeights().length);
	    }
	    var params = {
	        conv32_down: conv32_down,
	        conv32_1: conv32_1,
	        conv32_2: conv32_2,
	        conv32_3: conv32_3,
	        conv64_down: conv64_down,
	        conv64_1: conv64_1,
	        conv64_2: conv64_2,
	        conv64_3: conv64_3,
	        conv128_down: conv128_down,
	        conv128_1: conv128_1,
	        conv128_2: conv128_2,
	        conv256_down: conv256_down,
	        conv256_1: conv256_1,
	        conv256_2: conv256_2,
	        conv256_down_out: conv256_down_out,
	        fc: fc
	    };
	    return { params: params, paramMappings: paramMappings };
	}
	exports.extractParams = extractParams;
	//# sourceMappingURL=extractParams.js.map

/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(33);
	var utils_1 = __webpack_require__(34);
	function extractorsFactory(weightMap, paramMappings) {
	    var extractWeightEntry = common_1.extractWeightEntryFactory(weightMap, paramMappings);
	    function extractScaleLayerParams(prefix) {
	        var weights = extractWeightEntry(prefix + "/scale/weights", 1);
	        var biases = extractWeightEntry(prefix + "/scale/biases", 1);
	        return { weights: weights, biases: biases };
	    }
	    function extractConvLayerParams(prefix) {
	        var filters = extractWeightEntry(prefix + "/conv/filters", 4);
	        var bias = extractWeightEntry(prefix + "/conv/bias", 1);
	        var scale = extractScaleLayerParams(prefix);
	        return { conv: { filters: filters, bias: bias }, scale: scale };
	    }
	    function extractResidualLayerParams(prefix) {
	        return {
	            conv1: extractConvLayerParams(prefix + "/conv1"),
	            conv2: extractConvLayerParams(prefix + "/conv2")
	        };
	    }
	    return {
	        extractConvLayerParams: extractConvLayerParams,
	        extractResidualLayerParams: extractResidualLayerParams
	    };
	}
	function extractParamsFromWeigthMap(weightMap) {
	    var paramMappings = [];
	    var _a = extractorsFactory(weightMap, paramMappings), extractConvLayerParams = _a.extractConvLayerParams, extractResidualLayerParams = _a.extractResidualLayerParams;
	    var conv32_down = extractConvLayerParams('conv32_down');
	    var conv32_1 = extractResidualLayerParams('conv32_1');
	    var conv32_2 = extractResidualLayerParams('conv32_2');
	    var conv32_3 = extractResidualLayerParams('conv32_3');
	    var conv64_down = extractResidualLayerParams('conv64_down');
	    var conv64_1 = extractResidualLayerParams('conv64_1');
	    var conv64_2 = extractResidualLayerParams('conv64_2');
	    var conv64_3 = extractResidualLayerParams('conv64_3');
	    var conv128_down = extractResidualLayerParams('conv128_down');
	    var conv128_1 = extractResidualLayerParams('conv128_1');
	    var conv128_2 = extractResidualLayerParams('conv128_2');
	    var conv256_down = extractResidualLayerParams('conv256_down');
	    var conv256_1 = extractResidualLayerParams('conv256_1');
	    var conv256_2 = extractResidualLayerParams('conv256_2');
	    var conv256_down_out = extractResidualLayerParams('conv256_down_out');
	    var fc = weightMap['fc'];
	    paramMappings.push({ originalPath: 'fc', paramPath: 'fc' });
	    if (!utils_1.isTensor2D(fc)) {
	        throw new Error("expected weightMap[fc] to be a Tensor2D, instead have " + fc);
	    }
	    var params = {
	        conv32_down: conv32_down,
	        conv32_1: conv32_1,
	        conv32_2: conv32_2,
	        conv32_3: conv32_3,
	        conv64_down: conv64_down,
	        conv64_1: conv64_1,
	        conv64_2: conv64_2,
	        conv64_3: conv64_3,
	        conv128_down: conv128_down,
	        conv128_1: conv128_1,
	        conv128_2: conv128_2,
	        conv256_down: conv256_down,
	        conv256_1: conv256_1,
	        conv256_2: conv256_2,
	        conv256_down_out: conv256_down_out,
	        fc: fc
	    };
	    common_1.disposeUnusedWeightTensors(weightMap, paramMappings);
	    return { params: params, paramMappings: paramMappings };
	}
	exports.extractParamsFromWeigthMap = extractParamsFromWeigthMap;
	//# sourceMappingURL=extractParamsFromWeigthMap.js.map

/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var FaceRecognitionNet_1 = __webpack_require__(387);
	tslib_1.__exportStar(__webpack_require__(387), exports);
	function createFaceRecognitionNet(weights) {
	    var net = new FaceRecognitionNet_1.FaceRecognitionNet();
	    net.extractWeights(weights);
	    return net;
	}
	exports.createFaceRecognitionNet = createFaceRecognitionNet;
	//# sourceMappingURL=index.js.map

/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var convLayer_1 = __webpack_require__(607);
	function residual(x, params) {
	    var out = convLayer_1.conv(x, params.conv1);
	    out = convLayer_1.convNoRelu(out, params.conv2);
	    out = tf.add(out, x);
	    out = tf.relu(out);
	    return out;
	}
	exports.residual = residual;
	function residualDown(x, params) {
	    var out = convLayer_1.convDown(x, params.conv1);
	    out = convLayer_1.convNoRelu(out, params.conv2);
	    var pooled = tf.avgPool(x, 2, 2, 'valid');
	    var zeros = tf.zeros(pooled.shape);
	    var isPad = pooled.shape[3] !== out.shape[3];
	    var isAdjustShape = pooled.shape[1] !== out.shape[1] || pooled.shape[2] !== out.shape[2];
	    if (isAdjustShape) {
	        var padShapeX = tslib_1.__spreadArrays(out.shape);
	        padShapeX[1] = 1;
	        var zerosW = tf.zeros(padShapeX);
	        out = tf.concat([out, zerosW], 1);
	        var padShapeY = tslib_1.__spreadArrays(out.shape);
	        padShapeY[2] = 1;
	        var zerosH = tf.zeros(padShapeY);
	        out = tf.concat([out, zerosH], 2);
	    }
	    pooled = isPad ? tf.concat([pooled, zeros], 3) : pooled;
	    out = tf.add(pooled, out);
	    out = tf.relu(out);
	    return out;
	}
	exports.residualDown = residualDown;
	//# sourceMappingURL=residualLayer.js.map

/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	function scale(x, params) {
	    return tf.add(tf.mul(x, params.weights), params.biases);
	}
	exports.scale = scale;
	//# sourceMappingURL=scaleLayer.js.map

/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var FaceMatch_1 = __webpack_require__(575);
	var LabeledFaceDescriptors_1 = __webpack_require__(577);
	var euclideanDistance_1 = __webpack_require__(596);
	var FaceMatcher = /** @class */ (function () {
	    function FaceMatcher(inputs, distanceThreshold) {
	        if (distanceThreshold === void 0) { distanceThreshold = 0.6; }
	        this._distanceThreshold = distanceThreshold;
	        var inputArray = Array.isArray(inputs) ? inputs : [inputs];
	        if (!inputArray.length) {
	            throw new Error("FaceRecognizer.constructor - expected atleast one input");
	        }
	        var count = 1;
	        var createUniqueLabel = function () { return "person " + count++; };
	        this._labeledDescriptors = inputArray.map(function (desc) {
	            if (desc instanceof LabeledFaceDescriptors_1.LabeledFaceDescriptors) {
	                return desc;
	            }
	            if (desc instanceof Float32Array) {
	                return new LabeledFaceDescriptors_1.LabeledFaceDescriptors(createUniqueLabel(), [desc]);
	            }
	            if (desc.descriptor && desc.descriptor instanceof Float32Array) {
	                return new LabeledFaceDescriptors_1.LabeledFaceDescriptors(createUniqueLabel(), [desc.descriptor]);
	            }
	            throw new Error("FaceRecognizer.constructor - expected inputs to be of type LabeledFaceDescriptors | WithFaceDescriptor<any> | Float32Array | Array<LabeledFaceDescriptors | WithFaceDescriptor<any> | Float32Array>");
	        });
	    }
	    Object.defineProperty(FaceMatcher.prototype, "labeledDescriptors", {
	        get: function () { return this._labeledDescriptors; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FaceMatcher.prototype, "distanceThreshold", {
	        get: function () { return this._distanceThreshold; },
	        enumerable: true,
	        configurable: true
	    });
	    FaceMatcher.prototype.computeMeanDistance = function (queryDescriptor, descriptors) {
	        return descriptors
	            .map(function (d) { return euclideanDistance_1.euclideanDistance(d, queryDescriptor); })
	            .reduce(function (d1, d2) { return d1 + d2; }, 0)
	            / (descriptors.length || 1);
	    };
	    FaceMatcher.prototype.matchDescriptor = function (queryDescriptor) {
	        var _this = this;
	        return this.labeledDescriptors
	            .map(function (_a) {
	            var descriptors = _a.descriptors, label = _a.label;
	            return new FaceMatch_1.FaceMatch(label, _this.computeMeanDistance(queryDescriptor, descriptors));
	        })
	            .reduce(function (best, curr) { return best.distance < curr.distance ? best : curr; });
	    };
	    FaceMatcher.prototype.findBestMatch = function (queryDescriptor) {
	        var bestMatch = this.matchDescriptor(queryDescriptor);
	        return bestMatch.distance < this.distanceThreshold
	            ? bestMatch
	            : new FaceMatch_1.FaceMatch('unknown', bestMatch.distance);
	    };
	    FaceMatcher.prototype.toJSON = function () {
	        return {
	            distanceThreshold: this.distanceThreshold,
	            labeledDescriptors: this.labeledDescriptors.map(function (ld) { return ld.toJSON(); })
	        };
	    };
	    FaceMatcher.fromJSON = function (json) {
	        var labeledDescriptors = json.labeledDescriptors
	            .map(function (ld) { return LabeledFaceDescriptors_1.LabeledFaceDescriptors.fromJSON(ld); });
	        return new FaceMatcher(labeledDescriptors, json.distanceThreshold);
	    };
	    return FaceMatcher;
	}());
	exports.FaceMatcher = FaceMatcher;
	//# sourceMappingURL=FaceMatcher.js.map

/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var MtcnnOptions_1 = __webpack_require__(272);
	var ssdMobilenetv1_1 = __webpack_require__(622);
	var tinyYolov2_1 = __webpack_require__(212);
	var detectFaces_1 = __webpack_require__(614);
	// export allFaces API for backward compatibility
	function allFacesSsdMobilenetv1(input, minConfidence) {
	    return tslib_1.__awaiter(this, void 0, void 0, function () {
	        return tslib_1.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    console.warn('allFacesSsdMobilenetv1 is deprecated and will be removed soon, use the high level api instead');
	                    return [4 /*yield*/, detectFaces_1.detectAllFaces(input, new ssdMobilenetv1_1.SsdMobilenetv1Options(minConfidence ? { minConfidence: minConfidence } : {}))
	                            .withFaceLandmarks()
	                            .withFaceDescriptors()];
	                case 1: return [2 /*return*/, _a.sent()];
	            }
	        });
	    });
	}
	exports.allFacesSsdMobilenetv1 = allFacesSsdMobilenetv1;
	function allFacesTinyYolov2(input, forwardParams) {
	    if (forwardParams === void 0) { forwardParams = {}; }
	    return tslib_1.__awaiter(this, void 0, void 0, function () {
	        return tslib_1.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    console.warn('allFacesTinyYolov2 is deprecated and will be removed soon, use the high level api instead');
	                    return [4 /*yield*/, detectFaces_1.detectAllFaces(input, new tinyYolov2_1.TinyYolov2Options(forwardParams))
	                            .withFaceLandmarks()
	                            .withFaceDescriptors()];
	                case 1: return [2 /*return*/, _a.sent()];
	            }
	        });
	    });
	}
	exports.allFacesTinyYolov2 = allFacesTinyYolov2;
	function allFacesMtcnn(input, forwardParams) {
	    if (forwardParams === void 0) { forwardParams = {}; }
	    return tslib_1.__awaiter(this, void 0, void 0, function () {
	        return tslib_1.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    console.warn('allFacesMtcnn is deprecated and will be removed soon, use the high level api instead');
	                    return [4 /*yield*/, detectFaces_1.detectAllFaces(input, new MtcnnOptions_1.MtcnnOptions(forwardParams))
	                            .withFaceLandmarks()
	                            .withFaceDescriptors()];
	                case 1: return [2 /*return*/, _a.sent()];
	            }
	        });
	    });
	}
	exports.allFacesMtcnn = allFacesMtcnn;
	exports.allFaces = allFacesSsdMobilenetv1;
	//# sourceMappingURL=allFaces.js.map

/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	tslib_1.__exportStar(__webpack_require__(1473), exports);
	tslib_1.__exportStar(__webpack_require__(168), exports);
	tslib_1.__exportStar(__webpack_require__(269), exports);
	tslib_1.__exportStar(__webpack_require__(614), exports);
	tslib_1.__exportStar(__webpack_require__(613), exports);
	tslib_1.__exportStar(__webpack_require__(612), exports);
	tslib_1.__exportStar(__webpack_require__(1472), exports);
	tslib_1.__exportStar(__webpack_require__(169), exports);
	//# sourceMappingURL=index.js.map

/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	exports.tf = tf;
	var draw = __webpack_require__(1454);
	exports.draw = draw;
	var utils = __webpack_require__(34);
	exports.utils = utils;
	tslib_1.__exportStar(__webpack_require__(1440), exports);
	tslib_1.__exportStar(__webpack_require__(48), exports);
	tslib_1.__exportStar(__webpack_require__(54), exports);
	tslib_1.__exportStar(__webpack_require__(55), exports);
	tslib_1.__exportStar(__webpack_require__(598), exports);
	tslib_1.__exportStar(__webpack_require__(1464), exports);
	tslib_1.__exportStar(__webpack_require__(1469), exports);
	tslib_1.__exportStar(__webpack_require__(611), exports);
	tslib_1.__exportStar(__webpack_require__(1474), exports);
	tslib_1.__exportStar(__webpack_require__(1482), exports);
	tslib_1.__exportStar(__webpack_require__(98), exports);
	tslib_1.__exportStar(__webpack_require__(622), exports);
	tslib_1.__exportStar(__webpack_require__(1498), exports);
	tslib_1.__exportStar(__webpack_require__(212), exports);
	tslib_1.__exportStar(__webpack_require__(596), exports);
	tslib_1.__exportStar(__webpack_require__(96), exports);
	tslib_1.__exportStar(__webpack_require__(1489), exports);
	//# sourceMappingURL=index.js.map

/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	var common_1 = __webpack_require__(33);
	var fullyConnectedLayer_1 = __webpack_require__(264);
	var prelu_1 = __webpack_require__(393);
	var sharedLayers_1 = __webpack_require__(394);
	function ONet(x, params) {
	    return tf.tidy(function () {
	        var out = sharedLayers_1.sharedLayer(x, params);
	        out = tf.maxPool(out, [2, 2], [2, 2], 'same');
	        out = common_1.convLayer(out, params.conv4, 'valid');
	        out = prelu_1.prelu(out, params.prelu4_alpha);
	        var vectorized = tf.reshape(out, [out.shape[0], params.fc1.weights.shape[0]]);
	        var fc1 = fullyConnectedLayer_1.fullyConnectedLayer(vectorized, params.fc1);
	        var prelu5 = prelu_1.prelu(fc1, params.prelu5_alpha);
	        var fc2_1 = fullyConnectedLayer_1.fullyConnectedLayer(prelu5, params.fc2_1);
	        var max = tf.expandDims(tf.max(fc2_1, 1), 1);
	        var prob = tf.softmax(tf.sub(fc2_1, max), 1);
	        var regions = fullyConnectedLayer_1.fullyConnectedLayer(prelu5, params.fc2_2);
	        var points = fullyConnectedLayer_1.fullyConnectedLayer(prelu5, params.fc2_3);
	        var scores = tf.unstack(prob, 1)[1];
	        return { scores: scores, regions: regions, points: points };
	    });
	}
	exports.ONet = ONet;
	//# sourceMappingURL=ONet.js.map

/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	var common_1 = __webpack_require__(33);
	var sharedLayers_1 = __webpack_require__(394);
	function PNet(x, params) {
	    return tf.tidy(function () {
	        var out = sharedLayers_1.sharedLayer(x, params, true);
	        var conv = common_1.convLayer(out, params.conv4_1, 'valid');
	        var max = tf.expandDims(tf.max(conv, 3), 3);
	        var prob = tf.softmax(tf.sub(conv, max), 3);
	        var regions = common_1.convLayer(out, params.conv4_2, 'valid');
	        return { prob: prob, regions: regions };
	    });
	}
	exports.PNet = PNet;
	//# sourceMappingURL=PNet.js.map

/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	var fullyConnectedLayer_1 = __webpack_require__(264);
	var prelu_1 = __webpack_require__(393);
	var sharedLayers_1 = __webpack_require__(394);
	function RNet(x, params) {
	    return tf.tidy(function () {
	        var convOut = sharedLayers_1.sharedLayer(x, params);
	        var vectorized = tf.reshape(convOut, [convOut.shape[0], params.fc1.weights.shape[0]]);
	        var fc1 = fullyConnectedLayer_1.fullyConnectedLayer(vectorized, params.fc1);
	        var prelu4 = prelu_1.prelu(fc1, params.prelu4_alpha);
	        var fc2_1 = fullyConnectedLayer_1.fullyConnectedLayer(prelu4, params.fc2_1);
	        var max = tf.expandDims(tf.max(fc2_1, 1), 1);
	        var prob = tf.softmax(tf.sub(fc2_1, max), 1);
	        var regions = fullyConnectedLayer_1.fullyConnectedLayer(prelu4, params.fc2_2);
	        var scores = tf.unstack(prob, 1)[1];
	        return { scores: scores, regions: regions };
	    });
	}
	exports.RNet = RNet;
	//# sourceMappingURL=RNet.js.map

/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	function bgrToRgbTensor(tensor) {
	    return tf.tidy(function () { return tf.stack(tf.unstack(tensor, 3).reverse(), 3); });
	}
	exports.bgrToRgbTensor = bgrToRgbTensor;
	//# sourceMappingURL=bgrToRgbTensor.js.map

/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var common_1 = __webpack_require__(33);
	function extractorsFactory(extractWeights, paramMappings) {
	    var extractConvParams = common_1.extractConvParamsFactory(extractWeights, paramMappings);
	    var extractFCParams = common_1.extractFCParamsFactory(extractWeights, paramMappings);
	    function extractPReluParams(size, paramPath) {
	        var alpha = tf.tensor1d(extractWeights(size));
	        paramMappings.push({ paramPath: paramPath });
	        return alpha;
	    }
	    function extractSharedParams(numFilters, mappedPrefix, isRnet) {
	        if (isRnet === void 0) { isRnet = false; }
	        var conv1 = extractConvParams(numFilters[0], numFilters[1], 3, mappedPrefix + "/conv1");
	        var prelu1_alpha = extractPReluParams(numFilters[1], mappedPrefix + "/prelu1_alpha");
	        var conv2 = extractConvParams(numFilters[1], numFilters[2], 3, mappedPrefix + "/conv2");
	        var prelu2_alpha = extractPReluParams(numFilters[2], mappedPrefix + "/prelu2_alpha");
	        var conv3 = extractConvParams(numFilters[2], numFilters[3], isRnet ? 2 : 3, mappedPrefix + "/conv3");
	        var prelu3_alpha = extractPReluParams(numFilters[3], mappedPrefix + "/prelu3_alpha");
	        return { conv1: conv1, prelu1_alpha: prelu1_alpha, conv2: conv2, prelu2_alpha: prelu2_alpha, conv3: conv3, prelu3_alpha: prelu3_alpha };
	    }
	    function extractPNetParams() {
	        var sharedParams = extractSharedParams([3, 10, 16, 32], 'pnet');
	        var conv4_1 = extractConvParams(32, 2, 1, 'pnet/conv4_1');
	        var conv4_2 = extractConvParams(32, 4, 1, 'pnet/conv4_2');
	        return tslib_1.__assign(tslib_1.__assign({}, sharedParams), { conv4_1: conv4_1, conv4_2: conv4_2 });
	    }
	    function extractRNetParams() {
	        var sharedParams = extractSharedParams([3, 28, 48, 64], 'rnet', true);
	        var fc1 = extractFCParams(576, 128, 'rnet/fc1');
	        var prelu4_alpha = extractPReluParams(128, 'rnet/prelu4_alpha');
	        var fc2_1 = extractFCParams(128, 2, 'rnet/fc2_1');
	        var fc2_2 = extractFCParams(128, 4, 'rnet/fc2_2');
	        return tslib_1.__assign(tslib_1.__assign({}, sharedParams), { fc1: fc1, prelu4_alpha: prelu4_alpha, fc2_1: fc2_1, fc2_2: fc2_2 });
	    }
	    function extractONetParams() {
	        var sharedParams = extractSharedParams([3, 32, 64, 64], 'onet');
	        var conv4 = extractConvParams(64, 128, 2, 'onet/conv4');
	        var prelu4_alpha = extractPReluParams(128, 'onet/prelu4_alpha');
	        var fc1 = extractFCParams(1152, 256, 'onet/fc1');
	        var prelu5_alpha = extractPReluParams(256, 'onet/prelu5_alpha');
	        var fc2_1 = extractFCParams(256, 2, 'onet/fc2_1');
	        var fc2_2 = extractFCParams(256, 4, 'onet/fc2_2');
	        var fc2_3 = extractFCParams(256, 10, 'onet/fc2_3');
	        return tslib_1.__assign(tslib_1.__assign({}, sharedParams), { conv4: conv4, prelu4_alpha: prelu4_alpha, fc1: fc1, prelu5_alpha: prelu5_alpha, fc2_1: fc2_1, fc2_2: fc2_2, fc2_3: fc2_3 });
	    }
	    return {
	        extractPNetParams: extractPNetParams,
	        extractRNetParams: extractRNetParams,
	        extractONetParams: extractONetParams
	    };
	}
	function extractParams(weights) {
	    var _a = common_1.extractWeightsFactory(weights), extractWeights = _a.extractWeights, getRemainingWeights = _a.getRemainingWeights;
	    var paramMappings = [];
	    var _b = extractorsFactory(extractWeights, paramMappings), extractPNetParams = _b.extractPNetParams, extractRNetParams = _b.extractRNetParams, extractONetParams = _b.extractONetParams;
	    var pnet = extractPNetParams();
	    var rnet = extractRNetParams();
	    var onet = extractONetParams();
	    if (getRemainingWeights().length !== 0) {
	        throw new Error("weights remaing after extract: " + getRemainingWeights().length);
	    }
	    return { params: { pnet: pnet, rnet: rnet, onet: onet }, paramMappings: paramMappings };
	}
	exports.extractParams = extractParams;
	//# sourceMappingURL=extractParams.js.map

/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var common_1 = __webpack_require__(33);
	function extractorsFactory(weightMap, paramMappings) {
	    var extractWeightEntry = common_1.extractWeightEntryFactory(weightMap, paramMappings);
	    function extractConvParams(prefix) {
	        var filters = extractWeightEntry(prefix + "/weights", 4, prefix + "/filters");
	        var bias = extractWeightEntry(prefix + "/bias", 1);
	        return { filters: filters, bias: bias };
	    }
	    function extractFCParams(prefix) {
	        var weights = extractWeightEntry(prefix + "/weights", 2);
	        var bias = extractWeightEntry(prefix + "/bias", 1);
	        return { weights: weights, bias: bias };
	    }
	    function extractPReluParams(paramPath) {
	        return extractWeightEntry(paramPath, 1);
	    }
	    function extractSharedParams(prefix) {
	        var conv1 = extractConvParams(prefix + "/conv1");
	        var prelu1_alpha = extractPReluParams(prefix + "/prelu1_alpha");
	        var conv2 = extractConvParams(prefix + "/conv2");
	        var prelu2_alpha = extractPReluParams(prefix + "/prelu2_alpha");
	        var conv3 = extractConvParams(prefix + "/conv3");
	        var prelu3_alpha = extractPReluParams(prefix + "/prelu3_alpha");
	        return { conv1: conv1, prelu1_alpha: prelu1_alpha, conv2: conv2, prelu2_alpha: prelu2_alpha, conv3: conv3, prelu3_alpha: prelu3_alpha };
	    }
	    function extractPNetParams() {
	        var sharedParams = extractSharedParams('pnet');
	        var conv4_1 = extractConvParams('pnet/conv4_1');
	        var conv4_2 = extractConvParams('pnet/conv4_2');
	        return tslib_1.__assign(tslib_1.__assign({}, sharedParams), { conv4_1: conv4_1, conv4_2: conv4_2 });
	    }
	    function extractRNetParams() {
	        var sharedParams = extractSharedParams('rnet');
	        var fc1 = extractFCParams('rnet/fc1');
	        var prelu4_alpha = extractPReluParams('rnet/prelu4_alpha');
	        var fc2_1 = extractFCParams('rnet/fc2_1');
	        var fc2_2 = extractFCParams('rnet/fc2_2');
	        return tslib_1.__assign(tslib_1.__assign({}, sharedParams), { fc1: fc1, prelu4_alpha: prelu4_alpha, fc2_1: fc2_1, fc2_2: fc2_2 });
	    }
	    function extractONetParams() {
	        var sharedParams = extractSharedParams('onet');
	        var conv4 = extractConvParams('onet/conv4');
	        var prelu4_alpha = extractPReluParams('onet/prelu4_alpha');
	        var fc1 = extractFCParams('onet/fc1');
	        var prelu5_alpha = extractPReluParams('onet/prelu5_alpha');
	        var fc2_1 = extractFCParams('onet/fc2_1');
	        var fc2_2 = extractFCParams('onet/fc2_2');
	        var fc2_3 = extractFCParams('onet/fc2_3');
	        return tslib_1.__assign(tslib_1.__assign({}, sharedParams), { conv4: conv4, prelu4_alpha: prelu4_alpha, fc1: fc1, prelu5_alpha: prelu5_alpha, fc2_1: fc2_1, fc2_2: fc2_2, fc2_3: fc2_3 });
	    }
	    return {
	        extractPNetParams: extractPNetParams,
	        extractRNetParams: extractRNetParams,
	        extractONetParams: extractONetParams
	    };
	}
	function extractParamsFromWeigthMap(weightMap) {
	    var paramMappings = [];
	    var _a = extractorsFactory(weightMap, paramMappings), extractPNetParams = _a.extractPNetParams, extractRNetParams = _a.extractRNetParams, extractONetParams = _a.extractONetParams;
	    var pnet = extractPNetParams();
	    var rnet = extractRNetParams();
	    var onet = extractONetParams();
	    common_1.disposeUnusedWeightTensors(weightMap, paramMappings);
	    return { params: { pnet: pnet, rnet: rnet, onet: onet }, paramMappings: paramMappings };
	}
	exports.extractParamsFromWeigthMap = extractParamsFromWeigthMap;
	//# sourceMappingURL=extractParamsFromWeigthMap.js.map

/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var Mtcnn_1 = __webpack_require__(390);
	tslib_1.__exportStar(__webpack_require__(390), exports);
	tslib_1.__exportStar(__webpack_require__(272), exports);
	function createMtcnn(weights) {
	    var net = new Mtcnn_1.Mtcnn();
	    net.extractWeights(weights);
	    return net;
	}
	exports.createMtcnn = createMtcnn;
	//# sourceMappingURL=index.js.map

/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var config_1 = __webpack_require__(392);
	function pyramidDown(minFaceSize, scaleFactor, dims) {
	    var height = dims[0], width = dims[1];
	    var m = config_1.CELL_SIZE / minFaceSize;
	    var scales = [];
	    var minLayer = Math.min(height, width) * m;
	    var exp = 0;
	    while (minLayer >= 12) {
	        scales.push(m * Math.pow(scaleFactor, exp));
	        minLayer = minLayer * scaleFactor;
	        exp += 1;
	    }
	    return scales;
	}
	exports.pyramidDown = pyramidDown;
	//# sourceMappingURL=pyramidDown.js.map

/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	var classes_1 = __webpack_require__(48);
	var ops_1 = __webpack_require__(98);
	var config_1 = __webpack_require__(392);
	var getSizesForScale_1 = __webpack_require__(616);
	var MtcnnBox_1 = __webpack_require__(391);
	var normalize_1 = __webpack_require__(617);
	var PNet_1 = __webpack_require__(1477);
	function rescaleAndNormalize(x, scale) {
	    return tf.tidy(function () {
	        var _a = getSizesForScale_1.getSizesForScale(scale, x.shape.slice(1)), height = _a.height, width = _a.width;
	        var resized = tf.image.resizeBilinear(x, [height, width]);
	        var normalized = normalize_1.normalize(resized);
	        return tf.transpose(normalized, [0, 2, 1, 3]);
	    });
	}
	function extractBoundingBoxes(scoresTensor, regionsTensor, scale, scoreThreshold) {
	    // TODO: fix this!, maybe better to use tf.gather here
	    var indices = [];
	    var scoresData = scoresTensor.arraySync();
	    for (var y = 0; y < scoresTensor.shape[0]; y++) {
	        for (var x = 0; x < scoresTensor.shape[1]; x++) {
	            if (scoresData[y][x] >= scoreThreshold) {
	                indices.push(new classes_1.Point(x, y));
	            }
	        }
	    }
	    var boundingBoxes = indices.map(function (idx) {
	        var cell = new classes_1.BoundingBox(Math.round((idx.y * config_1.CELL_STRIDE + 1) / scale), Math.round((idx.x * config_1.CELL_STRIDE + 1) / scale), Math.round((idx.y * config_1.CELL_STRIDE + config_1.CELL_SIZE) / scale), Math.round((idx.x * config_1.CELL_STRIDE + config_1.CELL_SIZE) / scale));
	        var score = scoresData[idx.y][idx.x];
	        var regionsData = regionsTensor.arraySync();
	        var region = new MtcnnBox_1.MtcnnBox(regionsData[idx.y][idx.x][0], regionsData[idx.y][idx.x][1], regionsData[idx.y][idx.x][2], regionsData[idx.y][idx.x][3]);
	        return {
	            cell: cell,
	            score: score,
	            region: region
	        };
	    });
	    return boundingBoxes;
	}
	function stage1(imgTensor, scales, scoreThreshold, params, stats) {
	    stats.stage1 = [];
	    var pnetOutputs = scales.map(function (scale) { return tf.tidy(function () {
	        var statsForScale = { scale: scale };
	        var resized = rescaleAndNormalize(imgTensor, scale);
	        var ts = Date.now();
	        var _a = PNet_1.PNet(resized, params), prob = _a.prob, regions = _a.regions;
	        statsForScale.pnet = Date.now() - ts;
	        var scoresTensor = tf.unstack(tf.unstack(prob, 3)[1])[0];
	        var regionsTensor = tf.unstack(regions)[0];
	        return {
	            scoresTensor: scoresTensor,
	            regionsTensor: regionsTensor,
	            scale: scale,
	            statsForScale: statsForScale
	        };
	    }); });
	    var boxesForScale = pnetOutputs.map(function (_a) {
	        var scoresTensor = _a.scoresTensor, regionsTensor = _a.regionsTensor, scale = _a.scale, statsForScale = _a.statsForScale;
	        var boundingBoxes = extractBoundingBoxes(scoresTensor, regionsTensor, scale, scoreThreshold);
	        scoresTensor.dispose();
	        regionsTensor.dispose();
	        if (!boundingBoxes.length) {
	            stats.stage1.push(statsForScale);
	            return [];
	        }
	        var ts = Date.now();
	        var indices = ops_1.nonMaxSuppression(boundingBoxes.map(function (bbox) { return bbox.cell; }), boundingBoxes.map(function (bbox) { return bbox.score; }), 0.5);
	        statsForScale.nms = Date.now() - ts;
	        statsForScale.numBoxes = indices.length;
	        stats.stage1.push(statsForScale);
	        return indices.map(function (boxIdx) { return boundingBoxes[boxIdx]; });
	    });
	    var allBoxes = boxesForScale.reduce(function (all, boxes) { return all.concat(boxes); }, []);
	    var finalBoxes = [];
	    var finalScores = [];
	    if (allBoxes.length > 0) {
	        var ts = Date.now();
	        var indices = ops_1.nonMaxSuppression(allBoxes.map(function (bbox) { return bbox.cell; }), allBoxes.map(function (bbox) { return bbox.score; }), 0.7);
	        stats.stage1_nms = Date.now() - ts;
	        finalScores = indices.map(function (idx) { return allBoxes[idx].score; });
	        finalBoxes = indices
	            .map(function (idx) { return allBoxes[idx]; })
	            .map(function (_a) {
	            var cell = _a.cell, region = _a.region;
	            return new classes_1.BoundingBox(cell.left + (region.left * cell.width), cell.top + (region.top * cell.height), cell.right + (region.right * cell.width), cell.bottom + (region.bottom * cell.height)).toSquare().round();
	        });
	    }
	    return {
	        boxes: finalBoxes,
	        scores: finalScores
	    };
	}
	exports.stage1 = stage1;
	//# sourceMappingURL=stage1.js.map

/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var ops_1 = __webpack_require__(98);
	var extractImagePatches_1 = __webpack_require__(615);
	var MtcnnBox_1 = __webpack_require__(391);
	var RNet_1 = __webpack_require__(1478);
	function stage2(img, inputBoxes, scoreThreshold, params, stats) {
	    return tslib_1.__awaiter(this, void 0, void 0, function () {
	        var ts, rnetInputs, rnetOuts, scoresTensor, scores, _a, _b, indices, filteredBoxes, filteredScores, finalBoxes, finalScores, indicesNms, regions_1;
	        return tslib_1.__generator(this, function (_c) {
	            switch (_c.label) {
	                case 0:
	                    ts = Date.now();
	                    return [4 /*yield*/, extractImagePatches_1.extractImagePatches(img, inputBoxes, { width: 24, height: 24 })];
	                case 1:
	                    rnetInputs = _c.sent();
	                    stats.stage2_extractImagePatches = Date.now() - ts;
	                    ts = Date.now();
	                    rnetOuts = rnetInputs.map(function (rnetInput) {
	                        var out = RNet_1.RNet(rnetInput, params);
	                        rnetInput.dispose();
	                        return out;
	                    });
	                    stats.stage2_rnet = Date.now() - ts;
	                    scoresTensor = rnetOuts.length > 1
	                        ? tf.concat(rnetOuts.map(function (out) { return out.scores; }))
	                        : rnetOuts[0].scores;
	                    _b = (_a = Array).from;
	                    return [4 /*yield*/, scoresTensor.data()];
	                case 2:
	                    scores = _b.apply(_a, [_c.sent()]);
	                    scoresTensor.dispose();
	                    indices = scores
	                        .map(function (score, idx) { return ({ score: score, idx: idx }); })
	                        .filter(function (c) { return c.score > scoreThreshold; })
	                        .map(function (_a) {
	                        var idx = _a.idx;
	                        return idx;
	                    });
	                    filteredBoxes = indices.map(function (idx) { return inputBoxes[idx]; });
	                    filteredScores = indices.map(function (idx) { return scores[idx]; });
	                    finalBoxes = [];
	                    finalScores = [];
	                    if (filteredBoxes.length > 0) {
	                        ts = Date.now();
	                        indicesNms = ops_1.nonMaxSuppression(filteredBoxes, filteredScores, 0.7);
	                        stats.stage2_nms = Date.now() - ts;
	                        regions_1 = indicesNms.map(function (idx) {
	                            var regionsData = rnetOuts[indices[idx]].regions.arraySync();
	                            return new MtcnnBox_1.MtcnnBox(regionsData[0][0], regionsData[0][1], regionsData[0][2], regionsData[0][3]);
	                        });
	                        finalScores = indicesNms.map(function (idx) { return filteredScores[idx]; });
	                        finalBoxes = indicesNms.map(function (idx, i) { return filteredBoxes[idx].calibrate(regions_1[i]); });
	                    }
	                    rnetOuts.forEach(function (t) {
	                        t.regions.dispose();
	                        t.scores.dispose();
	                    });
	                    return [2 /*return*/, {
	                            boxes: finalBoxes,
	                            scores: finalScores
	                        }];
	            }
	        });
	    });
	}
	exports.stage2 = stage2;
	//# sourceMappingURL=stage2.js.map

/***/ },
/* 1486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var classes_1 = __webpack_require__(48);
	var ops_1 = __webpack_require__(98);
	var extractImagePatches_1 = __webpack_require__(615);
	var MtcnnBox_1 = __webpack_require__(391);
	var ONet_1 = __webpack_require__(1476);
	function stage3(img, inputBoxes, scoreThreshold, params, stats) {
	    return tslib_1.__awaiter(this, void 0, void 0, function () {
	        var ts, onetInputs, onetOuts, scoresTensor, scores, _a, _b, indices, filteredRegions, filteredBoxes, filteredScores, finalBoxes, finalScores, points, indicesNms;
	        return tslib_1.__generator(this, function (_c) {
	            switch (_c.label) {
	                case 0:
	                    ts = Date.now();
	                    return [4 /*yield*/, extractImagePatches_1.extractImagePatches(img, inputBoxes, { width: 48, height: 48 })];
	                case 1:
	                    onetInputs = _c.sent();
	                    stats.stage3_extractImagePatches = Date.now() - ts;
	                    ts = Date.now();
	                    onetOuts = onetInputs.map(function (onetInput) {
	                        var out = ONet_1.ONet(onetInput, params);
	                        onetInput.dispose();
	                        return out;
	                    });
	                    stats.stage3_onet = Date.now() - ts;
	                    scoresTensor = onetOuts.length > 1
	                        ? tf.concat(onetOuts.map(function (out) { return out.scores; }))
	                        : onetOuts[0].scores;
	                    _b = (_a = Array).from;
	                    return [4 /*yield*/, scoresTensor.data()];
	                case 2:
	                    scores = _b.apply(_a, [_c.sent()]);
	                    scoresTensor.dispose();
	                    indices = scores
	                        .map(function (score, idx) { return ({ score: score, idx: idx }); })
	                        .filter(function (c) { return c.score > scoreThreshold; })
	                        .map(function (_a) {
	                        var idx = _a.idx;
	                        return idx;
	                    });
	                    filteredRegions = indices.map(function (idx) {
	                        var regionsData = onetOuts[idx].regions.arraySync();
	                        return new MtcnnBox_1.MtcnnBox(regionsData[0][0], regionsData[0][1], regionsData[0][2], regionsData[0][3]);
	                    });
	                    filteredBoxes = indices
	                        .map(function (idx, i) { return inputBoxes[idx].calibrate(filteredRegions[i]); });
	                    filteredScores = indices.map(function (idx) { return scores[idx]; });
	                    finalBoxes = [];
	                    finalScores = [];
	                    points = [];
	                    if (filteredBoxes.length > 0) {
	                        ts = Date.now();
	                        indicesNms = ops_1.nonMaxSuppression(filteredBoxes, filteredScores, 0.7, false);
	                        stats.stage3_nms = Date.now() - ts;
	                        finalBoxes = indicesNms.map(function (idx) { return filteredBoxes[idx]; });
	                        finalScores = indicesNms.map(function (idx) { return filteredScores[idx]; });
	                        points = indicesNms.map(function (idx, i) {
	                            return Array(5).fill(0).map(function (_, ptIdx) {
	                                var pointsData = onetOuts[idx].points.arraySync();
	                                return new classes_1.Point(((pointsData[0][ptIdx] * (finalBoxes[i].width + 1)) + finalBoxes[i].left), ((pointsData[0][ptIdx + 5] * (finalBoxes[i].height + 1)) + finalBoxes[i].top));
	                            });
	                        });
	                    }
	                    onetOuts.forEach(function (t) {
	                        t.regions.dispose();
	                        t.scores.dispose();
	                        t.points.dispose();
	                    });
	                    return [2 /*return*/, {
	                            boxes: finalBoxes,
	                            scores: finalScores,
	                            points: points
	                        }];
	            }
	        });
	    });
	}
	exports.stage3 = stage3;
	//# sourceMappingURL=stage3.js.map

/***/ },
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var classes_1 = __webpack_require__(48);
	function minBbox(pts) {
	    var xs = pts.map(function (pt) { return pt.x; });
	    var ys = pts.map(function (pt) { return pt.y; });
	    var minX = xs.reduce(function (min, x) { return x < min ? x : min; }, Infinity);
	    var minY = ys.reduce(function (min, y) { return y < min ? y : min; }, Infinity);
	    var maxX = xs.reduce(function (max, x) { return max < x ? x : max; }, 0);
	    var maxY = ys.reduce(function (max, y) { return max < y ? y : max; }, 0);
	    return new classes_1.BoundingBox(minX, minY, maxX, maxY);
	}
	exports.minBbox = minBbox;
	//# sourceMappingURL=minBbox.js.map

/***/ },
/* 1488 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function shuffleArray(inputArray) {
	    var array = inputArray.slice();
	    for (var i = array.length - 1; i > 0; i--) {
	        var j = Math.floor(Math.random() * (i + 1));
	        var x = array[i];
	        array[i] = array[j];
	        array[j] = x;
	    }
	    return array;
	}
	exports.shuffleArray = shuffleArray;
	//# sourceMappingURL=shuffleArray.js.map

/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var classes_1 = __webpack_require__(48);
	var FaceDetection_1 = __webpack_require__(97);
	var FaceLandmarks_1 = __webpack_require__(166);
	var WithFaceDetection_1 = __webpack_require__(167);
	var WithFaceLandmarks_1 = __webpack_require__(211);
	function resizeResults(results, dimensions) {
	    var _a = new classes_1.Dimensions(dimensions.width, dimensions.height), width = _a.width, height = _a.height;
	    if (width <= 0 || height <= 0) {
	        throw new Error("resizeResults - invalid dimensions: " + JSON.stringify({ width: width, height: height }));
	    }
	    if (Array.isArray(results)) {
	        return results.map(function (obj) { return resizeResults(obj, { width: width, height: height }); });
	    }
	    if (WithFaceLandmarks_1.isWithFaceLandmarks(results)) {
	        var resizedDetection = results.detection.forSize(width, height);
	        var resizedLandmarks = results.unshiftedLandmarks.forSize(resizedDetection.box.width, resizedDetection.box.height);
	        return WithFaceLandmarks_1.extendWithFaceLandmarks(WithFaceDetection_1.extendWithFaceDetection(results, resizedDetection), resizedLandmarks);
	    }
	    if (WithFaceDetection_1.isWithFaceDetection(results)) {
	        return WithFaceDetection_1.extendWithFaceDetection(results, results.detection.forSize(width, height));
	    }
	    if (results instanceof FaceLandmarks_1.FaceLandmarks || results instanceof FaceDetection_1.FaceDetection) {
	        return results.forSize(width, height);
	    }
	    return results;
	}
	exports.resizeResults = resizeResults;
	//# sourceMappingURL=resizeResults.js.map

/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	var common_1 = __webpack_require__(33);
	function boxPredictionLayer(x, params) {
	    return tf.tidy(function () {
	        var batchSize = x.shape[0];
	        var boxPredictionEncoding = tf.reshape(common_1.convLayer(x, params.box_encoding_predictor), [batchSize, -1, 1, 4]);
	        var classPrediction = tf.reshape(common_1.convLayer(x, params.class_predictor), [batchSize, -1, 3]);
	        return {
	            boxPredictionEncoding: boxPredictionEncoding,
	            classPrediction: classPrediction
	        };
	    });
	}
	exports.boxPredictionLayer = boxPredictionLayer;
	//# sourceMappingURL=boxPredictionLayer.js.map

/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	var common_1 = __webpack_require__(33);
	function extractorsFactory(extractWeights, paramMappings) {
	    function extractDepthwiseConvParams(numChannels, mappedPrefix) {
	        var filters = tf.tensor4d(extractWeights(3 * 3 * numChannels), [3, 3, numChannels, 1]);
	        var batch_norm_scale = tf.tensor1d(extractWeights(numChannels));
	        var batch_norm_offset = tf.tensor1d(extractWeights(numChannels));
	        var batch_norm_mean = tf.tensor1d(extractWeights(numChannels));
	        var batch_norm_variance = tf.tensor1d(extractWeights(numChannels));
	        paramMappings.push({ paramPath: mappedPrefix + "/filters" }, { paramPath: mappedPrefix + "/batch_norm_scale" }, { paramPath: mappedPrefix + "/batch_norm_offset" }, { paramPath: mappedPrefix + "/batch_norm_mean" }, { paramPath: mappedPrefix + "/batch_norm_variance" });
	        return {
	            filters: filters,
	            batch_norm_scale: batch_norm_scale,
	            batch_norm_offset: batch_norm_offset,
	            batch_norm_mean: batch_norm_mean,
	            batch_norm_variance: batch_norm_variance
	        };
	    }
	    function extractConvParams(channelsIn, channelsOut, filterSize, mappedPrefix, isPointwiseConv) {
	        var filters = tf.tensor4d(extractWeights(channelsIn * channelsOut * filterSize * filterSize), [filterSize, filterSize, channelsIn, channelsOut]);
	        var bias = tf.tensor1d(extractWeights(channelsOut));
	        paramMappings.push({ paramPath: mappedPrefix + "/filters" }, { paramPath: mappedPrefix + "/" + (isPointwiseConv ? 'batch_norm_offset' : 'bias') });
	        return { filters: filters, bias: bias };
	    }
	    function extractPointwiseConvParams(channelsIn, channelsOut, filterSize, mappedPrefix) {
	        var _a = extractConvParams(channelsIn, channelsOut, filterSize, mappedPrefix, true), filters = _a.filters, bias = _a.bias;
	        return {
	            filters: filters,
	            batch_norm_offset: bias
	        };
	    }
	    function extractConvPairParams(channelsIn, channelsOut, mappedPrefix) {
	        var depthwise_conv = extractDepthwiseConvParams(channelsIn, mappedPrefix + "/depthwise_conv");
	        var pointwise_conv = extractPointwiseConvParams(channelsIn, channelsOut, 1, mappedPrefix + "/pointwise_conv");
	        return { depthwise_conv: depthwise_conv, pointwise_conv: pointwise_conv };
	    }
	    function extractMobilenetV1Params() {
	        var conv_0 = extractPointwiseConvParams(3, 32, 3, 'mobilenetv1/conv_0');
	        var conv_1 = extractConvPairParams(32, 64, 'mobilenetv1/conv_1');
	        var conv_2 = extractConvPairParams(64, 128, 'mobilenetv1/conv_2');
	        var conv_3 = extractConvPairParams(128, 128, 'mobilenetv1/conv_3');
	        var conv_4 = extractConvPairParams(128, 256, 'mobilenetv1/conv_4');
	        var conv_5 = extractConvPairParams(256, 256, 'mobilenetv1/conv_5');
	        var conv_6 = extractConvPairParams(256, 512, 'mobilenetv1/conv_6');
	        var conv_7 = extractConvPairParams(512, 512, 'mobilenetv1/conv_7');
	        var conv_8 = extractConvPairParams(512, 512, 'mobilenetv1/conv_8');
	        var conv_9 = extractConvPairParams(512, 512, 'mobilenetv1/conv_9');
	        var conv_10 = extractConvPairParams(512, 512, 'mobilenetv1/conv_10');
	        var conv_11 = extractConvPairParams(512, 512, 'mobilenetv1/conv_11');
	        var conv_12 = extractConvPairParams(512, 1024, 'mobilenetv1/conv_12');
	        var conv_13 = extractConvPairParams(1024, 1024, 'mobilenetv1/conv_13');
	        return {
	            conv_0: conv_0,
	            conv_1: conv_1,
	            conv_2: conv_2,
	            conv_3: conv_3,
	            conv_4: conv_4,
	            conv_5: conv_5,
	            conv_6: conv_6,
	            conv_7: conv_7,
	            conv_8: conv_8,
	            conv_9: conv_9,
	            conv_10: conv_10,
	            conv_11: conv_11,
	            conv_12: conv_12,
	            conv_13: conv_13
	        };
	    }
	    function extractPredictionLayerParams() {
	        var conv_0 = extractPointwiseConvParams(1024, 256, 1, 'prediction_layer/conv_0');
	        var conv_1 = extractPointwiseConvParams(256, 512, 3, 'prediction_layer/conv_1');
	        var conv_2 = extractPointwiseConvParams(512, 128, 1, 'prediction_layer/conv_2');
	        var conv_3 = extractPointwiseConvParams(128, 256, 3, 'prediction_layer/conv_3');
	        var conv_4 = extractPointwiseConvParams(256, 128, 1, 'prediction_layer/conv_4');
	        var conv_5 = extractPointwiseConvParams(128, 256, 3, 'prediction_layer/conv_5');
	        var conv_6 = extractPointwiseConvParams(256, 64, 1, 'prediction_layer/conv_6');
	        var conv_7 = extractPointwiseConvParams(64, 128, 3, 'prediction_layer/conv_7');
	        var box_encoding_0_predictor = extractConvParams(512, 12, 1, 'prediction_layer/box_predictor_0/box_encoding_predictor');
	        var class_predictor_0 = extractConvParams(512, 9, 1, 'prediction_layer/box_predictor_0/class_predictor');
	        var box_encoding_1_predictor = extractConvParams(1024, 24, 1, 'prediction_layer/box_predictor_1/box_encoding_predictor');
	        var class_predictor_1 = extractConvParams(1024, 18, 1, 'prediction_layer/box_predictor_1/class_predictor');
	        var box_encoding_2_predictor = extractConvParams(512, 24, 1, 'prediction_layer/box_predictor_2/box_encoding_predictor');
	        var class_predictor_2 = extractConvParams(512, 18, 1, 'prediction_layer/box_predictor_2/class_predictor');
	        var box_encoding_3_predictor = extractConvParams(256, 24, 1, 'prediction_layer/box_predictor_3/box_encoding_predictor');
	        var class_predictor_3 = extractConvParams(256, 18, 1, 'prediction_layer/box_predictor_3/class_predictor');
	        var box_encoding_4_predictor = extractConvParams(256, 24, 1, 'prediction_layer/box_predictor_4/box_encoding_predictor');
	        var class_predictor_4 = extractConvParams(256, 18, 1, 'prediction_layer/box_predictor_4/class_predictor');
	        var box_encoding_5_predictor = extractConvParams(128, 24, 1, 'prediction_layer/box_predictor_5/box_encoding_predictor');
	        var class_predictor_5 = extractConvParams(128, 18, 1, 'prediction_layer/box_predictor_5/class_predictor');
	        var box_predictor_0 = {
	            box_encoding_predictor: box_encoding_0_predictor,
	            class_predictor: class_predictor_0
	        };
	        var box_predictor_1 = {
	            box_encoding_predictor: box_encoding_1_predictor,
	            class_predictor: class_predictor_1
	        };
	        var box_predictor_2 = {
	            box_encoding_predictor: box_encoding_2_predictor,
	            class_predictor: class_predictor_2
	        };
	        var box_predictor_3 = {
	            box_encoding_predictor: box_encoding_3_predictor,
	            class_predictor: class_predictor_3
	        };
	        var box_predictor_4 = {
	            box_encoding_predictor: box_encoding_4_predictor,
	            class_predictor: class_predictor_4
	        };
	        var box_predictor_5 = {
	            box_encoding_predictor: box_encoding_5_predictor,
	            class_predictor: class_predictor_5
	        };
	        return {
	            conv_0: conv_0,
	            conv_1: conv_1,
	            conv_2: conv_2,
	            conv_3: conv_3,
	            conv_4: conv_4,
	            conv_5: conv_5,
	            conv_6: conv_6,
	            conv_7: conv_7,
	            box_predictor_0: box_predictor_0,
	            box_predictor_1: box_predictor_1,
	            box_predictor_2: box_predictor_2,
	            box_predictor_3: box_predictor_3,
	            box_predictor_4: box_predictor_4,
	            box_predictor_5: box_predictor_5
	        };
	    }
	    return {
	        extractMobilenetV1Params: extractMobilenetV1Params,
	        extractPredictionLayerParams: extractPredictionLayerParams
	    };
	}
	function extractParams(weights) {
	    var paramMappings = [];
	    var _a = common_1.extractWeightsFactory(weights), extractWeights = _a.extractWeights, getRemainingWeights = _a.getRemainingWeights;
	    var _b = extractorsFactory(extractWeights, paramMappings), extractMobilenetV1Params = _b.extractMobilenetV1Params, extractPredictionLayerParams = _b.extractPredictionLayerParams;
	    var mobilenetv1 = extractMobilenetV1Params();
	    var prediction_layer = extractPredictionLayerParams();
	    var extra_dim = tf.tensor3d(extractWeights(5118 * 4), [1, 5118, 4]);
	    var output_layer = {
	        extra_dim: extra_dim
	    };
	    paramMappings.push({ paramPath: 'output_layer/extra_dim' });
	    if (getRemainingWeights().length !== 0) {
	        throw new Error("weights remaing after extract: " + getRemainingWeights().length);
	    }
	    return {
	        params: {
	            mobilenetv1: mobilenetv1,
	            prediction_layer: prediction_layer,
	            output_layer: output_layer
	        },
	        paramMappings: paramMappings
	    };
	}
	exports.extractParams = extractParams;
	//# sourceMappingURL=extractParams.js.map

/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(33);
	var utils_1 = __webpack_require__(34);
	function extractorsFactory(weightMap, paramMappings) {
	    var extractWeightEntry = common_1.extractWeightEntryFactory(weightMap, paramMappings);
	    function extractPointwiseConvParams(prefix, idx, mappedPrefix) {
	        var filters = extractWeightEntry(prefix + "/Conv2d_" + idx + "_pointwise/weights", 4, mappedPrefix + "/filters");
	        var batch_norm_offset = extractWeightEntry(prefix + "/Conv2d_" + idx + "_pointwise/convolution_bn_offset", 1, mappedPrefix + "/batch_norm_offset");
	        return { filters: filters, batch_norm_offset: batch_norm_offset };
	    }
	    function extractConvPairParams(idx) {
	        var mappedPrefix = "mobilenetv1/conv_" + idx;
	        var prefixDepthwiseConv = "MobilenetV1/Conv2d_" + idx + "_depthwise";
	        var mappedPrefixDepthwiseConv = mappedPrefix + "/depthwise_conv";
	        var mappedPrefixPointwiseConv = mappedPrefix + "/pointwise_conv";
	        var filters = extractWeightEntry(prefixDepthwiseConv + "/depthwise_weights", 4, mappedPrefixDepthwiseConv + "/filters");
	        var batch_norm_scale = extractWeightEntry(prefixDepthwiseConv + "/BatchNorm/gamma", 1, mappedPrefixDepthwiseConv + "/batch_norm_scale");
	        var batch_norm_offset = extractWeightEntry(prefixDepthwiseConv + "/BatchNorm/beta", 1, mappedPrefixDepthwiseConv + "/batch_norm_offset");
	        var batch_norm_mean = extractWeightEntry(prefixDepthwiseConv + "/BatchNorm/moving_mean", 1, mappedPrefixDepthwiseConv + "/batch_norm_mean");
	        var batch_norm_variance = extractWeightEntry(prefixDepthwiseConv + "/BatchNorm/moving_variance", 1, mappedPrefixDepthwiseConv + "/batch_norm_variance");
	        return {
	            depthwise_conv: {
	                filters: filters,
	                batch_norm_scale: batch_norm_scale,
	                batch_norm_offset: batch_norm_offset,
	                batch_norm_mean: batch_norm_mean,
	                batch_norm_variance: batch_norm_variance
	            },
	            pointwise_conv: extractPointwiseConvParams('MobilenetV1', idx, mappedPrefixPointwiseConv)
	        };
	    }
	    function extractMobilenetV1Params() {
	        return {
	            conv_0: extractPointwiseConvParams('MobilenetV1', 0, 'mobilenetv1/conv_0'),
	            conv_1: extractConvPairParams(1),
	            conv_2: extractConvPairParams(2),
	            conv_3: extractConvPairParams(3),
	            conv_4: extractConvPairParams(4),
	            conv_5: extractConvPairParams(5),
	            conv_6: extractConvPairParams(6),
	            conv_7: extractConvPairParams(7),
	            conv_8: extractConvPairParams(8),
	            conv_9: extractConvPairParams(9),
	            conv_10: extractConvPairParams(10),
	            conv_11: extractConvPairParams(11),
	            conv_12: extractConvPairParams(12),
	            conv_13: extractConvPairParams(13)
	        };
	    }
	    function extractConvParams(prefix, mappedPrefix) {
	        var filters = extractWeightEntry(prefix + "/weights", 4, mappedPrefix + "/filters");
	        var bias = extractWeightEntry(prefix + "/biases", 1, mappedPrefix + "/bias");
	        return { filters: filters, bias: bias };
	    }
	    function extractBoxPredictorParams(idx) {
	        var box_encoding_predictor = extractConvParams("Prediction/BoxPredictor_" + idx + "/BoxEncodingPredictor", "prediction_layer/box_predictor_" + idx + "/box_encoding_predictor");
	        var class_predictor = extractConvParams("Prediction/BoxPredictor_" + idx + "/ClassPredictor", "prediction_layer/box_predictor_" + idx + "/class_predictor");
	        return { box_encoding_predictor: box_encoding_predictor, class_predictor: class_predictor };
	    }
	    function extractPredictionLayerParams() {
	        return {
	            conv_0: extractPointwiseConvParams('Prediction', 0, 'prediction_layer/conv_0'),
	            conv_1: extractPointwiseConvParams('Prediction', 1, 'prediction_layer/conv_1'),
	            conv_2: extractPointwiseConvParams('Prediction', 2, 'prediction_layer/conv_2'),
	            conv_3: extractPointwiseConvParams('Prediction', 3, 'prediction_layer/conv_3'),
	            conv_4: extractPointwiseConvParams('Prediction', 4, 'prediction_layer/conv_4'),
	            conv_5: extractPointwiseConvParams('Prediction', 5, 'prediction_layer/conv_5'),
	            conv_6: extractPointwiseConvParams('Prediction', 6, 'prediction_layer/conv_6'),
	            conv_7: extractPointwiseConvParams('Prediction', 7, 'prediction_layer/conv_7'),
	            box_predictor_0: extractBoxPredictorParams(0),
	            box_predictor_1: extractBoxPredictorParams(1),
	            box_predictor_2: extractBoxPredictorParams(2),
	            box_predictor_3: extractBoxPredictorParams(3),
	            box_predictor_4: extractBoxPredictorParams(4),
	            box_predictor_5: extractBoxPredictorParams(5)
	        };
	    }
	    return {
	        extractMobilenetV1Params: extractMobilenetV1Params,
	        extractPredictionLayerParams: extractPredictionLayerParams
	    };
	}
	function extractParamsFromWeigthMap(weightMap) {
	    var paramMappings = [];
	    var _a = extractorsFactory(weightMap, paramMappings), extractMobilenetV1Params = _a.extractMobilenetV1Params, extractPredictionLayerParams = _a.extractPredictionLayerParams;
	    var extra_dim = weightMap['Output/extra_dim'];
	    paramMappings.push({ originalPath: 'Output/extra_dim', paramPath: 'output_layer/extra_dim' });
	    if (!utils_1.isTensor3D(extra_dim)) {
	        throw new Error("expected weightMap['Output/extra_dim'] to be a Tensor3D, instead have " + extra_dim);
	    }
	    var params = {
	        mobilenetv1: extractMobilenetV1Params(),
	        prediction_layer: extractPredictionLayerParams(),
	        output_layer: {
	            extra_dim: extra_dim
	        }
	    };
	    common_1.disposeUnusedWeightTensors(weightMap, paramMappings);
	    return { params: params, paramMappings: paramMappings };
	}
	exports.extractParamsFromWeigthMap = extractParamsFromWeigthMap;
	//# sourceMappingURL=extractParamsFromWeigthMap.js.map

/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	var pointwiseConvLayer_1 = __webpack_require__(623);
	var epsilon = 0.0010000000474974513;
	function depthwiseConvLayer(x, params, strides) {
	    return tf.tidy(function () {
	        var out = tf.depthwiseConv2d(x, params.filters, strides, 'same');
	        out = tf.batchNorm(out, params.batch_norm_mean, params.batch_norm_variance, params.batch_norm_offset, params.batch_norm_scale, epsilon);
	        return tf.clipByValue(out, 0, 6);
	    });
	}
	function getStridesForLayerIdx(layerIdx) {
	    return [2, 4, 6, 12].some(function (idx) { return idx === layerIdx; }) ? [2, 2] : [1, 1];
	}
	function mobileNetV1(x, params) {
	    return tf.tidy(function () {
	        var conv11 = null;
	        var out = pointwiseConvLayer_1.pointwiseConvLayer(x, params.conv_0, [2, 2]);
	        var convPairParams = [
	            params.conv_1,
	            params.conv_2,
	            params.conv_3,
	            params.conv_4,
	            params.conv_5,
	            params.conv_6,
	            params.conv_7,
	            params.conv_8,
	            params.conv_9,
	            params.conv_10,
	            params.conv_11,
	            params.conv_12,
	            params.conv_13
	        ];
	        convPairParams.forEach(function (param, i) {
	            var layerIdx = i + 1;
	            var depthwiseConvStrides = getStridesForLayerIdx(layerIdx);
	            out = depthwiseConvLayer(out, param.depthwise_conv, depthwiseConvStrides);
	            out = pointwiseConvLayer_1.pointwiseConvLayer(out, param.pointwise_conv, [1, 1]);
	            if (layerIdx === 11) {
	                conv11 = out;
	            }
	        });
	        if (conv11 === null) {
	            throw new Error('mobileNetV1 - output of conv layer 11 is null');
	        }
	        return {
	            out: out,
	            conv11: conv11
	        };
	    });
	}
	exports.mobileNetV1 = mobileNetV1;
	//# sourceMappingURL=mobileNetV1.js.map

/***/ },
/* 1494 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function nonMaxSuppression(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold) {
	    var numBoxes = boxes.shape[0];
	    var outputSize = Math.min(maxOutputSize, numBoxes);
	    var candidates = scores
	        .map(function (score, boxIndex) { return ({ score: score, boxIndex: boxIndex }); })
	        .filter(function (c) { return c.score > scoreThreshold; })
	        .sort(function (c1, c2) { return c2.score - c1.score; });
	    var suppressFunc = function (x) { return x <= iouThreshold ? 1 : 0; };
	    var selected = [];
	    candidates.forEach(function (c) {
	        if (selected.length >= outputSize) {
	            return;
	        }
	        var originalScore = c.score;
	        for (var j = selected.length - 1; j >= 0; --j) {
	            var iou = IOU(boxes, c.boxIndex, selected[j]);
	            if (iou === 0.0) {
	                continue;
	            }
	            c.score *= suppressFunc(iou);
	            if (c.score <= scoreThreshold) {
	                break;
	            }
	        }
	        if (originalScore === c.score) {
	            selected.push(c.boxIndex);
	        }
	    });
	    return selected;
	}
	exports.nonMaxSuppression = nonMaxSuppression;
	function IOU(boxes, i, j) {
	    var boxesData = boxes.arraySync();
	    var yminI = Math.min(boxesData[i][0], boxesData[i][2]);
	    var xminI = Math.min(boxesData[i][1], boxesData[i][3]);
	    var ymaxI = Math.max(boxesData[i][0], boxesData[i][2]);
	    var xmaxI = Math.max(boxesData[i][1], boxesData[i][3]);
	    var yminJ = Math.min(boxesData[j][0], boxesData[j][2]);
	    var xminJ = Math.min(boxesData[j][1], boxesData[j][3]);
	    var ymaxJ = Math.max(boxesData[j][0], boxesData[j][2]);
	    var xmaxJ = Math.max(boxesData[j][1], boxesData[j][3]);
	    var areaI = (ymaxI - yminI) * (xmaxI - xminI);
	    var areaJ = (ymaxJ - yminJ) * (xmaxJ - xminJ);
	    if (areaI <= 0 || areaJ <= 0) {
	        return 0.0;
	    }
	    var intersectionYmin = Math.max(yminI, yminJ);
	    var intersectionXmin = Math.max(xminI, xminJ);
	    var intersectionYmax = Math.min(ymaxI, ymaxJ);
	    var intersectionXmax = Math.min(xmaxI, xmaxJ);
	    var intersectionArea = Math.max(intersectionYmax - intersectionYmin, 0.0) *
	        Math.max(intersectionXmax - intersectionXmin, 0.0);
	    return intersectionArea / (areaI + areaJ - intersectionArea);
	}
	//# sourceMappingURL=nonMaxSuppression.js.map

/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	function getCenterCoordinatesAndSizesLayer(x) {
	    var vec = tf.unstack(tf.transpose(x, [1, 0]));
	    var sizes = [
	        tf.sub(vec[2], vec[0]),
	        tf.sub(vec[3], vec[1])
	    ];
	    var centers = [
	        tf.add(vec[0], tf.div(sizes[0], tf.scalar(2))),
	        tf.add(vec[1], tf.div(sizes[1], tf.scalar(2)))
	    ];
	    return {
	        sizes: sizes,
	        centers: centers
	    };
	}
	function decodeBoxesLayer(x0, x1) {
	    var _a = getCenterCoordinatesAndSizesLayer(x0), sizes = _a.sizes, centers = _a.centers;
	    var vec = tf.unstack(tf.transpose(x1, [1, 0]));
	    var div0_out = tf.div(tf.mul(tf.exp(tf.div(vec[2], tf.scalar(5))), sizes[0]), tf.scalar(2));
	    var add0_out = tf.add(tf.mul(tf.div(vec[0], tf.scalar(10)), sizes[0]), centers[0]);
	    var div1_out = tf.div(tf.mul(tf.exp(tf.div(vec[3], tf.scalar(5))), sizes[1]), tf.scalar(2));
	    var add1_out = tf.add(tf.mul(tf.div(vec[1], tf.scalar(10)), sizes[1]), centers[1]);
	    return tf.transpose(tf.stack([
	        tf.sub(add0_out, div0_out),
	        tf.sub(add1_out, div1_out),
	        tf.add(add0_out, div0_out),
	        tf.add(add1_out, div1_out)
	    ]), [1, 0]);
	}
	function outputLayer(boxPredictions, classPredictions, params) {
	    return tf.tidy(function () {
	        var batchSize = boxPredictions.shape[0];
	        var boxes = decodeBoxesLayer(tf.reshape(tf.tile(params.extra_dim, [batchSize, 1, 1]), [-1, 4]), tf.reshape(boxPredictions, [-1, 4]));
	        boxes = tf.reshape(boxes, [batchSize, (boxes.shape[0] / batchSize), 4]);
	        var scoresAndClasses = tf.sigmoid(tf.slice(classPredictions, [0, 0, 1], [-1, -1, -1]));
	        var scores = tf.slice(scoresAndClasses, [0, 0, 0], [-1, -1, 1]);
	        scores = tf.reshape(scores, [batchSize, scores.shape[1]]);
	        var boxesByBatch = tf.unstack(boxes);
	        var scoresByBatch = tf.unstack(scores);
	        return {
	            boxes: boxesByBatch,
	            scores: scoresByBatch
	        };
	    });
	}
	exports.outputLayer = outputLayer;
	//# sourceMappingURL=outputLayer.js.map

/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	var boxPredictionLayer_1 = __webpack_require__(1490);
	var pointwiseConvLayer_1 = __webpack_require__(623);
	function predictionLayer(x, conv11, params) {
	    return tf.tidy(function () {
	        var conv0 = pointwiseConvLayer_1.pointwiseConvLayer(x, params.conv_0, [1, 1]);
	        var conv1 = pointwiseConvLayer_1.pointwiseConvLayer(conv0, params.conv_1, [2, 2]);
	        var conv2 = pointwiseConvLayer_1.pointwiseConvLayer(conv1, params.conv_2, [1, 1]);
	        var conv3 = pointwiseConvLayer_1.pointwiseConvLayer(conv2, params.conv_3, [2, 2]);
	        var conv4 = pointwiseConvLayer_1.pointwiseConvLayer(conv3, params.conv_4, [1, 1]);
	        var conv5 = pointwiseConvLayer_1.pointwiseConvLayer(conv4, params.conv_5, [2, 2]);
	        var conv6 = pointwiseConvLayer_1.pointwiseConvLayer(conv5, params.conv_6, [1, 1]);
	        var conv7 = pointwiseConvLayer_1.pointwiseConvLayer(conv6, params.conv_7, [2, 2]);
	        var boxPrediction0 = boxPredictionLayer_1.boxPredictionLayer(conv11, params.box_predictor_0);
	        var boxPrediction1 = boxPredictionLayer_1.boxPredictionLayer(x, params.box_predictor_1);
	        var boxPrediction2 = boxPredictionLayer_1.boxPredictionLayer(conv1, params.box_predictor_2);
	        var boxPrediction3 = boxPredictionLayer_1.boxPredictionLayer(conv3, params.box_predictor_3);
	        var boxPrediction4 = boxPredictionLayer_1.boxPredictionLayer(conv5, params.box_predictor_4);
	        var boxPrediction5 = boxPredictionLayer_1.boxPredictionLayer(conv7, params.box_predictor_5);
	        var boxPredictions = tf.concat([
	            boxPrediction0.boxPredictionEncoding,
	            boxPrediction1.boxPredictionEncoding,
	            boxPrediction2.boxPredictionEncoding,
	            boxPrediction3.boxPredictionEncoding,
	            boxPrediction4.boxPredictionEncoding,
	            boxPrediction5.boxPredictionEncoding
	        ], 1);
	        var classPredictions = tf.concat([
	            boxPrediction0.classPrediction,
	            boxPrediction1.classPrediction,
	            boxPrediction2.classPrediction,
	            boxPrediction3.classPrediction,
	            boxPrediction4.classPrediction,
	            boxPrediction5.classPrediction
	        ], 1);
	        return {
	            boxPredictions: boxPredictions,
	            classPredictions: classPredictions
	        };
	    });
	}
	exports.predictionLayer = predictionLayer;
	//# sourceMappingURL=predictionLayer.js.map

/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var classes_1 = __webpack_require__(48);
	exports.IOU_THRESHOLD = 0.4;
	exports.BOX_ANCHORS = [
	    new classes_1.Point(1.603231, 2.094468),
	    new classes_1.Point(6.041143, 7.080126),
	    new classes_1.Point(2.882459, 3.518061),
	    new classes_1.Point(4.266906, 5.178857),
	    new classes_1.Point(9.041765, 10.66308)
	];
	exports.MEAN_RGB = [117.001, 114.697, 97.404];
	//# sourceMappingURL=const.js.map

/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var TinyFaceDetector_1 = __webpack_require__(396);
	tslib_1.__exportStar(__webpack_require__(396), exports);
	tslib_1.__exportStar(__webpack_require__(624), exports);
	function createTinyFaceDetector(weights) {
	    var net = new TinyFaceDetector_1.TinyFaceDetector();
	    net.extractWeights(weights);
	    return net;
	}
	exports.createTinyFaceDetector = createTinyFaceDetector;
	//# sourceMappingURL=index.js.map

/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var classes_1 = __webpack_require__(48);
	var const_1 = __webpack_require__(1500);
	var TinyYolov2Base_1 = __webpack_require__(625);
	var TinyYolov2 = /** @class */ (function (_super) {
	    tslib_1.__extends(TinyYolov2, _super);
	    function TinyYolov2(withSeparableConvs) {
	        if (withSeparableConvs === void 0) { withSeparableConvs = true; }
	        var _this = this;
	        var config = Object.assign({}, {
	            withSeparableConvs: withSeparableConvs,
	            iouThreshold: const_1.IOU_THRESHOLD,
	            classes: ['face']
	        }, withSeparableConvs
	            ? {
	                anchors: const_1.BOX_ANCHORS_SEPARABLE,
	                meanRgb: const_1.MEAN_RGB_SEPARABLE
	            }
	            : {
	                anchors: const_1.BOX_ANCHORS,
	                withClassScores: true
	            });
	        _this = _super.call(this, config) || this;
	        return _this;
	    }
	    Object.defineProperty(TinyYolov2.prototype, "withSeparableConvs", {
	        get: function () {
	            return this.config.withSeparableConvs;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TinyYolov2.prototype, "anchors", {
	        get: function () {
	            return this.config.anchors;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TinyYolov2.prototype.locateFaces = function (input, forwardParams) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var objectDetections;
	            return tslib_1.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.detect(input, forwardParams)];
	                    case 1:
	                        objectDetections = _a.sent();
	                        return [2 /*return*/, objectDetections.map(function (det) { return new classes_1.FaceDetection(det.score, det.relativeBox, { width: det.imageWidth, height: det.imageHeight }); })];
	                }
	            });
	        });
	    };
	    TinyYolov2.prototype.getDefaultModelName = function () {
	        return this.withSeparableConvs ? const_1.DEFAULT_MODEL_NAME_SEPARABLE_CONV : const_1.DEFAULT_MODEL_NAME;
	    };
	    TinyYolov2.prototype.extractParamsFromWeigthMap = function (weightMap) {
	        return _super.prototype.extractParamsFromWeigthMap.call(this, weightMap);
	    };
	    return TinyYolov2;
	}(TinyYolov2Base_1.TinyYolov2Base));
	exports.TinyYolov2 = TinyYolov2;
	//# sourceMappingURL=TinyYolov2.js.map

/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var classes_1 = __webpack_require__(48);
	exports.IOU_THRESHOLD = 0.4;
	exports.BOX_ANCHORS = [
	    new classes_1.Point(0.738768, 0.874946),
	    new classes_1.Point(2.42204, 2.65704),
	    new classes_1.Point(4.30971, 7.04493),
	    new classes_1.Point(10.246, 4.59428),
	    new classes_1.Point(12.6868, 11.8741)
	];
	exports.BOX_ANCHORS_SEPARABLE = [
	    new classes_1.Point(1.603231, 2.094468),
	    new classes_1.Point(6.041143, 7.080126),
	    new classes_1.Point(2.882459, 3.518061),
	    new classes_1.Point(4.266906, 5.178857),
	    new classes_1.Point(9.041765, 10.66308)
	];
	exports.MEAN_RGB_SEPARABLE = [117.001, 114.697, 97.404];
	exports.DEFAULT_MODEL_NAME = 'tiny_yolov2_model';
	exports.DEFAULT_MODEL_NAME_SEPARABLE_CONV = 'tiny_yolov2_separable_conv_model';
	//# sourceMappingURL=const.js.map

/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	var leaky_1 = __webpack_require__(397);
	function convWithBatchNorm(x, params) {
	    return tf.tidy(function () {
	        var out = tf.pad(x, [[0, 0], [1, 1], [1, 1], [0, 0]]);
	        out = tf.conv2d(out, params.conv.filters, [1, 1], 'valid');
	        out = tf.sub(out, params.bn.sub);
	        out = tf.mul(out, params.bn.truediv);
	        out = tf.add(out, params.conv.bias);
	        return leaky_1.leaky(out);
	    });
	}
	exports.convWithBatchNorm = convWithBatchNorm;
	//# sourceMappingURL=convWithBatchNorm.js.map

/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	var leaky_1 = __webpack_require__(397);
	function depthwiseSeparableConv(x, params) {
	    return tf.tidy(function () {
	        var out = tf.pad(x, [[0, 0], [1, 1], [1, 1], [0, 0]]);
	        out = tf.separableConv2d(out, params.depthwise_filter, params.pointwise_filter, [1, 1], 'valid');
	        out = tf.add(out, params.bias);
	        return leaky_1.leaky(out);
	    });
	}
	exports.depthwiseSeparableConv = depthwiseSeparableConv;
	//# sourceMappingURL=depthwiseSeparableConv.js.map

/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tf = __webpack_require__(13);
	var common_1 = __webpack_require__(33);
	var extractSeparableConvParamsFactory_1 = __webpack_require__(381);
	var extractWeightsFactory_1 = __webpack_require__(582);
	function extractorsFactory(extractWeights, paramMappings) {
	    var extractConvParams = common_1.extractConvParamsFactory(extractWeights, paramMappings);
	    function extractBatchNormParams(size, mappedPrefix) {
	        var sub = tf.tensor1d(extractWeights(size));
	        var truediv = tf.tensor1d(extractWeights(size));
	        paramMappings.push({ paramPath: mappedPrefix + "/sub" }, { paramPath: mappedPrefix + "/truediv" });
	        return { sub: sub, truediv: truediv };
	    }
	    function extractConvWithBatchNormParams(channelsIn, channelsOut, mappedPrefix) {
	        var conv = extractConvParams(channelsIn, channelsOut, 3, mappedPrefix + "/conv");
	        var bn = extractBatchNormParams(channelsOut, mappedPrefix + "/bn");
	        return { conv: conv, bn: bn };
	    }
	    var extractSeparableConvParams = extractSeparableConvParamsFactory_1.extractSeparableConvParamsFactory(extractWeights, paramMappings);
	    return {
	        extractConvParams: extractConvParams,
	        extractConvWithBatchNormParams: extractConvWithBatchNormParams,
	        extractSeparableConvParams: extractSeparableConvParams
	    };
	}
	function extractParams(weights, config, boxEncodingSize, filterSizes) {
	    var _a = extractWeightsFactory_1.extractWeightsFactory(weights), extractWeights = _a.extractWeights, getRemainingWeights = _a.getRemainingWeights;
	    var paramMappings = [];
	    var _b = extractorsFactory(extractWeights, paramMappings), extractConvParams = _b.extractConvParams, extractConvWithBatchNormParams = _b.extractConvWithBatchNormParams, extractSeparableConvParams = _b.extractSeparableConvParams;
	    var params;
	    if (config.withSeparableConvs) {
	        var s0 = filterSizes[0], s1 = filterSizes[1], s2 = filterSizes[2], s3 = filterSizes[3], s4 = filterSizes[4], s5 = filterSizes[5], s6 = filterSizes[6], s7 = filterSizes[7], s8 = filterSizes[8];
	        var conv0 = config.isFirstLayerConv2d
	            ? extractConvParams(s0, s1, 3, 'conv0')
	            : extractSeparableConvParams(s0, s1, 'conv0');
	        var conv1 = extractSeparableConvParams(s1, s2, 'conv1');
	        var conv2 = extractSeparableConvParams(s2, s3, 'conv2');
	        var conv3 = extractSeparableConvParams(s3, s4, 'conv3');
	        var conv4 = extractSeparableConvParams(s4, s5, 'conv4');
	        var conv5 = extractSeparableConvParams(s5, s6, 'conv5');
	        var conv6 = s7 ? extractSeparableConvParams(s6, s7, 'conv6') : undefined;
	        var conv7 = s8 ? extractSeparableConvParams(s7, s8, 'conv7') : undefined;
	        var conv8 = extractConvParams(s8 || s7 || s6, 5 * boxEncodingSize, 1, 'conv8');
	        params = { conv0: conv0, conv1: conv1, conv2: conv2, conv3: conv3, conv4: conv4, conv5: conv5, conv6: conv6, conv7: conv7, conv8: conv8 };
	    }
	    else {
	        var s0 = filterSizes[0], s1 = filterSizes[1], s2 = filterSizes[2], s3 = filterSizes[3], s4 = filterSizes[4], s5 = filterSizes[5], s6 = filterSizes[6], s7 = filterSizes[7], s8 = filterSizes[8];
	        var conv0 = extractConvWithBatchNormParams(s0, s1, 'conv0');
	        var conv1 = extractConvWithBatchNormParams(s1, s2, 'conv1');
	        var conv2 = extractConvWithBatchNormParams(s2, s3, 'conv2');
	        var conv3 = extractConvWithBatchNormParams(s3, s4, 'conv3');
	        var conv4 = extractConvWithBatchNormParams(s4, s5, 'conv4');
	        var conv5 = extractConvWithBatchNormParams(s5, s6, 'conv5');
	        var conv6 = extractConvWithBatchNormParams(s6, s7, 'conv6');
	        var conv7 = extractConvWithBatchNormParams(s7, s8, 'conv7');
	        var conv8 = extractConvParams(s8, 5 * boxEncodingSize, 1, 'conv8');
	        params = { conv0: conv0, conv1: conv1, conv2: conv2, conv3: conv3, conv4: conv4, conv5: conv5, conv6: conv6, conv7: conv7, conv8: conv8 };
	    }
	    if (getRemainingWeights().length !== 0) {
	        throw new Error("weights remaing after extract: " + getRemainingWeights().length);
	    }
	    return { params: params, paramMappings: paramMappings };
	}
	exports.extractParams = extractParams;
	//# sourceMappingURL=extractParams.js.map

/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var disposeUnusedWeightTensors_1 = __webpack_require__(580);
	var extractSeparableConvParamsFactory_1 = __webpack_require__(381);
	var extractWeightEntryFactory_1 = __webpack_require__(581);
	function extractorsFactory(weightMap, paramMappings) {
	    var extractWeightEntry = extractWeightEntryFactory_1.extractWeightEntryFactory(weightMap, paramMappings);
	    function extractBatchNormParams(prefix) {
	        var sub = extractWeightEntry(prefix + "/sub", 1);
	        var truediv = extractWeightEntry(prefix + "/truediv", 1);
	        return { sub: sub, truediv: truediv };
	    }
	    function extractConvParams(prefix) {
	        var filters = extractWeightEntry(prefix + "/filters", 4);
	        var bias = extractWeightEntry(prefix + "/bias", 1);
	        return { filters: filters, bias: bias };
	    }
	    function extractConvWithBatchNormParams(prefix) {
	        var conv = extractConvParams(prefix + "/conv");
	        var bn = extractBatchNormParams(prefix + "/bn");
	        return { conv: conv, bn: bn };
	    }
	    var extractSeparableConvParams = extractSeparableConvParamsFactory_1.loadSeparableConvParamsFactory(extractWeightEntry);
	    return {
	        extractConvParams: extractConvParams,
	        extractConvWithBatchNormParams: extractConvWithBatchNormParams,
	        extractSeparableConvParams: extractSeparableConvParams
	    };
	}
	function extractParamsFromWeigthMap(weightMap, config) {
	    var paramMappings = [];
	    var _a = extractorsFactory(weightMap, paramMappings), extractConvParams = _a.extractConvParams, extractConvWithBatchNormParams = _a.extractConvWithBatchNormParams, extractSeparableConvParams = _a.extractSeparableConvParams;
	    var params;
	    if (config.withSeparableConvs) {
	        var numFilters = (config.filterSizes && config.filterSizes.length || 9);
	        params = {
	            conv0: config.isFirstLayerConv2d ? extractConvParams('conv0') : extractSeparableConvParams('conv0'),
	            conv1: extractSeparableConvParams('conv1'),
	            conv2: extractSeparableConvParams('conv2'),
	            conv3: extractSeparableConvParams('conv3'),
	            conv4: extractSeparableConvParams('conv4'),
	            conv5: extractSeparableConvParams('conv5'),
	            conv6: numFilters > 7 ? extractSeparableConvParams('conv6') : undefined,
	            conv7: numFilters > 8 ? extractSeparableConvParams('conv7') : undefined,
	            conv8: extractConvParams('conv8')
	        };
	    }
	    else {
	        params = {
	            conv0: extractConvWithBatchNormParams('conv0'),
	            conv1: extractConvWithBatchNormParams('conv1'),
	            conv2: extractConvWithBatchNormParams('conv2'),
	            conv3: extractConvWithBatchNormParams('conv3'),
	            conv4: extractConvWithBatchNormParams('conv4'),
	            conv5: extractConvWithBatchNormParams('conv5'),
	            conv6: extractConvWithBatchNormParams('conv6'),
	            conv7: extractConvWithBatchNormParams('conv7'),
	            conv8: extractConvParams('conv8')
	        };
	    }
	    disposeUnusedWeightTensors_1.disposeUnusedWeightTensors(weightMap, paramMappings);
	    return { params: params, paramMappings: paramMappings };
	}
	exports.extractParamsFromWeigthMap = extractParamsFromWeigthMap;
	//# sourceMappingURL=extractParamsFromWeigthMap.js.map

/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(12);
	var tf = __webpack_require__(13);
	var common_1 = __webpack_require__(33);
	var dom_1 = __webpack_require__(54);
	var NeuralNetwork_1 = __webpack_require__(96);
	var ops_1 = __webpack_require__(98);
	var utils_1 = __webpack_require__(34);
	var extractParams_1 = __webpack_require__(1506);
	var extractParamsFromWeigthMap_1 = __webpack_require__(1507);
	function conv(x, params, stride) {
	    return tf.add(tf.conv2d(x, params.filters, stride, 'same'), params.bias);
	}
	function reductionBlock(x, params, isActivateInput) {
	    if (isActivateInput === void 0) { isActivateInput = true; }
	    var out = isActivateInput ? tf.relu(x) : x;
	    out = common_1.depthwiseSeparableConv(out, params.separable_conv0, [1, 1]);
	    out = common_1.depthwiseSeparableConv(tf.relu(out), params.separable_conv1, [1, 1]);
	    out = tf.maxPool(out, [3, 3], [2, 2], 'same');
	    out = tf.add(out, conv(x, params.expansion_conv, [2, 2]));
	    return out;
	}
	function mainBlock(x, params) {
	    var out = common_1.depthwiseSeparableConv(tf.relu(x), params.separable_conv0, [1, 1]);
	    out = common_1.depthwiseSeparableConv(tf.relu(out), params.separable_conv1, [1, 1]);
	    out = common_1.depthwiseSeparableConv(tf.relu(out), params.separable_conv2, [1, 1]);
	    out = tf.add(out, x);
	    return out;
	}
	var TinyXception = /** @class */ (function (_super) {
	    tslib_1.__extends(TinyXception, _super);
	    function TinyXception(numMainBlocks) {
	        var _this = _super.call(this, 'TinyXception') || this;
	        _this._numMainBlocks = numMainBlocks;
	        return _this;
	    }
	    TinyXception.prototype.forwardInput = function (input) {
	        var _this = this;
	        var params = this.params;
	        if (!params) {
	            throw new Error('TinyXception - load model before inference');
	        }
	        return tf.tidy(function () {
	            var batchTensor = input.toBatchTensor(112, true);
	            var meanRgb = [122.782, 117.001, 104.298];
	            var normalized = ops_1.normalize(batchTensor, meanRgb).div(tf.scalar(256));
	            var out = tf.relu(conv(normalized, params.entry_flow.conv_in, [2, 2]));
	            out = reductionBlock(out, params.entry_flow.reduction_block_0, false);
	            out = reductionBlock(out, params.entry_flow.reduction_block_1);
	            utils_1.range(_this._numMainBlocks, 0, 1).forEach(function (idx) {
	                out = mainBlock(out, params.middle_flow["main_block_" + idx]);
	            });
	            out = reductionBlock(out, params.exit_flow.reduction_block);
	            out = tf.relu(common_1.depthwiseSeparableConv(out, params.exit_flow.separable_conv, [1, 1]));
	            return out;
	        });
	    };
	    TinyXception.prototype.forward = function (input) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _a;
	            return tslib_1.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        _a = this.forwardInput;
	                        return [4 /*yield*/, dom_1.toNetInput(input)];
	                    case 1: return [2 /*return*/, _a.apply(this, [_b.sent()])];
	                }
	            });
	        });
	    };
	    TinyXception.prototype.getDefaultModelName = function () {
	        return 'tiny_xception_model';
	    };
	    TinyXception.prototype.extractParamsFromWeigthMap = function (weightMap) {
	        return extractParamsFromWeigthMap_1.extractParamsFromWeigthMap(weightMap, this._numMainBlocks);
	    };
	    TinyXception.prototype.extractParams = function (weights) {
	        return extractParams_1.extractParams(weights, this._numMainBlocks);
	    };
	    return TinyXception;
	}(NeuralNetwork_1.NeuralNetwork));
	exports.TinyXception = TinyXception;
	//# sourceMappingURL=TinyXception.js.map

/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(33);
	var utils_1 = __webpack_require__(34);
	function extractorsFactory(extractWeights, paramMappings) {
	    var extractConvParams = common_1.extractConvParamsFactory(extractWeights, paramMappings);
	    var extractSeparableConvParams = common_1.extractSeparableConvParamsFactory(extractWeights, paramMappings);
	    function extractReductionBlockParams(channelsIn, channelsOut, mappedPrefix) {
	        var separable_conv0 = extractSeparableConvParams(channelsIn, channelsOut, mappedPrefix + "/separable_conv0");
	        var separable_conv1 = extractSeparableConvParams(channelsOut, channelsOut, mappedPrefix + "/separable_conv1");
	        var expansion_conv = extractConvParams(channelsIn, channelsOut, 1, mappedPrefix + "/expansion_conv");
	        return { separable_conv0: separable_conv0, separable_conv1: separable_conv1, expansion_conv: expansion_conv };
	    }
	    function extractMainBlockParams(channels, mappedPrefix) {
	        var separable_conv0 = extractSeparableConvParams(channels, channels, mappedPrefix + "/separable_conv0");
	        var separable_conv1 = extractSeparableConvParams(channels, channels, mappedPrefix + "/separable_conv1");
	        var separable_conv2 = extractSeparableConvParams(channels, channels, mappedPrefix + "/separable_conv2");
	        return { separable_conv0: separable_conv0, separable_conv1: separable_conv1, separable_conv2: separable_conv2 };
	    }
	    return {
	        extractConvParams: extractConvParams,
	        extractSeparableConvParams: extractSeparableConvParams,
	        extractReductionBlockParams: extractReductionBlockParams,
	        extractMainBlockParams: extractMainBlockParams
	    };
	}
	function extractParams(weights, numMainBlocks) {
	    var paramMappings = [];
	    var _a = common_1.extractWeightsFactory(weights), extractWeights = _a.extractWeights, getRemainingWeights = _a.getRemainingWeights;
	    var _b = extractorsFactory(extractWeights, paramMappings), extractConvParams = _b.extractConvParams, extractSeparableConvParams = _b.extractSeparableConvParams, extractReductionBlockParams = _b.extractReductionBlockParams, extractMainBlockParams = _b.extractMainBlockParams;
	    var entry_flow_conv_in = extractConvParams(3, 32, 3, 'entry_flow/conv_in');
	    var entry_flow_reduction_block_0 = extractReductionBlockParams(32, 64, 'entry_flow/reduction_block_0');
	    var entry_flow_reduction_block_1 = extractReductionBlockParams(64, 128, 'entry_flow/reduction_block_1');
	    var entry_flow = {
	        conv_in: entry_flow_conv_in,
	        reduction_block_0: entry_flow_reduction_block_0,
	        reduction_block_1: entry_flow_reduction_block_1
	    };
	    var middle_flow = {};
	    utils_1.range(numMainBlocks, 0, 1).forEach(function (idx) {
	        middle_flow["main_block_" + idx] = extractMainBlockParams(128, "middle_flow/main_block_" + idx);
	    });
	    var exit_flow_reduction_block = extractReductionBlockParams(128, 256, 'exit_flow/reduction_block');
	    var exit_flow_separable_conv = extractSeparableConvParams(256, 512, 'exit_flow/separable_conv');
	    var exit_flow = {
	        reduction_block: exit_flow_reduction_block,
	        separable_conv: exit_flow_separable_conv
	    };
	    if (getRemainingWeights().length !== 0) {
	        throw new Error("weights remaing after extract: " + getRemainingWeights().length);
	    }
	    return {
	        paramMappings: paramMappings,
	        params: { entry_flow: entry_flow, middle_flow: middle_flow, exit_flow: exit_flow }
	    };
	}
	exports.extractParams = extractParams;
	//# sourceMappingURL=extractParams.js.map

/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(33);
	var loadConvParamsFactory_1 = __webpack_require__(583);
	var utils_1 = __webpack_require__(34);
	function loadParamsFactory(weightMap, paramMappings) {
	    var extractWeightEntry = common_1.extractWeightEntryFactory(weightMap, paramMappings);
	    var extractConvParams = loadConvParamsFactory_1.loadConvParamsFactory(extractWeightEntry);
	    var extractSeparableConvParams = common_1.loadSeparableConvParamsFactory(extractWeightEntry);
	    function extractReductionBlockParams(mappedPrefix) {
	        var separable_conv0 = extractSeparableConvParams(mappedPrefix + "/separable_conv0");
	        var separable_conv1 = extractSeparableConvParams(mappedPrefix + "/separable_conv1");
	        var expansion_conv = extractConvParams(mappedPrefix + "/expansion_conv");
	        return { separable_conv0: separable_conv0, separable_conv1: separable_conv1, expansion_conv: expansion_conv };
	    }
	    function extractMainBlockParams(mappedPrefix) {
	        var separable_conv0 = extractSeparableConvParams(mappedPrefix + "/separable_conv0");
	        var separable_conv1 = extractSeparableConvParams(mappedPrefix + "/separable_conv1");
	        var separable_conv2 = extractSeparableConvParams(mappedPrefix + "/separable_conv2");
	        return { separable_conv0: separable_conv0, separable_conv1: separable_conv1, separable_conv2: separable_conv2 };
	    }
	    return {
	        extractConvParams: extractConvParams,
	        extractSeparableConvParams: extractSeparableConvParams,
	        extractReductionBlockParams: extractReductionBlockParams,
	        extractMainBlockParams: extractMainBlockParams
	    };
	}
	function extractParamsFromWeigthMap(weightMap, numMainBlocks) {
	    var paramMappings = [];
	    var _a = loadParamsFactory(weightMap, paramMappings), extractConvParams = _a.extractConvParams, extractSeparableConvParams = _a.extractSeparableConvParams, extractReductionBlockParams = _a.extractReductionBlockParams, extractMainBlockParams = _a.extractMainBlockParams;
	    var entry_flow_conv_in = extractConvParams('entry_flow/conv_in');
	    var entry_flow_reduction_block_0 = extractReductionBlockParams('entry_flow/reduction_block_0');
	    var entry_flow_reduction_block_1 = extractReductionBlockParams('entry_flow/reduction_block_1');
	    var entry_flow = {
	        conv_in: entry_flow_conv_in,
	        reduction_block_0: entry_flow_reduction_block_0,
	        reduction_block_1: entry_flow_reduction_block_1
	    };
	    var middle_flow = {};
	    utils_1.range(numMainBlocks, 0, 1).forEach(function (idx) {
	        middle_flow["main_block_" + idx] = extractMainBlockParams("middle_flow/main_block_" + idx);
	    });
	    var exit_flow_reduction_block = extractReductionBlockParams('exit_flow/reduction_block');
	    var exit_flow_separable_conv = extractSeparableConvParams('exit_flow/separable_conv');
	    var exit_flow = {
	        reduction_block: exit_flow_reduction_block,
	        separable_conv: exit_flow_separable_conv
	    };
	    common_1.disposeUnusedWeightTensors(weightMap, paramMappings);
	    return { params: { entry_flow: entry_flow, middle_flow: middle_flow, exit_flow: exit_flow }, paramMappings: paramMappings };
	}
	exports.extractParamsFromWeigthMap = extractParamsFromWeigthMap;
	//# sourceMappingURL=extractParamsFromWeigthMap.js.map

/***/ },
/* 1508 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 1509 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(1508);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(1518);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(20);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(67);
	
	var createArrayFromMixed = __webpack_require__(1511);
	var getMarkupWrap = __webpack_require__(1513);
	var invariant = __webpack_require__(20);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(67);
	
	var invariant = __webpack_require__(20);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 1514 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 1515 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(1515);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 1517 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 1518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(1517);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 1519 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isFSA = isFSA;
	exports.isError = isError;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodashIsplainobject = __webpack_require__(1557);
	
	var _lodashIsplainobject2 = _interopRequireDefault(_lodashIsplainobject);
	
	var validKeys = ['type', 'payload', 'error', 'meta'];
	
	function isValidKey(key) {
	  return validKeys.indexOf(key) > -1;
	}
	
	function isFSA(action) {
	  return _lodashIsplainobject2['default'](action) && typeof action.type !== 'undefined' && Object.keys(action).every(isValidKey);
	}
	
	function isError(action) {
	  return action.error === true;
	}

/***/ },
/* 1521 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var toStr = Object.prototype.toString;
	var max = Math.max;
	var funcType = '[object Function]';
	
	var concatty = function concatty(a, b) {
	    var arr = [];
	
	    for (var i = 0; i < a.length; i += 1) {
	        arr[i] = a[i];
	    }
	    for (var j = 0; j < b.length; j += 1) {
	        arr[j + a.length] = b[j];
	    }
	
	    return arr;
	};
	
	var slicy = function slicy(arrLike, offset) {
	    var arr = [];
	    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
	        arr[j] = arrLike[i];
	    }
	    return arr;
	};
	
	var joiny = function (arr, joiner) {
	    var str = '';
	    for (var i = 0; i < arr.length; i += 1) {
	        str += arr[i];
	        if (i + 1 < arr.length) {
	            str += joiner;
	        }
	    }
	    return str;
	};
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slicy(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                concatty(args, arguments)
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        }
	        return target.apply(
	            that,
	            concatty(args, arguments)
	        );
	
	    };
	
	    var boundLength = max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs[i] = '$' + i;
	    }
	
	    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reflectGetProto = __webpack_require__(632);
	var originalGetProto = __webpack_require__(631);
	
	var getDunderProto = __webpack_require__(1361);
	
	/** @type {import('.')} */
	module.exports = reflectGetProto
		? function getProto(O) {
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return reflectGetProto(O);
		}
		: originalGetProto
			? function getProto(O) {
				if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
					throw new TypeError('getProto: not an object');
				}
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return originalGetProto(O);
			}
			: getDunderProto
				? function getProto(O) {
					// @ts-expect-error TS can't narrow inside a closure, for some reason
					return getDunderProto(O);
				}
				: null;


/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var define = __webpack_require__(94);
	var isSymbol = __webpack_require__(641);
	
	var globalKey = '__ global cache key __';
	/* istanbul ignore else */
	// eslint-disable-next-line no-restricted-properties
	if (typeof Symbol === 'function' && isSymbol(Symbol('foo')) && typeof Symbol['for'] === 'function') {
		// eslint-disable-next-line no-restricted-properties
		globalKey = Symbol['for'](globalKey);
	}
	
	var trueThunk = function () {
		return true;
	};
	
	var ensureCache = function ensureCache() {
		if (!global[globalKey]) {
			var properties = {};
			properties[globalKey] = {};
			var predicates = {};
			predicates[globalKey] = trueThunk;
			define(global, properties, predicates);
		}
		return global[globalKey];
	};
	
	var cache = ensureCache();
	
	var isPrimitive = function isPrimitive(val) {
		return val === null || (typeof val !== 'object' && typeof val !== 'function');
	};
	
	var getPrimitiveKey = function getPrimitiveKey(val) {
		if (isSymbol(val)) {
			return Symbol.prototype.valueOf.call(val);
		}
		return typeof val + ' | ' + String(val);
	};
	
	var requirePrimitiveKey = function requirePrimitiveKey(val) {
		if (!isPrimitive(val)) {
			throw new TypeError('key must not be an object');
		}
	};
	
	var globalCache = {
		clear: function clear() {
			delete global[globalKey];
			cache = ensureCache();
		},
	
		'delete': function deleteKey(key) {
			requirePrimitiveKey(key);
			delete cache[getPrimitiveKey(key)];
			return !globalCache.has(key);
		},
	
		get: function get(key) {
			requirePrimitiveKey(key);
			return cache[getPrimitiveKey(key)];
		},
	
		has: function has(key) {
			requirePrimitiveKey(key);
			return getPrimitiveKey(key) in cache;
		},
	
		set: function set(key, value) {
			requirePrimitiveKey(key);
			var primitiveKey = getPrimitiveKey(key);
			var props = {};
			props[primitiveKey] = value;
			var predicates = {};
			predicates[primitiveKey] = trueThunk;
			define(cache, props, predicates);
			return globalCache.has(key);
		},
	
		setIfMissingThenGet: function setIfMissingThenGet(key, valueThunk) {
			if (globalCache.has(key)) {
				return globalCache.get(key);
			}
			var item = valueThunk();
			globalCache.set(key, item);
			return item;
		}
	};
	
	module.exports = globalCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1524 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./gOPD')} */
	module.exports = Object.getOwnPropertyDescriptor;


/***/ },
/* 1525 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },
/* 1526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(401);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(170);
	
	var _DOMUtils = __webpack_require__(276);
	
	var _DOMStateStorage = __webpack_require__(635);
	
	var _PathUtils = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(401);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(170);
	
	var _PathUtils = __webpack_require__(126);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(402);
	
	var _BrowserProtocol = __webpack_require__(401);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(1527);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(276);
	
	var _createHistory = __webpack_require__(403);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(402);
	
	var _DOMUtils = __webpack_require__(276);
	
	var _HashProtocol = __webpack_require__(1526);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(403);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(170);
	
	var _PathUtils = __webpack_require__(126);
	
	var _createHistory = __webpack_require__(403);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(275);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 1531 */
/***/ function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 1532 */
/***/ function(module, exports) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	var RelativeTimeFormat;
	// -- Utilities ----------------------------------------------------------------
	function getCacheId(inputs) {
	    return JSON.stringify(inputs.map(function (input) {
	        return input && typeof input === 'object' ? orderedProps(input) : input;
	    }));
	}
	function orderedProps(obj) {
	    return Object.keys(obj)
	        .sort()
	        .map(function (k) {
	        var _a;
	        return (_a = {}, _a[k] = obj[k], _a);
	    });
	}
	var memoizeFormatConstructor = function (FormatConstructor, cache) {
	    if (cache === void 0) { cache = {}; }
	    return function () {
	        var _a;
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var cacheId = getCacheId(args);
	        var format = cacheId && cache[cacheId];
	        if (!format) {
	            format = new ((_a = FormatConstructor).bind.apply(_a, [void 0].concat(args)))();
	            if (cacheId) {
	                cache[cacheId] = format;
	            }
	        }
	        return format;
	    };
	};
	exports.default = memoizeFormatConstructor;
	//# sourceMappingURL=index.js.map

/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(1532)['default'];
	exports['default'] = exports;


/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(1535)['default'];
	exports['default'] = exports;


/***/ },
/* 1535 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = (function() {
	  "use strict";
	
	  /*
	   * Generated by PEG.js 0.9.0.
	   *
	   * http://pegjs.org/
	   */
	
	  function peg$subclass(child, parent) {
	    function ctor() { this.constructor = child; }
	    ctor.prototype = parent.prototype;
	    child.prototype = new ctor();
	  }
	
	  function peg$SyntaxError(message, expected, found, location) {
	    this.message  = message;
	    this.expected = expected;
	    this.found    = found;
	    this.location = location;
	    this.name     = "SyntaxError";
	
	    if (typeof Error.captureStackTrace === "function") {
	      Error.captureStackTrace(this, peg$SyntaxError);
	    }
	  }
	
	  peg$subclass(peg$SyntaxError, Error);
	
	  function peg$parse(input) {
	    var options = arguments.length > 1 ? arguments[1] : {},
	        parser  = this,
	
	        peg$FAILED = {},
	
	        peg$startRuleFunctions = { start: peg$parsestart },
	        peg$startRuleFunction  = peg$parsestart,
	
	        peg$c0 = function(elements) {
	                return {
	                    type    : 'messageFormatPattern',
	                    elements: elements,
	                    location: location()
	                };
	            },
	        peg$c1 = function(text) {
	                var string = '',
	                    i, j, outerLen, inner, innerLen;
	
	                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
	                    inner = text[i];
	
	                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
	                        string += inner[j];
	                    }
	                }
	
	                return string;
	            },
	        peg$c2 = function(messageText) {
	                return {
	                    type : 'messageTextElement',
	                    value: messageText,
	                    location: location()
	                };
	            },
	        peg$c3 = /^[^ \t\n\r,.+={}#]/,
	        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
	        peg$c5 = "{",
	        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
	        peg$c7 = ",",
	        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
	        peg$c9 = "}",
	        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
	        peg$c11 = function(id, format) {
	                return {
	                    type  : 'argumentElement',
	                    id    : id,
	                    format: format && format[2],
	                    location: location()
	                };
	            },
	        peg$c12 = "number",
	        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
	        peg$c14 = "date",
	        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
	        peg$c16 = "time",
	        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
	        peg$c18 = function(type, style) {
	                return {
	                    type : type + 'Format',
	                    style: style && style[2],
	                    location: location()
	                };
	            },
	        peg$c19 = "plural",
	        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
	        peg$c21 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: false,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options,
	                    location: location()
	                };
	            },
	        peg$c22 = "selectordinal",
	        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
	        peg$c24 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: true,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options,
	                    location: location()
	                }
	            },
	        peg$c25 = "select",
	        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
	        peg$c27 = function(options) {
	                return {
	                    type   : 'selectFormat',
	                    options: options,
	                    location: location()
	                };
	            },
	        peg$c28 = "=",
	        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
	        peg$c30 = function(selector, pattern) {
	                return {
	                    type    : 'optionalFormatPattern',
	                    selector: selector,
	                    value   : pattern,
	                    location: location()
	                };
	            },
	        peg$c31 = "offset:",
	        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
	        peg$c33 = function(number) {
	                return number;
	            },
	        peg$c34 = function(offset, options) {
	                return {
	                    type   : 'pluralFormat',
	                    offset : offset,
	                    options: options,
	                    location: location()
	                };
	            },
	        peg$c35 = { type: "other", description: "whitespace" },
	        peg$c36 = /^[ \t\n\r]/,
	        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
	        peg$c38 = { type: "other", description: "optionalWhitespace" },
	        peg$c39 = /^[0-9]/,
	        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
	        peg$c41 = /^[0-9a-f]/i,
	        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
	        peg$c43 = "0",
	        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
	        peg$c45 = /^[1-9]/,
	        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
	        peg$c47 = function(digits) {
	            return parseInt(digits, 10);
	        },
	        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
	        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
	        peg$c50 = "\\\\",
	        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
	        peg$c52 = function() { return '\\'; },
	        peg$c53 = "\\#",
	        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
	        peg$c55 = function() { return '\\#'; },
	        peg$c56 = "\\{",
	        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
	        peg$c58 = function() { return '\u007B'; },
	        peg$c59 = "\\}",
	        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
	        peg$c61 = function() { return '\u007D'; },
	        peg$c62 = "\\u",
	        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
	        peg$c64 = function(digits) {
	                return String.fromCharCode(parseInt(digits, 16));
	            },
	        peg$c65 = function(chars) { return chars.join(''); },
	
	        peg$currPos          = 0,
	        peg$savedPos         = 0,
	        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
	        peg$maxFailPos       = 0,
	        peg$maxFailExpected  = [],
	        peg$silentFails      = 0,
	
	        peg$result;
	
	    if ("startRule" in options) {
	      if (!(options.startRule in peg$startRuleFunctions)) {
	        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	      }
	
	      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	    }
	
	    function text() {
	      return input.substring(peg$savedPos, peg$currPos);
	    }
	
	    function location() {
	      return peg$computeLocation(peg$savedPos, peg$currPos);
	    }
	
	    function expected(description) {
	      throw peg$buildException(
	        null,
	        [{ type: "other", description: description }],
	        input.substring(peg$savedPos, peg$currPos),
	        peg$computeLocation(peg$savedPos, peg$currPos)
	      );
	    }
	
	    function error(message) {
	      throw peg$buildException(
	        message,
	        null,
	        input.substring(peg$savedPos, peg$currPos),
	        peg$computeLocation(peg$savedPos, peg$currPos)
	      );
	    }
	
	    function peg$computePosDetails(pos) {
	      var details = peg$posDetailsCache[pos],
	          p, ch;
	
	      if (details) {
	        return details;
	      } else {
	        p = pos - 1;
	        while (!peg$posDetailsCache[p]) {
	          p--;
	        }
	
	        details = peg$posDetailsCache[p];
	        details = {
	          line:   details.line,
	          column: details.column,
	          seenCR: details.seenCR
	        };
	
	        while (p < pos) {
	          ch = input.charAt(p);
	          if (ch === "\n") {
	            if (!details.seenCR) { details.line++; }
	            details.column = 1;
	            details.seenCR = false;
	          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
	            details.line++;
	            details.column = 1;
	            details.seenCR = true;
	          } else {
	            details.column++;
	            details.seenCR = false;
	          }
	
	          p++;
	        }
	
	        peg$posDetailsCache[pos] = details;
	        return details;
	      }
	    }
	
	    function peg$computeLocation(startPos, endPos) {
	      var startPosDetails = peg$computePosDetails(startPos),
	          endPosDetails   = peg$computePosDetails(endPos);
	
	      return {
	        start: {
	          offset: startPos,
	          line:   startPosDetails.line,
	          column: startPosDetails.column
	        },
	        end: {
	          offset: endPos,
	          line:   endPosDetails.line,
	          column: endPosDetails.column
	        }
	      };
	    }
	
	    function peg$fail(expected) {
	      if (peg$currPos < peg$maxFailPos) { return; }
	
	      if (peg$currPos > peg$maxFailPos) {
	        peg$maxFailPos = peg$currPos;
	        peg$maxFailExpected = [];
	      }
	
	      peg$maxFailExpected.push(expected);
	    }
	
	    function peg$buildException(message, expected, found, location) {
	      function cleanupExpected(expected) {
	        var i = 1;
	
	        expected.sort(function(a, b) {
	          if (a.description < b.description) {
	            return -1;
	          } else if (a.description > b.description) {
	            return 1;
	          } else {
	            return 0;
	          }
	        });
	
	        while (i < expected.length) {
	          if (expected[i - 1] === expected[i]) {
	            expected.splice(i, 1);
	          } else {
	            i++;
	          }
	        }
	      }
	
	      function buildMessage(expected, found) {
	        function stringEscape(s) {
	          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }
	
	          return s
	            .replace(/\\/g,   '\\\\')
	            .replace(/"/g,    '\\"')
	            .replace(/\x08/g, '\\b')
	            .replace(/\t/g,   '\\t')
	            .replace(/\n/g,   '\\n')
	            .replace(/\f/g,   '\\f')
	            .replace(/\r/g,   '\\r')
	            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
	            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
	            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
	            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
	        }
	
	        var expectedDescs = new Array(expected.length),
	            expectedDesc, foundDesc, i;
	
	        for (i = 0; i < expected.length; i++) {
	          expectedDescs[i] = expected[i].description;
	        }
	
	        expectedDesc = expected.length > 1
	          ? expectedDescs.slice(0, -1).join(", ")
	              + " or "
	              + expectedDescs[expected.length - 1]
	          : expectedDescs[0];
	
	        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
	
	        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
	      }
	
	      if (expected !== null) {
	        cleanupExpected(expected);
	      }
	
	      return new peg$SyntaxError(
	        message !== null ? message : buildMessage(expected, found),
	        expected,
	        found,
	        location
	      );
	    }
	
	    function peg$parsestart() {
	      var s0;
	
	      s0 = peg$parsemessageFormatPattern();
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatPattern() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsemessageFormatElement();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsemessageFormatElement();
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c0(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatElement() {
	      var s0;
	
	      s0 = peg$parsemessageTextElement();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parseargumentElement();
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageText() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parse_();
	      if (s3 !== peg$FAILED) {
	        s4 = peg$parsechars();
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parse_();
	          if (s5 !== peg$FAILED) {
	            s3 = [s3, s4, s5];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$FAILED;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsechars();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s3 = [s3, s4, s5];
	                s2 = s3;
	              } else {
	                peg$currPos = s2;
	                s2 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s2;
	              s2 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c1(s1);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = peg$parsews();
	        if (s1 !== peg$FAILED) {
	          s0 = input.substring(s0, peg$currPos);
	        } else {
	          s0 = s1;
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageTextElement() {
	      var s0, s1;
	
	      s0 = peg$currPos;
	      s1 = peg$parsemessageText();
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c2(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseargument() {
	      var s0, s1, s2;
	
	      s0 = peg$parsenumber();
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = [];
	        if (peg$c3.test(input.charAt(peg$currPos))) {
	          s2 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c4); }
	        }
	        if (s2 !== peg$FAILED) {
	          while (s2 !== peg$FAILED) {
	            s1.push(s2);
	            if (peg$c3.test(input.charAt(peg$currPos))) {
	              s2 = input.charAt(peg$currPos);
	              peg$currPos++;
	            } else {
	              s2 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c4); }
	            }
	          }
	        } else {
	          s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	          s0 = input.substring(s0, peg$currPos);
	        } else {
	          s0 = s1;
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parseargumentElement() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 123) {
	        s1 = peg$c5;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c6); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parseargument();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$currPos;
	              if (input.charCodeAt(peg$currPos) === 44) {
	                s6 = peg$c7;
	                peg$currPos++;
	              } else {
	                s6 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c8); }
	              }
	              if (s6 !== peg$FAILED) {
	                s7 = peg$parse_();
	                if (s7 !== peg$FAILED) {
	                  s8 = peg$parseelementFormat();
	                  if (s8 !== peg$FAILED) {
	                    s6 = [s6, s7, s8];
	                    s5 = s6;
	                  } else {
	                    peg$currPos = s5;
	                    s5 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s5;
	                  s5 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s5;
	                s5 = peg$FAILED;
	              }
	              if (s5 === peg$FAILED) {
	                s5 = null;
	              }
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parse_();
	                if (s6 !== peg$FAILED) {
	                  if (input.charCodeAt(peg$currPos) === 125) {
	                    s7 = peg$c9;
	                    peg$currPos++;
	                  } else {
	                    s7 = peg$FAILED;
	                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
	                  }
	                  if (s7 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c11(s3, s5);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseelementFormat() {
	      var s0;
	
	      s0 = peg$parsesimpleFormat();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsepluralFormat();
	        if (s0 === peg$FAILED) {
	          s0 = peg$parseselectOrdinalFormat();
	          if (s0 === peg$FAILED) {
	            s0 = peg$parseselectFormat();
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsesimpleFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c12) {
	        s1 = peg$c12;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c13); }
	      }
	      if (s1 === peg$FAILED) {
	        if (input.substr(peg$currPos, 4) === peg$c14) {
	          s1 = peg$c14;
	          peg$currPos += 4;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c15); }
	        }
	        if (s1 === peg$FAILED) {
	          if (input.substr(peg$currPos, 4) === peg$c16) {
	            s1 = peg$c16;
	            peg$currPos += 4;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c17); }
	          }
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$currPos;
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s4 = peg$c7;
	            peg$currPos++;
	          } else {
	            s4 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s4 !== peg$FAILED) {
	            s5 = peg$parse_();
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parsechars();
	              if (s6 !== peg$FAILED) {
	                s4 = [s4, s5, s6];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s3;
	            s3 = peg$FAILED;
	          }
	          if (s3 === peg$FAILED) {
	            s3 = null;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c18(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c19) {
	        s1 = peg$c19;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c20); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c21(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectOrdinalFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 13) === peg$c22) {
	        s1 = peg$c22;
	        peg$currPos += 13;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c23); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c24(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c25) {
	        s1 = peg$c25;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c26); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = [];
	              s6 = peg$parseoptionalFormatPattern();
	              if (s6 !== peg$FAILED) {
	                while (s6 !== peg$FAILED) {
	                  s5.push(s6);
	                  s6 = peg$parseoptionalFormatPattern();
	                }
	              } else {
	                s5 = peg$FAILED;
	              }
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c27(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselector() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 61) {
	        s2 = peg$c28;
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c29); }
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parsenumber();
	        if (s3 !== peg$FAILED) {
	          s2 = [s2, s3];
	          s1 = s2;
	        } else {
	          peg$currPos = s1;
	          s1 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s1;
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        s0 = input.substring(s0, peg$currPos);
	      } else {
	        s0 = s1;
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsechars();
	      }
	
	      return s0;
	    }
	
	    function peg$parseoptionalFormatPattern() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseselector();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 123) {
	              s4 = peg$c5;
	              peg$currPos++;
	            } else {
	              s4 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c6); }
	            }
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parsemessageFormatPattern();
	                if (s6 !== peg$FAILED) {
	                  s7 = peg$parse_();
	                  if (s7 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 125) {
	                      s8 = peg$c9;
	                      peg$currPos++;
	                    } else {
	                      s8 = peg$FAILED;
	                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
	                    }
	                    if (s8 !== peg$FAILED) {
	                      peg$savedPos = s0;
	                      s1 = peg$c30(s2, s6);
	                      s0 = s1;
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseoffset() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 7) === peg$c31) {
	        s1 = peg$c31;
	        peg$currPos += 7;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c32); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parsenumber();
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c33(s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralStyle() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = peg$parseoffset();
	      if (s1 === peg$FAILED) {
	        s1 = null;
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = [];
	          s4 = peg$parseoptionalFormatPattern();
	          if (s4 !== peg$FAILED) {
	            while (s4 !== peg$FAILED) {
	              s3.push(s4);
	              s4 = peg$parseoptionalFormatPattern();
	            }
	          } else {
	            s3 = peg$FAILED;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c34(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsews() {
	      var s0, s1;
	
	      peg$silentFails++;
	      s0 = [];
	      if (peg$c36.test(input.charAt(peg$currPos))) {
	        s1 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c37); }
	      }
	      if (s1 !== peg$FAILED) {
	        while (s1 !== peg$FAILED) {
	          s0.push(s1);
	          if (peg$c36.test(input.charAt(peg$currPos))) {
	            s1 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c37); }
	          }
	        }
	      } else {
	        s0 = peg$FAILED;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c35); }
	      }
	
	      return s0;
	    }
	
	    function peg$parse_() {
	      var s0, s1, s2;
	
	      peg$silentFails++;
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsews();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsews();
	      }
	      if (s1 !== peg$FAILED) {
	        s0 = input.substring(s0, peg$currPos);
	      } else {
	        s0 = s1;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c38); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsedigit() {
	      var s0;
	
	      if (peg$c39.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c40); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsehexDigit() {
	      var s0;
	
	      if (peg$c41.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c42); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsenumber() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 48) {
	        s1 = peg$c43;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c44); }
	      }
	      if (s1 === peg$FAILED) {
	        s1 = peg$currPos;
	        s2 = peg$currPos;
	        if (peg$c45.test(input.charAt(peg$currPos))) {
	          s3 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s3 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c46); }
	        }
	        if (s3 !== peg$FAILED) {
	          s4 = [];
	          s5 = peg$parsedigit();
	          while (s5 !== peg$FAILED) {
	            s4.push(s5);
	            s5 = peg$parsedigit();
	          }
	          if (s4 !== peg$FAILED) {
	            s3 = [s3, s4];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	          s1 = input.substring(s1, peg$currPos);
	        } else {
	          s1 = s2;
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c47(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsechar() {
	      var s0, s1, s2, s3, s4, s5, s6, s7;
	
	      if (peg$c48.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c49); }
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c50) {
	          s1 = peg$c50;
	          peg$currPos += 2;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c51); }
	        }
	        if (s1 !== peg$FAILED) {
	          peg$savedPos = s0;
	          s1 = peg$c52();
	        }
	        s0 = s1;
	        if (s0 === peg$FAILED) {
	          s0 = peg$currPos;
	          if (input.substr(peg$currPos, 2) === peg$c53) {
	            s1 = peg$c53;
	            peg$currPos += 2;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c54); }
	          }
	          if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c55();
	          }
	          s0 = s1;
	          if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            if (input.substr(peg$currPos, 2) === peg$c56) {
	              s1 = peg$c56;
	              peg$currPos += 2;
	            } else {
	              s1 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c57); }
	            }
	            if (s1 !== peg$FAILED) {
	              peg$savedPos = s0;
	              s1 = peg$c58();
	            }
	            s0 = s1;
	            if (s0 === peg$FAILED) {
	              s0 = peg$currPos;
	              if (input.substr(peg$currPos, 2) === peg$c59) {
	                s1 = peg$c59;
	                peg$currPos += 2;
	              } else {
	                s1 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c60); }
	              }
	              if (s1 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c61();
	              }
	              s0 = s1;
	              if (s0 === peg$FAILED) {
	                s0 = peg$currPos;
	                if (input.substr(peg$currPos, 2) === peg$c62) {
	                  s1 = peg$c62;
	                  peg$currPos += 2;
	                } else {
	                  s1 = peg$FAILED;
	                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
	                }
	                if (s1 !== peg$FAILED) {
	                  s2 = peg$currPos;
	                  s3 = peg$currPos;
	                  s4 = peg$parsehexDigit();
	                  if (s4 !== peg$FAILED) {
	                    s5 = peg$parsehexDigit();
	                    if (s5 !== peg$FAILED) {
	                      s6 = peg$parsehexDigit();
	                      if (s6 !== peg$FAILED) {
	                        s7 = peg$parsehexDigit();
	                        if (s7 !== peg$FAILED) {
	                          s4 = [s4, s5, s6, s7];
	                          s3 = s4;
	                        } else {
	                          peg$currPos = s3;
	                          s3 = peg$FAILED;
	                        }
	                      } else {
	                        peg$currPos = s3;
	                        s3 = peg$FAILED;
	                      }
	                    } else {
	                      peg$currPos = s3;
	                      s3 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s3;
	                    s3 = peg$FAILED;
	                  }
	                  if (s3 !== peg$FAILED) {
	                    s2 = input.substring(s2, peg$currPos);
	                  } else {
	                    s2 = s3;
	                  }
	                  if (s2 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c64(s2);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              }
	            }
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsechars() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsechar();
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$parsechar();
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c65(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    peg$result = peg$startRuleFunction();
	
	    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	      return peg$result;
	    } else {
	      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	        peg$fail({ type: "end", description: "end of input" });
	      }
	
	      throw peg$buildException(
	        null,
	        peg$maxFailExpected,
	        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
	        peg$maxFailPos < input.length
	          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
	          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
	      );
	    }
	  }
	
	  return {
	    SyntaxError: peg$SyntaxError,
	    parse:       peg$parse
	  };
	})();
	
	//# sourceMappingURL=parser.js.map

/***/ },
/* 1536 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports["default"] = Compiler;
	
	function Compiler(locales, formats, pluralFn) {
	    this.locales  = locales;
	    this.formats  = formats;
	    this.pluralFn = pluralFn;
	}
	
	Compiler.prototype.compile = function (ast) {
	    this.pluralStack        = [];
	    this.currentPlural      = null;
	    this.pluralNumberFormat = null;
	
	    return this.compileMessage(ast);
	};
	
	Compiler.prototype.compileMessage = function (ast) {
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new Error('Message AST is not of type: "messageFormatPattern"');
	    }
	
	    var elements = ast.elements,
	        pattern  = [];
	
	    var i, len, element;
	
	    for (i = 0, len = elements.length; i < len; i += 1) {
	        element = elements[i];
	
	        switch (element.type) {
	            case 'messageTextElement':
	                pattern.push(this.compileMessageText(element));
	                break;
	
	            case 'argumentElement':
	                pattern.push(this.compileArgument(element));
	                break;
	
	            default:
	                throw new Error('Message element does not have a valid type');
	        }
	    }
	
	    return pattern;
	};
	
	Compiler.prototype.compileMessageText = function (element) {
	    // When this `element` is part of plural sub-pattern and its value contains
	    // an unescaped '#', use a `PluralOffsetString` helper to properly output
	    // the number with the correct offset in the string.
	    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
	        // Create a cache a NumberFormat instance that can be reused for any
	        // PluralOffsetString instance in this message.
	        if (!this.pluralNumberFormat) {
	            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
	        }
	
	        return new PluralOffsetString(
	                this.currentPlural.id,
	                this.currentPlural.format.offset,
	                this.pluralNumberFormat,
	                element.value);
	    }
	
	    // Unescape the escaped '#'s in the message text.
	    return element.value.replace(/\\#/g, '#');
	};
	
	Compiler.prototype.compileArgument = function (element) {
	    var format = element.format;
	
	    if (!format) {
	        return new StringFormat(element.id);
	    }
	
	    var formats  = this.formats,
	        locales  = this.locales,
	        pluralFn = this.pluralFn,
	        options;
	
	    switch (format.type) {
	        case 'numberFormat':
	            options = formats.number[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.NumberFormat(locales, options).format
	            };
	
	        case 'dateFormat':
	            options = formats.date[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'timeFormat':
	            options = formats.time[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'pluralFormat':
	            options = this.compileOptions(element);
	            return new PluralFormat(
	                element.id, format.ordinal, format.offset, options, pluralFn
	            );
	
	        case 'selectFormat':
	            options = this.compileOptions(element);
	            return new SelectFormat(element.id, options);
	
	        default:
	            throw new Error('Message element does not have a valid format type');
	    }
	};
	
	Compiler.prototype.compileOptions = function (element) {
	    var format      = element.format,
	        options     = format.options,
	        optionsHash = {};
	
	    // Save the current plural element, if any, then set it to a new value when
	    // compiling the options sub-patterns. This conforms the spec's algorithm
	    // for handling `"#"` syntax in message text.
	    this.pluralStack.push(this.currentPlural);
	    this.currentPlural = format.type === 'pluralFormat' ? element : null;
	
	    var i, len, option;
	
	    for (i = 0, len = options.length; i < len; i += 1) {
	        option = options[i];
	
	        // Compile the sub-pattern and save it under the options's selector.
	        optionsHash[option.selector] = this.compileMessage(option.value);
	    }
	
	    // Pop the plural stack to put back the original current plural value.
	    this.currentPlural = this.pluralStack.pop();
	
	    return optionsHash;
	};
	
	// -- Compiler Helper Classes --------------------------------------------------
	
	function StringFormat(id) {
	    this.id = id;
	}
	
	StringFormat.prototype.format = function (value) {
	    if (!value && typeof value !== 'number') {
	        return '';
	    }
	
	    return typeof value === 'string' ? value : String(value);
	};
	
	function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
	    this.id         = id;
	    this.useOrdinal = useOrdinal;
	    this.offset     = offset;
	    this.options    = options;
	    this.pluralFn   = pluralFn;
	}
	
	PluralFormat.prototype.getOption = function (value) {
	    var options = this.options;
	
	    var option = options['=' + value] ||
	            options[this.pluralFn(value - this.offset, this.useOrdinal)];
	
	    return option || options.other;
	};
	
	function PluralOffsetString(id, offset, numberFormat, string) {
	    this.id           = id;
	    this.offset       = offset;
	    this.numberFormat = numberFormat;
	    this.string       = string;
	}
	
	PluralOffsetString.prototype.format = function (value) {
	    var number = this.numberFormat.format(value - this.offset);
	
	    return this.string
	            .replace(/(^|[^\\])#/g, '$1' + number)
	            .replace(/\\#/g, '#');
	};
	
	function SelectFormat(id, options) {
	    this.id      = id;
	    this.options = options;
	}
	
	SelectFormat.prototype.getOption = function (value) {
	    var options = this.options;
	    return options[value] || options.other;
	};
	
	//# sourceMappingURL=compiler.js.map

/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(639), src$es5$$ = __webpack_require__(1539), src$compiler$$ = __webpack_require__(1536), intl$messageformat$parser$$ = __webpack_require__(1534);
	exports["default"] = MessageFormat;
	
	// -- MessageFormat --------------------------------------------------------
	
	function MessageFormat(message, locales, formats) {
	    // Parse string messages into an AST.
	    var ast = typeof message === 'string' ?
	            MessageFormat.__parse(message) : message;
	
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new TypeError('A message must be provided as a String or AST.');
	    }
	
	    // Creates a new object with the specified `formats` merged with the default
	    // formats.
	    formats = this._mergeFormats(MessageFormat.formats, formats);
	
	    // Defined first because it's used to build the format pattern.
	    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});
	
	    // Compile the `ast` to a pattern that is highly optimized for repeated
	    // `format()` invocations. **Note:** This passes the `locales` set provided
	    // to the constructor instead of just the resolved locale.
	    var pluralFn = this._findPluralRuleFunction(this._locale);
	    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var messageFormat = this;
	    this.format = function (values) {
	      try {
	        return messageFormat._format(pattern, values);
	      } catch (e) {
	        if (e.variableId) {
	          throw new Error(
	            'The intl string context variable \'' + e.variableId + '\'' +
	            ' was not provided to the string \'' + message + '\''
	          );
	        } else {
	          throw e;
	        }
	      }
	    };
	}
	
	// Default format options used as the prototype of the `formats` provided to the
	// constructor. These are used when constructing the internal Intl.NumberFormat
	// and Intl.DateTimeFormat instances.
	src$es5$$.defineProperty(MessageFormat, 'formats', {
	    enumerable: true,
	
	    value: {
	        number: {
	            'currency': {
	                style: 'currency'
	            },
	
	            'percent': {
	                style: 'percent'
	            }
	        },
	
	        date: {
	            'short': {
	                month: 'numeric',
	                day  : 'numeric',
	                year : '2-digit'
	            },
	
	            'medium': {
	                month: 'short',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'long': {
	                month: 'long',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'full': {
	                weekday: 'long',
	                month  : 'long',
	                day    : 'numeric',
	                year   : 'numeric'
	            }
	        },
	
	        time: {
	            'short': {
	                hour  : 'numeric',
	                minute: 'numeric'
	            },
	
	            'medium':  {
	                hour  : 'numeric',
	                minute: 'numeric',
	                second: 'numeric'
	            },
	
	            'long': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            },
	
	            'full': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            }
	        }
	    }
	});
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlMessageFormat is missing a ' +
	            '`locale` property'
	        );
	    }
	
	    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
	}});
	
	// Defines `__parse()` static method as an exposed private.
	src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});
	
	// Define public `defaultLocale` property which defaults to English, but can be
	// set by the developer.
	src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	MessageFormat.prototype.resolvedOptions = function () {
	    // TODO: Provide anything else?
	    return {
	        locale: this._locale
	    };
	};
	
	MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
	    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
	    return compiler.compile(ast);
	};
	
	MessageFormat.prototype._findPluralRuleFunction = function (locale) {
	    var localeData = MessageFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find a `pluralRuleFunction` to return.
	    while (data) {
	        if (data.pluralRuleFunction) {
	            return data.pluralRuleFunction;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlMessageFormat is missing a ' +
	        '`pluralRuleFunction` for :' + locale
	    );
	};
	
	MessageFormat.prototype._format = function (pattern, values) {
	    var result = '',
	        i, len, part, id, value, err;
	
	    for (i = 0, len = pattern.length; i < len; i += 1) {
	        part = pattern[i];
	
	        // Exist early for string parts.
	        if (typeof part === 'string') {
	            result += part;
	            continue;
	        }
	
	        id = part.id;
	
	        // Enforce that all required values are provided by the caller.
	        if (!(values && src$utils$$.hop.call(values, id))) {
	          err = new Error('A value must be provided for: ' + id);
	          err.variableId = id;
	          throw err;
	        }
	
	        value = values[id];
	
	        // Recursively format plural and select parts' option — which can be a
	        // nested pattern structure. The choosing of the option to use is
	        // abstracted-by and delegated-to the part helper object.
	        if (part.options) {
	            result += this._format(part.getOption(value), values);
	        } else {
	            result += part.format(value);
	        }
	    }
	
	    return result;
	};
	
	MessageFormat.prototype._mergeFormats = function (defaults, formats) {
	    var mergedFormats = {},
	        type, mergedType;
	
	    for (type in defaults) {
	        if (!src$utils$$.hop.call(defaults, type)) { continue; }
	
	        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);
	
	        if (formats && src$utils$$.hop.call(formats, type)) {
	            src$utils$$.extend(mergedType, formats[type]);
	        }
	    }
	
	    return mergedFormats;
	};
	
	MessageFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(MessageFormat.defaultLocale);
	
	    var localeData = MessageFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlMessageFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	//# sourceMappingURL=core.js.map

/***/ },
/* 1538 */
/***/ function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};
	
	//# sourceMappingURL=en.js.map

/***/ },
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(639);
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (src$utils$$.hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	/* jslint esnext: true */
	
	"use strict";
	var src$core$$ = __webpack_require__(1537), src$en$$ = __webpack_require__(1538);
	
	src$core$$["default"].__addLocaleData(src$en$$["default"]);
	src$core$$["default"].defaultLocale = 'en';
	
	exports["default"] = src$core$$["default"];
	
	//# sourceMappingURL=main.js.map

/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlRelativeFormat = __webpack_require__(1546)['default'];
	
	// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(2072);
	
	// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlRelativeFormat;
	exports['default'] = exports;


/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	/* jslint esnext: true */
	var intl_messageformat_1 = __webpack_require__(638);
	var diff_1 = __webpack_require__(1543);
	var es5_1 = __webpack_require__(1545);
	exports.default = RelativeFormat;
	// -----------------------------------------------------------------------------
	var FIELDS = [
	    'second', 'second-short',
	    'minute', 'minute-short',
	    'hour', 'hour-short',
	    'day', 'day-short',
	    'month', 'month-short',
	    'year', 'year-short'
	];
	var STYLES = ['best fit', 'numeric'];
	// -- RelativeFormat -----------------------------------------------------------
	function RelativeFormat(locales, options) {
	    options = options || {};
	    // Make a copy of `locales` if it's an array, so that it doesn't change
	    // since it's used lazily.
	    if (es5_1.isArray(locales)) {
	        locales = locales.concat();
	    }
	    es5_1.defineProperty(this, '_locale', { value: this._resolveLocale(locales) });
	    es5_1.defineProperty(this, '_options', { value: {
	            style: this._resolveStyle(options.style),
	            units: this._isValidUnits(options.units) && options.units
	        } });
	    es5_1.defineProperty(this, '_locales', { value: locales });
	    es5_1.defineProperty(this, '_fields', { value: this._findFields(this._locale) });
	    es5_1.defineProperty(this, '_messages', { value: es5_1.objCreate(null) });
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var relativeFormat = this;
	    this.format = function format(date, options) {
	        return relativeFormat._format(date, options);
	    };
	}
	// Define internal private properties for dealing with locale data.
	es5_1.defineProperty(RelativeFormat, '__localeData__', { value: es5_1.objCreate(null) });
	es5_1.defineProperty(RelativeFormat, '__addLocaleData', { value: function () {
	        for (var i = 0; i < arguments.length; i++) {
	            var datum = arguments[i];
	            if (!(datum && datum.locale)) {
	                throw new Error('Locale data provided to IntlRelativeFormat is missing a ' +
	                    '`locale` property value');
	            }
	            RelativeFormat.__localeData__[datum.locale.toLowerCase()] = datum;
	            // Add data to IntlMessageFormat.
	            intl_messageformat_1.default.__addLocaleData(datum);
	        }
	    } });
	// Define public `defaultLocale` property which can be set by the developer, or
	// it will be set when the first RelativeFormat instance is created by
	// leveraging the resolved locale from `Intl`.
	es5_1.defineProperty(RelativeFormat, 'defaultLocale', {
	    enumerable: true,
	    writable: true,
	    value: undefined
	});
	// Define public `thresholds` property which can be set by the developer, and
	// defaults to relative time thresholds from moment.js.
	es5_1.defineProperty(RelativeFormat, 'thresholds', {
	    enumerable: true,
	    value: {
	        second: 45, 'second-short': 45,
	        minute: 45, 'minute-short': 45,
	        hour: 22, 'hour-short': 22,
	        day: 26, 'day-short': 26,
	        month: 11, 'month-short': 11 // months to year
	    }
	});
	RelativeFormat.prototype.resolvedOptions = function () {
	    return {
	        locale: this._locale,
	        style: this._options.style,
	        units: this._options.units
	    };
	};
	RelativeFormat.prototype._compileMessage = function (units) {
	    // `this._locales` is the original set of locales the user specified to the
	    // constructor, while `this._locale` is the resolved root locale.
	    var locales = this._locales;
	    var resolvedLocale = this._locale;
	    var field = this._fields[units];
	    var relativeTime = field.relativeTime;
	    var future = '';
	    var past = '';
	    var i;
	    for (i in relativeTime.future) {
	        if (relativeTime.future.hasOwnProperty(i)) {
	            future += ' ' + i + ' {' +
	                relativeTime.future[i].replace('{0}', '#') + '}';
	        }
	    }
	    for (i in relativeTime.past) {
	        if (relativeTime.past.hasOwnProperty(i)) {
	            past += ' ' + i + ' {' +
	                relativeTime.past[i].replace('{0}', '#') + '}';
	        }
	    }
	    var message = '{when, select, future {{0, plural, ' + future + '}}' +
	        'past {{0, plural, ' + past + '}}}';
	    // Create the synthetic IntlMessageFormat instance using the original
	    // locales value specified by the user when constructing the the parent
	    // IntlRelativeFormat instance.
	    return new intl_messageformat_1.default(message, locales);
	};
	RelativeFormat.prototype._getMessage = function (units) {
	    var messages = this._messages;
	    // Create a new synthetic message based on the locale data from CLDR.
	    if (!messages[units]) {
	        messages[units] = this._compileMessage(units);
	    }
	    return messages[units];
	};
	RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
	    var field = this._fields[units];
	    if (field.relative) {
	        return field.relative[diff];
	    }
	};
	RelativeFormat.prototype._findFields = function (locale) {
	    var localeData = RelativeFormat.__localeData__;
	    var data = localeData[locale.toLowerCase()];
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find `fields` to return.
	    while (data) {
	        if (data.fields) {
	            return data.fields;
	        }
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	    throw new Error('Locale data added to IntlRelativeFormat is missing `fields` for :' +
	        locale);
	};
	RelativeFormat.prototype._format = function (date, options) {
	    var now = options && options.now !== undefined ? options.now : es5_1.dateNow();
	    if (date === undefined) {
	        date = now;
	    }
	    // Determine if the `date` and optional `now` values are valid, and throw a
	    // similar error to what `Intl.DateTimeFormat#format()` would throw.
	    if (!isFinite(now)) {
	        throw new RangeError('The `now` option provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.');
	    }
	    if (!isFinite(date)) {
	        throw new RangeError('The date value provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.');
	    }
	    var diffReport = diff_1.default(now, date);
	    var units = this._options.units || this._selectUnits(diffReport);
	    var diffInUnits = diffReport[units];
	    if (this._options.style !== 'numeric') {
	        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
	        if (relativeUnits) {
	            return relativeUnits;
	        }
	    }
	    return this._getMessage(units).format({
	        '0': Math.abs(diffInUnits),
	        when: diffInUnits < 0 ? 'past' : 'future'
	    });
	};
	RelativeFormat.prototype._isValidUnits = function (units) {
	    if (!units || es5_1.arrIndexOf.call(FIELDS, units) >= 0) {
	        return true;
	    }
	    if (typeof units === 'string') {
	        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
	        if (suggestion && es5_1.arrIndexOf.call(FIELDS, suggestion) >= 0) {
	            throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` ' +
	                'value, did you mean: ' + suggestion);
	        }
	    }
	    throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
	        'must be one of: "' + FIELDS.join('", "') + '"');
	};
	RelativeFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(RelativeFormat.defaultLocale);
	    var localeData = RelativeFormat.__localeData__;
	    var i, len, localeParts, data;
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	            localeParts.pop();
	        }
	    }
	    var defaultLocale = locales.pop();
	    throw new Error('No locale data has been added to IntlRelativeFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale);
	};
	RelativeFormat.prototype._resolveStyle = function (style) {
	    // Default to "best fit" style.
	    if (!style) {
	        return STYLES[0];
	    }
	    if (es5_1.arrIndexOf.call(STYLES, style) >= 0) {
	        return style;
	    }
	    throw new Error('"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
	        'must be one of: "' + STYLES.join('", "') + '"');
	};
	RelativeFormat.prototype._selectUnits = function (diffReport) {
	    var i, l, units;
	    var fields = FIELDS.filter(function (field) {
	        return field.indexOf('-short') < 1;
	    });
	    for (i = 0, l = fields.length; i < l; i += 1) {
	        units = fields[i];
	        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
	            break;
	        }
	    }
	    return units;
	};
	//# sourceMappingURL=core.js.map

/***/ },
/* 1543 */
/***/ function(module, exports) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	/* jslint esnext: true */
	var round = Math.round;
	function daysToYears(days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    return days * 400 / 146097;
	}
	// Thanks to date-fns
	// https://github.com/date-fns/date-fns
	// MIT © Sasha Koss
	var MILLISECONDS_IN_MINUTE = 60000;
	var MILLISECONDS_IN_DAY = 86400000;
	function startOfDay(dirtyDate) {
	    var date = new Date(dirtyDate);
	    date.setHours(0, 0, 0, 0);
	    return date;
	}
	function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
	    var startOfDayLeft = startOfDay(dirtyDateLeft);
	    var startOfDayRight = startOfDay(dirtyDateRight);
	    var timestampLeft = startOfDayLeft.getTime() -
	        startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
	    var timestampRight = startOfDayRight.getTime() -
	        startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
	    // Round the number of days to the nearest integer
	    // because the number of milliseconds in a day is not constant
	    // (e.g. it's different in the day of the daylight saving time clock shift)
	    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
	}
	function default_1(from, to) {
	    // Convert to ms timestamps.
	    from = +from;
	    to = +to;
	    var millisecond = round(to - from), second = round(millisecond / 1000), minute = round(second / 60), hour = round(minute / 60);
	    // We expect a more precision in rounding when dealing with
	    // days as it feels wrong when something happended 13 hours ago and
	    // is regarded as "yesterday" even if the time was this morning.
	    var day = differenceInCalendarDays(to, from);
	    var week = round(day / 7);
	    var rawYears = daysToYears(day), month = round(rawYears * 12), year = round(rawYears);
	    return {
	        millisecond: millisecond,
	        second: second,
	        'second-short': second,
	        minute: minute,
	        'minute-short': minute,
	        hour: hour,
	        'hour-short': hour,
	        day: day,
	        'day-short': day,
	        week: week,
	        'week-short': week,
	        month: month,
	        'month-short': month,
	        year: year,
	        'year-short': year
	    };
	}
	exports.default = default_1;
	//# sourceMappingURL=diff.js.map

/***/ },
/* 1544 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* @generated */
	exports.default = { "locale": "en", "pluralRuleFunction": function (n, ord) {
	        var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
	        if (ord)
	            return (n10 == 1 && n100 != 11) ? 'one'
	                : (n10 == 2 && n100 != 12) ? 'two'
	                    : (n10 == 3 && n100 != 13) ? 'few'
	                        : 'other';
	        return (n == 1 && v0) ? 'one' : 'other';
	    }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "week": { "displayName": "week", "relativePeriod": "the week of {0}", "relative": { "0": "this week", "1": "next week", "-1": "last week" }, "relativeTime": { "future": { "one": "in {0} week", "other": "in {0} weeks" }, "past": { "one": "{0} week ago", "other": "{0} weeks ago" } } }, "week-short": { "displayName": "wk.", "relativePeriod": "the week of {0}", "relative": { "0": "this wk.", "1": "next wk.", "-1": "last wk." }, "relativeTime": { "future": { "one": "in {0} wk.", "other": "in {0} wk." }, "past": { "one": "{0} wk. ago", "other": "{0} wk. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
	//# sourceMappingURL=en.js.map

/***/ },
/* 1545 */
/***/ function(module, exports) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	/* jslint esnext: true */
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	var hop = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	var realDefineProp = (function () {
	    try {
	        return !!Object.defineProperty({}, 'a', {});
	    }
	    catch (e) {
	        return false;
	    }
	})();
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	var defineProperty = realDefineProp ? Object.defineProperty :
	    function (obj, name, desc) {
	        if ('get' in desc && obj.__defineGetter__) {
	            obj.__defineGetter__(name, desc.get);
	        }
	        else if (!hop.call(obj, name) || 'value' in desc) {
	            obj[name] = desc.value;
	        }
	    };
	exports.defineProperty = defineProperty;
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	    function F() { }
	    F.prototype = proto;
	    obj = new F();
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	    return obj;
	};
	exports.objCreate = objCreate;
	var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
	    /*jshint validthis:true */
	    var arr = this;
	    if (!arr.length) {
	        return -1;
	    }
	    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
	        if (arr[i] === search) {
	            return i;
	        }
	    }
	    return -1;
	};
	exports.arrIndexOf = arrIndexOf;
	var isArray = Array.isArray || function (obj) {
	    return toString.call(obj) === '[object Array]';
	};
	exports.isArray = isArray;
	var dateNow = Date.now || function () {
	    return new Date().getTime();
	};
	exports.dateNow = dateNow;
	//# sourceMappingURL=es5.js.map

/***/ },
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/* jslint esnext: true */
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1542);
	var en_1 = __webpack_require__(1544);
	core_1.default.__addLocaleData(en_1.default);
	core_1.default.defaultLocale = 'en';
	exports.default = core_1.default;
	//# sourceMappingURL=main.js.map

/***/ },
/* 1547 */
/***/ function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBound = __webpack_require__(84);
	
	var getDay = callBound('Date.prototype.getDay');
	/** @type {import('.')} */
	var tryDateObject = function tryDateGetDayCall(value) {
		try {
			getDay(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	/** @type {(value: unknown) => string} */
	var toStr = callBound('Object.prototype.toString');
	var dateClass = '[object Date]';
	var hasToStringTag = __webpack_require__(634)();
	
	/** @type {import('.')} */
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) {
			return false;
		}
		return hasToStringTag ? tryDateObject(value) : toStr(value) === dateClass;
	};


/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBound = __webpack_require__(84);
	var hasToStringTag = __webpack_require__(634)();
	var hasOwn = __webpack_require__(141);
	var gOPD = __webpack_require__(140);
	
	/** @type {import('.')} */
	var fn;
	
	if (hasToStringTag) {
		/** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */
		var $exec = callBound('RegExp.prototype.exec');
		/** @type {object} */
		var isRegexMarker = {};
	
		var throwRegexMarker = function () {
			throw isRegexMarker;
		};
		/** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */
		var badStringifier = {
			toString: throwRegexMarker,
			valueOf: throwRegexMarker
		};
	
		if (typeof Symbol.toPrimitive === 'symbol') {
			badStringifier[Symbol.toPrimitive] = throwRegexMarker;
		}
	
		/** @type {import('.')} */
		// @ts-expect-error TS can't figure out that the $exec call always throws
		// eslint-disable-next-line consistent-return
		fn = function isRegex(value) {
			if (!value || typeof value !== 'object') {
				return false;
			}
	
			// eslint-disable-next-line no-extra-parens
			var descriptor = /** @type {NonNullable<typeof gOPD>} */ (gOPD)(/** @type {{ lastIndex?: unknown }} */ (value), 'lastIndex');
			var hasLastIndexDataProperty = descriptor && hasOwn(descriptor, 'value');
			if (!hasLastIndexDataProperty) {
				return false;
			}
	
			try {
				// eslint-disable-next-line no-extra-parens
				$exec(value, /** @type {string} */ (/** @type {unknown} */ (badStringifier)));
			} catch (e) {
				return e === isRegexMarker;
			}
		};
	} else {
		/** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */
		var $toString = callBound('Object.prototype.toString');
		/** @const @type {'[object RegExp]'} */
		var regexClass = '[object RegExp]';
	
		/** @type {import('.')} */
		fn = function isRegex(value) {
			// In older browsers, typeof regex incorrectly returns 'function'
			if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
				return false;
			}
	
			return $toString(value) === regexClass;
		};
	}
	
	module.exports = fn;


/***/ },
/* 1550 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 1551 */
/***/ function(module, exports) {

	module.exports = {
		"app.intro": "<h3>Llená el formulario y enterate si aprobás, préstamos desde el celu!</h3>",
		"app.footer-info": "<p>Información financiera: Préstamos personales en pesos de libre disponibilidad. Los montos, plazo, tasas y demás condiciones del préstamo dependen de la calificación crediticia del solicitante. Los montos van desde los $1.000 a los $100.000. Los plazos varían entre los 12 meses y los 36 meses.</p><p>COSTO FINANCIERO TOTAL (ANUAL) (CFT) Mínimo 53,60 %, Máximo: 200,14%. Las presentes condiciones son a modo informativo, no constituyen una oferta y pueden ser modificadas en cualquier momento sin previo aviso.</p>",
		"app.footer-sign": "<p>Copyright © 2017 - demo.creditos.com.ar. Todos los derechos reservados. SUMMIT S.A. Domicilio: Montevideo 251, piso 2, Mendoza Ciudad (C.P. 5500), Mendoza, Argentina.</p><p>Defensa al consumidor: 0800-666-1518 - Línea de Atención Gratuita de lunes a viernes de 8 a 20 hs. - <a className=\"footer-link\" href=\"mailto:consultas@consumidor.gob.ar\">consultas@consumidor.gob.ar</a> - <a className=\"footer-link\" href=\"https://www.argentina.gob.ar/produccion/consumidor\">https://www.argentina.gob.ar/produccion/consumidor</a></p>",
		"app.min_specs": "<p><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Ser mayor de 18 años</p><p><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Poseer una cuenta bancaria a tu nombre</p><p><i class=\"fa fa-check\" aria-hidden=\"true\"></i> CBU de esa cuenta, para depositar el préstamo y debitar la cuota</p><p><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Tener una cuenta de correo electrónico</p><p><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Tener un teléfono celular</p>",
		"app.how_it_works": "<div class=\"how_it_works__row row\"><div class=\"col-lg-3 col-md-3 col-sm-6\"><div class=\"how_it_works__block\"><div class=\"how_it_works__block__icon\"><img src=\"{step_1_url}\" alt=\"\" class=\"how_it_works__block__icon__img\"></div><div class=\"how_it_works__epigraph\"><div class=\"how_it_works__epigraph__title\"><h4>Paso 1</h4></div><div class=\"how_it_works__epigraph__description\"><p>Ingresás tus datos personales</p></div></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-6\"><div class=\"how_it_works__block\"><div class=\"how_it_works__block__icon\"><img src=\"{step_2_url}\" alt=\"\" class=\"how_it_works__block__icon__img\"></div><div class=\"how_it_works__epigraph\"><div class=\"how_it_works__epigraph__title\"><h4>Paso 2</h4></div><div class=\"how_it_works__epigraph__description\"><p>Elegís el monto y las cuotas</p></div></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-6\"><div class=\"how_it_works__block\"><div class=\"how_it_works__block__icon\"><img src=\"{step_3_url}\" alt=\"\" class=\"how_it_works__block__icon__img\"><div class=\"how_it_works__epigraph__title\"><h4>Paso 3</h4></div><div class=\"how_it_works__epigraph__description\"><p>Verificamos tus datos por teléfono</p></div></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-6\"><div class=\"how_it_works__block\"><div class=\"how_it_works__block__icon\"><img src=\"{step_4_url}\" alt=\"\" class=\"how_it_works__block__icon__img\"></div><div class=\"how_it_works__epigraph\"><div class=\"how_it_works__epigraph__title\"><h4>Paso 4</h4></div><div class=\"how_it_works__epigraph__description\"><p>Recibís el dinero en tu cuenta bancaria</p></div></div></div></div></div>",
		"app.faq1": "<h4>¿Completar el formulario genera algún compromiso?</h4><p>No, la decisión final siempre está en tus manos y contás con ella hasta el último paso.</p><h4>¿Tengo que ir personalmente a algún lado?</h4><p>No, la gestión del préstamo se puede realizar completamente desde tu celu.</p><h4><img class=\"blue-tick\" src=\"/img/tick-azul.png\"/>¿Cómo se realiza el pago de la cuota del préstamo?</h4><p>El pago de la cuota es por débito automático del 1 al 10 de cada mes, desde la cuenta donde se depositó el préstamo y en la misma tiene que haber fondos.</p>",
		"app.faq2": "<h4>¿Tengo que tener una cuenta bancaria a mi nombre?</h4><p>Sí, es indispensable contar con una cuenta bancaria a tu nombre donde se depositará el dinero.</p><h4>¿Tengo que firmar algún papel?</h4><p>No, todo el proceso es en línea y telefónicamente.</p><h4>¿Cuánto tiempo tarda en acreditarse el préstamo en mi cuenta?</h4><p>El préstamo estará disponible en no más de 24 hs hábiles desde la verificación telefónica de indentidad.</p>",
		"app.step_sms": "<h3>Hemos enviado un SMS a tu celular, por favor ingresá ese código para continuar</h3><p>(el sms puede demorar unos segundos)</p>",
		"app.whatsapp_timetable": "<p class=\"pd-opening-hours\">Lunes a Viernes 09 - 17hs </p>",
		"app.phone_timetable": " ",
		"app.renaper_step": "A continuación efectuaremos una validación de tu identidad a través del Registro Nacional de las Personas (RENAPER)",
		"app.renaper_step_form": "Este botón te llevará a la página del RENAPER, una vez que hayamos validado tu idendidad podrás seguir con tu solicitud en nuestra web.",
		"app.step_cbu": "<h3>Último paso!</h3><p>Por favor ingresá el CBU de una cuenta sueldo a tu nombre (para depositar el préstamo y debitar la cuota)</p>",
		"app.step_address": "<h3>Ya casi terminás!</h3><p>Por favor confirmanos tu dirección e ingresos mensuales</p>",
		"app.step_incomes": "<p>Por favor ingresá la información de tu último recibo de sueldo o documentación de ingresos más reciente.</p>",
		"app.step_personal_info": "<p>Por favor ingresá tu información personal y los servicios que tenés disponible en tu domicilio.</p>",
		"app.step_service_info": "<p>Por favor ingresá tu información personal y los servicios que tenés disponible en tu domicilio.</p>",
		"app.step_job_info": "<p>Por favor ingresá la información de tus datos laborales.</p>",
		"app.step_email": "<p>Para continuar con tu solicitud por favor ingresá tu correo electrónico.</p>",
		"app.step_upload_info": "<p>Para continuar por favor subí una foto de tu DNI del frente / dorso, 2 servicios y tus últimos 3 bonos de sueldo.</p>",
		"app.step_product": "<h3><b>Felicitaciones</b> estás <b>Pre-APROBADO!</b></h3><p>Para continuar, elegí el monto y las cuotas a solicitar:</p>",
		"app.step_product_description": "",
		"app.step_product_label_quota": "cuota",
		"app.step_upload": "<p>Para continuar por favor subí una foto de tu DNI del frente / dorso, 2 servicios y tus últimos 3 bonos de sueldo.</p>",
		"app.step_affidavit": "<h4>Declaraciones Juradas</h4><p>Para cumplir con las regulaciones del Banco Central y de la UIF necesitamos saber lo siguiente:</p>",
		"app.step_checkout": "<h3><b>Gracias por tu tiempo!</b></h3><h4>Resumen de tu Solicitud:</h4>",
		"app.contract_advice": "<p>Por favor, abrir, leer y acordar con Demo-creditos.com.ar</p>",
		"app.step_checkout_info": "El pago se realiza via Débito Automático desde la cuenta donde se depositó el préstamo.",
		"app.step_email_verification": "<h3><b>Para finalizar con tu préstamo hace clic en el enlace que te enviamos a tu correo electrónico</b></h3>",
		"app.disapproved": "<h3><b>Por el momento no tenemos una oferta de crédito que se ajuste a su perfil.</b></h3>"
	};

/***/ },
/* 1552 */
/***/ function(module, exports) {

	module.exports = {
		"app.intro": "<h3 class=\"custom-orange-font \" ><b>Obtené tu préstamo 100% online</b></h3>",
		"app.intro_start": "<p><b>Comenzá ingresando tus datos personales</b></p>",
		"app.footer-info": "<div><p><strong>Información financiera:</strong></p><p>Préstamos personales en pesos de libre disponibilidad. Los montos, plazos y demás condiciones del préstamo dependen de la calificación crediticia del solicitante y las normas propias de Montemar Compañía Financiera S.A. Los montos van mínimo $1.000 y máximos $ 5.000.000. Los plazos varían entre 270 días hasta 1080 días (9 y 36 cuotas). La tasa de interés es Fija.</p><p><span class=\"footer-rates-info\">CFTEA Sin IVA Mínimo 12,87% y Máximo 575,45% - CFTEA Con IVA Mínimo 15,76% y Máximo 873,67%.</span></p><p>Ejemplo: Para un préstamos de $400.000.- en 180 días (6 cuotas) con una TNA del 152,21%, TEA del 319,59%, el cliente devolverá $622.452.</p><p><span class=\"footer-rates-info\">CFTEA con IVA 455,63% – CFTEA sin IVA 319,59%</span></p><p>CFT (Costo Financiero Total) – CFTEA (Costo Financiero Total Efectivo Anual) – TNA (Tasa Nominal Anual) – TEA (Tasa Efectiva Anual) – IVA (Impuesto al Valor Agregado)</p><p><a class=\"site-contracts\" target=\"_blank\" href=\"https://www.montemar.com.ar/wp-content/uploads/2020/02/comisionesycargos.pdf\">Consultá el listado completo de comisiones y cargos</a><p><strong>Solicitá tu Préstamo por teléfono llamando al <a class=\"site-contracts\" href=\"tel:08108109988\">0810-810-9988</a></strong></p></div><p><a class=\"site-contracts\" href=\"http://www.bcra.gov.ar/BCRAyVos/Regimen_de_transparencia.asp\" target=\"_blank\" rel=\"noopener\" data-saferedirecturl=\"https://www.google.com/url?q=http://www.bcra.gov.ar/BCRAyVos/Regimen_de_transparencia.asp&amp;source=gmail&amp;ust=1547657448464000&amp;usg=AFQjCNFYEECFrshLd8sTjVXmKvYVXWHWMQ\">Usted puede consultar el “Régimen de Transparencia” elaborado por el Banco Central de la República Argentina sobre la base de información proporcionada por los sujetos obligados</a></p><p><a class=\"site-contracts\" href=\"http://www.bcra.gov.ar/BCRAyVos/Comparacion_de_Comisiones.asp\" target=\"_blank\" data-saferedirecturl=\"https://www.google.com/url?q=http://www.bcra.gov.ar/BCRAyVos/Comparacion_de_Comisiones.asp&amp;source=gmail&amp;ust=1547657448464000&amp;usg=AFQjCNGJ7RxLjB_JQ92s8XLjGaHjrnrAjA\">Comparación de Comisiones</a></p><p><a class=\"site-contracts\" href=\"http://www.usuariosfinancieros.gob.ar/\" target=\"_blank\" data-saferedirecturl=\"https://www.google.com/url?q=http://www.usuariosfinancieros.gob.ar/&amp;source=gmail&amp;ust=1547657448464000&amp;usg=AFQjCNF1g-kWmsPlxnDN8Fo4ZCwIydvLdA\"><span>Señor Usuario Financiero, usted podrá contactarse con el BCRA mediante www.usuariosfinancieros.gob.ar</span></a></p><p><img class=\"bcra-img\" border=\"0\"   id=\"m_1279288845216596003m_7642749289141926230Imagen_x0020_2\" src=\"/img/bcra.png\" alt=\"Descripción: Usuarios Financieros\" data-image-whitelisted=\"\" class=\"CToWUd\"></p><p><span style=\"font-size: 12px;\">Av. San Martín 1152 – (5500) Ciudad de Mendoza – Mendoza.</span></p>",
		"app.footer-sign": "<div class=\"prefooter\"><div class=\"row\"><div class=\"columns medium-8\" style=\"height: 125px;\"><span><a class=\"site-contracts\" href=\"https://www.montemar.com.ar/quienes-somos-2/\" target=\"_blank\" data-saferedirecturl=\"https://www.google.com/url?q=https://www.montemar.com.ar/quienes-somos-2/&amp;source=gmail&amp;ust=1547657448464000&amp;usg=AFQjCNHh4yuTKtL-8sj9a0Ub6RfvamZmqA\"><span>Quiénes Somos</span></a> <a class=\"site-contracts\" href=\"https://www.montemar.com.ar/responsabilidad-social/\" target=\"_blank\" data-saferedirecturl=\"https://www.google.com/url?q=https://www.montemar.com.ar/responsabilidad-social/&amp;source=gmail&amp;ust=1547657448464000&amp;usg=AFQjCNHDU2MZFUb64U8fLMVx7xh5LQU-pg\"><span>Responsabilidad Social Empresaria</span></a> <a class=\"site-contracts\" href=\"https://www.montemar.com.ar/normas-legales/\" target=\"_blank\" data-saferedirecturl=\"https://www.google.com/url?q=https://www.montemar.com.ar/normas-legales/&amp;source=gmail&amp;ust=1547657448464000&amp;usg=AFQjCNEI3elK3VeHo6XWkcrV-Az_ZA6FOw\"><span>Normas Legales</span></a> <a class=\"site-contracts\" href=\"http://www.montemar.com.ar/wp-content/uploads/2015/11/codigo-de-practicas-bancarias-v54.pdf\" target=\"_blank\" data-saferedirecturl=\"https://www.google.com/url?q=http://www.montemar.com.ar/wp-content/uploads/2015/11/codigo-de-practicas-bancarias-v54.pdf&amp;source=gmail&amp;ust=1547657448464000&amp;usg=AFQjCNFDItIxd0Yd6domFbcYndqLByI3vg\"><span>Prácticas Bancarias</span></a>&nbsp;<a class=\"site-contracts\" href=\"https://www.montemar.com.ar/disciplina-de-mercado/\" target=\"_blank\" data-saferedirecturl=\"https://www.google.com/url?q=https://www.montemar.com.ar/disciplina-de-mercado/&amp;source=gmail&amp;ust=1547657448464000&amp;usg=AFQjCNFZ9UgcBe6fn5Jmx5p8ciCciinQKw\"><span>Disciplina de Mercado</span></a>&nbsp;<a class=\"site-contracts\" href=\"https://www.montemar.com.ar/proteccion-de-datos-personales/\" target=\"_blank\" data-saferedirecturl=\"https://www.google.com/url?q=https://www.montemar.com.ar/proteccion-de-datos-personales/&amp;source=gmail&amp;ust=1547657448464000&amp;usg=AFQjCNH1QS8NK368EpN8Q4o4G7BVvhMOLA\"><span>Protección de Datos Personales</span></a><u></u><u></u></span></div></div></div>",
		"app.min_specs": "<p><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Ser mayor de 18 años</p><p><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Poseer una Caja de Ahorro Sueldo</p><p><i class=\"fa fa-check\" aria-hidden=\"true\"></i> CBU de esa cuenta, para depositar el préstamo</p><p><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Tener una cuenta de correo electrónico y un celular</p>",
		"app.how_it_works": "<div class=\"how_it_works__row row\"><div class=\"col-lg-4 col-md-4 col-sm-12\"><div class=\"how_it_works__block\"><div class=\"how_it_works__block__icon\"><img src=\"{step_1_url}\" alt=\"\" class=\"how_it_works__block__icon__img\"></div><div class=\"how_it_works__epigraph\"><div class=\"how_it_works__epigraph__title\"><h4>Paso 1</h4></div><div class=\"how_it_works__epigraph__description\"><p>Ingresás tus datos personales</p></div></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-12\"><div class=\"how_it_works__block\"><div class=\"how_it_works__block__icon\"><img src=\"{step_2_url}\" alt=\"\" class=\"how_it_works__block__icon__img\"></div><div class=\"how_it_works__epigraph\"><div class=\"how_it_works__epigraph__title\"><h4>Paso 2</h4></div><div class=\"how_it_works__epigraph__description\"><p>Elegís el monto y las cuotas</p></div></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-12\"><div class=\"how_it_works__block\"><div class=\"how_it_works__block__icon\"><img src=\"{step_4_url}\" alt=\"\" class=\"how_it_works__block__icon__img\"><div class=\"how_it_works__epigraph__title\"><h4>Paso 3</h4></div><div class=\"how_it_works__epigraph__description\"><p>Recibís el dinero en tu cuenta bancaria</p></div></div></div></div>",
		"app.faq1": "<h4><img class=\"blue-tick\" src=\"/img/tick-azul.png\"/>¿Completar el formulario genera algún compromiso?</h4><p>No, la decisión final siempre está en tus manos y contás con ella hasta el último paso.</p><h4><img class=\"blue-tick\" src=\"/img/tick-azul.png\"/>¿Tengo que contestar todas las preguntas?</h4><p>Si, así tu préstamo será mas económico.</p><h4><img class=\"blue-tick\" src=\"/img/tick-azul.png\"/>¿Cómo se realiza el pago de la cuota del préstamo?</h4><p>El pago de la cuota es por débito automático del 1 al 10 de cada mes, desde la cuenta donde se depositó el préstamo y en la misma tiene que haber fondos.</p>",
		"app.faq2": "<h4><img class=\"blue-tick\" src=\"/img/tick-azul.png\"/>¿Tengo que tener una cuenta bancaria a mi nombre?</h4><p>Sí, es indispensable contar con una cuenta bancaria a tu nombre donde se depositará el dinero.</p><h4><img class=\"blue-tick\" src=\"/img/tick-azul.png\"/>¿Tengo que firmar algún documento, dónde?</h4><p>Si aceptas la propuesta, podés asistir a una sucursal o te visitamos donde nos indiques.</p><h4><img class=\"blue-tick\" src=\"/img/tick-azul.png\"/>¿Cuánto tiempo tarda en acreditarse el préstamo en mi cuenta?</h4><p>De forma inmediata si asistís a sucursal o 48 horas hábiles si preferís que visitemos tu domicilio.</p>",
		"app.step_sms": "<h3>Validemos tu celular</p>",
		"app.step_sms_info": "<p><span class=\"custom-orange-font \">{nameClient}</span>, ingresá el código que hemos enviado por SMS a tu celular </p>",
		"app.whatsapp_timetable": "<p>(solo whatsapp)</p>",
		"app.phone_timetable": "<p>(solo llamadas)</p>",
		"app.renaper_step": "A continuación efectuaremos una validación de tu identidad a través del Registro Nacional de las Personas (RENAPER)",
		"app.renaper_step_form": "Este botón te llevará a la página del RENAPER, una vez que hayamos validado tu idendidad podrás seguir con tu solicitud en nuestra web.",
		"app.step_cbu": "<p><b>Ingresá el CBU de tu cuenta Sueldo para recibir el dinero<b></p>",
		"app.step_address": "<h3>Ingresá tu dirección<h3>",
		"app.step_incomes": "<p>Por favor ingresá la información de tu último recibo de sueldo o documentación de ingresos más reciente.</p>",
		"app.step_personal_info": "<p>Por favor ingresá tu información personal y los servicios que tenés disponible en tu domicilio.</p>",
		"app.step_service_info": "<p>Por favor ingresá tu información personal y los servicios que tenés disponible en tu domicilio.</p>",
		"app.step_job_info": "<h3>Completá tu información laboral</h3>",
		"app.step_email": "<p>Para continuar con tu solicitud por favor ingresá tu correo electrónico.</p>",
		"app.step_upload_info": "<p>Para continuar por favor subí una foto de tu DNI del frente / dorso, 2 servicios y tus últimos 3 bonos de sueldo.</p>",
		"app.step_product": "<h3><b>¡Felicitaciones <span class=\"custom-orange-font \">{nameClient}</span></b>, tu solicitud está <b>APROBADA!</b>",
		"app.step_product_description": "<h3><b>Llevate YA <span class=\"custom-orange-font \">{maxAmount}</span><b></h3>",
		"app.step_upload": "<p>Para continuar por favor subí una foto de tu DNI del frente / dorso, 2 servicios y tus últimos 3 bonos de sueldo.</p>",
		"app.step_upload_documents": "<p>Subí tu documentación ahora para agilizar tu préstamo.</p>",
		"app.step_checkout": "<h3><b><span class=\"custom-orange-font \">{nameClient}</span>, estás a un paso de obtener tu dinero</b></h3>",
		"app.step_affidavit": "<h3><b>Declaraciones Juradas</b></h3><p>Para cumplir con las regulaciones del Banco Central y de la UIF necesitamos saber lo siguiente:</p>",
		"app.contract_advice": "<p>Por favor, abrir, leer y acordar con Montemar.com.ar</p>",
		"app.step_checkout_info": "El pago se realiza via Débito Automático desde la cuenta donde se depositó el préstamo.",
		"app.step_email_verification": "<h3><b>Validación de correo electrónico</b></h3>",
		"app.disapproved": "<h3><b>Por el momento no tenemos una oferta de crédito que se ajuste a su perfil.</b></h3>",
		"app.step_email_pending": "<h3><b>Validación de correo electrónico</b></h3>",
		"app.step_email_pending_info": "<h3><b>Estamos terminando de procesar tu Préstamo Pre-Aprobado. Cuando esté listo, recibirás un enlace en tu correo electrónico para continuar.</b></h3>",
		"app.step_congratulations": "<h3><b>¡Felicitaciones <span class=\"custom-orange-font \">{nameClient}</span>, Tú Préstamo ha sido APROBADO!</b></h3>"
	};

/***/ },
/* 1553 */
/***/ function(module, exports) {

	module.exports = {
		"app.intro": "<h3 class=\"custom-orange-font \" ><b>Obtené tu préstamo 100% online</b></h3>",
		"app.intro_start": "<p><b>Comenzá ingresando tus datos personales</b></p>",
		"app.footer-info": "<div><p><strong>Información financiera:</strong></p><p>Préstamos personales en pesos de libre disponibilidad. Los montos, plazos y demás condiciones del préstamo dependen de la calificación crediticia del solicitante y las normas propias de Montemar Compañía Financiera S.A. Los montos van mínimo $1.000 y máximos $ 2.000.000. Los plazos varían entre 270 días hasta 1080 días (9 y 36 cuotas). La tasa de interés es Fija.</p><p><span class=\"footer-rates-info\">CFTEA Sin IVA Mínimo 102,02% y Máximo 518,11% - CFTEA Con IVA Mínimo 132,99% y Máximo 777,29%.</span></p><p>Ejemplo: Para un préstamos de $5.000.- en 180 días (6 cuotas) con una TNA del 124,71%, TEA del 227,80%, el cliente devolverá $7.686.</p><p><span class=\"footer-rates-info\">CFTEA con IVA 314,74% – CFTEA sin IVA 227,80%</span></p><p>CFT (Costo Financiero Total) – CFTEA (Costo Financiero Total Efectivo Anual) – TNA (Tasa Nominal Anual) – TEA (Tasa Efectiva Anual) – IVA (Impuesto al Valor Agregado)</p><p><a class=\"site-contracts\" target=\"_blank\" href=\"https://www.montemar.com.ar/wp-content/uploads/2020/02/comisionesycargos.pdf\">Consultá el listado completo de comisiones y cargos</a><p><strong>Solicitá tu Préstamo por teléfono llamando al <a class=\"site-contracts\" href=\"tel:08108109988\">0810-810-9988</a></strong></p></div><p><a class=\"site-contracts\" href=\"http://www.bcra.gov.ar/BCRAyVos/Regimen_de_transparencia.asp\" target=\"_blank\" rel=\"noopener\" data-saferedirecturl=\"https://www.google.com/url?q=http://www.bcra.gov.ar/BCRAyVos/Regimen_de_transparencia.asp&amp;source=gmail&amp;ust=1547657448464000&amp;usg=AFQjCNFYEECFrshLd8sTjVXmKvYVXWHWMQ\">Usted puede consultar el “Régimen de Transparencia” elaborado por el Banco Central de la República Argentina sobre la base de información proporcionada por los sujetos obligados</a></p><p><a class=\"site-contracts\" href=\"http://www.bcra.gov.ar/BCRAyVos/Comparacion_de_Comisiones.asp\" target=\"_blank\" data-saferedirecturl=\"https://www.google.com/url?q=http://www.bcra.gov.ar/BCRAyVos/Comparacion_de_Comisiones.asp&amp;source=gmail&amp;ust=1547657448464000&amp;usg=AFQjCNGJ7RxLjB_JQ92s8XLjGaHjrnrAjA\">Comparación de Comisiones</a></p><p><a class=\"site-contracts\" href=\"http://www.usuariosfinancieros.gob.ar/\" target=\"_blank\" data-saferedirecturl=\"https://www.google.com/url?q=http://www.usuariosfinancieros.gob.ar/&amp;source=gmail&amp;ust=1547657448464000&amp;usg=AFQjCNF1g-kWmsPlxnDN8Fo4ZCwIydvLdA\"><span>Señor Usuario Financiero, usted podrá contactarse con el BCRA mediante www.usuariosfinancieros.gob.ar</span></a></p><p><img class=\"bcra-img\" border=\"0\"   id=\"m_1279288845216596003m_7642749289141926230Imagen_x0020_2\" src=\"/img/bcra.png\" alt=\"Descripción: Usuarios Financieros\" data-image-whitelisted=\"\" class=\"CToWUd\"></p><p><span style=\"font-size: 12px;\">Av. San Martín 1152 – (5500) Ciudad de Mendoza – Mendoza.</span></p>",
		"app.footer-sign": "<div class=\"prefooter\"><div class=\"row\"><div class=\"columns medium-8\" style=\"height: 125px;\"><span><a class=\"site-contracts\" href=\"https://www.montemar.com.ar/quienes-somos-2/\" target=\"_blank\" data-saferedirecturl=\"https://www.google.com/url?q=https://www.montemar.com.ar/quienes-somos-2/&amp;source=gmail&amp;ust=1547657448464000&amp;usg=AFQjCNHh4yuTKtL-8sj9a0Ub6RfvamZmqA\"><span>Quiénes Somos</span></a> <a class=\"site-contracts\" href=\"https://www.montemar.com.ar/responsabilidad-social/\" target=\"_blank\" data-saferedirecturl=\"https://www.google.com/url?q=https://www.montemar.com.ar/responsabilidad-social/&amp;source=gmail&amp;ust=1547657448464000&amp;usg=AFQjCNHDU2MZFUb64U8fLMVx7xh5LQU-pg\"><span>Responsabilidad Social Empresaria</span></a> <a class=\"site-contracts\" href=\"https://www.montemar.com.ar/normas-legales/\" target=\"_blank\" data-saferedirecturl=\"https://www.google.com/url?q=https://www.montemar.com.ar/normas-legales/&amp;source=gmail&amp;ust=1547657448464000&amp;usg=AFQjCNEI3elK3VeHo6XWkcrV-Az_ZA6FOw\"><span>Normas Legales</span></a> <a class=\"site-contracts\" href=\"http://www.montemar.com.ar/wp-content/uploads/2015/11/codigo-de-practicas-bancarias-v54.pdf\" target=\"_blank\" data-saferedirecturl=\"https://www.google.com/url?q=http://www.montemar.com.ar/wp-content/uploads/2015/11/codigo-de-practicas-bancarias-v54.pdf&amp;source=gmail&amp;ust=1547657448464000&amp;usg=AFQjCNFDItIxd0Yd6domFbcYndqLByI3vg\"><span>Prácticas Bancarias</span></a>&nbsp;<a class=\"site-contracts\" href=\"https://www.montemar.com.ar/disciplina-de-mercado/\" target=\"_blank\" data-saferedirecturl=\"https://www.google.com/url?q=https://www.montemar.com.ar/disciplina-de-mercado/&amp;source=gmail&amp;ust=1547657448464000&amp;usg=AFQjCNFZ9UgcBe6fn5Jmx5p8ciCciinQKw\"><span>Disciplina de Mercado</span></a>&nbsp;<a class=\"site-contracts\" href=\"https://www.montemar.com.ar/proteccion-de-datos-personales/\" target=\"_blank\" data-saferedirecturl=\"https://www.google.com/url?q=https://www.montemar.com.ar/proteccion-de-datos-personales/&amp;source=gmail&amp;ust=1547657448464000&amp;usg=AFQjCNH1QS8NK368EpN8Q4o4G7BVvhMOLA\"><span>Protección de Datos Personales</span></a><u></u><u></u></span></div></div></div>",
		"app.min_specs": "<p><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Ser mayor de 18 años</p><p><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Poseer una Caja de Ahorro Sueldo</p><p><i class=\"fa fa-check\" aria-hidden=\"true\"></i> CBU de esa cuenta, para depositar el préstamo</p><p><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Tener una cuenta de correo electrónico y un celular</p>",
		"app.how_it_works": "<div class=\"how_it_works__row row\"><div class=\"col-lg-4 col-md-4 col-sm-12\"><div class=\"how_it_works__block\"><div class=\"how_it_works__block__icon\"><img src=\"{step_1_url}\" alt=\"\" class=\"how_it_works__block__icon__img\"></div><div class=\"how_it_works__epigraph\"><div class=\"how_it_works__epigraph__title\"><h4>Paso 1</h4></div><div class=\"how_it_works__epigraph__description\"><p>Ingresás tus datos personales</p></div></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-12\"><div class=\"how_it_works__block\"><div class=\"how_it_works__block__icon\"><img src=\"{step_2_url}\" alt=\"\" class=\"how_it_works__block__icon__img\"></div><div class=\"how_it_works__epigraph\"><div class=\"how_it_works__epigraph__title\"><h4>Paso 2</h4></div><div class=\"how_it_works__epigraph__description\"><p>Elegís el monto y las cuotas</p></div></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-12\"><div class=\"how_it_works__block\"><div class=\"how_it_works__block__icon\"><img src=\"{step_4_url}\" alt=\"\" class=\"how_it_works__block__icon__img\"><div class=\"how_it_works__epigraph__title\"><h4>Paso 3</h4></div><div class=\"how_it_works__epigraph__description\"><p>Recibís el dinero en tu cuenta bancaria</p></div></div></div></div>",
		"app.faq1": "<h4><img class=\"blue-tick\" src=\"/img/tick-azul.png\"/>¿Completar el formulario genera algún compromiso?</h4><p>No, la decisión final siempre está en tus manos y contás con ella hasta el último paso.</p><h4><img class=\"blue-tick\" src=\"/img/tick-azul.png\"/>¿Tengo que contestar todas las preguntas?</h4><p>Si, así tu préstamo será mas económico.</p><h4><img class=\"blue-tick\" src=\"/img/tick-azul.png\"/>¿Cómo se realiza el pago de la cuota del préstamo?</h4><p>El pago de la cuota es por débito automático del 1 al 10 de cada mes, desde la cuenta donde se depositó el préstamo y en la misma tiene que haber fondos.</p>",
		"app.faq2": "<h4><img class=\"blue-tick\" src=\"/img/tick-azul.png\"/>¿Tengo que tener una cuenta bancaria a mi nombre?</h4><p>Sí, es indispensable contar con una cuenta bancaria a tu nombre donde se depositará el dinero.</p><h4><img class=\"blue-tick\" src=\"/img/tick-azul.png\"/>¿Tengo que firmar algún documento, dónde?</h4><p>Si aceptas la propuesta, podés asistir a una sucursal o te visitamos donde nos indiques.</p><h4><img class=\"blue-tick\" src=\"/img/tick-azul.png\"/>¿Cuánto tiempo tarda en acreditarse el préstamo en mi cuenta?</h4><p>De forma inmediata si asistís a sucursal o 48 horas hábiles si preferís que visitemos tu domicilio.</p>",
		"app.step_sms": "<h3>Validemos tu celular</p>",
		"app.step_sms_info": "<p><span class=\"custom-orange-font \">{nameClient}</span>, ingresá el código que hemos enviado por SMS a tu celular </p>",
		"app.whatsapp_timetable": "<p>(solo whatsapp)</p>",
		"app.phone_timetable": "<p>(solo llamadas)</p>",
		"app.renaper_step": "A continuación efectuaremos una validación de tu identidad a través del Registro Nacional de las Personas (RENAPER)",
		"app.renaper_step_form": "Este botón te llevará a la página del RENAPER, una vez que hayamos validado tu idendidad podrás seguir con tu solicitud en nuestra web.",
		"app.step_cbu": "<p><b>Ingresá el CBU de tu cuenta Sueldo para recibir el dinero<b></p>",
		"app.step_address": "<h3>Ingresá tu dirección<h3>",
		"app.step_incomes": "<p>Por favor ingresá la información de tu último recibo de sueldo o documentación de ingresos más reciente.</p>",
		"app.step_personal_info": "<p>Por favor ingresá tu información personal y los servicios que tenés disponible en tu domicilio.</p>",
		"app.step_service_info": "<p>Por favor ingresá tu información personal y los servicios que tenés disponible en tu domicilio.</p>",
		"app.step_job_info": "<h3>Completá tu información laboral</h3>",
		"app.step_email": "<p>Para continuar con tu solicitud por favor ingresá tu correo electrónico.</p>",
		"app.step_upload_info": "<p>Para continuar por favor subí una foto de tu DNI del frente / dorso, 2 servicios y tus últimos 3 bonos de sueldo.</p>",
		"app.step_product": "<h3><b>¡Felicitaciones <span class=\"custom-orange-font \">{nameClient}</span></b>, tu solicitud está <b>APROBADA!</b>",
		"app.step_product_description": "<h3><b>Llevate YA <span class=\"custom-orange-font \">{maxAmount}</span><b></h3>",
		"app.step_upload": "<p>Para continuar por favor subí una foto de tu DNI del frente / dorso, 2 servicios y tus últimos 3 bonos de sueldo.</p>",
		"app.step_upload_documents": "<p>Subí tu documentación ahora para agilizar tu préstamo.</p>",
		"app.step_checkout": "<h3><b><span class=\"custom-orange-font \">{nameClient}</span>, estás a un paso de obtener tu dinero</b></h3>",
		"app.step_affidavit": "<h3><b>Declaraciones Juradas</b></h3><p>Para cumplir con las regulaciones del Banco Central y de la UIF necesitamos saber lo siguiente:</p>",
		"app.contract_advice": "<p>Por favor, abrir, leer y acordar con Montemar.com.ar</p>",
		"app.step_checkout_info": "El pago se realiza via Débito Automático desde la cuenta donde se depositó el préstamo.",
		"app.step_email_verification": "<h3><b>Validación de correo electrónico</b></h3>",
		"app.disapproved": "<h3><b>Por el momento no tenemos una oferta de crédito que se ajuste a su perfil.</b></h3>",
		"app.step_email_pending": "<h3><b>Validación de correo electrónico</b></h3>",
		"app.step_email_pending_info": "<h3><b>Estamos terminando de procesar tu Préstamo Pre-Aprobado. Cuando esté listo, recibirás un enlace en tu correo electrónico para continuar.</b></h3>",
		"app.step_congratulations": "<h3><b>¡Felicitaciones <span class=\"custom-orange-font \">{nameClient}</span>, Tú Préstamo ha sido APROBADO!</b></h3>"
	};

/***/ },
/* 1554 */
/***/ function(module, exports) {

	module.exports = {
		"app.intro": "<h3>Llená el formulario y enterate si aprobás, préstamos desde el celu!</h3>",
		"app.footer-info": "<p>Información financiera: Préstamos personales en pesos de libre disponibilidad. Los montos, plazo, tasas y demás condiciones del préstamo dependen de la calificación crediticia del solicitante. Los montos van desde los $1.000 a los $100.000. Los plazos varían entre los 90 días y los 36 meses.</p><p>COSTO FINANCIERO TOTAL (ANUAL) (CFT) Mínimo 53,60 %, Máximo: 200,14%. Las presentes condiciones son a modo informativo, no constituyen una oferta y pueden ser modificadas en cualquier momento sin previo aviso.</p><p><a href=\"https://puedo.com.ar/terminos-y-condiciones/\" class=\"site-contracts\">Términos y condiciones</a></p><p><a href=\"https://puedo.com.ar/politicas-de-privacidad/\" class=\"site-contracts\">Políticas de privacidad</a></p>",
		"app.footer-sign": "<p>Copyright © 2017 - puedo.com.ar. Todos los derechos reservados. EBUCAR S.A. Domicilio: 9 de Julio 1455, piso 2, Mendoza Ciudad (C.P. 5500), Mendoza, Argentina.</p><p>Defensa al consumidor: 0800-666-1518 - Línea de Atención Gratuita de lunes a viernes de 8 a 20 hs. - <a class=\"footer-link\" href=\"mailto:consultas@consumidor.gob.ar\">consultas@consumidor.gob.ar</a> - <a class=\"footer-link\" href=\"https://www.argentina.gob.ar/produccion/consumidor\">https://www.argentina.gob.ar/produccion/consumidor</a></p><div class=\"afip-logo\"><a href=\"http://qr.afip.gob.ar/?qr=agypMWLlEOyo7W5BFO2krA,,\"><img src={require('../img/data-fiscal.png')} alt=\"AFIP\" class=\"afip-img\" /></a></div>",
		"app.min_specs": "<p><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Ser mayor de 18 años</p><p><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Poseer una cuenta bancaria a tu nombre</p><p><i class=\"fa fa-check\" aria-hidden=\"true\"></i> CBU de esa cuenta, para depositar el préstamo y debitar la cuota</p><p><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Tener una cuenta de correo electrónico</p><p><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Tener un teléfono celular</p>",
		"app.how_it_works": "<div class=\"how_it_works__row row\"><div class=\"col-lg-3 col-md-3 col-sm-6\"><div class=\"how_it_works__block\"><div class=\"how_it_works__block__icon\"><img src=\"{step_1_url}\" alt=\"\" class=\"how_it_works__block__icon__img\"></div><div class=\"how_it_works__epigraph\"><div class=\"how_it_works__epigraph__title\"><h4>Paso 1</h4></div><div class=\"how_it_works__epigraph__description\"><p>Ingresás tus datos personales</p></div></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-6\"><div class=\"how_it_works__block\"><div class=\"how_it_works__block__icon\"><img src=\"{step_2_url}\" alt=\"\" class=\"how_it_works__block__icon__img\"></div><div class=\"how_it_works__epigraph\"><div class=\"how_it_works__epigraph__title\"><h4>Paso 2</h4></div><div class=\"how_it_works__epigraph__description\"><p>Elegís el monto y las cuotas</p></div></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-6\"><div class=\"how_it_works__block\"><div class=\"how_it_works__block__icon\"><img src=\"{step_3_url}\" alt=\"\" class=\"how_it_works__block__icon__img\"><div class=\"how_it_works__epigraph__title\"><h4>Paso 3</h4></div><div class=\"how_it_works__epigraph__description\"><p>Verificamos tus datos por teléfono</p></div></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-6\"><div class=\"how_it_works__block\"><div class=\"how_it_works__block__icon\"><img src=\"{step_4_url}\" alt=\"\" class=\"how_it_works__block__icon__img\"></div><div class=\"how_it_works__epigraph\"><div class=\"how_it_works__epigraph__title\"><h4>Paso 4</h4></div><div class=\"how_it_works__epigraph__description\"><p>Recibís el dinero en tu cuenta bancaria</p></div></div></div></div></div>",
		"app.faq1": "<h4>¿Completar el formulario genera algún compromiso?</h4><p>No, la decisión final siempre está en tus manos y contás con ella hasta el último paso.</p><h4>¿Tengo que ir personalmente a algún lado?</h4><p>No, la gestión del préstamo se puede realizar completamente desde tu celu.</p><h4><img class=\"blue-tick\" src=\"/img/tick-azul.png\"/>¿Cómo se realiza el pago de la cuota del préstamo?</h4><p>El pago de la cuota es por débito automático del 1 al 10 de cada mes, desde la cuenta donde se depositó el préstamo y en la misma tiene que haber fondos.</p>",
		"app.faq2": "<h4>¿Tengo que tener una cuenta bancaria a mi nombre?</h4><p>Sí, es indispensable contar con una cuenta bancaria a tu nombre donde se depositará el dinero.</p><h4>¿Tengo que firmar algún papel?</h4><p>No, todo el proceso es en línea y telefónicamente.</p><h4>¿Cuánto tiempo tarda en acreditarse el préstamo en mi cuenta?</h4><p>El préstamo estará disponible en no más de 24 hs hábiles desde la verificación telefónica de indentidad.</p>",
		"app.step_sms": "<h3>Hemos enviado un SMS a tu celular, por favor ingresá ese código para continuar</h3><p>(el sms puede demorar unos segundos)</p>",
		"app.whatsapp_timetable": "<p class=\"pd-opening-hours\">Lunes a Viernes 09 - 17hs </p>",
		"app.phone_timetable": " ",
		"app.renaper_step": "A continuación efectuaremos una validación de tu identidad a través del Registro Nacional de las Personas (RENAPER)",
		"app.renaper_step_form": "Este botón te llevará a la página del RENAPER, una vez que hayamos validado tu idendidad podrás seguir con tu solicitud en nuestra web.",
		"app.step_cbu": "<h3>Último paso!</h3><p>Por favor ingresá el CBU de una cuenta sueldo a tu nombre (para depositar el préstamo y debitar la cuota)</p>",
		"app.step_address": "<h3>Ya casi terminás!</h3><p>Por favor confirmanos tu dirección e ingresos mensuales</p>",
		"app.step_incomes": "<p>Por favor ingresá la información de tu último recibo de sueldo o documentación de ingresos más reciente.</p>",
		"app.step_personal_info": "<p>Por favor ingresá tu información personal y los servicios que tenés disponible en tu domicilio.</p>",
		"app.step_service_info": "<p>Por favor ingresá tu información personal y los servicios que tenés disponible en tu domicilio.</p>",
		"app.step_job_info": "<p>Por favor ingresá la información de tus datos laborales.</p>",
		"app.step_email": "<p>Para continuar con tu solicitud por favor ingresá tu correo electrónico.</p>",
		"app.step_upload_info": "<p>Para continuar por favor subí una foto de tu DNI del frente / dorso, 2 servicios y tus últimos 3 bonos de sueldo.</p>",
		"app.step_product": "<h3><b>Felicitaciones</b> estás <b>Pre-APROBADO!</b></h3><p>Para continuar, elegí el monto y las cuotas a solicitar:</p>",
		"app.step_product_description": "",
		"app.step_product_label_quota": "cuota",
		"app.step_upload": "<p>Para continuar por favor subí una foto de tu DNI del frente / dorso, 2 servicios y tus últimos 3 bonos de sueldo.</p>",
		"app.step_affidavit": "<h4>Declaraciones Juradas</h4><p>Para cumplir con las regulaciones del Banco Central y de la UIF necesitamos saber lo siguiente:</p>",
		"app.step_checkout": "<h3><b>Gracias por tu tiempo!</b></h3><h4>Resumen de tu Solicitud:</h4>",
		"app.contract_advice": "<p>Por favor, abrir, leer y acordar con Puedo.com.ar</p>",
		"app.step_checkout_info": "El pago se realiza via Débito Automático desde la cuenta donde se depositó el préstamo.",
		"app.step_email_verification": "<h3><b>Para finalizar con tu préstamo hace clic en el enlace que te enviamos a tu correo electrónico</b></h3>",
		"app.disapproved": "<h3><b>Por el momento no tenemos una oferta de crédito que se ajuste a su perfil.</b></h3>"
	};

/***/ },
/* 1555 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * Creates a base function for methods like `_.forIn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = baseFor;


/***/ },
/* 1556 */
/***/ function(module, exports) {

	/**
	 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = getNative;


/***/ },
/* 1557 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseFor = __webpack_require__(1555),
	    isArguments = __webpack_require__(408),
	    keysIn = __webpack_require__(1559);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * **Note:** This method assumes objects created by the `Object` constructor
	 * have no inherited enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  var Ctor;
	
	  // Exit early for non `Object` objects.
	  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	    return false;
	  }
	  // IE < 9 iterates inherited properties before own properties. If the first
	  // iterated property is an object's own property then there are no inherited
	  // enumerable properties.
	  var result;
	  // In most environments an object's own properties are iterated before
	  // its inherited properties. If the last iterated property is an object's
	  // own property then there are no inherited enumerable properties.
	  baseForIn(value, function(subValue, key) {
	    result = key;
	  });
	  return result === undefined || hasOwnProperty.call(value, result);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var getNative = __webpack_require__(1556),
	    isArguments = __webpack_require__(408),
	    isArray = __webpack_require__(642);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ },
/* 1559 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var isArguments = __webpack_require__(408),
	    isArray = __webpack_require__(642);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 1560 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Creates a function that invokes `func`, with the `this` binding and arguments
	 * of the created function, while it's called less than `n` times. Subsequent
	 * calls to the created function return the result of the last `func` invocation.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {number} n The number of calls at which `func` is no longer invoked.
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * jQuery(element).on('click', _.before(5, addContactToList));
	 * // => Allows adding up to 4 contacts to the list.
	 */
	function before(n, func) {
	  var result;
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  n = toInteger(n);
	  return function() {
	    if (--n > 0) {
	      result = func.apply(this, arguments);
	    }
	    if (n <= 1) {
	      func = undefined;
	    }
	    return result;
	  };
	}
	
	/**
	 * Creates a function that is restricted to invoking `func` once. Repeat calls
	 * to the function return the value of the first invocation. The `func` is
	 * invoked with the `this` binding and arguments of the created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * var initialize = _.once(createApplication);
	 * initialize();
	 * initialize();
	 * // => `createApplication` is invoked once
	 */
	function once(func) {
	  return before(2, func);
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = once;


/***/ },
/* 1561 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(142),
	    root = __webpack_require__(101);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 1562 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1607),
	    hashDelete = __webpack_require__(1608),
	    hashGet = __webpack_require__(1609),
	    hashHas = __webpack_require__(1610),
	    hashSet = __webpack_require__(1611);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 1563 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(142),
	    root = __webpack_require__(101);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 1564 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(142),
	    root = __webpack_require__(101);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(410),
	    setCacheAdd = __webpack_require__(1631),
	    setCacheHas = __webpack_require__(1632);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(101);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 1567 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(142),
	    root = __webpack_require__(101);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 1568 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1587),
	    isArguments = __webpack_require__(657),
	    isArray = __webpack_require__(102),
	    isBuffer = __webpack_require__(658),
	    isIndex = __webpack_require__(412),
	    isTypedArray = __webpack_require__(660);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 1570 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 1571 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(1596);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 1572 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(646),
	    createBaseEach = __webpack_require__(1594);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 1573 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1595);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 1574 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(1570),
	    isArray = __webpack_require__(102);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 1575 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 1576 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(172),
	    isObjectLike = __webpack_require__(173);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 1577 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(643),
	    equalArrays = __webpack_require__(650),
	    equalByTag = __webpack_require__(1597),
	    equalObjects = __webpack_require__(1598),
	    getTag = __webpack_require__(1604),
	    isArray = __webpack_require__(102),
	    isBuffer = __webpack_require__(658),
	    isTypedArray = __webpack_require__(660);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(643),
	    baseIsEqual = __webpack_require__(411);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 1579 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(659),
	    isMasked = __webpack_require__(1614),
	    isObject = __webpack_require__(143),
	    toSource = __webpack_require__(656);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 1580 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(172),
	    isLength = __webpack_require__(416),
	    isObjectLike = __webpack_require__(173);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 1581 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(1615),
	    nativeKeys = __webpack_require__(1628);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 1582 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1578),
	    getMatchData = __webpack_require__(1600),
	    matchesStrictComparable = __webpack_require__(653);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(411),
	    get = __webpack_require__(1641),
	    hasIn = __webpack_require__(1642),
	    isKey = __webpack_require__(413),
	    isStrictComparable = __webpack_require__(652),
	    matchesStrictComparable = __webpack_require__(653),
	    toKey = __webpack_require__(214);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 1584 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 1585 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(647);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 1586 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(1572);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ },
/* 1587 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(278),
	    arrayMap = __webpack_require__(644),
	    isArray = __webpack_require__(102),
	    isSymbol = __webpack_require__(215);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(1639);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ },
/* 1590 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 1591 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 1592 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 1593 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(101);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(415);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 1595 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 1596 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(142);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 1597 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(278),
	    Uint8Array = __webpack_require__(1566),
	    eq = __webpack_require__(414),
	    equalArrays = __webpack_require__(650),
	    mapToArray = __webpack_require__(1626),
	    setToArray = __webpack_require__(1633);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(1599);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(1574),
	    getSymbols = __webpack_require__(1603),
	    keys = __webpack_require__(418);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(652),
	    keys = __webpack_require__(418);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 1601 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(654);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 1602 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(278);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 1603 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(1568),
	    stubArray = __webpack_require__(1650);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 1604 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1561),
	    Map = __webpack_require__(409),
	    Promise = __webpack_require__(1563),
	    Set = __webpack_require__(1564),
	    WeakMap = __webpack_require__(1567),
	    baseGetTag = __webpack_require__(172),
	    toSource = __webpack_require__(656);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 1605 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 1606 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(649),
	    isArguments = __webpack_require__(657),
	    isArray = __webpack_require__(102),
	    isIndex = __webpack_require__(412),
	    isLength = __webpack_require__(416),
	    toKey = __webpack_require__(214);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(281);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 1608 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(281);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 1610 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(281);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 1611 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(281);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 1612 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(414),
	    isArrayLike = __webpack_require__(415),
	    isIndex = __webpack_require__(412),
	    isObject = __webpack_require__(143);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 1613 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 1614 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1593);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 1615 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 1616 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 1617 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(279);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 1618 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(279);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 1619 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(279);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 1620 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(279);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 1621 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1562),
	    ListCache = __webpack_require__(277),
	    Map = __webpack_require__(409);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 1622 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(280);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 1623 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(280);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 1624 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(280);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 1625 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(280);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 1626 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1645);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(654);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(651);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)(module)))

/***/ },
/* 1630 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 1631 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 1632 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 1633 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(277);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 1635 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 1636 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 1637 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(277),
	    Map = __webpack_require__(409),
	    MapCache = __webpack_require__(410);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 1639 */
/***/ function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(143),
	    now = __webpack_require__(1647),
	    toNumber = __webpack_require__(1652);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(647);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 1642 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1575),
	    hasPath = __webpack_require__(1606);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 1643 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(411);
	
	/**
	 * This method is like `_.isEqual` except that it accepts `customizer` which
	 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	 * are handled by the method instead. The `customizer` is invoked with up to
	 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * function isGreeting(value) {
	 *   return /^h(?:i|ello)$/.test(value);
	 * }
	 *
	 * function customizer(objValue, othValue) {
	 *   if (isGreeting(objValue) && isGreeting(othValue)) {
	 *     return true;
	 *   }
	 * }
	 *
	 * var array = ['hello', 'goodbye'];
	 * var other = ['hi', 'goodbye'];
	 *
	 * _.isEqualWith(array, other, customizer);
	 * // => true
	 */
	function isEqualWith(value, other, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  var result = customizer ? customizer(value, other) : undefined;
	  return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	}
	
	module.exports = isEqualWith;


/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(410);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 1646 */
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 1647 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(101);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },
/* 1648 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1584),
	    basePropertyDeep = __webpack_require__(1585),
	    isKey = __webpack_require__(413),
	    toKey = __webpack_require__(214);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 1649 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(645),
	    baseIteratee = __webpack_require__(648),
	    baseSome = __webpack_require__(1586),
	    isArray = __webpack_require__(102),
	    isIterateeCall = __webpack_require__(1612);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ },
/* 1650 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 1651 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 1652 */
/***/ function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(1589),
	    isObject = __webpack_require__(143),
	    isSymbol = __webpack_require__(215);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 1653 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./maxArrayLength')} */
	module.exports = 4294967295; // Math.pow(2, 32) - 1;


/***/ },
/* 1654 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./max')} */
	module.exports = Math.max;


/***/ },
/* 1655 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./min')} */
	module.exports = Math.min;


/***/ },
/* 1656 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./pow')} */
	module.exports = Math.pow;


/***/ },
/* 1657 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./round')} */
	module.exports = Math.round;


/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $isNaN = __webpack_require__(216);
	
	/** @type {import('./sign')} */
	module.exports = function sign(number) {
		if ($isNaN(number) || number === 0) {
			return number;
		}
		return number < 0 ? -1 : +1;
	};


/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	(function(){
	  var crypt = __webpack_require__(1342),
	      utf8 = __webpack_require__(515).utf8,
	      isBuffer = __webpack_require__(1547),
	      bin = __webpack_require__(515).bin,
	
	  // The core
	  md5 = function (message, options) {
	    // Convert to byte array
	    if (message.constructor == String)
	      if (options && options.encoding === 'binary')
	        message = bin.stringToBytes(message);
	      else
	        message = utf8.stringToBytes(message);
	    else if (isBuffer(message))
	      message = Array.prototype.slice.call(message, 0);
	    else if (!Array.isArray(message) && message.constructor !== Uint8Array)
	      message = message.toString();
	    // else, assume byte array already
	
	    var m = crypt.bytesToWords(message),
	        l = message.length * 8,
	        a =  1732584193,
	        b = -271733879,
	        c = -1732584194,
	        d =  271733878;
	
	    // Swap endian
	    for (var i = 0; i < m.length; i++) {
	      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
	             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
	    }
	
	    // Padding
	    m[l >>> 5] |= 0x80 << (l % 32);
	    m[(((l + 64) >>> 9) << 4) + 14] = l;
	
	    // Method shortcuts
	    var FF = md5._ff,
	        GG = md5._gg,
	        HH = md5._hh,
	        II = md5._ii;
	
	    for (var i = 0; i < m.length; i += 16) {
	
	      var aa = a,
	          bb = b,
	          cc = c,
	          dd = d;
	
	      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
	      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
	      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
	      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
	      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
	      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
	      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
	      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
	      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
	      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
	      c = FF(c, d, a, b, m[i+10], 17, -42063);
	      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
	      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
	      d = FF(d, a, b, c, m[i+13], 12, -40341101);
	      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
	      b = FF(b, c, d, a, m[i+15], 22,  1236535329);
	
	      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
	      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
	      c = GG(c, d, a, b, m[i+11], 14,  643717713);
	      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
	      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
	      d = GG(d, a, b, c, m[i+10],  9,  38016083);
	      c = GG(c, d, a, b, m[i+15], 14, -660478335);
	      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
	      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
	      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
	      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
	      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
	      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
	      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
	      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
	      b = GG(b, c, d, a, m[i+12], 20, -1926607734);
	
	      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
	      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
	      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
	      b = HH(b, c, d, a, m[i+14], 23, -35309556);
	      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
	      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
	      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
	      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
	      a = HH(a, b, c, d, m[i+13],  4,  681279174);
	      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
	      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
	      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
	      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
	      d = HH(d, a, b, c, m[i+12], 11, -421815835);
	      c = HH(c, d, a, b, m[i+15], 16,  530742520);
	      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);
	
	      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
	      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
	      c = II(c, d, a, b, m[i+14], 15, -1416354905);
	      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
	      a = II(a, b, c, d, m[i+12],  6,  1700485571);
	      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
	      c = II(c, d, a, b, m[i+10], 15, -1051523);
	      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
	      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
	      d = II(d, a, b, c, m[i+15], 10, -30611744);
	      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
	      b = II(b, c, d, a, m[i+13], 21,  1309151649);
	      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
	      d = II(d, a, b, c, m[i+11], 10, -1120210379);
	      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
	      b = II(b, c, d, a, m[i+ 9], 21, -343485551);
	
	      a = (a + aa) >>> 0;
	      b = (b + bb) >>> 0;
	      c = (c + cc) >>> 0;
	      d = (d + dd) >>> 0;
	    }
	
	    return crypt.endian([a, b, c, d]);
	  };
	
	  // Auxiliary functions
	  md5._ff  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._gg  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._hh  = function (a, b, c, d, x, s, t) {
	    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._ii  = function (a, b, c, d, x, s, t) {
	    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	
	  // Package private blocksize
	  md5._blocksize = 16;
	  md5._digestsize = 16;
	
	  module.exports = function (message, options) {
	    if (message === undefined || message === null)
	      throw new Error('Illegal argument ' + message);
	
	    var digestbytes = crypt.wordsToBytes(md5(message, options));
	    return options && options.asBytes ? digestbytes :
	        options && options.asString ? bin.bytesToString(digestbytes) :
	        crypt.bytesToHex(digestbytes);
	  };
	
	})();


/***/ },
/* 1660 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 668,
		"./af.js": 668,
		"./ar": 676,
		"./ar-dz": 669,
		"./ar-dz.js": 669,
		"./ar-kw": 670,
		"./ar-kw.js": 670,
		"./ar-ly": 671,
		"./ar-ly.js": 671,
		"./ar-ma": 672,
		"./ar-ma.js": 672,
		"./ar-ps": 673,
		"./ar-ps.js": 673,
		"./ar-sa": 674,
		"./ar-sa.js": 674,
		"./ar-tn": 675,
		"./ar-tn.js": 675,
		"./ar.js": 676,
		"./az": 677,
		"./az.js": 677,
		"./be": 678,
		"./be.js": 678,
		"./bg": 679,
		"./bg.js": 679,
		"./bm": 680,
		"./bm.js": 680,
		"./bn": 682,
		"./bn-bd": 681,
		"./bn-bd.js": 681,
		"./bn.js": 682,
		"./bo": 683,
		"./bo.js": 683,
		"./br": 684,
		"./br.js": 684,
		"./bs": 685,
		"./bs.js": 685,
		"./ca": 686,
		"./ca.js": 686,
		"./cs": 687,
		"./cs.js": 687,
		"./cv": 688,
		"./cv.js": 688,
		"./cy": 689,
		"./cy.js": 689,
		"./da": 690,
		"./da.js": 690,
		"./de": 693,
		"./de-at": 691,
		"./de-at.js": 691,
		"./de-ch": 692,
		"./de-ch.js": 692,
		"./de.js": 693,
		"./dv": 694,
		"./dv.js": 694,
		"./el": 695,
		"./el.js": 695,
		"./en-au": 696,
		"./en-au.js": 696,
		"./en-ca": 697,
		"./en-ca.js": 697,
		"./en-gb": 698,
		"./en-gb.js": 698,
		"./en-ie": 699,
		"./en-ie.js": 699,
		"./en-il": 700,
		"./en-il.js": 700,
		"./en-in": 701,
		"./en-in.js": 701,
		"./en-nz": 702,
		"./en-nz.js": 702,
		"./en-sg": 703,
		"./en-sg.js": 703,
		"./eo": 704,
		"./eo.js": 704,
		"./es": 708,
		"./es-do": 705,
		"./es-do.js": 705,
		"./es-mx": 706,
		"./es-mx.js": 706,
		"./es-us": 707,
		"./es-us.js": 707,
		"./es.js": 708,
		"./et": 709,
		"./et.js": 709,
		"./eu": 710,
		"./eu.js": 710,
		"./fa": 711,
		"./fa.js": 711,
		"./fi": 712,
		"./fi.js": 712,
		"./fil": 713,
		"./fil.js": 713,
		"./fo": 714,
		"./fo.js": 714,
		"./fr": 717,
		"./fr-ca": 715,
		"./fr-ca.js": 715,
		"./fr-ch": 716,
		"./fr-ch.js": 716,
		"./fr.js": 717,
		"./fy": 718,
		"./fy.js": 718,
		"./ga": 719,
		"./ga.js": 719,
		"./gd": 720,
		"./gd.js": 720,
		"./gl": 721,
		"./gl.js": 721,
		"./gom-deva": 722,
		"./gom-deva.js": 722,
		"./gom-latn": 723,
		"./gom-latn.js": 723,
		"./gu": 724,
		"./gu.js": 724,
		"./he": 725,
		"./he.js": 725,
		"./hi": 726,
		"./hi.js": 726,
		"./hr": 727,
		"./hr.js": 727,
		"./hu": 728,
		"./hu.js": 728,
		"./hy-am": 729,
		"./hy-am.js": 729,
		"./id": 730,
		"./id.js": 730,
		"./is": 731,
		"./is.js": 731,
		"./it": 733,
		"./it-ch": 732,
		"./it-ch.js": 732,
		"./it.js": 733,
		"./ja": 734,
		"./ja.js": 734,
		"./jv": 735,
		"./jv.js": 735,
		"./ka": 736,
		"./ka.js": 736,
		"./kk": 737,
		"./kk.js": 737,
		"./km": 738,
		"./km.js": 738,
		"./kn": 739,
		"./kn.js": 739,
		"./ko": 740,
		"./ko.js": 740,
		"./ku": 742,
		"./ku-kmr": 741,
		"./ku-kmr.js": 741,
		"./ku.js": 742,
		"./ky": 743,
		"./ky.js": 743,
		"./lb": 744,
		"./lb.js": 744,
		"./lo": 745,
		"./lo.js": 745,
		"./lt": 746,
		"./lt.js": 746,
		"./lv": 747,
		"./lv.js": 747,
		"./me": 748,
		"./me.js": 748,
		"./mi": 749,
		"./mi.js": 749,
		"./mk": 750,
		"./mk.js": 750,
		"./ml": 751,
		"./ml.js": 751,
		"./mn": 752,
		"./mn.js": 752,
		"./mr": 753,
		"./mr.js": 753,
		"./ms": 755,
		"./ms-my": 754,
		"./ms-my.js": 754,
		"./ms.js": 755,
		"./mt": 756,
		"./mt.js": 756,
		"./my": 757,
		"./my.js": 757,
		"./nb": 758,
		"./nb.js": 758,
		"./ne": 759,
		"./ne.js": 759,
		"./nl": 761,
		"./nl-be": 760,
		"./nl-be.js": 760,
		"./nl.js": 761,
		"./nn": 762,
		"./nn.js": 762,
		"./oc-lnc": 763,
		"./oc-lnc.js": 763,
		"./pa-in": 764,
		"./pa-in.js": 764,
		"./pl": 765,
		"./pl.js": 765,
		"./pt": 767,
		"./pt-br": 766,
		"./pt-br.js": 766,
		"./pt.js": 767,
		"./ro": 768,
		"./ro.js": 768,
		"./ru": 769,
		"./ru.js": 769,
		"./sd": 770,
		"./sd.js": 770,
		"./se": 771,
		"./se.js": 771,
		"./si": 772,
		"./si.js": 772,
		"./sk": 773,
		"./sk.js": 773,
		"./sl": 774,
		"./sl.js": 774,
		"./sq": 775,
		"./sq.js": 775,
		"./sr": 777,
		"./sr-cyrl": 776,
		"./sr-cyrl.js": 776,
		"./sr.js": 777,
		"./ss": 778,
		"./ss.js": 778,
		"./sv": 779,
		"./sv.js": 779,
		"./sw": 780,
		"./sw.js": 780,
		"./ta": 781,
		"./ta.js": 781,
		"./te": 782,
		"./te.js": 782,
		"./tet": 783,
		"./tet.js": 783,
		"./tg": 784,
		"./tg.js": 784,
		"./th": 785,
		"./th.js": 785,
		"./tk": 786,
		"./tk.js": 786,
		"./tl-ph": 787,
		"./tl-ph.js": 787,
		"./tlh": 788,
		"./tlh.js": 788,
		"./tr": 789,
		"./tr.js": 789,
		"./tzl": 790,
		"./tzl.js": 790,
		"./tzm": 792,
		"./tzm-latn": 791,
		"./tzm-latn.js": 791,
		"./tzm.js": 792,
		"./ug-cn": 793,
		"./ug-cn.js": 793,
		"./uk": 794,
		"./uk.js": 794,
		"./ur": 795,
		"./ur.js": 795,
		"./uz": 797,
		"./uz-latn": 796,
		"./uz-latn.js": 796,
		"./uz.js": 797,
		"./vi": 798,
		"./vi.js": 798,
		"./x-pseudo": 799,
		"./x-pseudo.js": 799,
		"./yo": 800,
		"./yo.js": 800,
		"./zh-cn": 801,
		"./zh-cn.js": 801,
		"./zh-hk": 802,
		"./zh-hk.js": 802,
		"./zh-mo": 803,
		"./zh-mo.js": 803,
		"./zh-tw": 804,
		"./zh-tw.js": 804
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1660;


/***/ },
/* 1661 */
534,
/* 1662 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 1663 */
[2139, 1662, 2073, 217, 217],
/* 1664 */
[2140, 217],
/* 1665 */
[2141, 217, 217],
/* 1666 */
[2142, 1664],
/* 1667 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 1668 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var hasMap = typeof Map === 'function' && Map.prototype;
	var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
	var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
	var mapForEach = hasMap && Map.prototype.forEach;
	var hasSet = typeof Set === 'function' && Set.prototype;
	var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
	var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
	var setForEach = hasSet && Set.prototype.forEach;
	var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
	var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
	var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
	var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
	var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
	var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
	var booleanValueOf = Boolean.prototype.valueOf;
	var objectToString = Object.prototype.toString;
	var functionToString = Function.prototype.toString;
	var $match = String.prototype.match;
	var $slice = String.prototype.slice;
	var $replace = String.prototype.replace;
	var $toUpperCase = String.prototype.toUpperCase;
	var $toLowerCase = String.prototype.toLowerCase;
	var $test = RegExp.prototype.test;
	var $concat = Array.prototype.concat;
	var $join = Array.prototype.join;
	var $arrSlice = Array.prototype.slice;
	var $floor = Math.floor;
	var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
	var gOPS = Object.getOwnPropertySymbols;
	var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
	var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
	// ie, `has-tostringtag/shams
	var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
	    ? Symbol.toStringTag
	    : null;
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	
	var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
	    [].__proto__ === Array.prototype // eslint-disable-line no-proto
	        ? function (O) {
	            return O.__proto__; // eslint-disable-line no-proto
	        }
	        : null
	);
	
	function addNumericSeparator(num, str) {
	    if (
	        num === Infinity
	        || num === -Infinity
	        || num !== num
	        || (num && num > -1000 && num < 1000)
	        || $test.call(/e/, str)
	    ) {
	        return str;
	    }
	    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
	    if (typeof num === 'number') {
	        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
	        if (int !== num) {
	            var intStr = String(int);
	            var dec = $slice.call(str, intStr.length + 1);
	            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
	        }
	    }
	    return $replace.call(str, sepRegex, '$&_');
	}
	
	var utilInspect = __webpack_require__(2074);
	var inspectCustom = utilInspect.custom;
	var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
	
	var quotes = {
	    __proto__: null,
	    'double': '"',
	    single: "'"
	};
	var quoteREs = {
	    __proto__: null,
	    'double': /(["\\])/g,
	    single: /(['\\])/g
	};
	
	module.exports = function inspect_(obj, options, depth, seen) {
	    var opts = options || {};
	
	    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
	        throw new TypeError('option "quoteStyle" must be "single" or "double"');
	    }
	    if (
	        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
	            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
	            : opts.maxStringLength !== null
	        )
	    ) {
	        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
	    }
	    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
	    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
	        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
	    }
	
	    if (
	        has(opts, 'indent')
	        && opts.indent !== null
	        && opts.indent !== '\t'
	        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
	    ) {
	        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
	    }
	    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
	        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
	    }
	    var numericSeparator = opts.numericSeparator;
	
	    if (typeof obj === 'undefined') {
	        return 'undefined';
	    }
	    if (obj === null) {
	        return 'null';
	    }
	    if (typeof obj === 'boolean') {
	        return obj ? 'true' : 'false';
	    }
	
	    if (typeof obj === 'string') {
	        return inspectString(obj, opts);
	    }
	    if (typeof obj === 'number') {
	        if (obj === 0) {
	            return Infinity / obj > 0 ? '0' : '-0';
	        }
	        var str = String(obj);
	        return numericSeparator ? addNumericSeparator(obj, str) : str;
	    }
	    if (typeof obj === 'bigint') {
	        var bigIntStr = String(obj) + 'n';
	        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
	    }
	
	    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
	    if (typeof depth === 'undefined') { depth = 0; }
	    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
	        return isArray(obj) ? '[Array]' : '[Object]';
	    }
	
	    var indent = getIndent(opts, depth);
	
	    if (typeof seen === 'undefined') {
	        seen = [];
	    } else if (indexOf(seen, obj) >= 0) {
	        return '[Circular]';
	    }
	
	    function inspect(value, from, noIndent) {
	        if (from) {
	            seen = $arrSlice.call(seen);
	            seen.push(from);
	        }
	        if (noIndent) {
	            var newOpts = {
	                depth: opts.depth
	            };
	            if (has(opts, 'quoteStyle')) {
	                newOpts.quoteStyle = opts.quoteStyle;
	            }
	            return inspect_(value, newOpts, depth + 1, seen);
	        }
	        return inspect_(value, opts, depth + 1, seen);
	    }
	
	    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
	        var name = nameOf(obj);
	        var keys = arrObjKeys(obj, inspect);
	        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
	    }
	    if (isSymbol(obj)) {
	        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
	        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
	    }
	    if (isElement(obj)) {
	        var s = '<' + $toLowerCase.call(String(obj.nodeName));
	        var attrs = obj.attributes || [];
	        for (var i = 0; i < attrs.length; i++) {
	            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
	        }
	        s += '>';
	        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
	        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
	        return s;
	    }
	    if (isArray(obj)) {
	        if (obj.length === 0) { return '[]'; }
	        var xs = arrObjKeys(obj, inspect);
	        if (indent && !singleLineValues(xs)) {
	            return '[' + indentedJoin(xs, indent) + ']';
	        }
	        return '[ ' + $join.call(xs, ', ') + ' ]';
	    }
	    if (isError(obj)) {
	        var parts = arrObjKeys(obj, inspect);
	        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
	            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
	        }
	        if (parts.length === 0) { return '[' + String(obj) + ']'; }
	        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
	    }
	    if (typeof obj === 'object' && customInspect) {
	        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
	            return utilInspect(obj, { depth: maxDepth - depth });
	        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
	            return obj.inspect();
	        }
	    }
	    if (isMap(obj)) {
	        var mapParts = [];
	        if (mapForEach) {
	            mapForEach.call(obj, function (value, key) {
	                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
	            });
	        }
	        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
	    }
	    if (isSet(obj)) {
	        var setParts = [];
	        if (setForEach) {
	            setForEach.call(obj, function (value) {
	                setParts.push(inspect(value, obj));
	            });
	        }
	        return collectionOf('Set', setSize.call(obj), setParts, indent);
	    }
	    if (isWeakMap(obj)) {
	        return weakCollectionOf('WeakMap');
	    }
	    if (isWeakSet(obj)) {
	        return weakCollectionOf('WeakSet');
	    }
	    if (isWeakRef(obj)) {
	        return weakCollectionOf('WeakRef');
	    }
	    if (isNumber(obj)) {
	        return markBoxed(inspect(Number(obj)));
	    }
	    if (isBigInt(obj)) {
	        return markBoxed(inspect(bigIntValueOf.call(obj)));
	    }
	    if (isBoolean(obj)) {
	        return markBoxed(booleanValueOf.call(obj));
	    }
	    if (isString(obj)) {
	        return markBoxed(inspect(String(obj)));
	    }
	    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
	    /* eslint-env browser */
	    if (typeof window !== 'undefined' && obj === window) {
	        return '{ [object Window] }';
	    }
	    if (
	        (typeof globalThis !== 'undefined' && obj === globalThis)
	        || (typeof global !== 'undefined' && obj === global)
	    ) {
	        return '{ [object globalThis] }';
	    }
	    if (!isDate(obj) && !isRegExp(obj)) {
	        var ys = arrObjKeys(obj, inspect);
	        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
	        var protoTag = obj instanceof Object ? '' : 'null prototype';
	        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
	        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
	        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
	        if (ys.length === 0) { return tag + '{}'; }
	        if (indent) {
	            return tag + '{' + indentedJoin(ys, indent) + '}';
	        }
	        return tag + '{ ' + $join.call(ys, ', ') + ' }';
	    }
	    return String(obj);
	};
	
	function wrapQuotes(s, defaultStyle, opts) {
	    var style = opts.quoteStyle || defaultStyle;
	    var quoteChar = quotes[style];
	    return quoteChar + s + quoteChar;
	}
	
	function quote(s) {
	    return $replace.call(String(s), /"/g, '&quot;');
	}
	
	function canTrustToString(obj) {
	    return !toStringTag || !(typeof obj === 'object' && (toStringTag in obj || typeof obj[toStringTag] !== 'undefined'));
	}
	function isArray(obj) { return toStr(obj) === '[object Array]' && canTrustToString(obj); }
	function isDate(obj) { return toStr(obj) === '[object Date]' && canTrustToString(obj); }
	function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && canTrustToString(obj); }
	function isError(obj) { return toStr(obj) === '[object Error]' && canTrustToString(obj); }
	function isString(obj) { return toStr(obj) === '[object String]' && canTrustToString(obj); }
	function isNumber(obj) { return toStr(obj) === '[object Number]' && canTrustToString(obj); }
	function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && canTrustToString(obj); }
	
	// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
	function isSymbol(obj) {
	    if (hasShammedSymbols) {
	        return obj && typeof obj === 'object' && obj instanceof Symbol;
	    }
	    if (typeof obj === 'symbol') {
	        return true;
	    }
	    if (!obj || typeof obj !== 'object' || !symToString) {
	        return false;
	    }
	    try {
	        symToString.call(obj);
	        return true;
	    } catch (e) {}
	    return false;
	}
	
	function isBigInt(obj) {
	    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
	        return false;
	    }
	    try {
	        bigIntValueOf.call(obj);
	        return true;
	    } catch (e) {}
	    return false;
	}
	
	var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
	function has(obj, key) {
	    return hasOwn.call(obj, key);
	}
	
	function toStr(obj) {
	    return objectToString.call(obj);
	}
	
	function nameOf(f) {
	    if (f.name) { return f.name; }
	    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
	    if (m) { return m[1]; }
	    return null;
	}
	
	function indexOf(xs, x) {
	    if (xs.indexOf) { return xs.indexOf(x); }
	    for (var i = 0, l = xs.length; i < l; i++) {
	        if (xs[i] === x) { return i; }
	    }
	    return -1;
	}
	
	function isMap(x) {
	    if (!mapSize || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        mapSize.call(x);
	        try {
	            setSize.call(x);
	        } catch (s) {
	            return true;
	        }
	        return x instanceof Map; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isWeakMap(x) {
	    if (!weakMapHas || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        weakMapHas.call(x, weakMapHas);
	        try {
	            weakSetHas.call(x, weakSetHas);
	        } catch (s) {
	            return true;
	        }
	        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isWeakRef(x) {
	    if (!weakRefDeref || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        weakRefDeref.call(x);
	        return true;
	    } catch (e) {}
	    return false;
	}
	
	function isSet(x) {
	    if (!setSize || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        setSize.call(x);
	        try {
	            mapSize.call(x);
	        } catch (m) {
	            return true;
	        }
	        return x instanceof Set; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isWeakSet(x) {
	    if (!weakSetHas || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        weakSetHas.call(x, weakSetHas);
	        try {
	            weakMapHas.call(x, weakMapHas);
	        } catch (s) {
	            return true;
	        }
	        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isElement(x) {
	    if (!x || typeof x !== 'object') { return false; }
	    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
	        return true;
	    }
	    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
	}
	
	function inspectString(str, opts) {
	    if (str.length > opts.maxStringLength) {
	        var remaining = str.length - opts.maxStringLength;
	        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
	        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
	    }
	    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
	    quoteRE.lastIndex = 0;
	    // eslint-disable-next-line no-control-regex
	    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
	    return wrapQuotes(s, 'single', opts);
	}
	
	function lowbyte(c) {
	    var n = c.charCodeAt(0);
	    var x = {
	        8: 'b',
	        9: 't',
	        10: 'n',
	        12: 'f',
	        13: 'r'
	    }[n];
	    if (x) { return '\\' + x; }
	    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
	}
	
	function markBoxed(str) {
	    return 'Object(' + str + ')';
	}
	
	function weakCollectionOf(type) {
	    return type + ' { ? }';
	}
	
	function collectionOf(type, size, entries, indent) {
	    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
	    return type + ' (' + size + ') {' + joinedEntries + '}';
	}
	
	function singleLineValues(xs) {
	    for (var i = 0; i < xs.length; i++) {
	        if (indexOf(xs[i], '\n') >= 0) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function getIndent(opts, depth) {
	    var baseIndent;
	    if (opts.indent === '\t') {
	        baseIndent = '\t';
	    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
	        baseIndent = $join.call(Array(opts.indent + 1), ' ');
	    } else {
	        return null;
	    }
	    return {
	        base: baseIndent,
	        prev: $join.call(Array(depth + 1), baseIndent)
	    };
	}
	
	function indentedJoin(xs, indent) {
	    if (xs.length === 0) { return ''; }
	    var lineJoiner = '\n' + indent.prev + indent.base;
	    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
	}
	
	function arrObjKeys(obj, inspect) {
	    var isArr = isArray(obj);
	    var xs = [];
	    if (isArr) {
	        xs.length = obj.length;
	        for (var i = 0; i < obj.length; i++) {
	            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
	        }
	    }
	    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
	    var symMap;
	    if (hasShammedSymbols) {
	        symMap = {};
	        for (var k = 0; k < syms.length; k++) {
	            symMap['$' + syms[k]] = syms[k];
	        }
	    }
	
	    for (var key in obj) { // eslint-disable-line no-restricted-syntax
	        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
	        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
	        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
	            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
	            continue; // eslint-disable-line no-restricted-syntax, no-continue
	        } else if ($test.call(/[^\w$]/, key)) {
	            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
	        } else {
	            xs.push(key + ': ' + inspect(obj[key], obj));
	        }
	    }
	    if (typeof gOPS === 'function') {
	        for (var j = 0; j < syms.length; j++) {
	            if (isEnumerable.call(obj, syms[j])) {
	                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
	            }
	        }
	    }
	    return xs;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(806); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ },
/* 1670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defineProperties = __webpack_require__(94);
	var callBind = __webpack_require__(248);
	
	var implementation = __webpack_require__(807);
	var getPolyfill = __webpack_require__(421);
	var shim = __webpack_require__(1671);
	
	var polyfill = callBind.apply(getPolyfill());
	// eslint-disable-next-line no-unused-vars
	var bound = function assign(target, source1) {
		return polyfill(Object, arguments);
	};
	
	defineProperties(bound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = bound;


/***/ },
/* 1671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(94);
	var getPolyfill = __webpack_require__(421);
	
	module.exports = function shimAssign() {
		var polyfill = getPolyfill();
		define(
			Object,
			{ assign: polyfill },
			{ assign: function () { return Object.assign !== polyfill; } }
		);
		return polyfill;
	};


/***/ },
/* 1672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(809);
	var define = __webpack_require__(94);
	
	module.exports = function shimValues() {
		var polyfill = getPolyfill();
		define(Object, { values: polyfill }, {
			values: function testValues() {
				return Object.values !== polyfill;
			}
		});
		return polyfill;
	};


/***/ },
/* 1673 */
/***/ function(module, exports) {

	'use strict';
	
	
	module.exports = {
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,
	
	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,
	
	
	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,
	
	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,
	
	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};


/***/ },
/* 1674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils   = __webpack_require__(283);
	var trees   = __webpack_require__(1678);
	var adler32 = __webpack_require__(810);
	var crc32   = __webpack_require__(811);
	var msg     = __webpack_require__(812);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only(s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  // zmemcpy(buf, strm->next_in, len);
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH - 1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH - 1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length - 1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH - 1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	function Config(good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	}
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
	  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	
	  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
	  //s->pending_buf = (uchf *) overlay;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
	  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
	  s.d_buf = 1 * s.lit_bufsize;
	
	  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	                );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	
	/* =========================================================================
	 * Initializes the compression dictionary from the given byte
	 * sequence without producing any compressed output.
	 */
	function deflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var s;
	  var str, n;
	  var wrap;
	  var avail;
	  var next;
	  var input;
	  var tmpDict;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	  wrap = s.wrap;
	
	  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
	  if (wrap === 1) {
	    /* adler32(strm->adler, dictionary, dictLength); */
	    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
	  }
	
	  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */
	
	  /* if dictionary would fill window, just replace the history */
	  if (dictLength >= s.w_size) {
	    if (wrap === 0) {            /* already empty otherwise */
	      /*** CLEAR_HASH(s); ***/
	      zero(s.head); // Fill with NIL (= 0);
	      s.strstart = 0;
	      s.block_start = 0;
	      s.insert = 0;
	    }
	    /* use the tail */
	    // dictionary = dictionary.slice(dictLength - s.w_size);
	    tmpDict = new utils.Buf8(s.w_size);
	    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
	    dictionary = tmpDict;
	    dictLength = s.w_size;
	  }
	  /* insert dictionary into window and hash */
	  avail = strm.avail_in;
	  next = strm.next_in;
	  input = strm.input;
	  strm.avail_in = dictLength;
	  strm.next_in = 0;
	  strm.input = dictionary;
	  fill_window(s);
	  while (s.lookahead >= MIN_MATCH) {
	    str = s.strstart;
	    n = s.lookahead - (MIN_MATCH - 1);
	    do {
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	      s.prev[str & s.w_mask] = s.head[s.ins_h];
	
	      s.head[s.ins_h] = str;
	      str++;
	    } while (--n);
	    s.strstart = str;
	    s.lookahead = MIN_MATCH - 1;
	    fill_window(s);
	  }
	  s.strstart += s.lookahead;
	  s.block_start = s.strstart;
	  s.insert = s.lookahead;
	  s.lookahead = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  strm.next_in = next;
	  strm.input = input;
	  strm.avail_in = avail;
	  s.wrap = wrap;
	  return Z_OK;
	}
	
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/


/***/ },
/* 1675 */
/***/ function(module, exports) {

	'use strict';
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
	  var s_window;               /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  s_window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = s_window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};


/***/ },
/* 1676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils         = __webpack_require__(283);
	var adler32       = __webpack_require__(810);
	var crc32         = __webpack_require__(811);
	var inflate_fast  = __webpack_require__(1675);
	var inflate_table = __webpack_require__(1677);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function zswap32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window, src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	    case HEAD:
	      if (state.wrap === 0) {
	        state.mode = TYPEDO;
	        break;
	      }
	      //=== NEEDBITS(16);
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = FLAGS;
	        break;
	      }
	      state.flags = 0;           /* expect zlib header */
	      if (state.head) {
	        state.head.done = false;
	      }
	      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	        strm.msg = 'incorrect header check';
	        state.mode = BAD;
	        break;
	      }
	      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	      len = (hold & 0x0f)/*BITS(4)*/ + 8;
	      if (state.wbits === 0) {
	        state.wbits = len;
	      }
	      else if (len > state.wbits) {
	        strm.msg = 'invalid window size';
	        state.mode = BAD;
	        break;
	      }
	      state.dmax = 1 << len;
	      //Tracev((stderr, "inflate:   zlib header ok\n"));
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = hold & 0x200 ? DICTID : TYPE;
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      break;
	    case FLAGS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.flags = hold;
	      if ((state.flags & 0xff) !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      if (state.flags & 0xe000) {
	        strm.msg = 'unknown header flags set';
	        state.mode = BAD;
	        break;
	      }
	      if (state.head) {
	        state.head.text = ((hold >> 8) & 1);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = TIME;
	      /* falls through */
	    case TIME:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.time = hold;
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC4(state.check, hold)
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        hbuf[2] = (hold >>> 16) & 0xff;
	        hbuf[3] = (hold >>> 24) & 0xff;
	        state.check = crc32(state.check, hbuf, 4, 0);
	        //===
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = OS;
	      /* falls through */
	    case OS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.xflags = (hold & 0xff);
	        state.head.os = (hold >> 8);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = EXLEN;
	      /* falls through */
	    case EXLEN:
	      if (state.flags & 0x0400) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length = hold;
	        if (state.head) {
	          state.head.extra_len = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      else if (state.head) {
	        state.head.extra = null/*Z_NULL*/;
	      }
	      state.mode = EXTRA;
	      /* falls through */
	    case EXTRA:
	      if (state.flags & 0x0400) {
	        copy = state.length;
	        if (copy > have) { copy = have; }
	        if (copy) {
	          if (state.head) {
	            len = state.head.extra_len - state.length;
	            if (!state.head.extra) {
	              // Use untyped array for more conveniend processing later
	              state.head.extra = new Array(state.head.extra_len);
	            }
	            utils.arraySet(
	              state.head.extra,
	              input,
	              next,
	              // extra field is limited to 65536 bytes
	              // - no need for additional size check
	              copy,
	              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	              len
	            );
	            //zmemcpy(state.head.extra + len, next,
	            //        len + copy > state.head.extra_max ?
	            //        state.head.extra_max - len : copy);
	          }
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          state.length -= copy;
	        }
	        if (state.length) { break inf_leave; }
	      }
	      state.length = 0;
	      state.mode = NAME;
	      /* falls through */
	    case NAME:
	      if (state.flags & 0x0800) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          // TODO: 2 or 1 bytes?
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.name_max*/)) {
	            state.head.name += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.name = null;
	      }
	      state.length = 0;
	      state.mode = COMMENT;
	      /* falls through */
	    case COMMENT:
	      if (state.flags & 0x1000) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.comm_max*/)) {
	            state.head.comment += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.comment = null;
	      }
	      state.mode = HCRC;
	      /* falls through */
	    case HCRC:
	      if (state.flags & 0x0200) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.check & 0xffff)) {
	          strm.msg = 'header crc mismatch';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      if (state.head) {
	        state.head.hcrc = ((state.flags >> 9) & 1);
	        state.head.done = true;
	      }
	      strm.adler = state.check = 0;
	      state.mode = TYPE;
	      break;
	    case DICTID:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      strm.adler = state.check = zswap32(hold);
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = DICT;
	      /* falls through */
	    case DICT:
	      if (state.havedict === 0) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        return Z_NEED_DICT;
	      }
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = TYPE;
	      /* falls through */
	    case TYPE:
	      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case TYPEDO:
	      if (state.last) {
	        //--- BYTEBITS() ---//
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        state.mode = CHECK;
	        break;
	      }
	      //=== NEEDBITS(3); */
	      while (bits < 3) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.last = (hold & 0x01)/*BITS(1)*/;
	      //--- DROPBITS(1) ---//
	      hold >>>= 1;
	      bits -= 1;
	      //---//
	
	      switch ((hold & 0x03)/*BITS(2)*/) {
	      case 0:                             /* stored block */
	        //Tracev((stderr, "inflate:     stored block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = STORED;
	        break;
	      case 1:                             /* fixed block */
	        fixedtables(state);
	        //Tracev((stderr, "inflate:     fixed codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = LEN_;             /* decode codes */
	        if (flush === Z_TREES) {
	          //--- DROPBITS(2) ---//
	          hold >>>= 2;
	          bits -= 2;
	          //---//
	          break inf_leave;
	        }
	        break;
	      case 2:                             /* dynamic block */
	        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = TABLE;
	        break;
	      case 3:
	        strm.msg = 'invalid block type';
	        state.mode = BAD;
	      }
	      //--- DROPBITS(2) ---//
	      hold >>>= 2;
	      bits -= 2;
	      //---//
	      break;
	    case STORED:
	      //--- BYTEBITS() ---// /* go to byte boundary */
	      hold >>>= bits & 7;
	      bits -= bits & 7;
	      //---//
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	        strm.msg = 'invalid stored block lengths';
	        state.mode = BAD;
	        break;
	      }
	      state.length = hold & 0xffff;
	      //Tracev((stderr, "inflate:       stored length %u\n",
	      //        state.length));
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = COPY_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case COPY_:
	      state.mode = COPY;
	      /* falls through */
	    case COPY:
	      copy = state.length;
	      if (copy) {
	        if (copy > have) { copy = have; }
	        if (copy > left) { copy = left; }
	        if (copy === 0) { break inf_leave; }
	        //--- zmemcpy(put, next, copy); ---
	        utils.arraySet(output, input, next, copy, put);
	        //---//
	        have -= copy;
	        next += copy;
	        left -= copy;
	        put += copy;
	        state.length -= copy;
	        break;
	      }
	      //Tracev((stderr, "inflate:       stored end\n"));
	      state.mode = TYPE;
	      break;
	    case TABLE:
	      //=== NEEDBITS(14); */
	      while (bits < 14) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	      if (state.nlen > 286 || state.ndist > 30) {
	        strm.msg = 'too many length or distance symbols';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracev((stderr, "inflate:       table sizes ok\n"));
	      state.have = 0;
	      state.mode = LENLENS;
	      /* falls through */
	    case LENLENS:
	      while (state.have < state.ncode) {
	        //=== NEEDBITS(3);
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	        //--- DROPBITS(3) ---//
	        hold >>>= 3;
	        bits -= 3;
	        //---//
	      }
	      while (state.have < 19) {
	        state.lens[order[state.have++]] = 0;
	      }
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      //state.next = state.codes;
	      //state.lencode = state.next;
	      // Switch to use dynamic table
	      state.lencode = state.lendyn;
	      state.lenbits = 7;
	
	      opts = { bits: state.lenbits };
	      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	      state.lenbits = opts.bits;
	
	      if (ret) {
	        strm.msg = 'invalid code lengths set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, "inflate:       code lengths ok\n"));
	      state.have = 0;
	      state.mode = CODELENS;
	      /* falls through */
	    case CODELENS:
	      while (state.have < state.nlen + state.ndist) {
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_val < 16) {
	          //--- DROPBITS(here.bits) ---//
	          hold >>>= here_bits;
	          bits -= here_bits;
	          //---//
	          state.lens[state.have++] = here_val;
	        }
	        else {
	          if (here_val === 16) {
	            //=== NEEDBITS(here.bits + 2);
	            n = here_bits + 2;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            if (state.have === 0) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            len = state.lens[state.have - 1];
	            copy = 3 + (hold & 0x03);//BITS(2);
	            //--- DROPBITS(2) ---//
	            hold >>>= 2;
	            bits -= 2;
	            //---//
	          }
	          else if (here_val === 17) {
	            //=== NEEDBITS(here.bits + 3);
	            n = here_bits + 3;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 3 + (hold & 0x07);//BITS(3);
	            //--- DROPBITS(3) ---//
	            hold >>>= 3;
	            bits -= 3;
	            //---//
	          }
	          else {
	            //=== NEEDBITS(here.bits + 7);
	            n = here_bits + 7;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 11 + (hold & 0x7f);//BITS(7);
	            //--- DROPBITS(7) ---//
	            hold >>>= 7;
	            bits -= 7;
	            //---//
	          }
	          if (state.have + copy > state.nlen + state.ndist) {
	            strm.msg = 'invalid bit length repeat';
	            state.mode = BAD;
	            break;
	          }
	          while (copy--) {
	            state.lens[state.have++] = len;
	          }
	        }
	      }
	
	      /* handle error breaks in while */
	      if (state.mode === BAD) { break; }
	
	      /* check for end-of-block code (better have one) */
	      if (state.lens[256] === 0) {
	        strm.msg = 'invalid code -- missing end-of-block';
	        state.mode = BAD;
	        break;
	      }
	
	      /* build code tables -- note: do not change the lenbits or distbits
	         values here (9 and 6) without reading the comments in inftrees.h
	         concerning the ENOUGH constants, which depend on those values */
	      state.lenbits = 9;
	
	      opts = { bits: state.lenbits };
	      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.lenbits = opts.bits;
	      // state.lencode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid literal/lengths set';
	        state.mode = BAD;
	        break;
	      }
	
	      state.distbits = 6;
	      //state.distcode.copy(state.codes);
	      // Switch to use dynamic table
	      state.distcode = state.distdyn;
	      opts = { bits: state.distbits };
	      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.distbits = opts.bits;
	      // state.distcode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid distances set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, 'inflate:       codes ok\n'));
	      state.mode = LEN_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case LEN_:
	      state.mode = LEN;
	      /* falls through */
	    case LEN:
	      if (have >= 6 && left >= 258) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        inflate_fast(strm, _out);
	        //--- LOAD() ---
	        put = strm.next_out;
	        output = strm.output;
	        left = strm.avail_out;
	        next = strm.next_in;
	        input = strm.input;
	        have = strm.avail_in;
	        hold = state.hold;
	        bits = state.bits;
	        //---
	
	        if (state.mode === TYPE) {
	          state.back = -1;
	        }
	        break;
	      }
	      state.back = 0;
	      for (;;) {
	        here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if (here_bits <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if (here_op && (here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.lencode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      state.length = here_val;
	      if (here_op === 0) {
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        state.mode = LIT;
	        break;
	      }
	      if (here_op & 32) {
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.back = -1;
	        state.mode = TYPE;
	        break;
	      }
	      if (here_op & 64) {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break;
	      }
	      state.extra = here_op & 15;
	      state.mode = LENEXT;
	      /* falls through */
	    case LENEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	      //Tracevv((stderr, "inflate:         length %u\n", state.length));
	      state.was = state.length;
	      state.mode = DIST;
	      /* falls through */
	    case DIST:
	      for (;;) {
	        here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if ((here_bits) <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if ((here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.distcode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      if (here_op & 64) {
	        strm.msg = 'invalid distance code';
	        state.mode = BAD;
	        break;
	      }
	      state.offset = here_val;
	      state.extra = (here_op) & 15;
	      state.mode = DISTEXT;
	      /* falls through */
	    case DISTEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	//#ifdef INFLATE_STRICT
	      if (state.offset > state.dmax) {
	        strm.msg = 'invalid distance too far back';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	      state.mode = MATCH;
	      /* falls through */
	    case MATCH:
	      if (left === 0) { break inf_leave; }
	      copy = _out - left;
	      if (state.offset > copy) {         /* copy from window */
	        copy = state.offset - copy;
	        if (copy > state.whave) {
	          if (state.sane) {
	            strm.msg = 'invalid distance too far back';
	            state.mode = BAD;
	            break;
	          }
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	        }
	        if (copy > state.wnext) {
	          copy -= state.wnext;
	          from = state.wsize - copy;
	        }
	        else {
	          from = state.wnext - copy;
	        }
	        if (copy > state.length) { copy = state.length; }
	        from_source = state.window;
	      }
	      else {                              /* copy from output */
	        from_source = output;
	        from = put - state.offset;
	        copy = state.length;
	      }
	      if (copy > left) { copy = left; }
	      left -= copy;
	      state.length -= copy;
	      do {
	        output[put++] = from_source[from++];
	      } while (--copy);
	      if (state.length === 0) { state.mode = LEN; }
	      break;
	    case LIT:
	      if (left === 0) { break inf_leave; }
	      output[put++] = state.length;
	      left--;
	      state.mode = LEN;
	      break;
	    case CHECK:
	      if (state.wrap) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          // Use '|' insdead of '+' to make sure that result is signed
	          hold |= input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        _out -= left;
	        strm.total_out += _out;
	        state.total += _out;
	        if (_out) {
	          strm.adler = state.check =
	              /*UPDATE(state.check, put - _out, _out);*/
	              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	        }
	        _out = left;
	        // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
	        if ((state.flags ? hold : zswap32(hold)) !== state.check) {
	          strm.msg = 'incorrect data check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   check matches trailer\n"));
	      }
	      state.mode = LENGTH;
	      /* falls through */
	    case LENGTH:
	      if (state.wrap && state.flags) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.total & 0xffffffff)) {
	          strm.msg = 'incorrect length check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   length matches trailer\n"));
	      }
	      state.mode = DONE;
	      /* falls through */
	    case DONE:
	      ret = Z_STREAM_END;
	      break inf_leave;
	    case BAD:
	      ret = Z_DATA_ERROR;
	      break inf_leave;
	    case MEM:
	      return Z_MEM_ERROR;
	    case SYNC:
	      /* falls through */
	    default:
	      return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	function inflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var state;
	  var dictid;
	  var ret;
	
	  /* check state */
	  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  if (state.wrap !== 0 && state.mode !== DICT) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* check for correct dictionary identifier */
	  if (state.mode === DICT) {
	    dictid = 1; /* adler32(0, null, 0)*/
	    /* dictid = adler32(dictid, dictionary, dictLength); */
	    dictid = adler32(dictid, dictionary, dictLength, 0);
	    if (dictid !== state.check) {
	      return Z_DATA_ERROR;
	    }
	  }
	  /* copy dictionary to window using updatewindow(), which will amend the
	   existing dictionary if appropriate */
	  ret = updatewindow(strm, dictionary, dictLength, dictLength);
	  if (ret) {
	    state.mode = MEM;
	    return Z_MEM_ERROR;
	  }
	  state.havedict = 1;
	  // Tracev((stderr, "inflate:   dictionary set\n"));
	  return Z_OK;
	}
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/


/***/ },
/* 1677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils = __webpack_require__(283);
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	    base = extra = work;    /* dummy value--not used */
	    end = 19;
	
	  } else if (type === LENS) {
	    base = lbase;
	    base_index -= 257;
	    extra = lext;
	    extra_index -= 257;
	    end = 256;
	
	  } else {                    /* DISTS */
	    base = dbase;
	    extra = dext;
	    end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  var i = 0;
	  /* process all codes and make table entries */
	  for (;;) {
	    i++;
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};


/***/ },
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils = __webpack_require__(283);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	/* eslint-disable comma-spacing,array-bracket-spacing */
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* eslint-enable comma-spacing,array-bracket-spacing */
	
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES + 2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	}
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	function TreeDesc(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	}
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short(s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n * 2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n - base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length - 1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
	        tree[m * 2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n * 2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES - 1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1 << extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length - 1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1 << extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for (; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES + 1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n * 2 + 1]/*.Len*/ = 5;
	    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n * 2;
	  var _m2 = m * 2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n * 2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node * 2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count - 3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count - 3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count - 11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes - 1,   5);
	  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES << 1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
	    static_lenb = (s.static_len + 3 + 7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc * 2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize - 1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;


/***/ },
/* 1679 */
/***/ function(module, exports) {

	'use strict';
	
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;


/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process, Buffer) {/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define("pdfjs-dist/build/pdf", [], factory);
		else if(typeof exports === 'object')
			exports["pdfjs-dist/build/pdf"] = factory();
		else
			root["pdfjs-dist/build/pdf"] = root.pdfjsDistBuildPdf = factory();
	})(typeof self !== 'undefined' ? self : this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __w_pdfjs_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__w_pdfjs_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__w_pdfjs_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__w_pdfjs_require__.d = function(exports, name, getter) {
	/******/ 		if(!__w_pdfjs_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__w_pdfjs_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__w_pdfjs_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__w_pdfjs_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__w_pdfjs_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __w_pdfjs_require__(__w_pdfjs_require__.s = 63);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unreachable = exports.warn = exports.utf8StringToString = exports.stringToUTF8String = exports.stringToPDFString = exports.stringToBytes = exports.string32 = exports.shadow = exports.setVerbosityLevel = exports.ReadableStream = exports.removeNullCharacters = exports.readUint32 = exports.readUint16 = exports.readInt8 = exports.log2 = exports.loadJpegStream = exports.isEvalSupported = exports.isLittleEndian = exports.createValidAbsoluteUrl = exports.isSameOrigin = exports.isSpace = exports.isString = exports.isNum = exports.isEmptyObj = exports.isBool = exports.isArrayBuffer = exports.info = exports.getVerbosityLevel = exports.getLookupTableFactory = exports.deprecated = exports.createObjectURL = exports.createPromiseCapability = exports.createBlob = exports.bytesToString = exports.assert = exports.arraysToBytes = exports.arrayByteLength = exports.FormatError = exports.XRefParseException = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.StreamType = exports.PasswordResponses = exports.PasswordException = exports.PageViewport = exports.NotImplementedException = exports.NativeImageDecoding = exports.MissingPDFException = exports.MissingDataException = exports.MessageHandler = exports.InvalidPDFException = exports.AbortException = exports.CMapCompressionType = exports.ImageKind = exports.FontType = exports.AnnotationType = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.UNSUPPORTED_FEATURES = exports.VERBOSITY_LEVELS = exports.OPS = exports.IDENTITY_MATRIX = exports.FONT_IDENTITY_MATRIX = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	__w_pdfjs_require__(64);
	
	var _streams_polyfill = __w_pdfjs_require__(113);
	
	var FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
	var NativeImageDecoding = {
	  NONE: 'none',
	  DECODE: 'decode',
	  DISPLAY: 'display'
	};
	var TextRenderingMode = {
	  FILL: 0,
	  STROKE: 1,
	  FILL_STROKE: 2,
	  INVISIBLE: 3,
	  FILL_ADD_TO_PATH: 4,
	  STROKE_ADD_TO_PATH: 5,
	  FILL_STROKE_ADD_TO_PATH: 6,
	  ADD_TO_PATH: 7,
	  FILL_STROKE_MASK: 3,
	  ADD_TO_PATH_FLAG: 4
	};
	var ImageKind = {
	  GRAYSCALE_1BPP: 1,
	  RGB_24BPP: 2,
	  RGBA_32BPP: 3
	};
	var AnnotationType = {
	  TEXT: 1,
	  LINK: 2,
	  FREETEXT: 3,
	  LINE: 4,
	  SQUARE: 5,
	  CIRCLE: 6,
	  POLYGON: 7,
	  POLYLINE: 8,
	  HIGHLIGHT: 9,
	  UNDERLINE: 10,
	  SQUIGGLY: 11,
	  STRIKEOUT: 12,
	  STAMP: 13,
	  CARET: 14,
	  INK: 15,
	  POPUP: 16,
	  FILEATTACHMENT: 17,
	  SOUND: 18,
	  MOVIE: 19,
	  WIDGET: 20,
	  SCREEN: 21,
	  PRINTERMARK: 22,
	  TRAPNET: 23,
	  WATERMARK: 24,
	  THREED: 25,
	  REDACT: 26
	};
	var AnnotationFlag = {
	  INVISIBLE: 0x01,
	  HIDDEN: 0x02,
	  PRINT: 0x04,
	  NOZOOM: 0x08,
	  NOROTATE: 0x10,
	  NOVIEW: 0x20,
	  READONLY: 0x40,
	  LOCKED: 0x80,
	  TOGGLENOVIEW: 0x100,
	  LOCKEDCONTENTS: 0x200
	};
	var AnnotationFieldFlag = {
	  READONLY: 0x0000001,
	  REQUIRED: 0x0000002,
	  NOEXPORT: 0x0000004,
	  MULTILINE: 0x0001000,
	  PASSWORD: 0x0002000,
	  NOTOGGLETOOFF: 0x0004000,
	  RADIO: 0x0008000,
	  PUSHBUTTON: 0x0010000,
	  COMBO: 0x0020000,
	  EDIT: 0x0040000,
	  SORT: 0x0080000,
	  FILESELECT: 0x0100000,
	  MULTISELECT: 0x0200000,
	  DONOTSPELLCHECK: 0x0400000,
	  DONOTSCROLL: 0x0800000,
	  COMB: 0x1000000,
	  RICHTEXT: 0x2000000,
	  RADIOSINUNISON: 0x2000000,
	  COMMITONSELCHANGE: 0x4000000
	};
	var AnnotationBorderStyleType = {
	  SOLID: 1,
	  DASHED: 2,
	  BEVELED: 3,
	  INSET: 4,
	  UNDERLINE: 5
	};
	var StreamType = {
	  UNKNOWN: 0,
	  FLATE: 1,
	  LZW: 2,
	  DCT: 3,
	  JPX: 4,
	  JBIG: 5,
	  A85: 6,
	  AHX: 7,
	  CCF: 8,
	  RL: 9
	};
	var FontType = {
	  UNKNOWN: 0,
	  TYPE1: 1,
	  TYPE1C: 2,
	  CIDFONTTYPE0: 3,
	  CIDFONTTYPE0C: 4,
	  TRUETYPE: 5,
	  CIDFONTTYPE2: 6,
	  TYPE3: 7,
	  OPENTYPE: 8,
	  TYPE0: 9,
	  MMTYPE1: 10
	};
	var VERBOSITY_LEVELS = {
	  errors: 0,
	  warnings: 1,
	  infos: 5
	};
	var CMapCompressionType = {
	  NONE: 0,
	  BINARY: 1,
	  STREAM: 2
	};
	var OPS = {
	  dependency: 1,
	  setLineWidth: 2,
	  setLineCap: 3,
	  setLineJoin: 4,
	  setMiterLimit: 5,
	  setDash: 6,
	  setRenderingIntent: 7,
	  setFlatness: 8,
	  setGState: 9,
	  save: 10,
	  restore: 11,
	  transform: 12,
	  moveTo: 13,
	  lineTo: 14,
	  curveTo: 15,
	  curveTo2: 16,
	  curveTo3: 17,
	  closePath: 18,
	  rectangle: 19,
	  stroke: 20,
	  closeStroke: 21,
	  fill: 22,
	  eoFill: 23,
	  fillStroke: 24,
	  eoFillStroke: 25,
	  closeFillStroke: 26,
	  closeEOFillStroke: 27,
	  endPath: 28,
	  clip: 29,
	  eoClip: 30,
	  beginText: 31,
	  endText: 32,
	  setCharSpacing: 33,
	  setWordSpacing: 34,
	  setHScale: 35,
	  setLeading: 36,
	  setFont: 37,
	  setTextRenderingMode: 38,
	  setTextRise: 39,
	  moveText: 40,
	  setLeadingMoveText: 41,
	  setTextMatrix: 42,
	  nextLine: 43,
	  showText: 44,
	  showSpacedText: 45,
	  nextLineShowText: 46,
	  nextLineSetSpacingShowText: 47,
	  setCharWidth: 48,
	  setCharWidthAndBounds: 49,
	  setStrokeColorSpace: 50,
	  setFillColorSpace: 51,
	  setStrokeColor: 52,
	  setStrokeColorN: 53,
	  setFillColor: 54,
	  setFillColorN: 55,
	  setStrokeGray: 56,
	  setFillGray: 57,
	  setStrokeRGBColor: 58,
	  setFillRGBColor: 59,
	  setStrokeCMYKColor: 60,
	  setFillCMYKColor: 61,
	  shadingFill: 62,
	  beginInlineImage: 63,
	  beginImageData: 64,
	  endInlineImage: 65,
	  paintXObject: 66,
	  markPoint: 67,
	  markPointProps: 68,
	  beginMarkedContent: 69,
	  beginMarkedContentProps: 70,
	  endMarkedContent: 71,
	  beginCompat: 72,
	  endCompat: 73,
	  paintFormXObjectBegin: 74,
	  paintFormXObjectEnd: 75,
	  beginGroup: 76,
	  endGroup: 77,
	  beginAnnotations: 78,
	  endAnnotations: 79,
	  beginAnnotation: 80,
	  endAnnotation: 81,
	  paintJpegXObject: 82,
	  paintImageMaskXObject: 83,
	  paintImageMaskXObjectGroup: 84,
	  paintImageXObject: 85,
	  paintInlineImageXObject: 86,
	  paintInlineImageXObjectGroup: 87,
	  paintImageXObjectRepeat: 88,
	  paintImageMaskXObjectRepeat: 89,
	  paintSolidColorImageMask: 90,
	  constructPath: 91
	};
	var verbosity = VERBOSITY_LEVELS.warnings;
	function setVerbosityLevel(level) {
	  verbosity = level;
	}
	function getVerbosityLevel() {
	  return verbosity;
	}
	function info(msg) {
	  if (verbosity >= VERBOSITY_LEVELS.infos) {
	    console.log('Info: ' + msg);
	  }
	}
	function warn(msg) {
	  if (verbosity >= VERBOSITY_LEVELS.warnings) {
	    console.log('Warning: ' + msg);
	  }
	}
	function deprecated(details) {
	  console.log('Deprecated API usage: ' + details);
	}
	function unreachable(msg) {
	  throw new Error(msg);
	}
	function assert(cond, msg) {
	  if (!cond) {
	    unreachable(msg);
	  }
	}
	var UNSUPPORTED_FEATURES = {
	  unknown: 'unknown',
	  forms: 'forms',
	  javaScript: 'javaScript',
	  smask: 'smask',
	  shadingPattern: 'shadingPattern',
	  font: 'font'
	};
	function isSameOrigin(baseUrl, otherUrl) {
	  try {
	    var base = new URL(baseUrl);
	    if (!base.origin || base.origin === 'null') {
	      return false;
	    }
	  } catch (e) {
	    return false;
	  }
	  var other = new URL(otherUrl, base);
	  return base.origin === other.origin;
	}
	function isValidProtocol(url) {
	  if (!url) {
	    return false;
	  }
	  switch (url.protocol) {
	    case 'http:':
	    case 'https:':
	    case 'ftp:':
	    case 'mailto:':
	    case 'tel:':
	      return true;
	    default:
	      return false;
	  }
	}
	function createValidAbsoluteUrl(url, baseUrl) {
	  if (!url) {
	    return null;
	  }
	  try {
	    var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
	    if (isValidProtocol(absoluteUrl)) {
	      return absoluteUrl;
	    }
	  } catch (ex) {}
	  return null;
	}
	function shadow(obj, prop, value) {
	  Object.defineProperty(obj, prop, {
	    value: value,
	    enumerable: true,
	    configurable: true,
	    writable: false
	  });
	  return value;
	}
	function getLookupTableFactory(initializer) {
	  var lookup;
	  return function () {
	    if (initializer) {
	      lookup = Object.create(null);
	      initializer(lookup);
	      initializer = null;
	    }
	    return lookup;
	  };
	}
	var PasswordResponses = {
	  NEED_PASSWORD: 1,
	  INCORRECT_PASSWORD: 2
	};
	var PasswordException = function PasswordExceptionClosure() {
	  function PasswordException(msg, code) {
	    this.name = 'PasswordException';
	    this.message = msg;
	    this.code = code;
	  }
	  PasswordException.prototype = new Error();
	  PasswordException.constructor = PasswordException;
	  return PasswordException;
	}();
	var UnknownErrorException = function UnknownErrorExceptionClosure() {
	  function UnknownErrorException(msg, details) {
	    this.name = 'UnknownErrorException';
	    this.message = msg;
	    this.details = details;
	  }
	  UnknownErrorException.prototype = new Error();
	  UnknownErrorException.constructor = UnknownErrorException;
	  return UnknownErrorException;
	}();
	var InvalidPDFException = function InvalidPDFExceptionClosure() {
	  function InvalidPDFException(msg) {
	    this.name = 'InvalidPDFException';
	    this.message = msg;
	  }
	  InvalidPDFException.prototype = new Error();
	  InvalidPDFException.constructor = InvalidPDFException;
	  return InvalidPDFException;
	}();
	var MissingPDFException = function MissingPDFExceptionClosure() {
	  function MissingPDFException(msg) {
	    this.name = 'MissingPDFException';
	    this.message = msg;
	  }
	  MissingPDFException.prototype = new Error();
	  MissingPDFException.constructor = MissingPDFException;
	  return MissingPDFException;
	}();
	var UnexpectedResponseException = function UnexpectedResponseExceptionClosure() {
	  function UnexpectedResponseException(msg, status) {
	    this.name = 'UnexpectedResponseException';
	    this.message = msg;
	    this.status = status;
	  }
	  UnexpectedResponseException.prototype = new Error();
	  UnexpectedResponseException.constructor = UnexpectedResponseException;
	  return UnexpectedResponseException;
	}();
	var NotImplementedException = function NotImplementedExceptionClosure() {
	  function NotImplementedException(msg) {
	    this.message = msg;
	  }
	  NotImplementedException.prototype = new Error();
	  NotImplementedException.prototype.name = 'NotImplementedException';
	  NotImplementedException.constructor = NotImplementedException;
	  return NotImplementedException;
	}();
	var MissingDataException = function MissingDataExceptionClosure() {
	  function MissingDataException(begin, end) {
	    this.begin = begin;
	    this.end = end;
	    this.message = 'Missing data [' + begin + ', ' + end + ')';
	  }
	  MissingDataException.prototype = new Error();
	  MissingDataException.prototype.name = 'MissingDataException';
	  MissingDataException.constructor = MissingDataException;
	  return MissingDataException;
	}();
	var XRefParseException = function XRefParseExceptionClosure() {
	  function XRefParseException(msg) {
	    this.message = msg;
	  }
	  XRefParseException.prototype = new Error();
	  XRefParseException.prototype.name = 'XRefParseException';
	  XRefParseException.constructor = XRefParseException;
	  return XRefParseException;
	}();
	var FormatError = function FormatErrorClosure() {
	  function FormatError(msg) {
	    this.message = msg;
	  }
	  FormatError.prototype = new Error();
	  FormatError.prototype.name = 'FormatError';
	  FormatError.constructor = FormatError;
	  return FormatError;
	}();
	var AbortException = function AbortExceptionClosure() {
	  function AbortException(msg) {
	    this.name = 'AbortException';
	    this.message = msg;
	  }
	  AbortException.prototype = new Error();
	  AbortException.constructor = AbortException;
	  return AbortException;
	}();
	var NullCharactersRegExp = /\x00/g;
	function removeNullCharacters(str) {
	  if (typeof str !== 'string') {
	    warn('The argument for removeNullCharacters must be a string.');
	    return str;
	  }
	  return str.replace(NullCharactersRegExp, '');
	}
	function bytesToString(bytes) {
	  assert(bytes !== null && (typeof bytes === 'undefined' ? 'undefined' : _typeof(bytes)) === 'object' && bytes.length !== undefined, 'Invalid argument for bytesToString');
	  var length = bytes.length;
	  var MAX_ARGUMENT_COUNT = 8192;
	  if (length < MAX_ARGUMENT_COUNT) {
	    return String.fromCharCode.apply(null, bytes);
	  }
	  var strBuf = [];
	  for (var i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
	    var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
	    var chunk = bytes.subarray(i, chunkEnd);
	    strBuf.push(String.fromCharCode.apply(null, chunk));
	  }
	  return strBuf.join('');
	}
	function stringToBytes(str) {
	  assert(typeof str === 'string', 'Invalid argument for stringToBytes');
	  var length = str.length;
	  var bytes = new Uint8Array(length);
	  for (var i = 0; i < length; ++i) {
	    bytes[i] = str.charCodeAt(i) & 0xFF;
	  }
	  return bytes;
	}
	function arrayByteLength(arr) {
	  if (arr.length !== undefined) {
	    return arr.length;
	  }
	  assert(arr.byteLength !== undefined);
	  return arr.byteLength;
	}
	function arraysToBytes(arr) {
	  if (arr.length === 1 && arr[0] instanceof Uint8Array) {
	    return arr[0];
	  }
	  var resultLength = 0;
	  var i,
	      ii = arr.length;
	  var item, itemLength;
	  for (i = 0; i < ii; i++) {
	    item = arr[i];
	    itemLength = arrayByteLength(item);
	    resultLength += itemLength;
	  }
	  var pos = 0;
	  var data = new Uint8Array(resultLength);
	  for (i = 0; i < ii; i++) {
	    item = arr[i];
	    if (!(item instanceof Uint8Array)) {
	      if (typeof item === 'string') {
	        item = stringToBytes(item);
	      } else {
	        item = new Uint8Array(item);
	      }
	    }
	    itemLength = item.byteLength;
	    data.set(item, pos);
	    pos += itemLength;
	  }
	  return data;
	}
	function string32(value) {
	  return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
	}
	function log2(x) {
	  if (x <= 0) {
	    return 0;
	  }
	  return Math.ceil(Math.log2(x));
	}
	function readInt8(data, start) {
	  return data[start] << 24 >> 24;
	}
	function readUint16(data, offset) {
	  return data[offset] << 8 | data[offset + 1];
	}
	function readUint32(data, offset) {
	  return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
	}
	function isLittleEndian() {
	  var buffer8 = new Uint8Array(4);
	  buffer8[0] = 1;
	  var view32 = new Uint32Array(buffer8.buffer, 0, 1);
	  return view32[0] === 1;
	}
	function isEvalSupported() {
	  try {
	    new Function('');
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	var IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
	var Util = function UtilClosure() {
	  function Util() {}
	  var rgbBuf = ['rgb(', 0, ',', 0, ',', 0, ')'];
	  Util.makeCssRgb = function Util_makeCssRgb(r, g, b) {
	    rgbBuf[1] = r;
	    rgbBuf[3] = g;
	    rgbBuf[5] = b;
	    return rgbBuf.join('');
	  };
	  Util.transform = function Util_transform(m1, m2) {
	    return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
	  };
	  Util.applyTransform = function Util_applyTransform(p, m) {
	    var xt = p[0] * m[0] + p[1] * m[2] + m[4];
	    var yt = p[0] * m[1] + p[1] * m[3] + m[5];
	    return [xt, yt];
	  };
	  Util.applyInverseTransform = function Util_applyInverseTransform(p, m) {
	    var d = m[0] * m[3] - m[1] * m[2];
	    var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
	    var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
	    return [xt, yt];
	  };
	  Util.getAxialAlignedBoundingBox = function Util_getAxialAlignedBoundingBox(r, m) {
	    var p1 = Util.applyTransform(r, m);
	    var p2 = Util.applyTransform(r.slice(2, 4), m);
	    var p3 = Util.applyTransform([r[0], r[3]], m);
	    var p4 = Util.applyTransform([r[2], r[1]], m);
	    return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
	  };
	  Util.inverseTransform = function Util_inverseTransform(m) {
	    var d = m[0] * m[3] - m[1] * m[2];
	    return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
	  };
	  Util.apply3dTransform = function Util_apply3dTransform(m, v) {
	    return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]];
	  };
	  Util.singularValueDecompose2dScale = function Util_singularValueDecompose2dScale(m) {
	    var transpose = [m[0], m[2], m[1], m[3]];
	    var a = m[0] * transpose[0] + m[1] * transpose[2];
	    var b = m[0] * transpose[1] + m[1] * transpose[3];
	    var c = m[2] * transpose[0] + m[3] * transpose[2];
	    var d = m[2] * transpose[1] + m[3] * transpose[3];
	    var first = (a + d) / 2;
	    var second = Math.sqrt((a + d) * (a + d) - 4 * (a * d - c * b)) / 2;
	    var sx = first + second || 1;
	    var sy = first - second || 1;
	    return [Math.sqrt(sx), Math.sqrt(sy)];
	  };
	  Util.normalizeRect = function Util_normalizeRect(rect) {
	    var r = rect.slice(0);
	    if (rect[0] > rect[2]) {
	      r[0] = rect[2];
	      r[2] = rect[0];
	    }
	    if (rect[1] > rect[3]) {
	      r[1] = rect[3];
	      r[3] = rect[1];
	    }
	    return r;
	  };
	  Util.intersect = function Util_intersect(rect1, rect2) {
	    function compare(a, b) {
	      return a - b;
	    }
	    var orderedX = [rect1[0], rect1[2], rect2[0], rect2[2]].sort(compare),
	        orderedY = [rect1[1], rect1[3], rect2[1], rect2[3]].sort(compare),
	        result = [];
	    rect1 = Util.normalizeRect(rect1);
	    rect2 = Util.normalizeRect(rect2);
	    if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
	      result[0] = orderedX[1];
	      result[2] = orderedX[2];
	    } else {
	      return false;
	    }
	    if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
	      result[1] = orderedY[1];
	      result[3] = orderedY[2];
	    } else {
	      return false;
	    }
	    return result;
	  };
	  var ROMAN_NUMBER_MAP = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM', '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC', '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
	  Util.toRoman = function Util_toRoman(number, lowerCase) {
	    assert(Number.isInteger(number) && number > 0, 'The number should be a positive integer.');
	    var pos,
	        romanBuf = [];
	    while (number >= 1000) {
	      number -= 1000;
	      romanBuf.push('M');
	    }
	    pos = number / 100 | 0;
	    number %= 100;
	    romanBuf.push(ROMAN_NUMBER_MAP[pos]);
	    pos = number / 10 | 0;
	    number %= 10;
	    romanBuf.push(ROMAN_NUMBER_MAP[10 + pos]);
	    romanBuf.push(ROMAN_NUMBER_MAP[20 + number]);
	    var romanStr = romanBuf.join('');
	    return lowerCase ? romanStr.toLowerCase() : romanStr;
	  };
	  Util.appendToArray = function Util_appendToArray(arr1, arr2) {
	    Array.prototype.push.apply(arr1, arr2);
	  };
	  Util.prependToArray = function Util_prependToArray(arr1, arr2) {
	    Array.prototype.unshift.apply(arr1, arr2);
	  };
	  Util.extendObj = function extendObj(obj1, obj2) {
	    for (var key in obj2) {
	      obj1[key] = obj2[key];
	    }
	  };
	  Util.getInheritableProperty = function Util_getInheritableProperty(dict, name, getArray) {
	    while (dict && !dict.has(name)) {
	      dict = dict.get('Parent');
	    }
	    if (!dict) {
	      return null;
	    }
	    return getArray ? dict.getArray(name) : dict.get(name);
	  };
	  Util.inherit = function Util_inherit(sub, base, prototype) {
	    sub.prototype = Object.create(base.prototype);
	    sub.prototype.constructor = sub;
	    for (var prop in prototype) {
	      sub.prototype[prop] = prototype[prop];
	    }
	  };
	  Util.loadScript = function Util_loadScript(src, callback) {
	    var script = document.createElement('script');
	    var loaded = false;
	    script.setAttribute('src', src);
	    if (callback) {
	      script.onload = function () {
	        if (!loaded) {
	          callback();
	        }
	        loaded = true;
	      };
	    }
	    document.getElementsByTagName('head')[0].appendChild(script);
	  };
	  return Util;
	}();
	var PageViewport = function PageViewportClosure() {
	  function PageViewport(viewBox, scale, rotation, offsetX, offsetY, dontFlip) {
	    this.viewBox = viewBox;
	    this.scale = scale;
	    this.rotation = rotation;
	    this.offsetX = offsetX;
	    this.offsetY = offsetY;
	    var centerX = (viewBox[2] + viewBox[0]) / 2;
	    var centerY = (viewBox[3] + viewBox[1]) / 2;
	    var rotateA, rotateB, rotateC, rotateD;
	    rotation = rotation % 360;
	    rotation = rotation < 0 ? rotation + 360 : rotation;
	    switch (rotation) {
	      case 180:
	        rotateA = -1;
	        rotateB = 0;
	        rotateC = 0;
	        rotateD = 1;
	        break;
	      case 90:
	        rotateA = 0;
	        rotateB = 1;
	        rotateC = 1;
	        rotateD = 0;
	        break;
	      case 270:
	        rotateA = 0;
	        rotateB = -1;
	        rotateC = -1;
	        rotateD = 0;
	        break;
	      default:
	        rotateA = 1;
	        rotateB = 0;
	        rotateC = 0;
	        rotateD = -1;
	        break;
	    }
	    if (dontFlip) {
	      rotateC = -rotateC;
	      rotateD = -rotateD;
	    }
	    var offsetCanvasX, offsetCanvasY;
	    var width, height;
	    if (rotateA === 0) {
	      offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
	      offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
	      width = Math.abs(viewBox[3] - viewBox[1]) * scale;
	      height = Math.abs(viewBox[2] - viewBox[0]) * scale;
	    } else {
	      offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
	      offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
	      width = Math.abs(viewBox[2] - viewBox[0]) * scale;
	      height = Math.abs(viewBox[3] - viewBox[1]) * scale;
	    }
	    this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
	    this.width = width;
	    this.height = height;
	    this.fontScale = scale;
	  }
	  PageViewport.prototype = {
	    clone: function PageViewPort_clone(args) {
	      args = args || {};
	      var scale = 'scale' in args ? args.scale : this.scale;
	      var rotation = 'rotation' in args ? args.rotation : this.rotation;
	      return new PageViewport(this.viewBox.slice(), scale, rotation, this.offsetX, this.offsetY, args.dontFlip);
	    },
	    convertToViewportPoint: function PageViewport_convertToViewportPoint(x, y) {
	      return Util.applyTransform([x, y], this.transform);
	    },
	    convertToViewportRectangle: function PageViewport_convertToViewportRectangle(rect) {
	      var tl = Util.applyTransform([rect[0], rect[1]], this.transform);
	      var br = Util.applyTransform([rect[2], rect[3]], this.transform);
	      return [tl[0], tl[1], br[0], br[1]];
	    },
	    convertToPdfPoint: function PageViewport_convertToPdfPoint(x, y) {
	      return Util.applyInverseTransform([x, y], this.transform);
	    }
	  };
	  return PageViewport;
	}();
	var PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2D8, 0x2C7, 0x2C6, 0x2D9, 0x2DD, 0x2DB, 0x2DA, 0x2DC, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203A, 0x2212, 0x2030, 0x201E, 0x201C, 0x201D, 0x2018, 0x2019, 0x201A, 0x2122, 0xFB01, 0xFB02, 0x141, 0x152, 0x160, 0x178, 0x17D, 0x131, 0x142, 0x153, 0x161, 0x17E, 0, 0x20AC];
	function stringToPDFString(str) {
	  var i,
	      n = str.length,
	      strBuf = [];
	  if (str[0] === '\xFE' && str[1] === '\xFF') {
	    for (i = 2; i < n; i += 2) {
	      strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
	    }
	  } else {
	    for (i = 0; i < n; ++i) {
	      var code = PDFStringTranslateTable[str.charCodeAt(i)];
	      strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
	    }
	  }
	  return strBuf.join('');
	}
	function stringToUTF8String(str) {
	  return decodeURIComponent(escape(str));
	}
	function utf8StringToString(str) {
	  return unescape(encodeURIComponent(str));
	}
	function isEmptyObj(obj) {
	  for (var key in obj) {
	    return false;
	  }
	  return true;
	}
	function isBool(v) {
	  return typeof v === 'boolean';
	}
	function isNum(v) {
	  return typeof v === 'number';
	}
	function isString(v) {
	  return typeof v === 'string';
	}
	function isArrayBuffer(v) {
	  return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v !== null && v.byteLength !== undefined;
	}
	function isSpace(ch) {
	  return ch === 0x20 || ch === 0x09 || ch === 0x0D || ch === 0x0A;
	}
	function createPromiseCapability() {
	  var capability = {};
	  capability.promise = new Promise(function (resolve, reject) {
	    capability.resolve = resolve;
	    capability.reject = reject;
	  });
	  return capability;
	}
	var createBlob = function createBlob(data, contentType) {
	  if (typeof Blob !== 'undefined') {
	    return new Blob([data], { type: contentType });
	  }
	  throw new Error('The "Blob" constructor is not supported.');
	};
	var createObjectURL = function createObjectURLClosure() {
	  var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	  return function createObjectURL(data, contentType) {
	    var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    if (!forceDataSchema && URL.createObjectURL) {
	      var blob = createBlob(data, contentType);
	      return URL.createObjectURL(blob);
	    }
	    var buffer = 'data:' + contentType + ';base64,';
	    for (var i = 0, ii = data.length; i < ii; i += 3) {
	      var b1 = data[i] & 0xFF;
	      var b2 = data[i + 1] & 0xFF;
	      var b3 = data[i + 2] & 0xFF;
	      var d1 = b1 >> 2,
	          d2 = (b1 & 3) << 4 | b2 >> 4;
	      var d3 = i + 1 < ii ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
	      var d4 = i + 2 < ii ? b3 & 0x3F : 64;
	      buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
	    }
	    return buffer;
	  };
	}();
	function resolveCall(fn, args) {
	  var thisArg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  if (!fn) {
	    return Promise.resolve(undefined);
	  }
	  return new Promise(function (resolve, reject) {
	    resolve(fn.apply(thisArg, args));
	  });
	}
	function wrapReason(reason) {
	  if ((typeof reason === 'undefined' ? 'undefined' : _typeof(reason)) !== 'object') {
	    return reason;
	  }
	  switch (reason.name) {
	    case 'AbortException':
	      return new AbortException(reason.message);
	    case 'MissingPDFException':
	      return new MissingPDFException(reason.message);
	    case 'UnexpectedResponseException':
	      return new UnexpectedResponseException(reason.message, reason.status);
	    default:
	      return new UnknownErrorException(reason.message, reason.details);
	  }
	}
	function makeReasonSerializable(reason) {
	  if (!(reason instanceof Error) || reason instanceof AbortException || reason instanceof MissingPDFException || reason instanceof UnexpectedResponseException || reason instanceof UnknownErrorException) {
	    return reason;
	  }
	  return new UnknownErrorException(reason.message, reason.toString());
	}
	function resolveOrReject(capability, success, reason) {
	  if (success) {
	    capability.resolve();
	  } else {
	    capability.reject(reason);
	  }
	}
	function finalize(promise) {
	  return Promise.resolve(promise).catch(function () {});
	}
	function MessageHandler(sourceName, targetName, comObj) {
	  var _this = this;
	
	  this.sourceName = sourceName;
	  this.targetName = targetName;
	  this.comObj = comObj;
	  this.callbackId = 1;
	  this.streamId = 1;
	  this.postMessageTransfers = true;
	  this.streamSinks = Object.create(null);
	  this.streamControllers = Object.create(null);
	  var callbacksCapabilities = this.callbacksCapabilities = Object.create(null);
	  var ah = this.actionHandler = Object.create(null);
	  this._onComObjOnMessage = function (event) {
	    var data = event.data;
	    if (data.targetName !== _this.sourceName) {
	      return;
	    }
	    if (data.stream) {
	      _this._processStreamMessage(data);
	    } else if (data.isReply) {
	      var callbackId = data.callbackId;
	      if (data.callbackId in callbacksCapabilities) {
	        var callback = callbacksCapabilities[callbackId];
	        delete callbacksCapabilities[callbackId];
	        if ('error' in data) {
	          callback.reject(wrapReason(data.error));
	        } else {
	          callback.resolve(data.data);
	        }
	      } else {
	        throw new Error('Cannot resolve callback ' + callbackId);
	      }
	    } else if (data.action in ah) {
	      var action = ah[data.action];
	      if (data.callbackId) {
	        var _sourceName = _this.sourceName;
	        var _targetName = data.sourceName;
	        Promise.resolve().then(function () {
	          return action[0].call(action[1], data.data);
	        }).then(function (result) {
	          comObj.postMessage({
	            sourceName: _sourceName,
	            targetName: _targetName,
	            isReply: true,
	            callbackId: data.callbackId,
	            data: result
	          });
	        }, function (reason) {
	          comObj.postMessage({
	            sourceName: _sourceName,
	            targetName: _targetName,
	            isReply: true,
	            callbackId: data.callbackId,
	            error: makeReasonSerializable(reason)
	          });
	        });
	      } else if (data.streamId) {
	        _this._createStreamSink(data);
	      } else {
	        action[0].call(action[1], data.data);
	      }
	    } else {
	      throw new Error('Unknown action from worker: ' + data.action);
	    }
	  };
	  comObj.addEventListener('message', this._onComObjOnMessage);
	}
	MessageHandler.prototype = {
	  on: function on(actionName, handler, scope) {
	    var ah = this.actionHandler;
	    if (ah[actionName]) {
	      throw new Error('There is already an actionName called "' + actionName + '"');
	    }
	    ah[actionName] = [handler, scope];
	  },
	  send: function send(actionName, data, transfers) {
	    var message = {
	      sourceName: this.sourceName,
	      targetName: this.targetName,
	      action: actionName,
	      data: data
	    };
	    this.postMessage(message, transfers);
	  },
	  sendWithPromise: function sendWithPromise(actionName, data, transfers) {
	    var callbackId = this.callbackId++;
	    var message = {
	      sourceName: this.sourceName,
	      targetName: this.targetName,
	      action: actionName,
	      data: data,
	      callbackId: callbackId
	    };
	    var capability = createPromiseCapability();
	    this.callbacksCapabilities[callbackId] = capability;
	    try {
	      this.postMessage(message, transfers);
	    } catch (e) {
	      capability.reject(e);
	    }
	    return capability.promise;
	  },
	  sendWithStream: function sendWithStream(actionName, data, queueingStrategy, transfers) {
	    var _this2 = this;
	
	    var streamId = this.streamId++;
	    var sourceName = this.sourceName;
	    var targetName = this.targetName;
	    return new _streams_polyfill.ReadableStream({
	      start: function start(controller) {
	        var startCapability = createPromiseCapability();
	        _this2.streamControllers[streamId] = {
	          controller: controller,
	          startCall: startCapability,
	          isClosed: false
	        };
	        _this2.postMessage({
	          sourceName: sourceName,
	          targetName: targetName,
	          action: actionName,
	          streamId: streamId,
	          data: data,
	          desiredSize: controller.desiredSize
	        });
	        return startCapability.promise;
	      },
	      pull: function pull(controller) {
	        var pullCapability = createPromiseCapability();
	        _this2.streamControllers[streamId].pullCall = pullCapability;
	        _this2.postMessage({
	          sourceName: sourceName,
	          targetName: targetName,
	          stream: 'pull',
	          streamId: streamId,
	          desiredSize: controller.desiredSize
	        });
	        return pullCapability.promise;
	      },
	      cancel: function cancel(reason) {
	        var cancelCapability = createPromiseCapability();
	        _this2.streamControllers[streamId].cancelCall = cancelCapability;
	        _this2.streamControllers[streamId].isClosed = true;
	        _this2.postMessage({
	          sourceName: sourceName,
	          targetName: targetName,
	          stream: 'cancel',
	          reason: reason,
	          streamId: streamId
	        });
	        return cancelCapability.promise;
	      }
	    }, queueingStrategy);
	  },
	  _createStreamSink: function _createStreamSink(data) {
	    var _this3 = this;
	
	    var self = this;
	    var action = this.actionHandler[data.action];
	    var streamId = data.streamId;
	    var desiredSize = data.desiredSize;
	    var sourceName = this.sourceName;
	    var targetName = data.sourceName;
	    var capability = createPromiseCapability();
	    var sendStreamRequest = function sendStreamRequest(_ref) {
	      var stream = _ref.stream,
	          chunk = _ref.chunk,
	          transfers = _ref.transfers,
	          success = _ref.success,
	          reason = _ref.reason;
	
	      _this3.postMessage({
	        sourceName: sourceName,
	        targetName: targetName,
	        stream: stream,
	        streamId: streamId,
	        chunk: chunk,
	        success: success,
	        reason: reason
	      }, transfers);
	    };
	    var streamSink = {
	      enqueue: function enqueue(chunk) {
	        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	        var transfers = arguments[2];
	
	        if (this.isCancelled) {
	          return;
	        }
	        var lastDesiredSize = this.desiredSize;
	        this.desiredSize -= size;
	        if (lastDesiredSize > 0 && this.desiredSize <= 0) {
	          this.sinkCapability = createPromiseCapability();
	          this.ready = this.sinkCapability.promise;
	        }
	        sendStreamRequest({
	          stream: 'enqueue',
	          chunk: chunk,
	          transfers: transfers
	        });
	      },
	      close: function close() {
	        if (this.isCancelled) {
	          return;
	        }
	        this.isCancelled = true;
	        sendStreamRequest({ stream: 'close' });
	        delete self.streamSinks[streamId];
	      },
	      error: function error(reason) {
	        if (this.isCancelled) {
	          return;
	        }
	        this.isCancelled = true;
	        sendStreamRequest({
	          stream: 'error',
	          reason: reason
	        });
	      },
	
	      sinkCapability: capability,
	      onPull: null,
	      onCancel: null,
	      isCancelled: false,
	      desiredSize: desiredSize,
	      ready: null
	    };
	    streamSink.sinkCapability.resolve();
	    streamSink.ready = streamSink.sinkCapability.promise;
	    this.streamSinks[streamId] = streamSink;
	    resolveCall(action[0], [data.data, streamSink], action[1]).then(function () {
	      sendStreamRequest({
	        stream: 'start_complete',
	        success: true
	      });
	    }, function (reason) {
	      sendStreamRequest({
	        stream: 'start_complete',
	        success: false,
	        reason: reason
	      });
	    });
	  },
	  _processStreamMessage: function _processStreamMessage(data) {
	    var _this4 = this;
	
	    var sourceName = this.sourceName;
	    var targetName = data.sourceName;
	    var streamId = data.streamId;
	    var sendStreamResponse = function sendStreamResponse(_ref2) {
	      var stream = _ref2.stream,
	          success = _ref2.success,
	          reason = _ref2.reason;
	
	      _this4.comObj.postMessage({
	        sourceName: sourceName,
	        targetName: targetName,
	        stream: stream,
	        success: success,
	        streamId: streamId,
	        reason: reason
	      });
	    };
	    var deleteStreamController = function deleteStreamController() {
	      Promise.all([_this4.streamControllers[data.streamId].startCall, _this4.streamControllers[data.streamId].pullCall, _this4.streamControllers[data.streamId].cancelCall].map(function (capability) {
	        return capability && finalize(capability.promise);
	      })).then(function () {
	        delete _this4.streamControllers[data.streamId];
	      });
	    };
	    switch (data.stream) {
	      case 'start_complete':
	        resolveOrReject(this.streamControllers[data.streamId].startCall, data.success, wrapReason(data.reason));
	        break;
	      case 'pull_complete':
	        resolveOrReject(this.streamControllers[data.streamId].pullCall, data.success, wrapReason(data.reason));
	        break;
	      case 'pull':
	        if (!this.streamSinks[data.streamId]) {
	          sendStreamResponse({
	            stream: 'pull_complete',
	            success: true
	          });
	          break;
	        }
	        if (this.streamSinks[data.streamId].desiredSize <= 0 && data.desiredSize > 0) {
	          this.streamSinks[data.streamId].sinkCapability.resolve();
	        }
	        this.streamSinks[data.streamId].desiredSize = data.desiredSize;
	        resolveCall(this.streamSinks[data.streamId].onPull).then(function () {
	          sendStreamResponse({
	            stream: 'pull_complete',
	            success: true
	          });
	        }, function (reason) {
	          sendStreamResponse({
	            stream: 'pull_complete',
	            success: false,
	            reason: reason
	          });
	        });
	        break;
	      case 'enqueue':
	        assert(this.streamControllers[data.streamId], 'enqueue should have stream controller');
	        if (!this.streamControllers[data.streamId].isClosed) {
	          this.streamControllers[data.streamId].controller.enqueue(data.chunk);
	        }
	        break;
	      case 'close':
	        assert(this.streamControllers[data.streamId], 'close should have stream controller');
	        if (this.streamControllers[data.streamId].isClosed) {
	          break;
	        }
	        this.streamControllers[data.streamId].isClosed = true;
	        this.streamControllers[data.streamId].controller.close();
	        deleteStreamController();
	        break;
	      case 'error':
	        assert(this.streamControllers[data.streamId], 'error should have stream controller');
	        this.streamControllers[data.streamId].controller.error(wrapReason(data.reason));
	        deleteStreamController();
	        break;
	      case 'cancel_complete':
	        resolveOrReject(this.streamControllers[data.streamId].cancelCall, data.success, wrapReason(data.reason));
	        deleteStreamController();
	        break;
	      case 'cancel':
	        if (!this.streamSinks[data.streamId]) {
	          break;
	        }
	        resolveCall(this.streamSinks[data.streamId].onCancel, [wrapReason(data.reason)]).then(function () {
	          sendStreamResponse({
	            stream: 'cancel_complete',
	            success: true
	          });
	        }, function (reason) {
	          sendStreamResponse({
	            stream: 'cancel_complete',
	            success: false,
	            reason: reason
	          });
	        });
	        this.streamSinks[data.streamId].sinkCapability.reject(wrapReason(data.reason));
	        this.streamSinks[data.streamId].isCancelled = true;
	        delete this.streamSinks[data.streamId];
	        break;
	      default:
	        throw new Error('Unexpected stream case');
	    }
	  },
	  postMessage: function postMessage(message, transfers) {
	    if (transfers && this.postMessageTransfers) {
	      this.comObj.postMessage(message, transfers);
	    } else {
	      this.comObj.postMessage(message);
	    }
	  },
	  destroy: function destroy() {
	    this.comObj.removeEventListener('message', this._onComObjOnMessage);
	  }
	};
	function loadJpegStream(id, imageUrl, objs) {
	  var img = new Image();
	  img.onload = function loadJpegStream_onloadClosure() {
	    objs.resolve(id, img);
	  };
	  img.onerror = function loadJpegStream_onerrorClosure() {
	    objs.resolve(id, null);
	    warn('Error during JPEG image loading');
	  };
	  img.src = imageUrl;
	}
	exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
	exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
	exports.OPS = OPS;
	exports.VERBOSITY_LEVELS = VERBOSITY_LEVELS;
	exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
	exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
	exports.AnnotationFieldFlag = AnnotationFieldFlag;
	exports.AnnotationFlag = AnnotationFlag;
	exports.AnnotationType = AnnotationType;
	exports.FontType = FontType;
	exports.ImageKind = ImageKind;
	exports.CMapCompressionType = CMapCompressionType;
	exports.AbortException = AbortException;
	exports.InvalidPDFException = InvalidPDFException;
	exports.MessageHandler = MessageHandler;
	exports.MissingDataException = MissingDataException;
	exports.MissingPDFException = MissingPDFException;
	exports.NativeImageDecoding = NativeImageDecoding;
	exports.NotImplementedException = NotImplementedException;
	exports.PageViewport = PageViewport;
	exports.PasswordException = PasswordException;
	exports.PasswordResponses = PasswordResponses;
	exports.StreamType = StreamType;
	exports.TextRenderingMode = TextRenderingMode;
	exports.UnexpectedResponseException = UnexpectedResponseException;
	exports.UnknownErrorException = UnknownErrorException;
	exports.Util = Util;
	exports.XRefParseException = XRefParseException;
	exports.FormatError = FormatError;
	exports.arrayByteLength = arrayByteLength;
	exports.arraysToBytes = arraysToBytes;
	exports.assert = assert;
	exports.bytesToString = bytesToString;
	exports.createBlob = createBlob;
	exports.createPromiseCapability = createPromiseCapability;
	exports.createObjectURL = createObjectURL;
	exports.deprecated = deprecated;
	exports.getLookupTableFactory = getLookupTableFactory;
	exports.getVerbosityLevel = getVerbosityLevel;
	exports.info = info;
	exports.isArrayBuffer = isArrayBuffer;
	exports.isBool = isBool;
	exports.isEmptyObj = isEmptyObj;
	exports.isNum = isNum;
	exports.isString = isString;
	exports.isSpace = isSpace;
	exports.isSameOrigin = isSameOrigin;
	exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
	exports.isLittleEndian = isLittleEndian;
	exports.isEvalSupported = isEvalSupported;
	exports.loadJpegStream = loadJpegStream;
	exports.log2 = log2;
	exports.readInt8 = readInt8;
	exports.readUint16 = readUint16;
	exports.readUint32 = readUint32;
	exports.removeNullCharacters = removeNullCharacters;
	exports.ReadableStream = _streams_polyfill.ReadableStream;
	exports.setVerbosityLevel = setVerbosityLevel;
	exports.shadow = shadow;
	exports.string32 = string32;
	exports.stringToBytes = stringToBytes;
	exports.stringToPDFString = stringToPDFString;
	exports.stringToUTF8String = stringToUTF8String;
	exports.utf8StringToString = utf8StringToString;
	exports.warn = warn;
	exports.unreachable = unreachable;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	module.exports = function (it) {
	  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
	};
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var store = __w_pdfjs_require__(44)('wks');
	var uid = __w_pdfjs_require__(20);
	var _Symbol = __w_pdfjs_require__(3).Symbol;
	var USE_SYMBOL = typeof _Symbol == 'function';
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
	};
	$exports.store = store;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if (typeof __g == 'number') __g = global;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(3);
	var core = __w_pdfjs_require__(5);
	var hide = __w_pdfjs_require__(11);
	var redefine = __w_pdfjs_require__(8);
	var ctx = __w_pdfjs_require__(9);
	var PROTOTYPE = 'prototype';
	var $export = function $export(type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    own = !IS_FORCED && target && target[key] !== undefined;
	    out = (own ? target : source)[key];
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    if (target) redefine(target, key, out, type & $export.U);
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	$export.F = 1;
	$export.G = 2;
	$export.S = 4;
	$export.P = 8;
	$export.B = 16;
	$export.W = 32;
	$export.U = 64;
	$export.R = 128;
	module.exports = $export;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var core = module.exports = { version: '2.5.3' };
	if (typeof __e == 'number') __e = core;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(1);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(3);
	var hide = __w_pdfjs_require__(11);
	var has = __w_pdfjs_require__(7);
	var SRC = __w_pdfjs_require__(20)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	__w_pdfjs_require__(5).inspectSource = function (it) {
	  return $toString.call(it);
	};
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var aFunction = __w_pdfjs_require__(16);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1:
	      return function (a) {
	        return fn.call(that, a);
	      };
	    case 2:
	      return function (a, b) {
	        return fn.call(that, a, b);
	      };
	    case 3:
	      return function (a, b, c) {
	        return fn.call(that, a, b, c);
	      };
	  }
	  return function () {
	    return fn.apply(that, arguments);
	  };
	};
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DummyStatTimer = exports.StatTimer = exports.SimpleXMLParser = exports.DOMSVGFactory = exports.DOMCMapReaderFactory = exports.DOMCanvasFactory = exports.DEFAULT_LINK_REL = exports.getDefaultSetting = exports.LinkTarget = exports.getFilenameFromUrl = exports.isExternalLinkTargetSet = exports.addLinkAttributes = exports.RenderingCancelledException = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __w_pdfjs_require__(0);
	
	var _global_scope = __w_pdfjs_require__(14);
	
	var _global_scope2 = _interopRequireDefault(_global_scope);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DEFAULT_LINK_REL = 'noopener noreferrer nofollow';
	var SVG_NS = 'http://www.w3.org/2000/svg';
	
	var DOMCanvasFactory = function () {
	  function DOMCanvasFactory() {
	    _classCallCheck(this, DOMCanvasFactory);
	  }
	
	  _createClass(DOMCanvasFactory, [{
	    key: 'create',
	    value: function create(width, height) {
	      if (width <= 0 || height <= 0) {
	        throw new Error('invalid canvas size');
	      }
	      var canvas = document.createElement('canvas');
	      var context = canvas.getContext('2d');
	      canvas.width = width;
	      canvas.height = height;
	      return {
	        canvas: canvas,
	        context: context
	      };
	    }
	  }, {
	    key: 'reset',
	    value: function reset(canvasAndContext, width, height) {
	      if (!canvasAndContext.canvas) {
	        throw new Error('canvas is not specified');
	      }
	      if (width <= 0 || height <= 0) {
	        throw new Error('invalid canvas size');
	      }
	      canvasAndContext.canvas.width = width;
	      canvasAndContext.canvas.height = height;
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy(canvasAndContext) {
	      if (!canvasAndContext.canvas) {
	        throw new Error('canvas is not specified');
	      }
	      canvasAndContext.canvas.width = 0;
	      canvasAndContext.canvas.height = 0;
	      canvasAndContext.canvas = null;
	      canvasAndContext.context = null;
	    }
	  }]);
	
	  return DOMCanvasFactory;
	}();
	
	var DOMCMapReaderFactory = function () {
	  function DOMCMapReaderFactory(_ref) {
	    var _ref$baseUrl = _ref.baseUrl,
	        baseUrl = _ref$baseUrl === undefined ? null : _ref$baseUrl,
	        _ref$isCompressed = _ref.isCompressed,
	        isCompressed = _ref$isCompressed === undefined ? false : _ref$isCompressed;
	
	    _classCallCheck(this, DOMCMapReaderFactory);
	
	    this.baseUrl = baseUrl;
	    this.isCompressed = isCompressed;
	  }
	
	  _createClass(DOMCMapReaderFactory, [{
	    key: 'fetch',
	    value: function fetch(_ref2) {
	      var _this = this;
	
	      var name = _ref2.name;
	
	      if (!this.baseUrl) {
	        return Promise.reject(new Error('CMap baseUrl must be specified, ' + 'see "PDFJS.cMapUrl" (and also "PDFJS.cMapPacked").'));
	      }
	      if (!name) {
	        return Promise.reject(new Error('CMap name must be specified.'));
	      }
	      return new Promise(function (resolve, reject) {
	        var url = _this.baseUrl + name + (_this.isCompressed ? '.bcmap' : '');
	        var request = new XMLHttpRequest();
	        request.open('GET', url, true);
	        if (_this.isCompressed) {
	          request.responseType = 'arraybuffer';
	        }
	        request.onreadystatechange = function () {
	          if (request.readyState !== XMLHttpRequest.DONE) {
	            return;
	          }
	          if (request.status === 200 || request.status === 0) {
	            var data = void 0;
	            if (_this.isCompressed && request.response) {
	              data = new Uint8Array(request.response);
	            } else if (!_this.isCompressed && request.responseText) {
	              data = (0, _util.stringToBytes)(request.responseText);
	            }
	            if (data) {
	              resolve({
	                cMapData: data,
	                compressionType: _this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE
	              });
	              return;
	            }
	          }
	          reject(new Error('Unable to load ' + (_this.isCompressed ? 'binary ' : '') + 'CMap at: ' + url));
	        };
	        request.send(null);
	      });
	    }
	  }]);
	
	  return DOMCMapReaderFactory;
	}();
	
	var DOMSVGFactory = function () {
	  function DOMSVGFactory() {
	    _classCallCheck(this, DOMSVGFactory);
	  }
	
	  _createClass(DOMSVGFactory, [{
	    key: 'create',
	    value: function create(width, height) {
	      (0, _util.assert)(width > 0 && height > 0, 'Invalid SVG dimensions');
	      var svg = document.createElementNS(SVG_NS, 'svg:svg');
	      svg.setAttribute('version', '1.1');
	      svg.setAttribute('width', width + 'px');
	      svg.setAttribute('height', height + 'px');
	      svg.setAttribute('preserveAspectRatio', 'none');
	      svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
	      return svg;
	    }
	  }, {
	    key: 'createElement',
	    value: function createElement(type) {
	      (0, _util.assert)(typeof type === 'string', 'Invalid SVG element type');
	      return document.createElementNS(SVG_NS, type);
	    }
	  }]);
	
	  return DOMSVGFactory;
	}();
	
	var SimpleDOMNode = function () {
	  function SimpleDOMNode(nodeName, nodeValue) {
	    _classCallCheck(this, SimpleDOMNode);
	
	    this.nodeName = nodeName;
	    this.nodeValue = nodeValue;
	    Object.defineProperty(this, 'parentNode', {
	      value: null,
	      writable: true
	    });
	  }
	
	  _createClass(SimpleDOMNode, [{
	    key: 'hasChildNodes',
	    value: function hasChildNodes() {
	      return this.childNodes && this.childNodes.length > 0;
	    }
	  }, {
	    key: 'firstChild',
	    get: function get() {
	      return this.childNodes[0];
	    }
	  }, {
	    key: 'nextSibling',
	    get: function get() {
	      var index = this.parentNode.childNodes.indexOf(this);
	      return this.parentNode.childNodes[index + 1];
	    }
	  }, {
	    key: 'textContent',
	    get: function get() {
	      if (!this.childNodes) {
	        return this.nodeValue || '';
	      }
	      return this.childNodes.map(function (child) {
	        return child.textContent;
	      }).join('');
	    }
	  }]);
	
	  return SimpleDOMNode;
	}();
	
	var SimpleXMLParser = function () {
	  function SimpleXMLParser() {
	    _classCallCheck(this, SimpleXMLParser);
	  }
	
	  _createClass(SimpleXMLParser, [{
	    key: 'parseFromString',
	    value: function parseFromString(data) {
	      var _this2 = this;
	
	      var nodes = [];
	      data = data.replace(/<\?[\s\S]*?\?>|<!--[\s\S]*?-->/g, '').trim();
	      data = data.replace(/<!DOCTYPE[^>\[]+(\[[^\]]+)?[^>]+>/g, '').trim();
	      data = data.replace(/>([^<][\s\S]*?)</g, function (all, text) {
	        var length = nodes.length;
	        var node = new SimpleDOMNode('#text', _this2._decodeXML(text));
	        nodes.push(node);
	        if (node.textContent.trim().length === 0) {
	          return '><';
	        }
	        return '>' + length + ',<';
	      });
	      data = data.replace(/<!\[CDATA\[([\s\S]*?)\]\]>/g, function (all, text) {
	        var length = nodes.length;
	        var node = new SimpleDOMNode('#text', text);
	        nodes.push(node);
	        return length + ',';
	      });
	      var regex = /<([\w\:]+)((?:[\s\w:=]|'[^']*'|"[^"]*")*)(?:\/>|>([\d,]*)<\/[^>]+>)/g;
	      var lastLength = void 0;
	      do {
	        lastLength = nodes.length;
	        data = data.replace(regex, function (all, name, attrs, data) {
	          var length = nodes.length;
	          var node = new SimpleDOMNode(name);
	          var children = [];
	          if (data) {
	            data = data.split(',');
	            data.pop();
	            data.forEach(function (child) {
	              var childNode = nodes[+child];
	              childNode.parentNode = node;
	              children.push(childNode);
	            });
	          }
	          node.childNodes = children;
	          nodes.push(node);
	          return length + ',';
	        });
	      } while (lastLength < nodes.length);
	      return { documentElement: nodes.pop() };
	    }
	  }, {
	    key: '_decodeXML',
	    value: function _decodeXML(text) {
	      if (text.indexOf('&') < 0) {
	        return text;
	      }
	      return text.replace(/&(#(x[0-9a-f]+|\d+)|\w+);/gi, function (all, entityName, number) {
	        if (number) {
	          if (number[0] === 'x') {
	            number = parseInt(number.substring(1), 16);
	          } else {
	            number = +number;
	          }
	          return String.fromCharCode(number);
	        }
	        switch (entityName) {
	          case 'amp':
	            return '&';
	          case 'lt':
	            return '<';
	          case 'gt':
	            return '>';
	          case 'quot':
	            return '\"';
	          case 'apos':
	            return '\'';
	        }
	        return '&' + entityName + ';';
	      });
	    }
	  }]);
	
	  return SimpleXMLParser;
	}();
	
	var RenderingCancelledException = function RenderingCancelledException() {
	  function RenderingCancelledException(msg, type) {
	    this.message = msg;
	    this.type = type;
	  }
	  RenderingCancelledException.prototype = new Error();
	  RenderingCancelledException.prototype.name = 'RenderingCancelledException';
	  RenderingCancelledException.constructor = RenderingCancelledException;
	  return RenderingCancelledException;
	}();
	var LinkTarget = {
	  NONE: 0,
	  SELF: 1,
	  BLANK: 2,
	  PARENT: 3,
	  TOP: 4
	};
	var LinkTargetStringMap = ['', '_self', '_blank', '_parent', '_top'];
	function addLinkAttributes(link, params) {
	  var url = params && params.url;
	  link.href = link.title = url ? (0, _util.removeNullCharacters)(url) : '';
	  if (url) {
	    var target = params.target;
	    if (typeof target === 'undefined') {
	      target = getDefaultSetting('externalLinkTarget');
	    }
	    link.target = LinkTargetStringMap[target];
	    var rel = params.rel;
	    if (typeof rel === 'undefined') {
	      rel = getDefaultSetting('externalLinkRel');
	    }
	    link.rel = rel;
	  }
	}
	function getFilenameFromUrl(url) {
	  var anchor = url.indexOf('#');
	  var query = url.indexOf('?');
	  var end = Math.min(anchor > 0 ? anchor : url.length, query > 0 ? query : url.length);
	  return url.substring(url.lastIndexOf('/', end) + 1, end);
	}
	function getDefaultSetting(id) {
	  var globalSettings = _global_scope2.default.PDFJS;
	  switch (id) {
	    case 'pdfBug':
	      return globalSettings ? globalSettings.pdfBug : false;
	    case 'disableAutoFetch':
	      return globalSettings ? globalSettings.disableAutoFetch : false;
	    case 'disableStream':
	      return globalSettings ? globalSettings.disableStream : false;
	    case 'disableRange':
	      return globalSettings ? globalSettings.disableRange : false;
	    case 'disableFontFace':
	      return globalSettings ? globalSettings.disableFontFace : false;
	    case 'disableCreateObjectURL':
	      return globalSettings ? globalSettings.disableCreateObjectURL : false;
	    case 'disableWebGL':
	      return globalSettings ? globalSettings.disableWebGL : true;
	    case 'cMapUrl':
	      return globalSettings ? globalSettings.cMapUrl : null;
	    case 'cMapPacked':
	      return globalSettings ? globalSettings.cMapPacked : false;
	    case 'postMessageTransfers':
	      return globalSettings ? globalSettings.postMessageTransfers : true;
	    case 'workerPort':
	      return globalSettings ? globalSettings.workerPort : null;
	    case 'workerSrc':
	      return globalSettings ? globalSettings.workerSrc : null;
	    case 'disableWorker':
	      return globalSettings ? globalSettings.disableWorker : false;
	    case 'maxImageSize':
	      return globalSettings ? globalSettings.maxImageSize : -1;
	    case 'imageResourcesPath':
	      return globalSettings ? globalSettings.imageResourcesPath : '';
	    case 'isEvalSupported':
	      return globalSettings ? globalSettings.isEvalSupported : true;
	    case 'externalLinkTarget':
	      if (!globalSettings) {
	        return LinkTarget.NONE;
	      }
	      switch (globalSettings.externalLinkTarget) {
	        case LinkTarget.NONE:
	        case LinkTarget.SELF:
	        case LinkTarget.BLANK:
	        case LinkTarget.PARENT:
	        case LinkTarget.TOP:
	          return globalSettings.externalLinkTarget;
	      }
	      (0, _util.warn)('PDFJS.externalLinkTarget is invalid: ' + globalSettings.externalLinkTarget);
	      globalSettings.externalLinkTarget = LinkTarget.NONE;
	      return LinkTarget.NONE;
	    case 'externalLinkRel':
	      return globalSettings ? globalSettings.externalLinkRel : DEFAULT_LINK_REL;
	    case 'enableStats':
	      return !!(globalSettings && globalSettings.enableStats);
	    default:
	      throw new Error('Unknown default setting: ' + id);
	  }
	}
	function isExternalLinkTargetSet() {
	  var externalLinkTarget = getDefaultSetting('externalLinkTarget');
	  switch (externalLinkTarget) {
	    case LinkTarget.NONE:
	      return false;
	    case LinkTarget.SELF:
	    case LinkTarget.BLANK:
	    case LinkTarget.PARENT:
	    case LinkTarget.TOP:
	      return true;
	  }
	}
	
	var StatTimer = function () {
	  function StatTimer() {
	    var enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	    _classCallCheck(this, StatTimer);
	
	    this.enabled = !!enable;
	    this.started = Object.create(null);
	    this.times = [];
	  }
	
	  _createClass(StatTimer, [{
	    key: 'time',
	    value: function time(name) {
	      if (!this.enabled) {
	        return;
	      }
	      if (name in this.started) {
	        (0, _util.warn)('Timer is already running for ' + name);
	      }
	      this.started[name] = Date.now();
	    }
	  }, {
	    key: 'timeEnd',
	    value: function timeEnd(name) {
	      if (!this.enabled) {
	        return;
	      }
	      if (!(name in this.started)) {
	        (0, _util.warn)('Timer has not been started for ' + name);
	      }
	      this.times.push({
	        'name': name,
	        'start': this.started[name],
	        'end': Date.now()
	      });
	      delete this.started[name];
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var times = this.times;
	      var out = '',
	          longest = 0;
	      for (var i = 0, ii = times.length; i < ii; ++i) {
	        var name = times[i]['name'];
	        if (name.length > longest) {
	          longest = name.length;
	        }
	      }
	      for (var _i = 0, _ii = times.length; _i < _ii; ++_i) {
	        var span = times[_i];
	        var duration = span.end - span.start;
	        out += span['name'].padEnd(longest) + ' ' + duration + 'ms\n';
	      }
	      return out;
	    }
	  }]);
	
	  return StatTimer;
	}();
	
	var DummyStatTimer = function () {
	  function DummyStatTimer() {
	    _classCallCheck(this, DummyStatTimer);
	
	    (0, _util.unreachable)('Cannot initialize DummyStatTimer.');
	  }
	
	  _createClass(DummyStatTimer, null, [{
	    key: 'time',
	    value: function time(name) {}
	  }, {
	    key: 'timeEnd',
	    value: function timeEnd(name) {}
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return '';
	    }
	  }]);
	
	  return DummyStatTimer;
	}();
	
	exports.RenderingCancelledException = RenderingCancelledException;
	exports.addLinkAttributes = addLinkAttributes;
	exports.isExternalLinkTargetSet = isExternalLinkTargetSet;
	exports.getFilenameFromUrl = getFilenameFromUrl;
	exports.LinkTarget = LinkTarget;
	exports.getDefaultSetting = getDefaultSetting;
	exports.DEFAULT_LINK_REL = DEFAULT_LINK_REL;
	exports.DOMCanvasFactory = DOMCanvasFactory;
	exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
	exports.DOMSVGFactory = DOMSVGFactory;
	exports.SimpleXMLParser = SimpleXMLParser;
	exports.StatTimer = StatTimer;
	exports.DummyStatTimer = DummyStatTimer;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var dP = __w_pdfjs_require__(15);
	var createDesc = __w_pdfjs_require__(26);
	module.exports = __w_pdfjs_require__(12) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = !__w_pdfjs_require__(13)(function () {
	  return Object.defineProperty({}, 'a', {
	    get: function get() {
	      return 7;
	    }
	  }).a != 7;
	});
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = typeof window !== 'undefined' && window.Math === Math ? window : typeof global !== 'undefined' && global.Math === Math ? global : typeof self !== 'undefined' && self.Math === Math ? self : {};
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var anObject = __w_pdfjs_require__(6);
	var IE8_DOM_DEFINE = __w_pdfjs_require__(40);
	var toPrimitive = __w_pdfjs_require__(41);
	var dP = Object.defineProperty;
	exports.f = __w_pdfjs_require__(12) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) {}
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var IObject = __w_pdfjs_require__(27);
	var defined = __w_pdfjs_require__(28);
	module.exports = function (it) {
	  return IObject(defined(it));
	};
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toString = {}.toString;
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = {};
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $keys = __w_pdfjs_require__(81);
	var enumBugKeys = __w_pdfjs_require__(48);
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var def = __w_pdfjs_require__(15).f;
	var has = __w_pdfjs_require__(7);
	var TAG = __w_pdfjs_require__(2)('toStringTag');
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
	    configurable: true,
	    value: tag
	  });
	};
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var ctx = __w_pdfjs_require__(9);
	var call = __w_pdfjs_require__(86);
	var isArrayIter = __w_pdfjs_require__(87);
	var anObject = __w_pdfjs_require__(6);
	var toLength = __w_pdfjs_require__(29);
	var getIterFn = __w_pdfjs_require__(88);
	var BREAK = {};
	var RETURN = {};
	var _exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () {
	    return iterable;
	  } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	_exports.BREAK = BREAK;
	_exports.RETURN = RETURN;
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	module.exports = function isNodeJS() {
	  return (typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && process + '' === '[object process]';
	};
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(1);
	var document = __w_pdfjs_require__(3).document;
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var cof = __w_pdfjs_require__(18);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toInteger = __w_pdfjs_require__(30);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0;
	};
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var cof = __w_pdfjs_require__(18);
	var TAG = __w_pdfjs_require__(2)('toStringTag');
	var ARG = cof(function () {
	  return arguments;
	}()) == 'Arguments';
	var tryGet = function tryGet(it, key) {
	  try {
	    return it[key];
	  } catch (e) {}
	};
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T : ARG ? cof(O) : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var shared = __w_pdfjs_require__(44)('keys');
	var uid = __w_pdfjs_require__(20);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var defined = __w_pdfjs_require__(28);
	module.exports = function (it) {
	  return Object(defined(it));
	};
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
	    throw TypeError(name + ': incorrect invocation!');
	  }
	  return it;
	};
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var aFunction = __w_pdfjs_require__(16);
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var redefine = __w_pdfjs_require__(8);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    redefine(target, key, src[key], safe);
	  }return target;
	};
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var META = __w_pdfjs_require__(20)('meta');
	var isObject = __w_pdfjs_require__(1);
	var has = __w_pdfjs_require__(7);
	var setDesc = __w_pdfjs_require__(15).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__w_pdfjs_require__(13)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function setMeta(it) {
	  setDesc(it, META, {
	    value: {
	      i: 'O' + ++id,
	      w: {}
	    }
	  });
	};
	var fastKey = function fastKey(it, create) {
	  if (!isObject(it)) return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    if (!isExtensible(it)) return 'F';
	    if (!create) return 'E';
	    setMeta(it);
	  }
	  return it[META].i;
	};
	var getWeak = function getWeak(it, create) {
	  if (!has(it, META)) {
	    if (!isExtensible(it)) return true;
	    if (!create) return false;
	    setMeta(it);
	  }
	  return it[META].w;
	};
	var onFreeze = function onFreeze(it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	exports.f = {}.propertyIsEnumerable;
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateResponseStatus = exports.validateRangeRequestCapabilities = exports.extractFilenameFromHeader = exports.createResponseStatusError = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _content_disposition = __w_pdfjs_require__(122);
	
	function validateRangeRequestCapabilities(_ref) {
	  var getResponseHeader = _ref.getResponseHeader,
	      isHttp = _ref.isHttp,
	      rangeChunkSize = _ref.rangeChunkSize,
	      disableRange = _ref.disableRange;
	
	  (0, _util.assert)(rangeChunkSize > 0, 'Range chunk size must be larger than zero');
	  var returnValues = {
	    allowRangeRequests: false,
	    suggestedLength: undefined
	  };
	  if (disableRange || !isHttp) {
	    return returnValues;
	  }
	  if (getResponseHeader('Accept-Ranges') !== 'bytes') {
	    return returnValues;
	  }
	  var contentEncoding = getResponseHeader('Content-Encoding') || 'identity';
	  if (contentEncoding !== 'identity') {
	    return returnValues;
	  }
	  var length = parseInt(getResponseHeader('Content-Length'), 10);
	  if (!Number.isInteger(length)) {
	    return returnValues;
	  }
	  returnValues.suggestedLength = length;
	  if (length <= 2 * rangeChunkSize) {
	    return returnValues;
	  }
	  returnValues.allowRangeRequests = true;
	  return returnValues;
	}
	function extractFilenameFromHeader(getResponseHeader) {
	  var contentDisposition = getResponseHeader('Content-Disposition');
	  if (contentDisposition) {
	    var filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);
	    if (/\.pdf$/i.test(filename)) {
	      return filename;
	    }
	  }
	  return null;
	}
	function createResponseStatusError(status, url) {
	  if (status === 404 || status === 0 && /^file:/.test(url)) {
	    return new _util.MissingPDFException('Missing PDF "' + url + '".');
	  }
	  return new _util.UnexpectedResponseException('Unexpected server response (' + status + ') while retrieving PDF "' + url + '".', status);
	}
	function validateResponseStatus(status) {
	  return status === 200 || status === 206;
	}
	exports.createResponseStatusError = createResponseStatusError;
	exports.extractFilenameFromHeader = extractFilenameFromHeader;
	exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
	exports.validateResponseStatus = validateResponseStatus;
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = !__w_pdfjs_require__(12) && !__w_pdfjs_require__(13)(function () {
	  return Object.defineProperty(__w_pdfjs_require__(25)('div'), 'a', {
	    get: function get() {
	      return 7;
	    }
	  }).a != 7;
	});
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(1);
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toIObject = __w_pdfjs_require__(17);
	var toLength = __w_pdfjs_require__(29);
	var toAbsoluteIndex = __w_pdfjs_require__(67);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      if (value != value) return true;
	    } else for (; length > index; index++) {
	      if (IS_INCLUDES || index in O) {
	        if (O[index] === el) return IS_INCLUDES || index || 0;
	      }
	    }return !IS_INCLUDES && -1;
	  };
	};
	
	/***/ }),
	/* 43 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var UNSCOPABLES = __w_pdfjs_require__(2)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __w_pdfjs_require__(11)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};
	
	/***/ }),
	/* 44 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(3);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};
	
	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var classof = __w_pdfjs_require__(31);
	var test = {};
	test[__w_pdfjs_require__(2)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __w_pdfjs_require__(8)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}
	
	/***/ }),
	/* 46 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var LIBRARY = __w_pdfjs_require__(47);
	var $export = __w_pdfjs_require__(4);
	var redefine = __w_pdfjs_require__(8);
	var hide = __w_pdfjs_require__(11);
	var has = __w_pdfjs_require__(7);
	var Iterators = __w_pdfjs_require__(19);
	var $iterCreate = __w_pdfjs_require__(78);
	var setToStringTag = __w_pdfjs_require__(22);
	var getPrototypeOf = __w_pdfjs_require__(82);
	var ITERATOR = __w_pdfjs_require__(2)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys());
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	var returnThis = function returnThis() {
	  return this;
	};
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function getMethod(kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS:
	        return function keys() {
	          return new Constructor(this, kind);
	        };
	      case VALUES:
	        return function values() {
	          return new Constructor(this, kind);
	        };
	    }
	    return function entries() {
	      return new Constructor(this, kind);
	    };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = !BUGGY && $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      setToStringTag(IteratorPrototype, TAG, true);
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() {
	      return $native.call(this);
	    };
	  }
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};
	
	/***/ }),
	/* 47 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = false;
	
	/***/ }),
	/* 48 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
	
	/***/ }),
	/* 49 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var document = __w_pdfjs_require__(3).document;
	module.exports = document && document.documentElement;
	
	/***/ }),
	/* 50 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $iterators = __w_pdfjs_require__(83);
	var getKeys = __w_pdfjs_require__(21);
	var redefine = __w_pdfjs_require__(8);
	var global = __w_pdfjs_require__(3);
	var hide = __w_pdfjs_require__(11);
	var Iterators = __w_pdfjs_require__(19);
	var wks = __w_pdfjs_require__(2);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	var DOMIterables = {
	  CSSRuleList: true,
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true,
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true,
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) {
	      if (!proto[key]) redefine(proto, key, $iterators[key], true);
	    }
	  }
	}
	
	/***/ }),
	/* 51 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var anObject = __w_pdfjs_require__(6);
	var aFunction = __w_pdfjs_require__(16);
	var SPECIES = __w_pdfjs_require__(2)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};
	
	/***/ }),
	/* 52 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var ctx = __w_pdfjs_require__(9);
	var invoke = __w_pdfjs_require__(89);
	var html = __w_pdfjs_require__(49);
	var cel = __w_pdfjs_require__(25);
	var global = __w_pdfjs_require__(3);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function run() {
	  var id = +this;
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function listener(event) {
	  run.call(event.data);
	};
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) {
	      args.push(arguments[i++]);
	    }queue[++counter] = function () {
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  if (__w_pdfjs_require__(18)(process) == 'process') {
	    defer = function defer(id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  } else if (Dispatch && Dispatch.now) {
	    defer = function defer(id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function defer(id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function defer(id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  } else {
	    defer = function defer(id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};
	
	/***/ }),
	/* 53 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (exec) {
	  try {
	    return {
	      e: false,
	      v: exec()
	    };
	  } catch (e) {
	    return {
	      e: true,
	      v: e
	    };
	  }
	};
	
	/***/ }),
	/* 54 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var anObject = __w_pdfjs_require__(6);
	var isObject = __w_pdfjs_require__(1);
	var newPromiseCapability = __w_pdfjs_require__(35);
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};
	
	/***/ }),
	/* 55 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var ITERATOR = __w_pdfjs_require__(2)('iterator');
	var SAFE_CLOSING = false;
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () {
	    SAFE_CLOSING = true;
	  };
	  Array.from(riter, function () {
	    throw 2;
	  });
	} catch (e) {}
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () {
	      return { done: safe = true };
	    };
	    arr[ITERATOR] = function () {
	      return iter;
	    };
	    exec(arr);
	  } catch (e) {}
	  return safe;
	};
	
	/***/ }),
	/* 56 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var ctx = __w_pdfjs_require__(9);
	var IObject = __w_pdfjs_require__(27);
	var toObject = __w_pdfjs_require__(33);
	var toLength = __w_pdfjs_require__(29);
	var asc = __w_pdfjs_require__(96);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (; length > index; index++) {
	      if (NO_HOLES || index in self) {
	        val = self[index];
	        res = f(val, index, O);
	        if (TYPE) {
	          if (IS_MAP) result[index] = res;else if (res) switch (TYPE) {
	            case 3:
	              return true;
	            case 5:
	              return val;
	            case 6:
	              return index;
	            case 2:
	              result.push(val);
	          } else if (IS_EVERY) return false;
	        }
	      }
	    }return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};
	
	/***/ }),
	/* 57 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(1);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};
	
	/***/ }),
	/* 58 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.build = exports.version = exports.setPDFNetworkStreamFactory = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFWorker = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.getDocument = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _util = __w_pdfjs_require__(0);
	
	var _dom_utils = __w_pdfjs_require__(10);
	
	var _font_loader = __w_pdfjs_require__(116);
	
	var _canvas = __w_pdfjs_require__(117);
	
	var _global_scope = __w_pdfjs_require__(14);
	
	var _global_scope2 = _interopRequireDefault(_global_scope);
	
	var _metadata = __w_pdfjs_require__(59);
	
	var _transport_stream = __w_pdfjs_require__(119);
	
	var _webgl = __w_pdfjs_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DEFAULT_RANGE_CHUNK_SIZE = 65536;
	var isWorkerDisabled = false;
	var workerSrc;
	var isPostMessageTransfersDisabled = false;
	var pdfjsFilePath = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : null;
	var fakeWorkerFilesLoader = null;
	var useRequireEnsure = false;
	{
	  if (typeof window === 'undefined') {
	    isWorkerDisabled = true;
	    if (false) {
	      require.ensure = require('node-ensure');
	    }
	    useRequireEnsure = true;
	  } else if (true) {
	    useRequireEnsure = true;
	  }
	  if (typeof requirejs !== 'undefined' && requirejs.toUrl) {
	    workerSrc = requirejs.toUrl('pdfjs-dist/build/pdf.worker.js');
	  }
	  var dynamicLoaderSupported = typeof requirejs !== 'undefined' && requirejs.load;
	  fakeWorkerFilesLoader = useRequireEnsure ? function (callback) {
	    __webpack_require__.e/* nsure */(2, function () {
	      var worker;
	      worker = __webpack_require__(1681);
	      callback(worker.WorkerMessageHandler);
	    });
	  } : dynamicLoaderSupported ? function (callback) {
	    requirejs(['pdfjs-dist/build/pdf.worker'], function (worker) {
	      callback(worker.WorkerMessageHandler);
	    });
	  } : null;
	}
	var createPDFNetworkStream;
	function setPDFNetworkStreamFactory(pdfNetworkStreamFactory) {
	  createPDFNetworkStream = pdfNetworkStreamFactory;
	}
	function getDocument(src) {
	  var task = new PDFDocumentLoadingTask();
	  var source;
	  if (typeof src === 'string') {
	    source = { url: src };
	  } else if ((0, _util.isArrayBuffer)(src)) {
	    source = { data: src };
	  } else if (src instanceof PDFDataRangeTransport) {
	    source = { range: src };
	  } else {
	    if ((typeof src === 'undefined' ? 'undefined' : _typeof(src)) !== 'object') {
	      throw new Error('Invalid parameter in getDocument, ' + 'need either Uint8Array, string or a parameter object');
	    }
	    if (!src.url && !src.data && !src.range) {
	      throw new Error('Invalid parameter object: need either .data, .range or .url');
	    }
	    source = src;
	  }
	  var params = {};
	  var rangeTransport = null;
	  var worker = null;
	  var CMapReaderFactory = _dom_utils.DOMCMapReaderFactory;
	  for (var key in source) {
	    if (key === 'url' && typeof window !== 'undefined') {
	      params[key] = new URL(source[key], window.location).href;
	      continue;
	    } else if (key === 'range') {
	      rangeTransport = source[key];
	      continue;
	    } else if (key === 'worker') {
	      worker = source[key];
	      continue;
	    } else if (key === 'data' && !(source[key] instanceof Uint8Array)) {
	      var pdfBytes = source[key];
	      if (typeof pdfBytes === 'string') {
	        params[key] = (0, _util.stringToBytes)(pdfBytes);
	      } else if ((typeof pdfBytes === 'undefined' ? 'undefined' : _typeof(pdfBytes)) === 'object' && pdfBytes !== null && !isNaN(pdfBytes.length)) {
	        params[key] = new Uint8Array(pdfBytes);
	      } else if ((0, _util.isArrayBuffer)(pdfBytes)) {
	        params[key] = new Uint8Array(pdfBytes);
	      } else {
	        throw new Error('Invalid PDF binary data: either typed array, ' + 'string or array-like object is expected in the ' + 'data property.');
	      }
	      continue;
	    } else if (key === 'CMapReaderFactory') {
	      CMapReaderFactory = source[key];
	      continue;
	    }
	    params[key] = source[key];
	  }
	  params.rangeChunkSize = params.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE;
	  params.ignoreErrors = params.stopAtErrors !== true;
	  var nativeImageDecoderValues = Object.values(_util.NativeImageDecoding);
	  if (params.nativeImageDecoderSupport === undefined || !nativeImageDecoderValues.includes(params.nativeImageDecoderSupport)) {
	    params.nativeImageDecoderSupport = _util.NativeImageDecoding.DECODE;
	  }
	  if (!worker) {
	    var workerPort = (0, _dom_utils.getDefaultSetting)('workerPort');
	    worker = workerPort ? PDFWorker.fromPort(workerPort) : new PDFWorker();
	    task._worker = worker;
	  }
	  var docId = task.docId;
	  worker.promise.then(function () {
	    if (task.destroyed) {
	      throw new Error('Loading aborted');
	    }
	    return _fetchDocument(worker, params, rangeTransport, docId).then(function (workerId) {
	      if (task.destroyed) {
	        throw new Error('Loading aborted');
	      }
	      var networkStream = void 0;
	      if (rangeTransport) {
	        networkStream = new _transport_stream.PDFDataTransportStream(params, rangeTransport);
	      } else if (!params.data) {
	        networkStream = createPDFNetworkStream(params);
	      }
	      var messageHandler = new _util.MessageHandler(docId, workerId, worker.port);
	      messageHandler.postMessageTransfers = worker.postMessageTransfers;
	      var transport = new WorkerTransport(messageHandler, task, networkStream, CMapReaderFactory);
	      task._transport = transport;
	      messageHandler.send('Ready', null);
	    });
	  }).catch(task._capability.reject);
	  return task;
	}
	function _fetchDocument(worker, source, pdfDataRangeTransport, docId) {
	  if (worker.destroyed) {
	    return Promise.reject(new Error('Worker was destroyed'));
	  }
	  var apiVersion = '2.0.305';
	  source.disableRange = (0, _dom_utils.getDefaultSetting)('disableRange');
	  source.disableAutoFetch = (0, _dom_utils.getDefaultSetting)('disableAutoFetch');
	  source.disableStream = (0, _dom_utils.getDefaultSetting)('disableStream');
	  if (pdfDataRangeTransport) {
	    source.length = pdfDataRangeTransport.length;
	    source.initialData = pdfDataRangeTransport.initialData;
	  }
	  return worker.messageHandler.sendWithPromise('GetDocRequest', {
	    docId: docId,
	    apiVersion: apiVersion,
	    source: {
	      data: source.data,
	      url: source.url,
	      password: source.password,
	      disableAutoFetch: source.disableAutoFetch,
	      rangeChunkSize: source.rangeChunkSize,
	      length: source.length
	    },
	    maxImageSize: (0, _dom_utils.getDefaultSetting)('maxImageSize'),
	    disableFontFace: (0, _dom_utils.getDefaultSetting)('disableFontFace'),
	    disableCreateObjectURL: (0, _dom_utils.getDefaultSetting)('disableCreateObjectURL'),
	    postMessageTransfers: (0, _dom_utils.getDefaultSetting)('postMessageTransfers') && !isPostMessageTransfersDisabled,
	    docBaseUrl: source.docBaseUrl,
	    nativeImageDecoderSupport: source.nativeImageDecoderSupport,
	    ignoreErrors: source.ignoreErrors,
	    isEvalSupported: (0, _dom_utils.getDefaultSetting)('isEvalSupported')
	  }).then(function (workerId) {
	    if (worker.destroyed) {
	      throw new Error('Worker was destroyed');
	    }
	    return workerId;
	  });
	}
	var PDFDocumentLoadingTask = function PDFDocumentLoadingTaskClosure() {
	  var nextDocumentId = 0;
	  function PDFDocumentLoadingTask() {
	    this._capability = (0, _util.createPromiseCapability)();
	    this._transport = null;
	    this._worker = null;
	    this.docId = 'd' + nextDocumentId++;
	    this.destroyed = false;
	    this.onPassword = null;
	    this.onProgress = null;
	    this.onUnsupportedFeature = null;
	  }
	  PDFDocumentLoadingTask.prototype = {
	    get promise() {
	      return this._capability.promise;
	    },
	    destroy: function destroy() {
	      var _this = this;
	
	      this.destroyed = true;
	      var transportDestroyed = !this._transport ? Promise.resolve() : this._transport.destroy();
	      return transportDestroyed.then(function () {
	        _this._transport = null;
	        if (_this._worker) {
	          _this._worker.destroy();
	          _this._worker = null;
	        }
	      });
	    },
	
	    then: function PDFDocumentLoadingTask_then(onFulfilled, onRejected) {
	      return this.promise.then.apply(this.promise, arguments);
	    }
	  };
	  return PDFDocumentLoadingTask;
	}();
	var PDFDataRangeTransport = function pdfDataRangeTransportClosure() {
	  function PDFDataRangeTransport(length, initialData) {
	    this.length = length;
	    this.initialData = initialData;
	    this._rangeListeners = [];
	    this._progressListeners = [];
	    this._progressiveReadListeners = [];
	    this._readyCapability = (0, _util.createPromiseCapability)();
	  }
	  PDFDataRangeTransport.prototype = {
	    addRangeListener: function PDFDataRangeTransport_addRangeListener(listener) {
	      this._rangeListeners.push(listener);
	    },
	    addProgressListener: function PDFDataRangeTransport_addProgressListener(listener) {
	      this._progressListeners.push(listener);
	    },
	    addProgressiveReadListener: function PDFDataRangeTransport_addProgressiveReadListener(listener) {
	      this._progressiveReadListeners.push(listener);
	    },
	    onDataRange: function PDFDataRangeTransport_onDataRange(begin, chunk) {
	      var listeners = this._rangeListeners;
	      for (var i = 0, n = listeners.length; i < n; ++i) {
	        listeners[i](begin, chunk);
	      }
	    },
	    onDataProgress: function PDFDataRangeTransport_onDataProgress(loaded) {
	      var _this2 = this;
	
	      this._readyCapability.promise.then(function () {
	        var listeners = _this2._progressListeners;
	        for (var i = 0, n = listeners.length; i < n; ++i) {
	          listeners[i](loaded);
	        }
	      });
	    },
	    onDataProgressiveRead: function PDFDataRangeTransport_onDataProgress(chunk) {
	      var _this3 = this;
	
	      this._readyCapability.promise.then(function () {
	        var listeners = _this3._progressiveReadListeners;
	        for (var i = 0, n = listeners.length; i < n; ++i) {
	          listeners[i](chunk);
	        }
	      });
	    },
	    transportReady: function PDFDataRangeTransport_transportReady() {
	      this._readyCapability.resolve();
	    },
	    requestDataRange: function PDFDataRangeTransport_requestDataRange(begin, end) {
	      (0, _util.unreachable)('Abstract method PDFDataRangeTransport.requestDataRange');
	    },
	    abort: function PDFDataRangeTransport_abort() {}
	  };
	  return PDFDataRangeTransport;
	}();
	var PDFDocumentProxy = function PDFDocumentProxyClosure() {
	  function PDFDocumentProxy(pdfInfo, transport, loadingTask) {
	    this.pdfInfo = pdfInfo;
	    this.transport = transport;
	    this.loadingTask = loadingTask;
	  }
	  PDFDocumentProxy.prototype = {
	    get numPages() {
	      return this.pdfInfo.numPages;
	    },
	    get fingerprint() {
	      return this.pdfInfo.fingerprint;
	    },
	    getPage: function getPage(pageNumber) {
	      return this.transport.getPage(pageNumber);
	    },
	
	    getPageIndex: function PDFDocumentProxy_getPageIndex(ref) {
	      return this.transport.getPageIndex(ref);
	    },
	    getDestinations: function PDFDocumentProxy_getDestinations() {
	      return this.transport.getDestinations();
	    },
	    getDestination: function PDFDocumentProxy_getDestination(id) {
	      return this.transport.getDestination(id);
	    },
	    getPageLabels: function PDFDocumentProxy_getPageLabels() {
	      return this.transport.getPageLabels();
	    },
	    getPageMode: function getPageMode() {
	      return this.transport.getPageMode();
	    },
	
	    getAttachments: function PDFDocumentProxy_getAttachments() {
	      return this.transport.getAttachments();
	    },
	    getJavaScript: function getJavaScript() {
	      return this.transport.getJavaScript();
	    },
	
	    getOutline: function PDFDocumentProxy_getOutline() {
	      return this.transport.getOutline();
	    },
	    getMetadata: function PDFDocumentProxy_getMetadata() {
	      return this.transport.getMetadata();
	    },
	    getData: function PDFDocumentProxy_getData() {
	      return this.transport.getData();
	    },
	    getDownloadInfo: function PDFDocumentProxy_getDownloadInfo() {
	      return this.transport.downloadInfoCapability.promise;
	    },
	    getStats: function PDFDocumentProxy_getStats() {
	      return this.transport.getStats();
	    },
	    cleanup: function PDFDocumentProxy_cleanup() {
	      this.transport.startCleanup();
	    },
	    destroy: function PDFDocumentProxy_destroy() {
	      return this.loadingTask.destroy();
	    }
	  };
	  return PDFDocumentProxy;
	}();
	var PDFPageProxy = function PDFPageProxyClosure() {
	  function PDFPageProxy(pageIndex, pageInfo, transport) {
	    this.pageIndex = pageIndex;
	    this.pageInfo = pageInfo;
	    this.transport = transport;
	    this._stats = (0, _dom_utils.getDefaultSetting)('enableStats') ? new _dom_utils.StatTimer() : _dom_utils.DummyStatTimer;
	    this.commonObjs = transport.commonObjs;
	    this.objs = new PDFObjects();
	    this.cleanupAfterRender = false;
	    this.pendingCleanup = false;
	    this.intentStates = Object.create(null);
	    this.destroyed = false;
	  }
	  PDFPageProxy.prototype = {
	    get pageNumber() {
	      return this.pageIndex + 1;
	    },
	    get rotate() {
	      return this.pageInfo.rotate;
	    },
	    get ref() {
	      return this.pageInfo.ref;
	    },
	    get userUnit() {
	      return this.pageInfo.userUnit;
	    },
	    get view() {
	      return this.pageInfo.view;
	    },
	    getViewport: function getViewport(scale) {
	      var rotate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.rotate;
	      var dontFlip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      return new _util.PageViewport(this.view, scale, rotate, 0, 0, dontFlip);
	    },
	
	    getAnnotations: function PDFPageProxy_getAnnotations(params) {
	      var intent = params && params.intent || null;
	      if (!this.annotationsPromise || this.annotationsIntent !== intent) {
	        this.annotationsPromise = this.transport.getAnnotations(this.pageIndex, intent);
	        this.annotationsIntent = intent;
	      }
	      return this.annotationsPromise;
	    },
	    render: function PDFPageProxy_render(params) {
	      var _this4 = this;
	
	      var stats = this._stats;
	      stats.time('Overall');
	      this.pendingCleanup = false;
	      var renderingIntent = params.intent === 'print' ? 'print' : 'display';
	      var canvasFactory = params.canvasFactory || new _dom_utils.DOMCanvasFactory();
	      var webGLContext = new _webgl.WebGLContext({ enable: !(0, _dom_utils.getDefaultSetting)('disableWebGL') });
	      if (!this.intentStates[renderingIntent]) {
	        this.intentStates[renderingIntent] = Object.create(null);
	      }
	      var intentState = this.intentStates[renderingIntent];
	      if (!intentState.displayReadyCapability) {
	        intentState.receivingOperatorList = true;
	        intentState.displayReadyCapability = (0, _util.createPromiseCapability)();
	        intentState.operatorList = {
	          fnArray: [],
	          argsArray: [],
	          lastChunk: false
	        };
	        stats.time('Page Request');
	        this.transport.messageHandler.send('RenderPageRequest', {
	          pageIndex: this.pageNumber - 1,
	          intent: renderingIntent,
	          renderInteractiveForms: params.renderInteractiveForms === true
	        });
	      }
	      var complete = function complete(error) {
	        var i = intentState.renderTasks.indexOf(internalRenderTask);
	        if (i >= 0) {
	          intentState.renderTasks.splice(i, 1);
	        }
	        if (_this4.cleanupAfterRender) {
	          _this4.pendingCleanup = true;
	        }
	        _this4._tryCleanup();
	        if (error) {
	          internalRenderTask.capability.reject(error);
	        } else {
	          internalRenderTask.capability.resolve();
	        }
	        stats.timeEnd('Rendering');
	        stats.timeEnd('Overall');
	      };
	      var internalRenderTask = new InternalRenderTask(complete, params, this.objs, this.commonObjs, intentState.operatorList, this.pageNumber, canvasFactory, webGLContext);
	      internalRenderTask.useRequestAnimationFrame = renderingIntent !== 'print';
	      if (!intentState.renderTasks) {
	        intentState.renderTasks = [];
	      }
	      intentState.renderTasks.push(internalRenderTask);
	      var renderTask = internalRenderTask.task;
	      intentState.displayReadyCapability.promise.then(function (transparency) {
	        if (_this4.pendingCleanup) {
	          complete();
	          return;
	        }
	        stats.time('Rendering');
	        internalRenderTask.initializeGraphics(transparency);
	        internalRenderTask.operatorListChanged();
	      }).catch(complete);
	      return renderTask;
	    },
	    getOperatorList: function PDFPageProxy_getOperatorList() {
	      function operatorListChanged() {
	        if (intentState.operatorList.lastChunk) {
	          intentState.opListReadCapability.resolve(intentState.operatorList);
	          var i = intentState.renderTasks.indexOf(opListTask);
	          if (i >= 0) {
	            intentState.renderTasks.splice(i, 1);
	          }
	        }
	      }
	      var renderingIntent = 'oplist';
	      if (!this.intentStates[renderingIntent]) {
	        this.intentStates[renderingIntent] = Object.create(null);
	      }
	      var intentState = this.intentStates[renderingIntent];
	      var opListTask;
	      if (!intentState.opListReadCapability) {
	        opListTask = {};
	        opListTask.operatorListChanged = operatorListChanged;
	        intentState.receivingOperatorList = true;
	        intentState.opListReadCapability = (0, _util.createPromiseCapability)();
	        intentState.renderTasks = [];
	        intentState.renderTasks.push(opListTask);
	        intentState.operatorList = {
	          fnArray: [],
	          argsArray: [],
	          lastChunk: false
	        };
	        this.transport.messageHandler.send('RenderPageRequest', {
	          pageIndex: this.pageIndex,
	          intent: renderingIntent
	        });
	      }
	      return intentState.opListReadCapability.promise;
	    },
	    streamTextContent: function streamTextContent() {
	      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var TEXT_CONTENT_CHUNK_SIZE = 100;
	      return this.transport.messageHandler.sendWithStream('GetTextContent', {
	        pageIndex: this.pageNumber - 1,
	        normalizeWhitespace: params.normalizeWhitespace === true,
	        combineTextItems: params.disableCombineTextItems !== true
	      }, {
	        highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
	        size: function size(textContent) {
	          return textContent.items.length;
	        }
	      });
	    },
	
	    getTextContent: function PDFPageProxy_getTextContent(params) {
	      params = params || {};
	      var readableStream = this.streamTextContent(params);
	      return new Promise(function (resolve, reject) {
	        function pump() {
	          reader.read().then(function (_ref) {
	            var value = _ref.value,
	                done = _ref.done;
	
	            if (done) {
	              resolve(textContent);
	              return;
	            }
	            _util.Util.extendObj(textContent.styles, value.styles);
	            _util.Util.appendToArray(textContent.items, value.items);
	            pump();
	          }, reject);
	        }
	        var reader = readableStream.getReader();
	        var textContent = {
	          items: [],
	          styles: Object.create(null)
	        };
	        pump();
	      });
	    },
	    _destroy: function PDFPageProxy_destroy() {
	      this.destroyed = true;
	      this.transport.pageCache[this.pageIndex] = null;
	      var waitOn = [];
	      Object.keys(this.intentStates).forEach(function (intent) {
	        if (intent === 'oplist') {
	          return;
	        }
	        var intentState = this.intentStates[intent];
	        intentState.renderTasks.forEach(function (renderTask) {
	          var renderCompleted = renderTask.capability.promise.catch(function () {});
	          waitOn.push(renderCompleted);
	          renderTask.cancel();
	        });
	      }, this);
	      this.objs.clear();
	      this.annotationsPromise = null;
	      this.pendingCleanup = false;
	      return Promise.all(waitOn);
	    },
	    cleanup: function cleanup() {
	      var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      this.pendingCleanup = true;
	      this._tryCleanup(resetStats);
	    },
	    _tryCleanup: function _tryCleanup() {
	      var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!this.pendingCleanup || Object.keys(this.intentStates).some(function (intent) {
	        var intentState = this.intentStates[intent];
	        return intentState.renderTasks.length !== 0 || intentState.receivingOperatorList;
	      }, this)) {
	        return;
	      }
	      Object.keys(this.intentStates).forEach(function (intent) {
	        delete this.intentStates[intent];
	      }, this);
	      this.objs.clear();
	      this.annotationsPromise = null;
	      if (resetStats && this._stats instanceof _dom_utils.StatTimer) {
	        this._stats = new _dom_utils.StatTimer();
	      }
	      this.pendingCleanup = false;
	    },
	
	    _startRenderPage: function PDFPageProxy_startRenderPage(transparency, intent) {
	      var intentState = this.intentStates[intent];
	      if (intentState.displayReadyCapability) {
	        intentState.displayReadyCapability.resolve(transparency);
	      }
	    },
	    _renderPageChunk: function PDFPageProxy_renderPageChunk(operatorListChunk, intent) {
	      var intentState = this.intentStates[intent];
	      var i, ii;
	      for (i = 0, ii = operatorListChunk.length; i < ii; i++) {
	        intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
	        intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
	      }
	      intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
	      for (i = 0; i < intentState.renderTasks.length; i++) {
	        intentState.renderTasks[i].operatorListChanged();
	      }
	      if (operatorListChunk.lastChunk) {
	        intentState.receivingOperatorList = false;
	        this._tryCleanup();
	      }
	    },
	    get stats() {
	      return this._stats instanceof _dom_utils.StatTimer ? this._stats : null;
	    }
	  };
	  return PDFPageProxy;
	}();
	
	var LoopbackPort = function () {
	  function LoopbackPort(defer) {
	    _classCallCheck(this, LoopbackPort);
	
	    this._listeners = [];
	    this._defer = defer;
	    this._deferred = Promise.resolve(undefined);
	  }
	
	  _createClass(LoopbackPort, [{
	    key: 'postMessage',
	    value: function postMessage(obj, transfers) {
	      var _this5 = this;
	
	      function cloneValue(value) {
	        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null) {
	          return value;
	        }
	        if (cloned.has(value)) {
	          return cloned.get(value);
	        }
	        var result;
	        var buffer;
	        if ((buffer = value.buffer) && (0, _util.isArrayBuffer)(buffer)) {
	          var transferable = transfers && transfers.indexOf(buffer) >= 0;
	          if (value === buffer) {
	            result = value;
	          } else if (transferable) {
	            result = new value.constructor(buffer, value.byteOffset, value.byteLength);
	          } else {
	            result = new value.constructor(value);
	          }
	          cloned.set(value, result);
	          return result;
	        }
	        result = Array.isArray(value) ? [] : {};
	        cloned.set(value, result);
	        for (var i in value) {
	          var desc,
	              p = value;
	          while (!(desc = Object.getOwnPropertyDescriptor(p, i))) {
	            p = Object.getPrototypeOf(p);
	          }
	          if (typeof desc.value === 'undefined' || typeof desc.value === 'function') {
	            continue;
	          }
	          result[i] = cloneValue(desc.value);
	        }
	        return result;
	      }
	      if (!this._defer) {
	        this._listeners.forEach(function (listener) {
	          listener.call(this, { data: obj });
	        }, this);
	        return;
	      }
	      var cloned = new WeakMap();
	      var e = { data: cloneValue(obj) };
	      this._deferred.then(function () {
	        _this5._listeners.forEach(function (listener) {
	          listener.call(this, e);
	        }, _this5);
	      });
	    }
	  }, {
	    key: 'addEventListener',
	    value: function addEventListener(name, listener) {
	      this._listeners.push(listener);
	    }
	  }, {
	    key: 'removeEventListener',
	    value: function removeEventListener(name, listener) {
	      var i = this._listeners.indexOf(listener);
	      this._listeners.splice(i, 1);
	    }
	  }, {
	    key: 'terminate',
	    value: function terminate() {
	      this._listeners = [];
	    }
	  }]);
	
	  return LoopbackPort;
	}();
	
	var PDFWorker = function PDFWorkerClosure() {
	  var nextFakeWorkerId = 0;
	  function getWorkerSrc() {
	    if (typeof workerSrc !== 'undefined') {
	      return workerSrc;
	    }
	    if ((0, _dom_utils.getDefaultSetting)('workerSrc')) {
	      return (0, _dom_utils.getDefaultSetting)('workerSrc');
	    }
	    if (pdfjsFilePath) {
	      return pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, '.worker$1$2');
	    }
	    throw new Error('No PDFJS.workerSrc specified');
	  }
	  var fakeWorkerFilesLoadedCapability = void 0;
	  function setupFakeWorkerGlobal() {
	    var WorkerMessageHandler;
	    if (fakeWorkerFilesLoadedCapability) {
	      return fakeWorkerFilesLoadedCapability.promise;
	    }
	    fakeWorkerFilesLoadedCapability = (0, _util.createPromiseCapability)();
	    var loader = fakeWorkerFilesLoader || function (callback) {
	      _util.Util.loadScript(getWorkerSrc(), function () {
	        callback(window.pdfjsDistBuildPdfWorker.WorkerMessageHandler);
	      });
	    };
	    loader(fakeWorkerFilesLoadedCapability.resolve);
	    return fakeWorkerFilesLoadedCapability.promise;
	  }
	  function createCDNWrapper(url) {
	    var wrapper = 'importScripts(\'' + url + '\');';
	    return URL.createObjectURL(new Blob([wrapper]));
	  }
	  var pdfWorkerPorts = new WeakMap();
	  function PDFWorker(name, port) {
	    if (port && pdfWorkerPorts.has(port)) {
	      throw new Error('Cannot use more than one PDFWorker per port');
	    }
	    this.name = name;
	    this.destroyed = false;
	    this.postMessageTransfers = true;
	    this._readyCapability = (0, _util.createPromiseCapability)();
	    this._port = null;
	    this._webWorker = null;
	    this._messageHandler = null;
	    if (port) {
	      pdfWorkerPorts.set(port, this);
	      this._initializeFromPort(port);
	      return;
	    }
	    this._initialize();
	  }
	  PDFWorker.prototype = {
	    get promise() {
	      return this._readyCapability.promise;
	    },
	    get port() {
	      return this._port;
	    },
	    get messageHandler() {
	      return this._messageHandler;
	    },
	    _initializeFromPort: function PDFWorker_initializeFromPort(port) {
	      this._port = port;
	      this._messageHandler = new _util.MessageHandler('main', 'worker', port);
	      this._messageHandler.on('ready', function () {});
	      this._readyCapability.resolve();
	    },
	    _initialize: function PDFWorker_initialize() {
	      var _this6 = this;
	
	      if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)('disableWorker') && typeof Worker !== 'undefined') {
	        var workerSrc = getWorkerSrc();
	        try {
	          if (!(0, _util.isSameOrigin)(window.location.href, workerSrc)) {
	            workerSrc = createCDNWrapper(new URL(workerSrc, window.location).href);
	          }
	          var worker = new Worker(workerSrc);
	          var messageHandler = new _util.MessageHandler('main', 'worker', worker);
	          var terminateEarly = function terminateEarly() {
	            worker.removeEventListener('error', onWorkerError);
	            messageHandler.destroy();
	            worker.terminate();
	            if (_this6.destroyed) {
	              _this6._readyCapability.reject(new Error('Worker was destroyed'));
	            } else {
	              _this6._setupFakeWorker();
	            }
	          };
	          var onWorkerError = function onWorkerError() {
	            if (!_this6._webWorker) {
	              terminateEarly();
	            }
	          };
	          worker.addEventListener('error', onWorkerError);
	          messageHandler.on('test', function (data) {
	            worker.removeEventListener('error', onWorkerError);
	            if (_this6.destroyed) {
	              terminateEarly();
	              return;
	            }
	            var supportTypedArray = data && data.supportTypedArray;
	            if (supportTypedArray) {
	              _this6._messageHandler = messageHandler;
	              _this6._port = worker;
	              _this6._webWorker = worker;
	              if (!data.supportTransfers) {
	                _this6.postMessageTransfers = false;
	                isPostMessageTransfersDisabled = true;
	              }
	              _this6._readyCapability.resolve();
	              messageHandler.send('configure', { verbosity: (0, _util.getVerbosityLevel)() });
	            } else {
	              _this6._setupFakeWorker();
	              messageHandler.destroy();
	              worker.terminate();
	            }
	          });
	          messageHandler.on('ready', function (data) {
	            worker.removeEventListener('error', onWorkerError);
	            if (_this6.destroyed) {
	              terminateEarly();
	              return;
	            }
	            try {
	              sendTest();
	            } catch (e) {
	              _this6._setupFakeWorker();
	            }
	          });
	          var sendTest = function sendTest() {
	            var postMessageTransfers = (0, _dom_utils.getDefaultSetting)('postMessageTransfers') && !isPostMessageTransfersDisabled;
	            var testObj = new Uint8Array([postMessageTransfers ? 255 : 0]);
	            try {
	              messageHandler.send('test', testObj, [testObj.buffer]);
	            } catch (ex) {
	              (0, _util.info)('Cannot use postMessage transfers');
	              testObj[0] = 0;
	              messageHandler.send('test', testObj);
	            }
	          };
	          sendTest();
	          return;
	        } catch (e) {
	          (0, _util.info)('The worker has been disabled.');
	        }
	      }
	      this._setupFakeWorker();
	    },
	    _setupFakeWorker: function PDFWorker_setupFakeWorker() {
	      var _this7 = this;
	
	      if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)('disableWorker')) {
	        (0, _util.warn)('Setting up fake worker.');
	        isWorkerDisabled = true;
	      }
	      setupFakeWorkerGlobal().then(function (WorkerMessageHandler) {
	        if (_this7.destroyed) {
	          _this7._readyCapability.reject(new Error('Worker was destroyed'));
	          return;
	        }
	        var isTypedArraysPresent = Uint8Array !== Float32Array;
	        var port = new LoopbackPort(isTypedArraysPresent);
	        _this7._port = port;
	        var id = 'fake' + nextFakeWorkerId++;
	        var workerHandler = new _util.MessageHandler(id + '_worker', id, port);
	        WorkerMessageHandler.setup(workerHandler, port);
	        var messageHandler = new _util.MessageHandler(id, id + '_worker', port);
	        _this7._messageHandler = messageHandler;
	        _this7._readyCapability.resolve();
	      });
	    },
	    destroy: function PDFWorker_destroy() {
	      this.destroyed = true;
	      if (this._webWorker) {
	        this._webWorker.terminate();
	        this._webWorker = null;
	      }
	      pdfWorkerPorts.delete(this._port);
	      this._port = null;
	      if (this._messageHandler) {
	        this._messageHandler.destroy();
	        this._messageHandler = null;
	      }
	    }
	  };
	  PDFWorker.fromPort = function (port) {
	    if (pdfWorkerPorts.has(port)) {
	      return pdfWorkerPorts.get(port);
	    }
	    return new PDFWorker(null, port);
	  };
	  return PDFWorker;
	}();
	var WorkerTransport = function WorkerTransportClosure() {
	  function WorkerTransport(messageHandler, loadingTask, networkStream, CMapReaderFactory) {
	    this.messageHandler = messageHandler;
	    this.loadingTask = loadingTask;
	    this.commonObjs = new PDFObjects();
	    this.fontLoader = new _font_loader.FontLoader(loadingTask.docId);
	    this.CMapReaderFactory = new CMapReaderFactory({
	      baseUrl: (0, _dom_utils.getDefaultSetting)('cMapUrl'),
	      isCompressed: (0, _dom_utils.getDefaultSetting)('cMapPacked')
	    });
	    this.destroyed = false;
	    this.destroyCapability = null;
	    this._passwordCapability = null;
	    this._networkStream = networkStream;
	    this._fullReader = null;
	    this._lastProgress = null;
	    this.pageCache = [];
	    this.pagePromises = [];
	    this.downloadInfoCapability = (0, _util.createPromiseCapability)();
	    this.setupMessageHandler();
	  }
	  WorkerTransport.prototype = {
	    destroy: function WorkerTransport_destroy() {
	      var _this8 = this;
	
	      if (this.destroyCapability) {
	        return this.destroyCapability.promise;
	      }
	      this.destroyed = true;
	      this.destroyCapability = (0, _util.createPromiseCapability)();
	      if (this._passwordCapability) {
	        this._passwordCapability.reject(new Error('Worker was destroyed during onPassword callback'));
	      }
	      var waitOn = [];
	      this.pageCache.forEach(function (page) {
	        if (page) {
	          waitOn.push(page._destroy());
	        }
	      });
	      this.pageCache = [];
	      this.pagePromises = [];
	      var terminated = this.messageHandler.sendWithPromise('Terminate', null);
	      waitOn.push(terminated);
	      Promise.all(waitOn).then(function () {
	        _this8.fontLoader.clear();
	        if (_this8._networkStream) {
	          _this8._networkStream.cancelAllRequests();
	        }
	        if (_this8.messageHandler) {
	          _this8.messageHandler.destroy();
	          _this8.messageHandler = null;
	        }
	        _this8.destroyCapability.resolve();
	      }, this.destroyCapability.reject);
	      return this.destroyCapability.promise;
	    },
	    setupMessageHandler: function WorkerTransport_setupMessageHandler() {
	      var messageHandler = this.messageHandler;
	      var loadingTask = this.loadingTask;
	      messageHandler.on('GetReader', function (data, sink) {
	        var _this9 = this;
	
	        (0, _util.assert)(this._networkStream);
	        this._fullReader = this._networkStream.getFullReader();
	        this._fullReader.onProgress = function (evt) {
	          _this9._lastProgress = {
	            loaded: evt.loaded,
	            total: evt.total
	          };
	        };
	        sink.onPull = function () {
	          _this9._fullReader.read().then(function (_ref2) {
	            var value = _ref2.value,
	                done = _ref2.done;
	
	            if (done) {
	              sink.close();
	              return;
	            }
	            (0, _util.assert)((0, _util.isArrayBuffer)(value));
	            sink.enqueue(new Uint8Array(value), 1, [value]);
	          }).catch(function (reason) {
	            sink.error(reason);
	          });
	        };
	        sink.onCancel = function (reason) {
	          _this9._fullReader.cancel(reason);
	        };
	      }, this);
	      messageHandler.on('ReaderHeadersReady', function (data) {
	        var _this10 = this;
	
	        var headersCapability = (0, _util.createPromiseCapability)();
	        var fullReader = this._fullReader;
	        fullReader.headersReady.then(function () {
	          if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
	            if (_this10._lastProgress) {
	              var _loadingTask = _this10.loadingTask;
	              if (_loadingTask.onProgress) {
	                _loadingTask.onProgress(_this10._lastProgress);
	              }
	            }
	            fullReader.onProgress = function (evt) {
	              var loadingTask = _this10.loadingTask;
	              if (loadingTask.onProgress) {
	                loadingTask.onProgress({
	                  loaded: evt.loaded,
	                  total: evt.total
	                });
	              }
	            };
	          }
	          headersCapability.resolve({
	            isStreamingSupported: fullReader.isStreamingSupported,
	            isRangeSupported: fullReader.isRangeSupported,
	            contentLength: fullReader.contentLength
	          });
	        }, headersCapability.reject);
	        return headersCapability.promise;
	      }, this);
	      messageHandler.on('GetRangeReader', function (data, sink) {
	        (0, _util.assert)(this._networkStream);
	        var _rangeReader = this._networkStream.getRangeReader(data.begin, data.end);
	        sink.onPull = function () {
	          _rangeReader.read().then(function (_ref3) {
	            var value = _ref3.value,
	                done = _ref3.done;
	
	            if (done) {
	              sink.close();
	              return;
	            }
	            (0, _util.assert)((0, _util.isArrayBuffer)(value));
	            sink.enqueue(new Uint8Array(value), 1, [value]);
	          }).catch(function (reason) {
	            sink.error(reason);
	          });
	        };
	        sink.onCancel = function (reason) {
	          _rangeReader.cancel(reason);
	        };
	      }, this);
	      messageHandler.on('GetDoc', function transportDoc(_ref4) {
	        var pdfInfo = _ref4.pdfInfo;
	
	        this.numPages = pdfInfo.numPages;
	        var loadingTask = this.loadingTask;
	        var pdfDocument = new PDFDocumentProxy(pdfInfo, this, loadingTask);
	        this.pdfDocument = pdfDocument;
	        loadingTask._capability.resolve(pdfDocument);
	      }, this);
	      messageHandler.on('PasswordRequest', function transportPasswordRequest(exception) {
	        var _this11 = this;
	
	        this._passwordCapability = (0, _util.createPromiseCapability)();
	        if (loadingTask.onPassword) {
	          var updatePassword = function updatePassword(password) {
	            _this11._passwordCapability.resolve({ password: password });
	          };
	          loadingTask.onPassword(updatePassword, exception.code);
	        } else {
	          this._passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
	        }
	        return this._passwordCapability.promise;
	      }, this);
	      messageHandler.on('PasswordException', function transportPasswordException(exception) {
	        loadingTask._capability.reject(new _util.PasswordException(exception.message, exception.code));
	      }, this);
	      messageHandler.on('InvalidPDF', function transportInvalidPDF(exception) {
	        this.loadingTask._capability.reject(new _util.InvalidPDFException(exception.message));
	      }, this);
	      messageHandler.on('MissingPDF', function transportMissingPDF(exception) {
	        this.loadingTask._capability.reject(new _util.MissingPDFException(exception.message));
	      }, this);
	      messageHandler.on('UnexpectedResponse', function transportUnexpectedResponse(exception) {
	        this.loadingTask._capability.reject(new _util.UnexpectedResponseException(exception.message, exception.status));
	      }, this);
	      messageHandler.on('UnknownError', function transportUnknownError(exception) {
	        this.loadingTask._capability.reject(new _util.UnknownErrorException(exception.message, exception.details));
	      }, this);
	      messageHandler.on('DataLoaded', function transportPage(data) {
	        this.downloadInfoCapability.resolve(data);
	      }, this);
	      messageHandler.on('PDFManagerReady', function transportPage(data) {}, this);
	      messageHandler.on('StartRenderPage', function transportRender(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var page = this.pageCache[data.pageIndex];
	        page._stats.timeEnd('Page Request');
	        page._startRenderPage(data.transparency, data.intent);
	      }, this);
	      messageHandler.on('RenderPageChunk', function transportRender(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var page = this.pageCache[data.pageIndex];
	        page._renderPageChunk(data.operatorList, data.intent);
	      }, this);
	      messageHandler.on('commonobj', function transportObj(data) {
	        var _this12 = this;
	
	        if (this.destroyed) {
	          return;
	        }
	        var id = data[0];
	        var type = data[1];
	        if (this.commonObjs.hasData(id)) {
	          return;
	        }
	        switch (type) {
	          case 'Font':
	            var exportedData = data[2];
	            if ('error' in exportedData) {
	              var exportedError = exportedData.error;
	              (0, _util.warn)('Error during font loading: ' + exportedError);
	              this.commonObjs.resolve(id, exportedError);
	              break;
	            }
	            var fontRegistry = null;
	            if ((0, _dom_utils.getDefaultSetting)('pdfBug') && _global_scope2.default.FontInspector && _global_scope2.default['FontInspector'].enabled) {
	              fontRegistry = {
	                registerFont: function registerFont(font, url) {
	                  _global_scope2.default['FontInspector'].fontAdded(font, url);
	                }
	              };
	            }
	            var font = new _font_loader.FontFaceObject(exportedData, {
	              isEvalSupported: (0, _dom_utils.getDefaultSetting)('isEvalSupported'),
	              disableFontFace: (0, _dom_utils.getDefaultSetting)('disableFontFace'),
	              fontRegistry: fontRegistry
	            });
	            var fontReady = function fontReady(fontObjs) {
	              _this12.commonObjs.resolve(id, font);
	            };
	            this.fontLoader.bind([font], fontReady);
	            break;
	          case 'FontPath':
	            this.commonObjs.resolve(id, data[2]);
	            break;
	          default:
	            throw new Error('Got unknown common object type ' + type);
	        }
	      }, this);
	      messageHandler.on('obj', function transportObj(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var id = data[0];
	        var pageIndex = data[1];
	        var type = data[2];
	        var pageProxy = this.pageCache[pageIndex];
	        var imageData;
	        if (pageProxy.objs.hasData(id)) {
	          return;
	        }
	        switch (type) {
	          case 'JpegStream':
	            imageData = data[3];
	            (0, _util.loadJpegStream)(id, imageData, pageProxy.objs);
	            break;
	          case 'Image':
	            imageData = data[3];
	            pageProxy.objs.resolve(id, imageData);
	            var MAX_IMAGE_SIZE_TO_STORE = 8000000;
	            if (imageData && 'data' in imageData && imageData.data.length > MAX_IMAGE_SIZE_TO_STORE) {
	              pageProxy.cleanupAfterRender = true;
	            }
	            break;
	          default:
	            throw new Error('Got unknown object type ' + type);
	        }
	      }, this);
	      messageHandler.on('DocProgress', function transportDocProgress(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var loadingTask = this.loadingTask;
	        if (loadingTask.onProgress) {
	          loadingTask.onProgress({
	            loaded: data.loaded,
	            total: data.total
	          });
	        }
	      }, this);
	      messageHandler.on('PageError', function transportError(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var page = this.pageCache[data.pageNum - 1];
	        var intentState = page.intentStates[data.intent];
	        if (intentState.displayReadyCapability) {
	          intentState.displayReadyCapability.reject(data.error);
	        } else {
	          throw new Error(data.error);
	        }
	        if (intentState.operatorList) {
	          intentState.operatorList.lastChunk = true;
	          for (var i = 0; i < intentState.renderTasks.length; i++) {
	            intentState.renderTasks[i].operatorListChanged();
	          }
	        }
	      }, this);
	      messageHandler.on('UnsupportedFeature', function (data) {
	        if (this.destroyed) {
	          return;
	        }
	        var loadingTask = this.loadingTask;
	        if (loadingTask.onUnsupportedFeature) {
	          loadingTask.onUnsupportedFeature(data.featureId);
	        }
	      }, this);
	      messageHandler.on('JpegDecode', function (data) {
	        if (this.destroyed) {
	          return Promise.reject(new Error('Worker was destroyed'));
	        }
	        if (typeof document === 'undefined') {
	          return Promise.reject(new Error('"document" is not defined.'));
	        }
	        var imageUrl = data[0];
	        var components = data[1];
	        if (components !== 3 && components !== 1) {
	          return Promise.reject(new Error('Only 3 components or 1 component can be returned'));
	        }
	        return new Promise(function (resolve, reject) {
	          var img = new Image();
	          img.onload = function () {
	            var width = img.width;
	            var height = img.height;
	            var size = width * height;
	            var rgbaLength = size * 4;
	            var buf = new Uint8Array(size * components);
	            var tmpCanvas = document.createElement('canvas');
	            tmpCanvas.width = width;
	            tmpCanvas.height = height;
	            var tmpCtx = tmpCanvas.getContext('2d');
	            tmpCtx.drawImage(img, 0, 0);
	            var data = tmpCtx.getImageData(0, 0, width, height).data;
	            var i, j;
	            if (components === 3) {
	              for (i = 0, j = 0; i < rgbaLength; i += 4, j += 3) {
	                buf[j] = data[i];
	                buf[j + 1] = data[i + 1];
	                buf[j + 2] = data[i + 2];
	              }
	            } else if (components === 1) {
	              for (i = 0, j = 0; i < rgbaLength; i += 4, j++) {
	                buf[j] = data[i];
	              }
	            }
	            resolve({
	              data: buf,
	              width: width,
	              height: height
	            });
	          };
	          img.onerror = function () {
	            reject(new Error('JpegDecode failed to load image'));
	          };
	          img.src = imageUrl;
	        });
	      }, this);
	      messageHandler.on('FetchBuiltInCMap', function (data) {
	        if (this.destroyed) {
	          return Promise.reject(new Error('Worker was destroyed'));
	        }
	        return this.CMapReaderFactory.fetch({ name: data.name });
	      }, this);
	    },
	    getData: function WorkerTransport_getData() {
	      return this.messageHandler.sendWithPromise('GetData', null);
	    },
	    getPage: function getPage(pageNumber) {
	      var _this13 = this;
	
	      if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this.numPages) {
	        return Promise.reject(new Error('Invalid page request'));
	      }
	      var pageIndex = pageNumber - 1;
	      if (pageIndex in this.pagePromises) {
	        return this.pagePromises[pageIndex];
	      }
	      var promise = this.messageHandler.sendWithPromise('GetPage', { pageIndex: pageIndex }).then(function (pageInfo) {
	        if (_this13.destroyed) {
	          throw new Error('Transport destroyed');
	        }
	        var page = new PDFPageProxy(pageIndex, pageInfo, _this13);
	        _this13.pageCache[pageIndex] = page;
	        return page;
	      });
	      this.pagePromises[pageIndex] = promise;
	      return promise;
	    },
	
	    getPageIndex: function WorkerTransport_getPageIndexByRef(ref) {
	      return this.messageHandler.sendWithPromise('GetPageIndex', { ref: ref }).catch(function (reason) {
	        return Promise.reject(new Error(reason));
	      });
	    },
	    getAnnotations: function WorkerTransport_getAnnotations(pageIndex, intent) {
	      return this.messageHandler.sendWithPromise('GetAnnotations', {
	        pageIndex: pageIndex,
	        intent: intent
	      });
	    },
	    getDestinations: function WorkerTransport_getDestinations() {
	      return this.messageHandler.sendWithPromise('GetDestinations', null);
	    },
	    getDestination: function WorkerTransport_getDestination(id) {
	      return this.messageHandler.sendWithPromise('GetDestination', { id: id });
	    },
	    getPageLabels: function WorkerTransport_getPageLabels() {
	      return this.messageHandler.sendWithPromise('GetPageLabels', null);
	    },
	    getPageMode: function getPageMode() {
	      return this.messageHandler.sendWithPromise('GetPageMode', null);
	    },
	
	    getAttachments: function WorkerTransport_getAttachments() {
	      return this.messageHandler.sendWithPromise('GetAttachments', null);
	    },
	    getJavaScript: function WorkerTransport_getJavaScript() {
	      return this.messageHandler.sendWithPromise('GetJavaScript', null);
	    },
	    getOutline: function WorkerTransport_getOutline() {
	      return this.messageHandler.sendWithPromise('GetOutline', null);
	    },
	    getMetadata: function WorkerTransport_getMetadata() {
	      var _this14 = this;
	
	      return this.messageHandler.sendWithPromise('GetMetadata', null).then(function (results) {
	        return {
	          info: results[0],
	          metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
	          contentDispositionFilename: _this14._fullReader ? _this14._fullReader.filename : null
	        };
	      });
	    },
	    getStats: function WorkerTransport_getStats() {
	      return this.messageHandler.sendWithPromise('GetStats', null);
	    },
	    startCleanup: function WorkerTransport_startCleanup() {
	      var _this15 = this;
	
	      this.messageHandler.sendWithPromise('Cleanup', null).then(function () {
	        for (var i = 0, ii = _this15.pageCache.length; i < ii; i++) {
	          var page = _this15.pageCache[i];
	          if (page) {
	            page.cleanup();
	          }
	        }
	        _this15.commonObjs.clear();
	        _this15.fontLoader.clear();
	      });
	    }
	  };
	  return WorkerTransport;
	}();
	var PDFObjects = function PDFObjectsClosure() {
	  function PDFObjects() {
	    this.objs = Object.create(null);
	  }
	  PDFObjects.prototype = {
	    ensureObj: function PDFObjects_ensureObj(objId) {
	      if (this.objs[objId]) {
	        return this.objs[objId];
	      }
	      var obj = {
	        capability: (0, _util.createPromiseCapability)(),
	        data: null,
	        resolved: false
	      };
	      this.objs[objId] = obj;
	      return obj;
	    },
	    get: function PDFObjects_get(objId, callback) {
	      if (callback) {
	        this.ensureObj(objId).capability.promise.then(callback);
	        return null;
	      }
	      var obj = this.objs[objId];
	      if (!obj || !obj.resolved) {
	        throw new Error('Requesting object that isn\'t resolved yet ' + objId);
	      }
	      return obj.data;
	    },
	    resolve: function PDFObjects_resolve(objId, data) {
	      var obj = this.ensureObj(objId);
	      obj.resolved = true;
	      obj.data = data;
	      obj.capability.resolve(data);
	    },
	    isResolved: function PDFObjects_isResolved(objId) {
	      var objs = this.objs;
	      if (!objs[objId]) {
	        return false;
	      }
	      return objs[objId].resolved;
	    },
	    hasData: function PDFObjects_hasData(objId) {
	      return this.isResolved(objId);
	    },
	    getData: function PDFObjects_getData(objId) {
	      var objs = this.objs;
	      if (!objs[objId] || !objs[objId].resolved) {
	        return null;
	      }
	      return objs[objId].data;
	    },
	    clear: function PDFObjects_clear() {
	      this.objs = Object.create(null);
	    }
	  };
	  return PDFObjects;
	}();
	var RenderTask = function RenderTaskClosure() {
	  function RenderTask(internalRenderTask) {
	    this._internalRenderTask = internalRenderTask;
	    this.onContinue = null;
	  }
	  RenderTask.prototype = {
	    get promise() {
	      return this._internalRenderTask.capability.promise;
	    },
	    cancel: function RenderTask_cancel() {
	      this._internalRenderTask.cancel();
	    },
	    then: function RenderTask_then(onFulfilled, onRejected) {
	      return this.promise.then.apply(this.promise, arguments);
	    }
	  };
	  return RenderTask;
	}();
	var InternalRenderTask = function InternalRenderTaskClosure() {
	  var canvasInRendering = new WeakMap();
	  function InternalRenderTask(callback, params, objs, commonObjs, operatorList, pageNumber, canvasFactory, webGLContext) {
	    this.callback = callback;
	    this.params = params;
	    this.objs = objs;
	    this.commonObjs = commonObjs;
	    this.operatorListIdx = null;
	    this.operatorList = operatorList;
	    this.pageNumber = pageNumber;
	    this.canvasFactory = canvasFactory;
	    this.webGLContext = webGLContext;
	    this.running = false;
	    this.graphicsReadyCallback = null;
	    this.graphicsReady = false;
	    this.useRequestAnimationFrame = false;
	    this.cancelled = false;
	    this.capability = (0, _util.createPromiseCapability)();
	    this.task = new RenderTask(this);
	    this._continueBound = this._continue.bind(this);
	    this._scheduleNextBound = this._scheduleNext.bind(this);
	    this._nextBound = this._next.bind(this);
	    this._canvas = params.canvasContext.canvas;
	  }
	  InternalRenderTask.prototype = {
	    initializeGraphics: function InternalRenderTask_initializeGraphics(transparency) {
	      if (this._canvas) {
	        if (canvasInRendering.has(this._canvas)) {
	          throw new Error('Cannot use the same canvas during multiple render() operations. ' + 'Use different canvas or ensure previous operations were ' + 'cancelled or completed.');
	        }
	        canvasInRendering.set(this._canvas, this);
	      }
	      if (this.cancelled) {
	        return;
	      }
	      if ((0, _dom_utils.getDefaultSetting)('pdfBug') && _global_scope2.default.StepperManager && _global_scope2.default.StepperManager.enabled) {
	        this.stepper = _global_scope2.default.StepperManager.create(this.pageNumber - 1);
	        this.stepper.init(this.operatorList);
	        this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
	      }
	      var params = this.params;
	      this.gfx = new _canvas.CanvasGraphics(params.canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.webGLContext, params.imageLayer);
	      this.gfx.beginDrawing({
	        transform: params.transform,
	        viewport: params.viewport,
	        transparency: transparency,
	        background: params.background
	      });
	      this.operatorListIdx = 0;
	      this.graphicsReady = true;
	      if (this.graphicsReadyCallback) {
	        this.graphicsReadyCallback();
	      }
	    },
	    cancel: function InternalRenderTask_cancel() {
	      this.running = false;
	      this.cancelled = true;
	      if (this._canvas) {
	        canvasInRendering.delete(this._canvas);
	      }
	      this.callback(new _dom_utils.RenderingCancelledException('Rendering cancelled, page ' + this.pageNumber, 'canvas'));
	    },
	    operatorListChanged: function InternalRenderTask_operatorListChanged() {
	      if (!this.graphicsReady) {
	        if (!this.graphicsReadyCallback) {
	          this.graphicsReadyCallback = this._continueBound;
	        }
	        return;
	      }
	      if (this.stepper) {
	        this.stepper.updateOperatorList(this.operatorList);
	      }
	      if (this.running) {
	        return;
	      }
	      this._continue();
	    },
	    _continue: function InternalRenderTask__continue() {
	      this.running = true;
	      if (this.cancelled) {
	        return;
	      }
	      if (this.task.onContinue) {
	        this.task.onContinue(this._scheduleNextBound);
	      } else {
	        this._scheduleNext();
	      }
	    },
	    _scheduleNext: function InternalRenderTask__scheduleNext() {
	      if (this.useRequestAnimationFrame && typeof window !== 'undefined') {
	        window.requestAnimationFrame(this._nextBound);
	      } else {
	        Promise.resolve(undefined).then(this._nextBound);
	      }
	    },
	    _next: function InternalRenderTask__next() {
	      if (this.cancelled) {
	        return;
	      }
	      this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
	      if (this.operatorListIdx === this.operatorList.argsArray.length) {
	        this.running = false;
	        if (this.operatorList.lastChunk) {
	          this.gfx.endDrawing();
	          if (this._canvas) {
	            canvasInRendering.delete(this._canvas);
	          }
	          this.callback();
	        }
	      }
	    }
	  };
	  return InternalRenderTask;
	}();
	var version, build;
	{
	  exports.version = version = '2.0.305';
	  exports.build = build = '9c6a8801';
	}
	exports.getDocument = getDocument;
	exports.LoopbackPort = LoopbackPort;
	exports.PDFDataRangeTransport = PDFDataRangeTransport;
	exports.PDFWorker = PDFWorker;
	exports.PDFDocumentProxy = PDFDocumentProxy;
	exports.PDFPageProxy = PDFPageProxy;
	exports.setPDFNetworkStreamFactory = setPDFNetworkStreamFactory;
	exports.version = version;
	exports.build = build;
	
	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Metadata = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __w_pdfjs_require__(0);
	
	var _dom_utils = __w_pdfjs_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Metadata = function () {
	  function Metadata(data) {
	    _classCallCheck(this, Metadata);
	
	    (0, _util.assert)(typeof data === 'string', 'Metadata: input is not a string');
	    data = this._repair(data);
	    var parser = new _dom_utils.SimpleXMLParser();
	    data = parser.parseFromString(data);
	    this._metadata = Object.create(null);
	    this._parse(data);
	  }
	
	  _createClass(Metadata, [{
	    key: '_repair',
	    value: function _repair(data) {
	      return data.replace(/>\\376\\377([^<]+)/g, function (all, codes) {
	        var bytes = codes.replace(/\\([0-3])([0-7])([0-7])/g, function (code, d1, d2, d3) {
	          return String.fromCharCode(d1 * 64 + d2 * 8 + d3 * 1);
	        }).replace(/&(amp|apos|gt|lt|quot);/g, function (str, name) {
	          switch (name) {
	            case 'amp':
	              return '&';
	            case 'apos':
	              return '\'';
	            case 'gt':
	              return '>';
	            case 'lt':
	              return '<';
	            case 'quot':
	              return '\"';
	          }
	          throw new Error('_repair: ' + name + ' isn\'t defined.');
	        });
	        var chars = '';
	        for (var i = 0, ii = bytes.length; i < ii; i += 2) {
	          var code = bytes.charCodeAt(i) * 256 + bytes.charCodeAt(i + 1);
	          if (code >= 32 && code < 127 && code !== 60 && code !== 62 && code !== 38) {
	            chars += String.fromCharCode(code);
	          } else {
	            chars += '&#x' + (0x10000 + code).toString(16).substring(1) + ';';
	          }
	        }
	        return '>' + chars;
	      });
	    }
	  }, {
	    key: '_parse',
	    value: function _parse(domDocument) {
	      var rdf = domDocument.documentElement;
	      if (rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
	        rdf = rdf.firstChild;
	        while (rdf && rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
	          rdf = rdf.nextSibling;
	        }
	      }
	      var nodeName = rdf ? rdf.nodeName.toLowerCase() : null;
	      if (!rdf || nodeName !== 'rdf:rdf' || !rdf.hasChildNodes()) {
	        return;
	      }
	      var children = rdf.childNodes;
	      for (var i = 0, ii = children.length; i < ii; i++) {
	        var desc = children[i];
	        if (desc.nodeName.toLowerCase() !== 'rdf:description') {
	          continue;
	        }
	        for (var j = 0, jj = desc.childNodes.length; j < jj; j++) {
	          if (desc.childNodes[j].nodeName.toLowerCase() !== '#text') {
	            var entry = desc.childNodes[j];
	            var name = entry.nodeName.toLowerCase();
	            this._metadata[name] = entry.textContent.trim();
	          }
	        }
	      }
	    }
	  }, {
	    key: 'get',
	    value: function get(name) {
	      return this._metadata[name] || null;
	    }
	  }, {
	    key: 'getAll',
	    value: function getAll() {
	      return this._metadata;
	    }
	  }, {
	    key: 'has',
	    value: function has(name) {
	      return typeof this._metadata[name] !== 'undefined';
	    }
	  }]);
	
	  return Metadata;
	}();
	
	exports.Metadata = Metadata;
	
	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AnnotationLayer = undefined;
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dom_utils = __w_pdfjs_require__(10);
	
	var _util = __w_pdfjs_require__(0);
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AnnotationElementFactory = function () {
	  function AnnotationElementFactory() {
	    _classCallCheck(this, AnnotationElementFactory);
	  }
	
	  _createClass(AnnotationElementFactory, null, [{
	    key: 'create',
	    value: function create(parameters) {
	      var subtype = parameters.data.annotationType;
	      switch (subtype) {
	        case _util.AnnotationType.LINK:
	          return new LinkAnnotationElement(parameters);
	        case _util.AnnotationType.TEXT:
	          return new TextAnnotationElement(parameters);
	        case _util.AnnotationType.WIDGET:
	          var fieldType = parameters.data.fieldType;
	          switch (fieldType) {
	            case 'Tx':
	              return new TextWidgetAnnotationElement(parameters);
	            case 'Btn':
	              if (parameters.data.radioButton) {
	                return new RadioButtonWidgetAnnotationElement(parameters);
	              } else if (parameters.data.checkBox) {
	                return new CheckboxWidgetAnnotationElement(parameters);
	              }
	              return new PushButtonWidgetAnnotationElement(parameters);
	            case 'Ch':
	              return new ChoiceWidgetAnnotationElement(parameters);
	          }
	          return new WidgetAnnotationElement(parameters);
	        case _util.AnnotationType.POPUP:
	          return new PopupAnnotationElement(parameters);
	        case _util.AnnotationType.LINE:
	          return new LineAnnotationElement(parameters);
	        case _util.AnnotationType.SQUARE:
	          return new SquareAnnotationElement(parameters);
	        case _util.AnnotationType.CIRCLE:
	          return new CircleAnnotationElement(parameters);
	        case _util.AnnotationType.POLYLINE:
	          return new PolylineAnnotationElement(parameters);
	        case _util.AnnotationType.POLYGON:
	          return new PolygonAnnotationElement(parameters);
	        case _util.AnnotationType.HIGHLIGHT:
	          return new HighlightAnnotationElement(parameters);
	        case _util.AnnotationType.UNDERLINE:
	          return new UnderlineAnnotationElement(parameters);
	        case _util.AnnotationType.SQUIGGLY:
	          return new SquigglyAnnotationElement(parameters);
	        case _util.AnnotationType.STRIKEOUT:
	          return new StrikeOutAnnotationElement(parameters);
	        case _util.AnnotationType.STAMP:
	          return new StampAnnotationElement(parameters);
	        case _util.AnnotationType.FILEATTACHMENT:
	          return new FileAttachmentAnnotationElement(parameters);
	        default:
	          return new AnnotationElement(parameters);
	      }
	    }
	  }]);
	
	  return AnnotationElementFactory;
	}();
	
	var AnnotationElement = function () {
	  function AnnotationElement(parameters) {
	    var isRenderable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    var ignoreBorder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    _classCallCheck(this, AnnotationElement);
	
	    this.isRenderable = isRenderable;
	    this.data = parameters.data;
	    this.layer = parameters.layer;
	    this.page = parameters.page;
	    this.viewport = parameters.viewport;
	    this.linkService = parameters.linkService;
	    this.downloadManager = parameters.downloadManager;
	    this.imageResourcesPath = parameters.imageResourcesPath;
	    this.renderInteractiveForms = parameters.renderInteractiveForms;
	    this.svgFactory = parameters.svgFactory;
	    if (isRenderable) {
	      this.container = this._createContainer(ignoreBorder);
	    }
	  }
	
	  _createClass(AnnotationElement, [{
	    key: '_createContainer',
	    value: function _createContainer() {
	      var ignoreBorder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var data = this.data,
	          page = this.page,
	          viewport = this.viewport;
	      var container = document.createElement('section');
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      container.setAttribute('data-annotation-id', data.id);
	      var rect = _util.Util.normalizeRect([data.rect[0], page.view[3] - data.rect[1] + page.view[1], data.rect[2], page.view[3] - data.rect[3] + page.view[1]]);
	      container.style.transform = 'matrix(' + viewport.transform.join(',') + ')';
	      container.style.transformOrigin = -rect[0] + 'px ' + -rect[1] + 'px';
	      if (!ignoreBorder && data.borderStyle.width > 0) {
	        container.style.borderWidth = data.borderStyle.width + 'px';
	        if (data.borderStyle.style !== _util.AnnotationBorderStyleType.UNDERLINE) {
	          width = width - 2 * data.borderStyle.width;
	          height = height - 2 * data.borderStyle.width;
	        }
	        var horizontalRadius = data.borderStyle.horizontalCornerRadius;
	        var verticalRadius = data.borderStyle.verticalCornerRadius;
	        if (horizontalRadius > 0 || verticalRadius > 0) {
	          var radius = horizontalRadius + 'px / ' + verticalRadius + 'px';
	          container.style.borderRadius = radius;
	        }
	        switch (data.borderStyle.style) {
	          case _util.AnnotationBorderStyleType.SOLID:
	            container.style.borderStyle = 'solid';
	            break;
	          case _util.AnnotationBorderStyleType.DASHED:
	            container.style.borderStyle = 'dashed';
	            break;
	          case _util.AnnotationBorderStyleType.BEVELED:
	            (0, _util.warn)('Unimplemented border style: beveled');
	            break;
	          case _util.AnnotationBorderStyleType.INSET:
	            (0, _util.warn)('Unimplemented border style: inset');
	            break;
	          case _util.AnnotationBorderStyleType.UNDERLINE:
	            container.style.borderBottomStyle = 'solid';
	            break;
	          default:
	            break;
	        }
	        if (data.color) {
	          container.style.borderColor = _util.Util.makeCssRgb(data.color[0] | 0, data.color[1] | 0, data.color[2] | 0);
	        } else {
	          container.style.borderWidth = 0;
	        }
	      }
	      container.style.left = rect[0] + 'px';
	      container.style.top = rect[1] + 'px';
	      container.style.width = width + 'px';
	      container.style.height = height + 'px';
	      return container;
	    }
	  }, {
	    key: '_createPopup',
	    value: function _createPopup(container, trigger, data) {
	      if (!trigger) {
	        trigger = document.createElement('div');
	        trigger.style.height = container.style.height;
	        trigger.style.width = container.style.width;
	        container.appendChild(trigger);
	      }
	      var popupElement = new PopupElement({
	        container: container,
	        trigger: trigger,
	        color: data.color,
	        title: data.title,
	        contents: data.contents,
	        hideWrapper: true
	      });
	      var popup = popupElement.render();
	      popup.style.left = container.style.width;
	      container.appendChild(popup);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      (0, _util.unreachable)('Abstract method `AnnotationElement.render` called');
	    }
	  }]);
	
	  return AnnotationElement;
	}();
	
	var LinkAnnotationElement = function (_AnnotationElement) {
	  _inherits(LinkAnnotationElement, _AnnotationElement);
	
	  function LinkAnnotationElement(parameters) {
	    _classCallCheck(this, LinkAnnotationElement);
	
	    var isRenderable = !!(parameters.data.url || parameters.data.dest || parameters.data.action);
	    return _possibleConstructorReturn(this, (LinkAnnotationElement.__proto__ || Object.getPrototypeOf(LinkAnnotationElement)).call(this, parameters, isRenderable));
	  }
	
	  _createClass(LinkAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'linkAnnotation';
	      var link = document.createElement('a');
	      (0, _dom_utils.addLinkAttributes)(link, {
	        url: this.data.url,
	        target: this.data.newWindow ? _dom_utils.LinkTarget.BLANK : undefined
	      });
	      if (!this.data.url) {
	        if (this.data.action) {
	          this._bindNamedAction(link, this.data.action);
	        } else {
	          this._bindLink(link, this.data.dest);
	        }
	      }
	      this.container.appendChild(link);
	      return this.container;
	    }
	  }, {
	    key: '_bindLink',
	    value: function _bindLink(link, destination) {
	      var _this2 = this;
	
	      link.href = this.linkService.getDestinationHash(destination);
	      link.onclick = function () {
	        if (destination) {
	          _this2.linkService.navigateTo(destination);
	        }
	        return false;
	      };
	      if (destination) {
	        link.className = 'internalLink';
	      }
	    }
	  }, {
	    key: '_bindNamedAction',
	    value: function _bindNamedAction(link, action) {
	      var _this3 = this;
	
	      link.href = this.linkService.getAnchorUrl('');
	      link.onclick = function () {
	        _this3.linkService.executeNamedAction(action);
	        return false;
	      };
	      link.className = 'internalLink';
	    }
	  }]);
	
	  return LinkAnnotationElement;
	}(AnnotationElement);
	
	var TextAnnotationElement = function (_AnnotationElement2) {
	  _inherits(TextAnnotationElement, _AnnotationElement2);
	
	  function TextAnnotationElement(parameters) {
	    _classCallCheck(this, TextAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (TextAnnotationElement.__proto__ || Object.getPrototypeOf(TextAnnotationElement)).call(this, parameters, isRenderable));
	  }
	
	  _createClass(TextAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'textAnnotation';
	      var image = document.createElement('img');
	      image.style.height = this.container.style.height;
	      image.style.width = this.container.style.width;
	      image.src = this.imageResourcesPath + 'annotation-' + this.data.name.toLowerCase() + '.svg';
	      image.alt = '[{{type}} Annotation]';
	      image.dataset.l10nId = 'text_annotation_type';
	      image.dataset.l10nArgs = JSON.stringify({ type: this.data.name });
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, image, this.data);
	      }
	      this.container.appendChild(image);
	      return this.container;
	    }
	  }]);
	
	  return TextAnnotationElement;
	}(AnnotationElement);
	
	var WidgetAnnotationElement = function (_AnnotationElement3) {
	  _inherits(WidgetAnnotationElement, _AnnotationElement3);
	
	  function WidgetAnnotationElement() {
	    _classCallCheck(this, WidgetAnnotationElement);
	
	    return _possibleConstructorReturn(this, (WidgetAnnotationElement.__proto__ || Object.getPrototypeOf(WidgetAnnotationElement)).apply(this, arguments));
	  }
	
	  _createClass(WidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      return this.container;
	    }
	  }]);
	
	  return WidgetAnnotationElement;
	}(AnnotationElement);
	
	var TextWidgetAnnotationElement = function (_WidgetAnnotationElem) {
	  _inherits(TextWidgetAnnotationElement, _WidgetAnnotationElem);
	
	  function TextWidgetAnnotationElement(parameters) {
	    _classCallCheck(this, TextWidgetAnnotationElement);
	
	    var isRenderable = parameters.renderInteractiveForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
	    return _possibleConstructorReturn(this, (TextWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(TextWidgetAnnotationElement)).call(this, parameters, isRenderable));
	  }
	
	  _createClass(TextWidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      var TEXT_ALIGNMENT = ['left', 'center', 'right'];
	      this.container.className = 'textWidgetAnnotation';
	      var element = null;
	      if (this.renderInteractiveForms) {
	        if (this.data.multiLine) {
	          element = document.createElement('textarea');
	          element.textContent = this.data.fieldValue;
	        } else {
	          element = document.createElement('input');
	          element.type = 'text';
	          element.setAttribute('value', this.data.fieldValue);
	        }
	        element.disabled = this.data.readOnly;
	        if (this.data.maxLen !== null) {
	          element.maxLength = this.data.maxLen;
	        }
	        if (this.data.comb) {
	          var fieldWidth = this.data.rect[2] - this.data.rect[0];
	          var combWidth = fieldWidth / this.data.maxLen;
	          element.classList.add('comb');
	          element.style.letterSpacing = 'calc(' + combWidth + 'px - 1ch)';
	        }
	      } else {
	        element = document.createElement('div');
	        element.textContent = this.data.fieldValue;
	        element.style.verticalAlign = 'middle';
	        element.style.display = 'table-cell';
	        var font = null;
	        if (this.data.fontRefName) {
	          font = this.page.commonObjs.getData(this.data.fontRefName);
	        }
	        this._setTextStyle(element, font);
	      }
	      if (this.data.textAlignment !== null) {
	        element.style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
	      }
	      this.container.appendChild(element);
	      return this.container;
	    }
	  }, {
	    key: '_setTextStyle',
	    value: function _setTextStyle(element, font) {
	      var style = element.style;
	      style.fontSize = this.data.fontSize + 'px';
	      style.direction = this.data.fontDirection < 0 ? 'rtl' : 'ltr';
	      if (!font) {
	        return;
	      }
	      style.fontWeight = font.black ? font.bold ? '900' : 'bold' : font.bold ? 'bold' : 'normal';
	      style.fontStyle = font.italic ? 'italic' : 'normal';
	      var fontFamily = font.loadedName ? '"' + font.loadedName + '", ' : '';
	      var fallbackName = font.fallbackName || 'Helvetica, sans-serif';
	      style.fontFamily = fontFamily + fallbackName;
	    }
	  }]);
	
	  return TextWidgetAnnotationElement;
	}(WidgetAnnotationElement);
	
	var CheckboxWidgetAnnotationElement = function (_WidgetAnnotationElem2) {
	  _inherits(CheckboxWidgetAnnotationElement, _WidgetAnnotationElem2);
	
	  function CheckboxWidgetAnnotationElement(parameters) {
	    _classCallCheck(this, CheckboxWidgetAnnotationElement);
	
	    return _possibleConstructorReturn(this, (CheckboxWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(CheckboxWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
	  }
	
	  _createClass(CheckboxWidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'buttonWidgetAnnotation checkBox';
	      var element = document.createElement('input');
	      element.disabled = this.data.readOnly;
	      element.type = 'checkbox';
	      if (this.data.fieldValue && this.data.fieldValue !== 'Off') {
	        element.setAttribute('checked', true);
	      }
	      this.container.appendChild(element);
	      return this.container;
	    }
	  }]);
	
	  return CheckboxWidgetAnnotationElement;
	}(WidgetAnnotationElement);
	
	var RadioButtonWidgetAnnotationElement = function (_WidgetAnnotationElem3) {
	  _inherits(RadioButtonWidgetAnnotationElement, _WidgetAnnotationElem3);
	
	  function RadioButtonWidgetAnnotationElement(parameters) {
	    _classCallCheck(this, RadioButtonWidgetAnnotationElement);
	
	    return _possibleConstructorReturn(this, (RadioButtonWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(RadioButtonWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
	  }
	
	  _createClass(RadioButtonWidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'buttonWidgetAnnotation radioButton';
	      var element = document.createElement('input');
	      element.disabled = this.data.readOnly;
	      element.type = 'radio';
	      element.name = this.data.fieldName;
	      if (this.data.fieldValue === this.data.buttonValue) {
	        element.setAttribute('checked', true);
	      }
	      this.container.appendChild(element);
	      return this.container;
	    }
	  }]);
	
	  return RadioButtonWidgetAnnotationElement;
	}(WidgetAnnotationElement);
	
	var PushButtonWidgetAnnotationElement = function (_LinkAnnotationElemen) {
	  _inherits(PushButtonWidgetAnnotationElement, _LinkAnnotationElemen);
	
	  function PushButtonWidgetAnnotationElement() {
	    _classCallCheck(this, PushButtonWidgetAnnotationElement);
	
	    return _possibleConstructorReturn(this, (PushButtonWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(PushButtonWidgetAnnotationElement)).apply(this, arguments));
	  }
	
	  _createClass(PushButtonWidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      var container = _get(PushButtonWidgetAnnotationElement.prototype.__proto__ || Object.getPrototypeOf(PushButtonWidgetAnnotationElement.prototype), 'render', this).call(this);
	      container.className = 'buttonWidgetAnnotation pushButton';
	      return container;
	    }
	  }]);
	
	  return PushButtonWidgetAnnotationElement;
	}(LinkAnnotationElement);
	
	var ChoiceWidgetAnnotationElement = function (_WidgetAnnotationElem4) {
	  _inherits(ChoiceWidgetAnnotationElement, _WidgetAnnotationElem4);
	
	  function ChoiceWidgetAnnotationElement(parameters) {
	    _classCallCheck(this, ChoiceWidgetAnnotationElement);
	
	    return _possibleConstructorReturn(this, (ChoiceWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(ChoiceWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
	  }
	
	  _createClass(ChoiceWidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'choiceWidgetAnnotation';
	      var selectElement = document.createElement('select');
	      selectElement.disabled = this.data.readOnly;
	      if (!this.data.combo) {
	        selectElement.size = this.data.options.length;
	        if (this.data.multiSelect) {
	          selectElement.multiple = true;
	        }
	      }
	      for (var i = 0, ii = this.data.options.length; i < ii; i++) {
	        var option = this.data.options[i];
	        var optionElement = document.createElement('option');
	        optionElement.textContent = option.displayValue;
	        optionElement.value = option.exportValue;
	        if (this.data.fieldValue.indexOf(option.displayValue) >= 0) {
	          optionElement.setAttribute('selected', true);
	        }
	        selectElement.appendChild(optionElement);
	      }
	      this.container.appendChild(selectElement);
	      return this.container;
	    }
	  }]);
	
	  return ChoiceWidgetAnnotationElement;
	}(WidgetAnnotationElement);
	
	var PopupAnnotationElement = function (_AnnotationElement4) {
	  _inherits(PopupAnnotationElement, _AnnotationElement4);
	
	  function PopupAnnotationElement(parameters) {
	    _classCallCheck(this, PopupAnnotationElement);
	
	    var isRenderable = !!(parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (PopupAnnotationElement.__proto__ || Object.getPrototypeOf(PopupAnnotationElement)).call(this, parameters, isRenderable));
	  }
	
	  _createClass(PopupAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      var IGNORE_TYPES = ['Line', 'Square', 'Circle', 'PolyLine', 'Polygon'];
	      this.container.className = 'popupAnnotation';
	      if (IGNORE_TYPES.indexOf(this.data.parentType) >= 0) {
	        return this.container;
	      }
	      var selector = '[data-annotation-id="' + this.data.parentId + '"]';
	      var parentElement = this.layer.querySelector(selector);
	      if (!parentElement) {
	        return this.container;
	      }
	      var popup = new PopupElement({
	        container: this.container,
	        trigger: parentElement,
	        color: this.data.color,
	        title: this.data.title,
	        contents: this.data.contents
	      });
	      var parentLeft = parseFloat(parentElement.style.left);
	      var parentWidth = parseFloat(parentElement.style.width);
	      this.container.style.transformOrigin = -(parentLeft + parentWidth) + 'px -' + parentElement.style.top;
	      this.container.style.left = parentLeft + parentWidth + 'px';
	      this.container.appendChild(popup.render());
	      return this.container;
	    }
	  }]);
	
	  return PopupAnnotationElement;
	}(AnnotationElement);
	
	var PopupElement = function () {
	  function PopupElement(parameters) {
	    _classCallCheck(this, PopupElement);
	
	    this.container = parameters.container;
	    this.trigger = parameters.trigger;
	    this.color = parameters.color;
	    this.title = parameters.title;
	    this.contents = parameters.contents;
	    this.hideWrapper = parameters.hideWrapper || false;
	    this.pinned = false;
	  }
	
	  _createClass(PopupElement, [{
	    key: 'render',
	    value: function render() {
	      var BACKGROUND_ENLIGHT = 0.7;
	      var wrapper = document.createElement('div');
	      wrapper.className = 'popupWrapper';
	      this.hideElement = this.hideWrapper ? wrapper : this.container;
	      this.hideElement.setAttribute('hidden', true);
	      var popup = document.createElement('div');
	      popup.className = 'popup';
	      var color = this.color;
	      if (color) {
	        var r = BACKGROUND_ENLIGHT * (255 - color[0]) + color[0];
	        var g = BACKGROUND_ENLIGHT * (255 - color[1]) + color[1];
	        var b = BACKGROUND_ENLIGHT * (255 - color[2]) + color[2];
	        popup.style.backgroundColor = _util.Util.makeCssRgb(r | 0, g | 0, b | 0);
	      }
	      var contents = this._formatContents(this.contents);
	      var title = document.createElement('h1');
	      title.textContent = this.title;
	      this.trigger.addEventListener('click', this._toggle.bind(this));
	      this.trigger.addEventListener('mouseover', this._show.bind(this, false));
	      this.trigger.addEventListener('mouseout', this._hide.bind(this, false));
	      popup.addEventListener('click', this._hide.bind(this, true));
	      popup.appendChild(title);
	      popup.appendChild(contents);
	      wrapper.appendChild(popup);
	      return wrapper;
	    }
	  }, {
	    key: '_formatContents',
	    value: function _formatContents(contents) {
	      var p = document.createElement('p');
	      var lines = contents.split(/(?:\r\n?|\n)/);
	      for (var i = 0, ii = lines.length; i < ii; ++i) {
	        var line = lines[i];
	        p.appendChild(document.createTextNode(line));
	        if (i < ii - 1) {
	          p.appendChild(document.createElement('br'));
	        }
	      }
	      return p;
	    }
	  }, {
	    key: '_toggle',
	    value: function _toggle() {
	      if (this.pinned) {
	        this._hide(true);
	      } else {
	        this._show(true);
	      }
	    }
	  }, {
	    key: '_show',
	    value: function _show() {
	      var pin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (pin) {
	        this.pinned = true;
	      }
	      if (this.hideElement.hasAttribute('hidden')) {
	        this.hideElement.removeAttribute('hidden');
	        this.container.style.zIndex += 1;
	      }
	    }
	  }, {
	    key: '_hide',
	    value: function _hide() {
	      var unpin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (unpin) {
	        this.pinned = false;
	      }
	      if (!this.hideElement.hasAttribute('hidden') && !this.pinned) {
	        this.hideElement.setAttribute('hidden', true);
	        this.container.style.zIndex -= 1;
	      }
	    }
	  }]);
	
	  return PopupElement;
	}();
	
	var LineAnnotationElement = function (_AnnotationElement5) {
	  _inherits(LineAnnotationElement, _AnnotationElement5);
	
	  function LineAnnotationElement(parameters) {
	    _classCallCheck(this, LineAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (LineAnnotationElement.__proto__ || Object.getPrototypeOf(LineAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(LineAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'lineAnnotation';
	      var data = this.data;
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      var svg = this.svgFactory.create(width, height);
	      var line = this.svgFactory.createElement('svg:line');
	      line.setAttribute('x1', data.rect[2] - data.lineCoordinates[0]);
	      line.setAttribute('y1', data.rect[3] - data.lineCoordinates[1]);
	      line.setAttribute('x2', data.rect[2] - data.lineCoordinates[2]);
	      line.setAttribute('y2', data.rect[3] - data.lineCoordinates[3]);
	      line.setAttribute('stroke-width', data.borderStyle.width);
	      line.setAttribute('stroke', 'transparent');
	      svg.appendChild(line);
	      this.container.append(svg);
	      this._createPopup(this.container, line, data);
	      return this.container;
	    }
	  }]);
	
	  return LineAnnotationElement;
	}(AnnotationElement);
	
	var SquareAnnotationElement = function (_AnnotationElement6) {
	  _inherits(SquareAnnotationElement, _AnnotationElement6);
	
	  function SquareAnnotationElement(parameters) {
	    _classCallCheck(this, SquareAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (SquareAnnotationElement.__proto__ || Object.getPrototypeOf(SquareAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(SquareAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'squareAnnotation';
	      var data = this.data;
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      var svg = this.svgFactory.create(width, height);
	      var borderWidth = data.borderStyle.width;
	      var square = this.svgFactory.createElement('svg:rect');
	      square.setAttribute('x', borderWidth / 2);
	      square.setAttribute('y', borderWidth / 2);
	      square.setAttribute('width', width - borderWidth);
	      square.setAttribute('height', height - borderWidth);
	      square.setAttribute('stroke-width', borderWidth);
	      square.setAttribute('stroke', 'transparent');
	      square.setAttribute('fill', 'none');
	      svg.appendChild(square);
	      this.container.append(svg);
	      this._createPopup(this.container, square, data);
	      return this.container;
	    }
	  }]);
	
	  return SquareAnnotationElement;
	}(AnnotationElement);
	
	var CircleAnnotationElement = function (_AnnotationElement7) {
	  _inherits(CircleAnnotationElement, _AnnotationElement7);
	
	  function CircleAnnotationElement(parameters) {
	    _classCallCheck(this, CircleAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (CircleAnnotationElement.__proto__ || Object.getPrototypeOf(CircleAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(CircleAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'circleAnnotation';
	      var data = this.data;
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      var svg = this.svgFactory.create(width, height);
	      var borderWidth = data.borderStyle.width;
	      var circle = this.svgFactory.createElement('svg:ellipse');
	      circle.setAttribute('cx', width / 2);
	      circle.setAttribute('cy', height / 2);
	      circle.setAttribute('rx', width / 2 - borderWidth / 2);
	      circle.setAttribute('ry', height / 2 - borderWidth / 2);
	      circle.setAttribute('stroke-width', borderWidth);
	      circle.setAttribute('stroke', 'transparent');
	      circle.setAttribute('fill', 'none');
	      svg.appendChild(circle);
	      this.container.append(svg);
	      this._createPopup(this.container, circle, data);
	      return this.container;
	    }
	  }]);
	
	  return CircleAnnotationElement;
	}(AnnotationElement);
	
	var PolylineAnnotationElement = function (_AnnotationElement8) {
	  _inherits(PolylineAnnotationElement, _AnnotationElement8);
	
	  function PolylineAnnotationElement(parameters) {
	    _classCallCheck(this, PolylineAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	
	    var _this15 = _possibleConstructorReturn(this, (PolylineAnnotationElement.__proto__ || Object.getPrototypeOf(PolylineAnnotationElement)).call(this, parameters, isRenderable, true));
	
	    _this15.containerClassName = 'polylineAnnotation';
	    _this15.svgElementName = 'svg:polyline';
	    return _this15;
	  }
	
	  _createClass(PolylineAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = this.containerClassName;
	      var data = this.data;
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      var svg = this.svgFactory.create(width, height);
	      var vertices = data.vertices;
	      var points = [];
	      for (var i = 0, ii = vertices.length; i < ii; i++) {
	        var x = vertices[i].x - data.rect[0];
	        var y = data.rect[3] - vertices[i].y;
	        points.push(x + ',' + y);
	      }
	      points = points.join(' ');
	      var borderWidth = data.borderStyle.width;
	      var polyline = this.svgFactory.createElement(this.svgElementName);
	      polyline.setAttribute('points', points);
	      polyline.setAttribute('stroke-width', borderWidth);
	      polyline.setAttribute('stroke', 'transparent');
	      polyline.setAttribute('fill', 'none');
	      svg.appendChild(polyline);
	      this.container.append(svg);
	      this._createPopup(this.container, polyline, data);
	      return this.container;
	    }
	  }]);
	
	  return PolylineAnnotationElement;
	}(AnnotationElement);
	
	var PolygonAnnotationElement = function (_PolylineAnnotationEl) {
	  _inherits(PolygonAnnotationElement, _PolylineAnnotationEl);
	
	  function PolygonAnnotationElement(parameters) {
	    _classCallCheck(this, PolygonAnnotationElement);
	
	    var _this16 = _possibleConstructorReturn(this, (PolygonAnnotationElement.__proto__ || Object.getPrototypeOf(PolygonAnnotationElement)).call(this, parameters));
	
	    _this16.containerClassName = 'polygonAnnotation';
	    _this16.svgElementName = 'svg:polygon';
	    return _this16;
	  }
	
	  return PolygonAnnotationElement;
	}(PolylineAnnotationElement);
	
	var HighlightAnnotationElement = function (_AnnotationElement9) {
	  _inherits(HighlightAnnotationElement, _AnnotationElement9);
	
	  function HighlightAnnotationElement(parameters) {
	    _classCallCheck(this, HighlightAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (HighlightAnnotationElement.__proto__ || Object.getPrototypeOf(HighlightAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(HighlightAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'highlightAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  }]);
	
	  return HighlightAnnotationElement;
	}(AnnotationElement);
	
	var UnderlineAnnotationElement = function (_AnnotationElement10) {
	  _inherits(UnderlineAnnotationElement, _AnnotationElement10);
	
	  function UnderlineAnnotationElement(parameters) {
	    _classCallCheck(this, UnderlineAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (UnderlineAnnotationElement.__proto__ || Object.getPrototypeOf(UnderlineAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(UnderlineAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'underlineAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  }]);
	
	  return UnderlineAnnotationElement;
	}(AnnotationElement);
	
	var SquigglyAnnotationElement = function (_AnnotationElement11) {
	  _inherits(SquigglyAnnotationElement, _AnnotationElement11);
	
	  function SquigglyAnnotationElement(parameters) {
	    _classCallCheck(this, SquigglyAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (SquigglyAnnotationElement.__proto__ || Object.getPrototypeOf(SquigglyAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(SquigglyAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'squigglyAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  }]);
	
	  return SquigglyAnnotationElement;
	}(AnnotationElement);
	
	var StrikeOutAnnotationElement = function (_AnnotationElement12) {
	  _inherits(StrikeOutAnnotationElement, _AnnotationElement12);
	
	  function StrikeOutAnnotationElement(parameters) {
	    _classCallCheck(this, StrikeOutAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (StrikeOutAnnotationElement.__proto__ || Object.getPrototypeOf(StrikeOutAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(StrikeOutAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'strikeoutAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  }]);
	
	  return StrikeOutAnnotationElement;
	}(AnnotationElement);
	
	var StampAnnotationElement = function (_AnnotationElement13) {
	  _inherits(StampAnnotationElement, _AnnotationElement13);
	
	  function StampAnnotationElement(parameters) {
	    _classCallCheck(this, StampAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (StampAnnotationElement.__proto__ || Object.getPrototypeOf(StampAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(StampAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'stampAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  }]);
	
	  return StampAnnotationElement;
	}(AnnotationElement);
	
	var FileAttachmentAnnotationElement = function (_AnnotationElement14) {
	  _inherits(FileAttachmentAnnotationElement, _AnnotationElement14);
	
	  function FileAttachmentAnnotationElement(parameters) {
	    _classCallCheck(this, FileAttachmentAnnotationElement);
	
	    var _this22 = _possibleConstructorReturn(this, (FileAttachmentAnnotationElement.__proto__ || Object.getPrototypeOf(FileAttachmentAnnotationElement)).call(this, parameters, true));
	
	    var file = _this22.data.file;
	    _this22.filename = (0, _dom_utils.getFilenameFromUrl)(file.filename);
	    _this22.content = file.content;
	    _this22.linkService.onFileAttachmentAnnotation({
	      id: (0, _util.stringToPDFString)(file.filename),
	      filename: file.filename,
	      content: file.content
	    });
	    return _this22;
	  }
	
	  _createClass(FileAttachmentAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'fileAttachmentAnnotation';
	      var trigger = document.createElement('div');
	      trigger.style.height = this.container.style.height;
	      trigger.style.width = this.container.style.width;
	      trigger.addEventListener('dblclick', this._download.bind(this));
	      if (!this.data.hasPopup && (this.data.title || this.data.contents)) {
	        this._createPopup(this.container, trigger, this.data);
	      }
	      this.container.appendChild(trigger);
	      return this.container;
	    }
	  }, {
	    key: '_download',
	    value: function _download() {
	      if (!this.downloadManager) {
	        (0, _util.warn)('Download cannot be started due to unavailable download manager');
	        return;
	      }
	      this.downloadManager.downloadData(this.content, this.filename, '');
	    }
	  }]);
	
	  return FileAttachmentAnnotationElement;
	}(AnnotationElement);
	
	var AnnotationLayer = function () {
	  function AnnotationLayer() {
	    _classCallCheck(this, AnnotationLayer);
	  }
	
	  _createClass(AnnotationLayer, null, [{
	    key: 'render',
	    value: function render(parameters) {
	      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
	        var data = parameters.annotations[i];
	        if (!data) {
	          continue;
	        }
	        var element = AnnotationElementFactory.create({
	          data: data,
	          layer: parameters.div,
	          page: parameters.page,
	          viewport: parameters.viewport,
	          linkService: parameters.linkService,
	          downloadManager: parameters.downloadManager,
	          imageResourcesPath: parameters.imageResourcesPath || (0, _dom_utils.getDefaultSetting)('imageResourcesPath'),
	          renderInteractiveForms: parameters.renderInteractiveForms || false,
	          svgFactory: new _dom_utils.DOMSVGFactory()
	        });
	        if (element.isRenderable) {
	          parameters.div.appendChild(element.render());
	        }
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update(parameters) {
	      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
	        var data = parameters.annotations[i];
	        var element = parameters.div.querySelector('[data-annotation-id="' + data.id + '"]');
	        if (element) {
	          element.style.transform = 'matrix(' + parameters.viewport.transform.join(',') + ')';
	        }
	      }
	      parameters.div.removeAttribute('hidden');
	    }
	  }]);
	
	  return AnnotationLayer;
	}();
	
	exports.AnnotationLayer = AnnotationLayer;
	
	/***/ }),
	/* 61 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderTextLayer = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _dom_utils = __w_pdfjs_require__(10);
	
	var renderTextLayer = function renderTextLayerClosure() {
	  var MAX_TEXT_DIVS_TO_RENDER = 100000;
	  var NonWhitespaceRegexp = /\S/;
	  function isAllWhitespace(str) {
	    return !NonWhitespaceRegexp.test(str);
	  }
	  var styleBuf = ['left: ', 0, 'px; top: ', 0, 'px; font-size: ', 0, 'px; font-family: ', '', ';'];
	  function appendText(task, geom, styles) {
	    var textDiv = document.createElement('div');
	    var textDivProperties = {
	      style: null,
	      angle: 0,
	      canvasWidth: 0,
	      isWhitespace: false,
	      originalTransform: null,
	      paddingBottom: 0,
	      paddingLeft: 0,
	      paddingRight: 0,
	      paddingTop: 0,
	      scale: 1
	    };
	    task._textDivs.push(textDiv);
	    if (isAllWhitespace(geom.str)) {
	      textDivProperties.isWhitespace = true;
	      task._textDivProperties.set(textDiv, textDivProperties);
	      return;
	    }
	    var tx = _util.Util.transform(task._viewport.transform, geom.transform);
	    var angle = Math.atan2(tx[1], tx[0]);
	    var style = styles[geom.fontName];
	    if (style.vertical) {
	      angle += Math.PI / 2;
	    }
	    var fontHeight = Math.sqrt(tx[2] * tx[2] + tx[3] * tx[3]);
	    var fontAscent = fontHeight;
	    if (style.ascent) {
	      fontAscent = style.ascent * fontAscent;
	    } else if (style.descent) {
	      fontAscent = (1 + style.descent) * fontAscent;
	    }
	    var left;
	    var top;
	    if (angle === 0) {
	      left = tx[4];
	      top = tx[5] - fontAscent;
	    } else {
	      left = tx[4] + fontAscent * Math.sin(angle);
	      top = tx[5] - fontAscent * Math.cos(angle);
	    }
	    styleBuf[1] = left;
	    styleBuf[3] = top;
	    styleBuf[5] = fontHeight;
	    styleBuf[7] = style.fontFamily;
	    textDivProperties.style = styleBuf.join('');
	    textDiv.setAttribute('style', textDivProperties.style);
	    textDiv.textContent = geom.str;
	    if ((0, _dom_utils.getDefaultSetting)('pdfBug')) {
	      textDiv.dataset.fontName = geom.fontName;
	    }
	    if (angle !== 0) {
	      textDivProperties.angle = angle * (180 / Math.PI);
	    }
	    if (geom.str.length > 1) {
	      if (style.vertical) {
	        textDivProperties.canvasWidth = geom.height * task._viewport.scale;
	      } else {
	        textDivProperties.canvasWidth = geom.width * task._viewport.scale;
	      }
	    }
	    task._textDivProperties.set(textDiv, textDivProperties);
	    if (task._textContentStream) {
	      task._layoutText(textDiv);
	    }
	    if (task._enhanceTextSelection) {
	      var angleCos = 1,
	          angleSin = 0;
	      if (angle !== 0) {
	        angleCos = Math.cos(angle);
	        angleSin = Math.sin(angle);
	      }
	      var divWidth = (style.vertical ? geom.height : geom.width) * task._viewport.scale;
	      var divHeight = fontHeight;
	      var m, b;
	      if (angle !== 0) {
	        m = [angleCos, angleSin, -angleSin, angleCos, left, top];
	        b = _util.Util.getAxialAlignedBoundingBox([0, 0, divWidth, divHeight], m);
	      } else {
	        b = [left, top, left + divWidth, top + divHeight];
	      }
	      task._bounds.push({
	        left: b[0],
	        top: b[1],
	        right: b[2],
	        bottom: b[3],
	        div: textDiv,
	        size: [divWidth, divHeight],
	        m: m
	      });
	    }
	  }
	  function render(task) {
	    if (task._canceled) {
	      return;
	    }
	    var textDivs = task._textDivs;
	    var capability = task._capability;
	    var textDivsLength = textDivs.length;
	    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
	      task._renderingDone = true;
	      capability.resolve();
	      return;
	    }
	    if (!task._textContentStream) {
	      for (var i = 0; i < textDivsLength; i++) {
	        task._layoutText(textDivs[i]);
	      }
	    }
	    task._renderingDone = true;
	    capability.resolve();
	  }
	  function expand(task) {
	    var bounds = task._bounds;
	    var viewport = task._viewport;
	    var expanded = expandBounds(viewport.width, viewport.height, bounds);
	    for (var i = 0; i < expanded.length; i++) {
	      var div = bounds[i].div;
	      var divProperties = task._textDivProperties.get(div);
	      if (divProperties.angle === 0) {
	        divProperties.paddingLeft = bounds[i].left - expanded[i].left;
	        divProperties.paddingTop = bounds[i].top - expanded[i].top;
	        divProperties.paddingRight = expanded[i].right - bounds[i].right;
	        divProperties.paddingBottom = expanded[i].bottom - bounds[i].bottom;
	        task._textDivProperties.set(div, divProperties);
	        continue;
	      }
	      var e = expanded[i],
	          b = bounds[i];
	      var m = b.m,
	          c = m[0],
	          s = m[1];
	      var points = [[0, 0], [0, b.size[1]], [b.size[0], 0], b.size];
	      var ts = new Float64Array(64);
	      points.forEach(function (p, i) {
	        var t = _util.Util.applyTransform(p, m);
	        ts[i + 0] = c && (e.left - t[0]) / c;
	        ts[i + 4] = s && (e.top - t[1]) / s;
	        ts[i + 8] = c && (e.right - t[0]) / c;
	        ts[i + 12] = s && (e.bottom - t[1]) / s;
	        ts[i + 16] = s && (e.left - t[0]) / -s;
	        ts[i + 20] = c && (e.top - t[1]) / c;
	        ts[i + 24] = s && (e.right - t[0]) / -s;
	        ts[i + 28] = c && (e.bottom - t[1]) / c;
	        ts[i + 32] = c && (e.left - t[0]) / -c;
	        ts[i + 36] = s && (e.top - t[1]) / -s;
	        ts[i + 40] = c && (e.right - t[0]) / -c;
	        ts[i + 44] = s && (e.bottom - t[1]) / -s;
	        ts[i + 48] = s && (e.left - t[0]) / s;
	        ts[i + 52] = c && (e.top - t[1]) / -c;
	        ts[i + 56] = s && (e.right - t[0]) / s;
	        ts[i + 60] = c && (e.bottom - t[1]) / -c;
	      });
	      var findPositiveMin = function findPositiveMin(ts, offset, count) {
	        var result = 0;
	        for (var i = 0; i < count; i++) {
	          var t = ts[offset++];
	          if (t > 0) {
	            result = result ? Math.min(t, result) : t;
	          }
	        }
	        return result;
	      };
	      var boxScale = 1 + Math.min(Math.abs(c), Math.abs(s));
	      divProperties.paddingLeft = findPositiveMin(ts, 32, 16) / boxScale;
	      divProperties.paddingTop = findPositiveMin(ts, 48, 16) / boxScale;
	      divProperties.paddingRight = findPositiveMin(ts, 0, 16) / boxScale;
	      divProperties.paddingBottom = findPositiveMin(ts, 16, 16) / boxScale;
	      task._textDivProperties.set(div, divProperties);
	    }
	  }
	  function expandBounds(width, height, boxes) {
	    var bounds = boxes.map(function (box, i) {
	      return {
	        x1: box.left,
	        y1: box.top,
	        x2: box.right,
	        y2: box.bottom,
	        index: i,
	        x1New: undefined,
	        x2New: undefined
	      };
	    });
	    expandBoundsLTR(width, bounds);
	    var expanded = new Array(boxes.length);
	    bounds.forEach(function (b) {
	      var i = b.index;
	      expanded[i] = {
	        left: b.x1New,
	        top: 0,
	        right: b.x2New,
	        bottom: 0
	      };
	    });
	    boxes.map(function (box, i) {
	      var e = expanded[i],
	          b = bounds[i];
	      b.x1 = box.top;
	      b.y1 = width - e.right;
	      b.x2 = box.bottom;
	      b.y2 = width - e.left;
	      b.index = i;
	      b.x1New = undefined;
	      b.x2New = undefined;
	    });
	    expandBoundsLTR(height, bounds);
	    bounds.forEach(function (b) {
	      var i = b.index;
	      expanded[i].top = b.x1New;
	      expanded[i].bottom = b.x2New;
	    });
	    return expanded;
	  }
	  function expandBoundsLTR(width, bounds) {
	    bounds.sort(function (a, b) {
	      return a.x1 - b.x1 || a.index - b.index;
	    });
	    var fakeBoundary = {
	      x1: -Infinity,
	      y1: -Infinity,
	      x2: 0,
	      y2: Infinity,
	      index: -1,
	      x1New: 0,
	      x2New: 0
	    };
	    var horizon = [{
	      start: -Infinity,
	      end: Infinity,
	      boundary: fakeBoundary
	    }];
	    bounds.forEach(function (boundary) {
	      var i = 0;
	      while (i < horizon.length && horizon[i].end <= boundary.y1) {
	        i++;
	      }
	      var j = horizon.length - 1;
	      while (j >= 0 && horizon[j].start >= boundary.y2) {
	        j--;
	      }
	      var horizonPart, affectedBoundary;
	      var q,
	          k,
	          maxXNew = -Infinity;
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        var xNew;
	        if (affectedBoundary.x2 > boundary.x1) {
	          xNew = affectedBoundary.index > boundary.index ? affectedBoundary.x1New : boundary.x1;
	        } else if (affectedBoundary.x2New === undefined) {
	          xNew = (affectedBoundary.x2 + boundary.x1) / 2;
	        } else {
	          xNew = affectedBoundary.x2New;
	        }
	        if (xNew > maxXNew) {
	          maxXNew = xNew;
	        }
	      }
	      boundary.x1New = maxXNew;
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        if (affectedBoundary.x2New === undefined) {
	          if (affectedBoundary.x2 > boundary.x1) {
	            if (affectedBoundary.index > boundary.index) {
	              affectedBoundary.x2New = affectedBoundary.x2;
	            }
	          } else {
	            affectedBoundary.x2New = maxXNew;
	          }
	        } else if (affectedBoundary.x2New > maxXNew) {
	          affectedBoundary.x2New = Math.max(maxXNew, affectedBoundary.x2);
	        }
	      }
	      var changedHorizon = [],
	          lastBoundary = null;
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        var useBoundary = affectedBoundary.x2 > boundary.x2 ? affectedBoundary : boundary;
	        if (lastBoundary === useBoundary) {
	          changedHorizon[changedHorizon.length - 1].end = horizonPart.end;
	        } else {
	          changedHorizon.push({
	            start: horizonPart.start,
	            end: horizonPart.end,
	            boundary: useBoundary
	          });
	          lastBoundary = useBoundary;
	        }
	      }
	      if (horizon[i].start < boundary.y1) {
	        changedHorizon[0].start = boundary.y1;
	        changedHorizon.unshift({
	          start: horizon[i].start,
	          end: boundary.y1,
	          boundary: horizon[i].boundary
	        });
	      }
	      if (boundary.y2 < horizon[j].end) {
	        changedHorizon[changedHorizon.length - 1].end = boundary.y2;
	        changedHorizon.push({
	          start: boundary.y2,
	          end: horizon[j].end,
	          boundary: horizon[j].boundary
	        });
	      }
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        if (affectedBoundary.x2New !== undefined) {
	          continue;
	        }
	        var used = false;
	        for (k = i - 1; !used && k >= 0 && horizon[k].start >= affectedBoundary.y1; k--) {
	          used = horizon[k].boundary === affectedBoundary;
	        }
	        for (k = j + 1; !used && k < horizon.length && horizon[k].end <= affectedBoundary.y2; k++) {
	          used = horizon[k].boundary === affectedBoundary;
	        }
	        for (k = 0; !used && k < changedHorizon.length; k++) {
	          used = changedHorizon[k].boundary === affectedBoundary;
	        }
	        if (!used) {
	          affectedBoundary.x2New = maxXNew;
	        }
	      }
	      Array.prototype.splice.apply(horizon, [i, j - i + 1].concat(changedHorizon));
	    });
	    horizon.forEach(function (horizonPart) {
	      var affectedBoundary = horizonPart.boundary;
	      if (affectedBoundary.x2New === undefined) {
	        affectedBoundary.x2New = Math.max(width, affectedBoundary.x2);
	      }
	    });
	  }
	  function TextLayerRenderTask(_ref) {
	    var textContent = _ref.textContent,
	        textContentStream = _ref.textContentStream,
	        container = _ref.container,
	        viewport = _ref.viewport,
	        textDivs = _ref.textDivs,
	        textContentItemsStr = _ref.textContentItemsStr,
	        enhanceTextSelection = _ref.enhanceTextSelection;
	
	    this._textContent = textContent;
	    this._textContentStream = textContentStream;
	    this._container = container;
	    this._viewport = viewport;
	    this._textDivs = textDivs || [];
	    this._textContentItemsStr = textContentItemsStr || [];
	    this._enhanceTextSelection = !!enhanceTextSelection;
	    this._reader = null;
	    this._layoutTextLastFontSize = null;
	    this._layoutTextLastFontFamily = null;
	    this._layoutTextCtx = null;
	    this._textDivProperties = new WeakMap();
	    this._renderingDone = false;
	    this._canceled = false;
	    this._capability = (0, _util.createPromiseCapability)();
	    this._renderTimer = null;
	    this._bounds = [];
	  }
	  TextLayerRenderTask.prototype = {
	    get promise() {
	      return this._capability.promise;
	    },
	    cancel: function TextLayer_cancel() {
	      if (this._reader) {
	        this._reader.cancel(new _util.AbortException('text layer task cancelled'));
	        this._reader = null;
	      }
	      this._canceled = true;
	      if (this._renderTimer !== null) {
	        clearTimeout(this._renderTimer);
	        this._renderTimer = null;
	      }
	      this._capability.reject('canceled');
	    },
	    _processItems: function _processItems(items, styleCache) {
	      for (var i = 0, len = items.length; i < len; i++) {
	        this._textContentItemsStr.push(items[i].str);
	        appendText(this, items[i], styleCache);
	      }
	    },
	    _layoutText: function _layoutText(textDiv) {
	      var textLayerFrag = this._container;
	      var textDivProperties = this._textDivProperties.get(textDiv);
	      if (textDivProperties.isWhitespace) {
	        return;
	      }
	      var fontSize = textDiv.style.fontSize;
	      var fontFamily = textDiv.style.fontFamily;
	      if (fontSize !== this._layoutTextLastFontSize || fontFamily !== this._layoutTextLastFontFamily) {
	        this._layoutTextCtx.font = fontSize + ' ' + fontFamily;
	        this._lastFontSize = fontSize;
	        this._lastFontFamily = fontFamily;
	      }
	      var width = this._layoutTextCtx.measureText(textDiv.textContent).width;
	      var transform = '';
	      if (textDivProperties.canvasWidth !== 0 && width > 0) {
	        textDivProperties.scale = textDivProperties.canvasWidth / width;
	        transform = 'scaleX(' + textDivProperties.scale + ')';
	      }
	      if (textDivProperties.angle !== 0) {
	        transform = 'rotate(' + textDivProperties.angle + 'deg) ' + transform;
	      }
	      if (transform !== '') {
	        textDivProperties.originalTransform = transform;
	        textDiv.style.transform = transform;
	      }
	      this._textDivProperties.set(textDiv, textDivProperties);
	      textLayerFrag.appendChild(textDiv);
	    },
	
	    _render: function TextLayer_render(timeout) {
	      var _this = this;
	
	      var capability = (0, _util.createPromiseCapability)();
	      var styleCache = Object.create(null);
	      var canvas = document.createElement('canvas');
	      canvas.mozOpaque = true;
	      this._layoutTextCtx = canvas.getContext('2d', { alpha: false });
	      if (this._textContent) {
	        var textItems = this._textContent.items;
	        var textStyles = this._textContent.styles;
	        this._processItems(textItems, textStyles);
	        capability.resolve();
	      } else if (this._textContentStream) {
	        var pump = function pump() {
	          _this._reader.read().then(function (_ref2) {
	            var value = _ref2.value,
	                done = _ref2.done;
	
	            if (done) {
	              capability.resolve();
	              return;
	            }
	            _util.Util.extendObj(styleCache, value.styles);
	            _this._processItems(value.items, styleCache);
	            pump();
	          }, capability.reject);
	        };
	        this._reader = this._textContentStream.getReader();
	        pump();
	      } else {
	        throw new Error('Neither "textContent" nor "textContentStream"' + ' parameters specified.');
	      }
	      capability.promise.then(function () {
	        styleCache = null;
	        if (!timeout) {
	          render(_this);
	        } else {
	          _this._renderTimer = setTimeout(function () {
	            render(_this);
	            _this._renderTimer = null;
	          }, timeout);
	        }
	      }, this._capability.reject);
	    },
	    expandTextDivs: function TextLayer_expandTextDivs(expandDivs) {
	      if (!this._enhanceTextSelection || !this._renderingDone) {
	        return;
	      }
	      if (this._bounds !== null) {
	        expand(this);
	        this._bounds = null;
	      }
	      for (var i = 0, ii = this._textDivs.length; i < ii; i++) {
	        var div = this._textDivs[i];
	        var divProperties = this._textDivProperties.get(div);
	        if (divProperties.isWhitespace) {
	          continue;
	        }
	        if (expandDivs) {
	          var transform = '',
	              padding = '';
	          if (divProperties.scale !== 1) {
	            transform = 'scaleX(' + divProperties.scale + ')';
	          }
	          if (divProperties.angle !== 0) {
	            transform = 'rotate(' + divProperties.angle + 'deg) ' + transform;
	          }
	          if (divProperties.paddingLeft !== 0) {
	            padding += ' padding-left: ' + divProperties.paddingLeft / divProperties.scale + 'px;';
	            transform += ' translateX(' + -divProperties.paddingLeft / divProperties.scale + 'px)';
	          }
	          if (divProperties.paddingTop !== 0) {
	            padding += ' padding-top: ' + divProperties.paddingTop + 'px;';
	            transform += ' translateY(' + -divProperties.paddingTop + 'px)';
	          }
	          if (divProperties.paddingRight !== 0) {
	            padding += ' padding-right: ' + divProperties.paddingRight / divProperties.scale + 'px;';
	          }
	          if (divProperties.paddingBottom !== 0) {
	            padding += ' padding-bottom: ' + divProperties.paddingBottom + 'px;';
	          }
	          if (padding !== '') {
	            div.setAttribute('style', divProperties.style + padding);
	          }
	          if (transform !== '') {
	            div.style.transform = transform;
	          }
	        } else {
	          div.style.padding = 0;
	          div.style.transform = divProperties.originalTransform || '';
	        }
	      }
	    }
	  };
	  function renderTextLayer(renderParameters) {
	    var task = new TextLayerRenderTask({
	      textContent: renderParameters.textContent,
	      textContentStream: renderParameters.textContentStream,
	      container: renderParameters.container,
	      viewport: renderParameters.viewport,
	      textDivs: renderParameters.textDivs,
	      textContentItemsStr: renderParameters.textContentItemsStr,
	      enhanceTextSelection: renderParameters.enhanceTextSelection
	    });
	    task._render(renderParameters.timeout);
	    return task;
	  }
	  return renderTextLayer;
	}();
	exports.renderTextLayer = renderTextLayer;
	
	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SVGGraphics = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _dom_utils = __w_pdfjs_require__(10);
	
	var _is_node = __w_pdfjs_require__(24);
	
	var _is_node2 = _interopRequireDefault(_is_node);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SVGGraphics = function SVGGraphics() {
	  throw new Error('Not implemented: SVGGraphics');
	};
	{
	  var SVG_DEFAULTS = {
	    fontStyle: 'normal',
	    fontWeight: 'normal',
	    fillColor: '#000000'
	  };
	  var convertImgDataToPng = function convertImgDataToPngClosure() {
	    var PNG_HEADER = new Uint8Array([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]);
	    var CHUNK_WRAPPER_SIZE = 12;
	    var crcTable = new Int32Array(256);
	    for (var i = 0; i < 256; i++) {
	      var c = i;
	      for (var h = 0; h < 8; h++) {
	        if (c & 1) {
	          c = 0xedB88320 ^ c >> 1 & 0x7fffffff;
	        } else {
	          c = c >> 1 & 0x7fffffff;
	        }
	      }
	      crcTable[i] = c;
	    }
	    function crc32(data, start, end) {
	      var crc = -1;
	      for (var i = start; i < end; i++) {
	        var a = (crc ^ data[i]) & 0xff;
	        var b = crcTable[a];
	        crc = crc >>> 8 ^ b;
	      }
	      return crc ^ -1;
	    }
	    function writePngChunk(type, body, data, offset) {
	      var p = offset;
	      var len = body.length;
	      data[p] = len >> 24 & 0xff;
	      data[p + 1] = len >> 16 & 0xff;
	      data[p + 2] = len >> 8 & 0xff;
	      data[p + 3] = len & 0xff;
	      p += 4;
	      data[p] = type.charCodeAt(0) & 0xff;
	      data[p + 1] = type.charCodeAt(1) & 0xff;
	      data[p + 2] = type.charCodeAt(2) & 0xff;
	      data[p + 3] = type.charCodeAt(3) & 0xff;
	      p += 4;
	      data.set(body, p);
	      p += body.length;
	      var crc = crc32(data, offset + 4, p);
	      data[p] = crc >> 24 & 0xff;
	      data[p + 1] = crc >> 16 & 0xff;
	      data[p + 2] = crc >> 8 & 0xff;
	      data[p + 3] = crc & 0xff;
	    }
	    function adler32(data, start, end) {
	      var a = 1;
	      var b = 0;
	      for (var i = start; i < end; ++i) {
	        a = (a + (data[i] & 0xff)) % 65521;
	        b = (b + a) % 65521;
	      }
	      return b << 16 | a;
	    }
	    function deflateSync(literals) {
	      if (!(0, _is_node2.default)()) {
	        return deflateSyncUncompressed(literals);
	      }
	      try {
	        var input;
	        if (parseInt(process.versions.node) >= 8) {
	          input = literals;
	        } else {
	          input = new Buffer(literals);
	        }
	        var output = __webpack_require__(513).deflateSync(input, { level: 9 });
	        return output instanceof Uint8Array ? output : new Uint8Array(output);
	      } catch (e) {
	        (0, _util.warn)('Not compressing PNG because zlib.deflateSync is unavailable: ' + e);
	      }
	      return deflateSyncUncompressed(literals);
	    }
	    function deflateSyncUncompressed(literals) {
	      var len = literals.length;
	      var maxBlockLength = 0xFFFF;
	      var deflateBlocks = Math.ceil(len / maxBlockLength);
	      var idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
	      var pi = 0;
	      idat[pi++] = 0x78;
	      idat[pi++] = 0x9c;
	      var pos = 0;
	      while (len > maxBlockLength) {
	        idat[pi++] = 0x00;
	        idat[pi++] = 0xff;
	        idat[pi++] = 0xff;
	        idat[pi++] = 0x00;
	        idat[pi++] = 0x00;
	        idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
	        pi += maxBlockLength;
	        pos += maxBlockLength;
	        len -= maxBlockLength;
	      }
	      idat[pi++] = 0x01;
	      idat[pi++] = len & 0xff;
	      idat[pi++] = len >> 8 & 0xff;
	      idat[pi++] = ~len & 0xffff & 0xff;
	      idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
	      idat.set(literals.subarray(pos), pi);
	      pi += literals.length - pos;
	      var adler = adler32(literals, 0, literals.length);
	      idat[pi++] = adler >> 24 & 0xff;
	      idat[pi++] = adler >> 16 & 0xff;
	      idat[pi++] = adler >> 8 & 0xff;
	      idat[pi++] = adler & 0xff;
	      return idat;
	    }
	    function encode(imgData, kind, forceDataSchema, isMask) {
	      var width = imgData.width;
	      var height = imgData.height;
	      var bitDepth, colorType, lineSize;
	      var bytes = imgData.data;
	      switch (kind) {
	        case _util.ImageKind.GRAYSCALE_1BPP:
	          colorType = 0;
	          bitDepth = 1;
	          lineSize = width + 7 >> 3;
	          break;
	        case _util.ImageKind.RGB_24BPP:
	          colorType = 2;
	          bitDepth = 8;
	          lineSize = width * 3;
	          break;
	        case _util.ImageKind.RGBA_32BPP:
	          colorType = 6;
	          bitDepth = 8;
	          lineSize = width * 4;
	          break;
	        default:
	          throw new Error('invalid format');
	      }
	      var literals = new Uint8Array((1 + lineSize) * height);
	      var offsetLiterals = 0,
	          offsetBytes = 0;
	      var y, i;
	      for (y = 0; y < height; ++y) {
	        literals[offsetLiterals++] = 0;
	        literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
	        offsetBytes += lineSize;
	        offsetLiterals += lineSize;
	      }
	      if (kind === _util.ImageKind.GRAYSCALE_1BPP && isMask) {
	        offsetLiterals = 0;
	        for (y = 0; y < height; y++) {
	          offsetLiterals++;
	          for (i = 0; i < lineSize; i++) {
	            literals[offsetLiterals++] ^= 0xFF;
	          }
	        }
	      }
	      var ihdr = new Uint8Array([width >> 24 & 0xff, width >> 16 & 0xff, width >> 8 & 0xff, width & 0xff, height >> 24 & 0xff, height >> 16 & 0xff, height >> 8 & 0xff, height & 0xff, bitDepth, colorType, 0x00, 0x00, 0x00]);
	      var idat = deflateSync(literals);
	      var pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
	      var data = new Uint8Array(pngLength);
	      var offset = 0;
	      data.set(PNG_HEADER, offset);
	      offset += PNG_HEADER.length;
	      writePngChunk('IHDR', ihdr, data, offset);
	      offset += CHUNK_WRAPPER_SIZE + ihdr.length;
	      writePngChunk('IDATA', idat, data, offset);
	      offset += CHUNK_WRAPPER_SIZE + idat.length;
	      writePngChunk('IEND', new Uint8Array(0), data, offset);
	      return (0, _util.createObjectURL)(data, 'image/png', forceDataSchema);
	    }
	    return function convertImgDataToPng(imgData, forceDataSchema, isMask) {
	      var kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
	      return encode(imgData, kind, forceDataSchema, isMask);
	    };
	  }();
	  var SVGExtraState = function SVGExtraStateClosure() {
	    function SVGExtraState() {
	      this.fontSizeScale = 1;
	      this.fontWeight = SVG_DEFAULTS.fontWeight;
	      this.fontSize = 0;
	      this.textMatrix = _util.IDENTITY_MATRIX;
	      this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
	      this.leading = 0;
	      this.x = 0;
	      this.y = 0;
	      this.lineX = 0;
	      this.lineY = 0;
	      this.charSpacing = 0;
	      this.wordSpacing = 0;
	      this.textHScale = 1;
	      this.textRise = 0;
	      this.fillColor = SVG_DEFAULTS.fillColor;
	      this.strokeColor = '#000000';
	      this.fillAlpha = 1;
	      this.strokeAlpha = 1;
	      this.lineWidth = 1;
	      this.lineJoin = '';
	      this.lineCap = '';
	      this.miterLimit = 0;
	      this.dashArray = [];
	      this.dashPhase = 0;
	      this.dependencies = [];
	      this.activeClipUrl = null;
	      this.clipGroup = null;
	      this.maskId = '';
	    }
	    SVGExtraState.prototype = {
	      clone: function SVGExtraState_clone() {
	        return Object.create(this);
	      },
	      setCurrentPoint: function SVGExtraState_setCurrentPoint(x, y) {
	        this.x = x;
	        this.y = y;
	      }
	    };
	    return SVGExtraState;
	  }();
	  exports.SVGGraphics = SVGGraphics = function SVGGraphicsClosure() {
	    function opListToTree(opList) {
	      var opTree = [];
	      var tmp = [];
	      var opListLen = opList.length;
	      for (var x = 0; x < opListLen; x++) {
	        if (opList[x].fn === 'save') {
	          opTree.push({
	            'fnId': 92,
	            'fn': 'group',
	            'items': []
	          });
	          tmp.push(opTree);
	          opTree = opTree[opTree.length - 1].items;
	          continue;
	        }
	        if (opList[x].fn === 'restore') {
	          opTree = tmp.pop();
	        } else {
	          opTree.push(opList[x]);
	        }
	      }
	      return opTree;
	    }
	    function pf(value) {
	      if (Number.isInteger(value)) {
	        return value.toString();
	      }
	      var s = value.toFixed(10);
	      var i = s.length - 1;
	      if (s[i] !== '0') {
	        return s;
	      }
	      do {
	        i--;
	      } while (s[i] === '0');
	      return s.substr(0, s[i] === '.' ? i : i + 1);
	    }
	    function pm(m) {
	      if (m[4] === 0 && m[5] === 0) {
	        if (m[1] === 0 && m[2] === 0) {
	          if (m[0] === 1 && m[3] === 1) {
	            return '';
	          }
	          return 'scale(' + pf(m[0]) + ' ' + pf(m[3]) + ')';
	        }
	        if (m[0] === m[3] && m[1] === -m[2]) {
	          var a = Math.acos(m[0]) * 180 / Math.PI;
	          return 'rotate(' + pf(a) + ')';
	        }
	      } else {
	        if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) {
	          return 'translate(' + pf(m[4]) + ' ' + pf(m[5]) + ')';
	        }
	      }
	      return 'matrix(' + pf(m[0]) + ' ' + pf(m[1]) + ' ' + pf(m[2]) + ' ' + pf(m[3]) + ' ' + pf(m[4]) + ' ' + pf(m[5]) + ')';
	    }
	    function SVGGraphics(commonObjs, objs, forceDataSchema) {
	      this.svgFactory = new _dom_utils.DOMSVGFactory();
	      this.current = new SVGExtraState();
	      this.transformMatrix = _util.IDENTITY_MATRIX;
	      this.transformStack = [];
	      this.extraStack = [];
	      this.commonObjs = commonObjs;
	      this.objs = objs;
	      this.pendingClip = null;
	      this.pendingEOFill = false;
	      this.embedFonts = false;
	      this.embeddedFonts = Object.create(null);
	      this.cssStyle = null;
	      this.forceDataSchema = !!forceDataSchema;
	    }
	    var XML_NS = 'http://www.w3.org/XML/1998/namespace';
	    var XLINK_NS = 'http://www.w3.org/1999/xlink';
	    var LINE_CAP_STYLES = ['butt', 'round', 'square'];
	    var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
	    var clipCount = 0;
	    var maskCount = 0;
	    SVGGraphics.prototype = {
	      save: function SVGGraphics_save() {
	        this.transformStack.push(this.transformMatrix);
	        var old = this.current;
	        this.extraStack.push(old);
	        this.current = old.clone();
	      },
	      restore: function SVGGraphics_restore() {
	        this.transformMatrix = this.transformStack.pop();
	        this.current = this.extraStack.pop();
	        this.pendingClip = null;
	        this.tgrp = null;
	      },
	      group: function SVGGraphics_group(items) {
	        this.save();
	        this.executeOpTree(items);
	        this.restore();
	      },
	      loadDependencies: function SVGGraphics_loadDependencies(operatorList) {
	        var _this = this;
	
	        var fnArray = operatorList.fnArray;
	        var fnArrayLen = fnArray.length;
	        var argsArray = operatorList.argsArray;
	        for (var i = 0; i < fnArrayLen; i++) {
	          if (_util.OPS.dependency === fnArray[i]) {
	            var deps = argsArray[i];
	            for (var n = 0, nn = deps.length; n < nn; n++) {
	              var obj = deps[n];
	              var common = obj.substring(0, 2) === 'g_';
	              var promise;
	              if (common) {
	                promise = new Promise(function (resolve) {
	                  _this.commonObjs.get(obj, resolve);
	                });
	              } else {
	                promise = new Promise(function (resolve) {
	                  _this.objs.get(obj, resolve);
	                });
	              }
	              this.current.dependencies.push(promise);
	            }
	          }
	        }
	        return Promise.all(this.current.dependencies);
	      },
	      transform: function SVGGraphics_transform(a, b, c, d, e, f) {
	        var transformMatrix = [a, b, c, d, e, f];
	        this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
	        this.tgrp = null;
	      },
	      getSVG: function SVGGraphics_getSVG(operatorList, viewport) {
	        var _this2 = this;
	
	        this.viewport = viewport;
	        var svgElement = this._initialize(viewport);
	        return this.loadDependencies(operatorList).then(function () {
	          _this2.transformMatrix = _util.IDENTITY_MATRIX;
	          var opTree = _this2.convertOpList(operatorList);
	          _this2.executeOpTree(opTree);
	          return svgElement;
	        });
	      },
	      convertOpList: function SVGGraphics_convertOpList(operatorList) {
	        var argsArray = operatorList.argsArray;
	        var fnArray = operatorList.fnArray;
	        var fnArrayLen = fnArray.length;
	        var REVOPS = [];
	        var opList = [];
	        for (var op in _util.OPS) {
	          REVOPS[_util.OPS[op]] = op;
	        }
	        for (var x = 0; x < fnArrayLen; x++) {
	          var fnId = fnArray[x];
	          opList.push({
	            'fnId': fnId,
	            'fn': REVOPS[fnId],
	            'args': argsArray[x]
	          });
	        }
	        return opListToTree(opList);
	      },
	      executeOpTree: function SVGGraphics_executeOpTree(opTree) {
	        var opTreeLen = opTree.length;
	        for (var x = 0; x < opTreeLen; x++) {
	          var fn = opTree[x].fn;
	          var fnId = opTree[x].fnId;
	          var args = opTree[x].args;
	          switch (fnId | 0) {
	            case _util.OPS.beginText:
	              this.beginText();
	              break;
	            case _util.OPS.setLeading:
	              this.setLeading(args);
	              break;
	            case _util.OPS.setLeadingMoveText:
	              this.setLeadingMoveText(args[0], args[1]);
	              break;
	            case _util.OPS.setFont:
	              this.setFont(args);
	              break;
	            case _util.OPS.showText:
	              this.showText(args[0]);
	              break;
	            case _util.OPS.showSpacedText:
	              this.showText(args[0]);
	              break;
	            case _util.OPS.endText:
	              this.endText();
	              break;
	            case _util.OPS.moveText:
	              this.moveText(args[0], args[1]);
	              break;
	            case _util.OPS.setCharSpacing:
	              this.setCharSpacing(args[0]);
	              break;
	            case _util.OPS.setWordSpacing:
	              this.setWordSpacing(args[0]);
	              break;
	            case _util.OPS.setHScale:
	              this.setHScale(args[0]);
	              break;
	            case _util.OPS.setTextMatrix:
	              this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
	              break;
	            case _util.OPS.setTextRise:
	              this.setTextRise(args[0]);
	              break;
	            case _util.OPS.setLineWidth:
	              this.setLineWidth(args[0]);
	              break;
	            case _util.OPS.setLineJoin:
	              this.setLineJoin(args[0]);
	              break;
	            case _util.OPS.setLineCap:
	              this.setLineCap(args[0]);
	              break;
	            case _util.OPS.setMiterLimit:
	              this.setMiterLimit(args[0]);
	              break;
	            case _util.OPS.setFillRGBColor:
	              this.setFillRGBColor(args[0], args[1], args[2]);
	              break;
	            case _util.OPS.setStrokeRGBColor:
	              this.setStrokeRGBColor(args[0], args[1], args[2]);
	              break;
	            case _util.OPS.setDash:
	              this.setDash(args[0], args[1]);
	              break;
	            case _util.OPS.setGState:
	              this.setGState(args[0]);
	              break;
	            case _util.OPS.fill:
	              this.fill();
	              break;
	            case _util.OPS.eoFill:
	              this.eoFill();
	              break;
	            case _util.OPS.stroke:
	              this.stroke();
	              break;
	            case _util.OPS.fillStroke:
	              this.fillStroke();
	              break;
	            case _util.OPS.eoFillStroke:
	              this.eoFillStroke();
	              break;
	            case _util.OPS.clip:
	              this.clip('nonzero');
	              break;
	            case _util.OPS.eoClip:
	              this.clip('evenodd');
	              break;
	            case _util.OPS.paintSolidColorImageMask:
	              this.paintSolidColorImageMask();
	              break;
	            case _util.OPS.paintJpegXObject:
	              this.paintJpegXObject(args[0], args[1], args[2]);
	              break;
	            case _util.OPS.paintImageXObject:
	              this.paintImageXObject(args[0]);
	              break;
	            case _util.OPS.paintInlineImageXObject:
	              this.paintInlineImageXObject(args[0]);
	              break;
	            case _util.OPS.paintImageMaskXObject:
	              this.paintImageMaskXObject(args[0]);
	              break;
	            case _util.OPS.paintFormXObjectBegin:
	              this.paintFormXObjectBegin(args[0], args[1]);
	              break;
	            case _util.OPS.paintFormXObjectEnd:
	              this.paintFormXObjectEnd();
	              break;
	            case _util.OPS.closePath:
	              this.closePath();
	              break;
	            case _util.OPS.closeStroke:
	              this.closeStroke();
	              break;
	            case _util.OPS.closeFillStroke:
	              this.closeFillStroke();
	              break;
	            case _util.OPS.closeEOFillStroke:
	              this.closeEOFillStroke();
	              break;
	            case _util.OPS.nextLine:
	              this.nextLine();
	              break;
	            case _util.OPS.transform:
	              this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
	              break;
	            case _util.OPS.constructPath:
	              this.constructPath(args[0], args[1]);
	              break;
	            case _util.OPS.endPath:
	              this.endPath();
	              break;
	            case 92:
	              this.group(opTree[x].items);
	              break;
	            default:
	              (0, _util.warn)('Unimplemented operator ' + fn);
	              break;
	          }
	        }
	      },
	      setWordSpacing: function SVGGraphics_setWordSpacing(wordSpacing) {
	        this.current.wordSpacing = wordSpacing;
	      },
	      setCharSpacing: function SVGGraphics_setCharSpacing(charSpacing) {
	        this.current.charSpacing = charSpacing;
	      },
	      nextLine: function SVGGraphics_nextLine() {
	        this.moveText(0, this.current.leading);
	      },
	      setTextMatrix: function SVGGraphics_setTextMatrix(a, b, c, d, e, f) {
	        var current = this.current;
	        this.current.textMatrix = this.current.lineMatrix = [a, b, c, d, e, f];
	        this.current.x = this.current.lineX = 0;
	        this.current.y = this.current.lineY = 0;
	        current.xcoords = [];
	        current.tspan = this.svgFactory.createElement('svg:tspan');
	        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
	        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	        current.txtElement = this.svgFactory.createElement('svg:text');
	        current.txtElement.appendChild(current.tspan);
	      },
	      beginText: function SVGGraphics_beginText() {
	        this.current.x = this.current.lineX = 0;
	        this.current.y = this.current.lineY = 0;
	        this.current.textMatrix = _util.IDENTITY_MATRIX;
	        this.current.lineMatrix = _util.IDENTITY_MATRIX;
	        this.current.tspan = this.svgFactory.createElement('svg:tspan');
	        this.current.txtElement = this.svgFactory.createElement('svg:text');
	        this.current.txtgrp = this.svgFactory.createElement('svg:g');
	        this.current.xcoords = [];
	      },
	      moveText: function SVGGraphics_moveText(x, y) {
	        var current = this.current;
	        this.current.x = this.current.lineX += x;
	        this.current.y = this.current.lineY += y;
	        current.xcoords = [];
	        current.tspan = this.svgFactory.createElement('svg:tspan');
	        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
	        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	      },
	      showText: function SVGGraphics_showText(glyphs) {
	        var current = this.current;
	        var font = current.font;
	        var fontSize = current.fontSize;
	        if (fontSize === 0) {
	          return;
	        }
	        var charSpacing = current.charSpacing;
	        var wordSpacing = current.wordSpacing;
	        var fontDirection = current.fontDirection;
	        var textHScale = current.textHScale * fontDirection;
	        var glyphsLength = glyphs.length;
	        var vertical = font.vertical;
	        var widthAdvanceScale = fontSize * current.fontMatrix[0];
	        var x = 0,
	            i;
	        for (i = 0; i < glyphsLength; ++i) {
	          var glyph = glyphs[i];
	          if (glyph === null) {
	            x += fontDirection * wordSpacing;
	            continue;
	          } else if ((0, _util.isNum)(glyph)) {
	            x += -glyph * fontSize * 0.001;
	            continue;
	          }
	          var width = glyph.width;
	          var character = glyph.fontChar;
	          var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
	          var charWidth = width * widthAdvanceScale + spacing * fontDirection;
	          if (!glyph.isInFont && !font.missingFile) {
	            x += charWidth;
	            continue;
	          }
	          current.xcoords.push(current.x + x * textHScale);
	          current.tspan.textContent += character;
	          x += charWidth;
	        }
	        if (vertical) {
	          current.y -= x * textHScale;
	        } else {
	          current.x += x * textHScale;
	        }
	        current.tspan.setAttributeNS(null, 'x', current.xcoords.map(pf).join(' '));
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
	        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
	        if (current.fontStyle !== SVG_DEFAULTS.fontStyle) {
	          current.tspan.setAttributeNS(null, 'font-style', current.fontStyle);
	        }
	        if (current.fontWeight !== SVG_DEFAULTS.fontWeight) {
	          current.tspan.setAttributeNS(null, 'font-weight', current.fontWeight);
	        }
	        if (current.fillColor !== SVG_DEFAULTS.fillColor) {
	          current.tspan.setAttributeNS(null, 'fill', current.fillColor);
	        }
	        var textMatrix = current.textMatrix;
	        if (current.textRise !== 0) {
	          textMatrix = textMatrix.slice();
	          textMatrix[5] += current.textRise;
	        }
	        current.txtElement.setAttributeNS(null, 'transform', pm(textMatrix) + ' scale(1, -1)');
	        current.txtElement.setAttributeNS(XML_NS, 'xml:space', 'preserve');
	        current.txtElement.appendChild(current.tspan);
	        current.txtgrp.appendChild(current.txtElement);
	        this._ensureTransformGroup().appendChild(current.txtElement);
	      },
	      setLeadingMoveText: function SVGGraphics_setLeadingMoveText(x, y) {
	        this.setLeading(-y);
	        this.moveText(x, y);
	      },
	      addFontStyle: function SVGGraphics_addFontStyle(fontObj) {
	        if (!this.cssStyle) {
	          this.cssStyle = this.svgFactory.createElement('svg:style');
	          this.cssStyle.setAttributeNS(null, 'type', 'text/css');
	          this.defs.appendChild(this.cssStyle);
	        }
	        var url = (0, _util.createObjectURL)(fontObj.data, fontObj.mimetype, this.forceDataSchema);
	        this.cssStyle.textContent += '@font-face { font-family: "' + fontObj.loadedName + '";' + ' src: url(' + url + '); }\n';
	      },
	      setFont: function SVGGraphics_setFont(details) {
	        var current = this.current;
	        var fontObj = this.commonObjs.get(details[0]);
	        var size = details[1];
	        this.current.font = fontObj;
	        if (this.embedFonts && fontObj.data && !this.embeddedFonts[fontObj.loadedName]) {
	          this.addFontStyle(fontObj);
	          this.embeddedFonts[fontObj.loadedName] = fontObj;
	        }
	        current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
	        var bold = fontObj.black ? fontObj.bold ? 'bolder' : 'bold' : fontObj.bold ? 'bold' : 'normal';
	        var italic = fontObj.italic ? 'italic' : 'normal';
	        if (size < 0) {
	          size = -size;
	          current.fontDirection = -1;
	        } else {
	          current.fontDirection = 1;
	        }
	        current.fontSize = size;
	        current.fontFamily = fontObj.loadedName;
	        current.fontWeight = bold;
	        current.fontStyle = italic;
	        current.tspan = this.svgFactory.createElement('svg:tspan');
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	        current.xcoords = [];
	      },
	      endText: function SVGGraphics_endText() {},
	      setLineWidth: function SVGGraphics_setLineWidth(width) {
	        this.current.lineWidth = width;
	      },
	      setLineCap: function SVGGraphics_setLineCap(style) {
	        this.current.lineCap = LINE_CAP_STYLES[style];
	      },
	      setLineJoin: function SVGGraphics_setLineJoin(style) {
	        this.current.lineJoin = LINE_JOIN_STYLES[style];
	      },
	      setMiterLimit: function SVGGraphics_setMiterLimit(limit) {
	        this.current.miterLimit = limit;
	      },
	      setStrokeAlpha: function SVGGraphics_setStrokeAlpha(strokeAlpha) {
	        this.current.strokeAlpha = strokeAlpha;
	      },
	      setStrokeRGBColor: function SVGGraphics_setStrokeRGBColor(r, g, b) {
	        var color = _util.Util.makeCssRgb(r, g, b);
	        this.current.strokeColor = color;
	      },
	      setFillAlpha: function SVGGraphics_setFillAlpha(fillAlpha) {
	        this.current.fillAlpha = fillAlpha;
	      },
	      setFillRGBColor: function SVGGraphics_setFillRGBColor(r, g, b) {
	        var color = _util.Util.makeCssRgb(r, g, b);
	        this.current.fillColor = color;
	        this.current.tspan = this.svgFactory.createElement('svg:tspan');
	        this.current.xcoords = [];
	      },
	      setDash: function SVGGraphics_setDash(dashArray, dashPhase) {
	        this.current.dashArray = dashArray;
	        this.current.dashPhase = dashPhase;
	      },
	      constructPath: function SVGGraphics_constructPath(ops, args) {
	        var current = this.current;
	        var x = current.x,
	            y = current.y;
	        current.path = this.svgFactory.createElement('svg:path');
	        var d = [];
	        var opLength = ops.length;
	        for (var i = 0, j = 0; i < opLength; i++) {
	          switch (ops[i] | 0) {
	            case _util.OPS.rectangle:
	              x = args[j++];
	              y = args[j++];
	              var width = args[j++];
	              var height = args[j++];
	              var xw = x + width;
	              var yh = y + height;
	              d.push('M', pf(x), pf(y), 'L', pf(xw), pf(y), 'L', pf(xw), pf(yh), 'L', pf(x), pf(yh), 'Z');
	              break;
	            case _util.OPS.moveTo:
	              x = args[j++];
	              y = args[j++];
	              d.push('M', pf(x), pf(y));
	              break;
	            case _util.OPS.lineTo:
	              x = args[j++];
	              y = args[j++];
	              d.push('L', pf(x), pf(y));
	              break;
	            case _util.OPS.curveTo:
	              x = args[j + 4];
	              y = args[j + 5];
	              d.push('C', pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
	              j += 6;
	              break;
	            case _util.OPS.curveTo2:
	              x = args[j + 2];
	              y = args[j + 3];
	              d.push('C', pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
	              j += 4;
	              break;
	            case _util.OPS.curveTo3:
	              x = args[j + 2];
	              y = args[j + 3];
	              d.push('C', pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
	              j += 4;
	              break;
	            case _util.OPS.closePath:
	              d.push('Z');
	              break;
	          }
	        }
	        current.path.setAttributeNS(null, 'd', d.join(' '));
	        current.path.setAttributeNS(null, 'fill', 'none');
	        this._ensureTransformGroup().appendChild(current.path);
	        current.element = current.path;
	        current.setCurrentPoint(x, y);
	      },
	      endPath: function SVGGraphics_endPath() {
	        if (!this.pendingClip) {
	          return;
	        }
	        var current = this.current;
	        var clipId = 'clippath' + clipCount;
	        clipCount++;
	        var clipPath = this.svgFactory.createElement('svg:clipPath');
	        clipPath.setAttributeNS(null, 'id', clipId);
	        clipPath.setAttributeNS(null, 'transform', pm(this.transformMatrix));
	        var clipElement = current.element.cloneNode();
	        if (this.pendingClip === 'evenodd') {
	          clipElement.setAttributeNS(null, 'clip-rule', 'evenodd');
	        } else {
	          clipElement.setAttributeNS(null, 'clip-rule', 'nonzero');
	        }
	        this.pendingClip = null;
	        clipPath.appendChild(clipElement);
	        this.defs.appendChild(clipPath);
	        if (current.activeClipUrl) {
	          current.clipGroup = null;
	          this.extraStack.forEach(function (prev) {
	            prev.clipGroup = null;
	          });
	        }
	        current.activeClipUrl = 'url(#' + clipId + ')';
	        this.tgrp = null;
	      },
	      clip: function SVGGraphics_clip(type) {
	        this.pendingClip = type;
	      },
	      closePath: function SVGGraphics_closePath() {
	        var current = this.current;
	        if (current.path) {
	          var d = current.path.getAttributeNS(null, 'd');
	          d += 'Z';
	          current.path.setAttributeNS(null, 'd', d);
	        }
	      },
	      setLeading: function SVGGraphics_setLeading(leading) {
	        this.current.leading = -leading;
	      },
	      setTextRise: function SVGGraphics_setTextRise(textRise) {
	        this.current.textRise = textRise;
	      },
	      setHScale: function SVGGraphics_setHScale(scale) {
	        this.current.textHScale = scale / 100;
	      },
	      setGState: function SVGGraphics_setGState(states) {
	        for (var i = 0, ii = states.length; i < ii; i++) {
	          var state = states[i];
	          var key = state[0];
	          var value = state[1];
	          switch (key) {
	            case 'LW':
	              this.setLineWidth(value);
	              break;
	            case 'LC':
	              this.setLineCap(value);
	              break;
	            case 'LJ':
	              this.setLineJoin(value);
	              break;
	            case 'ML':
	              this.setMiterLimit(value);
	              break;
	            case 'D':
	              this.setDash(value[0], value[1]);
	              break;
	            case 'Font':
	              this.setFont(value);
	              break;
	            case 'CA':
	              this.setStrokeAlpha(value);
	              break;
	            case 'ca':
	              this.setFillAlpha(value);
	              break;
	            default:
	              (0, _util.warn)('Unimplemented graphic state ' + key);
	              break;
	          }
	        }
	      },
	      fill: function SVGGraphics_fill() {
	        var current = this.current;
	        if (current.element) {
	          current.element.setAttributeNS(null, 'fill', current.fillColor);
	          current.element.setAttributeNS(null, 'fill-opacity', current.fillAlpha);
	        }
	      },
	      stroke: function SVGGraphics_stroke() {
	        var current = this.current;
	        if (current.element) {
	          current.element.setAttributeNS(null, 'stroke', current.strokeColor);
	          current.element.setAttributeNS(null, 'stroke-opacity', current.strokeAlpha);
	          current.element.setAttributeNS(null, 'stroke-miterlimit', pf(current.miterLimit));
	          current.element.setAttributeNS(null, 'stroke-linecap', current.lineCap);
	          current.element.setAttributeNS(null, 'stroke-linejoin', current.lineJoin);
	          current.element.setAttributeNS(null, 'stroke-width', pf(current.lineWidth) + 'px');
	          current.element.setAttributeNS(null, 'stroke-dasharray', current.dashArray.map(pf).join(' '));
	          current.element.setAttributeNS(null, 'stroke-dashoffset', pf(current.dashPhase) + 'px');
	          current.element.setAttributeNS(null, 'fill', 'none');
	        }
	      },
	      eoFill: function SVGGraphics_eoFill() {
	        if (this.current.element) {
	          this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
	        }
	        this.fill();
	      },
	      fillStroke: function SVGGraphics_fillStroke() {
	        this.stroke();
	        this.fill();
	      },
	      eoFillStroke: function SVGGraphics_eoFillStroke() {
	        if (this.current.element) {
	          this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
	        }
	        this.fillStroke();
	      },
	      closeStroke: function SVGGraphics_closeStroke() {
	        this.closePath();
	        this.stroke();
	      },
	      closeFillStroke: function SVGGraphics_closeFillStroke() {
	        this.closePath();
	        this.fillStroke();
	      },
	      closeEOFillStroke: function closeEOFillStroke() {
	        this.closePath();
	        this.eoFillStroke();
	      },
	
	      paintSolidColorImageMask: function SVGGraphics_paintSolidColorImageMask() {
	        var current = this.current;
	        var rect = this.svgFactory.createElement('svg:rect');
	        rect.setAttributeNS(null, 'x', '0');
	        rect.setAttributeNS(null, 'y', '0');
	        rect.setAttributeNS(null, 'width', '1px');
	        rect.setAttributeNS(null, 'height', '1px');
	        rect.setAttributeNS(null, 'fill', current.fillColor);
	        this._ensureTransformGroup().appendChild(rect);
	      },
	      paintJpegXObject: function SVGGraphics_paintJpegXObject(objId, w, h) {
	        var imgObj = this.objs.get(objId);
	        var imgEl = this.svgFactory.createElement('svg:image');
	        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgObj.src);
	        imgEl.setAttributeNS(null, 'width', pf(w));
	        imgEl.setAttributeNS(null, 'height', pf(h));
	        imgEl.setAttributeNS(null, 'x', '0');
	        imgEl.setAttributeNS(null, 'y', pf(-h));
	        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / w) + ' ' + pf(-1 / h) + ')');
	        this._ensureTransformGroup().appendChild(imgEl);
	      },
	      paintImageXObject: function SVGGraphics_paintImageXObject(objId) {
	        var imgData = this.objs.get(objId);
	        if (!imgData) {
	          (0, _util.warn)('Dependent image isn\'t ready yet');
	          return;
	        }
	        this.paintInlineImageXObject(imgData);
	      },
	      paintInlineImageXObject: function SVGGraphics_paintInlineImageXObject(imgData, mask) {
	        var width = imgData.width;
	        var height = imgData.height;
	        var imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
	        var cliprect = this.svgFactory.createElement('svg:rect');
	        cliprect.setAttributeNS(null, 'x', '0');
	        cliprect.setAttributeNS(null, 'y', '0');
	        cliprect.setAttributeNS(null, 'width', pf(width));
	        cliprect.setAttributeNS(null, 'height', pf(height));
	        this.current.element = cliprect;
	        this.clip('nonzero');
	        var imgEl = this.svgFactory.createElement('svg:image');
	        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgSrc);
	        imgEl.setAttributeNS(null, 'x', '0');
	        imgEl.setAttributeNS(null, 'y', pf(-height));
	        imgEl.setAttributeNS(null, 'width', pf(width) + 'px');
	        imgEl.setAttributeNS(null, 'height', pf(height) + 'px');
	        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / width) + ' ' + pf(-1 / height) + ')');
	        if (mask) {
	          mask.appendChild(imgEl);
	        } else {
	          this._ensureTransformGroup().appendChild(imgEl);
	        }
	      },
	      paintImageMaskXObject: function SVGGraphics_paintImageMaskXObject(imgData) {
	        var current = this.current;
	        var width = imgData.width;
	        var height = imgData.height;
	        var fillColor = current.fillColor;
	        current.maskId = 'mask' + maskCount++;
	        var mask = this.svgFactory.createElement('svg:mask');
	        mask.setAttributeNS(null, 'id', current.maskId);
	        var rect = this.svgFactory.createElement('svg:rect');
	        rect.setAttributeNS(null, 'x', '0');
	        rect.setAttributeNS(null, 'y', '0');
	        rect.setAttributeNS(null, 'width', pf(width));
	        rect.setAttributeNS(null, 'height', pf(height));
	        rect.setAttributeNS(null, 'fill', fillColor);
	        rect.setAttributeNS(null, 'mask', 'url(#' + current.maskId + ')');
	        this.defs.appendChild(mask);
	        this._ensureTransformGroup().appendChild(rect);
	        this.paintInlineImageXObject(imgData, mask);
	      },
	      paintFormXObjectBegin: function SVGGraphics_paintFormXObjectBegin(matrix, bbox) {
	        if (Array.isArray(matrix) && matrix.length === 6) {
	          this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
	        }
	        if (Array.isArray(bbox) && bbox.length === 4) {
	          var width = bbox[2] - bbox[0];
	          var height = bbox[3] - bbox[1];
	          var cliprect = this.svgFactory.createElement('svg:rect');
	          cliprect.setAttributeNS(null, 'x', bbox[0]);
	          cliprect.setAttributeNS(null, 'y', bbox[1]);
	          cliprect.setAttributeNS(null, 'width', pf(width));
	          cliprect.setAttributeNS(null, 'height', pf(height));
	          this.current.element = cliprect;
	          this.clip('nonzero');
	          this.endPath();
	        }
	      },
	      paintFormXObjectEnd: function SVGGraphics_paintFormXObjectEnd() {},
	      _initialize: function _initialize(viewport) {
	        var svg = this.svgFactory.create(viewport.width, viewport.height);
	        var definitions = this.svgFactory.createElement('svg:defs');
	        svg.appendChild(definitions);
	        this.defs = definitions;
	        var rootGroup = this.svgFactory.createElement('svg:g');
	        rootGroup.setAttributeNS(null, 'transform', pm(viewport.transform));
	        svg.appendChild(rootGroup);
	        this.svg = rootGroup;
	        return svg;
	      },
	
	      _ensureClipGroup: function SVGGraphics_ensureClipGroup() {
	        if (!this.current.clipGroup) {
	          var clipGroup = this.svgFactory.createElement('svg:g');
	          clipGroup.setAttributeNS(null, 'clip-path', this.current.activeClipUrl);
	          this.svg.appendChild(clipGroup);
	          this.current.clipGroup = clipGroup;
	        }
	        return this.current.clipGroup;
	      },
	      _ensureTransformGroup: function SVGGraphics_ensureTransformGroup() {
	        if (!this.tgrp) {
	          this.tgrp = this.svgFactory.createElement('svg:g');
	          this.tgrp.setAttributeNS(null, 'transform', pm(this.transformMatrix));
	          if (this.current.activeClipUrl) {
	            this._ensureClipGroup().appendChild(this.tgrp);
	          } else {
	            this.svg.appendChild(this.tgrp);
	          }
	        }
	        return this.tgrp;
	      }
	    };
	    return SVGGraphics;
	  }();
	}
	exports.SVGGraphics = SVGGraphics;
	
	/***/ }),
	/* 63 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var pdfjsVersion = '2.0.305';
	var pdfjsBuild = '9c6a8801';
	var pdfjsSharedUtil = __w_pdfjs_require__(0);
	var pdfjsDisplayGlobal = __w_pdfjs_require__(115);
	var pdfjsDisplayAPI = __w_pdfjs_require__(58);
	var pdfjsDisplayTextLayer = __w_pdfjs_require__(61);
	var pdfjsDisplayAnnotationLayer = __w_pdfjs_require__(60);
	var pdfjsDisplayDOMUtils = __w_pdfjs_require__(10);
	var pdfjsDisplaySVG = __w_pdfjs_require__(62);
	{
	  var isNodeJS = __w_pdfjs_require__(24);
	  if (isNodeJS()) {
	    var PDFNodeStream = __w_pdfjs_require__(121).PDFNodeStream;
	    pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
	      return new PDFNodeStream(params);
	    });
	  } else if (typeof Response !== 'undefined' && 'body' in Response.prototype && typeof ReadableStream !== 'undefined') {
	    var PDFFetchStream = __w_pdfjs_require__(123).PDFFetchStream;
	    pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
	      return new PDFFetchStream(params);
	    });
	  } else {
	    var PDFNetworkStream = __w_pdfjs_require__(124).PDFNetworkStream;
	    pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
	      return new PDFNetworkStream(params);
	    });
	  }
	}
	exports.PDFJS = pdfjsDisplayGlobal.PDFJS;
	exports.build = pdfjsDisplayAPI.build;
	exports.version = pdfjsDisplayAPI.version;
	exports.getDocument = pdfjsDisplayAPI.getDocument;
	exports.LoopbackPort = pdfjsDisplayAPI.LoopbackPort;
	exports.PDFDataRangeTransport = pdfjsDisplayAPI.PDFDataRangeTransport;
	exports.PDFWorker = pdfjsDisplayAPI.PDFWorker;
	exports.renderTextLayer = pdfjsDisplayTextLayer.renderTextLayer;
	exports.AnnotationLayer = pdfjsDisplayAnnotationLayer.AnnotationLayer;
	exports.createPromiseCapability = pdfjsSharedUtil.createPromiseCapability;
	exports.PasswordResponses = pdfjsSharedUtil.PasswordResponses;
	exports.InvalidPDFException = pdfjsSharedUtil.InvalidPDFException;
	exports.MissingPDFException = pdfjsSharedUtil.MissingPDFException;
	exports.SVGGraphics = pdfjsDisplaySVG.SVGGraphics;
	exports.NativeImageDecoding = pdfjsSharedUtil.NativeImageDecoding;
	exports.UnexpectedResponseException = pdfjsSharedUtil.UnexpectedResponseException;
	exports.OPS = pdfjsSharedUtil.OPS;
	exports.UNSUPPORTED_FEATURES = pdfjsSharedUtil.UNSUPPORTED_FEATURES;
	exports.createValidAbsoluteUrl = pdfjsSharedUtil.createValidAbsoluteUrl;
	exports.createObjectURL = pdfjsSharedUtil.createObjectURL;
	exports.removeNullCharacters = pdfjsSharedUtil.removeNullCharacters;
	exports.shadow = pdfjsSharedUtil.shadow;
	exports.createBlob = pdfjsSharedUtil.createBlob;
	exports.RenderingCancelledException = pdfjsDisplayDOMUtils.RenderingCancelledException;
	exports.getFilenameFromUrl = pdfjsDisplayDOMUtils.getFilenameFromUrl;
	exports.addLinkAttributes = pdfjsDisplayDOMUtils.addLinkAttributes;
	
	/***/ }),
	/* 64 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	if (typeof PDFJS === 'undefined' || !PDFJS.compatibilityChecked) {
	  var globalScope = __w_pdfjs_require__(14);
	  var isNodeJS = __w_pdfjs_require__(24);
	  var userAgent = typeof navigator !== 'undefined' && navigator.userAgent || '';
	  var isAndroid = /Android/.test(userAgent);
	  var isIOSChrome = userAgent.indexOf('CriOS') >= 0;
	  var isIE = userAgent.indexOf('Trident') >= 0;
	  var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent);
	  var isSafari = /Safari\//.test(userAgent) && !/(Chrome\/|Android\s)/.test(userAgent);
	  var hasDOM = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object';
	  if (typeof PDFJS === 'undefined') {
	    globalScope.PDFJS = {};
	  }
	  PDFJS.compatibilityChecked = true;
	  (function checkNodeBtoa() {
	    if (globalScope.btoa || !isNodeJS()) {
	      return;
	    }
	    globalScope.btoa = function (chars) {
	      return Buffer.from(chars, 'binary').toString('base64');
	    };
	  })();
	  (function checkNodeAtob() {
	    if (globalScope.atob || !isNodeJS()) {
	      return;
	    }
	    globalScope.atob = function (input) {
	      return Buffer.from(input, 'base64').toString('binary');
	    };
	  })();
	  (function checkOnBlobSupport() {
	    if (isIE || isIOSChrome) {
	      PDFJS.disableCreateObjectURL = true;
	    }
	  })();
	  (function checkNavigatorLanguage() {
	    if (typeof navigator === 'undefined') {
	      return;
	    }
	    if ('language' in navigator) {
	      return;
	    }
	    PDFJS.locale = navigator.userLanguage || 'en-US';
	  })();
	  (function checkRangeRequests() {
	    if (isSafari || isIOS) {
	      PDFJS.disableRange = true;
	      PDFJS.disableStream = true;
	    }
	  })();
	  (function checkCanvasSizeLimitation() {
	    if (isIOS || isAndroid) {
	      PDFJS.maxCanvasPixels = 5242880;
	    }
	  })();
	  (function checkFullscreenSupport() {
	    if (!hasDOM) {
	      return;
	    }
	    if (isIE && window.parent !== window) {
	      PDFJS.disableFullscreen = true;
	    }
	  })();
	  (function checkCurrentScript() {
	    if (!hasDOM) {
	      return;
	    }
	    if ('currentScript' in document) {
	      return;
	    }
	    Object.defineProperty(document, 'currentScript', {
	      get: function get() {
	        var scripts = document.getElementsByTagName('script');
	        return scripts[scripts.length - 1];
	      },
	
	      enumerable: true,
	      configurable: true
	    });
	  })();
	  (function checkChildNodeRemove() {
	    if (!hasDOM) {
	      return;
	    }
	    if (typeof Element.prototype.remove !== 'undefined') {
	      return;
	    }
	    Element.prototype.remove = function () {
	      if (this.parentNode) {
	        this.parentNode.removeChild(this);
	      }
	    };
	  })();
	  (function checkArrayIncludes() {
	    if (Array.prototype.includes) {
	      return;
	    }
	    Array.prototype.includes = __w_pdfjs_require__(65);
	  })();
	  (function checkMathLog2() {
	    if (Math.log2) {
	      return;
	    }
	    Math.log2 = __w_pdfjs_require__(68);
	  })();
	  (function checkNumberIsNaN() {
	    if (Number.isNaN) {
	      return;
	    }
	    Number.isNaN = __w_pdfjs_require__(70);
	  })();
	  (function checkNumberIsInteger() {
	    if (Number.isInteger) {
	      return;
	    }
	    Number.isInteger = __w_pdfjs_require__(72);
	  })();
	  (function checkPromise() {
	    if (globalScope.Promise) {
	      return;
	    }
	    globalScope.Promise = __w_pdfjs_require__(75);
	  })();
	  (function checkWeakMap() {
	    if (globalScope.WeakMap) {
	      return;
	    }
	    globalScope.WeakMap = __w_pdfjs_require__(94);
	  })();
	  (function checkURLConstructor() {
	    var hasWorkingUrl = false;
	    try {
	      if (typeof URL === 'function' && _typeof(URL.prototype) === 'object' && 'origin' in URL.prototype) {
	        var u = new URL('b', 'http://a');
	        u.pathname = 'c%20d';
	        hasWorkingUrl = u.href === 'http://a/c%20d';
	      }
	    } catch (e) {}
	    if (hasWorkingUrl) {
	      return;
	    }
	    var relative = Object.create(null);
	    relative['ftp'] = 21;
	    relative['file'] = 0;
	    relative['gopher'] = 70;
	    relative['http'] = 80;
	    relative['https'] = 443;
	    relative['ws'] = 80;
	    relative['wss'] = 443;
	    var relativePathDotMapping = Object.create(null);
	    relativePathDotMapping['%2e'] = '.';
	    relativePathDotMapping['.%2e'] = '..';
	    relativePathDotMapping['%2e.'] = '..';
	    relativePathDotMapping['%2e%2e'] = '..';
	    function isRelativeScheme(scheme) {
	      return relative[scheme] !== undefined;
	    }
	    function invalid() {
	      clear.call(this);
	      this._isInvalid = true;
	    }
	    function IDNAToASCII(h) {
	      if (h === '') {
	        invalid.call(this);
	      }
	      return h.toLowerCase();
	    }
	    function percentEscape(c) {
	      var unicode = c.charCodeAt(0);
	      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x3F, 0x60].indexOf(unicode) === -1) {
	        return c;
	      }
	      return encodeURIComponent(c);
	    }
	    function percentEscapeQuery(c) {
	      var unicode = c.charCodeAt(0);
	      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x60].indexOf(unicode) === -1) {
	        return c;
	      }
	      return encodeURIComponent(c);
	    }
	    var EOF,
	        ALPHA = /[a-zA-Z]/,
	        ALPHANUMERIC = /[a-zA-Z0-9\+\-\.]/;
	    function parse(input, stateOverride, base) {
	      function err(message) {
	        errors.push(message);
	      }
	      var state = stateOverride || 'scheme start',
	          cursor = 0,
	          buffer = '',
	          seenAt = false,
	          seenBracket = false,
	          errors = [];
	      loop: while ((input[cursor - 1] !== EOF || cursor === 0) && !this._isInvalid) {
	        var c = input[cursor];
	        switch (state) {
	          case 'scheme start':
	            if (c && ALPHA.test(c)) {
	              buffer += c.toLowerCase();
	              state = 'scheme';
	            } else if (!stateOverride) {
	              buffer = '';
	              state = 'no scheme';
	              continue;
	            } else {
	              err('Invalid scheme.');
	              break loop;
	            }
	            break;
	          case 'scheme':
	            if (c && ALPHANUMERIC.test(c)) {
	              buffer += c.toLowerCase();
	            } else if (c === ':') {
	              this._scheme = buffer;
	              buffer = '';
	              if (stateOverride) {
	                break loop;
	              }
	              if (isRelativeScheme(this._scheme)) {
	                this._isRelative = true;
	              }
	              if (this._scheme === 'file') {
	                state = 'relative';
	              } else if (this._isRelative && base && base._scheme === this._scheme) {
	                state = 'relative or authority';
	              } else if (this._isRelative) {
	                state = 'authority first slash';
	              } else {
	                state = 'scheme data';
	              }
	            } else if (!stateOverride) {
	              buffer = '';
	              cursor = 0;
	              state = 'no scheme';
	              continue;
	            } else if (c === EOF) {
	              break loop;
	            } else {
	              err('Code point not allowed in scheme: ' + c);
	              break loop;
	            }
	            break;
	          case 'scheme data':
	            if (c === '?') {
	              this._query = '?';
	              state = 'query';
	            } else if (c === '#') {
	              this._fragment = '#';
	              state = 'fragment';
	            } else {
	              if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	                this._schemeData += percentEscape(c);
	              }
	            }
	            break;
	          case 'no scheme':
	            if (!base || !isRelativeScheme(base._scheme)) {
	              err('Missing scheme.');
	              invalid.call(this);
	            } else {
	              state = 'relative';
	              continue;
	            }
	            break;
	          case 'relative or authority':
	            if (c === '/' && input[cursor + 1] === '/') {
	              state = 'authority ignore slashes';
	            } else {
	              err('Expected /, got: ' + c);
	              state = 'relative';
	              continue;
	            }
	            break;
	          case 'relative':
	            this._isRelative = true;
	            if (this._scheme !== 'file') {
	              this._scheme = base._scheme;
	            }
	            if (c === EOF) {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = base._query;
	              this._username = base._username;
	              this._password = base._password;
	              break loop;
	            } else if (c === '/' || c === '\\') {
	              if (c === '\\') {
	                err('\\ is an invalid code point.');
	              }
	              state = 'relative slash';
	            } else if (c === '?') {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = '?';
	              this._username = base._username;
	              this._password = base._password;
	              state = 'query';
	            } else if (c === '#') {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = base._query;
	              this._fragment = '#';
	              this._username = base._username;
	              this._password = base._password;
	              state = 'fragment';
	            } else {
	              var nextC = input[cursor + 1];
	              var nextNextC = input[cursor + 2];
	              if (this._scheme !== 'file' || !ALPHA.test(c) || nextC !== ':' && nextC !== '|' || nextNextC !== EOF && nextNextC !== '/' && nextNextC !== '\\' && nextNextC !== '?' && nextNextC !== '#') {
	                this._host = base._host;
	                this._port = base._port;
	                this._username = base._username;
	                this._password = base._password;
	                this._path = base._path.slice();
	                this._path.pop();
	              }
	              state = 'relative path';
	              continue;
	            }
	            break;
	          case 'relative slash':
	            if (c === '/' || c === '\\') {
	              if (c === '\\') {
	                err('\\ is an invalid code point.');
	              }
	              if (this._scheme === 'file') {
	                state = 'file host';
	              } else {
	                state = 'authority ignore slashes';
	              }
	            } else {
	              if (this._scheme !== 'file') {
	                this._host = base._host;
	                this._port = base._port;
	                this._username = base._username;
	                this._password = base._password;
	              }
	              state = 'relative path';
	              continue;
	            }
	            break;
	          case 'authority first slash':
	            if (c === '/') {
	              state = 'authority second slash';
	            } else {
	              err('Expected \'/\', got: ' + c);
	              state = 'authority ignore slashes';
	              continue;
	            }
	            break;
	          case 'authority second slash':
	            state = 'authority ignore slashes';
	            if (c !== '/') {
	              err('Expected \'/\', got: ' + c);
	              continue;
	            }
	            break;
	          case 'authority ignore slashes':
	            if (c !== '/' && c !== '\\') {
	              state = 'authority';
	              continue;
	            } else {
	              err('Expected authority, got: ' + c);
	            }
	            break;
	          case 'authority':
	            if (c === '@') {
	              if (seenAt) {
	                err('@ already seen.');
	                buffer += '%40';
	              }
	              seenAt = true;
	              for (var i = 0; i < buffer.length; i++) {
	                var cp = buffer[i];
	                if (cp === '\t' || cp === '\n' || cp === '\r') {
	                  err('Invalid whitespace in authority.');
	                  continue;
	                }
	                if (cp === ':' && this._password === null) {
	                  this._password = '';
	                  continue;
	                }
	                var tempC = percentEscape(cp);
	                if (this._password !== null) {
	                  this._password += tempC;
	                } else {
	                  this._username += tempC;
	                }
	              }
	              buffer = '';
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              cursor -= buffer.length;
	              buffer = '';
	              state = 'host';
	              continue;
	            } else {
	              buffer += c;
	            }
	            break;
	          case 'file host':
	            if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              if (buffer.length === 2 && ALPHA.test(buffer[0]) && (buffer[1] === ':' || buffer[1] === '|')) {
	                state = 'relative path';
	              } else if (buffer.length === 0) {
	                state = 'relative path start';
	              } else {
	                this._host = IDNAToASCII.call(this, buffer);
	                buffer = '';
	                state = 'relative path start';
	              }
	              continue;
	            } else if (c === '\t' || c === '\n' || c === '\r') {
	              err('Invalid whitespace in file host.');
	            } else {
	              buffer += c;
	            }
	            break;
	          case 'host':
	          case 'hostname':
	            if (c === ':' && !seenBracket) {
	              this._host = IDNAToASCII.call(this, buffer);
	              buffer = '';
	              state = 'port';
	              if (stateOverride === 'hostname') {
	                break loop;
	              }
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              this._host = IDNAToASCII.call(this, buffer);
	              buffer = '';
	              state = 'relative path start';
	              if (stateOverride) {
	                break loop;
	              }
	              continue;
	            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
	              if (c === '[') {
	                seenBracket = true;
	              } else if (c === ']') {
	                seenBracket = false;
	              }
	              buffer += c;
	            } else {
	              err('Invalid code point in host/hostname: ' + c);
	            }
	            break;
	          case 'port':
	            if (/[0-9]/.test(c)) {
	              buffer += c;
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#' || stateOverride) {
	              if (buffer !== '') {
	                var temp = parseInt(buffer, 10);
	                if (temp !== relative[this._scheme]) {
	                  this._port = temp + '';
	                }
	                buffer = '';
	              }
	              if (stateOverride) {
	                break loop;
	              }
	              state = 'relative path start';
	              continue;
	            } else if (c === '\t' || c === '\n' || c === '\r') {
	              err('Invalid code point in port: ' + c);
	            } else {
	              invalid.call(this);
	            }
	            break;
	          case 'relative path start':
	            if (c === '\\') {
	              err('\'\\\' not allowed in path.');
	            }
	            state = 'relative path';
	            if (c !== '/' && c !== '\\') {
	              continue;
	            }
	            break;
	          case 'relative path':
	            if (c === EOF || c === '/' || c === '\\' || !stateOverride && (c === '?' || c === '#')) {
	              if (c === '\\') {
	                err('\\ not allowed in relative path.');
	              }
	              var tmp;
	              if (tmp = relativePathDotMapping[buffer.toLowerCase()]) {
	                buffer = tmp;
	              }
	              if (buffer === '..') {
	                this._path.pop();
	                if (c !== '/' && c !== '\\') {
	                  this._path.push('');
	                }
	              } else if (buffer === '.' && c !== '/' && c !== '\\') {
	                this._path.push('');
	              } else if (buffer !== '.') {
	                if (this._scheme === 'file' && this._path.length === 0 && buffer.length === 2 && ALPHA.test(buffer[0]) && buffer[1] === '|') {
	                  buffer = buffer[0] + ':';
	                }
	                this._path.push(buffer);
	              }
	              buffer = '';
	              if (c === '?') {
	                this._query = '?';
	                state = 'query';
	              } else if (c === '#') {
	                this._fragment = '#';
	                state = 'fragment';
	              }
	            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
	              buffer += percentEscape(c);
	            }
	            break;
	          case 'query':
	            if (!stateOverride && c === '#') {
	              this._fragment = '#';
	              state = 'fragment';
	            } else if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	              this._query += percentEscapeQuery(c);
	            }
	            break;
	          case 'fragment':
	            if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	              this._fragment += c;
	            }
	            break;
	        }
	        cursor++;
	      }
	    }
	    function clear() {
	      this._scheme = '';
	      this._schemeData = '';
	      this._username = '';
	      this._password = null;
	      this._host = '';
	      this._port = '';
	      this._path = [];
	      this._query = '';
	      this._fragment = '';
	      this._isInvalid = false;
	      this._isRelative = false;
	    }
	    function JURL(url, base) {
	      if (base !== undefined && !(base instanceof JURL)) {
	        base = new JURL(String(base));
	      }
	      this._url = url;
	      clear.call(this);
	      var input = url.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, '');
	      parse.call(this, input, null, base);
	    }
	    JURL.prototype = {
	      toString: function toString() {
	        return this.href;
	      },
	
	      get href() {
	        if (this._isInvalid) {
	          return this._url;
	        }
	        var authority = '';
	        if (this._username !== '' || this._password !== null) {
	          authority = this._username + (this._password !== null ? ':' + this._password : '') + '@';
	        }
	        return this.protocol + (this._isRelative ? '//' + authority + this.host : '') + this.pathname + this._query + this._fragment;
	      },
	      set href(value) {
	        clear.call(this);
	        parse.call(this, value);
	      },
	      get protocol() {
	        return this._scheme + ':';
	      },
	      set protocol(value) {
	        if (this._isInvalid) {
	          return;
	        }
	        parse.call(this, value + ':', 'scheme start');
	      },
	      get host() {
	        return this._isInvalid ? '' : this._port ? this._host + ':' + this._port : this._host;
	      },
	      set host(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, value, 'host');
	      },
	      get hostname() {
	        return this._host;
	      },
	      set hostname(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, value, 'hostname');
	      },
	      get port() {
	        return this._port;
	      },
	      set port(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, value, 'port');
	      },
	      get pathname() {
	        return this._isInvalid ? '' : this._isRelative ? '/' + this._path.join('/') : this._schemeData;
	      },
	      set pathname(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        this._path = [];
	        parse.call(this, value, 'relative path start');
	      },
	      get search() {
	        return this._isInvalid || !this._query || this._query === '?' ? '' : this._query;
	      },
	      set search(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        this._query = '?';
	        if (value[0] === '?') {
	          value = value.slice(1);
	        }
	        parse.call(this, value, 'query');
	      },
	      get hash() {
	        return this._isInvalid || !this._fragment || this._fragment === '#' ? '' : this._fragment;
	      },
	      set hash(value) {
	        if (this._isInvalid) {
	          return;
	        }
	        this._fragment = '#';
	        if (value[0] === '#') {
	          value = value.slice(1);
	        }
	        parse.call(this, value, 'fragment');
	      },
	      get origin() {
	        var host;
	        if (this._isInvalid || !this._scheme) {
	          return '';
	        }
	        switch (this._scheme) {
	          case 'data':
	          case 'file':
	          case 'javascript':
	          case 'mailto':
	            return 'null';
	          case 'blob':
	            try {
	              return new JURL(this._schemeData).origin || 'null';
	            } catch (_) {}
	            return 'null';
	        }
	        host = this.host;
	        if (!host) {
	          return '';
	        }
	        return this._scheme + '://' + host;
	      }
	    };
	    var OriginalURL = globalScope.URL;
	    if (OriginalURL) {
	      JURL.createObjectURL = function (blob) {
	        return OriginalURL.createObjectURL.apply(OriginalURL, arguments);
	      };
	      JURL.revokeObjectURL = function (url) {
	        OriginalURL.revokeObjectURL(url);
	      };
	    }
	    globalScope.URL = JURL;
	  })();
	  (function checkObjectValues() {
	    if (Object.values) {
	      return;
	    }
	    Object.values = __w_pdfjs_require__(110);
	  })();
	}
	
	/***/ }),
	/* 65 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(66);
	module.exports = __w_pdfjs_require__(5).Array.includes;
	
	/***/ }),
	/* 66 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(4);
	var $includes = __w_pdfjs_require__(42)(true);
	$export($export.P, 'Array', {
	  includes: function includes(el) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__w_pdfjs_require__(43)('includes');
	
	/***/ }),
	/* 67 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toInteger = __w_pdfjs_require__(30);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};
	
	/***/ }),
	/* 68 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(69);
	module.exports = __w_pdfjs_require__(5).Math.log2;
	
	/***/ }),
	/* 69 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(4);
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});
	
	/***/ }),
	/* 70 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(71);
	module.exports = __w_pdfjs_require__(5).Number.isNaN;
	
	/***/ }),
	/* 71 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(4);
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    return number != number;
	  }
	});
	
	/***/ }),
	/* 72 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(73);
	module.exports = __w_pdfjs_require__(5).Number.isInteger;
	
	/***/ }),
	/* 73 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(4);
	$export($export.S, 'Number', { isInteger: __w_pdfjs_require__(74) });
	
	/***/ }),
	/* 74 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(1);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};
	
	/***/ }),
	/* 75 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(45);
	__w_pdfjs_require__(76);
	__w_pdfjs_require__(50);
	__w_pdfjs_require__(85);
	__w_pdfjs_require__(92);
	__w_pdfjs_require__(93);
	module.exports = __w_pdfjs_require__(5).Promise;
	
	/***/ }),
	/* 76 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $at = __w_pdfjs_require__(77)(true);
	__w_pdfjs_require__(46)(String, 'String', function (iterated) {
	  this._t = String(iterated);
	  this._i = 0;
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return {
	    value: undefined,
	    done: true
	  };
	  point = $at(O, index);
	  this._i += point.length;
	  return {
	    value: point,
	    done: false
	  };
	});
	
	/***/ }),
	/* 77 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toInteger = __w_pdfjs_require__(30);
	var defined = __w_pdfjs_require__(28);
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};
	
	/***/ }),
	/* 78 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var create = __w_pdfjs_require__(79);
	var descriptor = __w_pdfjs_require__(26);
	var setToStringTag = __w_pdfjs_require__(22);
	var IteratorPrototype = {};
	__w_pdfjs_require__(11)(IteratorPrototype, __w_pdfjs_require__(2)('iterator'), function () {
	  return this;
	});
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};
	
	/***/ }),
	/* 79 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var anObject = __w_pdfjs_require__(6);
	var dPs = __w_pdfjs_require__(80);
	var enumBugKeys = __w_pdfjs_require__(48);
	var IE_PROTO = __w_pdfjs_require__(32)('IE_PROTO');
	var Empty = function Empty() {};
	var PROTOTYPE = 'prototype';
	var _createDict = function createDict() {
	  var iframe = __w_pdfjs_require__(25)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __w_pdfjs_require__(49).appendChild(iframe);
	  iframe.src = 'javascript:';
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  _createDict = iframeDocument.F;
	  while (i--) {
	    delete _createDict[PROTOTYPE][enumBugKeys[i]];
	  }return _createDict();
	};
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    result[IE_PROTO] = O;
	  } else result = _createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};
	
	/***/ }),
	/* 80 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var dP = __w_pdfjs_require__(15);
	var anObject = __w_pdfjs_require__(6);
	var getKeys = __w_pdfjs_require__(21);
	module.exports = __w_pdfjs_require__(12) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) {
	    dP.f(O, P = keys[i++], Properties[P]);
	  }return O;
	};
	
	/***/ }),
	/* 81 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var has = __w_pdfjs_require__(7);
	var toIObject = __w_pdfjs_require__(17);
	var arrayIndexOf = __w_pdfjs_require__(42)(false);
	var IE_PROTO = __w_pdfjs_require__(32)('IE_PROTO');
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) {
	    if (key != IE_PROTO) has(O, key) && result.push(key);
	  }while (names.length > i) {
	    if (has(O, key = names[i++])) {
	      ~arrayIndexOf(result, key) || result.push(key);
	    }
	  }return result;
	};
	
	/***/ }),
	/* 82 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var has = __w_pdfjs_require__(7);
	var toObject = __w_pdfjs_require__(33);
	var IE_PROTO = __w_pdfjs_require__(32)('IE_PROTO');
	var ObjectProto = Object.prototype;
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  }
	  return O instanceof Object ? ObjectProto : null;
	};
	
	/***/ }),
	/* 83 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var addToUnscopables = __w_pdfjs_require__(43);
	var step = __w_pdfjs_require__(84);
	var Iterators = __w_pdfjs_require__(19);
	var toIObject = __w_pdfjs_require__(17);
	module.exports = __w_pdfjs_require__(46)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated);
	  this._i = 0;
	  this._k = kind;
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	Iterators.Arguments = Iterators.Array;
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');
	
	/***/ }),
	/* 84 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (done, value) {
	  return {
	    value: value,
	    done: !!done
	  };
	};
	
	/***/ }),
	/* 85 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var LIBRARY = __w_pdfjs_require__(47);
	var global = __w_pdfjs_require__(3);
	var ctx = __w_pdfjs_require__(9);
	var classof = __w_pdfjs_require__(31);
	var $export = __w_pdfjs_require__(4);
	var isObject = __w_pdfjs_require__(1);
	var aFunction = __w_pdfjs_require__(16);
	var anInstance = __w_pdfjs_require__(34);
	var forOf = __w_pdfjs_require__(23);
	var speciesConstructor = __w_pdfjs_require__(51);
	var task = __w_pdfjs_require__(52).set;
	var microtask = __w_pdfjs_require__(90)();
	var newPromiseCapabilityModule = __w_pdfjs_require__(35);
	var perform = __w_pdfjs_require__(53);
	var promiseResolve = __w_pdfjs_require__(54);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function empty() {};
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	var USE_NATIVE = !!function () {
	  try {
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__w_pdfjs_require__(2)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) {}
	}();
	var isThenable = function isThenable(it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function notify(promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function run(reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;else {
	            if (domain) domain.enter();
	            result = handler(value);
	            if (domain) domain.exit();
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        reject(e);
	      }
	    };
	    while (chain.length > i) {
	      run(chain[i++]);
	    }promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function onUnhandled(promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({
	            promise: promise,
	            reason: value
	          });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    }
	    promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function isUnhandled(promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function onHandleUnhandled(promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({
	        promise: promise,
	        reason: promise._v
	      });
	    }
	  });
	};
	var $reject = function $reject(value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise;
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function $resolve(value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise;
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = {
	          _w: promise,
	          _d: false
	        };
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({
	      _w: promise,
	      _d: false
	    }, e);
	  }
	};
	if (!USE_NATIVE) {
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor) {
	    this._c = [];
	    this._a = undefined;
	    this._s = 0;
	    this._d = false;
	    this._v = undefined;
	    this._h = 0;
	    this._n = false;
	  };
	  Internal.prototype = __w_pdfjs_require__(36)($Promise.prototype, {
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    'catch': function _catch(onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function OwnPromiseCapability() {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
	    return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
	  };
	}
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__w_pdfjs_require__(22)($Promise, PROMISE);
	__w_pdfjs_require__(91)(PROMISE);
	Wrapper = __w_pdfjs_require__(5)[PROMISE];
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __w_pdfjs_require__(55)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});
	
	/***/ }),
	/* 86 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var anObject = __w_pdfjs_require__(6);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};
	
	/***/ }),
	/* 87 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var Iterators = __w_pdfjs_require__(19);
	var ITERATOR = __w_pdfjs_require__(2)('iterator');
	var ArrayProto = Array.prototype;
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};
	
	/***/ }),
	/* 88 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var classof = __w_pdfjs_require__(31);
	var ITERATOR = __w_pdfjs_require__(2)('iterator');
	var Iterators = __w_pdfjs_require__(19);
	module.exports = __w_pdfjs_require__(5).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
	};
	
	/***/ }),
	/* 89 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0:
	      return un ? fn() : fn.call(that);
	    case 1:
	      return un ? fn(args[0]) : fn.call(that, args[0]);
	    case 2:
	      return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
	    case 3:
	      return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
	    case 4:
	      return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
	  }
	  return fn.apply(that, args);
	};
	
	/***/ }),
	/* 90 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(3);
	var macrotask = __w_pdfjs_require__(52).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __w_pdfjs_require__(18)(process) == 'process';
	module.exports = function () {
	  var head, last, notify;
	  var flush = function flush() {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();else last = undefined;
	        throw e;
	      }
	    }
	    last = undefined;
	    if (parent) parent.enter();
	  };
	  if (isNode) {
	    notify = function notify() {
	      process.nextTick(flush);
	    };
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true });
	    notify = function notify() {
	      node.data = toggle = !toggle;
	    };
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function notify() {
	      promise.then(flush);
	    };
	  } else {
	    notify = function notify() {
	      macrotask.call(global, flush);
	    };
	  }
	  return function (fn) {
	    var task = {
	      fn: fn,
	      next: undefined
	    };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    }
	    last = task;
	  };
	};
	
	/***/ }),
	/* 91 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(3);
	var dP = __w_pdfjs_require__(15);
	var DESCRIPTORS = __w_pdfjs_require__(12);
	var SPECIES = __w_pdfjs_require__(2)('species');
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function get() {
	      return this;
	    }
	  });
	};
	
	/***/ }),
	/* 92 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(4);
	var core = __w_pdfjs_require__(5);
	var global = __w_pdfjs_require__(3);
	var speciesConstructor = __w_pdfjs_require__(51);
	var promiseResolve = __w_pdfjs_require__(54);
	$export($export.P + $export.R, 'Promise', {
	  'finally': function _finally(onFinally) {
	    var C = speciesConstructor(this, core.Promise || global.Promise);
	    var isFunction = typeof onFinally == 'function';
	    return this.then(isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () {
	        return x;
	      });
	    } : onFinally, isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () {
	        throw e;
	      });
	    } : onFinally);
	  }
	});
	
	/***/ }),
	/* 93 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(4);
	var newPromiseCapability = __w_pdfjs_require__(35);
	var perform = __w_pdfjs_require__(53);
	$export($export.S, 'Promise', {
	  'try': function _try(callbackfn) {
	    var promiseCapability = newPromiseCapability.f(this);
	    var result = perform(callbackfn);
	    (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	    return promiseCapability.promise;
	  }
	});
	
	/***/ }),
	/* 94 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(45);
	__w_pdfjs_require__(50);
	__w_pdfjs_require__(95);
	__w_pdfjs_require__(106);
	__w_pdfjs_require__(108);
	module.exports = __w_pdfjs_require__(5).WeakMap;
	
	/***/ }),
	/* 95 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var each = __w_pdfjs_require__(56)(0);
	var redefine = __w_pdfjs_require__(8);
	var meta = __w_pdfjs_require__(37);
	var assign = __w_pdfjs_require__(99);
	var weak = __w_pdfjs_require__(101);
	var isObject = __w_pdfjs_require__(1);
	var fails = __w_pdfjs_require__(13);
	var validate = __w_pdfjs_require__(57);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	var wrapper = function wrapper(get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	var methods = {
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	var $WeakMap = module.exports = __w_pdfjs_require__(102)(WEAK_MAP, wrapper, methods, weak, true, true);
	if (fails(function () {
	  return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7;
	})) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      }
	      return method.call(this, a, b);
	    });
	  });
	}
	
	/***/ }),
	/* 96 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var speciesConstructor = __w_pdfjs_require__(97);
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};
	
	/***/ }),
	/* 97 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(1);
	var isArray = __w_pdfjs_require__(98);
	var SPECIES = __w_pdfjs_require__(2)('species');
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  }
	  return C === undefined ? Array : C;
	};
	
	/***/ }),
	/* 98 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var cof = __w_pdfjs_require__(18);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};
	
	/***/ }),
	/* 99 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var getKeys = __w_pdfjs_require__(21);
	var gOPS = __w_pdfjs_require__(100);
	var pIE = __w_pdfjs_require__(38);
	var toObject = __w_pdfjs_require__(33);
	var IObject = __w_pdfjs_require__(27);
	var $assign = Object.assign;
	module.exports = !$assign || __w_pdfjs_require__(13)(function () {
	  var A = {};
	  var B = {};
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) {
	    B[k] = k;
	  });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) {
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	    }
	  }
	  return T;
	} : $assign;
	
	/***/ }),
	/* 100 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	exports.f = Object.getOwnPropertySymbols;
	
	/***/ }),
	/* 101 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var redefineAll = __w_pdfjs_require__(36);
	var getWeak = __w_pdfjs_require__(37).getWeak;
	var anObject = __w_pdfjs_require__(6);
	var isObject = __w_pdfjs_require__(1);
	var anInstance = __w_pdfjs_require__(34);
	var forOf = __w_pdfjs_require__(23);
	var createArrayMethod = __w_pdfjs_require__(56);
	var $has = __w_pdfjs_require__(7);
	var validate = __w_pdfjs_require__(57);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function UncaughtFrozenStore() {
	  this.a = [];
	};
	var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function get(key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function has(key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function set(key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;else this.a.push([key, value]);
	  },
	  'delete': function _delete(key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	module.exports = {
	  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;
	      that._i = id++;
	      that._l = undefined;
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      'delete': function _delete(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function def(that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};
	
	/***/ }),
	/* 102 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(3);
	var $export = __w_pdfjs_require__(4);
	var redefine = __w_pdfjs_require__(8);
	var redefineAll = __w_pdfjs_require__(36);
	var meta = __w_pdfjs_require__(37);
	var forOf = __w_pdfjs_require__(23);
	var anInstance = __w_pdfjs_require__(34);
	var isObject = __w_pdfjs_require__(1);
	var fails = __w_pdfjs_require__(13);
	var $iterDetect = __w_pdfjs_require__(55);
	var setToStringTag = __w_pdfjs_require__(22);
	var inheritIfRequired = __w_pdfjs_require__(103);
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function fixMethod(KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY, KEY == 'delete' ? function (a) {
	      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	    } : KEY == 'has' ? function has(a) {
	      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	    } : KEY == 'get' ? function get(a) {
	      return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	    } : KEY == 'add' ? function add(a) {
	      fn.call(this, a === 0 ? 0 : a);
	      return this;
	    } : function set(a, b) {
	      fn.call(this, a === 0 ? 0 : a, b);
	      return this;
	    });
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    var THROWS_ON_PRIMITIVES = fails(function () {
	      instance.has(1);
	    });
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) {
	      new C(iter);
	    });
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      var $instance = new C();
	      var index = 5;
	      while (index--) {
	        $instance[ADDER](index, index);
	      }return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	  setToStringTag(C, NAME);
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	  return C;
	};
	
	/***/ }),
	/* 103 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(1);
	var setPrototypeOf = __w_pdfjs_require__(104).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  }
	  return that;
	};
	
	/***/ }),
	/* 104 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(1);
	var anObject = __w_pdfjs_require__(6);
	var check = function check(O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? function (test, buggy, set) {
	    try {
	      set = __w_pdfjs_require__(9)(Function.call, __w_pdfjs_require__(105).f(Object.prototype, '__proto__').set, 2);
	      set(test, []);
	      buggy = !(test instanceof Array);
	    } catch (e) {
	      buggy = true;
	    }
	    return function setPrototypeOf(O, proto) {
	      check(O, proto);
	      if (buggy) O.__proto__ = proto;else set(O, proto);
	      return O;
	    };
	  }({}, false) : undefined),
	  check: check
	};
	
	/***/ }),
	/* 105 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var pIE = __w_pdfjs_require__(38);
	var createDesc = __w_pdfjs_require__(26);
	var toIObject = __w_pdfjs_require__(17);
	var toPrimitive = __w_pdfjs_require__(41);
	var has = __w_pdfjs_require__(7);
	var IE8_DOM_DEFINE = __w_pdfjs_require__(40);
	var gOPD = Object.getOwnPropertyDescriptor;
	exports.f = __w_pdfjs_require__(12) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) {}
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};
	
	/***/ }),
	/* 106 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(107)('WeakMap');
	
	/***/ }),
	/* 107 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(4);
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, {
	    of: function of() {
	      var length = arguments.length;
	      var A = new Array(length);
	      while (length--) {
	        A[length] = arguments[length];
	      }return new this(A);
	    }
	  });
	};
	
	/***/ }),
	/* 108 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(109)('WeakMap');
	
	/***/ }),
	/* 109 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(4);
	var aFunction = __w_pdfjs_require__(16);
	var ctx = __w_pdfjs_require__(9);
	var forOf = __w_pdfjs_require__(23);
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, {
	    from: function from(source) {
	      var mapFn = arguments[1];
	      var mapping, A, n, cb;
	      aFunction(this);
	      mapping = mapFn !== undefined;
	      if (mapping) aFunction(mapFn);
	      if (source == undefined) return new this();
	      A = [];
	      if (mapping) {
	        n = 0;
	        cb = ctx(mapFn, arguments[2], 2);
	        forOf(source, false, function (nextItem) {
	          A.push(cb(nextItem, n++));
	        });
	      } else {
	        forOf(source, false, A.push, A);
	      }
	      return new this(A);
	    }
	  });
	};
	
	/***/ }),
	/* 110 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(111);
	module.exports = __w_pdfjs_require__(5).Object.values;
	
	/***/ }),
	/* 111 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(4);
	var $values = __w_pdfjs_require__(112)(false);
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});
	
	/***/ }),
	/* 112 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var getKeys = __w_pdfjs_require__(21);
	var toIObject = __w_pdfjs_require__(17);
	var isEnum = __w_pdfjs_require__(38).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      if (isEnum.call(O, key = keys[i++])) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }return result;
	  };
	};
	
	/***/ }),
	/* 113 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isReadableStreamSupported = false;
	if (typeof ReadableStream !== 'undefined') {
	  try {
	    new ReadableStream({
	      start: function start(controller) {
	        controller.close();
	      }
	    });
	    isReadableStreamSupported = true;
	  } catch (e) {}
	}
	if (isReadableStreamSupported) {
	  exports.ReadableStream = ReadableStream;
	} else {
	  exports.ReadableStream = __w_pdfjs_require__(114).ReadableStream;
	}
	
	/***/ }),
	/* 114 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function (e, a) {
	  for (var i in a) {
	    e[i] = a[i];
	  }
	})(exports, function (modules) {
	  var installedModules = {};
	  function __w_pdfjs_require__(moduleId) {
	    if (installedModules[moduleId]) return installedModules[moduleId].exports;
	    var module = installedModules[moduleId] = {
	      i: moduleId,
	      l: false,
	      exports: {}
	    };
	    modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
	    module.l = true;
	    return module.exports;
	  }
	  __w_pdfjs_require__.m = modules;
	  __w_pdfjs_require__.c = installedModules;
	  __w_pdfjs_require__.i = function (value) {
	    return value;
	  };
	  __w_pdfjs_require__.d = function (exports, name, getter) {
	    if (!__w_pdfjs_require__.o(exports, name)) {
	      Object.defineProperty(exports, name, {
	        configurable: false,
	        enumerable: true,
	        get: getter
	      });
	    }
	  };
	  __w_pdfjs_require__.n = function (module) {
	    var getter = module && module.__esModule ? function getDefault() {
	      return module['default'];
	    } : function getModuleExports() {
	      return module;
	    };
	    __w_pdfjs_require__.d(getter, 'a', getter);
	    return getter;
	  };
	  __w_pdfjs_require__.o = function (object, property) {
	    return Object.prototype.hasOwnProperty.call(object, property);
	  };
	  __w_pdfjs_require__.p = "";
	  return __w_pdfjs_require__(__w_pdfjs_require__.s = 7);
	}([function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	    return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	  } : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	  };
	  var _require = __w_pdfjs_require__(1),
	      assert = _require.assert;
	  function IsPropertyKey(argument) {
	    return typeof argument === 'string' || (typeof argument === 'undefined' ? 'undefined' : _typeof(argument)) === 'symbol';
	  }
	  exports.typeIsObject = function (x) {
	    return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x !== null || typeof x === 'function';
	  };
	  exports.createDataProperty = function (o, p, v) {
	    assert(exports.typeIsObject(o));
	    Object.defineProperty(o, p, {
	      value: v,
	      writable: true,
	      enumerable: true,
	      configurable: true
	    });
	  };
	  exports.createArrayFromList = function (elements) {
	    return elements.slice();
	  };
	  exports.ArrayBufferCopy = function (dest, destOffset, src, srcOffset, n) {
	    new Uint8Array(dest).set(new Uint8Array(src, srcOffset, n), destOffset);
	  };
	  exports.CreateIterResultObject = function (value, done) {
	    assert(typeof done === 'boolean');
	    var obj = {};
	    Object.defineProperty(obj, 'value', {
	      value: value,
	      enumerable: true,
	      writable: true,
	      configurable: true
	    });
	    Object.defineProperty(obj, 'done', {
	      value: done,
	      enumerable: true,
	      writable: true,
	      configurable: true
	    });
	    return obj;
	  };
	  exports.IsFiniteNonNegativeNumber = function (v) {
	    if (Number.isNaN(v)) {
	      return false;
	    }
	    if (v === Infinity) {
	      return false;
	    }
	    if (v < 0) {
	      return false;
	    }
	    return true;
	  };
	  function Call(F, V, args) {
	    if (typeof F !== 'function') {
	      throw new TypeError('Argument is not a function');
	    }
	    return Function.prototype.apply.call(F, V, args);
	  }
	  exports.InvokeOrNoop = function (O, P, args) {
	    assert(O !== undefined);
	    assert(IsPropertyKey(P));
	    assert(Array.isArray(args));
	    var method = O[P];
	    if (method === undefined) {
	      return undefined;
	    }
	    return Call(method, O, args);
	  };
	  exports.PromiseInvokeOrNoop = function (O, P, args) {
	    assert(O !== undefined);
	    assert(IsPropertyKey(P));
	    assert(Array.isArray(args));
	    try {
	      return Promise.resolve(exports.InvokeOrNoop(O, P, args));
	    } catch (returnValueE) {
	      return Promise.reject(returnValueE);
	    }
	  };
	  exports.PromiseInvokeOrPerformFallback = function (O, P, args, F, argsF) {
	    assert(O !== undefined);
	    assert(IsPropertyKey(P));
	    assert(Array.isArray(args));
	    assert(Array.isArray(argsF));
	    var method = void 0;
	    try {
	      method = O[P];
	    } catch (methodE) {
	      return Promise.reject(methodE);
	    }
	    if (method === undefined) {
	      return F.apply(null, argsF);
	    }
	    try {
	      return Promise.resolve(Call(method, O, args));
	    } catch (e) {
	      return Promise.reject(e);
	    }
	  };
	  exports.TransferArrayBuffer = function (O) {
	    return O.slice();
	  };
	  exports.ValidateAndNormalizeHighWaterMark = function (highWaterMark) {
	    highWaterMark = Number(highWaterMark);
	    if (Number.isNaN(highWaterMark) || highWaterMark < 0) {
	      throw new RangeError('highWaterMark property of a queuing strategy must be non-negative and non-NaN');
	    }
	    return highWaterMark;
	  };
	  exports.ValidateAndNormalizeQueuingStrategy = function (size, highWaterMark) {
	    if (size !== undefined && typeof size !== 'function') {
	      throw new TypeError('size property of a queuing strategy must be a function');
	    }
	    highWaterMark = exports.ValidateAndNormalizeHighWaterMark(highWaterMark);
	    return {
	      size: size,
	      highWaterMark: highWaterMark
	    };
	  };
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  function rethrowAssertionErrorRejection(e) {
	    if (e && e.constructor === AssertionError) {
	      setTimeout(function () {
	        throw e;
	      }, 0);
	    }
	  }
	  function AssertionError(message) {
	    this.name = 'AssertionError';
	    this.message = message || '';
	    this.stack = new Error().stack;
	  }
	  AssertionError.prototype = Object.create(Error.prototype);
	  AssertionError.prototype.constructor = AssertionError;
	  function assert(value, message) {
	    if (!value) {
	      throw new AssertionError(message);
	    }
	  }
	  module.exports = {
	    rethrowAssertionErrorRejection: rethrowAssertionErrorRejection,
	    AssertionError: AssertionError,
	    assert: assert
	  };
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	  var _require = __w_pdfjs_require__(0),
	      InvokeOrNoop = _require.InvokeOrNoop,
	      PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
	      ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
	      typeIsObject = _require.typeIsObject;
	  var _require2 = __w_pdfjs_require__(1),
	      assert = _require2.assert,
	      rethrowAssertionErrorRejection = _require2.rethrowAssertionErrorRejection;
	  var _require3 = __w_pdfjs_require__(3),
	      DequeueValue = _require3.DequeueValue,
	      EnqueueValueWithSize = _require3.EnqueueValueWithSize,
	      PeekQueueValue = _require3.PeekQueueValue,
	      ResetQueue = _require3.ResetQueue;
	  var WritableStream = function () {
	    function WritableStream() {
	      var underlyingSink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          size = _ref.size,
	          _ref$highWaterMark = _ref.highWaterMark,
	          highWaterMark = _ref$highWaterMark === undefined ? 1 : _ref$highWaterMark;
	      _classCallCheck(this, WritableStream);
	      this._state = 'writable';
	      this._storedError = undefined;
	      this._writer = undefined;
	      this._writableStreamController = undefined;
	      this._writeRequests = [];
	      this._inFlightWriteRequest = undefined;
	      this._closeRequest = undefined;
	      this._inFlightCloseRequest = undefined;
	      this._pendingAbortRequest = undefined;
	      this._backpressure = false;
	      var type = underlyingSink.type;
	      if (type !== undefined) {
	        throw new RangeError('Invalid type is specified');
	      }
	      this._writableStreamController = new WritableStreamDefaultController(this, underlyingSink, size, highWaterMark);
	      this._writableStreamController.__startSteps();
	    }
	    _createClass(WritableStream, [{
	      key: 'abort',
	      value: function abort(reason) {
	        if (IsWritableStream(this) === false) {
	          return Promise.reject(streamBrandCheckException('abort'));
	        }
	        if (IsWritableStreamLocked(this) === true) {
	          return Promise.reject(new TypeError('Cannot abort a stream that already has a writer'));
	        }
	        return WritableStreamAbort(this, reason);
	      }
	    }, {
	      key: 'getWriter',
	      value: function getWriter() {
	        if (IsWritableStream(this) === false) {
	          throw streamBrandCheckException('getWriter');
	        }
	        return AcquireWritableStreamDefaultWriter(this);
	      }
	    }, {
	      key: 'locked',
	      get: function get() {
	        if (IsWritableStream(this) === false) {
	          throw streamBrandCheckException('locked');
	        }
	        return IsWritableStreamLocked(this);
	      }
	    }]);
	    return WritableStream;
	  }();
	  module.exports = {
	    AcquireWritableStreamDefaultWriter: AcquireWritableStreamDefaultWriter,
	    IsWritableStream: IsWritableStream,
	    IsWritableStreamLocked: IsWritableStreamLocked,
	    WritableStream: WritableStream,
	    WritableStreamAbort: WritableStreamAbort,
	    WritableStreamDefaultControllerError: WritableStreamDefaultControllerError,
	    WritableStreamDefaultWriterCloseWithErrorPropagation: WritableStreamDefaultWriterCloseWithErrorPropagation,
	    WritableStreamDefaultWriterRelease: WritableStreamDefaultWriterRelease,
	    WritableStreamDefaultWriterWrite: WritableStreamDefaultWriterWrite,
	    WritableStreamCloseQueuedOrInFlight: WritableStreamCloseQueuedOrInFlight
	  };
	  function AcquireWritableStreamDefaultWriter(stream) {
	    return new WritableStreamDefaultWriter(stream);
	  }
	  function IsWritableStream(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_writableStreamController')) {
	      return false;
	    }
	    return true;
	  }
	  function IsWritableStreamLocked(stream) {
	    assert(IsWritableStream(stream) === true, 'IsWritableStreamLocked should only be used on known writable streams');
	    if (stream._writer === undefined) {
	      return false;
	    }
	    return true;
	  }
	  function WritableStreamAbort(stream, reason) {
	    var state = stream._state;
	    if (state === 'closed') {
	      return Promise.resolve(undefined);
	    }
	    if (state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    var error = new TypeError('Requested to abort');
	    if (stream._pendingAbortRequest !== undefined) {
	      return Promise.reject(error);
	    }
	    assert(state === 'writable' || state === 'erroring', 'state must be writable or erroring');
	    var wasAlreadyErroring = false;
	    if (state === 'erroring') {
	      wasAlreadyErroring = true;
	      reason = undefined;
	    }
	    var promise = new Promise(function (resolve, reject) {
	      stream._pendingAbortRequest = {
	        _resolve: resolve,
	        _reject: reject,
	        _reason: reason,
	        _wasAlreadyErroring: wasAlreadyErroring
	      };
	    });
	    if (wasAlreadyErroring === false) {
	      WritableStreamStartErroring(stream, error);
	    }
	    return promise;
	  }
	  function WritableStreamAddWriteRequest(stream) {
	    assert(IsWritableStreamLocked(stream) === true);
	    assert(stream._state === 'writable');
	    var promise = new Promise(function (resolve, reject) {
	      var writeRequest = {
	        _resolve: resolve,
	        _reject: reject
	      };
	      stream._writeRequests.push(writeRequest);
	    });
	    return promise;
	  }
	  function WritableStreamDealWithRejection(stream, error) {
	    var state = stream._state;
	    if (state === 'writable') {
	      WritableStreamStartErroring(stream, error);
	      return;
	    }
	    assert(state === 'erroring');
	    WritableStreamFinishErroring(stream);
	  }
	  function WritableStreamStartErroring(stream, reason) {
	    assert(stream._storedError === undefined, 'stream._storedError === undefined');
	    assert(stream._state === 'writable', 'state must be writable');
	    var controller = stream._writableStreamController;
	    assert(controller !== undefined, 'controller must not be undefined');
	    stream._state = 'erroring';
	    stream._storedError = reason;
	    var writer = stream._writer;
	    if (writer !== undefined) {
	      WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, reason);
	    }
	    if (WritableStreamHasOperationMarkedInFlight(stream) === false && controller._started === true) {
	      WritableStreamFinishErroring(stream);
	    }
	  }
	  function WritableStreamFinishErroring(stream) {
	    assert(stream._state === 'erroring', 'stream._state === erroring');
	    assert(WritableStreamHasOperationMarkedInFlight(stream) === false, 'WritableStreamHasOperationMarkedInFlight(stream) === false');
	    stream._state = 'errored';
	    stream._writableStreamController.__errorSteps();
	    var storedError = stream._storedError;
	    for (var i = 0; i < stream._writeRequests.length; i++) {
	      var writeRequest = stream._writeRequests[i];
	      writeRequest._reject(storedError);
	    }
	    stream._writeRequests = [];
	    if (stream._pendingAbortRequest === undefined) {
	      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
	      return;
	    }
	    var abortRequest = stream._pendingAbortRequest;
	    stream._pendingAbortRequest = undefined;
	    if (abortRequest._wasAlreadyErroring === true) {
	      abortRequest._reject(storedError);
	      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
	      return;
	    }
	    var promise = stream._writableStreamController.__abortSteps(abortRequest._reason);
	    promise.then(function () {
	      abortRequest._resolve();
	      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
	    }, function (reason) {
	      abortRequest._reject(reason);
	      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
	    });
	  }
	  function WritableStreamFinishInFlightWrite(stream) {
	    assert(stream._inFlightWriteRequest !== undefined);
	    stream._inFlightWriteRequest._resolve(undefined);
	    stream._inFlightWriteRequest = undefined;
	  }
	  function WritableStreamFinishInFlightWriteWithError(stream, error) {
	    assert(stream._inFlightWriteRequest !== undefined);
	    stream._inFlightWriteRequest._reject(error);
	    stream._inFlightWriteRequest = undefined;
	    assert(stream._state === 'writable' || stream._state === 'erroring');
	    WritableStreamDealWithRejection(stream, error);
	  }
	  function WritableStreamFinishInFlightClose(stream) {
	    assert(stream._inFlightCloseRequest !== undefined);
	    stream._inFlightCloseRequest._resolve(undefined);
	    stream._inFlightCloseRequest = undefined;
	    var state = stream._state;
	    assert(state === 'writable' || state === 'erroring');
	    if (state === 'erroring') {
	      stream._storedError = undefined;
	      if (stream._pendingAbortRequest !== undefined) {
	        stream._pendingAbortRequest._resolve();
	        stream._pendingAbortRequest = undefined;
	      }
	    }
	    stream._state = 'closed';
	    var writer = stream._writer;
	    if (writer !== undefined) {
	      defaultWriterClosedPromiseResolve(writer);
	    }
	    assert(stream._pendingAbortRequest === undefined, 'stream._pendingAbortRequest === undefined');
	    assert(stream._storedError === undefined, 'stream._storedError === undefined');
	  }
	  function WritableStreamFinishInFlightCloseWithError(stream, error) {
	    assert(stream._inFlightCloseRequest !== undefined);
	    stream._inFlightCloseRequest._reject(error);
	    stream._inFlightCloseRequest = undefined;
	    assert(stream._state === 'writable' || stream._state === 'erroring');
	    if (stream._pendingAbortRequest !== undefined) {
	      stream._pendingAbortRequest._reject(error);
	      stream._pendingAbortRequest = undefined;
	    }
	    WritableStreamDealWithRejection(stream, error);
	  }
	  function WritableStreamCloseQueuedOrInFlight(stream) {
	    if (stream._closeRequest === undefined && stream._inFlightCloseRequest === undefined) {
	      return false;
	    }
	    return true;
	  }
	  function WritableStreamHasOperationMarkedInFlight(stream) {
	    if (stream._inFlightWriteRequest === undefined && stream._inFlightCloseRequest === undefined) {
	      return false;
	    }
	    return true;
	  }
	  function WritableStreamMarkCloseRequestInFlight(stream) {
	    assert(stream._inFlightCloseRequest === undefined);
	    assert(stream._closeRequest !== undefined);
	    stream._inFlightCloseRequest = stream._closeRequest;
	    stream._closeRequest = undefined;
	  }
	  function WritableStreamMarkFirstWriteRequestInFlight(stream) {
	    assert(stream._inFlightWriteRequest === undefined, 'there must be no pending write request');
	    assert(stream._writeRequests.length !== 0, 'writeRequests must not be empty');
	    stream._inFlightWriteRequest = stream._writeRequests.shift();
	  }
	  function WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream) {
	    assert(stream._state === 'errored', '_stream_.[[state]] is `"errored"`');
	    if (stream._closeRequest !== undefined) {
	      assert(stream._inFlightCloseRequest === undefined);
	      stream._closeRequest._reject(stream._storedError);
	      stream._closeRequest = undefined;
	    }
	    var writer = stream._writer;
	    if (writer !== undefined) {
	      defaultWriterClosedPromiseReject(writer, stream._storedError);
	      writer._closedPromise.catch(function () {});
	    }
	  }
	  function WritableStreamUpdateBackpressure(stream, backpressure) {
	    assert(stream._state === 'writable');
	    assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
	    var writer = stream._writer;
	    if (writer !== undefined && backpressure !== stream._backpressure) {
	      if (backpressure === true) {
	        defaultWriterReadyPromiseReset(writer);
	      } else {
	        assert(backpressure === false);
	        defaultWriterReadyPromiseResolve(writer);
	      }
	    }
	    stream._backpressure = backpressure;
	  }
	  var WritableStreamDefaultWriter = function () {
	    function WritableStreamDefaultWriter(stream) {
	      _classCallCheck(this, WritableStreamDefaultWriter);
	      if (IsWritableStream(stream) === false) {
	        throw new TypeError('WritableStreamDefaultWriter can only be constructed with a WritableStream instance');
	      }
	      if (IsWritableStreamLocked(stream) === true) {
	        throw new TypeError('This stream has already been locked for exclusive writing by another writer');
	      }
	      this._ownerWritableStream = stream;
	      stream._writer = this;
	      var state = stream._state;
	      if (state === 'writable') {
	        if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._backpressure === true) {
	          defaultWriterReadyPromiseInitialize(this);
	        } else {
	          defaultWriterReadyPromiseInitializeAsResolved(this);
	        }
	        defaultWriterClosedPromiseInitialize(this);
	      } else if (state === 'erroring') {
	        defaultWriterReadyPromiseInitializeAsRejected(this, stream._storedError);
	        this._readyPromise.catch(function () {});
	        defaultWriterClosedPromiseInitialize(this);
	      } else if (state === 'closed') {
	        defaultWriterReadyPromiseInitializeAsResolved(this);
	        defaultWriterClosedPromiseInitializeAsResolved(this);
	      } else {
	        assert(state === 'errored', 'state must be errored');
	        var storedError = stream._storedError;
	        defaultWriterReadyPromiseInitializeAsRejected(this, storedError);
	        this._readyPromise.catch(function () {});
	        defaultWriterClosedPromiseInitializeAsRejected(this, storedError);
	        this._closedPromise.catch(function () {});
	      }
	    }
	    _createClass(WritableStreamDefaultWriter, [{
	      key: 'abort',
	      value: function abort(reason) {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          return Promise.reject(defaultWriterBrandCheckException('abort'));
	        }
	        if (this._ownerWritableStream === undefined) {
	          return Promise.reject(defaultWriterLockException('abort'));
	        }
	        return WritableStreamDefaultWriterAbort(this, reason);
	      }
	    }, {
	      key: 'close',
	      value: function close() {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          return Promise.reject(defaultWriterBrandCheckException('close'));
	        }
	        var stream = this._ownerWritableStream;
	        if (stream === undefined) {
	          return Promise.reject(defaultWriterLockException('close'));
	        }
	        if (WritableStreamCloseQueuedOrInFlight(stream) === true) {
	          return Promise.reject(new TypeError('cannot close an already-closing stream'));
	        }
	        return WritableStreamDefaultWriterClose(this);
	      }
	    }, {
	      key: 'releaseLock',
	      value: function releaseLock() {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          throw defaultWriterBrandCheckException('releaseLock');
	        }
	        var stream = this._ownerWritableStream;
	        if (stream === undefined) {
	          return;
	        }
	        assert(stream._writer !== undefined);
	        WritableStreamDefaultWriterRelease(this);
	      }
	    }, {
	      key: 'write',
	      value: function write(chunk) {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          return Promise.reject(defaultWriterBrandCheckException('write'));
	        }
	        if (this._ownerWritableStream === undefined) {
	          return Promise.reject(defaultWriterLockException('write to'));
	        }
	        return WritableStreamDefaultWriterWrite(this, chunk);
	      }
	    }, {
	      key: 'closed',
	      get: function get() {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          return Promise.reject(defaultWriterBrandCheckException('closed'));
	        }
	        return this._closedPromise;
	      }
	    }, {
	      key: 'desiredSize',
	      get: function get() {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          throw defaultWriterBrandCheckException('desiredSize');
	        }
	        if (this._ownerWritableStream === undefined) {
	          throw defaultWriterLockException('desiredSize');
	        }
	        return WritableStreamDefaultWriterGetDesiredSize(this);
	      }
	    }, {
	      key: 'ready',
	      get: function get() {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          return Promise.reject(defaultWriterBrandCheckException('ready'));
	        }
	        return this._readyPromise;
	      }
	    }]);
	    return WritableStreamDefaultWriter;
	  }();
	  function IsWritableStreamDefaultWriter(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_ownerWritableStream')) {
	      return false;
	    }
	    return true;
	  }
	  function WritableStreamDefaultWriterAbort(writer, reason) {
	    var stream = writer._ownerWritableStream;
	    assert(stream !== undefined);
	    return WritableStreamAbort(stream, reason);
	  }
	  function WritableStreamDefaultWriterClose(writer) {
	    var stream = writer._ownerWritableStream;
	    assert(stream !== undefined);
	    var state = stream._state;
	    if (state === 'closed' || state === 'errored') {
	      return Promise.reject(new TypeError('The stream (in ' + state + ' state) is not in the writable state and cannot be closed'));
	    }
	    assert(state === 'writable' || state === 'erroring');
	    assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
	    var promise = new Promise(function (resolve, reject) {
	      var closeRequest = {
	        _resolve: resolve,
	        _reject: reject
	      };
	      stream._closeRequest = closeRequest;
	    });
	    if (stream._backpressure === true && state === 'writable') {
	      defaultWriterReadyPromiseResolve(writer);
	    }
	    WritableStreamDefaultControllerClose(stream._writableStreamController);
	    return promise;
	  }
	  function WritableStreamDefaultWriterCloseWithErrorPropagation(writer) {
	    var stream = writer._ownerWritableStream;
	    assert(stream !== undefined);
	    var state = stream._state;
	    if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
	      return Promise.resolve();
	    }
	    if (state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    assert(state === 'writable' || state === 'erroring');
	    return WritableStreamDefaultWriterClose(writer);
	  }
	  function WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, error) {
	    if (writer._closedPromiseState === 'pending') {
	      defaultWriterClosedPromiseReject(writer, error);
	    } else {
	      defaultWriterClosedPromiseResetToRejected(writer, error);
	    }
	    writer._closedPromise.catch(function () {});
	  }
	  function WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, error) {
	    if (writer._readyPromiseState === 'pending') {
	      defaultWriterReadyPromiseReject(writer, error);
	    } else {
	      defaultWriterReadyPromiseResetToRejected(writer, error);
	    }
	    writer._readyPromise.catch(function () {});
	  }
	  function WritableStreamDefaultWriterGetDesiredSize(writer) {
	    var stream = writer._ownerWritableStream;
	    var state = stream._state;
	    if (state === 'errored' || state === 'erroring') {
	      return null;
	    }
	    if (state === 'closed') {
	      return 0;
	    }
	    return WritableStreamDefaultControllerGetDesiredSize(stream._writableStreamController);
	  }
	  function WritableStreamDefaultWriterRelease(writer) {
	    var stream = writer._ownerWritableStream;
	    assert(stream !== undefined);
	    assert(stream._writer === writer);
	    var releasedError = new TypeError('Writer was released and can no longer be used to monitor the stream\'s closedness');
	    WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, releasedError);
	    WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, releasedError);
	    stream._writer = undefined;
	    writer._ownerWritableStream = undefined;
	  }
	  function WritableStreamDefaultWriterWrite(writer, chunk) {
	    var stream = writer._ownerWritableStream;
	    assert(stream !== undefined);
	    var controller = stream._writableStreamController;
	    var chunkSize = WritableStreamDefaultControllerGetChunkSize(controller, chunk);
	    if (stream !== writer._ownerWritableStream) {
	      return Promise.reject(defaultWriterLockException('write to'));
	    }
	    var state = stream._state;
	    if (state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
	      return Promise.reject(new TypeError('The stream is closing or closed and cannot be written to'));
	    }
	    if (state === 'erroring') {
	      return Promise.reject(stream._storedError);
	    }
	    assert(state === 'writable');
	    var promise = WritableStreamAddWriteRequest(stream);
	    WritableStreamDefaultControllerWrite(controller, chunk, chunkSize);
	    return promise;
	  }
	  var WritableStreamDefaultController = function () {
	    function WritableStreamDefaultController(stream, underlyingSink, size, highWaterMark) {
	      _classCallCheck(this, WritableStreamDefaultController);
	      if (IsWritableStream(stream) === false) {
	        throw new TypeError('WritableStreamDefaultController can only be constructed with a WritableStream instance');
	      }
	      if (stream._writableStreamController !== undefined) {
	        throw new TypeError('WritableStreamDefaultController instances can only be created by the WritableStream constructor');
	      }
	      this._controlledWritableStream = stream;
	      this._underlyingSink = underlyingSink;
	      this._queue = undefined;
	      this._queueTotalSize = undefined;
	      ResetQueue(this);
	      this._started = false;
	      var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
	      this._strategySize = normalizedStrategy.size;
	      this._strategyHWM = normalizedStrategy.highWaterMark;
	      var backpressure = WritableStreamDefaultControllerGetBackpressure(this);
	      WritableStreamUpdateBackpressure(stream, backpressure);
	    }
	    _createClass(WritableStreamDefaultController, [{
	      key: 'error',
	      value: function error(e) {
	        if (IsWritableStreamDefaultController(this) === false) {
	          throw new TypeError('WritableStreamDefaultController.prototype.error can only be used on a WritableStreamDefaultController');
	        }
	        var state = this._controlledWritableStream._state;
	        if (state !== 'writable') {
	          return;
	        }
	        WritableStreamDefaultControllerError(this, e);
	      }
	    }, {
	      key: '__abortSteps',
	      value: function __abortSteps(reason) {
	        return PromiseInvokeOrNoop(this._underlyingSink, 'abort', [reason]);
	      }
	    }, {
	      key: '__errorSteps',
	      value: function __errorSteps() {
	        ResetQueue(this);
	      }
	    }, {
	      key: '__startSteps',
	      value: function __startSteps() {
	        var _this = this;
	        var startResult = InvokeOrNoop(this._underlyingSink, 'start', [this]);
	        var stream = this._controlledWritableStream;
	        Promise.resolve(startResult).then(function () {
	          assert(stream._state === 'writable' || stream._state === 'erroring');
	          _this._started = true;
	          WritableStreamDefaultControllerAdvanceQueueIfNeeded(_this);
	        }, function (r) {
	          assert(stream._state === 'writable' || stream._state === 'erroring');
	          _this._started = true;
	          WritableStreamDealWithRejection(stream, r);
	        }).catch(rethrowAssertionErrorRejection);
	      }
	    }]);
	    return WritableStreamDefaultController;
	  }();
	  function WritableStreamDefaultControllerClose(controller) {
	    EnqueueValueWithSize(controller, 'close', 0);
	    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
	  }
	  function WritableStreamDefaultControllerGetChunkSize(controller, chunk) {
	    var strategySize = controller._strategySize;
	    if (strategySize === undefined) {
	      return 1;
	    }
	    try {
	      return strategySize(chunk);
	    } catch (chunkSizeE) {
	      WritableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
	      return 1;
	    }
	  }
	  function WritableStreamDefaultControllerGetDesiredSize(controller) {
	    return controller._strategyHWM - controller._queueTotalSize;
	  }
	  function WritableStreamDefaultControllerWrite(controller, chunk, chunkSize) {
	    var writeRecord = { chunk: chunk };
	    try {
	      EnqueueValueWithSize(controller, writeRecord, chunkSize);
	    } catch (enqueueE) {
	      WritableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
	      return;
	    }
	    var stream = controller._controlledWritableStream;
	    if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._state === 'writable') {
	      var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
	      WritableStreamUpdateBackpressure(stream, backpressure);
	    }
	    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
	  }
	  function IsWritableStreamDefaultController(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSink')) {
	      return false;
	    }
	    return true;
	  }
	  function WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller) {
	    var stream = controller._controlledWritableStream;
	    if (controller._started === false) {
	      return;
	    }
	    if (stream._inFlightWriteRequest !== undefined) {
	      return;
	    }
	    var state = stream._state;
	    if (state === 'closed' || state === 'errored') {
	      return;
	    }
	    if (state === 'erroring') {
	      WritableStreamFinishErroring(stream);
	      return;
	    }
	    if (controller._queue.length === 0) {
	      return;
	    }
	    var writeRecord = PeekQueueValue(controller);
	    if (writeRecord === 'close') {
	      WritableStreamDefaultControllerProcessClose(controller);
	    } else {
	      WritableStreamDefaultControllerProcessWrite(controller, writeRecord.chunk);
	    }
	  }
	  function WritableStreamDefaultControllerErrorIfNeeded(controller, error) {
	    if (controller._controlledWritableStream._state === 'writable') {
	      WritableStreamDefaultControllerError(controller, error);
	    }
	  }
	  function WritableStreamDefaultControllerProcessClose(controller) {
	    var stream = controller._controlledWritableStream;
	    WritableStreamMarkCloseRequestInFlight(stream);
	    DequeueValue(controller);
	    assert(controller._queue.length === 0, 'queue must be empty once the final write record is dequeued');
	    var sinkClosePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'close', []);
	    sinkClosePromise.then(function () {
	      WritableStreamFinishInFlightClose(stream);
	    }, function (reason) {
	      WritableStreamFinishInFlightCloseWithError(stream, reason);
	    }).catch(rethrowAssertionErrorRejection);
	  }
	  function WritableStreamDefaultControllerProcessWrite(controller, chunk) {
	    var stream = controller._controlledWritableStream;
	    WritableStreamMarkFirstWriteRequestInFlight(stream);
	    var sinkWritePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'write', [chunk, controller]);
	    sinkWritePromise.then(function () {
	      WritableStreamFinishInFlightWrite(stream);
	      var state = stream._state;
	      assert(state === 'writable' || state === 'erroring');
	      DequeueValue(controller);
	      if (WritableStreamCloseQueuedOrInFlight(stream) === false && state === 'writable') {
	        var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
	        WritableStreamUpdateBackpressure(stream, backpressure);
	      }
	      WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
	    }, function (reason) {
	      WritableStreamFinishInFlightWriteWithError(stream, reason);
	    }).catch(rethrowAssertionErrorRejection);
	  }
	  function WritableStreamDefaultControllerGetBackpressure(controller) {
	    var desiredSize = WritableStreamDefaultControllerGetDesiredSize(controller);
	    return desiredSize <= 0;
	  }
	  function WritableStreamDefaultControllerError(controller, error) {
	    var stream = controller._controlledWritableStream;
	    assert(stream._state === 'writable');
	    WritableStreamStartErroring(stream, error);
	  }
	  function streamBrandCheckException(name) {
	    return new TypeError('WritableStream.prototype.' + name + ' can only be used on a WritableStream');
	  }
	  function defaultWriterBrandCheckException(name) {
	    return new TypeError('WritableStreamDefaultWriter.prototype.' + name + ' can only be used on a WritableStreamDefaultWriter');
	  }
	  function defaultWriterLockException(name) {
	    return new TypeError('Cannot ' + name + ' a stream using a released writer');
	  }
	  function defaultWriterClosedPromiseInitialize(writer) {
	    writer._closedPromise = new Promise(function (resolve, reject) {
	      writer._closedPromise_resolve = resolve;
	      writer._closedPromise_reject = reject;
	      writer._closedPromiseState = 'pending';
	    });
	  }
	  function defaultWriterClosedPromiseInitializeAsRejected(writer, reason) {
	    writer._closedPromise = Promise.reject(reason);
	    writer._closedPromise_resolve = undefined;
	    writer._closedPromise_reject = undefined;
	    writer._closedPromiseState = 'rejected';
	  }
	  function defaultWriterClosedPromiseInitializeAsResolved(writer) {
	    writer._closedPromise = Promise.resolve(undefined);
	    writer._closedPromise_resolve = undefined;
	    writer._closedPromise_reject = undefined;
	    writer._closedPromiseState = 'resolved';
	  }
	  function defaultWriterClosedPromiseReject(writer, reason) {
	    assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
	    assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
	    assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');
	    writer._closedPromise_reject(reason);
	    writer._closedPromise_resolve = undefined;
	    writer._closedPromise_reject = undefined;
	    writer._closedPromiseState = 'rejected';
	  }
	  function defaultWriterClosedPromiseResetToRejected(writer, reason) {
	    assert(writer._closedPromise_resolve === undefined, 'writer._closedPromise_resolve === undefined');
	    assert(writer._closedPromise_reject === undefined, 'writer._closedPromise_reject === undefined');
	    assert(writer._closedPromiseState !== 'pending', 'writer._closedPromiseState is not pending');
	    writer._closedPromise = Promise.reject(reason);
	    writer._closedPromiseState = 'rejected';
	  }
	  function defaultWriterClosedPromiseResolve(writer) {
	    assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
	    assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
	    assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');
	    writer._closedPromise_resolve(undefined);
	    writer._closedPromise_resolve = undefined;
	    writer._closedPromise_reject = undefined;
	    writer._closedPromiseState = 'resolved';
	  }
	  function defaultWriterReadyPromiseInitialize(writer) {
	    writer._readyPromise = new Promise(function (resolve, reject) {
	      writer._readyPromise_resolve = resolve;
	      writer._readyPromise_reject = reject;
	    });
	    writer._readyPromiseState = 'pending';
	  }
	  function defaultWriterReadyPromiseInitializeAsRejected(writer, reason) {
	    writer._readyPromise = Promise.reject(reason);
	    writer._readyPromise_resolve = undefined;
	    writer._readyPromise_reject = undefined;
	    writer._readyPromiseState = 'rejected';
	  }
	  function defaultWriterReadyPromiseInitializeAsResolved(writer) {
	    writer._readyPromise = Promise.resolve(undefined);
	    writer._readyPromise_resolve = undefined;
	    writer._readyPromise_reject = undefined;
	    writer._readyPromiseState = 'fulfilled';
	  }
	  function defaultWriterReadyPromiseReject(writer, reason) {
	    assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
	    assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');
	    writer._readyPromise_reject(reason);
	    writer._readyPromise_resolve = undefined;
	    writer._readyPromise_reject = undefined;
	    writer._readyPromiseState = 'rejected';
	  }
	  function defaultWriterReadyPromiseReset(writer) {
	    assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
	    assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
	    writer._readyPromise = new Promise(function (resolve, reject) {
	      writer._readyPromise_resolve = resolve;
	      writer._readyPromise_reject = reject;
	    });
	    writer._readyPromiseState = 'pending';
	  }
	  function defaultWriterReadyPromiseResetToRejected(writer, reason) {
	    assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
	    assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
	    writer._readyPromise = Promise.reject(reason);
	    writer._readyPromiseState = 'rejected';
	  }
	  function defaultWriterReadyPromiseResolve(writer) {
	    assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
	    assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');
	    writer._readyPromise_resolve(undefined);
	    writer._readyPromise_resolve = undefined;
	    writer._readyPromise_reject = undefined;
	    writer._readyPromiseState = 'fulfilled';
	  }
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var _require = __w_pdfjs_require__(0),
	      IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber;
	  var _require2 = __w_pdfjs_require__(1),
	      assert = _require2.assert;
	  exports.DequeueValue = function (container) {
	    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: DequeueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
	    assert(container._queue.length > 0, 'Spec-level failure: should never dequeue from an empty queue.');
	    var pair = container._queue.shift();
	    container._queueTotalSize -= pair.size;
	    if (container._queueTotalSize < 0) {
	      container._queueTotalSize = 0;
	    }
	    return pair.value;
	  };
	  exports.EnqueueValueWithSize = function (container, value, size) {
	    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: EnqueueValueWithSize should only be used on containers with [[queue]] and ' + '[[queueTotalSize]].');
	    size = Number(size);
	    if (!IsFiniteNonNegativeNumber(size)) {
	      throw new RangeError('Size must be a finite, non-NaN, non-negative number.');
	    }
	    container._queue.push({
	      value: value,
	      size: size
	    });
	    container._queueTotalSize += size;
	  };
	  exports.PeekQueueValue = function (container) {
	    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: PeekQueueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
	    assert(container._queue.length > 0, 'Spec-level failure: should never peek at an empty queue.');
	    var pair = container._queue[0];
	    return pair.value;
	  };
	  exports.ResetQueue = function (container) {
	    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: ResetQueue should only be used on containers with [[queue]] and [[queueTotalSize]].');
	    container._queue = [];
	    container._queueTotalSize = 0;
	  };
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	  var _require = __w_pdfjs_require__(0),
	      ArrayBufferCopy = _require.ArrayBufferCopy,
	      CreateIterResultObject = _require.CreateIterResultObject,
	      IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber,
	      InvokeOrNoop = _require.InvokeOrNoop,
	      PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
	      TransferArrayBuffer = _require.TransferArrayBuffer,
	      ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
	      ValidateAndNormalizeHighWaterMark = _require.ValidateAndNormalizeHighWaterMark;
	  var _require2 = __w_pdfjs_require__(0),
	      createArrayFromList = _require2.createArrayFromList,
	      createDataProperty = _require2.createDataProperty,
	      typeIsObject = _require2.typeIsObject;
	  var _require3 = __w_pdfjs_require__(1),
	      assert = _require3.assert,
	      rethrowAssertionErrorRejection = _require3.rethrowAssertionErrorRejection;
	  var _require4 = __w_pdfjs_require__(3),
	      DequeueValue = _require4.DequeueValue,
	      EnqueueValueWithSize = _require4.EnqueueValueWithSize,
	      ResetQueue = _require4.ResetQueue;
	  var _require5 = __w_pdfjs_require__(2),
	      AcquireWritableStreamDefaultWriter = _require5.AcquireWritableStreamDefaultWriter,
	      IsWritableStream = _require5.IsWritableStream,
	      IsWritableStreamLocked = _require5.IsWritableStreamLocked,
	      WritableStreamAbort = _require5.WritableStreamAbort,
	      WritableStreamDefaultWriterCloseWithErrorPropagation = _require5.WritableStreamDefaultWriterCloseWithErrorPropagation,
	      WritableStreamDefaultWriterRelease = _require5.WritableStreamDefaultWriterRelease,
	      WritableStreamDefaultWriterWrite = _require5.WritableStreamDefaultWriterWrite,
	      WritableStreamCloseQueuedOrInFlight = _require5.WritableStreamCloseQueuedOrInFlight;
	  var ReadableStream = function () {
	    function ReadableStream() {
	      var underlyingSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          size = _ref.size,
	          highWaterMark = _ref.highWaterMark;
	      _classCallCheck(this, ReadableStream);
	      this._state = 'readable';
	      this._reader = undefined;
	      this._storedError = undefined;
	      this._disturbed = false;
	      this._readableStreamController = undefined;
	      var type = underlyingSource.type;
	      var typeString = String(type);
	      if (typeString === 'bytes') {
	        if (highWaterMark === undefined) {
	          highWaterMark = 0;
	        }
	        this._readableStreamController = new ReadableByteStreamController(this, underlyingSource, highWaterMark);
	      } else if (type === undefined) {
	        if (highWaterMark === undefined) {
	          highWaterMark = 1;
	        }
	        this._readableStreamController = new ReadableStreamDefaultController(this, underlyingSource, size, highWaterMark);
	      } else {
	        throw new RangeError('Invalid type is specified');
	      }
	    }
	    _createClass(ReadableStream, [{
	      key: 'cancel',
	      value: function cancel(reason) {
	        if (IsReadableStream(this) === false) {
	          return Promise.reject(streamBrandCheckException('cancel'));
	        }
	        if (IsReadableStreamLocked(this) === true) {
	          return Promise.reject(new TypeError('Cannot cancel a stream that already has a reader'));
	        }
	        return ReadableStreamCancel(this, reason);
	      }
	    }, {
	      key: 'getReader',
	      value: function getReader() {
	        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	            mode = _ref2.mode;
	        if (IsReadableStream(this) === false) {
	          throw streamBrandCheckException('getReader');
	        }
	        if (mode === undefined) {
	          return AcquireReadableStreamDefaultReader(this);
	        }
	        mode = String(mode);
	        if (mode === 'byob') {
	          return AcquireReadableStreamBYOBReader(this);
	        }
	        throw new RangeError('Invalid mode is specified');
	      }
	    }, {
	      key: 'pipeThrough',
	      value: function pipeThrough(_ref3, options) {
	        var writable = _ref3.writable,
	            readable = _ref3.readable;
	        var promise = this.pipeTo(writable, options);
	        ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise);
	        return readable;
	      }
	    }, {
	      key: 'pipeTo',
	      value: function pipeTo(dest) {
	        var _this = this;
	        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	            preventClose = _ref4.preventClose,
	            preventAbort = _ref4.preventAbort,
	            preventCancel = _ref4.preventCancel;
	        if (IsReadableStream(this) === false) {
	          return Promise.reject(streamBrandCheckException('pipeTo'));
	        }
	        if (IsWritableStream(dest) === false) {
	          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo\'s first argument must be a WritableStream'));
	        }
	        preventClose = Boolean(preventClose);
	        preventAbort = Boolean(preventAbort);
	        preventCancel = Boolean(preventCancel);
	        if (IsReadableStreamLocked(this) === true) {
	          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream'));
	        }
	        if (IsWritableStreamLocked(dest) === true) {
	          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream'));
	        }
	        var reader = AcquireReadableStreamDefaultReader(this);
	        var writer = AcquireWritableStreamDefaultWriter(dest);
	        var shuttingDown = false;
	        var currentWrite = Promise.resolve();
	        return new Promise(function (resolve, reject) {
	          function pipeLoop() {
	            currentWrite = Promise.resolve();
	            if (shuttingDown === true) {
	              return Promise.resolve();
	            }
	            return writer._readyPromise.then(function () {
	              return ReadableStreamDefaultReaderRead(reader).then(function (_ref5) {
	                var value = _ref5.value,
	                    done = _ref5.done;
	                if (done === true) {
	                  return;
	                }
	                currentWrite = WritableStreamDefaultWriterWrite(writer, value).catch(function () {});
	              });
	            }).then(pipeLoop);
	          }
	          isOrBecomesErrored(_this, reader._closedPromise, function (storedError) {
	            if (preventAbort === false) {
	              shutdownWithAction(function () {
	                return WritableStreamAbort(dest, storedError);
	              }, true, storedError);
	            } else {
	              shutdown(true, storedError);
	            }
	          });
	          isOrBecomesErrored(dest, writer._closedPromise, function (storedError) {
	            if (preventCancel === false) {
	              shutdownWithAction(function () {
	                return ReadableStreamCancel(_this, storedError);
	              }, true, storedError);
	            } else {
	              shutdown(true, storedError);
	            }
	          });
	          isOrBecomesClosed(_this, reader._closedPromise, function () {
	            if (preventClose === false) {
	              shutdownWithAction(function () {
	                return WritableStreamDefaultWriterCloseWithErrorPropagation(writer);
	              });
	            } else {
	              shutdown();
	            }
	          });
	          if (WritableStreamCloseQueuedOrInFlight(dest) === true || dest._state === 'closed') {
	            var destClosed = new TypeError('the destination writable stream closed before all data could be piped to it');
	            if (preventCancel === false) {
	              shutdownWithAction(function () {
	                return ReadableStreamCancel(_this, destClosed);
	              }, true, destClosed);
	            } else {
	              shutdown(true, destClosed);
	            }
	          }
	          pipeLoop().catch(function (err) {
	            currentWrite = Promise.resolve();
	            rethrowAssertionErrorRejection(err);
	          });
	          function waitForWritesToFinish() {
	            var oldCurrentWrite = currentWrite;
	            return currentWrite.then(function () {
	              return oldCurrentWrite !== currentWrite ? waitForWritesToFinish() : undefined;
	            });
	          }
	          function isOrBecomesErrored(stream, promise, action) {
	            if (stream._state === 'errored') {
	              action(stream._storedError);
	            } else {
	              promise.catch(action).catch(rethrowAssertionErrorRejection);
	            }
	          }
	          function isOrBecomesClosed(stream, promise, action) {
	            if (stream._state === 'closed') {
	              action();
	            } else {
	              promise.then(action).catch(rethrowAssertionErrorRejection);
	            }
	          }
	          function shutdownWithAction(action, originalIsError, originalError) {
	            if (shuttingDown === true) {
	              return;
	            }
	            shuttingDown = true;
	            if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
	              waitForWritesToFinish().then(doTheRest);
	            } else {
	              doTheRest();
	            }
	            function doTheRest() {
	              action().then(function () {
	                return finalize(originalIsError, originalError);
	              }, function (newError) {
	                return finalize(true, newError);
	              }).catch(rethrowAssertionErrorRejection);
	            }
	          }
	          function shutdown(isError, error) {
	            if (shuttingDown === true) {
	              return;
	            }
	            shuttingDown = true;
	            if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
	              waitForWritesToFinish().then(function () {
	                return finalize(isError, error);
	              }).catch(rethrowAssertionErrorRejection);
	            } else {
	              finalize(isError, error);
	            }
	          }
	          function finalize(isError, error) {
	            WritableStreamDefaultWriterRelease(writer);
	            ReadableStreamReaderGenericRelease(reader);
	            if (isError) {
	              reject(error);
	            } else {
	              resolve(undefined);
	            }
	          }
	        });
	      }
	    }, {
	      key: 'tee',
	      value: function tee() {
	        if (IsReadableStream(this) === false) {
	          throw streamBrandCheckException('tee');
	        }
	        var branches = ReadableStreamTee(this, false);
	        return createArrayFromList(branches);
	      }
	    }, {
	      key: 'locked',
	      get: function get() {
	        if (IsReadableStream(this) === false) {
	          throw streamBrandCheckException('locked');
	        }
	        return IsReadableStreamLocked(this);
	      }
	    }]);
	    return ReadableStream;
	  }();
	  module.exports = {
	    ReadableStream: ReadableStream,
	    IsReadableStreamDisturbed: IsReadableStreamDisturbed,
	    ReadableStreamDefaultControllerClose: ReadableStreamDefaultControllerClose,
	    ReadableStreamDefaultControllerEnqueue: ReadableStreamDefaultControllerEnqueue,
	    ReadableStreamDefaultControllerError: ReadableStreamDefaultControllerError,
	    ReadableStreamDefaultControllerGetDesiredSize: ReadableStreamDefaultControllerGetDesiredSize
	  };
	  function AcquireReadableStreamBYOBReader(stream) {
	    return new ReadableStreamBYOBReader(stream);
	  }
	  function AcquireReadableStreamDefaultReader(stream) {
	    return new ReadableStreamDefaultReader(stream);
	  }
	  function IsReadableStream(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_readableStreamController')) {
	      return false;
	    }
	    return true;
	  }
	  function IsReadableStreamDisturbed(stream) {
	    assert(IsReadableStream(stream) === true, 'IsReadableStreamDisturbed should only be used on known readable streams');
	    return stream._disturbed;
	  }
	  function IsReadableStreamLocked(stream) {
	    assert(IsReadableStream(stream) === true, 'IsReadableStreamLocked should only be used on known readable streams');
	    if (stream._reader === undefined) {
	      return false;
	    }
	    return true;
	  }
	  function ReadableStreamTee(stream, cloneForBranch2) {
	    assert(IsReadableStream(stream) === true);
	    assert(typeof cloneForBranch2 === 'boolean');
	    var reader = AcquireReadableStreamDefaultReader(stream);
	    var teeState = {
	      closedOrErrored: false,
	      canceled1: false,
	      canceled2: false,
	      reason1: undefined,
	      reason2: undefined
	    };
	    teeState.promise = new Promise(function (resolve) {
	      teeState._resolve = resolve;
	    });
	    var pull = create_ReadableStreamTeePullFunction();
	    pull._reader = reader;
	    pull._teeState = teeState;
	    pull._cloneForBranch2 = cloneForBranch2;
	    var cancel1 = create_ReadableStreamTeeBranch1CancelFunction();
	    cancel1._stream = stream;
	    cancel1._teeState = teeState;
	    var cancel2 = create_ReadableStreamTeeBranch2CancelFunction();
	    cancel2._stream = stream;
	    cancel2._teeState = teeState;
	    var underlyingSource1 = Object.create(Object.prototype);
	    createDataProperty(underlyingSource1, 'pull', pull);
	    createDataProperty(underlyingSource1, 'cancel', cancel1);
	    var branch1Stream = new ReadableStream(underlyingSource1);
	    var underlyingSource2 = Object.create(Object.prototype);
	    createDataProperty(underlyingSource2, 'pull', pull);
	    createDataProperty(underlyingSource2, 'cancel', cancel2);
	    var branch2Stream = new ReadableStream(underlyingSource2);
	    pull._branch1 = branch1Stream._readableStreamController;
	    pull._branch2 = branch2Stream._readableStreamController;
	    reader._closedPromise.catch(function (r) {
	      if (teeState.closedOrErrored === true) {
	        return;
	      }
	      ReadableStreamDefaultControllerError(pull._branch1, r);
	      ReadableStreamDefaultControllerError(pull._branch2, r);
	      teeState.closedOrErrored = true;
	    });
	    return [branch1Stream, branch2Stream];
	  }
	  function create_ReadableStreamTeePullFunction() {
	    function f() {
	      var reader = f._reader,
	          branch1 = f._branch1,
	          branch2 = f._branch2,
	          teeState = f._teeState;
	      return ReadableStreamDefaultReaderRead(reader).then(function (result) {
	        assert(typeIsObject(result));
	        var value = result.value;
	        var done = result.done;
	        assert(typeof done === 'boolean');
	        if (done === true && teeState.closedOrErrored === false) {
	          if (teeState.canceled1 === false) {
	            ReadableStreamDefaultControllerClose(branch1);
	          }
	          if (teeState.canceled2 === false) {
	            ReadableStreamDefaultControllerClose(branch2);
	          }
	          teeState.closedOrErrored = true;
	        }
	        if (teeState.closedOrErrored === true) {
	          return;
	        }
	        var value1 = value;
	        var value2 = value;
	        if (teeState.canceled1 === false) {
	          ReadableStreamDefaultControllerEnqueue(branch1, value1);
	        }
	        if (teeState.canceled2 === false) {
	          ReadableStreamDefaultControllerEnqueue(branch2, value2);
	        }
	      });
	    }
	    return f;
	  }
	  function create_ReadableStreamTeeBranch1CancelFunction() {
	    function f(reason) {
	      var stream = f._stream,
	          teeState = f._teeState;
	      teeState.canceled1 = true;
	      teeState.reason1 = reason;
	      if (teeState.canceled2 === true) {
	        var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
	        var cancelResult = ReadableStreamCancel(stream, compositeReason);
	        teeState._resolve(cancelResult);
	      }
	      return teeState.promise;
	    }
	    return f;
	  }
	  function create_ReadableStreamTeeBranch2CancelFunction() {
	    function f(reason) {
	      var stream = f._stream,
	          teeState = f._teeState;
	      teeState.canceled2 = true;
	      teeState.reason2 = reason;
	      if (teeState.canceled1 === true) {
	        var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
	        var cancelResult = ReadableStreamCancel(stream, compositeReason);
	        teeState._resolve(cancelResult);
	      }
	      return teeState.promise;
	    }
	    return f;
	  }
	  function ReadableStreamAddReadIntoRequest(stream) {
	    assert(IsReadableStreamBYOBReader(stream._reader) === true);
	    assert(stream._state === 'readable' || stream._state === 'closed');
	    var promise = new Promise(function (resolve, reject) {
	      var readIntoRequest = {
	        _resolve: resolve,
	        _reject: reject
	      };
	      stream._reader._readIntoRequests.push(readIntoRequest);
	    });
	    return promise;
	  }
	  function ReadableStreamAddReadRequest(stream) {
	    assert(IsReadableStreamDefaultReader(stream._reader) === true);
	    assert(stream._state === 'readable');
	    var promise = new Promise(function (resolve, reject) {
	      var readRequest = {
	        _resolve: resolve,
	        _reject: reject
	      };
	      stream._reader._readRequests.push(readRequest);
	    });
	    return promise;
	  }
	  function ReadableStreamCancel(stream, reason) {
	    stream._disturbed = true;
	    if (stream._state === 'closed') {
	      return Promise.resolve(undefined);
	    }
	    if (stream._state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    ReadableStreamClose(stream);
	    var sourceCancelPromise = stream._readableStreamController.__cancelSteps(reason);
	    return sourceCancelPromise.then(function () {
	      return undefined;
	    });
	  }
	  function ReadableStreamClose(stream) {
	    assert(stream._state === 'readable');
	    stream._state = 'closed';
	    var reader = stream._reader;
	    if (reader === undefined) {
	      return undefined;
	    }
	    if (IsReadableStreamDefaultReader(reader) === true) {
	      for (var i = 0; i < reader._readRequests.length; i++) {
	        var _resolve = reader._readRequests[i]._resolve;
	        _resolve(CreateIterResultObject(undefined, true));
	      }
	      reader._readRequests = [];
	    }
	    defaultReaderClosedPromiseResolve(reader);
	    return undefined;
	  }
	  function ReadableStreamError(stream, e) {
	    assert(IsReadableStream(stream) === true, 'stream must be ReadableStream');
	    assert(stream._state === 'readable', 'state must be readable');
	    stream._state = 'errored';
	    stream._storedError = e;
	    var reader = stream._reader;
	    if (reader === undefined) {
	      return undefined;
	    }
	    if (IsReadableStreamDefaultReader(reader) === true) {
	      for (var i = 0; i < reader._readRequests.length; i++) {
	        var readRequest = reader._readRequests[i];
	        readRequest._reject(e);
	      }
	      reader._readRequests = [];
	    } else {
	      assert(IsReadableStreamBYOBReader(reader), 'reader must be ReadableStreamBYOBReader');
	      for (var _i = 0; _i < reader._readIntoRequests.length; _i++) {
	        var readIntoRequest = reader._readIntoRequests[_i];
	        readIntoRequest._reject(e);
	      }
	      reader._readIntoRequests = [];
	    }
	    defaultReaderClosedPromiseReject(reader, e);
	    reader._closedPromise.catch(function () {});
	  }
	  function ReadableStreamFulfillReadIntoRequest(stream, chunk, done) {
	    var reader = stream._reader;
	    assert(reader._readIntoRequests.length > 0);
	    var readIntoRequest = reader._readIntoRequests.shift();
	    readIntoRequest._resolve(CreateIterResultObject(chunk, done));
	  }
	  function ReadableStreamFulfillReadRequest(stream, chunk, done) {
	    var reader = stream._reader;
	    assert(reader._readRequests.length > 0);
	    var readRequest = reader._readRequests.shift();
	    readRequest._resolve(CreateIterResultObject(chunk, done));
	  }
	  function ReadableStreamGetNumReadIntoRequests(stream) {
	    return stream._reader._readIntoRequests.length;
	  }
	  function ReadableStreamGetNumReadRequests(stream) {
	    return stream._reader._readRequests.length;
	  }
	  function ReadableStreamHasBYOBReader(stream) {
	    var reader = stream._reader;
	    if (reader === undefined) {
	      return false;
	    }
	    if (IsReadableStreamBYOBReader(reader) === false) {
	      return false;
	    }
	    return true;
	  }
	  function ReadableStreamHasDefaultReader(stream) {
	    var reader = stream._reader;
	    if (reader === undefined) {
	      return false;
	    }
	    if (IsReadableStreamDefaultReader(reader) === false) {
	      return false;
	    }
	    return true;
	  }
	  var ReadableStreamDefaultReader = function () {
	    function ReadableStreamDefaultReader(stream) {
	      _classCallCheck(this, ReadableStreamDefaultReader);
	      if (IsReadableStream(stream) === false) {
	        throw new TypeError('ReadableStreamDefaultReader can only be constructed with a ReadableStream instance');
	      }
	      if (IsReadableStreamLocked(stream) === true) {
	        throw new TypeError('This stream has already been locked for exclusive reading by another reader');
	      }
	      ReadableStreamReaderGenericInitialize(this, stream);
	      this._readRequests = [];
	    }
	    _createClass(ReadableStreamDefaultReader, [{
	      key: 'cancel',
	      value: function cancel(reason) {
	        if (IsReadableStreamDefaultReader(this) === false) {
	          return Promise.reject(defaultReaderBrandCheckException('cancel'));
	        }
	        if (this._ownerReadableStream === undefined) {
	          return Promise.reject(readerLockException('cancel'));
	        }
	        return ReadableStreamReaderGenericCancel(this, reason);
	      }
	    }, {
	      key: 'read',
	      value: function read() {
	        if (IsReadableStreamDefaultReader(this) === false) {
	          return Promise.reject(defaultReaderBrandCheckException('read'));
	        }
	        if (this._ownerReadableStream === undefined) {
	          return Promise.reject(readerLockException('read from'));
	        }
	        return ReadableStreamDefaultReaderRead(this);
	      }
	    }, {
	      key: 'releaseLock',
	      value: function releaseLock() {
	        if (IsReadableStreamDefaultReader(this) === false) {
	          throw defaultReaderBrandCheckException('releaseLock');
	        }
	        if (this._ownerReadableStream === undefined) {
	          return;
	        }
	        if (this._readRequests.length > 0) {
	          throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
	        }
	        ReadableStreamReaderGenericRelease(this);
	      }
	    }, {
	      key: 'closed',
	      get: function get() {
	        if (IsReadableStreamDefaultReader(this) === false) {
	          return Promise.reject(defaultReaderBrandCheckException('closed'));
	        }
	        return this._closedPromise;
	      }
	    }]);
	    return ReadableStreamDefaultReader;
	  }();
	  var ReadableStreamBYOBReader = function () {
	    function ReadableStreamBYOBReader(stream) {
	      _classCallCheck(this, ReadableStreamBYOBReader);
	      if (!IsReadableStream(stream)) {
	        throw new TypeError('ReadableStreamBYOBReader can only be constructed with a ReadableStream instance given a ' + 'byte source');
	      }
	      if (IsReadableByteStreamController(stream._readableStreamController) === false) {
	        throw new TypeError('Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte ' + 'source');
	      }
	      if (IsReadableStreamLocked(stream)) {
	        throw new TypeError('This stream has already been locked for exclusive reading by another reader');
	      }
	      ReadableStreamReaderGenericInitialize(this, stream);
	      this._readIntoRequests = [];
	    }
	    _createClass(ReadableStreamBYOBReader, [{
	      key: 'cancel',
	      value: function cancel(reason) {
	        if (!IsReadableStreamBYOBReader(this)) {
	          return Promise.reject(byobReaderBrandCheckException('cancel'));
	        }
	        if (this._ownerReadableStream === undefined) {
	          return Promise.reject(readerLockException('cancel'));
	        }
	        return ReadableStreamReaderGenericCancel(this, reason);
	      }
	    }, {
	      key: 'read',
	      value: function read(view) {
	        if (!IsReadableStreamBYOBReader(this)) {
	          return Promise.reject(byobReaderBrandCheckException('read'));
	        }
	        if (this._ownerReadableStream === undefined) {
	          return Promise.reject(readerLockException('read from'));
	        }
	        if (!ArrayBuffer.isView(view)) {
	          return Promise.reject(new TypeError('view must be an array buffer view'));
	        }
	        if (view.byteLength === 0) {
	          return Promise.reject(new TypeError('view must have non-zero byteLength'));
	        }
	        return ReadableStreamBYOBReaderRead(this, view);
	      }
	    }, {
	      key: 'releaseLock',
	      value: function releaseLock() {
	        if (!IsReadableStreamBYOBReader(this)) {
	          throw byobReaderBrandCheckException('releaseLock');
	        }
	        if (this._ownerReadableStream === undefined) {
	          return;
	        }
	        if (this._readIntoRequests.length > 0) {
	          throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
	        }
	        ReadableStreamReaderGenericRelease(this);
	      }
	    }, {
	      key: 'closed',
	      get: function get() {
	        if (!IsReadableStreamBYOBReader(this)) {
	          return Promise.reject(byobReaderBrandCheckException('closed'));
	        }
	        return this._closedPromise;
	      }
	    }]);
	    return ReadableStreamBYOBReader;
	  }();
	  function IsReadableStreamBYOBReader(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_readIntoRequests')) {
	      return false;
	    }
	    return true;
	  }
	  function IsReadableStreamDefaultReader(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_readRequests')) {
	      return false;
	    }
	    return true;
	  }
	  function ReadableStreamReaderGenericInitialize(reader, stream) {
	    reader._ownerReadableStream = stream;
	    stream._reader = reader;
	    if (stream._state === 'readable') {
	      defaultReaderClosedPromiseInitialize(reader);
	    } else if (stream._state === 'closed') {
	      defaultReaderClosedPromiseInitializeAsResolved(reader);
	    } else {
	      assert(stream._state === 'errored', 'state must be errored');
	      defaultReaderClosedPromiseInitializeAsRejected(reader, stream._storedError);
	      reader._closedPromise.catch(function () {});
	    }
	  }
	  function ReadableStreamReaderGenericCancel(reader, reason) {
	    var stream = reader._ownerReadableStream;
	    assert(stream !== undefined);
	    return ReadableStreamCancel(stream, reason);
	  }
	  function ReadableStreamReaderGenericRelease(reader) {
	    assert(reader._ownerReadableStream !== undefined);
	    assert(reader._ownerReadableStream._reader === reader);
	    if (reader._ownerReadableStream._state === 'readable') {
	      defaultReaderClosedPromiseReject(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
	    } else {
	      defaultReaderClosedPromiseResetToRejected(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
	    }
	    reader._closedPromise.catch(function () {});
	    reader._ownerReadableStream._reader = undefined;
	    reader._ownerReadableStream = undefined;
	  }
	  function ReadableStreamBYOBReaderRead(reader, view) {
	    var stream = reader._ownerReadableStream;
	    assert(stream !== undefined);
	    stream._disturbed = true;
	    if (stream._state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    return ReadableByteStreamControllerPullInto(stream._readableStreamController, view);
	  }
	  function ReadableStreamDefaultReaderRead(reader) {
	    var stream = reader._ownerReadableStream;
	    assert(stream !== undefined);
	    stream._disturbed = true;
	    if (stream._state === 'closed') {
	      return Promise.resolve(CreateIterResultObject(undefined, true));
	    }
	    if (stream._state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    assert(stream._state === 'readable');
	    return stream._readableStreamController.__pullSteps();
	  }
	  var ReadableStreamDefaultController = function () {
	    function ReadableStreamDefaultController(stream, underlyingSource, size, highWaterMark) {
	      _classCallCheck(this, ReadableStreamDefaultController);
	      if (IsReadableStream(stream) === false) {
	        throw new TypeError('ReadableStreamDefaultController can only be constructed with a ReadableStream instance');
	      }
	      if (stream._readableStreamController !== undefined) {
	        throw new TypeError('ReadableStreamDefaultController instances can only be created by the ReadableStream constructor');
	      }
	      this._controlledReadableStream = stream;
	      this._underlyingSource = underlyingSource;
	      this._queue = undefined;
	      this._queueTotalSize = undefined;
	      ResetQueue(this);
	      this._started = false;
	      this._closeRequested = false;
	      this._pullAgain = false;
	      this._pulling = false;
	      var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
	      this._strategySize = normalizedStrategy.size;
	      this._strategyHWM = normalizedStrategy.highWaterMark;
	      var controller = this;
	      var startResult = InvokeOrNoop(underlyingSource, 'start', [this]);
	      Promise.resolve(startResult).then(function () {
	        controller._started = true;
	        assert(controller._pulling === false);
	        assert(controller._pullAgain === false);
	        ReadableStreamDefaultControllerCallPullIfNeeded(controller);
	      }, function (r) {
	        ReadableStreamDefaultControllerErrorIfNeeded(controller, r);
	      }).catch(rethrowAssertionErrorRejection);
	    }
	    _createClass(ReadableStreamDefaultController, [{
	      key: 'close',
	      value: function close() {
	        if (IsReadableStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('close');
	        }
	        if (this._closeRequested === true) {
	          throw new TypeError('The stream has already been closed; do not close it again!');
	        }
	        var state = this._controlledReadableStream._state;
	        if (state !== 'readable') {
	          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
	        }
	        ReadableStreamDefaultControllerClose(this);
	      }
	    }, {
	      key: 'enqueue',
	      value: function enqueue(chunk) {
	        if (IsReadableStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('enqueue');
	        }
	        if (this._closeRequested === true) {
	          throw new TypeError('stream is closed or draining');
	        }
	        var state = this._controlledReadableStream._state;
	        if (state !== 'readable') {
	          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
	        }
	        return ReadableStreamDefaultControllerEnqueue(this, chunk);
	      }
	    }, {
	      key: 'error',
	      value: function error(e) {
	        if (IsReadableStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('error');
	        }
	        var stream = this._controlledReadableStream;
	        if (stream._state !== 'readable') {
	          throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
	        }
	        ReadableStreamDefaultControllerError(this, e);
	      }
	    }, {
	      key: '__cancelSteps',
	      value: function __cancelSteps(reason) {
	        ResetQueue(this);
	        return PromiseInvokeOrNoop(this._underlyingSource, 'cancel', [reason]);
	      }
	    }, {
	      key: '__pullSteps',
	      value: function __pullSteps() {
	        var stream = this._controlledReadableStream;
	        if (this._queue.length > 0) {
	          var chunk = DequeueValue(this);
	          if (this._closeRequested === true && this._queue.length === 0) {
	            ReadableStreamClose(stream);
	          } else {
	            ReadableStreamDefaultControllerCallPullIfNeeded(this);
	          }
	          return Promise.resolve(CreateIterResultObject(chunk, false));
	        }
	        var pendingPromise = ReadableStreamAddReadRequest(stream);
	        ReadableStreamDefaultControllerCallPullIfNeeded(this);
	        return pendingPromise;
	      }
	    }, {
	      key: 'desiredSize',
	      get: function get() {
	        if (IsReadableStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('desiredSize');
	        }
	        return ReadableStreamDefaultControllerGetDesiredSize(this);
	      }
	    }]);
	    return ReadableStreamDefaultController;
	  }();
	  function IsReadableStreamDefaultController(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSource')) {
	      return false;
	    }
	    return true;
	  }
	  function ReadableStreamDefaultControllerCallPullIfNeeded(controller) {
	    var shouldPull = ReadableStreamDefaultControllerShouldCallPull(controller);
	    if (shouldPull === false) {
	      return undefined;
	    }
	    if (controller._pulling === true) {
	      controller._pullAgain = true;
	      return undefined;
	    }
	    assert(controller._pullAgain === false);
	    controller._pulling = true;
	    var pullPromise = PromiseInvokeOrNoop(controller._underlyingSource, 'pull', [controller]);
	    pullPromise.then(function () {
	      controller._pulling = false;
	      if (controller._pullAgain === true) {
	        controller._pullAgain = false;
	        return ReadableStreamDefaultControllerCallPullIfNeeded(controller);
	      }
	      return undefined;
	    }, function (e) {
	      ReadableStreamDefaultControllerErrorIfNeeded(controller, e);
	    }).catch(rethrowAssertionErrorRejection);
	    return undefined;
	  }
	  function ReadableStreamDefaultControllerShouldCallPull(controller) {
	    var stream = controller._controlledReadableStream;
	    if (stream._state === 'closed' || stream._state === 'errored') {
	      return false;
	    }
	    if (controller._closeRequested === true) {
	      return false;
	    }
	    if (controller._started === false) {
	      return false;
	    }
	    if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
	      return true;
	    }
	    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
	    if (desiredSize > 0) {
	      return true;
	    }
	    return false;
	  }
	  function ReadableStreamDefaultControllerClose(controller) {
	    var stream = controller._controlledReadableStream;
	    assert(controller._closeRequested === false);
	    assert(stream._state === 'readable');
	    controller._closeRequested = true;
	    if (controller._queue.length === 0) {
	      ReadableStreamClose(stream);
	    }
	  }
	  function ReadableStreamDefaultControllerEnqueue(controller, chunk) {
	    var stream = controller._controlledReadableStream;
	    assert(controller._closeRequested === false);
	    assert(stream._state === 'readable');
	    if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
	      ReadableStreamFulfillReadRequest(stream, chunk, false);
	    } else {
	      var chunkSize = 1;
	      if (controller._strategySize !== undefined) {
	        var strategySize = controller._strategySize;
	        try {
	          chunkSize = strategySize(chunk);
	        } catch (chunkSizeE) {
	          ReadableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
	          throw chunkSizeE;
	        }
	      }
	      try {
	        EnqueueValueWithSize(controller, chunk, chunkSize);
	      } catch (enqueueE) {
	        ReadableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
	        throw enqueueE;
	      }
	    }
	    ReadableStreamDefaultControllerCallPullIfNeeded(controller);
	    return undefined;
	  }
	  function ReadableStreamDefaultControllerError(controller, e) {
	    var stream = controller._controlledReadableStream;
	    assert(stream._state === 'readable');
	    ResetQueue(controller);
	    ReadableStreamError(stream, e);
	  }
	  function ReadableStreamDefaultControllerErrorIfNeeded(controller, e) {
	    if (controller._controlledReadableStream._state === 'readable') {
	      ReadableStreamDefaultControllerError(controller, e);
	    }
	  }
	  function ReadableStreamDefaultControllerGetDesiredSize(controller) {
	    var stream = controller._controlledReadableStream;
	    var state = stream._state;
	    if (state === 'errored') {
	      return null;
	    }
	    if (state === 'closed') {
	      return 0;
	    }
	    return controller._strategyHWM - controller._queueTotalSize;
	  }
	  var ReadableStreamBYOBRequest = function () {
	    function ReadableStreamBYOBRequest(controller, view) {
	      _classCallCheck(this, ReadableStreamBYOBRequest);
	      this._associatedReadableByteStreamController = controller;
	      this._view = view;
	    }
	    _createClass(ReadableStreamBYOBRequest, [{
	      key: 'respond',
	      value: function respond(bytesWritten) {
	        if (IsReadableStreamBYOBRequest(this) === false) {
	          throw byobRequestBrandCheckException('respond');
	        }
	        if (this._associatedReadableByteStreamController === undefined) {
	          throw new TypeError('This BYOB request has been invalidated');
	        }
	        ReadableByteStreamControllerRespond(this._associatedReadableByteStreamController, bytesWritten);
	      }
	    }, {
	      key: 'respondWithNewView',
	      value: function respondWithNewView(view) {
	        if (IsReadableStreamBYOBRequest(this) === false) {
	          throw byobRequestBrandCheckException('respond');
	        }
	        if (this._associatedReadableByteStreamController === undefined) {
	          throw new TypeError('This BYOB request has been invalidated');
	        }
	        if (!ArrayBuffer.isView(view)) {
	          throw new TypeError('You can only respond with array buffer views');
	        }
	        ReadableByteStreamControllerRespondWithNewView(this._associatedReadableByteStreamController, view);
	      }
	    }, {
	      key: 'view',
	      get: function get() {
	        return this._view;
	      }
	    }]);
	    return ReadableStreamBYOBRequest;
	  }();
	  var ReadableByteStreamController = function () {
	    function ReadableByteStreamController(stream, underlyingByteSource, highWaterMark) {
	      _classCallCheck(this, ReadableByteStreamController);
	      if (IsReadableStream(stream) === false) {
	        throw new TypeError('ReadableByteStreamController can only be constructed with a ReadableStream instance given ' + 'a byte source');
	      }
	      if (stream._readableStreamController !== undefined) {
	        throw new TypeError('ReadableByteStreamController instances can only be created by the ReadableStream constructor given a byte ' + 'source');
	      }
	      this._controlledReadableStream = stream;
	      this._underlyingByteSource = underlyingByteSource;
	      this._pullAgain = false;
	      this._pulling = false;
	      ReadableByteStreamControllerClearPendingPullIntos(this);
	      this._queue = this._queueTotalSize = undefined;
	      ResetQueue(this);
	      this._closeRequested = false;
	      this._started = false;
	      this._strategyHWM = ValidateAndNormalizeHighWaterMark(highWaterMark);
	      var autoAllocateChunkSize = underlyingByteSource.autoAllocateChunkSize;
	      if (autoAllocateChunkSize !== undefined) {
	        if (Number.isInteger(autoAllocateChunkSize) === false || autoAllocateChunkSize <= 0) {
	          throw new RangeError('autoAllocateChunkSize must be a positive integer');
	        }
	      }
	      this._autoAllocateChunkSize = autoAllocateChunkSize;
	      this._pendingPullIntos = [];
	      var controller = this;
	      var startResult = InvokeOrNoop(underlyingByteSource, 'start', [this]);
	      Promise.resolve(startResult).then(function () {
	        controller._started = true;
	        assert(controller._pulling === false);
	        assert(controller._pullAgain === false);
	        ReadableByteStreamControllerCallPullIfNeeded(controller);
	      }, function (r) {
	        if (stream._state === 'readable') {
	          ReadableByteStreamControllerError(controller, r);
	        }
	      }).catch(rethrowAssertionErrorRejection);
	    }
	    _createClass(ReadableByteStreamController, [{
	      key: 'close',
	      value: function close() {
	        if (IsReadableByteStreamController(this) === false) {
	          throw byteStreamControllerBrandCheckException('close');
	        }
	        if (this._closeRequested === true) {
	          throw new TypeError('The stream has already been closed; do not close it again!');
	        }
	        var state = this._controlledReadableStream._state;
	        if (state !== 'readable') {
	          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
	        }
	        ReadableByteStreamControllerClose(this);
	      }
	    }, {
	      key: 'enqueue',
	      value: function enqueue(chunk) {
	        if (IsReadableByteStreamController(this) === false) {
	          throw byteStreamControllerBrandCheckException('enqueue');
	        }
	        if (this._closeRequested === true) {
	          throw new TypeError('stream is closed or draining');
	        }
	        var state = this._controlledReadableStream._state;
	        if (state !== 'readable') {
	          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
	        }
	        if (!ArrayBuffer.isView(chunk)) {
	          throw new TypeError('You can only enqueue array buffer views when using a ReadableByteStreamController');
	        }
	        ReadableByteStreamControllerEnqueue(this, chunk);
	      }
	    }, {
	      key: 'error',
	      value: function error(e) {
	        if (IsReadableByteStreamController(this) === false) {
	          throw byteStreamControllerBrandCheckException('error');
	        }
	        var stream = this._controlledReadableStream;
	        if (stream._state !== 'readable') {
	          throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
	        }
	        ReadableByteStreamControllerError(this, e);
	      }
	    }, {
	      key: '__cancelSteps',
	      value: function __cancelSteps(reason) {
	        if (this._pendingPullIntos.length > 0) {
	          var firstDescriptor = this._pendingPullIntos[0];
	          firstDescriptor.bytesFilled = 0;
	        }
	        ResetQueue(this);
	        return PromiseInvokeOrNoop(this._underlyingByteSource, 'cancel', [reason]);
	      }
	    }, {
	      key: '__pullSteps',
	      value: function __pullSteps() {
	        var stream = this._controlledReadableStream;
	        assert(ReadableStreamHasDefaultReader(stream) === true);
	        if (this._queueTotalSize > 0) {
	          assert(ReadableStreamGetNumReadRequests(stream) === 0);
	          var entry = this._queue.shift();
	          this._queueTotalSize -= entry.byteLength;
	          ReadableByteStreamControllerHandleQueueDrain(this);
	          var view = void 0;
	          try {
	            view = new Uint8Array(entry.buffer, entry.byteOffset, entry.byteLength);
	          } catch (viewE) {
	            return Promise.reject(viewE);
	          }
	          return Promise.resolve(CreateIterResultObject(view, false));
	        }
	        var autoAllocateChunkSize = this._autoAllocateChunkSize;
	        if (autoAllocateChunkSize !== undefined) {
	          var buffer = void 0;
	          try {
	            buffer = new ArrayBuffer(autoAllocateChunkSize);
	          } catch (bufferE) {
	            return Promise.reject(bufferE);
	          }
	          var pullIntoDescriptor = {
	            buffer: buffer,
	            byteOffset: 0,
	            byteLength: autoAllocateChunkSize,
	            bytesFilled: 0,
	            elementSize: 1,
	            ctor: Uint8Array,
	            readerType: 'default'
	          };
	          this._pendingPullIntos.push(pullIntoDescriptor);
	        }
	        var promise = ReadableStreamAddReadRequest(stream);
	        ReadableByteStreamControllerCallPullIfNeeded(this);
	        return promise;
	      }
	    }, {
	      key: 'byobRequest',
	      get: function get() {
	        if (IsReadableByteStreamController(this) === false) {
	          throw byteStreamControllerBrandCheckException('byobRequest');
	        }
	        if (this._byobRequest === undefined && this._pendingPullIntos.length > 0) {
	          var firstDescriptor = this._pendingPullIntos[0];
	          var view = new Uint8Array(firstDescriptor.buffer, firstDescriptor.byteOffset + firstDescriptor.bytesFilled, firstDescriptor.byteLength - firstDescriptor.bytesFilled);
	          this._byobRequest = new ReadableStreamBYOBRequest(this, view);
	        }
	        return this._byobRequest;
	      }
	    }, {
	      key: 'desiredSize',
	      get: function get() {
	        if (IsReadableByteStreamController(this) === false) {
	          throw byteStreamControllerBrandCheckException('desiredSize');
	        }
	        return ReadableByteStreamControllerGetDesiredSize(this);
	      }
	    }]);
	    return ReadableByteStreamController;
	  }();
	  function IsReadableByteStreamController(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingByteSource')) {
	      return false;
	    }
	    return true;
	  }
	  function IsReadableStreamBYOBRequest(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_associatedReadableByteStreamController')) {
	      return false;
	    }
	    return true;
	  }
	  function ReadableByteStreamControllerCallPullIfNeeded(controller) {
	    var shouldPull = ReadableByteStreamControllerShouldCallPull(controller);
	    if (shouldPull === false) {
	      return undefined;
	    }
	    if (controller._pulling === true) {
	      controller._pullAgain = true;
	      return undefined;
	    }
	    assert(controller._pullAgain === false);
	    controller._pulling = true;
	    var pullPromise = PromiseInvokeOrNoop(controller._underlyingByteSource, 'pull', [controller]);
	    pullPromise.then(function () {
	      controller._pulling = false;
	      if (controller._pullAgain === true) {
	        controller._pullAgain = false;
	        ReadableByteStreamControllerCallPullIfNeeded(controller);
	      }
	    }, function (e) {
	      if (controller._controlledReadableStream._state === 'readable') {
	        ReadableByteStreamControllerError(controller, e);
	      }
	    }).catch(rethrowAssertionErrorRejection);
	    return undefined;
	  }
	  function ReadableByteStreamControllerClearPendingPullIntos(controller) {
	    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
	    controller._pendingPullIntos = [];
	  }
	  function ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor) {
	    assert(stream._state !== 'errored', 'state must not be errored');
	    var done = false;
	    if (stream._state === 'closed') {
	      assert(pullIntoDescriptor.bytesFilled === 0);
	      done = true;
	    }
	    var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
	    if (pullIntoDescriptor.readerType === 'default') {
	      ReadableStreamFulfillReadRequest(stream, filledView, done);
	    } else {
	      assert(pullIntoDescriptor.readerType === 'byob');
	      ReadableStreamFulfillReadIntoRequest(stream, filledView, done);
	    }
	  }
	  function ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor) {
	    var bytesFilled = pullIntoDescriptor.bytesFilled;
	    var elementSize = pullIntoDescriptor.elementSize;
	    assert(bytesFilled <= pullIntoDescriptor.byteLength);
	    assert(bytesFilled % elementSize === 0);
	    return new pullIntoDescriptor.ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, bytesFilled / elementSize);
	  }
	  function ReadableByteStreamControllerEnqueueChunkToQueue(controller, buffer, byteOffset, byteLength) {
	    controller._queue.push({
	      buffer: buffer,
	      byteOffset: byteOffset,
	      byteLength: byteLength
	    });
	    controller._queueTotalSize += byteLength;
	  }
	  function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) {
	    var elementSize = pullIntoDescriptor.elementSize;
	    var currentAlignedBytes = pullIntoDescriptor.bytesFilled - pullIntoDescriptor.bytesFilled % elementSize;
	    var maxBytesToCopy = Math.min(controller._queueTotalSize, pullIntoDescriptor.byteLength - pullIntoDescriptor.bytesFilled);
	    var maxBytesFilled = pullIntoDescriptor.bytesFilled + maxBytesToCopy;
	    var maxAlignedBytes = maxBytesFilled - maxBytesFilled % elementSize;
	    var totalBytesToCopyRemaining = maxBytesToCopy;
	    var ready = false;
	    if (maxAlignedBytes > currentAlignedBytes) {
	      totalBytesToCopyRemaining = maxAlignedBytes - pullIntoDescriptor.bytesFilled;
	      ready = true;
	    }
	    var queue = controller._queue;
	    while (totalBytesToCopyRemaining > 0) {
	      var headOfQueue = queue[0];
	      var bytesToCopy = Math.min(totalBytesToCopyRemaining, headOfQueue.byteLength);
	      var destStart = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
	      ArrayBufferCopy(pullIntoDescriptor.buffer, destStart, headOfQueue.buffer, headOfQueue.byteOffset, bytesToCopy);
	      if (headOfQueue.byteLength === bytesToCopy) {
	        queue.shift();
	      } else {
	        headOfQueue.byteOffset += bytesToCopy;
	        headOfQueue.byteLength -= bytesToCopy;
	      }
	      controller._queueTotalSize -= bytesToCopy;
	      ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesToCopy, pullIntoDescriptor);
	      totalBytesToCopyRemaining -= bytesToCopy;
	    }
	    if (ready === false) {
	      assert(controller._queueTotalSize === 0, 'queue must be empty');
	      assert(pullIntoDescriptor.bytesFilled > 0);
	      assert(pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize);
	    }
	    return ready;
	  }
	  function ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, size, pullIntoDescriptor) {
	    assert(controller._pendingPullIntos.length === 0 || controller._pendingPullIntos[0] === pullIntoDescriptor);
	    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
	    pullIntoDescriptor.bytesFilled += size;
	  }
	  function ReadableByteStreamControllerHandleQueueDrain(controller) {
	    assert(controller._controlledReadableStream._state === 'readable');
	    if (controller._queueTotalSize === 0 && controller._closeRequested === true) {
	      ReadableStreamClose(controller._controlledReadableStream);
	    } else {
	      ReadableByteStreamControllerCallPullIfNeeded(controller);
	    }
	  }
	  function ReadableByteStreamControllerInvalidateBYOBRequest(controller) {
	    if (controller._byobRequest === undefined) {
	      return;
	    }
	    controller._byobRequest._associatedReadableByteStreamController = undefined;
	    controller._byobRequest._view = undefined;
	    controller._byobRequest = undefined;
	  }
	  function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller) {
	    assert(controller._closeRequested === false);
	    while (controller._pendingPullIntos.length > 0) {
	      if (controller._queueTotalSize === 0) {
	        return;
	      }
	      var pullIntoDescriptor = controller._pendingPullIntos[0];
	      if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
	        ReadableByteStreamControllerShiftPendingPullInto(controller);
	        ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
	      }
	    }
	  }
	  function ReadableByteStreamControllerPullInto(controller, view) {
	    var stream = controller._controlledReadableStream;
	    var elementSize = 1;
	    if (view.constructor !== DataView) {
	      elementSize = view.constructor.BYTES_PER_ELEMENT;
	    }
	    var ctor = view.constructor;
	    var pullIntoDescriptor = {
	      buffer: view.buffer,
	      byteOffset: view.byteOffset,
	      byteLength: view.byteLength,
	      bytesFilled: 0,
	      elementSize: elementSize,
	      ctor: ctor,
	      readerType: 'byob'
	    };
	    if (controller._pendingPullIntos.length > 0) {
	      pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
	      controller._pendingPullIntos.push(pullIntoDescriptor);
	      return ReadableStreamAddReadIntoRequest(stream);
	    }
	    if (stream._state === 'closed') {
	      var emptyView = new view.constructor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, 0);
	      return Promise.resolve(CreateIterResultObject(emptyView, true));
	    }
	    if (controller._queueTotalSize > 0) {
	      if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
	        var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
	        ReadableByteStreamControllerHandleQueueDrain(controller);
	        return Promise.resolve(CreateIterResultObject(filledView, false));
	      }
	      if (controller._closeRequested === true) {
	        var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
	        ReadableByteStreamControllerError(controller, e);
	        return Promise.reject(e);
	      }
	    }
	    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
	    controller._pendingPullIntos.push(pullIntoDescriptor);
	    var promise = ReadableStreamAddReadIntoRequest(stream);
	    ReadableByteStreamControllerCallPullIfNeeded(controller);
	    return promise;
	  }
	  function ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor) {
	    firstDescriptor.buffer = TransferArrayBuffer(firstDescriptor.buffer);
	    assert(firstDescriptor.bytesFilled === 0, 'bytesFilled must be 0');
	    var stream = controller._controlledReadableStream;
	    if (ReadableStreamHasBYOBReader(stream) === true) {
	      while (ReadableStreamGetNumReadIntoRequests(stream) > 0) {
	        var pullIntoDescriptor = ReadableByteStreamControllerShiftPendingPullInto(controller);
	        ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor);
	      }
	    }
	  }
	  function ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, pullIntoDescriptor) {
	    if (pullIntoDescriptor.bytesFilled + bytesWritten > pullIntoDescriptor.byteLength) {
	      throw new RangeError('bytesWritten out of range');
	    }
	    ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesWritten, pullIntoDescriptor);
	    if (pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize) {
	      return;
	    }
	    ReadableByteStreamControllerShiftPendingPullInto(controller);
	    var remainderSize = pullIntoDescriptor.bytesFilled % pullIntoDescriptor.elementSize;
	    if (remainderSize > 0) {
	      var end = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
	      var remainder = pullIntoDescriptor.buffer.slice(end - remainderSize, end);
	      ReadableByteStreamControllerEnqueueChunkToQueue(controller, remainder, 0, remainder.byteLength);
	    }
	    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
	    pullIntoDescriptor.bytesFilled -= remainderSize;
	    ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
	    ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
	  }
	  function ReadableByteStreamControllerRespondInternal(controller, bytesWritten) {
	    var firstDescriptor = controller._pendingPullIntos[0];
	    var stream = controller._controlledReadableStream;
	    if (stream._state === 'closed') {
	      if (bytesWritten !== 0) {
	        throw new TypeError('bytesWritten must be 0 when calling respond() on a closed stream');
	      }
	      ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor);
	    } else {
	      assert(stream._state === 'readable');
	      ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, firstDescriptor);
	    }
	  }
	  function ReadableByteStreamControllerShiftPendingPullInto(controller) {
	    var descriptor = controller._pendingPullIntos.shift();
	    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
	    return descriptor;
	  }
	  function ReadableByteStreamControllerShouldCallPull(controller) {
	    var stream = controller._controlledReadableStream;
	    if (stream._state !== 'readable') {
	      return false;
	    }
	    if (controller._closeRequested === true) {
	      return false;
	    }
	    if (controller._started === false) {
	      return false;
	    }
	    if (ReadableStreamHasDefaultReader(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
	      return true;
	    }
	    if (ReadableStreamHasBYOBReader(stream) === true && ReadableStreamGetNumReadIntoRequests(stream) > 0) {
	      return true;
	    }
	    if (ReadableByteStreamControllerGetDesiredSize(controller) > 0) {
	      return true;
	    }
	    return false;
	  }
	  function ReadableByteStreamControllerClose(controller) {
	    var stream = controller._controlledReadableStream;
	    assert(controller._closeRequested === false);
	    assert(stream._state === 'readable');
	    if (controller._queueTotalSize > 0) {
	      controller._closeRequested = true;
	      return;
	    }
	    if (controller._pendingPullIntos.length > 0) {
	      var firstPendingPullInto = controller._pendingPullIntos[0];
	      if (firstPendingPullInto.bytesFilled > 0) {
	        var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
	        ReadableByteStreamControllerError(controller, e);
	        throw e;
	      }
	    }
	    ReadableStreamClose(stream);
	  }
	  function ReadableByteStreamControllerEnqueue(controller, chunk) {
	    var stream = controller._controlledReadableStream;
	    assert(controller._closeRequested === false);
	    assert(stream._state === 'readable');
	    var buffer = chunk.buffer;
	    var byteOffset = chunk.byteOffset;
	    var byteLength = chunk.byteLength;
	    var transferredBuffer = TransferArrayBuffer(buffer);
	    if (ReadableStreamHasDefaultReader(stream) === true) {
	      if (ReadableStreamGetNumReadRequests(stream) === 0) {
	        ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
	      } else {
	        assert(controller._queue.length === 0);
	        var transferredView = new Uint8Array(transferredBuffer, byteOffset, byteLength);
	        ReadableStreamFulfillReadRequest(stream, transferredView, false);
	      }
	    } else if (ReadableStreamHasBYOBReader(stream) === true) {
	      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
	      ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
	    } else {
	      assert(IsReadableStreamLocked(stream) === false, 'stream must not be locked');
	      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
	    }
	  }
	  function ReadableByteStreamControllerError(controller, e) {
	    var stream = controller._controlledReadableStream;
	    assert(stream._state === 'readable');
	    ReadableByteStreamControllerClearPendingPullIntos(controller);
	    ResetQueue(controller);
	    ReadableStreamError(stream, e);
	  }
	  function ReadableByteStreamControllerGetDesiredSize(controller) {
	    var stream = controller._controlledReadableStream;
	    var state = stream._state;
	    if (state === 'errored') {
	      return null;
	    }
	    if (state === 'closed') {
	      return 0;
	    }
	    return controller._strategyHWM - controller._queueTotalSize;
	  }
	  function ReadableByteStreamControllerRespond(controller, bytesWritten) {
	    bytesWritten = Number(bytesWritten);
	    if (IsFiniteNonNegativeNumber(bytesWritten) === false) {
	      throw new RangeError('bytesWritten must be a finite');
	    }
	    assert(controller._pendingPullIntos.length > 0);
	    ReadableByteStreamControllerRespondInternal(controller, bytesWritten);
	  }
	  function ReadableByteStreamControllerRespondWithNewView(controller, view) {
	    assert(controller._pendingPullIntos.length > 0);
	    var firstDescriptor = controller._pendingPullIntos[0];
	    if (firstDescriptor.byteOffset + firstDescriptor.bytesFilled !== view.byteOffset) {
	      throw new RangeError('The region specified by view does not match byobRequest');
	    }
	    if (firstDescriptor.byteLength !== view.byteLength) {
	      throw new RangeError('The buffer of view has different capacity than byobRequest');
	    }
	    firstDescriptor.buffer = view.buffer;
	    ReadableByteStreamControllerRespondInternal(controller, view.byteLength);
	  }
	  function streamBrandCheckException(name) {
	    return new TypeError('ReadableStream.prototype.' + name + ' can only be used on a ReadableStream');
	  }
	  function readerLockException(name) {
	    return new TypeError('Cannot ' + name + ' a stream using a released reader');
	  }
	  function defaultReaderBrandCheckException(name) {
	    return new TypeError('ReadableStreamDefaultReader.prototype.' + name + ' can only be used on a ReadableStreamDefaultReader');
	  }
	  function defaultReaderClosedPromiseInitialize(reader) {
	    reader._closedPromise = new Promise(function (resolve, reject) {
	      reader._closedPromise_resolve = resolve;
	      reader._closedPromise_reject = reject;
	    });
	  }
	  function defaultReaderClosedPromiseInitializeAsRejected(reader, reason) {
	    reader._closedPromise = Promise.reject(reason);
	    reader._closedPromise_resolve = undefined;
	    reader._closedPromise_reject = undefined;
	  }
	  function defaultReaderClosedPromiseInitializeAsResolved(reader) {
	    reader._closedPromise = Promise.resolve(undefined);
	    reader._closedPromise_resolve = undefined;
	    reader._closedPromise_reject = undefined;
	  }
	  function defaultReaderClosedPromiseReject(reader, reason) {
	    assert(reader._closedPromise_resolve !== undefined);
	    assert(reader._closedPromise_reject !== undefined);
	    reader._closedPromise_reject(reason);
	    reader._closedPromise_resolve = undefined;
	    reader._closedPromise_reject = undefined;
	  }
	  function defaultReaderClosedPromiseResetToRejected(reader, reason) {
	    assert(reader._closedPromise_resolve === undefined);
	    assert(reader._closedPromise_reject === undefined);
	    reader._closedPromise = Promise.reject(reason);
	  }
	  function defaultReaderClosedPromiseResolve(reader) {
	    assert(reader._closedPromise_resolve !== undefined);
	    assert(reader._closedPromise_reject !== undefined);
	    reader._closedPromise_resolve(undefined);
	    reader._closedPromise_resolve = undefined;
	    reader._closedPromise_reject = undefined;
	  }
	  function byobReaderBrandCheckException(name) {
	    return new TypeError('ReadableStreamBYOBReader.prototype.' + name + ' can only be used on a ReadableStreamBYOBReader');
	  }
	  function defaultControllerBrandCheckException(name) {
	    return new TypeError('ReadableStreamDefaultController.prototype.' + name + ' can only be used on a ReadableStreamDefaultController');
	  }
	  function byobRequestBrandCheckException(name) {
	    return new TypeError('ReadableStreamBYOBRequest.prototype.' + name + ' can only be used on a ReadableStreamBYOBRequest');
	  }
	  function byteStreamControllerBrandCheckException(name) {
	    return new TypeError('ReadableByteStreamController.prototype.' + name + ' can only be used on a ReadableByteStreamController');
	  }
	  function ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise) {
	    try {
	      Promise.prototype.then.call(promise, undefined, function () {});
	    } catch (e) {}
	  }
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var transformStream = __w_pdfjs_require__(6);
	  var readableStream = __w_pdfjs_require__(4);
	  var writableStream = __w_pdfjs_require__(2);
	  exports.TransformStream = transformStream.TransformStream;
	  exports.ReadableStream = readableStream.ReadableStream;
	  exports.IsReadableStreamDisturbed = readableStream.IsReadableStreamDisturbed;
	  exports.ReadableStreamDefaultControllerClose = readableStream.ReadableStreamDefaultControllerClose;
	  exports.ReadableStreamDefaultControllerEnqueue = readableStream.ReadableStreamDefaultControllerEnqueue;
	  exports.ReadableStreamDefaultControllerError = readableStream.ReadableStreamDefaultControllerError;
	  exports.ReadableStreamDefaultControllerGetDesiredSize = readableStream.ReadableStreamDefaultControllerGetDesiredSize;
	  exports.AcquireWritableStreamDefaultWriter = writableStream.AcquireWritableStreamDefaultWriter;
	  exports.IsWritableStream = writableStream.IsWritableStream;
	  exports.IsWritableStreamLocked = writableStream.IsWritableStreamLocked;
	  exports.WritableStream = writableStream.WritableStream;
	  exports.WritableStreamAbort = writableStream.WritableStreamAbort;
	  exports.WritableStreamDefaultControllerError = writableStream.WritableStreamDefaultControllerError;
	  exports.WritableStreamDefaultWriterCloseWithErrorPropagation = writableStream.WritableStreamDefaultWriterCloseWithErrorPropagation;
	  exports.WritableStreamDefaultWriterRelease = writableStream.WritableStreamDefaultWriterRelease;
	  exports.WritableStreamDefaultWriterWrite = writableStream.WritableStreamDefaultWriterWrite;
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	  var _require = __w_pdfjs_require__(1),
	      assert = _require.assert;
	  var _require2 = __w_pdfjs_require__(0),
	      InvokeOrNoop = _require2.InvokeOrNoop,
	      PromiseInvokeOrPerformFallback = _require2.PromiseInvokeOrPerformFallback,
	      PromiseInvokeOrNoop = _require2.PromiseInvokeOrNoop,
	      typeIsObject = _require2.typeIsObject;
	  var _require3 = __w_pdfjs_require__(4),
	      ReadableStream = _require3.ReadableStream,
	      ReadableStreamDefaultControllerClose = _require3.ReadableStreamDefaultControllerClose,
	      ReadableStreamDefaultControllerEnqueue = _require3.ReadableStreamDefaultControllerEnqueue,
	      ReadableStreamDefaultControllerError = _require3.ReadableStreamDefaultControllerError,
	      ReadableStreamDefaultControllerGetDesiredSize = _require3.ReadableStreamDefaultControllerGetDesiredSize;
	  var _require4 = __w_pdfjs_require__(2),
	      WritableStream = _require4.WritableStream,
	      WritableStreamDefaultControllerError = _require4.WritableStreamDefaultControllerError;
	  function TransformStreamCloseReadable(transformStream) {
	    if (transformStream._errored === true) {
	      throw new TypeError('TransformStream is already errored');
	    }
	    if (transformStream._readableClosed === true) {
	      throw new TypeError('Readable side is already closed');
	    }
	    TransformStreamCloseReadableInternal(transformStream);
	  }
	  function TransformStreamEnqueueToReadable(transformStream, chunk) {
	    if (transformStream._errored === true) {
	      throw new TypeError('TransformStream is already errored');
	    }
	    if (transformStream._readableClosed === true) {
	      throw new TypeError('Readable side is already closed');
	    }
	    var controller = transformStream._readableController;
	    try {
	      ReadableStreamDefaultControllerEnqueue(controller, chunk);
	    } catch (e) {
	      transformStream._readableClosed = true;
	      TransformStreamErrorIfNeeded(transformStream, e);
	      throw transformStream._storedError;
	    }
	    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
	    var maybeBackpressure = desiredSize <= 0;
	    if (maybeBackpressure === true && transformStream._backpressure === false) {
	      TransformStreamSetBackpressure(transformStream, true);
	    }
	  }
	  function TransformStreamError(transformStream, e) {
	    if (transformStream._errored === true) {
	      throw new TypeError('TransformStream is already errored');
	    }
	    TransformStreamErrorInternal(transformStream, e);
	  }
	  function TransformStreamCloseReadableInternal(transformStream) {
	    assert(transformStream._errored === false);
	    assert(transformStream._readableClosed === false);
	    try {
	      ReadableStreamDefaultControllerClose(transformStream._readableController);
	    } catch (e) {
	      assert(false);
	    }
	    transformStream._readableClosed = true;
	  }
	  function TransformStreamErrorIfNeeded(transformStream, e) {
	    if (transformStream._errored === false) {
	      TransformStreamErrorInternal(transformStream, e);
	    }
	  }
	  function TransformStreamErrorInternal(transformStream, e) {
	    assert(transformStream._errored === false);
	    transformStream._errored = true;
	    transformStream._storedError = e;
	    if (transformStream._writableDone === false) {
	      WritableStreamDefaultControllerError(transformStream._writableController, e);
	    }
	    if (transformStream._readableClosed === false) {
	      ReadableStreamDefaultControllerError(transformStream._readableController, e);
	    }
	  }
	  function TransformStreamReadableReadyPromise(transformStream) {
	    assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
	    if (transformStream._backpressure === false) {
	      return Promise.resolve();
	    }
	    assert(transformStream._backpressure === true, '_backpressure should have been initialized');
	    return transformStream._backpressureChangePromise;
	  }
	  function TransformStreamSetBackpressure(transformStream, backpressure) {
	    assert(transformStream._backpressure !== backpressure, 'TransformStreamSetBackpressure() should be called only when backpressure is changed');
	    if (transformStream._backpressureChangePromise !== undefined) {
	      transformStream._backpressureChangePromise_resolve(backpressure);
	    }
	    transformStream._backpressureChangePromise = new Promise(function (resolve) {
	      transformStream._backpressureChangePromise_resolve = resolve;
	    });
	    transformStream._backpressureChangePromise.then(function (resolution) {
	      assert(resolution !== backpressure, '_backpressureChangePromise should be fulfilled only when backpressure is changed');
	    });
	    transformStream._backpressure = backpressure;
	  }
	  function TransformStreamDefaultTransform(chunk, transformStreamController) {
	    var transformStream = transformStreamController._controlledTransformStream;
	    TransformStreamEnqueueToReadable(transformStream, chunk);
	    return Promise.resolve();
	  }
	  function TransformStreamTransform(transformStream, chunk) {
	    assert(transformStream._errored === false);
	    assert(transformStream._transforming === false);
	    assert(transformStream._backpressure === false);
	    transformStream._transforming = true;
	    var transformer = transformStream._transformer;
	    var controller = transformStream._transformStreamController;
	    var transformPromise = PromiseInvokeOrPerformFallback(transformer, 'transform', [chunk, controller], TransformStreamDefaultTransform, [chunk, controller]);
	    return transformPromise.then(function () {
	      transformStream._transforming = false;
	      return TransformStreamReadableReadyPromise(transformStream);
	    }, function (e) {
	      TransformStreamErrorIfNeeded(transformStream, e);
	      return Promise.reject(e);
	    });
	  }
	  function IsTransformStreamDefaultController(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_controlledTransformStream')) {
	      return false;
	    }
	    return true;
	  }
	  function IsTransformStream(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_transformStreamController')) {
	      return false;
	    }
	    return true;
	  }
	  var TransformStreamSink = function () {
	    function TransformStreamSink(transformStream, startPromise) {
	      _classCallCheck(this, TransformStreamSink);
	      this._transformStream = transformStream;
	      this._startPromise = startPromise;
	    }
	    _createClass(TransformStreamSink, [{
	      key: 'start',
	      value: function start(c) {
	        var transformStream = this._transformStream;
	        transformStream._writableController = c;
	        return this._startPromise.then(function () {
	          return TransformStreamReadableReadyPromise(transformStream);
	        });
	      }
	    }, {
	      key: 'write',
	      value: function write(chunk) {
	        var transformStream = this._transformStream;
	        return TransformStreamTransform(transformStream, chunk);
	      }
	    }, {
	      key: 'abort',
	      value: function abort() {
	        var transformStream = this._transformStream;
	        transformStream._writableDone = true;
	        TransformStreamErrorInternal(transformStream, new TypeError('Writable side aborted'));
	      }
	    }, {
	      key: 'close',
	      value: function close() {
	        var transformStream = this._transformStream;
	        assert(transformStream._transforming === false);
	        transformStream._writableDone = true;
	        var flushPromise = PromiseInvokeOrNoop(transformStream._transformer, 'flush', [transformStream._transformStreamController]);
	        return flushPromise.then(function () {
	          if (transformStream._errored === true) {
	            return Promise.reject(transformStream._storedError);
	          }
	          if (transformStream._readableClosed === false) {
	            TransformStreamCloseReadableInternal(transformStream);
	          }
	          return Promise.resolve();
	        }).catch(function (r) {
	          TransformStreamErrorIfNeeded(transformStream, r);
	          return Promise.reject(transformStream._storedError);
	        });
	      }
	    }]);
	    return TransformStreamSink;
	  }();
	  var TransformStreamSource = function () {
	    function TransformStreamSource(transformStream, startPromise) {
	      _classCallCheck(this, TransformStreamSource);
	      this._transformStream = transformStream;
	      this._startPromise = startPromise;
	    }
	    _createClass(TransformStreamSource, [{
	      key: 'start',
	      value: function start(c) {
	        var transformStream = this._transformStream;
	        transformStream._readableController = c;
	        return this._startPromise.then(function () {
	          assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
	          if (transformStream._backpressure === true) {
	            return Promise.resolve();
	          }
	          assert(transformStream._backpressure === false, '_backpressure should have been initialized');
	          return transformStream._backpressureChangePromise;
	        });
	      }
	    }, {
	      key: 'pull',
	      value: function pull() {
	        var transformStream = this._transformStream;
	        assert(transformStream._backpressure === true, 'pull() should be never called while _backpressure is false');
	        assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
	        TransformStreamSetBackpressure(transformStream, false);
	        return transformStream._backpressureChangePromise;
	      }
	    }, {
	      key: 'cancel',
	      value: function cancel() {
	        var transformStream = this._transformStream;
	        transformStream._readableClosed = true;
	        TransformStreamErrorInternal(transformStream, new TypeError('Readable side canceled'));
	      }
	    }]);
	    return TransformStreamSource;
	  }();
	  var TransformStreamDefaultController = function () {
	    function TransformStreamDefaultController(transformStream) {
	      _classCallCheck(this, TransformStreamDefaultController);
	      if (IsTransformStream(transformStream) === false) {
	        throw new TypeError('TransformStreamDefaultController can only be ' + 'constructed with a TransformStream instance');
	      }
	      if (transformStream._transformStreamController !== undefined) {
	        throw new TypeError('TransformStreamDefaultController instances can ' + 'only be created by the TransformStream constructor');
	      }
	      this._controlledTransformStream = transformStream;
	    }
	    _createClass(TransformStreamDefaultController, [{
	      key: 'enqueue',
	      value: function enqueue(chunk) {
	        if (IsTransformStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('enqueue');
	        }
	        TransformStreamEnqueueToReadable(this._controlledTransformStream, chunk);
	      }
	    }, {
	      key: 'close',
	      value: function close() {
	        if (IsTransformStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('close');
	        }
	        TransformStreamCloseReadable(this._controlledTransformStream);
	      }
	    }, {
	      key: 'error',
	      value: function error(reason) {
	        if (IsTransformStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('error');
	        }
	        TransformStreamError(this._controlledTransformStream, reason);
	      }
	    }, {
	      key: 'desiredSize',
	      get: function get() {
	        if (IsTransformStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('desiredSize');
	        }
	        var transformStream = this._controlledTransformStream;
	        var readableController = transformStream._readableController;
	        return ReadableStreamDefaultControllerGetDesiredSize(readableController);
	      }
	    }]);
	    return TransformStreamDefaultController;
	  }();
	  var TransformStream = function () {
	    function TransformStream() {
	      var transformer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      _classCallCheck(this, TransformStream);
	      this._transformer = transformer;
	      var readableStrategy = transformer.readableStrategy,
	          writableStrategy = transformer.writableStrategy;
	      this._transforming = false;
	      this._errored = false;
	      this._storedError = undefined;
	      this._writableController = undefined;
	      this._readableController = undefined;
	      this._transformStreamController = undefined;
	      this._writableDone = false;
	      this._readableClosed = false;
	      this._backpressure = undefined;
	      this._backpressureChangePromise = undefined;
	      this._backpressureChangePromise_resolve = undefined;
	      this._transformStreamController = new TransformStreamDefaultController(this);
	      var startPromise_resolve = void 0;
	      var startPromise = new Promise(function (resolve) {
	        startPromise_resolve = resolve;
	      });
	      var source = new TransformStreamSource(this, startPromise);
	      this._readable = new ReadableStream(source, readableStrategy);
	      var sink = new TransformStreamSink(this, startPromise);
	      this._writable = new WritableStream(sink, writableStrategy);
	      assert(this._writableController !== undefined);
	      assert(this._readableController !== undefined);
	      var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(this._readableController);
	      TransformStreamSetBackpressure(this, desiredSize <= 0);
	      var transformStream = this;
	      var startResult = InvokeOrNoop(transformer, 'start', [transformStream._transformStreamController]);
	      startPromise_resolve(startResult);
	      startPromise.catch(function (e) {
	        if (transformStream._errored === false) {
	          transformStream._errored = true;
	          transformStream._storedError = e;
	        }
	      });
	    }
	    _createClass(TransformStream, [{
	      key: 'readable',
	      get: function get() {
	        if (IsTransformStream(this) === false) {
	          throw streamBrandCheckException('readable');
	        }
	        return this._readable;
	      }
	    }, {
	      key: 'writable',
	      get: function get() {
	        if (IsTransformStream(this) === false) {
	          throw streamBrandCheckException('writable');
	        }
	        return this._writable;
	      }
	    }]);
	    return TransformStream;
	  }();
	  module.exports = { TransformStream: TransformStream };
	  function defaultControllerBrandCheckException(name) {
	    return new TypeError('TransformStreamDefaultController.prototype.' + name + ' can only be used on a TransformStreamDefaultController');
	  }
	  function streamBrandCheckException(name) {
	    return new TypeError('TransformStream.prototype.' + name + ' can only be used on a TransformStream');
	  }
	}, function (module, exports, __w_pdfjs_require__) {
	  module.exports = __w_pdfjs_require__(5);
	}]));
	
	/***/ }),
	/* 115 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFJS = exports.globalScope = undefined;
	
	var _dom_utils = __w_pdfjs_require__(10);
	
	var _util = __w_pdfjs_require__(0);
	
	var _api = __w_pdfjs_require__(58);
	
	var _annotation_layer = __w_pdfjs_require__(60);
	
	var _global_scope = __w_pdfjs_require__(14);
	
	var _global_scope2 = _interopRequireDefault(_global_scope);
	
	var _metadata = __w_pdfjs_require__(59);
	
	var _text_layer = __w_pdfjs_require__(61);
	
	var _svg = __w_pdfjs_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (!_global_scope2.default.PDFJS) {
	  _global_scope2.default.PDFJS = {};
	}
	var PDFJS = _global_scope2.default.PDFJS;
	{
	  PDFJS.version = '2.0.305';
	  PDFJS.build = '9c6a8801';
	}
	PDFJS.pdfBug = false;
	if (PDFJS.verbosity !== undefined) {
	  (0, _util.setVerbosityLevel)(PDFJS.verbosity);
	}
	delete PDFJS.verbosity;
	Object.defineProperty(PDFJS, 'verbosity', {
	  get: function get() {
	    return (0, _util.getVerbosityLevel)();
	  },
	  set: function set(level) {
	    (0, _util.setVerbosityLevel)(level);
	  },
	
	  enumerable: true,
	  configurable: true
	});
	PDFJS.VERBOSITY_LEVELS = _util.VERBOSITY_LEVELS;
	PDFJS.OPS = _util.OPS;
	PDFJS.UNSUPPORTED_FEATURES = _util.UNSUPPORTED_FEATURES;
	PDFJS.isValidUrl = _dom_utils.isValidUrl;
	PDFJS.shadow = _util.shadow;
	PDFJS.createBlob = _util.createBlob;
	PDFJS.createObjectURL = function PDFJS_createObjectURL(data, contentType) {
	  return (0, _util.createObjectURL)(data, contentType, PDFJS.disableCreateObjectURL);
	};
	Object.defineProperty(PDFJS, 'isLittleEndian', {
	  configurable: true,
	  get: function PDFJS_isLittleEndian() {
	    return (0, _util.shadow)(PDFJS, 'isLittleEndian', (0, _util.isLittleEndian)());
	  }
	});
	PDFJS.removeNullCharacters = _util.removeNullCharacters;
	PDFJS.PasswordResponses = _util.PasswordResponses;
	PDFJS.PasswordException = _util.PasswordException;
	PDFJS.UnknownErrorException = _util.UnknownErrorException;
	PDFJS.InvalidPDFException = _util.InvalidPDFException;
	PDFJS.MissingPDFException = _util.MissingPDFException;
	PDFJS.UnexpectedResponseException = _util.UnexpectedResponseException;
	PDFJS.Util = _util.Util;
	PDFJS.PageViewport = _util.PageViewport;
	PDFJS.createPromiseCapability = _util.createPromiseCapability;
	PDFJS.maxImageSize = PDFJS.maxImageSize === undefined ? -1 : PDFJS.maxImageSize;
	PDFJS.cMapUrl = PDFJS.cMapUrl === undefined ? null : PDFJS.cMapUrl;
	PDFJS.cMapPacked = PDFJS.cMapPacked === undefined ? false : PDFJS.cMapPacked;
	PDFJS.disableFontFace = PDFJS.disableFontFace === undefined ? false : PDFJS.disableFontFace;
	PDFJS.imageResourcesPath = PDFJS.imageResourcesPath === undefined ? '' : PDFJS.imageResourcesPath;
	PDFJS.disableWorker = PDFJS.disableWorker === undefined ? false : PDFJS.disableWorker;
	PDFJS.workerSrc = PDFJS.workerSrc === undefined ? null : PDFJS.workerSrc;
	PDFJS.workerPort = PDFJS.workerPort === undefined ? null : PDFJS.workerPort;
	PDFJS.disableRange = PDFJS.disableRange === undefined ? false : PDFJS.disableRange;
	PDFJS.disableStream = PDFJS.disableStream === undefined ? false : PDFJS.disableStream;
	PDFJS.disableAutoFetch = PDFJS.disableAutoFetch === undefined ? false : PDFJS.disableAutoFetch;
	PDFJS.pdfBug = PDFJS.pdfBug === undefined ? false : PDFJS.pdfBug;
	PDFJS.postMessageTransfers = PDFJS.postMessageTransfers === undefined ? true : PDFJS.postMessageTransfers;
	PDFJS.disableCreateObjectURL = PDFJS.disableCreateObjectURL === undefined ? false : PDFJS.disableCreateObjectURL;
	PDFJS.disableWebGL = PDFJS.disableWebGL === undefined ? true : PDFJS.disableWebGL;
	PDFJS.externalLinkTarget = PDFJS.externalLinkTarget === undefined ? _dom_utils.LinkTarget.NONE : PDFJS.externalLinkTarget;
	PDFJS.externalLinkRel = PDFJS.externalLinkRel === undefined ? _dom_utils.DEFAULT_LINK_REL : PDFJS.externalLinkRel;
	PDFJS.isEvalSupported = PDFJS.isEvalSupported === undefined ? true : PDFJS.isEvalSupported;
	PDFJS.getDocument = _api.getDocument;
	PDFJS.LoopbackPort = _api.LoopbackPort;
	PDFJS.PDFDataRangeTransport = _api.PDFDataRangeTransport;
	PDFJS.PDFWorker = _api.PDFWorker;
	PDFJS.LinkTarget = _dom_utils.LinkTarget;
	PDFJS.addLinkAttributes = _dom_utils.addLinkAttributes;
	PDFJS.getFilenameFromUrl = _dom_utils.getFilenameFromUrl;
	PDFJS.isExternalLinkTargetSet = _dom_utils.isExternalLinkTargetSet;
	PDFJS.AnnotationLayer = _annotation_layer.AnnotationLayer;
	PDFJS.renderTextLayer = _text_layer.renderTextLayer;
	PDFJS.Metadata = _metadata.Metadata;
	PDFJS.SVGGraphics = _svg.SVGGraphics;
	exports.globalScope = _global_scope2.default;
	exports.PDFJS = PDFJS;
	
	/***/ }),
	/* 116 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontLoader = exports.FontFaceObject = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	function FontLoader(docId) {
	  this.docId = docId;
	  this.styleElement = null;
	  this.nativeFontFaces = [];
	  this.loadTestFontId = 0;
	  this.loadingContext = {
	    requests: [],
	    nextRequestId: 0
	  };
	}
	FontLoader.prototype = {
	  insertRule: function fontLoaderInsertRule(rule) {
	    var styleElement = this.styleElement;
	    if (!styleElement) {
	      styleElement = this.styleElement = document.createElement('style');
	      styleElement.id = 'PDFJS_FONT_STYLE_TAG_' + this.docId;
	      document.documentElement.getElementsByTagName('head')[0].appendChild(styleElement);
	    }
	    var styleSheet = styleElement.sheet;
	    styleSheet.insertRule(rule, styleSheet.cssRules.length);
	  },
	  clear: function fontLoaderClear() {
	    if (this.styleElement) {
	      this.styleElement.remove();
	      this.styleElement = null;
	    }
	    this.nativeFontFaces.forEach(function (nativeFontFace) {
	      document.fonts.delete(nativeFontFace);
	    });
	    this.nativeFontFaces.length = 0;
	  }
	};
	{
	  var getLoadTestFont = function getLoadTestFont() {
	    return atob('T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQ' + 'AABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwA' + 'AAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbm' + 'FtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAA' + 'AADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6A' + 'ABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAA' + 'MQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAA' + 'AAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAA' + 'AAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQ' + 'AAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMA' + 'AQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAA' + 'EAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAA' + 'AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAA' + 'AAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgc' + 'A/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWF' + 'hYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQA' + 'AAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAg' + 'ABAAAAAAAAAAAD6AAAAAAAAA==');
	  };
	  Object.defineProperty(FontLoader.prototype, 'loadTestFont', {
	    get: function get() {
	      return (0, _util.shadow)(this, 'loadTestFont', getLoadTestFont());
	    },
	
	    configurable: true
	  });
	  FontLoader.prototype.addNativeFontFace = function fontLoader_addNativeFontFace(nativeFontFace) {
	    this.nativeFontFaces.push(nativeFontFace);
	    document.fonts.add(nativeFontFace);
	  };
	  FontLoader.prototype.bind = function fontLoaderBind(fonts, callback) {
	    var rules = [];
	    var fontsToLoad = [];
	    var fontLoadPromises = [];
	    var getNativeFontPromise = function getNativeFontPromise(nativeFontFace) {
	      return nativeFontFace.loaded.catch(function (e) {
	        (0, _util.warn)('Failed to load font "' + nativeFontFace.family + '": ' + e);
	      });
	    };
	    var isFontLoadingAPISupported = FontLoader.isFontLoadingAPISupported && !FontLoader.isSyncFontLoadingSupported;
	    for (var i = 0, ii = fonts.length; i < ii; i++) {
	      var font = fonts[i];
	      if (font.attached || font.loading === false) {
	        continue;
	      }
	      font.attached = true;
	      if (isFontLoadingAPISupported) {
	        var nativeFontFace = font.createNativeFontFace();
	        if (nativeFontFace) {
	          this.addNativeFontFace(nativeFontFace);
	          fontLoadPromises.push(getNativeFontPromise(nativeFontFace));
	        }
	      } else {
	        var rule = font.createFontFaceRule();
	        if (rule) {
	          this.insertRule(rule);
	          rules.push(rule);
	          fontsToLoad.push(font);
	        }
	      }
	    }
	    var request = this.queueLoadingCallback(callback);
	    if (isFontLoadingAPISupported) {
	      Promise.all(fontLoadPromises).then(function () {
	        request.complete();
	      });
	    } else if (rules.length > 0 && !FontLoader.isSyncFontLoadingSupported) {
	      this.prepareFontLoadEvent(rules, fontsToLoad, request);
	    } else {
	      request.complete();
	    }
	  };
	  FontLoader.prototype.queueLoadingCallback = function FontLoader_queueLoadingCallback(callback) {
	    function LoadLoader_completeRequest() {
	      (0, _util.assert)(!request.end, 'completeRequest() cannot be called twice');
	      request.end = Date.now();
	      while (context.requests.length > 0 && context.requests[0].end) {
	        var otherRequest = context.requests.shift();
	        setTimeout(otherRequest.callback, 0);
	      }
	    }
	    var context = this.loadingContext;
	    var requestId = 'pdfjs-font-loading-' + context.nextRequestId++;
	    var request = {
	      id: requestId,
	      complete: LoadLoader_completeRequest,
	      callback: callback,
	      started: Date.now()
	    };
	    context.requests.push(request);
	    return request;
	  };
	  FontLoader.prototype.prepareFontLoadEvent = function fontLoaderPrepareFontLoadEvent(rules, fonts, request) {
	    function int32(data, offset) {
	      return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
	    }
	    function spliceString(s, offset, remove, insert) {
	      var chunk1 = s.substr(0, offset);
	      var chunk2 = s.substr(offset + remove);
	      return chunk1 + insert + chunk2;
	    }
	    var i, ii;
	    var canvas = document.createElement('canvas');
	    canvas.width = 1;
	    canvas.height = 1;
	    var ctx = canvas.getContext('2d');
	    var called = 0;
	    function isFontReady(name, callback) {
	      called++;
	      if (called > 30) {
	        (0, _util.warn)('Load test font never loaded.');
	        callback();
	        return;
	      }
	      ctx.font = '30px ' + name;
	      ctx.fillText('.', 0, 20);
	      var imageData = ctx.getImageData(0, 0, 1, 1);
	      if (imageData.data[3] > 0) {
	        callback();
	        return;
	      }
	      setTimeout(isFontReady.bind(null, name, callback));
	    }
	    var loadTestFontId = 'lt' + Date.now() + this.loadTestFontId++;
	    var data = this.loadTestFont;
	    var COMMENT_OFFSET = 976;
	    data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
	    var CFF_CHECKSUM_OFFSET = 16;
	    var XXXX_VALUE = 0x58585858;
	    var checksum = int32(data, CFF_CHECKSUM_OFFSET);
	    for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
	      checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
	    }
	    if (i < loadTestFontId.length) {
	      checksum = checksum - XXXX_VALUE + int32(loadTestFontId + 'XXX', i) | 0;
	    }
	    data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
	    var url = 'url(data:font/opentype;base64,' + btoa(data) + ');';
	    var rule = '@font-face { font-family:"' + loadTestFontId + '";src:' + url + '}';
	    this.insertRule(rule);
	    var names = [];
	    for (i = 0, ii = fonts.length; i < ii; i++) {
	      names.push(fonts[i].loadedName);
	    }
	    names.push(loadTestFontId);
	    var div = document.createElement('div');
	    div.setAttribute('style', 'visibility: hidden;' + 'width: 10px; height: 10px;' + 'position: absolute; top: 0px; left: 0px;');
	    for (i = 0, ii = names.length; i < ii; ++i) {
	      var span = document.createElement('span');
	      span.textContent = 'Hi';
	      span.style.fontFamily = names[i];
	      div.appendChild(span);
	    }
	    document.body.appendChild(div);
	    isFontReady(loadTestFontId, function () {
	      document.body.removeChild(div);
	      request.complete();
	    });
	  };
	}
	{
	  FontLoader.isFontLoadingAPISupported = typeof document !== 'undefined' && !!document.fonts;
	}
	{
	  var isSyncFontLoadingSupported = function isSyncFontLoadingSupported() {
	    if (typeof navigator === 'undefined') {
	      return true;
	    }
	    var supported = false;
	    var m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
	    if (m && m[1] >= 14) {
	      supported = true;
	    }
	    return supported;
	  };
	  Object.defineProperty(FontLoader, 'isSyncFontLoadingSupported', {
	    get: function get() {
	      return (0, _util.shadow)(FontLoader, 'isSyncFontLoadingSupported', isSyncFontLoadingSupported());
	    },
	
	    enumerable: true,
	    configurable: true
	  });
	}
	var IsEvalSupportedCached = {
	  get value() {
	    return (0, _util.shadow)(this, 'value', (0, _util.isEvalSupported)());
	  }
	};
	var FontFaceObject = function FontFaceObjectClosure() {
	  function FontFaceObject(translatedData, options) {
	    this.compiledGlyphs = Object.create(null);
	    for (var i in translatedData) {
	      this[i] = translatedData[i];
	    }
	    this.options = options;
	  }
	  FontFaceObject.prototype = {
	    createNativeFontFace: function FontFaceObject_createNativeFontFace() {
	      if (!this.data) {
	        return null;
	      }
	      if (this.options.disableFontFace) {
	        this.disableFontFace = true;
	        return null;
	      }
	      var nativeFontFace = new FontFace(this.loadedName, this.data, {});
	      if (this.options.fontRegistry) {
	        this.options.fontRegistry.registerFont(this);
	      }
	      return nativeFontFace;
	    },
	    createFontFaceRule: function FontFaceObject_createFontFaceRule() {
	      if (!this.data) {
	        return null;
	      }
	      if (this.options.disableFontFace) {
	        this.disableFontFace = true;
	        return null;
	      }
	      var data = (0, _util.bytesToString)(new Uint8Array(this.data));
	      var fontName = this.loadedName;
	      var url = 'url(data:' + this.mimetype + ';base64,' + btoa(data) + ');';
	      var rule = '@font-face { font-family:"' + fontName + '";src:' + url + '}';
	      if (this.options.fontRegistry) {
	        this.options.fontRegistry.registerFont(this, url);
	      }
	      return rule;
	    },
	    getPathGenerator: function FontFaceObject_getPathGenerator(objs, character) {
	      if (!(character in this.compiledGlyphs)) {
	        var cmds = objs.get(this.loadedName + '_path_' + character);
	        var current, i, len;
	        if (this.options.isEvalSupported && IsEvalSupportedCached.value) {
	          var args,
	              js = '';
	          for (i = 0, len = cmds.length; i < len; i++) {
	            current = cmds[i];
	            if (current.args !== undefined) {
	              args = current.args.join(',');
	            } else {
	              args = '';
	            }
	            js += 'c.' + current.cmd + '(' + args + ');\n';
	          }
	          this.compiledGlyphs[character] = new Function('c', 'size', js);
	        } else {
	          this.compiledGlyphs[character] = function (c, size) {
	            for (i = 0, len = cmds.length; i < len; i++) {
	              current = cmds[i];
	              if (current.cmd === 'scale') {
	                current.args = [size, -size];
	              }
	              c[current.cmd].apply(c, current.args);
	            }
	          };
	        }
	      }
	      return this.compiledGlyphs[character];
	    }
	  };
	  return FontFaceObject;
	}();
	exports.FontFaceObject = FontFaceObject;
	exports.FontLoader = FontLoader;
	
	/***/ }),
	/* 117 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CanvasGraphics = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _pattern_helper = __w_pdfjs_require__(118);
	
	var MIN_FONT_SIZE = 16;
	var MAX_FONT_SIZE = 100;
	var MAX_GROUP_SIZE = 4096;
	var MIN_WIDTH_FACTOR = 0.65;
	var COMPILE_TYPE3_GLYPHS = true;
	var MAX_SIZE_TO_COMPILE = 1000;
	var FULL_CHUNK_HEIGHT = 16;
	var IsLittleEndianCached = {
	  get value() {
	    return (0, _util.shadow)(IsLittleEndianCached, 'value', (0, _util.isLittleEndian)());
	  }
	};
	function addContextCurrentTransform(ctx) {
	  if (!ctx.mozCurrentTransform) {
	    ctx._originalSave = ctx.save;
	    ctx._originalRestore = ctx.restore;
	    ctx._originalRotate = ctx.rotate;
	    ctx._originalScale = ctx.scale;
	    ctx._originalTranslate = ctx.translate;
	    ctx._originalTransform = ctx.transform;
	    ctx._originalSetTransform = ctx.setTransform;
	    ctx._transformMatrix = ctx._transformMatrix || [1, 0, 0, 1, 0, 0];
	    ctx._transformStack = [];
	    Object.defineProperty(ctx, 'mozCurrentTransform', {
	      get: function getCurrentTransform() {
	        return this._transformMatrix;
	      }
	    });
	    Object.defineProperty(ctx, 'mozCurrentTransformInverse', {
	      get: function getCurrentTransformInverse() {
	        var m = this._transformMatrix;
	        var a = m[0],
	            b = m[1],
	            c = m[2],
	            d = m[3],
	            e = m[4],
	            f = m[5];
	        var ad_bc = a * d - b * c;
	        var bc_ad = b * c - a * d;
	        return [d / ad_bc, b / bc_ad, c / bc_ad, a / ad_bc, (d * e - c * f) / bc_ad, (b * e - a * f) / ad_bc];
	      }
	    });
	    ctx.save = function ctxSave() {
	      var old = this._transformMatrix;
	      this._transformStack.push(old);
	      this._transformMatrix = old.slice(0, 6);
	      this._originalSave();
	    };
	    ctx.restore = function ctxRestore() {
	      var prev = this._transformStack.pop();
	      if (prev) {
	        this._transformMatrix = prev;
	        this._originalRestore();
	      }
	    };
	    ctx.translate = function ctxTranslate(x, y) {
	      var m = this._transformMatrix;
	      m[4] = m[0] * x + m[2] * y + m[4];
	      m[5] = m[1] * x + m[3] * y + m[5];
	      this._originalTranslate(x, y);
	    };
	    ctx.scale = function ctxScale(x, y) {
	      var m = this._transformMatrix;
	      m[0] = m[0] * x;
	      m[1] = m[1] * x;
	      m[2] = m[2] * y;
	      m[3] = m[3] * y;
	      this._originalScale(x, y);
	    };
	    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
	      var m = this._transformMatrix;
	      this._transformMatrix = [m[0] * a + m[2] * b, m[1] * a + m[3] * b, m[0] * c + m[2] * d, m[1] * c + m[3] * d, m[0] * e + m[2] * f + m[4], m[1] * e + m[3] * f + m[5]];
	      ctx._originalTransform(a, b, c, d, e, f);
	    };
	    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
	      this._transformMatrix = [a, b, c, d, e, f];
	      ctx._originalSetTransform(a, b, c, d, e, f);
	    };
	    ctx.rotate = function ctxRotate(angle) {
	      var cosValue = Math.cos(angle);
	      var sinValue = Math.sin(angle);
	      var m = this._transformMatrix;
	      this._transformMatrix = [m[0] * cosValue + m[2] * sinValue, m[1] * cosValue + m[3] * sinValue, m[0] * -sinValue + m[2] * cosValue, m[1] * -sinValue + m[3] * cosValue, m[4], m[5]];
	      this._originalRotate(angle);
	    };
	  }
	}
	var CachedCanvases = function CachedCanvasesClosure() {
	  function CachedCanvases(canvasFactory) {
	    this.canvasFactory = canvasFactory;
	    this.cache = Object.create(null);
	  }
	  CachedCanvases.prototype = {
	    getCanvas: function CachedCanvases_getCanvas(id, width, height, trackTransform) {
	      var canvasEntry;
	      if (this.cache[id] !== undefined) {
	        canvasEntry = this.cache[id];
	        this.canvasFactory.reset(canvasEntry, width, height);
	        canvasEntry.context.setTransform(1, 0, 0, 1, 0, 0);
	      } else {
	        canvasEntry = this.canvasFactory.create(width, height);
	        this.cache[id] = canvasEntry;
	      }
	      if (trackTransform) {
	        addContextCurrentTransform(canvasEntry.context);
	      }
	      return canvasEntry;
	    },
	    clear: function clear() {
	      for (var id in this.cache) {
	        var canvasEntry = this.cache[id];
	        this.canvasFactory.destroy(canvasEntry);
	        delete this.cache[id];
	      }
	    }
	  };
	  return CachedCanvases;
	}();
	function compileType3Glyph(imgData) {
	  var POINT_TO_PROCESS_LIMIT = 1000;
	  var width = imgData.width,
	      height = imgData.height;
	  var i,
	      j,
	      j0,
	      width1 = width + 1;
	  var points = new Uint8Array(width1 * (height + 1));
	  var POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
	  var lineSize = width + 7 & ~7,
	      data0 = imgData.data;
	  var data = new Uint8Array(lineSize * height),
	      pos = 0,
	      ii;
	  for (i = 0, ii = data0.length; i < ii; i++) {
	    var mask = 128,
	        elem = data0[i];
	    while (mask > 0) {
	      data[pos++] = elem & mask ? 0 : 255;
	      mask >>= 1;
	    }
	  }
	  var count = 0;
	  pos = 0;
	  if (data[pos] !== 0) {
	    points[0] = 1;
	    ++count;
	  }
	  for (j = 1; j < width; j++) {
	    if (data[pos] !== data[pos + 1]) {
	      points[j] = data[pos] ? 2 : 1;
	      ++count;
	    }
	    pos++;
	  }
	  if (data[pos] !== 0) {
	    points[j] = 2;
	    ++count;
	  }
	  for (i = 1; i < height; i++) {
	    pos = i * lineSize;
	    j0 = i * width1;
	    if (data[pos - lineSize] !== data[pos]) {
	      points[j0] = data[pos] ? 1 : 8;
	      ++count;
	    }
	    var sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
	    for (j = 1; j < width; j++) {
	      sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
	      if (POINT_TYPES[sum]) {
	        points[j0 + j] = POINT_TYPES[sum];
	        ++count;
	      }
	      pos++;
	    }
	    if (data[pos - lineSize] !== data[pos]) {
	      points[j0 + j] = data[pos] ? 2 : 4;
	      ++count;
	    }
	    if (count > POINT_TO_PROCESS_LIMIT) {
	      return null;
	    }
	  }
	  pos = lineSize * (height - 1);
	  j0 = i * width1;
	  if (data[pos] !== 0) {
	    points[j0] = 8;
	    ++count;
	  }
	  for (j = 1; j < width; j++) {
	    if (data[pos] !== data[pos + 1]) {
	      points[j0 + j] = data[pos] ? 4 : 8;
	      ++count;
	    }
	    pos++;
	  }
	  if (data[pos] !== 0) {
	    points[j0 + j] = 4;
	    ++count;
	  }
	  if (count > POINT_TO_PROCESS_LIMIT) {
	    return null;
	  }
	  var steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
	  var outlines = [];
	  for (i = 0; count && i <= height; i++) {
	    var p = i * width1;
	    var end = p + width;
	    while (p < end && !points[p]) {
	      p++;
	    }
	    if (p === end) {
	      continue;
	    }
	    var coords = [p % width1, i];
	    var type = points[p],
	        p0 = p,
	        pp;
	    do {
	      var step = steps[type];
	      do {
	        p += step;
	      } while (!points[p]);
	      pp = points[p];
	      if (pp !== 5 && pp !== 10) {
	        type = pp;
	        points[p] = 0;
	      } else {
	        type = pp & 0x33 * type >> 4;
	        points[p] &= type >> 2 | type << 2;
	      }
	      coords.push(p % width1);
	      coords.push(p / width1 | 0);
	      --count;
	    } while (p0 !== p);
	    outlines.push(coords);
	    --i;
	  }
	  var drawOutline = function drawOutline(c) {
	    c.save();
	    c.scale(1 / width, -1 / height);
	    c.translate(0, -height);
	    c.beginPath();
	    for (var i = 0, ii = outlines.length; i < ii; i++) {
	      var o = outlines[i];
	      c.moveTo(o[0], o[1]);
	      for (var j = 2, jj = o.length; j < jj; j += 2) {
	        c.lineTo(o[j], o[j + 1]);
	      }
	    }
	    c.fill();
	    c.beginPath();
	    c.restore();
	  };
	  return drawOutline;
	}
	var CanvasExtraState = function CanvasExtraStateClosure() {
	  function CanvasExtraState() {
	    this.alphaIsShape = false;
	    this.fontSize = 0;
	    this.fontSizeScale = 1;
	    this.textMatrix = _util.IDENTITY_MATRIX;
	    this.textMatrixScale = 1;
	    this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
	    this.leading = 0;
	    this.x = 0;
	    this.y = 0;
	    this.lineX = 0;
	    this.lineY = 0;
	    this.charSpacing = 0;
	    this.wordSpacing = 0;
	    this.textHScale = 1;
	    this.textRenderingMode = _util.TextRenderingMode.FILL;
	    this.textRise = 0;
	    this.fillColor = '#000000';
	    this.strokeColor = '#000000';
	    this.patternFill = false;
	    this.fillAlpha = 1;
	    this.strokeAlpha = 1;
	    this.lineWidth = 1;
	    this.activeSMask = null;
	    this.resumeSMaskCtx = null;
	  }
	  CanvasExtraState.prototype = {
	    clone: function CanvasExtraState_clone() {
	      return Object.create(this);
	    },
	    setCurrentPoint: function CanvasExtraState_setCurrentPoint(x, y) {
	      this.x = x;
	      this.y = y;
	    }
	  };
	  return CanvasExtraState;
	}();
	var CanvasGraphics = function CanvasGraphicsClosure() {
	  var EXECUTION_TIME = 15;
	  var EXECUTION_STEPS = 10;
	  function CanvasGraphics(canvasCtx, commonObjs, objs, canvasFactory, webGLContext, imageLayer) {
	    this.ctx = canvasCtx;
	    this.current = new CanvasExtraState();
	    this.stateStack = [];
	    this.pendingClip = null;
	    this.pendingEOFill = false;
	    this.res = null;
	    this.xobjs = null;
	    this.commonObjs = commonObjs;
	    this.objs = objs;
	    this.canvasFactory = canvasFactory;
	    this.webGLContext = webGLContext;
	    this.imageLayer = imageLayer;
	    this.groupStack = [];
	    this.processingType3 = null;
	    this.baseTransform = null;
	    this.baseTransformStack = [];
	    this.groupLevel = 0;
	    this.smaskStack = [];
	    this.smaskCounter = 0;
	    this.tempSMask = null;
	    this.cachedCanvases = new CachedCanvases(this.canvasFactory);
	    if (canvasCtx) {
	      addContextCurrentTransform(canvasCtx);
	    }
	    this.cachedGetSinglePixelWidth = null;
	  }
	  function putBinaryImageData(ctx, imgData) {
	    if (typeof ImageData !== 'undefined' && imgData instanceof ImageData) {
	      ctx.putImageData(imgData, 0, 0);
	      return;
	    }
	    var height = imgData.height,
	        width = imgData.width;
	    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
	    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
	    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
	    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
	    var srcPos = 0,
	        destPos;
	    var src = imgData.data;
	    var dest = chunkImgData.data;
	    var i, j, thisChunkHeight, elemsInThisChunk;
	    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
	      var srcLength = src.byteLength;
	      var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
	      var dest32DataLength = dest32.length;
	      var fullSrcDiff = width + 7 >> 3;
	      var white = 0xFFFFFFFF;
	      var black = IsLittleEndianCached.value ? 0xFF000000 : 0x000000FF;
	      for (i = 0; i < totalChunks; i++) {
	        thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
	        destPos = 0;
	        for (j = 0; j < thisChunkHeight; j++) {
	          var srcDiff = srcLength - srcPos;
	          var k = 0;
	          var kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
	          var kEndUnrolled = kEnd & ~7;
	          var mask = 0;
	          var srcByte = 0;
	          for (; k < kEndUnrolled; k += 8) {
	            srcByte = src[srcPos++];
	            dest32[destPos++] = srcByte & 128 ? white : black;
	            dest32[destPos++] = srcByte & 64 ? white : black;
	            dest32[destPos++] = srcByte & 32 ? white : black;
	            dest32[destPos++] = srcByte & 16 ? white : black;
	            dest32[destPos++] = srcByte & 8 ? white : black;
	            dest32[destPos++] = srcByte & 4 ? white : black;
	            dest32[destPos++] = srcByte & 2 ? white : black;
	            dest32[destPos++] = srcByte & 1 ? white : black;
	          }
	          for (; k < kEnd; k++) {
	            if (mask === 0) {
	              srcByte = src[srcPos++];
	              mask = 128;
	            }
	            dest32[destPos++] = srcByte & mask ? white : black;
	            mask >>= 1;
	          }
	        }
	        while (destPos < dest32DataLength) {
	          dest32[destPos++] = 0;
	        }
	        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
	      }
	    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
	      j = 0;
	      elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
	      for (i = 0; i < fullChunks; i++) {
	        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
	        srcPos += elemsInThisChunk;
	        ctx.putImageData(chunkImgData, 0, j);
	        j += FULL_CHUNK_HEIGHT;
	      }
	      if (i < totalChunks) {
	        elemsInThisChunk = width * partialChunkHeight * 4;
	        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
	        ctx.putImageData(chunkImgData, 0, j);
	      }
	    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
	      thisChunkHeight = FULL_CHUNK_HEIGHT;
	      elemsInThisChunk = width * thisChunkHeight;
	      for (i = 0; i < totalChunks; i++) {
	        if (i >= fullChunks) {
	          thisChunkHeight = partialChunkHeight;
	          elemsInThisChunk = width * thisChunkHeight;
	        }
	        destPos = 0;
	        for (j = elemsInThisChunk; j--;) {
	          dest[destPos++] = src[srcPos++];
	          dest[destPos++] = src[srcPos++];
	          dest[destPos++] = src[srcPos++];
	          dest[destPos++] = 255;
	        }
	        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
	      }
	    } else {
	      throw new Error('bad image kind: ' + imgData.kind);
	    }
	  }
	  function putBinaryImageMask(ctx, imgData) {
	    var height = imgData.height,
	        width = imgData.width;
	    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
	    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
	    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
	    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
	    var srcPos = 0;
	    var src = imgData.data;
	    var dest = chunkImgData.data;
	    for (var i = 0; i < totalChunks; i++) {
	      var thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
	      var destPos = 3;
	      for (var j = 0; j < thisChunkHeight; j++) {
	        var mask = 0;
	        for (var k = 0; k < width; k++) {
	          if (!mask) {
	            var elem = src[srcPos++];
	            mask = 128;
	          }
	          dest[destPos] = elem & mask ? 0 : 255;
	          destPos += 4;
	          mask >>= 1;
	        }
	      }
	      ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
	    }
	  }
	  function copyCtxState(sourceCtx, destCtx) {
	    var properties = ['strokeStyle', 'fillStyle', 'fillRule', 'globalAlpha', 'lineWidth', 'lineCap', 'lineJoin', 'miterLimit', 'globalCompositeOperation', 'font'];
	    for (var i = 0, ii = properties.length; i < ii; i++) {
	      var property = properties[i];
	      if (sourceCtx[property] !== undefined) {
	        destCtx[property] = sourceCtx[property];
	      }
	    }
	    if (sourceCtx.setLineDash !== undefined) {
	      destCtx.setLineDash(sourceCtx.getLineDash());
	      destCtx.lineDashOffset = sourceCtx.lineDashOffset;
	    }
	  }
	  function resetCtxToDefault(ctx) {
	    ctx.strokeStyle = '#000000';
	    ctx.fillStyle = '#000000';
	    ctx.fillRule = 'nonzero';
	    ctx.globalAlpha = 1;
	    ctx.lineWidth = 1;
	    ctx.lineCap = 'butt';
	    ctx.lineJoin = 'miter';
	    ctx.miterLimit = 10;
	    ctx.globalCompositeOperation = 'source-over';
	    ctx.font = '10px sans-serif';
	    if (ctx.setLineDash !== undefined) {
	      ctx.setLineDash([]);
	      ctx.lineDashOffset = 0;
	    }
	  }
	  function composeSMaskBackdrop(bytes, r0, g0, b0) {
	    var length = bytes.length;
	    for (var i = 3; i < length; i += 4) {
	      var alpha = bytes[i];
	      if (alpha === 0) {
	        bytes[i - 3] = r0;
	        bytes[i - 2] = g0;
	        bytes[i - 1] = b0;
	      } else if (alpha < 255) {
	        var alpha_ = 255 - alpha;
	        bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
	        bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
	        bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
	      }
	    }
	  }
	  function composeSMaskAlpha(maskData, layerData, transferMap) {
	    var length = maskData.length;
	    var scale = 1 / 255;
	    for (var i = 3; i < length; i += 4) {
	      var alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
	      layerData[i] = layerData[i] * alpha * scale | 0;
	    }
	  }
	  function composeSMaskLuminosity(maskData, layerData, transferMap) {
	    var length = maskData.length;
	    for (var i = 3; i < length; i += 4) {
	      var y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
	      layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
	    }
	  }
	  function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap) {
	    var hasBackdrop = !!backdrop;
	    var r0 = hasBackdrop ? backdrop[0] : 0;
	    var g0 = hasBackdrop ? backdrop[1] : 0;
	    var b0 = hasBackdrop ? backdrop[2] : 0;
	    var composeFn;
	    if (subtype === 'Luminosity') {
	      composeFn = composeSMaskLuminosity;
	    } else {
	      composeFn = composeSMaskAlpha;
	    }
	    var PIXELS_TO_PROCESS = 1048576;
	    var chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
	    for (var row = 0; row < height; row += chunkSize) {
	      var chunkHeight = Math.min(chunkSize, height - row);
	      var maskData = maskCtx.getImageData(0, row, width, chunkHeight);
	      var layerData = layerCtx.getImageData(0, row, width, chunkHeight);
	      if (hasBackdrop) {
	        composeSMaskBackdrop(maskData.data, r0, g0, b0);
	      }
	      composeFn(maskData.data, layerData.data, transferMap);
	      maskCtx.putImageData(layerData, 0, row);
	    }
	  }
	  function composeSMask(ctx, smask, layerCtx, webGLContext) {
	    var mask = smask.canvas;
	    var maskCtx = smask.context;
	    ctx.setTransform(smask.scaleX, 0, 0, smask.scaleY, smask.offsetX, smask.offsetY);
	    var backdrop = smask.backdrop || null;
	    if (!smask.transferMap && webGLContext.isEnabled) {
	      var composed = webGLContext.composeSMask({
	        layer: layerCtx.canvas,
	        mask: mask,
	        properties: {
	          subtype: smask.subtype,
	          backdrop: backdrop
	        }
	      });
	      ctx.setTransform(1, 0, 0, 1, 0, 0);
	      ctx.drawImage(composed, smask.offsetX, smask.offsetY);
	      return;
	    }
	    genericComposeSMask(maskCtx, layerCtx, mask.width, mask.height, smask.subtype, backdrop, smask.transferMap);
	    ctx.drawImage(mask, 0, 0);
	  }
	  var LINE_CAP_STYLES = ['butt', 'round', 'square'];
	  var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
	  var NORMAL_CLIP = {};
	  var EO_CLIP = {};
	  CanvasGraphics.prototype = {
	    beginDrawing: function beginDrawing(_ref) {
	      var transform = _ref.transform,
	          viewport = _ref.viewport,
	          transparency = _ref.transparency,
	          _ref$background = _ref.background,
	          background = _ref$background === undefined ? null : _ref$background;
	
	      var width = this.ctx.canvas.width;
	      var height = this.ctx.canvas.height;
	      this.ctx.save();
	      this.ctx.fillStyle = background || 'rgb(255, 255, 255)';
	      this.ctx.fillRect(0, 0, width, height);
	      this.ctx.restore();
	      if (transparency) {
	        var transparentCanvas = this.cachedCanvases.getCanvas('transparent', width, height, true);
	        this.compositeCtx = this.ctx;
	        this.transparentCanvas = transparentCanvas.canvas;
	        this.ctx = transparentCanvas.context;
	        this.ctx.save();
	        this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
	      }
	      this.ctx.save();
	      resetCtxToDefault(this.ctx);
	      if (transform) {
	        this.ctx.transform.apply(this.ctx, transform);
	      }
	      this.ctx.transform.apply(this.ctx, viewport.transform);
	      this.baseTransform = this.ctx.mozCurrentTransform.slice();
	      if (this.imageLayer) {
	        this.imageLayer.beginLayout();
	      }
	    },
	
	    executeOperatorList: function CanvasGraphics_executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
	      var argsArray = operatorList.argsArray;
	      var fnArray = operatorList.fnArray;
	      var i = executionStartIdx || 0;
	      var argsArrayLen = argsArray.length;
	      if (argsArrayLen === i) {
	        return i;
	      }
	      var chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === 'function';
	      var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
	      var steps = 0;
	      var commonObjs = this.commonObjs;
	      var objs = this.objs;
	      var fnId;
	      while (true) {
	        if (stepper !== undefined && i === stepper.nextBreakPoint) {
	          stepper.breakIt(i, continueCallback);
	          return i;
	        }
	        fnId = fnArray[i];
	        if (fnId !== _util.OPS.dependency) {
	          this[fnId].apply(this, argsArray[i]);
	        } else {
	          var deps = argsArray[i];
	          for (var n = 0, nn = deps.length; n < nn; n++) {
	            var depObjId = deps[n];
	            var common = depObjId[0] === 'g' && depObjId[1] === '_';
	            var objsPool = common ? commonObjs : objs;
	            if (!objsPool.isResolved(depObjId)) {
	              objsPool.get(depObjId, continueCallback);
	              return i;
	            }
	          }
	        }
	        i++;
	        if (i === argsArrayLen) {
	          return i;
	        }
	        if (chunkOperations && ++steps > EXECUTION_STEPS) {
	          if (Date.now() > endTime) {
	            continueCallback();
	            return i;
	          }
	          steps = 0;
	        }
	      }
	    },
	    endDrawing: function CanvasGraphics_endDrawing() {
	      if (this.current.activeSMask !== null) {
	        this.endSMaskGroup();
	      }
	      this.ctx.restore();
	      if (this.transparentCanvas) {
	        this.ctx = this.compositeCtx;
	        this.ctx.save();
	        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
	        this.ctx.drawImage(this.transparentCanvas, 0, 0);
	        this.ctx.restore();
	        this.transparentCanvas = null;
	      }
	      this.cachedCanvases.clear();
	      this.webGLContext.clear();
	      if (this.imageLayer) {
	        this.imageLayer.endLayout();
	      }
	    },
	    setLineWidth: function CanvasGraphics_setLineWidth(width) {
	      this.current.lineWidth = width;
	      this.ctx.lineWidth = width;
	    },
	    setLineCap: function CanvasGraphics_setLineCap(style) {
	      this.ctx.lineCap = LINE_CAP_STYLES[style];
	    },
	    setLineJoin: function CanvasGraphics_setLineJoin(style) {
	      this.ctx.lineJoin = LINE_JOIN_STYLES[style];
	    },
	    setMiterLimit: function CanvasGraphics_setMiterLimit(limit) {
	      this.ctx.miterLimit = limit;
	    },
	    setDash: function CanvasGraphics_setDash(dashArray, dashPhase) {
	      var ctx = this.ctx;
	      if (ctx.setLineDash !== undefined) {
	        ctx.setLineDash(dashArray);
	        ctx.lineDashOffset = dashPhase;
	      }
	    },
	    setRenderingIntent: function CanvasGraphics_setRenderingIntent(intent) {},
	    setFlatness: function CanvasGraphics_setFlatness(flatness) {},
	    setGState: function CanvasGraphics_setGState(states) {
	      for (var i = 0, ii = states.length; i < ii; i++) {
	        var state = states[i];
	        var key = state[0];
	        var value = state[1];
	        switch (key) {
	          case 'LW':
	            this.setLineWidth(value);
	            break;
	          case 'LC':
	            this.setLineCap(value);
	            break;
	          case 'LJ':
	            this.setLineJoin(value);
	            break;
	          case 'ML':
	            this.setMiterLimit(value);
	            break;
	          case 'D':
	            this.setDash(value[0], value[1]);
	            break;
	          case 'RI':
	            this.setRenderingIntent(value);
	            break;
	          case 'FL':
	            this.setFlatness(value);
	            break;
	          case 'Font':
	            this.setFont(value[0], value[1]);
	            break;
	          case 'CA':
	            this.current.strokeAlpha = state[1];
	            break;
	          case 'ca':
	            this.current.fillAlpha = state[1];
	            this.ctx.globalAlpha = state[1];
	            break;
	          case 'BM':
	            this.ctx.globalCompositeOperation = value;
	            break;
	          case 'SMask':
	            if (this.current.activeSMask) {
	              if (this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask) {
	                this.suspendSMaskGroup();
	              } else {
	                this.endSMaskGroup();
	              }
	            }
	            this.current.activeSMask = value ? this.tempSMask : null;
	            if (this.current.activeSMask) {
	              this.beginSMaskGroup();
	            }
	            this.tempSMask = null;
	            break;
	        }
	      }
	    },
	    beginSMaskGroup: function CanvasGraphics_beginSMaskGroup() {
	      var activeSMask = this.current.activeSMask;
	      var drawnWidth = activeSMask.canvas.width;
	      var drawnHeight = activeSMask.canvas.height;
	      var cacheId = 'smaskGroupAt' + this.groupLevel;
	      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
	      var currentCtx = this.ctx;
	      var currentTransform = currentCtx.mozCurrentTransform;
	      this.ctx.save();
	      var groupCtx = scratchCanvas.context;
	      groupCtx.scale(1 / activeSMask.scaleX, 1 / activeSMask.scaleY);
	      groupCtx.translate(-activeSMask.offsetX, -activeSMask.offsetY);
	      groupCtx.transform.apply(groupCtx, currentTransform);
	      activeSMask.startTransformInverse = groupCtx.mozCurrentTransformInverse;
	      copyCtxState(currentCtx, groupCtx);
	      this.ctx = groupCtx;
	      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
	      this.groupStack.push(currentCtx);
	      this.groupLevel++;
	    },
	    suspendSMaskGroup: function CanvasGraphics_endSMaskGroup() {
	      var groupCtx = this.ctx;
	      this.groupLevel--;
	      this.ctx = this.groupStack.pop();
	      composeSMask(this.ctx, this.current.activeSMask, groupCtx, this.webGLContext);
	      this.ctx.restore();
	      this.ctx.save();
	      copyCtxState(groupCtx, this.ctx);
	      this.current.resumeSMaskCtx = groupCtx;
	      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
	      this.ctx.transform.apply(this.ctx, deltaTransform);
	      groupCtx.save();
	      groupCtx.setTransform(1, 0, 0, 1, 0, 0);
	      groupCtx.clearRect(0, 0, groupCtx.canvas.width, groupCtx.canvas.height);
	      groupCtx.restore();
	    },
	    resumeSMaskGroup: function CanvasGraphics_endSMaskGroup() {
	      var groupCtx = this.current.resumeSMaskCtx;
	      var currentCtx = this.ctx;
	      this.ctx = groupCtx;
	      this.groupStack.push(currentCtx);
	      this.groupLevel++;
	    },
	    endSMaskGroup: function CanvasGraphics_endSMaskGroup() {
	      var groupCtx = this.ctx;
	      this.groupLevel--;
	      this.ctx = this.groupStack.pop();
	      composeSMask(this.ctx, this.current.activeSMask, groupCtx, this.webGLContext);
	      this.ctx.restore();
	      copyCtxState(groupCtx, this.ctx);
	      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
	      this.ctx.transform.apply(this.ctx, deltaTransform);
	    },
	    save: function CanvasGraphics_save() {
	      this.ctx.save();
	      var old = this.current;
	      this.stateStack.push(old);
	      this.current = old.clone();
	      this.current.resumeSMaskCtx = null;
	    },
	    restore: function CanvasGraphics_restore() {
	      if (this.current.resumeSMaskCtx) {
	        this.resumeSMaskGroup();
	      }
	      if (this.current.activeSMask !== null && (this.stateStack.length === 0 || this.stateStack[this.stateStack.length - 1].activeSMask !== this.current.activeSMask)) {
	        this.endSMaskGroup();
	      }
	      if (this.stateStack.length !== 0) {
	        this.current = this.stateStack.pop();
	        this.ctx.restore();
	        this.pendingClip = null;
	        this.cachedGetSinglePixelWidth = null;
	      }
	    },
	    transform: function CanvasGraphics_transform(a, b, c, d, e, f) {
	      this.ctx.transform(a, b, c, d, e, f);
	      this.cachedGetSinglePixelWidth = null;
	    },
	    constructPath: function CanvasGraphics_constructPath(ops, args) {
	      var ctx = this.ctx;
	      var current = this.current;
	      var x = current.x,
	          y = current.y;
	      for (var i = 0, j = 0, ii = ops.length; i < ii; i++) {
	        switch (ops[i] | 0) {
	          case _util.OPS.rectangle:
	            x = args[j++];
	            y = args[j++];
	            var width = args[j++];
	            var height = args[j++];
	            if (width === 0) {
	              width = this.getSinglePixelWidth();
	            }
	            if (height === 0) {
	              height = this.getSinglePixelWidth();
	            }
	            var xw = x + width;
	            var yh = y + height;
	            this.ctx.moveTo(x, y);
	            this.ctx.lineTo(xw, y);
	            this.ctx.lineTo(xw, yh);
	            this.ctx.lineTo(x, yh);
	            this.ctx.lineTo(x, y);
	            this.ctx.closePath();
	            break;
	          case _util.OPS.moveTo:
	            x = args[j++];
	            y = args[j++];
	            ctx.moveTo(x, y);
	            break;
	          case _util.OPS.lineTo:
	            x = args[j++];
	            y = args[j++];
	            ctx.lineTo(x, y);
	            break;
	          case _util.OPS.curveTo:
	            x = args[j + 4];
	            y = args[j + 5];
	            ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
	            j += 6;
	            break;
	          case _util.OPS.curveTo2:
	            ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
	            x = args[j + 2];
	            y = args[j + 3];
	            j += 4;
	            break;
	          case _util.OPS.curveTo3:
	            x = args[j + 2];
	            y = args[j + 3];
	            ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
	            j += 4;
	            break;
	          case _util.OPS.closePath:
	            ctx.closePath();
	            break;
	        }
	      }
	      current.setCurrentPoint(x, y);
	    },
	    closePath: function CanvasGraphics_closePath() {
	      this.ctx.closePath();
	    },
	    stroke: function CanvasGraphics_stroke(consumePath) {
	      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
	      var ctx = this.ctx;
	      var strokeColor = this.current.strokeColor;
	      ctx.lineWidth = Math.max(this.getSinglePixelWidth() * MIN_WIDTH_FACTOR, this.current.lineWidth);
	      ctx.globalAlpha = this.current.strokeAlpha;
	      if (strokeColor && strokeColor.hasOwnProperty('type') && strokeColor.type === 'Pattern') {
	        ctx.save();
	        ctx.strokeStyle = strokeColor.getPattern(ctx, this);
	        ctx.stroke();
	        ctx.restore();
	      } else {
	        ctx.stroke();
	      }
	      if (consumePath) {
	        this.consumePath();
	      }
	      ctx.globalAlpha = this.current.fillAlpha;
	    },
	    closeStroke: function CanvasGraphics_closeStroke() {
	      this.closePath();
	      this.stroke();
	    },
	    fill: function CanvasGraphics_fill(consumePath) {
	      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
	      var ctx = this.ctx;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      var needRestore = false;
	      if (isPatternFill) {
	        ctx.save();
	        if (this.baseTransform) {
	          ctx.setTransform.apply(ctx, this.baseTransform);
	        }
	        ctx.fillStyle = fillColor.getPattern(ctx, this);
	        needRestore = true;
	      }
	      if (this.pendingEOFill) {
	        ctx.fill('evenodd');
	        this.pendingEOFill = false;
	      } else {
	        ctx.fill();
	      }
	      if (needRestore) {
	        ctx.restore();
	      }
	      if (consumePath) {
	        this.consumePath();
	      }
	    },
	    eoFill: function CanvasGraphics_eoFill() {
	      this.pendingEOFill = true;
	      this.fill();
	    },
	    fillStroke: function CanvasGraphics_fillStroke() {
	      this.fill(false);
	      this.stroke(false);
	      this.consumePath();
	    },
	    eoFillStroke: function CanvasGraphics_eoFillStroke() {
	      this.pendingEOFill = true;
	      this.fillStroke();
	    },
	    closeFillStroke: function CanvasGraphics_closeFillStroke() {
	      this.closePath();
	      this.fillStroke();
	    },
	    closeEOFillStroke: function CanvasGraphics_closeEOFillStroke() {
	      this.pendingEOFill = true;
	      this.closePath();
	      this.fillStroke();
	    },
	    endPath: function CanvasGraphics_endPath() {
	      this.consumePath();
	    },
	    clip: function CanvasGraphics_clip() {
	      this.pendingClip = NORMAL_CLIP;
	    },
	    eoClip: function CanvasGraphics_eoClip() {
	      this.pendingClip = EO_CLIP;
	    },
	    beginText: function CanvasGraphics_beginText() {
	      this.current.textMatrix = _util.IDENTITY_MATRIX;
	      this.current.textMatrixScale = 1;
	      this.current.x = this.current.lineX = 0;
	      this.current.y = this.current.lineY = 0;
	    },
	    endText: function CanvasGraphics_endText() {
	      var paths = this.pendingTextPaths;
	      var ctx = this.ctx;
	      if (paths === undefined) {
	        ctx.beginPath();
	        return;
	      }
	      ctx.save();
	      ctx.beginPath();
	      for (var i = 0; i < paths.length; i++) {
	        var path = paths[i];
	        ctx.setTransform.apply(ctx, path.transform);
	        ctx.translate(path.x, path.y);
	        path.addToPath(ctx, path.fontSize);
	      }
	      ctx.restore();
	      ctx.clip();
	      ctx.beginPath();
	      delete this.pendingTextPaths;
	    },
	    setCharSpacing: function CanvasGraphics_setCharSpacing(spacing) {
	      this.current.charSpacing = spacing;
	    },
	    setWordSpacing: function CanvasGraphics_setWordSpacing(spacing) {
	      this.current.wordSpacing = spacing;
	    },
	    setHScale: function CanvasGraphics_setHScale(scale) {
	      this.current.textHScale = scale / 100;
	    },
	    setLeading: function CanvasGraphics_setLeading(leading) {
	      this.current.leading = -leading;
	    },
	    setFont: function CanvasGraphics_setFont(fontRefName, size) {
	      var fontObj = this.commonObjs.get(fontRefName);
	      var current = this.current;
	      if (!fontObj) {
	        throw new Error('Can\'t find font for ' + fontRefName);
	      }
	      current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
	      if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
	        (0, _util.warn)('Invalid font matrix for font ' + fontRefName);
	      }
	      if (size < 0) {
	        size = -size;
	        current.fontDirection = -1;
	      } else {
	        current.fontDirection = 1;
	      }
	      this.current.font = fontObj;
	      this.current.fontSize = size;
	      if (fontObj.isType3Font) {
	        return;
	      }
	      var name = fontObj.loadedName || 'sans-serif';
	      var bold = fontObj.black ? '900' : fontObj.bold ? 'bold' : 'normal';
	      var italic = fontObj.italic ? 'italic' : 'normal';
	      var typeface = '"' + name + '", ' + fontObj.fallbackName;
	      var browserFontSize = size < MIN_FONT_SIZE ? MIN_FONT_SIZE : size > MAX_FONT_SIZE ? MAX_FONT_SIZE : size;
	      this.current.fontSizeScale = size / browserFontSize;
	      var rule = italic + ' ' + bold + ' ' + browserFontSize + 'px ' + typeface;
	      this.ctx.font = rule;
	    },
	    setTextRenderingMode: function CanvasGraphics_setTextRenderingMode(mode) {
	      this.current.textRenderingMode = mode;
	    },
	    setTextRise: function CanvasGraphics_setTextRise(rise) {
	      this.current.textRise = rise;
	    },
	    moveText: function CanvasGraphics_moveText(x, y) {
	      this.current.x = this.current.lineX += x;
	      this.current.y = this.current.lineY += y;
	    },
	    setLeadingMoveText: function CanvasGraphics_setLeadingMoveText(x, y) {
	      this.setLeading(-y);
	      this.moveText(x, y);
	    },
	    setTextMatrix: function CanvasGraphics_setTextMatrix(a, b, c, d, e, f) {
	      this.current.textMatrix = [a, b, c, d, e, f];
	      this.current.textMatrixScale = Math.sqrt(a * a + b * b);
	      this.current.x = this.current.lineX = 0;
	      this.current.y = this.current.lineY = 0;
	    },
	    nextLine: function CanvasGraphics_nextLine() {
	      this.moveText(0, this.current.leading);
	    },
	    paintChar: function paintChar(character, x, y, patternTransform) {
	      var ctx = this.ctx;
	      var current = this.current;
	      var font = current.font;
	      var textRenderingMode = current.textRenderingMode;
	      var fontSize = current.fontSize / current.fontSizeScale;
	      var fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
	      var isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
	      var patternFill = current.patternFill && font.data;
	      var addToPath;
	      if (font.disableFontFace || isAddToPathSet || patternFill) {
	        addToPath = font.getPathGenerator(this.commonObjs, character);
	      }
	      if (font.disableFontFace || patternFill) {
	        ctx.save();
	        ctx.translate(x, y);
	        ctx.beginPath();
	        addToPath(ctx, fontSize);
	        if (patternTransform) {
	          ctx.setTransform.apply(ctx, patternTransform);
	        }
	        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.fill();
	        }
	        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.stroke();
	        }
	        ctx.restore();
	      } else {
	        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.fillText(character, x, y);
	        }
	        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.strokeText(character, x, y);
	        }
	      }
	      if (isAddToPathSet) {
	        var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
	        paths.push({
	          transform: ctx.mozCurrentTransform,
	          x: x,
	          y: y,
	          fontSize: fontSize,
	          addToPath: addToPath
	        });
	      }
	    },
	
	    get isFontSubpixelAAEnabled() {
	      var ctx = this.canvasFactory.create(10, 10).context;
	      ctx.scale(1.5, 1);
	      ctx.fillText('I', 0, 10);
	      var data = ctx.getImageData(0, 0, 10, 10).data;
	      var enabled = false;
	      for (var i = 3; i < data.length; i += 4) {
	        if (data[i] > 0 && data[i] < 255) {
	          enabled = true;
	          break;
	        }
	      }
	      return (0, _util.shadow)(this, 'isFontSubpixelAAEnabled', enabled);
	    },
	    showText: function CanvasGraphics_showText(glyphs) {
	      var current = this.current;
	      var font = current.font;
	      if (font.isType3Font) {
	        return this.showType3Text(glyphs);
	      }
	      var fontSize = current.fontSize;
	      if (fontSize === 0) {
	        return;
	      }
	      var ctx = this.ctx;
	      var fontSizeScale = current.fontSizeScale;
	      var charSpacing = current.charSpacing;
	      var wordSpacing = current.wordSpacing;
	      var fontDirection = current.fontDirection;
	      var textHScale = current.textHScale * fontDirection;
	      var glyphsLength = glyphs.length;
	      var vertical = font.vertical;
	      var spacingDir = vertical ? 1 : -1;
	      var defaultVMetrics = font.defaultVMetrics;
	      var widthAdvanceScale = fontSize * current.fontMatrix[0];
	      var simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
	      ctx.save();
	      var patternTransform = void 0;
	      if (current.patternFill) {
	        ctx.save();
	        var pattern = current.fillColor.getPattern(ctx, this);
	        patternTransform = ctx.mozCurrentTransform;
	        ctx.restore();
	        ctx.fillStyle = pattern;
	      }
	      ctx.transform.apply(ctx, current.textMatrix);
	      ctx.translate(current.x, current.y + current.textRise);
	      if (fontDirection > 0) {
	        ctx.scale(textHScale, -1);
	      } else {
	        ctx.scale(textHScale, 1);
	      }
	      var lineWidth = current.lineWidth;
	      var scale = current.textMatrixScale;
	      if (scale === 0 || lineWidth === 0) {
	        var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
	        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          this.cachedGetSinglePixelWidth = null;
	          lineWidth = this.getSinglePixelWidth() * MIN_WIDTH_FACTOR;
	        }
	      } else {
	        lineWidth /= scale;
	      }
	      if (fontSizeScale !== 1.0) {
	        ctx.scale(fontSizeScale, fontSizeScale);
	        lineWidth /= fontSizeScale;
	      }
	      ctx.lineWidth = lineWidth;
	      var x = 0,
	          i;
	      for (i = 0; i < glyphsLength; ++i) {
	        var glyph = glyphs[i];
	        if ((0, _util.isNum)(glyph)) {
	          x += spacingDir * glyph * fontSize / 1000;
	          continue;
	        }
	        var restoreNeeded = false;
	        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
	        var character = glyph.fontChar;
	        var accent = glyph.accent;
	        var scaledX, scaledY, scaledAccentX, scaledAccentY;
	        var width = glyph.width;
	        if (vertical) {
	          var vmetric, vx, vy;
	          vmetric = glyph.vmetric || defaultVMetrics;
	          vx = glyph.vmetric ? vmetric[1] : width * 0.5;
	          vx = -vx * widthAdvanceScale;
	          vy = vmetric[2] * widthAdvanceScale;
	          width = vmetric ? -vmetric[0] : width;
	          scaledX = vx / fontSizeScale;
	          scaledY = (x + vy) / fontSizeScale;
	        } else {
	          scaledX = x / fontSizeScale;
	          scaledY = 0;
	        }
	        if (font.remeasure && width > 0) {
	          var measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
	          if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
	            var characterScaleX = width / measuredWidth;
	            restoreNeeded = true;
	            ctx.save();
	            ctx.scale(characterScaleX, 1);
	            scaledX /= characterScaleX;
	          } else if (width !== measuredWidth) {
	            scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
	          }
	        }
	        if (glyph.isInFont || font.missingFile) {
	          if (simpleFillText && !accent) {
	            ctx.fillText(character, scaledX, scaledY);
	          } else {
	            this.paintChar(character, scaledX, scaledY, patternTransform);
	            if (accent) {
	              scaledAccentX = scaledX + accent.offset.x / fontSizeScale;
	              scaledAccentY = scaledY - accent.offset.y / fontSizeScale;
	              this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform);
	            }
	          }
	        }
	        var charWidth = width * widthAdvanceScale + spacing * fontDirection;
	        x += charWidth;
	        if (restoreNeeded) {
	          ctx.restore();
	        }
	      }
	      if (vertical) {
	        current.y -= x * textHScale;
	      } else {
	        current.x += x * textHScale;
	      }
	      ctx.restore();
	    },
	    showType3Text: function CanvasGraphics_showType3Text(glyphs) {
	      var ctx = this.ctx;
	      var current = this.current;
	      var font = current.font;
	      var fontSize = current.fontSize;
	      var fontDirection = current.fontDirection;
	      var spacingDir = font.vertical ? 1 : -1;
	      var charSpacing = current.charSpacing;
	      var wordSpacing = current.wordSpacing;
	      var textHScale = current.textHScale * fontDirection;
	      var fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
	      var glyphsLength = glyphs.length;
	      var isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
	      var i, glyph, width, spacingLength;
	      if (isTextInvisible || fontSize === 0) {
	        return;
	      }
	      this.cachedGetSinglePixelWidth = null;
	      ctx.save();
	      ctx.transform.apply(ctx, current.textMatrix);
	      ctx.translate(current.x, current.y);
	      ctx.scale(textHScale, fontDirection);
	      for (i = 0; i < glyphsLength; ++i) {
	        glyph = glyphs[i];
	        if ((0, _util.isNum)(glyph)) {
	          spacingLength = spacingDir * glyph * fontSize / 1000;
	          this.ctx.translate(spacingLength, 0);
	          current.x += spacingLength * textHScale;
	          continue;
	        }
	        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
	        var operatorList = font.charProcOperatorList[glyph.operatorListId];
	        if (!operatorList) {
	          (0, _util.warn)('Type3 character "' + glyph.operatorListId + '" is not available.');
	          continue;
	        }
	        this.processingType3 = glyph;
	        this.save();
	        ctx.scale(fontSize, fontSize);
	        ctx.transform.apply(ctx, fontMatrix);
	        this.executeOperatorList(operatorList);
	        this.restore();
	        var transformed = _util.Util.applyTransform([glyph.width, 0], fontMatrix);
	        width = transformed[0] * fontSize + spacing;
	        ctx.translate(width, 0);
	        current.x += width * textHScale;
	      }
	      ctx.restore();
	      this.processingType3 = null;
	    },
	    setCharWidth: function CanvasGraphics_setCharWidth(xWidth, yWidth) {},
	    setCharWidthAndBounds: function CanvasGraphics_setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
	      this.ctx.rect(llx, lly, urx - llx, ury - lly);
	      this.clip();
	      this.endPath();
	    },
	    getColorN_Pattern: function CanvasGraphics_getColorN_Pattern(IR) {
	      var _this = this;
	
	      var pattern;
	      if (IR[0] === 'TilingPattern') {
	        var color = IR[1];
	        var baseTransform = this.baseTransform || this.ctx.mozCurrentTransform.slice();
	        var canvasGraphicsFactory = {
	          createCanvasGraphics: function createCanvasGraphics(ctx) {
	            return new CanvasGraphics(ctx, _this.commonObjs, _this.objs, _this.canvasFactory, _this.webGLContext);
	          }
	        };
	        pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
	      } else {
	        pattern = (0, _pattern_helper.getShadingPatternFromIR)(IR);
	      }
	      return pattern;
	    },
	    setStrokeColorN: function CanvasGraphics_setStrokeColorN() {
	      this.current.strokeColor = this.getColorN_Pattern(arguments);
	    },
	    setFillColorN: function CanvasGraphics_setFillColorN() {
	      this.current.fillColor = this.getColorN_Pattern(arguments);
	      this.current.patternFill = true;
	    },
	    setStrokeRGBColor: function CanvasGraphics_setStrokeRGBColor(r, g, b) {
	      var color = _util.Util.makeCssRgb(r, g, b);
	      this.ctx.strokeStyle = color;
	      this.current.strokeColor = color;
	    },
	    setFillRGBColor: function CanvasGraphics_setFillRGBColor(r, g, b) {
	      var color = _util.Util.makeCssRgb(r, g, b);
	      this.ctx.fillStyle = color;
	      this.current.fillColor = color;
	      this.current.patternFill = false;
	    },
	    shadingFill: function CanvasGraphics_shadingFill(patternIR) {
	      var ctx = this.ctx;
	      this.save();
	      var pattern = (0, _pattern_helper.getShadingPatternFromIR)(patternIR);
	      ctx.fillStyle = pattern.getPattern(ctx, this, true);
	      var inv = ctx.mozCurrentTransformInverse;
	      if (inv) {
	        var canvas = ctx.canvas;
	        var width = canvas.width;
	        var height = canvas.height;
	        var bl = _util.Util.applyTransform([0, 0], inv);
	        var br = _util.Util.applyTransform([0, height], inv);
	        var ul = _util.Util.applyTransform([width, 0], inv);
	        var ur = _util.Util.applyTransform([width, height], inv);
	        var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
	        var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
	        var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
	        var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
	        this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
	      } else {
	        this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
	      }
	      this.restore();
	    },
	    beginInlineImage: function CanvasGraphics_beginInlineImage() {
	      (0, _util.unreachable)('Should not call beginInlineImage');
	    },
	    beginImageData: function CanvasGraphics_beginImageData() {
	      (0, _util.unreachable)('Should not call beginImageData');
	    },
	    paintFormXObjectBegin: function CanvasGraphics_paintFormXObjectBegin(matrix, bbox) {
	      this.save();
	      this.baseTransformStack.push(this.baseTransform);
	      if (Array.isArray(matrix) && matrix.length === 6) {
	        this.transform.apply(this, matrix);
	      }
	      this.baseTransform = this.ctx.mozCurrentTransform;
	      if (Array.isArray(bbox) && bbox.length === 4) {
	        var width = bbox[2] - bbox[0];
	        var height = bbox[3] - bbox[1];
	        this.ctx.rect(bbox[0], bbox[1], width, height);
	        this.clip();
	        this.endPath();
	      }
	    },
	    paintFormXObjectEnd: function CanvasGraphics_paintFormXObjectEnd() {
	      this.restore();
	      this.baseTransform = this.baseTransformStack.pop();
	    },
	    beginGroup: function CanvasGraphics_beginGroup(group) {
	      this.save();
	      var currentCtx = this.ctx;
	      if (!group.isolated) {
	        (0, _util.info)('TODO: Support non-isolated groups.');
	      }
	      if (group.knockout) {
	        (0, _util.warn)('Knockout groups not supported.');
	      }
	      var currentTransform = currentCtx.mozCurrentTransform;
	      if (group.matrix) {
	        currentCtx.transform.apply(currentCtx, group.matrix);
	      }
	      if (!group.bbox) {
	        throw new Error('Bounding box is required.');
	      }
	      var bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, currentCtx.mozCurrentTransform);
	      var canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
	      bounds = _util.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
	      var offsetX = Math.floor(bounds[0]);
	      var offsetY = Math.floor(bounds[1]);
	      var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
	      var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
	      var scaleX = 1,
	          scaleY = 1;
	      if (drawnWidth > MAX_GROUP_SIZE) {
	        scaleX = drawnWidth / MAX_GROUP_SIZE;
	        drawnWidth = MAX_GROUP_SIZE;
	      }
	      if (drawnHeight > MAX_GROUP_SIZE) {
	        scaleY = drawnHeight / MAX_GROUP_SIZE;
	        drawnHeight = MAX_GROUP_SIZE;
	      }
	      var cacheId = 'groupAt' + this.groupLevel;
	      if (group.smask) {
	        cacheId += '_smask_' + this.smaskCounter++ % 2;
	      }
	      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
	      var groupCtx = scratchCanvas.context;
	      groupCtx.scale(1 / scaleX, 1 / scaleY);
	      groupCtx.translate(-offsetX, -offsetY);
	      groupCtx.transform.apply(groupCtx, currentTransform);
	      if (group.smask) {
	        this.smaskStack.push({
	          canvas: scratchCanvas.canvas,
	          context: groupCtx,
	          offsetX: offsetX,
	          offsetY: offsetY,
	          scaleX: scaleX,
	          scaleY: scaleY,
	          subtype: group.smask.subtype,
	          backdrop: group.smask.backdrop,
	          transferMap: group.smask.transferMap || null,
	          startTransformInverse: null
	        });
	      } else {
	        currentCtx.setTransform(1, 0, 0, 1, 0, 0);
	        currentCtx.translate(offsetX, offsetY);
	        currentCtx.scale(scaleX, scaleY);
	      }
	      copyCtxState(currentCtx, groupCtx);
	      this.ctx = groupCtx;
	      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
	      this.groupStack.push(currentCtx);
	      this.groupLevel++;
	      this.current.activeSMask = null;
	    },
	    endGroup: function CanvasGraphics_endGroup(group) {
	      this.groupLevel--;
	      var groupCtx = this.ctx;
	      this.ctx = this.groupStack.pop();
	      if (this.ctx.imageSmoothingEnabled !== undefined) {
	        this.ctx.imageSmoothingEnabled = false;
	      } else {
	        this.ctx.mozImageSmoothingEnabled = false;
	      }
	      if (group.smask) {
	        this.tempSMask = this.smaskStack.pop();
	      } else {
	        this.ctx.drawImage(groupCtx.canvas, 0, 0);
	      }
	      this.restore();
	    },
	    beginAnnotations: function CanvasGraphics_beginAnnotations() {
	      this.save();
	      if (this.baseTransform) {
	        this.ctx.setTransform.apply(this.ctx, this.baseTransform);
	      }
	    },
	    endAnnotations: function CanvasGraphics_endAnnotations() {
	      this.restore();
	    },
	    beginAnnotation: function CanvasGraphics_beginAnnotation(rect, transform, matrix) {
	      this.save();
	      resetCtxToDefault(this.ctx);
	      this.current = new CanvasExtraState();
	      if (Array.isArray(rect) && rect.length === 4) {
	        var width = rect[2] - rect[0];
	        var height = rect[3] - rect[1];
	        this.ctx.rect(rect[0], rect[1], width, height);
	        this.clip();
	        this.endPath();
	      }
	      this.transform.apply(this, transform);
	      this.transform.apply(this, matrix);
	    },
	    endAnnotation: function CanvasGraphics_endAnnotation() {
	      this.restore();
	    },
	    paintJpegXObject: function CanvasGraphics_paintJpegXObject(objId, w, h) {
	      var domImage = this.objs.get(objId);
	      if (!domImage) {
	        (0, _util.warn)('Dependent image isn\'t ready yet');
	        return;
	      }
	      this.save();
	      var ctx = this.ctx;
	      ctx.scale(1 / w, -1 / h);
	      ctx.drawImage(domImage, 0, 0, domImage.width, domImage.height, 0, -h, w, h);
	      if (this.imageLayer) {
	        var currentTransform = ctx.mozCurrentTransformInverse;
	        var position = this.getCanvasPosition(0, 0);
	        this.imageLayer.appendImage({
	          objId: objId,
	          left: position[0],
	          top: position[1],
	          width: w / currentTransform[0],
	          height: h / currentTransform[3]
	        });
	      }
	      this.restore();
	    },
	    paintImageMaskXObject: function CanvasGraphics_paintImageMaskXObject(img) {
	      var ctx = this.ctx;
	      var width = img.width,
	          height = img.height;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      var glyph = this.processingType3;
	      if (COMPILE_TYPE3_GLYPHS && glyph && glyph.compiled === undefined) {
	        if (width <= MAX_SIZE_TO_COMPILE && height <= MAX_SIZE_TO_COMPILE) {
	          glyph.compiled = compileType3Glyph({
	            data: img.data,
	            width: width,
	            height: height
	          });
	        } else {
	          glyph.compiled = null;
	        }
	      }
	      if (glyph && glyph.compiled) {
	        glyph.compiled(ctx);
	        return;
	      }
	      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
	      var maskCtx = maskCanvas.context;
	      maskCtx.save();
	      putBinaryImageMask(maskCtx, img);
	      maskCtx.globalCompositeOperation = 'source-in';
	      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
	      maskCtx.fillRect(0, 0, width, height);
	      maskCtx.restore();
	      this.paintInlineImageXObject(maskCanvas.canvas);
	    },
	    paintImageMaskXObjectRepeat: function CanvasGraphics_paintImageMaskXObjectRepeat(imgData, scaleX, scaleY, positions) {
	      var width = imgData.width;
	      var height = imgData.height;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
	      var maskCtx = maskCanvas.context;
	      maskCtx.save();
	      putBinaryImageMask(maskCtx, imgData);
	      maskCtx.globalCompositeOperation = 'source-in';
	      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
	      maskCtx.fillRect(0, 0, width, height);
	      maskCtx.restore();
	      var ctx = this.ctx;
	      for (var i = 0, ii = positions.length; i < ii; i += 2) {
	        ctx.save();
	        ctx.transform(scaleX, 0, 0, scaleY, positions[i], positions[i + 1]);
	        ctx.scale(1, -1);
	        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
	        ctx.restore();
	      }
	    },
	    paintImageMaskXObjectGroup: function CanvasGraphics_paintImageMaskXObjectGroup(images) {
	      var ctx = this.ctx;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      for (var i = 0, ii = images.length; i < ii; i++) {
	        var image = images[i];
	        var width = image.width,
	            height = image.height;
	        var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
	        var maskCtx = maskCanvas.context;
	        maskCtx.save();
	        putBinaryImageMask(maskCtx, image);
	        maskCtx.globalCompositeOperation = 'source-in';
	        maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
	        maskCtx.fillRect(0, 0, width, height);
	        maskCtx.restore();
	        ctx.save();
	        ctx.transform.apply(ctx, image.transform);
	        ctx.scale(1, -1);
	        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
	        ctx.restore();
	      }
	    },
	    paintImageXObject: function CanvasGraphics_paintImageXObject(objId) {
	      var imgData = this.objs.get(objId);
	      if (!imgData) {
	        (0, _util.warn)('Dependent image isn\'t ready yet');
	        return;
	      }
	      this.paintInlineImageXObject(imgData);
	    },
	    paintImageXObjectRepeat: function CanvasGraphics_paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
	      var imgData = this.objs.get(objId);
	      if (!imgData) {
	        (0, _util.warn)('Dependent image isn\'t ready yet');
	        return;
	      }
	      var width = imgData.width;
	      var height = imgData.height;
	      var map = [];
	      for (var i = 0, ii = positions.length; i < ii; i += 2) {
	        map.push({
	          transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
	          x: 0,
	          y: 0,
	          w: width,
	          h: height
	        });
	      }
	      this.paintInlineImageXObjectGroup(imgData, map);
	    },
	    paintInlineImageXObject: function CanvasGraphics_paintInlineImageXObject(imgData) {
	      var width = imgData.width;
	      var height = imgData.height;
	      var ctx = this.ctx;
	      this.save();
	      ctx.scale(1 / width, -1 / height);
	      var currentTransform = ctx.mozCurrentTransformInverse;
	      var a = currentTransform[0],
	          b = currentTransform[1];
	      var widthScale = Math.max(Math.sqrt(a * a + b * b), 1);
	      var c = currentTransform[2],
	          d = currentTransform[3];
	      var heightScale = Math.max(Math.sqrt(c * c + d * d), 1);
	      var imgToPaint, tmpCanvas;
	      if (imgData instanceof HTMLElement || !imgData.data) {
	        imgToPaint = imgData;
	      } else {
	        tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', width, height);
	        var tmpCtx = tmpCanvas.context;
	        putBinaryImageData(tmpCtx, imgData);
	        imgToPaint = tmpCanvas.canvas;
	      }
	      var paintWidth = width,
	          paintHeight = height;
	      var tmpCanvasId = 'prescale1';
	      while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
	        var newWidth = paintWidth,
	            newHeight = paintHeight;
	        if (widthScale > 2 && paintWidth > 1) {
	          newWidth = Math.ceil(paintWidth / 2);
	          widthScale /= paintWidth / newWidth;
	        }
	        if (heightScale > 2 && paintHeight > 1) {
	          newHeight = Math.ceil(paintHeight / 2);
	          heightScale /= paintHeight / newHeight;
	        }
	        tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
	        tmpCtx = tmpCanvas.context;
	        tmpCtx.clearRect(0, 0, newWidth, newHeight);
	        tmpCtx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
	        imgToPaint = tmpCanvas.canvas;
	        paintWidth = newWidth;
	        paintHeight = newHeight;
	        tmpCanvasId = tmpCanvasId === 'prescale1' ? 'prescale2' : 'prescale1';
	      }
	      ctx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, -height, width, height);
	      if (this.imageLayer) {
	        var position = this.getCanvasPosition(0, -height);
	        this.imageLayer.appendImage({
	          imgData: imgData,
	          left: position[0],
	          top: position[1],
	          width: width / currentTransform[0],
	          height: height / currentTransform[3]
	        });
	      }
	      this.restore();
	    },
	    paintInlineImageXObjectGroup: function CanvasGraphics_paintInlineImageXObjectGroup(imgData, map) {
	      var ctx = this.ctx;
	      var w = imgData.width;
	      var h = imgData.height;
	      var tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', w, h);
	      var tmpCtx = tmpCanvas.context;
	      putBinaryImageData(tmpCtx, imgData);
	      for (var i = 0, ii = map.length; i < ii; i++) {
	        var entry = map[i];
	        ctx.save();
	        ctx.transform.apply(ctx, entry.transform);
	        ctx.scale(1, -1);
	        ctx.drawImage(tmpCanvas.canvas, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
	        if (this.imageLayer) {
	          var position = this.getCanvasPosition(entry.x, entry.y);
	          this.imageLayer.appendImage({
	            imgData: imgData,
	            left: position[0],
	            top: position[1],
	            width: w,
	            height: h
	          });
	        }
	        ctx.restore();
	      }
	    },
	    paintSolidColorImageMask: function CanvasGraphics_paintSolidColorImageMask() {
	      this.ctx.fillRect(0, 0, 1, 1);
	    },
	    paintXObject: function CanvasGraphics_paintXObject() {
	      (0, _util.warn)('Unsupported \'paintXObject\' command.');
	    },
	    markPoint: function CanvasGraphics_markPoint(tag) {},
	    markPointProps: function CanvasGraphics_markPointProps(tag, properties) {},
	    beginMarkedContent: function CanvasGraphics_beginMarkedContent(tag) {},
	    beginMarkedContentProps: function CanvasGraphics_beginMarkedContentProps(tag, properties) {},
	    endMarkedContent: function CanvasGraphics_endMarkedContent() {},
	    beginCompat: function CanvasGraphics_beginCompat() {},
	    endCompat: function CanvasGraphics_endCompat() {},
	    consumePath: function CanvasGraphics_consumePath() {
	      var ctx = this.ctx;
	      if (this.pendingClip) {
	        if (this.pendingClip === EO_CLIP) {
	          ctx.clip('evenodd');
	        } else {
	          ctx.clip();
	        }
	        this.pendingClip = null;
	      }
	      ctx.beginPath();
	    },
	    getSinglePixelWidth: function CanvasGraphics_getSinglePixelWidth(scale) {
	      if (this.cachedGetSinglePixelWidth === null) {
	        this.ctx.save();
	        var inverse = this.ctx.mozCurrentTransformInverse;
	        this.ctx.restore();
	        this.cachedGetSinglePixelWidth = Math.sqrt(Math.max(inverse[0] * inverse[0] + inverse[1] * inverse[1], inverse[2] * inverse[2] + inverse[3] * inverse[3]));
	      }
	      return this.cachedGetSinglePixelWidth;
	    },
	    getCanvasPosition: function CanvasGraphics_getCanvasPosition(x, y) {
	      var transform = this.ctx.mozCurrentTransform;
	      return [transform[0] * x + transform[2] * y + transform[4], transform[1] * x + transform[3] * y + transform[5]];
	    }
	  };
	  for (var op in _util.OPS) {
	    CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
	  }
	  return CanvasGraphics;
	}();
	exports.CanvasGraphics = CanvasGraphics;
	
	/***/ }),
	/* 118 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TilingPattern = exports.getShadingPatternFromIR = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var ShadingIRs = {};
	ShadingIRs.RadialAxial = {
	  fromIR: function RadialAxial_fromIR(raw) {
	    var type = raw[1];
	    var colorStops = raw[2];
	    var p0 = raw[3];
	    var p1 = raw[4];
	    var r0 = raw[5];
	    var r1 = raw[6];
	    return {
	      type: 'Pattern',
	      getPattern: function RadialAxial_getPattern(ctx) {
	        var grad;
	        if (type === 'axial') {
	          grad = ctx.createLinearGradient(p0[0], p0[1], p1[0], p1[1]);
	        } else if (type === 'radial') {
	          grad = ctx.createRadialGradient(p0[0], p0[1], r0, p1[0], p1[1], r1);
	        }
	        for (var i = 0, ii = colorStops.length; i < ii; ++i) {
	          var c = colorStops[i];
	          grad.addColorStop(c[0], c[1]);
	        }
	        return grad;
	      }
	    };
	  }
	};
	var createMeshCanvas = function createMeshCanvasClosure() {
	  function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
	    var coords = context.coords,
	        colors = context.colors;
	    var bytes = data.data,
	        rowSize = data.width * 4;
	    var tmp;
	    if (coords[p1 + 1] > coords[p2 + 1]) {
	      tmp = p1;
	      p1 = p2;
	      p2 = tmp;
	      tmp = c1;
	      c1 = c2;
	      c2 = tmp;
	    }
	    if (coords[p2 + 1] > coords[p3 + 1]) {
	      tmp = p2;
	      p2 = p3;
	      p3 = tmp;
	      tmp = c2;
	      c2 = c3;
	      c3 = tmp;
	    }
	    if (coords[p1 + 1] > coords[p2 + 1]) {
	      tmp = p1;
	      p1 = p2;
	      p2 = tmp;
	      tmp = c1;
	      c1 = c2;
	      c2 = tmp;
	    }
	    var x1 = (coords[p1] + context.offsetX) * context.scaleX;
	    var y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
	    var x2 = (coords[p2] + context.offsetX) * context.scaleX;
	    var y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
	    var x3 = (coords[p3] + context.offsetX) * context.scaleX;
	    var y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
	    if (y1 >= y3) {
	      return;
	    }
	    var c1r = colors[c1],
	        c1g = colors[c1 + 1],
	        c1b = colors[c1 + 2];
	    var c2r = colors[c2],
	        c2g = colors[c2 + 1],
	        c2b = colors[c2 + 2];
	    var c3r = colors[c3],
	        c3g = colors[c3 + 1],
	        c3b = colors[c3 + 2];
	    var minY = Math.round(y1),
	        maxY = Math.round(y3);
	    var xa, car, cag, cab;
	    var xb, cbr, cbg, cbb;
	    var k;
	    for (var y = minY; y <= maxY; y++) {
	      if (y < y2) {
	        k = y < y1 ? 0 : y1 === y2 ? 1 : (y1 - y) / (y1 - y2);
	        xa = x1 - (x1 - x2) * k;
	        car = c1r - (c1r - c2r) * k;
	        cag = c1g - (c1g - c2g) * k;
	        cab = c1b - (c1b - c2b) * k;
	      } else {
	        k = y > y3 ? 1 : y2 === y3 ? 0 : (y2 - y) / (y2 - y3);
	        xa = x2 - (x2 - x3) * k;
	        car = c2r - (c2r - c3r) * k;
	        cag = c2g - (c2g - c3g) * k;
	        cab = c2b - (c2b - c3b) * k;
	      }
	      k = y < y1 ? 0 : y > y3 ? 1 : (y1 - y) / (y1 - y3);
	      xb = x1 - (x1 - x3) * k;
	      cbr = c1r - (c1r - c3r) * k;
	      cbg = c1g - (c1g - c3g) * k;
	      cbb = c1b - (c1b - c3b) * k;
	      var x1_ = Math.round(Math.min(xa, xb));
	      var x2_ = Math.round(Math.max(xa, xb));
	      var j = rowSize * y + x1_ * 4;
	      for (var x = x1_; x <= x2_; x++) {
	        k = (xa - x) / (xa - xb);
	        k = k < 0 ? 0 : k > 1 ? 1 : k;
	        bytes[j++] = car - (car - cbr) * k | 0;
	        bytes[j++] = cag - (cag - cbg) * k | 0;
	        bytes[j++] = cab - (cab - cbb) * k | 0;
	        bytes[j++] = 255;
	      }
	    }
	  }
	  function drawFigure(data, figure, context) {
	    var ps = figure.coords;
	    var cs = figure.colors;
	    var i, ii;
	    switch (figure.type) {
	      case 'lattice':
	        var verticesPerRow = figure.verticesPerRow;
	        var rows = Math.floor(ps.length / verticesPerRow) - 1;
	        var cols = verticesPerRow - 1;
	        for (i = 0; i < rows; i++) {
	          var q = i * verticesPerRow;
	          for (var j = 0; j < cols; j++, q++) {
	            drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
	            drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
	          }
	        }
	        break;
	      case 'triangles':
	        for (i = 0, ii = ps.length; i < ii; i += 3) {
	          drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
	        }
	        break;
	      default:
	        throw new Error('illegal figure');
	    }
	  }
	  function createMeshCanvas(bounds, combinesScale, coords, colors, figures, backgroundColor, cachedCanvases, webGLContext) {
	    var EXPECTED_SCALE = 1.1;
	    var MAX_PATTERN_SIZE = 3000;
	    var BORDER_SIZE = 2;
	    var offsetX = Math.floor(bounds[0]);
	    var offsetY = Math.floor(bounds[1]);
	    var boundsWidth = Math.ceil(bounds[2]) - offsetX;
	    var boundsHeight = Math.ceil(bounds[3]) - offsetY;
	    var width = Math.min(Math.ceil(Math.abs(boundsWidth * combinesScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
	    var height = Math.min(Math.ceil(Math.abs(boundsHeight * combinesScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
	    var scaleX = boundsWidth / width;
	    var scaleY = boundsHeight / height;
	    var context = {
	      coords: coords,
	      colors: colors,
	      offsetX: -offsetX,
	      offsetY: -offsetY,
	      scaleX: 1 / scaleX,
	      scaleY: 1 / scaleY
	    };
	    var paddedWidth = width + BORDER_SIZE * 2;
	    var paddedHeight = height + BORDER_SIZE * 2;
	    var canvas, tmpCanvas, i, ii;
	    if (webGLContext.isEnabled) {
	      canvas = webGLContext.drawFigures({
	        width: width,
	        height: height,
	        backgroundColor: backgroundColor,
	        figures: figures,
	        context: context
	      });
	      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
	      tmpCanvas.context.drawImage(canvas, BORDER_SIZE, BORDER_SIZE);
	      canvas = tmpCanvas.canvas;
	    } else {
	      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
	      var tmpCtx = tmpCanvas.context;
	      var data = tmpCtx.createImageData(width, height);
	      if (backgroundColor) {
	        var bytes = data.data;
	        for (i = 0, ii = bytes.length; i < ii; i += 4) {
	          bytes[i] = backgroundColor[0];
	          bytes[i + 1] = backgroundColor[1];
	          bytes[i + 2] = backgroundColor[2];
	          bytes[i + 3] = 255;
	        }
	      }
	      for (i = 0; i < figures.length; i++) {
	        drawFigure(data, figures[i], context);
	      }
	      tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
	      canvas = tmpCanvas.canvas;
	    }
	    return {
	      canvas: canvas,
	      offsetX: offsetX - BORDER_SIZE * scaleX,
	      offsetY: offsetY - BORDER_SIZE * scaleY,
	      scaleX: scaleX,
	      scaleY: scaleY
	    };
	  }
	  return createMeshCanvas;
	}();
	ShadingIRs.Mesh = {
	  fromIR: function Mesh_fromIR(raw) {
	    var coords = raw[2];
	    var colors = raw[3];
	    var figures = raw[4];
	    var bounds = raw[5];
	    var matrix = raw[6];
	    var background = raw[8];
	    return {
	      type: 'Pattern',
	      getPattern: function Mesh_getPattern(ctx, owner, shadingFill) {
	        var scale;
	        if (shadingFill) {
	          scale = _util.Util.singularValueDecompose2dScale(ctx.mozCurrentTransform);
	        } else {
	          scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
	          if (matrix) {
	            var matrixScale = _util.Util.singularValueDecompose2dScale(matrix);
	            scale = [scale[0] * matrixScale[0], scale[1] * matrixScale[1]];
	          }
	        }
	        var temporaryPatternCanvas = createMeshCanvas(bounds, scale, coords, colors, figures, shadingFill ? null : background, owner.cachedCanvases, owner.webGLContext);
	        if (!shadingFill) {
	          ctx.setTransform.apply(ctx, owner.baseTransform);
	          if (matrix) {
	            ctx.transform.apply(ctx, matrix);
	          }
	        }
	        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
	        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
	        return ctx.createPattern(temporaryPatternCanvas.canvas, 'no-repeat');
	      }
	    };
	  }
	};
	ShadingIRs.Dummy = {
	  fromIR: function Dummy_fromIR() {
	    return {
	      type: 'Pattern',
	      getPattern: function Dummy_fromIR_getPattern() {
	        return 'hotpink';
	      }
	    };
	  }
	};
	function getShadingPatternFromIR(raw) {
	  var shadingIR = ShadingIRs[raw[0]];
	  if (!shadingIR) {
	    throw new Error('Unknown IR type: ' + raw[0]);
	  }
	  return shadingIR.fromIR(raw);
	}
	var TilingPattern = function TilingPatternClosure() {
	  var PaintType = {
	    COLORED: 1,
	    UNCOLORED: 2
	  };
	  var MAX_PATTERN_SIZE = 3000;
	  function TilingPattern(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
	    this.operatorList = IR[2];
	    this.matrix = IR[3] || [1, 0, 0, 1, 0, 0];
	    this.bbox = IR[4];
	    this.xstep = IR[5];
	    this.ystep = IR[6];
	    this.paintType = IR[7];
	    this.tilingType = IR[8];
	    this.color = color;
	    this.canvasGraphicsFactory = canvasGraphicsFactory;
	    this.baseTransform = baseTransform;
	    this.type = 'Pattern';
	    this.ctx = ctx;
	  }
	  TilingPattern.prototype = {
	    createPatternCanvas: function TilinPattern_createPatternCanvas(owner) {
	      var operatorList = this.operatorList;
	      var bbox = this.bbox;
	      var xstep = this.xstep;
	      var ystep = this.ystep;
	      var paintType = this.paintType;
	      var tilingType = this.tilingType;
	      var color = this.color;
	      var canvasGraphicsFactory = this.canvasGraphicsFactory;
	      (0, _util.info)('TilingType: ' + tilingType);
	      var x0 = bbox[0],
	          y0 = bbox[1],
	          x1 = bbox[2],
	          y1 = bbox[3];
	      var topLeft = [x0, y0];
	      var botRight = [x0 + xstep, y0 + ystep];
	      var width = botRight[0] - topLeft[0];
	      var height = botRight[1] - topLeft[1];
	      var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
	      var curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
	      var combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]];
	      width = Math.min(Math.ceil(Math.abs(width * combinedScale[0])), MAX_PATTERN_SIZE);
	      height = Math.min(Math.ceil(Math.abs(height * combinedScale[1])), MAX_PATTERN_SIZE);
	      var tmpCanvas = owner.cachedCanvases.getCanvas('pattern', width, height, true);
	      var tmpCtx = tmpCanvas.context;
	      var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
	      graphics.groupLevel = owner.groupLevel;
	      this.setFillAndStrokeStyleToContext(graphics, paintType, color);
	      this.setScale(width, height, xstep, ystep);
	      this.transformToScale(graphics);
	      var tmpTranslate = [1, 0, 0, 1, -topLeft[0], -topLeft[1]];
	      graphics.transform.apply(graphics, tmpTranslate);
	      this.clipBbox(graphics, bbox, x0, y0, x1, y1);
	      graphics.executeOperatorList(operatorList);
	      return tmpCanvas.canvas;
	    },
	    setScale: function TilingPattern_setScale(width, height, xstep, ystep) {
	      this.scale = [width / xstep, height / ystep];
	    },
	    transformToScale: function TilingPattern_transformToScale(graphics) {
	      var scale = this.scale;
	      var tmpScale = [scale[0], 0, 0, scale[1], 0, 0];
	      graphics.transform.apply(graphics, tmpScale);
	    },
	    scaleToContext: function TilingPattern_scaleToContext() {
	      var scale = this.scale;
	      this.ctx.scale(1 / scale[0], 1 / scale[1]);
	    },
	    clipBbox: function clipBbox(graphics, bbox, x0, y0, x1, y1) {
	      if (Array.isArray(bbox) && bbox.length === 4) {
	        var bboxWidth = x1 - x0;
	        var bboxHeight = y1 - y0;
	        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
	        graphics.clip();
	        graphics.endPath();
	      }
	    },
	    setFillAndStrokeStyleToContext: function setFillAndStrokeStyleToContext(graphics, paintType, color) {
	      var context = graphics.ctx,
	          current = graphics.current;
	      switch (paintType) {
	        case PaintType.COLORED:
	          var ctx = this.ctx;
	          context.fillStyle = ctx.fillStyle;
	          context.strokeStyle = ctx.strokeStyle;
	          current.fillColor = ctx.fillStyle;
	          current.strokeColor = ctx.strokeStyle;
	          break;
	        case PaintType.UNCOLORED:
	          var cssColor = _util.Util.makeCssRgb(color[0], color[1], color[2]);
	          context.fillStyle = cssColor;
	          context.strokeStyle = cssColor;
	          current.fillColor = cssColor;
	          current.strokeColor = cssColor;
	          break;
	        default:
	          throw new _util.FormatError('Unsupported paint type: ' + paintType);
	      }
	    },
	    getPattern: function TilingPattern_getPattern(ctx, owner) {
	      var temporaryPatternCanvas = this.createPatternCanvas(owner);
	      ctx = this.ctx;
	      ctx.setTransform.apply(ctx, this.baseTransform);
	      ctx.transform.apply(ctx, this.matrix);
	      this.scaleToContext();
	      return ctx.createPattern(temporaryPatternCanvas, 'repeat');
	    }
	  };
	  return TilingPattern;
	}();
	exports.getShadingPatternFromIR = getShadingPatternFromIR;
	exports.TilingPattern = TilingPattern;
	
	/***/ }),
	/* 119 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFDataTransportStream = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var PDFDataTransportStream = function PDFDataTransportStreamClosure() {
	  function PDFDataTransportStream(params, pdfDataRangeTransport) {
	    var _this = this;
	
	    (0, _util.assert)(pdfDataRangeTransport);
	    this._queuedChunks = [];
	    var initialData = params.initialData;
	    if (initialData && initialData.length > 0) {
	      var buffer = new Uint8Array(initialData).buffer;
	      this._queuedChunks.push(buffer);
	    }
	    this._pdfDataRangeTransport = pdfDataRangeTransport;
	    this._isRangeSupported = !params.disableRange;
	    this._isStreamingSupported = !params.disableStream;
	    this._contentLength = params.length;
	    this._fullRequestReader = null;
	    this._rangeReaders = [];
	    this._pdfDataRangeTransport.addRangeListener(function (begin, chunk) {
	      _this._onReceiveData({
	        begin: begin,
	        chunk: chunk
	      });
	    });
	    this._pdfDataRangeTransport.addProgressListener(function (loaded) {
	      _this._onProgress({ loaded: loaded });
	    });
	    this._pdfDataRangeTransport.addProgressiveReadListener(function (chunk) {
	      _this._onReceiveData({ chunk: chunk });
	    });
	    this._pdfDataRangeTransport.transportReady();
	  }
	  PDFDataTransportStream.prototype = {
	    _onReceiveData: function PDFDataTransportStream_onReceiveData(args) {
	      var buffer = new Uint8Array(args.chunk).buffer;
	      if (args.begin === undefined) {
	        if (this._fullRequestReader) {
	          this._fullRequestReader._enqueue(buffer);
	        } else {
	          this._queuedChunks.push(buffer);
	        }
	      } else {
	        var found = this._rangeReaders.some(function (rangeReader) {
	          if (rangeReader._begin !== args.begin) {
	            return false;
	          }
	          rangeReader._enqueue(buffer);
	          return true;
	        });
	        (0, _util.assert)(found);
	      }
	    },
	    _onProgress: function PDFDataTransportStream_onDataProgress(evt) {
	      if (this._rangeReaders.length > 0) {
	        var firstReader = this._rangeReaders[0];
	        if (firstReader.onProgress) {
	          firstReader.onProgress({ loaded: evt.loaded });
	        }
	      }
	    },
	    _removeRangeReader: function PDFDataTransportStream_removeRangeReader(reader) {
	      var i = this._rangeReaders.indexOf(reader);
	      if (i >= 0) {
	        this._rangeReaders.splice(i, 1);
	      }
	    },
	    getFullReader: function PDFDataTransportStream_getFullReader() {
	      (0, _util.assert)(!this._fullRequestReader);
	      var queuedChunks = this._queuedChunks;
	      this._queuedChunks = null;
	      return new PDFDataTransportStreamReader(this, queuedChunks);
	    },
	    getRangeReader: function PDFDataTransportStream_getRangeReader(begin, end) {
	      var reader = new PDFDataTransportStreamRangeReader(this, begin, end);
	      this._pdfDataRangeTransport.requestDataRange(begin, end);
	      this._rangeReaders.push(reader);
	      return reader;
	    },
	    cancelAllRequests: function PDFDataTransportStream_cancelAllRequests(reason) {
	      if (this._fullRequestReader) {
	        this._fullRequestReader.cancel(reason);
	      }
	      var readers = this._rangeReaders.slice(0);
	      readers.forEach(function (rangeReader) {
	        rangeReader.cancel(reason);
	      });
	      this._pdfDataRangeTransport.abort();
	    }
	  };
	  function PDFDataTransportStreamReader(stream, queuedChunks) {
	    this._stream = stream;
	    this._done = false;
	    this._filename = null;
	    this._queuedChunks = queuedChunks || [];
	    this._requests = [];
	    this._headersReady = Promise.resolve();
	    stream._fullRequestReader = this;
	    this.onProgress = null;
	  }
	  PDFDataTransportStreamReader.prototype = {
	    _enqueue: function PDFDataTransportStreamReader_enqueue(chunk) {
	      if (this._done) {
	        return;
	      }
	      if (this._requests.length > 0) {
	        var requestCapability = this._requests.shift();
	        requestCapability.resolve({
	          value: chunk,
	          done: false
	        });
	        return;
	      }
	      this._queuedChunks.push(chunk);
	    },
	    get headersReady() {
	      return this._headersReady;
	    },
	    get filename() {
	      return this._filename;
	    },
	    get isRangeSupported() {
	      return this._stream._isRangeSupported;
	    },
	    get isStreamingSupported() {
	      return this._stream._isStreamingSupported;
	    },
	    get contentLength() {
	      return this._stream._contentLength;
	    },
	    read: function PDFDataTransportStreamReader_read() {
	      if (this._queuedChunks.length > 0) {
	        var chunk = this._queuedChunks.shift();
	        return Promise.resolve({
	          value: chunk,
	          done: false
	        });
	      }
	      if (this._done) {
	        return Promise.resolve({
	          value: undefined,
	          done: true
	        });
	      }
	      var requestCapability = (0, _util.createPromiseCapability)();
	      this._requests.push(requestCapability);
	      return requestCapability.promise;
	    },
	    cancel: function PDFDataTransportStreamReader_cancel(reason) {
	      this._done = true;
	      this._requests.forEach(function (requestCapability) {
	        requestCapability.resolve({
	          value: undefined,
	          done: true
	        });
	      });
	      this._requests = [];
	    }
	  };
	  function PDFDataTransportStreamRangeReader(stream, begin, end) {
	    this._stream = stream;
	    this._begin = begin;
	    this._end = end;
	    this._queuedChunk = null;
	    this._requests = [];
	    this._done = false;
	    this.onProgress = null;
	  }
	  PDFDataTransportStreamRangeReader.prototype = {
	    _enqueue: function PDFDataTransportStreamRangeReader_enqueue(chunk) {
	      if (this._done) {
	        return;
	      }
	      if (this._requests.length === 0) {
	        this._queuedChunk = chunk;
	      } else {
	        var requestsCapability = this._requests.shift();
	        requestsCapability.resolve({
	          value: chunk,
	          done: false
	        });
	        this._requests.forEach(function (requestCapability) {
	          requestCapability.resolve({
	            value: undefined,
	            done: true
	          });
	        });
	        this._requests = [];
	      }
	      this._done = true;
	      this._stream._removeRangeReader(this);
	    },
	    get isStreamingSupported() {
	      return false;
	    },
	    read: function PDFDataTransportStreamRangeReader_read() {
	      if (this._queuedChunk) {
	        var chunk = this._queuedChunk;
	        this._queuedChunk = null;
	        return Promise.resolve({
	          value: chunk,
	          done: false
	        });
	      }
	      if (this._done) {
	        return Promise.resolve({
	          value: undefined,
	          done: true
	        });
	      }
	      var requestCapability = (0, _util.createPromiseCapability)();
	      this._requests.push(requestCapability);
	      return requestCapability.promise;
	    },
	    cancel: function PDFDataTransportStreamRangeReader_cancel(reason) {
	      this._done = true;
	      this._requests.forEach(function (requestCapability) {
	        requestCapability.resolve({
	          value: undefined,
	          done: true
	        });
	      });
	      this._requests = [];
	      this._stream._removeRangeReader(this);
	    }
	  };
	  return PDFDataTransportStream;
	}();
	exports.PDFDataTransportStream = PDFDataTransportStream;
	
	/***/ }),
	/* 120 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WebGLContext = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __w_pdfjs_require__(0);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WebGLContext = function () {
	  function WebGLContext(_ref) {
	    var _ref$enable = _ref.enable,
	        enable = _ref$enable === undefined ? false : _ref$enable;
	
	    _classCallCheck(this, WebGLContext);
	
	    this._enabled = enable === true;
	  }
	
	  _createClass(WebGLContext, [{
	    key: 'composeSMask',
	    value: function composeSMask(_ref2) {
	      var layer = _ref2.layer,
	          mask = _ref2.mask,
	          properties = _ref2.properties;
	
	      return WebGLUtils.composeSMask(layer, mask, properties);
	    }
	  }, {
	    key: 'drawFigures',
	    value: function drawFigures(_ref3) {
	      var width = _ref3.width,
	          height = _ref3.height,
	          backgroundColor = _ref3.backgroundColor,
	          figures = _ref3.figures,
	          context = _ref3.context;
	
	      return WebGLUtils.drawFigures(width, height, backgroundColor, figures, context);
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      WebGLUtils.cleanup();
	    }
	  }, {
	    key: 'isEnabled',
	    get: function get() {
	      var enabled = this._enabled;
	      if (enabled) {
	        enabled = WebGLUtils.tryInitGL();
	      }
	      return (0, _util.shadow)(this, 'isEnabled', enabled);
	    }
	  }]);
	
	  return WebGLContext;
	}();
	
	var WebGLUtils = function WebGLUtilsClosure() {
	  function loadShader(gl, code, shaderType) {
	    var shader = gl.createShader(shaderType);
	    gl.shaderSource(shader, code);
	    gl.compileShader(shader);
	    var compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
	    if (!compiled) {
	      var errorMsg = gl.getShaderInfoLog(shader);
	      throw new Error('Error during shader compilation: ' + errorMsg);
	    }
	    return shader;
	  }
	  function createVertexShader(gl, code) {
	    return loadShader(gl, code, gl.VERTEX_SHADER);
	  }
	  function createFragmentShader(gl, code) {
	    return loadShader(gl, code, gl.FRAGMENT_SHADER);
	  }
	  function createProgram(gl, shaders) {
	    var program = gl.createProgram();
	    for (var i = 0, ii = shaders.length; i < ii; ++i) {
	      gl.attachShader(program, shaders[i]);
	    }
	    gl.linkProgram(program);
	    var linked = gl.getProgramParameter(program, gl.LINK_STATUS);
	    if (!linked) {
	      var errorMsg = gl.getProgramInfoLog(program);
	      throw new Error('Error during program linking: ' + errorMsg);
	    }
	    return program;
	  }
	  function createTexture(gl, image, textureId) {
	    gl.activeTexture(textureId);
	    var texture = gl.createTexture();
	    gl.bindTexture(gl.TEXTURE_2D, texture);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
	    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
	    return texture;
	  }
	  var currentGL, currentCanvas;
	  function generateGL() {
	    if (currentGL) {
	      return;
	    }
	    currentCanvas = document.createElement('canvas');
	    currentGL = currentCanvas.getContext('webgl', { premultipliedalpha: false });
	  }
	  var smaskVertexShaderCode = '\
	  attribute vec2 a_position;                                    \
	  attribute vec2 a_texCoord;                                    \
	                                                                \
	  uniform vec2 u_resolution;                                    \
	                                                                \
	  varying vec2 v_texCoord;                                      \
	                                                                \
	  void main() {                                                 \
	    vec2 clipSpace = (a_position / u_resolution) * 2.0 - 1.0;   \
	    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
	                                                                \
	    v_texCoord = a_texCoord;                                    \
	  }                                                             ';
	  var smaskFragmentShaderCode = '\
	  precision mediump float;                                      \
	                                                                \
	  uniform vec4 u_backdrop;                                      \
	  uniform int u_subtype;                                        \
	  uniform sampler2D u_image;                                    \
	  uniform sampler2D u_mask;                                     \
	                                                                \
	  varying vec2 v_texCoord;                                      \
	                                                                \
	  void main() {                                                 \
	    vec4 imageColor = texture2D(u_image, v_texCoord);           \
	    vec4 maskColor = texture2D(u_mask, v_texCoord);             \
	    if (u_backdrop.a > 0.0) {                                   \
	      maskColor.rgb = maskColor.rgb * maskColor.a +             \
	                      u_backdrop.rgb * (1.0 - maskColor.a);     \
	    }                                                           \
	    float lum;                                                  \
	    if (u_subtype == 0) {                                       \
	      lum = maskColor.a;                                        \
	    } else {                                                    \
	      lum = maskColor.r * 0.3 + maskColor.g * 0.59 +            \
	            maskColor.b * 0.11;                                 \
	    }                                                           \
	    imageColor.a *= lum;                                        \
	    imageColor.rgb *= imageColor.a;                             \
	    gl_FragColor = imageColor;                                  \
	  }                                                             ';
	  var smaskCache = null;
	  function initSmaskGL() {
	    var canvas, gl;
	    generateGL();
	    canvas = currentCanvas;
	    currentCanvas = null;
	    gl = currentGL;
	    currentGL = null;
	    var vertexShader = createVertexShader(gl, smaskVertexShaderCode);
	    var fragmentShader = createFragmentShader(gl, smaskFragmentShaderCode);
	    var program = createProgram(gl, [vertexShader, fragmentShader]);
	    gl.useProgram(program);
	    var cache = {};
	    cache.gl = gl;
	    cache.canvas = canvas;
	    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
	    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
	    cache.backdropLocation = gl.getUniformLocation(program, 'u_backdrop');
	    cache.subtypeLocation = gl.getUniformLocation(program, 'u_subtype');
	    var texCoordLocation = gl.getAttribLocation(program, 'a_texCoord');
	    var texLayerLocation = gl.getUniformLocation(program, 'u_image');
	    var texMaskLocation = gl.getUniformLocation(program, 'u_mask');
	    var texCoordBuffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0]), gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(texCoordLocation);
	    gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);
	    gl.uniform1i(texLayerLocation, 0);
	    gl.uniform1i(texMaskLocation, 1);
	    smaskCache = cache;
	  }
	  function composeSMask(layer, mask, properties) {
	    var width = layer.width,
	        height = layer.height;
	    if (!smaskCache) {
	      initSmaskGL();
	    }
	    var cache = smaskCache,
	        canvas = cache.canvas,
	        gl = cache.gl;
	    canvas.width = width;
	    canvas.height = height;
	    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
	    gl.uniform2f(cache.resolutionLocation, width, height);
	    if (properties.backdrop) {
	      gl.uniform4f(cache.resolutionLocation, properties.backdrop[0], properties.backdrop[1], properties.backdrop[2], 1);
	    } else {
	      gl.uniform4f(cache.resolutionLocation, 0, 0, 0, 0);
	    }
	    gl.uniform1i(cache.subtypeLocation, properties.subtype === 'Luminosity' ? 1 : 0);
	    var texture = createTexture(gl, layer, gl.TEXTURE0);
	    var maskTexture = createTexture(gl, mask, gl.TEXTURE1);
	    var buffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
	    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, width, 0, 0, height, 0, height, width, 0, width, height]), gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(cache.positionLocation);
	    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
	    gl.clearColor(0, 0, 0, 0);
	    gl.enable(gl.BLEND);
	    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
	    gl.clear(gl.COLOR_BUFFER_BIT);
	    gl.drawArrays(gl.TRIANGLES, 0, 6);
	    gl.flush();
	    gl.deleteTexture(texture);
	    gl.deleteTexture(maskTexture);
	    gl.deleteBuffer(buffer);
	    return canvas;
	  }
	  var figuresVertexShaderCode = '\
	  attribute vec2 a_position;                                    \
	  attribute vec3 a_color;                                       \
	                                                                \
	  uniform vec2 u_resolution;                                    \
	  uniform vec2 u_scale;                                         \
	  uniform vec2 u_offset;                                        \
	                                                                \
	  varying vec4 v_color;                                         \
	                                                                \
	  void main() {                                                 \
	    vec2 position = (a_position + u_offset) * u_scale;          \
	    vec2 clipSpace = (position / u_resolution) * 2.0 - 1.0;     \
	    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
	                                                                \
	    v_color = vec4(a_color / 255.0, 1.0);                       \
	  }                                                             ';
	  var figuresFragmentShaderCode = '\
	  precision mediump float;                                      \
	                                                                \
	  varying vec4 v_color;                                         \
	                                                                \
	  void main() {                                                 \
	    gl_FragColor = v_color;                                     \
	  }                                                             ';
	  var figuresCache = null;
	  function initFiguresGL() {
	    var canvas, gl;
	    generateGL();
	    canvas = currentCanvas;
	    currentCanvas = null;
	    gl = currentGL;
	    currentGL = null;
	    var vertexShader = createVertexShader(gl, figuresVertexShaderCode);
	    var fragmentShader = createFragmentShader(gl, figuresFragmentShaderCode);
	    var program = createProgram(gl, [vertexShader, fragmentShader]);
	    gl.useProgram(program);
	    var cache = {};
	    cache.gl = gl;
	    cache.canvas = canvas;
	    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
	    cache.scaleLocation = gl.getUniformLocation(program, 'u_scale');
	    cache.offsetLocation = gl.getUniformLocation(program, 'u_offset');
	    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
	    cache.colorLocation = gl.getAttribLocation(program, 'a_color');
	    figuresCache = cache;
	  }
	  function drawFigures(width, height, backgroundColor, figures, context) {
	    if (!figuresCache) {
	      initFiguresGL();
	    }
	    var cache = figuresCache,
	        canvas = cache.canvas,
	        gl = cache.gl;
	    canvas.width = width;
	    canvas.height = height;
	    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
	    gl.uniform2f(cache.resolutionLocation, width, height);
	    var count = 0;
	    var i, ii, rows;
	    for (i = 0, ii = figures.length; i < ii; i++) {
	      switch (figures[i].type) {
	        case 'lattice':
	          rows = figures[i].coords.length / figures[i].verticesPerRow | 0;
	          count += (rows - 1) * (figures[i].verticesPerRow - 1) * 6;
	          break;
	        case 'triangles':
	          count += figures[i].coords.length;
	          break;
	      }
	    }
	    var coords = new Float32Array(count * 2);
	    var colors = new Uint8Array(count * 3);
	    var coordsMap = context.coords,
	        colorsMap = context.colors;
	    var pIndex = 0,
	        cIndex = 0;
	    for (i = 0, ii = figures.length; i < ii; i++) {
	      var figure = figures[i],
	          ps = figure.coords,
	          cs = figure.colors;
	      switch (figure.type) {
	        case 'lattice':
	          var cols = figure.verticesPerRow;
	          rows = ps.length / cols | 0;
	          for (var row = 1; row < rows; row++) {
	            var offset = row * cols + 1;
	            for (var col = 1; col < cols; col++, offset++) {
	              coords[pIndex] = coordsMap[ps[offset - cols - 1]];
	              coords[pIndex + 1] = coordsMap[ps[offset - cols - 1] + 1];
	              coords[pIndex + 2] = coordsMap[ps[offset - cols]];
	              coords[pIndex + 3] = coordsMap[ps[offset - cols] + 1];
	              coords[pIndex + 4] = coordsMap[ps[offset - 1]];
	              coords[pIndex + 5] = coordsMap[ps[offset - 1] + 1];
	              colors[cIndex] = colorsMap[cs[offset - cols - 1]];
	              colors[cIndex + 1] = colorsMap[cs[offset - cols - 1] + 1];
	              colors[cIndex + 2] = colorsMap[cs[offset - cols - 1] + 2];
	              colors[cIndex + 3] = colorsMap[cs[offset - cols]];
	              colors[cIndex + 4] = colorsMap[cs[offset - cols] + 1];
	              colors[cIndex + 5] = colorsMap[cs[offset - cols] + 2];
	              colors[cIndex + 6] = colorsMap[cs[offset - 1]];
	              colors[cIndex + 7] = colorsMap[cs[offset - 1] + 1];
	              colors[cIndex + 8] = colorsMap[cs[offset - 1] + 2];
	              coords[pIndex + 6] = coords[pIndex + 2];
	              coords[pIndex + 7] = coords[pIndex + 3];
	              coords[pIndex + 8] = coords[pIndex + 4];
	              coords[pIndex + 9] = coords[pIndex + 5];
	              coords[pIndex + 10] = coordsMap[ps[offset]];
	              coords[pIndex + 11] = coordsMap[ps[offset] + 1];
	              colors[cIndex + 9] = colors[cIndex + 3];
	              colors[cIndex + 10] = colors[cIndex + 4];
	              colors[cIndex + 11] = colors[cIndex + 5];
	              colors[cIndex + 12] = colors[cIndex + 6];
	              colors[cIndex + 13] = colors[cIndex + 7];
	              colors[cIndex + 14] = colors[cIndex + 8];
	              colors[cIndex + 15] = colorsMap[cs[offset]];
	              colors[cIndex + 16] = colorsMap[cs[offset] + 1];
	              colors[cIndex + 17] = colorsMap[cs[offset] + 2];
	              pIndex += 12;
	              cIndex += 18;
	            }
	          }
	          break;
	        case 'triangles':
	          for (var j = 0, jj = ps.length; j < jj; j++) {
	            coords[pIndex] = coordsMap[ps[j]];
	            coords[pIndex + 1] = coordsMap[ps[j] + 1];
	            colors[cIndex] = colorsMap[cs[j]];
	            colors[cIndex + 1] = colorsMap[cs[j] + 1];
	            colors[cIndex + 2] = colorsMap[cs[j] + 2];
	            pIndex += 2;
	            cIndex += 3;
	          }
	          break;
	      }
	    }
	    if (backgroundColor) {
	      gl.clearColor(backgroundColor[0] / 255, backgroundColor[1] / 255, backgroundColor[2] / 255, 1.0);
	    } else {
	      gl.clearColor(0, 0, 0, 0);
	    }
	    gl.clear(gl.COLOR_BUFFER_BIT);
	    var coordsBuffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, coordsBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, coords, gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(cache.positionLocation);
	    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
	    var colorsBuffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, colorsBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, colors, gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(cache.colorLocation);
	    gl.vertexAttribPointer(cache.colorLocation, 3, gl.UNSIGNED_BYTE, false, 0, 0);
	    gl.uniform2f(cache.scaleLocation, context.scaleX, context.scaleY);
	    gl.uniform2f(cache.offsetLocation, context.offsetX, context.offsetY);
	    gl.drawArrays(gl.TRIANGLES, 0, count);
	    gl.flush();
	    gl.deleteBuffer(coordsBuffer);
	    gl.deleteBuffer(colorsBuffer);
	    return canvas;
	  }
	  return {
	    tryInitGL: function tryInitGL() {
	      try {
	        generateGL();
	        return !!currentGL;
	      } catch (ex) {}
	      return false;
	    },
	
	    composeSMask: composeSMask,
	    drawFigures: drawFigures,
	    cleanup: function cleanup() {
	      if (smaskCache && smaskCache.canvas) {
	        smaskCache.canvas.width = 0;
	        smaskCache.canvas.height = 0;
	      }
	      if (figuresCache && figuresCache.canvas) {
	        figuresCache.canvas.width = 0;
	        figuresCache.canvas.height = 0;
	      }
	      smaskCache = null;
	      figuresCache = null;
	    }
	  };
	}();
	exports.WebGLContext = WebGLContext;
	
	/***/ }),
	/* 121 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFNodeStream = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __w_pdfjs_require__(0);
	
	var _network_utils = __w_pdfjs_require__(39);
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var fs = __webpack_require__(2075);
	var http = __webpack_require__(2076);
	var https = __webpack_require__(2077);
	var url = __webpack_require__(951);
	
	var fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;
	
	var PDFNodeStream = function () {
	  function PDFNodeStream(source) {
	    _classCallCheck(this, PDFNodeStream);
	
	    this.source = source;
	    this.url = url.parse(source.url);
	    this.isHttp = this.url.protocol === 'http:' || this.url.protocol === 'https:';
	    this.isFsUrl = this.url.protocol === 'file:' || !this.url.host;
	    this.httpHeaders = this.isHttp && source.httpHeaders || {};
	    this._fullRequest = null;
	    this._rangeRequestReaders = [];
	  }
	
	  _createClass(PDFNodeStream, [{
	    key: 'getFullReader',
	    value: function getFullReader() {
	      (0, _util.assert)(!this._fullRequest);
	      this._fullRequest = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
	      return this._fullRequest;
	    }
	  }, {
	    key: 'getRangeReader',
	    value: function getRangeReader(start, end) {
	      var rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
	      this._rangeRequestReaders.push(rangeReader);
	      return rangeReader;
	    }
	  }, {
	    key: 'cancelAllRequests',
	    value: function cancelAllRequests(reason) {
	      if (this._fullRequest) {
	        this._fullRequest.cancel(reason);
	      }
	      var readers = this._rangeRequestReaders.slice(0);
	      readers.forEach(function (reader) {
	        reader.cancel(reason);
	      });
	    }
	  }]);
	
	  return PDFNodeStream;
	}();
	
	var BaseFullReader = function () {
	  function BaseFullReader(stream) {
	    _classCallCheck(this, BaseFullReader);
	
	    this._url = stream.url;
	    this._done = false;
	    this._errored = false;
	    this._reason = null;
	    this.onProgress = null;
	    var source = stream.source;
	    this._contentLength = source.length;
	    this._loaded = 0;
	    this._filename = null;
	    this._disableRange = source.disableRange || false;
	    this._rangeChunkSize = source.rangeChunkSize;
	    if (!this._rangeChunkSize && !this._disableRange) {
	      this._disableRange = true;
	    }
	    this._isStreamingSupported = !source.disableStream;
	    this._isRangeSupported = !source.disableRange;
	    this._readableStream = null;
	    this._readCapability = (0, _util.createPromiseCapability)();
	    this._headersCapability = (0, _util.createPromiseCapability)();
	  }
	
	  _createClass(BaseFullReader, [{
	    key: 'read',
	    value: function read() {
	      var _this = this;
	
	      return this._readCapability.promise.then(function () {
	        if (_this._done) {
	          return Promise.resolve({
	            value: undefined,
	            done: true
	          });
	        }
	        if (_this._errored) {
	          return Promise.reject(_this._reason);
	        }
	        var chunk = _this._readableStream.read();
	        if (chunk === null) {
	          _this._readCapability = (0, _util.createPromiseCapability)();
	          return _this.read();
	        }
	        _this._loaded += chunk.length;
	        if (_this.onProgress) {
	          _this.onProgress({
	            loaded: _this._loaded,
	            total: _this._contentLength
	          });
	        }
	        var buffer = new Uint8Array(chunk).buffer;
	        return Promise.resolve({
	          value: buffer,
	          done: false
	        });
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel(reason) {
	      if (!this._readableStream) {
	        this._error(reason);
	        return;
	      }
	      this._readableStream.destroy(reason);
	    }
	  }, {
	    key: '_error',
	    value: function _error(reason) {
	      this._errored = true;
	      this._reason = reason;
	      this._readCapability.resolve();
	    }
	  }, {
	    key: '_setReadableStream',
	    value: function _setReadableStream(readableStream) {
	      var _this2 = this;
	
	      this._readableStream = readableStream;
	      readableStream.on('readable', function () {
	        _this2._readCapability.resolve();
	      });
	      readableStream.on('end', function () {
	        readableStream.destroy();
	        _this2._done = true;
	        _this2._readCapability.resolve();
	      });
	      readableStream.on('error', function (reason) {
	        _this2._error(reason);
	      });
	      if (!this._isStreamingSupported && this._isRangeSupported) {
	        this._error(new _util.AbortException('streaming is disabled'));
	      }
	      if (this._errored) {
	        this._readableStream.destroy(this._reason);
	      }
	    }
	  }, {
	    key: 'headersReady',
	    get: function get() {
	      return this._headersCapability.promise;
	    }
	  }, {
	    key: 'filename',
	    get: function get() {
	      return this._filename;
	    }
	  }, {
	    key: 'contentLength',
	    get: function get() {
	      return this._contentLength;
	    }
	  }, {
	    key: 'isRangeSupported',
	    get: function get() {
	      return this._isRangeSupported;
	    }
	  }, {
	    key: 'isStreamingSupported',
	    get: function get() {
	      return this._isStreamingSupported;
	    }
	  }]);
	
	  return BaseFullReader;
	}();
	
	var BaseRangeReader = function () {
	  function BaseRangeReader(stream) {
	    _classCallCheck(this, BaseRangeReader);
	
	    this._url = stream.url;
	    this._done = false;
	    this._errored = false;
	    this._reason = null;
	    this.onProgress = null;
	    this._loaded = 0;
	    this._readableStream = null;
	    this._readCapability = (0, _util.createPromiseCapability)();
	    var source = stream.source;
	    this._isStreamingSupported = !source.disableStream;
	  }
	
	  _createClass(BaseRangeReader, [{
	    key: 'read',
	    value: function read() {
	      var _this3 = this;
	
	      return this._readCapability.promise.then(function () {
	        if (_this3._done) {
	          return Promise.resolve({
	            value: undefined,
	            done: true
	          });
	        }
	        if (_this3._errored) {
	          return Promise.reject(_this3._reason);
	        }
	        var chunk = _this3._readableStream.read();
	        if (chunk === null) {
	          _this3._readCapability = (0, _util.createPromiseCapability)();
	          return _this3.read();
	        }
	        _this3._loaded += chunk.length;
	        if (_this3.onProgress) {
	          _this3.onProgress({ loaded: _this3._loaded });
	        }
	        var buffer = new Uint8Array(chunk).buffer;
	        return Promise.resolve({
	          value: buffer,
	          done: false
	        });
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel(reason) {
	      if (!this._readableStream) {
	        this._error(reason);
	        return;
	      }
	      this._readableStream.destroy(reason);
	    }
	  }, {
	    key: '_error',
	    value: function _error(reason) {
	      this._errored = true;
	      this._reason = reason;
	      this._readCapability.resolve();
	    }
	  }, {
	    key: '_setReadableStream',
	    value: function _setReadableStream(readableStream) {
	      var _this4 = this;
	
	      this._readableStream = readableStream;
	      readableStream.on('readable', function () {
	        _this4._readCapability.resolve();
	      });
	      readableStream.on('end', function () {
	        readableStream.destroy();
	        _this4._done = true;
	        _this4._readCapability.resolve();
	      });
	      readableStream.on('error', function (reason) {
	        _this4._error(reason);
	      });
	      if (this._errored) {
	        this._readableStream.destroy(this._reason);
	      }
	    }
	  }, {
	    key: 'isStreamingSupported',
	    get: function get() {
	      return this._isStreamingSupported;
	    }
	  }]);
	
	  return BaseRangeReader;
	}();
	
	function createRequestOptions(url, headers) {
	  return {
	    protocol: url.protocol,
	    auth: url.auth,
	    host: url.hostname,
	    port: url.port,
	    path: url.path,
	    method: 'GET',
	    headers: headers
	  };
	}
	
	var PDFNodeStreamFullReader = function (_BaseFullReader) {
	  _inherits(PDFNodeStreamFullReader, _BaseFullReader);
	
	  function PDFNodeStreamFullReader(stream) {
	    _classCallCheck(this, PDFNodeStreamFullReader);
	
	    var _this5 = _possibleConstructorReturn(this, (PDFNodeStreamFullReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFullReader)).call(this, stream));
	
	    var handleResponse = function handleResponse(response) {
	      _this5._headersCapability.resolve();
	      _this5._setReadableStream(response);
	      var getResponseHeader = function getResponseHeader(name) {
	        return _this5._readableStream.headers[name.toLowerCase()];
	      };
	
	      var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
	        getResponseHeader: getResponseHeader,
	        isHttp: stream.isHttp,
	        rangeChunkSize: _this5._rangeChunkSize,
	        disableRange: _this5._disableRange
	      }),
	          allowRangeRequests = _validateRangeRequest.allowRangeRequests,
	          suggestedLength = _validateRangeRequest.suggestedLength;
	
	      if (allowRangeRequests) {
	        _this5._isRangeSupported = true;
	      }
	      _this5._contentLength = suggestedLength;
	      _this5._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
	    };
	    _this5._request = null;
	    if (_this5._url.protocol === 'http:') {
	      _this5._request = http.request(createRequestOptions(_this5._url, stream.httpHeaders), handleResponse);
	    } else {
	      _this5._request = https.request(createRequestOptions(_this5._url, stream.httpHeaders), handleResponse);
	    }
	    _this5._request.on('error', function (reason) {
	      _this5._errored = true;
	      _this5._reason = reason;
	      _this5._headersCapability.reject(reason);
	    });
	    _this5._request.end();
	    return _this5;
	  }
	
	  return PDFNodeStreamFullReader;
	}(BaseFullReader);
	
	var PDFNodeStreamRangeReader = function (_BaseRangeReader) {
	  _inherits(PDFNodeStreamRangeReader, _BaseRangeReader);
	
	  function PDFNodeStreamRangeReader(stream, start, end) {
	    _classCallCheck(this, PDFNodeStreamRangeReader);
	
	    var _this6 = _possibleConstructorReturn(this, (PDFNodeStreamRangeReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamRangeReader)).call(this, stream));
	
	    _this6._httpHeaders = {};
	    for (var property in stream.httpHeaders) {
	      var value = stream.httpHeaders[property];
	      if (typeof value === 'undefined') {
	        continue;
	      }
	      _this6._httpHeaders[property] = value;
	    }
	    _this6._httpHeaders['Range'] = 'bytes=' + start + '-' + (end - 1);
	    _this6._request = null;
	    if (_this6._url.protocol === 'http:') {
	      _this6._request = http.request(createRequestOptions(_this6._url, _this6._httpHeaders), function (response) {
	        _this6._setReadableStream(response);
	      });
	    } else {
	      _this6._request = https.request(createRequestOptions(_this6._url, _this6._httpHeaders), function (response) {
	        _this6._setReadableStream(response);
	      });
	    }
	    _this6._request.on('error', function (reason) {
	      _this6._errored = true;
	      _this6._reason = reason;
	    });
	    _this6._request.end();
	    return _this6;
	  }
	
	  return PDFNodeStreamRangeReader;
	}(BaseRangeReader);
	
	var PDFNodeStreamFsFullReader = function (_BaseFullReader2) {
	  _inherits(PDFNodeStreamFsFullReader, _BaseFullReader2);
	
	  function PDFNodeStreamFsFullReader(stream) {
	    _classCallCheck(this, PDFNodeStreamFsFullReader);
	
	    var _this7 = _possibleConstructorReturn(this, (PDFNodeStreamFsFullReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFsFullReader)).call(this, stream));
	
	    var path = decodeURIComponent(_this7._url.path);
	    if (fileUriRegex.test(_this7._url.href)) {
	      path = path.replace(/^\//, '');
	    }
	    fs.lstat(path, function (error, stat) {
	      if (error) {
	        _this7._errored = true;
	        _this7._reason = error;
	        _this7._headersCapability.reject(error);
	        return;
	      }
	      _this7._contentLength = stat.size;
	      _this7._setReadableStream(fs.createReadStream(path));
	      _this7._headersCapability.resolve();
	    });
	    return _this7;
	  }
	
	  return PDFNodeStreamFsFullReader;
	}(BaseFullReader);
	
	var PDFNodeStreamFsRangeReader = function (_BaseRangeReader2) {
	  _inherits(PDFNodeStreamFsRangeReader, _BaseRangeReader2);
	
	  function PDFNodeStreamFsRangeReader(stream, start, end) {
	    _classCallCheck(this, PDFNodeStreamFsRangeReader);
	
	    var _this8 = _possibleConstructorReturn(this, (PDFNodeStreamFsRangeReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFsRangeReader)).call(this, stream));
	
	    var path = decodeURIComponent(_this8._url.path);
	    if (fileUriRegex.test(_this8._url.href)) {
	      path = path.replace(/^\//, '');
	    }
	    _this8._setReadableStream(fs.createReadStream(path, {
	      start: start,
	      end: end - 1
	    }));
	    return _this8;
	  }
	
	  return PDFNodeStreamFsRangeReader;
	}(BaseRangeReader);
	
	exports.PDFNodeStream = PDFNodeStream;
	
	/***/ }),
	/* 122 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	function getFilenameFromContentDispositionHeader(contentDisposition) {
	  var needsEncodingFixup = true;
	  var tmp = /(?:^|;)\s*filename\*\s*=\s*([^;\s]+)/i.exec(contentDisposition);
	  if (tmp) {
	    tmp = tmp[1];
	    var filename = rfc2616unquote(tmp);
	    filename = unescape(filename);
	    filename = rfc5987decode(filename);
	    filename = rfc2047decode(filename);
	    return fixupEncoding(filename);
	  }
	  tmp = rfc2231getparam(contentDisposition);
	  if (tmp) {
	    var _filename = rfc2047decode(tmp);
	    return fixupEncoding(_filename);
	  }
	  tmp = /(?:^|;)\s*filename\s*=\s*([^;\s]+)/.exec(contentDisposition);
	  if (tmp) {
	    tmp = tmp[1];
	    var _filename2 = rfc2616unquote(tmp);
	    _filename2 = rfc2047decode(_filename2);
	    return fixupEncoding(_filename2);
	  }
	  function textdecode(encoding, value) {
	    if (encoding) {
	      if (!/^[^\x00-\xFF]+$/.test(value)) {
	        return value;
	      }
	      try {
	        var decoder = new TextDecoder(encoding, { fatal: true });
	        var bytes = new Array(value.length);
	        for (var i = 0; i < value.length; ++i) {
	          bytes[i] = value.charCodeAt(0);
	        }
	        value = decoder.decode(new Uint8Array(bytes));
	        needsEncodingFixup = false;
	      } catch (e) {
	        if (/^utf-?8$/i.test(encoding)) {
	          value = decodeURIComponent(escape(value));
	          needsEncodingFixup = false;
	        }
	      }
	    }
	    return value;
	  }
	  function fixupEncoding(value) {
	    if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
	      return textdecode('utf-8', value);
	    }
	    return value;
	  }
	  function rfc2231getparam(contentDisposition) {
	    var matches = [],
	        match = void 0;
	    var iter = /(?:^|;)\s*filename\*((?!0\d)\d+)(\*?)\s*=\s*([^;\s]+)/ig;
	    while ((match = iter.exec(contentDisposition)) !== null) {
	      var _match = match,
	          _match2 = _slicedToArray(_match, 4),
	          n = _match2[1],
	          quot = _match2[2],
	          part = _match2[3];
	
	      n = parseInt(n, 10);
	      if (n in matches) {
	        if (n === 0) {
	          break;
	        }
	        continue;
	      }
	      matches[n] = [quot, part];
	    }
	    var parts = [];
	    for (var _n = 0; _n < matches.length; ++_n) {
	      if (!(_n in matches)) {
	        break;
	      }
	
	      var _matches$_n = _slicedToArray(matches[_n], 2),
	          _quot = _matches$_n[0],
	          _part = _matches$_n[1];
	
	      _part = rfc2616unquote(_part);
	      if (_quot) {
	        _part = unescape(_part);
	        if (_n === 0) {
	          _part = rfc5987decode(_part);
	        }
	      }
	      parts.push(_part);
	    }
	    return parts.join('');
	  }
	  function rfc2616unquote(value) {
	    if (value.charAt(0) === '"') {
	      var parts = value.slice(1).split('\\"');
	      for (var i = 0; i < parts.length; ++i) {
	        var quotindex = parts[i].indexOf('"');
	        if (quotindex !== -1) {
	          parts[i] = parts[i].slice(0, quotindex);
	          parts.length = i + 1;
	        }
	        parts[i] = parts[i].replace(/\\(.)/g, '$1');
	      }
	      value = parts.join('"');
	    }
	    return value;
	  }
	  function rfc5987decode(extvalue) {
	    var encodingend = extvalue.indexOf('\'');
	    if (encodingend === -1) {
	      return extvalue;
	    }
	    var encoding = extvalue.slice(0, encodingend);
	    var langvalue = extvalue.slice(encodingend + 1);
	    var value = langvalue.replace(/^[^']*'/, '');
	    return textdecode(encoding, value);
	  }
	  function rfc2047decode(value) {
	    if (value.slice(0, 2) !== '=?' || /[\x00-\x19\x80-\xff]/.test(value)) {
	      return value;
	    }
	    return value.replace(/=\?([\w\-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function (_, charset, encoding, text) {
	      if (encoding === 'q' || encoding === 'Q') {
	        text = text.replace(/_/g, ' ');
	        text = text.replace(/=([0-9a-fA-F]{2})/g, function (_, hex) {
	          return String.fromCharCode(parseInt(hex, 16));
	        });
	        return textdecode(charset, text);
	      }
	      try {
	        return atob(text);
	      } catch (e) {
	        return text;
	      }
	    });
	  }
	  return '';
	}
	exports.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;
	
	/***/ }),
	/* 123 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFFetchStream = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __w_pdfjs_require__(0);
	
	var _network_utils = __w_pdfjs_require__(39);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function createFetchOptions(headers, withCredentials) {
	  return {
	    method: 'GET',
	    headers: headers,
	    mode: 'cors',
	    credentials: withCredentials ? 'include' : 'same-origin',
	    redirect: 'follow'
	  };
	}
	
	var PDFFetchStream = function () {
	  function PDFFetchStream(source) {
	    _classCallCheck(this, PDFFetchStream);
	
	    this.source = source;
	    this.isHttp = /^https?:/i.test(source.url);
	    this.httpHeaders = this.isHttp && source.httpHeaders || {};
	    this._fullRequestReader = null;
	    this._rangeRequestReaders = [];
	  }
	
	  _createClass(PDFFetchStream, [{
	    key: 'getFullReader',
	    value: function getFullReader() {
	      (0, _util.assert)(!this._fullRequestReader);
	      this._fullRequestReader = new PDFFetchStreamReader(this);
	      return this._fullRequestReader;
	    }
	  }, {
	    key: 'getRangeReader',
	    value: function getRangeReader(begin, end) {
	      var reader = new PDFFetchStreamRangeReader(this, begin, end);
	      this._rangeRequestReaders.push(reader);
	      return reader;
	    }
	  }, {
	    key: 'cancelAllRequests',
	    value: function cancelAllRequests(reason) {
	      if (this._fullRequestReader) {
	        this._fullRequestReader.cancel(reason);
	      }
	      var readers = this._rangeRequestReaders.slice(0);
	      readers.forEach(function (reader) {
	        reader.cancel(reason);
	      });
	    }
	  }]);
	
	  return PDFFetchStream;
	}();
	
	var PDFFetchStreamReader = function () {
	  function PDFFetchStreamReader(stream) {
	    var _this = this;
	
	    _classCallCheck(this, PDFFetchStreamReader);
	
	    this._stream = stream;
	    this._reader = null;
	    this._loaded = 0;
	    this._filename = null;
	    var source = stream.source;
	    this._withCredentials = source.withCredentials;
	    this._contentLength = source.length;
	    this._headersCapability = (0, _util.createPromiseCapability)();
	    this._disableRange = source.disableRange;
	    this._rangeChunkSize = source.rangeChunkSize;
	    if (!this._rangeChunkSize && !this._disableRange) {
	      this._disableRange = true;
	    }
	    this._isRangeSupported = !source.disableRange;
	    this._isStreamingSupported = !source.disableStream;
	    this._headers = new Headers();
	    for (var property in this._stream.httpHeaders) {
	      var value = this._stream.httpHeaders[property];
	      if (typeof value === 'undefined') {
	        continue;
	      }
	      this._headers.append(property, value);
	    }
	    var url = source.url;
	    fetch(url, createFetchOptions(this._headers, this._withCredentials)).then(function (response) {
	      if (!(0, _network_utils.validateResponseStatus)(response.status)) {
	        throw (0, _network_utils.createResponseStatusError)(response.status, url);
	      }
	      _this._reader = response.body.getReader();
	      _this._headersCapability.resolve();
	      var getResponseHeader = function getResponseHeader(name) {
	        return response.headers.get(name);
	      };
	
	      var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
	        getResponseHeader: getResponseHeader,
	        isHttp: _this._stream.isHttp,
	        rangeChunkSize: _this._rangeChunkSize,
	        disableRange: _this._disableRange
	      }),
	          allowRangeRequests = _validateRangeRequest.allowRangeRequests,
	          suggestedLength = _validateRangeRequest.suggestedLength;
	
	      _this._contentLength = suggestedLength;
	      _this._isRangeSupported = allowRangeRequests;
	      _this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
	      if (!_this._isStreamingSupported && _this._isRangeSupported) {
	        _this.cancel(new _util.AbortException('streaming is disabled'));
	      }
	    }).catch(this._headersCapability.reject);
	    this.onProgress = null;
	  }
	
	  _createClass(PDFFetchStreamReader, [{
	    key: 'read',
	    value: function read() {
	      var _this2 = this;
	
	      return this._headersCapability.promise.then(function () {
	        return _this2._reader.read().then(function (_ref) {
	          var value = _ref.value,
	              done = _ref.done;
	
	          if (done) {
	            return Promise.resolve({
	              value: value,
	              done: done
	            });
	          }
	          _this2._loaded += value.byteLength;
	          if (_this2.onProgress) {
	            _this2.onProgress({
	              loaded: _this2._loaded,
	              total: _this2._contentLength
	            });
	          }
	          var buffer = new Uint8Array(value).buffer;
	          return Promise.resolve({
	            value: buffer,
	            done: false
	          });
	        });
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel(reason) {
	      if (this._reader) {
	        this._reader.cancel(reason);
	      }
	    }
	  }, {
	    key: 'headersReady',
	    get: function get() {
	      return this._headersCapability.promise;
	    }
	  }, {
	    key: 'filename',
	    get: function get() {
	      return this._filename;
	    }
	  }, {
	    key: 'contentLength',
	    get: function get() {
	      return this._contentLength;
	    }
	  }, {
	    key: 'isRangeSupported',
	    get: function get() {
	      return this._isRangeSupported;
	    }
	  }, {
	    key: 'isStreamingSupported',
	    get: function get() {
	      return this._isStreamingSupported;
	    }
	  }]);
	
	  return PDFFetchStreamReader;
	}();
	
	var PDFFetchStreamRangeReader = function () {
	  function PDFFetchStreamRangeReader(stream, begin, end) {
	    var _this3 = this;
	
	    _classCallCheck(this, PDFFetchStreamRangeReader);
	
	    this._stream = stream;
	    this._reader = null;
	    this._loaded = 0;
	    var source = stream.source;
	    this._withCredentials = source.withCredentials;
	    this._readCapability = (0, _util.createPromiseCapability)();
	    this._isStreamingSupported = !source.disableStream;
	    this._headers = new Headers();
	    for (var property in this._stream.httpHeaders) {
	      var value = this._stream.httpHeaders[property];
	      if (typeof value === 'undefined') {
	        continue;
	      }
	      this._headers.append(property, value);
	    }
	    var rangeStr = begin + '-' + (end - 1);
	    this._headers.append('Range', 'bytes=' + rangeStr);
	    var url = source.url;
	    fetch(url, createFetchOptions(this._headers, this._withCredentials)).then(function (response) {
	      if (!(0, _network_utils.validateResponseStatus)(response.status)) {
	        throw (0, _network_utils.createResponseStatusError)(response.status, url);
	      }
	      _this3._readCapability.resolve();
	      _this3._reader = response.body.getReader();
	    });
	    this.onProgress = null;
	  }
	
	  _createClass(PDFFetchStreamRangeReader, [{
	    key: 'read',
	    value: function read() {
	      var _this4 = this;
	
	      return this._readCapability.promise.then(function () {
	        return _this4._reader.read().then(function (_ref2) {
	          var value = _ref2.value,
	              done = _ref2.done;
	
	          if (done) {
	            return Promise.resolve({
	              value: value,
	              done: done
	            });
	          }
	          _this4._loaded += value.byteLength;
	          if (_this4.onProgress) {
	            _this4.onProgress({ loaded: _this4._loaded });
	          }
	          var buffer = new Uint8Array(value).buffer;
	          return Promise.resolve({
	            value: buffer,
	            done: false
	          });
	        });
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel(reason) {
	      if (this._reader) {
	        this._reader.cancel(reason);
	      }
	    }
	  }, {
	    key: 'isStreamingSupported',
	    get: function get() {
	      return this._isStreamingSupported;
	    }
	  }]);
	
	  return PDFFetchStreamRangeReader;
	}();
	
	exports.PDFFetchStream = PDFFetchStream;
	
	/***/ }),
	/* 124 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NetworkManager = exports.PDFNetworkStream = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _network_utils = __w_pdfjs_require__(39);
	
	var _global_scope = __w_pdfjs_require__(14);
	
	var _global_scope2 = _interopRequireDefault(_global_scope);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	var OK_RESPONSE = 200;
	var PARTIAL_CONTENT_RESPONSE = 206;
	function NetworkManager(url, args) {
	  this.url = url;
	  args = args || {};
	  this.isHttp = /^https?:/i.test(url);
	  this.httpHeaders = this.isHttp && args.httpHeaders || {};
	  this.withCredentials = args.withCredentials || false;
	  this.getXhr = args.getXhr || function NetworkManager_getXhr() {
	    return new XMLHttpRequest();
	  };
	  this.currXhrId = 0;
	  this.pendingRequests = Object.create(null);
	  this.loadedRequests = Object.create(null);
	}
	function getArrayBuffer(xhr) {
	  var data = xhr.response;
	  if (typeof data !== 'string') {
	    return data;
	  }
	  var array = (0, _util.stringToBytes)(data);
	  return array.buffer;
	}
	var supportsMozChunked = function supportsMozChunkedClosure() {
	  try {
	    var x = new XMLHttpRequest();
	    x.open('GET', _global_scope2.default.location.href);
	    x.responseType = 'moz-chunked-arraybuffer';
	    return x.responseType === 'moz-chunked-arraybuffer';
	  } catch (e) {
	    return false;
	  }
	}();
	NetworkManager.prototype = {
	  requestRange: function NetworkManager_requestRange(begin, end, listeners) {
	    var args = {
	      begin: begin,
	      end: end
	    };
	    for (var prop in listeners) {
	      args[prop] = listeners[prop];
	    }
	    return this.request(args);
	  },
	  requestFull: function NetworkManager_requestFull(listeners) {
	    return this.request(listeners);
	  },
	  request: function NetworkManager_request(args) {
	    var xhr = this.getXhr();
	    var xhrId = this.currXhrId++;
	    var pendingRequest = this.pendingRequests[xhrId] = { xhr: xhr };
	    xhr.open('GET', this.url);
	    xhr.withCredentials = this.withCredentials;
	    for (var property in this.httpHeaders) {
	      var value = this.httpHeaders[property];
	      if (typeof value === 'undefined') {
	        continue;
	      }
	      xhr.setRequestHeader(property, value);
	    }
	    if (this.isHttp && 'begin' in args && 'end' in args) {
	      var rangeStr = args.begin + '-' + (args.end - 1);
	      xhr.setRequestHeader('Range', 'bytes=' + rangeStr);
	      pendingRequest.expectedStatus = 206;
	    } else {
	      pendingRequest.expectedStatus = 200;
	    }
	    var useMozChunkedLoading = supportsMozChunked && !!args.onProgressiveData;
	    if (useMozChunkedLoading) {
	      xhr.responseType = 'moz-chunked-arraybuffer';
	      pendingRequest.onProgressiveData = args.onProgressiveData;
	      pendingRequest.mozChunked = true;
	    } else {
	      xhr.responseType = 'arraybuffer';
	    }
	    if (args.onError) {
	      xhr.onerror = function (evt) {
	        args.onError(xhr.status);
	      };
	    }
	    xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
	    xhr.onprogress = this.onProgress.bind(this, xhrId);
	    pendingRequest.onHeadersReceived = args.onHeadersReceived;
	    pendingRequest.onDone = args.onDone;
	    pendingRequest.onError = args.onError;
	    pendingRequest.onProgress = args.onProgress;
	    xhr.send(null);
	    return xhrId;
	  },
	  onProgress: function NetworkManager_onProgress(xhrId, evt) {
	    var pendingRequest = this.pendingRequests[xhrId];
	    if (!pendingRequest) {
	      return;
	    }
	    if (pendingRequest.mozChunked) {
	      var chunk = getArrayBuffer(pendingRequest.xhr);
	      pendingRequest.onProgressiveData(chunk);
	    }
	    var onProgress = pendingRequest.onProgress;
	    if (onProgress) {
	      onProgress(evt);
	    }
	  },
	  onStateChange: function NetworkManager_onStateChange(xhrId, evt) {
	    var pendingRequest = this.pendingRequests[xhrId];
	    if (!pendingRequest) {
	      return;
	    }
	    var xhr = pendingRequest.xhr;
	    if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
	      pendingRequest.onHeadersReceived();
	      delete pendingRequest.onHeadersReceived;
	    }
	    if (xhr.readyState !== 4) {
	      return;
	    }
	    if (!(xhrId in this.pendingRequests)) {
	      return;
	    }
	    delete this.pendingRequests[xhrId];
	    if (xhr.status === 0 && this.isHttp) {
	      if (pendingRequest.onError) {
	        pendingRequest.onError(xhr.status);
	      }
	      return;
	    }
	    var xhrStatus = xhr.status || OK_RESPONSE;
	    var ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
	    if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
	      if (pendingRequest.onError) {
	        pendingRequest.onError(xhr.status);
	      }
	      return;
	    }
	    this.loadedRequests[xhrId] = true;
	    var chunk = getArrayBuffer(xhr);
	    if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
	      var rangeHeader = xhr.getResponseHeader('Content-Range');
	      var matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
	      var begin = parseInt(matches[1], 10);
	      pendingRequest.onDone({
	        begin: begin,
	        chunk: chunk
	      });
	    } else if (pendingRequest.onProgressiveData) {
	      pendingRequest.onDone(null);
	    } else if (chunk) {
	      pendingRequest.onDone({
	        begin: 0,
	        chunk: chunk
	      });
	    } else if (pendingRequest.onError) {
	      pendingRequest.onError(xhr.status);
	    }
	  },
	  hasPendingRequests: function NetworkManager_hasPendingRequests() {
	    for (var xhrId in this.pendingRequests) {
	      return true;
	    }
	    return false;
	  },
	  getRequestXhr: function NetworkManager_getXhr(xhrId) {
	    return this.pendingRequests[xhrId].xhr;
	  },
	  isStreamingRequest: function NetworkManager_isStreamingRequest(xhrId) {
	    return !!this.pendingRequests[xhrId].onProgressiveData;
	  },
	  isPendingRequest: function NetworkManager_isPendingRequest(xhrId) {
	    return xhrId in this.pendingRequests;
	  },
	  isLoadedRequest: function NetworkManager_isLoadedRequest(xhrId) {
	    return xhrId in this.loadedRequests;
	  },
	  abortAllRequests: function NetworkManager_abortAllRequests() {
	    for (var xhrId in this.pendingRequests) {
	      this.abortRequest(xhrId | 0);
	    }
	  },
	  abortRequest: function NetworkManager_abortRequest(xhrId) {
	    var xhr = this.pendingRequests[xhrId].xhr;
	    delete this.pendingRequests[xhrId];
	    xhr.abort();
	  }
	};
	function PDFNetworkStream(source) {
	  this._source = source;
	  this._manager = new NetworkManager(source.url, {
	    httpHeaders: source.httpHeaders,
	    withCredentials: source.withCredentials
	  });
	  this._rangeChunkSize = source.rangeChunkSize;
	  this._fullRequestReader = null;
	  this._rangeRequestReaders = [];
	}
	PDFNetworkStream.prototype = {
	  _onRangeRequestReaderClosed: function PDFNetworkStream_onRangeRequestReaderClosed(reader) {
	    var i = this._rangeRequestReaders.indexOf(reader);
	    if (i >= 0) {
	      this._rangeRequestReaders.splice(i, 1);
	    }
	  },
	  getFullReader: function PDFNetworkStream_getFullReader() {
	    (0, _util.assert)(!this._fullRequestReader);
	    this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
	    return this._fullRequestReader;
	  },
	  getRangeReader: function PDFNetworkStream_getRangeReader(begin, end) {
	    var reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
	    reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
	    this._rangeRequestReaders.push(reader);
	    return reader;
	  },
	  cancelAllRequests: function PDFNetworkStream_cancelAllRequests(reason) {
	    if (this._fullRequestReader) {
	      this._fullRequestReader.cancel(reason);
	    }
	    var readers = this._rangeRequestReaders.slice(0);
	    readers.forEach(function (reader) {
	      reader.cancel(reason);
	    });
	  }
	};
	function PDFNetworkStreamFullRequestReader(manager, source) {
	  this._manager = manager;
	  var args = {
	    onHeadersReceived: this._onHeadersReceived.bind(this),
	    onProgressiveData: source.disableStream ? null : this._onProgressiveData.bind(this),
	    onDone: this._onDone.bind(this),
	    onError: this._onError.bind(this),
	    onProgress: this._onProgress.bind(this)
	  };
	  this._url = source.url;
	  this._fullRequestId = manager.requestFull(args);
	  this._headersReceivedCapability = (0, _util.createPromiseCapability)();
	  this._disableRange = source.disableRange || false;
	  this._contentLength = source.length;
	  this._rangeChunkSize = source.rangeChunkSize;
	  if (!this._rangeChunkSize && !this._disableRange) {
	    this._disableRange = true;
	  }
	  this._isStreamingSupported = false;
	  this._isRangeSupported = false;
	  this._cachedChunks = [];
	  this._requests = [];
	  this._done = false;
	  this._storedError = undefined;
	  this._filename = null;
	  this.onProgress = null;
	}
	PDFNetworkStreamFullRequestReader.prototype = {
	  _onHeadersReceived: function PDFNetworkStreamFullRequestReader_onHeadersReceived() {
	    var fullRequestXhrId = this._fullRequestId;
	    var fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
	    var getResponseHeader = function getResponseHeader(name) {
	      return fullRequestXhr.getResponseHeader(name);
	    };
	
	    var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
	      getResponseHeader: getResponseHeader,
	      isHttp: this._manager.isHttp,
	      rangeChunkSize: this._rangeChunkSize,
	      disableRange: this._disableRange
	    }),
	        allowRangeRequests = _validateRangeRequest.allowRangeRequests,
	        suggestedLength = _validateRangeRequest.suggestedLength;
	
	    this._contentLength = suggestedLength || this._contentLength;
	    if (allowRangeRequests) {
	      this._isRangeSupported = true;
	    }
	    this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
	    var networkManager = this._manager;
	    if (networkManager.isStreamingRequest(fullRequestXhrId)) {
	      this._isStreamingSupported = true;
	    } else if (this._isRangeSupported) {
	      networkManager.abortRequest(fullRequestXhrId);
	    }
	    this._headersReceivedCapability.resolve();
	  },
	  _onProgressiveData: function PDFNetworkStreamFullRequestReader_onProgressiveData(chunk) {
	    if (this._requests.length > 0) {
	      var requestCapability = this._requests.shift();
	      requestCapability.resolve({
	        value: chunk,
	        done: false
	      });
	    } else {
	      this._cachedChunks.push(chunk);
	    }
	  },
	  _onDone: function PDFNetworkStreamFullRequestReader_onDone(args) {
	    if (args) {
	      this._onProgressiveData(args.chunk);
	    }
	    this._done = true;
	    if (this._cachedChunks.length > 0) {
	      return;
	    }
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	  },
	  _onError: function PDFNetworkStreamFullRequestReader_onError(status) {
	    var url = this._url;
	    var exception = (0, _network_utils.createResponseStatusError)(status, url);
	    this._storedError = exception;
	    this._headersReceivedCapability.reject(exception);
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.reject(exception);
	    });
	    this._requests = [];
	    this._cachedChunks = [];
	  },
	  _onProgress: function PDFNetworkStreamFullRequestReader_onProgress(data) {
	    if (this.onProgress) {
	      this.onProgress({
	        loaded: data.loaded,
	        total: data.lengthComputable ? data.total : this._contentLength
	      });
	    }
	  },
	  get filename() {
	    return this._filename;
	  },
	  get isRangeSupported() {
	    return this._isRangeSupported;
	  },
	  get isStreamingSupported() {
	    return this._isStreamingSupported;
	  },
	  get contentLength() {
	    return this._contentLength;
	  },
	  get headersReady() {
	    return this._headersReceivedCapability.promise;
	  },
	  read: function PDFNetworkStreamFullRequestReader_read() {
	    if (this._storedError) {
	      return Promise.reject(this._storedError);
	    }
	    if (this._cachedChunks.length > 0) {
	      var chunk = this._cachedChunks.shift();
	      return Promise.resolve({
	        value: chunk,
	        done: false
	      });
	    }
	    if (this._done) {
	      return Promise.resolve({
	        value: undefined,
	        done: true
	      });
	    }
	    var requestCapability = (0, _util.createPromiseCapability)();
	    this._requests.push(requestCapability);
	    return requestCapability.promise;
	  },
	  cancel: function PDFNetworkStreamFullRequestReader_cancel(reason) {
	    this._done = true;
	    this._headersReceivedCapability.reject(reason);
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	    if (this._manager.isPendingRequest(this._fullRequestId)) {
	      this._manager.abortRequest(this._fullRequestId);
	    }
	    this._fullRequestReader = null;
	  }
	};
	function PDFNetworkStreamRangeRequestReader(manager, begin, end) {
	  this._manager = manager;
	  var args = {
	    onDone: this._onDone.bind(this),
	    onProgress: this._onProgress.bind(this)
	  };
	  this._requestId = manager.requestRange(begin, end, args);
	  this._requests = [];
	  this._queuedChunk = null;
	  this._done = false;
	  this.onProgress = null;
	  this.onClosed = null;
	}
	PDFNetworkStreamRangeRequestReader.prototype = {
	  _close: function PDFNetworkStreamRangeRequestReader_close() {
	    if (this.onClosed) {
	      this.onClosed(this);
	    }
	  },
	  _onDone: function PDFNetworkStreamRangeRequestReader_onDone(data) {
	    var chunk = data.chunk;
	    if (this._requests.length > 0) {
	      var requestCapability = this._requests.shift();
	      requestCapability.resolve({
	        value: chunk,
	        done: false
	      });
	    } else {
	      this._queuedChunk = chunk;
	    }
	    this._done = true;
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	    this._close();
	  },
	  _onProgress: function PDFNetworkStreamRangeRequestReader_onProgress(evt) {
	    if (!this.isStreamingSupported && this.onProgress) {
	      this.onProgress({ loaded: evt.loaded });
	    }
	  },
	  get isStreamingSupported() {
	    return false;
	  },
	  read: function PDFNetworkStreamRangeRequestReader_read() {
	    if (this._queuedChunk !== null) {
	      var chunk = this._queuedChunk;
	      this._queuedChunk = null;
	      return Promise.resolve({
	        value: chunk,
	        done: false
	      });
	    }
	    if (this._done) {
	      return Promise.resolve({
	        value: undefined,
	        done: true
	      });
	    }
	    var requestCapability = (0, _util.createPromiseCapability)();
	    this._requests.push(requestCapability);
	    return requestCapability.promise;
	  },
	  cancel: function PDFNetworkStreamRangeRequestReader_cancel(reason) {
	    this._done = true;
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	    if (this._manager.isPendingRequest(this._requestId)) {
	      this._manager.abortRequest(this._requestId);
	    }
	    this._close();
	  }
	};
	exports.PDFNetworkStream = PDFNetworkStream;
	exports.NetworkManager = NetworkManager;
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=pdf.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(39), __webpack_require__(62).Buffer))

/***/ },
/* 1681 */,
/* 1682 */
/***/ function(module, exports) {

	/*
	 * To the extent possible under law, the authors have dedicated all copyright
	 * and related and neighboring rights to this software to the public
	 * domain worldwide. This software is distributed without any warranty.
	 *
	 * You should have received a copy of the CC0 Public Domain Dedication along
	 * with this software. If not, see https://creativecommons.org/publicdomain/zero/1.0/.
	 */
	
	(function(e, a) { for(var i in a) e[i] = a[i]; }(exports, /******/ (function(modules) { // webpackBootstrap
	/******/  // The module cache
	/******/  var installedModules = {};
	/******/
	/******/  // The require function
	/******/  function __webpack_require__(moduleId) {
	/******/
	/******/    // Check if module is in cache
	/******/    if(installedModules[moduleId])
	/******/      return installedModules[moduleId].exports;
	/******/
	/******/    // Create a new module (and put it into the cache)
	/******/    var module = installedModules[moduleId] = {
	/******/      i: moduleId,
	/******/      l: false,
	/******/      exports: {}
	/******/    };
	/******/
	/******/    // Execute the module function
	/******/    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/    // Flag the module as loaded
	/******/    module.l = true;
	/******/
	/******/    // Return the exports of the module
	/******/    return module.exports;
	/******/  }
	/******/
	/******/
	/******/  // expose the modules object (__webpack_modules__)
	/******/  __webpack_require__.m = modules;
	/******/
	/******/  // expose the module cache
	/******/  __webpack_require__.c = installedModules;
	/******/
	/******/  // identity function for calling harmony imports with the correct context
	/******/  __webpack_require__.i = function(value) { return value; };
	/******/
	/******/  // define getter function for harmony exports
	/******/  __webpack_require__.d = function(exports, name, getter) {
	/******/    if(!__webpack_require__.o(exports, name)) {
	/******/      Object.defineProperty(exports, name, {
	/******/        configurable: false,
	/******/        enumerable: true,
	/******/        get: getter
	/******/      });
	/******/    }
	/******/  };
	/******/
	/******/  // getDefaultExport function for compatibility with non-harmony modules
	/******/  __webpack_require__.n = function(module) {
	/******/    var getter = module && module.__esModule ?
	/******/      function getDefault() { return module['default']; } :
	/******/      function getModuleExports() { return module; };
	/******/    __webpack_require__.d(getter, 'a', getter);
	/******/    return getter;
	/******/  };
	/******/
	/******/  // Object.prototype.hasOwnProperty.call
	/******/  __webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/  // __webpack_public_path__
	/******/  __webpack_require__.p = "";
	/******/
	/******/  // Load entry module and return exports
	/******/  return __webpack_require__(__webpack_require__.s = 7);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _require = __webpack_require__(1),
	    assert = _require.assert;
	
	function IsPropertyKey(argument) {
	  return typeof argument === 'string' || (typeof argument === 'undefined' ? 'undefined' : _typeof(argument)) === 'symbol';
	}
	
	exports.typeIsObject = function (x) {
	  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x !== null || typeof x === 'function';
	};
	
	exports.createDataProperty = function (o, p, v) {
	  assert(exports.typeIsObject(o));
	  Object.defineProperty(o, p, { value: v, writable: true, enumerable: true, configurable: true });
	};
	
	exports.createArrayFromList = function (elements) {
	  // We use arrays to represent lists, so this is basically a no-op.
	  // Do a slice though just in case we happen to depend on the unique-ness.
	  return elements.slice();
	};
	
	exports.ArrayBufferCopy = function (dest, destOffset, src, srcOffset, n) {
	  new Uint8Array(dest).set(new Uint8Array(src, srcOffset, n), destOffset);
	};
	
	exports.CreateIterResultObject = function (value, done) {
	  assert(typeof done === 'boolean');
	  var obj = {};
	  Object.defineProperty(obj, 'value', { value: value, enumerable: true, writable: true, configurable: true });
	  Object.defineProperty(obj, 'done', { value: done, enumerable: true, writable: true, configurable: true });
	  return obj;
	};
	
	exports.IsFiniteNonNegativeNumber = function (v) {
	  if (Number.isNaN(v)) {
	    return false;
	  }
	  if (v === Infinity) {
	    return false;
	  }
	  if (v < 0) {
	    return false;
	  }
	
	  return true;
	};
	
	function Call(F, V, args) {
	  if (typeof F !== 'function') {
	    throw new TypeError('Argument is not a function');
	  }
	
	  return Function.prototype.apply.call(F, V, args);
	}
	
	exports.InvokeOrNoop = function (O, P, args) {
	  assert(O !== undefined);
	  assert(IsPropertyKey(P));
	  assert(Array.isArray(args));
	
	  var method = O[P];
	  if (method === undefined) {
	    return undefined;
	  }
	
	  return Call(method, O, args);
	};
	
	exports.PromiseInvokeOrNoop = function (O, P, args) {
	  assert(O !== undefined);
	  assert(IsPropertyKey(P));
	  assert(Array.isArray(args));
	  try {
	    return Promise.resolve(exports.InvokeOrNoop(O, P, args));
	  } catch (returnValueE) {
	    return Promise.reject(returnValueE);
	  }
	};
	
	exports.PromiseInvokeOrPerformFallback = function (O, P, args, F, argsF) {
	  assert(O !== undefined);
	  assert(IsPropertyKey(P));
	  assert(Array.isArray(args));
	  assert(Array.isArray(argsF));
	
	  var method = void 0;
	  try {
	    method = O[P];
	  } catch (methodE) {
	    return Promise.reject(methodE);
	  }
	
	  if (method === undefined) {
	    return F.apply(null, argsF);
	  }
	
	  try {
	    return Promise.resolve(Call(method, O, args));
	  } catch (e) {
	    return Promise.reject(e);
	  }
	};
	
	// Not implemented correctly
	exports.TransferArrayBuffer = function (O) {
	  return O.slice();
	};
	
	exports.ValidateAndNormalizeHighWaterMark = function (highWaterMark) {
	  highWaterMark = Number(highWaterMark);
	  if (Number.isNaN(highWaterMark) || highWaterMark < 0) {
	    throw new RangeError('highWaterMark property of a queuing strategy must be non-negative and non-NaN');
	  }
	
	  return highWaterMark;
	};
	
	exports.ValidateAndNormalizeQueuingStrategy = function (size, highWaterMark) {
	  if (size !== undefined && typeof size !== 'function') {
	    throw new TypeError('size property of a queuing strategy must be a function');
	  }
	
	  highWaterMark = exports.ValidateAndNormalizeHighWaterMark(highWaterMark);
	
	  return { size: size, highWaterMark: highWaterMark };
	};
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	function rethrowAssertionErrorRejection(e) {
	  // Used throughout the reference implementation, as `.catch(rethrowAssertionErrorRejection)`, to ensure any errors
	  // get shown. There are places in the spec where we do promise transformations and purposefully ignore or don't
	  // expect any errors, but assertion errors are always problematic.
	  if (e && e.constructor === AssertionError) {
	    setTimeout(function () {
	      throw e;
	    }, 0);
	  }
	};
	
	function AssertionError(message) {
	  this.name = 'AssertionError';
	  this.message = message || '';
	  this.stack = new Error().stack;
	}
	AssertionError.prototype = Object.create(Error.prototype);
	AssertionError.prototype.constructor = AssertionError;
	
	function assert(value, message) {
	  if (!value) {
	    throw new AssertionError(message);
	  }
	}
	
	module.exports = {
	  rethrowAssertionErrorRejection: rethrowAssertionErrorRejection,
	  AssertionError: AssertionError,
	  assert: assert
	};
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _require = __webpack_require__(0),
	    InvokeOrNoop = _require.InvokeOrNoop,
	    PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
	    ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
	    typeIsObject = _require.typeIsObject;
	
	var _require2 = __webpack_require__(1),
	    assert = _require2.assert,
	    rethrowAssertionErrorRejection = _require2.rethrowAssertionErrorRejection;
	
	var _require3 = __webpack_require__(3),
	    DequeueValue = _require3.DequeueValue,
	    EnqueueValueWithSize = _require3.EnqueueValueWithSize,
	    PeekQueueValue = _require3.PeekQueueValue,
	    ResetQueue = _require3.ResetQueue;
	
	var WritableStream = function () {
	  function WritableStream() {
	    var underlyingSink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        size = _ref.size,
	        _ref$highWaterMark = _ref.highWaterMark,
	        highWaterMark = _ref$highWaterMark === undefined ? 1 : _ref$highWaterMark;
	
	    _classCallCheck(this, WritableStream);
	
	    this._state = 'writable';
	
	    // The error that will be reported by new method calls once the state becomes errored. Only set when [[state]] is
	    // 'erroring' or 'errored'. May be set to an undefined value.
	    this._storedError = undefined;
	
	    this._writer = undefined;
	
	    // Initialize to undefined first because the constructor of the controller checks this
	    // variable to validate the caller.
	    this._writableStreamController = undefined;
	
	    // This queue is placed here instead of the writer class in order to allow for passing a writer to the next data
	    // producer without waiting for the queued writes to finish.
	    this._writeRequests = [];
	
	    // Write requests are removed from _writeRequests when write() is called on the underlying sink. This prevents
	    // them from being erroneously rejected on error. If a write() call is in-flight, the request is stored here.
	    this._inFlightWriteRequest = undefined;
	
	    // The promise that was returned from writer.close(). Stored here because it may be fulfilled after the writer
	    // has been detached.
	    this._closeRequest = undefined;
	
	    // Close request is removed from _closeRequest when close() is called on the underlying sink. This prevents it
	    // from being erroneously rejected on error. If a close() call is in-flight, the request is stored here.
	    this._inFlightCloseRequest = undefined;
	
	    // The promise that was returned from writer.abort(). This may also be fulfilled after the writer has detached.
	    this._pendingAbortRequest = undefined;
	
	    // The backpressure signal set by the controller.
	    this._backpressure = false;
	
	    var type = underlyingSink.type;
	
	    if (type !== undefined) {
	      throw new RangeError('Invalid type is specified');
	    }
	
	    this._writableStreamController = new WritableStreamDefaultController(this, underlyingSink, size, highWaterMark);
	    this._writableStreamController.__startSteps();
	  }
	
	  _createClass(WritableStream, [{
	    key: 'abort',
	    value: function abort(reason) {
	      if (IsWritableStream(this) === false) {
	        return Promise.reject(streamBrandCheckException('abort'));
	      }
	
	      if (IsWritableStreamLocked(this) === true) {
	        return Promise.reject(new TypeError('Cannot abort a stream that already has a writer'));
	      }
	
	      return WritableStreamAbort(this, reason);
	    }
	  }, {
	    key: 'getWriter',
	    value: function getWriter() {
	      if (IsWritableStream(this) === false) {
	        throw streamBrandCheckException('getWriter');
	      }
	
	      return AcquireWritableStreamDefaultWriter(this);
	    }
	  }, {
	    key: 'locked',
	    get: function get() {
	      if (IsWritableStream(this) === false) {
	        throw streamBrandCheckException('locked');
	      }
	
	      return IsWritableStreamLocked(this);
	    }
	  }]);
	
	  return WritableStream;
	}();
	
	module.exports = {
	  AcquireWritableStreamDefaultWriter: AcquireWritableStreamDefaultWriter,
	  IsWritableStream: IsWritableStream,
	  IsWritableStreamLocked: IsWritableStreamLocked,
	  WritableStream: WritableStream,
	  WritableStreamAbort: WritableStreamAbort,
	  WritableStreamDefaultControllerError: WritableStreamDefaultControllerError,
	  WritableStreamDefaultWriterCloseWithErrorPropagation: WritableStreamDefaultWriterCloseWithErrorPropagation,
	  WritableStreamDefaultWriterRelease: WritableStreamDefaultWriterRelease,
	  WritableStreamDefaultWriterWrite: WritableStreamDefaultWriterWrite,
	  WritableStreamCloseQueuedOrInFlight: WritableStreamCloseQueuedOrInFlight
	};
	
	// Abstract operations for the WritableStream.
	
	function AcquireWritableStreamDefaultWriter(stream) {
	  return new WritableStreamDefaultWriter(stream);
	}
	
	function IsWritableStream(x) {
	  if (!typeIsObject(x)) {
	    return false;
	  }
	
	  if (!Object.prototype.hasOwnProperty.call(x, '_writableStreamController')) {
	    return false;
	  }
	
	  return true;
	}
	
	function IsWritableStreamLocked(stream) {
	  assert(IsWritableStream(stream) === true, 'IsWritableStreamLocked should only be used on known writable streams');
	
	  if (stream._writer === undefined) {
	    return false;
	  }
	
	  return true;
	}
	
	function WritableStreamAbort(stream, reason) {
	  var state = stream._state;
	  if (state === 'closed') {
	    return Promise.resolve(undefined);
	  }
	  if (state === 'errored') {
	    return Promise.reject(stream._storedError);
	  }
	  var error = new TypeError('Requested to abort');
	  if (stream._pendingAbortRequest !== undefined) {
	    return Promise.reject(error);
	  }
	
	  assert(state === 'writable' || state === 'erroring', 'state must be writable or erroring');
	
	  var wasAlreadyErroring = false;
	  if (state === 'erroring') {
	    wasAlreadyErroring = true;
	    // reason will not be used, so don't keep a reference to it.
	    reason = undefined;
	  }
	
	  var promise = new Promise(function (resolve, reject) {
	    stream._pendingAbortRequest = {
	      _resolve: resolve,
	      _reject: reject,
	      _reason: reason,
	      _wasAlreadyErroring: wasAlreadyErroring
	    };
	  });
	
	  if (wasAlreadyErroring === false) {
	    WritableStreamStartErroring(stream, error);
	  }
	
	  return promise;
	}
	
	// WritableStream API exposed for controllers.
	
	function WritableStreamAddWriteRequest(stream) {
	  assert(IsWritableStreamLocked(stream) === true);
	  assert(stream._state === 'writable');
	
	  var promise = new Promise(function (resolve, reject) {
	    var writeRequest = {
	      _resolve: resolve,
	      _reject: reject
	    };
	
	    stream._writeRequests.push(writeRequest);
	  });
	
	  return promise;
	}
	
	function WritableStreamDealWithRejection(stream, error) {
	  var state = stream._state;
	
	  if (state === 'writable') {
	    WritableStreamStartErroring(stream, error);
	    return;
	  }
	
	  assert(state === 'erroring');
	  WritableStreamFinishErroring(stream);
	}
	
	function WritableStreamStartErroring(stream, reason) {
	  assert(stream._storedError === undefined, 'stream._storedError === undefined');
	  assert(stream._state === 'writable', 'state must be writable');
	
	  var controller = stream._writableStreamController;
	  assert(controller !== undefined, 'controller must not be undefined');
	
	  stream._state = 'erroring';
	  stream._storedError = reason;
	  var writer = stream._writer;
	  if (writer !== undefined) {
	    WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, reason);
	  }
	
	  if (WritableStreamHasOperationMarkedInFlight(stream) === false && controller._started === true) {
	    WritableStreamFinishErroring(stream);
	  }
	}
	
	function WritableStreamFinishErroring(stream) {
	  assert(stream._state === 'erroring', 'stream._state === erroring');
	  assert(WritableStreamHasOperationMarkedInFlight(stream) === false, 'WritableStreamHasOperationMarkedInFlight(stream) === false');
	  stream._state = 'errored';
	  stream._writableStreamController.__errorSteps();
	
	  var storedError = stream._storedError;
	  for (var i = 0; i < stream._writeRequests.length; i++) {
	    var writeRequest = stream._writeRequests[i];
	    writeRequest._reject(storedError);
	  }
	  stream._writeRequests = [];
	
	  if (stream._pendingAbortRequest === undefined) {
	    WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
	    return;
	  }
	
	  var abortRequest = stream._pendingAbortRequest;
	  stream._pendingAbortRequest = undefined;
	
	  if (abortRequest._wasAlreadyErroring === true) {
	    abortRequest._reject(storedError);
	    WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
	    return;
	  }
	
	  var promise = stream._writableStreamController.__abortSteps(abortRequest._reason);
	  promise.then(function () {
	    abortRequest._resolve();
	    WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
	  }, function (reason) {
	    abortRequest._reject(reason);
	    WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
	  });
	}
	
	function WritableStreamFinishInFlightWrite(stream) {
	  assert(stream._inFlightWriteRequest !== undefined);
	  stream._inFlightWriteRequest._resolve(undefined);
	  stream._inFlightWriteRequest = undefined;
	}
	
	function WritableStreamFinishInFlightWriteWithError(stream, error) {
	  assert(stream._inFlightWriteRequest !== undefined);
	  stream._inFlightWriteRequest._reject(error);
	  stream._inFlightWriteRequest = undefined;
	
	  assert(stream._state === 'writable' || stream._state === 'erroring');
	
	  WritableStreamDealWithRejection(stream, error);
	}
	
	function WritableStreamFinishInFlightClose(stream) {
	  assert(stream._inFlightCloseRequest !== undefined);
	  stream._inFlightCloseRequest._resolve(undefined);
	  stream._inFlightCloseRequest = undefined;
	
	  var state = stream._state;
	
	  assert(state === 'writable' || state === 'erroring');
	
	  if (state === 'erroring') {
	    // The error was too late to do anything, so it is ignored.
	    stream._storedError = undefined;
	    if (stream._pendingAbortRequest !== undefined) {
	      stream._pendingAbortRequest._resolve();
	      stream._pendingAbortRequest = undefined;
	    }
	  }
	
	  stream._state = 'closed';
	
	  var writer = stream._writer;
	  if (writer !== undefined) {
	    defaultWriterClosedPromiseResolve(writer);
	  }
	
	  assert(stream._pendingAbortRequest === undefined, 'stream._pendingAbortRequest === undefined');
	  assert(stream._storedError === undefined, 'stream._storedError === undefined');
	}
	
	function WritableStreamFinishInFlightCloseWithError(stream, error) {
	  assert(stream._inFlightCloseRequest !== undefined);
	  stream._inFlightCloseRequest._reject(error);
	  stream._inFlightCloseRequest = undefined;
	
	  assert(stream._state === 'writable' || stream._state === 'erroring');
	
	  // Never execute sink abort() after sink close().
	  if (stream._pendingAbortRequest !== undefined) {
	    stream._pendingAbortRequest._reject(error);
	    stream._pendingAbortRequest = undefined;
	  }
	  WritableStreamDealWithRejection(stream, error);
	}
	
	// TODO(ricea): Fix alphabetical order.
	function WritableStreamCloseQueuedOrInFlight(stream) {
	  if (stream._closeRequest === undefined && stream._inFlightCloseRequest === undefined) {
	    return false;
	  }
	
	  return true;
	}
	
	function WritableStreamHasOperationMarkedInFlight(stream) {
	  if (stream._inFlightWriteRequest === undefined && stream._inFlightCloseRequest === undefined) {
	    return false;
	  }
	
	  return true;
	}
	
	function WritableStreamMarkCloseRequestInFlight(stream) {
	  assert(stream._inFlightCloseRequest === undefined);
	  assert(stream._closeRequest !== undefined);
	  stream._inFlightCloseRequest = stream._closeRequest;
	  stream._closeRequest = undefined;
	}
	
	function WritableStreamMarkFirstWriteRequestInFlight(stream) {
	  assert(stream._inFlightWriteRequest === undefined, 'there must be no pending write request');
	  assert(stream._writeRequests.length !== 0, 'writeRequests must not be empty');
	  stream._inFlightWriteRequest = stream._writeRequests.shift();
	}
	
	function WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream) {
	  assert(stream._state === 'errored', '_stream_.[[state]] is `"errored"`');
	  if (stream._closeRequest !== undefined) {
	    assert(stream._inFlightCloseRequest === undefined);
	
	    stream._closeRequest._reject(stream._storedError);
	    stream._closeRequest = undefined;
	  }
	  var writer = stream._writer;
	  if (writer !== undefined) {
	    defaultWriterClosedPromiseReject(writer, stream._storedError);
	    writer._closedPromise.catch(function () {});
	  }
	}
	
	function WritableStreamUpdateBackpressure(stream, backpressure) {
	  assert(stream._state === 'writable');
	  assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
	
	  var writer = stream._writer;
	  if (writer !== undefined && backpressure !== stream._backpressure) {
	    if (backpressure === true) {
	      defaultWriterReadyPromiseReset(writer);
	    } else {
	      assert(backpressure === false);
	
	      defaultWriterReadyPromiseResolve(writer);
	    }
	  }
	
	  stream._backpressure = backpressure;
	}
	
	var WritableStreamDefaultWriter = function () {
	  function WritableStreamDefaultWriter(stream) {
	    _classCallCheck(this, WritableStreamDefaultWriter);
	
	    if (IsWritableStream(stream) === false) {
	      throw new TypeError('WritableStreamDefaultWriter can only be constructed with a WritableStream instance');
	    }
	    if (IsWritableStreamLocked(stream) === true) {
	      throw new TypeError('This stream has already been locked for exclusive writing by another writer');
	    }
	
	    this._ownerWritableStream = stream;
	    stream._writer = this;
	
	    var state = stream._state;
	
	    if (state === 'writable') {
	      if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._backpressure === true) {
	        defaultWriterReadyPromiseInitialize(this);
	      } else {
	        defaultWriterReadyPromiseInitializeAsResolved(this);
	      }
	
	      defaultWriterClosedPromiseInitialize(this);
	    } else if (state === 'erroring') {
	      defaultWriterReadyPromiseInitializeAsRejected(this, stream._storedError);
	      this._readyPromise.catch(function () {});
	      defaultWriterClosedPromiseInitialize(this);
	    } else if (state === 'closed') {
	      defaultWriterReadyPromiseInitializeAsResolved(this);
	      defaultWriterClosedPromiseInitializeAsResolved(this);
	    } else {
	      assert(state === 'errored', 'state must be errored');
	
	      var storedError = stream._storedError;
	      defaultWriterReadyPromiseInitializeAsRejected(this, storedError);
	      this._readyPromise.catch(function () {});
	      defaultWriterClosedPromiseInitializeAsRejected(this, storedError);
	      this._closedPromise.catch(function () {});
	    }
	  }
	
	  _createClass(WritableStreamDefaultWriter, [{
	    key: 'abort',
	    value: function abort(reason) {
	      if (IsWritableStreamDefaultWriter(this) === false) {
	        return Promise.reject(defaultWriterBrandCheckException('abort'));
	      }
	
	      if (this._ownerWritableStream === undefined) {
	        return Promise.reject(defaultWriterLockException('abort'));
	      }
	
	      return WritableStreamDefaultWriterAbort(this, reason);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      if (IsWritableStreamDefaultWriter(this) === false) {
	        return Promise.reject(defaultWriterBrandCheckException('close'));
	      }
	
	      var stream = this._ownerWritableStream;
	
	      if (stream === undefined) {
	        return Promise.reject(defaultWriterLockException('close'));
	      }
	
	      if (WritableStreamCloseQueuedOrInFlight(stream) === true) {
	        return Promise.reject(new TypeError('cannot close an already-closing stream'));
	      }
	
	      return WritableStreamDefaultWriterClose(this);
	    }
	  }, {
	    key: 'releaseLock',
	    value: function releaseLock() {
	      if (IsWritableStreamDefaultWriter(this) === false) {
	        throw defaultWriterBrandCheckException('releaseLock');
	      }
	
	      var stream = this._ownerWritableStream;
	
	      if (stream === undefined) {
	        return;
	      }
	
	      assert(stream._writer !== undefined);
	
	      WritableStreamDefaultWriterRelease(this);
	    }
	  }, {
	    key: 'write',
	    value: function write(chunk) {
	      if (IsWritableStreamDefaultWriter(this) === false) {
	        return Promise.reject(defaultWriterBrandCheckException('write'));
	      }
	
	      if (this._ownerWritableStream === undefined) {
	        return Promise.reject(defaultWriterLockException('write to'));
	      }
	
	      return WritableStreamDefaultWriterWrite(this, chunk);
	    }
	  }, {
	    key: 'closed',
	    get: function get() {
	      if (IsWritableStreamDefaultWriter(this) === false) {
	        return Promise.reject(defaultWriterBrandCheckException('closed'));
	      }
	
	      return this._closedPromise;
	    }
	  }, {
	    key: 'desiredSize',
	    get: function get() {
	      if (IsWritableStreamDefaultWriter(this) === false) {
	        throw defaultWriterBrandCheckException('desiredSize');
	      }
	
	      if (this._ownerWritableStream === undefined) {
	        throw defaultWriterLockException('desiredSize');
	      }
	
	      return WritableStreamDefaultWriterGetDesiredSize(this);
	    }
	  }, {
	    key: 'ready',
	    get: function get() {
	      if (IsWritableStreamDefaultWriter(this) === false) {
	        return Promise.reject(defaultWriterBrandCheckException('ready'));
	      }
	
	      return this._readyPromise;
	    }
	  }]);
	
	  return WritableStreamDefaultWriter;
	}();
	
	// Abstract operations for the WritableStreamDefaultWriter.
	
	function IsWritableStreamDefaultWriter(x) {
	  if (!typeIsObject(x)) {
	    return false;
	  }
	
	  if (!Object.prototype.hasOwnProperty.call(x, '_ownerWritableStream')) {
	    return false;
	  }
	
	  return true;
	}
	
	// A client of WritableStreamDefaultWriter may use these functions directly to bypass state check.
	
	function WritableStreamDefaultWriterAbort(writer, reason) {
	  var stream = writer._ownerWritableStream;
	
	  assert(stream !== undefined);
	
	  return WritableStreamAbort(stream, reason);
	}
	
	function WritableStreamDefaultWriterClose(writer) {
	  var stream = writer._ownerWritableStream;
	
	  assert(stream !== undefined);
	
	  var state = stream._state;
	  if (state === 'closed' || state === 'errored') {
	    return Promise.reject(new TypeError('The stream (in ' + state + ' state) is not in the writable state and cannot be closed'));
	  }
	
	  assert(state === 'writable' || state === 'erroring');
	  assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
	
	  var promise = new Promise(function (resolve, reject) {
	    var closeRequest = {
	      _resolve: resolve,
	      _reject: reject
	    };
	
	    stream._closeRequest = closeRequest;
	  });
	
	  if (stream._backpressure === true && state === 'writable') {
	    defaultWriterReadyPromiseResolve(writer);
	  }
	
	  WritableStreamDefaultControllerClose(stream._writableStreamController);
	
	  return promise;
	}
	
	function WritableStreamDefaultWriterCloseWithErrorPropagation(writer) {
	  var stream = writer._ownerWritableStream;
	
	  assert(stream !== undefined);
	
	  var state = stream._state;
	  if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
	    return Promise.resolve();
	  }
	
	  if (state === 'errored') {
	    return Promise.reject(stream._storedError);
	  }
	
	  assert(state === 'writable' || state === 'erroring');
	
	  return WritableStreamDefaultWriterClose(writer);
	}
	
	function WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, error) {
	  if (writer._closedPromiseState === 'pending') {
	    defaultWriterClosedPromiseReject(writer, error);
	  } else {
	    defaultWriterClosedPromiseResetToRejected(writer, error);
	  }
	  writer._closedPromise.catch(function () {});
	}
	
	function WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, error) {
	  if (writer._readyPromiseState === 'pending') {
	    defaultWriterReadyPromiseReject(writer, error);
	  } else {
	    defaultWriterReadyPromiseResetToRejected(writer, error);
	  }
	  writer._readyPromise.catch(function () {});
	}
	
	function WritableStreamDefaultWriterGetDesiredSize(writer) {
	  var stream = writer._ownerWritableStream;
	  var state = stream._state;
	
	  if (state === 'errored' || state === 'erroring') {
	    return null;
	  }
	
	  if (state === 'closed') {
	    return 0;
	  }
	
	  return WritableStreamDefaultControllerGetDesiredSize(stream._writableStreamController);
	}
	
	function WritableStreamDefaultWriterRelease(writer) {
	  var stream = writer._ownerWritableStream;
	  assert(stream !== undefined);
	  assert(stream._writer === writer);
	
	  var releasedError = new TypeError('Writer was released and can no longer be used to monitor the stream\'s closedness');
	
	  WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, releasedError);
	
	  // The state transitions to "errored" before the sink abort() method runs, but the writer.closed promise is not
	  // rejected until afterwards. This means that simply testing state will not work.
	  WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, releasedError);
	
	  stream._writer = undefined;
	  writer._ownerWritableStream = undefined;
	}
	
	function WritableStreamDefaultWriterWrite(writer, chunk) {
	  var stream = writer._ownerWritableStream;
	
	  assert(stream !== undefined);
	
	  var controller = stream._writableStreamController;
	
	  var chunkSize = WritableStreamDefaultControllerGetChunkSize(controller, chunk);
	
	  if (stream !== writer._ownerWritableStream) {
	    return Promise.reject(defaultWriterLockException('write to'));
	  }
	
	  var state = stream._state;
	  if (state === 'errored') {
	    return Promise.reject(stream._storedError);
	  }
	  if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
	    return Promise.reject(new TypeError('The stream is closing or closed and cannot be written to'));
	  }
	  if (state === 'erroring') {
	    return Promise.reject(stream._storedError);
	  }
	
	  assert(state === 'writable');
	
	  var promise = WritableStreamAddWriteRequest(stream);
	
	  WritableStreamDefaultControllerWrite(controller, chunk, chunkSize);
	
	  return promise;
	}
	
	var WritableStreamDefaultController = function () {
	  function WritableStreamDefaultController(stream, underlyingSink, size, highWaterMark) {
	    _classCallCheck(this, WritableStreamDefaultController);
	
	    if (IsWritableStream(stream) === false) {
	      throw new TypeError('WritableStreamDefaultController can only be constructed with a WritableStream instance');
	    }
	
	    if (stream._writableStreamController !== undefined) {
	      throw new TypeError('WritableStreamDefaultController instances can only be created by the WritableStream constructor');
	    }
	
	    this._controlledWritableStream = stream;
	
	    this._underlyingSink = underlyingSink;
	
	    // Need to set the slots so that the assert doesn't fire. In the spec the slots already exist implicitly.
	    this._queue = undefined;
	    this._queueTotalSize = undefined;
	    ResetQueue(this);
	
	    this._started = false;
	
	    var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
	    this._strategySize = normalizedStrategy.size;
	    this._strategyHWM = normalizedStrategy.highWaterMark;
	
	    var backpressure = WritableStreamDefaultControllerGetBackpressure(this);
	    WritableStreamUpdateBackpressure(stream, backpressure);
	  }
	
	  _createClass(WritableStreamDefaultController, [{
	    key: 'error',
	    value: function error(e) {
	      if (IsWritableStreamDefaultController(this) === false) {
	        throw new TypeError('WritableStreamDefaultController.prototype.error can only be used on a WritableStreamDefaultController');
	      }
	      var state = this._controlledWritableStream._state;
	      if (state !== 'writable') {
	        // The stream is closed, errored or will be soon. The sink can't do anything useful if it gets an error here, so
	        // just treat it as a no-op.
	        return;
	      }
	
	      WritableStreamDefaultControllerError(this, e);
	    }
	  }, {
	    key: '__abortSteps',
	    value: function __abortSteps(reason) {
	      return PromiseInvokeOrNoop(this._underlyingSink, 'abort', [reason]);
	    }
	  }, {
	    key: '__errorSteps',
	    value: function __errorSteps() {
	      ResetQueue(this);
	    }
	  }, {
	    key: '__startSteps',
	    value: function __startSteps() {
	      var _this = this;
	
	      var startResult = InvokeOrNoop(this._underlyingSink, 'start', [this]);
	      var stream = this._controlledWritableStream;
	
	      Promise.resolve(startResult).then(function () {
	        assert(stream._state === 'writable' || stream._state === 'erroring');
	        _this._started = true;
	        WritableStreamDefaultControllerAdvanceQueueIfNeeded(_this);
	      }, function (r) {
	        assert(stream._state === 'writable' || stream._state === 'erroring');
	        _this._started = true;
	        WritableStreamDealWithRejection(stream, r);
	      }).catch(rethrowAssertionErrorRejection);
	    }
	  }]);
	
	  return WritableStreamDefaultController;
	}();
	
	// Abstract operations implementing interface required by the WritableStream.
	
	function WritableStreamDefaultControllerClose(controller) {
	  EnqueueValueWithSize(controller, 'close', 0);
	  WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
	}
	
	function WritableStreamDefaultControllerGetChunkSize(controller, chunk) {
	  var strategySize = controller._strategySize;
	
	  if (strategySize === undefined) {
	    return 1;
	  }
	
	  try {
	    return strategySize(chunk);
	  } catch (chunkSizeE) {
	    WritableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
	    return 1;
	  }
	}
	
	function WritableStreamDefaultControllerGetDesiredSize(controller) {
	  return controller._strategyHWM - controller._queueTotalSize;
	}
	
	function WritableStreamDefaultControllerWrite(controller, chunk, chunkSize) {
	  var writeRecord = { chunk: chunk };
	
	  try {
	    EnqueueValueWithSize(controller, writeRecord, chunkSize);
	  } catch (enqueueE) {
	    WritableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
	    return;
	  }
	
	  var stream = controller._controlledWritableStream;
	  if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._state === 'writable') {
	    var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
	    WritableStreamUpdateBackpressure(stream, backpressure);
	  }
	
	  WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
	}
	
	// Abstract operations for the WritableStreamDefaultController.
	
	function IsWritableStreamDefaultController(x) {
	  if (!typeIsObject(x)) {
	    return false;
	  }
	
	  if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSink')) {
	    return false;
	  }
	
	  return true;
	}
	
	function WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller) {
	  var stream = controller._controlledWritableStream;
	
	  if (controller._started === false) {
	    return;
	  }
	
	  if (stream._inFlightWriteRequest !== undefined) {
	    return;
	  }
	
	  var state = stream._state;
	  if (state === 'closed' || state === 'errored') {
	    return;
	  }
	  if (state === 'erroring') {
	    WritableStreamFinishErroring(stream);
	    return;
	  }
	
	  if (controller._queue.length === 0) {
	    return;
	  }
	
	  var writeRecord = PeekQueueValue(controller);
	  if (writeRecord === 'close') {
	    WritableStreamDefaultControllerProcessClose(controller);
	  } else {
	    WritableStreamDefaultControllerProcessWrite(controller, writeRecord.chunk);
	  }
	}
	
	function WritableStreamDefaultControllerErrorIfNeeded(controller, error) {
	  if (controller._controlledWritableStream._state === 'writable') {
	    WritableStreamDefaultControllerError(controller, error);
	  }
	}
	
	function WritableStreamDefaultControllerProcessClose(controller) {
	  var stream = controller._controlledWritableStream;
	
	  WritableStreamMarkCloseRequestInFlight(stream);
	
	  DequeueValue(controller);
	  assert(controller._queue.length === 0, 'queue must be empty once the final write record is dequeued');
	
	  var sinkClosePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'close', []);
	  sinkClosePromise.then(function () {
	    WritableStreamFinishInFlightClose(stream);
	  }, function (reason) {
	    WritableStreamFinishInFlightCloseWithError(stream, reason);
	  }).catch(rethrowAssertionErrorRejection);
	}
	
	function WritableStreamDefaultControllerProcessWrite(controller, chunk) {
	  var stream = controller._controlledWritableStream;
	
	  WritableStreamMarkFirstWriteRequestInFlight(stream);
	
	  var sinkWritePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'write', [chunk, controller]);
	  sinkWritePromise.then(function () {
	    WritableStreamFinishInFlightWrite(stream);
	
	    var state = stream._state;
	    assert(state === 'writable' || state === 'erroring');
	
	    DequeueValue(controller);
	
	    if (WritableStreamCloseQueuedOrInFlight(stream) === false && state === 'writable') {
	      var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
	      WritableStreamUpdateBackpressure(stream, backpressure);
	    }
	
	    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
	  }, function (reason) {
	    WritableStreamFinishInFlightWriteWithError(stream, reason);
	  }).catch(rethrowAssertionErrorRejection);
	}
	
	function WritableStreamDefaultControllerGetBackpressure(controller) {
	  var desiredSize = WritableStreamDefaultControllerGetDesiredSize(controller);
	  return desiredSize <= 0;
	}
	
	// A client of WritableStreamDefaultController may use these functions directly to bypass state check.
	
	function WritableStreamDefaultControllerError(controller, error) {
	  var stream = controller._controlledWritableStream;
	
	  assert(stream._state === 'writable');
	
	  WritableStreamStartErroring(stream, error);
	}
	
	// Helper functions for the WritableStream.
	
	function streamBrandCheckException(name) {
	  return new TypeError('WritableStream.prototype.' + name + ' can only be used on a WritableStream');
	}
	
	// Helper functions for the WritableStreamDefaultWriter.
	
	function defaultWriterBrandCheckException(name) {
	  return new TypeError('WritableStreamDefaultWriter.prototype.' + name + ' can only be used on a WritableStreamDefaultWriter');
	}
	
	function defaultWriterLockException(name) {
	  return new TypeError('Cannot ' + name + ' a stream using a released writer');
	}
	
	function defaultWriterClosedPromiseInitialize(writer) {
	  writer._closedPromise = new Promise(function (resolve, reject) {
	    writer._closedPromise_resolve = resolve;
	    writer._closedPromise_reject = reject;
	    writer._closedPromiseState = 'pending';
	  });
	}
	
	function defaultWriterClosedPromiseInitializeAsRejected(writer, reason) {
	  writer._closedPromise = Promise.reject(reason);
	  writer._closedPromise_resolve = undefined;
	  writer._closedPromise_reject = undefined;
	  writer._closedPromiseState = 'rejected';
	}
	
	function defaultWriterClosedPromiseInitializeAsResolved(writer) {
	  writer._closedPromise = Promise.resolve(undefined);
	  writer._closedPromise_resolve = undefined;
	  writer._closedPromise_reject = undefined;
	  writer._closedPromiseState = 'resolved';
	}
	
	function defaultWriterClosedPromiseReject(writer, reason) {
	  assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
	  assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
	  assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');
	
	  writer._closedPromise_reject(reason);
	  writer._closedPromise_resolve = undefined;
	  writer._closedPromise_reject = undefined;
	  writer._closedPromiseState = 'rejected';
	}
	
	function defaultWriterClosedPromiseResetToRejected(writer, reason) {
	  assert(writer._closedPromise_resolve === undefined, 'writer._closedPromise_resolve === undefined');
	  assert(writer._closedPromise_reject === undefined, 'writer._closedPromise_reject === undefined');
	  assert(writer._closedPromiseState !== 'pending', 'writer._closedPromiseState is not pending');
	
	  writer._closedPromise = Promise.reject(reason);
	  writer._closedPromiseState = 'rejected';
	}
	
	function defaultWriterClosedPromiseResolve(writer) {
	  assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
	  assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
	  assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');
	
	  writer._closedPromise_resolve(undefined);
	  writer._closedPromise_resolve = undefined;
	  writer._closedPromise_reject = undefined;
	  writer._closedPromiseState = 'resolved';
	}
	
	function defaultWriterReadyPromiseInitialize(writer) {
	  writer._readyPromise = new Promise(function (resolve, reject) {
	    writer._readyPromise_resolve = resolve;
	    writer._readyPromise_reject = reject;
	  });
	  writer._readyPromiseState = 'pending';
	}
	
	function defaultWriterReadyPromiseInitializeAsRejected(writer, reason) {
	  writer._readyPromise = Promise.reject(reason);
	  writer._readyPromise_resolve = undefined;
	  writer._readyPromise_reject = undefined;
	  writer._readyPromiseState = 'rejected';
	}
	
	function defaultWriterReadyPromiseInitializeAsResolved(writer) {
	  writer._readyPromise = Promise.resolve(undefined);
	  writer._readyPromise_resolve = undefined;
	  writer._readyPromise_reject = undefined;
	  writer._readyPromiseState = 'fulfilled';
	}
	
	function defaultWriterReadyPromiseReject(writer, reason) {
	  assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
	  assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');
	
	  writer._readyPromise_reject(reason);
	  writer._readyPromise_resolve = undefined;
	  writer._readyPromise_reject = undefined;
	  writer._readyPromiseState = 'rejected';
	}
	
	function defaultWriterReadyPromiseReset(writer) {
	  assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
	  assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
	
	  writer._readyPromise = new Promise(function (resolve, reject) {
	    writer._readyPromise_resolve = resolve;
	    writer._readyPromise_reject = reject;
	  });
	  writer._readyPromiseState = 'pending';
	}
	
	function defaultWriterReadyPromiseResetToRejected(writer, reason) {
	  assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
	  assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
	
	  writer._readyPromise = Promise.reject(reason);
	  writer._readyPromiseState = 'rejected';
	}
	
	function defaultWriterReadyPromiseResolve(writer) {
	  assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
	  assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');
	
	  writer._readyPromise_resolve(undefined);
	  writer._readyPromise_resolve = undefined;
	  writer._readyPromise_reject = undefined;
	  writer._readyPromiseState = 'fulfilled';
	}
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _require = __webpack_require__(0),
	    IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber;
	
	var _require2 = __webpack_require__(1),
	    assert = _require2.assert;
	
	exports.DequeueValue = function (container) {
	  assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: DequeueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
	  assert(container._queue.length > 0, 'Spec-level failure: should never dequeue from an empty queue.');
	
	  var pair = container._queue.shift();
	  container._queueTotalSize -= pair.size;
	  if (container._queueTotalSize < 0) {
	    container._queueTotalSize = 0;
	  }
	
	  return pair.value;
	};
	
	exports.EnqueueValueWithSize = function (container, value, size) {
	  assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: EnqueueValueWithSize should only be used on containers with [[queue]] and ' + '[[queueTotalSize]].');
	
	  size = Number(size);
	  if (!IsFiniteNonNegativeNumber(size)) {
	    throw new RangeError('Size must be a finite, non-NaN, non-negative number.');
	  }
	
	  container._queue.push({ value: value, size: size });
	  container._queueTotalSize += size;
	};
	
	exports.PeekQueueValue = function (container) {
	  assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: PeekQueueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
	  assert(container._queue.length > 0, 'Spec-level failure: should never peek at an empty queue.');
	
	  var pair = container._queue[0];
	  return pair.value;
	};
	
	exports.ResetQueue = function (container) {
	  assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: ResetQueue should only be used on containers with [[queue]] and [[queueTotalSize]].');
	
	  container._queue = [];
	  container._queueTotalSize = 0;
	};
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _require = __webpack_require__(0),
	    ArrayBufferCopy = _require.ArrayBufferCopy,
	    CreateIterResultObject = _require.CreateIterResultObject,
	    IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber,
	    InvokeOrNoop = _require.InvokeOrNoop,
	    PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
	    TransferArrayBuffer = _require.TransferArrayBuffer,
	    ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
	    ValidateAndNormalizeHighWaterMark = _require.ValidateAndNormalizeHighWaterMark;
	
	var _require2 = __webpack_require__(0),
	    createArrayFromList = _require2.createArrayFromList,
	    createDataProperty = _require2.createDataProperty,
	    typeIsObject = _require2.typeIsObject;
	
	var _require3 = __webpack_require__(1),
	    assert = _require3.assert,
	    rethrowAssertionErrorRejection = _require3.rethrowAssertionErrorRejection;
	
	var _require4 = __webpack_require__(3),
	    DequeueValue = _require4.DequeueValue,
	    EnqueueValueWithSize = _require4.EnqueueValueWithSize,
	    ResetQueue = _require4.ResetQueue;
	
	var _require5 = __webpack_require__(2),
	    AcquireWritableStreamDefaultWriter = _require5.AcquireWritableStreamDefaultWriter,
	    IsWritableStream = _require5.IsWritableStream,
	    IsWritableStreamLocked = _require5.IsWritableStreamLocked,
	    WritableStreamAbort = _require5.WritableStreamAbort,
	    WritableStreamDefaultWriterCloseWithErrorPropagation = _require5.WritableStreamDefaultWriterCloseWithErrorPropagation,
	    WritableStreamDefaultWriterRelease = _require5.WritableStreamDefaultWriterRelease,
	    WritableStreamDefaultWriterWrite = _require5.WritableStreamDefaultWriterWrite,
	    WritableStreamCloseQueuedOrInFlight = _require5.WritableStreamCloseQueuedOrInFlight;
	
	var ReadableStream = function () {
	  function ReadableStream() {
	    var underlyingSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        size = _ref.size,
	        highWaterMark = _ref.highWaterMark;
	
	    _classCallCheck(this, ReadableStream);
	
	    // Exposed to controllers.
	    this._state = 'readable';
	
	    this._reader = undefined;
	    this._storedError = undefined;
	
	    this._disturbed = false;
	
	    // Initialize to undefined first because the constructor of the controller checks this
	    // variable to validate the caller.
	    this._readableStreamController = undefined;
	    var type = underlyingSource.type;
	    var typeString = String(type);
	    if (typeString === 'bytes') {
	      if (highWaterMark === undefined) {
	        highWaterMark = 0;
	      }
	      this._readableStreamController = new ReadableByteStreamController(this, underlyingSource, highWaterMark);
	    } else if (type === undefined) {
	      if (highWaterMark === undefined) {
	        highWaterMark = 1;
	      }
	      this._readableStreamController = new ReadableStreamDefaultController(this, underlyingSource, size, highWaterMark);
	    } else {
	      throw new RangeError('Invalid type is specified');
	    }
	  }
	
	  _createClass(ReadableStream, [{
	    key: 'cancel',
	    value: function cancel(reason) {
	      if (IsReadableStream(this) === false) {
	        return Promise.reject(streamBrandCheckException('cancel'));
	      }
	
	      if (IsReadableStreamLocked(this) === true) {
	        return Promise.reject(new TypeError('Cannot cancel a stream that already has a reader'));
	      }
	
	      return ReadableStreamCancel(this, reason);
	    }
	  }, {
	    key: 'getReader',
	    value: function getReader() {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          mode = _ref2.mode;
	
	      if (IsReadableStream(this) === false) {
	        throw streamBrandCheckException('getReader');
	      }
	
	      if (mode === undefined) {
	        return AcquireReadableStreamDefaultReader(this);
	      }
	
	      mode = String(mode);
	
	      if (mode === 'byob') {
	        return AcquireReadableStreamBYOBReader(this);
	      }
	
	      throw new RangeError('Invalid mode is specified');
	    }
	  }, {
	    key: 'pipeThrough',
	    value: function pipeThrough(_ref3, options) {
	      var writable = _ref3.writable,
	          readable = _ref3.readable;
	
	      var promise = this.pipeTo(writable, options);
	
	      ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise);
	
	      return readable;
	    }
	  }, {
	    key: 'pipeTo',
	    value: function pipeTo(dest) {
	      var _this = this;
	
	      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          preventClose = _ref4.preventClose,
	          preventAbort = _ref4.preventAbort,
	          preventCancel = _ref4.preventCancel;
	
	      if (IsReadableStream(this) === false) {
	        return Promise.reject(streamBrandCheckException('pipeTo'));
	      }
	      if (IsWritableStream(dest) === false) {
	        return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo\'s first argument must be a WritableStream'));
	      }
	
	      preventClose = Boolean(preventClose);
	      preventAbort = Boolean(preventAbort);
	      preventCancel = Boolean(preventCancel);
	
	      if (IsReadableStreamLocked(this) === true) {
	        return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream'));
	      }
	      if (IsWritableStreamLocked(dest) === true) {
	        return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream'));
	      }
	
	      var reader = AcquireReadableStreamDefaultReader(this);
	      var writer = AcquireWritableStreamDefaultWriter(dest);
	
	      var shuttingDown = false;
	
	      // This is used to keep track of the spec's requirement that we wait for ongoing writes during shutdown.
	      var currentWrite = Promise.resolve();
	
	      return new Promise(function (resolve, reject) {
	        // Using reader and writer, read all chunks from this and write them to dest
	        // - Backpressure must be enforced
	        // - Shutdown must stop all activity
	        function pipeLoop() {
	          currentWrite = Promise.resolve();
	
	          if (shuttingDown === true) {
	            return Promise.resolve();
	          }
	
	          return writer._readyPromise.then(function () {
	            return ReadableStreamDefaultReaderRead(reader).then(function (_ref5) {
	              var value = _ref5.value,
	                  done = _ref5.done;
	
	              if (done === true) {
	                return;
	              }
	
	              currentWrite = WritableStreamDefaultWriterWrite(writer, value).catch(function () {});
	            });
	          }).then(pipeLoop);
	        }
	
	        // Errors must be propagated forward
	        isOrBecomesErrored(_this, reader._closedPromise, function (storedError) {
	          if (preventAbort === false) {
	            shutdownWithAction(function () {
	              return WritableStreamAbort(dest, storedError);
	            }, true, storedError);
	          } else {
	            shutdown(true, storedError);
	          }
	        });
	
	        // Errors must be propagated backward
	        isOrBecomesErrored(dest, writer._closedPromise, function (storedError) {
	          if (preventCancel === false) {
	            shutdownWithAction(function () {
	              return ReadableStreamCancel(_this, storedError);
	            }, true, storedError);
	          } else {
	            shutdown(true, storedError);
	          }
	        });
	
	        // Closing must be propagated forward
	        isOrBecomesClosed(_this, reader._closedPromise, function () {
	          if (preventClose === false) {
	            shutdownWithAction(function () {
	              return WritableStreamDefaultWriterCloseWithErrorPropagation(writer);
	            });
	          } else {
	            shutdown();
	          }
	        });
	
	        // Closing must be propagated backward
	        if (WritableStreamCloseQueuedOrInFlight(dest) === true || dest._state === 'closed') {
	          var destClosed = new TypeError('the destination writable stream closed before all data could be piped to it');
	
	          if (preventCancel === false) {
	            shutdownWithAction(function () {
	              return ReadableStreamCancel(_this, destClosed);
	            }, true, destClosed);
	          } else {
	            shutdown(true, destClosed);
	          }
	        }
	
	        pipeLoop().catch(function (err) {
	          currentWrite = Promise.resolve();
	          rethrowAssertionErrorRejection(err);
	        });
	
	        function waitForWritesToFinish() {
	          // Another write may have started while we were waiting on this currentWrite, so we have to be sure to wait
	          // for that too.
	          var oldCurrentWrite = currentWrite;
	          return currentWrite.then(function () {
	            return oldCurrentWrite !== currentWrite ? waitForWritesToFinish() : undefined;
	          });
	        }
	
	        function isOrBecomesErrored(stream, promise, action) {
	          if (stream._state === 'errored') {
	            action(stream._storedError);
	          } else {
	            promise.catch(action).catch(rethrowAssertionErrorRejection);
	          }
	        }
	
	        function isOrBecomesClosed(stream, promise, action) {
	          if (stream._state === 'closed') {
	            action();
	          } else {
	            promise.then(action).catch(rethrowAssertionErrorRejection);
	          }
	        }
	
	        function shutdownWithAction(action, originalIsError, originalError) {
	          if (shuttingDown === true) {
	            return;
	          }
	          shuttingDown = true;
	
	          if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
	            waitForWritesToFinish().then(doTheRest);
	          } else {
	            doTheRest();
	          }
	
	          function doTheRest() {
	            action().then(function () {
	              return finalize(originalIsError, originalError);
	            }, function (newError) {
	              return finalize(true, newError);
	            }).catch(rethrowAssertionErrorRejection);
	          }
	        }
	
	        function shutdown(isError, error) {
	          if (shuttingDown === true) {
	            return;
	          }
	          shuttingDown = true;
	
	          if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
	            waitForWritesToFinish().then(function () {
	              return finalize(isError, error);
	            }).catch(rethrowAssertionErrorRejection);
	          } else {
	            finalize(isError, error);
	          }
	        }
	
	        function finalize(isError, error) {
	          WritableStreamDefaultWriterRelease(writer);
	          ReadableStreamReaderGenericRelease(reader);
	
	          if (isError) {
	            reject(error);
	          } else {
	            resolve(undefined);
	          }
	        }
	      });
	    }
	  }, {
	    key: 'tee',
	    value: function tee() {
	      if (IsReadableStream(this) === false) {
	        throw streamBrandCheckException('tee');
	      }
	
	      var branches = ReadableStreamTee(this, false);
	      return createArrayFromList(branches);
	    }
	  }, {
	    key: 'locked',
	    get: function get() {
	      if (IsReadableStream(this) === false) {
	        throw streamBrandCheckException('locked');
	      }
	
	      return IsReadableStreamLocked(this);
	    }
	  }]);
	
	  return ReadableStream;
	}();
	
	module.exports = {
	  ReadableStream: ReadableStream,
	  IsReadableStreamDisturbed: IsReadableStreamDisturbed,
	  ReadableStreamDefaultControllerClose: ReadableStreamDefaultControllerClose,
	  ReadableStreamDefaultControllerEnqueue: ReadableStreamDefaultControllerEnqueue,
	  ReadableStreamDefaultControllerError: ReadableStreamDefaultControllerError,
	  ReadableStreamDefaultControllerGetDesiredSize: ReadableStreamDefaultControllerGetDesiredSize
	};
	
	// Abstract operations for the ReadableStream.
	
	function AcquireReadableStreamBYOBReader(stream) {
	  return new ReadableStreamBYOBReader(stream);
	}
	
	function AcquireReadableStreamDefaultReader(stream) {
	  return new ReadableStreamDefaultReader(stream);
	}
	
	function IsReadableStream(x) {
	  if (!typeIsObject(x)) {
	    return false;
	  }
	
	  if (!Object.prototype.hasOwnProperty.call(x, '_readableStreamController')) {
	    return false;
	  }
	
	  return true;
	}
	
	function IsReadableStreamDisturbed(stream) {
	  assert(IsReadableStream(stream) === true, 'IsReadableStreamDisturbed should only be used on known readable streams');
	
	  return stream._disturbed;
	}
	
	function IsReadableStreamLocked(stream) {
	  assert(IsReadableStream(stream) === true, 'IsReadableStreamLocked should only be used on known readable streams');
	
	  if (stream._reader === undefined) {
	    return false;
	  }
	
	  return true;
	}
	
	function ReadableStreamTee(stream, cloneForBranch2) {
	  assert(IsReadableStream(stream) === true);
	  assert(typeof cloneForBranch2 === 'boolean');
	
	  var reader = AcquireReadableStreamDefaultReader(stream);
	
	  var teeState = {
	    closedOrErrored: false,
	    canceled1: false,
	    canceled2: false,
	    reason1: undefined,
	    reason2: undefined
	  };
	  teeState.promise = new Promise(function (resolve) {
	    teeState._resolve = resolve;
	  });
	
	  var pull = create_ReadableStreamTeePullFunction();
	  pull._reader = reader;
	  pull._teeState = teeState;
	  pull._cloneForBranch2 = cloneForBranch2;
	
	  var cancel1 = create_ReadableStreamTeeBranch1CancelFunction();
	  cancel1._stream = stream;
	  cancel1._teeState = teeState;
	
	  var cancel2 = create_ReadableStreamTeeBranch2CancelFunction();
	  cancel2._stream = stream;
	  cancel2._teeState = teeState;
	
	  var underlyingSource1 = Object.create(Object.prototype);
	  createDataProperty(underlyingSource1, 'pull', pull);
	  createDataProperty(underlyingSource1, 'cancel', cancel1);
	  var branch1Stream = new ReadableStream(underlyingSource1);
	
	  var underlyingSource2 = Object.create(Object.prototype);
	  createDataProperty(underlyingSource2, 'pull', pull);
	  createDataProperty(underlyingSource2, 'cancel', cancel2);
	  var branch2Stream = new ReadableStream(underlyingSource2);
	
	  pull._branch1 = branch1Stream._readableStreamController;
	  pull._branch2 = branch2Stream._readableStreamController;
	
	  reader._closedPromise.catch(function (r) {
	    if (teeState.closedOrErrored === true) {
	      return;
	    }
	
	    ReadableStreamDefaultControllerError(pull._branch1, r);
	    ReadableStreamDefaultControllerError(pull._branch2, r);
	    teeState.closedOrErrored = true;
	  });
	
	  return [branch1Stream, branch2Stream];
	}
	
	function create_ReadableStreamTeePullFunction() {
	  function f() {
	    var reader = f._reader,
	        branch1 = f._branch1,
	        branch2 = f._branch2,
	        teeState = f._teeState;
	
	
	    return ReadableStreamDefaultReaderRead(reader).then(function (result) {
	      assert(typeIsObject(result));
	      var value = result.value;
	      var done = result.done;
	      assert(typeof done === 'boolean');
	
	      if (done === true && teeState.closedOrErrored === false) {
	        if (teeState.canceled1 === false) {
	          ReadableStreamDefaultControllerClose(branch1);
	        }
	        if (teeState.canceled2 === false) {
	          ReadableStreamDefaultControllerClose(branch2);
	        }
	        teeState.closedOrErrored = true;
	      }
	
	      if (teeState.closedOrErrored === true) {
	        return;
	      }
	
	      var value1 = value;
	      var value2 = value;
	
	      // There is no way to access the cloning code right now in the reference implementation.
	      // If we add one then we'll need an implementation for serializable objects.
	      // if (teeState.canceled2 === false && cloneForBranch2 === true) {
	      //   value2 = StructuredDeserialize(StructuredSerialize(value2));
	      // }
	
	      if (teeState.canceled1 === false) {
	        ReadableStreamDefaultControllerEnqueue(branch1, value1);
	      }
	
	      if (teeState.canceled2 === false) {
	        ReadableStreamDefaultControllerEnqueue(branch2, value2);
	      }
	    });
	  }
	  return f;
	}
	
	function create_ReadableStreamTeeBranch1CancelFunction() {
	  function f(reason) {
	    var stream = f._stream,
	        teeState = f._teeState;
	
	
	    teeState.canceled1 = true;
	    teeState.reason1 = reason;
	    if (teeState.canceled2 === true) {
	      var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
	      var cancelResult = ReadableStreamCancel(stream, compositeReason);
	      teeState._resolve(cancelResult);
	    }
	    return teeState.promise;
	  }
	  return f;
	}
	
	function create_ReadableStreamTeeBranch2CancelFunction() {
	  function f(reason) {
	    var stream = f._stream,
	        teeState = f._teeState;
	
	
	    teeState.canceled2 = true;
	    teeState.reason2 = reason;
	    if (teeState.canceled1 === true) {
	      var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
	      var cancelResult = ReadableStreamCancel(stream, compositeReason);
	      teeState._resolve(cancelResult);
	    }
	    return teeState.promise;
	  }
	  return f;
	}
	
	// ReadableStream API exposed for controllers.
	
	function ReadableStreamAddReadIntoRequest(stream) {
	  assert(IsReadableStreamBYOBReader(stream._reader) === true);
	  assert(stream._state === 'readable' || stream._state === 'closed');
	
	  var promise = new Promise(function (resolve, reject) {
	    var readIntoRequest = {
	      _resolve: resolve,
	      _reject: reject
	    };
	
	    stream._reader._readIntoRequests.push(readIntoRequest);
	  });
	
	  return promise;
	}
	
	function ReadableStreamAddReadRequest(stream) {
	  assert(IsReadableStreamDefaultReader(stream._reader) === true);
	  assert(stream._state === 'readable');
	
	  var promise = new Promise(function (resolve, reject) {
	    var readRequest = {
	      _resolve: resolve,
	      _reject: reject
	    };
	
	    stream._reader._readRequests.push(readRequest);
	  });
	
	  return promise;
	}
	
	function ReadableStreamCancel(stream, reason) {
	  stream._disturbed = true;
	
	  if (stream._state === 'closed') {
	    return Promise.resolve(undefined);
	  }
	  if (stream._state === 'errored') {
	    return Promise.reject(stream._storedError);
	  }
	
	  ReadableStreamClose(stream);
	
	  var sourceCancelPromise = stream._readableStreamController.__cancelSteps(reason);
	  return sourceCancelPromise.then(function () {
	    return undefined;
	  });
	}
	
	function ReadableStreamClose(stream) {
	  assert(stream._state === 'readable');
	
	  stream._state = 'closed';
	
	  var reader = stream._reader;
	
	  if (reader === undefined) {
	    return undefined;
	  }
	
	  if (IsReadableStreamDefaultReader(reader) === true) {
	    for (var i = 0; i < reader._readRequests.length; i++) {
	      var _resolve = reader._readRequests[i]._resolve;
	
	      _resolve(CreateIterResultObject(undefined, true));
	    }
	    reader._readRequests = [];
	  }
	
	  defaultReaderClosedPromiseResolve(reader);
	
	  return undefined;
	}
	
	function ReadableStreamError(stream, e) {
	  assert(IsReadableStream(stream) === true, 'stream must be ReadableStream');
	  assert(stream._state === 'readable', 'state must be readable');
	
	  stream._state = 'errored';
	  stream._storedError = e;
	
	  var reader = stream._reader;
	
	  if (reader === undefined) {
	    return undefined;
	  }
	
	  if (IsReadableStreamDefaultReader(reader) === true) {
	    for (var i = 0; i < reader._readRequests.length; i++) {
	      var readRequest = reader._readRequests[i];
	      readRequest._reject(e);
	    }
	
	    reader._readRequests = [];
	  } else {
	    assert(IsReadableStreamBYOBReader(reader), 'reader must be ReadableStreamBYOBReader');
	
	    for (var _i = 0; _i < reader._readIntoRequests.length; _i++) {
	      var readIntoRequest = reader._readIntoRequests[_i];
	      readIntoRequest._reject(e);
	    }
	
	    reader._readIntoRequests = [];
	  }
	
	  defaultReaderClosedPromiseReject(reader, e);
	  reader._closedPromise.catch(function () {});
	}
	
	function ReadableStreamFulfillReadIntoRequest(stream, chunk, done) {
	  var reader = stream._reader;
	
	  assert(reader._readIntoRequests.length > 0);
	
	  var readIntoRequest = reader._readIntoRequests.shift();
	  readIntoRequest._resolve(CreateIterResultObject(chunk, done));
	}
	
	function ReadableStreamFulfillReadRequest(stream, chunk, done) {
	  var reader = stream._reader;
	
	  assert(reader._readRequests.length > 0);
	
	  var readRequest = reader._readRequests.shift();
	  readRequest._resolve(CreateIterResultObject(chunk, done));
	}
	
	function ReadableStreamGetNumReadIntoRequests(stream) {
	  return stream._reader._readIntoRequests.length;
	}
	
	function ReadableStreamGetNumReadRequests(stream) {
	  return stream._reader._readRequests.length;
	}
	
	function ReadableStreamHasBYOBReader(stream) {
	  var reader = stream._reader;
	
	  if (reader === undefined) {
	    return false;
	  }
	
	  if (IsReadableStreamBYOBReader(reader) === false) {
	    return false;
	  }
	
	  return true;
	}
	
	function ReadableStreamHasDefaultReader(stream) {
	  var reader = stream._reader;
	
	  if (reader === undefined) {
	    return false;
	  }
	
	  if (IsReadableStreamDefaultReader(reader) === false) {
	    return false;
	  }
	
	  return true;
	}
	
	// Readers
	
	var ReadableStreamDefaultReader = function () {
	  function ReadableStreamDefaultReader(stream) {
	    _classCallCheck(this, ReadableStreamDefaultReader);
	
	    if (IsReadableStream(stream) === false) {
	      throw new TypeError('ReadableStreamDefaultReader can only be constructed with a ReadableStream instance');
	    }
	    if (IsReadableStreamLocked(stream) === true) {
	      throw new TypeError('This stream has already been locked for exclusive reading by another reader');
	    }
	
	    ReadableStreamReaderGenericInitialize(this, stream);
	
	    this._readRequests = [];
	  }
	
	  _createClass(ReadableStreamDefaultReader, [{
	    key: 'cancel',
	    value: function cancel(reason) {
	      if (IsReadableStreamDefaultReader(this) === false) {
	        return Promise.reject(defaultReaderBrandCheckException('cancel'));
	      }
	
	      if (this._ownerReadableStream === undefined) {
	        return Promise.reject(readerLockException('cancel'));
	      }
	
	      return ReadableStreamReaderGenericCancel(this, reason);
	    }
	  }, {
	    key: 'read',
	    value: function read() {
	      if (IsReadableStreamDefaultReader(this) === false) {
	        return Promise.reject(defaultReaderBrandCheckException('read'));
	      }
	
	      if (this._ownerReadableStream === undefined) {
	        return Promise.reject(readerLockException('read from'));
	      }
	
	      return ReadableStreamDefaultReaderRead(this);
	    }
	  }, {
	    key: 'releaseLock',
	    value: function releaseLock() {
	      if (IsReadableStreamDefaultReader(this) === false) {
	        throw defaultReaderBrandCheckException('releaseLock');
	      }
	
	      if (this._ownerReadableStream === undefined) {
	        return;
	      }
	
	      if (this._readRequests.length > 0) {
	        throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
	      }
	
	      ReadableStreamReaderGenericRelease(this);
	    }
	  }, {
	    key: 'closed',
	    get: function get() {
	      if (IsReadableStreamDefaultReader(this) === false) {
	        return Promise.reject(defaultReaderBrandCheckException('closed'));
	      }
	
	      return this._closedPromise;
	    }
	  }]);
	
	  return ReadableStreamDefaultReader;
	}();
	
	var ReadableStreamBYOBReader = function () {
	  function ReadableStreamBYOBReader(stream) {
	    _classCallCheck(this, ReadableStreamBYOBReader);
	
	    if (!IsReadableStream(stream)) {
	      throw new TypeError('ReadableStreamBYOBReader can only be constructed with a ReadableStream instance given a ' + 'byte source');
	    }
	    if (IsReadableByteStreamController(stream._readableStreamController) === false) {
	      throw new TypeError('Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte ' + 'source');
	    }
	    if (IsReadableStreamLocked(stream)) {
	      throw new TypeError('This stream has already been locked for exclusive reading by another reader');
	    }
	
	    ReadableStreamReaderGenericInitialize(this, stream);
	
	    this._readIntoRequests = [];
	  }
	
	  _createClass(ReadableStreamBYOBReader, [{
	    key: 'cancel',
	    value: function cancel(reason) {
	      if (!IsReadableStreamBYOBReader(this)) {
	        return Promise.reject(byobReaderBrandCheckException('cancel'));
	      }
	
	      if (this._ownerReadableStream === undefined) {
	        return Promise.reject(readerLockException('cancel'));
	      }
	
	      return ReadableStreamReaderGenericCancel(this, reason);
	    }
	  }, {
	    key: 'read',
	    value: function read(view) {
	      if (!IsReadableStreamBYOBReader(this)) {
	        return Promise.reject(byobReaderBrandCheckException('read'));
	      }
	
	      if (this._ownerReadableStream === undefined) {
	        return Promise.reject(readerLockException('read from'));
	      }
	
	      if (!ArrayBuffer.isView(view)) {
	        return Promise.reject(new TypeError('view must be an array buffer view'));
	      }
	
	      if (view.byteLength === 0) {
	        return Promise.reject(new TypeError('view must have non-zero byteLength'));
	      }
	
	      return ReadableStreamBYOBReaderRead(this, view);
	    }
	  }, {
	    key: 'releaseLock',
	    value: function releaseLock() {
	      if (!IsReadableStreamBYOBReader(this)) {
	        throw byobReaderBrandCheckException('releaseLock');
	      }
	
	      if (this._ownerReadableStream === undefined) {
	        return;
	      }
	
	      if (this._readIntoRequests.length > 0) {
	        throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
	      }
	
	      ReadableStreamReaderGenericRelease(this);
	    }
	  }, {
	    key: 'closed',
	    get: function get() {
	      if (!IsReadableStreamBYOBReader(this)) {
	        return Promise.reject(byobReaderBrandCheckException('closed'));
	      }
	
	      return this._closedPromise;
	    }
	  }]);
	
	  return ReadableStreamBYOBReader;
	}();
	
	// Abstract operations for the readers.
	
	function IsReadableStreamBYOBReader(x) {
	  if (!typeIsObject(x)) {
	    return false;
	  }
	
	  if (!Object.prototype.hasOwnProperty.call(x, '_readIntoRequests')) {
	    return false;
	  }
	
	  return true;
	}
	
	function IsReadableStreamDefaultReader(x) {
	  if (!typeIsObject(x)) {
	    return false;
	  }
	
	  if (!Object.prototype.hasOwnProperty.call(x, '_readRequests')) {
	    return false;
	  }
	
	  return true;
	}
	
	function ReadableStreamReaderGenericInitialize(reader, stream) {
	  reader._ownerReadableStream = stream;
	  stream._reader = reader;
	
	  if (stream._state === 'readable') {
	    defaultReaderClosedPromiseInitialize(reader);
	  } else if (stream._state === 'closed') {
	    defaultReaderClosedPromiseInitializeAsResolved(reader);
	  } else {
	    assert(stream._state === 'errored', 'state must be errored');
	
	    defaultReaderClosedPromiseInitializeAsRejected(reader, stream._storedError);
	    reader._closedPromise.catch(function () {});
	  }
	}
	
	// A client of ReadableStreamDefaultReader and ReadableStreamBYOBReader may use these functions directly to bypass state
	// check.
	
	function ReadableStreamReaderGenericCancel(reader, reason) {
	  var stream = reader._ownerReadableStream;
	  assert(stream !== undefined);
	  return ReadableStreamCancel(stream, reason);
	}
	
	function ReadableStreamReaderGenericRelease(reader) {
	  assert(reader._ownerReadableStream !== undefined);
	  assert(reader._ownerReadableStream._reader === reader);
	
	  if (reader._ownerReadableStream._state === 'readable') {
	    defaultReaderClosedPromiseReject(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
	  } else {
	    defaultReaderClosedPromiseResetToRejected(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
	  }
	  reader._closedPromise.catch(function () {});
	
	  reader._ownerReadableStream._reader = undefined;
	  reader._ownerReadableStream = undefined;
	}
	
	function ReadableStreamBYOBReaderRead(reader, view) {
	  var stream = reader._ownerReadableStream;
	
	  assert(stream !== undefined);
	
	  stream._disturbed = true;
	
	  if (stream._state === 'errored') {
	    return Promise.reject(stream._storedError);
	  }
	
	  // Controllers must implement this.
	  return ReadableByteStreamControllerPullInto(stream._readableStreamController, view);
	}
	
	function ReadableStreamDefaultReaderRead(reader) {
	  var stream = reader._ownerReadableStream;
	
	  assert(stream !== undefined);
	
	  stream._disturbed = true;
	
	  if (stream._state === 'closed') {
	    return Promise.resolve(CreateIterResultObject(undefined, true));
	  }
	
	  if (stream._state === 'errored') {
	    return Promise.reject(stream._storedError);
	  }
	
	  assert(stream._state === 'readable');
	
	  return stream._readableStreamController.__pullSteps();
	}
	
	// Controllers
	
	var ReadableStreamDefaultController = function () {
	  function ReadableStreamDefaultController(stream, underlyingSource, size, highWaterMark) {
	    _classCallCheck(this, ReadableStreamDefaultController);
	
	    if (IsReadableStream(stream) === false) {
	      throw new TypeError('ReadableStreamDefaultController can only be constructed with a ReadableStream instance');
	    }
	
	    if (stream._readableStreamController !== undefined) {
	      throw new TypeError('ReadableStreamDefaultController instances can only be created by the ReadableStream constructor');
	    }
	
	    this._controlledReadableStream = stream;
	
	    this._underlyingSource = underlyingSource;
	
	    // Need to set the slots so that the assert doesn't fire. In the spec the slots already exist implicitly.
	    this._queue = undefined;
	    this._queueTotalSize = undefined;
	    ResetQueue(this);
	
	    this._started = false;
	    this._closeRequested = false;
	    this._pullAgain = false;
	    this._pulling = false;
	
	    var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
	    this._strategySize = normalizedStrategy.size;
	    this._strategyHWM = normalizedStrategy.highWaterMark;
	
	    var controller = this;
	
	    var startResult = InvokeOrNoop(underlyingSource, 'start', [this]);
	    Promise.resolve(startResult).then(function () {
	      controller._started = true;
	
	      assert(controller._pulling === false);
	      assert(controller._pullAgain === false);
	
	      ReadableStreamDefaultControllerCallPullIfNeeded(controller);
	    }, function (r) {
	      ReadableStreamDefaultControllerErrorIfNeeded(controller, r);
	    }).catch(rethrowAssertionErrorRejection);
	  }
	
	  _createClass(ReadableStreamDefaultController, [{
	    key: 'close',
	    value: function close() {
	      if (IsReadableStreamDefaultController(this) === false) {
	        throw defaultControllerBrandCheckException('close');
	      }
	
	      if (this._closeRequested === true) {
	        throw new TypeError('The stream has already been closed; do not close it again!');
	      }
	
	      var state = this._controlledReadableStream._state;
	      if (state !== 'readable') {
	        throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
	      }
	
	      ReadableStreamDefaultControllerClose(this);
	    }
	  }, {
	    key: 'enqueue',
	    value: function enqueue(chunk) {
	      if (IsReadableStreamDefaultController(this) === false) {
	        throw defaultControllerBrandCheckException('enqueue');
	      }
	
	      if (this._closeRequested === true) {
	        throw new TypeError('stream is closed or draining');
	      }
	
	      var state = this._controlledReadableStream._state;
	      if (state !== 'readable') {
	        throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
	      }
	
	      return ReadableStreamDefaultControllerEnqueue(this, chunk);
	    }
	  }, {
	    key: 'error',
	    value: function error(e) {
	      if (IsReadableStreamDefaultController(this) === false) {
	        throw defaultControllerBrandCheckException('error');
	      }
	
	      var stream = this._controlledReadableStream;
	      if (stream._state !== 'readable') {
	        throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
	      }
	
	      ReadableStreamDefaultControllerError(this, e);
	    }
	  }, {
	    key: '__cancelSteps',
	    value: function __cancelSteps(reason) {
	      ResetQueue(this);
	      return PromiseInvokeOrNoop(this._underlyingSource, 'cancel', [reason]);
	    }
	  }, {
	    key: '__pullSteps',
	    value: function __pullSteps() {
	      var stream = this._controlledReadableStream;
	
	      if (this._queue.length > 0) {
	        var chunk = DequeueValue(this);
	
	        if (this._closeRequested === true && this._queue.length === 0) {
	          ReadableStreamClose(stream);
	        } else {
	          ReadableStreamDefaultControllerCallPullIfNeeded(this);
	        }
	
	        return Promise.resolve(CreateIterResultObject(chunk, false));
	      }
	
	      var pendingPromise = ReadableStreamAddReadRequest(stream);
	      ReadableStreamDefaultControllerCallPullIfNeeded(this);
	      return pendingPromise;
	    }
	  }, {
	    key: 'desiredSize',
	    get: function get() {
	      if (IsReadableStreamDefaultController(this) === false) {
	        throw defaultControllerBrandCheckException('desiredSize');
	      }
	
	      return ReadableStreamDefaultControllerGetDesiredSize(this);
	    }
	  }]);
	
	  return ReadableStreamDefaultController;
	}();
	
	// Abstract operations for the ReadableStreamDefaultController.
	
	function IsReadableStreamDefaultController(x) {
	  if (!typeIsObject(x)) {
	    return false;
	  }
	
	  if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSource')) {
	    return false;
	  }
	
	  return true;
	}
	
	function ReadableStreamDefaultControllerCallPullIfNeeded(controller) {
	  var shouldPull = ReadableStreamDefaultControllerShouldCallPull(controller);
	  if (shouldPull === false) {
	    return undefined;
	  }
	
	  if (controller._pulling === true) {
	    controller._pullAgain = true;
	    return undefined;
	  }
	
	  assert(controller._pullAgain === false);
	
	  controller._pulling = true;
	
	  var pullPromise = PromiseInvokeOrNoop(controller._underlyingSource, 'pull', [controller]);
	  pullPromise.then(function () {
	    controller._pulling = false;
	
	    if (controller._pullAgain === true) {
	      controller._pullAgain = false;
	      return ReadableStreamDefaultControllerCallPullIfNeeded(controller);
	    }
	    return undefined;
	  }, function (e) {
	    ReadableStreamDefaultControllerErrorIfNeeded(controller, e);
	  }).catch(rethrowAssertionErrorRejection);
	
	  return undefined;
	}
	
	function ReadableStreamDefaultControllerShouldCallPull(controller) {
	  var stream = controller._controlledReadableStream;
	
	  if (stream._state === 'closed' || stream._state === 'errored') {
	    return false;
	  }
	
	  if (controller._closeRequested === true) {
	    return false;
	  }
	
	  if (controller._started === false) {
	    return false;
	  }
	
	  if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
	    return true;
	  }
	
	  var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
	  if (desiredSize > 0) {
	    return true;
	  }
	
	  return false;
	}
	
	// A client of ReadableStreamDefaultController may use these functions directly to bypass state check.
	
	function ReadableStreamDefaultControllerClose(controller) {
	  var stream = controller._controlledReadableStream;
	
	  assert(controller._closeRequested === false);
	  assert(stream._state === 'readable');
	
	  controller._closeRequested = true;
	
	  if (controller._queue.length === 0) {
	    ReadableStreamClose(stream);
	  }
	}
	
	function ReadableStreamDefaultControllerEnqueue(controller, chunk) {
	  var stream = controller._controlledReadableStream;
	
	  assert(controller._closeRequested === false);
	  assert(stream._state === 'readable');
	
	  if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
	    ReadableStreamFulfillReadRequest(stream, chunk, false);
	  } else {
	    var chunkSize = 1;
	
	    if (controller._strategySize !== undefined) {
	      var strategySize = controller._strategySize;
	      try {
	        chunkSize = strategySize(chunk);
	      } catch (chunkSizeE) {
	        ReadableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
	        throw chunkSizeE;
	      }
	    }
	
	    try {
	      EnqueueValueWithSize(controller, chunk, chunkSize);
	    } catch (enqueueE) {
	      ReadableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
	      throw enqueueE;
	    }
	  }
	
	  ReadableStreamDefaultControllerCallPullIfNeeded(controller);
	
	  return undefined;
	}
	
	function ReadableStreamDefaultControllerError(controller, e) {
	  var stream = controller._controlledReadableStream;
	
	  assert(stream._state === 'readable');
	
	  ResetQueue(controller);
	
	  ReadableStreamError(stream, e);
	}
	
	function ReadableStreamDefaultControllerErrorIfNeeded(controller, e) {
	  if (controller._controlledReadableStream._state === 'readable') {
	    ReadableStreamDefaultControllerError(controller, e);
	  }
	}
	
	function ReadableStreamDefaultControllerGetDesiredSize(controller) {
	  var stream = controller._controlledReadableStream;
	  var state = stream._state;
	
	  if (state === 'errored') {
	    return null;
	  }
	  if (state === 'closed') {
	    return 0;
	  }
	
	  return controller._strategyHWM - controller._queueTotalSize;
	}
	
	var ReadableStreamBYOBRequest = function () {
	  function ReadableStreamBYOBRequest(controller, view) {
	    _classCallCheck(this, ReadableStreamBYOBRequest);
	
	    this._associatedReadableByteStreamController = controller;
	    this._view = view;
	  }
	
	  _createClass(ReadableStreamBYOBRequest, [{
	    key: 'respond',
	    value: function respond(bytesWritten) {
	      if (IsReadableStreamBYOBRequest(this) === false) {
	        throw byobRequestBrandCheckException('respond');
	      }
	
	      if (this._associatedReadableByteStreamController === undefined) {
	        throw new TypeError('This BYOB request has been invalidated');
	      }
	
	      ReadableByteStreamControllerRespond(this._associatedReadableByteStreamController, bytesWritten);
	    }
	  }, {
	    key: 'respondWithNewView',
	    value: function respondWithNewView(view) {
	      if (IsReadableStreamBYOBRequest(this) === false) {
	        throw byobRequestBrandCheckException('respond');
	      }
	
	      if (this._associatedReadableByteStreamController === undefined) {
	        throw new TypeError('This BYOB request has been invalidated');
	      }
	
	      if (!ArrayBuffer.isView(view)) {
	        throw new TypeError('You can only respond with array buffer views');
	      }
	
	      ReadableByteStreamControllerRespondWithNewView(this._associatedReadableByteStreamController, view);
	    }
	  }, {
	    key: 'view',
	    get: function get() {
	      return this._view;
	    }
	  }]);
	
	  return ReadableStreamBYOBRequest;
	}();
	
	var ReadableByteStreamController = function () {
	  function ReadableByteStreamController(stream, underlyingByteSource, highWaterMark) {
	    _classCallCheck(this, ReadableByteStreamController);
	
	    if (IsReadableStream(stream) === false) {
	      throw new TypeError('ReadableByteStreamController can only be constructed with a ReadableStream instance given ' + 'a byte source');
	    }
	
	    if (stream._readableStreamController !== undefined) {
	      throw new TypeError('ReadableByteStreamController instances can only be created by the ReadableStream constructor given a byte ' + 'source');
	    }
	
	    this._controlledReadableStream = stream;
	
	    this._underlyingByteSource = underlyingByteSource;
	
	    this._pullAgain = false;
	    this._pulling = false;
	
	    ReadableByteStreamControllerClearPendingPullIntos(this);
	
	    // Need to set the slots so that the assert doesn't fire. In the spec the slots already exist implicitly.
	    this._queue = this._queueTotalSize = undefined;
	    ResetQueue(this);
	
	    this._closeRequested = false;
	    this._started = false;
	
	    this._strategyHWM = ValidateAndNormalizeHighWaterMark(highWaterMark);
	
	    var autoAllocateChunkSize = underlyingByteSource.autoAllocateChunkSize;
	    if (autoAllocateChunkSize !== undefined) {
	      if (Number.isInteger(autoAllocateChunkSize) === false || autoAllocateChunkSize <= 0) {
	        throw new RangeError('autoAllocateChunkSize must be a positive integer');
	      }
	    }
	    this._autoAllocateChunkSize = autoAllocateChunkSize;
	
	    this._pendingPullIntos = [];
	
	    var controller = this;
	
	    var startResult = InvokeOrNoop(underlyingByteSource, 'start', [this]);
	    Promise.resolve(startResult).then(function () {
	      controller._started = true;
	
	      assert(controller._pulling === false);
	      assert(controller._pullAgain === false);
	
	      ReadableByteStreamControllerCallPullIfNeeded(controller);
	    }, function (r) {
	      if (stream._state === 'readable') {
	        ReadableByteStreamControllerError(controller, r);
	      }
	    }).catch(rethrowAssertionErrorRejection);
	  }
	
	  _createClass(ReadableByteStreamController, [{
	    key: 'close',
	    value: function close() {
	      if (IsReadableByteStreamController(this) === false) {
	        throw byteStreamControllerBrandCheckException('close');
	      }
	
	      if (this._closeRequested === true) {
	        throw new TypeError('The stream has already been closed; do not close it again!');
	      }
	
	      var state = this._controlledReadableStream._state;
	      if (state !== 'readable') {
	        throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
	      }
	
	      ReadableByteStreamControllerClose(this);
	    }
	  }, {
	    key: 'enqueue',
	    value: function enqueue(chunk) {
	      if (IsReadableByteStreamController(this) === false) {
	        throw byteStreamControllerBrandCheckException('enqueue');
	      }
	
	      if (this._closeRequested === true) {
	        throw new TypeError('stream is closed or draining');
	      }
	
	      var state = this._controlledReadableStream._state;
	      if (state !== 'readable') {
	        throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
	      }
	
	      if (!ArrayBuffer.isView(chunk)) {
	        throw new TypeError('You can only enqueue array buffer views when using a ReadableByteStreamController');
	      }
	
	      ReadableByteStreamControllerEnqueue(this, chunk);
	    }
	  }, {
	    key: 'error',
	    value: function error(e) {
	      if (IsReadableByteStreamController(this) === false) {
	        throw byteStreamControllerBrandCheckException('error');
	      }
	
	      var stream = this._controlledReadableStream;
	      if (stream._state !== 'readable') {
	        throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
	      }
	
	      ReadableByteStreamControllerError(this, e);
	    }
	  }, {
	    key: '__cancelSteps',
	    value: function __cancelSteps(reason) {
	      if (this._pendingPullIntos.length > 0) {
	        var firstDescriptor = this._pendingPullIntos[0];
	        firstDescriptor.bytesFilled = 0;
	      }
	
	      ResetQueue(this);
	
	      return PromiseInvokeOrNoop(this._underlyingByteSource, 'cancel', [reason]);
	    }
	  }, {
	    key: '__pullSteps',
	    value: function __pullSteps() {
	      var stream = this._controlledReadableStream;
	      assert(ReadableStreamHasDefaultReader(stream) === true);
	
	      if (this._queueTotalSize > 0) {
	        assert(ReadableStreamGetNumReadRequests(stream) === 0);
	
	        var entry = this._queue.shift();
	        this._queueTotalSize -= entry.byteLength;
	
	        ReadableByteStreamControllerHandleQueueDrain(this);
	
	        var view = void 0;
	        try {
	          view = new Uint8Array(entry.buffer, entry.byteOffset, entry.byteLength);
	        } catch (viewE) {
	          return Promise.reject(viewE);
	        }
	
	        return Promise.resolve(CreateIterResultObject(view, false));
	      }
	
	      var autoAllocateChunkSize = this._autoAllocateChunkSize;
	      if (autoAllocateChunkSize !== undefined) {
	        var buffer = void 0;
	        try {
	          buffer = new ArrayBuffer(autoAllocateChunkSize);
	        } catch (bufferE) {
	          return Promise.reject(bufferE);
	        }
	
	        var pullIntoDescriptor = {
	          buffer: buffer,
	          byteOffset: 0,
	          byteLength: autoAllocateChunkSize,
	          bytesFilled: 0,
	          elementSize: 1,
	          ctor: Uint8Array,
	          readerType: 'default'
	        };
	
	        this._pendingPullIntos.push(pullIntoDescriptor);
	      }
	
	      var promise = ReadableStreamAddReadRequest(stream);
	
	      ReadableByteStreamControllerCallPullIfNeeded(this);
	
	      return promise;
	    }
	  }, {
	    key: 'byobRequest',
	    get: function get() {
	      if (IsReadableByteStreamController(this) === false) {
	        throw byteStreamControllerBrandCheckException('byobRequest');
	      }
	
	      if (this._byobRequest === undefined && this._pendingPullIntos.length > 0) {
	        var firstDescriptor = this._pendingPullIntos[0];
	        var view = new Uint8Array(firstDescriptor.buffer, firstDescriptor.byteOffset + firstDescriptor.bytesFilled, firstDescriptor.byteLength - firstDescriptor.bytesFilled);
	
	        this._byobRequest = new ReadableStreamBYOBRequest(this, view);
	      }
	
	      return this._byobRequest;
	    }
	  }, {
	    key: 'desiredSize',
	    get: function get() {
	      if (IsReadableByteStreamController(this) === false) {
	        throw byteStreamControllerBrandCheckException('desiredSize');
	      }
	
	      return ReadableByteStreamControllerGetDesiredSize(this);
	    }
	  }]);
	
	  return ReadableByteStreamController;
	}();
	
	// Abstract operations for the ReadableByteStreamController.
	
	function IsReadableByteStreamController(x) {
	  if (!typeIsObject(x)) {
	    return false;
	  }
	
	  if (!Object.prototype.hasOwnProperty.call(x, '_underlyingByteSource')) {
	    return false;
	  }
	
	  return true;
	}
	
	function IsReadableStreamBYOBRequest(x) {
	  if (!typeIsObject(x)) {
	    return false;
	  }
	
	  if (!Object.prototype.hasOwnProperty.call(x, '_associatedReadableByteStreamController')) {
	    return false;
	  }
	
	  return true;
	}
	
	function ReadableByteStreamControllerCallPullIfNeeded(controller) {
	  var shouldPull = ReadableByteStreamControllerShouldCallPull(controller);
	  if (shouldPull === false) {
	    return undefined;
	  }
	
	  if (controller._pulling === true) {
	    controller._pullAgain = true;
	    return undefined;
	  }
	
	  assert(controller._pullAgain === false);
	
	  controller._pulling = true;
	
	  // TODO: Test controller argument
	  var pullPromise = PromiseInvokeOrNoop(controller._underlyingByteSource, 'pull', [controller]);
	  pullPromise.then(function () {
	    controller._pulling = false;
	
	    if (controller._pullAgain === true) {
	      controller._pullAgain = false;
	      ReadableByteStreamControllerCallPullIfNeeded(controller);
	    }
	  }, function (e) {
	    if (controller._controlledReadableStream._state === 'readable') {
	      ReadableByteStreamControllerError(controller, e);
	    }
	  }).catch(rethrowAssertionErrorRejection);
	
	  return undefined;
	}
	
	function ReadableByteStreamControllerClearPendingPullIntos(controller) {
	  ReadableByteStreamControllerInvalidateBYOBRequest(controller);
	  controller._pendingPullIntos = [];
	}
	
	function ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor) {
	  assert(stream._state !== 'errored', 'state must not be errored');
	
	  var done = false;
	  if (stream._state === 'closed') {
	    assert(pullIntoDescriptor.bytesFilled === 0);
	    done = true;
	  }
	
	  var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
	  if (pullIntoDescriptor.readerType === 'default') {
	    ReadableStreamFulfillReadRequest(stream, filledView, done);
	  } else {
	    assert(pullIntoDescriptor.readerType === 'byob');
	    ReadableStreamFulfillReadIntoRequest(stream, filledView, done);
	  }
	}
	
	function ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor) {
	  var bytesFilled = pullIntoDescriptor.bytesFilled;
	  var elementSize = pullIntoDescriptor.elementSize;
	
	  assert(bytesFilled <= pullIntoDescriptor.byteLength);
	  assert(bytesFilled % elementSize === 0);
	
	  return new pullIntoDescriptor.ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, bytesFilled / elementSize);
	}
	
	function ReadableByteStreamControllerEnqueueChunkToQueue(controller, buffer, byteOffset, byteLength) {
	  controller._queue.push({ buffer: buffer, byteOffset: byteOffset, byteLength: byteLength });
	  controller._queueTotalSize += byteLength;
	}
	
	function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) {
	  var elementSize = pullIntoDescriptor.elementSize;
	
	  var currentAlignedBytes = pullIntoDescriptor.bytesFilled - pullIntoDescriptor.bytesFilled % elementSize;
	
	  var maxBytesToCopy = Math.min(controller._queueTotalSize, pullIntoDescriptor.byteLength - pullIntoDescriptor.bytesFilled);
	  var maxBytesFilled = pullIntoDescriptor.bytesFilled + maxBytesToCopy;
	  var maxAlignedBytes = maxBytesFilled - maxBytesFilled % elementSize;
	
	  var totalBytesToCopyRemaining = maxBytesToCopy;
	  var ready = false;
	  if (maxAlignedBytes > currentAlignedBytes) {
	    totalBytesToCopyRemaining = maxAlignedBytes - pullIntoDescriptor.bytesFilled;
	    ready = true;
	  }
	
	  var queue = controller._queue;
	
	  while (totalBytesToCopyRemaining > 0) {
	    var headOfQueue = queue[0];
	
	    var bytesToCopy = Math.min(totalBytesToCopyRemaining, headOfQueue.byteLength);
	
	    var destStart = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
	    ArrayBufferCopy(pullIntoDescriptor.buffer, destStart, headOfQueue.buffer, headOfQueue.byteOffset, bytesToCopy);
	
	    if (headOfQueue.byteLength === bytesToCopy) {
	      queue.shift();
	    } else {
	      headOfQueue.byteOffset += bytesToCopy;
	      headOfQueue.byteLength -= bytesToCopy;
	    }
	    controller._queueTotalSize -= bytesToCopy;
	
	    ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesToCopy, pullIntoDescriptor);
	
	    totalBytesToCopyRemaining -= bytesToCopy;
	  }
	
	  if (ready === false) {
	    assert(controller._queueTotalSize === 0, 'queue must be empty');
	    assert(pullIntoDescriptor.bytesFilled > 0);
	    assert(pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize);
	  }
	
	  return ready;
	}
	
	function ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, size, pullIntoDescriptor) {
	  assert(controller._pendingPullIntos.length === 0 || controller._pendingPullIntos[0] === pullIntoDescriptor);
	
	  ReadableByteStreamControllerInvalidateBYOBRequest(controller);
	  pullIntoDescriptor.bytesFilled += size;
	}
	
	function ReadableByteStreamControllerHandleQueueDrain(controller) {
	  assert(controller._controlledReadableStream._state === 'readable');
	
	  if (controller._queueTotalSize === 0 && controller._closeRequested === true) {
	    ReadableStreamClose(controller._controlledReadableStream);
	  } else {
	    ReadableByteStreamControllerCallPullIfNeeded(controller);
	  }
	}
	
	function ReadableByteStreamControllerInvalidateBYOBRequest(controller) {
	  if (controller._byobRequest === undefined) {
	    return;
	  }
	
	  controller._byobRequest._associatedReadableByteStreamController = undefined;
	  controller._byobRequest._view = undefined;
	  controller._byobRequest = undefined;
	}
	
	function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller) {
	  assert(controller._closeRequested === false);
	
	  while (controller._pendingPullIntos.length > 0) {
	    if (controller._queueTotalSize === 0) {
	      return;
	    }
	
	    var pullIntoDescriptor = controller._pendingPullIntos[0];
	
	    if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
	      ReadableByteStreamControllerShiftPendingPullInto(controller);
	
	      ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
	    }
	  }
	}
	
	function ReadableByteStreamControllerPullInto(controller, view) {
	  var stream = controller._controlledReadableStream;
	
	  var elementSize = 1;
	  if (view.constructor !== DataView) {
	    elementSize = view.constructor.BYTES_PER_ELEMENT;
	  }
	
	  var ctor = view.constructor;
	
	  var pullIntoDescriptor = {
	    buffer: view.buffer,
	    byteOffset: view.byteOffset,
	    byteLength: view.byteLength,
	    bytesFilled: 0,
	    elementSize: elementSize,
	    ctor: ctor,
	    readerType: 'byob'
	  };
	
	  if (controller._pendingPullIntos.length > 0) {
	    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
	    controller._pendingPullIntos.push(pullIntoDescriptor);
	
	    // No ReadableByteStreamControllerCallPullIfNeeded() call since:
	    // - No change happens on desiredSize
	    // - The source has already been notified of that there's at least 1 pending read(view)
	
	    return ReadableStreamAddReadIntoRequest(stream);
	  }
	
	  if (stream._state === 'closed') {
	    var emptyView = new view.constructor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, 0);
	    return Promise.resolve(CreateIterResultObject(emptyView, true));
	  }
	
	  if (controller._queueTotalSize > 0) {
	    if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
	      var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
	
	      ReadableByteStreamControllerHandleQueueDrain(controller);
	
	      return Promise.resolve(CreateIterResultObject(filledView, false));
	    }
	
	    if (controller._closeRequested === true) {
	      var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
	      ReadableByteStreamControllerError(controller, e);
	
	      return Promise.reject(e);
	    }
	  }
	
	  pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
	  controller._pendingPullIntos.push(pullIntoDescriptor);
	
	  var promise = ReadableStreamAddReadIntoRequest(stream);
	
	  ReadableByteStreamControllerCallPullIfNeeded(controller);
	
	  return promise;
	}
	
	function ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor) {
	  firstDescriptor.buffer = TransferArrayBuffer(firstDescriptor.buffer);
	
	  assert(firstDescriptor.bytesFilled === 0, 'bytesFilled must be 0');
	
	  var stream = controller._controlledReadableStream;
	  if (ReadableStreamHasBYOBReader(stream) === true) {
	    while (ReadableStreamGetNumReadIntoRequests(stream) > 0) {
	      var pullIntoDescriptor = ReadableByteStreamControllerShiftPendingPullInto(controller);
	      ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor);
	    }
	  }
	}
	
	function ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, pullIntoDescriptor) {
	  if (pullIntoDescriptor.bytesFilled + bytesWritten > pullIntoDescriptor.byteLength) {
	    throw new RangeError('bytesWritten out of range');
	  }
	
	  ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesWritten, pullIntoDescriptor);
	
	  if (pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize) {
	    // TODO: Figure out whether we should detach the buffer or not here.
	    return;
	  }
	
	  ReadableByteStreamControllerShiftPendingPullInto(controller);
	
	  var remainderSize = pullIntoDescriptor.bytesFilled % pullIntoDescriptor.elementSize;
	  if (remainderSize > 0) {
	    var end = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
	    var remainder = pullIntoDescriptor.buffer.slice(end - remainderSize, end);
	    ReadableByteStreamControllerEnqueueChunkToQueue(controller, remainder, 0, remainder.byteLength);
	  }
	
	  pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
	  pullIntoDescriptor.bytesFilled -= remainderSize;
	  ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
	
	  ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
	}
	
	function ReadableByteStreamControllerRespondInternal(controller, bytesWritten) {
	  var firstDescriptor = controller._pendingPullIntos[0];
	
	  var stream = controller._controlledReadableStream;
	
	  if (stream._state === 'closed') {
	    if (bytesWritten !== 0) {
	      throw new TypeError('bytesWritten must be 0 when calling respond() on a closed stream');
	    }
	
	    ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor);
	  } else {
	    assert(stream._state === 'readable');
	
	    ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, firstDescriptor);
	  }
	}
	
	function ReadableByteStreamControllerShiftPendingPullInto(controller) {
	  var descriptor = controller._pendingPullIntos.shift();
	  ReadableByteStreamControllerInvalidateBYOBRequest(controller);
	  return descriptor;
	}
	
	function ReadableByteStreamControllerShouldCallPull(controller) {
	  var stream = controller._controlledReadableStream;
	
	  if (stream._state !== 'readable') {
	    return false;
	  }
	
	  if (controller._closeRequested === true) {
	    return false;
	  }
	
	  if (controller._started === false) {
	    return false;
	  }
	
	  if (ReadableStreamHasDefaultReader(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
	    return true;
	  }
	
	  if (ReadableStreamHasBYOBReader(stream) === true && ReadableStreamGetNumReadIntoRequests(stream) > 0) {
	    return true;
	  }
	
	  if (ReadableByteStreamControllerGetDesiredSize(controller) > 0) {
	    return true;
	  }
	
	  return false;
	}
	
	// A client of ReadableByteStreamController may use these functions directly to bypass state check.
	
	function ReadableByteStreamControllerClose(controller) {
	  var stream = controller._controlledReadableStream;
	
	  assert(controller._closeRequested === false);
	  assert(stream._state === 'readable');
	
	  if (controller._queueTotalSize > 0) {
	    controller._closeRequested = true;
	
	    return;
	  }
	
	  if (controller._pendingPullIntos.length > 0) {
	    var firstPendingPullInto = controller._pendingPullIntos[0];
	    if (firstPendingPullInto.bytesFilled > 0) {
	      var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
	      ReadableByteStreamControllerError(controller, e);
	
	      throw e;
	    }
	  }
	
	  ReadableStreamClose(stream);
	}
	
	function ReadableByteStreamControllerEnqueue(controller, chunk) {
	  var stream = controller._controlledReadableStream;
	
	  assert(controller._closeRequested === false);
	  assert(stream._state === 'readable');
	
	  var buffer = chunk.buffer;
	  var byteOffset = chunk.byteOffset;
	  var byteLength = chunk.byteLength;
	  var transferredBuffer = TransferArrayBuffer(buffer);
	
	  if (ReadableStreamHasDefaultReader(stream) === true) {
	    if (ReadableStreamGetNumReadRequests(stream) === 0) {
	      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
	    } else {
	      assert(controller._queue.length === 0);
	
	      var transferredView = new Uint8Array(transferredBuffer, byteOffset, byteLength);
	      ReadableStreamFulfillReadRequest(stream, transferredView, false);
	    }
	  } else if (ReadableStreamHasBYOBReader(stream) === true) {
	    // TODO: Ideally in this branch detaching should happen only if the buffer is not consumed fully.
	    ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
	    ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
	  } else {
	    assert(IsReadableStreamLocked(stream) === false, 'stream must not be locked');
	    ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
	  }
	}
	
	function ReadableByteStreamControllerError(controller, e) {
	  var stream = controller._controlledReadableStream;
	
	  assert(stream._state === 'readable');
	
	  ReadableByteStreamControllerClearPendingPullIntos(controller);
	
	  ResetQueue(controller);
	  ReadableStreamError(stream, e);
	}
	
	function ReadableByteStreamControllerGetDesiredSize(controller) {
	  var stream = controller._controlledReadableStream;
	  var state = stream._state;
	
	  if (state === 'errored') {
	    return null;
	  }
	  if (state === 'closed') {
	    return 0;
	  }
	
	  return controller._strategyHWM - controller._queueTotalSize;
	}
	
	function ReadableByteStreamControllerRespond(controller, bytesWritten) {
	  bytesWritten = Number(bytesWritten);
	  if (IsFiniteNonNegativeNumber(bytesWritten) === false) {
	    throw new RangeError('bytesWritten must be a finite');
	  }
	
	  assert(controller._pendingPullIntos.length > 0);
	
	  ReadableByteStreamControllerRespondInternal(controller, bytesWritten);
	}
	
	function ReadableByteStreamControllerRespondWithNewView(controller, view) {
	  assert(controller._pendingPullIntos.length > 0);
	
	  var firstDescriptor = controller._pendingPullIntos[0];
	
	  if (firstDescriptor.byteOffset + firstDescriptor.bytesFilled !== view.byteOffset) {
	    throw new RangeError('The region specified by view does not match byobRequest');
	  }
	  if (firstDescriptor.byteLength !== view.byteLength) {
	    throw new RangeError('The buffer of view has different capacity than byobRequest');
	  }
	
	  firstDescriptor.buffer = view.buffer;
	
	  ReadableByteStreamControllerRespondInternal(controller, view.byteLength);
	}
	
	// Helper functions for the ReadableStream.
	
	function streamBrandCheckException(name) {
	  return new TypeError('ReadableStream.prototype.' + name + ' can only be used on a ReadableStream');
	}
	
	// Helper functions for the readers.
	
	function readerLockException(name) {
	  return new TypeError('Cannot ' + name + ' a stream using a released reader');
	}
	
	// Helper functions for the ReadableStreamDefaultReader.
	
	function defaultReaderBrandCheckException(name) {
	  return new TypeError('ReadableStreamDefaultReader.prototype.' + name + ' can only be used on a ReadableStreamDefaultReader');
	}
	
	function defaultReaderClosedPromiseInitialize(reader) {
	  reader._closedPromise = new Promise(function (resolve, reject) {
	    reader._closedPromise_resolve = resolve;
	    reader._closedPromise_reject = reject;
	  });
	}
	
	function defaultReaderClosedPromiseInitializeAsRejected(reader, reason) {
	  reader._closedPromise = Promise.reject(reason);
	  reader._closedPromise_resolve = undefined;
	  reader._closedPromise_reject = undefined;
	}
	
	function defaultReaderClosedPromiseInitializeAsResolved(reader) {
	  reader._closedPromise = Promise.resolve(undefined);
	  reader._closedPromise_resolve = undefined;
	  reader._closedPromise_reject = undefined;
	}
	
	function defaultReaderClosedPromiseReject(reader, reason) {
	  assert(reader._closedPromise_resolve !== undefined);
	  assert(reader._closedPromise_reject !== undefined);
	
	  reader._closedPromise_reject(reason);
	  reader._closedPromise_resolve = undefined;
	  reader._closedPromise_reject = undefined;
	}
	
	function defaultReaderClosedPromiseResetToRejected(reader, reason) {
	  assert(reader._closedPromise_resolve === undefined);
	  assert(reader._closedPromise_reject === undefined);
	
	  reader._closedPromise = Promise.reject(reason);
	}
	
	function defaultReaderClosedPromiseResolve(reader) {
	  assert(reader._closedPromise_resolve !== undefined);
	  assert(reader._closedPromise_reject !== undefined);
	
	  reader._closedPromise_resolve(undefined);
	  reader._closedPromise_resolve = undefined;
	  reader._closedPromise_reject = undefined;
	}
	
	// Helper functions for the ReadableStreamDefaultReader.
	
	function byobReaderBrandCheckException(name) {
	  return new TypeError('ReadableStreamBYOBReader.prototype.' + name + ' can only be used on a ReadableStreamBYOBReader');
	}
	
	// Helper functions for the ReadableStreamDefaultController.
	
	function defaultControllerBrandCheckException(name) {
	  return new TypeError('ReadableStreamDefaultController.prototype.' + name + ' can only be used on a ReadableStreamDefaultController');
	}
	
	// Helper functions for the ReadableStreamBYOBRequest.
	
	function byobRequestBrandCheckException(name) {
	  return new TypeError('ReadableStreamBYOBRequest.prototype.' + name + ' can only be used on a ReadableStreamBYOBRequest');
	}
	
	// Helper functions for the ReadableByteStreamController.
	
	function byteStreamControllerBrandCheckException(name) {
	  return new TypeError('ReadableByteStreamController.prototype.' + name + ' can only be used on a ReadableByteStreamController');
	}
	
	// Helper function for ReadableStream pipeThrough
	
	function ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise) {
	  try {
	    // This relies on the brand-check that is enforced by Promise.prototype.then(). As with the rest of the reference
	    // implementation, it doesn't attempt to do the right thing if someone has modified the global environment.
	    Promise.prototype.then.call(promise, undefined, function () {});
	  } catch (e) {
	    // The brand check failed, therefore the internal slot is not present and there's nothing further to do.
	  }
	}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var transformStream = __webpack_require__(6);
	var readableStream = __webpack_require__(4);
	var writableStream = __webpack_require__(2);
	
	exports.TransformStream = transformStream.TransformStream;
	exports.ReadableStream = readableStream.ReadableStream;
	exports.IsReadableStreamDisturbed = readableStream.IsReadableStreamDisturbed;
	exports.ReadableStreamDefaultControllerClose = readableStream.ReadableStreamDefaultControllerClose;
	exports.ReadableStreamDefaultControllerEnqueue = readableStream.ReadableStreamDefaultControllerEnqueue;
	exports.ReadableStreamDefaultControllerError = readableStream.ReadableStreamDefaultControllerError;
	exports.ReadableStreamDefaultControllerGetDesiredSize = readableStream.ReadableStreamDefaultControllerGetDesiredSize;
	exports.AcquireWritableStreamDefaultWriter = writableStream.AcquireWritableStreamDefaultWriter;
	exports.IsWritableStream = writableStream.IsWritableStream;
	exports.IsWritableStreamLocked = writableStream.IsWritableStreamLocked;
	exports.WritableStream = writableStream.WritableStream;
	exports.WritableStreamAbort = writableStream.WritableStreamAbort;
	exports.WritableStreamDefaultControllerError = writableStream.WritableStreamDefaultControllerError;
	exports.WritableStreamDefaultWriterCloseWithErrorPropagation = writableStream.WritableStreamDefaultWriterCloseWithErrorPropagation;
	exports.WritableStreamDefaultWriterRelease = writableStream.WritableStreamDefaultWriterRelease;
	exports.WritableStreamDefaultWriterWrite = writableStream.WritableStreamDefaultWriterWrite;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _require = __webpack_require__(1),
	    assert = _require.assert;
	
	var _require2 = __webpack_require__(0),
	    InvokeOrNoop = _require2.InvokeOrNoop,
	    PromiseInvokeOrPerformFallback = _require2.PromiseInvokeOrPerformFallback,
	    PromiseInvokeOrNoop = _require2.PromiseInvokeOrNoop,
	    typeIsObject = _require2.typeIsObject;
	
	var _require3 = __webpack_require__(4),
	    ReadableStream = _require3.ReadableStream,
	    ReadableStreamDefaultControllerClose = _require3.ReadableStreamDefaultControllerClose,
	    ReadableStreamDefaultControllerEnqueue = _require3.ReadableStreamDefaultControllerEnqueue,
	    ReadableStreamDefaultControllerError = _require3.ReadableStreamDefaultControllerError,
	    ReadableStreamDefaultControllerGetDesiredSize = _require3.ReadableStreamDefaultControllerGetDesiredSize;
	
	var _require4 = __webpack_require__(2),
	    WritableStream = _require4.WritableStream,
	    WritableStreamDefaultControllerError = _require4.WritableStreamDefaultControllerError;
	
	// Methods on the transform stream controller object
	
	function TransformStreamCloseReadable(transformStream) {
	  // console.log('TransformStreamCloseReadable()');
	
	  if (transformStream._errored === true) {
	    throw new TypeError('TransformStream is already errored');
	  }
	
	  if (transformStream._readableClosed === true) {
	    throw new TypeError('Readable side is already closed');
	  }
	
	  TransformStreamCloseReadableInternal(transformStream);
	}
	
	function TransformStreamEnqueueToReadable(transformStream, chunk) {
	  // console.log('TransformStreamEnqueueToReadable()');
	
	  if (transformStream._errored === true) {
	    throw new TypeError('TransformStream is already errored');
	  }
	
	  if (transformStream._readableClosed === true) {
	    throw new TypeError('Readable side is already closed');
	  }
	
	  // We throttle transformer.transform invocation based on the backpressure of the ReadableStream, but we still
	  // accept TransformStreamEnqueueToReadable() calls.
	
	  var controller = transformStream._readableController;
	
	  try {
	    ReadableStreamDefaultControllerEnqueue(controller, chunk);
	  } catch (e) {
	    // This happens when readableStrategy.size() throws.
	    // The ReadableStream has already errored itself.
	    transformStream._readableClosed = true;
	    TransformStreamErrorIfNeeded(transformStream, e);
	
	    throw transformStream._storedError;
	  }
	
	  var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
	  var maybeBackpressure = desiredSize <= 0;
	
	  if (maybeBackpressure === true && transformStream._backpressure === false) {
	    // This allows pull() again. When desiredSize is 0, it's possible that a pull() will happen immediately (but
	    // asynchronously) after this because of pending read()s and set _backpressure back to false.
	    //
	    // If pull() could be called from inside enqueue(), then this logic would be wrong. This cannot happen
	    // because there is always a promise pending from start() or pull() when _backpressure is false.
	    TransformStreamSetBackpressure(transformStream, true);
	  }
	}
	
	function TransformStreamError(transformStream, e) {
	  if (transformStream._errored === true) {
	    throw new TypeError('TransformStream is already errored');
	  }
	
	  TransformStreamErrorInternal(transformStream, e);
	}
	
	// Abstract operations.
	
	function TransformStreamCloseReadableInternal(transformStream) {
	  assert(transformStream._errored === false);
	  assert(transformStream._readableClosed === false);
	
	  try {
	    ReadableStreamDefaultControllerClose(transformStream._readableController);
	  } catch (e) {
	    assert(false);
	  }
	
	  transformStream._readableClosed = true;
	}
	
	function TransformStreamErrorIfNeeded(transformStream, e) {
	  if (transformStream._errored === false) {
	    TransformStreamErrorInternal(transformStream, e);
	  }
	}
	
	function TransformStreamErrorInternal(transformStream, e) {
	  // console.log('TransformStreamErrorInternal()');
	
	  assert(transformStream._errored === false);
	
	  transformStream._errored = true;
	  transformStream._storedError = e;
	
	  if (transformStream._writableDone === false) {
	    WritableStreamDefaultControllerError(transformStream._writableController, e);
	  }
	  if (transformStream._readableClosed === false) {
	    ReadableStreamDefaultControllerError(transformStream._readableController, e);
	  }
	}
	
	// Used for preventing the next write() call on TransformStreamSink until there
	// is no longer backpressure.
	function TransformStreamReadableReadyPromise(transformStream) {
	  assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
	
	  if (transformStream._backpressure === false) {
	    return Promise.resolve();
	  }
	
	  assert(transformStream._backpressure === true, '_backpressure should have been initialized');
	
	  return transformStream._backpressureChangePromise;
	}
	
	function TransformStreamSetBackpressure(transformStream, backpressure) {
	  // console.log(`TransformStreamSetBackpressure(${backpressure})`);
	
	  // Passes also when called during construction.
	  assert(transformStream._backpressure !== backpressure, 'TransformStreamSetBackpressure() should be called only when backpressure is changed');
	
	  if (transformStream._backpressureChangePromise !== undefined) {
	    // The fulfillment value is just for a sanity check.
	    transformStream._backpressureChangePromise_resolve(backpressure);
	  }
	
	  transformStream._backpressureChangePromise = new Promise(function (resolve) {
	    transformStream._backpressureChangePromise_resolve = resolve;
	  });
	
	  transformStream._backpressureChangePromise.then(function (resolution) {
	    assert(resolution !== backpressure, '_backpressureChangePromise should be fulfilled only when backpressure is changed');
	  });
	
	  transformStream._backpressure = backpressure;
	}
	
	function TransformStreamDefaultTransform(chunk, transformStreamController) {
	  var transformStream = transformStreamController._controlledTransformStream;
	  TransformStreamEnqueueToReadable(transformStream, chunk);
	  return Promise.resolve();
	}
	
	function TransformStreamTransform(transformStream, chunk) {
	  // console.log('TransformStreamTransform()');
	
	  assert(transformStream._errored === false);
	  assert(transformStream._transforming === false);
	  assert(transformStream._backpressure === false);
	
	  transformStream._transforming = true;
	
	  var transformer = transformStream._transformer;
	  var controller = transformStream._transformStreamController;
	
	  var transformPromise = PromiseInvokeOrPerformFallback(transformer, 'transform', [chunk, controller], TransformStreamDefaultTransform, [chunk, controller]);
	
	  return transformPromise.then(function () {
	    transformStream._transforming = false;
	
	    return TransformStreamReadableReadyPromise(transformStream);
	  }, function (e) {
	    TransformStreamErrorIfNeeded(transformStream, e);
	    return Promise.reject(e);
	  });
	}
	
	function IsTransformStreamDefaultController(x) {
	  if (!typeIsObject(x)) {
	    return false;
	  }
	
	  if (!Object.prototype.hasOwnProperty.call(x, '_controlledTransformStream')) {
	    return false;
	  }
	
	  return true;
	}
	
	function IsTransformStream(x) {
	  if (!typeIsObject(x)) {
	    return false;
	  }
	
	  if (!Object.prototype.hasOwnProperty.call(x, '_transformStreamController')) {
	    return false;
	  }
	
	  return true;
	}
	
	var TransformStreamSink = function () {
	  function TransformStreamSink(transformStream, startPromise) {
	    _classCallCheck(this, TransformStreamSink);
	
	    this._transformStream = transformStream;
	    this._startPromise = startPromise;
	  }
	
	  _createClass(TransformStreamSink, [{
	    key: 'start',
	    value: function start(c) {
	      var transformStream = this._transformStream;
	
	      transformStream._writableController = c;
	
	      return this._startPromise.then(function () {
	        return TransformStreamReadableReadyPromise(transformStream);
	      });
	    }
	  }, {
	    key: 'write',
	    value: function write(chunk) {
	      // console.log('TransformStreamSink.write()');
	
	      var transformStream = this._transformStream;
	
	      return TransformStreamTransform(transformStream, chunk);
	    }
	  }, {
	    key: 'abort',
	    value: function abort() {
	      var transformStream = this._transformStream;
	      transformStream._writableDone = true;
	      TransformStreamErrorInternal(transformStream, new TypeError('Writable side aborted'));
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      // console.log('TransformStreamSink.close()');
	
	      var transformStream = this._transformStream;
	
	      assert(transformStream._transforming === false);
	
	      transformStream._writableDone = true;
	
	      var flushPromise = PromiseInvokeOrNoop(transformStream._transformer, 'flush', [transformStream._transformStreamController]);
	      // Return a promise that is fulfilled with undefined on success.
	      return flushPromise.then(function () {
	        if (transformStream._errored === true) {
	          return Promise.reject(transformStream._storedError);
	        }
	        if (transformStream._readableClosed === false) {
	          TransformStreamCloseReadableInternal(transformStream);
	        }
	        return Promise.resolve();
	      }).catch(function (r) {
	        TransformStreamErrorIfNeeded(transformStream, r);
	        return Promise.reject(transformStream._storedError);
	      });
	    }
	  }]);
	
	  return TransformStreamSink;
	}();
	
	var TransformStreamSource = function () {
	  function TransformStreamSource(transformStream, startPromise) {
	    _classCallCheck(this, TransformStreamSource);
	
	    this._transformStream = transformStream;
	    this._startPromise = startPromise;
	  }
	
	  _createClass(TransformStreamSource, [{
	    key: 'start',
	    value: function start(c) {
	      var transformStream = this._transformStream;
	
	      transformStream._readableController = c;
	
	      return this._startPromise.then(function () {
	        // Prevent the first pull() call until there is backpressure.
	
	        assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
	
	        if (transformStream._backpressure === true) {
	          return Promise.resolve();
	        }
	
	        assert(transformStream._backpressure === false, '_backpressure should have been initialized');
	
	        return transformStream._backpressureChangePromise;
	      });
	    }
	  }, {
	    key: 'pull',
	    value: function pull() {
	      // console.log('TransformStreamSource.pull()');
	
	      var transformStream = this._transformStream;
	
	      // Invariant. Enforced by the promises returned by start() and pull().
	      assert(transformStream._backpressure === true, 'pull() should be never called while _backpressure is false');
	
	      assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
	
	      TransformStreamSetBackpressure(transformStream, false);
	
	      // Prevent the next pull() call until there is backpressure.
	      return transformStream._backpressureChangePromise;
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      var transformStream = this._transformStream;
	      transformStream._readableClosed = true;
	      TransformStreamErrorInternal(transformStream, new TypeError('Readable side canceled'));
	    }
	  }]);
	
	  return TransformStreamSource;
	}();
	
	var TransformStreamDefaultController = function () {
	  function TransformStreamDefaultController(transformStream) {
	    _classCallCheck(this, TransformStreamDefaultController);
	
	    if (IsTransformStream(transformStream) === false) {
	      throw new TypeError('TransformStreamDefaultController can only be ' + 'constructed with a TransformStream instance');
	    }
	
	    if (transformStream._transformStreamController !== undefined) {
	      throw new TypeError('TransformStreamDefaultController instances can ' + 'only be created by the TransformStream constructor');
	    }
	
	    this._controlledTransformStream = transformStream;
	  }
	
	  _createClass(TransformStreamDefaultController, [{
	    key: 'enqueue',
	    value: function enqueue(chunk) {
	      if (IsTransformStreamDefaultController(this) === false) {
	        throw defaultControllerBrandCheckException('enqueue');
	      }
	
	      TransformStreamEnqueueToReadable(this._controlledTransformStream, chunk);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      if (IsTransformStreamDefaultController(this) === false) {
	        throw defaultControllerBrandCheckException('close');
	      }
	
	      TransformStreamCloseReadable(this._controlledTransformStream);
	    }
	  }, {
	    key: 'error',
	    value: function error(reason) {
	      if (IsTransformStreamDefaultController(this) === false) {
	        throw defaultControllerBrandCheckException('error');
	      }
	
	      TransformStreamError(this._controlledTransformStream, reason);
	    }
	  }, {
	    key: 'desiredSize',
	    get: function get() {
	      if (IsTransformStreamDefaultController(this) === false) {
	        throw defaultControllerBrandCheckException('desiredSize');
	      }
	
	      var transformStream = this._controlledTransformStream;
	      var readableController = transformStream._readableController;
	
	      return ReadableStreamDefaultControllerGetDesiredSize(readableController);
	    }
	  }]);
	
	  return TransformStreamDefaultController;
	}();
	
	var TransformStream = function () {
	  function TransformStream() {
	    var transformer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, TransformStream);
	
	    this._transformer = transformer;
	    var readableStrategy = transformer.readableStrategy,
	        writableStrategy = transformer.writableStrategy;
	
	
	    this._transforming = false;
	    this._errored = false;
	    this._storedError = undefined;
	
	    this._writableController = undefined;
	    this._readableController = undefined;
	    this._transformStreamController = undefined;
	
	    this._writableDone = false;
	    this._readableClosed = false;
	
	    this._backpressure = undefined;
	    this._backpressureChangePromise = undefined;
	    this._backpressureChangePromise_resolve = undefined;
	
	    this._transformStreamController = new TransformStreamDefaultController(this);
	
	    var startPromise_resolve = void 0;
	    var startPromise = new Promise(function (resolve) {
	      startPromise_resolve = resolve;
	    });
	
	    var source = new TransformStreamSource(this, startPromise);
	
	    this._readable = new ReadableStream(source, readableStrategy);
	
	    var sink = new TransformStreamSink(this, startPromise);
	
	    this._writable = new WritableStream(sink, writableStrategy);
	
	    assert(this._writableController !== undefined);
	    assert(this._readableController !== undefined);
	
	    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(this._readableController);
	    // Set _backpressure based on desiredSize. As there is no read() at this point, we can just interpret
	    // desiredSize being non-positive as backpressure.
	    TransformStreamSetBackpressure(this, desiredSize <= 0);
	
	    var transformStream = this;
	    var startResult = InvokeOrNoop(transformer, 'start', [transformStream._transformStreamController]);
	    startPromise_resolve(startResult);
	    startPromise.catch(function (e) {
	      // The underlyingSink and underlyingSource will error the readable and writable ends on their own.
	      if (transformStream._errored === false) {
	        transformStream._errored = true;
	        transformStream._storedError = e;
	      }
	    });
	  }
	
	  _createClass(TransformStream, [{
	    key: 'readable',
	    get: function get() {
	      if (IsTransformStream(this) === false) {
	        throw streamBrandCheckException('readable');
	      }
	
	      return this._readable;
	    }
	  }, {
	    key: 'writable',
	    get: function get() {
	      if (IsTransformStream(this) === false) {
	        throw streamBrandCheckException('writable');
	      }
	
	      return this._writable;
	    }
	  }]);
	
	  return TransformStream;
	}();
	
	module.exports = { TransformStream: TransformStream };
	
	// Helper functions for the TransformStreamDefaultController.
	
	function defaultControllerBrandCheckException(name) {
	  return new TypeError('TransformStreamDefaultController.prototype.' + name + ' can only be used on a TransformStreamDefaultController');
	}
	
	// Helper functions for the TransformStream.
	
	function streamBrandCheckException(name) {
	  return new TypeError('TransformStream.prototype.' + name + ' can only be used on a TransformStream');
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(5);
	
	
	/***/ })
	/******/ ])));

/***/ },
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CanvasGraphics = undefined;
	
	var _util = __webpack_require__(14);
	
	var _pattern_helper = __webpack_require__(1711);
	
	var MIN_FONT_SIZE = 16;
	var MAX_FONT_SIZE = 100;
	var MAX_GROUP_SIZE = 4096;
	var MIN_WIDTH_FACTOR = 0.65;
	var COMPILE_TYPE3_GLYPHS = true;
	var MAX_SIZE_TO_COMPILE = 1000;
	var FULL_CHUNK_HEIGHT = 16;
	var IsLittleEndianCached = {
	  get value() {
	    return (0, _util.shadow)(IsLittleEndianCached, 'value', (0, _util.isLittleEndian)());
	  }
	};
	function addContextCurrentTransform(ctx) {
	  if (!ctx.mozCurrentTransform) {
	    ctx._originalSave = ctx.save;
	    ctx._originalRestore = ctx.restore;
	    ctx._originalRotate = ctx.rotate;
	    ctx._originalScale = ctx.scale;
	    ctx._originalTranslate = ctx.translate;
	    ctx._originalTransform = ctx.transform;
	    ctx._originalSetTransform = ctx.setTransform;
	    ctx._transformMatrix = ctx._transformMatrix || [1, 0, 0, 1, 0, 0];
	    ctx._transformStack = [];
	    Object.defineProperty(ctx, 'mozCurrentTransform', {
	      get: function getCurrentTransform() {
	        return this._transformMatrix;
	      }
	    });
	    Object.defineProperty(ctx, 'mozCurrentTransformInverse', {
	      get: function getCurrentTransformInverse() {
	        var m = this._transformMatrix;
	        var a = m[0],
	            b = m[1],
	            c = m[2],
	            d = m[3],
	            e = m[4],
	            f = m[5];
	        var ad_bc = a * d - b * c;
	        var bc_ad = b * c - a * d;
	        return [d / ad_bc, b / bc_ad, c / bc_ad, a / ad_bc, (d * e - c * f) / bc_ad, (b * e - a * f) / ad_bc];
	      }
	    });
	    ctx.save = function ctxSave() {
	      var old = this._transformMatrix;
	      this._transformStack.push(old);
	      this._transformMatrix = old.slice(0, 6);
	      this._originalSave();
	    };
	    ctx.restore = function ctxRestore() {
	      var prev = this._transformStack.pop();
	      if (prev) {
	        this._transformMatrix = prev;
	        this._originalRestore();
	      }
	    };
	    ctx.translate = function ctxTranslate(x, y) {
	      var m = this._transformMatrix;
	      m[4] = m[0] * x + m[2] * y + m[4];
	      m[5] = m[1] * x + m[3] * y + m[5];
	      this._originalTranslate(x, y);
	    };
	    ctx.scale = function ctxScale(x, y) {
	      var m = this._transformMatrix;
	      m[0] = m[0] * x;
	      m[1] = m[1] * x;
	      m[2] = m[2] * y;
	      m[3] = m[3] * y;
	      this._originalScale(x, y);
	    };
	    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
	      var m = this._transformMatrix;
	      this._transformMatrix = [m[0] * a + m[2] * b, m[1] * a + m[3] * b, m[0] * c + m[2] * d, m[1] * c + m[3] * d, m[0] * e + m[2] * f + m[4], m[1] * e + m[3] * f + m[5]];
	      ctx._originalTransform(a, b, c, d, e, f);
	    };
	    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
	      this._transformMatrix = [a, b, c, d, e, f];
	      ctx._originalSetTransform(a, b, c, d, e, f);
	    };
	    ctx.rotate = function ctxRotate(angle) {
	      var cosValue = Math.cos(angle);
	      var sinValue = Math.sin(angle);
	      var m = this._transformMatrix;
	      this._transformMatrix = [m[0] * cosValue + m[2] * sinValue, m[1] * cosValue + m[3] * sinValue, m[0] * -sinValue + m[2] * cosValue, m[1] * -sinValue + m[3] * cosValue, m[4], m[5]];
	      this._originalRotate(angle);
	    };
	  }
	}
	var CachedCanvases = function CachedCanvasesClosure() {
	  function CachedCanvases(canvasFactory) {
	    this.canvasFactory = canvasFactory;
	    this.cache = Object.create(null);
	  }
	  CachedCanvases.prototype = {
	    getCanvas: function CachedCanvases_getCanvas(id, width, height, trackTransform) {
	      var canvasEntry;
	      if (this.cache[id] !== undefined) {
	        canvasEntry = this.cache[id];
	        this.canvasFactory.reset(canvasEntry, width, height);
	        canvasEntry.context.setTransform(1, 0, 0, 1, 0, 0);
	      } else {
	        canvasEntry = this.canvasFactory.create(width, height);
	        this.cache[id] = canvasEntry;
	      }
	      if (trackTransform) {
	        addContextCurrentTransform(canvasEntry.context);
	      }
	      return canvasEntry;
	    },
	    clear: function clear() {
	      for (var id in this.cache) {
	        var canvasEntry = this.cache[id];
	        this.canvasFactory.destroy(canvasEntry);
	        delete this.cache[id];
	      }
	    }
	  };
	  return CachedCanvases;
	}();
	function compileType3Glyph(imgData) {
	  var POINT_TO_PROCESS_LIMIT = 1000;
	  var width = imgData.width,
	      height = imgData.height;
	  var i,
	      j,
	      j0,
	      width1 = width + 1;
	  var points = new Uint8Array(width1 * (height + 1));
	  var POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
	  var lineSize = width + 7 & ~7,
	      data0 = imgData.data;
	  var data = new Uint8Array(lineSize * height),
	      pos = 0,
	      ii;
	  for (i = 0, ii = data0.length; i < ii; i++) {
	    var mask = 128,
	        elem = data0[i];
	    while (mask > 0) {
	      data[pos++] = elem & mask ? 0 : 255;
	      mask >>= 1;
	    }
	  }
	  var count = 0;
	  pos = 0;
	  if (data[pos] !== 0) {
	    points[0] = 1;
	    ++count;
	  }
	  for (j = 1; j < width; j++) {
	    if (data[pos] !== data[pos + 1]) {
	      points[j] = data[pos] ? 2 : 1;
	      ++count;
	    }
	    pos++;
	  }
	  if (data[pos] !== 0) {
	    points[j] = 2;
	    ++count;
	  }
	  for (i = 1; i < height; i++) {
	    pos = i * lineSize;
	    j0 = i * width1;
	    if (data[pos - lineSize] !== data[pos]) {
	      points[j0] = data[pos] ? 1 : 8;
	      ++count;
	    }
	    var sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
	    for (j = 1; j < width; j++) {
	      sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
	      if (POINT_TYPES[sum]) {
	        points[j0 + j] = POINT_TYPES[sum];
	        ++count;
	      }
	      pos++;
	    }
	    if (data[pos - lineSize] !== data[pos]) {
	      points[j0 + j] = data[pos] ? 2 : 4;
	      ++count;
	    }
	    if (count > POINT_TO_PROCESS_LIMIT) {
	      return null;
	    }
	  }
	  pos = lineSize * (height - 1);
	  j0 = i * width1;
	  if (data[pos] !== 0) {
	    points[j0] = 8;
	    ++count;
	  }
	  for (j = 1; j < width; j++) {
	    if (data[pos] !== data[pos + 1]) {
	      points[j0 + j] = data[pos] ? 4 : 8;
	      ++count;
	    }
	    pos++;
	  }
	  if (data[pos] !== 0) {
	    points[j0 + j] = 4;
	    ++count;
	  }
	  if (count > POINT_TO_PROCESS_LIMIT) {
	    return null;
	  }
	  var steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
	  var outlines = [];
	  for (i = 0; count && i <= height; i++) {
	    var p = i * width1;
	    var end = p + width;
	    while (p < end && !points[p]) {
	      p++;
	    }
	    if (p === end) {
	      continue;
	    }
	    var coords = [p % width1, i];
	    var type = points[p],
	        p0 = p,
	        pp;
	    do {
	      var step = steps[type];
	      do {
	        p += step;
	      } while (!points[p]);
	      pp = points[p];
	      if (pp !== 5 && pp !== 10) {
	        type = pp;
	        points[p] = 0;
	      } else {
	        type = pp & 0x33 * type >> 4;
	        points[p] &= type >> 2 | type << 2;
	      }
	      coords.push(p % width1);
	      coords.push(p / width1 | 0);
	      --count;
	    } while (p0 !== p);
	    outlines.push(coords);
	    --i;
	  }
	  var drawOutline = function drawOutline(c) {
	    c.save();
	    c.scale(1 / width, -1 / height);
	    c.translate(0, -height);
	    c.beginPath();
	    for (var i = 0, ii = outlines.length; i < ii; i++) {
	      var o = outlines[i];
	      c.moveTo(o[0], o[1]);
	      for (var j = 2, jj = o.length; j < jj; j += 2) {
	        c.lineTo(o[j], o[j + 1]);
	      }
	    }
	    c.fill();
	    c.beginPath();
	    c.restore();
	  };
	  return drawOutline;
	}
	var CanvasExtraState = function CanvasExtraStateClosure() {
	  function CanvasExtraState() {
	    this.alphaIsShape = false;
	    this.fontSize = 0;
	    this.fontSizeScale = 1;
	    this.textMatrix = _util.IDENTITY_MATRIX;
	    this.textMatrixScale = 1;
	    this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
	    this.leading = 0;
	    this.x = 0;
	    this.y = 0;
	    this.lineX = 0;
	    this.lineY = 0;
	    this.charSpacing = 0;
	    this.wordSpacing = 0;
	    this.textHScale = 1;
	    this.textRenderingMode = _util.TextRenderingMode.FILL;
	    this.textRise = 0;
	    this.fillColor = '#000000';
	    this.strokeColor = '#000000';
	    this.patternFill = false;
	    this.fillAlpha = 1;
	    this.strokeAlpha = 1;
	    this.lineWidth = 1;
	    this.activeSMask = null;
	    this.resumeSMaskCtx = null;
	  }
	  CanvasExtraState.prototype = {
	    clone: function CanvasExtraState_clone() {
	      return Object.create(this);
	    },
	    setCurrentPoint: function CanvasExtraState_setCurrentPoint(x, y) {
	      this.x = x;
	      this.y = y;
	    }
	  };
	  return CanvasExtraState;
	}();
	var CanvasGraphics = function CanvasGraphicsClosure() {
	  var EXECUTION_TIME = 15;
	  var EXECUTION_STEPS = 10;
	  function CanvasGraphics(canvasCtx, commonObjs, objs, canvasFactory, webGLContext, imageLayer) {
	    this.ctx = canvasCtx;
	    this.current = new CanvasExtraState();
	    this.stateStack = [];
	    this.pendingClip = null;
	    this.pendingEOFill = false;
	    this.res = null;
	    this.xobjs = null;
	    this.commonObjs = commonObjs;
	    this.objs = objs;
	    this.canvasFactory = canvasFactory;
	    this.webGLContext = webGLContext;
	    this.imageLayer = imageLayer;
	    this.groupStack = [];
	    this.processingType3 = null;
	    this.baseTransform = null;
	    this.baseTransformStack = [];
	    this.groupLevel = 0;
	    this.smaskStack = [];
	    this.smaskCounter = 0;
	    this.tempSMask = null;
	    this.cachedCanvases = new CachedCanvases(this.canvasFactory);
	    if (canvasCtx) {
	      addContextCurrentTransform(canvasCtx);
	    }
	    this.cachedGetSinglePixelWidth = null;
	  }
	  function putBinaryImageData(ctx, imgData) {
	    if (typeof ImageData !== 'undefined' && imgData instanceof ImageData) {
	      ctx.putImageData(imgData, 0, 0);
	      return;
	    }
	    var height = imgData.height,
	        width = imgData.width;
	    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
	    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
	    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
	    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
	    var srcPos = 0,
	        destPos;
	    var src = imgData.data;
	    var dest = chunkImgData.data;
	    var i, j, thisChunkHeight, elemsInThisChunk;
	    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
	      var srcLength = src.byteLength;
	      var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
	      var dest32DataLength = dest32.length;
	      var fullSrcDiff = width + 7 >> 3;
	      var white = 0xFFFFFFFF;
	      var black = IsLittleEndianCached.value ? 0xFF000000 : 0x000000FF;
	      for (i = 0; i < totalChunks; i++) {
	        thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
	        destPos = 0;
	        for (j = 0; j < thisChunkHeight; j++) {
	          var srcDiff = srcLength - srcPos;
	          var k = 0;
	          var kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
	          var kEndUnrolled = kEnd & ~7;
	          var mask = 0;
	          var srcByte = 0;
	          for (; k < kEndUnrolled; k += 8) {
	            srcByte = src[srcPos++];
	            dest32[destPos++] = srcByte & 128 ? white : black;
	            dest32[destPos++] = srcByte & 64 ? white : black;
	            dest32[destPos++] = srcByte & 32 ? white : black;
	            dest32[destPos++] = srcByte & 16 ? white : black;
	            dest32[destPos++] = srcByte & 8 ? white : black;
	            dest32[destPos++] = srcByte & 4 ? white : black;
	            dest32[destPos++] = srcByte & 2 ? white : black;
	            dest32[destPos++] = srcByte & 1 ? white : black;
	          }
	          for (; k < kEnd; k++) {
	            if (mask === 0) {
	              srcByte = src[srcPos++];
	              mask = 128;
	            }
	            dest32[destPos++] = srcByte & mask ? white : black;
	            mask >>= 1;
	          }
	        }
	        while (destPos < dest32DataLength) {
	          dest32[destPos++] = 0;
	        }
	        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
	      }
	    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
	      j = 0;
	      elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
	      for (i = 0; i < fullChunks; i++) {
	        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
	        srcPos += elemsInThisChunk;
	        ctx.putImageData(chunkImgData, 0, j);
	        j += FULL_CHUNK_HEIGHT;
	      }
	      if (i < totalChunks) {
	        elemsInThisChunk = width * partialChunkHeight * 4;
	        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
	        ctx.putImageData(chunkImgData, 0, j);
	      }
	    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
	      thisChunkHeight = FULL_CHUNK_HEIGHT;
	      elemsInThisChunk = width * thisChunkHeight;
	      for (i = 0; i < totalChunks; i++) {
	        if (i >= fullChunks) {
	          thisChunkHeight = partialChunkHeight;
	          elemsInThisChunk = width * thisChunkHeight;
	        }
	        destPos = 0;
	        for (j = elemsInThisChunk; j--;) {
	          dest[destPos++] = src[srcPos++];
	          dest[destPos++] = src[srcPos++];
	          dest[destPos++] = src[srcPos++];
	          dest[destPos++] = 255;
	        }
	        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
	      }
	    } else {
	      throw new Error('bad image kind: ' + imgData.kind);
	    }
	  }
	  function putBinaryImageMask(ctx, imgData) {
	    var height = imgData.height,
	        width = imgData.width;
	    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
	    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
	    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
	    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
	    var srcPos = 0;
	    var src = imgData.data;
	    var dest = chunkImgData.data;
	    for (var i = 0; i < totalChunks; i++) {
	      var thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
	      var destPos = 3;
	      for (var j = 0; j < thisChunkHeight; j++) {
	        var mask = 0;
	        for (var k = 0; k < width; k++) {
	          if (!mask) {
	            var elem = src[srcPos++];
	            mask = 128;
	          }
	          dest[destPos] = elem & mask ? 0 : 255;
	          destPos += 4;
	          mask >>= 1;
	        }
	      }
	      ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
	    }
	  }
	  function copyCtxState(sourceCtx, destCtx) {
	    var properties = ['strokeStyle', 'fillStyle', 'fillRule', 'globalAlpha', 'lineWidth', 'lineCap', 'lineJoin', 'miterLimit', 'globalCompositeOperation', 'font'];
	    for (var i = 0, ii = properties.length; i < ii; i++) {
	      var property = properties[i];
	      if (sourceCtx[property] !== undefined) {
	        destCtx[property] = sourceCtx[property];
	      }
	    }
	    if (sourceCtx.setLineDash !== undefined) {
	      destCtx.setLineDash(sourceCtx.getLineDash());
	      destCtx.lineDashOffset = sourceCtx.lineDashOffset;
	    }
	  }
	  function resetCtxToDefault(ctx) {
	    ctx.strokeStyle = '#000000';
	    ctx.fillStyle = '#000000';
	    ctx.fillRule = 'nonzero';
	    ctx.globalAlpha = 1;
	    ctx.lineWidth = 1;
	    ctx.lineCap = 'butt';
	    ctx.lineJoin = 'miter';
	    ctx.miterLimit = 10;
	    ctx.globalCompositeOperation = 'source-over';
	    ctx.font = '10px sans-serif';
	    if (ctx.setLineDash !== undefined) {
	      ctx.setLineDash([]);
	      ctx.lineDashOffset = 0;
	    }
	  }
	  function composeSMaskBackdrop(bytes, r0, g0, b0) {
	    var length = bytes.length;
	    for (var i = 3; i < length; i += 4) {
	      var alpha = bytes[i];
	      if (alpha === 0) {
	        bytes[i - 3] = r0;
	        bytes[i - 2] = g0;
	        bytes[i - 1] = b0;
	      } else if (alpha < 255) {
	        var alpha_ = 255 - alpha;
	        bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
	        bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
	        bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
	      }
	    }
	  }
	  function composeSMaskAlpha(maskData, layerData, transferMap) {
	    var length = maskData.length;
	    var scale = 1 / 255;
	    for (var i = 3; i < length; i += 4) {
	      var alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
	      layerData[i] = layerData[i] * alpha * scale | 0;
	    }
	  }
	  function composeSMaskLuminosity(maskData, layerData, transferMap) {
	    var length = maskData.length;
	    for (var i = 3; i < length; i += 4) {
	      var y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
	      layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
	    }
	  }
	  function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap) {
	    var hasBackdrop = !!backdrop;
	    var r0 = hasBackdrop ? backdrop[0] : 0;
	    var g0 = hasBackdrop ? backdrop[1] : 0;
	    var b0 = hasBackdrop ? backdrop[2] : 0;
	    var composeFn;
	    if (subtype === 'Luminosity') {
	      composeFn = composeSMaskLuminosity;
	    } else {
	      composeFn = composeSMaskAlpha;
	    }
	    var PIXELS_TO_PROCESS = 1048576;
	    var chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
	    for (var row = 0; row < height; row += chunkSize) {
	      var chunkHeight = Math.min(chunkSize, height - row);
	      var maskData = maskCtx.getImageData(0, row, width, chunkHeight);
	      var layerData = layerCtx.getImageData(0, row, width, chunkHeight);
	      if (hasBackdrop) {
	        composeSMaskBackdrop(maskData.data, r0, g0, b0);
	      }
	      composeFn(maskData.data, layerData.data, transferMap);
	      maskCtx.putImageData(layerData, 0, row);
	    }
	  }
	  function composeSMask(ctx, smask, layerCtx, webGLContext) {
	    var mask = smask.canvas;
	    var maskCtx = smask.context;
	    ctx.setTransform(smask.scaleX, 0, 0, smask.scaleY, smask.offsetX, smask.offsetY);
	    var backdrop = smask.backdrop || null;
	    if (!smask.transferMap && webGLContext.isEnabled) {
	      var composed = webGLContext.composeSMask({
	        layer: layerCtx.canvas,
	        mask: mask,
	        properties: {
	          subtype: smask.subtype,
	          backdrop: backdrop
	        }
	      });
	      ctx.setTransform(1, 0, 0, 1, 0, 0);
	      ctx.drawImage(composed, smask.offsetX, smask.offsetY);
	      return;
	    }
	    genericComposeSMask(maskCtx, layerCtx, mask.width, mask.height, smask.subtype, backdrop, smask.transferMap);
	    ctx.drawImage(mask, 0, 0);
	  }
	  var LINE_CAP_STYLES = ['butt', 'round', 'square'];
	  var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
	  var NORMAL_CLIP = {};
	  var EO_CLIP = {};
	  CanvasGraphics.prototype = {
	    beginDrawing: function beginDrawing(_ref) {
	      var transform = _ref.transform,
	          viewport = _ref.viewport,
	          transparency = _ref.transparency,
	          _ref$background = _ref.background,
	          background = _ref$background === undefined ? null : _ref$background;
	
	      var width = this.ctx.canvas.width;
	      var height = this.ctx.canvas.height;
	      this.ctx.save();
	      this.ctx.fillStyle = background || 'rgb(255, 255, 255)';
	      this.ctx.fillRect(0, 0, width, height);
	      this.ctx.restore();
	      if (transparency) {
	        var transparentCanvas = this.cachedCanvases.getCanvas('transparent', width, height, true);
	        this.compositeCtx = this.ctx;
	        this.transparentCanvas = transparentCanvas.canvas;
	        this.ctx = transparentCanvas.context;
	        this.ctx.save();
	        this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
	      }
	      this.ctx.save();
	      resetCtxToDefault(this.ctx);
	      if (transform) {
	        this.ctx.transform.apply(this.ctx, transform);
	      }
	      this.ctx.transform.apply(this.ctx, viewport.transform);
	      this.baseTransform = this.ctx.mozCurrentTransform.slice();
	      if (this.imageLayer) {
	        this.imageLayer.beginLayout();
	      }
	    },
	
	    executeOperatorList: function CanvasGraphics_executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
	      var argsArray = operatorList.argsArray;
	      var fnArray = operatorList.fnArray;
	      var i = executionStartIdx || 0;
	      var argsArrayLen = argsArray.length;
	      if (argsArrayLen === i) {
	        return i;
	      }
	      var chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === 'function';
	      var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
	      var steps = 0;
	      var commonObjs = this.commonObjs;
	      var objs = this.objs;
	      var fnId;
	      while (true) {
	        if (stepper !== undefined && i === stepper.nextBreakPoint) {
	          stepper.breakIt(i, continueCallback);
	          return i;
	        }
	        fnId = fnArray[i];
	        if (fnId !== _util.OPS.dependency) {
	          this[fnId].apply(this, argsArray[i]);
	        } else {
	          var deps = argsArray[i];
	          for (var n = 0, nn = deps.length; n < nn; n++) {
	            var depObjId = deps[n];
	            var common = depObjId[0] === 'g' && depObjId[1] === '_';
	            var objsPool = common ? commonObjs : objs;
	            if (!objsPool.isResolved(depObjId)) {
	              objsPool.get(depObjId, continueCallback);
	              return i;
	            }
	          }
	        }
	        i++;
	        if (i === argsArrayLen) {
	          return i;
	        }
	        if (chunkOperations && ++steps > EXECUTION_STEPS) {
	          if (Date.now() > endTime) {
	            continueCallback();
	            return i;
	          }
	          steps = 0;
	        }
	      }
	    },
	    endDrawing: function CanvasGraphics_endDrawing() {
	      if (this.current.activeSMask !== null) {
	        this.endSMaskGroup();
	      }
	      this.ctx.restore();
	      if (this.transparentCanvas) {
	        this.ctx = this.compositeCtx;
	        this.ctx.save();
	        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
	        this.ctx.drawImage(this.transparentCanvas, 0, 0);
	        this.ctx.restore();
	        this.transparentCanvas = null;
	      }
	      this.cachedCanvases.clear();
	      this.webGLContext.clear();
	      if (this.imageLayer) {
	        this.imageLayer.endLayout();
	      }
	    },
	    setLineWidth: function CanvasGraphics_setLineWidth(width) {
	      this.current.lineWidth = width;
	      this.ctx.lineWidth = width;
	    },
	    setLineCap: function CanvasGraphics_setLineCap(style) {
	      this.ctx.lineCap = LINE_CAP_STYLES[style];
	    },
	    setLineJoin: function CanvasGraphics_setLineJoin(style) {
	      this.ctx.lineJoin = LINE_JOIN_STYLES[style];
	    },
	    setMiterLimit: function CanvasGraphics_setMiterLimit(limit) {
	      this.ctx.miterLimit = limit;
	    },
	    setDash: function CanvasGraphics_setDash(dashArray, dashPhase) {
	      var ctx = this.ctx;
	      if (ctx.setLineDash !== undefined) {
	        ctx.setLineDash(dashArray);
	        ctx.lineDashOffset = dashPhase;
	      }
	    },
	    setRenderingIntent: function CanvasGraphics_setRenderingIntent(intent) {},
	    setFlatness: function CanvasGraphics_setFlatness(flatness) {},
	    setGState: function CanvasGraphics_setGState(states) {
	      for (var i = 0, ii = states.length; i < ii; i++) {
	        var state = states[i];
	        var key = state[0];
	        var value = state[1];
	        switch (key) {
	          case 'LW':
	            this.setLineWidth(value);
	            break;
	          case 'LC':
	            this.setLineCap(value);
	            break;
	          case 'LJ':
	            this.setLineJoin(value);
	            break;
	          case 'ML':
	            this.setMiterLimit(value);
	            break;
	          case 'D':
	            this.setDash(value[0], value[1]);
	            break;
	          case 'RI':
	            this.setRenderingIntent(value);
	            break;
	          case 'FL':
	            this.setFlatness(value);
	            break;
	          case 'Font':
	            this.setFont(value[0], value[1]);
	            break;
	          case 'CA':
	            this.current.strokeAlpha = state[1];
	            break;
	          case 'ca':
	            this.current.fillAlpha = state[1];
	            this.ctx.globalAlpha = state[1];
	            break;
	          case 'BM':
	            this.ctx.globalCompositeOperation = value;
	            break;
	          case 'SMask':
	            if (this.current.activeSMask) {
	              if (this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask) {
	                this.suspendSMaskGroup();
	              } else {
	                this.endSMaskGroup();
	              }
	            }
	            this.current.activeSMask = value ? this.tempSMask : null;
	            if (this.current.activeSMask) {
	              this.beginSMaskGroup();
	            }
	            this.tempSMask = null;
	            break;
	        }
	      }
	    },
	    beginSMaskGroup: function CanvasGraphics_beginSMaskGroup() {
	      var activeSMask = this.current.activeSMask;
	      var drawnWidth = activeSMask.canvas.width;
	      var drawnHeight = activeSMask.canvas.height;
	      var cacheId = 'smaskGroupAt' + this.groupLevel;
	      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
	      var currentCtx = this.ctx;
	      var currentTransform = currentCtx.mozCurrentTransform;
	      this.ctx.save();
	      var groupCtx = scratchCanvas.context;
	      groupCtx.scale(1 / activeSMask.scaleX, 1 / activeSMask.scaleY);
	      groupCtx.translate(-activeSMask.offsetX, -activeSMask.offsetY);
	      groupCtx.transform.apply(groupCtx, currentTransform);
	      activeSMask.startTransformInverse = groupCtx.mozCurrentTransformInverse;
	      copyCtxState(currentCtx, groupCtx);
	      this.ctx = groupCtx;
	      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
	      this.groupStack.push(currentCtx);
	      this.groupLevel++;
	    },
	    suspendSMaskGroup: function CanvasGraphics_endSMaskGroup() {
	      var groupCtx = this.ctx;
	      this.groupLevel--;
	      this.ctx = this.groupStack.pop();
	      composeSMask(this.ctx, this.current.activeSMask, groupCtx, this.webGLContext);
	      this.ctx.restore();
	      this.ctx.save();
	      copyCtxState(groupCtx, this.ctx);
	      this.current.resumeSMaskCtx = groupCtx;
	      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
	      this.ctx.transform.apply(this.ctx, deltaTransform);
	      groupCtx.save();
	      groupCtx.setTransform(1, 0, 0, 1, 0, 0);
	      groupCtx.clearRect(0, 0, groupCtx.canvas.width, groupCtx.canvas.height);
	      groupCtx.restore();
	    },
	    resumeSMaskGroup: function CanvasGraphics_endSMaskGroup() {
	      var groupCtx = this.current.resumeSMaskCtx;
	      var currentCtx = this.ctx;
	      this.ctx = groupCtx;
	      this.groupStack.push(currentCtx);
	      this.groupLevel++;
	    },
	    endSMaskGroup: function CanvasGraphics_endSMaskGroup() {
	      var groupCtx = this.ctx;
	      this.groupLevel--;
	      this.ctx = this.groupStack.pop();
	      composeSMask(this.ctx, this.current.activeSMask, groupCtx, this.webGLContext);
	      this.ctx.restore();
	      copyCtxState(groupCtx, this.ctx);
	      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
	      this.ctx.transform.apply(this.ctx, deltaTransform);
	    },
	    save: function CanvasGraphics_save() {
	      this.ctx.save();
	      var old = this.current;
	      this.stateStack.push(old);
	      this.current = old.clone();
	      this.current.resumeSMaskCtx = null;
	    },
	    restore: function CanvasGraphics_restore() {
	      if (this.current.resumeSMaskCtx) {
	        this.resumeSMaskGroup();
	      }
	      if (this.current.activeSMask !== null && (this.stateStack.length === 0 || this.stateStack[this.stateStack.length - 1].activeSMask !== this.current.activeSMask)) {
	        this.endSMaskGroup();
	      }
	      if (this.stateStack.length !== 0) {
	        this.current = this.stateStack.pop();
	        this.ctx.restore();
	        this.pendingClip = null;
	        this.cachedGetSinglePixelWidth = null;
	      }
	    },
	    transform: function CanvasGraphics_transform(a, b, c, d, e, f) {
	      this.ctx.transform(a, b, c, d, e, f);
	      this.cachedGetSinglePixelWidth = null;
	    },
	    constructPath: function CanvasGraphics_constructPath(ops, args) {
	      var ctx = this.ctx;
	      var current = this.current;
	      var x = current.x,
	          y = current.y;
	      for (var i = 0, j = 0, ii = ops.length; i < ii; i++) {
	        switch (ops[i] | 0) {
	          case _util.OPS.rectangle:
	            x = args[j++];
	            y = args[j++];
	            var width = args[j++];
	            var height = args[j++];
	            if (width === 0) {
	              width = this.getSinglePixelWidth();
	            }
	            if (height === 0) {
	              height = this.getSinglePixelWidth();
	            }
	            var xw = x + width;
	            var yh = y + height;
	            this.ctx.moveTo(x, y);
	            this.ctx.lineTo(xw, y);
	            this.ctx.lineTo(xw, yh);
	            this.ctx.lineTo(x, yh);
	            this.ctx.lineTo(x, y);
	            this.ctx.closePath();
	            break;
	          case _util.OPS.moveTo:
	            x = args[j++];
	            y = args[j++];
	            ctx.moveTo(x, y);
	            break;
	          case _util.OPS.lineTo:
	            x = args[j++];
	            y = args[j++];
	            ctx.lineTo(x, y);
	            break;
	          case _util.OPS.curveTo:
	            x = args[j + 4];
	            y = args[j + 5];
	            ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
	            j += 6;
	            break;
	          case _util.OPS.curveTo2:
	            ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
	            x = args[j + 2];
	            y = args[j + 3];
	            j += 4;
	            break;
	          case _util.OPS.curveTo3:
	            x = args[j + 2];
	            y = args[j + 3];
	            ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
	            j += 4;
	            break;
	          case _util.OPS.closePath:
	            ctx.closePath();
	            break;
	        }
	      }
	      current.setCurrentPoint(x, y);
	    },
	    closePath: function CanvasGraphics_closePath() {
	      this.ctx.closePath();
	    },
	    stroke: function CanvasGraphics_stroke(consumePath) {
	      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
	      var ctx = this.ctx;
	      var strokeColor = this.current.strokeColor;
	      ctx.lineWidth = Math.max(this.getSinglePixelWidth() * MIN_WIDTH_FACTOR, this.current.lineWidth);
	      ctx.globalAlpha = this.current.strokeAlpha;
	      if (strokeColor && strokeColor.hasOwnProperty('type') && strokeColor.type === 'Pattern') {
	        ctx.save();
	        ctx.strokeStyle = strokeColor.getPattern(ctx, this);
	        ctx.stroke();
	        ctx.restore();
	      } else {
	        ctx.stroke();
	      }
	      if (consumePath) {
	        this.consumePath();
	      }
	      ctx.globalAlpha = this.current.fillAlpha;
	    },
	    closeStroke: function CanvasGraphics_closeStroke() {
	      this.closePath();
	      this.stroke();
	    },
	    fill: function CanvasGraphics_fill(consumePath) {
	      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
	      var ctx = this.ctx;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      var needRestore = false;
	      if (isPatternFill) {
	        ctx.save();
	        if (this.baseTransform) {
	          ctx.setTransform.apply(ctx, this.baseTransform);
	        }
	        ctx.fillStyle = fillColor.getPattern(ctx, this);
	        needRestore = true;
	      }
	      if (this.pendingEOFill) {
	        ctx.fill('evenodd');
	        this.pendingEOFill = false;
	      } else {
	        ctx.fill();
	      }
	      if (needRestore) {
	        ctx.restore();
	      }
	      if (consumePath) {
	        this.consumePath();
	      }
	    },
	    eoFill: function CanvasGraphics_eoFill() {
	      this.pendingEOFill = true;
	      this.fill();
	    },
	    fillStroke: function CanvasGraphics_fillStroke() {
	      this.fill(false);
	      this.stroke(false);
	      this.consumePath();
	    },
	    eoFillStroke: function CanvasGraphics_eoFillStroke() {
	      this.pendingEOFill = true;
	      this.fillStroke();
	    },
	    closeFillStroke: function CanvasGraphics_closeFillStroke() {
	      this.closePath();
	      this.fillStroke();
	    },
	    closeEOFillStroke: function CanvasGraphics_closeEOFillStroke() {
	      this.pendingEOFill = true;
	      this.closePath();
	      this.fillStroke();
	    },
	    endPath: function CanvasGraphics_endPath() {
	      this.consumePath();
	    },
	    clip: function CanvasGraphics_clip() {
	      this.pendingClip = NORMAL_CLIP;
	    },
	    eoClip: function CanvasGraphics_eoClip() {
	      this.pendingClip = EO_CLIP;
	    },
	    beginText: function CanvasGraphics_beginText() {
	      this.current.textMatrix = _util.IDENTITY_MATRIX;
	      this.current.textMatrixScale = 1;
	      this.current.x = this.current.lineX = 0;
	      this.current.y = this.current.lineY = 0;
	    },
	    endText: function CanvasGraphics_endText() {
	      var paths = this.pendingTextPaths;
	      var ctx = this.ctx;
	      if (paths === undefined) {
	        ctx.beginPath();
	        return;
	      }
	      ctx.save();
	      ctx.beginPath();
	      for (var i = 0; i < paths.length; i++) {
	        var path = paths[i];
	        ctx.setTransform.apply(ctx, path.transform);
	        ctx.translate(path.x, path.y);
	        path.addToPath(ctx, path.fontSize);
	      }
	      ctx.restore();
	      ctx.clip();
	      ctx.beginPath();
	      delete this.pendingTextPaths;
	    },
	    setCharSpacing: function CanvasGraphics_setCharSpacing(spacing) {
	      this.current.charSpacing = spacing;
	    },
	    setWordSpacing: function CanvasGraphics_setWordSpacing(spacing) {
	      this.current.wordSpacing = spacing;
	    },
	    setHScale: function CanvasGraphics_setHScale(scale) {
	      this.current.textHScale = scale / 100;
	    },
	    setLeading: function CanvasGraphics_setLeading(leading) {
	      this.current.leading = -leading;
	    },
	    setFont: function CanvasGraphics_setFont(fontRefName, size) {
	      var fontObj = this.commonObjs.get(fontRefName);
	      var current = this.current;
	      if (!fontObj) {
	        throw new Error('Can\'t find font for ' + fontRefName);
	      }
	      current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
	      if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
	        (0, _util.warn)('Invalid font matrix for font ' + fontRefName);
	      }
	      if (size < 0) {
	        size = -size;
	        current.fontDirection = -1;
	      } else {
	        current.fontDirection = 1;
	      }
	      this.current.font = fontObj;
	      this.current.fontSize = size;
	      if (fontObj.isType3Font) {
	        return;
	      }
	      var name = fontObj.loadedName || 'sans-serif';
	      var bold = fontObj.black ? '900' : fontObj.bold ? 'bold' : 'normal';
	      var italic = fontObj.italic ? 'italic' : 'normal';
	      var typeface = '"' + name + '", ' + fontObj.fallbackName;
	      var browserFontSize = size < MIN_FONT_SIZE ? MIN_FONT_SIZE : size > MAX_FONT_SIZE ? MAX_FONT_SIZE : size;
	      this.current.fontSizeScale = size / browserFontSize;
	      var rule = italic + ' ' + bold + ' ' + browserFontSize + 'px ' + typeface;
	      this.ctx.font = rule;
	    },
	    setTextRenderingMode: function CanvasGraphics_setTextRenderingMode(mode) {
	      this.current.textRenderingMode = mode;
	    },
	    setTextRise: function CanvasGraphics_setTextRise(rise) {
	      this.current.textRise = rise;
	    },
	    moveText: function CanvasGraphics_moveText(x, y) {
	      this.current.x = this.current.lineX += x;
	      this.current.y = this.current.lineY += y;
	    },
	    setLeadingMoveText: function CanvasGraphics_setLeadingMoveText(x, y) {
	      this.setLeading(-y);
	      this.moveText(x, y);
	    },
	    setTextMatrix: function CanvasGraphics_setTextMatrix(a, b, c, d, e, f) {
	      this.current.textMatrix = [a, b, c, d, e, f];
	      this.current.textMatrixScale = Math.sqrt(a * a + b * b);
	      this.current.x = this.current.lineX = 0;
	      this.current.y = this.current.lineY = 0;
	    },
	    nextLine: function CanvasGraphics_nextLine() {
	      this.moveText(0, this.current.leading);
	    },
	    paintChar: function paintChar(character, x, y, patternTransform) {
	      var ctx = this.ctx;
	      var current = this.current;
	      var font = current.font;
	      var textRenderingMode = current.textRenderingMode;
	      var fontSize = current.fontSize / current.fontSizeScale;
	      var fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
	      var isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
	      var patternFill = current.patternFill && font.data;
	      var addToPath;
	      if (font.disableFontFace || isAddToPathSet || patternFill) {
	        addToPath = font.getPathGenerator(this.commonObjs, character);
	      }
	      if (font.disableFontFace || patternFill) {
	        ctx.save();
	        ctx.translate(x, y);
	        ctx.beginPath();
	        addToPath(ctx, fontSize);
	        if (patternTransform) {
	          ctx.setTransform.apply(ctx, patternTransform);
	        }
	        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.fill();
	        }
	        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.stroke();
	        }
	        ctx.restore();
	      } else {
	        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.fillText(character, x, y);
	        }
	        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.strokeText(character, x, y);
	        }
	      }
	      if (isAddToPathSet) {
	        var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
	        paths.push({
	          transform: ctx.mozCurrentTransform,
	          x: x,
	          y: y,
	          fontSize: fontSize,
	          addToPath: addToPath
	        });
	      }
	    },
	
	    get isFontSubpixelAAEnabled() {
	      var ctx = this.canvasFactory.create(10, 10).context;
	      ctx.scale(1.5, 1);
	      ctx.fillText('I', 0, 10);
	      var data = ctx.getImageData(0, 0, 10, 10).data;
	      var enabled = false;
	      for (var i = 3; i < data.length; i += 4) {
	        if (data[i] > 0 && data[i] < 255) {
	          enabled = true;
	          break;
	        }
	      }
	      return (0, _util.shadow)(this, 'isFontSubpixelAAEnabled', enabled);
	    },
	    showText: function CanvasGraphics_showText(glyphs) {
	      var current = this.current;
	      var font = current.font;
	      if (font.isType3Font) {
	        return this.showType3Text(glyphs);
	      }
	      var fontSize = current.fontSize;
	      if (fontSize === 0) {
	        return;
	      }
	      var ctx = this.ctx;
	      var fontSizeScale = current.fontSizeScale;
	      var charSpacing = current.charSpacing;
	      var wordSpacing = current.wordSpacing;
	      var fontDirection = current.fontDirection;
	      var textHScale = current.textHScale * fontDirection;
	      var glyphsLength = glyphs.length;
	      var vertical = font.vertical;
	      var spacingDir = vertical ? 1 : -1;
	      var defaultVMetrics = font.defaultVMetrics;
	      var widthAdvanceScale = fontSize * current.fontMatrix[0];
	      var simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
	      ctx.save();
	      var patternTransform = void 0;
	      if (current.patternFill) {
	        ctx.save();
	        var pattern = current.fillColor.getPattern(ctx, this);
	        patternTransform = ctx.mozCurrentTransform;
	        ctx.restore();
	        ctx.fillStyle = pattern;
	      }
	      ctx.transform.apply(ctx, current.textMatrix);
	      ctx.translate(current.x, current.y + current.textRise);
	      if (fontDirection > 0) {
	        ctx.scale(textHScale, -1);
	      } else {
	        ctx.scale(textHScale, 1);
	      }
	      var lineWidth = current.lineWidth;
	      var scale = current.textMatrixScale;
	      if (scale === 0 || lineWidth === 0) {
	        var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
	        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          this.cachedGetSinglePixelWidth = null;
	          lineWidth = this.getSinglePixelWidth() * MIN_WIDTH_FACTOR;
	        }
	      } else {
	        lineWidth /= scale;
	      }
	      if (fontSizeScale !== 1.0) {
	        ctx.scale(fontSizeScale, fontSizeScale);
	        lineWidth /= fontSizeScale;
	      }
	      ctx.lineWidth = lineWidth;
	      var x = 0,
	          i;
	      for (i = 0; i < glyphsLength; ++i) {
	        var glyph = glyphs[i];
	        if ((0, _util.isNum)(glyph)) {
	          x += spacingDir * glyph * fontSize / 1000;
	          continue;
	        }
	        var restoreNeeded = false;
	        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
	        var character = glyph.fontChar;
	        var accent = glyph.accent;
	        var scaledX, scaledY, scaledAccentX, scaledAccentY;
	        var width = glyph.width;
	        if (vertical) {
	          var vmetric, vx, vy;
	          vmetric = glyph.vmetric || defaultVMetrics;
	          vx = glyph.vmetric ? vmetric[1] : width * 0.5;
	          vx = -vx * widthAdvanceScale;
	          vy = vmetric[2] * widthAdvanceScale;
	          width = vmetric ? -vmetric[0] : width;
	          scaledX = vx / fontSizeScale;
	          scaledY = (x + vy) / fontSizeScale;
	        } else {
	          scaledX = x / fontSizeScale;
	          scaledY = 0;
	        }
	        if (font.remeasure && width > 0) {
	          var measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
	          if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
	            var characterScaleX = width / measuredWidth;
	            restoreNeeded = true;
	            ctx.save();
	            ctx.scale(characterScaleX, 1);
	            scaledX /= characterScaleX;
	          } else if (width !== measuredWidth) {
	            scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
	          }
	        }
	        if (glyph.isInFont || font.missingFile) {
	          if (simpleFillText && !accent) {
	            ctx.fillText(character, scaledX, scaledY);
	          } else {
	            this.paintChar(character, scaledX, scaledY, patternTransform);
	            if (accent) {
	              scaledAccentX = scaledX + accent.offset.x / fontSizeScale;
	              scaledAccentY = scaledY - accent.offset.y / fontSizeScale;
	              this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform);
	            }
	          }
	        }
	        var charWidth = width * widthAdvanceScale + spacing * fontDirection;
	        x += charWidth;
	        if (restoreNeeded) {
	          ctx.restore();
	        }
	      }
	      if (vertical) {
	        current.y -= x * textHScale;
	      } else {
	        current.x += x * textHScale;
	      }
	      ctx.restore();
	    },
	    showType3Text: function CanvasGraphics_showType3Text(glyphs) {
	      var ctx = this.ctx;
	      var current = this.current;
	      var font = current.font;
	      var fontSize = current.fontSize;
	      var fontDirection = current.fontDirection;
	      var spacingDir = font.vertical ? 1 : -1;
	      var charSpacing = current.charSpacing;
	      var wordSpacing = current.wordSpacing;
	      var textHScale = current.textHScale * fontDirection;
	      var fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
	      var glyphsLength = glyphs.length;
	      var isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
	      var i, glyph, width, spacingLength;
	      if (isTextInvisible || fontSize === 0) {
	        return;
	      }
	      this.cachedGetSinglePixelWidth = null;
	      ctx.save();
	      ctx.transform.apply(ctx, current.textMatrix);
	      ctx.translate(current.x, current.y);
	      ctx.scale(textHScale, fontDirection);
	      for (i = 0; i < glyphsLength; ++i) {
	        glyph = glyphs[i];
	        if ((0, _util.isNum)(glyph)) {
	          spacingLength = spacingDir * glyph * fontSize / 1000;
	          this.ctx.translate(spacingLength, 0);
	          current.x += spacingLength * textHScale;
	          continue;
	        }
	        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
	        var operatorList = font.charProcOperatorList[glyph.operatorListId];
	        if (!operatorList) {
	          (0, _util.warn)('Type3 character "' + glyph.operatorListId + '" is not available.');
	          continue;
	        }
	        this.processingType3 = glyph;
	        this.save();
	        ctx.scale(fontSize, fontSize);
	        ctx.transform.apply(ctx, fontMatrix);
	        this.executeOperatorList(operatorList);
	        this.restore();
	        var transformed = _util.Util.applyTransform([glyph.width, 0], fontMatrix);
	        width = transformed[0] * fontSize + spacing;
	        ctx.translate(width, 0);
	        current.x += width * textHScale;
	      }
	      ctx.restore();
	      this.processingType3 = null;
	    },
	    setCharWidth: function CanvasGraphics_setCharWidth(xWidth, yWidth) {},
	    setCharWidthAndBounds: function CanvasGraphics_setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
	      this.ctx.rect(llx, lly, urx - llx, ury - lly);
	      this.clip();
	      this.endPath();
	    },
	    getColorN_Pattern: function CanvasGraphics_getColorN_Pattern(IR) {
	      var _this = this;
	
	      var pattern;
	      if (IR[0] === 'TilingPattern') {
	        var color = IR[1];
	        var baseTransform = this.baseTransform || this.ctx.mozCurrentTransform.slice();
	        var canvasGraphicsFactory = {
	          createCanvasGraphics: function createCanvasGraphics(ctx) {
	            return new CanvasGraphics(ctx, _this.commonObjs, _this.objs, _this.canvasFactory, _this.webGLContext);
	          }
	        };
	        pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
	      } else {
	        pattern = (0, _pattern_helper.getShadingPatternFromIR)(IR);
	      }
	      return pattern;
	    },
	    setStrokeColorN: function CanvasGraphics_setStrokeColorN() {
	      this.current.strokeColor = this.getColorN_Pattern(arguments);
	    },
	    setFillColorN: function CanvasGraphics_setFillColorN() {
	      this.current.fillColor = this.getColorN_Pattern(arguments);
	      this.current.patternFill = true;
	    },
	    setStrokeRGBColor: function CanvasGraphics_setStrokeRGBColor(r, g, b) {
	      var color = _util.Util.makeCssRgb(r, g, b);
	      this.ctx.strokeStyle = color;
	      this.current.strokeColor = color;
	    },
	    setFillRGBColor: function CanvasGraphics_setFillRGBColor(r, g, b) {
	      var color = _util.Util.makeCssRgb(r, g, b);
	      this.ctx.fillStyle = color;
	      this.current.fillColor = color;
	      this.current.patternFill = false;
	    },
	    shadingFill: function CanvasGraphics_shadingFill(patternIR) {
	      var ctx = this.ctx;
	      this.save();
	      var pattern = (0, _pattern_helper.getShadingPatternFromIR)(patternIR);
	      ctx.fillStyle = pattern.getPattern(ctx, this, true);
	      var inv = ctx.mozCurrentTransformInverse;
	      if (inv) {
	        var canvas = ctx.canvas;
	        var width = canvas.width;
	        var height = canvas.height;
	        var bl = _util.Util.applyTransform([0, 0], inv);
	        var br = _util.Util.applyTransform([0, height], inv);
	        var ul = _util.Util.applyTransform([width, 0], inv);
	        var ur = _util.Util.applyTransform([width, height], inv);
	        var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
	        var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
	        var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
	        var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
	        this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
	      } else {
	        this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
	      }
	      this.restore();
	    },
	    beginInlineImage: function CanvasGraphics_beginInlineImage() {
	      (0, _util.unreachable)('Should not call beginInlineImage');
	    },
	    beginImageData: function CanvasGraphics_beginImageData() {
	      (0, _util.unreachable)('Should not call beginImageData');
	    },
	    paintFormXObjectBegin: function CanvasGraphics_paintFormXObjectBegin(matrix, bbox) {
	      this.save();
	      this.baseTransformStack.push(this.baseTransform);
	      if (Array.isArray(matrix) && matrix.length === 6) {
	        this.transform.apply(this, matrix);
	      }
	      this.baseTransform = this.ctx.mozCurrentTransform;
	      if (Array.isArray(bbox) && bbox.length === 4) {
	        var width = bbox[2] - bbox[0];
	        var height = bbox[3] - bbox[1];
	        this.ctx.rect(bbox[0], bbox[1], width, height);
	        this.clip();
	        this.endPath();
	      }
	    },
	    paintFormXObjectEnd: function CanvasGraphics_paintFormXObjectEnd() {
	      this.restore();
	      this.baseTransform = this.baseTransformStack.pop();
	    },
	    beginGroup: function CanvasGraphics_beginGroup(group) {
	      this.save();
	      var currentCtx = this.ctx;
	      if (!group.isolated) {
	        (0, _util.info)('TODO: Support non-isolated groups.');
	      }
	      if (group.knockout) {
	        (0, _util.warn)('Knockout groups not supported.');
	      }
	      var currentTransform = currentCtx.mozCurrentTransform;
	      if (group.matrix) {
	        currentCtx.transform.apply(currentCtx, group.matrix);
	      }
	      if (!group.bbox) {
	        throw new Error('Bounding box is required.');
	      }
	      var bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, currentCtx.mozCurrentTransform);
	      var canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
	      bounds = _util.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
	      var offsetX = Math.floor(bounds[0]);
	      var offsetY = Math.floor(bounds[1]);
	      var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
	      var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
	      var scaleX = 1,
	          scaleY = 1;
	      if (drawnWidth > MAX_GROUP_SIZE) {
	        scaleX = drawnWidth / MAX_GROUP_SIZE;
	        drawnWidth = MAX_GROUP_SIZE;
	      }
	      if (drawnHeight > MAX_GROUP_SIZE) {
	        scaleY = drawnHeight / MAX_GROUP_SIZE;
	        drawnHeight = MAX_GROUP_SIZE;
	      }
	      var cacheId = 'groupAt' + this.groupLevel;
	      if (group.smask) {
	        cacheId += '_smask_' + this.smaskCounter++ % 2;
	      }
	      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
	      var groupCtx = scratchCanvas.context;
	      groupCtx.scale(1 / scaleX, 1 / scaleY);
	      groupCtx.translate(-offsetX, -offsetY);
	      groupCtx.transform.apply(groupCtx, currentTransform);
	      if (group.smask) {
	        this.smaskStack.push({
	          canvas: scratchCanvas.canvas,
	          context: groupCtx,
	          offsetX: offsetX,
	          offsetY: offsetY,
	          scaleX: scaleX,
	          scaleY: scaleY,
	          subtype: group.smask.subtype,
	          backdrop: group.smask.backdrop,
	          transferMap: group.smask.transferMap || null,
	          startTransformInverse: null
	        });
	      } else {
	        currentCtx.setTransform(1, 0, 0, 1, 0, 0);
	        currentCtx.translate(offsetX, offsetY);
	        currentCtx.scale(scaleX, scaleY);
	      }
	      copyCtxState(currentCtx, groupCtx);
	      this.ctx = groupCtx;
	      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
	      this.groupStack.push(currentCtx);
	      this.groupLevel++;
	      this.current.activeSMask = null;
	    },
	    endGroup: function CanvasGraphics_endGroup(group) {
	      this.groupLevel--;
	      var groupCtx = this.ctx;
	      this.ctx = this.groupStack.pop();
	      if (this.ctx.imageSmoothingEnabled !== undefined) {
	        this.ctx.imageSmoothingEnabled = false;
	      } else {
	        this.ctx.mozImageSmoothingEnabled = false;
	      }
	      if (group.smask) {
	        this.tempSMask = this.smaskStack.pop();
	      } else {
	        this.ctx.drawImage(groupCtx.canvas, 0, 0);
	      }
	      this.restore();
	    },
	    beginAnnotations: function CanvasGraphics_beginAnnotations() {
	      this.save();
	      if (this.baseTransform) {
	        this.ctx.setTransform.apply(this.ctx, this.baseTransform);
	      }
	    },
	    endAnnotations: function CanvasGraphics_endAnnotations() {
	      this.restore();
	    },
	    beginAnnotation: function CanvasGraphics_beginAnnotation(rect, transform, matrix) {
	      this.save();
	      resetCtxToDefault(this.ctx);
	      this.current = new CanvasExtraState();
	      if (Array.isArray(rect) && rect.length === 4) {
	        var width = rect[2] - rect[0];
	        var height = rect[3] - rect[1];
	        this.ctx.rect(rect[0], rect[1], width, height);
	        this.clip();
	        this.endPath();
	      }
	      this.transform.apply(this, transform);
	      this.transform.apply(this, matrix);
	    },
	    endAnnotation: function CanvasGraphics_endAnnotation() {
	      this.restore();
	    },
	    paintJpegXObject: function CanvasGraphics_paintJpegXObject(objId, w, h) {
	      var domImage = this.objs.get(objId);
	      if (!domImage) {
	        (0, _util.warn)('Dependent image isn\'t ready yet');
	        return;
	      }
	      this.save();
	      var ctx = this.ctx;
	      ctx.scale(1 / w, -1 / h);
	      ctx.drawImage(domImage, 0, 0, domImage.width, domImage.height, 0, -h, w, h);
	      if (this.imageLayer) {
	        var currentTransform = ctx.mozCurrentTransformInverse;
	        var position = this.getCanvasPosition(0, 0);
	        this.imageLayer.appendImage({
	          objId: objId,
	          left: position[0],
	          top: position[1],
	          width: w / currentTransform[0],
	          height: h / currentTransform[3]
	        });
	      }
	      this.restore();
	    },
	    paintImageMaskXObject: function CanvasGraphics_paintImageMaskXObject(img) {
	      var ctx = this.ctx;
	      var width = img.width,
	          height = img.height;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      var glyph = this.processingType3;
	      if (COMPILE_TYPE3_GLYPHS && glyph && glyph.compiled === undefined) {
	        if (width <= MAX_SIZE_TO_COMPILE && height <= MAX_SIZE_TO_COMPILE) {
	          glyph.compiled = compileType3Glyph({
	            data: img.data,
	            width: width,
	            height: height
	          });
	        } else {
	          glyph.compiled = null;
	        }
	      }
	      if (glyph && glyph.compiled) {
	        glyph.compiled(ctx);
	        return;
	      }
	      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
	      var maskCtx = maskCanvas.context;
	      maskCtx.save();
	      putBinaryImageMask(maskCtx, img);
	      maskCtx.globalCompositeOperation = 'source-in';
	      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
	      maskCtx.fillRect(0, 0, width, height);
	      maskCtx.restore();
	      this.paintInlineImageXObject(maskCanvas.canvas);
	    },
	    paintImageMaskXObjectRepeat: function CanvasGraphics_paintImageMaskXObjectRepeat(imgData, scaleX, scaleY, positions) {
	      var width = imgData.width;
	      var height = imgData.height;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
	      var maskCtx = maskCanvas.context;
	      maskCtx.save();
	      putBinaryImageMask(maskCtx, imgData);
	      maskCtx.globalCompositeOperation = 'source-in';
	      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
	      maskCtx.fillRect(0, 0, width, height);
	      maskCtx.restore();
	      var ctx = this.ctx;
	      for (var i = 0, ii = positions.length; i < ii; i += 2) {
	        ctx.save();
	        ctx.transform(scaleX, 0, 0, scaleY, positions[i], positions[i + 1]);
	        ctx.scale(1, -1);
	        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
	        ctx.restore();
	      }
	    },
	    paintImageMaskXObjectGroup: function CanvasGraphics_paintImageMaskXObjectGroup(images) {
	      var ctx = this.ctx;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      for (var i = 0, ii = images.length; i < ii; i++) {
	        var image = images[i];
	        var width = image.width,
	            height = image.height;
	        var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
	        var maskCtx = maskCanvas.context;
	        maskCtx.save();
	        putBinaryImageMask(maskCtx, image);
	        maskCtx.globalCompositeOperation = 'source-in';
	        maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
	        maskCtx.fillRect(0, 0, width, height);
	        maskCtx.restore();
	        ctx.save();
	        ctx.transform.apply(ctx, image.transform);
	        ctx.scale(1, -1);
	        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
	        ctx.restore();
	      }
	    },
	    paintImageXObject: function CanvasGraphics_paintImageXObject(objId) {
	      var imgData = this.objs.get(objId);
	      if (!imgData) {
	        (0, _util.warn)('Dependent image isn\'t ready yet');
	        return;
	      }
	      this.paintInlineImageXObject(imgData);
	    },
	    paintImageXObjectRepeat: function CanvasGraphics_paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
	      var imgData = this.objs.get(objId);
	      if (!imgData) {
	        (0, _util.warn)('Dependent image isn\'t ready yet');
	        return;
	      }
	      var width = imgData.width;
	      var height = imgData.height;
	      var map = [];
	      for (var i = 0, ii = positions.length; i < ii; i += 2) {
	        map.push({
	          transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
	          x: 0,
	          y: 0,
	          w: width,
	          h: height
	        });
	      }
	      this.paintInlineImageXObjectGroup(imgData, map);
	    },
	    paintInlineImageXObject: function CanvasGraphics_paintInlineImageXObject(imgData) {
	      var width = imgData.width;
	      var height = imgData.height;
	      var ctx = this.ctx;
	      this.save();
	      ctx.scale(1 / width, -1 / height);
	      var currentTransform = ctx.mozCurrentTransformInverse;
	      var a = currentTransform[0],
	          b = currentTransform[1];
	      var widthScale = Math.max(Math.sqrt(a * a + b * b), 1);
	      var c = currentTransform[2],
	          d = currentTransform[3];
	      var heightScale = Math.max(Math.sqrt(c * c + d * d), 1);
	      var imgToPaint, tmpCanvas;
	      if (imgData instanceof HTMLElement || !imgData.data) {
	        imgToPaint = imgData;
	      } else {
	        tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', width, height);
	        var tmpCtx = tmpCanvas.context;
	        putBinaryImageData(tmpCtx, imgData);
	        imgToPaint = tmpCanvas.canvas;
	      }
	      var paintWidth = width,
	          paintHeight = height;
	      var tmpCanvasId = 'prescale1';
	      while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
	        var newWidth = paintWidth,
	            newHeight = paintHeight;
	        if (widthScale > 2 && paintWidth > 1) {
	          newWidth = Math.ceil(paintWidth / 2);
	          widthScale /= paintWidth / newWidth;
	        }
	        if (heightScale > 2 && paintHeight > 1) {
	          newHeight = Math.ceil(paintHeight / 2);
	          heightScale /= paintHeight / newHeight;
	        }
	        tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
	        tmpCtx = tmpCanvas.context;
	        tmpCtx.clearRect(0, 0, newWidth, newHeight);
	        tmpCtx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
	        imgToPaint = tmpCanvas.canvas;
	        paintWidth = newWidth;
	        paintHeight = newHeight;
	        tmpCanvasId = tmpCanvasId === 'prescale1' ? 'prescale2' : 'prescale1';
	      }
	      ctx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, -height, width, height);
	      if (this.imageLayer) {
	        var position = this.getCanvasPosition(0, -height);
	        this.imageLayer.appendImage({
	          imgData: imgData,
	          left: position[0],
	          top: position[1],
	          width: width / currentTransform[0],
	          height: height / currentTransform[3]
	        });
	      }
	      this.restore();
	    },
	    paintInlineImageXObjectGroup: function CanvasGraphics_paintInlineImageXObjectGroup(imgData, map) {
	      var ctx = this.ctx;
	      var w = imgData.width;
	      var h = imgData.height;
	      var tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', w, h);
	      var tmpCtx = tmpCanvas.context;
	      putBinaryImageData(tmpCtx, imgData);
	      for (var i = 0, ii = map.length; i < ii; i++) {
	        var entry = map[i];
	        ctx.save();
	        ctx.transform.apply(ctx, entry.transform);
	        ctx.scale(1, -1);
	        ctx.drawImage(tmpCanvas.canvas, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
	        if (this.imageLayer) {
	          var position = this.getCanvasPosition(entry.x, entry.y);
	          this.imageLayer.appendImage({
	            imgData: imgData,
	            left: position[0],
	            top: position[1],
	            width: w,
	            height: h
	          });
	        }
	        ctx.restore();
	      }
	    },
	    paintSolidColorImageMask: function CanvasGraphics_paintSolidColorImageMask() {
	      this.ctx.fillRect(0, 0, 1, 1);
	    },
	    paintXObject: function CanvasGraphics_paintXObject() {
	      (0, _util.warn)('Unsupported \'paintXObject\' command.');
	    },
	    markPoint: function CanvasGraphics_markPoint(tag) {},
	    markPointProps: function CanvasGraphics_markPointProps(tag, properties) {},
	    beginMarkedContent: function CanvasGraphics_beginMarkedContent(tag) {},
	    beginMarkedContentProps: function CanvasGraphics_beginMarkedContentProps(tag, properties) {},
	    endMarkedContent: function CanvasGraphics_endMarkedContent() {},
	    beginCompat: function CanvasGraphics_beginCompat() {},
	    endCompat: function CanvasGraphics_endCompat() {},
	    consumePath: function CanvasGraphics_consumePath() {
	      var ctx = this.ctx;
	      if (this.pendingClip) {
	        if (this.pendingClip === EO_CLIP) {
	          ctx.clip('evenodd');
	        } else {
	          ctx.clip();
	        }
	        this.pendingClip = null;
	      }
	      ctx.beginPath();
	    },
	    getSinglePixelWidth: function CanvasGraphics_getSinglePixelWidth(scale) {
	      if (this.cachedGetSinglePixelWidth === null) {
	        this.ctx.save();
	        var inverse = this.ctx.mozCurrentTransformInverse;
	        this.ctx.restore();
	        this.cachedGetSinglePixelWidth = Math.sqrt(Math.max(inverse[0] * inverse[0] + inverse[1] * inverse[1], inverse[2] * inverse[2] + inverse[3] * inverse[3]));
	      }
	      return this.cachedGetSinglePixelWidth;
	    },
	    getCanvasPosition: function CanvasGraphics_getCanvasPosition(x, y) {
	      var transform = this.ctx.mozCurrentTransform;
	      return [transform[0] * x + transform[2] * y + transform[4], transform[1] * x + transform[3] * y + transform[5]];
	    }
	  };
	  for (var op in _util.OPS) {
	    CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
	  }
	  return CanvasGraphics;
	}();
	exports.CanvasGraphics = CanvasGraphics;

/***/ },
/* 1705 */
/***/ function(module, exports) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	function getFilenameFromContentDispositionHeader(contentDisposition) {
	  var needsEncodingFixup = true;
	  var tmp = /(?:^|;)\s*filename\*\s*=\s*([^;\s]+)/i.exec(contentDisposition);
	  if (tmp) {
	    tmp = tmp[1];
	    var filename = rfc2616unquote(tmp);
	    filename = unescape(filename);
	    filename = rfc5987decode(filename);
	    filename = rfc2047decode(filename);
	    return fixupEncoding(filename);
	  }
	  tmp = rfc2231getparam(contentDisposition);
	  if (tmp) {
	    var _filename = rfc2047decode(tmp);
	    return fixupEncoding(_filename);
	  }
	  tmp = /(?:^|;)\s*filename\s*=\s*([^;\s]+)/.exec(contentDisposition);
	  if (tmp) {
	    tmp = tmp[1];
	    var _filename2 = rfc2616unquote(tmp);
	    _filename2 = rfc2047decode(_filename2);
	    return fixupEncoding(_filename2);
	  }
	  function textdecode(encoding, value) {
	    if (encoding) {
	      if (!/^[^\x00-\xFF]+$/.test(value)) {
	        return value;
	      }
	      try {
	        var decoder = new TextDecoder(encoding, { fatal: true });
	        var bytes = new Array(value.length);
	        for (var i = 0; i < value.length; ++i) {
	          bytes[i] = value.charCodeAt(0);
	        }
	        value = decoder.decode(new Uint8Array(bytes));
	        needsEncodingFixup = false;
	      } catch (e) {
	        if (/^utf-?8$/i.test(encoding)) {
	          value = decodeURIComponent(escape(value));
	          needsEncodingFixup = false;
	        }
	      }
	    }
	    return value;
	  }
	  function fixupEncoding(value) {
	    if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
	      return textdecode('utf-8', value);
	    }
	    return value;
	  }
	  function rfc2231getparam(contentDisposition) {
	    var matches = [],
	        match = void 0;
	    var iter = /(?:^|;)\s*filename\*((?!0\d)\d+)(\*?)\s*=\s*([^;\s]+)/ig;
	    while ((match = iter.exec(contentDisposition)) !== null) {
	      var _match = match,
	          _match2 = _slicedToArray(_match, 4),
	          n = _match2[1],
	          quot = _match2[2],
	          part = _match2[3];
	
	      n = parseInt(n, 10);
	      if (n in matches) {
	        if (n === 0) {
	          break;
	        }
	        continue;
	      }
	      matches[n] = [quot, part];
	    }
	    var parts = [];
	    for (var _n = 0; _n < matches.length; ++_n) {
	      if (!(_n in matches)) {
	        break;
	      }
	
	      var _matches$_n = _slicedToArray(matches[_n], 2),
	          _quot = _matches$_n[0],
	          _part = _matches$_n[1];
	
	      _part = rfc2616unquote(_part);
	      if (_quot) {
	        _part = unescape(_part);
	        if (_n === 0) {
	          _part = rfc5987decode(_part);
	        }
	      }
	      parts.push(_part);
	    }
	    return parts.join('');
	  }
	  function rfc2616unquote(value) {
	    if (value.charAt(0) === '"') {
	      var parts = value.slice(1).split('\\"');
	      for (var i = 0; i < parts.length; ++i) {
	        var quotindex = parts[i].indexOf('"');
	        if (quotindex !== -1) {
	          parts[i] = parts[i].slice(0, quotindex);
	          parts.length = i + 1;
	        }
	        parts[i] = parts[i].replace(/\\(.)/g, '$1');
	      }
	      value = parts.join('"');
	    }
	    return value;
	  }
	  function rfc5987decode(extvalue) {
	    var encodingend = extvalue.indexOf('\'');
	    if (encodingend === -1) {
	      return extvalue;
	    }
	    var encoding = extvalue.slice(0, encodingend);
	    var langvalue = extvalue.slice(encodingend + 1);
	    var value = langvalue.replace(/^[^']*'/, '');
	    return textdecode(encoding, value);
	  }
	  function rfc2047decode(value) {
	    if (value.slice(0, 2) !== '=?' || /[\x00-\x19\x80-\xff]/.test(value)) {
	      return value;
	    }
	    return value.replace(/=\?([\w\-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function (_, charset, encoding, text) {
	      if (encoding === 'q' || encoding === 'Q') {
	        text = text.replace(/_/g, ' ');
	        text = text.replace(/=([0-9a-fA-F]{2})/g, function (_, hex) {
	          return String.fromCharCode(parseInt(hex, 16));
	        });
	        return textdecode(charset, text);
	      }
	      try {
	        return atob(text);
	      } catch (e) {
	        return text;
	      }
	    });
	  }
	  return '';
	}
	exports.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;

/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFFetchStream = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __webpack_require__(14);
	
	var _network_utils = __webpack_require__(426);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function createFetchOptions(headers, withCredentials) {
	  return {
	    method: 'GET',
	    headers: headers,
	    mode: 'cors',
	    credentials: withCredentials ? 'include' : 'same-origin',
	    redirect: 'follow'
	  };
	}
	
	var PDFFetchStream = function () {
	  function PDFFetchStream(source) {
	    _classCallCheck(this, PDFFetchStream);
	
	    this.source = source;
	    this.isHttp = /^https?:/i.test(source.url);
	    this.httpHeaders = this.isHttp && source.httpHeaders || {};
	    this._fullRequestReader = null;
	    this._rangeRequestReaders = [];
	  }
	
	  _createClass(PDFFetchStream, [{
	    key: 'getFullReader',
	    value: function getFullReader() {
	      (0, _util.assert)(!this._fullRequestReader);
	      this._fullRequestReader = new PDFFetchStreamReader(this);
	      return this._fullRequestReader;
	    }
	  }, {
	    key: 'getRangeReader',
	    value: function getRangeReader(begin, end) {
	      var reader = new PDFFetchStreamRangeReader(this, begin, end);
	      this._rangeRequestReaders.push(reader);
	      return reader;
	    }
	  }, {
	    key: 'cancelAllRequests',
	    value: function cancelAllRequests(reason) {
	      if (this._fullRequestReader) {
	        this._fullRequestReader.cancel(reason);
	      }
	      var readers = this._rangeRequestReaders.slice(0);
	      readers.forEach(function (reader) {
	        reader.cancel(reason);
	      });
	    }
	  }]);
	
	  return PDFFetchStream;
	}();
	
	var PDFFetchStreamReader = function () {
	  function PDFFetchStreamReader(stream) {
	    var _this = this;
	
	    _classCallCheck(this, PDFFetchStreamReader);
	
	    this._stream = stream;
	    this._reader = null;
	    this._loaded = 0;
	    this._filename = null;
	    var source = stream.source;
	    this._withCredentials = source.withCredentials;
	    this._contentLength = source.length;
	    this._headersCapability = (0, _util.createPromiseCapability)();
	    this._disableRange = source.disableRange;
	    this._rangeChunkSize = source.rangeChunkSize;
	    if (!this._rangeChunkSize && !this._disableRange) {
	      this._disableRange = true;
	    }
	    this._isRangeSupported = !source.disableRange;
	    this._isStreamingSupported = !source.disableStream;
	    this._headers = new Headers();
	    for (var property in this._stream.httpHeaders) {
	      var value = this._stream.httpHeaders[property];
	      if (typeof value === 'undefined') {
	        continue;
	      }
	      this._headers.append(property, value);
	    }
	    var url = source.url;
	    fetch(url, createFetchOptions(this._headers, this._withCredentials)).then(function (response) {
	      if (!(0, _network_utils.validateResponseStatus)(response.status)) {
	        throw (0, _network_utils.createResponseStatusError)(response.status, url);
	      }
	      _this._reader = response.body.getReader();
	      _this._headersCapability.resolve();
	      var getResponseHeader = function getResponseHeader(name) {
	        return response.headers.get(name);
	      };
	
	      var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
	        getResponseHeader: getResponseHeader,
	        isHttp: _this._stream.isHttp,
	        rangeChunkSize: _this._rangeChunkSize,
	        disableRange: _this._disableRange
	      }),
	          allowRangeRequests = _validateRangeRequest.allowRangeRequests,
	          suggestedLength = _validateRangeRequest.suggestedLength;
	
	      _this._contentLength = suggestedLength;
	      _this._isRangeSupported = allowRangeRequests;
	      _this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
	      if (!_this._isStreamingSupported && _this._isRangeSupported) {
	        _this.cancel(new _util.AbortException('streaming is disabled'));
	      }
	    }).catch(this._headersCapability.reject);
	    this.onProgress = null;
	  }
	
	  _createClass(PDFFetchStreamReader, [{
	    key: 'read',
	    value: function read() {
	      var _this2 = this;
	
	      return this._headersCapability.promise.then(function () {
	        return _this2._reader.read().then(function (_ref) {
	          var value = _ref.value,
	              done = _ref.done;
	
	          if (done) {
	            return Promise.resolve({
	              value: value,
	              done: done
	            });
	          }
	          _this2._loaded += value.byteLength;
	          if (_this2.onProgress) {
	            _this2.onProgress({
	              loaded: _this2._loaded,
	              total: _this2._contentLength
	            });
	          }
	          var buffer = new Uint8Array(value).buffer;
	          return Promise.resolve({
	            value: buffer,
	            done: false
	          });
	        });
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel(reason) {
	      if (this._reader) {
	        this._reader.cancel(reason);
	      }
	    }
	  }, {
	    key: 'headersReady',
	    get: function get() {
	      return this._headersCapability.promise;
	    }
	  }, {
	    key: 'filename',
	    get: function get() {
	      return this._filename;
	    }
	  }, {
	    key: 'contentLength',
	    get: function get() {
	      return this._contentLength;
	    }
	  }, {
	    key: 'isRangeSupported',
	    get: function get() {
	      return this._isRangeSupported;
	    }
	  }, {
	    key: 'isStreamingSupported',
	    get: function get() {
	      return this._isStreamingSupported;
	    }
	  }]);
	
	  return PDFFetchStreamReader;
	}();
	
	var PDFFetchStreamRangeReader = function () {
	  function PDFFetchStreamRangeReader(stream, begin, end) {
	    var _this3 = this;
	
	    _classCallCheck(this, PDFFetchStreamRangeReader);
	
	    this._stream = stream;
	    this._reader = null;
	    this._loaded = 0;
	    var source = stream.source;
	    this._withCredentials = source.withCredentials;
	    this._readCapability = (0, _util.createPromiseCapability)();
	    this._isStreamingSupported = !source.disableStream;
	    this._headers = new Headers();
	    for (var property in this._stream.httpHeaders) {
	      var value = this._stream.httpHeaders[property];
	      if (typeof value === 'undefined') {
	        continue;
	      }
	      this._headers.append(property, value);
	    }
	    var rangeStr = begin + '-' + (end - 1);
	    this._headers.append('Range', 'bytes=' + rangeStr);
	    var url = source.url;
	    fetch(url, createFetchOptions(this._headers, this._withCredentials)).then(function (response) {
	      if (!(0, _network_utils.validateResponseStatus)(response.status)) {
	        throw (0, _network_utils.createResponseStatusError)(response.status, url);
	      }
	      _this3._readCapability.resolve();
	      _this3._reader = response.body.getReader();
	    });
	    this.onProgress = null;
	  }
	
	  _createClass(PDFFetchStreamRangeReader, [{
	    key: 'read',
	    value: function read() {
	      var _this4 = this;
	
	      return this._readCapability.promise.then(function () {
	        return _this4._reader.read().then(function (_ref2) {
	          var value = _ref2.value,
	              done = _ref2.done;
	
	          if (done) {
	            return Promise.resolve({
	              value: value,
	              done: done
	            });
	          }
	          _this4._loaded += value.byteLength;
	          if (_this4.onProgress) {
	            _this4.onProgress({ loaded: _this4._loaded });
	          }
	          var buffer = new Uint8Array(value).buffer;
	          return Promise.resolve({
	            value: buffer,
	            done: false
	          });
	        });
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel(reason) {
	      if (this._reader) {
	        this._reader.cancel(reason);
	      }
	    }
	  }, {
	    key: 'isStreamingSupported',
	    get: function get() {
	      return this._isStreamingSupported;
	    }
	  }]);
	
	  return PDFFetchStreamRangeReader;
	}();
	
	exports.PDFFetchStream = PDFFetchStream;

/***/ },
/* 1707 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontLoader = exports.FontFaceObject = undefined;
	
	var _util = __webpack_require__(14);
	
	function FontLoader(docId) {
	  this.docId = docId;
	  this.styleElement = null;
	  this.nativeFontFaces = [];
	  this.loadTestFontId = 0;
	  this.loadingContext = {
	    requests: [],
	    nextRequestId: 0
	  };
	}
	FontLoader.prototype = {
	  insertRule: function fontLoaderInsertRule(rule) {
	    var styleElement = this.styleElement;
	    if (!styleElement) {
	      styleElement = this.styleElement = document.createElement('style');
	      styleElement.id = 'PDFJS_FONT_STYLE_TAG_' + this.docId;
	      document.documentElement.getElementsByTagName('head')[0].appendChild(styleElement);
	    }
	    var styleSheet = styleElement.sheet;
	    styleSheet.insertRule(rule, styleSheet.cssRules.length);
	  },
	  clear: function fontLoaderClear() {
	    if (this.styleElement) {
	      this.styleElement.remove();
	      this.styleElement = null;
	    }
	    this.nativeFontFaces.forEach(function (nativeFontFace) {
	      document.fonts.delete(nativeFontFace);
	    });
	    this.nativeFontFaces.length = 0;
	  }
	};
	{
	  var getLoadTestFont = function getLoadTestFont() {
	    return atob('T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQ' + 'AABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwA' + 'AAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbm' + 'FtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAA' + 'AADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6A' + 'ABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAA' + 'MQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAA' + 'AAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAA' + 'AAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQ' + 'AAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMA' + 'AQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAA' + 'EAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAA' + 'AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAA' + 'AAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgc' + 'A/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWF' + 'hYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQA' + 'AAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAg' + 'ABAAAAAAAAAAAD6AAAAAAAAA==');
	  };
	  Object.defineProperty(FontLoader.prototype, 'loadTestFont', {
	    get: function get() {
	      return (0, _util.shadow)(this, 'loadTestFont', getLoadTestFont());
	    },
	
	    configurable: true
	  });
	  FontLoader.prototype.addNativeFontFace = function fontLoader_addNativeFontFace(nativeFontFace) {
	    this.nativeFontFaces.push(nativeFontFace);
	    document.fonts.add(nativeFontFace);
	  };
	  FontLoader.prototype.bind = function fontLoaderBind(fonts, callback) {
	    var rules = [];
	    var fontsToLoad = [];
	    var fontLoadPromises = [];
	    var getNativeFontPromise = function getNativeFontPromise(nativeFontFace) {
	      return nativeFontFace.loaded.catch(function (e) {
	        (0, _util.warn)('Failed to load font "' + nativeFontFace.family + '": ' + e);
	      });
	    };
	    var isFontLoadingAPISupported = FontLoader.isFontLoadingAPISupported && !FontLoader.isSyncFontLoadingSupported;
	    for (var i = 0, ii = fonts.length; i < ii; i++) {
	      var font = fonts[i];
	      if (font.attached || font.loading === false) {
	        continue;
	      }
	      font.attached = true;
	      if (isFontLoadingAPISupported) {
	        var nativeFontFace = font.createNativeFontFace();
	        if (nativeFontFace) {
	          this.addNativeFontFace(nativeFontFace);
	          fontLoadPromises.push(getNativeFontPromise(nativeFontFace));
	        }
	      } else {
	        var rule = font.createFontFaceRule();
	        if (rule) {
	          this.insertRule(rule);
	          rules.push(rule);
	          fontsToLoad.push(font);
	        }
	      }
	    }
	    var request = this.queueLoadingCallback(callback);
	    if (isFontLoadingAPISupported) {
	      Promise.all(fontLoadPromises).then(function () {
	        request.complete();
	      });
	    } else if (rules.length > 0 && !FontLoader.isSyncFontLoadingSupported) {
	      this.prepareFontLoadEvent(rules, fontsToLoad, request);
	    } else {
	      request.complete();
	    }
	  };
	  FontLoader.prototype.queueLoadingCallback = function FontLoader_queueLoadingCallback(callback) {
	    function LoadLoader_completeRequest() {
	      (0, _util.assert)(!request.end, 'completeRequest() cannot be called twice');
	      request.end = Date.now();
	      while (context.requests.length > 0 && context.requests[0].end) {
	        var otherRequest = context.requests.shift();
	        setTimeout(otherRequest.callback, 0);
	      }
	    }
	    var context = this.loadingContext;
	    var requestId = 'pdfjs-font-loading-' + context.nextRequestId++;
	    var request = {
	      id: requestId,
	      complete: LoadLoader_completeRequest,
	      callback: callback,
	      started: Date.now()
	    };
	    context.requests.push(request);
	    return request;
	  };
	  FontLoader.prototype.prepareFontLoadEvent = function fontLoaderPrepareFontLoadEvent(rules, fonts, request) {
	    function int32(data, offset) {
	      return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
	    }
	    function spliceString(s, offset, remove, insert) {
	      var chunk1 = s.substr(0, offset);
	      var chunk2 = s.substr(offset + remove);
	      return chunk1 + insert + chunk2;
	    }
	    var i, ii;
	    var canvas = document.createElement('canvas');
	    canvas.width = 1;
	    canvas.height = 1;
	    var ctx = canvas.getContext('2d');
	    var called = 0;
	    function isFontReady(name, callback) {
	      called++;
	      if (called > 30) {
	        (0, _util.warn)('Load test font never loaded.');
	        callback();
	        return;
	      }
	      ctx.font = '30px ' + name;
	      ctx.fillText('.', 0, 20);
	      var imageData = ctx.getImageData(0, 0, 1, 1);
	      if (imageData.data[3] > 0) {
	        callback();
	        return;
	      }
	      setTimeout(isFontReady.bind(null, name, callback));
	    }
	    var loadTestFontId = 'lt' + Date.now() + this.loadTestFontId++;
	    var data = this.loadTestFont;
	    var COMMENT_OFFSET = 976;
	    data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
	    var CFF_CHECKSUM_OFFSET = 16;
	    var XXXX_VALUE = 0x58585858;
	    var checksum = int32(data, CFF_CHECKSUM_OFFSET);
	    for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
	      checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
	    }
	    if (i < loadTestFontId.length) {
	      checksum = checksum - XXXX_VALUE + int32(loadTestFontId + 'XXX', i) | 0;
	    }
	    data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
	    var url = 'url(data:font/opentype;base64,' + btoa(data) + ');';
	    var rule = '@font-face { font-family:"' + loadTestFontId + '";src:' + url + '}';
	    this.insertRule(rule);
	    var names = [];
	    for (i = 0, ii = fonts.length; i < ii; i++) {
	      names.push(fonts[i].loadedName);
	    }
	    names.push(loadTestFontId);
	    var div = document.createElement('div');
	    div.setAttribute('style', 'visibility: hidden;' + 'width: 10px; height: 10px;' + 'position: absolute; top: 0px; left: 0px;');
	    for (i = 0, ii = names.length; i < ii; ++i) {
	      var span = document.createElement('span');
	      span.textContent = 'Hi';
	      span.style.fontFamily = names[i];
	      div.appendChild(span);
	    }
	    document.body.appendChild(div);
	    isFontReady(loadTestFontId, function () {
	      document.body.removeChild(div);
	      request.complete();
	    });
	  };
	}
	{
	  FontLoader.isFontLoadingAPISupported = typeof document !== 'undefined' && !!document.fonts;
	}
	{
	  var isSyncFontLoadingSupported = function isSyncFontLoadingSupported() {
	    if (typeof navigator === 'undefined') {
	      return true;
	    }
	    var supported = false;
	    var m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
	    if (m && m[1] >= 14) {
	      supported = true;
	    }
	    return supported;
	  };
	  Object.defineProperty(FontLoader, 'isSyncFontLoadingSupported', {
	    get: function get() {
	      return (0, _util.shadow)(FontLoader, 'isSyncFontLoadingSupported', isSyncFontLoadingSupported());
	    },
	
	    enumerable: true,
	    configurable: true
	  });
	}
	var IsEvalSupportedCached = {
	  get value() {
	    return (0, _util.shadow)(this, 'value', (0, _util.isEvalSupported)());
	  }
	};
	var FontFaceObject = function FontFaceObjectClosure() {
	  function FontFaceObject(translatedData, options) {
	    this.compiledGlyphs = Object.create(null);
	    for (var i in translatedData) {
	      this[i] = translatedData[i];
	    }
	    this.options = options;
	  }
	  FontFaceObject.prototype = {
	    createNativeFontFace: function FontFaceObject_createNativeFontFace() {
	      if (!this.data) {
	        return null;
	      }
	      if (this.options.disableFontFace) {
	        this.disableFontFace = true;
	        return null;
	      }
	      var nativeFontFace = new FontFace(this.loadedName, this.data, {});
	      if (this.options.fontRegistry) {
	        this.options.fontRegistry.registerFont(this);
	      }
	      return nativeFontFace;
	    },
	    createFontFaceRule: function FontFaceObject_createFontFaceRule() {
	      if (!this.data) {
	        return null;
	      }
	      if (this.options.disableFontFace) {
	        this.disableFontFace = true;
	        return null;
	      }
	      var data = (0, _util.bytesToString)(new Uint8Array(this.data));
	      var fontName = this.loadedName;
	      var url = 'url(data:' + this.mimetype + ';base64,' + btoa(data) + ');';
	      var rule = '@font-face { font-family:"' + fontName + '";src:' + url + '}';
	      if (this.options.fontRegistry) {
	        this.options.fontRegistry.registerFont(this, url);
	      }
	      return rule;
	    },
	    getPathGenerator: function FontFaceObject_getPathGenerator(objs, character) {
	      if (!(character in this.compiledGlyphs)) {
	        var cmds = objs.get(this.loadedName + '_path_' + character);
	        var current, i, len;
	        if (this.options.isEvalSupported && IsEvalSupportedCached.value) {
	          var args,
	              js = '';
	          for (i = 0, len = cmds.length; i < len; i++) {
	            current = cmds[i];
	            if (current.args !== undefined) {
	              args = current.args.join(',');
	            } else {
	              args = '';
	            }
	            js += 'c.' + current.cmd + '(' + args + ');\n';
	          }
	          this.compiledGlyphs[character] = new Function('c', 'size', js);
	        } else {
	          this.compiledGlyphs[character] = function (c, size) {
	            for (i = 0, len = cmds.length; i < len; i++) {
	              current = cmds[i];
	              if (current.cmd === 'scale') {
	                current.args = [size, -size];
	              }
	              c[current.cmd].apply(c, current.args);
	            }
	          };
	        }
	      }
	      return this.compiledGlyphs[character];
	    }
	  };
	  return FontFaceObject;
	}();
	exports.FontFaceObject = FontFaceObject;
	exports.FontLoader = FontLoader;

/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFJS = exports.globalScope = undefined;
	
	var _dom_utils = __webpack_require__(144);
	
	var _util = __webpack_require__(14);
	
	var _api = __webpack_require__(824);
	
	var _annotation_layer = __webpack_require__(823);
	
	var _global_scope = __webpack_require__(220);
	
	var _global_scope2 = _interopRequireDefault(_global_scope);
	
	var _metadata = __webpack_require__(825);
	
	var _text_layer = __webpack_require__(827);
	
	var _svg = __webpack_require__(826);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (!_global_scope2.default.PDFJS) {
	  _global_scope2.default.PDFJS = {};
	}
	var PDFJS = _global_scope2.default.PDFJS;
	{
	  PDFJS.version = '2.0.305';
	  PDFJS.build = '9c6a8801';
	}
	PDFJS.pdfBug = false;
	if (PDFJS.verbosity !== undefined) {
	  (0, _util.setVerbosityLevel)(PDFJS.verbosity);
	}
	delete PDFJS.verbosity;
	Object.defineProperty(PDFJS, 'verbosity', {
	  get: function get() {
	    return (0, _util.getVerbosityLevel)();
	  },
	  set: function set(level) {
	    (0, _util.setVerbosityLevel)(level);
	  },
	
	  enumerable: true,
	  configurable: true
	});
	PDFJS.VERBOSITY_LEVELS = _util.VERBOSITY_LEVELS;
	PDFJS.OPS = _util.OPS;
	PDFJS.UNSUPPORTED_FEATURES = _util.UNSUPPORTED_FEATURES;
	PDFJS.isValidUrl = _dom_utils.isValidUrl;
	PDFJS.shadow = _util.shadow;
	PDFJS.createBlob = _util.createBlob;
	PDFJS.createObjectURL = function PDFJS_createObjectURL(data, contentType) {
	  return (0, _util.createObjectURL)(data, contentType, PDFJS.disableCreateObjectURL);
	};
	Object.defineProperty(PDFJS, 'isLittleEndian', {
	  configurable: true,
	  get: function PDFJS_isLittleEndian() {
	    return (0, _util.shadow)(PDFJS, 'isLittleEndian', (0, _util.isLittleEndian)());
	  }
	});
	PDFJS.removeNullCharacters = _util.removeNullCharacters;
	PDFJS.PasswordResponses = _util.PasswordResponses;
	PDFJS.PasswordException = _util.PasswordException;
	PDFJS.UnknownErrorException = _util.UnknownErrorException;
	PDFJS.InvalidPDFException = _util.InvalidPDFException;
	PDFJS.MissingPDFException = _util.MissingPDFException;
	PDFJS.UnexpectedResponseException = _util.UnexpectedResponseException;
	PDFJS.Util = _util.Util;
	PDFJS.PageViewport = _util.PageViewport;
	PDFJS.createPromiseCapability = _util.createPromiseCapability;
	PDFJS.maxImageSize = PDFJS.maxImageSize === undefined ? -1 : PDFJS.maxImageSize;
	PDFJS.cMapUrl = PDFJS.cMapUrl === undefined ? null : PDFJS.cMapUrl;
	PDFJS.cMapPacked = PDFJS.cMapPacked === undefined ? false : PDFJS.cMapPacked;
	PDFJS.disableFontFace = PDFJS.disableFontFace === undefined ? false : PDFJS.disableFontFace;
	PDFJS.imageResourcesPath = PDFJS.imageResourcesPath === undefined ? '' : PDFJS.imageResourcesPath;
	PDFJS.disableWorker = PDFJS.disableWorker === undefined ? false : PDFJS.disableWorker;
	PDFJS.workerSrc = PDFJS.workerSrc === undefined ? null : PDFJS.workerSrc;
	PDFJS.workerPort = PDFJS.workerPort === undefined ? null : PDFJS.workerPort;
	PDFJS.disableRange = PDFJS.disableRange === undefined ? false : PDFJS.disableRange;
	PDFJS.disableStream = PDFJS.disableStream === undefined ? false : PDFJS.disableStream;
	PDFJS.disableAutoFetch = PDFJS.disableAutoFetch === undefined ? false : PDFJS.disableAutoFetch;
	PDFJS.pdfBug = PDFJS.pdfBug === undefined ? false : PDFJS.pdfBug;
	PDFJS.postMessageTransfers = PDFJS.postMessageTransfers === undefined ? true : PDFJS.postMessageTransfers;
	PDFJS.disableCreateObjectURL = PDFJS.disableCreateObjectURL === undefined ? false : PDFJS.disableCreateObjectURL;
	PDFJS.disableWebGL = PDFJS.disableWebGL === undefined ? true : PDFJS.disableWebGL;
	PDFJS.externalLinkTarget = PDFJS.externalLinkTarget === undefined ? _dom_utils.LinkTarget.NONE : PDFJS.externalLinkTarget;
	PDFJS.externalLinkRel = PDFJS.externalLinkRel === undefined ? _dom_utils.DEFAULT_LINK_REL : PDFJS.externalLinkRel;
	PDFJS.isEvalSupported = PDFJS.isEvalSupported === undefined ? true : PDFJS.isEvalSupported;
	PDFJS.getDocument = _api.getDocument;
	PDFJS.LoopbackPort = _api.LoopbackPort;
	PDFJS.PDFDataRangeTransport = _api.PDFDataRangeTransport;
	PDFJS.PDFWorker = _api.PDFWorker;
	PDFJS.LinkTarget = _dom_utils.LinkTarget;
	PDFJS.addLinkAttributes = _dom_utils.addLinkAttributes;
	PDFJS.getFilenameFromUrl = _dom_utils.getFilenameFromUrl;
	PDFJS.isExternalLinkTargetSet = _dom_utils.isExternalLinkTargetSet;
	PDFJS.AnnotationLayer = _annotation_layer.AnnotationLayer;
	PDFJS.renderTextLayer = _text_layer.renderTextLayer;
	PDFJS.Metadata = _metadata.Metadata;
	PDFJS.SVGGraphics = _svg.SVGGraphics;
	exports.globalScope = _global_scope2.default;
	exports.PDFJS = PDFJS;

/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NetworkManager = exports.PDFNetworkStream = undefined;
	
	var _util = __webpack_require__(14);
	
	var _network_utils = __webpack_require__(426);
	
	var _global_scope = __webpack_require__(220);
	
	var _global_scope2 = _interopRequireDefault(_global_scope);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	var OK_RESPONSE = 200;
	var PARTIAL_CONTENT_RESPONSE = 206;
	function NetworkManager(url, args) {
	  this.url = url;
	  args = args || {};
	  this.isHttp = /^https?:/i.test(url);
	  this.httpHeaders = this.isHttp && args.httpHeaders || {};
	  this.withCredentials = args.withCredentials || false;
	  this.getXhr = args.getXhr || function NetworkManager_getXhr() {
	    return new XMLHttpRequest();
	  };
	  this.currXhrId = 0;
	  this.pendingRequests = Object.create(null);
	  this.loadedRequests = Object.create(null);
	}
	function getArrayBuffer(xhr) {
	  var data = xhr.response;
	  if (typeof data !== 'string') {
	    return data;
	  }
	  var array = (0, _util.stringToBytes)(data);
	  return array.buffer;
	}
	var supportsMozChunked = function supportsMozChunkedClosure() {
	  try {
	    var x = new XMLHttpRequest();
	    x.open('GET', _global_scope2.default.location.href);
	    x.responseType = 'moz-chunked-arraybuffer';
	    return x.responseType === 'moz-chunked-arraybuffer';
	  } catch (e) {
	    return false;
	  }
	}();
	NetworkManager.prototype = {
	  requestRange: function NetworkManager_requestRange(begin, end, listeners) {
	    var args = {
	      begin: begin,
	      end: end
	    };
	    for (var prop in listeners) {
	      args[prop] = listeners[prop];
	    }
	    return this.request(args);
	  },
	  requestFull: function NetworkManager_requestFull(listeners) {
	    return this.request(listeners);
	  },
	  request: function NetworkManager_request(args) {
	    var xhr = this.getXhr();
	    var xhrId = this.currXhrId++;
	    var pendingRequest = this.pendingRequests[xhrId] = { xhr: xhr };
	    xhr.open('GET', this.url);
	    xhr.withCredentials = this.withCredentials;
	    for (var property in this.httpHeaders) {
	      var value = this.httpHeaders[property];
	      if (typeof value === 'undefined') {
	        continue;
	      }
	      xhr.setRequestHeader(property, value);
	    }
	    if (this.isHttp && 'begin' in args && 'end' in args) {
	      var rangeStr = args.begin + '-' + (args.end - 1);
	      xhr.setRequestHeader('Range', 'bytes=' + rangeStr);
	      pendingRequest.expectedStatus = 206;
	    } else {
	      pendingRequest.expectedStatus = 200;
	    }
	    var useMozChunkedLoading = supportsMozChunked && !!args.onProgressiveData;
	    if (useMozChunkedLoading) {
	      xhr.responseType = 'moz-chunked-arraybuffer';
	      pendingRequest.onProgressiveData = args.onProgressiveData;
	      pendingRequest.mozChunked = true;
	    } else {
	      xhr.responseType = 'arraybuffer';
	    }
	    if (args.onError) {
	      xhr.onerror = function (evt) {
	        args.onError(xhr.status);
	      };
	    }
	    xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
	    xhr.onprogress = this.onProgress.bind(this, xhrId);
	    pendingRequest.onHeadersReceived = args.onHeadersReceived;
	    pendingRequest.onDone = args.onDone;
	    pendingRequest.onError = args.onError;
	    pendingRequest.onProgress = args.onProgress;
	    xhr.send(null);
	    return xhrId;
	  },
	  onProgress: function NetworkManager_onProgress(xhrId, evt) {
	    var pendingRequest = this.pendingRequests[xhrId];
	    if (!pendingRequest) {
	      return;
	    }
	    if (pendingRequest.mozChunked) {
	      var chunk = getArrayBuffer(pendingRequest.xhr);
	      pendingRequest.onProgressiveData(chunk);
	    }
	    var onProgress = pendingRequest.onProgress;
	    if (onProgress) {
	      onProgress(evt);
	    }
	  },
	  onStateChange: function NetworkManager_onStateChange(xhrId, evt) {
	    var pendingRequest = this.pendingRequests[xhrId];
	    if (!pendingRequest) {
	      return;
	    }
	    var xhr = pendingRequest.xhr;
	    if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
	      pendingRequest.onHeadersReceived();
	      delete pendingRequest.onHeadersReceived;
	    }
	    if (xhr.readyState !== 4) {
	      return;
	    }
	    if (!(xhrId in this.pendingRequests)) {
	      return;
	    }
	    delete this.pendingRequests[xhrId];
	    if (xhr.status === 0 && this.isHttp) {
	      if (pendingRequest.onError) {
	        pendingRequest.onError(xhr.status);
	      }
	      return;
	    }
	    var xhrStatus = xhr.status || OK_RESPONSE;
	    var ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
	    if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
	      if (pendingRequest.onError) {
	        pendingRequest.onError(xhr.status);
	      }
	      return;
	    }
	    this.loadedRequests[xhrId] = true;
	    var chunk = getArrayBuffer(xhr);
	    if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
	      var rangeHeader = xhr.getResponseHeader('Content-Range');
	      var matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
	      var begin = parseInt(matches[1], 10);
	      pendingRequest.onDone({
	        begin: begin,
	        chunk: chunk
	      });
	    } else if (pendingRequest.onProgressiveData) {
	      pendingRequest.onDone(null);
	    } else if (chunk) {
	      pendingRequest.onDone({
	        begin: 0,
	        chunk: chunk
	      });
	    } else if (pendingRequest.onError) {
	      pendingRequest.onError(xhr.status);
	    }
	  },
	  hasPendingRequests: function NetworkManager_hasPendingRequests() {
	    for (var xhrId in this.pendingRequests) {
	      return true;
	    }
	    return false;
	  },
	  getRequestXhr: function NetworkManager_getXhr(xhrId) {
	    return this.pendingRequests[xhrId].xhr;
	  },
	  isStreamingRequest: function NetworkManager_isStreamingRequest(xhrId) {
	    return !!this.pendingRequests[xhrId].onProgressiveData;
	  },
	  isPendingRequest: function NetworkManager_isPendingRequest(xhrId) {
	    return xhrId in this.pendingRequests;
	  },
	  isLoadedRequest: function NetworkManager_isLoadedRequest(xhrId) {
	    return xhrId in this.loadedRequests;
	  },
	  abortAllRequests: function NetworkManager_abortAllRequests() {
	    for (var xhrId in this.pendingRequests) {
	      this.abortRequest(xhrId | 0);
	    }
	  },
	  abortRequest: function NetworkManager_abortRequest(xhrId) {
	    var xhr = this.pendingRequests[xhrId].xhr;
	    delete this.pendingRequests[xhrId];
	    xhr.abort();
	  }
	};
	function PDFNetworkStream(source) {
	  this._source = source;
	  this._manager = new NetworkManager(source.url, {
	    httpHeaders: source.httpHeaders,
	    withCredentials: source.withCredentials
	  });
	  this._rangeChunkSize = source.rangeChunkSize;
	  this._fullRequestReader = null;
	  this._rangeRequestReaders = [];
	}
	PDFNetworkStream.prototype = {
	  _onRangeRequestReaderClosed: function PDFNetworkStream_onRangeRequestReaderClosed(reader) {
	    var i = this._rangeRequestReaders.indexOf(reader);
	    if (i >= 0) {
	      this._rangeRequestReaders.splice(i, 1);
	    }
	  },
	  getFullReader: function PDFNetworkStream_getFullReader() {
	    (0, _util.assert)(!this._fullRequestReader);
	    this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
	    return this._fullRequestReader;
	  },
	  getRangeReader: function PDFNetworkStream_getRangeReader(begin, end) {
	    var reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
	    reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
	    this._rangeRequestReaders.push(reader);
	    return reader;
	  },
	  cancelAllRequests: function PDFNetworkStream_cancelAllRequests(reason) {
	    if (this._fullRequestReader) {
	      this._fullRequestReader.cancel(reason);
	    }
	    var readers = this._rangeRequestReaders.slice(0);
	    readers.forEach(function (reader) {
	      reader.cancel(reason);
	    });
	  }
	};
	function PDFNetworkStreamFullRequestReader(manager, source) {
	  this._manager = manager;
	  var args = {
	    onHeadersReceived: this._onHeadersReceived.bind(this),
	    onProgressiveData: source.disableStream ? null : this._onProgressiveData.bind(this),
	    onDone: this._onDone.bind(this),
	    onError: this._onError.bind(this),
	    onProgress: this._onProgress.bind(this)
	  };
	  this._url = source.url;
	  this._fullRequestId = manager.requestFull(args);
	  this._headersReceivedCapability = (0, _util.createPromiseCapability)();
	  this._disableRange = source.disableRange || false;
	  this._contentLength = source.length;
	  this._rangeChunkSize = source.rangeChunkSize;
	  if (!this._rangeChunkSize && !this._disableRange) {
	    this._disableRange = true;
	  }
	  this._isStreamingSupported = false;
	  this._isRangeSupported = false;
	  this._cachedChunks = [];
	  this._requests = [];
	  this._done = false;
	  this._storedError = undefined;
	  this._filename = null;
	  this.onProgress = null;
	}
	PDFNetworkStreamFullRequestReader.prototype = {
	  _onHeadersReceived: function PDFNetworkStreamFullRequestReader_onHeadersReceived() {
	    var fullRequestXhrId = this._fullRequestId;
	    var fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
	    var getResponseHeader = function getResponseHeader(name) {
	      return fullRequestXhr.getResponseHeader(name);
	    };
	
	    var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
	      getResponseHeader: getResponseHeader,
	      isHttp: this._manager.isHttp,
	      rangeChunkSize: this._rangeChunkSize,
	      disableRange: this._disableRange
	    }),
	        allowRangeRequests = _validateRangeRequest.allowRangeRequests,
	        suggestedLength = _validateRangeRequest.suggestedLength;
	
	    this._contentLength = suggestedLength || this._contentLength;
	    if (allowRangeRequests) {
	      this._isRangeSupported = true;
	    }
	    this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
	    var networkManager = this._manager;
	    if (networkManager.isStreamingRequest(fullRequestXhrId)) {
	      this._isStreamingSupported = true;
	    } else if (this._isRangeSupported) {
	      networkManager.abortRequest(fullRequestXhrId);
	    }
	    this._headersReceivedCapability.resolve();
	  },
	  _onProgressiveData: function PDFNetworkStreamFullRequestReader_onProgressiveData(chunk) {
	    if (this._requests.length > 0) {
	      var requestCapability = this._requests.shift();
	      requestCapability.resolve({
	        value: chunk,
	        done: false
	      });
	    } else {
	      this._cachedChunks.push(chunk);
	    }
	  },
	  _onDone: function PDFNetworkStreamFullRequestReader_onDone(args) {
	    if (args) {
	      this._onProgressiveData(args.chunk);
	    }
	    this._done = true;
	    if (this._cachedChunks.length > 0) {
	      return;
	    }
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	  },
	  _onError: function PDFNetworkStreamFullRequestReader_onError(status) {
	    var url = this._url;
	    var exception = (0, _network_utils.createResponseStatusError)(status, url);
	    this._storedError = exception;
	    this._headersReceivedCapability.reject(exception);
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.reject(exception);
	    });
	    this._requests = [];
	    this._cachedChunks = [];
	  },
	  _onProgress: function PDFNetworkStreamFullRequestReader_onProgress(data) {
	    if (this.onProgress) {
	      this.onProgress({
	        loaded: data.loaded,
	        total: data.lengthComputable ? data.total : this._contentLength
	      });
	    }
	  },
	  get filename() {
	    return this._filename;
	  },
	  get isRangeSupported() {
	    return this._isRangeSupported;
	  },
	  get isStreamingSupported() {
	    return this._isStreamingSupported;
	  },
	  get contentLength() {
	    return this._contentLength;
	  },
	  get headersReady() {
	    return this._headersReceivedCapability.promise;
	  },
	  read: function PDFNetworkStreamFullRequestReader_read() {
	    if (this._storedError) {
	      return Promise.reject(this._storedError);
	    }
	    if (this._cachedChunks.length > 0) {
	      var chunk = this._cachedChunks.shift();
	      return Promise.resolve({
	        value: chunk,
	        done: false
	      });
	    }
	    if (this._done) {
	      return Promise.resolve({
	        value: undefined,
	        done: true
	      });
	    }
	    var requestCapability = (0, _util.createPromiseCapability)();
	    this._requests.push(requestCapability);
	    return requestCapability.promise;
	  },
	  cancel: function PDFNetworkStreamFullRequestReader_cancel(reason) {
	    this._done = true;
	    this._headersReceivedCapability.reject(reason);
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	    if (this._manager.isPendingRequest(this._fullRequestId)) {
	      this._manager.abortRequest(this._fullRequestId);
	    }
	    this._fullRequestReader = null;
	  }
	};
	function PDFNetworkStreamRangeRequestReader(manager, begin, end) {
	  this._manager = manager;
	  var args = {
	    onDone: this._onDone.bind(this),
	    onProgress: this._onProgress.bind(this)
	  };
	  this._requestId = manager.requestRange(begin, end, args);
	  this._requests = [];
	  this._queuedChunk = null;
	  this._done = false;
	  this.onProgress = null;
	  this.onClosed = null;
	}
	PDFNetworkStreamRangeRequestReader.prototype = {
	  _close: function PDFNetworkStreamRangeRequestReader_close() {
	    if (this.onClosed) {
	      this.onClosed(this);
	    }
	  },
	  _onDone: function PDFNetworkStreamRangeRequestReader_onDone(data) {
	    var chunk = data.chunk;
	    if (this._requests.length > 0) {
	      var requestCapability = this._requests.shift();
	      requestCapability.resolve({
	        value: chunk,
	        done: false
	      });
	    } else {
	      this._queuedChunk = chunk;
	    }
	    this._done = true;
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	    this._close();
	  },
	  _onProgress: function PDFNetworkStreamRangeRequestReader_onProgress(evt) {
	    if (!this.isStreamingSupported && this.onProgress) {
	      this.onProgress({ loaded: evt.loaded });
	    }
	  },
	  get isStreamingSupported() {
	    return false;
	  },
	  read: function PDFNetworkStreamRangeRequestReader_read() {
	    if (this._queuedChunk !== null) {
	      var chunk = this._queuedChunk;
	      this._queuedChunk = null;
	      return Promise.resolve({
	        value: chunk,
	        done: false
	      });
	    }
	    if (this._done) {
	      return Promise.resolve({
	        value: undefined,
	        done: true
	      });
	    }
	    var requestCapability = (0, _util.createPromiseCapability)();
	    this._requests.push(requestCapability);
	    return requestCapability.promise;
	  },
	  cancel: function PDFNetworkStreamRangeRequestReader_cancel(reason) {
	    this._done = true;
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	    if (this._manager.isPendingRequest(this._requestId)) {
	      this._manager.abortRequest(this._requestId);
	    }
	    this._close();
	  }
	};
	exports.PDFNetworkStream = PDFNetworkStream;
	exports.NetworkManager = NetworkManager;

/***/ },
/* 1710 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFNodeStream = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __webpack_require__(14);
	
	var _network_utils = __webpack_require__(426);
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var fs = __webpack_require__(2078);
	var http = __webpack_require__(2079);
	var https = __webpack_require__(2080);
	var url = __webpack_require__(951);
	
	var fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;
	
	var PDFNodeStream = function () {
	  function PDFNodeStream(source) {
	    _classCallCheck(this, PDFNodeStream);
	
	    this.source = source;
	    this.url = url.parse(source.url);
	    this.isHttp = this.url.protocol === 'http:' || this.url.protocol === 'https:';
	    this.isFsUrl = this.url.protocol === 'file:' || !this.url.host;
	    this.httpHeaders = this.isHttp && source.httpHeaders || {};
	    this._fullRequest = null;
	    this._rangeRequestReaders = [];
	  }
	
	  _createClass(PDFNodeStream, [{
	    key: 'getFullReader',
	    value: function getFullReader() {
	      (0, _util.assert)(!this._fullRequest);
	      this._fullRequest = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
	      return this._fullRequest;
	    }
	  }, {
	    key: 'getRangeReader',
	    value: function getRangeReader(start, end) {
	      var rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
	      this._rangeRequestReaders.push(rangeReader);
	      return rangeReader;
	    }
	  }, {
	    key: 'cancelAllRequests',
	    value: function cancelAllRequests(reason) {
	      if (this._fullRequest) {
	        this._fullRequest.cancel(reason);
	      }
	      var readers = this._rangeRequestReaders.slice(0);
	      readers.forEach(function (reader) {
	        reader.cancel(reason);
	      });
	    }
	  }]);
	
	  return PDFNodeStream;
	}();
	
	var BaseFullReader = function () {
	  function BaseFullReader(stream) {
	    _classCallCheck(this, BaseFullReader);
	
	    this._url = stream.url;
	    this._done = false;
	    this._errored = false;
	    this._reason = null;
	    this.onProgress = null;
	    var source = stream.source;
	    this._contentLength = source.length;
	    this._loaded = 0;
	    this._filename = null;
	    this._disableRange = source.disableRange || false;
	    this._rangeChunkSize = source.rangeChunkSize;
	    if (!this._rangeChunkSize && !this._disableRange) {
	      this._disableRange = true;
	    }
	    this._isStreamingSupported = !source.disableStream;
	    this._isRangeSupported = !source.disableRange;
	    this._readableStream = null;
	    this._readCapability = (0, _util.createPromiseCapability)();
	    this._headersCapability = (0, _util.createPromiseCapability)();
	  }
	
	  _createClass(BaseFullReader, [{
	    key: 'read',
	    value: function read() {
	      var _this = this;
	
	      return this._readCapability.promise.then(function () {
	        if (_this._done) {
	          return Promise.resolve({
	            value: undefined,
	            done: true
	          });
	        }
	        if (_this._errored) {
	          return Promise.reject(_this._reason);
	        }
	        var chunk = _this._readableStream.read();
	        if (chunk === null) {
	          _this._readCapability = (0, _util.createPromiseCapability)();
	          return _this.read();
	        }
	        _this._loaded += chunk.length;
	        if (_this.onProgress) {
	          _this.onProgress({
	            loaded: _this._loaded,
	            total: _this._contentLength
	          });
	        }
	        var buffer = new Uint8Array(chunk).buffer;
	        return Promise.resolve({
	          value: buffer,
	          done: false
	        });
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel(reason) {
	      if (!this._readableStream) {
	        this._error(reason);
	        return;
	      }
	      this._readableStream.destroy(reason);
	    }
	  }, {
	    key: '_error',
	    value: function _error(reason) {
	      this._errored = true;
	      this._reason = reason;
	      this._readCapability.resolve();
	    }
	  }, {
	    key: '_setReadableStream',
	    value: function _setReadableStream(readableStream) {
	      var _this2 = this;
	
	      this._readableStream = readableStream;
	      readableStream.on('readable', function () {
	        _this2._readCapability.resolve();
	      });
	      readableStream.on('end', function () {
	        readableStream.destroy();
	        _this2._done = true;
	        _this2._readCapability.resolve();
	      });
	      readableStream.on('error', function (reason) {
	        _this2._error(reason);
	      });
	      if (!this._isStreamingSupported && this._isRangeSupported) {
	        this._error(new _util.AbortException('streaming is disabled'));
	      }
	      if (this._errored) {
	        this._readableStream.destroy(this._reason);
	      }
	    }
	  }, {
	    key: 'headersReady',
	    get: function get() {
	      return this._headersCapability.promise;
	    }
	  }, {
	    key: 'filename',
	    get: function get() {
	      return this._filename;
	    }
	  }, {
	    key: 'contentLength',
	    get: function get() {
	      return this._contentLength;
	    }
	  }, {
	    key: 'isRangeSupported',
	    get: function get() {
	      return this._isRangeSupported;
	    }
	  }, {
	    key: 'isStreamingSupported',
	    get: function get() {
	      return this._isStreamingSupported;
	    }
	  }]);
	
	  return BaseFullReader;
	}();
	
	var BaseRangeReader = function () {
	  function BaseRangeReader(stream) {
	    _classCallCheck(this, BaseRangeReader);
	
	    this._url = stream.url;
	    this._done = false;
	    this._errored = false;
	    this._reason = null;
	    this.onProgress = null;
	    this._loaded = 0;
	    this._readableStream = null;
	    this._readCapability = (0, _util.createPromiseCapability)();
	    var source = stream.source;
	    this._isStreamingSupported = !source.disableStream;
	  }
	
	  _createClass(BaseRangeReader, [{
	    key: 'read',
	    value: function read() {
	      var _this3 = this;
	
	      return this._readCapability.promise.then(function () {
	        if (_this3._done) {
	          return Promise.resolve({
	            value: undefined,
	            done: true
	          });
	        }
	        if (_this3._errored) {
	          return Promise.reject(_this3._reason);
	        }
	        var chunk = _this3._readableStream.read();
	        if (chunk === null) {
	          _this3._readCapability = (0, _util.createPromiseCapability)();
	          return _this3.read();
	        }
	        _this3._loaded += chunk.length;
	        if (_this3.onProgress) {
	          _this3.onProgress({ loaded: _this3._loaded });
	        }
	        var buffer = new Uint8Array(chunk).buffer;
	        return Promise.resolve({
	          value: buffer,
	          done: false
	        });
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel(reason) {
	      if (!this._readableStream) {
	        this._error(reason);
	        return;
	      }
	      this._readableStream.destroy(reason);
	    }
	  }, {
	    key: '_error',
	    value: function _error(reason) {
	      this._errored = true;
	      this._reason = reason;
	      this._readCapability.resolve();
	    }
	  }, {
	    key: '_setReadableStream',
	    value: function _setReadableStream(readableStream) {
	      var _this4 = this;
	
	      this._readableStream = readableStream;
	      readableStream.on('readable', function () {
	        _this4._readCapability.resolve();
	      });
	      readableStream.on('end', function () {
	        readableStream.destroy();
	        _this4._done = true;
	        _this4._readCapability.resolve();
	      });
	      readableStream.on('error', function (reason) {
	        _this4._error(reason);
	      });
	      if (this._errored) {
	        this._readableStream.destroy(this._reason);
	      }
	    }
	  }, {
	    key: 'isStreamingSupported',
	    get: function get() {
	      return this._isStreamingSupported;
	    }
	  }]);
	
	  return BaseRangeReader;
	}();
	
	function createRequestOptions(url, headers) {
	  return {
	    protocol: url.protocol,
	    auth: url.auth,
	    host: url.hostname,
	    port: url.port,
	    path: url.path,
	    method: 'GET',
	    headers: headers
	  };
	}
	
	var PDFNodeStreamFullReader = function (_BaseFullReader) {
	  _inherits(PDFNodeStreamFullReader, _BaseFullReader);
	
	  function PDFNodeStreamFullReader(stream) {
	    _classCallCheck(this, PDFNodeStreamFullReader);
	
	    var _this5 = _possibleConstructorReturn(this, (PDFNodeStreamFullReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFullReader)).call(this, stream));
	
	    var handleResponse = function handleResponse(response) {
	      _this5._headersCapability.resolve();
	      _this5._setReadableStream(response);
	      var getResponseHeader = function getResponseHeader(name) {
	        return _this5._readableStream.headers[name.toLowerCase()];
	      };
	
	      var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
	        getResponseHeader: getResponseHeader,
	        isHttp: stream.isHttp,
	        rangeChunkSize: _this5._rangeChunkSize,
	        disableRange: _this5._disableRange
	      }),
	          allowRangeRequests = _validateRangeRequest.allowRangeRequests,
	          suggestedLength = _validateRangeRequest.suggestedLength;
	
	      if (allowRangeRequests) {
	        _this5._isRangeSupported = true;
	      }
	      _this5._contentLength = suggestedLength;
	      _this5._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
	    };
	    _this5._request = null;
	    if (_this5._url.protocol === 'http:') {
	      _this5._request = http.request(createRequestOptions(_this5._url, stream.httpHeaders), handleResponse);
	    } else {
	      _this5._request = https.request(createRequestOptions(_this5._url, stream.httpHeaders), handleResponse);
	    }
	    _this5._request.on('error', function (reason) {
	      _this5._errored = true;
	      _this5._reason = reason;
	      _this5._headersCapability.reject(reason);
	    });
	    _this5._request.end();
	    return _this5;
	  }
	
	  return PDFNodeStreamFullReader;
	}(BaseFullReader);
	
	var PDFNodeStreamRangeReader = function (_BaseRangeReader) {
	  _inherits(PDFNodeStreamRangeReader, _BaseRangeReader);
	
	  function PDFNodeStreamRangeReader(stream, start, end) {
	    _classCallCheck(this, PDFNodeStreamRangeReader);
	
	    var _this6 = _possibleConstructorReturn(this, (PDFNodeStreamRangeReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamRangeReader)).call(this, stream));
	
	    _this6._httpHeaders = {};
	    for (var property in stream.httpHeaders) {
	      var value = stream.httpHeaders[property];
	      if (typeof value === 'undefined') {
	        continue;
	      }
	      _this6._httpHeaders[property] = value;
	    }
	    _this6._httpHeaders['Range'] = 'bytes=' + start + '-' + (end - 1);
	    _this6._request = null;
	    if (_this6._url.protocol === 'http:') {
	      _this6._request = http.request(createRequestOptions(_this6._url, _this6._httpHeaders), function (response) {
	        _this6._setReadableStream(response);
	      });
	    } else {
	      _this6._request = https.request(createRequestOptions(_this6._url, _this6._httpHeaders), function (response) {
	        _this6._setReadableStream(response);
	      });
	    }
	    _this6._request.on('error', function (reason) {
	      _this6._errored = true;
	      _this6._reason = reason;
	    });
	    _this6._request.end();
	    return _this6;
	  }
	
	  return PDFNodeStreamRangeReader;
	}(BaseRangeReader);
	
	var PDFNodeStreamFsFullReader = function (_BaseFullReader2) {
	  _inherits(PDFNodeStreamFsFullReader, _BaseFullReader2);
	
	  function PDFNodeStreamFsFullReader(stream) {
	    _classCallCheck(this, PDFNodeStreamFsFullReader);
	
	    var _this7 = _possibleConstructorReturn(this, (PDFNodeStreamFsFullReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFsFullReader)).call(this, stream));
	
	    var path = decodeURIComponent(_this7._url.path);
	    if (fileUriRegex.test(_this7._url.href)) {
	      path = path.replace(/^\//, '');
	    }
	    fs.lstat(path, function (error, stat) {
	      if (error) {
	        _this7._errored = true;
	        _this7._reason = error;
	        _this7._headersCapability.reject(error);
	        return;
	      }
	      _this7._contentLength = stat.size;
	      _this7._setReadableStream(fs.createReadStream(path));
	      _this7._headersCapability.resolve();
	    });
	    return _this7;
	  }
	
	  return PDFNodeStreamFsFullReader;
	}(BaseFullReader);
	
	var PDFNodeStreamFsRangeReader = function (_BaseRangeReader2) {
	  _inherits(PDFNodeStreamFsRangeReader, _BaseRangeReader2);
	
	  function PDFNodeStreamFsRangeReader(stream, start, end) {
	    _classCallCheck(this, PDFNodeStreamFsRangeReader);
	
	    var _this8 = _possibleConstructorReturn(this, (PDFNodeStreamFsRangeReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFsRangeReader)).call(this, stream));
	
	    var path = decodeURIComponent(_this8._url.path);
	    if (fileUriRegex.test(_this8._url.href)) {
	      path = path.replace(/^\//, '');
	    }
	    _this8._setReadableStream(fs.createReadStream(path, {
	      start: start,
	      end: end - 1
	    }));
	    return _this8;
	  }
	
	  return PDFNodeStreamFsRangeReader;
	}(BaseRangeReader);
	
	exports.PDFNodeStream = PDFNodeStream;

/***/ },
/* 1711 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TilingPattern = exports.getShadingPatternFromIR = undefined;
	
	var _util = __webpack_require__(14);
	
	var ShadingIRs = {};
	ShadingIRs.RadialAxial = {
	  fromIR: function RadialAxial_fromIR(raw) {
	    var type = raw[1];
	    var colorStops = raw[2];
	    var p0 = raw[3];
	    var p1 = raw[4];
	    var r0 = raw[5];
	    var r1 = raw[6];
	    return {
	      type: 'Pattern',
	      getPattern: function RadialAxial_getPattern(ctx) {
	        var grad;
	        if (type === 'axial') {
	          grad = ctx.createLinearGradient(p0[0], p0[1], p1[0], p1[1]);
	        } else if (type === 'radial') {
	          grad = ctx.createRadialGradient(p0[0], p0[1], r0, p1[0], p1[1], r1);
	        }
	        for (var i = 0, ii = colorStops.length; i < ii; ++i) {
	          var c = colorStops[i];
	          grad.addColorStop(c[0], c[1]);
	        }
	        return grad;
	      }
	    };
	  }
	};
	var createMeshCanvas = function createMeshCanvasClosure() {
	  function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
	    var coords = context.coords,
	        colors = context.colors;
	    var bytes = data.data,
	        rowSize = data.width * 4;
	    var tmp;
	    if (coords[p1 + 1] > coords[p2 + 1]) {
	      tmp = p1;
	      p1 = p2;
	      p2 = tmp;
	      tmp = c1;
	      c1 = c2;
	      c2 = tmp;
	    }
	    if (coords[p2 + 1] > coords[p3 + 1]) {
	      tmp = p2;
	      p2 = p3;
	      p3 = tmp;
	      tmp = c2;
	      c2 = c3;
	      c3 = tmp;
	    }
	    if (coords[p1 + 1] > coords[p2 + 1]) {
	      tmp = p1;
	      p1 = p2;
	      p2 = tmp;
	      tmp = c1;
	      c1 = c2;
	      c2 = tmp;
	    }
	    var x1 = (coords[p1] + context.offsetX) * context.scaleX;
	    var y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
	    var x2 = (coords[p2] + context.offsetX) * context.scaleX;
	    var y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
	    var x3 = (coords[p3] + context.offsetX) * context.scaleX;
	    var y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
	    if (y1 >= y3) {
	      return;
	    }
	    var c1r = colors[c1],
	        c1g = colors[c1 + 1],
	        c1b = colors[c1 + 2];
	    var c2r = colors[c2],
	        c2g = colors[c2 + 1],
	        c2b = colors[c2 + 2];
	    var c3r = colors[c3],
	        c3g = colors[c3 + 1],
	        c3b = colors[c3 + 2];
	    var minY = Math.round(y1),
	        maxY = Math.round(y3);
	    var xa, car, cag, cab;
	    var xb, cbr, cbg, cbb;
	    var k;
	    for (var y = minY; y <= maxY; y++) {
	      if (y < y2) {
	        k = y < y1 ? 0 : y1 === y2 ? 1 : (y1 - y) / (y1 - y2);
	        xa = x1 - (x1 - x2) * k;
	        car = c1r - (c1r - c2r) * k;
	        cag = c1g - (c1g - c2g) * k;
	        cab = c1b - (c1b - c2b) * k;
	      } else {
	        k = y > y3 ? 1 : y2 === y3 ? 0 : (y2 - y) / (y2 - y3);
	        xa = x2 - (x2 - x3) * k;
	        car = c2r - (c2r - c3r) * k;
	        cag = c2g - (c2g - c3g) * k;
	        cab = c2b - (c2b - c3b) * k;
	      }
	      k = y < y1 ? 0 : y > y3 ? 1 : (y1 - y) / (y1 - y3);
	      xb = x1 - (x1 - x3) * k;
	      cbr = c1r - (c1r - c3r) * k;
	      cbg = c1g - (c1g - c3g) * k;
	      cbb = c1b - (c1b - c3b) * k;
	      var x1_ = Math.round(Math.min(xa, xb));
	      var x2_ = Math.round(Math.max(xa, xb));
	      var j = rowSize * y + x1_ * 4;
	      for (var x = x1_; x <= x2_; x++) {
	        k = (xa - x) / (xa - xb);
	        k = k < 0 ? 0 : k > 1 ? 1 : k;
	        bytes[j++] = car - (car - cbr) * k | 0;
	        bytes[j++] = cag - (cag - cbg) * k | 0;
	        bytes[j++] = cab - (cab - cbb) * k | 0;
	        bytes[j++] = 255;
	      }
	    }
	  }
	  function drawFigure(data, figure, context) {
	    var ps = figure.coords;
	    var cs = figure.colors;
	    var i, ii;
	    switch (figure.type) {
	      case 'lattice':
	        var verticesPerRow = figure.verticesPerRow;
	        var rows = Math.floor(ps.length / verticesPerRow) - 1;
	        var cols = verticesPerRow - 1;
	        for (i = 0; i < rows; i++) {
	          var q = i * verticesPerRow;
	          for (var j = 0; j < cols; j++, q++) {
	            drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
	            drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
	          }
	        }
	        break;
	      case 'triangles':
	        for (i = 0, ii = ps.length; i < ii; i += 3) {
	          drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
	        }
	        break;
	      default:
	        throw new Error('illegal figure');
	    }
	  }
	  function createMeshCanvas(bounds, combinesScale, coords, colors, figures, backgroundColor, cachedCanvases, webGLContext) {
	    var EXPECTED_SCALE = 1.1;
	    var MAX_PATTERN_SIZE = 3000;
	    var BORDER_SIZE = 2;
	    var offsetX = Math.floor(bounds[0]);
	    var offsetY = Math.floor(bounds[1]);
	    var boundsWidth = Math.ceil(bounds[2]) - offsetX;
	    var boundsHeight = Math.ceil(bounds[3]) - offsetY;
	    var width = Math.min(Math.ceil(Math.abs(boundsWidth * combinesScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
	    var height = Math.min(Math.ceil(Math.abs(boundsHeight * combinesScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
	    var scaleX = boundsWidth / width;
	    var scaleY = boundsHeight / height;
	    var context = {
	      coords: coords,
	      colors: colors,
	      offsetX: -offsetX,
	      offsetY: -offsetY,
	      scaleX: 1 / scaleX,
	      scaleY: 1 / scaleY
	    };
	    var paddedWidth = width + BORDER_SIZE * 2;
	    var paddedHeight = height + BORDER_SIZE * 2;
	    var canvas, tmpCanvas, i, ii;
	    if (webGLContext.isEnabled) {
	      canvas = webGLContext.drawFigures({
	        width: width,
	        height: height,
	        backgroundColor: backgroundColor,
	        figures: figures,
	        context: context
	      });
	      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
	      tmpCanvas.context.drawImage(canvas, BORDER_SIZE, BORDER_SIZE);
	      canvas = tmpCanvas.canvas;
	    } else {
	      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
	      var tmpCtx = tmpCanvas.context;
	      var data = tmpCtx.createImageData(width, height);
	      if (backgroundColor) {
	        var bytes = data.data;
	        for (i = 0, ii = bytes.length; i < ii; i += 4) {
	          bytes[i] = backgroundColor[0];
	          bytes[i + 1] = backgroundColor[1];
	          bytes[i + 2] = backgroundColor[2];
	          bytes[i + 3] = 255;
	        }
	      }
	      for (i = 0; i < figures.length; i++) {
	        drawFigure(data, figures[i], context);
	      }
	      tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
	      canvas = tmpCanvas.canvas;
	    }
	    return {
	      canvas: canvas,
	      offsetX: offsetX - BORDER_SIZE * scaleX,
	      offsetY: offsetY - BORDER_SIZE * scaleY,
	      scaleX: scaleX,
	      scaleY: scaleY
	    };
	  }
	  return createMeshCanvas;
	}();
	ShadingIRs.Mesh = {
	  fromIR: function Mesh_fromIR(raw) {
	    var coords = raw[2];
	    var colors = raw[3];
	    var figures = raw[4];
	    var bounds = raw[5];
	    var matrix = raw[6];
	    var background = raw[8];
	    return {
	      type: 'Pattern',
	      getPattern: function Mesh_getPattern(ctx, owner, shadingFill) {
	        var scale;
	        if (shadingFill) {
	          scale = _util.Util.singularValueDecompose2dScale(ctx.mozCurrentTransform);
	        } else {
	          scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
	          if (matrix) {
	            var matrixScale = _util.Util.singularValueDecompose2dScale(matrix);
	            scale = [scale[0] * matrixScale[0], scale[1] * matrixScale[1]];
	          }
	        }
	        var temporaryPatternCanvas = createMeshCanvas(bounds, scale, coords, colors, figures, shadingFill ? null : background, owner.cachedCanvases, owner.webGLContext);
	        if (!shadingFill) {
	          ctx.setTransform.apply(ctx, owner.baseTransform);
	          if (matrix) {
	            ctx.transform.apply(ctx, matrix);
	          }
	        }
	        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
	        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
	        return ctx.createPattern(temporaryPatternCanvas.canvas, 'no-repeat');
	      }
	    };
	  }
	};
	ShadingIRs.Dummy = {
	  fromIR: function Dummy_fromIR() {
	    return {
	      type: 'Pattern',
	      getPattern: function Dummy_fromIR_getPattern() {
	        return 'hotpink';
	      }
	    };
	  }
	};
	function getShadingPatternFromIR(raw) {
	  var shadingIR = ShadingIRs[raw[0]];
	  if (!shadingIR) {
	    throw new Error('Unknown IR type: ' + raw[0]);
	  }
	  return shadingIR.fromIR(raw);
	}
	var TilingPattern = function TilingPatternClosure() {
	  var PaintType = {
	    COLORED: 1,
	    UNCOLORED: 2
	  };
	  var MAX_PATTERN_SIZE = 3000;
	  function TilingPattern(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
	    this.operatorList = IR[2];
	    this.matrix = IR[3] || [1, 0, 0, 1, 0, 0];
	    this.bbox = IR[4];
	    this.xstep = IR[5];
	    this.ystep = IR[6];
	    this.paintType = IR[7];
	    this.tilingType = IR[8];
	    this.color = color;
	    this.canvasGraphicsFactory = canvasGraphicsFactory;
	    this.baseTransform = baseTransform;
	    this.type = 'Pattern';
	    this.ctx = ctx;
	  }
	  TilingPattern.prototype = {
	    createPatternCanvas: function TilinPattern_createPatternCanvas(owner) {
	      var operatorList = this.operatorList;
	      var bbox = this.bbox;
	      var xstep = this.xstep;
	      var ystep = this.ystep;
	      var paintType = this.paintType;
	      var tilingType = this.tilingType;
	      var color = this.color;
	      var canvasGraphicsFactory = this.canvasGraphicsFactory;
	      (0, _util.info)('TilingType: ' + tilingType);
	      var x0 = bbox[0],
	          y0 = bbox[1],
	          x1 = bbox[2],
	          y1 = bbox[3];
	      var topLeft = [x0, y0];
	      var botRight = [x0 + xstep, y0 + ystep];
	      var width = botRight[0] - topLeft[0];
	      var height = botRight[1] - topLeft[1];
	      var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
	      var curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
	      var combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]];
	      width = Math.min(Math.ceil(Math.abs(width * combinedScale[0])), MAX_PATTERN_SIZE);
	      height = Math.min(Math.ceil(Math.abs(height * combinedScale[1])), MAX_PATTERN_SIZE);
	      var tmpCanvas = owner.cachedCanvases.getCanvas('pattern', width, height, true);
	      var tmpCtx = tmpCanvas.context;
	      var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
	      graphics.groupLevel = owner.groupLevel;
	      this.setFillAndStrokeStyleToContext(graphics, paintType, color);
	      this.setScale(width, height, xstep, ystep);
	      this.transformToScale(graphics);
	      var tmpTranslate = [1, 0, 0, 1, -topLeft[0], -topLeft[1]];
	      graphics.transform.apply(graphics, tmpTranslate);
	      this.clipBbox(graphics, bbox, x0, y0, x1, y1);
	      graphics.executeOperatorList(operatorList);
	      return tmpCanvas.canvas;
	    },
	    setScale: function TilingPattern_setScale(width, height, xstep, ystep) {
	      this.scale = [width / xstep, height / ystep];
	    },
	    transformToScale: function TilingPattern_transformToScale(graphics) {
	      var scale = this.scale;
	      var tmpScale = [scale[0], 0, 0, scale[1], 0, 0];
	      graphics.transform.apply(graphics, tmpScale);
	    },
	    scaleToContext: function TilingPattern_scaleToContext() {
	      var scale = this.scale;
	      this.ctx.scale(1 / scale[0], 1 / scale[1]);
	    },
	    clipBbox: function clipBbox(graphics, bbox, x0, y0, x1, y1) {
	      if (Array.isArray(bbox) && bbox.length === 4) {
	        var bboxWidth = x1 - x0;
	        var bboxHeight = y1 - y0;
	        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
	        graphics.clip();
	        graphics.endPath();
	      }
	    },
	    setFillAndStrokeStyleToContext: function setFillAndStrokeStyleToContext(graphics, paintType, color) {
	      var context = graphics.ctx,
	          current = graphics.current;
	      switch (paintType) {
	        case PaintType.COLORED:
	          var ctx = this.ctx;
	          context.fillStyle = ctx.fillStyle;
	          context.strokeStyle = ctx.strokeStyle;
	          current.fillColor = ctx.fillStyle;
	          current.strokeColor = ctx.strokeStyle;
	          break;
	        case PaintType.UNCOLORED:
	          var cssColor = _util.Util.makeCssRgb(color[0], color[1], color[2]);
	          context.fillStyle = cssColor;
	          context.strokeStyle = cssColor;
	          current.fillColor = cssColor;
	          current.strokeColor = cssColor;
	          break;
	        default:
	          throw new _util.FormatError('Unsupported paint type: ' + paintType);
	      }
	    },
	    getPattern: function TilingPattern_getPattern(ctx, owner) {
	      var temporaryPatternCanvas = this.createPatternCanvas(owner);
	      ctx = this.ctx;
	      ctx.setTransform.apply(ctx, this.baseTransform);
	      ctx.transform.apply(ctx, this.matrix);
	      this.scaleToContext();
	      return ctx.createPattern(temporaryPatternCanvas, 'repeat');
	    }
	  };
	  return TilingPattern;
	}();
	exports.getShadingPatternFromIR = getShadingPatternFromIR;
	exports.TilingPattern = TilingPattern;

/***/ },
/* 1712 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFDataTransportStream = undefined;
	
	var _util = __webpack_require__(14);
	
	var PDFDataTransportStream = function PDFDataTransportStreamClosure() {
	  function PDFDataTransportStream(params, pdfDataRangeTransport) {
	    var _this = this;
	
	    (0, _util.assert)(pdfDataRangeTransport);
	    this._queuedChunks = [];
	    var initialData = params.initialData;
	    if (initialData && initialData.length > 0) {
	      var buffer = new Uint8Array(initialData).buffer;
	      this._queuedChunks.push(buffer);
	    }
	    this._pdfDataRangeTransport = pdfDataRangeTransport;
	    this._isRangeSupported = !params.disableRange;
	    this._isStreamingSupported = !params.disableStream;
	    this._contentLength = params.length;
	    this._fullRequestReader = null;
	    this._rangeReaders = [];
	    this._pdfDataRangeTransport.addRangeListener(function (begin, chunk) {
	      _this._onReceiveData({
	        begin: begin,
	        chunk: chunk
	      });
	    });
	    this._pdfDataRangeTransport.addProgressListener(function (loaded) {
	      _this._onProgress({ loaded: loaded });
	    });
	    this._pdfDataRangeTransport.addProgressiveReadListener(function (chunk) {
	      _this._onReceiveData({ chunk: chunk });
	    });
	    this._pdfDataRangeTransport.transportReady();
	  }
	  PDFDataTransportStream.prototype = {
	    _onReceiveData: function PDFDataTransportStream_onReceiveData(args) {
	      var buffer = new Uint8Array(args.chunk).buffer;
	      if (args.begin === undefined) {
	        if (this._fullRequestReader) {
	          this._fullRequestReader._enqueue(buffer);
	        } else {
	          this._queuedChunks.push(buffer);
	        }
	      } else {
	        var found = this._rangeReaders.some(function (rangeReader) {
	          if (rangeReader._begin !== args.begin) {
	            return false;
	          }
	          rangeReader._enqueue(buffer);
	          return true;
	        });
	        (0, _util.assert)(found);
	      }
	    },
	    _onProgress: function PDFDataTransportStream_onDataProgress(evt) {
	      if (this._rangeReaders.length > 0) {
	        var firstReader = this._rangeReaders[0];
	        if (firstReader.onProgress) {
	          firstReader.onProgress({ loaded: evt.loaded });
	        }
	      }
	    },
	    _removeRangeReader: function PDFDataTransportStream_removeRangeReader(reader) {
	      var i = this._rangeReaders.indexOf(reader);
	      if (i >= 0) {
	        this._rangeReaders.splice(i, 1);
	      }
	    },
	    getFullReader: function PDFDataTransportStream_getFullReader() {
	      (0, _util.assert)(!this._fullRequestReader);
	      var queuedChunks = this._queuedChunks;
	      this._queuedChunks = null;
	      return new PDFDataTransportStreamReader(this, queuedChunks);
	    },
	    getRangeReader: function PDFDataTransportStream_getRangeReader(begin, end) {
	      var reader = new PDFDataTransportStreamRangeReader(this, begin, end);
	      this._pdfDataRangeTransport.requestDataRange(begin, end);
	      this._rangeReaders.push(reader);
	      return reader;
	    },
	    cancelAllRequests: function PDFDataTransportStream_cancelAllRequests(reason) {
	      if (this._fullRequestReader) {
	        this._fullRequestReader.cancel(reason);
	      }
	      var readers = this._rangeReaders.slice(0);
	      readers.forEach(function (rangeReader) {
	        rangeReader.cancel(reason);
	      });
	      this._pdfDataRangeTransport.abort();
	    }
	  };
	  function PDFDataTransportStreamReader(stream, queuedChunks) {
	    this._stream = stream;
	    this._done = false;
	    this._filename = null;
	    this._queuedChunks = queuedChunks || [];
	    this._requests = [];
	    this._headersReady = Promise.resolve();
	    stream._fullRequestReader = this;
	    this.onProgress = null;
	  }
	  PDFDataTransportStreamReader.prototype = {
	    _enqueue: function PDFDataTransportStreamReader_enqueue(chunk) {
	      if (this._done) {
	        return;
	      }
	      if (this._requests.length > 0) {
	        var requestCapability = this._requests.shift();
	        requestCapability.resolve({
	          value: chunk,
	          done: false
	        });
	        return;
	      }
	      this._queuedChunks.push(chunk);
	    },
	    get headersReady() {
	      return this._headersReady;
	    },
	    get filename() {
	      return this._filename;
	    },
	    get isRangeSupported() {
	      return this._stream._isRangeSupported;
	    },
	    get isStreamingSupported() {
	      return this._stream._isStreamingSupported;
	    },
	    get contentLength() {
	      return this._stream._contentLength;
	    },
	    read: function PDFDataTransportStreamReader_read() {
	      if (this._queuedChunks.length > 0) {
	        var chunk = this._queuedChunks.shift();
	        return Promise.resolve({
	          value: chunk,
	          done: false
	        });
	      }
	      if (this._done) {
	        return Promise.resolve({
	          value: undefined,
	          done: true
	        });
	      }
	      var requestCapability = (0, _util.createPromiseCapability)();
	      this._requests.push(requestCapability);
	      return requestCapability.promise;
	    },
	    cancel: function PDFDataTransportStreamReader_cancel(reason) {
	      this._done = true;
	      this._requests.forEach(function (requestCapability) {
	        requestCapability.resolve({
	          value: undefined,
	          done: true
	        });
	      });
	      this._requests = [];
	    }
	  };
	  function PDFDataTransportStreamRangeReader(stream, begin, end) {
	    this._stream = stream;
	    this._begin = begin;
	    this._end = end;
	    this._queuedChunk = null;
	    this._requests = [];
	    this._done = false;
	    this.onProgress = null;
	  }
	  PDFDataTransportStreamRangeReader.prototype = {
	    _enqueue: function PDFDataTransportStreamRangeReader_enqueue(chunk) {
	      if (this._done) {
	        return;
	      }
	      if (this._requests.length === 0) {
	        this._queuedChunk = chunk;
	      } else {
	        var requestsCapability = this._requests.shift();
	        requestsCapability.resolve({
	          value: chunk,
	          done: false
	        });
	        this._requests.forEach(function (requestCapability) {
	          requestCapability.resolve({
	            value: undefined,
	            done: true
	          });
	        });
	        this._requests = [];
	      }
	      this._done = true;
	      this._stream._removeRangeReader(this);
	    },
	    get isStreamingSupported() {
	      return false;
	    },
	    read: function PDFDataTransportStreamRangeReader_read() {
	      if (this._queuedChunk) {
	        var chunk = this._queuedChunk;
	        this._queuedChunk = null;
	        return Promise.resolve({
	          value: chunk,
	          done: false
	        });
	      }
	      if (this._done) {
	        return Promise.resolve({
	          value: undefined,
	          done: true
	        });
	      }
	      var requestCapability = (0, _util.createPromiseCapability)();
	      this._requests.push(requestCapability);
	      return requestCapability.promise;
	    },
	    cancel: function PDFDataTransportStreamRangeReader_cancel(reason) {
	      this._done = true;
	      this._requests.forEach(function (requestCapability) {
	        requestCapability.resolve({
	          value: undefined,
	          done: true
	        });
	      });
	      this._requests = [];
	      this._stream._removeRangeReader(this);
	    }
	  };
	  return PDFDataTransportStream;
	}();
	exports.PDFDataTransportStream = PDFDataTransportStream;

/***/ },
/* 1713 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WebGLContext = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __webpack_require__(14);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WebGLContext = function () {
	  function WebGLContext(_ref) {
	    var _ref$enable = _ref.enable,
	        enable = _ref$enable === undefined ? false : _ref$enable;
	
	    _classCallCheck(this, WebGLContext);
	
	    this._enabled = enable === true;
	  }
	
	  _createClass(WebGLContext, [{
	    key: 'composeSMask',
	    value: function composeSMask(_ref2) {
	      var layer = _ref2.layer,
	          mask = _ref2.mask,
	          properties = _ref2.properties;
	
	      return WebGLUtils.composeSMask(layer, mask, properties);
	    }
	  }, {
	    key: 'drawFigures',
	    value: function drawFigures(_ref3) {
	      var width = _ref3.width,
	          height = _ref3.height,
	          backgroundColor = _ref3.backgroundColor,
	          figures = _ref3.figures,
	          context = _ref3.context;
	
	      return WebGLUtils.drawFigures(width, height, backgroundColor, figures, context);
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      WebGLUtils.cleanup();
	    }
	  }, {
	    key: 'isEnabled',
	    get: function get() {
	      var enabled = this._enabled;
	      if (enabled) {
	        enabled = WebGLUtils.tryInitGL();
	      }
	      return (0, _util.shadow)(this, 'isEnabled', enabled);
	    }
	  }]);
	
	  return WebGLContext;
	}();
	
	var WebGLUtils = function WebGLUtilsClosure() {
	  function loadShader(gl, code, shaderType) {
	    var shader = gl.createShader(shaderType);
	    gl.shaderSource(shader, code);
	    gl.compileShader(shader);
	    var compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
	    if (!compiled) {
	      var errorMsg = gl.getShaderInfoLog(shader);
	      throw new Error('Error during shader compilation: ' + errorMsg);
	    }
	    return shader;
	  }
	  function createVertexShader(gl, code) {
	    return loadShader(gl, code, gl.VERTEX_SHADER);
	  }
	  function createFragmentShader(gl, code) {
	    return loadShader(gl, code, gl.FRAGMENT_SHADER);
	  }
	  function createProgram(gl, shaders) {
	    var program = gl.createProgram();
	    for (var i = 0, ii = shaders.length; i < ii; ++i) {
	      gl.attachShader(program, shaders[i]);
	    }
	    gl.linkProgram(program);
	    var linked = gl.getProgramParameter(program, gl.LINK_STATUS);
	    if (!linked) {
	      var errorMsg = gl.getProgramInfoLog(program);
	      throw new Error('Error during program linking: ' + errorMsg);
	    }
	    return program;
	  }
	  function createTexture(gl, image, textureId) {
	    gl.activeTexture(textureId);
	    var texture = gl.createTexture();
	    gl.bindTexture(gl.TEXTURE_2D, texture);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
	    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
	    return texture;
	  }
	  var currentGL, currentCanvas;
	  function generateGL() {
	    if (currentGL) {
	      return;
	    }
	    currentCanvas = document.createElement('canvas');
	    currentGL = currentCanvas.getContext('webgl', { premultipliedalpha: false });
	  }
	  var smaskVertexShaderCode = '\
	  attribute vec2 a_position;                                    \
	  attribute vec2 a_texCoord;                                    \
	                                                                \
	  uniform vec2 u_resolution;                                    \
	                                                                \
	  varying vec2 v_texCoord;                                      \
	                                                                \
	  void main() {                                                 \
	    vec2 clipSpace = (a_position / u_resolution) * 2.0 - 1.0;   \
	    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
	                                                                \
	    v_texCoord = a_texCoord;                                    \
	  }                                                             ';
	  var smaskFragmentShaderCode = '\
	  precision mediump float;                                      \
	                                                                \
	  uniform vec4 u_backdrop;                                      \
	  uniform int u_subtype;                                        \
	  uniform sampler2D u_image;                                    \
	  uniform sampler2D u_mask;                                     \
	                                                                \
	  varying vec2 v_texCoord;                                      \
	                                                                \
	  void main() {                                                 \
	    vec4 imageColor = texture2D(u_image, v_texCoord);           \
	    vec4 maskColor = texture2D(u_mask, v_texCoord);             \
	    if (u_backdrop.a > 0.0) {                                   \
	      maskColor.rgb = maskColor.rgb * maskColor.a +             \
	                      u_backdrop.rgb * (1.0 - maskColor.a);     \
	    }                                                           \
	    float lum;                                                  \
	    if (u_subtype == 0) {                                       \
	      lum = maskColor.a;                                        \
	    } else {                                                    \
	      lum = maskColor.r * 0.3 + maskColor.g * 0.59 +            \
	            maskColor.b * 0.11;                                 \
	    }                                                           \
	    imageColor.a *= lum;                                        \
	    imageColor.rgb *= imageColor.a;                             \
	    gl_FragColor = imageColor;                                  \
	  }                                                             ';
	  var smaskCache = null;
	  function initSmaskGL() {
	    var canvas, gl;
	    generateGL();
	    canvas = currentCanvas;
	    currentCanvas = null;
	    gl = currentGL;
	    currentGL = null;
	    var vertexShader = createVertexShader(gl, smaskVertexShaderCode);
	    var fragmentShader = createFragmentShader(gl, smaskFragmentShaderCode);
	    var program = createProgram(gl, [vertexShader, fragmentShader]);
	    gl.useProgram(program);
	    var cache = {};
	    cache.gl = gl;
	    cache.canvas = canvas;
	    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
	    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
	    cache.backdropLocation = gl.getUniformLocation(program, 'u_backdrop');
	    cache.subtypeLocation = gl.getUniformLocation(program, 'u_subtype');
	    var texCoordLocation = gl.getAttribLocation(program, 'a_texCoord');
	    var texLayerLocation = gl.getUniformLocation(program, 'u_image');
	    var texMaskLocation = gl.getUniformLocation(program, 'u_mask');
	    var texCoordBuffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0]), gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(texCoordLocation);
	    gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);
	    gl.uniform1i(texLayerLocation, 0);
	    gl.uniform1i(texMaskLocation, 1);
	    smaskCache = cache;
	  }
	  function composeSMask(layer, mask, properties) {
	    var width = layer.width,
	        height = layer.height;
	    if (!smaskCache) {
	      initSmaskGL();
	    }
	    var cache = smaskCache,
	        canvas = cache.canvas,
	        gl = cache.gl;
	    canvas.width = width;
	    canvas.height = height;
	    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
	    gl.uniform2f(cache.resolutionLocation, width, height);
	    if (properties.backdrop) {
	      gl.uniform4f(cache.resolutionLocation, properties.backdrop[0], properties.backdrop[1], properties.backdrop[2], 1);
	    } else {
	      gl.uniform4f(cache.resolutionLocation, 0, 0, 0, 0);
	    }
	    gl.uniform1i(cache.subtypeLocation, properties.subtype === 'Luminosity' ? 1 : 0);
	    var texture = createTexture(gl, layer, gl.TEXTURE0);
	    var maskTexture = createTexture(gl, mask, gl.TEXTURE1);
	    var buffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
	    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, width, 0, 0, height, 0, height, width, 0, width, height]), gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(cache.positionLocation);
	    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
	    gl.clearColor(0, 0, 0, 0);
	    gl.enable(gl.BLEND);
	    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
	    gl.clear(gl.COLOR_BUFFER_BIT);
	    gl.drawArrays(gl.TRIANGLES, 0, 6);
	    gl.flush();
	    gl.deleteTexture(texture);
	    gl.deleteTexture(maskTexture);
	    gl.deleteBuffer(buffer);
	    return canvas;
	  }
	  var figuresVertexShaderCode = '\
	  attribute vec2 a_position;                                    \
	  attribute vec3 a_color;                                       \
	                                                                \
	  uniform vec2 u_resolution;                                    \
	  uniform vec2 u_scale;                                         \
	  uniform vec2 u_offset;                                        \
	                                                                \
	  varying vec4 v_color;                                         \
	                                                                \
	  void main() {                                                 \
	    vec2 position = (a_position + u_offset) * u_scale;          \
	    vec2 clipSpace = (position / u_resolution) * 2.0 - 1.0;     \
	    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
	                                                                \
	    v_color = vec4(a_color / 255.0, 1.0);                       \
	  }                                                             ';
	  var figuresFragmentShaderCode = '\
	  precision mediump float;                                      \
	                                                                \
	  varying vec4 v_color;                                         \
	                                                                \
	  void main() {                                                 \
	    gl_FragColor = v_color;                                     \
	  }                                                             ';
	  var figuresCache = null;
	  function initFiguresGL() {
	    var canvas, gl;
	    generateGL();
	    canvas = currentCanvas;
	    currentCanvas = null;
	    gl = currentGL;
	    currentGL = null;
	    var vertexShader = createVertexShader(gl, figuresVertexShaderCode);
	    var fragmentShader = createFragmentShader(gl, figuresFragmentShaderCode);
	    var program = createProgram(gl, [vertexShader, fragmentShader]);
	    gl.useProgram(program);
	    var cache = {};
	    cache.gl = gl;
	    cache.canvas = canvas;
	    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
	    cache.scaleLocation = gl.getUniformLocation(program, 'u_scale');
	    cache.offsetLocation = gl.getUniformLocation(program, 'u_offset');
	    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
	    cache.colorLocation = gl.getAttribLocation(program, 'a_color');
	    figuresCache = cache;
	  }
	  function drawFigures(width, height, backgroundColor, figures, context) {
	    if (!figuresCache) {
	      initFiguresGL();
	    }
	    var cache = figuresCache,
	        canvas = cache.canvas,
	        gl = cache.gl;
	    canvas.width = width;
	    canvas.height = height;
	    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
	    gl.uniform2f(cache.resolutionLocation, width, height);
	    var count = 0;
	    var i, ii, rows;
	    for (i = 0, ii = figures.length; i < ii; i++) {
	      switch (figures[i].type) {
	        case 'lattice':
	          rows = figures[i].coords.length / figures[i].verticesPerRow | 0;
	          count += (rows - 1) * (figures[i].verticesPerRow - 1) * 6;
	          break;
	        case 'triangles':
	          count += figures[i].coords.length;
	          break;
	      }
	    }
	    var coords = new Float32Array(count * 2);
	    var colors = new Uint8Array(count * 3);
	    var coordsMap = context.coords,
	        colorsMap = context.colors;
	    var pIndex = 0,
	        cIndex = 0;
	    for (i = 0, ii = figures.length; i < ii; i++) {
	      var figure = figures[i],
	          ps = figure.coords,
	          cs = figure.colors;
	      switch (figure.type) {
	        case 'lattice':
	          var cols = figure.verticesPerRow;
	          rows = ps.length / cols | 0;
	          for (var row = 1; row < rows; row++) {
	            var offset = row * cols + 1;
	            for (var col = 1; col < cols; col++, offset++) {
	              coords[pIndex] = coordsMap[ps[offset - cols - 1]];
	              coords[pIndex + 1] = coordsMap[ps[offset - cols - 1] + 1];
	              coords[pIndex + 2] = coordsMap[ps[offset - cols]];
	              coords[pIndex + 3] = coordsMap[ps[offset - cols] + 1];
	              coords[pIndex + 4] = coordsMap[ps[offset - 1]];
	              coords[pIndex + 5] = coordsMap[ps[offset - 1] + 1];
	              colors[cIndex] = colorsMap[cs[offset - cols - 1]];
	              colors[cIndex + 1] = colorsMap[cs[offset - cols - 1] + 1];
	              colors[cIndex + 2] = colorsMap[cs[offset - cols - 1] + 2];
	              colors[cIndex + 3] = colorsMap[cs[offset - cols]];
	              colors[cIndex + 4] = colorsMap[cs[offset - cols] + 1];
	              colors[cIndex + 5] = colorsMap[cs[offset - cols] + 2];
	              colors[cIndex + 6] = colorsMap[cs[offset - 1]];
	              colors[cIndex + 7] = colorsMap[cs[offset - 1] + 1];
	              colors[cIndex + 8] = colorsMap[cs[offset - 1] + 2];
	              coords[pIndex + 6] = coords[pIndex + 2];
	              coords[pIndex + 7] = coords[pIndex + 3];
	              coords[pIndex + 8] = coords[pIndex + 4];
	              coords[pIndex + 9] = coords[pIndex + 5];
	              coords[pIndex + 10] = coordsMap[ps[offset]];
	              coords[pIndex + 11] = coordsMap[ps[offset] + 1];
	              colors[cIndex + 9] = colors[cIndex + 3];
	              colors[cIndex + 10] = colors[cIndex + 4];
	              colors[cIndex + 11] = colors[cIndex + 5];
	              colors[cIndex + 12] = colors[cIndex + 6];
	              colors[cIndex + 13] = colors[cIndex + 7];
	              colors[cIndex + 14] = colors[cIndex + 8];
	              colors[cIndex + 15] = colorsMap[cs[offset]];
	              colors[cIndex + 16] = colorsMap[cs[offset] + 1];
	              colors[cIndex + 17] = colorsMap[cs[offset] + 2];
	              pIndex += 12;
	              cIndex += 18;
	            }
	          }
	          break;
	        case 'triangles':
	          for (var j = 0, jj = ps.length; j < jj; j++) {
	            coords[pIndex] = coordsMap[ps[j]];
	            coords[pIndex + 1] = coordsMap[ps[j] + 1];
	            colors[cIndex] = colorsMap[cs[j]];
	            colors[cIndex + 1] = colorsMap[cs[j] + 1];
	            colors[cIndex + 2] = colorsMap[cs[j] + 2];
	            pIndex += 2;
	            cIndex += 3;
	          }
	          break;
	      }
	    }
	    if (backgroundColor) {
	      gl.clearColor(backgroundColor[0] / 255, backgroundColor[1] / 255, backgroundColor[2] / 255, 1.0);
	    } else {
	      gl.clearColor(0, 0, 0, 0);
	    }
	    gl.clear(gl.COLOR_BUFFER_BIT);
	    var coordsBuffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, coordsBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, coords, gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(cache.positionLocation);
	    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
	    var colorsBuffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, colorsBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, colors, gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(cache.colorLocation);
	    gl.vertexAttribPointer(cache.colorLocation, 3, gl.UNSIGNED_BYTE, false, 0, 0);
	    gl.uniform2f(cache.scaleLocation, context.scaleX, context.scaleY);
	    gl.uniform2f(cache.offsetLocation, context.offsetX, context.offsetY);
	    gl.drawArrays(gl.TRIANGLES, 0, count);
	    gl.flush();
	    gl.deleteBuffer(coordsBuffer);
	    gl.deleteBuffer(colorsBuffer);
	    return canvas;
	  }
	  return {
	    tryInitGL: function tryInitGL() {
	      try {
	        generateGL();
	        return !!currentGL;
	      } catch (ex) {}
	      return false;
	    },
	
	    composeSMask: composeSMask,
	    drawFigures: drawFigures,
	    cleanup: function cleanup() {
	      if (smaskCache && smaskCache.canvas) {
	        smaskCache.canvas.width = 0;
	        smaskCache.canvas.height = 0;
	      }
	      if (figuresCache && figuresCache.canvas) {
	        figuresCache.canvas.width = 0;
	        figuresCache.canvas.height = 0;
	      }
	      smaskCache = null;
	      figuresCache = null;
	    }
	  };
	}();
	exports.WebGLContext = WebGLContext;

/***/ },
/* 1714 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	var pdfjsVersion = '2.0.305';
	var pdfjsBuild = '9c6a8801';
	var pdfjsSharedUtil = __webpack_require__(14);
	var pdfjsDisplayGlobal = __webpack_require__(1708);
	var pdfjsDisplayAPI = __webpack_require__(824);
	var pdfjsDisplayTextLayer = __webpack_require__(827);
	var pdfjsDisplayAnnotationLayer = __webpack_require__(823);
	var pdfjsDisplayDOMUtils = __webpack_require__(144);
	var pdfjsDisplaySVG = __webpack_require__(826);
	{
	  var isNodeJS = __webpack_require__(285);
	  if (isNodeJS()) {
	    var PDFNodeStream = __webpack_require__(1710).PDFNodeStream;
	    pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
	      return new PDFNodeStream(params);
	    });
	  } else if (typeof Response !== 'undefined' && 'body' in Response.prototype && typeof ReadableStream !== 'undefined') {
	    var PDFFetchStream = __webpack_require__(1706).PDFFetchStream;
	    pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
	      return new PDFFetchStream(params);
	    });
	  } else {
	    var PDFNetworkStream = __webpack_require__(1709).PDFNetworkStream;
	    pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
	      return new PDFNetworkStream(params);
	    });
	  }
	}
	exports.PDFJS = pdfjsDisplayGlobal.PDFJS;
	exports.build = pdfjsDisplayAPI.build;
	exports.version = pdfjsDisplayAPI.version;
	exports.getDocument = pdfjsDisplayAPI.getDocument;
	exports.LoopbackPort = pdfjsDisplayAPI.LoopbackPort;
	exports.PDFDataRangeTransport = pdfjsDisplayAPI.PDFDataRangeTransport;
	exports.PDFWorker = pdfjsDisplayAPI.PDFWorker;
	exports.renderTextLayer = pdfjsDisplayTextLayer.renderTextLayer;
	exports.AnnotationLayer = pdfjsDisplayAnnotationLayer.AnnotationLayer;
	exports.createPromiseCapability = pdfjsSharedUtil.createPromiseCapability;
	exports.PasswordResponses = pdfjsSharedUtil.PasswordResponses;
	exports.InvalidPDFException = pdfjsSharedUtil.InvalidPDFException;
	exports.MissingPDFException = pdfjsSharedUtil.MissingPDFException;
	exports.SVGGraphics = pdfjsDisplaySVG.SVGGraphics;
	exports.NativeImageDecoding = pdfjsSharedUtil.NativeImageDecoding;
	exports.UnexpectedResponseException = pdfjsSharedUtil.UnexpectedResponseException;
	exports.OPS = pdfjsSharedUtil.OPS;
	exports.UNSUPPORTED_FEATURES = pdfjsSharedUtil.UNSUPPORTED_FEATURES;
	exports.createValidAbsoluteUrl = pdfjsSharedUtil.createValidAbsoluteUrl;
	exports.createObjectURL = pdfjsSharedUtil.createObjectURL;
	exports.removeNullCharacters = pdfjsSharedUtil.removeNullCharacters;
	exports.shadow = pdfjsSharedUtil.shadow;
	exports.createBlob = pdfjsSharedUtil.createBlob;
	exports.RenderingCancelledException = pdfjsDisplayDOMUtils.RenderingCancelledException;
	exports.getFilenameFromUrl = pdfjsDisplayDOMUtils.getFilenameFromUrl;
	exports.addLinkAttributes = pdfjsDisplayDOMUtils.addLinkAttributes;

/***/ },
/* 1715 */,
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	if (typeof PDFJS === 'undefined' || !PDFJS.compatibilityChecked) {
	  var globalScope = __webpack_require__(220);
	  var isNodeJS = __webpack_require__(285);
	  var userAgent = typeof navigator !== 'undefined' && navigator.userAgent || '';
	  var isAndroid = /Android/.test(userAgent);
	  var isIOSChrome = userAgent.indexOf('CriOS') >= 0;
	  var isIE = userAgent.indexOf('Trident') >= 0;
	  var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent);
	  var isSafari = /Safari\//.test(userAgent) && !/(Chrome\/|Android\s)/.test(userAgent);
	  var hasDOM = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object';
	  if (typeof PDFJS === 'undefined') {
	    globalScope.PDFJS = {};
	  }
	  PDFJS.compatibilityChecked = true;
	  (function checkNodeBtoa() {
	    if (globalScope.btoa || !isNodeJS()) {
	      return;
	    }
	    globalScope.btoa = function (chars) {
	      return Buffer.from(chars, 'binary').toString('base64');
	    };
	  })();
	  (function checkNodeAtob() {
	    if (globalScope.atob || !isNodeJS()) {
	      return;
	    }
	    globalScope.atob = function (input) {
	      return Buffer.from(input, 'base64').toString('binary');
	    };
	  })();
	  (function checkOnBlobSupport() {
	    if (isIE || isIOSChrome) {
	      PDFJS.disableCreateObjectURL = true;
	    }
	  })();
	  (function checkNavigatorLanguage() {
	    if (typeof navigator === 'undefined') {
	      return;
	    }
	    if ('language' in navigator) {
	      return;
	    }
	    PDFJS.locale = navigator.userLanguage || 'en-US';
	  })();
	  (function checkRangeRequests() {
	    if (isSafari || isIOS) {
	      PDFJS.disableRange = true;
	      PDFJS.disableStream = true;
	    }
	  })();
	  (function checkCanvasSizeLimitation() {
	    if (isIOS || isAndroid) {
	      PDFJS.maxCanvasPixels = 5242880;
	    }
	  })();
	  (function checkFullscreenSupport() {
	    if (!hasDOM) {
	      return;
	    }
	    if (isIE && window.parent !== window) {
	      PDFJS.disableFullscreen = true;
	    }
	  })();
	  (function checkCurrentScript() {
	    if (!hasDOM) {
	      return;
	    }
	    if ('currentScript' in document) {
	      return;
	    }
	    Object.defineProperty(document, 'currentScript', {
	      get: function get() {
	        var scripts = document.getElementsByTagName('script');
	        return scripts[scripts.length - 1];
	      },
	
	      enumerable: true,
	      configurable: true
	    });
	  })();
	  (function checkChildNodeRemove() {
	    if (!hasDOM) {
	      return;
	    }
	    if (typeof Element.prototype.remove !== 'undefined') {
	      return;
	    }
	    Element.prototype.remove = function () {
	      if (this.parentNode) {
	        this.parentNode.removeChild(this);
	      }
	    };
	  })();
	  (function checkArrayIncludes() {
	    if (Array.prototype.includes) {
	      return;
	    }
	    Array.prototype.includes = __webpack_require__(1238);
	  })();
	  (function checkMathLog2() {
	    if (Math.log2) {
	      return;
	    }
	    Math.log2 = __webpack_require__(1239);
	  })();
	  (function checkNumberIsNaN() {
	    if (Number.isNaN) {
	      return;
	    }
	    Number.isNaN = __webpack_require__(1241);
	  })();
	  (function checkNumberIsInteger() {
	    if (Number.isInteger) {
	      return;
	    }
	    Number.isInteger = __webpack_require__(1240);
	  })();
	  (function checkPromise() {
	    if (globalScope.Promise) {
	      return;
	    }
	    globalScope.Promise = __webpack_require__(1243);
	  })();
	  (function checkWeakMap() {
	    if (globalScope.WeakMap) {
	      return;
	    }
	    globalScope.WeakMap = __webpack_require__(1244);
	  })();
	  (function checkURLConstructor() {
	    var hasWorkingUrl = false;
	    try {
	      if (typeof URL === 'function' && _typeof(URL.prototype) === 'object' && 'origin' in URL.prototype) {
	        var u = new URL('b', 'http://a');
	        u.pathname = 'c%20d';
	        hasWorkingUrl = u.href === 'http://a/c%20d';
	      }
	    } catch (e) {}
	    if (hasWorkingUrl) {
	      return;
	    }
	    var relative = Object.create(null);
	    relative['ftp'] = 21;
	    relative['file'] = 0;
	    relative['gopher'] = 70;
	    relative['http'] = 80;
	    relative['https'] = 443;
	    relative['ws'] = 80;
	    relative['wss'] = 443;
	    var relativePathDotMapping = Object.create(null);
	    relativePathDotMapping['%2e'] = '.';
	    relativePathDotMapping['.%2e'] = '..';
	    relativePathDotMapping['%2e.'] = '..';
	    relativePathDotMapping['%2e%2e'] = '..';
	    function isRelativeScheme(scheme) {
	      return relative[scheme] !== undefined;
	    }
	    function invalid() {
	      clear.call(this);
	      this._isInvalid = true;
	    }
	    function IDNAToASCII(h) {
	      if (h === '') {
	        invalid.call(this);
	      }
	      return h.toLowerCase();
	    }
	    function percentEscape(c) {
	      var unicode = c.charCodeAt(0);
	      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x3F, 0x60].indexOf(unicode) === -1) {
	        return c;
	      }
	      return encodeURIComponent(c);
	    }
	    function percentEscapeQuery(c) {
	      var unicode = c.charCodeAt(0);
	      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x60].indexOf(unicode) === -1) {
	        return c;
	      }
	      return encodeURIComponent(c);
	    }
	    var EOF,
	        ALPHA = /[a-zA-Z]/,
	        ALPHANUMERIC = /[a-zA-Z0-9\+\-\.]/;
	    function parse(input, stateOverride, base) {
	      function err(message) {
	        errors.push(message);
	      }
	      var state = stateOverride || 'scheme start',
	          cursor = 0,
	          buffer = '',
	          seenAt = false,
	          seenBracket = false,
	          errors = [];
	      loop: while ((input[cursor - 1] !== EOF || cursor === 0) && !this._isInvalid) {
	        var c = input[cursor];
	        switch (state) {
	          case 'scheme start':
	            if (c && ALPHA.test(c)) {
	              buffer += c.toLowerCase();
	              state = 'scheme';
	            } else if (!stateOverride) {
	              buffer = '';
	              state = 'no scheme';
	              continue;
	            } else {
	              err('Invalid scheme.');
	              break loop;
	            }
	            break;
	          case 'scheme':
	            if (c && ALPHANUMERIC.test(c)) {
	              buffer += c.toLowerCase();
	            } else if (c === ':') {
	              this._scheme = buffer;
	              buffer = '';
	              if (stateOverride) {
	                break loop;
	              }
	              if (isRelativeScheme(this._scheme)) {
	                this._isRelative = true;
	              }
	              if (this._scheme === 'file') {
	                state = 'relative';
	              } else if (this._isRelative && base && base._scheme === this._scheme) {
	                state = 'relative or authority';
	              } else if (this._isRelative) {
	                state = 'authority first slash';
	              } else {
	                state = 'scheme data';
	              }
	            } else if (!stateOverride) {
	              buffer = '';
	              cursor = 0;
	              state = 'no scheme';
	              continue;
	            } else if (c === EOF) {
	              break loop;
	            } else {
	              err('Code point not allowed in scheme: ' + c);
	              break loop;
	            }
	            break;
	          case 'scheme data':
	            if (c === '?') {
	              this._query = '?';
	              state = 'query';
	            } else if (c === '#') {
	              this._fragment = '#';
	              state = 'fragment';
	            } else {
	              if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	                this._schemeData += percentEscape(c);
	              }
	            }
	            break;
	          case 'no scheme':
	            if (!base || !isRelativeScheme(base._scheme)) {
	              err('Missing scheme.');
	              invalid.call(this);
	            } else {
	              state = 'relative';
	              continue;
	            }
	            break;
	          case 'relative or authority':
	            if (c === '/' && input[cursor + 1] === '/') {
	              state = 'authority ignore slashes';
	            } else {
	              err('Expected /, got: ' + c);
	              state = 'relative';
	              continue;
	            }
	            break;
	          case 'relative':
	            this._isRelative = true;
	            if (this._scheme !== 'file') {
	              this._scheme = base._scheme;
	            }
	            if (c === EOF) {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = base._query;
	              this._username = base._username;
	              this._password = base._password;
	              break loop;
	            } else if (c === '/' || c === '\\') {
	              if (c === '\\') {
	                err('\\ is an invalid code point.');
	              }
	              state = 'relative slash';
	            } else if (c === '?') {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = '?';
	              this._username = base._username;
	              this._password = base._password;
	              state = 'query';
	            } else if (c === '#') {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = base._query;
	              this._fragment = '#';
	              this._username = base._username;
	              this._password = base._password;
	              state = 'fragment';
	            } else {
	              var nextC = input[cursor + 1];
	              var nextNextC = input[cursor + 2];
	              if (this._scheme !== 'file' || !ALPHA.test(c) || nextC !== ':' && nextC !== '|' || nextNextC !== EOF && nextNextC !== '/' && nextNextC !== '\\' && nextNextC !== '?' && nextNextC !== '#') {
	                this._host = base._host;
	                this._port = base._port;
	                this._username = base._username;
	                this._password = base._password;
	                this._path = base._path.slice();
	                this._path.pop();
	              }
	              state = 'relative path';
	              continue;
	            }
	            break;
	          case 'relative slash':
	            if (c === '/' || c === '\\') {
	              if (c === '\\') {
	                err('\\ is an invalid code point.');
	              }
	              if (this._scheme === 'file') {
	                state = 'file host';
	              } else {
	                state = 'authority ignore slashes';
	              }
	            } else {
	              if (this._scheme !== 'file') {
	                this._host = base._host;
	                this._port = base._port;
	                this._username = base._username;
	                this._password = base._password;
	              }
	              state = 'relative path';
	              continue;
	            }
	            break;
	          case 'authority first slash':
	            if (c === '/') {
	              state = 'authority second slash';
	            } else {
	              err('Expected \'/\', got: ' + c);
	              state = 'authority ignore slashes';
	              continue;
	            }
	            break;
	          case 'authority second slash':
	            state = 'authority ignore slashes';
	            if (c !== '/') {
	              err('Expected \'/\', got: ' + c);
	              continue;
	            }
	            break;
	          case 'authority ignore slashes':
	            if (c !== '/' && c !== '\\') {
	              state = 'authority';
	              continue;
	            } else {
	              err('Expected authority, got: ' + c);
	            }
	            break;
	          case 'authority':
	            if (c === '@') {
	              if (seenAt) {
	                err('@ already seen.');
	                buffer += '%40';
	              }
	              seenAt = true;
	              for (var i = 0; i < buffer.length; i++) {
	                var cp = buffer[i];
	                if (cp === '\t' || cp === '\n' || cp === '\r') {
	                  err('Invalid whitespace in authority.');
	                  continue;
	                }
	                if (cp === ':' && this._password === null) {
	                  this._password = '';
	                  continue;
	                }
	                var tempC = percentEscape(cp);
	                if (this._password !== null) {
	                  this._password += tempC;
	                } else {
	                  this._username += tempC;
	                }
	              }
	              buffer = '';
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              cursor -= buffer.length;
	              buffer = '';
	              state = 'host';
	              continue;
	            } else {
	              buffer += c;
	            }
	            break;
	          case 'file host':
	            if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              if (buffer.length === 2 && ALPHA.test(buffer[0]) && (buffer[1] === ':' || buffer[1] === '|')) {
	                state = 'relative path';
	              } else if (buffer.length === 0) {
	                state = 'relative path start';
	              } else {
	                this._host = IDNAToASCII.call(this, buffer);
	                buffer = '';
	                state = 'relative path start';
	              }
	              continue;
	            } else if (c === '\t' || c === '\n' || c === '\r') {
	              err('Invalid whitespace in file host.');
	            } else {
	              buffer += c;
	            }
	            break;
	          case 'host':
	          case 'hostname':
	            if (c === ':' && !seenBracket) {
	              this._host = IDNAToASCII.call(this, buffer);
	              buffer = '';
	              state = 'port';
	              if (stateOverride === 'hostname') {
	                break loop;
	              }
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              this._host = IDNAToASCII.call(this, buffer);
	              buffer = '';
	              state = 'relative path start';
	              if (stateOverride) {
	                break loop;
	              }
	              continue;
	            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
	              if (c === '[') {
	                seenBracket = true;
	              } else if (c === ']') {
	                seenBracket = false;
	              }
	              buffer += c;
	            } else {
	              err('Invalid code point in host/hostname: ' + c);
	            }
	            break;
	          case 'port':
	            if (/[0-9]/.test(c)) {
	              buffer += c;
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#' || stateOverride) {
	              if (buffer !== '') {
	                var temp = parseInt(buffer, 10);
	                if (temp !== relative[this._scheme]) {
	                  this._port = temp + '';
	                }
	                buffer = '';
	              }
	              if (stateOverride) {
	                break loop;
	              }
	              state = 'relative path start';
	              continue;
	            } else if (c === '\t' || c === '\n' || c === '\r') {
	              err('Invalid code point in port: ' + c);
	            } else {
	              invalid.call(this);
	            }
	            break;
	          case 'relative path start':
	            if (c === '\\') {
	              err('\'\\\' not allowed in path.');
	            }
	            state = 'relative path';
	            if (c !== '/' && c !== '\\') {
	              continue;
	            }
	            break;
	          case 'relative path':
	            if (c === EOF || c === '/' || c === '\\' || !stateOverride && (c === '?' || c === '#')) {
	              if (c === '\\') {
	                err('\\ not allowed in relative path.');
	              }
	              var tmp;
	              if (tmp = relativePathDotMapping[buffer.toLowerCase()]) {
	                buffer = tmp;
	              }
	              if (buffer === '..') {
	                this._path.pop();
	                if (c !== '/' && c !== '\\') {
	                  this._path.push('');
	                }
	              } else if (buffer === '.' && c !== '/' && c !== '\\') {
	                this._path.push('');
	              } else if (buffer !== '.') {
	                if (this._scheme === 'file' && this._path.length === 0 && buffer.length === 2 && ALPHA.test(buffer[0]) && buffer[1] === '|') {
	                  buffer = buffer[0] + ':';
	                }
	                this._path.push(buffer);
	              }
	              buffer = '';
	              if (c === '?') {
	                this._query = '?';
	                state = 'query';
	              } else if (c === '#') {
	                this._fragment = '#';
	                state = 'fragment';
	              }
	            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
	              buffer += percentEscape(c);
	            }
	            break;
	          case 'query':
	            if (!stateOverride && c === '#') {
	              this._fragment = '#';
	              state = 'fragment';
	            } else if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	              this._query += percentEscapeQuery(c);
	            }
	            break;
	          case 'fragment':
	            if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	              this._fragment += c;
	            }
	            break;
	        }
	        cursor++;
	      }
	    }
	    function clear() {
	      this._scheme = '';
	      this._schemeData = '';
	      this._username = '';
	      this._password = null;
	      this._host = '';
	      this._port = '';
	      this._path = [];
	      this._query = '';
	      this._fragment = '';
	      this._isInvalid = false;
	      this._isRelative = false;
	    }
	    function JURL(url, base) {
	      if (base !== undefined && !(base instanceof JURL)) {
	        base = new JURL(String(base));
	      }
	      this._url = url;
	      clear.call(this);
	      var input = url.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, '');
	      parse.call(this, input, null, base);
	    }
	    JURL.prototype = {
	      toString: function toString() {
	        return this.href;
	      },
	
	      get href() {
	        if (this._isInvalid) {
	          return this._url;
	        }
	        var authority = '';
	        if (this._username !== '' || this._password !== null) {
	          authority = this._username + (this._password !== null ? ':' + this._password : '') + '@';
	        }
	        return this.protocol + (this._isRelative ? '//' + authority + this.host : '') + this.pathname + this._query + this._fragment;
	      },
	      set href(value) {
	        clear.call(this);
	        parse.call(this, value);
	      },
	      get protocol() {
	        return this._scheme + ':';
	      },
	      set protocol(value) {
	        if (this._isInvalid) {
	          return;
	        }
	        parse.call(this, value + ':', 'scheme start');
	      },
	      get host() {
	        return this._isInvalid ? '' : this._port ? this._host + ':' + this._port : this._host;
	      },
	      set host(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, value, 'host');
	      },
	      get hostname() {
	        return this._host;
	      },
	      set hostname(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, value, 'hostname');
	      },
	      get port() {
	        return this._port;
	      },
	      set port(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, value, 'port');
	      },
	      get pathname() {
	        return this._isInvalid ? '' : this._isRelative ? '/' + this._path.join('/') : this._schemeData;
	      },
	      set pathname(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        this._path = [];
	        parse.call(this, value, 'relative path start');
	      },
	      get search() {
	        return this._isInvalid || !this._query || this._query === '?' ? '' : this._query;
	      },
	      set search(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        this._query = '?';
	        if (value[0] === '?') {
	          value = value.slice(1);
	        }
	        parse.call(this, value, 'query');
	      },
	      get hash() {
	        return this._isInvalid || !this._fragment || this._fragment === '#' ? '' : this._fragment;
	      },
	      set hash(value) {
	        if (this._isInvalid) {
	          return;
	        }
	        this._fragment = '#';
	        if (value[0] === '#') {
	          value = value.slice(1);
	        }
	        parse.call(this, value, 'fragment');
	      },
	      get origin() {
	        var host;
	        if (this._isInvalid || !this._scheme) {
	          return '';
	        }
	        switch (this._scheme) {
	          case 'data':
	          case 'file':
	          case 'javascript':
	          case 'mailto':
	            return 'null';
	          case 'blob':
	            try {
	              return new JURL(this._schemeData).origin || 'null';
	            } catch (_) {}
	            return 'null';
	        }
	        host = this.host;
	        if (!host) {
	          return '';
	        }
	        return this._scheme + '://' + host;
	      }
	    };
	    var OriginalURL = globalScope.URL;
	    if (OriginalURL) {
	      JURL.createObjectURL = function (blob) {
	        return OriginalURL.createObjectURL.apply(OriginalURL, arguments);
	      };
	      JURL.revokeObjectURL = function (url) {
	        OriginalURL.revokeObjectURL(url);
	      };
	    }
	    globalScope.URL = JURL;
	  })();
	  (function checkObjectValues() {
	    if (Object.values) {
	      return;
	    }
	    Object.values = __webpack_require__(1242);
	  })();
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62).Buffer))

/***/ },
/* 1717 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	var isReadableStreamSupported = false;
	if (typeof ReadableStream !== 'undefined') {
	  try {
	    new ReadableStream({
	      start: function start(controller) {
	        controller.close();
	      }
	    });
	    isReadableStreamSupported = true;
	  } catch (e) {}
	}
	if (isReadableStreamSupported) {
	  exports.ReadableStream = ReadableStream;
	} else {
	  exports.ReadableStream = __webpack_require__(1682).ReadableStream;
	}

/***/ },
/* 1718 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getGlobalEventBus = exports.attachDOMEventsToEventBus = undefined;
	
	var _ui_utils = __webpack_require__(828);
	
	function attachDOMEventsToEventBus(eventBus) {
	  eventBus.on('documentload', function () {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('documentload', true, true, {});
	    window.dispatchEvent(event);
	  });
	  eventBus.on('pagerendered', function (evt) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('pagerendered', true, true, {
	      pageNumber: evt.pageNumber,
	      cssTransform: evt.cssTransform
	    });
	    evt.source.div.dispatchEvent(event);
	  });
	  eventBus.on('textlayerrendered', function (evt) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('textlayerrendered', true, true, { pageNumber: evt.pageNumber });
	    evt.source.textLayerDiv.dispatchEvent(event);
	  });
	  eventBus.on('pagechange', function (evt) {
	    var event = document.createEvent('UIEvents');
	    event.initUIEvent('pagechange', true, true, window, 0);
	    event.pageNumber = evt.pageNumber;
	    evt.source.container.dispatchEvent(event);
	  });
	  eventBus.on('pagesinit', function (evt) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('pagesinit', true, true, null);
	    evt.source.container.dispatchEvent(event);
	  });
	  eventBus.on('pagesloaded', function (evt) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('pagesloaded', true, true, { pagesCount: evt.pagesCount });
	    evt.source.container.dispatchEvent(event);
	  });
	  eventBus.on('scalechange', function (evt) {
	    var event = document.createEvent('UIEvents');
	    event.initUIEvent('scalechange', true, true, window, 0);
	    event.scale = evt.scale;
	    event.presetValue = evt.presetValue;
	    evt.source.container.dispatchEvent(event);
	  });
	  eventBus.on('updateviewarea', function (evt) {
	    var event = document.createEvent('UIEvents');
	    event.initUIEvent('updateviewarea', true, true, window, 0);
	    event.location = evt.location;
	    evt.source.container.dispatchEvent(event);
	  });
	  eventBus.on('find', function (evt) {
	    if (evt.source === window) {
	      return;
	    }
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('find' + evt.type, true, true, {
	      query: evt.query,
	      phraseSearch: evt.phraseSearch,
	      caseSensitive: evt.caseSensitive,
	      highlightAll: evt.highlightAll,
	      findPrevious: evt.findPrevious
	    });
	    window.dispatchEvent(event);
	  });
	  eventBus.on('attachmentsloaded', function (evt) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('attachmentsloaded', true, true, { attachmentsCount: evt.attachmentsCount });
	    evt.source.container.dispatchEvent(event);
	  });
	  eventBus.on('sidebarviewchanged', function (evt) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('sidebarviewchanged', true, true, { view: evt.view });
	    evt.source.outerContainer.dispatchEvent(event);
	  });
	  eventBus.on('pagemode', function (evt) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('pagemode', true, true, { mode: evt.mode });
	    evt.source.pdfViewer.container.dispatchEvent(event);
	  });
	  eventBus.on('namedaction', function (evt) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('namedaction', true, true, { action: evt.action });
	    evt.source.pdfViewer.container.dispatchEvent(event);
	  });
	  eventBus.on('presentationmodechanged', function (evt) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('presentationmodechanged', true, true, {
	      active: evt.active,
	      switchInProgress: evt.switchInProgress
	    });
	    window.dispatchEvent(event);
	  });
	  eventBus.on('outlineloaded', function (evt) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('outlineloaded', true, true, { outlineCount: evt.outlineCount });
	    evt.source.container.dispatchEvent(event);
	  });
	}
	var globalEventBus = null;
	function getGlobalEventBus() {
	  if (globalEventBus) {
	    return globalEventBus;
	  }
	  globalEventBus = new _ui_utils.EventBus();
	  attachDOMEventsToEventBus(globalEventBus);
	  return globalEventBus;
	}
	exports.attachDOMEventsToEventBus = attachDOMEventsToEventBus;
	exports.getGlobalEventBus = getGlobalEventBus;

/***/ },
/* 1719 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @licstart The following is the entire license notice for the
	 * Javascript code in this page
	 *
	 * Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @licend The above is the entire license notice for the
	 * Javascript code in this page
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SimpleLinkService = exports.PDFLinkService = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dom_events = __webpack_require__(1718);
	
	var _ui_utils = __webpack_require__(828);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PDFLinkService = function () {
	  function PDFLinkService() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        eventBus = _ref.eventBus;
	
	    _classCallCheck(this, PDFLinkService);
	
	    this.eventBus = eventBus || (0, _dom_events.getGlobalEventBus)();
	    this.baseUrl = null;
	    this.pdfDocument = null;
	    this.pdfViewer = null;
	    this.pdfHistory = null;
	    this._pagesRefCache = null;
	  }
	
	  _createClass(PDFLinkService, [{
	    key: 'setDocument',
	    value: function setDocument(pdfDocument, baseUrl) {
	      this.baseUrl = baseUrl;
	      this.pdfDocument = pdfDocument;
	      this._pagesRefCache = Object.create(null);
	    }
	  }, {
	    key: 'setViewer',
	    value: function setViewer(pdfViewer) {
	      this.pdfViewer = pdfViewer;
	    }
	  }, {
	    key: 'setHistory',
	    value: function setHistory(pdfHistory) {
	      this.pdfHistory = pdfHistory;
	    }
	  }, {
	    key: 'navigateTo',
	    value: function navigateTo(dest) {
	      var _this = this;
	
	      var goToDestination = function goToDestination(_ref2) {
	        var namedDest = _ref2.namedDest,
	            explicitDest = _ref2.explicitDest;
	
	        var destRef = explicitDest[0],
	            pageNumber = void 0;
	        if (destRef instanceof Object) {
	          pageNumber = _this._cachedPageNumber(destRef);
	          if (pageNumber === null) {
	            _this.pdfDocument.getPageIndex(destRef).then(function (pageIndex) {
	              _this.cachePageRef(pageIndex + 1, destRef);
	              goToDestination({
	                namedDest: namedDest,
	                explicitDest: explicitDest
	              });
	            }).catch(function () {
	              console.error('PDFLinkService.navigateTo: "' + destRef + '" is not ' + ('a valid page reference, for dest="' + dest + '".'));
	            });
	            return;
	          }
	        } else if (Number.isInteger(destRef)) {
	          pageNumber = destRef + 1;
	        } else {
	          console.error('PDFLinkService.navigateTo: "' + destRef + '" is not ' + ('a valid destination reference, for dest="' + dest + '".'));
	          return;
	        }
	        if (!pageNumber || pageNumber < 1 || pageNumber > _this.pagesCount) {
	          console.error('PDFLinkService.navigateTo: "' + pageNumber + '" is not ' + ('a valid page number, for dest="' + dest + '".'));
	          return;
	        }
	        if (_this.pdfHistory) {
	          _this.pdfHistory.pushCurrentPosition();
	          _this.pdfHistory.push({
	            namedDest: namedDest,
	            explicitDest: explicitDest,
	            pageNumber: pageNumber
	          });
	        }
	        _this.pdfViewer.scrollPageIntoView({
	          pageNumber: pageNumber,
	          destArray: explicitDest
	        });
	      };
	      new Promise(function (resolve, reject) {
	        if (typeof dest === 'string') {
	          _this.pdfDocument.getDestination(dest).then(function (destArray) {
	            resolve({
	              namedDest: dest,
	              explicitDest: destArray
	            });
	          });
	          return;
	        }
	        resolve({
	          namedDest: '',
	          explicitDest: dest
	        });
	      }).then(function (data) {
	        if (!(data.explicitDest instanceof Array)) {
	          console.error('PDFLinkService.navigateTo: "' + data.explicitDest + '" is' + (' not a valid destination array, for dest="' + dest + '".'));
	          return;
	        }
	        goToDestination(data);
	      });
	    }
	  }, {
	    key: 'getDestinationHash',
	    value: function getDestinationHash(dest) {
	      if (typeof dest === 'string') {
	        return this.getAnchorUrl('#' + escape(dest));
	      }
	      if (dest instanceof Array) {
	        var str = JSON.stringify(dest);
	        return this.getAnchorUrl('#' + escape(str));
	      }
	      return this.getAnchorUrl('');
	    }
	  }, {
	    key: 'getAnchorUrl',
	    value: function getAnchorUrl(anchor) {
	      return (this.baseUrl || '') + anchor;
	    }
	  }, {
	    key: 'setHash',
	    value: function setHash(hash) {
	      var pageNumber = void 0,
	          dest = void 0;
	      if (hash.indexOf('=') >= 0) {
	        var params = (0, _ui_utils.parseQueryString)(hash);
	        if ('search' in params) {
	          this.eventBus.dispatch('findfromurlhash', {
	            source: this,
	            query: params['search'].replace(/"/g, ''),
	            phraseSearch: params['phrase'] === 'true'
	          });
	        }
	        if ('nameddest' in params) {
	          this.navigateTo(params.nameddest);
	          return;
	        }
	        if ('page' in params) {
	          pageNumber = params.page | 0 || 1;
	        }
	        if ('zoom' in params) {
	          var zoomArgs = params.zoom.split(',');
	          var zoomArg = zoomArgs[0];
	          var zoomArgNumber = parseFloat(zoomArg);
	          if (zoomArg.indexOf('Fit') === -1) {
	            dest = [null, { name: 'XYZ' }, zoomArgs.length > 1 ? zoomArgs[1] | 0 : null, zoomArgs.length > 2 ? zoomArgs[2] | 0 : null, zoomArgNumber ? zoomArgNumber / 100 : zoomArg];
	          } else {
	            if (zoomArg === 'Fit' || zoomArg === 'FitB') {
	              dest = [null, { name: zoomArg }];
	            } else if (zoomArg === 'FitH' || zoomArg === 'FitBH' || zoomArg === 'FitV' || zoomArg === 'FitBV') {
	              dest = [null, { name: zoomArg }, zoomArgs.length > 1 ? zoomArgs[1] | 0 : null];
	            } else if (zoomArg === 'FitR') {
	              if (zoomArgs.length !== 5) {
	                console.error('PDFLinkService.setHash: Not enough parameters for "FitR".');
	              } else {
	                dest = [null, { name: zoomArg }, zoomArgs[1] | 0, zoomArgs[2] | 0, zoomArgs[3] | 0, zoomArgs[4] | 0];
	              }
	            } else {
	              console.error('PDFLinkService.setHash: "' + zoomArg + '" is not ' + 'a valid zoom value.');
	            }
	          }
	        }
	        if (dest) {
	          this.pdfViewer.scrollPageIntoView({
	            pageNumber: pageNumber || this.page,
	            destArray: dest,
	            allowNegativeOffset: true
	          });
	        } else if (pageNumber) {
	          this.page = pageNumber;
	        }
	        if ('pagemode' in params) {
	          this.eventBus.dispatch('pagemode', {
	            source: this,
	            mode: params.pagemode
	          });
	        }
	      } else {
	        dest = unescape(hash);
	        try {
	          dest = JSON.parse(dest);
	          if (!(dest instanceof Array)) {
	            dest = dest.toString();
	          }
	        } catch (ex) {}
	        if (typeof dest === 'string' || isValidExplicitDestination(dest)) {
	          this.navigateTo(dest);
	          return;
	        }
	        console.error('PDFLinkService.setHash: "' + unescape(hash) + '" is not ' + 'a valid destination.');
	      }
	    }
	  }, {
	    key: 'executeNamedAction',
	    value: function executeNamedAction(action) {
	      switch (action) {
	        case 'GoBack':
	          if (this.pdfHistory) {
	            this.pdfHistory.back();
	          }
	          break;
	        case 'GoForward':
	          if (this.pdfHistory) {
	            this.pdfHistory.forward();
	          }
	          break;
	        case 'NextPage':
	          if (this.page < this.pagesCount) {
	            this.page++;
	          }
	          break;
	        case 'PrevPage':
	          if (this.page > 1) {
	            this.page--;
	          }
	          break;
	        case 'LastPage':
	          this.page = this.pagesCount;
	          break;
	        case 'FirstPage':
	          this.page = 1;
	          break;
	        default:
	          break;
	      }
	      this.eventBus.dispatch('namedaction', {
	        source: this,
	        action: action
	      });
	    }
	  }, {
	    key: 'onFileAttachmentAnnotation',
	    value: function onFileAttachmentAnnotation(_ref3) {
	      var id = _ref3.id,
	          filename = _ref3.filename,
	          content = _ref3.content;
	
	      this.eventBus.dispatch('fileattachmentannotation', {
	        source: this,
	        id: id,
	        filename: filename,
	        content: content
	      });
	    }
	  }, {
	    key: 'cachePageRef',
	    value: function cachePageRef(pageNum, pageRef) {
	      var refStr = pageRef.num + ' ' + pageRef.gen + ' R';
	      this._pagesRefCache[refStr] = pageNum;
	    }
	  }, {
	    key: '_cachedPageNumber',
	    value: function _cachedPageNumber(pageRef) {
	      var refStr = pageRef.num + ' ' + pageRef.gen + ' R';
	      return this._pagesRefCache && this._pagesRefCache[refStr] || null;
	    }
	  }, {
	    key: 'pagesCount',
	    get: function get() {
	      return this.pdfDocument ? this.pdfDocument.numPages : 0;
	    }
	  }, {
	    key: 'page',
	    get: function get() {
	      return this.pdfViewer.currentPageNumber;
	    },
	    set: function set(value) {
	      this.pdfViewer.currentPageNumber = value;
	    }
	  }, {
	    key: 'rotation',
	    get: function get() {
	      return this.pdfViewer.pagesRotation;
	    },
	    set: function set(value) {
	      this.pdfViewer.pagesRotation = value;
	    }
	  }]);
	
	  return PDFLinkService;
	}();
	
	function isValidExplicitDestination(dest) {
	  if (!(dest instanceof Array)) {
	    return false;
	  }
	  var destLength = dest.length,
	      allowNull = true;
	  if (destLength < 2) {
	    return false;
	  }
	  var page = dest[0];
	  if (!((typeof page === 'undefined' ? 'undefined' : _typeof(page)) === 'object' && Number.isInteger(page.num) && Number.isInteger(page.gen)) && !(Number.isInteger(page) && page >= 0)) {
	    return false;
	  }
	  var zoom = dest[1];
	  if (!((typeof zoom === 'undefined' ? 'undefined' : _typeof(zoom)) === 'object' && typeof zoom.name === 'string')) {
	    return false;
	  }
	  switch (zoom.name) {
	    case 'XYZ':
	      if (destLength !== 5) {
	        return false;
	      }
	      break;
	    case 'Fit':
	    case 'FitB':
	      return destLength === 2;
	    case 'FitH':
	    case 'FitBH':
	    case 'FitV':
	    case 'FitBV':
	      if (destLength !== 3) {
	        return false;
	      }
	      break;
	    case 'FitR':
	      if (destLength !== 6) {
	        return false;
	      }
	      allowNull = false;
	      break;
	    default:
	      return false;
	  }
	  for (var i = 2; i < destLength; i++) {
	    var param = dest[i];
	    if (!(typeof param === 'number' || allowNull && param === null)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var SimpleLinkService = function () {
	  function SimpleLinkService() {
	    _classCallCheck(this, SimpleLinkService);
	  }
	
	  _createClass(SimpleLinkService, [{
	    key: 'navigateTo',
	    value: function navigateTo(dest) {}
	  }, {
	    key: 'getDestinationHash',
	    value: function getDestinationHash(dest) {
	      return '#';
	    }
	  }, {
	    key: 'getAnchorUrl',
	    value: function getAnchorUrl(hash) {
	      return '#';
	    }
	  }, {
	    key: 'setHash',
	    value: function setHash(hash) {}
	  }, {
	    key: 'executeNamedAction',
	    value: function executeNamedAction(action) {}
	  }, {
	    key: 'onFileAttachmentAnnotation',
	    value: function onFileAttachmentAnnotation(_ref4) {
	      var id = _ref4.id,
	          filename = _ref4.filename,
	          content = _ref4.content;
	    }
	  }, {
	    key: 'cachePageRef',
	    value: function cachePageRef(pageNum, pageRef) {}
	  }, {
	    key: 'page',
	    get: function get() {
	      return 0;
	    },
	    set: function set(value) {}
	  }, {
	    key: 'rotation',
	    get: function get() {
	      return 0;
	    },
	    set: function set(value) {}
	  }]);
	
	  return SimpleLinkService;
	}();
	
	exports.PDFLinkService = PDFLinkService;
	exports.SimpleLinkService = SimpleLinkService;

/***/ },
/* 1720 */
/***/ function(module, exports, __webpack_require__) {

	/* Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	
	var pdfjs = __webpack_require__(1680);
	var PdfjsWorker = __webpack_require__(2068);
	
	if (typeof window !== 'undefined' && 'Worker' in window) {
	  pdfjs.PDFJS.workerPort = new PdfjsWorker();
	} else {
	  pdfjs.PDFJS.disableWorker = true;
	}
	
	module.exports = pdfjs;


/***/ },
/* 1721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(829);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 1722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(829);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 1723 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = require('./lib/has');
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 1724 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(831);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1725 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(454);
	var assign = __webpack_require__(1727);
	
	var ReactPropTypesSecret = __webpack_require__(831);
	var has = __webpack_require__(1726);
	var checkPropTypes = __webpack_require__(1723);
	
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1726 */
/***/ function(module, exports) {

	module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ },
/* 1727 */
47,
/* 1728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(2041);
	var objectAssign = __webpack_require__(1729);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 1729 */
47,
/* 1730 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ },
/* 1731 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(1730);
	exports.encode = exports.stringify = __webpack_require__(1731);


/***/ },
/* 1733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _arrays = __webpack_require__(2032);
	
	var _arrays2 = _interopRequireDefault(_arrays);
	
	var _reactAutowhatever = __webpack_require__(1740);
	
	var _reactAutowhatever2 = _interopRequireDefault(_reactAutowhatever);
	
	var _theme = __webpack_require__(1735);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var alwaysTrue = function alwaysTrue() {
	  return true;
	};
	var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
	  return value.trim().length > 0;
	};
	var defaultRenderSuggestionsContainer = function defaultRenderSuggestionsContainer(_ref) {
	  var containerProps = _ref.containerProps,
	      children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    containerProps,
	    children
	  );
	};
	
	var Autosuggest = function (_Component) {
	  _inherits(Autosuggest, _Component);
	
	  function Autosuggest(_ref2) {
	    var alwaysRenderSuggestions = _ref2.alwaysRenderSuggestions;
	
	    _classCallCheck(this, Autosuggest);
	
	    var _this = _possibleConstructorReturn(this, (Autosuggest.__proto__ || Object.getPrototypeOf(Autosuggest)).call(this));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      isFocused: false,
	      isCollapsed: !alwaysRenderSuggestions,
	      highlightedSectionIndex: null,
	      highlightedSuggestionIndex: null,
	      highlightedSuggestion: null,
	      valueBeforeUpDown: null
	    };
	
	    _this.justPressedUpDown = false;
	    _this.justMouseEntered = false;
	
	    _this.pressedSuggestion = null;
	    return _this;
	  }
	
	  _createClass(Autosuggest, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('mousedown', this.onDocumentMouseDown);
	      document.addEventListener('mouseup', this.onDocumentMouseUp);
	
	      this.input = this.autowhatever.input;
	      this.suggestionsContainer = this.autowhatever.itemsContainer;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ((0, _arrays2.default)(nextProps.suggestions, this.props.suggestions)) {
	        if (nextProps.highlightFirstSuggestion && nextProps.suggestions.length > 0 && this.justPressedUpDown === false && this.justMouseEntered === false) {
	          this.highlightFirstSuggestion();
	        }
	      } else {
	        if (this.willRenderSuggestions(nextProps)) {
	          if (this.state.isCollapsed && !this.justSelectedSuggestion) {
	            this.revealSuggestions();
	          }
	        } else {
	          this.resetHighlightedSuggestion();
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props = this.props,
	          suggestions = _props.suggestions,
	          onSuggestionHighlighted = _props.onSuggestionHighlighted,
	          highlightFirstSuggestion = _props.highlightFirstSuggestion;
	
	
	      if (!(0, _arrays2.default)(suggestions, prevProps.suggestions) && suggestions.length > 0 && highlightFirstSuggestion) {
	        this.highlightFirstSuggestion();
	        return;
	      }
	
	      if (onSuggestionHighlighted) {
	        var highlightedSuggestion = this.getHighlightedSuggestion();
	        var prevHighlightedSuggestion = prevState.highlightedSuggestion;
	
	        if (highlightedSuggestion != prevHighlightedSuggestion) {
	          onSuggestionHighlighted({
	            suggestion: highlightedSuggestion
	          });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousedown', this.onDocumentMouseDown);
	      document.removeEventListener('mouseup', this.onDocumentMouseUp);
	    }
	  }, {
	    key: 'updateHighlightedSuggestion',
	    value: function updateHighlightedSuggestion(sectionIndex, suggestionIndex, prevValue) {
	      var _this2 = this;
	
	      this.setState(function (state) {
	        var valueBeforeUpDown = state.valueBeforeUpDown;
	
	
	        if (suggestionIndex === null) {
	          valueBeforeUpDown = null;
	        } else if (valueBeforeUpDown === null && typeof prevValue !== 'undefined') {
	          valueBeforeUpDown = prevValue;
	        }
	
	        return {
	          highlightedSectionIndex: sectionIndex,
	          highlightedSuggestionIndex: suggestionIndex,
	          highlightedSuggestion: suggestionIndex === null ? null : _this2.getSuggestion(sectionIndex, suggestionIndex),
	          valueBeforeUpDown: valueBeforeUpDown
	        };
	      });
	    }
	  }, {
	    key: 'resetHighlightedSuggestion',
	    value: function resetHighlightedSuggestion() {
	      var shouldResetValueBeforeUpDown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.setState(function (state) {
	        var valueBeforeUpDown = state.valueBeforeUpDown;
	
	
	        return {
	          highlightedSectionIndex: null,
	          highlightedSuggestionIndex: null,
	          highlightedSuggestion: null,
	          valueBeforeUpDown: shouldResetValueBeforeUpDown ? null : valueBeforeUpDown
	        };
	      });
	    }
	  }, {
	    key: 'revealSuggestions',
	    value: function revealSuggestions() {
	      this.setState({
	        isCollapsed: false
	      });
	    }
	  }, {
	    key: 'closeSuggestions',
	    value: function closeSuggestions() {
	      this.setState({
	        highlightedSectionIndex: null,
	        highlightedSuggestionIndex: null,
	        highlightedSuggestion: null,
	        valueBeforeUpDown: null,
	        isCollapsed: true
	      });
	    }
	  }, {
	    key: 'getSuggestion',
	    value: function getSuggestion(sectionIndex, suggestionIndex) {
	      var _props2 = this.props,
	          suggestions = _props2.suggestions,
	          multiSection = _props2.multiSection,
	          getSectionSuggestions = _props2.getSectionSuggestions;
	
	
	      if (multiSection) {
	        return getSectionSuggestions(suggestions[sectionIndex])[suggestionIndex];
	      }
	
	      return suggestions[suggestionIndex];
	    }
	  }, {
	    key: 'getHighlightedSuggestion',
	    value: function getHighlightedSuggestion() {
	      var _state = this.state,
	          highlightedSectionIndex = _state.highlightedSectionIndex,
	          highlightedSuggestionIndex = _state.highlightedSuggestionIndex;
	
	
	      if (highlightedSuggestionIndex === null) {
	        return null;
	      }
	
	      return this.getSuggestion(highlightedSectionIndex, highlightedSuggestionIndex);
	    }
	  }, {
	    key: 'getSuggestionValueByIndex',
	    value: function getSuggestionValueByIndex(sectionIndex, suggestionIndex) {
	      var getSuggestionValue = this.props.getSuggestionValue;
	
	
	      return getSuggestionValue(this.getSuggestion(sectionIndex, suggestionIndex));
	    }
	  }, {
	    key: 'getSuggestionIndices',
	    value: function getSuggestionIndices(suggestionElement) {
	      var sectionIndex = suggestionElement.getAttribute('data-section-index');
	      var suggestionIndex = suggestionElement.getAttribute('data-suggestion-index');
	
	      return {
	        sectionIndex: typeof sectionIndex === 'string' ? parseInt(sectionIndex, 10) : null,
	        suggestionIndex: parseInt(suggestionIndex, 10)
	      };
	    }
	  }, {
	    key: 'findSuggestionElement',
	    value: function findSuggestionElement(startNode) {
	      var node = startNode;
	
	      do {
	        if (node.getAttribute('data-suggestion-index') !== null) {
	          return node;
	        }
	
	        node = node.parentNode;
	      } while (node !== null);
	
	      console.error('Clicked element:', startNode); // eslint-disable-line no-console
	      throw new Error("Couldn't find suggestion element");
	    }
	  }, {
	    key: 'maybeCallOnChange',
	    value: function maybeCallOnChange(event, newValue, method) {
	      var _props$inputProps = this.props.inputProps,
	          value = _props$inputProps.value,
	          onChange = _props$inputProps.onChange;
	
	
	      if (newValue !== value) {
	        onChange(event, { newValue: newValue, method: method });
	      }
	    }
	  }, {
	    key: 'willRenderSuggestions',
	    value: function willRenderSuggestions(props) {
	      var suggestions = props.suggestions,
	          inputProps = props.inputProps,
	          shouldRenderSuggestions = props.shouldRenderSuggestions;
	      var value = inputProps.value;
	
	
	      return suggestions.length > 0 && shouldRenderSuggestions(value);
	    }
	  }, {
	    key: 'getQuery',
	    value: function getQuery() {
	      var inputProps = this.props.inputProps;
	      var value = inputProps.value;
	      var valueBeforeUpDown = this.state.valueBeforeUpDown;
	
	
	      return (valueBeforeUpDown === null ? value : valueBeforeUpDown).trim();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          suggestions = _props3.suggestions,
	          renderInputComponent = _props3.renderInputComponent,
	          onSuggestionsFetchRequested = _props3.onSuggestionsFetchRequested,
	          renderSuggestion = _props3.renderSuggestion,
	          inputProps = _props3.inputProps,
	          multiSection = _props3.multiSection,
	          renderSectionTitle = _props3.renderSectionTitle,
	          id = _props3.id,
	          getSectionSuggestions = _props3.getSectionSuggestions,
	          theme = _props3.theme,
	          getSuggestionValue = _props3.getSuggestionValue,
	          alwaysRenderSuggestions = _props3.alwaysRenderSuggestions,
	          highlightFirstSuggestion = _props3.highlightFirstSuggestion;
	      var _state2 = this.state,
	          isFocused = _state2.isFocused,
	          isCollapsed = _state2.isCollapsed,
	          highlightedSectionIndex = _state2.highlightedSectionIndex,
	          highlightedSuggestionIndex = _state2.highlightedSuggestionIndex,
	          valueBeforeUpDown = _state2.valueBeforeUpDown;
	
	      var shouldRenderSuggestions = alwaysRenderSuggestions ? alwaysTrue : this.props.shouldRenderSuggestions;
	      var value = inputProps.value,
	          _onFocus = inputProps.onFocus,
	          _onKeyDown = inputProps.onKeyDown;
	
	      var willRenderSuggestions = this.willRenderSuggestions(this.props);
	      var isOpen = alwaysRenderSuggestions || isFocused && !isCollapsed && willRenderSuggestions;
	      var items = isOpen ? suggestions : [];
	      var autowhateverInputProps = _extends({}, inputProps, {
	        onFocus: function onFocus(event) {
	          if (!_this3.justSelectedSuggestion && !_this3.justClickedOnSuggestionsContainer) {
	            var shouldRender = shouldRenderSuggestions(value);
	
	            _this3.setState({
	              isFocused: true,
	              isCollapsed: !shouldRender
	            });
	
	            _onFocus && _onFocus(event);
	
	            if (shouldRender) {
	              onSuggestionsFetchRequested({ value: value, reason: 'input-focused' });
	            }
	          }
	        },
	        onBlur: function onBlur(event) {
	          if (_this3.justClickedOnSuggestionsContainer) {
	            _this3.input.focus();
	            return;
	          }
	
	          _this3.blurEvent = event;
	
	          if (!_this3.justSelectedSuggestion) {
	            _this3.onBlur();
	            _this3.onSuggestionsClearRequested();
	          }
	        },
	        onChange: function onChange(event) {
	          var value = event.target.value;
	
	          var shouldRender = shouldRenderSuggestions(value);
	
	          _this3.maybeCallOnChange(event, value, 'type');
	
	          if (_this3.suggestionsContainer) {
	            _this3.suggestionsContainer.scrollTop = 0;
	          }
	
	          _this3.setState(_extends({}, highlightFirstSuggestion ? {} : {
	            highlightedSectionIndex: null,
	            highlightedSuggestionIndex: null,
	            highlightedSuggestion: null
	          }, {
	            valueBeforeUpDown: null,
	            isCollapsed: !shouldRender
	          }));
	
	          if (shouldRender) {
	            onSuggestionsFetchRequested({ value: value, reason: 'input-changed' });
	          } else {
	            _this3.onSuggestionsClearRequested();
	          }
	        },
	        onKeyDown: function onKeyDown(event, data) {
	          var keyCode = event.keyCode;
	
	
	          switch (keyCode) {
	            case 40: // ArrowDown
	            case 38:
	              // ArrowUp
	              if (isCollapsed) {
	                if (shouldRenderSuggestions(value)) {
	                  onSuggestionsFetchRequested({
	                    value: value,
	                    reason: 'suggestions-revealed'
	                  });
	                  _this3.revealSuggestions();
	                }
	              } else if (suggestions.length > 0) {
	                var newHighlightedSectionIndex = data.newHighlightedSectionIndex,
	                    newHighlightedItemIndex = data.newHighlightedItemIndex;
	
	
	                var newValue = void 0;
	
	                if (newHighlightedItemIndex === null) {
	                  // valueBeforeUpDown can be null if, for example, user
	                  // hovers on the first suggestion and then pressed Up.
	                  // If that happens, use the original input value.
	                  newValue = valueBeforeUpDown === null ? value : valueBeforeUpDown;
	                } else {
	                  newValue = _this3.getSuggestionValueByIndex(newHighlightedSectionIndex, newHighlightedItemIndex);
	                }
	
	                _this3.updateHighlightedSuggestion(newHighlightedSectionIndex, newHighlightedItemIndex, value);
	                _this3.maybeCallOnChange(event, newValue, keyCode === 40 ? 'down' : 'up');
	              }
	
	              event.preventDefault(); // Prevents the cursor from moving
	
	              _this3.justPressedUpDown = true;
	
	              setTimeout(function () {
	                _this3.justPressedUpDown = false;
	              });
	
	              break;
	
	            // Enter
	            case 13:
	              {
	                // See #388
	                if (event.keyCode === 229) {
	                  break;
	                }
	
	                var highlightedSuggestion = _this3.getHighlightedSuggestion();
	
	                if (isOpen && !alwaysRenderSuggestions) {
	                  _this3.closeSuggestions();
	                }
	
	                if (highlightedSuggestion != null) {
	                  var _newValue = getSuggestionValue(highlightedSuggestion);
	
	                  _this3.maybeCallOnChange(event, _newValue, 'enter');
	
	                  _this3.onSuggestionSelected(event, {
	                    suggestion: highlightedSuggestion,
	                    suggestionValue: _newValue,
	                    suggestionIndex: highlightedSuggestionIndex,
	                    sectionIndex: highlightedSectionIndex,
	                    method: 'enter'
	                  });
	
	                  _this3.justSelectedSuggestion = true;
	
	                  setTimeout(function () {
	                    _this3.justSelectedSuggestion = false;
	                  });
	                }
	
	                break;
	              }
	
	            // Escape
	            case 27:
	              {
	                if (isOpen) {
	                  // If input.type === 'search', the browser clears the input
	                  // when Escape is pressed. We want to disable this default
	                  // behaviour so that, when suggestions are shown, we just hide
	                  // them, without clearing the input.
	                  event.preventDefault();
	                }
	
	                var willCloseSuggestions = isOpen && !alwaysRenderSuggestions;
	
	                if (valueBeforeUpDown === null) {
	                  // Didn't interact with Up/Down
	                  if (!willCloseSuggestions) {
	                    var _newValue2 = '';
	
	                    _this3.maybeCallOnChange(event, _newValue2, 'escape');
	
	                    if (shouldRenderSuggestions(_newValue2)) {
	                      onSuggestionsFetchRequested({
	                        value: _newValue2,
	                        reason: 'escape-pressed'
	                      });
	                    } else {
	                      _this3.onSuggestionsClearRequested();
	                    }
	                  }
	                } else {
	                  // Interacted with Up/Down
	                  _this3.maybeCallOnChange(event, valueBeforeUpDown, 'escape');
	                }
	
	                if (willCloseSuggestions) {
	                  _this3.onSuggestionsClearRequested();
	                  _this3.closeSuggestions();
	                } else {
	                  _this3.resetHighlightedSuggestion();
	                }
	
	                break;
	              }
	          }
	
	          _onKeyDown && _onKeyDown(event);
	        }
	      });
	      var renderSuggestionData = {
	        query: this.getQuery()
	      };
	
	      return _react2.default.createElement(_reactAutowhatever2.default, {
	        multiSection: multiSection,
	        items: items,
	        renderInputComponent: renderInputComponent,
	        renderItemsContainer: this.renderSuggestionsContainer,
	        renderItem: renderSuggestion,
	        renderItemData: renderSuggestionData,
	        renderSectionTitle: renderSectionTitle,
	        getSectionItems: getSectionSuggestions,
	        highlightedSectionIndex: highlightedSectionIndex,
	        highlightedItemIndex: highlightedSuggestionIndex,
	        inputProps: autowhateverInputProps,
	        itemProps: this.itemProps,
	        theme: (0, _theme.mapToAutowhateverTheme)(theme),
	        id: id,
	        ref: this.storeAutowhateverRef
	      });
	    }
	  }]);
	
	  return Autosuggest;
	}(_react.Component);
	
	Autosuggest.propTypes = {
	  suggestions: _propTypes2.default.array.isRequired,
	  onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props, propName) {
	    var onSuggestionsFetchRequested = props[propName];
	
	    if (typeof onSuggestionsFetchRequested !== 'function') {
	      throw new Error("'onSuggestionsFetchRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp");
	    }
	  },
	  onSuggestionsClearRequested: function onSuggestionsClearRequested(props, propName) {
	    var onSuggestionsClearRequested = props[propName];
	
	    if (props.alwaysRenderSuggestions === false && typeof onSuggestionsClearRequested !== 'function') {
	      throw new Error("'onSuggestionsClearRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp");
	    }
	  },
	  onSuggestionSelected: _propTypes2.default.func,
	  onSuggestionHighlighted: _propTypes2.default.func,
	  renderInputComponent: _propTypes2.default.func,
	  renderSuggestionsContainer: _propTypes2.default.func,
	  getSuggestionValue: _propTypes2.default.func.isRequired,
	  renderSuggestion: _propTypes2.default.func.isRequired,
	  inputProps: function inputProps(props, propName) {
	    var inputProps = props[propName];
	
	    if (!inputProps.hasOwnProperty('value')) {
	      throw new Error("'inputProps' must have 'value'.");
	    }
	
	    if (!inputProps.hasOwnProperty('onChange')) {
	      throw new Error("'inputProps' must have 'onChange'.");
	    }
	  },
	  shouldRenderSuggestions: _propTypes2.default.func,
	  alwaysRenderSuggestions: _propTypes2.default.bool,
	  multiSection: _propTypes2.default.bool,
	  renderSectionTitle: function renderSectionTitle(props, propName) {
	    var renderSectionTitle = props[propName];
	
	    if (props.multiSection === true && typeof renderSectionTitle !== 'function') {
	      throw new Error("'renderSectionTitle' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp");
	    }
	  },
	  getSectionSuggestions: function getSectionSuggestions(props, propName) {
	    var getSectionSuggestions = props[propName];
	
	    if (props.multiSection === true && typeof getSectionSuggestions !== 'function') {
	      throw new Error("'getSectionSuggestions' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp");
	    }
	  },
	  focusInputOnSuggestionClick: _propTypes2.default.bool,
	  highlightFirstSuggestion: _propTypes2.default.bool,
	  theme: _propTypes2.default.object,
	  id: _propTypes2.default.string
	};
	Autosuggest.defaultProps = {
	  renderSuggestionsContainer: defaultRenderSuggestionsContainer,
	  shouldRenderSuggestions: defaultShouldRenderSuggestions,
	  alwaysRenderSuggestions: false,
	  multiSection: false,
	  focusInputOnSuggestionClick: true,
	  highlightFirstSuggestion: false,
	  theme: _theme.defaultTheme,
	  id: '1'
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.onDocumentMouseDown = function (event) {
	    _this4.justClickedOnSuggestionsContainer = false;
	
	    var node = event.detail && event.detail.target || // This is for testing only. Please show me a better way to emulate this.
	    event.target;
	
	    while (node !== null && node !== document) {
	      if (node.getAttribute('data-suggestion-index') !== null) {
	        // Suggestion was clicked
	        return;
	      }
	
	      if (node === _this4.suggestionsContainer) {
	        // Something else inside suggestions container was clicked
	        _this4.justClickedOnSuggestionsContainer = true;
	        return;
	      }
	
	      node = node.parentNode;
	    }
	  };
	
	  this.storeAutowhateverRef = function (autowhatever) {
	    if (autowhatever !== null) {
	      _this4.autowhatever = autowhatever;
	    }
	  };
	
	  this.onSuggestionMouseEnter = function (event, _ref3) {
	    var sectionIndex = _ref3.sectionIndex,
	        itemIndex = _ref3.itemIndex;
	
	    _this4.updateHighlightedSuggestion(sectionIndex, itemIndex);
	
	    if (event.target === _this4.pressedSuggestion) {
	      _this4.justSelectedSuggestion = true;
	    }
	
	    _this4.justMouseEntered = true;
	
	    setTimeout(function () {
	      _this4.justMouseEntered = false;
	    });
	  };
	
	  this.highlightFirstSuggestion = function () {
	    _this4.updateHighlightedSuggestion(_this4.props.multiSection ? 0 : null, 0);
	  };
	
	  this.onDocumentMouseUp = function () {
	    if (_this4.pressedSuggestion && !_this4.justSelectedSuggestion) {
	      _this4.input.focus();
	    }
	    _this4.pressedSuggestion = null;
	  };
	
	  this.onSuggestionMouseDown = function (event) {
	    // Checking if this.justSelectedSuggestion is already true to not duplicate touch events in chrome
	    // See: https://github.com/facebook/react/issues/9809#issuecomment-413978405
	    if (!_this4.justSelectedSuggestion) {
	      _this4.justSelectedSuggestion = true;
	      _this4.pressedSuggestion = event.target;
	    }
	  };
	
	  this.onSuggestionsClearRequested = function () {
	    var onSuggestionsClearRequested = _this4.props.onSuggestionsClearRequested;
	
	
	    onSuggestionsClearRequested && onSuggestionsClearRequested();
	  };
	
	  this.onSuggestionSelected = function (event, data) {
	    var _props4 = _this4.props,
	        alwaysRenderSuggestions = _props4.alwaysRenderSuggestions,
	        onSuggestionSelected = _props4.onSuggestionSelected,
	        onSuggestionsFetchRequested = _props4.onSuggestionsFetchRequested;
	
	
	    onSuggestionSelected && onSuggestionSelected(event, data);
	
	    if (alwaysRenderSuggestions) {
	      onSuggestionsFetchRequested({
	        value: data.suggestionValue,
	        reason: 'suggestion-selected'
	      });
	    } else {
	      _this4.onSuggestionsClearRequested();
	    }
	
	    _this4.resetHighlightedSuggestion();
	  };
	
	  this.onSuggestionClick = function (event) {
	    var _props5 = _this4.props,
	        alwaysRenderSuggestions = _props5.alwaysRenderSuggestions,
	        focusInputOnSuggestionClick = _props5.focusInputOnSuggestionClick;
	
	    var _getSuggestionIndices = _this4.getSuggestionIndices(_this4.findSuggestionElement(event.target)),
	        sectionIndex = _getSuggestionIndices.sectionIndex,
	        suggestionIndex = _getSuggestionIndices.suggestionIndex;
	
	    var clickedSuggestion = _this4.getSuggestion(sectionIndex, suggestionIndex);
	    var clickedSuggestionValue = _this4.props.getSuggestionValue(clickedSuggestion);
	
	    _this4.maybeCallOnChange(event, clickedSuggestionValue, 'click');
	    _this4.onSuggestionSelected(event, {
	      suggestion: clickedSuggestion,
	      suggestionValue: clickedSuggestionValue,
	      suggestionIndex: suggestionIndex,
	      sectionIndex: sectionIndex,
	      method: 'click'
	    });
	
	    if (!alwaysRenderSuggestions) {
	      _this4.closeSuggestions();
	    }
	
	    if (focusInputOnSuggestionClick === true) {
	      _this4.input.focus();
	    } else {
	      _this4.onBlur();
	    }
	
	    setTimeout(function () {
	      _this4.justSelectedSuggestion = false;
	    });
	  };
	
	  this.onBlur = function () {
	    var _props6 = _this4.props,
	        inputProps = _props6.inputProps,
	        shouldRenderSuggestions = _props6.shouldRenderSuggestions;
	    var value = inputProps.value,
	        onBlur = inputProps.onBlur;
	
	    var highlightedSuggestion = _this4.getHighlightedSuggestion();
	    var shouldRender = shouldRenderSuggestions(value);
	
	    _this4.setState({
	      isFocused: false,
	      highlightedSectionIndex: null,
	      highlightedSuggestionIndex: null,
	      highlightedSuggestion: null,
	      valueBeforeUpDown: null,
	      isCollapsed: !shouldRender
	    });
	
	    onBlur && onBlur(_this4.blurEvent, { highlightedSuggestion: highlightedSuggestion });
	  };
	
	  this.onSuggestionMouseLeave = function (event) {
	    _this4.resetHighlightedSuggestion(false); // shouldResetValueBeforeUpDown
	
	    if (_this4.justSelectedSuggestion && event.target === _this4.pressedSuggestion) {
	      _this4.justSelectedSuggestion = false;
	    }
	  };
	
	  this.onSuggestionTouchStart = function () {
	    _this4.justSelectedSuggestion = true;
	    // todo: event.preventDefault when https://github.com/facebook/react/issues/2043
	    // todo: gets released so onSuggestionMouseDown won't fire in chrome
	  };
	
	  this.onSuggestionTouchMove = function () {
	    _this4.justSelectedSuggestion = false;
	    _this4.pressedSuggestion = null;
	    _this4.input.focus();
	  };
	
	  this.itemProps = function (_ref4) {
	    var sectionIndex = _ref4.sectionIndex,
	        itemIndex = _ref4.itemIndex;
	
	    return {
	      'data-section-index': sectionIndex,
	      'data-suggestion-index': itemIndex,
	      onMouseEnter: _this4.onSuggestionMouseEnter,
	      onMouseLeave: _this4.onSuggestionMouseLeave,
	      onMouseDown: _this4.onSuggestionMouseDown,
	      onTouchStart: _this4.onSuggestionTouchStart,
	      onTouchMove: _this4.onSuggestionTouchMove,
	      onClick: _this4.onSuggestionClick
	    };
	  };
	
	  this.renderSuggestionsContainer = function (_ref5) {
	    var containerProps = _ref5.containerProps,
	        children = _ref5.children;
	    var renderSuggestionsContainer = _this4.props.renderSuggestionsContainer;
	
	
	    return renderSuggestionsContainer({
	      containerProps: containerProps,
	      children: children,
	      query: _this4.getQuery()
	    });
	  };
	};
	
	exports.default = Autosuggest;

/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1733).default;

/***/ },
/* 1735 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var defaultTheme = exports.defaultTheme = {
	  container: 'react-autosuggest__container',
	  containerOpen: 'react-autosuggest__container--open',
	  input: 'react-autosuggest__input',
	  inputOpen: 'react-autosuggest__input--open',
	  inputFocused: 'react-autosuggest__input--focused',
	  suggestionsContainer: 'react-autosuggest__suggestions-container',
	  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
	  suggestionsList: 'react-autosuggest__suggestions-list',
	  suggestion: 'react-autosuggest__suggestion',
	  suggestionFirst: 'react-autosuggest__suggestion--first',
	  suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
	  sectionContainer: 'react-autosuggest__section-container',
	  sectionContainerFirst: 'react-autosuggest__section-container--first',
	  sectionTitle: 'react-autosuggest__section-title'
	};
	
	var mapToAutowhateverTheme = exports.mapToAutowhateverTheme = function mapToAutowhateverTheme(theme) {
	  var result = {};
	
	  for (var key in theme) {
	    switch (key) {
	      case 'suggestionsContainer':
	        result['itemsContainer'] = theme[key];
	        break;
	
	      case 'suggestionsContainerOpen':
	        result['itemsContainerOpen'] = theme[key];
	        break;
	
	      case 'suggestion':
	        result['item'] = theme[key];
	        break;
	
	      case 'suggestionFirst':
	        result['itemFirst'] = theme[key];
	        break;
	
	      case 'suggestionHighlighted':
	        result['itemHighlighted'] = theme[key];
	        break;
	
	      case 'suggestionsList':
	        result['itemsList'] = theme[key];
	        break;
	
	      default:
	        result[key] = theme[key];
	    }
	  }
	
	  return result;
	};

/***/ },
/* 1736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _sectionIterator = __webpack_require__(2020);
	
	var _sectionIterator2 = _interopRequireDefault(_sectionIterator);
	
	var _reactThemeable = __webpack_require__(1956);
	
	var _reactThemeable2 = _interopRequireDefault(_reactThemeable);
	
	var _SectionTitle = __webpack_require__(1739);
	
	var _SectionTitle2 = _interopRequireDefault(_SectionTitle);
	
	var _ItemsList = __webpack_require__(1738);
	
	var _ItemsList2 = _interopRequireDefault(_ItemsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var emptyObject = {};
	var defaultRenderInputComponent = function defaultRenderInputComponent(props) {
	  return _react2.default.createElement('input', props);
	};
	var defaultRenderItemsContainer = function defaultRenderItemsContainer(_ref) {
	  var containerProps = _ref.containerProps,
	      children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    containerProps,
	    children
	  );
	};
	var defaultTheme = {
	  container: 'react-autowhatever__container',
	  containerOpen: 'react-autowhatever__container--open',
	  input: 'react-autowhatever__input',
	  inputOpen: 'react-autowhatever__input--open',
	  inputFocused: 'react-autowhatever__input--focused',
	  itemsContainer: 'react-autowhatever__items-container',
	  itemsContainerOpen: 'react-autowhatever__items-container--open',
	  itemsList: 'react-autowhatever__items-list',
	  item: 'react-autowhatever__item',
	  itemFirst: 'react-autowhatever__item--first',
	  itemHighlighted: 'react-autowhatever__item--highlighted',
	  sectionContainer: 'react-autowhatever__section-container',
	  sectionContainerFirst: 'react-autowhatever__section-container--first',
	  sectionTitle: 'react-autowhatever__section-title'
	};
	
	var Autowhatever = function (_Component) {
	  _inherits(Autowhatever, _Component);
	
	  function Autowhatever(props) {
	    _classCallCheck(this, Autowhatever);
	
	    var _this = _possibleConstructorReturn(this, (Autowhatever.__proto__ || Object.getPrototypeOf(Autowhatever)).call(this, props));
	
	    _this.storeInputReference = function (input) {
	      if (input !== null) {
	        _this.input = input;
	      }
	    };
	
	    _this.storeItemsContainerReference = function (itemsContainer) {
	      if (itemsContainer !== null) {
	        _this.itemsContainer = itemsContainer;
	      }
	    };
	
	    _this.onHighlightedItemChange = function (highlightedItem) {
	      _this.highlightedItem = highlightedItem;
	    };
	
	    _this.getItemId = function (sectionIndex, itemIndex) {
	      if (itemIndex === null) {
	        return null;
	      }
	
	      var id = _this.props.id;
	
	      var section = sectionIndex === null ? '' : 'section-' + sectionIndex;
	
	      return 'react-autowhatever-' + id + '-' + section + '-item-' + itemIndex;
	    };
	
	    _this.onFocus = function (event) {
	      var inputProps = _this.props.inputProps;
	
	
	      _this.setState({
	        isInputFocused: true
	      });
	
	      inputProps.onFocus && inputProps.onFocus(event);
	    };
	
	    _this.onBlur = function (event) {
	      var inputProps = _this.props.inputProps;
	
	
	      _this.setState({
	        isInputFocused: false
	      });
	
	      inputProps.onBlur && inputProps.onBlur(event);
	    };
	
	    _this.onKeyDown = function (event) {
	      var _this$props = _this.props,
	          inputProps = _this$props.inputProps,
	          highlightedSectionIndex = _this$props.highlightedSectionIndex,
	          highlightedItemIndex = _this$props.highlightedItemIndex;
	
	
	      switch (event.key) {
	        case 'ArrowDown':
	        case 'ArrowUp':
	          {
	            var nextPrev = event.key === 'ArrowDown' ? 'next' : 'prev';
	
	            var _this$sectionIterator = _this.sectionIterator[nextPrev]([highlightedSectionIndex, highlightedItemIndex]),
	                _this$sectionIterator2 = _slicedToArray(_this$sectionIterator, 2),
	                newHighlightedSectionIndex = _this$sectionIterator2[0],
	                newHighlightedItemIndex = _this$sectionIterator2[1];
	
	            inputProps.onKeyDown(event, { newHighlightedSectionIndex: newHighlightedSectionIndex, newHighlightedItemIndex: newHighlightedItemIndex });
	            break;
	          }
	
	        default:
	          inputProps.onKeyDown(event, { highlightedSectionIndex: highlightedSectionIndex, highlightedItemIndex: highlightedItemIndex });
	      }
	    };
	
	    _this.highlightedItem = null;
	
	    _this.state = {
	      isInputFocused: false
	    };
	
	    _this.setSectionsItems(props);
	    _this.setSectionIterator(props);
	    _this.setTheme(props);
	    return _this;
	  }
	
	  _createClass(Autowhatever, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.ensureHighlightedItemIsVisible();
	    }
	
	    // eslint-disable-next-line camelcase, react/sort-comp
	
	  }, {
	    key: 'UNSAFE_componentWillReceiveProps',
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      if (nextProps.items !== this.props.items) {
	        this.setSectionsItems(nextProps);
	      }
	
	      if (nextProps.items !== this.props.items || nextProps.multiSection !== this.props.multiSection) {
	        this.setSectionIterator(nextProps);
	      }
	
	      if (nextProps.theme !== this.props.theme) {
	        this.setTheme(nextProps);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.ensureHighlightedItemIsVisible();
	    }
	  }, {
	    key: 'setSectionsItems',
	    value: function setSectionsItems(props) {
	      if (props.multiSection) {
	        this.sectionsItems = props.items.map(function (section) {
	          return props.getSectionItems(section);
	        });
	        this.sectionsLengths = this.sectionsItems.map(function (items) {
	          return items.length;
	        });
	        this.allSectionsAreEmpty = this.sectionsLengths.every(function (itemsCount) {
	          return itemsCount === 0;
	        });
	      }
	    }
	  }, {
	    key: 'setSectionIterator',
	    value: function setSectionIterator(props) {
	      this.sectionIterator = (0, _sectionIterator2.default)({
	        multiSection: props.multiSection,
	        data: props.multiSection ? this.sectionsLengths : props.items.length
	      });
	    }
	  }, {
	    key: 'setTheme',
	    value: function setTheme(props) {
	      this.theme = (0, _reactThemeable2.default)(props.theme);
	    }
	  }, {
	    key: 'renderSections',
	    value: function renderSections() {
	      var _this2 = this;
	
	      if (this.allSectionsAreEmpty) {
	        return null;
	      }
	
	      var theme = this.theme;
	      var _props = this.props,
	          id = _props.id,
	          items = _props.items,
	          renderItem = _props.renderItem,
	          renderItemData = _props.renderItemData,
	          renderSectionTitle = _props.renderSectionTitle,
	          highlightedSectionIndex = _props.highlightedSectionIndex,
	          highlightedItemIndex = _props.highlightedItemIndex,
	          itemProps = _props.itemProps;
	
	
	      return items.map(function (section, sectionIndex) {
	        var keyPrefix = 'react-autowhatever-' + id + '-';
	        var sectionKeyPrefix = keyPrefix + 'section-' + sectionIndex + '-';
	        var isFirstSection = sectionIndex === 0;
	
	        // `key` is provided by theme()
	        /* eslint-disable react/jsx-key */
	        return _react2.default.createElement(
	          'div',
	          theme(sectionKeyPrefix + 'container', 'sectionContainer', isFirstSection && 'sectionContainerFirst'),
	          _react2.default.createElement(_SectionTitle2.default, {
	            section: section,
	            renderSectionTitle: renderSectionTitle,
	            theme: theme,
	            sectionKeyPrefix: sectionKeyPrefix
	          }),
	          _react2.default.createElement(_ItemsList2.default, {
	            items: _this2.sectionsItems[sectionIndex],
	            itemProps: itemProps,
	            renderItem: renderItem,
	            renderItemData: renderItemData,
	            sectionIndex: sectionIndex,
	            highlightedItemIndex: highlightedSectionIndex === sectionIndex ? highlightedItemIndex : null,
	            onHighlightedItemChange: _this2.onHighlightedItemChange,
	            getItemId: _this2.getItemId,
	            theme: theme,
	            keyPrefix: keyPrefix,
	            ref: _this2.storeItemsListReference
	          })
	        );
	        /* eslint-enable react/jsx-key */
	      });
	    }
	  }, {
	    key: 'renderItems',
	    value: function renderItems() {
	      var items = this.props.items;
	
	
	      if (items.length === 0) {
	        return null;
	      }
	
	      var theme = this.theme;
	      var _props2 = this.props,
	          id = _props2.id,
	          renderItem = _props2.renderItem,
	          renderItemData = _props2.renderItemData,
	          highlightedSectionIndex = _props2.highlightedSectionIndex,
	          highlightedItemIndex = _props2.highlightedItemIndex,
	          itemProps = _props2.itemProps;
	
	
	      return _react2.default.createElement(_ItemsList2.default, {
	        items: items,
	        itemProps: itemProps,
	        renderItem: renderItem,
	        renderItemData: renderItemData,
	        highlightedItemIndex: highlightedSectionIndex === null ? highlightedItemIndex : null,
	        onHighlightedItemChange: this.onHighlightedItemChange,
	        getItemId: this.getItemId,
	        theme: theme,
	        keyPrefix: 'react-autowhatever-' + id + '-'
	      });
	    }
	  }, {
	    key: 'ensureHighlightedItemIsVisible',
	    value: function ensureHighlightedItemIsVisible() {
	      var highlightedItem = this.highlightedItem;
	
	
	      if (!highlightedItem) {
	        return;
	      }
	
	      var itemsContainer = this.itemsContainer;
	
	      var itemOffsetRelativeToContainer = highlightedItem.offsetParent === itemsContainer ? highlightedItem.offsetTop : highlightedItem.offsetTop - itemsContainer.offsetTop;
	
	      var scrollTop = itemsContainer.scrollTop; // Top of the visible area
	
	      if (itemOffsetRelativeToContainer < scrollTop) {
	        // Item is off the top of the visible area
	        scrollTop = itemOffsetRelativeToContainer;
	      } else if (itemOffsetRelativeToContainer + highlightedItem.offsetHeight > scrollTop + itemsContainer.offsetHeight) {
	        // Item is off the bottom of the visible area
	        scrollTop = itemOffsetRelativeToContainer + highlightedItem.offsetHeight - itemsContainer.offsetHeight;
	      }
	
	      if (scrollTop !== itemsContainer.scrollTop) {
	        itemsContainer.scrollTop = scrollTop;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var theme = this.theme;
	      var _props3 = this.props,
	          id = _props3.id,
	          multiSection = _props3.multiSection,
	          renderInputComponent = _props3.renderInputComponent,
	          renderItemsContainer = _props3.renderItemsContainer,
	          highlightedSectionIndex = _props3.highlightedSectionIndex,
	          highlightedItemIndex = _props3.highlightedItemIndex;
	      var isInputFocused = this.state.isInputFocused;
	
	      var renderedItems = multiSection ? this.renderSections() : this.renderItems();
	      var isOpen = renderedItems !== null;
	      var ariaActivedescendant = this.getItemId(highlightedSectionIndex, highlightedItemIndex);
	      var itemsContainerId = 'react-autowhatever-' + id;
	      var containerProps = _extends({
	        role: 'combobox',
	        'aria-haspopup': 'listbox',
	        'aria-owns': itemsContainerId,
	        'aria-expanded': isOpen
	      }, theme('react-autowhatever-' + id + '-container', 'container', isOpen && 'containerOpen'), this.props.containerProps);
	      var inputComponent = renderInputComponent(_extends({
	        type: 'text',
	        value: '',
	        autoComplete: 'off',
	        'aria-autocomplete': 'list',
	        'aria-controls': itemsContainerId,
	        'aria-activedescendant': ariaActivedescendant
	      }, theme('react-autowhatever-' + id + '-input', 'input', isOpen && 'inputOpen', isInputFocused && 'inputFocused'), this.props.inputProps, {
	        onFocus: this.onFocus,
	        onBlur: this.onBlur,
	        onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
	        ref: this.storeInputReference
	      }));
	      var itemsContainer = renderItemsContainer({
	        containerProps: _extends({
	          id: itemsContainerId,
	          role: 'listbox'
	        }, theme('react-autowhatever-' + id + '-items-container', 'itemsContainer', isOpen && 'itemsContainerOpen'), {
	          ref: this.storeItemsContainerReference
	        }),
	        children: renderedItems
	      });
	
	      return _react2.default.createElement(
	        'div',
	        containerProps,
	        inputComponent,
	        itemsContainer
	      );
	    }
	  }]);
	
	  return Autowhatever;
	}(_react.Component);
	
	Autowhatever.propTypes = {
	  id: _propTypes2.default.string, // Used in aria-* attributes. If multiple Autowhatever's are rendered on a page, they must have unique ids.
	  multiSection: _propTypes2.default.bool, // Indicates whether a multi section layout should be rendered.
	  renderInputComponent: _propTypes2.default.func, // When specified, it is used to render the input element.
	  renderItemsContainer: _propTypes2.default.func, // Renders the items container.
	  items: _propTypes2.default.array.isRequired, // Array of items or sections to render.
	  renderItem: _propTypes2.default.func, // This function renders a single item.
	  renderItemData: _propTypes2.default.object, // Arbitrary data that will be passed to renderItem()
	  renderSectionTitle: _propTypes2.default.func, // This function gets a section and renders its title.
	  getSectionItems: _propTypes2.default.func, // This function gets a section and returns its items, which will be passed into `renderItem` for rendering.
	  containerProps: _propTypes2.default.object, // Arbitrary container props
	  inputProps: _propTypes2.default.object, // Arbitrary input props
	  itemProps: _propTypes2.default.oneOfType([// Arbitrary item props
	  _propTypes2.default.object, _propTypes2.default.func]),
	  highlightedSectionIndex: _propTypes2.default.number, // Section index of the highlighted item
	  highlightedItemIndex: _propTypes2.default.number, // Highlighted item index (within a section)
	  theme: _propTypes2.default.oneOfType([// Styles. See: https://github.com/markdalgleish/react-themeable
	  _propTypes2.default.object, _propTypes2.default.array])
	};
	Autowhatever.defaultProps = {
	  id: '1',
	  multiSection: false,
	  renderInputComponent: defaultRenderInputComponent,
	  renderItemsContainer: defaultRenderItemsContainer,
	  renderItem: function renderItem() {
	    throw new Error('`renderItem` must be provided');
	  },
	  renderItemData: emptyObject,
	  renderSectionTitle: function renderSectionTitle() {
	    throw new Error('`renderSectionTitle` must be provided');
	  },
	  getSectionItems: function getSectionItems() {
	    throw new Error('`getSectionItems` must be provided');
	  },
	  containerProps: emptyObject,
	  inputProps: emptyObject,
	  itemProps: emptyObject,
	  highlightedSectionIndex: null,
	  highlightedItemIndex: null,
	  theme: defaultTheme
	};
	exports.default = Autowhatever;

/***/ },
/* 1737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compareObjects = __webpack_require__(427);
	
	var _compareObjects2 = _interopRequireDefault(_compareObjects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Item = function (_Component) {
	  _inherits(Item, _Component);
	
	  function Item() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Item);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Item.__proto__ || Object.getPrototypeOf(Item)).call.apply(_ref, [this].concat(args))), _this), _this.storeItemReference = function (item) {
	      if (item !== null) {
	        _this.item = item;
	      }
	    }, _this.onMouseEnter = function (event) {
	      var _this$props = _this.props,
	          sectionIndex = _this$props.sectionIndex,
	          itemIndex = _this$props.itemIndex;
	
	
	      _this.props.onMouseEnter(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
	    }, _this.onMouseLeave = function (event) {
	      var _this$props2 = _this.props,
	          sectionIndex = _this$props2.sectionIndex,
	          itemIndex = _this$props2.itemIndex;
	
	
	      _this.props.onMouseLeave(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
	    }, _this.onMouseDown = function (event) {
	      var _this$props3 = _this.props,
	          sectionIndex = _this$props3.sectionIndex,
	          itemIndex = _this$props3.itemIndex;
	
	
	      _this.props.onMouseDown(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
	    }, _this.onClick = function (event) {
	      var _this$props4 = _this.props,
	          sectionIndex = _this$props4.sectionIndex,
	          itemIndex = _this$props4.itemIndex;
	
	
	      _this.props.onClick(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Item, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects2.default)(nextProps, this.props, ['renderItemData']);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isHighlighted = _props.isHighlighted,
	          item = _props.item,
	          renderItem = _props.renderItem,
	          renderItemData = _props.renderItemData,
	          restProps = _objectWithoutProperties(_props, ['isHighlighted', 'item', 'renderItem', 'renderItemData']);
	
	      delete restProps.sectionIndex;
	      delete restProps.itemIndex;
	
	      if (typeof restProps.onMouseEnter === 'function') {
	        restProps.onMouseEnter = this.onMouseEnter;
	      }
	
	      if (typeof restProps.onMouseLeave === 'function') {
	        restProps.onMouseLeave = this.onMouseLeave;
	      }
	
	      if (typeof restProps.onMouseDown === 'function') {
	        restProps.onMouseDown = this.onMouseDown;
	      }
	
	      if (typeof restProps.onClick === 'function') {
	        restProps.onClick = this.onClick;
	      }
	
	      return _react2.default.createElement(
	        'li',
	        _extends({ role: 'option' }, restProps, { ref: this.storeItemReference }),
	        renderItem(item, _extends({ isHighlighted: isHighlighted }, renderItemData))
	      );
	    }
	  }]);
	
	  return Item;
	}(_react.Component);
	
	Item.propTypes = {
	  sectionIndex: _propTypes2.default.number,
	  isHighlighted: _propTypes2.default.bool.isRequired,
	  itemIndex: _propTypes2.default.number.isRequired,
	  item: _propTypes2.default.any.isRequired,
	  renderItem: _propTypes2.default.func.isRequired,
	  renderItemData: _propTypes2.default.object.isRequired,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onMouseDown: _propTypes2.default.func,
	  onClick: _propTypes2.default.func
	};
	exports.default = Item;

/***/ },
/* 1738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Item = __webpack_require__(1737);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	var _compareObjects = __webpack_require__(427);
	
	var _compareObjects2 = _interopRequireDefault(_compareObjects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ItemsList = function (_Component) {
	  _inherits(ItemsList, _Component);
	
	  function ItemsList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ItemsList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemsList.__proto__ || Object.getPrototypeOf(ItemsList)).call.apply(_ref, [this].concat(args))), _this), _this.storeHighlightedItemReference = function (highlightedItem) {
	      _this.props.onHighlightedItemChange(highlightedItem === null ? null : highlightedItem.item);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ItemsList, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects2.default)(nextProps, this.props, ['itemProps']);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          items = _props.items,
	          itemProps = _props.itemProps,
	          renderItem = _props.renderItem,
	          renderItemData = _props.renderItemData,
	          sectionIndex = _props.sectionIndex,
	          highlightedItemIndex = _props.highlightedItemIndex,
	          getItemId = _props.getItemId,
	          theme = _props.theme,
	          keyPrefix = _props.keyPrefix;
	
	      var sectionPrefix = sectionIndex === null ? keyPrefix : keyPrefix + 'section-' + sectionIndex + '-';
	      var isItemPropsFunction = typeof itemProps === 'function';
	
	      return _react2.default.createElement(
	        'ul',
	        _extends({ role: 'listbox' }, theme(sectionPrefix + 'items-list', 'itemsList')),
	        items.map(function (item, itemIndex) {
	          var isFirst = itemIndex === 0;
	          var isHighlighted = itemIndex === highlightedItemIndex;
	          var itemKey = sectionPrefix + 'item-' + itemIndex;
	          var itemPropsObj = isItemPropsFunction ? itemProps({ sectionIndex: sectionIndex, itemIndex: itemIndex }) : itemProps;
	          var allItemProps = _extends({
	            id: getItemId(sectionIndex, itemIndex),
	            'aria-selected': isHighlighted
	          }, theme(itemKey, 'item', isFirst && 'itemFirst', isHighlighted && 'itemHighlighted'), itemPropsObj);
	
	          if (isHighlighted) {
	            allItemProps.ref = _this2.storeHighlightedItemReference;
	          }
	
	          // `key` is provided by theme()
	          /* eslint-disable react/jsx-key */
	          return _react2.default.createElement(_Item2.default, _extends({}, allItemProps, {
	            sectionIndex: sectionIndex,
	            isHighlighted: isHighlighted,
	            itemIndex: itemIndex,
	            item: item,
	            renderItem: renderItem,
	            renderItemData: renderItemData
	          }));
	          /* eslint-enable react/jsx-key */
	        })
	      );
	    }
	  }]);
	
	  return ItemsList;
	}(_react.Component);
	
	ItemsList.propTypes = {
	  items: _propTypes2.default.array.isRequired,
	  itemProps: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
	  renderItem: _propTypes2.default.func.isRequired,
	  renderItemData: _propTypes2.default.object.isRequired,
	  sectionIndex: _propTypes2.default.number,
	  highlightedItemIndex: _propTypes2.default.number,
	  onHighlightedItemChange: _propTypes2.default.func.isRequired,
	  getItemId: _propTypes2.default.func.isRequired,
	  theme: _propTypes2.default.func.isRequired,
	  keyPrefix: _propTypes2.default.string.isRequired
	};
	ItemsList.defaultProps = {
	  sectionIndex: null
	};
	exports.default = ItemsList;

/***/ },
/* 1739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compareObjects = __webpack_require__(427);
	
	var _compareObjects2 = _interopRequireDefault(_compareObjects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SectionTitle = function (_Component) {
	  _inherits(SectionTitle, _Component);
	
	  function SectionTitle() {
	    _classCallCheck(this, SectionTitle);
	
	    return _possibleConstructorReturn(this, (SectionTitle.__proto__ || Object.getPrototypeOf(SectionTitle)).apply(this, arguments));
	  }
	
	  _createClass(SectionTitle, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects2.default)(nextProps, this.props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          section = _props.section,
	          renderSectionTitle = _props.renderSectionTitle,
	          theme = _props.theme,
	          sectionKeyPrefix = _props.sectionKeyPrefix;
	
	      var sectionTitle = renderSectionTitle(section);
	
	      if (!sectionTitle) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        theme(sectionKeyPrefix + 'title', 'sectionTitle'),
	        sectionTitle
	      );
	    }
	  }]);
	
	  return SectionTitle;
	}(_react.Component);
	
	SectionTitle.propTypes = {
	  section: _propTypes2.default.any.isRequired,
	  renderSectionTitle: _propTypes2.default.func.isRequired,
	  theme: _propTypes2.default.func.isRequired,
	  sectionKeyPrefix: _propTypes2.default.string.isRequired
	};
	exports.default = SectionTitle;

/***/ },
/* 1740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1736).default;

/***/ },
/* 1741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelGroup = __webpack_require__(848);
	
	var _PanelGroup2 = _interopRequireDefault(_PanelGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Accordion = function (_React$Component) {
	  (0, _inherits3['default'])(Accordion, _React$Component);
	
	  function Accordion() {
	    (0, _classCallCheck3['default'])(this, Accordion);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Accordion.prototype.render = function render() {
	    return _react2['default'].createElement(
	      _PanelGroup2['default'],
	      (0, _extends3['default'])({}, this.props, { accordion: true }),
	      this.props.children
	    );
	  };
	
	  return Accordion;
	}(_react2['default'].Component);
	
	exports['default'] = Accordion;
	module.exports = exports['default'];

/***/ },
/* 1742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(156);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onDismiss: _propTypes2['default'].func,
	  closeLabel: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  closeLabel: 'Close alert'
	};
	
	var Alert = function (_React$Component) {
	  (0, _inherits3['default'])(Alert, _React$Component);
	
	  function Alert() {
	    (0, _classCallCheck3['default'])(this, Alert);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Alert.prototype.renderDismissButton = function renderDismissButton(onDismiss) {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close',
	        onClick: onDismiss,
	        'aria-hidden': 'true',
	        tabIndex: '-1'
	      },
	      _react2['default'].createElement(
	        'span',
	        null,
	        '\xD7'
	      )
	    );
	  };
	
	  Alert.prototype.renderSrOnlyDismissButton = function renderSrOnlyDismissButton(onDismiss, closeLabel) {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close sr-only',
	        onClick: onDismiss
	      },
	      closeLabel
	    );
	  };
	
	  Alert.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        onDismiss = _props.onDismiss,
	        closeLabel = _props.closeLabel,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onDismiss', 'closeLabel', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var dismissable = !!onDismiss;
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dismissable')] = dismissable, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'alert',
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      dismissable && this.renderDismissButton(onDismiss),
	      children,
	      dismissable && this.renderSrOnlyDismissButton(onDismiss, closeLabel)
	    );
	  };
	
	  return Alert;
	}(_react2['default'].Component);
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), _StyleConfig.State.INFO, (0, _bootstrapUtils.bsClass)('alert', Alert));
	module.exports = exports['default'];

/***/ },
/* 1743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `pullRight` doesn't belong here. There's no special handling here.
	
	var propTypes = {
	  pullRight: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  pullRight: false
	};
	
	var Badge = function (_React$Component) {
	  (0, _inherits3['default'])(Badge, _React$Component);
	
	  function Badge() {
	    (0, _classCallCheck3['default'])(this, Badge);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Badge.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Badge.prototype.render = function render() {
	    var _props = this.props,
	        pullRight = _props.pullRight,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['pullRight', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'pull-right': pullRight,
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Badge;
	}(_react2['default'].Component);
	
	Badge.propTypes = propTypes;
	Badge.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('badge', Badge);
	module.exports = exports['default'];

/***/ },
/* 1744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BreadcrumbItem = __webpack_require__(832);
	
	var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Breadcrumb = function (_React$Component) {
	  (0, _inherits3['default'])(Breadcrumb, _React$Component);
	
	  function Breadcrumb() {
	    (0, _classCallCheck3['default'])(this, Breadcrumb);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Breadcrumb.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('ol', (0, _extends3['default'])({}, elementProps, {
	      role: 'navigation',
	      'aria-label': 'breadcrumbs',
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Breadcrumb;
	}(_react2['default'].Component);
	
	Breadcrumb.Item = _BreadcrumbItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('breadcrumb', Breadcrumb);
	module.exports = exports['default'];

/***/ },
/* 1745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(221);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ButtonToolbar = function (_React$Component) {
	  (0, _inherits3['default'])(ButtonToolbar, _React$Component);
	
	  function ButtonToolbar() {
	    (0, _classCallCheck3['default'])(this, ButtonToolbar);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonToolbar.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'toolbar',
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ButtonToolbar;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn-toolbar', (0, _bootstrapUtils.bsSizes)(_Button2['default'].SIZES, ButtonToolbar));
	module.exports = exports['default'];

/***/ },
/* 1746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CarouselCaption = __webpack_require__(1747);
	
	var _CarouselCaption2 = _interopRequireDefault(_CarouselCaption);
	
	var _CarouselItem = __webpack_require__(834);
	
	var _CarouselItem2 = _interopRequireDefault(_CarouselItem);
	
	var _Glyphicon = __webpack_require__(429);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _SafeAnchor = __webpack_require__(103);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _ValidComponentChildren = __webpack_require__(71);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `slide` should be `animate`.
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  slide: _propTypes2['default'].bool,
	  indicators: _propTypes2['default'].bool,
	  interval: _propTypes2['default'].number,
	  controls: _propTypes2['default'].bool,
	  pauseOnHover: _propTypes2['default'].bool,
	  wrap: _propTypes2['default'].bool,
	  /**
	   * Callback fired when the active item changes.
	   *
	   * ```js
	   * (eventKey: any) => any | (eventKey: any, event: Object) => any
	   * ```
	   *
	   * If this callback takes two or more arguments, the second argument will
	   * be a persisted event object with `direction` set to the direction of the
	   * transition.
	   */
	  onSelect: _propTypes2['default'].func,
	  onSlideEnd: _propTypes2['default'].func,
	  activeIndex: _propTypes2['default'].number,
	  defaultActiveIndex: _propTypes2['default'].number,
	  direction: _propTypes2['default'].oneOf(['prev', 'next']),
	  prevIcon: _propTypes2['default'].node,
	  /**
	   * Label shown to screen readers only, can be used to show the previous element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  prevLabel: _propTypes2['default'].string,
	  nextIcon: _propTypes2['default'].node,
	  /**
	   * Label shown to screen readers only, can be used to show the next element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  nextLabel: _propTypes2['default'].string
	};
	
	var defaultProps = {
	  slide: true,
	  interval: 5000,
	  pauseOnHover: true,
	  wrap: true,
	  indicators: true,
	  controls: true,
	  prevIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-left' }),
	  prevLabel: 'Previous',
	  nextIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-right' }),
	  nextLabel: 'Next'
	};
	
	var Carousel = function (_React$Component) {
	  (0, _inherits3['default'])(Carousel, _React$Component);
	
	  function Carousel(props, context) {
	    (0, _classCallCheck3['default'])(this, Carousel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handlePrev = _this.handlePrev.bind(_this);
	    _this.handleNext = _this.handleNext.bind(_this);
	    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);
	
	    var defaultActiveIndex = props.defaultActiveIndex;
	
	
	    _this.state = {
	      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
	      previousActiveIndex: null,
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var activeIndex = this.getActiveIndex();
	
	    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
	      clearTimeout(this.timeout);
	
	      this.setState({
	        previousActiveIndex: activeIndex,
	        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
	      });
	    }
	  };
	
	  Carousel.prototype.componentDidMount = function componentDidMount() {
	    this.waitForNext();
	  };
	
	  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	    this.isUnmounted = true;
	  };
	
	  Carousel.prototype.handleMouseOver = function handleMouseOver() {
	    if (this.props.pauseOnHover) {
	      this.pause();
	    }
	  };
	
	  Carousel.prototype.handleMouseOut = function handleMouseOut() {
	    if (this.isPaused) {
	      this.play();
	    }
	  };
	
	  Carousel.prototype.handlePrev = function handlePrev(e) {
	    var index = this.getActiveIndex() - 1;
	
	    if (index < 0) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = _ValidComponentChildren2['default'].count(this.props.children) - 1;
	    }
	
	    this.select(index, e, 'prev');
	  };
	
	  Carousel.prototype.handleNext = function handleNext(e) {
	    var index = this.getActiveIndex() + 1;
	    var count = _ValidComponentChildren2['default'].count(this.props.children);
	
	    if (index > count - 1) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = 0;
	    }
	
	    this.select(index, e, 'next');
	  };
	
	  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
	    var _this2 = this;
	
	    this.setState({
	      previousActiveIndex: null,
	      direction: null
	    }, function () {
	      _this2.waitForNext();
	
	      if (_this2.props.onSlideEnd) {
	        _this2.props.onSlideEnd();
	      }
	    });
	  };
	
	  Carousel.prototype.getActiveIndex = function getActiveIndex() {
	    var activeIndexProp = this.props.activeIndex;
	    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
	  };
	
	  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
	    if (prevIndex === index) {
	      return null;
	    }
	
	    return prevIndex > index ? 'prev' : 'next';
	  };
	
	  Carousel.prototype.select = function select(index, e, direction) {
	    clearTimeout(this.timeout);
	
	    // TODO: Is this necessary? Seems like the only risk is if the component
	    // unmounts while handleItemAnimateOutEnd fires.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
	    direction = direction || this.getDirection(previousActiveIndex, index);
	
	    var onSelect = this.props.onSelect;
	
	
	    if (onSelect) {
	      if (onSelect.length > 1) {
	        // React SyntheticEvents are pooled, so we need to remove this event
	        // from the pool to add a custom property. To avoid unnecessarily
	        // removing objects from the pool, only do this when the listener
	        // actually wants the event.
	        if (e) {
	          e.persist();
	          e.direction = direction;
	        } else {
	          e = { direction: direction };
	        }
	
	        onSelect(index, e);
	      } else {
	        onSelect(index);
	      }
	    }
	
	    if (this.props.activeIndex == null && index !== previousActiveIndex) {
	      if (this.state.previousActiveIndex != null) {
	        // If currently animating don't activate the new index.
	        // TODO: look into queueing this canceled call and
	        // animating after the current animation has ended.
	        return;
	      }
	
	      this.setState({
	        activeIndex: index,
	        previousActiveIndex: previousActiveIndex,
	        direction: direction
	      });
	    }
	  };
	
	  Carousel.prototype.waitForNext = function waitForNext() {
	    var _props = this.props,
	        slide = _props.slide,
	        interval = _props.interval,
	        activeIndexProp = _props.activeIndex;
	
	
	    if (!this.isPaused && slide && interval && activeIndexProp == null) {
	      this.timeout = setTimeout(this.handleNext, interval);
	    }
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.pause = function pause() {
	    this.isPaused = true;
	    clearTimeout(this.timeout);
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.play = function play() {
	    this.isPaused = false;
	    this.waitForNext();
	  };
	
	  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
	    var _this3 = this;
	
	    var indicators = [];
	
	    _ValidComponentChildren2['default'].forEach(children, function (child, index) {
	      indicators.push(_react2['default'].createElement('li', {
	        key: index,
	        className: index === activeIndex ? 'active' : null,
	        onClick: function onClick(e) {
	          return _this3.select(index, e);
	        }
	      }),
	
	      // Force whitespace between indicator elements. Bootstrap requires
	      // this for correct spacing of elements.
	      ' ');
	    });
	
	    return _react2['default'].createElement(
	      'ol',
	      { className: (0, _bootstrapUtils.prefix)(bsProps, 'indicators') },
	      indicators
	    );
	  };
	
	  Carousel.prototype.renderControls = function renderControls(properties) {
	    var wrap = properties.wrap,
	        children = properties.children,
	        activeIndex = properties.activeIndex,
	        prevIcon = properties.prevIcon,
	        nextIcon = properties.nextIcon,
	        bsProps = properties.bsProps,
	        prevLabel = properties.prevLabel,
	        nextLabel = properties.nextLabel;
	
	    var controlClassName = (0, _bootstrapUtils.prefix)(bsProps, 'control');
	    var count = _ValidComponentChildren2['default'].count(children);
	
	    return [(wrap || activeIndex !== 0) && _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      {
	        key: 'prev',
	        className: (0, _classnames2['default'])(controlClassName, 'left'),
	        onClick: this.handlePrev
	      },
	      prevIcon,
	      prevLabel && _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        prevLabel
	      )
	    ), (wrap || activeIndex !== count - 1) && _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      {
	        key: 'next',
	        className: (0, _classnames2['default'])(controlClassName, 'right'),
	        onClick: this.handleNext
	      },
	      nextIcon,
	      nextLabel && _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        nextLabel
	      )
	    )];
	  };
	
	  Carousel.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props2 = this.props,
	        slide = _props2.slide,
	        indicators = _props2.indicators,
	        controls = _props2.controls,
	        wrap = _props2.wrap,
	        prevIcon = _props2.prevIcon,
	        prevLabel = _props2.prevLabel,
	        nextIcon = _props2.nextIcon,
	        nextLabel = _props2.nextLabel,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);
	    var _state = this.state,
	        previousActiveIndex = _state.previousActiveIndex,
	        direction = _state.direction;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
	    'defaultActiveIndex', 'direction']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeIndex = this.getActiveIndex();
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      slide: slide
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes),
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut
	      }),
	      indicators && this.renderIndicators(children, activeIndex, bsProps),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        _ValidComponentChildren2['default'].map(children, function (child, index) {
	          var active = index === activeIndex;
	          var previousActive = slide && index === previousActiveIndex;
	
	          return (0, _react.cloneElement)(child, {
	            active: active,
	            index: index,
	            animateOut: previousActive,
	            animateIn: active && previousActiveIndex != null && slide,
	            direction: direction,
	            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
	          });
	        })
	      ),
	      controls && this.renderControls({
	        wrap: wrap,
	        children: children,
	        activeIndex: activeIndex,
	        prevIcon: prevIcon,
	        prevLabel: prevLabel,
	        nextIcon: nextIcon,
	        nextLabel: nextLabel,
	        bsProps: bsProps
	      })
	    );
	  };
	
	  return Carousel;
	}(_react2['default'].Component);
	
	Carousel.propTypes = propTypes;
	Carousel.defaultProps = defaultProps;
	
	Carousel.Caption = _CarouselCaption2['default'];
	Carousel.Item = _CarouselItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('carousel', Carousel);
	module.exports = exports['default'];

/***/ },
/* 1747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var CarouselCaption = function (_React$Component) {
	  (0, _inherits3['default'])(CarouselCaption, _React$Component);
	
	  function CarouselCaption() {
	    (0, _classCallCheck3['default'])(this, CarouselCaption);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  CarouselCaption.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return CarouselCaption;
	}(_react2['default'].Component);
	
	CarouselCaption.propTypes = propTypes;
	CarouselCaption.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('carousel-caption', CarouselCaption);
	module.exports = exports['default'];

/***/ },
/* 1748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  inline: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Checkbox inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Checkbox = function (_React$Component) {
	  (0, _inherits3['default'])(Checkbox, _React$Component);
	
	  function Checkbox() {
	    (0, _classCallCheck3['default'])(this, Checkbox);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Checkbox.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2['default'].createElement('input', (0, _extends3['default'])({}, elementProps, {
	      ref: inputRef,
	      type: 'checkbox',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2['default'])(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: (0, _classnames2['default'])(className, _classes), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Checkbox;
	}(_react2['default'].Component);
	
	Checkbox.propTypes = propTypes;
	Checkbox.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('checkbox', Checkbox);
	module.exports = exports['default'];

/***/ },
/* 1749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _capitalize = __webpack_require__(850);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _StyleConfig = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Apply clearfix
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `visible-xs-block`
	   */
	  visibleXsBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Small devices Tablets
	   *
	   * adds class `visible-sm-block`
	   */
	  visibleSmBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `visible-md-block`
	   */
	  visibleMdBlock: _propTypes2['default'].bool,
	  /**
	   * Apply clearfix
	   *
	   * on Large devices Desktops
	   *
	   * adds class `visible-lg-block`
	   */
	  visibleLgBlock: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Clearfix = function (_React$Component) {
	  (0, _inherits3['default'])(Clearfix, _React$Component);
	
	  function Clearfix() {
	    (0, _classCallCheck3['default'])(this, Clearfix);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Clearfix.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      var propName = 'visible' + (0, _capitalize2['default'])(size) + 'Block';
	      if (elementProps[propName]) {
	        classes['visible-' + size + '-block'] = true;
	      }
	
	      delete elementProps[propName];
	    });
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Clearfix;
	}(_react2['default'].Component);
	
	Clearfix.propTypes = propTypes;
	Clearfix.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('clearfix', Clearfix);
	module.exports = exports['default'];

/***/ },
/* 1750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Extra small devices Phones (<768px)
	   *
	   * class-prefix `col-xs-`
	   */
	  xs: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Small devices Tablets (≥768px)
	   *
	   * class-prefix `col-sm-`
	   */
	  sm: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Medium devices Desktops (≥992px)
	   *
	   * class-prefix `col-md-`
	   */
	  md: _propTypes2['default'].number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Large devices Desktops (≥1200px)
	   *
	   * class-prefix `col-lg-`
	   */
	  lg: _propTypes2['default'].number,
	  /**
	   * Hide column
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `hidden-xs`
	   */
	  xsHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Small devices Tablets
	   *
	   * adds class `hidden-sm`
	   */
	  smHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `hidden-md`
	   */
	  mdHidden: _propTypes2['default'].bool,
	  /**
	   * Hide column
	   *
	   * on Large devices Desktops
	   *
	   * adds class `hidden-lg`
	   */
	  lgHidden: _propTypes2['default'].bool,
	  /**
	   * Move columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-offset-`
	   */
	  xsOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-offset-`
	   */
	  smOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-offset-`
	   */
	  mdOffset: _propTypes2['default'].number,
	  /**
	   * Move columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-offset-`
	   */
	  lgOffset: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-push-`
	   */
	  xsPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-push-`
	   */
	  smPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-push-`
	   */
	  mdPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-push-`
	   */
	  lgPush: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-pull-`
	   */
	  xsPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-pull-`
	   */
	  smPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-pull-`
	   */
	  mdPull: _propTypes2['default'].number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-pull-`
	   */
	  lgPull: _propTypes2['default'].number
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Col = function (_React$Component) {
	  (0, _inherits3['default'])(Col, _React$Component);
	
	  function Col() {
	    (0, _classCallCheck3['default'])(this, Col);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Col.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      function popProp(propSuffix, modifier) {
	        var propName = '' + size + propSuffix;
	        var propValue = elementProps[propName];
	
	        if (propValue != null) {
	          classes.push((0, _bootstrapUtils.prefix)(bsProps, '' + size + modifier + '-' + propValue));
	        }
	
	        delete elementProps[propName];
	      }
	
	      popProp('', '');
	      popProp('Offset', '-offset');
	      popProp('Push', '-push');
	      popProp('Pull', '-pull');
	
	      var hiddenPropName = size + 'Hidden';
	      if (elementProps[hiddenPropName]) {
	        classes.push('hidden-' + size);
	      }
	      delete elementProps[hiddenPropName];
	    });
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Col;
	}(_react2['default'].Component);
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('col', Col);
	module.exports = exports['default'];

/***/ },
/* 1751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  htmlFor: _propTypes2['default'].string,
	  srOnly: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  srOnly: false
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var ControlLabel = function (_React$Component) {
	  (0, _inherits3['default'])(ControlLabel, _React$Component);
	
	  function ControlLabel() {
	    (0, _classCallCheck3['default'])(this, ControlLabel);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ControlLabel.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        _props$htmlFor = _props.htmlFor,
	        htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
	        srOnly = _props.srOnly,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['htmlFor', 'srOnly', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'sr-only': srOnly
	    });
	
	    return _react2['default'].createElement('label', (0, _extends3['default'])({}, elementProps, {
	      htmlFor: htmlFor,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ControlLabel;
	}(_react2['default'].Component);
	
	ControlLabel.propTypes = propTypes;
	ControlLabel.defaultProps = defaultProps;
	ControlLabel.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('control-label', ControlLabel);
	module.exports = exports['default'];

/***/ },
/* 1752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__(286);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(288);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2['default'].string,
	  bsSize: _propTypes2['default'].string,
	  title: _propTypes2['default'].node.isRequired,
	  noCaret: _propTypes2['default'].bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var DropdownButton = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownButton, _React$Component);
	
	  function DropdownButton() {
	    (0, _classCallCheck3['default'])(this, DropdownButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        (0, _extends3['default'])({}, toggleProps, {
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return DropdownButton;
	}(_react2['default'].Component);
	
	DropdownButton.propTypes = propTypes;
	
	exports['default'] = DropdownButton;
	module.exports = exports['default'];

/***/ },
/* 1753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _from = __webpack_require__(1222);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(407);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _RootCloseWrapper = __webpack_require__(903);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _createChainedFunction = __webpack_require__(50);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(71);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  open: _propTypes2['default'].bool,
	  pullRight: _propTypes2['default'].bool,
	  onClose: _propTypes2['default'].func,
	  labelledBy: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	  onSelect: _propTypes2['default'].func,
	  rootCloseEvent: _propTypes2['default'].oneOf(['click', 'mousedown'])
	};
	
	var defaultProps = {
	  bsRole: 'menu',
	  pullRight: false
	};
	
	var DropdownMenu = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    (0, _classCallCheck3['default'])(this, DropdownMenu);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.handleRootClose = _this.handleRootClose.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    return _this;
	  }
	
	  DropdownMenu.prototype.handleRootClose = function handleRootClose(event) {
	    this.props.onClose(event, { source: 'rootClose' });
	  };
	
	  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        this.focusNext();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.up:
	        this.focusPrevious();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.props.onClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
	    var items = this.getFocusableMenuItems();
	    var activeIndex = items.indexOf(document.activeElement);
	
	    return { items: items, activeIndex: activeIndex };
	  };
	
	  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
	    var node = _reactDom2['default'].findDOMNode(this);
	    if (!node) {
	      return [];
	    }
	
	    return (0, _from2['default'])(node.querySelectorAll('[tabIndex="-1"]'));
	  };
	
	  DropdownMenu.prototype.focusNext = function focusNext() {
	    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd.items,
	        activeIndex = _getItemsAndActiveInd.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
	    items[nextIndex].focus();
	  };
	
	  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
	    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd2.items,
	        activeIndex = _getItemsAndActiveInd2.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
	    items[prevIndex].focus();
	  };
	
	  DropdownMenu.prototype.render = function render() {
	    var _extends2,
	        _this2 = this;
	
	    var _props = this.props,
	        open = _props.open,
	        pullRight = _props.pullRight,
	        labelledBy = _props.labelledBy,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['open', 'pullRight', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['onClose']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'right')] = pullRight, _extends2));
	
	    return _react2['default'].createElement(
	      _RootCloseWrapper2['default'],
	      {
	        disabled: !open,
	        onRootClose: this.handleRootClose,
	        event: rootCloseEvent
	      },
	      _react2['default'].createElement(
	        'ul',
	        (0, _extends4['default'])({}, elementProps, {
	          role: 'menu',
	          className: (0, _classnames2['default'])(className, classes),
	          'aria-labelledby': labelledBy
	        }),
	        _ValidComponentChildren2['default'].map(children, function (child) {
	          return _react2['default'].cloneElement(child, {
	            onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, _this2.handleKeyDown),
	            onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
	          });
	        })
	      )
	    );
	  };
	
	  return DropdownMenu;
	}(_react2['default'].Component);
	
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-menu', DropdownMenu);
	module.exports = exports['default'];

/***/ },
/* 1754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  horizontal: _propTypes2['default'].bool,
	  inline: _propTypes2['default'].bool,
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  horizontal: false,
	  inline: false,
	  componentClass: 'form'
	};
	
	var Form = function (_React$Component) {
	  (0, _inherits3['default'])(Form, _React$Component);
	
	  function Form() {
	    (0, _classCallCheck3['default'])(this, Form);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Form.prototype.render = function render() {
	    var _props = this.props,
	        horizontal = _props.horizontal,
	        inline = _props.inline,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['horizontal', 'inline', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	    if (horizontal) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'horizontal'));
	    }
	    if (inline) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'inline'));
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Form;
	}(_react2['default'].Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form', Form);
	module.exports = exports['default'];

/***/ },
/* 1755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _FormControlFeedback = __webpack_require__(1756);
	
	var _FormControlFeedback2 = _interopRequireDefault(_FormControlFeedback);
	
	var _FormControlStatic = __webpack_require__(1757);
	
	var _FormControlStatic2 = _interopRequireDefault(_FormControlStatic);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	  /**
	   * Only relevant if `componentClass` is `'input'`.
	   */
	  type: _propTypes2['default'].string,
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  id: _propTypes2['default'].string,
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <FormControl inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  componentClass: 'input'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var FormControl = function (_React$Component) {
	  (0, _inherits3['default'])(FormControl, _React$Component);
	
	  function FormControl() {
	    (0, _classCallCheck3['default'])(this, FormControl);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControl.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        type = _props.type,
	        _props$id = _props.id,
	        id = _props$id === undefined ? controlId : _props$id,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        bsSize = _props.bsSize,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'bsSize']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
	
	    // input[type="file"] should not have .form-control.
	    var classes = void 0;
	    if (type !== 'file') {
	      classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    }
	
	    // If user provides a size, make sure to append it to classes as input-
	    // e.g. if bsSize is small, it will append input-sm
	    if (bsSize) {
	      var size = _StyleConfig.SIZE_MAP[bsSize] || bsSize;
	      classes[(0, _bootstrapUtils.prefix)({ bsClass: 'input' }, size)] = true;
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      type: type,
	      id: id,
	      ref: inputRef,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return FormControl;
	}(_react2['default'].Component);
	
	FormControl.propTypes = propTypes;
	FormControl.defaultProps = defaultProps;
	FormControl.contextTypes = contextTypes;
	
	FormControl.Feedback = _FormControlFeedback2['default'];
	FormControl.Static = _FormControlStatic2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.SMALL, _StyleConfig.Size.LARGE], FormControl));
	module.exports = exports['default'];

/***/ },
/* 1756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Glyphicon = __webpack_require__(429);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultProps = {
	  bsRole: 'feedback'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2['default'].object
	};
	
	var FormControlFeedback = function (_React$Component) {
	  (0, _inherits3['default'])(FormControlFeedback, _React$Component);
	
	  function FormControlFeedback() {
	    (0, _classCallCheck3['default'])(this, FormControlFeedback);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
	    switch (validationState) {
	      case 'success':
	        return 'ok';
	      case 'warning':
	        return 'warning-sign';
	      case 'error':
	        return 'remove';
	      default:
	        return null;
	    }
	  };
	
	  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
	    var glyph = this.getGlyph(formGroup && formGroup.validationState);
	    if (!glyph) {
	      return null;
	    }
	
	    return _react2['default'].createElement(_Glyphicon2['default'], (0, _extends3['default'])({}, elementProps, {
	      glyph: glyph,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  FormControlFeedback.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (!children) {
	      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
	    }
	
	    var child = _react2['default'].Children.only(children);
	    return _react2['default'].cloneElement(child, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(child.props.className, className, classes)
	    }));
	  };
	
	  return FormControlFeedback;
	}(_react2['default'].Component);
	
	FormControlFeedback.defaultProps = defaultProps;
	FormControlFeedback.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-feedback', FormControlFeedback);
	module.exports = exports['default'];

/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'p'
	};
	
	var FormControlStatic = function (_React$Component) {
	  (0, _inherits3['default'])(FormControlStatic, _React$Component);
	
	  function FormControlStatic() {
	    (0, _classCallCheck3['default'])(this, FormControlStatic);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlStatic.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return FormControlStatic;
	}(_react2['default'].Component);
	
	FormControlStatic.propTypes = propTypes;
	FormControlStatic.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-static', FormControlStatic);
	module.exports = exports['default'];

/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(56);
	
	var _ValidComponentChildren = __webpack_require__(71);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
	   */
	  controlId: _propTypes2['default'].string,
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null])
	};
	
	var childContextTypes = {
	  $bs_formGroup: _propTypes2['default'].object.isRequired
	};
	
	var FormGroup = function (_React$Component) {
	  (0, _inherits3['default'])(FormGroup, _React$Component);
	
	  function FormGroup() {
	    (0, _classCallCheck3['default'])(this, FormGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormGroup.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        controlId = _props.controlId,
	        validationState = _props.validationState;
	
	
	    return {
	      $bs_formGroup: {
	        controlId: controlId,
	        validationState: validationState
	      }
	    };
	  };
	
	  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
	    var _this2 = this;
	
	    return _ValidComponentChildren2['default'].some(children, function (child) {
	      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
	    });
	  };
	
	  FormGroup.prototype.render = function render() {
	    var _props2 = this.props,
	        validationState = _props2.validationState,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['validationState', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['controlId']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'has-feedback': this.hasFeedback(children)
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return FormGroup;
	}(_react2['default'].Component);
	
	FormGroup.propTypes = propTypes;
	FormGroup.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], FormGroup));
	module.exports = exports['default'];

/***/ },
/* 1759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var HelpBlock = function (_React$Component) {
	  (0, _inherits3['default'])(HelpBlock, _React$Component);
	
	  function HelpBlock() {
	    (0, _classCallCheck3['default'])(this, HelpBlock);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  HelpBlock.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return HelpBlock;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('help-block', HelpBlock);
	module.exports = exports['default'];

/***/ },
/* 1760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Sets image as responsive image
	   */
	  responsive: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as rounded
	   */
	  rounded: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as circle
	   */
	  circle: _propTypes2['default'].bool,
	
	  /**
	   * Sets image shape as thumbnail
	   */
	  thumbnail: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  responsive: false,
	  rounded: false,
	  circle: false,
	  thumbnail: false
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3['default'])(Image, _React$Component);
	
	  function Image() {
	    (0, _classCallCheck3['default'])(this, Image);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Image.prototype.render = function render() {
	    var _classes;
	
	    var _props = this.props,
	        responsive = _props.responsive,
	        rounded = _props.rounded,
	        circle = _props.circle,
	        thumbnail = _props.thumbnail,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (_classes = {}, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'responsive')] = responsive, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'rounded')] = rounded, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'circle')] = circle, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'thumbnail')] = thumbnail, _classes);
	
	    return _react2['default'].createElement('img', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Image;
	}(_react2['default'].Component);
	
	Image.propTypes = propTypes;
	Image.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('img', Image);
	module.exports = exports['default'];

/***/ },
/* 1761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputGroupAddon = __webpack_require__(1762);
	
	var _InputGroupAddon2 = _interopRequireDefault(_InputGroupAddon);
	
	var _InputGroupButton = __webpack_require__(1763);
	
	var _InputGroupButton2 = _interopRequireDefault(_InputGroupButton);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroup = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroup, _React$Component);
	
	  function InputGroup() {
	    (0, _classCallCheck3['default'])(this, InputGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroup.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroup;
	}(_react2['default'].Component);
	
	InputGroup.Addon = _InputGroupAddon2['default'];
	InputGroup.Button = _InputGroupButton2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], InputGroup));
	module.exports = exports['default'];

/***/ },
/* 1762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroupAddon = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroupAddon, _React$Component);
	
	  function InputGroupAddon() {
	    (0, _classCallCheck3['default'])(this, InputGroupAddon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupAddon.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroupAddon;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-addon', InputGroupAddon);
	module.exports = exports['default'];

/***/ },
/* 1763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroupButton = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroupButton, _React$Component);
	
	  function InputGroupButton() {
	    (0, _classCallCheck3['default'])(this, InputGroupButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupButton.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroupButton;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-btn', InputGroupButton);
	module.exports = exports['default'];

/***/ },
/* 1764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Jumbotron = function (_React$Component) {
	  (0, _inherits3['default'])(Jumbotron, _React$Component);
	
	  function Jumbotron() {
	    (0, _classCallCheck3['default'])(this, Jumbotron);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Jumbotron.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Jumbotron;
	}(_react2['default'].Component);
	
	Jumbotron.propTypes = propTypes;
	Jumbotron.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('jumbotron', Jumbotron);
	module.exports = exports['default'];

/***/ },
/* 1765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(156);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Label = function (_React$Component) {
	  (0, _inherits3['default'])(Label, _React$Component);
	
	  function Label() {
	    (0, _classCallCheck3['default'])(this, Label);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Label.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Label.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Label;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('label', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Label));
	module.exports = exports['default'];

/***/ },
/* 1766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _ListGroupItem = __webpack_require__(837);
	
	var _ListGroupItem2 = _interopRequireDefault(_ListGroupItem);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _ValidComponentChildren = __webpack_require__(71);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * You can use a custom element type for this component.
	   *
	   * If not specified, it will be treated as `'li'` if every child is a
	   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
	   */
	  componentClass: _elementType2['default']
	};
	
	function getDefaultComponent(children) {
	  if (!children) {
	    // FIXME: This is the old behavior. Is this right?
	    return 'div';
	  }
	
	  if (_ValidComponentChildren2['default'].some(children, function (child) {
	    return child.type !== _ListGroupItem2['default'] || child.props.href || child.props.onClick;
	  })) {
	    return 'div';
	  }
	
	  return 'ul';
	}
	
	var ListGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ListGroup, _React$Component);
	
	  function ListGroup() {
	    (0, _classCallCheck3['default'])(this, ListGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroup.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        _props$componentClass = _props.componentClass,
	        Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['children', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var useListItem = Component === 'ul' && _ValidComponentChildren2['default'].every(children, function (child) {
	      return child.type === _ListGroupItem2['default'];
	    });
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      useListItem ? _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, { listItem: true });
	      }) : children
	    );
	  };
	
	  return ListGroup;
	}(_react2['default'].Component);
	
	ListGroup.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('list-group', ListGroup);
	module.exports = exports['default'];

/***/ },
/* 1767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var MediaBody = function (_React$Component) {
	  (0, _inherits3['default'])(MediaBody, _React$Component);
	
	  function MediaBody() {
	    (0, _classCallCheck3['default'])(this, MediaBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaBody;
	}(_react2['default'].Component);
	
	MediaBody.propTypes = propTypes;
	MediaBody.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-body', MediaBody);
	module.exports = exports['default'];

/***/ },
/* 1768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var MediaHeading = function (_React$Component) {
	  (0, _inherits3['default'])(MediaHeading, _React$Component);
	
	  function MediaHeading() {
	    (0, _classCallCheck3['default'])(this, MediaHeading);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaHeading.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaHeading;
	}(_react2['default'].Component);
	
	MediaHeading.propTypes = propTypes;
	MediaHeading.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-heading', MediaHeading);
	module.exports = exports['default'];

/***/ },
/* 1769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(430);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2['default'].oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaLeft = function (_React$Component) {
	  (0, _inherits3['default'])(MediaLeft, _React$Component);
	
	  function MediaLeft() {
	    (0, _classCallCheck3['default'])(this, MediaLeft);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaLeft.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2['default'].defaultProps, align)] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaLeft;
	}(_react2['default'].Component);
	
	MediaLeft.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-left', MediaLeft);
	module.exports = exports['default'];

/***/ },
/* 1770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MediaList = function (_React$Component) {
	  (0, _inherits3['default'])(MediaList, _React$Component);
	
	  function MediaList() {
	    (0, _classCallCheck3['default'])(this, MediaList);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaList.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('ul', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaList;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-list', MediaList);
	module.exports = exports['default'];

/***/ },
/* 1771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MediaListItem = function (_React$Component) {
	  (0, _inherits3['default'])(MediaListItem, _React$Component);
	
	  function MediaListItem() {
	    (0, _classCallCheck3['default'])(this, MediaListItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaListItem.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaListItem;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media', MediaListItem);
	module.exports = exports['default'];

/***/ },
/* 1772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(430);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2['default'].oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaRight = function (_React$Component) {
	  (0, _inherits3['default'])(MediaRight, _React$Component);
	
	  function MediaRight() {
	    (0, _classCallCheck3['default'])(this, MediaRight);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaRight.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-right-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2['default'].defaultProps, align)] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaRight;
	}(_react2['default'].Component);
	
	MediaRight.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-right', MediaRight);
	module.exports = exports['default'];

/***/ },
/* 1773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__(299);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _SafeAnchor = __webpack_require__(103);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _createChainedFunction = __webpack_require__(50);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Highlight the menu item as active.
	   */
	  active: _propTypes2['default'].bool,
	
	  /**
	   * Disable the menu item, making it unselectable.
	   */
	  disabled: _propTypes2['default'].bool,
	
	  /**
	   * Styles the menu item as a horizontal rule, providing visual separation between
	   * groups of menu items.
	   */
	  divider: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
	    var divider = _ref.divider,
	        children = _ref.children;
	    return divider && children ? new Error('Children will not be rendered for dividers') : null;
	  }),
	
	  /**
	   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
	   */
	  eventKey: _propTypes2['default'].any,
	
	  /**
	   * Styles the menu item as a header label, useful for describing a group of menu items.
	   */
	  header: _propTypes2['default'].bool,
	
	  /**
	   * HTML `href` attribute corresponding to `a.href`.
	   */
	  href: _propTypes2['default'].string,
	
	  /**
	   * Callback fired when the menu item is clicked.
	   */
	  onClick: _propTypes2['default'].func,
	
	  /**
	   * Callback fired when the menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  divider: false,
	  disabled: false,
	  header: false
	};
	
	var MenuItem = function (_React$Component) {
	  (0, _inherits3['default'])(MenuItem, _React$Component);
	
	  function MenuItem(props, context) {
	    (0, _classCallCheck3['default'])(this, MenuItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  MenuItem.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        href = _props.href,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (!href || disabled) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  MenuItem.prototype.render = function render() {
	    var _props2 = this.props,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        divider = _props2.divider,
	        header = _props2.header,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    if (divider) {
	      // Forcibly blank out the children; separators shouldn't render any.
	      elementProps.children = undefined;
	
	      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	        role: 'separator',
	        className: (0, _classnames2['default'])(className, 'divider'),
	        style: style
	      }));
	    }
	
	    if (header) {
	      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	        role: 'heading',
	        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'header')),
	        style: style
	      }));
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, elementProps, {
	        role: 'menuitem',
	        tabIndex: '-1',
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return MenuItem;
	}(_react2['default'].Component);
	
	MenuItem.propTypes = propTypes;
	MenuItem.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown', MenuItem);
	module.exports = exports['default'];

/***/ },
/* 1774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _events = __webpack_require__(1349);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _ownerDocument = __webpack_require__(163);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _inDOM = __webpack_require__(124);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _scrollbarSize = __webpack_require__(559);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Modal = __webpack_require__(1908);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _isOverflowing = __webpack_require__(906);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(287);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ModalBody = __webpack_require__(838);
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _ModalDialog = __webpack_require__(1775);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _ModalFooter = __webpack_require__(839);
	
	var _ModalFooter2 = _interopRequireDefault(_ModalFooter);
	
	var _ModalHeader = __webpack_require__(840);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalTitle = __webpack_require__(841);
	
	var _ModalTitle2 = _interopRequireDefault(_ModalTitle);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _createChainedFunction = __webpack_require__(50);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _splitComponentProps2 = __webpack_require__(288);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _StyleConfig = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Modal2['default'].propTypes, _ModalDialog2['default'].propTypes, {
	
	  /**
	   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
	   * trigger an "onHide" when clicked.
	   */
	  backdrop: _propTypes2['default'].oneOf(['static', true, false]),
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2['default'].bool,
	
	  /**
	   * Open and close the Modal with a slide and fade animation.
	   */
	  animation: _propTypes2['default'].bool,
	
	  /**
	   * A Component type that provides the modal content Markup. This is a useful
	   * prop when you want to use your own styles and markup to create a custom
	   * modal component.
	   */
	  dialogComponentClass: _elementType2['default'],
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it
	   * opens, and replace it to the last focused element when it closes.
	   * Generally this should never be set to false as it makes the Modal less
	   * accessible to assistive technologies, like screen-readers.
	   */
	  autoFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while
	   * open. Consider leaving the default value here, as it is necessary to make
	   * the Modal work well with assistive technologies, such as screen readers.
	   */
	  enforceFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2['default'].bool,
	
	  /**
	   * When `true` The modal will show itself.
	   */
	  show: _propTypes2['default'].bool,
	
	  /**
	   * A callback fired when the header closeButton or non-static backdrop is
	   * clicked. Required if either are specified.
	   */
	  onHide: _propTypes2['default'].func,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2['default'].func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2['default'].func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2['default'].func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2['default'].func,
	
	  /**
	   * @private
	   */
	  container: _Modal2['default'].propTypes.container
	});
	
	var defaultProps = (0, _extends3['default'])({}, _Modal2['default'].defaultProps, {
	  animation: true,
	  dialogComponentClass: _ModalDialog2['default']
	});
	
	var childContextTypes = {
	  $bs_modal: _propTypes2['default'].shape({
	    onHide: _propTypes2['default'].func
	  })
	};
	
	var Modal = function (_React$Component) {
	  (0, _inherits3['default'])(Modal, _React$Component);
	
	  function Modal(props, context) {
	    (0, _classCallCheck3['default'])(this, Modal);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
	
	    _this.state = {
	      style: {}
	    };
	    return _this;
	  }
	
	  Modal.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_modal: {
	        onHide: this.props.onHide
	      }
	    };
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    // Clean up the listener if we need to.
	    this.handleExited();
	  };
	
	  Modal.prototype.handleEntering = function handleEntering() {
	    // FIXME: This should work even when animation is disabled.
	    _events2['default'].on(window, 'resize', this.handleWindowResize);
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleExited = function handleExited() {
	    // FIXME: This should work even when animation is disabled.
	    _events2['default'].off(window, 'resize', this.handleWindowResize);
	  };
	
	  Modal.prototype.handleWindowResize = function handleWindowResize() {
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    this.props.onHide();
	  };
	
	  Modal.prototype.updateStyle = function updateStyle() {
	    if (!_inDOM2['default']) {
	      return;
	    }
	
	    var dialogNode = this._modal.getDialogElement();
	    var dialogHeight = dialogNode.scrollHeight;
	
	    var document = (0, _ownerDocument2['default'])(dialogNode);
	    var bodyIsOverflowing = (0, _isOverflowing2['default'])(_reactDom2['default'].findDOMNode(this.props.container || document.body));
	    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
	
	    this.setState({
	      style: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize2['default'])() : undefined,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize2['default'])() : undefined
	      }
	    });
	  };
	
	  Modal.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        backdrop = _props.backdrop,
	        animation = _props.animation,
	        show = _props.show,
	        Dialog = _props.dialogComponentClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        onEntering = _props.onEntering,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['backdrop', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Modal2['default']),
	        baseModalProps = _splitComponentProps[0],
	        dialogProps = _splitComponentProps[1];
	
	    var inClassName = show && !animation && 'in';
	
	    return _react2['default'].createElement(
	      _Modal2['default'],
	      (0, _extends3['default'])({}, baseModalProps, {
	        ref: function ref(c) {
	          _this2._modal = c;
	        },
	        show: show,
	        onEntering: (0, _createChainedFunction2['default'])(onEntering, this.handleEntering),
	        onExited: (0, _createChainedFunction2['default'])(onExited, this.handleExited),
	        backdrop: backdrop,
	        backdropClassName: (0, _classnames2['default'])((0, _bootstrapUtils.prefix)(props, 'backdrop'), inClassName),
	        containerClassName: (0, _bootstrapUtils.prefix)(props, 'open'),
	        transition: animation ? _Fade2['default'] : undefined,
	        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
	        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
	      }),
	      _react2['default'].createElement(
	        Dialog,
	        (0, _extends3['default'])({}, dialogProps, {
	          style: (0, _extends3['default'])({}, this.state.style, style),
	          className: (0, _classnames2['default'])(className, inClassName),
	          onClick: backdrop === true ? this.handleDialogClick : null
	        }),
	        children
	      )
	    );
	  };
	
	  return Modal;
	}(_react2['default'].Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.childContextTypes = childContextTypes;
	
	Modal.Body = _ModalBody2['default'];
	Modal.Header = _ModalHeader2['default'];
	Modal.Title = _ModalTitle2['default'];
	Modal.Footer = _ModalFooter2['default'];
	
	Modal.Dialog = _ModalDialog2['default'];
	
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Modal));
	module.exports = exports['default'];

/***/ },
/* 1775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * A css class to apply to the Modal dialog DOM node.
	   */
	  dialogClassName: _propTypes2['default'].string
	};
	
	var ModalDialog = function (_React$Component) {
	  (0, _inherits3['default'])(ModalDialog, _React$Component);
	
	  function ModalDialog() {
	    (0, _classCallCheck3['default'])(this, ModalDialog);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalDialog.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        dialogClassName = _props.dialogClassName,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['dialogClassName', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(bsProps);
	
	    var modalStyle = (0, _extends4['default'])({ display: 'block' }, style);
	
	    var dialogClasses = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dialog')] = true, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        tabIndex: '-1',
	        role: 'dialog',
	        style: modalStyle,
	        className: (0, _classnames2['default'])(className, bsClassName)
	      }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _classnames2['default'])(dialogClassName, dialogClasses) },
	        _react2['default'].createElement(
	          'div',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'content'), role: 'document' },
	          children
	        )
	      )
	    );
	  };
	
	  return ModalDialog;
	}(_react2['default'].Component);
	
	ModalDialog.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], ModalDialog));
	module.exports = exports['default'];

/***/ },
/* 1776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__(286);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(288);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _ValidComponentChildren = __webpack_require__(71);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  title: _propTypes2['default'].node.isRequired,
	  noCaret: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var NavDropdown = function (_React$Component) {
	  (0, _inherits3['default'])(NavDropdown, _React$Component);
	
	  function NavDropdown() {
	    (0, _classCallCheck3['default'])(this, NavDropdown);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
	    var props = _ref.props;
	
	    var _this2 = this;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    if (_ValidComponentChildren2['default'].some(props.children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    })) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  NavDropdown.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        title = _props.title,
	        activeKey = _props.activeKey,
	        activeHref = _props.activeHref,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);
	
	
	    var active = this.isActive(this, activeKey, activeHref);
	    delete props.active; // Accessed via this.isActive().
	    delete props.eventKey; // Accessed via this.isActive().
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
	    // rather than the `<Dropdown.Toggle>`.
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        componentClass: 'li',
	        className: (0, _classnames2['default'])(className, { active: active }),
	        style: style
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        (0, _extends3['default'])({}, toggleProps, { useAnchor: true }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        _ValidComponentChildren2['default'].map(children, function (child) {
	          return _react2['default'].cloneElement(child, {
	            active: _this3.isActive(child, activeKey, activeHref)
	          });
	        })
	      )
	    );
	  };
	
	  return NavDropdown;
	}(_react2['default'].Component);
	
	NavDropdown.propTypes = propTypes;
	
	exports['default'] = NavDropdown;
	module.exports = exports['default'];

/***/ },
/* 1777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _uncontrollable = __webpack_require__(305);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Grid = __webpack_require__(836);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _NavbarBrand = __webpack_require__(844);
	
	var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);
	
	var _NavbarCollapse = __webpack_require__(1778);
	
	var _NavbarCollapse2 = _interopRequireDefault(_NavbarCollapse);
	
	var _NavbarHeader = __webpack_require__(1779);
	
	var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);
	
	var _NavbarToggle = __webpack_require__(1780);
	
	var _NavbarToggle2 = _interopRequireDefault(_NavbarToggle);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(56);
	
	var _createChainedFunction = __webpack_require__(50);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Create a fixed navbar along the top of the screen, that scrolls with the
	   * page
	   */
	  fixedTop: _propTypes2['default'].bool,
	  /**
	   * Create a fixed navbar along the bottom of the screen, that scrolls with
	   * the page
	   */
	  fixedBottom: _propTypes2['default'].bool,
	  /**
	   * Create a full-width navbar that scrolls away with the page
	   */
	  staticTop: _propTypes2['default'].bool,
	  /**
	   * An alternative dark visual style for the Navbar
	   */
	  inverse: _propTypes2['default'].bool,
	  /**
	   * Allow the Navbar to fluidly adjust to the page or container width, instead
	   * of at the predefined screen breakpoints
	   */
	  fluid: _propTypes2['default'].bool,
	
	  /**
	   * Set a custom element for this component.
	   */
	  componentClass: _elementType2['default'],
	  /**
	   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
	   * a `<Navbar.Toggle>` is clicked and called with the new `navExpanded`
	   * boolean value.
	   *
	   * @controllable navExpanded
	   */
	  onToggle: _propTypes2['default'].func,
	  /**
	   * A callback fired when a descendant of a child `<Nav>` is selected. Should
	   * be used to execute complex closing or other miscellaneous actions desired
	   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
	   * descendants exist. The callback is called with an eventKey, which is a
	   * prop from the selected `<Nav>` descendant, and an event.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   *
	   * For basic closing behavior after all `<Nav>` descendant onSelect events in
	   * mobile viewports, try using collapseOnSelect.
	   *
	   * Note: If you are manually closing the navbar using this `OnSelect` prop,
	   * ensure that you are setting `expanded` to false and not *toggling* between
	   * true and false.
	   */
	  onSelect: _propTypes2['default'].func,
	  /**
	   * Sets `expanded` to `false` after the onSelect event of a descendant of a
	   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
	   *
	   * The onSelect callback should be used instead for more complex operations
	   * that need to be executed after the `select` event of `<Nav>` descendants.
	   */
	  collapseOnSelect: _propTypes2['default'].bool,
	  /**
	   * Explicitly set the visiblity of the navbar body
	   *
	   * @controllable onToggle
	   */
	  expanded: _propTypes2['default'].bool,
	
	  role: _propTypes2['default'].string
	}; // TODO: Remove this pragma once we upgrade eslint-config-airbnb.
	/* eslint-disable react/no-multi-comp */
	
	var defaultProps = {
	  componentClass: 'nav',
	  fixedTop: false,
	  fixedBottom: false,
	  staticTop: false,
	  inverse: false,
	  fluid: false,
	  collapseOnSelect: false
	};
	
	var childContextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool,
	    onToggle: _propTypes2['default'].func.isRequired,
	    onSelect: _propTypes2['default'].func
	  })
	};
	
	var Navbar = function (_React$Component) {
	  (0, _inherits3['default'])(Navbar, _React$Component);
	
	  function Navbar(props, context) {
	    (0, _classCallCheck3['default'])(this, Navbar);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleCollapse = _this.handleCollapse.bind(_this);
	    return _this;
	  }
	
	  Navbar.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        expanded = _props.expanded,
	        onSelect = _props.onSelect,
	        collapseOnSelect = _props.collapseOnSelect;
	
	
	    return {
	      $bs_navbar: {
	        bsClass: bsClass,
	        expanded: expanded,
	        onToggle: this.handleToggle,
	        onSelect: (0, _createChainedFunction2['default'])(onSelect, collapseOnSelect ? this.handleCollapse : null)
	      }
	    };
	  };
	
	  Navbar.prototype.handleCollapse = function handleCollapse() {
	    var _props2 = this.props,
	        onToggle = _props2.onToggle,
	        expanded = _props2.expanded;
	
	
	    if (expanded) {
	      onToggle(false);
	    }
	  };
	
	  Navbar.prototype.handleToggle = function handleToggle() {
	    var _props3 = this.props,
	        onToggle = _props3.onToggle,
	        expanded = _props3.expanded;
	
	
	    onToggle(!expanded);
	  };
	
	  Navbar.prototype.render = function render() {
	    var _extends2;
	
	    var _props4 = this.props,
	        Component = _props4.componentClass,
	        fixedTop = _props4.fixedTop,
	        fixedBottom = _props4.fixedBottom,
	        staticTop = _props4.staticTop,
	        inverse = _props4.inverse,
	        fluid = _props4.fluid,
	        className = _props4.className,
	        children = _props4.children,
	        props = (0, _objectWithoutProperties3['default'])(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	
	
	    if (elementProps.role === undefined && Component !== 'nav') {
	      elementProps.role = 'navigation';
	    }
	
	    if (inverse) {
	      bsProps.bsStyle = _StyleConfig.Style.INVERSE;
	    }
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-top')] = fixedTop, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'static-top')] = staticTop, _extends2));
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends4['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement(
	        _Grid2['default'],
	        { fluid: fluid },
	        children
	      )
	    );
	  };
	
	  return Navbar;
	}(_react2['default'].Component);
	
	Navbar.propTypes = propTypes;
	Navbar.defaultProps = defaultProps;
	Navbar.childContextTypes = childContextTypes;
	
	(0, _bootstrapUtils.bsClass)('navbar', Navbar);
	
	var UncontrollableNavbar = (0, _uncontrollable2['default'])(Navbar, { expanded: 'onToggle' });
	
	function createSimpleWrapper(tag, suffix, displayName) {
	  var Wrapper = function Wrapper(_ref, _ref2) {
	    var _ref2$$bs_navbar = _ref2.$bs_navbar,
	        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;
	    var Component = _ref.componentClass,
	        className = _ref.className,
	        pullRight = _ref.pullRight,
	        pullLeft = _ref.pullLeft,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);
	    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, props, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, suffix), pullRight && (0, _bootstrapUtils.prefix)(navbarProps, 'right'), pullLeft && (0, _bootstrapUtils.prefix)(navbarProps, 'left'))
	    }));
	  };
	
	  Wrapper.displayName = displayName;
	
	  Wrapper.propTypes = {
	    componentClass: _elementType2['default'],
	    pullRight: _propTypes2['default'].bool,
	    pullLeft: _propTypes2['default'].bool
	  };
	
	  Wrapper.defaultProps = {
	    componentClass: tag,
	    pullRight: false,
	    pullLeft: false
	  };
	
	  Wrapper.contextTypes = {
	    $bs_navbar: _propTypes2['default'].shape({
	      bsClass: _propTypes2['default'].string
	    })
	  };
	
	  return Wrapper;
	}
	
	UncontrollableNavbar.Brand = _NavbarBrand2['default'];
	UncontrollableNavbar.Header = _NavbarHeader2['default'];
	UncontrollableNavbar.Toggle = _NavbarToggle2['default'];
	UncontrollableNavbar.Collapse = _NavbarCollapse2['default'];
	
	UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
	UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
	UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');
	
	// Set bsStyles here so they can be overridden.
	exports['default'] = (0, _bootstrapUtils.bsStyles)([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.INVERSE], _StyleConfig.Style.DEFAULT, UncontrollableNavbar);
	module.exports = exports['default'];

/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(428);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool
	  })
	};
	
	var NavbarCollapse = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarCollapse, _React$Component);
	
	  function NavbarCollapse() {
	    (0, _classCallCheck3['default'])(this, NavbarCollapse);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarCollapse.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'collapse');
	
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      (0, _extends3['default'])({ 'in': navbarProps.expanded }, props),
	      _react2['default'].createElement(
	        'div',
	        { className: bsClassName },
	        children
	      )
	    );
	  };
	
	  return NavbarCollapse;
	}(_react2['default'].Component);
	
	NavbarCollapse.contextTypes = contextTypes;
	
	exports['default'] = NavbarCollapse;
	module.exports = exports['default'];

/***/ },
/* 1779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string
	  })
	};
	
	var NavbarHeader = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarHeader, _React$Component);
	
	  function NavbarHeader() {
	    (0, _classCallCheck3['default'])(this, NavbarHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'header');
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }));
	  };
	
	  return NavbarHeader;
	}(_react2['default'].Component);
	
	NavbarHeader.contextTypes = contextTypes;
	
	exports['default'] = NavbarHeader;
	module.exports = exports['default'];

/***/ },
/* 1780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _createChainedFunction = __webpack_require__(50);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onClick: _propTypes2['default'].func,
	  /**
	   * The toggle content, if left empty it will render the default toggle (seen above).
	   */
	  children: _propTypes2['default'].node
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2['default'].shape({
	    bsClass: _propTypes2['default'].string,
	    expanded: _propTypes2['default'].bool,
	    onToggle: _propTypes2['default'].func.isRequired
	  })
	};
	
	var NavbarToggle = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarToggle, _React$Component);
	
	  function NavbarToggle() {
	    (0, _classCallCheck3['default'])(this, NavbarToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarToggle.prototype.render = function render() {
	    var _props = this.props,
	        onClick = _props.onClick,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onClick', 'className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var buttonProps = (0, _extends3['default'])({
	      type: 'button'
	    }, props, {
	      onClick: (0, _createChainedFunction2['default'])(onClick, navbarProps.onToggle),
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
	    });
	
	    if (children) {
	      return _react2['default'].createElement(
	        'button',
	        buttonProps,
	        children
	      );
	    }
	
	    return _react2['default'].createElement(
	      'button',
	      buttonProps,
	      _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        'Toggle navigation'
	      ),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' })
	    );
	  };
	
	  return NavbarToggle;
	}(_react2['default'].Component);
	
	NavbarToggle.propTypes = propTypes;
	NavbarToggle.contextTypes = contextTypes;
	
	exports['default'] = NavbarToggle;
	module.exports = exports['default'];

/***/ },
/* 1781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _contains = __webpack_require__(164);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Overlay = __webpack_require__(845);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _createChainedFunction = __webpack_require__(50);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if (Array.isArray(of)) {
	    return of.indexOf(one) >= 0;
	  }
	  return one === of;
	}
	
	var triggerType = _propTypes2['default'].oneOf(['click', 'hover', 'focus']);
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	  * Specify which action or actions trigger Overlay visibility
	  */
	  trigger: _propTypes2['default'].oneOfType([triggerType, _propTypes2['default'].arrayOf(triggerType)]),
	
	  /**
	   * A millisecond delay amount to show and hide the Overlay once triggered
	   */
	  delay: _propTypes2['default'].number,
	  /**
	   * A millisecond delay amount before showing the Overlay once triggered.
	   */
	  delayShow: _propTypes2['default'].number,
	  /**
	   * A millisecond delay amount before hiding the Overlay once triggered.
	   */
	  delayHide: _propTypes2['default'].number,
	
	  // FIXME: This should be `defaultShow`.
	  /**
	   * The initial visibility state of the Overlay. For more nuanced visibility
	   * control, consider using the Overlay component directly.
	   */
	  defaultOverlayShown: _propTypes2['default'].bool,
	
	  /**
	   * An element or text to overlay next to the target.
	   */
	  overlay: _propTypes2['default'].node.isRequired,
	
	  /**
	   * @private
	   */
	  onBlur: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onClick: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onFocus: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseOut: _propTypes2['default'].func,
	  /**
	   * @private
	   */
	  onMouseOver: _propTypes2['default'].func,
	
	  // Overridden props from `<Overlay>`.
	  /**
	   * @private
	   */
	  target: _propTypes2['default'].oneOf([null]),
	  /**
	  * @private
	  */
	  onHide: _propTypes2['default'].oneOf([null]),
	  /**
	   * @private
	   */
	  show: _propTypes2['default'].oneOf([null])
	});
	
	var defaultProps = {
	  defaultOverlayShown: false,
	  trigger: ['hover', 'focus']
	};
	
	var OverlayTrigger = function (_React$Component) {
	  (0, _inherits3['default'])(OverlayTrigger, _React$Component);
	
	  function OverlayTrigger(props, context) {
	    (0, _classCallCheck3['default'])(this, OverlayTrigger);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
	    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
	    _this.handleHide = _this.handleHide.bind(_this);
	
	    _this.handleMouseOver = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedShow, e);
	    };
	    _this.handleMouseOut = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedHide, e);
	    };
	
	    _this._mountNode = null;
	
	    _this.state = {
	      show: props.defaultOverlayShown
	    };
	    return _this;
	  }
	
	  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
	    this._mountNode = document.createElement('div');
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    _reactDom2['default'].unmountComponentAtNode(this._mountNode);
	    this._mountNode = null;
	
	    clearTimeout(this._hoverShowDelay);
	    clearTimeout(this._hoverHideDelay);
	  };
	
	  OverlayTrigger.prototype.handleToggle = function handleToggle() {
	    if (this.state.show) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
	    var _this2 = this;
	
	    if (this._hoverHideDelay != null) {
	      clearTimeout(this._hoverHideDelay);
	      this._hoverHideDelay = null;
	      return;
	    }
	
	    if (this.state.show || this._hoverShowDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.show();
	      return;
	    }
	
	    this._hoverShowDelay = setTimeout(function () {
	      _this2._hoverShowDelay = null;
	      _this2.show();
	    }, delay);
	  };
	
	  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
	    var _this3 = this;
	
	    if (this._hoverShowDelay != null) {
	      clearTimeout(this._hoverShowDelay);
	      this._hoverShowDelay = null;
	      return;
	    }
	
	    if (!this.state.show || this._hoverHideDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hide();
	      return;
	    }
	
	    this._hoverHideDelay = setTimeout(function () {
	      _this3._hoverHideDelay = null;
	      _this3.hide();
	    }, delay);
	  };
	
	  // Simple implementation of mouseEnter and mouseLeave.
	  // React's built version is broken: https://github.com/facebook/react/issues/4251
	  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
	  // moving from one child element to another.
	
	
	  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
	    var target = e.currentTarget;
	    var related = e.relatedTarget || e.nativeEvent.toElement;
	
	    if (!related || related !== target && !(0, _contains2['default'])(target, related)) {
	      handler(e);
	    }
	  };
	
	  OverlayTrigger.prototype.handleHide = function handleHide() {
	    this.hide();
	  };
	
	  OverlayTrigger.prototype.show = function show() {
	    this.setState({ show: true });
	  };
	
	  OverlayTrigger.prototype.hide = function hide() {
	    this.setState({ show: false });
	  };
	
	  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        show: this.state.show,
	        onHide: this.handleHide,
	        target: this
	      }),
	      overlay
	    );
	  };
	
	  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
	    _reactDom2['default'].unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
	  };
	
	  OverlayTrigger.prototype.render = function render() {
	    var _props = this.props,
	        trigger = _props.trigger,
	        overlay = _props.overlay,
	        children = _props.children,
	        onBlur = _props.onBlur,
	        onClick = _props.onClick,
	        onFocus = _props.onFocus,
	        onMouseOut = _props.onMouseOut,
	        onMouseOver = _props.onMouseOver,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);
	
	
	    delete props.delay;
	    delete props.delayShow;
	    delete props.delayHide;
	    delete props.defaultOverlayShown;
	
	    var child = _react2['default'].Children.only(children);
	    var childProps = child.props;
	    var triggerProps = {};
	
	    if (this.state.show) {
	      triggerProps['aria-describedby'] = overlay.props.id;
	    }
	
	    // FIXME: The logic here for passing through handlers on this component is
	    // inconsistent. We shouldn't be passing any of these props through.
	
	    triggerProps.onClick = (0, _createChainedFunction2['default'])(childProps.onClick, onClick);
	
	    if (isOneOf('click', trigger)) {
	      triggerProps.onClick = (0, _createChainedFunction2['default'])(triggerProps.onClick, this.handleToggle);
	    }
	
	    if (isOneOf('hover', trigger)) {
	       false ? (0, _warning2['default'])(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
	
	      triggerProps.onMouseOver = (0, _createChainedFunction2['default'])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
	      triggerProps.onMouseOut = (0, _createChainedFunction2['default'])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
	    }
	
	    if (isOneOf('focus', trigger)) {
	      triggerProps.onFocus = (0, _createChainedFunction2['default'])(childProps.onFocus, onFocus, this.handleDelayedShow);
	      triggerProps.onBlur = (0, _createChainedFunction2['default'])(childProps.onBlur, onBlur, this.handleDelayedHide);
	    }
	
	    this._overlay = this.makeOverlay(overlay, props);
	
	    return (0, _react.cloneElement)(child, triggerProps);
	  };
	
	  return OverlayTrigger;
	}(_react2['default'].Component);
	
	OverlayTrigger.propTypes = propTypes;
	OverlayTrigger.defaultProps = defaultProps;
	
	exports['default'] = OverlayTrigger;
	module.exports = exports['default'];

/***/ },
/* 1782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PageHeader = function (_React$Component) {
	  (0, _inherits3['default'])(PageHeader, _React$Component);
	
	  function PageHeader() {
	    (0, _classCallCheck3['default'])(this, PageHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  PageHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement(
	        'h1',
	        null,
	        children
	      )
	    );
	  };
	
	  return PageHeader;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('page-header', PageHeader);
	module.exports = exports['default'];

/***/ },
/* 1783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PagerItem = __webpack_require__(846);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _deprecationWarning = __webpack_require__(1802);
	
	var _deprecationWarning2 = _interopRequireDefault(_deprecationWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _deprecationWarning2['default'].wrapper(_PagerItem2['default'], '`<PageItem>`', '`<Pager.Item>`');
	module.exports = exports['default'];

/***/ },
/* 1784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PagerItem = __webpack_require__(846);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _createChainedFunction = __webpack_require__(50);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(71);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onSelect: _propTypes2['default'].func
	};
	
	var Pager = function (_React$Component) {
	  (0, _inherits3['default'])(Pager, _React$Component);
	
	  function Pager() {
	    (0, _classCallCheck3['default'])(this, Pager);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Pager.prototype.render = function render() {
	    var _props = this.props,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onSelect', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, {
	          onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
	        });
	      })
	    );
	  };
	
	  return Pager;
	}(_react2['default'].Component);
	
	Pager.propTypes = propTypes;
	
	Pager.Item = _PagerItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('pager', Pager);
	module.exports = exports['default'];

/***/ },
/* 1785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _PaginationButton = __webpack_require__(847);
	
	var _PaginationButton2 = _interopRequireDefault(_PaginationButton);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  activePage: _propTypes2['default'].number,
	  items: _propTypes2['default'].number,
	  maxButtons: _propTypes2['default'].number,
	
	  /**
	   * When `true`, will display the first and the last button page when
	   * displaying ellipsis.
	   */
	  boundaryLinks: _propTypes2['default'].bool,
	
	  /**
	   * When `true`, will display the default node value ('&hellip;').
	   * Otherwise, will display provided node (when specified).
	   */
	  ellipsis: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&laquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  first: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&raquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  last: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&lsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  prev: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  /**
	   * When `true`, will display the default node value ('&rsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  next: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * You can use a custom element for the buttons
	   */
	  buttonComponentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  activePage: 1,
	  items: 1,
	  maxButtons: 0,
	  first: false,
	  last: false,
	  prev: false,
	  next: false,
	  ellipsis: true,
	  boundaryLinks: false
	};
	
	var Pagination = function (_React$Component) {
	  (0, _inherits3['default'])(Pagination, _React$Component);
	
	  function Pagination() {
	    (0, _classCallCheck3['default'])(this, Pagination);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Pagination.prototype.renderPageButtons = function renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps) {
	    var pageButtons = [];
	
	    var startPage = void 0;
	    var endPage = void 0;
	
	    if (maxButtons && maxButtons < items) {
	      startPage = Math.max(Math.min(activePage - Math.floor(maxButtons / 2, 10), items - maxButtons + 1), 1);
	      endPage = startPage + maxButtons - 1;
	    } else {
	      startPage = 1;
	      endPage = items;
	    }
	
	    for (var page = startPage; page <= endPage; ++page) {
	      pageButtons.push(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          key: page,
	          eventKey: page,
	          active: page === activePage
	        }),
	        page
	      ));
	    }
	
	    if (ellipsis && boundaryLinks && startPage > 1) {
	      if (startPage > 2) {
	        pageButtons.unshift(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          {
	            key: 'ellipsisFirst',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2['default'].createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      pageButtons.unshift(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          key: 1,
	          eventKey: 1,
	          active: false
	        }),
	        '1'
	      ));
	    }
	
	    if (ellipsis && endPage < items) {
	      if (!boundaryLinks || endPage < items - 1) {
	        pageButtons.push(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          {
	            key: 'ellipsis',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2['default'].createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      if (boundaryLinks) {
	        pageButtons.push(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          (0, _extends3['default'])({}, buttonProps, {
	            key: items,
	            eventKey: items,
	            active: false
	          }),
	          items
	        ));
	      }
	    }
	
	    return pageButtons;
	  };
	
	  Pagination.prototype.render = function render() {
	    var _props = this.props,
	        activePage = _props.activePage,
	        items = _props.items,
	        maxButtons = _props.maxButtons,
	        boundaryLinks = _props.boundaryLinks,
	        ellipsis = _props.ellipsis,
	        first = _props.first,
	        last = _props.last,
	        prev = _props.prev,
	        next = _props.next,
	        onSelect = _props.onSelect,
	        buttonComponentClass = _props.buttonComponentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['activePage', 'items', 'maxButtons', 'boundaryLinks', 'ellipsis', 'first', 'last', 'prev', 'next', 'onSelect', 'buttonComponentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var buttonProps = {
	      onSelect: onSelect,
	      componentClass: buttonComponentClass
	    };
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      first && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: 1,
	          disabled: activePage === 1
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'First' },
	          first === true ? '\xAB' : first
	        )
	      ),
	      prev && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: activePage - 1,
	          disabled: activePage === 1
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Previous' },
	          prev === true ? '\u2039' : prev
	        )
	      ),
	      this.renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps),
	      next && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: activePage + 1,
	          disabled: activePage >= items
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Next' },
	          next === true ? '\u203A' : next
	        )
	      ),
	      last && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: items,
	          disabled: activePage >= items
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Last' },
	          last === true ? '\xBB' : last
	        )
	      )
	    );
	  };
	
	  return Pagination;
	}(_react2['default'].Component);
	
	Pagination.propTypes = propTypes;
	Pagination.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('pagination', Pagination);
	module.exports = exports['default'];

/***/ },
/* 1786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(156);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(428);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  collapsible: _propTypes2['default'].bool,
	  onSelect: _propTypes2['default'].func,
	  header: _propTypes2['default'].node,
	  id: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	  footer: _propTypes2['default'].node,
	  defaultExpanded: _propTypes2['default'].bool,
	  expanded: _propTypes2['default'].bool,
	  eventKey: _propTypes2['default'].any,
	  headerRole: _propTypes2['default'].string,
	  panelRole: _propTypes2['default'].string,
	
	  // From Collapse.
	  onEnter: _propTypes2['default'].func,
	  onEntering: _propTypes2['default'].func,
	  onEntered: _propTypes2['default'].func,
	  onExit: _propTypes2['default'].func,
	  onExiting: _propTypes2['default'].func,
	  onExited: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  defaultExpanded: false
	};
	
	var Panel = function (_React$Component) {
	  (0, _inherits3['default'])(Panel, _React$Component);
	
	  function Panel(props, context) {
	    (0, _classCallCheck3['default'])(this, Panel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClickTitle = _this.handleClickTitle.bind(_this);
	
	    _this.state = {
	      expanded: _this.props.defaultExpanded
	    };
	    return _this;
	  }
	
	  Panel.prototype.handleClickTitle = function handleClickTitle(e) {
	    // FIXME: What the heck? This API is horrible. This needs to go away!
	    e.persist();
	    e.selected = true;
	
	    if (this.props.onSelect) {
	      this.props.onSelect(this.props.eventKey, e);
	    } else {
	      e.preventDefault();
	    }
	
	    if (e.selected) {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  };
	
	  Panel.prototype.renderHeader = function renderHeader(collapsible, header, id, role, expanded, bsProps) {
	    var titleClassName = (0, _bootstrapUtils.prefix)(bsProps, 'title');
	
	    if (!collapsible) {
	      if (!_react2['default'].isValidElement(header)) {
	        return header;
	      }
	
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2['default'])(header.props.className, titleClassName)
	      });
	    }
	
	    if (!_react2['default'].isValidElement(header)) {
	      return _react2['default'].createElement(
	        'h4',
	        { role: 'presentation', className: titleClassName },
	        this.renderAnchor(header, id, role, expanded)
	      );
	    }
	
	    return (0, _react.cloneElement)(header, {
	      className: (0, _classnames2['default'])(header.props.className, titleClassName),
	      children: this.renderAnchor(header.props.children, id, role, expanded)
	    });
	  };
	
	  Panel.prototype.renderAnchor = function renderAnchor(header, id, role, expanded) {
	    return _react2['default'].createElement(
	      'a',
	      {
	        role: role,
	        href: id && '#' + id,
	        onClick: this.handleClickTitle,
	        'aria-controls': id,
	        'aria-expanded': expanded,
	        'aria-selected': expanded,
	        className: expanded ? null : 'collapsed'
	      },
	      header
	    );
	  };
	
	  Panel.prototype.renderCollapsibleBody = function renderCollapsibleBody(id, expanded, role, children, bsProps, animationHooks) {
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      (0, _extends3['default'])({ 'in': expanded }, animationHooks),
	      _react2['default'].createElement(
	        'div',
	        {
	          id: id,
	          role: role,
	          className: (0, _bootstrapUtils.prefix)(bsProps, 'collapse'),
	          'aria-hidden': !expanded
	        },
	        this.renderBody(children, bsProps)
	      )
	    );
	  };
	
	  Panel.prototype.renderBody = function renderBody(rawChildren, bsProps) {
	    var children = [];
	    var bodyChildren = [];
	
	    var bodyClassName = (0, _bootstrapUtils.prefix)(bsProps, 'body');
	
	    function maybeAddBody() {
	      if (!bodyChildren.length) {
	        return;
	      }
	
	      // Derive the key from the index here, since we need to make one up.
	      children.push(_react2['default'].createElement(
	        'div',
	        { key: children.length, className: bodyClassName },
	        bodyChildren
	      ));
	
	      bodyChildren = [];
	    }
	
	    // Convert to array so we can re-use keys.
	    _react2['default'].Children.toArray(rawChildren).forEach(function (child) {
	      if (_react2['default'].isValidElement(child) && child.props.fill) {
	        maybeAddBody();
	
	        // Remove the child's unknown `fill` prop.
	        children.push((0, _react.cloneElement)(child, { fill: undefined }));
	
	        return;
	      }
	
	      bodyChildren.push(child);
	    });
	
	    maybeAddBody();
	
	    return children;
	  };
	
	  Panel.prototype.render = function render() {
	    var _props = this.props,
	        collapsible = _props.collapsible,
	        header = _props.header,
	        id = _props.id,
	        footer = _props.footer,
	        propsExpanded = _props.expanded,
	        headerRole = _props.headerRole,
	        panelRole = _props.panelRole,
	        className = _props.className,
	        children = _props.children,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['collapsible', 'header', 'id', 'footer', 'expanded', 'headerRole', 'panelRole', 'className', 'children', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultExpanded', 'eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var expanded = propsExpanded != null ? propsExpanded : this.state.expanded;
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes),
	        id: collapsible ? null : id
	      }),
	      header && _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'heading') },
	        this.renderHeader(collapsible, header, id, headerRole, expanded, bsProps)
	      ),
	      collapsible ? this.renderCollapsibleBody(id, expanded, panelRole, children, bsProps, { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited }) : this.renderBody(children, bsProps),
	      footer && _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'footer') },
	        footer
	      )
	    );
	  };
	
	  return Panel;
	}(_react2['default'].Component);
	
	Panel.propTypes = propTypes;
	Panel.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('panel', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Panel));
	module.exports = exports['default'];

/***/ },
/* 1787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(300);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Sets the direction the Popover is positioned towards.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Popover.
	   */
	  positionTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Popover.
	   */
	  positionLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * The "top" position value for the Popover arrow.
	   */
	  arrowOffsetTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Popover arrow.
	   */
	  arrowOffsetLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * Title content
	   */
	  title: _propTypes2['default'].node
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Popover = function (_React$Component) {
	  (0, _inherits3['default'])(Popover, _React$Component);
	
	  function Popover() {
	    (0, _classCallCheck3['default'])(this, Popover);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Popover.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        title = _props.title,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      display: 'block',
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: 'arrow', style: arrowStyle }),
	      title && _react2['default'].createElement(
	        'h3',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'title') },
	        title
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'content') },
	        children
	      )
	    );
	  };
	
	  return Popover;
	}(_react2['default'].Component);
	
	Popover.propTypes = propTypes;
	Popover.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('popover', Popover);
	module.exports = exports['default'];

/***/ },
/* 1788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(156);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(56);
	
	var _ValidComponentChildren = __webpack_require__(71);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ROUND_PRECISION = 1000;
	
	/**
	 * Validate that children, if any, are instances of `<ProgressBar>`.
	 */
	function onlyProgressBar(props, propName, componentName) {
	  var children = props[propName];
	  if (!children) {
	    return null;
	  }
	
	  var error = null;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (error) {
	      return;
	    }
	
	    if (child.type === ProgressBar) {
	      // eslint-disable-line no-use-before-define
	      return;
	    }
	
	    var childIdentifier = _react2['default'].isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
	    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
	  });
	
	  return error;
	}
	
	var propTypes = {
	  min: _propTypes2['default'].number,
	  now: _propTypes2['default'].number,
	  max: _propTypes2['default'].number,
	  label: _propTypes2['default'].node,
	  srOnly: _propTypes2['default'].bool,
	  striped: _propTypes2['default'].bool,
	  active: _propTypes2['default'].bool,
	  children: onlyProgressBar,
	
	  /**
	   * @private
	   */
	  isChild: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  min: 0,
	  max: 100,
	  active: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	};
	
	function getPercentage(now, min, max) {
	  var percentage = (now - min) / (max - min) * 100;
	  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
	}
	
	var ProgressBar = function (_React$Component) {
	  (0, _inherits3['default'])(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    (0, _classCallCheck3['default'])(this, ProgressBar);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
	    var _extends2;
	
	    var min = _ref.min,
	        now = _ref.now,
	        max = _ref.max,
	        label = _ref.label,
	        srOnly = _ref.srOnly,
	        striped = _ref.striped,
	        active = _ref.active,
	        className = _ref.className,
	        style = _ref.style,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = active || striped, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'progressbar',
	        className: (0, _classnames2['default'])(className, classes),
	        style: (0, _extends4['default'])({ width: getPercentage(now, min, max) + '%' }, style),
	        'aria-valuenow': now,
	        'aria-valuemin': min,
	        'aria-valuemax': max
	      }),
	      srOnly ? _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      ) : label
	    );
	  };
	
	  ProgressBar.prototype.render = function render() {
	    var _props = this.props,
	        isChild = _props.isChild,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['isChild']);
	
	
	    if (isChild) {
	      return this.renderProgressBar(props);
	    }
	
	    var min = props.min,
	        now = props.now,
	        max = props.max,
	        label = props.label,
	        srOnly = props.srOnly,
	        striped = props.striped,
	        active = props.active,
	        bsClass = props.bsClass,
	        bsStyle = props.bsStyle,
	        className = props.className,
	        children = props.children,
	        wrapperProps = (0, _objectWithoutProperties3['default'])(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);
	
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, wrapperProps, {
	        className: (0, _classnames2['default'])(className, 'progress')
	      }),
	      children ? _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, { isChild: true });
	      }) : this.renderProgressBar({
	        min: min, now: now, max: max, label: label, srOnly: srOnly, striped: striped, active: active, bsClass: bsClass, bsStyle: bsStyle
	      })
	    );
	  };
	
	  return ProgressBar;
	}(_react2['default'].Component);
	
	ProgressBar.propTypes = propTypes;
	ProgressBar.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('progress-bar', (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), ProgressBar));
	module.exports = exports['default'];

/***/ },
/* 1789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  inline: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2['default'].oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Radio inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Radio = function (_React$Component) {
	  (0, _inherits3['default'])(Radio, _React$Component);
	
	  function Radio() {
	    (0, _classCallCheck3['default'])(this, Radio);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Radio.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2['default'].createElement('input', (0, _extends3['default'])({}, elementProps, {
	      ref: inputRef,
	      type: 'radio',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2['default'])(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: (0, _classnames2['default'])(className, _classes), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Radio;
	}(_react2['default'].Component);
	
	Radio.propTypes = propTypes;
	Radio.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('radio', Radio);
	module.exports = exports['default'];

/***/ },
/* 1790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should probably take a single `aspectRatio` prop.
	
	var propTypes = {
	  /**
	   * This component requires a single child element
	   */
	  children: _propTypes2['default'].element.isRequired,
	  /**
	   * 16by9 aspect ratio
	   */
	  a16by9: _propTypes2['default'].bool,
	  /**
	   * 4by3 aspect ratio
	   */
	  a4by3: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  a16by9: false,
	  a4by3: false
	};
	
	var ResponsiveEmbed = function (_React$Component) {
	  (0, _inherits3['default'])(ResponsiveEmbed, _React$Component);
	
	  function ResponsiveEmbed() {
	    (0, _classCallCheck3['default'])(this, ResponsiveEmbed);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ResponsiveEmbed.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        a16by9 = _props.a16by9,
	        a4by3 = _props.a4by3,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['a16by9', 'a4by3', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
	     false ? (0, _warning2['default'])(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '16by9')] = a16by9, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '4by3')] = a4by3, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(classes) },
	      (0, _react.cloneElement)(children, (0, _extends4['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'item'))
	      }))
	    );
	  };
	
	  return ResponsiveEmbed;
	}(_react2['default'].Component);
	
	ResponsiveEmbed.propTypes = propTypes;
	ResponsiveEmbed.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('embed-responsive', ResponsiveEmbed);
	module.exports = exports['default'];

/***/ },
/* 1791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Row = function (_React$Component) {
	  (0, _inherits3['default'])(Row, _React$Component);
	
	  function Row() {
	    (0, _classCallCheck3['default'])(this, Row);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Row.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Row;
	}(_react2['default'].Component);
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('row', Row);
	module.exports = exports['default'];

/***/ },
/* 1792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(221);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dropdown = __webpack_require__(286);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SplitToggle = __webpack_require__(1793);
	
	var _SplitToggle2 = _interopRequireDefault(_SplitToggle);
	
	var _splitComponentProps2 = __webpack_require__(288);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2['default'].string,
	  bsSize: _propTypes2['default'].string,
	  href: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  /**
	   * The content of the split button.
	   */
	  title: _propTypes2['default'].node.isRequired,
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _propTypes2['default'].string,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2['default'].node
	});
	
	var SplitButton = function (_React$Component) {
	  (0, _inherits3['default'])(SplitButton, _React$Component);
	
	  function SplitButton() {
	    (0, _classCallCheck3['default'])(this, SplitButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        toggleLabel = _props.toggleLabel,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        buttonProps = _splitComponentProps[1];
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Button2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          disabled: props.disabled,
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2['default'].createElement(_SplitToggle2['default'], {
	        'aria-label': toggleLabel || title,
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return SplitButton;
	}(_react2['default'].Component);
	
	SplitButton.propTypes = propTypes;
	
	SplitButton.Toggle = _SplitToggle2['default'];
	
	exports['default'] = SplitButton;
	module.exports = exports['default'];

/***/ },
/* 1793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownToggle = __webpack_require__(835);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SplitToggle = function (_React$Component) {
	  (0, _inherits3['default'])(SplitToggle, _React$Component);
	
	  function SplitToggle() {
	    (0, _classCallCheck3['default'])(this, SplitToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitToggle.prototype.render = function render() {
	    return _react2['default'].createElement(_DropdownToggle2['default'], (0, _extends3['default'])({}, this.props, {
	      useAnchor: false,
	      noCaret: false
	    }));
	  };
	
	  return SplitToggle;
	}(_react2['default'].Component);
	
	SplitToggle.defaultProps = _DropdownToggle2['default'].defaultProps;
	
	exports['default'] = SplitToggle;
	module.exports = exports['default'];

/***/ },
/* 1794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TabContainer = __webpack_require__(431);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(432);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _TabPane = __webpack_require__(849);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _TabPane2['default'].propTypes, {
	
	  disabled: _propTypes2['default'].bool,
	
	  title: _propTypes2['default'].node,
	
	  /**
	   * tabClassName is used as className for the associated NavItem
	   */
	  tabClassName: _propTypes2['default'].string
	});
	
	var Tab = function (_React$Component) {
	  (0, _inherits3['default'])(Tab, _React$Component);
	
	  function Tab() {
	    (0, _classCallCheck3['default'])(this, Tab);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tab.prototype.render = function render() {
	    var props = (0, _extends3['default'])({}, this.props);
	
	    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
	    delete props.title;
	    delete props.disabled;
	    delete props.tabClassName;
	
	    return _react2['default'].createElement(_TabPane2['default'], props);
	  };
	
	  return Tab;
	}(_react2['default'].Component);
	
	Tab.propTypes = propTypes;
	
	Tab.Container = _TabContainer2['default'];
	Tab.Content = _TabContent2['default'];
	Tab.Pane = _TabPane2['default'];
	
	exports['default'] = Tab;
	module.exports = exports['default'];

/***/ },
/* 1795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  striped: _propTypes2['default'].bool,
	  bordered: _propTypes2['default'].bool,
	  condensed: _propTypes2['default'].bool,
	  hover: _propTypes2['default'].bool,
	  responsive: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  bordered: false,
	  condensed: false,
	  hover: false,
	  responsive: false,
	  striped: false
	};
	
	var Table = function (_React$Component) {
	  (0, _inherits3['default'])(Table, _React$Component);
	
	  function Table() {
	    (0, _classCallCheck3['default'])(this, Table);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Table.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        striped = _props.striped,
	        bordered = _props.bordered,
	        condensed = _props.condensed,
	        hover = _props.hover,
	        responsive = _props.responsive,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = striped, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'bordered')] = bordered, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'condensed')] = condensed, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'hover')] = hover, _extends2));
	
	    var table = _react2['default'].createElement('table', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (responsive) {
	      return _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'responsive') },
	        table
	      );
	    }
	
	    return table;
	  };
	
	  return Table;
	}(_react2['default'].Component);
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('table', Table);
	module.exports = exports['default'];

/***/ },
/* 1796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(300);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(305);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Nav = __webpack_require__(842);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _NavItem = __webpack_require__(843);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _TabContainer = __webpack_require__(431);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(432);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _ValidComponentChildren = __webpack_require__(71);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabContainer = _TabContainer2['default'].ControlledComponent;
	
	var propTypes = {
	  /**
	   * Mark the Tab with a matching `eventKey` as active.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2['default'].any,
	
	  /**
	   * Navigation style
	   */
	  bsStyle: _propTypes2['default'].oneOf(['tabs', 'pills']),
	
	  animation: _propTypes2['default'].bool,
	
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Callback fired when a Tab is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2['default'].func,
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2['default'].bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2['default'].bool
	};
	
	var defaultProps = {
	  bsStyle: 'tabs',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	function getDefaultActiveKey(children) {
	  var defaultActiveKey = void 0;
	  _ValidComponentChildren2['default'].forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	
	  return defaultActiveKey;
	}
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3['default'])(Tabs, _React$Component);
	
	  function Tabs() {
	    (0, _classCallCheck3['default'])(this, Tabs);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tabs.prototype.renderTab = function renderTab(child) {
	    var _child$props = child.props,
	        title = _child$props.title,
	        eventKey = _child$props.eventKey,
	        disabled = _child$props.disabled,
	        tabClassName = _child$props.tabClassName;
	
	    if (title == null) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _NavItem2['default'],
	      {
	        eventKey: eventKey,
	        disabled: disabled,
	        className: tabClassName
	      },
	      title
	    );
	  };
	
	  Tabs.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        onSelect = _props.onSelect,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        _props$activeKey = _props.activeKey,
	        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['id', 'onSelect', 'animation', 'mountOnEnter', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);
	
	
	    return _react2['default'].createElement(
	      TabContainer,
	      {
	        id: id,
	        activeKey: activeKey,
	        onSelect: onSelect,
	        className: className,
	        style: style
	      },
	      _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _Nav2['default'],
	          (0, _extends3['default'])({}, props, {
	            role: 'tablist'
	          }),
	          _ValidComponentChildren2['default'].map(children, this.renderTab)
	        ),
	        _react2['default'].createElement(
	          _TabContent2['default'],
	          {
	            bsClass: bsClass,
	            animation: animation,
	            mountOnEnter: mountOnEnter,
	            unmountOnExit: unmountOnExit
	          },
	          children
	        )
	      )
	    );
	  };
	
	  return Tabs;
	}(_react2['default'].Component);
	
	Tabs.propTypes = propTypes;
	Tabs.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('tab', Tabs);
	
	exports['default'] = (0, _uncontrollable2['default'])(Tabs, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 1797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(103);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  src: _propTypes2['default'].string,
	  alt: _propTypes2['default'].string,
	  href: _propTypes2['default'].string
	};
	
	var Thumbnail = function (_React$Component) {
	  (0, _inherits3['default'])(Thumbnail, _React$Component);
	
	  function Thumbnail() {
	    (0, _classCallCheck3['default'])(this, Thumbnail);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Thumbnail.prototype.render = function render() {
	    var _props = this.props,
	        src = _props.src,
	        alt = _props.alt,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['src', 'alt', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var Component = elementProps.href ? _SafeAnchor2['default'] : 'div';
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement('img', { src: src, alt: alt }),
	      children && _react2['default'].createElement(
	        'div',
	        { className: 'caption' },
	        children
	      )
	    );
	  };
	
	  return Thumbnail;
	}(_react2['default'].Component);
	
	Thumbnail.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('thumbnail', Thumbnail);
	module.exports = exports['default'];

/***/ },
/* 1798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(7);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(300);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	
	  /**
	   * Sets the direction the Tooltip is positioned towards.
	   */
	  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Tooltip.
	   */
	  positionTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Tooltip.
	   */
	  positionLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	
	  /**
	   * The "top" position value for the Tooltip arrow.
	   */
	  arrowOffsetTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  /**
	   * The "left" position value for the Tooltip arrow.
	   */
	  arrowOffsetLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Tooltip = function (_React$Component) {
	  (0, _inherits3['default'])(Tooltip, _React$Component);
	
	  function Tooltip() {
	    (0, _classCallCheck3['default'])(this, Tooltip);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tooltip.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: (0, _bootstrapUtils.prefix)(bsProps, 'arrow'), style: arrowStyle }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        children
	      )
	    );
	  };
	
	  return Tooltip;
	}(_react2['default'].Component);
	
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tooltip', Tooltip);
	module.exports = exports['default'];

/***/ },
/* 1799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(11);
	
	var _StyleConfig = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Well = function (_React$Component) {
	  (0, _inherits3['default'])(Well, _React$Component);
	
	  function Well() {
	    (0, _classCallCheck3['default'])(this, Well);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Well.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Well;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('well', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Well));
	module.exports = exports['default'];

/***/ },
/* 1800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.requiredRoles = requiredRoles;
	exports.exclusiveRoles = exclusiveRoles;
	
	var _createChainableTypeChecker = __webpack_require__(301);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	var _ValidComponentChildren = __webpack_require__(71);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function requiredRoles() {
	  for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
	    roles[_key] = arguments[_key];
	  }
	
	  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
	    var missing = void 0;
	
	    roles.every(function (role) {
	      if (!_ValidComponentChildren2['default'].some(props.children, function (child) {
	        return child.props.bsRole === role;
	      })) {
	        missing = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (missing) {
	      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}
	
	function exclusiveRoles() {
	  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    roles[_key2] = arguments[_key2];
	  }
	
	  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
	    var duplicate = void 0;
	
	    roles.every(function (role) {
	      var childrenWithRole = _ValidComponentChildren2['default'].filter(props.children, function (child) {
	        return child.props.bsRole === role;
	      });
	
	      if (childrenWithRole.length > 1) {
	        duplicate = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (duplicate) {
	      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}

/***/ },
/* 1801 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This file contains a modified version of:
	 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
	 *
	 * This source code is licensed under the BSD-style license found here:
	 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
	 * An additional grant of patent rights can be found here:
	 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
	 */
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },
	
	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    // eslint-disable-line guard-for-in
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = ReactTransitionEvents;
	module.exports = exports['default'];

/***/ },
/* 1802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(196);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var warned = {};
	
	function deprecationWarning(oldname, newname, link) {
	  var message = void 0;
	
	  if ((typeof oldname === 'undefined' ? 'undefined' : (0, _typeof3['default'])(oldname)) === 'object') {
	    message = oldname.message;
	  } else {
	    message = oldname + ' is deprecated. Use ' + newname + ' instead.';
	
	    if (link) {
	      message += '\nYou can read more about it at ' + link;
	    }
	  }
	
	  if (warned[message]) {
	    return;
	  }
	
	   false ? (0, _warning2['default'])(false, message) : void 0;
	  warned[message] = true;
	}
	
	deprecationWarning.wrapper = function (Component) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return function (_Component) {
	    (0, _inherits3['default'])(DeprecatedComponent, _Component);
	
	    function DeprecatedComponent() {
	      (0, _classCallCheck3['default'])(this, DeprecatedComponent);
	      return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	    }
	
	    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
	      deprecationWarning.apply(undefined, args);
	
	      if (_Component.prototype.componentWillMount) {
	        var _Component$prototype$;
	
	        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          methodArgs[_key2] = arguments[_key2];
	        }
	
	        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
	      }
	    };
	
	    return DeprecatedComponent;
	  }(Component);
	};
	
	exports['default'] = deprecationWarning;
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 1803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ValidComponentChildren = exports.createChainedFunction = exports.bootstrapUtils = undefined;
	
	var _bootstrapUtils2 = __webpack_require__(11);
	
	var _bootstrapUtils = _interopRequireWildcard(_bootstrapUtils2);
	
	var _createChainedFunction2 = __webpack_require__(50);
	
	var _createChainedFunction3 = _interopRequireDefault(_createChainedFunction2);
	
	var _ValidComponentChildren2 = __webpack_require__(71);
	
	var _ValidComponentChildren3 = _interopRequireDefault(_ValidComponentChildren2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	exports.bootstrapUtils = _bootstrapUtils;
	exports.createChainedFunction = _createChainedFunction3['default'];
	exports.ValidComponentChildren = _ValidComponentChildren3['default'];

/***/ },
/* 1804 */
/***/ function(module, exports, __webpack_require__) {

	// eslint-disable-next-line import/no-unresolved
	module.exports = __webpack_require__(1816);


/***/ },
/* 1805 */
/***/ function(module, exports, __webpack_require__) {

	// eslint-disable-next-line import/no-unresolved
	__webpack_require__(1817);


/***/ },
/* 1806 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = CalendarWeek;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _CalendarDay = _interopRequireDefault(__webpack_require__(433));
	
	var _CustomizableCalendarDay = _interopRequireDefault(__webpack_require__(1809));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)({
	  children: (0, _airbnbPropTypes.or)([(0, _airbnbPropTypes.childrenOfType)(_CalendarDay["default"]), (0, _airbnbPropTypes.childrenOfType)(_CustomizableCalendarDay["default"])]).isRequired
	}) : {};
	
	function CalendarWeek(_ref) {
	  var children = _ref.children;
	  return _react["default"].createElement("tr", null, children);
	}
	
	CalendarWeek.propTypes =  false ? propTypes : {};

/***/ },
/* 1807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var ChevronDown = function () {
	  function ChevronDown(props) {
	    return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
	      d: "M967.5 288.5L514.3 740.7c-11 11-21 11-32 0L29.1 288.5c-4-5-6-11-6-16 0-13 10-23 23-23 6 0 11 2 15 7l437.2 436.2 437.2-436.2c4-5 9-7 16-7 6 0 11 2 16 7 9 10.9 9 21 0 32z"
	    }));
	  }
	
	  return ChevronDown;
	}();
	
	ChevronDown.defaultProps = {
	  focusable: "false",
	  viewBox: "0 0 1000 1000"
	};
	var _default = ChevronDown;
	exports["default"] = _default;

/***/ },
/* 1808 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var ChevronUp = function () {
	  function ChevronUp(props) {
	    return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
	      d: "M32.1 712.6l453.2-452.2c11-11 21-11 32 0l453.2 452.2c4 5 6 10 6 16 0 13-10 23-22 23-7 0-12-2-16-7L501.3 308.5 64.1 744.7c-4 5-9 7-15 7-7 0-12-2-17-7-9-11-9-21 0-32.1z"
	    }));
	  }
	
	  return ChevronUp;
	}();
	
	ChevronUp.defaultProps = {
	  focusable: "false",
	  viewBox: "0 0 1000 1000"
	};
	var _default = ChevronUp;
	exports["default"] = _default;

/***/ },
/* 1809 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.PureCustomizableCalendarDay = exports.selectedStyles = exports.lastInRangeStyles = exports.selectedSpanStyles = exports.hoveredSpanStyles = exports.blockedOutOfRangeStyles = exports.blockedCalendarStyles = exports.blockedMinNightsStyles = exports.highlightedCalendarStyles = exports.outsideStyles = exports.defaultStyles = void 0;
	
	var _reactAddonsShallowCompare = _interopRequireDefault(__webpack_require__(70));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(105));
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _defaultPhrases = __webpack_require__(51);
	
	var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(60));
	
	var _getCalendarDaySettings = _interopRequireDefault(__webpack_require__(870));
	
	var _constants = __webpack_require__(21);
	
	var _DefaultTheme = _interopRequireDefault(__webpack_require__(867));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () { function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); } return _getPrototypeOf; }(); return _getPrototypeOf(o); }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function () { function _setPrototypeOf(o, p) { o.__proto__ = p; return o; } return _setPrototypeOf; }(); return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var color = _DefaultTheme["default"].reactDates.color;
	
	function getStyles(stylesObj, isHovered) {
	  if (!stylesObj) return null;
	  var hover = stylesObj.hover;
	
	  if (isHovered && hover) {
	    return hover;
	  }
	
	  return stylesObj;
	}
	
	var DayStyleShape =  false ? _propTypes["default"].shape({
	  background: _propTypes["default"].string,
	  border: (0, _airbnbPropTypes.or)([_propTypes["default"].string, _propTypes["default"].number]),
	  color: _propTypes["default"].string,
	  hover: _propTypes["default"].shape({
	    background: _propTypes["default"].string,
	    border: (0, _airbnbPropTypes.or)([_propTypes["default"].string, _propTypes["default"].number]),
	    color: _propTypes["default"].string
	  })
	}) : {};
	var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
	  day: _reactMomentProptypes["default"].momentObj,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  isOutsideDay: _propTypes["default"].bool,
	  modifiers: _propTypes["default"].instanceOf(Set),
	  isFocused: _propTypes["default"].bool,
	  tabIndex: _propTypes["default"].oneOf([0, -1]),
	  onDayClick: _propTypes["default"].func,
	  onDayMouseEnter: _propTypes["default"].func,
	  onDayMouseLeave: _propTypes["default"].func,
	  renderDayContents: _propTypes["default"].func,
	  ariaLabelFormat: _propTypes["default"].string,
	  // style overrides
	  defaultStyles: DayStyleShape,
	  outsideStyles: DayStyleShape,
	  todayStyles: DayStyleShape,
	  firstDayOfWeekStyles: DayStyleShape,
	  lastDayOfWeekStyles: DayStyleShape,
	  highlightedCalendarStyles: DayStyleShape,
	  blockedMinNightsStyles: DayStyleShape,
	  blockedCalendarStyles: DayStyleShape,
	  blockedOutOfRangeStyles: DayStyleShape,
	  hoveredSpanStyles: DayStyleShape,
	  selectedSpanStyles: DayStyleShape,
	  lastInRangeStyles: DayStyleShape,
	  selectedStyles: DayStyleShape,
	  selectedStartStyles: DayStyleShape,
	  selectedEndStyles: DayStyleShape,
	  afterHoveredStartStyles: DayStyleShape,
	  // internationalization
	  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.CalendarDayPhrases))
	})) : {};
	var defaultStyles = {
	  border: "1px solid ".concat(color.core.borderLight),
	  color: color.text,
	  background: color.background,
	  hover: {
	    background: color.core.borderLight,
	    border: "1px solid ".concat(color.core.borderLight),
	    color: 'inherit'
	  }
	};
	exports.defaultStyles = defaultStyles;
	var outsideStyles = {
	  background: color.outside.backgroundColor,
	  border: 0,
	  color: color.outside.color
	};
	exports.outsideStyles = outsideStyles;
	var highlightedCalendarStyles = {
	  background: color.highlighted.backgroundColor,
	  color: color.highlighted.color,
	  hover: {
	    background: color.highlighted.backgroundColor_hover,
	    color: color.highlighted.color_active
	  }
	};
	exports.highlightedCalendarStyles = highlightedCalendarStyles;
	var blockedMinNightsStyles = {
	  background: color.minimumNights.backgroundColor,
	  border: "1px solid ".concat(color.minimumNights.borderColor),
	  color: color.minimumNights.color,
	  hover: {
	    background: color.minimumNights.backgroundColor_hover,
	    color: color.minimumNights.color_active
	  }
	};
	exports.blockedMinNightsStyles = blockedMinNightsStyles;
	var blockedCalendarStyles = {
	  background: color.blocked_calendar.backgroundColor,
	  border: "1px solid ".concat(color.blocked_calendar.borderColor),
	  color: color.blocked_calendar.color,
	  hover: {
	    background: color.blocked_calendar.backgroundColor_hover,
	    border: "1px solid ".concat(color.blocked_calendar.borderColor),
	    color: color.blocked_calendar.color_active
	  }
	};
	exports.blockedCalendarStyles = blockedCalendarStyles;
	var blockedOutOfRangeStyles = {
	  background: color.blocked_out_of_range.backgroundColor,
	  border: "1px solid ".concat(color.blocked_out_of_range.borderColor),
	  color: color.blocked_out_of_range.color,
	  hover: {
	    background: color.blocked_out_of_range.backgroundColor_hover,
	    border: "1px solid ".concat(color.blocked_out_of_range.borderColor),
	    color: color.blocked_out_of_range.color_active
	  }
	};
	exports.blockedOutOfRangeStyles = blockedOutOfRangeStyles;
	var hoveredSpanStyles = {
	  background: color.hoveredSpan.backgroundColor,
	  border: "1px double ".concat(color.hoveredSpan.borderColor),
	  color: color.hoveredSpan.color,
	  hover: {
	    background: color.hoveredSpan.backgroundColor_hover,
	    border: "1px double ".concat(color.hoveredSpan.borderColor),
	    color: color.hoveredSpan.color_active
	  }
	};
	exports.hoveredSpanStyles = hoveredSpanStyles;
	var selectedSpanStyles = {
	  background: color.selectedSpan.backgroundColor,
	  border: "1px double ".concat(color.selectedSpan.borderColor),
	  color: color.selectedSpan.color,
	  hover: {
	    background: color.selectedSpan.backgroundColor_hover,
	    border: "1px double ".concat(color.selectedSpan.borderColor),
	    color: color.selectedSpan.color_active
	  }
	};
	exports.selectedSpanStyles = selectedSpanStyles;
	var lastInRangeStyles = {
	  borderStyle: 'solid',
	  hover: {
	    borderStyle: 'solid'
	  }
	};
	exports.lastInRangeStyles = lastInRangeStyles;
	var selectedStyles = {
	  background: color.selected.backgroundColor,
	  border: "1px double ".concat(color.selected.borderColor),
	  color: color.selected.color,
	  hover: {
	    background: color.selected.backgroundColor_hover,
	    border: "1px double ".concat(color.selected.borderColor),
	    color: color.selected.color_active
	  }
	};
	exports.selectedStyles = selectedStyles;
	var defaultProps = {
	  day: (0, _moment["default"])(),
	  daySize: _constants.DAY_SIZE,
	  isOutsideDay: false,
	  modifiers: new Set(),
	  isFocused: false,
	  tabIndex: -1,
	  onDayClick: function () {
	    function onDayClick() {}
	
	    return onDayClick;
	  }(),
	  onDayMouseEnter: function () {
	    function onDayMouseEnter() {}
	
	    return onDayMouseEnter;
	  }(),
	  onDayMouseLeave: function () {
	    function onDayMouseLeave() {}
	
	    return onDayMouseLeave;
	  }(),
	  renderDayContents: null,
	  ariaLabelFormat: 'dddd, LL',
	  // style defaults
	  defaultStyles: defaultStyles,
	  outsideStyles: outsideStyles,
	  todayStyles: {},
	  highlightedCalendarStyles: highlightedCalendarStyles,
	  blockedMinNightsStyles: blockedMinNightsStyles,
	  blockedCalendarStyles: blockedCalendarStyles,
	  blockedOutOfRangeStyles: blockedOutOfRangeStyles,
	  hoveredSpanStyles: hoveredSpanStyles,
	  selectedSpanStyles: selectedSpanStyles,
	  lastInRangeStyles: lastInRangeStyles,
	  selectedStyles: selectedStyles,
	  selectedStartStyles: {},
	  selectedEndStyles: {},
	  afterHoveredStartStyles: {},
	  firstDayOfWeekStyles: {},
	  lastDayOfWeekStyles: {},
	  // internationalization
	  phrases: _defaultPhrases.CalendarDayPhrases
	};
	
	var CustomizableCalendarDay =
	/*#__PURE__*/
	function (_ref) {
	  _inherits(CustomizableCalendarDay, _ref);
	
	  _createClass(CustomizableCalendarDay, [{
	    key: !_react["default"].PureComponent && "shouldComponentUpdate",
	    value: function () {
	      function value(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
	      }
	
	      return value;
	    }()
	  }]);
	
	  function CustomizableCalendarDay() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, CustomizableCalendarDay);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CustomizableCalendarDay)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isHovered: false
	    };
	    _this.setButtonRef = _this.setButtonRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    return _this;
	  }
	
	  _createClass(CustomizableCalendarDay, [{
	    key: "componentDidUpdate",
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var _this$props = this.props,
	            isFocused = _this$props.isFocused,
	            tabIndex = _this$props.tabIndex;
	
	        if (tabIndex === 0) {
	          if (isFocused || tabIndex !== prevProps.tabIndex) {
	            this.buttonRef.focus();
	          }
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: "onDayClick",
	    value: function () {
	      function onDayClick(day, e) {
	        var onDayClick = this.props.onDayClick;
	        onDayClick(day, e);
	      }
	
	      return onDayClick;
	    }()
	  }, {
	    key: "onDayMouseEnter",
	    value: function () {
	      function onDayMouseEnter(day, e) {
	        var onDayMouseEnter = this.props.onDayMouseEnter;
	        this.setState({
	          isHovered: true
	        });
	        onDayMouseEnter(day, e);
	      }
	
	      return onDayMouseEnter;
	    }()
	  }, {
	    key: "onDayMouseLeave",
	    value: function () {
	      function onDayMouseLeave(day, e) {
	        var onDayMouseLeave = this.props.onDayMouseLeave;
	        this.setState({
	          isHovered: false
	        });
	        onDayMouseLeave(day, e);
	      }
	
	      return onDayMouseLeave;
	    }()
	  }, {
	    key: "onKeyDown",
	    value: function () {
	      function onKeyDown(day, e) {
	        var onDayClick = this.props.onDayClick;
	        var key = e.key;
	
	        if (key === 'Enter' || key === ' ') {
	          onDayClick(day, e);
	        }
	      }
	
	      return onKeyDown;
	    }()
	  }, {
	    key: "setButtonRef",
	    value: function () {
	      function setButtonRef(ref) {
	        this.buttonRef = ref;
	      }
	
	      return setButtonRef;
	    }()
	  }, {
	    key: "render",
	    value: function () {
	      function render() {
	        var _this2 = this;
	
	        var _this$props2 = this.props,
	            day = _this$props2.day,
	            ariaLabelFormat = _this$props2.ariaLabelFormat,
	            daySize = _this$props2.daySize,
	            isOutsideDay = _this$props2.isOutsideDay,
	            modifiers = _this$props2.modifiers,
	            tabIndex = _this$props2.tabIndex,
	            renderDayContents = _this$props2.renderDayContents,
	            styles = _this$props2.styles,
	            phrases = _this$props2.phrases,
	            defaultStylesWithHover = _this$props2.defaultStyles,
	            outsideStylesWithHover = _this$props2.outsideStyles,
	            todayStylesWithHover = _this$props2.todayStyles,
	            firstDayOfWeekStylesWithHover = _this$props2.firstDayOfWeekStyles,
	            lastDayOfWeekStylesWithHover = _this$props2.lastDayOfWeekStyles,
	            highlightedCalendarStylesWithHover = _this$props2.highlightedCalendarStyles,
	            blockedMinNightsStylesWithHover = _this$props2.blockedMinNightsStyles,
	            blockedCalendarStylesWithHover = _this$props2.blockedCalendarStyles,
	            blockedOutOfRangeStylesWithHover = _this$props2.blockedOutOfRangeStyles,
	            hoveredSpanStylesWithHover = _this$props2.hoveredSpanStyles,
	            selectedSpanStylesWithHover = _this$props2.selectedSpanStyles,
	            lastInRangeStylesWithHover = _this$props2.lastInRangeStyles,
	            selectedStylesWithHover = _this$props2.selectedStyles,
	            selectedStartStylesWithHover = _this$props2.selectedStartStyles,
	            selectedEndStylesWithHover = _this$props2.selectedEndStyles,
	            afterHoveredStartStylesWithHover = _this$props2.afterHoveredStartStyles;
	        var isHovered = this.state.isHovered;
	        if (!day) return _react["default"].createElement("td", null);
	
	        var _getCalendarDaySettin = (0, _getCalendarDaySettings["default"])(day, ariaLabelFormat, daySize, modifiers, phrases),
	            daySizeStyles = _getCalendarDaySettin.daySizeStyles,
	            useDefaultCursor = _getCalendarDaySettin.useDefaultCursor,
	            selected = _getCalendarDaySettin.selected,
	            hoveredSpan = _getCalendarDaySettin.hoveredSpan,
	            isOutsideRange = _getCalendarDaySettin.isOutsideRange,
	            ariaLabel = _getCalendarDaySettin.ariaLabel;
	
	        return _react["default"].createElement("td", _extends({}, (0, _reactWithStyles.css)(styles.CalendarDay, useDefaultCursor && styles.CalendarDay__defaultCursor, daySizeStyles, getStyles(defaultStylesWithHover, isHovered), isOutsideDay && getStyles(outsideStylesWithHover, isHovered), modifiers.has('today') && getStyles(todayStylesWithHover, isHovered), modifiers.has('first-day-of-week') && getStyles(firstDayOfWeekStylesWithHover, isHovered), modifiers.has('last-day-of-week') && getStyles(lastDayOfWeekStylesWithHover, isHovered), modifiers.has('highlighted-calendar') && getStyles(highlightedCalendarStylesWithHover, isHovered), modifiers.has('blocked-minimum-nights') && getStyles(blockedMinNightsStylesWithHover, isHovered), modifiers.has('blocked-calendar') && getStyles(blockedCalendarStylesWithHover, isHovered), hoveredSpan && getStyles(hoveredSpanStylesWithHover, isHovered), modifiers.has('after-hovered-start') && getStyles(afterHoveredStartStylesWithHover, isHovered), modifiers.has('selected-span') && getStyles(selectedSpanStylesWithHover, isHovered), modifiers.has('last-in-range') && getStyles(lastInRangeStylesWithHover, isHovered), selected && getStyles(selectedStylesWithHover, isHovered), modifiers.has('selected-start') && getStyles(selectedStartStylesWithHover, isHovered), modifiers.has('selected-end') && getStyles(selectedEndStylesWithHover, isHovered), isOutsideRange && getStyles(blockedOutOfRangeStylesWithHover, isHovered)), {
	          role: "button" // eslint-disable-line jsx-a11y/no-noninteractive-element-to-interactive-role
	          ,
	          ref: this.setButtonRef,
	          "aria-disabled": modifiers.has('blocked'),
	          "aria-label": ariaLabel,
	          onMouseEnter: function () {
	            function onMouseEnter(e) {
	              _this2.onDayMouseEnter(day, e);
	            }
	
	            return onMouseEnter;
	          }(),
	          onMouseLeave: function () {
	            function onMouseLeave(e) {
	              _this2.onDayMouseLeave(day, e);
	            }
	
	            return onMouseLeave;
	          }(),
	          onMouseUp: function () {
	            function onMouseUp(e) {
	              e.currentTarget.blur();
	            }
	
	            return onMouseUp;
	          }(),
	          onClick: function () {
	            function onClick(e) {
	              _this2.onDayClick(day, e);
	            }
	
	            return onClick;
	          }(),
	          onKeyDown: function () {
	            function onKeyDown(e) {
	              _this2.onKeyDown(day, e);
	            }
	
	            return onKeyDown;
	          }(),
	          tabIndex: tabIndex
	        }), renderDayContents ? renderDayContents(day, modifiers) : day.format('D'));
	      }
	
	      return render;
	    }()
	  }]);
	
	  return CustomizableCalendarDay;
	}(_react["default"].PureComponent || _react["default"].Component);
	
	exports.PureCustomizableCalendarDay = CustomizableCalendarDay;
	CustomizableCalendarDay.propTypes =  false ? propTypes : {};
	CustomizableCalendarDay.defaultProps = defaultProps;
	
	var _default = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var font = _ref2.reactDates.font;
	  return {
	    CalendarDay: {
	      boxSizing: 'border-box',
	      cursor: 'pointer',
	      fontSize: font.size,
	      textAlign: 'center',
	      ':active': {
	        outline: 0
	      }
	    },
	    CalendarDay__defaultCursor: {
	      cursor: 'default'
	    }
	  };
	}, {
	  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
	})(CustomizableCalendarDay);
	
	exports["default"] = _default;

/***/ },
/* 1810 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.PureDateRangePicker = void 0;
	
	var _reactAddonsShallowCompare = _interopRequireDefault(__webpack_require__(70));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _reactPortal = __webpack_require__(909);
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _consolidatedEvents = __webpack_require__(249);
	
	var _isTouchDevice = _interopRequireDefault(__webpack_require__(171));
	
	var _reactOutsideClickHandler = _interopRequireDefault(__webpack_require__(457));
	
	var _DateRangePickerShape = _interopRequireDefault(__webpack_require__(863));
	
	var _defaultPhrases = __webpack_require__(51);
	
	var _getResponsiveContainerStyles = _interopRequireDefault(__webpack_require__(873));
	
	var _getDetachedContainerStyles = _interopRequireDefault(__webpack_require__(872));
	
	var _getInputHeight = _interopRequireDefault(__webpack_require__(435));
	
	var _isInclusivelyAfterDay = _interopRequireDefault(__webpack_require__(176));
	
	var _disableScroll2 = _interopRequireDefault(__webpack_require__(869));
	
	var _noflip = _interopRequireDefault(__webpack_require__(127));
	
	var _DateRangePickerInputController = _interopRequireDefault(__webpack_require__(856));
	
	var _DayPickerRangeController = _interopRequireDefault(__webpack_require__(857));
	
	var _CloseButton = _interopRequireDefault(__webpack_require__(222));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () { function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); } return _getPrototypeOf; }(); return _getPrototypeOf(o); }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function () { function _setPrototypeOf(o, p) { o.__proto__ = p; return o; } return _setPrototypeOf; }(); return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, _DateRangePickerShape["default"])) : {};
	var defaultProps = {
	  // required props for a functional interactive DateRangePicker
	  startDate: null,
	  endDate: null,
	  focusedInput: null,
	  // input related props
	  startDatePlaceholderText: 'Start Date',
	  endDatePlaceholderText: 'End Date',
	  startDateOffset: undefined,
	  endDateOffset: undefined,
	  disabled: false,
	  required: false,
	  readOnly: false,
	  screenReaderInputMessage: '',
	  showClearDates: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  customInputIcon: null,
	  customArrowIcon: null,
	  customCloseIcon: null,
	  noBorder: false,
	  block: false,
	  small: false,
	  regular: false,
	  keepFocusOnInput: false,
	  // calendar presentation and interaction related props
	  renderMonthText: null,
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  anchorDirection: _constants.ANCHOR_LEFT,
	  openDirection: _constants.OPEN_DOWN,
	  horizontalMargin: 0,
	  withPortal: false,
	  withFullScreenPortal: false,
	  appendToBody: false,
	  disableScroll: false,
	  initialVisibleMonth: null,
	  numberOfMonths: 2,
	  keepOpenOnDateSelect: false,
	  reopenPickerOnClearDates: false,
	  renderCalendarInfo: null,
	  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
	  hideKeyboardShortcutsPanel: false,
	  daySize: _constants.DAY_SIZE,
	  isRTL: false,
	  firstDayOfWeek: null,
	  verticalHeight: null,
	  transitionDuration: undefined,
	  verticalSpacing: _constants.DEFAULT_VERTICAL_SPACING,
	  horizontalMonthPadding: undefined,
	  // navigation related props
	  navPrev: null,
	  navNext: null,
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	  // day presentation and interaction related props
	  renderCalendarDay: undefined,
	  renderDayContents: null,
	  renderMonthElement: null,
	  minimumNights: 1,
	  enableOutsideDays: false,
	  isDayBlocked: function () {
	    function isDayBlocked() {
	      return false;
	    }
	
	    return isDayBlocked;
	  }(),
	  isOutsideRange: function () {
	    function isOutsideRange(day) {
	      return !(0, _isInclusivelyAfterDay["default"])(day, (0, _moment["default"])());
	    }
	
	    return isOutsideRange;
	  }(),
	  isDayHighlighted: function () {
	    function isDayHighlighted() {
	      return false;
	    }
	
	    return isDayHighlighted;
	  }(),
	  // internationalization
	  displayFormat: function () {
	    function displayFormat() {
	      return _moment["default"].localeData().longDateFormat('L');
	    }
	
	    return displayFormat;
	  }(),
	  monthFormat: 'MMMM YYYY',
	  weekDayFormat: 'dd',
	  phrases: _defaultPhrases.DateRangePickerPhrases,
	  dayAriaLabelFormat: undefined
	};
	
	var DateRangePicker =
	/*#__PURE__*/
	function (_ref) {
	  _inherits(DateRangePicker, _ref);
	
	  _createClass(DateRangePicker, [{
	    key: !_react["default"].PureComponent && "shouldComponentUpdate",
	    value: function () {
	      function value(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
	      }
	
	      return value;
	    }()
	  }]);
	
	  function DateRangePicker(props) {
	    var _this;
	
	    _classCallCheck(this, DateRangePicker);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateRangePicker).call(this, props));
	    _this.state = {
	      dayPickerContainerStyles: {},
	      isDateRangePickerInputFocused: false,
	      isDayPickerFocused: false,
	      showKeyboardShortcuts: false
	    };
	    _this.isTouchDevice = false;
	    _this.onOutsideClick = _this.onOutsideClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onDateRangePickerInputFocus = _this.onDateRangePickerInputFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onDayPickerFocus = _this.onDayPickerFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onDayPickerFocusOut = _this.onDayPickerFocusOut.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onDayPickerBlur = _this.onDayPickerBlur.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.showKeyboardShortcutsPanel = _this.showKeyboardShortcutsPanel.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.disableScroll = _this.disableScroll.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.setDayPickerContainerRef = _this.setDayPickerContainerRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.setContainerRef = _this.setContainerRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    return _this;
	  }
	
	  _createClass(DateRangePicker, [{
	    key: "componentDidMount",
	    value: function () {
	      function componentDidMount() {
	        this.removeEventListener = (0, _consolidatedEvents.addEventListener)(window, 'resize', this.responsivizePickerPosition, {
	          passive: true
	        });
	        this.responsivizePickerPosition();
	        this.disableScroll();
	        var focusedInput = this.props.focusedInput;
	
	        if (focusedInput) {
	          this.setState({
	            isDateRangePickerInputFocused: true
	          });
	        }
	
	        this.isTouchDevice = (0, _isTouchDevice["default"])();
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "componentDidUpdate",
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var focusedInput = this.props.focusedInput;
	
	        if (!prevProps.focusedInput && focusedInput && this.isOpened()) {
	          // The date picker just changed from being closed to being open.
	          this.responsivizePickerPosition();
	          this.disableScroll();
	        } else if (prevProps.focusedInput && !focusedInput && !this.isOpened()) {
	          // The date picker just changed from being open to being closed.
	          if (this.enableScroll) this.enableScroll();
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: "componentWillUnmount",
	    value: function () {
	      function componentWillUnmount() {
	        this.removeDayPickerEventListeners();
	        if (this.removeEventListener) this.removeEventListener();
	        if (this.enableScroll) this.enableScroll();
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: "onOutsideClick",
	    value: function () {
	      function onOutsideClick(event) {
	        var _this$props = this.props,
	            onFocusChange = _this$props.onFocusChange,
	            onClose = _this$props.onClose,
	            startDate = _this$props.startDate,
	            endDate = _this$props.endDate,
	            appendToBody = _this$props.appendToBody;
	        if (!this.isOpened()) return;
	        if (appendToBody && this.dayPickerContainer.contains(event.target)) return;
	        this.setState({
	          isDateRangePickerInputFocused: false,
	          isDayPickerFocused: false,
	          showKeyboardShortcuts: false
	        });
	        onFocusChange(null);
	        onClose({
	          startDate: startDate,
	          endDate: endDate
	        });
	      }
	
	      return onOutsideClick;
	    }()
	  }, {
	    key: "onDateRangePickerInputFocus",
	    value: function () {
	      function onDateRangePickerInputFocus(focusedInput) {
	        var _this$props2 = this.props,
	            onFocusChange = _this$props2.onFocusChange,
	            readOnly = _this$props2.readOnly,
	            withPortal = _this$props2.withPortal,
	            withFullScreenPortal = _this$props2.withFullScreenPortal,
	            keepFocusOnInput = _this$props2.keepFocusOnInput;
	
	        if (focusedInput) {
	          var withAnyPortal = withPortal || withFullScreenPortal;
	          var moveFocusToDayPicker = withAnyPortal || readOnly && !keepFocusOnInput || this.isTouchDevice && !keepFocusOnInput;
	
	          if (moveFocusToDayPicker) {
	            this.onDayPickerFocus();
	          } else {
	            this.onDayPickerBlur();
	          }
	        }
	
	        onFocusChange(focusedInput);
	      }
	
	      return onDateRangePickerInputFocus;
	    }()
	  }, {
	    key: "onDayPickerFocus",
	    value: function () {
	      function onDayPickerFocus() {
	        var _this$props3 = this.props,
	            focusedInput = _this$props3.focusedInput,
	            onFocusChange = _this$props3.onFocusChange;
	        if (!focusedInput) onFocusChange(_constants.START_DATE);
	        this.setState({
	          isDateRangePickerInputFocused: false,
	          isDayPickerFocused: true,
	          showKeyboardShortcuts: false
	        });
	      }
	
	      return onDayPickerFocus;
	    }()
	  }, {
	    key: "onDayPickerFocusOut",
	    value: function () {
	      function onDayPickerFocusOut(event) {
	        // In cases where **relatedTarget** is not null, it points to the right
	        // element here. However, in cases where it is null (such as clicking on a
	        // specific day), the appropriate value is **event.target**.
	        //
	        // We handle both situations here by using the ` || ` operator to fallback
	        // to *event.target** when **relatedTarget** is not provided.
	        if (this.dayPickerContainer.contains(event.relatedTarget || event.target)) return;
	        this.onOutsideClick(event);
	      }
	
	      return onDayPickerFocusOut;
	    }()
	  }, {
	    key: "onDayPickerBlur",
	    value: function () {
	      function onDayPickerBlur() {
	        this.setState({
	          isDateRangePickerInputFocused: true,
	          isDayPickerFocused: false,
	          showKeyboardShortcuts: false
	        });
	      }
	
	      return onDayPickerBlur;
	    }()
	  }, {
	    key: "setDayPickerContainerRef",
	    value: function () {
	      function setDayPickerContainerRef(ref) {
	        if (ref === this.dayPickerContainer) return;
	        if (this.dayPickerContainer) this.removeDayPickerEventListeners();
	        this.dayPickerContainer = ref;
	        if (!ref) return;
	        this.addDayPickerEventListeners();
	      }
	
	      return setDayPickerContainerRef;
	    }()
	  }, {
	    key: "setContainerRef",
	    value: function () {
	      function setContainerRef(ref) {
	        this.container = ref;
	      }
	
	      return setContainerRef;
	    }()
	  }, {
	    key: "addDayPickerEventListeners",
	    value: function () {
	      function addDayPickerEventListeners() {
	        // NOTE: We are using a manual event listener here, because React doesn't
	        // provide FocusOut, while blur and keydown don't provide the information
	        // needed in order to know whether we have left focus or not.
	        //
	        // For reference, this issue is further described here:
	        // - https://github.com/facebook/react/issues/6410
	        this.removeDayPickerFocusOut = (0, _consolidatedEvents.addEventListener)(this.dayPickerContainer, 'focusout', this.onDayPickerFocusOut);
	      }
	
	      return addDayPickerEventListeners;
	    }()
	  }, {
	    key: "removeDayPickerEventListeners",
	    value: function () {
	      function removeDayPickerEventListeners() {
	        if (this.removeDayPickerFocusOut) this.removeDayPickerFocusOut();
	      }
	
	      return removeDayPickerEventListeners;
	    }()
	  }, {
	    key: "isOpened",
	    value: function () {
	      function isOpened() {
	        var focusedInput = this.props.focusedInput;
	        return focusedInput === _constants.START_DATE || focusedInput === _constants.END_DATE;
	      }
	
	      return isOpened;
	    }()
	  }, {
	    key: "disableScroll",
	    value: function () {
	      function disableScroll() {
	        var _this$props4 = this.props,
	            appendToBody = _this$props4.appendToBody,
	            propDisableScroll = _this$props4.disableScroll;
	        if (!appendToBody && !propDisableScroll) return;
	        if (!this.isOpened()) return; // Disable scroll for every ancestor of this DateRangePicker up to the
	        // document level. This ensures the input and the picker never move. Other
	        // sibling elements or the picker itself can scroll.
	
	        this.enableScroll = (0, _disableScroll2["default"])(this.container);
	      }
	
	      return disableScroll;
	    }()
	  }, {
	    key: "responsivizePickerPosition",
	    value: function () {
	      function responsivizePickerPosition() {
	        // It's possible the portal props have been changed in response to window resizes
	        // So let's ensure we reset this back to the base state each time
	        this.setState({
	          dayPickerContainerStyles: {}
	        });
	
	        if (!this.isOpened()) {
	          return;
	        }
	
	        var _this$props5 = this.props,
	            openDirection = _this$props5.openDirection,
	            anchorDirection = _this$props5.anchorDirection,
	            horizontalMargin = _this$props5.horizontalMargin,
	            withPortal = _this$props5.withPortal,
	            withFullScreenPortal = _this$props5.withFullScreenPortal,
	            appendToBody = _this$props5.appendToBody;
	        var dayPickerContainerStyles = this.state.dayPickerContainerStyles;
	        var isAnchoredLeft = anchorDirection === _constants.ANCHOR_LEFT;
	
	        if (!withPortal && !withFullScreenPortal) {
	          var containerRect = this.dayPickerContainer.getBoundingClientRect();
	          var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
	          var containerEdge = isAnchoredLeft ? containerRect[_constants.ANCHOR_RIGHT] : containerRect[_constants.ANCHOR_LEFT];
	          this.setState({
	            dayPickerContainerStyles: _objectSpread({}, (0, _getResponsiveContainerStyles["default"])(anchorDirection, currentOffset, containerEdge, horizontalMargin), appendToBody && (0, _getDetachedContainerStyles["default"])(openDirection, anchorDirection, this.container))
	          });
	        }
	      }
	
	      return responsivizePickerPosition;
	    }()
	  }, {
	    key: "showKeyboardShortcutsPanel",
	    value: function () {
	      function showKeyboardShortcutsPanel() {
	        this.setState({
	          isDateRangePickerInputFocused: false,
	          isDayPickerFocused: true,
	          showKeyboardShortcuts: true
	        });
	      }
	
	      return showKeyboardShortcutsPanel;
	    }()
	  }, {
	    key: "maybeRenderDayPickerWithPortal",
	    value: function () {
	      function maybeRenderDayPickerWithPortal() {
	        var _this$props6 = this.props,
	            withPortal = _this$props6.withPortal,
	            withFullScreenPortal = _this$props6.withFullScreenPortal,
	            appendToBody = _this$props6.appendToBody;
	
	        if (!this.isOpened()) {
	          return null;
	        }
	
	        if (withPortal || withFullScreenPortal || appendToBody) {
	          return _react["default"].createElement(_reactPortal.Portal, null, this.renderDayPicker());
	        }
	
	        return this.renderDayPicker();
	      }
	
	      return maybeRenderDayPickerWithPortal;
	    }()
	  }, {
	    key: "renderDayPicker",
	    value: function () {
	      function renderDayPicker() {
	        var _this$props7 = this.props,
	            anchorDirection = _this$props7.anchorDirection,
	            openDirection = _this$props7.openDirection,
	            isDayBlocked = _this$props7.isDayBlocked,
	            isDayHighlighted = _this$props7.isDayHighlighted,
	            isOutsideRange = _this$props7.isOutsideRange,
	            numberOfMonths = _this$props7.numberOfMonths,
	            orientation = _this$props7.orientation,
	            monthFormat = _this$props7.monthFormat,
	            renderMonthText = _this$props7.renderMonthText,
	            navPrev = _this$props7.navPrev,
	            navNext = _this$props7.navNext,
	            onPrevMonthClick = _this$props7.onPrevMonthClick,
	            onNextMonthClick = _this$props7.onNextMonthClick,
	            onDatesChange = _this$props7.onDatesChange,
	            onFocusChange = _this$props7.onFocusChange,
	            withPortal = _this$props7.withPortal,
	            withFullScreenPortal = _this$props7.withFullScreenPortal,
	            daySize = _this$props7.daySize,
	            enableOutsideDays = _this$props7.enableOutsideDays,
	            focusedInput = _this$props7.focusedInput,
	            startDate = _this$props7.startDate,
	            startDateOffset = _this$props7.startDateOffset,
	            endDate = _this$props7.endDate,
	            endDateOffset = _this$props7.endDateOffset,
	            minimumNights = _this$props7.minimumNights,
	            keepOpenOnDateSelect = _this$props7.keepOpenOnDateSelect,
	            renderCalendarDay = _this$props7.renderCalendarDay,
	            renderDayContents = _this$props7.renderDayContents,
	            renderCalendarInfo = _this$props7.renderCalendarInfo,
	            renderMonthElement = _this$props7.renderMonthElement,
	            calendarInfoPosition = _this$props7.calendarInfoPosition,
	            firstDayOfWeek = _this$props7.firstDayOfWeek,
	            initialVisibleMonth = _this$props7.initialVisibleMonth,
	            hideKeyboardShortcutsPanel = _this$props7.hideKeyboardShortcutsPanel,
	            customCloseIcon = _this$props7.customCloseIcon,
	            onClose = _this$props7.onClose,
	            phrases = _this$props7.phrases,
	            dayAriaLabelFormat = _this$props7.dayAriaLabelFormat,
	            isRTL = _this$props7.isRTL,
	            weekDayFormat = _this$props7.weekDayFormat,
	            styles = _this$props7.styles,
	            verticalHeight = _this$props7.verticalHeight,
	            transitionDuration = _this$props7.transitionDuration,
	            verticalSpacing = _this$props7.verticalSpacing,
	            horizontalMonthPadding = _this$props7.horizontalMonthPadding,
	            small = _this$props7.small,
	            disabled = _this$props7.disabled,
	            reactDates = _this$props7.theme.reactDates;
	        var _this$state = this.state,
	            dayPickerContainerStyles = _this$state.dayPickerContainerStyles,
	            isDayPickerFocused = _this$state.isDayPickerFocused,
	            showKeyboardShortcuts = _this$state.showKeyboardShortcuts;
	        var onOutsideClick = !withFullScreenPortal && withPortal ? this.onOutsideClick : undefined;
	
	        var initialVisibleMonthThunk = initialVisibleMonth || function () {
	          return startDate || endDate || (0, _moment["default"])();
	        };
	
	        var closeIcon = customCloseIcon || _react["default"].createElement(_CloseButton["default"], (0, _reactWithStyles.css)(styles.DateRangePicker_closeButton_svg));
	
	        var inputHeight = (0, _getInputHeight["default"])(reactDates, small);
	        var withAnyPortal = withPortal || withFullScreenPortal;
	        return _react["default"].createElement("div", _extends({
	          // eslint-disable-line jsx-a11y/no-static-element-interactions
	          ref: this.setDayPickerContainerRef
	        }, (0, _reactWithStyles.css)(styles.DateRangePicker_picker, anchorDirection === _constants.ANCHOR_LEFT && styles.DateRangePicker_picker__directionLeft, anchorDirection === _constants.ANCHOR_RIGHT && styles.DateRangePicker_picker__directionRight, orientation === _constants.HORIZONTAL_ORIENTATION && styles.DateRangePicker_picker__horizontal, orientation === _constants.VERTICAL_ORIENTATION && styles.DateRangePicker_picker__vertical, !withAnyPortal && openDirection === _constants.OPEN_DOWN && {
	          top: inputHeight + verticalSpacing
	        }, !withAnyPortal && openDirection === _constants.OPEN_UP && {
	          bottom: inputHeight + verticalSpacing
	        }, withAnyPortal && styles.DateRangePicker_picker__portal, withFullScreenPortal && styles.DateRangePicker_picker__fullScreenPortal, isRTL && styles.DateRangePicker_picker__rtl, dayPickerContainerStyles), {
	          onClick: onOutsideClick
	        }), _react["default"].createElement(_DayPickerRangeController["default"], {
	          orientation: orientation,
	          enableOutsideDays: enableOutsideDays,
	          numberOfMonths: numberOfMonths,
	          onPrevMonthClick: onPrevMonthClick,
	          onNextMonthClick: onNextMonthClick,
	          onDatesChange: onDatesChange,
	          onFocusChange: onFocusChange,
	          onClose: onClose,
	          focusedInput: focusedInput,
	          startDate: startDate,
	          startDateOffset: startDateOffset,
	          endDate: endDate,
	          endDateOffset: endDateOffset,
	          monthFormat: monthFormat,
	          renderMonthText: renderMonthText,
	          withPortal: withAnyPortal,
	          daySize: daySize,
	          initialVisibleMonth: initialVisibleMonthThunk,
	          hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	          navPrev: navPrev,
	          navNext: navNext,
	          minimumNights: minimumNights,
	          isOutsideRange: isOutsideRange,
	          isDayHighlighted: isDayHighlighted,
	          isDayBlocked: isDayBlocked,
	          keepOpenOnDateSelect: keepOpenOnDateSelect,
	          renderCalendarDay: renderCalendarDay,
	          renderDayContents: renderDayContents,
	          renderCalendarInfo: renderCalendarInfo,
	          renderMonthElement: renderMonthElement,
	          calendarInfoPosition: calendarInfoPosition,
	          isFocused: isDayPickerFocused,
	          showKeyboardShortcuts: showKeyboardShortcuts,
	          onBlur: this.onDayPickerBlur,
	          phrases: phrases,
	          dayAriaLabelFormat: dayAriaLabelFormat,
	          isRTL: isRTL,
	          firstDayOfWeek: firstDayOfWeek,
	          weekDayFormat: weekDayFormat,
	          verticalHeight: verticalHeight,
	          transitionDuration: transitionDuration,
	          disabled: disabled,
	          horizontalMonthPadding: horizontalMonthPadding
	        }), withFullScreenPortal && _react["default"].createElement("button", _extends({}, (0, _reactWithStyles.css)(styles.DateRangePicker_closeButton), {
	          type: "button",
	          onClick: this.onOutsideClick,
	          "aria-label": phrases.closeDatePicker
	        }), closeIcon));
	      }
	
	      return renderDayPicker;
	    }()
	  }, {
	    key: "render",
	    value: function () {
	      function render() {
	        var _this$props8 = this.props,
	            startDate = _this$props8.startDate,
	            startDateId = _this$props8.startDateId,
	            startDatePlaceholderText = _this$props8.startDatePlaceholderText,
	            endDate = _this$props8.endDate,
	            endDateId = _this$props8.endDateId,
	            endDatePlaceholderText = _this$props8.endDatePlaceholderText,
	            focusedInput = _this$props8.focusedInput,
	            screenReaderInputMessage = _this$props8.screenReaderInputMessage,
	            showClearDates = _this$props8.showClearDates,
	            showDefaultInputIcon = _this$props8.showDefaultInputIcon,
	            inputIconPosition = _this$props8.inputIconPosition,
	            customInputIcon = _this$props8.customInputIcon,
	            customArrowIcon = _this$props8.customArrowIcon,
	            customCloseIcon = _this$props8.customCloseIcon,
	            disabled = _this$props8.disabled,
	            required = _this$props8.required,
	            readOnly = _this$props8.readOnly,
	            openDirection = _this$props8.openDirection,
	            phrases = _this$props8.phrases,
	            isOutsideRange = _this$props8.isOutsideRange,
	            minimumNights = _this$props8.minimumNights,
	            withPortal = _this$props8.withPortal,
	            withFullScreenPortal = _this$props8.withFullScreenPortal,
	            displayFormat = _this$props8.displayFormat,
	            reopenPickerOnClearDates = _this$props8.reopenPickerOnClearDates,
	            keepOpenOnDateSelect = _this$props8.keepOpenOnDateSelect,
	            onDatesChange = _this$props8.onDatesChange,
	            onClose = _this$props8.onClose,
	            isRTL = _this$props8.isRTL,
	            noBorder = _this$props8.noBorder,
	            block = _this$props8.block,
	            verticalSpacing = _this$props8.verticalSpacing,
	            small = _this$props8.small,
	            regular = _this$props8.regular,
	            styles = _this$props8.styles;
	        var isDateRangePickerInputFocused = this.state.isDateRangePickerInputFocused;
	        var enableOutsideClick = !withPortal && !withFullScreenPortal;
	        var hideFang = verticalSpacing < _constants.FANG_HEIGHT_PX;
	
	        var input = _react["default"].createElement(_DateRangePickerInputController["default"], {
	          startDate: startDate,
	          startDateId: startDateId,
	          startDatePlaceholderText: startDatePlaceholderText,
	          isStartDateFocused: focusedInput === _constants.START_DATE,
	          endDate: endDate,
	          endDateId: endDateId,
	          endDatePlaceholderText: endDatePlaceholderText,
	          isEndDateFocused: focusedInput === _constants.END_DATE,
	          displayFormat: displayFormat,
	          showClearDates: showClearDates,
	          showCaret: !withPortal && !withFullScreenPortal && !hideFang,
	          showDefaultInputIcon: showDefaultInputIcon,
	          inputIconPosition: inputIconPosition,
	          customInputIcon: customInputIcon,
	          customArrowIcon: customArrowIcon,
	          customCloseIcon: customCloseIcon,
	          disabled: disabled,
	          required: required,
	          readOnly: readOnly,
	          openDirection: openDirection,
	          reopenPickerOnClearDates: reopenPickerOnClearDates,
	          keepOpenOnDateSelect: keepOpenOnDateSelect,
	          isOutsideRange: isOutsideRange,
	          minimumNights: minimumNights,
	          withFullScreenPortal: withFullScreenPortal,
	          onDatesChange: onDatesChange,
	          onFocusChange: this.onDateRangePickerInputFocus,
	          onKeyDownArrowDown: this.onDayPickerFocus,
	          onKeyDownQuestionMark: this.showKeyboardShortcutsPanel,
	          onClose: onClose,
	          phrases: phrases,
	          screenReaderMessage: screenReaderInputMessage,
	          isFocused: isDateRangePickerInputFocused,
	          isRTL: isRTL,
	          noBorder: noBorder,
	          block: block,
	          small: small,
	          regular: regular,
	          verticalSpacing: verticalSpacing
	        }, this.maybeRenderDayPickerWithPortal());
	
	        return _react["default"].createElement("div", _extends({
	          ref: this.setContainerRef
	        }, (0, _reactWithStyles.css)(styles.DateRangePicker, block && styles.DateRangePicker__block)), enableOutsideClick && _react["default"].createElement(_reactOutsideClickHandler["default"], {
	          onOutsideClick: this.onOutsideClick
	        }, input), enableOutsideClick || input);
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DateRangePicker;
	}(_react["default"].PureComponent || _react["default"].Component);
	
	exports.PureDateRangePicker = DateRangePicker;
	DateRangePicker.propTypes =  false ? propTypes : {};
	DateRangePicker.defaultProps = defaultProps;
	
	var _default = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var _ref2$reactDates = _ref2.reactDates,
	      color = _ref2$reactDates.color,
	      zIndex = _ref2$reactDates.zIndex;
	  return {
	    DateRangePicker: {
	      position: 'relative',
	      display: 'inline-block'
	    },
	    DateRangePicker__block: {
	      display: 'block'
	    },
	    DateRangePicker_picker: {
	      zIndex: zIndex + 1,
	      backgroundColor: color.background,
	      position: 'absolute'
	    },
	    DateRangePicker_picker__rtl: {
	      direction: (0, _noflip["default"])('rtl')
	    },
	    DateRangePicker_picker__directionLeft: {
	      left: (0, _noflip["default"])(0)
	    },
	    DateRangePicker_picker__directionRight: {
	      right: (0, _noflip["default"])(0)
	    },
	    DateRangePicker_picker__portal: {
	      backgroundColor: 'rgba(0, 0, 0, 0.3)',
	      position: 'fixed',
	      top: 0,
	      left: (0, _noflip["default"])(0),
	      height: '100%',
	      width: '100%'
	    },
	    DateRangePicker_picker__fullScreenPortal: {
	      backgroundColor: color.background
	    },
	    DateRangePicker_closeButton: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	      cursor: 'pointer',
	      position: 'absolute',
	      top: 0,
	      right: (0, _noflip["default"])(0),
	      padding: 15,
	      zIndex: zIndex + 2,
	      ':hover': {
	        color: "darken(".concat(color.core.grayLighter, ", 10%)"),
	        textDecoration: 'none'
	      },
	      ':focus': {
	        color: "darken(".concat(color.core.grayLighter, ", 10%)"),
	        textDecoration: 'none'
	      }
	    },
	    DateRangePicker_closeButton_svg: {
	      height: 15,
	      width: 15,
	      fill: color.core.grayLighter
	    }
	  };
	}, {
	  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
	})(DateRangePicker);
	
	exports["default"] = _default;

/***/ },
/* 1811 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.BOTTOM_RIGHT = exports.TOP_RIGHT = exports.TOP_LEFT = void 0;
	
	var _reactAddonsShallowCompare = _interopRequireDefault(__webpack_require__(70));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _defaultPhrases = __webpack_require__(51);
	
	var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(60));
	
	var _KeyboardShortcutRow = _interopRequireDefault(__webpack_require__(1813));
	
	var _CloseButton = _interopRequireDefault(__webpack_require__(222));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () { function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); } return _getPrototypeOf; }(); return _getPrototypeOf(o); }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function () { function _setPrototypeOf(o, p) { o.__proto__ = p; return o; } return _setPrototypeOf; }(); return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var TOP_LEFT = 'top-left';
	exports.TOP_LEFT = TOP_LEFT;
	var TOP_RIGHT = 'top-right';
	exports.TOP_RIGHT = TOP_RIGHT;
	var BOTTOM_RIGHT = 'bottom-right';
	exports.BOTTOM_RIGHT = BOTTOM_RIGHT;
	var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
	  block: _propTypes["default"].bool,
	  // TODO: rename button location to be direction-agnostic
	  buttonLocation: _propTypes["default"].oneOf([TOP_LEFT, TOP_RIGHT, BOTTOM_RIGHT]),
	  showKeyboardShortcutsPanel: _propTypes["default"].bool,
	  openKeyboardShortcutsPanel: _propTypes["default"].func,
	  closeKeyboardShortcutsPanel: _propTypes["default"].func,
	  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.DayPickerKeyboardShortcutsPhrases))
	})) : {};
	var defaultProps = {
	  block: false,
	  buttonLocation: BOTTOM_RIGHT,
	  showKeyboardShortcutsPanel: false,
	  openKeyboardShortcutsPanel: function () {
	    function openKeyboardShortcutsPanel() {}
	
	    return openKeyboardShortcutsPanel;
	  }(),
	  closeKeyboardShortcutsPanel: function () {
	    function closeKeyboardShortcutsPanel() {}
	
	    return closeKeyboardShortcutsPanel;
	  }(),
	  phrases: _defaultPhrases.DayPickerKeyboardShortcutsPhrases
	};
	
	function getKeyboardShortcuts(phrases) {
	  return [{
	    unicode: '↵',
	    label: phrases.enterKey,
	    action: phrases.selectFocusedDate
	  }, {
	    unicode: '←/→',
	    label: phrases.leftArrowRightArrow,
	    action: phrases.moveFocusByOneDay
	  }, {
	    unicode: '↑/↓',
	    label: phrases.upArrowDownArrow,
	    action: phrases.moveFocusByOneWeek
	  }, {
	    unicode: 'PgUp/PgDn',
	    label: phrases.pageUpPageDown,
	    action: phrases.moveFocusByOneMonth
	  }, {
	    unicode: 'Home/End',
	    label: phrases.homeEnd,
	    action: phrases.moveFocustoStartAndEndOfWeek
	  }, {
	    unicode: 'Esc',
	    label: phrases.escape,
	    action: phrases.returnFocusToInput
	  }, {
	    unicode: '?',
	    label: phrases.questionMark,
	    action: phrases.openThisPanel
	  }];
	}
	
	var DayPickerKeyboardShortcuts =
	/*#__PURE__*/
	function (_ref) {
	  _inherits(DayPickerKeyboardShortcuts, _ref);
	
	  _createClass(DayPickerKeyboardShortcuts, [{
	    key: !_react["default"].PureComponent && "shouldComponentUpdate",
	    value: function () {
	      function value(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
	      }
	
	      return value;
	    }()
	  }]);
	
	  function DayPickerKeyboardShortcuts() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, DayPickerKeyboardShortcuts);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DayPickerKeyboardShortcuts)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    var phrases = _this.props.phrases;
	    _this.keyboardShortcuts = getKeyboardShortcuts(phrases);
	    _this.onShowKeyboardShortcutsButtonClick = _this.onShowKeyboardShortcutsButtonClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.setShowKeyboardShortcutsButtonRef = _this.setShowKeyboardShortcutsButtonRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.setHideKeyboardShortcutsButtonRef = _this.setHideKeyboardShortcutsButtonRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    return _this;
	  }
	
	  _createClass(DayPickerKeyboardShortcuts, [{
	    key: "componentWillReceiveProps",
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var phrases = this.props.phrases;
	
	        if (nextProps.phrases !== phrases) {
	          this.keyboardShortcuts = getKeyboardShortcuts(nextProps.phrases);
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: "componentDidUpdate",
	    value: function () {
	      function componentDidUpdate() {
	        this.handleFocus();
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: "onKeyDown",
	    value: function () {
	      function onKeyDown(e) {
	        e.stopPropagation();
	        var closeKeyboardShortcutsPanel = this.props.closeKeyboardShortcutsPanel; // Because the close button is the only focusable element inside of the panel, this
	        // amounts to a very basic focus trap. The user can exit the panel by "pressing" the
	        // close button or hitting escape
	
	        switch (e.key) {
	          case 'Escape':
	            closeKeyboardShortcutsPanel();
	            break;
	          // do nothing - this allows the up and down arrows continue their
	          // default behavior of scrolling the content of the Keyboard Shortcuts Panel
	          // which is needed when only a single month is shown for instance.
	
	          case 'ArrowUp':
	          case 'ArrowDown':
	            break;
	          // completely block the rest of the keys that have functionality outside of this panel
	
	          case 'Tab':
	          case 'Home':
	          case 'End':
	          case 'PageUp':
	          case 'PageDown':
	          case 'ArrowLeft':
	          case 'ArrowRight':
	            e.preventDefault();
	            break;
	
	          default:
	            break;
	        }
	      }
	
	      return onKeyDown;
	    }()
	  }, {
	    key: "onShowKeyboardShortcutsButtonClick",
	    value: function () {
	      function onShowKeyboardShortcutsButtonClick() {
	        var _this2 = this;
	
	        var openKeyboardShortcutsPanel = this.props.openKeyboardShortcutsPanel; // we want to return focus to this button after closing the keyboard shortcuts panel
	
	        openKeyboardShortcutsPanel(function () {
	          _this2.showKeyboardShortcutsButton.focus();
	        });
	      }
	
	      return onShowKeyboardShortcutsButtonClick;
	    }()
	  }, {
	    key: "setShowKeyboardShortcutsButtonRef",
	    value: function () {
	      function setShowKeyboardShortcutsButtonRef(ref) {
	        this.showKeyboardShortcutsButton = ref;
	      }
	
	      return setShowKeyboardShortcutsButtonRef;
	    }()
	  }, {
	    key: "setHideKeyboardShortcutsButtonRef",
	    value: function () {
	      function setHideKeyboardShortcutsButtonRef(ref) {
	        this.hideKeyboardShortcutsButton = ref;
	      }
	
	      return setHideKeyboardShortcutsButtonRef;
	    }()
	  }, {
	    key: "handleFocus",
	    value: function () {
	      function handleFocus() {
	        if (this.hideKeyboardShortcutsButton) {
	          // automatically move focus into the dialog by moving
	          // to the only interactive element, the hide button
	          this.hideKeyboardShortcutsButton.focus();
	        }
	      }
	
	      return handleFocus;
	    }()
	  }, {
	    key: "render",
	    value: function () {
	      function render() {
	        var _this$props = this.props,
	            block = _this$props.block,
	            buttonLocation = _this$props.buttonLocation,
	            showKeyboardShortcutsPanel = _this$props.showKeyboardShortcutsPanel,
	            closeKeyboardShortcutsPanel = _this$props.closeKeyboardShortcutsPanel,
	            styles = _this$props.styles,
	            phrases = _this$props.phrases;
	        var toggleButtonText = showKeyboardShortcutsPanel ? phrases.hideKeyboardShortcutsPanel : phrases.showKeyboardShortcutsPanel;
	        var bottomRight = buttonLocation === BOTTOM_RIGHT;
	        var topRight = buttonLocation === TOP_RIGHT;
	        var topLeft = buttonLocation === TOP_LEFT;
	        return _react["default"].createElement("div", null, _react["default"].createElement("button", _extends({
	          ref: this.setShowKeyboardShortcutsButtonRef
	        }, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_buttonReset, styles.DayPickerKeyboardShortcuts_show, bottomRight && styles.DayPickerKeyboardShortcuts_show__bottomRight, topRight && styles.DayPickerKeyboardShortcuts_show__topRight, topLeft && styles.DayPickerKeyboardShortcuts_show__topLeft), {
	          type: "button",
	          "aria-label": toggleButtonText,
	          onClick: this.onShowKeyboardShortcutsButtonClick,
	          onMouseUp: function () {
	            function onMouseUp(e) {
	              e.currentTarget.blur();
	            }
	
	            return onMouseUp;
	          }()
	        }), _react["default"].createElement("span", (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_showSpan, bottomRight && styles.DayPickerKeyboardShortcuts_showSpan__bottomRight, topRight && styles.DayPickerKeyboardShortcuts_showSpan__topRight, topLeft && styles.DayPickerKeyboardShortcuts_showSpan__topLeft), "?")), showKeyboardShortcutsPanel && _react["default"].createElement("div", _extends({}, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_panel), {
	          role: "dialog",
	          "aria-labelledby": "DayPickerKeyboardShortcuts_title",
	          "aria-describedby": "DayPickerKeyboardShortcuts_description"
	        }), _react["default"].createElement("div", _extends({}, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_title), {
	          id: "DayPickerKeyboardShortcuts_title"
	        }), phrases.keyboardShortcuts), _react["default"].createElement("button", _extends({
	          ref: this.setHideKeyboardShortcutsButtonRef
	        }, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_buttonReset, styles.DayPickerKeyboardShortcuts_close), {
	          type: "button",
	          tabIndex: "0",
	          "aria-label": phrases.hideKeyboardShortcutsPanel,
	          onClick: closeKeyboardShortcutsPanel,
	          onKeyDown: this.onKeyDown
	        }), _react["default"].createElement(_CloseButton["default"], (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_closeSvg))), _react["default"].createElement("ul", _extends({}, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_list), {
	          id: "DayPickerKeyboardShortcuts_description"
	        }), this.keyboardShortcuts.map(function (_ref2) {
	          var unicode = _ref2.unicode,
	              label = _ref2.label,
	              action = _ref2.action;
	          return _react["default"].createElement(_KeyboardShortcutRow["default"], {
	            key: label,
	            unicode: unicode,
	            label: label,
	            action: action,
	            block: block
	          });
	        }))));
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DayPickerKeyboardShortcuts;
	}(_react["default"].PureComponent || _react["default"].Component);
	
	DayPickerKeyboardShortcuts.propTypes =  false ? propTypes : {};
	DayPickerKeyboardShortcuts.defaultProps = defaultProps;
	
	var _default = (0, _reactWithStyles.withStyles)(function (_ref3) {
	  var _ref3$reactDates = _ref3.reactDates,
	      color = _ref3$reactDates.color,
	      font = _ref3$reactDates.font,
	      zIndex = _ref3$reactDates.zIndex;
	  return {
	    DayPickerKeyboardShortcuts_buttonReset: {
	      background: 'none',
	      border: 0,
	      borderRadius: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	      padding: 0,
	      cursor: 'pointer',
	      fontSize: font.size,
	      ':active': {
	        outline: 'none'
	      }
	    },
	    DayPickerKeyboardShortcuts_show: {
	      width: 33,
	      height: 26,
	      position: 'absolute',
	      zIndex: zIndex + 2,
	      '::before': {
	        content: '""',
	        display: 'block',
	        position: 'absolute'
	      }
	    },
	    DayPickerKeyboardShortcuts_show__bottomRight: {
	      bottom: 0,
	      right: 0,
	      '::before': {
	        borderTop: '26px solid transparent',
	        borderRight: "33px solid ".concat(color.core.primary),
	        bottom: 0,
	        right: 0
	      },
	      ':hover::before': {
	        borderRight: "33px solid ".concat(color.core.primary_dark)
	      }
	    },
	    DayPickerKeyboardShortcuts_show__topRight: {
	      top: 0,
	      right: 0,
	      '::before': {
	        borderBottom: '26px solid transparent',
	        borderRight: "33px solid ".concat(color.core.primary),
	        top: 0,
	        right: 0
	      },
	      ':hover::before': {
	        borderRight: "33px solid ".concat(color.core.primary_dark)
	      }
	    },
	    DayPickerKeyboardShortcuts_show__topLeft: {
	      top: 0,
	      left: 0,
	      '::before': {
	        borderBottom: '26px solid transparent',
	        borderLeft: "33px solid ".concat(color.core.primary),
	        top: 0,
	        left: 0
	      },
	      ':hover::before': {
	        borderLeft: "33px solid ".concat(color.core.primary_dark)
	      }
	    },
	    DayPickerKeyboardShortcuts_showSpan: {
	      color: color.core.white,
	      position: 'absolute'
	    },
	    DayPickerKeyboardShortcuts_showSpan__bottomRight: {
	      bottom: 0,
	      right: 5
	    },
	    DayPickerKeyboardShortcuts_showSpan__topRight: {
	      top: 1,
	      right: 5
	    },
	    DayPickerKeyboardShortcuts_showSpan__topLeft: {
	      top: 1,
	      left: 5
	    },
	    DayPickerKeyboardShortcuts_panel: {
	      overflow: 'auto',
	      background: color.background,
	      border: "1px solid ".concat(color.core.border),
	      borderRadius: 2,
	      position: 'absolute',
	      top: 0,
	      bottom: 0,
	      right: 0,
	      left: 0,
	      zIndex: zIndex + 2,
	      padding: 22,
	      margin: 33,
	      textAlign: 'left' // TODO: investigate use of text-align throughout the library
	
	    },
	    DayPickerKeyboardShortcuts_title: {
	      fontSize: 16,
	      fontWeight: 'bold',
	      margin: 0
	    },
	    DayPickerKeyboardShortcuts_list: {
	      listStyle: 'none',
	      padding: 0,
	      fontSize: font.size
	    },
	    DayPickerKeyboardShortcuts_close: {
	      position: 'absolute',
	      right: 22,
	      top: 22,
	      zIndex: zIndex + 2,
	      ':active': {
	        outline: 'none'
	      }
	    },
	    DayPickerKeyboardShortcuts_closeSvg: {
	      height: 15,
	      width: 15,
	      fill: color.core.grayLighter,
	      ':hover': {
	        fill: color.core.grayLight
	      },
	      ':focus': {
	        fill: color.core.grayLight
	      }
	    }
	  };
	}, {
	  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
	})(DayPickerKeyboardShortcuts);
	
	exports["default"] = _default;

/***/ },
/* 1812 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _defaultPhrases = __webpack_require__(51);
	
	var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(60));
	
	var _noflip = _interopRequireDefault(__webpack_require__(127));
	
	var _LeftArrow = _interopRequireDefault(__webpack_require__(859));
	
	var _RightArrow = _interopRequireDefault(__webpack_require__(860));
	
	var _ChevronUp = _interopRequireDefault(__webpack_require__(1808));
	
	var _ChevronDown = _interopRequireDefault(__webpack_require__(1807));
	
	var _ScrollableOrientationShape = _interopRequireDefault(__webpack_require__(175));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
	  disablePrev: _propTypes["default"].bool,
	  disableNext: _propTypes["default"].bool,
	  navPrev: _propTypes["default"].node,
	  navNext: _propTypes["default"].node,
	  orientation: _ScrollableOrientationShape["default"],
	  onPrevMonthClick: _propTypes["default"].func,
	  onNextMonthClick: _propTypes["default"].func,
	  // internationalization
	  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.DayPickerNavigationPhrases)),
	  isRTL: _propTypes["default"].bool
	})) : {};
	var defaultProps = {
	  disablePrev: false,
	  disableNext: false,
	  navPrev: null,
	  navNext: null,
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	  // internationalization
	  phrases: _defaultPhrases.DayPickerNavigationPhrases,
	  isRTL: false
	};
	
	function DayPickerNavigation(_ref) {
	  var disablePrev = _ref.disablePrev,
	      disableNext = _ref.disableNext,
	      navPrev = _ref.navPrev,
	      navNext = _ref.navNext,
	      onPrevMonthClick = _ref.onPrevMonthClick,
	      onNextMonthClick = _ref.onNextMonthClick,
	      orientation = _ref.orientation,
	      phrases = _ref.phrases,
	      isRTL = _ref.isRTL,
	      styles = _ref.styles;
	  var isHorizontal = orientation === _constants.HORIZONTAL_ORIENTATION;
	  var isVertical = orientation !== _constants.HORIZONTAL_ORIENTATION;
	  var isVerticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
	  var navPrevIcon = navPrev;
	  var navNextIcon = navNext;
	  var isDefaultNavPrev = false;
	  var isDefaultNavNext = false;
	
	  if (!navPrevIcon) {
	    isDefaultNavPrev = true;
	    var Icon = isVertical ? _ChevronUp["default"] : _LeftArrow["default"];
	
	    if (isRTL && !isVertical) {
	      Icon = _RightArrow["default"];
	    }
	
	    navPrevIcon = _react["default"].createElement(Icon, (0, _reactWithStyles.css)(isHorizontal && styles.DayPickerNavigation_svg__horizontal, isVertical && styles.DayPickerNavigation_svg__vertical, disablePrev && styles.DayPickerNavigation_svg__disabled));
	  }
	
	  if (!navNextIcon) {
	    isDefaultNavNext = true;
	
	    var _Icon = isVertical ? _ChevronDown["default"] : _RightArrow["default"];
	
	    if (isRTL && !isVertical) {
	      _Icon = _LeftArrow["default"];
	    }
	
	    navNextIcon = _react["default"].createElement(_Icon, (0, _reactWithStyles.css)(isHorizontal && styles.DayPickerNavigation_svg__horizontal, isVertical && styles.DayPickerNavigation_svg__vertical, disableNext && styles.DayPickerNavigation_svg__disabled));
	  }
	
	  var isDefaultNav = isVerticalScrollable ? isDefaultNavNext : isDefaultNavNext || isDefaultNavPrev;
	  return _react["default"].createElement("div", _reactWithStyles.css.apply(void 0, [styles.DayPickerNavigation, isHorizontal && styles.DayPickerNavigation__horizontal].concat(_toConsumableArray(isVertical ? [styles.DayPickerNavigation__vertical, isDefaultNav && styles.DayPickerNavigation__verticalDefault] : []), _toConsumableArray(isVerticalScrollable ? [styles.DayPickerNavigation__verticalScrollable, isDefaultNav && styles.DayPickerNavigation__verticalScrollableDefault] : []))), !isVerticalScrollable && _react["default"].createElement("div", _extends({
	    role: "button",
	    tabIndex: "0"
	  }, _reactWithStyles.css.apply(void 0, [styles.DayPickerNavigation_button, isDefaultNavPrev && styles.DayPickerNavigation_button__default, disablePrev && styles.DayPickerNavigation_button__disabled].concat(_toConsumableArray(isHorizontal ? [styles.DayPickerNavigation_button__horizontal].concat(_toConsumableArray(isDefaultNavPrev ? [styles.DayPickerNavigation_button__horizontalDefault, !isRTL && styles.DayPickerNavigation_leftButton__horizontalDefault, isRTL && styles.DayPickerNavigation_rightButton__horizontalDefault] : [])) : []), _toConsumableArray(isVertical ? [styles.DayPickerNavigation_button__vertical].concat(_toConsumableArray(isDefaultNavPrev ? [styles.DayPickerNavigation_button__verticalDefault, styles.DayPickerNavigation_prevButton__verticalDefault] : [])) : []))), {
	    "aria-disabled": disablePrev ? true : undefined,
	    "aria-label": phrases.jumpToPrevMonth,
	    onClick: disablePrev ? undefined : onPrevMonthClick,
	    onKeyUp: disablePrev ? undefined : function (e) {
	      var key = e.key;
	      if (key === 'Enter' || key === ' ') onPrevMonthClick(e);
	    },
	    onMouseUp: disablePrev ? undefined : function (e) {
	      e.currentTarget.blur();
	    }
	  }), navPrevIcon), _react["default"].createElement("div", _extends({
	    role: "button",
	    tabIndex: "0"
	  }, _reactWithStyles.css.apply(void 0, [styles.DayPickerNavigation_button, isDefaultNavNext && styles.DayPickerNavigation_button__default, disableNext && styles.DayPickerNavigation_button__disabled].concat(_toConsumableArray(isHorizontal ? [styles.DayPickerNavigation_button__horizontal].concat(_toConsumableArray(isDefaultNavNext ? [styles.DayPickerNavigation_button__horizontalDefault, isRTL && styles.DayPickerNavigation_leftButton__horizontalDefault, !isRTL && styles.DayPickerNavigation_rightButton__horizontalDefault] : [])) : []), _toConsumableArray(isVertical ? [styles.DayPickerNavigation_button__vertical, styles.DayPickerNavigation_nextButton__vertical].concat(_toConsumableArray(isDefaultNavNext ? [styles.DayPickerNavigation_button__verticalDefault, styles.DayPickerNavigation_nextButton__verticalDefault, isVerticalScrollable && styles.DayPickerNavigation_nextButton__verticalScrollableDefault] : [])) : []))), {
	    "aria-disabled": disableNext ? true : undefined,
	    "aria-label": phrases.jumpToNextMonth,
	    onClick: disableNext ? undefined : onNextMonthClick,
	    onKeyUp: disableNext ? undefined : function (e) {
	      var key = e.key;
	      if (key === 'Enter' || key === ' ') onNextMonthClick(e);
	    },
	    onMouseUp: disableNext ? undefined : function (e) {
	      e.currentTarget.blur();
	    }
	  }), navNextIcon));
	}
	
	DayPickerNavigation.propTypes =  false ? propTypes : {};
	DayPickerNavigation.defaultProps = defaultProps;
	
	var _default = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var _ref2$reactDates = _ref2.reactDates,
	      color = _ref2$reactDates.color,
	      zIndex = _ref2$reactDates.zIndex;
	  return {
	    DayPickerNavigation: {
	      position: 'relative',
	      zIndex: zIndex + 2
	    },
	    DayPickerNavigation__horizontal: {
	      height: 0
	    },
	    DayPickerNavigation__vertical: {},
	    DayPickerNavigation__verticalScrollable: {},
	    DayPickerNavigation__verticalDefault: {
	      position: 'absolute',
	      width: '100%',
	      height: 52,
	      bottom: 0,
	      left: (0, _noflip["default"])(0)
	    },
	    DayPickerNavigation__verticalScrollableDefault: {
	      position: 'relative'
	    },
	    DayPickerNavigation_button: {
	      cursor: 'pointer',
	      userSelect: 'none',
	      border: 0,
	      padding: 0,
	      margin: 0
	    },
	    DayPickerNavigation_button__default: {
	      border: "1px solid ".concat(color.core.borderLight),
	      backgroundColor: color.background,
	      color: color.placeholderText,
	      ':focus': {
	        border: "1px solid ".concat(color.core.borderMedium)
	      },
	      ':hover': {
	        border: "1px solid ".concat(color.core.borderMedium)
	      },
	      ':active': {
	        background: color.backgroundDark
	      }
	    },
	    DayPickerNavigation_button__disabled: {
	      cursor: 'default',
	      border: "1px solid ".concat(color.disabled),
	      ':focus': {
	        border: "1px solid ".concat(color.disabled)
	      },
	      ':hover': {
	        border: "1px solid ".concat(color.disabled)
	      },
	      ':active': {
	        background: 'none'
	      }
	    },
	    DayPickerNavigation_button__horizontal: {},
	    DayPickerNavigation_button__horizontalDefault: {
	      position: 'absolute',
	      top: 18,
	      lineHeight: 0.78,
	      borderRadius: 3,
	      padding: '6px 9px'
	    },
	    DayPickerNavigation_leftButton__horizontalDefault: {
	      left: (0, _noflip["default"])(22)
	    },
	    DayPickerNavigation_rightButton__horizontalDefault: {
	      right: (0, _noflip["default"])(22)
	    },
	    DayPickerNavigation_button__vertical: {},
	    DayPickerNavigation_button__verticalDefault: {
	      padding: 5,
	      background: color.background,
	      boxShadow: (0, _noflip["default"])('0 0 5px 2px rgba(0, 0, 0, 0.1)'),
	      position: 'relative',
	      display: 'inline-block',
	      textAlign: 'center',
	      height: '100%',
	      width: '50%'
	    },
	    DayPickerNavigation_prevButton__verticalDefault: {},
	    DayPickerNavigation_nextButton__verticalDefault: {
	      borderLeft: (0, _noflip["default"])(0)
	    },
	    DayPickerNavigation_nextButton__verticalScrollableDefault: {
	      width: '100%'
	    },
	    DayPickerNavigation_svg__horizontal: {
	      height: 19,
	      width: 19,
	      fill: color.core.grayLight,
	      display: 'block'
	    },
	    DayPickerNavigation_svg__vertical: {
	      height: 42,
	      width: 42,
	      fill: color.text
	    },
	    DayPickerNavigation_svg__disabled: {
	      fill: color.disabled
	    }
	  };
	}, {
	  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
	})(DayPickerNavigation);
	
	exports["default"] = _default;

/***/ },
/* 1813 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _reactWithStyles = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
	  unicode: _propTypes["default"].string.isRequired,
	  label: _propTypes["default"].string.isRequired,
	  action: _propTypes["default"].string.isRequired,
	  block: _propTypes["default"].bool
	})) : {};
	var defaultProps = {
	  block: false
	};
	
	function KeyboardShortcutRow(_ref) {
	  var unicode = _ref.unicode,
	      label = _ref.label,
	      action = _ref.action,
	      block = _ref.block,
	      styles = _ref.styles;
	  return _react["default"].createElement("li", (0, _reactWithStyles.css)(styles.KeyboardShortcutRow, block && styles.KeyboardShortcutRow__block), _react["default"].createElement("div", (0, _reactWithStyles.css)(styles.KeyboardShortcutRow_keyContainer, block && styles.KeyboardShortcutRow_keyContainer__block), _react["default"].createElement("span", _extends({}, (0, _reactWithStyles.css)(styles.KeyboardShortcutRow_key), {
	    role: "img",
	    "aria-label": "".concat(label, ",") // add comma so screen readers will pause before reading action
	
	  }), unicode)), _react["default"].createElement("div", (0, _reactWithStyles.css)(styles.KeyboardShortcutRow_action), action));
	}
	
	KeyboardShortcutRow.propTypes =  false ? propTypes : {};
	KeyboardShortcutRow.defaultProps = defaultProps;
	
	var _default = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var color = _ref2.reactDates.color;
	  return {
	    KeyboardShortcutRow: {
	      listStyle: 'none',
	      margin: '6px 0'
	    },
	    KeyboardShortcutRow__block: {
	      marginBottom: 16
	    },
	    KeyboardShortcutRow_keyContainer: {
	      display: 'inline-block',
	      whiteSpace: 'nowrap',
	      textAlign: 'right',
	      // is not handled by isRTL
	      marginRight: 6 // is not handled by isRTL
	
	    },
	    KeyboardShortcutRow_keyContainer__block: {
	      textAlign: 'left',
	      // is not handled by isRTL
	      display: 'inline'
	    },
	    KeyboardShortcutRow_key: {
	      fontFamily: 'monospace',
	      fontSize: 12,
	      textTransform: 'uppercase',
	      background: color.core.grayLightest,
	      padding: '2px 6px'
	    },
	    KeyboardShortcutRow_action: {
	      display: 'inline',
	      wordBreak: 'break-word',
	      marginLeft: 8 // is not handled by isRTL
	
	    }
	  };
	}, {
	  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
	})(KeyboardShortcutRow);
	
	exports["default"] = _default;

/***/ },
/* 1814 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.PureSingleDatePicker = void 0;
	
	var _reactAddonsShallowCompare = _interopRequireDefault(__webpack_require__(70));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _reactPortal = __webpack_require__(909);
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _consolidatedEvents = __webpack_require__(249);
	
	var _isTouchDevice = _interopRequireDefault(__webpack_require__(171));
	
	var _reactOutsideClickHandler = _interopRequireDefault(__webpack_require__(457));
	
	var _SingleDatePickerShape = _interopRequireDefault(__webpack_require__(866));
	
	var _defaultPhrases = __webpack_require__(51);
	
	var _getResponsiveContainerStyles = _interopRequireDefault(__webpack_require__(873));
	
	var _getDetachedContainerStyles = _interopRequireDefault(__webpack_require__(872));
	
	var _getInputHeight = _interopRequireDefault(__webpack_require__(435));
	
	var _isInclusivelyAfterDay = _interopRequireDefault(__webpack_require__(176));
	
	var _disableScroll2 = _interopRequireDefault(__webpack_require__(869));
	
	var _noflip = _interopRequireDefault(__webpack_require__(127));
	
	var _SingleDatePickerInputController = _interopRequireDefault(__webpack_require__(1815));
	
	var _DayPickerSingleDateController = _interopRequireDefault(__webpack_require__(858));
	
	var _CloseButton = _interopRequireDefault(__webpack_require__(222));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () { function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); } return _getPrototypeOf; }(); return _getPrototypeOf(o); }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function () { function _setPrototypeOf(o, p) { o.__proto__ = p; return o; } return _setPrototypeOf; }(); return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, _SingleDatePickerShape["default"])) : {};
	var defaultProps = {
	  // required props for a functional interactive SingleDatePicker
	  date: null,
	  focused: false,
	  // input related props
	  id: 'date',
	  placeholder: 'Date',
	  disabled: false,
	  required: false,
	  readOnly: false,
	  screenReaderInputMessage: '',
	  showClearDate: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  customInputIcon: null,
	  customCloseIcon: null,
	  noBorder: false,
	  block: false,
	  small: false,
	  regular: false,
	  verticalSpacing: _constants.DEFAULT_VERTICAL_SPACING,
	  keepFocusOnInput: false,
	  // calendar presentation and interaction related props
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  anchorDirection: _constants.ANCHOR_LEFT,
	  openDirection: _constants.OPEN_DOWN,
	  horizontalMargin: 0,
	  withPortal: false,
	  withFullScreenPortal: false,
	  appendToBody: false,
	  disableScroll: false,
	  initialVisibleMonth: null,
	  firstDayOfWeek: null,
	  numberOfMonths: 2,
	  keepOpenOnDateSelect: false,
	  reopenPickerOnClearDate: false,
	  renderCalendarInfo: null,
	  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
	  hideKeyboardShortcutsPanel: false,
	  daySize: _constants.DAY_SIZE,
	  isRTL: false,
	  verticalHeight: null,
	  transitionDuration: undefined,
	  horizontalMonthPadding: 13,
	  // navigation related props
	  navPrev: null,
	  navNext: null,
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	  // month presentation and interaction related props
	  renderMonthText: null,
	  // day presentation and interaction related props
	  renderCalendarDay: undefined,
	  renderDayContents: null,
	  renderMonthElement: null,
	  enableOutsideDays: false,
	  isDayBlocked: function () {
	    function isDayBlocked() {
	      return false;
	    }
	
	    return isDayBlocked;
	  }(),
	  isOutsideRange: function () {
	    function isOutsideRange(day) {
	      return !(0, _isInclusivelyAfterDay["default"])(day, (0, _moment["default"])());
	    }
	
	    return isOutsideRange;
	  }(),
	  isDayHighlighted: function () {
	    function isDayHighlighted() {}
	
	    return isDayHighlighted;
	  }(),
	  // internationalization props
	  displayFormat: function () {
	    function displayFormat() {
	      return _moment["default"].localeData().longDateFormat('L');
	    }
	
	    return displayFormat;
	  }(),
	  monthFormat: 'MMMM YYYY',
	  weekDayFormat: 'dd',
	  phrases: _defaultPhrases.SingleDatePickerPhrases,
	  dayAriaLabelFormat: undefined
	};
	
	var SingleDatePicker =
	/*#__PURE__*/
	function (_ref) {
	  _inherits(SingleDatePicker, _ref);
	
	  _createClass(SingleDatePicker, [{
	    key: !_react["default"].PureComponent && "shouldComponentUpdate",
	    value: function () {
	      function value(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
	      }
	
	      return value;
	    }()
	  }]);
	
	  function SingleDatePicker(props) {
	    var _this;
	
	    _classCallCheck(this, SingleDatePicker);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(SingleDatePicker).call(this, props));
	    _this.isTouchDevice = false;
	    _this.state = {
	      dayPickerContainerStyles: {},
	      isDayPickerFocused: false,
	      isInputFocused: false,
	      showKeyboardShortcuts: false
	    };
	    _this.onFocusOut = _this.onFocusOut.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onOutsideClick = _this.onOutsideClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onInputFocus = _this.onInputFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onDayPickerFocus = _this.onDayPickerFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onDayPickerBlur = _this.onDayPickerBlur.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.showKeyboardShortcutsPanel = _this.showKeyboardShortcutsPanel.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.disableScroll = _this.disableScroll.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.setDayPickerContainerRef = _this.setDayPickerContainerRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.setContainerRef = _this.setContainerRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    return _this;
	  }
	  /* istanbul ignore next */
	
	
	  _createClass(SingleDatePicker, [{
	    key: "componentDidMount",
	    value: function () {
	      function componentDidMount() {
	        this.removeResizeEventListener = (0, _consolidatedEvents.addEventListener)(window, 'resize', this.responsivizePickerPosition, {
	          passive: true
	        });
	        this.responsivizePickerPosition();
	        this.disableScroll();
	        var focused = this.props.focused;
	
	        if (focused) {
	          this.setState({
	            isInputFocused: true
	          });
	        }
	
	        this.isTouchDevice = (0, _isTouchDevice["default"])();
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "componentDidUpdate",
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var focused = this.props.focused;
	
	        if (!prevProps.focused && focused) {
	          this.responsivizePickerPosition();
	          this.disableScroll();
	        } else if (prevProps.focused && !focused) {
	          if (this.enableScroll) this.enableScroll();
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	    /* istanbul ignore next */
	
	  }, {
	    key: "componentWillUnmount",
	    value: function () {
	      function componentWillUnmount() {
	        if (this.removeResizeEventListener) this.removeResizeEventListener();
	        if (this.removeFocusOutEventListener) this.removeFocusOutEventListener();
	        if (this.enableScroll) this.enableScroll();
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: "onOutsideClick",
	    value: function () {
	      function onOutsideClick(event) {
	        var _this$props = this.props,
	            focused = _this$props.focused,
	            onFocusChange = _this$props.onFocusChange,
	            onClose = _this$props.onClose,
	            startDate = _this$props.startDate,
	            endDate = _this$props.endDate,
	            appendToBody = _this$props.appendToBody;
	        if (!focused) return;
	        if (appendToBody && this.dayPickerContainer.contains(event.target)) return;
	        this.setState({
	          isInputFocused: false,
	          isDayPickerFocused: false,
	          showKeyboardShortcuts: false
	        });
	        onFocusChange({
	          focused: false
	        });
	        onClose({
	          startDate: startDate,
	          endDate: endDate
	        });
	      }
	
	      return onOutsideClick;
	    }()
	  }, {
	    key: "onInputFocus",
	    value: function () {
	      function onInputFocus(_ref2) {
	        var focused = _ref2.focused;
	        var _this$props2 = this.props,
	            onFocusChange = _this$props2.onFocusChange,
	            readOnly = _this$props2.readOnly,
	            withPortal = _this$props2.withPortal,
	            withFullScreenPortal = _this$props2.withFullScreenPortal,
	            keepFocusOnInput = _this$props2.keepFocusOnInput;
	
	        if (focused) {
	          var withAnyPortal = withPortal || withFullScreenPortal;
	          var moveFocusToDayPicker = withAnyPortal || readOnly && !keepFocusOnInput || this.isTouchDevice && !keepFocusOnInput;
	
	          if (moveFocusToDayPicker) {
	            this.onDayPickerFocus();
	          } else {
	            this.onDayPickerBlur();
	          }
	        }
	
	        onFocusChange({
	          focused: focused
	        });
	      }
	
	      return onInputFocus;
	    }()
	  }, {
	    key: "onDayPickerFocus",
	    value: function () {
	      function onDayPickerFocus() {
	        this.setState({
	          isInputFocused: false,
	          isDayPickerFocused: true,
	          showKeyboardShortcuts: false
	        });
	      }
	
	      return onDayPickerFocus;
	    }()
	  }, {
	    key: "onDayPickerBlur",
	    value: function () {
	      function onDayPickerBlur() {
	        this.setState({
	          isInputFocused: true,
	          isDayPickerFocused: false,
	          showKeyboardShortcuts: false
	        });
	      }
	
	      return onDayPickerBlur;
	    }()
	  }, {
	    key: "onFocusOut",
	    value: function () {
	      function onFocusOut(e) {
	        var onFocusChange = this.props.onFocusChange;
	        if (this.container.contains(e.relatedTarget || e.target)) return;
	        onFocusChange({
	          focused: false
	        });
	      }
	
	      return onFocusOut;
	    }()
	  }, {
	    key: "setDayPickerContainerRef",
	    value: function () {
	      function setDayPickerContainerRef(ref) {
	        this.dayPickerContainer = ref;
	      }
	
	      return setDayPickerContainerRef;
	    }()
	  }, {
	    key: "setContainerRef",
	    value: function () {
	      function setContainerRef(ref) {
	        if (ref === this.container) return;
	        this.removeEventListeners();
	        this.container = ref;
	        if (!ref) return;
	        this.addEventListeners();
	      }
	
	      return setContainerRef;
	    }()
	  }, {
	    key: "addEventListeners",
	    value: function () {
	      function addEventListeners() {
	        // We manually set event because React has not implemented onFocusIn/onFocusOut.
	        // Keep an eye on https://github.com/facebook/react/issues/6410 for updates
	        // We use "blur w/ useCapture param" vs "onfocusout" for FF browser support
	        this.removeFocusOutEventListener = (0, _consolidatedEvents.addEventListener)(this.container, 'focusout', this.onFocusOut);
	      }
	
	      return addEventListeners;
	    }()
	  }, {
	    key: "removeEventListeners",
	    value: function () {
	      function removeEventListeners() {
	        if (this.removeFocusOutEventListener) this.removeFocusOutEventListener();
	      }
	
	      return removeEventListeners;
	    }()
	  }, {
	    key: "disableScroll",
	    value: function () {
	      function disableScroll() {
	        var _this$props3 = this.props,
	            appendToBody = _this$props3.appendToBody,
	            propDisableScroll = _this$props3.disableScroll,
	            focused = _this$props3.focused;
	        if (!appendToBody && !propDisableScroll) return;
	        if (!focused) return; // Disable scroll for every ancestor of this <SingleDatePicker> up to the
	        // document level. This ensures the input and the picker never move. Other
	        // sibling elements or the picker itself can scroll.
	
	        this.enableScroll = (0, _disableScroll2["default"])(this.container);
	      }
	
	      return disableScroll;
	    }()
	    /* istanbul ignore next */
	
	  }, {
	    key: "responsivizePickerPosition",
	    value: function () {
	      function responsivizePickerPosition() {
	        // It's possible the portal props have been changed in response to window resizes
	        // So let's ensure we reset this back to the base state each time
	        this.setState({
	          dayPickerContainerStyles: {}
	        });
	        var _this$props4 = this.props,
	            openDirection = _this$props4.openDirection,
	            anchorDirection = _this$props4.anchorDirection,
	            horizontalMargin = _this$props4.horizontalMargin,
	            withPortal = _this$props4.withPortal,
	            withFullScreenPortal = _this$props4.withFullScreenPortal,
	            appendToBody = _this$props4.appendToBody,
	            focused = _this$props4.focused;
	        var dayPickerContainerStyles = this.state.dayPickerContainerStyles;
	
	        if (!focused) {
	          return;
	        }
	
	        var isAnchoredLeft = anchorDirection === _constants.ANCHOR_LEFT;
	
	        if (!withPortal && !withFullScreenPortal) {
	          var containerRect = this.dayPickerContainer.getBoundingClientRect();
	          var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
	          var containerEdge = isAnchoredLeft ? containerRect[_constants.ANCHOR_RIGHT] : containerRect[_constants.ANCHOR_LEFT];
	          this.setState({
	            dayPickerContainerStyles: _objectSpread({}, (0, _getResponsiveContainerStyles["default"])(anchorDirection, currentOffset, containerEdge, horizontalMargin), appendToBody && (0, _getDetachedContainerStyles["default"])(openDirection, anchorDirection, this.container))
	          });
	        }
	      }
	
	      return responsivizePickerPosition;
	    }()
	  }, {
	    key: "showKeyboardShortcutsPanel",
	    value: function () {
	      function showKeyboardShortcutsPanel() {
	        this.setState({
	          isInputFocused: false,
	          isDayPickerFocused: true,
	          showKeyboardShortcuts: true
	        });
	      }
	
	      return showKeyboardShortcutsPanel;
	    }()
	  }, {
	    key: "maybeRenderDayPickerWithPortal",
	    value: function () {
	      function maybeRenderDayPickerWithPortal() {
	        var _this$props5 = this.props,
	            focused = _this$props5.focused,
	            withPortal = _this$props5.withPortal,
	            withFullScreenPortal = _this$props5.withFullScreenPortal,
	            appendToBody = _this$props5.appendToBody;
	
	        if (!focused) {
	          return null;
	        }
	
	        if (withPortal || withFullScreenPortal || appendToBody) {
	          return _react["default"].createElement(_reactPortal.Portal, null, this.renderDayPicker());
	        }
	
	        return this.renderDayPicker();
	      }
	
	      return maybeRenderDayPickerWithPortal;
	    }()
	  }, {
	    key: "renderDayPicker",
	    value: function () {
	      function renderDayPicker() {
	        var _this$props6 = this.props,
	            anchorDirection = _this$props6.anchorDirection,
	            openDirection = _this$props6.openDirection,
	            onDateChange = _this$props6.onDateChange,
	            date = _this$props6.date,
	            onFocusChange = _this$props6.onFocusChange,
	            focused = _this$props6.focused,
	            enableOutsideDays = _this$props6.enableOutsideDays,
	            numberOfMonths = _this$props6.numberOfMonths,
	            orientation = _this$props6.orientation,
	            monthFormat = _this$props6.monthFormat,
	            navPrev = _this$props6.navPrev,
	            navNext = _this$props6.navNext,
	            onPrevMonthClick = _this$props6.onPrevMonthClick,
	            onNextMonthClick = _this$props6.onNextMonthClick,
	            onClose = _this$props6.onClose,
	            withPortal = _this$props6.withPortal,
	            withFullScreenPortal = _this$props6.withFullScreenPortal,
	            keepOpenOnDateSelect = _this$props6.keepOpenOnDateSelect,
	            initialVisibleMonth = _this$props6.initialVisibleMonth,
	            renderMonthText = _this$props6.renderMonthText,
	            renderCalendarDay = _this$props6.renderCalendarDay,
	            renderDayContents = _this$props6.renderDayContents,
	            renderCalendarInfo = _this$props6.renderCalendarInfo,
	            renderMonthElement = _this$props6.renderMonthElement,
	            calendarInfoPosition = _this$props6.calendarInfoPosition,
	            hideKeyboardShortcutsPanel = _this$props6.hideKeyboardShortcutsPanel,
	            firstDayOfWeek = _this$props6.firstDayOfWeek,
	            customCloseIcon = _this$props6.customCloseIcon,
	            phrases = _this$props6.phrases,
	            dayAriaLabelFormat = _this$props6.dayAriaLabelFormat,
	            daySize = _this$props6.daySize,
	            isRTL = _this$props6.isRTL,
	            isOutsideRange = _this$props6.isOutsideRange,
	            isDayBlocked = _this$props6.isDayBlocked,
	            isDayHighlighted = _this$props6.isDayHighlighted,
	            weekDayFormat = _this$props6.weekDayFormat,
	            styles = _this$props6.styles,
	            verticalHeight = _this$props6.verticalHeight,
	            transitionDuration = _this$props6.transitionDuration,
	            verticalSpacing = _this$props6.verticalSpacing,
	            horizontalMonthPadding = _this$props6.horizontalMonthPadding,
	            small = _this$props6.small,
	            reactDates = _this$props6.theme.reactDates;
	        var _this$state = this.state,
	            dayPickerContainerStyles = _this$state.dayPickerContainerStyles,
	            isDayPickerFocused = _this$state.isDayPickerFocused,
	            showKeyboardShortcuts = _this$state.showKeyboardShortcuts;
	        var onOutsideClick = !withFullScreenPortal && withPortal ? this.onOutsideClick : undefined;
	
	        var closeIcon = customCloseIcon || _react["default"].createElement(_CloseButton["default"], null);
	
	        var inputHeight = (0, _getInputHeight["default"])(reactDates, small);
	        var withAnyPortal = withPortal || withFullScreenPortal;
	        return _react["default"].createElement("div", _extends({
	          // eslint-disable-line jsx-a11y/no-static-element-interactions
	          ref: this.setDayPickerContainerRef
	        }, (0, _reactWithStyles.css)(styles.SingleDatePicker_picker, anchorDirection === _constants.ANCHOR_LEFT && styles.SingleDatePicker_picker__directionLeft, anchorDirection === _constants.ANCHOR_RIGHT && styles.SingleDatePicker_picker__directionRight, openDirection === _constants.OPEN_DOWN && styles.SingleDatePicker_picker__openDown, openDirection === _constants.OPEN_UP && styles.SingleDatePicker_picker__openUp, !withAnyPortal && openDirection === _constants.OPEN_DOWN && {
	          top: inputHeight + verticalSpacing
	        }, !withAnyPortal && openDirection === _constants.OPEN_UP && {
	          bottom: inputHeight + verticalSpacing
	        }, orientation === _constants.HORIZONTAL_ORIENTATION && styles.SingleDatePicker_picker__horizontal, orientation === _constants.VERTICAL_ORIENTATION && styles.SingleDatePicker_picker__vertical, withAnyPortal && styles.SingleDatePicker_picker__portal, withFullScreenPortal && styles.SingleDatePicker_picker__fullScreenPortal, isRTL && styles.SingleDatePicker_picker__rtl, dayPickerContainerStyles), {
	          onClick: onOutsideClick
	        }), _react["default"].createElement(_DayPickerSingleDateController["default"], {
	          date: date,
	          onDateChange: onDateChange,
	          onFocusChange: onFocusChange,
	          orientation: orientation,
	          enableOutsideDays: enableOutsideDays,
	          numberOfMonths: numberOfMonths,
	          monthFormat: monthFormat,
	          withPortal: withAnyPortal,
	          focused: focused,
	          keepOpenOnDateSelect: keepOpenOnDateSelect,
	          hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	          initialVisibleMonth: initialVisibleMonth,
	          navPrev: navPrev,
	          navNext: navNext,
	          onPrevMonthClick: onPrevMonthClick,
	          onNextMonthClick: onNextMonthClick,
	          onClose: onClose,
	          renderMonthText: renderMonthText,
	          renderCalendarDay: renderCalendarDay,
	          renderDayContents: renderDayContents,
	          renderCalendarInfo: renderCalendarInfo,
	          renderMonthElement: renderMonthElement,
	          calendarInfoPosition: calendarInfoPosition,
	          isFocused: isDayPickerFocused,
	          showKeyboardShortcuts: showKeyboardShortcuts,
	          onBlur: this.onDayPickerBlur,
	          phrases: phrases,
	          dayAriaLabelFormat: dayAriaLabelFormat,
	          daySize: daySize,
	          isRTL: isRTL,
	          isOutsideRange: isOutsideRange,
	          isDayBlocked: isDayBlocked,
	          isDayHighlighted: isDayHighlighted,
	          firstDayOfWeek: firstDayOfWeek,
	          weekDayFormat: weekDayFormat,
	          verticalHeight: verticalHeight,
	          transitionDuration: transitionDuration,
	          horizontalMonthPadding: horizontalMonthPadding
	        }), withFullScreenPortal && _react["default"].createElement("button", _extends({}, (0, _reactWithStyles.css)(styles.SingleDatePicker_closeButton), {
	          "aria-label": phrases.closeDatePicker,
	          type: "button",
	          onClick: this.onOutsideClick
	        }), _react["default"].createElement("div", (0, _reactWithStyles.css)(styles.SingleDatePicker_closeButton_svg), closeIcon)));
	      }
	
	      return renderDayPicker;
	    }()
	  }, {
	    key: "render",
	    value: function () {
	      function render() {
	        var _this$props7 = this.props,
	            id = _this$props7.id,
	            placeholder = _this$props7.placeholder,
	            disabled = _this$props7.disabled,
	            focused = _this$props7.focused,
	            required = _this$props7.required,
	            readOnly = _this$props7.readOnly,
	            openDirection = _this$props7.openDirection,
	            showClearDate = _this$props7.showClearDate,
	            showDefaultInputIcon = _this$props7.showDefaultInputIcon,
	            inputIconPosition = _this$props7.inputIconPosition,
	            customCloseIcon = _this$props7.customCloseIcon,
	            customInputIcon = _this$props7.customInputIcon,
	            date = _this$props7.date,
	            onDateChange = _this$props7.onDateChange,
	            displayFormat = _this$props7.displayFormat,
	            phrases = _this$props7.phrases,
	            withPortal = _this$props7.withPortal,
	            withFullScreenPortal = _this$props7.withFullScreenPortal,
	            screenReaderInputMessage = _this$props7.screenReaderInputMessage,
	            isRTL = _this$props7.isRTL,
	            noBorder = _this$props7.noBorder,
	            block = _this$props7.block,
	            small = _this$props7.small,
	            regular = _this$props7.regular,
	            verticalSpacing = _this$props7.verticalSpacing,
	            reopenPickerOnClearDate = _this$props7.reopenPickerOnClearDate,
	            keepOpenOnDateSelect = _this$props7.keepOpenOnDateSelect,
	            styles = _this$props7.styles,
	            isOutsideRange = _this$props7.isOutsideRange;
	        var isInputFocused = this.state.isInputFocused;
	        var enableOutsideClick = !withPortal && !withFullScreenPortal;
	        var hideFang = verticalSpacing < _constants.FANG_HEIGHT_PX;
	
	        var input = _react["default"].createElement(_SingleDatePickerInputController["default"], {
	          id: id,
	          placeholder: placeholder,
	          focused: focused,
	          isFocused: isInputFocused,
	          disabled: disabled,
	          required: required,
	          readOnly: readOnly,
	          openDirection: openDirection,
	          showCaret: !withPortal && !withFullScreenPortal && !hideFang,
	          showClearDate: showClearDate,
	          showDefaultInputIcon: showDefaultInputIcon,
	          inputIconPosition: inputIconPosition,
	          isOutsideRange: isOutsideRange,
	          customCloseIcon: customCloseIcon,
	          customInputIcon: customInputIcon,
	          date: date,
	          onDateChange: onDateChange,
	          displayFormat: displayFormat,
	          onFocusChange: this.onInputFocus,
	          onKeyDownArrowDown: this.onDayPickerFocus,
	          onKeyDownQuestionMark: this.showKeyboardShortcutsPanel,
	          screenReaderMessage: screenReaderInputMessage,
	          phrases: phrases,
	          isRTL: isRTL,
	          noBorder: noBorder,
	          block: block,
	          small: small,
	          regular: regular,
	          verticalSpacing: verticalSpacing,
	          reopenPickerOnClearDate: reopenPickerOnClearDate,
	          keepOpenOnDateSelect: keepOpenOnDateSelect
	        }, this.maybeRenderDayPickerWithPortal());
	
	        return _react["default"].createElement("div", _extends({
	          ref: this.setContainerRef
	        }, (0, _reactWithStyles.css)(styles.SingleDatePicker, block && styles.SingleDatePicker__block)), enableOutsideClick && _react["default"].createElement(_reactOutsideClickHandler["default"], {
	          onOutsideClick: this.onOutsideClick
	        }, input), enableOutsideClick || input);
	      }
	
	      return render;
	    }()
	  }]);
	
	  return SingleDatePicker;
	}(_react["default"].PureComponent || _react["default"].Component);
	
	exports.PureSingleDatePicker = SingleDatePicker;
	SingleDatePicker.propTypes =  false ? propTypes : {};
	SingleDatePicker.defaultProps = defaultProps;
	
	var _default = (0, _reactWithStyles.withStyles)(function (_ref3) {
	  var _ref3$reactDates = _ref3.reactDates,
	      color = _ref3$reactDates.color,
	      zIndex = _ref3$reactDates.zIndex;
	  return {
	    SingleDatePicker: {
	      position: 'relative',
	      display: 'inline-block'
	    },
	    SingleDatePicker__block: {
	      display: 'block'
	    },
	    SingleDatePicker_picker: {
	      zIndex: zIndex + 1,
	      backgroundColor: color.background,
	      position: 'absolute'
	    },
	    SingleDatePicker_picker__rtl: {
	      direction: (0, _noflip["default"])('rtl')
	    },
	    SingleDatePicker_picker__directionLeft: {
	      left: (0, _noflip["default"])(0)
	    },
	    SingleDatePicker_picker__directionRight: {
	      right: (0, _noflip["default"])(0)
	    },
	    SingleDatePicker_picker__portal: {
	      backgroundColor: 'rgba(0, 0, 0, 0.3)',
	      position: 'fixed',
	      top: 0,
	      left: (0, _noflip["default"])(0),
	      height: '100%',
	      width: '100%'
	    },
	    SingleDatePicker_picker__fullScreenPortal: {
	      backgroundColor: color.background
	    },
	    SingleDatePicker_closeButton: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	      cursor: 'pointer',
	      position: 'absolute',
	      top: 0,
	      right: (0, _noflip["default"])(0),
	      padding: 15,
	      zIndex: zIndex + 2,
	      ':hover': {
	        color: "darken(".concat(color.core.grayLighter, ", 10%)"),
	        textDecoration: 'none'
	      },
	      ':focus': {
	        color: "darken(".concat(color.core.grayLighter, ", 10%)"),
	        textDecoration: 'none'
	      }
	    },
	    SingleDatePicker_closeButton_svg: {
	      height: 15,
	      width: 15,
	      fill: color.core.grayLighter
	    }
	  };
	}, {
	  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
	})(SingleDatePicker);
	
	exports["default"] = _default;

/***/ },
/* 1815 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _reactAddonsShallowCompare = _interopRequireDefault(__webpack_require__(70));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(105));
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _OpenDirectionShape = _interopRequireDefault(__webpack_require__(146));
	
	var _defaultPhrases = __webpack_require__(51);
	
	var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(60));
	
	var _SingleDatePickerInput = _interopRequireDefault(__webpack_require__(861));
	
	var _IconPositionShape = _interopRequireDefault(__webpack_require__(174));
	
	var _DisabledShape = _interopRequireDefault(__webpack_require__(224));
	
	var _toMomentObject = _interopRequireDefault(__webpack_require__(178));
	
	var _toLocalizedDateString = _interopRequireDefault(__webpack_require__(437));
	
	var _isInclusivelyAfterDay = _interopRequireDefault(__webpack_require__(176));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function () { function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); } return _getPrototypeOf; }(); return _getPrototypeOf(o); }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function () { function _setPrototypeOf(o, p) { o.__proto__ = p; return o; } return _setPrototypeOf; }(); return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)({
	  children: _propTypes["default"].node,
	  date: _reactMomentProptypes["default"].momentObj,
	  onDateChange: _propTypes["default"].func.isRequired,
	  focused: _propTypes["default"].bool,
	  onFocusChange: _propTypes["default"].func.isRequired,
	  id: _propTypes["default"].string.isRequired,
	  placeholder: _propTypes["default"].string,
	  // also used as label
	  screenReaderMessage: _propTypes["default"].string,
	  showClearDate: _propTypes["default"].bool,
	  showCaret: _propTypes["default"].bool,
	  showDefaultInputIcon: _propTypes["default"].bool,
	  inputIconPosition: _IconPositionShape["default"],
	  disabled: _DisabledShape["default"],
	  required: _propTypes["default"].bool,
	  readOnly: _propTypes["default"].bool,
	  openDirection: _OpenDirectionShape["default"],
	  noBorder: _propTypes["default"].bool,
	  block: _propTypes["default"].bool,
	  small: _propTypes["default"].bool,
	  regular: _propTypes["default"].bool,
	  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
	  keepOpenOnDateSelect: _propTypes["default"].bool,
	  reopenPickerOnClearDate: _propTypes["default"].bool,
	  isOutsideRange: _propTypes["default"].func,
	  displayFormat: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
	  onClose: _propTypes["default"].func,
	  onKeyDownArrowDown: _propTypes["default"].func,
	  onKeyDownQuestionMark: _propTypes["default"].func,
	  customInputIcon: _propTypes["default"].node,
	  customCloseIcon: _propTypes["default"].node,
	  // accessibility
	  isFocused: _propTypes["default"].bool,
	  // i18n
	  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.SingleDatePickerInputPhrases)),
	  isRTL: _propTypes["default"].bool
	}) : {};
	var defaultProps = {
	  children: null,
	  date: null,
	  focused: false,
	  placeholder: '',
	  screenReaderMessage: 'Date',
	  showClearDate: false,
	  showCaret: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  disabled: false,
	  required: false,
	  readOnly: false,
	  openDirection: _constants.OPEN_DOWN,
	  noBorder: false,
	  block: false,
	  small: false,
	  regular: false,
	  verticalSpacing: undefined,
	  keepOpenOnDateSelect: false,
	  reopenPickerOnClearDate: false,
	  isOutsideRange: function () {
	    function isOutsideRange(day) {
	      return !(0, _isInclusivelyAfterDay["default"])(day, (0, _moment["default"])());
	    }
	
	    return isOutsideRange;
	  }(),
	  displayFormat: function () {
	    function displayFormat() {
	      return _moment["default"].localeData().longDateFormat('L');
	    }
	
	    return displayFormat;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	  onKeyDownArrowDown: function () {
	    function onKeyDownArrowDown() {}
	
	    return onKeyDownArrowDown;
	  }(),
	  onKeyDownQuestionMark: function () {
	    function onKeyDownQuestionMark() {}
	
	    return onKeyDownQuestionMark;
	  }(),
	  customInputIcon: null,
	  customCloseIcon: null,
	  // accessibility
	  isFocused: false,
	  // i18n
	  phrases: _defaultPhrases.SingleDatePickerInputPhrases,
	  isRTL: false
	};
	
	var SingleDatePickerInputController =
	/*#__PURE__*/
	function (_ref) {
	  _inherits(SingleDatePickerInputController, _ref);
	
	  _createClass(SingleDatePickerInputController, [{
	    key: !_react["default"].PureComponent && "shouldComponentUpdate",
	    value: function () {
	      function value(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
	      }
	
	      return value;
	    }()
	  }]);
	
	  function SingleDatePickerInputController(props) {
	    var _this;
	
	    _classCallCheck(this, SingleDatePickerInputController);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(SingleDatePickerInputController).call(this, props));
	    _this.onChange = _this.onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onClearFocus = _this.onClearFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.clearDate = _this.clearDate.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    return _this;
	  }
	
	  _createClass(SingleDatePickerInputController, [{
	    key: "onChange",
	    value: function () {
	      function onChange(dateString) {
	        var _this$props = this.props,
	            isOutsideRange = _this$props.isOutsideRange,
	            keepOpenOnDateSelect = _this$props.keepOpenOnDateSelect,
	            onDateChange = _this$props.onDateChange,
	            onFocusChange = _this$props.onFocusChange,
	            onClose = _this$props.onClose;
	        var newDate = (0, _toMomentObject["default"])(dateString, this.getDisplayFormat());
	        var isValid = newDate && !isOutsideRange(newDate);
	
	        if (isValid) {
	          onDateChange(newDate);
	
	          if (!keepOpenOnDateSelect) {
	            onFocusChange({
	              focused: false
	            });
	            onClose({
	              date: newDate
	            });
	          }
	        } else {
	          onDateChange(null);
	        }
	      }
	
	      return onChange;
	    }()
	  }, {
	    key: "onFocus",
	    value: function () {
	      function onFocus() {
	        var _this$props2 = this.props,
	            onFocusChange = _this$props2.onFocusChange,
	            disabled = _this$props2.disabled;
	
	        if (!disabled) {
	          onFocusChange({
	            focused: true
	          });
	        }
	      }
	
	      return onFocus;
	    }()
	  }, {
	    key: "onClearFocus",
	    value: function () {
	      function onClearFocus() {
	        var _this$props3 = this.props,
	            focused = _this$props3.focused,
	            onFocusChange = _this$props3.onFocusChange,
	            onClose = _this$props3.onClose,
	            date = _this$props3.date;
	        if (!focused) return;
	        onFocusChange({
	          focused: false
	        });
	        onClose({
	          date: date
	        });
	      }
	
	      return onClearFocus;
	    }()
	  }, {
	    key: "getDisplayFormat",
	    value: function () {
	      function getDisplayFormat() {
	        var displayFormat = this.props.displayFormat;
	        return typeof displayFormat === 'string' ? displayFormat : displayFormat();
	      }
	
	      return getDisplayFormat;
	    }()
	  }, {
	    key: "getDateString",
	    value: function () {
	      function getDateString(date) {
	        var displayFormat = this.getDisplayFormat();
	
	        if (date && displayFormat) {
	          return date && date.format(displayFormat);
	        }
	
	        return (0, _toLocalizedDateString["default"])(date);
	      }
	
	      return getDateString;
	    }()
	  }, {
	    key: "clearDate",
	    value: function () {
	      function clearDate() {
	        var _this$props4 = this.props,
	            onDateChange = _this$props4.onDateChange,
	            reopenPickerOnClearDate = _this$props4.reopenPickerOnClearDate,
	            onFocusChange = _this$props4.onFocusChange;
	        onDateChange(null);
	
	        if (reopenPickerOnClearDate) {
	          onFocusChange({
	            focused: true
	          });
	        }
	      }
	
	      return clearDate;
	    }()
	  }, {
	    key: "render",
	    value: function () {
	      function render() {
	        var _this$props5 = this.props,
	            children = _this$props5.children,
	            id = _this$props5.id,
	            placeholder = _this$props5.placeholder,
	            disabled = _this$props5.disabled,
	            focused = _this$props5.focused,
	            isFocused = _this$props5.isFocused,
	            required = _this$props5.required,
	            readOnly = _this$props5.readOnly,
	            openDirection = _this$props5.openDirection,
	            showClearDate = _this$props5.showClearDate,
	            showCaret = _this$props5.showCaret,
	            showDefaultInputIcon = _this$props5.showDefaultInputIcon,
	            inputIconPosition = _this$props5.inputIconPosition,
	            customCloseIcon = _this$props5.customCloseIcon,
	            customInputIcon = _this$props5.customInputIcon,
	            date = _this$props5.date,
	            phrases = _this$props5.phrases,
	            onKeyDownArrowDown = _this$props5.onKeyDownArrowDown,
	            onKeyDownQuestionMark = _this$props5.onKeyDownQuestionMark,
	            screenReaderMessage = _this$props5.screenReaderMessage,
	            isRTL = _this$props5.isRTL,
	            noBorder = _this$props5.noBorder,
	            block = _this$props5.block,
	            small = _this$props5.small,
	            regular = _this$props5.regular,
	            verticalSpacing = _this$props5.verticalSpacing;
	        var displayValue = this.getDateString(date);
	        return _react["default"].createElement(_SingleDatePickerInput["default"], {
	          id: id,
	          placeholder: placeholder,
	          focused: focused,
	          isFocused: isFocused,
	          disabled: disabled,
	          required: required,
	          readOnly: readOnly,
	          openDirection: openDirection,
	          showCaret: showCaret,
	          onClearDate: this.clearDate,
	          showClearDate: showClearDate,
	          showDefaultInputIcon: showDefaultInputIcon,
	          inputIconPosition: inputIconPosition,
	          customCloseIcon: customCloseIcon,
	          customInputIcon: customInputIcon,
	          displayValue: displayValue,
	          onChange: this.onChange,
	          onFocus: this.onFocus,
	          onKeyDownShiftTab: this.onClearFocus,
	          onKeyDownArrowDown: onKeyDownArrowDown,
	          onKeyDownQuestionMark: onKeyDownQuestionMark,
	          screenReaderMessage: screenReaderMessage,
	          phrases: phrases,
	          isRTL: isRTL,
	          noBorder: noBorder,
	          block: block,
	          small: small,
	          regular: regular,
	          verticalSpacing: verticalSpacing
	        }, children);
	      }
	
	      return render;
	    }()
	  }]);
	
	  return SingleDatePickerInputController;
	}(_react["default"].PureComponent || _react["default"].Component);
	
	exports["default"] = SingleDatePickerInputController;
	SingleDatePickerInputController.propTypes =  false ? propTypes : {};
	SingleDatePickerInputController.defaultProps = defaultProps;

/***/ },
/* 1816 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "CalendarDay", {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _CalendarDay["default"];
	    }
	
	    return get;
	  }()
	});
	Object.defineProperty(exports, "CalendarMonth", {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _CalendarMonth["default"];
	    }
	
	    return get;
	  }()
	});
	Object.defineProperty(exports, "CalendarMonthGrid", {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _CalendarMonthGrid["default"];
	    }
	
	    return get;
	  }()
	});
	Object.defineProperty(exports, "DateRangePicker", {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _DateRangePicker["default"];
	    }
	
	    return get;
	  }()
	});
	Object.defineProperty(exports, "DateRangePickerInput", {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _DateRangePickerInput["default"];
	    }
	
	    return get;
	  }()
	});
	Object.defineProperty(exports, "DateRangePickerInputController", {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _DateRangePickerInputController["default"];
	    }
	
	    return get;
	  }()
	});
	Object.defineProperty(exports, "DateRangePickerShape", {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _DateRangePickerShape["default"];
	    }
	
	    return get;
	  }()
	});
	Object.defineProperty(exports, "DayPicker", {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _DayPicker["default"];
	    }
	
	    return get;
	  }()
	});
	Object.defineProperty(exports, "DayPickerRangeController", {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _DayPickerRangeController["default"];
	    }
	
	    return get;
	  }()
	});
	Object.defineProperty(exports, "DayPickerSingleDateController", {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _DayPickerSingleDateController["default"];
	    }
	
	    return get;
	  }()
	});
	Object.defineProperty(exports, "SingleDatePicker", {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _SingleDatePicker["default"];
	    }
	
	    return get;
	  }()
	});
	Object.defineProperty(exports, "SingleDatePickerInput", {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _SingleDatePickerInput["default"];
	    }
	
	    return get;
	  }()
	});
	Object.defineProperty(exports, "SingleDatePickerShape", {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _SingleDatePickerShape["default"];
	    }
	
	    return get;
	  }()
	});
	Object.defineProperty(exports, "isInclusivelyAfterDay", {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _isInclusivelyAfterDay["default"];
	    }
	
	    return get;
	  }()
	});
	Object.defineProperty(exports, "isInclusivelyBeforeDay", {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _isInclusivelyBeforeDay["default"];
	    }
	
	    return get;
	  }()
	});
	Object.defineProperty(exports, "isNextDay", {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _isNextDay["default"];
	    }
	
	    return get;
	  }()
	});
	Object.defineProperty(exports, "isSameDay", {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _isSameDay["default"];
	    }
	
	    return get;
	  }()
	});
	Object.defineProperty(exports, "toISODateString", {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _toISODateString["default"];
	    }
	
	    return get;
	  }()
	});
	Object.defineProperty(exports, "toLocalizedDateString", {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _toLocalizedDateString["default"];
	    }
	
	    return get;
	  }()
	});
	Object.defineProperty(exports, "toMomentObject", {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _toMomentObject["default"];
	    }
	
	    return get;
	  }()
	});
	
	var _CalendarDay = _interopRequireDefault(__webpack_require__(433));
	
	var _CalendarMonth = _interopRequireDefault(__webpack_require__(852));
	
	var _CalendarMonthGrid = _interopRequireDefault(__webpack_require__(853));
	
	var _DateRangePicker = _interopRequireDefault(__webpack_require__(1810));
	
	var _DateRangePickerInput = _interopRequireDefault(__webpack_require__(855));
	
	var _DateRangePickerInputController = _interopRequireDefault(__webpack_require__(856));
	
	var _DateRangePickerShape = _interopRequireDefault(__webpack_require__(863));
	
	var _DayPicker = _interopRequireDefault(__webpack_require__(434));
	
	var _DayPickerRangeController = _interopRequireDefault(__webpack_require__(857));
	
	var _DayPickerSingleDateController = _interopRequireDefault(__webpack_require__(858));
	
	var _SingleDatePicker = _interopRequireDefault(__webpack_require__(1814));
	
	var _SingleDatePickerInput = _interopRequireDefault(__webpack_require__(861));
	
	var _SingleDatePickerShape = _interopRequireDefault(__webpack_require__(866));
	
	var _isInclusivelyAfterDay = _interopRequireDefault(__webpack_require__(176));
	
	var _isInclusivelyBeforeDay = _interopRequireDefault(__webpack_require__(1824));
	
	var _isNextDay = _interopRequireDefault(__webpack_require__(875));
	
	var _isSameDay = _interopRequireDefault(__webpack_require__(177));
	
	var _toISODateString = _interopRequireDefault(__webpack_require__(291));
	
	var _toLocalizedDateString = _interopRequireDefault(__webpack_require__(437));
	
	var _toMomentObject = _interopRequireDefault(__webpack_require__(178));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ },
/* 1817 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _registerCSSInterfaceWithDefaultTheme = _interopRequireDefault(__webpack_require__(1828));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	(0, _registerCSSInterfaceWithDefaultTheme["default"])();

/***/ },
/* 1818 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getActiveElement;
	
	function getActiveElement() {
	  return typeof document !== 'undefined' && document.activeElement;
	}

/***/ },
/* 1819 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getCalendarMonthWeeks;
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _constants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getCalendarMonthWeeks(month, enableOutsideDays) {
	  var firstDayOfWeek = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _moment["default"].localeData().firstDayOfWeek();
	
	  if (!_moment["default"].isMoment(month) || !month.isValid()) {
	    throw new TypeError('`month` must be a valid moment object');
	  }
	
	  if (_constants.WEEKDAYS.indexOf(firstDayOfWeek) === -1) {
	    throw new TypeError('`firstDayOfWeek` must be an integer between 0 and 6');
	  } // set utc offset to get correct dates in future (when timezone changes)
	
	
	  var firstOfMonth = month.clone().startOf('month').hour(12);
	  var lastOfMonth = month.clone().endOf('month').hour(12); // calculate the exact first and last days to fill the entire matrix
	  // (considering days outside month)
	
	  var prevDays = (firstOfMonth.day() + 7 - firstDayOfWeek) % 7;
	  var nextDays = (firstDayOfWeek + 6 - lastOfMonth.day()) % 7;
	  var firstDay = firstOfMonth.clone().subtract(prevDays, 'day');
	  var lastDay = lastOfMonth.clone().add(nextDays, 'day');
	  var totalDays = lastDay.diff(firstDay, 'days') + 1;
	  var currentDay = firstDay.clone();
	  var weeksInMonth = [];
	
	  for (var i = 0; i < totalDays; i += 1) {
	    if (i % 7 === 0) {
	      weeksInMonth.push([]);
	    }
	
	    var day = null;
	
	    if (i >= prevDays && i < totalDays - nextDays || enableOutsideDays) {
	      day = currentDay.clone();
	    }
	
	    weeksInMonth[weeksInMonth.length - 1].push(day);
	    currentDay.add(1, 'day');
	  }
	
	  return weeksInMonth;
	}

/***/ },
/* 1820 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getNumberOfCalendarMonthWeeks;
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getBlankDaysBeforeFirstDay(firstDayOfMonth, firstDayOfWeek) {
	  var weekDayDiff = firstDayOfMonth.day() - firstDayOfWeek;
	  return (weekDayDiff + 7) % 7;
	}
	
	function getNumberOfCalendarMonthWeeks(month) {
	  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _moment["default"].localeData().firstDayOfWeek();
	  var firstDayOfMonth = month.clone().startOf('month');
	  var numBlankDays = getBlankDaysBeforeFirstDay(firstDayOfMonth, firstDayOfWeek);
	  return Math.ceil((numBlankDays + month.daysInMonth()) / 7);
	}

/***/ },
/* 1821 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getPhrase;
	
	function getPhrase(phrase, args) {
	  if (typeof phrase === 'string') return phrase;
	
	  if (typeof phrase === 'function') {
	    return phrase(args);
	  }
	
	  return '';
	}

/***/ },
/* 1822 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getSelectedDateOffset;
	
	var defaultModifier = function defaultModifier(day) {
	  return day;
	};
	
	function getSelectedDateOffset(fn, day) {
	  var modifier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultModifier;
	  if (!fn) return day;
	  return modifier(fn(day.clone()));
	}

/***/ },
/* 1823 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getTransformStyles;
	
	function getTransformStyles(transformValue) {
	  return {
	    transform: transformValue,
	    msTransform: transformValue,
	    MozTransform: transformValue,
	    WebkitTransform: transformValue
	  };
	}

/***/ },
/* 1824 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isInclusivelyBeforeDay;
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _isAfterDay = _interopRequireDefault(__webpack_require__(290));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function isInclusivelyBeforeDay(a, b) {
	  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
	  return !(0, _isAfterDay["default"])(a, b);
	}

/***/ },
/* 1825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isNextMonth;
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _isSameMonth = _interopRequireDefault(__webpack_require__(876));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function isNextMonth(a, b) {
	  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
	  return (0, _isSameMonth["default"])(a.clone().add(1, 'month'), b);
	}

/***/ },
/* 1826 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isPrevMonth;
	
	var _moment = _interopRequireDefault(__webpack_require__(2));
	
	var _isSameMonth = _interopRequireDefault(__webpack_require__(876));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function isPrevMonth(a, b) {
	  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
	  return (0, _isSameMonth["default"])(a.clone().subtract(1, 'month'), b);
	}

/***/ },
/* 1827 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isTransitionEndSupported;
	
	function isTransitionEndSupported() {
	  return !!(typeof window !== 'undefined' && 'TransitionEvent' in window);
	}

/***/ },
/* 1828 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = registerCSSInterfaceWithDefaultTheme;
	
	var _reactWithStylesInterfaceCss = _interopRequireDefault(__webpack_require__(1964));
	
	var _registerInterfaceWithDefaultTheme = _interopRequireDefault(__webpack_require__(1829));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function registerCSSInterfaceWithDefaultTheme() {
	  (0, _registerInterfaceWithDefaultTheme["default"])(_reactWithStylesInterfaceCss["default"]);
	}

/***/ },
/* 1829 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = registerInterfaceWithDefaultTheme;
	
	var _ThemedStyleSheet = _interopRequireDefault(__webpack_require__(920));
	
	var _DefaultTheme = _interopRequireDefault(__webpack_require__(867));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function registerInterfaceWithDefaultTheme(reactWithStylesInterface) {
	  _ThemedStyleSheet["default"].registerInterface(reactWithStylesInterface);
	
	  _ThemedStyleSheet["default"].registerTheme(_DefaultTheme["default"]);
	}

/***/ },
/* 1830 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 1831 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(44);
	
	var focusNode = __webpack_require__(629);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 1832 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(227);
	var ExecutionEnvironment = __webpack_require__(67);
	var FallbackCompositionState = __webpack_require__(1838);
	var SyntheticCompositionEvent = __webpack_require__(1875);
	var SyntheticInputEvent = __webpack_require__(1878);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 1833 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(877);
	var ExecutionEnvironment = __webpack_require__(67);
	var ReactInstrumentation = __webpack_require__(86);
	
	var camelizeStyleName = __webpack_require__(1509);
	var dangerousStyleValue = __webpack_require__(1884);
	var hyphenateStyleName = __webpack_require__(1516);
	var memoizeStringOnly = __webpack_require__(1519);
	var warning = __webpack_require__(25);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 1834 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(226);
	var EventPropagators = __webpack_require__(227);
	var ExecutionEnvironment = __webpack_require__(67);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(104);
	var SyntheticEvent = __webpack_require__(116);
	
	var inputValueTracking = __webpack_require__(893);
	var getEventTarget = __webpack_require__(450);
	var isEventSupported = __webpack_require__(451);
	var isTextInputElement = __webpack_require__(895);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 1835 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var DOMLazyTree = __webpack_require__(179);
	var ExecutionEnvironment = __webpack_require__(67);
	
	var createNodesFromMarkup = __webpack_require__(1512);
	var emptyFunction = __webpack_require__(99);
	var invariant = __webpack_require__(20);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 1836 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 1837 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(227);
	var ReactDOMComponentTree = __webpack_require__(44);
	var SyntheticMouseEvent = __webpack_require__(294);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 1838 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(47);
	
	var PooledClass = __webpack_require__(147);
	
	var getTextContentAccessor = __webpack_require__(892);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 1839 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(180);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 1840 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(181);
	
	var instantiateReactComponent = __webpack_require__(894);
	var KeyEscapeUtils = __webpack_require__(442);
	var shouldUpdateReactComponent = __webpack_require__(452);
	var traverseAllChildren = __webpack_require__(897);
	var warning = __webpack_require__(25);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","API_URL":"https://api-dev.montemar.com.ar/0.3","PAGE_TITLE":"Calf Pay - Montemar","PUBLIC_URL":"","PAGE":"montemar-card-calf","REACT_APP_PAGE_TITLE":"Calf Pay - Montemar","REACT_APP_PHONE_NUMBER":"2616362912","REACT_APP_API_URL":"https://api-dev.montemar.com.ar/0.3"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(922);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ },
/* 1841 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(438);
	var ReactDOMIDOperations = __webpack_require__(1848);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 1842 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(47);
	
	var React = __webpack_require__(184);
	var ReactComponentEnvironment = __webpack_require__(444);
	var ReactCurrentOwner = __webpack_require__(118);
	var ReactErrorUtils = __webpack_require__(445);
	var ReactInstanceMap = __webpack_require__(228);
	var ReactInstrumentation = __webpack_require__(86);
	var ReactNodeTypes = __webpack_require__(887);
	var ReactReconciler = __webpack_require__(181);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(398);
	var invariant = __webpack_require__(20);
	var shallowEqual = __webpack_require__(399);
	var shouldUpdateReactComponent = __webpack_require__(452);
	var warning = __webpack_require__(25);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 1843 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactDefaultInjection = __webpack_require__(1856);
	var ReactMount = __webpack_require__(886);
	var ReactReconciler = __webpack_require__(181);
	var ReactUpdates = __webpack_require__(104);
	var ReactVersion = __webpack_require__(1869);
	
	var findDOMNode = __webpack_require__(1885);
	var getHostComponentFromComposite = __webpack_require__(891);
	var renderSubtreeIntoContainer = __webpack_require__(1892);
	var warning = __webpack_require__(25);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 1844 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(47);
	
	var AutoFocusUtils = __webpack_require__(1831);
	var CSSPropertyOperations = __webpack_require__(1833);
	var DOMLazyTree = __webpack_require__(179);
	var DOMNamespaces = __webpack_require__(439);
	var DOMProperty = __webpack_require__(180);
	var DOMPropertyOperations = __webpack_require__(879);
	var EventPluginHub = __webpack_require__(226);
	var EventPluginRegistry = __webpack_require__(440);
	var ReactBrowserEventEmitter = __webpack_require__(293);
	var ReactDOMComponentFlags = __webpack_require__(880);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactDOMInput = __webpack_require__(1849);
	var ReactDOMOption = __webpack_require__(1850);
	var ReactDOMSelect = __webpack_require__(881);
	var ReactDOMTextarea = __webpack_require__(1853);
	var ReactInstrumentation = __webpack_require__(86);
	var ReactMultiChild = __webpack_require__(1862);
	var ReactServerRenderingTransaction = __webpack_require__(1867);
	
	var emptyFunction = __webpack_require__(99);
	var escapeTextContentForBrowser = __webpack_require__(296);
	var invariant = __webpack_require__(20);
	var isEventSupported = __webpack_require__(451);
	var shallowEqual = __webpack_require__(399);
	var inputValueTracking = __webpack_require__(893);
	var validateDOMNesting = __webpack_require__(453);
	var warning = __webpack_require__(25);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 1845 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(453);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 1846 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(47);
	
	var DOMLazyTree = __webpack_require__(179);
	var ReactDOMComponentTree = __webpack_require__(44);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 1847 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 1848 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(438);
	var ReactDOMComponentTree = __webpack_require__(44);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 1849 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(47);
	
	var DOMPropertyOperations = __webpack_require__(879);
	var LinkedValueUtils = __webpack_require__(443);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(104);
	
	var invariant = __webpack_require__(20);
	var warning = __webpack_require__(25);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 1850 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(47);
	
	var React = __webpack_require__(184);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactDOMSelect = __webpack_require__(881);
	
	var warning = __webpack_require__(25);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 1851 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(67);
	
	var getNodeForCharacterOffset = __webpack_require__(1889);
	var getTextContentAccessor = __webpack_require__(892);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 1852 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(47);
	
	var DOMChildrenOperations = __webpack_require__(438);
	var DOMLazyTree = __webpack_require__(179);
	var ReactDOMComponentTree = __webpack_require__(44);
	
	var escapeTextContentForBrowser = __webpack_require__(296);
	var invariant = __webpack_require__(20);
	var validateDOMNesting = __webpack_require__(453);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 1853 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(47);
	
	var LinkedValueUtils = __webpack_require__(443);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(104);
	
	var invariant = __webpack_require__(20);
	var warning = __webpack_require__(25);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 1854 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(20);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 1855 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(47);
	
	var ReactUpdates = __webpack_require__(104);
	var Transaction = __webpack_require__(295);
	
	var emptyFunction = __webpack_require__(99);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 1856 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1830);
	var BeforeInputEventPlugin = __webpack_require__(1832);
	var ChangeEventPlugin = __webpack_require__(1834);
	var DefaultEventPluginOrder = __webpack_require__(1836);
	var EnterLeaveEventPlugin = __webpack_require__(1837);
	var HTMLDOMPropertyConfig = __webpack_require__(1839);
	var ReactComponentBrowserEnvironment = __webpack_require__(1841);
	var ReactDOMComponent = __webpack_require__(1844);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactDOMEmptyComponent = __webpack_require__(1846);
	var ReactDOMTreeTraversal = __webpack_require__(1854);
	var ReactDOMTextComponent = __webpack_require__(1852);
	var ReactDefaultBatchingStrategy = __webpack_require__(1855);
	var ReactEventListener = __webpack_require__(1859);
	var ReactInjection = __webpack_require__(1860);
	var ReactReconcileTransaction = __webpack_require__(1865);
	var SVGDOMPropertyConfig = __webpack_require__(1870);
	var SelectEventPlugin = __webpack_require__(1871);
	var SimpleEventPlugin = __webpack_require__(1872);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 1857 */
923,
/* 1858 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(226);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 1859 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(47);
	
	var EventListener = __webpack_require__(628);
	var ExecutionEnvironment = __webpack_require__(67);
	var PooledClass = __webpack_require__(147);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(104);
	
	var getEventTarget = __webpack_require__(450);
	var getUnboundedScrollPosition = __webpack_require__(1514);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 1860 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(180);
	var EventPluginHub = __webpack_require__(226);
	var EventPluginUtils = __webpack_require__(441);
	var ReactComponentEnvironment = __webpack_require__(444);
	var ReactEmptyComponent = __webpack_require__(882);
	var ReactBrowserEventEmitter = __webpack_require__(293);
	var ReactHostComponent = __webpack_require__(884);
	var ReactUpdates = __webpack_require__(104);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 1861 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1883);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 1862 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactComponentEnvironment = __webpack_require__(444);
	var ReactInstanceMap = __webpack_require__(228);
	var ReactInstrumentation = __webpack_require__(86);
	
	var ReactCurrentOwner = __webpack_require__(118);
	var ReactReconciler = __webpack_require__(181);
	var ReactChildReconciler = __webpack_require__(1840);
	
	var emptyFunction = __webpack_require__(99);
	var flattenChildren = __webpack_require__(1886);
	var invariant = __webpack_require__(20);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 1863 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(20);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 1864 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 1865 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(47);
	
	var CallbackQueue = __webpack_require__(878);
	var PooledClass = __webpack_require__(147);
	var ReactBrowserEventEmitter = __webpack_require__(293);
	var ReactInputSelection = __webpack_require__(885);
	var ReactInstrumentation = __webpack_require__(86);
	var Transaction = __webpack_require__(295);
	var ReactUpdateQueue = __webpack_require__(446);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 1866 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1863);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 1867 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(47);
	
	var PooledClass = __webpack_require__(147);
	var Transaction = __webpack_require__(295);
	var ReactInstrumentation = __webpack_require__(86);
	var ReactServerUpdateQueue = __webpack_require__(1868);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 1868 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(446);
	
	var warning = __webpack_require__(25);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 1869 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 1870 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 1871 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(227);
	var ExecutionEnvironment = __webpack_require__(67);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactInputSelection = __webpack_require__(885);
	var SyntheticEvent = __webpack_require__(116);
	
	var getActiveElement = __webpack_require__(630);
	var isTextInputElement = __webpack_require__(895);
	var shallowEqual = __webpack_require__(399);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 1872 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var EventListener = __webpack_require__(628);
	var EventPropagators = __webpack_require__(227);
	var ReactDOMComponentTree = __webpack_require__(44);
	var SyntheticAnimationEvent = __webpack_require__(1873);
	var SyntheticClipboardEvent = __webpack_require__(1874);
	var SyntheticEvent = __webpack_require__(116);
	var SyntheticFocusEvent = __webpack_require__(1877);
	var SyntheticKeyboardEvent = __webpack_require__(1879);
	var SyntheticMouseEvent = __webpack_require__(294);
	var SyntheticDragEvent = __webpack_require__(1876);
	var SyntheticTouchEvent = __webpack_require__(1880);
	var SyntheticTransitionEvent = __webpack_require__(1881);
	var SyntheticUIEvent = __webpack_require__(229);
	var SyntheticWheelEvent = __webpack_require__(1882);
	
	var emptyFunction = __webpack_require__(99);
	var getEventCharCode = __webpack_require__(448);
	var invariant = __webpack_require__(20);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 1873 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(116);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 1874 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(116);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 1875 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(116);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 1876 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(294);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 1877 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(229);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 1878 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(116);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 1879 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(229);
	
	var getEventCharCode = __webpack_require__(448);
	var getEventKey = __webpack_require__(1887);
	var getEventModifierState = __webpack_require__(449);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 1880 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(229);
	
	var getEventModifierState = __webpack_require__(449);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 1881 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(116);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 1882 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(294);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 1883 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 1884 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(877);
	var warning = __webpack_require__(25);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 1885 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactCurrentOwner = __webpack_require__(118);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactInstanceMap = __webpack_require__(228);
	
	var getHostComponentFromComposite = __webpack_require__(891);
	var invariant = __webpack_require__(20);
	var warning = __webpack_require__(25);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 1886 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(442);
	var traverseAllChildren = __webpack_require__(897);
	var warning = __webpack_require__(25);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","API_URL":"https://api-dev.montemar.com.ar/0.3","PAGE_TITLE":"Calf Pay - Montemar","PUBLIC_URL":"","PAGE":"montemar-card-calf","REACT_APP_PAGE_TITLE":"Calf Pay - Montemar","REACT_APP_PHONE_NUMBER":"2616362912","REACT_APP_API_URL":"https://api-dev.montemar.com.ar/0.3"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(922);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ },
/* 1887 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(448);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 1888 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 1889 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 1890 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(67);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 1891 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(296);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 1892 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(886);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 1893 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(3));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__12__, __WEBPACK_EXTERNAL_MODULE__13__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 10);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = warn;
	
	function warn(s) {
	  console.warn('[react-ga]', s);
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = trim;
	
	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	function trim(s) {
	  return s.replace(/^\s+|\s+$/g, '');
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialize = initialize;
	exports.ga = ga;
	exports.set = set;
	exports.send = send;
	exports.pageview = pageview;
	exports.modalview = modalview;
	exports.timing = timing;
	exports.event = event;
	exports.exception = exception;
	exports.outboundLink = outboundLink;
	exports["default"] = exports.testModeAPI = exports.plugin = void 0;
	
	var _format2 = _interopRequireDefault(__webpack_require__(3));
	
	var _removeLeadingSlash = _interopRequireDefault(__webpack_require__(6));
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	var _loadGA = _interopRequireDefault(__webpack_require__(7));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	var _log = _interopRequireDefault(__webpack_require__(8));
	
	var _testModeAPI = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';
	
	var _debug = false;
	var _titleCase = true;
	var _testMode = false;
	var _alwaysSendToDefaultTracker = true;
	
	var internalGa = function internalGa() {
	  var _window;
	
	  if (_testMode) return _testModeAPI["default"].ga.apply(_testModeAPI["default"], arguments);
	  if (_isNotBrowser) return false;
	  if (!window.ga) return (0, _warn["default"])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
	  return (_window = window).ga.apply(_window, arguments);
	};
	
	function _format(s) {
	  return (0, _format2["default"])(s, _titleCase);
	}
	
	function _gaCommand(trackerNames) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var command = args[0];
	
	  if (typeof internalGa === 'function') {
	    if (typeof command !== 'string') {
	      (0, _warn["default"])('ga command must be a string');
	      return;
	    }
	
	    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);
	
	    if (Array.isArray(trackerNames)) {
	      trackerNames.forEach(function (name) {
	        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
	      });
	    }
	  }
	}
	
	function _initialize(gaTrackingID, options) {
	  if (!gaTrackingID) {
	    (0, _warn["default"])('gaTrackingID is required in initialize()');
	    return;
	  }
	
	  if (options) {
	    if (options.debug && options.debug === true) {
	      _debug = true;
	    }
	
	    if (options.titleCase === false) {
	      _titleCase = false;
	    }
	
	    if (options.useExistingGa) {
	      return;
	    }
	  }
	
	  if (options && options.gaOptions) {
	    internalGa('create', gaTrackingID, options.gaOptions);
	  } else {
	    internalGa('create', gaTrackingID, 'auto');
	  }
	}
	
	function initialize(configsOrTrackingId, options) {
	  if (options && options.testMode === true) {
	    _testMode = true;
	  } else {
	    if (_isNotBrowser) {
	      return false;
	    }
	
	    if (!options || options.standardImplementation !== true) (0, _loadGA["default"])(options);
	  }
	
	  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
	
	  if (Array.isArray(configsOrTrackingId)) {
	    configsOrTrackingId.forEach(function (config) {
	      if (_typeof(config) !== 'object') {
	        (0, _warn["default"])('All configs must be an object');
	        return;
	      }
	
	      _initialize(config.trackingId, config);
	    });
	  } else {
	    _initialize(configsOrTrackingId, options);
	  }
	
	  return true;
	}
	/**
	 * ga:
	 * Returns the original GA object.
	 */
	
	
	function ga() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (args.length > 0) {
	    internalGa.apply(void 0, args);
	
	    if (_debug) {
	      (0, _log["default"])('called ga(\'arguments\');');
	      (0, _log["default"])("with arguments: ".concat(JSON.stringify(args)));
	    }
	  }
	
	  return window.ga;
	}
	/**
	 * set:
	 * GA tracker set method
	 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function set(fieldsObject, trackerNames) {
	  if (!fieldsObject) {
	    (0, _warn["default"])('`fieldsObject` is required in .set()');
	    return;
	  }
	
	  if (_typeof(fieldsObject) !== 'object') {
	    (0, _warn["default"])('Expected `fieldsObject` arg to be an Object');
	    return;
	  }
	
	  if (Object.keys(fieldsObject).length === 0) {
	    (0, _warn["default"])('empty `fieldsObject` given to .set()');
	  }
	
	  _gaCommand(trackerNames, 'set', fieldsObject);
	
	  if (_debug) {
	    (0, _log["default"])('called ga(\'set\', fieldsObject);');
	    (0, _log["default"])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
	  }
	}
	/**
	 * send:
	 * Clone of the low level `ga.send` method
	 * WARNING: No validations will be applied to this
	 * @param  {Object} fieldObject - field object for tracking different analytics
	 * @param  {Array} trackerNames - trackers to send the command to
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function send(fieldObject, trackerNames) {
	  _gaCommand(trackerNames, 'send', fieldObject);
	
	  if (_debug) {
	    (0, _log["default"])('called ga(\'send\', fieldObject);');
	    (0, _log["default"])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
	    (0, _log["default"])("with trackers: ".concat(JSON.stringify(trackerNames)));
	  }
	}
	/**
	 * pageview:
	 * Basic GA pageview tracking
	 * @param  {String} path - the current page page e.g. '/about'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 * @param {String} title - (optional) the page title e. g. 'My Website'
	 */
	
	
	function pageview(rawPath, trackerNames, title) {
	  if (!rawPath) {
	    (0, _warn["default"])('path is required in .pageview()');
	    return;
	  }
	
	  var path = (0, _trim["default"])(rawPath);
	
	  if (path === '') {
	    (0, _warn["default"])('path cannot be an empty string in .pageview()');
	    return;
	  }
	
	  var extraFields = {};
	
	  if (title) {
	    extraFields.title = title;
	  }
	
	  if (typeof ga === 'function') {
	    _gaCommand(trackerNames, 'send', _objectSpread({
	      hitType: 'pageview',
	      page: path
	    }, extraFields));
	
	    if (_debug) {
	      (0, _log["default"])('called ga(\'send\', \'pageview\', path);');
	      var extraLog = '';
	
	      if (title) {
	        extraLog = " and title: ".concat(title);
	      }
	
	      (0, _log["default"])("with path: ".concat(path).concat(extraLog));
	    }
	  }
	}
	/**
	 * modalview:
	 * a proxy to basic GA pageview tracking to consistently track
	 * modal views that are an equivalent UX to a traditional pageview
	 * @param  {String} modalName e.g. 'add-or-edit-club'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function modalview(rawModalName, trackerNames) {
	  if (!rawModalName) {
	    (0, _warn["default"])('modalName is required in .modalview(modalName)');
	    return;
	  }
	
	  var modalName = (0, _removeLeadingSlash["default"])((0, _trim["default"])(rawModalName));
	
	  if (modalName === '') {
	    (0, _warn["default"])('modalName cannot be an empty string or a single / in .modalview()');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    var path = "/modal/".concat(modalName);
	
	    _gaCommand(trackerNames, 'send', 'pageview', path);
	
	    if (_debug) {
	      (0, _log["default"])('called ga(\'send\', \'pageview\', path);');
	      (0, _log["default"])("with path: ".concat(path));
	    }
	  }
	}
	/**
	 * timing:
	 * GA timing
	 * @param args.category {String} required
	 * @param args.variable {String} required
	 * @param args.value  {Int}  required
	 * @param args.label  {String} required
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function timing() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref.category,
	      variable = _ref.variable,
	      value = _ref.value,
	      label = _ref.label;
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    if (!category || !variable || !value || typeof value !== 'number') {
	      (0, _warn["default"])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'timing',
	      timingCategory: _format(category),
	      timingVar: _format(variable),
	      timingValue: value
	    };
	
	    if (label) {
	      fieldObject.timingLabel = _format(label);
	    }
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * event:
	 * GA event tracking
	 * @param args.category {String} required
	 * @param args.action {String} required
	 * @param args.label {String} optional
	 * @param args.value {Int} optional
	 * @param args.nonInteraction {boolean} optional
	 * @param args.transport {string} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function event() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref2.category,
	      action = _ref2.action,
	      label = _ref2.label,
	      value = _ref2.value,
	      nonInteraction = _ref2.nonInteraction,
	      transport = _ref2.transport,
	      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!category || !action) {
	      (0, _warn["default"])('args.category AND args.action are required in event()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: _format(category),
	      eventAction: _format(action)
	    }; // Optional Fields
	
	    if (label) {
	      fieldObject.eventLabel = _format(label);
	    }
	
	    if (typeof value !== 'undefined') {
	      if (typeof value !== 'number') {
	        (0, _warn["default"])('Expected `args.value` arg to be a Number.');
	      } else {
	        fieldObject.eventValue = value;
	      }
	    }
	
	    if (typeof nonInteraction !== 'undefined') {
	      if (typeof nonInteraction !== 'boolean') {
	        (0, _warn["default"])('`args.nonInteraction` must be a boolean.');
	      } else {
	        fieldObject.nonInteraction = nonInteraction;
	      }
	    }
	
	    if (typeof transport !== 'undefined') {
	      if (typeof transport !== 'string') {
	        (0, _warn["default"])('`args.transport` must be a string.');
	      } else {
	        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
	          (0, _warn["default"])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
	        }
	
	        fieldObject.transport = transport;
	      }
	    }
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'dimension'.length) === 'dimension';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'metric'.length) === 'metric';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    }); // Send to GA
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * exception:
	 * GA exception tracking
	 * @param args.description {String} optional
	 * @param args.fatal {boolean} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function exception(_ref3, trackerNames) {
	  var description = _ref3.description,
	      fatal = _ref3.fatal;
	
	  if (typeof ga === 'function') {
	    // Required Fields
	    var fieldObject = {
	      hitType: 'exception'
	    }; // Optional Fields
	
	    if (description) {
	      fieldObject.exDescription = _format(description);
	    }
	
	    if (typeof fatal !== 'undefined') {
	      if (typeof fatal !== 'boolean') {
	        (0, _warn["default"])('`args.fatal` must be a boolean.');
	      } else {
	        fieldObject.exFatal = fatal;
	      }
	    } // Send to GA
	
	
	    send(fieldObject, trackerNames);
	  }
	}
	
	var plugin = {
	  /**
	   * require:
	   * GA requires a plugin
	   * @param name {String} e.g. 'ecommerce' or 'myplugin'
	   * @param options {Object} optional e.g {path: '/log', debug: true}
	   * @param trackerName {String} optional e.g 'trackerName'
	   */
	  require: function require(rawName, options, trackerName) {
	    if (typeof ga === 'function') {
	      // Required Fields
	      if (!rawName) {
	        (0, _warn["default"])('`name` is required in .require()');
	        return;
	      }
	
	      var name = (0, _trim["default"])(rawName);
	
	      if (name === '') {
	        (0, _warn["default"])('`name` cannot be an empty string in .require()');
	        return;
	      }
	
	      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields
	
	      if (options) {
	        if (_typeof(options) !== 'object') {
	          (0, _warn["default"])('Expected `options` arg to be an Object');
	          return;
	        }
	
	        if (Object.keys(options).length === 0) {
	          (0, _warn["default"])('Empty `options` given to .require()');
	        }
	
	        ga(requireString, name, options);
	
	        if (_debug) {
	          (0, _log["default"])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
	        }
	      } else {
	        ga(requireString, name);
	
	        if (_debug) {
	          (0, _log["default"])("called ga('require', '".concat(name, "');"));
	        }
	      }
	    }
	  },
	
	  /**
	   * execute:
	   * GA execute action for plugin
	   * Takes variable number of arguments
	   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	   * @param action {String} e.g. 'addItem' or 'myCustomAction'
	   * @param actionType {String} optional e.g. 'detail'
	   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	   */
	  execute: function execute(pluginName, action) {
	    var payload;
	    var actionType;
	
	    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
	      payload = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      actionType = arguments.length <= 2 ? undefined : arguments[2];
	      payload = arguments.length <= 3 ? undefined : arguments[3];
	    }
	
	    if (typeof ga === 'function') {
	      if (typeof pluginName !== 'string') {
	        (0, _warn["default"])('Expected `pluginName` arg to be a String.');
	      } else if (typeof action !== 'string') {
	        (0, _warn["default"])('Expected `action` arg to be a String.');
	      } else {
	        var command = "".concat(pluginName, ":").concat(action);
	        payload = payload || null;
	
	        if (actionType && payload) {
	          ga(command, actionType, payload);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	            (0, _log["default"])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
	          }
	        } else if (payload) {
	          ga(command, payload);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	            (0, _log["default"])("with payload: ".concat(JSON.stringify(payload)));
	          }
	        } else {
	          ga(command);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	          }
	        }
	      }
	    }
	  }
	};
	/**
	 * outboundLink:
	 * GA outboundLink tracking
	 * @param args.label {String} e.g. url, or 'Create an Account'
	 * @param {function} hitCallback - Called after processing a hit.
	 */
	
	exports.plugin = plugin;
	
	function outboundLink(args, hitCallback, trackerNames) {
	  if (typeof hitCallback !== 'function') {
	    (0, _warn["default"])('hitCallback function is required');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!args || !args.label) {
	      (0, _warn["default"])('args.label is required in outboundLink()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: 'Outbound',
	      eventAction: 'Click',
	      eventLabel: _format(args.label)
	    };
	    var safetyCallbackCalled = false;
	
	    var safetyCallback = function safetyCallback() {
	      // This prevents a delayed response from GA
	      // causing hitCallback from being fired twice
	      safetyCallbackCalled = true;
	      hitCallback();
	    }; // Using a timeout to ensure the execution of critical application code
	    // in the case when the GA server might be down
	    // or an ad blocker prevents sending the data
	    // register safety net timeout:
	
	
	    var t = setTimeout(safetyCallback, 250);
	
	    var clearableCallbackForGA = function clearableCallbackForGA() {
	      clearTimeout(t);
	
	      if (!safetyCallbackCalled) {
	        hitCallback();
	      }
	    };
	
	    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA
	
	    send(fieldObject, trackerNames);
	  } else {
	    // if ga is not defined, return the callback so the application
	    // continues to work as expected
	    setTimeout(hitCallback, 0);
	  }
	}
	
	var testModeAPI = _testModeAPI["default"];
	exports.testModeAPI = testModeAPI;
	var _default = {
	  initialize: initialize,
	  ga: ga,
	  set: set,
	  send: send,
	  pageview: pageview,
	  modalview: modalview,
	  timing: timing,
	  event: event,
	  exception: exception,
	  plugin: plugin,
	  outboundLink: outboundLink,
	  testModeAPI: _testModeAPI["default"]
	};
	exports["default"] = _default;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = format;
	
	var _mightBeEmail = _interopRequireDefault(__webpack_require__(4));
	
	var _toTitleCase = _interopRequireDefault(__webpack_require__(5));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var redacted = 'REDACTED (Potential Email Address)';
	
	function format(s, titleCase) {
	  if ((0, _mightBeEmail["default"])(s)) {
	    (0, _warn["default"])('This arg looks like an email address, redacting.');
	    return redacted;
	  }
	
	  if (titleCase) {
	    return (0, _toTitleCase["default"])(s);
	  }
	
	  return s;
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = mightBeEmail;
	
	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return typeof s === 'string' && s.indexOf('@') !== -1;
	}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = toTitleCase;
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * To Title Case 2.1 - http://individed.com/code/to-title-case/
	 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	 * https://github.com/gouch/to-title-case
	 */
	var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
	
	function toTitleCase(string) {
	  return (0, _trim["default"])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = removeLeadingSlash;
	
	function removeLeadingSlash(string) {
	  if (string.substring(0, 1) === '/') {
	    return string.substring(1);
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = _default;
	
	function _default(options) {
	  var gaAddress = 'https://www.google-analytics.com/analytics.js';
	
	  if (options && options.gaAddress) {
	    gaAddress = options.gaAddress;
	  } else if (options && options.debug) {
	    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
	  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	
	  /* eslint-disable */
	
	
	  (function (i, s, o, g, r, a, m) {
	    i['GoogleAnalyticsObject'] = r;
	    i[r] = i[r] || function () {
	      (i[r].q = i[r].q || []).push(arguments);
	    }, i[r].l = 1 * new Date();
	    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	    a.async = 1;
	    a.src = g;
	    m.parentNode.insertBefore(a, m);
	  })(window, document, 'script', gaAddress, 'ga');
	  /* eslint-enable */
	
	}
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = log;
	
	function log(s) {
	  console.info('[react-ga]', s);
	}
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.gaCalls = void 0;
	var gaCalls = [];
	exports.gaCalls = gaCalls;
	var _default = {
	  calls: gaCalls,
	  ga: function ga() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    gaCalls.push([].concat(args));
	  },
	  resetCalls: function resetCalls() {
	    gaCalls.length = 0;
	  }
	};
	exports["default"] = _default;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.OutboundLink = exports.testModeAPI = exports.outboundLink = exports.plugin = exports.exception = exports.event = exports.timing = exports.modalview = exports.pageview = exports.send = exports.set = exports.ga = exports.initialize = void 0;
	
	var _OutboundLink = _interopRequireDefault(__webpack_require__(11));
	
	var Defaults = _interopRequireWildcard(__webpack_require__(2));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialize = Defaults.initialize;
	exports.initialize = initialize;
	var ga = Defaults.ga;
	exports.ga = ga;
	var set = Defaults.set;
	exports.set = set;
	var send = Defaults.send;
	exports.send = send;
	var pageview = Defaults.pageview;
	exports.pageview = pageview;
	var modalview = Defaults.modalview;
	exports.modalview = modalview;
	var timing = Defaults.timing;
	exports.timing = timing;
	var event = Defaults.event;
	exports.event = event;
	var exception = Defaults.exception;
	exports.exception = exception;
	var plugin = Defaults.plugin;
	exports.plugin = plugin;
	var outboundLink = Defaults.outboundLink;
	exports.outboundLink = outboundLink;
	var testModeAPI = Defaults.testModeAPI;
	exports.testModeAPI = testModeAPI;
	_OutboundLink["default"].origTrackLink = _OutboundLink["default"].trackLink;
	_OutboundLink["default"].trackLink = Defaults.outboundLink;
	var OutboundLink = _OutboundLink["default"];
	exports.OutboundLink = OutboundLink;
	
	var _default = _objectSpread({}, Defaults, {
	  OutboundLink: OutboundLink
	});
	
	exports["default"] = _default;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(12));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NEWTAB = '_blank';
	var MIDDLECLICK = 1;
	
	var OutboundLink =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(OutboundLink, _Component);
	
	  function OutboundLink() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, OutboundLink);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
	      var _this$props = _this.props,
	          target = _this$props.target,
	          eventLabel = _this$props.eventLabel,
	          to = _this$props.to,
	          onClick = _this$props.onClick,
	          trackerNames = _this$props.trackerNames;
	      var eventMeta = {
	        label: eventLabel
	      };
	      var sameTarget = target !== NEWTAB;
	      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
	
	      if (sameTarget && normalClick) {
	        event.preventDefault();
	        OutboundLink.trackLink(eventMeta, function () {
	          window.location.href = to;
	        }, trackerNames);
	      } else {
	        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(OutboundLink, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          href = _this$props2.to,
	          oldProps = _objectWithoutProperties(_this$props2, ["to"]);
	
	      var props = _objectSpread({}, oldProps, {
	        href: href,
	        onClick: this.handleClick
	      });
	
	      if (this.props.target === NEWTAB) {
	        props.rel = 'noopener noreferrer';
	      }
	
	      delete props.eventLabel;
	      delete props.trackerNames;
	      return _react["default"].createElement('a', props);
	    }
	  }]);
	
	  return OutboundLink;
	}(_react.Component);
	
	exports["default"] = OutboundLink;
	
	_defineProperty(OutboundLink, "trackLink", function () {
	  (0, _warn["default"])('ga tracking not enabled');
	});
	
	_defineProperty(OutboundLink, "propTypes", {
	  eventLabel: _propTypes["default"].string.isRequired,
	  target: _propTypes["default"].string,
	  to: _propTypes["default"].string,
	  onClick: _propTypes["default"].func,
	  trackerNames: _propTypes["default"].arrayOf(_propTypes["default"].string)
	});
	
	_defineProperty(OutboundLink, "defaultProps", {
	  target: null,
	  to: null,
	  onClick: null,
	  trackerNames: null
	});
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__12__;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__13__;
	
	/***/ })
	/******/ ]);
	});

/***/ },
/* 1894 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * ISC License
	 *
	 * Copyright (c) 2018, Aleck Greenham
	 *
	 * Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
	 */
	
	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var PropTypes=_interopDefault(__webpack_require__(3)),React=__webpack_require__(1),React__default=_interopDefault(React);function _typeof(e){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function _defineProperties(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}function _createClass(e,t,n){return t&&_defineProperties(e.prototype,t),n&&_defineProperties(e,n),e}function _defineProperty(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(e[i]=n[i])}return e}).apply(this,arguments)}function _objectSpread(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{},i=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(i=i.concat(Object.getOwnPropertySymbols(n).filter(function(e){return Object.getOwnPropertyDescriptor(n,e).enumerable}))),i.forEach(function(e){_defineProperty(t,e,n[e])})}return t}function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&_setPrototypeOf(e,t)}function _getPrototypeOf(e){return(_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function _setPrototypeOf(e,t){return(_setPrototypeOf=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function isNativeReflectConstruct(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],function(){})),!0}catch(e){return!1}}function _construct(e,t,n){return(_construct=isNativeReflectConstruct()?Reflect.construct:function(e,t,n){var i=[null];i.push.apply(i,t);var o=new(Function.bind.apply(e,i));return n&&_setPrototypeOf(o,n.prototype),o}).apply(null,arguments)}function _isNativeFunction(e){return-1!==Function.toString.call(e).indexOf("[native code]")}function _wrapNativeSuper(e){var n="function"==typeof Map?new Map:void 0;return(_wrapNativeSuper=function(e){if(null===e||!_isNativeFunction(e))return e;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==n){if(n.has(e))return n.get(e);n.set(e,t)}function t(){return _construct(e,arguments,_getPrototypeOf(this).constructor)}return t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),_setPrototypeOf(t,e)})(e)}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var n,i,o={},r=Object.keys(e);for(i=0;i<r.length;i++)n=r[i],0<=t.indexOf(n)||(o[n]=e[n]);return o}function _objectWithoutProperties(e,t){if(null==e)return{};var n,i,o=_objectWithoutPropertiesLoose(e,t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);for(i=0;i<r.length;i++)n=r[i],0<=t.indexOf(n)||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}function _assertThisInitialized(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function _possibleConstructorReturn(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?_assertThisInitialized(e):t}function _superPropBase(e,t){for(;!Object.prototype.hasOwnProperty.call(e,t)&&null!==(e=_getPrototypeOf(e)););return e}function _get(e,t,n){return(_get="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(e,t,n){var i=_superPropBase(e,t);if(i){var o=Object.getOwnPropertyDescriptor(i,t);return o.get?o.get.call(n):o.value}})(e,t,n||e)}function _toConsumableArray(e){return _arrayWithoutHoles(e)||_iterableToArray(e)||_nonIterableSpread()}function _arrayWithoutHoles(e){if(Array.isArray(e)){for(var t=0,n=new Array(e.length);t<e.length;t++)n[t]=e[t];return n}}function _iterableToArray(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance")}function dictionaryFrom(e){var n=1<arguments.length&&void 0!==arguments[1]?arguments[1]:null;return e.reduce(function(e,t){return e[t]=n||{value:t},e},{})}var _defaultConfiguration={logLevel:"warn",defaultKeyEvent:"keydown",defaultComponent:"div",defaultTabIndex:"-1",ignoreTags:["input","select","textarea"],enableHardSequences:!1,ignoreKeymapAndHandlerChangesByDefault:!0,ignoreEventsCondition:function(e){var t=e.target;if(t&&t.tagName){var n=t.tagName.toLowerCase();return Configuration.option("_ignoreTagsDict")[n]||t.isContentEditable}return!1},ignoreRepeatedEventsWhenKeyHeldDown:!0,simulateMissingKeyPressEvents:!0,stopEventPropagationAfterHandling:!0,stopEventPropagationAfterIgnoring:!0,allowCombinationSubmatches:!1,customKeyCodes:{}},_configuration=_objectSpread({},_defaultConfiguration);_configuration._ignoreTagsDict=dictionaryFrom(_configuration.ignoreTags,!0);var Configuration=function(){function e(){_classCallCheck(this,e)}return _createClass(e,null,[{key:"init",value:function(t){var n=this,e=t.ignoreTags,i=t.customKeyCodes;e&&(t._ignoreTagsDict=dictionaryFrom(t.ignoreTags)),i&&(t._customKeyNamesDict=dictionaryFrom(Object.values(t.customKeyCodes))),-1!==["verbose","debug","info"].indexOf(t.logLevel)&&console.warn("React HotKeys: You have requested log level '".concat(t.logLevel,"' but for performance reasons, logging below severity level 'warning' is disabled in production. Please use the development build for complete logs.")),Object.keys(t).forEach(function(e){n.set(e,t[e])})}},{key:"set",value:function(e,t){_configuration[e]=t}},{key:"reset",value:function(e){_configuration[e]=_defaultConfiguration[e]}},{key:"option",value:function(e){return _configuration[e]}}]),e}(),Logger=function(){function n(){var t=this,e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:"warn";_classCallCheck(this,n),_defineProperty(this,"verbose",this.noop),_defineProperty(this,"debug",this.noop),_defineProperty(this,"info",this.noop),_defineProperty(this,"warn",this.noop),_defineProperty(this,"error",this.noop),this.logLevel=this.constructor.levels[e],this.logLevel>=this.constructor.levels.error&&(this.error=console.error,this.logLevel>=this.constructor.levels.warn&&(this.warn=console.warn,["info","debug","verbose"].some(function(e){return!(t.logLevel>=t.constructor.levels[e])||(t[e]=console.log,!1)})))}return _createClass(n,[{key:"noop",value:function(){}}]),n}();_defineProperty(Logger,"logIcons",["📕","📗","📘","📙"]),_defineProperty(Logger,"componentIcons",["🔺","⭐️","🔷","🔶","⬛️"]),_defineProperty(Logger,"eventIcons",["❤️","💚","💙","💛","💜","🧡"]),_defineProperty(Logger,"levels",{none:0,error:1,warn:2,info:3,debug:4,verbose:5});var KeyEventType={keydown:0,keypress:1,keyup:2},ModifierFlagsDictionary={Shift:["shiftKey"],Meta:["metaKey"],Control:["ctrlKey"],Alt:["altKey"]},ShiftedKeysDictionary={"`":["~"],1:["!"],2:["@",'"'],3:["#","£"],4:["$"],5:["%"],6:["^"],7:["&"],8:["*"],9:["("],0:[")"],"-":["_"],"=":["plus"],";":[":"],"'":['"',"@"],",":["<"],".":[">"],"/":["?"],"\\":["|"],"[":["{"],"]":["}"],"#":["~"]};function resolveShiftedAlias(e){return ShiftedKeysDictionary[e]||[1===e.length?e.toUpperCase():e]}function hasKey(e,t){return e.hasOwnProperty(t)}function invertArrayDictionary(i){var o=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};return Object.keys(i).reduce(function(t,n){var e=i[n];return e.forEach(function(e){hasKey(t,e)||(t[e]=[]),t[e].push(n)}),o.includeOriginal&&(hasKey(t,n)||(t[n]=[]),t[n]=[].concat(_toConsumableArray(t[n]),_toConsumableArray(e))),t},{})}var UnshiftedKeysDictionary=invertArrayDictionary(ShiftedKeysDictionary);function resolveUnshiftedAlias(e){return UnshiftedKeysDictionary[e]||[1===e.length?e.toLowerCase():e]}var KeyOSAndLayoutAliasesDictionary={},KeyOSAndLayoutAliasesDictionary$1=invertArrayDictionary(KeyOSAndLayoutAliasesDictionary,{includeOriginal:!0});function isString(e){return"string"==typeof e}function stripSuperfluousWhitespace(e){return isString(e)?e.trim().replace(/\s+/g," "):e}var MousetrapToReactKeyNamesDictionary={tab:"Tab",capslock:"CapsLock",shift:"Shift",meta:"Meta",alt:"Alt",ctrl:"Control",space:" ",spacebar:" ",escape:"Escape",esc:"Escape",left:"ArrowLeft",right:"ArrowRight",up:"ArrowUp",down:"ArrowDown",return:"Enter",del:"Delete",command:"Meta",option:"Alt",enter:"Enter",backspace:"Backspace",ins:"Insert",pageup:"PageUp",pagedown:"PageDown",end:"End",home:"Home",contextmenu:"ContextMenu",numlock:"Clear"},KeyShorthandDictionary={cmd:"Meta"};function standardizeKeyName(e){var t=e.toLowerCase();return MousetrapToReactKeyNamesDictionary[t]||KeyShorthandDictionary[t]||(e.match(/^f\d+$/)?e.toUpperCase():e)}var translateToKey={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},NonPrintableKeysDictionary=dictionaryFrom(Object.values(translateToKey),!0);function isNonPrintableKeyName(e){return!!NonPrintableKeysDictionary[e]}function isCustomKeyName(e){return Configuration.option("_customKeyNamesDict")[e]}function isValidKey(e){return isNonPrintableKeyName(e)||String.fromCharCode(e.charCodeAt(0))===e||isCustomKeyName(e)}var InvalidKeyNameError=function(e){function r(){var e,t;_classCallCheck(this,r);for(var n=arguments.length,i=new Array(n),o=0;o<n;o++)i[o]=arguments[o];return _defineProperty(_assertThisInitialized(_assertThisInitialized(t=_possibleConstructorReturn(this,(e=_getPrototypeOf(r)).call.apply(e,[this].concat(i))))),"name","InvalidKeyNameError"),t}return _inherits(r,_wrapNativeSuper(Error)),r}();function normalizedCombinationId(e){return e.sort().join("+")}var KeySequenceParser=function(){function e(){_classCallCheck(this,e)}return _createClass(e,null,[{key:"parse",value:function(e){var n=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},t=stripSuperfluousWhitespace(e).split(" ");try{var i=t.slice(0,t.length-1),o=t[t.length-1],r=i.map(function(e){var t=parseCombination(e,n);return normalizedCombinationId(Object.keys(t))}).join(" "),s=parseCombination(o,n),a={id:normalizedCombinationId(Object.keys(s)),keyDictionary:s,keyEventType:n.keyEventType,size:Object.keys(s).length};return{sequence:{prefix:r,size:i.length+1},combination:a}}catch(e){return{sequence:null,combination:null}}}}]),e}();function parseCombination(e){var i=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};return e.replace(/^\+|(\s|[^+]\+)\+/,"$1plus").split("+").reduce(function(e,t){var n=standardizeKeyName(t);if(i.ensureValidKeys&&!isValidKey(n))throw new InvalidKeyNameError;return e[n]=!0,e},{})}var AltedKeysDictionary={"`":["`"],1:["¡"],2:["™"],3:["£"],4:["¢"],5:["∞"],6:["§"],7:["¶"],8:["•"],9:["ª"],0:["º"],"-":["–"],"=":["≠"],a:["å"],b:["∫"],c:["ç"],d:["∂"],e:["´"],f:["ƒ"],g:["©"],h:["˙"],i:["ˆ"],j:["∆"],k:["˚"],l:["¬"],m:["µ"],n:["˜"],o:["ø"],p:["π"],q:["œ"],r:["®"],s:["ß"],t:["†"],u:["¨"],v:["√"],w:["∑"],x:["≈"],y:["¥"],z:["Ω"],"[":["“"],"]":["‘"],"\\":["«"],"'":["æ"],";":["…"],",":["≤"],".":["≥"],"/":["÷"]},UnaltedKeysDictionary=invertArrayDictionary(AltedKeysDictionary);function resolveUnaltedAlias(e){return UnaltedKeysDictionary[e]||[e]}function resolveAltedAlias(e){return AltedKeysDictionary[e]||[e]}var AltShiftedKeysDictionary={"`":["`"],1:["⁄"],2:["€"],3:["‹"],4:["›"],5:["ﬁ"],6:["ﬂ"],7:["‡"],8:["°"],9:["·"],0:["‚"],"-":["—"],"=":["±"],a:["Å"],b:["ı"],c:["Ç"],d:["Î"],e:["´"],f:["Ï"],g:["˝"],h:["Ó"],i:["ˆ"],j:["Ô"],k:[""],l:["Ò"],m:["Â"],n:["˜"],o:["Ø"],p:["π"],q:["Œ"],r:["‰"],s:["Í"],t:["Î"],u:["¨"],v:["◊"],w:["„"],x:["˛"],y:["Á"],z:["¸"],"[":["”"],"]":["’"],"\\":["»"],"'":["Æ"],";":["Ú"],",":["¯"],".":["˘"]},UnaltShiftedKeysDictionary=invertArrayDictionary(AltShiftedKeysDictionary);function resolveUnaltShiftedAlias(e){return UnaltShiftedKeysDictionary[e]||resolveUnshiftedAlias(e)}function resolveAltShiftedAlias(e){return AltShiftedKeysDictionary[e]||[e]}var KeyCombinationSerializer=function(){function e(){_classCallCheck(this,e)}return _createClass(e,null,[{key:"serialize",value:function(e){var c=e.Shift,y=e.Alt,h={};return Object.keys(e).sort().forEach(function(e){var n=[];if(c)if(y){var t=resolveUnaltShiftedAlias(e),i=resolveAltShiftedAlias(e);n=[].concat(_toConsumableArray(n),[e],_toConsumableArray(t),_toConsumableArray(i))}else{var o=resolveUnshiftedAlias(e),r=resolveShiftedAlias(e);n=[].concat(_toConsumableArray(n),[e],_toConsumableArray(o),_toConsumableArray(r))}else if(y){var s=resolveUnaltedAlias(e),a=resolveAltedAlias(e);n=[].concat(_toConsumableArray(n),[e],_toConsumableArray(s),_toConsumableArray(a))}else{n.push(e);var u=KeyOSAndLayoutAliasesDictionary$1[e];u&&(n=[].concat(_toConsumableArray(n),_toConsumableArray(u)))}var l=Object.keys(h);0<l.length?l.forEach(function(t){n.forEach(function(e){h[t+"+".concat(e)]=_objectSpread({},h[t],_defineProperty({},e,!0))}),delete h[t]}):n.forEach(function(e){h[e]=_defineProperty({},e,!0)})}),Object.values(h).map(function(e){return Object.keys(e).sort().join("+")})}},{key:"isValidKeySerialization",value:function(e){return 0<e.length&&!!KeySequenceParser.parse(e,{ensureValidKeys:!0}).combination}}]),e}(),KeyEventSequenceIndex={previous:0,current:1};function resolveKeyAlias(e){return KeyOSAndLayoutAliasesDictionary$1[e]||[e]}function applicableAliasFunctions(e){if(e.Shift)return e.Alt?[resolveAltShiftedAlias,resolveUnaltShiftedAlias]:[resolveShiftedAlias,resolveUnshiftedAlias];if(e.Alt)return[resolveAltedAlias,resolveUnaltedAlias];var t=function(e){return[e]};return[t,t]}function isUndefined(e){return void 0===e}var KeyEventState={unseen:0,seen:1,simulated:2},KeyEventStateArrayManager=function(){function e(){_classCallCheck(this,e)}return _createClass(e,null,[{key:"newRecord",value:function(e,t){var n=[KeyEventState.unseen,KeyEventState.unseen,KeyEventState.unseen];if(!isUndefined(e))for(var i=0;i<=e;i++)n[i]=t;return n}},{key:"setBit",value:function(e,t,n){return e[t]=n,e}},{key:"clone",value:function(e){for(var t=this.newRecord(),n=0;n<e.length;n++)t[n]=e[n];return t}}]),e}();function isObject(e){return!Array.isArray(e)&&"object"===_typeof(e)&&null!==e}function isEmpty(e){return isObject(e)?0===Object.keys(e).length:!e||0===e.length}function size(e){return isObject(e)?Object.keys(e).length:e.length}var KeyCombination=function(){function t(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};_classCallCheck(this,t),this._keys=e,this._includesKeyUp=!1,this._update()}return _createClass(t,[{key:"getIds",value:function(){return this._ids}},{key:"getKeyAliases",value:function(){return this._keyAliases}},{key:"getNormalizedKeyName",value:function(e){if(this._keys[e])return e;var t=this._keyAliases[e];return t||e}},{key:"getNumberOfKeys",value:function(){return size(this._keys)}},{key:"any",value:function(){return 0<Object.keys(this._getKeyStates()).length}},{key:"isEnding",value:function(){return this._includesKeyUp}},{key:"hasEnded",value:function(){return isEmpty(this.keysStillPressedDict())}},{key:"addKey",value:function(e,t){this._setKeyState(e,[KeyEventStateArrayManager.newRecord(),KeyEventStateArrayManager.newRecord(KeyEventType.keydown,t)])}},{key:"setKeyState",value:function(e,t,n){var i=this._getKeyState(e);if(this.isKeyIncluded(e)){var o=KeyEventStateArrayManager.clone(i[1]),r=KeyEventStateArrayManager.clone(o);KeyEventStateArrayManager.setBit(r,t,n),this._setKeyState(e,[o,r])}else this.addKey(e,n);t===KeyEventType.keyup&&(this._includesKeyUp=!0)}},{key:"forEachKey",value:function(e){return Object.keys(this._keys).forEach(e)}},{key:"some",value:function(e){return Object.keys(this._keys).some(e)}},{key:"getKeyDictionary",value:function(){return dictionaryFrom(Object.keys(this._getKeyStates()),!0)}},{key:"keysStillPressedDict",value:function(){var n=this;return Object.keys(this._keys).reduce(function(e,t){return n.isKeyStillPressed(t)&&(e[t]=n._getKeyState(t)),e},{})}},{key:"isKeyIncluded",value:function(e){return!!this._getKeyState(e)}},{key:"isKeyStillPressed",value:function(e){return this.isEventTriggered(e,KeyEventType.keypress)&&!this.isKeyReleased(e)}},{key:"isKeyReleased",value:function(e){return this.isEventTriggered(e,KeyEventType.keyup)}},{key:"isEventTriggered",value:function(e,t){return this._getKeyStateType(e,KeyEventSequenceIndex.current,t)}},{key:"wasEventPreviouslyTriggered",value:function(e,t){return this._getKeyStateType(e,KeyEventSequenceIndex.previous,t)}},{key:"isKeyPressSimulated",value:function(e){return this._isKeyEventSimulated(e,KeyEventType.keypress)}},{key:"isKeyUpSimulated",value:function(e){return this._isKeyEventSimulated(e,KeyEventType.keyup)}},{key:"describe",value:function(){return this.getIds()[0]}},{key:"toJSON",value:function(){return{keys:this._getKeyStates(),ids:this.getIds(),keyAliases:this.getKeyAliases()}}},{key:"_getKeyStateType",value:function(e,t,n){var i=this._getKeyState(e);return i&&i[t][n]}},{key:"_update",value:function(){this._ids=KeyCombinationSerializer.serialize(this._keys),this._keyAliases=buildKeyAliases(this._keys)}},{key:"_isKeyEventSimulated",value:function(e,t){return this.isEventTriggered(e,t)===KeyEventState.simulated}},{key:"_getKeyStates",value:function(){return this._keys}},{key:"_getKeyState",value:function(e){var t=this._keys[e];if(t)return t;var n=this._keyAliases[e];return n?this._keys[n]:void 0}},{key:"_setKeyState",value:function(e,t){var n=this.getNormalizedKeyName(e);this._keys[n]=t,this._update()}}]),t}();function buildKeyAliases(e){return Object.keys(e).reduce(function(n,i){return resolveKeyAlias(i).forEach(function(t){applicableAliasFunctions(e).forEach(function(e){e(t).forEach(function(e){e===i&&i===t||(n[e]=i)})})}),n},{})}var KeyHistory=function(){function i(e){var t=e.maxLength,n=1<arguments.length&&void 0!==arguments[1]?arguments[1]:null;_classCallCheck(this,i),this._records=[],this._maxLength=t,n?this._push(n):this._push(new KeyCombination)}return _createClass(i,[{key:"getMostRecentCombinations",value:function(e){return this._records.slice(-e,-1)}},{key:"any",value:function(){return this._records.some(function(e){return e.any()})}},{key:"getLength",value:function(){return this._records.length}},{key:"getCurrentCombination",value:function(){return this._records[this.getLength()-1]}},{key:"addKeyToCurrentCombination",value:function(e,t,n){this._ensureInitialKeyCombination(),this.getCurrentCombination().setKeyState(e,t,n)}},{key:"setMaxLength",value:function(e){this._maxLength=e,this._trimHistory()}},{key:"startNewKeyCombination",value:function(e,t){this._ensureInitialKeyCombination();var n=new KeyCombination(this.getCurrentCombination().keysStillPressedDict());n.addKey(e,t),this._push(n)}},{key:"toJSON",value:function(){return this._records.map(function(e){return e.toJSON()})}},{key:"_ensureInitialKeyCombination",value:function(){0===this.getLength()&&this._push(new KeyCombination)}},{key:"_push",value:function(e){this._trimHistory(),this._records.push(e)}},{key:"_trimHistory",value:function(){for(;this.getLength()>this._maxLength;)this._shift()}},{key:"_shift",value:function(){this._records.shift()}}]),i}(),Registry=function(){function e(){_classCallCheck(this,e),this._registry={}}return _createClass(e,[{key:"get",value:function(e){return this._registry[e]}},{key:"set",value:function(e,t){this._registry[e]=t}},{key:"remove",value:function(e){delete this._registry[e]}},{key:"toJSON",value:function(){return this._registry}}]),e}();function arrayFrom(e){return Array.isArray(e)?e:e?[e]:[]}function without(n){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:[],i=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},o=dictionaryFrom(arrayFrom(e));return Array.isArray(n)?n.reduce(function(e,t){return o[t]&&(i.stringifyFirst||o[t].value===t)||e.push(t),e},[]):isObject(n)?Object.keys(n).reduce(function(e,t){return o[t]||(e[t]=n[t]),e},{}):n}var ComponentTree=function(e){function i(){return _classCallCheck(this,i),_possibleConstructorReturn(this,_getPrototypeOf(i).apply(this,arguments))}return _inherits(i,Registry),_createClass(i,[{key:"add",value:function(e,t){_get(_getPrototypeOf(i.prototype),"set",this).call(this,e,{childIds:[],parentId:null,keyMap:t})}},{key:"update",value:function(e,t){var n=_get(_getPrototypeOf(i.prototype),"get",this).call(this,e);_get(_getPrototypeOf(i.prototype),"set",this).call(this,e,_objectSpread({},n,{keyMap:t}))}},{key:"setParent",value:function(e,t){this.get(e).parentId=t,this._addChildId(t,e)}},{key:"remove",value:function(e){var t=this._getParentId(e);this._removeChildId(t,e),_get(_getPrototypeOf(i.prototype),"remove",this).call(this,e)}},{key:"_getParentId",value:function(e){var t=this.get(e);return t&&t.parentId}},{key:"_addChildId",value:function(e,t){this.get(e).childIds.push(t)}},{key:"_removeChildId",value:function(e,t){var n=this.get(e);n&&(n.childIds=without(n.childIds,t))}}]),i}();function removeAtIndex(e,t){return[].concat(_toConsumableArray(e.slice(0,t)),_toConsumableArray(e.slice(t+1)))}var ComponentOptionsListIterator=function(){function t(e){_classCallCheck(this,t),this._list=e,this._position=-1}return _createClass(t,[{key:"getPosition",value:function(){return this._position}},{key:"getComponent",value:function(){return this._list.getAtPosition(this.getPosition())}},{key:"next",value:function(){return this.getPosition()+1<this._list.getLength()?(this._position++,this.getComponent()):null}}]),t}(),ComponentOptionsList=function(){function e(){_classCallCheck(this,e),this._list=[],this._idToIndex={},this._longestSequence=1,this._longestSequenceComponentId=null,this._keyMapEventRecord=KeyEventStateArrayManager.newRecord()}return _createClass(e,[{key:"getNewIterator",value:function(){return new ComponentOptionsListIterator(this)}},{key:"add",value:function(e,t,n,i){if(this.containsId(e))return this.update(e,t,n,i);var o=this._build(e,t,n,i);this._list.push(o);var r=this._getLastIndex();return this._idToIndex[e]=r}},{key:"containsId",value:function(e){return!!this.get(e)}},{key:"get",value:function(e){return this.getAtPosition(this.getIndexById(e))}},{key:"getIndexById",value:function(e){return this._idToIndex[e]}},{key:"update",value:function(e,t,n,i){var o=this._isUpdatingComponentWithLongestSequence(e),r=this.getLongestSequence(),s=this._build(e,t,n,i);o&&s.sequenceLength!==r&&(s.sequenceLength>r?this._longestSequence=s.sequenceLength:this._recalculateLongestSequence()),this._list[this.getIndexById(e)]=s}},{key:"remove",value:function(e){var t=this._isUpdatingComponentWithLongestSequence(e);this.removeAtPosition(this.getIndexById(e)),t&&this._recalculateLongestSequence()}},{key:"any",value:function(){return 0!==this.getLength()}},{key:"isRoot",value:function(e){return this.getIndexById(e)>=this.getLength()-1}},{key:"getLongestSequence",value:function(){return this._longestSequence}},{key:"anyActionsForEventType",value:function(e){return!!this._keyMapEventRecord[e]}},{key:"getLength",value:function(){return this._list.length}},{key:"getAtPosition",value:function(e){return this._list[e]}},{key:"removeAtPosition",value:function(e){this._list=removeAtIndex(this._list,e);for(var t=e;t<this.getLength();)this._idToIndex[this.getAtPosition(t).componentId]=t,t++}},{key:"toJSON",value:function(){return this._list}},{key:"_getLastIndex",value:function(){return this.getLength()-1}},{key:"_build",value:function(e,t,n,i){var o=this._applyHardSequences(t,n),r=o.keyMap,s=o.handlers;return{actions:this._buildActionDictionary(_objectSpread({},t,r),i,e),handlers:s,componentId:e,options:i}}},{key:"_isUpdatingComponentWithLongestSequence",value:function(e){return e===this._getLongestSequenceComponentId()}},{key:"_getLongestSequenceComponentId",value:function(){return this._longestSequenceComponentId}},{key:"_recalculateLongestSequence",value:function(){for(var e=this.getNewIterator();e.next();){var t=e.getComponent(),n=t.longestSequence,i=t.componentId;n>this.getLongestSequence()&&(this._longestSequenceComponentId=i,this._longestSequence=n)}}},{key:"_applyHardSequences",value:function(n,i){return Configuration.option("enableHardSequences")?Object.keys(i).reduce(function(e,t){return!!!n[t]&&KeyCombinationSerializer.isValidKeySerialization(t)&&(e.keyMap[t]=t),e.handlers[t]=i[t],e},{keyMap:{},handlers:{}}):{keyMap:n,handlers:i}}},{key:"_buildActionDictionary",value:function(t,s,a){var u=this;return Object.keys(t).reduce(function(o,r){var e=t[r];return(isObject(e)&&hasKey(e,"sequences")?arrayFrom(e.sequences):arrayFrom(e)).forEach(function(e){var t=normalizeActionOptions(e,s),n=t.keySequence,i=t.keyEventType;u._addActionOptions(o,a,r,n,i)}),o},{})}},{key:"_addActionOptions",value:function(e,t,n,i,o){var r=KeySequenceParser.parse(i,{keyEventType:o}),s=r.sequence,a=r.combination;s.size>this.getLongestSequence()&&(this._longestSequence=s.size,this._longestSequenceComponentId=t),this._keyMapEventRecord[o]=KeyEventState.seen,e[n]||(e[n]=[]),e[n].push(_objectSpread({prefix:s.prefix,actionName:n,sequenceLength:s.size},a))}}]),e}();function normalizeActionOptions(e,t){if(isObject(e)){var n=e.sequence,i=e.action;return{keySequence:n,keyEventType:isUndefined(i)?KeyEventType[t.defaultKeyEvent]:KeyEventType[i]}}return{keySequence:e,keyEventType:KeyEventType[t.defaultKeyEvent]}}function indexFromEnd(e,t){return e[e.length-(t+1)]}for(var KeysWithKeyUpHiddenByCmd={Enter:!0,Backspace:!0,ArrowRight:!0,ArrowLeft:!0,ArrowUp:!0,ArrowDown:!0,CapsLock:!0},i=1;i<13;i++)KeysWithKeyUpHiddenByCmd["F".concat(i)]=!0;function keyupIsHiddenByCmd(e){return 1===e.length||hasKey(KeysWithKeyUpHiddenByCmd,e)}var KeyCombinationMatcher=function(){function e(){_classCallCheck(this,e),this._actionConfigs={},this._order=null}return _createClass(e,[{key:"addMatch",value:function(e,t){if(this._includesMatcherForCombination(e.id)){var n=e.keyEventType,i=e.actionName,o=e.id;this._addHandlerToActionConfig(o,{keyEventType:n,actionName:i,handler:t})}else this._addNewActionConfig(e,t)}},{key:"findMatch",value:function(e,t,n){this._order||this._setOrder();var i=!0,o=!1,r=void 0;try{for(var s,a=this._order[Symbol.iterator]();!(i=(s=a.next()).done);i=!0){var u=s.value,l=this._actionConfigs[u];if(this._matchesActionConfig(e,t,n,l))return l}}catch(e){o=!0,r=e}finally{try{i||null==a.return||a.return()}finally{if(o)throw r}}return null}},{key:"toJSON",value:function(){return{actionConfigs:this._actionConfigs,order:this._order}}},{key:"_matchesActionConfig",value:function(t,n,i,e){if(!canBeMatched(t,e))return!1;if(!e.events[i])return!1;var o=!1;return Object.keys(e.keyDictionary).every(function(e){return!!t.isEventTriggered(e,i)&&(n&&n===t.getNormalizedKeyName(e)&&(o=!t.wasEventPreviouslyTriggered(e,i)),!0)})&&o}},{key:"_setOrder",value:function(){var n=Object.values(this._actionConfigs).reduce(function(e,t){var n=t.id,i=t.size;return e[i]||(e[i]=[]),e[i].push(n),e},{});this._order=Object.keys(n).sort(function(e,t){return t-e}).reduce(function(e,t){return e.concat(n[t])},[])}},{key:"_addNewActionConfig",value:function(e,t){var n=e.prefix,i=e.sequenceLength,o=e.id,r=e.keyDictionary,s=e.size,a=e.keyEventType,u=e.actionName;this._setCombinationMatcher(o,{prefix:n,sequenceLength:i,id:o,keyDictionary:r,size:s,events:{}}),this._addHandlerToActionConfig(o,{keyEventType:a,actionName:u,handler:t})}},{key:"_addHandlerToActionConfig",value:function(e,t){var n=t.keyEventType,i=t.actionName,o=t.handler,r=this._getCombinationMatcher(e);this._setCombinationMatcher(e,_objectSpread({},r,{events:_objectSpread({},r.events,_defineProperty({},n,{actionName:i,handler:o}))}))}},{key:"_setCombinationMatcher",value:function(e,t){this._actionConfigs[e]=t}},{key:"_getCombinationMatcher",value:function(e){return this._actionConfigs[e]}},{key:"_includesMatcherForCombination",value:function(e){return!!this._getCombinationMatcher(e)}}]),e}();function canBeMatched(e,t){var n=size(t.keyDictionary);return Configuration.option("allowCombinationSubmatches")||keyUpIsBeingHidden(e)?e.getNumberOfKeys()>=n:e.getNumberOfKeys()===n}function keyUpIsBeingHidden(e){return!!e.isKeyStillPressed("Meta")&&e.some(function(e){return keyupIsHiddenByCmd(e)})}var KeyHistoryMatcher=function(){function e(){_classCallCheck(this,e),this._combinationMatchers={},this._eventRecord=KeyEventStateArrayManager.newRecord()}return _createClass(e,[{key:"addMatch",value:function(e,t){this._getOrCreateCombinationMatcher(e.prefix).addMatch(e,t),KeyEventStateArrayManager.setBit(this._eventRecord,e.keyEventType,KeyEventState.seen),(!this._longestSequence||this._longestSequence<e.sequenceLength)&&(this._longestSequence=e.sequenceLength)}},{key:"findMatch",value:function(e,t,n){var i=this._findCombinationMatcher(e);return i?i.findMatch(e.getCurrentCombination(),e.getCurrentCombination().getNormalizedKeyName(t),n):null}},{key:"hasMatchesForEventType",value:function(e){return!!this._eventRecord[e]}},{key:"getLongestSequence",value:function(){return this._longestSequence}},{key:"toJSON",value:function(){var i=this;return Object.keys(this._combinationMatchers).reduce(function(e,t){var n=i._combinationMatchers[t];return e[t]=n.toJSON(),e},{})}},{key:"_getOrCreateCombinationMatcher",value:function(e){return this._combinationMatchers[e]||(this._combinationMatchers[e]=new KeyCombinationMatcher),this._combinationMatchers[e]}},{key:"_findCombinationMatcher",value:function(e){var t=e.getMostRecentCombinations(this.getLongestSequence());if(0===t.length)return this._combinationMatchers[""];for(var n=t.map(function(e){return e.getIds()}),i=n.map(function(e){return e.length}),o=new Array(n.length).fill(0),r=!1;!r;){var s=o.map(function(e,t){return n[t][e]}).join(" ");if(this._combinationMatchers[s])return this._combinationMatchers[s];for(var a=0,u=!0;u&&a<o.length;){var l=(indexFromEnd(o,a)+1)%(indexFromEnd(i,a)||1);(u=0===(o[o.length-(a+1)]=l))&&a++}r=a===o.length}}}]),e}(),ActionResolver=function(){function i(e){_classCallCheck(this,i),this._keyMapMatchers=[],this._unmatchedHandlerStatus=[],this._handlersDictionary={},this._keySequencesDictionary={};for(var t=e.getNewIterator();t.next();){var n=t.getComponent().handlers;this._unmatchedHandlerStatus.push([Object.keys(n).length,{}]),this._keyMapMatchers.push(new KeyHistoryMatcher)}this._componentList=e,this._componentListIterator=e.getNewIterator()}return _createClass(i,[{key:"getKeyHistoryMatcher",value:function(e){if(this._componentHasUnmatchedHandlers(e))for(;this._componentListIterator.next();)this._addHandlersFromComponent(),this._addActionsFromComponent();return this._getKeyHistoryMatcher(e)}},{key:"componentHasActionsBoundToEventType",value:function(e,t){return this.getKeyHistoryMatcher(e).hasMatchesForEventType(t)}},{key:"findMatchingKeySequenceInComponent",value:function(e,t,n,i){return this.componentHasActionsBoundToEventType(e,i)?this.getKeyHistoryMatcher(e).findMatch(t,n,i):null}},{key:"_getKeyHistoryMatcher",value:function(e){return this._keyMapMatchers[e]}},{key:"_addActionsFromComponent",value:function(){var s=this,t=this._componentListIterator.getComponent().actions;Object.keys(t).forEach(function(n){var e=s._getHandlers(n);if(e){var i=e[0],o=s._componentList.getAtPosition(i).handlers[n],r=s._getKeyHistoryMatcher(i);t[n].forEach(function(e){var t=[e.prefix,e.id].join(" ");s._isClosestHandlerFound(t,e)||(r.addMatch(e,o),s._addKeySequence(t,[i,e.keyEventType]))}),e.forEach(function(e){var t=s._getUnmatchedHandlerStatus(e);t[1][n]||(t[1][n]=!0,t[0]--)})}})}},{key:"_getHandlers",value:function(e){return this._handlersDictionary[e]}},{key:"_addHandlersFromComponent",value:function(){var t=this,e=this._componentListIterator.getComponent().handlers;Object.keys(e).forEach(function(e){t._addHandler(e)})}},{key:"_addHandler",value:function(e){this._handlersDictionary[e]||(this._handlersDictionary[e]=[]),this._handlersDictionary[e].push(this._componentListIterator.getPosition())}},{key:"_addKeySequence",value:function(e,t){this._keySequencesDictionary[e]||(this._keySequencesDictionary[e]=[]),this._keySequencesDictionary[e].push(t)}},{key:"_componentHasUnmatchedHandlers",value:function(e){return 0<this._getUnmatchedHandlerStatus(e)[0]}},{key:"_getUnmatchedHandlerStatus",value:function(e){return this._unmatchedHandlerStatus[e]}},{key:"_isClosestHandlerFound",value:function(e,t){return this._keySequencesDictionary[e]&&this._keySequencesDictionary[e].some(function(e){return e[1]===t.keyEventType})}}]),i}();function copyAttributes(t,n,e){return e.forEach(function(e){hasKey(t,e)&&(n[e]=t[e])}),n}function describeKeyEventType(e){switch(parseInt(e,10)){case 0:return"keydown";case 1:return"keypress";default:return"keyup"}}function hasKeyPressEvent(e){return!isNonPrintableKeyName(e)}function stateFromEvent(e){return e.simulated?KeyEventState.simulated:KeyEventState.seen}var SEQUENCE_ATTRIBUTES=["sequence","action"],KEYMAP_ATTRIBUTES=["name","description","group"],AbstractKeyEventStrategy=function(){function n(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},t=1<arguments.length?arguments[1]:void 0;_classCallCheck(this,n),this.logger=e.logger||new Logger("warn"),this.componentId=-1,this.keyEventManager=t,this._componentTree=new ComponentTree,this.rootComponentId=null,this._reset(),this.resetKeyHistory()}return _createClass(n,[{key:"_reset",value:function(){this.componentList=new ComponentOptionsList,this._initHandlerResolutionState()}},{key:"_newKeyHistory",value:function(){return new KeyHistory({maxLength:this.componentList.getLongestSequence()})}},{key:"getKeyHistory",value:function(){return this._keyHistory||(this._keyHistory=this._newKeyHistory()),this._keyHistory}},{key:"_initHandlerResolutionState",value:function(){this._actionResolver=null}},{key:"resetKeyHistory",value:function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};this.keypressEventsToSimulate=[],this.keyupEventsToSimulate=[],this.getKeyHistory().any()&&!e.force?this._keyHistory=new KeyHistory({maxLength:this.componentList.getLongestSequence()},new KeyCombination(this.getCurrentCombination().keysStillPressedDict())):this._keyHistory=this._newKeyHistory()}},{key:"getApplicationKeyMap",value:function(){return null===this.rootComponentId?{}:this._buildApplicationKeyMap([this.rootComponentId],{})}},{key:"_buildApplicationKeyMap",value:function(e,o){var r=this;return e.forEach(function(e){var t=r._componentTree.get(e),n=t.childIds,i=t.keyMap;i&&Object.keys(i).forEach(function(e){var t=i[e];o[e]={},isObject(t)?hasKey(t,"sequences")?(copyAttributes(t,o[e],KEYMAP_ATTRIBUTES),o[e].sequences=r._createSequenceFromConfig(t.sequences)):(copyAttributes(t,o[e],KEYMAP_ATTRIBUTES),o[e].sequences=[copyAttributes(t,{},SEQUENCE_ATTRIBUTES)]):o[e].sequences=r._createSequenceFromConfig(t)}),r._buildApplicationKeyMap(n,o)}),o}},{key:"_createSequenceFromConfig",value:function(e){return arrayFrom(e).map(function(e){return isObject(e)?copyAttributes(e,{},SEQUENCE_ATTRIBUTES):{sequence:e}})}},{key:"registerKeyMap",value:function(e){return this.componentId+=1,this._componentTree.add(this.componentId,e),this.componentId}},{key:"reregisterKeyMap",value:function(e,t){this._componentTree.update(e,t)}},{key:"registerComponentMount",value:function(e,t){isUndefined(t)?this.rootComponentId=e:this._componentTree.setParent(e,t)}},{key:"deregisterKeyMap",value:function(e){this._componentTree.remove(e),e===this.rootComponentId&&(this.rootComponentId=null)}},{key:"_addComponent",value:function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},i=3<arguments.length?arguments[3]:void 0;this.componentList.add(e,t,n,i),this.getKeyHistory().setMaxLength(this.componentList.getLongestSequence())}},{key:"_allKeysAreReleased",value:function(){return this.getCurrentCombination().hasEnded()}},{key:"getCurrentCombination",value:function(){return this.getKeyHistory().getCurrentCombination()}},{key:"_shouldSimulate",value:function(e,t){var n=hasKeyPressEvent(t),i=this.getCurrentCombination();return e===KeyEventType.keypress?!n||n&&i.isKeyStillPressed("Meta"):e===KeyEventType.keyup&&(keyupIsHiddenByCmd(t)&&i.isKeyReleased("Meta"))}},{key:"_cloneAndMergeEvent",value:function(n,e){return _objectSpread({},Object.keys(ModifierFlagsDictionary).reduce(function(e,t){return e[t]=n[t],e},{}),e)}},{key:"_callClosestMatchingHandler",value:function(e,t,n,i,o){for(this._actionResolver||(this._actionResolver=new ActionResolver(this.componentList));o<=i;){this._actionResolver.getKeyHistoryMatcher(o);var r=this._actionResolver.findMatchingKeySequenceInComponent(o,this.getKeyHistory(),t,n);this.getCurrentCombination();if(r){var s=r.events[n];if(Configuration.option("allowCombinationSubmatches"))KeyCombinationSerializer.serialize(r.keyDictionary);return s.handler(e),this._stopEventPropagationAfterHandlingIfEnabled(e,o),!0}this._actionResolver.componentHasActionsBoundToEventType(o,n),o++}}},{key:"_stopEventPropagationAfterHandlingIfEnabled",value:function(e,t){return!!Configuration.option("stopEventPropagationAfterHandling")&&(this._stopEventPropagation(e,t),!0)}},{key:"_stopEventPropagation",value:function(e,t){throw new Error("_stopEventPropagation must be overridden by a subclass")}},{key:"_checkForModifierFlagDiscrepancies",value:function(o,e,r){var s=this;Object.keys(ModifierFlagsDictionary).forEach(function(t){if(e!==t||r!==KeyEventType.keyup){var n=s.getCurrentCombination(),i=n.isKeyStillPressed(t);ModifierFlagsDictionary[t].forEach(function(e){!1===o[e]&&i&&n.setKeyState(t,KeyEventType.keyup,stateFromEvent(o))})}})}},{key:"_logPrefix",value:function(){}}]),n}(),KeyEventCounter=function(){function e(){_classCallCheck(this,e)}return _createClass(e,null,[{key:"getId",value:function(){return isUndefined(this._id)&&(this._id=0),this._id}},{key:"incrementId",value:function(){this._id=this.getId()+1}}]),e}();function getEventCharCode(e){var t,n=e.keyCode;return"charCode"in e?0===(t=e.charCode)&&13===n&&(t=13):t=n,10===t&&(t=13),32<=t||13===t?t:0}var normalizeKey={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"};function reactsGetEventKey(e){if(e.key){var t=normalizeKey[e.key]||e.key;if("Unidentified"!==t)return t}if("keypress"!==e.type)return"keydown"===e.type||"keyup"===e.type?translateToKey[e.keyCode]||"Unidentified":"";var n=getEventCharCode(e);return 13===n?"Enter":String.fromCharCode(n)}function getKeyName(e){var t,n,i=(t=Configuration.option("customKeyCodes"),n=e.keyCode||e.charCode,hasKey(t,n)?t[n]:e.nativeEvent?e.key:reactsGetEventKey(e));return"+"===i?"plus":i}function isCmdKey(e){return"Meta"===e}var EventResponse={unseen:0,ignored:1,seen:2,recorded:3,handled:4},EventPropagator=function(){function o(e,t){var n=t.logger,i=t.logPrefix;_classCallCheck(this,o),this._componentList=e,this._previousPropagation=null,this.logger=n,this._logPrefix=i,this._reset()}return _createClass(o,[{key:"_reset",value:function(){this._previousPosition=-1,this._position=-1,this._actionHandled=!1,this._ignoreEvent=!1,this._observeIgnoredEvents=!1,this._stopping=!1,this._componentId=null,this._key=null,this._type=null}},{key:"isFirstPropagationStep",value:function(){var e=this.getPreviousPosition();return-1===e||e>=this._position}},{key:"isForKey",value:function(e){return this._key===e}},{key:"isForEventType",value:function(e){return this._type===e}},{key:"startNewPropagationStep",value:function(e,t,n,i){return this._position=this._componentList.getIndexById(e),this._componentId=e,this.isFirstPropagationStep()&&(KeyEventCounter.incrementId(),this._key=t.key,this._type=i),!t.repeat||!Configuration.option("ignoreRepeatedEventsWhenKeyHeldDown")||(this.ignoreEvent(t),!1)}},{key:"finishPropagationStep",value:function(){this.isStopped()||this._componentList.isRoot(this._componentId)?(this._previousPropagation=this._clone(),this._reset()):this._previousPosition=this._position}},{key:"getPreviousPropagation",value:function(){return this._previousPropagation||(this._previousPropagation=this._clone({copyState:!1})),this._previousPropagation}},{key:"getPreviousPosition",value:function(){return this._previousPosition}},{key:"observeIgnoredEvents",value:function(){this._observeIgnoredEvents=!0}},{key:"ignoreEvent",value:function(e){return this.setIgnoreEvent(!0),!(!this.isIgnoringEvent()||!Configuration.option("stopEventPropagationAfterIgnoring"))&&(this.stop(e),this.finishPropagationStep(),!0)}},{key:"setIgnoreEvent",value:function(e){this._ignoreEvent=e}},{key:"isIgnoringEvent",value:function(){return!this._observeIgnoredEvents&&this._ignoreEvent}},{key:"isStopped",value:function(){return this._stopping}},{key:"stop",value:function(e){return!this.isStopped()&&(this._stopping=!0,e.simulated||e.stopPropagation(),!0)}},{key:"isPendingPropagation",value:function(){var e=this.getPreviousPosition();return-1!==e&&e+1<this._position}},{key:"isHandled",value:function(){return this._actionHandled}},{key:"setHandled",value:function(){this._actionHandled=!0}},{key:"_clone",value:function(){var e=(0<arguments.length&&void 0!==arguments[0]?arguments[0]:{}).copyState,t=void 0===e||e,n=new o(this._componentList,{logger:this.logger,logPrefix:this._logPrefix});return t&&Object.assign(n,this),n}}]),o}(),FocusOnlyKeyEventStrategy=function(e){function i(){var e,t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},n=1<arguments.length?arguments[1]:void 0;return _classCallCheck(this,i),(e=_possibleConstructorReturn(this,_getPrototypeOf(i).call(this,t,n))).focusTreeId=0,e}return _inherits(i,AbstractKeyEventStrategy),_createClass(i,[{key:"_reset",value:function(){_get(_getPrototypeOf(i.prototype),"_reset",this).call(this),this.keypressEventsToSimulate=[],this.focusTreeId+=1,this.eventPropagator=new EventPropagator(this.componentList,{logger:this.logger,logPrefix:this._logPrefix.bind(this)})}},{key:"enableHotKeys",value:function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},i=3<arguments.length?arguments[3]:void 0;if(this.resetOnNextFocus&&(this._reset(),this.resetOnNextFocus=!1),!this.componentList.containsId(e))return this._addComponent(e,t,n,i),this.focusTreeId}},{key:"updateEnabledHotKeys",value:function(e,t){var n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},i=3<arguments.length&&void 0!==arguments[3]?arguments[3]:{},o=4<arguments.length?arguments[4]:void 0;e===this.focusTreeId&&this.componentList.containsId(t)&&(this.componentList.update(t,n,i,o),this.getKeyHistory().setMaxLength(this.componentList.getLongestSequence()),this._initHandlerResolutionState())}},{key:"disableHotKeys",value:function(e,t){return this.resetOnNextFocus||(this.resetOnNextFocus=!0),this.eventPropagator.isPendingPropagation()}},{key:"handleKeydown",value:function(e,t,n){var i=3<arguments.length&&void 0!==arguments[3]?arguments[3]:{},o=getKeyName(e);if(t!==this.focusTreeId)return this.eventPropagator.ignoreEvent(e),!0;if(this.eventPropagator.startNewPropagationStep(n,e,o,KeyEventType.keydown)){if(this._howToHandleKeyEvent(e,t,n,o,i,KeyEventType.keydown)===EventResponse.handled){var r=stateFromEvent(e),s=this.getCurrentCombination();s.isKeyIncluded(o)||s.isEnding()?this._startAndLogNewKeyCombination(o,t,n,r):this._addToAndLogCurrentKeyCombination(o,KeyEventType.keydown,t,n,r),this._callHandlerIfActionNotHandled(e,o,KeyEventType.keydown,n,t)}return this._simulateKeyPressForNonPrintableKeys(e,o,t,n,i),this.eventPropagator.finishPropagationStep(),!1}}},{key:"_howToHandleKeyEvent",value:function(e,t,n,i,o,r){if(this.eventPropagator.isFirstPropagationStep()){if(o.ignoreEventsCondition(e)&&this.eventPropagator.ignoreEvent(e))return this._eventIsToBeIgnored(e,n,i,r);this._checkForModifierFlagDiscrepancies(e,i,r)}else if(this.eventPropagator.isIgnoringEvent())return this._eventIsToBeIgnored(e,n,i,r);return EventResponse.handled}},{key:"_eventIsToBeIgnored",value:function(e,t,n,i){return EventResponse.ignored}},{key:"handleKeyPress",value:function(e,t,n,i){var o=getKeyName(e),r=this.getCurrentCombination();if(r.isKeyPressSimulated(o))return this.eventPropagator.ignoreEvent(e),!0;if(this.eventPropagator.startNewPropagationStep(n,e,o,KeyEventType.keypress)){var s=t!==this.focusTreeId,a=this._howToHandleKeyEvent(e,t,n,o,i,KeyEventType.keypress);return this.eventPropagator.isFirstPropagationStep(n)&&r.isKeyIncluded(o)&&this._addToAndLogCurrentKeyCombination(o,KeyEventType.keypress,t,n,stateFromEvent(e)),a===EventResponse.handled&&this._callHandlerIfActionNotHandled(e,o,KeyEventType.keypress,n,t),this.eventPropagator.finishPropagationStep(),s}}},{key:"handleKeyUp",value:function(e,t,n,i){var o=getKeyName(e),r=this.getCurrentCombination();if(r.isKeyUpSimulated(o))return this.eventPropagator.ignoreEvent(e),!0;if(this.eventPropagator.startNewPropagationStep(n,e,o,KeyEventType.keyup)){var s=t!==this.focusTreeId,a=this._howToHandleKeyEvent(e,t,n,o,i,KeyEventType.keyup);return this.eventPropagator.isFirstPropagationStep(n)&&r.isKeyIncluded(o)&&this._addToAndLogCurrentKeyCombination(o,KeyEventType.keyup,t,n,stateFromEvent(e)),a===EventResponse.handled&&this._callHandlerIfActionNotHandled(e,o,KeyEventType.keyup,n,t),this._simulateKeyUpEventsHiddenByCmd(e,o,t,n,i),this.eventPropagator.finishPropagationStep(),s}}},{key:"closeHangingKeyCombination",value:function(e,t){var n=this.getCurrentCombination();n.isKeyIncluded(e)&&!n.isEventTriggered(e,t)&&n.setKeyState(e,t,KeyEventState.simulated)}},{key:"_simulateKeyPressForNonPrintableKeys",value:function(e,t,n,i,o){this._handleEventSimulation("keypressEventsToSimulate","simulatePendingKeyPressEvents",this._shouldSimulate(KeyEventType.keypress,t),{event:e,key:t,focusTreeId:n,componentId:i,options:o})}},{key:"_simulateKeyUpEventsHiddenByCmd",value:function(t,e,n,i,o){var r=this;isCmdKey(e)&&this.getCurrentCombination().forEachKey(function(e){isCmdKey(e)||r._handleEventSimulation("keyupEventsToSimulate","simulatePendingKeyUpEvents",r._shouldSimulate(KeyEventType.keyup,e),{event:t,key:e,focusTreeId:n,componentId:i,options:o})})}},{key:"_stopEventPropagation",value:function(e,t){this.eventPropagator.stop(e)}},{key:"getEventPropagator",value:function(){return this.eventPropagator}},{key:"_startAndLogNewKeyCombination",value:function(e,t,n,i){this.getKeyHistory().startNewKeyCombination(e,i)}},{key:"_addToAndLogCurrentKeyCombination",value:function(e,t,n,i,o){this.getKeyHistory().addKeyToCurrentCombination(e,t,o)}},{key:"_handleEventSimulation",value:function(e,t,n,i){var o=i.event,r=i.key,s=i.focusTreeId,a=i.componentId,u=i.options;if(n&&Configuration.option("simulateMissingKeyPressEvents")){var l=this._cloneAndMergeEvent(o,{key:r,simulated:!0});this[e].push({event:l,focusTreeId:s,componentId:a,options:u})}(this.componentList.isRoot(a)||this.eventPropagator.isStopped())&&(this.keyEventManager.isGlobalListenersBound()||this[t]())}},{key:"simulatePendingKeyPressEvents",value:function(){this._simulatePendingKeyEvents("keypressEventsToSimulate","handleKeyPress")}},{key:"simulatePendingKeyUpEvents",value:function(){this._simulatePendingKeyEvents("keyupEventsToSimulate","handleKeyUp")}},{key:"_simulatePendingKeyEvents",value:function(e,r){var s=this;0<this[e].length&&KeyEventCounter.incrementId(),this[e].forEach(function(e){var t=e.event,n=e.focusTreeId,i=e.componentId,o=e.options;s[r](t,n,i,o)}),this[e]=[]}},{key:"_callHandlerIfActionNotHandled",value:function(e,t,n,i,o){this.getCurrentCombination().describe();if(this.componentList.anyActionsForEventType(n))if(this.eventPropagator.isHandled());else{var r=this.eventPropagator.getPreviousPosition(),s=this.componentList.getIndexById(i);this._callClosestMatchingHandler(e,t,n,s,-1===r?0:r)&&this.eventPropagator.setHandled()}}},{key:"_logPrefix",value:function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},n=Logger.logIcons,i=Logger.eventIcons,o=Logger.componentIcons,r="HotKeys (";if(!1!==t.focusTreeId){var s=isUndefined(t.focusTreeId)?this.focusTreeId:t.focusTreeId;r+="F".concat(s).concat(n[s%n.length],"-")}if(!1!==t.eventId){var a=isUndefined(t.eventId)?KeyEventCounter.getId():t.eventId;r+="E".concat(a).concat(i[a%i.length],"-")}r+="C".concat(e).concat(o[e%o.length]);var u=this.componentList.getIndexById(e);return isUndefined(u)||(r+="-P".concat(u).concat(o[u%o.length],":")),"".concat(r,")")}}]),i}();function contains(e,t){var n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{};return Array.isArray(e)||isString(e)?n.stringifyFirst?!isUndefined(e.find(function(e){return e.toString()===t.toString()})):-1!==e.indexOf(t):isObject(e)?hasKey(e,t):n.stringifyFirst?e.toString()===t.toString():e===t}function capitalize(e){return e.replace(/\b\w/g,function(e){return e.toUpperCase()})}function normalizeEventName(e){return"".concat(capitalize(e.slice(0,3))).concat(capitalize(e.slice(3)))}var GlobalKeyEventStrategy=function(e){function o(){var e,t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},n=1<arguments.length?arguments[1]:void 0;return _classCallCheck(this,o),(e=_possibleConstructorReturn(this,_getPrototypeOf(o).call(this,t,n))).listenersBound=!1,e.eventOptions={ignoreEventsCondition:Configuration.option("ignoreEventsCondition")},e.listeners={},e}return _inherits(o,AbstractKeyEventStrategy),_createClass(o,[{key:"enableHotKeys",value:function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},i=3<arguments.length?arguments[3]:void 0,o=4<arguments.length?arguments[4]:void 0;this.eventOptions=o,this._addComponent(e,t,n,i),this._updateDocumentHandlers(),this._initHandlerResolutionState()}},{key:"updateEnabledHotKeys",value:function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},i=3<arguments.length?arguments[3]:void 0,o=4<arguments.length?arguments[4]:void 0;this.eventOptions=o,this.componentList.update(e,t,n,i),this.getKeyHistory().setMaxLength(this.componentList.getLongestSequence()),this._updateDocumentHandlers(),this._initHandlerResolutionState()}},{key:"disableHotKeys",value:function(e){this.componentList.remove(e),this.getKeyHistory().setMaxLength(this.componentList.getLongestSequence()),this._updateDocumentHandlers(),this._initHandlerResolutionState()}},{key:"_updateDocumentHandlers",value:function(){var n=this,e=this._listenersShouldBeBound();!this.listenersBound&&e?(Object.values(KeyEventType).forEach(function(e){var t=describeKeyEventType(e);document["on".concat(t)]=function(e){n.keyEventManager["handleGlobal".concat(normalizeEventName(t))](e)}}),this.listenersBound=!0):this.listenersBound&&!e&&(Object.values(KeyEventType).forEach(function(e){var t=describeKeyEventType(e);delete document["on".concat(t)]}),this.listenersBound=!1)}},{key:"_listenersShouldBeBound",value:function(){return this.componentList.any()||this.listeners.keyCombination}},{key:"handleKeydown",value:function(e){var t=getKeyName(e);if(e.repeat&&Configuration.option("ignoreRepeatedEventsWhenKeyHeldDown"))return!0;this._checkForModifierFlagDiscrepancies(e,t,KeyEventType.keydown);var n=this._howReactAppRespondedTo(e,t,KeyEventType.keydown);if(n!==EventResponse.unseen||!this.eventOptions.ignoreEventsCondition(e)){if(n!==EventResponse.ignored){var i=stateFromEvent(e),o=this.getCurrentCombination();o.isKeyIncluded(t)||o.isEnding()?this._startAndLogNewKeyCombination(t,i):this._addToAndLogCurrentKeyCombination(t,KeyEventType.keydown,i)}contains([EventResponse.ignored,EventResponse.handled],n)||this._callHandlerIfExists(e,t,KeyEventType.keydown),this._simulateKeyPressForNonPrintableKeys(e,t)}}},{key:"_howReactAppRespondedTo",value:function(e,t,n){var i=this.keyEventManager.reactAppHistoryWithEvent(t,n);switch(i){case EventResponse.handled:case EventResponse.ignored:case EventResponse.seen:break;default:KeyEventCounter.incrementId()}return i}},{key:"handleKeyPress",value:function(e){var t=getKeyName(e);if(e.repeat&&Configuration.option("ignoreRepeatedEventsWhenKeyHeldDown"))return!0;var n=this.getCurrentCombination();if(n.isKeyPressSimulated(t))return!0;var i=this._howReactAppRespondedTo(e,t,KeyEventType.keypress);n.isKeyIncluded(t)&&this._addToAndLogCurrentKeyCombination(t,KeyEventType.keypress,stateFromEvent(e)),i===EventResponse.unseen&&(this.keyEventManager.closeHangingKeyCombination(t,KeyEventType.keypress),this.eventOptions.ignoreEventsCondition(e))||contains([EventResponse.ignored,EventResponse.handled],i)||this._callHandlerIfExists(e,t,KeyEventType.keypress)}},{key:"handleKeyUp",value:function(e){var t=getKeyName(e),n=this.getCurrentCombination();if(n.isKeyUpSimulated(t))return!0;var i=this._howReactAppRespondedTo(e,t,KeyEventType.keyup);n.isKeyIncluded(t)&&this._addToAndLogCurrentKeyCombination(t,KeyEventType.keyup,stateFromEvent(e)),i===EventResponse.unseen?(this.keyEventManager.closeHangingKeyCombination(t,KeyEventType.keyup),this.eventOptions.ignoreEventsCondition(e)||contains([EventResponse.ignored,EventResponse.handled],i)||this._callHandlerIfExists(e,t,KeyEventType.keyup)):contains([EventResponse.ignored,EventResponse.handled],i)||this._callHandlerIfExists(e,t,KeyEventType.keyup),this._simulateKeyUpEventsHiddenByCmd(e,t),this.listeners.keyCombination&&this._allKeysAreReleased()&&this.listeners.keyCombination({keys:n.getKeyDictionary(),id:n.describe()})}},{key:"_simulateKeyPressForNonPrintableKeys",value:function(e,t){this.keyEventManager.simulatePendingKeyPressEvents(),this._handleEventSimulation("handleKeyPress",this._shouldSimulate(KeyEventType.keypress,t),{event:e,key:t})}},{key:"_simulateKeyUpEventsHiddenByCmd",value:function(t,e){var n=this;isCmdKey(e)&&(this.keyEventManager.simulatePendingKeyUpEvents(),this.getCurrentCombination().forEachKey(function(e){isCmdKey(e)||n._handleEventSimulation("handleKeyUp",n._shouldSimulate(KeyEventType.keyup,e),{event:t,key:e})}))}},{key:"_startAndLogNewKeyCombination",value:function(e,t){this.getKeyHistory().startNewKeyCombination(e,t)}},{key:"_addToAndLogCurrentKeyCombination",value:function(e,t,n){this.getKeyHistory().addKeyToCurrentCombination(e,t,n)}},{key:"_handleEventSimulation",value:function(e,t,n){var i=n.event,o=n.key;if(t&&Configuration.option("simulateMissingKeyPressEvents")){var r=this._cloneAndMergeEvent(i,{key:o,simulated:!0});this[e](r)}}},{key:"_callHandlerIfExists",value:function(e,t,n){this.getCurrentCombination().describe();this.componentList.anyActionsForEventType(n)&&this._callClosestMatchingHandler(e,t,n)}},{key:"_callClosestMatchingHandler",value:function(e,t,n){for(var i=this.componentList.getNewIterator();i.next();){if(_get(_getPrototypeOf(o.prototype),"_callClosestMatchingHandler",this).call(this,e,t,n,i.getPosition(),0))return}}},{key:"_stopEventPropagation",value:function(e,t){e.simulated||e.stopPropagation()}},{key:"addKeyCombinationListener",value:function(t){var e=this,n=function(){delete e.listeners.keyCombination};return this.listeners.keyCombination=function(e){t(e),n()},this._updateDocumentHandlers(),n}},{key:"_logPrefix",value:function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},n=Logger.eventIcons,i=Logger.componentIcons,o="HotKeys (GLOBAL";if(!1!==t.eventId){var r=isUndefined(t.eventId)?KeyEventCounter.getId():t.eventId;o="".concat(o,"-E").concat(r).concat(n[r%n.length])}return isUndefined(e)?"".concat(o,"):"):"".concat(o,"-C").concat(e).concat(i[e%i.length],"):")}}]),o}();function isFromFocusOnlyComponent(e){return!isUndefined(e)}var KeyEventManager=function(){function t(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};_classCallCheck(this,t),this.logger=e.logger||new Logger(Configuration.option("logLevel")),this._focusOnlyEventStrategy=new FocusOnlyKeyEventStrategy({configuration:e,logger:this.logger},this),this._globalEventStrategy=new GlobalKeyEventStrategy({configuration:e,logger:this.logger},this),this.mountedComponentsCount=0}return _createClass(t,null,[{key:"getInstance",value:function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};return this.instance||(this.instance=new t(e)),this.instance}},{key:"clear",value:function(){delete this.instance}}]),_createClass(t,[{key:"getApplicationKeyMap",value:function(){return Object.assign(this._globalEventStrategy.getApplicationKeyMap(),this._focusOnlyEventStrategy.getApplicationKeyMap())}},{key:"registerKeyMap",value:function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};return this._focusOnlyEventStrategy.registerKeyMap(e)}},{key:"reregisterKeyMap",value:function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};this._focusOnlyEventStrategy.reregisterKeyMap(e,t)}},{key:"deregisterKeyMap",value:function(e){this._focusOnlyEventStrategy.deregisterKeyMap(e)}},{key:"registerComponentMount",value:function(e,t){return this._incrementComponentCount(),this._focusOnlyEventStrategy.registerComponentMount(e,t)}},{key:"registerComponentUnmount",value:function(){this._decrementComponentCount()}},{key:"_incrementComponentCount",value:function(){var e=this,t=this.mountedComponentsCount;this.mountedComponentsCount+=1,0===t&&1===this.mountedComponentsCount&&(window.onblur=function(){return e._clearKeyHistory()})}},{key:"_decrementComponentCount",value:function(){var e=this.mountedComponentsCount;this.mountedComponentsCount-=1,1===e&&0===this.mountedComponentsCount&&delete window.onblur}},{key:"_clearKeyHistory",value:function(){this._focusOnlyEventStrategy.resetKeyHistory({force:!0}),this._globalEventStrategy.resetKeyHistory({force:!0})}},{key:"registerGlobalKeyMap",value:function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};return this._globalEventStrategy.registerKeyMap(e)}},{key:"registerGlobalComponentUnmount",value:function(){this._decrementComponentCount()}},{key:"registerGlobalComponentMount",value:function(e,t){return this._incrementComponentCount(),this._globalEventStrategy.registerComponentMount(e,t)}},{key:"reregisterGlobalKeyMap",value:function(e,t){this._globalEventStrategy.reregisterKeyMap(e,t)}},{key:"deregisterGlobalKeyMap",value:function(e){this._globalEventStrategy.deregisterKeyMap(e)}},{key:"addKeyCombinationListener",value:function(e){return this._globalEventStrategy.addKeyCombinationListener(e)}},{key:"enableHotKeys",value:function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},i=3<arguments.length?arguments[3]:void 0;return this._focusOnlyEventStrategy.enableHotKeys(e,t,n,i)}},{key:"updateEnabledHotKeys",value:function(e,t){var n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},i=3<arguments.length&&void 0!==arguments[3]?arguments[3]:{},o=4<arguments.length?arguments[4]:void 0;return this._focusOnlyEventStrategy.updateEnabledHotKeys(e,t,n,i,o)}},{key:"disableHotKeys",value:function(e,t){return this._focusOnlyEventStrategy.disableHotKeys(e,t)}},{key:"handleKeydown",value:function(e,t,n,i){if(isFromFocusOnlyComponent(t))return this._focusOnlyEventStrategy.handleKeydown(e,t,n,i)}},{key:"handleKeyPress",value:function(e,t,n,i){if(isFromFocusOnlyComponent(t))return this._focusOnlyEventStrategy.handleKeyPress(e,t,n,i)}},{key:"handleKeyUp",value:function(e,t,n,i){if(isFromFocusOnlyComponent(t))return this._focusOnlyEventStrategy.handleKeyUp(e,t,n,i)}},{key:"enableGlobalHotKeys",value:function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},i=3<arguments.length?arguments[3]:void 0,o=4<arguments.length?arguments[4]:void 0;return this._globalEventStrategy.enableHotKeys(e,t,n,i,o)}},{key:"updateEnabledGlobalHotKeys",value:function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},i=3<arguments.length?arguments[3]:void 0,o=4<arguments.length?arguments[4]:void 0;return this._globalEventStrategy.updateEnabledHotKeys(e,t,n,i,o)}},{key:"disableGlobalHotKeys",value:function(e){return this._globalEventStrategy.disableHotKeys(e)}},{key:"handleGlobalKeyDown",value:function(e){return this._globalEventStrategy.handleKeydown(e)}},{key:"handleGlobalKeyPress",value:function(e){return this._globalEventStrategy.handleKeyPress(e)}},{key:"handleGlobalKeyUp",value:function(e){return this._globalEventStrategy.handleKeyUp(e)}},{key:"ignoreEvent",value:function(e){this._focusOnlyEventStrategy.getEventPropagator().ignoreEvent(e)}},{key:"observeIgnoredEvents",value:function(e){this._focusOnlyEventStrategy.getEventPropagator().observeIgnoredEvents(e)}},{key:"closeHangingKeyCombination",value:function(e,t){this._focusOnlyEventStrategy.closeHangingKeyCombination(e,t)}},{key:"reactAppHistoryWithEvent",value:function(e,t){var n=this._focusOnlyEventStrategy.eventPropagator.getPreviousPropagation();return n.isForKey(e)&&n.isForEventType(t)?n.isHandled()?EventResponse.handled:n.isIgnoringEvent()?EventResponse.ignored:EventResponse.seen:EventResponse.unseen}},{key:"simulatePendingKeyPressEvents",value:function(){this._focusOnlyEventStrategy.simulatePendingKeyPressEvents()}},{key:"simulatePendingKeyUpEvents",value:function(){this._focusOnlyEventStrategy.simulatePendingKeyUpEvents()}},{key:"isGlobalListenersBound",value:function(){return this._globalEventStrategy.listenersBound}}]),t}();function backwardsCompatibleContext(e,t){var n=t.deprecatedAPI,i=n.contextTypes,o=n.childContextTypes,r=t.newAPI.contextType;if(void 0===React__default.createContext)e.contextTypes=i,e.childContextTypes=o,e.prototype.getChildContext=function(){return this._childContext};else{var s=React__default.createContext(r);e.contextType=s,e.prototype._originalRender=e.prototype.render,e.prototype.render=function(){var e=this._originalRender();return e?React__default.createElement(s.Provider,{value:this._childContext},e):null}}return e}function withHotKeys(i){var n=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};function t(e,t){return _objectSpread({},n[e]||{},t[e]||{})}function o(e){return t("handlers",e)}function r(e){return t("keyMap",e)}var e=function(e){function n(e){var t;return _classCallCheck(this,n),(t=_possibleConstructorReturn(this,_getPrototypeOf(n).call(this,e)))._handleFocus=t._handleFocus.bind(_assertThisInitialized(_assertThisInitialized(t))),t._handleBlur=t._handleBlur.bind(_assertThisInitialized(_assertThisInitialized(t))),t._handleKeyDown=t._handleKeyDown.bind(_assertThisInitialized(_assertThisInitialized(t))),t._handleKeyPress=t._handleKeyPress.bind(_assertThisInitialized(_assertThisInitialized(t))),t._handleKeyUp=t._handleKeyUp.bind(_assertThisInitialized(_assertThisInitialized(t))),t._componentIsFocused=t._componentIsFocused.bind(_assertThisInitialized(_assertThisInitialized(t))),t._id=KeyEventManager.getInstance().registerKeyMap(e.keyMap),t._childContext={hotKeysParentId:t._id},t}return _inherits(n,React.PureComponent),_createClass(n,[{key:"render",value:function(){var e=this.props,t=(e.keyMap,e.handlers,e.allowChanges,e.root,_objectWithoutProperties(e,["keyMap","handlers","allowChanges","root"])),n={onFocus:this._wrapFunction("onFocus",this._handleFocus),onBlur:this._wrapFunction("onBlur",this._handleBlur),tabIndex:Configuration.option("defaultTabIndex")};return this._shouldBindKeyListeners()&&(n.onKeyDown=this._handleKeyDown,n.onKeyPress=this._handleKeyPress,n.onKeyUp=this._handleKeyUp),React__default.createElement(i,_extends({hotKeys:n},t))}},{key:"_shouldBindKeyListeners",value:function(){var e=r(this.props);return!isEmpty(e)||this.props.root||Configuration.option("enableHardSequences")&&this._handlersIncludeHardSequences(e,o(this.props))}},{key:"_handlersIncludeHardSequences",value:function(t,e){return Object.keys(e).some(function(e){return!t[e]&&KeyCombinationSerializer.isValidKeySerialization(e)})}},{key:"_wrapFunction",value:function(t,n){var i=this;return"function"==typeof this.props[t]?function(e){i.props[t](e),n(e)}:n}},{key:"_focusTreeIdsPush",value:function(e){this._focusTreeIds||(this._focusTreeIds=[]),this._focusTreeIds.push(e)}},{key:"_focusTreeIdsShift",value:function(){this._focusTreeIds&&this._focusTreeIds.shift()}},{key:"_getFocusTreeId",value:function(){if(this._focusTreeIds)return this._focusTreeIds[0]}},{key:"componentDidUpdate",value:function(){var e=KeyEventManager.getInstance();if(e.reregisterKeyMap(this._id,this.props.keyMap),this._componentIsFocused()&&(this.props.allowChanges||!Configuration.option("ignoreKeymapAndHandlerChangesByDefault"))){var t=this.props,n=t.keyMap,i=t.handlers;e.updateEnabledHotKeys(this._getFocusTreeId(),this._id,n,i,this._getComponentOptions())}}},{key:"_componentIsFocused",value:function(){return!0===this._focused}},{key:"componentDidMount",value:function(){var e=KeyEventManager.getInstance(),t=this.context.hotKeysParentId;e.registerComponentMount(this._id,t)}},{key:"_handleFocus",value:function(){var e;this.props.onFocus&&(e=this.props).onFocus.apply(e,arguments);var t=KeyEventManager.getInstance().enableHotKeys(this._id,r(this.props),o(this.props),this._getComponentOptions());isUndefined(t)||this._focusTreeIdsPush(t),this._focused=!0}},{key:"componentWillUnmount",value:function(){var e=KeyEventManager.getInstance();e.deregisterKeyMap(this._id),e.registerComponentUnmount(),this._handleBlur()}},{key:"_handleBlur",value:function(){var e;this.props.onBlur&&(e=this.props).onBlur.apply(e,arguments);KeyEventManager.getInstance().disableHotKeys(this._getFocusTreeId(),this._id)||this._focusTreeIdsShift(),this._focused=!1}},{key:"_handleKeyDown",value:function(e){KeyEventManager.getInstance().handleKeydown(e,this._getFocusTreeId(),this._id,this._getEventOptions())&&this._focusTreeIdsShift()}},{key:"_handleKeyPress",value:function(e){KeyEventManager.getInstance().handleKeyPress(e,this._getFocusTreeId(),this._id,this._getEventOptions())&&this._focusTreeIdsShift()}},{key:"_handleKeyUp",value:function(e){KeyEventManager.getInstance().handleKeyUp(e,this._getFocusTreeId(),this._id,this._getEventOptions())&&this._focusTreeIdsShift()}},{key:"_getComponentOptions",value:function(){return{defaultKeyEvent:Configuration.option("defaultKeyEvent")}}},{key:"_getEventOptions",value:function(){return{ignoreEventsCondition:Configuration.option("ignoreEventsCondition")}}}]),n}();return _defineProperty(e,"propTypes",{keyMap:PropTypes.object,handlers:PropTypes.object,onFocus:PropTypes.func,onBlur:PropTypes.func,allowChanges:PropTypes.bool,root:PropTypes.bool}),backwardsCompatibleContext(e,{deprecatedAPI:{contextTypes:{hotKeysParentId:PropTypes.number},childContextTypes:{hotKeysParentId:PropTypes.number}},newAPI:{contextType:{hotKeysParentId:void 0}}})}var HotKeysWrapper=function(e){function t(){return _classCallCheck(this,t),_possibleConstructorReturn(this,_getPrototypeOf(t).apply(this,arguments))}return _inherits(t,React.Component),_createClass(t,[{key:"render",value:function(){var e=this.props,t=e.hotKeys,n=e.innerRef,i=e.component,o=_objectWithoutProperties(e,["hotKeys","innerRef","component"]),r=i||Configuration.option("defaultComponent");return React__default.createElement(r,_objectSpread({},t,{ref:n},o))}}]),t}(),HotKeys=withHotKeys(HotKeysWrapper);HotKeys.propTypes={innerRef:PropTypes.oneOfType([PropTypes.object,PropTypes.func])};var GlobalHotKeys=function(e){function n(e){var t;return _classCallCheck(this,n),(t=_possibleConstructorReturn(this,_getPrototypeOf(n).call(this,e)))._id=KeyEventManager.getInstance().registerGlobalKeyMap(e.keyMap),t._childContext={globalHotKeysParentId:t._id},t}return _inherits(n,React.Component),_createClass(n,[{key:"render",value:function(){return this.props.children||null}},{key:"componentDidUpdate",value:function(){var e=KeyEventManager.getInstance();if(e.reregisterGlobalKeyMap(this._id,this.props.keyMap),this.props.allowChanges||!Configuration.option("ignoreKeymapAndHandlerChangesByDefault")){var t=this.props,n=t.keyMap,i=t.handlers;e.updateEnabledGlobalHotKeys(this._id,n,i,this._getComponentOptions(),this._getEventOptions())}}},{key:"componentDidMount",value:function(){var e=this.props,t=e.keyMap,n=e.handlers,i=this.context.globalHotKeysParentId,o=KeyEventManager.getInstance();o.registerGlobalComponentMount(this._id,i),o.enableGlobalHotKeys(this._id,t,n,this._getComponentOptions(),this._getEventOptions())}},{key:"componentWillUnmount",value:function(){var e=KeyEventManager.getInstance();e.deregisterGlobalKeyMap(this._id),e.disableGlobalHotKeys(this._id),e.registerGlobalComponentUnmount()}},{key:"_getComponentOptions",value:function(){return{defaultKeyEvent:Configuration.option("defaultKeyEvent")}}},{key:"_getEventOptions",value:function(){return{ignoreEventsCondition:Configuration.option("ignoreEventsCondition")}}}]),n}();_defineProperty(GlobalHotKeys,"propTypes",{keyMap:PropTypes.object,handlers:PropTypes.object,allowChanges:PropTypes.bool});var GlobalHotKeys$1=backwardsCompatibleContext(GlobalHotKeys,{deprecatedAPI:{contextTypes:{globalHotKeysParentId:PropTypes.number},childContextTypes:{globalHotKeysParentId:PropTypes.number}},newAPI:{contextType:{globalHotKeysParentId:void 0}}});function withHotKeysIgnoreOverride(i){var e,t,n=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{only:[],except:[]},o=2<arguments.length?arguments[2]:void 0;return t=e=function(e){function n(e){var t;return _classCallCheck(this,n),(t=_possibleConstructorReturn(this,_getPrototypeOf(n).call(this,e)))._handleKeyEvent=t._handleKeyEvent.bind(_assertThisInitialized(_assertThisInitialized(t))),t._reloadDictionaries=t._reloadDictionaries.bind(_assertThisInitialized(_assertThisInitialized(t))),t}return _inherits(n,React.PureComponent),_createClass(n,[{key:"render",value:function(){var e=this.props,t=(e.only,e.except,_objectWithoutProperties(e,["only","except"])),n={onKeyDown:this._handleKeyEvent,onKeyPress:this._handleKeyEvent,onKeyUp:this._handleKeyEvent,onFocus:this._reloadDictionaries};return React__default.createElement(i,_extends({hotKeys:n},t))}},{key:"_reloadDictionaries",value:function(){var e=this.props,t=e.only,n=e.except;this._onlyDict=keyDictionary(t),this._exceptDict=keyDictionary(n)}},{key:"_shouldIgnoreEvent",value:function(e){var t=e.key;return isEmpty(this._onlyDict)?!!isEmpty(this._exceptDict)||!hasKey(this._exceptDict,t):isEmpty(this._exceptDict)?hasKey(this._onlyDict,t):hasKey(this._onlyDict,t)&&!hasKey(this._exceptDict,t)}},{key:"_handleKeyEvent",value:function(e){this._shouldIgnoreEvent(e)&&KeyEventManager.getInstance()[o](e)}}]),n}(),_defineProperty(e,"propTypes",{only:PropTypes.oneOfType([PropTypes.string,PropTypes.arrayOf(PropTypes.string)]),except:PropTypes.oneOfType([PropTypes.string,PropTypes.arrayOf(PropTypes.string)])}),_defineProperty(e,"defaultProps",n),t}function keyDictionary(e){return arrayFrom(e).reduce(function(t,e){var n=standardizeKeyName(e);if(!isValidKey(n))throw new InvalidKeyNameError(e);return[resolveAltShiftedAlias,resolveUnaltShiftedAlias,resolveShiftedAlias,resolveUnshiftedAlias,resolveAltedAlias,resolveUnaltedAlias].forEach(function(e){t[e(n)]=!0}),t},{})}var IgnoreKeys=function(e){function t(){return _classCallCheck(this,t),_possibleConstructorReturn(this,_getPrototypeOf(t).apply(this,arguments))}return _inherits(t,React.Component),_createClass(t,[{key:"render",value:function(){var e=this.props,t=e.hotKeys,n=_objectWithoutProperties(e,["hotKeys"]),i=n.component||Configuration.option("defaultComponent");return React__default.createElement(i,_objectSpread({},t,n))}}]),t}(),IgnoreKeys$1=withHotKeysIgnoreOverride(IgnoreKeys,{},"ignoreEvent"),ObserveKeys=function(e){function t(){return _classCallCheck(this,t),_possibleConstructorReturn(this,_getPrototypeOf(t).apply(this,arguments))}return _inherits(t,React.Component),_createClass(t,[{key:"render",value:function(){var e=this.props,t=e.hotKeys,n=_objectWithoutProperties(e,["hotKeys"]),i=n.component||Configuration.option("defaultComponent");return React__default.createElement(i,_objectSpread({},t,n))}}]),t}(),ObserveKeys$1=withHotKeysIgnoreOverride(ObserveKeys,{},"observeIgnoredEvents");function withIgnoreKeys(e){return withHotKeysIgnoreOverride(e,1<arguments.length&&void 0!==arguments[1]?arguments[1]:{only:[],except:[]},"ignoreEvent")}function withObserveKeys(e){return withHotKeysIgnoreOverride(e,1<arguments.length&&void 0!==arguments[1]?arguments[1]:{only:[],except:[]},"observeIgnoredEvents")}function configure(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};Configuration.init(e)}function getApplicationKeyMap(){return KeyEventManager.getInstance().getApplicationKeyMap()}function recordKeyCombination(e){return KeyEventManager.getInstance().addKeyCombinationListener(e)}exports.HotKeys=HotKeys,exports.GlobalHotKeys=GlobalHotKeys$1,exports.IgnoreKeys=IgnoreKeys$1,exports.ObserveKeys=ObserveKeys$1,exports.withHotKeys=withHotKeys,exports.withIgnoreKeys=withIgnoreKeys,exports.withObserveKeys=withObserveKeys,exports.configure=configure,exports.getApplicationKeyMap=getApplicationKeyMap,exports.recordKeyCombination=recordKeyCombination;


/***/ },
/* 1895 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 1896 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 1897 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bodyOpenClassName = exports.portalClassName = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalPortal = __webpack_require__(1898);
	
	var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
	
	var _ariaAppHider = __webpack_require__(899);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _safeHTMLElement = __webpack_require__(456);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	var _reactLifecyclesCompat = __webpack_require__(1896);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var portalClassName = exports.portalClassName = "ReactModalPortal";
	var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";
	
	var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;
	
	var createHTMLElement = function createHTMLElement(name) {
	  return document.createElement(name);
	};
	
	var getCreatePortal = function getCreatePortal() {
	  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
	};
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
	      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
	      var parent = getParentElement(_this.props.parentSelector);
	      if (parent && parent.contains(_this.node)) {
	        parent.removeChild(_this.node);
	      } else {
	        // eslint-disable-next-line no-console
	        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
	      }
	    }, _this.portalRef = function (ref) {
	      _this.portal = ref;
	    }, _this.renderPortal = function (props) {
	      var createPortal = getCreatePortal();
	      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
	      _this.portalRef(portal);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Modal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!_safeHTMLElement.canUseDOM) return;
	
	      if (!isReact16) {
	        this.node = createHTMLElement("div");
	      }
	      this.node.className = this.props.portalClassName;
	
	      var parent = getParentElement(this.props.parentSelector);
	      parent.appendChild(this.node);
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "getSnapshotBeforeUpdate",
	    value: function getSnapshotBeforeUpdate(prevProps) {
	      var prevParent = getParentElement(prevProps.parentSelector);
	      var nextParent = getParentElement(this.props.parentSelector);
	      return { prevParent: prevParent, nextParent: nextParent };
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, _, snapshot) {
	      if (!_safeHTMLElement.canUseDOM) return;
	      var _props = this.props,
	          isOpen = _props.isOpen,
	          portalClassName = _props.portalClassName;
	
	
	      if (prevProps.portalClassName !== portalClassName) {
	        this.node.className = portalClassName;
	      }
	
	      var prevParent = snapshot.prevParent,
	          nextParent = snapshot.nextParent;
	
	      if (nextParent !== prevParent) {
	        prevParent.removeChild(this.node);
	        nextParent.appendChild(this.node);
	      }
	
	      // Stop unnecessary renders if modal is remaining closed
	      if (!prevProps.isOpen && !isOpen) return;
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
	
	      var state = this.portal.state;
	      var now = Date.now();
	      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
	
	      if (closesAt) {
	        if (!state.beforeClose) {
	          this.portal.closeWithTimeout();
	        }
	
	        setTimeout(this.removePortal, closesAt - now);
	      } else {
	        this.removePortal();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!_safeHTMLElement.canUseDOM || !isReact16) {
	        return null;
	      }
	
	      if (!this.node && isReact16) {
	        this.node = createHTMLElement("div");
	      }
	
	      var createPortal = getCreatePortal();
	      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
	        ref: this.portalRef,
	        defaultStyles: Modal.defaultStyles
	      }, this.props)), this.node);
	    }
	  }], [{
	    key: "setAppElement",
	    value: function setAppElement(element) {
	      ariaAppHider.setElement(element);
	    }
	
	    /* eslint-disable react/no-unused-prop-types */
	
	    /* eslint-enable react/no-unused-prop-types */
	
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  portalClassName: _propTypes2.default.string,
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  ariaHideApp: _propTypes2.default.bool,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  preventScroll: _propTypes2.default.bool,
	  parentSelector: _propTypes2.default.func,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func,
	  id: _propTypes2.default.string,
	  overlayElement: _propTypes2.default.func,
	  contentElement: _propTypes2.default.func
	};
	Modal.defaultProps = {
	  isOpen: false,
	  portalClassName: portalClassName,
	  bodyOpenClassName: bodyOpenClassName,
	  role: "dialog",
	  ariaHideApp: true,
	  closeTimeoutMS: 0,
	  shouldFocusAfterRender: true,
	  shouldCloseOnEsc: true,
	  shouldCloseOnOverlayClick: true,
	  shouldReturnFocusAfterClose: true,
	  preventScroll: false,
	  parentSelector: function parentSelector() {
	    return document.body;
	  },
	  overlayElement: function overlayElement(props, contentEl) {
	    return _react2.default.createElement(
	      "div",
	      props,
	      contentEl
	    );
	  },
	  contentElement: function contentElement(props, children) {
	    return _react2.default.createElement(
	      "div",
	      props,
	      children
	    );
	  }
	};
	Modal.defaultStyles = {
	  overlay: {
	    position: "fixed",
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    backgroundColor: "rgba(255, 255, 255, 0.75)"
	  },
	  content: {
	    position: "absolute",
	    top: "40px",
	    left: "40px",
	    right: "40px",
	    bottom: "40px",
	    border: "1px solid #ccc",
	    background: "#fff",
	    overflow: "auto",
	    WebkitOverflowScrolling: "touch",
	    borderRadius: "4px",
	    outline: "none",
	    padding: "20px"
	  }
	};
	
	
	(0, _reactLifecyclesCompat.polyfill)(Modal);
	
	if (false) {
	  Modal.setCreateHTMLElement = function (fn) {
	    return createHTMLElement = fn;
	  };
	}
	
	exports.default = Modal;

/***/ },
/* 1898 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _focusManager = __webpack_require__(1901);
	
	var focusManager = _interopRequireWildcard(_focusManager);
	
	var _scopeTab = __webpack_require__(1902);
	
	var _scopeTab2 = _interopRequireDefault(_scopeTab);
	
	var _ariaAppHider = __webpack_require__(899);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _classList = __webpack_require__(1900);
	
	var classList = _interopRequireWildcard(_classList);
	
	var _safeHTMLElement = __webpack_require__(456);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	var _portalOpenInstances = __webpack_require__(900);
	
	var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
	
	__webpack_require__(1899);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: "ReactModal__Overlay",
	  content: "ReactModal__Content"
	};
	
	/**
	 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
	 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
	 * `react-modal` only supports React >18 (which dropped IE support).
	 */
	var isTabKey = function isTabKey(event) {
	  return event.code === "Tab" || event.keyCode === 9;
	};
	var isEscKey = function isEscKey(event) {
	  return event.code === "Escape" || event.keyCode === 27;
	};
	
	var ariaHiddenInstances = 0;
	
	var ModalPortal = function (_Component) {
	  _inherits(ModalPortal, _Component);
	
	  function ModalPortal(props) {
	    _classCallCheck(this, ModalPortal);
	
	    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
	
	    _this.setOverlayRef = function (overlay) {
	      _this.overlay = overlay;
	      _this.props.overlayRef && _this.props.overlayRef(overlay);
	    };
	
	    _this.setContentRef = function (content) {
	      _this.content = content;
	      _this.props.contentRef && _this.props.contentRef(content);
	    };
	
	    _this.afterClose = function () {
	      var _this$props = _this.props,
	          appElement = _this$props.appElement,
	          ariaHideApp = _this$props.ariaHideApp,
	          htmlOpenClassName = _this$props.htmlOpenClassName,
	          bodyOpenClassName = _this$props.bodyOpenClassName,
	          parentSelector = _this$props.parentSelector;
	
	
	      var parentDocument = parentSelector && parentSelector().ownerDocument || document;
	
	      // Remove classes.
	      bodyOpenClassName && classList.remove(parentDocument.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      // Reset aria-hidden attribute if all modals have been removed
	      if (ariaHideApp && ariaHiddenInstances > 0) {
	        ariaHiddenInstances -= 1;
	
	        if (ariaHiddenInstances === 0) {
	          ariaAppHider.show(appElement);
	        }
	      }
	
	      if (_this.props.shouldFocusAfterRender) {
	        if (_this.props.shouldReturnFocusAfterClose) {
	          focusManager.returnFocus(_this.props.preventScroll);
	          focusManager.teardownScopedFocus();
	        } else {
	          focusManager.popWithoutFocus();
	        }
	      }
	
	      if (_this.props.onAfterClose) {
	        _this.props.onAfterClose();
	      }
	
	      _portalOpenInstances2.default.deregister(_this);
	    };
	
	    _this.open = function () {
	      _this.beforeOpen();
	      if (_this.state.afterOpen && _this.state.beforeClose) {
	        clearTimeout(_this.closeTimer);
	        _this.setState({ beforeClose: false });
	      } else {
	        if (_this.props.shouldFocusAfterRender) {
	          focusManager.setupScopedFocus(_this.node);
	          focusManager.markForFocusLater();
	        }
	
	        _this.setState({ isOpen: true }, function () {
	          _this.openAnimationFrame = requestAnimationFrame(function () {
	            _this.setState({ afterOpen: true });
	
	            if (_this.props.isOpen && _this.props.onAfterOpen) {
	              _this.props.onAfterOpen({
	                overlayEl: _this.overlay,
	                contentEl: _this.content
	              });
	            }
	          });
	        });
	      }
	    };
	
	    _this.close = function () {
	      if (_this.props.closeTimeoutMS > 0) {
	        _this.closeWithTimeout();
	      } else {
	        _this.closeWithoutTimeout();
	      }
	    };
	
	    _this.focusContent = function () {
	      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
	    };
	
	    _this.closeWithTimeout = function () {
	      var closesAt = Date.now() + _this.props.closeTimeoutMS;
	      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
	        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
	      });
	    };
	
	    _this.closeWithoutTimeout = function () {
	      _this.setState({
	        beforeClose: false,
	        isOpen: false,
	        afterOpen: false,
	        closesAt: null
	      }, _this.afterClose);
	    };
	
	    _this.handleKeyDown = function (event) {
	      if (isTabKey(event)) {
	        (0, _scopeTab2.default)(_this.content, event);
	      }
	
	      if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
	        event.stopPropagation();
	        _this.requestClose(event);
	      }
	    };
	
	    _this.handleOverlayOnClick = function (event) {
	      if (_this.shouldClose === null) {
	        _this.shouldClose = true;
	      }
	
	      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
	        if (_this.ownerHandlesClose()) {
	          _this.requestClose(event);
	        } else {
	          _this.focusContent();
	        }
	      }
	      _this.shouldClose = null;
	    };
	
	    _this.handleContentOnMouseUp = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleOverlayOnMouseDown = function (event) {
	      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
	        event.preventDefault();
	      }
	    };
	
	    _this.handleContentOnClick = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleContentOnMouseDown = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.requestClose = function (event) {
	      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
	    };
	
	    _this.ownerHandlesClose = function () {
	      return _this.props.onRequestClose;
	    };
	
	    _this.shouldBeClosed = function () {
	      return !_this.state.isOpen && !_this.state.beforeClose;
	    };
	
	    _this.contentHasFocus = function () {
	      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
	    };
	
	    _this.buildClassName = function (which, additional) {
	      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
	        base: CLASS_NAMES[which],
	        afterOpen: CLASS_NAMES[which] + "--after-open",
	        beforeClose: CLASS_NAMES[which] + "--before-close"
	      };
	      var className = classNames.base;
	      if (_this.state.afterOpen) {
	        className = className + " " + classNames.afterOpen;
	      }
	      if (_this.state.beforeClose) {
	        className = className + " " + classNames.beforeClose;
	      }
	      return typeof additional === "string" && additional ? className + " " + additional : className;
	    };
	
	    _this.attributesFromObject = function (prefix, items) {
	      return Object.keys(items).reduce(function (acc, name) {
	        acc[prefix + "-" + name] = items[name];
	        return acc;
	      }, {});
	    };
	
	    _this.state = {
	      afterOpen: false,
	      beforeClose: false
	    };
	
	    _this.shouldClose = null;
	    _this.moveFromContentToOverlay = null;
	    return _this;
	  }
	
	  _createClass(ModalPortal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.isOpen) {
	        this.open();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (false) {
	        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	      }
	
	      if (this.props.isOpen && !prevProps.isOpen) {
	        this.open();
	      } else if (!this.props.isOpen && prevProps.isOpen) {
	        this.close();
	      }
	
	      // Focus only needs to be set once when the modal is being opened
	      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
	        this.focusContent();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.state.isOpen) {
	        this.afterClose();
	      }
	      clearTimeout(this.closeTimer);
	      cancelAnimationFrame(this.openAnimationFrame);
	    }
	  }, {
	    key: "beforeOpen",
	    value: function beforeOpen() {
	      var _props = this.props,
	          appElement = _props.appElement,
	          ariaHideApp = _props.ariaHideApp,
	          htmlOpenClassName = _props.htmlOpenClassName,
	          bodyOpenClassName = _props.bodyOpenClassName,
	          parentSelector = _props.parentSelector;
	
	
	      var parentDocument = parentSelector && parentSelector().ownerDocument || document;
	
	      // Add classes.
	      bodyOpenClassName && classList.add(parentDocument.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      if (ariaHideApp) {
	        ariaHiddenInstances += 1;
	        ariaAppHider.hide(appElement);
	      }
	
	      _portalOpenInstances2.default.register(this);
	    }
	
	    // Don't steal focus from inner elements
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          id = _props2.id,
	          className = _props2.className,
	          overlayClassName = _props2.overlayClassName,
	          defaultStyles = _props2.defaultStyles,
	          children = _props2.children;
	
	      var contentStyles = className ? {} : defaultStyles.content;
	      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
	
	      if (this.shouldBeClosed()) {
	        return null;
	      }
	
	      var overlayProps = {
	        ref: this.setOverlayRef,
	        className: this.buildClassName("overlay", overlayClassName),
	        style: _extends({}, overlayStyles, this.props.style.overlay),
	        onClick: this.handleOverlayOnClick,
	        onMouseDown: this.handleOverlayOnMouseDown
	      };
	
	      var contentProps = _extends({
	        id: id,
	        ref: this.setContentRef,
	        style: _extends({}, contentStyles, this.props.style.content),
	        className: this.buildClassName("content", className),
	        tabIndex: "-1",
	        onKeyDown: this.handleKeyDown,
	        onMouseDown: this.handleContentOnMouseDown,
	        onMouseUp: this.handleContentOnMouseUp,
	        onClick: this.handleContentOnClick,
	        role: this.props.role,
	        "aria-label": this.props.contentLabel
	      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
	        "data-testid": this.props.testId
	      });
	
	      var contentElement = this.props.contentElement(contentProps, children);
	      return this.props.overlayElement(overlayProps, contentElement);
	    }
	  }]);
	
	  return ModalPortal;
	}(_react.Component);
	
	ModalPortal.defaultProps = {
	  style: {
	    overlay: {},
	    content: {}
	  },
	  defaultStyles: {}
	};
	ModalPortal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  defaultStyles: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  parentSelector: _propTypes2.default.func,
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  ariaHideApp: _propTypes2.default.bool,
	  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
	  onAfterOpen: _propTypes2.default.func,
	  onAfterClose: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  preventScroll: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func,
	  id: _propTypes2.default.string,
	  overlayElement: _propTypes2.default.func,
	  contentElement: _propTypes2.default.func,
	  testId: _propTypes2.default.string
	};
	exports.default = ModalPortal;
	module.exports = exports["default"];

/***/ },
/* 1899 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetState = resetState;
	exports.log = log;
	
	var _portalOpenInstances = __webpack_require__(900);
	
	var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Body focus trap see Issue #742
	
	var before = void 0,
	    after = void 0,
	    instances = [];
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function resetState() {
	  var _arr = [before, after];
	
	  for (var _i = 0; _i < _arr.length; _i++) {
	    var item = _arr[_i];
	    if (!item) continue;
	    item.parentNode && item.parentNode.removeChild(item);
	  }
	  before = after = null;
	  instances = [];
	}
	
	/* istanbul ignore next */
	function log() {
	  console.log("bodyTrap ----------");
	  console.log(instances.length);
	  var _arr2 = [before, after];
	  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
	    var item = _arr2[_i2];
	    var check = item || {};
	    console.log(check.nodeName, check.className, check.id);
	  }
	  console.log("edn bodyTrap ----------");
	}
	/* eslint-enable no-console */
	
	function focusContent() {
	  if (instances.length === 0) {
	    if (false) {
	      // eslint-disable-next-line no-console
	      console.warn("React-Modal: Open instances > 0 expected");
	    }
	    return;
	  }
	  instances[instances.length - 1].focusContent();
	}
	
	function bodyTrap(eventType, openInstances) {
	  if (!before && !after) {
	    before = document.createElement("div");
	    before.setAttribute("data-react-modal-body-trap", "");
	    before.style.position = "absolute";
	    before.style.opacity = "0";
	    before.setAttribute("tabindex", "0");
	    before.addEventListener("focus", focusContent);
	    after = before.cloneNode();
	    after.addEventListener("focus", focusContent);
	  }
	
	  instances = openInstances;
	
	  if (instances.length > 0) {
	    // Add focus trap
	    if (document.body.firstChild !== before) {
	      document.body.insertBefore(before, document.body.firstChild);
	    }
	    if (document.body.lastChild !== after) {
	      document.body.appendChild(after);
	    }
	  } else {
	    // Remove focus trap
	    if (before.parentElement) {
	      before.parentElement.removeChild(before);
	    }
	    if (after.parentElement) {
	      after.parentElement.removeChild(after);
	    }
	  }
	}
	
	_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ },
/* 1900 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetState = resetState;
	exports.log = log;
	var htmlClassList = {};
	var docBodyClassList = {};
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function removeClass(at, cls) {
	  at.classList.remove(cls);
	}
	
	/* istanbul ignore next */
	function resetState() {
	  var htmlElement = document.getElementsByTagName("html")[0];
	  for (var cls in htmlClassList) {
	    removeClass(htmlElement, htmlClassList[cls]);
	  }
	
	  var body = document.body;
	  for (var _cls in docBodyClassList) {
	    removeClass(body, docBodyClassList[_cls]);
	  }
	
	  htmlClassList = {};
	  docBodyClassList = {};
	}
	
	/* istanbul ignore next */
	function log() {
	  if (false) {
	    var classes = document.getElementsByTagName("html")[0].className;
	    var buffer = "Show tracked classes:\n\n";
	
	    buffer += "<html /> (" + classes + "):\n  ";
	    for (var x in htmlClassList) {
	      buffer += "  " + x + " " + htmlClassList[x] + "\n  ";
	    }
	
	    classes = document.body.className;
	
	    buffer += "\n\ndoc.body (" + classes + "):\n  ";
	    for (var _x in docBodyClassList) {
	      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n  ";
	    }
	
	    buffer += "\n";
	
	    console.log(buffer);
	  }
	}
	/* eslint-enable no-console */
	
	/**
	 * Track the number of reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var incrementReference = function incrementReference(poll, className) {
	  if (!poll[className]) {
	    poll[className] = 0;
	  }
	  poll[className] += 1;
	  return className;
	};
	
	/**
	 * Drop the reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var decrementReference = function decrementReference(poll, className) {
	  if (poll[className]) {
	    poll[className] -= 1;
	  }
	  return className;
	};
	
	/**
	 * Track a class and add to the given class list.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be tracked.
	 */
	var trackClass = function trackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    incrementReference(poll, className);
	    classListRef.add(className);
	  });
	};
	
	/**
	 * Untrack a class and remove from the given class list if the reference
	 * reaches 0.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be untracked.
	 */
	var untrackClass = function untrackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    decrementReference(poll, className);
	    poll[className] === 0 && classListRef.remove(className);
	  });
	};
	
	/**
	 * Public inferface to add classes to the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var add = exports.add = function add(element, classString) {
	  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};
	
	/**
	 * Public inferface to remove classes from the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var remove = exports.remove = function remove(element, classString) {
	  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};

/***/ },
/* 1901 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetState = resetState;
	exports.log = log;
	exports.handleBlur = handleBlur;
	exports.handleFocus = handleFocus;
	exports.markForFocusLater = markForFocusLater;
	exports.returnFocus = returnFocus;
	exports.popWithoutFocus = popWithoutFocus;
	exports.setupScopedFocus = setupScopedFocus;
	exports.teardownScopedFocus = teardownScopedFocus;
	
	var _tabbable = __webpack_require__(901);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function resetState() {
	  focusLaterElements = [];
	}
	
	/* istanbul ignore next */
	function log() {
	  if (false) {
	    console.log("focusManager ----------");
	    focusLaterElements.forEach(function (f) {
	      var check = f || {};
	      console.log(check.nodeName, check.className, check.id);
	    });
	    console.log("end focusManager ----------");
	  }
	}
	/* eslint-enable no-console */
	
	function handleBlur() {
	  needToFocus = true;
	}
	
	function handleFocus() {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function () {
	      if (modalElement.contains(document.activeElement)) {
	        return;
	      }
	      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
	      el.focus();
	    }, 0);
	  }
	}
	
	function markForFocusLater() {
	  focusLaterElements.push(document.activeElement);
	}
	
	/* eslint-disable no-console */
	function returnFocus() {
	  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	  var toFocus = null;
	  try {
	    if (focusLaterElements.length !== 0) {
	      toFocus = focusLaterElements.pop();
	      toFocus.focus({ preventScroll: preventScroll });
	    }
	    return;
	  } catch (e) {
	    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
	  }
	}
	/* eslint-enable no-console */
	
	function popWithoutFocus() {
	  focusLaterElements.length > 0 && focusLaterElements.pop();
	}
	
	function setupScopedFocus(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener("blur", handleBlur, false);
	    document.addEventListener("focus", handleFocus, true);
	  } else {
	    window.attachEvent("onBlur", handleBlur);
	    document.attachEvent("onFocus", handleFocus);
	  }
	}
	
	function teardownScopedFocus() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener("blur", handleBlur);
	    document.removeEventListener("focus", handleFocus);
	  } else {
	    window.detachEvent("onBlur", handleBlur);
	    document.detachEvent("onFocus", handleFocus);
	  }
	}

/***/ },
/* 1902 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scopeTab;
	
	var _tabbable = __webpack_require__(901);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getActiveElement() {
	  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
	
	  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
	}
	
	function scopeTab(node, event) {
	  var tabbable = (0, _tabbable2.default)(node);
	
	  if (!tabbable.length) {
	    // Do nothing, since there are no elements that can receive focus.
	    event.preventDefault();
	    return;
	  }
	
	  var target = void 0;
	
	  var shiftKey = event.shiftKey;
	  var head = tabbable[0];
	  var tail = tabbable[tabbable.length - 1];
	  var activeElement = getActiveElement();
	
	  // proceed with default browser behavior on tab.
	  // Focus on last element on shift + tab.
	  if (node === activeElement) {
	    if (!shiftKey) return;
	    target = tail;
	  }
	
	  if (tail === activeElement && !shiftKey) {
	    target = head;
	  }
	
	  if (head === activeElement && shiftKey) {
	    target = tail;
	  }
	
	  if (target) {
	    event.preventDefault();
	    target.focus();
	    return;
	  }
	
	  // Safari radio issue.
	  //
	  // Safari does not move the focus to the radio button,
	  // so we need to force it to really walk through all elements.
	  //
	  // This is very error prone, since we are trying to guess
	  // if it is a safari browser from the first occurence between
	  // chrome or safari.
	  //
	  // The chrome user agent contains the first ocurrence
	  // as the 'chrome/version' and later the 'safari/version'.
	  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
	  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
	
	  // If we are not in safari desktop, let the browser control
	  // the focus
	  if (!isSafariDesktop) return;
	
	  var x = tabbable.indexOf(activeElement);
	
	  if (x > -1) {
	    x += shiftKey ? -1 : 1;
	  }
	
	  target = tabbable[x];
	
	  // If the tabbable element does not exist,
	  // focus head/tail based on shiftKey
	  if (typeof target === "undefined") {
	    event.preventDefault();
	    target = shiftKey ? tail : head;
	    target.focus();
	    return;
	  }
	
	  event.preventDefault();
	
	  target.focus();
	}
	module.exports = exports["default"];

/***/ },
/* 1903 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(1897);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;
	module.exports = exports["default"];

/***/ },
/* 1904 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 1905 */
/***/ function(module, exports) {

	var messages = {
	  invalidPredicate: '`predicate` must be a function',
	  invalidPropValidator: '`propValidator` must be a function',
	  requiredCore: 'is marked as required',
	  invalidTypeCore: 'Invalid input type',
	  predicateFailureCore: 'Failed to succeed with predicate',
	  anonymousMessage: '<<anonymous>>',
	  baseInvalidMessage: 'Invalid ',
	};
	
	function constructPropValidatorVariations(propValidator) {
	  if (typeof propValidator !== 'function') {
	    throw new Error(messages.invalidPropValidator);
	  }
	
	  var requiredPropValidator = propValidator.bind(null, false, null);
	  requiredPropValidator.isRequired = propValidator.bind(null, true, null);
	
	  requiredPropValidator.withPredicate = function predicateApplication(predicate) {
	    if (typeof predicate !== 'function') {
	      throw new Error(messages.invalidPredicate);
	    }
	    var basePropValidator = propValidator.bind(null, false, predicate);
	    basePropValidator.isRequired = propValidator.bind(null, true, predicate);
	    return basePropValidator;
	  };
	
	  return requiredPropValidator;
	}
	
	function createInvalidRequiredErrorMessage(propName, componentName, value) {
	  return new Error(
	    'The prop `' + propName + '` ' + messages.requiredCore +
	    ' in `' + componentName + '`, but its value is `' + value + '`.'
	  );
	}
	
	var independentGuardianValue = -1;
	
	function preValidationRequireCheck(isRequired, componentName, propFullName, propValue) {
	  var isPropValueUndefined = typeof propValue === 'undefined';
	  var isPropValueNull = propValue === null;
	
	  if (isRequired) {
	    if (isPropValueUndefined) {
	      return createInvalidRequiredErrorMessage(propFullName, componentName, 'undefined');
	    } else if (isPropValueNull) {
	      return createInvalidRequiredErrorMessage(propFullName, componentName, 'null');
	    }
	  }
	
	  if (isPropValueUndefined || isPropValueNull) {
	    return null;
	  }
	
	  return independentGuardianValue;
	}
	
	function createMomentChecker(type, typeValidator, validator, momentType) {
	
	  function propValidator(
	    isRequired, // Bound parameter to indicate with the propType is required
	    predicate, // Bound parameter to allow user to add dynamic validation
	    props,
	    propName,
	    componentName,
	    location,
	    propFullName
	  ) {
	    var propValue = props[ propName ];
	    var propType = typeof propValue;
	
	    componentName = componentName || messages.anonymousMessage;
	    propFullName = propFullName || propName;
	
	    var preValidationRequireCheckValue = preValidationRequireCheck(
	      isRequired, componentName, propFullName, propValue
	    );
	
	    if (preValidationRequireCheckValue !== independentGuardianValue) {
	      return preValidationRequireCheckValue;
	    }
	
	    if (typeValidator && !typeValidator(propValue)) {
	      return new Error(
	        messages.invalidTypeCore + ': `' + propName + '` of type `' + propType + '` ' +
	        'supplied to `' + componentName + '`, expected `' + type + '`.'
	      );
	    }
	
	    if (!validator(propValue)) {
	      return new Error(
	        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
	        'supplied to `' + componentName + '`, expected `' + momentType + '`.'
	      );
	    }
	
	    if (predicate && !predicate(propValue)) {
	      var predicateName = predicate.name || messages.anonymousMessage;
	      return new Error(
	        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
	        'supplied to `' + componentName + '`. ' + messages.predicateFailureCore + ' `' +
	        predicateName + '`.'
	      );
	    }
	
	    return null;
	
	  }
	
	  return constructPropValidatorVariations(propValidator);
	
	}
	
	module.exports = {
	  constructPropValidatorVariations: constructPropValidatorVariations,
	  createMomentChecker: createMomentChecker,
	  messages: messages,
	};


/***/ },
/* 1906 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(2);
	
	function isValidMoment(testMoment) {
	  if (typeof moment.isMoment === 'function' && !moment.isMoment(testMoment)) {
	    return false;
	  }
	
	  /* istanbul ignore else  */
	  if (typeof testMoment.isValid === 'function') {
	    // moment 1.7.0+
	    return testMoment.isValid();
	  }
	
	  /* istanbul ignore next */
	  return !isNaN(testMoment);
	}
	
	module.exports = {
	  isValidMoment : isValidMoment,
	};


/***/ },
/* 1907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(37);
	
	var _consolidatedEvents = __webpack_require__(249);
	
	var _object = __webpack_require__(422);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _document = __webpack_require__(1343);
	
	var _document2 = _interopRequireDefault(_document);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DISPLAY = {
	  BLOCK: 'block',
	  FLEX: 'flex',
	  INLINE: 'inline',
	  INLINE_BLOCK: 'inline-block',
	  CONTENTS: 'contents'
	};
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
	  children: _propTypes2['default'].node.isRequired,
	  onOutsideClick: _propTypes2['default'].func.isRequired,
	  disabled: _propTypes2['default'].bool,
	  useCapture: _propTypes2['default'].bool,
	  display: _propTypes2['default'].oneOf((0, _object2['default'])(DISPLAY))
	});
	
	var defaultProps = {
	  disabled: false,
	
	  // `useCapture` is set to true by default so that a `stopPropagation` in the
	  // children will not prevent all outside click handlers from firing - maja
	  useCapture: true,
	  display: DISPLAY.BLOCK
	};
	
	var OutsideClickHandler = function (_React$Component) {
	  _inherits(OutsideClickHandler, _React$Component);
	
	  function OutsideClickHandler() {
	    var _ref;
	
	    _classCallCheck(this, OutsideClickHandler);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, (_ref = OutsideClickHandler.__proto__ || Object.getPrototypeOf(OutsideClickHandler)).call.apply(_ref, [this].concat(args)));
	
	    _this.onMouseDown = _this.onMouseDown.bind(_this);
	    _this.onMouseUp = _this.onMouseUp.bind(_this);
	    _this.setChildNodeRef = _this.setChildNodeRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(OutsideClickHandler, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        var _props = this.props,
	            disabled = _props.disabled,
	            useCapture = _props.useCapture;
	
	
	        if (!disabled) this.addMouseDownEventListener(useCapture);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(_ref2) {
	        var prevDisabled = _ref2.disabled;
	        var _props2 = this.props,
	            disabled = _props2.disabled,
	            useCapture = _props2.useCapture;
	
	        if (prevDisabled !== disabled) {
	          if (disabled) {
	            this.removeEventListeners();
	          } else {
	            this.addMouseDownEventListener(useCapture);
	          }
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        this.removeEventListeners();
	      }
	
	      return componentWillUnmount;
	    }()
	
	    // Use mousedown/mouseup to enforce that clicks remain outside the root's
	    // descendant tree, even when dragged. This should also get triggered on
	    // touch devices.
	
	  }, {
	    key: 'onMouseDown',
	    value: function () {
	      function onMouseDown(e) {
	        var useCapture = this.props.useCapture;
	
	
	        var isDescendantOfRoot = this.childNode && (0, _document2['default'])(this.childNode, e.target);
	        if (!isDescendantOfRoot) {
	          if (this.removeMouseUp) {
	            this.removeMouseUp();
	            this.removeMouseUp = null;
	          }
	          this.removeMouseUp = (0, _consolidatedEvents.addEventListener)(document, 'mouseup', this.onMouseUp, { capture: useCapture });
	        }
	      }
	
	      return onMouseDown;
	    }()
	
	    // Use mousedown/mouseup to enforce that clicks remain outside the root's
	    // descendant tree, even when dragged. This should also get triggered on
	    // touch devices.
	
	  }, {
	    key: 'onMouseUp',
	    value: function () {
	      function onMouseUp(e) {
	        var onOutsideClick = this.props.onOutsideClick;
	
	
	        var isDescendantOfRoot = this.childNode && (0, _document2['default'])(this.childNode, e.target);
	        if (this.removeMouseUp) {
	          this.removeMouseUp();
	          this.removeMouseUp = null;
	        }
	
	        if (!isDescendantOfRoot) {
	          onOutsideClick(e);
	        }
	      }
	
	      return onMouseUp;
	    }()
	  }, {
	    key: 'setChildNodeRef',
	    value: function () {
	      function setChildNodeRef(ref) {
	        this.childNode = ref;
	      }
	
	      return setChildNodeRef;
	    }()
	  }, {
	    key: 'addMouseDownEventListener',
	    value: function () {
	      function addMouseDownEventListener(useCapture) {
	        this.removeMouseDown = (0, _consolidatedEvents.addEventListener)(document, 'mousedown', this.onMouseDown, { capture: useCapture });
	      }
	
	      return addMouseDownEventListener;
	    }()
	  }, {
	    key: 'removeEventListeners',
	    value: function () {
	      function removeEventListeners() {
	        if (this.removeMouseDown) this.removeMouseDown();
	        if (this.removeMouseUp) this.removeMouseUp();
	      }
	
	      return removeEventListeners;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props3 = this.props,
	            children = _props3.children,
	            display = _props3.display;
	
	
	        return _react2['default'].createElement(
	          'div',
	          {
	            ref: this.setChildNodeRef,
	            style: display !== DISPLAY.BLOCK && (0, _object2['default'])(DISPLAY).includes(display) ? { display: display } : undefined
	          },
	          children
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return OutsideClickHandler;
	}(_react2['default'].Component);
	
	exports['default'] = OutsideClickHandler;
	
	
	OutsideClickHandler.propTypes = propTypes;
	OutsideClickHandler.defaultProps = defaultProps;

/***/ },
/* 1908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*eslint-disable react/prop-types */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(46);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _componentOrElement = __webpack_require__(459);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Portal = __webpack_require__(902);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ModalManager = __webpack_require__(1909);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _ownerDocument = __webpack_require__(230);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _addEventListener = __webpack_require__(905);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(1912);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _inDOM = __webpack_require__(124);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _activeElement = __webpack_require__(553);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(164);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _getContainer = __webpack_require__(458);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	var Modal = _react2.default.createClass({
	  displayName: 'Modal',
	
	
	  propTypes: _extends({}, _Portal2.default.propTypes, {
	
	    /**
	     * Set the visibility of the Modal
	     */
	    show: _react2.default.PropTypes.bool,
	
	    /**
	     * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	     *
	     * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	     * page content can be placed behind a virtual backdrop as well as a visual one.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	    /**
	     * A callback fired when the Modal is opening.
	     */
	    onShow: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	     *
	     * The `onHide` callback only signals intent from the Modal,
	     * you must actually set the `show` prop to `false` for the Modal to close.
	     */
	    onHide: _react2.default.PropTypes.func,
	
	    /**
	     * Include a backdrop component.
	     */
	    backdrop: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.oneOf(['static'])]),
	
	    /**
	     * A function that returns a backdrop component. Useful for custom
	     * backdrop rendering.
	     *
	     * ```js
	     *  renderBackdrop={props => <MyBackdrop {...props} />}
	     * ```
	     */
	    renderBackdrop: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	     */
	    onEscapeKeyUp: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the backdrop, if specified, is clicked.
	     */
	    onBackdropClick: _react2.default.PropTypes.func,
	
	    /**
	     * A style object for the backdrop component.
	     */
	    backdropStyle: _react2.default.PropTypes.object,
	
	    /**
	     * A css class or classes for the backdrop component.
	     */
	    backdropClassName: _react2.default.PropTypes.string,
	
	    /**
	     * A css class or set of classes applied to the modal container when the modal is open,
	     * and removed when it is closed.
	     */
	    containerClassName: _react2.default.PropTypes.string,
	
	    /**
	     * Close the modal when escape key is pressed
	     */
	    keyboard: _react2.default.PropTypes.bool,
	
	    /**
	     * A `<Transition/>` component to use for the dialog and backdrop components.
	     */
	    transition: _elementType2.default,
	
	    /**
	     * The `timeout` of the dialog transition if specified. This number is used to ensure that
	     * transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    dialogTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * The `timeout` of the backdrop transition if specified. This number is used to
	     * ensure that transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    backdropTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * When `true` The modal will automatically shift focus to itself when it opens, and
	     * replace it to the last focused element when it closes. This also
	     * works correctly with any Modal children that have the `autoFocus` prop.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    autoFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will prevent focus from leaving the Modal while open.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    enforceFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will restore focus to previously focused element once
	     * modal is hidden
	     */
	    restoreFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * Callback fired before the Modal transitions in
	     */
	    onEnter: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition in
	     */
	    onEntering: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning in
	     */
	    onEntered: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired right before the Modal transitions out
	     */
	    onExit: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition out
	     */
	    onExiting: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning out
	     */
	    onExited: _react2.default.PropTypes.func,
	
	    /**
	     * A ModalManager instance used to track and manage the state of open
	     * Modals. Useful when customizing how modals interact within a container
	     */
	    manager: _react2.default.PropTypes.object.isRequired
	  }),
	
	  getDefaultProps: function getDefaultProps() {
	    var noop = function noop() {};
	
	    return {
	      show: false,
	      backdrop: true,
	      keyboard: true,
	      autoFocus: true,
	      enforceFocus: true,
	      restoreFocus: true,
	      onHide: noop,
	      manager: modalManager,
	      renderBackdrop: function renderBackdrop(props) {
	        return _react2.default.createElement('div', props);
	      }
	    };
	  },
	  omitProps: function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  },
	  getInitialState: function getInitialState() {
	    return { exited: !this.props.show };
	  },
	  render: function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        dialogTransitionTimeout = _props.dialogTransitionTimeout,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          transitionAppear: true,
	          unmountOnExit: true,
	          'in': show,
	          timeout: dialogTransitionTimeout,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: 'modal',
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        dialog
	      )
	    );
	  },
	  renderBackdrop: function renderBackdrop() {
	    var _this = this;
	
	    var _props2 = this.props,
	        backdropStyle = _props2.backdropStyle,
	        backdropClassName = _props2.backdropClassName,
	        renderBackdrop = _props2.renderBackdrop,
	        Transition = _props2.transition,
	        backdropTransitionTimeout = _props2.backdropTransitionTimeout;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this.backdrop = ref;
	    };
	
	    var backdrop = _react2.default.createElement('div', {
	      ref: backdropRef,
	      style: this.props.backdropStyle,
	      className: this.props.backdropClassName,
	      onClick: this.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        { transitionAppear: true,
	          'in': this.props.show,
	          timeout: backdropTransitionTimeout
	        },
	        renderBackdrop({
	          ref: backdropRef,
	          style: backdropStyle,
	          className: backdropClassName,
	          onClick: this.handleBackdropClick
	        })
	      );
	    }
	
	    return backdrop;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  },
	  componentWillUpdate: function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.props.show) {
	      this.onShow();
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var _props3 = this.props,
	        show = _props3.show,
	        transition = _props3.transition;
	
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  },
	  onShow: function onShow() {
	    var doc = (0, _ownerDocument2.default)(this);
	    var container = (0, _getContainer2.default)(this.props.container, doc.body);
	
	    this.props.manager.add(this, container, this.props.containerClassName);
	
	    this._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleDocumentKeyUp);
	
	    this._onFocusinListener = (0, _addFocusListener2.default)(this.enforceFocus);
	
	    this.focus();
	
	    if (this.props.onShow) {
	      this.props.onShow();
	    }
	  },
	  onHide: function onHide() {
	    this.props.manager.remove(this);
	
	    this._onDocumentKeyupListener.remove();
	
	    this._onFocusinListener.remove();
	
	    if (this.props.restoreFocus) {
	      this.restoreLastFocus();
	    }
	  },
	  setMountNode: function setMountNode(ref) {
	    this.mountNode = ref ? ref.getMountNode() : ref;
	  },
	  handleHidden: function handleHidden() {
	    this.setState({ exited: true });
	    this.onHide();
	
	    if (this.props.onExited) {
	      var _props4;
	
	      (_props4 = this.props).onExited.apply(_props4, arguments);
	    }
	  },
	  handleBackdropClick: function handleBackdropClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (this.props.onBackdropClick) {
	      this.props.onBackdropClick(e);
	    }
	
	    if (this.props.backdrop === true) {
	      this.props.onHide();
	    }
	  },
	  handleDocumentKeyUp: function handleDocumentKeyUp(e) {
	    if (this.props.keyboard && e.keyCode === 27 && this.isTopModal()) {
	      if (this.props.onEscapeKeyUp) {
	        this.props.onEscapeKeyUp(e);
	      }
	      this.props.onHide();
	    }
	  },
	  checkForFocus: function checkForFocus() {
	    if (_inDOM2.default) {
	      this.lastFocus = (0, _activeElement2.default)();
	    }
	  },
	  focus: function focus() {
	    var autoFocus = this.props.autoFocus;
	    var modalContent = this.getDialogElement();
	    var current = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var focusInModal = current && (0, _contains2.default)(modalContent, current);
	
	    if (modalContent && autoFocus && !focusInModal) {
	      this.lastFocus = current;
	
	      if (!modalContent.hasAttribute('tabIndex')) {
	        modalContent.setAttribute('tabIndex', -1);
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
	      }
	
	      modalContent.focus();
	    }
	  },
	  restoreLastFocus: function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  },
	  enforceFocus: function enforceFocus() {
	    var enforceFocus = this.props.enforceFocus;
	
	
	    if (!enforceFocus || !this.isMounted() || !this.isTopModal()) {
	      return;
	    }
	
	    var active = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var modal = this.getDialogElement();
	
	    if (modal && modal !== active && !(0, _contains2.default)(modal, active)) {
	      modal.focus();
	    }
	  },
	
	
	  //instead of a ref, which might conflict with one the parent applied.
	  getDialogElement: function getDialogElement() {
	    var node = this.refs.modal;
	    return node && node.lastChild;
	  },
	  isTopModal: function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  }
	});
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ },
/* 1909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__(260);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _class = __webpack_require__(1346);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _scrollbarSize = __webpack_require__(559);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(906);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(1914);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function () {
	  function ModalManager() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	        hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	        _ref2$handleContainer = _ref2.handleContainerOverflow,
	        handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	    _classCallCheck(this, ModalManager);
	
	    this.hideSiblingNodes = hideSiblingNodes;
	    this.handleContainerOverflow = handleContainerOverflow;
	    this.modals = [];
	    this.containers = [];
	    this.data = [];
	  }
	
	  _createClass(ModalManager, [{
	    key: 'add',
	    value: function add(modal, container, className) {
	      var modalIdx = this.modals.indexOf(modal);
	      var containerIdx = this.containers.indexOf(container);
	
	      if (modalIdx !== -1) {
	        return modalIdx;
	      }
	
	      modalIdx = this.modals.length;
	      this.modals.push(modal);
	
	      if (this.hideSiblingNodes) {
	        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	      }
	
	      if (containerIdx !== -1) {
	        this.data[containerIdx].modals.push(modal);
	        return modalIdx;
	      }
	
	      var data = {
	        modals: [modal],
	        //right now only the first modal of a container will have its classes applied
	        classes: className ? className.split(/\s+/) : [],
	
	        overflowing: (0, _isOverflowing2.default)(container)
	      };
	
	      if (this.handleContainerOverflow) {
	        setContainerStyle(data, container);
	      }
	
	      data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	      this.containers.push(container);
	      this.data.push(data);
	
	      return modalIdx;
	    }
	  }, {
	    key: 'remove',
	    value: function remove(modal) {
	      var modalIdx = this.modals.indexOf(modal);
	
	      if (modalIdx === -1) {
	        return;
	      }
	
	      var containerIdx = findContainer(this.data, modal);
	      var data = this.data[containerIdx];
	      var container = this.containers[containerIdx];
	
	      data.modals.splice(data.modals.indexOf(modal), 1);
	
	      this.modals.splice(modalIdx, 1);
	
	      // if that was the last modal in a container,
	      // clean up the container
	      if (data.modals.length === 0) {
	        data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	        if (this.handleContainerOverflow) {
	          removeContainerStyle(data, container);
	        }
	
	        if (this.hideSiblingNodes) {
	          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	        }
	        this.containers.splice(containerIdx, 1);
	        this.data.splice(containerIdx, 1);
	      } else if (this.hideSiblingNodes) {
	        //otherwise make sure the next top modal is visible to a SR
	        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	      }
	    }
	  }, {
	    key: 'isTopModal',
	    value: function isTopModal(modal) {
	      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	
	  return ModalManager;
	}();
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ },
/* 1910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(902);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(1911);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(903);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _elementType = __webpack_require__(27);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props, context));
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.show) {
	        this.setState({ exited: false });
	      } else if (!nextProps.transition) {
	        // Otherwise let handleHidden take care of marking exited.
	        this.setState({ exited: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          container = _props.container,
	          containerPadding = _props.containerPadding,
	          target = _props.target,
	          placement = _props.placement,
	          shouldUpdatePosition = _props.shouldUpdatePosition,
	          rootClose = _props.rootClose,
	          children = _props.children,
	          Transition = _props.transition,
	          props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	      // Don't un-render the overlay while it's transitioning out.
	
	
	      var mountOverlay = props.show || Transition && !this.state.exited;
	      if (!mountOverlay) {
	        // Don't bother showing anything if we don't have to.
	        return null;
	      }
	
	      var child = children;
	
	      // Position is be inner-most because it adds inline styles into the child,
	      // which the other wrappers don't forward correctly.
	      child = _react2.default.createElement(
	        _Position2.default,
	        { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	        child
	      );
	
	      if (Transition) {
	        var onExit = props.onExit,
	            onExiting = props.onExiting,
	            onEnter = props.onEnter,
	            onEntering = props.onEntering,
	            onEntered = props.onEntered;
	
	        // This animates the child node by injecting props, so it must precede
	        // anything that adds a wrapping div.
	
	        child = _react2.default.createElement(
	          Transition,
	          {
	            'in': props.show,
	            transitionAppear: true,
	            onExit: onExit,
	            onExiting: onExiting,
	            onExited: this.onHiddenListener,
	            onEnter: onEnter,
	            onEntering: onEntering,
	            onEntered: onEntered
	          },
	          child
	        );
	      }
	
	      // This goes after everything else because it adds a wrapping div.
	      if (rootClose) {
	        child = _react2.default.createElement(
	          _RootCloseWrapper2.default,
	          { onRootClose: props.onHide },
	          child
	        );
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { container: container },
	        child
	      );
	    }
	  }, {
	    key: 'handleHidden',
	    value: function handleHidden() {
	      this.setState({ exited: true });
	
	      if (this.props.onExited) {
	        var _props2;
	
	        (_props2 = this.props).onExited.apply(_props2, arguments);
	      }
	    }
	  }]);
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _react2.default.PropTypes.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _react2.default.PropTypes.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _react2.default.PropTypes.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `<Transition/>` component used to animate the overlay changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _react2.default.PropTypes.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ },
/* 1911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(459);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _calculatePosition = __webpack_require__(1913);
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__(458);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(230);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).call(this, props, context));
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  _createClass(Position, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updatePosition(this.getTarget());
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this._needsFlush = true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this._needsFlush) {
	        this._needsFlush = false;
	        this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['children', 'className']);
	
	      var _state = this.state,
	          positionLeft = _state.positionLeft,
	          positionTop = _state.positionTop,
	          arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	      // These should not be forwarded to the child.
	
	
	      delete props.target;
	      delete props.container;
	      delete props.containerPadding;
	      delete props.shouldUpdatePosition;
	
	      var child = _react2.default.Children.only(children);
	      return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	        // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	        // and `props.style`.
	        positionLeft: positionLeft,
	        positionTop: positionTop,
	        className: (0, _classnames2.default)(className, child.props.className),
	        style: _extends({}, child.props.style, {
	          left: positionLeft,
	          top: positionTop
	        })
	      }));
	    }
	  }, {
	    key: 'getTarget',
	    value: function getTarget() {
	      var target = this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    }
	  }, {
	    key: 'maybeUpdatePosition',
	    value: function maybeUpdatePosition(placementChanged) {
	      var target = this.getTarget();
	
	      if (!this.props.shouldUpdatePosition && target === this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      this.updatePosition(target);
	    }
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition(target) {
	      this._lastTarget = target;
	
	      if (!target) {
	        this.setState({
	          positionLeft: 0,
	          positionTop: 0,
	          arrowOffsetLeft: null,
	          arrowOffsetTop: null
	        });
	
	        return;
	      }
	
	      var overlay = _reactDom2.default.findDOMNode(this);
	      var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	      this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	    }
	  }]);
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _react2.default.PropTypes.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _react2.default.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _react2.default.PropTypes.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ },
/* 1912 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ },
/* 1913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__(555);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__(1352);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__(556);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__(230);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode),
	      overlayHeight = _getOffset2.height,
	      overlayWidth = _getOffset2.width;
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ },
/* 1914 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ },
/* 1915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(196);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _assign = __webpack_require__(333);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _promise = __webpack_require__(334);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(90);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(91);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _mergeClassNames = __webpack_require__(420);
	
	var _mergeClassNames2 = _interopRequireDefault(_mergeClassNames);
	
	var _LinkService = __webpack_require__(907);
	
	var _LinkService2 = _interopRequireDefault(_LinkService);
	
	var _utils = __webpack_require__(106);
	
	var _events = __webpack_require__(298);
	
	var _propTypes3 = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Document = function (_Component) {
	  (0, _inherits3.default)(Document, _Component);
	
	  function Document() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Document);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Document.__proto__ || (0, _getPrototypeOf2.default)(Document)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      pdf: null
	    }, _this.viewer = {
	      scrollPageIntoView: function scrollPageIntoView(_ref2) {
	        var pageNumber = _ref2.pageNumber;
	
	        // Handling jumping to internal links target
	
	        // First, check if custom handling of onItemClick was provided
	        if (_this.props.onItemClick) {
	          _this.props.onItemClick({ pageNumber: pageNumber });
	          return;
	        }
	
	        // If not, try to look for target page within the <Document>.
	        var page = _this.pages[pageNumber - 1];
	
	        if (page) {
	          // Scroll to the page automatically
	          page.scrollIntoView();
	          return;
	        }
	
	        (0, _utils.warnOnDev)('Warning: An internal link leading to page ' + pageNumber + ' was clicked, but neither <Document> was provided with onItemClick nor it was able to find the page within itself. Either provide onItemClick to <Document> and handle navigating by yourself or ensure that all pages are rendered within <Document>.');
	      }
	    }, _this.linkService = new _LinkService2.default(), _this.onSourceSuccess = function (source) {
	      (0, _utils.callIfDefined)(_this.props.onSourceSuccess);
	
	      if (!PDFJS) {
	        throw new Error('Could not load the document. PDF.js is not loaded.');
	      }
	
	      if (!source) {
	        return null;
	      }
	
	      _this.runningTask = (0, _utils.makeCancellable)(PDFJS.getDocument(source));
	
	      return _this.runningTask.promise.then(_this.onLoadSuccess).catch(_this.onLoadError);
	    }, _this.onSourceError = function (error) {
	      if (error.name === 'RenderingCancelledException' || error.name === 'PromiseCancelledException') {
	        return;
	      }
	
	      (0, _utils.errorOnDev)(error.message, error);
	
	      (0, _utils.callIfDefined)(_this.props.onSourceError, error);
	
	      _this.setState({ pdf: false });
	    }, _this.onLoadSuccess = function (pdf) {
	      _this.setState({ pdf: pdf }, function () {
	        (0, _utils.callIfDefined)(_this.props.onLoadSuccess, pdf);
	
	        _this.pages = new Array(pdf.numPages);
	        _this.linkService.setDocument(pdf);
	      });
	    }, _this.onLoadError = function (error) {
	      if (error.name === 'RenderingCancelledException' || error.name === 'PromiseCancelledException') {
	        return;
	      }
	
	      (0, _utils.errorOnDev)(error.message, error);
	
	      (0, _utils.callIfDefined)(_this.props.onLoadError, error);
	
	      _this.setState({ pdf: false });
	    }, _this.findDocumentSource = function () {
	      var file = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.file;
	      return new _promise2.default(function (resolve, reject) {
	        if (!file) {
	          return resolve(null);
	        }
	
	        // File is a string
	        if ((0, _utils.isString)(file)) {
	          if ((0, _utils.isDataURI)(file)) {
	            var fileUint8Array = (0, _utils.dataURItoUint8Array)(file);
	            return resolve(fileUint8Array);
	          }
	
	          (0, _utils.displayCORSWarning)();
	          return resolve(file);
	        }
	
	        if ((0, _utils.isArrayBuffer)(file)) {
	          return resolve(file);
	        }
	
	        if ((0, _utils.isParamObject)(file)) {
	          // Prevent from modifying props
	          var modifiedFile = (0, _assign2.default)({}, file);
	
	          if ('url' in modifiedFile) {
	            // File is data URI
	            if ((0, _utils.isDataURI)(modifiedFile.url)) {
	              var _fileUint8Array = (0, _utils.dataURItoUint8Array)(modifiedFile.url);
	              return resolve(_fileUint8Array);
	            }
	
	            (0, _utils.displayCORSWarning)();
	          }
	
	          return resolve(modifiedFile);
	        }
	
	        /**
	         * The cases below are browser-only.
	         * If you're running on a non-browser environment, these cases will be of no use.
	         */
	        if (_utils.isBrowser) {
	          // File is a Blob
	          if ((0, _utils.isBlob)(file) || (0, _utils.isFile)(file)) {
	            var reader = new FileReader();
	
	            reader.onload = function () {
	              return resolve(new Uint8Array(reader.result));
	            };
	            reader.onerror = function (event) {
	              switch (event.target.error.code) {
	                case event.target.error.NOT_FOUND_ERR:
	                  return reject(new Error('Error while reading a file: File not found.'));
	                case event.target.error.NOT_READABLE_ERR:
	                  return reject(new Error('Error while reading a file: File not readable.'));
	                case event.target.error.SECURITY_ERR:
	                  return reject(new Error('Error while reading a file: Security error.'));
	                case event.target.error.ABORT_ERR:
	                  return reject(new Error('Error while reading a file: Aborted.'));
	                default:
	                  return reject(new Error('Error while reading a file.'));
	              }
	            };
	            reader.readAsArrayBuffer(file);
	
	            return null;
	          }
	        }
	
	        // No supported loading method worked
	        return reject(new Error('Unsupported loading method.'));
	      });
	    }, _this.registerPage = function (pageIndex, ref) {
	      _this.pages[pageIndex] = ref;
	    }, _this.unregisterPage = function (pageIndex) {
	      delete _this.pages[pageIndex];
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Document, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadDocument();
	
	      this.linkService.setViewer(this.viewer);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.shouldLoadDocument(nextProps)) {
	        if (this.state.pdf !== null) {
	          this.setState({ pdf: null });
	        }
	
	        this.loadDocument(nextProps);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _utils.cancelRunningTask)(this.runningTask);
	    }
	  }, {
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var linkService = this.linkService,
	          registerPage = this.registerPage,
	          unregisterPage = this.unregisterPage;
	      var rotate = this.props.rotate;
	
	
	      return {
	        linkService: linkService,
	        pdf: this.state.pdf,
	        registerPage: registerPage,
	        rotate: rotate,
	        unregisterPage: unregisterPage
	      };
	    }
	  }, {
	    key: 'shouldLoadDocument',
	    value: function shouldLoadDocument(nextProps) {
	      var nextFile = nextProps.file;
	      var file = this.props.file;
	
	      // We got file of different type - clearly there was a change
	
	      if ((typeof nextFile === 'undefined' ? 'undefined' : (0, _typeof3.default)(nextFile)) !== (typeof file === 'undefined' ? 'undefined' : (0, _typeof3.default)(file))) {
	        return true;
	      }
	
	      // We got an object and previously it was an object too - we need to compare deeply
	      if ((0, _utils.isParamObject)(nextFile) && (0, _utils.isParamObject)(file)) {
	        return nextFile.data !== file.data || nextFile.range !== file.range || nextFile.url !== file.url;
	        // We either have or had an object - most likely there was a change
	      } else if ((0, _utils.isParamObject)(nextFile) || (0, _utils.isParamObject)(file)) {
	        return true;
	      }
	
	      /**
	       * The cases below are browser-only.
	       * If you're running on a non-browser environment, these cases will be of no use.
	       */
	      if (_utils.isBrowser && (
	      // File is a Blob or a File
	      (0, _utils.isBlob)(nextFile) || (0, _utils.isFile)(nextFile)) && ((0, _utils.isBlob)(file) || (0, _utils.isFile)(file))) {
	        /**
	         * Theoretically, we could compare files here by reading them, but that would severely affect
	         * performance. Therefore, we're making a compromise here, agreeing on not loading the next
	         * file if its size is identical as the previous one's.
	         */
	        return nextFile.size !== file.size;
	      }
	
	      return nextFile !== file;
	    }
	  }, {
	    key: 'loadDocument',
	    value: function loadDocument() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      (0, _utils.cancelRunningTask)(this.runningTask);
	
	      this.runningTask = (0, _utils.makeCancellable)(this.findDocumentSource(props.file));
	
	      return this.runningTask.promise.then(this.onSourceSuccess).catch(this.onSourceError);
	    }
	
	    /**
	     * Attempts to find a document source based on props.
	     */
	
	  }, {
	    key: 'renderNoData',
	    value: function renderNoData() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'react-pdf__message react-pdf__message--no-data' },
	        this.props.noData
	      );
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'react-pdf__message react-pdf__message--error' },
	        this.props.error
	      );
	    }
	  }, {
	    key: 'renderLoader',
	    value: function renderLoader() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'react-pdf__message react-pdf__message--loading' },
	        this.props.loading
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          file = _props.file,
	          inputRef = _props.inputRef;
	      var pdf = this.state.pdf;
	
	
	      var content = void 0;
	      if (!file) {
	        content = this.renderNoData();
	      } else if (pdf === null) {
	        content = this.renderLoader();
	      } else if (pdf === false) {
	        content = this.renderError();
	      } else {
	        content = this.props.children;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({
	          className: (0, _mergeClassNames2.default)('react-pdf__Document', className),
	          ref: inputRef
	        }, this.eventProps),
	        content
	      );
	    }
	  }, {
	    key: 'eventProps',
	    get: function get() {
	      var _this2 = this;
	
	      return (0, _events.makeEventProps)(this.props, function () {
	        return _this2.state.pdf;
	      });
	    }
	
	    /**
	     * Called when a document source is resolved correctly
	     */
	
	
	    /**
	     * Called when a document source failed to be resolved correctly
	     */
	
	
	    /**
	     * Called when a document is read successfully
	     */
	
	
	    /**
	     * Called when a document failed to read successfully
	     */
	
	  }]);
	  return Document;
	}(_react.Component); /**
	                      * Loads a PDF document. Passes it to all children.
	                      */
	
	
	exports.default = Document;
	
	
	Document.childContextTypes = {
	  linkService: _propTypes3.isLinkService,
	  pdf: _propTypes3.isPdf,
	  registerPage: _propTypes2.default.func,
	  rotate: _propTypes2.default.number,
	  unregisterPage: _propTypes2.default.func
	};
	
	Document.defaultProps = {
	  error: 'Failed to load PDF file.',
	  loading: 'Loading PDF…',
	  noData: 'No PDF file specified.'
	};
	
	Document.propTypes = (0, _extends3.default)({
	  children: _propTypes2.default.node,
	  className: _propTypes3.isClassName,
	  error: _propTypes2.default.node,
	  file: _utils.isFile,
	  inputRef: _propTypes2.default.func,
	  loading: _propTypes2.default.node,
	  noData: _propTypes2.default.node,
	  onItemClick: _propTypes2.default.func,
	  onLoadError: _propTypes2.default.func,
	  onLoadSuccess: _propTypes2.default.func,
	  onSourceError: _propTypes2.default.func,
	  onSourceSuccess: _propTypes2.default.func,
	  rotate: _propTypes2.default.number
	}, (0, _propTypes3.eventsProps)());

/***/ },
/* 1916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(90);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(91);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _mergeClassNames = __webpack_require__(420);
	
	var _mergeClassNames2 = _interopRequireDefault(_mergeClassNames);
	
	var _OutlineItem = __webpack_require__(1917);
	
	var _OutlineItem2 = _interopRequireDefault(_OutlineItem);
	
	var _utils = __webpack_require__(106);
	
	var _events = __webpack_require__(298);
	
	var _propTypes3 = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Outline = function (_Component) {
	  (0, _inherits3.default)(Outline, _Component);
	
	  function Outline() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Outline);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Outline.__proto__ || (0, _getPrototypeOf2.default)(Outline)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      outline: null
	    }, _this.onLoadSuccess = function (outline) {
	      _this.setState({ outline: outline }, function () {
	        (0, _utils.callIfDefined)(_this.props.onLoadSuccess, outline);
	      });
	    }, _this.onLoadError = function (error) {
	      if (error.name === 'RenderingCancelledException' || error.name === 'PromiseCancelledException') {
	        return;
	      }
	
	      (0, _utils.errorOnDev)(error.message, error);
	
	      (0, _utils.callIfDefined)(_this.props.onLoadError, error);
	
	      _this.setState({ outline: false });
	    }, _this.onItemClick = function (_ref2) {
	      var pageIndex = _ref2.pageIndex,
	          pageNumber = _ref2.pageNumber;
	
	      (0, _utils.callIfDefined)(_this.props.onItemClick, {
	        pageIndex: pageIndex,
	        pageNumber: pageNumber
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Outline, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadOutline();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps, nextContext) {
	      if (this.getPdf(nextProps, nextContext) !== this.getPdf()) {
	        this.loadOutline(nextProps, nextContext);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _utils.cancelRunningTask)(this.runningTask);
	    }
	  }, {
	    key: 'getPdf',
	    value: function getPdf() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;
	
	      return props.pdf || context.pdf;
	    }
	  }, {
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        pdf: this.getPdf(),
	        onClick: this.onItemClick
	      };
	    }
	  }, {
	    key: 'loadOutline',
	    value: function loadOutline() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;
	
	      var pdf = this.getPdf(props, context);
	
	      if (!pdf) {
	        throw new Error('Attempted to load an outline, but no document was specified.');
	      }
	
	      if (this.state.outline !== null) {
	        this.setState({ outline: null });
	      }
	
	      this.runningTask = (0, _utils.makeCancellable)(pdf.getOutline());
	
	      return this.runningTask.promise.then(this.onLoadSuccess).catch(this.onLoadError);
	    }
	  }, {
	    key: 'renderOutline',
	    value: function renderOutline() {
	      var outline = this.state.outline;
	
	
	      return _react2.default.createElement(
	        'ul',
	        null,
	        outline.map(function (item, itemIndex) {
	          return _react2.default.createElement(_OutlineItem2.default, {
	            key: typeof item.destination === 'string' ? item.destination : itemIndex,
	            item: item
	          });
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var pdf = this.getPdf();
	      var outline = this.state.outline;
	
	
	      if (!pdf || !outline) {
	        return null;
	      }
	
	      var className = this.props.className;
	
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({
	          className: (0, _mergeClassNames2.default)('react-pdf__Outline', className),
	          ref: this.props.inputRef
	        }, this.eventProps),
	        this.renderOutline()
	      );
	    }
	  }, {
	    key: 'eventProps',
	    get: function get() {
	      var _this2 = this;
	
	      return (0, _events.makeEventProps)(this.props, function () {
	        return _this2.state.outline;
	      });
	    }
	
	    /**
	     * Called when an outline is read successfully
	     */
	
	
	    /**
	     * Called when an outline failed to read successfully
	     */
	
	  }]);
	  return Outline;
	}(_react.Component);
	
	exports.default = Outline;
	
	
	Outline.childContextTypes = {
	  onClick: _propTypes2.default.func,
	  pdf: _propTypes3.isPdf
	};
	
	Outline.contextTypes = {
	  pdf: _propTypes3.isPdf
	};
	
	Outline.propTypes = (0, _extends3.default)({
	  className: _propTypes3.isClassName,
	  inputRef: _propTypes2.default.func,
	  onItemClick: _propTypes2.default.func,
	  onLoadError: _propTypes2.default.func,
	  onLoadSuccess: _propTypes2.default.func
	}, (0, _propTypes3.eventsProps)());

/***/ },
/* 1917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(511);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _regenerator = __webpack_require__(512);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(510);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(90);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(91);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Ref = __webpack_require__(1924);
	
	var _Ref2 = _interopRequireDefault(_Ref);
	
	var _utils = __webpack_require__(106);
	
	var _propTypes3 = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OutlineItem = function (_Component) {
	  (0, _inherits3.default)(OutlineItem, _Component);
	
	  function OutlineItem() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, OutlineItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = OutlineItem.__proto__ || (0, _getPrototypeOf2.default)(OutlineItem)).call.apply(_ref, [this].concat(args))), _this), _this.getDestination = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var pdf, item;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              pdf = _this.context.pdf;
	              item = _this.props.item;
	
	              if ((0, _utils.isDefined)(_this.destination)) {
	                _context.next = 10;
	                break;
	              }
	
	              if (!(typeof item.dest === 'string')) {
	                _context.next = 9;
	                break;
	              }
	
	              _context.next = 6;
	              return pdf.getDestination(item.dest);
	
	            case 6:
	              _this.destination = _context.sent;
	              _context.next = 10;
	              break;
	
	            case 9:
	              _this.destination = item.dest;
	
	            case 10:
	              return _context.abrupt('return', _this.destination);
	
	            case 11:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    })), _this.getPageIndex = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
	      var pdf, destination, _destination, ref;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              pdf = _this.context.pdf;
	
	              if ((0, _utils.isDefined)(_this.pageIndex)) {
	                _context2.next = 10;
	                break;
	              }
	
	              _context2.next = 4;
	              return _this.getDestination();
	
	            case 4:
	              destination = _context2.sent;
	
	              if (!destination) {
	                _context2.next = 10;
	                break;
	              }
	
	              _destination = (0, _slicedToArray3.default)(destination, 1), ref = _destination[0];
	              _context2.next = 9;
	              return pdf.getPageIndex(new _Ref2.default(ref));
	
	            case 9:
	              _this.pageIndex = _context2.sent;
	
	            case 10:
	              return _context2.abrupt('return', _this.pageIndex);
	
	            case 11:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    })), _this.getPageNumber = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              if ((0, _utils.isDefined)(_this.pageNumber)) {
	                _context3.next = 5;
	                break;
	              }
	
	              _context3.next = 3;
	              return _this.getPageIndex();
	
	            case 3:
	              _context3.t0 = _context3.sent;
	              _this.pageNumber = _context3.t0 + 1;
	
	            case 5:
	              return _context3.abrupt('return', _this.pageNumber);
	
	            case 6:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    })), _this.onClick = function () {
	      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(event) {
	        var pageIndex, pageNumber;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                event.preventDefault();
	
	                _context4.next = 3;
	                return _this.getPageIndex();
	
	              case 3:
	                pageIndex = _context4.sent;
	                _context4.next = 6;
	                return _this.getPageNumber();
	
	              case 6:
	                pageNumber = _context4.sent;
	
	
	                (0, _utils.callIfDefined)(_this.context.onClick, {
	                  pageIndex: pageIndex,
	                  pageNumber: pageNumber
	                });
	
	              case 8:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x) {
	        return _ref5.apply(this, arguments);
	      };
	    }(), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(OutlineItem, [{
	    key: 'renderSubitems',
	    value: function renderSubitems() {
	      var item = this.props.item;
	
	
	      if (!item.items || !item.items.length) {
	        return null;
	      }
	
	      var subitems = item.items;
	
	
	      return _react2.default.createElement(
	        'ul',
	        null,
	        subitems.map(function (subitem, subitemIndex) {
	          return _react2.default.createElement(OutlineItem, {
	            key: typeof subitem.destination === 'string' ? subitem.destination : subitemIndex,
	            item: subitem
	          });
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var item = this.props.item;
	      var onClick = this.onClick;
	
	
	      return _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          {
	            href: '#',
	            onClick: onClick
	          },
	          item.title
	        ),
	        this.renderSubitems()
	      );
	    }
	  }]);
	  return OutlineItem;
	}(_react.Component);
	
	exports.default = OutlineItem;
	
	
	var isDestination = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.any)]);
	
	OutlineItem.contextTypes = {
	  onClick: _propTypes2.default.func,
	  pdf: _propTypes3.isPdf.isRequired
	};
	
	OutlineItem.propTypes = {
	  item: _propTypes2.default.shape({
	    title: _propTypes2.default.string,
	    destination: isDestination,
	    items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      title: _propTypes2.default.string,
	      destination: isDestination
	    }))
	  }).isRequired
	};

/***/ },
/* 1918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(90);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(91);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _mergeClassNames = __webpack_require__(420);
	
	var _mergeClassNames2 = _interopRequireDefault(_mergeClassNames);
	
	var _PageCanvas = __webpack_require__(1920);
	
	var _PageCanvas2 = _interopRequireDefault(_PageCanvas);
	
	var _PageSVG = __webpack_require__(1921);
	
	var _PageSVG2 = _interopRequireDefault(_PageSVG);
	
	var _TextLayer = __webpack_require__(1922);
	
	var _TextLayer2 = _interopRequireDefault(_TextLayer);
	
	var _AnnotationLayer = __webpack_require__(1919);
	
	var _AnnotationLayer2 = _interopRequireDefault(_AnnotationLayer);
	
	var _utils = __webpack_require__(106);
	
	var _events = __webpack_require__(298);
	
	var _propTypes3 = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultScale = 1.0;
	
	var Page = function (_Component) {
	  (0, _inherits3.default)(Page, _Component);
	
	  function Page() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Page);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Page.__proto__ || (0, _getPrototypeOf2.default)(Page)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      page: null
	    }, _this.onLoadSuccess = function (page) {
	      _this.setState({ page: page }, function () {
	        (0, _utils.callIfDefined)(_this.props.onLoadSuccess, (0, _utils.makePageCallback)(page, _this.scale));
	
	        (0, _utils.callIfDefined)(_this.context.registerPage, page.pageIndex, _this.ref);
	      });
	    }, _this.onLoadError = function (error) {
	      if (error.name === 'RenderingCancelledException' || error.name === 'PromiseCancelledException') {
	        return;
	      }
	
	      (0, _utils.errorOnDev)(error.message, error);
	
	      (0, _utils.callIfDefined)(_this.props.onLoadError, error);
	
	      _this.setState({ page: false });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadPage();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps, nextContext) {
	      if (this.getPdf(nextProps, nextContext) !== this.getPdf() || this.getPageNumber(nextProps) !== this.getPageNumber()) {
	        (0, _utils.callIfDefined)(this.context.unregisterPage, this.pageIndex);
	
	        if (this.state.page !== null) {
	          this.setState({ page: null });
	        }
	
	        this.loadPage(nextProps, nextContext);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _utils.callIfDefined)(this.context.unregisterPage, this.pageIndex);
	
	      (0, _utils.cancelRunningTask)(this.runningTask);
	    }
	  }, {
	    key: 'getPdf',
	    value: function getPdf() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;
	
	      return props.pdf || context.pdf;
	    }
	  }, {
	    key: 'getChildContext',
	    value: function getChildContext() {
	      if (!this.state.page) {
	        return {};
	      }
	
	      var context = {
	        page: this.state.page,
	        pdf: this.getPdf(),
	        rotate: this.rotate,
	        scale: this.scale
	      };
	
	      if (this.props.onRenderError) {
	        context.onRenderError = this.props.onRenderError;
	      }
	      if (this.props.onRenderSuccess) {
	        context.onRenderSuccess = this.props.onRenderSuccess;
	      }
	      if (this.props.onGetAnnotationsError) {
	        context.onGetAnnotationsError = this.props.onGetAnnotationsError;
	      }
	      if (this.props.onGetAnnotationsSuccess) {
	        context.onGetAnnotationsSuccess = this.props.onGetAnnotationsSuccess;
	      }
	      if (this.props.onGetTextError) {
	        context.onGetTextError = this.props.onGetTextError;
	      }
	      if (this.props.onGetTextSuccess) {
	        context.onGetTextSuccess = this.props.onGetTextSuccess;
	      }
	      if (this.props.customTextRenderer) {
	        context.customTextRenderer = this.props.customTextRenderer;
	      }
	      return context;
	    }
	
	    /**
	     * Called when a page is loaded successfully
	     */
	
	
	    /**
	     * Called when a page failed to load
	     */
	
	  }, {
	    key: 'getPageIndex',
	    value: function getPageIndex() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      if ((0, _utils.isProvided)(props.pageNumber)) {
	        return props.pageNumber - 1;
	      }
	
	      if ((0, _utils.isProvided)(props.pageIndex)) {
	        return props.pageIndex;
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getPageNumber',
	    value: function getPageNumber() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      if ((0, _utils.isProvided)(props.pageNumber)) {
	        return props.pageNumber;
	      }
	
	      if ((0, _utils.isProvided)(props.pageIndex)) {
	        return props.pageIndex + 1;
	      }
	
	      return null;
	    }
	  }, {
	    key: 'loadPage',
	    value: function loadPage() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;
	
	      var pdf = this.getPdf(props, context);
	
	      if (!pdf) {
	        throw new Error('Attempted to load a page, but no document was specified.');
	      }
	
	      var pageNumber = this.getPageNumber(props);
	
	      if (!pageNumber) {
	        return null;
	      }
	
	      this.runningTask = (0, _utils.makeCancellable)(pdf.getPage(pageNumber));
	
	      return this.runningTask.promise.then(this.onLoadSuccess).catch(this.onLoadError);
	    }
	  }, {
	    key: 'renderTextLayer',
	    value: function renderTextLayer() {
	      var renderTextLayer = this.props.renderTextLayer;
	
	
	      if (!renderTextLayer) {
	        return null;
	      }
	
	      return _react2.default.createElement(_TextLayer2.default, { key: this.pageKey + '_text' });
	    }
	  }, {
	    key: 'renderAnnotations',
	    value: function renderAnnotations() {
	      var renderAnnotations = this.props.renderAnnotations;
	
	
	      if (!renderAnnotations) {
	        return null;
	      }
	
	      return _react2.default.createElement(_AnnotationLayer2.default, { key: this.pageKey + '_annotations' });
	    }
	  }, {
	    key: 'renderSVG',
	    value: function renderSVG() {
	      return [_react2.default.createElement(_PageSVG2.default, { key: this.pageKeyNoScale + '_svg' }),
	      /**
	       * As of now, PDF.js 2.0.120 returns warnings on unimplemented annotations.
	       * Therefore, as a fallback, we render "traditional" AnnotationLayer component.
	       */
	      this.renderAnnotations()];
	    }
	  }, {
	    key: 'renderCanvas',
	    value: function renderCanvas() {
	      return [_react2.default.createElement(_PageCanvas2.default, { key: this.pageKey + '_canvas' }), this.renderTextLayer(), this.renderAnnotations()];
	    }
	  }, {
	    key: 'renderNoData',
	    value: function renderNoData() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'react-pdf__message react-pdf__message--no-data' },
	        this.props.noData
	      );
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'react-pdf__message react-pdf__message--error' },
	        this.props.error
	      );
	    }
	  }, {
	    key: 'renderLoader',
	    value: function renderLoader() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'react-pdf__message react-pdf__message--loading' },
	        this.props.loading
	      );
	    }
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var _props = this.props,
	          children = _props.children,
	          renderMode = _props.renderMode;
	
	
	      return [renderMode === 'svg' ? this.renderSVG() : this.renderCanvas(), children];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var pageNumber = this.pageNumber;
	
	      var pdf = this.getPdf();
	      var className = this.props.className;
	      var page = this.state.page;
	
	
	      var content = void 0;
	      if (!pageNumber) {
	        content = this.renderNoData();
	      } else if (pdf === null || page === null) {
	        content = this.renderLoader();
	      } else if (pdf === false || page === false) {
	        content = this.renderError();
	      } else {
	        content = this.renderChildren();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({
	          className: (0, _mergeClassNames2.default)('react-pdf__Page', className),
	          ref: function ref(_ref2) {
	            var inputRef = _this2.props.inputRef;
	
	            if (inputRef) {
	              inputRef(_ref2);
	            }
	
	            _this2.ref = _ref2;
	          },
	          style: { position: 'relative' },
	          'data-page-number': pageNumber
	        }, this.eventProps),
	        content
	      );
	    }
	  }, {
	    key: 'pageIndex',
	    get: function get() {
	      return this.getPageIndex();
	    }
	  }, {
	    key: 'pageNumber',
	    get: function get() {
	      return this.getPageNumber();
	    }
	  }, {
	    key: 'rotate',
	    get: function get() {
	      if ((0, _utils.isProvided)(this.props.rotate)) {
	        return this.props.rotate;
	      }
	
	      if ((0, _utils.isProvided)(this.context.rotate)) {
	        return this.context.rotate;
	      }
	
	      var page = this.state.page;
	
	
	      return page.rotate;
	    }
	  }, {
	    key: 'scale',
	    get: function get() {
	      var _props2 = this.props,
	          scale = _props2.scale,
	          width = _props2.width;
	      var page = this.state.page;
	      var rotate = this.rotate;
	
	      // Be default, we'll render page at 100% * scale width.
	
	      var pageScale = 1;
	
	      // If width is defined, calculate the scale of the page so it could be of desired width.
	      if (width) {
	        var viewport = page.getViewport(scale, rotate);
	        pageScale = width / viewport.width;
	      }
	
	      // Passing scale explicitly null would cause the page not to render
	      var scaleWithDefault = scale === null ? defaultScale : scale;
	
	      return scaleWithDefault * pageScale;
	    }
	  }, {
	    key: 'eventProps',
	    get: function get() {
	      var _this3 = this;
	
	      return (0, _events.makeEventProps)(this.props, function () {
	        var page = _this3.state.page;
	
	        return (0, _utils.makePageCallback)(page, _this3.scale);
	      });
	    }
	  }, {
	    key: 'pageKey',
	    get: function get() {
	      return this.state.page.pageIndex + '@' + this.scale + '/' + this.rotate;
	    }
	  }, {
	    key: 'pageKeyNoScale',
	    get: function get() {
	      return this.state.page.pageIndex + '/' + this.rotate;
	    }
	  }, {
	    key: 'pageProps',
	    get: function get() {
	      return {
	        page: this.state.page,
	        rotate: this.rotate,
	        scale: this.scale
	      };
	    }
	  }]);
	  return Page;
	}(_react.Component);
	
	exports.default = Page;
	
	
	Page.defaultProps = {
	  error: 'Failed to load the page.',
	  loading: 'Loading page…',
	  noData: 'No page specified.',
	  renderAnnotations: true,
	  renderMode: 'canvas',
	  renderTextLayer: true,
	  scale: defaultScale
	};
	
	Page.childContextTypes = {
	  customTextRenderer: _propTypes2.default.func,
	  onGetTextError: _propTypes2.default.func,
	  onGetTextSuccess: _propTypes2.default.func,
	  onRenderError: _propTypes2.default.func,
	  onRenderSuccess: _propTypes2.default.func,
	  page: _propTypes3.isPage,
	  pdf: _propTypes3.isPdf,
	  rotate: _propTypes3.isRotate,
	  scale: _propTypes2.default.number
	};
	
	Page.contextTypes = {
	  linkService: _propTypes3.isLinkService,
	  pdf: _propTypes3.isPdf,
	  registerPage: _propTypes2.default.func,
	  rotate: _propTypes3.isRotate,
	  unregisterPage: _propTypes2.default.func
	};
	
	Page.propTypes = (0, _extends3.default)({
	  children: _propTypes2.default.node,
	  className: _propTypes3.isClassName,
	  customTextRenderer: _propTypes2.default.func,
	  error: _propTypes2.default.node,
	  inputRef: _propTypes2.default.func,
	  loading: _propTypes2.default.node,
	  noData: _propTypes2.default.node,
	  onGetTextError: _propTypes2.default.func,
	  onGetTextSuccess: _propTypes2.default.func,
	  onLoadError: _propTypes2.default.func,
	  onLoadSuccess: _propTypes2.default.func,
	  onRenderError: _propTypes2.default.func,
	  onRenderSuccess: _propTypes2.default.func,
	  pageIndex: _propTypes3.isPageIndex,
	  pageNumber: _propTypes3.isPageNumber,
	  renderAnnotations: _propTypes2.default.bool,
	  renderMode: _propTypes2.default.oneOf(['canvas', 'svg']),
	  renderTextLayer: _propTypes2.default.bool,
	  rotate: _propTypes3.isRotate,
	  scale: _propTypes2.default.number,
	  width: _propTypes2.default.number
	}, (0, _propTypes3.eventsProps)());

/***/ },
/* 1919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(90);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(91);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(106);
	
	var _propTypes3 = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnnotationLayer = function (_Component) {
	  (0, _inherits3.default)(AnnotationLayer, _Component);
	
	  function AnnotationLayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AnnotationLayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AnnotationLayer.__proto__ || (0, _getPrototypeOf2.default)(AnnotationLayer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      annotations: null
	    }, _this.onGetAnnotationsSuccess = function (annotations) {
	      (0, _utils.callIfDefined)(_this.context.onGetAnnotationsSuccess, annotations);
	
	      _this.setState({ annotations: annotations });
	    }, _this.onGetAnnotationsError = function (error) {
	      if (error.name === 'RenderingCancelledException' || error.name === 'PromiseCancelledException') {
	        return;
	      }
	
	      (0, _utils.errorOnDev)(error.message, error);
	
	      (0, _utils.callIfDefined)(_this.context.onGetAnnotationsError, error);
	
	      _this.setState({ annotations: false });
	    }, _this.onRenderSuccess = function () {
	      (0, _utils.callIfDefined)(_this.context.onRenderAnnotationsSuccess);
	    }, _this.onRenderError = function (error) {
	      if (error.name === 'RenderingCancelledException' || error.name === 'PromiseCancelledException') {
	        return;
	      }
	
	      (0, _utils.errorOnDev)(error.message, error);
	
	      (0, _utils.callIfDefined)(_this.context.onRenderError, error);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AnnotationLayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getAnnotations();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps, nextContext) {
	      if (nextContext.page !== this.context.page) {
	        if (this.state.annotations !== null) {
	          this.setState({ annotations: null });
	        }
	
	        this.getAnnotations(nextContext);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _utils.cancelRunningTask)(this.runningTask);
	    }
	
	    /**
	     * Called when a annotations fails to render.
	     */
	
	  }, {
	    key: 'getAnnotations',
	    value: function getAnnotations() {
	      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.context;
	      var page = context.page;
	
	
	      if (!page) {
	        throw new Error('Attempted to load page annotations, but no page was specified.');
	      }
	
	      this.runningTask = (0, _utils.makeCancellable)(page.getAnnotations());
	
	      return this.runningTask.promise.then(this.onGetAnnotationsSuccess).catch(this.onGetAnnotationsError);
	    }
	  }, {
	    key: 'renderAnnotations',
	    value: function renderAnnotations() {
	      var annotations = this.state.annotations;
	
	
	      if (!annotations) {
	        return;
	      }
	
	      var _context = this.context,
	          linkService = _context.linkService,
	          page = _context.page;
	
	      var viewport = this.viewport.clone({ dontFlip: true });
	
	      var parameters = {
	        annotations: annotations,
	        div: this.annotationLayer,
	        linkService: linkService,
	        page: page,
	        viewport: viewport
	      };
	
	      this.annotationLayer.innerHTML = '';
	
	      try {
	        PDFJS.AnnotationLayer.render(parameters);
	        this.onRenderSuccess();
	      } catch (error) {
	        this.onRenderError(error);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'react-pdf__Page__annotations annotationLayer',
	          ref: function ref(_ref2) {
	            _this2.annotationLayer = _ref2;
	          }
	        },
	        this.renderAnnotations()
	      );
	    }
	  }, {
	    key: 'viewport',
	    get: function get() {
	      var _context2 = this.context,
	          page = _context2.page,
	          rotate = _context2.rotate,
	          scale = _context2.scale;
	
	
	      return page.getViewport(scale, rotate);
	    }
	  }]);
	  return AnnotationLayer;
	}(_react.Component);
	
	exports.default = AnnotationLayer;
	
	
	AnnotationLayer.contextTypes = {
	  linkService: _propTypes3.isLinkService,
	  onGetAnnotationsError: _propTypes2.default.func,
	  onGetAnnotationsSuccess: _propTypes2.default.func,
	  onRenderAnnotationsError: _propTypes2.default.func,
	  onRenderAnnotationsSuccess: _propTypes2.default.func,
	  page: _propTypes3.isPage,
	  rotate: _propTypes3.isRotate,
	  scale: _propTypes2.default.number
	};

/***/ },
/* 1920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(90);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(91);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(106);
	
	var _propTypes3 = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageCanvas = function (_Component) {
	  (0, _inherits3.default)(PageCanvas, _Component);
	
	  function PageCanvas() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PageCanvas);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PageCanvas.__proto__ || (0, _getPrototypeOf2.default)(PageCanvas)).call.apply(_ref, [this].concat(args))), _this), _this.onRenderSuccess = function () {
	      _this.renderer = null;
	
	      var _this$context = _this.context,
	          page = _this$context.page,
	          scale = _this$context.scale;
	
	
	      (0, _utils.callIfDefined)(_this.context.onRenderSuccess, (0, _utils.makePageCallback)(page, scale));
	    }, _this.onRenderError = function (error) {
	      if (error.name === 'RenderingCancelledException' || error.name === 'PromiseCancelledException') {
	        return;
	      }
	
	      (0, _utils.errorOnDev)(error.message, error);
	
	      (0, _utils.callIfDefined)(_this.context.onRenderError, error);
	    }, _this.drawPageOnCanvas = function (canvas) {
	      if (!canvas) {
	        return null;
	      }
	
	      var page = _this.context.page;
	      var _this2 = _this,
	          renderViewport = _this2.renderViewport,
	          viewport = _this2.viewport;
	
	
	      canvas.width = renderViewport.width;
	      canvas.height = renderViewport.height;
	
	      canvas.style.width = Math.floor(viewport.width) + 'px';
	      canvas.style.height = Math.floor(viewport.height) + 'px';
	
	      var renderContext = {
	        get canvasContext() {
	          return canvas.getContext('2d');
	        },
	        viewport: renderViewport
	      };
	
	      // If another render is in progress, let's cancel it
	      /* eslint-disable no-underscore-dangle */
	      if (_this.renderer && _this.renderer._internalRenderTask.running) {
	        _this.renderer._internalRenderTask.cancel();
	      }
	      /* eslint-enable no-underscore-dangle */
	
	      _this.renderer = page.render(renderContext);
	
	      return _this.renderer.then(_this.onRenderSuccess).catch(_this.onRenderError);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PageCanvas, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      /* eslint-disable no-underscore-dangle */
	      if (this.renderer && this.renderer._internalRenderTask.running) {
	        this.renderer._internalRenderTask.cancel();
	      }
	      /* eslint-enable no-underscore-dangle */
	    }
	
	    /**
	     * Called when a page is rendered successfully.
	     */
	
	
	    /**
	     * Called when a page fails to render.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('canvas', {
	        className: 'react-pdf__Page__canvas',
	        style: {
	          display: 'block',
	          userSelect: 'none'
	        },
	        ref: this.drawPageOnCanvas
	      });
	    }
	  }, {
	    key: 'renderViewport',
	    get: function get() {
	      var _context = this.context,
	          page = _context.page,
	          rotate = _context.rotate,
	          scale = _context.scale;
	
	
	      var pixelRatio = (0, _utils.getPixelRatio)();
	
	      return page.getViewport(scale * pixelRatio, rotate);
	    }
	  }, {
	    key: 'viewport',
	    get: function get() {
	      var _context2 = this.context,
	          page = _context2.page,
	          rotate = _context2.rotate,
	          scale = _context2.scale;
	
	
	      return page.getViewport(scale, rotate);
	    }
	  }]);
	  return PageCanvas;
	}(_react.Component);
	
	exports.default = PageCanvas;
	
	
	PageCanvas.contextTypes = {
	  onRenderError: _propTypes2.default.func,
	  onRenderSuccess: _propTypes2.default.func,
	  page: _propTypes3.isPage.isRequired,
	  rotate: _propTypes3.isRotate,
	  scale: _propTypes2.default.number
	};

/***/ },
/* 1921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(90);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(91);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(106);
	
	var _propTypes3 = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageSVG = function (_Component) {
	  (0, _inherits3.default)(PageSVG, _Component);
	
	  function PageSVG() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PageSVG);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PageSVG.__proto__ || (0, _getPrototypeOf2.default)(PageSVG)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      svg: null
	    }, _this.onRenderSuccess = function () {
	      _this.renderer = null;
	
	      var _this$context = _this.context,
	          page = _this$context.page,
	          scale = _this$context.scale;
	
	
	      (0, _utils.callIfDefined)(_this.context.onRenderSuccess, (0, _utils.makePageCallback)(page, scale));
	    }, _this.onRenderError = function (error) {
	      if (error.name === 'RenderingCancelledException') {
	        return;
	      }
	
	      (0, _utils.callIfDefined)(_this.context.onRenderError, error);
	    }, _this.renderSVG = function () {
	      var page = _this.context.page;
	
	
	      _this.renderer = page.getOperatorList();
	
	      return _this.renderer.then(function (operatorList) {
	        var svgGfx = new PDFJS.SVGGraphics(page.commonObjs, page.objs);
	        _this.renderer = svgGfx.getSVG(operatorList, _this.viewport).then(function (svg) {
	          svg.style.maxWidth = '100%';
	          svg.style.height = 'auto';
	          _this.setState({ svg: svg }, function () {
	            return _this.onRenderSuccess();
	          });
	        }).catch(_this.onRenderError);
	      }).catch(_this.onRenderError);
	    }, _this.drawPageOnContainer = function (element) {
	      var svg = _this.state.svg;
	
	
	      if (!element || !svg) {
	        return;
	      }
	
	      var renderedPage = element.firstElementChild;
	      if (renderedPage) {
	        var _this$viewport = _this.viewport,
	            width = _this$viewport.width,
	            height = _this$viewport.height;
	
	        renderedPage.setAttribute('width', width);
	        renderedPage.setAttribute('height', height);
	      } else {
	        element.appendChild(svg);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PageSVG, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderSVG();
	    }
	
	    /**
	     * Called when a page is rendered successfully.
	     */
	
	
	    /**
	     * Called when a page fails to render.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement('div', {
	        className: 'react-pdf__Page__svg',
	        style: {
	          display: 'block',
	          backgroundColor: 'white'
	        }
	        // Note: This cannot be shortened, as we need this function to be called with each render.
	        , ref: function ref(_ref2) {
	          return _this2.drawPageOnContainer(_ref2);
	        }
	      });
	    }
	  }, {
	    key: 'viewport',
	    get: function get() {
	      var _context = this.context,
	          page = _context.page,
	          rotate = _context.rotate,
	          scale = _context.scale;
	
	
	      return page.getViewport(scale, rotate);
	    }
	  }]);
	  return PageSVG;
	}(_react.Component);
	
	exports.default = PageSVG;
	
	
	PageSVG.contextTypes = {
	  onRenderError: _propTypes2.default.func,
	  onRenderSuccess: _propTypes2.default.func,
	  page: _propTypes3.isPage.isRequired,
	  rotate: _propTypes3.isRotate,
	  scale: _propTypes2.default.number
	};

/***/ },
/* 1922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(90);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(91);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextLayerItem = __webpack_require__(1923);
	
	var _TextLayerItem2 = _interopRequireDefault(_TextLayerItem);
	
	var _utils = __webpack_require__(106);
	
	var _propTypes3 = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TextLayer = function (_Component) {
	  (0, _inherits3.default)(TextLayer, _Component);
	
	  function TextLayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TextLayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextLayer.__proto__ || (0, _getPrototypeOf2.default)(TextLayer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      textItems: null
	    }, _this.onGetTextSuccess = function (textContent) {
	      var textItems = null;
	      if (textContent) {
	        textItems = textContent.items;
	      }
	
	      (0, _utils.callIfDefined)(_this.context.onGetTextSuccess, textItems);
	
	      _this.setState({ textItems: textItems });
	    }, _this.onGetTextError = function (error) {
	      if (error.name === 'RenderingCancelledException' || error.name === 'PromiseCancelledException') {
	        return;
	      }
	
	      (0, _utils.errorOnDev)(error.message, error);
	
	      (0, _utils.callIfDefined)(_this.context.onGetTextError, error);
	
	      _this.setState({ textItems: false });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TextLayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getTextContent();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps, nextContext) {
	      if (nextContext.page !== this.context.page) {
	        if (this.state.textItems !== null) {
	          this.setState({ textItems: null });
	        }
	
	        this.getTextContent(nextContext);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _utils.cancelRunningTask)(this.runningTask);
	    }
	  }, {
	    key: 'getTextContent',
	    value: function getTextContent() {
	      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.context;
	      var page = context.page;
	
	
	      if (!page) {
	        throw new Error('Attempted to load page text content, but no page was specified.');
	      }
	
	      this.runningTask = (0, _utils.makeCancellable)(page.getTextContent());
	
	      return this.runningTask.promise.then(this.onGetTextSuccess).catch(this.onGetTextError);
	    }
	  }, {
	    key: 'renderTextItems',
	    value: function renderTextItems() {
	      var textItems = this.state.textItems;
	
	
	      if (!textItems) {
	        return null;
	      }
	
	      return textItems.map(function (textItem, itemIndex) {
	        return _react2.default.createElement(_TextLayerItem2.default
	        // eslint-disable-next-line react/no-array-index-key
	        , (0, _extends3.default)({ key: itemIndex,
	          itemIndex: itemIndex
	        }, textItem));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var viewport = this.unrotatedViewport,
	          rotate = this.rotate;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'react-pdf__Page__textContent',
	          style: {
	            position: 'absolute',
	            top: '50%',
	            left: '50%',
	            width: viewport.width + 'px',
	            height: viewport.height + 'px',
	            color: 'transparent',
	            transform: 'translate(-50%, -50%) rotate(' + rotate + 'deg)',
	            pointerEvents: 'none'
	          }
	        },
	        this.renderTextItems()
	      );
	    }
	  }, {
	    key: 'unrotatedViewport',
	    get: function get() {
	      var _context = this.context,
	          page = _context.page,
	          scale = _context.scale;
	
	
	      return page.getViewport(scale);
	    }
	
	    /**
	     * It might happen that the page is rotated by default. In such cases, we shouldn't rotate
	     * text content.
	     */
	
	  }, {
	    key: 'rotate',
	    get: function get() {
	      var _context2 = this.context,
	          page = _context2.page,
	          rotate = _context2.rotate;
	
	      return rotate - page.rotate;
	    }
	  }]);
	  return TextLayer;
	}(_react.Component);
	
	exports.default = TextLayer;
	
	
	TextLayer.contextTypes = {
	  onGetTextError: _propTypes2.default.func,
	  onGetTextSuccess: _propTypes2.default.func,
	  page: _propTypes3.isPage.isRequired,
	  rotate: _propTypes3.isRotate,
	  scale: _propTypes2.default.number
	};

/***/ },
/* 1923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(511);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _regenerator = __webpack_require__(512);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(510);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(90);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(91);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propTypes3 = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Render disproportion above which font will be considered broken and fallback will be used
	var BROKEN_FONT_ALARM_THRESHOLD = 0.1;
	
	var TextLayerItem = function (_PureComponent) {
	  (0, _inherits3.default)(TextLayerItem, _PureComponent);
	
	  function TextLayerItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TextLayerItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextLayerItem.__proto__ || (0, _getPrototypeOf2.default)(TextLayerItem)).call.apply(_ref, [this].concat(args))), _this), _this.getElementWidth = function (element) {
	      var _this2 = _this,
	          sideways = _this2.sideways;
	
	      return element.getBoundingClientRect()[sideways ? 'height' : 'width'];
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TextLayerItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.alignTextItem();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.alignTextItem();
	    }
	  }, {
	    key: 'getFontData',
	    value: function () {
	      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(fontFamily) {
	        var page, font;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                page = this.context.page;
	                _context.next = 3;
	                return page.commonObjs.ensureObj(fontFamily);
	
	              case 3:
	                font = _context.sent;
	                return _context.abrupt('return', font.data);
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function getFontData(_x) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getFontData;
	    }()
	  }, {
	    key: 'alignTextItem',
	    value: function () {
	      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
	        var element, scale, _props, fontName, width, targetWidth, fontData, actualWidth, widthDisproportion, repairsNeeded, fallbackFontName, ascent;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (this.item) {
	                  _context2.next = 2;
	                  break;
	                }
	
	                return _context2.abrupt('return');
	
	              case 2:
	                element = this.item;
	
	                element.style.transform = '';
	
	                scale = this.context.scale;
	                _props = this.props, fontName = _props.fontName, width = _props.width;
	                targetWidth = width * scale;
	                _context2.next = 9;
	                return this.getFontData(fontName);
	
	              case 9:
	                fontData = _context2.sent;
	                actualWidth = this.getElementWidth(element);
	                widthDisproportion = Math.abs(targetWidth / actualWidth - 1);
	                repairsNeeded = widthDisproportion > BROKEN_FONT_ALARM_THRESHOLD;
	
	                if (repairsNeeded) {
	                  fallbackFontName = fontData ? fontData.fallbackName : 'sans-serif';
	
	                  element.style.fontFamily = fallbackFontName;
	
	                  actualWidth = this.getElementWidth(element);
	                }
	
	                ascent = fontData ? fontData.ascent : 1;
	
	
	                element.style.transform = 'scaleX(' + targetWidth / actualWidth + ') translateY(' + (1 - ascent) * 100 + '%)';
	
	              case 16:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function alignTextItem() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return alignTextItem;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var fontSize = this.fontSize,
	          top = this.top,
	          left = this.left;
	      var scale = this.context.scale;
	      var _props2 = this.props,
	          fontName = _props2.fontName,
	          text = _props2.str;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: {
	            height: '1em',
	            fontFamily: fontName,
	            fontSize: fontSize * scale + 'px',
	            position: 'absolute',
	            top: top * scale + 'px',
	            left: left * scale + 'px',
	            transformOrigin: 'left bottom',
	            whiteSpace: 'pre',
	            pointerEvents: 'all'
	          },
	          ref: function ref(_ref4) {
	            _this3.item = _ref4;
	          }
	        },
	        this.context.customTextRenderer ? this.context.customTextRenderer(this.props) : text
	      );
	    }
	  }, {
	    key: 'unrotatedViewport',
	    get: function get() {
	      var _context3 = this.context,
	          page = _context3.page,
	          scale = _context3.scale;
	
	
	      return page.getViewport(scale);
	    }
	
	    /**
	     * It might happen that the page is rotated by default. In such cases, we shouldn't rotate
	     * text content.
	     */
	
	  }, {
	    key: 'rotate',
	    get: function get() {
	      var _context4 = this.context,
	          page = _context4.page,
	          rotate = _context4.rotate;
	
	      return rotate - page.rotate;
	    }
	  }, {
	    key: 'sideways',
	    get: function get() {
	      var rotate = this.rotate;
	
	      return rotate % 180 !== 0;
	    }
	  }, {
	    key: 'defaultSideways',
	    get: function get() {
	      var rotation = this.unrotatedViewport.rotation;
	
	      return rotation % 180 !== 0;
	    }
	  }, {
	    key: 'fontSize',
	    get: function get() {
	      var transform = this.props.transform;
	      var defaultSideways = this.defaultSideways;
	
	      var _transform = (0, _slicedToArray3.default)(transform, 2),
	          fontHeightPx = _transform[0],
	          fontWidthPx = _transform[1];
	
	      return defaultSideways ? fontWidthPx : fontHeightPx;
	    }
	  }, {
	    key: 'top',
	    get: function get() {
	      var transform = this.props.transform;
	      var viewport = this.unrotatedViewport,
	          defaultSideways = this.defaultSideways;
	
	      var _transform2 = (0, _slicedToArray3.default)(transform, 6),
	          /* fontHeightPx */offsetX = _transform2[2],
	          offsetY = _transform2[3],
	          x = _transform2[4],
	          y = _transform2[5];
	
	      var _viewport$viewBox = (0, _slicedToArray3.default)(viewport.viewBox, 4),
	          /* xMin */yMin = _viewport$viewBox[1],
	          /* xMax */yMax = _viewport$viewBox[3];
	
	      return defaultSideways ? x + offsetX + yMin : yMax - (y + offsetY);
	    }
	  }, {
	    key: 'left',
	    get: function get() {
	      var transform = this.props.transform;
	      var viewport = this.unrotatedViewport,
	          defaultSideways = this.defaultSideways;
	
	      var _transform3 = (0, _slicedToArray3.default)(transform, 6),
	          /* fontHeightPx */ /* fontWidthPx */ /* offsetX */x = _transform3[4],
	          y = _transform3[5];
	
	      var _viewport$viewBox2 = (0, _slicedToArray3.default)(viewport.viewBox, 1),
	          xMin = _viewport$viewBox2[0];
	
	      return defaultSideways ? y - xMin : x - xMin;
	    }
	  }]);
	  return TextLayerItem;
	}(_react.PureComponent);
	
	exports.default = TextLayerItem;
	
	
	TextLayerItem.contextTypes = {
	  customTextRenderer: _propTypes2.default.func,
	  page: _propTypes3.isPage.isRequired,
	  rotate: _propTypes3.isRotate,
	  scale: _propTypes2.default.number
	};
	
	TextLayerItem.propTypes = {
	  fontName: _propTypes2.default.string.isRequired,
	  itemIndex: _propTypes2.default.number.isRequired, // eslint-disable-line react/no-unused-prop-types
	  str: _propTypes2.default.string.isRequired,
	  transform: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
	  width: _propTypes2.default.number.isRequired
	};

/***/ },
/* 1924 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(91);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Ref = function () {
	  function Ref(_ref) {
	    var num = _ref.num,
	        gen = _ref.gen;
	    (0, _classCallCheck3.default)(this, Ref);
	
	    this.num = num;
	    this.gen = gen;
	  }
	
	  (0, _createClass3.default)(Ref, [{
	    key: "toString",
	    value: function toString() {
	      var str = this.num + "R";
	      if (this.gen !== 0) {
	        str += this.gen;
	      }
	      return str;
	    }
	  }]);
	  return Ref;
	}();
	
	exports.default = Ref;

/***/ },
/* 1925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setOptions = exports.Page = exports.Outline = exports.Document = undefined;
	
	var _Document = __webpack_require__(1915);
	
	var _Document2 = _interopRequireDefault(_Document);
	
	var _Outline = __webpack_require__(1916);
	
	var _Outline2 = _interopRequireDefault(_Outline);
	
	var _Page = __webpack_require__(1918);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _setOptions = __webpack_require__(1926);
	
	var _setOptions2 = _interopRequireDefault(_setOptions);
	
	var _utils = __webpack_require__(106);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (_utils.isLocalFileSystem) {
	  // eslint-disable-next-line no-console
	  (0, _utils.warnOnDev)('You are running React-PDF from your local file system. PDF.js Worker may fail to load due to browser\'s security policies. If you\'re on Google Chrome, you can use --allow-file-access-from-files flag for debugging purposes.');
	}
	
	var pdfjs = __webpack_require__(1720);
	
	var setOptions = (0, _setOptions2.default)(pdfjs);
	
	exports.Document = _Document2.default;
	exports.Outline = _Outline2.default;
	exports.Page = _Page2.default;
	exports.setOptions = setOptions;

/***/ },
/* 1926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(1227);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var allowedProperties = ['cMapUrl', 'cMapPacked', 'disableWorker', 'workerSrc', 'workerPort'];
	
	var makeSetOptions = function makeSetOptions(pdfjs) {
	  return function (options) {
	    if (!(options instanceof Object)) {
	      return;
	    }
	
	    /* eslint-disable no-param-reassign */
	    (0, _keys2.default)(options).filter(function (property) {
	      return allowedProperties.includes(property);
	    }).forEach(function (property) {
	      pdfjs.PDFJS[property] = options[property];
	    });
	  };
	};
	
	exports.default = makeSetOptions;

/***/ },
/* 1927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // This file is a fallback for a consumer who is not yet on React 16
	// as createPortal was introduced in React 16
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(props) {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _reactDom2.default.unmountComponentAtNode(this.defaultNode || this.props.node);
	      if (this.defaultNode) {
	        document.body.removeChild(this.defaultNode);
	      }
	      this.defaultNode = null;
	      this.portal = null;
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal(props) {
	      if (!this.props.node && !this.defaultNode) {
	        this.defaultNode = document.createElement('div');
	        document.body.appendChild(this.defaultNode);
	      }
	
	      var children = this.props.children;
	      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
	      if (typeof this.props.children.type === 'function') {
	        children = _react2.default.cloneElement(this.props.children);
	      }
	
	      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	exports.default = Portal;
	
	
	Portal.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  node: _propTypes2.default.any
	};

/***/ },
/* 1928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utils = __webpack_require__(1930);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.defaultNode) {
	        document.body.removeChild(this.defaultNode);
	      }
	      this.defaultNode = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!_utils.canUseDOM) {
	        return null;
	      }
	      if (!this.props.node && !this.defaultNode) {
	        this.defaultNode = document.createElement('div');
	        document.body.appendChild(this.defaultNode);
	      }
	      return _reactDom2.default.createPortal(this.props.children, this.props.node || this.defaultNode);
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  node: _propTypes2.default.any
	};
	
	exports.default = Portal;

/***/ },
/* 1929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PortalCompat = __webpack_require__(908);
	
	var _PortalCompat2 = _interopRequireDefault(_PortalCompat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYCODES = {
	  ESCAPE: 27
	};
	
	var PortalWithState = function (_React$Component) {
	  _inherits(PortalWithState, _React$Component);
	
	  function PortalWithState(props) {
	    _classCallCheck(this, PortalWithState);
	
	    var _this = _possibleConstructorReturn(this, (PortalWithState.__proto__ || Object.getPrototypeOf(PortalWithState)).call(this, props));
	
	    _this.portalNode = null;
	    _this.state = { active: !!props.defaultOpen };
	    _this.openPortal = _this.openPortal.bind(_this);
	    _this.closePortal = _this.closePortal.bind(_this);
	    _this.wrapWithPortal = _this.wrapWithPortal.bind(_this);
	    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
	    _this.handleKeydown = _this.handleKeydown.bind(_this);
	    return _this;
	  }
	
	  _createClass(PortalWithState, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.closeOnEsc) {
	        document.addEventListener('keydown', this.handleKeydown);
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.addEventListener('click', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.closeOnEsc) {
	        document.removeEventListener('keydown', this.handleKeydown);
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.removeEventListener('click', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'openPortal',
	    value: function openPortal(e) {
	      if (this.state.active) {
	        return;
	      }
	      if (e && e.nativeEvent) {
	        e.nativeEvent.stopImmediatePropagation();
	      }
	      this.setState({ active: true }, this.props.onOpen);
	    }
	  }, {
	    key: 'closePortal',
	    value: function closePortal() {
	      if (!this.state.active) {
	        return;
	      }
	      this.setState({ active: false }, this.props.onClose);
	    }
	  }, {
	    key: 'wrapWithPortal',
	    value: function wrapWithPortal(children) {
	      var _this2 = this;
	
	      if (!this.state.active) {
	        return null;
	      }
	      return _react2.default.createElement(
	        _PortalCompat2.default,
	        {
	          node: this.props.node,
	          key: 'react-portal',
	          ref: function ref(portalNode) {
	            return _this2.portalNode = portalNode;
	          }
	        },
	        children
	      );
	    }
	  }, {
	    key: 'handleOutsideMouseClick',
	    value: function handleOutsideMouseClick(e) {
	      if (!this.state.active) {
	        return;
	      }
	      var root = this.portalNode && (this.portalNode.props.node || this.portalNode.defaultNode);
	      if (!root || root.contains(e.target) || e.button && e.button !== 0) {
	        return;
	      }
	      this.closePortal();
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
	        this.closePortal();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children({
	        openPortal: this.openPortal,
	        closePortal: this.closePortal,
	        portal: this.wrapWithPortal,
	        isOpen: this.state.active
	      });
	    }
	  }]);
	
	  return PortalWithState;
	}(_react2.default.Component);
	
	PortalWithState.propTypes = {
	  children: _propTypes2.default.func.isRequired,
	  defaultOpen: _propTypes2.default.bool,
	  node: _propTypes2.default.any,
	  closeOnEsc: _propTypes2.default.bool,
	  closeOnOutsideClick: _propTypes2.default.bool,
	  onOpen: _propTypes2.default.func,
	  onClose: _propTypes2.default.func
	};
	
	PortalWithState.defaultProps = {
	  onOpen: function onOpen() {},
	  onClose: function onClose() {}
	};
	
	exports.default = PortalWithState;

/***/ },
/* 1930 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 1931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(1933);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-debugger: "warn" */
	
	
	/**
	 * Predefined constants
	 * @type {Object}
	 */
	var constants = {
	  orientation: {
	    horizontal: {
	      dimension: 'width',
	      direction: 'left',
	      coordinate: 'x'
	    },
	    vertical: {
	      dimension: 'height',
	      direction: 'top',
	      coordinate: 'y'
	    }
	  }
	};
	
	var Slider = function (_Component) {
	  _inherits(Slider, _Component);
	
	  function Slider(props, context) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props, context));
	
	    _this.handleNoop = function (e) {
	      e.stopPropagation();
	      e.preventDefault();
	    };
	
	    _this.handleUpdate = function () {
	      var orientation = _this.props.orientation;
	
	      var dimension = (0, _utils.capitalize)(constants.orientation[orientation].dimension);
	      var sliderPos = _this.slider['offset' + dimension];
	      var handlePos = _this.handle['offset' + dimension];
	      _this.setState({
	        limit: sliderPos - handlePos,
	        grab: handlePos / 2
	      });
	    };
	
	    _this.handleStart = function () {
	      document.addEventListener('mousemove', _this.handleDrag);
	      document.addEventListener('mouseup', _this.handleEnd);
	    };
	
	    _this.handleDrag = function (e) {
	      _this.handleNoop(e);
	      var onChange = _this.props.onChange;
	
	      if (!onChange) return;
	
	      var value = _this.position(e);
	      onChange && onChange(value);
	    };
	
	    _this.handleEnd = function () {
	      document.removeEventListener('mousemove', _this.handleDrag);
	      document.removeEventListener('mouseup', _this.handleEnd);
	    };
	
	    _this.getPositionFromValue = function (value) {
	      var limit = _this.state.limit;
	      var _this$props = _this.props;
	      var min = _this$props.min;
	      var max = _this$props.max;
	
	      var diffMaxMin = max - min;
	      var diffValMin = value - min;
	      var percentage = diffValMin / diffMaxMin;
	      var pos = Math.round(percentage * limit);
	
	      return pos;
	    };
	
	    _this.getValueFromPosition = function (pos) {
	      var value = null;
	      var limit = _this.state.limit;
	      var _this$props2 = _this.props;
	      var orientation = _this$props2.orientation;
	      var min = _this$props2.min;
	      var max = _this$props2.max;
	      var step = _this$props2.step;
	
	      var percentage = (0, _utils.clamp)(pos, 0, limit) / (limit || 1);
	      var baseVal = step * Math.round(percentage * (max - min) / step);
	
	      if (orientation === 'horizontal') {
	        value = baseVal + min;
	      } else {
	        value = max - baseVal;
	      }
	
	      if (value >= max) value = max;
	      if (value <= min) value = min;
	
	      return value;
	    };
	
	    _this.position = function (e) {
	      var grab = _this.state.grab;
	      var orientation = _this.props.orientation;
	
	      var node = _this.slider;
	      var coordinateStyle = constants.orientation[orientation].coordinate;
	      var directionStyle = constants.orientation[orientation].direction;
	      var clientCoordinateStyle = 'client' + (0, _utils.capitalize)(coordinateStyle);
	      var coordinate = !e.touches ? e[clientCoordinateStyle] : e.touches[0][clientCoordinateStyle];
	      var direction = node.getBoundingClientRect()[directionStyle];
	
	      var pos = coordinate - direction - grab;
	      var value = _this.getValueFromPosition(pos);
	
	      return value;
	    };
	
	    _this.coordinates = function (pos) {
	      var fillPos = null;
	      var _this$state = _this.state;
	      var limit = _this$state.limit;
	      var grab = _this$state.grab;
	      var orientation = _this.props.orientation;
	
	      var value = _this.getValueFromPosition(pos);
	      var handlePos = _this.getPositionFromValue(value);
	      var sumHandleposGrab = orientation === 'horizontal' ? handlePos + grab : handlePos;
	
	      if (orientation === 'horizontal') {
	        fillPos = sumHandleposGrab;
	      } else {
	        fillPos = limit - sumHandleposGrab;
	      }
	
	      return {
	        fill: fillPos,
	        handle: handlePos
	      };
	    };
	
	    _this.state = {
	      limit: 0,
	      grab: 0
	    };
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.handleUpdate);
	      this.handleUpdate();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleUpdate);
	    }
	
	    /**
	     * Prevent default event and bubbling
	     * @param  {Object} e - Event object
	     * @return {void}
	     */
	
	
	    /**
	     * Update slider state on change
	     * @return {void}
	     */
	
	
	    /**
	     * Attach event listeners to mousemove/mouseup events
	     * @return {void}
	     */
	
	
	    /**
	     * Handle drag/mousemove event
	     * @param  {Object} e - Event object
	     * @return {void}
	     */
	
	
	    /**
	     * Detach event listeners to mousemove/mouseup events
	     * @return {void}
	     */
	
	
	    /**
	     * Calculate position of slider based on its value
	     * @param  {number} value - Current value of slider
	     * @return {position} pos - Calculated position of slider based on value
	     */
	
	
	    /**
	     * Translate position of slider to slider value
	     * @param  {number} pos - Current position/coordinates of slider
	     * @return {number} value - Slider value
	     */
	
	
	    /**
	     * Calculate position of slider based on value
	     * @param  {Object} e - Event object
	     * @return {number} value - Slider value
	     */
	
	
	    /**
	     * Grab coordinates of slider
	     * @param  {Object} pos - Position object
	     * @return {Object} - Slider fill/handle coordinates
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var value = _props.value;
	      var orientation = _props.orientation;
	      var className = _props.className;
	
	      var dimension = constants.orientation[orientation].dimension;
	      var direction = constants.orientation[orientation].direction;
	      var position = this.getPositionFromValue(value);
	      var coords = this.coordinates(position);
	      var fillStyle = _defineProperty({}, dimension, coords.fill + 'px');
	      var handleStyle = _defineProperty({}, direction, coords.handle + 'px');
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: function ref(s) {
	            _this2.slider = s;
	          },
	          className: (0, _classnames2.default)('rangeslider', 'rangeslider-' + orientation, className),
	          onMouseDown: this.handleDrag,
	          onTouchStart: this.handleDrag,
	          onTouchEnd: this.handleNoop
	        },
	        _react2.default.createElement('div', {
	          className: 'rangeslider__fill',
	          style: fillStyle
	        }),
	        _react2.default.createElement('div', {
	          ref: function ref(sh) {
	            _this2.handle = sh;
	          },
	          className: 'rangeslider__handle',
	          onMouseDown: this.handleStart,
	          onTouchEnd: this.handleNoop,
	          onTouchMove: this.handleDrag,
	          style: handleStyle
	        })
	      );
	    }
	  }]);
	
	  return Slider;
	}(_react.Component);
	
	Slider.propTypes = {
	  min: _react.PropTypes.number,
	  max: _react.PropTypes.number,
	  step: _react.PropTypes.number,
	  value: _react.PropTypes.number,
	  orientation: _react.PropTypes.string,
	  onChange: _react.PropTypes.func,
	  className: _react.PropTypes.string
	};
	Slider.defaultProps = {
	  min: 0,
	  max: 100,
	  step: 1,
	  value: 0,
	  orientation: 'horizontal'
	};
	exports.default = Slider;

/***/ },
/* 1932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Rangeslider = __webpack_require__(1931);
	
	var _Rangeslider2 = _interopRequireDefault(_Rangeslider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Rangeslider2.default;

/***/ },
/* 1933 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.capitalize = capitalize;
	exports.clamp = clamp;
	/**
	 * Capitalize first letter of string
	 * @private
	 * @param  {string} - String
	 * @return {string} - String with first letter capitalized
	 */
	function capitalize(str) {
	  return str.charAt(0).toUpperCase() + str.substr(1);
	}
	
	/**
	 * Clamp position between a range
	 * @param  {number} - Value to be clamped
	 * @param  {number} - Minimum value in range
	 * @param  {number} - Maximum value in range
	 * @return {number} - Clamped value
	 */
	function clamp(value, min, max) {
	  return Math.min(Math.max(value, min), max);
	}

/***/ },
/* 1934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(910);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(911);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _react.PropTypes.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ },
/* 1935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(910);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(1936);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(1937);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(911);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(417);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(1938);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 1936 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 1937 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(233);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ },
/* 1938 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 1939 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(115);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(912);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 1940 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(115);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _routerWarning = __webpack_require__(183);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(914);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 1941 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(115);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _routerWarning = __webpack_require__(183);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(128);
	
	var _InternalPropTypes = __webpack_require__(231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 1942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(115);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(128);
	
	var _InternalPropTypes = __webpack_require__(231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 1943 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(115);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _createTransitionManager2 = __webpack_require__(918);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(231);
	
	var _RouterContext = __webpack_require__(463);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(128);
	
	var _RouterUtils = __webpack_require__(915);
	
	var _routerWarning = __webpack_require__(183);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	};
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	if (prefixUnsafeLifecycleMethods) {
	  Router.prototype.UNSAFE_componentWillReceiveProps = Router.prototype.componentWillReceiveProps;
	  Router.prototype.UNSAFE_componentWillMount = Router.prototype.componentWillMount;
	  delete Router.prototype.componentWillReceiveProps;
	  delete Router.prototype.componentWillMount;
	}
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 1944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(460);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 1945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(463);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(183);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 1946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(1528);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(917);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1947 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(182);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 1948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(460);
	
	var _PromiseUtils = __webpack_require__(913);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 1949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(182);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 1950 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(1529);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(917);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1951 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(182);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 1952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(275);
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(916);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(918);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(128);
	
	var _RouterUtils = __webpack_require__(915);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 1953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(460);
	
	var _PromiseUtils = __webpack_require__(913);
	
	var _PatternUtils = __webpack_require__(182);
	
	var _routerWarning = __webpack_require__(183);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 1954 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(115);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(405);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(461);
	
	var _PropTypes = __webpack_require__(462);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 1955 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(3),__webpack_require__(1),__webpack_require__(2034),__webpack_require__(2050)):"function"==typeof define&&define.amd?define(["prop-types","react","signature_pad","trim-canvas"],t):"object"==typeof exports?exports.SignatureCanvas=t(require("prop-types"),require("react"),require("signature_pad"),require("trim-canvas")):e.SignatureCanvas=t(e["prop-types"],e.react,e.signature_pad,e["trim-canvas"])}(this,function(e,t,n,r){return function(e){function t(r){if(n[r])return n[r].exports;var a=n[r]={exports:{},id:r,loaded:!1};return e[r].call(a.exports,a,a.exports,t),a.loaded=!0,a.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),f=n(1),p=r(f),l=n(2),d=r(l),v=n(3),h=r(v),_=n(4),g=r(_),m=function(e){function t(){var e,n,r,u;o(this,t);for(var s=arguments.length,c=Array(s),f=0;f<s;f++)c[f]=arguments[f];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(c))),r._sigPad=null,r._excludeOurProps=function(){var e=r.props,t=(e.canvasProps,e.clearOnResize,a(e,["canvasProps","clearOnResize"]));return t},r.getCanvas=function(){return r._canvas},r.getTrimmedCanvas=function(){var e=document.createElement("canvas");return e.width=r._canvas.width,e.height=r._canvas.height,e.getContext("2d").drawImage(r._canvas,0,0),(0,g.default)(e)},r.getSignaturePad=function(){return r._sigPad},r._checkClearOnResize=function(){r.props.clearOnResize&&r._resizeCanvas()},r._resizeCanvas=function(){var e=r.props.canvasProps||{},t=e.width,n=e.height;if(!t||!n){var a=r._canvas,o=Math.max(window.devicePixelRatio||1,1);t||(a.width=a.offsetWidth*o),n||(a.height=a.offsetHeight*o),a.getContext("2d").scale(o,o),r.clear()}},r.on=function(){return window.addEventListener("resize",r._checkClearOnResize),r._sigPad.on()},r.off=function(){return window.removeEventListener("resize",r._checkClearOnResize),r._sigPad.off()},r.clear=function(){return r._sigPad.clear()},r.isEmpty=function(){return r._sigPad.isEmpty()},r.fromDataURL=function(e,t){return r._sigPad.fromDataURL(e,t)},r.toDataURL=function(e,t){return r._sigPad.toDataURL(e,t)},r.fromData=function(e){return r._sigPad.fromData(e)},r.toData=function(){return r._sigPad.toData()},u=n,i(r,u)}return u(t,e),c(t,[{key:"componentDidMount",value:function(){this._sigPad=new h.default(this._canvas,this._excludeOurProps()),this._resizeCanvas(),this.on()}},{key:"componentWillUnmount",value:function(){this.off()}},{key:"componentDidUpdate",value:function(){Object.assign(this._sigPad,this._excludeOurProps())}},{key:"render",value:function(){var e=this,t=this.props.canvasProps;return d.default.createElement("canvas",s({ref:function(t){e._canvas=t}},t))}}]),t}(l.Component);m.propTypes={velocityFilterWeight:p.default.number,minWidth:p.default.number,maxWidth:p.default.number,minDistance:p.default.number,dotSize:p.default.oneOfType([p.default.number,p.default.func]),penColor:p.default.string,throttle:p.default.number,onEnd:p.default.func,onBegin:p.default.func,canvasProps:p.default.object,clearOnResize:p.default.bool},m.defaultProps={clearOnResize:!0},t.default=m},function(t,n){t.exports=e},function(e,n){e.exports=t},function(e,t){e.exports=n},function(e,t){e.exports=r}])});

/***/ },
/* 1956 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var _objectAssign = __webpack_require__(1957);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var truthy = function truthy(x) {
	  return x;
	};
	
	exports['default'] = function (input) {
	  var _ref = Array.isArray(input) && input.length === 2 ? input : [input, null];
	
	  var _ref2 = _slicedToArray(_ref, 2);
	
	  var theme = _ref2[0];
	  var classNameDecorator = _ref2[1];
	
	  return function (key) {
	    for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      names[_key - 1] = arguments[_key];
	    }
	
	    var styles = names.map(function (name) {
	      return theme[name];
	    }).filter(truthy);
	
	    return typeof styles[0] === 'string' || typeof classNameDecorator === 'function' ? { key: key, className: classNameDecorator ? classNameDecorator.apply(undefined, _toConsumableArray(styles)) : styles.join(' ') } : { key: key, style: _objectAssign2['default'].apply(undefined, [{}].concat(_toConsumableArray(styles))) };
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 1957 */
/***/ function(module, exports) {

	'use strict';
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function ownEnumerableKeys(obj) {
		var keys = Object.getOwnPropertyNames(obj);
	
		if (Object.getOwnPropertySymbols) {
			keys = keys.concat(Object.getOwnPropertySymbols(obj));
		}
	
		return keys.filter(function (key) {
			return propIsEnumerable.call(obj, key);
		});
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = ownEnumerableKeys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ },
/* 1958 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CHANNEL = exports.CHANNEL = '__direction__';
	
	var DIRECTIONS = exports.DIRECTIONS = {
	  LTR: 'ltr',
	  RTL: 'rtl'
	};

/***/ },
/* 1959 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].shape({
	  getState: _propTypes2['default'].func,
	  setState: _propTypes2['default'].func,
	  subscribe: _propTypes2['default'].func
	});

/***/ },
/* 1960 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _arrayPrototype = __webpack_require__(1088);
	
	var _arrayPrototype2 = _interopRequireDefault(_arrayPrototype);
	
	var _globalCache = __webpack_require__(1523);
	
	var _globalCache2 = _interopRequireDefault(_globalCache);
	
	var _constants = __webpack_require__(1961);
	
	var _getClassName = __webpack_require__(1962);
	
	var _getClassName2 = _interopRequireDefault(_getClassName);
	
	var _separateStyles2 = __webpack_require__(1963);
	
	var _separateStyles3 = _interopRequireDefault(_separateStyles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Function required as part of the react-with-styles interface. Parses the styles provided by
	 * react-with-styles to produce class names based on the style name and optionally the namespace if
	 * available.
	 *
	 * stylesObject {Object} The styles object passed to withStyles.
	 *
	 * Return an object mapping style names to class names.
	 */
	function create(stylesObject) {
	  var stylesToClasses = {};
	  var styleNames = Object.keys(stylesObject);
	  var sharedState = _globalCache2['default'].get(_constants.GLOBAL_CACHE_KEY) || {};
	  var _sharedState$namespac = sharedState.namespace,
	      namespace = _sharedState$namespac === undefined ? '' : _sharedState$namespac;
	
	  styleNames.forEach(function (styleName) {
	    var className = (0, _getClassName2['default'])(namespace, styleName);
	    stylesToClasses[styleName] = className;
	  });
	  return stylesToClasses;
	}
	
	/**
	 * Process styles to be consumed by a component.
	 *
	 * stylesArray {Array} Array of the following: values returned by create, plain JavaScript objects
	 * representing inline styles, or arrays thereof.
	 *
	 * Return an object with optional className and style properties to be spread on a component.
	 */
	function resolve(stylesArray) {
	  var flattenedStyles = (0, _arrayPrototype2['default'])(stylesArray, Infinity);
	
	  var _separateStyles = (0, _separateStyles3['default'])(flattenedStyles),
	      classNames = _separateStyles.classNames,
	      hasInlineStyles = _separateStyles.hasInlineStyles,
	      inlineStyles = _separateStyles.inlineStyles;
	
	  var specificClassNames = classNames.map(function (name, index) {
	    return String(name) + ' ' + String(name) + '_' + String(index + 1);
	  });
	  var className = specificClassNames.join(' ');
	
	  var result = { className: className };
	  if (hasInlineStyles) result.style = inlineStyles;
	  return result;
	}
	
	exports['default'] = { create: create, resolve: resolve };

/***/ },
/* 1961 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GLOBAL_CACHE_KEY = 'reactWithStylesInterfaceCSS';
	var MAX_SPECIFICITY = 20;
	
	exports.GLOBAL_CACHE_KEY = GLOBAL_CACHE_KEY;
	exports.MAX_SPECIFICITY = MAX_SPECIFICITY;

/***/ },
/* 1962 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getClassName;
	/**
	 * Construct a class name.
	 *
	 * namespace {String} Used to construct unique class names.
	 * styleName {String} Name identifying the specific style.
	 *
	 * Return the class name.
	 */
	function getClassName(namespace, styleName) {
	  var namespaceSegment = namespace.length > 0 ? String(namespace) + '__' : '';
	  return '' + namespaceSegment + String(styleName);
	}

/***/ },
/* 1963 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// This function takes an array of styles and separates them into styles that
	// are handled by Aphrodite and inline styles.
	function separateStyles(stylesArray) {
	  var classNames = [];
	
	  // Since determining if an Object is empty requires collecting all of its
	  // keys, and we want the best performance in this code because we are in the
	  // render path, we are going to do a little bookkeeping ourselves.
	  var hasInlineStyles = false;
	  var inlineStyles = {};
	
	  // This is run on potentially every node in the tree when rendering, where
	  // performance is critical. Normally we would prefer using `forEach`, but
	  // old-fashioned for loops are faster so that's what we have chosen here.
	  for (var i = 0; i < stylesArray.length; i++) {
	    // eslint-disable-line no-plusplus
	    var style = stylesArray[i];
	
	    // If this  style is falsy, we just want to disregard it. This allows for
	    // syntax like:
	    //
	    //   css(isFoo && styles.foo)
	    if (style) {
	      if (typeof style === 'string') {
	        classNames.push(style);
	      } else {
	        Object.assign(inlineStyles, style);
	        hasInlineStyles = true;
	      }
	    }
	  }
	
	  return {
	    classNames: classNames,
	    hasInlineStyles: hasInlineStyles,
	    inlineStyles: inlineStyles
	  };
	}
	
	exports['default'] = separateStyles;

/***/ },
/* 1964 */
/***/ function(module, exports, __webpack_require__) {

	// eslint-disable-next-line import/no-unresolved
	module.exports = __webpack_require__(1960).default;


/***/ },
/* 1965 */
442,
/* 1966 */
[2143, 232],
/* 1967 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1966);
	var ReactElement = __webpack_require__(185);
	
	var emptyFunction = __webpack_require__(99);
	var traverseAllChildren = __webpack_require__(1976);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 1968 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(185);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 1969 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(185),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(830);
	
	module.exports = factory(isValidElement);

/***/ },
/* 1970 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.7.0';


/***/ },
/* 1971 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(921),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(185),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(924);
	var factory = __webpack_require__(550);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 1972 */
1888,
/* 1973 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 1974 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 1975 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(232);
	
	var ReactElement = __webpack_require__(185);
	
	var invariant = __webpack_require__(20);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 1976 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(232);
	
	var ReactCurrentOwner = __webpack_require__(118);
	var REACT_ELEMENT_TYPE = __webpack_require__(923);
	
	var getIteratorFn = __webpack_require__(1972);
	var invariant = __webpack_require__(20);
	var KeyEscapeUtils = __webpack_require__(1965);
	var warning = __webpack_require__(25);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 1977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(19);
	
	var _createFieldProps2 = __webpack_require__(928);
	
	var _createFieldProps3 = _interopRequireDefault(_createFieldProps2);
	
	var _plain = __webpack_require__(148);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	var createConnectedField = function createConnectedField(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn;
	
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    var error = _plain2.default.getIn(syncErrors, name);
	    // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	    return error && error._error ? error._error : error;
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = _plain2.default.getIn(syncWarnings, name);
	    // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	    return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedField = function (_Component) {
	    _inherits(ConnectedField, _Component);
	
	    function ConnectedField() {
	      _classCallCheck(this, ConnectedField);
	
	      return _possibleConstructorReturn(this, (ConnectedField.__proto__ || Object.getPrototypeOf(ConnectedField)).apply(this, arguments));
	    }
	
	    _createClass(ConnectedField, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this2 = this;
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	        });
	      }
	    }, {
	      key: 'isPristine',
	      value: function isPristine() {
	        return this.props.pristine;
	      }
	    }, {
	      key: 'getValue',
	      value: function getValue() {
	        return this.props.value;
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.refs.renderedComponent;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            component = _props.component,
	            withRef = _props.withRef,
	            name = _props.name,
	            _reduxForm = _props._reduxForm,
	            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm']);
	
	        var asyncValidate = _reduxForm.asyncValidate,
	            blur = _reduxForm.blur,
	            change = _reduxForm.change,
	            focus = _reduxForm.focus;
	
	        var _createFieldProps = (0, _createFieldProps3.default)(getIn, name, _extends({}, rest, {
	          name: name,
	          blur: blur,
	          change: change,
	          focus: focus
	        }), asyncValidate),
	            custom = _createFieldProps.custom,
	            props = _objectWithoutProperties(_createFieldProps, ['custom']);
	
	        if (withRef) {
	          custom.ref = 'renderedComponent';
	        }
	        if (typeof component === 'string') {
	          var input = props.input,
	              meta = props.meta; // eslint-disable-line no-unused-vars
	          // flatten input into other props
	
	          return (0, _react.createElement)(component, _extends({}, input, custom));
	        } else {
	          return (0, _react.createElement)(component, _extends({}, props, custom));
	        }
	      }
	    }]);
	
	    return ConnectedField;
	  }(_react.Component);
	
	  ConnectedField.propTypes = {
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	    props: _react.PropTypes.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    var initialState = getIn(formState, 'initial.' + name);
	    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	    var value = getIn(formState, 'values.' + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = value === initial;
	    return {
	      asyncError: getIn(formState, 'asyncErrors.' + name),
	      asyncValidating: getIn(formState, 'asyncValidating') === name,
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, 'fields.' + name),
	      submitError: getIn(formState, 'submitErrors.' + name),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      value: value,
	      _value: ownProps.value // save value passed in (for checkboxes)
	    };
	  }, undefined, undefined, { withRef: true });
	  return connector(ConnectedField);
	};
	
	exports.default = createConnectedField;

/***/ },
/* 1978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mapValues2 = __webpack_require__(661);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(19);
	
	var _redux = __webpack_require__(233);
	
	var _createFieldArrayProps = __webpack_require__(1986);
	
	var _createFieldArrayProps2 = _interopRequireDefault(_createFieldArrayProps);
	
	var _plain = __webpack_require__(148);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm', 'value'];
	
	var createConnectedFieldArray = function createConnectedFieldArray(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn,
	      size = _ref.size;
	
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    // For an array, the error can _ONLY_ be under _error.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return _plain2.default.getIn(syncErrors, name + '._error');
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    // For an array, the warning can _ONLY_ be under _warning.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return _plain2.default.getIn(syncWarnings, name + '._warning');
	  };
	
	  var ConnectedFieldArray = function (_Component) {
	    _inherits(ConnectedFieldArray, _Component);
	
	    function ConnectedFieldArray() {
	      _classCallCheck(this, ConnectedFieldArray);
	
	      return _possibleConstructorReturn(this, (ConnectedFieldArray.__proto__ || Object.getPrototypeOf(ConnectedFieldArray)).apply(this, arguments));
	    }
	
	    _createClass(ConnectedFieldArray, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this2 = this;
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          // useful to debug rerenders
	          // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	          //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	          // }
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	        });
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.refs.renderedComponent;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        /*eslint no-unused-vars: ["error", { "varsIgnorePattern": "^_reduxForm$" }]*/
	        var _props = this.props,
	            component = _props.component,
	            withRef = _props.withRef,
	            name = _props.name,
	            _reduxForm = _props._reduxForm,
	            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm']);
	
	        var props = (0, _createFieldArrayProps2.default)(getIn, name, _extends({}, rest, {
	          name: name
	        }));
	        if (withRef) {
	          props.ref = 'renderedComponent';
	        }
	        return (0, _react.createElement)(component, props);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.props.dirty;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.props.pristine;
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.props.value;
	      }
	    }]);
	
	    return ConnectedFieldArray;
	  }(_react.Component);
	
	  ConnectedFieldArray.propTypes = {
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	    props: _react.PropTypes.object
	  };
	
	  ConnectedFieldArray.contextTypes = {
	    _reduxForm: _react.PropTypes.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    var initial = getIn(formState, 'initial.' + name) || initialValues && getIn(initialValues, name);
	    var value = getIn(formState, 'values.' + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(formState, 'asyncErrors.' + name + '._error'),
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, 'fields.' + name),
	      submitError: getIn(formState, 'submitErrors.' + name + '._error'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      value: value,
	      length: size(value)
	    };
	  }, function (dispatch, ownProps) {
	    var name = ownProps.name,
	        _reduxForm = ownProps._reduxForm;
	    var arrayInsert = _reduxForm.arrayInsert,
	        arrayMove = _reduxForm.arrayMove,
	        arrayPop = _reduxForm.arrayPop,
	        arrayPush = _reduxForm.arrayPush,
	        arrayRemove = _reduxForm.arrayRemove,
	        arrayRemoveAll = _reduxForm.arrayRemoveAll,
	        arrayShift = _reduxForm.arrayShift,
	        arraySplice = _reduxForm.arraySplice,
	        arraySwap = _reduxForm.arraySwap,
	        arrayUnshift = _reduxForm.arrayUnshift;
	
	    return (0, _mapValues3.default)({
	      arrayInsert: arrayInsert,
	      arrayMove: arrayMove,
	      arrayPop: arrayPop,
	      arrayPush: arrayPush,
	      arrayRemove: arrayRemove,
	      arrayRemoveAll: arrayRemoveAll,
	      arrayShift: arrayShift,
	      arraySplice: arraySplice,
	      arraySwap: arraySwap,
	      arrayUnshift: arrayUnshift
	    }, function (actionCreator) {
	      return (0, _redux.bindActionCreators)(actionCreator.bind(null, name), dispatch);
	    });
	  }, undefined, { withRef: true });
	  return connector(ConnectedFieldArray);
	};
	
	exports.default = createConnectedFieldArray;

/***/ },
/* 1979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(19);
	
	var _createFieldProps2 = __webpack_require__(928);
	
	var _createFieldProps3 = _interopRequireDefault(_createFieldProps2);
	
	var _plain = __webpack_require__(148);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	var createConnectedFields = function createConnectedFields(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn;
	
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    var error = _plain2.default.getIn(syncErrors, name);
	    // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	    return error && error._error ? error._error : error;
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = _plain2.default.getIn(syncWarnings, name);
	    // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	    return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedFields = function (_Component) {
	    _inherits(ConnectedFields, _Component);
	
	    function ConnectedFields() {
	      _classCallCheck(this, ConnectedFields);
	
	      return _possibleConstructorReturn(this, (ConnectedFields.__proto__ || Object.getPrototypeOf(ConnectedFields)).apply(this, arguments));
	    }
	
	    _createClass(ConnectedFields, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this2 = this;
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	        });
	      }
	    }, {
	      key: 'isDirty',
	      value: function isDirty() {
	        var _fields = this.props._fields;
	
	        return Object.keys(_fields).some(function (name) {
	          return _fields[name].dirty;
	        });
	      }
	    }, {
	      key: 'getValues',
	      value: function getValues() {
	        var _fields = this.props._fields;
	
	        return Object.keys(_fields).reduce(function (accumulator, name) {
	          return _plain2.default.setIn(accumulator, name, _fields[name].value);
	        }, {});
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.refs.renderedComponent;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            component = _props.component,
	            withRef = _props.withRef,
	            _fields = _props._fields,
	            _reduxForm = _props._reduxForm,
	            rest = _objectWithoutProperties(_props, ['component', 'withRef', '_fields', '_reduxForm']);
	
	        var asyncValidate = _reduxForm.asyncValidate,
	            blur = _reduxForm.blur,
	            change = _reduxForm.change,
	            focus = _reduxForm.focus,
	            sectionPrefix = _reduxForm.sectionPrefix;
	
	        var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
	          var connectedProps = _fields[name];
	
	          var _createFieldProps = (0, _createFieldProps3.default)(getIn, name, _extends({}, connectedProps, rest, {
	            blur: blur,
	            change: change,
	            focus: focus
	          }), asyncValidate),
	              custom = _createFieldProps.custom,
	              fieldProps = _objectWithoutProperties(_createFieldProps, ['custom']);
	
	          accumulator.custom = custom;
	          var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
	          return _plain2.default.setIn(accumulator, fieldName, fieldProps);
	        }, {}),
	            custom = _Object$keys$reduce.custom,
	            props = _objectWithoutProperties(_Object$keys$reduce, ['custom']);
	
	        if (withRef) {
	          props.ref = 'renderedComponent';
	        }
	
	        return (0, _react.createElement)(component, _extends({}, props, custom));
	      }
	    }]);
	
	    return ConnectedFields;
	  }(_react.Component);
	
	  ConnectedFields.propTypes = {
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	    _fields: _react.PropTypes.object.isRequired,
	    props: _react.PropTypes.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var names = ownProps.names,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    return {
	      _fields: names.reduce(function (accumulator, name) {
	        var initialState = getIn(formState, 'initial.' + name);
	        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	        var value = getIn(formState, 'values.' + name);
	        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	        var submitting = getIn(formState, 'submitting');
	        var pristine = value === initial;
	        accumulator[name] = {
	          asyncError: getIn(formState, 'asyncErrors.' + name),
	          asyncValidating: getIn(formState, 'asyncValidating') === name,
	          dirty: !pristine,
	          pristine: pristine,
	          state: getIn(formState, 'fields.' + name),
	          submitError: getIn(formState, 'submitErrors.' + name),
	          submitting: submitting,
	          syncError: syncError,
	          syncWarning: syncWarning,
	          value: value,
	          _value: ownProps.value // save value passed in (for checkboxes)
	        };
	        return accumulator;
	      }, {})
	    };
	  }, undefined, undefined, { withRef: true });
	  return connector(ConnectedFields);
	};
	
	exports.default = createConnectedFields;

/***/ },
/* 1980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedField = __webpack_require__(1977);
	
	var _ConnectedField2 = _interopRequireDefault(_ConnectedField);
	
	var _shallowCompare = __webpack_require__(467);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	var _prefixName = __webpack_require__(302);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createField = function createField(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn,
	      setIn = _ref.setIn;
	
	
	  var ConnectedField = (0, _ConnectedField2.default)({
	    deepEqual: deepEqual,
	    getIn: getIn
	  });
	
	  var Field = function (_Component) {
	    _inherits(Field, _Component);
	
	    function Field(props, context) {
	      _classCallCheck(this, Field);
	
	      var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props, context));
	
	      if (!context._reduxForm) {
	        throw new Error('Field must be inside a component decorated with reduxForm()');
	      }
	
	      _this.normalize = _this.normalize.bind(_this);
	      return _this;
	    }
	
	    _createClass(Field, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _shallowCompare2.default)(this, nextProps, nextState);
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        this.context._reduxForm.register(this.name, 'Field');
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.name !== nextProps.name) {
	          // unregister old name
	          this.context._reduxForm.unregister(this.name);
	          // register new name
	          this.context._reduxForm.register((0, _prefixName2.default)(this.context, nextProps.name), 'Field');
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.context._reduxForm.unregister(this.name);
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Field');
	        return this.refs.connected.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'normalize',
	      value: function normalize(name, value) {
	        var normalize = this.props.normalize;
	
	        if (!normalize) {
	          return value;
	        }
	        var previousValues = this.context._reduxForm.getValues();
	        var previousValue = this.value;
	        var nextValues = setIn(previousValues, name, value);
	        return normalize(value, previousValue, nextValues, previousValues);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return (0, _react.createElement)(ConnectedField, _extends({}, this.props, {
	          name: this.name,
	          normalize: this.normalize,
	          _reduxForm: this.context._reduxForm,
	          ref: 'connected'
	        }));
	      }
	    }, {
	      key: 'name',
	      get: function get() {
	        return (0, _prefixName2.default)(this.context, this.props.name);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return !this.pristine;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().isPristine();
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.refs.connected && this.refs.connected.getWrappedInstance().getValue();
	      }
	    }]);
	
	    return Field;
	  }(_react.Component);
	
	  Field.propTypes = {
	    name: _react.PropTypes.string.isRequired,
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	    format: _react.PropTypes.func,
	    normalize: _react.PropTypes.func,
	    parse: _react.PropTypes.func,
	    props: _react.PropTypes.object
	  };
	  Field.contextTypes = {
	    _reduxForm: _react.PropTypes.object
	  };
	
	  return Field;
	};
	
	exports.default = createField;

/***/ },
/* 1981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedFieldArray = __webpack_require__(1978);
	
	var _ConnectedFieldArray2 = _interopRequireDefault(_ConnectedFieldArray);
	
	var _shallowCompare = __webpack_require__(467);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	var _prefixName = __webpack_require__(302);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createFieldArray = function createFieldArray(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn,
	      size = _ref.size;
	
	
	  var ConnectedFieldArray = (0, _ConnectedFieldArray2.default)({ deepEqual: deepEqual, getIn: getIn, size: size });
	
	  var FieldArray = function (_Component) {
	    _inherits(FieldArray, _Component);
	
	    function FieldArray(props, context) {
	      _classCallCheck(this, FieldArray);
	
	      var _this = _possibleConstructorReturn(this, (FieldArray.__proto__ || Object.getPrototypeOf(FieldArray)).call(this, props, context));
	
	      if (!context._reduxForm) {
	        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
	      }
	      return _this;
	    }
	
	    _createClass(FieldArray, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _shallowCompare2.default)(this, nextProps, nextState);
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        this.context._reduxForm.register(this.name, 'FieldArray');
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.name !== nextProps.name) {
	          // unregister old name
	          this.context._reduxForm.unregister(this.name);
	          // register new name
	          this.context._reduxForm.register((0, _prefixName2.default)(this.context, nextProps.name), 'FieldArray');
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.context._reduxForm.unregister(this.name);
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to FieldArray');
	        return this.refs.connected.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return (0, _react.createElement)(ConnectedFieldArray, _extends({}, this.props, {
	          name: this.name,
	          syncError: this.syncError,
	          syncWarning: this.syncWarning,
	          _reduxForm: this.context._reduxForm,
	          ref: 'connected'
	        }));
	      }
	    }, {
	      key: 'name',
	      get: function get() {
	        return (0, _prefixName2.default)(this.context, this.props.name);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().dirty;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().pristine;
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().value;
	      }
	    }]);
	
	    return FieldArray;
	  }(_react.Component);
	
	  FieldArray.propTypes = {
	    name: _react.PropTypes.string.isRequired,
	    component: _react.PropTypes.func.isRequired,
	    props: _react.PropTypes.object
	  };
	  FieldArray.contextTypes = {
	    _reduxForm: _react.PropTypes.object
	  };
	
	  return FieldArray;
	};
	
	exports.default = createFieldArray;

/***/ },
/* 1982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedFields = __webpack_require__(1979);
	
	var _ConnectedFields2 = _interopRequireDefault(_ConnectedFields);
	
	var _shallowCompare = __webpack_require__(467);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	var _plain = __webpack_require__(148);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _prefixName = __webpack_require__(302);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validateNameProp = function validateNameProp(prop) {
	  if (!prop) {
	    return new Error('No "names" prop was specified <Fields/>');
	  }
	  if (!Array.isArray(prop) && !prop._isFieldArray) {
	    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
	  }
	};
	
	var createFields = function createFields(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn;
	
	
	  var ConnectedFields = (0, _ConnectedFields2.default)({
	    deepEqual: deepEqual,
	    getIn: getIn
	  });
	
	  var Fields = function (_Component) {
	    _inherits(Fields, _Component);
	
	    function Fields(props, context) {
	      _classCallCheck(this, Fields);
	
	      var _this = _possibleConstructorReturn(this, (Fields.__proto__ || Object.getPrototypeOf(Fields)).call(this, props, context));
	
	      if (!context._reduxForm) {
	        throw new Error('Fields must be inside a component decorated with reduxForm()');
	      }
	      return _this;
	    }
	
	    _createClass(Fields, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _shallowCompare2.default)(this, nextProps, nextState);
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var error = validateNameProp(this.props.names);
	        if (error) {
	          throw error;
	        }
	        var context = this.context;
	        var register = context._reduxForm.register;
	
	        this.names.forEach(function (name) {
	          return register((0, _prefixName2.default)(context, name), 'Field');
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        if (!_plain2.default.deepEqual(this.props.names, nextProps.names)) {
	          (function () {
	            var context = _this2.context;
	            var _context$_reduxForm = context._reduxForm,
	                register = _context$_reduxForm.register,
	                unregister = _context$_reduxForm.unregister;
	            // unregister old name
	
	            _this2.props.names.forEach(function (name) {
	              return unregister((0, _prefixName2.default)(context, name));
	            });
	            // register new name
	            nextProps.names.forEach(function (name) {
	              return register((0, _prefixName2.default)(context, name), 'Field');
	            });
	          })();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var context = this.context;
	        var unregister = context._reduxForm.unregister;
	
	        this.props.names.forEach(function (name) {
	          return unregister((0, _prefixName2.default)(context, name));
	        });
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Fields');
	        return this.refs.connected.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var context = this.context;
	
	        return (0, _react.createElement)(ConnectedFields, _extends({}, this.props, {
	          names: this.props.names.map(function (name) {
	            return (0, _prefixName2.default)(context, name);
	          }),
	          _reduxForm: this.context._reduxForm,
	          ref: 'connected'
	        }));
	      }
	    }, {
	      key: 'names',
	      get: function get() {
	        return this.props.names;
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().isDirty();
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return !this.dirty;
	      }
	    }, {
	      key: 'values',
	      get: function get() {
	        return this.refs.connected && this.refs.connected.getWrappedInstance().getValues();
	      }
	    }]);
	
	    return Fields;
	  }(_react.Component);
	
	  Fields.propTypes = {
	    names: function names(props, propName) {
	      return validateNameProp(props[propName]);
	    },
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	    format: _react.PropTypes.func,
	    parse: _react.PropTypes.func,
	    props: _react.PropTypes.object
	  };
	  Fields.contextTypes = {
	    _reduxForm: _react.PropTypes.object
	  };
	
	  return Fields;
	};
	
	exports.default = createFields;

/***/ },
/* 1983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _prefixName = __webpack_require__(302);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormSection = function (_Component) {
	  _inherits(FormSection, _Component);
	
	  function FormSection(props, context) {
	    _classCallCheck(this, FormSection);
	
	    var _this = _possibleConstructorReturn(this, (FormSection.__proto__ || Object.getPrototypeOf(FormSection)).call(this, props, context));
	
	    if (!context._reduxForm) {
	      throw new Error('FormSection must be inside a component decorated with reduxForm()');
	    }
	    return _this;
	  }
	
	  _createClass(FormSection, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var context = this.context,
	          name = this.props.name;
	
	      return {
	        _reduxForm: _extends({}, context._reduxForm, {
	          sectionPrefix: (0, _prefixName2.default)(context, name)
	        })
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.children
	      );
	    }
	  }]);
	
	  return FormSection;
	}(_react.Component);
	
	FormSection.propTypes = {
	  name: _react.PropTypes.string.isRequired
	};
	
	FormSection.childContextTypes = {
	  _reduxForm: _react.PropTypes.object.isRequired
	};
	
	FormSection.contextTypes = {
	  _reduxForm: _react.PropTypes.object
	};
	
	exports.default = FormSection;

/***/ },
/* 1984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPromise = __webpack_require__(406);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var asyncValidation = function asyncValidation(fn, start, stop, field) {
	  start(field);
	  var promise = fn();
	  if (!(0, _isPromise2.default)(promise)) {
	    throw new Error('asyncValidate function passed to reduxForm must return a promise');
	  }
	  var handleErrors = function handleErrors(rejected) {
	    return function (errors) {
	      if (errors && Object.keys(errors).length) {
	        stop(errors);
	        return errors;
	      } else if (rejected) {
	        stop();
	        throw new Error('Asynchronous validation promise was rejected without errors.');
	      }
	      stop();
	      return Promise.resolve();
	    };
	  };
	  return promise.then(handleErrors(false), handleErrors(true));
	};
	
	exports.default = asyncValidation;

/***/ },
/* 1985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reducer = __webpack_require__(1999);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reduxForm = __webpack_require__(2000);
	
	var _reduxForm2 = _interopRequireDefault(_reduxForm);
	
	var _Field = __webpack_require__(1980);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Fields = __webpack_require__(1982);
	
	var _Fields2 = _interopRequireDefault(_Fields);
	
	var _FieldArray = __webpack_require__(1981);
	
	var _FieldArray2 = _interopRequireDefault(_FieldArray);
	
	var _formValueSelector = __webpack_require__(1995);
	
	var _formValueSelector2 = _interopRequireDefault(_formValueSelector);
	
	var _values = __webpack_require__(2011);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _getFormValues = __webpack_require__(2003);
	
	var _getFormValues2 = _interopRequireDefault(_getFormValues);
	
	var _getFormSyncErrors = __webpack_require__(2002);
	
	var _getFormSyncErrors2 = _interopRequireDefault(_getFormSyncErrors);
	
	var _getFormSubmitErrors = __webpack_require__(2001);
	
	var _getFormSubmitErrors2 = _interopRequireDefault(_getFormSubmitErrors);
	
	var _isDirty = __webpack_require__(2004);
	
	var _isDirty2 = _interopRequireDefault(_isDirty);
	
	var _isInvalid = __webpack_require__(2005);
	
	var _isInvalid2 = _interopRequireDefault(_isInvalid);
	
	var _isPristine = __webpack_require__(934);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	var _isValid = __webpack_require__(466);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _FormSection = __webpack_require__(1983);
	
	var _FormSection2 = _interopRequireDefault(_FormSection);
	
	var _SubmissionError = __webpack_require__(926);
	
	var _SubmissionError2 = _interopRequireDefault(_SubmissionError);
	
	var _propTypes = __webpack_require__(1998);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actions = __webpack_require__(927);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _actionTypes = __webpack_require__(465);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createAll = function createAll(structure) {
	  return _extends({
	    // separate out field actions
	    actionTypes: actionTypes
	  }, actions, {
	    Field: (0, _Field2.default)(structure),
	    Fields: (0, _Fields2.default)(structure),
	    FieldArray: (0, _FieldArray2.default)(structure),
	    FormSection: _FormSection2.default,
	    formValueSelector: (0, _formValueSelector2.default)(structure),
	    getFormValues: (0, _getFormValues2.default)(structure),
	    getFormSyncErrors: (0, _getFormSyncErrors2.default)(structure),
	    getFormSubmitErrors: (0, _getFormSubmitErrors2.default)(structure),
	    isDirty: (0, _isDirty2.default)(structure),
	    isInvalid: (0, _isInvalid2.default)(structure),
	    isPristine: (0, _isPristine2.default)(structure),
	    isValid: (0, _isValid2.default)(structure),
	    propTypes: _propTypes2.default,
	    reduxForm: (0, _reduxForm2.default)(structure),
	    reducer: (0, _reducer2.default)(structure),
	    SubmissionError: _SubmissionError2.default,
	    values: (0, _values2.default)(structure)
	  });
	};
	
	exports.default = createAll;

/***/ },
/* 1986 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var createFieldArrayProps = function createFieldArrayProps(getIn, name, _ref) {
	  var arrayInsert = _ref.arrayInsert,
	      arrayMove = _ref.arrayMove,
	      arrayPop = _ref.arrayPop,
	      arrayPush = _ref.arrayPush,
	      arrayRemove = _ref.arrayRemove,
	      arrayRemoveAll = _ref.arrayRemoveAll,
	      arrayShift = _ref.arrayShift,
	      arraySplice = _ref.arraySplice,
	      arraySwap = _ref.arraySwap,
	      arrayUnshift = _ref.arrayUnshift,
	      asyncError = _ref.asyncError,
	      dirty = _ref.dirty,
	      length = _ref.length,
	      pristine = _ref.pristine,
	      submitError = _ref.submitError,
	      state = _ref.state,
	      submitFailed = _ref.submitFailed,
	      submitting = _ref.submitting,
	      syncError = _ref.syncError,
	      syncWarning = _ref.syncWarning,
	      value = _ref.value,
	      props = _ref.props,
	      rest = _objectWithoutProperties(_ref, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncError', 'dirty', 'length', 'pristine', 'submitError', 'state', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'value', 'props']);
	
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	  var finalProps = _extends({
	    fields: {
	      _isFieldArray: true,
	      forEach: function forEach(callback) {
	        return (value || []).forEach(function (item, index) {
	          return callback(name + '[' + index + ']', index, finalProps.fields);
	        });
	      },
	      insert: arrayInsert,
	      length: length,
	      map: function map(callback) {
	        return (value || []).map(function (item, index) {
	          return callback(name + '[' + index + ']', index, finalProps.fields);
	        });
	      },
	      move: arrayMove,
	      name: name,
	      pop: function pop() {
	        arrayPop();
	        return getIn(value, length - 1);
	      },
	      push: arrayPush,
	      reduce: function reduce(callback, initial) {
	        return (value || []).reduce(function (accumulator, item, index) {
	          return callback(accumulator, name + '[' + index + ']', index, finalProps.fields);
	        }, initial);
	      },
	      remove: arrayRemove,
	      removeAll: arrayRemoveAll,
	      shift: function shift() {
	        arrayShift();
	        return getIn(value, 0);
	      },
	      swap: arraySwap,
	      unshift: arrayUnshift
	    },
	    meta: {
	      dirty: dirty,
	      error: error,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: submitting,
	      touched: !!(state && getIn(state, 'touched')),
	      valid: !error
	    }
	  }, props, rest);
	  return finalProps;
	};
	
	exports.default = createFieldArrayProps;

/***/ },
/* 1987 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
	  var initialized = _ref.initialized,
	      trigger = _ref.trigger,
	      pristine = _ref.pristine,
	      syncValidationPasses = _ref.syncValidationPasses;
	
	  if (!syncValidationPasses) {
	    return false;
	  }
	  switch (trigger) {
	    case 'blur':
	      // blurring
	      return true;
	    case 'submit':
	      // submitting, so only async validate if form is dirty or was never initialized
	      // conversely, DON'T async validate if the form is pristine just as it was initialized
	      return !pristine || !initialized;
	    default:
	      return false;
	  }
	};
	
	exports.default = defaultShouldAsyncValidate;

/***/ },
/* 1988 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var defaultShouldValidate = function defaultShouldValidate(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	  return !structure.deepEqual(values, nextProps.values);
	};
	
	exports.default = defaultShouldValidate;

/***/ },
/* 1989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(282);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createDeleteInWithCleanUp = function createDeleteInWithCleanUp(_ref) {
	  var deepEqual = _ref.deepEqual,
	      empty = _ref.empty,
	      getIn = _ref.getIn,
	      deleteIn = _ref.deleteIn,
	      setIn = _ref.setIn;
	
	
	  var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
	    if (path[path.length - 1] === ']') {
	      // array path
	      var pathTokens = (0, _toPath3.default)(path);
	      pathTokens.pop();
	      var parent = getIn(state, pathTokens.join('.'));
	      return parent ? setIn(state, path, undefined) : state;
	    }
	    var result = deleteIn(state, path);
	    var dotIndex = path.lastIndexOf('.');
	    if (dotIndex > 0) {
	      var parentPath = path.substring(0, dotIndex);
	      if (parentPath[parentPath.length - 1] !== ']') {
	        var _parent = getIn(result, parentPath);
	        if (deepEqual(_parent, empty)) {
	          return deleteInWithCleanUp(result, parentPath);
	        }
	      }
	    }
	    return result;
	  };
	
	  return deleteInWithCleanUp;
	};
	
	exports.default = createDeleteInWithCleanUp;

/***/ },
/* 1990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getValue = __webpack_require__(930);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	var _isReactNative = __webpack_require__(933);
	
	var _isReactNative2 = _interopRequireDefault(_isReactNative);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createOnBlur = function createOnBlur(blur) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      after = _ref.after,
	      normalize = _ref.normalize,
	      parse = _ref.parse;
	
	  return function (event) {
	    // read value from input
	    var value = (0, _getValue2.default)(event, _isReactNative2.default);
	
	    // parse value if we have a parser
	    if (parse) {
	      value = parse(value);
	    }
	
	    // normalize value
	    if (normalize) {
	      value = normalize(value);
	    }
	
	    // dispatch blur action
	    blur(value);
	
	    // call after callback
	    if (after) {
	      after(value);
	    }
	  };
	};
	
	exports.default = createOnBlur;

/***/ },
/* 1991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getValue = __webpack_require__(930);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	var _isReactNative = __webpack_require__(933);
	
	var _isReactNative2 = _interopRequireDefault(_isReactNative);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createOnChange = function createOnChange(change) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      parse = _ref.parse,
	      normalize = _ref.normalize;
	
	  return function (event) {
	    // read value from input
	    var value = (0, _getValue2.default)(event, _isReactNative2.default);
	
	    // parse value if we have a parser
	    if (parse) {
	      value = parse(value);
	    }
	
	    // normalize value
	    if (normalize) {
	      value = normalize(value);
	    }
	
	    // dispatch change action
	    change(value);
	  };
	};
	
	exports.default = createOnChange;

/***/ },
/* 1992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createOnDragStart = __webpack_require__(929);
	
	var createOnDrop = function createOnDrop(name, change) {
	  return function (event) {
	    change(event.dataTransfer.getData(_createOnDragStart.dataKey));
	    event.preventDefault();
	  };
	};
	exports.default = createOnDrop;

/***/ },
/* 1993 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createOnFocus = function createOnFocus(name, focus) {
	  return function () {
	    return focus(name);
	  };
	};
	exports.default = createOnFocus;

/***/ },
/* 1994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _silenceEvent = __webpack_require__(932);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvents = function silenceEvents(fn) {
	  return function (event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _silenceEvent2.default)(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
	  };
	};
	
	exports.default = silenceEvents;

/***/ },
/* 1995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _plain = __webpack_require__(148);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFormValueSelector = function createFormValueSelector(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	
	    (0, _invariant2.default)(form, 'Form value must be specified');
	    return function (state) {
	      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        fields[_key - 1] = arguments[_key];
	      }
	
	      (0, _invariant2.default)(fields.length, 'No fields specified');
	      return fields.length === 1 ?
	      // only selecting one field, so return its value
	      getIn(getFormState(state), form + '.values.' + fields[0]) :
	      // selecting many fields, so return an object of field values
	      fields.reduce(function (accumulator, field) {
	        var value = getIn(getFormState(state), form + '.values.' + field);
	        return value === undefined ? accumulator : _plain2.default.setIn(accumulator, field, value);
	      }, {});
	    };
	  };
	};
	
	exports.default = createFormValueSelector;

/***/ },
/* 1996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _isPromise = __webpack_require__(406);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _SubmissionError = __webpack_require__(926);
	
	var _SubmissionError2 = _interopRequireDefault(_SubmissionError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
	  var dispatch = props.dispatch,
	      onSubmitFail = props.onSubmitFail,
	      onSubmitSuccess = props.onSubmitSuccess,
	      startSubmit = props.startSubmit,
	      stopSubmit = props.stopSubmit,
	      setSubmitFailed = props.setSubmitFailed,
	      setSubmitSucceeded = props.setSubmitSucceeded,
	      syncErrors = props.syncErrors,
	      touch = props.touch,
	      values = props.values,
	      persistentSubmitErrors = props.persistentSubmitErrors;
	
	
	  touch.apply(undefined, _toConsumableArray(fields)); // mark all fields as touched
	
	  // XXX: Always submitting when persistentSubmitErrors is enabled ignores sync errors.
	  // It would be better to check whether the form as any other errors except submit errors.
	  // This would either require changing the meaning of `valid` (maybe breaking change),
	  // having a more complex conditional in here, or executing sync validation in here
	  // the same way as async validation is executed.
	  if (valid || persistentSubmitErrors) {
	    var _ret = function () {
	      var doSubmit = function doSubmit() {
	        var result = void 0;
	        try {
	          result = submit(values, dispatch, props);
	        } catch (submitError) {
	          var error = submitError instanceof _SubmissionError2.default ? submitError.errors : undefined;
	          setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	          if (onSubmitFail) {
	            onSubmitFail(error, dispatch, submitError);
	          }
	          if (error || onSubmitFail) {
	            // if you've provided an onSubmitFail callback, don't re-throw the error
	            return error;
	          } else {
	            throw submitError;
	          }
	        }
	        if ((0, _isPromise2.default)(result)) {
	          startSubmit();
	          return result.then(function (submitResult) {
	            stopSubmit();
	            setSubmitSucceeded();
	            if (onSubmitSuccess) {
	              onSubmitSuccess(submitResult, dispatch);
	            }
	            return submitResult;
	          }, function (submitError) {
	            var error = submitError instanceof _SubmissionError2.default ? submitError.errors : undefined;
	            stopSubmit(error);
	            setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	            if (onSubmitFail) {
	              onSubmitFail(error, dispatch, submitError);
	            }
	            if (error || onSubmitFail) {
	              // if you've provided an onSubmitFail callback, don't re-throw the error
	              return error;
	            } else {
	              throw submitError;
	            }
	          });
	        } else {
	          setSubmitSucceeded();
	          if (onSubmitSuccess) {
	            onSubmitSuccess(result, dispatch);
	          }
	        }
	        return result;
	      };
	
	      var asyncValidateResult = asyncValidate && asyncValidate();
	      if (asyncValidateResult) {
	        return {
	          v: asyncValidateResult.then(function (asyncErrors) {
	            if (asyncErrors) {
	              throw asyncErrors;
	            }
	            return doSubmit();
	          }).catch(function (asyncErrors) {
	            setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	            if (onSubmitFail) {
	              onSubmitFail(asyncErrors, dispatch, null);
	            }
	            return Promise.reject(asyncErrors);
	          })
	        };
	      } else {
	        return {
	          v: doSubmit()
	        };
	      }
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  } else {
	    setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	    if (onSubmitFail) {
	      onSubmitFail(syncErrors, dispatch, null);
	    }
	    return syncErrors;
	  }
	};
	
	exports.default = handleSubmit;

/***/ },
/* 1997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIn = __webpack_require__(935);
	
	var _getIn2 = _interopRequireDefault(_getIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getErrorKeys = function getErrorKeys(name, type) {
	  switch (type) {
	    case 'Field':
	      return [name, name + '._error'];
	    case 'FieldArray':
	      return [name + '._error'];
	  }
	};
	
	var createHasError = function createHasError(_ref) {
	  var getIn = _ref.getIn;
	
	  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
	    if (!syncErrors && !asyncErrors && !submitErrors) {
	      return false;
	    }
	
	    var name = getIn(field, 'name');
	    var type = getIn(field, 'type');
	    return getErrorKeys(name, type).some(function (key) {
	      return (0, _getIn2.default)(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
	    });
	  };
	  return hasError;
	};
	
	exports.default = createHasError;

/***/ },
/* 1998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var any = _react.PropTypes.any,
	    bool = _react.PropTypes.bool,
	    func = _react.PropTypes.func,
	    shape = _react.PropTypes.shape;
	
	
	var propTypes = {
	  // State:
	  asyncValidating: bool.isRequired, // true if async validation is running
	  dirty: bool.isRequired, // true if any values are different from initialValues
	  error: any, // form-wide error from '_error' key in validation result
	  warning: any, // form-wide warning from '_warning' key in validation result
	  invalid: bool.isRequired, // true if there are any validation errors
	  initialized: bool.isRequired, // true if the form has been initialized
	  pristine: bool.isRequired, // true if the values are the same as initialValues
	  submitting: bool.isRequired, // true if the form is in the process of being submitted
	  submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
	  submitSucceeded: bool.isRequired, // true if the form was successfully submitted
	  valid: bool.isRequired, // true if there are no validation errors
	  // Actions:
	  array: shape({
	    insert: func.isRequired, // function to insert a value into an array field
	    move: func.isRequired, // function to move a value within an array field
	    pop: func.isRequired, // function to pop a value off of an array field
	    push: func.isRequired, // function to push a value onto an array field
	    remove: func.isRequired, // function to remove a value from an array field
	    removeAll: func.isRequired, // function to remove all the values from an array field
	    shift: func.isRequired, // function to shift a value out of an array field
	    splice: func.isRequired, // function to splice a value into an array field
	    swap: func.isRequired, // function to swap values in an array field
	    unshift: func.isRequired // function to unshift a value into an array field
	  }),
	  asyncValidate: func.isRequired, // function to trigger async validation
	  blur: func.isRequired, // action to mark a field as blurred
	  change: func.isRequired, // action to change the value of a field
	  destroy: func.isRequired, // action to destroy the form's data in Redux
	  dispatch: func.isRequired, // the Redux dispatch action
	  handleSubmit: func.isRequired, // function to submit the form
	  initialize: func.isRequired, // action to initialize form data
	  reset: func.isRequired, // action to reset the form data to previously initialized values
	  touch: func.isRequired, // action to mark fields as touched
	  untouch: func.isRequired // action to mark fields as untouched
	};
	
	exports.default = propTypes;

/***/ },
/* 1999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionTypes = __webpack_require__(465);
	
	__webpack_require__(1087);
	
	var _deleteInWithCleanUp = __webpack_require__(1989);
	
	var _deleteInWithCleanUp2 = _interopRequireDefault(_deleteInWithCleanUp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var createReducer = function createReducer(structure) {
	  var _behaviors;
	
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      deleteIn = structure.deleteIn,
	      fromJS = structure.fromJS,
	      size = structure.size,
	      some = structure.some,
	      splice = structure.splice;
	
	  var deleteInWithCleanUp = (0, _deleteInWithCleanUp2.default)(structure);
	  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
	    var existing = getIn(state, key + '.' + field);
	    return existing || force ? setIn(state, key + '.' + field, splice(existing, index, removeNum, value)) : state;
	  };
	  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
	  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
	    var result = state;
	    var nonValuesValue = value != null ? empty : undefined;
	    result = doSplice(result, 'values', field, index, removeNum, value, true);
	    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
	    result = doSplice(result, 'submitErrors', field, index, removeNum, nonValuesValue);
	    result = doSplice(result, 'asyncErrors', field, index, removeNum, nonValuesValue);
	    return result;
	  };
	
	  var behaviors = (_behaviors = {}, _defineProperty(_behaviors, _actionTypes.ARRAY_INSERT, function (state, _ref) {
	    var _ref$meta = _ref.meta,
	        field = _ref$meta.field,
	        index = _ref$meta.index,
	        payload = _ref.payload;
	
	    return arraySplice(state, field, index, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_MOVE, function (state, _ref2) {
	    var _ref2$meta = _ref2.meta,
	        field = _ref2$meta.field,
	        from = _ref2$meta.from,
	        to = _ref2$meta.to;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    var result = state;
	    if (length) {
	      rootKeys.forEach(function (key) {
	        var path = key + '.' + field;
	        if (getIn(result, path)) {
	          var value = getIn(result, path + '[' + from + ']');
	          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
	          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
	        }
	      });
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_POP, function (state, _ref3) {
	    var field = _ref3.meta.field;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, length - 1, 1) : state;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_PUSH, function (state, _ref4) {
	    var field = _ref4.meta.field,
	        payload = _ref4.payload;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return arraySplice(state, field, length, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_REMOVE, function (state, _ref5) {
	    var _ref5$meta = _ref5.meta,
	        field = _ref5$meta.field,
	        index = _ref5$meta.index;
	
	    return arraySplice(state, field, index, 1);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_REMOVE_ALL, function (state, _ref6) {
	    var field = _ref6.meta.field;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, 0, length) : state;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SHIFT, function (state, _ref7) {
	    var field = _ref7.meta.field;
	
	    return arraySplice(state, field, 0, 1);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SPLICE, function (state, _ref8) {
	    var _ref8$meta = _ref8.meta,
	        field = _ref8$meta.field,
	        index = _ref8$meta.index,
	        removeNum = _ref8$meta.removeNum,
	        payload = _ref8.payload;
	
	    return arraySplice(state, field, index, removeNum, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SWAP, function (state, _ref9) {
	    var _ref9$meta = _ref9.meta,
	        field = _ref9$meta.field,
	        indexA = _ref9$meta.indexA,
	        indexB = _ref9$meta.indexB;
	
	    var result = state;
	    rootKeys.forEach(function (key) {
	      var valueA = getIn(result, key + '.' + field + '[' + indexA + ']');
	      var valueB = getIn(result, key + '.' + field + '[' + indexB + ']');
	      if (valueA !== undefined || valueB !== undefined) {
	        result = setIn(result, key + '.' + field + '[' + indexA + ']', valueB);
	        result = setIn(result, key + '.' + field + '[' + indexB + ']', valueA);
	      }
	    });
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_UNSHIFT, function (state, _ref10) {
	    var field = _ref10.meta.field,
	        payload = _ref10.payload;
	
	    return arraySplice(state, field, 0, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.AUTOFILL, function (state, _ref11) {
	    var field = _ref11.meta.field,
	        payload = _ref11.payload;
	
	    var result = state;
	    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
	    result = deleteInWithCleanUp(result, 'submitErrors.' + field);
	    result = setIn(result, 'fields.' + field + '.autofilled', true);
	    result = setIn(result, 'values.' + field, payload);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.BLUR, function (state, _ref12) {
	    var _ref12$meta = _ref12.meta,
	        field = _ref12$meta.field,
	        touch = _ref12$meta.touch,
	        payload = _ref12.payload;
	
	    var result = state;
	    var initial = getIn(result, 'initial.' + field);
	    if (initial === undefined && payload === '') {
	      result = deleteInWithCleanUp(result, 'values.' + field);
	    } else if (payload !== undefined) {
	      result = setIn(result, 'values.' + field, payload);
	    }
	    if (field === getIn(result, 'active')) {
	      result = deleteIn(result, 'active');
	    }
	    result = deleteIn(result, 'fields.' + field + '.active');
	    if (touch) {
	      result = setIn(result, 'fields.' + field + '.touched', true);
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.CHANGE, function (state, _ref13) {
	    var _ref13$meta = _ref13.meta,
	        field = _ref13$meta.field,
	        touch = _ref13$meta.touch,
	        persistentSubmitErrors = _ref13$meta.persistentSubmitErrors,
	        payload = _ref13.payload;
	
	    var result = state;
	    var initial = getIn(result, 'initial.' + field);
	    if (initial === undefined && payload === '') {
	      result = deleteInWithCleanUp(result, 'values.' + field);
	    } else if (payload !== undefined) {
	      result = setIn(result, 'values.' + field, payload);
	    }
	    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
	    if (!persistentSubmitErrors) {
	      result = deleteInWithCleanUp(result, 'submitErrors.' + field);
	    }
	    result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
	    if (touch) {
	      result = setIn(result, 'fields.' + field + '.touched', true);
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.CLEAR_SUBMIT, function (state) {
	    return deleteIn(state, 'triggerSubmit');
	  }), _defineProperty(_behaviors, _actionTypes.FOCUS, function (state, _ref14) {
	    var field = _ref14.meta.field;
	
	    var result = state;
	    var previouslyActive = getIn(state, 'active');
	    result = deleteIn(result, 'fields.' + previouslyActive + '.active');
	    result = setIn(result, 'fields.' + field + '.visited', true);
	    result = setIn(result, 'fields.' + field + '.active', true);
	    result = setIn(result, 'active', field);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.INITIALIZE, function (state, _ref15) {
	    var payload = _ref15.payload,
	        keepDirty = _ref15.meta.keepDirty;
	
	    var mapData = fromJS(payload);
	    var result = empty; // clean all field state
	
	    // persist old warnings, they will get recalculated if the new form values are different from the old values
	    var warning = getIn(state, 'warning');
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    }
	    var syncWarnings = getIn(state, 'syncWarnings');
	    if (syncWarnings) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    }
	
	    var registeredFields = getIn(state, 'registeredFields');
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	    var newValues = mapData;
	    if (keepDirty && registeredFields) {
	      (function () {
	        //
	        // Keep the value of dirty fields while updating the value of
	        // pristine fields. This way, apps can reinitialize forms while
	        // avoiding stomping on user edits.
	        //
	        // Note 1: The initialize action replaces all initial values
	        // regardless of keepDirty.
	        //
	        // Note 2: When a field is dirty, keepDirty is enabled, and the field
	        // value is the same as the new initial value for the field, the
	        // initialize action causes the field to become pristine. That effect
	        // is what we want.
	        //
	        var previousValues = getIn(state, 'values');
	        var previousInitialValues = getIn(state, 'initial');
	        registeredFields.forEach(function (field) {
	          var name = getIn(field, 'name');
	          var previousInitialValue = getIn(previousInitialValues, name);
	          var previousValue = getIn(previousValues, name);
	          if (!deepEqual(previousValue, previousInitialValue)) {
	            // This field was dirty. Restore the dirty value.
	            newValues = setIn(newValues, name, previousValue);
	          }
	        });
	      })();
	    }
	    result = setIn(result, 'values', newValues);
	    result = setIn(result, 'initial', mapData);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.REGISTER_FIELD, function (state, _ref16) {
	    var _ref16$payload = _ref16.payload,
	        name = _ref16$payload.name,
	        type = _ref16$payload.type;
	
	    var result = state;
	    var registeredFields = getIn(result, 'registeredFields');
	    if (some(registeredFields, function (field) {
	      return getIn(field, 'name') === name;
	    })) {
	      return state;
	    }
	
	    var mapData = fromJS({ name: name, type: type });
	    result = setIn(state, 'registeredFields', splice(registeredFields, size(registeredFields), 0, mapData));
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.RESET, function (state) {
	    var result = empty;
	    var registeredFields = getIn(state, 'registeredFields');
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	    var values = getIn(state, 'initial');
	    if (values) {
	      result = setIn(result, 'values', values);
	      result = setIn(result, 'initial', values);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SUBMIT, function (state) {
	    return setIn(state, 'triggerSubmit', true);
	  }), _defineProperty(_behaviors, _actionTypes.START_ASYNC_VALIDATION, function (state, _ref17) {
	    var field = _ref17.meta.field;
	
	    return setIn(state, 'asyncValidating', field || true);
	  }), _defineProperty(_behaviors, _actionTypes.START_SUBMIT, function (state) {
	    return setIn(state, 'submitting', true);
	  }), _defineProperty(_behaviors, _actionTypes.STOP_ASYNC_VALIDATION, function (state, _ref18) {
	    var payload = _ref18.payload;
	
	    var result = state;
	    result = deleteIn(result, 'asyncValidating');
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = _objectWithoutProperties(payload, ['_error']);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      }
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
	      } else {
	        result = deleteIn(result, 'asyncErrors');
	      }
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'asyncErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.STOP_SUBMIT, function (state, _ref19) {
	    var payload = _ref19.payload;
	
	    var result = state;
	    result = deleteIn(result, 'submitting');
	    result = deleteIn(result, 'submitFailed');
	    result = deleteIn(result, 'submitSucceeded');
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = _objectWithoutProperties(payload, ['_error']);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      } else {
	        result = deleteIn(result, 'error');
	      }
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
	      } else {
	        result = deleteIn(result, 'submitErrors');
	      }
	      result = setIn(result, 'submitFailed', true);
	    } else {
	      result = setIn(result, 'submitSucceeded', true);
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'submitErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SET_SUBMIT_FAILED, function (state, _ref20) {
	    var fields = _ref20.meta.fields;
	
	    var result = state;
	    result = setIn(result, 'submitFailed', true);
	    result = deleteIn(result, 'submitSucceeded');
	    result = deleteIn(result, 'submitting');
	    fields.forEach(function (field) {
	      return result = setIn(result, 'fields.' + field + '.touched', true);
	    });
	    if (fields.length) {
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SET_SUBMIT_SUCCEEDED, function (state) {
	    var result = state;
	    result = deleteIn(result, 'submitFailed');
	    result = setIn(result, 'submitSucceeded', true);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.TOUCH, function (state, _ref21) {
	    var fields = _ref21.meta.fields;
	
	    var result = state;
	    fields.forEach(function (field) {
	      return result = setIn(result, 'fields.' + field + '.touched', true);
	    });
	    result = setIn(result, 'anyTouched', true);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UNREGISTER_FIELD, function (state, _ref22) {
	    var name = _ref22.payload.name;
	
	    var registeredFields = getIn(state, 'registeredFields');
	
	    // in case the form was destroyed and registeredFields no longer exists
	    if (!registeredFields) {
	      return state;
	    }
	
	    var fieldIndex = registeredFields.findIndex(function (value) {
	      return getIn(value, 'name') === name;
	    });
	    if (size(registeredFields) <= 1 && fieldIndex >= 0) {
	      return deleteInWithCleanUp(state, 'registeredFields');
	    }
	    if (fieldIndex < 0) {
	      return state;
	    }
	    return setIn(state, 'registeredFields', splice(registeredFields, fieldIndex, 1));
	  }), _defineProperty(_behaviors, _actionTypes.UNTOUCH, function (state, _ref23) {
	    var fields = _ref23.meta.fields;
	
	    var result = state;
	    fields.forEach(function (field) {
	      return result = deleteIn(result, 'fields.' + field + '.touched');
	    });
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UPDATE_SYNC_ERRORS, function (state, _ref24) {
	    var _ref24$payload = _ref24.payload,
	        syncErrors = _ref24$payload.syncErrors,
	        error = _ref24$payload.error;
	
	    var result = state;
	    if (error) {
	      result = setIn(result, 'error', error);
	      result = setIn(result, 'syncError', true);
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'syncError');
	    }
	    if (Object.keys(syncErrors).length) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    } else {
	      result = deleteIn(result, 'syncErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UPDATE_SYNC_WARNINGS, function (state, _ref25) {
	    var _ref25$payload = _ref25.payload,
	        syncWarnings = _ref25$payload.syncWarnings,
	        warning = _ref25$payload.warning;
	
	    var result = state;
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    } else {
	      result = deleteIn(result, 'warning');
	    }
	    if (Object.keys(syncWarnings).length) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    } else {
	      result = deleteIn(result, 'syncWarnings');
	    }
	    return result;
	  }), _behaviors);
	
	  var reducer = function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	    var action = arguments[1];
	
	    var behavior = behaviors[action.type];
	    return behavior ? behavior(state, action) : state;
	  };
	
	  var byForm = function byForm(reducer) {
	    return function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var form = action && action.meta && action.meta.form;
	      if (!form) {
	        return state;
	      }
	      if (action.type === _actionTypes.DESTROY) {
	        return deleteInWithCleanUp(state, action.meta.form);
	      }
	      var formState = getIn(state, form);
	      var result = reducer(formState, action);
	      return result === formState ? state : setIn(state, form, result);
	    };
	  };
	
	  /**
	   * Adds additional functionality to the reducer
	   */
	  function decorate(target) {
	    target.plugin = function plugin(reducers) {
	      var _this = this;
	
	      // use 'function' keyword to enable 'this'
	      return decorate(function () {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return Object.keys(reducers).reduce(function (accumulator, key) {
	          var previousState = getIn(accumulator, key);
	          var nextState = reducers[key](previousState, action, getIn(state, key));
	          return nextState === previousState ? accumulator : setIn(accumulator, key, nextState);
	        }, _this(state, action));
	      });
	    };
	
	    return target;
	  }
	
	  return decorate(byForm(reducer));
	};
	
	exports.default = createReducer;

/***/ },
/* 2000 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mapValues2 = __webpack_require__(661);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _hoistNonReactStatics = __webpack_require__(2012);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _reactRedux = __webpack_require__(19);
	
	var _redux = __webpack_require__(233);
	
	var _isPromise = __webpack_require__(406);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _getDisplayName = __webpack_require__(2010);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _actions = __webpack_require__(927);
	
	var importedActions = _interopRequireWildcard(_actions);
	
	var _handleSubmit = __webpack_require__(1996);
	
	var _handleSubmit2 = _interopRequireDefault(_handleSubmit);
	
	var _silenceEvent = __webpack_require__(932);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	var _silenceEvents = __webpack_require__(1994);
	
	var _silenceEvents2 = _interopRequireDefault(_silenceEvents);
	
	var _asyncValidation = __webpack_require__(1984);
	
	var _asyncValidation2 = _interopRequireDefault(_asyncValidation);
	
	var _defaultShouldAsyncValidate = __webpack_require__(1987);
	
	var _defaultShouldAsyncValidate2 = _interopRequireDefault(_defaultShouldAsyncValidate);
	
	var _defaultShouldValidate = __webpack_require__(1988);
	
	var _defaultShouldValidate2 = _interopRequireDefault(_defaultShouldValidate);
	
	var _plain = __webpack_require__(148);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _isValid = __webpack_require__(466);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
	};
	
	// extract field-specific actions
	
	var arrayInsert = importedActions.arrayInsert,
	    arrayMove = importedActions.arrayMove,
	    arrayPop = importedActions.arrayPop,
	    arrayPush = importedActions.arrayPush,
	    arrayRemove = importedActions.arrayRemove,
	    arrayRemoveAll = importedActions.arrayRemoveAll,
	    arrayShift = importedActions.arrayShift,
	    arraySplice = importedActions.arraySplice,
	    arraySwap = importedActions.arraySwap,
	    arrayUnshift = importedActions.arrayUnshift,
	    blur = importedActions.blur,
	    change = importedActions.change,
	    focus = importedActions.focus,
	    formActions = _objectWithoutProperties(importedActions, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'blur', 'change', 'focus']);
	
	var arrayActions = {
	  arrayInsert: arrayInsert,
	  arrayMove: arrayMove,
	  arrayPop: arrayPop,
	  arrayPush: arrayPush,
	  arrayRemove: arrayRemove,
	  arrayRemoveAll: arrayRemoveAll,
	  arrayShift: arrayShift,
	  arraySplice: arraySplice,
	  arraySwap: arraySwap,
	  arrayUnshift: arrayUnshift
	};
	
	var propsToNotUpdateFor = [].concat(_toConsumableArray(Object.keys(importedActions)), ['array', 'asyncErrors', 'initialized', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);
	
	var checkSubmit = function checkSubmit(submit) {
	  if (!submit || typeof submit !== 'function') {
	    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
	  }
	  return submit;
	};
	
	/**
	 * The decorator that is the main API to redux-form
	 */
	var createReduxForm = function createReduxForm(structure) {
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      fromJS = structure.fromJS;
	
	  var isValid = (0, _isValid2.default)(structure);
	  return function (initialConfig) {
	    var config = _extends({
	      touchOnBlur: true,
	      touchOnChange: false,
	      persistentSubmitErrors: false,
	      destroyOnUnmount: true,
	      shouldAsyncValidate: _defaultShouldAsyncValidate2.default,
	      shouldValidate: _defaultShouldValidate2.default,
	      enableReinitialize: false,
	      keepDirtyOnReinitialize: false,
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      },
	      pure: true
	    }, initialConfig);
	
	    return function (WrappedComponent) {
	      var instances = 0;
	
	      var Form = function (_Component) {
	        _inherits(Form, _Component);
	
	        function Form(props) {
	          _classCallCheck(this, Form);
	
	          var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));
	
	          _this.submit = _this.submit.bind(_this);
	          _this.reset = _this.reset.bind(_this);
	          _this.asyncValidate = _this.asyncValidate.bind(_this);
	          _this.getValues = _this.getValues.bind(_this);
	          _this.register = _this.register.bind(_this);
	          _this.unregister = _this.unregister.bind(_this);
	          _this.submitCompleted = _this.submitCompleted.bind(_this);
	
	          instances++;
	          return _this;
	        }
	
	        _createClass(Form, [{
	          key: 'getChildContext',
	          value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	              _reduxForm: _extends({}, this.props, {
	                getFormState: function getFormState(state) {
	                  return getIn(_this2.props.getFormState(state), _this2.props.form);
	                },
	                asyncValidate: this.asyncValidate,
	                getValues: this.getValues,
	                sectionPrefix: undefined,
	                register: this.register,
	                unregister: this.unregister
	              })
	            };
	          }
	        }, {
	          key: 'initIfNeeded',
	          value: function initIfNeeded(nextProps) {
	            var enableReinitialize = this.props.enableReinitialize;
	
	            if (nextProps) {
	              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
	                var keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
	                this.props.initialize(nextProps.initialValues, keepDirty);
	              }
	            } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
	              this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize);
	            }
	          }
	        }, {
	          key: 'updateSyncErrorsIfNeeded',
	          value: function updateSyncErrorsIfNeeded(nextSyncErrors, nextError) {
	            var _props = this.props,
	                error = _props.error,
	                syncErrors = _props.syncErrors,
	                updateSyncErrors = _props.updateSyncErrors;
	
	            var noErrors = (!syncErrors || !Object.keys(syncErrors).length) && !error;
	            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
	            if (!(noErrors && nextNoErrors) && (!_plain2.default.deepEqual(syncErrors, nextSyncErrors) || !_plain2.default.deepEqual(error, nextError))) {
	              updateSyncErrors(nextSyncErrors, nextError);
	            }
	          }
	        }, {
	          key: 'submitIfNeeded',
	          value: function submitIfNeeded(nextProps) {
	            var _props2 = this.props,
	                clearSubmit = _props2.clearSubmit,
	                triggerSubmit = _props2.triggerSubmit;
	
	            if (!triggerSubmit && nextProps.triggerSubmit) {
	              clearSubmit();
	              this.submit();
	            }
	          }
	        }, {
	          key: 'validateIfNeeded',
	          value: function validateIfNeeded(nextProps) {
	            var _props3 = this.props,
	                shouldValidate = _props3.shouldValidate,
	                validate = _props3.validate,
	                values = _props3.values;
	
	            if (validate) {
	              var initialRender = nextProps === undefined;
	              var shouldValidateResult = shouldValidate({
	                values: values,
	                nextProps: nextProps,
	                props: this.props,
	                initialRender: initialRender,
	                structure: structure
	              });
	
	              if (shouldValidateResult) {
	                if (initialRender) {
	                  var _validate = validate(values, this.props),
	                      _error = _validate._error,
	                      nextSyncErrors = _objectWithoutProperties(_validate, ['_error']);
	
	                  this.updateSyncErrorsIfNeeded(nextSyncErrors, _error);
	                } else {
	                  var _validate2 = validate(nextProps.values, nextProps),
	                      _error2 = _validate2._error,
	                      _nextSyncErrors = _objectWithoutProperties(_validate2, ['_error']);
	
	                  this.updateSyncErrorsIfNeeded(_nextSyncErrors, _error2);
	                }
	              }
	            }
	          }
	        }, {
	          key: 'updateSyncWarningsIfNeeded',
	          value: function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning) {
	            var _props4 = this.props,
	                warning = _props4.warning,
	                syncWarnings = _props4.syncWarnings,
	                updateSyncWarnings = _props4.updateSyncWarnings;
	
	            var noWarnings = (!syncWarnings || !Object.keys(syncWarnings).length) && !warning;
	            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
	            if (!(noWarnings && nextNoWarnings) && (!_plain2.default.deepEqual(syncWarnings, nextSyncWarnings) || !_plain2.default.deepEqual(warning, nextWarning))) {
	              updateSyncWarnings(nextSyncWarnings, nextWarning);
	            }
	          }
	        }, {
	          key: 'warnIfNeeded',
	          value: function warnIfNeeded(nextProps) {
	            var _props5 = this.props,
	                warn = _props5.warn,
	                values = _props5.values;
	
	            if (warn) {
	              if (nextProps) {
	                // not initial render
	                if (!deepEqual(values, nextProps.values)) {
	                  var _warn = warn(nextProps.values, nextProps),
	                      _warning = _warn._warning,
	                      nextSyncWarnings = _objectWithoutProperties(_warn, ['_warning']);
	
	                  this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning);
	                }
	              } else {
	                // initial render
	                var _warn2 = warn(values, this.props),
	                    _warning2 = _warn2._warning,
	                    _nextSyncWarnings = _objectWithoutProperties(_warn2, ['_warning']);
	
	                this.updateSyncWarningsIfNeeded(_nextSyncWarnings, _warning2);
	              }
	            }
	          }
	        }, {
	          key: 'componentWillMount',
	          value: function componentWillMount() {
	            this.initIfNeeded();
	            this.validateIfNeeded();
	            this.warnIfNeeded();
	          }
	        }, {
	          key: 'componentWillReceiveProps',
	          value: function componentWillReceiveProps(nextProps) {
	            this.initIfNeeded(nextProps);
	            this.validateIfNeeded(nextProps);
	            this.warnIfNeeded(nextProps);
	            this.submitIfNeeded(nextProps);
	          }
	        }, {
	          key: 'shouldComponentUpdate',
	          value: function shouldComponentUpdate(nextProps) {
	            var _this3 = this;
	
	            if (!config.pure) return true;
	            return Object.keys(nextProps).some(function (prop) {
	              // useful to debug rerenders
	              // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	              //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	              // }
	              return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
	            });
	          }
	        }, {
	          key: 'componentWillUnmount',
	          value: function componentWillUnmount() {
	            var _props6 = this.props,
	                destroyOnUnmount = _props6.destroyOnUnmount,
	                destroy = _props6.destroy;
	
	            if (destroyOnUnmount) {
	              this.destroyed = true;
	              destroy();
	            }
	
	            this.unmounted = true;
	
	            instances--;
	          }
	        }, {
	          key: 'getValues',
	          value: function getValues() {
	            return this.props.values;
	          }
	        }, {
	          key: 'isValid',
	          value: function isValid() {
	            return this.props.valid;
	          }
	        }, {
	          key: 'isPristine',
	          value: function isPristine() {
	            return this.props.pristine;
	          }
	        }, {
	          key: 'register',
	          value: function register(name, type) {
	            this.props.registerField(name, type);
	          }
	        }, {
	          key: 'unregister',
	          value: function unregister(name) {
	            if (this.props.destroyOnUnmount && !this.destroyed && (!this.unmounted || !instances)) {
	              this.props.unregisterField(name);
	            }
	          }
	        }, {
	          key: 'getFieldList',
	          value: function getFieldList() {
	            return this.props.registeredFields.map(function (field) {
	              return getIn(field, 'name');
	            });
	          }
	        }, {
	          key: 'asyncValidate',
	          value: function asyncValidate(name, value) {
	            var _this4 = this;
	
	            var _props7 = this.props,
	                asyncBlurFields = _props7.asyncBlurFields,
	                asyncErrors = _props7.asyncErrors,
	                asyncValidate = _props7.asyncValidate,
	                dispatch = _props7.dispatch,
	                initialized = _props7.initialized,
	                pristine = _props7.pristine,
	                shouldAsyncValidate = _props7.shouldAsyncValidate,
	                startAsyncValidation = _props7.startAsyncValidation,
	                stopAsyncValidation = _props7.stopAsyncValidation,
	                syncErrors = _props7.syncErrors,
	                values = _props7.values;
	
	            var submitting = !name;
	            if (asyncValidate) {
	              var _ret = function () {
	                var valuesToValidate = submitting ? values : setIn(values, name, value);
	                var syncValidationPasses = submitting || !getIn(syncErrors, name);
	                var isBlurredField = !submitting && (!asyncBlurFields || ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]')));
	                if ((isBlurredField || submitting) && shouldAsyncValidate({
	                  asyncErrors: asyncErrors,
	                  initialized: initialized,
	                  trigger: submitting ? 'submit' : 'blur',
	                  blurredField: name,
	                  pristine: pristine,
	                  syncValidationPasses: syncValidationPasses
	                })) {
	                  return {
	                    v: (0, _asyncValidation2.default)(function () {
	                      return asyncValidate(valuesToValidate, dispatch, _this4.props, name);
	                    }, startAsyncValidation, stopAsyncValidation, name)
	                  };
	                }
	              }();
	
	              if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	            }
	          }
	        }, {
	          key: 'submitCompleted',
	          value: function submitCompleted(result) {
	            delete this.submitPromise;
	            return result;
	          }
	        }, {
	          key: 'listenToSubmit',
	          value: function listenToSubmit(promise) {
	            if (!(0, _isPromise2.default)(promise)) {
	              return promise;
	            }
	            this.submitPromise = promise;
	            return promise.then(this.submitCompleted);
	          }
	        }, {
	          key: 'submit',
	          value: function submit(submitOrEvent) {
	            var _this5 = this;
	
	            var onSubmit = this.props.onSubmit;
	
	
	            if (!submitOrEvent || (0, _silenceEvent2.default)(submitOrEvent)) {
	              // submitOrEvent is an event: fire submit if not already submitting
	              if (!this.submitPromise) {
	                return this.listenToSubmit((0, _handleSubmit2.default)(checkSubmit(onSubmit), this.props, this.isValid(), this.asyncValidate, this.getFieldList()));
	              }
	            } else {
	              // submitOrEvent is the submit function: return deferred submit thunk
	              return (0, _silenceEvents2.default)(function () {
	                return !_this5.submitPromise && _this5.listenToSubmit((0, _handleSubmit2.default)(checkSubmit(submitOrEvent), _this5.props, _this5.isValid(), _this5.asyncValidate, _this5.getFieldList()));
	              });
	            }
	          }
	        }, {
	          key: 'reset',
	          value: function reset() {
	            this.props.reset();
	          }
	        }, {
	          key: 'render',
	          value: function render() {
	            // remove some redux-form config-only props
	            /* eslint-disable no-unused-vars */
	            var _props8 = this.props,
	                anyTouched = _props8.anyTouched,
	                arrayInsert = _props8.arrayInsert,
	                arrayMove = _props8.arrayMove,
	                arrayPop = _props8.arrayPop,
	                arrayPush = _props8.arrayPush,
	                arrayRemove = _props8.arrayRemove,
	                arrayRemoveAll = _props8.arrayRemoveAll,
	                arrayShift = _props8.arrayShift,
	                arraySplice = _props8.arraySplice,
	                arraySwap = _props8.arraySwap,
	                arrayUnshift = _props8.arrayUnshift,
	                asyncErrors = _props8.asyncErrors,
	                asyncValidate = _props8.asyncValidate,
	                asyncValidating = _props8.asyncValidating,
	                blur = _props8.blur,
	                change = _props8.change,
	                destroy = _props8.destroy,
	                destroyOnUnmount = _props8.destroyOnUnmount,
	                dirty = _props8.dirty,
	                dispatch = _props8.dispatch,
	                enableReinitialize = _props8.enableReinitialize,
	                error = _props8.error,
	                focus = _props8.focus,
	                form = _props8.form,
	                getFormState = _props8.getFormState,
	                initialize = _props8.initialize,
	                initialized = _props8.initialized,
	                initialValues = _props8.initialValues,
	                invalid = _props8.invalid,
	                keepDirtyOnReinitialize = _props8.keepDirtyOnReinitialize,
	                pristine = _props8.pristine,
	                propNamespace = _props8.propNamespace,
	                registeredFields = _props8.registeredFields,
	                registerField = _props8.registerField,
	                reset = _props8.reset,
	                setSubmitFailed = _props8.setSubmitFailed,
	                setSubmitSucceeded = _props8.setSubmitSucceeded,
	                shouldAsyncValidate = _props8.shouldAsyncValidate,
	                shouldValidate = _props8.shouldValidate,
	                startAsyncValidation = _props8.startAsyncValidation,
	                startSubmit = _props8.startSubmit,
	                stopAsyncValidation = _props8.stopAsyncValidation,
	                stopSubmit = _props8.stopSubmit,
	                submitting = _props8.submitting,
	                submitFailed = _props8.submitFailed,
	                submitSucceeded = _props8.submitSucceeded,
	                touch = _props8.touch,
	                touchOnBlur = _props8.touchOnBlur,
	                touchOnChange = _props8.touchOnChange,
	                persistentSubmitErrors = _props8.persistentSubmitErrors,
	                syncErrors = _props8.syncErrors,
	                syncWarnings = _props8.syncWarnings,
	                unregisterField = _props8.unregisterField,
	                untouch = _props8.untouch,
	                updateSyncErrors = _props8.updateSyncErrors,
	                updateSyncWarnings = _props8.updateSyncWarnings,
	                valid = _props8.valid,
	                values = _props8.values,
	                warning = _props8.warning,
	                rest = _objectWithoutProperties(_props8, ['anyTouched', 'arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncErrors', 'asyncValidate', 'asyncValidating', 'blur', 'change', 'destroy', 'destroyOnUnmount', 'dirty', 'dispatch', 'enableReinitialize', 'error', 'focus', 'form', 'getFormState', 'initialize', 'initialized', 'initialValues', 'invalid', 'keepDirtyOnReinitialize', 'pristine', 'propNamespace', 'registeredFields', 'registerField', 'reset', 'setSubmitFailed', 'setSubmitSucceeded', 'shouldAsyncValidate', 'shouldValidate', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitting', 'submitFailed', 'submitSucceeded', 'touch', 'touchOnBlur', 'touchOnChange', 'persistentSubmitErrors', 'syncErrors', 'syncWarnings', 'unregisterField', 'untouch', 'updateSyncErrors', 'updateSyncWarnings', 'valid', 'values', 'warning']);
	            /* eslint-enable no-unused-vars */
	
	
	            var reduxFormProps = _extends({
	              anyTouched: anyTouched,
	              asyncValidate: this.asyncValidate,
	              asyncValidating: asyncValidating
	            }, (0, _redux.bindActionCreators)({ blur: blur, change: change }, dispatch), {
	              destroy: destroy,
	              dirty: dirty,
	              dispatch: dispatch,
	              error: error,
	              form: form,
	              handleSubmit: this.submit,
	              initialize: initialize,
	              initialized: initialized,
	              initialValues: initialValues,
	              invalid: invalid,
	              pristine: pristine,
	              reset: reset,
	              submitting: submitting,
	              submitFailed: submitFailed,
	              submitSucceeded: submitSucceeded,
	              touch: touch,
	              untouch: untouch,
	              valid: valid,
	              warning: warning
	            });
	            var propsToPass = _extends({}, propNamespace ? _defineProperty({}, propNamespace, reduxFormProps) : reduxFormProps, rest);
	            if (isClassComponent(WrappedComponent)) {
	              propsToPass.ref = 'wrapped';
	            }
	            return (0, _react.createElement)(WrappedComponent, propsToPass);
	          }
	        }]);
	
	        return Form;
	      }(_react.Component);
	
	      Form.displayName = 'Form(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	      Form.WrappedComponent = WrappedComponent;
	      Form.childContextTypes = {
	        _reduxForm: _react.PropTypes.object.isRequired
	      };
	      Form.propTypes = {
	        destroyOnUnmount: _react.PropTypes.bool,
	        form: _react.PropTypes.string.isRequired,
	        initialValues: _react.PropTypes.object,
	        getFormState: _react.PropTypes.func,
	        onSubmitFail: _react.PropTypes.func,
	        onSubmitSuccess: _react.PropTypes.func,
	        propNameSpace: _react.PropTypes.string,
	        validate: _react.PropTypes.func,
	        warn: _react.PropTypes.func,
	        touchOnBlur: _react.PropTypes.bool,
	        touchOnChange: _react.PropTypes.bool,
	        triggerSubmit: _react.PropTypes.bool,
	        persistentSubmitErrors: _react.PropTypes.bool,
	        registeredFields: _react.PropTypes.any
	      };
	
	      var connector = (0, _reactRedux.connect)(function (state, props) {
	        var form = props.form,
	            getFormState = props.getFormState,
	            initialValues = props.initialValues,
	            enableReinitialize = props.enableReinitialize,
	            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;
	
	        var formState = getIn(getFormState(state) || empty, form) || empty;
	        var stateInitial = getIn(formState, 'initial');
	
	        var shouldUpdateInitialValues = enableReinitialize && !deepEqual(initialValues, stateInitial);
	        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;
	
	        var initial = initialValues || stateInitial || empty;
	
	        if (shouldUpdateInitialValues) {
	          initial = stateInitial || empty;
	        }
	
	        var values = getIn(formState, 'values') || initial;
	
	        if (shouldResetValues) {
	          values = initial;
	        }
	
	        var pristine = deepEqual(initial, values);
	        var asyncErrors = getIn(formState, 'asyncErrors');
	        var syncErrors = getIn(formState, 'syncErrors') || {};
	        var syncWarnings = getIn(formState, 'syncWarnings') || {};
	        var registeredFields = getIn(formState, 'registeredFields') || [];
	        var valid = isValid(form, getFormState)(state);
	        var anyTouched = !!getIn(formState, 'anyTouched');
	        var submitting = !!getIn(formState, 'submitting');
	        var submitFailed = !!getIn(formState, 'submitFailed');
	        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
	        var error = getIn(formState, 'error');
	        var warning = getIn(formState, 'warning');
	        var triggerSubmit = getIn(formState, 'triggerSubmit');
	        return {
	          anyTouched: anyTouched,
	          asyncErrors: asyncErrors,
	          asyncValidating: getIn(formState, 'asyncValidating') || false,
	          dirty: !pristine,
	          error: error,
	          initialized: !!stateInitial,
	          invalid: !valid,
	          pristine: pristine,
	          registeredFields: registeredFields,
	          submitting: submitting,
	          submitFailed: submitFailed,
	          submitSucceeded: submitSucceeded,
	          syncErrors: syncErrors,
	          syncWarnings: syncWarnings,
	          triggerSubmit: triggerSubmit,
	          values: values,
	          valid: valid,
	          warning: warning
	        };
	      }, function (dispatch, initialProps) {
	        var bindForm = function bindForm(actionCreator) {
	          return actionCreator.bind(null, initialProps.form);
	        };
	
	        // Bind the first parameter on `props.form`
	        var boundFormACs = (0, _mapValues3.default)(formActions, bindForm);
	        var boundArrayACs = (0, _mapValues3.default)(arrayActions, bindForm);
	        var boundBlur = function boundBlur(field, value) {
	          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
	        };
	        var boundChange = function boundChange(field, value) {
	          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
	        };
	        var boundFocus = bindForm(focus);
	
	        // Wrap action creators with `dispatch`
	        var connectedFormACs = (0, _redux.bindActionCreators)(boundFormACs, dispatch);
	        var connectedArrayACs = {
	          insert: (0, _redux.bindActionCreators)(boundArrayACs.arrayInsert, dispatch),
	          move: (0, _redux.bindActionCreators)(boundArrayACs.arrayMove, dispatch),
	          pop: (0, _redux.bindActionCreators)(boundArrayACs.arrayPop, dispatch),
	          push: (0, _redux.bindActionCreators)(boundArrayACs.arrayPush, dispatch),
	          remove: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemove, dispatch),
	          removeAll: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemoveAll, dispatch),
	          shift: (0, _redux.bindActionCreators)(boundArrayACs.arrayShift, dispatch),
	          splice: (0, _redux.bindActionCreators)(boundArrayACs.arraySplice, dispatch),
	          swap: (0, _redux.bindActionCreators)(boundArrayACs.arraySwap, dispatch),
	          unshift: (0, _redux.bindActionCreators)(boundArrayACs.arrayUnshift, dispatch)
	        };
	
	        var computedActions = _extends({}, connectedFormACs, boundArrayACs, {
	          blur: boundBlur,
	          change: boundChange,
	          array: connectedArrayACs,
	          focus: boundFocus,
	          dispatch: dispatch
	        });
	
	        return function () {
	          return computedActions;
	        };
	      }, undefined, { withRef: true });
	      var ConnectedForm = (0, _hoistNonReactStatics2.default)(connector(Form), WrappedComponent);
	      ConnectedForm.defaultProps = config;
	
	      // build outer component to expose instance api
	      return function (_Component2) {
	        _inherits(ReduxForm, _Component2);
	
	        function ReduxForm() {
	          _classCallCheck(this, ReduxForm);
	
	          return _possibleConstructorReturn(this, (ReduxForm.__proto__ || Object.getPrototypeOf(ReduxForm)).apply(this, arguments));
	        }
	
	        _createClass(ReduxForm, [{
	          key: 'submit',
	          value: function submit() {
	            return this.refs.wrapped.getWrappedInstance().submit();
	          }
	        }, {
	          key: 'reset',
	          value: function reset() {
	            return this.refs.wrapped.getWrappedInstance().reset();
	          }
	        }, {
	          key: 'render',
	          value: function render() {
	            var _props9 = this.props,
	                initialValues = _props9.initialValues,
	                rest = _objectWithoutProperties(_props9, ['initialValues']);
	
	            return (0, _react.createElement)(ConnectedForm, _extends({}, rest, {
	              ref: 'wrapped',
	              // convert initialValues if need to
	              initialValues: fromJS(initialValues)
	            }));
	          }
	        }, {
	          key: 'valid',
	          get: function get() {
	            return this.refs.wrapped.getWrappedInstance().isValid();
	          }
	        }, {
	          key: 'invalid',
	          get: function get() {
	            return !this.valid;
	          }
	        }, {
	          key: 'pristine',
	          get: function get() {
	            return this.refs.wrapped.getWrappedInstance().isPristine();
	          }
	        }, {
	          key: 'dirty',
	          get: function get() {
	            return !this.pristine;
	          }
	        }, {
	          key: 'values',
	          get: function get() {
	            return this.refs.wrapped.getWrappedInstance().getValues();
	          }
	        }, {
	          key: 'fieldList',
	          get: function get() {
	            // mainly provided for testing
	            return this.refs.wrapped.getWrappedInstance().getFieldList();
	          }
	        }, {
	          key: 'wrappedInstance',
	          get: function get() {
	            // for testine
	            return this.refs.wrapped.getWrappedInstance().refs.wrapped;
	          }
	        }]);
	
	        return ReduxForm;
	      }(_react.Component);
	    };
	  };
	};
	
	exports.default = createReduxForm;

/***/ },
/* 2001 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.submitErrors');
	    };
	  };
	};
	
	exports.default = createGetFormSubmitErrors;

/***/ },
/* 2002 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormSyncErrors = function createGetFormSyncErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.syncErrors');
	    };
	  };
	};
	
	exports.default = createGetFormSyncErrors;

/***/ },
/* 2003 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormValues = function createGetFormValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.values');
	    };
	  };
	};
	
	exports.default = createGetFormValues;

/***/ },
/* 2004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPristine = __webpack_require__(934);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsDirty = function createIsDirty(structure) {
	  return function (form, getFormState) {
	    var isPristine = (0, _isPristine2.default)(structure)(form, getFormState);
	    return function (state) {
	      return !isPristine(state);
	    };
	  };
	};
	
	exports.default = createIsDirty;

/***/ },
/* 2005 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isValid = __webpack_require__(466);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsInvalid = function createIsInvalid(structure) {
	  return function (form, getFormState) {
	    var isValid = (0, _isValid2.default)(structure)(form, getFormState);
	    return function (state) {
	      return !isValid(state);
	    };
	  };
	};
	
	exports.default = createIsInvalid;

/***/ },
/* 2006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqualWith2 = __webpack_require__(1644);
	
	var _isEqualWith3 = _interopRequireDefault(_isEqualWith2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customizer = function customizer(obj, other) {
	  if (obj == other) return true;
	  if ((obj == null || obj === '' || obj === false) && (other == null || other === '' || other === false)) return true;
	
	  if (obj && other && obj._error !== other._error) return false;
	  if (obj && other && obj._warning !== other._warning) return false;
	};
	
	var deepEqual = function deepEqual(a, b) {
	  return (0, _isEqualWith3.default)(a, b, customizer);
	};
	
	exports.default = deepEqual;

/***/ },
/* 2007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(282);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var deleteInWithPath = function deleteInWithPath(state, first) {
	  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    rest[_key - 2] = arguments[_key];
	  }
	
	  if (state === undefined || first === undefined) {
	    return state;
	  }
	  if (rest.length) {
	    if (Array.isArray(state)) {
	      if (first < state.length) {
	        var result = deleteInWithPath.apply(undefined, [state && state[first]].concat(rest));
	        if (result !== state[first]) {
	          var copy = [].concat(_toConsumableArray(state));
	          copy[first] = result;
	          return copy;
	        }
	      }
	      return state;
	    }
	    if (first in state) {
	      var _result = deleteInWithPath.apply(undefined, [state && state[first]].concat(rest));
	      return state[first] === _result ? state : _extends({}, state, _defineProperty({}, first, _result));
	    }
	    return state;
	  }
	  if (Array.isArray(state)) {
	    if (isNaN(first)) {
	      throw new Error('Cannot delete non-numerical index from an array');
	    }
	    if (first < state.length) {
	      var _copy = [].concat(_toConsumableArray(state));
	      _copy.splice(first, 1);
	      return _copy;
	    }
	    return state;
	  }
	  if (first in state) {
	    var _copy2 = _extends({}, state);
	    delete _copy2[first];
	    return _copy2;
	  }
	  return state;
	};
	
	var deleteIn = function deleteIn(state, field) {
	  return deleteInWithPath.apply(undefined, [state].concat(_toConsumableArray((0, _toPath3.default)(field))));
	};
	
	exports.default = deleteIn;

/***/ },
/* 2008 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(282);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
	  if (pathIndex >= path.length) {
	    return value;
	  }
	
	  var first = path[pathIndex];
	  var next = setInWithPath(state && state[first], value, path, pathIndex + 1);
	
	  if (!state) {
	    var initialized = isNaN(first) ? {} : [];
	    initialized[first] = next;
	    return initialized;
	  }
	
	  if (Array.isArray(state)) {
	    var copy = state.slice();
	    copy[first] = next;
	    return copy;
	  }
	
	  return _extends({}, state, _defineProperty({}, first, next));
	};
	
	var setIn = function setIn(state, field, value) {
	  return setInWithPath(state, value, (0, _toPath3.default)(field), 0);
	};
	
	exports.default = setIn;

/***/ },
/* 2009 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var splice = function splice(array, index, removeNum, value) {
	  array = array || [];
	
	  if (index < array.length) {
	    if (value === undefined && !removeNum) {
	      // inserting undefined
	      var _copy2 = [].concat(_toConsumableArray(array));
	      _copy2.splice(index, 0, null);
	      _copy2[index] = undefined;
	      return _copy2;
	    }
	    if (value != null) {
	      var _copy3 = [].concat(_toConsumableArray(array));
	      _copy3.splice(index, removeNum, value); // removing and adding
	      return _copy3;
	    }
	    var _copy = [].concat(_toConsumableArray(array));
	    _copy.splice(index, removeNum); // removing
	    return _copy;
	  }
	  if (removeNum) {
	    // trying to remove non-existant item: return original array
	    return array;
	  }
	  // trying to add outside of range: just set value
	  var copy = [].concat(_toConsumableArray(array));
	  copy[index] = value;
	  return copy;
	};
	
	exports.default = splice;

/***/ },
/* 2010 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getDisplayName = function getDisplayName(Comp) {
	  return Comp.displayName || Comp.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ },
/* 2011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRedux = __webpack_require__(19);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var createValues = function createValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (config) {
	    var _prop$getFormState$co = _extends({
	      prop: 'values',
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      }
	    }, config),
	        form = _prop$getFormState$co.form,
	        prop = _prop$getFormState$co.prop,
	        getFormState = _prop$getFormState$co.getFormState;
	
	    return (0, _reactRedux.connect)(function (state) {
	      return _defineProperty({}, prop, getIn(getFormState(state), form + '.values'));
	    }, function () {
	      return {};
	    } // ignore dispatch
	    );
	  };
	};
	
	exports.default = createValues;

/***/ },
/* 2012 */
1938,
/* 2013 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = promiseMiddleware;
	
	var _fluxStandardAction = __webpack_require__(1520);
	
	function isPromise(val) {
	  return val && typeof val.then === 'function';
	}
	
	function promiseMiddleware(_ref) {
	  var dispatch = _ref.dispatch;
	
	  return function (next) {
	    return function (action) {
	      if (!_fluxStandardAction.isFSA(action)) {
	        return isPromise(action) ? action.then(dispatch) : next(action);
	      }
	
	      return isPromise(action.payload) ? action.payload.then(function (result) {
	        return dispatch(_extends({}, action, { payload: result }));
	      }, function (error) {
	        return dispatch(_extends({}, action, { payload: error, error: true }));
	      }) : next(action);
	    };
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 2014 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(936);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 2015 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 2016 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(937);
	
	var _isPlainObject = __webpack_require__(417);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(938);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  if (false) {
	    var unexpectedKeyCache = {};
	  }
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 2017 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(2018);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ },
/* 2018 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ },
/* 2019 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2020 */
/***/ function(module, exports) {

	"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	module.exports = function (_ref) {
	  var data = _ref.data;
	  var multiSection = _ref.multiSection;
	
	  function nextNonEmptySectionIndex(sectionIndex) {
	    if (sectionIndex === null) {
	      sectionIndex = 0;
	    } else {
	      sectionIndex++;
	    }
	
	    while (sectionIndex < data.length && data[sectionIndex] === 0) {
	      sectionIndex++;
	    }
	
	    return sectionIndex === data.length ? null : sectionIndex;
	  }
	
	  function prevNonEmptySectionIndex(sectionIndex) {
	    if (sectionIndex === null) {
	      sectionIndex = data.length - 1;
	    } else {
	      sectionIndex--;
	    }
	
	    while (sectionIndex >= 0 && data[sectionIndex] === 0) {
	      sectionIndex--;
	    }
	
	    return sectionIndex === -1 ? null : sectionIndex;
	  }
	
	  function next(position) {
	    var _position = _slicedToArray(position, 2);
	
	    var sectionIndex = _position[0];
	    var itemIndex = _position[1];
	
	
	    if (multiSection) {
	      if (itemIndex === null || itemIndex === data[sectionIndex] - 1) {
	        sectionIndex = nextNonEmptySectionIndex(sectionIndex);
	
	        if (sectionIndex === null) {
	          return [null, null];
	        }
	
	        return [sectionIndex, 0];
	      }
	
	      return [sectionIndex, itemIndex + 1];
	    }
	
	    if (data === 0 || itemIndex === data - 1) {
	      return [null, null];
	    }
	
	    if (itemIndex === null) {
	      return [null, 0];
	    }
	
	    return [null, itemIndex + 1];
	  }
	
	  function prev(position) {
	    var _position2 = _slicedToArray(position, 2);
	
	    var sectionIndex = _position2[0];
	    var itemIndex = _position2[1];
	
	
	    if (multiSection) {
	      if (itemIndex === null || itemIndex === 0) {
	        sectionIndex = prevNonEmptySectionIndex(sectionIndex);
	
	        if (sectionIndex === null) {
	          return [null, null];
	        }
	
	        return [sectionIndex, data[sectionIndex] - 1];
	      }
	
	      return [sectionIndex, itemIndex - 1];
	    }
	
	    if (data === 0 || itemIndex === 0) {
	      return [null, null];
	    }
	
	    if (itemIndex === null) {
	      return [null, data - 1];
	    }
	
	    return [null, itemIndex - 1];
	  }
	
	  function isLast(position) {
	    return next(position)[1] === null;
	  }
	
	  return {
	    next: next,
	    prev: prev,
	    isLast: isLast
	  };
	};


/***/ },
/* 2021 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {// A port of an algorithm by Johannes Baagøe <baagoe@baagoe.com>, 2010
	// http://baagoe.com/en/RandomMusings/javascript/
	// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
	// Original work is under MIT license -
	
	// Copyright (C) 2010 by Johannes Baagøe <baagoe@baagoe.org>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	// 
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	// 
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	
	
	(function(global, module, define) {
	
	function Alea(seed) {
	  var me = this, mash = Mash();
	
	  me.next = function() {
	    var t = 2091639 * me.s0 + me.c * 2.3283064365386963e-10; // 2^-32
	    me.s0 = me.s1;
	    me.s1 = me.s2;
	    return me.s2 = t - (me.c = t | 0);
	  };
	
	  // Apply the seeding algorithm from Baagoe.
	  me.c = 1;
	  me.s0 = mash(' ');
	  me.s1 = mash(' ');
	  me.s2 = mash(' ');
	  me.s0 -= mash(seed);
	  if (me.s0 < 0) { me.s0 += 1; }
	  me.s1 -= mash(seed);
	  if (me.s1 < 0) { me.s1 += 1; }
	  me.s2 -= mash(seed);
	  if (me.s2 < 0) { me.s2 += 1; }
	  mash = null;
	}
	
	function copy(f, t) {
	  t.c = f.c;
	  t.s0 = f.s0;
	  t.s1 = f.s1;
	  t.s2 = f.s2;
	  return t;
	}
	
	function impl(seed, opts) {
	  var xg = new Alea(seed),
	      state = opts && opts.state,
	      prng = xg.next;
	  prng.int32 = function() { return (xg.next() * 0x100000000) | 0; }
	  prng.double = function() {
	    return prng() + (prng() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
	  };
	  prng.quick = prng;
	  if (state) {
	    if (typeof(state) == 'object') copy(state, xg);
	    prng.state = function() { return copy(xg, {}); }
	  }
	  return prng;
	}
	
	function Mash() {
	  var n = 0xefc8249d;
	
	  var mash = function(data) {
	    data = data.toString();
	    for (var i = 0; i < data.length; i++) {
	      n += data.charCodeAt(i);
	      var h = 0.02519603282416938 * n;
	      n = h >>> 0;
	      h -= n;
	      h *= n;
	      n = h >>> 0;
	      h -= n;
	      n += h * 0x100000000; // 2^32
	    }
	    return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
	  };
	
	  return mash;
	}
	
	
	if (module && module.exports) {
	  module.exports = impl;
	} else if (__webpack_require__(80) && __webpack_require__(187)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return impl; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
	  this.alea = impl;
	}
	
	})(
	  this,
	  (typeof module) == 'object' && module,    // present in node.js
	  __webpack_require__(80)   // present with an AMD loader
	);
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)(module)))

/***/ },
/* 2022 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {// A Javascript implementaion of the "Tyche-i" prng algorithm by
	// Samuel Neves and Filipe Araujo.
	// See https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf
	
	(function(global, module, define) {
	
	function XorGen(seed) {
	  var me = this, strseed = '';
	
	  // Set up generator function.
	  me.next = function() {
	    var b = me.b, c = me.c, d = me.d, a = me.a;
	    b = (b << 25) ^ (b >>> 7) ^ c;
	    c = (c - d) | 0;
	    d = (d << 24) ^ (d >>> 8) ^ a;
	    a = (a - b) | 0;
	    me.b = b = (b << 20) ^ (b >>> 12) ^ c;
	    me.c = c = (c - d) | 0;
	    me.d = (d << 16) ^ (c >>> 16) ^ a;
	    return me.a = (a - b) | 0;
	  };
	
	  /* The following is non-inverted tyche, which has better internal
	   * bit diffusion, but which is about 25% slower than tyche-i in JS.
	  me.next = function() {
	    var a = me.a, b = me.b, c = me.c, d = me.d;
	    a = (me.a + me.b | 0) >>> 0;
	    d = me.d ^ a; d = d << 16 ^ d >>> 16;
	    c = me.c + d | 0;
	    b = me.b ^ c; b = b << 12 ^ d >>> 20;
	    me.a = a = a + b | 0;
	    d = d ^ a; me.d = d = d << 8 ^ d >>> 24;
	    me.c = c = c + d | 0;
	    b = b ^ c;
	    return me.b = (b << 7 ^ b >>> 25);
	  }
	  */
	
	  me.a = 0;
	  me.b = 0;
	  me.c = 2654435769 | 0;
	  me.d = 1367130551;
	
	  if (seed === Math.floor(seed)) {
	    // Integer seed.
	    me.a = (seed / 0x100000000) | 0;
	    me.b = seed | 0;
	  } else {
	    // String seed.
	    strseed += seed;
	  }
	
	  // Mix in string seed, then discard an initial batch of 64 values.
	  for (var k = 0; k < strseed.length + 20; k++) {
	    me.b ^= strseed.charCodeAt(k) | 0;
	    me.next();
	  }
	}
	
	function copy(f, t) {
	  t.a = f.a;
	  t.b = f.b;
	  t.c = f.c;
	  t.d = f.d;
	  return t;
	};
	
	function impl(seed, opts) {
	  var xg = new XorGen(seed),
	      state = opts && opts.state,
	      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
	  prng.double = function() {
	    do {
	      var top = xg.next() >>> 11,
	          bot = (xg.next() >>> 0) / 0x100000000,
	          result = (top + bot) / (1 << 21);
	    } while (result === 0);
	    return result;
	  };
	  prng.int32 = xg.next;
	  prng.quick = prng;
	  if (state) {
	    if (typeof(state) == 'object') copy(state, xg);
	    prng.state = function() { return copy(xg, {}); }
	  }
	  return prng;
	}
	
	if (module && module.exports) {
	  module.exports = impl;
	} else if (__webpack_require__(80) && __webpack_require__(187)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return impl; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
	  this.tychei = impl;
	}
	
	})(
	  this,
	  (typeof module) == 'object' && module,    // present in node.js
	  __webpack_require__(80)   // present with an AMD loader
	);
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)(module)))

/***/ },
/* 2023 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {// A Javascript implementaion of the "xor128" prng algorithm by
	// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
	
	(function(global, module, define) {
	
	function XorGen(seed) {
	  var me = this, strseed = '';
	
	  me.x = 0;
	  me.y = 0;
	  me.z = 0;
	  me.w = 0;
	
	  // Set up generator function.
	  me.next = function() {
	    var t = me.x ^ (me.x << 11);
	    me.x = me.y;
	    me.y = me.z;
	    me.z = me.w;
	    return me.w ^= (me.w >>> 19) ^ t ^ (t >>> 8);
	  };
	
	  if (seed === (seed | 0)) {
	    // Integer seed.
	    me.x = seed;
	  } else {
	    // String seed.
	    strseed += seed;
	  }
	
	  // Mix in string seed, then discard an initial batch of 64 values.
	  for (var k = 0; k < strseed.length + 64; k++) {
	    me.x ^= strseed.charCodeAt(k) | 0;
	    me.next();
	  }
	}
	
	function copy(f, t) {
	  t.x = f.x;
	  t.y = f.y;
	  t.z = f.z;
	  t.w = f.w;
	  return t;
	}
	
	function impl(seed, opts) {
	  var xg = new XorGen(seed),
	      state = opts && opts.state,
	      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
	  prng.double = function() {
	    do {
	      var top = xg.next() >>> 11,
	          bot = (xg.next() >>> 0) / 0x100000000,
	          result = (top + bot) / (1 << 21);
	    } while (result === 0);
	    return result;
	  };
	  prng.int32 = xg.next;
	  prng.quick = prng;
	  if (state) {
	    if (typeof(state) == 'object') copy(state, xg);
	    prng.state = function() { return copy(xg, {}); }
	  }
	  return prng;
	}
	
	if (module && module.exports) {
	  module.exports = impl;
	} else if (__webpack_require__(80) && __webpack_require__(187)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return impl; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
	  this.xor128 = impl;
	}
	
	})(
	  this,
	  (typeof module) == 'object' && module,    // present in node.js
	  __webpack_require__(80)   // present with an AMD loader
	);
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)(module)))

/***/ },
/* 2024 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {// A Javascript implementaion of Richard Brent's Xorgens xor4096 algorithm.
	//
	// This fast non-cryptographic random number generator is designed for
	// use in Monte-Carlo algorithms. It combines a long-period xorshift
	// generator with a Weyl generator, and it passes all common batteries
	// of stasticial tests for randomness while consuming only a few nanoseconds
	// for each prng generated.  For background on the generator, see Brent's
	// paper: "Some long-period random number generators using shifts and xors."
	// http://arxiv.org/pdf/1004.3115v1.pdf
	//
	// Usage:
	//
	// var xor4096 = require('xor4096');
	// random = xor4096(1);                        // Seed with int32 or string.
	// assert.equal(random(), 0.1520436450538547); // (0, 1) range, 53 bits.
	// assert.equal(random.int32(), 1806534897);   // signed int32, 32 bits.
	//
	// For nonzero numeric keys, this impelementation provides a sequence
	// identical to that by Brent's xorgens 3 implementaion in C.  This
	// implementation also provides for initalizing the generator with
	// string seeds, or for saving and restoring the state of the generator.
	//
	// On Chrome, this prng benchmarks about 2.1 times slower than
	// Javascript's built-in Math.random().
	
	(function(global, module, define) {
	
	function XorGen(seed) {
	  var me = this;
	
	  // Set up generator function.
	  me.next = function() {
	    var w = me.w,
	        X = me.X, i = me.i, t, v;
	    // Update Weyl generator.
	    me.w = w = (w + 0x61c88647) | 0;
	    // Update xor generator.
	    v = X[(i + 34) & 127];
	    t = X[i = ((i + 1) & 127)];
	    v ^= v << 13;
	    t ^= t << 17;
	    v ^= v >>> 15;
	    t ^= t >>> 12;
	    // Update Xor generator array state.
	    v = X[i] = v ^ t;
	    me.i = i;
	    // Result is the combination.
	    return (v + (w ^ (w >>> 16))) | 0;
	  };
	
	  function init(me, seed) {
	    var t, v, i, j, w, X = [], limit = 128;
	    if (seed === (seed | 0)) {
	      // Numeric seeds initialize v, which is used to generates X.
	      v = seed;
	      seed = null;
	    } else {
	      // String seeds are mixed into v and X one character at a time.
	      seed = seed + '\0';
	      v = 0;
	      limit = Math.max(limit, seed.length);
	    }
	    // Initialize circular array and weyl value.
	    for (i = 0, j = -32; j < limit; ++j) {
	      // Put the unicode characters into the array, and shuffle them.
	      if (seed) v ^= seed.charCodeAt((j + 32) % seed.length);
	      // After 32 shuffles, take v as the starting w value.
	      if (j === 0) w = v;
	      v ^= v << 10;
	      v ^= v >>> 15;
	      v ^= v << 4;
	      v ^= v >>> 13;
	      if (j >= 0) {
	        w = (w + 0x61c88647) | 0;     // Weyl.
	        t = (X[j & 127] ^= (v + w));  // Combine xor and weyl to init array.
	        i = (0 == t) ? i + 1 : 0;     // Count zeroes.
	      }
	    }
	    // We have detected all zeroes; make the key nonzero.
	    if (i >= 128) {
	      X[(seed && seed.length || 0) & 127] = -1;
	    }
	    // Run the generator 512 times to further mix the state before using it.
	    // Factoring this as a function slows the main generator, so it is just
	    // unrolled here.  The weyl generator is not advanced while warming up.
	    i = 127;
	    for (j = 4 * 128; j > 0; --j) {
	      v = X[(i + 34) & 127];
	      t = X[i = ((i + 1) & 127)];
	      v ^= v << 13;
	      t ^= t << 17;
	      v ^= v >>> 15;
	      t ^= t >>> 12;
	      X[i] = v ^ t;
	    }
	    // Storing state as object members is faster than using closure variables.
	    me.w = w;
	    me.X = X;
	    me.i = i;
	  }
	
	  init(me, seed);
	}
	
	function copy(f, t) {
	  t.i = f.i;
	  t.w = f.w;
	  t.X = f.X.slice();
	  return t;
	};
	
	function impl(seed, opts) {
	  if (seed == null) seed = +(new Date);
	  var xg = new XorGen(seed),
	      state = opts && opts.state,
	      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
	  prng.double = function() {
	    do {
	      var top = xg.next() >>> 11,
	          bot = (xg.next() >>> 0) / 0x100000000,
	          result = (top + bot) / (1 << 21);
	    } while (result === 0);
	    return result;
	  };
	  prng.int32 = xg.next;
	  prng.quick = prng;
	  if (state) {
	    if (state.X) copy(state, xg);
	    prng.state = function() { return copy(xg, {}); }
	  }
	  return prng;
	}
	
	if (module && module.exports) {
	  module.exports = impl;
	} else if (__webpack_require__(80) && __webpack_require__(187)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return impl; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
	  this.xor4096 = impl;
	}
	
	})(
	  this,                                     // window object or global
	  (typeof module) == 'object' && module,    // present in node.js
	  __webpack_require__(80)   // present with an AMD loader
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)(module)))

/***/ },
/* 2025 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {// A Javascript implementaion of the "xorshift7" algorithm by
	// François Panneton and Pierre L'ecuyer:
	// "On the Xorgshift Random Number Generators"
	// http://saluc.engr.uconn.edu/refs/crypto/rng/panneton05onthexorshift.pdf
	
	(function(global, module, define) {
	
	function XorGen(seed) {
	  var me = this;
	
	  // Set up generator function.
	  me.next = function() {
	    // Update xor generator.
	    var X = me.x, i = me.i, t, v, w;
	    t = X[i]; t ^= (t >>> 7); v = t ^ (t << 24);
	    t = X[(i + 1) & 7]; v ^= t ^ (t >>> 10);
	    t = X[(i + 3) & 7]; v ^= t ^ (t >>> 3);
	    t = X[(i + 4) & 7]; v ^= t ^ (t << 7);
	    t = X[(i + 7) & 7]; t = t ^ (t << 13); v ^= t ^ (t << 9);
	    X[i] = v;
	    me.i = (i + 1) & 7;
	    return v;
	  };
	
	  function init(me, seed) {
	    var j, w, X = [];
	
	    if (seed === (seed | 0)) {
	      // Seed state array using a 32-bit integer.
	      w = X[0] = seed;
	    } else {
	      // Seed state using a string.
	      seed = '' + seed;
	      for (j = 0; j < seed.length; ++j) {
	        X[j & 7] = (X[j & 7] << 15) ^
	            (seed.charCodeAt(j) + X[(j + 1) & 7] << 13);
	      }
	    }
	    // Enforce an array length of 8, not all zeroes.
	    while (X.length < 8) X.push(0);
	    for (j = 0; j < 8 && X[j] === 0; ++j);
	    if (j == 8) w = X[7] = -1; else w = X[j];
	
	    me.x = X;
	    me.i = 0;
	
	    // Discard an initial 256 values.
	    for (j = 256; j > 0; --j) {
	      me.next();
	    }
	  }
	
	  init(me, seed);
	}
	
	function copy(f, t) {
	  t.x = f.x.slice();
	  t.i = f.i;
	  return t;
	}
	
	function impl(seed, opts) {
	  if (seed == null) seed = +(new Date);
	  var xg = new XorGen(seed),
	      state = opts && opts.state,
	      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
	  prng.double = function() {
	    do {
	      var top = xg.next() >>> 11,
	          bot = (xg.next() >>> 0) / 0x100000000,
	          result = (top + bot) / (1 << 21);
	    } while (result === 0);
	    return result;
	  };
	  prng.int32 = xg.next;
	  prng.quick = prng;
	  if (state) {
	    if (state.x) copy(state, xg);
	    prng.state = function() { return copy(xg, {}); }
	  }
	  return prng;
	}
	
	if (module && module.exports) {
	  module.exports = impl;
	} else if (__webpack_require__(80) && __webpack_require__(187)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return impl; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
	  this.xorshift7 = impl;
	}
	
	})(
	  this,
	  (typeof module) == 'object' && module,    // present in node.js
	  __webpack_require__(80)   // present with an AMD loader
	);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)(module)))

/***/ },
/* 2026 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {// A Javascript implementaion of the "xorwow" prng algorithm by
	// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
	
	(function(global, module, define) {
	
	function XorGen(seed) {
	  var me = this, strseed = '';
	
	  // Set up generator function.
	  me.next = function() {
	    var t = (me.x ^ (me.x >>> 2));
	    me.x = me.y; me.y = me.z; me.z = me.w; me.w = me.v;
	    return (me.d = (me.d + 362437 | 0)) +
	       (me.v = (me.v ^ (me.v << 4)) ^ (t ^ (t << 1))) | 0;
	  };
	
	  me.x = 0;
	  me.y = 0;
	  me.z = 0;
	  me.w = 0;
	  me.v = 0;
	
	  if (seed === (seed | 0)) {
	    // Integer seed.
	    me.x = seed;
	  } else {
	    // String seed.
	    strseed += seed;
	  }
	
	  // Mix in string seed, then discard an initial batch of 64 values.
	  for (var k = 0; k < strseed.length + 64; k++) {
	    me.x ^= strseed.charCodeAt(k) | 0;
	    if (k == strseed.length) {
	      me.d = me.x << 10 ^ me.x >>> 4;
	    }
	    me.next();
	  }
	}
	
	function copy(f, t) {
	  t.x = f.x;
	  t.y = f.y;
	  t.z = f.z;
	  t.w = f.w;
	  t.v = f.v;
	  t.d = f.d;
	  return t;
	}
	
	function impl(seed, opts) {
	  var xg = new XorGen(seed),
	      state = opts && opts.state,
	      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
	  prng.double = function() {
	    do {
	      var top = xg.next() >>> 11,
	          bot = (xg.next() >>> 0) / 0x100000000,
	          result = (top + bot) / (1 << 21);
	    } while (result === 0);
	    return result;
	  };
	  prng.int32 = xg.next;
	  prng.quick = prng;
	  if (state) {
	    if (typeof(state) == 'object') copy(state, xg);
	    prng.state = function() { return copy(xg, {}); }
	  }
	  return prng;
	}
	
	if (module && module.exports) {
	  module.exports = impl;
	} else if (__webpack_require__(80) && __webpack_require__(187)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return impl; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
	  this.xorwow = impl;
	}
	
	})(
	  this,
	  (typeof module) == 'object' && module,    // present in node.js
	  __webpack_require__(80)   // present with an AMD loader
	);
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)(module)))

/***/ },
/* 2027 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	Copyright 2014 David Bau.
	
	Permission is hereby granted, free of charge, to any person obtaining
	a copy of this software and associated documentation files (the
	"Software"), to deal in the Software without restriction, including
	without limitation the rights to use, copy, modify, merge, publish,
	distribute, sublicense, and/or sell copies of the Software, and to
	permit persons to whom the Software is furnished to do so, subject to
	the following conditions:
	
	The above copyright notice and this permission notice shall be
	included in all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	*/
	
	(function (pool, math) {
	//
	// The following constants are related to IEEE 754 limits.
	//
	var global = this,
	    width = 256,        // each RC4 output is 0 <= x < 256
	    chunks = 6,         // at least six RC4 outputs for each double
	    digits = 52,        // there are 52 significant digits in a double
	    rngname = 'random', // rngname: name for Math.random and Math.seedrandom
	    startdenom = math.pow(width, chunks),
	    significance = math.pow(2, digits),
	    overflow = significance * 2,
	    mask = width - 1,
	    nodecrypto;         // node.js crypto module, initialized at the bottom.
	
	//
	// seedrandom()
	// This is the seedrandom function described above.
	//
	function seedrandom(seed, options, callback) {
	  var key = [];
	  options = (options == true) ? { entropy: true } : (options || {});
	
	  // Flatten the seed string or build one from local entropy if needed.
	  var shortseed = mixkey(flatten(
	    options.entropy ? [seed, tostring(pool)] :
	    (seed == null) ? autoseed() : seed, 3), key);
	
	  // Use the seed to initialize an ARC4 generator.
	  var arc4 = new ARC4(key);
	
	  // This function returns a random double in [0, 1) that contains
	  // randomness in every bit of the mantissa of the IEEE 754 value.
	  var prng = function() {
	    var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
	        d = startdenom,                 //   and denominator d = 2 ^ 48.
	        x = 0;                          //   and no 'extra last byte'.
	    while (n < significance) {          // Fill up all significant digits by
	      n = (n + x) * width;              //   shifting numerator and
	      d *= width;                       //   denominator and generating a
	      x = arc4.g(1);                    //   new least-significant-byte.
	    }
	    while (n >= overflow) {             // To avoid rounding up, before adding
	      n /= 2;                           //   last byte, shift everything
	      d /= 2;                           //   right using integer math until
	      x >>>= 1;                         //   we have exactly the desired bits.
	    }
	    return (n + x) / d;                 // Form the number within [0, 1).
	  };
	
	  prng.int32 = function() { return arc4.g(4) | 0; }
	  prng.quick = function() { return arc4.g(4) / 0x100000000; }
	  prng.double = prng;
	
	  // Mix the randomness into accumulated entropy.
	  mixkey(tostring(arc4.S), pool);
	
	  // Calling convention: what to return as a function of prng, seed, is_math.
	  return (options.pass || callback ||
	      function(prng, seed, is_math_call, state) {
	        if (state) {
	          // Load the arc4 state from the given state if it has an S array.
	          if (state.S) { copy(state, arc4); }
	          // Only provide the .state method if requested via options.state.
	          prng.state = function() { return copy(arc4, {}); }
	        }
	
	        // If called as a method of Math (Math.seedrandom()), mutate
	        // Math.random because that is how seedrandom.js has worked since v1.0.
	        if (is_math_call) { math[rngname] = prng; return seed; }
	
	        // Otherwise, it is a newer calling convention, so return the
	        // prng directly.
	        else return prng;
	      })(
	  prng,
	  shortseed,
	  'global' in options ? options.global : (this == math),
	  options.state);
	}
	math['seed' + rngname] = seedrandom;
	
	//
	// ARC4
	//
	// An ARC4 implementation.  The constructor takes a key in the form of
	// an array of at most (width) integers that should be 0 <= x < (width).
	//
	// The g(count) method returns a pseudorandom integer that concatenates
	// the next (count) outputs from ARC4.  Its return value is a number x
	// that is in the range 0 <= x < (width ^ count).
	//
	function ARC4(key) {
	  var t, keylen = key.length,
	      me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
	
	  // The empty key [] is treated as [0].
	  if (!keylen) { key = [keylen++]; }
	
	  // Set up S using the standard key scheduling algorithm.
	  while (i < width) {
	    s[i] = i++;
	  }
	  for (i = 0; i < width; i++) {
	    s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
	    s[j] = t;
	  }
	
	  // The "g" method returns the next (count) outputs as one number.
	  (me.g = function(count) {
	    // Using instance members instead of closure state nearly doubles speed.
	    var t, r = 0,
	        i = me.i, j = me.j, s = me.S;
	    while (count--) {
	      t = s[i = mask & (i + 1)];
	      r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
	    }
	    me.i = i; me.j = j;
	    return r;
	    // For robust unpredictability, the function call below automatically
	    // discards an initial batch of values.  This is called RC4-drop[256].
	    // See http://google.com/search?q=rsa+fluhrer+response&btnI
	  })(width);
	}
	
	//
	// copy()
	// Copies internal state of ARC4 to or from a plain object.
	//
	function copy(f, t) {
	  t.i = f.i;
	  t.j = f.j;
	  t.S = f.S.slice();
	  return t;
	};
	
	//
	// flatten()
	// Converts an object tree to nested arrays of strings.
	//
	function flatten(obj, depth) {
	  var result = [], typ = (typeof obj), prop;
	  if (depth && typ == 'object') {
	    for (prop in obj) {
	      try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
	    }
	  }
	  return (result.length ? result : typ == 'string' ? obj : obj + '\0');
	}
	
	//
	// mixkey()
	// Mixes a string seed into a key that is an array of integers, and
	// returns a shortened string seed that is equivalent to the result key.
	//
	function mixkey(seed, key) {
	  var stringseed = seed + '', smear, j = 0;
	  while (j < stringseed.length) {
	    key[mask & j] =
	      mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
	  }
	  return tostring(key);
	}
	
	//
	// autoseed()
	// Returns an object for autoseeding, using window.crypto and Node crypto
	// module if available.
	//
	function autoseed() {
	  try {
	    var out;
	    if (nodecrypto && (out = nodecrypto.randomBytes)) {
	      // The use of 'out' to remember randomBytes makes tight minified code.
	      out = out(width);
	    } else {
	      out = new Uint8Array(width);
	      (global.crypto || global.msCrypto).getRandomValues(out);
	    }
	    return tostring(out);
	  } catch (e) {
	    var browser = global.navigator,
	        plugins = browser && browser.plugins;
	    return [+new Date, global, plugins, global.screen, tostring(pool)];
	  }
	}
	
	//
	// tostring()
	// Converts an array of charcodes to a string
	//
	function tostring(a) {
	  return String.fromCharCode.apply(0, a);
	}
	
	//
	// When seedrandom.js is loaded, we immediately mix a few bits
	// from the built-in RNG into the entropy pool.  Because we do
	// not want to interfere with deterministic PRNG state later,
	// seedrandom will not call math.random on its own again after
	// initialization.
	//
	mixkey(math.random(), pool);
	
	//
	// Nodejs and AMD support: export the implementation as a module using
	// either convention.
	//
	if ((typeof module) == 'object' && module.exports) {
	  module.exports = seedrandom;
	  // When in node.js, try using crypto package for autoseeding.
	  try {
	    nodecrypto = __webpack_require__(2082);
	  } catch (ex) {}
	} else if (true) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return seedrandom; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	// End anonymous scope, and pass initial values.
	})(
	  [],     // pool: entropy pool starts empty
	  Math    // math: package containing random, pow, and seedrandom
	);


/***/ },
/* 2028 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(85);
	var define = __webpack_require__(369);
	var hasDescriptors = __webpack_require__(274)();
	var gOPD = __webpack_require__(140);
	
	var $TypeError = __webpack_require__(22);
	var $floor = GetIntrinsic('%Math.floor%');
	
	/** @type {import('.')} */
	module.exports = function setFunctionLength(fn, length) {
		if (typeof fn !== 'function') {
			throw new $TypeError('`fn` is not a function');
		}
		if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
			throw new $TypeError('`length` must be a positive 32-bit integer');
		}
	
		var loose = arguments.length > 2 && !!arguments[2];
	
		var functionLengthIsConfigurable = true;
		var functionLengthIsWritable = true;
		if ('length' in fn && gOPD) {
			var desc = gOPD(fn, 'length');
			if (desc && !desc.configurable) {
				functionLengthIsConfigurable = false;
			}
			if (desc && !desc.writable) {
				functionLengthIsWritable = false;
			}
		}
	
		if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
			if (hasDescriptors) {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
			} else {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
			}
		}
		return fn;
	};


/***/ },
/* 2029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $Object = __webpack_require__(209);
	
	/** @type {import('./Object.setPrototypeOf')} */
	module.exports = $Object.setPrototypeOf || null;


/***/ },
/* 2030 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./Reflect.setPrototypeOf')} */
	module.exports = (typeof Reflect !== 'undefined' && Reflect.setPrototypeOf) || null;


/***/ },
/* 2031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reflectSetProto = __webpack_require__(2030);
	var originalSetProto = __webpack_require__(2029);
	
	var setDunderProto = __webpack_require__(1362);
	
	var $TypeError = __webpack_require__(22);
	
	/** @type {import('.')} */
	module.exports = reflectSetProto
		? function setProto(O, proto) {
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			if (reflectSetProto(O, proto)) {
				return O;
			}
			throw new $TypeError('Reflect.setPrototypeOf: failed to set [[Prototype]]');
		}
		: originalSetProto || (
			setDunderProto ? function setProto(O, proto) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				setDunderProto(O, proto);
				return O;
			} : null
		);


/***/ },
/* 2032 */
/***/ function(module, exports) {

	'use strict';
	
	function shallowEqualArrays(arrA, arrB) {
	  if (arrA === arrB) {
	    return true;
	  }
	
	  if (!arrA || !arrB) {
	    return false;
	  }
	
	  var len = arrA.length;
	
	  if (arrB.length !== len) {
	    return false;
	  }
	
	  for (var i = 0; i < len; i++) {
	    if (arrA[i] !== arrB[i]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqualArrays;


/***/ },
/* 2033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var fetchKeys = __webpack_require__(1558);
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if (ret !== void 0) {
	        return !!ret;
	    }
	
	    if (objA === objB) {
	        return true;
	    }
	
	    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	        return false;
	    }
	
	    var keysA = fetchKeys(objA);
	    var keysB = fetchKeys(objB);
	
	    var len = keysA.length;
	    if (len !== keysB.length) {
	        return false;
	    }
	
	    compareContext = compareContext || null;
	
	    // Test for A's keys different from B.
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	    for (var i = 0; i < len; i++) {
	        var key = keysA[i];
	        if (!bHasOwnProperty(key)) {
	            return false;
	        }
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        var _ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	        if (_ret === false || _ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	    }
	
	    return true;
	};

/***/ },
/* 2034 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Signature Pad v2.3.2
	 * https://github.com/szimek/signature_pad
	 *
	 * Copyright 2017 Szymon Nowak
	 * Released under the MIT license
	 *
	 * The main idea and some parts of the code (e.g. drawing variable width Bézier curve) are taken from:
	 * http://corner.squareup.com/2012/07/smoother-signatures.html
	 *
	 * Implementation of interpolation using cubic Bézier curves is taken from:
	 * http://benknowscode.wordpress.com/2012/09/14/path-interpolation-using-cubic-bezier-and-control-point-estimation-in-javascript
	 *
	 * Algorithm for approximated length of a Bézier curve is taken from:
	 * http://www.lemoda.net/maths/bezier-length/index.html
	 *
	 */
	
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.SignaturePad = factory());
	}(this, (function () { 'use strict';
	
	function Point(x, y, time) {
	  this.x = x;
	  this.y = y;
	  this.time = time || new Date().getTime();
	}
	
	Point.prototype.velocityFrom = function (start) {
	  return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 1;
	};
	
	Point.prototype.distanceTo = function (start) {
	  return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
	};
	
	Point.prototype.equals = function (other) {
	  return this.x === other.x && this.y === other.y && this.time === other.time;
	};
	
	function Bezier(startPoint, control1, control2, endPoint) {
	  this.startPoint = startPoint;
	  this.control1 = control1;
	  this.control2 = control2;
	  this.endPoint = endPoint;
	}
	
	// Returns approximated length.
	Bezier.prototype.length = function () {
	  var steps = 10;
	  var length = 0;
	  var px = void 0;
	  var py = void 0;
	
	  for (var i = 0; i <= steps; i += 1) {
	    var t = i / steps;
	    var cx = this._point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
	    var cy = this._point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
	    if (i > 0) {
	      var xdiff = cx - px;
	      var ydiff = cy - py;
	      length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
	    }
	    px = cx;
	    py = cy;
	  }
	
	  return length;
	};
	
	/* eslint-disable no-multi-spaces, space-in-parens */
	Bezier.prototype._point = function (t, start, c1, c2, end) {
	  return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
	};
	
	/* eslint-disable */
	
	// http://stackoverflow.com/a/27078401/815507
	function throttle(func, wait, options) {
	  var context, args, result;
	  var timeout = null;
	  var previous = 0;
	  if (!options) options = {};
	  var later = function later() {
	    previous = options.leading === false ? 0 : Date.now();
	    timeout = null;
	    result = func.apply(context, args);
	    if (!timeout) context = args = null;
	  };
	  return function () {
	    var now = Date.now();
	    if (!previous && options.leading === false) previous = now;
	    var remaining = wait - (now - previous);
	    context = this;
	    args = arguments;
	    if (remaining <= 0 || remaining > wait) {
	      if (timeout) {
	        clearTimeout(timeout);
	        timeout = null;
	      }
	      previous = now;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    } else if (!timeout && options.trailing !== false) {
	      timeout = setTimeout(later, remaining);
	    }
	    return result;
	  };
	}
	
	function SignaturePad(canvas, options) {
	  var self = this;
	  var opts = options || {};
	
	  this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
	  this.minWidth = opts.minWidth || 0.5;
	  this.maxWidth = opts.maxWidth || 2.5;
	  this.throttle = 'throttle' in opts ? opts.throttle : 16; // in miliseconds
	  this.minDistance = 'minDistance' in opts ? opts.minDistance : 5;
	
	  if (this.throttle) {
	    this._strokeMoveUpdate = throttle(SignaturePad.prototype._strokeUpdate, this.throttle);
	  } else {
	    this._strokeMoveUpdate = SignaturePad.prototype._strokeUpdate;
	  }
	
	  this.dotSize = opts.dotSize || function () {
	    return (this.minWidth + this.maxWidth) / 2;
	  };
	  this.penColor = opts.penColor || 'black';
	  this.backgroundColor = opts.backgroundColor || 'rgba(0,0,0,0)';
	  this.onBegin = opts.onBegin;
	  this.onEnd = opts.onEnd;
	
	  this._canvas = canvas;
	  this._ctx = canvas.getContext('2d');
	  this.clear();
	
	  // We need add these inline so they are available to unbind while still having
	  // access to 'self' we could use _.bind but it's not worth adding a dependency.
	  this._handleMouseDown = function (event) {
	    if (event.which === 1) {
	      self._mouseButtonDown = true;
	      self._strokeBegin(event);
	    }
	  };
	
	  this._handleMouseMove = function (event) {
	    if (self._mouseButtonDown) {
	      self._strokeMoveUpdate(event);
	    }
	  };
	
	  this._handleMouseUp = function (event) {
	    if (event.which === 1 && self._mouseButtonDown) {
	      self._mouseButtonDown = false;
	      self._strokeEnd(event);
	    }
	  };
	
	  this._handleTouchStart = function (event) {
	    if (event.targetTouches.length === 1) {
	      var touch = event.changedTouches[0];
	      self._strokeBegin(touch);
	    }
	  };
	
	  this._handleTouchMove = function (event) {
	    // Prevent scrolling.
	    event.preventDefault();
	
	    var touch = event.targetTouches[0];
	    self._strokeMoveUpdate(touch);
	  };
	
	  this._handleTouchEnd = function (event) {
	    var wasCanvasTouched = event.target === self._canvas;
	    if (wasCanvasTouched) {
	      event.preventDefault();
	      self._strokeEnd(event);
	    }
	  };
	
	  // Enable mouse and touch event handlers
	  this.on();
	}
	
	// Public methods
	SignaturePad.prototype.clear = function () {
	  var ctx = this._ctx;
	  var canvas = this._canvas;
	
	  ctx.fillStyle = this.backgroundColor;
	  ctx.clearRect(0, 0, canvas.width, canvas.height);
	  ctx.fillRect(0, 0, canvas.width, canvas.height);
	
	  this._data = [];
	  this._reset();
	  this._isEmpty = true;
	};
	
	SignaturePad.prototype.fromDataURL = function (dataUrl) {
	  var _this = this;
	
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var image = new Image();
	  var ratio = options.ratio || window.devicePixelRatio || 1;
	  var width = options.width || this._canvas.width / ratio;
	  var height = options.height || this._canvas.height / ratio;
	
	  this._reset();
	  image.src = dataUrl;
	  image.onload = function () {
	    _this._ctx.drawImage(image, 0, 0, width, height);
	  };
	  this._isEmpty = false;
	};
	
	SignaturePad.prototype.toDataURL = function (type) {
	  var _canvas;
	
	  switch (type) {
	    case 'image/svg+xml':
	      return this._toSVG();
	    default:
	      for (var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        options[_key - 1] = arguments[_key];
	      }
	
	      return (_canvas = this._canvas).toDataURL.apply(_canvas, [type].concat(options));
	  }
	};
	
	SignaturePad.prototype.on = function () {
	  this._handleMouseEvents();
	  this._handleTouchEvents();
	};
	
	SignaturePad.prototype.off = function () {
	  this._canvas.removeEventListener('mousedown', this._handleMouseDown);
	  this._canvas.removeEventListener('mousemove', this._handleMouseMove);
	  document.removeEventListener('mouseup', this._handleMouseUp);
	
	  this._canvas.removeEventListener('touchstart', this._handleTouchStart);
	  this._canvas.removeEventListener('touchmove', this._handleTouchMove);
	  this._canvas.removeEventListener('touchend', this._handleTouchEnd);
	};
	
	SignaturePad.prototype.isEmpty = function () {
	  return this._isEmpty;
	};
	
	// Private methods
	SignaturePad.prototype._strokeBegin = function (event) {
	  this._data.push([]);
	  this._reset();
	  this._strokeUpdate(event);
	
	  if (typeof this.onBegin === 'function') {
	    this.onBegin(event);
	  }
	};
	
	SignaturePad.prototype._strokeUpdate = function (event) {
	  var x = event.clientX;
	  var y = event.clientY;
	
	  var point = this._createPoint(x, y);
	  var lastPointGroup = this._data[this._data.length - 1];
	  var lastPoint = lastPointGroup && lastPointGroup[lastPointGroup.length - 1];
	  var isLastPointTooClose = lastPoint && point.distanceTo(lastPoint) < this.minDistance;
	
	  // Skip this point if it's too close to the previous one
	  if (!(lastPoint && isLastPointTooClose)) {
	    var _addPoint = this._addPoint(point),
	        curve = _addPoint.curve,
	        widths = _addPoint.widths;
	
	    if (curve && widths) {
	      this._drawCurve(curve, widths.start, widths.end);
	    }
	
	    this._data[this._data.length - 1].push({
	      x: point.x,
	      y: point.y,
	      time: point.time,
	      color: this.penColor
	    });
	  }
	};
	
	SignaturePad.prototype._strokeEnd = function (event) {
	  var canDrawCurve = this.points.length > 2;
	  var point = this.points[0]; // Point instance
	
	  if (!canDrawCurve && point) {
	    this._drawDot(point);
	  }
	
	  if (point) {
	    var lastPointGroup = this._data[this._data.length - 1];
	    var lastPoint = lastPointGroup[lastPointGroup.length - 1]; // plain object
	
	    // When drawing a dot, there's only one point in a group, so without this check
	    // such group would end up with exactly the same 2 points.
	    if (!point.equals(lastPoint)) {
	      lastPointGroup.push({
	        x: point.x,
	        y: point.y,
	        time: point.time,
	        color: this.penColor
	      });
	    }
	  }
	
	  if (typeof this.onEnd === 'function') {
	    this.onEnd(event);
	  }
	};
	
	SignaturePad.prototype._handleMouseEvents = function () {
	  this._mouseButtonDown = false;
	
	  this._canvas.addEventListener('mousedown', this._handleMouseDown);
	  this._canvas.addEventListener('mousemove', this._handleMouseMove);
	  document.addEventListener('mouseup', this._handleMouseUp);
	};
	
	SignaturePad.prototype._handleTouchEvents = function () {
	  // Pass touch events to canvas element on mobile IE11 and Edge.
	  this._canvas.style.msTouchAction = 'none';
	  this._canvas.style.touchAction = 'none';
	
	  this._canvas.addEventListener('touchstart', this._handleTouchStart);
	  this._canvas.addEventListener('touchmove', this._handleTouchMove);
	  this._canvas.addEventListener('touchend', this._handleTouchEnd);
	};
	
	SignaturePad.prototype._reset = function () {
	  this.points = [];
	  this._lastVelocity = 0;
	  this._lastWidth = (this.minWidth + this.maxWidth) / 2;
	  this._ctx.fillStyle = this.penColor;
	};
	
	SignaturePad.prototype._createPoint = function (x, y, time) {
	  var rect = this._canvas.getBoundingClientRect();
	
	  return new Point(x - rect.left, y - rect.top, time || new Date().getTime());
	};
	
	SignaturePad.prototype._addPoint = function (point) {
	  var points = this.points;
	  var tmp = void 0;
	
	  points.push(point);
	
	  if (points.length > 2) {
	    // To reduce the initial lag make it work with 3 points
	    // by copying the first point to the beginning.
	    if (points.length === 3) points.unshift(points[0]);
	
	    tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
	    var c2 = tmp.c2;
	    tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
	    var c3 = tmp.c1;
	    var curve = new Bezier(points[1], c2, c3, points[2]);
	    var widths = this._calculateCurveWidths(curve);
	
	    // Remove the first element from the list,
	    // so that we always have no more than 4 points in points array.
	    points.shift();
	
	    return { curve: curve, widths: widths };
	  }
	
	  return {};
	};
	
	SignaturePad.prototype._calculateCurveControlPoints = function (s1, s2, s3) {
	  var dx1 = s1.x - s2.x;
	  var dy1 = s1.y - s2.y;
	  var dx2 = s2.x - s3.x;
	  var dy2 = s2.y - s3.y;
	
	  var m1 = { x: (s1.x + s2.x) / 2.0, y: (s1.y + s2.y) / 2.0 };
	  var m2 = { x: (s2.x + s3.x) / 2.0, y: (s2.y + s3.y) / 2.0 };
	
	  var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
	  var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
	
	  var dxm = m1.x - m2.x;
	  var dym = m1.y - m2.y;
	
	  var k = l2 / (l1 + l2);
	  var cm = { x: m2.x + dxm * k, y: m2.y + dym * k };
	
	  var tx = s2.x - cm.x;
	  var ty = s2.y - cm.y;
	
	  return {
	    c1: new Point(m1.x + tx, m1.y + ty),
	    c2: new Point(m2.x + tx, m2.y + ty)
	  };
	};
	
	SignaturePad.prototype._calculateCurveWidths = function (curve) {
	  var startPoint = curve.startPoint;
	  var endPoint = curve.endPoint;
	  var widths = { start: null, end: null };
	
	  var velocity = this.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - this.velocityFilterWeight) * this._lastVelocity;
	
	  var newWidth = this._strokeWidth(velocity);
	
	  widths.start = this._lastWidth;
	  widths.end = newWidth;
	
	  this._lastVelocity = velocity;
	  this._lastWidth = newWidth;
	
	  return widths;
	};
	
	SignaturePad.prototype._strokeWidth = function (velocity) {
	  return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
	};
	
	SignaturePad.prototype._drawPoint = function (x, y, size) {
	  var ctx = this._ctx;
	
	  ctx.moveTo(x, y);
	  ctx.arc(x, y, size, 0, 2 * Math.PI, false);
	  this._isEmpty = false;
	};
	
	SignaturePad.prototype._drawCurve = function (curve, startWidth, endWidth) {
	  var ctx = this._ctx;
	  var widthDelta = endWidth - startWidth;
	  var drawSteps = Math.floor(curve.length());
	
	  ctx.beginPath();
	
	  for (var i = 0; i < drawSteps; i += 1) {
	    // Calculate the Bezier (x, y) coordinate for this step.
	    var t = i / drawSteps;
	    var tt = t * t;
	    var ttt = tt * t;
	    var u = 1 - t;
	    var uu = u * u;
	    var uuu = uu * u;
	
	    var x = uuu * curve.startPoint.x;
	    x += 3 * uu * t * curve.control1.x;
	    x += 3 * u * tt * curve.control2.x;
	    x += ttt * curve.endPoint.x;
	
	    var y = uuu * curve.startPoint.y;
	    y += 3 * uu * t * curve.control1.y;
	    y += 3 * u * tt * curve.control2.y;
	    y += ttt * curve.endPoint.y;
	
	    var width = startWidth + ttt * widthDelta;
	    this._drawPoint(x, y, width);
	  }
	
	  ctx.closePath();
	  ctx.fill();
	};
	
	SignaturePad.prototype._drawDot = function (point) {
	  var ctx = this._ctx;
	  var width = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;
	
	  ctx.beginPath();
	  this._drawPoint(point.x, point.y, width);
	  ctx.closePath();
	  ctx.fill();
	};
	
	SignaturePad.prototype._fromData = function (pointGroups, drawCurve, drawDot) {
	  for (var i = 0; i < pointGroups.length; i += 1) {
	    var group = pointGroups[i];
	
	    if (group.length > 1) {
	      for (var j = 0; j < group.length; j += 1) {
	        var rawPoint = group[j];
	        var point = new Point(rawPoint.x, rawPoint.y, rawPoint.time);
	        var color = rawPoint.color;
	
	        if (j === 0) {
	          // First point in a group. Nothing to draw yet.
	
	          // All points in the group have the same color, so it's enough to set
	          // penColor just at the beginning.
	          this.penColor = color;
	          this._reset();
	
	          this._addPoint(point);
	        } else if (j !== group.length - 1) {
	          // Middle point in a group.
	          var _addPoint2 = this._addPoint(point),
	              curve = _addPoint2.curve,
	              widths = _addPoint2.widths;
	
	          if (curve && widths) {
	            drawCurve(curve, widths, color);
	          }
	        } else {
	          // Last point in a group. Do nothing.
	        }
	      }
	    } else {
	      this._reset();
	      var _rawPoint = group[0];
	      drawDot(_rawPoint);
	    }
	  }
	};
	
	SignaturePad.prototype._toSVG = function () {
	  var _this2 = this;
	
	  var pointGroups = this._data;
	  var canvas = this._canvas;
	  var ratio = Math.max(window.devicePixelRatio || 1, 1);
	  var minX = 0;
	  var minY = 0;
	  var maxX = canvas.width / ratio;
	  var maxY = canvas.height / ratio;
	  var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
	
	  svg.setAttributeNS(null, 'width', canvas.width);
	  svg.setAttributeNS(null, 'height', canvas.height);
	
	  this._fromData(pointGroups, function (curve, widths, color) {
	    var path = document.createElement('path');
	
	    // Need to check curve for NaN values, these pop up when drawing
	    // lines on the canvas that are not continuous. E.g. Sharp corners
	    // or stopping mid-stroke and than continuing without lifting mouse.
	    if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
	      var attr = 'M ' + curve.startPoint.x.toFixed(3) + ',' + curve.startPoint.y.toFixed(3) + ' ' + ('C ' + curve.control1.x.toFixed(3) + ',' + curve.control1.y.toFixed(3) + ' ') + (curve.control2.x.toFixed(3) + ',' + curve.control2.y.toFixed(3) + ' ') + (curve.endPoint.x.toFixed(3) + ',' + curve.endPoint.y.toFixed(3));
	
	      path.setAttribute('d', attr);
	      path.setAttribute('stroke-width', (widths.end * 2.25).toFixed(3));
	      path.setAttribute('stroke', color);
	      path.setAttribute('fill', 'none');
	      path.setAttribute('stroke-linecap', 'round');
	
	      svg.appendChild(path);
	    }
	  }, function (rawPoint) {
	    var circle = document.createElement('circle');
	    var dotSize = typeof _this2.dotSize === 'function' ? _this2.dotSize() : _this2.dotSize;
	    circle.setAttribute('r', dotSize);
	    circle.setAttribute('cx', rawPoint.x);
	    circle.setAttribute('cy', rawPoint.y);
	    circle.setAttribute('fill', rawPoint.color);
	
	    svg.appendChild(circle);
	  });
	
	  var prefix = 'data:image/svg+xml;base64,';
	  var header = '<svg' + ' xmlns="http://www.w3.org/2000/svg"' + ' xmlns:xlink="http://www.w3.org/1999/xlink"' + (' viewBox="' + minX + ' ' + minY + ' ' + maxX + ' ' + maxY + '"') + (' width="' + maxX + '"') + (' height="' + maxY + '"') + '>';
	  var body = svg.innerHTML;
	
	  // IE hack for missing innerHTML property on SVGElement
	  if (body === undefined) {
	    var dummy = document.createElement('dummy');
	    var nodes = svg.childNodes;
	    dummy.innerHTML = '';
	
	    for (var i = 0; i < nodes.length; i += 1) {
	      dummy.appendChild(nodes[i].cloneNode(true));
	    }
	
	    body = dummy.innerHTML;
	  }
	
	  var footer = '</svg>';
	  var data = header + body + footer;
	
	  return prefix + btoa(data);
	};
	
	SignaturePad.prototype.fromData = function (pointGroups) {
	  var _this3 = this;
	
	  this.clear();
	
	  this._fromData(pointGroups, function (curve, widths) {
	    return _this3._drawCurve(curve, widths.start, widths.end);
	  }, function (rawPoint) {
	    return _this3._drawDot(rawPoint);
	  });
	
	  this._data = pointGroups;
	};
	
	SignaturePad.prototype.toData = function () {
	  return this._data;
	};
	
	return SignaturePad;
	
	})));


/***/ },
/* 2035 */
1662,
/* 2036 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(149)


/***/ },
/* 2037 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(941)


/***/ },
/* 2038 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = __webpack_require__(942);
	exports.Stream = __webpack_require__(186);
	exports.Readable = exports;
	exports.Writable = __webpack_require__(469);
	exports.Duplex = __webpack_require__(149);
	exports.Transform = __webpack_require__(468);
	exports.PassThrough = __webpack_require__(941);
	if (!process.browser && ({"NODE_ENV":"production","API_URL":"https://api-dev.montemar.com.ar/0.3","PAGE_TITLE":"Calf Pay - Montemar","PUBLIC_URL":"","PAGE":"montemar-card-calf","REACT_APP_PAGE_TITLE":"Calf Pay - Montemar","REACT_APP_PHONE_NUMBER":"2616362912","REACT_APP_API_URL":"https://api-dev.montemar.com.ar/0.3"}).READABLE_STREAM === 'disable') {
	  module.exports = __webpack_require__(186);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ },
/* 2039 */
[2142, 468],
/* 2040 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(469)


/***/ },
/* 2041 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 2042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBind = __webpack_require__(248);
	var define = __webpack_require__(94);
	var RequireObjectCoercible = __webpack_require__(263);
	
	var implementation = __webpack_require__(943);
	var getPolyfill = __webpack_require__(944);
	var shim = __webpack_require__(2043);
	
	var bound = callBind(getPolyfill());
	var boundMethod = function trim(receiver) {
		RequireObjectCoercible(receiver);
		return bound(receiver);
	};
	
	define(boundMethod, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = boundMethod;


/***/ },
/* 2043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var supportsDescriptors = __webpack_require__(274)();
	var defineDataProperty = __webpack_require__(369);
	
	var getPolyfill = __webpack_require__(944);
	
	module.exports = function shimStringTrim() {
		var polyfill = getPolyfill();
	
		if (String.prototype.trim !== polyfill) {
			if (supportsDescriptors) {
				defineDataProperty(String.prototype, 'trim', polyfill, true);
			} else {
				defineDataProperty(String.prototype, 'trim', polyfill);
			}
		}
	
		return polyfill;
	};


/***/ },
/* 2044 */
/***/ function(module, exports) {

	function Agent() {
	  this._defaults = [];
	}
	
	["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects",
	 "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function(fn) {
	  /** Default setting for all requests from this agent */
	  Agent.prototype[fn] = function(/*varargs*/) {
	    this._defaults.push({fn:fn, arguments:arguments});
	    return this;
	  }
	});
	
	Agent.prototype._setDefaults = function(req) {
	    this._defaults.forEach(function(def) {
	      req[def.fn].apply(req, def.arguments);
	    });
	};
	
	module.exports = Agent;


/***/ },
/* 2045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module of mixed-in functions shared between node and client code
	 */
	var isObject = __webpack_require__(945);
	
	/**
	 * Expose `RequestBase`.
	 */
	
	module.exports = RequestBase;
	
	/**
	 * Initialize a new `RequestBase`.
	 *
	 * @api public
	 */
	
	function RequestBase(obj) {
	  if (obj) return mixin(obj);
	}
	
	/**
	 * Mixin the prototype properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in RequestBase.prototype) {
	    obj[key] = RequestBase.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.clearTimeout = function _clearTimeout(){
	  clearTimeout(this._timer);
	  clearTimeout(this._responseTimeoutTimer);
	  delete this._timer;
	  delete this._responseTimeoutTimer;
	  return this;
	};
	
	/**
	 * Override default response body parser
	 *
	 * This function will be called to convert incoming data into request.body
	 *
	 * @param {Function}
	 * @api public
	 */
	
	RequestBase.prototype.parse = function parse(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Set format of binary response body.
	 * In browser valid formats are 'blob' and 'arraybuffer',
	 * which return Blob and ArrayBuffer, respectively.
	 *
	 * In Node all values result in Buffer.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .responseType('blob')
	 *        .end(callback);
	 *
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.responseType = function(val){
	  this._responseType = val;
	  return this;
	};
	
	/**
	 * Override default request body serializer
	 *
	 * This function will be called to convert data set via .send or .attach into payload to send
	 *
	 * @param {Function}
	 * @api public
	 */
	
	RequestBase.prototype.serialize = function serialize(fn){
	  this._serializer = fn;
	  return this;
	};
	
	/**
	 * Set timeouts.
	 *
	 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
	 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
	 *
	 * Value of 0 or false means no timeout.
	 *
	 * @param {Number|Object} ms or {response, deadline}
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.timeout = function timeout(options){
	  if (!options || 'object' !== typeof options) {
	    this._timeout = options;
	    this._responseTimeout = 0;
	    return this;
	  }
	
	  for(var option in options) {
	    switch(option) {
	      case 'deadline':
	        this._timeout = options.deadline;
	        break;
	      case 'response':
	        this._responseTimeout = options.response;
	        break;
	      default:
	        console.warn("Unknown timeout option", option);
	    }
	  }
	  return this;
	};
	
	/**
	 * Set number of retry attempts on error.
	 *
	 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
	 *
	 * @param {Number} count
	 * @param {Function} [fn]
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.retry = function retry(count, fn){
	  // Default to 1 if no count passed or true
	  if (arguments.length === 0 || count === true) count = 1;
	  if (count <= 0) count = 0;
	  this._maxRetries = count;
	  this._retries = 0;
	  this._retryCallback = fn;
	  return this;
	};
	
	var ERROR_CODES = [
	  'ECONNRESET',
	  'ETIMEDOUT',
	  'EADDRINFO',
	  'ESOCKETTIMEDOUT'
	];
	
	/**
	 * Determine if a request should be retried.
	 * (Borrowed from segmentio/superagent-retry)
	 *
	 * @param {Error} err
	 * @param {Response} [res]
	 * @returns {Boolean}
	 */
	RequestBase.prototype._shouldRetry = function(err, res) {
	  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
	    return false;
	  }
	  if (this._retryCallback) {
	    try {
	      var override = this._retryCallback(err, res);
	      if (override === true) return true;
	      if (override === false) return false;
	      // undefined falls back to defaults
	    } catch(e) {
	      console.error(e);
	    }
	  }
	  if (res && res.status && res.status >= 500 && res.status != 501) return true;
	  if (err) {
	    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;
	    // Superagent timeout
	    if (err.timeout && err.code == 'ECONNABORTED') return true;
	    if (err.crossDomain) return true;
	  }
	  return false;
	};
	
	/**
	 * Retry request
	 *
	 * @return {Request} for chaining
	 * @api private
	 */
	
	RequestBase.prototype._retry = function() {
	
	  this.clearTimeout();
	
	  // node
	  if (this.req) {
	    this.req = null;
	    this.req = this.request();
	  }
	
	  this._aborted = false;
	  this.timedout = false;
	
	  return this._end();
	};
	
	/**
	 * Promise support
	 *
	 * @param {Function} resolve
	 * @param {Function} [reject]
	 * @return {Request}
	 */
	
	RequestBase.prototype.then = function then(resolve, reject) {
	  if (!this._fullfilledPromise) {
	    var self = this;
	    if (this._endCalled) {
	      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
	    }
	    this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
	      self.end(function(err, res) {
	        if (err) innerReject(err);
	        else innerResolve(res);
	      });
	    });
	  }
	  return this._fullfilledPromise.then(resolve, reject);
	};
	
	RequestBase.prototype['catch'] = function(cb) {
	  return this.then(undefined, cb);
	};
	
	/**
	 * Allow for extension
	 */
	
	RequestBase.prototype.use = function use(fn) {
	  fn(this);
	  return this;
	};
	
	RequestBase.prototype.ok = function(cb) {
	  if ('function' !== typeof cb) throw Error("Callback required");
	  this._okCallback = cb;
	  return this;
	};
	
	RequestBase.prototype._isResponseOK = function(res) {
	  if (!res) {
	    return false;
	  }
	
	  if (this._okCallback) {
	    return this._okCallback(res);
	  }
	
	  return res.status >= 200 && res.status < 300;
	};
	
	/**
	 * Get request header `field`.
	 * Case-insensitive.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	RequestBase.prototype.get = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 * This is a deprecated internal API. Use `.get(field)` instead.
	 *
	 * (getHeader is no longer used internally by the superagent code base)
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 * @deprecated
	 */
	
	RequestBase.prototype.getHeader = RequestBase.prototype.get;
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 * Case-insensitive.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 * Case-insensitive.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 */
	RequestBase.prototype.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Write the field `name` and `val`, or multiple fields with one object
	 * for "multipart/form-data" request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 *
	 * request.post('/upload')
	 *   .field({ foo: 'bar', baz: 'qux' })
	 *   .end(callback);
	 * ```
	 *
	 * @param {String|Object} name
	 * @param {String|Blob|File|Buffer|fs.ReadStream} val
	 * @return {Request} for chaining
	 * @api public
	 */
	RequestBase.prototype.field = function(name, val) {
	  // name should be either a string or an object.
	  if (null === name || undefined === name) {
	    throw new Error('.field(name, val) name can not be empty');
	  }
	
	  if (this._data) {
	    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
	  }
	
	  if (isObject(name)) {
	    for (var key in name) {
	      this.field(key, name[key]);
	    }
	    return this;
	  }
	
	  if (Array.isArray(val)) {
	    for (var i in val) {
	      this.field(name, val[i]);
	    }
	    return this;
	  }
	
	  // val should be defined now
	  if (null === val || undefined === val) {
	    throw new Error('.field(name, val) val can not be empty');
	  }
	  if ('boolean' === typeof val) {
	    val = '' + val;
	  }
	  this._getFormData().append(name, val);
	  return this;
	};
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	RequestBase.prototype.abort = function(){
	  if (this._aborted) {
	    return this;
	  }
	  this._aborted = true;
	  this.xhr && this.xhr.abort(); // browser
	  this.req && this.req.abort(); // node
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
	  switch (options.type) {
	    case 'basic':
	      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
	      break;
	
	    case 'auto':
	      this.username = user;
	      this.password = pass;
	      break;
	
	    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
	      this.set('Authorization', 'Bearer ' + user);
	      break;
	  }
	  return this;
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	RequestBase.prototype.withCredentials = function(on) {
	  // This is browser-only functionality. Node side is no-op.
	  if (on == undefined) on = true;
	  this._withCredentials = on;
	  return this;
	};
	
	/**
	 * Set the max redirects to `n`. Does noting in browser XHR implementation.
	 *
	 * @param {Number} n
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.redirects = function(n){
	  this._maxRedirects = n;
	  return this;
	};
	
	/**
	 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
	 * Default 200MB.
	 *
	 * @param {Number} n
	 * @return {Request} for chaining
	 */
	RequestBase.prototype.maxResponseSize = function(n){
	  if ('number' !== typeof n) {
	    throw TypeError("Invalid argument");
	  }
	  this._maxResponseSize = n;
	  return this;
	};
	
	/**
	 * Convert to a plain javascript object (not JSON string) of scalar properties.
	 * Note as this method is designed to return a useful non-this value,
	 * it cannot be chained.
	 *
	 * @return {Object} describing method, url, and data of this request
	 * @api public
	 */
	
	RequestBase.prototype.toJSON = function() {
	  return {
	    method: this.method,
	    url: this.url,
	    data: this._data,
	    headers: this._header,
	  };
	};
	
	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	 *      request.post('/user')
	 *        .send('name=tobi')
	 *        .send('species=ferret')
	 *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.send = function(data){
	  var isObj = isObject(data);
	  var type = this._header['content-type'];
	
	  if (this._formData) {
	    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
	  }
	
	  if (isObj && !this._data) {
	    if (Array.isArray(data)) {
	      this._data = [];
	    } else if (!this._isHost(data)) {
	      this._data = {};
	    }
	  } else if (data && this._data && this._isHost(this._data)) {
	    throw Error("Can't merge these send calls");
	  }
	
	  // merge
	  if (isObj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    // default to x-www-form-urlencoded
	    if (!type) this.type('form');
	    type = this._header['content-type'];
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!isObj || this._isHost(data)) {
	    return this;
	  }
	
	  // default to json
	  if (!type) this.type('json');
	  return this;
	};
	
	/**
	 * Sort `querystring` by the sort function
	 *
	 *
	 * Examples:
	 *
	 *       // default order
	 *       request.get('/user')
	 *         .query('name=Nick')
	 *         .query('search=Manny')
	 *         .sortQuery()
	 *         .end(callback)
	 *
	 *       // customized sort function
	 *       request.get('/user')
	 *         .query('name=Nick')
	 *         .query('search=Manny')
	 *         .sortQuery(function(a, b){
	 *           return a.length - b.length;
	 *         })
	 *         .end(callback)
	 *
	 *
	 * @param {Function} sort
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.sortQuery = function(sort) {
	  // _sort default to true but otherwise can be a function or boolean
	  this._sort = typeof sort === 'undefined' ? true : sort;
	  return this;
	};
	
	/**
	 * Compose querystring to append to req.url
	 *
	 * @api private
	 */
	RequestBase.prototype._finalizeQueryString = function(){
	  var query = this._query.join('&');
	  if (query) {
	    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
	  }
	  this._query.length = 0; // Makes the call idempotent
	
	  if (this._sort) {
	    var index = this.url.indexOf('?');
	    if (index >= 0) {
	      var queryArr = this.url.substring(index + 1).split('&');
	      if ('function' === typeof this._sort) {
	        queryArr.sort(this._sort);
	      } else {
	        queryArr.sort();
	      }
	      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
	    }
	  }
	};
	
	// For backwards compat only
	RequestBase.prototype._appendQueryString = function() {console.trace("Unsupported");}
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	RequestBase.prototype._timeoutError = function(reason, timeout, errno){
	  if (this._aborted) {
	    return;
	  }
	  var err = new Error(reason + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  err.code = 'ECONNABORTED';
	  err.errno = errno;
	  this.timedout = true;
	  this.abort();
	  this.callback(err);
	};
	
	RequestBase.prototype._setTimeouts = function() {
	  var self = this;
	
	  // deadline
	  if (this._timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
	    }, this._timeout);
	  }
	  // response timeout
	  if (this._responseTimeout && !this._responseTimeoutTimer) {
	    this._responseTimeoutTimer = setTimeout(function(){
	      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
	    }, this._responseTimeout);
	  }
	};


/***/ },
/* 2046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	
	var utils = __webpack_require__(2047);
	
	/**
	 * Expose `ResponseBase`.
	 */
	
	module.exports = ResponseBase;
	
	/**
	 * Initialize a new `ResponseBase`.
	 *
	 * @api public
	 */
	
	function ResponseBase(obj) {
	  if (obj) return mixin(obj);
	}
	
	/**
	 * Mixin the prototype properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in ResponseBase.prototype) {
	    obj[key] = ResponseBase.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	ResponseBase.prototype.get = function(field) {
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	ResponseBase.prototype._setHeaderProperties = function(header){
	    // TODO: moar!
	    // TODO: make this a util
	
	    // content-type
	    var ct = header['content-type'] || '';
	    this.type = utils.type(ct);
	
	    // params
	    var params = utils.params(ct);
	    for (var key in params) this[key] = params[key];
	
	    this.links = {};
	
	    // links
	    try {
	        if (header.link) {
	            this.links = utils.parseLinks(header.link);
	        }
	    } catch (err) {
	        // ignore
	    }
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	ResponseBase.prototype._setStatusProperties = function(status){
	    var type = status / 100 | 0;
	
	    // status / class
	    this.status = this.statusCode = status;
	    this.statusType = type;
	
	    // basics
	    this.info = 1 == type;
	    this.ok = 2 == type;
	    this.redirect = 3 == type;
	    this.clientError = 4 == type;
	    this.serverError = 5 == type;
	    this.error = (4 == type || 5 == type)
	        ? this.toError()
	        : false;
	
	    // sugar
	    this.created = 201 == status;
	    this.accepted = 202 == status;
	    this.noContent = 204 == status;
	    this.badRequest = 400 == status;
	    this.unauthorized = 401 == status;
	    this.notAcceptable = 406 == status;
	    this.forbidden = 403 == status;
	    this.notFound = 404 == status;
	    this.unprocessableEntity = 422 == status;
	};


/***/ },
/* 2047 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	exports.type = function(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	exports.params = function(str){
	  return str.split(/ *; */).reduce(function(obj, str){
	    var parts = str.split(/ *= */);
	    var key = parts.shift();
	    var val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Parse Link header fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	exports.parseLinks = function(str){
	  return str.split(/ *, */).reduce(function(obj, str){
	    var parts = str.split(/ *; */);
	    var url = parts[0].slice(1, -1);
	    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
	    obj[rel] = url;
	    return obj;
	  }, {});
	};
	
	/**
	 * Strip content related fields from `header`.
	 *
	 * @param {Object} header
	 * @return {Object} header
	 * @api private
	 */
	
	exports.cleanHeader = function(header, changesOrigin){
	  delete header['content-type'];
	  delete header['content-length'];
	  delete header['transfer-encoding'];
	  delete header['host'];
	  // secuirty
	  if (changesOrigin) {
	    delete header['authorization'];
	    delete header['cookie'];
	  }
	  return header;
	};


/***/ },
/* 2048 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(2049);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(87)(module)))

/***/ },
/* 2049 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 2050 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.trimCanvas=t():e.trimCanvas=t()}(this,function(){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t){"use strict";function r(e){var t=e.getContext("2d"),r=e.width,n=e.height,o=t.getImageData(0,0,r,n).data,f=a(!0,r,n,o),i=a(!1,r,n,o),c=u(!0,r,n,o),d=u(!1,r,n,o),p=d-c+1,l=i-f+1,s=t.getImageData(c,f,p,l);return e.width=p,e.height=l,t.clearRect(0,0,p,l),t.putImageData(s,0,0),e}function n(e,t,r,n){return{red:n[4*(r*t+e)],green:n[4*(r*t+e)+1],blue:n[4*(r*t+e)+2],alpha:n[4*(r*t+e)+3]}}function o(e,t,r,o){return n(e,t,r,o).alpha}function a(e,t,r,n){for(var a=e?1:-1,u=e?0:r-1,f=u;e?f<r:f>-1;f+=a)for(var i=0;i<t;i++)if(o(i,f,t,n))return f;return null}function u(e,t,r,n){for(var a=e?1:-1,u=e?0:t-1,f=u;e?f<t:f>-1;f+=a)for(var i=0;i<r;i++)if(o(f,i,t,n))return f;return null}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r}])});

/***/ },
/* 2051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(2052);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createUncontrollable(mixin, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var _class, _temp;
	
	    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        controlledProps = Object.keys(controlledValues),
	        propTypes;
	
	    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = (_temp = _class = function (_React$Component) {
	      _inherits(component, _React$Component);
	
	      function component() {
	        _classCallCheck(this, component);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	      }
	
	      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
	      };
	
	      component.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        var props = this.props;
	
	        this._values = {};
	
	        controlledProps.forEach(function (key) {
	          _this2._values[key] = props[utils.defaultKey(key)];
	        });
	      };
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	
	
	      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        var _this3 = this;
	
	        var props = this.props;
	
	        if (mixin.componentWillReceiveProps) {
	          mixin.componentWillReceiveProps.call(this, nextProps);
	        }
	
	        controlledProps.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this3._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      };
	
	      component.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.unmounted = true;
	      };
	
	      component.prototype.getControlledInstance = function getControlledInstance() {
	        return this.refs.inner;
	      };
	
	      component.prototype.render = function render() {
	        var _this4 = this;
	
	        var newProps = {},
	            props = omitProps(this.props);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this4.props[propName];
	
	          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
	            prop = _this4.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this4, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      };
	
	      return component;
	    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);
	
	    _extends(component.prototype, methods);
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	
	    function omitProps(props) {
	      var result = {};
	
	      utils.each(props, function (value, key) {
	        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
	      });
	
	      return result;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 2052 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.has = has;
	exports.isReactComponent = isReactComponent;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function readOnlyPropType(handler, name) {
	  return function (props, propName) {
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = readOnlyPropType(handler, displayName);
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}

/***/ },
/* 2053 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/selfie-document-instructions.79ad010a.png";

/***/ },
/* 2054 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2055 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2056 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2057 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/dni-tramite.b412b9c2.png";

/***/ },
/* 2058 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/piggy-bank.702f055e.png";

/***/ },
/* 2059 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step-01.28996b33.png";

/***/ },
/* 2060 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step-02.d47c453c.png";

/***/ },
/* 2061 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step-03.f3037a5e.png";

/***/ },
/* 2062 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step-04.c682135c.png";

/***/ },
/* 2063 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tarjeta-mastercard.8ebc1bfd.png";

/***/ },
/* 2064 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)(module), (function() { return this; }())))

/***/ },
/* 2065 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 2066 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 2067 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 2068 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
	  return new Worker(__webpack_require__.p + "38762ef9b2abd4a0fc0f.worker.js");
	};

/***/ },
/* 2069 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 2070 */
2069,
/* 2071 */
2069,
/* 2072 */
2069,
/* 2073 */
2069,
/* 2074 */
2069,
/* 2075 */
2069,
/* 2076 */
2069,
/* 2077 */
2069,
/* 2078 */
2069,
/* 2079 */
2069,
/* 2080 */
2069,
/* 2081 */
2069,
/* 2082 */
2069,
/* 2083 */
2069,
/* 2084 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = __webpack_require__(__webpack_module_template_argument_0__);


/***/ },
/* 2085 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	__webpack_require__(__webpack_module_template_argument_0__);
	module.exports = __webpack_require__(__webpack_module_template_argument_1__).Object.values;


/***/ },
/* 2086 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	__webpack_require__(__webpack_module_template_argument_0__);
	__webpack_require__(__webpack_module_template_argument_1__);
	__webpack_require__(__webpack_module_template_argument_2__);
	__webpack_require__(__webpack_module_template_argument_3__);
	__webpack_require__(__webpack_module_template_argument_4__);
	__webpack_require__(__webpack_module_template_argument_5__);
	module.exports = __webpack_require__(__webpack_module_template_argument_6__).Promise;


/***/ },
/* 2087 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 2088 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var toLength = __webpack_require__(__webpack_module_template_argument_1__);
	var toAbsoluteIndex = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 2089 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	var TAG = __webpack_require__(__webpack_module_template_argument_1__)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 2090 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 2091 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(__webpack_module_template_argument_0__)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 2092 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var document = __webpack_require__(__webpack_module_template_argument_1__).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 2093 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var call = __webpack_require__(__webpack_module_template_argument_1__);
	var isArrayIter = __webpack_require__(__webpack_module_template_argument_2__);
	var anObject = __webpack_require__(__webpack_module_template_argument_3__);
	var toLength = __webpack_require__(__webpack_module_template_argument_4__);
	var getIterFn = __webpack_require__(__webpack_module_template_argument_5__);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 2094 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = __webpack_require__(__webpack_module_template_argument_2__) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 2095 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var document = __webpack_require__(__webpack_module_template_argument_0__).document;
	module.exports = document && document.documentElement;


/***/ },
/* 2096 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	module.exports = !__webpack_require__(__webpack_module_template_argument_0__) && !__webpack_require__(__webpack_module_template_argument_1__)(function () {
	  return Object.defineProperty(__webpack_require__(__webpack_module_template_argument_2__)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 2097 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 2098 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 2099 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 2100 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 2101 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var create = __webpack_require__(__webpack_module_template_argument_0__);
	var descriptor = __webpack_require__(__webpack_module_template_argument_1__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_2__);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_3__)(IteratorPrototype, __webpack_require__(__webpack_module_template_argument_4__)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 2102 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var redefine = __webpack_require__(__webpack_module_template_argument_2__);
	var hide = __webpack_require__(__webpack_module_template_argument_3__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_4__);
	var $iterCreate = __webpack_require__(__webpack_module_template_argument_5__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_6__);
	var getPrototypeOf = __webpack_require__(__webpack_module_template_argument_7__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_8__)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 2103 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ITERATOR = __webpack_require__(__webpack_module_template_argument_0__)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 2104 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var META = __webpack_require__(__webpack_module_template_argument_0__)('meta');
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var has = __webpack_require__(__webpack_module_template_argument_2__);
	var setDesc = __webpack_require__(__webpack_module_template_argument_3__).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(__webpack_module_template_argument_4__)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 2105 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var macrotask = __webpack_require__(__webpack_module_template_argument_1__).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(__webpack_module_template_argument_2__)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 2106 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 2107 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_0__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_1__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_2__);
	var pIE = __webpack_require__(__webpack_module_template_argument_3__);
	var toObject = __webpack_require__(__webpack_module_template_argument_4__);
	var IObject = __webpack_require__(__webpack_module_template_argument_5__);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(__webpack_module_template_argument_6__)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 2108 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var dPs = __webpack_require__(__webpack_module_template_argument_1__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_2__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(__webpack_module_template_argument_4__)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(__webpack_module_template_argument_5__).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 2109 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_1__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_2__);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 2110 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 2111 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var pIE = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_5__);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_6__) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 2112 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toObject = __webpack_require__(__webpack_module_template_argument_1__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_2__)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 2113 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	var arrayIndexOf = __webpack_require__(__webpack_module_template_argument_2__)(false);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 2114 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 2115 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_0__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var isEnum = __webpack_require__(__webpack_module_template_argument_3__).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ },
/* 2116 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var newPromiseCapability = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 2117 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(__webpack_module_template_argument_2__)(Function.call, __webpack_require__(__webpack_module_template_argument_3__).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 2118 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var def = __webpack_require__(__webpack_module_template_argument_0__).f;
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var TAG = __webpack_require__(__webpack_module_template_argument_2__)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 2119 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var shared = __webpack_require__(__webpack_module_template_argument_0__)('keys');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 2120 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var core = __webpack_require__(__webpack_module_template_argument_0__);
	var global = __webpack_require__(__webpack_module_template_argument_1__);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(__webpack_module_template_argument_2__) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 2121 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var aFunction = __webpack_require__(__webpack_module_template_argument_1__);
	var SPECIES = __webpack_require__(__webpack_module_template_argument_2__)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 2122 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 2123 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var invoke = __webpack_require__(__webpack_module_template_argument_1__);
	var html = __webpack_require__(__webpack_module_template_argument_2__);
	var cel = __webpack_require__(__webpack_module_template_argument_3__);
	var global = __webpack_require__(__webpack_module_template_argument_4__);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(__webpack_module_template_argument_5__)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 2124 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 2125 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 2126 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 2127 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 2128 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 2129 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 2130 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var store = __webpack_require__(__webpack_module_template_argument_0__)('wks');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	var Symbol = __webpack_require__(__webpack_module_template_argument_2__).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 2131 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var classof = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = __webpack_require__(__webpack_module_template_argument_3__).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 2132 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var addToUnscopables = __webpack_require__(__webpack_module_template_argument_0__);
	var step = __webpack_require__(__webpack_module_template_argument_1__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(__webpack_module_template_argument_4__)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 2133 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__, __webpack_module_template_argument_21__) {

	'use strict';
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_0__);
	var global = __webpack_require__(__webpack_module_template_argument_1__);
	var ctx = __webpack_require__(__webpack_module_template_argument_2__);
	var classof = __webpack_require__(__webpack_module_template_argument_3__);
	var $export = __webpack_require__(__webpack_module_template_argument_4__);
	var isObject = __webpack_require__(__webpack_module_template_argument_5__);
	var aFunction = __webpack_require__(__webpack_module_template_argument_6__);
	var anInstance = __webpack_require__(__webpack_module_template_argument_7__);
	var forOf = __webpack_require__(__webpack_module_template_argument_8__);
	var speciesConstructor = __webpack_require__(__webpack_module_template_argument_9__);
	var task = __webpack_require__(__webpack_module_template_argument_10__).set;
	var microtask = __webpack_require__(__webpack_module_template_argument_11__)();
	var newPromiseCapabilityModule = __webpack_require__(__webpack_module_template_argument_12__);
	var perform = __webpack_require__(__webpack_module_template_argument_13__);
	var userAgent = __webpack_require__(__webpack_module_template_argument_14__);
	var promiseResolve = __webpack_require__(__webpack_module_template_argument_15__);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(__webpack_module_template_argument_16__)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(__webpack_module_template_argument_17__)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(__webpack_module_template_argument_18__)($Promise, PROMISE);
	__webpack_require__(__webpack_module_template_argument_19__)(PROMISE);
	Wrapper = __webpack_require__(__webpack_module_template_argument_20__)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(__webpack_module_template_argument_21__)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 2134 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $at = __webpack_require__(__webpack_module_template_argument_0__)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_1__)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 2135 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var $values = __webpack_require__(__webpack_module_template_argument_1__)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 2136 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var global = __webpack_require__(__webpack_module_template_argument_2__);
	var speciesConstructor = __webpack_require__(__webpack_module_template_argument_3__);
	var promiseResolve = __webpack_require__(__webpack_module_template_argument_4__);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 2137 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var newPromiseCapability = __webpack_require__(__webpack_module_template_argument_1__);
	var perform = __webpack_require__(__webpack_module_template_argument_2__);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 2138 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}
	/*</replacement>*/
	
	
	/*<replacement>*/
	var util = __webpack_require__(114);
	util.inherits = __webpack_require__(100);
	/*</replacement>*/
	
	var Readable = __webpack_require__(__webpack_module_template_argument_0__);
	var Writable = __webpack_require__(__webpack_module_template_argument_1__);
	
	util.inherits(Duplex, Readable);
	
	forEach(objectKeys(Writable.prototype), function(method) {
	  if (!Duplex.prototype[method])
	    Duplex.prototype[method] = Writable.prototype[method];
	});
	
	function Duplex(options) {
	  if (!(this instanceof Duplex))
	    return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false)
	    this.readable = false;
	
	  if (options && options.writable === false)
	    this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false)
	    this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended)
	    return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  process.nextTick(this.end.bind(this));
	}
	
	function forEach (xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ },
/* 2139 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(__webpack_module_template_argument_0__);
	/*</replacement>*/
	
	
	/*<replacement>*/
	var Buffer = __webpack_require__(62).Buffer;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	var EE = __webpack_require__(375).EventEmitter;
	
	/*<replacement>*/
	if (!EE.listenerCount) EE.listenerCount = function(emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	var Stream = __webpack_require__(186);
	
	/*<replacement>*/
	var util = __webpack_require__(114);
	util.inherits = __webpack_require__(100);
	/*</replacement>*/
	
	var StringDecoder;
	
	
	/*<replacement>*/
	var debug = __webpack_require__(__webpack_module_template_argument_1__);
	if (debug && debug.debuglog) {
	  debug = debug.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	
	util.inherits(Readable, Stream);
	
	function ReadableState(options, stream) {
	  var Duplex = __webpack_require__(__webpack_module_template_argument_2__);
	
	  options = options || {};
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = options.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  this.buffer = [];
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex)
	    this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // when piping, we only care about 'readable' events that happen
	  // after read()ing all the bytes and not getting any pushback.
	  this.ranOut = false;
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder)
	      StringDecoder = __webpack_require__(303).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  var Duplex = __webpack_require__(__webpack_module_template_argument_3__);
	
	  if (!(this instanceof Readable))
	    return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  Stream.call(this);
	}
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function(chunk, encoding) {
	  var state = this._readableState;
	
	  if (util.isString(chunk) && !state.objectMode) {
	    encoding = encoding || state.defaultEncoding;
	    if (encoding !== state.encoding) {
	      chunk = new Buffer(chunk, encoding);
	      encoding = '';
	    }
	  }
	
	  return readableAddChunk(this, state, chunk, encoding, false);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function(chunk) {
	  var state = this._readableState;
	  return readableAddChunk(this, state, chunk, '', true);
	};
	
	function readableAddChunk(stream, state, chunk, encoding, addToFront) {
	  var er = chunkInvalid(state, chunk);
	  if (er) {
	    stream.emit('error', er);
	  } else if (util.isNullOrUndefined(chunk)) {
	    state.reading = false;
	    if (!state.ended)
	      onEofChunk(stream, state);
	  } else if (state.objectMode || chunk && chunk.length > 0) {
	    if (state.ended && !addToFront) {
	      var e = new Error('stream.push() after EOF');
	      stream.emit('error', e);
	    } else if (state.endEmitted && addToFront) {
	      var e = new Error('stream.unshift() after end event');
	      stream.emit('error', e);
	    } else {
	      if (state.decoder && !addToFront && !encoding)
	        chunk = state.decoder.write(chunk);
	
	      if (!addToFront)
	        state.reading = false;
	
	      // if we want the data now, just emit it.
	      if (state.flowing && state.length === 0 && !state.sync) {
	        stream.emit('data', chunk);
	        stream.read(0);
	      } else {
	        // update the buffer info.
	        state.length += state.objectMode ? 1 : chunk.length;
	        if (addToFront)
	          state.buffer.unshift(chunk);
	        else
	          state.buffer.push(chunk);
	
	        if (state.needReadable)
	          emitReadable(stream);
	      }
	
	      maybeReadMore(stream, state);
	    }
	  } else if (!addToFront) {
	    state.reading = false;
	  }
	
	  return needMoreData(state);
	}
	
	
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended &&
	         (state.needReadable ||
	          state.length < state.highWaterMark ||
	          state.length === 0);
	}
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function(enc) {
	  if (!StringDecoder)
	    StringDecoder = __webpack_require__(303).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 128MB
	var MAX_HWM = 0x800000;
	function roundUpToNextPowerOf2(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2
	    n--;
	    for (var p = 1; p < 32; p <<= 1) n |= n >> p;
	    n++;
	  }
	  return n;
	}
	
	function howMuchToRead(n, state) {
	  if (state.length === 0 && state.ended)
	    return 0;
	
	  if (state.objectMode)
	    return n === 0 ? 0 : 1;
	
	  if (isNaN(n) || util.isNull(n)) {
	    // only flow one buffer at a time
	    if (state.flowing && state.buffer.length)
	      return state.buffer[0].length;
	    else
	      return state.length;
	  }
	
	  if (n <= 0)
	    return 0;
	
	  // If we're asking for more than the target buffer level,
	  // then raise the water mark.  Bump up to the next highest
	  // power of 2, to prevent increasing it excessively in tiny
	  // amounts.
	  if (n > state.highWaterMark)
	    state.highWaterMark = roundUpToNextPowerOf2(n);
	
	  // don't have that much.  return null, unless we've ended.
	  if (n > state.length) {
	    if (!state.ended) {
	      state.needReadable = true;
	      return 0;
	    } else
	      return state.length;
	  }
	
	  return n;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function(n) {
	  debug('read', n);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (!util.isNumber(n) || n > 0)
	    state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 &&
	      state.needReadable &&
	      (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended)
	      endReadable(this);
	    else
	      emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0)
	      endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  }
	
	  if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0)
	      state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	  }
	
	  // If _read pushed data synchronously, then `reading` will be false,
	  // and we need to re-evaluate how much data we can return to the user.
	  if (doRead && !state.reading)
	    n = howMuchToRead(nOrig, state);
	
	  var ret;
	  if (n > 0)
	    ret = fromList(n, state);
	  else
	    ret = null;
	
	  if (util.isNull(ret)) {
	    state.needReadable = true;
	    n = 0;
	  }
	
	  state.length -= n;
	
	  // If we have nothing in the buffer, then we want to know
	  // as soon as we *do* get something into the buffer.
	  if (state.length === 0 && !state.ended)
	    state.needReadable = true;
	
	  // If we tried to read() past the EOF, then emit end on the next tick.
	  if (nOrig !== n && state.ended && state.length === 0)
	    endReadable(this);
	
	  if (!util.isNull(ret))
	    this.emit('data', ret);
	
	  return ret;
	};
	
	function chunkInvalid(state, chunk) {
	  var er = null;
	  if (!util.isBuffer(chunk) &&
	      !util.isString(chunk) &&
	      !util.isNullOrUndefined(chunk) &&
	      !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	
	function onEofChunk(stream, state) {
	  if (state.decoder && !state.ended) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync)
	      process.nextTick(function() {
	        emitReadable_(stream);
	      });
	    else
	      emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    process.nextTick(function() {
	      maybeReadMore_(stream, state);
	    });
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended &&
	         state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;
	    else
	      len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function(n) {
	  this.emit('error', new Error('not implemented'));
	};
	
	Readable.prototype.pipe = function(dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) &&
	              dest !== process.stdout &&
	              dest !== process.stderr;
	
	  var endFn = doEnd ? onend : cleanup;
	  if (state.endEmitted)
	    process.nextTick(endFn);
	  else
	    src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable) {
	    debug('onunpipe');
	    if (readable === src) {
	      cleanup();
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', cleanup);
	    src.removeListener('data', ondata);
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain &&
	        (!dest._writableState || dest._writableState.needDrain))
	      ondrain();
	  }
	
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    var ret = dest.write(chunk);
	    if (false === ret) {
	      debug('false write response, pause',
	            src._readableState.awaitDrain);
	      src._readableState.awaitDrain++;
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EE.listenerCount(dest, 'error') === 0)
	      dest.emit('error', er);
	  }
	  // This is a brutally ugly hack to make sure that our error handler
	  // is attached before any userland ones.  NEVER DO THIS.
	  if (!dest._events || !dest._events.error)
	    dest.on('error', onerror);
	  else if (isArray(dest._events.error))
	    dest._events.error.unshift(onerror);
	  else
	    dest._events.error = [onerror, dest._events.error];
	
	
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function() {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain)
	      state.awaitDrain--;
	    if (state.awaitDrain === 0 && EE.listenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	
	Readable.prototype.unpipe = function(dest) {
	  var state = this._readableState;
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0)
	    return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes)
	      return this;
	
	    if (!dest)
	      dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest)
	      dest.emit('unpipe', this);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++)
	      dests[i].emit('unpipe', this);
	    return this;
	  }
	
	  // try to find the right one.
	  var i = indexOf(state.pipes, dest);
	  if (i === -1)
	    return this;
	
	  state.pipes.splice(i, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1)
	    state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function(ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  // If listening to data, and it has not explicitly been paused,
	  // then call resume to start the flow of data on the next tick.
	  if (ev === 'data' && false !== this._readableState.flowing) {
	    this.resume();
	  }
	
	  if (ev === 'readable' && this.readable) {
	    var state = this._readableState;
	    if (!state.readableListening) {
	      state.readableListening = true;
	      state.emittedReadable = false;
	      state.needReadable = true;
	      if (!state.reading) {
	        var self = this;
	        process.nextTick(function() {
	          debug('readable nexttick read 0');
	          self.read(0);
	        });
	      } else if (state.length) {
	        emitReadable(this, state);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function() {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    if (!state.reading) {
	      debug('resume read 0');
	      this.read(0);
	    }
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    process.nextTick(function() {
	      resume_(stream, state);
	    });
	  }
	}
	
	function resume_(stream, state) {
	  state.resumeScheduled = false;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading)
	    stream.read(0);
	}
	
	Readable.prototype.pause = function() {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  if (state.flowing) {
	    do {
	      var chunk = stream.read();
	    } while (null !== chunk && state.flowing);
	  }
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function(stream) {
	  var state = this._readableState;
	  var paused = false;
	
	  var self = this;
	  stream.on('end', function() {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length)
	        self.push(chunk);
	    }
	
	    self.push(null);
	  });
	
	  stream.on('data', function(chunk) {
	    debug('wrapped data');
	    if (state.decoder)
	      chunk = state.decoder.write(chunk);
	    if (!chunk || !state.objectMode && !chunk.length)
	      return;
	
	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (util.isFunction(stream[i]) && util.isUndefined(this[i])) {
	      this[i] = function(method) { return function() {
	        return stream[method].apply(stream, arguments);
	      }}(i);
	    }
	  }
	
	  // proxy certain important events.
	  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
	  forEach(events, function(ev) {
	    stream.on(ev, self.emit.bind(self, ev));
	  });
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function(n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return self;
	};
	
	
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	function fromList(n, state) {
	  var list = state.buffer;
	  var length = state.length;
	  var stringMode = !!state.decoder;
	  var objectMode = !!state.objectMode;
	  var ret;
	
	  // nothing in the list, definitely empty.
	  if (list.length === 0)
	    return null;
	
	  if (length === 0)
	    ret = null;
	  else if (objectMode)
	    ret = list.shift();
	  else if (!n || n >= length) {
	    // read it all, truncate the array.
	    if (stringMode)
	      ret = list.join('');
	    else
	      ret = Buffer.concat(list, length);
	    list.length = 0;
	  } else {
	    // read just some of it.
	    if (n < list[0].length) {
	      // just take a part of the first list item.
	      // slice is the same for buffers and strings.
	      var buf = list[0];
	      ret = buf.slice(0, n);
	      list[0] = buf.slice(n);
	    } else if (n === list[0].length) {
	      // first list is a perfect match
	      ret = list.shift();
	    } else {
	      // complex case.
	      // we have enough to cover it, but it spans past the first buffer.
	      if (stringMode)
	        ret = '';
	      else
	        ret = new Buffer(n);
	
	      var c = 0;
	      for (var i = 0, l = list.length; i < l && c < n; i++) {
	        var buf = list[0];
	        var cpy = Math.min(n - c, buf.length);
	
	        if (stringMode)
	          ret += buf.slice(0, cpy);
	        else
	          buf.copy(ret, c, 0, cpy);
	
	        if (cpy < buf.length)
	          list[0] = buf.slice(cpy);
	        else
	          list.shift();
	
	        c += cpy;
	      }
	    }
	  }
	
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0)
	    throw new Error('endReadable called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    process.nextTick(function() {
	      // Check that we didn't get one last unshift.
	      if (!state.endEmitted && state.length === 0) {
	        state.endEmitted = true;
	        stream.readable = false;
	        stream.emit('end');
	      }
	    });
	  }
	}
	
	function forEach (xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf (xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ },
/* 2140 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(__webpack_module_template_argument_0__);
	
	/*<replacement>*/
	var util = __webpack_require__(114);
	util.inherits = __webpack_require__(100);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	
	function TransformState(options, stream) {
	  this.afterTransform = function(er, data) {
	    return afterTransform(stream, er, data);
	  };
	
	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	}
	
	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb)
	    return stream.emit('error', new Error('no writecb in Transform class'));
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (!util.isNullOrUndefined(data))
	    stream.push(data);
	
	  if (cb)
	    cb(er);
	
	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}
	
	
	function Transform(options) {
	  if (!(this instanceof Transform))
	    return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = new TransformState(options, this);
	
	  // when the writable side finishes, then flush out anything remaining.
	  var stream = this;
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  this.once('prefinish', function() {
	    if (util.isFunction(this._flush))
	      this._flush(function(er) {
	        done(stream, er);
	      });
	    else
	      done(stream);
	  });
	}
	
	Transform.prototype.push = function(chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function(chunk, encoding, cb) {
	  throw new Error('not implemented');
	};
	
	Transform.prototype._write = function(chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform ||
	        rs.needReadable ||
	        rs.length < rs.highWaterMark)
	      this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function(n) {
	  var ts = this._transformState;
	
	  if (!util.isNull(ts.writechunk) && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	
	function done(stream, er) {
	  if (er)
	    return stream.emit('error', er);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;
	
	  if (ws.length)
	    throw new Error('calling transform done when ws.length != 0');
	
	  if (ts.transforming)
	    throw new Error('calling transform done when still transforming');
	
	  return stream.push(null);
	}


/***/ },
/* 2141 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, cb), and it'll handle all
	// the drain event emission and buffering.
	
	module.exports = Writable;
	
	/*<replacement>*/
	var Buffer = __webpack_require__(62).Buffer;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	
	/*<replacement>*/
	var util = __webpack_require__(114);
	util.inherits = __webpack_require__(100);
	/*</replacement>*/
	
	var Stream = __webpack_require__(186);
	
	util.inherits(Writable, Stream);
	
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	}
	
	function WritableState(options, stream) {
	  var Duplex = __webpack_require__(__webpack_module_template_argument_0__);
	
	  options = options || {};
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = options.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex)
	    this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function(er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.buffer = [];
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	}
	
	function Writable(options) {
	  var Duplex = __webpack_require__(__webpack_module_template_argument_1__);
	
	  // Writable ctor is applied to Duplexes, though they're not
	  // instanceof Writable, they're instanceof Readable.
	  if (!(this instanceof Writable) && !(this instanceof Duplex))
	    return new Writable(options);
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function() {
	  this.emit('error', new Error('Cannot pipe. Not readable.'));
	};
	
	
	function writeAfterEnd(stream, state, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  process.nextTick(function() {
	    cb(er);
	  });
	}
	
	// If we get something that is not a buffer, string, null, or undefined,
	// and we're not in objectMode, then that's an error.
	// Otherwise stream chunks are all considered to be of length=1, and the
	// watermarks determine how many objects to keep in the buffer, rather than
	// how many bytes or characters.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  if (!util.isBuffer(chunk) &&
	      !util.isString(chunk) &&
	      !util.isNullOrUndefined(chunk) &&
	      !state.objectMode) {
	    var er = new TypeError('Invalid non-string/buffer chunk');
	    stream.emit('error', er);
	    process.nextTick(function() {
	      cb(er);
	    });
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function(chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	
	  if (util.isFunction(encoding)) {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (util.isBuffer(chunk))
	    encoding = 'buffer';
	  else if (!encoding)
	    encoding = state.defaultEncoding;
	
	  if (!util.isFunction(cb))
	    cb = function() {};
	
	  if (state.ended)
	    writeAfterEnd(this, state, cb);
	  else if (validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function() {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function() {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing &&
	        !state.corked &&
	        !state.finished &&
	        !state.bufferProcessing &&
	        state.buffer.length)
	      clearBuffer(this, state);
	  }
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode &&
	      state.decodeStrings !== false &&
	      util.isString(chunk)) {
	    chunk = new Buffer(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, chunk, encoding, cb) {
	  chunk = decodeChunk(state, chunk, encoding);
	  if (util.isBuffer(chunk))
	    encoding = 'buffer';
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret)
	    state.needDrain = true;
	
	  if (state.writing || state.corked)
	    state.buffer.push(new WriteReq(chunk, encoding, cb));
	  else
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev)
	    stream._writev(chunk, state.onwrite);
	  else
	    stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  if (sync)
	    process.nextTick(function() {
	      state.pendingcb--;
	      cb(er);
	    });
	  else {
	    state.pendingcb--;
	    cb(er);
	  }
	
	  stream._writableState.errorEmitted = true;
	  stream.emit('error', er);
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er)
	    onwriteError(stream, state, sync, er, cb);
	  else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(stream, state);
	
	    if (!finished &&
	        !state.corked &&
	        !state.bufferProcessing &&
	        state.buffer.length) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      process.nextTick(function() {
	        afterWrite(stream, state, finished, cb);
	      });
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished)
	    onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	
	  if (stream._writev && state.buffer.length > 1) {
	    // Fast case, write everything using _writev()
	    var cbs = [];
	    for (var c = 0; c < state.buffer.length; c++)
	      cbs.push(state.buffer[c].callback);
	
	    // count the one we are adding, as well.
	    // TODO(isaacs) clean this up
	    state.pendingcb++;
	    doWrite(stream, state, true, state.length, state.buffer, '', function(err) {
	      for (var i = 0; i < cbs.length; i++) {
	        state.pendingcb--;
	        cbs[i](err);
	      }
	    });
	
	    // Clear buffer
	    state.buffer = [];
	  } else {
	    // Slow case, write chunks one-by-one
	    for (var c = 0; c < state.buffer.length; c++) {
	      var entry = state.buffer[c];
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        c++;
	        break;
	      }
	    }
	
	    if (c < state.buffer.length)
	      state.buffer = state.buffer.slice(c);
	    else
	      state.buffer.length = 0;
	  }
	
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function(chunk, encoding, cb) {
	  cb(new Error('not implemented'));
	
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function(chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (util.isFunction(chunk)) {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (util.isFunction(encoding)) {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (!util.isNullOrUndefined(chunk))
	    this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished)
	    endWritable(this, state, cb);
	};
	
	
	function needFinish(stream, state) {
	  return (state.ending &&
	          state.length === 0 &&
	          !state.finished &&
	          !state.writing);
	}
	
	function prefinish(stream, state) {
	  if (!state.prefinished) {
	    state.prefinished = true;
	    stream.emit('prefinish');
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(stream, state);
	  if (need) {
	    if (state.pendingcb === 0) {
	      prefinish(stream, state);
	      state.finished = true;
	      stream.emit('finish');
	    } else
	      prefinish(stream, state);
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished)
	      process.nextTick(cb);
	    else
	      stream.once('finish', cb);
	  }
	  state.ended = true;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ },
/* 2142 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = __webpack_require__(__webpack_module_template_argument_0__)


/***/ },
/* 2143 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(20);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** static/js/main.819a4b26.js
 **/